// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[7].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[7].use[2]!../../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[0].oneOf[7].use[3]!../../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[7].use[4]!./shepherd.css";
import ___CSS_LOADER_AT_RULE_IMPORT_1___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[7].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[7].use[2]!../../../node_modules/resolve-url-loader/index.js??ruleSet[1].rules[0].oneOf[7].use[3]!../../../node_modules/sass-loader/dist/cjs.js??ruleSet[1].rules[0].oneOf[7].use[4]!./mermaid.min.css";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/materialdesignicons-webfont.eot?v=6.5.95", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/materialdesignicons-webfont.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/materialdesignicons-webfont.woff2?v=6.5.95", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../fonts/materialdesignicons-webfont.woff?v=6.5.95", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../fonts/materialdesignicons-webfont.ttf?v=6.5.95", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../fonts/boxicons.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../fonts/boxicons.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../fonts/boxicons.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../fonts/boxicons.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("../fonts/boxicons.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("../fonts/la-brands-400.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("../fonts/la-brands-400.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("../fonts/la-brands-400.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("../fonts/la-brands-400.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("../fonts/la-brands-400.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("../fonts/la-regular-400.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("../fonts/la-regular-400.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("../fonts/la-regular-400.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("../fonts/la-regular-400.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("../fonts/la-regular-400.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_20___ = new URL("../fonts/la-solid-900.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_21___ = new URL("../fonts/la-solid-900.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_22___ = new URL("../fonts/la-solid-900.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_23___ = new URL("../fonts/la-solid-900.ttf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_24___ = new URL("../fonts/la-solid-900.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_25___ = new URL("../fonts/remixicon.eot?t=1590207869815", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_26___ = new URL("../fonts/remixicon.woff2?t=1590207869815", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_27___ = new URL("../fonts/remixicon.woff?t=1590207869815", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_28___ = new URL("../fonts/remixicon.ttf?t=1590207869815", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_29___ = new URL("../fonts/remixicon.svg?t=1590207869815", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_30___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23343a40%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27M2 5l6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_31___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10l3 3l6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_32___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%272%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_33___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 20 20%27%3e%3cpath fill=%27none%27 stroke=%27%23fff%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%273%27 d=%27M6 10h8%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_34___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27rgba%280, 0, 0, 0.25%29%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_35___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23afd1e5%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_36___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23fff%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_37___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 8 8%27%3e%3cpath fill=%27%23319795%27 d=%27M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_38___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 12 12%27 width=%2712%27 height=%2712%27 fill=%27none%27 stroke=%27%23E53E3E%27%3e%3ccircle cx=%276%27 cy=%276%27 r=%274.5%27/%3e%3cpath stroke-linejoin=%27round%27 d=%27M5.8 3.6h.4L6 6.5z%27/%3e%3ccircle cx=%276%27 cy=%278.2%27 r=%27.6%27 fill=%27%23E53E3E%27 stroke=%27none%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_39___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%280, 0, 0, 0.55%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_40___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 30 30%27%3e%3cpath stroke=%27rgba%28255, 255, 255, 0.55%29%27 stroke-linecap=%27round%27 stroke-miterlimit=%2710%27 stroke-width=%272%27 d=%27M4 7h22M4 15h22M4 23h22%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_41___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27var%28--vz-body-color%29%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_42___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%235593b7%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_43___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23000%27%3e%3cpath d=%27M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_44___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath d=%27M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_45___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath d=%27M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_46___ = new URL("../fonts/hkgrotesk-light.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_47___ = new URL("../fonts/hkgrotesk-light.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_48___ = new URL("../fonts/hkgrotesk-regular.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_49___ = new URL("../fonts/hkgrotesk-regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_50___ = new URL("../fonts/hkgrotesk-medium.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_51___ = new URL("../fonts/hkgrotesk-medium.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_52___ = new URL("../fonts/hkgrotesk-semibold.eot", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_53___ = new URL("../fonts/hkgrotesk-semibold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_54___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23fff%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_55___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27 fill=%27%23adb5bd%27%3e%3cpath fill-rule=%27evenodd%27 d=%27M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_56___ = new URL("../images/modal-bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_57___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 version=%271.1%27 xmlns:xlink=%27http://www.w3.org/1999/xlink%27 xmlns:svgjs=%27http://svgjs.com/svgjs%27 width=%271440%27 height=%27560%27 preserveAspectRatio=%27none%27 viewBox=%270 0 1440 560%27%3e%3cg mask=%27url%28%26quot%3b%23SvgjsMask1016%26quot%3b%29%27 fill=%27none%27%3e%3crect width=%271440%27 height=%27560%27 x=%270%27 y=%270%27 fill=%27rgba%2864%2c 81%2c 137%2c 1%29%27%3e%3c/rect%3e%3cpath d=%27M0%2c650.704C122.328%2c648.746%2c159.175%2c473.043%2c255.674%2c397.837C339.724%2c332.333%2c461.529%2c324.924%2c526.449%2c240.421C598.428%2c146.73%2c655.546%2c24.847%2c631.015%2c-90.726C606.666%2c-205.444%2c482.926%2c-263.497%2c401.565%2c-347.958C325.215%2c-427.217%2c275.543%2c-549.012%2c167.826%2c-571.563C60.344%2c-594.065%2c-27.703%2c-482.932%2c-135.163%2c-460.325C-256.336%2c-434.833%2c-401.929%2c-509.651%2c-497.972%2c-431.495C-592.807%2c-354.321%2c-579.865%2c-206.886%2c-595.603%2c-85.635C-611.133%2c34.016%2c-656.761%2c169.183%2c-588.884%2c268.934C-520.854%2c368.909%2c-362.458%2c340.324%2c-260.989%2c406.106C-158.875%2c472.306%2c-121.679%2c652.651%2c0%2c650.704%27 fill=%27%2333416e%27%3e%3c/path%3e%3cpath d=%27M1440 995.672C1519.728 984.741 1563.12 899.779 1626.466 850.1469999999999 1682.6390000000001 806.135 1756.261 782.602 1791.2939999999999 720.431 1827.571 656.052 1835.537 577.6610000000001 1820.814 505.247 1806.518 434.933 1753.2640000000001 383.16999999999996 1710.941 325.228 1664.475 261.614 1634.992 175.16000000000003 1560.657 149.07999999999998 1485.96 122.87299999999999 1402.146 155.543 1332.03 192.289 1269.541 225.038 1232.754 287.251 1189.969 343.347 1149.925 395.849 1115.781 448.9 1089.96 509.672 1056 589.599 988.9680000000001 671.1659999999999 1015.557 753.837 1041.91 835.774 1142.714 863.61 1217.498 906.22 1288.388 946.611 1359.167 1006.755 1440 995.672%27 fill=%27%234d61a4%27%3e%3c/path%3e%3c/g%3e%3cdefs%3e%3cmask id=%27SvgjsMask1016%27%3e%3crect width=%271440%27 height=%27560%27 fill=%27white%27%3e%3c/rect%3e%3c/mask%3e%3c/defs%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_58___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%27-4 -4 8 8%27%3e%3ccircle r=%273%27 fill=%27%23ced4da%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_59___ = new URL("data:image/svg+xml,%3csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 16 16%27%3e%3cpath fill=%27none%27 stroke=%27%23ced4da%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27 stroke-width=%272%27 d=%27M2 5l6 6 6-6%27/%3e%3c/svg%3e", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_60___ = new URL("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyMSAyMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSIjMDAwIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik0yLjU5Mi4wNDRsMTguMzY0IDE4LjM2NC0yLjU0OCAyLjU0OEwuMDQ0IDIuNTkyeiIvPjxwYXRoIGQ9Ik0wIDE4LjM2NEwxOC4zNjQgMGwyLjU0OCAyLjU0OEwyLjU0OCAyMC45MTJ6Ii8+PC9nPjwvc3ZnPg==", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_61___ = new URL("data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyMSAyMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSIjRkZGIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik0yLjU5Mi4wNDRsMTguMzY0IDE4LjM2NC0yLjU0OCAyLjU0OEwuMDQ0IDIuNTkyeiIvPjxwYXRoIGQ9Ik0wIDE4LjM2NEwxOC4zNjQgMGwyLjU0OCAyLjU0OEwyLjU0OCAyMC45MTJ6Ii8+PC9nPjwvc3ZnPg==", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_62___ = new URL("../images/auth-one-bg.jpg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_63___ = new URL("../images/cover-pattern.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_64___ = new URL("../images/chat-bg-pattern.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_65___ = new URL("../images/file.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_66___ = new URL("../images/landing/bg-pattern.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Nunito:wght@300;400;500;600;700&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap);"]);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Nunito:wght@300;400;500;600;700&display=swap);"]);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___, { hash: "?#iefix&v=6.5.95" });
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___, { hash: "?#boxicons" });
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___, { hash: "#lineawesome" });
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_20___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_21___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___, { hash: "#lineawesome" });
var ___CSS_LOADER_URL_REPLACEMENT_22___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___);
var ___CSS_LOADER_URL_REPLACEMENT_23___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_20___, { hash: "?#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_24___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_21___);
var ___CSS_LOADER_URL_REPLACEMENT_25___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_22___);
var ___CSS_LOADER_URL_REPLACEMENT_26___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_23___);
var ___CSS_LOADER_URL_REPLACEMENT_27___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_24___, { hash: "#lineawesome" });
var ___CSS_LOADER_URL_REPLACEMENT_28___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___);
var ___CSS_LOADER_URL_REPLACEMENT_29___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_25___, { hash: "#iefix" });
var ___CSS_LOADER_URL_REPLACEMENT_30___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_26___);
var ___CSS_LOADER_URL_REPLACEMENT_31___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_27___);
var ___CSS_LOADER_URL_REPLACEMENT_32___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_28___);
var ___CSS_LOADER_URL_REPLACEMENT_33___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_29___, { hash: "#remixicon" });
var ___CSS_LOADER_URL_REPLACEMENT_34___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_30___);
var ___CSS_LOADER_URL_REPLACEMENT_35___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_31___);
var ___CSS_LOADER_URL_REPLACEMENT_36___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_32___);
var ___CSS_LOADER_URL_REPLACEMENT_37___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_33___);
var ___CSS_LOADER_URL_REPLACEMENT_38___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_34___);
var ___CSS_LOADER_URL_REPLACEMENT_39___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_35___);
var ___CSS_LOADER_URL_REPLACEMENT_40___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_36___);
var ___CSS_LOADER_URL_REPLACEMENT_41___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_37___);
var ___CSS_LOADER_URL_REPLACEMENT_42___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_38___);
var ___CSS_LOADER_URL_REPLACEMENT_43___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_39___);
var ___CSS_LOADER_URL_REPLACEMENT_44___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_40___);
var ___CSS_LOADER_URL_REPLACEMENT_45___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_41___);
var ___CSS_LOADER_URL_REPLACEMENT_46___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_42___);
var ___CSS_LOADER_URL_REPLACEMENT_47___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_43___);
var ___CSS_LOADER_URL_REPLACEMENT_48___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_44___);
var ___CSS_LOADER_URL_REPLACEMENT_49___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_45___);
var ___CSS_LOADER_URL_REPLACEMENT_50___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_46___);
var ___CSS_LOADER_URL_REPLACEMENT_51___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_47___);
var ___CSS_LOADER_URL_REPLACEMENT_52___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_48___);
var ___CSS_LOADER_URL_REPLACEMENT_53___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_49___);
var ___CSS_LOADER_URL_REPLACEMENT_54___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_50___);
var ___CSS_LOADER_URL_REPLACEMENT_55___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_51___);
var ___CSS_LOADER_URL_REPLACEMENT_56___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_52___);
var ___CSS_LOADER_URL_REPLACEMENT_57___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_53___);
var ___CSS_LOADER_URL_REPLACEMENT_58___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_54___);
var ___CSS_LOADER_URL_REPLACEMENT_59___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_55___);
var ___CSS_LOADER_URL_REPLACEMENT_60___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_56___);
var ___CSS_LOADER_URL_REPLACEMENT_61___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_57___);
var ___CSS_LOADER_URL_REPLACEMENT_62___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_58___);
var ___CSS_LOADER_URL_REPLACEMENT_63___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_59___);
var ___CSS_LOADER_URL_REPLACEMENT_64___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_60___);
var ___CSS_LOADER_URL_REPLACEMENT_65___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_61___);
var ___CSS_LOADER_URL_REPLACEMENT_66___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_62___);
var ___CSS_LOADER_URL_REPLACEMENT_67___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_63___);
var ___CSS_LOADER_URL_REPLACEMENT_68___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_64___);
var ___CSS_LOADER_URL_REPLACEMENT_69___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_65___);
var ___CSS_LOADER_URL_REPLACEMENT_70___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_66___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/*
Template Name: Velzon - Admin & Dashboard Template
Author: Themesbrand
Version: 1.4.0
Website: https://Themesbrand.com/
Contact: Themesbrand@gmail.com
File: Icons Css File
*/
/* MaterialDesignIcons.com */
@font-face {
  font-family: "Material Design Icons";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("truetype");
  font-weight: normal;
  font-style: normal; }

.mdi:before,
.mdi-set {
  display: inline-block;
  font: normal normal normal 24px/1 "Material Design Icons";
  font-size: inherit;
  text-rendering: auto;
  line-height: inherit;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale; }

.mdi-ab-testing::before {
  content: "\\F01C9"; }

.mdi-abacus::before {
  content: "\\F16E0"; }

.mdi-abjad-arabic::before {
  content: "\\F1328"; }

.mdi-abjad-hebrew::before {
  content: "\\F1329"; }

.mdi-abugida-devanagari::before {
  content: "\\F132A"; }

.mdi-abugida-thai::before {
  content: "\\F132B"; }

.mdi-access-point::before {
  content: "\\F0003"; }

.mdi-access-point-check::before {
  content: "\\F1538"; }

.mdi-access-point-minus::before {
  content: "\\F1539"; }

.mdi-access-point-network::before {
  content: "\\F0002"; }

.mdi-access-point-network-off::before {
  content: "\\F0BE1"; }

.mdi-access-point-off::before {
  content: "\\F1511"; }

.mdi-access-point-plus::before {
  content: "\\F153A"; }

.mdi-access-point-remove::before {
  content: "\\F153B"; }

.mdi-account::before {
  content: "\\F0004"; }

.mdi-account-alert::before {
  content: "\\F0005"; }

.mdi-account-alert-outline::before {
  content: "\\F0B50"; }

.mdi-account-arrow-down::before {
  content: "\\F1868"; }

.mdi-account-arrow-down-outline::before {
  content: "\\F1869"; }

.mdi-account-arrow-left::before {
  content: "\\F0B51"; }

.mdi-account-arrow-left-outline::before {
  content: "\\F0B52"; }

.mdi-account-arrow-right::before {
  content: "\\F0B53"; }

.mdi-account-arrow-right-outline::before {
  content: "\\F0B54"; }

.mdi-account-arrow-up::before {
  content: "\\F1867"; }

.mdi-account-arrow-up-outline::before {
  content: "\\F186A"; }

.mdi-account-box::before {
  content: "\\F0006"; }

.mdi-account-box-multiple::before {
  content: "\\F0934"; }

.mdi-account-box-multiple-outline::before {
  content: "\\F100A"; }

.mdi-account-box-outline::before {
  content: "\\F0007"; }

.mdi-account-cancel::before {
  content: "\\F12DF"; }

.mdi-account-cancel-outline::before {
  content: "\\F12E0"; }

.mdi-account-cash::before {
  content: "\\F1097"; }

.mdi-account-cash-outline::before {
  content: "\\F1098"; }

.mdi-account-check::before {
  content: "\\F0008"; }

.mdi-account-check-outline::before {
  content: "\\F0BE2"; }

.mdi-account-child::before {
  content: "\\F0A89"; }

.mdi-account-child-circle::before {
  content: "\\F0A8A"; }

.mdi-account-child-outline::before {
  content: "\\F10C8"; }

.mdi-account-circle::before {
  content: "\\F0009"; }

.mdi-account-circle-outline::before {
  content: "\\F0B55"; }

.mdi-account-clock::before {
  content: "\\F0B56"; }

.mdi-account-clock-outline::before {
  content: "\\F0B57"; }

.mdi-account-cog::before {
  content: "\\F1370"; }

.mdi-account-cog-outline::before {
  content: "\\F1371"; }

.mdi-account-convert::before {
  content: "\\F000A"; }

.mdi-account-convert-outline::before {
  content: "\\F1301"; }

.mdi-account-cowboy-hat::before {
  content: "\\F0E9B"; }

.mdi-account-cowboy-hat-outline::before {
  content: "\\F17F3"; }

.mdi-account-details::before {
  content: "\\F0631"; }

.mdi-account-details-outline::before {
  content: "\\F1372"; }

.mdi-account-edit::before {
  content: "\\F06BC"; }

.mdi-account-edit-outline::before {
  content: "\\F0FFB"; }

.mdi-account-eye::before {
  content: "\\F0420"; }

.mdi-account-eye-outline::before {
  content: "\\F127B"; }

.mdi-account-filter::before {
  content: "\\F0936"; }

.mdi-account-filter-outline::before {
  content: "\\F0F9D"; }

.mdi-account-group::before {
  content: "\\F0849"; }

.mdi-account-group-outline::before {
  content: "\\F0B58"; }

.mdi-account-hard-hat::before {
  content: "\\F05B5"; }

.mdi-account-heart::before {
  content: "\\F0899"; }

.mdi-account-heart-outline::before {
  content: "\\F0BE3"; }

.mdi-account-injury::before {
  content: "\\F1815"; }

.mdi-account-injury-outline::before {
  content: "\\F1816"; }

.mdi-account-key::before {
  content: "\\F000B"; }

.mdi-account-key-outline::before {
  content: "\\F0BE4"; }

.mdi-account-lock::before {
  content: "\\F115E"; }

.mdi-account-lock-open::before {
  content: "\\F1960"; }

.mdi-account-lock-open-outline::before {
  content: "\\F1961"; }

.mdi-account-lock-outline::before {
  content: "\\F115F"; }

.mdi-account-minus::before {
  content: "\\F000D"; }

.mdi-account-minus-outline::before {
  content: "\\F0AEC"; }

.mdi-account-multiple::before {
  content: "\\F000E"; }

.mdi-account-multiple-check::before {
  content: "\\F08C5"; }

.mdi-account-multiple-check-outline::before {
  content: "\\F11FE"; }

.mdi-account-multiple-minus::before {
  content: "\\F05D3"; }

.mdi-account-multiple-minus-outline::before {
  content: "\\F0BE5"; }

.mdi-account-multiple-outline::before {
  content: "\\F000F"; }

.mdi-account-multiple-plus::before {
  content: "\\F0010"; }

.mdi-account-multiple-plus-outline::before {
  content: "\\F0800"; }

.mdi-account-multiple-remove::before {
  content: "\\F120A"; }

.mdi-account-multiple-remove-outline::before {
  content: "\\F120B"; }

.mdi-account-music::before {
  content: "\\F0803"; }

.mdi-account-music-outline::before {
  content: "\\F0CE9"; }

.mdi-account-network::before {
  content: "\\F0011"; }

.mdi-account-network-outline::before {
  content: "\\F0BE6"; }

.mdi-account-off::before {
  content: "\\F0012"; }

.mdi-account-off-outline::before {
  content: "\\F0BE7"; }

.mdi-account-outline::before {
  content: "\\F0013"; }

.mdi-account-plus::before {
  content: "\\F0014"; }

.mdi-account-plus-outline::before {
  content: "\\F0801"; }

.mdi-account-question::before {
  content: "\\F0B59"; }

.mdi-account-question-outline::before {
  content: "\\F0B5A"; }

.mdi-account-reactivate::before {
  content: "\\F152B"; }

.mdi-account-reactivate-outline::before {
  content: "\\F152C"; }

.mdi-account-remove::before {
  content: "\\F0015"; }

.mdi-account-remove-outline::before {
  content: "\\F0AED"; }

.mdi-account-search::before {
  content: "\\F0016"; }

.mdi-account-search-outline::before {
  content: "\\F0935"; }

.mdi-account-settings::before {
  content: "\\F0630"; }

.mdi-account-settings-outline::before {
  content: "\\F10C9"; }

.mdi-account-star::before {
  content: "\\F0017"; }

.mdi-account-star-outline::before {
  content: "\\F0BE8"; }

.mdi-account-supervisor::before {
  content: "\\F0A8B"; }

.mdi-account-supervisor-circle::before {
  content: "\\F0A8C"; }

.mdi-account-supervisor-circle-outline::before {
  content: "\\F14EC"; }

.mdi-account-supervisor-outline::before {
  content: "\\F112D"; }

.mdi-account-switch::before {
  content: "\\F0019"; }

.mdi-account-switch-outline::before {
  content: "\\F04CB"; }

.mdi-account-sync::before {
  content: "\\F191B"; }

.mdi-account-sync-outline::before {
  content: "\\F191C"; }

.mdi-account-tie::before {
  content: "\\F0CE3"; }

.mdi-account-tie-hat::before {
  content: "\\F1898"; }

.mdi-account-tie-hat-outline::before {
  content: "\\F1899"; }

.mdi-account-tie-outline::before {
  content: "\\F10CA"; }

.mdi-account-tie-voice::before {
  content: "\\F1308"; }

.mdi-account-tie-voice-off::before {
  content: "\\F130A"; }

.mdi-account-tie-voice-off-outline::before {
  content: "\\F130B"; }

.mdi-account-tie-voice-outline::before {
  content: "\\F1309"; }

.mdi-account-voice::before {
  content: "\\F05CB"; }

.mdi-account-voice-off::before {
  content: "\\F0ED4"; }

.mdi-account-wrench::before {
  content: "\\F189A"; }

.mdi-account-wrench-outline::before {
  content: "\\F189B"; }

.mdi-adjust::before {
  content: "\\F001A"; }

.mdi-advertisements::before {
  content: "\\F192A"; }

.mdi-advertisements-off::before {
  content: "\\F192B"; }

.mdi-air-conditioner::before {
  content: "\\F001B"; }

.mdi-air-filter::before {
  content: "\\F0D43"; }

.mdi-air-horn::before {
  content: "\\F0DAC"; }

.mdi-air-humidifier::before {
  content: "\\F1099"; }

.mdi-air-humidifier-off::before {
  content: "\\F1466"; }

.mdi-air-purifier::before {
  content: "\\F0D44"; }

.mdi-airbag::before {
  content: "\\F0BE9"; }

.mdi-airballoon::before {
  content: "\\F001C"; }

.mdi-airballoon-outline::before {
  content: "\\F100B"; }

.mdi-airplane::before {
  content: "\\F001D"; }

.mdi-airplane-alert::before {
  content: "\\F187A"; }

.mdi-airplane-check::before {
  content: "\\F187B"; }

.mdi-airplane-clock::before {
  content: "\\F187C"; }

.mdi-airplane-cog::before {
  content: "\\F187D"; }

.mdi-airplane-edit::before {
  content: "\\F187E"; }

.mdi-airplane-landing::before {
  content: "\\F05D4"; }

.mdi-airplane-marker::before {
  content: "\\F187F"; }

.mdi-airplane-minus::before {
  content: "\\F1880"; }

.mdi-airplane-off::before {
  content: "\\F001E"; }

.mdi-airplane-plus::before {
  content: "\\F1881"; }

.mdi-airplane-remove::before {
  content: "\\F1882"; }

.mdi-airplane-search::before {
  content: "\\F1883"; }

.mdi-airplane-settings::before {
  content: "\\F1884"; }

.mdi-airplane-takeoff::before {
  content: "\\F05D5"; }

.mdi-airport::before {
  content: "\\F084B"; }

.mdi-alarm::before {
  content: "\\F0020"; }

.mdi-alarm-bell::before {
  content: "\\F078E"; }

.mdi-alarm-check::before {
  content: "\\F0021"; }

.mdi-alarm-light::before {
  content: "\\F078F"; }

.mdi-alarm-light-off::before {
  content: "\\F171E"; }

.mdi-alarm-light-off-outline::before {
  content: "\\F171F"; }

.mdi-alarm-light-outline::before {
  content: "\\F0BEA"; }

.mdi-alarm-multiple::before {
  content: "\\F0022"; }

.mdi-alarm-note::before {
  content: "\\F0E71"; }

.mdi-alarm-note-off::before {
  content: "\\F0E72"; }

.mdi-alarm-off::before {
  content: "\\F0023"; }

.mdi-alarm-panel::before {
  content: "\\F15C4"; }

.mdi-alarm-panel-outline::before {
  content: "\\F15C5"; }

.mdi-alarm-plus::before {
  content: "\\F0024"; }

.mdi-alarm-snooze::before {
  content: "\\F068E"; }

.mdi-album::before {
  content: "\\F0025"; }

.mdi-alert::before {
  content: "\\F0026"; }

.mdi-alert-box::before {
  content: "\\F0027"; }

.mdi-alert-box-outline::before {
  content: "\\F0CE4"; }

.mdi-alert-circle::before {
  content: "\\F0028"; }

.mdi-alert-circle-check::before {
  content: "\\F11ED"; }

.mdi-alert-circle-check-outline::before {
  content: "\\F11EE"; }

.mdi-alert-circle-outline::before {
  content: "\\F05D6"; }

.mdi-alert-decagram::before {
  content: "\\F06BD"; }

.mdi-alert-decagram-outline::before {
  content: "\\F0CE5"; }

.mdi-alert-minus::before {
  content: "\\F14BB"; }

.mdi-alert-minus-outline::before {
  content: "\\F14BE"; }

.mdi-alert-octagon::before {
  content: "\\F0029"; }

.mdi-alert-octagon-outline::before {
  content: "\\F0CE6"; }

.mdi-alert-octagram::before {
  content: "\\F0767"; }

.mdi-alert-octagram-outline::before {
  content: "\\F0CE7"; }

.mdi-alert-outline::before {
  content: "\\F002A"; }

.mdi-alert-plus::before {
  content: "\\F14BA"; }

.mdi-alert-plus-outline::before {
  content: "\\F14BD"; }

.mdi-alert-remove::before {
  content: "\\F14BC"; }

.mdi-alert-remove-outline::before {
  content: "\\F14BF"; }

.mdi-alert-rhombus::before {
  content: "\\F11CE"; }

.mdi-alert-rhombus-outline::before {
  content: "\\F11CF"; }

.mdi-alien::before {
  content: "\\F089A"; }

.mdi-alien-outline::before {
  content: "\\F10CB"; }

.mdi-align-horizontal-center::before {
  content: "\\F11C3"; }

.mdi-align-horizontal-distribute::before {
  content: "\\F1962"; }

.mdi-align-horizontal-left::before {
  content: "\\F11C2"; }

.mdi-align-horizontal-right::before {
  content: "\\F11C4"; }

.mdi-align-vertical-bottom::before {
  content: "\\F11C5"; }

.mdi-align-vertical-center::before {
  content: "\\F11C6"; }

.mdi-align-vertical-distribute::before {
  content: "\\F1963"; }

.mdi-align-vertical-top::before {
  content: "\\F11C7"; }

.mdi-all-inclusive::before {
  content: "\\F06BE"; }

.mdi-all-inclusive-box::before {
  content: "\\F188D"; }

.mdi-all-inclusive-box-outline::before {
  content: "\\F188E"; }

.mdi-allergy::before {
  content: "\\F1258"; }

.mdi-alpha::before {
  content: "\\F002B"; }

.mdi-alpha-a::before {
  content: "\\F0AEE"; }

.mdi-alpha-a-box::before {
  content: "\\F0B08"; }

.mdi-alpha-a-box-outline::before {
  content: "\\F0BEB"; }

.mdi-alpha-a-circle::before {
  content: "\\F0BEC"; }

.mdi-alpha-a-circle-outline::before {
  content: "\\F0BED"; }

.mdi-alpha-b::before {
  content: "\\F0AEF"; }

.mdi-alpha-b-box::before {
  content: "\\F0B09"; }

.mdi-alpha-b-box-outline::before {
  content: "\\F0BEE"; }

.mdi-alpha-b-circle::before {
  content: "\\F0BEF"; }

.mdi-alpha-b-circle-outline::before {
  content: "\\F0BF0"; }

.mdi-alpha-c::before {
  content: "\\F0AF0"; }

.mdi-alpha-c-box::before {
  content: "\\F0B0A"; }

.mdi-alpha-c-box-outline::before {
  content: "\\F0BF1"; }

.mdi-alpha-c-circle::before {
  content: "\\F0BF2"; }

.mdi-alpha-c-circle-outline::before {
  content: "\\F0BF3"; }

.mdi-alpha-d::before {
  content: "\\F0AF1"; }

.mdi-alpha-d-box::before {
  content: "\\F0B0B"; }

.mdi-alpha-d-box-outline::before {
  content: "\\F0BF4"; }

.mdi-alpha-d-circle::before {
  content: "\\F0BF5"; }

.mdi-alpha-d-circle-outline::before {
  content: "\\F0BF6"; }

.mdi-alpha-e::before {
  content: "\\F0AF2"; }

.mdi-alpha-e-box::before {
  content: "\\F0B0C"; }

.mdi-alpha-e-box-outline::before {
  content: "\\F0BF7"; }

.mdi-alpha-e-circle::before {
  content: "\\F0BF8"; }

.mdi-alpha-e-circle-outline::before {
  content: "\\F0BF9"; }

.mdi-alpha-f::before {
  content: "\\F0AF3"; }

.mdi-alpha-f-box::before {
  content: "\\F0B0D"; }

.mdi-alpha-f-box-outline::before {
  content: "\\F0BFA"; }

.mdi-alpha-f-circle::before {
  content: "\\F0BFB"; }

.mdi-alpha-f-circle-outline::before {
  content: "\\F0BFC"; }

.mdi-alpha-g::before {
  content: "\\F0AF4"; }

.mdi-alpha-g-box::before {
  content: "\\F0B0E"; }

.mdi-alpha-g-box-outline::before {
  content: "\\F0BFD"; }

.mdi-alpha-g-circle::before {
  content: "\\F0BFE"; }

.mdi-alpha-g-circle-outline::before {
  content: "\\F0BFF"; }

.mdi-alpha-h::before {
  content: "\\F0AF5"; }

.mdi-alpha-h-box::before {
  content: "\\F0B0F"; }

.mdi-alpha-h-box-outline::before {
  content: "\\F0C00"; }

.mdi-alpha-h-circle::before {
  content: "\\F0C01"; }

.mdi-alpha-h-circle-outline::before {
  content: "\\F0C02"; }

.mdi-alpha-i::before {
  content: "\\F0AF6"; }

.mdi-alpha-i-box::before {
  content: "\\F0B10"; }

.mdi-alpha-i-box-outline::before {
  content: "\\F0C03"; }

.mdi-alpha-i-circle::before {
  content: "\\F0C04"; }

.mdi-alpha-i-circle-outline::before {
  content: "\\F0C05"; }

.mdi-alpha-j::before {
  content: "\\F0AF7"; }

.mdi-alpha-j-box::before {
  content: "\\F0B11"; }

.mdi-alpha-j-box-outline::before {
  content: "\\F0C06"; }

.mdi-alpha-j-circle::before {
  content: "\\F0C07"; }

.mdi-alpha-j-circle-outline::before {
  content: "\\F0C08"; }

.mdi-alpha-k::before {
  content: "\\F0AF8"; }

.mdi-alpha-k-box::before {
  content: "\\F0B12"; }

.mdi-alpha-k-box-outline::before {
  content: "\\F0C09"; }

.mdi-alpha-k-circle::before {
  content: "\\F0C0A"; }

.mdi-alpha-k-circle-outline::before {
  content: "\\F0C0B"; }

.mdi-alpha-l::before {
  content: "\\F0AF9"; }

.mdi-alpha-l-box::before {
  content: "\\F0B13"; }

.mdi-alpha-l-box-outline::before {
  content: "\\F0C0C"; }

.mdi-alpha-l-circle::before {
  content: "\\F0C0D"; }

.mdi-alpha-l-circle-outline::before {
  content: "\\F0C0E"; }

.mdi-alpha-m::before {
  content: "\\F0AFA"; }

.mdi-alpha-m-box::before {
  content: "\\F0B14"; }

.mdi-alpha-m-box-outline::before {
  content: "\\F0C0F"; }

.mdi-alpha-m-circle::before {
  content: "\\F0C10"; }

.mdi-alpha-m-circle-outline::before {
  content: "\\F0C11"; }

.mdi-alpha-n::before {
  content: "\\F0AFB"; }

.mdi-alpha-n-box::before {
  content: "\\F0B15"; }

.mdi-alpha-n-box-outline::before {
  content: "\\F0C12"; }

.mdi-alpha-n-circle::before {
  content: "\\F0C13"; }

.mdi-alpha-n-circle-outline::before {
  content: "\\F0C14"; }

.mdi-alpha-o::before {
  content: "\\F0AFC"; }

.mdi-alpha-o-box::before {
  content: "\\F0B16"; }

.mdi-alpha-o-box-outline::before {
  content: "\\F0C15"; }

.mdi-alpha-o-circle::before {
  content: "\\F0C16"; }

.mdi-alpha-o-circle-outline::before {
  content: "\\F0C17"; }

.mdi-alpha-p::before {
  content: "\\F0AFD"; }

.mdi-alpha-p-box::before {
  content: "\\F0B17"; }

.mdi-alpha-p-box-outline::before {
  content: "\\F0C18"; }

.mdi-alpha-p-circle::before {
  content: "\\F0C19"; }

.mdi-alpha-p-circle-outline::before {
  content: "\\F0C1A"; }

.mdi-alpha-q::before {
  content: "\\F0AFE"; }

.mdi-alpha-q-box::before {
  content: "\\F0B18"; }

.mdi-alpha-q-box-outline::before {
  content: "\\F0C1B"; }

.mdi-alpha-q-circle::before {
  content: "\\F0C1C"; }

.mdi-alpha-q-circle-outline::before {
  content: "\\F0C1D"; }

.mdi-alpha-r::before {
  content: "\\F0AFF"; }

.mdi-alpha-r-box::before {
  content: "\\F0B19"; }

.mdi-alpha-r-box-outline::before {
  content: "\\F0C1E"; }

.mdi-alpha-r-circle::before {
  content: "\\F0C1F"; }

.mdi-alpha-r-circle-outline::before {
  content: "\\F0C20"; }

.mdi-alpha-s::before {
  content: "\\F0B00"; }

.mdi-alpha-s-box::before {
  content: "\\F0B1A"; }

.mdi-alpha-s-box-outline::before {
  content: "\\F0C21"; }

.mdi-alpha-s-circle::before {
  content: "\\F0C22"; }

.mdi-alpha-s-circle-outline::before {
  content: "\\F0C23"; }

.mdi-alpha-t::before {
  content: "\\F0B01"; }

.mdi-alpha-t-box::before {
  content: "\\F0B1B"; }

.mdi-alpha-t-box-outline::before {
  content: "\\F0C24"; }

.mdi-alpha-t-circle::before {
  content: "\\F0C25"; }

.mdi-alpha-t-circle-outline::before {
  content: "\\F0C26"; }

.mdi-alpha-u::before {
  content: "\\F0B02"; }

.mdi-alpha-u-box::before {
  content: "\\F0B1C"; }

.mdi-alpha-u-box-outline::before {
  content: "\\F0C27"; }

.mdi-alpha-u-circle::before {
  content: "\\F0C28"; }

.mdi-alpha-u-circle-outline::before {
  content: "\\F0C29"; }

.mdi-alpha-v::before {
  content: "\\F0B03"; }

.mdi-alpha-v-box::before {
  content: "\\F0B1D"; }

.mdi-alpha-v-box-outline::before {
  content: "\\F0C2A"; }

.mdi-alpha-v-circle::before {
  content: "\\F0C2B"; }

.mdi-alpha-v-circle-outline::before {
  content: "\\F0C2C"; }

.mdi-alpha-w::before {
  content: "\\F0B04"; }

.mdi-alpha-w-box::before {
  content: "\\F0B1E"; }

.mdi-alpha-w-box-outline::before {
  content: "\\F0C2D"; }

.mdi-alpha-w-circle::before {
  content: "\\F0C2E"; }

.mdi-alpha-w-circle-outline::before {
  content: "\\F0C2F"; }

.mdi-alpha-x::before {
  content: "\\F0B05"; }

.mdi-alpha-x-box::before {
  content: "\\F0B1F"; }

.mdi-alpha-x-box-outline::before {
  content: "\\F0C30"; }

.mdi-alpha-x-circle::before {
  content: "\\F0C31"; }

.mdi-alpha-x-circle-outline::before {
  content: "\\F0C32"; }

.mdi-alpha-y::before {
  content: "\\F0B06"; }

.mdi-alpha-y-box::before {
  content: "\\F0B20"; }

.mdi-alpha-y-box-outline::before {
  content: "\\F0C33"; }

.mdi-alpha-y-circle::before {
  content: "\\F0C34"; }

.mdi-alpha-y-circle-outline::before {
  content: "\\F0C35"; }

.mdi-alpha-z::before {
  content: "\\F0B07"; }

.mdi-alpha-z-box::before {
  content: "\\F0B21"; }

.mdi-alpha-z-box-outline::before {
  content: "\\F0C36"; }

.mdi-alpha-z-circle::before {
  content: "\\F0C37"; }

.mdi-alpha-z-circle-outline::before {
  content: "\\F0C38"; }

.mdi-alphabet-aurebesh::before {
  content: "\\F132C"; }

.mdi-alphabet-cyrillic::before {
  content: "\\F132D"; }

.mdi-alphabet-greek::before {
  content: "\\F132E"; }

.mdi-alphabet-latin::before {
  content: "\\F132F"; }

.mdi-alphabet-piqad::before {
  content: "\\F1330"; }

.mdi-alphabet-tengwar::before {
  content: "\\F1337"; }

.mdi-alphabetical::before {
  content: "\\F002C"; }

.mdi-alphabetical-off::before {
  content: "\\F100C"; }

.mdi-alphabetical-variant::before {
  content: "\\F100D"; }

.mdi-alphabetical-variant-off::before {
  content: "\\F100E"; }

.mdi-altimeter::before {
  content: "\\F05D7"; }

.mdi-ambulance::before {
  content: "\\F002F"; }

.mdi-ammunition::before {
  content: "\\F0CE8"; }

.mdi-ampersand::before {
  content: "\\F0A8D"; }

.mdi-amplifier::before {
  content: "\\F0030"; }

.mdi-amplifier-off::before {
  content: "\\F11B5"; }

.mdi-anchor::before {
  content: "\\F0031"; }

.mdi-android::before {
  content: "\\F0032"; }

.mdi-android-messages::before {
  content: "\\F0D45"; }

.mdi-android-studio::before {
  content: "\\F0034"; }

.mdi-angle-acute::before {
  content: "\\F0937"; }

.mdi-angle-obtuse::before {
  content: "\\F0938"; }

.mdi-angle-right::before {
  content: "\\F0939"; }

.mdi-angular::before {
  content: "\\F06B2"; }

.mdi-angularjs::before {
  content: "\\F06BF"; }

.mdi-animation::before {
  content: "\\F05D8"; }

.mdi-animation-outline::before {
  content: "\\F0A8F"; }

.mdi-animation-play::before {
  content: "\\F093A"; }

.mdi-animation-play-outline::before {
  content: "\\F0A90"; }

.mdi-ansible::before {
  content: "\\F109A"; }

.mdi-antenna::before {
  content: "\\F1119"; }

.mdi-anvil::before {
  content: "\\F089B"; }

.mdi-apache-kafka::before {
  content: "\\F100F"; }

.mdi-api::before {
  content: "\\F109B"; }

.mdi-api-off::before {
  content: "\\F1257"; }

.mdi-apple::before {
  content: "\\F0035"; }

.mdi-apple-finder::before {
  content: "\\F0036"; }

.mdi-apple-icloud::before {
  content: "\\F0038"; }

.mdi-apple-ios::before {
  content: "\\F0037"; }

.mdi-apple-keyboard-caps::before {
  content: "\\F0632"; }

.mdi-apple-keyboard-command::before {
  content: "\\F0633"; }

.mdi-apple-keyboard-control::before {
  content: "\\F0634"; }

.mdi-apple-keyboard-option::before {
  content: "\\F0635"; }

.mdi-apple-keyboard-shift::before {
  content: "\\F0636"; }

.mdi-apple-safari::before {
  content: "\\F0039"; }

.mdi-application::before {
  content: "\\F08C6"; }

.mdi-application-array::before {
  content: "\\F10F5"; }

.mdi-application-array-outline::before {
  content: "\\F10F6"; }

.mdi-application-braces::before {
  content: "\\F10F7"; }

.mdi-application-braces-outline::before {
  content: "\\F10F8"; }

.mdi-application-brackets::before {
  content: "\\F0C8B"; }

.mdi-application-brackets-outline::before {
  content: "\\F0C8C"; }

.mdi-application-cog::before {
  content: "\\F0675"; }

.mdi-application-cog-outline::before {
  content: "\\F1577"; }

.mdi-application-edit::before {
  content: "\\F00AE"; }

.mdi-application-edit-outline::before {
  content: "\\F0619"; }

.mdi-application-export::before {
  content: "\\F0DAD"; }

.mdi-application-import::before {
  content: "\\F0DAE"; }

.mdi-application-outline::before {
  content: "\\F0614"; }

.mdi-application-parentheses::before {
  content: "\\F10F9"; }

.mdi-application-parentheses-outline::before {
  content: "\\F10FA"; }

.mdi-application-settings::before {
  content: "\\F0B60"; }

.mdi-application-settings-outline::before {
  content: "\\F1555"; }

.mdi-application-variable::before {
  content: "\\F10FB"; }

.mdi-application-variable-outline::before {
  content: "\\F10FC"; }

.mdi-approximately-equal::before {
  content: "\\F0F9E"; }

.mdi-approximately-equal-box::before {
  content: "\\F0F9F"; }

.mdi-apps::before {
  content: "\\F003B"; }

.mdi-apps-box::before {
  content: "\\F0D46"; }

.mdi-arch::before {
  content: "\\F08C7"; }

.mdi-archive::before {
  content: "\\F003C"; }

.mdi-archive-alert::before {
  content: "\\F14FD"; }

.mdi-archive-alert-outline::before {
  content: "\\F14FE"; }

.mdi-archive-arrow-down::before {
  content: "\\F1259"; }

.mdi-archive-arrow-down-outline::before {
  content: "\\F125A"; }

.mdi-archive-arrow-up::before {
  content: "\\F125B"; }

.mdi-archive-arrow-up-outline::before {
  content: "\\F125C"; }

.mdi-archive-cancel::before {
  content: "\\F174B"; }

.mdi-archive-cancel-outline::before {
  content: "\\F174C"; }

.mdi-archive-check::before {
  content: "\\F174D"; }

.mdi-archive-check-outline::before {
  content: "\\F174E"; }

.mdi-archive-clock::before {
  content: "\\F174F"; }

.mdi-archive-clock-outline::before {
  content: "\\F1750"; }

.mdi-archive-cog::before {
  content: "\\F1751"; }

.mdi-archive-cog-outline::before {
  content: "\\F1752"; }

.mdi-archive-edit::before {
  content: "\\F1753"; }

.mdi-archive-edit-outline::before {
  content: "\\F1754"; }

.mdi-archive-eye::before {
  content: "\\F1755"; }

.mdi-archive-eye-outline::before {
  content: "\\F1756"; }

.mdi-archive-lock::before {
  content: "\\F1757"; }

.mdi-archive-lock-open::before {
  content: "\\F1758"; }

.mdi-archive-lock-open-outline::before {
  content: "\\F1759"; }

.mdi-archive-lock-outline::before {
  content: "\\F175A"; }

.mdi-archive-marker::before {
  content: "\\F175B"; }

.mdi-archive-marker-outline::before {
  content: "\\F175C"; }

.mdi-archive-minus::before {
  content: "\\F175D"; }

.mdi-archive-minus-outline::before {
  content: "\\F175E"; }

.mdi-archive-music::before {
  content: "\\F175F"; }

.mdi-archive-music-outline::before {
  content: "\\F1760"; }

.mdi-archive-off::before {
  content: "\\F1761"; }

.mdi-archive-off-outline::before {
  content: "\\F1762"; }

.mdi-archive-outline::before {
  content: "\\F120E"; }

.mdi-archive-plus::before {
  content: "\\F1763"; }

.mdi-archive-plus-outline::before {
  content: "\\F1764"; }

.mdi-archive-refresh::before {
  content: "\\F1765"; }

.mdi-archive-refresh-outline::before {
  content: "\\F1766"; }

.mdi-archive-remove::before {
  content: "\\F1767"; }

.mdi-archive-remove-outline::before {
  content: "\\F1768"; }

.mdi-archive-search::before {
  content: "\\F1769"; }

.mdi-archive-search-outline::before {
  content: "\\F176A"; }

.mdi-archive-settings::before {
  content: "\\F176B"; }

.mdi-archive-settings-outline::before {
  content: "\\F176C"; }

.mdi-archive-star::before {
  content: "\\F176D"; }

.mdi-archive-star-outline::before {
  content: "\\F176E"; }

.mdi-archive-sync::before {
  content: "\\F176F"; }

.mdi-archive-sync-outline::before {
  content: "\\F1770"; }

.mdi-arm-flex::before {
  content: "\\F0FD7"; }

.mdi-arm-flex-outline::before {
  content: "\\F0FD6"; }

.mdi-arrange-bring-forward::before {
  content: "\\F003D"; }

.mdi-arrange-bring-to-front::before {
  content: "\\F003E"; }

.mdi-arrange-send-backward::before {
  content: "\\F003F"; }

.mdi-arrange-send-to-back::before {
  content: "\\F0040"; }

.mdi-arrow-all::before {
  content: "\\F0041"; }

.mdi-arrow-bottom-left::before {
  content: "\\F0042"; }

.mdi-arrow-bottom-left-bold-box::before {
  content: "\\F1964"; }

.mdi-arrow-bottom-left-bold-box-outline::before {
  content: "\\F1965"; }

.mdi-arrow-bottom-left-bold-outline::before {
  content: "\\F09B7"; }

.mdi-arrow-bottom-left-thick::before {
  content: "\\F09B8"; }

.mdi-arrow-bottom-left-thin::before {
  content: "\\F19B6"; }

.mdi-arrow-bottom-left-thin-circle-outline::before {
  content: "\\F1596"; }

.mdi-arrow-bottom-right::before {
  content: "\\F0043"; }

.mdi-arrow-bottom-right-bold-box::before {
  content: "\\F1966"; }

.mdi-arrow-bottom-right-bold-box-outline::before {
  content: "\\F1967"; }

.mdi-arrow-bottom-right-bold-outline::before {
  content: "\\F09B9"; }

.mdi-arrow-bottom-right-thick::before {
  content: "\\F09BA"; }

.mdi-arrow-bottom-right-thin::before {
  content: "\\F19B7"; }

.mdi-arrow-bottom-right-thin-circle-outline::before {
  content: "\\F1595"; }

.mdi-arrow-collapse::before {
  content: "\\F0615"; }

.mdi-arrow-collapse-all::before {
  content: "\\F0044"; }

.mdi-arrow-collapse-down::before {
  content: "\\F0792"; }

.mdi-arrow-collapse-horizontal::before {
  content: "\\F084C"; }

.mdi-arrow-collapse-left::before {
  content: "\\F0793"; }

.mdi-arrow-collapse-right::before {
  content: "\\F0794"; }

.mdi-arrow-collapse-up::before {
  content: "\\F0795"; }

.mdi-arrow-collapse-vertical::before {
  content: "\\F084D"; }

.mdi-arrow-decision::before {
  content: "\\F09BB"; }

.mdi-arrow-decision-auto::before {
  content: "\\F09BC"; }

.mdi-arrow-decision-auto-outline::before {
  content: "\\F09BD"; }

.mdi-arrow-decision-outline::before {
  content: "\\F09BE"; }

.mdi-arrow-down::before {
  content: "\\F0045"; }

.mdi-arrow-down-bold::before {
  content: "\\F072E"; }

.mdi-arrow-down-bold-box::before {
  content: "\\F072F"; }

.mdi-arrow-down-bold-box-outline::before {
  content: "\\F0730"; }

.mdi-arrow-down-bold-circle::before {
  content: "\\F0047"; }

.mdi-arrow-down-bold-circle-outline::before {
  content: "\\F0048"; }

.mdi-arrow-down-bold-hexagon-outline::before {
  content: "\\F0049"; }

.mdi-arrow-down-bold-outline::before {
  content: "\\F09BF"; }

.mdi-arrow-down-box::before {
  content: "\\F06C0"; }

.mdi-arrow-down-circle::before {
  content: "\\F0CDB"; }

.mdi-arrow-down-circle-outline::before {
  content: "\\F0CDC"; }

.mdi-arrow-down-drop-circle::before {
  content: "\\F004A"; }

.mdi-arrow-down-drop-circle-outline::before {
  content: "\\F004B"; }

.mdi-arrow-down-left::before {
  content: "\\F17A1"; }

.mdi-arrow-down-left-bold::before {
  content: "\\F17A2"; }

.mdi-arrow-down-right::before {
  content: "\\F17A3"; }

.mdi-arrow-down-right-bold::before {
  content: "\\F17A4"; }

.mdi-arrow-down-thick::before {
  content: "\\F0046"; }

.mdi-arrow-down-thin::before {
  content: "\\F19B3"; }

.mdi-arrow-down-thin-circle-outline::before {
  content: "\\F1599"; }

.mdi-arrow-expand::before {
  content: "\\F0616"; }

.mdi-arrow-expand-all::before {
  content: "\\F004C"; }

.mdi-arrow-expand-down::before {
  content: "\\F0796"; }

.mdi-arrow-expand-horizontal::before {
  content: "\\F084E"; }

.mdi-arrow-expand-left::before {
  content: "\\F0797"; }

.mdi-arrow-expand-right::before {
  content: "\\F0798"; }

.mdi-arrow-expand-up::before {
  content: "\\F0799"; }

.mdi-arrow-expand-vertical::before {
  content: "\\F084F"; }

.mdi-arrow-horizontal-lock::before {
  content: "\\F115B"; }

.mdi-arrow-left::before {
  content: "\\F004D"; }

.mdi-arrow-left-bold::before {
  content: "\\F0731"; }

.mdi-arrow-left-bold-box::before {
  content: "\\F0732"; }

.mdi-arrow-left-bold-box-outline::before {
  content: "\\F0733"; }

.mdi-arrow-left-bold-circle::before {
  content: "\\F004F"; }

.mdi-arrow-left-bold-circle-outline::before {
  content: "\\F0050"; }

.mdi-arrow-left-bold-hexagon-outline::before {
  content: "\\F0051"; }

.mdi-arrow-left-bold-outline::before {
  content: "\\F09C0"; }

.mdi-arrow-left-bottom::before {
  content: "\\F17A5"; }

.mdi-arrow-left-bottom-bold::before {
  content: "\\F17A6"; }

.mdi-arrow-left-box::before {
  content: "\\F06C1"; }

.mdi-arrow-left-circle::before {
  content: "\\F0CDD"; }

.mdi-arrow-left-circle-outline::before {
  content: "\\F0CDE"; }

.mdi-arrow-left-drop-circle::before {
  content: "\\F0052"; }

.mdi-arrow-left-drop-circle-outline::before {
  content: "\\F0053"; }

.mdi-arrow-left-right::before {
  content: "\\F0E73"; }

.mdi-arrow-left-right-bold::before {
  content: "\\F0E74"; }

.mdi-arrow-left-right-bold-outline::before {
  content: "\\F09C1"; }

.mdi-arrow-left-thick::before {
  content: "\\F004E"; }

.mdi-arrow-left-thin::before {
  content: "\\F19B1"; }

.mdi-arrow-left-thin-circle-outline::before {
  content: "\\F159A"; }

.mdi-arrow-left-top::before {
  content: "\\F17A7"; }

.mdi-arrow-left-top-bold::before {
  content: "\\F17A8"; }

.mdi-arrow-projectile::before {
  content: "\\F1840"; }

.mdi-arrow-projectile-multiple::before {
  content: "\\F183F"; }

.mdi-arrow-right::before {
  content: "\\F0054"; }

.mdi-arrow-right-bold::before {
  content: "\\F0734"; }

.mdi-arrow-right-bold-box::before {
  content: "\\F0735"; }

.mdi-arrow-right-bold-box-outline::before {
  content: "\\F0736"; }

.mdi-arrow-right-bold-circle::before {
  content: "\\F0056"; }

.mdi-arrow-right-bold-circle-outline::before {
  content: "\\F0057"; }

.mdi-arrow-right-bold-hexagon-outline::before {
  content: "\\F0058"; }

.mdi-arrow-right-bold-outline::before {
  content: "\\F09C2"; }

.mdi-arrow-right-bottom::before {
  content: "\\F17A9"; }

.mdi-arrow-right-bottom-bold::before {
  content: "\\F17AA"; }

.mdi-arrow-right-box::before {
  content: "\\F06C2"; }

.mdi-arrow-right-circle::before {
  content: "\\F0CDF"; }

.mdi-arrow-right-circle-outline::before {
  content: "\\F0CE0"; }

.mdi-arrow-right-drop-circle::before {
  content: "\\F0059"; }

.mdi-arrow-right-drop-circle-outline::before {
  content: "\\F005A"; }

.mdi-arrow-right-thick::before {
  content: "\\F0055"; }

.mdi-arrow-right-thin::before {
  content: "\\F19B0"; }

.mdi-arrow-right-thin-circle-outline::before {
  content: "\\F1598"; }

.mdi-arrow-right-top::before {
  content: "\\F17AB"; }

.mdi-arrow-right-top-bold::before {
  content: "\\F17AC"; }

.mdi-arrow-split-horizontal::before {
  content: "\\F093B"; }

.mdi-arrow-split-vertical::before {
  content: "\\F093C"; }

.mdi-arrow-top-left::before {
  content: "\\F005B"; }

.mdi-arrow-top-left-bold-box::before {
  content: "\\F1968"; }

.mdi-arrow-top-left-bold-box-outline::before {
  content: "\\F1969"; }

.mdi-arrow-top-left-bold-outline::before {
  content: "\\F09C3"; }

.mdi-arrow-top-left-bottom-right::before {
  content: "\\F0E75"; }

.mdi-arrow-top-left-bottom-right-bold::before {
  content: "\\F0E76"; }

.mdi-arrow-top-left-thick::before {
  content: "\\F09C4"; }

.mdi-arrow-top-left-thin::before {
  content: "\\F19B5"; }

.mdi-arrow-top-left-thin-circle-outline::before {
  content: "\\F1593"; }

.mdi-arrow-top-right::before {
  content: "\\F005C"; }

.mdi-arrow-top-right-bold-box::before {
  content: "\\F196A"; }

.mdi-arrow-top-right-bold-box-outline::before {
  content: "\\F196B"; }

.mdi-arrow-top-right-bold-outline::before {
  content: "\\F09C5"; }

.mdi-arrow-top-right-bottom-left::before {
  content: "\\F0E77"; }

.mdi-arrow-top-right-bottom-left-bold::before {
  content: "\\F0E78"; }

.mdi-arrow-top-right-thick::before {
  content: "\\F09C6"; }

.mdi-arrow-top-right-thin::before {
  content: "\\F19B4"; }

.mdi-arrow-top-right-thin-circle-outline::before {
  content: "\\F1594"; }

.mdi-arrow-u-down-left::before {
  content: "\\F17AD"; }

.mdi-arrow-u-down-left-bold::before {
  content: "\\F17AE"; }

.mdi-arrow-u-down-right::before {
  content: "\\F17AF"; }

.mdi-arrow-u-down-right-bold::before {
  content: "\\F17B0"; }

.mdi-arrow-u-left-bottom::before {
  content: "\\F17B1"; }

.mdi-arrow-u-left-bottom-bold::before {
  content: "\\F17B2"; }

.mdi-arrow-u-left-top::before {
  content: "\\F17B3"; }

.mdi-arrow-u-left-top-bold::before {
  content: "\\F17B4"; }

.mdi-arrow-u-right-bottom::before {
  content: "\\F17B5"; }

.mdi-arrow-u-right-bottom-bold::before {
  content: "\\F17B6"; }

.mdi-arrow-u-right-top::before {
  content: "\\F17B7"; }

.mdi-arrow-u-right-top-bold::before {
  content: "\\F17B8"; }

.mdi-arrow-u-up-left::before {
  content: "\\F17B9"; }

.mdi-arrow-u-up-left-bold::before {
  content: "\\F17BA"; }

.mdi-arrow-u-up-right::before {
  content: "\\F17BB"; }

.mdi-arrow-u-up-right-bold::before {
  content: "\\F17BC"; }

.mdi-arrow-up::before {
  content: "\\F005D"; }

.mdi-arrow-up-bold::before {
  content: "\\F0737"; }

.mdi-arrow-up-bold-box::before {
  content: "\\F0738"; }

.mdi-arrow-up-bold-box-outline::before {
  content: "\\F0739"; }

.mdi-arrow-up-bold-circle::before {
  content: "\\F005F"; }

.mdi-arrow-up-bold-circle-outline::before {
  content: "\\F0060"; }

.mdi-arrow-up-bold-hexagon-outline::before {
  content: "\\F0061"; }

.mdi-arrow-up-bold-outline::before {
  content: "\\F09C7"; }

.mdi-arrow-up-box::before {
  content: "\\F06C3"; }

.mdi-arrow-up-circle::before {
  content: "\\F0CE1"; }

.mdi-arrow-up-circle-outline::before {
  content: "\\F0CE2"; }

.mdi-arrow-up-down::before {
  content: "\\F0E79"; }

.mdi-arrow-up-down-bold::before {
  content: "\\F0E7A"; }

.mdi-arrow-up-down-bold-outline::before {
  content: "\\F09C8"; }

.mdi-arrow-up-drop-circle::before {
  content: "\\F0062"; }

.mdi-arrow-up-drop-circle-outline::before {
  content: "\\F0063"; }

.mdi-arrow-up-left::before {
  content: "\\F17BD"; }

.mdi-arrow-up-left-bold::before {
  content: "\\F17BE"; }

.mdi-arrow-up-right::before {
  content: "\\F17BF"; }

.mdi-arrow-up-right-bold::before {
  content: "\\F17C0"; }

.mdi-arrow-up-thick::before {
  content: "\\F005E"; }

.mdi-arrow-up-thin::before {
  content: "\\F19B2"; }

.mdi-arrow-up-thin-circle-outline::before {
  content: "\\F1597"; }

.mdi-arrow-vertical-lock::before {
  content: "\\F115C"; }

.mdi-artstation::before {
  content: "\\F0B5B"; }

.mdi-aspect-ratio::before {
  content: "\\F0A24"; }

.mdi-assistant::before {
  content: "\\F0064"; }

.mdi-asterisk::before {
  content: "\\F06C4"; }

.mdi-at::before {
  content: "\\F0065"; }

.mdi-atlassian::before {
  content: "\\F0804"; }

.mdi-atm::before {
  content: "\\F0D47"; }

.mdi-atom::before {
  content: "\\F0768"; }

.mdi-atom-variant::before {
  content: "\\F0E7B"; }

.mdi-attachment::before {
  content: "\\F0066"; }

.mdi-audio-input-rca::before {
  content: "\\F186B"; }

.mdi-audio-input-stereo-minijack::before {
  content: "\\F186C"; }

.mdi-audio-input-xlr::before {
  content: "\\F186D"; }

.mdi-audio-video::before {
  content: "\\F093D"; }

.mdi-audio-video-off::before {
  content: "\\F11B6"; }

.mdi-augmented-reality::before {
  content: "\\F0850"; }

.mdi-auto-download::before {
  content: "\\F137E"; }

.mdi-auto-fix::before {
  content: "\\F0068"; }

.mdi-auto-upload::before {
  content: "\\F0069"; }

.mdi-autorenew::before {
  content: "\\F006A"; }

.mdi-av-timer::before {
  content: "\\F006B"; }

.mdi-aws::before {
  content: "\\F0E0F"; }

.mdi-axe::before {
  content: "\\F08C8"; }

.mdi-axe-battle::before {
  content: "\\F1842"; }

.mdi-axis::before {
  content: "\\F0D48"; }

.mdi-axis-arrow::before {
  content: "\\F0D49"; }

.mdi-axis-arrow-info::before {
  content: "\\F140E"; }

.mdi-axis-arrow-lock::before {
  content: "\\F0D4A"; }

.mdi-axis-lock::before {
  content: "\\F0D4B"; }

.mdi-axis-x-arrow::before {
  content: "\\F0D4C"; }

.mdi-axis-x-arrow-lock::before {
  content: "\\F0D4D"; }

.mdi-axis-x-rotate-clockwise::before {
  content: "\\F0D4E"; }

.mdi-axis-x-rotate-counterclockwise::before {
  content: "\\F0D4F"; }

.mdi-axis-x-y-arrow-lock::before {
  content: "\\F0D50"; }

.mdi-axis-y-arrow::before {
  content: "\\F0D51"; }

.mdi-axis-y-arrow-lock::before {
  content: "\\F0D52"; }

.mdi-axis-y-rotate-clockwise::before {
  content: "\\F0D53"; }

.mdi-axis-y-rotate-counterclockwise::before {
  content: "\\F0D54"; }

.mdi-axis-z-arrow::before {
  content: "\\F0D55"; }

.mdi-axis-z-arrow-lock::before {
  content: "\\F0D56"; }

.mdi-axis-z-rotate-clockwise::before {
  content: "\\F0D57"; }

.mdi-axis-z-rotate-counterclockwise::before {
  content: "\\F0D58"; }

.mdi-babel::before {
  content: "\\F0A25"; }

.mdi-baby::before {
  content: "\\F006C"; }

.mdi-baby-bottle::before {
  content: "\\F0F39"; }

.mdi-baby-bottle-outline::before {
  content: "\\F0F3A"; }

.mdi-baby-buggy::before {
  content: "\\F13E0"; }

.mdi-baby-carriage::before {
  content: "\\F068F"; }

.mdi-baby-carriage-off::before {
  content: "\\F0FA0"; }

.mdi-baby-face::before {
  content: "\\F0E7C"; }

.mdi-baby-face-outline::before {
  content: "\\F0E7D"; }

.mdi-backburger::before {
  content: "\\F006D"; }

.mdi-backspace::before {
  content: "\\F006E"; }

.mdi-backspace-outline::before {
  content: "\\F0B5C"; }

.mdi-backspace-reverse::before {
  content: "\\F0E7E"; }

.mdi-backspace-reverse-outline::before {
  content: "\\F0E7F"; }

.mdi-backup-restore::before {
  content: "\\F006F"; }

.mdi-bacteria::before {
  content: "\\F0ED5"; }

.mdi-bacteria-outline::before {
  content: "\\F0ED6"; }

.mdi-badge-account::before {
  content: "\\F0DA7"; }

.mdi-badge-account-alert::before {
  content: "\\F0DA8"; }

.mdi-badge-account-alert-outline::before {
  content: "\\F0DA9"; }

.mdi-badge-account-horizontal::before {
  content: "\\F0E0D"; }

.mdi-badge-account-horizontal-outline::before {
  content: "\\F0E0E"; }

.mdi-badge-account-outline::before {
  content: "\\F0DAA"; }

.mdi-badminton::before {
  content: "\\F0851"; }

.mdi-bag-carry-on::before {
  content: "\\F0F3B"; }

.mdi-bag-carry-on-check::before {
  content: "\\F0D65"; }

.mdi-bag-carry-on-off::before {
  content: "\\F0F3C"; }

.mdi-bag-checked::before {
  content: "\\F0F3D"; }

.mdi-bag-personal::before {
  content: "\\F0E10"; }

.mdi-bag-personal-off::before {
  content: "\\F0E11"; }

.mdi-bag-personal-off-outline::before {
  content: "\\F0E12"; }

.mdi-bag-personal-outline::before {
  content: "\\F0E13"; }

.mdi-bag-suitcase::before {
  content: "\\F158B"; }

.mdi-bag-suitcase-off::before {
  content: "\\F158D"; }

.mdi-bag-suitcase-off-outline::before {
  content: "\\F158E"; }

.mdi-bag-suitcase-outline::before {
  content: "\\F158C"; }

.mdi-baguette::before {
  content: "\\F0F3E"; }

.mdi-balcony::before {
  content: "\\F1817"; }

.mdi-balloon::before {
  content: "\\F0A26"; }

.mdi-ballot::before {
  content: "\\F09C9"; }

.mdi-ballot-outline::before {
  content: "\\F09CA"; }

.mdi-ballot-recount::before {
  content: "\\F0C39"; }

.mdi-ballot-recount-outline::before {
  content: "\\F0C3A"; }

.mdi-bandage::before {
  content: "\\F0DAF"; }

.mdi-bank::before {
  content: "\\F0070"; }

.mdi-bank-check::before {
  content: "\\F1655"; }

.mdi-bank-minus::before {
  content: "\\F0DB0"; }

.mdi-bank-off::before {
  content: "\\F1656"; }

.mdi-bank-off-outline::before {
  content: "\\F1657"; }

.mdi-bank-outline::before {
  content: "\\F0E80"; }

.mdi-bank-plus::before {
  content: "\\F0DB1"; }

.mdi-bank-remove::before {
  content: "\\F0DB2"; }

.mdi-bank-transfer::before {
  content: "\\F0A27"; }

.mdi-bank-transfer-in::before {
  content: "\\F0A28"; }

.mdi-bank-transfer-out::before {
  content: "\\F0A29"; }

.mdi-barcode::before {
  content: "\\F0071"; }

.mdi-barcode-off::before {
  content: "\\F1236"; }

.mdi-barcode-scan::before {
  content: "\\F0072"; }

.mdi-barley::before {
  content: "\\F0073"; }

.mdi-barley-off::before {
  content: "\\F0B5D"; }

.mdi-barn::before {
  content: "\\F0B5E"; }

.mdi-barrel::before {
  content: "\\F0074"; }

.mdi-baseball::before {
  content: "\\F0852"; }

.mdi-baseball-bat::before {
  content: "\\F0853"; }

.mdi-baseball-diamond::before {
  content: "\\F15EC"; }

.mdi-baseball-diamond-outline::before {
  content: "\\F15ED"; }

.mdi-bash::before {
  content: "\\F1183"; }

.mdi-basket::before {
  content: "\\F0076"; }

.mdi-basket-check::before {
  content: "\\F18E5"; }

.mdi-basket-check-outline::before {
  content: "\\F18E6"; }

.mdi-basket-fill::before {
  content: "\\F0077"; }

.mdi-basket-minus::before {
  content: "\\F1523"; }

.mdi-basket-minus-outline::before {
  content: "\\F1524"; }

.mdi-basket-off::before {
  content: "\\F1525"; }

.mdi-basket-off-outline::before {
  content: "\\F1526"; }

.mdi-basket-outline::before {
  content: "\\F1181"; }

.mdi-basket-plus::before {
  content: "\\F1527"; }

.mdi-basket-plus-outline::before {
  content: "\\F1528"; }

.mdi-basket-remove::before {
  content: "\\F1529"; }

.mdi-basket-remove-outline::before {
  content: "\\F152A"; }

.mdi-basket-unfill::before {
  content: "\\F0078"; }

.mdi-basketball::before {
  content: "\\F0806"; }

.mdi-basketball-hoop::before {
  content: "\\F0C3B"; }

.mdi-basketball-hoop-outline::before {
  content: "\\F0C3C"; }

.mdi-bat::before {
  content: "\\F0B5F"; }

.mdi-bathtub::before {
  content: "\\F1818"; }

.mdi-bathtub-outline::before {
  content: "\\F1819"; }

.mdi-battery::before {
  content: "\\F0079"; }

.mdi-battery-10::before {
  content: "\\F007A"; }

.mdi-battery-10-bluetooth::before {
  content: "\\F093E"; }

.mdi-battery-20::before {
  content: "\\F007B"; }

.mdi-battery-20-bluetooth::before {
  content: "\\F093F"; }

.mdi-battery-30::before {
  content: "\\F007C"; }

.mdi-battery-30-bluetooth::before {
  content: "\\F0940"; }

.mdi-battery-40::before {
  content: "\\F007D"; }

.mdi-battery-40-bluetooth::before {
  content: "\\F0941"; }

.mdi-battery-50::before {
  content: "\\F007E"; }

.mdi-battery-50-bluetooth::before {
  content: "\\F0942"; }

.mdi-battery-60::before {
  content: "\\F007F"; }

.mdi-battery-60-bluetooth::before {
  content: "\\F0943"; }

.mdi-battery-70::before {
  content: "\\F0080"; }

.mdi-battery-70-bluetooth::before {
  content: "\\F0944"; }

.mdi-battery-80::before {
  content: "\\F0081"; }

.mdi-battery-80-bluetooth::before {
  content: "\\F0945"; }

.mdi-battery-90::before {
  content: "\\F0082"; }

.mdi-battery-90-bluetooth::before {
  content: "\\F0946"; }

.mdi-battery-alert::before {
  content: "\\F0083"; }

.mdi-battery-alert-bluetooth::before {
  content: "\\F0947"; }

.mdi-battery-alert-variant::before {
  content: "\\F10CC"; }

.mdi-battery-alert-variant-outline::before {
  content: "\\F10CD"; }

.mdi-battery-arrow-down::before {
  content: "\\F17DE"; }

.mdi-battery-arrow-down-outline::before {
  content: "\\F17DF"; }

.mdi-battery-arrow-up::before {
  content: "\\F17E0"; }

.mdi-battery-arrow-up-outline::before {
  content: "\\F17E1"; }

.mdi-battery-bluetooth::before {
  content: "\\F0948"; }

.mdi-battery-bluetooth-variant::before {
  content: "\\F0949"; }

.mdi-battery-charging::before {
  content: "\\F0084"; }

.mdi-battery-charging-10::before {
  content: "\\F089C"; }

.mdi-battery-charging-100::before {
  content: "\\F0085"; }

.mdi-battery-charging-20::before {
  content: "\\F0086"; }

.mdi-battery-charging-30::before {
  content: "\\F0087"; }

.mdi-battery-charging-40::before {
  content: "\\F0088"; }

.mdi-battery-charging-50::before {
  content: "\\F089D"; }

.mdi-battery-charging-60::before {
  content: "\\F0089"; }

.mdi-battery-charging-70::before {
  content: "\\F089E"; }

.mdi-battery-charging-80::before {
  content: "\\F008A"; }

.mdi-battery-charging-90::before {
  content: "\\F008B"; }

.mdi-battery-charging-high::before {
  content: "\\F12A6"; }

.mdi-battery-charging-low::before {
  content: "\\F12A4"; }

.mdi-battery-charging-medium::before {
  content: "\\F12A5"; }

.mdi-battery-charging-outline::before {
  content: "\\F089F"; }

.mdi-battery-charging-wireless::before {
  content: "\\F0807"; }

.mdi-battery-charging-wireless-10::before {
  content: "\\F0808"; }

.mdi-battery-charging-wireless-20::before {
  content: "\\F0809"; }

.mdi-battery-charging-wireless-30::before {
  content: "\\F080A"; }

.mdi-battery-charging-wireless-40::before {
  content: "\\F080B"; }

.mdi-battery-charging-wireless-50::before {
  content: "\\F080C"; }

.mdi-battery-charging-wireless-60::before {
  content: "\\F080D"; }

.mdi-battery-charging-wireless-70::before {
  content: "\\F080E"; }

.mdi-battery-charging-wireless-80::before {
  content: "\\F080F"; }

.mdi-battery-charging-wireless-90::before {
  content: "\\F0810"; }

.mdi-battery-charging-wireless-alert::before {
  content: "\\F0811"; }

.mdi-battery-charging-wireless-outline::before {
  content: "\\F0812"; }

.mdi-battery-check::before {
  content: "\\F17E2"; }

.mdi-battery-check-outline::before {
  content: "\\F17E3"; }

.mdi-battery-heart::before {
  content: "\\F120F"; }

.mdi-battery-heart-outline::before {
  content: "\\F1210"; }

.mdi-battery-heart-variant::before {
  content: "\\F1211"; }

.mdi-battery-high::before {
  content: "\\F12A3"; }

.mdi-battery-lock::before {
  content: "\\F179C"; }

.mdi-battery-lock-open::before {
  content: "\\F179D"; }

.mdi-battery-low::before {
  content: "\\F12A1"; }

.mdi-battery-medium::before {
  content: "\\F12A2"; }

.mdi-battery-minus::before {
  content: "\\F17E4"; }

.mdi-battery-minus-outline::before {
  content: "\\F17E5"; }

.mdi-battery-minus-variant::before {
  content: "\\F008C"; }

.mdi-battery-negative::before {
  content: "\\F008D"; }

.mdi-battery-off::before {
  content: "\\F125D"; }

.mdi-battery-off-outline::before {
  content: "\\F125E"; }

.mdi-battery-outline::before {
  content: "\\F008E"; }

.mdi-battery-plus::before {
  content: "\\F17E6"; }

.mdi-battery-plus-outline::before {
  content: "\\F17E7"; }

.mdi-battery-plus-variant::before {
  content: "\\F008F"; }

.mdi-battery-positive::before {
  content: "\\F0090"; }

.mdi-battery-remove::before {
  content: "\\F17E8"; }

.mdi-battery-remove-outline::before {
  content: "\\F17E9"; }

.mdi-battery-sync::before {
  content: "\\F1834"; }

.mdi-battery-sync-outline::before {
  content: "\\F1835"; }

.mdi-battery-unknown::before {
  content: "\\F0091"; }

.mdi-battery-unknown-bluetooth::before {
  content: "\\F094A"; }

.mdi-beach::before {
  content: "\\F0092"; }

.mdi-beaker::before {
  content: "\\F0CEA"; }

.mdi-beaker-alert::before {
  content: "\\F1229"; }

.mdi-beaker-alert-outline::before {
  content: "\\F122A"; }

.mdi-beaker-check::before {
  content: "\\F122B"; }

.mdi-beaker-check-outline::before {
  content: "\\F122C"; }

.mdi-beaker-minus::before {
  content: "\\F122D"; }

.mdi-beaker-minus-outline::before {
  content: "\\F122E"; }

.mdi-beaker-outline::before {
  content: "\\F0690"; }

.mdi-beaker-plus::before {
  content: "\\F122F"; }

.mdi-beaker-plus-outline::before {
  content: "\\F1230"; }

.mdi-beaker-question::before {
  content: "\\F1231"; }

.mdi-beaker-question-outline::before {
  content: "\\F1232"; }

.mdi-beaker-remove::before {
  content: "\\F1233"; }

.mdi-beaker-remove-outline::before {
  content: "\\F1234"; }

.mdi-bed::before {
  content: "\\F02E3"; }

.mdi-bed-double::before {
  content: "\\F0FD4"; }

.mdi-bed-double-outline::before {
  content: "\\F0FD3"; }

.mdi-bed-empty::before {
  content: "\\F08A0"; }

.mdi-bed-king::before {
  content: "\\F0FD2"; }

.mdi-bed-king-outline::before {
  content: "\\F0FD1"; }

.mdi-bed-outline::before {
  content: "\\F0099"; }

.mdi-bed-queen::before {
  content: "\\F0FD0"; }

.mdi-bed-queen-outline::before {
  content: "\\F0FDB"; }

.mdi-bed-single::before {
  content: "\\F106D"; }

.mdi-bed-single-outline::before {
  content: "\\F106E"; }

.mdi-bee::before {
  content: "\\F0FA1"; }

.mdi-bee-flower::before {
  content: "\\F0FA2"; }

.mdi-beehive-off-outline::before {
  content: "\\F13ED"; }

.mdi-beehive-outline::before {
  content: "\\F10CE"; }

.mdi-beekeeper::before {
  content: "\\F14E2"; }

.mdi-beer::before {
  content: "\\F0098"; }

.mdi-beer-outline::before {
  content: "\\F130C"; }

.mdi-bell::before {
  content: "\\F009A"; }

.mdi-bell-alert::before {
  content: "\\F0D59"; }

.mdi-bell-alert-outline::before {
  content: "\\F0E81"; }

.mdi-bell-badge::before {
  content: "\\F116B"; }

.mdi-bell-badge-outline::before {
  content: "\\F0178"; }

.mdi-bell-cancel::before {
  content: "\\F13E7"; }

.mdi-bell-cancel-outline::before {
  content: "\\F13E8"; }

.mdi-bell-check::before {
  content: "\\F11E5"; }

.mdi-bell-check-outline::before {
  content: "\\F11E6"; }

.mdi-bell-circle::before {
  content: "\\F0D5A"; }

.mdi-bell-circle-outline::before {
  content: "\\F0D5B"; }

.mdi-bell-minus::before {
  content: "\\F13E9"; }

.mdi-bell-minus-outline::before {
  content: "\\F13EA"; }

.mdi-bell-off::before {
  content: "\\F009B"; }

.mdi-bell-off-outline::before {
  content: "\\F0A91"; }

.mdi-bell-outline::before {
  content: "\\F009C"; }

.mdi-bell-plus::before {
  content: "\\F009D"; }

.mdi-bell-plus-outline::before {
  content: "\\F0A92"; }

.mdi-bell-remove::before {
  content: "\\F13EB"; }

.mdi-bell-remove-outline::before {
  content: "\\F13EC"; }

.mdi-bell-ring::before {
  content: "\\F009E"; }

.mdi-bell-ring-outline::before {
  content: "\\F009F"; }

.mdi-bell-sleep::before {
  content: "\\F00A0"; }

.mdi-bell-sleep-outline::before {
  content: "\\F0A93"; }

.mdi-beta::before {
  content: "\\F00A1"; }

.mdi-betamax::before {
  content: "\\F09CB"; }

.mdi-biathlon::before {
  content: "\\F0E14"; }

.mdi-bicycle::before {
  content: "\\F109C"; }

.mdi-bicycle-basket::before {
  content: "\\F1235"; }

.mdi-bicycle-cargo::before {
  content: "\\F189C"; }

.mdi-bicycle-electric::before {
  content: "\\F15B4"; }

.mdi-bicycle-penny-farthing::before {
  content: "\\F15E9"; }

.mdi-bike::before {
  content: "\\F00A3"; }

.mdi-bike-fast::before {
  content: "\\F111F"; }

.mdi-billboard::before {
  content: "\\F1010"; }

.mdi-billiards::before {
  content: "\\F0B61"; }

.mdi-billiards-rack::before {
  content: "\\F0B62"; }

.mdi-binoculars::before {
  content: "\\F00A5"; }

.mdi-bio::before {
  content: "\\F00A6"; }

.mdi-biohazard::before {
  content: "\\F00A7"; }

.mdi-bird::before {
  content: "\\F15C6"; }

.mdi-bitbucket::before {
  content: "\\F00A8"; }

.mdi-bitcoin::before {
  content: "\\F0813"; }

.mdi-black-mesa::before {
  content: "\\F00A9"; }

.mdi-blender::before {
  content: "\\F0CEB"; }

.mdi-blender-outline::before {
  content: "\\F181A"; }

.mdi-blender-software::before {
  content: "\\F00AB"; }

.mdi-blinds::before {
  content: "\\F00AC"; }

.mdi-blinds-open::before {
  content: "\\F1011"; }

.mdi-block-helper::before {
  content: "\\F00AD"; }

.mdi-blood-bag::before {
  content: "\\F0CEC"; }

.mdi-bluetooth::before {
  content: "\\F00AF"; }

.mdi-bluetooth-audio::before {
  content: "\\F00B0"; }

.mdi-bluetooth-connect::before {
  content: "\\F00B1"; }

.mdi-bluetooth-off::before {
  content: "\\F00B2"; }

.mdi-bluetooth-settings::before {
  content: "\\F00B3"; }

.mdi-bluetooth-transfer::before {
  content: "\\F00B4"; }

.mdi-blur::before {
  content: "\\F00B5"; }

.mdi-blur-linear::before {
  content: "\\F00B6"; }

.mdi-blur-off::before {
  content: "\\F00B7"; }

.mdi-blur-radial::before {
  content: "\\F00B8"; }

.mdi-bolt::before {
  content: "\\F0DB3"; }

.mdi-bomb::before {
  content: "\\F0691"; }

.mdi-bomb-off::before {
  content: "\\F06C5"; }

.mdi-bone::before {
  content: "\\F00B9"; }

.mdi-book::before {
  content: "\\F00BA"; }

.mdi-book-account::before {
  content: "\\F13AD"; }

.mdi-book-account-outline::before {
  content: "\\F13AE"; }

.mdi-book-alert::before {
  content: "\\F167C"; }

.mdi-book-alert-outline::before {
  content: "\\F167D"; }

.mdi-book-alphabet::before {
  content: "\\F061D"; }

.mdi-book-arrow-down::before {
  content: "\\F167E"; }

.mdi-book-arrow-down-outline::before {
  content: "\\F167F"; }

.mdi-book-arrow-left::before {
  content: "\\F1680"; }

.mdi-book-arrow-left-outline::before {
  content: "\\F1681"; }

.mdi-book-arrow-right::before {
  content: "\\F1682"; }

.mdi-book-arrow-right-outline::before {
  content: "\\F1683"; }

.mdi-book-arrow-up::before {
  content: "\\F1684"; }

.mdi-book-arrow-up-outline::before {
  content: "\\F1685"; }

.mdi-book-cancel::before {
  content: "\\F1686"; }

.mdi-book-cancel-outline::before {
  content: "\\F1687"; }

.mdi-book-check::before {
  content: "\\F14F3"; }

.mdi-book-check-outline::before {
  content: "\\F14F4"; }

.mdi-book-clock::before {
  content: "\\F1688"; }

.mdi-book-clock-outline::before {
  content: "\\F1689"; }

.mdi-book-cog::before {
  content: "\\F168A"; }

.mdi-book-cog-outline::before {
  content: "\\F168B"; }

.mdi-book-cross::before {
  content: "\\F00A2"; }

.mdi-book-edit::before {
  content: "\\F168C"; }

.mdi-book-edit-outline::before {
  content: "\\F168D"; }

.mdi-book-education::before {
  content: "\\F16C9"; }

.mdi-book-education-outline::before {
  content: "\\F16CA"; }

.mdi-book-information-variant::before {
  content: "\\F106F"; }

.mdi-book-lock::before {
  content: "\\F079A"; }

.mdi-book-lock-open::before {
  content: "\\F079B"; }

.mdi-book-lock-open-outline::before {
  content: "\\F168E"; }

.mdi-book-lock-outline::before {
  content: "\\F168F"; }

.mdi-book-marker::before {
  content: "\\F1690"; }

.mdi-book-marker-outline::before {
  content: "\\F1691"; }

.mdi-book-minus::before {
  content: "\\F05D9"; }

.mdi-book-minus-multiple::before {
  content: "\\F0A94"; }

.mdi-book-minus-multiple-outline::before {
  content: "\\F090B"; }

.mdi-book-minus-outline::before {
  content: "\\F1692"; }

.mdi-book-multiple::before {
  content: "\\F00BB"; }

.mdi-book-multiple-outline::before {
  content: "\\F0436"; }

.mdi-book-music::before {
  content: "\\F0067"; }

.mdi-book-music-outline::before {
  content: "\\F1693"; }

.mdi-book-off::before {
  content: "\\F1694"; }

.mdi-book-off-outline::before {
  content: "\\F1695"; }

.mdi-book-open::before {
  content: "\\F00BD"; }

.mdi-book-open-blank-variant::before {
  content: "\\F00BE"; }

.mdi-book-open-outline::before {
  content: "\\F0B63"; }

.mdi-book-open-page-variant::before {
  content: "\\F05DA"; }

.mdi-book-open-page-variant-outline::before {
  content: "\\F15D6"; }

.mdi-book-open-variant::before {
  content: "\\F14F7"; }

.mdi-book-outline::before {
  content: "\\F0B64"; }

.mdi-book-play::before {
  content: "\\F0E82"; }

.mdi-book-play-outline::before {
  content: "\\F0E83"; }

.mdi-book-plus::before {
  content: "\\F05DB"; }

.mdi-book-plus-multiple::before {
  content: "\\F0A95"; }

.mdi-book-plus-multiple-outline::before {
  content: "\\F0ADE"; }

.mdi-book-plus-outline::before {
  content: "\\F1696"; }

.mdi-book-refresh::before {
  content: "\\F1697"; }

.mdi-book-refresh-outline::before {
  content: "\\F1698"; }

.mdi-book-remove::before {
  content: "\\F0A97"; }

.mdi-book-remove-multiple::before {
  content: "\\F0A96"; }

.mdi-book-remove-multiple-outline::before {
  content: "\\F04CA"; }

.mdi-book-remove-outline::before {
  content: "\\F1699"; }

.mdi-book-search::before {
  content: "\\F0E84"; }

.mdi-book-search-outline::before {
  content: "\\F0E85"; }

.mdi-book-settings::before {
  content: "\\F169A"; }

.mdi-book-settings-outline::before {
  content: "\\F169B"; }

.mdi-book-sync::before {
  content: "\\F169C"; }

.mdi-book-sync-outline::before {
  content: "\\F16C8"; }

.mdi-book-variant::before {
  content: "\\F00BF"; }

.mdi-book-variant-multiple::before {
  content: "\\F00BC"; }

.mdi-bookmark::before {
  content: "\\F00C0"; }

.mdi-bookmark-box-multiple::before {
  content: "\\F196C"; }

.mdi-bookmark-box-multiple-outline::before {
  content: "\\F196D"; }

.mdi-bookmark-check::before {
  content: "\\F00C1"; }

.mdi-bookmark-check-outline::before {
  content: "\\F137B"; }

.mdi-bookmark-minus::before {
  content: "\\F09CC"; }

.mdi-bookmark-minus-outline::before {
  content: "\\F09CD"; }

.mdi-bookmark-multiple::before {
  content: "\\F0E15"; }

.mdi-bookmark-multiple-outline::before {
  content: "\\F0E16"; }

.mdi-bookmark-music::before {
  content: "\\F00C2"; }

.mdi-bookmark-music-outline::before {
  content: "\\F1379"; }

.mdi-bookmark-off::before {
  content: "\\F09CE"; }

.mdi-bookmark-off-outline::before {
  content: "\\F09CF"; }

.mdi-bookmark-outline::before {
  content: "\\F00C3"; }

.mdi-bookmark-plus::before {
  content: "\\F00C5"; }

.mdi-bookmark-plus-outline::before {
  content: "\\F00C4"; }

.mdi-bookmark-remove::before {
  content: "\\F00C6"; }

.mdi-bookmark-remove-outline::before {
  content: "\\F137A"; }

.mdi-bookshelf::before {
  content: "\\F125F"; }

.mdi-boom-gate::before {
  content: "\\F0E86"; }

.mdi-boom-gate-alert::before {
  content: "\\F0E87"; }

.mdi-boom-gate-alert-outline::before {
  content: "\\F0E88"; }

.mdi-boom-gate-arrow-down::before {
  content: "\\F0E89"; }

.mdi-boom-gate-arrow-down-outline::before {
  content: "\\F0E8A"; }

.mdi-boom-gate-arrow-up::before {
  content: "\\F0E8C"; }

.mdi-boom-gate-arrow-up-outline::before {
  content: "\\F0E8D"; }

.mdi-boom-gate-outline::before {
  content: "\\F0E8B"; }

.mdi-boom-gate-up::before {
  content: "\\F17F9"; }

.mdi-boom-gate-up-outline::before {
  content: "\\F17FA"; }

.mdi-boombox::before {
  content: "\\F05DC"; }

.mdi-boomerang::before {
  content: "\\F10CF"; }

.mdi-bootstrap::before {
  content: "\\F06C6"; }

.mdi-border-all::before {
  content: "\\F00C7"; }

.mdi-border-all-variant::before {
  content: "\\F08A1"; }

.mdi-border-bottom::before {
  content: "\\F00C8"; }

.mdi-border-bottom-variant::before {
  content: "\\F08A2"; }

.mdi-border-color::before {
  content: "\\F00C9"; }

.mdi-border-horizontal::before {
  content: "\\F00CA"; }

.mdi-border-inside::before {
  content: "\\F00CB"; }

.mdi-border-left::before {
  content: "\\F00CC"; }

.mdi-border-left-variant::before {
  content: "\\F08A3"; }

.mdi-border-none::before {
  content: "\\F00CD"; }

.mdi-border-none-variant::before {
  content: "\\F08A4"; }

.mdi-border-outside::before {
  content: "\\F00CE"; }

.mdi-border-right::before {
  content: "\\F00CF"; }

.mdi-border-right-variant::before {
  content: "\\F08A5"; }

.mdi-border-style::before {
  content: "\\F00D0"; }

.mdi-border-top::before {
  content: "\\F00D1"; }

.mdi-border-top-variant::before {
  content: "\\F08A6"; }

.mdi-border-vertical::before {
  content: "\\F00D2"; }

.mdi-bottle-soda::before {
  content: "\\F1070"; }

.mdi-bottle-soda-classic::before {
  content: "\\F1071"; }

.mdi-bottle-soda-classic-outline::before {
  content: "\\F1363"; }

.mdi-bottle-soda-outline::before {
  content: "\\F1072"; }

.mdi-bottle-tonic::before {
  content: "\\F112E"; }

.mdi-bottle-tonic-outline::before {
  content: "\\F112F"; }

.mdi-bottle-tonic-plus::before {
  content: "\\F1130"; }

.mdi-bottle-tonic-plus-outline::before {
  content: "\\F1131"; }

.mdi-bottle-tonic-skull::before {
  content: "\\F1132"; }

.mdi-bottle-tonic-skull-outline::before {
  content: "\\F1133"; }

.mdi-bottle-wine::before {
  content: "\\F0854"; }

.mdi-bottle-wine-outline::before {
  content: "\\F1310"; }

.mdi-bow-arrow::before {
  content: "\\F1841"; }

.mdi-bow-tie::before {
  content: "\\F0678"; }

.mdi-bowl::before {
  content: "\\F028E"; }

.mdi-bowl-mix::before {
  content: "\\F0617"; }

.mdi-bowl-mix-outline::before {
  content: "\\F02E4"; }

.mdi-bowl-outline::before {
  content: "\\F02A9"; }

.mdi-bowling::before {
  content: "\\F00D3"; }

.mdi-box::before {
  content: "\\F00D4"; }

.mdi-box-cutter::before {
  content: "\\F00D5"; }

.mdi-box-cutter-off::before {
  content: "\\F0B4A"; }

.mdi-box-shadow::before {
  content: "\\F0637"; }

.mdi-boxing-glove::before {
  content: "\\F0B65"; }

.mdi-braille::before {
  content: "\\F09D0"; }

.mdi-brain::before {
  content: "\\F09D1"; }

.mdi-bread-slice::before {
  content: "\\F0CEE"; }

.mdi-bread-slice-outline::before {
  content: "\\F0CEF"; }

.mdi-bridge::before {
  content: "\\F0618"; }

.mdi-briefcase::before {
  content: "\\F00D6"; }

.mdi-briefcase-account::before {
  content: "\\F0CF0"; }

.mdi-briefcase-account-outline::before {
  content: "\\F0CF1"; }

.mdi-briefcase-check::before {
  content: "\\F00D7"; }

.mdi-briefcase-check-outline::before {
  content: "\\F131E"; }

.mdi-briefcase-clock::before {
  content: "\\F10D0"; }

.mdi-briefcase-clock-outline::before {
  content: "\\F10D1"; }

.mdi-briefcase-download::before {
  content: "\\F00D8"; }

.mdi-briefcase-download-outline::before {
  content: "\\F0C3D"; }

.mdi-briefcase-edit::before {
  content: "\\F0A98"; }

.mdi-briefcase-edit-outline::before {
  content: "\\F0C3E"; }

.mdi-briefcase-eye::before {
  content: "\\F17D9"; }

.mdi-briefcase-eye-outline::before {
  content: "\\F17DA"; }

.mdi-briefcase-minus::before {
  content: "\\F0A2A"; }

.mdi-briefcase-minus-outline::before {
  content: "\\F0C3F"; }

.mdi-briefcase-off::before {
  content: "\\F1658"; }

.mdi-briefcase-off-outline::before {
  content: "\\F1659"; }

.mdi-briefcase-outline::before {
  content: "\\F0814"; }

.mdi-briefcase-plus::before {
  content: "\\F0A2B"; }

.mdi-briefcase-plus-outline::before {
  content: "\\F0C40"; }

.mdi-briefcase-remove::before {
  content: "\\F0A2C"; }

.mdi-briefcase-remove-outline::before {
  content: "\\F0C41"; }

.mdi-briefcase-search::before {
  content: "\\F0A2D"; }

.mdi-briefcase-search-outline::before {
  content: "\\F0C42"; }

.mdi-briefcase-upload::before {
  content: "\\F00D9"; }

.mdi-briefcase-upload-outline::before {
  content: "\\F0C43"; }

.mdi-briefcase-variant::before {
  content: "\\F1494"; }

.mdi-briefcase-variant-off::before {
  content: "\\F165A"; }

.mdi-briefcase-variant-off-outline::before {
  content: "\\F165B"; }

.mdi-briefcase-variant-outline::before {
  content: "\\F1495"; }

.mdi-brightness-1::before {
  content: "\\F00DA"; }

.mdi-brightness-2::before {
  content: "\\F00DB"; }

.mdi-brightness-3::before {
  content: "\\F00DC"; }

.mdi-brightness-4::before {
  content: "\\F00DD"; }

.mdi-brightness-5::before {
  content: "\\F00DE"; }

.mdi-brightness-6::before {
  content: "\\F00DF"; }

.mdi-brightness-7::before {
  content: "\\F00E0"; }

.mdi-brightness-auto::before {
  content: "\\F00E1"; }

.mdi-brightness-percent::before {
  content: "\\F0CF2"; }

.mdi-broadcast::before {
  content: "\\F1720"; }

.mdi-broadcast-off::before {
  content: "\\F1721"; }

.mdi-broom::before {
  content: "\\F00E2"; }

.mdi-brush::before {
  content: "\\F00E3"; }

.mdi-brush-off::before {
  content: "\\F1771"; }

.mdi-brush-variant::before {
  content: "\\F1813"; }

.mdi-bucket::before {
  content: "\\F1415"; }

.mdi-bucket-outline::before {
  content: "\\F1416"; }

.mdi-buffet::before {
  content: "\\F0578"; }

.mdi-bug::before {
  content: "\\F00E4"; }

.mdi-bug-check::before {
  content: "\\F0A2E"; }

.mdi-bug-check-outline::before {
  content: "\\F0A2F"; }

.mdi-bug-outline::before {
  content: "\\F0A30"; }

.mdi-bugle::before {
  content: "\\F0DB4"; }

.mdi-bulldozer::before {
  content: "\\F0B22"; }

.mdi-bullet::before {
  content: "\\F0CF3"; }

.mdi-bulletin-board::before {
  content: "\\F00E5"; }

.mdi-bullhorn::before {
  content: "\\F00E6"; }

.mdi-bullhorn-outline::before {
  content: "\\F0B23"; }

.mdi-bullhorn-variant::before {
  content: "\\F196E"; }

.mdi-bullhorn-variant-outline::before {
  content: "\\F196F"; }

.mdi-bullseye::before {
  content: "\\F05DD"; }

.mdi-bullseye-arrow::before {
  content: "\\F08C9"; }

.mdi-bulma::before {
  content: "\\F12E7"; }

.mdi-bunk-bed::before {
  content: "\\F1302"; }

.mdi-bunk-bed-outline::before {
  content: "\\F0097"; }

.mdi-bus::before {
  content: "\\F00E7"; }

.mdi-bus-alert::before {
  content: "\\F0A99"; }

.mdi-bus-articulated-end::before {
  content: "\\F079C"; }

.mdi-bus-articulated-front::before {
  content: "\\F079D"; }

.mdi-bus-clock::before {
  content: "\\F08CA"; }

.mdi-bus-double-decker::before {
  content: "\\F079E"; }

.mdi-bus-electric::before {
  content: "\\F191D"; }

.mdi-bus-marker::before {
  content: "\\F1212"; }

.mdi-bus-multiple::before {
  content: "\\F0F3F"; }

.mdi-bus-school::before {
  content: "\\F079F"; }

.mdi-bus-side::before {
  content: "\\F07A0"; }

.mdi-bus-stop::before {
  content: "\\F1012"; }

.mdi-bus-stop-covered::before {
  content: "\\F1013"; }

.mdi-bus-stop-uncovered::before {
  content: "\\F1014"; }

.mdi-butterfly::before {
  content: "\\F1589"; }

.mdi-butterfly-outline::before {
  content: "\\F158A"; }

.mdi-cabin-a-frame::before {
  content: "\\F188C"; }

.mdi-cable-data::before {
  content: "\\F1394"; }

.mdi-cached::before {
  content: "\\F00E8"; }

.mdi-cactus::before {
  content: "\\F0DB5"; }

.mdi-cake::before {
  content: "\\F00E9"; }

.mdi-cake-layered::before {
  content: "\\F00EA"; }

.mdi-cake-variant::before {
  content: "\\F00EB"; }

.mdi-cake-variant-outline::before {
  content: "\\F17F0"; }

.mdi-calculator::before {
  content: "\\F00EC"; }

.mdi-calculator-variant::before {
  content: "\\F0A9A"; }

.mdi-calculator-variant-outline::before {
  content: "\\F15A6"; }

.mdi-calendar::before {
  content: "\\F00ED"; }

.mdi-calendar-account::before {
  content: "\\F0ED7"; }

.mdi-calendar-account-outline::before {
  content: "\\F0ED8"; }

.mdi-calendar-alert::before {
  content: "\\F0A31"; }

.mdi-calendar-arrow-left::before {
  content: "\\F1134"; }

.mdi-calendar-arrow-right::before {
  content: "\\F1135"; }

.mdi-calendar-blank::before {
  content: "\\F00EE"; }

.mdi-calendar-blank-multiple::before {
  content: "\\F1073"; }

.mdi-calendar-blank-outline::before {
  content: "\\F0B66"; }

.mdi-calendar-check::before {
  content: "\\F00EF"; }

.mdi-calendar-check-outline::before {
  content: "\\F0C44"; }

.mdi-calendar-clock::before {
  content: "\\F00F0"; }

.mdi-calendar-clock-outline::before {
  content: "\\F16E1"; }

.mdi-calendar-collapse-horizontal::before {
  content: "\\F189D"; }

.mdi-calendar-cursor::before {
  content: "\\F157B"; }

.mdi-calendar-edit::before {
  content: "\\F08A7"; }

.mdi-calendar-end::before {
  content: "\\F166C"; }

.mdi-calendar-expand-horizontal::before {
  content: "\\F189E"; }

.mdi-calendar-export::before {
  content: "\\F0B24"; }

.mdi-calendar-heart::before {
  content: "\\F09D2"; }

.mdi-calendar-import::before {
  content: "\\F0B25"; }

.mdi-calendar-lock::before {
  content: "\\F1641"; }

.mdi-calendar-lock-outline::before {
  content: "\\F1642"; }

.mdi-calendar-minus::before {
  content: "\\F0D5C"; }

.mdi-calendar-month::before {
  content: "\\F0E17"; }

.mdi-calendar-month-outline::before {
  content: "\\F0E18"; }

.mdi-calendar-multiple::before {
  content: "\\F00F1"; }

.mdi-calendar-multiple-check::before {
  content: "\\F00F2"; }

.mdi-calendar-multiselect::before {
  content: "\\F0A32"; }

.mdi-calendar-outline::before {
  content: "\\F0B67"; }

.mdi-calendar-plus::before {
  content: "\\F00F3"; }

.mdi-calendar-question::before {
  content: "\\F0692"; }

.mdi-calendar-range::before {
  content: "\\F0679"; }

.mdi-calendar-range-outline::before {
  content: "\\F0B68"; }

.mdi-calendar-refresh::before {
  content: "\\F01E1"; }

.mdi-calendar-refresh-outline::before {
  content: "\\F0203"; }

.mdi-calendar-remove::before {
  content: "\\F00F4"; }

.mdi-calendar-remove-outline::before {
  content: "\\F0C45"; }

.mdi-calendar-search::before {
  content: "\\F094C"; }

.mdi-calendar-star::before {
  content: "\\F09D3"; }

.mdi-calendar-start::before {
  content: "\\F166D"; }

.mdi-calendar-sync::before {
  content: "\\F0E8E"; }

.mdi-calendar-sync-outline::before {
  content: "\\F0E8F"; }

.mdi-calendar-text::before {
  content: "\\F00F5"; }

.mdi-calendar-text-outline::before {
  content: "\\F0C46"; }

.mdi-calendar-today::before {
  content: "\\F00F6"; }

.mdi-calendar-week::before {
  content: "\\F0A33"; }

.mdi-calendar-week-begin::before {
  content: "\\F0A34"; }

.mdi-calendar-weekend::before {
  content: "\\F0ED9"; }

.mdi-calendar-weekend-outline::before {
  content: "\\F0EDA"; }

.mdi-call-made::before {
  content: "\\F00F7"; }

.mdi-call-merge::before {
  content: "\\F00F8"; }

.mdi-call-missed::before {
  content: "\\F00F9"; }

.mdi-call-received::before {
  content: "\\F00FA"; }

.mdi-call-split::before {
  content: "\\F00FB"; }

.mdi-camcorder::before {
  content: "\\F00FC"; }

.mdi-camcorder-off::before {
  content: "\\F00FF"; }

.mdi-camera::before {
  content: "\\F0100"; }

.mdi-camera-account::before {
  content: "\\F08CB"; }

.mdi-camera-burst::before {
  content: "\\F0693"; }

.mdi-camera-control::before {
  content: "\\F0B69"; }

.mdi-camera-document::before {
  content: "\\F1871"; }

.mdi-camera-document-off::before {
  content: "\\F1872"; }

.mdi-camera-enhance::before {
  content: "\\F0101"; }

.mdi-camera-enhance-outline::before {
  content: "\\F0B6A"; }

.mdi-camera-flip::before {
  content: "\\F15D9"; }

.mdi-camera-flip-outline::before {
  content: "\\F15DA"; }

.mdi-camera-front::before {
  content: "\\F0102"; }

.mdi-camera-front-variant::before {
  content: "\\F0103"; }

.mdi-camera-gopro::before {
  content: "\\F07A1"; }

.mdi-camera-image::before {
  content: "\\F08CC"; }

.mdi-camera-iris::before {
  content: "\\F0104"; }

.mdi-camera-marker::before {
  content: "\\F19A7"; }

.mdi-camera-marker-outline::before {
  content: "\\F19A8"; }

.mdi-camera-metering-center::before {
  content: "\\F07A2"; }

.mdi-camera-metering-matrix::before {
  content: "\\F07A3"; }

.mdi-camera-metering-partial::before {
  content: "\\F07A4"; }

.mdi-camera-metering-spot::before {
  content: "\\F07A5"; }

.mdi-camera-off::before {
  content: "\\F05DF"; }

.mdi-camera-off-outline::before {
  content: "\\F19BF"; }

.mdi-camera-outline::before {
  content: "\\F0D5D"; }

.mdi-camera-party-mode::before {
  content: "\\F0105"; }

.mdi-camera-plus::before {
  content: "\\F0EDB"; }

.mdi-camera-plus-outline::before {
  content: "\\F0EDC"; }

.mdi-camera-rear::before {
  content: "\\F0106"; }

.mdi-camera-rear-variant::before {
  content: "\\F0107"; }

.mdi-camera-retake::before {
  content: "\\F0E19"; }

.mdi-camera-retake-outline::before {
  content: "\\F0E1A"; }

.mdi-camera-switch::before {
  content: "\\F0108"; }

.mdi-camera-switch-outline::before {
  content: "\\F084A"; }

.mdi-camera-timer::before {
  content: "\\F0109"; }

.mdi-camera-wireless::before {
  content: "\\F0DB6"; }

.mdi-camera-wireless-outline::before {
  content: "\\F0DB7"; }

.mdi-campfire::before {
  content: "\\F0EDD"; }

.mdi-cancel::before {
  content: "\\F073A"; }

.mdi-candelabra::before {
  content: "\\F17D2"; }

.mdi-candelabra-fire::before {
  content: "\\F17D3"; }

.mdi-candle::before {
  content: "\\F05E2"; }

.mdi-candy::before {
  content: "\\F1970"; }

.mdi-candy-off::before {
  content: "\\F1971"; }

.mdi-candy-off-outline::before {
  content: "\\F1972"; }

.mdi-candy-outline::before {
  content: "\\F1973"; }

.mdi-candycane::before {
  content: "\\F010A"; }

.mdi-cannabis::before {
  content: "\\F07A6"; }

.mdi-cannabis-off::before {
  content: "\\F166E"; }

.mdi-caps-lock::before {
  content: "\\F0A9B"; }

.mdi-car::before {
  content: "\\F010B"; }

.mdi-car-2-plus::before {
  content: "\\F1015"; }

.mdi-car-3-plus::before {
  content: "\\F1016"; }

.mdi-car-arrow-left::before {
  content: "\\F13B2"; }

.mdi-car-arrow-right::before {
  content: "\\F13B3"; }

.mdi-car-back::before {
  content: "\\F0E1B"; }

.mdi-car-battery::before {
  content: "\\F010C"; }

.mdi-car-brake-abs::before {
  content: "\\F0C47"; }

.mdi-car-brake-alert::before {
  content: "\\F0C48"; }

.mdi-car-brake-fluid-level::before {
  content: "\\F1909"; }

.mdi-car-brake-hold::before {
  content: "\\F0D5E"; }

.mdi-car-brake-low-pressure::before {
  content: "\\F190A"; }

.mdi-car-brake-parking::before {
  content: "\\F0D5F"; }

.mdi-car-brake-retarder::before {
  content: "\\F1017"; }

.mdi-car-brake-temperature::before {
  content: "\\F190B"; }

.mdi-car-brake-worn-linings::before {
  content: "\\F190C"; }

.mdi-car-child-seat::before {
  content: "\\F0FA3"; }

.mdi-car-clock::before {
  content: "\\F1974"; }

.mdi-car-clutch::before {
  content: "\\F1018"; }

.mdi-car-cog::before {
  content: "\\F13CC"; }

.mdi-car-connected::before {
  content: "\\F010D"; }

.mdi-car-convertible::before {
  content: "\\F07A7"; }

.mdi-car-coolant-level::before {
  content: "\\F1019"; }

.mdi-car-cruise-control::before {
  content: "\\F0D60"; }

.mdi-car-defrost-front::before {
  content: "\\F0D61"; }

.mdi-car-defrost-rear::before {
  content: "\\F0D62"; }

.mdi-car-door::before {
  content: "\\F0B6B"; }

.mdi-car-door-lock::before {
  content: "\\F109D"; }

.mdi-car-electric::before {
  content: "\\F0B6C"; }

.mdi-car-electric-outline::before {
  content: "\\F15B5"; }

.mdi-car-emergency::before {
  content: "\\F160F"; }

.mdi-car-esp::before {
  content: "\\F0C49"; }

.mdi-car-estate::before {
  content: "\\F07A8"; }

.mdi-car-hatchback::before {
  content: "\\F07A9"; }

.mdi-car-info::before {
  content: "\\F11BE"; }

.mdi-car-key::before {
  content: "\\F0B6D"; }

.mdi-car-lifted-pickup::before {
  content: "\\F152D"; }

.mdi-car-light-alert::before {
  content: "\\F190D"; }

.mdi-car-light-dimmed::before {
  content: "\\F0C4A"; }

.mdi-car-light-fog::before {
  content: "\\F0C4B"; }

.mdi-car-light-high::before {
  content: "\\F0C4C"; }

.mdi-car-limousine::before {
  content: "\\F08CD"; }

.mdi-car-multiple::before {
  content: "\\F0B6E"; }

.mdi-car-off::before {
  content: "\\F0E1C"; }

.mdi-car-outline::before {
  content: "\\F14ED"; }

.mdi-car-parking-lights::before {
  content: "\\F0D63"; }

.mdi-car-pickup::before {
  content: "\\F07AA"; }

.mdi-car-seat::before {
  content: "\\F0FA4"; }

.mdi-car-seat-cooler::before {
  content: "\\F0FA5"; }

.mdi-car-seat-heater::before {
  content: "\\F0FA6"; }

.mdi-car-select::before {
  content: "\\F1879"; }

.mdi-car-settings::before {
  content: "\\F13CD"; }

.mdi-car-shift-pattern::before {
  content: "\\F0F40"; }

.mdi-car-side::before {
  content: "\\F07AB"; }

.mdi-car-speed-limiter::before {
  content: "\\F190E"; }

.mdi-car-sports::before {
  content: "\\F07AC"; }

.mdi-car-tire-alert::before {
  content: "\\F0C4D"; }

.mdi-car-traction-control::before {
  content: "\\F0D64"; }

.mdi-car-turbocharger::before {
  content: "\\F101A"; }

.mdi-car-wash::before {
  content: "\\F010E"; }

.mdi-car-windshield::before {
  content: "\\F101B"; }

.mdi-car-windshield-outline::before {
  content: "\\F101C"; }

.mdi-car-wireless::before {
  content: "\\F1878"; }

.mdi-car-wrench::before {
  content: "\\F1814"; }

.mdi-carabiner::before {
  content: "\\F14C0"; }

.mdi-caravan::before {
  content: "\\F07AD"; }

.mdi-card::before {
  content: "\\F0B6F"; }

.mdi-card-account-details::before {
  content: "\\F05D2"; }

.mdi-card-account-details-outline::before {
  content: "\\F0DAB"; }

.mdi-card-account-details-star::before {
  content: "\\F02A3"; }

.mdi-card-account-details-star-outline::before {
  content: "\\F06DB"; }

.mdi-card-account-mail::before {
  content: "\\F018E"; }

.mdi-card-account-mail-outline::before {
  content: "\\F0E98"; }

.mdi-card-account-phone::before {
  content: "\\F0E99"; }

.mdi-card-account-phone-outline::before {
  content: "\\F0E9A"; }

.mdi-card-bulleted::before {
  content: "\\F0B70"; }

.mdi-card-bulleted-off::before {
  content: "\\F0B71"; }

.mdi-card-bulleted-off-outline::before {
  content: "\\F0B72"; }

.mdi-card-bulleted-outline::before {
  content: "\\F0B73"; }

.mdi-card-bulleted-settings::before {
  content: "\\F0B74"; }

.mdi-card-bulleted-settings-outline::before {
  content: "\\F0B75"; }

.mdi-card-minus::before {
  content: "\\F1600"; }

.mdi-card-minus-outline::before {
  content: "\\F1601"; }

.mdi-card-multiple::before {
  content: "\\F17F1"; }

.mdi-card-multiple-outline::before {
  content: "\\F17F2"; }

.mdi-card-off::before {
  content: "\\F1602"; }

.mdi-card-off-outline::before {
  content: "\\F1603"; }

.mdi-card-outline::before {
  content: "\\F0B76"; }

.mdi-card-plus::before {
  content: "\\F11FF"; }

.mdi-card-plus-outline::before {
  content: "\\F1200"; }

.mdi-card-remove::before {
  content: "\\F1604"; }

.mdi-card-remove-outline::before {
  content: "\\F1605"; }

.mdi-card-search::before {
  content: "\\F1074"; }

.mdi-card-search-outline::before {
  content: "\\F1075"; }

.mdi-card-text::before {
  content: "\\F0B77"; }

.mdi-card-text-outline::before {
  content: "\\F0B78"; }

.mdi-cards::before {
  content: "\\F0638"; }

.mdi-cards-club::before {
  content: "\\F08CE"; }

.mdi-cards-club-outline::before {
  content: "\\F189F"; }

.mdi-cards-diamond::before {
  content: "\\F08CF"; }

.mdi-cards-diamond-outline::before {
  content: "\\F101D"; }

.mdi-cards-heart::before {
  content: "\\F08D0"; }

.mdi-cards-heart-outline::before {
  content: "\\F18A0"; }

.mdi-cards-outline::before {
  content: "\\F0639"; }

.mdi-cards-playing::before {
  content: "\\F18A1"; }

.mdi-cards-playing-club::before {
  content: "\\F18A2"; }

.mdi-cards-playing-club-multiple::before {
  content: "\\F18A3"; }

.mdi-cards-playing-club-multiple-outline::before {
  content: "\\F18A4"; }

.mdi-cards-playing-club-outline::before {
  content: "\\F18A5"; }

.mdi-cards-playing-diamond::before {
  content: "\\F18A6"; }

.mdi-cards-playing-diamond-multiple::before {
  content: "\\F18A7"; }

.mdi-cards-playing-diamond-multiple-outline::before {
  content: "\\F18A8"; }

.mdi-cards-playing-diamond-outline::before {
  content: "\\F18A9"; }

.mdi-cards-playing-heart::before {
  content: "\\F18AA"; }

.mdi-cards-playing-heart-multiple::before {
  content: "\\F18AB"; }

.mdi-cards-playing-heart-multiple-outline::before {
  content: "\\F18AC"; }

.mdi-cards-playing-heart-outline::before {
  content: "\\F18AD"; }

.mdi-cards-playing-outline::before {
  content: "\\F063A"; }

.mdi-cards-playing-spade::before {
  content: "\\F18AE"; }

.mdi-cards-playing-spade-multiple::before {
  content: "\\F18AF"; }

.mdi-cards-playing-spade-multiple-outline::before {
  content: "\\F18B0"; }

.mdi-cards-playing-spade-outline::before {
  content: "\\F18B1"; }

.mdi-cards-spade::before {
  content: "\\F08D1"; }

.mdi-cards-spade-outline::before {
  content: "\\F18B2"; }

.mdi-cards-variant::before {
  content: "\\F06C7"; }

.mdi-carrot::before {
  content: "\\F010F"; }

.mdi-cart::before {
  content: "\\F0110"; }

.mdi-cart-arrow-down::before {
  content: "\\F0D66"; }

.mdi-cart-arrow-right::before {
  content: "\\F0C4E"; }

.mdi-cart-arrow-up::before {
  content: "\\F0D67"; }

.mdi-cart-check::before {
  content: "\\F15EA"; }

.mdi-cart-heart::before {
  content: "\\F18E0"; }

.mdi-cart-minus::before {
  content: "\\F0D68"; }

.mdi-cart-off::before {
  content: "\\F066B"; }

.mdi-cart-outline::before {
  content: "\\F0111"; }

.mdi-cart-plus::before {
  content: "\\F0112"; }

.mdi-cart-remove::before {
  content: "\\F0D69"; }

.mdi-cart-variant::before {
  content: "\\F15EB"; }

.mdi-case-sensitive-alt::before {
  content: "\\F0113"; }

.mdi-cash::before {
  content: "\\F0114"; }

.mdi-cash-100::before {
  content: "\\F0115"; }

.mdi-cash-check::before {
  content: "\\F14EE"; }

.mdi-cash-fast::before {
  content: "\\F185C"; }

.mdi-cash-lock::before {
  content: "\\F14EA"; }

.mdi-cash-lock-open::before {
  content: "\\F14EB"; }

.mdi-cash-marker::before {
  content: "\\F0DB8"; }

.mdi-cash-minus::before {
  content: "\\F1260"; }

.mdi-cash-multiple::before {
  content: "\\F0116"; }

.mdi-cash-plus::before {
  content: "\\F1261"; }

.mdi-cash-refund::before {
  content: "\\F0A9C"; }

.mdi-cash-register::before {
  content: "\\F0CF4"; }

.mdi-cash-remove::before {
  content: "\\F1262"; }

.mdi-cassette::before {
  content: "\\F09D4"; }

.mdi-cast::before {
  content: "\\F0118"; }

.mdi-cast-audio::before {
  content: "\\F101E"; }

.mdi-cast-audio-variant::before {
  content: "\\F1749"; }

.mdi-cast-connected::before {
  content: "\\F0119"; }

.mdi-cast-education::before {
  content: "\\F0E1D"; }

.mdi-cast-off::before {
  content: "\\F078A"; }

.mdi-cast-variant::before {
  content: "\\F001F"; }

.mdi-castle::before {
  content: "\\F011A"; }

.mdi-cat::before {
  content: "\\F011B"; }

.mdi-cctv::before {
  content: "\\F07AE"; }

.mdi-cctv-off::before {
  content: "\\F185F"; }

.mdi-ceiling-fan::before {
  content: "\\F1797"; }

.mdi-ceiling-fan-light::before {
  content: "\\F1798"; }

.mdi-ceiling-light::before {
  content: "\\F0769"; }

.mdi-ceiling-light-multiple::before {
  content: "\\F18DD"; }

.mdi-ceiling-light-multiple-outline::before {
  content: "\\F18DE"; }

.mdi-ceiling-light-outline::before {
  content: "\\F17C7"; }

.mdi-cellphone::before {
  content: "\\F011C"; }

.mdi-cellphone-arrow-down::before {
  content: "\\F09D5"; }

.mdi-cellphone-basic::before {
  content: "\\F011E"; }

.mdi-cellphone-charging::before {
  content: "\\F1397"; }

.mdi-cellphone-check::before {
  content: "\\F17FD"; }

.mdi-cellphone-cog::before {
  content: "\\F0951"; }

.mdi-cellphone-dock::before {
  content: "\\F011F"; }

.mdi-cellphone-information::before {
  content: "\\F0F41"; }

.mdi-cellphone-key::before {
  content: "\\F094E"; }

.mdi-cellphone-link::before {
  content: "\\F0121"; }

.mdi-cellphone-link-off::before {
  content: "\\F0122"; }

.mdi-cellphone-lock::before {
  content: "\\F094F"; }

.mdi-cellphone-marker::before {
  content: "\\F183A"; }

.mdi-cellphone-message::before {
  content: "\\F08D3"; }

.mdi-cellphone-message-off::before {
  content: "\\F10D2"; }

.mdi-cellphone-nfc::before {
  content: "\\F0E90"; }

.mdi-cellphone-nfc-off::before {
  content: "\\F12D8"; }

.mdi-cellphone-off::before {
  content: "\\F0950"; }

.mdi-cellphone-play::before {
  content: "\\F101F"; }

.mdi-cellphone-remove::before {
  content: "\\F094D"; }

.mdi-cellphone-screenshot::before {
  content: "\\F0A35"; }

.mdi-cellphone-settings::before {
  content: "\\F0123"; }

.mdi-cellphone-sound::before {
  content: "\\F0952"; }

.mdi-cellphone-text::before {
  content: "\\F08D2"; }

.mdi-cellphone-wireless::before {
  content: "\\F0815"; }

.mdi-centos::before {
  content: "\\F111A"; }

.mdi-certificate::before {
  content: "\\F0124"; }

.mdi-certificate-outline::before {
  content: "\\F1188"; }

.mdi-chair-rolling::before {
  content: "\\F0F48"; }

.mdi-chair-school::before {
  content: "\\F0125"; }

.mdi-chandelier::before {
  content: "\\F1793"; }

.mdi-charity::before {
  content: "\\F0C4F"; }

.mdi-chart-arc::before {
  content: "\\F0126"; }

.mdi-chart-areaspline::before {
  content: "\\F0127"; }

.mdi-chart-areaspline-variant::before {
  content: "\\F0E91"; }

.mdi-chart-bar::before {
  content: "\\F0128"; }

.mdi-chart-bar-stacked::before {
  content: "\\F076A"; }

.mdi-chart-bell-curve::before {
  content: "\\F0C50"; }

.mdi-chart-bell-curve-cumulative::before {
  content: "\\F0FA7"; }

.mdi-chart-box::before {
  content: "\\F154D"; }

.mdi-chart-box-outline::before {
  content: "\\F154E"; }

.mdi-chart-box-plus-outline::before {
  content: "\\F154F"; }

.mdi-chart-bubble::before {
  content: "\\F05E3"; }

.mdi-chart-donut::before {
  content: "\\F07AF"; }

.mdi-chart-donut-variant::before {
  content: "\\F07B0"; }

.mdi-chart-gantt::before {
  content: "\\F066C"; }

.mdi-chart-histogram::before {
  content: "\\F0129"; }

.mdi-chart-line::before {
  content: "\\F012A"; }

.mdi-chart-line-stacked::before {
  content: "\\F076B"; }

.mdi-chart-line-variant::before {
  content: "\\F07B1"; }

.mdi-chart-multiline::before {
  content: "\\F08D4"; }

.mdi-chart-multiple::before {
  content: "\\F1213"; }

.mdi-chart-pie::before {
  content: "\\F012B"; }

.mdi-chart-ppf::before {
  content: "\\F1380"; }

.mdi-chart-sankey::before {
  content: "\\F11DF"; }

.mdi-chart-sankey-variant::before {
  content: "\\F11E0"; }

.mdi-chart-scatter-plot::before {
  content: "\\F0E92"; }

.mdi-chart-scatter-plot-hexbin::before {
  content: "\\F066D"; }

.mdi-chart-timeline::before {
  content: "\\F066E"; }

.mdi-chart-timeline-variant::before {
  content: "\\F0E93"; }

.mdi-chart-timeline-variant-shimmer::before {
  content: "\\F15B6"; }

.mdi-chart-tree::before {
  content: "\\F0E94"; }

.mdi-chart-waterfall::before {
  content: "\\F1918"; }

.mdi-chat::before {
  content: "\\F0B79"; }

.mdi-chat-alert::before {
  content: "\\F0B7A"; }

.mdi-chat-alert-outline::before {
  content: "\\F12C9"; }

.mdi-chat-minus::before {
  content: "\\F1410"; }

.mdi-chat-minus-outline::before {
  content: "\\F1413"; }

.mdi-chat-outline::before {
  content: "\\F0EDE"; }

.mdi-chat-plus::before {
  content: "\\F140F"; }

.mdi-chat-plus-outline::before {
  content: "\\F1412"; }

.mdi-chat-processing::before {
  content: "\\F0B7B"; }

.mdi-chat-processing-outline::before {
  content: "\\F12CA"; }

.mdi-chat-question::before {
  content: "\\F1738"; }

.mdi-chat-question-outline::before {
  content: "\\F1739"; }

.mdi-chat-remove::before {
  content: "\\F1411"; }

.mdi-chat-remove-outline::before {
  content: "\\F1414"; }

.mdi-chat-sleep::before {
  content: "\\F12D1"; }

.mdi-chat-sleep-outline::before {
  content: "\\F12D2"; }

.mdi-check::before {
  content: "\\F012C"; }

.mdi-check-all::before {
  content: "\\F012D"; }

.mdi-check-bold::before {
  content: "\\F0E1E"; }

.mdi-check-circle::before {
  content: "\\F05E0"; }

.mdi-check-circle-outline::before {
  content: "\\F05E1"; }

.mdi-check-decagram::before {
  content: "\\F0791"; }

.mdi-check-decagram-outline::before {
  content: "\\F1740"; }

.mdi-check-network::before {
  content: "\\F0C53"; }

.mdi-check-network-outline::before {
  content: "\\F0C54"; }

.mdi-check-outline::before {
  content: "\\F0855"; }

.mdi-check-underline::before {
  content: "\\F0E1F"; }

.mdi-check-underline-circle::before {
  content: "\\F0E20"; }

.mdi-check-underline-circle-outline::before {
  content: "\\F0E21"; }

.mdi-checkbook::before {
  content: "\\F0A9D"; }

.mdi-checkbox-blank::before {
  content: "\\F012E"; }

.mdi-checkbox-blank-badge::before {
  content: "\\F1176"; }

.mdi-checkbox-blank-badge-outline::before {
  content: "\\F0117"; }

.mdi-checkbox-blank-circle::before {
  content: "\\F012F"; }

.mdi-checkbox-blank-circle-outline::before {
  content: "\\F0130"; }

.mdi-checkbox-blank-off::before {
  content: "\\F12EC"; }

.mdi-checkbox-blank-off-outline::before {
  content: "\\F12ED"; }

.mdi-checkbox-blank-outline::before {
  content: "\\F0131"; }

.mdi-checkbox-intermediate::before {
  content: "\\F0856"; }

.mdi-checkbox-marked::before {
  content: "\\F0132"; }

.mdi-checkbox-marked-circle::before {
  content: "\\F0133"; }

.mdi-checkbox-marked-circle-outline::before {
  content: "\\F0134"; }

.mdi-checkbox-marked-circle-plus-outline::before {
  content: "\\F1927"; }

.mdi-checkbox-marked-outline::before {
  content: "\\F0135"; }

.mdi-checkbox-multiple-blank::before {
  content: "\\F0136"; }

.mdi-checkbox-multiple-blank-circle::before {
  content: "\\F063B"; }

.mdi-checkbox-multiple-blank-circle-outline::before {
  content: "\\F063C"; }

.mdi-checkbox-multiple-blank-outline::before {
  content: "\\F0137"; }

.mdi-checkbox-multiple-marked::before {
  content: "\\F0138"; }

.mdi-checkbox-multiple-marked-circle::before {
  content: "\\F063D"; }

.mdi-checkbox-multiple-marked-circle-outline::before {
  content: "\\F063E"; }

.mdi-checkbox-multiple-marked-outline::before {
  content: "\\F0139"; }

.mdi-checkbox-multiple-outline::before {
  content: "\\F0C51"; }

.mdi-checkbox-outline::before {
  content: "\\F0C52"; }

.mdi-checkerboard::before {
  content: "\\F013A"; }

.mdi-checkerboard-minus::before {
  content: "\\F1202"; }

.mdi-checkerboard-plus::before {
  content: "\\F1201"; }

.mdi-checkerboard-remove::before {
  content: "\\F1203"; }

.mdi-cheese::before {
  content: "\\F12B9"; }

.mdi-cheese-off::before {
  content: "\\F13EE"; }

.mdi-chef-hat::before {
  content: "\\F0B7C"; }

.mdi-chemical-weapon::before {
  content: "\\F013B"; }

.mdi-chess-bishop::before {
  content: "\\F085C"; }

.mdi-chess-king::before {
  content: "\\F0857"; }

.mdi-chess-knight::before {
  content: "\\F0858"; }

.mdi-chess-pawn::before {
  content: "\\F0859"; }

.mdi-chess-queen::before {
  content: "\\F085A"; }

.mdi-chess-rook::before {
  content: "\\F085B"; }

.mdi-chevron-double-down::before {
  content: "\\F013C"; }

.mdi-chevron-double-left::before {
  content: "\\F013D"; }

.mdi-chevron-double-right::before {
  content: "\\F013E"; }

.mdi-chevron-double-up::before {
  content: "\\F013F"; }

.mdi-chevron-down::before {
  content: "\\F0140"; }

.mdi-chevron-down-box::before {
  content: "\\F09D6"; }

.mdi-chevron-down-box-outline::before {
  content: "\\F09D7"; }

.mdi-chevron-down-circle::before {
  content: "\\F0B26"; }

.mdi-chevron-down-circle-outline::before {
  content: "\\F0B27"; }

.mdi-chevron-left::before {
  content: "\\F0141"; }

.mdi-chevron-left-box::before {
  content: "\\F09D8"; }

.mdi-chevron-left-box-outline::before {
  content: "\\F09D9"; }

.mdi-chevron-left-circle::before {
  content: "\\F0B28"; }

.mdi-chevron-left-circle-outline::before {
  content: "\\F0B29"; }

.mdi-chevron-right::before {
  content: "\\F0142"; }

.mdi-chevron-right-box::before {
  content: "\\F09DA"; }

.mdi-chevron-right-box-outline::before {
  content: "\\F09DB"; }

.mdi-chevron-right-circle::before {
  content: "\\F0B2A"; }

.mdi-chevron-right-circle-outline::before {
  content: "\\F0B2B"; }

.mdi-chevron-triple-down::before {
  content: "\\F0DB9"; }

.mdi-chevron-triple-left::before {
  content: "\\F0DBA"; }

.mdi-chevron-triple-right::before {
  content: "\\F0DBB"; }

.mdi-chevron-triple-up::before {
  content: "\\F0DBC"; }

.mdi-chevron-up::before {
  content: "\\F0143"; }

.mdi-chevron-up-box::before {
  content: "\\F09DC"; }

.mdi-chevron-up-box-outline::before {
  content: "\\F09DD"; }

.mdi-chevron-up-circle::before {
  content: "\\F0B2C"; }

.mdi-chevron-up-circle-outline::before {
  content: "\\F0B2D"; }

.mdi-chili-alert::before {
  content: "\\F17EA"; }

.mdi-chili-alert-outline::before {
  content: "\\F17EB"; }

.mdi-chili-hot::before {
  content: "\\F07B2"; }

.mdi-chili-hot-outline::before {
  content: "\\F17EC"; }

.mdi-chili-medium::before {
  content: "\\F07B3"; }

.mdi-chili-medium-outline::before {
  content: "\\F17ED"; }

.mdi-chili-mild::before {
  content: "\\F07B4"; }

.mdi-chili-mild-outline::before {
  content: "\\F17EE"; }

.mdi-chili-off::before {
  content: "\\F1467"; }

.mdi-chili-off-outline::before {
  content: "\\F17EF"; }

.mdi-chip::before {
  content: "\\F061A"; }

.mdi-church::before {
  content: "\\F0144"; }

.mdi-cigar::before {
  content: "\\F1189"; }

.mdi-cigar-off::before {
  content: "\\F141B"; }

.mdi-circle::before {
  content: "\\F0765"; }

.mdi-circle-box::before {
  content: "\\F15DC"; }

.mdi-circle-box-outline::before {
  content: "\\F15DD"; }

.mdi-circle-double::before {
  content: "\\F0E95"; }

.mdi-circle-edit-outline::before {
  content: "\\F08D5"; }

.mdi-circle-expand::before {
  content: "\\F0E96"; }

.mdi-circle-half::before {
  content: "\\F1395"; }

.mdi-circle-half-full::before {
  content: "\\F1396"; }

.mdi-circle-medium::before {
  content: "\\F09DE"; }

.mdi-circle-multiple::before {
  content: "\\F0B38"; }

.mdi-circle-multiple-outline::before {
  content: "\\F0695"; }

.mdi-circle-off-outline::before {
  content: "\\F10D3"; }

.mdi-circle-opacity::before {
  content: "\\F1853"; }

.mdi-circle-outline::before {
  content: "\\F0766"; }

.mdi-circle-slice-1::before {
  content: "\\F0A9E"; }

.mdi-circle-slice-2::before {
  content: "\\F0A9F"; }

.mdi-circle-slice-3::before {
  content: "\\F0AA0"; }

.mdi-circle-slice-4::before {
  content: "\\F0AA1"; }

.mdi-circle-slice-5::before {
  content: "\\F0AA2"; }

.mdi-circle-slice-6::before {
  content: "\\F0AA3"; }

.mdi-circle-slice-7::before {
  content: "\\F0AA4"; }

.mdi-circle-slice-8::before {
  content: "\\F0AA5"; }

.mdi-circle-small::before {
  content: "\\F09DF"; }

.mdi-circular-saw::before {
  content: "\\F0E22"; }

.mdi-city::before {
  content: "\\F0146"; }

.mdi-city-variant::before {
  content: "\\F0A36"; }

.mdi-city-variant-outline::before {
  content: "\\F0A37"; }

.mdi-clipboard::before {
  content: "\\F0147"; }

.mdi-clipboard-account::before {
  content: "\\F0148"; }

.mdi-clipboard-account-outline::before {
  content: "\\F0C55"; }

.mdi-clipboard-alert::before {
  content: "\\F0149"; }

.mdi-clipboard-alert-outline::before {
  content: "\\F0CF7"; }

.mdi-clipboard-arrow-down::before {
  content: "\\F014A"; }

.mdi-clipboard-arrow-down-outline::before {
  content: "\\F0C56"; }

.mdi-clipboard-arrow-left::before {
  content: "\\F014B"; }

.mdi-clipboard-arrow-left-outline::before {
  content: "\\F0CF8"; }

.mdi-clipboard-arrow-right::before {
  content: "\\F0CF9"; }

.mdi-clipboard-arrow-right-outline::before {
  content: "\\F0CFA"; }

.mdi-clipboard-arrow-up::before {
  content: "\\F0C57"; }

.mdi-clipboard-arrow-up-outline::before {
  content: "\\F0C58"; }

.mdi-clipboard-check::before {
  content: "\\F014E"; }

.mdi-clipboard-check-multiple::before {
  content: "\\F1263"; }

.mdi-clipboard-check-multiple-outline::before {
  content: "\\F1264"; }

.mdi-clipboard-check-outline::before {
  content: "\\F08A8"; }

.mdi-clipboard-clock::before {
  content: "\\F16E2"; }

.mdi-clipboard-clock-outline::before {
  content: "\\F16E3"; }

.mdi-clipboard-edit::before {
  content: "\\F14E5"; }

.mdi-clipboard-edit-outline::before {
  content: "\\F14E6"; }

.mdi-clipboard-file::before {
  content: "\\F1265"; }

.mdi-clipboard-file-outline::before {
  content: "\\F1266"; }

.mdi-clipboard-flow::before {
  content: "\\F06C8"; }

.mdi-clipboard-flow-outline::before {
  content: "\\F1117"; }

.mdi-clipboard-list::before {
  content: "\\F10D4"; }

.mdi-clipboard-list-outline::before {
  content: "\\F10D5"; }

.mdi-clipboard-minus::before {
  content: "\\F1618"; }

.mdi-clipboard-minus-outline::before {
  content: "\\F1619"; }

.mdi-clipboard-multiple::before {
  content: "\\F1267"; }

.mdi-clipboard-multiple-outline::before {
  content: "\\F1268"; }

.mdi-clipboard-off::before {
  content: "\\F161A"; }

.mdi-clipboard-off-outline::before {
  content: "\\F161B"; }

.mdi-clipboard-outline::before {
  content: "\\F014C"; }

.mdi-clipboard-play::before {
  content: "\\F0C59"; }

.mdi-clipboard-play-multiple::before {
  content: "\\F1269"; }

.mdi-clipboard-play-multiple-outline::before {
  content: "\\F126A"; }

.mdi-clipboard-play-outline::before {
  content: "\\F0C5A"; }

.mdi-clipboard-plus::before {
  content: "\\F0751"; }

.mdi-clipboard-plus-outline::before {
  content: "\\F131F"; }

.mdi-clipboard-pulse::before {
  content: "\\F085D"; }

.mdi-clipboard-pulse-outline::before {
  content: "\\F085E"; }

.mdi-clipboard-remove::before {
  content: "\\F161C"; }

.mdi-clipboard-remove-outline::before {
  content: "\\F161D"; }

.mdi-clipboard-search::before {
  content: "\\F161E"; }

.mdi-clipboard-search-outline::before {
  content: "\\F161F"; }

.mdi-clipboard-text::before {
  content: "\\F014D"; }

.mdi-clipboard-text-clock::before {
  content: "\\F18F9"; }

.mdi-clipboard-text-clock-outline::before {
  content: "\\F18FA"; }

.mdi-clipboard-text-multiple::before {
  content: "\\F126B"; }

.mdi-clipboard-text-multiple-outline::before {
  content: "\\F126C"; }

.mdi-clipboard-text-off::before {
  content: "\\F1620"; }

.mdi-clipboard-text-off-outline::before {
  content: "\\F1621"; }

.mdi-clipboard-text-outline::before {
  content: "\\F0A38"; }

.mdi-clipboard-text-play::before {
  content: "\\F0C5B"; }

.mdi-clipboard-text-play-outline::before {
  content: "\\F0C5C"; }

.mdi-clipboard-text-search::before {
  content: "\\F1622"; }

.mdi-clipboard-text-search-outline::before {
  content: "\\F1623"; }

.mdi-clippy::before {
  content: "\\F014F"; }

.mdi-clock::before {
  content: "\\F0954"; }

.mdi-clock-alert::before {
  content: "\\F0955"; }

.mdi-clock-alert-outline::before {
  content: "\\F05CE"; }

.mdi-clock-check::before {
  content: "\\F0FA8"; }

.mdi-clock-check-outline::before {
  content: "\\F0FA9"; }

.mdi-clock-digital::before {
  content: "\\F0E97"; }

.mdi-clock-edit::before {
  content: "\\F19BA"; }

.mdi-clock-edit-outline::before {
  content: "\\F19BB"; }

.mdi-clock-end::before {
  content: "\\F0151"; }

.mdi-clock-fast::before {
  content: "\\F0152"; }

.mdi-clock-in::before {
  content: "\\F0153"; }

.mdi-clock-minus::before {
  content: "\\F1863"; }

.mdi-clock-minus-outline::before {
  content: "\\F1864"; }

.mdi-clock-out::before {
  content: "\\F0154"; }

.mdi-clock-outline::before {
  content: "\\F0150"; }

.mdi-clock-plus::before {
  content: "\\F1861"; }

.mdi-clock-plus-outline::before {
  content: "\\F1862"; }

.mdi-clock-remove::before {
  content: "\\F1865"; }

.mdi-clock-remove-outline::before {
  content: "\\F1866"; }

.mdi-clock-start::before {
  content: "\\F0155"; }

.mdi-clock-time-eight::before {
  content: "\\F1446"; }

.mdi-clock-time-eight-outline::before {
  content: "\\F1452"; }

.mdi-clock-time-eleven::before {
  content: "\\F1449"; }

.mdi-clock-time-eleven-outline::before {
  content: "\\F1455"; }

.mdi-clock-time-five::before {
  content: "\\F1443"; }

.mdi-clock-time-five-outline::before {
  content: "\\F144F"; }

.mdi-clock-time-four::before {
  content: "\\F1442"; }

.mdi-clock-time-four-outline::before {
  content: "\\F144E"; }

.mdi-clock-time-nine::before {
  content: "\\F1447"; }

.mdi-clock-time-nine-outline::before {
  content: "\\F1453"; }

.mdi-clock-time-one::before {
  content: "\\F143F"; }

.mdi-clock-time-one-outline::before {
  content: "\\F144B"; }

.mdi-clock-time-seven::before {
  content: "\\F1445"; }

.mdi-clock-time-seven-outline::before {
  content: "\\F1451"; }

.mdi-clock-time-six::before {
  content: "\\F1444"; }

.mdi-clock-time-six-outline::before {
  content: "\\F1450"; }

.mdi-clock-time-ten::before {
  content: "\\F1448"; }

.mdi-clock-time-ten-outline::before {
  content: "\\F1454"; }

.mdi-clock-time-three::before {
  content: "\\F1441"; }

.mdi-clock-time-three-outline::before {
  content: "\\F144D"; }

.mdi-clock-time-twelve::before {
  content: "\\F144A"; }

.mdi-clock-time-twelve-outline::before {
  content: "\\F1456"; }

.mdi-clock-time-two::before {
  content: "\\F1440"; }

.mdi-clock-time-two-outline::before {
  content: "\\F144C"; }

.mdi-close::before {
  content: "\\F0156"; }

.mdi-close-box::before {
  content: "\\F0157"; }

.mdi-close-box-multiple::before {
  content: "\\F0C5D"; }

.mdi-close-box-multiple-outline::before {
  content: "\\F0C5E"; }

.mdi-close-box-outline::before {
  content: "\\F0158"; }

.mdi-close-circle::before {
  content: "\\F0159"; }

.mdi-close-circle-multiple::before {
  content: "\\F062A"; }

.mdi-close-circle-multiple-outline::before {
  content: "\\F0883"; }

.mdi-close-circle-outline::before {
  content: "\\F015A"; }

.mdi-close-network::before {
  content: "\\F015B"; }

.mdi-close-network-outline::before {
  content: "\\F0C5F"; }

.mdi-close-octagon::before {
  content: "\\F015C"; }

.mdi-close-octagon-outline::before {
  content: "\\F015D"; }

.mdi-close-outline::before {
  content: "\\F06C9"; }

.mdi-close-thick::before {
  content: "\\F1398"; }

.mdi-closed-caption::before {
  content: "\\F015E"; }

.mdi-closed-caption-outline::before {
  content: "\\F0DBD"; }

.mdi-cloud::before {
  content: "\\F015F"; }

.mdi-cloud-alert::before {
  content: "\\F09E0"; }

.mdi-cloud-braces::before {
  content: "\\F07B5"; }

.mdi-cloud-check::before {
  content: "\\F0160"; }

.mdi-cloud-check-outline::before {
  content: "\\F12CC"; }

.mdi-cloud-circle::before {
  content: "\\F0161"; }

.mdi-cloud-download::before {
  content: "\\F0162"; }

.mdi-cloud-download-outline::before {
  content: "\\F0B7D"; }

.mdi-cloud-lock::before {
  content: "\\F11F1"; }

.mdi-cloud-lock-outline::before {
  content: "\\F11F2"; }

.mdi-cloud-off-outline::before {
  content: "\\F0164"; }

.mdi-cloud-outline::before {
  content: "\\F0163"; }

.mdi-cloud-print::before {
  content: "\\F0165"; }

.mdi-cloud-print-outline::before {
  content: "\\F0166"; }

.mdi-cloud-question::before {
  content: "\\F0A39"; }

.mdi-cloud-refresh::before {
  content: "\\F052A"; }

.mdi-cloud-search::before {
  content: "\\F0956"; }

.mdi-cloud-search-outline::before {
  content: "\\F0957"; }

.mdi-cloud-sync::before {
  content: "\\F063F"; }

.mdi-cloud-sync-outline::before {
  content: "\\F12D6"; }

.mdi-cloud-tags::before {
  content: "\\F07B6"; }

.mdi-cloud-upload::before {
  content: "\\F0167"; }

.mdi-cloud-upload-outline::before {
  content: "\\F0B7E"; }

.mdi-clover::before {
  content: "\\F0816"; }

.mdi-coach-lamp::before {
  content: "\\F1020"; }

.mdi-coat-rack::before {
  content: "\\F109E"; }

.mdi-code-array::before {
  content: "\\F0168"; }

.mdi-code-braces::before {
  content: "\\F0169"; }

.mdi-code-braces-box::before {
  content: "\\F10D6"; }

.mdi-code-brackets::before {
  content: "\\F016A"; }

.mdi-code-equal::before {
  content: "\\F016B"; }

.mdi-code-greater-than::before {
  content: "\\F016C"; }

.mdi-code-greater-than-or-equal::before {
  content: "\\F016D"; }

.mdi-code-json::before {
  content: "\\F0626"; }

.mdi-code-less-than::before {
  content: "\\F016E"; }

.mdi-code-less-than-or-equal::before {
  content: "\\F016F"; }

.mdi-code-not-equal::before {
  content: "\\F0170"; }

.mdi-code-not-equal-variant::before {
  content: "\\F0171"; }

.mdi-code-parentheses::before {
  content: "\\F0172"; }

.mdi-code-parentheses-box::before {
  content: "\\F10D7"; }

.mdi-code-string::before {
  content: "\\F0173"; }

.mdi-code-tags::before {
  content: "\\F0174"; }

.mdi-code-tags-check::before {
  content: "\\F0694"; }

.mdi-codepen::before {
  content: "\\F0175"; }

.mdi-coffee::before {
  content: "\\F0176"; }

.mdi-coffee-maker::before {
  content: "\\F109F"; }

.mdi-coffee-maker-check::before {
  content: "\\F1931"; }

.mdi-coffee-maker-check-outline::before {
  content: "\\F1932"; }

.mdi-coffee-maker-outline::before {
  content: "\\F181B"; }

.mdi-coffee-off::before {
  content: "\\F0FAA"; }

.mdi-coffee-off-outline::before {
  content: "\\F0FAB"; }

.mdi-coffee-outline::before {
  content: "\\F06CA"; }

.mdi-coffee-to-go::before {
  content: "\\F0177"; }

.mdi-coffee-to-go-outline::before {
  content: "\\F130E"; }

.mdi-coffin::before {
  content: "\\F0B7F"; }

.mdi-cog::before {
  content: "\\F0493"; }

.mdi-cog-box::before {
  content: "\\F0494"; }

.mdi-cog-clockwise::before {
  content: "\\F11DD"; }

.mdi-cog-counterclockwise::before {
  content: "\\F11DE"; }

.mdi-cog-off::before {
  content: "\\F13CE"; }

.mdi-cog-off-outline::before {
  content: "\\F13CF"; }

.mdi-cog-outline::before {
  content: "\\F08BB"; }

.mdi-cog-pause::before {
  content: "\\F1933"; }

.mdi-cog-pause-outline::before {
  content: "\\F1934"; }

.mdi-cog-play::before {
  content: "\\F1935"; }

.mdi-cog-play-outline::before {
  content: "\\F1936"; }

.mdi-cog-refresh::before {
  content: "\\F145E"; }

.mdi-cog-refresh-outline::before {
  content: "\\F145F"; }

.mdi-cog-stop::before {
  content: "\\F1937"; }

.mdi-cog-stop-outline::before {
  content: "\\F1938"; }

.mdi-cog-sync::before {
  content: "\\F1460"; }

.mdi-cog-sync-outline::before {
  content: "\\F1461"; }

.mdi-cog-transfer::before {
  content: "\\F105B"; }

.mdi-cog-transfer-outline::before {
  content: "\\F105C"; }

.mdi-cogs::before {
  content: "\\F08D6"; }

.mdi-collage::before {
  content: "\\F0640"; }

.mdi-collapse-all::before {
  content: "\\F0AA6"; }

.mdi-collapse-all-outline::before {
  content: "\\F0AA7"; }

.mdi-color-helper::before {
  content: "\\F0179"; }

.mdi-comma::before {
  content: "\\F0E23"; }

.mdi-comma-box::before {
  content: "\\F0E2B"; }

.mdi-comma-box-outline::before {
  content: "\\F0E24"; }

.mdi-comma-circle::before {
  content: "\\F0E25"; }

.mdi-comma-circle-outline::before {
  content: "\\F0E26"; }

.mdi-comment::before {
  content: "\\F017A"; }

.mdi-comment-account::before {
  content: "\\F017B"; }

.mdi-comment-account-outline::before {
  content: "\\F017C"; }

.mdi-comment-alert::before {
  content: "\\F017D"; }

.mdi-comment-alert-outline::before {
  content: "\\F017E"; }

.mdi-comment-arrow-left::before {
  content: "\\F09E1"; }

.mdi-comment-arrow-left-outline::before {
  content: "\\F09E2"; }

.mdi-comment-arrow-right::before {
  content: "\\F09E3"; }

.mdi-comment-arrow-right-outline::before {
  content: "\\F09E4"; }

.mdi-comment-bookmark::before {
  content: "\\F15AE"; }

.mdi-comment-bookmark-outline::before {
  content: "\\F15AF"; }

.mdi-comment-check::before {
  content: "\\F017F"; }

.mdi-comment-check-outline::before {
  content: "\\F0180"; }

.mdi-comment-edit::before {
  content: "\\F11BF"; }

.mdi-comment-edit-outline::before {
  content: "\\F12C4"; }

.mdi-comment-eye::before {
  content: "\\F0A3A"; }

.mdi-comment-eye-outline::before {
  content: "\\F0A3B"; }

.mdi-comment-flash::before {
  content: "\\F15B0"; }

.mdi-comment-flash-outline::before {
  content: "\\F15B1"; }

.mdi-comment-minus::before {
  content: "\\F15DF"; }

.mdi-comment-minus-outline::before {
  content: "\\F15E0"; }

.mdi-comment-multiple::before {
  content: "\\F085F"; }

.mdi-comment-multiple-outline::before {
  content: "\\F0181"; }

.mdi-comment-off::before {
  content: "\\F15E1"; }

.mdi-comment-off-outline::before {
  content: "\\F15E2"; }

.mdi-comment-outline::before {
  content: "\\F0182"; }

.mdi-comment-plus::before {
  content: "\\F09E5"; }

.mdi-comment-plus-outline::before {
  content: "\\F0183"; }

.mdi-comment-processing::before {
  content: "\\F0184"; }

.mdi-comment-processing-outline::before {
  content: "\\F0185"; }

.mdi-comment-question::before {
  content: "\\F0817"; }

.mdi-comment-question-outline::before {
  content: "\\F0186"; }

.mdi-comment-quote::before {
  content: "\\F1021"; }

.mdi-comment-quote-outline::before {
  content: "\\F1022"; }

.mdi-comment-remove::before {
  content: "\\F05DE"; }

.mdi-comment-remove-outline::before {
  content: "\\F0187"; }

.mdi-comment-search::before {
  content: "\\F0A3C"; }

.mdi-comment-search-outline::before {
  content: "\\F0A3D"; }

.mdi-comment-text::before {
  content: "\\F0188"; }

.mdi-comment-text-multiple::before {
  content: "\\F0860"; }

.mdi-comment-text-multiple-outline::before {
  content: "\\F0861"; }

.mdi-comment-text-outline::before {
  content: "\\F0189"; }

.mdi-compare::before {
  content: "\\F018A"; }

.mdi-compare-horizontal::before {
  content: "\\F1492"; }

.mdi-compare-remove::before {
  content: "\\F18B3"; }

.mdi-compare-vertical::before {
  content: "\\F1493"; }

.mdi-compass::before {
  content: "\\F018B"; }

.mdi-compass-off::before {
  content: "\\F0B80"; }

.mdi-compass-off-outline::before {
  content: "\\F0B81"; }

.mdi-compass-outline::before {
  content: "\\F018C"; }

.mdi-compass-rose::before {
  content: "\\F1382"; }

.mdi-cone::before {
  content: "\\F194C"; }

.mdi-cone-off::before {
  content: "\\F194D"; }

.mdi-connection::before {
  content: "\\F1616"; }

.mdi-console::before {
  content: "\\F018D"; }

.mdi-console-line::before {
  content: "\\F07B7"; }

.mdi-console-network::before {
  content: "\\F08A9"; }

.mdi-console-network-outline::before {
  content: "\\F0C60"; }

.mdi-consolidate::before {
  content: "\\F10D8"; }

.mdi-contactless-payment::before {
  content: "\\F0D6A"; }

.mdi-contactless-payment-circle::before {
  content: "\\F0321"; }

.mdi-contactless-payment-circle-outline::before {
  content: "\\F0408"; }

.mdi-contacts::before {
  content: "\\F06CB"; }

.mdi-contacts-outline::before {
  content: "\\F05B8"; }

.mdi-contain::before {
  content: "\\F0A3E"; }

.mdi-contain-end::before {
  content: "\\F0A3F"; }

.mdi-contain-start::before {
  content: "\\F0A40"; }

.mdi-content-copy::before {
  content: "\\F018F"; }

.mdi-content-cut::before {
  content: "\\F0190"; }

.mdi-content-duplicate::before {
  content: "\\F0191"; }

.mdi-content-paste::before {
  content: "\\F0192"; }

.mdi-content-save::before {
  content: "\\F0193"; }

.mdi-content-save-alert::before {
  content: "\\F0F42"; }

.mdi-content-save-alert-outline::before {
  content: "\\F0F43"; }

.mdi-content-save-all::before {
  content: "\\F0194"; }

.mdi-content-save-all-outline::before {
  content: "\\F0F44"; }

.mdi-content-save-check::before {
  content: "\\F18EA"; }

.mdi-content-save-check-outline::before {
  content: "\\F18EB"; }

.mdi-content-save-cog::before {
  content: "\\F145B"; }

.mdi-content-save-cog-outline::before {
  content: "\\F145C"; }

.mdi-content-save-edit::before {
  content: "\\F0CFB"; }

.mdi-content-save-edit-outline::before {
  content: "\\F0CFC"; }

.mdi-content-save-move::before {
  content: "\\F0E27"; }

.mdi-content-save-move-outline::before {
  content: "\\F0E28"; }

.mdi-content-save-off::before {
  content: "\\F1643"; }

.mdi-content-save-off-outline::before {
  content: "\\F1644"; }

.mdi-content-save-outline::before {
  content: "\\F0818"; }

.mdi-content-save-settings::before {
  content: "\\F061B"; }

.mdi-content-save-settings-outline::before {
  content: "\\F0B2E"; }

.mdi-contrast::before {
  content: "\\F0195"; }

.mdi-contrast-box::before {
  content: "\\F0196"; }

.mdi-contrast-circle::before {
  content: "\\F0197"; }

.mdi-controller-classic::before {
  content: "\\F0B82"; }

.mdi-controller-classic-outline::before {
  content: "\\F0B83"; }

.mdi-cookie::before {
  content: "\\F0198"; }

.mdi-cookie-alert::before {
  content: "\\F16D0"; }

.mdi-cookie-alert-outline::before {
  content: "\\F16D1"; }

.mdi-cookie-check::before {
  content: "\\F16D2"; }

.mdi-cookie-check-outline::before {
  content: "\\F16D3"; }

.mdi-cookie-clock::before {
  content: "\\F16E4"; }

.mdi-cookie-clock-outline::before {
  content: "\\F16E5"; }

.mdi-cookie-cog::before {
  content: "\\F16D4"; }

.mdi-cookie-cog-outline::before {
  content: "\\F16D5"; }

.mdi-cookie-edit::before {
  content: "\\F16E6"; }

.mdi-cookie-edit-outline::before {
  content: "\\F16E7"; }

.mdi-cookie-lock::before {
  content: "\\F16E8"; }

.mdi-cookie-lock-outline::before {
  content: "\\F16E9"; }

.mdi-cookie-minus::before {
  content: "\\F16DA"; }

.mdi-cookie-minus-outline::before {
  content: "\\F16DB"; }

.mdi-cookie-off::before {
  content: "\\F16EA"; }

.mdi-cookie-off-outline::before {
  content: "\\F16EB"; }

.mdi-cookie-outline::before {
  content: "\\F16DE"; }

.mdi-cookie-plus::before {
  content: "\\F16D6"; }

.mdi-cookie-plus-outline::before {
  content: "\\F16D7"; }

.mdi-cookie-refresh::before {
  content: "\\F16EC"; }

.mdi-cookie-refresh-outline::before {
  content: "\\F16ED"; }

.mdi-cookie-remove::before {
  content: "\\F16D8"; }

.mdi-cookie-remove-outline::before {
  content: "\\F16D9"; }

.mdi-cookie-settings::before {
  content: "\\F16DC"; }

.mdi-cookie-settings-outline::before {
  content: "\\F16DD"; }

.mdi-coolant-temperature::before {
  content: "\\F03C8"; }

.mdi-copyleft::before {
  content: "\\F1939"; }

.mdi-copyright::before {
  content: "\\F05E6"; }

.mdi-cordova::before {
  content: "\\F0958"; }

.mdi-corn::before {
  content: "\\F07B8"; }

.mdi-corn-off::before {
  content: "\\F13EF"; }

.mdi-cosine-wave::before {
  content: "\\F1479"; }

.mdi-counter::before {
  content: "\\F0199"; }

.mdi-countertop::before {
  content: "\\F181C"; }

.mdi-countertop-outline::before {
  content: "\\F181D"; }

.mdi-cow::before {
  content: "\\F019A"; }

.mdi-cow-off::before {
  content: "\\F18FC"; }

.mdi-cpu-32-bit::before {
  content: "\\F0EDF"; }

.mdi-cpu-64-bit::before {
  content: "\\F0EE0"; }

.mdi-cradle::before {
  content: "\\F198B"; }

.mdi-cradle-outline::before {
  content: "\\F1991"; }

.mdi-crane::before {
  content: "\\F0862"; }

.mdi-creation::before {
  content: "\\F0674"; }

.mdi-creative-commons::before {
  content: "\\F0D6B"; }

.mdi-credit-card::before {
  content: "\\F0FEF"; }

.mdi-credit-card-check::before {
  content: "\\F13D0"; }

.mdi-credit-card-check-outline::before {
  content: "\\F13D1"; }

.mdi-credit-card-chip::before {
  content: "\\F190F"; }

.mdi-credit-card-chip-outline::before {
  content: "\\F1910"; }

.mdi-credit-card-clock::before {
  content: "\\F0EE1"; }

.mdi-credit-card-clock-outline::before {
  content: "\\F0EE2"; }

.mdi-credit-card-edit::before {
  content: "\\F17D7"; }

.mdi-credit-card-edit-outline::before {
  content: "\\F17D8"; }

.mdi-credit-card-fast::before {
  content: "\\F1911"; }

.mdi-credit-card-fast-outline::before {
  content: "\\F1912"; }

.mdi-credit-card-lock::before {
  content: "\\F18E7"; }

.mdi-credit-card-lock-outline::before {
  content: "\\F18E8"; }

.mdi-credit-card-marker::before {
  content: "\\F06A8"; }

.mdi-credit-card-marker-outline::before {
  content: "\\F0DBE"; }

.mdi-credit-card-minus::before {
  content: "\\F0FAC"; }

.mdi-credit-card-minus-outline::before {
  content: "\\F0FAD"; }

.mdi-credit-card-multiple::before {
  content: "\\F0FF0"; }

.mdi-credit-card-multiple-outline::before {
  content: "\\F019C"; }

.mdi-credit-card-off::before {
  content: "\\F0FF1"; }

.mdi-credit-card-off-outline::before {
  content: "\\F05E4"; }

.mdi-credit-card-outline::before {
  content: "\\F019B"; }

.mdi-credit-card-plus::before {
  content: "\\F0FF2"; }

.mdi-credit-card-plus-outline::before {
  content: "\\F0676"; }

.mdi-credit-card-refresh::before {
  content: "\\F1645"; }

.mdi-credit-card-refresh-outline::before {
  content: "\\F1646"; }

.mdi-credit-card-refund::before {
  content: "\\F0FF3"; }

.mdi-credit-card-refund-outline::before {
  content: "\\F0AA8"; }

.mdi-credit-card-remove::before {
  content: "\\F0FAE"; }

.mdi-credit-card-remove-outline::before {
  content: "\\F0FAF"; }

.mdi-credit-card-scan::before {
  content: "\\F0FF4"; }

.mdi-credit-card-scan-outline::before {
  content: "\\F019D"; }

.mdi-credit-card-search::before {
  content: "\\F1647"; }

.mdi-credit-card-search-outline::before {
  content: "\\F1648"; }

.mdi-credit-card-settings::before {
  content: "\\F0FF5"; }

.mdi-credit-card-settings-outline::before {
  content: "\\F08D7"; }

.mdi-credit-card-sync::before {
  content: "\\F1649"; }

.mdi-credit-card-sync-outline::before {
  content: "\\F164A"; }

.mdi-credit-card-wireless::before {
  content: "\\F0802"; }

.mdi-credit-card-wireless-off::before {
  content: "\\F057A"; }

.mdi-credit-card-wireless-off-outline::before {
  content: "\\F057B"; }

.mdi-credit-card-wireless-outline::before {
  content: "\\F0D6C"; }

.mdi-cricket::before {
  content: "\\F0D6D"; }

.mdi-crop::before {
  content: "\\F019E"; }

.mdi-crop-free::before {
  content: "\\F019F"; }

.mdi-crop-landscape::before {
  content: "\\F01A0"; }

.mdi-crop-portrait::before {
  content: "\\F01A1"; }

.mdi-crop-rotate::before {
  content: "\\F0696"; }

.mdi-crop-square::before {
  content: "\\F01A2"; }

.mdi-cross::before {
  content: "\\F0953"; }

.mdi-cross-bolnisi::before {
  content: "\\F0CED"; }

.mdi-cross-celtic::before {
  content: "\\F0CF5"; }

.mdi-cross-outline::before {
  content: "\\F0CF6"; }

.mdi-crosshairs::before {
  content: "\\F01A3"; }

.mdi-crosshairs-gps::before {
  content: "\\F01A4"; }

.mdi-crosshairs-off::before {
  content: "\\F0F45"; }

.mdi-crosshairs-question::before {
  content: "\\F1136"; }

.mdi-crowd::before {
  content: "\\F1975"; }

.mdi-crown::before {
  content: "\\F01A5"; }

.mdi-crown-circle::before {
  content: "\\F17DC"; }

.mdi-crown-circle-outline::before {
  content: "\\F17DD"; }

.mdi-crown-outline::before {
  content: "\\F11D0"; }

.mdi-cryengine::before {
  content: "\\F0959"; }

.mdi-crystal-ball::before {
  content: "\\F0B2F"; }

.mdi-cube::before {
  content: "\\F01A6"; }

.mdi-cube-off::before {
  content: "\\F141C"; }

.mdi-cube-off-outline::before {
  content: "\\F141D"; }

.mdi-cube-outline::before {
  content: "\\F01A7"; }

.mdi-cube-scan::before {
  content: "\\F0B84"; }

.mdi-cube-send::before {
  content: "\\F01A8"; }

.mdi-cube-unfolded::before {
  content: "\\F01A9"; }

.mdi-cup::before {
  content: "\\F01AA"; }

.mdi-cup-off::before {
  content: "\\F05E5"; }

.mdi-cup-off-outline::before {
  content: "\\F137D"; }

.mdi-cup-outline::before {
  content: "\\F130F"; }

.mdi-cup-water::before {
  content: "\\F01AB"; }

.mdi-cupboard::before {
  content: "\\F0F46"; }

.mdi-cupboard-outline::before {
  content: "\\F0F47"; }

.mdi-cupcake::before {
  content: "\\F095A"; }

.mdi-curling::before {
  content: "\\F0863"; }

.mdi-currency-bdt::before {
  content: "\\F0864"; }

.mdi-currency-brl::before {
  content: "\\F0B85"; }

.mdi-currency-btc::before {
  content: "\\F01AC"; }

.mdi-currency-cny::before {
  content: "\\F07BA"; }

.mdi-currency-eth::before {
  content: "\\F07BB"; }

.mdi-currency-eur::before {
  content: "\\F01AD"; }

.mdi-currency-eur-off::before {
  content: "\\F1315"; }

.mdi-currency-gbp::before {
  content: "\\F01AE"; }

.mdi-currency-ils::before {
  content: "\\F0C61"; }

.mdi-currency-inr::before {
  content: "\\F01AF"; }

.mdi-currency-jpy::before {
  content: "\\F07BC"; }

.mdi-currency-krw::before {
  content: "\\F07BD"; }

.mdi-currency-kzt::before {
  content: "\\F0865"; }

.mdi-currency-mnt::before {
  content: "\\F1512"; }

.mdi-currency-ngn::before {
  content: "\\F01B0"; }

.mdi-currency-php::before {
  content: "\\F09E6"; }

.mdi-currency-rial::before {
  content: "\\F0E9C"; }

.mdi-currency-rub::before {
  content: "\\F01B1"; }

.mdi-currency-rupee::before {
  content: "\\F1976"; }

.mdi-currency-sign::before {
  content: "\\F07BE"; }

.mdi-currency-try::before {
  content: "\\F01B2"; }

.mdi-currency-twd::before {
  content: "\\F07BF"; }

.mdi-currency-usd::before {
  content: "\\F01C1"; }

.mdi-currency-usd-off::before {
  content: "\\F067A"; }

.mdi-current-ac::before {
  content: "\\F1480"; }

.mdi-current-dc::before {
  content: "\\F095C"; }

.mdi-cursor-default::before {
  content: "\\F01C0"; }

.mdi-cursor-default-click::before {
  content: "\\F0CFD"; }

.mdi-cursor-default-click-outline::before {
  content: "\\F0CFE"; }

.mdi-cursor-default-gesture::before {
  content: "\\F1127"; }

.mdi-cursor-default-gesture-outline::before {
  content: "\\F1128"; }

.mdi-cursor-default-outline::before {
  content: "\\F01BF"; }

.mdi-cursor-move::before {
  content: "\\F01BE"; }

.mdi-cursor-pointer::before {
  content: "\\F01BD"; }

.mdi-cursor-text::before {
  content: "\\F05E7"; }

.mdi-curtains::before {
  content: "\\F1846"; }

.mdi-curtains-closed::before {
  content: "\\F1847"; }

.mdi-cylinder::before {
  content: "\\F194E"; }

.mdi-cylinder-off::before {
  content: "\\F194F"; }

.mdi-dance-ballroom::before {
  content: "\\F15FB"; }

.mdi-dance-pole::before {
  content: "\\F1578"; }

.mdi-data-matrix::before {
  content: "\\F153C"; }

.mdi-data-matrix-edit::before {
  content: "\\F153D"; }

.mdi-data-matrix-minus::before {
  content: "\\F153E"; }

.mdi-data-matrix-plus::before {
  content: "\\F153F"; }

.mdi-data-matrix-remove::before {
  content: "\\F1540"; }

.mdi-data-matrix-scan::before {
  content: "\\F1541"; }

.mdi-database::before {
  content: "\\F01BC"; }

.mdi-database-alert::before {
  content: "\\F163A"; }

.mdi-database-alert-outline::before {
  content: "\\F1624"; }

.mdi-database-arrow-down::before {
  content: "\\F163B"; }

.mdi-database-arrow-down-outline::before {
  content: "\\F1625"; }

.mdi-database-arrow-left::before {
  content: "\\F163C"; }

.mdi-database-arrow-left-outline::before {
  content: "\\F1626"; }

.mdi-database-arrow-right::before {
  content: "\\F163D"; }

.mdi-database-arrow-right-outline::before {
  content: "\\F1627"; }

.mdi-database-arrow-up::before {
  content: "\\F163E"; }

.mdi-database-arrow-up-outline::before {
  content: "\\F1628"; }

.mdi-database-check::before {
  content: "\\F0AA9"; }

.mdi-database-check-outline::before {
  content: "\\F1629"; }

.mdi-database-clock::before {
  content: "\\F163F"; }

.mdi-database-clock-outline::before {
  content: "\\F162A"; }

.mdi-database-cog::before {
  content: "\\F164B"; }

.mdi-database-cog-outline::before {
  content: "\\F164C"; }

.mdi-database-edit::before {
  content: "\\F0B86"; }

.mdi-database-edit-outline::before {
  content: "\\F162B"; }

.mdi-database-export::before {
  content: "\\F095E"; }

.mdi-database-export-outline::before {
  content: "\\F162C"; }

.mdi-database-eye::before {
  content: "\\F191F"; }

.mdi-database-eye-off::before {
  content: "\\F1920"; }

.mdi-database-eye-off-outline::before {
  content: "\\F1921"; }

.mdi-database-eye-outline::before {
  content: "\\F1922"; }

.mdi-database-import::before {
  content: "\\F095D"; }

.mdi-database-import-outline::before {
  content: "\\F162D"; }

.mdi-database-lock::before {
  content: "\\F0AAA"; }

.mdi-database-lock-outline::before {
  content: "\\F162E"; }

.mdi-database-marker::before {
  content: "\\F12F6"; }

.mdi-database-marker-outline::before {
  content: "\\F162F"; }

.mdi-database-minus::before {
  content: "\\F01BB"; }

.mdi-database-minus-outline::before {
  content: "\\F1630"; }

.mdi-database-off::before {
  content: "\\F1640"; }

.mdi-database-off-outline::before {
  content: "\\F1631"; }

.mdi-database-outline::before {
  content: "\\F1632"; }

.mdi-database-plus::before {
  content: "\\F01BA"; }

.mdi-database-plus-outline::before {
  content: "\\F1633"; }

.mdi-database-refresh::before {
  content: "\\F05C2"; }

.mdi-database-refresh-outline::before {
  content: "\\F1634"; }

.mdi-database-remove::before {
  content: "\\F0D00"; }

.mdi-database-remove-outline::before {
  content: "\\F1635"; }

.mdi-database-search::before {
  content: "\\F0866"; }

.mdi-database-search-outline::before {
  content: "\\F1636"; }

.mdi-database-settings::before {
  content: "\\F0D01"; }

.mdi-database-settings-outline::before {
  content: "\\F1637"; }

.mdi-database-sync::before {
  content: "\\F0CFF"; }

.mdi-database-sync-outline::before {
  content: "\\F1638"; }

.mdi-death-star::before {
  content: "\\F08D8"; }

.mdi-death-star-variant::before {
  content: "\\F08D9"; }

.mdi-deathly-hallows::before {
  content: "\\F0B87"; }

.mdi-debian::before {
  content: "\\F08DA"; }

.mdi-debug-step-into::before {
  content: "\\F01B9"; }

.mdi-debug-step-out::before {
  content: "\\F01B8"; }

.mdi-debug-step-over::before {
  content: "\\F01B7"; }

.mdi-decagram::before {
  content: "\\F076C"; }

.mdi-decagram-outline::before {
  content: "\\F076D"; }

.mdi-decimal::before {
  content: "\\F10A1"; }

.mdi-decimal-comma::before {
  content: "\\F10A2"; }

.mdi-decimal-comma-decrease::before {
  content: "\\F10A3"; }

.mdi-decimal-comma-increase::before {
  content: "\\F10A4"; }

.mdi-decimal-decrease::before {
  content: "\\F01B6"; }

.mdi-decimal-increase::before {
  content: "\\F01B5"; }

.mdi-delete::before {
  content: "\\F01B4"; }

.mdi-delete-alert::before {
  content: "\\F10A5"; }

.mdi-delete-alert-outline::before {
  content: "\\F10A6"; }

.mdi-delete-circle::before {
  content: "\\F0683"; }

.mdi-delete-circle-outline::before {
  content: "\\F0B88"; }

.mdi-delete-clock::before {
  content: "\\F1556"; }

.mdi-delete-clock-outline::before {
  content: "\\F1557"; }

.mdi-delete-empty::before {
  content: "\\F06CC"; }

.mdi-delete-empty-outline::before {
  content: "\\F0E9D"; }

.mdi-delete-forever::before {
  content: "\\F05E8"; }

.mdi-delete-forever-outline::before {
  content: "\\F0B89"; }

.mdi-delete-off::before {
  content: "\\F10A7"; }

.mdi-delete-off-outline::before {
  content: "\\F10A8"; }

.mdi-delete-outline::before {
  content: "\\F09E7"; }

.mdi-delete-restore::before {
  content: "\\F0819"; }

.mdi-delete-sweep::before {
  content: "\\F05E9"; }

.mdi-delete-sweep-outline::before {
  content: "\\F0C62"; }

.mdi-delete-variant::before {
  content: "\\F01B3"; }

.mdi-delta::before {
  content: "\\F01C2"; }

.mdi-desk::before {
  content: "\\F1239"; }

.mdi-desk-lamp::before {
  content: "\\F095F"; }

.mdi-deskphone::before {
  content: "\\F01C3"; }

.mdi-desktop-classic::before {
  content: "\\F07C0"; }

.mdi-desktop-mac::before {
  content: "\\F01C4"; }

.mdi-desktop-mac-dashboard::before {
  content: "\\F09E8"; }

.mdi-desktop-tower::before {
  content: "\\F01C5"; }

.mdi-desktop-tower-monitor::before {
  content: "\\F0AAB"; }

.mdi-details::before {
  content: "\\F01C6"; }

.mdi-dev-to::before {
  content: "\\F0D6E"; }

.mdi-developer-board::before {
  content: "\\F0697"; }

.mdi-deviantart::before {
  content: "\\F01C7"; }

.mdi-devices::before {
  content: "\\F0FB0"; }

.mdi-dharmachakra::before {
  content: "\\F094B"; }

.mdi-diabetes::before {
  content: "\\F1126"; }

.mdi-dialpad::before {
  content: "\\F061C"; }

.mdi-diameter::before {
  content: "\\F0C63"; }

.mdi-diameter-outline::before {
  content: "\\F0C64"; }

.mdi-diameter-variant::before {
  content: "\\F0C65"; }

.mdi-diamond::before {
  content: "\\F0B8A"; }

.mdi-diamond-outline::before {
  content: "\\F0B8B"; }

.mdi-diamond-stone::before {
  content: "\\F01C8"; }

.mdi-dice-1::before {
  content: "\\F01CA"; }

.mdi-dice-1-outline::before {
  content: "\\F114A"; }

.mdi-dice-2::before {
  content: "\\F01CB"; }

.mdi-dice-2-outline::before {
  content: "\\F114B"; }

.mdi-dice-3::before {
  content: "\\F01CC"; }

.mdi-dice-3-outline::before {
  content: "\\F114C"; }

.mdi-dice-4::before {
  content: "\\F01CD"; }

.mdi-dice-4-outline::before {
  content: "\\F114D"; }

.mdi-dice-5::before {
  content: "\\F01CE"; }

.mdi-dice-5-outline::before {
  content: "\\F114E"; }

.mdi-dice-6::before {
  content: "\\F01CF"; }

.mdi-dice-6-outline::before {
  content: "\\F114F"; }

.mdi-dice-d10::before {
  content: "\\F1153"; }

.mdi-dice-d10-outline::before {
  content: "\\F076F"; }

.mdi-dice-d12::before {
  content: "\\F1154"; }

.mdi-dice-d12-outline::before {
  content: "\\F0867"; }

.mdi-dice-d20::before {
  content: "\\F1155"; }

.mdi-dice-d20-outline::before {
  content: "\\F05EA"; }

.mdi-dice-d4::before {
  content: "\\F1150"; }

.mdi-dice-d4-outline::before {
  content: "\\F05EB"; }

.mdi-dice-d6::before {
  content: "\\F1151"; }

.mdi-dice-d6-outline::before {
  content: "\\F05ED"; }

.mdi-dice-d8::before {
  content: "\\F1152"; }

.mdi-dice-d8-outline::before {
  content: "\\F05EC"; }

.mdi-dice-multiple::before {
  content: "\\F076E"; }

.mdi-dice-multiple-outline::before {
  content: "\\F1156"; }

.mdi-digital-ocean::before {
  content: "\\F1237"; }

.mdi-dip-switch::before {
  content: "\\F07C1"; }

.mdi-directions::before {
  content: "\\F01D0"; }

.mdi-directions-fork::before {
  content: "\\F0641"; }

.mdi-disc::before {
  content: "\\F05EE"; }

.mdi-disc-alert::before {
  content: "\\F01D1"; }

.mdi-disc-player::before {
  content: "\\F0960"; }

.mdi-discord::before {
  content: "\\F066F"; }

.mdi-dishwasher::before {
  content: "\\F0AAC"; }

.mdi-dishwasher-alert::before {
  content: "\\F11B8"; }

.mdi-dishwasher-off::before {
  content: "\\F11B9"; }

.mdi-disqus::before {
  content: "\\F01D2"; }

.mdi-distribute-horizontal-center::before {
  content: "\\F11C9"; }

.mdi-distribute-horizontal-left::before {
  content: "\\F11C8"; }

.mdi-distribute-horizontal-right::before {
  content: "\\F11CA"; }

.mdi-distribute-vertical-bottom::before {
  content: "\\F11CB"; }

.mdi-distribute-vertical-center::before {
  content: "\\F11CC"; }

.mdi-distribute-vertical-top::before {
  content: "\\F11CD"; }

.mdi-diversify::before {
  content: "\\F1877"; }

.mdi-diving::before {
  content: "\\F1977"; }

.mdi-diving-flippers::before {
  content: "\\F0DBF"; }

.mdi-diving-helmet::before {
  content: "\\F0DC0"; }

.mdi-diving-scuba::before {
  content: "\\F0DC1"; }

.mdi-diving-scuba-flag::before {
  content: "\\F0DC2"; }

.mdi-diving-scuba-tank::before {
  content: "\\F0DC3"; }

.mdi-diving-scuba-tank-multiple::before {
  content: "\\F0DC4"; }

.mdi-diving-snorkel::before {
  content: "\\F0DC5"; }

.mdi-division::before {
  content: "\\F01D4"; }

.mdi-division-box::before {
  content: "\\F01D5"; }

.mdi-dlna::before {
  content: "\\F0A41"; }

.mdi-dna::before {
  content: "\\F0684"; }

.mdi-dns::before {
  content: "\\F01D6"; }

.mdi-dns-outline::before {
  content: "\\F0B8C"; }

.mdi-dock-bottom::before {
  content: "\\F10A9"; }

.mdi-dock-left::before {
  content: "\\F10AA"; }

.mdi-dock-right::before {
  content: "\\F10AB"; }

.mdi-dock-top::before {
  content: "\\F1513"; }

.mdi-dock-window::before {
  content: "\\F10AC"; }

.mdi-docker::before {
  content: "\\F0868"; }

.mdi-doctor::before {
  content: "\\F0A42"; }

.mdi-dog::before {
  content: "\\F0A43"; }

.mdi-dog-service::before {
  content: "\\F0AAD"; }

.mdi-dog-side::before {
  content: "\\F0A44"; }

.mdi-dog-side-off::before {
  content: "\\F16EE"; }

.mdi-dolby::before {
  content: "\\F06B3"; }

.mdi-dolly::before {
  content: "\\F0E9E"; }

.mdi-dolphin::before {
  content: "\\F18B4"; }

.mdi-domain::before {
  content: "\\F01D7"; }

.mdi-domain-off::before {
  content: "\\F0D6F"; }

.mdi-domain-plus::before {
  content: "\\F10AD"; }

.mdi-domain-remove::before {
  content: "\\F10AE"; }

.mdi-dome-light::before {
  content: "\\F141E"; }

.mdi-domino-mask::before {
  content: "\\F1023"; }

.mdi-donkey::before {
  content: "\\F07C2"; }

.mdi-door::before {
  content: "\\F081A"; }

.mdi-door-closed::before {
  content: "\\F081B"; }

.mdi-door-closed-lock::before {
  content: "\\F10AF"; }

.mdi-door-open::before {
  content: "\\F081C"; }

.mdi-door-sliding::before {
  content: "\\F181E"; }

.mdi-door-sliding-lock::before {
  content: "\\F181F"; }

.mdi-door-sliding-open::before {
  content: "\\F1820"; }

.mdi-doorbell::before {
  content: "\\F12E6"; }

.mdi-doorbell-video::before {
  content: "\\F0869"; }

.mdi-dot-net::before {
  content: "\\F0AAE"; }

.mdi-dots-circle::before {
  content: "\\F1978"; }

.mdi-dots-grid::before {
  content: "\\F15FC"; }

.mdi-dots-hexagon::before {
  content: "\\F15FF"; }

.mdi-dots-horizontal::before {
  content: "\\F01D8"; }

.mdi-dots-horizontal-circle::before {
  content: "\\F07C3"; }

.mdi-dots-horizontal-circle-outline::before {
  content: "\\F0B8D"; }

.mdi-dots-square::before {
  content: "\\F15FD"; }

.mdi-dots-triangle::before {
  content: "\\F15FE"; }

.mdi-dots-vertical::before {
  content: "\\F01D9"; }

.mdi-dots-vertical-circle::before {
  content: "\\F07C4"; }

.mdi-dots-vertical-circle-outline::before {
  content: "\\F0B8E"; }

.mdi-download::before {
  content: "\\F01DA"; }

.mdi-download-box::before {
  content: "\\F1462"; }

.mdi-download-box-outline::before {
  content: "\\F1463"; }

.mdi-download-circle::before {
  content: "\\F1464"; }

.mdi-download-circle-outline::before {
  content: "\\F1465"; }

.mdi-download-lock::before {
  content: "\\F1320"; }

.mdi-download-lock-outline::before {
  content: "\\F1321"; }

.mdi-download-multiple::before {
  content: "\\F09E9"; }

.mdi-download-network::before {
  content: "\\F06F4"; }

.mdi-download-network-outline::before {
  content: "\\F0C66"; }

.mdi-download-off::before {
  content: "\\F10B0"; }

.mdi-download-off-outline::before {
  content: "\\F10B1"; }

.mdi-download-outline::before {
  content: "\\F0B8F"; }

.mdi-drag::before {
  content: "\\F01DB"; }

.mdi-drag-horizontal::before {
  content: "\\F01DC"; }

.mdi-drag-horizontal-variant::before {
  content: "\\F12F0"; }

.mdi-drag-variant::before {
  content: "\\F0B90"; }

.mdi-drag-vertical::before {
  content: "\\F01DD"; }

.mdi-drag-vertical-variant::before {
  content: "\\F12F1"; }

.mdi-drama-masks::before {
  content: "\\F0D02"; }

.mdi-draw::before {
  content: "\\F0F49"; }

.mdi-draw-pen::before {
  content: "\\F19B9"; }

.mdi-drawing::before {
  content: "\\F01DE"; }

.mdi-drawing-box::before {
  content: "\\F01DF"; }

.mdi-dresser::before {
  content: "\\F0F4A"; }

.mdi-dresser-outline::before {
  content: "\\F0F4B"; }

.mdi-drone::before {
  content: "\\F01E2"; }

.mdi-dropbox::before {
  content: "\\F01E3"; }

.mdi-drupal::before {
  content: "\\F01E4"; }

.mdi-duck::before {
  content: "\\F01E5"; }

.mdi-dumbbell::before {
  content: "\\F01E6"; }

.mdi-dump-truck::before {
  content: "\\F0C67"; }

.mdi-ear-hearing::before {
  content: "\\F07C5"; }

.mdi-ear-hearing-off::before {
  content: "\\F0A45"; }

.mdi-earbuds::before {
  content: "\\F184F"; }

.mdi-earbuds-off::before {
  content: "\\F1850"; }

.mdi-earbuds-off-outline::before {
  content: "\\F1851"; }

.mdi-earbuds-outline::before {
  content: "\\F1852"; }

.mdi-earth::before {
  content: "\\F01E7"; }

.mdi-earth-arrow-right::before {
  content: "\\F1311"; }

.mdi-earth-box::before {
  content: "\\F06CD"; }

.mdi-earth-box-minus::before {
  content: "\\F1407"; }

.mdi-earth-box-off::before {
  content: "\\F06CE"; }

.mdi-earth-box-plus::before {
  content: "\\F1406"; }

.mdi-earth-box-remove::before {
  content: "\\F1408"; }

.mdi-earth-minus::before {
  content: "\\F1404"; }

.mdi-earth-off::before {
  content: "\\F01E8"; }

.mdi-earth-plus::before {
  content: "\\F1403"; }

.mdi-earth-remove::before {
  content: "\\F1405"; }

.mdi-egg::before {
  content: "\\F0AAF"; }

.mdi-egg-easter::before {
  content: "\\F0AB0"; }

.mdi-egg-fried::before {
  content: "\\F184A"; }

.mdi-egg-off::before {
  content: "\\F13F0"; }

.mdi-egg-off-outline::before {
  content: "\\F13F1"; }

.mdi-egg-outline::before {
  content: "\\F13F2"; }

.mdi-eiffel-tower::before {
  content: "\\F156B"; }

.mdi-eight-track::before {
  content: "\\F09EA"; }

.mdi-eject::before {
  content: "\\F01EA"; }

.mdi-eject-outline::before {
  content: "\\F0B91"; }

.mdi-electric-switch::before {
  content: "\\F0E9F"; }

.mdi-electric-switch-closed::before {
  content: "\\F10D9"; }

.mdi-electron-framework::before {
  content: "\\F1024"; }

.mdi-elephant::before {
  content: "\\F07C6"; }

.mdi-elevation-decline::before {
  content: "\\F01EB"; }

.mdi-elevation-rise::before {
  content: "\\F01EC"; }

.mdi-elevator::before {
  content: "\\F01ED"; }

.mdi-elevator-down::before {
  content: "\\F12C2"; }

.mdi-elevator-passenger::before {
  content: "\\F1381"; }

.mdi-elevator-passenger-off::before {
  content: "\\F1979"; }

.mdi-elevator-passenger-off-outline::before {
  content: "\\F197A"; }

.mdi-elevator-passenger-outline::before {
  content: "\\F197B"; }

.mdi-elevator-up::before {
  content: "\\F12C1"; }

.mdi-ellipse::before {
  content: "\\F0EA0"; }

.mdi-ellipse-outline::before {
  content: "\\F0EA1"; }

.mdi-email::before {
  content: "\\F01EE"; }

.mdi-email-alert::before {
  content: "\\F06CF"; }

.mdi-email-alert-outline::before {
  content: "\\F0D42"; }

.mdi-email-box::before {
  content: "\\F0D03"; }

.mdi-email-check::before {
  content: "\\F0AB1"; }

.mdi-email-check-outline::before {
  content: "\\F0AB2"; }

.mdi-email-edit::before {
  content: "\\F0EE3"; }

.mdi-email-edit-outline::before {
  content: "\\F0EE4"; }

.mdi-email-fast::before {
  content: "\\F186F"; }

.mdi-email-fast-outline::before {
  content: "\\F1870"; }

.mdi-email-lock::before {
  content: "\\F01F1"; }

.mdi-email-mark-as-unread::before {
  content: "\\F0B92"; }

.mdi-email-minus::before {
  content: "\\F0EE5"; }

.mdi-email-minus-outline::before {
  content: "\\F0EE6"; }

.mdi-email-multiple::before {
  content: "\\F0EE7"; }

.mdi-email-multiple-outline::before {
  content: "\\F0EE8"; }

.mdi-email-newsletter::before {
  content: "\\F0FB1"; }

.mdi-email-off::before {
  content: "\\F13E3"; }

.mdi-email-off-outline::before {
  content: "\\F13E4"; }

.mdi-email-open::before {
  content: "\\F01EF"; }

.mdi-email-open-multiple::before {
  content: "\\F0EE9"; }

.mdi-email-open-multiple-outline::before {
  content: "\\F0EEA"; }

.mdi-email-open-outline::before {
  content: "\\F05EF"; }

.mdi-email-outline::before {
  content: "\\F01F0"; }

.mdi-email-plus::before {
  content: "\\F09EB"; }

.mdi-email-plus-outline::before {
  content: "\\F09EC"; }

.mdi-email-receive::before {
  content: "\\F10DA"; }

.mdi-email-receive-outline::before {
  content: "\\F10DB"; }

.mdi-email-remove::before {
  content: "\\F1661"; }

.mdi-email-remove-outline::before {
  content: "\\F1662"; }

.mdi-email-seal::before {
  content: "\\F195B"; }

.mdi-email-seal-outline::before {
  content: "\\F195C"; }

.mdi-email-search::before {
  content: "\\F0961"; }

.mdi-email-search-outline::before {
  content: "\\F0962"; }

.mdi-email-send::before {
  content: "\\F10DC"; }

.mdi-email-send-outline::before {
  content: "\\F10DD"; }

.mdi-email-sync::before {
  content: "\\F12C7"; }

.mdi-email-sync-outline::before {
  content: "\\F12C8"; }

.mdi-email-variant::before {
  content: "\\F05F0"; }

.mdi-ember::before {
  content: "\\F0B30"; }

.mdi-emby::before {
  content: "\\F06B4"; }

.mdi-emoticon::before {
  content: "\\F0C68"; }

.mdi-emoticon-angry::before {
  content: "\\F0C69"; }

.mdi-emoticon-angry-outline::before {
  content: "\\F0C6A"; }

.mdi-emoticon-confused::before {
  content: "\\F10DE"; }

.mdi-emoticon-confused-outline::before {
  content: "\\F10DF"; }

.mdi-emoticon-cool::before {
  content: "\\F0C6B"; }

.mdi-emoticon-cool-outline::before {
  content: "\\F01F3"; }

.mdi-emoticon-cry::before {
  content: "\\F0C6C"; }

.mdi-emoticon-cry-outline::before {
  content: "\\F0C6D"; }

.mdi-emoticon-dead::before {
  content: "\\F0C6E"; }

.mdi-emoticon-dead-outline::before {
  content: "\\F069B"; }

.mdi-emoticon-devil::before {
  content: "\\F0C6F"; }

.mdi-emoticon-devil-outline::before {
  content: "\\F01F4"; }

.mdi-emoticon-excited::before {
  content: "\\F0C70"; }

.mdi-emoticon-excited-outline::before {
  content: "\\F069C"; }

.mdi-emoticon-frown::before {
  content: "\\F0F4C"; }

.mdi-emoticon-frown-outline::before {
  content: "\\F0F4D"; }

.mdi-emoticon-happy::before {
  content: "\\F0C71"; }

.mdi-emoticon-happy-outline::before {
  content: "\\F01F5"; }

.mdi-emoticon-kiss::before {
  content: "\\F0C72"; }

.mdi-emoticon-kiss-outline::before {
  content: "\\F0C73"; }

.mdi-emoticon-lol::before {
  content: "\\F1214"; }

.mdi-emoticon-lol-outline::before {
  content: "\\F1215"; }

.mdi-emoticon-neutral::before {
  content: "\\F0C74"; }

.mdi-emoticon-neutral-outline::before {
  content: "\\F01F6"; }

.mdi-emoticon-outline::before {
  content: "\\F01F2"; }

.mdi-emoticon-poop::before {
  content: "\\F01F7"; }

.mdi-emoticon-poop-outline::before {
  content: "\\F0C75"; }

.mdi-emoticon-sad::before {
  content: "\\F0C76"; }

.mdi-emoticon-sad-outline::before {
  content: "\\F01F8"; }

.mdi-emoticon-sick::before {
  content: "\\F157C"; }

.mdi-emoticon-sick-outline::before {
  content: "\\F157D"; }

.mdi-emoticon-tongue::before {
  content: "\\F01F9"; }

.mdi-emoticon-tongue-outline::before {
  content: "\\F0C77"; }

.mdi-emoticon-wink::before {
  content: "\\F0C78"; }

.mdi-emoticon-wink-outline::before {
  content: "\\F0C79"; }

.mdi-engine::before {
  content: "\\F01FA"; }

.mdi-engine-off::before {
  content: "\\F0A46"; }

.mdi-engine-off-outline::before {
  content: "\\F0A47"; }

.mdi-engine-outline::before {
  content: "\\F01FB"; }

.mdi-epsilon::before {
  content: "\\F10E0"; }

.mdi-equal::before {
  content: "\\F01FC"; }

.mdi-equal-box::before {
  content: "\\F01FD"; }

.mdi-equalizer::before {
  content: "\\F0EA2"; }

.mdi-equalizer-outline::before {
  content: "\\F0EA3"; }

.mdi-eraser::before {
  content: "\\F01FE"; }

.mdi-eraser-variant::before {
  content: "\\F0642"; }

.mdi-escalator::before {
  content: "\\F01FF"; }

.mdi-escalator-box::before {
  content: "\\F1399"; }

.mdi-escalator-down::before {
  content: "\\F12C0"; }

.mdi-escalator-up::before {
  content: "\\F12BF"; }

.mdi-eslint::before {
  content: "\\F0C7A"; }

.mdi-et::before {
  content: "\\F0AB3"; }

.mdi-ethereum::before {
  content: "\\F086A"; }

.mdi-ethernet::before {
  content: "\\F0200"; }

.mdi-ethernet-cable::before {
  content: "\\F0201"; }

.mdi-ethernet-cable-off::before {
  content: "\\F0202"; }

.mdi-ev-plug-ccs1::before {
  content: "\\F1519"; }

.mdi-ev-plug-ccs2::before {
  content: "\\F151A"; }

.mdi-ev-plug-chademo::before {
  content: "\\F151B"; }

.mdi-ev-plug-tesla::before {
  content: "\\F151C"; }

.mdi-ev-plug-type1::before {
  content: "\\F151D"; }

.mdi-ev-plug-type2::before {
  content: "\\F151E"; }

.mdi-ev-station::before {
  content: "\\F05F1"; }

.mdi-evernote::before {
  content: "\\F0204"; }

.mdi-excavator::before {
  content: "\\F1025"; }

.mdi-exclamation::before {
  content: "\\F0205"; }

.mdi-exclamation-thick::before {
  content: "\\F1238"; }

.mdi-exit-run::before {
  content: "\\F0A48"; }

.mdi-exit-to-app::before {
  content: "\\F0206"; }

.mdi-expand-all::before {
  content: "\\F0AB4"; }

.mdi-expand-all-outline::before {
  content: "\\F0AB5"; }

.mdi-expansion-card::before {
  content: "\\F08AE"; }

.mdi-expansion-card-variant::before {
  content: "\\F0FB2"; }

.mdi-exponent::before {
  content: "\\F0963"; }

.mdi-exponent-box::before {
  content: "\\F0964"; }

.mdi-export::before {
  content: "\\F0207"; }

.mdi-export-variant::before {
  content: "\\F0B93"; }

.mdi-eye::before {
  content: "\\F0208"; }

.mdi-eye-arrow-left::before {
  content: "\\F18FD"; }

.mdi-eye-arrow-left-outline::before {
  content: "\\F18FE"; }

.mdi-eye-arrow-right::before {
  content: "\\F18FF"; }

.mdi-eye-arrow-right-outline::before {
  content: "\\F1900"; }

.mdi-eye-check::before {
  content: "\\F0D04"; }

.mdi-eye-check-outline::before {
  content: "\\F0D05"; }

.mdi-eye-circle::before {
  content: "\\F0B94"; }

.mdi-eye-circle-outline::before {
  content: "\\F0B95"; }

.mdi-eye-minus::before {
  content: "\\F1026"; }

.mdi-eye-minus-outline::before {
  content: "\\F1027"; }

.mdi-eye-off::before {
  content: "\\F0209"; }

.mdi-eye-off-outline::before {
  content: "\\F06D1"; }

.mdi-eye-outline::before {
  content: "\\F06D0"; }

.mdi-eye-plus::before {
  content: "\\F086B"; }

.mdi-eye-plus-outline::before {
  content: "\\F086C"; }

.mdi-eye-refresh::before {
  content: "\\F197C"; }

.mdi-eye-refresh-outline::before {
  content: "\\F197D"; }

.mdi-eye-remove::before {
  content: "\\F15E3"; }

.mdi-eye-remove-outline::before {
  content: "\\F15E4"; }

.mdi-eye-settings::before {
  content: "\\F086D"; }

.mdi-eye-settings-outline::before {
  content: "\\F086E"; }

.mdi-eyedropper::before {
  content: "\\F020A"; }

.mdi-eyedropper-minus::before {
  content: "\\F13DD"; }

.mdi-eyedropper-off::before {
  content: "\\F13DF"; }

.mdi-eyedropper-plus::before {
  content: "\\F13DC"; }

.mdi-eyedropper-remove::before {
  content: "\\F13DE"; }

.mdi-eyedropper-variant::before {
  content: "\\F020B"; }

.mdi-face-agent::before {
  content: "\\F0D70"; }

.mdi-face-man::before {
  content: "\\F0643"; }

.mdi-face-man-outline::before {
  content: "\\F0B96"; }

.mdi-face-man-profile::before {
  content: "\\F0644"; }

.mdi-face-man-shimmer::before {
  content: "\\F15CC"; }

.mdi-face-man-shimmer-outline::before {
  content: "\\F15CD"; }

.mdi-face-mask::before {
  content: "\\F1586"; }

.mdi-face-mask-outline::before {
  content: "\\F1587"; }

.mdi-face-recognition::before {
  content: "\\F0C7B"; }

.mdi-face-woman::before {
  content: "\\F1077"; }

.mdi-face-woman-outline::before {
  content: "\\F1078"; }

.mdi-face-woman-profile::before {
  content: "\\F1076"; }

.mdi-face-woman-shimmer::before {
  content: "\\F15CE"; }

.mdi-face-woman-shimmer-outline::before {
  content: "\\F15CF"; }

.mdi-facebook::before {
  content: "\\F020C"; }

.mdi-facebook-gaming::before {
  content: "\\F07DD"; }

.mdi-facebook-messenger::before {
  content: "\\F020E"; }

.mdi-facebook-workplace::before {
  content: "\\F0B31"; }

.mdi-factory::before {
  content: "\\F020F"; }

.mdi-family-tree::before {
  content: "\\F160E"; }

.mdi-fan::before {
  content: "\\F0210"; }

.mdi-fan-alert::before {
  content: "\\F146C"; }

.mdi-fan-auto::before {
  content: "\\F171D"; }

.mdi-fan-chevron-down::before {
  content: "\\F146D"; }

.mdi-fan-chevron-up::before {
  content: "\\F146E"; }

.mdi-fan-minus::before {
  content: "\\F1470"; }

.mdi-fan-off::before {
  content: "\\F081D"; }

.mdi-fan-plus::before {
  content: "\\F146F"; }

.mdi-fan-remove::before {
  content: "\\F1471"; }

.mdi-fan-speed-1::before {
  content: "\\F1472"; }

.mdi-fan-speed-2::before {
  content: "\\F1473"; }

.mdi-fan-speed-3::before {
  content: "\\F1474"; }

.mdi-fast-forward::before {
  content: "\\F0211"; }

.mdi-fast-forward-10::before {
  content: "\\F0D71"; }

.mdi-fast-forward-15::before {
  content: "\\F193A"; }

.mdi-fast-forward-30::before {
  content: "\\F0D06"; }

.mdi-fast-forward-5::before {
  content: "\\F11F8"; }

.mdi-fast-forward-60::before {
  content: "\\F160B"; }

.mdi-fast-forward-outline::before {
  content: "\\F06D2"; }

.mdi-fax::before {
  content: "\\F0212"; }

.mdi-feather::before {
  content: "\\F06D3"; }

.mdi-feature-search::before {
  content: "\\F0A49"; }

.mdi-feature-search-outline::before {
  content: "\\F0A4A"; }

.mdi-fedora::before {
  content: "\\F08DB"; }

.mdi-fence::before {
  content: "\\F179A"; }

.mdi-fence-electric::before {
  content: "\\F17F6"; }

.mdi-fencing::before {
  content: "\\F14C1"; }

.mdi-ferris-wheel::before {
  content: "\\F0EA4"; }

.mdi-ferry::before {
  content: "\\F0213"; }

.mdi-file::before {
  content: "\\F0214"; }

.mdi-file-account::before {
  content: "\\F073B"; }

.mdi-file-account-outline::before {
  content: "\\F1028"; }

.mdi-file-alert::before {
  content: "\\F0A4B"; }

.mdi-file-alert-outline::before {
  content: "\\F0A4C"; }

.mdi-file-cabinet::before {
  content: "\\F0AB6"; }

.mdi-file-cad::before {
  content: "\\F0EEB"; }

.mdi-file-cad-box::before {
  content: "\\F0EEC"; }

.mdi-file-cancel::before {
  content: "\\F0DC6"; }

.mdi-file-cancel-outline::before {
  content: "\\F0DC7"; }

.mdi-file-certificate::before {
  content: "\\F1186"; }

.mdi-file-certificate-outline::before {
  content: "\\F1187"; }

.mdi-file-chart::before {
  content: "\\F0215"; }

.mdi-file-chart-outline::before {
  content: "\\F1029"; }

.mdi-file-check::before {
  content: "\\F0216"; }

.mdi-file-check-outline::before {
  content: "\\F0E29"; }

.mdi-file-clock::before {
  content: "\\F12E1"; }

.mdi-file-clock-outline::before {
  content: "\\F12E2"; }

.mdi-file-cloud::before {
  content: "\\F0217"; }

.mdi-file-cloud-outline::before {
  content: "\\F102A"; }

.mdi-file-code::before {
  content: "\\F022E"; }

.mdi-file-code-outline::before {
  content: "\\F102B"; }

.mdi-file-cog::before {
  content: "\\F107B"; }

.mdi-file-cog-outline::before {
  content: "\\F107C"; }

.mdi-file-compare::before {
  content: "\\F08AA"; }

.mdi-file-delimited::before {
  content: "\\F0218"; }

.mdi-file-delimited-outline::before {
  content: "\\F0EA5"; }

.mdi-file-document::before {
  content: "\\F0219"; }

.mdi-file-document-edit::before {
  content: "\\F0DC8"; }

.mdi-file-document-edit-outline::before {
  content: "\\F0DC9"; }

.mdi-file-document-multiple::before {
  content: "\\F1517"; }

.mdi-file-document-multiple-outline::before {
  content: "\\F1518"; }

.mdi-file-document-outline::before {
  content: "\\F09EE"; }

.mdi-file-download::before {
  content: "\\F0965"; }

.mdi-file-download-outline::before {
  content: "\\F0966"; }

.mdi-file-edit::before {
  content: "\\F11E7"; }

.mdi-file-edit-outline::before {
  content: "\\F11E8"; }

.mdi-file-excel::before {
  content: "\\F021B"; }

.mdi-file-excel-box::before {
  content: "\\F021C"; }

.mdi-file-excel-box-outline::before {
  content: "\\F102C"; }

.mdi-file-excel-outline::before {
  content: "\\F102D"; }

.mdi-file-export::before {
  content: "\\F021D"; }

.mdi-file-export-outline::before {
  content: "\\F102E"; }

.mdi-file-eye::before {
  content: "\\F0DCA"; }

.mdi-file-eye-outline::before {
  content: "\\F0DCB"; }

.mdi-file-find::before {
  content: "\\F021E"; }

.mdi-file-find-outline::before {
  content: "\\F0B97"; }

.mdi-file-gif-box::before {
  content: "\\F0D78"; }

.mdi-file-hidden::before {
  content: "\\F0613"; }

.mdi-file-image::before {
  content: "\\F021F"; }

.mdi-file-image-marker::before {
  content: "\\F1772"; }

.mdi-file-image-marker-outline::before {
  content: "\\F1773"; }

.mdi-file-image-minus::before {
  content: "\\F193B"; }

.mdi-file-image-minus-outline::before {
  content: "\\F193C"; }

.mdi-file-image-outline::before {
  content: "\\F0EB0"; }

.mdi-file-image-plus::before {
  content: "\\F193D"; }

.mdi-file-image-plus-outline::before {
  content: "\\F193E"; }

.mdi-file-image-remove::before {
  content: "\\F193F"; }

.mdi-file-image-remove-outline::before {
  content: "\\F1940"; }

.mdi-file-import::before {
  content: "\\F0220"; }

.mdi-file-import-outline::before {
  content: "\\F102F"; }

.mdi-file-jpg-box::before {
  content: "\\F0225"; }

.mdi-file-key::before {
  content: "\\F1184"; }

.mdi-file-key-outline::before {
  content: "\\F1185"; }

.mdi-file-link::before {
  content: "\\F1177"; }

.mdi-file-link-outline::before {
  content: "\\F1178"; }

.mdi-file-lock::before {
  content: "\\F0221"; }

.mdi-file-lock-outline::before {
  content: "\\F1030"; }

.mdi-file-marker::before {
  content: "\\F1774"; }

.mdi-file-marker-outline::before {
  content: "\\F1775"; }

.mdi-file-move::before {
  content: "\\F0AB9"; }

.mdi-file-move-outline::before {
  content: "\\F1031"; }

.mdi-file-multiple::before {
  content: "\\F0222"; }

.mdi-file-multiple-outline::before {
  content: "\\F1032"; }

.mdi-file-music::before {
  content: "\\F0223"; }

.mdi-file-music-outline::before {
  content: "\\F0E2A"; }

.mdi-file-outline::before {
  content: "\\F0224"; }

.mdi-file-pdf-box::before {
  content: "\\F0226"; }

.mdi-file-percent::before {
  content: "\\F081E"; }

.mdi-file-percent-outline::before {
  content: "\\F1033"; }

.mdi-file-phone::before {
  content: "\\F1179"; }

.mdi-file-phone-outline::before {
  content: "\\F117A"; }

.mdi-file-plus::before {
  content: "\\F0752"; }

.mdi-file-plus-outline::before {
  content: "\\F0EED"; }

.mdi-file-png-box::before {
  content: "\\F0E2D"; }

.mdi-file-powerpoint::before {
  content: "\\F0227"; }

.mdi-file-powerpoint-box::before {
  content: "\\F0228"; }

.mdi-file-powerpoint-box-outline::before {
  content: "\\F1034"; }

.mdi-file-powerpoint-outline::before {
  content: "\\F1035"; }

.mdi-file-presentation-box::before {
  content: "\\F0229"; }

.mdi-file-question::before {
  content: "\\F086F"; }

.mdi-file-question-outline::before {
  content: "\\F1036"; }

.mdi-file-refresh::before {
  content: "\\F0918"; }

.mdi-file-refresh-outline::before {
  content: "\\F0541"; }

.mdi-file-remove::before {
  content: "\\F0B98"; }

.mdi-file-remove-outline::before {
  content: "\\F1037"; }

.mdi-file-replace::before {
  content: "\\F0B32"; }

.mdi-file-replace-outline::before {
  content: "\\F0B33"; }

.mdi-file-restore::before {
  content: "\\F0670"; }

.mdi-file-restore-outline::before {
  content: "\\F1038"; }

.mdi-file-search::before {
  content: "\\F0C7C"; }

.mdi-file-search-outline::before {
  content: "\\F0C7D"; }

.mdi-file-send::before {
  content: "\\F022A"; }

.mdi-file-send-outline::before {
  content: "\\F1039"; }

.mdi-file-settings::before {
  content: "\\F1079"; }

.mdi-file-settings-outline::before {
  content: "\\F107A"; }

.mdi-file-sign::before {
  content: "\\F19C3"; }

.mdi-file-star::before {
  content: "\\F103A"; }

.mdi-file-star-outline::before {
  content: "\\F103B"; }

.mdi-file-swap::before {
  content: "\\F0FB4"; }

.mdi-file-swap-outline::before {
  content: "\\F0FB5"; }

.mdi-file-sync::before {
  content: "\\F1216"; }

.mdi-file-sync-outline::before {
  content: "\\F1217"; }

.mdi-file-table::before {
  content: "\\F0C7E"; }

.mdi-file-table-box::before {
  content: "\\F10E1"; }

.mdi-file-table-box-multiple::before {
  content: "\\F10E2"; }

.mdi-file-table-box-multiple-outline::before {
  content: "\\F10E3"; }

.mdi-file-table-box-outline::before {
  content: "\\F10E4"; }

.mdi-file-table-outline::before {
  content: "\\F0C7F"; }

.mdi-file-tree::before {
  content: "\\F0645"; }

.mdi-file-tree-outline::before {
  content: "\\F13D2"; }

.mdi-file-undo::before {
  content: "\\F08DC"; }

.mdi-file-undo-outline::before {
  content: "\\F103C"; }

.mdi-file-upload::before {
  content: "\\F0A4D"; }

.mdi-file-upload-outline::before {
  content: "\\F0A4E"; }

.mdi-file-video::before {
  content: "\\F022B"; }

.mdi-file-video-outline::before {
  content: "\\F0E2C"; }

.mdi-file-word::before {
  content: "\\F022C"; }

.mdi-file-word-box::before {
  content: "\\F022D"; }

.mdi-file-word-box-outline::before {
  content: "\\F103D"; }

.mdi-file-word-outline::before {
  content: "\\F103E"; }

.mdi-film::before {
  content: "\\F022F"; }

.mdi-filmstrip::before {
  content: "\\F0230"; }

.mdi-filmstrip-box::before {
  content: "\\F0332"; }

.mdi-filmstrip-box-multiple::before {
  content: "\\F0D18"; }

.mdi-filmstrip-off::before {
  content: "\\F0231"; }

.mdi-filter::before {
  content: "\\F0232"; }

.mdi-filter-check::before {
  content: "\\F18EC"; }

.mdi-filter-check-outline::before {
  content: "\\F18ED"; }

.mdi-filter-menu::before {
  content: "\\F10E5"; }

.mdi-filter-menu-outline::before {
  content: "\\F10E6"; }

.mdi-filter-minus::before {
  content: "\\F0EEE"; }

.mdi-filter-minus-outline::before {
  content: "\\F0EEF"; }

.mdi-filter-off::before {
  content: "\\F14EF"; }

.mdi-filter-off-outline::before {
  content: "\\F14F0"; }

.mdi-filter-outline::before {
  content: "\\F0233"; }

.mdi-filter-plus::before {
  content: "\\F0EF0"; }

.mdi-filter-plus-outline::before {
  content: "\\F0EF1"; }

.mdi-filter-remove::before {
  content: "\\F0234"; }

.mdi-filter-remove-outline::before {
  content: "\\F0235"; }

.mdi-filter-variant::before {
  content: "\\F0236"; }

.mdi-filter-variant-minus::before {
  content: "\\F1112"; }

.mdi-filter-variant-plus::before {
  content: "\\F1113"; }

.mdi-filter-variant-remove::before {
  content: "\\F103F"; }

.mdi-finance::before {
  content: "\\F081F"; }

.mdi-find-replace::before {
  content: "\\F06D4"; }

.mdi-fingerprint::before {
  content: "\\F0237"; }

.mdi-fingerprint-off::before {
  content: "\\F0EB1"; }

.mdi-fire::before {
  content: "\\F0238"; }

.mdi-fire-alert::before {
  content: "\\F15D7"; }

.mdi-fire-circle::before {
  content: "\\F1807"; }

.mdi-fire-extinguisher::before {
  content: "\\F0EF2"; }

.mdi-fire-hydrant::before {
  content: "\\F1137"; }

.mdi-fire-hydrant-alert::before {
  content: "\\F1138"; }

.mdi-fire-hydrant-off::before {
  content: "\\F1139"; }

.mdi-fire-off::before {
  content: "\\F1722"; }

.mdi-fire-truck::before {
  content: "\\F08AB"; }

.mdi-firebase::before {
  content: "\\F0967"; }

.mdi-firefox::before {
  content: "\\F0239"; }

.mdi-fireplace::before {
  content: "\\F0E2E"; }

.mdi-fireplace-off::before {
  content: "\\F0E2F"; }

.mdi-firewire::before {
  content: "\\F05BE"; }

.mdi-firework::before {
  content: "\\F0E30"; }

.mdi-firework-off::before {
  content: "\\F1723"; }

.mdi-fish::before {
  content: "\\F023A"; }

.mdi-fish-off::before {
  content: "\\F13F3"; }

.mdi-fishbowl::before {
  content: "\\F0EF3"; }

.mdi-fishbowl-outline::before {
  content: "\\F0EF4"; }

.mdi-fit-to-page::before {
  content: "\\F0EF5"; }

.mdi-fit-to-page-outline::before {
  content: "\\F0EF6"; }

.mdi-fit-to-screen::before {
  content: "\\F18F4"; }

.mdi-fit-to-screen-outline::before {
  content: "\\F18F5"; }

.mdi-flag::before {
  content: "\\F023B"; }

.mdi-flag-checkered::before {
  content: "\\F023C"; }

.mdi-flag-minus::before {
  content: "\\F0B99"; }

.mdi-flag-minus-outline::before {
  content: "\\F10B2"; }

.mdi-flag-off::before {
  content: "\\F18EE"; }

.mdi-flag-off-outline::before {
  content: "\\F18EF"; }

.mdi-flag-outline::before {
  content: "\\F023D"; }

.mdi-flag-plus::before {
  content: "\\F0B9A"; }

.mdi-flag-plus-outline::before {
  content: "\\F10B3"; }

.mdi-flag-remove::before {
  content: "\\F0B9B"; }

.mdi-flag-remove-outline::before {
  content: "\\F10B4"; }

.mdi-flag-triangle::before {
  content: "\\F023F"; }

.mdi-flag-variant::before {
  content: "\\F0240"; }

.mdi-flag-variant-outline::before {
  content: "\\F023E"; }

.mdi-flare::before {
  content: "\\F0D72"; }

.mdi-flash::before {
  content: "\\F0241"; }

.mdi-flash-alert::before {
  content: "\\F0EF7"; }

.mdi-flash-alert-outline::before {
  content: "\\F0EF8"; }

.mdi-flash-auto::before {
  content: "\\F0242"; }

.mdi-flash-off::before {
  content: "\\F0243"; }

.mdi-flash-outline::before {
  content: "\\F06D5"; }

.mdi-flash-red-eye::before {
  content: "\\F067B"; }

.mdi-flashlight::before {
  content: "\\F0244"; }

.mdi-flashlight-off::before {
  content: "\\F0245"; }

.mdi-flask::before {
  content: "\\F0093"; }

.mdi-flask-empty::before {
  content: "\\F0094"; }

.mdi-flask-empty-minus::before {
  content: "\\F123A"; }

.mdi-flask-empty-minus-outline::before {
  content: "\\F123B"; }

.mdi-flask-empty-off::before {
  content: "\\F13F4"; }

.mdi-flask-empty-off-outline::before {
  content: "\\F13F5"; }

.mdi-flask-empty-outline::before {
  content: "\\F0095"; }

.mdi-flask-empty-plus::before {
  content: "\\F123C"; }

.mdi-flask-empty-plus-outline::before {
  content: "\\F123D"; }

.mdi-flask-empty-remove::before {
  content: "\\F123E"; }

.mdi-flask-empty-remove-outline::before {
  content: "\\F123F"; }

.mdi-flask-minus::before {
  content: "\\F1240"; }

.mdi-flask-minus-outline::before {
  content: "\\F1241"; }

.mdi-flask-off::before {
  content: "\\F13F6"; }

.mdi-flask-off-outline::before {
  content: "\\F13F7"; }

.mdi-flask-outline::before {
  content: "\\F0096"; }

.mdi-flask-plus::before {
  content: "\\F1242"; }

.mdi-flask-plus-outline::before {
  content: "\\F1243"; }

.mdi-flask-remove::before {
  content: "\\F1244"; }

.mdi-flask-remove-outline::before {
  content: "\\F1245"; }

.mdi-flask-round-bottom::before {
  content: "\\F124B"; }

.mdi-flask-round-bottom-empty::before {
  content: "\\F124C"; }

.mdi-flask-round-bottom-empty-outline::before {
  content: "\\F124D"; }

.mdi-flask-round-bottom-outline::before {
  content: "\\F124E"; }

.mdi-fleur-de-lis::before {
  content: "\\F1303"; }

.mdi-flip-horizontal::before {
  content: "\\F10E7"; }

.mdi-flip-to-back::before {
  content: "\\F0247"; }

.mdi-flip-to-front::before {
  content: "\\F0248"; }

.mdi-flip-vertical::before {
  content: "\\F10E8"; }

.mdi-floor-lamp::before {
  content: "\\F08DD"; }

.mdi-floor-lamp-dual::before {
  content: "\\F1040"; }

.mdi-floor-lamp-dual-outline::before {
  content: "\\F17CE"; }

.mdi-floor-lamp-outline::before {
  content: "\\F17C8"; }

.mdi-floor-lamp-torchiere::before {
  content: "\\F1747"; }

.mdi-floor-lamp-torchiere-outline::before {
  content: "\\F17D6"; }

.mdi-floor-lamp-torchiere-variant::before {
  content: "\\F1041"; }

.mdi-floor-lamp-torchiere-variant-outline::before {
  content: "\\F17CF"; }

.mdi-floor-plan::before {
  content: "\\F0821"; }

.mdi-floppy::before {
  content: "\\F0249"; }

.mdi-floppy-variant::before {
  content: "\\F09EF"; }

.mdi-flower::before {
  content: "\\F024A"; }

.mdi-flower-outline::before {
  content: "\\F09F0"; }

.mdi-flower-pollen::before {
  content: "\\F1885"; }

.mdi-flower-pollen-outline::before {
  content: "\\F1886"; }

.mdi-flower-poppy::before {
  content: "\\F0D08"; }

.mdi-flower-tulip::before {
  content: "\\F09F1"; }

.mdi-flower-tulip-outline::before {
  content: "\\F09F2"; }

.mdi-focus-auto::before {
  content: "\\F0F4E"; }

.mdi-focus-field::before {
  content: "\\F0F4F"; }

.mdi-focus-field-horizontal::before {
  content: "\\F0F50"; }

.mdi-focus-field-vertical::before {
  content: "\\F0F51"; }

.mdi-folder::before {
  content: "\\F024B"; }

.mdi-folder-account::before {
  content: "\\F024C"; }

.mdi-folder-account-outline::before {
  content: "\\F0B9C"; }

.mdi-folder-alert::before {
  content: "\\F0DCC"; }

.mdi-folder-alert-outline::before {
  content: "\\F0DCD"; }

.mdi-folder-check::before {
  content: "\\F197E"; }

.mdi-folder-check-outline::before {
  content: "\\F197F"; }

.mdi-folder-clock::before {
  content: "\\F0ABA"; }

.mdi-folder-clock-outline::before {
  content: "\\F0ABB"; }

.mdi-folder-cog::before {
  content: "\\F107F"; }

.mdi-folder-cog-outline::before {
  content: "\\F1080"; }

.mdi-folder-download::before {
  content: "\\F024D"; }

.mdi-folder-download-outline::before {
  content: "\\F10E9"; }

.mdi-folder-edit::before {
  content: "\\F08DE"; }

.mdi-folder-edit-outline::before {
  content: "\\F0DCE"; }

.mdi-folder-eye::before {
  content: "\\F178A"; }

.mdi-folder-eye-outline::before {
  content: "\\F178B"; }

.mdi-folder-google-drive::before {
  content: "\\F024E"; }

.mdi-folder-heart::before {
  content: "\\F10EA"; }

.mdi-folder-heart-outline::before {
  content: "\\F10EB"; }

.mdi-folder-hidden::before {
  content: "\\F179E"; }

.mdi-folder-home::before {
  content: "\\F10B5"; }

.mdi-folder-home-outline::before {
  content: "\\F10B6"; }

.mdi-folder-image::before {
  content: "\\F024F"; }

.mdi-folder-information::before {
  content: "\\F10B7"; }

.mdi-folder-information-outline::before {
  content: "\\F10B8"; }

.mdi-folder-key::before {
  content: "\\F08AC"; }

.mdi-folder-key-network::before {
  content: "\\F08AD"; }

.mdi-folder-key-network-outline::before {
  content: "\\F0C80"; }

.mdi-folder-key-outline::before {
  content: "\\F10EC"; }

.mdi-folder-lock::before {
  content: "\\F0250"; }

.mdi-folder-lock-open::before {
  content: "\\F0251"; }

.mdi-folder-marker::before {
  content: "\\F126D"; }

.mdi-folder-marker-outline::before {
  content: "\\F126E"; }

.mdi-folder-move::before {
  content: "\\F0252"; }

.mdi-folder-move-outline::before {
  content: "\\F1246"; }

.mdi-folder-multiple::before {
  content: "\\F0253"; }

.mdi-folder-multiple-image::before {
  content: "\\F0254"; }

.mdi-folder-multiple-outline::before {
  content: "\\F0255"; }

.mdi-folder-multiple-plus::before {
  content: "\\F147E"; }

.mdi-folder-multiple-plus-outline::before {
  content: "\\F147F"; }

.mdi-folder-music::before {
  content: "\\F1359"; }

.mdi-folder-music-outline::before {
  content: "\\F135A"; }

.mdi-folder-network::before {
  content: "\\F0870"; }

.mdi-folder-network-outline::before {
  content: "\\F0C81"; }

.mdi-folder-open::before {
  content: "\\F0770"; }

.mdi-folder-open-outline::before {
  content: "\\F0DCF"; }

.mdi-folder-outline::before {
  content: "\\F0256"; }

.mdi-folder-plus::before {
  content: "\\F0257"; }

.mdi-folder-plus-outline::before {
  content: "\\F0B9D"; }

.mdi-folder-pound::before {
  content: "\\F0D09"; }

.mdi-folder-pound-outline::before {
  content: "\\F0D0A"; }

.mdi-folder-refresh::before {
  content: "\\F0749"; }

.mdi-folder-refresh-outline::before {
  content: "\\F0542"; }

.mdi-folder-remove::before {
  content: "\\F0258"; }

.mdi-folder-remove-outline::before {
  content: "\\F0B9E"; }

.mdi-folder-search::before {
  content: "\\F0968"; }

.mdi-folder-search-outline::before {
  content: "\\F0969"; }

.mdi-folder-settings::before {
  content: "\\F107D"; }

.mdi-folder-settings-outline::before {
  content: "\\F107E"; }

.mdi-folder-star::before {
  content: "\\F069D"; }

.mdi-folder-star-multiple::before {
  content: "\\F13D3"; }

.mdi-folder-star-multiple-outline::before {
  content: "\\F13D4"; }

.mdi-folder-star-outline::before {
  content: "\\F0B9F"; }

.mdi-folder-swap::before {
  content: "\\F0FB6"; }

.mdi-folder-swap-outline::before {
  content: "\\F0FB7"; }

.mdi-folder-sync::before {
  content: "\\F0D0B"; }

.mdi-folder-sync-outline::before {
  content: "\\F0D0C"; }

.mdi-folder-table::before {
  content: "\\F12E3"; }

.mdi-folder-table-outline::before {
  content: "\\F12E4"; }

.mdi-folder-text::before {
  content: "\\F0C82"; }

.mdi-folder-text-outline::before {
  content: "\\F0C83"; }

.mdi-folder-upload::before {
  content: "\\F0259"; }

.mdi-folder-upload-outline::before {
  content: "\\F10ED"; }

.mdi-folder-zip::before {
  content: "\\F06EB"; }

.mdi-folder-zip-outline::before {
  content: "\\F07B9"; }

.mdi-font-awesome::before {
  content: "\\F003A"; }

.mdi-food::before {
  content: "\\F025A"; }

.mdi-food-apple::before {
  content: "\\F025B"; }

.mdi-food-apple-outline::before {
  content: "\\F0C84"; }

.mdi-food-croissant::before {
  content: "\\F07C8"; }

.mdi-food-drumstick::before {
  content: "\\F141F"; }

.mdi-food-drumstick-off::before {
  content: "\\F1468"; }

.mdi-food-drumstick-off-outline::before {
  content: "\\F1469"; }

.mdi-food-drumstick-outline::before {
  content: "\\F1420"; }

.mdi-food-fork-drink::before {
  content: "\\F05F2"; }

.mdi-food-halal::before {
  content: "\\F1572"; }

.mdi-food-hot-dog::before {
  content: "\\F184B"; }

.mdi-food-kosher::before {
  content: "\\F1573"; }

.mdi-food-off::before {
  content: "\\F05F3"; }

.mdi-food-off-outline::before {
  content: "\\F1915"; }

.mdi-food-outline::before {
  content: "\\F1916"; }

.mdi-food-steak::before {
  content: "\\F146A"; }

.mdi-food-steak-off::before {
  content: "\\F146B"; }

.mdi-food-takeout-box::before {
  content: "\\F1836"; }

.mdi-food-takeout-box-outline::before {
  content: "\\F1837"; }

.mdi-food-turkey::before {
  content: "\\F171C"; }

.mdi-food-variant::before {
  content: "\\F025C"; }

.mdi-food-variant-off::before {
  content: "\\F13E5"; }

.mdi-foot-print::before {
  content: "\\F0F52"; }

.mdi-football::before {
  content: "\\F025D"; }

.mdi-football-australian::before {
  content: "\\F025E"; }

.mdi-football-helmet::before {
  content: "\\F025F"; }

.mdi-forest::before {
  content: "\\F1897"; }

.mdi-forklift::before {
  content: "\\F07C9"; }

.mdi-form-dropdown::before {
  content: "\\F1400"; }

.mdi-form-select::before {
  content: "\\F1401"; }

.mdi-form-textarea::before {
  content: "\\F1095"; }

.mdi-form-textbox::before {
  content: "\\F060E"; }

.mdi-form-textbox-lock::before {
  content: "\\F135D"; }

.mdi-form-textbox-password::before {
  content: "\\F07F5"; }

.mdi-format-align-bottom::before {
  content: "\\F0753"; }

.mdi-format-align-center::before {
  content: "\\F0260"; }

.mdi-format-align-justify::before {
  content: "\\F0261"; }

.mdi-format-align-left::before {
  content: "\\F0262"; }

.mdi-format-align-middle::before {
  content: "\\F0754"; }

.mdi-format-align-right::before {
  content: "\\F0263"; }

.mdi-format-align-top::before {
  content: "\\F0755"; }

.mdi-format-annotation-minus::before {
  content: "\\F0ABC"; }

.mdi-format-annotation-plus::before {
  content: "\\F0646"; }

.mdi-format-bold::before {
  content: "\\F0264"; }

.mdi-format-clear::before {
  content: "\\F0265"; }

.mdi-format-color-fill::before {
  content: "\\F0266"; }

.mdi-format-color-highlight::before {
  content: "\\F0E31"; }

.mdi-format-color-marker-cancel::before {
  content: "\\F1313"; }

.mdi-format-color-text::before {
  content: "\\F069E"; }

.mdi-format-columns::before {
  content: "\\F08DF"; }

.mdi-format-float-center::before {
  content: "\\F0267"; }

.mdi-format-float-left::before {
  content: "\\F0268"; }

.mdi-format-float-none::before {
  content: "\\F0269"; }

.mdi-format-float-right::before {
  content: "\\F026A"; }

.mdi-format-font::before {
  content: "\\F06D6"; }

.mdi-format-font-size-decrease::before {
  content: "\\F09F3"; }

.mdi-format-font-size-increase::before {
  content: "\\F09F4"; }

.mdi-format-header-1::before {
  content: "\\F026B"; }

.mdi-format-header-2::before {
  content: "\\F026C"; }

.mdi-format-header-3::before {
  content: "\\F026D"; }

.mdi-format-header-4::before {
  content: "\\F026E"; }

.mdi-format-header-5::before {
  content: "\\F026F"; }

.mdi-format-header-6::before {
  content: "\\F0270"; }

.mdi-format-header-decrease::before {
  content: "\\F0271"; }

.mdi-format-header-equal::before {
  content: "\\F0272"; }

.mdi-format-header-increase::before {
  content: "\\F0273"; }

.mdi-format-header-pound::before {
  content: "\\F0274"; }

.mdi-format-horizontal-align-center::before {
  content: "\\F061E"; }

.mdi-format-horizontal-align-left::before {
  content: "\\F061F"; }

.mdi-format-horizontal-align-right::before {
  content: "\\F0620"; }

.mdi-format-indent-decrease::before {
  content: "\\F0275"; }

.mdi-format-indent-increase::before {
  content: "\\F0276"; }

.mdi-format-italic::before {
  content: "\\F0277"; }

.mdi-format-letter-case::before {
  content: "\\F0B34"; }

.mdi-format-letter-case-lower::before {
  content: "\\F0B35"; }

.mdi-format-letter-case-upper::before {
  content: "\\F0B36"; }

.mdi-format-letter-ends-with::before {
  content: "\\F0FB8"; }

.mdi-format-letter-matches::before {
  content: "\\F0FB9"; }

.mdi-format-letter-spacing::before {
  content: "\\F1956"; }

.mdi-format-letter-starts-with::before {
  content: "\\F0FBA"; }

.mdi-format-line-spacing::before {
  content: "\\F0278"; }

.mdi-format-line-style::before {
  content: "\\F05C8"; }

.mdi-format-line-weight::before {
  content: "\\F05C9"; }

.mdi-format-list-bulleted::before {
  content: "\\F0279"; }

.mdi-format-list-bulleted-square::before {
  content: "\\F0DD0"; }

.mdi-format-list-bulleted-triangle::before {
  content: "\\F0EB2"; }

.mdi-format-list-bulleted-type::before {
  content: "\\F027A"; }

.mdi-format-list-checkbox::before {
  content: "\\F096A"; }

.mdi-format-list-checks::before {
  content: "\\F0756"; }

.mdi-format-list-group::before {
  content: "\\F1860"; }

.mdi-format-list-numbered::before {
  content: "\\F027B"; }

.mdi-format-list-numbered-rtl::before {
  content: "\\F0D0D"; }

.mdi-format-list-text::before {
  content: "\\F126F"; }

.mdi-format-overline::before {
  content: "\\F0EB3"; }

.mdi-format-page-break::before {
  content: "\\F06D7"; }

.mdi-format-page-split::before {
  content: "\\F1917"; }

.mdi-format-paint::before {
  content: "\\F027C"; }

.mdi-format-paragraph::before {
  content: "\\F027D"; }

.mdi-format-pilcrow::before {
  content: "\\F06D8"; }

.mdi-format-quote-close::before {
  content: "\\F027E"; }

.mdi-format-quote-close-outline::before {
  content: "\\F11A8"; }

.mdi-format-quote-open::before {
  content: "\\F0757"; }

.mdi-format-quote-open-outline::before {
  content: "\\F11A7"; }

.mdi-format-rotate-90::before {
  content: "\\F06AA"; }

.mdi-format-section::before {
  content: "\\F069F"; }

.mdi-format-size::before {
  content: "\\F027F"; }

.mdi-format-strikethrough::before {
  content: "\\F0280"; }

.mdi-format-strikethrough-variant::before {
  content: "\\F0281"; }

.mdi-format-subscript::before {
  content: "\\F0282"; }

.mdi-format-superscript::before {
  content: "\\F0283"; }

.mdi-format-text::before {
  content: "\\F0284"; }

.mdi-format-text-rotation-angle-down::before {
  content: "\\F0FBB"; }

.mdi-format-text-rotation-angle-up::before {
  content: "\\F0FBC"; }

.mdi-format-text-rotation-down::before {
  content: "\\F0D73"; }

.mdi-format-text-rotation-down-vertical::before {
  content: "\\F0FBD"; }

.mdi-format-text-rotation-none::before {
  content: "\\F0D74"; }

.mdi-format-text-rotation-up::before {
  content: "\\F0FBE"; }

.mdi-format-text-rotation-vertical::before {
  content: "\\F0FBF"; }

.mdi-format-text-variant::before {
  content: "\\F0E32"; }

.mdi-format-text-variant-outline::before {
  content: "\\F150F"; }

.mdi-format-text-wrapping-clip::before {
  content: "\\F0D0E"; }

.mdi-format-text-wrapping-overflow::before {
  content: "\\F0D0F"; }

.mdi-format-text-wrapping-wrap::before {
  content: "\\F0D10"; }

.mdi-format-textbox::before {
  content: "\\F0D11"; }

.mdi-format-textdirection-l-to-r::before {
  content: "\\F0285"; }

.mdi-format-textdirection-r-to-l::before {
  content: "\\F0286"; }

.mdi-format-title::before {
  content: "\\F05F4"; }

.mdi-format-underline::before {
  content: "\\F0287"; }

.mdi-format-underline-wavy::before {
  content: "\\F18E9"; }

.mdi-format-vertical-align-bottom::before {
  content: "\\F0621"; }

.mdi-format-vertical-align-center::before {
  content: "\\F0622"; }

.mdi-format-vertical-align-top::before {
  content: "\\F0623"; }

.mdi-format-wrap-inline::before {
  content: "\\F0288"; }

.mdi-format-wrap-square::before {
  content: "\\F0289"; }

.mdi-format-wrap-tight::before {
  content: "\\F028A"; }

.mdi-format-wrap-top-bottom::before {
  content: "\\F028B"; }

.mdi-forum::before {
  content: "\\F028C"; }

.mdi-forum-outline::before {
  content: "\\F0822"; }

.mdi-forward::before {
  content: "\\F028D"; }

.mdi-forwardburger::before {
  content: "\\F0D75"; }

.mdi-fountain::before {
  content: "\\F096B"; }

.mdi-fountain-pen::before {
  content: "\\F0D12"; }

.mdi-fountain-pen-tip::before {
  content: "\\F0D13"; }

.mdi-fraction-one-half::before {
  content: "\\F1992"; }

.mdi-freebsd::before {
  content: "\\F08E0"; }

.mdi-french-fries::before {
  content: "\\F1957"; }

.mdi-frequently-asked-questions::before {
  content: "\\F0EB4"; }

.mdi-fridge::before {
  content: "\\F0290"; }

.mdi-fridge-alert::before {
  content: "\\F11B1"; }

.mdi-fridge-alert-outline::before {
  content: "\\F11B2"; }

.mdi-fridge-bottom::before {
  content: "\\F0292"; }

.mdi-fridge-industrial::before {
  content: "\\F15EE"; }

.mdi-fridge-industrial-alert::before {
  content: "\\F15EF"; }

.mdi-fridge-industrial-alert-outline::before {
  content: "\\F15F0"; }

.mdi-fridge-industrial-off::before {
  content: "\\F15F1"; }

.mdi-fridge-industrial-off-outline::before {
  content: "\\F15F2"; }

.mdi-fridge-industrial-outline::before {
  content: "\\F15F3"; }

.mdi-fridge-off::before {
  content: "\\F11AF"; }

.mdi-fridge-off-outline::before {
  content: "\\F11B0"; }

.mdi-fridge-outline::before {
  content: "\\F028F"; }

.mdi-fridge-top::before {
  content: "\\F0291"; }

.mdi-fridge-variant::before {
  content: "\\F15F4"; }

.mdi-fridge-variant-alert::before {
  content: "\\F15F5"; }

.mdi-fridge-variant-alert-outline::before {
  content: "\\F15F6"; }

.mdi-fridge-variant-off::before {
  content: "\\F15F7"; }

.mdi-fridge-variant-off-outline::before {
  content: "\\F15F8"; }

.mdi-fridge-variant-outline::before {
  content: "\\F15F9"; }

.mdi-fruit-cherries::before {
  content: "\\F1042"; }

.mdi-fruit-cherries-off::before {
  content: "\\F13F8"; }

.mdi-fruit-citrus::before {
  content: "\\F1043"; }

.mdi-fruit-citrus-off::before {
  content: "\\F13F9"; }

.mdi-fruit-grapes::before {
  content: "\\F1044"; }

.mdi-fruit-grapes-outline::before {
  content: "\\F1045"; }

.mdi-fruit-pineapple::before {
  content: "\\F1046"; }

.mdi-fruit-watermelon::before {
  content: "\\F1047"; }

.mdi-fuel::before {
  content: "\\F07CA"; }

.mdi-fuel-cell::before {
  content: "\\F18B5"; }

.mdi-fullscreen::before {
  content: "\\F0293"; }

.mdi-fullscreen-exit::before {
  content: "\\F0294"; }

.mdi-function::before {
  content: "\\F0295"; }

.mdi-function-variant::before {
  content: "\\F0871"; }

.mdi-furigana-horizontal::before {
  content: "\\F1081"; }

.mdi-furigana-vertical::before {
  content: "\\F1082"; }

.mdi-fuse::before {
  content: "\\F0C85"; }

.mdi-fuse-alert::before {
  content: "\\F142D"; }

.mdi-fuse-blade::before {
  content: "\\F0C86"; }

.mdi-fuse-off::before {
  content: "\\F142C"; }

.mdi-gamepad::before {
  content: "\\F0296"; }

.mdi-gamepad-circle::before {
  content: "\\F0E33"; }

.mdi-gamepad-circle-down::before {
  content: "\\F0E34"; }

.mdi-gamepad-circle-left::before {
  content: "\\F0E35"; }

.mdi-gamepad-circle-outline::before {
  content: "\\F0E36"; }

.mdi-gamepad-circle-right::before {
  content: "\\F0E37"; }

.mdi-gamepad-circle-up::before {
  content: "\\F0E38"; }

.mdi-gamepad-down::before {
  content: "\\F0E39"; }

.mdi-gamepad-left::before {
  content: "\\F0E3A"; }

.mdi-gamepad-outline::before {
  content: "\\F1919"; }

.mdi-gamepad-right::before {
  content: "\\F0E3B"; }

.mdi-gamepad-round::before {
  content: "\\F0E3C"; }

.mdi-gamepad-round-down::before {
  content: "\\F0E3D"; }

.mdi-gamepad-round-left::before {
  content: "\\F0E3E"; }

.mdi-gamepad-round-outline::before {
  content: "\\F0E3F"; }

.mdi-gamepad-round-right::before {
  content: "\\F0E40"; }

.mdi-gamepad-round-up::before {
  content: "\\F0E41"; }

.mdi-gamepad-square::before {
  content: "\\F0EB5"; }

.mdi-gamepad-square-outline::before {
  content: "\\F0EB6"; }

.mdi-gamepad-up::before {
  content: "\\F0E42"; }

.mdi-gamepad-variant::before {
  content: "\\F0297"; }

.mdi-gamepad-variant-outline::before {
  content: "\\F0EB7"; }

.mdi-gamma::before {
  content: "\\F10EE"; }

.mdi-gantry-crane::before {
  content: "\\F0DD1"; }

.mdi-garage::before {
  content: "\\F06D9"; }

.mdi-garage-alert::before {
  content: "\\F0872"; }

.mdi-garage-alert-variant::before {
  content: "\\F12D5"; }

.mdi-garage-lock::before {
  content: "\\F17FB"; }

.mdi-garage-open::before {
  content: "\\F06DA"; }

.mdi-garage-open-variant::before {
  content: "\\F12D4"; }

.mdi-garage-variant::before {
  content: "\\F12D3"; }

.mdi-garage-variant-lock::before {
  content: "\\F17FC"; }

.mdi-gas-cylinder::before {
  content: "\\F0647"; }

.mdi-gas-station::before {
  content: "\\F0298"; }

.mdi-gas-station-off::before {
  content: "\\F1409"; }

.mdi-gas-station-off-outline::before {
  content: "\\F140A"; }

.mdi-gas-station-outline::before {
  content: "\\F0EB8"; }

.mdi-gate::before {
  content: "\\F0299"; }

.mdi-gate-alert::before {
  content: "\\F17F8"; }

.mdi-gate-and::before {
  content: "\\F08E1"; }

.mdi-gate-arrow-left::before {
  content: "\\F17F7"; }

.mdi-gate-arrow-right::before {
  content: "\\F1169"; }

.mdi-gate-nand::before {
  content: "\\F08E2"; }

.mdi-gate-nor::before {
  content: "\\F08E3"; }

.mdi-gate-not::before {
  content: "\\F08E4"; }

.mdi-gate-open::before {
  content: "\\F116A"; }

.mdi-gate-or::before {
  content: "\\F08E5"; }

.mdi-gate-xnor::before {
  content: "\\F08E6"; }

.mdi-gate-xor::before {
  content: "\\F08E7"; }

.mdi-gatsby::before {
  content: "\\F0E43"; }

.mdi-gauge::before {
  content: "\\F029A"; }

.mdi-gauge-empty::before {
  content: "\\F0873"; }

.mdi-gauge-full::before {
  content: "\\F0874"; }

.mdi-gauge-low::before {
  content: "\\F0875"; }

.mdi-gavel::before {
  content: "\\F029B"; }

.mdi-gender-female::before {
  content: "\\F029C"; }

.mdi-gender-male::before {
  content: "\\F029D"; }

.mdi-gender-male-female::before {
  content: "\\F029E"; }

.mdi-gender-male-female-variant::before {
  content: "\\F113F"; }

.mdi-gender-non-binary::before {
  content: "\\F1140"; }

.mdi-gender-transgender::before {
  content: "\\F029F"; }

.mdi-gentoo::before {
  content: "\\F08E8"; }

.mdi-gesture::before {
  content: "\\F07CB"; }

.mdi-gesture-double-tap::before {
  content: "\\F073C"; }

.mdi-gesture-pinch::before {
  content: "\\F0ABD"; }

.mdi-gesture-spread::before {
  content: "\\F0ABE"; }

.mdi-gesture-swipe::before {
  content: "\\F0D76"; }

.mdi-gesture-swipe-down::before {
  content: "\\F073D"; }

.mdi-gesture-swipe-horizontal::before {
  content: "\\F0ABF"; }

.mdi-gesture-swipe-left::before {
  content: "\\F073E"; }

.mdi-gesture-swipe-right::before {
  content: "\\F073F"; }

.mdi-gesture-swipe-up::before {
  content: "\\F0740"; }

.mdi-gesture-swipe-vertical::before {
  content: "\\F0AC0"; }

.mdi-gesture-tap::before {
  content: "\\F0741"; }

.mdi-gesture-tap-box::before {
  content: "\\F12A9"; }

.mdi-gesture-tap-button::before {
  content: "\\F12A8"; }

.mdi-gesture-tap-hold::before {
  content: "\\F0D77"; }

.mdi-gesture-two-double-tap::before {
  content: "\\F0742"; }

.mdi-gesture-two-tap::before {
  content: "\\F0743"; }

.mdi-ghost::before {
  content: "\\F02A0"; }

.mdi-ghost-off::before {
  content: "\\F09F5"; }

.mdi-ghost-off-outline::before {
  content: "\\F165C"; }

.mdi-ghost-outline::before {
  content: "\\F165D"; }

.mdi-gift::before {
  content: "\\F0E44"; }

.mdi-gift-off::before {
  content: "\\F16EF"; }

.mdi-gift-off-outline::before {
  content: "\\F16F0"; }

.mdi-gift-open::before {
  content: "\\F16F1"; }

.mdi-gift-open-outline::before {
  content: "\\F16F2"; }

.mdi-gift-outline::before {
  content: "\\F02A1"; }

.mdi-git::before {
  content: "\\F02A2"; }

.mdi-github::before {
  content: "\\F02A4"; }

.mdi-gitlab::before {
  content: "\\F0BA0"; }

.mdi-glass-cocktail::before {
  content: "\\F0356"; }

.mdi-glass-cocktail-off::before {
  content: "\\F15E6"; }

.mdi-glass-flute::before {
  content: "\\F02A5"; }

.mdi-glass-fragile::before {
  content: "\\F1873"; }

.mdi-glass-mug::before {
  content: "\\F02A6"; }

.mdi-glass-mug-off::before {
  content: "\\F15E7"; }

.mdi-glass-mug-variant::before {
  content: "\\F1116"; }

.mdi-glass-mug-variant-off::before {
  content: "\\F15E8"; }

.mdi-glass-pint-outline::before {
  content: "\\F130D"; }

.mdi-glass-stange::before {
  content: "\\F02A7"; }

.mdi-glass-tulip::before {
  content: "\\F02A8"; }

.mdi-glass-wine::before {
  content: "\\F0876"; }

.mdi-glasses::before {
  content: "\\F02AA"; }

.mdi-globe-light::before {
  content: "\\F12D7"; }

.mdi-globe-model::before {
  content: "\\F08E9"; }

.mdi-gmail::before {
  content: "\\F02AB"; }

.mdi-gnome::before {
  content: "\\F02AC"; }

.mdi-go-kart::before {
  content: "\\F0D79"; }

.mdi-go-kart-track::before {
  content: "\\F0D7A"; }

.mdi-gog::before {
  content: "\\F0BA1"; }

.mdi-gold::before {
  content: "\\F124F"; }

.mdi-golf::before {
  content: "\\F0823"; }

.mdi-golf-cart::before {
  content: "\\F11A4"; }

.mdi-golf-tee::before {
  content: "\\F1083"; }

.mdi-gondola::before {
  content: "\\F0686"; }

.mdi-goodreads::before {
  content: "\\F0D7B"; }

.mdi-google::before {
  content: "\\F02AD"; }

.mdi-google-ads::before {
  content: "\\F0C87"; }

.mdi-google-analytics::before {
  content: "\\F07CC"; }

.mdi-google-assistant::before {
  content: "\\F07CD"; }

.mdi-google-cardboard::before {
  content: "\\F02AE"; }

.mdi-google-chrome::before {
  content: "\\F02AF"; }

.mdi-google-circles::before {
  content: "\\F02B0"; }

.mdi-google-circles-communities::before {
  content: "\\F02B1"; }

.mdi-google-circles-extended::before {
  content: "\\F02B2"; }

.mdi-google-circles-group::before {
  content: "\\F02B3"; }

.mdi-google-classroom::before {
  content: "\\F02C0"; }

.mdi-google-cloud::before {
  content: "\\F11F6"; }

.mdi-google-controller::before {
  content: "\\F02B4"; }

.mdi-google-controller-off::before {
  content: "\\F02B5"; }

.mdi-google-downasaur::before {
  content: "\\F1362"; }

.mdi-google-drive::before {
  content: "\\F02B6"; }

.mdi-google-earth::before {
  content: "\\F02B7"; }

.mdi-google-fit::before {
  content: "\\F096C"; }

.mdi-google-glass::before {
  content: "\\F02B8"; }

.mdi-google-hangouts::before {
  content: "\\F02C9"; }

.mdi-google-home::before {
  content: "\\F0824"; }

.mdi-google-keep::before {
  content: "\\F06DC"; }

.mdi-google-lens::before {
  content: "\\F09F6"; }

.mdi-google-maps::before {
  content: "\\F05F5"; }

.mdi-google-my-business::before {
  content: "\\F1048"; }

.mdi-google-nearby::before {
  content: "\\F02B9"; }

.mdi-google-play::before {
  content: "\\F02BC"; }

.mdi-google-plus::before {
  content: "\\F02BD"; }

.mdi-google-podcast::before {
  content: "\\F0EB9"; }

.mdi-google-spreadsheet::before {
  content: "\\F09F7"; }

.mdi-google-street-view::before {
  content: "\\F0C88"; }

.mdi-google-translate::before {
  content: "\\F02BF"; }

.mdi-gradient-horizontal::before {
  content: "\\F174A"; }

.mdi-gradient-vertical::before {
  content: "\\F06A0"; }

.mdi-grain::before {
  content: "\\F0D7C"; }

.mdi-graph::before {
  content: "\\F1049"; }

.mdi-graph-outline::before {
  content: "\\F104A"; }

.mdi-graphql::before {
  content: "\\F0877"; }

.mdi-grass::before {
  content: "\\F1510"; }

.mdi-grave-stone::before {
  content: "\\F0BA2"; }

.mdi-grease-pencil::before {
  content: "\\F0648"; }

.mdi-greater-than::before {
  content: "\\F096D"; }

.mdi-greater-than-or-equal::before {
  content: "\\F096E"; }

.mdi-greenhouse::before {
  content: "\\F002D"; }

.mdi-grid::before {
  content: "\\F02C1"; }

.mdi-grid-large::before {
  content: "\\F0758"; }

.mdi-grid-off::before {
  content: "\\F02C2"; }

.mdi-grill::before {
  content: "\\F0E45"; }

.mdi-grill-outline::before {
  content: "\\F118A"; }

.mdi-group::before {
  content: "\\F02C3"; }

.mdi-guitar-acoustic::before {
  content: "\\F0771"; }

.mdi-guitar-electric::before {
  content: "\\F02C4"; }

.mdi-guitar-pick::before {
  content: "\\F02C5"; }

.mdi-guitar-pick-outline::before {
  content: "\\F02C6"; }

.mdi-guy-fawkes-mask::before {
  content: "\\F0825"; }

.mdi-hail::before {
  content: "\\F0AC1"; }

.mdi-hair-dryer::before {
  content: "\\F10EF"; }

.mdi-hair-dryer-outline::before {
  content: "\\F10F0"; }

.mdi-halloween::before {
  content: "\\F0BA3"; }

.mdi-hamburger::before {
  content: "\\F0685"; }

.mdi-hamburger-check::before {
  content: "\\F1776"; }

.mdi-hamburger-minus::before {
  content: "\\F1777"; }

.mdi-hamburger-off::before {
  content: "\\F1778"; }

.mdi-hamburger-plus::before {
  content: "\\F1779"; }

.mdi-hamburger-remove::before {
  content: "\\F177A"; }

.mdi-hammer::before {
  content: "\\F08EA"; }

.mdi-hammer-screwdriver::before {
  content: "\\F1322"; }

.mdi-hammer-sickle::before {
  content: "\\F1887"; }

.mdi-hammer-wrench::before {
  content: "\\F1323"; }

.mdi-hand-back-left::before {
  content: "\\F0E46"; }

.mdi-hand-back-left-off::before {
  content: "\\F1830"; }

.mdi-hand-back-left-off-outline::before {
  content: "\\F1832"; }

.mdi-hand-back-left-outline::before {
  content: "\\F182C"; }

.mdi-hand-back-right::before {
  content: "\\F0E47"; }

.mdi-hand-back-right-off::before {
  content: "\\F1831"; }

.mdi-hand-back-right-off-outline::before {
  content: "\\F1833"; }

.mdi-hand-back-right-outline::before {
  content: "\\F182D"; }

.mdi-hand-clap::before {
  content: "\\F194B"; }

.mdi-hand-coin::before {
  content: "\\F188F"; }

.mdi-hand-coin-outline::before {
  content: "\\F1890"; }

.mdi-hand-extended::before {
  content: "\\F18B6"; }

.mdi-hand-extended-outline::before {
  content: "\\F18B7"; }

.mdi-hand-front-left::before {
  content: "\\F182B"; }

.mdi-hand-front-left-outline::before {
  content: "\\F182E"; }

.mdi-hand-front-right::before {
  content: "\\F0A4F"; }

.mdi-hand-front-right-outline::before {
  content: "\\F182F"; }

.mdi-hand-heart::before {
  content: "\\F10F1"; }

.mdi-hand-heart-outline::before {
  content: "\\F157E"; }

.mdi-hand-okay::before {
  content: "\\F0A50"; }

.mdi-hand-peace::before {
  content: "\\F0A51"; }

.mdi-hand-peace-variant::before {
  content: "\\F0A52"; }

.mdi-hand-pointing-down::before {
  content: "\\F0A53"; }

.mdi-hand-pointing-left::before {
  content: "\\F0A54"; }

.mdi-hand-pointing-right::before {
  content: "\\F02C7"; }

.mdi-hand-pointing-up::before {
  content: "\\F0A55"; }

.mdi-hand-saw::before {
  content: "\\F0E48"; }

.mdi-hand-wash::before {
  content: "\\F157F"; }

.mdi-hand-wash-outline::before {
  content: "\\F1580"; }

.mdi-hand-water::before {
  content: "\\F139F"; }

.mdi-hand-wave::before {
  content: "\\F1821"; }

.mdi-hand-wave-outline::before {
  content: "\\F1822"; }

.mdi-handball::before {
  content: "\\F0F53"; }

.mdi-handcuffs::before {
  content: "\\F113E"; }

.mdi-hands-pray::before {
  content: "\\F0579"; }

.mdi-handshake::before {
  content: "\\F1218"; }

.mdi-handshake-outline::before {
  content: "\\F15A1"; }

.mdi-hanger::before {
  content: "\\F02C8"; }

.mdi-hard-hat::before {
  content: "\\F096F"; }

.mdi-harddisk::before {
  content: "\\F02CA"; }

.mdi-harddisk-plus::before {
  content: "\\F104B"; }

.mdi-harddisk-remove::before {
  content: "\\F104C"; }

.mdi-hat-fedora::before {
  content: "\\F0BA4"; }

.mdi-hazard-lights::before {
  content: "\\F0C89"; }

.mdi-hdr::before {
  content: "\\F0D7D"; }

.mdi-hdr-off::before {
  content: "\\F0D7E"; }

.mdi-head::before {
  content: "\\F135E"; }

.mdi-head-alert::before {
  content: "\\F1338"; }

.mdi-head-alert-outline::before {
  content: "\\F1339"; }

.mdi-head-check::before {
  content: "\\F133A"; }

.mdi-head-check-outline::before {
  content: "\\F133B"; }

.mdi-head-cog::before {
  content: "\\F133C"; }

.mdi-head-cog-outline::before {
  content: "\\F133D"; }

.mdi-head-dots-horizontal::before {
  content: "\\F133E"; }

.mdi-head-dots-horizontal-outline::before {
  content: "\\F133F"; }

.mdi-head-flash::before {
  content: "\\F1340"; }

.mdi-head-flash-outline::before {
  content: "\\F1341"; }

.mdi-head-heart::before {
  content: "\\F1342"; }

.mdi-head-heart-outline::before {
  content: "\\F1343"; }

.mdi-head-lightbulb::before {
  content: "\\F1344"; }

.mdi-head-lightbulb-outline::before {
  content: "\\F1345"; }

.mdi-head-minus::before {
  content: "\\F1346"; }

.mdi-head-minus-outline::before {
  content: "\\F1347"; }

.mdi-head-outline::before {
  content: "\\F135F"; }

.mdi-head-plus::before {
  content: "\\F1348"; }

.mdi-head-plus-outline::before {
  content: "\\F1349"; }

.mdi-head-question::before {
  content: "\\F134A"; }

.mdi-head-question-outline::before {
  content: "\\F134B"; }

.mdi-head-remove::before {
  content: "\\F134C"; }

.mdi-head-remove-outline::before {
  content: "\\F134D"; }

.mdi-head-snowflake::before {
  content: "\\F134E"; }

.mdi-head-snowflake-outline::before {
  content: "\\F134F"; }

.mdi-head-sync::before {
  content: "\\F1350"; }

.mdi-head-sync-outline::before {
  content: "\\F1351"; }

.mdi-headphones::before {
  content: "\\F02CB"; }

.mdi-headphones-bluetooth::before {
  content: "\\F0970"; }

.mdi-headphones-box::before {
  content: "\\F02CC"; }

.mdi-headphones-off::before {
  content: "\\F07CE"; }

.mdi-headphones-settings::before {
  content: "\\F02CD"; }

.mdi-headset::before {
  content: "\\F02CE"; }

.mdi-headset-dock::before {
  content: "\\F02CF"; }

.mdi-headset-off::before {
  content: "\\F02D0"; }

.mdi-heart::before {
  content: "\\F02D1"; }

.mdi-heart-box::before {
  content: "\\F02D2"; }

.mdi-heart-box-outline::before {
  content: "\\F02D3"; }

.mdi-heart-broken::before {
  content: "\\F02D4"; }

.mdi-heart-broken-outline::before {
  content: "\\F0D14"; }

.mdi-heart-circle::before {
  content: "\\F0971"; }

.mdi-heart-circle-outline::before {
  content: "\\F0972"; }

.mdi-heart-cog::before {
  content: "\\F1663"; }

.mdi-heart-cog-outline::before {
  content: "\\F1664"; }

.mdi-heart-flash::before {
  content: "\\F0EF9"; }

.mdi-heart-half::before {
  content: "\\F06DF"; }

.mdi-heart-half-full::before {
  content: "\\F06DE"; }

.mdi-heart-half-outline::before {
  content: "\\F06E0"; }

.mdi-heart-minus::before {
  content: "\\F142F"; }

.mdi-heart-minus-outline::before {
  content: "\\F1432"; }

.mdi-heart-multiple::before {
  content: "\\F0A56"; }

.mdi-heart-multiple-outline::before {
  content: "\\F0A57"; }

.mdi-heart-off::before {
  content: "\\F0759"; }

.mdi-heart-off-outline::before {
  content: "\\F1434"; }

.mdi-heart-outline::before {
  content: "\\F02D5"; }

.mdi-heart-plus::before {
  content: "\\F142E"; }

.mdi-heart-plus-outline::before {
  content: "\\F1431"; }

.mdi-heart-pulse::before {
  content: "\\F05F6"; }

.mdi-heart-remove::before {
  content: "\\F1430"; }

.mdi-heart-remove-outline::before {
  content: "\\F1433"; }

.mdi-heart-settings::before {
  content: "\\F1665"; }

.mdi-heart-settings-outline::before {
  content: "\\F1666"; }

.mdi-helicopter::before {
  content: "\\F0AC2"; }

.mdi-help::before {
  content: "\\F02D6"; }

.mdi-help-box::before {
  content: "\\F078B"; }

.mdi-help-circle::before {
  content: "\\F02D7"; }

.mdi-help-circle-outline::before {
  content: "\\F0625"; }

.mdi-help-network::before {
  content: "\\F06F5"; }

.mdi-help-network-outline::before {
  content: "\\F0C8A"; }

.mdi-help-rhombus::before {
  content: "\\F0BA5"; }

.mdi-help-rhombus-outline::before {
  content: "\\F0BA6"; }

.mdi-hexadecimal::before {
  content: "\\F12A7"; }

.mdi-hexagon::before {
  content: "\\F02D8"; }

.mdi-hexagon-multiple::before {
  content: "\\F06E1"; }

.mdi-hexagon-multiple-outline::before {
  content: "\\F10F2"; }

.mdi-hexagon-outline::before {
  content: "\\F02D9"; }

.mdi-hexagon-slice-1::before {
  content: "\\F0AC3"; }

.mdi-hexagon-slice-2::before {
  content: "\\F0AC4"; }

.mdi-hexagon-slice-3::before {
  content: "\\F0AC5"; }

.mdi-hexagon-slice-4::before {
  content: "\\F0AC6"; }

.mdi-hexagon-slice-5::before {
  content: "\\F0AC7"; }

.mdi-hexagon-slice-6::before {
  content: "\\F0AC8"; }

.mdi-hexagram::before {
  content: "\\F0AC9"; }

.mdi-hexagram-outline::before {
  content: "\\F0ACA"; }

.mdi-high-definition::before {
  content: "\\F07CF"; }

.mdi-high-definition-box::before {
  content: "\\F0878"; }

.mdi-highway::before {
  content: "\\F05F7"; }

.mdi-hiking::before {
  content: "\\F0D7F"; }

.mdi-history::before {
  content: "\\F02DA"; }

.mdi-hockey-puck::before {
  content: "\\F0879"; }

.mdi-hockey-sticks::before {
  content: "\\F087A"; }

.mdi-hololens::before {
  content: "\\F02DB"; }

.mdi-home::before {
  content: "\\F02DC"; }

.mdi-home-account::before {
  content: "\\F0826"; }

.mdi-home-alert::before {
  content: "\\F087B"; }

.mdi-home-alert-outline::before {
  content: "\\F15D0"; }

.mdi-home-analytics::before {
  content: "\\F0EBA"; }

.mdi-home-assistant::before {
  content: "\\F07D0"; }

.mdi-home-automation::before {
  content: "\\F07D1"; }

.mdi-home-battery::before {
  content: "\\F1901"; }

.mdi-home-battery-outline::before {
  content: "\\F1902"; }

.mdi-home-circle::before {
  content: "\\F07D2"; }

.mdi-home-circle-outline::before {
  content: "\\F104D"; }

.mdi-home-city::before {
  content: "\\F0D15"; }

.mdi-home-city-outline::before {
  content: "\\F0D16"; }

.mdi-home-edit::before {
  content: "\\F1159"; }

.mdi-home-edit-outline::before {
  content: "\\F115A"; }

.mdi-home-export-outline::before {
  content: "\\F0F9B"; }

.mdi-home-flood::before {
  content: "\\F0EFA"; }

.mdi-home-floor-0::before {
  content: "\\F0DD2"; }

.mdi-home-floor-1::before {
  content: "\\F0D80"; }

.mdi-home-floor-2::before {
  content: "\\F0D81"; }

.mdi-home-floor-3::before {
  content: "\\F0D82"; }

.mdi-home-floor-a::before {
  content: "\\F0D83"; }

.mdi-home-floor-b::before {
  content: "\\F0D84"; }

.mdi-home-floor-g::before {
  content: "\\F0D85"; }

.mdi-home-floor-l::before {
  content: "\\F0D86"; }

.mdi-home-floor-negative-1::before {
  content: "\\F0DD3"; }

.mdi-home-group::before {
  content: "\\F0DD4"; }

.mdi-home-group-minus::before {
  content: "\\F19C1"; }

.mdi-home-group-plus::before {
  content: "\\F19C0"; }

.mdi-home-group-remove::before {
  content: "\\F19C2"; }

.mdi-home-heart::before {
  content: "\\F0827"; }

.mdi-home-import-outline::before {
  content: "\\F0F9C"; }

.mdi-home-lightbulb::before {
  content: "\\F1251"; }

.mdi-home-lightbulb-outline::before {
  content: "\\F1252"; }

.mdi-home-lightning-bolt::before {
  content: "\\F1903"; }

.mdi-home-lightning-bolt-outline::before {
  content: "\\F1904"; }

.mdi-home-lock::before {
  content: "\\F08EB"; }

.mdi-home-lock-open::before {
  content: "\\F08EC"; }

.mdi-home-map-marker::before {
  content: "\\F05F8"; }

.mdi-home-minus::before {
  content: "\\F0974"; }

.mdi-home-minus-outline::before {
  content: "\\F13D5"; }

.mdi-home-modern::before {
  content: "\\F02DD"; }

.mdi-home-outline::before {
  content: "\\F06A1"; }

.mdi-home-plus::before {
  content: "\\F0975"; }

.mdi-home-plus-outline::before {
  content: "\\F13D6"; }

.mdi-home-remove::before {
  content: "\\F1247"; }

.mdi-home-remove-outline::before {
  content: "\\F13D7"; }

.mdi-home-roof::before {
  content: "\\F112B"; }

.mdi-home-search::before {
  content: "\\F13B0"; }

.mdi-home-search-outline::before {
  content: "\\F13B1"; }

.mdi-home-switch::before {
  content: "\\F1794"; }

.mdi-home-switch-outline::before {
  content: "\\F1795"; }

.mdi-home-thermometer::before {
  content: "\\F0F54"; }

.mdi-home-thermometer-outline::before {
  content: "\\F0F55"; }

.mdi-home-variant::before {
  content: "\\F02DE"; }

.mdi-home-variant-outline::before {
  content: "\\F0BA7"; }

.mdi-hook::before {
  content: "\\F06E2"; }

.mdi-hook-off::before {
  content: "\\F06E3"; }

.mdi-hoop-house::before {
  content: "\\F0E56"; }

.mdi-hops::before {
  content: "\\F02DF"; }

.mdi-horizontal-rotate-clockwise::before {
  content: "\\F10F3"; }

.mdi-horizontal-rotate-counterclockwise::before {
  content: "\\F10F4"; }

.mdi-horse::before {
  content: "\\F15BF"; }

.mdi-horse-human::before {
  content: "\\F15C0"; }

.mdi-horse-variant::before {
  content: "\\F15C1"; }

.mdi-horse-variant-fast::before {
  content: "\\F186E"; }

.mdi-horseshoe::before {
  content: "\\F0A58"; }

.mdi-hospital::before {
  content: "\\F0FF6"; }

.mdi-hospital-box::before {
  content: "\\F02E0"; }

.mdi-hospital-box-outline::before {
  content: "\\F0FF7"; }

.mdi-hospital-building::before {
  content: "\\F02E1"; }

.mdi-hospital-marker::before {
  content: "\\F02E2"; }

.mdi-hot-tub::before {
  content: "\\F0828"; }

.mdi-hours-24::before {
  content: "\\F1478"; }

.mdi-hubspot::before {
  content: "\\F0D17"; }

.mdi-hulu::before {
  content: "\\F0829"; }

.mdi-human::before {
  content: "\\F02E6"; }

.mdi-human-baby-changing-table::before {
  content: "\\F138B"; }

.mdi-human-cane::before {
  content: "\\F1581"; }

.mdi-human-capacity-decrease::before {
  content: "\\F159B"; }

.mdi-human-capacity-increase::before {
  content: "\\F159C"; }

.mdi-human-child::before {
  content: "\\F02E7"; }

.mdi-human-dolly::before {
  content: "\\F1980"; }

.mdi-human-edit::before {
  content: "\\F14E8"; }

.mdi-human-female::before {
  content: "\\F0649"; }

.mdi-human-female-boy::before {
  content: "\\F0A59"; }

.mdi-human-female-dance::before {
  content: "\\F15C9"; }

.mdi-human-female-female::before {
  content: "\\F0A5A"; }

.mdi-human-female-girl::before {
  content: "\\F0A5B"; }

.mdi-human-greeting::before {
  content: "\\F17C4"; }

.mdi-human-greeting-proximity::before {
  content: "\\F159D"; }

.mdi-human-greeting-variant::before {
  content: "\\F064A"; }

.mdi-human-handsdown::before {
  content: "\\F064B"; }

.mdi-human-handsup::before {
  content: "\\F064C"; }

.mdi-human-male::before {
  content: "\\F064D"; }

.mdi-human-male-board::before {
  content: "\\F0890"; }

.mdi-human-male-board-poll::before {
  content: "\\F0846"; }

.mdi-human-male-boy::before {
  content: "\\F0A5C"; }

.mdi-human-male-child::before {
  content: "\\F138C"; }

.mdi-human-male-female::before {
  content: "\\F02E8"; }

.mdi-human-male-female-child::before {
  content: "\\F1823"; }

.mdi-human-male-girl::before {
  content: "\\F0A5D"; }

.mdi-human-male-height::before {
  content: "\\F0EFB"; }

.mdi-human-male-height-variant::before {
  content: "\\F0EFC"; }

.mdi-human-male-male::before {
  content: "\\F0A5E"; }

.mdi-human-non-binary::before {
  content: "\\F1848"; }

.mdi-human-pregnant::before {
  content: "\\F05CF"; }

.mdi-human-queue::before {
  content: "\\F1571"; }

.mdi-human-scooter::before {
  content: "\\F11E9"; }

.mdi-human-wheelchair::before {
  content: "\\F138D"; }

.mdi-human-white-cane::before {
  content: "\\F1981"; }

.mdi-humble-bundle::before {
  content: "\\F0744"; }

.mdi-hvac::before {
  content: "\\F1352"; }

.mdi-hvac-off::before {
  content: "\\F159E"; }

.mdi-hydraulic-oil-level::before {
  content: "\\F1324"; }

.mdi-hydraulic-oil-temperature::before {
  content: "\\F1325"; }

.mdi-hydro-power::before {
  content: "\\F12E5"; }

.mdi-hydrogen-station::before {
  content: "\\F1894"; }

.mdi-ice-cream::before {
  content: "\\F082A"; }

.mdi-ice-cream-off::before {
  content: "\\F0E52"; }

.mdi-ice-pop::before {
  content: "\\F0EFD"; }

.mdi-id-card::before {
  content: "\\F0FC0"; }

.mdi-identifier::before {
  content: "\\F0EFE"; }

.mdi-ideogram-cjk::before {
  content: "\\F1331"; }

.mdi-ideogram-cjk-variant::before {
  content: "\\F1332"; }

.mdi-image::before {
  content: "\\F02E9"; }

.mdi-image-album::before {
  content: "\\F02EA"; }

.mdi-image-area::before {
  content: "\\F02EB"; }

.mdi-image-area-close::before {
  content: "\\F02EC"; }

.mdi-image-auto-adjust::before {
  content: "\\F0FC1"; }

.mdi-image-broken::before {
  content: "\\F02ED"; }

.mdi-image-broken-variant::before {
  content: "\\F02EE"; }

.mdi-image-edit::before {
  content: "\\F11E3"; }

.mdi-image-edit-outline::before {
  content: "\\F11E4"; }

.mdi-image-filter-black-white::before {
  content: "\\F02F0"; }

.mdi-image-filter-center-focus::before {
  content: "\\F02F1"; }

.mdi-image-filter-center-focus-strong::before {
  content: "\\F0EFF"; }

.mdi-image-filter-center-focus-strong-outline::before {
  content: "\\F0F00"; }

.mdi-image-filter-center-focus-weak::before {
  content: "\\F02F2"; }

.mdi-image-filter-drama::before {
  content: "\\F02F3"; }

.mdi-image-filter-frames::before {
  content: "\\F02F4"; }

.mdi-image-filter-hdr::before {
  content: "\\F02F5"; }

.mdi-image-filter-none::before {
  content: "\\F02F6"; }

.mdi-image-filter-tilt-shift::before {
  content: "\\F02F7"; }

.mdi-image-filter-vintage::before {
  content: "\\F02F8"; }

.mdi-image-frame::before {
  content: "\\F0E49"; }

.mdi-image-marker::before {
  content: "\\F177B"; }

.mdi-image-marker-outline::before {
  content: "\\F177C"; }

.mdi-image-minus::before {
  content: "\\F1419"; }

.mdi-image-move::before {
  content: "\\F09F8"; }

.mdi-image-multiple::before {
  content: "\\F02F9"; }

.mdi-image-multiple-outline::before {
  content: "\\F02EF"; }

.mdi-image-off::before {
  content: "\\F082B"; }

.mdi-image-off-outline::before {
  content: "\\F11D1"; }

.mdi-image-outline::before {
  content: "\\F0976"; }

.mdi-image-plus::before {
  content: "\\F087C"; }

.mdi-image-remove::before {
  content: "\\F1418"; }

.mdi-image-search::before {
  content: "\\F0977"; }

.mdi-image-search-outline::before {
  content: "\\F0978"; }

.mdi-image-size-select-actual::before {
  content: "\\F0C8D"; }

.mdi-image-size-select-large::before {
  content: "\\F0C8E"; }

.mdi-image-size-select-small::before {
  content: "\\F0C8F"; }

.mdi-image-text::before {
  content: "\\F160D"; }

.mdi-import::before {
  content: "\\F02FA"; }

.mdi-inbox::before {
  content: "\\F0687"; }

.mdi-inbox-arrow-down::before {
  content: "\\F02FB"; }

.mdi-inbox-arrow-down-outline::before {
  content: "\\F1270"; }

.mdi-inbox-arrow-up::before {
  content: "\\F03D1"; }

.mdi-inbox-arrow-up-outline::before {
  content: "\\F1271"; }

.mdi-inbox-full::before {
  content: "\\F1272"; }

.mdi-inbox-full-outline::before {
  content: "\\F1273"; }

.mdi-inbox-multiple::before {
  content: "\\F08B0"; }

.mdi-inbox-multiple-outline::before {
  content: "\\F0BA8"; }

.mdi-inbox-outline::before {
  content: "\\F1274"; }

.mdi-inbox-remove::before {
  content: "\\F159F"; }

.mdi-inbox-remove-outline::before {
  content: "\\F15A0"; }

.mdi-incognito::before {
  content: "\\F05F9"; }

.mdi-incognito-circle::before {
  content: "\\F1421"; }

.mdi-incognito-circle-off::before {
  content: "\\F1422"; }

.mdi-incognito-off::before {
  content: "\\F0075"; }

.mdi-induction::before {
  content: "\\F184C"; }

.mdi-infinity::before {
  content: "\\F06E4"; }

.mdi-information::before {
  content: "\\F02FC"; }

.mdi-information-off::before {
  content: "\\F178C"; }

.mdi-information-off-outline::before {
  content: "\\F178D"; }

.mdi-information-outline::before {
  content: "\\F02FD"; }

.mdi-information-variant::before {
  content: "\\F064E"; }

.mdi-instagram::before {
  content: "\\F02FE"; }

.mdi-instrument-triangle::before {
  content: "\\F104E"; }

.mdi-integrated-circuit-chip::before {
  content: "\\F1913"; }

.mdi-invert-colors::before {
  content: "\\F0301"; }

.mdi-invert-colors-off::before {
  content: "\\F0E4A"; }

.mdi-iobroker::before {
  content: "\\F12E8"; }

.mdi-ip::before {
  content: "\\F0A5F"; }

.mdi-ip-network::before {
  content: "\\F0A60"; }

.mdi-ip-network-outline::before {
  content: "\\F0C90"; }

.mdi-ip-outline::before {
  content: "\\F1982"; }

.mdi-ipod::before {
  content: "\\F0C91"; }

.mdi-iron::before {
  content: "\\F1824"; }

.mdi-iron-board::before {
  content: "\\F1838"; }

.mdi-iron-outline::before {
  content: "\\F1825"; }

.mdi-island::before {
  content: "\\F104F"; }

.mdi-iv-bag::before {
  content: "\\F10B9"; }

.mdi-jabber::before {
  content: "\\F0DD5"; }

.mdi-jeepney::before {
  content: "\\F0302"; }

.mdi-jellyfish::before {
  content: "\\F0F01"; }

.mdi-jellyfish-outline::before {
  content: "\\F0F02"; }

.mdi-jira::before {
  content: "\\F0303"; }

.mdi-jquery::before {
  content: "\\F087D"; }

.mdi-jsfiddle::before {
  content: "\\F0304"; }

.mdi-jump-rope::before {
  content: "\\F12FF"; }

.mdi-kabaddi::before {
  content: "\\F0D87"; }

.mdi-kangaroo::before {
  content: "\\F1558"; }

.mdi-karate::before {
  content: "\\F082C"; }

.mdi-kayaking::before {
  content: "\\F08AF"; }

.mdi-keg::before {
  content: "\\F0305"; }

.mdi-kettle::before {
  content: "\\F05FA"; }

.mdi-kettle-alert::before {
  content: "\\F1317"; }

.mdi-kettle-alert-outline::before {
  content: "\\F1318"; }

.mdi-kettle-off::before {
  content: "\\F131B"; }

.mdi-kettle-off-outline::before {
  content: "\\F131C"; }

.mdi-kettle-outline::before {
  content: "\\F0F56"; }

.mdi-kettle-pour-over::before {
  content: "\\F173C"; }

.mdi-kettle-steam::before {
  content: "\\F1319"; }

.mdi-kettle-steam-outline::before {
  content: "\\F131A"; }

.mdi-kettlebell::before {
  content: "\\F1300"; }

.mdi-key::before {
  content: "\\F0306"; }

.mdi-key-alert::before {
  content: "\\F1983"; }

.mdi-key-alert-outline::before {
  content: "\\F1984"; }

.mdi-key-arrow-right::before {
  content: "\\F1312"; }

.mdi-key-chain::before {
  content: "\\F1574"; }

.mdi-key-chain-variant::before {
  content: "\\F1575"; }

.mdi-key-change::before {
  content: "\\F0307"; }

.mdi-key-link::before {
  content: "\\F119F"; }

.mdi-key-minus::before {
  content: "\\F0308"; }

.mdi-key-outline::before {
  content: "\\F0DD6"; }

.mdi-key-plus::before {
  content: "\\F0309"; }

.mdi-key-remove::before {
  content: "\\F030A"; }

.mdi-key-star::before {
  content: "\\F119E"; }

.mdi-key-variant::before {
  content: "\\F030B"; }

.mdi-key-wireless::before {
  content: "\\F0FC2"; }

.mdi-keyboard::before {
  content: "\\F030C"; }

.mdi-keyboard-backspace::before {
  content: "\\F030D"; }

.mdi-keyboard-caps::before {
  content: "\\F030E"; }

.mdi-keyboard-close::before {
  content: "\\F030F"; }

.mdi-keyboard-esc::before {
  content: "\\F12B7"; }

.mdi-keyboard-f1::before {
  content: "\\F12AB"; }

.mdi-keyboard-f10::before {
  content: "\\F12B4"; }

.mdi-keyboard-f11::before {
  content: "\\F12B5"; }

.mdi-keyboard-f12::before {
  content: "\\F12B6"; }

.mdi-keyboard-f2::before {
  content: "\\F12AC"; }

.mdi-keyboard-f3::before {
  content: "\\F12AD"; }

.mdi-keyboard-f4::before {
  content: "\\F12AE"; }

.mdi-keyboard-f5::before {
  content: "\\F12AF"; }

.mdi-keyboard-f6::before {
  content: "\\F12B0"; }

.mdi-keyboard-f7::before {
  content: "\\F12B1"; }

.mdi-keyboard-f8::before {
  content: "\\F12B2"; }

.mdi-keyboard-f9::before {
  content: "\\F12B3"; }

.mdi-keyboard-off::before {
  content: "\\F0310"; }

.mdi-keyboard-off-outline::before {
  content: "\\F0E4B"; }

.mdi-keyboard-outline::before {
  content: "\\F097B"; }

.mdi-keyboard-return::before {
  content: "\\F0311"; }

.mdi-keyboard-settings::before {
  content: "\\F09F9"; }

.mdi-keyboard-settings-outline::before {
  content: "\\F09FA"; }

.mdi-keyboard-space::before {
  content: "\\F1050"; }

.mdi-keyboard-tab::before {
  content: "\\F0312"; }

.mdi-keyboard-tab-reverse::before {
  content: "\\F0325"; }

.mdi-keyboard-variant::before {
  content: "\\F0313"; }

.mdi-khanda::before {
  content: "\\F10FD"; }

.mdi-kickstarter::before {
  content: "\\F0745"; }

.mdi-kite::before {
  content: "\\F1985"; }

.mdi-kite-outline::before {
  content: "\\F1986"; }

.mdi-kitesurfing::before {
  content: "\\F1744"; }

.mdi-klingon::before {
  content: "\\F135B"; }

.mdi-knife::before {
  content: "\\F09FB"; }

.mdi-knife-military::before {
  content: "\\F09FC"; }

.mdi-koala::before {
  content: "\\F173F"; }

.mdi-kodi::before {
  content: "\\F0314"; }

.mdi-kubernetes::before {
  content: "\\F10FE"; }

.mdi-label::before {
  content: "\\F0315"; }

.mdi-label-multiple::before {
  content: "\\F1375"; }

.mdi-label-multiple-outline::before {
  content: "\\F1376"; }

.mdi-label-off::before {
  content: "\\F0ACB"; }

.mdi-label-off-outline::before {
  content: "\\F0ACC"; }

.mdi-label-outline::before {
  content: "\\F0316"; }

.mdi-label-percent::before {
  content: "\\F12EA"; }

.mdi-label-percent-outline::before {
  content: "\\F12EB"; }

.mdi-label-variant::before {
  content: "\\F0ACD"; }

.mdi-label-variant-outline::before {
  content: "\\F0ACE"; }

.mdi-ladder::before {
  content: "\\F15A2"; }

.mdi-ladybug::before {
  content: "\\F082D"; }

.mdi-lambda::before {
  content: "\\F0627"; }

.mdi-lamp::before {
  content: "\\F06B5"; }

.mdi-lamp-outline::before {
  content: "\\F17D0"; }

.mdi-lamps::before {
  content: "\\F1576"; }

.mdi-lamps-outline::before {
  content: "\\F17D1"; }

.mdi-lan::before {
  content: "\\F0317"; }

.mdi-lan-check::before {
  content: "\\F12AA"; }

.mdi-lan-connect::before {
  content: "\\F0318"; }

.mdi-lan-disconnect::before {
  content: "\\F0319"; }

.mdi-lan-pending::before {
  content: "\\F031A"; }

.mdi-language-c::before {
  content: "\\F0671"; }

.mdi-language-cpp::before {
  content: "\\F0672"; }

.mdi-language-csharp::before {
  content: "\\F031B"; }

.mdi-language-css3::before {
  content: "\\F031C"; }

.mdi-language-fortran::before {
  content: "\\F121A"; }

.mdi-language-go::before {
  content: "\\F07D3"; }

.mdi-language-haskell::before {
  content: "\\F0C92"; }

.mdi-language-html5::before {
  content: "\\F031D"; }

.mdi-language-java::before {
  content: "\\F0B37"; }

.mdi-language-javascript::before {
  content: "\\F031E"; }

.mdi-language-kotlin::before {
  content: "\\F1219"; }

.mdi-language-lua::before {
  content: "\\F08B1"; }

.mdi-language-markdown::before {
  content: "\\F0354"; }

.mdi-language-markdown-outline::before {
  content: "\\F0F5B"; }

.mdi-language-php::before {
  content: "\\F031F"; }

.mdi-language-python::before {
  content: "\\F0320"; }

.mdi-language-r::before {
  content: "\\F07D4"; }

.mdi-language-ruby::before {
  content: "\\F0D2D"; }

.mdi-language-ruby-on-rails::before {
  content: "\\F0ACF"; }

.mdi-language-rust::before {
  content: "\\F1617"; }

.mdi-language-swift::before {
  content: "\\F06E5"; }

.mdi-language-typescript::before {
  content: "\\F06E6"; }

.mdi-language-xaml::before {
  content: "\\F0673"; }

.mdi-laptop::before {
  content: "\\F0322"; }

.mdi-laptop-off::before {
  content: "\\F06E7"; }

.mdi-laravel::before {
  content: "\\F0AD0"; }

.mdi-laser-pointer::before {
  content: "\\F1484"; }

.mdi-lasso::before {
  content: "\\F0F03"; }

.mdi-lastpass::before {
  content: "\\F0446"; }

.mdi-latitude::before {
  content: "\\F0F57"; }

.mdi-launch::before {
  content: "\\F0327"; }

.mdi-lava-lamp::before {
  content: "\\F07D5"; }

.mdi-layers::before {
  content: "\\F0328"; }

.mdi-layers-edit::before {
  content: "\\F1892"; }

.mdi-layers-minus::before {
  content: "\\F0E4C"; }

.mdi-layers-off::before {
  content: "\\F0329"; }

.mdi-layers-off-outline::before {
  content: "\\F09FD"; }

.mdi-layers-outline::before {
  content: "\\F09FE"; }

.mdi-layers-plus::before {
  content: "\\F0E4D"; }

.mdi-layers-remove::before {
  content: "\\F0E4E"; }

.mdi-layers-search::before {
  content: "\\F1206"; }

.mdi-layers-search-outline::before {
  content: "\\F1207"; }

.mdi-layers-triple::before {
  content: "\\F0F58"; }

.mdi-layers-triple-outline::before {
  content: "\\F0F59"; }

.mdi-lead-pencil::before {
  content: "\\F064F"; }

.mdi-leaf::before {
  content: "\\F032A"; }

.mdi-leaf-circle::before {
  content: "\\F1905"; }

.mdi-leaf-circle-outline::before {
  content: "\\F1906"; }

.mdi-leaf-maple::before {
  content: "\\F0C93"; }

.mdi-leaf-maple-off::before {
  content: "\\F12DA"; }

.mdi-leaf-off::before {
  content: "\\F12D9"; }

.mdi-leak::before {
  content: "\\F0DD7"; }

.mdi-leak-off::before {
  content: "\\F0DD8"; }

.mdi-led-off::before {
  content: "\\F032B"; }

.mdi-led-on::before {
  content: "\\F032C"; }

.mdi-led-outline::before {
  content: "\\F032D"; }

.mdi-led-strip::before {
  content: "\\F07D6"; }

.mdi-led-strip-variant::before {
  content: "\\F1051"; }

.mdi-led-variant-off::before {
  content: "\\F032E"; }

.mdi-led-variant-on::before {
  content: "\\F032F"; }

.mdi-led-variant-outline::before {
  content: "\\F0330"; }

.mdi-leek::before {
  content: "\\F117D"; }

.mdi-less-than::before {
  content: "\\F097C"; }

.mdi-less-than-or-equal::before {
  content: "\\F097D"; }

.mdi-library::before {
  content: "\\F0331"; }

.mdi-library-shelves::before {
  content: "\\F0BA9"; }

.mdi-license::before {
  content: "\\F0FC3"; }

.mdi-lifebuoy::before {
  content: "\\F087E"; }

.mdi-light-flood-down::before {
  content: "\\F1987"; }

.mdi-light-flood-up::before {
  content: "\\F1988"; }

.mdi-light-recessed::before {
  content: "\\F179B"; }

.mdi-light-switch::before {
  content: "\\F097E"; }

.mdi-lightbulb::before {
  content: "\\F0335"; }

.mdi-lightbulb-auto::before {
  content: "\\F1800"; }

.mdi-lightbulb-auto-outline::before {
  content: "\\F1801"; }

.mdi-lightbulb-cfl::before {
  content: "\\F1208"; }

.mdi-lightbulb-cfl-off::before {
  content: "\\F1209"; }

.mdi-lightbulb-cfl-spiral::before {
  content: "\\F1275"; }

.mdi-lightbulb-cfl-spiral-off::before {
  content: "\\F12C3"; }

.mdi-lightbulb-fluorescent-tube::before {
  content: "\\F1804"; }

.mdi-lightbulb-fluorescent-tube-outline::before {
  content: "\\F1805"; }

.mdi-lightbulb-group::before {
  content: "\\F1253"; }

.mdi-lightbulb-group-off::before {
  content: "\\F12CD"; }

.mdi-lightbulb-group-off-outline::before {
  content: "\\F12CE"; }

.mdi-lightbulb-group-outline::before {
  content: "\\F1254"; }

.mdi-lightbulb-multiple::before {
  content: "\\F1255"; }

.mdi-lightbulb-multiple-off::before {
  content: "\\F12CF"; }

.mdi-lightbulb-multiple-off-outline::before {
  content: "\\F12D0"; }

.mdi-lightbulb-multiple-outline::before {
  content: "\\F1256"; }

.mdi-lightbulb-off::before {
  content: "\\F0E4F"; }

.mdi-lightbulb-off-outline::before {
  content: "\\F0E50"; }

.mdi-lightbulb-on::before {
  content: "\\F06E8"; }

.mdi-lightbulb-on-outline::before {
  content: "\\F06E9"; }

.mdi-lightbulb-outline::before {
  content: "\\F0336"; }

.mdi-lightbulb-spot::before {
  content: "\\F17F4"; }

.mdi-lightbulb-spot-off::before {
  content: "\\F17F5"; }

.mdi-lightbulb-variant::before {
  content: "\\F1802"; }

.mdi-lightbulb-variant-outline::before {
  content: "\\F1803"; }

.mdi-lighthouse::before {
  content: "\\F09FF"; }

.mdi-lighthouse-on::before {
  content: "\\F0A00"; }

.mdi-lightning-bolt::before {
  content: "\\F140B"; }

.mdi-lightning-bolt-circle::before {
  content: "\\F0820"; }

.mdi-lightning-bolt-outline::before {
  content: "\\F140C"; }

.mdi-line-scan::before {
  content: "\\F0624"; }

.mdi-lingerie::before {
  content: "\\F1476"; }

.mdi-link::before {
  content: "\\F0337"; }

.mdi-link-box::before {
  content: "\\F0D1A"; }

.mdi-link-box-outline::before {
  content: "\\F0D1B"; }

.mdi-link-box-variant::before {
  content: "\\F0D1C"; }

.mdi-link-box-variant-outline::before {
  content: "\\F0D1D"; }

.mdi-link-lock::before {
  content: "\\F10BA"; }

.mdi-link-off::before {
  content: "\\F0338"; }

.mdi-link-plus::before {
  content: "\\F0C94"; }

.mdi-link-variant::before {
  content: "\\F0339"; }

.mdi-link-variant-minus::before {
  content: "\\F10FF"; }

.mdi-link-variant-off::before {
  content: "\\F033A"; }

.mdi-link-variant-plus::before {
  content: "\\F1100"; }

.mdi-link-variant-remove::before {
  content: "\\F1101"; }

.mdi-linkedin::before {
  content: "\\F033B"; }

.mdi-linux::before {
  content: "\\F033D"; }

.mdi-linux-mint::before {
  content: "\\F08ED"; }

.mdi-lipstick::before {
  content: "\\F13B5"; }

.mdi-liquid-spot::before {
  content: "\\F1826"; }

.mdi-liquor::before {
  content: "\\F191E"; }

.mdi-list-status::before {
  content: "\\F15AB"; }

.mdi-litecoin::before {
  content: "\\F0A61"; }

.mdi-loading::before {
  content: "\\F0772"; }

.mdi-location-enter::before {
  content: "\\F0FC4"; }

.mdi-location-exit::before {
  content: "\\F0FC5"; }

.mdi-lock::before {
  content: "\\F033E"; }

.mdi-lock-alert::before {
  content: "\\F08EE"; }

.mdi-lock-alert-outline::before {
  content: "\\F15D1"; }

.mdi-lock-check::before {
  content: "\\F139A"; }

.mdi-lock-check-outline::before {
  content: "\\F16A8"; }

.mdi-lock-clock::before {
  content: "\\F097F"; }

.mdi-lock-minus::before {
  content: "\\F16A9"; }

.mdi-lock-minus-outline::before {
  content: "\\F16AA"; }

.mdi-lock-off::before {
  content: "\\F1671"; }

.mdi-lock-off-outline::before {
  content: "\\F1672"; }

.mdi-lock-open::before {
  content: "\\F033F"; }

.mdi-lock-open-alert::before {
  content: "\\F139B"; }

.mdi-lock-open-alert-outline::before {
  content: "\\F15D2"; }

.mdi-lock-open-check::before {
  content: "\\F139C"; }

.mdi-lock-open-check-outline::before {
  content: "\\F16AB"; }

.mdi-lock-open-minus::before {
  content: "\\F16AC"; }

.mdi-lock-open-minus-outline::before {
  content: "\\F16AD"; }

.mdi-lock-open-outline::before {
  content: "\\F0340"; }

.mdi-lock-open-plus::before {
  content: "\\F16AE"; }

.mdi-lock-open-plus-outline::before {
  content: "\\F16AF"; }

.mdi-lock-open-remove::before {
  content: "\\F16B0"; }

.mdi-lock-open-remove-outline::before {
  content: "\\F16B1"; }

.mdi-lock-open-variant::before {
  content: "\\F0FC6"; }

.mdi-lock-open-variant-outline::before {
  content: "\\F0FC7"; }

.mdi-lock-outline::before {
  content: "\\F0341"; }

.mdi-lock-pattern::before {
  content: "\\F06EA"; }

.mdi-lock-plus::before {
  content: "\\F05FB"; }

.mdi-lock-plus-outline::before {
  content: "\\F16B2"; }

.mdi-lock-question::before {
  content: "\\F08EF"; }

.mdi-lock-remove::before {
  content: "\\F16B3"; }

.mdi-lock-remove-outline::before {
  content: "\\F16B4"; }

.mdi-lock-reset::before {
  content: "\\F0773"; }

.mdi-lock-smart::before {
  content: "\\F08B2"; }

.mdi-locker::before {
  content: "\\F07D7"; }

.mdi-locker-multiple::before {
  content: "\\F07D8"; }

.mdi-login::before {
  content: "\\F0342"; }

.mdi-login-variant::before {
  content: "\\F05FC"; }

.mdi-logout::before {
  content: "\\F0343"; }

.mdi-logout-variant::before {
  content: "\\F05FD"; }

.mdi-longitude::before {
  content: "\\F0F5A"; }

.mdi-looks::before {
  content: "\\F0344"; }

.mdi-lotion::before {
  content: "\\F1582"; }

.mdi-lotion-outline::before {
  content: "\\F1583"; }

.mdi-lotion-plus::before {
  content: "\\F1584"; }

.mdi-lotion-plus-outline::before {
  content: "\\F1585"; }

.mdi-loupe::before {
  content: "\\F0345"; }

.mdi-lumx::before {
  content: "\\F0346"; }

.mdi-lungs::before {
  content: "\\F1084"; }

.mdi-mace::before {
  content: "\\F1843"; }

.mdi-magazine-pistol::before {
  content: "\\F0324"; }

.mdi-magazine-rifle::before {
  content: "\\F0323"; }

.mdi-magic-staff::before {
  content: "\\F1844"; }

.mdi-magnet::before {
  content: "\\F0347"; }

.mdi-magnet-on::before {
  content: "\\F0348"; }

.mdi-magnify::before {
  content: "\\F0349"; }

.mdi-magnify-close::before {
  content: "\\F0980"; }

.mdi-magnify-expand::before {
  content: "\\F1874"; }

.mdi-magnify-minus::before {
  content: "\\F034A"; }

.mdi-magnify-minus-cursor::before {
  content: "\\F0A62"; }

.mdi-magnify-minus-outline::before {
  content: "\\F06EC"; }

.mdi-magnify-plus::before {
  content: "\\F034B"; }

.mdi-magnify-plus-cursor::before {
  content: "\\F0A63"; }

.mdi-magnify-plus-outline::before {
  content: "\\F06ED"; }

.mdi-magnify-remove-cursor::before {
  content: "\\F120C"; }

.mdi-magnify-remove-outline::before {
  content: "\\F120D"; }

.mdi-magnify-scan::before {
  content: "\\F1276"; }

.mdi-mail::before {
  content: "\\F0EBB"; }

.mdi-mailbox::before {
  content: "\\F06EE"; }

.mdi-mailbox-open::before {
  content: "\\F0D88"; }

.mdi-mailbox-open-outline::before {
  content: "\\F0D89"; }

.mdi-mailbox-open-up::before {
  content: "\\F0D8A"; }

.mdi-mailbox-open-up-outline::before {
  content: "\\F0D8B"; }

.mdi-mailbox-outline::before {
  content: "\\F0D8C"; }

.mdi-mailbox-up::before {
  content: "\\F0D8D"; }

.mdi-mailbox-up-outline::before {
  content: "\\F0D8E"; }

.mdi-manjaro::before {
  content: "\\F160A"; }

.mdi-map::before {
  content: "\\F034D"; }

.mdi-map-check::before {
  content: "\\F0EBC"; }

.mdi-map-check-outline::before {
  content: "\\F0EBD"; }

.mdi-map-clock::before {
  content: "\\F0D1E"; }

.mdi-map-clock-outline::before {
  content: "\\F0D1F"; }

.mdi-map-legend::before {
  content: "\\F0A01"; }

.mdi-map-marker::before {
  content: "\\F034E"; }

.mdi-map-marker-account::before {
  content: "\\F18E3"; }

.mdi-map-marker-account-outline::before {
  content: "\\F18E4"; }

.mdi-map-marker-alert::before {
  content: "\\F0F05"; }

.mdi-map-marker-alert-outline::before {
  content: "\\F0F06"; }

.mdi-map-marker-check::before {
  content: "\\F0C95"; }

.mdi-map-marker-check-outline::before {
  content: "\\F12FB"; }

.mdi-map-marker-circle::before {
  content: "\\F034F"; }

.mdi-map-marker-distance::before {
  content: "\\F08F0"; }

.mdi-map-marker-down::before {
  content: "\\F1102"; }

.mdi-map-marker-left::before {
  content: "\\F12DB"; }

.mdi-map-marker-left-outline::before {
  content: "\\F12DD"; }

.mdi-map-marker-minus::before {
  content: "\\F0650"; }

.mdi-map-marker-minus-outline::before {
  content: "\\F12F9"; }

.mdi-map-marker-multiple::before {
  content: "\\F0350"; }

.mdi-map-marker-multiple-outline::before {
  content: "\\F1277"; }

.mdi-map-marker-off::before {
  content: "\\F0351"; }

.mdi-map-marker-off-outline::before {
  content: "\\F12FD"; }

.mdi-map-marker-outline::before {
  content: "\\F07D9"; }

.mdi-map-marker-path::before {
  content: "\\F0D20"; }

.mdi-map-marker-plus::before {
  content: "\\F0651"; }

.mdi-map-marker-plus-outline::before {
  content: "\\F12F8"; }

.mdi-map-marker-question::before {
  content: "\\F0F07"; }

.mdi-map-marker-question-outline::before {
  content: "\\F0F08"; }

.mdi-map-marker-radius::before {
  content: "\\F0352"; }

.mdi-map-marker-radius-outline::before {
  content: "\\F12FC"; }

.mdi-map-marker-remove::before {
  content: "\\F0F09"; }

.mdi-map-marker-remove-outline::before {
  content: "\\F12FA"; }

.mdi-map-marker-remove-variant::before {
  content: "\\F0F0A"; }

.mdi-map-marker-right::before {
  content: "\\F12DC"; }

.mdi-map-marker-right-outline::before {
  content: "\\F12DE"; }

.mdi-map-marker-star::before {
  content: "\\F1608"; }

.mdi-map-marker-star-outline::before {
  content: "\\F1609"; }

.mdi-map-marker-up::before {
  content: "\\F1103"; }

.mdi-map-minus::before {
  content: "\\F0981"; }

.mdi-map-outline::before {
  content: "\\F0982"; }

.mdi-map-plus::before {
  content: "\\F0983"; }

.mdi-map-search::before {
  content: "\\F0984"; }

.mdi-map-search-outline::before {
  content: "\\F0985"; }

.mdi-mapbox::before {
  content: "\\F0BAA"; }

.mdi-margin::before {
  content: "\\F0353"; }

.mdi-marker::before {
  content: "\\F0652"; }

.mdi-marker-cancel::before {
  content: "\\F0DD9"; }

.mdi-marker-check::before {
  content: "\\F0355"; }

.mdi-mastodon::before {
  content: "\\F0AD1"; }

.mdi-material-design::before {
  content: "\\F0986"; }

.mdi-material-ui::before {
  content: "\\F0357"; }

.mdi-math-compass::before {
  content: "\\F0358"; }

.mdi-math-cos::before {
  content: "\\F0C96"; }

.mdi-math-integral::before {
  content: "\\F0FC8"; }

.mdi-math-integral-box::before {
  content: "\\F0FC9"; }

.mdi-math-log::before {
  content: "\\F1085"; }

.mdi-math-norm::before {
  content: "\\F0FCA"; }

.mdi-math-norm-box::before {
  content: "\\F0FCB"; }

.mdi-math-sin::before {
  content: "\\F0C97"; }

.mdi-math-tan::before {
  content: "\\F0C98"; }

.mdi-matrix::before {
  content: "\\F0628"; }

.mdi-medal::before {
  content: "\\F0987"; }

.mdi-medal-outline::before {
  content: "\\F1326"; }

.mdi-medical-bag::before {
  content: "\\F06EF"; }

.mdi-meditation::before {
  content: "\\F117B"; }

.mdi-memory::before {
  content: "\\F035B"; }

.mdi-menorah::before {
  content: "\\F17D4"; }

.mdi-menorah-fire::before {
  content: "\\F17D5"; }

.mdi-menu::before {
  content: "\\F035C"; }

.mdi-menu-down::before {
  content: "\\F035D"; }

.mdi-menu-down-outline::before {
  content: "\\F06B6"; }

.mdi-menu-left::before {
  content: "\\F035E"; }

.mdi-menu-left-outline::before {
  content: "\\F0A02"; }

.mdi-menu-open::before {
  content: "\\F0BAB"; }

.mdi-menu-right::before {
  content: "\\F035F"; }

.mdi-menu-right-outline::before {
  content: "\\F0A03"; }

.mdi-menu-swap::before {
  content: "\\F0A64"; }

.mdi-menu-swap-outline::before {
  content: "\\F0A65"; }

.mdi-menu-up::before {
  content: "\\F0360"; }

.mdi-menu-up-outline::before {
  content: "\\F06B7"; }

.mdi-merge::before {
  content: "\\F0F5C"; }

.mdi-message::before {
  content: "\\F0361"; }

.mdi-message-alert::before {
  content: "\\F0362"; }

.mdi-message-alert-outline::before {
  content: "\\F0A04"; }

.mdi-message-arrow-left::before {
  content: "\\F12F2"; }

.mdi-message-arrow-left-outline::before {
  content: "\\F12F3"; }

.mdi-message-arrow-right::before {
  content: "\\F12F4"; }

.mdi-message-arrow-right-outline::before {
  content: "\\F12F5"; }

.mdi-message-badge::before {
  content: "\\F1941"; }

.mdi-message-badge-outline::before {
  content: "\\F1942"; }

.mdi-message-bookmark::before {
  content: "\\F15AC"; }

.mdi-message-bookmark-outline::before {
  content: "\\F15AD"; }

.mdi-message-bulleted::before {
  content: "\\F06A2"; }

.mdi-message-bulleted-off::before {
  content: "\\F06A3"; }

.mdi-message-cog::before {
  content: "\\F06F1"; }

.mdi-message-cog-outline::before {
  content: "\\F1172"; }

.mdi-message-draw::before {
  content: "\\F0363"; }

.mdi-message-flash::before {
  content: "\\F15A9"; }

.mdi-message-flash-outline::before {
  content: "\\F15AA"; }

.mdi-message-image::before {
  content: "\\F0364"; }

.mdi-message-image-outline::before {
  content: "\\F116C"; }

.mdi-message-lock::before {
  content: "\\F0FCC"; }

.mdi-message-lock-outline::before {
  content: "\\F116D"; }

.mdi-message-minus::before {
  content: "\\F116E"; }

.mdi-message-minus-outline::before {
  content: "\\F116F"; }

.mdi-message-off::before {
  content: "\\F164D"; }

.mdi-message-off-outline::before {
  content: "\\F164E"; }

.mdi-message-outline::before {
  content: "\\F0365"; }

.mdi-message-plus::before {
  content: "\\F0653"; }

.mdi-message-plus-outline::before {
  content: "\\F10BB"; }

.mdi-message-processing::before {
  content: "\\F0366"; }

.mdi-message-processing-outline::before {
  content: "\\F1170"; }

.mdi-message-question::before {
  content: "\\F173A"; }

.mdi-message-question-outline::before {
  content: "\\F173B"; }

.mdi-message-reply::before {
  content: "\\F0367"; }

.mdi-message-reply-outline::before {
  content: "\\F173D"; }

.mdi-message-reply-text::before {
  content: "\\F0368"; }

.mdi-message-reply-text-outline::before {
  content: "\\F173E"; }

.mdi-message-settings::before {
  content: "\\F06F0"; }

.mdi-message-settings-outline::before {
  content: "\\F1171"; }

.mdi-message-star::before {
  content: "\\F069A"; }

.mdi-message-star-outline::before {
  content: "\\F1250"; }

.mdi-message-text::before {
  content: "\\F0369"; }

.mdi-message-text-clock::before {
  content: "\\F1173"; }

.mdi-message-text-clock-outline::before {
  content: "\\F1174"; }

.mdi-message-text-lock::before {
  content: "\\F0FCD"; }

.mdi-message-text-lock-outline::before {
  content: "\\F1175"; }

.mdi-message-text-outline::before {
  content: "\\F036A"; }

.mdi-message-video::before {
  content: "\\F036B"; }

.mdi-meteor::before {
  content: "\\F0629"; }

.mdi-metronome::before {
  content: "\\F07DA"; }

.mdi-metronome-tick::before {
  content: "\\F07DB"; }

.mdi-micro-sd::before {
  content: "\\F07DC"; }

.mdi-microphone::before {
  content: "\\F036C"; }

.mdi-microphone-minus::before {
  content: "\\F08B3"; }

.mdi-microphone-off::before {
  content: "\\F036D"; }

.mdi-microphone-outline::before {
  content: "\\F036E"; }

.mdi-microphone-plus::before {
  content: "\\F08B4"; }

.mdi-microphone-question::before {
  content: "\\F1989"; }

.mdi-microphone-question-outline::before {
  content: "\\F198A"; }

.mdi-microphone-settings::before {
  content: "\\F036F"; }

.mdi-microphone-variant::before {
  content: "\\F0370"; }

.mdi-microphone-variant-off::before {
  content: "\\F0371"; }

.mdi-microscope::before {
  content: "\\F0654"; }

.mdi-microsoft::before {
  content: "\\F0372"; }

.mdi-microsoft-access::before {
  content: "\\F138E"; }

.mdi-microsoft-azure::before {
  content: "\\F0805"; }

.mdi-microsoft-azure-devops::before {
  content: "\\F0FD5"; }

.mdi-microsoft-bing::before {
  content: "\\F00A4"; }

.mdi-microsoft-dynamics-365::before {
  content: "\\F0988"; }

.mdi-microsoft-edge::before {
  content: "\\F01E9"; }

.mdi-microsoft-excel::before {
  content: "\\F138F"; }

.mdi-microsoft-internet-explorer::before {
  content: "\\F0300"; }

.mdi-microsoft-office::before {
  content: "\\F03C6"; }

.mdi-microsoft-onedrive::before {
  content: "\\F03CA"; }

.mdi-microsoft-onenote::before {
  content: "\\F0747"; }

.mdi-microsoft-outlook::before {
  content: "\\F0D22"; }

.mdi-microsoft-powerpoint::before {
  content: "\\F1390"; }

.mdi-microsoft-sharepoint::before {
  content: "\\F1391"; }

.mdi-microsoft-teams::before {
  content: "\\F02BB"; }

.mdi-microsoft-visual-studio::before {
  content: "\\F0610"; }

.mdi-microsoft-visual-studio-code::before {
  content: "\\F0A1E"; }

.mdi-microsoft-windows::before {
  content: "\\F05B3"; }

.mdi-microsoft-windows-classic::before {
  content: "\\F0A21"; }

.mdi-microsoft-word::before {
  content: "\\F1392"; }

.mdi-microsoft-xbox::before {
  content: "\\F05B9"; }

.mdi-microsoft-xbox-controller::before {
  content: "\\F05BA"; }

.mdi-microsoft-xbox-controller-battery-alert::before {
  content: "\\F074B"; }

.mdi-microsoft-xbox-controller-battery-charging::before {
  content: "\\F0A22"; }

.mdi-microsoft-xbox-controller-battery-empty::before {
  content: "\\F074C"; }

.mdi-microsoft-xbox-controller-battery-full::before {
  content: "\\F074D"; }

.mdi-microsoft-xbox-controller-battery-low::before {
  content: "\\F074E"; }

.mdi-microsoft-xbox-controller-battery-medium::before {
  content: "\\F074F"; }

.mdi-microsoft-xbox-controller-battery-unknown::before {
  content: "\\F0750"; }

.mdi-microsoft-xbox-controller-menu::before {
  content: "\\F0E6F"; }

.mdi-microsoft-xbox-controller-off::before {
  content: "\\F05BB"; }

.mdi-microsoft-xbox-controller-view::before {
  content: "\\F0E70"; }

.mdi-microwave::before {
  content: "\\F0C99"; }

.mdi-microwave-off::before {
  content: "\\F1423"; }

.mdi-middleware::before {
  content: "\\F0F5D"; }

.mdi-middleware-outline::before {
  content: "\\F0F5E"; }

.mdi-midi::before {
  content: "\\F08F1"; }

.mdi-midi-port::before {
  content: "\\F08F2"; }

.mdi-mine::before {
  content: "\\F0DDA"; }

.mdi-minecraft::before {
  content: "\\F0373"; }

.mdi-mini-sd::before {
  content: "\\F0A05"; }

.mdi-minidisc::before {
  content: "\\F0A06"; }

.mdi-minus::before {
  content: "\\F0374"; }

.mdi-minus-box::before {
  content: "\\F0375"; }

.mdi-minus-box-multiple::before {
  content: "\\F1141"; }

.mdi-minus-box-multiple-outline::before {
  content: "\\F1142"; }

.mdi-minus-box-outline::before {
  content: "\\F06F2"; }

.mdi-minus-circle::before {
  content: "\\F0376"; }

.mdi-minus-circle-multiple::before {
  content: "\\F035A"; }

.mdi-minus-circle-multiple-outline::before {
  content: "\\F0AD3"; }

.mdi-minus-circle-off::before {
  content: "\\F1459"; }

.mdi-minus-circle-off-outline::before {
  content: "\\F145A"; }

.mdi-minus-circle-outline::before {
  content: "\\F0377"; }

.mdi-minus-network::before {
  content: "\\F0378"; }

.mdi-minus-network-outline::before {
  content: "\\F0C9A"; }

.mdi-minus-thick::before {
  content: "\\F1639"; }

.mdi-mirror::before {
  content: "\\F11FD"; }

.mdi-mirror-rectangle::before {
  content: "\\F179F"; }

.mdi-mirror-variant::before {
  content: "\\F17A0"; }

.mdi-mixed-martial-arts::before {
  content: "\\F0D8F"; }

.mdi-mixed-reality::before {
  content: "\\F087F"; }

.mdi-molecule::before {
  content: "\\F0BAC"; }

.mdi-molecule-co::before {
  content: "\\F12FE"; }

.mdi-molecule-co2::before {
  content: "\\F07E4"; }

.mdi-monitor::before {
  content: "\\F0379"; }

.mdi-monitor-cellphone::before {
  content: "\\F0989"; }

.mdi-monitor-cellphone-star::before {
  content: "\\F098A"; }

.mdi-monitor-dashboard::before {
  content: "\\F0A07"; }

.mdi-monitor-edit::before {
  content: "\\F12C6"; }

.mdi-monitor-eye::before {
  content: "\\F13B4"; }

.mdi-monitor-lock::before {
  content: "\\F0DDB"; }

.mdi-monitor-multiple::before {
  content: "\\F037A"; }

.mdi-monitor-off::before {
  content: "\\F0D90"; }

.mdi-monitor-screenshot::before {
  content: "\\F0E51"; }

.mdi-monitor-share::before {
  content: "\\F1483"; }

.mdi-monitor-shimmer::before {
  content: "\\F1104"; }

.mdi-monitor-small::before {
  content: "\\F1876"; }

.mdi-monitor-speaker::before {
  content: "\\F0F5F"; }

.mdi-monitor-speaker-off::before {
  content: "\\F0F60"; }

.mdi-monitor-star::before {
  content: "\\F0DDC"; }

.mdi-moon-first-quarter::before {
  content: "\\F0F61"; }

.mdi-moon-full::before {
  content: "\\F0F62"; }

.mdi-moon-last-quarter::before {
  content: "\\F0F63"; }

.mdi-moon-new::before {
  content: "\\F0F64"; }

.mdi-moon-waning-crescent::before {
  content: "\\F0F65"; }

.mdi-moon-waning-gibbous::before {
  content: "\\F0F66"; }

.mdi-moon-waxing-crescent::before {
  content: "\\F0F67"; }

.mdi-moon-waxing-gibbous::before {
  content: "\\F0F68"; }

.mdi-moped::before {
  content: "\\F1086"; }

.mdi-moped-electric::before {
  content: "\\F15B7"; }

.mdi-moped-electric-outline::before {
  content: "\\F15B8"; }

.mdi-moped-outline::before {
  content: "\\F15B9"; }

.mdi-more::before {
  content: "\\F037B"; }

.mdi-mortar-pestle::before {
  content: "\\F1748"; }

.mdi-mortar-pestle-plus::before {
  content: "\\F03F1"; }

.mdi-mosque::before {
  content: "\\F1827"; }

.mdi-mother-heart::before {
  content: "\\F1314"; }

.mdi-mother-nurse::before {
  content: "\\F0D21"; }

.mdi-motion::before {
  content: "\\F15B2"; }

.mdi-motion-outline::before {
  content: "\\F15B3"; }

.mdi-motion-pause::before {
  content: "\\F1590"; }

.mdi-motion-pause-outline::before {
  content: "\\F1592"; }

.mdi-motion-play::before {
  content: "\\F158F"; }

.mdi-motion-play-outline::before {
  content: "\\F1591"; }

.mdi-motion-sensor::before {
  content: "\\F0D91"; }

.mdi-motion-sensor-off::before {
  content: "\\F1435"; }

.mdi-motorbike::before {
  content: "\\F037C"; }

.mdi-motorbike-electric::before {
  content: "\\F15BA"; }

.mdi-mouse::before {
  content: "\\F037D"; }

.mdi-mouse-bluetooth::before {
  content: "\\F098B"; }

.mdi-mouse-move-down::before {
  content: "\\F1550"; }

.mdi-mouse-move-up::before {
  content: "\\F1551"; }

.mdi-mouse-move-vertical::before {
  content: "\\F1552"; }

.mdi-mouse-off::before {
  content: "\\F037E"; }

.mdi-mouse-variant::before {
  content: "\\F037F"; }

.mdi-mouse-variant-off::before {
  content: "\\F0380"; }

.mdi-move-resize::before {
  content: "\\F0655"; }

.mdi-move-resize-variant::before {
  content: "\\F0656"; }

.mdi-movie::before {
  content: "\\F0381"; }

.mdi-movie-check::before {
  content: "\\F16F3"; }

.mdi-movie-check-outline::before {
  content: "\\F16F4"; }

.mdi-movie-cog::before {
  content: "\\F16F5"; }

.mdi-movie-cog-outline::before {
  content: "\\F16F6"; }

.mdi-movie-edit::before {
  content: "\\F1122"; }

.mdi-movie-edit-outline::before {
  content: "\\F1123"; }

.mdi-movie-filter::before {
  content: "\\F1124"; }

.mdi-movie-filter-outline::before {
  content: "\\F1125"; }

.mdi-movie-minus::before {
  content: "\\F16F7"; }

.mdi-movie-minus-outline::before {
  content: "\\F16F8"; }

.mdi-movie-off::before {
  content: "\\F16F9"; }

.mdi-movie-off-outline::before {
  content: "\\F16FA"; }

.mdi-movie-open::before {
  content: "\\F0FCE"; }

.mdi-movie-open-check::before {
  content: "\\F16FB"; }

.mdi-movie-open-check-outline::before {
  content: "\\F16FC"; }

.mdi-movie-open-cog::before {
  content: "\\F16FD"; }

.mdi-movie-open-cog-outline::before {
  content: "\\F16FE"; }

.mdi-movie-open-edit::before {
  content: "\\F16FF"; }

.mdi-movie-open-edit-outline::before {
  content: "\\F1700"; }

.mdi-movie-open-minus::before {
  content: "\\F1701"; }

.mdi-movie-open-minus-outline::before {
  content: "\\F1702"; }

.mdi-movie-open-off::before {
  content: "\\F1703"; }

.mdi-movie-open-off-outline::before {
  content: "\\F1704"; }

.mdi-movie-open-outline::before {
  content: "\\F0FCF"; }

.mdi-movie-open-play::before {
  content: "\\F1705"; }

.mdi-movie-open-play-outline::before {
  content: "\\F1706"; }

.mdi-movie-open-plus::before {
  content: "\\F1707"; }

.mdi-movie-open-plus-outline::before {
  content: "\\F1708"; }

.mdi-movie-open-remove::before {
  content: "\\F1709"; }

.mdi-movie-open-remove-outline::before {
  content: "\\F170A"; }

.mdi-movie-open-settings::before {
  content: "\\F170B"; }

.mdi-movie-open-settings-outline::before {
  content: "\\F170C"; }

.mdi-movie-open-star::before {
  content: "\\F170D"; }

.mdi-movie-open-star-outline::before {
  content: "\\F170E"; }

.mdi-movie-outline::before {
  content: "\\F0DDD"; }

.mdi-movie-play::before {
  content: "\\F170F"; }

.mdi-movie-play-outline::before {
  content: "\\F1710"; }

.mdi-movie-plus::before {
  content: "\\F1711"; }

.mdi-movie-plus-outline::before {
  content: "\\F1712"; }

.mdi-movie-remove::before {
  content: "\\F1713"; }

.mdi-movie-remove-outline::before {
  content: "\\F1714"; }

.mdi-movie-roll::before {
  content: "\\F07DE"; }

.mdi-movie-search::before {
  content: "\\F11D2"; }

.mdi-movie-search-outline::before {
  content: "\\F11D3"; }

.mdi-movie-settings::before {
  content: "\\F1715"; }

.mdi-movie-settings-outline::before {
  content: "\\F1716"; }

.mdi-movie-star::before {
  content: "\\F1717"; }

.mdi-movie-star-outline::before {
  content: "\\F1718"; }

.mdi-mower::before {
  content: "\\F166F"; }

.mdi-mower-bag::before {
  content: "\\F1670"; }

.mdi-muffin::before {
  content: "\\F098C"; }

.mdi-multicast::before {
  content: "\\F1893"; }

.mdi-multiplication::before {
  content: "\\F0382"; }

.mdi-multiplication-box::before {
  content: "\\F0383"; }

.mdi-mushroom::before {
  content: "\\F07DF"; }

.mdi-mushroom-off::before {
  content: "\\F13FA"; }

.mdi-mushroom-off-outline::before {
  content: "\\F13FB"; }

.mdi-mushroom-outline::before {
  content: "\\F07E0"; }

.mdi-music::before {
  content: "\\F075A"; }

.mdi-music-accidental-double-flat::before {
  content: "\\F0F69"; }

.mdi-music-accidental-double-sharp::before {
  content: "\\F0F6A"; }

.mdi-music-accidental-flat::before {
  content: "\\F0F6B"; }

.mdi-music-accidental-natural::before {
  content: "\\F0F6C"; }

.mdi-music-accidental-sharp::before {
  content: "\\F0F6D"; }

.mdi-music-box::before {
  content: "\\F0384"; }

.mdi-music-box-multiple::before {
  content: "\\F0333"; }

.mdi-music-box-multiple-outline::before {
  content: "\\F0F04"; }

.mdi-music-box-outline::before {
  content: "\\F0385"; }

.mdi-music-circle::before {
  content: "\\F0386"; }

.mdi-music-circle-outline::before {
  content: "\\F0AD4"; }

.mdi-music-clef-alto::before {
  content: "\\F0F6E"; }

.mdi-music-clef-bass::before {
  content: "\\F0F6F"; }

.mdi-music-clef-treble::before {
  content: "\\F0F70"; }

.mdi-music-note::before {
  content: "\\F0387"; }

.mdi-music-note-bluetooth::before {
  content: "\\F05FE"; }

.mdi-music-note-bluetooth-off::before {
  content: "\\F05FF"; }

.mdi-music-note-eighth::before {
  content: "\\F0388"; }

.mdi-music-note-eighth-dotted::before {
  content: "\\F0F71"; }

.mdi-music-note-half::before {
  content: "\\F0389"; }

.mdi-music-note-half-dotted::before {
  content: "\\F0F72"; }

.mdi-music-note-off::before {
  content: "\\F038A"; }

.mdi-music-note-off-outline::before {
  content: "\\F0F73"; }

.mdi-music-note-outline::before {
  content: "\\F0F74"; }

.mdi-music-note-plus::before {
  content: "\\F0DDE"; }

.mdi-music-note-quarter::before {
  content: "\\F038B"; }

.mdi-music-note-quarter-dotted::before {
  content: "\\F0F75"; }

.mdi-music-note-sixteenth::before {
  content: "\\F038C"; }

.mdi-music-note-sixteenth-dotted::before {
  content: "\\F0F76"; }

.mdi-music-note-whole::before {
  content: "\\F038D"; }

.mdi-music-note-whole-dotted::before {
  content: "\\F0F77"; }

.mdi-music-off::before {
  content: "\\F075B"; }

.mdi-music-rest-eighth::before {
  content: "\\F0F78"; }

.mdi-music-rest-half::before {
  content: "\\F0F79"; }

.mdi-music-rest-quarter::before {
  content: "\\F0F7A"; }

.mdi-music-rest-sixteenth::before {
  content: "\\F0F7B"; }

.mdi-music-rest-whole::before {
  content: "\\F0F7C"; }

.mdi-mustache::before {
  content: "\\F15DE"; }

.mdi-nail::before {
  content: "\\F0DDF"; }

.mdi-nas::before {
  content: "\\F08F3"; }

.mdi-nativescript::before {
  content: "\\F0880"; }

.mdi-nature::before {
  content: "\\F038E"; }

.mdi-nature-people::before {
  content: "\\F038F"; }

.mdi-navigation::before {
  content: "\\F0390"; }

.mdi-navigation-outline::before {
  content: "\\F1607"; }

.mdi-navigation-variant::before {
  content: "\\F18F0"; }

.mdi-navigation-variant-outline::before {
  content: "\\F18F1"; }

.mdi-near-me::before {
  content: "\\F05CD"; }

.mdi-necklace::before {
  content: "\\F0F0B"; }

.mdi-needle::before {
  content: "\\F0391"; }

.mdi-netflix::before {
  content: "\\F0746"; }

.mdi-network::before {
  content: "\\F06F3"; }

.mdi-network-off::before {
  content: "\\F0C9B"; }

.mdi-network-off-outline::before {
  content: "\\F0C9C"; }

.mdi-network-outline::before {
  content: "\\F0C9D"; }

.mdi-network-strength-1::before {
  content: "\\F08F4"; }

.mdi-network-strength-1-alert::before {
  content: "\\F08F5"; }

.mdi-network-strength-2::before {
  content: "\\F08F6"; }

.mdi-network-strength-2-alert::before {
  content: "\\F08F7"; }

.mdi-network-strength-3::before {
  content: "\\F08F8"; }

.mdi-network-strength-3-alert::before {
  content: "\\F08F9"; }

.mdi-network-strength-4::before {
  content: "\\F08FA"; }

.mdi-network-strength-4-alert::before {
  content: "\\F08FB"; }

.mdi-network-strength-4-cog::before {
  content: "\\F191A"; }

.mdi-network-strength-off::before {
  content: "\\F08FC"; }

.mdi-network-strength-off-outline::before {
  content: "\\F08FD"; }

.mdi-network-strength-outline::before {
  content: "\\F08FE"; }

.mdi-new-box::before {
  content: "\\F0394"; }

.mdi-newspaper::before {
  content: "\\F0395"; }

.mdi-newspaper-check::before {
  content: "\\F1943"; }

.mdi-newspaper-minus::before {
  content: "\\F0F0C"; }

.mdi-newspaper-plus::before {
  content: "\\F0F0D"; }

.mdi-newspaper-remove::before {
  content: "\\F1944"; }

.mdi-newspaper-variant::before {
  content: "\\F1001"; }

.mdi-newspaper-variant-multiple::before {
  content: "\\F1002"; }

.mdi-newspaper-variant-multiple-outline::before {
  content: "\\F1003"; }

.mdi-newspaper-variant-outline::before {
  content: "\\F1004"; }

.mdi-nfc::before {
  content: "\\F0396"; }

.mdi-nfc-search-variant::before {
  content: "\\F0E53"; }

.mdi-nfc-tap::before {
  content: "\\F0397"; }

.mdi-nfc-variant::before {
  content: "\\F0398"; }

.mdi-nfc-variant-off::before {
  content: "\\F0E54"; }

.mdi-ninja::before {
  content: "\\F0774"; }

.mdi-nintendo-game-boy::before {
  content: "\\F1393"; }

.mdi-nintendo-switch::before {
  content: "\\F07E1"; }

.mdi-nintendo-wii::before {
  content: "\\F05AB"; }

.mdi-nintendo-wiiu::before {
  content: "\\F072D"; }

.mdi-nix::before {
  content: "\\F1105"; }

.mdi-nodejs::before {
  content: "\\F0399"; }

.mdi-noodles::before {
  content: "\\F117E"; }

.mdi-not-equal::before {
  content: "\\F098D"; }

.mdi-not-equal-variant::before {
  content: "\\F098E"; }

.mdi-note::before {
  content: "\\F039A"; }

.mdi-note-alert::before {
  content: "\\F177D"; }

.mdi-note-alert-outline::before {
  content: "\\F177E"; }

.mdi-note-check::before {
  content: "\\F177F"; }

.mdi-note-check-outline::before {
  content: "\\F1780"; }

.mdi-note-edit::before {
  content: "\\F1781"; }

.mdi-note-edit-outline::before {
  content: "\\F1782"; }

.mdi-note-minus::before {
  content: "\\F164F"; }

.mdi-note-minus-outline::before {
  content: "\\F1650"; }

.mdi-note-multiple::before {
  content: "\\F06B8"; }

.mdi-note-multiple-outline::before {
  content: "\\F06B9"; }

.mdi-note-off::before {
  content: "\\F1783"; }

.mdi-note-off-outline::before {
  content: "\\F1784"; }

.mdi-note-outline::before {
  content: "\\F039B"; }

.mdi-note-plus::before {
  content: "\\F039C"; }

.mdi-note-plus-outline::before {
  content: "\\F039D"; }

.mdi-note-remove::before {
  content: "\\F1651"; }

.mdi-note-remove-outline::before {
  content: "\\F1652"; }

.mdi-note-search::before {
  content: "\\F1653"; }

.mdi-note-search-outline::before {
  content: "\\F1654"; }

.mdi-note-text::before {
  content: "\\F039E"; }

.mdi-note-text-outline::before {
  content: "\\F11D7"; }

.mdi-notebook::before {
  content: "\\F082E"; }

.mdi-notebook-check::before {
  content: "\\F14F5"; }

.mdi-notebook-check-outline::before {
  content: "\\F14F6"; }

.mdi-notebook-edit::before {
  content: "\\F14E7"; }

.mdi-notebook-edit-outline::before {
  content: "\\F14E9"; }

.mdi-notebook-minus::before {
  content: "\\F1610"; }

.mdi-notebook-minus-outline::before {
  content: "\\F1611"; }

.mdi-notebook-multiple::before {
  content: "\\F0E55"; }

.mdi-notebook-outline::before {
  content: "\\F0EBF"; }

.mdi-notebook-plus::before {
  content: "\\F1612"; }

.mdi-notebook-plus-outline::before {
  content: "\\F1613"; }

.mdi-notebook-remove::before {
  content: "\\F1614"; }

.mdi-notebook-remove-outline::before {
  content: "\\F1615"; }

.mdi-notification-clear-all::before {
  content: "\\F039F"; }

.mdi-npm::before {
  content: "\\F06F7"; }

.mdi-nuke::before {
  content: "\\F06A4"; }

.mdi-null::before {
  content: "\\F07E2"; }

.mdi-numeric::before {
  content: "\\F03A0"; }

.mdi-numeric-0::before {
  content: "\\F0B39"; }

.mdi-numeric-0-box::before {
  content: "\\F03A1"; }

.mdi-numeric-0-box-multiple::before {
  content: "\\F0F0E"; }

.mdi-numeric-0-box-multiple-outline::before {
  content: "\\F03A2"; }

.mdi-numeric-0-box-outline::before {
  content: "\\F03A3"; }

.mdi-numeric-0-circle::before {
  content: "\\F0C9E"; }

.mdi-numeric-0-circle-outline::before {
  content: "\\F0C9F"; }

.mdi-numeric-1::before {
  content: "\\F0B3A"; }

.mdi-numeric-1-box::before {
  content: "\\F03A4"; }

.mdi-numeric-1-box-multiple::before {
  content: "\\F0F0F"; }

.mdi-numeric-1-box-multiple-outline::before {
  content: "\\F03A5"; }

.mdi-numeric-1-box-outline::before {
  content: "\\F03A6"; }

.mdi-numeric-1-circle::before {
  content: "\\F0CA0"; }

.mdi-numeric-1-circle-outline::before {
  content: "\\F0CA1"; }

.mdi-numeric-10::before {
  content: "\\F0FE9"; }

.mdi-numeric-10-box::before {
  content: "\\F0F7D"; }

.mdi-numeric-10-box-multiple::before {
  content: "\\F0FEA"; }

.mdi-numeric-10-box-multiple-outline::before {
  content: "\\F0FEB"; }

.mdi-numeric-10-box-outline::before {
  content: "\\F0F7E"; }

.mdi-numeric-10-circle::before {
  content: "\\F0FEC"; }

.mdi-numeric-10-circle-outline::before {
  content: "\\F0FED"; }

.mdi-numeric-2::before {
  content: "\\F0B3B"; }

.mdi-numeric-2-box::before {
  content: "\\F03A7"; }

.mdi-numeric-2-box-multiple::before {
  content: "\\F0F10"; }

.mdi-numeric-2-box-multiple-outline::before {
  content: "\\F03A8"; }

.mdi-numeric-2-box-outline::before {
  content: "\\F03A9"; }

.mdi-numeric-2-circle::before {
  content: "\\F0CA2"; }

.mdi-numeric-2-circle-outline::before {
  content: "\\F0CA3"; }

.mdi-numeric-3::before {
  content: "\\F0B3C"; }

.mdi-numeric-3-box::before {
  content: "\\F03AA"; }

.mdi-numeric-3-box-multiple::before {
  content: "\\F0F11"; }

.mdi-numeric-3-box-multiple-outline::before {
  content: "\\F03AB"; }

.mdi-numeric-3-box-outline::before {
  content: "\\F03AC"; }

.mdi-numeric-3-circle::before {
  content: "\\F0CA4"; }

.mdi-numeric-3-circle-outline::before {
  content: "\\F0CA5"; }

.mdi-numeric-4::before {
  content: "\\F0B3D"; }

.mdi-numeric-4-box::before {
  content: "\\F03AD"; }

.mdi-numeric-4-box-multiple::before {
  content: "\\F0F12"; }

.mdi-numeric-4-box-multiple-outline::before {
  content: "\\F03B2"; }

.mdi-numeric-4-box-outline::before {
  content: "\\F03AE"; }

.mdi-numeric-4-circle::before {
  content: "\\F0CA6"; }

.mdi-numeric-4-circle-outline::before {
  content: "\\F0CA7"; }

.mdi-numeric-5::before {
  content: "\\F0B3E"; }

.mdi-numeric-5-box::before {
  content: "\\F03B1"; }

.mdi-numeric-5-box-multiple::before {
  content: "\\F0F13"; }

.mdi-numeric-5-box-multiple-outline::before {
  content: "\\F03AF"; }

.mdi-numeric-5-box-outline::before {
  content: "\\F03B0"; }

.mdi-numeric-5-circle::before {
  content: "\\F0CA8"; }

.mdi-numeric-5-circle-outline::before {
  content: "\\F0CA9"; }

.mdi-numeric-6::before {
  content: "\\F0B3F"; }

.mdi-numeric-6-box::before {
  content: "\\F03B3"; }

.mdi-numeric-6-box-multiple::before {
  content: "\\F0F14"; }

.mdi-numeric-6-box-multiple-outline::before {
  content: "\\F03B4"; }

.mdi-numeric-6-box-outline::before {
  content: "\\F03B5"; }

.mdi-numeric-6-circle::before {
  content: "\\F0CAA"; }

.mdi-numeric-6-circle-outline::before {
  content: "\\F0CAB"; }

.mdi-numeric-7::before {
  content: "\\F0B40"; }

.mdi-numeric-7-box::before {
  content: "\\F03B6"; }

.mdi-numeric-7-box-multiple::before {
  content: "\\F0F15"; }

.mdi-numeric-7-box-multiple-outline::before {
  content: "\\F03B7"; }

.mdi-numeric-7-box-outline::before {
  content: "\\F03B8"; }

.mdi-numeric-7-circle::before {
  content: "\\F0CAC"; }

.mdi-numeric-7-circle-outline::before {
  content: "\\F0CAD"; }

.mdi-numeric-8::before {
  content: "\\F0B41"; }

.mdi-numeric-8-box::before {
  content: "\\F03B9"; }

.mdi-numeric-8-box-multiple::before {
  content: "\\F0F16"; }

.mdi-numeric-8-box-multiple-outline::before {
  content: "\\F03BA"; }

.mdi-numeric-8-box-outline::before {
  content: "\\F03BB"; }

.mdi-numeric-8-circle::before {
  content: "\\F0CAE"; }

.mdi-numeric-8-circle-outline::before {
  content: "\\F0CAF"; }

.mdi-numeric-9::before {
  content: "\\F0B42"; }

.mdi-numeric-9-box::before {
  content: "\\F03BC"; }

.mdi-numeric-9-box-multiple::before {
  content: "\\F0F17"; }

.mdi-numeric-9-box-multiple-outline::before {
  content: "\\F03BD"; }

.mdi-numeric-9-box-outline::before {
  content: "\\F03BE"; }

.mdi-numeric-9-circle::before {
  content: "\\F0CB0"; }

.mdi-numeric-9-circle-outline::before {
  content: "\\F0CB1"; }

.mdi-numeric-9-plus::before {
  content: "\\F0FEE"; }

.mdi-numeric-9-plus-box::before {
  content: "\\F03BF"; }

.mdi-numeric-9-plus-box-multiple::before {
  content: "\\F0F18"; }

.mdi-numeric-9-plus-box-multiple-outline::before {
  content: "\\F03C0"; }

.mdi-numeric-9-plus-box-outline::before {
  content: "\\F03C1"; }

.mdi-numeric-9-plus-circle::before {
  content: "\\F0CB2"; }

.mdi-numeric-9-plus-circle-outline::before {
  content: "\\F0CB3"; }

.mdi-numeric-negative-1::before {
  content: "\\F1052"; }

.mdi-numeric-positive-1::before {
  content: "\\F15CB"; }

.mdi-nut::before {
  content: "\\F06F8"; }

.mdi-nutrition::before {
  content: "\\F03C2"; }

.mdi-nuxt::before {
  content: "\\F1106"; }

.mdi-oar::before {
  content: "\\F067C"; }

.mdi-ocarina::before {
  content: "\\F0DE0"; }

.mdi-oci::before {
  content: "\\F12E9"; }

.mdi-ocr::before {
  content: "\\F113A"; }

.mdi-octagon::before {
  content: "\\F03C3"; }

.mdi-octagon-outline::before {
  content: "\\F03C4"; }

.mdi-octagram::before {
  content: "\\F06F9"; }

.mdi-octagram-outline::before {
  content: "\\F0775"; }

.mdi-octahedron::before {
  content: "\\F1950"; }

.mdi-octahedron-off::before {
  content: "\\F1951"; }

.mdi-odnoklassniki::before {
  content: "\\F03C5"; }

.mdi-offer::before {
  content: "\\F121B"; }

.mdi-office-building::before {
  content: "\\F0991"; }

.mdi-office-building-cog::before {
  content: "\\F1949"; }

.mdi-office-building-cog-outline::before {
  content: "\\F194A"; }

.mdi-office-building-marker::before {
  content: "\\F1520"; }

.mdi-office-building-marker-outline::before {
  content: "\\F1521"; }

.mdi-office-building-outline::before {
  content: "\\F151F"; }

.mdi-oil::before {
  content: "\\F03C7"; }

.mdi-oil-lamp::before {
  content: "\\F0F19"; }

.mdi-oil-level::before {
  content: "\\F1053"; }

.mdi-oil-temperature::before {
  content: "\\F0FF8"; }

.mdi-om::before {
  content: "\\F0973"; }

.mdi-omega::before {
  content: "\\F03C9"; }

.mdi-one-up::before {
  content: "\\F0BAD"; }

.mdi-onepassword::before {
  content: "\\F0881"; }

.mdi-opacity::before {
  content: "\\F05CC"; }

.mdi-open-in-app::before {
  content: "\\F03CB"; }

.mdi-open-in-new::before {
  content: "\\F03CC"; }

.mdi-open-source-initiative::before {
  content: "\\F0BAE"; }

.mdi-openid::before {
  content: "\\F03CD"; }

.mdi-opera::before {
  content: "\\F03CE"; }

.mdi-orbit::before {
  content: "\\F0018"; }

.mdi-orbit-variant::before {
  content: "\\F15DB"; }

.mdi-order-alphabetical-ascending::before {
  content: "\\F020D"; }

.mdi-order-alphabetical-descending::before {
  content: "\\F0D07"; }

.mdi-order-bool-ascending::before {
  content: "\\F02BE"; }

.mdi-order-bool-ascending-variant::before {
  content: "\\F098F"; }

.mdi-order-bool-descending::before {
  content: "\\F1384"; }

.mdi-order-bool-descending-variant::before {
  content: "\\F0990"; }

.mdi-order-numeric-ascending::before {
  content: "\\F0545"; }

.mdi-order-numeric-descending::before {
  content: "\\F0546"; }

.mdi-origin::before {
  content: "\\F0B43"; }

.mdi-ornament::before {
  content: "\\F03CF"; }

.mdi-ornament-variant::before {
  content: "\\F03D0"; }

.mdi-outdoor-lamp::before {
  content: "\\F1054"; }

.mdi-overscan::before {
  content: "\\F1005"; }

.mdi-owl::before {
  content: "\\F03D2"; }

.mdi-pac-man::before {
  content: "\\F0BAF"; }

.mdi-package::before {
  content: "\\F03D3"; }

.mdi-package-down::before {
  content: "\\F03D4"; }

.mdi-package-up::before {
  content: "\\F03D5"; }

.mdi-package-variant::before {
  content: "\\F03D6"; }

.mdi-package-variant-closed::before {
  content: "\\F03D7"; }

.mdi-page-first::before {
  content: "\\F0600"; }

.mdi-page-last::before {
  content: "\\F0601"; }

.mdi-page-layout-body::before {
  content: "\\F06FA"; }

.mdi-page-layout-footer::before {
  content: "\\F06FB"; }

.mdi-page-layout-header::before {
  content: "\\F06FC"; }

.mdi-page-layout-header-footer::before {
  content: "\\F0F7F"; }

.mdi-page-layout-sidebar-left::before {
  content: "\\F06FD"; }

.mdi-page-layout-sidebar-right::before {
  content: "\\F06FE"; }

.mdi-page-next::before {
  content: "\\F0BB0"; }

.mdi-page-next-outline::before {
  content: "\\F0BB1"; }

.mdi-page-previous::before {
  content: "\\F0BB2"; }

.mdi-page-previous-outline::before {
  content: "\\F0BB3"; }

.mdi-pail::before {
  content: "\\F1417"; }

.mdi-pail-minus::before {
  content: "\\F1437"; }

.mdi-pail-minus-outline::before {
  content: "\\F143C"; }

.mdi-pail-off::before {
  content: "\\F1439"; }

.mdi-pail-off-outline::before {
  content: "\\F143E"; }

.mdi-pail-outline::before {
  content: "\\F143A"; }

.mdi-pail-plus::before {
  content: "\\F1436"; }

.mdi-pail-plus-outline::before {
  content: "\\F143B"; }

.mdi-pail-remove::before {
  content: "\\F1438"; }

.mdi-pail-remove-outline::before {
  content: "\\F143D"; }

.mdi-palette::before {
  content: "\\F03D8"; }

.mdi-palette-advanced::before {
  content: "\\F03D9"; }

.mdi-palette-outline::before {
  content: "\\F0E0C"; }

.mdi-palette-swatch::before {
  content: "\\F08B5"; }

.mdi-palette-swatch-outline::before {
  content: "\\F135C"; }

.mdi-palette-swatch-variant::before {
  content: "\\F195A"; }

.mdi-palm-tree::before {
  content: "\\F1055"; }

.mdi-pan::before {
  content: "\\F0BB4"; }

.mdi-pan-bottom-left::before {
  content: "\\F0BB5"; }

.mdi-pan-bottom-right::before {
  content: "\\F0BB6"; }

.mdi-pan-down::before {
  content: "\\F0BB7"; }

.mdi-pan-horizontal::before {
  content: "\\F0BB8"; }

.mdi-pan-left::before {
  content: "\\F0BB9"; }

.mdi-pan-right::before {
  content: "\\F0BBA"; }

.mdi-pan-top-left::before {
  content: "\\F0BBB"; }

.mdi-pan-top-right::before {
  content: "\\F0BBC"; }

.mdi-pan-up::before {
  content: "\\F0BBD"; }

.mdi-pan-vertical::before {
  content: "\\F0BBE"; }

.mdi-panda::before {
  content: "\\F03DA"; }

.mdi-pandora::before {
  content: "\\F03DB"; }

.mdi-panorama::before {
  content: "\\F03DC"; }

.mdi-panorama-fisheye::before {
  content: "\\F03DD"; }

.mdi-panorama-horizontal::before {
  content: "\\F1928"; }

.mdi-panorama-horizontal-outline::before {
  content: "\\F03DE"; }

.mdi-panorama-outline::before {
  content: "\\F198C"; }

.mdi-panorama-sphere::before {
  content: "\\F198D"; }

.mdi-panorama-sphere-outline::before {
  content: "\\F198E"; }

.mdi-panorama-variant::before {
  content: "\\F198F"; }

.mdi-panorama-variant-outline::before {
  content: "\\F1990"; }

.mdi-panorama-vertical::before {
  content: "\\F1929"; }

.mdi-panorama-vertical-outline::before {
  content: "\\F03DF"; }

.mdi-panorama-wide-angle::before {
  content: "\\F195F"; }

.mdi-panorama-wide-angle-outline::before {
  content: "\\F03E0"; }

.mdi-paper-cut-vertical::before {
  content: "\\F03E1"; }

.mdi-paper-roll::before {
  content: "\\F1157"; }

.mdi-paper-roll-outline::before {
  content: "\\F1158"; }

.mdi-paperclip::before {
  content: "\\F03E2"; }

.mdi-parachute::before {
  content: "\\F0CB4"; }

.mdi-parachute-outline::before {
  content: "\\F0CB5"; }

.mdi-paragliding::before {
  content: "\\F1745"; }

.mdi-parking::before {
  content: "\\F03E3"; }

.mdi-party-popper::before {
  content: "\\F1056"; }

.mdi-passport::before {
  content: "\\F07E3"; }

.mdi-passport-biometric::before {
  content: "\\F0DE1"; }

.mdi-pasta::before {
  content: "\\F1160"; }

.mdi-patio-heater::before {
  content: "\\F0F80"; }

.mdi-patreon::before {
  content: "\\F0882"; }

.mdi-pause::before {
  content: "\\F03E4"; }

.mdi-pause-circle::before {
  content: "\\F03E5"; }

.mdi-pause-circle-outline::before {
  content: "\\F03E6"; }

.mdi-pause-octagon::before {
  content: "\\F03E7"; }

.mdi-pause-octagon-outline::before {
  content: "\\F03E8"; }

.mdi-paw::before {
  content: "\\F03E9"; }

.mdi-paw-off::before {
  content: "\\F0657"; }

.mdi-paw-off-outline::before {
  content: "\\F1676"; }

.mdi-paw-outline::before {
  content: "\\F1675"; }

.mdi-peace::before {
  content: "\\F0884"; }

.mdi-peanut::before {
  content: "\\F0FFC"; }

.mdi-peanut-off::before {
  content: "\\F0FFD"; }

.mdi-peanut-off-outline::before {
  content: "\\F0FFF"; }

.mdi-peanut-outline::before {
  content: "\\F0FFE"; }

.mdi-pen::before {
  content: "\\F03EA"; }

.mdi-pen-lock::before {
  content: "\\F0DE2"; }

.mdi-pen-minus::before {
  content: "\\F0DE3"; }

.mdi-pen-off::before {
  content: "\\F0DE4"; }

.mdi-pen-plus::before {
  content: "\\F0DE5"; }

.mdi-pen-remove::before {
  content: "\\F0DE6"; }

.mdi-pencil::before {
  content: "\\F03EB"; }

.mdi-pencil-box::before {
  content: "\\F03EC"; }

.mdi-pencil-box-multiple::before {
  content: "\\F1144"; }

.mdi-pencil-box-multiple-outline::before {
  content: "\\F1145"; }

.mdi-pencil-box-outline::before {
  content: "\\F03ED"; }

.mdi-pencil-circle::before {
  content: "\\F06FF"; }

.mdi-pencil-circle-outline::before {
  content: "\\F0776"; }

.mdi-pencil-lock::before {
  content: "\\F03EE"; }

.mdi-pencil-lock-outline::before {
  content: "\\F0DE7"; }

.mdi-pencil-minus::before {
  content: "\\F0DE8"; }

.mdi-pencil-minus-outline::before {
  content: "\\F0DE9"; }

.mdi-pencil-off::before {
  content: "\\F03EF"; }

.mdi-pencil-off-outline::before {
  content: "\\F0DEA"; }

.mdi-pencil-outline::before {
  content: "\\F0CB6"; }

.mdi-pencil-plus::before {
  content: "\\F0DEB"; }

.mdi-pencil-plus-outline::before {
  content: "\\F0DEC"; }

.mdi-pencil-remove::before {
  content: "\\F0DED"; }

.mdi-pencil-remove-outline::before {
  content: "\\F0DEE"; }

.mdi-pencil-ruler::before {
  content: "\\F1353"; }

.mdi-penguin::before {
  content: "\\F0EC0"; }

.mdi-pentagon::before {
  content: "\\F0701"; }

.mdi-pentagon-outline::before {
  content: "\\F0700"; }

.mdi-pentagram::before {
  content: "\\F1667"; }

.mdi-percent::before {
  content: "\\F03F0"; }

.mdi-percent-outline::before {
  content: "\\F1278"; }

.mdi-periodic-table::before {
  content: "\\F08B6"; }

.mdi-perspective-less::before {
  content: "\\F0D23"; }

.mdi-perspective-more::before {
  content: "\\F0D24"; }

.mdi-ph::before {
  content: "\\F17C5"; }

.mdi-phone::before {
  content: "\\F03F2"; }

.mdi-phone-alert::before {
  content: "\\F0F1A"; }

.mdi-phone-alert-outline::before {
  content: "\\F118E"; }

.mdi-phone-bluetooth::before {
  content: "\\F03F3"; }

.mdi-phone-bluetooth-outline::before {
  content: "\\F118F"; }

.mdi-phone-cancel::before {
  content: "\\F10BC"; }

.mdi-phone-cancel-outline::before {
  content: "\\F1190"; }

.mdi-phone-check::before {
  content: "\\F11A9"; }

.mdi-phone-check-outline::before {
  content: "\\F11AA"; }

.mdi-phone-classic::before {
  content: "\\F0602"; }

.mdi-phone-classic-off::before {
  content: "\\F1279"; }

.mdi-phone-dial::before {
  content: "\\F1559"; }

.mdi-phone-dial-outline::before {
  content: "\\F155A"; }

.mdi-phone-forward::before {
  content: "\\F03F4"; }

.mdi-phone-forward-outline::before {
  content: "\\F1191"; }

.mdi-phone-hangup::before {
  content: "\\F03F5"; }

.mdi-phone-hangup-outline::before {
  content: "\\F1192"; }

.mdi-phone-in-talk::before {
  content: "\\F03F6"; }

.mdi-phone-in-talk-outline::before {
  content: "\\F1182"; }

.mdi-phone-incoming::before {
  content: "\\F03F7"; }

.mdi-phone-incoming-outline::before {
  content: "\\F1193"; }

.mdi-phone-lock::before {
  content: "\\F03F8"; }

.mdi-phone-lock-outline::before {
  content: "\\F1194"; }

.mdi-phone-log::before {
  content: "\\F03F9"; }

.mdi-phone-log-outline::before {
  content: "\\F1195"; }

.mdi-phone-message::before {
  content: "\\F1196"; }

.mdi-phone-message-outline::before {
  content: "\\F1197"; }

.mdi-phone-minus::before {
  content: "\\F0658"; }

.mdi-phone-minus-outline::before {
  content: "\\F1198"; }

.mdi-phone-missed::before {
  content: "\\F03FA"; }

.mdi-phone-missed-outline::before {
  content: "\\F11A5"; }

.mdi-phone-off::before {
  content: "\\F0DEF"; }

.mdi-phone-off-outline::before {
  content: "\\F11A6"; }

.mdi-phone-outgoing::before {
  content: "\\F03FB"; }

.mdi-phone-outgoing-outline::before {
  content: "\\F1199"; }

.mdi-phone-outline::before {
  content: "\\F0DF0"; }

.mdi-phone-paused::before {
  content: "\\F03FC"; }

.mdi-phone-paused-outline::before {
  content: "\\F119A"; }

.mdi-phone-plus::before {
  content: "\\F0659"; }

.mdi-phone-plus-outline::before {
  content: "\\F119B"; }

.mdi-phone-refresh::before {
  content: "\\F1993"; }

.mdi-phone-refresh-outline::before {
  content: "\\F1994"; }

.mdi-phone-remove::before {
  content: "\\F152F"; }

.mdi-phone-remove-outline::before {
  content: "\\F1530"; }

.mdi-phone-return::before {
  content: "\\F082F"; }

.mdi-phone-return-outline::before {
  content: "\\F119C"; }

.mdi-phone-ring::before {
  content: "\\F11AB"; }

.mdi-phone-ring-outline::before {
  content: "\\F11AC"; }

.mdi-phone-rotate-landscape::before {
  content: "\\F0885"; }

.mdi-phone-rotate-portrait::before {
  content: "\\F0886"; }

.mdi-phone-settings::before {
  content: "\\F03FD"; }

.mdi-phone-settings-outline::before {
  content: "\\F119D"; }

.mdi-phone-sync::before {
  content: "\\F1995"; }

.mdi-phone-sync-outline::before {
  content: "\\F1996"; }

.mdi-phone-voip::before {
  content: "\\F03FE"; }

.mdi-pi::before {
  content: "\\F03FF"; }

.mdi-pi-box::before {
  content: "\\F0400"; }

.mdi-pi-hole::before {
  content: "\\F0DF1"; }

.mdi-piano::before {
  content: "\\F067D"; }

.mdi-piano-off::before {
  content: "\\F0698"; }

.mdi-pickaxe::before {
  content: "\\F08B7"; }

.mdi-picture-in-picture-bottom-right::before {
  content: "\\F0E57"; }

.mdi-picture-in-picture-bottom-right-outline::before {
  content: "\\F0E58"; }

.mdi-picture-in-picture-top-right::before {
  content: "\\F0E59"; }

.mdi-picture-in-picture-top-right-outline::before {
  content: "\\F0E5A"; }

.mdi-pier::before {
  content: "\\F0887"; }

.mdi-pier-crane::before {
  content: "\\F0888"; }

.mdi-pig::before {
  content: "\\F0401"; }

.mdi-pig-variant::before {
  content: "\\F1006"; }

.mdi-pig-variant-outline::before {
  content: "\\F1678"; }

.mdi-piggy-bank::before {
  content: "\\F1007"; }

.mdi-piggy-bank-outline::before {
  content: "\\F1679"; }

.mdi-pill::before {
  content: "\\F0402"; }

.mdi-pillar::before {
  content: "\\F0702"; }

.mdi-pin::before {
  content: "\\F0403"; }

.mdi-pin-off::before {
  content: "\\F0404"; }

.mdi-pin-off-outline::before {
  content: "\\F0930"; }

.mdi-pin-outline::before {
  content: "\\F0931"; }

.mdi-pine-tree::before {
  content: "\\F0405"; }

.mdi-pine-tree-box::before {
  content: "\\F0406"; }

.mdi-pine-tree-fire::before {
  content: "\\F141A"; }

.mdi-pinterest::before {
  content: "\\F0407"; }

.mdi-pinwheel::before {
  content: "\\F0AD5"; }

.mdi-pinwheel-outline::before {
  content: "\\F0AD6"; }

.mdi-pipe::before {
  content: "\\F07E5"; }

.mdi-pipe-disconnected::before {
  content: "\\F07E6"; }

.mdi-pipe-leak::before {
  content: "\\F0889"; }

.mdi-pipe-valve::before {
  content: "\\F184D"; }

.mdi-pipe-wrench::before {
  content: "\\F1354"; }

.mdi-pirate::before {
  content: "\\F0A08"; }

.mdi-pistol::before {
  content: "\\F0703"; }

.mdi-piston::before {
  content: "\\F088A"; }

.mdi-pitchfork::before {
  content: "\\F1553"; }

.mdi-pizza::before {
  content: "\\F0409"; }

.mdi-play::before {
  content: "\\F040A"; }

.mdi-play-box::before {
  content: "\\F127A"; }

.mdi-play-box-multiple::before {
  content: "\\F0D19"; }

.mdi-play-box-multiple-outline::before {
  content: "\\F13E6"; }

.mdi-play-box-outline::before {
  content: "\\F040B"; }

.mdi-play-circle::before {
  content: "\\F040C"; }

.mdi-play-circle-outline::before {
  content: "\\F040D"; }

.mdi-play-network::before {
  content: "\\F088B"; }

.mdi-play-network-outline::before {
  content: "\\F0CB7"; }

.mdi-play-outline::before {
  content: "\\F0F1B"; }

.mdi-play-pause::before {
  content: "\\F040E"; }

.mdi-play-protected-content::before {
  content: "\\F040F"; }

.mdi-play-speed::before {
  content: "\\F08FF"; }

.mdi-playlist-check::before {
  content: "\\F05C7"; }

.mdi-playlist-edit::before {
  content: "\\F0900"; }

.mdi-playlist-minus::before {
  content: "\\F0410"; }

.mdi-playlist-music::before {
  content: "\\F0CB8"; }

.mdi-playlist-music-outline::before {
  content: "\\F0CB9"; }

.mdi-playlist-play::before {
  content: "\\F0411"; }

.mdi-playlist-plus::before {
  content: "\\F0412"; }

.mdi-playlist-remove::before {
  content: "\\F0413"; }

.mdi-playlist-star::before {
  content: "\\F0DF2"; }

.mdi-plex::before {
  content: "\\F06BA"; }

.mdi-pliers::before {
  content: "\\F19A4"; }

.mdi-plus::before {
  content: "\\F0415"; }

.mdi-plus-box::before {
  content: "\\F0416"; }

.mdi-plus-box-multiple::before {
  content: "\\F0334"; }

.mdi-plus-box-multiple-outline::before {
  content: "\\F1143"; }

.mdi-plus-box-outline::before {
  content: "\\F0704"; }

.mdi-plus-circle::before {
  content: "\\F0417"; }

.mdi-plus-circle-multiple::before {
  content: "\\F034C"; }

.mdi-plus-circle-multiple-outline::before {
  content: "\\F0418"; }

.mdi-plus-circle-outline::before {
  content: "\\F0419"; }

.mdi-plus-minus::before {
  content: "\\F0992"; }

.mdi-plus-minus-box::before {
  content: "\\F0993"; }

.mdi-plus-minus-variant::before {
  content: "\\F14C9"; }

.mdi-plus-network::before {
  content: "\\F041A"; }

.mdi-plus-network-outline::before {
  content: "\\F0CBA"; }

.mdi-plus-outline::before {
  content: "\\F0705"; }

.mdi-plus-thick::before {
  content: "\\F11EC"; }

.mdi-podcast::before {
  content: "\\F0994"; }

.mdi-podium::before {
  content: "\\F0D25"; }

.mdi-podium-bronze::before {
  content: "\\F0D26"; }

.mdi-podium-gold::before {
  content: "\\F0D27"; }

.mdi-podium-silver::before {
  content: "\\F0D28"; }

.mdi-point-of-sale::before {
  content: "\\F0D92"; }

.mdi-pokeball::before {
  content: "\\F041D"; }

.mdi-pokemon-go::before {
  content: "\\F0A09"; }

.mdi-poker-chip::before {
  content: "\\F0830"; }

.mdi-polaroid::before {
  content: "\\F041E"; }

.mdi-police-badge::before {
  content: "\\F1167"; }

.mdi-police-badge-outline::before {
  content: "\\F1168"; }

.mdi-police-station::before {
  content: "\\F1839"; }

.mdi-poll::before {
  content: "\\F041F"; }

.mdi-polo::before {
  content: "\\F14C3"; }

.mdi-polymer::before {
  content: "\\F0421"; }

.mdi-pool::before {
  content: "\\F0606"; }

.mdi-popcorn::before {
  content: "\\F0422"; }

.mdi-post::before {
  content: "\\F1008"; }

.mdi-post-outline::before {
  content: "\\F1009"; }

.mdi-postage-stamp::before {
  content: "\\F0CBB"; }

.mdi-pot::before {
  content: "\\F02E5"; }

.mdi-pot-mix::before {
  content: "\\F065B"; }

.mdi-pot-mix-outline::before {
  content: "\\F0677"; }

.mdi-pot-outline::before {
  content: "\\F02FF"; }

.mdi-pot-steam::before {
  content: "\\F065A"; }

.mdi-pot-steam-outline::before {
  content: "\\F0326"; }

.mdi-pound::before {
  content: "\\F0423"; }

.mdi-pound-box::before {
  content: "\\F0424"; }

.mdi-pound-box-outline::before {
  content: "\\F117F"; }

.mdi-power::before {
  content: "\\F0425"; }

.mdi-power-cycle::before {
  content: "\\F0901"; }

.mdi-power-off::before {
  content: "\\F0902"; }

.mdi-power-on::before {
  content: "\\F0903"; }

.mdi-power-plug::before {
  content: "\\F06A5"; }

.mdi-power-plug-off::before {
  content: "\\F06A6"; }

.mdi-power-plug-off-outline::before {
  content: "\\F1424"; }

.mdi-power-plug-outline::before {
  content: "\\F1425"; }

.mdi-power-settings::before {
  content: "\\F0426"; }

.mdi-power-sleep::before {
  content: "\\F0904"; }

.mdi-power-socket::before {
  content: "\\F0427"; }

.mdi-power-socket-au::before {
  content: "\\F0905"; }

.mdi-power-socket-ch::before {
  content: "\\F0FB3"; }

.mdi-power-socket-de::before {
  content: "\\F1107"; }

.mdi-power-socket-eu::before {
  content: "\\F07E7"; }

.mdi-power-socket-fr::before {
  content: "\\F1108"; }

.mdi-power-socket-it::before {
  content: "\\F14FF"; }

.mdi-power-socket-jp::before {
  content: "\\F1109"; }

.mdi-power-socket-uk::before {
  content: "\\F07E8"; }

.mdi-power-socket-us::before {
  content: "\\F07E9"; }

.mdi-power-standby::before {
  content: "\\F0906"; }

.mdi-powershell::before {
  content: "\\F0A0A"; }

.mdi-prescription::before {
  content: "\\F0706"; }

.mdi-presentation::before {
  content: "\\F0428"; }

.mdi-presentation-play::before {
  content: "\\F0429"; }

.mdi-pretzel::before {
  content: "\\F1562"; }

.mdi-printer::before {
  content: "\\F042A"; }

.mdi-printer-3d::before {
  content: "\\F042B"; }

.mdi-printer-3d-nozzle::before {
  content: "\\F0E5B"; }

.mdi-printer-3d-nozzle-alert::before {
  content: "\\F11C0"; }

.mdi-printer-3d-nozzle-alert-outline::before {
  content: "\\F11C1"; }

.mdi-printer-3d-nozzle-heat::before {
  content: "\\F18B8"; }

.mdi-printer-3d-nozzle-heat-outline::before {
  content: "\\F18B9"; }

.mdi-printer-3d-nozzle-outline::before {
  content: "\\F0E5C"; }

.mdi-printer-alert::before {
  content: "\\F042C"; }

.mdi-printer-check::before {
  content: "\\F1146"; }

.mdi-printer-eye::before {
  content: "\\F1458"; }

.mdi-printer-off::before {
  content: "\\F0E5D"; }

.mdi-printer-off-outline::before {
  content: "\\F1785"; }

.mdi-printer-outline::before {
  content: "\\F1786"; }

.mdi-printer-pos::before {
  content: "\\F1057"; }

.mdi-printer-search::before {
  content: "\\F1457"; }

.mdi-printer-settings::before {
  content: "\\F0707"; }

.mdi-printer-wireless::before {
  content: "\\F0A0B"; }

.mdi-priority-high::before {
  content: "\\F0603"; }

.mdi-priority-low::before {
  content: "\\F0604"; }

.mdi-professional-hexagon::before {
  content: "\\F042D"; }

.mdi-progress-alert::before {
  content: "\\F0CBC"; }

.mdi-progress-check::before {
  content: "\\F0995"; }

.mdi-progress-clock::before {
  content: "\\F0996"; }

.mdi-progress-close::before {
  content: "\\F110A"; }

.mdi-progress-download::before {
  content: "\\F0997"; }

.mdi-progress-pencil::before {
  content: "\\F1787"; }

.mdi-progress-question::before {
  content: "\\F1522"; }

.mdi-progress-star::before {
  content: "\\F1788"; }

.mdi-progress-upload::before {
  content: "\\F0998"; }

.mdi-progress-wrench::before {
  content: "\\F0CBD"; }

.mdi-projector::before {
  content: "\\F042E"; }

.mdi-projector-screen::before {
  content: "\\F042F"; }

.mdi-projector-screen-off::before {
  content: "\\F180D"; }

.mdi-projector-screen-off-outline::before {
  content: "\\F180E"; }

.mdi-projector-screen-outline::before {
  content: "\\F1724"; }

.mdi-projector-screen-variant::before {
  content: "\\F180F"; }

.mdi-projector-screen-variant-off::before {
  content: "\\F1810"; }

.mdi-projector-screen-variant-off-outline::before {
  content: "\\F1811"; }

.mdi-projector-screen-variant-outline::before {
  content: "\\F1812"; }

.mdi-propane-tank::before {
  content: "\\F1357"; }

.mdi-propane-tank-outline::before {
  content: "\\F1358"; }

.mdi-protocol::before {
  content: "\\F0FD8"; }

.mdi-publish::before {
  content: "\\F06A7"; }

.mdi-publish-off::before {
  content: "\\F1945"; }

.mdi-pulse::before {
  content: "\\F0430"; }

.mdi-pump::before {
  content: "\\F1402"; }

.mdi-pumpkin::before {
  content: "\\F0BBF"; }

.mdi-purse::before {
  content: "\\F0F1C"; }

.mdi-purse-outline::before {
  content: "\\F0F1D"; }

.mdi-puzzle::before {
  content: "\\F0431"; }

.mdi-puzzle-check::before {
  content: "\\F1426"; }

.mdi-puzzle-check-outline::before {
  content: "\\F1427"; }

.mdi-puzzle-edit::before {
  content: "\\F14D3"; }

.mdi-puzzle-edit-outline::before {
  content: "\\F14D9"; }

.mdi-puzzle-heart::before {
  content: "\\F14D4"; }

.mdi-puzzle-heart-outline::before {
  content: "\\F14DA"; }

.mdi-puzzle-minus::before {
  content: "\\F14D1"; }

.mdi-puzzle-minus-outline::before {
  content: "\\F14D7"; }

.mdi-puzzle-outline::before {
  content: "\\F0A66"; }

.mdi-puzzle-plus::before {
  content: "\\F14D0"; }

.mdi-puzzle-plus-outline::before {
  content: "\\F14D6"; }

.mdi-puzzle-remove::before {
  content: "\\F14D2"; }

.mdi-puzzle-remove-outline::before {
  content: "\\F14D8"; }

.mdi-puzzle-star::before {
  content: "\\F14D5"; }

.mdi-puzzle-star-outline::before {
  content: "\\F14DB"; }

.mdi-pyramid::before {
  content: "\\F1952"; }

.mdi-pyramid-off::before {
  content: "\\F1953"; }

.mdi-qi::before {
  content: "\\F0999"; }

.mdi-qqchat::before {
  content: "\\F0605"; }

.mdi-qrcode::before {
  content: "\\F0432"; }

.mdi-qrcode-edit::before {
  content: "\\F08B8"; }

.mdi-qrcode-minus::before {
  content: "\\F118C"; }

.mdi-qrcode-plus::before {
  content: "\\F118B"; }

.mdi-qrcode-remove::before {
  content: "\\F118D"; }

.mdi-qrcode-scan::before {
  content: "\\F0433"; }

.mdi-quadcopter::before {
  content: "\\F0434"; }

.mdi-quality-high::before {
  content: "\\F0435"; }

.mdi-quality-low::before {
  content: "\\F0A0C"; }

.mdi-quality-medium::before {
  content: "\\F0A0D"; }

.mdi-quora::before {
  content: "\\F0D29"; }

.mdi-rabbit::before {
  content: "\\F0907"; }

.mdi-racing-helmet::before {
  content: "\\F0D93"; }

.mdi-racquetball::before {
  content: "\\F0D94"; }

.mdi-radar::before {
  content: "\\F0437"; }

.mdi-radiator::before {
  content: "\\F0438"; }

.mdi-radiator-disabled::before {
  content: "\\F0AD7"; }

.mdi-radiator-off::before {
  content: "\\F0AD8"; }

.mdi-radio::before {
  content: "\\F0439"; }

.mdi-radio-am::before {
  content: "\\F0CBE"; }

.mdi-radio-fm::before {
  content: "\\F0CBF"; }

.mdi-radio-handheld::before {
  content: "\\F043A"; }

.mdi-radio-off::before {
  content: "\\F121C"; }

.mdi-radio-tower::before {
  content: "\\F043B"; }

.mdi-radioactive::before {
  content: "\\F043C"; }

.mdi-radioactive-circle::before {
  content: "\\F185D"; }

.mdi-radioactive-circle-outline::before {
  content: "\\F185E"; }

.mdi-radioactive-off::before {
  content: "\\F0EC1"; }

.mdi-radiobox-blank::before {
  content: "\\F043D"; }

.mdi-radiobox-marked::before {
  content: "\\F043E"; }

.mdi-radiology-box::before {
  content: "\\F14C5"; }

.mdi-radiology-box-outline::before {
  content: "\\F14C6"; }

.mdi-radius::before {
  content: "\\F0CC0"; }

.mdi-radius-outline::before {
  content: "\\F0CC1"; }

.mdi-railroad-light::before {
  content: "\\F0F1E"; }

.mdi-rake::before {
  content: "\\F1544"; }

.mdi-raspberry-pi::before {
  content: "\\F043F"; }

.mdi-ray-end::before {
  content: "\\F0440"; }

.mdi-ray-end-arrow::before {
  content: "\\F0441"; }

.mdi-ray-start::before {
  content: "\\F0442"; }

.mdi-ray-start-arrow::before {
  content: "\\F0443"; }

.mdi-ray-start-end::before {
  content: "\\F0444"; }

.mdi-ray-start-vertex-end::before {
  content: "\\F15D8"; }

.mdi-ray-vertex::before {
  content: "\\F0445"; }

.mdi-razor-double-edge::before {
  content: "\\F1997"; }

.mdi-razor-single-edge::before {
  content: "\\F1998"; }

.mdi-react::before {
  content: "\\F0708"; }

.mdi-read::before {
  content: "\\F0447"; }

.mdi-receipt::before {
  content: "\\F0449"; }

.mdi-record::before {
  content: "\\F044A"; }

.mdi-record-circle::before {
  content: "\\F0EC2"; }

.mdi-record-circle-outline::before {
  content: "\\F0EC3"; }

.mdi-record-player::before {
  content: "\\F099A"; }

.mdi-record-rec::before {
  content: "\\F044B"; }

.mdi-rectangle::before {
  content: "\\F0E5E"; }

.mdi-rectangle-outline::before {
  content: "\\F0E5F"; }

.mdi-recycle::before {
  content: "\\F044C"; }

.mdi-recycle-variant::before {
  content: "\\F139D"; }

.mdi-reddit::before {
  content: "\\F044D"; }

.mdi-redhat::before {
  content: "\\F111B"; }

.mdi-redo::before {
  content: "\\F044E"; }

.mdi-redo-variant::before {
  content: "\\F044F"; }

.mdi-reflect-horizontal::before {
  content: "\\F0A0E"; }

.mdi-reflect-vertical::before {
  content: "\\F0A0F"; }

.mdi-refresh::before {
  content: "\\F0450"; }

.mdi-refresh-auto::before {
  content: "\\F18F2"; }

.mdi-refresh-circle::before {
  content: "\\F1377"; }

.mdi-regex::before {
  content: "\\F0451"; }

.mdi-registered-trademark::before {
  content: "\\F0A67"; }

.mdi-reiterate::before {
  content: "\\F1588"; }

.mdi-relation-many-to-many::before {
  content: "\\F1496"; }

.mdi-relation-many-to-one::before {
  content: "\\F1497"; }

.mdi-relation-many-to-one-or-many::before {
  content: "\\F1498"; }

.mdi-relation-many-to-only-one::before {
  content: "\\F1499"; }

.mdi-relation-many-to-zero-or-many::before {
  content: "\\F149A"; }

.mdi-relation-many-to-zero-or-one::before {
  content: "\\F149B"; }

.mdi-relation-one-or-many-to-many::before {
  content: "\\F149C"; }

.mdi-relation-one-or-many-to-one::before {
  content: "\\F149D"; }

.mdi-relation-one-or-many-to-one-or-many::before {
  content: "\\F149E"; }

.mdi-relation-one-or-many-to-only-one::before {
  content: "\\F149F"; }

.mdi-relation-one-or-many-to-zero-or-many::before {
  content: "\\F14A0"; }

.mdi-relation-one-or-many-to-zero-or-one::before {
  content: "\\F14A1"; }

.mdi-relation-one-to-many::before {
  content: "\\F14A2"; }

.mdi-relation-one-to-one::before {
  content: "\\F14A3"; }

.mdi-relation-one-to-one-or-many::before {
  content: "\\F14A4"; }

.mdi-relation-one-to-only-one::before {
  content: "\\F14A5"; }

.mdi-relation-one-to-zero-or-many::before {
  content: "\\F14A6"; }

.mdi-relation-one-to-zero-or-one::before {
  content: "\\F14A7"; }

.mdi-relation-only-one-to-many::before {
  content: "\\F14A8"; }

.mdi-relation-only-one-to-one::before {
  content: "\\F14A9"; }

.mdi-relation-only-one-to-one-or-many::before {
  content: "\\F14AA"; }

.mdi-relation-only-one-to-only-one::before {
  content: "\\F14AB"; }

.mdi-relation-only-one-to-zero-or-many::before {
  content: "\\F14AC"; }

.mdi-relation-only-one-to-zero-or-one::before {
  content: "\\F14AD"; }

.mdi-relation-zero-or-many-to-many::before {
  content: "\\F14AE"; }

.mdi-relation-zero-or-many-to-one::before {
  content: "\\F14AF"; }

.mdi-relation-zero-or-many-to-one-or-many::before {
  content: "\\F14B0"; }

.mdi-relation-zero-or-many-to-only-one::before {
  content: "\\F14B1"; }

.mdi-relation-zero-or-many-to-zero-or-many::before {
  content: "\\F14B2"; }

.mdi-relation-zero-or-many-to-zero-or-one::before {
  content: "\\F14B3"; }

.mdi-relation-zero-or-one-to-many::before {
  content: "\\F14B4"; }

.mdi-relation-zero-or-one-to-one::before {
  content: "\\F14B5"; }

.mdi-relation-zero-or-one-to-one-or-many::before {
  content: "\\F14B6"; }

.mdi-relation-zero-or-one-to-only-one::before {
  content: "\\F14B7"; }

.mdi-relation-zero-or-one-to-zero-or-many::before {
  content: "\\F14B8"; }

.mdi-relation-zero-or-one-to-zero-or-one::before {
  content: "\\F14B9"; }

.mdi-relative-scale::before {
  content: "\\F0452"; }

.mdi-reload::before {
  content: "\\F0453"; }

.mdi-reload-alert::before {
  content: "\\F110B"; }

.mdi-reminder::before {
  content: "\\F088C"; }

.mdi-remote::before {
  content: "\\F0454"; }

.mdi-remote-desktop::before {
  content: "\\F08B9"; }

.mdi-remote-off::before {
  content: "\\F0EC4"; }

.mdi-remote-tv::before {
  content: "\\F0EC5"; }

.mdi-remote-tv-off::before {
  content: "\\F0EC6"; }

.mdi-rename-box::before {
  content: "\\F0455"; }

.mdi-reorder-horizontal::before {
  content: "\\F0688"; }

.mdi-reorder-vertical::before {
  content: "\\F0689"; }

.mdi-repeat::before {
  content: "\\F0456"; }

.mdi-repeat-off::before {
  content: "\\F0457"; }

.mdi-repeat-once::before {
  content: "\\F0458"; }

.mdi-repeat-variant::before {
  content: "\\F0547"; }

.mdi-replay::before {
  content: "\\F0459"; }

.mdi-reply::before {
  content: "\\F045A"; }

.mdi-reply-all::before {
  content: "\\F045B"; }

.mdi-reply-all-outline::before {
  content: "\\F0F1F"; }

.mdi-reply-circle::before {
  content: "\\F11AE"; }

.mdi-reply-outline::before {
  content: "\\F0F20"; }

.mdi-reproduction::before {
  content: "\\F045C"; }

.mdi-resistor::before {
  content: "\\F0B44"; }

.mdi-resistor-nodes::before {
  content: "\\F0B45"; }

.mdi-resize::before {
  content: "\\F0A68"; }

.mdi-resize-bottom-right::before {
  content: "\\F045D"; }

.mdi-responsive::before {
  content: "\\F045E"; }

.mdi-restart::before {
  content: "\\F0709"; }

.mdi-restart-alert::before {
  content: "\\F110C"; }

.mdi-restart-off::before {
  content: "\\F0D95"; }

.mdi-restore::before {
  content: "\\F099B"; }

.mdi-restore-alert::before {
  content: "\\F110D"; }

.mdi-rewind::before {
  content: "\\F045F"; }

.mdi-rewind-10::before {
  content: "\\F0D2A"; }

.mdi-rewind-15::before {
  content: "\\F1946"; }

.mdi-rewind-30::before {
  content: "\\F0D96"; }

.mdi-rewind-5::before {
  content: "\\F11F9"; }

.mdi-rewind-60::before {
  content: "\\F160C"; }

.mdi-rewind-outline::before {
  content: "\\F070A"; }

.mdi-rhombus::before {
  content: "\\F070B"; }

.mdi-rhombus-medium::before {
  content: "\\F0A10"; }

.mdi-rhombus-medium-outline::before {
  content: "\\F14DC"; }

.mdi-rhombus-outline::before {
  content: "\\F070C"; }

.mdi-rhombus-split::before {
  content: "\\F0A11"; }

.mdi-rhombus-split-outline::before {
  content: "\\F14DD"; }

.mdi-ribbon::before {
  content: "\\F0460"; }

.mdi-rice::before {
  content: "\\F07EA"; }

.mdi-rickshaw::before {
  content: "\\F15BB"; }

.mdi-rickshaw-electric::before {
  content: "\\F15BC"; }

.mdi-ring::before {
  content: "\\F07EB"; }

.mdi-rivet::before {
  content: "\\F0E60"; }

.mdi-road::before {
  content: "\\F0461"; }

.mdi-road-variant::before {
  content: "\\F0462"; }

.mdi-robber::before {
  content: "\\F1058"; }

.mdi-robot::before {
  content: "\\F06A9"; }

.mdi-robot-angry::before {
  content: "\\F169D"; }

.mdi-robot-angry-outline::before {
  content: "\\F169E"; }

.mdi-robot-confused::before {
  content: "\\F169F"; }

.mdi-robot-confused-outline::before {
  content: "\\F16A0"; }

.mdi-robot-dead::before {
  content: "\\F16A1"; }

.mdi-robot-dead-outline::before {
  content: "\\F16A2"; }

.mdi-robot-excited::before {
  content: "\\F16A3"; }

.mdi-robot-excited-outline::before {
  content: "\\F16A4"; }

.mdi-robot-happy::before {
  content: "\\F1719"; }

.mdi-robot-happy-outline::before {
  content: "\\F171A"; }

.mdi-robot-industrial::before {
  content: "\\F0B46"; }

.mdi-robot-love::before {
  content: "\\F16A5"; }

.mdi-robot-love-outline::before {
  content: "\\F16A6"; }

.mdi-robot-mower::before {
  content: "\\F11F7"; }

.mdi-robot-mower-outline::before {
  content: "\\F11F3"; }

.mdi-robot-off::before {
  content: "\\F16A7"; }

.mdi-robot-off-outline::before {
  content: "\\F167B"; }

.mdi-robot-outline::before {
  content: "\\F167A"; }

.mdi-robot-vacuum::before {
  content: "\\F070D"; }

.mdi-robot-vacuum-variant::before {
  content: "\\F0908"; }

.mdi-rocket::before {
  content: "\\F0463"; }

.mdi-rocket-launch::before {
  content: "\\F14DE"; }

.mdi-rocket-launch-outline::before {
  content: "\\F14DF"; }

.mdi-rocket-outline::before {
  content: "\\F13AF"; }

.mdi-rodent::before {
  content: "\\F1327"; }

.mdi-roller-skate::before {
  content: "\\F0D2B"; }

.mdi-roller-skate-off::before {
  content: "\\F0145"; }

.mdi-rollerblade::before {
  content: "\\F0D2C"; }

.mdi-rollerblade-off::before {
  content: "\\F002E"; }

.mdi-rollupjs::before {
  content: "\\F0BC0"; }

.mdi-roman-numeral-1::before {
  content: "\\F1088"; }

.mdi-roman-numeral-10::before {
  content: "\\F1091"; }

.mdi-roman-numeral-2::before {
  content: "\\F1089"; }

.mdi-roman-numeral-3::before {
  content: "\\F108A"; }

.mdi-roman-numeral-4::before {
  content: "\\F108B"; }

.mdi-roman-numeral-5::before {
  content: "\\F108C"; }

.mdi-roman-numeral-6::before {
  content: "\\F108D"; }

.mdi-roman-numeral-7::before {
  content: "\\F108E"; }

.mdi-roman-numeral-8::before {
  content: "\\F108F"; }

.mdi-roman-numeral-9::before {
  content: "\\F1090"; }

.mdi-room-service::before {
  content: "\\F088D"; }

.mdi-room-service-outline::before {
  content: "\\F0D97"; }

.mdi-rotate-360::before {
  content: "\\F1999"; }

.mdi-rotate-3d::before {
  content: "\\F0EC7"; }

.mdi-rotate-3d-variant::before {
  content: "\\F0464"; }

.mdi-rotate-left::before {
  content: "\\F0465"; }

.mdi-rotate-left-variant::before {
  content: "\\F0466"; }

.mdi-rotate-orbit::before {
  content: "\\F0D98"; }

.mdi-rotate-right::before {
  content: "\\F0467"; }

.mdi-rotate-right-variant::before {
  content: "\\F0468"; }

.mdi-rounded-corner::before {
  content: "\\F0607"; }

.mdi-router::before {
  content: "\\F11E2"; }

.mdi-router-network::before {
  content: "\\F1087"; }

.mdi-router-wireless::before {
  content: "\\F0469"; }

.mdi-router-wireless-off::before {
  content: "\\F15A3"; }

.mdi-router-wireless-settings::before {
  content: "\\F0A69"; }

.mdi-routes::before {
  content: "\\F046A"; }

.mdi-routes-clock::before {
  content: "\\F1059"; }

.mdi-rowing::before {
  content: "\\F0608"; }

.mdi-rss::before {
  content: "\\F046B"; }

.mdi-rss-box::before {
  content: "\\F046C"; }

.mdi-rss-off::before {
  content: "\\F0F21"; }

.mdi-rug::before {
  content: "\\F1475"; }

.mdi-rugby::before {
  content: "\\F0D99"; }

.mdi-ruler::before {
  content: "\\F046D"; }

.mdi-ruler-square::before {
  content: "\\F0CC2"; }

.mdi-ruler-square-compass::before {
  content: "\\F0EBE"; }

.mdi-run::before {
  content: "\\F070E"; }

.mdi-run-fast::before {
  content: "\\F046E"; }

.mdi-rv-truck::before {
  content: "\\F11D4"; }

.mdi-sack::before {
  content: "\\F0D2E"; }

.mdi-sack-percent::before {
  content: "\\F0D2F"; }

.mdi-safe::before {
  content: "\\F0A6A"; }

.mdi-safe-square::before {
  content: "\\F127C"; }

.mdi-safe-square-outline::before {
  content: "\\F127D"; }

.mdi-safety-goggles::before {
  content: "\\F0D30"; }

.mdi-sail-boat::before {
  content: "\\F0EC8"; }

.mdi-sale::before {
  content: "\\F046F"; }

.mdi-salesforce::before {
  content: "\\F088E"; }

.mdi-sass::before {
  content: "\\F07EC"; }

.mdi-satellite::before {
  content: "\\F0470"; }

.mdi-satellite-uplink::before {
  content: "\\F0909"; }

.mdi-satellite-variant::before {
  content: "\\F0471"; }

.mdi-sausage::before {
  content: "\\F08BA"; }

.mdi-sausage-off::before {
  content: "\\F1789"; }

.mdi-saw-blade::before {
  content: "\\F0E61"; }

.mdi-sawtooth-wave::before {
  content: "\\F147A"; }

.mdi-saxophone::before {
  content: "\\F0609"; }

.mdi-scale::before {
  content: "\\F0472"; }

.mdi-scale-balance::before {
  content: "\\F05D1"; }

.mdi-scale-bathroom::before {
  content: "\\F0473"; }

.mdi-scale-off::before {
  content: "\\F105A"; }

.mdi-scale-unbalanced::before {
  content: "\\F19B8"; }

.mdi-scan-helper::before {
  content: "\\F13D8"; }

.mdi-scanner::before {
  content: "\\F06AB"; }

.mdi-scanner-off::before {
  content: "\\F090A"; }

.mdi-scatter-plot::before {
  content: "\\F0EC9"; }

.mdi-scatter-plot-outline::before {
  content: "\\F0ECA"; }

.mdi-scent::before {
  content: "\\F1958"; }

.mdi-scent-off::before {
  content: "\\F1959"; }

.mdi-school::before {
  content: "\\F0474"; }

.mdi-school-outline::before {
  content: "\\F1180"; }

.mdi-scissors-cutting::before {
  content: "\\F0A6B"; }

.mdi-scooter::before {
  content: "\\F15BD"; }

.mdi-scooter-electric::before {
  content: "\\F15BE"; }

.mdi-scoreboard::before {
  content: "\\F127E"; }

.mdi-scoreboard-outline::before {
  content: "\\F127F"; }

.mdi-screen-rotation::before {
  content: "\\F0475"; }

.mdi-screen-rotation-lock::before {
  content: "\\F0478"; }

.mdi-screw-flat-top::before {
  content: "\\F0DF3"; }

.mdi-screw-lag::before {
  content: "\\F0DF4"; }

.mdi-screw-machine-flat-top::before {
  content: "\\F0DF5"; }

.mdi-screw-machine-round-top::before {
  content: "\\F0DF6"; }

.mdi-screw-round-top::before {
  content: "\\F0DF7"; }

.mdi-screwdriver::before {
  content: "\\F0476"; }

.mdi-script::before {
  content: "\\F0BC1"; }

.mdi-script-outline::before {
  content: "\\F0477"; }

.mdi-script-text::before {
  content: "\\F0BC2"; }

.mdi-script-text-key::before {
  content: "\\F1725"; }

.mdi-script-text-key-outline::before {
  content: "\\F1726"; }

.mdi-script-text-outline::before {
  content: "\\F0BC3"; }

.mdi-script-text-play::before {
  content: "\\F1727"; }

.mdi-script-text-play-outline::before {
  content: "\\F1728"; }

.mdi-sd::before {
  content: "\\F0479"; }

.mdi-seal::before {
  content: "\\F047A"; }

.mdi-seal-variant::before {
  content: "\\F0FD9"; }

.mdi-search-web::before {
  content: "\\F070F"; }

.mdi-seat::before {
  content: "\\F0CC3"; }

.mdi-seat-flat::before {
  content: "\\F047B"; }

.mdi-seat-flat-angled::before {
  content: "\\F047C"; }

.mdi-seat-individual-suite::before {
  content: "\\F047D"; }

.mdi-seat-legroom-extra::before {
  content: "\\F047E"; }

.mdi-seat-legroom-normal::before {
  content: "\\F047F"; }

.mdi-seat-legroom-reduced::before {
  content: "\\F0480"; }

.mdi-seat-outline::before {
  content: "\\F0CC4"; }

.mdi-seat-passenger::before {
  content: "\\F1249"; }

.mdi-seat-recline-extra::before {
  content: "\\F0481"; }

.mdi-seat-recline-normal::before {
  content: "\\F0482"; }

.mdi-seatbelt::before {
  content: "\\F0CC5"; }

.mdi-security::before {
  content: "\\F0483"; }

.mdi-security-network::before {
  content: "\\F0484"; }

.mdi-seed::before {
  content: "\\F0E62"; }

.mdi-seed-off::before {
  content: "\\F13FD"; }

.mdi-seed-off-outline::before {
  content: "\\F13FE"; }

.mdi-seed-outline::before {
  content: "\\F0E63"; }

.mdi-seesaw::before {
  content: "\\F15A4"; }

.mdi-segment::before {
  content: "\\F0ECB"; }

.mdi-select::before {
  content: "\\F0485"; }

.mdi-select-all::before {
  content: "\\F0486"; }

.mdi-select-color::before {
  content: "\\F0D31"; }

.mdi-select-compare::before {
  content: "\\F0AD9"; }

.mdi-select-drag::before {
  content: "\\F0A6C"; }

.mdi-select-group::before {
  content: "\\F0F82"; }

.mdi-select-inverse::before {
  content: "\\F0487"; }

.mdi-select-marker::before {
  content: "\\F1280"; }

.mdi-select-multiple::before {
  content: "\\F1281"; }

.mdi-select-multiple-marker::before {
  content: "\\F1282"; }

.mdi-select-off::before {
  content: "\\F0488"; }

.mdi-select-place::before {
  content: "\\F0FDA"; }

.mdi-select-remove::before {
  content: "\\F17C1"; }

.mdi-select-search::before {
  content: "\\F1204"; }

.mdi-selection::before {
  content: "\\F0489"; }

.mdi-selection-drag::before {
  content: "\\F0A6D"; }

.mdi-selection-ellipse::before {
  content: "\\F0D32"; }

.mdi-selection-ellipse-arrow-inside::before {
  content: "\\F0F22"; }

.mdi-selection-ellipse-remove::before {
  content: "\\F17C2"; }

.mdi-selection-marker::before {
  content: "\\F1283"; }

.mdi-selection-multiple::before {
  content: "\\F1285"; }

.mdi-selection-multiple-marker::before {
  content: "\\F1284"; }

.mdi-selection-off::before {
  content: "\\F0777"; }

.mdi-selection-remove::before {
  content: "\\F17C3"; }

.mdi-selection-search::before {
  content: "\\F1205"; }

.mdi-semantic-web::before {
  content: "\\F1316"; }

.mdi-send::before {
  content: "\\F048A"; }

.mdi-send-check::before {
  content: "\\F1161"; }

.mdi-send-check-outline::before {
  content: "\\F1162"; }

.mdi-send-circle::before {
  content: "\\F0DF8"; }

.mdi-send-circle-outline::before {
  content: "\\F0DF9"; }

.mdi-send-clock::before {
  content: "\\F1163"; }

.mdi-send-clock-outline::before {
  content: "\\F1164"; }

.mdi-send-lock::before {
  content: "\\F07ED"; }

.mdi-send-lock-outline::before {
  content: "\\F1166"; }

.mdi-send-outline::before {
  content: "\\F1165"; }

.mdi-serial-port::before {
  content: "\\F065C"; }

.mdi-server::before {
  content: "\\F048B"; }

.mdi-server-minus::before {
  content: "\\F048C"; }

.mdi-server-network::before {
  content: "\\F048D"; }

.mdi-server-network-off::before {
  content: "\\F048E"; }

.mdi-server-off::before {
  content: "\\F048F"; }

.mdi-server-plus::before {
  content: "\\F0490"; }

.mdi-server-remove::before {
  content: "\\F0491"; }

.mdi-server-security::before {
  content: "\\F0492"; }

.mdi-set-all::before {
  content: "\\F0778"; }

.mdi-set-center::before {
  content: "\\F0779"; }

.mdi-set-center-right::before {
  content: "\\F077A"; }

.mdi-set-left::before {
  content: "\\F077B"; }

.mdi-set-left-center::before {
  content: "\\F077C"; }

.mdi-set-left-right::before {
  content: "\\F077D"; }

.mdi-set-merge::before {
  content: "\\F14E0"; }

.mdi-set-none::before {
  content: "\\F077E"; }

.mdi-set-right::before {
  content: "\\F077F"; }

.mdi-set-split::before {
  content: "\\F14E1"; }

.mdi-set-square::before {
  content: "\\F145D"; }

.mdi-set-top-box::before {
  content: "\\F099F"; }

.mdi-settings-helper::before {
  content: "\\F0A6E"; }

.mdi-shaker::before {
  content: "\\F110E"; }

.mdi-shaker-outline::before {
  content: "\\F110F"; }

.mdi-shape::before {
  content: "\\F0831"; }

.mdi-shape-circle-plus::before {
  content: "\\F065D"; }

.mdi-shape-outline::before {
  content: "\\F0832"; }

.mdi-shape-oval-plus::before {
  content: "\\F11FA"; }

.mdi-shape-plus::before {
  content: "\\F0495"; }

.mdi-shape-polygon-plus::before {
  content: "\\F065E"; }

.mdi-shape-rectangle-plus::before {
  content: "\\F065F"; }

.mdi-shape-square-plus::before {
  content: "\\F0660"; }

.mdi-shape-square-rounded-plus::before {
  content: "\\F14FA"; }

.mdi-share::before {
  content: "\\F0496"; }

.mdi-share-all::before {
  content: "\\F11F4"; }

.mdi-share-all-outline::before {
  content: "\\F11F5"; }

.mdi-share-circle::before {
  content: "\\F11AD"; }

.mdi-share-off::before {
  content: "\\F0F23"; }

.mdi-share-off-outline::before {
  content: "\\F0F24"; }

.mdi-share-outline::before {
  content: "\\F0932"; }

.mdi-share-variant::before {
  content: "\\F0497"; }

.mdi-share-variant-outline::before {
  content: "\\F1514"; }

.mdi-shark::before {
  content: "\\F18BA"; }

.mdi-shark-fin::before {
  content: "\\F1673"; }

.mdi-shark-fin-outline::before {
  content: "\\F1674"; }

.mdi-shark-off::before {
  content: "\\F18BB"; }

.mdi-sheep::before {
  content: "\\F0CC6"; }

.mdi-shield::before {
  content: "\\F0498"; }

.mdi-shield-account::before {
  content: "\\F088F"; }

.mdi-shield-account-outline::before {
  content: "\\F0A12"; }

.mdi-shield-account-variant::before {
  content: "\\F15A7"; }

.mdi-shield-account-variant-outline::before {
  content: "\\F15A8"; }

.mdi-shield-airplane::before {
  content: "\\F06BB"; }

.mdi-shield-airplane-outline::before {
  content: "\\F0CC7"; }

.mdi-shield-alert::before {
  content: "\\F0ECC"; }

.mdi-shield-alert-outline::before {
  content: "\\F0ECD"; }

.mdi-shield-bug::before {
  content: "\\F13DA"; }

.mdi-shield-bug-outline::before {
  content: "\\F13DB"; }

.mdi-shield-car::before {
  content: "\\F0F83"; }

.mdi-shield-check::before {
  content: "\\F0565"; }

.mdi-shield-check-outline::before {
  content: "\\F0CC8"; }

.mdi-shield-cross::before {
  content: "\\F0CC9"; }

.mdi-shield-cross-outline::before {
  content: "\\F0CCA"; }

.mdi-shield-crown::before {
  content: "\\F18BC"; }

.mdi-shield-crown-outline::before {
  content: "\\F18BD"; }

.mdi-shield-edit::before {
  content: "\\F11A0"; }

.mdi-shield-edit-outline::before {
  content: "\\F11A1"; }

.mdi-shield-half::before {
  content: "\\F1360"; }

.mdi-shield-half-full::before {
  content: "\\F0780"; }

.mdi-shield-home::before {
  content: "\\F068A"; }

.mdi-shield-home-outline::before {
  content: "\\F0CCB"; }

.mdi-shield-key::before {
  content: "\\F0BC4"; }

.mdi-shield-key-outline::before {
  content: "\\F0BC5"; }

.mdi-shield-link-variant::before {
  content: "\\F0D33"; }

.mdi-shield-link-variant-outline::before {
  content: "\\F0D34"; }

.mdi-shield-lock::before {
  content: "\\F099D"; }

.mdi-shield-lock-open::before {
  content: "\\F199A"; }

.mdi-shield-lock-open-outline::before {
  content: "\\F199B"; }

.mdi-shield-lock-outline::before {
  content: "\\F0CCC"; }

.mdi-shield-moon::before {
  content: "\\F1828"; }

.mdi-shield-moon-outline::before {
  content: "\\F1829"; }

.mdi-shield-off::before {
  content: "\\F099E"; }

.mdi-shield-off-outline::before {
  content: "\\F099C"; }

.mdi-shield-outline::before {
  content: "\\F0499"; }

.mdi-shield-plus::before {
  content: "\\F0ADA"; }

.mdi-shield-plus-outline::before {
  content: "\\F0ADB"; }

.mdi-shield-refresh::before {
  content: "\\F00AA"; }

.mdi-shield-refresh-outline::before {
  content: "\\F01E0"; }

.mdi-shield-remove::before {
  content: "\\F0ADC"; }

.mdi-shield-remove-outline::before {
  content: "\\F0ADD"; }

.mdi-shield-search::before {
  content: "\\F0D9A"; }

.mdi-shield-star::before {
  content: "\\F113B"; }

.mdi-shield-star-outline::before {
  content: "\\F113C"; }

.mdi-shield-sun::before {
  content: "\\F105D"; }

.mdi-shield-sun-outline::before {
  content: "\\F105E"; }

.mdi-shield-sword::before {
  content: "\\F18BE"; }

.mdi-shield-sword-outline::before {
  content: "\\F18BF"; }

.mdi-shield-sync::before {
  content: "\\F11A2"; }

.mdi-shield-sync-outline::before {
  content: "\\F11A3"; }

.mdi-shimmer::before {
  content: "\\F1545"; }

.mdi-ship-wheel::before {
  content: "\\F0833"; }

.mdi-shipping-pallet::before {
  content: "\\F184E"; }

.mdi-shoe-ballet::before {
  content: "\\F15CA"; }

.mdi-shoe-cleat::before {
  content: "\\F15C7"; }

.mdi-shoe-formal::before {
  content: "\\F0B47"; }

.mdi-shoe-heel::before {
  content: "\\F0B48"; }

.mdi-shoe-print::before {
  content: "\\F0DFA"; }

.mdi-shoe-sneaker::before {
  content: "\\F15C8"; }

.mdi-shopping::before {
  content: "\\F049A"; }

.mdi-shopping-music::before {
  content: "\\F049B"; }

.mdi-shopping-outline::before {
  content: "\\F11D5"; }

.mdi-shopping-search::before {
  content: "\\F0F84"; }

.mdi-shore::before {
  content: "\\F14F9"; }

.mdi-shovel::before {
  content: "\\F0710"; }

.mdi-shovel-off::before {
  content: "\\F0711"; }

.mdi-shower::before {
  content: "\\F09A0"; }

.mdi-shower-head::before {
  content: "\\F09A1"; }

.mdi-shredder::before {
  content: "\\F049C"; }

.mdi-shuffle::before {
  content: "\\F049D"; }

.mdi-shuffle-disabled::before {
  content: "\\F049E"; }

.mdi-shuffle-variant::before {
  content: "\\F049F"; }

.mdi-shuriken::before {
  content: "\\F137F"; }

.mdi-sickle::before {
  content: "\\F18C0"; }

.mdi-sigma::before {
  content: "\\F04A0"; }

.mdi-sigma-lower::before {
  content: "\\F062B"; }

.mdi-sign-caution::before {
  content: "\\F04A1"; }

.mdi-sign-direction::before {
  content: "\\F0781"; }

.mdi-sign-direction-minus::before {
  content: "\\F1000"; }

.mdi-sign-direction-plus::before {
  content: "\\F0FDC"; }

.mdi-sign-direction-remove::before {
  content: "\\F0FDD"; }

.mdi-sign-pole::before {
  content: "\\F14F8"; }

.mdi-sign-real-estate::before {
  content: "\\F1118"; }

.mdi-sign-text::before {
  content: "\\F0782"; }

.mdi-signal::before {
  content: "\\F04A2"; }

.mdi-signal-2g::before {
  content: "\\F0712"; }

.mdi-signal-3g::before {
  content: "\\F0713"; }

.mdi-signal-4g::before {
  content: "\\F0714"; }

.mdi-signal-5g::before {
  content: "\\F0A6F"; }

.mdi-signal-cellular-1::before {
  content: "\\F08BC"; }

.mdi-signal-cellular-2::before {
  content: "\\F08BD"; }

.mdi-signal-cellular-3::before {
  content: "\\F08BE"; }

.mdi-signal-cellular-outline::before {
  content: "\\F08BF"; }

.mdi-signal-distance-variant::before {
  content: "\\F0E64"; }

.mdi-signal-hspa::before {
  content: "\\F0715"; }

.mdi-signal-hspa-plus::before {
  content: "\\F0716"; }

.mdi-signal-off::before {
  content: "\\F0783"; }

.mdi-signal-variant::before {
  content: "\\F060A"; }

.mdi-signature::before {
  content: "\\F0DFB"; }

.mdi-signature-freehand::before {
  content: "\\F0DFC"; }

.mdi-signature-image::before {
  content: "\\F0DFD"; }

.mdi-signature-text::before {
  content: "\\F0DFE"; }

.mdi-silo::before {
  content: "\\F0B49"; }

.mdi-silverware::before {
  content: "\\F04A3"; }

.mdi-silverware-clean::before {
  content: "\\F0FDE"; }

.mdi-silverware-fork::before {
  content: "\\F04A4"; }

.mdi-silverware-fork-knife::before {
  content: "\\F0A70"; }

.mdi-silverware-spoon::before {
  content: "\\F04A5"; }

.mdi-silverware-variant::before {
  content: "\\F04A6"; }

.mdi-sim::before {
  content: "\\F04A7"; }

.mdi-sim-alert::before {
  content: "\\F04A8"; }

.mdi-sim-alert-outline::before {
  content: "\\F15D3"; }

.mdi-sim-off::before {
  content: "\\F04A9"; }

.mdi-sim-off-outline::before {
  content: "\\F15D4"; }

.mdi-sim-outline::before {
  content: "\\F15D5"; }

.mdi-simple-icons::before {
  content: "\\F131D"; }

.mdi-sina-weibo::before {
  content: "\\F0ADF"; }

.mdi-sine-wave::before {
  content: "\\F095B"; }

.mdi-sitemap::before {
  content: "\\F04AA"; }

.mdi-sitemap-outline::before {
  content: "\\F199C"; }

.mdi-size-l::before {
  content: "\\F13A6"; }

.mdi-size-m::before {
  content: "\\F13A5"; }

.mdi-size-s::before {
  content: "\\F13A4"; }

.mdi-size-xl::before {
  content: "\\F13A7"; }

.mdi-size-xs::before {
  content: "\\F13A3"; }

.mdi-size-xxl::before {
  content: "\\F13A8"; }

.mdi-size-xxs::before {
  content: "\\F13A2"; }

.mdi-size-xxxl::before {
  content: "\\F13A9"; }

.mdi-skate::before {
  content: "\\F0D35"; }

.mdi-skate-off::before {
  content: "\\F0699"; }

.mdi-skateboard::before {
  content: "\\F14C2"; }

.mdi-skateboarding::before {
  content: "\\F0501"; }

.mdi-skew-less::before {
  content: "\\F0D36"; }

.mdi-skew-more::before {
  content: "\\F0D37"; }

.mdi-ski::before {
  content: "\\F1304"; }

.mdi-ski-cross-country::before {
  content: "\\F1305"; }

.mdi-ski-water::before {
  content: "\\F1306"; }

.mdi-skip-backward::before {
  content: "\\F04AB"; }

.mdi-skip-backward-outline::before {
  content: "\\F0F25"; }

.mdi-skip-forward::before {
  content: "\\F04AC"; }

.mdi-skip-forward-outline::before {
  content: "\\F0F26"; }

.mdi-skip-next::before {
  content: "\\F04AD"; }

.mdi-skip-next-circle::before {
  content: "\\F0661"; }

.mdi-skip-next-circle-outline::before {
  content: "\\F0662"; }

.mdi-skip-next-outline::before {
  content: "\\F0F27"; }

.mdi-skip-previous::before {
  content: "\\F04AE"; }

.mdi-skip-previous-circle::before {
  content: "\\F0663"; }

.mdi-skip-previous-circle-outline::before {
  content: "\\F0664"; }

.mdi-skip-previous-outline::before {
  content: "\\F0F28"; }

.mdi-skull::before {
  content: "\\F068C"; }

.mdi-skull-crossbones::before {
  content: "\\F0BC6"; }

.mdi-skull-crossbones-outline::before {
  content: "\\F0BC7"; }

.mdi-skull-outline::before {
  content: "\\F0BC8"; }

.mdi-skull-scan::before {
  content: "\\F14C7"; }

.mdi-skull-scan-outline::before {
  content: "\\F14C8"; }

.mdi-skype::before {
  content: "\\F04AF"; }

.mdi-skype-business::before {
  content: "\\F04B0"; }

.mdi-slack::before {
  content: "\\F04B1"; }

.mdi-slash-forward::before {
  content: "\\F0FDF"; }

.mdi-slash-forward-box::before {
  content: "\\F0FE0"; }

.mdi-sledding::before {
  content: "\\F041B"; }

.mdi-sleep::before {
  content: "\\F04B2"; }

.mdi-sleep-off::before {
  content: "\\F04B3"; }

.mdi-slide::before {
  content: "\\F15A5"; }

.mdi-slope-downhill::before {
  content: "\\F0DFF"; }

.mdi-slope-uphill::before {
  content: "\\F0E00"; }

.mdi-slot-machine::before {
  content: "\\F1114"; }

.mdi-slot-machine-outline::before {
  content: "\\F1115"; }

.mdi-smart-card::before {
  content: "\\F10BD"; }

.mdi-smart-card-off::before {
  content: "\\F18F7"; }

.mdi-smart-card-off-outline::before {
  content: "\\F18F8"; }

.mdi-smart-card-outline::before {
  content: "\\F10BE"; }

.mdi-smart-card-reader::before {
  content: "\\F10BF"; }

.mdi-smart-card-reader-outline::before {
  content: "\\F10C0"; }

.mdi-smog::before {
  content: "\\F0A71"; }

.mdi-smoke::before {
  content: "\\F1799"; }

.mdi-smoke-detector::before {
  content: "\\F0392"; }

.mdi-smoke-detector-alert::before {
  content: "\\F192E"; }

.mdi-smoke-detector-alert-outline::before {
  content: "\\F192F"; }

.mdi-smoke-detector-off::before {
  content: "\\F1809"; }

.mdi-smoke-detector-off-outline::before {
  content: "\\F180A"; }

.mdi-smoke-detector-outline::before {
  content: "\\F1808"; }

.mdi-smoke-detector-variant::before {
  content: "\\F180B"; }

.mdi-smoke-detector-variant-alert::before {
  content: "\\F1930"; }

.mdi-smoke-detector-variant-off::before {
  content: "\\F180C"; }

.mdi-smoking::before {
  content: "\\F04B4"; }

.mdi-smoking-off::before {
  content: "\\F04B5"; }

.mdi-smoking-pipe::before {
  content: "\\F140D"; }

.mdi-smoking-pipe-off::before {
  content: "\\F1428"; }

.mdi-snail::before {
  content: "\\F1677"; }

.mdi-snake::before {
  content: "\\F150E"; }

.mdi-snapchat::before {
  content: "\\F04B6"; }

.mdi-snowboard::before {
  content: "\\F1307"; }

.mdi-snowflake::before {
  content: "\\F0717"; }

.mdi-snowflake-alert::before {
  content: "\\F0F29"; }

.mdi-snowflake-melt::before {
  content: "\\F12CB"; }

.mdi-snowflake-off::before {
  content: "\\F14E3"; }

.mdi-snowflake-variant::before {
  content: "\\F0F2A"; }

.mdi-snowman::before {
  content: "\\F04B7"; }

.mdi-snowmobile::before {
  content: "\\F06DD"; }

.mdi-soccer::before {
  content: "\\F04B8"; }

.mdi-soccer-field::before {
  content: "\\F0834"; }

.mdi-social-distance-2-meters::before {
  content: "\\F1579"; }

.mdi-social-distance-6-feet::before {
  content: "\\F157A"; }

.mdi-sofa::before {
  content: "\\F04B9"; }

.mdi-sofa-outline::before {
  content: "\\F156D"; }

.mdi-sofa-single::before {
  content: "\\F156E"; }

.mdi-sofa-single-outline::before {
  content: "\\F156F"; }

.mdi-solar-panel::before {
  content: "\\F0D9B"; }

.mdi-solar-panel-large::before {
  content: "\\F0D9C"; }

.mdi-solar-power::before {
  content: "\\F0A72"; }

.mdi-soldering-iron::before {
  content: "\\F1092"; }

.mdi-solid::before {
  content: "\\F068D"; }

.mdi-sony-playstation::before {
  content: "\\F0414"; }

.mdi-sort::before {
  content: "\\F04BA"; }

.mdi-sort-alphabetical-ascending::before {
  content: "\\F05BD"; }

.mdi-sort-alphabetical-ascending-variant::before {
  content: "\\F1148"; }

.mdi-sort-alphabetical-descending::before {
  content: "\\F05BF"; }

.mdi-sort-alphabetical-descending-variant::before {
  content: "\\F1149"; }

.mdi-sort-alphabetical-variant::before {
  content: "\\F04BB"; }

.mdi-sort-ascending::before {
  content: "\\F04BC"; }

.mdi-sort-bool-ascending::before {
  content: "\\F1385"; }

.mdi-sort-bool-ascending-variant::before {
  content: "\\F1386"; }

.mdi-sort-bool-descending::before {
  content: "\\F1387"; }

.mdi-sort-bool-descending-variant::before {
  content: "\\F1388"; }

.mdi-sort-calendar-ascending::before {
  content: "\\F1547"; }

.mdi-sort-calendar-descending::before {
  content: "\\F1548"; }

.mdi-sort-clock-ascending::before {
  content: "\\F1549"; }

.mdi-sort-clock-ascending-outline::before {
  content: "\\F154A"; }

.mdi-sort-clock-descending::before {
  content: "\\F154B"; }

.mdi-sort-clock-descending-outline::before {
  content: "\\F154C"; }

.mdi-sort-descending::before {
  content: "\\F04BD"; }

.mdi-sort-numeric-ascending::before {
  content: "\\F1389"; }

.mdi-sort-numeric-ascending-variant::before {
  content: "\\F090D"; }

.mdi-sort-numeric-descending::before {
  content: "\\F138A"; }

.mdi-sort-numeric-descending-variant::before {
  content: "\\F0AD2"; }

.mdi-sort-numeric-variant::before {
  content: "\\F04BE"; }

.mdi-sort-reverse-variant::before {
  content: "\\F033C"; }

.mdi-sort-variant::before {
  content: "\\F04BF"; }

.mdi-sort-variant-lock::before {
  content: "\\F0CCD"; }

.mdi-sort-variant-lock-open::before {
  content: "\\F0CCE"; }

.mdi-sort-variant-remove::before {
  content: "\\F1147"; }

.mdi-soundbar::before {
  content: "\\F17DB"; }

.mdi-soundcloud::before {
  content: "\\F04C0"; }

.mdi-source-branch::before {
  content: "\\F062C"; }

.mdi-source-branch-check::before {
  content: "\\F14CF"; }

.mdi-source-branch-minus::before {
  content: "\\F14CB"; }

.mdi-source-branch-plus::before {
  content: "\\F14CA"; }

.mdi-source-branch-refresh::before {
  content: "\\F14CD"; }

.mdi-source-branch-remove::before {
  content: "\\F14CC"; }

.mdi-source-branch-sync::before {
  content: "\\F14CE"; }

.mdi-source-commit::before {
  content: "\\F0718"; }

.mdi-source-commit-end::before {
  content: "\\F0719"; }

.mdi-source-commit-end-local::before {
  content: "\\F071A"; }

.mdi-source-commit-local::before {
  content: "\\F071B"; }

.mdi-source-commit-next-local::before {
  content: "\\F071C"; }

.mdi-source-commit-start::before {
  content: "\\F071D"; }

.mdi-source-commit-start-next-local::before {
  content: "\\F071E"; }

.mdi-source-fork::before {
  content: "\\F04C1"; }

.mdi-source-merge::before {
  content: "\\F062D"; }

.mdi-source-pull::before {
  content: "\\F04C2"; }

.mdi-source-repository::before {
  content: "\\F0CCF"; }

.mdi-source-repository-multiple::before {
  content: "\\F0CD0"; }

.mdi-soy-sauce::before {
  content: "\\F07EE"; }

.mdi-soy-sauce-off::before {
  content: "\\F13FC"; }

.mdi-spa::before {
  content: "\\F0CD1"; }

.mdi-spa-outline::before {
  content: "\\F0CD2"; }

.mdi-space-invaders::before {
  content: "\\F0BC9"; }

.mdi-space-station::before {
  content: "\\F1383"; }

.mdi-spade::before {
  content: "\\F0E65"; }

.mdi-speaker::before {
  content: "\\F04C3"; }

.mdi-speaker-bluetooth::before {
  content: "\\F09A2"; }

.mdi-speaker-multiple::before {
  content: "\\F0D38"; }

.mdi-speaker-off::before {
  content: "\\F04C4"; }

.mdi-speaker-wireless::before {
  content: "\\F071F"; }

.mdi-spear::before {
  content: "\\F1845"; }

.mdi-speedometer::before {
  content: "\\F04C5"; }

.mdi-speedometer-medium::before {
  content: "\\F0F85"; }

.mdi-speedometer-slow::before {
  content: "\\F0F86"; }

.mdi-spellcheck::before {
  content: "\\F04C6"; }

.mdi-sphere::before {
  content: "\\F1954"; }

.mdi-sphere-off::before {
  content: "\\F1955"; }

.mdi-spider::before {
  content: "\\F11EA"; }

.mdi-spider-thread::before {
  content: "\\F11EB"; }

.mdi-spider-web::before {
  content: "\\F0BCA"; }

.mdi-spirit-level::before {
  content: "\\F14F1"; }

.mdi-spoon-sugar::before {
  content: "\\F1429"; }

.mdi-spotify::before {
  content: "\\F04C7"; }

.mdi-spotlight::before {
  content: "\\F04C8"; }

.mdi-spotlight-beam::before {
  content: "\\F04C9"; }

.mdi-spray::before {
  content: "\\F0665"; }

.mdi-spray-bottle::before {
  content: "\\F0AE0"; }

.mdi-sprinkler::before {
  content: "\\F105F"; }

.mdi-sprinkler-fire::before {
  content: "\\F199D"; }

.mdi-sprinkler-variant::before {
  content: "\\F1060"; }

.mdi-sprout::before {
  content: "\\F0E66"; }

.mdi-sprout-outline::before {
  content: "\\F0E67"; }

.mdi-square::before {
  content: "\\F0764"; }

.mdi-square-circle::before {
  content: "\\F1500"; }

.mdi-square-edit-outline::before {
  content: "\\F090C"; }

.mdi-square-medium::before {
  content: "\\F0A13"; }

.mdi-square-medium-outline::before {
  content: "\\F0A14"; }

.mdi-square-off::before {
  content: "\\F12EE"; }

.mdi-square-off-outline::before {
  content: "\\F12EF"; }

.mdi-square-opacity::before {
  content: "\\F1854"; }

.mdi-square-outline::before {
  content: "\\F0763"; }

.mdi-square-root::before {
  content: "\\F0784"; }

.mdi-square-root-box::before {
  content: "\\F09A3"; }

.mdi-square-rounded::before {
  content: "\\F14FB"; }

.mdi-square-rounded-outline::before {
  content: "\\F14FC"; }

.mdi-square-small::before {
  content: "\\F0A15"; }

.mdi-square-wave::before {
  content: "\\F147B"; }

.mdi-squeegee::before {
  content: "\\F0AE1"; }

.mdi-ssh::before {
  content: "\\F08C0"; }

.mdi-stack-exchange::before {
  content: "\\F060B"; }

.mdi-stack-overflow::before {
  content: "\\F04CC"; }

.mdi-stackpath::before {
  content: "\\F0359"; }

.mdi-stadium::before {
  content: "\\F0FF9"; }

.mdi-stadium-variant::before {
  content: "\\F0720"; }

.mdi-stairs::before {
  content: "\\F04CD"; }

.mdi-stairs-box::before {
  content: "\\F139E"; }

.mdi-stairs-down::before {
  content: "\\F12BE"; }

.mdi-stairs-up::before {
  content: "\\F12BD"; }

.mdi-stamper::before {
  content: "\\F0D39"; }

.mdi-standard-definition::before {
  content: "\\F07EF"; }

.mdi-star::before {
  content: "\\F04CE"; }

.mdi-star-box::before {
  content: "\\F0A73"; }

.mdi-star-box-multiple::before {
  content: "\\F1286"; }

.mdi-star-box-multiple-outline::before {
  content: "\\F1287"; }

.mdi-star-box-outline::before {
  content: "\\F0A74"; }

.mdi-star-check::before {
  content: "\\F1566"; }

.mdi-star-check-outline::before {
  content: "\\F156A"; }

.mdi-star-circle::before {
  content: "\\F04CF"; }

.mdi-star-circle-outline::before {
  content: "\\F09A4"; }

.mdi-star-cog::before {
  content: "\\F1668"; }

.mdi-star-cog-outline::before {
  content: "\\F1669"; }

.mdi-star-crescent::before {
  content: "\\F0979"; }

.mdi-star-david::before {
  content: "\\F097A"; }

.mdi-star-face::before {
  content: "\\F09A5"; }

.mdi-star-four-points::before {
  content: "\\F0AE2"; }

.mdi-star-four-points-outline::before {
  content: "\\F0AE3"; }

.mdi-star-half::before {
  content: "\\F0246"; }

.mdi-star-half-full::before {
  content: "\\F04D0"; }

.mdi-star-minus::before {
  content: "\\F1564"; }

.mdi-star-minus-outline::before {
  content: "\\F1568"; }

.mdi-star-off::before {
  content: "\\F04D1"; }

.mdi-star-off-outline::before {
  content: "\\F155B"; }

.mdi-star-outline::before {
  content: "\\F04D2"; }

.mdi-star-plus::before {
  content: "\\F1563"; }

.mdi-star-plus-outline::before {
  content: "\\F1567"; }

.mdi-star-remove::before {
  content: "\\F1565"; }

.mdi-star-remove-outline::before {
  content: "\\F1569"; }

.mdi-star-settings::before {
  content: "\\F166A"; }

.mdi-star-settings-outline::before {
  content: "\\F166B"; }

.mdi-star-shooting::before {
  content: "\\F1741"; }

.mdi-star-shooting-outline::before {
  content: "\\F1742"; }

.mdi-star-three-points::before {
  content: "\\F0AE4"; }

.mdi-star-three-points-outline::before {
  content: "\\F0AE5"; }

.mdi-state-machine::before {
  content: "\\F11EF"; }

.mdi-steam::before {
  content: "\\F04D3"; }

.mdi-steering::before {
  content: "\\F04D4"; }

.mdi-steering-off::before {
  content: "\\F090E"; }

.mdi-step-backward::before {
  content: "\\F04D5"; }

.mdi-step-backward-2::before {
  content: "\\F04D6"; }

.mdi-step-forward::before {
  content: "\\F04D7"; }

.mdi-step-forward-2::before {
  content: "\\F04D8"; }

.mdi-stethoscope::before {
  content: "\\F04D9"; }

.mdi-sticker::before {
  content: "\\F1364"; }

.mdi-sticker-alert::before {
  content: "\\F1365"; }

.mdi-sticker-alert-outline::before {
  content: "\\F1366"; }

.mdi-sticker-check::before {
  content: "\\F1367"; }

.mdi-sticker-check-outline::before {
  content: "\\F1368"; }

.mdi-sticker-circle-outline::before {
  content: "\\F05D0"; }

.mdi-sticker-emoji::before {
  content: "\\F0785"; }

.mdi-sticker-minus::before {
  content: "\\F1369"; }

.mdi-sticker-minus-outline::before {
  content: "\\F136A"; }

.mdi-sticker-outline::before {
  content: "\\F136B"; }

.mdi-sticker-plus::before {
  content: "\\F136C"; }

.mdi-sticker-plus-outline::before {
  content: "\\F136D"; }

.mdi-sticker-remove::before {
  content: "\\F136E"; }

.mdi-sticker-remove-outline::before {
  content: "\\F136F"; }

.mdi-sticker-text::before {
  content: "\\F178E"; }

.mdi-sticker-text-outline::before {
  content: "\\F178F"; }

.mdi-stocking::before {
  content: "\\F04DA"; }

.mdi-stomach::before {
  content: "\\F1093"; }

.mdi-stool::before {
  content: "\\F195D"; }

.mdi-stool-outline::before {
  content: "\\F195E"; }

.mdi-stop::before {
  content: "\\F04DB"; }

.mdi-stop-circle::before {
  content: "\\F0666"; }

.mdi-stop-circle-outline::before {
  content: "\\F0667"; }

.mdi-store::before {
  content: "\\F04DC"; }

.mdi-store-24-hour::before {
  content: "\\F04DD"; }

.mdi-store-alert::before {
  content: "\\F18C1"; }

.mdi-store-alert-outline::before {
  content: "\\F18C2"; }

.mdi-store-check::before {
  content: "\\F18C3"; }

.mdi-store-check-outline::before {
  content: "\\F18C4"; }

.mdi-store-clock::before {
  content: "\\F18C5"; }

.mdi-store-clock-outline::before {
  content: "\\F18C6"; }

.mdi-store-cog::before {
  content: "\\F18C7"; }

.mdi-store-cog-outline::before {
  content: "\\F18C8"; }

.mdi-store-edit::before {
  content: "\\F18C9"; }

.mdi-store-edit-outline::before {
  content: "\\F18CA"; }

.mdi-store-marker::before {
  content: "\\F18CB"; }

.mdi-store-marker-outline::before {
  content: "\\F18CC"; }

.mdi-store-minus::before {
  content: "\\F165E"; }

.mdi-store-minus-outline::before {
  content: "\\F18CD"; }

.mdi-store-off::before {
  content: "\\F18CE"; }

.mdi-store-off-outline::before {
  content: "\\F18CF"; }

.mdi-store-outline::before {
  content: "\\F1361"; }

.mdi-store-plus::before {
  content: "\\F165F"; }

.mdi-store-plus-outline::before {
  content: "\\F18D0"; }

.mdi-store-remove::before {
  content: "\\F1660"; }

.mdi-store-remove-outline::before {
  content: "\\F18D1"; }

.mdi-store-search::before {
  content: "\\F18D2"; }

.mdi-store-search-outline::before {
  content: "\\F18D3"; }

.mdi-store-settings::before {
  content: "\\F18D4"; }

.mdi-store-settings-outline::before {
  content: "\\F18D5"; }

.mdi-storefront::before {
  content: "\\F07C7"; }

.mdi-storefront-outline::before {
  content: "\\F10C1"; }

.mdi-stove::before {
  content: "\\F04DE"; }

.mdi-strategy::before {
  content: "\\F11D6"; }

.mdi-stretch-to-page::before {
  content: "\\F0F2B"; }

.mdi-stretch-to-page-outline::before {
  content: "\\F0F2C"; }

.mdi-string-lights::before {
  content: "\\F12BA"; }

.mdi-string-lights-off::before {
  content: "\\F12BB"; }

.mdi-subdirectory-arrow-left::before {
  content: "\\F060C"; }

.mdi-subdirectory-arrow-right::before {
  content: "\\F060D"; }

.mdi-submarine::before {
  content: "\\F156C"; }

.mdi-subtitles::before {
  content: "\\F0A16"; }

.mdi-subtitles-outline::before {
  content: "\\F0A17"; }

.mdi-subway::before {
  content: "\\F06AC"; }

.mdi-subway-alert-variant::before {
  content: "\\F0D9D"; }

.mdi-subway-variant::before {
  content: "\\F04DF"; }

.mdi-summit::before {
  content: "\\F0786"; }

.mdi-sun-compass::before {
  content: "\\F19A5"; }

.mdi-sun-snowflake::before {
  content: "\\F1796"; }

.mdi-sun-thermometer::before {
  content: "\\F18D6"; }

.mdi-sun-thermometer-outline::before {
  content: "\\F18D7"; }

.mdi-sun-wireless::before {
  content: "\\F17FE"; }

.mdi-sun-wireless-outline::before {
  content: "\\F17FF"; }

.mdi-sunglasses::before {
  content: "\\F04E0"; }

.mdi-surfing::before {
  content: "\\F1746"; }

.mdi-surround-sound::before {
  content: "\\F05C5"; }

.mdi-surround-sound-2-0::before {
  content: "\\F07F0"; }

.mdi-surround-sound-2-1::before {
  content: "\\F1729"; }

.mdi-surround-sound-3-1::before {
  content: "\\F07F1"; }

.mdi-surround-sound-5-1::before {
  content: "\\F07F2"; }

.mdi-surround-sound-5-1-2::before {
  content: "\\F172A"; }

.mdi-surround-sound-7-1::before {
  content: "\\F07F3"; }

.mdi-svg::before {
  content: "\\F0721"; }

.mdi-swap-horizontal::before {
  content: "\\F04E1"; }

.mdi-swap-horizontal-bold::before {
  content: "\\F0BCD"; }

.mdi-swap-horizontal-circle::before {
  content: "\\F0FE1"; }

.mdi-swap-horizontal-circle-outline::before {
  content: "\\F0FE2"; }

.mdi-swap-horizontal-variant::before {
  content: "\\F08C1"; }

.mdi-swap-vertical::before {
  content: "\\F04E2"; }

.mdi-swap-vertical-bold::before {
  content: "\\F0BCE"; }

.mdi-swap-vertical-circle::before {
  content: "\\F0FE3"; }

.mdi-swap-vertical-circle-outline::before {
  content: "\\F0FE4"; }

.mdi-swap-vertical-variant::before {
  content: "\\F08C2"; }

.mdi-swim::before {
  content: "\\F04E3"; }

.mdi-switch::before {
  content: "\\F04E4"; }

.mdi-sword::before {
  content: "\\F04E5"; }

.mdi-sword-cross::before {
  content: "\\F0787"; }

.mdi-syllabary-hangul::before {
  content: "\\F1333"; }

.mdi-syllabary-hiragana::before {
  content: "\\F1334"; }

.mdi-syllabary-katakana::before {
  content: "\\F1335"; }

.mdi-syllabary-katakana-halfwidth::before {
  content: "\\F1336"; }

.mdi-symbol::before {
  content: "\\F1501"; }

.mdi-symfony::before {
  content: "\\F0AE6"; }

.mdi-sync::before {
  content: "\\F04E6"; }

.mdi-sync-alert::before {
  content: "\\F04E7"; }

.mdi-sync-circle::before {
  content: "\\F1378"; }

.mdi-sync-off::before {
  content: "\\F04E8"; }

.mdi-tab::before {
  content: "\\F04E9"; }

.mdi-tab-minus::before {
  content: "\\F0B4B"; }

.mdi-tab-plus::before {
  content: "\\F075C"; }

.mdi-tab-remove::before {
  content: "\\F0B4C"; }

.mdi-tab-search::before {
  content: "\\F199E"; }

.mdi-tab-unselected::before {
  content: "\\F04EA"; }

.mdi-table::before {
  content: "\\F04EB"; }

.mdi-table-account::before {
  content: "\\F13B9"; }

.mdi-table-alert::before {
  content: "\\F13BA"; }

.mdi-table-arrow-down::before {
  content: "\\F13BB"; }

.mdi-table-arrow-left::before {
  content: "\\F13BC"; }

.mdi-table-arrow-right::before {
  content: "\\F13BD"; }

.mdi-table-arrow-up::before {
  content: "\\F13BE"; }

.mdi-table-border::before {
  content: "\\F0A18"; }

.mdi-table-cancel::before {
  content: "\\F13BF"; }

.mdi-table-chair::before {
  content: "\\F1061"; }

.mdi-table-check::before {
  content: "\\F13C0"; }

.mdi-table-clock::before {
  content: "\\F13C1"; }

.mdi-table-cog::before {
  content: "\\F13C2"; }

.mdi-table-column::before {
  content: "\\F0835"; }

.mdi-table-column-plus-after::before {
  content: "\\F04EC"; }

.mdi-table-column-plus-before::before {
  content: "\\F04ED"; }

.mdi-table-column-remove::before {
  content: "\\F04EE"; }

.mdi-table-column-width::before {
  content: "\\F04EF"; }

.mdi-table-edit::before {
  content: "\\F04F0"; }

.mdi-table-eye::before {
  content: "\\F1094"; }

.mdi-table-eye-off::before {
  content: "\\F13C3"; }

.mdi-table-furniture::before {
  content: "\\F05BC"; }

.mdi-table-headers-eye::before {
  content: "\\F121D"; }

.mdi-table-headers-eye-off::before {
  content: "\\F121E"; }

.mdi-table-heart::before {
  content: "\\F13C4"; }

.mdi-table-key::before {
  content: "\\F13C5"; }

.mdi-table-large::before {
  content: "\\F04F1"; }

.mdi-table-large-plus::before {
  content: "\\F0F87"; }

.mdi-table-large-remove::before {
  content: "\\F0F88"; }

.mdi-table-lock::before {
  content: "\\F13C6"; }

.mdi-table-merge-cells::before {
  content: "\\F09A6"; }

.mdi-table-minus::before {
  content: "\\F13C7"; }

.mdi-table-multiple::before {
  content: "\\F13C8"; }

.mdi-table-network::before {
  content: "\\F13C9"; }

.mdi-table-of-contents::before {
  content: "\\F0836"; }

.mdi-table-off::before {
  content: "\\F13CA"; }

.mdi-table-picnic::before {
  content: "\\F1743"; }

.mdi-table-pivot::before {
  content: "\\F183C"; }

.mdi-table-plus::before {
  content: "\\F0A75"; }

.mdi-table-refresh::before {
  content: "\\F13A0"; }

.mdi-table-remove::before {
  content: "\\F0A76"; }

.mdi-table-row::before {
  content: "\\F0837"; }

.mdi-table-row-height::before {
  content: "\\F04F2"; }

.mdi-table-row-plus-after::before {
  content: "\\F04F3"; }

.mdi-table-row-plus-before::before {
  content: "\\F04F4"; }

.mdi-table-row-remove::before {
  content: "\\F04F5"; }

.mdi-table-search::before {
  content: "\\F090F"; }

.mdi-table-settings::before {
  content: "\\F0838"; }

.mdi-table-split-cell::before {
  content: "\\F142A"; }

.mdi-table-star::before {
  content: "\\F13CB"; }

.mdi-table-sync::before {
  content: "\\F13A1"; }

.mdi-table-tennis::before {
  content: "\\F0E68"; }

.mdi-tablet::before {
  content: "\\F04F6"; }

.mdi-tablet-android::before {
  content: "\\F04F7"; }

.mdi-tablet-cellphone::before {
  content: "\\F09A7"; }

.mdi-tablet-dashboard::before {
  content: "\\F0ECE"; }

.mdi-taco::before {
  content: "\\F0762"; }

.mdi-tag::before {
  content: "\\F04F9"; }

.mdi-tag-arrow-down::before {
  content: "\\F172B"; }

.mdi-tag-arrow-down-outline::before {
  content: "\\F172C"; }

.mdi-tag-arrow-left::before {
  content: "\\F172D"; }

.mdi-tag-arrow-left-outline::before {
  content: "\\F172E"; }

.mdi-tag-arrow-right::before {
  content: "\\F172F"; }

.mdi-tag-arrow-right-outline::before {
  content: "\\F1730"; }

.mdi-tag-arrow-up::before {
  content: "\\F1731"; }

.mdi-tag-arrow-up-outline::before {
  content: "\\F1732"; }

.mdi-tag-faces::before {
  content: "\\F04FA"; }

.mdi-tag-heart::before {
  content: "\\F068B"; }

.mdi-tag-heart-outline::before {
  content: "\\F0BCF"; }

.mdi-tag-minus::before {
  content: "\\F0910"; }

.mdi-tag-minus-outline::before {
  content: "\\F121F"; }

.mdi-tag-multiple::before {
  content: "\\F04FB"; }

.mdi-tag-multiple-outline::before {
  content: "\\F12F7"; }

.mdi-tag-off::before {
  content: "\\F1220"; }

.mdi-tag-off-outline::before {
  content: "\\F1221"; }

.mdi-tag-outline::before {
  content: "\\F04FC"; }

.mdi-tag-plus::before {
  content: "\\F0722"; }

.mdi-tag-plus-outline::before {
  content: "\\F1222"; }

.mdi-tag-remove::before {
  content: "\\F0723"; }

.mdi-tag-remove-outline::before {
  content: "\\F1223"; }

.mdi-tag-search::before {
  content: "\\F1907"; }

.mdi-tag-search-outline::before {
  content: "\\F1908"; }

.mdi-tag-text::before {
  content: "\\F1224"; }

.mdi-tag-text-outline::before {
  content: "\\F04FD"; }

.mdi-tailwind::before {
  content: "\\F13FF"; }

.mdi-tangram::before {
  content: "\\F04F8"; }

.mdi-tank::before {
  content: "\\F0D3A"; }

.mdi-tanker-truck::before {
  content: "\\F0FE5"; }

.mdi-tape-drive::before {
  content: "\\F16DF"; }

.mdi-tape-measure::before {
  content: "\\F0B4D"; }

.mdi-target::before {
  content: "\\F04FE"; }

.mdi-target-account::before {
  content: "\\F0BD0"; }

.mdi-target-variant::before {
  content: "\\F0A77"; }

.mdi-taxi::before {
  content: "\\F04FF"; }

.mdi-tea::before {
  content: "\\F0D9E"; }

.mdi-tea-outline::before {
  content: "\\F0D9F"; }

.mdi-teamviewer::before {
  content: "\\F0500"; }

.mdi-teddy-bear::before {
  content: "\\F18FB"; }

.mdi-telescope::before {
  content: "\\F0B4E"; }

.mdi-television::before {
  content: "\\F0502"; }

.mdi-television-ambient-light::before {
  content: "\\F1356"; }

.mdi-television-box::before {
  content: "\\F0839"; }

.mdi-television-classic::before {
  content: "\\F07F4"; }

.mdi-television-classic-off::before {
  content: "\\F083A"; }

.mdi-television-guide::before {
  content: "\\F0503"; }

.mdi-television-off::before {
  content: "\\F083B"; }

.mdi-television-pause::before {
  content: "\\F0F89"; }

.mdi-television-play::before {
  content: "\\F0ECF"; }

.mdi-television-shimmer::before {
  content: "\\F1110"; }

.mdi-television-stop::before {
  content: "\\F0F8A"; }

.mdi-temperature-celsius::before {
  content: "\\F0504"; }

.mdi-temperature-fahrenheit::before {
  content: "\\F0505"; }

.mdi-temperature-kelvin::before {
  content: "\\F0506"; }

.mdi-tennis::before {
  content: "\\F0DA0"; }

.mdi-tennis-ball::before {
  content: "\\F0507"; }

.mdi-tent::before {
  content: "\\F0508"; }

.mdi-terraform::before {
  content: "\\F1062"; }

.mdi-terrain::before {
  content: "\\F0509"; }

.mdi-test-tube::before {
  content: "\\F0668"; }

.mdi-test-tube-empty::before {
  content: "\\F0911"; }

.mdi-test-tube-off::before {
  content: "\\F0912"; }

.mdi-text::before {
  content: "\\F09A8"; }

.mdi-text-account::before {
  content: "\\F1570"; }

.mdi-text-box::before {
  content: "\\F021A"; }

.mdi-text-box-check::before {
  content: "\\F0EA6"; }

.mdi-text-box-check-outline::before {
  content: "\\F0EA7"; }

.mdi-text-box-minus::before {
  content: "\\F0EA8"; }

.mdi-text-box-minus-outline::before {
  content: "\\F0EA9"; }

.mdi-text-box-multiple::before {
  content: "\\F0AB7"; }

.mdi-text-box-multiple-outline::before {
  content: "\\F0AB8"; }

.mdi-text-box-outline::before {
  content: "\\F09ED"; }

.mdi-text-box-plus::before {
  content: "\\F0EAA"; }

.mdi-text-box-plus-outline::before {
  content: "\\F0EAB"; }

.mdi-text-box-remove::before {
  content: "\\F0EAC"; }

.mdi-text-box-remove-outline::before {
  content: "\\F0EAD"; }

.mdi-text-box-search::before {
  content: "\\F0EAE"; }

.mdi-text-box-search-outline::before {
  content: "\\F0EAF"; }

.mdi-text-long::before {
  content: "\\F09AA"; }

.mdi-text-recognition::before {
  content: "\\F113D"; }

.mdi-text-search::before {
  content: "\\F13B8"; }

.mdi-text-shadow::before {
  content: "\\F0669"; }

.mdi-text-short::before {
  content: "\\F09A9"; }

.mdi-text-to-speech::before {
  content: "\\F050A"; }

.mdi-text-to-speech-off::before {
  content: "\\F050B"; }

.mdi-texture::before {
  content: "\\F050C"; }

.mdi-texture-box::before {
  content: "\\F0FE6"; }

.mdi-theater::before {
  content: "\\F050D"; }

.mdi-theme-light-dark::before {
  content: "\\F050E"; }

.mdi-thermometer::before {
  content: "\\F050F"; }

.mdi-thermometer-alert::before {
  content: "\\F0E01"; }

.mdi-thermometer-bluetooth::before {
  content: "\\F1895"; }

.mdi-thermometer-chevron-down::before {
  content: "\\F0E02"; }

.mdi-thermometer-chevron-up::before {
  content: "\\F0E03"; }

.mdi-thermometer-high::before {
  content: "\\F10C2"; }

.mdi-thermometer-lines::before {
  content: "\\F0510"; }

.mdi-thermometer-low::before {
  content: "\\F10C3"; }

.mdi-thermometer-minus::before {
  content: "\\F0E04"; }

.mdi-thermometer-off::before {
  content: "\\F1531"; }

.mdi-thermometer-plus::before {
  content: "\\F0E05"; }

.mdi-thermostat::before {
  content: "\\F0393"; }

.mdi-thermostat-box::before {
  content: "\\F0891"; }

.mdi-thought-bubble::before {
  content: "\\F07F6"; }

.mdi-thought-bubble-outline::before {
  content: "\\F07F7"; }

.mdi-thumb-down::before {
  content: "\\F0511"; }

.mdi-thumb-down-outline::before {
  content: "\\F0512"; }

.mdi-thumb-up::before {
  content: "\\F0513"; }

.mdi-thumb-up-outline::before {
  content: "\\F0514"; }

.mdi-thumbs-up-down::before {
  content: "\\F0515"; }

.mdi-thumbs-up-down-outline::before {
  content: "\\F1914"; }

.mdi-ticket::before {
  content: "\\F0516"; }

.mdi-ticket-account::before {
  content: "\\F0517"; }

.mdi-ticket-confirmation::before {
  content: "\\F0518"; }

.mdi-ticket-confirmation-outline::before {
  content: "\\F13AA"; }

.mdi-ticket-outline::before {
  content: "\\F0913"; }

.mdi-ticket-percent::before {
  content: "\\F0724"; }

.mdi-ticket-percent-outline::before {
  content: "\\F142B"; }

.mdi-tie::before {
  content: "\\F0519"; }

.mdi-tilde::before {
  content: "\\F0725"; }

.mdi-tilde-off::before {
  content: "\\F18F3"; }

.mdi-timelapse::before {
  content: "\\F051A"; }

.mdi-timeline::before {
  content: "\\F0BD1"; }

.mdi-timeline-alert::before {
  content: "\\F0F95"; }

.mdi-timeline-alert-outline::before {
  content: "\\F0F98"; }

.mdi-timeline-check::before {
  content: "\\F1532"; }

.mdi-timeline-check-outline::before {
  content: "\\F1533"; }

.mdi-timeline-clock::before {
  content: "\\F11FB"; }

.mdi-timeline-clock-outline::before {
  content: "\\F11FC"; }

.mdi-timeline-help::before {
  content: "\\F0F99"; }

.mdi-timeline-help-outline::before {
  content: "\\F0F9A"; }

.mdi-timeline-minus::before {
  content: "\\F1534"; }

.mdi-timeline-minus-outline::before {
  content: "\\F1535"; }

.mdi-timeline-outline::before {
  content: "\\F0BD2"; }

.mdi-timeline-plus::before {
  content: "\\F0F96"; }

.mdi-timeline-plus-outline::before {
  content: "\\F0F97"; }

.mdi-timeline-remove::before {
  content: "\\F1536"; }

.mdi-timeline-remove-outline::before {
  content: "\\F1537"; }

.mdi-timeline-text::before {
  content: "\\F0BD3"; }

.mdi-timeline-text-outline::before {
  content: "\\F0BD4"; }

.mdi-timer::before {
  content: "\\F13AB"; }

.mdi-timer-10::before {
  content: "\\F051C"; }

.mdi-timer-3::before {
  content: "\\F051D"; }

.mdi-timer-cog::before {
  content: "\\F1925"; }

.mdi-timer-cog-outline::before {
  content: "\\F1926"; }

.mdi-timer-off::before {
  content: "\\F13AC"; }

.mdi-timer-off-outline::before {
  content: "\\F051E"; }

.mdi-timer-outline::before {
  content: "\\F051B"; }

.mdi-timer-sand::before {
  content: "\\F051F"; }

.mdi-timer-sand-complete::before {
  content: "\\F199F"; }

.mdi-timer-sand-empty::before {
  content: "\\F06AD"; }

.mdi-timer-sand-full::before {
  content: "\\F078C"; }

.mdi-timer-sand-paused::before {
  content: "\\F19A0"; }

.mdi-timer-settings::before {
  content: "\\F1923"; }

.mdi-timer-settings-outline::before {
  content: "\\F1924"; }

.mdi-timetable::before {
  content: "\\F0520"; }

.mdi-tire::before {
  content: "\\F1896"; }

.mdi-toaster::before {
  content: "\\F1063"; }

.mdi-toaster-off::before {
  content: "\\F11B7"; }

.mdi-toaster-oven::before {
  content: "\\F0CD3"; }

.mdi-toggle-switch::before {
  content: "\\F0521"; }

.mdi-toggle-switch-off::before {
  content: "\\F0522"; }

.mdi-toggle-switch-off-outline::before {
  content: "\\F0A19"; }

.mdi-toggle-switch-outline::before {
  content: "\\F0A1A"; }

.mdi-toilet::before {
  content: "\\F09AB"; }

.mdi-toolbox::before {
  content: "\\F09AC"; }

.mdi-toolbox-outline::before {
  content: "\\F09AD"; }

.mdi-tools::before {
  content: "\\F1064"; }

.mdi-tooltip::before {
  content: "\\F0523"; }

.mdi-tooltip-account::before {
  content: "\\F000C"; }

.mdi-tooltip-cellphone::before {
  content: "\\F183B"; }

.mdi-tooltip-check::before {
  content: "\\F155C"; }

.mdi-tooltip-check-outline::before {
  content: "\\F155D"; }

.mdi-tooltip-edit::before {
  content: "\\F0524"; }

.mdi-tooltip-edit-outline::before {
  content: "\\F12C5"; }

.mdi-tooltip-image::before {
  content: "\\F0525"; }

.mdi-tooltip-image-outline::before {
  content: "\\F0BD5"; }

.mdi-tooltip-minus::before {
  content: "\\F155E"; }

.mdi-tooltip-minus-outline::before {
  content: "\\F155F"; }

.mdi-tooltip-outline::before {
  content: "\\F0526"; }

.mdi-tooltip-plus::before {
  content: "\\F0BD6"; }

.mdi-tooltip-plus-outline::before {
  content: "\\F0527"; }

.mdi-tooltip-remove::before {
  content: "\\F1560"; }

.mdi-tooltip-remove-outline::before {
  content: "\\F1561"; }

.mdi-tooltip-text::before {
  content: "\\F0528"; }

.mdi-tooltip-text-outline::before {
  content: "\\F0BD7"; }

.mdi-tooth::before {
  content: "\\F08C3"; }

.mdi-tooth-outline::before {
  content: "\\F0529"; }

.mdi-toothbrush::before {
  content: "\\F1129"; }

.mdi-toothbrush-electric::before {
  content: "\\F112C"; }

.mdi-toothbrush-paste::before {
  content: "\\F112A"; }

.mdi-torch::before {
  content: "\\F1606"; }

.mdi-tortoise::before {
  content: "\\F0D3B"; }

.mdi-toslink::before {
  content: "\\F12B8"; }

.mdi-tournament::before {
  content: "\\F09AE"; }

.mdi-tow-truck::before {
  content: "\\F083C"; }

.mdi-tower-beach::before {
  content: "\\F0681"; }

.mdi-tower-fire::before {
  content: "\\F0682"; }

.mdi-town-hall::before {
  content: "\\F1875"; }

.mdi-toy-brick::before {
  content: "\\F1288"; }

.mdi-toy-brick-marker::before {
  content: "\\F1289"; }

.mdi-toy-brick-marker-outline::before {
  content: "\\F128A"; }

.mdi-toy-brick-minus::before {
  content: "\\F128B"; }

.mdi-toy-brick-minus-outline::before {
  content: "\\F128C"; }

.mdi-toy-brick-outline::before {
  content: "\\F128D"; }

.mdi-toy-brick-plus::before {
  content: "\\F128E"; }

.mdi-toy-brick-plus-outline::before {
  content: "\\F128F"; }

.mdi-toy-brick-remove::before {
  content: "\\F1290"; }

.mdi-toy-brick-remove-outline::before {
  content: "\\F1291"; }

.mdi-toy-brick-search::before {
  content: "\\F1292"; }

.mdi-toy-brick-search-outline::before {
  content: "\\F1293"; }

.mdi-track-light::before {
  content: "\\F0914"; }

.mdi-trackpad::before {
  content: "\\F07F8"; }

.mdi-trackpad-lock::before {
  content: "\\F0933"; }

.mdi-tractor::before {
  content: "\\F0892"; }

.mdi-tractor-variant::before {
  content: "\\F14C4"; }

.mdi-trademark::before {
  content: "\\F0A78"; }

.mdi-traffic-cone::before {
  content: "\\F137C"; }

.mdi-traffic-light::before {
  content: "\\F052B"; }

.mdi-traffic-light-outline::before {
  content: "\\F182A"; }

.mdi-train::before {
  content: "\\F052C"; }

.mdi-train-car::before {
  content: "\\F0BD8"; }

.mdi-train-car-passenger::before {
  content: "\\F1733"; }

.mdi-train-car-passenger-door::before {
  content: "\\F1734"; }

.mdi-train-car-passenger-door-open::before {
  content: "\\F1735"; }

.mdi-train-car-passenger-variant::before {
  content: "\\F1736"; }

.mdi-train-variant::before {
  content: "\\F08C4"; }

.mdi-tram::before {
  content: "\\F052D"; }

.mdi-tram-side::before {
  content: "\\F0FE7"; }

.mdi-transcribe::before {
  content: "\\F052E"; }

.mdi-transcribe-close::before {
  content: "\\F052F"; }

.mdi-transfer::before {
  content: "\\F1065"; }

.mdi-transfer-down::before {
  content: "\\F0DA1"; }

.mdi-transfer-left::before {
  content: "\\F0DA2"; }

.mdi-transfer-right::before {
  content: "\\F0530"; }

.mdi-transfer-up::before {
  content: "\\F0DA3"; }

.mdi-transit-connection::before {
  content: "\\F0D3C"; }

.mdi-transit-connection-horizontal::before {
  content: "\\F1546"; }

.mdi-transit-connection-variant::before {
  content: "\\F0D3D"; }

.mdi-transit-detour::before {
  content: "\\F0F8B"; }

.mdi-transit-skip::before {
  content: "\\F1515"; }

.mdi-transit-transfer::before {
  content: "\\F06AE"; }

.mdi-transition::before {
  content: "\\F0915"; }

.mdi-transition-masked::before {
  content: "\\F0916"; }

.mdi-translate::before {
  content: "\\F05CA"; }

.mdi-translate-off::before {
  content: "\\F0E06"; }

.mdi-transmission-tower::before {
  content: "\\F0D3E"; }

.mdi-transmission-tower-export::before {
  content: "\\F192C"; }

.mdi-transmission-tower-import::before {
  content: "\\F192D"; }

.mdi-trash-can::before {
  content: "\\F0A79"; }

.mdi-trash-can-outline::before {
  content: "\\F0A7A"; }

.mdi-tray::before {
  content: "\\F1294"; }

.mdi-tray-alert::before {
  content: "\\F1295"; }

.mdi-tray-arrow-down::before {
  content: "\\F0120"; }

.mdi-tray-arrow-up::before {
  content: "\\F011D"; }

.mdi-tray-full::before {
  content: "\\F1296"; }

.mdi-tray-minus::before {
  content: "\\F1297"; }

.mdi-tray-plus::before {
  content: "\\F1298"; }

.mdi-tray-remove::before {
  content: "\\F1299"; }

.mdi-treasure-chest::before {
  content: "\\F0726"; }

.mdi-tree::before {
  content: "\\F0531"; }

.mdi-tree-outline::before {
  content: "\\F0E69"; }

.mdi-trello::before {
  content: "\\F0532"; }

.mdi-trending-down::before {
  content: "\\F0533"; }

.mdi-trending-neutral::before {
  content: "\\F0534"; }

.mdi-trending-up::before {
  content: "\\F0535"; }

.mdi-triangle::before {
  content: "\\F0536"; }

.mdi-triangle-outline::before {
  content: "\\F0537"; }

.mdi-triangle-wave::before {
  content: "\\F147C"; }

.mdi-triforce::before {
  content: "\\F0BD9"; }

.mdi-trophy::before {
  content: "\\F0538"; }

.mdi-trophy-award::before {
  content: "\\F0539"; }

.mdi-trophy-broken::before {
  content: "\\F0DA4"; }

.mdi-trophy-outline::before {
  content: "\\F053A"; }

.mdi-trophy-variant::before {
  content: "\\F053B"; }

.mdi-trophy-variant-outline::before {
  content: "\\F053C"; }

.mdi-truck::before {
  content: "\\F053D"; }

.mdi-truck-cargo-container::before {
  content: "\\F18D8"; }

.mdi-truck-check::before {
  content: "\\F0CD4"; }

.mdi-truck-check-outline::before {
  content: "\\F129A"; }

.mdi-truck-delivery::before {
  content: "\\F053E"; }

.mdi-truck-delivery-outline::before {
  content: "\\F129B"; }

.mdi-truck-fast::before {
  content: "\\F0788"; }

.mdi-truck-fast-outline::before {
  content: "\\F129C"; }

.mdi-truck-flatbed::before {
  content: "\\F1891"; }

.mdi-truck-minus::before {
  content: "\\F19AE"; }

.mdi-truck-minus-outline::before {
  content: "\\F19BD"; }

.mdi-truck-outline::before {
  content: "\\F129D"; }

.mdi-truck-plus::before {
  content: "\\F19AD"; }

.mdi-truck-plus-outline::before {
  content: "\\F19BC"; }

.mdi-truck-remove::before {
  content: "\\F19AF"; }

.mdi-truck-remove-outline::before {
  content: "\\F19BE"; }

.mdi-truck-snowflake::before {
  content: "\\F19A6"; }

.mdi-truck-trailer::before {
  content: "\\F0727"; }

.mdi-trumpet::before {
  content: "\\F1096"; }

.mdi-tshirt-crew::before {
  content: "\\F0A7B"; }

.mdi-tshirt-crew-outline::before {
  content: "\\F053F"; }

.mdi-tshirt-v::before {
  content: "\\F0A7C"; }

.mdi-tshirt-v-outline::before {
  content: "\\F0540"; }

.mdi-tumble-dryer::before {
  content: "\\F0917"; }

.mdi-tumble-dryer-alert::before {
  content: "\\F11BA"; }

.mdi-tumble-dryer-off::before {
  content: "\\F11BB"; }

.mdi-tune::before {
  content: "\\F062E"; }

.mdi-tune-variant::before {
  content: "\\F1542"; }

.mdi-tune-vertical::before {
  content: "\\F066A"; }

.mdi-tune-vertical-variant::before {
  content: "\\F1543"; }

.mdi-tunnel::before {
  content: "\\F183D"; }

.mdi-tunnel-outline::before {
  content: "\\F183E"; }

.mdi-turkey::before {
  content: "\\F171B"; }

.mdi-turnstile::before {
  content: "\\F0CD5"; }

.mdi-turnstile-outline::before {
  content: "\\F0CD6"; }

.mdi-turtle::before {
  content: "\\F0CD7"; }

.mdi-twitch::before {
  content: "\\F0543"; }

.mdi-twitter::before {
  content: "\\F0544"; }

.mdi-two-factor-authentication::before {
  content: "\\F09AF"; }

.mdi-typewriter::before {
  content: "\\F0F2D"; }

.mdi-ubisoft::before {
  content: "\\F0BDA"; }

.mdi-ubuntu::before {
  content: "\\F0548"; }

.mdi-ufo::before {
  content: "\\F10C4"; }

.mdi-ufo-outline::before {
  content: "\\F10C5"; }

.mdi-ultra-high-definition::before {
  content: "\\F07F9"; }

.mdi-umbraco::before {
  content: "\\F0549"; }

.mdi-umbrella::before {
  content: "\\F054A"; }

.mdi-umbrella-beach::before {
  content: "\\F188A"; }

.mdi-umbrella-beach-outline::before {
  content: "\\F188B"; }

.mdi-umbrella-closed::before {
  content: "\\F09B0"; }

.mdi-umbrella-closed-outline::before {
  content: "\\F13E2"; }

.mdi-umbrella-closed-variant::before {
  content: "\\F13E1"; }

.mdi-umbrella-outline::before {
  content: "\\F054B"; }

.mdi-undo::before {
  content: "\\F054C"; }

.mdi-undo-variant::before {
  content: "\\F054D"; }

.mdi-unfold-less-horizontal::before {
  content: "\\F054E"; }

.mdi-unfold-less-vertical::before {
  content: "\\F0760"; }

.mdi-unfold-more-horizontal::before {
  content: "\\F054F"; }

.mdi-unfold-more-vertical::before {
  content: "\\F0761"; }

.mdi-ungroup::before {
  content: "\\F0550"; }

.mdi-unicode::before {
  content: "\\F0ED0"; }

.mdi-unicorn::before {
  content: "\\F15C2"; }

.mdi-unicorn-variant::before {
  content: "\\F15C3"; }

.mdi-unicycle::before {
  content: "\\F15E5"; }

.mdi-unity::before {
  content: "\\F06AF"; }

.mdi-unreal::before {
  content: "\\F09B1"; }

.mdi-update::before {
  content: "\\F06B0"; }

.mdi-upload::before {
  content: "\\F0552"; }

.mdi-upload-lock::before {
  content: "\\F1373"; }

.mdi-upload-lock-outline::before {
  content: "\\F1374"; }

.mdi-upload-multiple::before {
  content: "\\F083D"; }

.mdi-upload-network::before {
  content: "\\F06F6"; }

.mdi-upload-network-outline::before {
  content: "\\F0CD8"; }

.mdi-upload-off::before {
  content: "\\F10C6"; }

.mdi-upload-off-outline::before {
  content: "\\F10C7"; }

.mdi-upload-outline::before {
  content: "\\F0E07"; }

.mdi-usb::before {
  content: "\\F0553"; }

.mdi-usb-flash-drive::before {
  content: "\\F129E"; }

.mdi-usb-flash-drive-outline::before {
  content: "\\F129F"; }

.mdi-usb-port::before {
  content: "\\F11F0"; }

.mdi-vacuum::before {
  content: "\\F19A1"; }

.mdi-vacuum-outline::before {
  content: "\\F19A2"; }

.mdi-valve::before {
  content: "\\F1066"; }

.mdi-valve-closed::before {
  content: "\\F1067"; }

.mdi-valve-open::before {
  content: "\\F1068"; }

.mdi-van-passenger::before {
  content: "\\F07FA"; }

.mdi-van-utility::before {
  content: "\\F07FB"; }

.mdi-vanish::before {
  content: "\\F07FC"; }

.mdi-vanish-quarter::before {
  content: "\\F1554"; }

.mdi-vanity-light::before {
  content: "\\F11E1"; }

.mdi-variable::before {
  content: "\\F0AE7"; }

.mdi-variable-box::before {
  content: "\\F1111"; }

.mdi-vector-arrange-above::before {
  content: "\\F0554"; }

.mdi-vector-arrange-below::before {
  content: "\\F0555"; }

.mdi-vector-bezier::before {
  content: "\\F0AE8"; }

.mdi-vector-circle::before {
  content: "\\F0556"; }

.mdi-vector-circle-variant::before {
  content: "\\F0557"; }

.mdi-vector-combine::before {
  content: "\\F0558"; }

.mdi-vector-curve::before {
  content: "\\F0559"; }

.mdi-vector-difference::before {
  content: "\\F055A"; }

.mdi-vector-difference-ab::before {
  content: "\\F055B"; }

.mdi-vector-difference-ba::before {
  content: "\\F055C"; }

.mdi-vector-ellipse::before {
  content: "\\F0893"; }

.mdi-vector-intersection::before {
  content: "\\F055D"; }

.mdi-vector-line::before {
  content: "\\F055E"; }

.mdi-vector-link::before {
  content: "\\F0FE8"; }

.mdi-vector-point::before {
  content: "\\F055F"; }

.mdi-vector-polygon::before {
  content: "\\F0560"; }

.mdi-vector-polygon-variant::before {
  content: "\\F1856"; }

.mdi-vector-polyline::before {
  content: "\\F0561"; }

.mdi-vector-polyline-edit::before {
  content: "\\F1225"; }

.mdi-vector-polyline-minus::before {
  content: "\\F1226"; }

.mdi-vector-polyline-plus::before {
  content: "\\F1227"; }

.mdi-vector-polyline-remove::before {
  content: "\\F1228"; }

.mdi-vector-radius::before {
  content: "\\F074A"; }

.mdi-vector-rectangle::before {
  content: "\\F05C6"; }

.mdi-vector-selection::before {
  content: "\\F0562"; }

.mdi-vector-square::before {
  content: "\\F0001"; }

.mdi-vector-square-close::before {
  content: "\\F1857"; }

.mdi-vector-square-edit::before {
  content: "\\F18D9"; }

.mdi-vector-square-minus::before {
  content: "\\F18DA"; }

.mdi-vector-square-open::before {
  content: "\\F1858"; }

.mdi-vector-square-plus::before {
  content: "\\F18DB"; }

.mdi-vector-square-remove::before {
  content: "\\F18DC"; }

.mdi-vector-triangle::before {
  content: "\\F0563"; }

.mdi-vector-union::before {
  content: "\\F0564"; }

.mdi-vhs::before {
  content: "\\F0A1B"; }

.mdi-vibrate::before {
  content: "\\F0566"; }

.mdi-vibrate-off::before {
  content: "\\F0CD9"; }

.mdi-video::before {
  content: "\\F0567"; }

.mdi-video-3d::before {
  content: "\\F07FD"; }

.mdi-video-3d-off::before {
  content: "\\F13D9"; }

.mdi-video-3d-variant::before {
  content: "\\F0ED1"; }

.mdi-video-4k-box::before {
  content: "\\F083E"; }

.mdi-video-account::before {
  content: "\\F0919"; }

.mdi-video-box::before {
  content: "\\F00FD"; }

.mdi-video-box-off::before {
  content: "\\F00FE"; }

.mdi-video-check::before {
  content: "\\F1069"; }

.mdi-video-check-outline::before {
  content: "\\F106A"; }

.mdi-video-high-definition::before {
  content: "\\F152E"; }

.mdi-video-image::before {
  content: "\\F091A"; }

.mdi-video-input-antenna::before {
  content: "\\F083F"; }

.mdi-video-input-component::before {
  content: "\\F0840"; }

.mdi-video-input-hdmi::before {
  content: "\\F0841"; }

.mdi-video-input-scart::before {
  content: "\\F0F8C"; }

.mdi-video-input-svideo::before {
  content: "\\F0842"; }

.mdi-video-marker::before {
  content: "\\F19A9"; }

.mdi-video-marker-outline::before {
  content: "\\F19AA"; }

.mdi-video-minus::before {
  content: "\\F09B2"; }

.mdi-video-minus-outline::before {
  content: "\\F02BA"; }

.mdi-video-off::before {
  content: "\\F0568"; }

.mdi-video-off-outline::before {
  content: "\\F0BDB"; }

.mdi-video-outline::before {
  content: "\\F0BDC"; }

.mdi-video-plus::before {
  content: "\\F09B3"; }

.mdi-video-plus-outline::before {
  content: "\\F01D3"; }

.mdi-video-stabilization::before {
  content: "\\F091B"; }

.mdi-video-switch::before {
  content: "\\F0569"; }

.mdi-video-switch-outline::before {
  content: "\\F0790"; }

.mdi-video-vintage::before {
  content: "\\F0A1C"; }

.mdi-video-wireless::before {
  content: "\\F0ED2"; }

.mdi-video-wireless-outline::before {
  content: "\\F0ED3"; }

.mdi-view-agenda::before {
  content: "\\F056A"; }

.mdi-view-agenda-outline::before {
  content: "\\F11D8"; }

.mdi-view-array::before {
  content: "\\F056B"; }

.mdi-view-array-outline::before {
  content: "\\F1485"; }

.mdi-view-carousel::before {
  content: "\\F056C"; }

.mdi-view-carousel-outline::before {
  content: "\\F1486"; }

.mdi-view-column::before {
  content: "\\F056D"; }

.mdi-view-column-outline::before {
  content: "\\F1487"; }

.mdi-view-comfy::before {
  content: "\\F0E6A"; }

.mdi-view-comfy-outline::before {
  content: "\\F1488"; }

.mdi-view-compact::before {
  content: "\\F0E6B"; }

.mdi-view-compact-outline::before {
  content: "\\F0E6C"; }

.mdi-view-dashboard::before {
  content: "\\F056E"; }

.mdi-view-dashboard-edit::before {
  content: "\\F1947"; }

.mdi-view-dashboard-edit-outline::before {
  content: "\\F1948"; }

.mdi-view-dashboard-outline::before {
  content: "\\F0A1D"; }

.mdi-view-dashboard-variant::before {
  content: "\\F0843"; }

.mdi-view-dashboard-variant-outline::before {
  content: "\\F1489"; }

.mdi-view-day::before {
  content: "\\F056F"; }

.mdi-view-day-outline::before {
  content: "\\F148A"; }

.mdi-view-gallery::before {
  content: "\\F1888"; }

.mdi-view-gallery-outline::before {
  content: "\\F1889"; }

.mdi-view-grid::before {
  content: "\\F0570"; }

.mdi-view-grid-outline::before {
  content: "\\F11D9"; }

.mdi-view-grid-plus::before {
  content: "\\F0F8D"; }

.mdi-view-grid-plus-outline::before {
  content: "\\F11DA"; }

.mdi-view-headline::before {
  content: "\\F0571"; }

.mdi-view-list::before {
  content: "\\F0572"; }

.mdi-view-list-outline::before {
  content: "\\F148B"; }

.mdi-view-module::before {
  content: "\\F0573"; }

.mdi-view-module-outline::before {
  content: "\\F148C"; }

.mdi-view-parallel::before {
  content: "\\F0728"; }

.mdi-view-parallel-outline::before {
  content: "\\F148D"; }

.mdi-view-quilt::before {
  content: "\\F0574"; }

.mdi-view-quilt-outline::before {
  content: "\\F148E"; }

.mdi-view-sequential::before {
  content: "\\F0729"; }

.mdi-view-sequential-outline::before {
  content: "\\F148F"; }

.mdi-view-split-horizontal::before {
  content: "\\F0BCB"; }

.mdi-view-split-vertical::before {
  content: "\\F0BCC"; }

.mdi-view-stream::before {
  content: "\\F0575"; }

.mdi-view-stream-outline::before {
  content: "\\F1490"; }

.mdi-view-week::before {
  content: "\\F0576"; }

.mdi-view-week-outline::before {
  content: "\\F1491"; }

.mdi-vimeo::before {
  content: "\\F0577"; }

.mdi-violin::before {
  content: "\\F060F"; }

.mdi-virtual-reality::before {
  content: "\\F0894"; }

.mdi-virus::before {
  content: "\\F13B6"; }

.mdi-virus-off::before {
  content: "\\F18E1"; }

.mdi-virus-off-outline::before {
  content: "\\F18E2"; }

.mdi-virus-outline::before {
  content: "\\F13B7"; }

.mdi-vlc::before {
  content: "\\F057C"; }

.mdi-voicemail::before {
  content: "\\F057D"; }

.mdi-volleyball::before {
  content: "\\F09B4"; }

.mdi-volume-high::before {
  content: "\\F057E"; }

.mdi-volume-low::before {
  content: "\\F057F"; }

.mdi-volume-medium::before {
  content: "\\F0580"; }

.mdi-volume-minus::before {
  content: "\\F075E"; }

.mdi-volume-mute::before {
  content: "\\F075F"; }

.mdi-volume-off::before {
  content: "\\F0581"; }

.mdi-volume-plus::before {
  content: "\\F075D"; }

.mdi-volume-source::before {
  content: "\\F1120"; }

.mdi-volume-variant-off::before {
  content: "\\F0E08"; }

.mdi-volume-vibrate::before {
  content: "\\F1121"; }

.mdi-vote::before {
  content: "\\F0A1F"; }

.mdi-vote-outline::before {
  content: "\\F0A20"; }

.mdi-vpn::before {
  content: "\\F0582"; }

.mdi-vuejs::before {
  content: "\\F0844"; }

.mdi-vuetify::before {
  content: "\\F0E6D"; }

.mdi-walk::before {
  content: "\\F0583"; }

.mdi-wall::before {
  content: "\\F07FE"; }

.mdi-wall-sconce::before {
  content: "\\F091C"; }

.mdi-wall-sconce-flat::before {
  content: "\\F091D"; }

.mdi-wall-sconce-flat-outline::before {
  content: "\\F17C9"; }

.mdi-wall-sconce-flat-variant::before {
  content: "\\F041C"; }

.mdi-wall-sconce-flat-variant-outline::before {
  content: "\\F17CA"; }

.mdi-wall-sconce-outline::before {
  content: "\\F17CB"; }

.mdi-wall-sconce-round::before {
  content: "\\F0748"; }

.mdi-wall-sconce-round-outline::before {
  content: "\\F17CC"; }

.mdi-wall-sconce-round-variant::before {
  content: "\\F091E"; }

.mdi-wall-sconce-round-variant-outline::before {
  content: "\\F17CD"; }

.mdi-wallet::before {
  content: "\\F0584"; }

.mdi-wallet-giftcard::before {
  content: "\\F0585"; }

.mdi-wallet-membership::before {
  content: "\\F0586"; }

.mdi-wallet-outline::before {
  content: "\\F0BDD"; }

.mdi-wallet-plus::before {
  content: "\\F0F8E"; }

.mdi-wallet-plus-outline::before {
  content: "\\F0F8F"; }

.mdi-wallet-travel::before {
  content: "\\F0587"; }

.mdi-wallpaper::before {
  content: "\\F0E09"; }

.mdi-wan::before {
  content: "\\F0588"; }

.mdi-wardrobe::before {
  content: "\\F0F90"; }

.mdi-wardrobe-outline::before {
  content: "\\F0F91"; }

.mdi-warehouse::before {
  content: "\\F0F81"; }

.mdi-washing-machine::before {
  content: "\\F072A"; }

.mdi-washing-machine-alert::before {
  content: "\\F11BC"; }

.mdi-washing-machine-off::before {
  content: "\\F11BD"; }

.mdi-watch::before {
  content: "\\F0589"; }

.mdi-watch-export::before {
  content: "\\F058A"; }

.mdi-watch-export-variant::before {
  content: "\\F0895"; }

.mdi-watch-import::before {
  content: "\\F058B"; }

.mdi-watch-import-variant::before {
  content: "\\F0896"; }

.mdi-watch-variant::before {
  content: "\\F0897"; }

.mdi-watch-vibrate::before {
  content: "\\F06B1"; }

.mdi-watch-vibrate-off::before {
  content: "\\F0CDA"; }

.mdi-water::before {
  content: "\\F058C"; }

.mdi-water-alert::before {
  content: "\\F1502"; }

.mdi-water-alert-outline::before {
  content: "\\F1503"; }

.mdi-water-boiler::before {
  content: "\\F0F92"; }

.mdi-water-boiler-alert::before {
  content: "\\F11B3"; }

.mdi-water-boiler-off::before {
  content: "\\F11B4"; }

.mdi-water-check::before {
  content: "\\F1504"; }

.mdi-water-check-outline::before {
  content: "\\F1505"; }

.mdi-water-circle::before {
  content: "\\F1806"; }

.mdi-water-minus::before {
  content: "\\F1506"; }

.mdi-water-minus-outline::before {
  content: "\\F1507"; }

.mdi-water-off::before {
  content: "\\F058D"; }

.mdi-water-off-outline::before {
  content: "\\F1508"; }

.mdi-water-opacity::before {
  content: "\\F1855"; }

.mdi-water-outline::before {
  content: "\\F0E0A"; }

.mdi-water-percent::before {
  content: "\\F058E"; }

.mdi-water-percent-alert::before {
  content: "\\F1509"; }

.mdi-water-plus::before {
  content: "\\F150A"; }

.mdi-water-plus-outline::before {
  content: "\\F150B"; }

.mdi-water-polo::before {
  content: "\\F12A0"; }

.mdi-water-pump::before {
  content: "\\F058F"; }

.mdi-water-pump-off::before {
  content: "\\F0F93"; }

.mdi-water-remove::before {
  content: "\\F150C"; }

.mdi-water-remove-outline::before {
  content: "\\F150D"; }

.mdi-water-sync::before {
  content: "\\F17C6"; }

.mdi-water-well::before {
  content: "\\F106B"; }

.mdi-water-well-outline::before {
  content: "\\F106C"; }

.mdi-waterfall::before {
  content: "\\F1849"; }

.mdi-watering-can::before {
  content: "\\F1481"; }

.mdi-watering-can-outline::before {
  content: "\\F1482"; }

.mdi-watermark::before {
  content: "\\F0612"; }

.mdi-wave::before {
  content: "\\F0F2E"; }

.mdi-waveform::before {
  content: "\\F147D"; }

.mdi-waves::before {
  content: "\\F078D"; }

.mdi-waves-arrow-left::before {
  content: "\\F1859"; }

.mdi-waves-arrow-right::before {
  content: "\\F185A"; }

.mdi-waves-arrow-up::before {
  content: "\\F185B"; }

.mdi-waze::before {
  content: "\\F0BDE"; }

.mdi-weather-cloudy::before {
  content: "\\F0590"; }

.mdi-weather-cloudy-alert::before {
  content: "\\F0F2F"; }

.mdi-weather-cloudy-arrow-right::before {
  content: "\\F0E6E"; }

.mdi-weather-cloudy-clock::before {
  content: "\\F18F6"; }

.mdi-weather-fog::before {
  content: "\\F0591"; }

.mdi-weather-hail::before {
  content: "\\F0592"; }

.mdi-weather-hazy::before {
  content: "\\F0F30"; }

.mdi-weather-hurricane::before {
  content: "\\F0898"; }

.mdi-weather-lightning::before {
  content: "\\F0593"; }

.mdi-weather-lightning-rainy::before {
  content: "\\F067E"; }

.mdi-weather-night::before {
  content: "\\F0594"; }

.mdi-weather-night-partly-cloudy::before {
  content: "\\F0F31"; }

.mdi-weather-partly-cloudy::before {
  content: "\\F0595"; }

.mdi-weather-partly-lightning::before {
  content: "\\F0F32"; }

.mdi-weather-partly-rainy::before {
  content: "\\F0F33"; }

.mdi-weather-partly-snowy::before {
  content: "\\F0F34"; }

.mdi-weather-partly-snowy-rainy::before {
  content: "\\F0F35"; }

.mdi-weather-pouring::before {
  content: "\\F0596"; }

.mdi-weather-rainy::before {
  content: "\\F0597"; }

.mdi-weather-snowy::before {
  content: "\\F0598"; }

.mdi-weather-snowy-heavy::before {
  content: "\\F0F36"; }

.mdi-weather-snowy-rainy::before {
  content: "\\F067F"; }

.mdi-weather-sunny::before {
  content: "\\F0599"; }

.mdi-weather-sunny-alert::before {
  content: "\\F0F37"; }

.mdi-weather-sunny-off::before {
  content: "\\F14E4"; }

.mdi-weather-sunset::before {
  content: "\\F059A"; }

.mdi-weather-sunset-down::before {
  content: "\\F059B"; }

.mdi-weather-sunset-up::before {
  content: "\\F059C"; }

.mdi-weather-tornado::before {
  content: "\\F0F38"; }

.mdi-weather-windy::before {
  content: "\\F059D"; }

.mdi-weather-windy-variant::before {
  content: "\\F059E"; }

.mdi-web::before {
  content: "\\F059F"; }

.mdi-web-box::before {
  content: "\\F0F94"; }

.mdi-web-cancel::before {
  content: "\\F1790"; }

.mdi-web-check::before {
  content: "\\F0789"; }

.mdi-web-clock::before {
  content: "\\F124A"; }

.mdi-web-minus::before {
  content: "\\F10A0"; }

.mdi-web-off::before {
  content: "\\F0A8E"; }

.mdi-web-plus::before {
  content: "\\F0033"; }

.mdi-web-refresh::before {
  content: "\\F1791"; }

.mdi-web-remove::before {
  content: "\\F0551"; }

.mdi-web-sync::before {
  content: "\\F1792"; }

.mdi-webcam::before {
  content: "\\F05A0"; }

.mdi-webcam-off::before {
  content: "\\F1737"; }

.mdi-webhook::before {
  content: "\\F062F"; }

.mdi-webpack::before {
  content: "\\F072B"; }

.mdi-webrtc::before {
  content: "\\F1248"; }

.mdi-wechat::before {
  content: "\\F0611"; }

.mdi-weight::before {
  content: "\\F05A1"; }

.mdi-weight-gram::before {
  content: "\\F0D3F"; }

.mdi-weight-kilogram::before {
  content: "\\F05A2"; }

.mdi-weight-lifter::before {
  content: "\\F115D"; }

.mdi-weight-pound::before {
  content: "\\F09B5"; }

.mdi-whatsapp::before {
  content: "\\F05A3"; }

.mdi-wheel-barrow::before {
  content: "\\F14F2"; }

.mdi-wheelchair-accessibility::before {
  content: "\\F05A4"; }

.mdi-whistle::before {
  content: "\\F09B6"; }

.mdi-whistle-outline::before {
  content: "\\F12BC"; }

.mdi-white-balance-auto::before {
  content: "\\F05A5"; }

.mdi-white-balance-incandescent::before {
  content: "\\F05A6"; }

.mdi-white-balance-iridescent::before {
  content: "\\F05A7"; }

.mdi-white-balance-sunny::before {
  content: "\\F05A8"; }

.mdi-widgets::before {
  content: "\\F072C"; }

.mdi-widgets-outline::before {
  content: "\\F1355"; }

.mdi-wifi::before {
  content: "\\F05A9"; }

.mdi-wifi-alert::before {
  content: "\\F16B5"; }

.mdi-wifi-arrow-down::before {
  content: "\\F16B6"; }

.mdi-wifi-arrow-left::before {
  content: "\\F16B7"; }

.mdi-wifi-arrow-left-right::before {
  content: "\\F16B8"; }

.mdi-wifi-arrow-right::before {
  content: "\\F16B9"; }

.mdi-wifi-arrow-up::before {
  content: "\\F16BA"; }

.mdi-wifi-arrow-up-down::before {
  content: "\\F16BB"; }

.mdi-wifi-cancel::before {
  content: "\\F16BC"; }

.mdi-wifi-check::before {
  content: "\\F16BD"; }

.mdi-wifi-cog::before {
  content: "\\F16BE"; }

.mdi-wifi-lock::before {
  content: "\\F16BF"; }

.mdi-wifi-lock-open::before {
  content: "\\F16C0"; }

.mdi-wifi-marker::before {
  content: "\\F16C1"; }

.mdi-wifi-minus::before {
  content: "\\F16C2"; }

.mdi-wifi-off::before {
  content: "\\F05AA"; }

.mdi-wifi-plus::before {
  content: "\\F16C3"; }

.mdi-wifi-refresh::before {
  content: "\\F16C4"; }

.mdi-wifi-remove::before {
  content: "\\F16C5"; }

.mdi-wifi-settings::before {
  content: "\\F16C6"; }

.mdi-wifi-star::before {
  content: "\\F0E0B"; }

.mdi-wifi-strength-1::before {
  content: "\\F091F"; }

.mdi-wifi-strength-1-alert::before {
  content: "\\F0920"; }

.mdi-wifi-strength-1-lock::before {
  content: "\\F0921"; }

.mdi-wifi-strength-1-lock-open::before {
  content: "\\F16CB"; }

.mdi-wifi-strength-2::before {
  content: "\\F0922"; }

.mdi-wifi-strength-2-alert::before {
  content: "\\F0923"; }

.mdi-wifi-strength-2-lock::before {
  content: "\\F0924"; }

.mdi-wifi-strength-2-lock-open::before {
  content: "\\F16CC"; }

.mdi-wifi-strength-3::before {
  content: "\\F0925"; }

.mdi-wifi-strength-3-alert::before {
  content: "\\F0926"; }

.mdi-wifi-strength-3-lock::before {
  content: "\\F0927"; }

.mdi-wifi-strength-3-lock-open::before {
  content: "\\F16CD"; }

.mdi-wifi-strength-4::before {
  content: "\\F0928"; }

.mdi-wifi-strength-4-alert::before {
  content: "\\F0929"; }

.mdi-wifi-strength-4-lock::before {
  content: "\\F092A"; }

.mdi-wifi-strength-4-lock-open::before {
  content: "\\F16CE"; }

.mdi-wifi-strength-alert-outline::before {
  content: "\\F092B"; }

.mdi-wifi-strength-lock-open-outline::before {
  content: "\\F16CF"; }

.mdi-wifi-strength-lock-outline::before {
  content: "\\F092C"; }

.mdi-wifi-strength-off::before {
  content: "\\F092D"; }

.mdi-wifi-strength-off-outline::before {
  content: "\\F092E"; }

.mdi-wifi-strength-outline::before {
  content: "\\F092F"; }

.mdi-wifi-sync::before {
  content: "\\F16C7"; }

.mdi-wikipedia::before {
  content: "\\F05AC"; }

.mdi-wind-turbine::before {
  content: "\\F0DA5"; }

.mdi-wind-turbine-alert::before {
  content: "\\F19AB"; }

.mdi-wind-turbine-check::before {
  content: "\\F19AC"; }

.mdi-window-close::before {
  content: "\\F05AD"; }

.mdi-window-closed::before {
  content: "\\F05AE"; }

.mdi-window-closed-variant::before {
  content: "\\F11DB"; }

.mdi-window-maximize::before {
  content: "\\F05AF"; }

.mdi-window-minimize::before {
  content: "\\F05B0"; }

.mdi-window-open::before {
  content: "\\F05B1"; }

.mdi-window-open-variant::before {
  content: "\\F11DC"; }

.mdi-window-restore::before {
  content: "\\F05B2"; }

.mdi-window-shutter::before {
  content: "\\F111C"; }

.mdi-window-shutter-alert::before {
  content: "\\F111D"; }

.mdi-window-shutter-open::before {
  content: "\\F111E"; }

.mdi-windsock::before {
  content: "\\F15FA"; }

.mdi-wiper::before {
  content: "\\F0AE9"; }

.mdi-wiper-wash::before {
  content: "\\F0DA6"; }

.mdi-wiper-wash-alert::before {
  content: "\\F18DF"; }

.mdi-wizard-hat::before {
  content: "\\F1477"; }

.mdi-wordpress::before {
  content: "\\F05B4"; }

.mdi-wrap::before {
  content: "\\F05B6"; }

.mdi-wrap-disabled::before {
  content: "\\F0BDF"; }

.mdi-wrench::before {
  content: "\\F05B7"; }

.mdi-wrench-clock::before {
  content: "\\F19A3"; }

.mdi-wrench-outline::before {
  content: "\\F0BE0"; }

.mdi-xamarin::before {
  content: "\\F0845"; }

.mdi-xml::before {
  content: "\\F05C0"; }

.mdi-xmpp::before {
  content: "\\F07FF"; }

.mdi-yahoo::before {
  content: "\\F0B4F"; }

.mdi-yeast::before {
  content: "\\F05C1"; }

.mdi-yin-yang::before {
  content: "\\F0680"; }

.mdi-yoga::before {
  content: "\\F117C"; }

.mdi-youtube::before {
  content: "\\F05C3"; }

.mdi-youtube-gaming::before {
  content: "\\F0848"; }

.mdi-youtube-studio::before {
  content: "\\F0847"; }

.mdi-youtube-subscription::before {
  content: "\\F0D40"; }

.mdi-youtube-tv::before {
  content: "\\F0448"; }

.mdi-yurt::before {
  content: "\\F1516"; }

.mdi-z-wave::before {
  content: "\\F0AEA"; }

.mdi-zend::before {
  content: "\\F0AEB"; }

.mdi-zigbee::before {
  content: "\\F0D41"; }

.mdi-zip-box::before {
  content: "\\F05C4"; }

.mdi-zip-box-outline::before {
  content: "\\F0FFA"; }

.mdi-zip-disk::before {
  content: "\\F0A23"; }

.mdi-zodiac-aquarius::before {
  content: "\\F0A7D"; }

.mdi-zodiac-aries::before {
  content: "\\F0A7E"; }

.mdi-zodiac-cancer::before {
  content: "\\F0A7F"; }

.mdi-zodiac-capricorn::before {
  content: "\\F0A80"; }

.mdi-zodiac-gemini::before {
  content: "\\F0A81"; }

.mdi-zodiac-leo::before {
  content: "\\F0A82"; }

.mdi-zodiac-libra::before {
  content: "\\F0A83"; }

.mdi-zodiac-pisces::before {
  content: "\\F0A84"; }

.mdi-zodiac-sagittarius::before {
  content: "\\F0A85"; }

.mdi-zodiac-scorpio::before {
  content: "\\F0A86"; }

.mdi-zodiac-taurus::before {
  content: "\\F0A87"; }

.mdi-zodiac-virgo::before {
  content: "\\F0A88"; }

.mdi-blank::before {
  content: "\\F68C";
  visibility: hidden; }

.mdi-18px.mdi-set, .mdi-18px.mdi:before {
  font-size: 18px; }

.mdi-24px.mdi-set, .mdi-24px.mdi:before {
  font-size: 24px; }

.mdi-36px.mdi-set, .mdi-36px.mdi:before {
  font-size: 36px; }

.mdi-48px.mdi-set, .mdi-48px.mdi:before {
  font-size: 48px; }

.mdi-dark:before {
  color: rgba(0, 0, 0, 0.54); }

.mdi-dark.mdi-inactive:before {
  color: rgba(0, 0, 0, 0.26); }

.mdi-light:before {
  color: white; }

.mdi-light.mdi-inactive:before {
  color: rgba(255, 255, 255, 0.3); }

.mdi-rotate-45 {
  /*
        // Not included in production
        &.mdi-flip-h:before {
            -webkit-transform: scaleX(-1) rotate(45deg);
            transform: scaleX(-1) rotate(45deg);
            filter: FlipH;
            -ms-filter: "FlipH";
        }
        &.mdi-flip-v:before {
            -webkit-transform: scaleY(-1) rotate(45deg);
            -ms-transform: rotate(45deg);
            transform: scaleY(-1) rotate(45deg);
            filter: FlipV;
            -ms-filter: "FlipV";
        }
        */ }

.mdi-rotate-45:before {
  transform: rotate(45deg); }

.mdi-rotate-90 {
  /*
        // Not included in production
        &.mdi-flip-h:before {
            -webkit-transform: scaleX(-1) rotate(90deg);
            transform: scaleX(-1) rotate(90deg);
            filter: FlipH;
            -ms-filter: "FlipH";
        }
        &.mdi-flip-v:before {
            -webkit-transform: scaleY(-1) rotate(90deg);
            -ms-transform: rotate(90deg);
            transform: scaleY(-1) rotate(90deg);
            filter: FlipV;
            -ms-filter: "FlipV";
        }
        */ }

.mdi-rotate-90:before {
  transform: rotate(90deg); }

.mdi-rotate-135 {
  /*
        // Not included in production
        &.mdi-flip-h:before {
            -webkit-transform: scaleX(-1) rotate(135deg);
            transform: scaleX(-1) rotate(135deg);
            filter: FlipH;
            -ms-filter: "FlipH";
        }
        &.mdi-flip-v:before {
            -webkit-transform: scaleY(-1) rotate(135deg);
            -ms-transform: rotate(135deg);
            transform: scaleY(-1) rotate(135deg);
            filter: FlipV;
            -ms-filter: "FlipV";
        }
        */ }

.mdi-rotate-135:before {
  transform: rotate(135deg); }

.mdi-rotate-180 {
  /*
        // Not included in production
        &.mdi-flip-h:before {
            -webkit-transform: scaleX(-1) rotate(180deg);
            transform: scaleX(-1) rotate(180deg);
            filter: FlipH;
            -ms-filter: "FlipH";
        }
        &.mdi-flip-v:before {
            -webkit-transform: scaleY(-1) rotate(180deg);
            -ms-transform: rotate(180deg);
            transform: scaleY(-1) rotate(180deg);
            filter: FlipV;
            -ms-filter: "FlipV";
        }
        */ }

.mdi-rotate-180:before {
  transform: rotate(180deg); }

.mdi-rotate-225 {
  /*
        // Not included in production
        &.mdi-flip-h:before {
            -webkit-transform: scaleX(-1) rotate(225deg);
            transform: scaleX(-1) rotate(225deg);
            filter: FlipH;
            -ms-filter: "FlipH";
        }
        &.mdi-flip-v:before {
            -webkit-transform: scaleY(-1) rotate(225deg);
            -ms-transform: rotate(225deg);
            transform: scaleY(-1) rotate(225deg);
            filter: FlipV;
            -ms-filter: "FlipV";
        }
        */ }

.mdi-rotate-225:before {
  transform: rotate(225deg); }

.mdi-rotate-270 {
  /*
        // Not included in production
        &.mdi-flip-h:before {
            -webkit-transform: scaleX(-1) rotate(270deg);
            transform: scaleX(-1) rotate(270deg);
            filter: FlipH;
            -ms-filter: "FlipH";
        }
        &.mdi-flip-v:before {
            -webkit-transform: scaleY(-1) rotate(270deg);
            -ms-transform: rotate(270deg);
            transform: scaleY(-1) rotate(270deg);
            filter: FlipV;
            -ms-filter: "FlipV";
        }
        */ }

.mdi-rotate-270:before {
  transform: rotate(270deg); }

.mdi-rotate-315 {
  /*
        // Not included in production
        &.mdi-flip-h:before {
            -webkit-transform: scaleX(-1) rotate(315deg);
            transform: scaleX(-1) rotate(315deg);
            filter: FlipH;
            -ms-filter: "FlipH";
        }
        &.mdi-flip-v:before {
            -webkit-transform: scaleY(-1) rotate(315deg);
            -ms-transform: rotate(315deg);
            transform: scaleY(-1) rotate(315deg);
            filter: FlipV;
            -ms-filter: "FlipV";
        }
        */ }

.mdi-rotate-315:before {
  transform: rotate(315deg); }

.mdi-flip-h:before {
  transform: scaleX(-1);
  filter: FlipH;
  -ms-filter: "FlipH"; }

.mdi-flip-v:before {
  transform: scaleY(-1);
  filter: FlipV;
  -ms-filter: "FlipV"; }

.mdi-spin:before {
  animation: mdi-spin 2s infinite linear; }

@keyframes mdi-spin {
  0% {
    transform: rotate(0deg); }
  100% {
    transform: rotate(359deg); } }

/*# sourceMappingURL=materialdesignicons.css.map */
@font-face {
  font-family: 'boxicons';
  font-weight: normal;
  font-style: normal;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format("svg"); }

.bx {
  font-family: 'boxicons' !important;
  font-weight: normal;
  font-style: normal;
  font-feature-settings: normal;
  font-variant: normal;
  line-height: 1;
  text-rendering: auto;
  display: inline-block;
  text-transform: none;
  speak: none;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale; }

.bx-ul {
  margin-left: 2em;
  padding-left: 0;
  list-style: none; }

.bx-ul > li {
  position: relative; }

.bx-ul .bx {
  font-size: inherit;
  line-height: inherit;
  position: absolute;
  left: -2em;
  width: 2em;
  text-align: center; }

@keyframes spin {
  0% {
    transform: rotate(0); }
  100% {
    transform: rotate(359deg); } }

@keyframes burst {
  0% {
    transform: scale(1);
    opacity: 1; }
  90% {
    transform: scale(1.5);
    opacity: 0; } }

@keyframes flashing {
  0% {
    opacity: 1; }
  45% {
    opacity: 0; }
  90% {
    opacity: 1; } }

@keyframes fade-left {
  0% {
    transform: translateX(0);
    opacity: 1; }
  75% {
    transform: translateX(-20px);
    opacity: 0; } }

@keyframes fade-right {
  0% {
    transform: translateX(0);
    opacity: 1; }
  75% {
    transform: translateX(20px);
    opacity: 0; } }

@keyframes fade-up {
  0% {
    transform: translateY(0);
    opacity: 1; }
  75% {
    transform: translateY(-20px);
    opacity: 0; } }

@keyframes fade-down {
  0% {
    transform: translateY(0);
    opacity: 1; }
  75% {
    transform: translateY(20px);
    opacity: 0; } }

@keyframes tada {
  from {
    transform: scale3d(1, 1, 1); }
  10%,
  20% {
    transform: scale3d(0.95, 0.95, 0.95) rotate3d(0, 0, 1, -10deg); }
  30%,
  50%,
  70%,
  90% {
    transform: scale3d(1, 1, 1) rotate3d(0, 0, 1, 10deg); }
  40%,
  60%,
  80% {
    transform: rotate3d(0, 0, 1, -10deg); }
  to {
    transform: scale3d(1, 1, 1); } }

.bx-spin {
  animation: spin 2s linear infinite; }

.bx-spin-hover:hover {
  animation: spin 2s linear infinite; }

.bx-tada {
  animation: tada 1.5s ease infinite; }

.bx-tada-hover:hover {
  animation: tada 1.5s ease infinite; }

.bx-flashing {
  animation: flashing 1.5s infinite linear; }

.bx-flashing-hover:hover {
  animation: flashing 1.5s infinite linear; }

.bx-burst {
  animation: burst 1.5s infinite linear; }

.bx-burst-hover:hover {
  animation: burst 1.5s infinite linear; }

.bx-fade-up {
  animation: fade-up 1.5s infinite linear; }

.bx-fade-up-hover:hover {
  animation: fade-up 1.5s infinite linear; }

.bx-fade-down {
  animation: fade-down 1.5s infinite linear; }

.bx-fade-down-hover:hover {
  animation: fade-down 1.5s infinite linear; }

.bx-fade-left {
  animation: fade-left 1.5s infinite linear; }

.bx-fade-left-hover:hover {
  animation: fade-left 1.5s infinite linear; }

.bx-fade-right {
  animation: fade-right 1.5s infinite linear; }

.bx-fade-right-hover:hover {
  animation: fade-right 1.5s infinite linear; }

.bx-xs {
  font-size: 1rem !important; }

.bx-sm {
  font-size: 1.55rem !important; }

.bx-md {
  font-size: 2.25rem !important; }

.bx-lg {
  font-size: 3rem !important; }

.bx-fw {
  font-size: 1.2857142857em;
  line-height: .8em;
  width: 1.2857142857em;
  height: .8em;
  margin-top: -0.2em !important;
  vertical-align: middle; }

.bx-pull-left {
  float: left;
  margin-right: 0.3em !important; }

.bx-pull-right {
  float: right;
  margin-left: 0.3em !important; }

.bx-rotate-90 {
  transform: rotate(90deg);
  -ms-filter: 'progid:DXImageTransform.Microsoft.BasicImage(rotation=1)'; }

.bx-rotate-180 {
  transform: rotate(180deg);
  -ms-filter: 'progid:DXImageTransform.Microsoft.BasicImage(rotation=2)'; }

.bx-rotate-270 {
  transform: rotate(270deg);
  -ms-filter: 'progid:DXImageTransform.Microsoft.BasicImage(rotation=3)'; }

.bx-flip-horizontal {
  transform: scaleX(-1);
  -ms-filter: 'progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)'; }

.bx-flip-vertical {
  transform: scaleY(-1);
  -ms-filter: 'progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)'; }

.bx-border {
  padding: .25em;
  border: 0.07em solid rgba(0, 0, 0, 0.1);
  border-radius: .25em; }

.bx-border-circle {
  padding: .25em;
  border: 0.07em solid rgba(0, 0, 0, 0.1);
  border-radius: 50%; }

.bxl-meta:before {
  content: "\\ef27"; }

.bx-lemon:before {
  content: "\\ef28"; }

.bxs-lemon:before {
  content: "\\ef29"; }

.bx-cricket-ball:before {
  content: "\\ef0c"; }

.bx-baguette:before {
  content: "\\ef0d"; }

.bx-bowl-hot:before {
  content: "\\ef0e"; }

.bx-bowl-rice:before {
  content: "\\ef0f"; }

.bx-cable-car:before {
  content: "\\ef10"; }

.bx-candles:before {
  content: "\\ef11"; }

.bx-circle-half:before {
  content: "\\ef12"; }

.bx-circle-quarter:before {
  content: "\\ef13"; }

.bx-circle-three-quarter:before {
  content: "\\ef14"; }

.bx-cross:before {
  content: "\\ef15"; }

.bx-fork:before {
  content: "\\ef16"; }

.bx-knife:before {
  content: "\\ef17"; }

.bx-money-withdraw:before {
  content: "\\ef18"; }

.bx-popsicle:before {
  content: "\\ef19"; }

.bx-scatter-chart:before {
  content: "\\ef1a"; }

.bxs-baguette:before {
  content: "\\ef1b"; }

.bxs-bowl-hot:before {
  content: "\\ef1c"; }

.bxs-bowl-rice:before {
  content: "\\ef1d"; }

.bxs-cable-car:before {
  content: "\\ef1e"; }

.bxs-circle-half:before {
  content: "\\ef1f"; }

.bxs-circle-quarter:before {
  content: "\\ef20"; }

.bxs-circle-three-quarter:before {
  content: "\\ef21"; }

.bxs-cricket-ball:before {
  content: "\\ef22"; }

.bxs-invader:before {
  content: "\\ef23"; }

.bx-male-female:before {
  content: "\\ef24"; }

.bxs-popsicle:before {
  content: "\\ef25"; }

.bxs-tree-alt:before {
  content: "\\ef26"; }

.bxl-venmo:before {
  content: "\\e900"; }

.bxl-upwork:before {
  content: "\\e901"; }

.bxl-netlify:before {
  content: "\\e902"; }

.bxl-java:before {
  content: "\\e903"; }

.bxl-heroku:before {
  content: "\\e904"; }

.bxl-go-lang:before {
  content: "\\e905"; }

.bxl-gmail:before {
  content: "\\e906"; }

.bxl-flask:before {
  content: "\\e907"; }

.bxl-99designs:before {
  content: "\\e908"; }

.bxl-500px:before {
  content: "\\e909"; }

.bxl-adobe:before {
  content: "\\e90a"; }

.bxl-airbnb:before {
  content: "\\e90b"; }

.bxl-algolia:before {
  content: "\\e90c"; }

.bxl-amazon:before {
  content: "\\e90d"; }

.bxl-android:before {
  content: "\\e90e"; }

.bxl-angular:before {
  content: "\\e90f"; }

.bxl-apple:before {
  content: "\\e910"; }

.bxl-audible:before {
  content: "\\e911"; }

.bxl-aws:before {
  content: "\\e912"; }

.bxl-baidu:before {
  content: "\\e913"; }

.bxl-behance:before {
  content: "\\e914"; }

.bxl-bing:before {
  content: "\\e915"; }

.bxl-bitcoin:before {
  content: "\\e916"; }

.bxl-blender:before {
  content: "\\e917"; }

.bxl-blogger:before {
  content: "\\e918"; }

.bxl-bootstrap:before {
  content: "\\e919"; }

.bxl-chrome:before {
  content: "\\e91a"; }

.bxl-codepen:before {
  content: "\\e91b"; }

.bxl-c-plus-plus:before {
  content: "\\e91c"; }

.bxl-creative-commons:before {
  content: "\\e91d"; }

.bxl-css3:before {
  content: "\\e91e"; }

.bxl-dailymotion:before {
  content: "\\e91f"; }

.bxl-deviantart:before {
  content: "\\e920"; }

.bxl-dev-to:before {
  content: "\\e921"; }

.bxl-digg:before {
  content: "\\e922"; }

.bxl-digitalocean:before {
  content: "\\e923"; }

.bxl-discord:before {
  content: "\\e924"; }

.bxl-discord-alt:before {
  content: "\\e925"; }

.bxl-discourse:before {
  content: "\\e926"; }

.bxl-django:before {
  content: "\\e927"; }

.bxl-docker:before {
  content: "\\e928"; }

.bxl-dribbble:before {
  content: "\\e929"; }

.bxl-dropbox:before {
  content: "\\e92a"; }

.bxl-drupal:before {
  content: "\\e92b"; }

.bxl-ebay:before {
  content: "\\e92c"; }

.bxl-edge:before {
  content: "\\e92d"; }

.bxl-etsy:before {
  content: "\\e92e"; }

.bxl-facebook:before {
  content: "\\e92f"; }

.bxl-facebook-circle:before {
  content: "\\e930"; }

.bxl-facebook-square:before {
  content: "\\e931"; }

.bxl-figma:before {
  content: "\\e932"; }

.bxl-firebase:before {
  content: "\\e933"; }

.bxl-firefox:before {
  content: "\\e934"; }

.bxl-flickr:before {
  content: "\\e935"; }

.bxl-flickr-square:before {
  content: "\\e936"; }

.bxl-flutter:before {
  content: "\\e937"; }

.bxl-foursquare:before {
  content: "\\e938"; }

.bxl-git:before {
  content: "\\e939"; }

.bxl-github:before {
  content: "\\e93a"; }

.bxl-gitlab:before {
  content: "\\e93b"; }

.bxl-google:before {
  content: "\\e93c"; }

.bxl-google-cloud:before {
  content: "\\e93d"; }

.bxl-google-plus:before {
  content: "\\e93e"; }

.bxl-google-plus-circle:before {
  content: "\\e93f"; }

.bxl-html5:before {
  content: "\\e940"; }

.bxl-imdb:before {
  content: "\\e941"; }

.bxl-instagram:before {
  content: "\\e942"; }

.bxl-instagram-alt:before {
  content: "\\e943"; }

.bxl-internet-explorer:before {
  content: "\\e944"; }

.bxl-invision:before {
  content: "\\e945"; }

.bxl-javascript:before {
  content: "\\e946"; }

.bxl-joomla:before {
  content: "\\e947"; }

.bxl-jquery:before {
  content: "\\e948"; }

.bxl-jsfiddle:before {
  content: "\\e949"; }

.bxl-kickstarter:before {
  content: "\\e94a"; }

.bxl-kubernetes:before {
  content: "\\e94b"; }

.bxl-less:before {
  content: "\\e94c"; }

.bxl-linkedin:before {
  content: "\\e94d"; }

.bxl-linkedin-square:before {
  content: "\\e94e"; }

.bxl-magento:before {
  content: "\\e94f"; }

.bxl-mailchimp:before {
  content: "\\e950"; }

.bxl-markdown:before {
  content: "\\e951"; }

.bxl-mastercard:before {
  content: "\\e952"; }

.bxl-mastodon:before {
  content: "\\e953"; }

.bxl-medium:before {
  content: "\\e954"; }

.bxl-medium-old:before {
  content: "\\e955"; }

.bxl-medium-square:before {
  content: "\\e956"; }

.bxl-messenger:before {
  content: "\\e957"; }

.bxl-microsoft:before {
  content: "\\e958"; }

.bxl-microsoft-teams:before {
  content: "\\e959"; }

.bxl-nodejs:before {
  content: "\\e95a"; }

.bxl-ok-ru:before {
  content: "\\e95b"; }

.bxl-opera:before {
  content: "\\e95c"; }

.bxl-patreon:before {
  content: "\\e95d"; }

.bxl-paypal:before {
  content: "\\e95e"; }

.bxl-periscope:before {
  content: "\\e95f"; }

.bxl-php:before {
  content: "\\e960"; }

.bxl-pinterest:before {
  content: "\\e961"; }

.bxl-pinterest-alt:before {
  content: "\\e962"; }

.bxl-play-store:before {
  content: "\\e963"; }

.bxl-pocket:before {
  content: "\\e964"; }

.bxl-product-hunt:before {
  content: "\\e965"; }

.bxl-python:before {
  content: "\\e966"; }

.bxl-quora:before {
  content: "\\e967"; }

.bxl-react:before {
  content: "\\e968"; }

.bxl-redbubble:before {
  content: "\\e969"; }

.bxl-reddit:before {
  content: "\\e96a"; }

.bxl-redux:before {
  content: "\\e96b"; }

.bxl-sass:before {
  content: "\\e96c"; }

.bxl-shopify:before {
  content: "\\e96d"; }

.bxl-sketch:before {
  content: "\\e96e"; }

.bxl-skype:before {
  content: "\\e96f"; }

.bxl-slack:before {
  content: "\\e970"; }

.bxl-slack-old:before {
  content: "\\e971"; }

.bxl-snapchat:before {
  content: "\\e972"; }

.bxl-soundcloud:before {
  content: "\\e973"; }

.bxl-spotify:before {
  content: "\\e974"; }

.bxl-spring-boot:before {
  content: "\\e975"; }

.bxl-squarespace:before {
  content: "\\e976"; }

.bxl-stack-overflow:before {
  content: "\\e977"; }

.bxl-steam:before {
  content: "\\e978"; }

.bxl-stripe:before {
  content: "\\e979"; }

.bxl-tailwind-css:before {
  content: "\\e97a"; }

.bxl-telegram:before {
  content: "\\e97b"; }

.bxl-tiktok:before {
  content: "\\e97c"; }

.bxl-trello:before {
  content: "\\e97d"; }

.bxl-trip-advisor:before {
  content: "\\e97e"; }

.bxl-tumblr:before {
  content: "\\e97f"; }

.bxl-tux:before {
  content: "\\e980"; }

.bxl-twitch:before {
  content: "\\e981"; }

.bxl-twitter:before {
  content: "\\e982"; }

.bxl-unity:before {
  content: "\\e983"; }

.bxl-unsplash:before {
  content: "\\e984"; }

.bxl-vimeo:before {
  content: "\\e985"; }

.bxl-visa:before {
  content: "\\e986"; }

.bxl-visual-studio:before {
  content: "\\e987"; }

.bxl-vk:before {
  content: "\\e988"; }

.bxl-vuejs:before {
  content: "\\e989"; }

.bxl-whatsapp:before {
  content: "\\e98a"; }

.bxl-whatsapp-square:before {
  content: "\\e98b"; }

.bxl-wikipedia:before {
  content: "\\e98c"; }

.bxl-windows:before {
  content: "\\e98d"; }

.bxl-wix:before {
  content: "\\e98e"; }

.bxl-wordpress:before {
  content: "\\e98f"; }

.bxl-yahoo:before {
  content: "\\e990"; }

.bxl-yelp:before {
  content: "\\e991"; }

.bxl-youtube:before {
  content: "\\e992"; }

.bxl-zoom:before {
  content: "\\e993"; }

.bx-collapse-alt:before {
  content: "\\e994"; }

.bx-collapse-horizontal:before {
  content: "\\e995"; }

.bx-collapse-vertical:before {
  content: "\\e996"; }

.bx-expand-horizontal:before {
  content: "\\e997"; }

.bx-expand-vertical:before {
  content: "\\e998"; }

.bx-injection:before {
  content: "\\e999"; }

.bx-leaf:before {
  content: "\\e99a"; }

.bx-math:before {
  content: "\\e99b"; }

.bx-party:before {
  content: "\\e99c"; }

.bx-abacus:before {
  content: "\\e99d"; }

.bx-accessibility:before {
  content: "\\e99e"; }

.bx-add-to-queue:before {
  content: "\\e99f"; }

.bx-adjust:before {
  content: "\\e9a0"; }

.bx-alarm:before {
  content: "\\e9a1"; }

.bx-alarm-add:before {
  content: "\\e9a2"; }

.bx-alarm-exclamation:before {
  content: "\\e9a3"; }

.bx-alarm-off:before {
  content: "\\e9a4"; }

.bx-alarm-snooze:before {
  content: "\\e9a5"; }

.bx-album:before {
  content: "\\e9a6"; }

.bx-align-justify:before {
  content: "\\e9a7"; }

.bx-align-left:before {
  content: "\\e9a8"; }

.bx-align-middle:before {
  content: "\\e9a9"; }

.bx-align-right:before {
  content: "\\e9aa"; }

.bx-analyse:before {
  content: "\\e9ab"; }

.bx-anchor:before {
  content: "\\e9ac"; }

.bx-angry:before {
  content: "\\e9ad"; }

.bx-aperture:before {
  content: "\\e9ae"; }

.bx-arch:before {
  content: "\\e9af"; }

.bx-archive:before {
  content: "\\e9b0"; }

.bx-archive-in:before {
  content: "\\e9b1"; }

.bx-archive-out:before {
  content: "\\e9b2"; }

.bx-area:before {
  content: "\\e9b3"; }

.bx-arrow-back:before {
  content: "\\e9b4"; }

.bx-arrow-from-bottom:before {
  content: "\\e9b5"; }

.bx-arrow-from-left:before {
  content: "\\e9b6"; }

.bx-arrow-from-right:before {
  content: "\\e9b7"; }

.bx-arrow-from-top:before {
  content: "\\e9b8"; }

.bx-arrow-to-bottom:before {
  content: "\\e9b9"; }

.bx-arrow-to-left:before {
  content: "\\e9ba"; }

.bx-arrow-to-right:before {
  content: "\\e9bb"; }

.bx-arrow-to-top:before {
  content: "\\e9bc"; }

.bx-at:before {
  content: "\\e9bd"; }

.bx-atom:before {
  content: "\\e9be"; }

.bx-award:before {
  content: "\\e9bf"; }

.bx-badge:before {
  content: "\\e9c0"; }

.bx-badge-check:before {
  content: "\\e9c1"; }

.bx-ball:before {
  content: "\\e9c2"; }

.bx-band-aid:before {
  content: "\\e9c3"; }

.bx-bar-chart:before {
  content: "\\e9c4"; }

.bx-bar-chart-alt:before {
  content: "\\e9c5"; }

.bx-bar-chart-alt-2:before {
  content: "\\e9c6"; }

.bx-bar-chart-square:before {
  content: "\\e9c7"; }

.bx-barcode:before {
  content: "\\e9c8"; }

.bx-barcode-reader:before {
  content: "\\e9c9"; }

.bx-baseball:before {
  content: "\\e9ca"; }

.bx-basket:before {
  content: "\\e9cb"; }

.bx-basketball:before {
  content: "\\e9cc"; }

.bx-bath:before {
  content: "\\e9cd"; }

.bx-battery:before {
  content: "\\e9ce"; }

.bx-bed:before {
  content: "\\e9cf"; }

.bx-been-here:before {
  content: "\\e9d0"; }

.bx-beer:before {
  content: "\\e9d1"; }

.bx-bell:before {
  content: "\\e9d2"; }

.bx-bell-minus:before {
  content: "\\e9d3"; }

.bx-bell-off:before {
  content: "\\e9d4"; }

.bx-bell-plus:before {
  content: "\\e9d5"; }

.bx-bible:before {
  content: "\\e9d6"; }

.bx-bitcoin:before {
  content: "\\e9d7"; }

.bx-blanket:before {
  content: "\\e9d8"; }

.bx-block:before {
  content: "\\e9d9"; }

.bx-bluetooth:before {
  content: "\\e9da"; }

.bx-body:before {
  content: "\\e9db"; }

.bx-bold:before {
  content: "\\e9dc"; }

.bx-bolt-circle:before {
  content: "\\e9dd"; }

.bx-bomb:before {
  content: "\\e9de"; }

.bx-bone:before {
  content: "\\e9df"; }

.bx-bong:before {
  content: "\\e9e0"; }

.bx-book:before {
  content: "\\e9e1"; }

.bx-book-add:before {
  content: "\\e9e2"; }

.bx-book-alt:before {
  content: "\\e9e3"; }

.bx-book-bookmark:before {
  content: "\\e9e4"; }

.bx-book-content:before {
  content: "\\e9e5"; }

.bx-book-heart:before {
  content: "\\e9e6"; }

.bx-bookmark:before {
  content: "\\e9e7"; }

.bx-bookmark-alt:before {
  content: "\\e9e8"; }

.bx-bookmark-alt-minus:before {
  content: "\\e9e9"; }

.bx-bookmark-alt-plus:before {
  content: "\\e9ea"; }

.bx-bookmark-heart:before {
  content: "\\e9eb"; }

.bx-bookmark-minus:before {
  content: "\\e9ec"; }

.bx-bookmark-plus:before {
  content: "\\e9ed"; }

.bx-bookmarks:before {
  content: "\\e9ee"; }

.bx-book-open:before {
  content: "\\e9ef"; }

.bx-book-reader:before {
  content: "\\e9f0"; }

.bx-border-all:before {
  content: "\\e9f1"; }

.bx-border-bottom:before {
  content: "\\e9f2"; }

.bx-border-inner:before {
  content: "\\e9f3"; }

.bx-border-left:before {
  content: "\\e9f4"; }

.bx-border-none:before {
  content: "\\e9f5"; }

.bx-border-outer:before {
  content: "\\e9f6"; }

.bx-border-radius:before {
  content: "\\e9f7"; }

.bx-border-right:before {
  content: "\\e9f8"; }

.bx-border-top:before {
  content: "\\e9f9"; }

.bx-bot:before {
  content: "\\e9fa"; }

.bx-bowling-ball:before {
  content: "\\e9fb"; }

.bx-box:before {
  content: "\\e9fc"; }

.bx-bracket:before {
  content: "\\e9fd"; }

.bx-braille:before {
  content: "\\e9fe"; }

.bx-brain:before {
  content: "\\e9ff"; }

.bx-briefcase:before {
  content: "\\ea00"; }

.bx-briefcase-alt:before {
  content: "\\ea01"; }

.bx-briefcase-alt-2:before {
  content: "\\ea02"; }

.bx-brightness:before {
  content: "\\ea03"; }

.bx-brightness-half:before {
  content: "\\ea04"; }

.bx-broadcast:before {
  content: "\\ea05"; }

.bx-brush:before {
  content: "\\ea06"; }

.bx-brush-alt:before {
  content: "\\ea07"; }

.bx-bug:before {
  content: "\\ea08"; }

.bx-bug-alt:before {
  content: "\\ea09"; }

.bx-building:before {
  content: "\\ea0a"; }

.bx-building-house:before {
  content: "\\ea0b"; }

.bx-buildings:before {
  content: "\\ea0c"; }

.bx-bulb:before {
  content: "\\ea0d"; }

.bx-bullseye:before {
  content: "\\ea0e"; }

.bx-buoy:before {
  content: "\\ea0f"; }

.bx-bus:before {
  content: "\\ea10"; }

.bx-bus-school:before {
  content: "\\ea11"; }

.bx-cabinet:before {
  content: "\\ea12"; }

.bx-cake:before {
  content: "\\ea13"; }

.bx-calculator:before {
  content: "\\ea14"; }

.bx-calendar:before {
  content: "\\ea15"; }

.bx-calendar-alt:before {
  content: "\\ea16"; }

.bx-calendar-check:before {
  content: "\\ea17"; }

.bx-calendar-edit:before {
  content: "\\ea18"; }

.bx-calendar-event:before {
  content: "\\ea19"; }

.bx-calendar-exclamation:before {
  content: "\\ea1a"; }

.bx-calendar-heart:before {
  content: "\\ea1b"; }

.bx-calendar-minus:before {
  content: "\\ea1c"; }

.bx-calendar-plus:before {
  content: "\\ea1d"; }

.bx-calendar-star:before {
  content: "\\ea1e"; }

.bx-calendar-week:before {
  content: "\\ea1f"; }

.bx-calendar-x:before {
  content: "\\ea20"; }

.bx-camera:before {
  content: "\\ea21"; }

.bx-camera-home:before {
  content: "\\ea22"; }

.bx-camera-movie:before {
  content: "\\ea23"; }

.bx-camera-off:before {
  content: "\\ea24"; }

.bx-capsule:before {
  content: "\\ea25"; }

.bx-captions:before {
  content: "\\ea26"; }

.bx-car:before {
  content: "\\ea27"; }

.bx-card:before {
  content: "\\ea28"; }

.bx-caret-down:before {
  content: "\\ea29"; }

.bx-caret-down-circle:before {
  content: "\\ea2a"; }

.bx-caret-down-square:before {
  content: "\\ea2b"; }

.bx-caret-left:before {
  content: "\\ea2c"; }

.bx-caret-left-circle:before {
  content: "\\ea2d"; }

.bx-caret-left-square:before {
  content: "\\ea2e"; }

.bx-caret-right:before {
  content: "\\ea2f"; }

.bx-caret-right-circle:before {
  content: "\\ea30"; }

.bx-caret-right-square:before {
  content: "\\ea31"; }

.bx-caret-up:before {
  content: "\\ea32"; }

.bx-caret-up-circle:before {
  content: "\\ea33"; }

.bx-caret-up-square:before {
  content: "\\ea34"; }

.bx-carousel:before {
  content: "\\ea35"; }

.bx-cart:before {
  content: "\\ea36"; }

.bx-cart-alt:before {
  content: "\\ea37"; }

.bx-cast:before {
  content: "\\ea38"; }

.bx-category:before {
  content: "\\ea39"; }

.bx-category-alt:before {
  content: "\\ea3a"; }

.bx-cctv:before {
  content: "\\ea3b"; }

.bx-certification:before {
  content: "\\ea3c"; }

.bx-chair:before {
  content: "\\ea3d"; }

.bx-chalkboard:before {
  content: "\\ea3e"; }

.bx-chart:before {
  content: "\\ea3f"; }

.bx-chat:before {
  content: "\\ea40"; }

.bx-check:before {
  content: "\\ea41"; }

.bx-checkbox:before {
  content: "\\ea42"; }

.bx-checkbox-checked:before {
  content: "\\ea43"; }

.bx-checkbox-minus:before {
  content: "\\ea44"; }

.bx-checkbox-square:before {
  content: "\\ea45"; }

.bx-check-circle:before {
  content: "\\ea46"; }

.bx-check-double:before {
  content: "\\ea47"; }

.bx-check-shield:before {
  content: "\\ea48"; }

.bx-check-square:before {
  content: "\\ea49"; }

.bx-chevron-down:before {
  content: "\\ea4a"; }

.bx-chevron-down-circle:before {
  content: "\\ea4b"; }

.bx-chevron-down-square:before {
  content: "\\ea4c"; }

.bx-chevron-left:before {
  content: "\\ea4d"; }

.bx-chevron-left-circle:before {
  content: "\\ea4e"; }

.bx-chevron-left-square:before {
  content: "\\ea4f"; }

.bx-chevron-right:before {
  content: "\\ea50"; }

.bx-chevron-right-circle:before {
  content: "\\ea51"; }

.bx-chevron-right-square:before {
  content: "\\ea52"; }

.bx-chevrons-down:before {
  content: "\\ea53"; }

.bx-chevrons-left:before {
  content: "\\ea54"; }

.bx-chevrons-right:before {
  content: "\\ea55"; }

.bx-chevrons-up:before {
  content: "\\ea56"; }

.bx-chevron-up:before {
  content: "\\ea57"; }

.bx-chevron-up-circle:before {
  content: "\\ea58"; }

.bx-chevron-up-square:before {
  content: "\\ea59"; }

.bx-chip:before {
  content: "\\ea5a"; }

.bx-church:before {
  content: "\\ea5b"; }

.bx-circle:before {
  content: "\\ea5c"; }

.bx-clinic:before {
  content: "\\ea5d"; }

.bx-clipboard:before {
  content: "\\ea5e"; }

.bx-closet:before {
  content: "\\ea5f"; }

.bx-cloud:before {
  content: "\\ea60"; }

.bx-cloud-download:before {
  content: "\\ea61"; }

.bx-cloud-drizzle:before {
  content: "\\ea62"; }

.bx-cloud-lightning:before {
  content: "\\ea63"; }

.bx-cloud-light-rain:before {
  content: "\\ea64"; }

.bx-cloud-rain:before {
  content: "\\ea65"; }

.bx-cloud-snow:before {
  content: "\\ea66"; }

.bx-cloud-upload:before {
  content: "\\ea67"; }

.bx-code:before {
  content: "\\ea68"; }

.bx-code-alt:before {
  content: "\\ea69"; }

.bx-code-block:before {
  content: "\\ea6a"; }

.bx-code-curly:before {
  content: "\\ea6b"; }

.bx-coffee:before {
  content: "\\ea6c"; }

.bx-coffee-togo:before {
  content: "\\ea6d"; }

.bx-cog:before {
  content: "\\ea6e"; }

.bx-coin:before {
  content: "\\ea6f"; }

.bx-coin-stack:before {
  content: "\\ea70"; }

.bx-collapse:before {
  content: "\\ea71"; }

.bx-collection:before {
  content: "\\ea72"; }

.bx-color-fill:before {
  content: "\\ea73"; }

.bx-columns:before {
  content: "\\ea74"; }

.bx-command:before {
  content: "\\ea75"; }

.bx-comment:before {
  content: "\\ea76"; }

.bx-comment-add:before {
  content: "\\ea77"; }

.bx-comment-check:before {
  content: "\\ea78"; }

.bx-comment-detail:before {
  content: "\\ea79"; }

.bx-comment-dots:before {
  content: "\\ea7a"; }

.bx-comment-edit:before {
  content: "\\ea7b"; }

.bx-comment-error:before {
  content: "\\ea7c"; }

.bx-comment-minus:before {
  content: "\\ea7d"; }

.bx-comment-x:before {
  content: "\\ea7e"; }

.bx-compass:before {
  content: "\\ea7f"; }

.bx-confused:before {
  content: "\\ea80"; }

.bx-conversation:before {
  content: "\\ea81"; }

.bx-cookie:before {
  content: "\\ea82"; }

.bx-cool:before {
  content: "\\ea83"; }

.bx-copy:before {
  content: "\\ea84"; }

.bx-copy-alt:before {
  content: "\\ea85"; }

.bx-copyright:before {
  content: "\\ea86"; }

.bx-credit-card:before {
  content: "\\ea87"; }

.bx-credit-card-alt:before {
  content: "\\ea88"; }

.bx-credit-card-front:before {
  content: "\\ea89"; }

.bx-crop:before {
  content: "\\ea8a"; }

.bx-crosshair:before {
  content: "\\ea8b"; }

.bx-crown:before {
  content: "\\ea8c"; }

.bx-cube:before {
  content: "\\ea8d"; }

.bx-cube-alt:before {
  content: "\\ea8e"; }

.bx-cuboid:before {
  content: "\\ea8f"; }

.bx-current-location:before {
  content: "\\ea90"; }

.bx-customize:before {
  content: "\\ea91"; }

.bx-cut:before {
  content: "\\ea92"; }

.bx-cycling:before {
  content: "\\ea93"; }

.bx-cylinder:before {
  content: "\\ea94"; }

.bx-data:before {
  content: "\\ea95"; }

.bx-desktop:before {
  content: "\\ea96"; }

.bx-detail:before {
  content: "\\ea97"; }

.bx-devices:before {
  content: "\\ea98"; }

.bx-dialpad:before {
  content: "\\ea99"; }

.bx-dialpad-alt:before {
  content: "\\ea9a"; }

.bx-diamond:before {
  content: "\\ea9b"; }

.bx-dice-1:before {
  content: "\\ea9c"; }

.bx-dice-2:before {
  content: "\\ea9d"; }

.bx-dice-3:before {
  content: "\\ea9e"; }

.bx-dice-4:before {
  content: "\\ea9f"; }

.bx-dice-5:before {
  content: "\\eaa0"; }

.bx-dice-6:before {
  content: "\\eaa1"; }

.bx-directions:before {
  content: "\\eaa2"; }

.bx-disc:before {
  content: "\\eaa3"; }

.bx-dish:before {
  content: "\\eaa4"; }

.bx-dislike:before {
  content: "\\eaa5"; }

.bx-dizzy:before {
  content: "\\eaa6"; }

.bx-dna:before {
  content: "\\eaa7"; }

.bx-dock-bottom:before {
  content: "\\eaa8"; }

.bx-dock-left:before {
  content: "\\eaa9"; }

.bx-dock-right:before {
  content: "\\eaaa"; }

.bx-dock-top:before {
  content: "\\eaab"; }

.bx-dollar:before {
  content: "\\eaac"; }

.bx-dollar-circle:before {
  content: "\\eaad"; }

.bx-donate-blood:before {
  content: "\\eaae"; }

.bx-donate-heart:before {
  content: "\\eaaf"; }

.bx-door-open:before {
  content: "\\eab0"; }

.bx-dots-horizontal:before {
  content: "\\eab1"; }

.bx-dots-horizontal-rounded:before {
  content: "\\eab2"; }

.bx-dots-vertical:before {
  content: "\\eab3"; }

.bx-dots-vertical-rounded:before {
  content: "\\eab4"; }

.bx-doughnut-chart:before {
  content: "\\eab5"; }

.bx-down-arrow:before {
  content: "\\eab6"; }

.bx-down-arrow-alt:before {
  content: "\\eab7"; }

.bx-down-arrow-circle:before {
  content: "\\eab8"; }

.bx-download:before {
  content: "\\eab9"; }

.bx-downvote:before {
  content: "\\eaba"; }

.bx-drink:before {
  content: "\\eabb"; }

.bx-droplet:before {
  content: "\\eabc"; }

.bx-dumbbell:before {
  content: "\\eabd"; }

.bx-duplicate:before {
  content: "\\eabe"; }

.bx-edit:before {
  content: "\\eabf"; }

.bx-edit-alt:before {
  content: "\\eac0"; }

.bx-envelope:before {
  content: "\\eac1"; }

.bx-envelope-open:before {
  content: "\\eac2"; }

.bx-equalizer:before {
  content: "\\eac3"; }

.bx-eraser:before {
  content: "\\eac4"; }

.bx-error:before {
  content: "\\eac5"; }

.bx-error-alt:before {
  content: "\\eac6"; }

.bx-error-circle:before {
  content: "\\eac7"; }

.bx-euro:before {
  content: "\\eac8"; }

.bx-exclude:before {
  content: "\\eac9"; }

.bx-exit:before {
  content: "\\eaca"; }

.bx-exit-fullscreen:before {
  content: "\\eacb"; }

.bx-expand:before {
  content: "\\eacc"; }

.bx-expand-alt:before {
  content: "\\eacd"; }

.bx-export:before {
  content: "\\eace"; }

.bx-extension:before {
  content: "\\eacf"; }

.bx-face:before {
  content: "\\ead0"; }

.bx-fast-forward:before {
  content: "\\ead1"; }

.bx-fast-forward-circle:before {
  content: "\\ead2"; }

.bx-female:before {
  content: "\\ead3"; }

.bx-female-sign:before {
  content: "\\ead4"; }

.bx-file:before {
  content: "\\ead5"; }

.bx-file-blank:before {
  content: "\\ead6"; }

.bx-file-find:before {
  content: "\\ead7"; }

.bx-film:before {
  content: "\\ead8"; }

.bx-filter:before {
  content: "\\ead9"; }

.bx-filter-alt:before {
  content: "\\eada"; }

.bx-fingerprint:before {
  content: "\\eadb"; }

.bx-first-aid:before {
  content: "\\eadc"; }

.bx-first-page:before {
  content: "\\eadd"; }

.bx-flag:before {
  content: "\\eade"; }

.bx-folder:before {
  content: "\\eadf"; }

.bx-folder-minus:before {
  content: "\\eae0"; }

.bx-folder-open:before {
  content: "\\eae1"; }

.bx-folder-plus:before {
  content: "\\eae2"; }

.bx-font:before {
  content: "\\eae3"; }

.bx-font-color:before {
  content: "\\eae4"; }

.bx-font-family:before {
  content: "\\eae5"; }

.bx-font-size:before {
  content: "\\eae6"; }

.bx-food-menu:before {
  content: "\\eae7"; }

.bx-food-tag:before {
  content: "\\eae8"; }

.bx-football:before {
  content: "\\eae9"; }

.bx-fridge:before {
  content: "\\eaea"; }

.bx-fullscreen:before {
  content: "\\eaeb"; }

.bx-game:before {
  content: "\\eaec"; }

.bx-gas-pump:before {
  content: "\\eaed"; }

.bx-ghost:before {
  content: "\\eaee"; }

.bx-gift:before {
  content: "\\eaef"; }

.bx-git-branch:before {
  content: "\\eaf0"; }

.bx-git-commit:before {
  content: "\\eaf1"; }

.bx-git-compare:before {
  content: "\\eaf2"; }

.bx-git-merge:before {
  content: "\\eaf3"; }

.bx-git-pull-request:before {
  content: "\\eaf4"; }

.bx-git-repo-forked:before {
  content: "\\eaf5"; }

.bx-glasses:before {
  content: "\\eaf6"; }

.bx-glasses-alt:before {
  content: "\\eaf7"; }

.bx-globe:before {
  content: "\\eaf8"; }

.bx-globe-alt:before {
  content: "\\eaf9"; }

.bx-grid:before {
  content: "\\eafa"; }

.bx-grid-alt:before {
  content: "\\eafb"; }

.bx-grid-horizontal:before {
  content: "\\eafc"; }

.bx-grid-small:before {
  content: "\\eafd"; }

.bx-grid-vertical:before {
  content: "\\eafe"; }

.bx-group:before {
  content: "\\eaff"; }

.bx-handicap:before {
  content: "\\eb00"; }

.bx-happy:before {
  content: "\\eb01"; }

.bx-happy-alt:before {
  content: "\\eb02"; }

.bx-happy-beaming:before {
  content: "\\eb03"; }

.bx-happy-heart-eyes:before {
  content: "\\eb04"; }

.bx-hash:before {
  content: "\\eb05"; }

.bx-hdd:before {
  content: "\\eb06"; }

.bx-heading:before {
  content: "\\eb07"; }

.bx-headphone:before {
  content: "\\eb08"; }

.bx-health:before {
  content: "\\eb09"; }

.bx-heart:before {
  content: "\\eb0a"; }

.bx-heart-circle:before {
  content: "\\eb0b"; }

.bx-heart-square:before {
  content: "\\eb0c"; }

.bx-help-circle:before {
  content: "\\eb0d"; }

.bx-hide:before {
  content: "\\eb0e"; }

.bx-highlight:before {
  content: "\\eb0f"; }

.bx-history:before {
  content: "\\eb10"; }

.bx-hive:before {
  content: "\\eb11"; }

.bx-home:before {
  content: "\\eb12"; }

.bx-home-alt:before {
  content: "\\eb13"; }

.bx-home-circle:before {
  content: "\\eb14"; }

.bx-home-heart:before {
  content: "\\eb15"; }

.bx-home-smile:before {
  content: "\\eb16"; }

.bx-horizontal-center:before {
  content: "\\eb17"; }

.bx-hotel:before {
  content: "\\eb18"; }

.bx-hourglass:before {
  content: "\\eb19"; }

.bx-id-card:before {
  content: "\\eb1a"; }

.bx-image:before {
  content: "\\eb1b"; }

.bx-image-add:before {
  content: "\\eb1c"; }

.bx-image-alt:before {
  content: "\\eb1d"; }

.bx-images:before {
  content: "\\eb1e"; }

.bx-import:before {
  content: "\\eb1f"; }

.bx-infinite:before {
  content: "\\eb20"; }

.bx-info-circle:before {
  content: "\\eb21"; }

.bx-info-square:before {
  content: "\\eb22"; }

.bx-intersect:before {
  content: "\\eb23"; }

.bx-italic:before {
  content: "\\eb24"; }

.bx-joystick:before {
  content: "\\eb25"; }

.bx-joystick-alt:before {
  content: "\\eb26"; }

.bx-joystick-button:before {
  content: "\\eb27"; }

.bx-key:before {
  content: "\\eb28"; }

.bx-label:before {
  content: "\\eb29"; }

.bx-landscape:before {
  content: "\\eb2a"; }

.bx-laptop:before {
  content: "\\eb2b"; }

.bx-last-page:before {
  content: "\\eb2c"; }

.bx-laugh:before {
  content: "\\eb2d"; }

.bx-layer:before {
  content: "\\eb2e"; }

.bx-layer-minus:before {
  content: "\\eb2f"; }

.bx-layer-plus:before {
  content: "\\eb30"; }

.bx-layout:before {
  content: "\\eb31"; }

.bx-left-arrow:before {
  content: "\\eb32"; }

.bx-left-arrow-alt:before {
  content: "\\eb33"; }

.bx-left-arrow-circle:before {
  content: "\\eb34"; }

.bx-left-down-arrow-circle:before {
  content: "\\eb35"; }

.bx-left-indent:before {
  content: "\\eb36"; }

.bx-left-top-arrow-circle:before {
  content: "\\eb37"; }

.bx-library:before {
  content: "\\eb38"; }

.bx-like:before {
  content: "\\eb39"; }

.bx-line-chart:before {
  content: "\\eb3a"; }

.bx-line-chart-down:before {
  content: "\\eb3b"; }

.bx-link:before {
  content: "\\eb3c"; }

.bx-link-alt:before {
  content: "\\eb3d"; }

.bx-link-external:before {
  content: "\\eb3e"; }

.bx-lira:before {
  content: "\\eb3f"; }

.bx-list-check:before {
  content: "\\eb40"; }

.bx-list-minus:before {
  content: "\\eb41"; }

.bx-list-ol:before {
  content: "\\eb42"; }

.bx-list-plus:before {
  content: "\\eb43"; }

.bx-list-ul:before {
  content: "\\eb44"; }

.bx-loader:before {
  content: "\\eb45"; }

.bx-loader-alt:before {
  content: "\\eb46"; }

.bx-loader-circle:before {
  content: "\\eb47"; }

.bx-location-plus:before {
  content: "\\eb48"; }

.bx-lock:before {
  content: "\\eb49"; }

.bx-lock-alt:before {
  content: "\\eb4a"; }

.bx-lock-open:before {
  content: "\\eb4b"; }

.bx-lock-open-alt:before {
  content: "\\eb4c"; }

.bx-log-in:before {
  content: "\\eb4d"; }

.bx-log-in-circle:before {
  content: "\\eb4e"; }

.bx-log-out:before {
  content: "\\eb4f"; }

.bx-log-out-circle:before {
  content: "\\eb50"; }

.bx-low-vision:before {
  content: "\\eb51"; }

.bx-magnet:before {
  content: "\\eb52"; }

.bx-mail-send:before {
  content: "\\eb53"; }

.bx-male:before {
  content: "\\eb54"; }

.bx-male-sign:before {
  content: "\\eb55"; }

.bx-map:before {
  content: "\\eb56"; }

.bx-map-alt:before {
  content: "\\eb57"; }

.bx-map-pin:before {
  content: "\\eb58"; }

.bx-mask:before {
  content: "\\eb59"; }

.bx-medal:before {
  content: "\\eb5a"; }

.bx-meh:before {
  content: "\\eb5b"; }

.bx-meh-alt:before {
  content: "\\eb5c"; }

.bx-meh-blank:before {
  content: "\\eb5d"; }

.bx-memory-card:before {
  content: "\\eb5e"; }

.bx-menu:before {
  content: "\\eb5f"; }

.bx-menu-alt-left:before {
  content: "\\eb60"; }

.bx-menu-alt-right:before {
  content: "\\eb61"; }

.bx-merge:before {
  content: "\\eb62"; }

.bx-message:before {
  content: "\\eb63"; }

.bx-message-add:before {
  content: "\\eb64"; }

.bx-message-alt:before {
  content: "\\eb65"; }

.bx-message-alt-add:before {
  content: "\\eb66"; }

.bx-message-alt-check:before {
  content: "\\eb67"; }

.bx-message-alt-detail:before {
  content: "\\eb68"; }

.bx-message-alt-dots:before {
  content: "\\eb69"; }

.bx-message-alt-edit:before {
  content: "\\eb6a"; }

.bx-message-alt-error:before {
  content: "\\eb6b"; }

.bx-message-alt-minus:before {
  content: "\\eb6c"; }

.bx-message-alt-x:before {
  content: "\\eb6d"; }

.bx-message-check:before {
  content: "\\eb6e"; }

.bx-message-detail:before {
  content: "\\eb6f"; }

.bx-message-dots:before {
  content: "\\eb70"; }

.bx-message-edit:before {
  content: "\\eb71"; }

.bx-message-error:before {
  content: "\\eb72"; }

.bx-message-minus:before {
  content: "\\eb73"; }

.bx-message-rounded:before {
  content: "\\eb74"; }

.bx-message-rounded-add:before {
  content: "\\eb75"; }

.bx-message-rounded-check:before {
  content: "\\eb76"; }

.bx-message-rounded-detail:before {
  content: "\\eb77"; }

.bx-message-rounded-dots:before {
  content: "\\eb78"; }

.bx-message-rounded-edit:before {
  content: "\\eb79"; }

.bx-message-rounded-error:before {
  content: "\\eb7a"; }

.bx-message-rounded-minus:before {
  content: "\\eb7b"; }

.bx-message-rounded-x:before {
  content: "\\eb7c"; }

.bx-message-square:before {
  content: "\\eb7d"; }

.bx-message-square-add:before {
  content: "\\eb7e"; }

.bx-message-square-check:before {
  content: "\\eb7f"; }

.bx-message-square-detail:before {
  content: "\\eb80"; }

.bx-message-square-dots:before {
  content: "\\eb81"; }

.bx-message-square-edit:before {
  content: "\\eb82"; }

.bx-message-square-error:before {
  content: "\\eb83"; }

.bx-message-square-minus:before {
  content: "\\eb84"; }

.bx-message-square-x:before {
  content: "\\eb85"; }

.bx-message-x:before {
  content: "\\eb86"; }

.bx-meteor:before {
  content: "\\eb87"; }

.bx-microchip:before {
  content: "\\eb88"; }

.bx-microphone:before {
  content: "\\eb89"; }

.bx-microphone-off:before {
  content: "\\eb8a"; }

.bx-minus:before {
  content: "\\eb8b"; }

.bx-minus-back:before {
  content: "\\eb8c"; }

.bx-minus-circle:before {
  content: "\\eb8d"; }

.bx-minus-front:before {
  content: "\\eb8e"; }

.bx-mobile:before {
  content: "\\eb8f"; }

.bx-mobile-alt:before {
  content: "\\eb90"; }

.bx-mobile-landscape:before {
  content: "\\eb91"; }

.bx-mobile-vibration:before {
  content: "\\eb92"; }

.bx-money:before {
  content: "\\eb93"; }

.bx-moon:before {
  content: "\\eb94"; }

.bx-mouse:before {
  content: "\\eb95"; }

.bx-mouse-alt:before {
  content: "\\eb96"; }

.bx-move:before {
  content: "\\eb97"; }

.bx-move-horizontal:before {
  content: "\\eb98"; }

.bx-move-vertical:before {
  content: "\\eb99"; }

.bx-movie:before {
  content: "\\eb9a"; }

.bx-movie-play:before {
  content: "\\eb9b"; }

.bx-music:before {
  content: "\\eb9c"; }

.bx-navigation:before {
  content: "\\eb9d"; }

.bx-network-chart:before {
  content: "\\eb9e"; }

.bx-news:before {
  content: "\\eb9f"; }

.bx-no-entry:before {
  content: "\\eba0"; }

.bx-note:before {
  content: "\\eba1"; }

.bx-notepad:before {
  content: "\\eba2"; }

.bx-notification:before {
  content: "\\eba3"; }

.bx-notification-off:before {
  content: "\\eba4"; }

.bx-outline:before {
  content: "\\eba5"; }

.bx-package:before {
  content: "\\eba6"; }

.bx-paint:before {
  content: "\\eba7"; }

.bx-paint-roll:before {
  content: "\\eba8"; }

.bx-palette:before {
  content: "\\eba9"; }

.bx-paperclip:before {
  content: "\\ebaa"; }

.bx-paper-plane:before {
  content: "\\ebab"; }

.bx-paragraph:before {
  content: "\\ebac"; }

.bx-paste:before {
  content: "\\ebad"; }

.bx-pause:before {
  content: "\\ebae"; }

.bx-pause-circle:before {
  content: "\\ebaf"; }

.bx-pen:before {
  content: "\\ebb0"; }

.bx-pencil:before {
  content: "\\ebb1"; }

.bx-phone:before {
  content: "\\ebb2"; }

.bx-phone-call:before {
  content: "\\ebb3"; }

.bx-phone-incoming:before {
  content: "\\ebb4"; }

.bx-phone-off:before {
  content: "\\ebb5"; }

.bx-phone-outgoing:before {
  content: "\\ebb6"; }

.bx-photo-album:before {
  content: "\\ebb7"; }

.bx-pie-chart:before {
  content: "\\ebb8"; }

.bx-pie-chart-alt:before {
  content: "\\ebb9"; }

.bx-pie-chart-alt-2:before {
  content: "\\ebba"; }

.bx-pin:before {
  content: "\\ebbb"; }

.bx-planet:before {
  content: "\\ebbc"; }

.bx-play:before {
  content: "\\ebbd"; }

.bx-play-circle:before {
  content: "\\ebbe"; }

.bx-plug:before {
  content: "\\ebbf"; }

.bx-plus:before {
  content: "\\ebc0"; }

.bx-plus-circle:before {
  content: "\\ebc1"; }

.bx-plus-medical:before {
  content: "\\ebc2"; }

.bx-podcast:before {
  content: "\\ebc3"; }

.bx-pointer:before {
  content: "\\ebc4"; }

.bx-poll:before {
  content: "\\ebc5"; }

.bx-polygon:before {
  content: "\\ebc6"; }

.bx-pound:before {
  content: "\\ebc7"; }

.bx-power-off:before {
  content: "\\ebc8"; }

.bx-printer:before {
  content: "\\ebc9"; }

.bx-pulse:before {
  content: "\\ebca"; }

.bx-purchase-tag:before {
  content: "\\ebcb"; }

.bx-purchase-tag-alt:before {
  content: "\\ebcc"; }

.bx-pyramid:before {
  content: "\\ebcd"; }

.bx-qr:before {
  content: "\\ebce"; }

.bx-qr-scan:before {
  content: "\\ebcf"; }

.bx-question-mark:before {
  content: "\\ebd0"; }

.bx-radar:before {
  content: "\\ebd1"; }

.bx-radio:before {
  content: "\\ebd2"; }

.bx-radio-circle:before {
  content: "\\ebd3"; }

.bx-radio-circle-marked:before {
  content: "\\ebd4"; }

.bx-receipt:before {
  content: "\\ebd5"; }

.bx-rectangle:before {
  content: "\\ebd6"; }

.bx-recycle:before {
  content: "\\ebd7"; }

.bx-redo:before {
  content: "\\ebd8"; }

.bx-refresh:before {
  content: "\\ebd9"; }

.bx-registered:before {
  content: "\\ebda"; }

.bx-rename:before {
  content: "\\ebdb"; }

.bx-repeat:before {
  content: "\\ebdc"; }

.bx-reply:before {
  content: "\\ebdd"; }

.bx-reply-all:before {
  content: "\\ebde"; }

.bx-repost:before {
  content: "\\ebdf"; }

.bx-reset:before {
  content: "\\ebe0"; }

.bx-restaurant:before {
  content: "\\ebe1"; }

.bx-revision:before {
  content: "\\ebe2"; }

.bx-rewind:before {
  content: "\\ebe3"; }

.bx-rewind-circle:before {
  content: "\\ebe4"; }

.bx-right-arrow:before {
  content: "\\ebe5"; }

.bx-right-arrow-alt:before {
  content: "\\ebe6"; }

.bx-right-arrow-circle:before {
  content: "\\ebe7"; }

.bx-right-down-arrow-circle:before {
  content: "\\ebe8"; }

.bx-right-indent:before {
  content: "\\ebe9"; }

.bx-right-top-arrow-circle:before {
  content: "\\ebea"; }

.bx-rocket:before {
  content: "\\ebeb"; }

.bx-rotate-left:before {
  content: "\\ebec"; }

.bx-rotate-right:before {
  content: "\\ebed"; }

.bx-rss:before {
  content: "\\ebee"; }

.bx-ruble:before {
  content: "\\ebef"; }

.bx-ruler:before {
  content: "\\ebf0"; }

.bx-run:before {
  content: "\\ebf1"; }

.bx-rupee:before {
  content: "\\ebf2"; }

.bx-sad:before {
  content: "\\ebf3"; }

.bx-save:before {
  content: "\\ebf4"; }

.bx-scan:before {
  content: "\\ebf5"; }

.bx-screenshot:before {
  content: "\\ebf6"; }

.bx-search:before {
  content: "\\ebf7"; }

.bx-search-alt:before {
  content: "\\ebf8"; }

.bx-search-alt-2:before {
  content: "\\ebf9"; }

.bx-selection:before {
  content: "\\ebfa"; }

.bx-select-multiple:before {
  content: "\\ebfb"; }

.bx-send:before {
  content: "\\ebfc"; }

.bx-server:before {
  content: "\\ebfd"; }

.bx-shape-circle:before {
  content: "\\ebfe"; }

.bx-shape-polygon:before {
  content: "\\ebff"; }

.bx-shape-square:before {
  content: "\\ec00"; }

.bx-shape-triangle:before {
  content: "\\ec01"; }

.bx-share:before {
  content: "\\ec02"; }

.bx-share-alt:before {
  content: "\\ec03"; }

.bx-shekel:before {
  content: "\\ec04"; }

.bx-shield:before {
  content: "\\ec05"; }

.bx-shield-alt:before {
  content: "\\ec06"; }

.bx-shield-alt-2:before {
  content: "\\ec07"; }

.bx-shield-quarter:before {
  content: "\\ec08"; }

.bx-shield-x:before {
  content: "\\ec09"; }

.bx-shocked:before {
  content: "\\ec0a"; }

.bx-shopping-bag:before {
  content: "\\ec0b"; }

.bx-show:before {
  content: "\\ec0c"; }

.bx-show-alt:before {
  content: "\\ec0d"; }

.bx-shuffle:before {
  content: "\\ec0e"; }

.bx-sidebar:before {
  content: "\\ec0f"; }

.bx-sitemap:before {
  content: "\\ec10"; }

.bx-skip-next:before {
  content: "\\ec11"; }

.bx-skip-next-circle:before {
  content: "\\ec12"; }

.bx-skip-previous:before {
  content: "\\ec13"; }

.bx-skip-previous-circle:before {
  content: "\\ec14"; }

.bx-sleepy:before {
  content: "\\ec15"; }

.bx-slider:before {
  content: "\\ec16"; }

.bx-slider-alt:before {
  content: "\\ec17"; }

.bx-slideshow:before {
  content: "\\ec18"; }

.bx-smile:before {
  content: "\\ec19"; }

.bx-sort:before {
  content: "\\ec1a"; }

.bx-sort-alt-2:before {
  content: "\\ec1b"; }

.bx-sort-a-z:before {
  content: "\\ec1c"; }

.bx-sort-down:before {
  content: "\\ec1d"; }

.bx-sort-up:before {
  content: "\\ec1e"; }

.bx-sort-z-a:before {
  content: "\\ec1f"; }

.bx-spa:before {
  content: "\\ec20"; }

.bx-space-bar:before {
  content: "\\ec21"; }

.bx-speaker:before {
  content: "\\ec22"; }

.bx-spray-can:before {
  content: "\\ec23"; }

.bx-spreadsheet:before {
  content: "\\ec24"; }

.bx-square:before {
  content: "\\ec25"; }

.bx-square-rounded:before {
  content: "\\ec26"; }

.bx-star:before {
  content: "\\ec27"; }

.bx-station:before {
  content: "\\ec28"; }

.bx-stats:before {
  content: "\\ec29"; }

.bx-sticker:before {
  content: "\\ec2a"; }

.bx-stop:before {
  content: "\\ec2b"; }

.bx-stop-circle:before {
  content: "\\ec2c"; }

.bx-stopwatch:before {
  content: "\\ec2d"; }

.bx-store:before {
  content: "\\ec2e"; }

.bx-store-alt:before {
  content: "\\ec2f"; }

.bx-street-view:before {
  content: "\\ec30"; }

.bx-strikethrough:before {
  content: "\\ec31"; }

.bx-subdirectory-left:before {
  content: "\\ec32"; }

.bx-subdirectory-right:before {
  content: "\\ec33"; }

.bx-sun:before {
  content: "\\ec34"; }

.bx-support:before {
  content: "\\ec35"; }

.bx-swim:before {
  content: "\\ec36"; }

.bx-sync:before {
  content: "\\ec37"; }

.bx-tab:before {
  content: "\\ec38"; }

.bx-table:before {
  content: "\\ec39"; }

.bx-tachometer:before {
  content: "\\ec3a"; }

.bx-tag:before {
  content: "\\ec3b"; }

.bx-tag-alt:before {
  content: "\\ec3c"; }

.bx-target-lock:before {
  content: "\\ec3d"; }

.bx-task:before {
  content: "\\ec3e"; }

.bx-task-x:before {
  content: "\\ec3f"; }

.bx-taxi:before {
  content: "\\ec40"; }

.bx-tennis-ball:before {
  content: "\\ec41"; }

.bx-terminal:before {
  content: "\\ec42"; }

.bx-test-tube:before {
  content: "\\ec43"; }

.bx-text:before {
  content: "\\ec44"; }

.bx-time:before {
  content: "\\ec45"; }

.bx-time-five:before {
  content: "\\ec46"; }

.bx-timer:before {
  content: "\\ec47"; }

.bx-tired:before {
  content: "\\ec48"; }

.bx-toggle-left:before {
  content: "\\ec49"; }

.bx-toggle-right:before {
  content: "\\ec4a"; }

.bx-tone:before {
  content: "\\ec4b"; }

.bx-traffic-cone:before {
  content: "\\ec4c"; }

.bx-train:before {
  content: "\\ec4d"; }

.bx-transfer:before {
  content: "\\ec4e"; }

.bx-transfer-alt:before {
  content: "\\ec4f"; }

.bx-trash:before {
  content: "\\ec50"; }

.bx-trash-alt:before {
  content: "\\ec51"; }

.bx-trending-down:before {
  content: "\\ec52"; }

.bx-trending-up:before {
  content: "\\ec53"; }

.bx-trim:before {
  content: "\\ec54"; }

.bx-trip:before {
  content: "\\ec55"; }

.bx-trophy:before {
  content: "\\ec56"; }

.bx-tv:before {
  content: "\\ec57"; }

.bx-underline:before {
  content: "\\ec58"; }

.bx-undo:before {
  content: "\\ec59"; }

.bx-unite:before {
  content: "\\ec5a"; }

.bx-unlink:before {
  content: "\\ec5b"; }

.bx-up-arrow:before {
  content: "\\ec5c"; }

.bx-up-arrow-alt:before {
  content: "\\ec5d"; }

.bx-up-arrow-circle:before {
  content: "\\ec5e"; }

.bx-upload:before {
  content: "\\ec5f"; }

.bx-upside-down:before {
  content: "\\ec60"; }

.bx-upvote:before {
  content: "\\ec61"; }

.bx-usb:before {
  content: "\\ec62"; }

.bx-user:before {
  content: "\\ec63"; }

.bx-user-check:before {
  content: "\\ec64"; }

.bx-user-circle:before {
  content: "\\ec65"; }

.bx-user-minus:before {
  content: "\\ec66"; }

.bx-user-pin:before {
  content: "\\ec67"; }

.bx-user-plus:before {
  content: "\\ec68"; }

.bx-user-voice:before {
  content: "\\ec69"; }

.bx-user-x:before {
  content: "\\ec6a"; }

.bx-vector:before {
  content: "\\ec6b"; }

.bx-vertical-center:before {
  content: "\\ec6c"; }

.bx-vial:before {
  content: "\\ec6d"; }

.bx-video:before {
  content: "\\ec6e"; }

.bx-video-off:before {
  content: "\\ec6f"; }

.bx-video-plus:before {
  content: "\\ec70"; }

.bx-video-recording:before {
  content: "\\ec71"; }

.bx-voicemail:before {
  content: "\\ec72"; }

.bx-volume:before {
  content: "\\ec73"; }

.bx-volume-full:before {
  content: "\\ec74"; }

.bx-volume-low:before {
  content: "\\ec75"; }

.bx-volume-mute:before {
  content: "\\ec76"; }

.bx-walk:before {
  content: "\\ec77"; }

.bx-wallet:before {
  content: "\\ec78"; }

.bx-wallet-alt:before {
  content: "\\ec79"; }

.bx-water:before {
  content: "\\ec7a"; }

.bx-webcam:before {
  content: "\\ec7b"; }

.bx-wifi:before {
  content: "\\ec7c"; }

.bx-wifi-0:before {
  content: "\\ec7d"; }

.bx-wifi-1:before {
  content: "\\ec7e"; }

.bx-wifi-2:before {
  content: "\\ec7f"; }

.bx-wifi-off:before {
  content: "\\ec80"; }

.bx-wind:before {
  content: "\\ec81"; }

.bx-window:before {
  content: "\\ec82"; }

.bx-window-alt:before {
  content: "\\ec83"; }

.bx-window-close:before {
  content: "\\ec84"; }

.bx-window-open:before {
  content: "\\ec85"; }

.bx-windows:before {
  content: "\\ec86"; }

.bx-wine:before {
  content: "\\ec87"; }

.bx-wink-smile:before {
  content: "\\ec88"; }

.bx-wink-tongue:before {
  content: "\\ec89"; }

.bx-won:before {
  content: "\\ec8a"; }

.bx-world:before {
  content: "\\ec8b"; }

.bx-wrench:before {
  content: "\\ec8c"; }

.bx-x:before {
  content: "\\ec8d"; }

.bx-x-circle:before {
  content: "\\ec8e"; }

.bx-yen:before {
  content: "\\ec8f"; }

.bx-zoom-in:before {
  content: "\\ec90"; }

.bx-zoom-out:before {
  content: "\\ec91"; }

.bxs-party:before {
  content: "\\ec92"; }

.bxs-hot:before {
  content: "\\ec93"; }

.bxs-droplet:before {
  content: "\\ec94"; }

.bxs-cat:before {
  content: "\\ec95"; }

.bxs-dog:before {
  content: "\\ec96"; }

.bxs-injection:before {
  content: "\\ec97"; }

.bxs-leaf:before {
  content: "\\ec98"; }

.bxs-add-to-queue:before {
  content: "\\ec99"; }

.bxs-adjust:before {
  content: "\\ec9a"; }

.bxs-adjust-alt:before {
  content: "\\ec9b"; }

.bxs-alarm:before {
  content: "\\ec9c"; }

.bxs-alarm-add:before {
  content: "\\ec9d"; }

.bxs-alarm-exclamation:before {
  content: "\\ec9e"; }

.bxs-alarm-off:before {
  content: "\\ec9f"; }

.bxs-alarm-snooze:before {
  content: "\\eca0"; }

.bxs-album:before {
  content: "\\eca1"; }

.bxs-ambulance:before {
  content: "\\eca2"; }

.bxs-analyse:before {
  content: "\\eca3"; }

.bxs-angry:before {
  content: "\\eca4"; }

.bxs-arch:before {
  content: "\\eca5"; }

.bxs-archive:before {
  content: "\\eca6"; }

.bxs-archive-in:before {
  content: "\\eca7"; }

.bxs-archive-out:before {
  content: "\\eca8"; }

.bxs-area:before {
  content: "\\eca9"; }

.bxs-arrow-from-bottom:before {
  content: "\\ecaa"; }

.bxs-arrow-from-left:before {
  content: "\\ecab"; }

.bxs-arrow-from-right:before {
  content: "\\ecac"; }

.bxs-arrow-from-top:before {
  content: "\\ecad"; }

.bxs-arrow-to-bottom:before {
  content: "\\ecae"; }

.bxs-arrow-to-left:before {
  content: "\\ecaf"; }

.bxs-arrow-to-right:before {
  content: "\\ecb0"; }

.bxs-arrow-to-top:before {
  content: "\\ecb1"; }

.bxs-award:before {
  content: "\\ecb2"; }

.bxs-baby-carriage:before {
  content: "\\ecb3"; }

.bxs-backpack:before {
  content: "\\ecb4"; }

.bxs-badge:before {
  content: "\\ecb5"; }

.bxs-badge-check:before {
  content: "\\ecb6"; }

.bxs-badge-dollar:before {
  content: "\\ecb7"; }

.bxs-ball:before {
  content: "\\ecb8"; }

.bxs-band-aid:before {
  content: "\\ecb9"; }

.bxs-bank:before {
  content: "\\ecba"; }

.bxs-bar-chart-alt-2:before {
  content: "\\ecbb"; }

.bxs-bar-chart-square:before {
  content: "\\ecbc"; }

.bxs-barcode:before {
  content: "\\ecbd"; }

.bxs-baseball:before {
  content: "\\ecbe"; }

.bxs-basket:before {
  content: "\\ecbf"; }

.bxs-basketball:before {
  content: "\\ecc0"; }

.bxs-bath:before {
  content: "\\ecc1"; }

.bxs-battery:before {
  content: "\\ecc2"; }

.bxs-battery-charging:before {
  content: "\\ecc3"; }

.bxs-battery-full:before {
  content: "\\ecc4"; }

.bxs-battery-low:before {
  content: "\\ecc5"; }

.bxs-bed:before {
  content: "\\ecc6"; }

.bxs-been-here:before {
  content: "\\ecc7"; }

.bxs-beer:before {
  content: "\\ecc8"; }

.bxs-bell:before {
  content: "\\ecc9"; }

.bxs-bell-minus:before {
  content: "\\ecca"; }

.bxs-bell-off:before {
  content: "\\eccb"; }

.bxs-bell-plus:before {
  content: "\\eccc"; }

.bxs-bell-ring:before {
  content: "\\eccd"; }

.bxs-bible:before {
  content: "\\ecce"; }

.bxs-binoculars:before {
  content: "\\eccf"; }

.bxs-blanket:before {
  content: "\\ecd0"; }

.bxs-bolt:before {
  content: "\\ecd1"; }

.bxs-bolt-circle:before {
  content: "\\ecd2"; }

.bxs-bomb:before {
  content: "\\ecd3"; }

.bxs-bone:before {
  content: "\\ecd4"; }

.bxs-bong:before {
  content: "\\ecd5"; }

.bxs-book:before {
  content: "\\ecd6"; }

.bxs-book-add:before {
  content: "\\ecd7"; }

.bxs-book-alt:before {
  content: "\\ecd8"; }

.bxs-book-bookmark:before {
  content: "\\ecd9"; }

.bxs-book-content:before {
  content: "\\ecda"; }

.bxs-book-heart:before {
  content: "\\ecdb"; }

.bxs-bookmark:before {
  content: "\\ecdc"; }

.bxs-bookmark-alt:before {
  content: "\\ecdd"; }

.bxs-bookmark-alt-minus:before {
  content: "\\ecde"; }

.bxs-bookmark-alt-plus:before {
  content: "\\ecdf"; }

.bxs-bookmark-heart:before {
  content: "\\ece0"; }

.bxs-bookmark-minus:before {
  content: "\\ece1"; }

.bxs-bookmark-plus:before {
  content: "\\ece2"; }

.bxs-bookmarks:before {
  content: "\\ece3"; }

.bxs-bookmark-star:before {
  content: "\\ece4"; }

.bxs-book-open:before {
  content: "\\ece5"; }

.bxs-book-reader:before {
  content: "\\ece6"; }

.bxs-bot:before {
  content: "\\ece7"; }

.bxs-bowling-ball:before {
  content: "\\ece8"; }

.bxs-box:before {
  content: "\\ece9"; }

.bxs-brain:before {
  content: "\\ecea"; }

.bxs-briefcase:before {
  content: "\\eceb"; }

.bxs-briefcase-alt:before {
  content: "\\ecec"; }

.bxs-briefcase-alt-2:before {
  content: "\\eced"; }

.bxs-brightness:before {
  content: "\\ecee"; }

.bxs-brightness-half:before {
  content: "\\ecef"; }

.bxs-brush:before {
  content: "\\ecf0"; }

.bxs-brush-alt:before {
  content: "\\ecf1"; }

.bxs-bug:before {
  content: "\\ecf2"; }

.bxs-bug-alt:before {
  content: "\\ecf3"; }

.bxs-building:before {
  content: "\\ecf4"; }

.bxs-building-house:before {
  content: "\\ecf5"; }

.bxs-buildings:before {
  content: "\\ecf6"; }

.bxs-bulb:before {
  content: "\\ecf7"; }

.bxs-bullseye:before {
  content: "\\ecf8"; }

.bxs-buoy:before {
  content: "\\ecf9"; }

.bxs-bus:before {
  content: "\\ecfa"; }

.bxs-business:before {
  content: "\\ecfb"; }

.bxs-bus-school:before {
  content: "\\ecfc"; }

.bxs-cabinet:before {
  content: "\\ecfd"; }

.bxs-cake:before {
  content: "\\ecfe"; }

.bxs-calculator:before {
  content: "\\ecff"; }

.bxs-calendar:before {
  content: "\\ed00"; }

.bxs-calendar-alt:before {
  content: "\\ed01"; }

.bxs-calendar-check:before {
  content: "\\ed02"; }

.bxs-calendar-edit:before {
  content: "\\ed03"; }

.bxs-calendar-event:before {
  content: "\\ed04"; }

.bxs-calendar-exclamation:before {
  content: "\\ed05"; }

.bxs-calendar-heart:before {
  content: "\\ed06"; }

.bxs-calendar-minus:before {
  content: "\\ed07"; }

.bxs-calendar-plus:before {
  content: "\\ed08"; }

.bxs-calendar-star:before {
  content: "\\ed09"; }

.bxs-calendar-week:before {
  content: "\\ed0a"; }

.bxs-calendar-x:before {
  content: "\\ed0b"; }

.bxs-camera:before {
  content: "\\ed0c"; }

.bxs-camera-home:before {
  content: "\\ed0d"; }

.bxs-camera-movie:before {
  content: "\\ed0e"; }

.bxs-camera-off:before {
  content: "\\ed0f"; }

.bxs-camera-plus:before {
  content: "\\ed10"; }

.bxs-capsule:before {
  content: "\\ed11"; }

.bxs-captions:before {
  content: "\\ed12"; }

.bxs-car:before {
  content: "\\ed13"; }

.bxs-car-battery:before {
  content: "\\ed14"; }

.bxs-car-crash:before {
  content: "\\ed15"; }

.bxs-card:before {
  content: "\\ed16"; }

.bxs-caret-down-circle:before {
  content: "\\ed17"; }

.bxs-caret-down-square:before {
  content: "\\ed18"; }

.bxs-caret-left-circle:before {
  content: "\\ed19"; }

.bxs-caret-left-square:before {
  content: "\\ed1a"; }

.bxs-caret-right-circle:before {
  content: "\\ed1b"; }

.bxs-caret-right-square:before {
  content: "\\ed1c"; }

.bxs-caret-up-circle:before {
  content: "\\ed1d"; }

.bxs-caret-up-square:before {
  content: "\\ed1e"; }

.bxs-car-garage:before {
  content: "\\ed1f"; }

.bxs-car-mechanic:before {
  content: "\\ed20"; }

.bxs-carousel:before {
  content: "\\ed21"; }

.bxs-cart:before {
  content: "\\ed22"; }

.bxs-cart-add:before {
  content: "\\ed23"; }

.bxs-cart-alt:before {
  content: "\\ed24"; }

.bxs-cart-download:before {
  content: "\\ed25"; }

.bxs-car-wash:before {
  content: "\\ed26"; }

.bxs-category:before {
  content: "\\ed27"; }

.bxs-category-alt:before {
  content: "\\ed28"; }

.bxs-cctv:before {
  content: "\\ed29"; }

.bxs-certification:before {
  content: "\\ed2a"; }

.bxs-chalkboard:before {
  content: "\\ed2b"; }

.bxs-chart:before {
  content: "\\ed2c"; }

.bxs-chat:before {
  content: "\\ed2d"; }

.bxs-checkbox:before {
  content: "\\ed2e"; }

.bxs-checkbox-checked:before {
  content: "\\ed2f"; }

.bxs-checkbox-minus:before {
  content: "\\ed30"; }

.bxs-check-circle:before {
  content: "\\ed31"; }

.bxs-check-shield:before {
  content: "\\ed32"; }

.bxs-check-square:before {
  content: "\\ed33"; }

.bxs-chess:before {
  content: "\\ed34"; }

.bxs-chevron-down:before {
  content: "\\ed35"; }

.bxs-chevron-down-circle:before {
  content: "\\ed36"; }

.bxs-chevron-down-square:before {
  content: "\\ed37"; }

.bxs-chevron-left:before {
  content: "\\ed38"; }

.bxs-chevron-left-circle:before {
  content: "\\ed39"; }

.bxs-chevron-left-square:before {
  content: "\\ed3a"; }

.bxs-chevron-right:before {
  content: "\\ed3b"; }

.bxs-chevron-right-circle:before {
  content: "\\ed3c"; }

.bxs-chevron-right-square:before {
  content: "\\ed3d"; }

.bxs-chevrons-down:before {
  content: "\\ed3e"; }

.bxs-chevrons-left:before {
  content: "\\ed3f"; }

.bxs-chevrons-right:before {
  content: "\\ed40"; }

.bxs-chevrons-up:before {
  content: "\\ed41"; }

.bxs-chevron-up:before {
  content: "\\ed42"; }

.bxs-chevron-up-circle:before {
  content: "\\ed43"; }

.bxs-chevron-up-square:before {
  content: "\\ed44"; }

.bxs-chip:before {
  content: "\\ed45"; }

.bxs-church:before {
  content: "\\ed46"; }

.bxs-circle:before {
  content: "\\ed47"; }

.bxs-city:before {
  content: "\\ed48"; }

.bxs-clinic:before {
  content: "\\ed49"; }

.bxs-cloud:before {
  content: "\\ed4a"; }

.bxs-cloud-download:before {
  content: "\\ed4b"; }

.bxs-cloud-lightning:before {
  content: "\\ed4c"; }

.bxs-cloud-rain:before {
  content: "\\ed4d"; }

.bxs-cloud-upload:before {
  content: "\\ed4e"; }

.bxs-coffee:before {
  content: "\\ed4f"; }

.bxs-coffee-alt:before {
  content: "\\ed50"; }

.bxs-coffee-togo:before {
  content: "\\ed51"; }

.bxs-cog:before {
  content: "\\ed52"; }

.bxs-coin:before {
  content: "\\ed53"; }

.bxs-coin-stack:before {
  content: "\\ed54"; }

.bxs-collection:before {
  content: "\\ed55"; }

.bxs-color-fill:before {
  content: "\\ed56"; }

.bxs-comment:before {
  content: "\\ed57"; }

.bxs-comment-add:before {
  content: "\\ed58"; }

.bxs-comment-check:before {
  content: "\\ed59"; }

.bxs-comment-detail:before {
  content: "\\ed5a"; }

.bxs-comment-dots:before {
  content: "\\ed5b"; }

.bxs-comment-edit:before {
  content: "\\ed5c"; }

.bxs-comment-error:before {
  content: "\\ed5d"; }

.bxs-comment-minus:before {
  content: "\\ed5e"; }

.bxs-comment-x:before {
  content: "\\ed5f"; }

.bxs-compass:before {
  content: "\\ed60"; }

.bxs-component:before {
  content: "\\ed61"; }

.bxs-confused:before {
  content: "\\ed62"; }

.bxs-contact:before {
  content: "\\ed63"; }

.bxs-conversation:before {
  content: "\\ed64"; }

.bxs-cookie:before {
  content: "\\ed65"; }

.bxs-cool:before {
  content: "\\ed66"; }

.bxs-copy:before {
  content: "\\ed67"; }

.bxs-copy-alt:before {
  content: "\\ed68"; }

.bxs-copyright:before {
  content: "\\ed69"; }

.bxs-coupon:before {
  content: "\\ed6a"; }

.bxs-credit-card:before {
  content: "\\ed6b"; }

.bxs-credit-card-alt:before {
  content: "\\ed6c"; }

.bxs-credit-card-front:before {
  content: "\\ed6d"; }

.bxs-crop:before {
  content: "\\ed6e"; }

.bxs-crown:before {
  content: "\\ed6f"; }

.bxs-cube:before {
  content: "\\ed70"; }

.bxs-cube-alt:before {
  content: "\\ed71"; }

.bxs-cuboid:before {
  content: "\\ed72"; }

.bxs-customize:before {
  content: "\\ed73"; }

.bxs-cylinder:before {
  content: "\\ed74"; }

.bxs-dashboard:before {
  content: "\\ed75"; }

.bxs-data:before {
  content: "\\ed76"; }

.bxs-detail:before {
  content: "\\ed77"; }

.bxs-devices:before {
  content: "\\ed78"; }

.bxs-diamond:before {
  content: "\\ed79"; }

.bxs-dice-1:before {
  content: "\\ed7a"; }

.bxs-dice-2:before {
  content: "\\ed7b"; }

.bxs-dice-3:before {
  content: "\\ed7c"; }

.bxs-dice-4:before {
  content: "\\ed7d"; }

.bxs-dice-5:before {
  content: "\\ed7e"; }

.bxs-dice-6:before {
  content: "\\ed7f"; }

.bxs-direction-left:before {
  content: "\\ed80"; }

.bxs-direction-right:before {
  content: "\\ed81"; }

.bxs-directions:before {
  content: "\\ed82"; }

.bxs-disc:before {
  content: "\\ed83"; }

.bxs-discount:before {
  content: "\\ed84"; }

.bxs-dish:before {
  content: "\\ed85"; }

.bxs-dislike:before {
  content: "\\ed86"; }

.bxs-dizzy:before {
  content: "\\ed87"; }

.bxs-dock-bottom:before {
  content: "\\ed88"; }

.bxs-dock-left:before {
  content: "\\ed89"; }

.bxs-dock-right:before {
  content: "\\ed8a"; }

.bxs-dock-top:before {
  content: "\\ed8b"; }

.bxs-dollar-circle:before {
  content: "\\ed8c"; }

.bxs-donate-blood:before {
  content: "\\ed8d"; }

.bxs-donate-heart:before {
  content: "\\ed8e"; }

.bxs-door-open:before {
  content: "\\ed8f"; }

.bxs-doughnut-chart:before {
  content: "\\ed90"; }

.bxs-down-arrow:before {
  content: "\\ed91"; }

.bxs-down-arrow-alt:before {
  content: "\\ed92"; }

.bxs-down-arrow-circle:before {
  content: "\\ed93"; }

.bxs-down-arrow-square:before {
  content: "\\ed94"; }

.bxs-download:before {
  content: "\\ed95"; }

.bxs-downvote:before {
  content: "\\ed96"; }

.bxs-drink:before {
  content: "\\ed97"; }

.bxs-droplet-half:before {
  content: "\\ed98"; }

.bxs-dryer:before {
  content: "\\ed99"; }

.bxs-duplicate:before {
  content: "\\ed9a"; }

.bxs-edit:before {
  content: "\\ed9b"; }

.bxs-edit-alt:before {
  content: "\\ed9c"; }

.bxs-edit-location:before {
  content: "\\ed9d"; }

.bxs-eject:before {
  content: "\\ed9e"; }

.bxs-envelope:before {
  content: "\\ed9f"; }

.bxs-envelope-open:before {
  content: "\\eda0"; }

.bxs-eraser:before {
  content: "\\eda1"; }

.bxs-error:before {
  content: "\\eda2"; }

.bxs-error-alt:before {
  content: "\\eda3"; }

.bxs-error-circle:before {
  content: "\\eda4"; }

.bxs-ev-station:before {
  content: "\\eda5"; }

.bxs-exit:before {
  content: "\\eda6"; }

.bxs-extension:before {
  content: "\\eda7"; }

.bxs-eyedropper:before {
  content: "\\eda8"; }

.bxs-face:before {
  content: "\\eda9"; }

.bxs-face-mask:before {
  content: "\\edaa"; }

.bxs-factory:before {
  content: "\\edab"; }

.bxs-fast-forward-circle:before {
  content: "\\edac"; }

.bxs-file:before {
  content: "\\edad"; }

.bxs-file-archive:before {
  content: "\\edae"; }

.bxs-file-blank:before {
  content: "\\edaf"; }

.bxs-file-css:before {
  content: "\\edb0"; }

.bxs-file-doc:before {
  content: "\\edb1"; }

.bxs-file-export:before {
  content: "\\edb2"; }

.bxs-file-find:before {
  content: "\\edb3"; }

.bxs-file-gif:before {
  content: "\\edb4"; }

.bxs-file-html:before {
  content: "\\edb5"; }

.bxs-file-image:before {
  content: "\\edb6"; }

.bxs-file-import:before {
  content: "\\edb7"; }

.bxs-file-jpg:before {
  content: "\\edb8"; }

.bxs-file-js:before {
  content: "\\edb9"; }

.bxs-file-json:before {
  content: "\\edba"; }

.bxs-file-md:before {
  content: "\\edbb"; }

.bxs-file-pdf:before {
  content: "\\edbc"; }

.bxs-file-plus:before {
  content: "\\edbd"; }

.bxs-file-png:before {
  content: "\\edbe"; }

.bxs-file-txt:before {
  content: "\\edbf"; }

.bxs-film:before {
  content: "\\edc0"; }

.bxs-filter-alt:before {
  content: "\\edc1"; }

.bxs-first-aid:before {
  content: "\\edc2"; }

.bxs-flag:before {
  content: "\\edc3"; }

.bxs-flag-alt:before {
  content: "\\edc4"; }

.bxs-flag-checkered:before {
  content: "\\edc5"; }

.bxs-flame:before {
  content: "\\edc6"; }

.bxs-flask:before {
  content: "\\edc7"; }

.bxs-florist:before {
  content: "\\edc8"; }

.bxs-folder:before {
  content: "\\edc9"; }

.bxs-folder-minus:before {
  content: "\\edca"; }

.bxs-folder-open:before {
  content: "\\edcb"; }

.bxs-folder-plus:before {
  content: "\\edcc"; }

.bxs-food-menu:before {
  content: "\\edcd"; }

.bxs-fridge:before {
  content: "\\edce"; }

.bxs-game:before {
  content: "\\edcf"; }

.bxs-gas-pump:before {
  content: "\\edd0"; }

.bxs-ghost:before {
  content: "\\edd1"; }

.bxs-gift:before {
  content: "\\edd2"; }

.bxs-graduation:before {
  content: "\\edd3"; }

.bxs-grid:before {
  content: "\\edd4"; }

.bxs-grid-alt:before {
  content: "\\edd5"; }

.bxs-group:before {
  content: "\\edd6"; }

.bxs-guitar-amp:before {
  content: "\\edd7"; }

.bxs-hand:before {
  content: "\\edd8"; }

.bxs-hand-down:before {
  content: "\\edd9"; }

.bxs-hand-left:before {
  content: "\\edda"; }

.bxs-hand-right:before {
  content: "\\eddb"; }

.bxs-hand-up:before {
  content: "\\eddc"; }

.bxs-happy:before {
  content: "\\eddd"; }

.bxs-happy-alt:before {
  content: "\\edde"; }

.bxs-happy-beaming:before {
  content: "\\eddf"; }

.bxs-happy-heart-eyes:before {
  content: "\\ede0"; }

.bxs-hdd:before {
  content: "\\ede1"; }

.bxs-heart:before {
  content: "\\ede2"; }

.bxs-heart-circle:before {
  content: "\\ede3"; }

.bxs-heart-square:before {
  content: "\\ede4"; }

.bxs-help-circle:before {
  content: "\\ede5"; }

.bxs-hide:before {
  content: "\\ede6"; }

.bxs-home:before {
  content: "\\ede7"; }

.bxs-home-circle:before {
  content: "\\ede8"; }

.bxs-home-heart:before {
  content: "\\ede9"; }

.bxs-home-smile:before {
  content: "\\edea"; }

.bxs-hotel:before {
  content: "\\edeb"; }

.bxs-hourglass:before {
  content: "\\edec"; }

.bxs-hourglass-bottom:before {
  content: "\\eded"; }

.bxs-hourglass-top:before {
  content: "\\edee"; }

.bxs-id-card:before {
  content: "\\edef"; }

.bxs-image:before {
  content: "\\edf0"; }

.bxs-image-add:before {
  content: "\\edf1"; }

.bxs-image-alt:before {
  content: "\\edf2"; }

.bxs-inbox:before {
  content: "\\edf3"; }

.bxs-info-circle:before {
  content: "\\edf4"; }

.bxs-info-square:before {
  content: "\\edf5"; }

.bxs-institution:before {
  content: "\\edf6"; }

.bxs-joystick:before {
  content: "\\edf7"; }

.bxs-joystick-alt:before {
  content: "\\edf8"; }

.bxs-joystick-button:before {
  content: "\\edf9"; }

.bxs-key:before {
  content: "\\edfa"; }

.bxs-keyboard:before {
  content: "\\edfb"; }

.bxs-label:before {
  content: "\\edfc"; }

.bxs-landmark:before {
  content: "\\edfd"; }

.bxs-landscape:before {
  content: "\\edfe"; }

.bxs-laugh:before {
  content: "\\edff"; }

.bxs-layer:before {
  content: "\\ee00"; }

.bxs-layer-minus:before {
  content: "\\ee01"; }

.bxs-layer-plus:before {
  content: "\\ee02"; }

.bxs-layout:before {
  content: "\\ee03"; }

.bxs-left-arrow:before {
  content: "\\ee04"; }

.bxs-left-arrow-alt:before {
  content: "\\ee05"; }

.bxs-left-arrow-circle:before {
  content: "\\ee06"; }

.bxs-left-arrow-square:before {
  content: "\\ee07"; }

.bxs-left-down-arrow-circle:before {
  content: "\\ee08"; }

.bxs-left-top-arrow-circle:before {
  content: "\\ee09"; }

.bxs-like:before {
  content: "\\ee0a"; }

.bxs-location-plus:before {
  content: "\\ee0b"; }

.bxs-lock:before {
  content: "\\ee0c"; }

.bxs-lock-alt:before {
  content: "\\ee0d"; }

.bxs-lock-open:before {
  content: "\\ee0e"; }

.bxs-lock-open-alt:before {
  content: "\\ee0f"; }

.bxs-log-in:before {
  content: "\\ee10"; }

.bxs-log-in-circle:before {
  content: "\\ee11"; }

.bxs-log-out:before {
  content: "\\ee12"; }

.bxs-log-out-circle:before {
  content: "\\ee13"; }

.bxs-low-vision:before {
  content: "\\ee14"; }

.bxs-magic-wand:before {
  content: "\\ee15"; }

.bxs-magnet:before {
  content: "\\ee16"; }

.bxs-map:before {
  content: "\\ee17"; }

.bxs-map-alt:before {
  content: "\\ee18"; }

.bxs-map-pin:before {
  content: "\\ee19"; }

.bxs-mask:before {
  content: "\\ee1a"; }

.bxs-medal:before {
  content: "\\ee1b"; }

.bxs-megaphone:before {
  content: "\\ee1c"; }

.bxs-meh:before {
  content: "\\ee1d"; }

.bxs-meh-alt:before {
  content: "\\ee1e"; }

.bxs-meh-blank:before {
  content: "\\ee1f"; }

.bxs-memory-card:before {
  content: "\\ee20"; }

.bxs-message:before {
  content: "\\ee21"; }

.bxs-message-add:before {
  content: "\\ee22"; }

.bxs-message-alt:before {
  content: "\\ee23"; }

.bxs-message-alt-add:before {
  content: "\\ee24"; }

.bxs-message-alt-check:before {
  content: "\\ee25"; }

.bxs-message-alt-detail:before {
  content: "\\ee26"; }

.bxs-message-alt-dots:before {
  content: "\\ee27"; }

.bxs-message-alt-edit:before {
  content: "\\ee28"; }

.bxs-message-alt-error:before {
  content: "\\ee29"; }

.bxs-message-alt-minus:before {
  content: "\\ee2a"; }

.bxs-message-alt-x:before {
  content: "\\ee2b"; }

.bxs-message-check:before {
  content: "\\ee2c"; }

.bxs-message-detail:before {
  content: "\\ee2d"; }

.bxs-message-dots:before {
  content: "\\ee2e"; }

.bxs-message-edit:before {
  content: "\\ee2f"; }

.bxs-message-error:before {
  content: "\\ee30"; }

.bxs-message-minus:before {
  content: "\\ee31"; }

.bxs-message-rounded:before {
  content: "\\ee32"; }

.bxs-message-rounded-add:before {
  content: "\\ee33"; }

.bxs-message-rounded-check:before {
  content: "\\ee34"; }

.bxs-message-rounded-detail:before {
  content: "\\ee35"; }

.bxs-message-rounded-dots:before {
  content: "\\ee36"; }

.bxs-message-rounded-edit:before {
  content: "\\ee37"; }

.bxs-message-rounded-error:before {
  content: "\\ee38"; }

.bxs-message-rounded-minus:before {
  content: "\\ee39"; }

.bxs-message-rounded-x:before {
  content: "\\ee3a"; }

.bxs-message-square:before {
  content: "\\ee3b"; }

.bxs-message-square-add:before {
  content: "\\ee3c"; }

.bxs-message-square-check:before {
  content: "\\ee3d"; }

.bxs-message-square-detail:before {
  content: "\\ee3e"; }

.bxs-message-square-dots:before {
  content: "\\ee3f"; }

.bxs-message-square-edit:before {
  content: "\\ee40"; }

.bxs-message-square-error:before {
  content: "\\ee41"; }

.bxs-message-square-minus:before {
  content: "\\ee42"; }

.bxs-message-square-x:before {
  content: "\\ee43"; }

.bxs-message-x:before {
  content: "\\ee44"; }

.bxs-meteor:before {
  content: "\\ee45"; }

.bxs-microchip:before {
  content: "\\ee46"; }

.bxs-microphone:before {
  content: "\\ee47"; }

.bxs-microphone-alt:before {
  content: "\\ee48"; }

.bxs-microphone-off:before {
  content: "\\ee49"; }

.bxs-minus-circle:before {
  content: "\\ee4a"; }

.bxs-minus-square:before {
  content: "\\ee4b"; }

.bxs-mobile:before {
  content: "\\ee4c"; }

.bxs-mobile-vibration:before {
  content: "\\ee4d"; }

.bxs-moon:before {
  content: "\\ee4e"; }

.bxs-mouse:before {
  content: "\\ee4f"; }

.bxs-mouse-alt:before {
  content: "\\ee50"; }

.bxs-movie:before {
  content: "\\ee51"; }

.bxs-movie-play:before {
  content: "\\ee52"; }

.bxs-music:before {
  content: "\\ee53"; }

.bxs-navigation:before {
  content: "\\ee54"; }

.bxs-network-chart:before {
  content: "\\ee55"; }

.bxs-news:before {
  content: "\\ee56"; }

.bxs-no-entry:before {
  content: "\\ee57"; }

.bxs-note:before {
  content: "\\ee58"; }

.bxs-notepad:before {
  content: "\\ee59"; }

.bxs-notification:before {
  content: "\\ee5a"; }

.bxs-notification-off:before {
  content: "\\ee5b"; }

.bxs-offer:before {
  content: "\\ee5c"; }

.bxs-package:before {
  content: "\\ee5d"; }

.bxs-paint:before {
  content: "\\ee5e"; }

.bxs-paint-roll:before {
  content: "\\ee5f"; }

.bxs-palette:before {
  content: "\\ee60"; }

.bxs-paper-plane:before {
  content: "\\ee61"; }

.bxs-parking:before {
  content: "\\ee62"; }

.bxs-paste:before {
  content: "\\ee63"; }

.bxs-pen:before {
  content: "\\ee64"; }

.bxs-pencil:before {
  content: "\\ee65"; }

.bxs-phone:before {
  content: "\\ee66"; }

.bxs-phone-call:before {
  content: "\\ee67"; }

.bxs-phone-incoming:before {
  content: "\\ee68"; }

.bxs-phone-off:before {
  content: "\\ee69"; }

.bxs-phone-outgoing:before {
  content: "\\ee6a"; }

.bxs-photo-album:before {
  content: "\\ee6b"; }

.bxs-piano:before {
  content: "\\ee6c"; }

.bxs-pie-chart:before {
  content: "\\ee6d"; }

.bxs-pie-chart-alt:before {
  content: "\\ee6e"; }

.bxs-pie-chart-alt-2:before {
  content: "\\ee6f"; }

.bxs-pin:before {
  content: "\\ee70"; }

.bxs-pizza:before {
  content: "\\ee71"; }

.bxs-plane:before {
  content: "\\ee72"; }

.bxs-plane-alt:before {
  content: "\\ee73"; }

.bxs-plane-land:before {
  content: "\\ee74"; }

.bxs-planet:before {
  content: "\\ee75"; }

.bxs-plane-take-off:before {
  content: "\\ee76"; }

.bxs-playlist:before {
  content: "\\ee77"; }

.bxs-plug:before {
  content: "\\ee78"; }

.bxs-plus-circle:before {
  content: "\\ee79"; }

.bxs-plus-square:before {
  content: "\\ee7a"; }

.bxs-pointer:before {
  content: "\\ee7b"; }

.bxs-polygon:before {
  content: "\\ee7c"; }

.bxs-printer:before {
  content: "\\ee7d"; }

.bxs-purchase-tag:before {
  content: "\\ee7e"; }

.bxs-purchase-tag-alt:before {
  content: "\\ee7f"; }

.bxs-pyramid:before {
  content: "\\ee80"; }

.bxs-quote-alt-left:before {
  content: "\\ee81"; }

.bxs-quote-alt-right:before {
  content: "\\ee82"; }

.bxs-quote-left:before {
  content: "\\ee83"; }

.bxs-quote-right:before {
  content: "\\ee84"; }

.bxs-quote-single-left:before {
  content: "\\ee85"; }

.bxs-quote-single-right:before {
  content: "\\ee86"; }

.bxs-radiation:before {
  content: "\\ee87"; }

.bxs-radio:before {
  content: "\\ee88"; }

.bxs-receipt:before {
  content: "\\ee89"; }

.bxs-rectangle:before {
  content: "\\ee8a"; }

.bxs-registered:before {
  content: "\\ee8b"; }

.bxs-rename:before {
  content: "\\ee8c"; }

.bxs-report:before {
  content: "\\ee8d"; }

.bxs-rewind-circle:before {
  content: "\\ee8e"; }

.bxs-right-arrow:before {
  content: "\\ee8f"; }

.bxs-right-arrow-alt:before {
  content: "\\ee90"; }

.bxs-right-arrow-circle:before {
  content: "\\ee91"; }

.bxs-right-arrow-square:before {
  content: "\\ee92"; }

.bxs-right-down-arrow-circle:before {
  content: "\\ee93"; }

.bxs-right-top-arrow-circle:before {
  content: "\\ee94"; }

.bxs-rocket:before {
  content: "\\ee95"; }

.bxs-ruler:before {
  content: "\\ee96"; }

.bxs-sad:before {
  content: "\\ee97"; }

.bxs-save:before {
  content: "\\ee98"; }

.bxs-school:before {
  content: "\\ee99"; }

.bxs-search:before {
  content: "\\ee9a"; }

.bxs-search-alt-2:before {
  content: "\\ee9b"; }

.bxs-select-multiple:before {
  content: "\\ee9c"; }

.bxs-send:before {
  content: "\\ee9d"; }

.bxs-server:before {
  content: "\\ee9e"; }

.bxs-shapes:before {
  content: "\\ee9f"; }

.bxs-share:before {
  content: "\\eea0"; }

.bxs-share-alt:before {
  content: "\\eea1"; }

.bxs-shield:before {
  content: "\\eea2"; }

.bxs-shield-alt-2:before {
  content: "\\eea3"; }

.bxs-shield-x:before {
  content: "\\eea4"; }

.bxs-ship:before {
  content: "\\eea5"; }

.bxs-shocked:before {
  content: "\\eea6"; }

.bxs-shopping-bag:before {
  content: "\\eea7"; }

.bxs-shopping-bag-alt:before {
  content: "\\eea8"; }

.bxs-shopping-bags:before {
  content: "\\eea9"; }

.bxs-show:before {
  content: "\\eeaa"; }

.bxs-skip-next-circle:before {
  content: "\\eeab"; }

.bxs-skip-previous-circle:before {
  content: "\\eeac"; }

.bxs-skull:before {
  content: "\\eead"; }

.bxs-sleepy:before {
  content: "\\eeae"; }

.bxs-slideshow:before {
  content: "\\eeaf"; }

.bxs-smile:before {
  content: "\\eeb0"; }

.bxs-sort-alt:before {
  content: "\\eeb1"; }

.bxs-spa:before {
  content: "\\eeb2"; }

.bxs-speaker:before {
  content: "\\eeb3"; }

.bxs-spray-can:before {
  content: "\\eeb4"; }

.bxs-spreadsheet:before {
  content: "\\eeb5"; }

.bxs-square:before {
  content: "\\eeb6"; }

.bxs-square-rounded:before {
  content: "\\eeb7"; }

.bxs-star:before {
  content: "\\eeb8"; }

.bxs-star-half:before {
  content: "\\eeb9"; }

.bxs-sticker:before {
  content: "\\eeba"; }

.bxs-stopwatch:before {
  content: "\\eebb"; }

.bxs-store:before {
  content: "\\eebc"; }

.bxs-store-alt:before {
  content: "\\eebd"; }

.bxs-sun:before {
  content: "\\eebe"; }

.bxs-tachometer:before {
  content: "\\eebf"; }

.bxs-tag:before {
  content: "\\eec0"; }

.bxs-tag-alt:before {
  content: "\\eec1"; }

.bxs-tag-x:before {
  content: "\\eec2"; }

.bxs-taxi:before {
  content: "\\eec3"; }

.bxs-tennis-ball:before {
  content: "\\eec4"; }

.bxs-terminal:before {
  content: "\\eec5"; }

.bxs-thermometer:before {
  content: "\\eec6"; }

.bxs-time:before {
  content: "\\eec7"; }

.bxs-time-five:before {
  content: "\\eec8"; }

.bxs-timer:before {
  content: "\\eec9"; }

.bxs-tired:before {
  content: "\\eeca"; }

.bxs-toggle-left:before {
  content: "\\eecb"; }

.bxs-toggle-right:before {
  content: "\\eecc"; }

.bxs-tone:before {
  content: "\\eecd"; }

.bxs-torch:before {
  content: "\\eece"; }

.bxs-to-top:before {
  content: "\\eecf"; }

.bxs-traffic:before {
  content: "\\eed0"; }

.bxs-traffic-barrier:before {
  content: "\\eed1"; }

.bxs-traffic-cone:before {
  content: "\\eed2"; }

.bxs-train:before {
  content: "\\eed3"; }

.bxs-trash:before {
  content: "\\eed4"; }

.bxs-trash-alt:before {
  content: "\\eed5"; }

.bxs-tree:before {
  content: "\\eed6"; }

.bxs-trophy:before {
  content: "\\eed7"; }

.bxs-truck:before {
  content: "\\eed8"; }

.bxs-t-shirt:before {
  content: "\\eed9"; }

.bxs-tv:before {
  content: "\\eeda"; }

.bxs-up-arrow:before {
  content: "\\eedb"; }

.bxs-up-arrow-alt:before {
  content: "\\eedc"; }

.bxs-up-arrow-circle:before {
  content: "\\eedd"; }

.bxs-up-arrow-square:before {
  content: "\\eede"; }

.bxs-upside-down:before {
  content: "\\eedf"; }

.bxs-upvote:before {
  content: "\\eee0"; }

.bxs-user:before {
  content: "\\eee1"; }

.bxs-user-account:before {
  content: "\\eee2"; }

.bxs-user-badge:before {
  content: "\\eee3"; }

.bxs-user-check:before {
  content: "\\eee4"; }

.bxs-user-circle:before {
  content: "\\eee5"; }

.bxs-user-detail:before {
  content: "\\eee6"; }

.bxs-user-minus:before {
  content: "\\eee7"; }

.bxs-user-pin:before {
  content: "\\eee8"; }

.bxs-user-plus:before {
  content: "\\eee9"; }

.bxs-user-rectangle:before {
  content: "\\eeea"; }

.bxs-user-voice:before {
  content: "\\eeeb"; }

.bxs-user-x:before {
  content: "\\eeec"; }

.bxs-vector:before {
  content: "\\eeed"; }

.bxs-vial:before {
  content: "\\eeee"; }

.bxs-video:before {
  content: "\\eeef"; }

.bxs-video-off:before {
  content: "\\eef0"; }

.bxs-video-plus:before {
  content: "\\eef1"; }

.bxs-video-recording:before {
  content: "\\eef2"; }

.bxs-videos:before {
  content: "\\eef3"; }

.bxs-virus:before {
  content: "\\eef4"; }

.bxs-virus-block:before {
  content: "\\eef5"; }

.bxs-volume:before {
  content: "\\eef6"; }

.bxs-volume-full:before {
  content: "\\eef7"; }

.bxs-volume-low:before {
  content: "\\eef8"; }

.bxs-volume-mute:before {
  content: "\\eef9"; }

.bxs-wallet:before {
  content: "\\eefa"; }

.bxs-wallet-alt:before {
  content: "\\eefb"; }

.bxs-washer:before {
  content: "\\eefc"; }

.bxs-watch:before {
  content: "\\eefd"; }

.bxs-watch-alt:before {
  content: "\\eefe"; }

.bxs-webcam:before {
  content: "\\eeff"; }

.bxs-widget:before {
  content: "\\ef00"; }

.bxs-window-alt:before {
  content: "\\ef01"; }

.bxs-wine:before {
  content: "\\ef02"; }

.bxs-wink-smile:before {
  content: "\\ef03"; }

.bxs-wink-tongue:before {
  content: "\\ef04"; }

.bxs-wrench:before {
  content: "\\ef05"; }

.bxs-x-circle:before {
  content: "\\ef06"; }

.bxs-x-square:before {
  content: "\\ef07"; }

.bxs-yin-yang:before {
  content: "\\ef08"; }

.bxs-zap:before {
  content: "\\ef09"; }

.bxs-zoom-in:before {
  content: "\\ef0a"; }

.bxs-zoom-out:before {
  content: "\\ef0b"; }

.la,
.las,
.lar,
.lal,
.lad,
.lab {
  -moz-osx-font-smoothing: grayscale;
  -webkit-font-smoothing: antialiased;
  display: inline-block;
  font-style: normal;
  font-feature-settings: normal;
  font-variant: normal;
  text-rendering: auto;
  line-height: 1; }

.la-lg {
  font-size: 1.33333em;
  line-height: 0.75em;
  vertical-align: -.0667em; }

.la-xs {
  font-size: .75em; }

.la-sm {
  font-size: .875em; }

.la-1x {
  font-size: 1em; }

.la-2x {
  font-size: 2em; }

.la-3x {
  font-size: 3em; }

.la-4x {
  font-size: 4em; }

.la-5x {
  font-size: 5em; }

.la-6x {
  font-size: 6em; }

.la-7x {
  font-size: 7em; }

.la-8x {
  font-size: 8em; }

.la-9x {
  font-size: 9em; }

.la-10x {
  font-size: 10em; }

.la-fw {
  text-align: center;
  width: 1.25em; }

.la-ul {
  list-style-type: none;
  margin-left: 2.5em;
  padding-left: 0; }

.la-ul > li {
  position: relative; }

.la-li {
  left: -2em;
  position: absolute;
  text-align: center;
  width: 2em;
  line-height: inherit; }

.la-border {
  border: solid 0.08em #eee;
  border-radius: .1em;
  padding: .2em .25em .15em; }

.la-pull-left {
  float: left; }

.la-pull-right {
  float: right; }

.la.la-pull-left,
.las.la-pull-left,
.lar.la-pull-left,
.lal.la-pull-left,
.lab.la-pull-left {
  margin-right: .3em; }

.la.la-pull-right,
.las.la-pull-right,
.lar.la-pull-right,
.lal.la-pull-right,
.lab.la-pull-right {
  margin-left: .3em; }

.la-spin {
  animation: la-spin 2s infinite linear; }

.la-pulse {
  animation: la-spin 1s infinite steps(8); }

@keyframes la-spin {
  0% {
    transform: rotate(0deg); }
  100% {
    transform: rotate(360deg); } }

.la-rotate-90 {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=1)";
  transform: rotate(90deg); }

.la-rotate-180 {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2)";
  transform: rotate(180deg); }

.la-rotate-270 {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=3)";
  transform: rotate(270deg); }

.la-flip-horizontal {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)";
  transform: scale(-1, 1); }

.la-flip-vertical {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)";
  transform: scale(1, -1); }

.la-flip-both, .la-flip-horizontal.la-flip-vertical {
  -ms-filter: "progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)";
  transform: scale(-1, -1); }

:root .la-rotate-90,
:root .la-rotate-180,
:root .la-rotate-270,
:root .la-flip-horizontal,
:root .la-flip-vertical,
:root .la-flip-both {
  filter: none; }

.la-stack {
  display: inline-block;
  height: 2em;
  line-height: 2em;
  position: relative;
  vertical-align: middle;
  width: 2.5em; }

.la-stack-1x,
.la-stack-2x {
  left: 0;
  position: absolute;
  text-align: center;
  width: 100%; }

.la-stack-1x {
  line-height: inherit; }

.la-stack-2x {
  font-size: 2em; }

.la-inverse {
  color: #fff; }

/* Font Awesome uses the Unicode Private Use Area (PUA) to ensure screen
readers do not read off random characters that represent icons */
.la-500px:before {
  content: "\\f26e"; }

.la-accessible-icon:before {
  content: "\\f368"; }

.la-accusoft:before {
  content: "\\f369"; }

.la-acquisitions-incorporated:before {
  content: "\\f6af"; }

.la-ad:before {
  content: "\\f641"; }

.la-address-book:before {
  content: "\\f2b9"; }

.la-address-card:before {
  content: "\\f2bb"; }

.la-adjust:before {
  content: "\\f042"; }

.la-adn:before {
  content: "\\f170"; }

.la-adobe:before {
  content: "\\f778"; }

.la-adversal:before {
  content: "\\f36a"; }

.la-affiliatetheme:before {
  content: "\\f36b"; }

.la-air-freshener:before {
  content: "\\f5d0"; }

.la-airbnb:before {
  content: "\\f834"; }

.la-algolia:before {
  content: "\\f36c"; }

.la-align-center:before {
  content: "\\f037"; }

.la-align-justify:before {
  content: "\\f039"; }

.la-align-left:before {
  content: "\\f036"; }

.la-align-right:before {
  content: "\\f038"; }

.la-alipay:before {
  content: "\\f642"; }

.la-allergies:before {
  content: "\\f461"; }

.la-amazon:before {
  content: "\\f270"; }

.la-amazon-pay:before {
  content: "\\f42c"; }

.la-ambulance:before {
  content: "\\f0f9"; }

.la-american-sign-language-interpreting:before {
  content: "\\f2a3"; }

.la-amilia:before {
  content: "\\f36d"; }

.la-anchor:before {
  content: "\\f13d"; }

.la-android:before {
  content: "\\f17b"; }

.la-angellist:before {
  content: "\\f209"; }

.la-angle-double-down:before {
  content: "\\f103"; }

.la-angle-double-left:before {
  content: "\\f100"; }

.la-angle-double-right:before {
  content: "\\f101"; }

.la-angle-double-up:before {
  content: "\\f102"; }

.la-angle-down:before {
  content: "\\f107"; }

.la-angle-left:before {
  content: "\\f104"; }

.la-angle-right:before {
  content: "\\f105"; }

.la-angle-up:before {
  content: "\\f106"; }

.la-angry:before {
  content: "\\f556"; }

.la-angrycreative:before {
  content: "\\f36e"; }

.la-angular:before {
  content: "\\f420"; }

.la-ankh:before {
  content: "\\f644"; }

.la-app-store:before {
  content: "\\f36f"; }

.la-app-store-ios:before {
  content: "\\f370"; }

.la-apper:before {
  content: "\\f371"; }

.la-apple:before {
  content: "\\f179"; }

.la-apple-alt:before {
  content: "\\f5d1"; }

.la-apple-pay:before {
  content: "\\f415"; }

.la-archive:before {
  content: "\\f187"; }

.la-archway:before {
  content: "\\f557"; }

.la-arrow-alt-circle-down:before {
  content: "\\f358"; }

.la-arrow-alt-circle-left:before {
  content: "\\f359"; }

.la-arrow-alt-circle-right:before {
  content: "\\f35a"; }

.la-arrow-alt-circle-up:before {
  content: "\\f35b"; }

.la-arrow-circle-down:before {
  content: "\\f0ab"; }

.la-arrow-circle-left:before {
  content: "\\f0a8"; }

.la-arrow-circle-right:before {
  content: "\\f0a9"; }

.la-arrow-circle-up:before {
  content: "\\f0aa"; }

.la-arrow-down:before {
  content: "\\f063"; }

.la-arrow-left:before {
  content: "\\f060"; }

.la-arrow-right:before {
  content: "\\f061"; }

.la-arrow-up:before {
  content: "\\f062"; }

.la-arrows-alt:before {
  content: "\\f0b2"; }

.la-arrows-alt-h:before {
  content: "\\f337"; }

.la-arrows-alt-v:before {
  content: "\\f338"; }

.la-artstation:before {
  content: "\\f77a"; }

.la-assistive-listening-systems:before {
  content: "\\f2a2"; }

.la-asterisk:before {
  content: "\\f069"; }

.la-asymmetrik:before {
  content: "\\f372"; }

.la-at:before {
  content: "\\f1fa"; }

.la-atlas:before {
  content: "\\f558"; }

.la-atlassian:before {
  content: "\\f77b"; }

.la-atom:before {
  content: "\\f5d2"; }

.la-audible:before {
  content: "\\f373"; }

.la-audio-description:before {
  content: "\\f29e"; }

.la-autoprefixer:before {
  content: "\\f41c"; }

.la-avianex:before {
  content: "\\f374"; }

.la-aviato:before {
  content: "\\f421"; }

.la-award:before {
  content: "\\f559"; }

.la-aws:before {
  content: "\\f375"; }

.la-baby:before {
  content: "\\f77c"; }

.la-baby-carriage:before {
  content: "\\f77d"; }

.la-backspace:before {
  content: "\\f55a"; }

.la-backward:before {
  content: "\\f04a"; }

.la-bacon:before {
  content: "\\f7e5"; }

.la-balance-scale:before {
  content: "\\f24e"; }

.la-balance-scale-left:before {
  content: "\\f515"; }

.la-balance-scale-right:before {
  content: "\\f516"; }

.la-ban:before {
  content: "\\f05e"; }

.la-band-aid:before {
  content: "\\f462"; }

.la-bandcamp:before {
  content: "\\f2d5"; }

.la-barcode:before {
  content: "\\f02a"; }

.la-bars:before {
  content: "\\f0c9"; }

.la-baseball-ball:before {
  content: "\\f433"; }

.la-basketball-ball:before {
  content: "\\f434"; }

.la-bath:before {
  content: "\\f2cd"; }

.la-battery-empty:before {
  content: "\\f244"; }

.la-battery-full:before {
  content: "\\f240"; }

.la-battery-half:before {
  content: "\\f242"; }

.la-battery-quarter:before {
  content: "\\f243"; }

.la-battery-three-quarters:before {
  content: "\\f241"; }

.la-battle-net:before {
  content: "\\f835"; }

.la-bed:before {
  content: "\\f236"; }

.la-beer:before {
  content: "\\f0fc"; }

.la-behance:before {
  content: "\\f1b4"; }

.la-behance-square:before {
  content: "\\f1b5"; }

.la-bell:before {
  content: "\\f0f3"; }

.la-bell-slash:before {
  content: "\\f1f6"; }

.la-bezier-curve:before {
  content: "\\f55b"; }

.la-bible:before {
  content: "\\f647"; }

.la-bicycle:before {
  content: "\\f206"; }

.la-biking:before {
  content: "\\f84a"; }

.la-bimobject:before {
  content: "\\f378"; }

.la-binoculars:before {
  content: "\\f1e5"; }

.la-biohazard:before {
  content: "\\f780"; }

.la-birthday-cake:before {
  content: "\\f1fd"; }

.la-bitbucket:before {
  content: "\\f171"; }

.la-bitcoin:before {
  content: "\\f379"; }

.la-bity:before {
  content: "\\f37a"; }

.la-black-tie:before {
  content: "\\f27e"; }

.la-blackberry:before {
  content: "\\f37b"; }

.la-blender:before {
  content: "\\f517"; }

.la-blender-phone:before {
  content: "\\f6b6"; }

.la-blind:before {
  content: "\\f29d"; }

.la-blog:before {
  content: "\\f781"; }

.la-blogger:before {
  content: "\\f37c"; }

.la-blogger-b:before {
  content: "\\f37d"; }

.la-bluetooth:before {
  content: "\\f293"; }

.la-bluetooth-b:before {
  content: "\\f294"; }

.la-bold:before {
  content: "\\f032"; }

.la-bolt:before {
  content: "\\f0e7"; }

.la-bomb:before {
  content: "\\f1e2"; }

.la-bone:before {
  content: "\\f5d7"; }

.la-bong:before {
  content: "\\f55c"; }

.la-book:before {
  content: "\\f02d"; }

.la-book-dead:before {
  content: "\\f6b7"; }

.la-book-medical:before {
  content: "\\f7e6"; }

.la-book-open:before {
  content: "\\f518"; }

.la-book-reader:before {
  content: "\\f5da"; }

.la-bookmark:before {
  content: "\\f02e"; }

.la-bootstrap:before {
  content: "\\f836"; }

.la-border-all:before {
  content: "\\f84c"; }

.la-border-none:before {
  content: "\\f850"; }

.la-border-style:before {
  content: "\\f853"; }

.la-bowling-ball:before {
  content: "\\f436"; }

.la-box:before {
  content: "\\f466"; }

.la-box-open:before {
  content: "\\f49e"; }

.la-boxes:before {
  content: "\\f468"; }

.la-braille:before {
  content: "\\f2a1"; }

.la-brain:before {
  content: "\\f5dc"; }

.la-bread-slice:before {
  content: "\\f7ec"; }

.la-briefcase:before {
  content: "\\f0b1"; }

.la-briefcase-medical:before {
  content: "\\f469"; }

.la-broadcast-tower:before {
  content: "\\f519"; }

.la-broom:before {
  content: "\\f51a"; }

.la-brush:before {
  content: "\\f55d"; }

.la-btc:before {
  content: "\\f15a"; }

.la-buffer:before {
  content: "\\f837"; }

.la-bug:before {
  content: "\\f188"; }

.la-building:before {
  content: "\\f1ad"; }

.la-bullhorn:before {
  content: "\\f0a1"; }

.la-bullseye:before {
  content: "\\f140"; }

.la-burn:before {
  content: "\\f46a"; }

.la-buromobelexperte:before {
  content: "\\f37f"; }

.la-bus:before {
  content: "\\f207"; }

.la-bus-alt:before {
  content: "\\f55e"; }

.la-business-time:before {
  content: "\\f64a"; }

.la-buy-n-large:before {
  content: "\\f8a6"; }

.la-buysellads:before {
  content: "\\f20d"; }

.la-calculator:before {
  content: "\\f1ec"; }

.la-calendar:before {
  content: "\\f133"; }

.la-calendar-alt:before {
  content: "\\f073"; }

.la-calendar-check:before {
  content: "\\f274"; }

.la-calendar-day:before {
  content: "\\f783"; }

.la-calendar-minus:before {
  content: "\\f272"; }

.la-calendar-plus:before {
  content: "\\f271"; }

.la-calendar-times:before {
  content: "\\f273"; }

.la-calendar-week:before {
  content: "\\f784"; }

.la-camera:before {
  content: "\\f030"; }

.la-camera-retro:before {
  content: "\\f083"; }

.la-campground:before {
  content: "\\f6bb"; }

.la-canadian-maple-leaf:before {
  content: "\\f785"; }

.la-candy-cane:before {
  content: "\\f786"; }

.la-cannabis:before {
  content: "\\f55f"; }

.la-capsules:before {
  content: "\\f46b"; }

.la-car:before {
  content: "\\f1b9"; }

.la-car-alt:before {
  content: "\\f5de"; }

.la-car-battery:before {
  content: "\\f5df"; }

.la-car-crash:before {
  content: "\\f5e1"; }

.la-car-side:before {
  content: "\\f5e4"; }

.la-caret-down:before {
  content: "\\f0d7"; }

.la-caret-left:before {
  content: "\\f0d9"; }

.la-caret-right:before {
  content: "\\f0da"; }

.la-caret-square-down:before {
  content: "\\f150"; }

.la-caret-square-left:before {
  content: "\\f191"; }

.la-caret-square-right:before {
  content: "\\f152"; }

.la-caret-square-up:before {
  content: "\\f151"; }

.la-caret-up:before {
  content: "\\f0d8"; }

.la-carrot:before {
  content: "\\f787"; }

.la-cart-arrow-down:before {
  content: "\\f218"; }

.la-cart-plus:before {
  content: "\\f217"; }

.la-cash-register:before {
  content: "\\f788"; }

.la-cat:before {
  content: "\\f6be"; }

.la-cc-amazon-pay:before {
  content: "\\f42d"; }

.la-cc-amex:before {
  content: "\\f1f3"; }

.la-cc-apple-pay:before {
  content: "\\f416"; }

.la-cc-diners-club:before {
  content: "\\f24c"; }

.la-cc-discover:before {
  content: "\\f1f2"; }

.la-cc-jcb:before {
  content: "\\f24b"; }

.la-cc-mastercard:before {
  content: "\\f1f1"; }

.la-cc-paypal:before {
  content: "\\f1f4"; }

.la-cc-stripe:before {
  content: "\\f1f5"; }

.la-cc-visa:before {
  content: "\\f1f0"; }

.la-centercode:before {
  content: "\\f380"; }

.la-centos:before {
  content: "\\f789"; }

.la-certificate:before {
  content: "\\f0a3"; }

.la-chair:before {
  content: "\\f6c0"; }

.la-chalkboard:before {
  content: "\\f51b"; }

.la-chalkboard-teacher:before {
  content: "\\f51c"; }

.la-charging-station:before {
  content: "\\f5e7"; }

.la-chart-area:before {
  content: "\\f1fe"; }

.la-chart-bar:before {
  content: "\\f080"; }

.la-chart-line:before {
  content: "\\f201"; }

.la-chart-pie:before {
  content: "\\f200"; }

.la-check:before {
  content: "\\f00c"; }

.la-check-circle:before {
  content: "\\f058"; }

.la-check-double:before {
  content: "\\f560"; }

.la-check-square:before {
  content: "\\f14a"; }

.la-cheese:before {
  content: "\\f7ef"; }

.la-chess:before {
  content: "\\f439"; }

.la-chess-bishop:before {
  content: "\\f43a"; }

.la-chess-board:before {
  content: "\\f43c"; }

.la-chess-king:before {
  content: "\\f43f"; }

.la-chess-knight:before {
  content: "\\f441"; }

.la-chess-pawn:before {
  content: "\\f443"; }

.la-chess-queen:before {
  content: "\\f445"; }

.la-chess-rook:before {
  content: "\\f447"; }

.la-chevron-circle-down:before {
  content: "\\f13a"; }

.la-chevron-circle-left:before {
  content: "\\f137"; }

.la-chevron-circle-right:before {
  content: "\\f138"; }

.la-chevron-circle-up:before {
  content: "\\f139"; }

.la-chevron-down:before {
  content: "\\f078"; }

.la-chevron-left:before {
  content: "\\f053"; }

.la-chevron-right:before {
  content: "\\f054"; }

.la-chevron-up:before {
  content: "\\f077"; }

.la-child:before {
  content: "\\f1ae"; }

.la-chrome:before {
  content: "\\f268"; }

.la-chromecast:before {
  content: "\\f838"; }

.la-church:before {
  content: "\\f51d"; }

.la-circle:before {
  content: "\\f111"; }

.la-circle-notch:before {
  content: "\\f1ce"; }

.la-city:before {
  content: "\\f64f"; }

.la-clinic-medical:before {
  content: "\\f7f2"; }

.la-clipboard:before {
  content: "\\f328"; }

.la-clipboard-check:before {
  content: "\\f46c"; }

.la-clipboard-list:before {
  content: "\\f46d"; }

.la-clock:before {
  content: "\\f017"; }

.la-clone:before {
  content: "\\f24d"; }

.la-closed-captioning:before {
  content: "\\f20a"; }

.la-cloud:before {
  content: "\\f0c2"; }

.la-cloud-download-alt:before {
  content: "\\f381"; }

.la-cloud-meatball:before {
  content: "\\f73b"; }

.la-cloud-moon:before {
  content: "\\f6c3"; }

.la-cloud-moon-rain:before {
  content: "\\f73c"; }

.la-cloud-rain:before {
  content: "\\f73d"; }

.la-cloud-showers-heavy:before {
  content: "\\f740"; }

.la-cloud-sun:before {
  content: "\\f6c4"; }

.la-cloud-sun-rain:before {
  content: "\\f743"; }

.la-cloud-upload-alt:before {
  content: "\\f382"; }

.la-cloudscale:before {
  content: "\\f383"; }

.la-cloudsmith:before {
  content: "\\f384"; }

.la-cloudversify:before {
  content: "\\f385"; }

.la-cocktail:before {
  content: "\\f561"; }

.la-code:before {
  content: "\\f121"; }

.la-code-branch:before {
  content: "\\f126"; }

.la-codepen:before {
  content: "\\f1cb"; }

.la-codiepie:before {
  content: "\\f284"; }

.la-coffee:before {
  content: "\\f0f4"; }

.la-cog:before {
  content: "\\f013"; }

.la-cogs:before {
  content: "\\f085"; }

.la-coins:before {
  content: "\\f51e"; }

.la-columns:before {
  content: "\\f0db"; }

.la-comment:before {
  content: "\\f075"; }

.la-comment-alt:before {
  content: "\\f27a"; }

.la-comment-dollar:before {
  content: "\\f651"; }

.la-comment-dots:before {
  content: "\\f4ad"; }

.la-comment-medical:before {
  content: "\\f7f5"; }

.la-comment-slash:before {
  content: "\\f4b3"; }

.la-comments:before {
  content: "\\f086"; }

.la-comments-dollar:before {
  content: "\\f653"; }

.la-compact-disc:before {
  content: "\\f51f"; }

.la-compass:before {
  content: "\\f14e"; }

.la-compress:before {
  content: "\\f066"; }

.la-compress-arrows-alt:before {
  content: "\\f78c"; }

.la-concierge-bell:before {
  content: "\\f562"; }

.la-confluence:before {
  content: "\\f78d"; }

.la-connectdevelop:before {
  content: "\\f20e"; }

.la-contao:before {
  content: "\\f26d"; }

.la-cookie:before {
  content: "\\f563"; }

.la-cookie-bite:before {
  content: "\\f564"; }

.la-copy:before {
  content: "\\f0c5"; }

.la-copyright:before {
  content: "\\f1f9"; }

.la-cotton-bureau:before {
  content: "\\f89e"; }

.la-couch:before {
  content: "\\f4b8"; }

.la-cpanel:before {
  content: "\\f388"; }

.la-creative-commons:before {
  content: "\\f25e"; }

.la-creative-commons-by:before {
  content: "\\f4e7"; }

.la-creative-commons-nc:before {
  content: "\\f4e8"; }

.la-creative-commons-nc-eu:before {
  content: "\\f4e9"; }

.la-creative-commons-nc-jp:before {
  content: "\\f4ea"; }

.la-creative-commons-nd:before {
  content: "\\f4eb"; }

.la-creative-commons-pd:before {
  content: "\\f4ec"; }

.la-creative-commons-pd-alt:before {
  content: "\\f4ed"; }

.la-creative-commons-remix:before {
  content: "\\f4ee"; }

.la-creative-commons-sa:before {
  content: "\\f4ef"; }

.la-creative-commons-sampling:before {
  content: "\\f4f0"; }

.la-creative-commons-sampling-plus:before {
  content: "\\f4f1"; }

.la-creative-commons-share:before {
  content: "\\f4f2"; }

.la-creative-commons-zero:before {
  content: "\\f4f3"; }

.la-credit-card:before {
  content: "\\f09d"; }

.la-critical-role:before {
  content: "\\f6c9"; }

.la-crop:before {
  content: "\\f125"; }

.la-crop-alt:before {
  content: "\\f565"; }

.la-cross:before {
  content: "\\f654"; }

.la-crosshairs:before {
  content: "\\f05b"; }

.la-crow:before {
  content: "\\f520"; }

.la-crown:before {
  content: "\\f521"; }

.la-crutch:before {
  content: "\\f7f7"; }

.la-css3:before {
  content: "\\f13c"; }

.la-css3-alt:before {
  content: "\\f38b"; }

.la-cube:before {
  content: "\\f1b2"; }

.la-cubes:before {
  content: "\\f1b3"; }

.la-cut:before {
  content: "\\f0c4"; }

.la-cuttlefish:before {
  content: "\\f38c"; }

.la-d-and-d:before {
  content: "\\f38d"; }

.la-d-and-d-beyond:before {
  content: "\\f6ca"; }

.la-dashcube:before {
  content: "\\f210"; }

.la-database:before {
  content: "\\f1c0"; }

.la-deaf:before {
  content: "\\f2a4"; }

.la-delicious:before {
  content: "\\f1a5"; }

.la-democrat:before {
  content: "\\f747"; }

.la-deploydog:before {
  content: "\\f38e"; }

.la-deskpro:before {
  content: "\\f38f"; }

.la-desktop:before {
  content: "\\f108"; }

.la-dev:before {
  content: "\\f6cc"; }

.la-deviantart:before {
  content: "\\f1bd"; }

.la-dharmachakra:before {
  content: "\\f655"; }

.la-dhl:before {
  content: "\\f790"; }

.la-diagnoses:before {
  content: "\\f470"; }

.la-diaspora:before {
  content: "\\f791"; }

.la-dice:before {
  content: "\\f522"; }

.la-dice-d20:before {
  content: "\\f6cf"; }

.la-dice-d6:before {
  content: "\\f6d1"; }

.la-dice-five:before {
  content: "\\f523"; }

.la-dice-four:before {
  content: "\\f524"; }

.la-dice-one:before {
  content: "\\f525"; }

.la-dice-six:before {
  content: "\\f526"; }

.la-dice-three:before {
  content: "\\f527"; }

.la-dice-two:before {
  content: "\\f528"; }

.la-digg:before {
  content: "\\f1a6"; }

.la-digital-ocean:before {
  content: "\\f391"; }

.la-digital-tachograph:before {
  content: "\\f566"; }

.la-directions:before {
  content: "\\f5eb"; }

.la-discord:before {
  content: "\\f392"; }

.la-discourse:before {
  content: "\\f393"; }

.la-divide:before {
  content: "\\f529"; }

.la-dizzy:before {
  content: "\\f567"; }

.la-dna:before {
  content: "\\f471"; }

.la-dochub:before {
  content: "\\f394"; }

.la-docker:before {
  content: "\\f395"; }

.la-dog:before {
  content: "\\f6d3"; }

.la-dollar-sign:before {
  content: "\\f155"; }

.la-dolly:before {
  content: "\\f472"; }

.la-dolly-flatbed:before {
  content: "\\f474"; }

.la-donate:before {
  content: "\\f4b9"; }

.la-door-closed:before {
  content: "\\f52a"; }

.la-door-open:before {
  content: "\\f52b"; }

.la-dot-circle:before {
  content: "\\f192"; }

.la-dove:before {
  content: "\\f4ba"; }

.la-download:before {
  content: "\\f019"; }

.la-draft2digital:before {
  content: "\\f396"; }

.la-drafting-compass:before {
  content: "\\f568"; }

.la-dragon:before {
  content: "\\f6d5"; }

.la-draw-polygon:before {
  content: "\\f5ee"; }

.la-dribbble:before {
  content: "\\f17d"; }

.la-dribbble-square:before {
  content: "\\f397"; }

.la-dropbox:before {
  content: "\\f16b"; }

.la-drum:before {
  content: "\\f569"; }

.la-drum-steelpan:before {
  content: "\\f56a"; }

.la-drumstick-bite:before {
  content: "\\f6d7"; }

.la-drupal:before {
  content: "\\f1a9"; }

.la-dumbbell:before {
  content: "\\f44b"; }

.la-dumpster:before {
  content: "\\f793"; }

.la-dumpster-fire:before {
  content: "\\f794"; }

.la-dungeon:before {
  content: "\\f6d9"; }

.la-dyalog:before {
  content: "\\f399"; }

.la-earlybirds:before {
  content: "\\f39a"; }

.la-ebay:before {
  content: "\\f4f4"; }

.la-edge:before {
  content: "\\f282"; }

.la-edit:before {
  content: "\\f044"; }

.la-egg:before {
  content: "\\f7fb"; }

.la-eject:before {
  content: "\\f052"; }

.la-elementor:before {
  content: "\\f430"; }

.la-ellipsis-h:before {
  content: "\\f141"; }

.la-ellipsis-v:before {
  content: "\\f142"; }

.la-ello:before {
  content: "\\f5f1"; }

.la-ember:before {
  content: "\\f423"; }

.la-empire:before {
  content: "\\f1d1"; }

.la-envelope:before {
  content: "\\f0e0"; }

.la-envelope-open:before {
  content: "\\f2b6"; }

.la-envelope-open-text:before {
  content: "\\f658"; }

.la-envelope-square:before {
  content: "\\f199"; }

.la-envira:before {
  content: "\\f299"; }

.la-equals:before {
  content: "\\f52c"; }

.la-eraser:before {
  content: "\\f12d"; }

.la-erlang:before {
  content: "\\f39d"; }

.la-ethereum:before {
  content: "\\f42e"; }

.la-ethernet:before {
  content: "\\f796"; }

.la-etsy:before {
  content: "\\f2d7"; }

.la-euro-sign:before {
  content: "\\f153"; }

.la-evernote:before {
  content: "\\f839"; }

.la-exchange-alt:before {
  content: "\\f362"; }

.la-exclamation:before {
  content: "\\f12a"; }

.la-exclamation-circle:before {
  content: "\\f06a"; }

.la-exclamation-triangle:before {
  content: "\\f071"; }

.la-expand:before {
  content: "\\f065"; }

.la-expand-arrows-alt:before {
  content: "\\f31e"; }

.la-expeditedssl:before {
  content: "\\f23e"; }

.la-external-link-alt:before {
  content: "\\f35d"; }

.la-external-link-square-alt:before {
  content: "\\f360"; }

.la-eye:before {
  content: "\\f06e"; }

.la-eye-dropper:before {
  content: "\\f1fb"; }

.la-eye-slash:before {
  content: "\\f070"; }

.la-facebook:before {
  content: "\\f09a"; }

.la-facebook-f:before {
  content: "\\f39e"; }

.la-facebook-messenger:before {
  content: "\\f39f"; }

.la-facebook-square:before {
  content: "\\f082"; }

.la-fan:before {
  content: "\\f863"; }

.la-fantasy-flight-games:before {
  content: "\\f6dc"; }

.la-fast-backward:before {
  content: "\\f049"; }

.la-fast-forward:before {
  content: "\\f050"; }

.la-fax:before {
  content: "\\f1ac"; }

.la-feather:before {
  content: "\\f52d"; }

.la-feather-alt:before {
  content: "\\f56b"; }

.la-fedex:before {
  content: "\\f797"; }

.la-fedora:before {
  content: "\\f798"; }

.la-female:before {
  content: "\\f182"; }

.la-fighter-jet:before {
  content: "\\f0fb"; }

.la-figma:before {
  content: "\\f799"; }

.la-file:before {
  content: "\\f15b"; }

.la-file-alt:before {
  content: "\\f15c"; }

.la-file-archive:before {
  content: "\\f1c6"; }

.la-file-audio:before {
  content: "\\f1c7"; }

.la-file-code:before {
  content: "\\f1c9"; }

.la-file-contract:before {
  content: "\\f56c"; }

.la-file-csv:before {
  content: "\\f6dd"; }

.la-file-download:before {
  content: "\\f56d"; }

.la-file-excel:before {
  content: "\\f1c3"; }

.la-file-export:before {
  content: "\\f56e"; }

.la-file-image:before {
  content: "\\f1c5"; }

.la-file-import:before {
  content: "\\f56f"; }

.la-file-invoice:before {
  content: "\\f570"; }

.la-file-invoice-dollar:before {
  content: "\\f571"; }

.la-file-medical:before {
  content: "\\f477"; }

.la-file-medical-alt:before {
  content: "\\f478"; }

.la-file-pdf:before {
  content: "\\f1c1"; }

.la-file-powerpoint:before {
  content: "\\f1c4"; }

.la-file-prescription:before {
  content: "\\f572"; }

.la-file-signature:before {
  content: "\\f573"; }

.la-file-upload:before {
  content: "\\f574"; }

.la-file-video:before {
  content: "\\f1c8"; }

.la-file-word:before {
  content: "\\f1c2"; }

.la-fill:before {
  content: "\\f575"; }

.la-fill-drip:before {
  content: "\\f576"; }

.la-film:before {
  content: "\\f008"; }

.la-filter:before {
  content: "\\f0b0"; }

.la-fingerprint:before {
  content: "\\f577"; }

.la-fire:before {
  content: "\\f06d"; }

.la-fire-alt:before {
  content: "\\f7e4"; }

.la-fire-extinguisher:before {
  content: "\\f134"; }

.la-firefox:before {
  content: "\\f269"; }

.la-first-aid:before {
  content: "\\f479"; }

.la-first-order:before {
  content: "\\f2b0"; }

.la-first-order-alt:before {
  content: "\\f50a"; }

.la-firstdraft:before {
  content: "\\f3a1"; }

.la-fish:before {
  content: "\\f578"; }

.la-fist-raised:before {
  content: "\\f6de"; }

.la-flag:before {
  content: "\\f024"; }

.la-flag-checkered:before {
  content: "\\f11e"; }

.la-flag-usa:before {
  content: "\\f74d"; }

.la-flask:before {
  content: "\\f0c3"; }

.la-flickr:before {
  content: "\\f16e"; }

.la-flipboard:before {
  content: "\\f44d"; }

.la-flushed:before {
  content: "\\f579"; }

.la-fly:before {
  content: "\\f417"; }

.la-folder:before {
  content: "\\f07b"; }

.la-folder-minus:before {
  content: "\\f65d"; }

.la-folder-open:before {
  content: "\\f07c"; }

.la-folder-plus:before {
  content: "\\f65e"; }

.la-font:before {
  content: "\\f031"; }

.la-font-awesome:before {
  content: "\\f2b4"; }

.la-font-awesome-alt:before {
  content: "\\f35c"; }

.la-font-awesome-flag:before {
  content: "\\f425"; }

.la-font-awesome-logo-full:before {
  content: "\\f4e6"; }

.la-fonticons:before {
  content: "\\f280"; }

.la-fonticons-fi:before {
  content: "\\f3a2"; }

.la-football-ball:before {
  content: "\\f44e"; }

.la-fort-awesome:before {
  content: "\\f286"; }

.la-fort-awesome-alt:before {
  content: "\\f3a3"; }

.la-forumbee:before {
  content: "\\f211"; }

.la-forward:before {
  content: "\\f04e"; }

.la-foursquare:before {
  content: "\\f180"; }

.la-free-code-camp:before {
  content: "\\f2c5"; }

.la-freebsd:before {
  content: "\\f3a4"; }

.la-frog:before {
  content: "\\f52e"; }

.la-frown:before {
  content: "\\f119"; }

.la-frown-open:before {
  content: "\\f57a"; }

.la-fulcrum:before {
  content: "\\f50b"; }

.la-funnel-dollar:before {
  content: "\\f662"; }

.la-futbol:before {
  content: "\\f1e3"; }

.la-galactic-republic:before {
  content: "\\f50c"; }

.la-galactic-senate:before {
  content: "\\f50d"; }

.la-gamepad:before {
  content: "\\f11b"; }

.la-gas-pump:before {
  content: "\\f52f"; }

.la-gavel:before {
  content: "\\f0e3"; }

.la-gem:before {
  content: "\\f3a5"; }

.la-genderless:before {
  content: "\\f22d"; }

.la-get-pocket:before {
  content: "\\f265"; }

.la-gg:before {
  content: "\\f260"; }

.la-gg-circle:before {
  content: "\\f261"; }

.la-ghost:before {
  content: "\\f6e2"; }

.la-gift:before {
  content: "\\f06b"; }

.la-gifts:before {
  content: "\\f79c"; }

.la-git:before {
  content: "\\f1d3"; }

.la-git-alt:before {
  content: "\\f841"; }

.la-git-square:before {
  content: "\\f1d2"; }

.la-github:before {
  content: "\\f09b"; }

.la-github-alt:before {
  content: "\\f113"; }

.la-github-square:before {
  content: "\\f092"; }

.la-gitkraken:before {
  content: "\\f3a6"; }

.la-gitlab:before {
  content: "\\f296"; }

.la-gitter:before {
  content: "\\f426"; }

.la-glass-cheers:before {
  content: "\\f79f"; }

.la-glass-martini:before {
  content: "\\f000"; }

.la-glass-martini-alt:before {
  content: "\\f57b"; }

.la-glass-whiskey:before {
  content: "\\f7a0"; }

.la-glasses:before {
  content: "\\f530"; }

.la-glide:before {
  content: "\\f2a5"; }

.la-glide-g:before {
  content: "\\f2a6"; }

.la-globe:before {
  content: "\\f0ac"; }

.la-globe-africa:before {
  content: "\\f57c"; }

.la-globe-americas:before {
  content: "\\f57d"; }

.la-globe-asia:before {
  content: "\\f57e"; }

.la-globe-europe:before {
  content: "\\f7a2"; }

.la-gofore:before {
  content: "\\f3a7"; }

.la-golf-ball:before {
  content: "\\f450"; }

.la-goodreads:before {
  content: "\\f3a8"; }

.la-goodreads-g:before {
  content: "\\f3a9"; }

.la-google:before {
  content: "\\f1a0"; }

.la-google-drive:before {
  content: "\\f3aa"; }

.la-google-play:before {
  content: "\\f3ab"; }

.la-google-plus:before {
  content: "\\f2b3"; }

.la-google-plus-g:before {
  content: "\\f0d5"; }

.la-google-plus-square:before {
  content: "\\f0d4"; }

.la-google-wallet:before {
  content: "\\f1ee"; }

.la-gopuram:before {
  content: "\\f664"; }

.la-graduation-cap:before {
  content: "\\f19d"; }

.la-gratipay:before {
  content: "\\f184"; }

.la-grav:before {
  content: "\\f2d6"; }

.la-greater-than:before {
  content: "\\f531"; }

.la-greater-than-equal:before {
  content: "\\f532"; }

.la-grimace:before {
  content: "\\f57f"; }

.la-grin:before {
  content: "\\f580"; }

.la-grin-alt:before {
  content: "\\f581"; }

.la-grin-beam:before {
  content: "\\f582"; }

.la-grin-beam-sweat:before {
  content: "\\f583"; }

.la-grin-hearts:before {
  content: "\\f584"; }

.la-grin-squint:before {
  content: "\\f585"; }

.la-grin-squint-tears:before {
  content: "\\f586"; }

.la-grin-stars:before {
  content: "\\f587"; }

.la-grin-tears:before {
  content: "\\f588"; }

.la-grin-tongue:before {
  content: "\\f589"; }

.la-grin-tongue-squint:before {
  content: "\\f58a"; }

.la-grin-tongue-wink:before {
  content: "\\f58b"; }

.la-grin-wink:before {
  content: "\\f58c"; }

.la-grip-horizontal:before {
  content: "\\f58d"; }

.la-grip-lines:before {
  content: "\\f7a4"; }

.la-grip-lines-vertical:before {
  content: "\\f7a5"; }

.la-grip-vertical:before {
  content: "\\f58e"; }

.la-gripfire:before {
  content: "\\f3ac"; }

.la-grunt:before {
  content: "\\f3ad"; }

.la-guitar:before {
  content: "\\f7a6"; }

.la-gulp:before {
  content: "\\f3ae"; }

.la-h-square:before {
  content: "\\f0fd"; }

.la-hacker-news:before {
  content: "\\f1d4"; }

.la-hacker-news-square:before {
  content: "\\f3af"; }

.la-hackerrank:before {
  content: "\\f5f7"; }

.la-hamburger:before {
  content: "\\f805"; }

.la-hammer:before {
  content: "\\f6e3"; }

.la-hamsa:before {
  content: "\\f665"; }

.la-hand-holding:before {
  content: "\\f4bd"; }

.la-hand-holding-heart:before {
  content: "\\f4be"; }

.la-hand-holding-usd:before {
  content: "\\f4c0"; }

.la-hand-lizard:before {
  content: "\\f258"; }

.la-hand-middle-finger:before {
  content: "\\f806"; }

.la-hand-paper:before {
  content: "\\f256"; }

.la-hand-peace:before {
  content: "\\f25b"; }

.la-hand-point-down:before {
  content: "\\f0a7"; }

.la-hand-point-left:before {
  content: "\\f0a5"; }

.la-hand-point-right:before {
  content: "\\f0a4"; }

.la-hand-point-up:before {
  content: "\\f0a6"; }

.la-hand-pointer:before {
  content: "\\f25a"; }

.la-hand-rock:before {
  content: "\\f255"; }

.la-hand-scissors:before {
  content: "\\f257"; }

.la-hand-spock:before {
  content: "\\f259"; }

.la-hands:before {
  content: "\\f4c2"; }

.la-hands-helping:before {
  content: "\\f4c4"; }

.la-handshake:before {
  content: "\\f2b5"; }

.la-hanukiah:before {
  content: "\\f6e6"; }

.la-hard-hat:before {
  content: "\\f807"; }

.la-hashtag:before {
  content: "\\f292"; }

.la-hat-cowboy:before {
  content: "\\f8c0"; }

.la-hat-cowboy-side:before {
  content: "\\f8c1"; }

.la-hat-wizard:before {
  content: "\\f6e8"; }

.la-haykal:before {
  content: "\\f666"; }

.la-hdd:before {
  content: "\\f0a0"; }

.la-heading:before {
  content: "\\f1dc"; }

.la-headphones:before {
  content: "\\f025"; }

.la-headphones-alt:before {
  content: "\\f58f"; }

.la-headset:before {
  content: "\\f590"; }

.la-heart:before {
  content: "\\f004"; }

.la-heart-broken:before {
  content: "\\f7a9"; }

.la-heartbeat:before {
  content: "\\f21e"; }

.la-helicopter:before {
  content: "\\f533"; }

.la-highlighter:before {
  content: "\\f591"; }

.la-hiking:before {
  content: "\\f6ec"; }

.la-hippo:before {
  content: "\\f6ed"; }

.la-hips:before {
  content: "\\f452"; }

.la-hire-a-helper:before {
  content: "\\f3b0"; }

.la-history:before {
  content: "\\f1da"; }

.la-hockey-puck:before {
  content: "\\f453"; }

.la-holly-berry:before {
  content: "\\f7aa"; }

.la-home:before {
  content: "\\f015"; }

.la-hooli:before {
  content: "\\f427"; }

.la-hornbill:before {
  content: "\\f592"; }

.la-horse:before {
  content: "\\f6f0"; }

.la-horse-head:before {
  content: "\\f7ab"; }

.la-hospital:before {
  content: "\\f0f8"; }

.la-hospital-alt:before {
  content: "\\f47d"; }

.la-hospital-symbol:before {
  content: "\\f47e"; }

.la-hot-tub:before {
  content: "\\f593"; }

.la-hotdog:before {
  content: "\\f80f"; }

.la-hotel:before {
  content: "\\f594"; }

.la-hotjar:before {
  content: "\\f3b1"; }

.la-hourglass:before {
  content: "\\f254"; }

.la-hourglass-end:before {
  content: "\\f253"; }

.la-hourglass-half:before {
  content: "\\f252"; }

.la-hourglass-start:before {
  content: "\\f251"; }

.la-house-damage:before {
  content: "\\f6f1"; }

.la-houzz:before {
  content: "\\f27c"; }

.la-hryvnia:before {
  content: "\\f6f2"; }

.la-html5:before {
  content: "\\f13b"; }

.la-hubspot:before {
  content: "\\f3b2"; }

.la-i-cursor:before {
  content: "\\f246"; }

.la-ice-cream:before {
  content: "\\f810"; }

.la-icicles:before {
  content: "\\f7ad"; }

.la-icons:before {
  content: "\\f86d"; }

.la-id-badge:before {
  content: "\\f2c1"; }

.la-id-card:before {
  content: "\\f2c2"; }

.la-id-card-alt:before {
  content: "\\f47f"; }

.la-igloo:before {
  content: "\\f7ae"; }

.la-image:before {
  content: "\\f03e"; }

.la-images:before {
  content: "\\f302"; }

.la-imdb:before {
  content: "\\f2d8"; }

.la-inbox:before {
  content: "\\f01c"; }

.la-indent:before {
  content: "\\f03c"; }

.la-industry:before {
  content: "\\f275"; }

.la-infinity:before {
  content: "\\f534"; }

.la-info:before {
  content: "\\f129"; }

.la-info-circle:before {
  content: "\\f05a"; }

.la-instagram:before {
  content: "\\f16d"; }

.la-intercom:before {
  content: "\\f7af"; }

.la-internet-explorer:before {
  content: "\\f26b"; }

.la-invision:before {
  content: "\\f7b0"; }

.la-ioxhost:before {
  content: "\\f208"; }

.la-italic:before {
  content: "\\f033"; }

.la-itch-io:before {
  content: "\\f83a"; }

.la-itunes:before {
  content: "\\f3b4"; }

.la-itunes-note:before {
  content: "\\f3b5"; }

.la-java:before {
  content: "\\f4e4"; }

.la-jedi:before {
  content: "\\f669"; }

.la-jedi-order:before {
  content: "\\f50e"; }

.la-jenkins:before {
  content: "\\f3b6"; }

.la-jira:before {
  content: "\\f7b1"; }

.la-joget:before {
  content: "\\f3b7"; }

.la-joint:before {
  content: "\\f595"; }

.la-joomla:before {
  content: "\\f1aa"; }

.la-journal-whills:before {
  content: "\\f66a"; }

.la-js:before {
  content: "\\f3b8"; }

.la-js-square:before {
  content: "\\f3b9"; }

.la-jsfiddle:before {
  content: "\\f1cc"; }

.la-kaaba:before {
  content: "\\f66b"; }

.la-kaggle:before {
  content: "\\f5fa"; }

.la-key:before {
  content: "\\f084"; }

.la-keybase:before {
  content: "\\f4f5"; }

.la-keyboard:before {
  content: "\\f11c"; }

.la-keycdn:before {
  content: "\\f3ba"; }

.la-khanda:before {
  content: "\\f66d"; }

.la-kickstarter:before {
  content: "\\f3bb"; }

.la-kickstarter-k:before {
  content: "\\f3bc"; }

.la-kiss:before {
  content: "\\f596"; }

.la-kiss-beam:before {
  content: "\\f597"; }

.la-kiss-wink-heart:before {
  content: "\\f598"; }

.la-kiwi-bird:before {
  content: "\\f535"; }

.la-korvue:before {
  content: "\\f42f"; }

.la-landmark:before {
  content: "\\f66f"; }

.la-language:before {
  content: "\\f1ab"; }

.la-laptop:before {
  content: "\\f109"; }

.la-laptop-code:before {
  content: "\\f5fc"; }

.la-laptop-medical:before {
  content: "\\f812"; }

.la-laravel:before {
  content: "\\f3bd"; }

.la-lastfm:before {
  content: "\\f202"; }

.la-lastfm-square:before {
  content: "\\f203"; }

.la-laugh:before {
  content: "\\f599"; }

.la-laugh-beam:before {
  content: "\\f59a"; }

.la-laugh-squint:before {
  content: "\\f59b"; }

.la-laugh-wink:before {
  content: "\\f59c"; }

.la-layer-group:before {
  content: "\\f5fd"; }

.la-leaf:before {
  content: "\\f06c"; }

.la-leanpub:before {
  content: "\\f212"; }

.la-lemon:before {
  content: "\\f094"; }

.la-less:before {
  content: "\\f41d"; }

.la-less-than:before {
  content: "\\f536"; }

.la-less-than-equal:before {
  content: "\\f537"; }

.la-level-down-alt:before {
  content: "\\f3be"; }

.la-level-up-alt:before {
  content: "\\f3bf"; }

.la-life-ring:before {
  content: "\\f1cd"; }

.la-lightbulb:before {
  content: "\\f0eb"; }

.la-line:before {
  content: "\\f3c0"; }

.la-link:before {
  content: "\\f0c1"; }

.la-linkedin:before {
  content: "\\f08c"; }

.la-linkedin-in:before {
  content: "\\f0e1"; }

.la-linode:before {
  content: "\\f2b8"; }

.la-linux:before {
  content: "\\f17c"; }

.la-lira-sign:before {
  content: "\\f195"; }

.la-list:before {
  content: "\\f03a"; }

.la-list-alt:before {
  content: "\\f022"; }

.la-list-ol:before {
  content: "\\f0cb"; }

.la-list-ul:before {
  content: "\\f0ca"; }

.la-location-arrow:before {
  content: "\\f124"; }

.la-lock:before {
  content: "\\f023"; }

.la-lock-open:before {
  content: "\\f3c1"; }

.la-long-arrow-alt-down:before {
  content: "\\f309"; }

.la-long-arrow-alt-left:before {
  content: "\\f30a"; }

.la-long-arrow-alt-right:before {
  content: "\\f30b"; }

.la-long-arrow-alt-up:before {
  content: "\\f30c"; }

.la-low-vision:before {
  content: "\\f2a8"; }

.la-luggage-cart:before {
  content: "\\f59d"; }

.la-lyft:before {
  content: "\\f3c3"; }

.la-magento:before {
  content: "\\f3c4"; }

.la-magic:before {
  content: "\\f0d0"; }

.la-magnet:before {
  content: "\\f076"; }

.la-mail-bulk:before {
  content: "\\f674"; }

.la-mailchimp:before {
  content: "\\f59e"; }

.la-male:before {
  content: "\\f183"; }

.la-mandalorian:before {
  content: "\\f50f"; }

.la-map:before {
  content: "\\f279"; }

.la-map-marked:before {
  content: "\\f59f"; }

.la-map-marked-alt:before {
  content: "\\f5a0"; }

.la-map-marker:before {
  content: "\\f041"; }

.la-map-marker-alt:before {
  content: "\\f3c5"; }

.la-map-pin:before {
  content: "\\f276"; }

.la-map-signs:before {
  content: "\\f277"; }

.la-markdown:before {
  content: "\\f60f"; }

.la-marker:before {
  content: "\\f5a1"; }

.la-mars:before {
  content: "\\f222"; }

.la-mars-double:before {
  content: "\\f227"; }

.la-mars-stroke:before {
  content: "\\f229"; }

.la-mars-stroke-h:before {
  content: "\\f22b"; }

.la-mars-stroke-v:before {
  content: "\\f22a"; }

.la-mask:before {
  content: "\\f6fa"; }

.la-mastodon:before {
  content: "\\f4f6"; }

.la-maxcdn:before {
  content: "\\f136"; }

.la-mdb:before {
  content: "\\f8ca"; }

.la-medal:before {
  content: "\\f5a2"; }

.la-medapps:before {
  content: "\\f3c6"; }

.la-medium:before {
  content: "\\f23a"; }

.la-medium-m:before {
  content: "\\f3c7"; }

.la-medkit:before {
  content: "\\f0fa"; }

.la-medrt:before {
  content: "\\f3c8"; }

.la-meetup:before {
  content: "\\f2e0"; }

.la-megaport:before {
  content: "\\f5a3"; }

.la-meh:before {
  content: "\\f11a"; }

.la-meh-blank:before {
  content: "\\f5a4"; }

.la-meh-rolling-eyes:before {
  content: "\\f5a5"; }

.la-memory:before {
  content: "\\f538"; }

.la-mendeley:before {
  content: "\\f7b3"; }

.la-menorah:before {
  content: "\\f676"; }

.la-mercury:before {
  content: "\\f223"; }

.la-meteor:before {
  content: "\\f753"; }

.la-microchip:before {
  content: "\\f2db"; }

.la-microphone:before {
  content: "\\f130"; }

.la-microphone-alt:before {
  content: "\\f3c9"; }

.la-microphone-alt-slash:before {
  content: "\\f539"; }

.la-microphone-slash:before {
  content: "\\f131"; }

.la-microscope:before {
  content: "\\f610"; }

.la-microsoft:before {
  content: "\\f3ca"; }

.la-minus:before {
  content: "\\f068"; }

.la-minus-circle:before {
  content: "\\f056"; }

.la-minus-square:before {
  content: "\\f146"; }

.la-mitten:before {
  content: "\\f7b5"; }

.la-mix:before {
  content: "\\f3cb"; }

.la-mixcloud:before {
  content: "\\f289"; }

.la-mizuni:before {
  content: "\\f3cc"; }

.la-mobile:before {
  content: "\\f10b"; }

.la-mobile-alt:before {
  content: "\\f3cd"; }

.la-modx:before {
  content: "\\f285"; }

.la-monero:before {
  content: "\\f3d0"; }

.la-money-bill:before {
  content: "\\f0d6"; }

.la-money-bill-alt:before {
  content: "\\f3d1"; }

.la-money-bill-wave:before {
  content: "\\f53a"; }

.la-money-bill-wave-alt:before {
  content: "\\f53b"; }

.la-money-check:before {
  content: "\\f53c"; }

.la-money-check-alt:before {
  content: "\\f53d"; }

.la-monument:before {
  content: "\\f5a6"; }

.la-moon:before {
  content: "\\f186"; }

.la-mortar-pestle:before {
  content: "\\f5a7"; }

.la-mosque:before {
  content: "\\f678"; }

.la-motorcycle:before {
  content: "\\f21c"; }

.la-mountain:before {
  content: "\\f6fc"; }

.la-mouse:before {
  content: "\\f8cc"; }

.la-mouse-pointer:before {
  content: "\\f245"; }

.la-mug-hot:before {
  content: "\\f7b6"; }

.la-music:before {
  content: "\\f001"; }

.la-napster:before {
  content: "\\f3d2"; }

.la-neos:before {
  content: "\\f612"; }

.la-network-wired:before {
  content: "\\f6ff"; }

.la-neuter:before {
  content: "\\f22c"; }

.la-newspaper:before {
  content: "\\f1ea"; }

.la-nimblr:before {
  content: "\\f5a8"; }

.la-node:before {
  content: "\\f419"; }

.la-node-js:before {
  content: "\\f3d3"; }

.la-not-equal:before {
  content: "\\f53e"; }

.la-notes-medical:before {
  content: "\\f481"; }

.la-npm:before {
  content: "\\f3d4"; }

.la-ns8:before {
  content: "\\f3d5"; }

.la-nutritionix:before {
  content: "\\f3d6"; }

.la-object-group:before {
  content: "\\f247"; }

.la-object-ungroup:before {
  content: "\\f248"; }

.la-odnoklassniki:before {
  content: "\\f263"; }

.la-odnoklassniki-square:before {
  content: "\\f264"; }

.la-oil-can:before {
  content: "\\f613"; }

.la-old-republic:before {
  content: "\\f510"; }

.la-om:before {
  content: "\\f679"; }

.la-opencart:before {
  content: "\\f23d"; }

.la-openid:before {
  content: "\\f19b"; }

.la-opera:before {
  content: "\\f26a"; }

.la-optin-monster:before {
  content: "\\f23c"; }

.la-orcid:before {
  content: "\\f8d2"; }

.la-osi:before {
  content: "\\f41a"; }

.la-otter:before {
  content: "\\f700"; }

.la-outdent:before {
  content: "\\f03b"; }

.la-page4:before {
  content: "\\f3d7"; }

.la-pagelines:before {
  content: "\\f18c"; }

.la-pager:before {
  content: "\\f815"; }

.la-paint-brush:before {
  content: "\\f1fc"; }

.la-paint-roller:before {
  content: "\\f5aa"; }

.la-palette:before {
  content: "\\f53f"; }

.la-palfed:before {
  content: "\\f3d8"; }

.la-pallet:before {
  content: "\\f482"; }

.la-paper-plane:before {
  content: "\\f1d8"; }

.la-paperclip:before {
  content: "\\f0c6"; }

.la-parachute-box:before {
  content: "\\f4cd"; }

.la-paragraph:before {
  content: "\\f1dd"; }

.la-parking:before {
  content: "\\f540"; }

.la-passport:before {
  content: "\\f5ab"; }

.la-pastafarianism:before {
  content: "\\f67b"; }

.la-paste:before {
  content: "\\f0ea"; }

.la-patreon:before {
  content: "\\f3d9"; }

.la-pause:before {
  content: "\\f04c"; }

.la-pause-circle:before {
  content: "\\f28b"; }

.la-paw:before {
  content: "\\f1b0"; }

.la-paypal:before {
  content: "\\f1ed"; }

.la-peace:before {
  content: "\\f67c"; }

.la-pen:before {
  content: "\\f304"; }

.la-pen-alt:before {
  content: "\\f305"; }

.la-pen-fancy:before {
  content: "\\f5ac"; }

.la-pen-nib:before {
  content: "\\f5ad"; }

.la-pen-square:before {
  content: "\\f14b"; }

.la-pencil-alt:before {
  content: "\\f303"; }

.la-pencil-ruler:before {
  content: "\\f5ae"; }

.la-penny-arcade:before {
  content: "\\f704"; }

.la-people-carry:before {
  content: "\\f4ce"; }

.la-pepper-hot:before {
  content: "\\f816"; }

.la-percent:before {
  content: "\\f295"; }

.la-percentage:before {
  content: "\\f541"; }

.la-periscope:before {
  content: "\\f3da"; }

.la-person-booth:before {
  content: "\\f756"; }

.la-phabricator:before {
  content: "\\f3db"; }

.la-phoenix-framework:before {
  content: "\\f3dc"; }

.la-phoenix-squadron:before {
  content: "\\f511"; }

.la-phone:before {
  content: "\\f095"; }

.la-phone-alt:before {
  content: "\\f879"; }

.la-phone-slash:before {
  content: "\\f3dd"; }

.la-phone-square:before {
  content: "\\f098"; }

.la-phone-square-alt:before {
  content: "\\f87b"; }

.la-phone-volume:before {
  content: "\\f2a0"; }

.la-photo-video:before {
  content: "\\f87c"; }

.la-php:before {
  content: "\\f457"; }

.la-pied-piper:before {
  content: "\\f2ae"; }

.la-pied-piper-alt:before {
  content: "\\f1a8"; }

.la-pied-piper-hat:before {
  content: "\\f4e5"; }

.la-pied-piper-pp:before {
  content: "\\f1a7"; }

.la-piggy-bank:before {
  content: "\\f4d3"; }

.la-pills:before {
  content: "\\f484"; }

.la-pinterest:before {
  content: "\\f0d2"; }

.la-pinterest-p:before {
  content: "\\f231"; }

.la-pinterest-square:before {
  content: "\\f0d3"; }

.la-pizza-slice:before {
  content: "\\f818"; }

.la-place-of-worship:before {
  content: "\\f67f"; }

.la-plane:before {
  content: "\\f072"; }

.la-plane-arrival:before {
  content: "\\f5af"; }

.la-plane-departure:before {
  content: "\\f5b0"; }

.la-play:before {
  content: "\\f04b"; }

.la-play-circle:before {
  content: "\\f144"; }

.la-playstation:before {
  content: "\\f3df"; }

.la-plug:before {
  content: "\\f1e6"; }

.la-plus:before {
  content: "\\f067"; }

.la-plus-circle:before {
  content: "\\f055"; }

.la-plus-square:before {
  content: "\\f0fe"; }

.la-podcast:before {
  content: "\\f2ce"; }

.la-poll:before {
  content: "\\f681"; }

.la-poll-h:before {
  content: "\\f682"; }

.la-poo:before {
  content: "\\f2fe"; }

.la-poo-storm:before {
  content: "\\f75a"; }

.la-poop:before {
  content: "\\f619"; }

.la-portrait:before {
  content: "\\f3e0"; }

.la-pound-sign:before {
  content: "\\f154"; }

.la-power-off:before {
  content: "\\f011"; }

.la-pray:before {
  content: "\\f683"; }

.la-praying-hands:before {
  content: "\\f684"; }

.la-prescription:before {
  content: "\\f5b1"; }

.la-prescription-bottle:before {
  content: "\\f485"; }

.la-prescription-bottle-alt:before {
  content: "\\f486"; }

.la-print:before {
  content: "\\f02f"; }

.la-procedures:before {
  content: "\\f487"; }

.la-product-hunt:before {
  content: "\\f288"; }

.la-project-diagram:before {
  content: "\\f542"; }

.la-pushed:before {
  content: "\\f3e1"; }

.la-puzzle-piece:before {
  content: "\\f12e"; }

.la-python:before {
  content: "\\f3e2"; }

.la-qq:before {
  content: "\\f1d6"; }

.la-qrcode:before {
  content: "\\f029"; }

.la-question:before {
  content: "\\f128"; }

.la-question-circle:before {
  content: "\\f059"; }

.la-quidditch:before {
  content: "\\f458"; }

.la-quinscape:before {
  content: "\\f459"; }

.la-quora:before {
  content: "\\f2c4"; }

.la-quote-left:before {
  content: "\\f10d"; }

.la-quote-right:before {
  content: "\\f10e"; }

.la-quran:before {
  content: "\\f687"; }

.la-r-project:before {
  content: "\\f4f7"; }

.la-radiation:before {
  content: "\\f7b9"; }

.la-radiation-alt:before {
  content: "\\f7ba"; }

.la-rainbow:before {
  content: "\\f75b"; }

.la-random:before {
  content: "\\f074"; }

.la-raspberry-pi:before {
  content: "\\f7bb"; }

.la-ravelry:before {
  content: "\\f2d9"; }

.la-react:before {
  content: "\\f41b"; }

.la-reacteurope:before {
  content: "\\f75d"; }

.la-readme:before {
  content: "\\f4d5"; }

.la-rebel:before {
  content: "\\f1d0"; }

.la-receipt:before {
  content: "\\f543"; }

.la-record-vinyl:before {
  content: "\\f8d9"; }

.la-recycle:before {
  content: "\\f1b8"; }

.la-red-river:before {
  content: "\\f3e3"; }

.la-reddit:before {
  content: "\\f1a1"; }

.la-reddit-alien:before {
  content: "\\f281"; }

.la-reddit-square:before {
  content: "\\f1a2"; }

.la-redhat:before {
  content: "\\f7bc"; }

.la-redo:before {
  content: "\\f01e"; }

.la-redo-alt:before {
  content: "\\f2f9"; }

.la-registered:before {
  content: "\\f25d"; }

.la-remove-format:before {
  content: "\\f87d"; }

.la-renren:before {
  content: "\\f18b"; }

.la-reply:before {
  content: "\\f3e5"; }

.la-reply-all:before {
  content: "\\f122"; }

.la-replyd:before {
  content: "\\f3e6"; }

.la-republican:before {
  content: "\\f75e"; }

.la-researchgate:before {
  content: "\\f4f8"; }

.la-resolving:before {
  content: "\\f3e7"; }

.la-restroom:before {
  content: "\\f7bd"; }

.la-retweet:before {
  content: "\\f079"; }

.la-rev:before {
  content: "\\f5b2"; }

.la-ribbon:before {
  content: "\\f4d6"; }

.la-ring:before {
  content: "\\f70b"; }

.la-road:before {
  content: "\\f018"; }

.la-robot:before {
  content: "\\f544"; }

.la-rocket:before {
  content: "\\f135"; }

.la-rocketchat:before {
  content: "\\f3e8"; }

.la-rockrms:before {
  content: "\\f3e9"; }

.la-route:before {
  content: "\\f4d7"; }

.la-rss:before {
  content: "\\f09e"; }

.la-rss-square:before {
  content: "\\f143"; }

.la-ruble-sign:before {
  content: "\\f158"; }

.la-ruler:before {
  content: "\\f545"; }

.la-ruler-combined:before {
  content: "\\f546"; }

.la-ruler-horizontal:before {
  content: "\\f547"; }

.la-ruler-vertical:before {
  content: "\\f548"; }

.la-running:before {
  content: "\\f70c"; }

.la-rupee-sign:before {
  content: "\\f156"; }

.la-sad-cry:before {
  content: "\\f5b3"; }

.la-sad-tear:before {
  content: "\\f5b4"; }

.la-safari:before {
  content: "\\f267"; }

.la-salesforce:before {
  content: "\\f83b"; }

.la-sass:before {
  content: "\\f41e"; }

.la-satellite:before {
  content: "\\f7bf"; }

.la-satellite-dish:before {
  content: "\\f7c0"; }

.la-save:before {
  content: "\\f0c7"; }

.la-schlix:before {
  content: "\\f3ea"; }

.la-school:before {
  content: "\\f549"; }

.la-screwdriver:before {
  content: "\\f54a"; }

.la-scribd:before {
  content: "\\f28a"; }

.la-scroll:before {
  content: "\\f70e"; }

.la-sd-card:before {
  content: "\\f7c2"; }

.la-search:before {
  content: "\\f002"; }

.la-search-dollar:before {
  content: "\\f688"; }

.la-search-location:before {
  content: "\\f689"; }

.la-search-minus:before {
  content: "\\f010"; }

.la-search-plus:before {
  content: "\\f00e"; }

.la-searchengin:before {
  content: "\\f3eb"; }

.la-seedling:before {
  content: "\\f4d8"; }

.la-sellcast:before {
  content: "\\f2da"; }

.la-sellsy:before {
  content: "\\f213"; }

.la-server:before {
  content: "\\f233"; }

.la-servicestack:before {
  content: "\\f3ec"; }

.la-shapes:before {
  content: "\\f61f"; }

.la-share:before {
  content: "\\f064"; }

.la-share-alt:before {
  content: "\\f1e0"; }

.la-share-alt-square:before {
  content: "\\f1e1"; }

.la-share-square:before {
  content: "\\f14d"; }

.la-shekel-sign:before {
  content: "\\f20b"; }

.la-shield-alt:before {
  content: "\\f3ed"; }

.la-ship:before {
  content: "\\f21a"; }

.la-shipping-fast:before {
  content: "\\f48b"; }

.la-shirtsinbulk:before {
  content: "\\f214"; }

.la-shoe-prints:before {
  content: "\\f54b"; }

.la-shopping-bag:before {
  content: "\\f290"; }

.la-shopping-basket:before {
  content: "\\f291"; }

.la-shopping-cart:before {
  content: "\\f07a"; }

.la-shopware:before {
  content: "\\f5b5"; }

.la-shower:before {
  content: "\\f2cc"; }

.la-shuttle-van:before {
  content: "\\f5b6"; }

.la-sign:before {
  content: "\\f4d9"; }

.la-sign-in-alt:before {
  content: "\\f2f6"; }

.la-sign-language:before {
  content: "\\f2a7"; }

.la-sign-out-alt:before {
  content: "\\f2f5"; }

.la-signal:before {
  content: "\\f012"; }

.la-signature:before {
  content: "\\f5b7"; }

.la-sim-card:before {
  content: "\\f7c4"; }

.la-simplybuilt:before {
  content: "\\f215"; }

.la-sistrix:before {
  content: "\\f3ee"; }

.la-sitemap:before {
  content: "\\f0e8"; }

.la-sith:before {
  content: "\\f512"; }

.la-skating:before {
  content: "\\f7c5"; }

.la-sketch:before {
  content: "\\f7c6"; }

.la-skiing:before {
  content: "\\f7c9"; }

.la-skiing-nordic:before {
  content: "\\f7ca"; }

.la-skull:before {
  content: "\\f54c"; }

.la-skull-crossbones:before {
  content: "\\f714"; }

.la-skyatlas:before {
  content: "\\f216"; }

.la-skype:before {
  content: "\\f17e"; }

.la-slack:before {
  content: "\\f198"; }

.la-slack-hash:before {
  content: "\\f3ef"; }

.la-slash:before {
  content: "\\f715"; }

.la-sleigh:before {
  content: "\\f7cc"; }

.la-sliders-h:before {
  content: "\\f1de"; }

.la-slideshare:before {
  content: "\\f1e7"; }

.la-smile:before {
  content: "\\f118"; }

.la-smile-beam:before {
  content: "\\f5b8"; }

.la-smile-wink:before {
  content: "\\f4da"; }

.la-smog:before {
  content: "\\f75f"; }

.la-smoking:before {
  content: "\\f48d"; }

.la-smoking-ban:before {
  content: "\\f54d"; }

.la-sms:before {
  content: "\\f7cd"; }

.la-snapchat:before {
  content: "\\f2ab"; }

.la-snapchat-ghost:before {
  content: "\\f2ac"; }

.la-snapchat-square:before {
  content: "\\f2ad"; }

.la-snowboarding:before {
  content: "\\f7ce"; }

.la-snowflake:before {
  content: "\\f2dc"; }

.la-snowman:before {
  content: "\\f7d0"; }

.la-snowplow:before {
  content: "\\f7d2"; }

.la-socks:before {
  content: "\\f696"; }

.la-solar-panel:before {
  content: "\\f5ba"; }

.la-sort:before {
  content: "\\f0dc"; }

.la-sort-alpha-down:before {
  content: "\\f15d"; }

.la-sort-alpha-down-alt:before {
  content: "\\f881"; }

.la-sort-alpha-up:before {
  content: "\\f15e"; }

.la-sort-alpha-up-alt:before {
  content: "\\f882"; }

.la-sort-amount-down:before {
  content: "\\f160"; }

.la-sort-amount-down-alt:before {
  content: "\\f884"; }

.la-sort-amount-up:before {
  content: "\\f161"; }

.la-sort-amount-up-alt:before {
  content: "\\f885"; }

.la-sort-down:before {
  content: "\\f0dd"; }

.la-sort-numeric-down:before {
  content: "\\f162"; }

.la-sort-numeric-down-alt:before {
  content: "\\f886"; }

.la-sort-numeric-up:before {
  content: "\\f163"; }

.la-sort-numeric-up-alt:before {
  content: "\\f887"; }

.la-sort-up:before {
  content: "\\f0de"; }

.la-soundcloud:before {
  content: "\\f1be"; }

.la-sourcetree:before {
  content: "\\f7d3"; }

.la-spa:before {
  content: "\\f5bb"; }

.la-space-shuttle:before {
  content: "\\f197"; }

.la-speakap:before {
  content: "\\f3f3"; }

.la-speaker-deck:before {
  content: "\\f83c"; }

.la-spell-check:before {
  content: "\\f891"; }

.la-spider:before {
  content: "\\f717"; }

.la-spinner:before {
  content: "\\f110"; }

.la-splotch:before {
  content: "\\f5bc"; }

.la-spotify:before {
  content: "\\f1bc"; }

.la-spray-can:before {
  content: "\\f5bd"; }

.la-square:before {
  content: "\\f0c8"; }

.la-square-full:before {
  content: "\\f45c"; }

.la-square-root-alt:before {
  content: "\\f698"; }

.la-squarespace:before {
  content: "\\f5be"; }

.la-stack-exchange:before {
  content: "\\f18d"; }

.la-stack-overflow:before {
  content: "\\f16c"; }

.la-stackpath:before {
  content: "\\f842"; }

.la-stamp:before {
  content: "\\f5bf"; }

.la-star:before {
  content: "\\f005"; }

.la-star-and-crescent:before {
  content: "\\f699"; }

.la-star-half:before {
  content: "\\f089"; }

.la-star-half-alt:before {
  content: "\\f5c0"; }

.la-star-of-david:before {
  content: "\\f69a"; }

.la-star-of-life:before {
  content: "\\f621"; }

.la-staylinked:before {
  content: "\\f3f5"; }

.la-steam:before {
  content: "\\f1b6"; }

.la-steam-square:before {
  content: "\\f1b7"; }

.la-steam-symbol:before {
  content: "\\f3f6"; }

.la-step-backward:before {
  content: "\\f048"; }

.la-step-forward:before {
  content: "\\f051"; }

.la-stethoscope:before {
  content: "\\f0f1"; }

.la-sticker-mule:before {
  content: "\\f3f7"; }

.la-sticky-note:before {
  content: "\\f249"; }

.la-stop:before {
  content: "\\f04d"; }

.la-stop-circle:before {
  content: "\\f28d"; }

.la-stopwatch:before {
  content: "\\f2f2"; }

.la-store:before {
  content: "\\f54e"; }

.la-store-alt:before {
  content: "\\f54f"; }

.la-strava:before {
  content: "\\f428"; }

.la-stream:before {
  content: "\\f550"; }

.la-street-view:before {
  content: "\\f21d"; }

.la-strikethrough:before {
  content: "\\f0cc"; }

.la-stripe:before {
  content: "\\f429"; }

.la-stripe-s:before {
  content: "\\f42a"; }

.la-stroopwafel:before {
  content: "\\f551"; }

.la-studiovinari:before {
  content: "\\f3f8"; }

.la-stumbleupon:before {
  content: "\\f1a4"; }

.la-stumbleupon-circle:before {
  content: "\\f1a3"; }

.la-subscript:before {
  content: "\\f12c"; }

.la-subway:before {
  content: "\\f239"; }

.la-suitcase:before {
  content: "\\f0f2"; }

.la-suitcase-rolling:before {
  content: "\\f5c1"; }

.la-sun:before {
  content: "\\f185"; }

.la-superpowers:before {
  content: "\\f2dd"; }

.la-superscript:before {
  content: "\\f12b"; }

.la-supple:before {
  content: "\\f3f9"; }

.la-surprise:before {
  content: "\\f5c2"; }

.la-suse:before {
  content: "\\f7d6"; }

.la-swatchbook:before {
  content: "\\f5c3"; }

.la-swift:before {
  content: "\\f8e1"; }

.la-swimmer:before {
  content: "\\f5c4"; }

.la-swimming-pool:before {
  content: "\\f5c5"; }

.la-symfony:before {
  content: "\\f83d"; }

.la-synagogue:before {
  content: "\\f69b"; }

.la-sync:before {
  content: "\\f021"; }

.la-sync-alt:before {
  content: "\\f2f1"; }

.la-syringe:before {
  content: "\\f48e"; }

.la-table:before {
  content: "\\f0ce"; }

.la-table-tennis:before {
  content: "\\f45d"; }

.la-tablet:before {
  content: "\\f10a"; }

.la-tablet-alt:before {
  content: "\\f3fa"; }

.la-tablets:before {
  content: "\\f490"; }

.la-tachometer-alt:before {
  content: "\\f3fd"; }

.la-tag:before {
  content: "\\f02b"; }

.la-tags:before {
  content: "\\f02c"; }

.la-tape:before {
  content: "\\f4db"; }

.la-tasks:before {
  content: "\\f0ae"; }

.la-taxi:before {
  content: "\\f1ba"; }

.la-teamspeak:before {
  content: "\\f4f9"; }

.la-teeth:before {
  content: "\\f62e"; }

.la-teeth-open:before {
  content: "\\f62f"; }

.la-telegram:before {
  content: "\\f2c6"; }

.la-telegram-plane:before {
  content: "\\f3fe"; }

.la-temperature-high:before {
  content: "\\f769"; }

.la-temperature-low:before {
  content: "\\f76b"; }

.la-tencent-weibo:before {
  content: "\\f1d5"; }

.la-tenge:before {
  content: "\\f7d7"; }

.la-terminal:before {
  content: "\\f120"; }

.la-text-height:before {
  content: "\\f034"; }

.la-text-width:before {
  content: "\\f035"; }

.la-th:before {
  content: "\\f00a"; }

.la-th-large:before {
  content: "\\f009"; }

.la-th-list:before {
  content: "\\f00b"; }

.la-the-red-yeti:before {
  content: "\\f69d"; }

.la-theater-masks:before {
  content: "\\f630"; }

.la-themeco:before {
  content: "\\f5c6"; }

.la-themeisle:before {
  content: "\\f2b2"; }

.la-thermometer:before {
  content: "\\f491"; }

.la-thermometer-empty:before {
  content: "\\f2cb"; }

.la-thermometer-full:before {
  content: "\\f2c7"; }

.la-thermometer-half:before {
  content: "\\f2c9"; }

.la-thermometer-quarter:before {
  content: "\\f2ca"; }

.la-thermometer-three-quarters:before {
  content: "\\f2c8"; }

.la-think-peaks:before {
  content: "\\f731"; }

.la-thumbs-down:before {
  content: "\\f165"; }

.la-thumbs-up:before {
  content: "\\f164"; }

.la-thumbtack:before {
  content: "\\f08d"; }

.la-ticket-alt:before {
  content: "\\f3ff"; }

.la-times:before {
  content: "\\f00d"; }

.la-times-circle:before {
  content: "\\f057"; }

.la-tint:before {
  content: "\\f043"; }

.la-tint-slash:before {
  content: "\\f5c7"; }

.la-tired:before {
  content: "\\f5c8"; }

.la-toggle-off:before {
  content: "\\f204"; }

.la-toggle-on:before {
  content: "\\f205"; }

.la-toilet:before {
  content: "\\f7d8"; }

.la-toilet-paper:before {
  content: "\\f71e"; }

.la-toolbox:before {
  content: "\\f552"; }

.la-tools:before {
  content: "\\f7d9"; }

.la-tooth:before {
  content: "\\f5c9"; }

.la-torah:before {
  content: "\\f6a0"; }

.la-torii-gate:before {
  content: "\\f6a1"; }

.la-tractor:before {
  content: "\\f722"; }

.la-trade-federation:before {
  content: "\\f513"; }

.la-trademark:before {
  content: "\\f25c"; }

.la-traffic-light:before {
  content: "\\f637"; }

.la-train:before {
  content: "\\f238"; }

.la-tram:before {
  content: "\\f7da"; }

.la-transgender:before {
  content: "\\f224"; }

.la-transgender-alt:before {
  content: "\\f225"; }

.la-trash:before {
  content: "\\f1f8"; }

.la-trash-alt:before {
  content: "\\f2ed"; }

.la-trash-restore:before {
  content: "\\f829"; }

.la-trash-restore-alt:before {
  content: "\\f82a"; }

.la-tree:before {
  content: "\\f1bb"; }

.la-trello:before {
  content: "\\f181"; }

.la-tripadvisor:before {
  content: "\\f262"; }

.la-trophy:before {
  content: "\\f091"; }

.la-truck:before {
  content: "\\f0d1"; }

.la-truck-loading:before {
  content: "\\f4de"; }

.la-truck-monster:before {
  content: "\\f63b"; }

.la-truck-moving:before {
  content: "\\f4df"; }

.la-truck-pickup:before {
  content: "\\f63c"; }

.la-tshirt:before {
  content: "\\f553"; }

.la-tty:before {
  content: "\\f1e4"; }

.la-tumblr:before {
  content: "\\f173"; }

.la-tumblr-square:before {
  content: "\\f174"; }

.la-tv:before {
  content: "\\f26c"; }

.la-twitch:before {
  content: "\\f1e8"; }

.la-twitter:before {
  content: "\\f099"; }

.la-twitter-square:before {
  content: "\\f081"; }

.la-typo3:before {
  content: "\\f42b"; }

.la-uber:before {
  content: "\\f402"; }

.la-ubuntu:before {
  content: "\\f7df"; }

.la-uikit:before {
  content: "\\f403"; }

.la-umbraco:before {
  content: "\\f8e8"; }

.la-umbrella:before {
  content: "\\f0e9"; }

.la-umbrella-beach:before {
  content: "\\f5ca"; }

.la-underline:before {
  content: "\\f0cd"; }

.la-undo:before {
  content: "\\f0e2"; }

.la-undo-alt:before {
  content: "\\f2ea"; }

.la-uniregistry:before {
  content: "\\f404"; }

.la-universal-access:before {
  content: "\\f29a"; }

.la-university:before {
  content: "\\f19c"; }

.la-unlink:before {
  content: "\\f127"; }

.la-unlock:before {
  content: "\\f09c"; }

.la-unlock-alt:before {
  content: "\\f13e"; }

.la-untappd:before {
  content: "\\f405"; }

.la-upload:before {
  content: "\\f093"; }

.la-ups:before {
  content: "\\f7e0"; }

.la-usb:before {
  content: "\\f287"; }

.la-user:before {
  content: "\\f007"; }

.la-user-alt:before {
  content: "\\f406"; }

.la-user-alt-slash:before {
  content: "\\f4fa"; }

.la-user-astronaut:before {
  content: "\\f4fb"; }

.la-user-check:before {
  content: "\\f4fc"; }

.la-user-circle:before {
  content: "\\f2bd"; }

.la-user-clock:before {
  content: "\\f4fd"; }

.la-user-cog:before {
  content: "\\f4fe"; }

.la-user-edit:before {
  content: "\\f4ff"; }

.la-user-friends:before {
  content: "\\f500"; }

.la-user-graduate:before {
  content: "\\f501"; }

.la-user-injured:before {
  content: "\\f728"; }

.la-user-lock:before {
  content: "\\f502"; }

.la-user-md:before {
  content: "\\f0f0"; }

.la-user-minus:before {
  content: "\\f503"; }

.la-user-ninja:before {
  content: "\\f504"; }

.la-user-nurse:before {
  content: "\\f82f"; }

.la-user-plus:before {
  content: "\\f234"; }

.la-user-secret:before {
  content: "\\f21b"; }

.la-user-shield:before {
  content: "\\f505"; }

.la-user-slash:before {
  content: "\\f506"; }

.la-user-tag:before {
  content: "\\f507"; }

.la-user-tie:before {
  content: "\\f508"; }

.la-user-times:before {
  content: "\\f235"; }

.la-users:before {
  content: "\\f0c0"; }

.la-users-cog:before {
  content: "\\f509"; }

.la-usps:before {
  content: "\\f7e1"; }

.la-ussunnah:before {
  content: "\\f407"; }

.la-utensil-spoon:before {
  content: "\\f2e5"; }

.la-utensils:before {
  content: "\\f2e7"; }

.la-vaadin:before {
  content: "\\f408"; }

.la-vector-square:before {
  content: "\\f5cb"; }

.la-venus:before {
  content: "\\f221"; }

.la-venus-double:before {
  content: "\\f226"; }

.la-venus-mars:before {
  content: "\\f228"; }

.la-viacoin:before {
  content: "\\f237"; }

.la-viadeo:before {
  content: "\\f2a9"; }

.la-viadeo-square:before {
  content: "\\f2aa"; }

.la-vial:before {
  content: "\\f492"; }

.la-vials:before {
  content: "\\f493"; }

.la-viber:before {
  content: "\\f409"; }

.la-video:before {
  content: "\\f03d"; }

.la-video-slash:before {
  content: "\\f4e2"; }

.la-vihara:before {
  content: "\\f6a7"; }

.la-vimeo:before {
  content: "\\f40a"; }

.la-vimeo-square:before {
  content: "\\f194"; }

.la-vimeo-v:before {
  content: "\\f27d"; }

.la-vine:before {
  content: "\\f1ca"; }

.la-vk:before {
  content: "\\f189"; }

.la-vnv:before {
  content: "\\f40b"; }

.la-voicemail:before {
  content: "\\f897"; }

.la-volleyball-ball:before {
  content: "\\f45f"; }

.la-volume-down:before {
  content: "\\f027"; }

.la-volume-mute:before {
  content: "\\f6a9"; }

.la-volume-off:before {
  content: "\\f026"; }

.la-volume-up:before {
  content: "\\f028"; }

.la-vote-yea:before {
  content: "\\f772"; }

.la-vr-cardboard:before {
  content: "\\f729"; }

.la-vuejs:before {
  content: "\\f41f"; }

.la-walking:before {
  content: "\\f554"; }

.la-wallet:before {
  content: "\\f555"; }

.la-warehouse:before {
  content: "\\f494"; }

.la-water:before {
  content: "\\f773"; }

.la-wave-square:before {
  content: "\\f83e"; }

.la-waze:before {
  content: "\\f83f"; }

.la-weebly:before {
  content: "\\f5cc"; }

.la-weibo:before {
  content: "\\f18a"; }

.la-weight:before {
  content: "\\f496"; }

.la-weight-hanging:before {
  content: "\\f5cd"; }

.la-weixin:before {
  content: "\\f1d7"; }

.la-whatsapp:before {
  content: "\\f232"; }

.la-whatsapp-square:before {
  content: "\\f40c"; }

.la-wheelchair:before {
  content: "\\f193"; }

.la-whmcs:before {
  content: "\\f40d"; }

.la-wifi:before {
  content: "\\f1eb"; }

.la-wikipedia-w:before {
  content: "\\f266"; }

.la-wind:before {
  content: "\\f72e"; }

.la-window-close:before {
  content: "\\f410"; }

.la-window-maximize:before {
  content: "\\f2d0"; }

.la-window-minimize:before {
  content: "\\f2d1"; }

.la-window-restore:before {
  content: "\\f2d2"; }

.la-windows:before {
  content: "\\f17a"; }

.la-wine-bottle:before {
  content: "\\f72f"; }

.la-wine-glass:before {
  content: "\\f4e3"; }

.la-wine-glass-alt:before {
  content: "\\f5ce"; }

.la-wix:before {
  content: "\\f5cf"; }

.la-wizards-of-the-coast:before {
  content: "\\f730"; }

.la-wolf-pack-battalion:before {
  content: "\\f514"; }

.la-won-sign:before {
  content: "\\f159"; }

.la-wordpress:before {
  content: "\\f19a"; }

.la-wordpress-simple:before {
  content: "\\f411"; }

.la-wpbeginner:before {
  content: "\\f297"; }

.la-wpexplorer:before {
  content: "\\f2de"; }

.la-wpforms:before {
  content: "\\f298"; }

.la-wpressr:before {
  content: "\\f3e4"; }

.la-wrench:before {
  content: "\\f0ad"; }

.la-x-ray:before {
  content: "\\f497"; }

.la-xbox:before {
  content: "\\f412"; }

.la-xing:before {
  content: "\\f168"; }

.la-xing-square:before {
  content: "\\f169"; }

.la-y-combinator:before {
  content: "\\f23b"; }

.la-yahoo:before {
  content: "\\f19e"; }

.la-yammer:before {
  content: "\\f840"; }

.la-yandex:before {
  content: "\\f413"; }

.la-yandex-international:before {
  content: "\\f414"; }

.la-yarn:before {
  content: "\\f7e3"; }

.la-yelp:before {
  content: "\\f1e9"; }

.la-yen-sign:before {
  content: "\\f157"; }

.la-yin-yang:before {
  content: "\\f6ad"; }

.la-yoast:before {
  content: "\\f2b1"; }

.la-youtube:before {
  content: "\\f167"; }

.la-youtube-square:before {
  content: "\\f431"; }

.la-zhihu:before {
  content: "\\f63f"; }

.sr-only {
  border: 0;
  clip: rect(0, 0, 0, 0);
  height: 1px;
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
  width: 1px; }

.sr-only-focusable:active, .sr-only-focusable:focus {
  clip: auto;
  height: auto;
  margin: 0;
  overflow: visible;
  position: static;
  width: auto; }

@font-face {
  font-family: 'Line Awesome Brands';
  font-style: normal;
  font-weight: normal;
  font-display: auto;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_10___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_14___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_15___}) format("svg"); }

.lab {
  font-family: 'Line Awesome Brands'; }

@font-face {
  font-family: 'Line Awesome Free';
  font-style: normal;
  font-weight: 400;
  font-display: auto;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_16___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_17___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_18___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_19___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_20___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_21___}) format("svg"); }

.lar {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

@font-face {
  font-family: 'Line Awesome Free';
  font-style: normal;
  font-weight: 900;
  font-display: auto;
  src: url(${___CSS_LOADER_URL_REPLACEMENT_22___});
  src: url(${___CSS_LOADER_URL_REPLACEMENT_23___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_24___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_25___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_26___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_27___}) format("svg"); }

.la,
.las {
  font-family: 'Line Awesome Free';
  font-weight: 900; }

.la.la-glass:before {
  content: "\\f000"; }

.la.la-meetup {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-star-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-star-o:before {
  content: "\\f005"; }

.la.la-remove:before {
  content: "\\f00d"; }

.la.la-close:before {
  content: "\\f00d"; }

.la.la-gear:before {
  content: "\\f013"; }

.la.la-trash-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-trash-o:before {
  content: "\\f2ed"; }

.la.la-file-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-file-o:before {
  content: "\\f15b"; }

.la.la-clock-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-clock-o:before {
  content: "\\f017"; }

.la.la-arrow-circle-o-down {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-arrow-circle-o-down:before {
  content: "\\f358"; }

.la.la-arrow-circle-o-up {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-arrow-circle-o-up:before {
  content: "\\f35b"; }

.la.la-play-circle-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-play-circle-o:before {
  content: "\\f144"; }

.la.la-repeat:before {
  content: "\\f01e"; }

.la.la-rotate-right:before {
  content: "\\f01e"; }

.la.la-refresh:before {
  content: "\\f021"; }

.la.la-list-alt {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-dedent:before {
  content: "\\f03b"; }

.la.la-video-camera:before {
  content: "\\f03d"; }

.la.la-picture-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-picture-o:before {
  content: "\\f03e"; }

.la.la-photo {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-photo:before {
  content: "\\f03e"; }

.la.la-image {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-image:before {
  content: "\\f03e"; }

.la.la-pencil:before {
  content: "\\f303"; }

.la.la-map-marker:before {
  content: "\\f3c5"; }

.la.la-pencil-square-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-pencil-square-o:before {
  content: "\\f044"; }

.la.la-share-square-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-share-square-o:before {
  content: "\\f14d"; }

.la.la-check-square-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-check-square-o:before {
  content: "\\f14a"; }

.la.la-arrows:before {
  content: "\\f0b2"; }

.la.la-times-circle-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-times-circle-o:before {
  content: "\\f057"; }

.la.la-check-circle-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-check-circle-o:before {
  content: "\\f058"; }

.la.la-mail-forward:before {
  content: "\\f064"; }

.la.la-eye {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-eye-slash {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-warning:before {
  content: "\\f071"; }

.la.la-calendar:before {
  content: "\\f073"; }

.la.la-arrows-v:before {
  content: "\\f338"; }

.la.la-arrows-h:before {
  content: "\\f337"; }

.la.la-bar-chart {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-bar-chart:before {
  content: "\\f080"; }

.la.la-bar-chart-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-bar-chart-o:before {
  content: "\\f080"; }

.la.la-twitter-square {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-facebook-square {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-gears:before {
  content: "\\f085"; }

.la.la-thumbs-o-up {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-thumbs-o-up:before {
  content: "\\f164"; }

.la.la-thumbs-o-down {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-thumbs-o-down:before {
  content: "\\f165"; }

.la.la-heart-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-heart-o:before {
  content: "\\f004"; }

.la.la-sign-out:before {
  content: "\\f2f5"; }

.la.la-linkedin-square {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-linkedin-square:before {
  content: "\\f08c"; }

.la.la-thumb-tack:before {
  content: "\\f08d"; }

.la.la-external-link:before {
  content: "\\f35d"; }

.la.la-sign-in:before {
  content: "\\f2f6"; }

.la.la-github-square {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-lemon-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-lemon-o:before {
  content: "\\f094"; }

.la.la-square-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-square-o:before {
  content: "\\f0c8"; }

.la.la-bookmark-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-bookmark-o:before {
  content: "\\f02e"; }

.la.la-twitter {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-facebook {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-facebook:before {
  content: "\\f39e"; }

.la.la-facebook-f {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-facebook-f:before {
  content: "\\f39e"; }

.la.la-github {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-credit-card {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-feed:before {
  content: "\\f09e"; }

.la.la-hdd-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-hdd-o:before {
  content: "\\f0a0"; }

.la.la-hand-o-right {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-hand-o-right:before {
  content: "\\f0a4"; }

.la.la-hand-o-left {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-hand-o-left:before {
  content: "\\f0a5"; }

.la.la-hand-o-up {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-hand-o-up:before {
  content: "\\f0a6"; }

.la.la-hand-o-down {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-hand-o-down:before {
  content: "\\f0a7"; }

.la.la-arrows-alt:before {
  content: "\\f31e"; }

.la.la-group:before {
  content: "\\f0c0"; }

.la.la-chain:before {
  content: "\\f0c1"; }

.la.la-scissors:before {
  content: "\\f0c4"; }

.la.la-files-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-files-o:before {
  content: "\\f0c5"; }

.la.la-floppy-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-floppy-o:before {
  content: "\\f0c7"; }

.la.la-navicon:before {
  content: "\\f0c9"; }

.la.la-reorder:before {
  content: "\\f0c9"; }

.la.la-pinterest {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-pinterest-square {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-google-plus-square {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-google-plus {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-google-plus:before {
  content: "\\f0d5"; }

.la.la-money {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-money:before {
  content: "\\f3d1"; }

.la.la-unsorted:before {
  content: "\\f0dc"; }

.la.la-sort-desc:before {
  content: "\\f0dd"; }

.la.la-sort-asc:before {
  content: "\\f0de"; }

.la.la-linkedin {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-linkedin:before {
  content: "\\f0e1"; }

.la.la-rotate-left:before {
  content: "\\f0e2"; }

.la.la-legal:before {
  content: "\\f0e3"; }

.la.la-tachometer:before {
  content: "\\f3fd"; }

.la.la-dashboard:before {
  content: "\\f3fd"; }

.la.la-comment-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-comment-o:before {
  content: "\\f075"; }

.la.la-comments-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-comments-o:before {
  content: "\\f086"; }

.la.la-flash:before {
  content: "\\f0e7"; }

.la.la-clipboard {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-paste {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-paste:before {
  content: "\\f328"; }

.la.la-lightbulb-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-lightbulb-o:before {
  content: "\\f0eb"; }

.la.la-exchange:before {
  content: "\\f362"; }

.la.la-cloud-download:before {
  content: "\\f381"; }

.la.la-cloud-upload:before {
  content: "\\f382"; }

.la.la-bell-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-bell-o:before {
  content: "\\f0f3"; }

.la.la-cutlery:before {
  content: "\\f2e7"; }

.la.la-file-text-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-file-text-o:before {
  content: "\\f15c"; }

.la.la-building-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-building-o:before {
  content: "\\f1ad"; }

.la.la-hospital-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-hospital-o:before {
  content: "\\f0f8"; }

.la.la-tablet:before {
  content: "\\f3fa"; }

.la.la-mobile:before {
  content: "\\f3cd"; }

.la.la-mobile-phone:before {
  content: "\\f3cd"; }

.la.la-circle-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-circle-o:before {
  content: "\\f111"; }

.la.la-mail-reply:before {
  content: "\\f3e5"; }

.la.la-github-alt {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-folder-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-folder-o:before {
  content: "\\f07b"; }

.la.la-folder-open-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-folder-open-o:before {
  content: "\\f07c"; }

.la.la-smile-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-smile-o:before {
  content: "\\f118"; }

.la.la-frown-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-frown-o:before {
  content: "\\f119"; }

.la.la-meh-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-meh-o:before {
  content: "\\f11a"; }

.la.la-keyboard-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-keyboard-o:before {
  content: "\\f11c"; }

.la.la-flag-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-flag-o:before {
  content: "\\f024"; }

.la.la-mail-reply-all:before {
  content: "\\f122"; }

.la.la-star-half-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-star-half-o:before {
  content: "\\f089"; }

.la.la-star-half-empty {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-star-half-empty:before {
  content: "\\f089"; }

.la.la-star-half-full {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-star-half-full:before {
  content: "\\f089"; }

.la.la-code-fork:before {
  content: "\\f126"; }

.la.la-chain-broken:before {
  content: "\\f127"; }

.la.la-shield:before {
  content: "\\f3ed"; }

.la.la-calendar-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-calendar-o:before {
  content: "\\f133"; }

.la.la-maxcdn {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-html5 {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-css3 {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-ticket:before {
  content: "\\f3ff"; }

.la.la-minus-square-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-minus-square-o:before {
  content: "\\f146"; }

.la.la-level-up:before {
  content: "\\f3bf"; }

.la.la-level-down:before {
  content: "\\f3be"; }

.la.la-pencil-square:before {
  content: "\\f14b"; }

.la.la-external-link-square:before {
  content: "\\f360"; }

.la.la-compass {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-caret-square-o-down {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-caret-square-o-down:before {
  content: "\\f150"; }

.la.la-toggle-down {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-toggle-down:before {
  content: "\\f150"; }

.la.la-caret-square-o-up {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-caret-square-o-up:before {
  content: "\\f151"; }

.la.la-toggle-up {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-toggle-up:before {
  content: "\\f151"; }

.la.la-caret-square-o-right {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-caret-square-o-right:before {
  content: "\\f152"; }

.la.la-toggle-right {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-toggle-right:before {
  content: "\\f152"; }

.la.la-eur:before {
  content: "\\f153"; }

.la.la-euro:before {
  content: "\\f153"; }

.la.la-gbp:before {
  content: "\\f154"; }

.la.la-usd:before {
  content: "\\f155"; }

.la.la-dollar:before {
  content: "\\f155"; }

.la.la-inr:before {
  content: "\\f156"; }

.la.la-rupee:before {
  content: "\\f156"; }

.la.la-jpy:before {
  content: "\\f157"; }

.la.la-cny:before {
  content: "\\f157"; }

.la.la-rmb:before {
  content: "\\f157"; }

.la.la-yen:before {
  content: "\\f157"; }

.la.la-rub:before {
  content: "\\f158"; }

.la.la-ruble:before {
  content: "\\f158"; }

.la.la-rouble:before {
  content: "\\f158"; }

.la.la-krw:before {
  content: "\\f159"; }

.la.la-won:before {
  content: "\\f159"; }

.la.la-btc {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-bitcoin {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-bitcoin:before {
  content: "\\f15a"; }

.la.la-file-text:before {
  content: "\\f15c"; }

.la.la-sort-alpha-asc:before {
  content: "\\f15d"; }

.la.la-sort-alpha-desc:before {
  content: "\\f881"; }

.la.la-sort-amount-asc:before {
  content: "\\f160"; }

.la.la-sort-amount-desc:before {
  content: "\\f884"; }

.la.la-sort-numeric-asc:before {
  content: "\\f162"; }

.la.la-sort-numeric-desc:before {
  content: "\\f886"; }

.la.la-youtube-square {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-youtube {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-xing {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-xing-square {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-youtube-play {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-youtube-play:before {
  content: "\\f167"; }

.la.la-dropbox {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-stack-overflow {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-instagram {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-flickr {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-adn {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-bitbucket {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-bitbucket-square {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-bitbucket-square:before {
  content: "\\f171"; }

.la.la-tumblr {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-tumblr-square {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-long-arrow-down:before {
  content: "\\f309"; }

.la.la-long-arrow-up:before {
  content: "\\f30c"; }

.la.la-long-arrow-left:before {
  content: "\\f30a"; }

.la.la-long-arrow-right:before {
  content: "\\f30b"; }

.la.la-apple {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-windows {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-android {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-linux {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-dribbble {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-skype {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-foursquare {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-trello {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-gratipay {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-gittip {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-gittip:before {
  content: "\\f184"; }

.la.la-sun-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-sun-o:before {
  content: "\\f185"; }

.la.la-moon-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-moon-o:before {
  content: "\\f186"; }

.la.la-vk {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-weibo {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-renren {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-pagelines {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-stack-exchange {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-arrow-circle-o-right {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-arrow-circle-o-right:before {
  content: "\\f35a"; }

.la.la-arrow-circle-o-left {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-arrow-circle-o-left:before {
  content: "\\f359"; }

.la.la-caret-square-o-left {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-caret-square-o-left:before {
  content: "\\f191"; }

.la.la-toggle-left {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-toggle-left:before {
  content: "\\f191"; }

.la.la-dot-circle-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-dot-circle-o:before {
  content: "\\f192"; }

.la.la-vimeo-square {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-try:before {
  content: "\\f195"; }

.la.la-turkish-lira:before {
  content: "\\f195"; }

.la.la-plus-square-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-plus-square-o:before {
  content: "\\f0fe"; }

.la.la-slack {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-wordpress {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-openid {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-institution:before {
  content: "\\f19c"; }

.la.la-bank:before {
  content: "\\f19c"; }

.la.la-mortar-board:before {
  content: "\\f19d"; }

.la.la-yahoo {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-google {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-reddit {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-reddit-square {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-stumbleupon-circle {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-stumbleupon {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-delicious {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-digg {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-pied-piper-pp {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-pied-piper-alt {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-drupal {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-joomla {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-spoon:before {
  content: "\\f2e5"; }

.la.la-behance {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-behance-square {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-steam {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-steam-square {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-automobile:before {
  content: "\\f1b9"; }

.la.la-cab:before {
  content: "\\f1ba"; }

.la.la-envelope-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-envelope-o:before {
  content: "\\f0e0"; }

.la.la-deviantart {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-soundcloud {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-file-pdf-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-file-pdf-o:before {
  content: "\\f1c1"; }

.la.la-file-word-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-file-word-o:before {
  content: "\\f1c2"; }

.la.la-file-excel-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-file-excel-o:before {
  content: "\\f1c3"; }

.la.la-file-powerpoint-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-file-powerpoint-o:before {
  content: "\\f1c4"; }

.la.la-file-image-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-file-image-o:before {
  content: "\\f1c5"; }

.la.la-file-photo-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-file-photo-o:before {
  content: "\\f1c5"; }

.la.la-file-picture-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-file-picture-o:before {
  content: "\\f1c5"; }

.la.la-file-archive-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-file-archive-o:before {
  content: "\\f1c6"; }

.la.la-file-zip-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-file-zip-o:before {
  content: "\\f1c6"; }

.la.la-file-audio-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-file-audio-o:before {
  content: "\\f1c7"; }

.la.la-file-sound-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-file-sound-o:before {
  content: "\\f1c7"; }

.la.la-file-video-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-file-video-o:before {
  content: "\\f1c8"; }

.la.la-file-movie-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-file-movie-o:before {
  content: "\\f1c8"; }

.la.la-file-code-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-file-code-o:before {
  content: "\\f1c9"; }

.la.la-vine {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-codepen {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-jsfiddle {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-life-ring {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-life-bouy {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-life-bouy:before {
  content: "\\f1cd"; }

.la.la-life-buoy {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-life-buoy:before {
  content: "\\f1cd"; }

.la.la-life-saver {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-life-saver:before {
  content: "\\f1cd"; }

.la.la-support {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-support:before {
  content: "\\f1cd"; }

.la.la-circle-o-notch:before {
  content: "\\f1ce"; }

.la.la-rebel {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-ra {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-ra:before {
  content: "\\f1d0"; }

.la.la-resistance {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-resistance:before {
  content: "\\f1d0"; }

.la.la-empire {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-ge {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-ge:before {
  content: "\\f1d1"; }

.la.la-git-square {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-git {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-hacker-news {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-y-combinator-square {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-y-combinator-square:before {
  content: "\\f1d4"; }

.la.la-yc-square {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-yc-square:before {
  content: "\\f1d4"; }

.la.la-tencent-weibo {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-qq {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-weixin {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-wechat {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-wechat:before {
  content: "\\f1d7"; }

.la.la-send:before {
  content: "\\f1d8"; }

.la.la-paper-plane-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-paper-plane-o:before {
  content: "\\f1d8"; }

.la.la-send-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-send-o:before {
  content: "\\f1d8"; }

.la.la-circle-thin {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-circle-thin:before {
  content: "\\f111"; }

.la.la-header:before {
  content: "\\f1dc"; }

.la.la-sliders:before {
  content: "\\f1de"; }

.la.la-futbol-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-futbol-o:before {
  content: "\\f1e3"; }

.la.la-soccer-ball-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-soccer-ball-o:before {
  content: "\\f1e3"; }

.la.la-slideshare {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-twitch {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-yelp {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-newspaper-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-newspaper-o:before {
  content: "\\f1ea"; }

.la.la-paypal {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-google-wallet {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-cc-visa {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-cc-mastercard {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-cc-discover {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-cc-amex {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-cc-paypal {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-cc-stripe {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-bell-slash-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-bell-slash-o:before {
  content: "\\f1f6"; }

.la.la-trash:before {
  content: "\\f2ed"; }

.la.la-copyright {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-eyedropper:before {
  content: "\\f1fb"; }

.la.la-area-chart:before {
  content: "\\f1fe"; }

.la.la-pie-chart:before {
  content: "\\f200"; }

.la.la-line-chart:before {
  content: "\\f201"; }

.la.la-lastfm {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-lastfm-square {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-ioxhost {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-angellist {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-cc {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-cc:before {
  content: "\\f20a"; }

.la.la-ils:before {
  content: "\\f20b"; }

.la.la-shekel:before {
  content: "\\f20b"; }

.la.la-sheqel:before {
  content: "\\f20b"; }

.la.la-meanpath {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-meanpath:before {
  content: "\\f2b4"; }

.la.la-buysellads {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-connectdevelop {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-dashcube {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-forumbee {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-leanpub {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-sellsy {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-shirtsinbulk {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-simplybuilt {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-skyatlas {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-diamond {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-diamond:before {
  content: "\\f3a5"; }

.la.la-intersex:before {
  content: "\\f224"; }

.la.la-facebook-official {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-facebook-official:before {
  content: "\\f09a"; }

.la.la-pinterest-p {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-whatsapp {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-hotel:before {
  content: "\\f236"; }

.la.la-viacoin {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-medium {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-y-combinator {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-yc {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-yc:before {
  content: "\\f23b"; }

.la.la-optin-monster {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-opencart {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-expeditedssl {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-battery-4:before {
  content: "\\f240"; }

.la.la-battery:before {
  content: "\\f240"; }

.la.la-battery-3:before {
  content: "\\f241"; }

.la.la-battery-2:before {
  content: "\\f242"; }

.la.la-battery-1:before {
  content: "\\f243"; }

.la.la-battery-0:before {
  content: "\\f244"; }

.la.la-object-group {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-object-ungroup {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-sticky-note-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-sticky-note-o:before {
  content: "\\f249"; }

.la.la-cc-jcb {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-cc-diners-club {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-clone {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-hourglass-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-hourglass-o:before {
  content: "\\f254"; }

.la.la-hourglass-1:before {
  content: "\\f251"; }

.la.la-hourglass-2:before {
  content: "\\f252"; }

.la.la-hourglass-3:before {
  content: "\\f253"; }

.la.la-hand-rock-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-hand-rock-o:before {
  content: "\\f255"; }

.la.la-hand-grab-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-hand-grab-o:before {
  content: "\\f255"; }

.la.la-hand-paper-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-hand-paper-o:before {
  content: "\\f256"; }

.la.la-hand-stop-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-hand-stop-o:before {
  content: "\\f256"; }

.la.la-hand-scissors-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-hand-scissors-o:before {
  content: "\\f257"; }

.la.la-hand-lizard-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-hand-lizard-o:before {
  content: "\\f258"; }

.la.la-hand-spock-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-hand-spock-o:before {
  content: "\\f259"; }

.la.la-hand-pointer-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-hand-pointer-o:before {
  content: "\\f25a"; }

.la.la-hand-peace-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-hand-peace-o:before {
  content: "\\f25b"; }

.la.la-registered {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-creative-commons {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-gg {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-gg-circle {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-tripadvisor {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-odnoklassniki {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-odnoklassniki-square {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-get-pocket {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-wikipedia-w {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-safari {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-chrome {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-firefox {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-opera {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-internet-explorer {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-television:before {
  content: "\\f26c"; }

.la.la-contao {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-500px {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-amazon {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-calendar-plus-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-calendar-plus-o:before {
  content: "\\f271"; }

.la.la-calendar-minus-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-calendar-minus-o:before {
  content: "\\f272"; }

.la.la-calendar-times-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-calendar-times-o:before {
  content: "\\f273"; }

.la.la-calendar-check-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-calendar-check-o:before {
  content: "\\f274"; }

.la.la-map-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-map-o:before {
  content: "\\f279"; }

.la.la-commenting:before {
  content: "\\f4ad"; }

.la.la-commenting-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-commenting-o:before {
  content: "\\f4ad"; }

.la.la-houzz {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-vimeo {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-vimeo:before {
  content: "\\f27d"; }

.la.la-black-tie {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-fonticons {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-reddit-alien {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-edge {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-credit-card-alt:before {
  content: "\\f09d"; }

.la.la-codiepie {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-modx {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-fort-awesome {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-usb {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-product-hunt {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-mixcloud {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-scribd {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-pause-circle-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-pause-circle-o:before {
  content: "\\f28b"; }

.la.la-stop-circle-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-stop-circle-o:before {
  content: "\\f28d"; }

.la.la-bluetooth {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-bluetooth-b {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-gitlab {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-wpbeginner {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-wpforms {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-envira {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-wheelchair-alt {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-wheelchair-alt:before {
  content: "\\f368"; }

.la.la-question-circle-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-question-circle-o:before {
  content: "\\f059"; }

.la.la-volume-control-phone:before {
  content: "\\f2a0"; }

.la.la-asl-interpreting:before {
  content: "\\f2a3"; }

.la.la-deafness:before {
  content: "\\f2a4"; }

.la.la-hard-of-hearing:before {
  content: "\\f2a4"; }

.la.la-glide {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-glide-g {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-signing:before {
  content: "\\f2a7"; }

.la.la-viadeo {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-viadeo-square {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-snapchat {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-snapchat-ghost {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-snapchat-square {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-pied-piper {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-first-order {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-yoast {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-themeisle {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-google-plus-official {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-google-plus-official:before {
  content: "\\f2b3"; }

.la.la-google-plus-circle {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-google-plus-circle:before {
  content: "\\f2b3"; }

.la.la-font-awesome {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-fa {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-fa:before {
  content: "\\f2b4"; }

.la.la-handshake-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-handshake-o:before {
  content: "\\f2b5"; }

.la.la-envelope-open-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-envelope-open-o:before {
  content: "\\f2b6"; }

.la.la-linode {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-address-book-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-address-book-o:before {
  content: "\\f2b9"; }

.la.la-vcard:before {
  content: "\\f2bb"; }

.la.la-address-card-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-address-card-o:before {
  content: "\\f2bb"; }

.la.la-vcard-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-vcard-o:before {
  content: "\\f2bb"; }

.la.la-user-circle-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-user-circle-o:before {
  content: "\\f2bd"; }

.la.la-user-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-user-o:before {
  content: "\\f007"; }

.la.la-id-badge {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-drivers-license:before {
  content: "\\f2c2"; }

.la.la-id-card-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-id-card-o:before {
  content: "\\f2c2"; }

.la.la-drivers-license-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-drivers-license-o:before {
  content: "\\f2c2"; }

.la.la-quora {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-free-code-camp {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-telegram {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-thermometer-4:before {
  content: "\\f2c7"; }

.la.la-thermometer:before {
  content: "\\f2c7"; }

.la.la-thermometer-3:before {
  content: "\\f2c8"; }

.la.la-thermometer-2:before {
  content: "\\f2c9"; }

.la.la-thermometer-1:before {
  content: "\\f2ca"; }

.la.la-thermometer-0:before {
  content: "\\f2cb"; }

.la.la-bathtub:before {
  content: "\\f2cd"; }

.la.la-s15:before {
  content: "\\f2cd"; }

.la.la-window-maximize {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-window-restore {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-times-rectangle:before {
  content: "\\f410"; }

.la.la-window-close-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-window-close-o:before {
  content: "\\f410"; }

.la.la-times-rectangle-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-times-rectangle-o:before {
  content: "\\f410"; }

.la.la-bandcamp {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-grav {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-etsy {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-imdb {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-ravelry {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-eercast {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-eercast:before {
  content: "\\f2da"; }

.la.la-snowflake-o {
  font-family: 'Line Awesome Free';
  font-weight: 400; }

.la.la-snowflake-o:before {
  content: "\\f2dc"; }

.la.la-superpowers {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-wpexplorer {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

.la.la-spotify {
  font-family: 'Line Awesome Brands';
  font-weight: 400; }

/*
* Remix Icon v2.5.0
* https://remixicon.com
* https://github.com/Remix-Design/RemixIcon
*
* Copyright RemixIcon.com
* Released under the Apache License Version 2.0
*
* Date: 2020-05-23
*/
@font-face {
  font-family: "remixicon";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_28___});
  /* IE9*/
  src: url(${___CSS_LOADER_URL_REPLACEMENT_29___}) format("embedded-opentype"), url(${___CSS_LOADER_URL_REPLACEMENT_30___}) format("woff2"), url(${___CSS_LOADER_URL_REPLACEMENT_31___}) format("woff"), url(${___CSS_LOADER_URL_REPLACEMENT_32___}) format("truetype"), url(${___CSS_LOADER_URL_REPLACEMENT_33___}) format("svg");
  /* iOS 4.1- */
  font-display: swap; }

[class^="ri-"], [class*=" ri-"] {
  font-family: 'remixicon' !important;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale; }

.ri-lg {
  font-size: 1.3333em;
  line-height: 0.75em;
  vertical-align: -.0667em; }

.ri-xl {
  font-size: 1.5em;
  line-height: 0.6666em;
  vertical-align: -.075em; }

.ri-xxs {
  font-size: .5em; }

.ri-xs {
  font-size: .75em; }

.ri-sm {
  font-size: .875em; }

.ri-1x {
  font-size: 1em; }

.ri-2x {
  font-size: 2em; }

.ri-3x {
  font-size: 3em; }

.ri-4x {
  font-size: 4em; }

.ri-5x {
  font-size: 5em; }

.ri-6x {
  font-size: 6em; }

.ri-7x {
  font-size: 7em; }

.ri-8x {
  font-size: 8em; }

.ri-9x {
  font-size: 9em; }

.ri-10x {
  font-size: 10em; }

.ri-fw {
  text-align: center;
  width: 1.25em; }

.ri-24-hours-fill:before {
  content: "\\ea01"; }

.ri-24-hours-line:before {
  content: "\\ea02"; }

.ri-4k-fill:before {
  content: "\\ea03"; }

.ri-4k-line:before {
  content: "\\ea04"; }

.ri-a-b:before {
  content: "\\ea05"; }

.ri-account-box-fill:before {
  content: "\\ea06"; }

.ri-account-box-line:before {
  content: "\\ea07"; }

.ri-account-circle-fill:before {
  content: "\\ea08"; }

.ri-account-circle-line:before {
  content: "\\ea09"; }

.ri-account-pin-box-fill:before {
  content: "\\ea0a"; }

.ri-account-pin-box-line:before {
  content: "\\ea0b"; }

.ri-account-pin-circle-fill:before {
  content: "\\ea0c"; }

.ri-account-pin-circle-line:before {
  content: "\\ea0d"; }

.ri-add-box-fill:before {
  content: "\\ea0e"; }

.ri-add-box-line:before {
  content: "\\ea0f"; }

.ri-add-circle-fill:before {
  content: "\\ea10"; }

.ri-add-circle-line:before {
  content: "\\ea11"; }

.ri-add-fill:before {
  content: "\\ea12"; }

.ri-add-line:before {
  content: "\\ea13"; }

.ri-admin-fill:before {
  content: "\\ea14"; }

.ri-admin-line:before {
  content: "\\ea15"; }

.ri-advertisement-fill:before {
  content: "\\ea16"; }

.ri-advertisement-line:before {
  content: "\\ea17"; }

.ri-airplay-fill:before {
  content: "\\ea18"; }

.ri-airplay-line:before {
  content: "\\ea19"; }

.ri-alarm-fill:before {
  content: "\\ea1a"; }

.ri-alarm-line:before {
  content: "\\ea1b"; }

.ri-alarm-warning-fill:before {
  content: "\\ea1c"; }

.ri-alarm-warning-line:before {
  content: "\\ea1d"; }

.ri-album-fill:before {
  content: "\\ea1e"; }

.ri-album-line:before {
  content: "\\ea1f"; }

.ri-alert-fill:before {
  content: "\\ea20"; }

.ri-alert-line:before {
  content: "\\ea21"; }

.ri-aliens-fill:before {
  content: "\\ea22"; }

.ri-aliens-line:before {
  content: "\\ea23"; }

.ri-align-bottom:before {
  content: "\\ea24"; }

.ri-align-center:before {
  content: "\\ea25"; }

.ri-align-justify:before {
  content: "\\ea26"; }

.ri-align-left:before {
  content: "\\ea27"; }

.ri-align-right:before {
  content: "\\ea28"; }

.ri-align-top:before {
  content: "\\ea29"; }

.ri-align-vertically:before {
  content: "\\ea2a"; }

.ri-alipay-fill:before {
  content: "\\ea2b"; }

.ri-alipay-line:before {
  content: "\\ea2c"; }

.ri-amazon-fill:before {
  content: "\\ea2d"; }

.ri-amazon-line:before {
  content: "\\ea2e"; }

.ri-anchor-fill:before {
  content: "\\ea2f"; }

.ri-anchor-line:before {
  content: "\\ea30"; }

.ri-ancient-gate-fill:before {
  content: "\\ea31"; }

.ri-ancient-gate-line:before {
  content: "\\ea32"; }

.ri-ancient-pavilion-fill:before {
  content: "\\ea33"; }

.ri-ancient-pavilion-line:before {
  content: "\\ea34"; }

.ri-android-fill:before {
  content: "\\ea35"; }

.ri-android-line:before {
  content: "\\ea36"; }

.ri-angularjs-fill:before {
  content: "\\ea37"; }

.ri-angularjs-line:before {
  content: "\\ea38"; }

.ri-anticlockwise-2-fill:before {
  content: "\\ea39"; }

.ri-anticlockwise-2-line:before {
  content: "\\ea3a"; }

.ri-anticlockwise-fill:before {
  content: "\\ea3b"; }

.ri-anticlockwise-line:before {
  content: "\\ea3c"; }

.ri-app-store-fill:before {
  content: "\\ea3d"; }

.ri-app-store-line:before {
  content: "\\ea3e"; }

.ri-apple-fill:before {
  content: "\\ea3f"; }

.ri-apple-line:before {
  content: "\\ea40"; }

.ri-apps-2-fill:before {
  content: "\\ea41"; }

.ri-apps-2-line:before {
  content: "\\ea42"; }

.ri-apps-fill:before {
  content: "\\ea43"; }

.ri-apps-line:before {
  content: "\\ea44"; }

.ri-archive-drawer-fill:before {
  content: "\\ea45"; }

.ri-archive-drawer-line:before {
  content: "\\ea46"; }

.ri-archive-fill:before {
  content: "\\ea47"; }

.ri-archive-line:before {
  content: "\\ea48"; }

.ri-arrow-down-circle-fill:before {
  content: "\\ea49"; }

.ri-arrow-down-circle-line:before {
  content: "\\ea4a"; }

.ri-arrow-down-fill:before {
  content: "\\ea4b"; }

.ri-arrow-down-line:before {
  content: "\\ea4c"; }

.ri-arrow-down-s-fill:before {
  content: "\\ea4d"; }

.ri-arrow-down-s-line:before {
  content: "\\ea4e"; }

.ri-arrow-drop-down-fill:before {
  content: "\\ea4f"; }

.ri-arrow-drop-down-line:before {
  content: "\\ea50"; }

.ri-arrow-drop-left-fill:before {
  content: "\\ea51"; }

.ri-arrow-drop-left-line:before {
  content: "\\ea52"; }

.ri-arrow-drop-right-fill:before {
  content: "\\ea53"; }

.ri-arrow-drop-right-line:before {
  content: "\\ea54"; }

.ri-arrow-drop-up-fill:before {
  content: "\\ea55"; }

.ri-arrow-drop-up-line:before {
  content: "\\ea56"; }

.ri-arrow-go-back-fill:before {
  content: "\\ea57"; }

.ri-arrow-go-back-line:before {
  content: "\\ea58"; }

.ri-arrow-go-forward-fill:before {
  content: "\\ea59"; }

.ri-arrow-go-forward-line:before {
  content: "\\ea5a"; }

.ri-arrow-left-circle-fill:before {
  content: "\\ea5b"; }

.ri-arrow-left-circle-line:before {
  content: "\\ea5c"; }

.ri-arrow-left-down-fill:before {
  content: "\\ea5d"; }

.ri-arrow-left-down-line:before {
  content: "\\ea5e"; }

.ri-arrow-left-fill:before {
  content: "\\ea5f"; }

.ri-arrow-left-line:before {
  content: "\\ea60"; }

.ri-arrow-left-right-fill:before {
  content: "\\ea61"; }

.ri-arrow-left-right-line:before {
  content: "\\ea62"; }

.ri-arrow-left-s-fill:before {
  content: "\\ea63"; }

.ri-arrow-left-s-line:before {
  content: "\\ea64"; }

.ri-arrow-left-up-fill:before {
  content: "\\ea65"; }

.ri-arrow-left-up-line:before {
  content: "\\ea66"; }

.ri-arrow-right-circle-fill:before {
  content: "\\ea67"; }

.ri-arrow-right-circle-line:before {
  content: "\\ea68"; }

.ri-arrow-right-down-fill:before {
  content: "\\ea69"; }

.ri-arrow-right-down-line:before {
  content: "\\ea6a"; }

.ri-arrow-right-fill:before {
  content: "\\ea6b"; }

.ri-arrow-right-line:before {
  content: "\\ea6c"; }

.ri-arrow-right-s-fill:before {
  content: "\\ea6d"; }

.ri-arrow-right-s-line:before {
  content: "\\ea6e"; }

.ri-arrow-right-up-fill:before {
  content: "\\ea6f"; }

.ri-arrow-right-up-line:before {
  content: "\\ea70"; }

.ri-arrow-up-circle-fill:before {
  content: "\\ea71"; }

.ri-arrow-up-circle-line:before {
  content: "\\ea72"; }

.ri-arrow-up-down-fill:before {
  content: "\\ea73"; }

.ri-arrow-up-down-line:before {
  content: "\\ea74"; }

.ri-arrow-up-fill:before {
  content: "\\ea75"; }

.ri-arrow-up-line:before {
  content: "\\ea76"; }

.ri-arrow-up-s-fill:before {
  content: "\\ea77"; }

.ri-arrow-up-s-line:before {
  content: "\\ea78"; }

.ri-artboard-2-fill:before {
  content: "\\ea79"; }

.ri-artboard-2-line:before {
  content: "\\ea7a"; }

.ri-artboard-fill:before {
  content: "\\ea7b"; }

.ri-artboard-line:before {
  content: "\\ea7c"; }

.ri-article-fill:before {
  content: "\\ea7d"; }

.ri-article-line:before {
  content: "\\ea7e"; }

.ri-aspect-ratio-fill:before {
  content: "\\ea7f"; }

.ri-aspect-ratio-line:before {
  content: "\\ea80"; }

.ri-asterisk:before {
  content: "\\ea81"; }

.ri-at-fill:before {
  content: "\\ea82"; }

.ri-at-line:before {
  content: "\\ea83"; }

.ri-attachment-2:before {
  content: "\\ea84"; }

.ri-attachment-fill:before {
  content: "\\ea85"; }

.ri-attachment-line:before {
  content: "\\ea86"; }

.ri-auction-fill:before {
  content: "\\ea87"; }

.ri-auction-line:before {
  content: "\\ea88"; }

.ri-award-fill:before {
  content: "\\ea89"; }

.ri-award-line:before {
  content: "\\ea8a"; }

.ri-baidu-fill:before {
  content: "\\ea8b"; }

.ri-baidu-line:before {
  content: "\\ea8c"; }

.ri-ball-pen-fill:before {
  content: "\\ea8d"; }

.ri-ball-pen-line:before {
  content: "\\ea8e"; }

.ri-bank-card-2-fill:before {
  content: "\\ea8f"; }

.ri-bank-card-2-line:before {
  content: "\\ea90"; }

.ri-bank-card-fill:before {
  content: "\\ea91"; }

.ri-bank-card-line:before {
  content: "\\ea92"; }

.ri-bank-fill:before {
  content: "\\ea93"; }

.ri-bank-line:before {
  content: "\\ea94"; }

.ri-bar-chart-2-fill:before {
  content: "\\ea95"; }

.ri-bar-chart-2-line:before {
  content: "\\ea96"; }

.ri-bar-chart-box-fill:before {
  content: "\\ea97"; }

.ri-bar-chart-box-line:before {
  content: "\\ea98"; }

.ri-bar-chart-fill:before {
  content: "\\ea99"; }

.ri-bar-chart-grouped-fill:before {
  content: "\\ea9a"; }

.ri-bar-chart-grouped-line:before {
  content: "\\ea9b"; }

.ri-bar-chart-horizontal-fill:before {
  content: "\\ea9c"; }

.ri-bar-chart-horizontal-line:before {
  content: "\\ea9d"; }

.ri-bar-chart-line:before {
  content: "\\ea9e"; }

.ri-barcode-box-fill:before {
  content: "\\ea9f"; }

.ri-barcode-box-line:before {
  content: "\\eaa0"; }

.ri-barcode-fill:before {
  content: "\\eaa1"; }

.ri-barcode-line:before {
  content: "\\eaa2"; }

.ri-barricade-fill:before {
  content: "\\eaa3"; }

.ri-barricade-line:before {
  content: "\\eaa4"; }

.ri-base-station-fill:before {
  content: "\\eaa5"; }

.ri-base-station-line:before {
  content: "\\eaa6"; }

.ri-basketball-fill:before {
  content: "\\eaa7"; }

.ri-basketball-line:before {
  content: "\\eaa8"; }

.ri-battery-2-charge-fill:before {
  content: "\\eaa9"; }

.ri-battery-2-charge-line:before {
  content: "\\eaaa"; }

.ri-battery-2-fill:before {
  content: "\\eaab"; }

.ri-battery-2-line:before {
  content: "\\eaac"; }

.ri-battery-charge-fill:before {
  content: "\\eaad"; }

.ri-battery-charge-line:before {
  content: "\\eaae"; }

.ri-battery-fill:before {
  content: "\\eaaf"; }

.ri-battery-line:before {
  content: "\\eab0"; }

.ri-battery-low-fill:before {
  content: "\\eab1"; }

.ri-battery-low-line:before {
  content: "\\eab2"; }

.ri-battery-saver-fill:before {
  content: "\\eab3"; }

.ri-battery-saver-line:before {
  content: "\\eab4"; }

.ri-battery-share-fill:before {
  content: "\\eab5"; }

.ri-battery-share-line:before {
  content: "\\eab6"; }

.ri-bear-smile-fill:before {
  content: "\\eab7"; }

.ri-bear-smile-line:before {
  content: "\\eab8"; }

.ri-behance-fill:before {
  content: "\\eab9"; }

.ri-behance-line:before {
  content: "\\eaba"; }

.ri-bell-fill:before {
  content: "\\eabb"; }

.ri-bell-line:before {
  content: "\\eabc"; }

.ri-bike-fill:before {
  content: "\\eabd"; }

.ri-bike-line:before {
  content: "\\eabe"; }

.ri-bilibili-fill:before {
  content: "\\eabf"; }

.ri-bilibili-line:before {
  content: "\\eac0"; }

.ri-bill-fill:before {
  content: "\\eac1"; }

.ri-bill-line:before {
  content: "\\eac2"; }

.ri-billiards-fill:before {
  content: "\\eac3"; }

.ri-billiards-line:before {
  content: "\\eac4"; }

.ri-bit-coin-fill:before {
  content: "\\eac5"; }

.ri-bit-coin-line:before {
  content: "\\eac6"; }

.ri-blaze-fill:before {
  content: "\\eac7"; }

.ri-blaze-line:before {
  content: "\\eac8"; }

.ri-bluetooth-connect-fill:before {
  content: "\\eac9"; }

.ri-bluetooth-connect-line:before {
  content: "\\eaca"; }

.ri-bluetooth-fill:before {
  content: "\\eacb"; }

.ri-bluetooth-line:before {
  content: "\\eacc"; }

.ri-blur-off-fill:before {
  content: "\\eacd"; }

.ri-blur-off-line:before {
  content: "\\eace"; }

.ri-body-scan-fill:before {
  content: "\\eacf"; }

.ri-body-scan-line:before {
  content: "\\ead0"; }

.ri-bold:before {
  content: "\\ead1"; }

.ri-book-2-fill:before {
  content: "\\ead2"; }

.ri-book-2-line:before {
  content: "\\ead3"; }

.ri-book-3-fill:before {
  content: "\\ead4"; }

.ri-book-3-line:before {
  content: "\\ead5"; }

.ri-book-fill:before {
  content: "\\ead6"; }

.ri-book-line:before {
  content: "\\ead7"; }

.ri-book-mark-fill:before {
  content: "\\ead8"; }

.ri-book-mark-line:before {
  content: "\\ead9"; }

.ri-book-open-fill:before {
  content: "\\eada"; }

.ri-book-open-line:before {
  content: "\\eadb"; }

.ri-book-read-fill:before {
  content: "\\eadc"; }

.ri-book-read-line:before {
  content: "\\eadd"; }

.ri-booklet-fill:before {
  content: "\\eade"; }

.ri-booklet-line:before {
  content: "\\eadf"; }

.ri-bookmark-2-fill:before {
  content: "\\eae0"; }

.ri-bookmark-2-line:before {
  content: "\\eae1"; }

.ri-bookmark-3-fill:before {
  content: "\\eae2"; }

.ri-bookmark-3-line:before {
  content: "\\eae3"; }

.ri-bookmark-fill:before {
  content: "\\eae4"; }

.ri-bookmark-line:before {
  content: "\\eae5"; }

.ri-boxing-fill:before {
  content: "\\eae6"; }

.ri-boxing-line:before {
  content: "\\eae7"; }

.ri-braces-fill:before {
  content: "\\eae8"; }

.ri-braces-line:before {
  content: "\\eae9"; }

.ri-brackets-fill:before {
  content: "\\eaea"; }

.ri-brackets-line:before {
  content: "\\eaeb"; }

.ri-briefcase-2-fill:before {
  content: "\\eaec"; }

.ri-briefcase-2-line:before {
  content: "\\eaed"; }

.ri-briefcase-3-fill:before {
  content: "\\eaee"; }

.ri-briefcase-3-line:before {
  content: "\\eaef"; }

.ri-briefcase-4-fill:before {
  content: "\\eaf0"; }

.ri-briefcase-4-line:before {
  content: "\\eaf1"; }

.ri-briefcase-5-fill:before {
  content: "\\eaf2"; }

.ri-briefcase-5-line:before {
  content: "\\eaf3"; }

.ri-briefcase-fill:before {
  content: "\\eaf4"; }

.ri-briefcase-line:before {
  content: "\\eaf5"; }

.ri-bring-forward:before {
  content: "\\eaf6"; }

.ri-bring-to-front:before {
  content: "\\eaf7"; }

.ri-broadcast-fill:before {
  content: "\\eaf8"; }

.ri-broadcast-line:before {
  content: "\\eaf9"; }

.ri-brush-2-fill:before {
  content: "\\eafa"; }

.ri-brush-2-line:before {
  content: "\\eafb"; }

.ri-brush-3-fill:before {
  content: "\\eafc"; }

.ri-brush-3-line:before {
  content: "\\eafd"; }

.ri-brush-4-fill:before {
  content: "\\eafe"; }

.ri-brush-4-line:before {
  content: "\\eaff"; }

.ri-brush-fill:before {
  content: "\\eb00"; }

.ri-brush-line:before {
  content: "\\eb01"; }

.ri-bubble-chart-fill:before {
  content: "\\eb02"; }

.ri-bubble-chart-line:before {
  content: "\\eb03"; }

.ri-bug-2-fill:before {
  content: "\\eb04"; }

.ri-bug-2-line:before {
  content: "\\eb05"; }

.ri-bug-fill:before {
  content: "\\eb06"; }

.ri-bug-line:before {
  content: "\\eb07"; }

.ri-building-2-fill:before {
  content: "\\eb08"; }

.ri-building-2-line:before {
  content: "\\eb09"; }

.ri-building-3-fill:before {
  content: "\\eb0a"; }

.ri-building-3-line:before {
  content: "\\eb0b"; }

.ri-building-4-fill:before {
  content: "\\eb0c"; }

.ri-building-4-line:before {
  content: "\\eb0d"; }

.ri-building-fill:before {
  content: "\\eb0e"; }

.ri-building-line:before {
  content: "\\eb0f"; }

.ri-bus-2-fill:before {
  content: "\\eb10"; }

.ri-bus-2-line:before {
  content: "\\eb11"; }

.ri-bus-fill:before {
  content: "\\eb12"; }

.ri-bus-line:before {
  content: "\\eb13"; }

.ri-bus-wifi-fill:before {
  content: "\\eb14"; }

.ri-bus-wifi-line:before {
  content: "\\eb15"; }

.ri-cactus-fill:before {
  content: "\\eb16"; }

.ri-cactus-line:before {
  content: "\\eb17"; }

.ri-cake-2-fill:before {
  content: "\\eb18"; }

.ri-cake-2-line:before {
  content: "\\eb19"; }

.ri-cake-3-fill:before {
  content: "\\eb1a"; }

.ri-cake-3-line:before {
  content: "\\eb1b"; }

.ri-cake-fill:before {
  content: "\\eb1c"; }

.ri-cake-line:before {
  content: "\\eb1d"; }

.ri-calculator-fill:before {
  content: "\\eb1e"; }

.ri-calculator-line:before {
  content: "\\eb1f"; }

.ri-calendar-2-fill:before {
  content: "\\eb20"; }

.ri-calendar-2-line:before {
  content: "\\eb21"; }

.ri-calendar-check-fill:before {
  content: "\\eb22"; }

.ri-calendar-check-line:before {
  content: "\\eb23"; }

.ri-calendar-event-fill:before {
  content: "\\eb24"; }

.ri-calendar-event-line:before {
  content: "\\eb25"; }

.ri-calendar-fill:before {
  content: "\\eb26"; }

.ri-calendar-line:before {
  content: "\\eb27"; }

.ri-calendar-todo-fill:before {
  content: "\\eb28"; }

.ri-calendar-todo-line:before {
  content: "\\eb29"; }

.ri-camera-2-fill:before {
  content: "\\eb2a"; }

.ri-camera-2-line:before {
  content: "\\eb2b"; }

.ri-camera-3-fill:before {
  content: "\\eb2c"; }

.ri-camera-3-line:before {
  content: "\\eb2d"; }

.ri-camera-fill:before {
  content: "\\eb2e"; }

.ri-camera-lens-fill:before {
  content: "\\eb2f"; }

.ri-camera-lens-line:before {
  content: "\\eb30"; }

.ri-camera-line:before {
  content: "\\eb31"; }

.ri-camera-off-fill:before {
  content: "\\eb32"; }

.ri-camera-off-line:before {
  content: "\\eb33"; }

.ri-camera-switch-fill:before {
  content: "\\eb34"; }

.ri-camera-switch-line:before {
  content: "\\eb35"; }

.ri-capsule-fill:before {
  content: "\\eb36"; }

.ri-capsule-line:before {
  content: "\\eb37"; }

.ri-car-fill:before {
  content: "\\eb38"; }

.ri-car-line:before {
  content: "\\eb39"; }

.ri-car-washing-fill:before {
  content: "\\eb3a"; }

.ri-car-washing-line:before {
  content: "\\eb3b"; }

.ri-caravan-fill:before {
  content: "\\eb3c"; }

.ri-caravan-line:before {
  content: "\\eb3d"; }

.ri-cast-fill:before {
  content: "\\eb3e"; }

.ri-cast-line:before {
  content: "\\eb3f"; }

.ri-cellphone-fill:before {
  content: "\\eb40"; }

.ri-cellphone-line:before {
  content: "\\eb41"; }

.ri-celsius-fill:before {
  content: "\\eb42"; }

.ri-celsius-line:before {
  content: "\\eb43"; }

.ri-centos-fill:before {
  content: "\\eb44"; }

.ri-centos-line:before {
  content: "\\eb45"; }

.ri-character-recognition-fill:before {
  content: "\\eb46"; }

.ri-character-recognition-line:before {
  content: "\\eb47"; }

.ri-charging-pile-2-fill:before {
  content: "\\eb48"; }

.ri-charging-pile-2-line:before {
  content: "\\eb49"; }

.ri-charging-pile-fill:before {
  content: "\\eb4a"; }

.ri-charging-pile-line:before {
  content: "\\eb4b"; }

.ri-chat-1-fill:before {
  content: "\\eb4c"; }

.ri-chat-1-line:before {
  content: "\\eb4d"; }

.ri-chat-2-fill:before {
  content: "\\eb4e"; }

.ri-chat-2-line:before {
  content: "\\eb4f"; }

.ri-chat-3-fill:before {
  content: "\\eb50"; }

.ri-chat-3-line:before {
  content: "\\eb51"; }

.ri-chat-4-fill:before {
  content: "\\eb52"; }

.ri-chat-4-line:before {
  content: "\\eb53"; }

.ri-chat-check-fill:before {
  content: "\\eb54"; }

.ri-chat-check-line:before {
  content: "\\eb55"; }

.ri-chat-delete-fill:before {
  content: "\\eb56"; }

.ri-chat-delete-line:before {
  content: "\\eb57"; }

.ri-chat-download-fill:before {
  content: "\\eb58"; }

.ri-chat-download-line:before {
  content: "\\eb59"; }

.ri-chat-follow-up-fill:before {
  content: "\\eb5a"; }

.ri-chat-follow-up-line:before {
  content: "\\eb5b"; }

.ri-chat-forward-fill:before {
  content: "\\eb5c"; }

.ri-chat-forward-line:before {
  content: "\\eb5d"; }

.ri-chat-heart-fill:before {
  content: "\\eb5e"; }

.ri-chat-heart-line:before {
  content: "\\eb5f"; }

.ri-chat-history-fill:before {
  content: "\\eb60"; }

.ri-chat-history-line:before {
  content: "\\eb61"; }

.ri-chat-new-fill:before {
  content: "\\eb62"; }

.ri-chat-new-line:before {
  content: "\\eb63"; }

.ri-chat-off-fill:before {
  content: "\\eb64"; }

.ri-chat-off-line:before {
  content: "\\eb65"; }

.ri-chat-poll-fill:before {
  content: "\\eb66"; }

.ri-chat-poll-line:before {
  content: "\\eb67"; }

.ri-chat-private-fill:before {
  content: "\\eb68"; }

.ri-chat-private-line:before {
  content: "\\eb69"; }

.ri-chat-quote-fill:before {
  content: "\\eb6a"; }

.ri-chat-quote-line:before {
  content: "\\eb6b"; }

.ri-chat-settings-fill:before {
  content: "\\eb6c"; }

.ri-chat-settings-line:before {
  content: "\\eb6d"; }

.ri-chat-smile-2-fill:before {
  content: "\\eb6e"; }

.ri-chat-smile-2-line:before {
  content: "\\eb6f"; }

.ri-chat-smile-3-fill:before {
  content: "\\eb70"; }

.ri-chat-smile-3-line:before {
  content: "\\eb71"; }

.ri-chat-smile-fill:before {
  content: "\\eb72"; }

.ri-chat-smile-line:before {
  content: "\\eb73"; }

.ri-chat-upload-fill:before {
  content: "\\eb74"; }

.ri-chat-upload-line:before {
  content: "\\eb75"; }

.ri-chat-voice-fill:before {
  content: "\\eb76"; }

.ri-chat-voice-line:before {
  content: "\\eb77"; }

.ri-check-double-fill:before {
  content: "\\eb78"; }

.ri-check-double-line:before {
  content: "\\eb79"; }

.ri-check-fill:before {
  content: "\\eb7a"; }

.ri-check-line:before {
  content: "\\eb7b"; }

.ri-checkbox-blank-circle-fill:before {
  content: "\\eb7c"; }

.ri-checkbox-blank-circle-line:before {
  content: "\\eb7d"; }

.ri-checkbox-blank-fill:before {
  content: "\\eb7e"; }

.ri-checkbox-blank-line:before {
  content: "\\eb7f"; }

.ri-checkbox-circle-fill:before {
  content: "\\eb80"; }

.ri-checkbox-circle-line:before {
  content: "\\eb81"; }

.ri-checkbox-fill:before {
  content: "\\eb82"; }

.ri-checkbox-indeterminate-fill:before {
  content: "\\eb83"; }

.ri-checkbox-indeterminate-line:before {
  content: "\\eb84"; }

.ri-checkbox-line:before {
  content: "\\eb85"; }

.ri-checkbox-multiple-blank-fill:before {
  content: "\\eb86"; }

.ri-checkbox-multiple-blank-line:before {
  content: "\\eb87"; }

.ri-checkbox-multiple-fill:before {
  content: "\\eb88"; }

.ri-checkbox-multiple-line:before {
  content: "\\eb89"; }

.ri-china-railway-fill:before {
  content: "\\eb8a"; }

.ri-china-railway-line:before {
  content: "\\eb8b"; }

.ri-chrome-fill:before {
  content: "\\eb8c"; }

.ri-chrome-line:before {
  content: "\\eb8d"; }

.ri-clapperboard-fill:before {
  content: "\\eb8e"; }

.ri-clapperboard-line:before {
  content: "\\eb8f"; }

.ri-clipboard-fill:before {
  content: "\\eb90"; }

.ri-clipboard-line:before {
  content: "\\eb91"; }

.ri-clockwise-2-fill:before {
  content: "\\eb92"; }

.ri-clockwise-2-line:before {
  content: "\\eb93"; }

.ri-clockwise-fill:before {
  content: "\\eb94"; }

.ri-clockwise-line:before {
  content: "\\eb95"; }

.ri-close-circle-fill:before {
  content: "\\eb96"; }

.ri-close-circle-line:before {
  content: "\\eb97"; }

.ri-close-fill:before {
  content: "\\eb98"; }

.ri-close-line:before {
  content: "\\eb99"; }

.ri-closed-captioning-fill:before {
  content: "\\eb9a"; }

.ri-closed-captioning-line:before {
  content: "\\eb9b"; }

.ri-cloud-fill:before {
  content: "\\eb9c"; }

.ri-cloud-line:before {
  content: "\\eb9d"; }

.ri-cloud-off-fill:before {
  content: "\\eb9e"; }

.ri-cloud-off-line:before {
  content: "\\eb9f"; }

.ri-cloud-windy-fill:before {
  content: "\\eba0"; }

.ri-cloud-windy-line:before {
  content: "\\eba1"; }

.ri-cloudy-2-fill:before {
  content: "\\eba2"; }

.ri-cloudy-2-line:before {
  content: "\\eba3"; }

.ri-cloudy-fill:before {
  content: "\\eba4"; }

.ri-cloudy-line:before {
  content: "\\eba5"; }

.ri-code-box-fill:before {
  content: "\\eba6"; }

.ri-code-box-line:before {
  content: "\\eba7"; }

.ri-code-fill:before {
  content: "\\eba8"; }

.ri-code-line:before {
  content: "\\eba9"; }

.ri-code-s-fill:before {
  content: "\\ebaa"; }

.ri-code-s-line:before {
  content: "\\ebab"; }

.ri-code-s-slash-fill:before {
  content: "\\ebac"; }

.ri-code-s-slash-line:before {
  content: "\\ebad"; }

.ri-code-view:before {
  content: "\\ebae"; }

.ri-codepen-fill:before {
  content: "\\ebaf"; }

.ri-codepen-line:before {
  content: "\\ebb0"; }

.ri-coin-fill:before {
  content: "\\ebb1"; }

.ri-coin-line:before {
  content: "\\ebb2"; }

.ri-coins-fill:before {
  content: "\\ebb3"; }

.ri-coins-line:before {
  content: "\\ebb4"; }

.ri-collage-fill:before {
  content: "\\ebb5"; }

.ri-collage-line:before {
  content: "\\ebb6"; }

.ri-command-fill:before {
  content: "\\ebb7"; }

.ri-command-line:before {
  content: "\\ebb8"; }

.ri-community-fill:before {
  content: "\\ebb9"; }

.ri-community-line:before {
  content: "\\ebba"; }

.ri-compass-2-fill:before {
  content: "\\ebbb"; }

.ri-compass-2-line:before {
  content: "\\ebbc"; }

.ri-compass-3-fill:before {
  content: "\\ebbd"; }

.ri-compass-3-line:before {
  content: "\\ebbe"; }

.ri-compass-4-fill:before {
  content: "\\ebbf"; }

.ri-compass-4-line:before {
  content: "\\ebc0"; }

.ri-compass-discover-fill:before {
  content: "\\ebc1"; }

.ri-compass-discover-line:before {
  content: "\\ebc2"; }

.ri-compass-fill:before {
  content: "\\ebc3"; }

.ri-compass-line:before {
  content: "\\ebc4"; }

.ri-compasses-2-fill:before {
  content: "\\ebc5"; }

.ri-compasses-2-line:before {
  content: "\\ebc6"; }

.ri-compasses-fill:before {
  content: "\\ebc7"; }

.ri-compasses-line:before {
  content: "\\ebc8"; }

.ri-computer-fill:before {
  content: "\\ebc9"; }

.ri-computer-line:before {
  content: "\\ebca"; }

.ri-contacts-book-2-fill:before {
  content: "\\ebcb"; }

.ri-contacts-book-2-line:before {
  content: "\\ebcc"; }

.ri-contacts-book-fill:before {
  content: "\\ebcd"; }

.ri-contacts-book-line:before {
  content: "\\ebce"; }

.ri-contacts-book-upload-fill:before {
  content: "\\ebcf"; }

.ri-contacts-book-upload-line:before {
  content: "\\ebd0"; }

.ri-contacts-fill:before {
  content: "\\ebd1"; }

.ri-contacts-line:before {
  content: "\\ebd2"; }

.ri-contrast-2-fill:before {
  content: "\\ebd3"; }

.ri-contrast-2-line:before {
  content: "\\ebd4"; }

.ri-contrast-drop-2-fill:before {
  content: "\\ebd5"; }

.ri-contrast-drop-2-line:before {
  content: "\\ebd6"; }

.ri-contrast-drop-fill:before {
  content: "\\ebd7"; }

.ri-contrast-drop-line:before {
  content: "\\ebd8"; }

.ri-contrast-fill:before {
  content: "\\ebd9"; }

.ri-contrast-line:before {
  content: "\\ebda"; }

.ri-copper-coin-fill:before {
  content: "\\ebdb"; }

.ri-copper-coin-line:before {
  content: "\\ebdc"; }

.ri-copper-diamond-fill:before {
  content: "\\ebdd"; }

.ri-copper-diamond-line:before {
  content: "\\ebde"; }

.ri-copyleft-fill:before {
  content: "\\ebdf"; }

.ri-copyleft-line:before {
  content: "\\ebe0"; }

.ri-copyright-fill:before {
  content: "\\ebe1"; }

.ri-copyright-line:before {
  content: "\\ebe2"; }

.ri-coreos-fill:before {
  content: "\\ebe3"; }

.ri-coreos-line:before {
  content: "\\ebe4"; }

.ri-coupon-2-fill:before {
  content: "\\ebe5"; }

.ri-coupon-2-line:before {
  content: "\\ebe6"; }

.ri-coupon-3-fill:before {
  content: "\\ebe7"; }

.ri-coupon-3-line:before {
  content: "\\ebe8"; }

.ri-coupon-4-fill:before {
  content: "\\ebe9"; }

.ri-coupon-4-line:before {
  content: "\\ebea"; }

.ri-coupon-5-fill:before {
  content: "\\ebeb"; }

.ri-coupon-5-line:before {
  content: "\\ebec"; }

.ri-coupon-fill:before {
  content: "\\ebed"; }

.ri-coupon-line:before {
  content: "\\ebee"; }

.ri-cpu-fill:before {
  content: "\\ebef"; }

.ri-cpu-line:before {
  content: "\\ebf0"; }

.ri-creative-commons-by-fill:before {
  content: "\\ebf1"; }

.ri-creative-commons-by-line:before {
  content: "\\ebf2"; }

.ri-creative-commons-fill:before {
  content: "\\ebf3"; }

.ri-creative-commons-line:before {
  content: "\\ebf4"; }

.ri-creative-commons-nc-fill:before {
  content: "\\ebf5"; }

.ri-creative-commons-nc-line:before {
  content: "\\ebf6"; }

.ri-creative-commons-nd-fill:before {
  content: "\\ebf7"; }

.ri-creative-commons-nd-line:before {
  content: "\\ebf8"; }

.ri-creative-commons-sa-fill:before {
  content: "\\ebf9"; }

.ri-creative-commons-sa-line:before {
  content: "\\ebfa"; }

.ri-creative-commons-zero-fill:before {
  content: "\\ebfb"; }

.ri-creative-commons-zero-line:before {
  content: "\\ebfc"; }

.ri-criminal-fill:before {
  content: "\\ebfd"; }

.ri-criminal-line:before {
  content: "\\ebfe"; }

.ri-crop-2-fill:before {
  content: "\\ebff"; }

.ri-crop-2-line:before {
  content: "\\ec00"; }

.ri-crop-fill:before {
  content: "\\ec01"; }

.ri-crop-line:before {
  content: "\\ec02"; }

.ri-css3-fill:before {
  content: "\\ec03"; }

.ri-css3-line:before {
  content: "\\ec04"; }

.ri-cup-fill:before {
  content: "\\ec05"; }

.ri-cup-line:before {
  content: "\\ec06"; }

.ri-currency-fill:before {
  content: "\\ec07"; }

.ri-currency-line:before {
  content: "\\ec08"; }

.ri-cursor-fill:before {
  content: "\\ec09"; }

.ri-cursor-line:before {
  content: "\\ec0a"; }

.ri-customer-service-2-fill:before {
  content: "\\ec0b"; }

.ri-customer-service-2-line:before {
  content: "\\ec0c"; }

.ri-customer-service-fill:before {
  content: "\\ec0d"; }

.ri-customer-service-line:before {
  content: "\\ec0e"; }

.ri-dashboard-2-fill:before {
  content: "\\ec0f"; }

.ri-dashboard-2-line:before {
  content: "\\ec10"; }

.ri-dashboard-3-fill:before {
  content: "\\ec11"; }

.ri-dashboard-3-line:before {
  content: "\\ec12"; }

.ri-dashboard-fill:before {
  content: "\\ec13"; }

.ri-dashboard-line:before {
  content: "\\ec14"; }

.ri-database-2-fill:before {
  content: "\\ec15"; }

.ri-database-2-line:before {
  content: "\\ec16"; }

.ri-database-fill:before {
  content: "\\ec17"; }

.ri-database-line:before {
  content: "\\ec18"; }

.ri-delete-back-2-fill:before {
  content: "\\ec19"; }

.ri-delete-back-2-line:before {
  content: "\\ec1a"; }

.ri-delete-back-fill:before {
  content: "\\ec1b"; }

.ri-delete-back-line:before {
  content: "\\ec1c"; }

.ri-delete-bin-2-fill:before {
  content: "\\ec1d"; }

.ri-delete-bin-2-line:before {
  content: "\\ec1e"; }

.ri-delete-bin-3-fill:before {
  content: "\\ec1f"; }

.ri-delete-bin-3-line:before {
  content: "\\ec20"; }

.ri-delete-bin-4-fill:before {
  content: "\\ec21"; }

.ri-delete-bin-4-line:before {
  content: "\\ec22"; }

.ri-delete-bin-5-fill:before {
  content: "\\ec23"; }

.ri-delete-bin-5-line:before {
  content: "\\ec24"; }

.ri-delete-bin-6-fill:before {
  content: "\\ec25"; }

.ri-delete-bin-6-line:before {
  content: "\\ec26"; }

.ri-delete-bin-7-fill:before {
  content: "\\ec27"; }

.ri-delete-bin-7-line:before {
  content: "\\ec28"; }

.ri-delete-bin-fill:before {
  content: "\\ec29"; }

.ri-delete-bin-line:before {
  content: "\\ec2a"; }

.ri-delete-column:before {
  content: "\\ec2b"; }

.ri-delete-row:before {
  content: "\\ec2c"; }

.ri-device-fill:before {
  content: "\\ec2d"; }

.ri-device-line:before {
  content: "\\ec2e"; }

.ri-device-recover-fill:before {
  content: "\\ec2f"; }

.ri-device-recover-line:before {
  content: "\\ec30"; }

.ri-dingding-fill:before {
  content: "\\ec31"; }

.ri-dingding-line:before {
  content: "\\ec32"; }

.ri-direction-fill:before {
  content: "\\ec33"; }

.ri-direction-line:before {
  content: "\\ec34"; }

.ri-disc-fill:before {
  content: "\\ec35"; }

.ri-disc-line:before {
  content: "\\ec36"; }

.ri-discord-fill:before {
  content: "\\ec37"; }

.ri-discord-line:before {
  content: "\\ec38"; }

.ri-discuss-fill:before {
  content: "\\ec39"; }

.ri-discuss-line:before {
  content: "\\ec3a"; }

.ri-dislike-fill:before {
  content: "\\ec3b"; }

.ri-dislike-line:before {
  content: "\\ec3c"; }

.ri-disqus-fill:before {
  content: "\\ec3d"; }

.ri-disqus-line:before {
  content: "\\ec3e"; }

.ri-divide-fill:before {
  content: "\\ec3f"; }

.ri-divide-line:before {
  content: "\\ec40"; }

.ri-donut-chart-fill:before {
  content: "\\ec41"; }

.ri-donut-chart-line:before {
  content: "\\ec42"; }

.ri-door-closed-fill:before {
  content: "\\ec43"; }

.ri-door-closed-line:before {
  content: "\\ec44"; }

.ri-door-fill:before {
  content: "\\ec45"; }

.ri-door-line:before {
  content: "\\ec46"; }

.ri-door-lock-box-fill:before {
  content: "\\ec47"; }

.ri-door-lock-box-line:before {
  content: "\\ec48"; }

.ri-door-lock-fill:before {
  content: "\\ec49"; }

.ri-door-lock-line:before {
  content: "\\ec4a"; }

.ri-door-open-fill:before {
  content: "\\ec4b"; }

.ri-door-open-line:before {
  content: "\\ec4c"; }

.ri-dossier-fill:before {
  content: "\\ec4d"; }

.ri-dossier-line:before {
  content: "\\ec4e"; }

.ri-douban-fill:before {
  content: "\\ec4f"; }

.ri-douban-line:before {
  content: "\\ec50"; }

.ri-double-quotes-l:before {
  content: "\\ec51"; }

.ri-double-quotes-r:before {
  content: "\\ec52"; }

.ri-download-2-fill:before {
  content: "\\ec53"; }

.ri-download-2-line:before {
  content: "\\ec54"; }

.ri-download-cloud-2-fill:before {
  content: "\\ec55"; }

.ri-download-cloud-2-line:before {
  content: "\\ec56"; }

.ri-download-cloud-fill:before {
  content: "\\ec57"; }

.ri-download-cloud-line:before {
  content: "\\ec58"; }

.ri-download-fill:before {
  content: "\\ec59"; }

.ri-download-line:before {
  content: "\\ec5a"; }

.ri-draft-fill:before {
  content: "\\ec5b"; }

.ri-draft-line:before {
  content: "\\ec5c"; }

.ri-drag-drop-fill:before {
  content: "\\ec5d"; }

.ri-drag-drop-line:before {
  content: "\\ec5e"; }

.ri-drag-move-2-fill:before {
  content: "\\ec5f"; }

.ri-drag-move-2-line:before {
  content: "\\ec60"; }

.ri-drag-move-fill:before {
  content: "\\ec61"; }

.ri-drag-move-line:before {
  content: "\\ec62"; }

.ri-dribbble-fill:before {
  content: "\\ec63"; }

.ri-dribbble-line:before {
  content: "\\ec64"; }

.ri-drive-fill:before {
  content: "\\ec65"; }

.ri-drive-line:before {
  content: "\\ec66"; }

.ri-drizzle-fill:before {
  content: "\\ec67"; }

.ri-drizzle-line:before {
  content: "\\ec68"; }

.ri-drop-fill:before {
  content: "\\ec69"; }

.ri-drop-line:before {
  content: "\\ec6a"; }

.ri-dropbox-fill:before {
  content: "\\ec6b"; }

.ri-dropbox-line:before {
  content: "\\ec6c"; }

.ri-dual-sim-1-fill:before {
  content: "\\ec6d"; }

.ri-dual-sim-1-line:before {
  content: "\\ec6e"; }

.ri-dual-sim-2-fill:before {
  content: "\\ec6f"; }

.ri-dual-sim-2-line:before {
  content: "\\ec70"; }

.ri-dv-fill:before {
  content: "\\ec71"; }

.ri-dv-line:before {
  content: "\\ec72"; }

.ri-dvd-fill:before {
  content: "\\ec73"; }

.ri-dvd-line:before {
  content: "\\ec74"; }

.ri-e-bike-2-fill:before {
  content: "\\ec75"; }

.ri-e-bike-2-line:before {
  content: "\\ec76"; }

.ri-e-bike-fill:before {
  content: "\\ec77"; }

.ri-e-bike-line:before {
  content: "\\ec78"; }

.ri-earth-fill:before {
  content: "\\ec79"; }

.ri-earth-line:before {
  content: "\\ec7a"; }

.ri-earthquake-fill:before {
  content: "\\ec7b"; }

.ri-earthquake-line:before {
  content: "\\ec7c"; }

.ri-edge-fill:before {
  content: "\\ec7d"; }

.ri-edge-line:before {
  content: "\\ec7e"; }

.ri-edit-2-fill:before {
  content: "\\ec7f"; }

.ri-edit-2-line:before {
  content: "\\ec80"; }

.ri-edit-box-fill:before {
  content: "\\ec81"; }

.ri-edit-box-line:before {
  content: "\\ec82"; }

.ri-edit-circle-fill:before {
  content: "\\ec83"; }

.ri-edit-circle-line:before {
  content: "\\ec84"; }

.ri-edit-fill:before {
  content: "\\ec85"; }

.ri-edit-line:before {
  content: "\\ec86"; }

.ri-eject-fill:before {
  content: "\\ec87"; }

.ri-eject-line:before {
  content: "\\ec88"; }

.ri-emotion-2-fill:before {
  content: "\\ec89"; }

.ri-emotion-2-line:before {
  content: "\\ec8a"; }

.ri-emotion-fill:before {
  content: "\\ec8b"; }

.ri-emotion-happy-fill:before {
  content: "\\ec8c"; }

.ri-emotion-happy-line:before {
  content: "\\ec8d"; }

.ri-emotion-laugh-fill:before {
  content: "\\ec8e"; }

.ri-emotion-laugh-line:before {
  content: "\\ec8f"; }

.ri-emotion-line:before {
  content: "\\ec90"; }

.ri-emotion-normal-fill:before {
  content: "\\ec91"; }

.ri-emotion-normal-line:before {
  content: "\\ec92"; }

.ri-emotion-sad-fill:before {
  content: "\\ec93"; }

.ri-emotion-sad-line:before {
  content: "\\ec94"; }

.ri-emotion-unhappy-fill:before {
  content: "\\ec95"; }

.ri-emotion-unhappy-line:before {
  content: "\\ec96"; }

.ri-empathize-fill:before {
  content: "\\ec97"; }

.ri-empathize-line:before {
  content: "\\ec98"; }

.ri-emphasis-cn:before {
  content: "\\ec99"; }

.ri-emphasis:before {
  content: "\\ec9a"; }

.ri-english-input:before {
  content: "\\ec9b"; }

.ri-equalizer-fill:before {
  content: "\\ec9c"; }

.ri-equalizer-line:before {
  content: "\\ec9d"; }

.ri-eraser-fill:before {
  content: "\\ec9e"; }

.ri-eraser-line:before {
  content: "\\ec9f"; }

.ri-error-warning-fill:before {
  content: "\\eca0"; }

.ri-error-warning-line:before {
  content: "\\eca1"; }

.ri-evernote-fill:before {
  content: "\\eca2"; }

.ri-evernote-line:before {
  content: "\\eca3"; }

.ri-exchange-box-fill:before {
  content: "\\eca4"; }

.ri-exchange-box-line:before {
  content: "\\eca5"; }

.ri-exchange-cny-fill:before {
  content: "\\eca6"; }

.ri-exchange-cny-line:before {
  content: "\\eca7"; }

.ri-exchange-dollar-fill:before {
  content: "\\eca8"; }

.ri-exchange-dollar-line:before {
  content: "\\eca9"; }

.ri-exchange-fill:before {
  content: "\\ecaa"; }

.ri-exchange-funds-fill:before {
  content: "\\ecab"; }

.ri-exchange-funds-line:before {
  content: "\\ecac"; }

.ri-exchange-line:before {
  content: "\\ecad"; }

.ri-external-link-fill:before {
  content: "\\ecae"; }

.ri-external-link-line:before {
  content: "\\ecaf"; }

.ri-eye-2-fill:before {
  content: "\\ecb0"; }

.ri-eye-2-line:before {
  content: "\\ecb1"; }

.ri-eye-close-fill:before {
  content: "\\ecb2"; }

.ri-eye-close-line:before {
  content: "\\ecb3"; }

.ri-eye-fill:before {
  content: "\\ecb4"; }

.ri-eye-line:before {
  content: "\\ecb5"; }

.ri-eye-off-fill:before {
  content: "\\ecb6"; }

.ri-eye-off-line:before {
  content: "\\ecb7"; }

.ri-facebook-box-fill:before {
  content: "\\ecb8"; }

.ri-facebook-box-line:before {
  content: "\\ecb9"; }

.ri-facebook-circle-fill:before {
  content: "\\ecba"; }

.ri-facebook-circle-line:before {
  content: "\\ecbb"; }

.ri-facebook-fill:before {
  content: "\\ecbc"; }

.ri-facebook-line:before {
  content: "\\ecbd"; }

.ri-fahrenheit-fill:before {
  content: "\\ecbe"; }

.ri-fahrenheit-line:before {
  content: "\\ecbf"; }

.ri-feedback-fill:before {
  content: "\\ecc0"; }

.ri-feedback-line:before {
  content: "\\ecc1"; }

.ri-file-2-fill:before {
  content: "\\ecc2"; }

.ri-file-2-line:before {
  content: "\\ecc3"; }

.ri-file-3-fill:before {
  content: "\\ecc4"; }

.ri-file-3-line:before {
  content: "\\ecc5"; }

.ri-file-4-fill:before {
  content: "\\ecc6"; }

.ri-file-4-line:before {
  content: "\\ecc7"; }

.ri-file-add-fill:before {
  content: "\\ecc8"; }

.ri-file-add-line:before {
  content: "\\ecc9"; }

.ri-file-chart-2-fill:before {
  content: "\\ecca"; }

.ri-file-chart-2-line:before {
  content: "\\eccb"; }

.ri-file-chart-fill:before {
  content: "\\eccc"; }

.ri-file-chart-line:before {
  content: "\\eccd"; }

.ri-file-cloud-fill:before {
  content: "\\ecce"; }

.ri-file-cloud-line:before {
  content: "\\eccf"; }

.ri-file-code-fill:before {
  content: "\\ecd0"; }

.ri-file-code-line:before {
  content: "\\ecd1"; }

.ri-file-copy-2-fill:before {
  content: "\\ecd2"; }

.ri-file-copy-2-line:before {
  content: "\\ecd3"; }

.ri-file-copy-fill:before {
  content: "\\ecd4"; }

.ri-file-copy-line:before {
  content: "\\ecd5"; }

.ri-file-damage-fill:before {
  content: "\\ecd6"; }

.ri-file-damage-line:before {
  content: "\\ecd7"; }

.ri-file-download-fill:before {
  content: "\\ecd8"; }

.ri-file-download-line:before {
  content: "\\ecd9"; }

.ri-file-edit-fill:before {
  content: "\\ecda"; }

.ri-file-edit-line:before {
  content: "\\ecdb"; }

.ri-file-excel-2-fill:before {
  content: "\\ecdc"; }

.ri-file-excel-2-line:before {
  content: "\\ecdd"; }

.ri-file-excel-fill:before {
  content: "\\ecde"; }

.ri-file-excel-line:before {
  content: "\\ecdf"; }

.ri-file-fill:before {
  content: "\\ece0"; }

.ri-file-forbid-fill:before {
  content: "\\ece1"; }

.ri-file-forbid-line:before {
  content: "\\ece2"; }

.ri-file-gif-fill:before {
  content: "\\ece3"; }

.ri-file-gif-line:before {
  content: "\\ece4"; }

.ri-file-history-fill:before {
  content: "\\ece5"; }

.ri-file-history-line:before {
  content: "\\ece6"; }

.ri-file-hwp-fill:before {
  content: "\\ece7"; }

.ri-file-hwp-line:before {
  content: "\\ece8"; }

.ri-file-info-fill:before {
  content: "\\ece9"; }

.ri-file-info-line:before {
  content: "\\ecea"; }

.ri-file-line:before {
  content: "\\eceb"; }

.ri-file-list-2-fill:before {
  content: "\\ecec"; }

.ri-file-list-2-line:before {
  content: "\\eced"; }

.ri-file-list-3-fill:before {
  content: "\\ecee"; }

.ri-file-list-3-line:before {
  content: "\\ecef"; }

.ri-file-list-fill:before {
  content: "\\ecf0"; }

.ri-file-list-line:before {
  content: "\\ecf1"; }

.ri-file-lock-fill:before {
  content: "\\ecf2"; }

.ri-file-lock-line:before {
  content: "\\ecf3"; }

.ri-file-mark-fill:before {
  content: "\\ecf4"; }

.ri-file-mark-line:before {
  content: "\\ecf5"; }

.ri-file-music-fill:before {
  content: "\\ecf6"; }

.ri-file-music-line:before {
  content: "\\ecf7"; }

.ri-file-paper-2-fill:before {
  content: "\\ecf8"; }

.ri-file-paper-2-line:before {
  content: "\\ecf9"; }

.ri-file-paper-fill:before {
  content: "\\ecfa"; }

.ri-file-paper-line:before {
  content: "\\ecfb"; }

.ri-file-pdf-fill:before {
  content: "\\ecfc"; }

.ri-file-pdf-line:before {
  content: "\\ecfd"; }

.ri-file-ppt-2-fill:before {
  content: "\\ecfe"; }

.ri-file-ppt-2-line:before {
  content: "\\ecff"; }

.ri-file-ppt-fill:before {
  content: "\\ed00"; }

.ri-file-ppt-line:before {
  content: "\\ed01"; }

.ri-file-reduce-fill:before {
  content: "\\ed02"; }

.ri-file-reduce-line:before {
  content: "\\ed03"; }

.ri-file-search-fill:before {
  content: "\\ed04"; }

.ri-file-search-line:before {
  content: "\\ed05"; }

.ri-file-settings-fill:before {
  content: "\\ed06"; }

.ri-file-settings-line:before {
  content: "\\ed07"; }

.ri-file-shield-2-fill:before {
  content: "\\ed08"; }

.ri-file-shield-2-line:before {
  content: "\\ed09"; }

.ri-file-shield-fill:before {
  content: "\\ed0a"; }

.ri-file-shield-line:before {
  content: "\\ed0b"; }

.ri-file-shred-fill:before {
  content: "\\ed0c"; }

.ri-file-shred-line:before {
  content: "\\ed0d"; }

.ri-file-text-fill:before {
  content: "\\ed0e"; }

.ri-file-text-line:before {
  content: "\\ed0f"; }

.ri-file-transfer-fill:before {
  content: "\\ed10"; }

.ri-file-transfer-line:before {
  content: "\\ed11"; }

.ri-file-unknow-fill:before {
  content: "\\ed12"; }

.ri-file-unknow-line:before {
  content: "\\ed13"; }

.ri-file-upload-fill:before {
  content: "\\ed14"; }

.ri-file-upload-line:before {
  content: "\\ed15"; }

.ri-file-user-fill:before {
  content: "\\ed16"; }

.ri-file-user-line:before {
  content: "\\ed17"; }

.ri-file-warning-fill:before {
  content: "\\ed18"; }

.ri-file-warning-line:before {
  content: "\\ed19"; }

.ri-file-word-2-fill:before {
  content: "\\ed1a"; }

.ri-file-word-2-line:before {
  content: "\\ed1b"; }

.ri-file-word-fill:before {
  content: "\\ed1c"; }

.ri-file-word-line:before {
  content: "\\ed1d"; }

.ri-file-zip-fill:before {
  content: "\\ed1e"; }

.ri-file-zip-line:before {
  content: "\\ed1f"; }

.ri-film-fill:before {
  content: "\\ed20"; }

.ri-film-line:before {
  content: "\\ed21"; }

.ri-filter-2-fill:before {
  content: "\\ed22"; }

.ri-filter-2-line:before {
  content: "\\ed23"; }

.ri-filter-3-fill:before {
  content: "\\ed24"; }

.ri-filter-3-line:before {
  content: "\\ed25"; }

.ri-filter-fill:before {
  content: "\\ed26"; }

.ri-filter-line:before {
  content: "\\ed27"; }

.ri-filter-off-fill:before {
  content: "\\ed28"; }

.ri-filter-off-line:before {
  content: "\\ed29"; }

.ri-find-replace-fill:before {
  content: "\\ed2a"; }

.ri-find-replace-line:before {
  content: "\\ed2b"; }

.ri-finder-fill:before {
  content: "\\ed2c"; }

.ri-finder-line:before {
  content: "\\ed2d"; }

.ri-fingerprint-2-fill:before {
  content: "\\ed2e"; }

.ri-fingerprint-2-line:before {
  content: "\\ed2f"; }

.ri-fingerprint-fill:before {
  content: "\\ed30"; }

.ri-fingerprint-line:before {
  content: "\\ed31"; }

.ri-fire-fill:before {
  content: "\\ed32"; }

.ri-fire-line:before {
  content: "\\ed33"; }

.ri-firefox-fill:before {
  content: "\\ed34"; }

.ri-firefox-line:before {
  content: "\\ed35"; }

.ri-first-aid-kit-fill:before {
  content: "\\ed36"; }

.ri-first-aid-kit-line:before {
  content: "\\ed37"; }

.ri-flag-2-fill:before {
  content: "\\ed38"; }

.ri-flag-2-line:before {
  content: "\\ed39"; }

.ri-flag-fill:before {
  content: "\\ed3a"; }

.ri-flag-line:before {
  content: "\\ed3b"; }

.ri-flashlight-fill:before {
  content: "\\ed3c"; }

.ri-flashlight-line:before {
  content: "\\ed3d"; }

.ri-flask-fill:before {
  content: "\\ed3e"; }

.ri-flask-line:before {
  content: "\\ed3f"; }

.ri-flight-land-fill:before {
  content: "\\ed40"; }

.ri-flight-land-line:before {
  content: "\\ed41"; }

.ri-flight-takeoff-fill:before {
  content: "\\ed42"; }

.ri-flight-takeoff-line:before {
  content: "\\ed43"; }

.ri-flood-fill:before {
  content: "\\ed44"; }

.ri-flood-line:before {
  content: "\\ed45"; }

.ri-flow-chart:before {
  content: "\\ed46"; }

.ri-flutter-fill:before {
  content: "\\ed47"; }

.ri-flutter-line:before {
  content: "\\ed48"; }

.ri-focus-2-fill:before {
  content: "\\ed49"; }

.ri-focus-2-line:before {
  content: "\\ed4a"; }

.ri-focus-3-fill:before {
  content: "\\ed4b"; }

.ri-focus-3-line:before {
  content: "\\ed4c"; }

.ri-focus-fill:before {
  content: "\\ed4d"; }

.ri-focus-line:before {
  content: "\\ed4e"; }

.ri-foggy-fill:before {
  content: "\\ed4f"; }

.ri-foggy-line:before {
  content: "\\ed50"; }

.ri-folder-2-fill:before {
  content: "\\ed51"; }

.ri-folder-2-line:before {
  content: "\\ed52"; }

.ri-folder-3-fill:before {
  content: "\\ed53"; }

.ri-folder-3-line:before {
  content: "\\ed54"; }

.ri-folder-4-fill:before {
  content: "\\ed55"; }

.ri-folder-4-line:before {
  content: "\\ed56"; }

.ri-folder-5-fill:before {
  content: "\\ed57"; }

.ri-folder-5-line:before {
  content: "\\ed58"; }

.ri-folder-add-fill:before {
  content: "\\ed59"; }

.ri-folder-add-line:before {
  content: "\\ed5a"; }

.ri-folder-chart-2-fill:before {
  content: "\\ed5b"; }

.ri-folder-chart-2-line:before {
  content: "\\ed5c"; }

.ri-folder-chart-fill:before {
  content: "\\ed5d"; }

.ri-folder-chart-line:before {
  content: "\\ed5e"; }

.ri-folder-download-fill:before {
  content: "\\ed5f"; }

.ri-folder-download-line:before {
  content: "\\ed60"; }

.ri-folder-fill:before {
  content: "\\ed61"; }

.ri-folder-forbid-fill:before {
  content: "\\ed62"; }

.ri-folder-forbid-line:before {
  content: "\\ed63"; }

.ri-folder-history-fill:before {
  content: "\\ed64"; }

.ri-folder-history-line:before {
  content: "\\ed65"; }

.ri-folder-info-fill:before {
  content: "\\ed66"; }

.ri-folder-info-line:before {
  content: "\\ed67"; }

.ri-folder-keyhole-fill:before {
  content: "\\ed68"; }

.ri-folder-keyhole-line:before {
  content: "\\ed69"; }

.ri-folder-line:before {
  content: "\\ed6a"; }

.ri-folder-lock-fill:before {
  content: "\\ed6b"; }

.ri-folder-lock-line:before {
  content: "\\ed6c"; }

.ri-folder-music-fill:before {
  content: "\\ed6d"; }

.ri-folder-music-line:before {
  content: "\\ed6e"; }

.ri-folder-open-fill:before {
  content: "\\ed6f"; }

.ri-folder-open-line:before {
  content: "\\ed70"; }

.ri-folder-received-fill:before {
  content: "\\ed71"; }

.ri-folder-received-line:before {
  content: "\\ed72"; }

.ri-folder-reduce-fill:before {
  content: "\\ed73"; }

.ri-folder-reduce-line:before {
  content: "\\ed74"; }

.ri-folder-settings-fill:before {
  content: "\\ed75"; }

.ri-folder-settings-line:before {
  content: "\\ed76"; }

.ri-folder-shared-fill:before {
  content: "\\ed77"; }

.ri-folder-shared-line:before {
  content: "\\ed78"; }

.ri-folder-shield-2-fill:before {
  content: "\\ed79"; }

.ri-folder-shield-2-line:before {
  content: "\\ed7a"; }

.ri-folder-shield-fill:before {
  content: "\\ed7b"; }

.ri-folder-shield-line:before {
  content: "\\ed7c"; }

.ri-folder-transfer-fill:before {
  content: "\\ed7d"; }

.ri-folder-transfer-line:before {
  content: "\\ed7e"; }

.ri-folder-unknow-fill:before {
  content: "\\ed7f"; }

.ri-folder-unknow-line:before {
  content: "\\ed80"; }

.ri-folder-upload-fill:before {
  content: "\\ed81"; }

.ri-folder-upload-line:before {
  content: "\\ed82"; }

.ri-folder-user-fill:before {
  content: "\\ed83"; }

.ri-folder-user-line:before {
  content: "\\ed84"; }

.ri-folder-warning-fill:before {
  content: "\\ed85"; }

.ri-folder-warning-line:before {
  content: "\\ed86"; }

.ri-folder-zip-fill:before {
  content: "\\ed87"; }

.ri-folder-zip-line:before {
  content: "\\ed88"; }

.ri-folders-fill:before {
  content: "\\ed89"; }

.ri-folders-line:before {
  content: "\\ed8a"; }

.ri-font-color:before {
  content: "\\ed8b"; }

.ri-font-size-2:before {
  content: "\\ed8c"; }

.ri-font-size:before {
  content: "\\ed8d"; }

.ri-football-fill:before {
  content: "\\ed8e"; }

.ri-football-line:before {
  content: "\\ed8f"; }

.ri-footprint-fill:before {
  content: "\\ed90"; }

.ri-footprint-line:before {
  content: "\\ed91"; }

.ri-forbid-2-fill:before {
  content: "\\ed92"; }

.ri-forbid-2-line:before {
  content: "\\ed93"; }

.ri-forbid-fill:before {
  content: "\\ed94"; }

.ri-forbid-line:before {
  content: "\\ed95"; }

.ri-format-clear:before {
  content: "\\ed96"; }

.ri-fridge-fill:before {
  content: "\\ed97"; }

.ri-fridge-line:before {
  content: "\\ed98"; }

.ri-fullscreen-exit-fill:before {
  content: "\\ed99"; }

.ri-fullscreen-exit-line:before {
  content: "\\ed9a"; }

.ri-fullscreen-fill:before {
  content: "\\ed9b"; }

.ri-fullscreen-line:before {
  content: "\\ed9c"; }

.ri-function-fill:before {
  content: "\\ed9d"; }

.ri-function-line:before {
  content: "\\ed9e"; }

.ri-functions:before {
  content: "\\ed9f"; }

.ri-funds-box-fill:before {
  content: "\\eda0"; }

.ri-funds-box-line:before {
  content: "\\eda1"; }

.ri-funds-fill:before {
  content: "\\eda2"; }

.ri-funds-line:before {
  content: "\\eda3"; }

.ri-gallery-fill:before {
  content: "\\eda4"; }

.ri-gallery-line:before {
  content: "\\eda5"; }

.ri-gallery-upload-fill:before {
  content: "\\eda6"; }

.ri-gallery-upload-line:before {
  content: "\\eda7"; }

.ri-game-fill:before {
  content: "\\eda8"; }

.ri-game-line:before {
  content: "\\eda9"; }

.ri-gamepad-fill:before {
  content: "\\edaa"; }

.ri-gamepad-line:before {
  content: "\\edab"; }

.ri-gas-station-fill:before {
  content: "\\edac"; }

.ri-gas-station-line:before {
  content: "\\edad"; }

.ri-gatsby-fill:before {
  content: "\\edae"; }

.ri-gatsby-line:before {
  content: "\\edaf"; }

.ri-genderless-fill:before {
  content: "\\edb0"; }

.ri-genderless-line:before {
  content: "\\edb1"; }

.ri-ghost-2-fill:before {
  content: "\\edb2"; }

.ri-ghost-2-line:before {
  content: "\\edb3"; }

.ri-ghost-fill:before {
  content: "\\edb4"; }

.ri-ghost-line:before {
  content: "\\edb5"; }

.ri-ghost-smile-fill:before {
  content: "\\edb6"; }

.ri-ghost-smile-line:before {
  content: "\\edb7"; }

.ri-gift-2-fill:before {
  content: "\\edb8"; }

.ri-gift-2-line:before {
  content: "\\edb9"; }

.ri-gift-fill:before {
  content: "\\edba"; }

.ri-gift-line:before {
  content: "\\edbb"; }

.ri-git-branch-fill:before {
  content: "\\edbc"; }

.ri-git-branch-line:before {
  content: "\\edbd"; }

.ri-git-commit-fill:before {
  content: "\\edbe"; }

.ri-git-commit-line:before {
  content: "\\edbf"; }

.ri-git-merge-fill:before {
  content: "\\edc0"; }

.ri-git-merge-line:before {
  content: "\\edc1"; }

.ri-git-pull-request-fill:before {
  content: "\\edc2"; }

.ri-git-pull-request-line:before {
  content: "\\edc3"; }

.ri-git-repository-commits-fill:before {
  content: "\\edc4"; }

.ri-git-repository-commits-line:before {
  content: "\\edc5"; }

.ri-git-repository-fill:before {
  content: "\\edc6"; }

.ri-git-repository-line:before {
  content: "\\edc7"; }

.ri-git-repository-private-fill:before {
  content: "\\edc8"; }

.ri-git-repository-private-line:before {
  content: "\\edc9"; }

.ri-github-fill:before {
  content: "\\edca"; }

.ri-github-line:before {
  content: "\\edcb"; }

.ri-gitlab-fill:before {
  content: "\\edcc"; }

.ri-gitlab-line:before {
  content: "\\edcd"; }

.ri-global-fill:before {
  content: "\\edce"; }

.ri-global-line:before {
  content: "\\edcf"; }

.ri-globe-fill:before {
  content: "\\edd0"; }

.ri-globe-line:before {
  content: "\\edd1"; }

.ri-goblet-fill:before {
  content: "\\edd2"; }

.ri-goblet-line:before {
  content: "\\edd3"; }

.ri-google-fill:before {
  content: "\\edd4"; }

.ri-google-line:before {
  content: "\\edd5"; }

.ri-google-play-fill:before {
  content: "\\edd6"; }

.ri-google-play-line:before {
  content: "\\edd7"; }

.ri-government-fill:before {
  content: "\\edd8"; }

.ri-government-line:before {
  content: "\\edd9"; }

.ri-gps-fill:before {
  content: "\\edda"; }

.ri-gps-line:before {
  content: "\\eddb"; }

.ri-gradienter-fill:before {
  content: "\\eddc"; }

.ri-gradienter-line:before {
  content: "\\eddd"; }

.ri-grid-fill:before {
  content: "\\edde"; }

.ri-grid-line:before {
  content: "\\eddf"; }

.ri-group-2-fill:before {
  content: "\\ede0"; }

.ri-group-2-line:before {
  content: "\\ede1"; }

.ri-group-fill:before {
  content: "\\ede2"; }

.ri-group-line:before {
  content: "\\ede3"; }

.ri-guide-fill:before {
  content: "\\ede4"; }

.ri-guide-line:before {
  content: "\\ede5"; }

.ri-h-1:before {
  content: "\\ede6"; }

.ri-h-2:before {
  content: "\\ede7"; }

.ri-h-3:before {
  content: "\\ede8"; }

.ri-h-4:before {
  content: "\\ede9"; }

.ri-h-5:before {
  content: "\\edea"; }

.ri-h-6:before {
  content: "\\edeb"; }

.ri-hail-fill:before {
  content: "\\edec"; }

.ri-hail-line:before {
  content: "\\eded"; }

.ri-hammer-fill:before {
  content: "\\edee"; }

.ri-hammer-line:before {
  content: "\\edef"; }

.ri-hand-coin-fill:before {
  content: "\\edf0"; }

.ri-hand-coin-line:before {
  content: "\\edf1"; }

.ri-hand-heart-fill:before {
  content: "\\edf2"; }

.ri-hand-heart-line:before {
  content: "\\edf3"; }

.ri-hand-sanitizer-fill:before {
  content: "\\edf4"; }

.ri-hand-sanitizer-line:before {
  content: "\\edf5"; }

.ri-handbag-fill:before {
  content: "\\edf6"; }

.ri-handbag-line:before {
  content: "\\edf7"; }

.ri-hard-drive-2-fill:before {
  content: "\\edf8"; }

.ri-hard-drive-2-line:before {
  content: "\\edf9"; }

.ri-hard-drive-fill:before {
  content: "\\edfa"; }

.ri-hard-drive-line:before {
  content: "\\edfb"; }

.ri-hashtag:before {
  content: "\\edfc"; }

.ri-haze-2-fill:before {
  content: "\\edfd"; }

.ri-haze-2-line:before {
  content: "\\edfe"; }

.ri-haze-fill:before {
  content: "\\edff"; }

.ri-haze-line:before {
  content: "\\ee00"; }

.ri-hd-fill:before {
  content: "\\ee01"; }

.ri-hd-line:before {
  content: "\\ee02"; }

.ri-heading:before {
  content: "\\ee03"; }

.ri-headphone-fill:before {
  content: "\\ee04"; }

.ri-headphone-line:before {
  content: "\\ee05"; }

.ri-health-book-fill:before {
  content: "\\ee06"; }

.ri-health-book-line:before {
  content: "\\ee07"; }

.ri-heart-2-fill:before {
  content: "\\ee08"; }

.ri-heart-2-line:before {
  content: "\\ee09"; }

.ri-heart-3-fill:before {
  content: "\\ee0a"; }

.ri-heart-3-line:before {
  content: "\\ee0b"; }

.ri-heart-add-fill:before {
  content: "\\ee0c"; }

.ri-heart-add-line:before {
  content: "\\ee0d"; }

.ri-heart-fill:before {
  content: "\\ee0e"; }

.ri-heart-line:before {
  content: "\\ee0f"; }

.ri-heart-pulse-fill:before {
  content: "\\ee10"; }

.ri-heart-pulse-line:before {
  content: "\\ee11"; }

.ri-hearts-fill:before {
  content: "\\ee12"; }

.ri-hearts-line:before {
  content: "\\ee13"; }

.ri-heavy-showers-fill:before {
  content: "\\ee14"; }

.ri-heavy-showers-line:before {
  content: "\\ee15"; }

.ri-history-fill:before {
  content: "\\ee16"; }

.ri-history-line:before {
  content: "\\ee17"; }

.ri-home-2-fill:before {
  content: "\\ee18"; }

.ri-home-2-line:before {
  content: "\\ee19"; }

.ri-home-3-fill:before {
  content: "\\ee1a"; }

.ri-home-3-line:before {
  content: "\\ee1b"; }

.ri-home-4-fill:before {
  content: "\\ee1c"; }

.ri-home-4-line:before {
  content: "\\ee1d"; }

.ri-home-5-fill:before {
  content: "\\ee1e"; }

.ri-home-5-line:before {
  content: "\\ee1f"; }

.ri-home-6-fill:before {
  content: "\\ee20"; }

.ri-home-6-line:before {
  content: "\\ee21"; }

.ri-home-7-fill:before {
  content: "\\ee22"; }

.ri-home-7-line:before {
  content: "\\ee23"; }

.ri-home-8-fill:before {
  content: "\\ee24"; }

.ri-home-8-line:before {
  content: "\\ee25"; }

.ri-home-fill:before {
  content: "\\ee26"; }

.ri-home-gear-fill:before {
  content: "\\ee27"; }

.ri-home-gear-line:before {
  content: "\\ee28"; }

.ri-home-heart-fill:before {
  content: "\\ee29"; }

.ri-home-heart-line:before {
  content: "\\ee2a"; }

.ri-home-line:before {
  content: "\\ee2b"; }

.ri-home-smile-2-fill:before {
  content: "\\ee2c"; }

.ri-home-smile-2-line:before {
  content: "\\ee2d"; }

.ri-home-smile-fill:before {
  content: "\\ee2e"; }

.ri-home-smile-line:before {
  content: "\\ee2f"; }

.ri-home-wifi-fill:before {
  content: "\\ee30"; }

.ri-home-wifi-line:before {
  content: "\\ee31"; }

.ri-honor-of-kings-fill:before {
  content: "\\ee32"; }

.ri-honor-of-kings-line:before {
  content: "\\ee33"; }

.ri-honour-fill:before {
  content: "\\ee34"; }

.ri-honour-line:before {
  content: "\\ee35"; }

.ri-hospital-fill:before {
  content: "\\ee36"; }

.ri-hospital-line:before {
  content: "\\ee37"; }

.ri-hotel-bed-fill:before {
  content: "\\ee38"; }

.ri-hotel-bed-line:before {
  content: "\\ee39"; }

.ri-hotel-fill:before {
  content: "\\ee3a"; }

.ri-hotel-line:before {
  content: "\\ee3b"; }

.ri-hotspot-fill:before {
  content: "\\ee3c"; }

.ri-hotspot-line:before {
  content: "\\ee3d"; }

.ri-hq-fill:before {
  content: "\\ee3e"; }

.ri-hq-line:before {
  content: "\\ee3f"; }

.ri-html5-fill:before {
  content: "\\ee40"; }

.ri-html5-line:before {
  content: "\\ee41"; }

.ri-ie-fill:before {
  content: "\\ee42"; }

.ri-ie-line:before {
  content: "\\ee43"; }

.ri-image-2-fill:before {
  content: "\\ee44"; }

.ri-image-2-line:before {
  content: "\\ee45"; }

.ri-image-add-fill:before {
  content: "\\ee46"; }

.ri-image-add-line:before {
  content: "\\ee47"; }

.ri-image-edit-fill:before {
  content: "\\ee48"; }

.ri-image-edit-line:before {
  content: "\\ee49"; }

.ri-image-fill:before {
  content: "\\ee4a"; }

.ri-image-line:before {
  content: "\\ee4b"; }

.ri-inbox-archive-fill:before {
  content: "\\ee4c"; }

.ri-inbox-archive-line:before {
  content: "\\ee4d"; }

.ri-inbox-fill:before {
  content: "\\ee4e"; }

.ri-inbox-line:before {
  content: "\\ee4f"; }

.ri-inbox-unarchive-fill:before {
  content: "\\ee50"; }

.ri-inbox-unarchive-line:before {
  content: "\\ee51"; }

.ri-increase-decrease-fill:before {
  content: "\\ee52"; }

.ri-increase-decrease-line:before {
  content: "\\ee53"; }

.ri-indent-decrease:before {
  content: "\\ee54"; }

.ri-indent-increase:before {
  content: "\\ee55"; }

.ri-indeterminate-circle-fill:before {
  content: "\\ee56"; }

.ri-indeterminate-circle-line:before {
  content: "\\ee57"; }

.ri-information-fill:before {
  content: "\\ee58"; }

.ri-information-line:before {
  content: "\\ee59"; }

.ri-infrared-thermometer-fill:before {
  content: "\\ee5a"; }

.ri-infrared-thermometer-line:before {
  content: "\\ee5b"; }

.ri-ink-bottle-fill:before {
  content: "\\ee5c"; }

.ri-ink-bottle-line:before {
  content: "\\ee5d"; }

.ri-input-cursor-move:before {
  content: "\\ee5e"; }

.ri-input-method-fill:before {
  content: "\\ee5f"; }

.ri-input-method-line:before {
  content: "\\ee60"; }

.ri-insert-column-left:before {
  content: "\\ee61"; }

.ri-insert-column-right:before {
  content: "\\ee62"; }

.ri-insert-row-bottom:before {
  content: "\\ee63"; }

.ri-insert-row-top:before {
  content: "\\ee64"; }

.ri-instagram-fill:before {
  content: "\\ee65"; }

.ri-instagram-line:before {
  content: "\\ee66"; }

.ri-install-fill:before {
  content: "\\ee67"; }

.ri-install-line:before {
  content: "\\ee68"; }

.ri-invision-fill:before {
  content: "\\ee69"; }

.ri-invision-line:before {
  content: "\\ee6a"; }

.ri-italic:before {
  content: "\\ee6b"; }

.ri-kakao-talk-fill:before {
  content: "\\ee6c"; }

.ri-kakao-talk-line:before {
  content: "\\ee6d"; }

.ri-key-2-fill:before {
  content: "\\ee6e"; }

.ri-key-2-line:before {
  content: "\\ee6f"; }

.ri-key-fill:before {
  content: "\\ee70"; }

.ri-key-line:before {
  content: "\\ee71"; }

.ri-keyboard-box-fill:before {
  content: "\\ee72"; }

.ri-keyboard-box-line:before {
  content: "\\ee73"; }

.ri-keyboard-fill:before {
  content: "\\ee74"; }

.ri-keyboard-line:before {
  content: "\\ee75"; }

.ri-keynote-fill:before {
  content: "\\ee76"; }

.ri-keynote-line:before {
  content: "\\ee77"; }

.ri-knife-blood-fill:before {
  content: "\\ee78"; }

.ri-knife-blood-line:before {
  content: "\\ee79"; }

.ri-knife-fill:before {
  content: "\\ee7a"; }

.ri-knife-line:before {
  content: "\\ee7b"; }

.ri-landscape-fill:before {
  content: "\\ee7c"; }

.ri-landscape-line:before {
  content: "\\ee7d"; }

.ri-layout-2-fill:before {
  content: "\\ee7e"; }

.ri-layout-2-line:before {
  content: "\\ee7f"; }

.ri-layout-3-fill:before {
  content: "\\ee80"; }

.ri-layout-3-line:before {
  content: "\\ee81"; }

.ri-layout-4-fill:before {
  content: "\\ee82"; }

.ri-layout-4-line:before {
  content: "\\ee83"; }

.ri-layout-5-fill:before {
  content: "\\ee84"; }

.ri-layout-5-line:before {
  content: "\\ee85"; }

.ri-layout-6-fill:before {
  content: "\\ee86"; }

.ri-layout-6-line:before {
  content: "\\ee87"; }

.ri-layout-bottom-2-fill:before {
  content: "\\ee88"; }

.ri-layout-bottom-2-line:before {
  content: "\\ee89"; }

.ri-layout-bottom-fill:before {
  content: "\\ee8a"; }

.ri-layout-bottom-line:before {
  content: "\\ee8b"; }

.ri-layout-column-fill:before {
  content: "\\ee8c"; }

.ri-layout-column-line:before {
  content: "\\ee8d"; }

.ri-layout-fill:before {
  content: "\\ee8e"; }

.ri-layout-grid-fill:before {
  content: "\\ee8f"; }

.ri-layout-grid-line:before {
  content: "\\ee90"; }

.ri-layout-left-2-fill:before {
  content: "\\ee91"; }

.ri-layout-left-2-line:before {
  content: "\\ee92"; }

.ri-layout-left-fill:before {
  content: "\\ee93"; }

.ri-layout-left-line:before {
  content: "\\ee94"; }

.ri-layout-line:before {
  content: "\\ee95"; }

.ri-layout-masonry-fill:before {
  content: "\\ee96"; }

.ri-layout-masonry-line:before {
  content: "\\ee97"; }

.ri-layout-right-2-fill:before {
  content: "\\ee98"; }

.ri-layout-right-2-line:before {
  content: "\\ee99"; }

.ri-layout-right-fill:before {
  content: "\\ee9a"; }

.ri-layout-right-line:before {
  content: "\\ee9b"; }

.ri-layout-row-fill:before {
  content: "\\ee9c"; }

.ri-layout-row-line:before {
  content: "\\ee9d"; }

.ri-layout-top-2-fill:before {
  content: "\\ee9e"; }

.ri-layout-top-2-line:before {
  content: "\\ee9f"; }

.ri-layout-top-fill:before {
  content: "\\eea0"; }

.ri-layout-top-line:before {
  content: "\\eea1"; }

.ri-leaf-fill:before {
  content: "\\eea2"; }

.ri-leaf-line:before {
  content: "\\eea3"; }

.ri-lifebuoy-fill:before {
  content: "\\eea4"; }

.ri-lifebuoy-line:before {
  content: "\\eea5"; }

.ri-lightbulb-fill:before {
  content: "\\eea6"; }

.ri-lightbulb-flash-fill:before {
  content: "\\eea7"; }

.ri-lightbulb-flash-line:before {
  content: "\\eea8"; }

.ri-lightbulb-line:before {
  content: "\\eea9"; }

.ri-line-chart-fill:before {
  content: "\\eeaa"; }

.ri-line-chart-line:before {
  content: "\\eeab"; }

.ri-line-fill:before {
  content: "\\eeac"; }

.ri-line-height:before {
  content: "\\eead"; }

.ri-line-line:before {
  content: "\\eeae"; }

.ri-link-m:before {
  content: "\\eeaf"; }

.ri-link-unlink-m:before {
  content: "\\eeb0"; }

.ri-link-unlink:before {
  content: "\\eeb1"; }

.ri-link:before {
  content: "\\eeb2"; }

.ri-linkedin-box-fill:before {
  content: "\\eeb3"; }

.ri-linkedin-box-line:before {
  content: "\\eeb4"; }

.ri-linkedin-fill:before {
  content: "\\eeb5"; }

.ri-linkedin-line:before {
  content: "\\eeb6"; }

.ri-links-fill:before {
  content: "\\eeb7"; }

.ri-links-line:before {
  content: "\\eeb8"; }

.ri-list-check-2:before {
  content: "\\eeb9"; }

.ri-list-check:before {
  content: "\\eeba"; }

.ri-list-ordered:before {
  content: "\\eebb"; }

.ri-list-settings-fill:before {
  content: "\\eebc"; }

.ri-list-settings-line:before {
  content: "\\eebd"; }

.ri-list-unordered:before {
  content: "\\eebe"; }

.ri-live-fill:before {
  content: "\\eebf"; }

.ri-live-line:before {
  content: "\\eec0"; }

.ri-loader-2-fill:before {
  content: "\\eec1"; }

.ri-loader-2-line:before {
  content: "\\eec2"; }

.ri-loader-3-fill:before {
  content: "\\eec3"; }

.ri-loader-3-line:before {
  content: "\\eec4"; }

.ri-loader-4-fill:before {
  content: "\\eec5"; }

.ri-loader-4-line:before {
  content: "\\eec6"; }

.ri-loader-5-fill:before {
  content: "\\eec7"; }

.ri-loader-5-line:before {
  content: "\\eec8"; }

.ri-loader-fill:before {
  content: "\\eec9"; }

.ri-loader-line:before {
  content: "\\eeca"; }

.ri-lock-2-fill:before {
  content: "\\eecb"; }

.ri-lock-2-line:before {
  content: "\\eecc"; }

.ri-lock-fill:before {
  content: "\\eecd"; }

.ri-lock-line:before {
  content: "\\eece"; }

.ri-lock-password-fill:before {
  content: "\\eecf"; }

.ri-lock-password-line:before {
  content: "\\eed0"; }

.ri-lock-unlock-fill:before {
  content: "\\eed1"; }

.ri-lock-unlock-line:before {
  content: "\\eed2"; }

.ri-login-box-fill:before {
  content: "\\eed3"; }

.ri-login-box-line:before {
  content: "\\eed4"; }

.ri-login-circle-fill:before {
  content: "\\eed5"; }

.ri-login-circle-line:before {
  content: "\\eed6"; }

.ri-logout-box-fill:before {
  content: "\\eed7"; }

.ri-logout-box-line:before {
  content: "\\eed8"; }

.ri-logout-box-r-fill:before {
  content: "\\eed9"; }

.ri-logout-box-r-line:before {
  content: "\\eeda"; }

.ri-logout-circle-fill:before {
  content: "\\eedb"; }

.ri-logout-circle-line:before {
  content: "\\eedc"; }

.ri-logout-circle-r-fill:before {
  content: "\\eedd"; }

.ri-logout-circle-r-line:before {
  content: "\\eede"; }

.ri-luggage-cart-fill:before {
  content: "\\eedf"; }

.ri-luggage-cart-line:before {
  content: "\\eee0"; }

.ri-luggage-deposit-fill:before {
  content: "\\eee1"; }

.ri-luggage-deposit-line:before {
  content: "\\eee2"; }

.ri-lungs-fill:before {
  content: "\\eee3"; }

.ri-lungs-line:before {
  content: "\\eee4"; }

.ri-mac-fill:before {
  content: "\\eee5"; }

.ri-mac-line:before {
  content: "\\eee6"; }

.ri-macbook-fill:before {
  content: "\\eee7"; }

.ri-macbook-line:before {
  content: "\\eee8"; }

.ri-magic-fill:before {
  content: "\\eee9"; }

.ri-magic-line:before {
  content: "\\eeea"; }

.ri-mail-add-fill:before {
  content: "\\eeeb"; }

.ri-mail-add-line:before {
  content: "\\eeec"; }

.ri-mail-check-fill:before {
  content: "\\eeed"; }

.ri-mail-check-line:before {
  content: "\\eeee"; }

.ri-mail-close-fill:before {
  content: "\\eeef"; }

.ri-mail-close-line:before {
  content: "\\eef0"; }

.ri-mail-download-fill:before {
  content: "\\eef1"; }

.ri-mail-download-line:before {
  content: "\\eef2"; }

.ri-mail-fill:before {
  content: "\\eef3"; }

.ri-mail-forbid-fill:before {
  content: "\\eef4"; }

.ri-mail-forbid-line:before {
  content: "\\eef5"; }

.ri-mail-line:before {
  content: "\\eef6"; }

.ri-mail-lock-fill:before {
  content: "\\eef7"; }

.ri-mail-lock-line:before {
  content: "\\eef8"; }

.ri-mail-open-fill:before {
  content: "\\eef9"; }

.ri-mail-open-line:before {
  content: "\\eefa"; }

.ri-mail-send-fill:before {
  content: "\\eefb"; }

.ri-mail-send-line:before {
  content: "\\eefc"; }

.ri-mail-settings-fill:before {
  content: "\\eefd"; }

.ri-mail-settings-line:before {
  content: "\\eefe"; }

.ri-mail-star-fill:before {
  content: "\\eeff"; }

.ri-mail-star-line:before {
  content: "\\ef00"; }

.ri-mail-unread-fill:before {
  content: "\\ef01"; }

.ri-mail-unread-line:before {
  content: "\\ef02"; }

.ri-mail-volume-fill:before {
  content: "\\ef03"; }

.ri-mail-volume-line:before {
  content: "\\ef04"; }

.ri-map-2-fill:before {
  content: "\\ef05"; }

.ri-map-2-line:before {
  content: "\\ef06"; }

.ri-map-fill:before {
  content: "\\ef07"; }

.ri-map-line:before {
  content: "\\ef08"; }

.ri-map-pin-2-fill:before {
  content: "\\ef09"; }

.ri-map-pin-2-line:before {
  content: "\\ef0a"; }

.ri-map-pin-3-fill:before {
  content: "\\ef0b"; }

.ri-map-pin-3-line:before {
  content: "\\ef0c"; }

.ri-map-pin-4-fill:before {
  content: "\\ef0d"; }

.ri-map-pin-4-line:before {
  content: "\\ef0e"; }

.ri-map-pin-5-fill:before {
  content: "\\ef0f"; }

.ri-map-pin-5-line:before {
  content: "\\ef10"; }

.ri-map-pin-add-fill:before {
  content: "\\ef11"; }

.ri-map-pin-add-line:before {
  content: "\\ef12"; }

.ri-map-pin-fill:before {
  content: "\\ef13"; }

.ri-map-pin-line:before {
  content: "\\ef14"; }

.ri-map-pin-range-fill:before {
  content: "\\ef15"; }

.ri-map-pin-range-line:before {
  content: "\\ef16"; }

.ri-map-pin-time-fill:before {
  content: "\\ef17"; }

.ri-map-pin-time-line:before {
  content: "\\ef18"; }

.ri-map-pin-user-fill:before {
  content: "\\ef19"; }

.ri-map-pin-user-line:before {
  content: "\\ef1a"; }

.ri-mark-pen-fill:before {
  content: "\\ef1b"; }

.ri-mark-pen-line:before {
  content: "\\ef1c"; }

.ri-markdown-fill:before {
  content: "\\ef1d"; }

.ri-markdown-line:before {
  content: "\\ef1e"; }

.ri-markup-fill:before {
  content: "\\ef1f"; }

.ri-markup-line:before {
  content: "\\ef20"; }

.ri-mastercard-fill:before {
  content: "\\ef21"; }

.ri-mastercard-line:before {
  content: "\\ef22"; }

.ri-mastodon-fill:before {
  content: "\\ef23"; }

.ri-mastodon-line:before {
  content: "\\ef24"; }

.ri-medal-2-fill:before {
  content: "\\ef25"; }

.ri-medal-2-line:before {
  content: "\\ef26"; }

.ri-medal-fill:before {
  content: "\\ef27"; }

.ri-medal-line:before {
  content: "\\ef28"; }

.ri-medicine-bottle-fill:before {
  content: "\\ef29"; }

.ri-medicine-bottle-line:before {
  content: "\\ef2a"; }

.ri-medium-fill:before {
  content: "\\ef2b"; }

.ri-medium-line:before {
  content: "\\ef2c"; }

.ri-men-fill:before {
  content: "\\ef2d"; }

.ri-men-line:before {
  content: "\\ef2e"; }

.ri-mental-health-fill:before {
  content: "\\ef2f"; }

.ri-mental-health-line:before {
  content: "\\ef30"; }

.ri-menu-2-fill:before {
  content: "\\ef31"; }

.ri-menu-2-line:before {
  content: "\\ef32"; }

.ri-menu-3-fill:before {
  content: "\\ef33"; }

.ri-menu-3-line:before {
  content: "\\ef34"; }

.ri-menu-4-fill:before {
  content: "\\ef35"; }

.ri-menu-4-line:before {
  content: "\\ef36"; }

.ri-menu-5-fill:before {
  content: "\\ef37"; }

.ri-menu-5-line:before {
  content: "\\ef38"; }

.ri-menu-add-fill:before {
  content: "\\ef39"; }

.ri-menu-add-line:before {
  content: "\\ef3a"; }

.ri-menu-fill:before {
  content: "\\ef3b"; }

.ri-menu-fold-fill:before {
  content: "\\ef3c"; }

.ri-menu-fold-line:before {
  content: "\\ef3d"; }

.ri-menu-line:before {
  content: "\\ef3e"; }

.ri-menu-unfold-fill:before {
  content: "\\ef3f"; }

.ri-menu-unfold-line:before {
  content: "\\ef40"; }

.ri-merge-cells-horizontal:before {
  content: "\\ef41"; }

.ri-merge-cells-vertical:before {
  content: "\\ef42"; }

.ri-message-2-fill:before {
  content: "\\ef43"; }

.ri-message-2-line:before {
  content: "\\ef44"; }

.ri-message-3-fill:before {
  content: "\\ef45"; }

.ri-message-3-line:before {
  content: "\\ef46"; }

.ri-message-fill:before {
  content: "\\ef47"; }

.ri-message-line:before {
  content: "\\ef48"; }

.ri-messenger-fill:before {
  content: "\\ef49"; }

.ri-messenger-line:before {
  content: "\\ef4a"; }

.ri-meteor-fill:before {
  content: "\\ef4b"; }

.ri-meteor-line:before {
  content: "\\ef4c"; }

.ri-mic-2-fill:before {
  content: "\\ef4d"; }

.ri-mic-2-line:before {
  content: "\\ef4e"; }

.ri-mic-fill:before {
  content: "\\ef4f"; }

.ri-mic-line:before {
  content: "\\ef50"; }

.ri-mic-off-fill:before {
  content: "\\ef51"; }

.ri-mic-off-line:before {
  content: "\\ef52"; }

.ri-mickey-fill:before {
  content: "\\ef53"; }

.ri-mickey-line:before {
  content: "\\ef54"; }

.ri-microscope-fill:before {
  content: "\\ef55"; }

.ri-microscope-line:before {
  content: "\\ef56"; }

.ri-microsoft-fill:before {
  content: "\\ef57"; }

.ri-microsoft-line:before {
  content: "\\ef58"; }

.ri-mind-map:before {
  content: "\\ef59"; }

.ri-mini-program-fill:before {
  content: "\\ef5a"; }

.ri-mini-program-line:before {
  content: "\\ef5b"; }

.ri-mist-fill:before {
  content: "\\ef5c"; }

.ri-mist-line:before {
  content: "\\ef5d"; }

.ri-money-cny-box-fill:before {
  content: "\\ef5e"; }

.ri-money-cny-box-line:before {
  content: "\\ef5f"; }

.ri-money-cny-circle-fill:before {
  content: "\\ef60"; }

.ri-money-cny-circle-line:before {
  content: "\\ef61"; }

.ri-money-dollar-box-fill:before {
  content: "\\ef62"; }

.ri-money-dollar-box-line:before {
  content: "\\ef63"; }

.ri-money-dollar-circle-fill:before {
  content: "\\ef64"; }

.ri-money-dollar-circle-line:before {
  content: "\\ef65"; }

.ri-money-euro-box-fill:before {
  content: "\\ef66"; }

.ri-money-euro-box-line:before {
  content: "\\ef67"; }

.ri-money-euro-circle-fill:before {
  content: "\\ef68"; }

.ri-money-euro-circle-line:before {
  content: "\\ef69"; }

.ri-money-pound-box-fill:before {
  content: "\\ef6a"; }

.ri-money-pound-box-line:before {
  content: "\\ef6b"; }

.ri-money-pound-circle-fill:before {
  content: "\\ef6c"; }

.ri-money-pound-circle-line:before {
  content: "\\ef6d"; }

.ri-moon-clear-fill:before {
  content: "\\ef6e"; }

.ri-moon-clear-line:before {
  content: "\\ef6f"; }

.ri-moon-cloudy-fill:before {
  content: "\\ef70"; }

.ri-moon-cloudy-line:before {
  content: "\\ef71"; }

.ri-moon-fill:before {
  content: "\\ef72"; }

.ri-moon-foggy-fill:before {
  content: "\\ef73"; }

.ri-moon-foggy-line:before {
  content: "\\ef74"; }

.ri-moon-line:before {
  content: "\\ef75"; }

.ri-more-2-fill:before {
  content: "\\ef76"; }

.ri-more-2-line:before {
  content: "\\ef77"; }

.ri-more-fill:before {
  content: "\\ef78"; }

.ri-more-line:before {
  content: "\\ef79"; }

.ri-motorbike-fill:before {
  content: "\\ef7a"; }

.ri-motorbike-line:before {
  content: "\\ef7b"; }

.ri-mouse-fill:before {
  content: "\\ef7c"; }

.ri-mouse-line:before {
  content: "\\ef7d"; }

.ri-movie-2-fill:before {
  content: "\\ef7e"; }

.ri-movie-2-line:before {
  content: "\\ef7f"; }

.ri-movie-fill:before {
  content: "\\ef80"; }

.ri-movie-line:before {
  content: "\\ef81"; }

.ri-music-2-fill:before {
  content: "\\ef82"; }

.ri-music-2-line:before {
  content: "\\ef83"; }

.ri-music-fill:before {
  content: "\\ef84"; }

.ri-music-line:before {
  content: "\\ef85"; }

.ri-mv-fill:before {
  content: "\\ef86"; }

.ri-mv-line:before {
  content: "\\ef87"; }

.ri-navigation-fill:before {
  content: "\\ef88"; }

.ri-navigation-line:before {
  content: "\\ef89"; }

.ri-netease-cloud-music-fill:before {
  content: "\\ef8a"; }

.ri-netease-cloud-music-line:before {
  content: "\\ef8b"; }

.ri-netflix-fill:before {
  content: "\\ef8c"; }

.ri-netflix-line:before {
  content: "\\ef8d"; }

.ri-newspaper-fill:before {
  content: "\\ef8e"; }

.ri-newspaper-line:before {
  content: "\\ef8f"; }

.ri-node-tree:before {
  content: "\\ef90"; }

.ri-notification-2-fill:before {
  content: "\\ef91"; }

.ri-notification-2-line:before {
  content: "\\ef92"; }

.ri-notification-3-fill:before {
  content: "\\ef93"; }

.ri-notification-3-line:before {
  content: "\\ef94"; }

.ri-notification-4-fill:before {
  content: "\\ef95"; }

.ri-notification-4-line:before {
  content: "\\ef96"; }

.ri-notification-badge-fill:before {
  content: "\\ef97"; }

.ri-notification-badge-line:before {
  content: "\\ef98"; }

.ri-notification-fill:before {
  content: "\\ef99"; }

.ri-notification-line:before {
  content: "\\ef9a"; }

.ri-notification-off-fill:before {
  content: "\\ef9b"; }

.ri-notification-off-line:before {
  content: "\\ef9c"; }

.ri-npmjs-fill:before {
  content: "\\ef9d"; }

.ri-npmjs-line:before {
  content: "\\ef9e"; }

.ri-number-0:before {
  content: "\\ef9f"; }

.ri-number-1:before {
  content: "\\efa0"; }

.ri-number-2:before {
  content: "\\efa1"; }

.ri-number-3:before {
  content: "\\efa2"; }

.ri-number-4:before {
  content: "\\efa3"; }

.ri-number-5:before {
  content: "\\efa4"; }

.ri-number-6:before {
  content: "\\efa5"; }

.ri-number-7:before {
  content: "\\efa6"; }

.ri-number-8:before {
  content: "\\efa7"; }

.ri-number-9:before {
  content: "\\efa8"; }

.ri-numbers-fill:before {
  content: "\\efa9"; }

.ri-numbers-line:before {
  content: "\\efaa"; }

.ri-nurse-fill:before {
  content: "\\efab"; }

.ri-nurse-line:before {
  content: "\\efac"; }

.ri-oil-fill:before {
  content: "\\efad"; }

.ri-oil-line:before {
  content: "\\efae"; }

.ri-omega:before {
  content: "\\efaf"; }

.ri-open-arm-fill:before {
  content: "\\efb0"; }

.ri-open-arm-line:before {
  content: "\\efb1"; }

.ri-open-source-fill:before {
  content: "\\efb2"; }

.ri-open-source-line:before {
  content: "\\efb3"; }

.ri-opera-fill:before {
  content: "\\efb4"; }

.ri-opera-line:before {
  content: "\\efb5"; }

.ri-order-play-fill:before {
  content: "\\efb6"; }

.ri-order-play-line:before {
  content: "\\efb7"; }

.ri-organization-chart:before {
  content: "\\efb8"; }

.ri-outlet-2-fill:before {
  content: "\\efb9"; }

.ri-outlet-2-line:before {
  content: "\\efba"; }

.ri-outlet-fill:before {
  content: "\\efbb"; }

.ri-outlet-line:before {
  content: "\\efbc"; }

.ri-page-separator:before {
  content: "\\efbd"; }

.ri-pages-fill:before {
  content: "\\efbe"; }

.ri-pages-line:before {
  content: "\\efbf"; }

.ri-paint-brush-fill:before {
  content: "\\efc0"; }

.ri-paint-brush-line:before {
  content: "\\efc1"; }

.ri-paint-fill:before {
  content: "\\efc2"; }

.ri-paint-line:before {
  content: "\\efc3"; }

.ri-palette-fill:before {
  content: "\\efc4"; }

.ri-palette-line:before {
  content: "\\efc5"; }

.ri-pantone-fill:before {
  content: "\\efc6"; }

.ri-pantone-line:before {
  content: "\\efc7"; }

.ri-paragraph:before {
  content: "\\efc8"; }

.ri-parent-fill:before {
  content: "\\efc9"; }

.ri-parent-line:before {
  content: "\\efca"; }

.ri-parentheses-fill:before {
  content: "\\efcb"; }

.ri-parentheses-line:before {
  content: "\\efcc"; }

.ri-parking-box-fill:before {
  content: "\\efcd"; }

.ri-parking-box-line:before {
  content: "\\efce"; }

.ri-parking-fill:before {
  content: "\\efcf"; }

.ri-parking-line:before {
  content: "\\efd0"; }

.ri-passport-fill:before {
  content: "\\efd1"; }

.ri-passport-line:before {
  content: "\\efd2"; }

.ri-patreon-fill:before {
  content: "\\efd3"; }

.ri-patreon-line:before {
  content: "\\efd4"; }

.ri-pause-circle-fill:before {
  content: "\\efd5"; }

.ri-pause-circle-line:before {
  content: "\\efd6"; }

.ri-pause-fill:before {
  content: "\\efd7"; }

.ri-pause-line:before {
  content: "\\efd8"; }

.ri-pause-mini-fill:before {
  content: "\\efd9"; }

.ri-pause-mini-line:before {
  content: "\\efda"; }

.ri-paypal-fill:before {
  content: "\\efdb"; }

.ri-paypal-line:before {
  content: "\\efdc"; }

.ri-pen-nib-fill:before {
  content: "\\efdd"; }

.ri-pen-nib-line:before {
  content: "\\efde"; }

.ri-pencil-fill:before {
  content: "\\efdf"; }

.ri-pencil-line:before {
  content: "\\efe0"; }

.ri-pencil-ruler-2-fill:before {
  content: "\\efe1"; }

.ri-pencil-ruler-2-line:before {
  content: "\\efe2"; }

.ri-pencil-ruler-fill:before {
  content: "\\efe3"; }

.ri-pencil-ruler-line:before {
  content: "\\efe4"; }

.ri-percent-fill:before {
  content: "\\efe5"; }

.ri-percent-line:before {
  content: "\\efe6"; }

.ri-phone-camera-fill:before {
  content: "\\efe7"; }

.ri-phone-camera-line:before {
  content: "\\efe8"; }

.ri-phone-fill:before {
  content: "\\efe9"; }

.ri-phone-find-fill:before {
  content: "\\efea"; }

.ri-phone-find-line:before {
  content: "\\efeb"; }

.ri-phone-line:before {
  content: "\\efec"; }

.ri-phone-lock-fill:before {
  content: "\\efed"; }

.ri-phone-lock-line:before {
  content: "\\efee"; }

.ri-picture-in-picture-2-fill:before {
  content: "\\efef"; }

.ri-picture-in-picture-2-line:before {
  content: "\\eff0"; }

.ri-picture-in-picture-exit-fill:before {
  content: "\\eff1"; }

.ri-picture-in-picture-exit-line:before {
  content: "\\eff2"; }

.ri-picture-in-picture-fill:before {
  content: "\\eff3"; }

.ri-picture-in-picture-line:before {
  content: "\\eff4"; }

.ri-pie-chart-2-fill:before {
  content: "\\eff5"; }

.ri-pie-chart-2-line:before {
  content: "\\eff6"; }

.ri-pie-chart-box-fill:before {
  content: "\\eff7"; }

.ri-pie-chart-box-line:before {
  content: "\\eff8"; }

.ri-pie-chart-fill:before {
  content: "\\eff9"; }

.ri-pie-chart-line:before {
  content: "\\effa"; }

.ri-pin-distance-fill:before {
  content: "\\effb"; }

.ri-pin-distance-line:before {
  content: "\\effc"; }

.ri-ping-pong-fill:before {
  content: "\\effd"; }

.ri-ping-pong-line:before {
  content: "\\effe"; }

.ri-pinterest-fill:before {
  content: "\\efff"; }

.ri-pinterest-line:before {
  content: "\\f000"; }

.ri-pinyin-input:before {
  content: "\\f001"; }

.ri-pixelfed-fill:before {
  content: "\\f002"; }

.ri-pixelfed-line:before {
  content: "\\f003"; }

.ri-plane-fill:before {
  content: "\\f004"; }

.ri-plane-line:before {
  content: "\\f005"; }

.ri-plant-fill:before {
  content: "\\f006"; }

.ri-plant-line:before {
  content: "\\f007"; }

.ri-play-circle-fill:before {
  content: "\\f008"; }

.ri-play-circle-line:before {
  content: "\\f009"; }

.ri-play-fill:before {
  content: "\\f00a"; }

.ri-play-line:before {
  content: "\\f00b"; }

.ri-play-list-2-fill:before {
  content: "\\f00c"; }

.ri-play-list-2-line:before {
  content: "\\f00d"; }

.ri-play-list-add-fill:before {
  content: "\\f00e"; }

.ri-play-list-add-line:before {
  content: "\\f00f"; }

.ri-play-list-fill:before {
  content: "\\f010"; }

.ri-play-list-line:before {
  content: "\\f011"; }

.ri-play-mini-fill:before {
  content: "\\f012"; }

.ri-play-mini-line:before {
  content: "\\f013"; }

.ri-playstation-fill:before {
  content: "\\f014"; }

.ri-playstation-line:before {
  content: "\\f015"; }

.ri-plug-2-fill:before {
  content: "\\f016"; }

.ri-plug-2-line:before {
  content: "\\f017"; }

.ri-plug-fill:before {
  content: "\\f018"; }

.ri-plug-line:before {
  content: "\\f019"; }

.ri-polaroid-2-fill:before {
  content: "\\f01a"; }

.ri-polaroid-2-line:before {
  content: "\\f01b"; }

.ri-polaroid-fill:before {
  content: "\\f01c"; }

.ri-polaroid-line:before {
  content: "\\f01d"; }

.ri-police-car-fill:before {
  content: "\\f01e"; }

.ri-police-car-line:before {
  content: "\\f01f"; }

.ri-price-tag-2-fill:before {
  content: "\\f020"; }

.ri-price-tag-2-line:before {
  content: "\\f021"; }

.ri-price-tag-3-fill:before {
  content: "\\f022"; }

.ri-price-tag-3-line:before {
  content: "\\f023"; }

.ri-price-tag-fill:before {
  content: "\\f024"; }

.ri-price-tag-line:before {
  content: "\\f025"; }

.ri-printer-cloud-fill:before {
  content: "\\f026"; }

.ri-printer-cloud-line:before {
  content: "\\f027"; }

.ri-printer-fill:before {
  content: "\\f028"; }

.ri-printer-line:before {
  content: "\\f029"; }

.ri-product-hunt-fill:before {
  content: "\\f02a"; }

.ri-product-hunt-line:before {
  content: "\\f02b"; }

.ri-profile-fill:before {
  content: "\\f02c"; }

.ri-profile-line:before {
  content: "\\f02d"; }

.ri-projector-2-fill:before {
  content: "\\f02e"; }

.ri-projector-2-line:before {
  content: "\\f02f"; }

.ri-projector-fill:before {
  content: "\\f030"; }

.ri-projector-line:before {
  content: "\\f031"; }

.ri-psychotherapy-fill:before {
  content: "\\f032"; }

.ri-psychotherapy-line:before {
  content: "\\f033"; }

.ri-pulse-fill:before {
  content: "\\f034"; }

.ri-pulse-line:before {
  content: "\\f035"; }

.ri-pushpin-2-fill:before {
  content: "\\f036"; }

.ri-pushpin-2-line:before {
  content: "\\f037"; }

.ri-pushpin-fill:before {
  content: "\\f038"; }

.ri-pushpin-line:before {
  content: "\\f039"; }

.ri-qq-fill:before {
  content: "\\f03a"; }

.ri-qq-line:before {
  content: "\\f03b"; }

.ri-qr-code-fill:before {
  content: "\\f03c"; }

.ri-qr-code-line:before {
  content: "\\f03d"; }

.ri-qr-scan-2-fill:before {
  content: "\\f03e"; }

.ri-qr-scan-2-line:before {
  content: "\\f03f"; }

.ri-qr-scan-fill:before {
  content: "\\f040"; }

.ri-qr-scan-line:before {
  content: "\\f041"; }

.ri-question-answer-fill:before {
  content: "\\f042"; }

.ri-question-answer-line:before {
  content: "\\f043"; }

.ri-question-fill:before {
  content: "\\f044"; }

.ri-question-line:before {
  content: "\\f045"; }

.ri-question-mark:before {
  content: "\\f046"; }

.ri-questionnaire-fill:before {
  content: "\\f047"; }

.ri-questionnaire-line:before {
  content: "\\f048"; }

.ri-quill-pen-fill:before {
  content: "\\f049"; }

.ri-quill-pen-line:before {
  content: "\\f04a"; }

.ri-radar-fill:before {
  content: "\\f04b"; }

.ri-radar-line:before {
  content: "\\f04c"; }

.ri-radio-2-fill:before {
  content: "\\f04d"; }

.ri-radio-2-line:before {
  content: "\\f04e"; }

.ri-radio-button-fill:before {
  content: "\\f04f"; }

.ri-radio-button-line:before {
  content: "\\f050"; }

.ri-radio-fill:before {
  content: "\\f051"; }

.ri-radio-line:before {
  content: "\\f052"; }

.ri-rainbow-fill:before {
  content: "\\f053"; }

.ri-rainbow-line:before {
  content: "\\f054"; }

.ri-rainy-fill:before {
  content: "\\f055"; }

.ri-rainy-line:before {
  content: "\\f056"; }

.ri-reactjs-fill:before {
  content: "\\f057"; }

.ri-reactjs-line:before {
  content: "\\f058"; }

.ri-record-circle-fill:before {
  content: "\\f059"; }

.ri-record-circle-line:before {
  content: "\\f05a"; }

.ri-record-mail-fill:before {
  content: "\\f05b"; }

.ri-record-mail-line:before {
  content: "\\f05c"; }

.ri-recycle-fill:before {
  content: "\\f05d"; }

.ri-recycle-line:before {
  content: "\\f05e"; }

.ri-red-packet-fill:before {
  content: "\\f05f"; }

.ri-red-packet-line:before {
  content: "\\f060"; }

.ri-reddit-fill:before {
  content: "\\f061"; }

.ri-reddit-line:before {
  content: "\\f062"; }

.ri-refresh-fill:before {
  content: "\\f063"; }

.ri-refresh-line:before {
  content: "\\f064"; }

.ri-refund-2-fill:before {
  content: "\\f065"; }

.ri-refund-2-line:before {
  content: "\\f066"; }

.ri-refund-fill:before {
  content: "\\f067"; }

.ri-refund-line:before {
  content: "\\f068"; }

.ri-registered-fill:before {
  content: "\\f069"; }

.ri-registered-line:before {
  content: "\\f06a"; }

.ri-remixicon-fill:before {
  content: "\\f06b"; }

.ri-remixicon-line:before {
  content: "\\f06c"; }

.ri-remote-control-2-fill:before {
  content: "\\f06d"; }

.ri-remote-control-2-line:before {
  content: "\\f06e"; }

.ri-remote-control-fill:before {
  content: "\\f06f"; }

.ri-remote-control-line:before {
  content: "\\f070"; }

.ri-repeat-2-fill:before {
  content: "\\f071"; }

.ri-repeat-2-line:before {
  content: "\\f072"; }

.ri-repeat-fill:before {
  content: "\\f073"; }

.ri-repeat-line:before {
  content: "\\f074"; }

.ri-repeat-one-fill:before {
  content: "\\f075"; }

.ri-repeat-one-line:before {
  content: "\\f076"; }

.ri-reply-all-fill:before {
  content: "\\f077"; }

.ri-reply-all-line:before {
  content: "\\f078"; }

.ri-reply-fill:before {
  content: "\\f079"; }

.ri-reply-line:before {
  content: "\\f07a"; }

.ri-reserved-fill:before {
  content: "\\f07b"; }

.ri-reserved-line:before {
  content: "\\f07c"; }

.ri-rest-time-fill:before {
  content: "\\f07d"; }

.ri-rest-time-line:before {
  content: "\\f07e"; }

.ri-restart-fill:before {
  content: "\\f07f"; }

.ri-restart-line:before {
  content: "\\f080"; }

.ri-restaurant-2-fill:before {
  content: "\\f081"; }

.ri-restaurant-2-line:before {
  content: "\\f082"; }

.ri-restaurant-fill:before {
  content: "\\f083"; }

.ri-restaurant-line:before {
  content: "\\f084"; }

.ri-rewind-fill:before {
  content: "\\f085"; }

.ri-rewind-line:before {
  content: "\\f086"; }

.ri-rewind-mini-fill:before {
  content: "\\f087"; }

.ri-rewind-mini-line:before {
  content: "\\f088"; }

.ri-rhythm-fill:before {
  content: "\\f089"; }

.ri-rhythm-line:before {
  content: "\\f08a"; }

.ri-riding-fill:before {
  content: "\\f08b"; }

.ri-riding-line:before {
  content: "\\f08c"; }

.ri-road-map-fill:before {
  content: "\\f08d"; }

.ri-road-map-line:before {
  content: "\\f08e"; }

.ri-roadster-fill:before {
  content: "\\f08f"; }

.ri-roadster-line:before {
  content: "\\f090"; }

.ri-robot-fill:before {
  content: "\\f091"; }

.ri-robot-line:before {
  content: "\\f092"; }

.ri-rocket-2-fill:before {
  content: "\\f093"; }

.ri-rocket-2-line:before {
  content: "\\f094"; }

.ri-rocket-fill:before {
  content: "\\f095"; }

.ri-rocket-line:before {
  content: "\\f096"; }

.ri-rotate-lock-fill:before {
  content: "\\f097"; }

.ri-rotate-lock-line:before {
  content: "\\f098"; }

.ri-rounded-corner:before {
  content: "\\f099"; }

.ri-route-fill:before {
  content: "\\f09a"; }

.ri-route-line:before {
  content: "\\f09b"; }

.ri-router-fill:before {
  content: "\\f09c"; }

.ri-router-line:before {
  content: "\\f09d"; }

.ri-rss-fill:before {
  content: "\\f09e"; }

.ri-rss-line:before {
  content: "\\f09f"; }

.ri-ruler-2-fill:before {
  content: "\\f0a0"; }

.ri-ruler-2-line:before {
  content: "\\f0a1"; }

.ri-ruler-fill:before {
  content: "\\f0a2"; }

.ri-ruler-line:before {
  content: "\\f0a3"; }

.ri-run-fill:before {
  content: "\\f0a4"; }

.ri-run-line:before {
  content: "\\f0a5"; }

.ri-safari-fill:before {
  content: "\\f0a6"; }

.ri-safari-line:before {
  content: "\\f0a7"; }

.ri-safe-2-fill:before {
  content: "\\f0a8"; }

.ri-safe-2-line:before {
  content: "\\f0a9"; }

.ri-safe-fill:before {
  content: "\\f0aa"; }

.ri-safe-line:before {
  content: "\\f0ab"; }

.ri-sailboat-fill:before {
  content: "\\f0ac"; }

.ri-sailboat-line:before {
  content: "\\f0ad"; }

.ri-save-2-fill:before {
  content: "\\f0ae"; }

.ri-save-2-line:before {
  content: "\\f0af"; }

.ri-save-3-fill:before {
  content: "\\f0b0"; }

.ri-save-3-line:before {
  content: "\\f0b1"; }

.ri-save-fill:before {
  content: "\\f0b2"; }

.ri-save-line:before {
  content: "\\f0b3"; }

.ri-scales-2-fill:before {
  content: "\\f0b4"; }

.ri-scales-2-line:before {
  content: "\\f0b5"; }

.ri-scales-3-fill:before {
  content: "\\f0b6"; }

.ri-scales-3-line:before {
  content: "\\f0b7"; }

.ri-scales-fill:before {
  content: "\\f0b8"; }

.ri-scales-line:before {
  content: "\\f0b9"; }

.ri-scan-2-fill:before {
  content: "\\f0ba"; }

.ri-scan-2-line:before {
  content: "\\f0bb"; }

.ri-scan-fill:before {
  content: "\\f0bc"; }

.ri-scan-line:before {
  content: "\\f0bd"; }

.ri-scissors-2-fill:before {
  content: "\\f0be"; }

.ri-scissors-2-line:before {
  content: "\\f0bf"; }

.ri-scissors-cut-fill:before {
  content: "\\f0c0"; }

.ri-scissors-cut-line:before {
  content: "\\f0c1"; }

.ri-scissors-fill:before {
  content: "\\f0c2"; }

.ri-scissors-line:before {
  content: "\\f0c3"; }

.ri-screenshot-2-fill:before {
  content: "\\f0c4"; }

.ri-screenshot-2-line:before {
  content: "\\f0c5"; }

.ri-screenshot-fill:before {
  content: "\\f0c6"; }

.ri-screenshot-line:before {
  content: "\\f0c7"; }

.ri-sd-card-fill:before {
  content: "\\f0c8"; }

.ri-sd-card-line:before {
  content: "\\f0c9"; }

.ri-sd-card-mini-fill:before {
  content: "\\f0ca"; }

.ri-sd-card-mini-line:before {
  content: "\\f0cb"; }

.ri-search-2-fill:before {
  content: "\\f0cc"; }

.ri-search-2-line:before {
  content: "\\f0cd"; }

.ri-search-eye-fill:before {
  content: "\\f0ce"; }

.ri-search-eye-line:before {
  content: "\\f0cf"; }

.ri-search-fill:before {
  content: "\\f0d0"; }

.ri-search-line:before {
  content: "\\f0d1"; }

.ri-secure-payment-fill:before {
  content: "\\f0d2"; }

.ri-secure-payment-line:before {
  content: "\\f0d3"; }

.ri-seedling-fill:before {
  content: "\\f0d4"; }

.ri-seedling-line:before {
  content: "\\f0d5"; }

.ri-send-backward:before {
  content: "\\f0d6"; }

.ri-send-plane-2-fill:before {
  content: "\\f0d7"; }

.ri-send-plane-2-line:before {
  content: "\\f0d8"; }

.ri-send-plane-fill:before {
  content: "\\f0d9"; }

.ri-send-plane-line:before {
  content: "\\f0da"; }

.ri-send-to-back:before {
  content: "\\f0db"; }

.ri-sensor-fill:before {
  content: "\\f0dc"; }

.ri-sensor-line:before {
  content: "\\f0dd"; }

.ri-separator:before {
  content: "\\f0de"; }

.ri-server-fill:before {
  content: "\\f0df"; }

.ri-server-line:before {
  content: "\\f0e0"; }

.ri-service-fill:before {
  content: "\\f0e1"; }

.ri-service-line:before {
  content: "\\f0e2"; }

.ri-settings-2-fill:before {
  content: "\\f0e3"; }

.ri-settings-2-line:before {
  content: "\\f0e4"; }

.ri-settings-3-fill:before {
  content: "\\f0e5"; }

.ri-settings-3-line:before {
  content: "\\f0e6"; }

.ri-settings-4-fill:before {
  content: "\\f0e7"; }

.ri-settings-4-line:before {
  content: "\\f0e8"; }

.ri-settings-5-fill:before {
  content: "\\f0e9"; }

.ri-settings-5-line:before {
  content: "\\f0ea"; }

.ri-settings-6-fill:before {
  content: "\\f0eb"; }

.ri-settings-6-line:before {
  content: "\\f0ec"; }

.ri-settings-fill:before {
  content: "\\f0ed"; }

.ri-settings-line:before {
  content: "\\f0ee"; }

.ri-shape-2-fill:before {
  content: "\\f0ef"; }

.ri-shape-2-line:before {
  content: "\\f0f0"; }

.ri-shape-fill:before {
  content: "\\f0f1"; }

.ri-shape-line:before {
  content: "\\f0f2"; }

.ri-share-box-fill:before {
  content: "\\f0f3"; }

.ri-share-box-line:before {
  content: "\\f0f4"; }

.ri-share-circle-fill:before {
  content: "\\f0f5"; }

.ri-share-circle-line:before {
  content: "\\f0f6"; }

.ri-share-fill:before {
  content: "\\f0f7"; }

.ri-share-forward-2-fill:before {
  content: "\\f0f8"; }

.ri-share-forward-2-line:before {
  content: "\\f0f9"; }

.ri-share-forward-box-fill:before {
  content: "\\f0fa"; }

.ri-share-forward-box-line:before {
  content: "\\f0fb"; }

.ri-share-forward-fill:before {
  content: "\\f0fc"; }

.ri-share-forward-line:before {
  content: "\\f0fd"; }

.ri-share-line:before {
  content: "\\f0fe"; }

.ri-shield-check-fill:before {
  content: "\\f0ff"; }

.ri-shield-check-line:before {
  content: "\\f100"; }

.ri-shield-cross-fill:before {
  content: "\\f101"; }

.ri-shield-cross-line:before {
  content: "\\f102"; }

.ri-shield-fill:before {
  content: "\\f103"; }

.ri-shield-flash-fill:before {
  content: "\\f104"; }

.ri-shield-flash-line:before {
  content: "\\f105"; }

.ri-shield-keyhole-fill:before {
  content: "\\f106"; }

.ri-shield-keyhole-line:before {
  content: "\\f107"; }

.ri-shield-line:before {
  content: "\\f108"; }

.ri-shield-star-fill:before {
  content: "\\f109"; }

.ri-shield-star-line:before {
  content: "\\f10a"; }

.ri-shield-user-fill:before {
  content: "\\f10b"; }

.ri-shield-user-line:before {
  content: "\\f10c"; }

.ri-ship-2-fill:before {
  content: "\\f10d"; }

.ri-ship-2-line:before {
  content: "\\f10e"; }

.ri-ship-fill:before {
  content: "\\f10f"; }

.ri-ship-line:before {
  content: "\\f110"; }

.ri-shirt-fill:before {
  content: "\\f111"; }

.ri-shirt-line:before {
  content: "\\f112"; }

.ri-shopping-bag-2-fill:before {
  content: "\\f113"; }

.ri-shopping-bag-2-line:before {
  content: "\\f114"; }

.ri-shopping-bag-3-fill:before {
  content: "\\f115"; }

.ri-shopping-bag-3-line:before {
  content: "\\f116"; }

.ri-shopping-bag-fill:before {
  content: "\\f117"; }

.ri-shopping-bag-line:before {
  content: "\\f118"; }

.ri-shopping-basket-2-fill:before {
  content: "\\f119"; }

.ri-shopping-basket-2-line:before {
  content: "\\f11a"; }

.ri-shopping-basket-fill:before {
  content: "\\f11b"; }

.ri-shopping-basket-line:before {
  content: "\\f11c"; }

.ri-shopping-cart-2-fill:before {
  content: "\\f11d"; }

.ri-shopping-cart-2-line:before {
  content: "\\f11e"; }

.ri-shopping-cart-fill:before {
  content: "\\f11f"; }

.ri-shopping-cart-line:before {
  content: "\\f120"; }

.ri-showers-fill:before {
  content: "\\f121"; }

.ri-showers-line:before {
  content: "\\f122"; }

.ri-shuffle-fill:before {
  content: "\\f123"; }

.ri-shuffle-line:before {
  content: "\\f124"; }

.ri-shut-down-fill:before {
  content: "\\f125"; }

.ri-shut-down-line:before {
  content: "\\f126"; }

.ri-side-bar-fill:before {
  content: "\\f127"; }

.ri-side-bar-line:before {
  content: "\\f128"; }

.ri-signal-tower-fill:before {
  content: "\\f129"; }

.ri-signal-tower-line:before {
  content: "\\f12a"; }

.ri-signal-wifi-1-fill:before {
  content: "\\f12b"; }

.ri-signal-wifi-1-line:before {
  content: "\\f12c"; }

.ri-signal-wifi-2-fill:before {
  content: "\\f12d"; }

.ri-signal-wifi-2-line:before {
  content: "\\f12e"; }

.ri-signal-wifi-3-fill:before {
  content: "\\f12f"; }

.ri-signal-wifi-3-line:before {
  content: "\\f130"; }

.ri-signal-wifi-error-fill:before {
  content: "\\f131"; }

.ri-signal-wifi-error-line:before {
  content: "\\f132"; }

.ri-signal-wifi-fill:before {
  content: "\\f133"; }

.ri-signal-wifi-line:before {
  content: "\\f134"; }

.ri-signal-wifi-off-fill:before {
  content: "\\f135"; }

.ri-signal-wifi-off-line:before {
  content: "\\f136"; }

.ri-sim-card-2-fill:before {
  content: "\\f137"; }

.ri-sim-card-2-line:before {
  content: "\\f138"; }

.ri-sim-card-fill:before {
  content: "\\f139"; }

.ri-sim-card-line:before {
  content: "\\f13a"; }

.ri-single-quotes-l:before {
  content: "\\f13b"; }

.ri-single-quotes-r:before {
  content: "\\f13c"; }

.ri-sip-fill:before {
  content: "\\f13d"; }

.ri-sip-line:before {
  content: "\\f13e"; }

.ri-skip-back-fill:before {
  content: "\\f13f"; }

.ri-skip-back-line:before {
  content: "\\f140"; }

.ri-skip-back-mini-fill:before {
  content: "\\f141"; }

.ri-skip-back-mini-line:before {
  content: "\\f142"; }

.ri-skip-forward-fill:before {
  content: "\\f143"; }

.ri-skip-forward-line:before {
  content: "\\f144"; }

.ri-skip-forward-mini-fill:before {
  content: "\\f145"; }

.ri-skip-forward-mini-line:before {
  content: "\\f146"; }

.ri-skull-2-fill:before {
  content: "\\f147"; }

.ri-skull-2-line:before {
  content: "\\f148"; }

.ri-skull-fill:before {
  content: "\\f149"; }

.ri-skull-line:before {
  content: "\\f14a"; }

.ri-skype-fill:before {
  content: "\\f14b"; }

.ri-skype-line:before {
  content: "\\f14c"; }

.ri-slack-fill:before {
  content: "\\f14d"; }

.ri-slack-line:before {
  content: "\\f14e"; }

.ri-slice-fill:before {
  content: "\\f14f"; }

.ri-slice-line:before {
  content: "\\f150"; }

.ri-slideshow-2-fill:before {
  content: "\\f151"; }

.ri-slideshow-2-line:before {
  content: "\\f152"; }

.ri-slideshow-3-fill:before {
  content: "\\f153"; }

.ri-slideshow-3-line:before {
  content: "\\f154"; }

.ri-slideshow-4-fill:before {
  content: "\\f155"; }

.ri-slideshow-4-line:before {
  content: "\\f156"; }

.ri-slideshow-fill:before {
  content: "\\f157"; }

.ri-slideshow-line:before {
  content: "\\f158"; }

.ri-smartphone-fill:before {
  content: "\\f159"; }

.ri-smartphone-line:before {
  content: "\\f15a"; }

.ri-snapchat-fill:before {
  content: "\\f15b"; }

.ri-snapchat-line:before {
  content: "\\f15c"; }

.ri-snowy-fill:before {
  content: "\\f15d"; }

.ri-snowy-line:before {
  content: "\\f15e"; }

.ri-sort-asc:before {
  content: "\\f15f"; }

.ri-sort-desc:before {
  content: "\\f160"; }

.ri-sound-module-fill:before {
  content: "\\f161"; }

.ri-sound-module-line:before {
  content: "\\f162"; }

.ri-soundcloud-fill:before {
  content: "\\f163"; }

.ri-soundcloud-line:before {
  content: "\\f164"; }

.ri-space-ship-fill:before {
  content: "\\f165"; }

.ri-space-ship-line:before {
  content: "\\f166"; }

.ri-space:before {
  content: "\\f167"; }

.ri-spam-2-fill:before {
  content: "\\f168"; }

.ri-spam-2-line:before {
  content: "\\f169"; }

.ri-spam-3-fill:before {
  content: "\\f16a"; }

.ri-spam-3-line:before {
  content: "\\f16b"; }

.ri-spam-fill:before {
  content: "\\f16c"; }

.ri-spam-line:before {
  content: "\\f16d"; }

.ri-speaker-2-fill:before {
  content: "\\f16e"; }

.ri-speaker-2-line:before {
  content: "\\f16f"; }

.ri-speaker-3-fill:before {
  content: "\\f170"; }

.ri-speaker-3-line:before {
  content: "\\f171"; }

.ri-speaker-fill:before {
  content: "\\f172"; }

.ri-speaker-line:before {
  content: "\\f173"; }

.ri-spectrum-fill:before {
  content: "\\f174"; }

.ri-spectrum-line:before {
  content: "\\f175"; }

.ri-speed-fill:before {
  content: "\\f176"; }

.ri-speed-line:before {
  content: "\\f177"; }

.ri-speed-mini-fill:before {
  content: "\\f178"; }

.ri-speed-mini-line:before {
  content: "\\f179"; }

.ri-split-cells-horizontal:before {
  content: "\\f17a"; }

.ri-split-cells-vertical:before {
  content: "\\f17b"; }

.ri-spotify-fill:before {
  content: "\\f17c"; }

.ri-spotify-line:before {
  content: "\\f17d"; }

.ri-spy-fill:before {
  content: "\\f17e"; }

.ri-spy-line:before {
  content: "\\f17f"; }

.ri-stack-fill:before {
  content: "\\f180"; }

.ri-stack-line:before {
  content: "\\f181"; }

.ri-stack-overflow-fill:before {
  content: "\\f182"; }

.ri-stack-overflow-line:before {
  content: "\\f183"; }

.ri-stackshare-fill:before {
  content: "\\f184"; }

.ri-stackshare-line:before {
  content: "\\f185"; }

.ri-star-fill:before {
  content: "\\f186"; }

.ri-star-half-fill:before {
  content: "\\f187"; }

.ri-star-half-line:before {
  content: "\\f188"; }

.ri-star-half-s-fill:before {
  content: "\\f189"; }

.ri-star-half-s-line:before {
  content: "\\f18a"; }

.ri-star-line:before {
  content: "\\f18b"; }

.ri-star-s-fill:before {
  content: "\\f18c"; }

.ri-star-s-line:before {
  content: "\\f18d"; }

.ri-star-smile-fill:before {
  content: "\\f18e"; }

.ri-star-smile-line:before {
  content: "\\f18f"; }

.ri-steam-fill:before {
  content: "\\f190"; }

.ri-steam-line:before {
  content: "\\f191"; }

.ri-steering-2-fill:before {
  content: "\\f192"; }

.ri-steering-2-line:before {
  content: "\\f193"; }

.ri-steering-fill:before {
  content: "\\f194"; }

.ri-steering-line:before {
  content: "\\f195"; }

.ri-stethoscope-fill:before {
  content: "\\f196"; }

.ri-stethoscope-line:before {
  content: "\\f197"; }

.ri-sticky-note-2-fill:before {
  content: "\\f198"; }

.ri-sticky-note-2-line:before {
  content: "\\f199"; }

.ri-sticky-note-fill:before {
  content: "\\f19a"; }

.ri-sticky-note-line:before {
  content: "\\f19b"; }

.ri-stock-fill:before {
  content: "\\f19c"; }

.ri-stock-line:before {
  content: "\\f19d"; }

.ri-stop-circle-fill:before {
  content: "\\f19e"; }

.ri-stop-circle-line:before {
  content: "\\f19f"; }

.ri-stop-fill:before {
  content: "\\f1a0"; }

.ri-stop-line:before {
  content: "\\f1a1"; }

.ri-stop-mini-fill:before {
  content: "\\f1a2"; }

.ri-stop-mini-line:before {
  content: "\\f1a3"; }

.ri-store-2-fill:before {
  content: "\\f1a4"; }

.ri-store-2-line:before {
  content: "\\f1a5"; }

.ri-store-3-fill:before {
  content: "\\f1a6"; }

.ri-store-3-line:before {
  content: "\\f1a7"; }

.ri-store-fill:before {
  content: "\\f1a8"; }

.ri-store-line:before {
  content: "\\f1a9"; }

.ri-strikethrough-2:before {
  content: "\\f1aa"; }

.ri-strikethrough:before {
  content: "\\f1ab"; }

.ri-subscript-2:before {
  content: "\\f1ac"; }

.ri-subscript:before {
  content: "\\f1ad"; }

.ri-subtract-fill:before {
  content: "\\f1ae"; }

.ri-subtract-line:before {
  content: "\\f1af"; }

.ri-subway-fill:before {
  content: "\\f1b0"; }

.ri-subway-line:before {
  content: "\\f1b1"; }

.ri-subway-wifi-fill:before {
  content: "\\f1b2"; }

.ri-subway-wifi-line:before {
  content: "\\f1b3"; }

.ri-suitcase-2-fill:before {
  content: "\\f1b4"; }

.ri-suitcase-2-line:before {
  content: "\\f1b5"; }

.ri-suitcase-3-fill:before {
  content: "\\f1b6"; }

.ri-suitcase-3-line:before {
  content: "\\f1b7"; }

.ri-suitcase-fill:before {
  content: "\\f1b8"; }

.ri-suitcase-line:before {
  content: "\\f1b9"; }

.ri-sun-cloudy-fill:before {
  content: "\\f1ba"; }

.ri-sun-cloudy-line:before {
  content: "\\f1bb"; }

.ri-sun-fill:before {
  content: "\\f1bc"; }

.ri-sun-foggy-fill:before {
  content: "\\f1bd"; }

.ri-sun-foggy-line:before {
  content: "\\f1be"; }

.ri-sun-line:before {
  content: "\\f1bf"; }

.ri-superscript-2:before {
  content: "\\f1c0"; }

.ri-superscript:before {
  content: "\\f1c1"; }

.ri-surgical-mask-fill:before {
  content: "\\f1c2"; }

.ri-surgical-mask-line:before {
  content: "\\f1c3"; }

.ri-surround-sound-fill:before {
  content: "\\f1c4"; }

.ri-surround-sound-line:before {
  content: "\\f1c5"; }

.ri-survey-fill:before {
  content: "\\f1c6"; }

.ri-survey-line:before {
  content: "\\f1c7"; }

.ri-swap-box-fill:before {
  content: "\\f1c8"; }

.ri-swap-box-line:before {
  content: "\\f1c9"; }

.ri-swap-fill:before {
  content: "\\f1ca"; }

.ri-swap-line:before {
  content: "\\f1cb"; }

.ri-switch-fill:before {
  content: "\\f1cc"; }

.ri-switch-line:before {
  content: "\\f1cd"; }

.ri-sword-fill:before {
  content: "\\f1ce"; }

.ri-sword-line:before {
  content: "\\f1cf"; }

.ri-syringe-fill:before {
  content: "\\f1d0"; }

.ri-syringe-line:before {
  content: "\\f1d1"; }

.ri-t-box-fill:before {
  content: "\\f1d2"; }

.ri-t-box-line:before {
  content: "\\f1d3"; }

.ri-t-shirt-2-fill:before {
  content: "\\f1d4"; }

.ri-t-shirt-2-line:before {
  content: "\\f1d5"; }

.ri-t-shirt-air-fill:before {
  content: "\\f1d6"; }

.ri-t-shirt-air-line:before {
  content: "\\f1d7"; }

.ri-t-shirt-fill:before {
  content: "\\f1d8"; }

.ri-t-shirt-line:before {
  content: "\\f1d9"; }

.ri-table-2:before {
  content: "\\f1da"; }

.ri-table-alt-fill:before {
  content: "\\f1db"; }

.ri-table-alt-line:before {
  content: "\\f1dc"; }

.ri-table-fill:before {
  content: "\\f1dd"; }

.ri-table-line:before {
  content: "\\f1de"; }

.ri-tablet-fill:before {
  content: "\\f1df"; }

.ri-tablet-line:before {
  content: "\\f1e0"; }

.ri-takeaway-fill:before {
  content: "\\f1e1"; }

.ri-takeaway-line:before {
  content: "\\f1e2"; }

.ri-taobao-fill:before {
  content: "\\f1e3"; }

.ri-taobao-line:before {
  content: "\\f1e4"; }

.ri-tape-fill:before {
  content: "\\f1e5"; }

.ri-tape-line:before {
  content: "\\f1e6"; }

.ri-task-fill:before {
  content: "\\f1e7"; }

.ri-task-line:before {
  content: "\\f1e8"; }

.ri-taxi-fill:before {
  content: "\\f1e9"; }

.ri-taxi-line:before {
  content: "\\f1ea"; }

.ri-taxi-wifi-fill:before {
  content: "\\f1eb"; }

.ri-taxi-wifi-line:before {
  content: "\\f1ec"; }

.ri-team-fill:before {
  content: "\\f1ed"; }

.ri-team-line:before {
  content: "\\f1ee"; }

.ri-telegram-fill:before {
  content: "\\f1ef"; }

.ri-telegram-line:before {
  content: "\\f1f0"; }

.ri-temp-cold-fill:before {
  content: "\\f1f1"; }

.ri-temp-cold-line:before {
  content: "\\f1f2"; }

.ri-temp-hot-fill:before {
  content: "\\f1f3"; }

.ri-temp-hot-line:before {
  content: "\\f1f4"; }

.ri-terminal-box-fill:before {
  content: "\\f1f5"; }

.ri-terminal-box-line:before {
  content: "\\f1f6"; }

.ri-terminal-fill:before {
  content: "\\f1f7"; }

.ri-terminal-line:before {
  content: "\\f1f8"; }

.ri-terminal-window-fill:before {
  content: "\\f1f9"; }

.ri-terminal-window-line:before {
  content: "\\f1fa"; }

.ri-test-tube-fill:before {
  content: "\\f1fb"; }

.ri-test-tube-line:before {
  content: "\\f1fc"; }

.ri-text-direction-l:before {
  content: "\\f1fd"; }

.ri-text-direction-r:before {
  content: "\\f1fe"; }

.ri-text-spacing:before {
  content: "\\f1ff"; }

.ri-text-wrap:before {
  content: "\\f200"; }

.ri-text:before {
  content: "\\f201"; }

.ri-thermometer-fill:before {
  content: "\\f202"; }

.ri-thermometer-line:before {
  content: "\\f203"; }

.ri-thumb-down-fill:before {
  content: "\\f204"; }

.ri-thumb-down-line:before {
  content: "\\f205"; }

.ri-thumb-up-fill:before {
  content: "\\f206"; }

.ri-thumb-up-line:before {
  content: "\\f207"; }

.ri-thunderstorms-fill:before {
  content: "\\f208"; }

.ri-thunderstorms-line:before {
  content: "\\f209"; }

.ri-ticket-2-fill:before {
  content: "\\f20a"; }

.ri-ticket-2-line:before {
  content: "\\f20b"; }

.ri-ticket-fill:before {
  content: "\\f20c"; }

.ri-ticket-line:before {
  content: "\\f20d"; }

.ri-time-fill:before {
  content: "\\f20e"; }

.ri-time-line:before {
  content: "\\f20f"; }

.ri-timer-2-fill:before {
  content: "\\f210"; }

.ri-timer-2-line:before {
  content: "\\f211"; }

.ri-timer-fill:before {
  content: "\\f212"; }

.ri-timer-flash-fill:before {
  content: "\\f213"; }

.ri-timer-flash-line:before {
  content: "\\f214"; }

.ri-timer-line:before {
  content: "\\f215"; }

.ri-todo-fill:before {
  content: "\\f216"; }

.ri-todo-line:before {
  content: "\\f217"; }

.ri-toggle-fill:before {
  content: "\\f218"; }

.ri-toggle-line:before {
  content: "\\f219"; }

.ri-tools-fill:before {
  content: "\\f21a"; }

.ri-tools-line:before {
  content: "\\f21b"; }

.ri-tornado-fill:before {
  content: "\\f21c"; }

.ri-tornado-line:before {
  content: "\\f21d"; }

.ri-trademark-fill:before {
  content: "\\f21e"; }

.ri-trademark-line:before {
  content: "\\f21f"; }

.ri-traffic-light-fill:before {
  content: "\\f220"; }

.ri-traffic-light-line:before {
  content: "\\f221"; }

.ri-train-fill:before {
  content: "\\f222"; }

.ri-train-line:before {
  content: "\\f223"; }

.ri-train-wifi-fill:before {
  content: "\\f224"; }

.ri-train-wifi-line:before {
  content: "\\f225"; }

.ri-translate-2:before {
  content: "\\f226"; }

.ri-translate:before {
  content: "\\f227"; }

.ri-travesti-fill:before {
  content: "\\f228"; }

.ri-travesti-line:before {
  content: "\\f229"; }

.ri-treasure-map-fill:before {
  content: "\\f22a"; }

.ri-treasure-map-line:before {
  content: "\\f22b"; }

.ri-trello-fill:before {
  content: "\\f22c"; }

.ri-trello-line:before {
  content: "\\f22d"; }

.ri-trophy-fill:before {
  content: "\\f22e"; }

.ri-trophy-line:before {
  content: "\\f22f"; }

.ri-truck-fill:before {
  content: "\\f230"; }

.ri-truck-line:before {
  content: "\\f231"; }

.ri-tumblr-fill:before {
  content: "\\f232"; }

.ri-tumblr-line:before {
  content: "\\f233"; }

.ri-tv-2-fill:before {
  content: "\\f234"; }

.ri-tv-2-line:before {
  content: "\\f235"; }

.ri-tv-fill:before {
  content: "\\f236"; }

.ri-tv-line:before {
  content: "\\f237"; }

.ri-twitch-fill:before {
  content: "\\f238"; }

.ri-twitch-line:before {
  content: "\\f239"; }

.ri-twitter-fill:before {
  content: "\\f23a"; }

.ri-twitter-line:before {
  content: "\\f23b"; }

.ri-typhoon-fill:before {
  content: "\\f23c"; }

.ri-typhoon-line:before {
  content: "\\f23d"; }

.ri-u-disk-fill:before {
  content: "\\f23e"; }

.ri-u-disk-line:before {
  content: "\\f23f"; }

.ri-ubuntu-fill:before {
  content: "\\f240"; }

.ri-ubuntu-line:before {
  content: "\\f241"; }

.ri-umbrella-fill:before {
  content: "\\f242"; }

.ri-umbrella-line:before {
  content: "\\f243"; }

.ri-underline:before {
  content: "\\f244"; }

.ri-uninstall-fill:before {
  content: "\\f245"; }

.ri-uninstall-line:before {
  content: "\\f246"; }

.ri-unsplash-fill:before {
  content: "\\f247"; }

.ri-unsplash-line:before {
  content: "\\f248"; }

.ri-upload-2-fill:before {
  content: "\\f249"; }

.ri-upload-2-line:before {
  content: "\\f24a"; }

.ri-upload-cloud-2-fill:before {
  content: "\\f24b"; }

.ri-upload-cloud-2-line:before {
  content: "\\f24c"; }

.ri-upload-cloud-fill:before {
  content: "\\f24d"; }

.ri-upload-cloud-line:before {
  content: "\\f24e"; }

.ri-upload-fill:before {
  content: "\\f24f"; }

.ri-upload-line:before {
  content: "\\f250"; }

.ri-usb-fill:before {
  content: "\\f251"; }

.ri-usb-line:before {
  content: "\\f252"; }

.ri-user-2-fill:before {
  content: "\\f253"; }

.ri-user-2-line:before {
  content: "\\f254"; }

.ri-user-3-fill:before {
  content: "\\f255"; }

.ri-user-3-line:before {
  content: "\\f256"; }

.ri-user-4-fill:before {
  content: "\\f257"; }

.ri-user-4-line:before {
  content: "\\f258"; }

.ri-user-5-fill:before {
  content: "\\f259"; }

.ri-user-5-line:before {
  content: "\\f25a"; }

.ri-user-6-fill:before {
  content: "\\f25b"; }

.ri-user-6-line:before {
  content: "\\f25c"; }

.ri-user-add-fill:before {
  content: "\\f25d"; }

.ri-user-add-line:before {
  content: "\\f25e"; }

.ri-user-fill:before {
  content: "\\f25f"; }

.ri-user-follow-fill:before {
  content: "\\f260"; }

.ri-user-follow-line:before {
  content: "\\f261"; }

.ri-user-heart-fill:before {
  content: "\\f262"; }

.ri-user-heart-line:before {
  content: "\\f263"; }

.ri-user-line:before {
  content: "\\f264"; }

.ri-user-location-fill:before {
  content: "\\f265"; }

.ri-user-location-line:before {
  content: "\\f266"; }

.ri-user-received-2-fill:before {
  content: "\\f267"; }

.ri-user-received-2-line:before {
  content: "\\f268"; }

.ri-user-received-fill:before {
  content: "\\f269"; }

.ri-user-received-line:before {
  content: "\\f26a"; }

.ri-user-search-fill:before {
  content: "\\f26b"; }

.ri-user-search-line:before {
  content: "\\f26c"; }

.ri-user-settings-fill:before {
  content: "\\f26d"; }

.ri-user-settings-line:before {
  content: "\\f26e"; }

.ri-user-shared-2-fill:before {
  content: "\\f26f"; }

.ri-user-shared-2-line:before {
  content: "\\f270"; }

.ri-user-shared-fill:before {
  content: "\\f271"; }

.ri-user-shared-line:before {
  content: "\\f272"; }

.ri-user-smile-fill:before {
  content: "\\f273"; }

.ri-user-smile-line:before {
  content: "\\f274"; }

.ri-user-star-fill:before {
  content: "\\f275"; }

.ri-user-star-line:before {
  content: "\\f276"; }

.ri-user-unfollow-fill:before {
  content: "\\f277"; }

.ri-user-unfollow-line:before {
  content: "\\f278"; }

.ri-user-voice-fill:before {
  content: "\\f279"; }

.ri-user-voice-line:before {
  content: "\\f27a"; }

.ri-video-add-fill:before {
  content: "\\f27b"; }

.ri-video-add-line:before {
  content: "\\f27c"; }

.ri-video-chat-fill:before {
  content: "\\f27d"; }

.ri-video-chat-line:before {
  content: "\\f27e"; }

.ri-video-download-fill:before {
  content: "\\f27f"; }

.ri-video-download-line:before {
  content: "\\f280"; }

.ri-video-fill:before {
  content: "\\f281"; }

.ri-video-line:before {
  content: "\\f282"; }

.ri-video-upload-fill:before {
  content: "\\f283"; }

.ri-video-upload-line:before {
  content: "\\f284"; }

.ri-vidicon-2-fill:before {
  content: "\\f285"; }

.ri-vidicon-2-line:before {
  content: "\\f286"; }

.ri-vidicon-fill:before {
  content: "\\f287"; }

.ri-vidicon-line:before {
  content: "\\f288"; }

.ri-vimeo-fill:before {
  content: "\\f289"; }

.ri-vimeo-line:before {
  content: "\\f28a"; }

.ri-vip-crown-2-fill:before {
  content: "\\f28b"; }

.ri-vip-crown-2-line:before {
  content: "\\f28c"; }

.ri-vip-crown-fill:before {
  content: "\\f28d"; }

.ri-vip-crown-line:before {
  content: "\\f28e"; }

.ri-vip-diamond-fill:before {
  content: "\\f28f"; }

.ri-vip-diamond-line:before {
  content: "\\f290"; }

.ri-vip-fill:before {
  content: "\\f291"; }

.ri-vip-line:before {
  content: "\\f292"; }

.ri-virus-fill:before {
  content: "\\f293"; }

.ri-virus-line:before {
  content: "\\f294"; }

.ri-visa-fill:before {
  content: "\\f295"; }

.ri-visa-line:before {
  content: "\\f296"; }

.ri-voice-recognition-fill:before {
  content: "\\f297"; }

.ri-voice-recognition-line:before {
  content: "\\f298"; }

.ri-voiceprint-fill:before {
  content: "\\f299"; }

.ri-voiceprint-line:before {
  content: "\\f29a"; }

.ri-volume-down-fill:before {
  content: "\\f29b"; }

.ri-volume-down-line:before {
  content: "\\f29c"; }

.ri-volume-mute-fill:before {
  content: "\\f29d"; }

.ri-volume-mute-line:before {
  content: "\\f29e"; }

.ri-volume-off-vibrate-fill:before {
  content: "\\f29f"; }

.ri-volume-off-vibrate-line:before {
  content: "\\f2a0"; }

.ri-volume-up-fill:before {
  content: "\\f2a1"; }

.ri-volume-up-line:before {
  content: "\\f2a2"; }

.ri-volume-vibrate-fill:before {
  content: "\\f2a3"; }

.ri-volume-vibrate-line:before {
  content: "\\f2a4"; }

.ri-vuejs-fill:before {
  content: "\\f2a5"; }

.ri-vuejs-line:before {
  content: "\\f2a6"; }

.ri-walk-fill:before {
  content: "\\f2a7"; }

.ri-walk-line:before {
  content: "\\f2a8"; }

.ri-wallet-2-fill:before {
  content: "\\f2a9"; }

.ri-wallet-2-line:before {
  content: "\\f2aa"; }

.ri-wallet-3-fill:before {
  content: "\\f2ab"; }

.ri-wallet-3-line:before {
  content: "\\f2ac"; }

.ri-wallet-fill:before {
  content: "\\f2ad"; }

.ri-wallet-line:before {
  content: "\\f2ae"; }

.ri-water-flash-fill:before {
  content: "\\f2af"; }

.ri-water-flash-line:before {
  content: "\\f2b0"; }

.ri-webcam-fill:before {
  content: "\\f2b1"; }

.ri-webcam-line:before {
  content: "\\f2b2"; }

.ri-wechat-2-fill:before {
  content: "\\f2b3"; }

.ri-wechat-2-line:before {
  content: "\\f2b4"; }

.ri-wechat-fill:before {
  content: "\\f2b5"; }

.ri-wechat-line:before {
  content: "\\f2b6"; }

.ri-wechat-pay-fill:before {
  content: "\\f2b7"; }

.ri-wechat-pay-line:before {
  content: "\\f2b8"; }

.ri-weibo-fill:before {
  content: "\\f2b9"; }

.ri-weibo-line:before {
  content: "\\f2ba"; }

.ri-whatsapp-fill:before {
  content: "\\f2bb"; }

.ri-whatsapp-line:before {
  content: "\\f2bc"; }

.ri-wheelchair-fill:before {
  content: "\\f2bd"; }

.ri-wheelchair-line:before {
  content: "\\f2be"; }

.ri-wifi-fill:before {
  content: "\\f2bf"; }

.ri-wifi-line:before {
  content: "\\f2c0"; }

.ri-wifi-off-fill:before {
  content: "\\f2c1"; }

.ri-wifi-off-line:before {
  content: "\\f2c2"; }

.ri-window-2-fill:before {
  content: "\\f2c3"; }

.ri-window-2-line:before {
  content: "\\f2c4"; }

.ri-window-fill:before {
  content: "\\f2c5"; }

.ri-window-line:before {
  content: "\\f2c6"; }

.ri-windows-fill:before {
  content: "\\f2c7"; }

.ri-windows-line:before {
  content: "\\f2c8"; }

.ri-windy-fill:before {
  content: "\\f2c9"; }

.ri-windy-line:before {
  content: "\\f2ca"; }

.ri-wireless-charging-fill:before {
  content: "\\f2cb"; }

.ri-wireless-charging-line:before {
  content: "\\f2cc"; }

.ri-women-fill:before {
  content: "\\f2cd"; }

.ri-women-line:before {
  content: "\\f2ce"; }

.ri-wubi-input:before {
  content: "\\f2cf"; }

.ri-xbox-fill:before {
  content: "\\f2d0"; }

.ri-xbox-line:before {
  content: "\\f2d1"; }

.ri-xing-fill:before {
  content: "\\f2d2"; }

.ri-xing-line:before {
  content: "\\f2d3"; }

.ri-youtube-fill:before {
  content: "\\f2d4"; }

.ri-youtube-line:before {
  content: "\\f2d5"; }

.ri-zcool-fill:before {
  content: "\\f2d6"; }

.ri-zcool-line:before {
  content: "\\f2d7"; }

.ri-zhihu-fill:before {
  content: "\\f2d8"; }

.ri-zhihu-line:before {
  content: "\\f2d9"; }

.ri-zoom-in-fill:before {
  content: "\\f2da"; }

.ri-zoom-in-line:before {
  content: "\\f2db"; }

.ri-zoom-out-fill:before {
  content: "\\f2dc"; }

.ri-zoom-out-line:before {
  content: "\\f2dd"; }

.ri-zzz-fill:before {
  content: "\\f2de"; }

.ri-zzz-line:before {
  content: "\\f2df"; }

/*
Template Name: Velzon - Admin & Dashboard Template
Author: Themesbrand
Version: 1.0.0
Website: https://Themesbrand.com/
Contact: Themesbrand@gmail.com
File: Custom Bootstrap Css File
*/
/*!
   * Bootstrap  v5.2.3 (https://getbootstrap.com/)
   * Copyright 2011-2022 The Bootstrap Authors
   * Copyright 2011-2022 Twitter, Inc.
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   */
:root {
  --bs-blue: #5ea3cb;
  --bs-indigo: #405189;
  --bs-purple: #7084c7;
  --bs-pink: #f672a7;
  --bs-red: #E53E3E;
  --bs-orange: #f1963b;
  --bs-yellow: #f7b84b;
  --bs-green: #319795;
  --bs-teal: #02a8b5;
  --bs-cyan: #58caea;
  --bs-white: #fff;
  --bs-gray: #878a99;
  --bs-gray-dark: #343a40;
  --bs-gray-100: #f3f6f9;
  --bs-gray-200: #eff2f7;
  --bs-gray-300: #e9ebec;
  --bs-gray-400: #ced4da;
  --bs-gray-500: #adb5bd;
  --bs-gray-600: #878a99;
  --bs-gray-700: #495057;
  --bs-gray-800: #343a40;
  --bs-gray-900: #212529;
  --bs-primary: #5ea3cb;
  --bs-secondary: #7084c7;
  --bs-success: #319795;
  --bs-info: #58caea;
  --bs-warning: #f7b84b;
  --bs-danger: #E53E3E;
  --bs-light: #f3f6f9;
  --bs-dark: #212529;
  --bs-primary-rgb: 94, 163, 203;
  --bs-secondary-rgb: 112, 132, 199;
  --bs-success-rgb: 49, 151, 149;
  --bs-info-rgb: 88, 202, 234;
  --bs-warning-rgb: 247, 184, 75;
  --bs-danger-rgb: 229, 62, 62;
  --bs-light-rgb: 243, 246, 249;
  --bs-dark-rgb: 33, 37, 41;
  --bs-white-rgb: 255, 255, 255;
  --bs-black-rgb: 0, 0, 0;
  --bs-body-color-rgb: 33, 37, 41;
  --bs-body-bg-rgb: 255, 255, 255;
  --bs-font-sans-serif: "Poppins", sans-serif;
  --bs-font-monospace: SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
  --bs-gradient: linear-gradient(180deg, rgba(255, 255, 255, 0.15), rgba(255, 255, 255, 0));
  --bs-body-font-family: var(--vz-font-sans-serif);
  --bs-body-font-size: 0.875rem;
  --bs-body-font-weight: 400;
  --bs-body-line-height: 1.5;
  --bs-body-color: #212529;
  --bs-body-bg: #ffffff;
  --bs-border-width: 1px;
  --bs-border-style: solid;
  --bs-border-color: var(--vz-border-color);
  --bs-border-color-translucent: rgba(0, 0, 0, 0.175);
  --bs-border-radius: 0.25rem;
  --bs-border-radius-sm: 0.2rem;
  --bs-border-radius-lg: 0.3rem;
  --bs-border-radius-xl: 1rem;
  --bs-border-radius-2xl: 2rem;
  --bs-border-radius-pill: 50rem;
  --bs-link-color: var(--vz-link-color);
  --bs-link-hover-color: var(--vz-link-hover-color);
  --bs-code-color: #f672a7;
  --bs-highlight-bg: #fcf8e3; }

*,
*::before,
*::after {
  box-sizing: border-box; }

@media (prefers-reduced-motion: no-preference) {
  :root {
    scroll-behavior: smooth; } }

body {
  margin: 0;
  font-family: var(--bs-body-font-family);
  font-size: var(--bs-body-font-size);
  font-weight: var(--bs-body-font-weight);
  line-height: var(--bs-body-line-height);
  color: var(--bs-body-color);
  text-align: var(--bs-body-text-align);
  background-color: var(--bs-body-bg);
  -webkit-text-size-adjust: 100%;
  -webkit-tap-highlight-color: rgba(0, 0, 0, 0); }

hr {
  margin: 1rem 0;
  color: inherit;
  border: 0;
  border-top: 1px solid;
  opacity: 0.25; }

h1, .h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5, h6, .h6 {
  margin-top: 0;
  margin-bottom: 0.5rem;
  font-weight: 600;
  line-height: 1.2; }

h1, .h1 {
  font-size: calc(1.34375rem + 1.125vw); }
  @media (min-width: 1200px) {
    h1, .h1 {
      font-size: 2.1875rem; } }

h2, .h2 {
  font-size: calc(1.3rem + 0.6vw); }
  @media (min-width: 1200px) {
    h2, .h2 {
      font-size: 1.75rem; } }

h3, .h3 {
  font-size: calc(1.27813rem + 0.3375vw); }
  @media (min-width: 1200px) {
    h3, .h3 {
      font-size: 1.53125rem; } }

h4, .h4 {
  font-size: calc(1.25625rem + 0.075vw); }
  @media (min-width: 1200px) {
    h4, .h4 {
      font-size: 1.3125rem; } }

h5, .h5 {
  font-size: 1.09375rem; }

h6, .h6 {
  font-size: 0.875rem; }

p {
  margin-top: 0;
  margin-bottom: 1rem; }

abbr[title] {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
  cursor: help;
  text-decoration-skip-ink: none; }

address {
  margin-bottom: 1rem;
  font-style: normal;
  line-height: inherit; }

ol,
ul {
  padding-left: 2rem; }

ol,
ul,
dl {
  margin-top: 0;
  margin-bottom: 1rem; }

ol ol,
ul ul,
ol ul,
ul ol {
  margin-bottom: 0; }

dt {
  font-weight: 600; }

dd {
  margin-bottom: .5rem;
  margin-left: 0; }

blockquote {
  margin: 0 0 1rem; }

b,
strong {
  font-weight: bolder; }

small, .small {
  font-size: 0.875em; }

mark, .mark {
  padding: 0.2em;
  background-color: var(--bs-highlight-bg); }

sub,
sup {
  position: relative;
  font-size: 0.75em;
  line-height: 0;
  vertical-align: baseline; }

sub {
  bottom: -.25em; }

sup {
  top: -.5em; }

a {
  color: var(--bs-link-color);
  text-decoration: underline; }
  a:hover {
    color: var(--bs-link-hover-color); }

a:not([href]):not([class]), a:not([href]):not([class]):hover {
  color: inherit;
  text-decoration: none; }

pre,
code,
kbd,
samp {
  font-family: var(--vz-font-monospace);
  font-size: 1em; }

pre {
  display: block;
  margin-top: 0;
  margin-bottom: 1rem;
  overflow: auto;
  font-size: 0.875em; }
  pre code {
    font-size: inherit;
    color: inherit;
    word-break: normal; }

code {
  font-size: 0.875em;
  color: var(--bs-code-color);
  word-wrap: break-word; }
  a > code {
    color: inherit; }

kbd {
  padding: 0.2rem 0.4rem;
  font-size: 0.875em;
  color: #fff;
  background-color: #212529;
  border-radius: 0.2rem; }
  kbd kbd {
    padding: 0;
    font-size: 1em;
    font-weight: 700; }

figure {
  margin: 0 0 1rem; }

img,
svg {
  vertical-align: middle; }

table {
  caption-side: bottom;
  border-collapse: collapse; }

caption {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
  color: #878a99;
  text-align: left; }

th {
  text-align: inherit;
  text-align: -webkit-match-parent; }

thead,
tbody,
tfoot,
tr,
td,
th {
  border-color: inherit;
  border-style: solid;
  border-width: 0; }

label {
  display: inline-block; }

button {
  border-radius: 0; }

button:focus:not(:focus-visible) {
  outline: 0; }

input,
button,
select,
optgroup,
textarea {
  margin: 0;
  font-family: inherit;
  font-size: inherit;
  line-height: inherit; }

button,
select {
  text-transform: none; }

[role="button"] {
  cursor: pointer; }

select {
  word-wrap: normal; }
  select:disabled {
    opacity: 1; }

[list]:not([type="date"]):not([type="datetime-local"]):not([type="month"]):not([type="week"]):not([type="time"])::-webkit-calendar-picker-indicator {
  display: none !important; }

button,
[type="button"],
[type="reset"],
[type="submit"] {
  -webkit-appearance: button; }
  button:not(:disabled),
  [type="button"]:not(:disabled),
  [type="reset"]:not(:disabled),
  [type="submit"]:not(:disabled) {
    cursor: pointer; }

::-moz-focus-inner {
  padding: 0;
  border-style: none; }

textarea {
  resize: vertical; }

fieldset {
  min-width: 0;
  padding: 0;
  margin: 0;
  border: 0; }

legend {
  float: left;
  width: 100%;
  padding: 0;
  margin-bottom: 0.5rem;
  font-size: calc(1.275rem + 0.3vw);
  line-height: inherit; }
  @media (min-width: 1200px) {
    legend {
      font-size: 1.5rem; } }
  legend + * {
    clear: left; }

::-webkit-datetime-edit-fields-wrapper,
::-webkit-datetime-edit-text,
::-webkit-datetime-edit-minute,
::-webkit-datetime-edit-hour-field,
::-webkit-datetime-edit-day-field,
::-webkit-datetime-edit-month-field,
::-webkit-datetime-edit-year-field {
  padding: 0; }

::-webkit-inner-spin-button {
  height: auto; }

[type="search"] {
  outline-offset: -2px;
  -webkit-appearance: textfield; }

/* rtl:raw:
[type="tel"],
[type="url"],
[type="email"],
[type="number"] {
  direction: ltr;
}
*/
::-webkit-search-decoration {
  -webkit-appearance: none; }

::-webkit-color-swatch-wrapper {
  padding: 0; }

::file-selector-button {
  font: inherit;
  -webkit-appearance: button; }

output {
  display: inline-block; }

iframe {
  border: 0; }

summary {
  display: list-item;
  cursor: pointer; }

progress {
  vertical-align: baseline; }

[hidden] {
  display: none !important; }

.lead {
  font-size: 1.09375rem;
  font-weight: 300; }

.display-1 {
  font-size: calc(1.625rem + 4.5vw);
  font-weight: 300;
  line-height: 1.2; }
  @media (min-width: 1200px) {
    .display-1 {
      font-size: 5rem; } }

.display-2 {
  font-size: calc(1.575rem + 3.9vw);
  font-weight: 300;
  line-height: 1.2; }
  @media (min-width: 1200px) {
    .display-2 {
      font-size: 4.5rem; } }

.display-3 {
  font-size: calc(1.525rem + 3.3vw);
  font-weight: 300;
  line-height: 1.2; }
  @media (min-width: 1200px) {
    .display-3 {
      font-size: 4rem; } }

.display-4 {
  font-size: calc(1.475rem + 2.7vw);
  font-weight: 300;
  line-height: 1.2; }
  @media (min-width: 1200px) {
    .display-4 {
      font-size: 3.5rem; } }

.display-5 {
  font-size: calc(1.425rem + 2.1vw);
  font-weight: 300;
  line-height: 1.2; }
  @media (min-width: 1200px) {
    .display-5 {
      font-size: 3rem; } }

.display-6 {
  font-size: calc(1.375rem + 1.5vw);
  font-weight: 300;
  line-height: 1.2; }
  @media (min-width: 1200px) {
    .display-6 {
      font-size: 2.5rem; } }

.list-unstyled {
  padding-left: 0;
  list-style: none; }

.list-inline {
  padding-left: 0;
  list-style: none; }

.list-inline-item {
  display: inline-block; }
  .list-inline-item:not(:last-child) {
    margin-right: 0.5rem; }

.initialism {
  font-size: 0.875em;
  text-transform: uppercase; }

.blockquote {
  margin-bottom: 1rem;
  font-size: 0.9625rem; }
  .blockquote > :last-child {
    margin-bottom: 0; }

.blockquote-footer {
  margin-top: -1rem;
  margin-bottom: 1rem;
  font-size: 0.875em;
  color: #878a99; }
  .blockquote-footer::before {
    content: "\\2014\\00A0"; }

.img-fluid {
  max-width: 100%;
  height: auto; }

.img-thumbnail {
  padding: 0.25rem;
  background-color: var(--vz-body-bg);
  border: 1px solid var(--vz-border-color);
  border-radius: 0.25rem;
  max-width: 100%;
  height: auto; }

.figure {
  display: inline-block; }

.figure-img {
  margin-bottom: 0.5rem;
  line-height: 1; }

.figure-caption {
  font-size: 0.875em;
  color: #878a99; }

.container,
.container-fluid,
.container-sm,
.container-md,
.container-lg,
.container-xl,
.container-xxl {
  --bs-gutter-x: 0.75rem;
  --bs-gutter-y: 0;
  width: 100%;
  padding-right: calc(var(--bs-gutter-x) * .5);
  padding-left: calc(var(--bs-gutter-x) * .5);
  margin-right: auto;
  margin-left: auto; }

@media (min-width: 576px) {
  .container, .container-sm {
    max-width: 540px; } }

@media (min-width: 768px) {
  .container, .container-sm, .container-md {
    max-width: 720px; } }

@media (min-width: 992px) {
  .container, .container-sm, .container-md, .container-lg {
    max-width: 960px; } }

@media (min-width: 1200px) {
  .container, .container-sm, .container-md, .container-lg, .container-xl {
    max-width: 1140px; } }

@media (min-width: 1400px) {
  .container, .container-sm, .container-md, .container-lg, .container-xl, .container-xxl {
    max-width: 1320px; } }

.row {
  --bs-gutter-x: 1.5rem;
  --bs-gutter-y: 0;
  display: flex;
  flex-wrap: wrap;
  margin-top: calc(-1 * var(--bs-gutter-y));
  margin-right: calc(-.5 * var(--bs-gutter-x));
  margin-left: calc(-.5 * var(--bs-gutter-x)); }
  .row > * {
    flex-shrink: 0;
    width: 100%;
    max-width: 100%;
    padding-right: calc(var(--bs-gutter-x) * .5);
    padding-left: calc(var(--bs-gutter-x) * .5);
    margin-top: var(--bs-gutter-y); }

.col {
  flex: 1 0; }

.row-cols-auto > * {
  flex: 0 0 auto;
  width: auto; }

.row-cols-1 > * {
  flex: 0 0 auto;
  width: 100%; }

.row-cols-2 > * {
  flex: 0 0 auto;
  width: 50%; }

.row-cols-3 > * {
  flex: 0 0 auto;
  width: 33.33333%; }

.row-cols-4 > * {
  flex: 0 0 auto;
  width: 25%; }

.row-cols-5 > * {
  flex: 0 0 auto;
  width: 20%; }

.row-cols-6 > * {
  flex: 0 0 auto;
  width: 16.66667%; }

.col-auto {
  flex: 0 0 auto;
  width: auto; }

.col-1 {
  flex: 0 0 auto;
  width: 8.33333%; }

.col-2 {
  flex: 0 0 auto;
  width: 16.66667%; }

.col-3 {
  flex: 0 0 auto;
  width: 25%; }

.col-4 {
  flex: 0 0 auto;
  width: 33.33333%; }

.col-5 {
  flex: 0 0 auto;
  width: 41.66667%; }

.col-6 {
  flex: 0 0 auto;
  width: 50%; }

.col-7 {
  flex: 0 0 auto;
  width: 58.33333%; }

.col-8 {
  flex: 0 0 auto;
  width: 66.66667%; }

.col-9 {
  flex: 0 0 auto;
  width: 75%; }

.col-10 {
  flex: 0 0 auto;
  width: 83.33333%; }

.col-11 {
  flex: 0 0 auto;
  width: 91.66667%; }

.col-12 {
  flex: 0 0 auto;
  width: 100%; }

.offset-1 {
  margin-left: 8.33333%; }

.offset-2 {
  margin-left: 16.66667%; }

.offset-3 {
  margin-left: 25%; }

.offset-4 {
  margin-left: 33.33333%; }

.offset-5 {
  margin-left: 41.66667%; }

.offset-6 {
  margin-left: 50%; }

.offset-7 {
  margin-left: 58.33333%; }

.offset-8 {
  margin-left: 66.66667%; }

.offset-9 {
  margin-left: 75%; }

.offset-10 {
  margin-left: 83.33333%; }

.offset-11 {
  margin-left: 91.66667%; }

.g-0,
.gx-0 {
  --bs-gutter-x: 0; }

.g-0,
.gy-0 {
  --bs-gutter-y: 0; }

.g-1,
.gx-1 {
  --bs-gutter-x: 0.25rem; }

.g-1,
.gy-1 {
  --bs-gutter-y: 0.25rem; }

.g-2,
.gx-2 {
  --bs-gutter-x: 0.5rem; }

.g-2,
.gy-2 {
  --bs-gutter-y: 0.5rem; }

.g-3,
.gx-3 {
  --bs-gutter-x: 1rem; }

.g-3,
.gy-3 {
  --bs-gutter-y: 1rem; }

.g-4,
.gx-4 {
  --bs-gutter-x: 1.5rem; }

.g-4,
.gy-4 {
  --bs-gutter-y: 1.5rem; }

.g-5,
.gx-5 {
  --bs-gutter-x: 3rem; }

.g-5,
.gy-5 {
  --bs-gutter-y: 3rem; }

@media (min-width: 576px) {
  .col-sm {
    flex: 1 0; }
  .row-cols-sm-auto > * {
    flex: 0 0 auto;
    width: auto; }
  .row-cols-sm-1 > * {
    flex: 0 0 auto;
    width: 100%; }
  .row-cols-sm-2 > * {
    flex: 0 0 auto;
    width: 50%; }
  .row-cols-sm-3 > * {
    flex: 0 0 auto;
    width: 33.33333%; }
  .row-cols-sm-4 > * {
    flex: 0 0 auto;
    width: 25%; }
  .row-cols-sm-5 > * {
    flex: 0 0 auto;
    width: 20%; }
  .row-cols-sm-6 > * {
    flex: 0 0 auto;
    width: 16.66667%; }
  .col-sm-auto {
    flex: 0 0 auto;
    width: auto; }
  .col-sm-1 {
    flex: 0 0 auto;
    width: 8.33333%; }
  .col-sm-2 {
    flex: 0 0 auto;
    width: 16.66667%; }
  .col-sm-3 {
    flex: 0 0 auto;
    width: 25%; }
  .col-sm-4 {
    flex: 0 0 auto;
    width: 33.33333%; }
  .col-sm-5 {
    flex: 0 0 auto;
    width: 41.66667%; }
  .col-sm-6 {
    flex: 0 0 auto;
    width: 50%; }
  .col-sm-7 {
    flex: 0 0 auto;
    width: 58.33333%; }
  .col-sm-8 {
    flex: 0 0 auto;
    width: 66.66667%; }
  .col-sm-9 {
    flex: 0 0 auto;
    width: 75%; }
  .col-sm-10 {
    flex: 0 0 auto;
    width: 83.33333%; }
  .col-sm-11 {
    flex: 0 0 auto;
    width: 91.66667%; }
  .col-sm-12 {
    flex: 0 0 auto;
    width: 100%; }
  .offset-sm-0 {
    margin-left: 0; }
  .offset-sm-1 {
    margin-left: 8.33333%; }
  .offset-sm-2 {
    margin-left: 16.66667%; }
  .offset-sm-3 {
    margin-left: 25%; }
  .offset-sm-4 {
    margin-left: 33.33333%; }
  .offset-sm-5 {
    margin-left: 41.66667%; }
  .offset-sm-6 {
    margin-left: 50%; }
  .offset-sm-7 {
    margin-left: 58.33333%; }
  .offset-sm-8 {
    margin-left: 66.66667%; }
  .offset-sm-9 {
    margin-left: 75%; }
  .offset-sm-10 {
    margin-left: 83.33333%; }
  .offset-sm-11 {
    margin-left: 91.66667%; }
  .g-sm-0,
  .gx-sm-0 {
    --bs-gutter-x: 0; }
  .g-sm-0,
  .gy-sm-0 {
    --bs-gutter-y: 0; }
  .g-sm-1,
  .gx-sm-1 {
    --bs-gutter-x: 0.25rem; }
  .g-sm-1,
  .gy-sm-1 {
    --bs-gutter-y: 0.25rem; }
  .g-sm-2,
  .gx-sm-2 {
    --bs-gutter-x: 0.5rem; }
  .g-sm-2,
  .gy-sm-2 {
    --bs-gutter-y: 0.5rem; }
  .g-sm-3,
  .gx-sm-3 {
    --bs-gutter-x: 1rem; }
  .g-sm-3,
  .gy-sm-3 {
    --bs-gutter-y: 1rem; }
  .g-sm-4,
  .gx-sm-4 {
    --bs-gutter-x: 1.5rem; }
  .g-sm-4,
  .gy-sm-4 {
    --bs-gutter-y: 1.5rem; }
  .g-sm-5,
  .gx-sm-5 {
    --bs-gutter-x: 3rem; }
  .g-sm-5,
  .gy-sm-5 {
    --bs-gutter-y: 3rem; } }

@media (min-width: 768px) {
  .col-md {
    flex: 1 0; }
  .row-cols-md-auto > * {
    flex: 0 0 auto;
    width: auto; }
  .row-cols-md-1 > * {
    flex: 0 0 auto;
    width: 100%; }
  .row-cols-md-2 > * {
    flex: 0 0 auto;
    width: 50%; }
  .row-cols-md-3 > * {
    flex: 0 0 auto;
    width: 33.33333%; }
  .row-cols-md-4 > * {
    flex: 0 0 auto;
    width: 25%; }
  .row-cols-md-5 > * {
    flex: 0 0 auto;
    width: 20%; }
  .row-cols-md-6 > * {
    flex: 0 0 auto;
    width: 16.66667%; }
  .col-md-auto {
    flex: 0 0 auto;
    width: auto; }
  .col-md-1 {
    flex: 0 0 auto;
    width: 8.33333%; }
  .col-md-2 {
    flex: 0 0 auto;
    width: 16.66667%; }
  .col-md-3 {
    flex: 0 0 auto;
    width: 25%; }
  .col-md-4 {
    flex: 0 0 auto;
    width: 33.33333%; }
  .col-md-5 {
    flex: 0 0 auto;
    width: 41.66667%; }
  .col-md-6 {
    flex: 0 0 auto;
    width: 50%; }
  .col-md-7 {
    flex: 0 0 auto;
    width: 58.33333%; }
  .col-md-8 {
    flex: 0 0 auto;
    width: 66.66667%; }
  .col-md-9 {
    flex: 0 0 auto;
    width: 75%; }
  .col-md-10 {
    flex: 0 0 auto;
    width: 83.33333%; }
  .col-md-11 {
    flex: 0 0 auto;
    width: 91.66667%; }
  .col-md-12 {
    flex: 0 0 auto;
    width: 100%; }
  .offset-md-0 {
    margin-left: 0; }
  .offset-md-1 {
    margin-left: 8.33333%; }
  .offset-md-2 {
    margin-left: 16.66667%; }
  .offset-md-3 {
    margin-left: 25%; }
  .offset-md-4 {
    margin-left: 33.33333%; }
  .offset-md-5 {
    margin-left: 41.66667%; }
  .offset-md-6 {
    margin-left: 50%; }
  .offset-md-7 {
    margin-left: 58.33333%; }
  .offset-md-8 {
    margin-left: 66.66667%; }
  .offset-md-9 {
    margin-left: 75%; }
  .offset-md-10 {
    margin-left: 83.33333%; }
  .offset-md-11 {
    margin-left: 91.66667%; }
  .g-md-0,
  .gx-md-0 {
    --bs-gutter-x: 0; }
  .g-md-0,
  .gy-md-0 {
    --bs-gutter-y: 0; }
  .g-md-1,
  .gx-md-1 {
    --bs-gutter-x: 0.25rem; }
  .g-md-1,
  .gy-md-1 {
    --bs-gutter-y: 0.25rem; }
  .g-md-2,
  .gx-md-2 {
    --bs-gutter-x: 0.5rem; }
  .g-md-2,
  .gy-md-2 {
    --bs-gutter-y: 0.5rem; }
  .g-md-3,
  .gx-md-3 {
    --bs-gutter-x: 1rem; }
  .g-md-3,
  .gy-md-3 {
    --bs-gutter-y: 1rem; }
  .g-md-4,
  .gx-md-4 {
    --bs-gutter-x: 1.5rem; }
  .g-md-4,
  .gy-md-4 {
    --bs-gutter-y: 1.5rem; }
  .g-md-5,
  .gx-md-5 {
    --bs-gutter-x: 3rem; }
  .g-md-5,
  .gy-md-5 {
    --bs-gutter-y: 3rem; } }

@media (min-width: 992px) {
  .col-lg {
    flex: 1 0; }
  .row-cols-lg-auto > * {
    flex: 0 0 auto;
    width: auto; }
  .row-cols-lg-1 > * {
    flex: 0 0 auto;
    width: 100%; }
  .row-cols-lg-2 > * {
    flex: 0 0 auto;
    width: 50%; }
  .row-cols-lg-3 > * {
    flex: 0 0 auto;
    width: 33.33333%; }
  .row-cols-lg-4 > * {
    flex: 0 0 auto;
    width: 25%; }
  .row-cols-lg-5 > * {
    flex: 0 0 auto;
    width: 20%; }
  .row-cols-lg-6 > * {
    flex: 0 0 auto;
    width: 16.66667%; }
  .col-lg-auto {
    flex: 0 0 auto;
    width: auto; }
  .col-lg-1 {
    flex: 0 0 auto;
    width: 8.33333%; }
  .col-lg-2 {
    flex: 0 0 auto;
    width: 16.66667%; }
  .col-lg-3 {
    flex: 0 0 auto;
    width: 25%; }
  .col-lg-4 {
    flex: 0 0 auto;
    width: 33.33333%; }
  .col-lg-5 {
    flex: 0 0 auto;
    width: 41.66667%; }
  .col-lg-6 {
    flex: 0 0 auto;
    width: 50%; }
  .col-lg-7 {
    flex: 0 0 auto;
    width: 58.33333%; }
  .col-lg-8 {
    flex: 0 0 auto;
    width: 66.66667%; }
  .col-lg-9 {
    flex: 0 0 auto;
    width: 75%; }
  .col-lg-10 {
    flex: 0 0 auto;
    width: 83.33333%; }
  .col-lg-11 {
    flex: 0 0 auto;
    width: 91.66667%; }
  .col-lg-12 {
    flex: 0 0 auto;
    width: 100%; }
  .offset-lg-0 {
    margin-left: 0; }
  .offset-lg-1 {
    margin-left: 8.33333%; }
  .offset-lg-2 {
    margin-left: 16.66667%; }
  .offset-lg-3 {
    margin-left: 25%; }
  .offset-lg-4 {
    margin-left: 33.33333%; }
  .offset-lg-5 {
    margin-left: 41.66667%; }
  .offset-lg-6 {
    margin-left: 50%; }
  .offset-lg-7 {
    margin-left: 58.33333%; }
  .offset-lg-8 {
    margin-left: 66.66667%; }
  .offset-lg-9 {
    margin-left: 75%; }
  .offset-lg-10 {
    margin-left: 83.33333%; }
  .offset-lg-11 {
    margin-left: 91.66667%; }
  .g-lg-0,
  .gx-lg-0 {
    --bs-gutter-x: 0; }
  .g-lg-0,
  .gy-lg-0 {
    --bs-gutter-y: 0; }
  .g-lg-1,
  .gx-lg-1 {
    --bs-gutter-x: 0.25rem; }
  .g-lg-1,
  .gy-lg-1 {
    --bs-gutter-y: 0.25rem; }
  .g-lg-2,
  .gx-lg-2 {
    --bs-gutter-x: 0.5rem; }
  .g-lg-2,
  .gy-lg-2 {
    --bs-gutter-y: 0.5rem; }
  .g-lg-3,
  .gx-lg-3 {
    --bs-gutter-x: 1rem; }
  .g-lg-3,
  .gy-lg-3 {
    --bs-gutter-y: 1rem; }
  .g-lg-4,
  .gx-lg-4 {
    --bs-gutter-x: 1.5rem; }
  .g-lg-4,
  .gy-lg-4 {
    --bs-gutter-y: 1.5rem; }
  .g-lg-5,
  .gx-lg-5 {
    --bs-gutter-x: 3rem; }
  .g-lg-5,
  .gy-lg-5 {
    --bs-gutter-y: 3rem; } }

@media (min-width: 1200px) {
  .col-xl {
    flex: 1 0; }
  .row-cols-xl-auto > * {
    flex: 0 0 auto;
    width: auto; }
  .row-cols-xl-1 > * {
    flex: 0 0 auto;
    width: 100%; }
  .row-cols-xl-2 > * {
    flex: 0 0 auto;
    width: 50%; }
  .row-cols-xl-3 > * {
    flex: 0 0 auto;
    width: 33.33333%; }
  .row-cols-xl-4 > * {
    flex: 0 0 auto;
    width: 25%; }
  .row-cols-xl-5 > * {
    flex: 0 0 auto;
    width: 20%; }
  .row-cols-xl-6 > * {
    flex: 0 0 auto;
    width: 16.66667%; }
  .col-xl-auto {
    flex: 0 0 auto;
    width: auto; }
  .col-xl-1 {
    flex: 0 0 auto;
    width: 8.33333%; }
  .col-xl-2 {
    flex: 0 0 auto;
    width: 16.66667%; }
  .col-xl-3 {
    flex: 0 0 auto;
    width: 25%; }
  .col-xl-4 {
    flex: 0 0 auto;
    width: 33.33333%; }
  .col-xl-5 {
    flex: 0 0 auto;
    width: 41.66667%; }
  .col-xl-6 {
    flex: 0 0 auto;
    width: 50%; }
  .col-xl-7 {
    flex: 0 0 auto;
    width: 58.33333%; }
  .col-xl-8 {
    flex: 0 0 auto;
    width: 66.66667%; }
  .col-xl-9 {
    flex: 0 0 auto;
    width: 75%; }
  .col-xl-10 {
    flex: 0 0 auto;
    width: 83.33333%; }
  .col-xl-11 {
    flex: 0 0 auto;
    width: 91.66667%; }
  .col-xl-12 {
    flex: 0 0 auto;
    width: 100%; }
  .offset-xl-0 {
    margin-left: 0; }
  .offset-xl-1 {
    margin-left: 8.33333%; }
  .offset-xl-2 {
    margin-left: 16.66667%; }
  .offset-xl-3 {
    margin-left: 25%; }
  .offset-xl-4 {
    margin-left: 33.33333%; }
  .offset-xl-5 {
    margin-left: 41.66667%; }
  .offset-xl-6 {
    margin-left: 50%; }
  .offset-xl-7 {
    margin-left: 58.33333%; }
  .offset-xl-8 {
    margin-left: 66.66667%; }
  .offset-xl-9 {
    margin-left: 75%; }
  .offset-xl-10 {
    margin-left: 83.33333%; }
  .offset-xl-11 {
    margin-left: 91.66667%; }
  .g-xl-0,
  .gx-xl-0 {
    --bs-gutter-x: 0; }
  .g-xl-0,
  .gy-xl-0 {
    --bs-gutter-y: 0; }
  .g-xl-1,
  .gx-xl-1 {
    --bs-gutter-x: 0.25rem; }
  .g-xl-1,
  .gy-xl-1 {
    --bs-gutter-y: 0.25rem; }
  .g-xl-2,
  .gx-xl-2 {
    --bs-gutter-x: 0.5rem; }
  .g-xl-2,
  .gy-xl-2 {
    --bs-gutter-y: 0.5rem; }
  .g-xl-3,
  .gx-xl-3 {
    --bs-gutter-x: 1rem; }
  .g-xl-3,
  .gy-xl-3 {
    --bs-gutter-y: 1rem; }
  .g-xl-4,
  .gx-xl-4 {
    --bs-gutter-x: 1.5rem; }
  .g-xl-4,
  .gy-xl-4 {
    --bs-gutter-y: 1.5rem; }
  .g-xl-5,
  .gx-xl-5 {
    --bs-gutter-x: 3rem; }
  .g-xl-5,
  .gy-xl-5 {
    --bs-gutter-y: 3rem; } }

@media (min-width: 1400px) {
  .col-xxl {
    flex: 1 0; }
  .row-cols-xxl-auto > * {
    flex: 0 0 auto;
    width: auto; }
  .row-cols-xxl-1 > * {
    flex: 0 0 auto;
    width: 100%; }
  .row-cols-xxl-2 > * {
    flex: 0 0 auto;
    width: 50%; }
  .row-cols-xxl-3 > * {
    flex: 0 0 auto;
    width: 33.33333%; }
  .row-cols-xxl-4 > * {
    flex: 0 0 auto;
    width: 25%; }
  .row-cols-xxl-5 > * {
    flex: 0 0 auto;
    width: 20%; }
  .row-cols-xxl-6 > * {
    flex: 0 0 auto;
    width: 16.66667%; }
  .col-xxl-auto {
    flex: 0 0 auto;
    width: auto; }
  .col-xxl-1 {
    flex: 0 0 auto;
    width: 8.33333%; }
  .col-xxl-2 {
    flex: 0 0 auto;
    width: 16.66667%; }
  .col-xxl-3 {
    flex: 0 0 auto;
    width: 25%; }
  .col-xxl-4 {
    flex: 0 0 auto;
    width: 33.33333%; }
  .col-xxl-5 {
    flex: 0 0 auto;
    width: 41.66667%; }
  .col-xxl-6 {
    flex: 0 0 auto;
    width: 50%; }
  .col-xxl-7 {
    flex: 0 0 auto;
    width: 58.33333%; }
  .col-xxl-8 {
    flex: 0 0 auto;
    width: 66.66667%; }
  .col-xxl-9 {
    flex: 0 0 auto;
    width: 75%; }
  .col-xxl-10 {
    flex: 0 0 auto;
    width: 83.33333%; }
  .col-xxl-11 {
    flex: 0 0 auto;
    width: 91.66667%; }
  .col-xxl-12 {
    flex: 0 0 auto;
    width: 100%; }
  .offset-xxl-0 {
    margin-left: 0; }
  .offset-xxl-1 {
    margin-left: 8.33333%; }
  .offset-xxl-2 {
    margin-left: 16.66667%; }
  .offset-xxl-3 {
    margin-left: 25%; }
  .offset-xxl-4 {
    margin-left: 33.33333%; }
  .offset-xxl-5 {
    margin-left: 41.66667%; }
  .offset-xxl-6 {
    margin-left: 50%; }
  .offset-xxl-7 {
    margin-left: 58.33333%; }
  .offset-xxl-8 {
    margin-left: 66.66667%; }
  .offset-xxl-9 {
    margin-left: 75%; }
  .offset-xxl-10 {
    margin-left: 83.33333%; }
  .offset-xxl-11 {
    margin-left: 91.66667%; }
  .g-xxl-0,
  .gx-xxl-0 {
    --bs-gutter-x: 0; }
  .g-xxl-0,
  .gy-xxl-0 {
    --bs-gutter-y: 0; }
  .g-xxl-1,
  .gx-xxl-1 {
    --bs-gutter-x: 0.25rem; }
  .g-xxl-1,
  .gy-xxl-1 {
    --bs-gutter-y: 0.25rem; }
  .g-xxl-2,
  .gx-xxl-2 {
    --bs-gutter-x: 0.5rem; }
  .g-xxl-2,
  .gy-xxl-2 {
    --bs-gutter-y: 0.5rem; }
  .g-xxl-3,
  .gx-xxl-3 {
    --bs-gutter-x: 1rem; }
  .g-xxl-3,
  .gy-xxl-3 {
    --bs-gutter-y: 1rem; }
  .g-xxl-4,
  .gx-xxl-4 {
    --bs-gutter-x: 1.5rem; }
  .g-xxl-4,
  .gy-xxl-4 {
    --bs-gutter-y: 1.5rem; }
  .g-xxl-5,
  .gx-xxl-5 {
    --bs-gutter-x: 3rem; }
  .g-xxl-5,
  .gy-xxl-5 {
    --bs-gutter-y: 3rem; } }

.table {
  --bs-table-color: var(--vz-body-color);
  --bs-table-bg: transparent;
  --bs-table-border-color: var(--vz-border-color);
  --bs-table-accent-bg: transparent;
  --bs-table-striped-color: var(--vz-body-color);
  --bs-table-striped-bg: rgba(var(--vz-dark-rgb), 0.02);
  --bs-table-active-color: var(--vz-body-color);
  --bs-table-active-bg: rgba(var(--vz-light-rgb), 1);
  --bs-table-hover-color: var(--vz-body-color);
  --bs-table-hover-bg: rgba(var(--vz-light-rgb), 1);
  width: 100%;
  margin-bottom: 1rem;
  color: var(--bs-table-color);
  vertical-align: top;
  border-color: var(--bs-table-border-color); }
  .table > :not(caption) > * > * {
    padding: 0.75rem 0.6rem;
    background-color: var(--bs-table-bg);
    border-bottom-width: 1px;
    box-shadow: inset 0 0 0 9999px var(--bs-table-accent-bg); }
  .table > tbody {
    vertical-align: inherit; }
  .table > thead {
    vertical-align: bottom; }

.table-group-divider {
  border-top: 2px solid var(--vz-border-color); }

.caption-top {
  caption-side: top; }

.table-sm > :not(caption) > * > * {
  padding: 0.3rem 0.25rem; }

.table-bordered > :not(caption) > * {
  border-width: 1px 0; }
  .table-bordered > :not(caption) > * > * {
    border-width: 0 1px; }

.table-borderless > :not(caption) > * > * {
  border-bottom-width: 0; }

.table-borderless > :not(:first-child) {
  border-top-width: 0; }

.table-striped > tbody > tr:nth-of-type(odd) > * {
  --bs-table-accent-bg: var(--bs-table-striped-bg);
  color: var(--bs-table-striped-color); }

.table-striped-columns > :not(caption) > tr > :nth-child(even) {
  --bs-table-accent-bg: var(--bs-table-striped-bg);
  color: var(--bs-table-striped-color); }

.table-active {
  --bs-table-accent-bg: var(--bs-table-active-bg);
  color: var(--bs-table-active-color); }

.table-hover > tbody > tr:hover > * {
  --bs-table-accent-bg: var(--bs-table-hover-bg);
  color: var(--bs-table-hover-color); }

.table-primary {
  --bs-table-color: #000;
  --bs-table-bg: #dfedf5;
  --bs-table-border-color: #c9d5dd;
  --bs-table-striped-bg: #dbe8f0;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: black;
  --bs-table-active-color: #fff;
  --bs-table-hover-bg: black;
  --bs-table-hover-color: #fff;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color); }

.table-secondary {
  --bs-table-color: #000;
  --bs-table-bg: #e2e6f4;
  --bs-table-border-color: #cbcfdc;
  --bs-table-striped-bg: #dde1ef;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: black;
  --bs-table-active-color: #fff;
  --bs-table-hover-bg: black;
  --bs-table-hover-color: #fff;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color); }

.table-success {
  --bs-table-color: #000;
  --bs-table-bg: #d6eaea;
  --bs-table-border-color: #c1d3d3;
  --bs-table-striped-bg: #d2e5e5;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: black;
  --bs-table-active-color: #fff;
  --bs-table-hover-bg: black;
  --bs-table-hover-color: #fff;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color); }

.table-info {
  --bs-table-color: #000;
  --bs-table-bg: #def4fb;
  --bs-table-border-color: #c8dce2;
  --bs-table-striped-bg: #daeff6;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: black;
  --bs-table-active-color: #fff;
  --bs-table-hover-bg: black;
  --bs-table-hover-color: #fff;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color); }

.table-warning {
  --bs-table-color: #000;
  --bs-table-bg: #fdf1db;
  --bs-table-border-color: #e4d9c5;
  --bs-table-striped-bg: #f8ecd7;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: black;
  --bs-table-active-color: #fff;
  --bs-table-hover-bg: black;
  --bs-table-hover-color: #fff;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color); }

.table-danger {
  --bs-table-color: #000;
  --bs-table-bg: #fad8d8;
  --bs-table-border-color: #e1c2c2;
  --bs-table-striped-bg: #f5d4d4;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: black;
  --bs-table-active-color: #fff;
  --bs-table-hover-bg: black;
  --bs-table-hover-color: #fff;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color); }

.table-light {
  --bs-table-color: #000;
  --bs-table-bg: #f3f6f9;
  --bs-table-border-color: #dbdde0;
  --bs-table-striped-bg: #eef1f4;
  --bs-table-striped-color: #000;
  --bs-table-active-bg: black;
  --bs-table-active-color: #fff;
  --bs-table-hover-bg: black;
  --bs-table-hover-color: #fff;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color); }

.table-dark {
  --bs-table-color: #fff;
  --bs-table-bg: #212529;
  --bs-table-border-color: #373b3e;
  --bs-table-striped-bg: #25292d;
  --bs-table-striped-color: #fff;
  --bs-table-active-bg: white;
  --bs-table-active-color: #000;
  --bs-table-hover-bg: white;
  --bs-table-hover-color: #000;
  color: var(--bs-table-color);
  border-color: var(--bs-table-border-color); }

.table-responsive {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch; }

@media (max-width: 575.98px) {
  .table-responsive-sm {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch; } }

@media (max-width: 767.98px) {
  .table-responsive-md {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch; } }

@media (max-width: 991.98px) {
  .table-responsive-lg {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch; } }

@media (max-width: 1199.98px) {
  .table-responsive-xl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch; } }

@media (max-width: 1399.98px) {
  .table-responsive-xxl {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch; } }

.form-label {
  margin-bottom: 0.5rem;
  font-weight: 800; }

.col-form-label {
  padding-top: calc(0.5rem + 1px);
  padding-bottom: calc(0.5rem + 1px);
  margin-bottom: 0;
  font-size: inherit;
  font-weight: 800;
  line-height: 1.5; }

.col-form-label-lg {
  padding-top: calc(0.7rem + 1px);
  padding-bottom: calc(0.7rem + 1px);
  font-size: 1.09375rem; }

.col-form-label-sm {
  padding-top: calc(0.25rem + 1px);
  padding-bottom: calc(0.25rem + 1px);
  font-size: 0.76563rem; }
  @media (min-width: 1200px) {
    .col-form-label-sm {
      font-size: 0.76562rem; } }

.form-text {
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: #878a99; }

.form-control {
  display: block;
  width: 100%;
  padding: 0.5rem 0.9rem;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--vz-body-color);
  background-color: var(--vz-input-bg);
  background-clip: padding-box;
  border: 1px solid var(--vz-input-border);
  appearance: none;
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out; }
  @media (prefers-reduced-motion: reduce) {
    .form-control {
      transition: none; } }
  .form-control[type="file"] {
    overflow: hidden; }
    .form-control[type="file"]:not(:disabled):not([readonly]) {
      cursor: pointer; }
  .form-control:focus {
    color: var(--vz-body-color);
    background-color: var(--vz-input-bg);
    border-color: var(--vz-input-focus-border);
    outline: 0;
    box-shadow: 0 0 0 0 rgba(94, 163, 203, 0.25); }
  .form-control::-webkit-date-and-time-value {
    height: 1.5em; }
  .form-control::placeholder {
    color: #878a99;
    opacity: 1; }
  .form-control:disabled {
    background-color: var(--vz-input-disabled-bg);
    opacity: 1; }
  .form-control::file-selector-button {
    padding: 0.5rem 0.9rem;
    margin: -0.5rem -0.9rem;
    margin-inline-end: 0.9rem;
    color: var(--vz-body-color);
    background-color: var(--vz-input-group-addon-bg);
    pointer-events: none;
    border-color: inherit;
    border-style: solid;
    border-width: 0;
    border-inline-end-width: 1px;
    border-radius: 0;
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out; }
    @media (prefers-reduced-motion: reduce) {
      .form-control::file-selector-button {
        transition: none; } }
  .form-control:hover:not(:disabled):not([readonly])::file-selector-button {
    background-color: var(--vz-input-group-addon-bg); }

.form-control-plaintext {
  display: block;
  width: 100%;
  padding: 0.5rem 0;
  margin-bottom: 0;
  line-height: 1.5;
  color: var(--vz-body-color);
  background-color: transparent;
  border: solid transparent;
  border-width: 1px 0; }
  .form-control-plaintext:focus {
    outline: 0; }
  .form-control-plaintext.form-control-sm, .form-control-plaintext.form-control-lg {
    padding-right: 0;
    padding-left: 0; }

.form-control-sm {
  min-height: calc(1.5em + 0.5rem + 2px);
  padding: 0.25rem 0.5rem;
  font-size: 0.76563rem;
  border-radius: 0.2rem; }
  @media (min-width: 1200px) {
    .form-control-sm {
      font-size: 0.76562rem; } }
  .form-control-sm::file-selector-button {
    padding: 0.25rem 0.5rem;
    margin: -0.25rem -0.5rem;
    margin-inline-end: 0.5rem; }

.form-control-lg {
  min-height: calc(1.5em + 1.4rem + 2px);
  padding: 0.7rem 1.2rem;
  font-size: 1.09375rem;
  border-radius: 0.3rem; }
  .form-control-lg::file-selector-button {
    padding: 0.7rem 1.2rem;
    margin: -0.7rem -1.2rem;
    margin-inline-end: 1.2rem; }

textarea.form-control {
  min-height: calc(1.5em + 1rem + 2px); }

textarea.form-control-sm {
  min-height: calc(1.5em + 0.5rem + 2px); }

textarea.form-control-lg {
  min-height: calc(1.5em + 1.4rem + 2px); }

.form-control-color {
  width: 3rem;
  height: calc(1.5em + 1rem + 2px);
  padding: 0.5rem; }
  .form-control-color:not(:disabled):not([readonly]) {
    cursor: pointer; }
  .form-control-color::-moz-color-swatch {
    border: 0 !important;
    border-radius: 0.25rem; }
  .form-control-color::-webkit-color-swatch {
    border-radius: 0.25rem; }
  .form-control-color.form-control-sm {
    height: calc(1.5em + 0.5rem + 2px); }
  .form-control-color.form-control-lg {
    height: calc(1.5em + 1.4rem + 2px); }

.form-select {
  display: block;
  width: 100%;
  padding: 0.5rem 2.7rem 0.5rem 0.9rem;
  -moz-padding-start: calc(0.9rem - 3px);
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--vz-body-color);
  background-color: var(--vz-input-bg);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_34___});
  background-repeat: no-repeat;
  background-position: right 0.9rem center;
  background-size: 16px 12px;
  border: 1px solid var(--vz-input-border);
  border-radius: 0.25rem;
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
  appearance: none; }
  @media (prefers-reduced-motion: reduce) {
    .form-select {
      transition: none; } }
  .form-select:focus {
    border-color: var(--vz-input-focus-border);
    outline: 0;
    box-shadow: 0 0 0 0 rgba(94, 163, 203, 0.25); }
  .form-select[multiple], .form-select[size]:not([size="1"]) {
    padding-right: 0.9rem;
    background-image: none; }
  .form-select:disabled {
    background-color: var(--vz-input-disabled-bg); }
  .form-select:-moz-focusring {
    color: transparent;
    text-shadow: 0 0 0 var(--vz-body-color); }

.form-select-sm {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
  padding-left: 0.5rem;
  font-size: 0.76563rem;
  border-radius: 0.25rem; }
  @media (min-width: 1200px) {
    .form-select-sm {
      font-size: 0.76562rem; } }

.form-select-lg {
  padding-top: 0.7rem;
  padding-bottom: 0.7rem;
  padding-left: 1.2rem;
  font-size: 1.09375rem;
  border-radius: 0.5rem; }

.form-check {
  display: block;
  min-height: 1.3125rem;
  padding-left: 1.6em;
  margin-bottom: 0.125rem; }
  .form-check .form-check-input {
    float: left;
    margin-left: -1.6em; }

.form-check-reverse {
  padding-right: 1.6em;
  padding-left: 0;
  text-align: right; }
  .form-check-reverse .form-check-input {
    float: right;
    margin-right: -1.6em;
    margin-left: 0; }

.form-check-input {
  width: 1.1em;
  height: 1.1em;
  margin-top: 0.2em;
  vertical-align: top;
  background-color: var(--vz-input-bg);
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  border: 1px solid var(--vz-input-check-border);
  appearance: none;
  -webkit-print-color-adjust: exact;
          print-color-adjust: exact; }
  .form-check-input[type="checkbox"] {
    border-radius: 0.25em; }
  .form-check-input[type="radio"] {
    border-radius: 50%; }
  .form-check-input:active {
    filter: brightness(90%); }
  .form-check-input:focus {
    border-color: var(--vz-input-focus-border);
    outline: 0;
    box-shadow: 0 0 0 0 rgba(94, 163, 203, 0.25); }
  .form-check-input:checked {
    background-color: #5ea3cb;
    border-color: #5ea3cb; }
    .form-check-input:checked[type="checkbox"] {
      background-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___}); }
    .form-check-input:checked[type="radio"] {
      background-image: url(${___CSS_LOADER_URL_REPLACEMENT_36___}); }
  .form-check-input[type="checkbox"]:indeterminate {
    background-color: #5ea3cb;
    border-color: #5ea3cb;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_37___}); }
  .form-check-input:disabled {
    pointer-events: none;
    filter: none;
    opacity: 0.5; }
  .form-check-input[disabled] ~ .form-check-label, .form-check-input:disabled ~ .form-check-label {
    cursor: default;
    opacity: 0.5; }

.form-switch {
  padding-left: 2.5em; }
  .form-switch .form-check-input {
    width: 2em;
    margin-left: -2.5em;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_38___});
    background-position: left center;
    border-radius: 2em;
    transition: background-position 0.15s ease-in-out; }
    @media (prefers-reduced-motion: reduce) {
      .form-switch .form-check-input {
        transition: none; } }
    .form-switch .form-check-input:focus {
      background-image: url(${___CSS_LOADER_URL_REPLACEMENT_39___}); }
    .form-switch .form-check-input:checked {
      background-position: right center;
      background-image: url(${___CSS_LOADER_URL_REPLACEMENT_40___}); }
  .form-switch.form-check-reverse {
    padding-right: 2.5em;
    padding-left: 0; }
    .form-switch.form-check-reverse .form-check-input {
      margin-right: -2.5em;
      margin-left: 0; }

.form-check-inline {
  display: inline-block;
  margin-right: 1rem; }

.btn-check {
  position: absolute;
  clip: rect(0, 0, 0, 0);
  pointer-events: none; }
  .btn-check[disabled] + .btn, .btn-check:disabled + .btn {
    pointer-events: none;
    filter: none;
    opacity: 0.65; }

.form-range {
  width: 100%;
  height: 1rem;
  padding: 0;
  background-color: transparent;
  appearance: none; }
  .form-range:focus {
    outline: 0; }
    .form-range:focus::-webkit-slider-thumb {
      box-shadow: 0 0 0 1px #ffffff, 0 0 0 0 rgba(94, 163, 203, 0.25); }
    .form-range:focus::-moz-range-thumb {
      box-shadow: 0 0 0 1px #ffffff, 0 0 0 0 rgba(94, 163, 203, 0.25); }
  .form-range::-moz-focus-outer {
    border: 0; }
  .form-range::-webkit-slider-thumb {
    width: 1rem;
    height: 1rem;
    margin-top: -0.25rem;
    background-color: #5ea3cb;
    border: 0;
    border-radius: 1rem;
    -webkit-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    appearance: none; }
    @media (prefers-reduced-motion: reduce) {
      .form-range::-webkit-slider-thumb {
        -webkit-transition: none;
        transition: none; } }
    .form-range::-webkit-slider-thumb:active {
      background-color: #cfe3ef; }
  .form-range::-webkit-slider-runnable-track {
    width: 100%;
    height: 0.5rem;
    color: transparent;
    cursor: pointer;
    background-color: var(--vz-gray-300);
    border-color: transparent;
    border-radius: 1rem; }
  .form-range::-moz-range-thumb {
    width: 1rem;
    height: 1rem;
    background-color: #5ea3cb;
    border: 0;
    border-radius: 1rem;
    -moz-transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    appearance: none; }
    @media (prefers-reduced-motion: reduce) {
      .form-range::-moz-range-thumb {
        -moz-transition: none;
        transition: none; } }
    .form-range::-moz-range-thumb:active {
      background-color: #cfe3ef; }
  .form-range::-moz-range-track {
    width: 100%;
    height: 0.5rem;
    color: transparent;
    cursor: pointer;
    background-color: var(--vz-gray-300);
    border-color: transparent;
    border-radius: 1rem; }
  .form-range:disabled {
    pointer-events: none; }
    .form-range:disabled::-webkit-slider-thumb {
      background-color: #adb5bd; }
    .form-range:disabled::-moz-range-thumb {
      background-color: #adb5bd; }

.form-floating {
  position: relative; }
  .form-floating > .form-control,
  .form-floating > .form-control-plaintext,
  .form-floating > .form-select {
    height: calc(3.5rem + 2px);
    line-height: 1.25; }
  .form-floating > label {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    padding: 1rem 0.9rem;
    overflow: hidden;
    text-align: start;
    text-overflow: ellipsis;
    white-space: nowrap;
    pointer-events: none;
    border: 1px solid transparent;
    transform-origin: 0 0;
    transition: opacity 0.1s ease-in-out, transform 0.1s ease-in-out; }
    @media (prefers-reduced-motion: reduce) {
      .form-floating > label {
        transition: none; } }
  .form-floating > .form-control,
  .form-floating > .form-control-plaintext {
    padding: 1rem 0.9rem; }
    .form-floating > .form-control::placeholder,
    .form-floating > .form-control-plaintext::placeholder {
      color: transparent; }
    .form-floating > .form-control:focus, .form-floating > .form-control:not(:placeholder-shown),
    .form-floating > .form-control-plaintext:focus,
    .form-floating > .form-control-plaintext:not(:placeholder-shown) {
      padding-top: 1.625rem;
      padding-bottom: 0.625rem; }
    .form-floating > .form-control:-webkit-autofill,
    .form-floating > .form-control-plaintext:-webkit-autofill {
      padding-top: 1.625rem;
      padding-bottom: 0.625rem; }
  .form-floating > .form-select {
    padding-top: 1.625rem;
    padding-bottom: 0.625rem; }
  .form-floating > .form-control:focus ~ label,
  .form-floating > .form-control:not(:placeholder-shown) ~ label,
  .form-floating > .form-control-plaintext ~ label,
  .form-floating > .form-select ~ label {
    opacity: 0.65;
    transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem); }
  .form-floating > .form-control:-webkit-autofill ~ label {
    opacity: 0.65;
    transform: scale(0.85) translateY(-0.5rem) translateX(0.15rem); }
  .form-floating > .form-control-plaintext ~ label {
    border-width: 1px 0; }

.input-group {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: stretch;
  width: 100%; }
  .input-group > .form-control,
  .input-group > .form-select,
  .input-group > .form-floating {
    position: relative;
    flex: 1 1 auto;
    width: 1%;
    min-width: 0; }
  .input-group > .form-control:focus,
  .input-group > .form-select:focus,
  .input-group > .form-floating:focus-within {
    z-index: 5; }
  .input-group .btn {
    position: relative;
    z-index: 2; }
    .input-group .btn:focus {
      z-index: 5; }

.input-group-text {
  display: flex;
  align-items: center;
  padding: 0.5rem 0.9rem;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--vz-body-color);
  text-align: center;
  white-space: nowrap;
  background-color: var(--vz-input-group-addon-bg);
  border: 1px solid var(--vz-input-border);
  border-radius: 0.25rem; }

.input-group-lg > .form-control,
.input-group-lg > .form-select,
.input-group-lg > .input-group-text,
.input-group-lg > .btn {
  padding: 0.7rem 1.2rem;
  font-size: 1.09375rem;
  border-radius: 0.3rem; }

.input-group-sm > .form-control,
.input-group-sm > .form-select,
.input-group-sm > .input-group-text,
.input-group-sm > .btn {
  padding: 0.25rem 0.5rem;
  font-size: 0.76563rem;
  border-radius: 0.2rem; }
  @media (min-width: 1200px) {
    .input-group-sm > .form-control,
    .input-group-sm > .form-select,
    .input-group-sm > .input-group-text,
    .input-group-sm > .btn {
      font-size: 0.76562rem; } }

.input-group-lg > .form-select,
.input-group-sm > .form-select {
  padding-right: 3.6rem; }

.input-group:not(.has-validation) > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.input-group:not(.has-validation) > .dropdown-toggle:nth-last-child(n + 3),
.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-control,
.input-group:not(.has-validation) > .form-floating:not(:last-child) > .form-select {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0; }

.input-group.has-validation > :nth-last-child(n + 3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),
.input-group.has-validation > .dropdown-toggle:nth-last-child(n + 4),
.input-group.has-validation > .form-floating:nth-last-child(n + 3) > .form-control,
.input-group.has-validation > .form-floating:nth-last-child(n + 3) > .form-select {
  border-top-right-radius: 0;
  border-bottom-right-radius: 0; }

.input-group > :not(:first-child):not(.dropdown-menu):not(.valid-tooltip):not(.valid-feedback):not(.invalid-tooltip):not(.invalid-feedback) {
  margin-left: -1px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0; }

.input-group > .form-floating:not(:first-child) > .form-control,
.input-group > .form-floating:not(:first-child) > .form-select {
  border-top-left-radius: 0;
  border-bottom-left-radius: 0; }

.valid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: #319795; }

.valid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.4rem 0.7rem;
  margin-top: .1rem;
  font-size: 0.76563rem;
  color: #fff;
  background-color: rgba(49, 151, 149, 0.9);
  border-radius: 0.2rem; }
  @media (min-width: 1200px) {
    .valid-tooltip {
      font-size: 0.76562rem; } }

.was-validated :valid ~ .valid-feedback,
.was-validated :valid ~ .valid-tooltip,
.is-valid ~ .valid-feedback,
.is-valid ~ .valid-tooltip {
  display: block; }

.was-validated .form-control:valid, .form-control.is-valid {
  border-color: #319795;
  padding-right: calc(1.5em + 1rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_41___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.25rem) center;
  background-size: calc(0.75em + 0.5rem) calc(0.75em + 0.5rem); }
  .was-validated .form-control:valid:focus, .form-control.is-valid:focus {
    border-color: #319795;
    box-shadow: 0 0 0 0 rgba(49, 151, 149, 0.25); }

.was-validated textarea.form-control:valid, textarea.form-control.is-valid {
  padding-right: calc(1.5em + 1rem);
  background-position: top calc(0.375em + 0.25rem) right calc(0.375em + 0.25rem); }

.was-validated .form-select:valid, .form-select.is-valid {
  border-color: #319795; }
  .was-validated .form-select:valid:not([multiple]):not([size]), .was-validated .form-select:valid:not([multiple])[size="1"], .form-select.is-valid:not([multiple]):not([size]), .form-select.is-valid:not([multiple])[size="1"] {
    padding-right: 4.95rem;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_34___}), url(${___CSS_LOADER_URL_REPLACEMENT_41___});
    background-position: right 0.9rem center, center right 2.7rem;
    background-size: 16px 12px, calc(0.75em + 0.5rem) calc(0.75em + 0.5rem); }
  .was-validated .form-select:valid:focus, .form-select.is-valid:focus {
    border-color: #319795;
    box-shadow: 0 0 0 0 rgba(49, 151, 149, 0.25); }

.was-validated .form-control-color:valid, .form-control-color.is-valid {
  width: calc(3rem + calc(1.5em + 1rem)); }

.was-validated .form-check-input:valid, .form-check-input.is-valid {
  border-color: #319795; }
  .was-validated .form-check-input:valid:checked, .form-check-input.is-valid:checked {
    background-color: #319795; }
  .was-validated .form-check-input:valid:focus, .form-check-input.is-valid:focus {
    box-shadow: 0 0 0 0 rgba(49, 151, 149, 0.25); }
  .was-validated .form-check-input:valid ~ .form-check-label, .form-check-input.is-valid ~ .form-check-label {
    color: #319795; }

.form-check-inline .form-check-input ~ .valid-feedback {
  margin-left: .5em; }

.was-validated .input-group > .form-control:not(:focus):valid, .input-group > .form-control:not(:focus).is-valid, .was-validated
.input-group > .form-select:not(:focus):valid,
.input-group > .form-select:not(:focus).is-valid, .was-validated
.input-group > .form-floating:not(:focus-within):valid,
.input-group > .form-floating:not(:focus-within).is-valid {
  z-index: 3; }

.invalid-feedback {
  display: none;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: #E53E3E; }

.invalid-tooltip {
  position: absolute;
  top: 100%;
  z-index: 5;
  display: none;
  max-width: 100%;
  padding: 0.4rem 0.7rem;
  margin-top: .1rem;
  font-size: 0.76563rem;
  color: #fff;
  background-color: rgba(229, 62, 62, 0.9);
  border-radius: 0.2rem; }
  @media (min-width: 1200px) {
    .invalid-tooltip {
      font-size: 0.76562rem; } }

.was-validated :invalid ~ .invalid-feedback,
.was-validated :invalid ~ .invalid-tooltip,
.is-invalid ~ .invalid-feedback,
.is-invalid ~ .invalid-tooltip {
  display: block; }

.was-validated .form-control:invalid, .form-control.is-invalid {
  border-color: #E53E3E;
  padding-right: calc(1.5em + 1rem);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_42___});
  background-repeat: no-repeat;
  background-position: right calc(0.375em + 0.25rem) center;
  background-size: calc(0.75em + 0.5rem) calc(0.75em + 0.5rem); }
  .was-validated .form-control:invalid:focus, .form-control.is-invalid:focus {
    border-color: #E53E3E;
    box-shadow: 0 0 0 0 rgba(229, 62, 62, 0.25); }

.was-validated textarea.form-control:invalid, textarea.form-control.is-invalid {
  padding-right: calc(1.5em + 1rem);
  background-position: top calc(0.375em + 0.25rem) right calc(0.375em + 0.25rem); }

.was-validated .form-select:invalid, .form-select.is-invalid {
  border-color: #E53E3E; }
  .was-validated .form-select:invalid:not([multiple]):not([size]), .was-validated .form-select:invalid:not([multiple])[size="1"], .form-select.is-invalid:not([multiple]):not([size]), .form-select.is-invalid:not([multiple])[size="1"] {
    padding-right: 4.95rem;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_34___}), url(${___CSS_LOADER_URL_REPLACEMENT_42___});
    background-position: right 0.9rem center, center right 2.7rem;
    background-size: 16px 12px, calc(0.75em + 0.5rem) calc(0.75em + 0.5rem); }
  .was-validated .form-select:invalid:focus, .form-select.is-invalid:focus {
    border-color: #E53E3E;
    box-shadow: 0 0 0 0 rgba(229, 62, 62, 0.25); }

.was-validated .form-control-color:invalid, .form-control-color.is-invalid {
  width: calc(3rem + calc(1.5em + 1rem)); }

.was-validated .form-check-input:invalid, .form-check-input.is-invalid {
  border-color: #E53E3E; }
  .was-validated .form-check-input:invalid:checked, .form-check-input.is-invalid:checked {
    background-color: #E53E3E; }
  .was-validated .form-check-input:invalid:focus, .form-check-input.is-invalid:focus {
    box-shadow: 0 0 0 0 rgba(229, 62, 62, 0.25); }
  .was-validated .form-check-input:invalid ~ .form-check-label, .form-check-input.is-invalid ~ .form-check-label {
    color: #E53E3E; }

.form-check-inline .form-check-input ~ .invalid-feedback {
  margin-left: .5em; }

.was-validated .input-group > .form-control:not(:focus):invalid, .input-group > .form-control:not(:focus).is-invalid, .was-validated
.input-group > .form-select:not(:focus):invalid,
.input-group > .form-select:not(:focus).is-invalid, .was-validated
.input-group > .form-floating:not(:focus-within):invalid,
.input-group > .form-floating:not(:focus-within).is-invalid {
  z-index: 4; }

.btn {
  --bs-btn-padding-x: 0.9rem;
  --bs-btn-padding-y: 0.5rem;
  --bs-btn-font-family: ;
  --bs-btn-font-size: 0.875rem;
  --bs-btn-font-weight: 500;
  --bs-btn-line-height: 1.5;
  --bs-btn-color: #212529;
  --bs-btn-bg: transparent;
  --bs-btn-border-width: 1px;
  --bs-btn-border-color: transparent;
  --bs-btn-border-radius: 0.25rem;
  --bs-btn-hover-border-color: transparent;
  --bs-btn-box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.15), 0 1px 1px rgba(0, 0, 0, 0.075);
  --bs-btn-disabled-opacity: 0.65;
  --bs-btn-focus-box-shadow: 0 0 0 0 rgba(var(--bs-btn-focus-shadow-rgb), .5);
  display: inline-block;
  padding: var(--bs-btn-padding-y) var(--bs-btn-padding-x);
  font-family: var(--bs-btn-font-family);
  font-size: var(--bs-btn-font-size);
  font-weight: var(--bs-btn-font-weight);
  line-height: var(--bs-btn-line-height);
  color: var(--bs-btn-color);
  text-align: center;
  text-decoration: none;
  vertical-align: middle;
  cursor: pointer;
  -webkit-user-select: none;
          user-select: none;
  border: var(--bs-btn-border-width) solid var(--bs-btn-border-color);
  border-radius: var(--bs-btn-border-radius);
  background-color: var(--bs-btn-bg);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out; }
  @media (prefers-reduced-motion: reduce) {
    .btn {
      transition: none; } }
  .btn:hover {
    color: var(--bs-btn-hover-color);
    background-color: var(--bs-btn-hover-bg);
    border-color: var(--bs-btn-hover-border-color); }
  .btn-check + .btn:hover {
    color: var(--bs-btn-color);
    background-color: var(--bs-btn-bg);
    border-color: var(--bs-btn-border-color); }
  .btn:focus-visible {
    color: var(--bs-btn-hover-color);
    background-color: var(--bs-btn-hover-bg);
    border-color: var(--bs-btn-hover-border-color);
    outline: 0;
    box-shadow: var(--bs-btn-focus-box-shadow); }
  .btn-check:focus-visible + .btn {
    border-color: var(--bs-btn-hover-border-color);
    outline: 0;
    box-shadow: var(--bs-btn-focus-box-shadow); }
  .btn-check:checked + .btn,
  :not(.btn-check) + .btn:active, .btn:first-child:active, .btn.active, .btn.show {
    color: var(--bs-btn-active-color);
    background-color: var(--bs-btn-active-bg);
    border-color: var(--bs-btn-active-border-color); }
    .btn-check:checked + .btn:focus-visible,
    :not(.btn-check) + .btn:active:focus-visible, .btn:first-child:active:focus-visible, .btn.active:focus-visible, .btn.show:focus-visible {
      box-shadow: var(--bs-btn-focus-box-shadow); }
  .btn:disabled, .btn.disabled,
  fieldset:disabled .btn {
    color: var(--bs-btn-disabled-color);
    pointer-events: none;
    background-color: var(--bs-btn-disabled-bg);
    border-color: var(--bs-btn-disabled-border-color);
    opacity: var(--bs-btn-disabled-opacity); }

.btn-primary {
  --bs-btn-color: #fff;
  --bs-btn-bg: #5ea3cb;
  --bs-btn-border-color: #5ea3cb;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #508bad;
  --bs-btn-hover-border-color: #4b82a2;
  --bs-btn-focus-shadow-rgb: 118, 177, 211;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #4b82a2;
  --bs-btn-active-border-color: #477a98;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #5ea3cb;
  --bs-btn-disabled-border-color: #5ea3cb; }

.btn-secondary {
  --bs-btn-color: #fff;
  --bs-btn-bg: #7084c7;
  --bs-btn-border-color: #7084c7;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #5f70a9;
  --bs-btn-hover-border-color: #5a6a9f;
  --bs-btn-focus-shadow-rgb: 133, 150, 207;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #5a6a9f;
  --bs-btn-active-border-color: #546395;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #7084c7;
  --bs-btn-disabled-border-color: #7084c7; }

.btn-success {
  --bs-btn-color: #fff;
  --bs-btn-bg: #319795;
  --bs-btn-border-color: #319795;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #2a807f;
  --bs-btn-hover-border-color: #277977;
  --bs-btn-focus-shadow-rgb: 80, 167, 165;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #277977;
  --bs-btn-active-border-color: #257170;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #319795;
  --bs-btn-disabled-border-color: #319795; }

.btn-info {
  --bs-btn-color: #fff;
  --bs-btn-bg: #58caea;
  --bs-btn-border-color: #58caea;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #4bacc7;
  --bs-btn-hover-border-color: #46a2bb;
  --bs-btn-focus-shadow-rgb: 113, 210, 237;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #46a2bb;
  --bs-btn-active-border-color: #4298b0;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #58caea;
  --bs-btn-disabled-border-color: #58caea; }

.btn-warning {
  --bs-btn-color: #fff;
  --bs-btn-bg: #f7b84b;
  --bs-btn-border-color: #f7b84b;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #d29c40;
  --bs-btn-hover-border-color: #c6933c;
  --bs-btn-focus-shadow-rgb: 248, 195, 102;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #c6933c;
  --bs-btn-active-border-color: #b98a38;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #f7b84b;
  --bs-btn-disabled-border-color: #f7b84b; }

.btn-danger {
  --bs-btn-color: #fff;
  --bs-btn-bg: #E53E3E;
  --bs-btn-border-color: #E53E3E;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #c33535;
  --bs-btn-hover-border-color: #b73232;
  --bs-btn-focus-shadow-rgb: 233, 91, 91;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #b73232;
  --bs-btn-active-border-color: #ac2f2f;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #E53E3E;
  --bs-btn-disabled-border-color: #E53E3E; }

.btn-light {
  --bs-btn-color: #000;
  --bs-btn-bg: #f3f6f9;
  --bs-btn-border-color: #f3f6f9;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #cfd1d4;
  --bs-btn-hover-border-color: #c2c5c7;
  --bs-btn-focus-shadow-rgb: 207, 209, 212;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #c2c5c7;
  --bs-btn-active-border-color: #b6b9bb;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #000;
  --bs-btn-disabled-bg: #f3f6f9;
  --bs-btn-disabled-border-color: #f3f6f9; }

.btn-dark {
  --bs-btn-color: #fff;
  --bs-btn-bg: #212529;
  --bs-btn-border-color: #212529;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #424649;
  --bs-btn-hover-border-color: #373b3e;
  --bs-btn-focus-shadow-rgb: 66, 70, 73;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #4d5154;
  --bs-btn-active-border-color: #373b3e;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #fff;
  --bs-btn-disabled-bg: #212529;
  --bs-btn-disabled-border-color: #212529; }

.btn-outline-primary {
  --bs-btn-color: #5ea3cb;
  --bs-btn-border-color: #5ea3cb;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #5ea3cb;
  --bs-btn-hover-border-color: #5ea3cb;
  --bs-btn-focus-shadow-rgb: 94, 163, 203;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #5ea3cb;
  --bs-btn-active-border-color: #5ea3cb;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #5ea3cb;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #5ea3cb;
  --bs-gradient: none; }

.btn-outline-secondary {
  --bs-btn-color: #7084c7;
  --bs-btn-border-color: #7084c7;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #7084c7;
  --bs-btn-hover-border-color: #7084c7;
  --bs-btn-focus-shadow-rgb: 112, 132, 199;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #7084c7;
  --bs-btn-active-border-color: #7084c7;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #7084c7;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #7084c7;
  --bs-gradient: none; }

.btn-outline-success {
  --bs-btn-color: #319795;
  --bs-btn-border-color: #319795;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #319795;
  --bs-btn-hover-border-color: #319795;
  --bs-btn-focus-shadow-rgb: 49, 151, 149;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #319795;
  --bs-btn-active-border-color: #319795;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #319795;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #319795;
  --bs-gradient: none; }

.btn-outline-info {
  --bs-btn-color: #58caea;
  --bs-btn-border-color: #58caea;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #58caea;
  --bs-btn-hover-border-color: #58caea;
  --bs-btn-focus-shadow-rgb: 88, 202, 234;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #58caea;
  --bs-btn-active-border-color: #58caea;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #58caea;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #58caea;
  --bs-gradient: none; }

.btn-outline-warning {
  --bs-btn-color: #f7b84b;
  --bs-btn-border-color: #f7b84b;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #f7b84b;
  --bs-btn-hover-border-color: #f7b84b;
  --bs-btn-focus-shadow-rgb: 247, 184, 75;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #f7b84b;
  --bs-btn-active-border-color: #f7b84b;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #f7b84b;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #f7b84b;
  --bs-gradient: none; }

.btn-outline-danger {
  --bs-btn-color: #E53E3E;
  --bs-btn-border-color: #E53E3E;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #E53E3E;
  --bs-btn-hover-border-color: #E53E3E;
  --bs-btn-focus-shadow-rgb: 229, 62, 62;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #E53E3E;
  --bs-btn-active-border-color: #E53E3E;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #E53E3E;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #E53E3E;
  --bs-gradient: none; }

.btn-outline-light {
  --bs-btn-color: #f3f6f9;
  --bs-btn-border-color: #f3f6f9;
  --bs-btn-hover-color: #000;
  --bs-btn-hover-bg: #f3f6f9;
  --bs-btn-hover-border-color: #f3f6f9;
  --bs-btn-focus-shadow-rgb: 243, 246, 249;
  --bs-btn-active-color: #000;
  --bs-btn-active-bg: #f3f6f9;
  --bs-btn-active-border-color: #f3f6f9;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #f3f6f9;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #f3f6f9;
  --bs-gradient: none; }

.btn-outline-dark {
  --bs-btn-color: #212529;
  --bs-btn-border-color: #212529;
  --bs-btn-hover-color: #fff;
  --bs-btn-hover-bg: #212529;
  --bs-btn-hover-border-color: #212529;
  --bs-btn-focus-shadow-rgb: 33, 37, 41;
  --bs-btn-active-color: #fff;
  --bs-btn-active-bg: #212529;
  --bs-btn-active-border-color: #212529;
  --bs-btn-active-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  --bs-btn-disabled-color: #212529;
  --bs-btn-disabled-bg: transparent;
  --bs-btn-disabled-border-color: #212529;
  --bs-gradient: none; }

.btn-link {
  --bs-btn-font-weight: 400;
  --bs-btn-color: var(--vz-link-color);
  --bs-btn-bg: transparent;
  --bs-btn-border-color: transparent;
  --bs-btn-hover-color: var(--vz-link-hover-color);
  --bs-btn-hover-border-color: transparent;
  --bs-btn-active-color: var(--vz-link-hover-color);
  --bs-btn-active-border-color: transparent;
  --bs-btn-disabled-color: #878a99;
  --bs-btn-disabled-border-color: transparent;
  --bs-btn-box-shadow: none;
  --bs-btn-focus-shadow-rgb: 118, 177, 211;
  text-decoration: underline; }
  .btn-link:focus-visible {
    color: var(--bs-btn-color); }
  .btn-link:hover {
    color: var(--bs-btn-hover-color); }

.btn-lg, .btn-group-lg > .btn {
  --bs-btn-padding-y: 0.7rem;
  --bs-btn-padding-x: 1.2rem;
  --bs-btn-font-size: 1.09375rem;
  --bs-btn-border-radius: 0.3rem; }

.btn-sm, .btn-group-sm > .btn {
  --bs-btn-padding-y: 0.25rem;
  --bs-btn-padding-x: 0.5rem;
  --bs-btn-font-size: 0.76563rem;
  --bs-btn-border-radius: 0.2rem; }
  @media (min-width: 1200px) {
    .btn-sm, .btn-group-sm > .btn {
      --bs-btn-font-size: 0.76562rem; } }

.fade {
  transition: opacity 0.15s linear; }
  @media (prefers-reduced-motion: reduce) {
    .fade {
      transition: none; } }
  .fade:not(.show) {
    opacity: 0; }

.collapse:not(.show) {
  display: none; }

.collapsing {
  height: 0;
  overflow: hidden;
  transition: height 0.35s ease; }
  @media (prefers-reduced-motion: reduce) {
    .collapsing {
      transition: none; } }
  .collapsing.collapse-horizontal {
    width: 0;
    height: auto;
    transition: width 0.35s ease; }
    @media (prefers-reduced-motion: reduce) {
      .collapsing.collapse-horizontal {
        transition: none; } }

.dropup,
.dropend,
.dropdown,
.dropstart,
.dropup-center,
.dropdown-center {
  position: relative; }

.dropdown-toggle {
  white-space: nowrap; }

.dropdown-menu {
  --bs-dropdown-zindex: 1000;
  --bs-dropdown-min-width: 10rem;
  --bs-dropdown-padding-x: 0;
  --bs-dropdown-padding-y: 0.5rem;
  --bs-dropdown-spacer: 0.125rem;
  --bs-dropdown-font-size: 0.875rem;
  --bs-dropdown-color: var(--vz-body-color);
  --bs-dropdown-bg: var(--vz-dropdown-bg);
  --bs-dropdown-border-color: var(--vz-border-color);
  --bs-dropdown-border-radius: 0.3rem;
  --bs-dropdown-border-width: var(--vz-dropdown-border-width);
  --bs-dropdown-inner-border-radius: calc(0.3rem - (var(--vz-dropdown-border-width)));
  --bs-dropdown-divider-bg: var(--vz-border-color);
  --bs-dropdown-divider-margin-y: 0.5rem;
  --bs-dropdown-box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);
  --bs-dropdown-link-color: var(--vz-dropdown-link-color);
  --bs-dropdown-link-hover-color: var(--vz-dropdown-link-hover-color);
  --bs-dropdown-link-hover-bg: var(--vz-dropdown-link-hover-bg);
  --bs-dropdown-link-active-color: var(--vz-dropdown-link-hover-color);
  --bs-dropdown-link-active-bg: var(--vz-dropdown-link-hover-bg);
  --bs-dropdown-link-disabled-color: #adb5bd;
  --bs-dropdown-item-padding-x: 1.2rem;
  --bs-dropdown-item-padding-y: 0.35rem;
  --bs-dropdown-header-color: #878a99;
  --bs-dropdown-header-padding-x: 1rem;
  --bs-dropdown-header-padding-y: 0.5rem;
  position: absolute;
  z-index: var(--bs-dropdown-zindex);
  display: none;
  min-width: var(--bs-dropdown-min-width);
  padding: var(--bs-dropdown-padding-y) var(--bs-dropdown-padding-x);
  margin: 0;
  font-size: var(--bs-dropdown-font-size);
  color: var(--bs-dropdown-color);
  text-align: left;
  list-style: none;
  background-color: var(--bs-dropdown-bg);
  background-clip: padding-box;
  border: var(--bs-dropdown-border-width) solid var(--bs-dropdown-border-color);
  border-radius: var(--bs-dropdown-border-radius); }
  .dropdown-menu[data-bs-popper] {
    top: 100%;
    left: 0;
    margin-top: var(--bs-dropdown-spacer); }

.dropdown-menu-start {
  --bs-position: start; }
  .dropdown-menu-start[data-bs-popper] {
    right: auto;
    left: 0; }

.dropdown-menu-end {
  --bs-position: end; }
  .dropdown-menu-end[data-bs-popper] {
    right: 0;
    left: auto; }

@media (min-width: 576px) {
  .dropdown-menu-sm-start {
    --bs-position: start; }
    .dropdown-menu-sm-start[data-bs-popper] {
      right: auto;
      left: 0; }
  .dropdown-menu-sm-end {
    --bs-position: end; }
    .dropdown-menu-sm-end[data-bs-popper] {
      right: 0;
      left: auto; } }

@media (min-width: 768px) {
  .dropdown-menu-md-start {
    --bs-position: start; }
    .dropdown-menu-md-start[data-bs-popper] {
      right: auto;
      left: 0; }
  .dropdown-menu-md-end {
    --bs-position: end; }
    .dropdown-menu-md-end[data-bs-popper] {
      right: 0;
      left: auto; } }

@media (min-width: 992px) {
  .dropdown-menu-lg-start {
    --bs-position: start; }
    .dropdown-menu-lg-start[data-bs-popper] {
      right: auto;
      left: 0; }
  .dropdown-menu-lg-end {
    --bs-position: end; }
    .dropdown-menu-lg-end[data-bs-popper] {
      right: 0;
      left: auto; } }

@media (min-width: 1200px) {
  .dropdown-menu-xl-start {
    --bs-position: start; }
    .dropdown-menu-xl-start[data-bs-popper] {
      right: auto;
      left: 0; }
  .dropdown-menu-xl-end {
    --bs-position: end; }
    .dropdown-menu-xl-end[data-bs-popper] {
      right: 0;
      left: auto; } }

@media (min-width: 1400px) {
  .dropdown-menu-xxl-start {
    --bs-position: start; }
    .dropdown-menu-xxl-start[data-bs-popper] {
      right: auto;
      left: 0; }
  .dropdown-menu-xxl-end {
    --bs-position: end; }
    .dropdown-menu-xxl-end[data-bs-popper] {
      right: 0;
      left: auto; } }

.dropup .dropdown-menu[data-bs-popper] {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: var(--bs-dropdown-spacer); }

.dropend .dropdown-menu[data-bs-popper] {
  top: 0;
  right: auto;
  left: 100%;
  margin-top: 0;
  margin-left: var(--bs-dropdown-spacer); }

.dropend .dropdown-toggle::after {
  vertical-align: 0; }

.dropstart .dropdown-menu[data-bs-popper] {
  top: 0;
  right: 100%;
  left: auto;
  margin-top: 0;
  margin-right: var(--bs-dropdown-spacer); }

.dropstart .dropdown-toggle::before {
  vertical-align: 0; }

.dropdown-divider {
  height: 0;
  margin: var(--bs-dropdown-divider-margin-y) 0;
  overflow: hidden;
  border-top: 1px solid var(--bs-dropdown-divider-bg);
  opacity: 1; }

.dropdown-item {
  display: block;
  width: 100%;
  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);
  clear: both;
  font-weight: 400;
  color: var(--bs-dropdown-link-color);
  text-align: inherit;
  text-decoration: none;
  white-space: nowrap;
  background-color: transparent;
  border: 0; }
  .dropdown-item:hover, .dropdown-item:focus {
    color: var(--bs-dropdown-link-hover-color);
    background-color: var(--bs-dropdown-link-hover-bg); }
  .dropdown-item.active, .dropdown-item:active {
    color: var(--bs-dropdown-link-active-color);
    text-decoration: none;
    background-color: var(--bs-dropdown-link-active-bg); }
  .dropdown-item.disabled, .dropdown-item:disabled {
    color: var(--bs-dropdown-link-disabled-color);
    pointer-events: none;
    background-color: transparent; }

.dropdown-menu.show {
  display: block; }

.dropdown-header {
  display: block;
  padding: var(--bs-dropdown-header-padding-y) var(--bs-dropdown-header-padding-x);
  margin-bottom: 0;
  font-size: 0.76563rem;
  color: var(--bs-dropdown-header-color);
  white-space: nowrap; }
  @media (min-width: 1200px) {
    .dropdown-header {
      font-size: 0.76562rem; } }

.dropdown-item-text {
  display: block;
  padding: var(--bs-dropdown-item-padding-y) var(--bs-dropdown-item-padding-x);
  color: var(--bs-dropdown-link-color); }

.dropdown-menu-dark {
  --bs-dropdown-color: #e9ebec;
  --bs-dropdown-bg: #343a40;
  --bs-dropdown-border-color: var(--vz-border-color);
  --bs-dropdown-box-shadow: ;
  --bs-dropdown-link-color: #e9ebec;
  --bs-dropdown-link-hover-color: #fff;
  --bs-dropdown-divider-bg: var(--vz-border-color);
  --bs-dropdown-link-hover-bg: rgba(255, 255, 255, 0.15);
  --bs-dropdown-link-active-color: #fff;
  --bs-dropdown-link-active-bg: #3f474e;
  --bs-dropdown-link-disabled-color: #adb5bd;
  --bs-dropdown-header-color: #adb5bd; }

.btn-group,
.btn-group-vertical {
  position: relative;
  display: inline-flex;
  vertical-align: middle; }
  .btn-group > .btn,
  .btn-group-vertical > .btn {
    position: relative;
    flex: 1 1 auto; }
  .btn-group > .btn-check:checked + .btn,
  .btn-group > .btn-check:focus + .btn,
  .btn-group > .btn:hover,
  .btn-group > .btn:focus,
  .btn-group > .btn:active,
  .btn-group > .btn.active,
  .btn-group-vertical > .btn-check:checked + .btn,
  .btn-group-vertical > .btn-check:focus + .btn,
  .btn-group-vertical > .btn:hover,
  .btn-group-vertical > .btn:focus,
  .btn-group-vertical > .btn:active,
  .btn-group-vertical > .btn.active {
    z-index: 1; }

.btn-toolbar {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start; }
  .btn-toolbar .input-group {
    width: auto; }

.btn-group {
  border-radius: 0.25rem; }
  .btn-group > :not(.btn-check:first-child) + .btn,
  .btn-group > .btn-group:not(:first-child) {
    margin-left: -1px; }
  .btn-group > .btn:not(:last-child):not(.dropdown-toggle),
  .btn-group > .btn.dropdown-toggle-split:first-child,
  .btn-group > .btn-group:not(:last-child) > .btn {
    border-top-right-radius: 0;
    border-bottom-right-radius: 0; }
  .btn-group > .btn:nth-child(n + 3),
  .btn-group > :not(.btn-check) + .btn,
  .btn-group > .btn-group:not(:first-child) > .btn {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0; }

.dropdown-toggle-split {
  padding-right: 0.675rem;
  padding-left: 0.675rem; }
  .dropdown-toggle-split::after,
  .dropup .dropdown-toggle-split::after,
  .dropend .dropdown-toggle-split::after {
    margin-left: 0; }
  .dropstart .dropdown-toggle-split::before {
    margin-right: 0; }

.btn-sm + .dropdown-toggle-split, .btn-group-sm > .btn + .dropdown-toggle-split {
  padding-right: 0.375rem;
  padding-left: 0.375rem; }

.btn-lg + .dropdown-toggle-split, .btn-group-lg > .btn + .dropdown-toggle-split {
  padding-right: 0.9rem;
  padding-left: 0.9rem; }

.btn-group-vertical {
  flex-direction: column;
  align-items: flex-start;
  justify-content: center; }
  .btn-group-vertical > .btn,
  .btn-group-vertical > .btn-group {
    width: 100%; }
  .btn-group-vertical > .btn:not(:first-child),
  .btn-group-vertical > .btn-group:not(:first-child) {
    margin-top: -1px; }
  .btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle),
  .btn-group-vertical > .btn-group:not(:last-child) > .btn {
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0; }
  .btn-group-vertical > .btn ~ .btn,
  .btn-group-vertical > .btn-group:not(:first-child) > .btn {
    border-top-left-radius: 0;
    border-top-right-radius: 0; }

.nav {
  --bs-nav-link-padding-x: 1rem;
  --bs-nav-link-padding-y: 0.5rem;
  --bs-nav-link-font-weight: ;
  --bs-nav-link-color: var(--vz-link-color);
  --bs-nav-link-hover-color: var(--vz-link-hover-color);
  --bs-nav-link-disabled-color: #878a99;
  display: flex;
  flex-wrap: wrap;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none; }

.nav-link {
  display: block;
  padding: var(--bs-nav-link-padding-y) var(--bs-nav-link-padding-x);
  font-size: var(--bs-nav-link-font-size);
  font-weight: var(--bs-nav-link-font-weight);
  color: var(--bs-nav-link-color);
  text-decoration: none;
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out; }
  @media (prefers-reduced-motion: reduce) {
    .nav-link {
      transition: none; } }
  .nav-link:hover, .nav-link:focus {
    color: var(--bs-nav-link-hover-color); }
  .nav-link.disabled {
    color: var(--bs-nav-link-disabled-color);
    pointer-events: none;
    cursor: default; }

.nav-tabs {
  --bs-nav-tabs-border-width: 1px;
  --bs-nav-tabs-border-color: var(--vz-gray-300);
  --bs-nav-tabs-border-radius: 0.25rem;
  --bs-nav-tabs-link-hover-border-color: var(--vz-gray-300) var(--vz-gray-300) var(--vz-gray-300);
  --bs-nav-tabs-link-active-color: var(--vz-nav-tabs-link-active-color);
  --bs-nav-tabs-link-active-bg: var(--vz-nav-tabs-link-active-bg);
  --bs-nav-tabs-link-active-border-color: var(--vz-gray-300) var(--vz-gray-300) var(--vz-nav-tabs-link-active-bg);
  border-bottom: var(--bs-nav-tabs-border-width) solid var(--bs-nav-tabs-border-color); }
  .nav-tabs .nav-link {
    margin-bottom: calc(-1 * var(--bs-nav-tabs-border-width));
    background: none;
    border: var(--bs-nav-tabs-border-width) solid transparent;
    border-top-left-radius: var(--bs-nav-tabs-border-radius);
    border-top-right-radius: var(--bs-nav-tabs-border-radius); }
    .nav-tabs .nav-link:hover, .nav-tabs .nav-link:focus {
      isolation: isolate;
      border-color: var(--bs-nav-tabs-link-hover-border-color); }
    .nav-tabs .nav-link.disabled, .nav-tabs .nav-link:disabled {
      color: var(--bs-nav-link-disabled-color);
      background-color: transparent;
      border-color: transparent; }
  .nav-tabs .nav-link.active,
  .nav-tabs .nav-item.show .nav-link {
    color: var(--bs-nav-tabs-link-active-color);
    background-color: var(--bs-nav-tabs-link-active-bg);
    border-color: var(--bs-nav-tabs-link-active-border-color); }
  .nav-tabs .dropdown-menu {
    margin-top: calc(-1 * var(--bs-nav-tabs-border-width));
    border-top-left-radius: 0;
    border-top-right-radius: 0; }

.nav-pills {
  --bs-nav-pills-border-radius: 0.25rem;
  --bs-nav-pills-link-active-color: #fff;
  --bs-nav-pills-link-active-bg: #5ea3cb; }
  .nav-pills .nav-link {
    background: none;
    border: 0;
    border-radius: var(--bs-nav-pills-border-radius); }
    .nav-pills .nav-link:disabled {
      color: var(--bs-nav-link-disabled-color);
      background-color: transparent;
      border-color: transparent; }
  .nav-pills .nav-link.active,
  .nav-pills .show > .nav-link {
    color: var(--bs-nav-pills-link-active-color);
    background-color: var(--bs-nav-pills-link-active-bg); }

.nav-fill > .nav-link,
.nav-fill .nav-item {
  flex: 1 1 auto;
  text-align: center; }

.nav-justified > .nav-link,
.nav-justified .nav-item {
  flex-basis: 0;
  flex-grow: 1;
  text-align: center; }

.nav-fill .nav-item .nav-link,
.nav-justified .nav-item .nav-link {
  width: 100%; }

.tab-content > .tab-pane {
  display: none; }

.tab-content > .active {
  display: block; }

.navbar {
  --bs-navbar-padding-x: 0;
  --bs-navbar-padding-y: 0.5rem;
  --bs-navbar-color: rgba(0, 0, 0, 0.55);
  --bs-navbar-hover-color: rgba(0, 0, 0, 0.7);
  --bs-navbar-disabled-color: rgba(0, 0, 0, 0.3);
  --bs-navbar-active-color: rgba(0, 0, 0, 0.9);
  --bs-navbar-brand-padding-y: 0.33594rem;
  --bs-navbar-brand-margin-end: 1rem;
  --bs-navbar-brand-font-size: 1.09375rem;
  --bs-navbar-brand-color: rgba(0, 0, 0, 0.9);
  --bs-navbar-brand-hover-color: rgba(0, 0, 0, 0.9);
  --bs-navbar-nav-link-padding-x: 0.5rem;
  --bs-navbar-toggler-padding-y: 0.25rem;
  --bs-navbar-toggler-padding-x: 0.75rem;
  --bs-navbar-toggler-font-size: 1.09375rem;
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_43___});
  --bs-navbar-toggler-border-color: rgba(0, 0, 0, 0.1);
  --bs-navbar-toggler-border-radius: 0.25rem;
  --bs-navbar-toggler-focus-width: 0;
  --bs-navbar-toggler-transition: box-shadow 0.15s ease-in-out;
  position: relative;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: var(--bs-navbar-padding-y) var(--bs-navbar-padding-x); }
  .navbar > .container,
  .navbar > .container-fluid, .navbar > .container-sm, .navbar > .container-md, .navbar > .container-lg, .navbar > .container-xl, .navbar > .container-xxl {
    display: flex;
    flex-wrap: inherit;
    align-items: center;
    justify-content: space-between; }

.navbar-brand {
  padding-top: var(--bs-navbar-brand-padding-y);
  padding-bottom: var(--bs-navbar-brand-padding-y);
  margin-right: var(--bs-navbar-brand-margin-end);
  font-size: var(--bs-navbar-brand-font-size);
  color: var(--bs-navbar-brand-color);
  text-decoration: none;
  white-space: nowrap; }
  .navbar-brand:hover, .navbar-brand:focus {
    color: var(--bs-navbar-brand-hover-color); }

.navbar-nav {
  --bs-nav-link-padding-x: 0;
  --bs-nav-link-padding-y: 0.5rem;
  --bs-nav-link-font-weight: ;
  --bs-nav-link-color: var(--bs-navbar-color);
  --bs-nav-link-hover-color: var(--bs-navbar-hover-color);
  --bs-nav-link-disabled-color: var(--bs-navbar-disabled-color);
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  list-style: none; }
  .navbar-nav .show > .nav-link,
  .navbar-nav .nav-link.active {
    color: var(--bs-navbar-active-color); }
  .navbar-nav .dropdown-menu {
    position: static; }

.navbar-text {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  color: var(--bs-navbar-color); }
  .navbar-text a,
  .navbar-text a:hover,
  .navbar-text a:focus {
    color: var(--bs-navbar-active-color); }

.navbar-collapse {
  flex-basis: 100%;
  flex-grow: 1;
  align-items: center; }

.navbar-toggler {
  padding: var(--bs-navbar-toggler-padding-y) var(--bs-navbar-toggler-padding-x);
  font-size: var(--bs-navbar-toggler-font-size);
  line-height: 1;
  color: var(--bs-navbar-color);
  background-color: transparent;
  border: var(--bs-border-width) solid var(--bs-navbar-toggler-border-color);
  border-radius: var(--bs-navbar-toggler-border-radius);
  transition: var(--bs-navbar-toggler-transition); }
  @media (prefers-reduced-motion: reduce) {
    .navbar-toggler {
      transition: none; } }
  .navbar-toggler:hover {
    text-decoration: none; }
  .navbar-toggler:focus {
    text-decoration: none;
    outline: 0;
    box-shadow: 0 0 0 var(--bs-navbar-toggler-focus-width); }

.navbar-toggler-icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  vertical-align: middle;
  background-image: var(--bs-navbar-toggler-icon-bg);
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%; }

.navbar-nav-scroll {
  max-height: var(--bs-scroll-height, 75vh);
  overflow-y: auto; }

@media (min-width: 576px) {
  .navbar-expand-sm {
    flex-wrap: nowrap;
    justify-content: flex-start; }
    .navbar-expand-sm .navbar-nav {
      flex-direction: row; }
      .navbar-expand-sm .navbar-nav .dropdown-menu {
        position: absolute; }
      .navbar-expand-sm .navbar-nav .nav-link {
        padding-right: var(--bs-navbar-nav-link-padding-x);
        padding-left: var(--bs-navbar-nav-link-padding-x); }
    .navbar-expand-sm .navbar-nav-scroll {
      overflow: visible; }
    .navbar-expand-sm .navbar-collapse {
      display: flex !important;
      flex-basis: auto; }
    .navbar-expand-sm .navbar-toggler {
      display: none; }
    .navbar-expand-sm .offcanvas {
      position: static;
      z-index: auto;
      flex-grow: 1;
      width: auto !important;
      height: auto !important;
      visibility: visible !important;
      background-color: transparent !important;
      border: 0 !important;
      transform: none !important;
      transition: none; }
      .navbar-expand-sm .offcanvas .offcanvas-header {
        display: none; }
      .navbar-expand-sm .offcanvas .offcanvas-body {
        display: flex;
        flex-grow: 0;
        padding: 0;
        overflow-y: visible; } }

@media (min-width: 768px) {
  .navbar-expand-md {
    flex-wrap: nowrap;
    justify-content: flex-start; }
    .navbar-expand-md .navbar-nav {
      flex-direction: row; }
      .navbar-expand-md .navbar-nav .dropdown-menu {
        position: absolute; }
      .navbar-expand-md .navbar-nav .nav-link {
        padding-right: var(--bs-navbar-nav-link-padding-x);
        padding-left: var(--bs-navbar-nav-link-padding-x); }
    .navbar-expand-md .navbar-nav-scroll {
      overflow: visible; }
    .navbar-expand-md .navbar-collapse {
      display: flex !important;
      flex-basis: auto; }
    .navbar-expand-md .navbar-toggler {
      display: none; }
    .navbar-expand-md .offcanvas {
      position: static;
      z-index: auto;
      flex-grow: 1;
      width: auto !important;
      height: auto !important;
      visibility: visible !important;
      background-color: transparent !important;
      border: 0 !important;
      transform: none !important;
      transition: none; }
      .navbar-expand-md .offcanvas .offcanvas-header {
        display: none; }
      .navbar-expand-md .offcanvas .offcanvas-body {
        display: flex;
        flex-grow: 0;
        padding: 0;
        overflow-y: visible; } }

@media (min-width: 992px) {
  .navbar-expand-lg {
    flex-wrap: nowrap;
    justify-content: flex-start; }
    .navbar-expand-lg .navbar-nav {
      flex-direction: row; }
      .navbar-expand-lg .navbar-nav .dropdown-menu {
        position: absolute; }
      .navbar-expand-lg .navbar-nav .nav-link {
        padding-right: var(--bs-navbar-nav-link-padding-x);
        padding-left: var(--bs-navbar-nav-link-padding-x); }
    .navbar-expand-lg .navbar-nav-scroll {
      overflow: visible; }
    .navbar-expand-lg .navbar-collapse {
      display: flex !important;
      flex-basis: auto; }
    .navbar-expand-lg .navbar-toggler {
      display: none; }
    .navbar-expand-lg .offcanvas {
      position: static;
      z-index: auto;
      flex-grow: 1;
      width: auto !important;
      height: auto !important;
      visibility: visible !important;
      background-color: transparent !important;
      border: 0 !important;
      transform: none !important;
      transition: none; }
      .navbar-expand-lg .offcanvas .offcanvas-header {
        display: none; }
      .navbar-expand-lg .offcanvas .offcanvas-body {
        display: flex;
        flex-grow: 0;
        padding: 0;
        overflow-y: visible; } }

@media (min-width: 1200px) {
  .navbar-expand-xl {
    flex-wrap: nowrap;
    justify-content: flex-start; }
    .navbar-expand-xl .navbar-nav {
      flex-direction: row; }
      .navbar-expand-xl .navbar-nav .dropdown-menu {
        position: absolute; }
      .navbar-expand-xl .navbar-nav .nav-link {
        padding-right: var(--bs-navbar-nav-link-padding-x);
        padding-left: var(--bs-navbar-nav-link-padding-x); }
    .navbar-expand-xl .navbar-nav-scroll {
      overflow: visible; }
    .navbar-expand-xl .navbar-collapse {
      display: flex !important;
      flex-basis: auto; }
    .navbar-expand-xl .navbar-toggler {
      display: none; }
    .navbar-expand-xl .offcanvas {
      position: static;
      z-index: auto;
      flex-grow: 1;
      width: auto !important;
      height: auto !important;
      visibility: visible !important;
      background-color: transparent !important;
      border: 0 !important;
      transform: none !important;
      transition: none; }
      .navbar-expand-xl .offcanvas .offcanvas-header {
        display: none; }
      .navbar-expand-xl .offcanvas .offcanvas-body {
        display: flex;
        flex-grow: 0;
        padding: 0;
        overflow-y: visible; } }

@media (min-width: 1400px) {
  .navbar-expand-xxl {
    flex-wrap: nowrap;
    justify-content: flex-start; }
    .navbar-expand-xxl .navbar-nav {
      flex-direction: row; }
      .navbar-expand-xxl .navbar-nav .dropdown-menu {
        position: absolute; }
      .navbar-expand-xxl .navbar-nav .nav-link {
        padding-right: var(--bs-navbar-nav-link-padding-x);
        padding-left: var(--bs-navbar-nav-link-padding-x); }
    .navbar-expand-xxl .navbar-nav-scroll {
      overflow: visible; }
    .navbar-expand-xxl .navbar-collapse {
      display: flex !important;
      flex-basis: auto; }
    .navbar-expand-xxl .navbar-toggler {
      display: none; }
    .navbar-expand-xxl .offcanvas {
      position: static;
      z-index: auto;
      flex-grow: 1;
      width: auto !important;
      height: auto !important;
      visibility: visible !important;
      background-color: transparent !important;
      border: 0 !important;
      transform: none !important;
      transition: none; }
      .navbar-expand-xxl .offcanvas .offcanvas-header {
        display: none; }
      .navbar-expand-xxl .offcanvas .offcanvas-body {
        display: flex;
        flex-grow: 0;
        padding: 0;
        overflow-y: visible; } }

.navbar-expand {
  flex-wrap: nowrap;
  justify-content: flex-start; }
  .navbar-expand .navbar-nav {
    flex-direction: row; }
    .navbar-expand .navbar-nav .dropdown-menu {
      position: absolute; }
    .navbar-expand .navbar-nav .nav-link {
      padding-right: var(--bs-navbar-nav-link-padding-x);
      padding-left: var(--bs-navbar-nav-link-padding-x); }
  .navbar-expand .navbar-nav-scroll {
    overflow: visible; }
  .navbar-expand .navbar-collapse {
    display: flex !important;
    flex-basis: auto; }
  .navbar-expand .navbar-toggler {
    display: none; }
  .navbar-expand .offcanvas {
    position: static;
    z-index: auto;
    flex-grow: 1;
    width: auto !important;
    height: auto !important;
    visibility: visible !important;
    background-color: transparent !important;
    border: 0 !important;
    transform: none !important;
    transition: none; }
    .navbar-expand .offcanvas .offcanvas-header {
      display: none; }
    .navbar-expand .offcanvas .offcanvas-body {
      display: flex;
      flex-grow: 0;
      padding: 0;
      overflow-y: visible; }

.navbar-dark {
  --bs-navbar-color: rgba(255, 255, 255, 0.55);
  --bs-navbar-hover-color: rgba(255, 255, 255, 0.75);
  --bs-navbar-disabled-color: rgba(255, 255, 255, 0.25);
  --bs-navbar-active-color: #fff;
  --bs-navbar-brand-color: #fff;
  --bs-navbar-brand-hover-color: #fff;
  --bs-navbar-toggler-border-color: rgba(255, 255, 255, 0.1);
  --bs-navbar-toggler-icon-bg: url(${___CSS_LOADER_URL_REPLACEMENT_44___}); }

.card {
  --bs-card-spacer-y: 1rem;
  --bs-card-spacer-x: 1rem;
  --bs-card-title-spacer-y: 0.5rem;
  --bs-card-border-width: 0;
  --bs-card-border-color: rgba(0, 0, 0, 0.125);
  --bs-card-border-radius: 0.25rem;
  --bs-card-box-shadow: 0 1px 2px rgba(56, 65, 74, 0.15);
  --bs-card-inner-border-radius: 0.25rem;
  --bs-card-cap-padding-y: 1rem;
  --bs-card-cap-padding-x: 1rem;
  --bs-card-cap-bg: var(--vz-card-cap-bg);
  --bs-card-cap-color: ;
  --bs-card-height: ;
  --bs-card-color: ;
  --bs-card-bg: var(--vz-card-bg);
  --bs-card-img-overlay-padding: 1rem;
  --bs-card-group-margin: 0.75rem;
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  height: var(--bs-card-height);
  word-wrap: break-word;
  background-color: var(--bs-card-bg);
  background-clip: border-box;
  border: var(--bs-card-border-width) solid var(--bs-card-border-color);
  border-radius: var(--bs-card-border-radius); }
  .card > hr {
    margin-right: 0;
    margin-left: 0; }
  .card > .list-group {
    border-top: inherit;
    border-bottom: inherit; }
    .card > .list-group:first-child {
      border-top-width: 0;
      border-top-left-radius: var(--bs-card-inner-border-radius);
      border-top-right-radius: var(--bs-card-inner-border-radius); }
    .card > .list-group:last-child {
      border-bottom-width: 0;
      border-bottom-right-radius: var(--bs-card-inner-border-radius);
      border-bottom-left-radius: var(--bs-card-inner-border-radius); }
  .card > .card-header + .list-group,
  .card > .list-group + .card-footer {
    border-top: 0; }

.card-body {
  flex: 1 1 auto;
  padding: var(--bs-card-spacer-y) var(--bs-card-spacer-x);
  color: var(--bs-card-color); }

.card-title {
  margin-bottom: var(--bs-card-title-spacer-y); }

.card-subtitle {
  margin-top: calc(-.5 * var(--bs-card-title-spacer-y));
  margin-bottom: 0; }

.card-text:last-child {
  margin-bottom: 0; }

.card-link + .card-link {
  margin-left: var(--bs-card-spacer-x); }

.card-header {
  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);
  margin-bottom: 0;
  color: var(--bs-card-cap-color);
  background-color: var(--bs-card-cap-bg);
  border-bottom: var(--bs-card-border-width) solid var(--bs-card-border-color); }
  .card-header:first-child {
    border-radius: var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius) 0 0; }

.card-footer {
  padding: var(--bs-card-cap-padding-y) var(--bs-card-cap-padding-x);
  color: var(--bs-card-cap-color);
  background-color: var(--bs-card-cap-bg);
  border-top: var(--bs-card-border-width) solid var(--bs-card-border-color); }
  .card-footer:last-child {
    border-radius: 0 0 var(--bs-card-inner-border-radius) var(--bs-card-inner-border-radius); }

.card-header-tabs {
  margin-right: calc(-.5 * var(--bs-card-cap-padding-x));
  margin-bottom: calc(-1 * var(--bs-card-cap-padding-y));
  margin-left: calc(-.5 * var(--bs-card-cap-padding-x));
  border-bottom: 0; }
  .card-header-tabs .nav-link.active {
    background-color: var(--bs-card-bg);
    border-bottom-color: var(--bs-card-bg); }

.card-header-pills {
  margin-right: calc(-.5 * var(--bs-card-cap-padding-x));
  margin-left: calc(-.5 * var(--bs-card-cap-padding-x)); }

.card-img-overlay {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  padding: var(--bs-card-img-overlay-padding);
  border-radius: var(--bs-card-inner-border-radius); }

.card-img,
.card-img-top,
.card-img-bottom {
  width: 100%; }

.card-img,
.card-img-top {
  border-top-left-radius: var(--bs-card-inner-border-radius);
  border-top-right-radius: var(--bs-card-inner-border-radius); }

.card-img,
.card-img-bottom {
  border-bottom-right-radius: var(--bs-card-inner-border-radius);
  border-bottom-left-radius: var(--bs-card-inner-border-radius); }

.card-group > .card {
  margin-bottom: var(--bs-card-group-margin); }

@media (min-width: 576px) {
  .card-group {
    display: flex;
    flex-flow: row wrap; }
    .card-group > .card {
      flex: 1 0;
      margin-bottom: 0; }
      .card-group > .card + .card {
        margin-left: 0;
        border-left: 0; }
      .card-group > .card:not(:last-child) {
        border-top-right-radius: 0;
        border-bottom-right-radius: 0; }
        .card-group > .card:not(:last-child) .card-img-top,
        .card-group > .card:not(:last-child) .card-header {
          border-top-right-radius: 0; }
        .card-group > .card:not(:last-child) .card-img-bottom,
        .card-group > .card:not(:last-child) .card-footer {
          border-bottom-right-radius: 0; }
      .card-group > .card:not(:first-child) {
        border-top-left-radius: 0;
        border-bottom-left-radius: 0; }
        .card-group > .card:not(:first-child) .card-img-top,
        .card-group > .card:not(:first-child) .card-header {
          border-top-left-radius: 0; }
        .card-group > .card:not(:first-child) .card-img-bottom,
        .card-group > .card:not(:first-child) .card-footer {
          border-bottom-left-radius: 0; } }

.accordion {
  --bs-accordion-color: var(--vz-body-color);
  --bs-accordion-bg: var(--vz-card-bg);
  --bs-accordion-transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out, border-radius 0.15s ease;
  --bs-accordion-border-color: var(--vz-border-color);
  --bs-accordion-border-width: 1px;
  --bs-accordion-border-radius: 0.25rem;
  --bs-accordion-inner-border-radius: calc(0.25rem - 1px);
  --bs-accordion-btn-padding-x: 1.25rem;
  --bs-accordion-btn-padding-y: 1rem;
  --bs-accordion-btn-color: var(--vz-body-color);
  --bs-accordion-btn-bg: var(--vz-card-bg);
  --bs-accordion-btn-icon: url(${___CSS_LOADER_URL_REPLACEMENT_45___});
  --bs-accordion-btn-icon-width: 0.75rem;
  --bs-accordion-btn-icon-transform: rotate(-180deg);
  --bs-accordion-btn-icon-transition: transform 0.2s ease-in-out;
  --bs-accordion-btn-active-icon: url(${___CSS_LOADER_URL_REPLACEMENT_46___});
  --bs-accordion-btn-focus-border-color: var(--vz-input-focus-border);
  --bs-accordion-btn-focus-box-shadow: inset 0 -1px 0 var(--vz-border-color);
  --bs-accordion-body-padding-x: 1.25rem;
  --bs-accordion-body-padding-y: 1rem;
  --bs-accordion-active-color: #5593b7;
  --bs-accordion-active-bg: rgba(94, 163, 203, 0.05); }

.accordion-button {
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  padding: var(--bs-accordion-btn-padding-y) var(--bs-accordion-btn-padding-x);
  font-size: 0.875rem;
  color: var(--bs-accordion-btn-color);
  text-align: left;
  background-color: var(--bs-accordion-btn-bg);
  border: 0;
  border-radius: 0;
  overflow-anchor: none;
  transition: var(--bs-accordion-transition); }
  @media (prefers-reduced-motion: reduce) {
    .accordion-button {
      transition: none; } }
  .accordion-button:not(.collapsed) {
    color: var(--bs-accordion-active-color);
    background-color: var(--bs-accordion-active-bg);
    box-shadow: inset 0 calc(-1 * var(--bs-accordion-border-width)) 0 var(--bs-accordion-border-color); }
    .accordion-button:not(.collapsed)::after {
      background-image: var(--bs-accordion-btn-active-icon);
      transform: var(--bs-accordion-btn-icon-transform); }
  .accordion-button::after {
    flex-shrink: 0;
    width: var(--bs-accordion-btn-icon-width);
    height: var(--bs-accordion-btn-icon-width);
    margin-left: auto;
    content: "";
    background-image: var(--bs-accordion-btn-icon);
    background-repeat: no-repeat;
    background-size: var(--bs-accordion-btn-icon-width);
    transition: var(--bs-accordion-btn-icon-transition); }
    @media (prefers-reduced-motion: reduce) {
      .accordion-button::after {
        transition: none; } }
  .accordion-button:hover {
    z-index: 2; }
  .accordion-button:focus {
    z-index: 3;
    border-color: var(--bs-accordion-btn-focus-border-color);
    outline: 0;
    box-shadow: var(--bs-accordion-btn-focus-box-shadow); }

.accordion-header {
  margin-bottom: 0; }

.accordion-item {
  color: var(--bs-accordion-color);
  background-color: var(--bs-accordion-bg);
  border: var(--bs-accordion-border-width) solid var(--bs-accordion-border-color); }
  .accordion-item:first-of-type {
    border-top-left-radius: var(--bs-accordion-border-radius);
    border-top-right-radius: var(--bs-accordion-border-radius); }
    .accordion-item:first-of-type .accordion-button {
      border-top-left-radius: var(--bs-accordion-inner-border-radius);
      border-top-right-radius: var(--bs-accordion-inner-border-radius); }
  .accordion-item:not(:first-of-type) {
    border-top: 0; }
  .accordion-item:last-of-type {
    border-bottom-right-radius: var(--bs-accordion-border-radius);
    border-bottom-left-radius: var(--bs-accordion-border-radius); }
    .accordion-item:last-of-type .accordion-button.collapsed {
      border-bottom-right-radius: var(--bs-accordion-inner-border-radius);
      border-bottom-left-radius: var(--bs-accordion-inner-border-radius); }
    .accordion-item:last-of-type .accordion-collapse {
      border-bottom-right-radius: var(--bs-accordion-border-radius);
      border-bottom-left-radius: var(--bs-accordion-border-radius); }

.accordion-body {
  padding: var(--bs-accordion-body-padding-y) var(--bs-accordion-body-padding-x); }

.accordion-flush .accordion-collapse {
  border-width: 0; }

.accordion-flush .accordion-item {
  border-right: 0;
  border-left: 0;
  border-radius: 0; }
  .accordion-flush .accordion-item:first-child {
    border-top: 0; }
  .accordion-flush .accordion-item:last-child {
    border-bottom: 0; }
  .accordion-flush .accordion-item .accordion-button, .accordion-flush .accordion-item .accordion-button.collapsed {
    border-radius: 0; }

.breadcrumb {
  --bs-breadcrumb-padding-x: 0;
  --bs-breadcrumb-padding-y: 0;
  --bs-breadcrumb-margin-bottom: 1rem;
  --bs-breadcrumb-bg: ;
  --bs-breadcrumb-border-radius: ;
  --bs-breadcrumb-divider-color: #878a99;
  --bs-breadcrumb-item-padding-x: 0.5rem;
  --bs-breadcrumb-item-active-color: #878a99;
  display: flex;
  flex-wrap: wrap;
  padding: var(--bs-breadcrumb-padding-y) var(--bs-breadcrumb-padding-x);
  margin-bottom: var(--bs-breadcrumb-margin-bottom);
  font-size: var(--bs-breadcrumb-font-size);
  list-style: none;
  background-color: var(--bs-breadcrumb-bg);
  border-radius: var(--bs-breadcrumb-border-radius); }

.breadcrumb-item + .breadcrumb-item {
  padding-left: var(--bs-breadcrumb-item-padding-x); }
  .breadcrumb-item + .breadcrumb-item::before {
    float: left;
    padding-right: var(--bs-breadcrumb-item-padding-x);
    color: var(--bs-breadcrumb-divider-color);
    content: var(--bs-breadcrumb-divider, "󰅂") /* rtl: var(--bs-breadcrumb-divider, "󰅂") */; }

.breadcrumb-item.active {
  color: var(--bs-breadcrumb-item-active-color); }

.pagination {
  --bs-pagination-padding-x: 0.75rem;
  --bs-pagination-padding-y: 0.375rem;
  --bs-pagination-font-size: 1rem;
  --bs-pagination-color: var(--vz-link-color);
  --bs-pagination-bg: var(--vz-card-bg);
  --bs-pagination-border-width: 1px;
  --bs-pagination-border-color: var(--vz-border-color);
  --bs-pagination-border-radius: 0.25rem;
  --bs-pagination-hover-color: var(--vz-link-hover-color);
  --bs-pagination-hover-bg: var(--vz-pagination-hover-bg);
  --bs-pagination-hover-border-color: var(--vz-border-color);
  --bs-pagination-focus-color: var(--vz-link-hover-color);
  --bs-pagination-focus-bg: var(--vz-pagination-hover-bg);
  --bs-pagination-focus-box-shadow: 0 0 0 0 rgba(94, 163, 203, 0.25);
  --bs-pagination-active-color: #fff;
  --bs-pagination-active-bg: #5ea3cb;
  --bs-pagination-active-border-color: #5ea3cb;
  --bs-pagination-disabled-color: #878a99;
  --bs-pagination-disabled-bg: var(--vz-card-bg);
  --bs-pagination-disabled-border-color: var(--vz-border-color);
  display: flex;
  padding-left: 0;
  list-style: none; }

.page-link {
  position: relative;
  display: block;
  padding: var(--bs-pagination-padding-y) var(--bs-pagination-padding-x);
  font-size: var(--bs-pagination-font-size);
  color: var(--bs-pagination-color);
  text-decoration: none;
  background-color: var(--bs-pagination-bg);
  border: var(--bs-pagination-border-width) solid var(--bs-pagination-border-color);
  transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out; }
  @media (prefers-reduced-motion: reduce) {
    .page-link {
      transition: none; } }
  .page-link:hover {
    z-index: 2;
    color: var(--bs-pagination-hover-color);
    background-color: var(--bs-pagination-hover-bg);
    border-color: var(--bs-pagination-hover-border-color); }
  .page-link:focus {
    z-index: 3;
    color: var(--bs-pagination-focus-color);
    background-color: var(--bs-pagination-focus-bg);
    outline: 0;
    box-shadow: var(--bs-pagination-focus-box-shadow); }
  .page-link.active,
  .active > .page-link {
    z-index: 3;
    color: var(--bs-pagination-active-color);
    background-color: var(--bs-pagination-active-bg);
    border-color: var(--bs-pagination-active-border-color); }
  .page-link.disabled,
  .disabled > .page-link {
    color: var(--bs-pagination-disabled-color);
    pointer-events: none;
    background-color: var(--bs-pagination-disabled-bg);
    border-color: var(--bs-pagination-disabled-border-color); }

.page-item:not(:first-child) .page-link {
  margin-left: -1px; }

.page-item:first-child .page-link {
  border-top-left-radius: var(--bs-pagination-border-radius);
  border-bottom-left-radius: var(--bs-pagination-border-radius); }

.page-item:last-child .page-link {
  border-top-right-radius: var(--bs-pagination-border-radius);
  border-bottom-right-radius: var(--bs-pagination-border-radius); }

.pagination-lg {
  --bs-pagination-padding-x: 1.2rem;
  --bs-pagination-padding-y: 0.6rem;
  --bs-pagination-font-size: 1.09375rem;
  --bs-pagination-border-radius: 0.3rem; }

.pagination-sm {
  --bs-pagination-padding-x: 0.5rem;
  --bs-pagination-padding-y: 0.25rem;
  --bs-pagination-font-size: 0.76563rem;
  --bs-pagination-border-radius: 0.2rem; }
  @media (min-width: 1200px) {
    .pagination-sm {
      --bs-pagination-font-size: 0.76562rem; } }

.badge {
  --bs-badge-padding-x: 0.65em;
  --bs-badge-padding-y: 0.35em;
  --bs-badge-font-size: 0.75em;
  --bs-badge-font-weight: 600;
  --bs-badge-color: #fff;
  --bs-badge-border-radius: 0.25rem;
  display: inline-block;
  padding: var(--bs-badge-padding-y) var(--bs-badge-padding-x);
  font-size: var(--bs-badge-font-size);
  font-weight: var(--bs-badge-font-weight);
  line-height: 1;
  color: var(--bs-badge-color);
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: var(--bs-badge-border-radius); }
  .badge:empty {
    display: none; }

.btn .badge {
  position: relative;
  top: -1px; }

.alert {
  --bs-alert-bg: transparent;
  --bs-alert-padding-x: 1rem;
  --bs-alert-padding-y: 0.8rem;
  --bs-alert-margin-bottom: 1rem;
  --bs-alert-color: inherit;
  --bs-alert-border-color: transparent;
  --bs-alert-border: 1px solid var(--bs-alert-border-color);
  --bs-alert-border-radius: 0.25rem;
  position: relative;
  padding: var(--bs-alert-padding-y) var(--bs-alert-padding-x);
  margin-bottom: var(--bs-alert-margin-bottom);
  color: var(--bs-alert-color);
  background-color: var(--bs-alert-bg);
  border: var(--bs-alert-border);
  border-radius: var(--bs-alert-border-radius); }

.alert-heading {
  color: inherit; }

.alert-link {
  font-weight: 600; }

.alert-dismissible {
  padding-right: 3rem; }
  .alert-dismissible .btn-close {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 2;
    padding: 1rem 1rem; }

.alert-primary {
  --bs-alert-color: #477a98;
  --bs-alert-bg: #e7f1f7;
  --bs-alert-border-color: #cfe3ef; }
  .alert-primary .alert-link {
    color: #39627a; }

.alert-secondary {
  --bs-alert-color: #546395;
  --bs-alert-bg: #eaedf7;
  --bs-alert-border-color: #d4daee; }
  .alert-secondary .alert-link {
    color: #434f77; }

.alert-success {
  --bs-alert-color: #257170;
  --bs-alert-bg: #e0efef;
  --bs-alert-border-color: #c1e0df; }
  .alert-success .alert-link {
    color: #1e5a5a; }

.alert-info {
  --bs-alert-color: #4298b0;
  --bs-alert-bg: #e6f7fc;
  --bs-alert-border-color: #cdeff9; }
  .alert-info .alert-link {
    color: #357a8d; }

.alert-warning {
  --bs-alert-color: #b98a38;
  --bs-alert-bg: #fef4e4;
  --bs-alert-border-color: #fdeac9; }
  .alert-warning .alert-link {
    color: #946e2d; }

.alert-danger {
  --bs-alert-color: #ac2f2f;
  --bs-alert-bg: #fbe2e2;
  --bs-alert-border-color: #f7c5c5; }
  .alert-danger .alert-link {
    color: #8a2626; }

.alert-light {
  --bs-alert-color: #b6b9bb;
  --bs-alert-bg: #fdfefe;
  --bs-alert-border-color: #fbfcfd; }
  .alert-light .alert-link {
    color: #929496; }

.alert-dark {
  --bs-alert-color: #191c1f;
  --bs-alert-bg: #dededf;
  --bs-alert-border-color: #bcbebf; }
  .alert-dark .alert-link {
    color: #141619; }

@keyframes progress-bar-stripes {
  0% {
    background-position-x: 0.625rem; } }

.progress {
  --bs-progress-height: 0.625rem;
  --bs-progress-font-size: 0.65625rem;
  --bs-progress-bg: var(--vz-progress-bg);
  --bs-progress-border-radius: 0.25rem;
  --bs-progress-box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.075);
  --bs-progress-bar-color: #fff;
  --bs-progress-bar-bg: #5ea3cb;
  --bs-progress-bar-transition: width 0.6s ease;
  display: flex;
  height: var(--bs-progress-height);
  overflow: hidden;
  font-size: var(--bs-progress-font-size);
  background-color: var(--bs-progress-bg);
  border-radius: var(--bs-progress-border-radius); }

.progress-bar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: hidden;
  color: var(--bs-progress-bar-color);
  text-align: center;
  white-space: nowrap;
  background-color: var(--bs-progress-bar-bg);
  transition: var(--bs-progress-bar-transition); }
  @media (prefers-reduced-motion: reduce) {
    .progress-bar {
      transition: none; } }

.progress-bar-striped {
  background-image: linear-gradient(45deg, rgba(255, 255, 255, 0.15) 25%, transparent 25%, transparent 50%, rgba(255, 255, 255, 0.15) 50%, rgba(255, 255, 255, 0.15) 75%, transparent 75%, transparent);
  background-size: var(--bs-progress-height) var(--bs-progress-height); }

.progress-bar-animated {
  animation: 1s linear infinite progress-bar-stripes; }
  @media (prefers-reduced-motion: reduce) {
    .progress-bar-animated {
      animation: none; } }

.list-group {
  --bs-list-group-color: var(--vz-body-color);
  --bs-list-group-bg: var(--vz-card-bg);
  --bs-list-group-border-color: var(--vz-border-color);
  --bs-list-group-border-width: 1px;
  --bs-list-group-border-radius: 0.25rem;
  --bs-list-group-item-padding-x: 1rem;
  --bs-list-group-item-padding-y: 0.7rem;
  --bs-list-group-action-color: var(--vz-body-color);
  --bs-list-group-action-hover-color: var(--vz-body-color);
  --bs-list-group-action-hover-bg: var(--vz-list-group-hover-bg);
  --bs-list-group-action-active-color: var(--vz-body-color);
  --bs-list-group-action-active-bg: var(--vz-list-group-hover-bg);
  --bs-list-group-disabled-color: #878a99;
  --bs-list-group-disabled-bg: var(--vz-card-bg);
  --bs-list-group-active-color: #fff;
  --bs-list-group-active-bg: #5ea3cb;
  --bs-list-group-active-border-color: #5ea3cb;
  display: flex;
  flex-direction: column;
  padding-left: 0;
  margin-bottom: 0;
  border-radius: var(--bs-list-group-border-radius); }

.list-group-numbered {
  list-style-type: none;
  counter-reset: section; }
  .list-group-numbered > .list-group-item::before {
    content: counters(section, ".") ". ";
    counter-increment: section; }

.list-group-item-action {
  width: 100%;
  color: var(--bs-list-group-action-color);
  text-align: inherit; }
  .list-group-item-action:hover, .list-group-item-action:focus {
    z-index: 1;
    color: var(--bs-list-group-action-hover-color);
    text-decoration: none;
    background-color: var(--bs-list-group-action-hover-bg); }
  .list-group-item-action:active {
    color: var(--bs-list-group-action-active-color);
    background-color: var(--bs-list-group-action-active-bg); }

.list-group-item {
  position: relative;
  display: block;
  padding: var(--bs-list-group-item-padding-y) var(--bs-list-group-item-padding-x);
  color: var(--bs-list-group-color);
  text-decoration: none;
  background-color: var(--bs-list-group-bg);
  border: var(--bs-list-group-border-width) solid var(--bs-list-group-border-color); }
  .list-group-item:first-child {
    border-top-left-radius: inherit;
    border-top-right-radius: inherit; }
  .list-group-item:last-child {
    border-bottom-right-radius: inherit;
    border-bottom-left-radius: inherit; }
  .list-group-item.disabled, .list-group-item:disabled {
    color: var(--bs-list-group-disabled-color);
    pointer-events: none;
    background-color: var(--bs-list-group-disabled-bg); }
  .list-group-item.active {
    z-index: 2;
    color: var(--bs-list-group-active-color);
    background-color: var(--bs-list-group-active-bg);
    border-color: var(--bs-list-group-active-border-color); }
  .list-group-item + .list-group-item {
    border-top-width: 0; }
    .list-group-item + .list-group-item.active {
      margin-top: calc(-1 * var(--bs-list-group-border-width));
      border-top-width: var(--bs-list-group-border-width); }

.list-group-horizontal {
  flex-direction: row; }
  .list-group-horizontal > .list-group-item:first-child:not(:last-child) {
    border-bottom-left-radius: var(--bs-list-group-border-radius);
    border-top-right-radius: 0; }
  .list-group-horizontal > .list-group-item:last-child:not(:first-child) {
    border-top-right-radius: var(--bs-list-group-border-radius);
    border-bottom-left-radius: 0; }
  .list-group-horizontal > .list-group-item.active {
    margin-top: 0; }
  .list-group-horizontal > .list-group-item + .list-group-item {
    border-top-width: var(--bs-list-group-border-width);
    border-left-width: 0; }
    .list-group-horizontal > .list-group-item + .list-group-item.active {
      margin-left: calc(-1 * var(--bs-list-group-border-width));
      border-left-width: var(--bs-list-group-border-width); }

@media (min-width: 576px) {
  .list-group-horizontal-sm {
    flex-direction: row; }
    .list-group-horizontal-sm > .list-group-item:first-child:not(:last-child) {
      border-bottom-left-radius: var(--bs-list-group-border-radius);
      border-top-right-radius: 0; }
    .list-group-horizontal-sm > .list-group-item:last-child:not(:first-child) {
      border-top-right-radius: var(--bs-list-group-border-radius);
      border-bottom-left-radius: 0; }
    .list-group-horizontal-sm > .list-group-item.active {
      margin-top: 0; }
    .list-group-horizontal-sm > .list-group-item + .list-group-item {
      border-top-width: var(--bs-list-group-border-width);
      border-left-width: 0; }
      .list-group-horizontal-sm > .list-group-item + .list-group-item.active {
        margin-left: calc(-1 * var(--bs-list-group-border-width));
        border-left-width: var(--bs-list-group-border-width); } }

@media (min-width: 768px) {
  .list-group-horizontal-md {
    flex-direction: row; }
    .list-group-horizontal-md > .list-group-item:first-child:not(:last-child) {
      border-bottom-left-radius: var(--bs-list-group-border-radius);
      border-top-right-radius: 0; }
    .list-group-horizontal-md > .list-group-item:last-child:not(:first-child) {
      border-top-right-radius: var(--bs-list-group-border-radius);
      border-bottom-left-radius: 0; }
    .list-group-horizontal-md > .list-group-item.active {
      margin-top: 0; }
    .list-group-horizontal-md > .list-group-item + .list-group-item {
      border-top-width: var(--bs-list-group-border-width);
      border-left-width: 0; }
      .list-group-horizontal-md > .list-group-item + .list-group-item.active {
        margin-left: calc(-1 * var(--bs-list-group-border-width));
        border-left-width: var(--bs-list-group-border-width); } }

@media (min-width: 992px) {
  .list-group-horizontal-lg {
    flex-direction: row; }
    .list-group-horizontal-lg > .list-group-item:first-child:not(:last-child) {
      border-bottom-left-radius: var(--bs-list-group-border-radius);
      border-top-right-radius: 0; }
    .list-group-horizontal-lg > .list-group-item:last-child:not(:first-child) {
      border-top-right-radius: var(--bs-list-group-border-radius);
      border-bottom-left-radius: 0; }
    .list-group-horizontal-lg > .list-group-item.active {
      margin-top: 0; }
    .list-group-horizontal-lg > .list-group-item + .list-group-item {
      border-top-width: var(--bs-list-group-border-width);
      border-left-width: 0; }
      .list-group-horizontal-lg > .list-group-item + .list-group-item.active {
        margin-left: calc(-1 * var(--bs-list-group-border-width));
        border-left-width: var(--bs-list-group-border-width); } }

@media (min-width: 1200px) {
  .list-group-horizontal-xl {
    flex-direction: row; }
    .list-group-horizontal-xl > .list-group-item:first-child:not(:last-child) {
      border-bottom-left-radius: var(--bs-list-group-border-radius);
      border-top-right-radius: 0; }
    .list-group-horizontal-xl > .list-group-item:last-child:not(:first-child) {
      border-top-right-radius: var(--bs-list-group-border-radius);
      border-bottom-left-radius: 0; }
    .list-group-horizontal-xl > .list-group-item.active {
      margin-top: 0; }
    .list-group-horizontal-xl > .list-group-item + .list-group-item {
      border-top-width: var(--bs-list-group-border-width);
      border-left-width: 0; }
      .list-group-horizontal-xl > .list-group-item + .list-group-item.active {
        margin-left: calc(-1 * var(--bs-list-group-border-width));
        border-left-width: var(--bs-list-group-border-width); } }

@media (min-width: 1400px) {
  .list-group-horizontal-xxl {
    flex-direction: row; }
    .list-group-horizontal-xxl > .list-group-item:first-child:not(:last-child) {
      border-bottom-left-radius: var(--bs-list-group-border-radius);
      border-top-right-radius: 0; }
    .list-group-horizontal-xxl > .list-group-item:last-child:not(:first-child) {
      border-top-right-radius: var(--bs-list-group-border-radius);
      border-bottom-left-radius: 0; }
    .list-group-horizontal-xxl > .list-group-item.active {
      margin-top: 0; }
    .list-group-horizontal-xxl > .list-group-item + .list-group-item {
      border-top-width: var(--bs-list-group-border-width);
      border-left-width: 0; }
      .list-group-horizontal-xxl > .list-group-item + .list-group-item.active {
        margin-left: calc(-1 * var(--bs-list-group-border-width));
        border-left-width: var(--bs-list-group-border-width); } }

.list-group-flush {
  border-radius: 0; }
  .list-group-flush > .list-group-item {
    border-width: 0 0 var(--bs-list-group-border-width); }
    .list-group-flush > .list-group-item:last-child {
      border-bottom-width: 0; }

.list-group-item-primary {
  color: #38627a;
  background-color: #dfedf5; }
  .list-group-item-primary.list-group-item-action:hover, .list-group-item-primary.list-group-item-action:focus {
    color: #38627a;
    background-color: #c9d5dd; }
  .list-group-item-primary.list-group-item-action.active {
    color: #fff;
    background-color: #38627a;
    border-color: #38627a; }

.list-group-item-secondary {
  color: #434f77;
  background-color: #e2e6f4; }
  .list-group-item-secondary.list-group-item-action:hover, .list-group-item-secondary.list-group-item-action:focus {
    color: #434f77;
    background-color: #cbcfdc; }
  .list-group-item-secondary.list-group-item-action.active {
    color: #fff;
    background-color: #434f77;
    border-color: #434f77; }

.list-group-item-success {
  color: #1d5b59;
  background-color: #d6eaea; }
  .list-group-item-success.list-group-item-action:hover, .list-group-item-success.list-group-item-action:focus {
    color: #1d5b59;
    background-color: #c1d3d3; }
  .list-group-item-success.list-group-item-action.active {
    color: #fff;
    background-color: #1d5b59;
    border-color: #1d5b59; }

.list-group-item-info {
  color: #35798c;
  background-color: #def4fb; }
  .list-group-item-info.list-group-item-action:hover, .list-group-item-info.list-group-item-action:focus {
    color: #35798c;
    background-color: #c8dce2; }
  .list-group-item-info.list-group-item-action.active {
    color: #fff;
    background-color: #35798c;
    border-color: #35798c; }

.list-group-item-warning {
  color: #946e2d;
  background-color: #fdf1db; }
  .list-group-item-warning.list-group-item-action:hover, .list-group-item-warning.list-group-item-action:focus {
    color: #946e2d;
    background-color: #e4d9c5; }
  .list-group-item-warning.list-group-item-action.active {
    color: #fff;
    background-color: #946e2d;
    border-color: #946e2d; }

.list-group-item-danger {
  color: #892525;
  background-color: #fad8d8; }
  .list-group-item-danger.list-group-item-action:hover, .list-group-item-danger.list-group-item-action:focus {
    color: #892525;
    background-color: #e1c2c2; }
  .list-group-item-danger.list-group-item-action.active {
    color: #fff;
    background-color: #892525;
    border-color: #892525; }

.list-group-item-light {
  color: #929495;
  background-color: #fdfdfe; }
  .list-group-item-light.list-group-item-action:hover, .list-group-item-light.list-group-item-action:focus {
    color: #929495;
    background-color: #e4e4e5; }
  .list-group-item-light.list-group-item-action.active {
    color: #fff;
    background-color: #929495;
    border-color: #929495; }

.list-group-item-dark {
  color: #141619;
  background-color: #d3d3d4; }
  .list-group-item-dark.list-group-item-action:hover, .list-group-item-dark.list-group-item-action:focus {
    color: #141619;
    background-color: #bebebf; }
  .list-group-item-dark.list-group-item-action.active {
    color: #fff;
    background-color: #141619;
    border-color: #141619; }

.btn-close {
  box-sizing: content-box;
  width: 1em;
  height: 1em;
  padding: 0.25em 0.25em;
  color: #000;
  background: transparent url(${___CSS_LOADER_URL_REPLACEMENT_47___}) center/1em auto no-repeat;
  border: 0;
  border-radius: 0.25rem;
  opacity: 0.5; }
  .btn-close:hover {
    color: #000;
    text-decoration: none;
    opacity: 0.75; }
  .btn-close:focus {
    outline: 0;
    box-shadow: 0 0 0 0 rgba(94, 163, 203, 0.25);
    opacity: 1; }
  .btn-close:disabled, .btn-close.disabled {
    pointer-events: none;
    -webkit-user-select: none;
            user-select: none;
    opacity: 0.25; }

.btn-close-white {
  filter: invert(1) grayscale(100%) brightness(200%); }

.toast {
  --bs-toast-zindex: 1090;
  --bs-toast-padding-x: 0.75rem;
  --bs-toast-padding-y: 0.5rem;
  --bs-toast-spacing: 0.75rem;
  --bs-toast-max-width: 350px;
  --bs-toast-font-size: 0.875rem;
  --bs-toast-color: ;
  --bs-toast-bg: var(--vz-toast-background-color);
  --bs-toast-border-width: 1px;
  --bs-toast-border-color: var(--vz-toast-border-color);
  --bs-toast-border-radius: 0.25rem;
  --bs-toast-box-shadow: 0 1px 2px rgba(56, 65, 74, 0.15);
  --bs-toast-header-color: #878a99;
  --bs-toast-header-bg: var(--vz-toast-background-color);
  --bs-toast-header-border-color: var(--vz-toast-header-border-color);
  width: var(--bs-toast-max-width);
  max-width: 100%;
  font-size: var(--bs-toast-font-size);
  color: var(--bs-toast-color);
  pointer-events: auto;
  background-color: var(--bs-toast-bg);
  background-clip: padding-box;
  border: var(--bs-toast-border-width) solid var(--bs-toast-border-color);
  box-shadow: var(--bs-toast-box-shadow);
  border-radius: var(--bs-toast-border-radius); }
  .toast.showing {
    opacity: 0; }
  .toast:not(.show) {
    display: none; }

.toast-container {
  --bs-toast-zindex: 1090;
  position: absolute;
  z-index: var(--bs-toast-zindex);
  width: max-content;
  max-width: 100%;
  pointer-events: none; }
  .toast-container > :not(:last-child) {
    margin-bottom: var(--bs-toast-spacing); }

.toast-header {
  display: flex;
  align-items: center;
  padding: var(--bs-toast-padding-y) var(--bs-toast-padding-x);
  color: var(--bs-toast-header-color);
  background-color: var(--bs-toast-header-bg);
  background-clip: padding-box;
  border-bottom: var(--bs-toast-border-width) solid var(--bs-toast-header-border-color);
  border-top-left-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width));
  border-top-right-radius: calc(var(--bs-toast-border-radius) - var(--bs-toast-border-width)); }
  .toast-header .btn-close {
    margin-right: calc(-.5 * var(--bs-toast-padding-x));
    margin-left: var(--bs-toast-padding-x); }

.toast-body {
  padding: var(--bs-toast-padding-x);
  word-wrap: break-word; }

.modal {
  --bs-modal-zindex: 1055;
  --bs-modal-width: 500px;
  --bs-modal-padding: 1.25rem;
  --bs-modal-margin: 0.5rem;
  --bs-modal-color: ;
  --bs-modal-bg: var(--vz-modal-bg);
  --bs-modal-border-color: var(--vz-border-color);
  --bs-modal-border-width: 1px;
  --bs-modal-border-radius: 0.3rem;
  --bs-modal-box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  --bs-modal-inner-border-radius: calc(0.3rem - 1px);
  --bs-modal-header-padding-x: 1.25rem;
  --bs-modal-header-padding-y: 1.25rem;
  --bs-modal-header-padding: 1.25rem 1.25rem;
  --bs-modal-header-border-color: var(--vz-border-color);
  --bs-modal-header-border-width: 0;
  --bs-modal-title-line-height: 1.5;
  --bs-modal-footer-gap: 0.5rem;
  --bs-modal-footer-bg: ;
  --bs-modal-footer-border-color: var(--vz-border-color);
  --bs-modal-footer-border-width: 0;
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--bs-modal-zindex);
  display: none;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  outline: 0; }

.modal-dialog {
  position: relative;
  width: auto;
  margin: var(--bs-modal-margin);
  pointer-events: none; }
  .modal.fade .modal-dialog {
    transition: transform 0.3s ease-out;
    transform: translate(0, -50px); }
    @media (prefers-reduced-motion: reduce) {
      .modal.fade .modal-dialog {
        transition: none; } }
  .modal.show .modal-dialog {
    transform: none; }
  .modal.modal-static .modal-dialog {
    transform: scale(1.02); }

.modal-dialog-scrollable {
  height: calc(100% - var(--bs-modal-margin) * 2); }
  .modal-dialog-scrollable .modal-content {
    max-height: 100%;
    overflow: hidden; }
  .modal-dialog-scrollable .modal-body {
    overflow-y: auto; }

.modal-dialog-centered {
  display: flex;
  align-items: center;
  min-height: calc(100% - var(--bs-modal-margin) * 2); }

.modal-content {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 100%;
  color: var(--bs-modal-color);
  pointer-events: auto;
  background-color: var(--bs-modal-bg);
  background-clip: padding-box;
  border: var(--bs-modal-border-width) solid var(--bs-modal-border-color);
  border-radius: var(--bs-modal-border-radius);
  outline: 0; }

.modal-backdrop {
  --bs-backdrop-zindex: 1050;
  --bs-backdrop-bg: #000;
  --bs-backdrop-opacity: 0.5;
  position: fixed;
  top: 0;
  left: 0;
  z-index: var(--bs-backdrop-zindex);
  width: 100vw;
  height: 100vh;
  background-color: var(--bs-backdrop-bg); }
  .modal-backdrop.fade {
    opacity: 0; }
  .modal-backdrop.show {
    opacity: var(--bs-backdrop-opacity); }

.modal-header {
  display: flex;
  flex-shrink: 0;
  align-items: center;
  justify-content: space-between;
  padding: var(--bs-modal-header-padding);
  border-bottom: var(--bs-modal-header-border-width) solid var(--bs-modal-header-border-color);
  border-top-left-radius: var(--bs-modal-inner-border-radius);
  border-top-right-radius: var(--bs-modal-inner-border-radius); }
  .modal-header .btn-close {
    padding: calc(var(--bs-modal-header-padding-y) * .5) calc(var(--bs-modal-header-padding-x) * .5);
    margin: calc(-.5 * var(--bs-modal-header-padding-y)) calc(-.5 * var(--bs-modal-header-padding-x)) calc(-.5 * var(--bs-modal-header-padding-y)) auto; }

.modal-title {
  margin-bottom: 0;
  line-height: var(--bs-modal-title-line-height); }

.modal-body {
  position: relative;
  flex: 1 1 auto;
  padding: var(--bs-modal-padding); }

.modal-footer {
  display: flex;
  flex-shrink: 0;
  flex-wrap: wrap;
  align-items: center;
  justify-content: flex-end;
  padding: calc(var(--bs-modal-padding) - var(--bs-modal-footer-gap) * .5);
  background-color: var(--bs-modal-footer-bg);
  border-top: var(--bs-modal-footer-border-width) solid var(--bs-modal-footer-border-color);
  border-bottom-right-radius: var(--bs-modal-inner-border-radius);
  border-bottom-left-radius: var(--bs-modal-inner-border-radius); }
  .modal-footer > * {
    margin: calc(var(--bs-modal-footer-gap) * .5); }

@media (min-width: 576px) {
  .modal {
    --bs-modal-margin: 1.75rem;
    --bs-modal-box-shadow: 0 1px 2px rgba(56, 65, 74, 0.15); }
  .modal-dialog {
    max-width: var(--bs-modal-width);
    margin-right: auto;
    margin-left: auto; }
  .modal-sm {
    --bs-modal-width: 300px; } }

@media (min-width: 992px) {
  .modal-lg,
  .modal-xl {
    --bs-modal-width: 800px; } }

@media (min-width: 1200px) {
  .modal-xl {
    --bs-modal-width: 1140px; } }

.modal-fullscreen {
  width: 100vw;
  max-width: none;
  height: 100%;
  margin: 0; }
  .modal-fullscreen .modal-content {
    height: 100%;
    border: 0;
    border-radius: 0; }
  .modal-fullscreen .modal-header,
  .modal-fullscreen .modal-footer {
    border-radius: 0; }
  .modal-fullscreen .modal-body {
    overflow-y: auto; }

@media (max-width: 575.98px) {
  .modal-fullscreen-sm-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0; }
    .modal-fullscreen-sm-down .modal-content {
      height: 100%;
      border: 0;
      border-radius: 0; }
    .modal-fullscreen-sm-down .modal-header,
    .modal-fullscreen-sm-down .modal-footer {
      border-radius: 0; }
    .modal-fullscreen-sm-down .modal-body {
      overflow-y: auto; } }

@media (max-width: 767.98px) {
  .modal-fullscreen-md-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0; }
    .modal-fullscreen-md-down .modal-content {
      height: 100%;
      border: 0;
      border-radius: 0; }
    .modal-fullscreen-md-down .modal-header,
    .modal-fullscreen-md-down .modal-footer {
      border-radius: 0; }
    .modal-fullscreen-md-down .modal-body {
      overflow-y: auto; } }

@media (max-width: 991.98px) {
  .modal-fullscreen-lg-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0; }
    .modal-fullscreen-lg-down .modal-content {
      height: 100%;
      border: 0;
      border-radius: 0; }
    .modal-fullscreen-lg-down .modal-header,
    .modal-fullscreen-lg-down .modal-footer {
      border-radius: 0; }
    .modal-fullscreen-lg-down .modal-body {
      overflow-y: auto; } }

@media (max-width: 1199.98px) {
  .modal-fullscreen-xl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0; }
    .modal-fullscreen-xl-down .modal-content {
      height: 100%;
      border: 0;
      border-radius: 0; }
    .modal-fullscreen-xl-down .modal-header,
    .modal-fullscreen-xl-down .modal-footer {
      border-radius: 0; }
    .modal-fullscreen-xl-down .modal-body {
      overflow-y: auto; } }

@media (max-width: 1399.98px) {
  .modal-fullscreen-xxl-down {
    width: 100vw;
    max-width: none;
    height: 100%;
    margin: 0; }
    .modal-fullscreen-xxl-down .modal-content {
      height: 100%;
      border: 0;
      border-radius: 0; }
    .modal-fullscreen-xxl-down .modal-header,
    .modal-fullscreen-xxl-down .modal-footer {
      border-radius: 0; }
    .modal-fullscreen-xxl-down .modal-body {
      overflow-y: auto; } }

.tooltip {
  --bs-tooltip-zindex: 1080;
  --bs-tooltip-max-width: 200px;
  --bs-tooltip-padding-x: 0.7rem;
  --bs-tooltip-padding-y: 0.4rem;
  --bs-tooltip-margin: 0;
  --bs-tooltip-font-size: 0.76563rem;
  --bs-tooltip-color: #fff;
  --bs-tooltip-bg: #000;
  --bs-tooltip-border-radius: 0.2rem;
  --bs-tooltip-opacity: 0.9;
  --bs-tooltip-arrow-width: 0.8rem;
  --bs-tooltip-arrow-height: 0.4rem;
  z-index: var(--bs-tooltip-zindex);
  display: block;
  padding: var(--bs-tooltip-arrow-height);
  margin: var(--bs-tooltip-margin);
  font-family: var(--vz-font-sans-serif);
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--bs-tooltip-font-size);
  word-wrap: break-word;
  opacity: 0; }
  @media (min-width: 1200px) {
    .tooltip {
      --bs-tooltip-font-size: 0.76562rem; } }
  .tooltip.show {
    opacity: var(--bs-tooltip-opacity); }
  .tooltip .tooltip-arrow {
    display: block;
    width: var(--bs-tooltip-arrow-width);
    height: var(--bs-tooltip-arrow-height); }
    .tooltip .tooltip-arrow::before {
      position: absolute;
      content: "";
      border-color: transparent;
      border-style: solid; }

.bs-tooltip-top .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^="top"] .tooltip-arrow {
  bottom: 0; }
  .bs-tooltip-top .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^="top"] .tooltip-arrow::before {
    top: -1px;
    border-width: var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * .5) 0;
    border-top-color: var(--bs-tooltip-bg); }

/* rtl:begin:ignore */
.bs-tooltip-end .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^="right"] .tooltip-arrow {
  left: 0;
  width: var(--bs-tooltip-arrow-height);
  height: var(--bs-tooltip-arrow-width); }
  .bs-tooltip-end .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^="right"] .tooltip-arrow::before {
    right: -1px;
    border-width: calc(var(--bs-tooltip-arrow-width) * .5) var(--bs-tooltip-arrow-height) calc(var(--bs-tooltip-arrow-width) * .5) 0;
    border-right-color: var(--bs-tooltip-bg); }

/* rtl:end:ignore */
.bs-tooltip-bottom .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^="bottom"] .tooltip-arrow {
  top: 0; }
  .bs-tooltip-bottom .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^="bottom"] .tooltip-arrow::before {
    bottom: -1px;
    border-width: 0 calc(var(--bs-tooltip-arrow-width) * .5) var(--bs-tooltip-arrow-height);
    border-bottom-color: var(--bs-tooltip-bg); }

/* rtl:begin:ignore */
.bs-tooltip-start .tooltip-arrow, .bs-tooltip-auto[data-popper-placement^="left"] .tooltip-arrow {
  right: 0;
  width: var(--bs-tooltip-arrow-height);
  height: var(--bs-tooltip-arrow-width); }
  .bs-tooltip-start .tooltip-arrow::before, .bs-tooltip-auto[data-popper-placement^="left"] .tooltip-arrow::before {
    left: -1px;
    border-width: calc(var(--bs-tooltip-arrow-width) * .5) 0 calc(var(--bs-tooltip-arrow-width) * .5) var(--bs-tooltip-arrow-height);
    border-left-color: var(--bs-tooltip-bg); }

/* rtl:end:ignore */
.tooltip-inner {
  max-width: var(--bs-tooltip-max-width);
  padding: var(--bs-tooltip-padding-y) var(--bs-tooltip-padding-x);
  color: var(--bs-tooltip-color);
  text-align: center;
  background-color: var(--bs-tooltip-bg);
  border-radius: var(--bs-tooltip-border-radius); }

.popover {
  --bs-popover-zindex: 1070;
  --bs-popover-max-width: 276px;
  --bs-popover-font-size: 0.875rem;
  --bs-popover-bg: var(--vz-popover-bg);
  --bs-popover-border-width: 1px;
  --bs-popover-border-color: var(--vz-border-color);
  --bs-popover-border-radius: 0.25rem;
  --bs-popover-inner-border-radius: calc(0.25rem - 1px);
  --bs-popover-box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);
  --bs-popover-header-padding-x: 1rem;
  --bs-popover-header-padding-y: 0.7rem;
  --bs-popover-header-font-size: 1rem;
  --bs-popover-header-color: ;
  --bs-popover-header-bg: var(--vz-popover-bg);
  --bs-popover-body-padding-x: 1rem;
  --bs-popover-body-padding-y: 1rem;
  --bs-popover-body-color: var(--vz-body-color);
  --bs-popover-arrow-width: 1rem;
  --bs-popover-arrow-height: 0.5rem;
  --bs-popover-arrow-border: var(--bs-popover-border-color);
  z-index: var(--bs-popover-zindex);
  display: block;
  max-width: var(--bs-popover-max-width);
  font-family: var(--vz-font-sans-serif);
  font-style: normal;
  font-weight: 400;
  line-height: 1.5;
  text-align: left;
  text-align: start;
  text-decoration: none;
  text-shadow: none;
  text-transform: none;
  letter-spacing: normal;
  word-break: normal;
  white-space: normal;
  word-spacing: normal;
  line-break: auto;
  font-size: var(--bs-popover-font-size);
  word-wrap: break-word;
  background-color: var(--bs-popover-bg);
  background-clip: padding-box;
  border: var(--bs-popover-border-width) solid var(--bs-popover-border-color);
  border-radius: var(--bs-popover-border-radius); }
  .popover .popover-arrow {
    display: block;
    width: var(--bs-popover-arrow-width);
    height: var(--bs-popover-arrow-height); }
    .popover .popover-arrow::before, .popover .popover-arrow::after {
      position: absolute;
      display: block;
      content: "";
      border-color: transparent;
      border-style: solid;
      border-width: 0; }

.bs-popover-top > .popover-arrow, .bs-popover-auto[data-popper-placement^="top"] > .popover-arrow {
  bottom: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width)); }
  .bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^="top"] > .popover-arrow::before, .bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^="top"] > .popover-arrow::after {
    border-width: var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * .5) 0; }
  .bs-popover-top > .popover-arrow::before, .bs-popover-auto[data-popper-placement^="top"] > .popover-arrow::before {
    bottom: 0;
    border-top-color: var(--bs-popover-arrow-border); }
  .bs-popover-top > .popover-arrow::after, .bs-popover-auto[data-popper-placement^="top"] > .popover-arrow::after {
    bottom: var(--bs-popover-border-width);
    border-top-color: var(--bs-popover-bg); }

/* rtl:begin:ignore */
.bs-popover-end > .popover-arrow, .bs-popover-auto[data-popper-placement^="right"] > .popover-arrow {
  left: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
  width: var(--bs-popover-arrow-height);
  height: var(--bs-popover-arrow-width); }
  .bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^="right"] > .popover-arrow::before, .bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^="right"] > .popover-arrow::after {
    border-width: calc(var(--bs-popover-arrow-width) * .5) var(--bs-popover-arrow-height) calc(var(--bs-popover-arrow-width) * .5) 0; }
  .bs-popover-end > .popover-arrow::before, .bs-popover-auto[data-popper-placement^="right"] > .popover-arrow::before {
    left: 0;
    border-right-color: var(--bs-popover-arrow-border); }
  .bs-popover-end > .popover-arrow::after, .bs-popover-auto[data-popper-placement^="right"] > .popover-arrow::after {
    left: var(--bs-popover-border-width);
    border-right-color: var(--bs-popover-bg); }

/* rtl:end:ignore */
.bs-popover-bottom > .popover-arrow, .bs-popover-auto[data-popper-placement^="bottom"] > .popover-arrow {
  top: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width)); }
  .bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^="bottom"] > .popover-arrow::before, .bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^="bottom"] > .popover-arrow::after {
    border-width: 0 calc(var(--bs-popover-arrow-width) * .5) var(--bs-popover-arrow-height); }
  .bs-popover-bottom > .popover-arrow::before, .bs-popover-auto[data-popper-placement^="bottom"] > .popover-arrow::before {
    top: 0;
    border-bottom-color: var(--bs-popover-arrow-border); }
  .bs-popover-bottom > .popover-arrow::after, .bs-popover-auto[data-popper-placement^="bottom"] > .popover-arrow::after {
    top: var(--bs-popover-border-width);
    border-bottom-color: var(--bs-popover-bg); }

.bs-popover-bottom .popover-header::before, .bs-popover-auto[data-popper-placement^="bottom"] .popover-header::before {
  position: absolute;
  top: 0;
  left: 50%;
  display: block;
  width: var(--bs-popover-arrow-width);
  margin-left: calc(-.5 * var(--bs-popover-arrow-width));
  content: "";
  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-header-bg); }

/* rtl:begin:ignore */
.bs-popover-start > .popover-arrow, .bs-popover-auto[data-popper-placement^="left"] > .popover-arrow {
  right: calc(-1 * (var(--bs-popover-arrow-height)) - var(--bs-popover-border-width));
  width: var(--bs-popover-arrow-height);
  height: var(--bs-popover-arrow-width); }
  .bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^="left"] > .popover-arrow::before, .bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^="left"] > .popover-arrow::after {
    border-width: calc(var(--bs-popover-arrow-width) * .5) 0 calc(var(--bs-popover-arrow-width) * .5) var(--bs-popover-arrow-height); }
  .bs-popover-start > .popover-arrow::before, .bs-popover-auto[data-popper-placement^="left"] > .popover-arrow::before {
    right: 0;
    border-left-color: var(--bs-popover-arrow-border); }
  .bs-popover-start > .popover-arrow::after, .bs-popover-auto[data-popper-placement^="left"] > .popover-arrow::after {
    right: var(--bs-popover-border-width);
    border-left-color: var(--bs-popover-bg); }

/* rtl:end:ignore */
.popover-header {
  padding: var(--bs-popover-header-padding-y) var(--bs-popover-header-padding-x);
  margin-bottom: 0;
  font-size: var(--bs-popover-header-font-size);
  color: var(--bs-popover-header-color);
  background-color: var(--bs-popover-header-bg);
  border-bottom: var(--bs-popover-border-width) solid var(--bs-popover-border-color);
  border-top-left-radius: var(--bs-popover-inner-border-radius);
  border-top-right-radius: var(--bs-popover-inner-border-radius); }
  .popover-header:empty {
    display: none; }

.popover-body {
  padding: var(--bs-popover-body-padding-y) var(--bs-popover-body-padding-x);
  color: var(--bs-popover-body-color); }

.carousel {
  position: relative; }

.carousel.pointer-event {
  touch-action: pan-y; }

.carousel-inner {
  position: relative;
  width: 100%;
  overflow: hidden; }
  .carousel-inner::after {
    display: block;
    clear: both;
    content: ""; }

.carousel-item {
  position: relative;
  display: none;
  float: left;
  width: 100%;
  margin-right: -100%;
  backface-visibility: hidden;
  transition: transform 0.6s ease-in-out; }
  @media (prefers-reduced-motion: reduce) {
    .carousel-item {
      transition: none; } }

.carousel-item.active,
.carousel-item-next,
.carousel-item-prev {
  display: block; }

.carousel-item-next:not(.carousel-item-start),
.active.carousel-item-end {
  transform: translateX(100%); }

.carousel-item-prev:not(.carousel-item-end),
.active.carousel-item-start {
  transform: translateX(-100%); }

.carousel-fade .carousel-item {
  opacity: 0;
  transition-property: opacity;
  transform: none; }

.carousel-fade .carousel-item.active,
.carousel-fade .carousel-item-next.carousel-item-start,
.carousel-fade .carousel-item-prev.carousel-item-end {
  z-index: 1;
  opacity: 1; }

.carousel-fade .active.carousel-item-start,
.carousel-fade .active.carousel-item-end {
  z-index: 0;
  opacity: 0;
  transition: opacity 0s 0.6s; }
  @media (prefers-reduced-motion: reduce) {
    .carousel-fade .active.carousel-item-start,
    .carousel-fade .active.carousel-item-end {
      transition: none; } }

.carousel-control-prev,
.carousel-control-next {
  position: absolute;
  top: 0;
  bottom: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15%;
  padding: 0;
  color: #fff;
  text-align: center;
  background: none;
  border: 0;
  opacity: 0.5;
  transition: opacity 0.15s ease; }
  @media (prefers-reduced-motion: reduce) {
    .carousel-control-prev,
    .carousel-control-next {
      transition: none; } }
  .carousel-control-prev:hover, .carousel-control-prev:focus,
  .carousel-control-next:hover,
  .carousel-control-next:focus {
    color: #fff;
    text-decoration: none;
    outline: 0;
    opacity: 0.9; }

.carousel-control-prev {
  left: 0; }

.carousel-control-next {
  right: 0; }

.carousel-control-prev-icon,
.carousel-control-next-icon {
  display: inline-block;
  width: 2rem;
  height: 2rem;
  background-repeat: no-repeat;
  background-position: 50%;
  background-size: 100% 100%; }

/* rtl:options: {
  "autoRename": true,
  "stringMap":[ {
    "name"    : "prev-next",
    "search"  : "prev",
    "replace" : "next"
  } ]
} */
.carousel-control-prev-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_48___}); }

.carousel-control-next-icon {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_49___}); }

.carousel-indicators {
  position: absolute;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 2;
  display: flex;
  justify-content: center;
  padding: 0;
  margin-right: 15%;
  margin-bottom: 1rem;
  margin-left: 15%;
  list-style: none; }
  .carousel-indicators [data-bs-target] {
    box-sizing: content-box;
    flex: 0 1 auto;
    width: 30px;
    height: 3px;
    padding: 0;
    margin-right: 3px;
    margin-left: 3px;
    text-indent: -999px;
    cursor: pointer;
    background-color: #fff;
    background-clip: padding-box;
    border: 0;
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent;
    opacity: 0.5;
    transition: opacity 0.6s ease; }
    @media (prefers-reduced-motion: reduce) {
      .carousel-indicators [data-bs-target] {
        transition: none; } }
  .carousel-indicators .active {
    opacity: 1; }

.carousel-caption {
  position: absolute;
  right: 15%;
  bottom: 1.25rem;
  left: 15%;
  padding-top: 1.25rem;
  padding-bottom: 1.25rem;
  color: #fff;
  text-align: center; }

.carousel-dark .carousel-control-prev-icon,
.carousel-dark .carousel-control-next-icon {
  filter: invert(1) grayscale(100); }

.carousel-dark .carousel-indicators [data-bs-target] {
  background-color: #000; }

.carousel-dark .carousel-caption {
  color: #000; }

.spinner-grow,
.spinner-border {
  display: inline-block;
  width: var(--bs-spinner-width);
  height: var(--bs-spinner-height);
  vertical-align: var(--bs-spinner-vertical-align);
  border-radius: 50%;
  animation: var(--bs-spinner-animation-speed) linear infinite var(--bs-spinner-animation-name); }

@keyframes spinner-border {
  to {
    transform: rotate(360deg) /* rtl:ignore */; } }

.spinner-border {
  --bs-spinner-width: 2rem;
  --bs-spinner-height: 2rem;
  --bs-spinner-vertical-align: -0.125em;
  --bs-spinner-border-width: 0.25em;
  --bs-spinner-animation-speed: 0.75s;
  --bs-spinner-animation-name: spinner-border;
  border: var(--bs-spinner-border-width) solid currentcolor;
  border-right-color: transparent; }

.spinner-border-sm {
  --bs-spinner-width: 1rem;
  --bs-spinner-height: 1rem;
  --bs-spinner-border-width: 0.2em; }

@keyframes spinner-grow {
  0% {
    transform: scale(0); }
  50% {
    opacity: 1;
    transform: none; } }

.spinner-grow {
  --bs-spinner-width: 2rem;
  --bs-spinner-height: 2rem;
  --bs-spinner-vertical-align: -0.125em;
  --bs-spinner-animation-speed: 0.75s;
  --bs-spinner-animation-name: spinner-grow;
  background-color: currentcolor;
  opacity: 0; }

.spinner-grow-sm {
  --bs-spinner-width: 1rem;
  --bs-spinner-height: 1rem; }

@media (prefers-reduced-motion: reduce) {
  .spinner-border,
  .spinner-grow {
    --bs-spinner-animation-speed: 1.5s; } }

.offcanvas-sm, .offcanvas-md, .offcanvas-lg, .offcanvas-xl, .offcanvas-xxl, .offcanvas {
  --bs-offcanvas-zindex: 1045;
  --bs-offcanvas-width: 400px;
  --bs-offcanvas-height: 30vh;
  --bs-offcanvas-padding-x: 1.25rem;
  --bs-offcanvas-padding-y: 1.25rem;
  --bs-offcanvas-color: ;
  --bs-offcanvas-bg: var(--vz-modal-bg);
  --bs-offcanvas-border-width: 1px;
  --bs-offcanvas-border-color: var(--vz-border-color);
  --bs-offcanvas-box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075); }

@media (max-width: 575.98px) {
  .offcanvas-sm {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: transform 0.3s ease-in-out; } }
  @media (max-width: 575.98px) and (prefers-reduced-motion: reduce) {
    .offcanvas-sm {
      transition: none; } }

@media (max-width: 575.98px) {
    .offcanvas-sm.offcanvas-start {
      top: 0;
      left: 0;
      width: var(--bs-offcanvas-width);
      border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
      transform: translateX(-100%); }
    .offcanvas-sm.offcanvas-end {
      top: 0;
      right: 0;
      width: var(--bs-offcanvas-width);
      border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
      transform: translateX(100%); }
    .offcanvas-sm.offcanvas-top {
      top: 0;
      right: 0;
      left: 0;
      height: var(--bs-offcanvas-height);
      max-height: 100%;
      border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
      transform: translateY(-100%); }
    .offcanvas-sm.offcanvas-bottom {
      right: 0;
      left: 0;
      height: var(--bs-offcanvas-height);
      max-height: 100%;
      border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
      transform: translateY(100%); }
    .offcanvas-sm.showing, .offcanvas-sm.show:not(.hiding) {
      transform: none; }
    .offcanvas-sm.showing, .offcanvas-sm.hiding, .offcanvas-sm.show {
      visibility: visible; } }

@media (min-width: 576px) {
  .offcanvas-sm {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important; }
    .offcanvas-sm .offcanvas-header {
      display: none; }
    .offcanvas-sm .offcanvas-body {
      display: flex;
      flex-grow: 0;
      padding: 0;
      overflow-y: visible;
      background-color: transparent !important; } }

@media (max-width: 767.98px) {
  .offcanvas-md {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: transform 0.3s ease-in-out; } }
  @media (max-width: 767.98px) and (prefers-reduced-motion: reduce) {
    .offcanvas-md {
      transition: none; } }

@media (max-width: 767.98px) {
    .offcanvas-md.offcanvas-start {
      top: 0;
      left: 0;
      width: var(--bs-offcanvas-width);
      border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
      transform: translateX(-100%); }
    .offcanvas-md.offcanvas-end {
      top: 0;
      right: 0;
      width: var(--bs-offcanvas-width);
      border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
      transform: translateX(100%); }
    .offcanvas-md.offcanvas-top {
      top: 0;
      right: 0;
      left: 0;
      height: var(--bs-offcanvas-height);
      max-height: 100%;
      border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
      transform: translateY(-100%); }
    .offcanvas-md.offcanvas-bottom {
      right: 0;
      left: 0;
      height: var(--bs-offcanvas-height);
      max-height: 100%;
      border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
      transform: translateY(100%); }
    .offcanvas-md.showing, .offcanvas-md.show:not(.hiding) {
      transform: none; }
    .offcanvas-md.showing, .offcanvas-md.hiding, .offcanvas-md.show {
      visibility: visible; } }

@media (min-width: 768px) {
  .offcanvas-md {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important; }
    .offcanvas-md .offcanvas-header {
      display: none; }
    .offcanvas-md .offcanvas-body {
      display: flex;
      flex-grow: 0;
      padding: 0;
      overflow-y: visible;
      background-color: transparent !important; } }

@media (max-width: 991.98px) {
  .offcanvas-lg {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: transform 0.3s ease-in-out; } }
  @media (max-width: 991.98px) and (prefers-reduced-motion: reduce) {
    .offcanvas-lg {
      transition: none; } }

@media (max-width: 991.98px) {
    .offcanvas-lg.offcanvas-start {
      top: 0;
      left: 0;
      width: var(--bs-offcanvas-width);
      border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
      transform: translateX(-100%); }
    .offcanvas-lg.offcanvas-end {
      top: 0;
      right: 0;
      width: var(--bs-offcanvas-width);
      border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
      transform: translateX(100%); }
    .offcanvas-lg.offcanvas-top {
      top: 0;
      right: 0;
      left: 0;
      height: var(--bs-offcanvas-height);
      max-height: 100%;
      border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
      transform: translateY(-100%); }
    .offcanvas-lg.offcanvas-bottom {
      right: 0;
      left: 0;
      height: var(--bs-offcanvas-height);
      max-height: 100%;
      border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
      transform: translateY(100%); }
    .offcanvas-lg.showing, .offcanvas-lg.show:not(.hiding) {
      transform: none; }
    .offcanvas-lg.showing, .offcanvas-lg.hiding, .offcanvas-lg.show {
      visibility: visible; } }

@media (min-width: 992px) {
  .offcanvas-lg {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important; }
    .offcanvas-lg .offcanvas-header {
      display: none; }
    .offcanvas-lg .offcanvas-body {
      display: flex;
      flex-grow: 0;
      padding: 0;
      overflow-y: visible;
      background-color: transparent !important; } }

@media (max-width: 1199.98px) {
  .offcanvas-xl {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: transform 0.3s ease-in-out; } }
  @media (max-width: 1199.98px) and (prefers-reduced-motion: reduce) {
    .offcanvas-xl {
      transition: none; } }

@media (max-width: 1199.98px) {
    .offcanvas-xl.offcanvas-start {
      top: 0;
      left: 0;
      width: var(--bs-offcanvas-width);
      border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
      transform: translateX(-100%); }
    .offcanvas-xl.offcanvas-end {
      top: 0;
      right: 0;
      width: var(--bs-offcanvas-width);
      border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
      transform: translateX(100%); }
    .offcanvas-xl.offcanvas-top {
      top: 0;
      right: 0;
      left: 0;
      height: var(--bs-offcanvas-height);
      max-height: 100%;
      border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
      transform: translateY(-100%); }
    .offcanvas-xl.offcanvas-bottom {
      right: 0;
      left: 0;
      height: var(--bs-offcanvas-height);
      max-height: 100%;
      border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
      transform: translateY(100%); }
    .offcanvas-xl.showing, .offcanvas-xl.show:not(.hiding) {
      transform: none; }
    .offcanvas-xl.showing, .offcanvas-xl.hiding, .offcanvas-xl.show {
      visibility: visible; } }

@media (min-width: 1200px) {
  .offcanvas-xl {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important; }
    .offcanvas-xl .offcanvas-header {
      display: none; }
    .offcanvas-xl .offcanvas-body {
      display: flex;
      flex-grow: 0;
      padding: 0;
      overflow-y: visible;
      background-color: transparent !important; } }

@media (max-width: 1399.98px) {
  .offcanvas-xxl {
    position: fixed;
    bottom: 0;
    z-index: var(--bs-offcanvas-zindex);
    display: flex;
    flex-direction: column;
    max-width: 100%;
    color: var(--bs-offcanvas-color);
    visibility: hidden;
    background-color: var(--bs-offcanvas-bg);
    background-clip: padding-box;
    outline: 0;
    transition: transform 0.3s ease-in-out; } }
  @media (max-width: 1399.98px) and (prefers-reduced-motion: reduce) {
    .offcanvas-xxl {
      transition: none; } }

@media (max-width: 1399.98px) {
    .offcanvas-xxl.offcanvas-start {
      top: 0;
      left: 0;
      width: var(--bs-offcanvas-width);
      border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
      transform: translateX(-100%); }
    .offcanvas-xxl.offcanvas-end {
      top: 0;
      right: 0;
      width: var(--bs-offcanvas-width);
      border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
      transform: translateX(100%); }
    .offcanvas-xxl.offcanvas-top {
      top: 0;
      right: 0;
      left: 0;
      height: var(--bs-offcanvas-height);
      max-height: 100%;
      border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
      transform: translateY(-100%); }
    .offcanvas-xxl.offcanvas-bottom {
      right: 0;
      left: 0;
      height: var(--bs-offcanvas-height);
      max-height: 100%;
      border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
      transform: translateY(100%); }
    .offcanvas-xxl.showing, .offcanvas-xxl.show:not(.hiding) {
      transform: none; }
    .offcanvas-xxl.showing, .offcanvas-xxl.hiding, .offcanvas-xxl.show {
      visibility: visible; } }

@media (min-width: 1400px) {
  .offcanvas-xxl {
    --bs-offcanvas-height: auto;
    --bs-offcanvas-border-width: 0;
    background-color: transparent !important; }
    .offcanvas-xxl .offcanvas-header {
      display: none; }
    .offcanvas-xxl .offcanvas-body {
      display: flex;
      flex-grow: 0;
      padding: 0;
      overflow-y: visible;
      background-color: transparent !important; } }

.offcanvas {
  position: fixed;
  bottom: 0;
  z-index: var(--bs-offcanvas-zindex);
  display: flex;
  flex-direction: column;
  max-width: 100%;
  color: var(--bs-offcanvas-color);
  visibility: hidden;
  background-color: var(--bs-offcanvas-bg);
  background-clip: padding-box;
  outline: 0;
  transition: transform 0.3s ease-in-out; }
  @media (prefers-reduced-motion: reduce) {
    .offcanvas {
      transition: none; } }
  .offcanvas.offcanvas-start {
    top: 0;
    left: 0;
    width: var(--bs-offcanvas-width);
    border-right: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(-100%); }
  .offcanvas.offcanvas-end {
    top: 0;
    right: 0;
    width: var(--bs-offcanvas-width);
    border-left: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateX(100%); }
  .offcanvas.offcanvas-top {
    top: 0;
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-bottom: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(-100%); }
  .offcanvas.offcanvas-bottom {
    right: 0;
    left: 0;
    height: var(--bs-offcanvas-height);
    max-height: 100%;
    border-top: var(--bs-offcanvas-border-width) solid var(--bs-offcanvas-border-color);
    transform: translateY(100%); }
  .offcanvas.showing, .offcanvas.show:not(.hiding) {
    transform: none; }
  .offcanvas.showing, .offcanvas.hiding, .offcanvas.show {
    visibility: visible; }

.offcanvas-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1040;
  width: 100vw;
  height: 100vh;
  background-color: #000; }
  .offcanvas-backdrop.fade {
    opacity: 0; }
  .offcanvas-backdrop.show {
    opacity: 0.5; }

.offcanvas-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x); }
  .offcanvas-header .btn-close {
    padding: calc(var(--bs-offcanvas-padding-y) * .5) calc(var(--bs-offcanvas-padding-x) * .5);
    margin-top: calc(-.5 * var(--bs-offcanvas-padding-y));
    margin-right: calc(-.5 * var(--bs-offcanvas-padding-x));
    margin-bottom: calc(-.5 * var(--bs-offcanvas-padding-y)); }

.offcanvas-title {
  margin-bottom: 0;
  line-height: 1.5; }

.offcanvas-body {
  flex-grow: 1;
  padding: var(--bs-offcanvas-padding-y) var(--bs-offcanvas-padding-x);
  overflow-y: auto; }

.placeholder {
  display: inline-block;
  min-height: 1em;
  vertical-align: middle;
  cursor: wait;
  background-color: currentcolor;
  opacity: 0.5; }
  .placeholder.btn::before {
    display: inline-block;
    content: ""; }

.placeholder-xs {
  min-height: .6em; }

.placeholder-sm {
  min-height: .8em; }

.placeholder-lg {
  min-height: 1.2em; }

.placeholder-glow .placeholder {
  animation: placeholder-glow 2s ease-in-out infinite; }

@keyframes placeholder-glow {
  50% {
    opacity: 0.2; } }

.placeholder-wave {
  -webkit-mask-image: linear-gradient(130deg, #000 55%, rgba(0, 0, 0, 0.8) 75%, #000 95%);
          mask-image: linear-gradient(130deg, #000 55%, rgba(0, 0, 0, 0.8) 75%, #000 95%);
  -webkit-mask-size: 200% 100%;
          mask-size: 200% 100%;
  animation: placeholder-wave 2s linear infinite; }

@keyframes placeholder-wave {
  100% {
    -webkit-mask-position: -200% 0%;
            mask-position: -200% 0%; } }

.clearfix::after {
  display: block;
  clear: both;
  content: ""; }

.text-bg-primary {
  color: #fff !important;
  background-color: RGBA(94, 163, 203, var(--bs-bg-opacity, 1)) !important; }

.text-bg-secondary {
  color: #fff !important;
  background-color: RGBA(112, 132, 199, var(--bs-bg-opacity, 1)) !important; }

.text-bg-success {
  color: #fff !important;
  background-color: RGBA(49, 151, 149, var(--bs-bg-opacity, 1)) !important; }

.text-bg-info {
  color: #fff !important;
  background-color: RGBA(88, 202, 234, var(--bs-bg-opacity, 1)) !important; }

.text-bg-warning {
  color: #fff !important;
  background-color: RGBA(247, 184, 75, var(--bs-bg-opacity, 1)) !important; }

.text-bg-danger {
  color: #fff !important;
  background-color: RGBA(229, 62, 62, var(--bs-bg-opacity, 1)) !important; }

.text-bg-light {
  color: #000 !important;
  background-color: RGBA(243, 246, 249, var(--bs-bg-opacity, 1)) !important; }

.text-bg-dark {
  color: #fff !important;
  background-color: RGBA(33, 37, 41, var(--bs-bg-opacity, 1)) !important; }

.link-primary {
  color: #5ea3cb !important; }
  .link-primary:hover, .link-primary:focus {
    color: #4b82a2 !important; }

.link-secondary {
  color: #7084c7 !important; }
  .link-secondary:hover, .link-secondary:focus {
    color: #5a6a9f !important; }

.link-success {
  color: #319795 !important; }
  .link-success:hover, .link-success:focus {
    color: #277977 !important; }

.link-info {
  color: #58caea !important; }
  .link-info:hover, .link-info:focus {
    color: #46a2bb !important; }

.link-warning {
  color: #f7b84b !important; }
  .link-warning:hover, .link-warning:focus {
    color: #c6933c !important; }

.link-danger {
  color: #E53E3E !important; }
  .link-danger:hover, .link-danger:focus {
    color: #b73232 !important; }

.link-light {
  color: #f3f6f9 !important; }
  .link-light:hover, .link-light:focus {
    color: #f5f8fa !important; }

.link-dark {
  color: #212529 !important; }
  .link-dark:hover, .link-dark:focus {
    color: #1a1e21 !important; }

.ratio {
  position: relative;
  width: 100%; }
  .ratio::before {
    display: block;
    padding-top: var(--bs-aspect-ratio);
    content: ""; }
  .ratio > * {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%; }

.ratio-1x1 {
  --bs-aspect-ratio: 100%; }

.ratio-4x3 {
  --bs-aspect-ratio: calc(3 / 4 * 100%); }

.ratio-16x9 {
  --bs-aspect-ratio: calc(9 / 16 * 100%); }

.ratio-21x9 {
  --bs-aspect-ratio: calc(9 / 21 * 100%); }

.fixed-top {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1030; }

.fixed-bottom {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1030; }

.sticky-top {
  position: sticky;
  top: 0;
  z-index: 1020; }

.sticky-bottom {
  position: sticky;
  bottom: 0;
  z-index: 1020; }

@media (min-width: 576px) {
  .sticky-sm-top {
    position: sticky;
    top: 0;
    z-index: 1020; }
  .sticky-sm-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020; } }

@media (min-width: 768px) {
  .sticky-md-top {
    position: sticky;
    top: 0;
    z-index: 1020; }
  .sticky-md-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020; } }

@media (min-width: 992px) {
  .sticky-lg-top {
    position: sticky;
    top: 0;
    z-index: 1020; }
  .sticky-lg-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020; } }

@media (min-width: 1200px) {
  .sticky-xl-top {
    position: sticky;
    top: 0;
    z-index: 1020; }
  .sticky-xl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020; } }

@media (min-width: 1400px) {
  .sticky-xxl-top {
    position: sticky;
    top: 0;
    z-index: 1020; }
  .sticky-xxl-bottom {
    position: sticky;
    bottom: 0;
    z-index: 1020; } }

.hstack {
  display: flex;
  flex-direction: row;
  align-items: center;
  align-self: stretch; }

.vstack {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  align-self: stretch; }

.visually-hidden,
.visually-hidden-focusable:not(:focus):not(:focus-within) {
  position: absolute !important;
  width: 1px !important;
  height: 1px !important;
  padding: 0 !important;
  margin: -1px !important;
  overflow: hidden !important;
  clip: rect(0, 0, 0, 0) !important;
  white-space: nowrap !important;
  border: 0 !important; }

.stretched-link::after {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1;
  content: ""; }

.text-truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap; }

.vr {
  display: inline-block;
  align-self: stretch;
  width: 1px;
  min-height: 1em;
  background-color: currentcolor;
  opacity: 0.25; }

.align-baseline {
  vertical-align: baseline !important; }

.align-top {
  vertical-align: top !important; }

.align-middle {
  vertical-align: middle !important; }

.align-bottom {
  vertical-align: bottom !important; }

.align-text-bottom {
  vertical-align: text-bottom !important; }

.align-text-top {
  vertical-align: text-top !important; }

.float-start {
  float: left !important; }

.float-end {
  float: right !important; }

.float-none {
  float: none !important; }

.opacity-0 {
  opacity: 0 !important; }

.opacity-25 {
  opacity: 0.25 !important; }

.opacity-50 {
  opacity: 0.5 !important; }

.opacity-75 {
  opacity: 0.75 !important; }

.opacity-100 {
  opacity: 1 !important; }

.overflow-auto {
  overflow: auto !important; }

.overflow-hidden {
  overflow: hidden !important; }

.overflow-visible {
  overflow: visible !important; }

.overflow-scroll {
  overflow: scroll !important; }

.d-inline {
  display: inline !important; }

.d-inline-block {
  display: inline-block !important; }

.d-block {
  display: block !important; }

.d-grid {
  display: grid !important; }

.d-table {
  display: table !important; }

.d-table-row {
  display: table-row !important; }

.d-table-cell {
  display: table-cell !important; }

.d-flex {
  display: flex !important; }

.d-inline-flex {
  display: inline-flex !important; }

.d-none {
  display: none !important; }

.shadow {
  box-shadow: 0 1px 2px rgba(56, 65, 74, 0.15) !important; }

.shadow-sm {
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important; }

.shadow-lg {
  box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12) !important; }

.shadow-none {
  box-shadow: none !important; }

.position-static {
  position: static !important; }

.position-relative {
  position: relative !important; }

.position-absolute {
  position: absolute !important; }

.position-fixed {
  position: fixed !important; }

.position-sticky {
  position: sticky !important; }

.top-0 {
  top: 0 !important; }

.top-50 {
  top: 50% !important; }

.top-100 {
  top: 100% !important; }

.bottom-0 {
  bottom: 0 !important; }

.bottom-50 {
  bottom: 50% !important; }

.bottom-100 {
  bottom: 100% !important; }

.start-0 {
  left: 0 !important; }

.start-50 {
  left: 50% !important; }

.start-100 {
  left: 100% !important; }

.end-0 {
  right: 0 !important; }

.end-50 {
  right: 50% !important; }

.end-100 {
  right: 100% !important; }

.translate-middle {
  transform: translate(-50%, -50%) !important; }

.translate-middle-x {
  transform: translateX(-50%) !important; }

.translate-middle-y {
  transform: translateY(-50%) !important; }

.border {
  border: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important; }

.border-0 {
  border: 0 !important; }

.border-top {
  border-top: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important; }

.border-top-0 {
  border-top: 0 !important; }

.border-end {
  border-right: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important; }

.border-end-0 {
  border-right: 0 !important; }

.border-bottom {
  border-bottom: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important; }

.border-bottom-0 {
  border-bottom: 0 !important; }

.border-start {
  border-left: var(--bs-border-width) var(--bs-border-style) var(--bs-border-color) !important; }

.border-start-0 {
  border-left: 0 !important; }

.border-primary {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-primary-rgb), var(--bs-border-opacity)) !important; }

.border-secondary {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-secondary-rgb), var(--bs-border-opacity)) !important; }

.border-success {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-success-rgb), var(--bs-border-opacity)) !important; }

.border-info {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-info-rgb), var(--bs-border-opacity)) !important; }

.border-warning {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-warning-rgb), var(--bs-border-opacity)) !important; }

.border-danger {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-danger-rgb), var(--bs-border-opacity)) !important; }

.border-light {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-light-rgb), var(--bs-border-opacity)) !important; }

.border-dark {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-dark-rgb), var(--bs-border-opacity)) !important; }

.border-white {
  --bs-border-opacity: 1;
  border-color: rgba(var(--bs-white-rgb), var(--bs-border-opacity)) !important; }

.border-1 {
  --bs-border-width: 1px; }

.border-2 {
  --bs-border-width: 2px; }

.border-3 {
  --bs-border-width: 3px; }

.border-4 {
  --bs-border-width: 4px; }

.border-5 {
  --bs-border-width: 5px; }

.border-opacity-10 {
  --bs-border-opacity: 0.1; }

.border-opacity-25 {
  --bs-border-opacity: 0.25; }

.border-opacity-50 {
  --bs-border-opacity: 0.5; }

.border-opacity-75 {
  --bs-border-opacity: 0.75; }

.border-opacity-100 {
  --bs-border-opacity: 1; }

.w-25 {
  width: 25% !important; }

.w-50 {
  width: 50% !important; }

.w-75 {
  width: 75% !important; }

.w-100 {
  width: 100% !important; }

.w-auto {
  width: auto !important; }

.mw-100 {
  max-width: 100% !important; }

.vw-100 {
  width: 100vw !important; }

.min-vw-100 {
  min-width: 100vw !important; }

.h-25 {
  height: 25% !important; }

.h-50 {
  height: 50% !important; }

.h-75 {
  height: 75% !important; }

.h-100 {
  height: 100% !important; }

.h-auto {
  height: auto !important; }

.mh-100 {
  max-height: 100% !important; }

.vh-100 {
  height: 100vh !important; }

.min-vh-100 {
  min-height: 100vh !important; }

.flex-fill {
  flex: 1 1 auto !important; }

.flex-row {
  flex-direction: row !important; }

.flex-column {
  flex-direction: column !important; }

.flex-row-reverse {
  flex-direction: row-reverse !important; }

.flex-column-reverse {
  flex-direction: column-reverse !important; }

.flex-grow-0 {
  flex-grow: 0 !important; }

.flex-grow-1 {
  flex-grow: 1 !important; }

.flex-shrink-0 {
  flex-shrink: 0 !important; }

.flex-shrink-1 {
  flex-shrink: 1 !important; }

.flex-wrap {
  flex-wrap: wrap !important; }

.flex-nowrap {
  flex-wrap: nowrap !important; }

.flex-wrap-reverse {
  flex-wrap: wrap-reverse !important; }

.justify-content-start {
  justify-content: flex-start !important; }

.justify-content-end {
  justify-content: flex-end !important; }

.justify-content-center {
  justify-content: center !important; }

.justify-content-between {
  justify-content: space-between !important; }

.justify-content-around {
  justify-content: space-around !important; }

.justify-content-evenly {
  justify-content: space-evenly !important; }

.align-items-start {
  align-items: flex-start !important; }

.align-items-end {
  align-items: flex-end !important; }

.align-items-center {
  align-items: center !important; }

.align-items-baseline {
  align-items: baseline !important; }

.align-items-stretch {
  align-items: stretch !important; }

.align-content-start {
  align-content: flex-start !important; }

.align-content-end {
  align-content: flex-end !important; }

.align-content-center {
  align-content: center !important; }

.align-content-between {
  align-content: space-between !important; }

.align-content-around {
  align-content: space-around !important; }

.align-content-stretch {
  align-content: stretch !important; }

.align-self-auto {
  align-self: auto !important; }

.align-self-start {
  align-self: flex-start !important; }

.align-self-end {
  align-self: flex-end !important; }

.align-self-center {
  align-self: center !important; }

.align-self-baseline {
  align-self: baseline !important; }

.align-self-stretch {
  align-self: stretch !important; }

.order-first {
  order: -1 !important; }

.order-0 {
  order: 0 !important; }

.order-1 {
  order: 1 !important; }

.order-2 {
  order: 2 !important; }

.order-3 {
  order: 3 !important; }

.order-4 {
  order: 4 !important; }

.order-5 {
  order: 5 !important; }

.order-last {
  order: 6 !important; }

.m-0 {
  margin: 0 !important; }

.m-1 {
  margin: 0.25rem !important; }

.m-2 {
  margin: 0.5rem !important; }

.m-3 {
  margin: 1rem !important; }

.m-4 {
  margin: 1.5rem !important; }

.m-5 {
  margin: 3rem !important; }

.m-auto {
  margin: auto !important; }

.mx-0 {
  margin-right: 0 !important;
  margin-left: 0 !important; }

.mx-1 {
  margin-right: 0.25rem !important;
  margin-left: 0.25rem !important; }

.mx-2 {
  margin-right: 0.5rem !important;
  margin-left: 0.5rem !important; }

.mx-3 {
  margin-right: 1rem !important;
  margin-left: 1rem !important; }

.mx-4 {
  margin-right: 1.5rem !important;
  margin-left: 1.5rem !important; }

.mx-5 {
  margin-right: 3rem !important;
  margin-left: 3rem !important; }

.mx-auto {
  margin-right: auto !important;
  margin-left: auto !important; }

.my-0 {
  margin-top: 0 !important;
  margin-bottom: 0 !important; }

.my-1 {
  margin-top: 0.25rem !important;
  margin-bottom: 0.25rem !important; }

.my-2 {
  margin-top: 0.5rem !important;
  margin-bottom: 0.5rem !important; }

.my-3 {
  margin-top: 1rem !important;
  margin-bottom: 1rem !important; }

.my-4 {
  margin-top: 1.5rem !important;
  margin-bottom: 1.5rem !important; }

.my-5 {
  margin-top: 3rem !important;
  margin-bottom: 3rem !important; }

.my-auto {
  margin-top: auto !important;
  margin-bottom: auto !important; }

.mt-0 {
  margin-top: 0 !important; }

.mt-1 {
  margin-top: 0.25rem !important; }

.mt-2 {
  margin-top: 0.5rem !important; }

.mt-3 {
  margin-top: 1rem !important; }

.mt-4 {
  margin-top: 1.5rem !important; }

.mt-5 {
  margin-top: 3rem !important; }

.mt-auto {
  margin-top: auto !important; }

.me-0 {
  margin-right: 0 !important; }

.me-1 {
  margin-right: 0.25rem !important; }

.me-2 {
  margin-right: 0.5rem !important; }

.me-3 {
  margin-right: 1rem !important; }

.me-4 {
  margin-right: 1.5rem !important; }

.me-5 {
  margin-right: 3rem !important; }

.me-auto {
  margin-right: auto !important; }

.mb-0 {
  margin-bottom: 0 !important; }

.mb-1 {
  margin-bottom: 0.25rem !important; }

.mb-2 {
  margin-bottom: 0.5rem !important; }

.mb-3 {
  margin-bottom: 1rem !important; }

.mb-4 {
  margin-bottom: 1.5rem !important; }

.mb-5 {
  margin-bottom: 3rem !important; }

.mb-auto {
  margin-bottom: auto !important; }

.ms-0 {
  margin-left: 0 !important; }

.ms-1 {
  margin-left: 0.25rem !important; }

.ms-2 {
  margin-left: 0.5rem !important; }

.ms-3 {
  margin-left: 1rem !important; }

.ms-4 {
  margin-left: 1.5rem !important; }

.ms-5 {
  margin-left: 3rem !important; }

.ms-auto {
  margin-left: auto !important; }

.m-n1 {
  margin: -0.25rem !important; }

.m-n2 {
  margin: -0.5rem !important; }

.m-n3 {
  margin: -1rem !important; }

.m-n4 {
  margin: -1.5rem !important; }

.m-n5 {
  margin: -3rem !important; }

.mx-n1 {
  margin-right: -0.25rem !important;
  margin-left: -0.25rem !important; }

.mx-n2 {
  margin-right: -0.5rem !important;
  margin-left: -0.5rem !important; }

.mx-n3 {
  margin-right: -1rem !important;
  margin-left: -1rem !important; }

.mx-n4 {
  margin-right: -1.5rem !important;
  margin-left: -1.5rem !important; }

.mx-n5 {
  margin-right: -3rem !important;
  margin-left: -3rem !important; }

.my-n1 {
  margin-top: -0.25rem !important;
  margin-bottom: -0.25rem !important; }

.my-n2 {
  margin-top: -0.5rem !important;
  margin-bottom: -0.5rem !important; }

.my-n3 {
  margin-top: -1rem !important;
  margin-bottom: -1rem !important; }

.my-n4 {
  margin-top: -1.5rem !important;
  margin-bottom: -1.5rem !important; }

.my-n5 {
  margin-top: -3rem !important;
  margin-bottom: -3rem !important; }

.mt-n1 {
  margin-top: -0.25rem !important; }

.mt-n2 {
  margin-top: -0.5rem !important; }

.mt-n3 {
  margin-top: -1rem !important; }

.mt-n4 {
  margin-top: -1.5rem !important; }

.mt-n5 {
  margin-top: -3rem !important; }

.me-n1 {
  margin-right: -0.25rem !important; }

.me-n2 {
  margin-right: -0.5rem !important; }

.me-n3 {
  margin-right: -1rem !important; }

.me-n4 {
  margin-right: -1.5rem !important; }

.me-n5 {
  margin-right: -3rem !important; }

.mb-n1 {
  margin-bottom: -0.25rem !important; }

.mb-n2 {
  margin-bottom: -0.5rem !important; }

.mb-n3 {
  margin-bottom: -1rem !important; }

.mb-n4 {
  margin-bottom: -1.5rem !important; }

.mb-n5 {
  margin-bottom: -3rem !important; }

.ms-n1 {
  margin-left: -0.25rem !important; }

.ms-n2 {
  margin-left: -0.5rem !important; }

.ms-n3 {
  margin-left: -1rem !important; }

.ms-n4 {
  margin-left: -1.5rem !important; }

.ms-n5 {
  margin-left: -3rem !important; }

.p-0 {
  padding: 0 !important; }

.p-1 {
  padding: 0.25rem !important; }

.p-2 {
  padding: 0.5rem !important; }

.p-3 {
  padding: 1rem !important; }

.p-4 {
  padding: 1.5rem !important; }

.p-5 {
  padding: 3rem !important; }

.px-0 {
  padding-right: 0 !important;
  padding-left: 0 !important; }

.px-1 {
  padding-right: 0.25rem !important;
  padding-left: 0.25rem !important; }

.px-2 {
  padding-right: 0.5rem !important;
  padding-left: 0.5rem !important; }

.px-3 {
  padding-right: 1rem !important;
  padding-left: 1rem !important; }

.px-4 {
  padding-right: 1.5rem !important;
  padding-left: 1.5rem !important; }

.px-5 {
  padding-right: 3rem !important;
  padding-left: 3rem !important; }

.py-0 {
  padding-top: 0 !important;
  padding-bottom: 0 !important; }

.py-1 {
  padding-top: 0.25rem !important;
  padding-bottom: 0.25rem !important; }

.py-2 {
  padding-top: 0.5rem !important;
  padding-bottom: 0.5rem !important; }

.py-3 {
  padding-top: 1rem !important;
  padding-bottom: 1rem !important; }

.py-4 {
  padding-top: 1.5rem !important;
  padding-bottom: 1.5rem !important; }

.py-5 {
  padding-top: 3rem !important;
  padding-bottom: 3rem !important; }

.pt-0 {
  padding-top: 0 !important; }

.pt-1 {
  padding-top: 0.25rem !important; }

.pt-2 {
  padding-top: 0.5rem !important; }

.pt-3 {
  padding-top: 1rem !important; }

.pt-4 {
  padding-top: 1.5rem !important; }

.pt-5 {
  padding-top: 3rem !important; }

.pe-0 {
  padding-right: 0 !important; }

.pe-1 {
  padding-right: 0.25rem !important; }

.pe-2 {
  padding-right: 0.5rem !important; }

.pe-3 {
  padding-right: 1rem !important; }

.pe-4 {
  padding-right: 1.5rem !important; }

.pe-5 {
  padding-right: 3rem !important; }

.pb-0 {
  padding-bottom: 0 !important; }

.pb-1 {
  padding-bottom: 0.25rem !important; }

.pb-2 {
  padding-bottom: 0.5rem !important; }

.pb-3 {
  padding-bottom: 1rem !important; }

.pb-4 {
  padding-bottom: 1.5rem !important; }

.pb-5 {
  padding-bottom: 3rem !important; }

.ps-0 {
  padding-left: 0 !important; }

.ps-1 {
  padding-left: 0.25rem !important; }

.ps-2 {
  padding-left: 0.5rem !important; }

.ps-3 {
  padding-left: 1rem !important; }

.ps-4 {
  padding-left: 1.5rem !important; }

.ps-5 {
  padding-left: 3rem !important; }

.gap-0 {
  gap: 0 !important; }

.gap-1 {
  gap: 0.25rem !important; }

.gap-2 {
  gap: 0.5rem !important; }

.gap-3 {
  gap: 1rem !important; }

.gap-4 {
  gap: 1.5rem !important; }

.gap-5 {
  gap: 3rem !important; }

.font-monospace {
  font-family: var(--bs-font-monospace) !important; }

.fs-1 {
  font-size: calc(1.34375rem + 1.125vw) !important; }

.fs-2 {
  font-size: calc(1.3rem + 0.6vw) !important; }

.fs-3 {
  font-size: calc(1.27813rem + 0.3375vw) !important; }

.fs-4 {
  font-size: calc(1.25625rem + 0.075vw) !important; }

.fs-5 {
  font-size: 1.09375rem !important; }

.fs-6 {
  font-size: 0.875rem !important; }

.fst-italic {
  font-style: italic !important; }

.fst-normal {
  font-style: normal !important; }

.fw-light {
  font-weight: 300 !important; }

.fw-lighter {
  font-weight: lighter !important; }

.fw-normal {
  font-weight: 400 !important; }

.fw-bold {
  font-weight: 700 !important; }

.fw-semibold {
  font-weight: 600 !important; }

.fw-bolder {
  font-weight: bolder !important; }

.lh-1 {
  line-height: 1 !important; }

.lh-sm {
  line-height: 1.25 !important; }

.lh-base {
  line-height: 1.5 !important; }

.lh-lg {
  line-height: 2 !important; }

.text-start {
  text-align: left !important; }

.text-end {
  text-align: right !important; }

.text-center {
  text-align: center !important; }

.text-decoration-none {
  text-decoration: none !important; }

.text-decoration-underline {
  text-decoration: underline !important; }

.text-decoration-line-through {
  text-decoration: line-through !important; }

.text-lowercase {
  text-transform: lowercase !important; }

.text-uppercase {
  text-transform: uppercase !important; }

.text-capitalize {
  text-transform: capitalize !important; }

.text-wrap {
  white-space: normal !important; }

.text-nowrap {
  white-space: nowrap !important; }

/* rtl:begin:remove */
.text-break {
  word-wrap: break-word !important;
  word-break: break-word !important; }

/* rtl:end:remove */
.text-primary {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-primary-rgb), var(--bs-text-opacity)) !important; }

.text-secondary {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-secondary-rgb), var(--bs-text-opacity)) !important; }

.text-success {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-success-rgb), var(--bs-text-opacity)) !important; }

.text-info {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-info-rgb), var(--bs-text-opacity)) !important; }

.text-warning {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-warning-rgb), var(--bs-text-opacity)) !important; }

.text-danger {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-danger-rgb), var(--bs-text-opacity)) !important; }

.text-light {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-light-rgb), var(--bs-text-opacity)) !important; }

.text-dark {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-dark-rgb), var(--bs-text-opacity)) !important; }

.text-black {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-black-rgb), var(--bs-text-opacity)) !important; }

.text-white {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-white-rgb), var(--bs-text-opacity)) !important; }

.text-body {
  --bs-text-opacity: 1;
  color: rgba(var(--bs-body-color-rgb), var(--bs-text-opacity)) !important; }

.text-muted {
  --bs-text-opacity: 1;
  color: #878a99 !important; }

.text-black-50 {
  --bs-text-opacity: 1;
  color: rgba(0, 0, 0, 0.5) !important; }

.text-white-50 {
  --bs-text-opacity: 1;
  color: rgba(255, 255, 255, 0.5) !important; }

.text-reset {
  --bs-text-opacity: 1;
  color: inherit !important; }

.text-opacity-25 {
  --bs-text-opacity: 0.25; }

.text-opacity-50 {
  --bs-text-opacity: 0.5; }

.text-opacity-75 {
  --bs-text-opacity: 0.75; }

.text-opacity-100 {
  --bs-text-opacity: 1; }

.bg-primary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-primary-rgb), var(--bs-bg-opacity)) !important; }

.bg-secondary {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-secondary-rgb), var(--bs-bg-opacity)) !important; }

.bg-success {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-success-rgb), var(--bs-bg-opacity)) !important; }

.bg-info {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-info-rgb), var(--bs-bg-opacity)) !important; }

.bg-warning {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-warning-rgb), var(--bs-bg-opacity)) !important; }

.bg-danger {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-danger-rgb), var(--bs-bg-opacity)) !important; }

.bg-light {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-light-rgb), var(--bs-bg-opacity)) !important; }

.bg-dark {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-dark-rgb), var(--bs-bg-opacity)) !important; }

.bg-black {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-black-rgb), var(--bs-bg-opacity)) !important; }

.bg-white {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-white-rgb), var(--bs-bg-opacity)) !important; }

.bg-body {
  --bs-bg-opacity: 1;
  background-color: rgba(var(--bs-body-bg-rgb), var(--bs-bg-opacity)) !important; }

.bg-transparent {
  --bs-bg-opacity: 1;
  background-color: transparent !important; }

.bg-opacity-10 {
  --bs-bg-opacity: 0.1; }

.bg-opacity-25 {
  --bs-bg-opacity: 0.25; }

.bg-opacity-50 {
  --bs-bg-opacity: 0.5; }

.bg-opacity-75 {
  --bs-bg-opacity: 0.75; }

.bg-opacity-100 {
  --bs-bg-opacity: 1; }

.bg-gradient {
  background-image: var(--bs-gradient) !important; }

.user-select-all {
  -webkit-user-select: all !important;
          user-select: all !important; }

.user-select-auto {
  -webkit-user-select: auto !important;
          user-select: auto !important; }

.user-select-none {
  -webkit-user-select: none !important;
          user-select: none !important; }

.pe-none {
  pointer-events: none !important; }

.pe-auto {
  pointer-events: auto !important; }

.rounded {
  border-radius: var(--bs-border-radius) !important; }

.rounded-0 {
  border-radius: 0 !important; }

.rounded-1 {
  border-radius: var(--bs-border-radius-sm) !important; }

.rounded-2 {
  border-radius: var(--bs-border-radius) !important; }

.rounded-3 {
  border-radius: var(--bs-border-radius-lg) !important; }

.rounded-4 {
  border-radius: var(--bs-border-radius-xl) !important; }

.rounded-5 {
  border-radius: var(--bs-border-radius-2xl) !important; }

.rounded-circle {
  border-radius: 50% !important; }

.rounded-pill {
  border-radius: var(--bs-border-radius-pill) !important; }

.rounded-top {
  border-top-left-radius: var(--bs-border-radius) !important;
  border-top-right-radius: var(--bs-border-radius) !important; }

.rounded-end {
  border-top-right-radius: var(--bs-border-radius) !important;
  border-bottom-right-radius: var(--bs-border-radius) !important; }

.rounded-bottom {
  border-bottom-right-radius: var(--bs-border-radius) !important;
  border-bottom-left-radius: var(--bs-border-radius) !important; }

.rounded-start {
  border-bottom-left-radius: var(--bs-border-radius) !important;
  border-top-left-radius: var(--bs-border-radius) !important; }

.visible {
  visibility: visible !important; }

.invisible {
  visibility: hidden !important; }

@media (min-width: 576px) {
  .float-sm-start {
    float: left !important; }
  .float-sm-end {
    float: right !important; }
  .float-sm-none {
    float: none !important; }
  .d-sm-inline {
    display: inline !important; }
  .d-sm-inline-block {
    display: inline-block !important; }
  .d-sm-block {
    display: block !important; }
  .d-sm-grid {
    display: grid !important; }
  .d-sm-table {
    display: table !important; }
  .d-sm-table-row {
    display: table-row !important; }
  .d-sm-table-cell {
    display: table-cell !important; }
  .d-sm-flex {
    display: flex !important; }
  .d-sm-inline-flex {
    display: inline-flex !important; }
  .d-sm-none {
    display: none !important; }
  .flex-sm-fill {
    flex: 1 1 auto !important; }
  .flex-sm-row {
    flex-direction: row !important; }
  .flex-sm-column {
    flex-direction: column !important; }
  .flex-sm-row-reverse {
    flex-direction: row-reverse !important; }
  .flex-sm-column-reverse {
    flex-direction: column-reverse !important; }
  .flex-sm-grow-0 {
    flex-grow: 0 !important; }
  .flex-sm-grow-1 {
    flex-grow: 1 !important; }
  .flex-sm-shrink-0 {
    flex-shrink: 0 !important; }
  .flex-sm-shrink-1 {
    flex-shrink: 1 !important; }
  .flex-sm-wrap {
    flex-wrap: wrap !important; }
  .flex-sm-nowrap {
    flex-wrap: nowrap !important; }
  .flex-sm-wrap-reverse {
    flex-wrap: wrap-reverse !important; }
  .justify-content-sm-start {
    justify-content: flex-start !important; }
  .justify-content-sm-end {
    justify-content: flex-end !important; }
  .justify-content-sm-center {
    justify-content: center !important; }
  .justify-content-sm-between {
    justify-content: space-between !important; }
  .justify-content-sm-around {
    justify-content: space-around !important; }
  .justify-content-sm-evenly {
    justify-content: space-evenly !important; }
  .align-items-sm-start {
    align-items: flex-start !important; }
  .align-items-sm-end {
    align-items: flex-end !important; }
  .align-items-sm-center {
    align-items: center !important; }
  .align-items-sm-baseline {
    align-items: baseline !important; }
  .align-items-sm-stretch {
    align-items: stretch !important; }
  .align-content-sm-start {
    align-content: flex-start !important; }
  .align-content-sm-end {
    align-content: flex-end !important; }
  .align-content-sm-center {
    align-content: center !important; }
  .align-content-sm-between {
    align-content: space-between !important; }
  .align-content-sm-around {
    align-content: space-around !important; }
  .align-content-sm-stretch {
    align-content: stretch !important; }
  .align-self-sm-auto {
    align-self: auto !important; }
  .align-self-sm-start {
    align-self: flex-start !important; }
  .align-self-sm-end {
    align-self: flex-end !important; }
  .align-self-sm-center {
    align-self: center !important; }
  .align-self-sm-baseline {
    align-self: baseline !important; }
  .align-self-sm-stretch {
    align-self: stretch !important; }
  .order-sm-first {
    order: -1 !important; }
  .order-sm-0 {
    order: 0 !important; }
  .order-sm-1 {
    order: 1 !important; }
  .order-sm-2 {
    order: 2 !important; }
  .order-sm-3 {
    order: 3 !important; }
  .order-sm-4 {
    order: 4 !important; }
  .order-sm-5 {
    order: 5 !important; }
  .order-sm-last {
    order: 6 !important; }
  .m-sm-0 {
    margin: 0 !important; }
  .m-sm-1 {
    margin: 0.25rem !important; }
  .m-sm-2 {
    margin: 0.5rem !important; }
  .m-sm-3 {
    margin: 1rem !important; }
  .m-sm-4 {
    margin: 1.5rem !important; }
  .m-sm-5 {
    margin: 3rem !important; }
  .m-sm-auto {
    margin: auto !important; }
  .mx-sm-0 {
    margin-right: 0 !important;
    margin-left: 0 !important; }
  .mx-sm-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important; }
  .mx-sm-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important; }
  .mx-sm-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important; }
  .mx-sm-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important; }
  .mx-sm-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important; }
  .mx-sm-auto {
    margin-right: auto !important;
    margin-left: auto !important; }
  .my-sm-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important; }
  .my-sm-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important; }
  .my-sm-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important; }
  .my-sm-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important; }
  .my-sm-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important; }
  .my-sm-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important; }
  .my-sm-auto {
    margin-top: auto !important;
    margin-bottom: auto !important; }
  .mt-sm-0 {
    margin-top: 0 !important; }
  .mt-sm-1 {
    margin-top: 0.25rem !important; }
  .mt-sm-2 {
    margin-top: 0.5rem !important; }
  .mt-sm-3 {
    margin-top: 1rem !important; }
  .mt-sm-4 {
    margin-top: 1.5rem !important; }
  .mt-sm-5 {
    margin-top: 3rem !important; }
  .mt-sm-auto {
    margin-top: auto !important; }
  .me-sm-0 {
    margin-right: 0 !important; }
  .me-sm-1 {
    margin-right: 0.25rem !important; }
  .me-sm-2 {
    margin-right: 0.5rem !important; }
  .me-sm-3 {
    margin-right: 1rem !important; }
  .me-sm-4 {
    margin-right: 1.5rem !important; }
  .me-sm-5 {
    margin-right: 3rem !important; }
  .me-sm-auto {
    margin-right: auto !important; }
  .mb-sm-0 {
    margin-bottom: 0 !important; }
  .mb-sm-1 {
    margin-bottom: 0.25rem !important; }
  .mb-sm-2 {
    margin-bottom: 0.5rem !important; }
  .mb-sm-3 {
    margin-bottom: 1rem !important; }
  .mb-sm-4 {
    margin-bottom: 1.5rem !important; }
  .mb-sm-5 {
    margin-bottom: 3rem !important; }
  .mb-sm-auto {
    margin-bottom: auto !important; }
  .ms-sm-0 {
    margin-left: 0 !important; }
  .ms-sm-1 {
    margin-left: 0.25rem !important; }
  .ms-sm-2 {
    margin-left: 0.5rem !important; }
  .ms-sm-3 {
    margin-left: 1rem !important; }
  .ms-sm-4 {
    margin-left: 1.5rem !important; }
  .ms-sm-5 {
    margin-left: 3rem !important; }
  .ms-sm-auto {
    margin-left: auto !important; }
  .m-sm-n1 {
    margin: -0.25rem !important; }
  .m-sm-n2 {
    margin: -0.5rem !important; }
  .m-sm-n3 {
    margin: -1rem !important; }
  .m-sm-n4 {
    margin: -1.5rem !important; }
  .m-sm-n5 {
    margin: -3rem !important; }
  .mx-sm-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important; }
  .mx-sm-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important; }
  .mx-sm-n3 {
    margin-right: -1rem !important;
    margin-left: -1rem !important; }
  .mx-sm-n4 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important; }
  .mx-sm-n5 {
    margin-right: -3rem !important;
    margin-left: -3rem !important; }
  .my-sm-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important; }
  .my-sm-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important; }
  .my-sm-n3 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important; }
  .my-sm-n4 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important; }
  .my-sm-n5 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important; }
  .mt-sm-n1 {
    margin-top: -0.25rem !important; }
  .mt-sm-n2 {
    margin-top: -0.5rem !important; }
  .mt-sm-n3 {
    margin-top: -1rem !important; }
  .mt-sm-n4 {
    margin-top: -1.5rem !important; }
  .mt-sm-n5 {
    margin-top: -3rem !important; }
  .me-sm-n1 {
    margin-right: -0.25rem !important; }
  .me-sm-n2 {
    margin-right: -0.5rem !important; }
  .me-sm-n3 {
    margin-right: -1rem !important; }
  .me-sm-n4 {
    margin-right: -1.5rem !important; }
  .me-sm-n5 {
    margin-right: -3rem !important; }
  .mb-sm-n1 {
    margin-bottom: -0.25rem !important; }
  .mb-sm-n2 {
    margin-bottom: -0.5rem !important; }
  .mb-sm-n3 {
    margin-bottom: -1rem !important; }
  .mb-sm-n4 {
    margin-bottom: -1.5rem !important; }
  .mb-sm-n5 {
    margin-bottom: -3rem !important; }
  .ms-sm-n1 {
    margin-left: -0.25rem !important; }
  .ms-sm-n2 {
    margin-left: -0.5rem !important; }
  .ms-sm-n3 {
    margin-left: -1rem !important; }
  .ms-sm-n4 {
    margin-left: -1.5rem !important; }
  .ms-sm-n5 {
    margin-left: -3rem !important; }
  .p-sm-0 {
    padding: 0 !important; }
  .p-sm-1 {
    padding: 0.25rem !important; }
  .p-sm-2 {
    padding: 0.5rem !important; }
  .p-sm-3 {
    padding: 1rem !important; }
  .p-sm-4 {
    padding: 1.5rem !important; }
  .p-sm-5 {
    padding: 3rem !important; }
  .px-sm-0 {
    padding-right: 0 !important;
    padding-left: 0 !important; }
  .px-sm-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important; }
  .px-sm-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important; }
  .px-sm-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important; }
  .px-sm-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important; }
  .px-sm-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important; }
  .py-sm-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important; }
  .py-sm-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important; }
  .py-sm-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important; }
  .py-sm-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important; }
  .py-sm-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important; }
  .py-sm-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important; }
  .pt-sm-0 {
    padding-top: 0 !important; }
  .pt-sm-1 {
    padding-top: 0.25rem !important; }
  .pt-sm-2 {
    padding-top: 0.5rem !important; }
  .pt-sm-3 {
    padding-top: 1rem !important; }
  .pt-sm-4 {
    padding-top: 1.5rem !important; }
  .pt-sm-5 {
    padding-top: 3rem !important; }
  .pe-sm-0 {
    padding-right: 0 !important; }
  .pe-sm-1 {
    padding-right: 0.25rem !important; }
  .pe-sm-2 {
    padding-right: 0.5rem !important; }
  .pe-sm-3 {
    padding-right: 1rem !important; }
  .pe-sm-4 {
    padding-right: 1.5rem !important; }
  .pe-sm-5 {
    padding-right: 3rem !important; }
  .pb-sm-0 {
    padding-bottom: 0 !important; }
  .pb-sm-1 {
    padding-bottom: 0.25rem !important; }
  .pb-sm-2 {
    padding-bottom: 0.5rem !important; }
  .pb-sm-3 {
    padding-bottom: 1rem !important; }
  .pb-sm-4 {
    padding-bottom: 1.5rem !important; }
  .pb-sm-5 {
    padding-bottom: 3rem !important; }
  .ps-sm-0 {
    padding-left: 0 !important; }
  .ps-sm-1 {
    padding-left: 0.25rem !important; }
  .ps-sm-2 {
    padding-left: 0.5rem !important; }
  .ps-sm-3 {
    padding-left: 1rem !important; }
  .ps-sm-4 {
    padding-left: 1.5rem !important; }
  .ps-sm-5 {
    padding-left: 3rem !important; }
  .gap-sm-0 {
    gap: 0 !important; }
  .gap-sm-1 {
    gap: 0.25rem !important; }
  .gap-sm-2 {
    gap: 0.5rem !important; }
  .gap-sm-3 {
    gap: 1rem !important; }
  .gap-sm-4 {
    gap: 1.5rem !important; }
  .gap-sm-5 {
    gap: 3rem !important; }
  .text-sm-start {
    text-align: left !important; }
  .text-sm-end {
    text-align: right !important; }
  .text-sm-center {
    text-align: center !important; } }

@media (min-width: 768px) {
  .float-md-start {
    float: left !important; }
  .float-md-end {
    float: right !important; }
  .float-md-none {
    float: none !important; }
  .d-md-inline {
    display: inline !important; }
  .d-md-inline-block {
    display: inline-block !important; }
  .d-md-block {
    display: block !important; }
  .d-md-grid {
    display: grid !important; }
  .d-md-table {
    display: table !important; }
  .d-md-table-row {
    display: table-row !important; }
  .d-md-table-cell {
    display: table-cell !important; }
  .d-md-flex {
    display: flex !important; }
  .d-md-inline-flex {
    display: inline-flex !important; }
  .d-md-none {
    display: none !important; }
  .flex-md-fill {
    flex: 1 1 auto !important; }
  .flex-md-row {
    flex-direction: row !important; }
  .flex-md-column {
    flex-direction: column !important; }
  .flex-md-row-reverse {
    flex-direction: row-reverse !important; }
  .flex-md-column-reverse {
    flex-direction: column-reverse !important; }
  .flex-md-grow-0 {
    flex-grow: 0 !important; }
  .flex-md-grow-1 {
    flex-grow: 1 !important; }
  .flex-md-shrink-0 {
    flex-shrink: 0 !important; }
  .flex-md-shrink-1 {
    flex-shrink: 1 !important; }
  .flex-md-wrap {
    flex-wrap: wrap !important; }
  .flex-md-nowrap {
    flex-wrap: nowrap !important; }
  .flex-md-wrap-reverse {
    flex-wrap: wrap-reverse !important; }
  .justify-content-md-start {
    justify-content: flex-start !important; }
  .justify-content-md-end {
    justify-content: flex-end !important; }
  .justify-content-md-center {
    justify-content: center !important; }
  .justify-content-md-between {
    justify-content: space-between !important; }
  .justify-content-md-around {
    justify-content: space-around !important; }
  .justify-content-md-evenly {
    justify-content: space-evenly !important; }
  .align-items-md-start {
    align-items: flex-start !important; }
  .align-items-md-end {
    align-items: flex-end !important; }
  .align-items-md-center {
    align-items: center !important; }
  .align-items-md-baseline {
    align-items: baseline !important; }
  .align-items-md-stretch {
    align-items: stretch !important; }
  .align-content-md-start {
    align-content: flex-start !important; }
  .align-content-md-end {
    align-content: flex-end !important; }
  .align-content-md-center {
    align-content: center !important; }
  .align-content-md-between {
    align-content: space-between !important; }
  .align-content-md-around {
    align-content: space-around !important; }
  .align-content-md-stretch {
    align-content: stretch !important; }
  .align-self-md-auto {
    align-self: auto !important; }
  .align-self-md-start {
    align-self: flex-start !important; }
  .align-self-md-end {
    align-self: flex-end !important; }
  .align-self-md-center {
    align-self: center !important; }
  .align-self-md-baseline {
    align-self: baseline !important; }
  .align-self-md-stretch {
    align-self: stretch !important; }
  .order-md-first {
    order: -1 !important; }
  .order-md-0 {
    order: 0 !important; }
  .order-md-1 {
    order: 1 !important; }
  .order-md-2 {
    order: 2 !important; }
  .order-md-3 {
    order: 3 !important; }
  .order-md-4 {
    order: 4 !important; }
  .order-md-5 {
    order: 5 !important; }
  .order-md-last {
    order: 6 !important; }
  .m-md-0 {
    margin: 0 !important; }
  .m-md-1 {
    margin: 0.25rem !important; }
  .m-md-2 {
    margin: 0.5rem !important; }
  .m-md-3 {
    margin: 1rem !important; }
  .m-md-4 {
    margin: 1.5rem !important; }
  .m-md-5 {
    margin: 3rem !important; }
  .m-md-auto {
    margin: auto !important; }
  .mx-md-0 {
    margin-right: 0 !important;
    margin-left: 0 !important; }
  .mx-md-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important; }
  .mx-md-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important; }
  .mx-md-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important; }
  .mx-md-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important; }
  .mx-md-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important; }
  .mx-md-auto {
    margin-right: auto !important;
    margin-left: auto !important; }
  .my-md-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important; }
  .my-md-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important; }
  .my-md-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important; }
  .my-md-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important; }
  .my-md-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important; }
  .my-md-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important; }
  .my-md-auto {
    margin-top: auto !important;
    margin-bottom: auto !important; }
  .mt-md-0 {
    margin-top: 0 !important; }
  .mt-md-1 {
    margin-top: 0.25rem !important; }
  .mt-md-2 {
    margin-top: 0.5rem !important; }
  .mt-md-3 {
    margin-top: 1rem !important; }
  .mt-md-4 {
    margin-top: 1.5rem !important; }
  .mt-md-5 {
    margin-top: 3rem !important; }
  .mt-md-auto {
    margin-top: auto !important; }
  .me-md-0 {
    margin-right: 0 !important; }
  .me-md-1 {
    margin-right: 0.25rem !important; }
  .me-md-2 {
    margin-right: 0.5rem !important; }
  .me-md-3 {
    margin-right: 1rem !important; }
  .me-md-4 {
    margin-right: 1.5rem !important; }
  .me-md-5 {
    margin-right: 3rem !important; }
  .me-md-auto {
    margin-right: auto !important; }
  .mb-md-0 {
    margin-bottom: 0 !important; }
  .mb-md-1 {
    margin-bottom: 0.25rem !important; }
  .mb-md-2 {
    margin-bottom: 0.5rem !important; }
  .mb-md-3 {
    margin-bottom: 1rem !important; }
  .mb-md-4 {
    margin-bottom: 1.5rem !important; }
  .mb-md-5 {
    margin-bottom: 3rem !important; }
  .mb-md-auto {
    margin-bottom: auto !important; }
  .ms-md-0 {
    margin-left: 0 !important; }
  .ms-md-1 {
    margin-left: 0.25rem !important; }
  .ms-md-2 {
    margin-left: 0.5rem !important; }
  .ms-md-3 {
    margin-left: 1rem !important; }
  .ms-md-4 {
    margin-left: 1.5rem !important; }
  .ms-md-5 {
    margin-left: 3rem !important; }
  .ms-md-auto {
    margin-left: auto !important; }
  .m-md-n1 {
    margin: -0.25rem !important; }
  .m-md-n2 {
    margin: -0.5rem !important; }
  .m-md-n3 {
    margin: -1rem !important; }
  .m-md-n4 {
    margin: -1.5rem !important; }
  .m-md-n5 {
    margin: -3rem !important; }
  .mx-md-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important; }
  .mx-md-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important; }
  .mx-md-n3 {
    margin-right: -1rem !important;
    margin-left: -1rem !important; }
  .mx-md-n4 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important; }
  .mx-md-n5 {
    margin-right: -3rem !important;
    margin-left: -3rem !important; }
  .my-md-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important; }
  .my-md-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important; }
  .my-md-n3 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important; }
  .my-md-n4 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important; }
  .my-md-n5 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important; }
  .mt-md-n1 {
    margin-top: -0.25rem !important; }
  .mt-md-n2 {
    margin-top: -0.5rem !important; }
  .mt-md-n3 {
    margin-top: -1rem !important; }
  .mt-md-n4 {
    margin-top: -1.5rem !important; }
  .mt-md-n5 {
    margin-top: -3rem !important; }
  .me-md-n1 {
    margin-right: -0.25rem !important; }
  .me-md-n2 {
    margin-right: -0.5rem !important; }
  .me-md-n3 {
    margin-right: -1rem !important; }
  .me-md-n4 {
    margin-right: -1.5rem !important; }
  .me-md-n5 {
    margin-right: -3rem !important; }
  .mb-md-n1 {
    margin-bottom: -0.25rem !important; }
  .mb-md-n2 {
    margin-bottom: -0.5rem !important; }
  .mb-md-n3 {
    margin-bottom: -1rem !important; }
  .mb-md-n4 {
    margin-bottom: -1.5rem !important; }
  .mb-md-n5 {
    margin-bottom: -3rem !important; }
  .ms-md-n1 {
    margin-left: -0.25rem !important; }
  .ms-md-n2 {
    margin-left: -0.5rem !important; }
  .ms-md-n3 {
    margin-left: -1rem !important; }
  .ms-md-n4 {
    margin-left: -1.5rem !important; }
  .ms-md-n5 {
    margin-left: -3rem !important; }
  .p-md-0 {
    padding: 0 !important; }
  .p-md-1 {
    padding: 0.25rem !important; }
  .p-md-2 {
    padding: 0.5rem !important; }
  .p-md-3 {
    padding: 1rem !important; }
  .p-md-4 {
    padding: 1.5rem !important; }
  .p-md-5 {
    padding: 3rem !important; }
  .px-md-0 {
    padding-right: 0 !important;
    padding-left: 0 !important; }
  .px-md-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important; }
  .px-md-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important; }
  .px-md-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important; }
  .px-md-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important; }
  .px-md-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important; }
  .py-md-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important; }
  .py-md-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important; }
  .py-md-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important; }
  .py-md-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important; }
  .py-md-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important; }
  .py-md-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important; }
  .pt-md-0 {
    padding-top: 0 !important; }
  .pt-md-1 {
    padding-top: 0.25rem !important; }
  .pt-md-2 {
    padding-top: 0.5rem !important; }
  .pt-md-3 {
    padding-top: 1rem !important; }
  .pt-md-4 {
    padding-top: 1.5rem !important; }
  .pt-md-5 {
    padding-top: 3rem !important; }
  .pe-md-0 {
    padding-right: 0 !important; }
  .pe-md-1 {
    padding-right: 0.25rem !important; }
  .pe-md-2 {
    padding-right: 0.5rem !important; }
  .pe-md-3 {
    padding-right: 1rem !important; }
  .pe-md-4 {
    padding-right: 1.5rem !important; }
  .pe-md-5 {
    padding-right: 3rem !important; }
  .pb-md-0 {
    padding-bottom: 0 !important; }
  .pb-md-1 {
    padding-bottom: 0.25rem !important; }
  .pb-md-2 {
    padding-bottom: 0.5rem !important; }
  .pb-md-3 {
    padding-bottom: 1rem !important; }
  .pb-md-4 {
    padding-bottom: 1.5rem !important; }
  .pb-md-5 {
    padding-bottom: 3rem !important; }
  .ps-md-0 {
    padding-left: 0 !important; }
  .ps-md-1 {
    padding-left: 0.25rem !important; }
  .ps-md-2 {
    padding-left: 0.5rem !important; }
  .ps-md-3 {
    padding-left: 1rem !important; }
  .ps-md-4 {
    padding-left: 1.5rem !important; }
  .ps-md-5 {
    padding-left: 3rem !important; }
  .gap-md-0 {
    gap: 0 !important; }
  .gap-md-1 {
    gap: 0.25rem !important; }
  .gap-md-2 {
    gap: 0.5rem !important; }
  .gap-md-3 {
    gap: 1rem !important; }
  .gap-md-4 {
    gap: 1.5rem !important; }
  .gap-md-5 {
    gap: 3rem !important; }
  .text-md-start {
    text-align: left !important; }
  .text-md-end {
    text-align: right !important; }
  .text-md-center {
    text-align: center !important; } }

@media (min-width: 992px) {
  .float-lg-start {
    float: left !important; }
  .float-lg-end {
    float: right !important; }
  .float-lg-none {
    float: none !important; }
  .d-lg-inline {
    display: inline !important; }
  .d-lg-inline-block {
    display: inline-block !important; }
  .d-lg-block {
    display: block !important; }
  .d-lg-grid {
    display: grid !important; }
  .d-lg-table {
    display: table !important; }
  .d-lg-table-row {
    display: table-row !important; }
  .d-lg-table-cell {
    display: table-cell !important; }
  .d-lg-flex {
    display: flex !important; }
  .d-lg-inline-flex {
    display: inline-flex !important; }
  .d-lg-none {
    display: none !important; }
  .flex-lg-fill {
    flex: 1 1 auto !important; }
  .flex-lg-row {
    flex-direction: row !important; }
  .flex-lg-column {
    flex-direction: column !important; }
  .flex-lg-row-reverse {
    flex-direction: row-reverse !important; }
  .flex-lg-column-reverse {
    flex-direction: column-reverse !important; }
  .flex-lg-grow-0 {
    flex-grow: 0 !important; }
  .flex-lg-grow-1 {
    flex-grow: 1 !important; }
  .flex-lg-shrink-0 {
    flex-shrink: 0 !important; }
  .flex-lg-shrink-1 {
    flex-shrink: 1 !important; }
  .flex-lg-wrap {
    flex-wrap: wrap !important; }
  .flex-lg-nowrap {
    flex-wrap: nowrap !important; }
  .flex-lg-wrap-reverse {
    flex-wrap: wrap-reverse !important; }
  .justify-content-lg-start {
    justify-content: flex-start !important; }
  .justify-content-lg-end {
    justify-content: flex-end !important; }
  .justify-content-lg-center {
    justify-content: center !important; }
  .justify-content-lg-between {
    justify-content: space-between !important; }
  .justify-content-lg-around {
    justify-content: space-around !important; }
  .justify-content-lg-evenly {
    justify-content: space-evenly !important; }
  .align-items-lg-start {
    align-items: flex-start !important; }
  .align-items-lg-end {
    align-items: flex-end !important; }
  .align-items-lg-center {
    align-items: center !important; }
  .align-items-lg-baseline {
    align-items: baseline !important; }
  .align-items-lg-stretch {
    align-items: stretch !important; }
  .align-content-lg-start {
    align-content: flex-start !important; }
  .align-content-lg-end {
    align-content: flex-end !important; }
  .align-content-lg-center {
    align-content: center !important; }
  .align-content-lg-between {
    align-content: space-between !important; }
  .align-content-lg-around {
    align-content: space-around !important; }
  .align-content-lg-stretch {
    align-content: stretch !important; }
  .align-self-lg-auto {
    align-self: auto !important; }
  .align-self-lg-start {
    align-self: flex-start !important; }
  .align-self-lg-end {
    align-self: flex-end !important; }
  .align-self-lg-center {
    align-self: center !important; }
  .align-self-lg-baseline {
    align-self: baseline !important; }
  .align-self-lg-stretch {
    align-self: stretch !important; }
  .order-lg-first {
    order: -1 !important; }
  .order-lg-0 {
    order: 0 !important; }
  .order-lg-1 {
    order: 1 !important; }
  .order-lg-2 {
    order: 2 !important; }
  .order-lg-3 {
    order: 3 !important; }
  .order-lg-4 {
    order: 4 !important; }
  .order-lg-5 {
    order: 5 !important; }
  .order-lg-last {
    order: 6 !important; }
  .m-lg-0 {
    margin: 0 !important; }
  .m-lg-1 {
    margin: 0.25rem !important; }
  .m-lg-2 {
    margin: 0.5rem !important; }
  .m-lg-3 {
    margin: 1rem !important; }
  .m-lg-4 {
    margin: 1.5rem !important; }
  .m-lg-5 {
    margin: 3rem !important; }
  .m-lg-auto {
    margin: auto !important; }
  .mx-lg-0 {
    margin-right: 0 !important;
    margin-left: 0 !important; }
  .mx-lg-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important; }
  .mx-lg-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important; }
  .mx-lg-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important; }
  .mx-lg-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important; }
  .mx-lg-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important; }
  .mx-lg-auto {
    margin-right: auto !important;
    margin-left: auto !important; }
  .my-lg-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important; }
  .my-lg-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important; }
  .my-lg-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important; }
  .my-lg-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important; }
  .my-lg-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important; }
  .my-lg-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important; }
  .my-lg-auto {
    margin-top: auto !important;
    margin-bottom: auto !important; }
  .mt-lg-0 {
    margin-top: 0 !important; }
  .mt-lg-1 {
    margin-top: 0.25rem !important; }
  .mt-lg-2 {
    margin-top: 0.5rem !important; }
  .mt-lg-3 {
    margin-top: 1rem !important; }
  .mt-lg-4 {
    margin-top: 1.5rem !important; }
  .mt-lg-5 {
    margin-top: 3rem !important; }
  .mt-lg-auto {
    margin-top: auto !important; }
  .me-lg-0 {
    margin-right: 0 !important; }
  .me-lg-1 {
    margin-right: 0.25rem !important; }
  .me-lg-2 {
    margin-right: 0.5rem !important; }
  .me-lg-3 {
    margin-right: 1rem !important; }
  .me-lg-4 {
    margin-right: 1.5rem !important; }
  .me-lg-5 {
    margin-right: 3rem !important; }
  .me-lg-auto {
    margin-right: auto !important; }
  .mb-lg-0 {
    margin-bottom: 0 !important; }
  .mb-lg-1 {
    margin-bottom: 0.25rem !important; }
  .mb-lg-2 {
    margin-bottom: 0.5rem !important; }
  .mb-lg-3 {
    margin-bottom: 1rem !important; }
  .mb-lg-4 {
    margin-bottom: 1.5rem !important; }
  .mb-lg-5 {
    margin-bottom: 3rem !important; }
  .mb-lg-auto {
    margin-bottom: auto !important; }
  .ms-lg-0 {
    margin-left: 0 !important; }
  .ms-lg-1 {
    margin-left: 0.25rem !important; }
  .ms-lg-2 {
    margin-left: 0.5rem !important; }
  .ms-lg-3 {
    margin-left: 1rem !important; }
  .ms-lg-4 {
    margin-left: 1.5rem !important; }
  .ms-lg-5 {
    margin-left: 3rem !important; }
  .ms-lg-auto {
    margin-left: auto !important; }
  .m-lg-n1 {
    margin: -0.25rem !important; }
  .m-lg-n2 {
    margin: -0.5rem !important; }
  .m-lg-n3 {
    margin: -1rem !important; }
  .m-lg-n4 {
    margin: -1.5rem !important; }
  .m-lg-n5 {
    margin: -3rem !important; }
  .mx-lg-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important; }
  .mx-lg-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important; }
  .mx-lg-n3 {
    margin-right: -1rem !important;
    margin-left: -1rem !important; }
  .mx-lg-n4 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important; }
  .mx-lg-n5 {
    margin-right: -3rem !important;
    margin-left: -3rem !important; }
  .my-lg-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important; }
  .my-lg-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important; }
  .my-lg-n3 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important; }
  .my-lg-n4 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important; }
  .my-lg-n5 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important; }
  .mt-lg-n1 {
    margin-top: -0.25rem !important; }
  .mt-lg-n2 {
    margin-top: -0.5rem !important; }
  .mt-lg-n3 {
    margin-top: -1rem !important; }
  .mt-lg-n4 {
    margin-top: -1.5rem !important; }
  .mt-lg-n5 {
    margin-top: -3rem !important; }
  .me-lg-n1 {
    margin-right: -0.25rem !important; }
  .me-lg-n2 {
    margin-right: -0.5rem !important; }
  .me-lg-n3 {
    margin-right: -1rem !important; }
  .me-lg-n4 {
    margin-right: -1.5rem !important; }
  .me-lg-n5 {
    margin-right: -3rem !important; }
  .mb-lg-n1 {
    margin-bottom: -0.25rem !important; }
  .mb-lg-n2 {
    margin-bottom: -0.5rem !important; }
  .mb-lg-n3 {
    margin-bottom: -1rem !important; }
  .mb-lg-n4 {
    margin-bottom: -1.5rem !important; }
  .mb-lg-n5 {
    margin-bottom: -3rem !important; }
  .ms-lg-n1 {
    margin-left: -0.25rem !important; }
  .ms-lg-n2 {
    margin-left: -0.5rem !important; }
  .ms-lg-n3 {
    margin-left: -1rem !important; }
  .ms-lg-n4 {
    margin-left: -1.5rem !important; }
  .ms-lg-n5 {
    margin-left: -3rem !important; }
  .p-lg-0 {
    padding: 0 !important; }
  .p-lg-1 {
    padding: 0.25rem !important; }
  .p-lg-2 {
    padding: 0.5rem !important; }
  .p-lg-3 {
    padding: 1rem !important; }
  .p-lg-4 {
    padding: 1.5rem !important; }
  .p-lg-5 {
    padding: 3rem !important; }
  .px-lg-0 {
    padding-right: 0 !important;
    padding-left: 0 !important; }
  .px-lg-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important; }
  .px-lg-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important; }
  .px-lg-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important; }
  .px-lg-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important; }
  .px-lg-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important; }
  .py-lg-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important; }
  .py-lg-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important; }
  .py-lg-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important; }
  .py-lg-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important; }
  .py-lg-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important; }
  .py-lg-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important; }
  .pt-lg-0 {
    padding-top: 0 !important; }
  .pt-lg-1 {
    padding-top: 0.25rem !important; }
  .pt-lg-2 {
    padding-top: 0.5rem !important; }
  .pt-lg-3 {
    padding-top: 1rem !important; }
  .pt-lg-4 {
    padding-top: 1.5rem !important; }
  .pt-lg-5 {
    padding-top: 3rem !important; }
  .pe-lg-0 {
    padding-right: 0 !important; }
  .pe-lg-1 {
    padding-right: 0.25rem !important; }
  .pe-lg-2 {
    padding-right: 0.5rem !important; }
  .pe-lg-3 {
    padding-right: 1rem !important; }
  .pe-lg-4 {
    padding-right: 1.5rem !important; }
  .pe-lg-5 {
    padding-right: 3rem !important; }
  .pb-lg-0 {
    padding-bottom: 0 !important; }
  .pb-lg-1 {
    padding-bottom: 0.25rem !important; }
  .pb-lg-2 {
    padding-bottom: 0.5rem !important; }
  .pb-lg-3 {
    padding-bottom: 1rem !important; }
  .pb-lg-4 {
    padding-bottom: 1.5rem !important; }
  .pb-lg-5 {
    padding-bottom: 3rem !important; }
  .ps-lg-0 {
    padding-left: 0 !important; }
  .ps-lg-1 {
    padding-left: 0.25rem !important; }
  .ps-lg-2 {
    padding-left: 0.5rem !important; }
  .ps-lg-3 {
    padding-left: 1rem !important; }
  .ps-lg-4 {
    padding-left: 1.5rem !important; }
  .ps-lg-5 {
    padding-left: 3rem !important; }
  .gap-lg-0 {
    gap: 0 !important; }
  .gap-lg-1 {
    gap: 0.25rem !important; }
  .gap-lg-2 {
    gap: 0.5rem !important; }
  .gap-lg-3 {
    gap: 1rem !important; }
  .gap-lg-4 {
    gap: 1.5rem !important; }
  .gap-lg-5 {
    gap: 3rem !important; }
  .text-lg-start {
    text-align: left !important; }
  .text-lg-end {
    text-align: right !important; }
  .text-lg-center {
    text-align: center !important; } }

@media (min-width: 1200px) {
  .float-xl-start {
    float: left !important; }
  .float-xl-end {
    float: right !important; }
  .float-xl-none {
    float: none !important; }
  .d-xl-inline {
    display: inline !important; }
  .d-xl-inline-block {
    display: inline-block !important; }
  .d-xl-block {
    display: block !important; }
  .d-xl-grid {
    display: grid !important; }
  .d-xl-table {
    display: table !important; }
  .d-xl-table-row {
    display: table-row !important; }
  .d-xl-table-cell {
    display: table-cell !important; }
  .d-xl-flex {
    display: flex !important; }
  .d-xl-inline-flex {
    display: inline-flex !important; }
  .d-xl-none {
    display: none !important; }
  .flex-xl-fill {
    flex: 1 1 auto !important; }
  .flex-xl-row {
    flex-direction: row !important; }
  .flex-xl-column {
    flex-direction: column !important; }
  .flex-xl-row-reverse {
    flex-direction: row-reverse !important; }
  .flex-xl-column-reverse {
    flex-direction: column-reverse !important; }
  .flex-xl-grow-0 {
    flex-grow: 0 !important; }
  .flex-xl-grow-1 {
    flex-grow: 1 !important; }
  .flex-xl-shrink-0 {
    flex-shrink: 0 !important; }
  .flex-xl-shrink-1 {
    flex-shrink: 1 !important; }
  .flex-xl-wrap {
    flex-wrap: wrap !important; }
  .flex-xl-nowrap {
    flex-wrap: nowrap !important; }
  .flex-xl-wrap-reverse {
    flex-wrap: wrap-reverse !important; }
  .justify-content-xl-start {
    justify-content: flex-start !important; }
  .justify-content-xl-end {
    justify-content: flex-end !important; }
  .justify-content-xl-center {
    justify-content: center !important; }
  .justify-content-xl-between {
    justify-content: space-between !important; }
  .justify-content-xl-around {
    justify-content: space-around !important; }
  .justify-content-xl-evenly {
    justify-content: space-evenly !important; }
  .align-items-xl-start {
    align-items: flex-start !important; }
  .align-items-xl-end {
    align-items: flex-end !important; }
  .align-items-xl-center {
    align-items: center !important; }
  .align-items-xl-baseline {
    align-items: baseline !important; }
  .align-items-xl-stretch {
    align-items: stretch !important; }
  .align-content-xl-start {
    align-content: flex-start !important; }
  .align-content-xl-end {
    align-content: flex-end !important; }
  .align-content-xl-center {
    align-content: center !important; }
  .align-content-xl-between {
    align-content: space-between !important; }
  .align-content-xl-around {
    align-content: space-around !important; }
  .align-content-xl-stretch {
    align-content: stretch !important; }
  .align-self-xl-auto {
    align-self: auto !important; }
  .align-self-xl-start {
    align-self: flex-start !important; }
  .align-self-xl-end {
    align-self: flex-end !important; }
  .align-self-xl-center {
    align-self: center !important; }
  .align-self-xl-baseline {
    align-self: baseline !important; }
  .align-self-xl-stretch {
    align-self: stretch !important; }
  .order-xl-first {
    order: -1 !important; }
  .order-xl-0 {
    order: 0 !important; }
  .order-xl-1 {
    order: 1 !important; }
  .order-xl-2 {
    order: 2 !important; }
  .order-xl-3 {
    order: 3 !important; }
  .order-xl-4 {
    order: 4 !important; }
  .order-xl-5 {
    order: 5 !important; }
  .order-xl-last {
    order: 6 !important; }
  .m-xl-0 {
    margin: 0 !important; }
  .m-xl-1 {
    margin: 0.25rem !important; }
  .m-xl-2 {
    margin: 0.5rem !important; }
  .m-xl-3 {
    margin: 1rem !important; }
  .m-xl-4 {
    margin: 1.5rem !important; }
  .m-xl-5 {
    margin: 3rem !important; }
  .m-xl-auto {
    margin: auto !important; }
  .mx-xl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important; }
  .mx-xl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important; }
  .mx-xl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important; }
  .mx-xl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important; }
  .mx-xl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important; }
  .mx-xl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important; }
  .mx-xl-auto {
    margin-right: auto !important;
    margin-left: auto !important; }
  .my-xl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important; }
  .my-xl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important; }
  .my-xl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important; }
  .my-xl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important; }
  .my-xl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important; }
  .my-xl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important; }
  .my-xl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important; }
  .mt-xl-0 {
    margin-top: 0 !important; }
  .mt-xl-1 {
    margin-top: 0.25rem !important; }
  .mt-xl-2 {
    margin-top: 0.5rem !important; }
  .mt-xl-3 {
    margin-top: 1rem !important; }
  .mt-xl-4 {
    margin-top: 1.5rem !important; }
  .mt-xl-5 {
    margin-top: 3rem !important; }
  .mt-xl-auto {
    margin-top: auto !important; }
  .me-xl-0 {
    margin-right: 0 !important; }
  .me-xl-1 {
    margin-right: 0.25rem !important; }
  .me-xl-2 {
    margin-right: 0.5rem !important; }
  .me-xl-3 {
    margin-right: 1rem !important; }
  .me-xl-4 {
    margin-right: 1.5rem !important; }
  .me-xl-5 {
    margin-right: 3rem !important; }
  .me-xl-auto {
    margin-right: auto !important; }
  .mb-xl-0 {
    margin-bottom: 0 !important; }
  .mb-xl-1 {
    margin-bottom: 0.25rem !important; }
  .mb-xl-2 {
    margin-bottom: 0.5rem !important; }
  .mb-xl-3 {
    margin-bottom: 1rem !important; }
  .mb-xl-4 {
    margin-bottom: 1.5rem !important; }
  .mb-xl-5 {
    margin-bottom: 3rem !important; }
  .mb-xl-auto {
    margin-bottom: auto !important; }
  .ms-xl-0 {
    margin-left: 0 !important; }
  .ms-xl-1 {
    margin-left: 0.25rem !important; }
  .ms-xl-2 {
    margin-left: 0.5rem !important; }
  .ms-xl-3 {
    margin-left: 1rem !important; }
  .ms-xl-4 {
    margin-left: 1.5rem !important; }
  .ms-xl-5 {
    margin-left: 3rem !important; }
  .ms-xl-auto {
    margin-left: auto !important; }
  .m-xl-n1 {
    margin: -0.25rem !important; }
  .m-xl-n2 {
    margin: -0.5rem !important; }
  .m-xl-n3 {
    margin: -1rem !important; }
  .m-xl-n4 {
    margin: -1.5rem !important; }
  .m-xl-n5 {
    margin: -3rem !important; }
  .mx-xl-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important; }
  .mx-xl-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important; }
  .mx-xl-n3 {
    margin-right: -1rem !important;
    margin-left: -1rem !important; }
  .mx-xl-n4 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important; }
  .mx-xl-n5 {
    margin-right: -3rem !important;
    margin-left: -3rem !important; }
  .my-xl-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important; }
  .my-xl-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important; }
  .my-xl-n3 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important; }
  .my-xl-n4 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important; }
  .my-xl-n5 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important; }
  .mt-xl-n1 {
    margin-top: -0.25rem !important; }
  .mt-xl-n2 {
    margin-top: -0.5rem !important; }
  .mt-xl-n3 {
    margin-top: -1rem !important; }
  .mt-xl-n4 {
    margin-top: -1.5rem !important; }
  .mt-xl-n5 {
    margin-top: -3rem !important; }
  .me-xl-n1 {
    margin-right: -0.25rem !important; }
  .me-xl-n2 {
    margin-right: -0.5rem !important; }
  .me-xl-n3 {
    margin-right: -1rem !important; }
  .me-xl-n4 {
    margin-right: -1.5rem !important; }
  .me-xl-n5 {
    margin-right: -3rem !important; }
  .mb-xl-n1 {
    margin-bottom: -0.25rem !important; }
  .mb-xl-n2 {
    margin-bottom: -0.5rem !important; }
  .mb-xl-n3 {
    margin-bottom: -1rem !important; }
  .mb-xl-n4 {
    margin-bottom: -1.5rem !important; }
  .mb-xl-n5 {
    margin-bottom: -3rem !important; }
  .ms-xl-n1 {
    margin-left: -0.25rem !important; }
  .ms-xl-n2 {
    margin-left: -0.5rem !important; }
  .ms-xl-n3 {
    margin-left: -1rem !important; }
  .ms-xl-n4 {
    margin-left: -1.5rem !important; }
  .ms-xl-n5 {
    margin-left: -3rem !important; }
  .p-xl-0 {
    padding: 0 !important; }
  .p-xl-1 {
    padding: 0.25rem !important; }
  .p-xl-2 {
    padding: 0.5rem !important; }
  .p-xl-3 {
    padding: 1rem !important; }
  .p-xl-4 {
    padding: 1.5rem !important; }
  .p-xl-5 {
    padding: 3rem !important; }
  .px-xl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important; }
  .px-xl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important; }
  .px-xl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important; }
  .px-xl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important; }
  .px-xl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important; }
  .px-xl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important; }
  .py-xl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important; }
  .py-xl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important; }
  .py-xl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important; }
  .py-xl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important; }
  .py-xl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important; }
  .py-xl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important; }
  .pt-xl-0 {
    padding-top: 0 !important; }
  .pt-xl-1 {
    padding-top: 0.25rem !important; }
  .pt-xl-2 {
    padding-top: 0.5rem !important; }
  .pt-xl-3 {
    padding-top: 1rem !important; }
  .pt-xl-4 {
    padding-top: 1.5rem !important; }
  .pt-xl-5 {
    padding-top: 3rem !important; }
  .pe-xl-0 {
    padding-right: 0 !important; }
  .pe-xl-1 {
    padding-right: 0.25rem !important; }
  .pe-xl-2 {
    padding-right: 0.5rem !important; }
  .pe-xl-3 {
    padding-right: 1rem !important; }
  .pe-xl-4 {
    padding-right: 1.5rem !important; }
  .pe-xl-5 {
    padding-right: 3rem !important; }
  .pb-xl-0 {
    padding-bottom: 0 !important; }
  .pb-xl-1 {
    padding-bottom: 0.25rem !important; }
  .pb-xl-2 {
    padding-bottom: 0.5rem !important; }
  .pb-xl-3 {
    padding-bottom: 1rem !important; }
  .pb-xl-4 {
    padding-bottom: 1.5rem !important; }
  .pb-xl-5 {
    padding-bottom: 3rem !important; }
  .ps-xl-0 {
    padding-left: 0 !important; }
  .ps-xl-1 {
    padding-left: 0.25rem !important; }
  .ps-xl-2 {
    padding-left: 0.5rem !important; }
  .ps-xl-3 {
    padding-left: 1rem !important; }
  .ps-xl-4 {
    padding-left: 1.5rem !important; }
  .ps-xl-5 {
    padding-left: 3rem !important; }
  .gap-xl-0 {
    gap: 0 !important; }
  .gap-xl-1 {
    gap: 0.25rem !important; }
  .gap-xl-2 {
    gap: 0.5rem !important; }
  .gap-xl-3 {
    gap: 1rem !important; }
  .gap-xl-4 {
    gap: 1.5rem !important; }
  .gap-xl-5 {
    gap: 3rem !important; }
  .text-xl-start {
    text-align: left !important; }
  .text-xl-end {
    text-align: right !important; }
  .text-xl-center {
    text-align: center !important; } }

@media (min-width: 1400px) {
  .float-xxl-start {
    float: left !important; }
  .float-xxl-end {
    float: right !important; }
  .float-xxl-none {
    float: none !important; }
  .d-xxl-inline {
    display: inline !important; }
  .d-xxl-inline-block {
    display: inline-block !important; }
  .d-xxl-block {
    display: block !important; }
  .d-xxl-grid {
    display: grid !important; }
  .d-xxl-table {
    display: table !important; }
  .d-xxl-table-row {
    display: table-row !important; }
  .d-xxl-table-cell {
    display: table-cell !important; }
  .d-xxl-flex {
    display: flex !important; }
  .d-xxl-inline-flex {
    display: inline-flex !important; }
  .d-xxl-none {
    display: none !important; }
  .flex-xxl-fill {
    flex: 1 1 auto !important; }
  .flex-xxl-row {
    flex-direction: row !important; }
  .flex-xxl-column {
    flex-direction: column !important; }
  .flex-xxl-row-reverse {
    flex-direction: row-reverse !important; }
  .flex-xxl-column-reverse {
    flex-direction: column-reverse !important; }
  .flex-xxl-grow-0 {
    flex-grow: 0 !important; }
  .flex-xxl-grow-1 {
    flex-grow: 1 !important; }
  .flex-xxl-shrink-0 {
    flex-shrink: 0 !important; }
  .flex-xxl-shrink-1 {
    flex-shrink: 1 !important; }
  .flex-xxl-wrap {
    flex-wrap: wrap !important; }
  .flex-xxl-nowrap {
    flex-wrap: nowrap !important; }
  .flex-xxl-wrap-reverse {
    flex-wrap: wrap-reverse !important; }
  .justify-content-xxl-start {
    justify-content: flex-start !important; }
  .justify-content-xxl-end {
    justify-content: flex-end !important; }
  .justify-content-xxl-center {
    justify-content: center !important; }
  .justify-content-xxl-between {
    justify-content: space-between !important; }
  .justify-content-xxl-around {
    justify-content: space-around !important; }
  .justify-content-xxl-evenly {
    justify-content: space-evenly !important; }
  .align-items-xxl-start {
    align-items: flex-start !important; }
  .align-items-xxl-end {
    align-items: flex-end !important; }
  .align-items-xxl-center {
    align-items: center !important; }
  .align-items-xxl-baseline {
    align-items: baseline !important; }
  .align-items-xxl-stretch {
    align-items: stretch !important; }
  .align-content-xxl-start {
    align-content: flex-start !important; }
  .align-content-xxl-end {
    align-content: flex-end !important; }
  .align-content-xxl-center {
    align-content: center !important; }
  .align-content-xxl-between {
    align-content: space-between !important; }
  .align-content-xxl-around {
    align-content: space-around !important; }
  .align-content-xxl-stretch {
    align-content: stretch !important; }
  .align-self-xxl-auto {
    align-self: auto !important; }
  .align-self-xxl-start {
    align-self: flex-start !important; }
  .align-self-xxl-end {
    align-self: flex-end !important; }
  .align-self-xxl-center {
    align-self: center !important; }
  .align-self-xxl-baseline {
    align-self: baseline !important; }
  .align-self-xxl-stretch {
    align-self: stretch !important; }
  .order-xxl-first {
    order: -1 !important; }
  .order-xxl-0 {
    order: 0 !important; }
  .order-xxl-1 {
    order: 1 !important; }
  .order-xxl-2 {
    order: 2 !important; }
  .order-xxl-3 {
    order: 3 !important; }
  .order-xxl-4 {
    order: 4 !important; }
  .order-xxl-5 {
    order: 5 !important; }
  .order-xxl-last {
    order: 6 !important; }
  .m-xxl-0 {
    margin: 0 !important; }
  .m-xxl-1 {
    margin: 0.25rem !important; }
  .m-xxl-2 {
    margin: 0.5rem !important; }
  .m-xxl-3 {
    margin: 1rem !important; }
  .m-xxl-4 {
    margin: 1.5rem !important; }
  .m-xxl-5 {
    margin: 3rem !important; }
  .m-xxl-auto {
    margin: auto !important; }
  .mx-xxl-0 {
    margin-right: 0 !important;
    margin-left: 0 !important; }
  .mx-xxl-1 {
    margin-right: 0.25rem !important;
    margin-left: 0.25rem !important; }
  .mx-xxl-2 {
    margin-right: 0.5rem !important;
    margin-left: 0.5rem !important; }
  .mx-xxl-3 {
    margin-right: 1rem !important;
    margin-left: 1rem !important; }
  .mx-xxl-4 {
    margin-right: 1.5rem !important;
    margin-left: 1.5rem !important; }
  .mx-xxl-5 {
    margin-right: 3rem !important;
    margin-left: 3rem !important; }
  .mx-xxl-auto {
    margin-right: auto !important;
    margin-left: auto !important; }
  .my-xxl-0 {
    margin-top: 0 !important;
    margin-bottom: 0 !important; }
  .my-xxl-1 {
    margin-top: 0.25rem !important;
    margin-bottom: 0.25rem !important; }
  .my-xxl-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important; }
  .my-xxl-3 {
    margin-top: 1rem !important;
    margin-bottom: 1rem !important; }
  .my-xxl-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important; }
  .my-xxl-5 {
    margin-top: 3rem !important;
    margin-bottom: 3rem !important; }
  .my-xxl-auto {
    margin-top: auto !important;
    margin-bottom: auto !important; }
  .mt-xxl-0 {
    margin-top: 0 !important; }
  .mt-xxl-1 {
    margin-top: 0.25rem !important; }
  .mt-xxl-2 {
    margin-top: 0.5rem !important; }
  .mt-xxl-3 {
    margin-top: 1rem !important; }
  .mt-xxl-4 {
    margin-top: 1.5rem !important; }
  .mt-xxl-5 {
    margin-top: 3rem !important; }
  .mt-xxl-auto {
    margin-top: auto !important; }
  .me-xxl-0 {
    margin-right: 0 !important; }
  .me-xxl-1 {
    margin-right: 0.25rem !important; }
  .me-xxl-2 {
    margin-right: 0.5rem !important; }
  .me-xxl-3 {
    margin-right: 1rem !important; }
  .me-xxl-4 {
    margin-right: 1.5rem !important; }
  .me-xxl-5 {
    margin-right: 3rem !important; }
  .me-xxl-auto {
    margin-right: auto !important; }
  .mb-xxl-0 {
    margin-bottom: 0 !important; }
  .mb-xxl-1 {
    margin-bottom: 0.25rem !important; }
  .mb-xxl-2 {
    margin-bottom: 0.5rem !important; }
  .mb-xxl-3 {
    margin-bottom: 1rem !important; }
  .mb-xxl-4 {
    margin-bottom: 1.5rem !important; }
  .mb-xxl-5 {
    margin-bottom: 3rem !important; }
  .mb-xxl-auto {
    margin-bottom: auto !important; }
  .ms-xxl-0 {
    margin-left: 0 !important; }
  .ms-xxl-1 {
    margin-left: 0.25rem !important; }
  .ms-xxl-2 {
    margin-left: 0.5rem !important; }
  .ms-xxl-3 {
    margin-left: 1rem !important; }
  .ms-xxl-4 {
    margin-left: 1.5rem !important; }
  .ms-xxl-5 {
    margin-left: 3rem !important; }
  .ms-xxl-auto {
    margin-left: auto !important; }
  .m-xxl-n1 {
    margin: -0.25rem !important; }
  .m-xxl-n2 {
    margin: -0.5rem !important; }
  .m-xxl-n3 {
    margin: -1rem !important; }
  .m-xxl-n4 {
    margin: -1.5rem !important; }
  .m-xxl-n5 {
    margin: -3rem !important; }
  .mx-xxl-n1 {
    margin-right: -0.25rem !important;
    margin-left: -0.25rem !important; }
  .mx-xxl-n2 {
    margin-right: -0.5rem !important;
    margin-left: -0.5rem !important; }
  .mx-xxl-n3 {
    margin-right: -1rem !important;
    margin-left: -1rem !important; }
  .mx-xxl-n4 {
    margin-right: -1.5rem !important;
    margin-left: -1.5rem !important; }
  .mx-xxl-n5 {
    margin-right: -3rem !important;
    margin-left: -3rem !important; }
  .my-xxl-n1 {
    margin-top: -0.25rem !important;
    margin-bottom: -0.25rem !important; }
  .my-xxl-n2 {
    margin-top: -0.5rem !important;
    margin-bottom: -0.5rem !important; }
  .my-xxl-n3 {
    margin-top: -1rem !important;
    margin-bottom: -1rem !important; }
  .my-xxl-n4 {
    margin-top: -1.5rem !important;
    margin-bottom: -1.5rem !important; }
  .my-xxl-n5 {
    margin-top: -3rem !important;
    margin-bottom: -3rem !important; }
  .mt-xxl-n1 {
    margin-top: -0.25rem !important; }
  .mt-xxl-n2 {
    margin-top: -0.5rem !important; }
  .mt-xxl-n3 {
    margin-top: -1rem !important; }
  .mt-xxl-n4 {
    margin-top: -1.5rem !important; }
  .mt-xxl-n5 {
    margin-top: -3rem !important; }
  .me-xxl-n1 {
    margin-right: -0.25rem !important; }
  .me-xxl-n2 {
    margin-right: -0.5rem !important; }
  .me-xxl-n3 {
    margin-right: -1rem !important; }
  .me-xxl-n4 {
    margin-right: -1.5rem !important; }
  .me-xxl-n5 {
    margin-right: -3rem !important; }
  .mb-xxl-n1 {
    margin-bottom: -0.25rem !important; }
  .mb-xxl-n2 {
    margin-bottom: -0.5rem !important; }
  .mb-xxl-n3 {
    margin-bottom: -1rem !important; }
  .mb-xxl-n4 {
    margin-bottom: -1.5rem !important; }
  .mb-xxl-n5 {
    margin-bottom: -3rem !important; }
  .ms-xxl-n1 {
    margin-left: -0.25rem !important; }
  .ms-xxl-n2 {
    margin-left: -0.5rem !important; }
  .ms-xxl-n3 {
    margin-left: -1rem !important; }
  .ms-xxl-n4 {
    margin-left: -1.5rem !important; }
  .ms-xxl-n5 {
    margin-left: -3rem !important; }
  .p-xxl-0 {
    padding: 0 !important; }
  .p-xxl-1 {
    padding: 0.25rem !important; }
  .p-xxl-2 {
    padding: 0.5rem !important; }
  .p-xxl-3 {
    padding: 1rem !important; }
  .p-xxl-4 {
    padding: 1.5rem !important; }
  .p-xxl-5 {
    padding: 3rem !important; }
  .px-xxl-0 {
    padding-right: 0 !important;
    padding-left: 0 !important; }
  .px-xxl-1 {
    padding-right: 0.25rem !important;
    padding-left: 0.25rem !important; }
  .px-xxl-2 {
    padding-right: 0.5rem !important;
    padding-left: 0.5rem !important; }
  .px-xxl-3 {
    padding-right: 1rem !important;
    padding-left: 1rem !important; }
  .px-xxl-4 {
    padding-right: 1.5rem !important;
    padding-left: 1.5rem !important; }
  .px-xxl-5 {
    padding-right: 3rem !important;
    padding-left: 3rem !important; }
  .py-xxl-0 {
    padding-top: 0 !important;
    padding-bottom: 0 !important; }
  .py-xxl-1 {
    padding-top: 0.25rem !important;
    padding-bottom: 0.25rem !important; }
  .py-xxl-2 {
    padding-top: 0.5rem !important;
    padding-bottom: 0.5rem !important; }
  .py-xxl-3 {
    padding-top: 1rem !important;
    padding-bottom: 1rem !important; }
  .py-xxl-4 {
    padding-top: 1.5rem !important;
    padding-bottom: 1.5rem !important; }
  .py-xxl-5 {
    padding-top: 3rem !important;
    padding-bottom: 3rem !important; }
  .pt-xxl-0 {
    padding-top: 0 !important; }
  .pt-xxl-1 {
    padding-top: 0.25rem !important; }
  .pt-xxl-2 {
    padding-top: 0.5rem !important; }
  .pt-xxl-3 {
    padding-top: 1rem !important; }
  .pt-xxl-4 {
    padding-top: 1.5rem !important; }
  .pt-xxl-5 {
    padding-top: 3rem !important; }
  .pe-xxl-0 {
    padding-right: 0 !important; }
  .pe-xxl-1 {
    padding-right: 0.25rem !important; }
  .pe-xxl-2 {
    padding-right: 0.5rem !important; }
  .pe-xxl-3 {
    padding-right: 1rem !important; }
  .pe-xxl-4 {
    padding-right: 1.5rem !important; }
  .pe-xxl-5 {
    padding-right: 3rem !important; }
  .pb-xxl-0 {
    padding-bottom: 0 !important; }
  .pb-xxl-1 {
    padding-bottom: 0.25rem !important; }
  .pb-xxl-2 {
    padding-bottom: 0.5rem !important; }
  .pb-xxl-3 {
    padding-bottom: 1rem !important; }
  .pb-xxl-4 {
    padding-bottom: 1.5rem !important; }
  .pb-xxl-5 {
    padding-bottom: 3rem !important; }
  .ps-xxl-0 {
    padding-left: 0 !important; }
  .ps-xxl-1 {
    padding-left: 0.25rem !important; }
  .ps-xxl-2 {
    padding-left: 0.5rem !important; }
  .ps-xxl-3 {
    padding-left: 1rem !important; }
  .ps-xxl-4 {
    padding-left: 1.5rem !important; }
  .ps-xxl-5 {
    padding-left: 3rem !important; }
  .gap-xxl-0 {
    gap: 0 !important; }
  .gap-xxl-1 {
    gap: 0.25rem !important; }
  .gap-xxl-2 {
    gap: 0.5rem !important; }
  .gap-xxl-3 {
    gap: 1rem !important; }
  .gap-xxl-4 {
    gap: 1.5rem !important; }
  .gap-xxl-5 {
    gap: 3rem !important; }
  .text-xxl-start {
    text-align: left !important; }
  .text-xxl-end {
    text-align: right !important; }
  .text-xxl-center {
    text-align: center !important; } }

@media (min-width: 1200px) {
  .fs-1 {
    font-size: 2.1875rem !important; }
  .fs-2 {
    font-size: 1.75rem !important; }
  .fs-3 {
    font-size: 1.53125rem !important; }
  .fs-4 {
    font-size: 1.3125rem !important; } }

@media print {
  .d-print-inline {
    display: inline !important; }
  .d-print-inline-block {
    display: inline-block !important; }
  .d-print-block {
    display: block !important; }
  .d-print-grid {
    display: grid !important; }
  .d-print-table {
    display: table !important; }
  .d-print-table-row {
    display: table-row !important; }
  .d-print-table-cell {
    display: table-cell !important; }
  .d-print-flex {
    display: flex !important; }
  .d-print-inline-flex {
    display: inline-flex !important; }
  .d-print-none {
    display: none !important; } }

/*
Template Name: Velzon - Admin & Dashboard Template
Author: Themesbrand
Version: 1.0.0
Website: https://themesbrand.com/
Contact: support@themesbrand.com
File: Main Css File
*/
@font-face {
  font-family: "hkgrotesk";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_50___});
  src: local("hkgrotesk light"), url(${___CSS_LOADER_URL_REPLACEMENT_51___}) format("woff");
  font-weight: 300; }

@font-face {
  font-family: "hkgrotesk";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_52___});
  src: local("hkgrotesk regular"), url(${___CSS_LOADER_URL_REPLACEMENT_53___}) format("woff");
  font-weight: 400; }

@font-face {
  font-family: "hkgrotesk";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_54___});
  src: local("hkgrotesk medium"), url(${___CSS_LOADER_URL_REPLACEMENT_55___}) format("woff");
  font-weight: 500; }

@font-face {
  font-family: "hkgrotesk";
  src: url(${___CSS_LOADER_URL_REPLACEMENT_56___});
  src: local("hkgrotesk semibold"), url(${___CSS_LOADER_URL_REPLACEMENT_57___}) format("woff");
  font-weight: 600; }

:root {
  --vz-body-bg: #ffffff;
  --vz-body-color: #212529;
  --vz-body-color-rgb: 33, 37, 41;
  --vz-vertical-menu-bg:                      #fff;
  --vz-vertical-menu-item-color:              #6d7080;
  --vz-vertical-menu-item-hover-color:        #5ea3cb;
  --vz-vertical-menu-item-active-color:       #5ea3cb;
  --vz-vertical-menu-sub-item-color:          #7c7f90;
  --vz-vertical-menu-sub-item-hover-color:    #5ea3cb;
  --vz-vertical-menu-sub-item-active-color:   #5ea3cb;
  --vz-vertical-menu-title-color:             #919da9;
  --vz-vertical-menu-bg-dark:                 #2e3230;
  --vz-vertical-menu-item-color-dark:         #a4b0bf;
  --vz-vertical-menu-item-hover-color-dark:   #fff;
  --vz-vertical-menu-item-active-color-dark:  #fff;
  --vz-vertical-menu-sub-item-color-dark:     #a4b0bf;
  --vz-vertical-menu-sub-item-hover-color-dark: #fff;
  --vz-vertical-menu-sub-item-active-color-dark: #fff;
  --vz-vertical-menu-title-color-dark:         #a4b0bf;
  --vz-header-bg:  #fff;
  --vz-header-item-color:  #e9ecef;
  --vz-header-bg-dark:  #323835;
  --vz-header-item-color-dark:  #a4b0bf;
  --vz-topbar-search-bg: #f3f3f9;
  --vz-topbar-user-bg: #f3f3f9;
  --vz-topbar-user-bg-dark: #39423e;
  --vz-footer-bg: #fff;
  --vz-footer-color: #98a6ad;
  --vz-topnav-bg: #fff;
  --vz-topnav-item-color: #6d7080;
  --vz-topnav-item-color-active: #5ea3cb;
  --vz-twocolumn-menu-iconview-bg: #fff;
  --vz-twocolumn-menu-bg:  #fff;
  --vz-twocolumn-menu-iconview-bg-dark: var(--vz-vertical-menu-bg-dark);
  --vz-twocolumn-menu-bg-dark:  #363a38;
  --vz-twocolumn-menu-item-color-dark: var(--vz-vertical-menu-item-color-dark);
  --vz-twocolumn-menu-item-active-color-dark:  #fff;
  --vz-twocolumn-menu-item-active-bg-dark:  rgba(255, 255, 255, 0.15);
  --vz-boxed-body-bg: whitesmoke;
  --vz-heading-color: #495057;
  --vz-light: #f3f6f9;
  --vz-light-rgb: 243, 246, 249;
  --vz-dark: #212529;
  --vz-dark-rgb: 33, 37, 41;
  --vz-link-color: #5ea3cb;
  --vz-link-hover-color: #5ea3cb;
  --vz-border-color:  #e9ebec;
  --vz-dropdown-bg: #fff;
  --vz-dropdown-link-color: #212529;
  --vz-dropdown-link-hover-color: #1e2125;
  --vz-dropdown-link-hover-bg: #f3f6f9;
  --vz-dropdown-border-width: 0;
  --vz-card-bg: #fff;
  --vz-card-cap-bg: #fff;
  --vz-card-logo-dark: block;
  --vz-card-logo-light: none;
  --vz-modal-bg: #fff;
  --vz-nav-tabs-link-active-color: #495057;
  --vz-nav-tabs-link-active-bg: #ffffff;
  --vz-accordion-button-active-color: #5593b7;
  --vz-progress-bg: #eff2f7;
  --vz-toast-background-color: rgba(255, 255, 255, 0.85);
  --vz-toast-border-color: rgba(0, 0, 0, 0.1);
  --vz-toast-header-border-color: rgba(0, 0, 0, 0.05);
  --vz-list-group-hover-bg: #f3f6f9;
  --vz-popover-bg: #fff;
  --vz-pagination-hover-bg: #eff2f7;
  --vz-input-bg: #fff;
  --vz-input-border: #ced4da;
  --vz-input-focus-border: #afd1e5;
  --vz-input-disabled-bg: #eff2f7;
  --vz-input-group-addon-bg: #eff2f7;
  --vz-input-check-border: var(--vz-input-border); }

[data-layout-mode="dark"] {
  --vz-gray-100: #1a1d21;
  --vz-gray-200: #212529;
  --vz-gray-300: #2a2f34;
  --vz-gray-400: #878a99;
  --vz-gray-500: #adb5bd;
  --vz-gray-600: #bfc8e2;
  --vz-gray-700: #ced4da;
  --vz-gray-800: #eff2f7;
  --vz-gray-900: #f3f6f9;
  --vz-body-bg:  #1a1d21;
  --vz-body-color: #ced4da;
  --vz-body-color-rgb: 206, 212, 218;
  --vz-vertical-menu-bg:                      #fff;
  --vz-vertical-menu-item-color:              #5f6270;
  --vz-vertical-menu-item-hover-color:        #5ea3cb;
  --vz-vertical-menu-item-active-color:       #5ea3cb;
  --vz-vertical-menu-sub-item-color:          #686b7b;
  --vz-vertical-menu-sub-item-hover-color:    #5ea3cb;
  --vz-vertical-menu-sub-item-active-color:   #5ea3cb;
  --vz-vertical-menu-title-color:             #878a99;
  --vz-vertical-menu-bg-dark:                 #24292d;
  --vz-vertical-menu-item-color-dark:        #89929b;
  --vz-vertical-menu-item-hover-color-dark:   #fff;
  --vz-vertical-menu-item-active-color-dark:  #fff;
  --vz-vertical-menu-sub-item-color-dark:    #89929b;
  --vz-vertical-menu-sub-item-hover-color-dark: #fff;
  --vz-vertical-menu-sub-item-active-color-dark: #fff;
  --vz-vertical-menu-title-color-dark:         #89929b;
  --vz-header-bg:  #292e32;
  --vz-header-item-color:  #e9ecef;
  --vz-header-bg-dark:   #212529;
  --vz-header-item-color-dark:  #89929b;
  --vz-topbar-search-bg: #1a1d21;
  --vz-topbar-user-bg: #31373c;
  --vz-topbar-user-bg-dark: #2f343a;
  --vz-footer-bg: #212529;
  --vz-footer-color: #878a99;
  --vz-topnav-bg: #272b30;
  --vz-topnav-item-color: #878a99;
  --vz-topnav-item-color-active: #fff;
  --vz-twocolumn-menu-iconview-bg: #fff;
  --vz-twocolumn-menu-bg:  #fff;
  --vz-twocolumn-menu-iconview-bg-dark: var(--vz-vertical-menu-bg-dark);
  --vz-twocolumn-menu-bg-dark:  #272b30;
  --vz-twocolumn-menu-item-color-dark: var(--vz-vertical-menu-item-color-dark);
  --vz-twocolumn-menu-item-active-color-dark:  #fff;
  --vz-twocolumn-menu-item-active-bg-dark:  rgba(255, 255, 255, 0.15);
  --vz-boxed-body-bg: #111316;
  --vz-heading-color: #ced4da;
  --vz-light: #2a2f34;
  --vz-light-rgb: 42, 47, 52;
  --vz-dark: #eff2f7;
  --vz-dark-rgb: 239, 242, 247;
  --vz-link-color: #ced4da;
  --vz-link-hover-color: #ced4da;
  --vz-border-color:  #32383e;
  --vz-dropdown-bg: #292e33;
  --vz-dropdown-link-color: #adb5bd;
  --vz-dropdown-link-hover-color: #b9bfc4;
  --vz-dropdown-link-hover-bg: #2f343a;
  --vz-dropdown-border-width: 1px;
  --vz-card-bg: #212529;
  --vz-card-cap-bg: #212529;
  --vz-card-logo-dark: none;
  --vz-card-logo-light: block;
  --vz-modal-bg: #212529;
  --vz-nav-tabs-link-active-color: #f3f6f9;
  --vz-nav-tabs-link-active-bg: #2a2f34;
  --vz-accordion-button-active-color: #fff;
  --vz-progress-bg: #2a2f34;
  --vz-toast-background-color: rgba(42, 47, 52, 0.85);
  --vz-toast-border-color: rgba(255, 255, 255, 0.1);
  --vz-toast-header-border-color: rgba(255, 255, 255, 0.05);
  --vz-list-group-hover-bg: #272b30;
  --vz-popover-bg: #23282c;
  --vz-pagination-hover-bg: #2a2f34;
  --vz-input-bg: #262a2f;
  --vz-input-border: #2a2f34;
  --vz-input-focus-border: #33393f;
  --vz-input-disabled-bg: #212529;
  --vz-input-group-addon-bg: #2a2f34;
  --vz-input-check-border:  #33393f; }

#page-topbar {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1002;
  background-color: var(--vz-header-bg);
  transition: all 0.1s ease-out; }
  #page-topbar.topbar-shadow {
    box-shadow: 0 1px 2px rgba(56, 65, 74, 0.15); }
  @media (min-width: 768px) {
    #page-topbar {
      left: 250px; } }

.navbar-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0 auto;
  height: 70px;
  padding: 0 1.5rem 0 calc(1.5rem / 2); }
  @media (max-width: 767.98px) {
    .navbar-header {
      padding: 0 calc(1.5rem / 2) 0 calc(1.5rem / 2); } }
  .navbar-header .topbar-head-dropdown .dropdown-menu.show {
    top: 13px !important; }
  .navbar-header .btn-topbar {
    height: 42px;
    width: 42px; }
    @media (max-width: 360px) {
      .navbar-header .btn-topbar {
        height: 36px;
        width: 36px; } }
  .navbar-header .user-name-text {
    color: var(--vz-gray-700); }

/* Search */
.app-search {
  padding: calc(32px / 2) 0; }
  .app-search .form-control {
    border: none;
    height: 38px;
    padding-left: 40px;
    padding-right: 30px;
    background-color: var(--vz-topbar-search-bg);
    box-shadow: none; }
  .app-search span.search-widget-icon {
    position: absolute;
    z-index: 10;
    font-size: 18px;
    line-height: 38px;
    left: 13px;
    top: 0;
    color: #878a99; }
  .app-search .search-widget-icon-close {
    right: 7px;
    left: auto !important; }
  @media (max-width: 1023.99px) {
    .app-search {
      padding-left: calc(1.5rem / 2); } }

.megamenu-list li {
  position: relative;
  padding: 5px 0px; }
  .megamenu-list li a {
    color: var(--vz-body-color); }

@media (max-width: 767.98px) {
  .logo span.logo-lg {
    display: none; }
  .logo span.logo-sm {
    display: inline-block; } }

.header-item {
  height: 70px;
  display: flex;
  align-items: center; }

.header-profile-user {
  height: 32px;
  width: 32px; }

.topbar-badge-sm {
  right: 0;
  top: 7px !important; }

.topbar-badge {
  right: -9px;
  top: 4px !important; }

@media (min-width: 768px) {
  .topbar-user {
    background-color: var(--vz-topbar-user-bg); } }

.topbar-user .dropdown-menu {
  top: 6px !important; }

.notification-item {
  padding: 0.75rem 1rem;
  white-space: inherit;
  position: relative; }
  .notification-item .form-check-input {
    position: relative;
    z-index: 2; }

.dropdown-icon-item {
  display: block;
  border-radius: 3px;
  line-height: 34px;
  text-align: center;
  padding: 15px 0 9px;
  border: 1px solid transparent;
  color: var(--vz-dropdown-link-color); }
  .dropdown-icon-item img {
    height: 24px; }
  .dropdown-icon-item span {
    display: block;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap; }
  .dropdown-icon-item:hover {
    background-color: var(--vz-dropdown-link-hover-bg); }

.fullscreen-enable [data-toggle="fullscreen"] .bx-fullscreen::before {
  content: "\\eacb"; }

[data-layout-mode="dark"] .light-dark-mode .bx-moon::before {
  content: "\\ec34"; }

[data-topbar="dark"] #page-topbar {
  background-color: var(--vz-header-bg-dark);
  border-color: var(--vz-header-bg-dark); }

[data-topbar="dark"] .navbar-header .btn-topbar {
  color: var(--vz-header-item-color-dark); }
  [data-topbar="dark"] .navbar-header .btn-topbar:hover, [data-topbar="dark"] .navbar-header .btn-topbar:focus {
    background-color: rgba(255, 255, 255, 0.07);
    color: #fff; }

@media (min-width: 767.99px) {
  [data-topbar="dark"] .topbar-user {
    background-color: var(--vz-topbar-user-bg-dark); } }

[data-topbar="dark"] .topbar-user .user-name-text {
  color: rgba(255, 255, 255, 0.85) !important; }

[data-topbar="dark"] .topbar-user .user-name-sub-text {
  color: var(--vz-header-item-color-dark) !important; }

[data-topbar="dark"] .logo-dark {
  display: none; }

[data-topbar="dark"] .logo-light {
  display: inline-block; }

[data-topbar="dark"] .app-search .form-control {
  background-color: rgba(255, 255, 255, 0.05);
  color: #fff; }

[data-topbar="dark"] .app-search span.search-widget-icon,
[data-topbar="dark"] .app-search input.form-control::-webkit-input-placeholder {
  color: rgba(255, 255, 255, 0.5); }

[data-topbar="dark"] .hamburger-icon span {
  background-color: #e9ebec; }

@media (max-width: 600px) {
  .navbar-header .dropdown {
    position: static; }
    .navbar-header .dropdown .dropdown-menu {
      width: 100%; } }

@media (max-width: 767.98px) {
  #search-dropdown-reponsive {
    top: 54px !important; } }

@media (min-width: 1024.1px) {
  [data-layout="vertical"][data-layout-style="detached"] #page-topbar {
    left: 0 !important;
    box-shadow: 0 1px 2px rgba(56, 65, 74, 0.15); }
  [data-layout="vertical"][data-layout-style="detached"] .horizontal-logo {
    display: inline-block;
    padding-left: 0; }
  [data-layout="vertical"][data-layout-style="detached"] .topnav-hamburger {
    visibility: hidden; }
  [data-layout="vertical"][data-layout-style="detached"] .layout-width {
    max-width: 95%;
    margin: 0 auto; }
  [data-layout="vertical"][data-layout-style="detached"][data-sidebar-size="sm"] .navbar-brand-box, [data-layout="vertical"][data-layout-style="detached"][data-sidebar-size="sm-hover"] .navbar-brand-box {
    background-color: transparent !important;
    position: relative;
    width: auto;
    text-align: left; }
    [data-layout="vertical"][data-layout-style="detached"][data-sidebar-size="sm"] .navbar-brand-box .logo-sm, [data-layout="vertical"][data-layout-style="detached"][data-sidebar-size="sm-hover"] .navbar-brand-box .logo-sm {
      display: none; }
    [data-layout="vertical"][data-layout-style="detached"][data-sidebar-size="sm"] .navbar-brand-box .logo-lg, [data-layout="vertical"][data-layout-style="detached"][data-sidebar-size="sm-hover"] .navbar-brand-box .logo-lg {
      display: block; } }

[data-layout="vertical"][data-layout-style="detached"][data-topbar="dark"] .horizontal-logo .logo-dark {
  display: none; }

[data-layout="vertical"][data-layout-style="detached"][data-topbar="dark"] .horizontal-logo .logo-light {
  display: block; }

[data-layout="horizontal"] #page-topbar {
  left: 0;
  border-bottom: 1px solid var(--vz-gray-300); }
  @media (min-width: 1024.1px) {
    [data-layout="horizontal"] #page-topbar.topbar-shadow {
      box-shadow: none; } }

[data-layout="horizontal"] .page-content {
  padding: calc(45px + 1.5rem) calc(1.5rem / 2) 60px calc(1.5rem / 2); }
  @media (min-width: 1024.1px) {
    [data-layout="horizontal"] .page-content {
      margin-top: 70px; } }

@media (min-width: 1024.1px) {
  [data-layout="horizontal"][data-layout-width="boxed"] .page-content {
    min-height: calc(100vh - 130px); } }

@media (min-width: 768px) {
  [data-layout="vertical"][data-sidebar-size="sm"] #page-topbar, [data-layout="vertical"][data-sidebar-size="sm-hover"] #page-topbar {
    left: 70px; } }

@media (min-width: 768px) {
  [data-layout="vertical"][data-sidebar-size="md"] #page-topbar {
    left: 180px; } }

@media (min-width: 768px) {
  [data-layout="twocolumn"] #page-topbar {
    left: calc(70px + 220px); } }

[data-layout="twocolumn"] .horizontal-logo {
  display: none; }

.page-title-box {
  padding: 10px 1.5rem;
  background-color: var(--vz-card-bg);
  box-shadow: 0 1px 2px rgba(56, 65, 74, 0.15);
  border-bottom: 1px solid none;
  border-top: 1px solid none;
  margin: -23px -1.5rem 1.5rem -1.5rem; }
  .page-title-box .breadcrumb {
    background-color: transparent;
    padding: 0; }
  .page-title-box h4, .page-title-box .h4 {
    font-weight: 700;
    font-size: 15px !important;
    text-transform: uppercase; }

[data-layout="horizontal"] .page-title-box {
  padding: 1.2rem 0;
  background-color: transparent !important;
  border-bottom: none;
  border-top: none;
  box-shadow: none;
  margin: 0; }
  @media (min-width: 1024.1px) {
    [data-layout="horizontal"] .page-title-box {
      margin: -19px 0 0 0; } }

[data-layout="vertical"][data-layout-style="detached"] .page-title-box {
  padding: 1.2rem 0;
  background-color: transparent !important;
  border-bottom: none;
  border-top: none;
  box-shadow: none;
  margin: 0; }
  @media (min-width: 1024.1px) {
    [data-layout="vertical"][data-layout-style="detached"] .page-title-box {
      margin: -19px 0 0 0; } }

.footer {
  bottom: 0;
  padding: 20px calc(1.5rem / 2);
  position: absolute;
  right: 0;
  color: var(--vz-footer-color);
  left: 250px;
  height: 60px;
  background-color: var(--vz-footer-bg); }
  @media (max-width: 991.98px) {
    .footer {
      left: 0; } }

[data-layout="vertical"][data-sidebar-size="sm"] .footer, [data-layout="vertical"][data-sidebar-size="sm-hover"] .footer {
  left: 70px; }
  @media (max-width: 767.98px) {
    [data-layout="vertical"][data-sidebar-size="sm"] .footer, [data-layout="vertical"][data-sidebar-size="sm-hover"] .footer {
      left: 0; } }

[data-layout="vertical"][data-sidebar-size="md"] .footer {
  left: 180px; }
  @media (max-width: 991.98px) {
    [data-layout="vertical"][data-sidebar-size="md"] .footer {
      left: 0; } }

[data-layout="horizontal"] .footer {
  left: 0 !important; }

@media (min-width: 1024.1px) {
  [data-layout="vertical"][data-layout-style="detached"] .footer {
    left: 0 !important;
    background-color: transparent; } }

@media (min-width: 768.1px) {
  [data-layout="twocolumn"] .footer {
    left: calc(70px + 220px); } }

.app-content {
  margin-left: 250px;
  overflow: hidden; }
  .app-content .content {
    padding: 0 15px 10px 15px;
    margin-top: 70px; }

.main-content {
  transition: all 0.1s ease-out; }
  @media (min-width: 768px) {
    .main-content {
      margin-left: 250px; } }

.page-content {
  padding: 100px 60px; }

.navbar-menu {
  width: 250px;
  z-index: 1002;
  background: var(--vz-vertical-menu-bg);
  border-right: 1px solid #fff;
  bottom: 0;
  margin-top: 0;
  position: fixed;
  top: 0;
  box-shadow: 0 2px 4px rgba(15, 34, 58, 0.12);
  padding: 0 0 calc(70px + 25px) 0;
  transition: all 0.1s ease-out; }
  .navbar-menu .navbar-nav .nav-link {
    display: flex;
    align-items: center;
    padding: 0.625rem 1.5rem;
    color: var(--vz-vertical-menu-item-color);
    font-size: 0.9375rem;
    font-family: "Poppins", sans-serif; }
    .navbar-menu .navbar-nav .nav-link.active {
      color: var(--vz-vertical-menu-item-active-color); }
    .navbar-menu .navbar-nav .nav-link:hover {
      color: var(--vz-vertical-menu-item-hover-color); }
    .navbar-menu .navbar-nav .nav-link i {
      display: inline-block;
      min-width: 1.75rem;
      font-size: 18px;
      line-height: inherit; }
    .navbar-menu .navbar-nav .nav-link svg {
      width: 18px;
      margin-right: 0.665rem;
      color: var(--vz-vertical-menu-item-color); }
    .navbar-menu .navbar-nav .nav-link .badge {
      margin-left: auto;
      margin-right: -2px;
      z-index: 1; }
    .navbar-menu .navbar-nav .nav-link:hover {
      color: var(--vz-vertical-menu-item-hover-color); }
      .navbar-menu .navbar-nav .nav-link:hover .icon-dual {
        color: var(--vz-vertical-menu-item-hover-color);
        fill: rgba(94, 163, 203, 0.16); }
    .navbar-menu .navbar-nav .nav-link[data-bs-toggle="collapse"]:after {
      display: block;
      content: "\\F0142";
      font-family: "Material Design Icons";
      margin-left: auto;
      transition: transform 0.2s;
      font-size: 1.05rem;
      position: absolute;
      right: 18px;
      color: var(--vz-vertical-menu-title-color); }
    .navbar-menu .navbar-nav .nav-link[data-bs-toggle="collapse"][aria-expanded="true"] {
      color: var(--vz-vertical-menu-item-active-color); }
      .navbar-menu .navbar-nav .nav-link[data-bs-toggle="collapse"][aria-expanded="true"] .icon-dual {
        color: var(--vz-vertical-menu-item-hover-color);
        fill: rgba(94, 163, 203, 0.16); }
      .navbar-menu .navbar-nav .nav-link[data-bs-toggle="collapse"][aria-expanded="true"]:after {
        transform: rotate(90deg);
        color: var(--vz-vertical-menu-item-active-color); }
      .navbar-menu .navbar-nav .nav-link[data-bs-toggle="collapse"][aria-expanded="true"]:before {
        opacity: 1;
        background-color: var(--vz-vertical-menu-item-active-color); }
    .navbar-menu .navbar-nav .nav-link.collapsed.active::after {
      transform: rotate(90deg); }
  .navbar-menu .navbar-nav .nav-sm {
    padding-left: 1.75rem; }
    .navbar-menu .navbar-nav .nav-sm .nav-link {
      padding: 0.55rem 1.5rem !important;
      color: var(--vz-vertical-menu-sub-item-color);
      white-space: none;
      position: relative;
      font-size: 0.875rem;
      font-family: "Poppins", sans-serif; }
      .navbar-menu .navbar-nav .nav-sm .nav-link:before {
        content: "";
        width: 6px;
        height: 1.5px;
        background-color: var(--vz-vertical-menu-sub-item-color);
        position: absolute;
        left: 2px;
        top: 16.5px;
        transition: all 0.4s ease-in-out;
        opacity: 0.5; }
      .navbar-menu .navbar-nav .nav-sm .nav-link:hover {
        color: var(--vz-vertical-menu-sub-item-hover-color); }
        .navbar-menu .navbar-nav .nav-sm .nav-link:hover:before {
          background-color: var(--vz-vertical-menu-sub-item-hover-color) !important;
          opacity: 1; }
      .navbar-menu .navbar-nav .nav-sm .nav-link.active {
        color: var(--vz-vertical-menu-item-active-color); }
        .navbar-menu .navbar-nav .nav-sm .nav-link.active:before {
          background-color: var(--vz-vertical-menu-item-active-color) !important; }
    .navbar-menu .navbar-nav .nav-sm .nav-sm {
      padding-left: 15px; }
      .navbar-menu .navbar-nav .nav-sm .nav-sm .nav-link:before {
        height: 5px;
        width: 5px;
        left: 5px;
        border-radius: 50%;
        background-color: transparent;
        border: 1px solid;
        top: 16px; }
  .navbar-menu .btn-vertical-sm-hover {
    color: #878a99;
    display: none; }

.navbar-brand-box {
  padding: 0 1.3rem;
  text-align: center;
  transition: all 0.1s ease-out; }
  @media (max-width: 767.98px) {
    .navbar-brand-box {
      display: none; } }

.hamburger-icon {
  width: 20px;
  height: 14px;
  position: relative;
  cursor: pointer;
  display: inline-block; }
  .hamburger-icon span {
    background-color: #878a99;
    position: absolute;
    border-radius: 2px;
    transition: 0.3s cubic-bezier(0.8, 0.5, 0.2, 1.4);
    width: 100%;
    height: 2px;
    display: block;
    left: 0px; }
    .hamburger-icon span:nth-child(1) {
      top: 0;
      width: 80%; }
    .hamburger-icon span:nth-child(2) {
      top: 6px; }
    .hamburger-icon span:nth-child(3) {
      bottom: 0;
      width: 60%; }
  .vertical-menu-btn:hover .hamburger-icon:not(.open) span:nth-child(1) {
    top: -1px; }
  .vertical-menu-btn:hover .hamburger-icon:not(.open) span:nth-child(3) {
    bottom: -1px; }
  .hamburger-icon.open {
    transform: rotate(-90deg); }
    .hamburger-icon.open span:nth-child(1) {
      left: 1px;
      top: 5px;
      width: 20px;
      transform: rotate(90deg);
      transition-delay: 150ms; }
    .hamburger-icon.open span:nth-child(2) {
      left: 3px;
      top: 13px;
      width: 10px;
      transform: rotate(45deg);
      transition-delay: 50ms; }
    .hamburger-icon.open span:nth-child(3) {
      left: 9px;
      top: 13px;
      width: 10px;
      transform: rotate(-45deg);
      transition-delay: 100ms; }

.logo {
  line-height: 70px; }
  .logo .logo-sm {
    display: none; }

.logo-light {
  display: none; }

[data-layout="vertical"] .app-menu .row {
  margin: 0; }
  [data-layout="vertical"] .app-menu .row > * {
    width: 100%;
    padding: 0; }

@media (max-width: 767.98px) {
  [data-layout="vertical"] .app-menu {
    margin-left: -100%;
    padding: 10px 0 20px 0; } }

[data-layout="vertical"] .navbar-menu .container-fluid, [data-layout="vertical"] .navbar-menu .container-sm, [data-layout="vertical"] .navbar-menu .container-md, [data-layout="vertical"] .navbar-menu .container-lg, [data-layout="vertical"] .navbar-menu .container-xl, [data-layout="vertical"] .navbar-menu .container-xxl {
  padding: 0; }

@media (max-width: 767.98px) {
  [data-layout="vertical"] .navbar-brand-box {
    display: none; } }

[data-layout="vertical"] .horizontal-logo {
  display: none; }

[data-layout="vertical"][data-sidebar-size="sm-hover"] .main-content {
  margin-left: 70px; }
  @media (max-width: 767.98px) {
    [data-layout="vertical"][data-sidebar-size="sm-hover"] .main-content {
      margin-left: 0; } }

[data-layout="vertical"][data-sidebar-size="sm-hover"] .logo span.logo-lg {
  display: none; }

[data-layout="vertical"][data-sidebar-size="sm-hover"] .logo span.logo-sm {
  display: inline-block; }

[data-layout="vertical"][data-sidebar-size="sm-hover"] .btn-vertical-sm-hover {
  display: inline-block; }

@media (min-width: 768px) {
  [data-layout="vertical"][data-sidebar-size="sm-hover"] .topnav-hamburger {
    display: none; } }

[data-layout="vertical"][data-sidebar-size="sm-hover"] .navbar-menu {
  width: 70px; }
  [data-layout="vertical"][data-sidebar-size="sm-hover"] .navbar-menu .btn-vertical-sm-hover {
    display: none; }
    [data-layout="vertical"][data-sidebar-size="sm-hover"] .navbar-menu .btn-vertical-sm-hover i.ri-record-circle-line:before {
      content: "\\EB7D"; }
  [data-layout="vertical"][data-sidebar-size="sm-hover"] .navbar-menu .navbar-nav .badge {
    display: none; }
  [data-layout="vertical"][data-sidebar-size="sm-hover"] .navbar-menu .navbar-nav .menu-title {
    text-align: center; }
    [data-layout="vertical"][data-sidebar-size="sm-hover"] .navbar-menu .navbar-nav .menu-title span {
      display: none; }
    [data-layout="vertical"][data-sidebar-size="sm-hover"] .navbar-menu .navbar-nav .menu-title i {
      display: block;
      line-height: 36px;
      font-size: 1rem; }
  [data-layout="vertical"][data-sidebar-size="sm-hover"] .navbar-menu .navbar-nav .nav-link span {
    display: none; }
  [data-layout="vertical"][data-sidebar-size="sm-hover"] .navbar-menu .navbar-nav .nav-link i {
    font-size: 22px; }
    [data-layout="vertical"][data-sidebar-size="sm-hover"] .navbar-menu .navbar-nav .nav-link i.las, [data-layout="vertical"][data-sidebar-size="sm-hover"] .navbar-menu .navbar-nav .nav-link i.lar, [data-layout="vertical"][data-sidebar-size="sm-hover"] .navbar-menu .navbar-nav .nav-link i.lab {
      font-size: 24px; }
  [data-layout="vertical"][data-sidebar-size="sm-hover"] .navbar-menu .navbar-nav .nav-link svg {
    margin-right: 0px; }
  [data-layout="vertical"][data-sidebar-size="sm-hover"] .navbar-menu .navbar-nav .nav-link:after, [data-layout="vertical"][data-sidebar-size="sm-hover"] .navbar-menu .navbar-nav .nav-link:before {
    display: none; }
  [data-layout="vertical"][data-sidebar-size="sm-hover"] .navbar-menu .navbar-nav .menu-dropdown {
    display: none; }
  [data-layout="vertical"][data-sidebar-size="sm-hover"] .navbar-menu:hover {
    width: 250px !important; }
    @media (min-width: 1024.99px) {
      [data-layout="vertical"][data-sidebar-size="sm-hover"] .navbar-menu:hover .btn-vertical-sm-hover {
        display: inline-block; }
      [data-layout="vertical"][data-sidebar-size="sm-hover"] .navbar-menu:hover .navbar-brand-box {
        text-align: left; } }
    [data-layout="vertical"][data-sidebar-size="sm-hover"] .navbar-menu:hover .navbar-nav .menu-dropdown.show {
      display: block; }
    [data-layout="vertical"][data-sidebar-size="sm-hover"] .navbar-menu:hover .nav-link i {
      font-size: 18px; }
      [data-layout="vertical"][data-sidebar-size="sm-hover"] .navbar-menu:hover .nav-link i.las, [data-layout="vertical"][data-sidebar-size="sm-hover"] .navbar-menu:hover .nav-link i.lar, [data-layout="vertical"][data-sidebar-size="sm-hover"] .navbar-menu:hover .nav-link i.lab {
        font-size: 20px; }
    [data-layout="vertical"][data-sidebar-size="sm-hover"] .navbar-menu:hover .nav-link svg {
      margin-right: 0.665rem; }
    [data-layout="vertical"][data-sidebar-size="sm-hover"] .navbar-menu:hover .nav-link span, [data-layout="vertical"][data-sidebar-size="sm-hover"] .navbar-menu:hover .nav-link:after, [data-layout="vertical"][data-sidebar-size="sm-hover"] .navbar-menu:hover .nav-link:before {
      display: inline-block; }
    [data-layout="vertical"][data-sidebar-size="sm-hover"] .navbar-menu:hover .logo span.logo-lg {
      display: inline-block; }
    [data-layout="vertical"][data-sidebar-size="sm-hover"] .navbar-menu:hover .logo span.logo-sm {
      display: none; }
    [data-layout="vertical"][data-sidebar-size="sm-hover"] .navbar-menu:hover .menu-title {
      text-align: left; }
      [data-layout="vertical"][data-sidebar-size="sm-hover"] .navbar-menu:hover .menu-title span {
        display: inline-block; }
      [data-layout="vertical"][data-sidebar-size="sm-hover"] .navbar-menu:hover .menu-title i {
        display: none; }

@media (min-width: 1025px) {
  [data-layout="vertical"][data-sidebar-size="sm-hover"] .navbar-header, [data-layout="vertical"][data-sidebar-size="sm-hover-active"] .navbar-header {
    padding-left: 1.5rem; } }

[data-layout="vertical"][data-sidebar-size="sm-hover-active"] .navbar-brand-box {
  text-align: left; }

[data-layout="vertical"][data-sidebar-size="sm-hover-active"] .topnav-hamburger {
  display: none; }

[data-layout="vertical"][data-sidebar-size="sm-hover-active"] .btn-vertical-sm-hover {
  display: inline-block; }

@media (min-width: 768px) {
  [data-layout="vertical"][data-sidebar-size="sm"] {
    min-height: 1400px; }
    [data-layout="vertical"][data-sidebar-size="sm"] .main-content {
      margin-left: 70px; } }

@media (max-width: 767.98px) {
  [data-layout="vertical"][data-sidebar-size="sm"] .app-menu {
    margin-left: 0; } }

[data-layout="vertical"][data-sidebar-size="sm"] #page-topbar {
  z-index: calc(1002 + 1); }

[data-layout="vertical"][data-sidebar-size="sm"] .navbar-brand-box {
  position: fixed;
  padding: 0;
  width: 70px;
  z-index: 1;
  top: 0;
  background: var(--vz-vertical-menu-bg); }

[data-layout="vertical"][data-sidebar-size="sm"] .logo span.logo-lg {
  display: none; }

[data-layout="vertical"][data-sidebar-size="sm"] .logo span.logo-sm {
  display: inline-block; }

[data-layout="vertical"][data-sidebar-size="sm"] .navbar-menu {
  position: absolute;
  width: 70px !important;
  padding-top: 70px; }
  [data-layout="vertical"][data-sidebar-size="sm"] .navbar-menu .simplebar-mask,
  [data-layout="vertical"][data-sidebar-size="sm"] .navbar-menu .simplebar-content-wrapper {
    overflow: visible !important; }
  [data-layout="vertical"][data-sidebar-size="sm"] .navbar-menu .simplebar-scrollbar,
  [data-layout="vertical"][data-sidebar-size="sm"] .navbar-menu .vertical-menu-btn {
    display: none !important; }
  [data-layout="vertical"][data-sidebar-size="sm"] .navbar-menu .simplebar-offset {
    bottom: 0 !important; }
  [data-layout="vertical"][data-sidebar-size="sm"] .navbar-menu .navbar-nav .badge {
    display: none !important; }
  [data-layout="vertical"][data-sidebar-size="sm"] .navbar-menu .navbar-nav .menu-title {
    text-align: center;
    font-size: 1rem; }
    [data-layout="vertical"][data-sidebar-size="sm"] .navbar-menu .navbar-nav .menu-title span {
      display: none; }
    [data-layout="vertical"][data-sidebar-size="sm"] .navbar-menu .navbar-nav .menu-title i {
      display: block;
      line-height: 36px; }
  [data-layout="vertical"][data-sidebar-size="sm"] .navbar-menu .navbar-nav .nav-link span {
    display: none; }
  [data-layout="vertical"][data-sidebar-size="sm"] .navbar-menu .navbar-nav .nav-link i {
    font-size: 22px; }
  [data-layout="vertical"][data-sidebar-size="sm"] .navbar-menu .navbar-nav .nav-link svg {
    margin-right: 0px; }
  [data-layout="vertical"][data-sidebar-size="sm"] .navbar-menu .navbar-nav .nav-link:after, [data-layout="vertical"][data-sidebar-size="sm"] .navbar-menu .navbar-nav .nav-link:before {
    display: none; }
  [data-layout="vertical"][data-sidebar-size="sm"] .navbar-menu .navbar-nav .menu-dropdown {
    display: none;
    height: auto !important; }
  [data-layout="vertical"][data-sidebar-size="sm"] .navbar-menu .navbar-nav .nav-item {
    position: relative; }
    [data-layout="vertical"][data-sidebar-size="sm"] .navbar-menu .navbar-nav .nav-item:hover > a.menu-link {
      position: relative;
      width: calc(200px + 70px);
      color: #fff;
      background-color: var(--vz-vertical-menu-bg-dark);
      transition: none; }
      [data-layout="vertical"][data-sidebar-size="sm"] .navbar-menu .navbar-nav .nav-item:hover > a.menu-link .icon-dual {
        color: var(--vz-vertical-menu-item-hover-color-dark);
        fill: rgba(255, 255, 255, 0.16); }
      [data-layout="vertical"][data-sidebar-size="sm"] .navbar-menu .navbar-nav .nav-item:hover > a.menu-link span {
        display: inline-block;
        padding-left: 25px; }
      [data-layout="vertical"][data-sidebar-size="sm"] .navbar-menu .navbar-nav .nav-item:hover > a.menu-link:after {
        display: block;
        transform: rotate(90deg);
        color: #fff; }
    [data-layout="vertical"][data-sidebar-size="sm"] .navbar-menu .navbar-nav .nav-item:hover > .menu-dropdown {
      display: block;
      left: 70px;
      position: absolute;
      width: 200px;
      background: var(--vz-vertical-menu-bg);
      height: auto !important;
      padding: 0.5rem 0;
      border-radius: 0 0 3px 3px;
      box-shadow: 0 2px 4px rgba(15, 34, 58, 0.12); }
  [data-layout="vertical"][data-sidebar-size="sm"] .navbar-menu .navbar-nav .nav-sm {
    padding: 0; }
    [data-layout="vertical"][data-sidebar-size="sm"] .navbar-menu .navbar-nav .nav-sm .nav-item:hover > .nav-link {
      color: #E53E3E; }
      [data-layout="vertical"][data-sidebar-size="sm"] .navbar-menu .navbar-nav .nav-sm .nav-item:hover > .nav-link:after {
        color: inherit; }
    [data-layout="vertical"][data-sidebar-size="sm"] .navbar-menu .navbar-nav .nav-sm .nav-link:after {
      display: block !important;
      transform: rotate(0deg) !important; }
    [data-layout="vertical"][data-sidebar-size="sm"] .navbar-menu .navbar-nav .nav-sm .menu-dropdown {
      left: 100% !important;
      top: 0;
      border-radius: 3px !important; }

@media (min-width: 768px) {
  [data-layout="vertical"][data-sidebar-size="md"] .main-content {
    margin-left: 180px; } }

[data-layout="vertical"][data-sidebar-size="md"] .navbar-brand-box {
  width: 180px; }

[data-layout="vertical"][data-sidebar-size="md"] .navbar-menu {
  width: 180px !important; }
  [data-layout="vertical"][data-sidebar-size="md"] .navbar-menu .navbar-nav .nav-link {
    display: block;
    text-align: center;
    padding: 0.55rem 0.525rem; }
    [data-layout="vertical"][data-sidebar-size="md"] .navbar-menu .navbar-nav .nav-link i {
      display: block; }
    [data-layout="vertical"][data-sidebar-size="md"] .navbar-menu .navbar-nav .nav-link svg {
      display: block;
      margin-left: auto;
      margin-right: auto; }
    [data-layout="vertical"][data-sidebar-size="md"] .navbar-menu .navbar-nav .nav-link:before {
      display: none !important; }
    [data-layout="vertical"][data-sidebar-size="md"] .navbar-menu .navbar-nav .nav-link[data-bs-toggle="collapse"]:after {
      position: relative;
      display: inline-block;
      right: 0;
      top: 3px; }
    [data-layout="vertical"][data-sidebar-size="md"] .navbar-menu .navbar-nav .nav-link.menu-link[data-bs-toggle="collapse"]:after {
      display: none; }
  [data-layout="vertical"][data-sidebar-size="md"] .navbar-menu .navbar-nav .badge {
    display: none !important; }
  [data-layout="vertical"][data-sidebar-size="md"] .navbar-menu .navbar-nav .nav-sm {
    padding-left: 0; }
  [data-layout="vertical"][data-sidebar-size="md"] .navbar-menu .menu-title {
    text-align: center; }
    [data-layout="vertical"][data-sidebar-size="md"] .navbar-menu .menu-title span {
      text-decoration: underline; }

[data-layout="vertical"][data-sidebar="dark"] .navbar-menu {
  background: #F7FAFC;
  border-right: 1px solid #F7FAFC; }
  [data-layout="vertical"][data-sidebar="dark"] .navbar-menu .hamburger-icon span {
    background-color: var(--vz-vertical-menu-item-color-dark); }
  [data-layout="vertical"][data-sidebar="dark"] .navbar-menu .btn-vertical-sm-hover {
    color: var(--vz-vertical-menu-item-color-dark); }

[data-layout="vertical"][data-sidebar="dark"] .navbar-nav .nav-link {
  color: #212529; }
  [data-layout="vertical"][data-sidebar="dark"] .navbar-nav .nav-link.active {
    color: var(--vz-vertical-menu-item-active-color-dark); }
  [data-layout="vertical"][data-sidebar="dark"] .navbar-nav .nav-link[data-bs-toggle="collapse"]:after {
    color: inherit; }
  [data-layout="vertical"][data-sidebar="dark"] .navbar-nav .nav-link[data-bs-toggle="collapse"][aria-expanded="true"] {
    color: var(--vz-vertical-menu-item-active-color-dark); }
    [data-layout="vertical"][data-sidebar="dark"] .navbar-nav .nav-link[data-bs-toggle="collapse"][aria-expanded="true"]:after {
      color: inherit; }
    [data-layout="vertical"][data-sidebar="dark"] .navbar-nav .nav-link[data-bs-toggle="collapse"][aria-expanded="true"] .icon-dual {
      color: var(--vz-vertical-menu-item-active-color-dark);
      fill: rgba(255, 255, 255, 0.1); }
  [data-layout="vertical"][data-sidebar="dark"] .navbar-nav .nav-link svg {
    color: var(--vz-vertical-menu-item-color-dark);
    fill: rgba(255, 255, 255, 0.1); }
  [data-layout="vertical"][data-sidebar="dark"] .navbar-nav .nav-link:hover {
    color: #E53E3E; }
    [data-layout="vertical"][data-sidebar="dark"] .navbar-nav .nav-link:hover .icon-dual {
      color: #E53E3E;
      fill: rgba(255, 255, 255, 0.16); }

[data-layout="vertical"][data-sidebar="dark"] .navbar-nav > .nav-item {
  margin: 10px 15px; }
  [data-layout="vertical"][data-sidebar="dark"] .navbar-nav > .nav-item .nav-link.active {
    color: #E53E3E;
    background-color: #FFE7E7;
    border-radius: 10px; }
    [data-layout="vertical"][data-sidebar="dark"] .navbar-nav > .nav-item .nav-link.active .icon-dual {
      color: #E53E3E;
      fill: rgba(255, 255, 255, 0.16); }

[data-layout="vertical"][data-sidebar="dark"] .navbar-nav .nav-sm .nav-link {
  color: #212529; }
  [data-layout="vertical"][data-sidebar="dark"] .navbar-nav .nav-sm .nav-link:before {
    background-color: var(--vz-vertical-menu-sub-item-color-dark) !important; }
  [data-layout="vertical"][data-sidebar="dark"] .navbar-nav .nav-sm .nav-link:hover {
    color: #E53E3E; }
    [data-layout="vertical"][data-sidebar="dark"] .navbar-nav .nav-sm .nav-link:hover:before {
      background-color: #E53E3E !important; }
  [data-layout="vertical"][data-sidebar="dark"] .navbar-nav .nav-sm .nav-link.active {
    color: #E53E3E;
    background-color: #FBE7E6;
    border-radius: 10px;
    margin-right: 20px; }

[data-layout="vertical"][data-sidebar="dark"] .navbar-nav .nav-sm .nav-sm .nav-link:before {
  background-color: transparent !important; }

[data-layout="vertical"][data-sidebar="dark"] .navbar-nav .nav-sm .nav-sm .nav-link:hover:before {
  background-color: var(--vz-vertical-menu-item-hover-color-dark) !important; }

[data-layout="vertical"][data-sidebar="dark"] .navbar-nav .nav-sm .nav-sm .nav-link.active {
  color: #E53E3E; }
  [data-layout="vertical"][data-sidebar="dark"] .navbar-nav .nav-sm .nav-sm .nav-link.active:before {
    background-color: var(--vz-vertical-menu-item-active-color-dark) !important; }

[data-layout="vertical"][data-sidebar="dark"][data-sidebar-size="sm"] .navbar-brand-box {
  background: var(--vz-vertical-menu-bg-dark); }

[data-layout="vertical"][data-sidebar="dark"][data-sidebar-size="sm"] .navbar-menu .navbar-nav .nav-item:hover > .menu-dropdown {
  background: var(--vz-vertical-menu-bg-dark); }

[data-layout="vertical"][data-sidebar="dark"][data-sidebar-size="sm"] .navbar-menu .navbar-nav .nav-sm {
  padding: 0; }
  [data-layout="vertical"][data-sidebar="dark"][data-sidebar-size="sm"] .navbar-menu .navbar-nav .nav-sm .nav-link:after {
    display: block !important;
    transform: rotate(0deg) !important; }
  [data-layout="vertical"][data-sidebar="dark"][data-sidebar-size="sm"] .navbar-menu .navbar-nav .nav-sm .nav-item:hover > .nav-link {
    color: var(--vz-vertical-menu-item-active-color-dark); }
    [data-layout="vertical"][data-sidebar="dark"][data-sidebar-size="sm"] .navbar-menu .navbar-nav .nav-sm .nav-item:hover > .nav-link:after {
      color: inherit; }
  [data-layout="vertical"][data-sidebar="dark"][data-sidebar-size="sm"] .navbar-menu .navbar-nav .nav-sm .menu-dropdown {
    left: 100% !important;
    top: 0;
    border-radius: 3px !important; }

[data-layout="vertical"][data-sidebar="dark"] .menu-title {
  color: #212529; }

[data-layout="vertical"][data-sidebar="dark"] .logo-dark {
  display: none; }

[data-layout="vertical"][data-sidebar="dark"] .logo-light {
  display: inline-block; }

[data-layout="vertical"][data-sidebar="light"] .logo-dark {
  display: inline-block; }

[data-layout="vertical"][data-sidebar="light"] .logo-light {
  display: none; }

[data-layout="vertical"][data-layout-style="detached"] #layout-wrapper,
[data-layout="vertical"][data-layout-style="detached"] .main-content {
  min-height: 100vh; }

@media (min-width: 1024.1px) {
  [data-layout="vertical"][data-layout-style="detached"] .main-content {
    position: relative; }
  [data-layout="vertical"][data-layout-style="detached"] #layout-wrapper {
    max-width: 95%;
    margin: 0 auto;
    padding-left: 1.5rem; }
  [data-layout="vertical"][data-layout-style="detached"] .navbar-header {
    padding-left: 1.5rem; }
  [data-layout="vertical"][data-layout-style="detached"] .navbar-menu {
    top: calc(70px + 1.5rem);
    bottom: 1.5rem;
    padding: 0;
    border-right: var(--vz-vertical-menu-bg);
    border-radius: 5px;
    padding: 10px 0;
    z-index: 1; }
    [data-layout="vertical"][data-layout-style="detached"] .navbar-menu .navbar-brand-box {
      display: none; }
  [data-layout="vertical"][data-layout-style="detached"][data-sidebar="dark"] .logo-dark {
    display: inline-block; }
  [data-layout="vertical"][data-layout-style="detached"][data-sidebar="dark"] .logo-light {
    display: none; } }

[data-layout="vertical"][data-layout-style="detached"] .footer {
  border-top: 1px dashed var(--vz-border-color); }

[data-layout="vertical"][data-layout-style="detached"] .auth-page-wrapper .footer {
  border-top: none; }

@media (min-width: 768px) {
  [data-layout="vertical"][data-layout-style="detached"][data-sidebar-size="sm"] #layout-wrapper,
  [data-layout="vertical"][data-layout-style="detached"][data-sidebar-size="sm"] .main-content {
    min-height: 1400px; } }

.menu-title {
  letter-spacing: 0.05em;
  cursor: default;
  font-size: 11px;
  text-transform: uppercase;
  color: var(--vz-vertical-menu-title-color);
  font-weight: 600; }
  .menu-title span {
    padding: 12px 20px;
    display: inline-block; }
  .menu-title i {
    display: none; }

.vertical-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(33, 37, 41, 0.35);
  z-index: 1003;
  display: none; }

.vertical-sidebar-enable .vertical-overlay {
  display: block; }

.vertical-sidebar-enable .app-menu {
  margin-left: 0 !important;
  z-index: 1004; }

[dir="rtl"] .navbar-menu .navbar-nav .nav-link[data-bs-toggle="collapse"]:after {
  transform: rotate(180deg); }

[dir="rtl"] .navbar-menu .navbar-nav .nav-link[data-bs-toggle="collapse"][aria-expanded="true"]:after {
  transform: rotate(270deg); }

[data-layout="horizontal"] .main-content {
  margin-left: 0; }

@media (min-width: 1024.1px) {
  [data-layout="horizontal"] .layout-width,
  [data-layout="horizontal"] .container-fluid,
  [data-layout="horizontal"] .container-sm,
  [data-layout="horizontal"] .container-md,
  [data-layout="horizontal"] .container-lg,
  [data-layout="horizontal"] .container-xl,
  [data-layout="horizontal"] .container-xxl {
    max-width: 90%;
    margin: 0 auto; }
  [data-layout="horizontal"] .topnav-hamburger {
    visibility: hidden; } }

[data-layout="horizontal"] .horizontal-logo {
  padding-left: calc(1.5rem / 2); }
  @media (max-width: 1024.98px) {
    [data-layout="horizontal"] .horizontal-logo {
      padding-left: 1.5rem; } }

[data-layout="horizontal"] .navbar-menu {
  background: var(--vz-topnav-bg);
  padding: 0 calc(1.5rem / 2);
  box-shadow: 0 2px 4px rgba(15, 34, 58, 0.12);
  margin-top: 70px;
  position: fixed;
  left: 0;
  right: 0;
  z-index: 100;
  width: 100%;
  bottom: auto; }
  @media (max-width: 575.98px) {
    [data-layout="horizontal"] .navbar-menu .container-fluid, [data-layout="horizontal"] .navbar-menu .container-sm, [data-layout="horizontal"] .navbar-menu .container-md, [data-layout="horizontal"] .navbar-menu .container-lg, [data-layout="horizontal"] .navbar-menu .container-xl, [data-layout="horizontal"] .navbar-menu .container-xxl {
      padding: 0; } }
  [data-layout="horizontal"] .navbar-menu .navbar-nav {
    flex-direction: row; }
    [data-layout="horizontal"] .navbar-menu .navbar-nav .nav-sm {
      padding-left: 0; }
      [data-layout="horizontal"] .navbar-menu .navbar-nav .nav-sm .nav-link:before {
        opacity: 0 !important; }
      [data-layout="horizontal"] .navbar-menu .navbar-nav .nav-sm .nav-link:hover, [data-layout="horizontal"] .navbar-menu .navbar-nav .nav-sm .nav-link.active {
        color: var(--vz-topnav-item-color-active); }
    [data-layout="horizontal"] .navbar-menu .navbar-nav .nav-link {
      color: var(--vz-topnav-item-color);
      padding: 0.75rem 1.5rem; }
      [data-layout="horizontal"] .navbar-menu .navbar-nav .nav-link i {
        line-height: 1; }
      [data-layout="horizontal"] .navbar-menu .navbar-nav .nav-link.active {
        color: var(--vz-topnav-item-color-active); }
      [data-layout="horizontal"] .navbar-menu .navbar-nav .nav-link[data-bs-toggle="collapse"][aria-expanded="true"] {
        color: var(--vz-topnav-item-color-active); }
        [data-layout="horizontal"] .navbar-menu .navbar-nav .nav-link[data-bs-toggle="collapse"][aria-expanded="true"] .icon-dual {
          color: var(--vz-topnav-item-color-active);
          fill: rgba(94, 163, 203, 0.1); }
        [data-layout="horizontal"] .navbar-menu .navbar-nav .nav-link[data-bs-toggle="collapse"][aria-expanded="true"]:after {
          color: var(--vz-topnav-item-color-active); }
      [data-layout="horizontal"] .navbar-menu .navbar-nav .nav-link:hover .icon-dual {
        color: var(--vz-topnav-item-color-active);
        fill: rgba(94, 163, 203, 0.1); }
    [data-layout="horizontal"] .navbar-menu .navbar-nav > .nav-item > .nav-link[data-bs-toggle="collapse"]:after {
      right: 0px;
      transform: rotate(90deg) !important; }
    [data-layout="horizontal"] .navbar-menu .navbar-nav > li:nth-of-type(2) > .nav-link.menu-link {
      padding-left: 0; }
  [data-layout="horizontal"] .navbar-menu .navbar-brand-box {
    display: none; }

[data-layout="horizontal"] .navbar-nav .nav-item {
  position: relative; }
  [data-layout="horizontal"] .navbar-nav .nav-item .nav-link[data-bs-toggle="collapse"]:after {
    right: 10px;
    transform: rotate(0deg) !important; }
  [data-layout="horizontal"] .navbar-nav .nav-item > .nav-link > .badge {
    margin-right: -10px; }
  [data-layout="horizontal"] .navbar-nav .nav-item:hover > .nav-link {
    color: var(--vz-topnav-item-color-active); }
    [data-layout="horizontal"] .navbar-nav .nav-item:hover > .nav-link .icon-dual {
      color: var(--vz-topnav-item-color-active);
      fill: rgba(94, 163, 203, 0.1); }
    [data-layout="horizontal"] .navbar-nav .nav-item:hover > .nav-link:after {
      color: var(--vz-topnav-item-color-active); }
  @media (min-width: 1024.1px) {
    [data-layout="horizontal"] .navbar-nav .nav-item:hover > .menu-dropdown {
      display: block;
      height: auto !important; } }

[data-layout="horizontal"] .menu-dropdown {
  position: absolute;
  min-width: 12rem;
  padding: 0.5rem 0;
  box-shadow: 0 0px 5px rgba(15, 34, 58, 0.15);
  animation-name: DropDownSlide;
  animation-duration: 0.3s;
  animation-fill-mode: both;
  margin: 0;
  z-index: 1000;
  background-color: var(--vz-dropdown-bg);
  background-clip: padding-box;
  border: var(--vz-dropdown-border-width) solid var(--vz-border-color);
  border-radius: 0.3rem;
  display: none; }
  [data-layout="horizontal"] .menu-dropdown .menu-dropdown {
    top: 0;
    left: 100%; }

[data-layout="horizontal"] .mega-dropdown-menu {
  width: 40rem; }

[data-layout="horizontal"] .menu-title {
  display: none; }

[data-layout="horizontal"] .dropdown-custom-right {
  left: -100% !important;
  right: 100%; }

@media (max-width: 1024px) {
  [data-layout="horizontal"] .navbar-menu {
    display: none; } }

@media (max-width: 1024px) {
  [data-layout="horizontal"] .menu .navbar-menu {
    display: block;
    max-height: 360px;
    overflow-y: auto;
    padding-left: 0; }
    [data-layout="horizontal"] .menu .navbar-menu .navbar-nav {
      flex-direction: column; }
      [data-layout="horizontal"] .menu .navbar-menu .navbar-nav > li:nth-of-type(2) > .nav-link.menu-link {
        padding-left: 1.5rem; }
      [data-layout="horizontal"] .menu .navbar-menu .navbar-nav .nav-sm .nav-link:before {
        opacity: 1 !important; }
  [data-layout="horizontal"] .menu .menu-dropdown {
    position: relative;
    min-width: 100%;
    box-shadow: none;
    padding-left: 28px;
    left: 0;
    animation: none;
    padding-top: 0; }
    [data-layout="horizontal"] .menu .menu-dropdown.show {
      display: block; }
  [data-layout="horizontal"] .menu .dropdown-custom-right {
    left: 0 !important; }
  [data-layout="horizontal"] .menu .nav-item .nav-link[data-bs-toggle="collapse"]:after {
    right: 0px; }
  [data-layout="horizontal"] .menu .mega-dropdown-menu {
    width: 100%; } }

[data-layout-mode="dark"][data-topbar="light"] .navbar-header .horizontal-logo .logo-dark {
  display: none; }

[data-layout-mode="dark"][data-topbar="light"] .navbar-header .horizontal-logo .logo-light {
  display: block; }

[dir="rtl"][data-layout="horizontal"] .navbar-menu .navbar-nav > .nav-item > .nav-link[data-bs-toggle="collapse"]:after {
  transform: rotate(-90deg) !important; }

[dir="rtl"][data-layout="horizontal"] .navbar-nav .nav-item .nav-link[data-bs-toggle="collapse"]:after {
  transform: rotate(-180deg) !important; }

[data-layout="twocolumn"] .app-menu {
  padding-bottom: 0;
  width: 220px;
  left: 70px; }
  [data-layout="twocolumn"] .app-menu .menu-link {
    letter-spacing: .05em;
    cursor: default;
    font-size: 11px;
    text-transform: uppercase;
    color: var(--vz-vertical-menu-title-color) !important;
    font-weight: 600; }
    [data-layout="twocolumn"] .app-menu .menu-link:after {
      display: none !important; }
    [data-layout="twocolumn"] .app-menu .menu-link i {
      display: none; }
  [data-layout="twocolumn"] .app-menu .navbar-nav {
    height: calc(100vh - 70px); }
    @media (max-width: 767.98px) {
      [data-layout="twocolumn"] .app-menu .navbar-nav {
        padding-top: 16px; } }
    [data-layout="twocolumn"] .app-menu .navbar-nav > li:not(.twocolumn-item-show) {
      display: none; }
    [data-layout="twocolumn"] .app-menu .navbar-nav .twocolumn-item-show > div {
      display: block !important;
      height: auto !important; }
    [data-layout="twocolumn"] .app-menu .navbar-nav > .nav-item > .menu-dropdown {
      display: block !important;
      height: auto !important; }
    [data-layout="twocolumn"] .app-menu .navbar-nav .nav-item .menu-dropdown .row {
      margin: 0; }
      [data-layout="twocolumn"] .app-menu .navbar-nav .nav-item .menu-dropdown .row .col-lg-4 {
        width: 100%;
        padding: 0; }
    [data-layout="twocolumn"] .app-menu .navbar-nav .nav-sm .nav-link {
      color: var(--vz-vertical-menu-item-color); }
      [data-layout="twocolumn"] .app-menu .navbar-nav .nav-sm .nav-link.active {
        color: var(--vz-vertical-menu-item-active-color); }
  [data-layout="twocolumn"] .app-menu .container-fluid, [data-layout="twocolumn"] .app-menu .container-sm, [data-layout="twocolumn"] .app-menu .container-md, [data-layout="twocolumn"] .app-menu .container-lg, [data-layout="twocolumn"] .app-menu .container-xl, [data-layout="twocolumn"] .app-menu .container-xxl {
    padding: 0; }

[data-layout="twocolumn"] .main-content {
  margin-left: calc(220px + 70px); }
  @media (max-width: 767.98px) {
    [data-layout="twocolumn"] .main-content {
      margin-left: 70px; } }

[data-layout="twocolumn"] .twocolumn-iconview {
  width: 70px;
  background-color: var(--vz-twocolumn-menu-iconview-bg);
  height: 100%;
  left: -70px;
  box-shadow: 0 2px 4px rgba(15, 34, 58, 0.12);
  top: 0;
  position: absolute;
  padding: 0;
  text-align: center; }
  [data-layout="twocolumn"] .twocolumn-iconview li {
    position: relative;
    list-style: none; }
    [data-layout="twocolumn"] .twocolumn-iconview li .nav-icon::after {
      content: "";
      position: absolute;
      top: 0;
      right: 0;
      bottom: 0;
      left: 0; }
  [data-layout="twocolumn"] .twocolumn-iconview .nav-icon {
    width: 42px;
    height: 42px;
    line-height: 42px;
    color: var(--vz-vertical-menu-item-color);
    z-index: 1;
    font-size: 22px;
    text-align: center;
    border-radius: 3px;
    margin: 5px 0;
    display: inline-flex;
    justify-content: center;
    align-items: center; }
    [data-layout="twocolumn"] .twocolumn-iconview .nav-icon .icon-dual {
      width: 18px;
      color: var(--vz-vertical-menu-item-color); }
    [data-layout="twocolumn"] .twocolumn-iconview .nav-icon.active {
      background-color: rgba(94, 163, 203, 0.15);
      color: #5ea3cb; }
      [data-layout="twocolumn"] .twocolumn-iconview .nav-icon.active .icon-dual {
        color: #5ea3cb;
        fill: rgba(94, 163, 203, 0.1); }

[data-layout="twocolumn"] .menu-title {
  display: none; }

@media (max-width: 991.98px) {
  [data-layout="twocolumn"] .logo span.logo-lg {
    display: block; }
  [data-layout="twocolumn"] .logo span.logo-sm {
    display: none; } }

[data-layout="twocolumn"][data-sidebar="light"] .app-menu .navbar-brand-box .logo-light {
  display: none; }

[data-layout="twocolumn"][data-sidebar="light"] .app-menu .navbar-brand-box .logo-dark {
  display: block; }

[data-layout="twocolumn"][data-sidebar="dark"] .twocolumn-iconview {
  background-color: var(--vz-twocolumn-menu-iconview-bg-dark); }
  [data-layout="twocolumn"][data-sidebar="dark"] .twocolumn-iconview .nav-icon {
    color: var(--vz-twocolumn-menu-item-color-dark); }
    [data-layout="twocolumn"][data-sidebar="dark"] .twocolumn-iconview .nav-icon.active {
      color: var(--vz-twocolumn-menu-item-active-color-dark);
      background-color: var(--vz-twocolumn-menu-item-active-bg-dark); }

[data-layout="twocolumn"][data-sidebar="dark"] .app-menu {
  background-color: var(--vz-twocolumn-menu-bg-dark);
  border-right-color: var(--vz-twocolumn-menu-bg-dark); }
  [data-layout="twocolumn"][data-sidebar="dark"] .app-menu .navbar-brand-box .logo-light {
    display: block; }
  [data-layout="twocolumn"][data-sidebar="dark"] .app-menu .navbar-brand-box .logo-dark {
    display: none; }
  [data-layout="twocolumn"][data-sidebar="dark"] .app-menu .navbar-nav .nav-sm .nav-link {
    color: var(--vz-twocolumn-menu-item-color-dark); }

[data-layout="twocolumn"][data-sidebar="dark"] .navbar-menu .navbar-nav .nav-sm .nav-link:hover, [data-layout="twocolumn"][data-sidebar="dark"] .navbar-menu .navbar-nav .nav-sm .nav-link.active {
  color: var(--vz-twocolumn-menu-item-active-color-dark); }
  [data-layout="twocolumn"][data-sidebar="dark"] .navbar-menu .navbar-nav .nav-sm .nav-link:hover::before, [data-layout="twocolumn"][data-sidebar="dark"] .navbar-menu .navbar-nav .nav-sm .nav-link.active::before {
    background-color: var(--vz-twocolumn-menu-item-active-color-dark) !important; }

[data-layout="twocolumn"][data-sidebar="dark"] .navbar-menu .navbar-nav .nav-link[data-bs-toggle=collapse][aria-expanded=true] {
  color: var(--vz-twocolumn-menu-item-active-color-dark); }
  [data-layout="twocolumn"][data-sidebar="dark"] .navbar-menu .navbar-nav .nav-link[data-bs-toggle=collapse][aria-expanded=true]:before {
    background-color: var(--vz-twocolumn-menu-item-active-color-dark); }
  [data-layout="twocolumn"][data-sidebar="dark"] .navbar-menu .navbar-nav .nav-link[data-bs-toggle=collapse][aria-expanded=true]::after {
    color: var(--vz-twocolumn-menu-item-active-color-dark) !important; }

[data-layout="twocolumn"] .twocolumn-panel .app-menu {
  width: 0; }
  @media (max-width: 575.98px) {
    [data-layout="twocolumn"] .twocolumn-panel .app-menu {
      display: none; } }

[data-layout="twocolumn"] .twocolumn-panel .navbar-brand-box, [data-layout="twocolumn"] .twocolumn-panel .navbar-nav {
  display: none; }

[data-layout="twocolumn"] .twocolumn-panel .main-content {
  margin-left: 70px; }

[data-layout="twocolumn"] .twocolumn-panel #page-topbar, [data-layout="twocolumn"] .twocolumn-panel .footer {
  left: 70px; }

@media (max-width: 575.98px) {
  [data-layout="twocolumn"] .twocolumn-panel .main-content {
    margin-left: 0; }
  [data-layout="twocolumn"] .twocolumn-panel #page-topbar, [data-layout="twocolumn"] .twocolumn-panel .footer {
    left: 0; } }

@media (max-width: 767.98px) {
  [data-layout="twocolumn"] #page-topbar, [data-layout="twocolumn"] .footer {
    left: 70px; } }

@media (max-width: 575.98px) {
  [data-layout="twocolumn"] .main-content {
    margin-left: 0; }
  [data-layout="twocolumn"] #page-topbar, [data-layout="twocolumn"] .footer {
    left: 0; } }

[data-layout-width="boxed"] body {
  background-color: var(--vz-boxed-body-bg); }

[data-layout-width="boxed"] #layout-wrapper {
  max-width: 1300px;
  margin: 0 auto;
  box-shadow: 0 1px 2px rgba(56, 65, 74, 0.15);
  background-color: var(--vz-body-bg); }

[data-layout-width="boxed"][data-layout="vertical"] #layout-wrapper {
  min-height: 100vh; }

[data-layout-width="boxed"] #page-topbar, [data-layout-width="boxed"] .footer {
  max-width: 1300px;
  margin: 0 auto;
  left: 0 !important; }

@media (min-width: 768px) {
  [data-layout-width="boxed"][data-sidebar-size="sm-hover"][data-layout="vertical"] #layout-wrapper, [data-layout-width="boxed"][data-sidebar-size="sm"][data-layout="vertical"] #layout-wrapper {
    min-height: 1400px; } }

@media (max-width: 767.98px) {
  [data-layout-width="boxed"][data-sidebar-size="sm-hover"][data-layout="vertical"] .main-content, [data-layout-width="boxed"][data-sidebar-size="sm"][data-layout="vertical"] .main-content {
    margin-left: 0; } }

[data-layout-width="boxed"][data-sidebar-size="sm-hover"] #page-topbar, [data-layout-width="boxed"][data-sidebar-size="sm-hover"] .footer, [data-layout-width="boxed"][data-sidebar-size="sm"] #page-topbar, [data-layout-width="boxed"][data-sidebar-size="sm"] .footer {
  left: 0 !important;
  max-width: calc(1300px - 70px); }
  @media (min-width: 768px) {
    [data-layout-width="boxed"][data-sidebar-size="sm-hover"] #page-topbar, [data-layout-width="boxed"][data-sidebar-size="sm-hover"] .footer, [data-layout-width="boxed"][data-sidebar-size="sm"] #page-topbar, [data-layout-width="boxed"][data-sidebar-size="sm"] .footer {
      left: 70px !important; } }

[data-layout-width="boxed"][data-sidebar-size="sm-hover-active"] #page-topbar, [data-layout-width="boxed"][data-sidebar-size="sm-hover-active"] .footer, [data-layout-width="boxed"][data-sidebar-size="lg"] #page-topbar, [data-layout-width="boxed"][data-sidebar-size="lg"] .footer {
  max-width: calc(1300px - 250px); }
  @media (min-width: 768px) {
    [data-layout-width="boxed"][data-sidebar-size="sm-hover-active"] #page-topbar, [data-layout-width="boxed"][data-sidebar-size="sm-hover-active"] .footer, [data-layout-width="boxed"][data-sidebar-size="lg"] #page-topbar, [data-layout-width="boxed"][data-sidebar-size="lg"] .footer {
      left: 250px !important; } }

[data-layout-width="boxed"][data-sidebar-size="md"] #page-topbar, [data-layout-width="boxed"][data-sidebar-size="md"] .footer {
  max-width: calc(1300px - 180px); }
  @media (min-width: 768px) {
    [data-layout-width="boxed"][data-sidebar-size="md"] #page-topbar, [data-layout-width="boxed"][data-sidebar-size="md"] .footer {
      left: 180px !important; } }

[data-layout-width="boxed"][data-layout=vertical][data-layout-style=detached] body {
  background-color: var(--vz-body-bg); }

@media (min-width: 1024.1px) {
  [data-layout-width="boxed"][data-layout=vertical][data-layout-style=detached] #layout-wrapper {
    max-width: 1300px;
    box-shadow: none; }
  [data-layout-width="boxed"][data-layout=vertical][data-layout-style=detached] .layout-width {
    max-width: 1300px; } }

[data-layout-width="boxed"][data-layout=vertical][data-layout-style=detached][data-sidebar-size="sm-hover"] #page-topbar, [data-layout-width="boxed"][data-layout=vertical][data-layout-style=detached][data-sidebar-size="sm-hover"] .footer, [data-layout-width="boxed"][data-layout=vertical][data-layout-style=detached][data-sidebar-size="sm"] #page-topbar, [data-layout-width="boxed"][data-layout=vertical][data-layout-style=detached][data-sidebar-size="sm"] .footer, [data-layout-width="boxed"][data-layout=vertical][data-layout-style=detached][data-sidebar-size="md"] #page-topbar, [data-layout-width="boxed"][data-layout=vertical][data-layout-style=detached][data-sidebar-size="md"] .footer, [data-layout-width="boxed"][data-layout=vertical][data-layout-style=detached][data-sidebar-size="lg"] #page-topbar, [data-layout-width="boxed"][data-layout=vertical][data-layout-style=detached][data-sidebar-size="lg"] .footer {
  max-width: 100%;
  left: 0 !important; }

[data-layout="horizontal"][data-layout-width="boxed"] #page-topbar, [data-layout="horizontal"][data-layout-width="boxed"] #layout-wrapper, [data-layout="horizontal"][data-layout-width="boxed"] .footer {
  max-width: 100%; }

[data-layout="horizontal"][data-layout-width="boxed"] .container-fluid, [data-layout="horizontal"][data-layout-width="boxed"] .container-sm, [data-layout="horizontal"][data-layout-width="boxed"] .container-md, [data-layout="horizontal"][data-layout-width="boxed"] .container-lg, [data-layout="horizontal"][data-layout-width="boxed"] .container-xl, [data-layout="horizontal"][data-layout-width="boxed"] .container-xxl, [data-layout="horizontal"][data-layout-width="boxed"] .navbar-header {
  max-width: 1300px; }

[data-layout="horizontal"][data-layout-width="boxed"] .navbar-header {
  padding: 0 calc(1.5rem / 2) 0 0; }

[data-layout="horizontal"][data-layout-width="boxed"][data-sidebar-size="sm-hover"] #page-topbar, [data-layout="horizontal"][data-layout-width="boxed"][data-sidebar-size="sm-hover"] .footer, [data-layout="horizontal"][data-layout-width="boxed"][data-sidebar-size="sm"] [data-layout="horizontal"][data-layout-width="boxed"][data-sidebar-size="sm-hover-active"] #page-topbar, [data-layout="horizontal"][data-layout-width="boxed"][data-sidebar-size="sm"] [data-layout="horizontal"][data-layout-width="boxed"][data-sidebar-size="sm-hover-active"] .footer, [data-layout="horizontal"][data-layout-width="boxed"][data-sidebar-size="lg"] #page-topbar, [data-layout="horizontal"][data-layout-width="boxed"][data-sidebar-size="lg"] .footer {
  left: 0 !important; }

@media (min-width: 992px) {
  [data-layout-position="scrollable"] #page-topbar, [data-layout-position="scrollable"] .navbar-menu {
    position: absolute; } }

@media (min-width: 992px) {
  [data-layout-position="scrollable"][data-layout="horizontal"] #page-topbar, [data-layout-position="scrollable"][data-layout="horizontal"] .topnav {
    position: absolute; } }

/*!
 * Waves v0.7.6
 * http://fian.my.id/Waves 
 * 
 * Copyright 2014-2018 Alfiana E. Sibuea and other contributors 
 * Released under the MIT license 
 * https://github.com/fians/Waves/blob/master/LICENSE */
.waves-effect {
  position: relative;
  cursor: pointer;
  display: inline-block;
  overflow: hidden;
  -webkit-user-select: none;
  user-select: none;
  -webkit-tap-highlight-color: transparent; }

.waves-effect .waves-ripple {
  position: absolute;
  border-radius: 50%;
  width: 100px;
  height: 100px;
  margin-top: -50px;
  margin-left: -50px;
  opacity: 0;
  background: rgba(0, 0, 0, 0.2);
  background: radial-gradient(rgba(0, 0, 0, 0.2) 0, rgba(0, 0, 0, 0.3) 40%, rgba(0, 0, 0, 0.4) 50%, rgba(0, 0, 0, 0.5) 60%, rgba(255, 255, 255, 0) 70%);
  transition: all 0.5s ease-out;
  transition-property: transform, opacity;
  transform: scale(0) translate(0, 0);
  pointer-events: none; }

.waves-effect.waves-light .waves-ripple {
  background: rgba(255, 255, 255, 0.4);
  background: radial-gradient(rgba(255, 255, 255, 0.2) 0, rgba(255, 255, 255, 0.3) 40%, rgba(255, 255, 255, 0.4) 50%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0) 70%); }

.waves-effect.waves-classic .waves-ripple {
  background: rgba(0, 0, 0, 0.2); }

.waves-effect.waves-classic.waves-light .waves-ripple {
  background: rgba(255, 255, 255, 0.4); }

.waves-notransition {
  transition: none !important; }

.waves-button,
.waves-circle {
  transform: translateZ(0);
  -webkit-mask-image: -webkit-radial-gradient(circle, white 100%, black 100%); }

.waves-button,
.waves-button:hover,
.waves-button:visited,
.waves-button-input {
  white-space: nowrap;
  vertical-align: middle;
  cursor: pointer;
  border: none;
  outline: none;
  color: inherit;
  background-color: rgba(0, 0, 0, 0);
  font-size: 1em;
  line-height: 1em;
  text-align: center;
  text-decoration: none;
  z-index: 1; }

.waves-button {
  padding: 0.85em 1.1em;
  border-radius: 0.2em; }

.waves-button-input {
  margin: 0;
  padding: 0.85em 1.1em; }

.waves-input-wrapper {
  border-radius: 0.2em;
  vertical-align: bottom; }

.waves-input-wrapper.waves-button {
  padding: 0; }

.waves-input-wrapper .waves-button-input {
  position: relative;
  top: 0;
  left: 0;
  z-index: 1; }

.waves-circle {
  text-align: center;
  width: 2.5em;
  height: 2.5em;
  line-height: 2.5em;
  border-radius: 50%; }

.waves-float {
  -webkit-mask-image: none;
  box-shadow: 0px 1px 1.5px 1px rgba(0, 0, 0, 0.12);
  transition: all 300ms; }

.waves-float:active {
  box-shadow: 0px 8px 20px 1px rgba(0, 0, 0, 0.3); }

.waves-block {
  display: block; }

.waves-effect.waves-light .waves-ripple {
  background-color: rgba(255, 255, 255, 0.4); }

.waves-effect.waves-primary .waves-ripple {
  background-color: rgba(94, 163, 203, 0.4); }

.waves-effect.waves-success .waves-ripple {
  background-color: rgba(49, 151, 149, 0.4); }

.waves-effect.waves-info .waves-ripple {
  background-color: rgba(88, 202, 234, 0.4); }

.waves-effect.waves-warning .waves-ripple {
  background-color: rgba(247, 184, 75, 0.4); }

.waves-effect.waves-danger .waves-ripple {
  background-color: rgba(229, 62, 62, 0.4); }

.avatar-xxs {
  height: 1.5rem;
  width: 1.5rem; }

.avatar-xs {
  height: 2rem;
  width: 2rem; }

.avatar-sm {
  height: 3rem;
  width: 3rem; }

.avatar-md {
  height: 4.5rem;
  width: 4.5rem; }

.avatar-lg {
  height: 6rem;
  width: 6rem; }

.avatar-xl {
  height: 7.5rem;
  width: 7.5rem; }

.avatar-title {
  align-items: center;
  background-color: #5ea3cb;
  color: #fff;
  display: flex;
  font-weight: 500;
  height: 100%;
  justify-content: center;
  width: 100%; }

.avatar-group {
  padding-left: 12px;
  display: flex;
  flex-wrap: wrap; }
  .avatar-group .avatar-group-item {
    margin-left: -12px;
    border: 2px solid var(--vz-card-bg);
    border-radius: 50%;
    transition: all 0.2s; }
    .avatar-group .avatar-group-item:hover {
      position: relative;
      transform: translateY(-2px);
      z-index: 1; }

.accordion .accordion-button {
  font-weight: 500; }

.accordion .accordion-body {
  color: #878a99; }

.accordion.accordion-icon-none .accordion-button::after {
  content: "";
  background-image: none !important; }

.accordion.accordion-icon-none .accordion-button:not(.collapsed)::after {
  content: ""; }

.custom-accordionwithicon .accordion-button::after {
  background-image: none !important;
  font-family: "Material Design Icons";
  content: "\\F0142";
  font-size: 1.1rem;
  vertical-align: middle;
  line-height: 0.8; }

.custom-accordionwithicon .accordion-button:not(.collapsed)::after {
  background-image: none !important;
  content: "\\F0140";
  margin-right: -3px; }

.custom-accordionwithicon-plus .accordion-button::after {
  background-image: none !important;
  font-family: "Material Design Icons";
  content: "\\F0415";
  font-size: 1.1rem;
  vertical-align: middle;
  line-height: 0.8; }

.custom-accordionwithicon-plus .accordion-button:not(.collapsed)::after {
  background-image: none !important;
  content: "\\F0374";
  margin-right: -3px; }

.lefticon-accordion .accordion-button {
  padding-left: 2.75rem; }
  .lefticon-accordion .accordion-button::after {
    position: absolute;
    left: 1.25rem;
    top: 14px; }
  .lefticon-accordion .accordion-button:not(.collapsed)::after {
    top: 20px; }

.accordion-border-box .accordion-item {
  border-top: 1px solid var(--vz-border-color);
  border-radius: 0.25rem; }
  .accordion-border-box .accordion-item:not(:first-of-type) {
    margin-top: 8px; }
  .accordion-border-box .accordion-item .accordion-button {
    border-radius: 0.25rem; }
    .accordion-border-box .accordion-item .accordion-button:not(.collapsed) {
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0; }

.custom-accordion-border .accordion-item {
  border-left: 3px solid var(--vz-border-color); }

.accordion-primary .accordion-item {
  border-color: rgba(94, 163, 203, 0.6); }
  .accordion-primary .accordion-item .accordion-button {
    box-shadow: none; }
    .accordion-primary .accordion-item .accordion-button:not(.collapsed) {
      color: #5ea3cb;
      background-color: rgba(94, 163, 203, 0.1) !important; }
    .accordion-primary .accordion-item .accordion-button::after {
      color: #5ea3cb; }

.accordion-fill-primary .accordion-item .accordion-button {
  box-shadow: none; }
  .accordion-fill-primary .accordion-item .accordion-button:not(.collapsed) {
    color: #fff;
    background-color: #5ea3cb !important; }

.accordion-secondary .accordion-item {
  border-color: rgba(112, 132, 199, 0.6); }
  .accordion-secondary .accordion-item .accordion-button {
    box-shadow: none; }
    .accordion-secondary .accordion-item .accordion-button:not(.collapsed) {
      color: #7084c7;
      background-color: rgba(112, 132, 199, 0.1) !important; }
    .accordion-secondary .accordion-item .accordion-button::after {
      color: #7084c7; }

.accordion-fill-secondary .accordion-item .accordion-button {
  box-shadow: none; }
  .accordion-fill-secondary .accordion-item .accordion-button:not(.collapsed) {
    color: #fff;
    background-color: #7084c7 !important; }

.accordion-success .accordion-item {
  border-color: rgba(49, 151, 149, 0.6); }
  .accordion-success .accordion-item .accordion-button {
    box-shadow: none; }
    .accordion-success .accordion-item .accordion-button:not(.collapsed) {
      color: #319795;
      background-color: rgba(49, 151, 149, 0.1) !important; }
    .accordion-success .accordion-item .accordion-button::after {
      color: #319795; }

.accordion-fill-success .accordion-item .accordion-button {
  box-shadow: none; }
  .accordion-fill-success .accordion-item .accordion-button:not(.collapsed) {
    color: #fff;
    background-color: #319795 !important; }

.accordion-info .accordion-item {
  border-color: rgba(88, 202, 234, 0.6); }
  .accordion-info .accordion-item .accordion-button {
    box-shadow: none; }
    .accordion-info .accordion-item .accordion-button:not(.collapsed) {
      color: #58caea;
      background-color: rgba(88, 202, 234, 0.1) !important; }
    .accordion-info .accordion-item .accordion-button::after {
      color: #58caea; }

.accordion-fill-info .accordion-item .accordion-button {
  box-shadow: none; }
  .accordion-fill-info .accordion-item .accordion-button:not(.collapsed) {
    color: #fff;
    background-color: #58caea !important; }

.accordion-warning .accordion-item {
  border-color: rgba(247, 184, 75, 0.6); }
  .accordion-warning .accordion-item .accordion-button {
    box-shadow: none; }
    .accordion-warning .accordion-item .accordion-button:not(.collapsed) {
      color: #f7b84b;
      background-color: rgba(247, 184, 75, 0.1) !important; }
    .accordion-warning .accordion-item .accordion-button::after {
      color: #f7b84b; }

.accordion-fill-warning .accordion-item .accordion-button {
  box-shadow: none; }
  .accordion-fill-warning .accordion-item .accordion-button:not(.collapsed) {
    color: #fff;
    background-color: #f7b84b !important; }

.accordion-danger .accordion-item {
  border-color: rgba(229, 62, 62, 0.6); }
  .accordion-danger .accordion-item .accordion-button {
    box-shadow: none; }
    .accordion-danger .accordion-item .accordion-button:not(.collapsed) {
      color: #E53E3E;
      background-color: rgba(229, 62, 62, 0.1) !important; }
    .accordion-danger .accordion-item .accordion-button::after {
      color: #E53E3E; }

.accordion-fill-danger .accordion-item .accordion-button {
  box-shadow: none; }
  .accordion-fill-danger .accordion-item .accordion-button:not(.collapsed) {
    color: #fff;
    background-color: #E53E3E !important; }

.accordion-light .accordion-item {
  border-color: rgba(243, 246, 249, 0.6); }
  .accordion-light .accordion-item .accordion-button {
    box-shadow: none; }
    .accordion-light .accordion-item .accordion-button:not(.collapsed) {
      color: #f3f6f9;
      background-color: rgba(243, 246, 249, 0.1) !important; }
    .accordion-light .accordion-item .accordion-button::after {
      color: #f3f6f9; }

.accordion-fill-light .accordion-item .accordion-button {
  box-shadow: none; }
  .accordion-fill-light .accordion-item .accordion-button:not(.collapsed) {
    color: #fff;
    background-color: #f3f6f9 !important; }

.accordion-dark .accordion-item {
  border-color: rgba(33, 37, 41, 0.6); }
  .accordion-dark .accordion-item .accordion-button {
    box-shadow: none; }
    .accordion-dark .accordion-item .accordion-button:not(.collapsed) {
      color: #212529;
      background-color: rgba(33, 37, 41, 0.1) !important; }
    .accordion-dark .accordion-item .accordion-button::after {
      color: #212529; }

.accordion-fill-dark .accordion-item .accordion-button {
  box-shadow: none; }
  .accordion-fill-dark .accordion-item .accordion-button:not(.collapsed) {
    color: #fff;
    background-color: #212529 !important; }

[data-layout-mode="dark"] .accordion-button:not(.collapsed) {
  color: var(--vz-accordion-button-active-color); }
  [data-layout-mode="dark"] .accordion-button:not(.collapsed):after {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_58___}); }

[data-layout-mode="dark"] .accordion-button:after {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_59___}); }

[dir="rtl"] .custom-accordionwithicon .accordion-button::after {
  transform: rotate(180deg); }

.fs-10 {
  font-size: 10px !important; }

.fs-11 {
  font-size: 11px !important; }

.fs-12 {
  font-size: 12px !important; }

.fs-13 {
  font-size: 13px !important; }

.fs-14 {
  font-size: 14px !important; }

.fs-15 {
  font-size: 15px !important; }

.fs-16 {
  font-size: 16px !important; }

.fs-17 {
  font-size: 17px !important; }

.fs-18 {
  font-size: 18px !important; }

.fs-19 {
  font-size: 19px !important; }

.fs-20 {
  font-size: 20px !important; }

.fs-21 {
  font-size: 21px !important; }

.fs-22 {
  font-size: 22px !important; }

.fs-23 {
  font-size: 23px !important; }

.fs-24 {
  font-size: 24px !important; }

.fs-36 {
  font-size: 36px !important; }

.fs-48 {
  font-size: 48px !important; }

.border-dark {
  border-color: var(--vz-dark) !important; }

.border-light {
  border-color: var(--vz-light) !important; }

.border-double {
  border-style: double !important; }

.border-top-double {
  border-top-style: double !important; }

.border-bottom-double {
  border-bottom-style: double !important; }

.border-end-double {
  border-right-style: double !important; }

.border-start-double {
  border-left-style: double !important; }

.list-group-flush.border-double {
  border: none !important; }
  .list-group-flush.border-double .list-group-item {
    border-style: double !important; }

.border-dashed {
  border-style: dashed !important; }

.border-top-dashed {
  border-top-style: dashed !important; }

.border-bottom-dashed {
  border-bottom-style: dashed !important; }

.border-end-dashed {
  border-right-style: dashed !important; }

.border-start-dashed {
  border-left-style: dashed !important; }

.list-group-flush.border-dashed {
  border: none !important; }
  .list-group-flush.border-dashed .list-group-item {
    border-style: dashed !important; }

.border-groove {
  border-style: groove !important; }

.border-top-groove {
  border-top-style: groove !important; }

.border-bottom-groove {
  border-bottom-style: groove !important; }

.border-end-groove {
  border-right-style: groove !important; }

.border-start-groove {
  border-left-style: groove !important; }

.list-group-flush.border-groove {
  border: none !important; }
  .list-group-flush.border-groove .list-group-item {
    border-style: groove !important; }

.border-outset {
  border-style: outset !important; }

.border-top-outset {
  border-top-style: outset !important; }

.border-bottom-outset {
  border-bottom-style: outset !important; }

.border-end-outset {
  border-right-style: outset !important; }

.border-start-outset {
  border-left-style: outset !important; }

.list-group-flush.border-outset {
  border: none !important; }
  .list-group-flush.border-outset .list-group-item {
    border-style: outset !important; }

.border-ridge {
  border-style: ridge !important; }

.border-top-ridge {
  border-top-style: ridge !important; }

.border-bottom-ridge {
  border-bottom-style: ridge !important; }

.border-end-ridge {
  border-right-style: ridge !important; }

.border-start-ridge {
  border-left-style: ridge !important; }

.list-group-flush.border-ridge {
  border: none !important; }
  .list-group-flush.border-ridge .list-group-item {
    border-style: ridge !important; }

.border-dotted {
  border-style: dotted !important; }

.border-top-dotted {
  border-top-style: dotted !important; }

.border-bottom-dotted {
  border-bottom-style: dotted !important; }

.border-end-dotted {
  border-right-style: dotted !important; }

.border-start-dotted {
  border-left-style: dotted !important; }

.list-group-flush.border-dotted {
  border: none !important; }
  .list-group-flush.border-dotted .list-group-item {
    border-style: dotted !important; }

.border-inset {
  border-style: inset !important; }

.border-top-inset {
  border-top-style: inset !important; }

.border-bottom-inset {
  border-bottom-style: inset !important; }

.border-end-inset {
  border-right-style: inset !important; }

.border-start-inset {
  border-left-style: inset !important; }

.list-group-flush.border-inset {
  border: none !important; }
  .list-group-flush.border-inset .list-group-item {
    border-style: inset !important; }

[data-layout-mode="dark"] .link-dark, [data-layout-mode="dark"] .link-light {
  color: var(--vz-dark); }
  [data-layout-mode="dark"] .link-dark:focus, [data-layout-mode="dark"] .link-dark:hover, [data-layout-mode="dark"] .link-light:focus, [data-layout-mode="dark"] .link-light:hover {
    color: rgba(var(--vz-dark-rgb), 0.75); }

#back-to-top {
  position: fixed;
  bottom: 100px;
  right: 28px;
  transition: all 0.5s ease;
  display: none;
  z-index: 1000; }
  #back-to-top:hover {
    animation: fade-up 1.5s infinite linear; }

.ff-base {
  font-family: var(--vz-font-sans-serif); }

.ff-secondary {
  font-family: "Poppins", sans-serif; }

.fw-medium {
  font-weight: 500; }

.fw-semibold {
  font-weight: 600 !important; }

.flex-1 {
  flex: 1 1; }

.social-list-item {
  height: 2rem;
  width: 2rem;
  line-height: calc(2rem - 4px);
  display: block;
  border: 2px solid #adb5bd;
  border-radius: 50%;
  color: #adb5bd;
  text-align: center;
  transition: all 0.4s; }
  .social-list-item:hover {
    color: #878a99;
    background-color: #eff2f7; }

.bg-pattern {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_60___}) var(--vz-modal-bg); }

.w-xs {
  min-width: 80px; }

.w-sm {
  min-width: 95px; }

.w-md {
  min-width: 110px; }

.w-lg {
  min-width: 140px; }

.w-xl {
  min-width: 160px; }

.icon-xs {
  height: 16px;
  width: 16px; }

.icon-sm {
  height: 18px;
  width: 18px; }

.icon-md {
  height: 22px;
  width: 22px; }

.icon-lg {
  height: 24px;
  width: 24px; }

.icon-xl {
  height: 28px;
  width: 28px; }

.icon-xxl {
  height: 32px;
  width: 32px; }

.icon-dual {
  color: #adb5bd;
  fill: rgba(173, 181, 189, 0.16); }

.icon-dual-primary {
  color: #5ea3cb;
  fill: rgba(94, 163, 203, 0.16); }

.icon-dual-secondary {
  color: #7084c7;
  fill: rgba(112, 132, 199, 0.16); }

.icon-dual-success {
  color: #319795;
  fill: rgba(49, 151, 149, 0.16); }

.icon-dual-info {
  color: #58caea;
  fill: rgba(88, 202, 234, 0.16); }

.icon-dual-warning {
  color: #f7b84b;
  fill: rgba(247, 184, 75, 0.16); }

.icon-dual-danger {
  color: #E53E3E;
  fill: rgba(229, 62, 62, 0.16); }

.icon-dual-light {
  color: #f3f6f9;
  fill: rgba(243, 246, 249, 0.16); }

.icon-dual-dark {
  color: #212529;
  fill: rgba(33, 37, 41, 0.16); }

.search-box {
  position: relative; }
  .search-box .form-control {
    padding-left: 40px; }
  .search-box .search-icon {
    font-size: 14px;
    position: absolute;
    left: 13px;
    top: 0;
    height: 100%;
    display: flex;
    align-items: center;
    color: #878a99; }

.bg-overlay {
  position: absolute;
  height: 100%;
  width: 100%;
  right: 0;
  bottom: 0;
  left: 0;
  top: 0;
  opacity: 0.7;
  background-color: #fff; }

.customizer-setting {
  position: fixed;
  bottom: 40px;
  right: 20px;
  z-index: 1000; }

code {
  -webkit-user-select: all;
          user-select: all; }

.layout-rightside {
  width: 280px;
  margin-right: -1.5rem;
  margin-top: calc(1px - 1.5rem);
  height: calc(100% + 1.5rem); }

@media (max-width: 1699.98px) {
  .layout-rightside-col {
    display: none;
    position: fixed !important;
    height: 100vh;
    right: 0px;
    top: 0px;
    bottom: 0px;
    z-index: 1004; }
    .layout-rightside-col .overlay {
      position: fixed;
      top: 0;
      right: 0px;
      bottom: 0px;
      left: 0px;
      background-color: rgba(33, 37, 41, 0.2); }
    .layout-rightside-col .layout-rightside {
      margin-top: 0px;
      height: 100%;
      margin-left: auto; }
    .layout-rightside-col .card-body {
      overflow-y: auto;
      padding-bottom: 1rem !important; } }

@media (min-width: 1700px) {
  [data-layout="horizontal"] .layout-rightside, [data-layout-style=detached] .layout-rightside {
    margin-top: calc(28px - 1.5rem);
    margin-right: 0;
    height: calc(100% - calc(1.5rem / 5)); } }

.object-cover {
  object-fit: cover; }

.text-truncate-two-lines {
  overflow: hidden;
  text-overflow: ellipsis;
  -webkit-line-clamp: 2;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  white-space: normal; }

.favourite-btn .ri-star-fill {
  color: #878a99; }

.favourite-btn.active .ri-star-fill {
  color: #f7b84b; }
  .favourite-btn.active .ri-star-fill:before {
    content: "\\f186"; }

.card-logo-light {
  display: var(--vz-card-logo-light); }

.card-logo-dark {
  display: var(--vz-card-logo-dark); }

[data-layout-mode="dark"] .btn-close {
  filter: invert(1) grayscale(100%) brightness(200%); }

.cursor-pointer {
  cursor: pointer; }

#preloader {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: var(--vz-card-bg);
  z-index: 9999; }

#status {
  width: 40px;
  height: 40px;
  position: absolute;
  left: 50%;
  top: 50%;
  margin: -20px 0 0 -20px; }

.spinner-chase {
  margin: 0 auto;
  width: 40px;
  height: 40px;
  position: relative;
  animation: spinner-chase 2.5s infinite linear both; }

.chase-dot {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  animation: chase-dot 2.0s infinite ease-in-out both; }
  .chase-dot:before {
    content: '';
    display: block;
    width: 25%;
    height: 25%;
    background-color: #5ea3cb;
    border-radius: 100%;
    animation: chase-dot-before 2.0s infinite ease-in-out both; }
  .chase-dot:nth-child(1) {
    animation-delay: -1.1s; }
    .chase-dot:nth-child(1):before {
      animation-delay: -1.1s; }
  .chase-dot:nth-child(2) {
    animation-delay: -1.0s; }
    .chase-dot:nth-child(2):before {
      animation-delay: -1.0s; }
  .chase-dot:nth-child(3) {
    animation-delay: -0.9s; }
    .chase-dot:nth-child(3):before {
      animation-delay: -0.9s; }
  .chase-dot:nth-child(4) {
    animation-delay: -0.8s; }
    .chase-dot:nth-child(4):before {
      animation-delay: -0.8s; }
  .chase-dot:nth-child(5) {
    animation-delay: -0.7s; }
    .chase-dot:nth-child(5):before {
      animation-delay: -0.7s; }
  .chase-dot:nth-child(6) {
    animation-delay: -0.6s; }
    .chase-dot:nth-child(6):before {
      animation-delay: -0.6s; }

@keyframes spinner-chase {
  100% {
    transform: rotate(360deg); } }

@keyframes chase-dot {
  80%, 100% {
    transform: rotate(360deg); } }

@keyframes chase-dot-before {
  50% {
    transform: scale(0.4); }
  100%, 0% {
    transform: scale(1); } }

[type="tel"]::placeholder,
[type="url"]::placeholder,
[type="email"]::placeholder,
[type="number"]::placeholder {
  text-align: left; }

.main-chart .chart-border-left {
  border-left: 1.4px solid var(--vz-border-color);
  padding: 2px 20px; }
  .main-chart .chart-border-left:last-child {
    margin-right: 0px; }

/* Activity */
.activity-feed {
  list-style: none; }
  .activity-feed .feed-item {
    position: relative;
    padding-bottom: 27px;
    padding-left: 16px;
    border-left: 2px solid #f3f6f9; }
    .activity-feed .feed-item:after {
      content: "";
      display: block;
      position: absolute;
      top: 4px;
      left: -6px;
      width: 10px;
      height: 10px;
      border-radius: 50%;
      border: 2px solid #5ea3cb;
      background-color: var(--vz-card-bg); }
    .activity-feed .feed-item:last-child {
      border-color: transparent; }

.mini-stats-wid {
  position: relative; }
  .mini-stats-wid .mini-stat-icon {
    overflow: hidden;
    position: relative; }
    .mini-stats-wid .mini-stat-icon:before, .mini-stats-wid .mini-stat-icon:after {
      content: "";
      position: absolute;
      width: 8px;
      height: 69px;
      background-color: rgba(49, 151, 149, 0.1);
      left: 3px;
      transform: rotate(32deg);
      top: -8px;
      transition: all 0.4s; }
    .mini-stats-wid .mini-stat-icon::after {
      left: 27px;
      width: 8px;
      transition: all 0.2s; }
  .mini-stats-wid:hover .mini-stat-icon::after {
    left: 60px; }
  .mini-stats-wid:hover .mini-stat-icon::before {
    left: 50px; }

.button-items {
  margin-left: -8px;
  margin-bottom: -12px; }
  .button-items .btn {
    margin-bottom: 12px;
    margin-left: 8px; }

.bs-example-modal {
  position: relative;
  top: auto;
  right: auto;
  bottom: auto;
  left: auto;
  z-index: 1;
  display: block; }

[dir="rtl"] .modal-open {
  padding-left: 0px !important; }

.icon-demo-content {
  color: var(--vz-gray-500); }
  .icon-demo-content i {
    font-size: 24px;
    margin-right: 10px;
    color: var(--vz-gray-600);
    transition: all 0.4s;
    vertical-align: middle; }
  .icon-demo-content svg {
    margin-right: 10px;
    transition: all 0.4s;
    height: 20px; }
  .icon-demo-content .col-lg-4 {
    margin-top: 24px; }
    .icon-demo-content .col-lg-4:hover i, .icon-demo-content .col-lg-4:hover svg {
      color: #5ea3cb;
      transform: scale(1.5); }

.grid-structure .grid-container {
  background-color: #f3f6f9;
  margin-top: 10px;
  font-size: .8rem;
  font-weight: 500;
  padding: 10px 20px; }

[data-layout-mode="dark"] .colorscheme-cardradio .form-check-label {
  background-color: var(--vz-dark); }

[data-layout-mode="dark"] .colorscheme-cardradio .bg-light {
  background-color: rgba(var(--vz-light-rgb), 0.1) !important; }

[data-layout-mode="dark"] .colorscheme-cardradio .bg-soft-light {
  background-color: rgba(var(--vz-dark-rgb), 0.1) !important; }

[data-layout-mode="dark"] .colorscheme-cardradio .dark .bg-dark {
  background-color: var(--vz-card-bg) !important; }

@media print {
  .vertical-menu,
  .right-bar,
  .page-title-box,
  .navbar-header,
  .footer,
  #back-to-top {
    display: none !important; }
  .card-body,
  .main-content,
  .right-bar,
  .page-content,
  body {
    padding: 0;
    margin: 0; }
  .card {
    border: 0; }
  .invoice-details .d-sm-flex {
    display: flex !important; }
  .address.col-sm-6 {
    flex: 0 0 auto !important;
    width: 50% !important;
    max-width: 100% !important; } }

.ribbon-box {
  position: relative;
  /* Ribbon two */ }
  .ribbon-box .ribbon {
    padding: 5px 12px;
    box-shadow: 2px 5px 10px rgba(33, 37, 41, 0.15);
    color: #fff;
    font-size: 0.875rem;
    font-weight: 600;
    position: absolute;
    left: -1px;
    top: 5px; }
    .ribbon-box .ribbon.round-shape {
      border-radius: 0 30px 30px 0; }
    .ribbon-box .ribbon.ribbon-shape {
      display: inline-block; }
      .ribbon-box .ribbon.ribbon-shape::before {
        content: "";
        position: absolute;
        right: -17px;
        top: 0;
        border: 14px solid transparent; }
      .ribbon-box .ribbon.ribbon-shape::after {
        content: "";
        position: absolute;
        right: -17px;
        bottom: 0;
        border: 14px solid transparent; }
  .ribbon-box.ribbon-circle .ribbon {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    left: 20px;
    top: 20px; }
  .ribbon-box.ribbon-fill {
    overflow: hidden; }
    .ribbon-box.ribbon-fill .ribbon {
      transform: rotate(-45deg);
      width: 93px;
      height: 52px;
      left: -36px;
      top: -16px;
      display: flex;
      justify-content: center;
      align-items: flex-end; }
    .ribbon-box.ribbon-fill.ribbon-sm .ribbon {
      padding: 2px 12px;
      width: 78px;
      height: 42px;
      font-size: 12px;
      box-shadow: none; }
  .ribbon-box.right .ribbon {
    position: absolute;
    left: auto;
    right: 0; }
    .ribbon-box.right .ribbon.round-shape {
      border-radius: 30px 0 0 30px; }
    .ribbon-box.right .ribbon.ribbon-shape {
      text-align: right; }
      .ribbon-box.right .ribbon.ribbon-shape::before, .ribbon-box.right .ribbon.ribbon-shape::after {
        right: auto;
        left: -17px;
        border-left-color: transparent; }
  .ribbon-box.right.ribbon-circle .ribbon {
    left: auto;
    right: 20px; }
  .ribbon-box.right .icon-ribbon {
    right: 24px;
    left: auto; }
  .ribbon-box.right.ribbon-fill .ribbon {
    transform: rotate(45deg);
    right: -38px;
    left: auto; }
  .ribbon-box.right.ribbon-box .ribbon-two {
    left: auto;
    right: -5px; }
    .ribbon-box.right.ribbon-box .ribbon-two span {
      left: auto;
      right: -21px;
      transform: rotate(45deg); }
  .ribbon-box .ribbon-content {
    clear: both; }
  .ribbon-box .ribbon-primary {
    background: #5ea3cb; }
    .ribbon-box .ribbon-primary:before {
      border-color: #3c8cba transparent transparent; }
    .ribbon-box .ribbon-primary.ribbon-shape::before {
      border-left-color: #5ea3cb;
      border-top-color: #5ea3cb; }
    .ribbon-box .ribbon-primary.ribbon-shape::after {
      border-left-color: #5ea3cb;
      border-bottom-color: #5ea3cb; }
  .ribbon-box.right .ribbon-primary {
    background: #5ea3cb; }
    .ribbon-box.right .ribbon-primary.ribbon-shape::before {
      border-right-color: #5ea3cb;
      border-top-color: #5ea3cb; }
    .ribbon-box.right .ribbon-primary.ribbon-shape::after {
      border-right-color: #5ea3cb;
      border-bottom-color: #5ea3cb; }
  .ribbon-box .ribbon-secondary {
    background: #7084c7; }
    .ribbon-box .ribbon-secondary:before {
      border-color: #4b64b9 transparent transparent; }
    .ribbon-box .ribbon-secondary.ribbon-shape::before {
      border-left-color: #7084c7;
      border-top-color: #7084c7; }
    .ribbon-box .ribbon-secondary.ribbon-shape::after {
      border-left-color: #7084c7;
      border-bottom-color: #7084c7; }
  .ribbon-box.right .ribbon-secondary {
    background: #7084c7; }
    .ribbon-box.right .ribbon-secondary.ribbon-shape::before {
      border-right-color: #7084c7;
      border-top-color: #7084c7; }
    .ribbon-box.right .ribbon-secondary.ribbon-shape::after {
      border-right-color: #7084c7;
      border-bottom-color: #7084c7; }
  .ribbon-box .ribbon-success {
    background: #319795; }
    .ribbon-box .ribbon-success:before {
      border-color: #25706f transparent transparent; }
    .ribbon-box .ribbon-success.ribbon-shape::before {
      border-left-color: #319795;
      border-top-color: #319795; }
    .ribbon-box .ribbon-success.ribbon-shape::after {
      border-left-color: #319795;
      border-bottom-color: #319795; }
  .ribbon-box.right .ribbon-success {
    background: #319795; }
    .ribbon-box.right .ribbon-success.ribbon-shape::before {
      border-right-color: #319795;
      border-top-color: #319795; }
    .ribbon-box.right .ribbon-success.ribbon-shape::after {
      border-right-color: #319795;
      border-bottom-color: #319795; }
  .ribbon-box .ribbon-info {
    background: #58caea; }
    .ribbon-box .ribbon-info:before {
      border-color: #2bbce4 transparent transparent; }
    .ribbon-box .ribbon-info.ribbon-shape::before {
      border-left-color: #58caea;
      border-top-color: #58caea; }
    .ribbon-box .ribbon-info.ribbon-shape::after {
      border-left-color: #58caea;
      border-bottom-color: #58caea; }
  .ribbon-box.right .ribbon-info {
    background: #58caea; }
    .ribbon-box.right .ribbon-info.ribbon-shape::before {
      border-right-color: #58caea;
      border-top-color: #58caea; }
    .ribbon-box.right .ribbon-info.ribbon-shape::after {
      border-right-color: #58caea;
      border-bottom-color: #58caea; }
  .ribbon-box .ribbon-warning {
    background: #f7b84b; }
    .ribbon-box .ribbon-warning:before {
      border-color: #f5a51a transparent transparent; }
    .ribbon-box .ribbon-warning.ribbon-shape::before {
      border-left-color: #f7b84b;
      border-top-color: #f7b84b; }
    .ribbon-box .ribbon-warning.ribbon-shape::after {
      border-left-color: #f7b84b;
      border-bottom-color: #f7b84b; }
  .ribbon-box.right .ribbon-warning {
    background: #f7b84b; }
    .ribbon-box.right .ribbon-warning.ribbon-shape::before {
      border-right-color: #f7b84b;
      border-top-color: #f7b84b; }
    .ribbon-box.right .ribbon-warning.ribbon-shape::after {
      border-right-color: #f7b84b;
      border-bottom-color: #f7b84b; }
  .ribbon-box .ribbon-danger {
    background: #E53E3E; }
    .ribbon-box .ribbon-danger:before {
      border-color: #d41c1c transparent transparent; }
    .ribbon-box .ribbon-danger.ribbon-shape::before {
      border-left-color: #E53E3E;
      border-top-color: #E53E3E; }
    .ribbon-box .ribbon-danger.ribbon-shape::after {
      border-left-color: #E53E3E;
      border-bottom-color: #E53E3E; }
  .ribbon-box.right .ribbon-danger {
    background: #E53E3E; }
    .ribbon-box.right .ribbon-danger.ribbon-shape::before {
      border-right-color: #E53E3E;
      border-top-color: #E53E3E; }
    .ribbon-box.right .ribbon-danger.ribbon-shape::after {
      border-right-color: #E53E3E;
      border-bottom-color: #E53E3E; }
  .ribbon-box .ribbon-light {
    background: #f3f6f9; }
    .ribbon-box .ribbon-light:before {
      border-color: #d1dde8 transparent transparent; }
    .ribbon-box .ribbon-light.ribbon-shape::before {
      border-left-color: #f3f6f9;
      border-top-color: #f3f6f9; }
    .ribbon-box .ribbon-light.ribbon-shape::after {
      border-left-color: #f3f6f9;
      border-bottom-color: #f3f6f9; }
  .ribbon-box.right .ribbon-light {
    background: #f3f6f9; }
    .ribbon-box.right .ribbon-light.ribbon-shape::before {
      border-right-color: #f3f6f9;
      border-top-color: #f3f6f9; }
    .ribbon-box.right .ribbon-light.ribbon-shape::after {
      border-right-color: #f3f6f9;
      border-bottom-color: #f3f6f9; }
  .ribbon-box .ribbon-dark {
    background: #212529; }
    .ribbon-box .ribbon-dark:before {
      border-color: #0a0c0d transparent transparent; }
    .ribbon-box .ribbon-dark.ribbon-shape::before {
      border-left-color: #212529;
      border-top-color: #212529; }
    .ribbon-box .ribbon-dark.ribbon-shape::after {
      border-left-color: #212529;
      border-bottom-color: #212529; }
  .ribbon-box.right .ribbon-dark {
    background: #212529; }
    .ribbon-box.right .ribbon-dark.ribbon-shape::before {
      border-right-color: #212529;
      border-top-color: #212529; }
    .ribbon-box.right .ribbon-dark.ribbon-shape::after {
      border-right-color: #212529;
      border-bottom-color: #212529; }
  .ribbon-box .icon-ribbon {
    box-shadow: none;
    left: 24px;
    top: -12px;
    font-size: 40px;
    padding: 0; }
  .ribbon-box .ribbon-two {
    position: absolute;
    left: -5px;
    top: -5px;
    z-index: 1;
    overflow: hidden;
    width: 75px;
    height: 75px;
    text-align: right; }
    .ribbon-box .ribbon-two span {
      font-size: 13px;
      color: #fff;
      text-align: center;
      line-height: 20px;
      transform: rotate(-45deg);
      width: 100px;
      display: block;
      box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.06), 0 1px 0 0 rgba(0, 0, 0, 0.02);
      position: absolute;
      top: 19px;
      left: -21px;
      font-weight: 600; }
      .ribbon-box .ribbon-two span:before {
        content: "";
        position: absolute;
        left: 0;
        top: 100%;
        z-index: -1;
        border-right: 3px solid transparent;
        border-bottom: 3px solid transparent; }
      .ribbon-box .ribbon-two span:after {
        content: "";
        position: absolute;
        right: 0;
        top: 100%;
        z-index: -1;
        border-left: 3px solid transparent;
        border-bottom: 3px solid transparent; }
  .ribbon-box .ribbon-two-primary span {
    background: #5ea3cb; }
    .ribbon-box .ribbon-two-primary span:before {
      border-left: 3px solid #367da7;
      border-top: 3px solid #367da7; }
    .ribbon-box .ribbon-two-primary span:after {
      border-right: 3px solid #367da7;
      border-top: 3px solid #367da7; }
  .ribbon-box .ribbon-two-secondary span {
    background: #7084c7; }
    .ribbon-box .ribbon-two-secondary span:before {
      border-left: 3px solid #425aa9;
      border-top: 3px solid #425aa9; }
    .ribbon-box .ribbon-two-secondary span:after {
      border-right: 3px solid #425aa9;
      border-top: 3px solid #425aa9; }
  .ribbon-box .ribbon-two-success span {
    background: #319795; }
    .ribbon-box .ribbon-two-success span:before {
      border-left: 3px solid #1e5d5c;
      border-top: 3px solid #1e5d5c; }
    .ribbon-box .ribbon-two-success span:after {
      border-right: 3px solid #1e5d5c;
      border-top: 3px solid #1e5d5c; }
  .ribbon-box .ribbon-two-info span {
    background: #58caea; }
    .ribbon-box .ribbon-two-info span:before {
      border-left: 3px solid #1bb0da;
      border-top: 3px solid #1bb0da; }
    .ribbon-box .ribbon-two-info span:after {
      border-right: 3px solid #1bb0da;
      border-top: 3px solid #1bb0da; }
  .ribbon-box .ribbon-two-warning span {
    background: #f7b84b; }
    .ribbon-box .ribbon-two-warning span:before {
      border-left: 3px solid #eb990a;
      border-top: 3px solid #eb990a; }
    .ribbon-box .ribbon-two-warning span:after {
      border-right: 3px solid #eb990a;
      border-top: 3px solid #eb990a; }
  .ribbon-box .ribbon-two-danger span {
    background: #E53E3E; }
    .ribbon-box .ribbon-two-danger span:before {
      border-left: 3px solid #bd1919;
      border-top: 3px solid #bd1919; }
    .ribbon-box .ribbon-two-danger span:after {
      border-right: 3px solid #bd1919;
      border-top: 3px solid #bd1919; }
  .ribbon-box .ribbon-two-light span {
    background: #f3f6f9; }
    .ribbon-box .ribbon-two-light span:before {
      border-left: 3px solid #c0d0e0;
      border-top: 3px solid #c0d0e0; }
    .ribbon-box .ribbon-two-light span:after {
      border-right: 3px solid #c0d0e0;
      border-top: 3px solid #c0d0e0; }
  .ribbon-box .ribbon-two-dark span {
    background: #212529; }
    .ribbon-box .ribbon-two-dark span:before {
      border-left: 3px solid black;
      border-top: 3px solid black; }
    .ribbon-box .ribbon-two-dark span:after {
      border-right: 3px solid black;
      border-top: 3px solid black; }

.ribbon-box.right .ribbon-three {
  position: absolute;
  top: -6.1px;
  right: 10px;
  left: auto; }

.ribbon-three {
  position: absolute;
  top: -6.1px;
  left: 10px; }
  .ribbon-three span {
    position: relative;
    display: block;
    text-align: center;
    color: #fff;
    font-size: 14px;
    line-height: 1;
    padding: 12px 8px 10px;
    border-top-right-radius: 8px;
    width: 90px; }
    .ribbon-three span::after, .ribbon-three span::before {
      position: absolute;
      content: ""; }
    .ribbon-three span::before {
      height: 6px;
      width: 6px;
      left: -6px;
      top: 0; }
    .ribbon-three span::after {
      height: 6px;
      width: 8px;
      left: -8px;
      top: 0;
      border-radius: 8px 8px 0 0; }
  .ribbon-three::after {
    position: absolute;
    content: "";
    width: 0;
    height: 0;
    border-left: 44px solid transparent;
    border-right: 44px solid transparent;
    border-top: 10px solid; }

.ribbon-three-primary span {
  background: #5ea3cb; }
  .ribbon-three-primary span:before {
    background: #5ea3cb; }
  .ribbon-three-primary span:after {
    background: #3c8cba; }

.ribbon-three-primary::after {
  border-top-color: #5ea3cb; }

.ribbon-three-secondary span {
  background: #7084c7; }
  .ribbon-three-secondary span:before {
    background: #7084c7; }
  .ribbon-three-secondary span:after {
    background: #4b64b9; }

.ribbon-three-secondary::after {
  border-top-color: #7084c7; }

.ribbon-three-success span {
  background: #319795; }
  .ribbon-three-success span:before {
    background: #319795; }
  .ribbon-three-success span:after {
    background: #25706f; }

.ribbon-three-success::after {
  border-top-color: #319795; }

.ribbon-three-info span {
  background: #58caea; }
  .ribbon-three-info span:before {
    background: #58caea; }
  .ribbon-three-info span:after {
    background: #2bbce4; }

.ribbon-three-info::after {
  border-top-color: #58caea; }

.ribbon-three-warning span {
  background: #f7b84b; }
  .ribbon-three-warning span:before {
    background: #f7b84b; }
  .ribbon-three-warning span:after {
    background: #f5a51a; }

.ribbon-three-warning::after {
  border-top-color: #f7b84b; }

.ribbon-three-danger span {
  background: #E53E3E; }
  .ribbon-three-danger span:before {
    background: #E53E3E; }
  .ribbon-three-danger span:after {
    background: #d41c1c; }

.ribbon-three-danger::after {
  border-top-color: #E53E3E; }

.ribbon-three-light span {
  background: #f3f6f9; }
  .ribbon-three-light span:before {
    background: #f3f6f9; }
  .ribbon-three-light span:after {
    background: #d1dde8; }

.ribbon-three-light::after {
  border-top-color: #f3f6f9; }

.ribbon-three-dark span {
  background: #212529; }
  .ribbon-three-dark span:before {
    background: #212529; }
  .ribbon-three-dark span:after {
    background: #0a0c0d; }

.ribbon-three-dark::after {
  border-top-color: #212529; }

.ribbon-box .trending-ribbon {
  transform: translateX(-50px);
  transition: all 0.5s ease; }
  .ribbon-box .trending-ribbon .trending-ribbon-text {
    transition: all 0.5s ease;
    opacity: 0; }

.ribbon-box:hover .trending-ribbon {
  transform: translateX(0); }
  .ribbon-box:hover .trending-ribbon .trending-ribbon-text {
    opacity: 1; }

.ribbon-box.right .trending-ribbon {
  transform: translateX(50px);
  transition: all 0.5s ease; }
  .ribbon-box.right .trending-ribbon .trending-ribbon-text {
    transition: all 0.5s ease;
    opacity: 0; }

.ribbon-box.right:hover .trending-ribbon {
  transform: translateX(0); }
  .ribbon-box.right:hover .trending-ribbon .trending-ribbon-text {
    opacity: 1; }

.toast:not(:last-child) {
  margin-bottom: 0.75rem; }

.toast-border-primary .toast-body {
  color: #5ea3cb;
  border-bottom: 3px solid #5ea3cb; }

.toast-border-secondary .toast-body {
  color: #7084c7;
  border-bottom: 3px solid #7084c7; }

.toast-border-success .toast-body {
  color: #319795;
  border-bottom: 3px solid #319795; }

.toast-border-info .toast-body {
  color: #58caea;
  border-bottom: 3px solid #58caea; }

.toast-border-warning .toast-body {
  color: #f7b84b;
  border-bottom: 3px solid #f7b84b; }

.toast-border-danger .toast-body {
  color: #E53E3E;
  border-bottom: 3px solid #E53E3E; }

.toast-border-light .toast-body {
  color: #f3f6f9;
  border-bottom: 3px solid #f3f6f9; }

.toast-border-dark .toast-body {
  color: #212529;
  border-bottom: 3px solid #212529; }

.scrollspy-example {
  position: relative;
  height: 200px;
  margin-top: .5rem;
  overflow: auto; }

.scrollspy-example-2 {
  position: relative;
  height: 370px;
  overflow: auto; }

html {
  position: relative;
  min-height: 100%; }

.h1,
.h2,
.h3,
.h4,
.h5,
.h6, h1, .h1, h2, .h2, h3, .h3, h4, .h4, h5, .h5, h6, .h6 {
  color: var(--vz-heading-color);
  font-family: "Poppins", sans-serif; }

a {
  text-decoration: none !important; }

label {
  font-weight: 500;
  margin-bottom: 0.5rem; }

b,
strong {
  font-weight: 600; }

.blockquote {
  padding: 10px 20px;
  border-left: 4px solid #e9ebec; }

.blockquote-reverse {
  border-left: 0;
  border-right: 4px solid #e9ebec;
  text-align: right; }

@media (min-width: 1200px) {
  .container,
  .container-lg,
  .container-md,
  .container-sm,
  .container-xl,
  .container-xxl {
    max-width: 1140px; } }

.row > * {
  position: relative; }

.alert-solid .alert-link {
  color: #fff; }

.alert-outline {
  background-color: var(--vz-card-bg);
  border-width: 2px; }

.alert-borderless {
  border-width: 0; }

.alert-label-icon {
  position: relative;
  padding-left: 60px;
  border: 0; }
  .alert-label-icon .label-icon {
    position: absolute;
    width: 45px;
    height: 100%;
    left: 0;
    top: 0;
    background-color: rgba(255, 255, 255, 0.15);
    font-size: 16px;
    display: flex;
    align-items: center;
    justify-content: center; }
  .alert-label-icon.label-arrow {
    overflow: hidden; }
    .alert-label-icon.label-arrow .label-icon:after {
      content: "";
      position: absolute;
      border: 6px solid transparent;
      border-left-color: #5ea3cb;
      right: -12px; }

.alert-border-left {
  border-left: 3px solid; }

.alert-top-border {
  background-color: var(--vz-card-bg);
  border-color: var(--vz-border-color);
  border-top: 2px solid;
  color: var(--vz-body-color); }

.alert-additional {
  padding: 0; }
  .alert-additional .alert-body {
    padding: 0.8rem 1rem; }
  .alert-additional .alert-content {
    padding: 0.8rem 1rem;
    border-bottom-left-radius: 0.25rem;
    border-bottom-right-radius: 0.25rem;
    margin: 0 -1px -1px -1px; }

.rounded-label .label-icon {
  width: 45px;
  height: 26px;
  left: 0px;
  top: 50%;
  transform: translateY(-50%);
  border-radius: 0 30px 30px 0; }

.alert-solid.alert-primary {
  background-color: #5ea3cb;
  border-color: #5ea3cb;
  color: #fff; }

.alert-outline.alert-primary {
  color: #5ea3cb; }

.alert-border-left.alert-primary {
  border-left-color: #5ea3cb; }

.alert-top-border.alert-primary {
  border-top-color: #5ea3cb; }

.rounded-label.alert-primary .label-icon {
  background-color: #5ea3cb;
  color: #fff; }

.label-arrow.alert-primary .label-icon {
  color: #fff;
  background-color: #5ea3cb; }
  .label-arrow.alert-primary .label-icon:after {
    border-left-color: #5ea3cb !important; }

.alert.alert-primary .btn-close::after {
  color: #5ea3cb; }

.alert-additional.alert-primary .alert-content {
  background-color: #5ea3cb;
  color: #fff; }

.alert-solid.alert-secondary {
  background-color: #7084c7;
  border-color: #7084c7;
  color: #fff; }

.alert-outline.alert-secondary {
  color: #7084c7; }

.alert-border-left.alert-secondary {
  border-left-color: #7084c7; }

.alert-top-border.alert-secondary {
  border-top-color: #7084c7; }

.rounded-label.alert-secondary .label-icon {
  background-color: #7084c7;
  color: #fff; }

.label-arrow.alert-secondary .label-icon {
  color: #fff;
  background-color: #7084c7; }
  .label-arrow.alert-secondary .label-icon:after {
    border-left-color: #7084c7 !important; }

.alert.alert-secondary .btn-close::after {
  color: #7084c7; }

.alert-additional.alert-secondary .alert-content {
  background-color: #7084c7;
  color: #fff; }

.alert-solid.alert-success {
  background-color: #319795;
  border-color: #319795;
  color: #fff; }

.alert-outline.alert-success {
  color: #319795; }

.alert-border-left.alert-success {
  border-left-color: #319795; }

.alert-top-border.alert-success {
  border-top-color: #319795; }

.rounded-label.alert-success .label-icon {
  background-color: #319795;
  color: #fff; }

.label-arrow.alert-success .label-icon {
  color: #fff;
  background-color: #319795; }
  .label-arrow.alert-success .label-icon:after {
    border-left-color: #319795 !important; }

.alert.alert-success .btn-close::after {
  color: #319795; }

.alert-additional.alert-success .alert-content {
  background-color: #319795;
  color: #fff; }

.alert-solid.alert-info {
  background-color: #58caea;
  border-color: #58caea;
  color: #fff; }

.alert-outline.alert-info {
  color: #58caea; }

.alert-border-left.alert-info {
  border-left-color: #58caea; }

.alert-top-border.alert-info {
  border-top-color: #58caea; }

.rounded-label.alert-info .label-icon {
  background-color: #58caea;
  color: #fff; }

.label-arrow.alert-info .label-icon {
  color: #fff;
  background-color: #58caea; }
  .label-arrow.alert-info .label-icon:after {
    border-left-color: #58caea !important; }

.alert.alert-info .btn-close::after {
  color: #58caea; }

.alert-additional.alert-info .alert-content {
  background-color: #58caea;
  color: #fff; }

.alert-solid.alert-warning {
  background-color: #f7b84b;
  border-color: #f7b84b;
  color: #fff; }

.alert-outline.alert-warning {
  color: #f7b84b; }

.alert-border-left.alert-warning {
  border-left-color: #f7b84b; }

.alert-top-border.alert-warning {
  border-top-color: #f7b84b; }

.rounded-label.alert-warning .label-icon {
  background-color: #f7b84b;
  color: #fff; }

.label-arrow.alert-warning .label-icon {
  color: #fff;
  background-color: #f7b84b; }
  .label-arrow.alert-warning .label-icon:after {
    border-left-color: #f7b84b !important; }

.alert.alert-warning .btn-close::after {
  color: #f7b84b; }

.alert-additional.alert-warning .alert-content {
  background-color: #f7b84b;
  color: #fff; }

.alert-solid.alert-danger {
  background-color: #E53E3E;
  border-color: #E53E3E;
  color: #fff; }

.alert-outline.alert-danger {
  color: #E53E3E; }

.alert-border-left.alert-danger {
  border-left-color: #E53E3E; }

.alert-top-border.alert-danger {
  border-top-color: #E53E3E; }

.rounded-label.alert-danger .label-icon {
  background-color: #E53E3E;
  color: #fff; }

.label-arrow.alert-danger .label-icon {
  color: #fff;
  background-color: #E53E3E; }
  .label-arrow.alert-danger .label-icon:after {
    border-left-color: #E53E3E !important; }

.alert.alert-danger .btn-close::after {
  color: #E53E3E; }

.alert-additional.alert-danger .alert-content {
  background-color: #E53E3E;
  color: #fff; }

.alert-solid.alert-light {
  background-color: #f3f6f9;
  border-color: #f3f6f9;
  color: #000; }

.alert-outline.alert-light {
  color: #f3f6f9; }

.alert-border-left.alert-light {
  border-left-color: #f3f6f9; }

.alert-top-border.alert-light {
  border-top-color: #f3f6f9; }

.rounded-label.alert-light .label-icon {
  background-color: #f3f6f9;
  color: #000; }

.label-arrow.alert-light .label-icon {
  color: #000;
  background-color: #f3f6f9; }
  .label-arrow.alert-light .label-icon:after {
    border-left-color: #f3f6f9 !important; }

.alert.alert-light .btn-close::after {
  color: #f3f6f9; }

.alert-additional.alert-light .alert-content {
  background-color: #f3f6f9;
  color: #000; }

.alert-solid.alert-dark {
  background-color: #212529;
  border-color: #212529;
  color: #fff; }

.alert-outline.alert-dark {
  color: #212529; }

.alert-border-left.alert-dark {
  border-left-color: #212529; }

.alert-top-border.alert-dark {
  border-top-color: #212529; }

.rounded-label.alert-dark .label-icon {
  background-color: #212529;
  color: #fff; }

.label-arrow.alert-dark .label-icon {
  color: #fff;
  background-color: #212529; }
  .label-arrow.alert-dark .label-icon:after {
    border-left-color: #212529 !important; }

.alert.alert-dark .btn-close::after {
  color: #212529; }

.alert-additional.alert-dark .alert-content {
  background-color: #212529;
  color: #fff; }

.alert-dismissible .btn-close {
  background: transparent !important; }
  .alert-dismissible .btn-close::after {
    background: transparent !important;
    content: "\\F0156" !important;
    font-size: 18px;
    line-height: 15px;
    font-family: "Material Design Icons" !important; }

.alert-outline.alert-dark {
  color: var(--vz-dark); }

.bg-soft-primary {
  background-color: rgba(94, 163, 203, 0.18) !important; }

.bg-soft-secondary {
  background-color: rgba(112, 132, 199, 0.18) !important; }

.bg-soft-success {
  background-color: rgba(49, 151, 149, 0.18) !important; }

.bg-soft-info {
  background-color: rgba(88, 202, 234, 0.18) !important; }

.bg-soft-warning {
  background-color: rgba(247, 184, 75, 0.18) !important; }

.bg-soft-danger {
  background-color: rgba(229, 62, 62, 0.18) !important; }

.bg-soft-light {
  background-color: rgba(243, 246, 249, 0.18) !important; }

.bg-soft-dark {
  background-color: rgba(33, 37, 41, 0.18) !important; }

.bg-soft-dark {
  background-color: rgba(var(--vz-dark-rgb), 0.18) !important; }

.bg-soft-light {
  background-color: rgba(var(--vz-light-rgb), 0.18) !important; }

.badge-outline-primary {
  color: #5ea3cb;
  border: 1px solid #5ea3cb;
  background-color: transparent; }

.badge-outline-secondary {
  color: #7084c7;
  border: 1px solid #7084c7;
  background-color: transparent; }

.badge-outline-success {
  color: #319795;
  border: 1px solid #319795;
  background-color: transparent; }

.badge-outline-info {
  color: #58caea;
  border: 1px solid #58caea;
  background-color: transparent; }

.badge-outline-warning {
  color: #f7b84b;
  border: 1px solid #f7b84b;
  background-color: transparent; }

.badge-outline-danger {
  color: #E53E3E;
  border: 1px solid #E53E3E;
  background-color: transparent; }

.badge-outline-light {
  color: #f3f6f9;
  border: 1px solid #f3f6f9;
  background-color: transparent; }

.badge-outline-dark {
  color: #212529;
  border: 1px solid #212529;
  background-color: transparent; }

.badge-outline {
  background-color: var(--vz-card-bg);
  border: 1px solid; }

.badge-soft-primary {
  color: #5ea3cb;
  background-color: rgba(94, 163, 203, 0.1); }

.badge-outline.badge-primary {
  color: #5ea3cb;
  border: 1px solid #5ea3cb;
  background-color: transparent; }

.badge-label.bg-primary:before {
  border-right-color: #5ea3cb; }

.badge-soft-secondary {
  color: #7084c7;
  background-color: rgba(112, 132, 199, 0.1); }

.badge-outline.badge-secondary {
  color: #7084c7;
  border: 1px solid #7084c7;
  background-color: transparent; }

.badge-label.bg-secondary:before {
  border-right-color: #7084c7; }

.badge-soft-success {
  color: #319795;
  background-color: rgba(49, 151, 149, 0.1); }

.badge-outline.badge-success {
  color: #319795;
  border: 1px solid #319795;
  background-color: transparent; }

.badge-label.bg-success:before {
  border-right-color: #319795; }

.badge-soft-info {
  color: #58caea;
  background-color: rgba(88, 202, 234, 0.1); }

.badge-outline.badge-info {
  color: #58caea;
  border: 1px solid #58caea;
  background-color: transparent; }

.badge-label.bg-info:before {
  border-right-color: #58caea; }

.badge-soft-warning {
  color: #f7b84b;
  background-color: rgba(247, 184, 75, 0.1); }

.badge-outline.badge-warning {
  color: #f7b84b;
  border: 1px solid #f7b84b;
  background-color: transparent; }

.badge-label.bg-warning:before {
  border-right-color: #f7b84b; }

.badge-soft-danger {
  color: #E53E3E;
  background-color: rgba(229, 62, 62, 0.1); }

.badge-outline.badge-danger {
  color: #E53E3E;
  border: 1px solid #E53E3E;
  background-color: transparent; }

.badge-label.bg-danger:before {
  border-right-color: #E53E3E; }

.badge-soft-light {
  color: #f3f6f9;
  background-color: rgba(243, 246, 249, 0.1); }

.badge-outline.badge-light {
  color: #f3f6f9;
  border: 1px solid #f3f6f9;
  background-color: transparent; }

.badge-label.bg-light:before {
  border-right-color: #f3f6f9; }

.badge-soft-dark {
  color: #212529;
  background-color: rgba(33, 37, 41, 0.1); }

.badge-outline.badge-dark {
  color: #212529;
  border: 1px solid #212529;
  background-color: transparent; }

.badge-label.bg-dark:before {
  border-right-color: #212529; }

.badge-border {
  border-left: 2px solid; }

.badge-label {
  margin-left: 8px;
  position: relative; }
  .badge-label:before {
    content: "";
    position: absolute;
    border: 8px solid transparent;
    border-right-color: #5ea3cb;
    left: -14px;
    top: 0; }

[data-layout-mode="dark"] .badge.bg-dark {
  background-color: var(--vz-light) !important; }

[data-layout-mode="dark"] .badge.bg-light {
  background-color: var(--vz-dark) !important;
  color: var(--vz-light) !important; }

.badge-gradient-primary {
  background: linear-gradient(135deg, #5ea3cb 0%, #319795 100%); }

.badge-gradient-secondary {
  background: linear-gradient(135deg, #7084c7 0%, #58caea 100%); }

.badge-gradient-success {
  background: linear-gradient(135deg, #319795 0%, #f7b84b 100%); }

.badge-gradient-danger {
  background: linear-gradient(135deg, #E53E3E 0%, #7084c7 100%); }

.badge-gradient-warning {
  background: linear-gradient(135deg, #f7b84b 0%, #eb990a 100%); }

.badge-gradient-info {
  background: linear-gradient(135deg, #58caea 0%, #319795 100%); }

.badge-gradient-dark {
  background: linear-gradient(135deg, #212529 0%, #5ea3cb 100%); }

button,
a {
  outline: none !important;
  position: relative; }

.btn {
  box-shadow: none; }

.btn-rounded {
  border-radius: 30px; }

.btn-icon {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  height: calc(1rem + 1.5em + 2px);
  width: calc(1rem + 1.5em + 2px);
  padding: 0; }
  .btn-icon i,
  .btn-icon svg,
  .btn-icon img {
    vertical-align: middle; }
  .btn-icon.btn-sm, .btn-group-sm > .btn-icon.btn {
    height: calc(0.5rem + 1.5em + 2px);
    width: calc(0.5rem + 1.5em + 2px); }
  .btn-icon.btn-lg, .btn-group-lg > .btn-icon.btn {
    height: calc(1.4rem + 1.5em + 2px);
    width: calc(1.4rem + 1.5em + 2px); }

.btn-soft-primary {
  color: #5ea3cb;
  background-color: rgba(94, 163, 203, 0.1);
  border-color: transparent; }
  .btn-soft-primary:hover, .btn-soft-primary:focus, .btn-soft-primary:active {
    color: #fff;
    background-color: #5ea3cb; }

.btn-soft-secondary {
  color: #7084c7;
  background-color: rgba(112, 132, 199, 0.1);
  border-color: transparent; }
  .btn-soft-secondary:hover, .btn-soft-secondary:focus, .btn-soft-secondary:active {
    color: #fff;
    background-color: #7084c7; }

.btn-soft-success {
  color: #319795;
  background-color: rgba(49, 151, 149, 0.1);
  border-color: transparent; }
  .btn-soft-success:hover, .btn-soft-success:focus, .btn-soft-success:active {
    color: #fff;
    background-color: #319795; }

.btn-soft-info {
  color: #58caea;
  background-color: rgba(88, 202, 234, 0.1);
  border-color: transparent; }
  .btn-soft-info:hover, .btn-soft-info:focus, .btn-soft-info:active {
    color: #fff;
    background-color: #58caea; }

.btn-soft-warning {
  color: #f7b84b;
  background-color: rgba(247, 184, 75, 0.1);
  border-color: transparent; }
  .btn-soft-warning:hover, .btn-soft-warning:focus, .btn-soft-warning:active {
    color: #fff;
    background-color: #f7b84b; }

.btn-soft-danger {
  color: #E53E3E;
  background-color: rgba(229, 62, 62, 0.1);
  border-color: transparent; }
  .btn-soft-danger:hover, .btn-soft-danger:focus, .btn-soft-danger:active {
    color: #fff;
    background-color: #E53E3E; }

.btn-soft-light {
  color: #f3f6f9;
  background-color: rgba(243, 246, 249, 0.1);
  border-color: transparent; }
  .btn-soft-light:hover, .btn-soft-light:focus, .btn-soft-light:active {
    color: #fff;
    background-color: #f3f6f9; }

.btn-soft-dark {
  color: #212529;
  background-color: rgba(33, 37, 41, 0.1);
  border-color: transparent; }
  .btn-soft-dark:hover, .btn-soft-dark:focus, .btn-soft-dark:active {
    color: #fff;
    background-color: #212529; }

.btn-ghost-primary {
  color: #5ea3cb;
  border-color: transparent; }
  .btn-ghost-primary:hover, .btn-ghost-primary:focus, .btn-ghost-primary:active {
    color: #5ea3cb;
    background-color: rgba(94, 163, 203, 0.1); }

.btn-ghost-secondary {
  color: #7084c7;
  border-color: transparent; }
  .btn-ghost-secondary:hover, .btn-ghost-secondary:focus, .btn-ghost-secondary:active {
    color: #7084c7;
    background-color: rgba(112, 132, 199, 0.1); }

.btn-ghost-success {
  color: #319795;
  border-color: transparent; }
  .btn-ghost-success:hover, .btn-ghost-success:focus, .btn-ghost-success:active {
    color: #319795;
    background-color: rgba(49, 151, 149, 0.1); }

.btn-ghost-info {
  color: #58caea;
  border-color: transparent; }
  .btn-ghost-info:hover, .btn-ghost-info:focus, .btn-ghost-info:active {
    color: #58caea;
    background-color: rgba(88, 202, 234, 0.1); }

.btn-ghost-warning {
  color: #f7b84b;
  border-color: transparent; }
  .btn-ghost-warning:hover, .btn-ghost-warning:focus, .btn-ghost-warning:active {
    color: #f7b84b;
    background-color: rgba(247, 184, 75, 0.1); }

.btn-ghost-danger {
  color: #E53E3E;
  border-color: transparent; }
  .btn-ghost-danger:hover, .btn-ghost-danger:focus, .btn-ghost-danger:active {
    color: #E53E3E;
    background-color: rgba(229, 62, 62, 0.1); }

.btn-ghost-light {
  color: #f3f6f9;
  border-color: transparent; }
  .btn-ghost-light:hover, .btn-ghost-light:focus, .btn-ghost-light:active {
    color: #f3f6f9;
    background-color: rgba(243, 246, 249, 0.1); }

.btn-ghost-dark {
  color: #212529;
  border-color: transparent; }
  .btn-ghost-dark:hover, .btn-ghost-dark:focus, .btn-ghost-dark:active {
    color: #212529;
    background-color: rgba(33, 37, 41, 0.1); }

.btn-ghost-secondary {
  color: var(--vz-gray-700); }

.btn-label {
  position: relative;
  padding-left: 44px; }
  .btn-label .label-icon {
    position: absolute;
    width: 35.5px;
    left: -1px;
    top: -1px;
    bottom: -1px;
    background-color: rgba(255, 255, 255, 0.1);
    font-size: 16px;
    display: flex;
    align-items: center;
    justify-content: center; }
  .btn-label.btn-light .label-icon {
    background-color: rgba(33, 37, 41, 0.05); }
  .btn-label.right {
    padding-left: 0.9rem;
    padding-right: 44px; }
    .btn-label.right .label-icon {
      right: -1px;
      left: auto; }

.btn-animation {
  overflow: hidden;
  transition: border-color 0.3s, background-color 0.3s;
  transition-timing-function: cubic-bezier(0.2, 1, 0.3, 1); }
  .btn-animation::after {
    content: attr(data-text);
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    opacity: 0;
    transform: translate3d(0, 25%, 0);
    padding: 0.5rem 0.9rem;
    transition: transform 0.3s, opacity 0.3s;
    transition-timing-function: cubic-bezier(0.2, 1, 0.3, 1); }
  .btn-animation > span {
    display: block;
    transition: transform 0.3s, opacity 0.3s;
    transition-timing-function: cubic-bezier(0.2, 1, 0.3, 1); }
  .btn-animation:hover::after {
    opacity: 1;
    transform: translate3d(0, 0, 0); }
  .btn-animation:hover > span {
    opacity: 0;
    transform: translate3d(0, -25%, 0); }

.btn-primary.btn-animation {
  background-color: #5ea3cb;
  border-color: #5ea3cb; }
  .btn-primary.btn-animation:hover, .btn-primary.btn-animation:focus, .btn-primary.btn-animation:active {
    color: #5ea3cb;
    background-color: rgba(94, 163, 203, 0.1); }

.btn-secondary.btn-animation {
  background-color: #7084c7;
  border-color: #7084c7; }
  .btn-secondary.btn-animation:hover, .btn-secondary.btn-animation:focus, .btn-secondary.btn-animation:active {
    color: #7084c7;
    background-color: rgba(112, 132, 199, 0.1); }

.btn-success.btn-animation {
  background-color: #319795;
  border-color: #319795; }
  .btn-success.btn-animation:hover, .btn-success.btn-animation:focus, .btn-success.btn-animation:active {
    color: #319795;
    background-color: rgba(49, 151, 149, 0.1); }

.btn-info.btn-animation {
  background-color: #58caea;
  border-color: #58caea; }
  .btn-info.btn-animation:hover, .btn-info.btn-animation:focus, .btn-info.btn-animation:active {
    color: #58caea;
    background-color: rgba(88, 202, 234, 0.1); }

.btn-warning.btn-animation {
  background-color: #f7b84b;
  border-color: #f7b84b; }
  .btn-warning.btn-animation:hover, .btn-warning.btn-animation:focus, .btn-warning.btn-animation:active {
    color: #f7b84b;
    background-color: rgba(247, 184, 75, 0.1); }

.btn-danger.btn-animation {
  background-color: #E53E3E;
  border-color: #E53E3E; }
  .btn-danger.btn-animation:hover, .btn-danger.btn-animation:focus, .btn-danger.btn-animation:active {
    color: #E53E3E;
    background-color: rgba(229, 62, 62, 0.1); }

.btn-light.btn-animation {
  background-color: #f3f6f9;
  border-color: #f3f6f9; }
  .btn-light.btn-animation:hover, .btn-light.btn-animation:focus, .btn-light.btn-animation:active {
    color: #f3f6f9;
    background-color: rgba(243, 246, 249, 0.1); }

.btn-dark.btn-animation {
  background-color: #212529;
  border-color: #212529; }
  .btn-dark.btn-animation:hover, .btn-dark.btn-animation:focus, .btn-dark.btn-animation:active {
    color: #212529;
    background-color: rgba(33, 37, 41, 0.1); }

.btn-group-vertical label {
  margin-bottom: 0; }

.btn-group.radio .btn {
  border: none; }

.btn-group.radio .btn-check:active + .btn-light,
.btn-group.radio .btn-check:checked + .btn-light,
.btn-group.radio .btn-light.active,
.btn-group.radio .btn-light.dropdown-toggle.show,
.btn-group.radio .btn-light:active {
  background-color: rgba(88, 202, 234, 0.2);
  color: #58caea; }

[data-layout-mode="dark"] .btn-light {
  color: var(--vz-dark);
  background-color: var(--vz-light);
  border-color: var(--vz-light); }
  [data-layout-mode="dark"] .btn-light:hover {
    color: var(--vz-dark);
    background-color: rgba(var(--vz-light-rgb), 0.75);
    border-color: rgba(var(--vz-light-rgb), 0.75); }

[data-layout-mode="dark"] .btn-check:focus + .btn-light,
[data-layout-mode="dark"] .btn-check:focus + .btn-outline-light,
[data-layout-mode="dark"] .btn-check:focus + .btn-soft-light,
[data-layout-mode="dark"] .btn-light:focus,
[data-layout-mode="dark"] .btn-outline-light:focus,
[data-layout-mode="dark"] .btn-soft-light:focus {
  color: var(--vz-dark);
  background-color: rgba(var(--vz-light-rgb), 0.75);
  border-color: rgba(var(--vz-light-rgb), 0.75); }

[data-layout-mode="dark"] .btn-check:active + .btn-light,
[data-layout-mode="dark"] .btn-check:active + .btn-outline-light,
[data-layout-mode="dark"] .btn-check:active + .btn-soft-light,
[data-layout-mode="dark"] .btn-check:checked + .btn-light,
[data-layout-mode="dark"] .btn-check:checked + .btn-outline-light,
[data-layout-mode="dark"] .btn-check:checked + .btn-soft-light,
[data-layout-mode="dark"] .btn-light.active, [data-layout-mode="dark"] .btn-light:active,
[data-layout-mode="dark"] .btn-outline-light.active, [data-layout-mode="dark"] .btn-outline-light:active,
[data-layout-mode="dark"] .btn-soft-light.active, [data-layout-mode="dark"] .btn-soft-light:active,
[data-layout-mode="dark"] .show > .btn-light.dropdown-toggle,
[data-layout-mode="dark"] .show > .btn-outline-light.dropdown-toggle,
[data-layout-mode="dark"] .show > .btn-soft-light.dropdown-toggle {
  color: var(--vz-dark);
  background-color: rgba(var(--vz-light-rgb), 0.75);
  border-color: rgba(var(--vz-light-rgb), 0.75); }

[data-layout-mode="dark"] .btn-dark {
  color: var(--vz-light);
  background-color: var(--vz-dark);
  border-color: var(--vz-dark); }
  [data-layout-mode="dark"] .btn-dark:hover {
    color: var(--vz-light);
    background-color: rgba(var(--vz-dark-rgb), 0.75);
    border-color: rgba(var(--vz-dark-rgb), 0.75); }

[data-layout-mode="dark"] .btn-check:focus + .btn-dark,
[data-layout-mode="dark"] .btn-check:focus + .btn-outline-dark,
[data-layout-mode="dark"] .btn-check:focus + .btn-soft-dark,
[data-layout-mode="dark"] .btn-dark:focus,
[data-layout-mode="dark"] .btn-outline-dark:focus,
[data-layout-mode="dark"] .btn-soft-dark:focus {
  color: var(--vz-light);
  background-color: rgba(var(--vz-dark-rgb), 0.75);
  border-color: rgba(var(--vz-dark-rgb), 0.75); }

[data-layout-mode="dark"] .btn-check:active + .btn-dark,
[data-layout-mode="dark"] .btn-check:active + .btn-outline-dark,
[data-layout-mode="dark"] .btn-check:active + .btn-soft-dark,
[data-layout-mode="dark"] .btn-check:checked + .btn-dark,
[data-layout-mode="dark"] .btn-check:checked + .btn-outline-dark,
[data-layout-mode="dark"] .btn-check:checked + .btn-soft-dark,
[data-layout-mode="dark"] .btn-dark.active, [data-layout-mode="dark"] .btn-dark:active,
[data-layout-mode="dark"] .btn-outline-dark.active, [data-layout-mode="dark"] .btn-outline-dark:active,
[data-layout-mode="dark"] .btn-soft-dark.active, [data-layout-mode="dark"] .btn-soft-dark:active,
[data-layout-mode="dark"] .show > .btn-dark.dropdown-toggle,
[data-layout-mode="dark"] .show > .btn-outline-dark.dropdown-toggle,
[data-layout-mode="dark"] .show > .btn-soft-dark.dropdown-toggle {
  color: var(--vz-light);
  background-color: rgba(var(--vz-dark-rgb), 0.75);
  border-color: rgba(var(--vz-dark-rgb), 0.75); }

[data-layout-mode="dark"] .btn-outline-light {
  color: var(--vz-dark);
  border-color: var(--vz-light); }
  [data-layout-mode="dark"] .btn-outline-light:hover {
    color: var(--vz-dark);
    background-color: rgba(var(--vz-light-rgb), 0.75);
    border-color: rgba(var(--vz-light-rgb), 0.75); }

[data-layout-mode="dark"] .btn-outline-dark {
  color: var(--vz-dark);
  border-color: var(--vz-dark); }
  [data-layout-mode="dark"] .btn-outline-dark:hover {
    color: var(--vz-light);
    background-color: rgba(var(--vz-dark-rgb), 0.75);
    border-color: rgba(var(--vz-dark-rgb), 0.75); }

[data-layout-mode="dark"] .btn-soft-light {
  color: var(--vz-dark);
  background-color: rgba(var(--vz-light-rgb), 0.1); }
  [data-layout-mode="dark"] .btn-soft-light:hover {
    color: var(--vz-dark);
    background-color: var(--vz-light); }

[data-layout-mode="dark"] .btn-soft-dark {
  color: var(--vz-dark);
  background-color: rgba(var(--vz-dark-rgb), 0.1); }
  [data-layout-mode="dark"] .btn-soft-dark:hover {
    color: var(--vz-light);
    background-color: var(--vz-dark); }

[data-layout-mode="dark"] .btn-ghost-light {
  color: var(--vz-dark); }
  [data-layout-mode="dark"] .btn-ghost-light:hover, [data-layout-mode="dark"] .btn-ghost-light:focus, [data-layout-mode="dark"] .btn-ghost-light:active {
    color: var(--vz-dark);
    background-color: rgba(var(--vz-light-rgb), 0.5); }

[data-layout-mode="dark"] .btn-ghost-dark {
  color: var(--vz-dark); }
  [data-layout-mode="dark"] .btn-ghost-dark:hover, [data-layout-mode="dark"] .btn-ghost-dark:focus, [data-layout-mode="dark"] .btn-ghost-dark:active {
    color: var(--vz-dark);
    background-color: rgba(var(--vz-dark-rgb), 0.1); }

.btn-primary.btn-border,
.btn-outline-primary.btn-border,
.btn-soft-primary.btn-border {
  border-bottom: 2px solid #3f91c1; }

.btn-secondary.btn-border,
.btn-outline-secondary.btn-border,
.btn-soft-secondary.btn-border {
  border-bottom: 2px solid #536bbc; }

.btn-success.btn-border,
.btn-outline-success.btn-border,
.btn-soft-success.btn-border {
  border-bottom: 2px solid #277877; }

.btn-info.btn-border,
.btn-outline-info.btn-border,
.btn-soft-info.btn-border {
  border-bottom: 2px solid #34bee5; }

.btn-warning.btn-border,
.btn-outline-warning.btn-border,
.btn-soft-warning.btn-border {
  border-bottom: 2px solid #f5a924; }

.btn-danger.btn-border,
.btn-outline-danger.btn-border,
.btn-soft-danger.btn-border {
  border-bottom: 2px solid #dc1e1e; }

.btn-light.btn-border,
.btn-outline-light.btn-border,
.btn-soft-light.btn-border {
  border-bottom: 2px solid #d8e2eb; }

.btn-dark.btn-border,
.btn-outline-dark.btn-border,
.btn-soft-dark.btn-border {
  border-bottom: 2px solid #0f1112; }

.breadcrumb-item > a {
  color: var(--vz-gray-700); }

.breadcrumb-item + .breadcrumb-item::before {
  font-family: "Material Design Icons";
  font-size: 15px;
  line-height: 20px; }

.card {
  margin-bottom: 1.5rem;
  box-shadow: 0 1px 2px rgba(56, 65, 74, 0.15); }

.card-header {
  border-bottom: 1px solid var(--vz-border-color); }

.card-header-dropdown .dropdown-btn {
  padding: 1rem 0; }

.card-footer {
  border-top: 1px solid var(--vz-border-color); }

.card-drop {
  color: #212529; }

.card-title {
  font-size: 16px;
  margin: 0 0 7px 0; }

.card-title-desc {
  margin-bottom: 24px; }

.card-height-100 {
  height: calc(100% - 1.5rem); }

.card-animate {
  transition: all 0.4s; }
  .card-animate:hover {
    transform: translateY(calc(-1.5rem / 5));
    box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12); }

.card-primary {
  color: #fff;
  background-color: #5ea3cb; }
  .card-primary .card-header, .card-primary .card-footer {
    background-color: rgba(255, 255, 255, 0.1);
    color: #fff;
    border-color: transparent; }
  .card-primary .card-title {
    color: #fff; }

.card-secondary {
  color: #fff;
  background-color: #7084c7; }
  .card-secondary .card-header, .card-secondary .card-footer {
    background-color: rgba(255, 255, 255, 0.1);
    color: #fff;
    border-color: transparent; }
  .card-secondary .card-title {
    color: #fff; }

.card-success {
  color: #fff;
  background-color: #319795; }
  .card-success .card-header, .card-success .card-footer {
    background-color: rgba(255, 255, 255, 0.1);
    color: #fff;
    border-color: transparent; }
  .card-success .card-title {
    color: #fff; }

.card-info {
  color: #fff;
  background-color: #58caea; }
  .card-info .card-header, .card-info .card-footer {
    background-color: rgba(255, 255, 255, 0.1);
    color: #fff;
    border-color: transparent; }
  .card-info .card-title {
    color: #fff; }

.card-warning {
  color: #fff;
  background-color: #f7b84b; }
  .card-warning .card-header, .card-warning .card-footer {
    background-color: rgba(255, 255, 255, 0.1);
    color: #fff;
    border-color: transparent; }
  .card-warning .card-title {
    color: #fff; }

.card-danger {
  color: #fff;
  background-color: #E53E3E; }
  .card-danger .card-header, .card-danger .card-footer {
    background-color: rgba(255, 255, 255, 0.1);
    color: #fff;
    border-color: transparent; }
  .card-danger .card-title {
    color: #fff; }

.card-light {
  color: #fff;
  background-color: #f3f6f9; }
  .card-light .card-header, .card-light .card-footer {
    background-color: rgba(255, 255, 255, 0.1);
    color: #fff;
    border-color: transparent; }
  .card-light .card-title {
    color: #fff; }

.card-dark {
  color: #fff;
  background-color: #212529; }
  .card-dark .card-header, .card-dark .card-footer {
    background-color: rgba(255, 255, 255, 0.1);
    color: #fff;
    border-color: transparent; }
  .card-dark .card-title {
    color: #fff; }

.card-border-primary {
  border-color: #5ea3cb !important; }
  .card-border-primary .card-header, .card-border-primary .card-footer {
    border-color: #5ea3cb; }

.card-border-secondary {
  border-color: #7084c7 !important; }
  .card-border-secondary .card-header, .card-border-secondary .card-footer {
    border-color: #7084c7; }

.card-border-success {
  border-color: #319795 !important; }
  .card-border-success .card-header, .card-border-success .card-footer {
    border-color: #319795; }

.card-border-info {
  border-color: #58caea !important; }
  .card-border-info .card-header, .card-border-info .card-footer {
    border-color: #58caea; }

.card-border-warning {
  border-color: #f7b84b !important; }
  .card-border-warning .card-header, .card-border-warning .card-footer {
    border-color: #f7b84b; }

.card-border-danger {
  border-color: #E53E3E !important; }
  .card-border-danger .card-header, .card-border-danger .card-footer {
    border-color: #E53E3E; }

.card-border-light {
  border-color: #f3f6f9 !important; }
  .card-border-light .card-header, .card-border-light .card-footer {
    border-color: #f3f6f9; }

.card-border-dark {
  border-color: #212529 !important; }
  .card-border-dark .card-header, .card-border-dark .card-footer {
    border-color: #212529; }

.card-light {
  background-color: var(--vz-light); }
  .card-light .card-header, .card-light .card-footer {
    color: var(--vz-body-color) !important;
    background-color: rgba(var(--vz-dark-rgb), 0.1); }
  .card-light .card-title, .card-light .card-text {
    color: var(--vz-body-color) !important; }

.stretched-link {
  position: static; }

.card-preloader {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(var(--vz-light-rgb), 0.6);
  z-index: 9999; }

.card-status {
  width: 40px;
  height: 40px;
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%) !important; }

.custom-loader {
  animation: spin 2s linear infinite; }

@keyframes spin {
  to {
    transform: rotate(360deg); } }

.card-overlay {
  position: relative;
  overflow: hidden; }
  .card-overlay:before {
    content: "";
    background-color: rgba(94, 163, 203, 0.2);
    position: absolute;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0; }
  .card-overlay .card-header, .card-overlay .card-footer {
    border-color: rgba(255, 255, 255, 0.15) !important; }

.card-toolbar-menu {
  line-height: 0.8; }
  .card-toolbar-menu a {
    font-size: 17px; }
  .card-toolbar-menu .minimize-card .plus {
    display: none; }
  .card-toolbar-menu .minimize-card .minus {
    display: block; }
  .card-toolbar-menu .minimize-card.collapsed .plus {
    display: block; }
  .card-toolbar-menu .minimize-card.collapsed .minus {
    display: none; }

.dropdown-toggle::after {
  display: inline-block;
  margin-left: .255em;
  font-size: 15px;
  line-height: 15px;
  content: "\\F0140";
  font-family: "Material Design Icons"; }

.dropdown-menu {
  box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);
  animation-duration: .3s;
  animation-fill-mode: both;
  position: absolute;
  z-index: 1000; }
  .dropdown-menu.dropdown-megamenu {
    padding: 20px;
    left: 0 !important;
    right: 0 !important; }

@media (min-width: 600px) {
  .dropdown-menu-xl {
    width: 420px; }
  .dropdown-menu-lg {
    width: 320px; }
  .dropdown-menu-md {
    width: 240px; } }

.dropdown-toggle-split {
  border-left: none; }
  .dropdown-toggle-split::after {
    margin-left: 0px; }
  .dropdown-toggle-split:before {
    content: "";
    position: absolute;
    background-color: rgba(255, 255, 255, 0.12);
    top: -1px;
    bottom: -1px;
    right: -1px;
    left: 0;
    border-radius: 0 0.25rem 0.25rem 0; }

.dropdown-mega {
  position: static !important; }

.dropdown-mega-menu-xl {
  width: 38rem; }

.dropdown-mega-menu-lg {
  width: 26rem; }

[dir="ltr"] .dropdown-menu-start {
  --bs-position: end; }

[dir="ltr"] .dropdown-menu-end {
  --bs-position: start; }

.dropdown-head .nav-tabs-custom {
  border: 0; }
  .dropdown-head .nav-tabs-custom .nav-link {
    color: rgba(255, 255, 255, 0.6); }
    .dropdown-head .nav-tabs-custom .nav-link.active {
      background-color: var(--vz-dropdown-bg); }
    .dropdown-head .nav-tabs-custom .nav-link:hover {
      color: #fff; }

.dropdownmenu-primary .dropdown-item:focus, .dropdownmenu-primary .dropdown-item:hover, .dropdownmenu-primary .dropdown-item.active {
  background-color: rgba(94, 163, 203, 0.07);
  color: #5ea3cb; }

.dropdownmenu-secondary .dropdown-item:focus, .dropdownmenu-secondary .dropdown-item:hover, .dropdownmenu-secondary .dropdown-item.active {
  background-color: rgba(112, 132, 199, 0.07);
  color: #7084c7; }

.dropdownmenu-success .dropdown-item:focus, .dropdownmenu-success .dropdown-item:hover, .dropdownmenu-success .dropdown-item.active {
  background-color: rgba(49, 151, 149, 0.07);
  color: #319795; }

.dropdownmenu-info .dropdown-item:focus, .dropdownmenu-info .dropdown-item:hover, .dropdownmenu-info .dropdown-item.active {
  background-color: rgba(88, 202, 234, 0.07);
  color: #58caea; }

.dropdownmenu-warning .dropdown-item:focus, .dropdownmenu-warning .dropdown-item:hover, .dropdownmenu-warning .dropdown-item.active {
  background-color: rgba(247, 184, 75, 0.07);
  color: #f7b84b; }

.dropdownmenu-danger .dropdown-item:focus, .dropdownmenu-danger .dropdown-item:hover, .dropdownmenu-danger .dropdown-item.active {
  background-color: rgba(229, 62, 62, 0.07);
  color: #E53E3E; }

.dropdownmenu-light .dropdown-item:focus, .dropdownmenu-light .dropdown-item:hover, .dropdownmenu-light .dropdown-item.active {
  background-color: rgba(243, 246, 249, 0.07);
  color: #f3f6f9; }

.dropdownmenu-dark .dropdown-item:focus, .dropdownmenu-dark .dropdown-item:hover, .dropdownmenu-dark .dropdown-item.active {
  background-color: rgba(33, 37, 41, 0.07);
  color: #212529; }

.nav-tabs > li > a,
.nav-pills > li > a {
  color: var(--vz-gray-700);
  font-weight: 500; }

.nav-pills > a {
  color: var(--vz-gray-700);
  font-weight: 500; }

.nav-pills .nav-link.active,
.nav-pills .show > .nav-link {
  box-shadow: none; }

.nav-tabs-custom {
  border-bottom: 1px solid var(--vz-gray-300); }
  .nav-tabs-custom .nav-item {
    position: relative; }
    .nav-tabs-custom .nav-item .nav-link {
      border: none;
      font-weight: 500; }
      .nav-tabs-custom .nav-item .nav-link::after {
        content: "";
        background: #5ea3cb;
        height: 1px;
        position: absolute;
        width: 100%;
        left: 0;
        bottom: 0;
        transition: all 250ms ease 0s;
        transform: scale(0); }
      .nav-tabs-custom .nav-item .nav-link.active {
        color: #5ea3cb; }
        .nav-tabs-custom .nav-item .nav-link.active:after {
          transform: scale(1); }
  .nav-tabs-custom.card-header-tabs {
    margin-top: -1rem; }
    .nav-tabs-custom.card-header-tabs .nav-link {
      padding: 1rem 1rem; }

.vertical-nav .nav .nav-link {
  padding: 24px 16px;
  text-align: center;
  margin-bottom: 8px; }
  .vertical-nav .nav .nav-link .nav-icon {
    font-size: 24px; }

.navtab-bg li > a {
  background-color: #e9ebec;
  margin: 0 5px; }

.arrow-navtabs .nav-item .nav-link {
  position: relative;
  text-align: center; }
  .arrow-navtabs .nav-item .nav-link:before {
    content: "";
    position: absolute;
    border: 6px solid transparent;
    bottom: -12px;
    left: 50%;
    transform: translateX(-50%);
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out; }
    @media (prefers-reduced-motion: reduce) {
      .arrow-navtabs .nav-item .nav-link:before {
        transition: none; } }
  .arrow-navtabs .nav-item .nav-link.active:before {
    border-top-color: #5ea3cb; }

.custom-hover-nav-tabs .nav-item {
  text-align: center;
  overflow: hidden; }
  .custom-hover-nav-tabs .nav-item .nav-link {
    width: 120px;
    height: 45px;
    position: relative;
    border-radius: 0px; }
    .custom-hover-nav-tabs .nav-item .nav-link .nav-icon {
      font-size: 22px; }
    .custom-hover-nav-tabs .nav-item .nav-link .nav-titl {
      font-size: 14px; }
    .custom-hover-nav-tabs .nav-item .nav-link.active .nav-tab-position {
      color: #fff; }
    .custom-hover-nav-tabs .nav-item .nav-link .nav-tab-position {
      position: absolute;
      left: 0;
      right: 0;
      transition: all 0.4s; }
      .custom-hover-nav-tabs .nav-item .nav-link .nav-tab-position.nav-icon {
        top: 50%;
        transform: translateY(-50%); }
      .custom-hover-nav-tabs .nav-item .nav-link .nav-tab-position.nav-titl {
        bottom: -20px; }
    .custom-hover-nav-tabs .nav-item .nav-link:hover .nav-titl {
      bottom: 50%;
      transform: translateY(50%); }
    .custom-hover-nav-tabs .nav-item .nav-link:hover .nav-icon {
      top: -20px; }

.custom-verti-nav-pills .nav-link {
  background-color: var(--vz-light);
  margin-top: 7px;
  position: relative; }
  @media (min-width: 992px) {
    .custom-verti-nav-pills .nav-link::before {
      content: "";
      position: absolute;
      right: -20px;
      top: 50%;
      transform: translateY(-50%);
      border: 12px solid transparent;
      border-left-color: transparent;
      transition: border-left-color .04 ease; }
    .custom-verti-nav-pills .nav-link.active::before {
      border-left-color: #5ea3cb; } }

.animation-nav li {
  position: relative; }
  .animation-nav li a {
    color: var(--vz-body-color);
    border-radius: 4px;
    position: relative;
    overflow: hidden;
    transition: all 0.4s;
    z-index: 1; }
    .animation-nav li a span {
      position: relative; }
    .animation-nav li a::before {
      content: '';
      position: absolute;
      top: 0;
      width: 0;
      right: 0;
      height: 100%;
      transition: width 0.4s cubic-bezier(0.51, 0.18, 0, 0.88) 0.1s;
      background-color: #5ea3cb;
      z-index: -1; }
    .animation-nav li a:hover, .animation-nav li a.active {
      color: #fff;
      background-color: transparent !important; }
      .animation-nav li a:hover::before, .animation-nav li a.active::before {
        width: 100%;
        left: 0; }

.nav-border-top .nav-link {
  border-top: 3px solid transparent; }
  .nav-border-top .nav-link.active {
    border-top-color: #5ea3cb; }

.nav-border-top-primary .nav-link.active {
  color: #5ea3cb;
  border-top-color: #5ea3cb; }

.nav-border-top-secondary .nav-link.active {
  color: #7084c7;
  border-top-color: #7084c7; }

.nav-border-top-success .nav-link.active {
  color: #319795;
  border-top-color: #319795; }

.nav-border-top-info .nav-link.active {
  color: #58caea;
  border-top-color: #58caea; }

.nav-border-top-warning .nav-link.active {
  color: #f7b84b;
  border-top-color: #f7b84b; }

.nav-border-top-danger .nav-link.active {
  color: #E53E3E;
  border-top-color: #E53E3E; }

.nav-border-top-light .nav-link.active {
  color: #f3f6f9;
  border-top-color: #f3f6f9; }

.nav-border-top-dark .nav-link.active {
  color: #212529;
  border-top-color: #212529; }

.nav-custom {
  background-color: #5ea3cb;
  border-radius: 0.25rem; }
  .nav-custom .nav-item .nav-link {
    color: rgba(255, 255, 255, 0.75); }
    .nav-custom .nav-item .nav-link.active {
      color: #fff;
      background-color: rgba(255, 255, 255, 0.1); }
  .nav-custom.nav-custom-light .nav-item .nav-link {
    color: rgba(var(--vz-dark-rgb), 0.75); }
    .nav-custom.nav-custom-light .nav-item .nav-link.active {
      color: #f3f6f9;
      background-color: #5ea3cb; }

.nav-custom-primary {
  background-color: #5ea3cb; }

.nav-custom-secondary {
  background-color: #7084c7; }

.nav-custom-success {
  background-color: #319795; }

.nav-custom-info {
  background-color: #58caea; }

.nav-custom-warning {
  background-color: #f7b84b; }

.nav-custom-danger {
  background-color: #E53E3E; }

.nav-custom-light {
  background-color: #f3f6f9; }

.nav-custom-dark {
  background-color: #212529; }

.nav-custom-light {
  background-color: var(--vz-light); }

.nav-primary .nav-link.active {
  color: #fff;
  background-color: #5ea3cb; }

.nav-primary.nav-tabs .nav-link.active {
  color: #5ea3cb;
  background-color: var(--vz-card-bg); }

.nav-primary.nav-tabs-custom .nav-link.active {
  color: #5ea3cb;
  background-color: var(--vz-card-bg); }
  .nav-primary.nav-tabs-custom .nav-link.active::after {
    background-color: #5ea3cb; }

.nav-primary.arrow-navtabs .nav-link.active::before {
  border-top-color: #5ea3cb; }

.nav-primary.custom-verti-nav-pills .nav-link.active::before {
  border-left-color: #5ea3cb; }

.nav-secondary .nav-link.active {
  color: #fff;
  background-color: #7084c7; }

.nav-secondary.nav-tabs .nav-link.active {
  color: #7084c7;
  background-color: var(--vz-card-bg); }

.nav-secondary.nav-tabs-custom .nav-link.active {
  color: #7084c7;
  background-color: var(--vz-card-bg); }
  .nav-secondary.nav-tabs-custom .nav-link.active::after {
    background-color: #7084c7; }

.nav-secondary.arrow-navtabs .nav-link.active::before {
  border-top-color: #7084c7; }

.nav-secondary.custom-verti-nav-pills .nav-link.active::before {
  border-left-color: #7084c7; }

.nav-success .nav-link.active {
  color: #fff;
  background-color: #319795; }

.nav-success.nav-tabs .nav-link.active {
  color: #319795;
  background-color: var(--vz-card-bg); }

.nav-success.nav-tabs-custom .nav-link.active {
  color: #319795;
  background-color: var(--vz-card-bg); }
  .nav-success.nav-tabs-custom .nav-link.active::after {
    background-color: #319795; }

.nav-success.arrow-navtabs .nav-link.active::before {
  border-top-color: #319795; }

.nav-success.custom-verti-nav-pills .nav-link.active::before {
  border-left-color: #319795; }

.nav-info .nav-link.active {
  color: #fff;
  background-color: #58caea; }

.nav-info.nav-tabs .nav-link.active {
  color: #58caea;
  background-color: var(--vz-card-bg); }

.nav-info.nav-tabs-custom .nav-link.active {
  color: #58caea;
  background-color: var(--vz-card-bg); }
  .nav-info.nav-tabs-custom .nav-link.active::after {
    background-color: #58caea; }

.nav-info.arrow-navtabs .nav-link.active::before {
  border-top-color: #58caea; }

.nav-info.custom-verti-nav-pills .nav-link.active::before {
  border-left-color: #58caea; }

.nav-warning .nav-link.active {
  color: #fff;
  background-color: #f7b84b; }

.nav-warning.nav-tabs .nav-link.active {
  color: #f7b84b;
  background-color: var(--vz-card-bg); }

.nav-warning.nav-tabs-custom .nav-link.active {
  color: #f7b84b;
  background-color: var(--vz-card-bg); }
  .nav-warning.nav-tabs-custom .nav-link.active::after {
    background-color: #f7b84b; }

.nav-warning.arrow-navtabs .nav-link.active::before {
  border-top-color: #f7b84b; }

.nav-warning.custom-verti-nav-pills .nav-link.active::before {
  border-left-color: #f7b84b; }

.nav-danger .nav-link.active {
  color: #fff;
  background-color: #E53E3E; }

.nav-danger.nav-tabs .nav-link.active {
  color: #E53E3E;
  background-color: var(--vz-card-bg); }

.nav-danger.nav-tabs-custom .nav-link.active {
  color: #E53E3E;
  background-color: var(--vz-card-bg); }
  .nav-danger.nav-tabs-custom .nav-link.active::after {
    background-color: #E53E3E; }

.nav-danger.arrow-navtabs .nav-link.active::before {
  border-top-color: #E53E3E; }

.nav-danger.custom-verti-nav-pills .nav-link.active::before {
  border-left-color: #E53E3E; }

.nav-light .nav-link.active {
  color: #fff;
  background-color: #f3f6f9; }

.nav-light.nav-tabs .nav-link.active {
  color: #f3f6f9;
  background-color: var(--vz-card-bg); }

.nav-light.nav-tabs-custom .nav-link.active {
  color: #f3f6f9;
  background-color: var(--vz-card-bg); }
  .nav-light.nav-tabs-custom .nav-link.active::after {
    background-color: #f3f6f9; }

.nav-light.arrow-navtabs .nav-link.active::before {
  border-top-color: #f3f6f9; }

.nav-light.custom-verti-nav-pills .nav-link.active::before {
  border-left-color: #f3f6f9; }

.nav-dark .nav-link.active {
  color: #fff;
  background-color: #212529; }

.nav-dark.nav-tabs .nav-link.active {
  color: #212529;
  background-color: var(--vz-card-bg); }

.nav-dark.nav-tabs-custom .nav-link.active {
  color: #212529;
  background-color: var(--vz-card-bg); }
  .nav-dark.nav-tabs-custom .nav-link.active::after {
    background-color: #212529; }

.nav-dark.arrow-navtabs .nav-link.active::before {
  border-top-color: #212529; }

.nav-dark.custom-verti-nav-pills .nav-link.active::before {
  border-left-color: #212529; }

.progress-nav {
  position: relative;
  margin-right: 1rem;
  margin-left: 1rem; }
  .progress-nav .progress {
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 100%; }
  .progress-nav .nav {
    margin-right: -1rem;
    margin-left: -1rem;
    justify-content: space-between; }
    .progress-nav .nav .nav-link {
      width: 2rem;
      height: 2rem;
      background-color: var(--vz-light);
      padding: 0;
      color: var(--vz-dark);
      font-weight: 500; }
      .progress-nav .nav .nav-link.active, .progress-nav .nav .nav-link.done {
        background-color: #5ea3cb;
        color: #fff; }

.step-arrow-nav .nav {
  background-color: var(--vz-light); }
  .step-arrow-nav .nav .nav-link {
    border-radius: 0;
    position: relative;
    font-weight: 500;
    color: var(--vz-dark); }
    .step-arrow-nav .nav .nav-link::before {
      content: "";
      position: absolute;
      border: 7px solid transparent;
      right: -14px;
      top: 50%;
      transform: translateY(-50%); }
    .step-arrow-nav .nav .nav-link.done {
      background-color: rgba(94, 163, 203, 0.05);
      color: #5ea3cb; }
      .step-arrow-nav .nav .nav-link.done::before {
        border-left-color: transparent; }
    .step-arrow-nav .nav .nav-link.active {
      background-color: rgba(94, 163, 203, 0.1);
      color: #5ea3cb;
      box-shadow: none; }
      .step-arrow-nav .nav .nav-link.active::before {
        border-left-color: rgba(94, 163, 203, 0.1); }
  .step-arrow-nav .nav .nav-item:last-child .nav-link:before {
    display: none; }

.vertical-navs-step .nav {
  gap: 16px; }
  .vertical-navs-step .nav .nav-link {
    text-align: left;
    background-color: rgba(var(--vz-light-rgb), 0.4);
    border: 1px solid var(--vz-border-color);
    color: var(--vz-dark); }
    .vertical-navs-step .nav .nav-link .step-title {
      font-weight: 600; }
    .vertical-navs-step .nav .nav-link .step-icon {
      color: #E53E3E;
      vertical-align: middle;
      font-weight: 500;
      float: left; }
    .vertical-navs-step .nav .nav-link.active .step-icon, .vertical-navs-step .nav .nav-link.done .step-icon {
      color: #319795; }
      .vertical-navs-step .nav .nav-link.active .step-icon:before, .vertical-navs-step .nav .nav-link.done .step-icon:before {
        content: "\\eb80"; }
    .vertical-navs-step .nav .nav-link.active {
      border-color: #5ea3cb; }
    .vertical-navs-step .nav .nav-link.done {
      border-color: #319795; }

.nav-custom-outline.nav .nav-link {
  border: 1px solid transparent;
  border-bottom: 2px solid transparent; }
  .nav-custom-outline.nav .nav-link.active {
    border-color: #5ea3cb;
    background-color: transparent;
    color: #5ea3cb; }

.nav-primary.nav-custom-outline .nav-link.active {
  color: #5ea3cb;
  border-color: #5ea3cb; }

.nav-secondary.nav-custom-outline .nav-link.active {
  color: #7084c7;
  border-color: #7084c7; }

.nav-success.nav-custom-outline .nav-link.active {
  color: #319795;
  border-color: #319795; }

.nav-info.nav-custom-outline .nav-link.active {
  color: #58caea;
  border-color: #58caea; }

.nav-warning.nav-custom-outline .nav-link.active {
  color: #f7b84b;
  border-color: #f7b84b; }

.nav-danger.nav-custom-outline .nav-link.active {
  color: #E53E3E;
  border-color: #E53E3E; }

.nav-light.nav-custom-outline .nav-link.active {
  color: #f3f6f9;
  border-color: #f3f6f9; }

.nav-dark.nav-custom-outline .nav-link.active {
  color: #212529;
  border-color: #212529; }

.nav-customs.nav {
  padding-left: 34px;
  overflow: hidden; }
  .nav-customs.nav .nav-link {
    position: relative;
    display: block;
    float: right;
    background-color: var(--vz-body-bg);
    margin-right: 46px;
    transition: all 0.5s ease; }
    .nav-customs.nav .nav-link::before, .nav-customs.nav .nav-link::after {
      display: block;
      content: " ";
      position: absolute;
      top: -1px;
      bottom: -1px;
      width: 37px;
      background-color: var(--vz-body-bg);
      transition: all 0.5s ease; }
    .nav-customs.nav .nav-link::before {
      border-radius: 0 8px 0 0;
      right: -24px;
      transform: skew(30deg, 0deg); }
    .nav-customs.nav .nav-link::after {
      border-radius: 8px 0 0 0;
      left: -24px;
      transform: skew(-30deg, 0deg); }
    .nav-customs.nav .nav-link.active, .nav-customs.nav .nav-link.active:before, .nav-customs.nav .nav-link.active:after {
      background-color: #5ea3cb;
      color: #fff; }
    .nav-customs.nav .nav-link.active {
      z-index: 1; }

.table th {
  font-weight: 600; }

.table .table-light {
  color: #212529;
  border-color: var(--vz-border-color);
  background-color: var(--vz-light); }

.table > thead {
  border-color: var(--vz-border-color); }

.table > :not(:first-child) {
  border-top-width: 1px; }

.table-nowrap th,
.table-nowrap td {
  white-space: nowrap; }

.table-card {
  margin: -1rem -1rem; }
  .table-card th:first-child,
  .table-card td:first-child {
    padding-left: 16px; }
  .table-card th:last-child,
  .table-card td:last-child {
    padding-right: 16px; }
  .table-card .table > :not(:first-child) {
    border-top-width: 1px; }

.border-primary.table > thead {
  border-color: #5ea3cb !important; }

.table-primary.table > thead {
  border-bottom-color: #85b9d7 !important; }

.border-secondary.table > thead {
  border-color: #7084c7 !important; }

.table-secondary.table > thead {
  border-bottom-color: #95a4d5 !important; }

.border-success.table > thead {
  border-color: #319795 !important; }

.table-success.table > thead {
  border-bottom-color: #3dbebb !important; }

.border-info.table > thead {
  border-color: #58caea !important; }

.table-info.table > thead {
  border-bottom-color: #85d8f0 !important; }

.border-warning.table > thead {
  border-color: #f7b84b !important; }

.table-warning.table > thead {
  border-bottom-color: #f9cb7c !important; }

.border-danger.table > thead {
  border-color: #E53E3E !important; }

.table-danger.table > thead {
  border-bottom-color: #eb6b6b !important; }

.border-light.table > thead {
  border-color: #f3f6f9 !important; }

.table-light.table > thead {
  border-bottom-color: white !important; }

.border-dark.table > thead {
  border-color: #212529 !important; }

.table-dark.table > thead {
  border-bottom-color: #383f45 !important; }

.table .form-check {
  padding-left: 0px;
  margin-bottom: 0px; }
  .table .form-check .form-check-input {
    margin-left: 0px;
    margin-top: 0px;
    float: none;
    vertical-align: middle; }

.table .sort {
  position: relative; }
  .table .sort::before {
    content: "\\f035d";
    position: absolute;
    right: 0.5rem;
    top: 18px;
    font-size: 0.8rem;
    font-family: "Material Design Icons"; }
  .table .sort::after {
    position: absolute;
    right: 0.5rem;
    content: "\\f0360";
    font-family: "Material Design Icons";
    font-size: 0.8rem;
    top: 12px; }

[data-layout-mode="dark"] .table-light {
  background-color: var(--vz-light);
  color: var(--vz-body-color); }
  [data-layout-mode="dark"] .table-light th,
  [data-layout-mode="dark"] .table-light td {
    background-color: var(--vz-light); }

.modal-title {
  font-weight: 600; }

.modal-dialog:not(.modal-dialog-scrollable) .modal-header {
  padding-bottom: 0; }
  .modal-dialog:not(.modal-dialog-scrollable) .modal-header .btn-close {
    margin-top: -1.25rem 1.25rem; }

.modal-dialog:not(.modal-dialog-scrollable) .modal-footer {
  padding-top: 0; }

.modal.fadeInRight .modal-dialog {
  opacity: 0;
  transform: translateX(20%);
  transition: all .3s ease-in-out; }

.modal.fadeInRight.show .modal-dialog {
  opacity: 1;
  transform: translateX(0); }

.modal.fadeInLeft .modal-dialog {
  animation: fadeInLeft 0.3s ease-in-out;
  transform: translate(-50%, 0); }

.modal.fadeInLeft.show .modal-dialog {
  transform: none; }

.modal.fadeInUp .modal-dialog {
  animation: fadeInUp 0.3s ease-in-out;
  transform: translate(0, 30%); }

.modal.fadeInUp.show .modal-dialog {
  transform: none; }

.modal.flip {
  perspective: 1300px; }
  .modal.flip .modal-dialog {
    opacity: 0;
    transform: rotateY(-70deg);
    transition: all .3s; }
  .modal.flip.show .modal-dialog {
    opacity: 1;
    transform: rotateY(0deg); }

.modal.zoomIn .modal-dialog {
  opacity: 0;
  transform: scale(0.7);
  transition: all .3s ease; }

.modal.zoomIn.show .modal-dialog {
  opacity: 1;
  transform: scale(1); }

.modal-dialog-right {
  margin-right: 1.75rem; }

.modal-dialog-bottom {
  display: flex;
  align-items: flex-end;
  min-height: calc(100% - 1.75rem); }
  @media (min-width: 576px) {
    .modal-dialog-bottom {
      min-height: calc(100% - 3.5rem); } }

.modal-dialog-bottom-right {
  display: flex;
  align-items: flex-end;
  min-height: calc(100% - 1.75rem);
  margin-right: 1.75rem; }
  @media (min-width: 576px) {
    .modal-dialog-bottom-right {
      min-height: calc(100% - 3.5rem); } }

@keyframes fadeInLeft {
  0% {
    opacity: 0;
    transform: translate3d(-30%, 0, 0); }
  to {
    opacity: 1;
    transform: translateZ(0); } }

@keyframes fadeInUp {
  0% {
    opacity: 0;
    transform: translate3d(0, 30%, 0); }
  to {
    opacity: 1;
    transform: translateZ(0); } }

@keyframes zoomIn {
  0% {
    opacity: 0;
    transform: scale3d(0.3, 0.3, 0.3); }
  50% {
    opacity: 1; } }

.login-modal {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_61___});
  background-size: cover;
  background-position: center; }

.pagination-separated .page-item .page-link {
  margin-left: 0.35rem;
  border-radius: 0.25rem; }

.pagination-rounded .page-link {
  border-radius: 30px !important;
  margin: 0 3px !important;
  border: none;
  min-width: 32px;
  min-height: 32px;
  text-align: center; }

.pagination-rounded.pagination-sm .page-link {
  min-width: 25px;
  min-height: 25px; }

.page-item.active .page-link {
  box-shadow: none; }

.progress-sm {
  height: 5px; }

.progress-lg {
  height: 12px; }

.progress-xl {
  height: 16px; }

.custom-progess {
  position: relative; }
  .custom-progess .progress-icon {
    position: absolute;
    top: -12px; }
    .custom-progess .progress-icon .avatar-title {
      background: var(--vz-card-bg); }

.animated-progess {
  position: relative; }
  .animated-progess .progress-bar {
    position: relative;
    border-radius: 6px;
    animation: animate-positive 2s; }

@keyframes animate-positive {
  0% {
    width: 0; } }

.custom-progress {
  height: 15px;
  padding: 4px;
  border-radius: 30px; }
  .custom-progress .progress-bar {
    position: relative;
    border-radius: 30px; }
    .custom-progress .progress-bar::before {
      content: "";
      position: absolute;
      width: 4px;
      height: 4px;
      background-color: #fff;
      border-radius: 7px;
      right: 2px;
      top: 50%;
      transform: translateY(-50%); }

.progress-label {
  overflow: visible; }
  .progress-label .progress-bar {
    position: relative;
    overflow: visible; }
    .progress-label .progress-bar .label {
      position: absolute;
      top: -25px;
      right: -9px;
      background-color: #5ea3cb;
      color: #fff;
      display: inline-block;
      line-height: 18px;
      padding: 0 4px;
      border-radius: 4px; }
      .progress-label .progress-bar .label:after {
        content: "";
        position: absolute;
        border: 4px solid transparent;
        border-top-color: #5ea3cb;
        bottom: -7px;
        left: 50%;
        transform: translateX(-50%); }

.progress-step-arrow {
  height: 3.25rem; }
  .progress-step-arrow .progress-bar {
    position: relative;
    overflow: initial;
    font-size: .875rem;
    color: #fff; }
    .progress-step-arrow .progress-bar::after {
      content: "";
      position: absolute;
      border: 10px solid transparent;
      bottom: 15px;
      right: -20px;
      z-index: 1; }

.progress-primary .progress-bar {
  background-color: #5ea3cb; }
  .progress-primary .progress-bar::after {
    border-left-color: #5ea3cb; }
  .progress-primary .progress-bar:nth-child(2) {
    background-color: rgba(94, 163, 203, 0.1) !important;
    color: #5ea3cb !important; }
    .progress-primary .progress-bar:nth-child(2)::after {
      border-left-color: rgba(94, 163, 203, 0.1); }

.progress-secondary .progress-bar {
  background-color: #7084c7; }
  .progress-secondary .progress-bar::after {
    border-left-color: #7084c7; }
  .progress-secondary .progress-bar:nth-child(2) {
    background-color: rgba(112, 132, 199, 0.1) !important;
    color: #7084c7 !important; }
    .progress-secondary .progress-bar:nth-child(2)::after {
      border-left-color: rgba(112, 132, 199, 0.1); }

.progress-success .progress-bar {
  background-color: #319795; }
  .progress-success .progress-bar::after {
    border-left-color: #319795; }
  .progress-success .progress-bar:nth-child(2) {
    background-color: rgba(49, 151, 149, 0.1) !important;
    color: #319795 !important; }
    .progress-success .progress-bar:nth-child(2)::after {
      border-left-color: rgba(49, 151, 149, 0.1); }

.progress-info .progress-bar {
  background-color: #58caea; }
  .progress-info .progress-bar::after {
    border-left-color: #58caea; }
  .progress-info .progress-bar:nth-child(2) {
    background-color: rgba(88, 202, 234, 0.1) !important;
    color: #58caea !important; }
    .progress-info .progress-bar:nth-child(2)::after {
      border-left-color: rgba(88, 202, 234, 0.1); }

.progress-warning .progress-bar {
  background-color: #f7b84b; }
  .progress-warning .progress-bar::after {
    border-left-color: #f7b84b; }
  .progress-warning .progress-bar:nth-child(2) {
    background-color: rgba(247, 184, 75, 0.1) !important;
    color: #f7b84b !important; }
    .progress-warning .progress-bar:nth-child(2)::after {
      border-left-color: rgba(247, 184, 75, 0.1); }

.progress-danger .progress-bar {
  background-color: #E53E3E; }
  .progress-danger .progress-bar::after {
    border-left-color: #E53E3E; }
  .progress-danger .progress-bar:nth-child(2) {
    background-color: rgba(229, 62, 62, 0.1) !important;
    color: #E53E3E !important; }
    .progress-danger .progress-bar:nth-child(2)::after {
      border-left-color: rgba(229, 62, 62, 0.1); }

.progress-light .progress-bar {
  background-color: #f3f6f9; }
  .progress-light .progress-bar::after {
    border-left-color: #f3f6f9; }
  .progress-light .progress-bar:nth-child(2) {
    background-color: rgba(243, 246, 249, 0.1) !important;
    color: #f3f6f9 !important; }
    .progress-light .progress-bar:nth-child(2)::after {
      border-left-color: rgba(243, 246, 249, 0.1); }

.progress-dark .progress-bar {
  background-color: #212529; }
  .progress-dark .progress-bar::after {
    border-left-color: #212529; }
  .progress-dark .progress-bar:nth-child(2) {
    background-color: rgba(33, 37, 41, 0.1) !important;
    color: #212529 !important; }
    .progress-dark .progress-bar:nth-child(2)::after {
      border-left-color: rgba(33, 37, 41, 0.1); }

.popover {
  box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12); }

.text-white-75 {
  color: rgba(255, 255, 255, 0.75) !important; }

.custom-blockquote.blockquote {
  padding: 16px;
  border-left: 3px solid; }
  .custom-blockquote.blockquote.blockquote-outline {
    background-color: var(--vz-card-bg) !important;
    border: 1px solid;
    border-left: 3px solid; }

.custom-blockquote.blockquote.blockquote-primary {
  color: #5ea3cb;
  border-color: #5ea3cb;
  background-color: rgba(94, 163, 203, 0.15); }
  .custom-blockquote.blockquote.blockquote-primary .blockquote-footer {
    color: #5ea3cb; }

.custom-blockquote.blockquote.blockquote-outline.blockquote-primary {
  border-color: #5ea3cb; }
  .custom-blockquote.blockquote.blockquote-outline.blockquote-primary .blockquote-footer {
    color: #5ea3cb; }

.custom-blockquote.blockquote.blockquote-secondary {
  color: #7084c7;
  border-color: #7084c7;
  background-color: rgba(112, 132, 199, 0.15); }
  .custom-blockquote.blockquote.blockquote-secondary .blockquote-footer {
    color: #7084c7; }

.custom-blockquote.blockquote.blockquote-outline.blockquote-secondary {
  border-color: #7084c7; }
  .custom-blockquote.blockquote.blockquote-outline.blockquote-secondary .blockquote-footer {
    color: #7084c7; }

.custom-blockquote.blockquote.blockquote-success {
  color: #319795;
  border-color: #319795;
  background-color: rgba(49, 151, 149, 0.15); }
  .custom-blockquote.blockquote.blockquote-success .blockquote-footer {
    color: #319795; }

.custom-blockquote.blockquote.blockquote-outline.blockquote-success {
  border-color: #319795; }
  .custom-blockquote.blockquote.blockquote-outline.blockquote-success .blockquote-footer {
    color: #319795; }

.custom-blockquote.blockquote.blockquote-info {
  color: #58caea;
  border-color: #58caea;
  background-color: rgba(88, 202, 234, 0.15); }
  .custom-blockquote.blockquote.blockquote-info .blockquote-footer {
    color: #58caea; }

.custom-blockquote.blockquote.blockquote-outline.blockquote-info {
  border-color: #58caea; }
  .custom-blockquote.blockquote.blockquote-outline.blockquote-info .blockquote-footer {
    color: #58caea; }

.custom-blockquote.blockquote.blockquote-warning {
  color: #f7b84b;
  border-color: #f7b84b;
  background-color: rgba(247, 184, 75, 0.15); }
  .custom-blockquote.blockquote.blockquote-warning .blockquote-footer {
    color: #f7b84b; }

.custom-blockquote.blockquote.blockquote-outline.blockquote-warning {
  border-color: #f7b84b; }
  .custom-blockquote.blockquote.blockquote-outline.blockquote-warning .blockquote-footer {
    color: #f7b84b; }

.custom-blockquote.blockquote.blockquote-danger {
  color: #E53E3E;
  border-color: #E53E3E;
  background-color: rgba(229, 62, 62, 0.15); }
  .custom-blockquote.blockquote.blockquote-danger .blockquote-footer {
    color: #E53E3E; }

.custom-blockquote.blockquote.blockquote-outline.blockquote-danger {
  border-color: #E53E3E; }
  .custom-blockquote.blockquote.blockquote-outline.blockquote-danger .blockquote-footer {
    color: #E53E3E; }

.custom-blockquote.blockquote.blockquote-light {
  color: #f3f6f9;
  border-color: #f3f6f9;
  background-color: rgba(243, 246, 249, 0.15); }
  .custom-blockquote.blockquote.blockquote-light .blockquote-footer {
    color: #f3f6f9; }

.custom-blockquote.blockquote.blockquote-outline.blockquote-light {
  border-color: #f3f6f9; }
  .custom-blockquote.blockquote.blockquote-outline.blockquote-light .blockquote-footer {
    color: #f3f6f9; }

.custom-blockquote.blockquote.blockquote-dark {
  color: #212529;
  border-color: #212529;
  background-color: rgba(33, 37, 41, 0.15); }
  .custom-blockquote.blockquote.blockquote-dark .blockquote-footer {
    color: #212529; }

.custom-blockquote.blockquote.blockquote-outline.blockquote-dark {
  border-color: #212529; }
  .custom-blockquote.blockquote.blockquote-outline.blockquote-dark .blockquote-footer {
    color: #212529; }

.custom-blockquote.blockquote.blockquote-dark {
  color: var(--vz-dark);
  border-color: var(--vz-dark);
  background-color: rgba(var(--vz-dark-rgb), 0.15); }
  .custom-blockquote.blockquote.blockquote-dark .blockquote-footer {
    color: var(--vz-dark); }

.custom-blockquote.blockquote.blockquote-outline.blockquote-dark {
  border-color: var(--vz-dark); }
  .custom-blockquote.blockquote.blockquote-outline.blockquote-dark .blockquote-footer {
    color: var(--vz-dark); }

.form-check {
  position: relative;
  text-align: left; }
  .form-check .form-check-input {
    cursor: pointer; }
  .form-check label {
    cursor: pointer; }

.form-check-primary .form-check-input:checked {
  background-color: #5ea3cb;
  border-color: #5ea3cb; }

.form-radio-primary .form-check-input:checked {
  border-color: #5ea3cb;
  background-color: #5ea3cb; }
  .form-radio-primary .form-check-input:checked:after {
    background-color: #5ea3cb; }

.form-check-secondary .form-check-input:checked {
  background-color: #7084c7;
  border-color: #7084c7; }

.form-radio-secondary .form-check-input:checked {
  border-color: #7084c7;
  background-color: #7084c7; }
  .form-radio-secondary .form-check-input:checked:after {
    background-color: #7084c7; }

.form-check-success .form-check-input:checked {
  background-color: #319795;
  border-color: #319795; }

.form-radio-success .form-check-input:checked {
  border-color: #319795;
  background-color: #319795; }
  .form-radio-success .form-check-input:checked:after {
    background-color: #319795; }

.form-check-info .form-check-input:checked {
  background-color: #58caea;
  border-color: #58caea; }

.form-radio-info .form-check-input:checked {
  border-color: #58caea;
  background-color: #58caea; }
  .form-radio-info .form-check-input:checked:after {
    background-color: #58caea; }

.form-check-warning .form-check-input:checked {
  background-color: #f7b84b;
  border-color: #f7b84b; }

.form-radio-warning .form-check-input:checked {
  border-color: #f7b84b;
  background-color: #f7b84b; }
  .form-radio-warning .form-check-input:checked:after {
    background-color: #f7b84b; }

.form-check-danger .form-check-input:checked {
  background-color: #E53E3E;
  border-color: #E53E3E; }

.form-radio-danger .form-check-input:checked {
  border-color: #E53E3E;
  background-color: #E53E3E; }
  .form-radio-danger .form-check-input:checked:after {
    background-color: #E53E3E; }

.form-check-light .form-check-input:checked {
  background-color: #f3f6f9;
  border-color: #f3f6f9; }

.form-radio-light .form-check-input:checked {
  border-color: #f3f6f9;
  background-color: #f3f6f9; }
  .form-radio-light .form-check-input:checked:after {
    background-color: #f3f6f9; }

.form-check-dark .form-check-input:checked {
  background-color: #212529;
  border-color: #212529; }

.form-radio-dark .form-check-input:checked {
  border-color: #212529;
  background-color: #212529; }
  .form-radio-dark .form-check-input:checked:after {
    background-color: #212529; }

.form-check-label {
  cursor: pointer;
  margin-bottom: 0; }

.form-check-right {
  padding-left: 0;
  display: inline-block; }
  .form-check-right .form-check-input {
    float: right;
    margin-left: 0;
    margin-right: -1.6em; }
  .form-check-right .form-check-label {
    display: block; }
  .form-check-right.form-switch .form-check-input {
    margin-right: -2.56em; }

.form-check-outline.form-check-primary .form-check-input:checked[type=checkbox] {
  color: #5ea3cb;
  background-color: transparent;
  border-color: #5ea3cb; }

.form-check-outline.form-check-secondary .form-check-input:checked[type=checkbox] {
  color: #7084c7;
  background-color: transparent;
  border-color: #7084c7; }

.form-check-outline.form-check-success .form-check-input:checked[type=checkbox] {
  color: #319795;
  background-color: transparent;
  border-color: #319795; }

.form-check-outline.form-check-info .form-check-input:checked[type=checkbox] {
  color: #58caea;
  background-color: transparent;
  border-color: #58caea; }

.form-check-outline.form-check-warning .form-check-input:checked[type=checkbox] {
  color: #f7b84b;
  background-color: transparent;
  border-color: #f7b84b; }

.form-check-outline.form-check-danger .form-check-input:checked[type=checkbox] {
  color: #E53E3E;
  background-color: transparent;
  border-color: #E53E3E; }

.form-check-outline.form-check-light .form-check-input:checked[type=checkbox] {
  color: #f3f6f9;
  background-color: transparent;
  border-color: #f3f6f9; }

.form-check-outline.form-check-dark .form-check-input:checked[type=checkbox] {
  color: #212529;
  background-color: transparent;
  border-color: #212529; }

.form-check-outline .form-check-input {
  position: relative; }
  .form-check-outline .form-check-input:checked[type=checkbox] {
    background-image: none; }
    .form-check-outline .form-check-input:checked[type=checkbox]::before {
      content: "\\F012C";
      font-family: "Material Design Icons";
      top: -2px;
      position: absolute;
      font-weight: 700;
      font-size: 11px;
      left: 1px; }

.form-radio-outline.form-radio-primary .form-check-input:checked[type=radio] {
  color: #5ea3cb;
  background-color: transparent;
  border-color: #5ea3cb; }

.form-radio-outline.form-radio-secondary .form-check-input:checked[type=radio] {
  color: #7084c7;
  background-color: transparent;
  border-color: #7084c7; }

.form-radio-outline.form-radio-success .form-check-input:checked[type=radio] {
  color: #319795;
  background-color: transparent;
  border-color: #319795; }

.form-radio-outline.form-radio-info .form-check-input:checked[type=radio] {
  color: #58caea;
  background-color: transparent;
  border-color: #58caea; }

.form-radio-outline.form-radio-warning .form-check-input:checked[type=radio] {
  color: #f7b84b;
  background-color: transparent;
  border-color: #f7b84b; }

.form-radio-outline.form-radio-danger .form-check-input:checked[type=radio] {
  color: #E53E3E;
  background-color: transparent;
  border-color: #E53E3E; }

.form-radio-outline.form-radio-light .form-check-input:checked[type=radio] {
  color: #f3f6f9;
  background-color: transparent;
  border-color: #f3f6f9; }

.form-radio-outline.form-radio-dark .form-check-input:checked[type=radio] {
  color: #212529;
  background-color: transparent;
  border-color: #212529; }

.form-radio-outline .form-check-input {
  position: relative; }
  .form-radio-outline .form-check-input:checked[type=radio] {
    background-image: none; }
    .form-radio-outline .form-check-input:checked[type=radio]::before {
      content: "\\F0765";
      font-family: "Material Design Icons";
      top: 0px;
      position: absolute;
      font-size: 8px;
      left: 2.2px; }

.form-switch-md {
  padding-left: 2.5rem;
  min-height: 22px;
  line-height: 22px; }
  .form-switch-md .form-check-input {
    width: 40px;
    height: 20px;
    left: -0.5rem;
    position: relative; }
  .form-switch-md .form-check-label {
    vertical-align: middle; }

.form-switch-lg {
  padding-left: 2.75rem;
  min-height: 28px;
  line-height: 28px; }
  .form-switch-lg .form-check-input {
    width: 48px;
    height: 24px;
    left: -0.75rem;
    position: relative; }

.input-group-text {
  margin-bottom: 0px; }

.form-switch-primary .form-check-input:checked {
  background-color: #5ea3cb;
  border-color: #5ea3cb; }

.form-switch-custom.form-switch-primary .form-check-input:checked::before {
  color: #5ea3cb; }

.form-switch-secondary .form-check-input:checked {
  background-color: #7084c7;
  border-color: #7084c7; }

.form-switch-custom.form-switch-secondary .form-check-input:checked::before {
  color: #7084c7; }

.form-switch-success .form-check-input:checked {
  background-color: #319795;
  border-color: #319795; }

.form-switch-custom.form-switch-success .form-check-input:checked::before {
  color: #319795; }

.form-switch-info .form-check-input:checked {
  background-color: #58caea;
  border-color: #58caea; }

.form-switch-custom.form-switch-info .form-check-input:checked::before {
  color: #58caea; }

.form-switch-warning .form-check-input:checked {
  background-color: #f7b84b;
  border-color: #f7b84b; }

.form-switch-custom.form-switch-warning .form-check-input:checked::before {
  color: #f7b84b; }

.form-switch-danger .form-check-input:checked {
  background-color: #E53E3E;
  border-color: #E53E3E; }

.form-switch-custom.form-switch-danger .form-check-input:checked::before {
  color: #E53E3E; }

.form-switch-light .form-check-input:checked {
  background-color: #f3f6f9;
  border-color: #f3f6f9; }

.form-switch-custom.form-switch-light .form-check-input:checked::before {
  color: #f3f6f9; }

.form-switch-dark .form-check-input:checked {
  background-color: #212529;
  border-color: #212529; }

.form-switch-custom.form-switch-dark .form-check-input:checked::before {
  color: #212529; }

.form-switch-custom .form-check-input {
  position: relative;
  background-image: none; }
  .form-switch-custom .form-check-input::before {
    content: "\\F0765";
    font-family: "Material Design Icons";
    top: -9px;
    position: absolute;
    font-size: 20px;
    left: -3px;
    color: #878a99;
    transition: background-position 0.15s ease-in-out; }
    @media (prefers-reduced-motion: reduce) {
      .form-switch-custom .form-check-input::before {
        transition: none; } }
  .form-switch-custom .form-check-input:checked {
    background-image: none;
    background-color: var(--vz-input-bg);
    transition: background-position 0.15s ease-in-out; }
    @media (prefers-reduced-motion: reduce) {
      .form-switch-custom .form-check-input:checked {
        transition: none; } }
    .form-switch-custom .form-check-input:checked::before {
      right: -3px;
      left: auto; }
  .form-switch-custom .form-check-input:focus {
    background-image: none; }

.form-switch-right {
  display: inline-block;
  padding-right: 0.8em;
  margin-bottom: 0;
  padding-left: 0 !important; }
  .form-switch-right .form-check-input {
    float: right;
    margin-left: 0;
    margin-right: -1.6em;
    margin-top: .1em !important; }
  .form-switch-right label {
    margin-bottom: 0;
    margin-right: 1rem; }

.card-radio {
  padding: 0; }
  .card-radio .form-check-label {
    background-color: var(--vz-card-bg);
    border: 1px solid rgba(0, 0, 0, 0.125);
    border-radius: 0.25rem;
    padding: 1rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: block;
    position: relative;
    padding-right: 32px; }
    .card-radio .form-check-label:hover {
      cursor: pointer; }
  .card-radio .form-check-input {
    display: none; }
    .card-radio .form-check-input:checked + .form-check-label {
      border-color: #5ea3cb !important; }
      .card-radio .form-check-input:checked + .form-check-label:before {
        content: '\\eb80';
        font-family: "remixicon";
        position: absolute;
        top: 2px;
        right: 6px;
        font-size: 16px;
        color: #5ea3cb; }
  .card-radio.dark .form-check-input:checked + .form-check-label:before {
    color: #fff; }

[data-layout-mode="dark"] .form-switch .form-check-input, [data-layout-mode="dark"] .form-switch .form-check-input:focus {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_62___}); }

.form-icon {
  position: relative; }
  .form-icon .form-control-icon {
    padding-left: 2.7rem;
    position: relative; }
  .form-icon i {
    position: absolute;
    top: 0px;
    bottom: 0px;
    left: 18px;
    display: flex;
    align-items: center; }
  .form-icon.right .form-control-icon {
    padding-right: 2.7rem;
    padding-left: 0.9rem;
    position: relative; }
  .form-icon.right i {
    left: auto;
    right: 18px; }

[data-layout-mode="dark"] .form-select {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_63___}); }

.list-group-fill-primary {
  background-color: #5ea3cb;
  border-color: #5ea3cb;
  color: #fff; }
  .list-group-fill-primary .list-group-item.active {
    background-color: #5ea3cb !important;
    border-color: #5ea3cb; }

.list-group-fill-secondary {
  background-color: #7084c7;
  border-color: #7084c7;
  color: #fff; }
  .list-group-fill-secondary .list-group-item.active {
    background-color: #7084c7 !important;
    border-color: #7084c7; }

.list-group-fill-success {
  background-color: #319795;
  border-color: #319795;
  color: #fff; }
  .list-group-fill-success .list-group-item.active {
    background-color: #319795 !important;
    border-color: #319795; }

.list-group-fill-info {
  background-color: #58caea;
  border-color: #58caea;
  color: #fff; }
  .list-group-fill-info .list-group-item.active {
    background-color: #58caea !important;
    border-color: #58caea; }

.list-group-fill-warning {
  background-color: #f7b84b;
  border-color: #f7b84b;
  color: #fff; }
  .list-group-fill-warning .list-group-item.active {
    background-color: #f7b84b !important;
    border-color: #f7b84b; }

.list-group-fill-danger {
  background-color: #E53E3E;
  border-color: #E53E3E;
  color: #fff; }
  .list-group-fill-danger .list-group-item.active {
    background-color: #E53E3E !important;
    border-color: #E53E3E; }

.list-group-fill-light {
  background-color: #f3f6f9;
  border-color: #f3f6f9;
  color: #fff; }
  .list-group-fill-light .list-group-item.active {
    background-color: #f3f6f9 !important;
    border-color: #f3f6f9; }

.list-group-fill-dark {
  background-color: #212529;
  border-color: #212529;
  color: #fff; }
  .list-group-fill-dark .list-group-item.active {
    background-color: #212529 !important;
    border-color: #212529; }

.list-group-fill-light {
  color: #212529 !important; }

.list-group-item {
  margin-bottom: 0px; }
  .list-group-item .list-text {
    color: #878a99; }
  .list-group-item.active {
    box-shadow: none; }
    .list-group-item.active .list-title {
      color: #fff; }
    .list-group-item.active .list-text {
      color: rgba(255, 255, 255, 0.5); }

[data-simplebar] {
  position: relative;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: flex-start;
  align-content: flex-start;
  align-items: flex-start; }

.simplebar-wrapper {
  overflow: hidden;
  width: inherit;
  height: inherit;
  max-width: inherit;
  max-height: inherit; }

.simplebar-mask {
  direction: inherit;
  position: absolute;
  overflow: hidden;
  padding: 0;
  margin: 0;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  width: auto !important;
  height: auto !important;
  z-index: 0; }

.simplebar-offset {
  direction: inherit !important;
  box-sizing: inherit !important;
  resize: none !important;
  position: absolute;
  top: 0;
  left: 0 !important;
  bottom: 0;
  right: 0 !important;
  padding: 0;
  margin: 0;
  -webkit-overflow-scrolling: touch; }

.simplebar-content-wrapper {
  direction: inherit;
  box-sizing: border-box !important;
  position: relative;
  display: block;
  height: 100%;
  /* Required for horizontal native scrollbar to not appear if parent is taller than natural height */
  width: auto;
  visibility: visible;
  overflow: auto;
  /* Scroll on this element otherwise element can't have a padding applied properly */
  max-width: 100%;
  /* Not required for horizontal scroll to trigger */
  max-height: 100%;
  /* Needed for vertical scroll to trigger */
  scrollbar-width: none;
  padding: 0px !important; }

.simplebar-content-wrapper::-webkit-scrollbar,
.simplebar-hide-scrollbar::-webkit-scrollbar {
  display: none; }

.simplebar-content:before,
.simplebar-content:after {
  content: ' ';
  display: table; }

.simplebar-placeholder {
  max-height: 100%;
  max-width: 100%;
  width: 100%;
  pointer-events: none; }

.simplebar-height-auto-observer-wrapper {
  box-sizing: inherit !important;
  height: 100%;
  width: 100%;
  max-width: 1px;
  position: relative;
  float: left;
  max-height: 1px;
  overflow: hidden;
  z-index: -1;
  padding: 0;
  margin: 0;
  pointer-events: none;
  flex-grow: inherit;
  flex-shrink: 0;
  flex-basis: 0; }

.simplebar-height-auto-observer {
  box-sizing: inherit;
  display: block;
  opacity: 0;
  position: absolute;
  top: 0;
  left: 0;
  height: 1000%;
  width: 1000%;
  min-height: 1px;
  min-width: 1px;
  overflow: hidden;
  pointer-events: none;
  z-index: -1; }

.simplebar-track {
  z-index: 1;
  position: absolute;
  right: 0;
  bottom: 0;
  pointer-events: none;
  overflow: hidden; }

[data-simplebar].simplebar-dragging .simplebar-content {
  pointer-events: none;
  user-select: none;
  -webkit-user-select: none; }

[data-simplebar].simplebar-dragging .simplebar-track {
  pointer-events: all; }

.simplebar-scrollbar {
  position: absolute;
  right: 2px;
  width: 6px;
  min-height: 10px; }

.simplebar-scrollbar:before {
  position: absolute;
  content: '';
  background: #a2adb7;
  border-radius: 7px;
  left: 0;
  right: 0;
  opacity: 0;
  transition: opacity 0.2s linear; }

.simplebar-scrollbar.simplebar-visible:before {
  /* When hovered, remove all transitions from drag handle */
  opacity: 0.5;
  transition: opacity 0s linear; }

.simplebar-track.simplebar-vertical {
  top: 0;
  width: 11px; }

.simplebar-track.simplebar-vertical .simplebar-scrollbar:before {
  top: 2px;
  bottom: 2px; }

.simplebar-track.simplebar-horizontal {
  left: 0;
  height: 11px; }

.simplebar-track.simplebar-horizontal .simplebar-scrollbar:before {
  height: 100%;
  left: 2px;
  right: 2px; }

.simplebar-track.simplebar-horizontal .simplebar-scrollbar {
  right: auto;
  left: 0;
  top: 2px;
  height: 7px;
  min-height: 0;
  min-width: 10px;
  width: auto; }

/* Rtl support */
[data-simplebar-direction='rtl'] .simplebar-track.simplebar-vertical {
  right: auto;
  left: 0; }

.hs-dummy-scrollbar-size {
  direction: rtl;
  position: fixed;
  opacity: 0;
  visibility: hidden;
  height: 500px;
  width: 500px;
  overflow-y: hidden;
  overflow-x: scroll; }

.simplebar-hide-scrollbar {
  position: fixed;
  left: 0;
  visibility: hidden;
  overflow-y: scroll;
  scrollbar-width: none; }

.custom-scroll {
  height: 100%; }

[data-simplebar-track="primary"] .simplebar-scrollbar:before {
  background: #5ea3cb; }

[data-simplebar-track="secondary"] .simplebar-scrollbar:before {
  background: #7084c7; }

[data-simplebar-track="success"] .simplebar-scrollbar:before {
  background: #319795; }

[data-simplebar-track="info"] .simplebar-scrollbar:before {
  background: #58caea; }

[data-simplebar-track="warning"] .simplebar-scrollbar:before {
  background: #f7b84b; }

[data-simplebar-track="danger"] .simplebar-scrollbar:before {
  background: #E53E3E; }

[data-simplebar-track="light"] .simplebar-scrollbar:before {
  background: #f3f6f9; }

[data-simplebar-track="dark"] .simplebar-scrollbar:before {
  background: #212529; }

/**
 * prism.js default theme for JavaScript, CSS and HTML
 * Based on dabblet (http://dabblet.com)
 * @author Lea Verou
 */
code[class*="language-"],
pre[class*="language-"] {
  color: black;
  background: none;
  text-shadow: 0 1px white;
  font-family: Consolas, Monaco, "Andale Mono", "Ubuntu Mono", monospace;
  font-size: 1em;
  text-align: left;
  white-space: pre;
  word-spacing: normal;
  word-break: normal;
  word-wrap: normal;
  line-height: 1.5;
  tab-size: 4;
  -webkit-hyphens: none;
  hyphens: none; }

pre[class*="language-"]::selection,
pre[class*="language-"] ::selection,
code[class*="language-"]::selection,
code[class*="language-"] ::selection {
  text-shadow: none;
  background: #b3d4fc; }

@media print {
  code[class*="language-"],
  pre[class*="language-"] {
    text-shadow: none; } }

/* Code blocks */
pre[class*="language-"] {
  padding: 1em;
  margin: 0;
  overflow: auto; }

:not(pre) > code[class*="language-"],
pre[class*="language-"] {
  background: var(--vz-light) !important; }

/* Inline code */
:not(pre) > code[class*="language-"] {
  padding: 0.1em;
  border-radius: 0.3em;
  white-space: normal; }

.token.comment,
.token.prolog,
.token.doctype,
.token.cdata {
  color: slategray; }

.token.punctuation {
  color: #999; }

.token.namespace {
  opacity: 0.7; }

.token.property,
.token.tag,
.token.boolean,
.token.number,
.token.constant,
.token.symbol,
.token.deleted {
  color: #E53E3E; }

.token.selector,
.token.attr-name,
.token.string,
.token.char,
.token.builtin,
.token.inserted {
  color: #690; }

.token.operator,
.token.entity,
.token.url,
.language-css .token.string,
.style .token.string {
  color: #9a6e3a;
  /* This background color was intended by the author of this theme. */
  background: rgba(255, 255, 255, 0.5); }

.token.atrule,
.token.attr-value,
.token.keyword {
  color: #07a; }

.token.function,
.token.class-name {
  color: #dd4a68; }

.token.regex,
.token.important,
.token.variable {
  color: #e90; }

.token.important,
.token.bold {
  font-weight: bold; }

.token.italic {
  font-style: italic; }

.token.entity {
  cursor: help; }

/* Prism editor */
:not(pre) > code[class*="language-"],
pre[class*="language-"] {
  background: #eff2f7; }

code[class*="language-"],
pre[class*="language-"] {
  color: #878a99;
  text-shadow: none; }

.language-markup::-webkit-scrollbar {
  -webkit-appearance: none; }

.language-markup::-webkit-scrollbar:vertical {
  width: 10px; }

.language-markup::-webkit-scrollbar:horizontal {
  height: 10px; }

.language-markup::-webkit-scrollbar-thumb {
  background-color: rgba(var(--vz-dark-rgb), 0.1);
  border-radius: 10px;
  border: 2px solid var(--vz-light); }

.language-markup::-webkit-scrollbar-track {
  border-radius: 10px;
  background-color: var(--vz-light); }

#scroll-top {
  width: 30px;
  height: 30px;
  position: fixed;
  bottom: 65px;
  right: 30px;
  background: #343a40;
  border-color: transparent;
  border-radius: 3px;
  color: #ffffff;
  transition: all 0.5s ease; }

.btn-clipboard {
  position: absolute !important;
  right: 15px !important;
  z-index: 1 !important; }

div.code-toolbar > .toolbar {
  opacity: 1 !important; }
  div.code-toolbar > .toolbar button {
    display: inline-block !important;
    margin: 0.375rem 0.5rem !important;
    padding: 0.25rem 0.75rem !important;
    transition: color 0.15s ease-in-out, background-color 0.15s ease-in-out, border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out !important;
    border-radius: 0.2rem !important;
    border: 1px solid rgba(94, 163, 203, 0.35) !important;
    background-color: transparent;
    color: #5ea3cb !important;
    box-shadow: none !important; }
    div.code-toolbar > .toolbar button:focus {
      outline: none !important;
      box-shadow: none !important; }
    div.code-toolbar > .toolbar button:hover {
      background-color: #5ea3cb !important;
      color: #fff !important; }

.swal2-container .swal2-title {
  padding: 24px 24px 0;
  font-size: 20px;
  font-weight: 500; }

.swal2-popup {
  padding-bottom: 24px;
  border-radius: 0.3rem;
  background-color: var(--vz-modal-bg);
  color: var(--vz-body-color); }
  .swal2-popup .swal2-title {
    color: var(--vz-heading-color); }
  .swal2-popup .swal2-html-container {
    color: var(--vz-body-color); }

.swal2-footer {
  border-top: 1px solid var(--vz-border-color);
  color: var(--vz-body-color); }

.swal2-html-container {
  font-size: 16px; }

.swal2-icon.swal2-question {
  border-color: #58caea;
  color: #58caea; }

.swal2-icon.swal2-success [class^=swal2-success-line] {
  background-color: #319795; }

.swal2-icon.swal2-success .swal2-success-ring {
  border-color: rgba(49, 151, 149, 0.3); }

.swal2-icon.swal2-warning {
  border-color: #f7b84b;
  color: #f7b84b; }

.swal2-styled:focus {
  box-shadow: none; }

.swal2-loader {
  border-color: #5ea3cb transparent #5ea3cb transparent; }

.swal2-timer-progress-bar {
  background-color: rgba(49, 151, 149, 0.4); }

.swal2-progress-steps .swal2-progress-step {
  background: #5ea3cb; }
  .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step {
    background: #5ea3cb; }
    .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step ~ .swal2-progress-step, .swal2-progress-steps .swal2-progress-step.swal2-active-progress-step ~ .swal2-progress-step-line {
      background: rgba(94, 163, 203, 0.3); }

.swal2-progress-steps .swal2-progress-step-line {
  background: #5ea3cb; }

.swal2-actions.swal2-loading .swal2-styled.swal2-confirm {
  border-left-color: #5ea3cb !important;
  border-right-color: #5ea3cb !important; }

.swal2-file, .swal2-input, .swal2-textarea {
  border: 1px solid var(--vz-input-border); }
  .swal2-file:focus, .swal2-input:focus, .swal2-textarea:focus {
    box-shadow: none;
    border-color: var(--vz-input-focus-border); }

.swal2-input {
  height: auto;
  display: block;
  padding: 0.5rem 0.9rem;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  color: var(--vz-body-color);
  background-color: var(--vz-input-bg);
  background-clip: padding-box;
  border: 1px solid var(--vz-input-border); }

.swal2-close {
  font-family: var(--vz-font-sans-serif);
  font-weight: 300;
  font-size: 28px; }
  .swal2-close:focus {
    box-shadow: none; }
  .swal2-close:hover {
    color: #5ea3cb; }

.swal2-validation-message {
  background-color: transparent; }

.dropzone {
  min-height: 230px;
  border: 2px dashed var(--vz-border-color);
  background: var(--vz-card-bg);
  border-radius: 6px; }
  .dropzone .dz-message {
    font-size: 24px;
    width: 100%;
    margin: 1em 0; }

.noUi-connect {
  background: #319795; }

.noUi-handle {
  background: #319795;
  border: 2px solid var(--vz-card-bg);
  box-shadow: none; }

.noUi-horizontal {
  height: 4px; }
  .noUi-horizontal .noUi-handle {
    height: 16px;
    width: 16px;
    border-radius: 50%;
    right: -10px !important;
    top: -7px; }
    .noUi-horizontal .noUi-handle::before, .noUi-horizontal .noUi-handle::after {
      display: none; }
    .noUi-horizontal .noUi-handle:focus {
      outline: 0; }

.noUi-pips-horizontal {
  height: 50px; }

.noUi-tooltip {
  padding: 0.4rem 0.7rem;
  border-color: var(--vz-border-color);
  border-radius: 0.2rem;
  background-color: var(--vz-card-bg);
  color: #212529; }

.noUi-vertical {
  width: 4px; }
  .noUi-vertical .noUi-handle {
    height: 16px;
    width: 16px;
    right: -8px;
    top: -12px;
    left: auto;
    border-radius: 50%; }
    .noUi-vertical .noUi-handle::before, .noUi-vertical .noUi-handle::after {
      display: none; }
    .noUi-vertical .noUi-handle:focus {
      outline: 0; }
  .noUi-vertical .noUi-origin {
    top: 0; }

.noUi-value {
  font-size: 12px; }

.noUi-marker-horizontal.noUi-marker-large {
  height: 12px; }

.noUi-value-horizontal {
  padding-top: 4px; }

.noUi-target {
  box-shadow: none;
  background-color: var(--vz-light);
  border-color: var(--vz-light); }

.noUi-touch-area:focus {
  outline: 0; }

#red, #green, #blue {
  margin: 10px;
  display: inline-block;
  height: 200px; }

#colorpicker {
  height: 240px;
  width: 310px;
  margin: 0 auto;
  padding: 10px;
  border: 1px solid var(--vz-border-color); }

#result {
  margin: 60px 26px;
  height: 100px;
  width: 100px;
  display: inline-block;
  vertical-align: top;
  border: 1px solid var(--vz-border-color);
  box-shadow: 0 0 3px;
  border-radius: 7px; }

#red .noUi-connect {
  background: #E53E3E; }

#green .noUi-connect {
  background: #319795; }

#blue .noUi-connect {
  background: #5ea3cb; }

.form-control.keyboard {
  max-width: 340px !important; }

.example-val {
  font-size: 12px;
  color: #878a99;
  display: block;
  margin: 15px 0; }
  .example-val:before {
    content: "Value: ";
    font-size: 12px;
    font-weight: 600; }

.noUi-tooltip {
  display: none; }

.noUi-active .noUi-tooltip {
  display: block; }

.c-1-color {
  background: #E53E3E; }

.c-2-color {
  background: #f7b84b; }

.c-3-color {
  background: #319795; }

.c-4-color {
  background: #5ea3cb; }

.c-5-color {
  background: #7084c7; }

#slider-toggle {
  height: 50px; }
  #slider-toggle.off .noUi-handle {
    border-color: #E53E3E; }

[data-slider-color="primary"] .noUi-connect {
  background: #5ea3cb; }

[data-slider-color="primary"] .noUi-handle {
  background: #5ea3cb; }

[data-slider-color="primary"][data-slider-style="border"] .noUi-handle, [data-slider-color="primary"][data-slider-style="square"] .noUi-handle {
  border-color: #5ea3cb; }

[data-slider-color="secondary"] .noUi-connect {
  background: #7084c7; }

[data-slider-color="secondary"] .noUi-handle {
  background: #7084c7; }

[data-slider-color="secondary"][data-slider-style="border"] .noUi-handle, [data-slider-color="secondary"][data-slider-style="square"] .noUi-handle {
  border-color: #7084c7; }

[data-slider-color="success"] .noUi-connect {
  background: #319795; }

[data-slider-color="success"] .noUi-handle {
  background: #319795; }

[data-slider-color="success"][data-slider-style="border"] .noUi-handle, [data-slider-color="success"][data-slider-style="square"] .noUi-handle {
  border-color: #319795; }

[data-slider-color="info"] .noUi-connect {
  background: #58caea; }

[data-slider-color="info"] .noUi-handle {
  background: #58caea; }

[data-slider-color="info"][data-slider-style="border"] .noUi-handle, [data-slider-color="info"][data-slider-style="square"] .noUi-handle {
  border-color: #58caea; }

[data-slider-color="warning"] .noUi-connect {
  background: #f7b84b; }

[data-slider-color="warning"] .noUi-handle {
  background: #f7b84b; }

[data-slider-color="warning"][data-slider-style="border"] .noUi-handle, [data-slider-color="warning"][data-slider-style="square"] .noUi-handle {
  border-color: #f7b84b; }

[data-slider-color="danger"] .noUi-connect {
  background: #E53E3E; }

[data-slider-color="danger"] .noUi-handle {
  background: #E53E3E; }

[data-slider-color="danger"][data-slider-style="border"] .noUi-handle, [data-slider-color="danger"][data-slider-style="square"] .noUi-handle {
  border-color: #E53E3E; }

[data-slider-color="light"] .noUi-connect {
  background: #f3f6f9; }

[data-slider-color="light"] .noUi-handle {
  background: #f3f6f9; }

[data-slider-color="light"][data-slider-style="border"] .noUi-handle, [data-slider-color="light"][data-slider-style="square"] .noUi-handle {
  border-color: #f3f6f9; }

[data-slider-color="dark"] .noUi-connect {
  background: #212529; }

[data-slider-color="dark"] .noUi-handle {
  background: #212529; }

[data-slider-color="dark"][data-slider-style="border"] .noUi-handle, [data-slider-color="dark"][data-slider-style="square"] .noUi-handle {
  border-color: #212529; }

[data-slider-size="lg"].noUi-horizontal {
  height: 12px; }
  [data-slider-size="lg"].noUi-horizontal .noUi-handle {
    width: 24px;
    height: 24px; }

[data-slider-size="md"].noUi-horizontal {
  height: 8px; }
  [data-slider-size="md"].noUi-horizontal .noUi-handle {
    width: 20px;
    height: 20px; }

[data-slider-size="sm"].noUi-horizontal {
  height: 4px; }
  [data-slider-size="sm"].noUi-horizontal .noUi-handle {
    width: 16px;
    height: 16px; }

[data-slider-style="line"].noUi-horizontal .noUi-handle {
  width: 8px;
  border-radius: 4px;
  right: -8px; }

[data-slider-style="line"].noUi-vertical .noUi-handle {
  height: 8px;
  border-radius: 4px;
  top: -3px; }

[data-slider-style="border"] .noUi-handle {
  border-color: #319795;
  background-color: var(--vz-card-bg); }

[data-slider-style="square"] .noUi-handle {
  border-radius: 0px;
  transform: rotate(45deg);
  height: 10px;
  width: 10px;
  top: -4px;
  border-color: #319795;
  background-color: var(--vz-card-bg); }

.nested-list .list-group-item {
  background-color: rgba(94, 163, 203, 0.05);
  border-color: rgba(94, 163, 203, 0.05); }

.nested-list, .nested-1, .nested-2, .nested-3 {
  margin-top: 5px; }

.nested-sortable-handle .handle {
  position: absolute;
  left: 0;
  top: 0;
  width: 42px;
  height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: grab; }

.nested-sortable-handle .list-group-item {
  padding-left: 42px; }

.shepherd-element {
  background: var(--vz-card-bg);
  box-shadow: 0 1px 2px rgba(56, 65, 74, 0.15); }

.shepherd-has-title .shepherd-content .shepherd-header {
  background-color: var(--vz-light);
  padding: 0.5rem 0.75rem; }

.shepherd-has-title .shepherd-content .shepherd-cancel-icon {
  color: rgba(var(--vz-dark-rgb), 0.75); }
  .shepherd-has-title .shepherd-content .shepherd-cancel-icon:hover {
    color: rgba(var(--vz-dark-rgb), 0.75); }

.shepherd-element.shepherd-has-title[data-popper-placement^=bottom] > .shepherd-arrow:before {
  background-color: var(--vz-light); }

.shepherd-title {
  font-size: 15px;
  font-weight: 500;
  color: var(--vz-body-color); }

.shepherd-text {
  padding: 0.75rem;
  font-size: 0.875rem;
  color: var(--vz-body-color); }

.shepherd-button.btn-success:not(:disabled):hover {
  background: #2e8d8c;
  color: #fff; }

.shepherd-button.btn-light:not(:disabled):hover {
  background: rgba(var(--vz-light-rgb), 0.75);
  color: var(--vz-dark); }

.shepherd-button.btn-primary:not(:disabled):hover {
  background: #549dc8;
  color: #fff; }

.shepherd-footer {
  padding: 0 0.75rem 0.75rem; }

.shepherd-arrow,
.shepherd-arrow:before {
  content: "\\ea75";
  font-family: 'remixicon';
  font-size: 24px;
  z-index: 1;
  background-color: transparent !important;
  transform: rotate(0deg);
  color: #5ea3cb; }

.shepherd-element[data-popper-placement^=bottom] > .shepherd-arrow {
  top: -18px; }

.shepherd-button {
  margin-right: 0.5rem; }

.swiper-button-next, .swiper-button-prev {
  height: 32px !important;
  width: 32px !important;
  background-color: rgba(94, 163, 203, 0.2);
  -webkit-backdrop-filter: blur(2px);
          backdrop-filter: blur(2px);
  border-radius: 8px; }
  .swiper-button-next::after, .swiper-button-prev::after {
    font-family: remixicon !important;
    font-size: 28px !important;
    color: #5ea3cb;
    transition: all 0.3s ease; }

.swiper-button-prev::after {
  content: "\\ea64" !important; }

.swiper-button-next::after {
  content: "\\ea6e" !important; }

.swiper-pagination-bullet {
  width: 22px !important;
  height: 5px !important;
  background-color: #fff !important;
  border-radius: 50px !important;
  box-shadow: none; }
  .swiper-pagination-bullet .swiper-pagination-bullet-active {
    opacity: 1; }

.dynamic-pagination .swiper-pagination-bullet {
  width: 8px;
  height: 8px;
  background-color: #fff;
  opacity: 0.5;
  transition: all 0.5s ease; }
  .dynamic-pagination .swiper-pagination-bullet.swiper-pagination-bullet-active {
    opacity: 1;
    width: 20px; }

.swiper-pagination-fraction {
  color: #fff;
  font-size: 16px;
  background-color: rgba(0, 0, 0, 0.3);
  -webkit-backdrop-filter: blur(2px);
          backdrop-filter: blur(2px); }

.pagination-custom .swiper-pagination-bullet {
  height: 25px !important;
  width: 25px !important;
  line-height: 25px !important;
  border-radius: 8px !important;
  background-color: #fff !important;
  opacity: 0.5 !important;
  transition: all 0.5s ease; }
  .pagination-custom .swiper-pagination-bullet.swiper-pagination-bullet-active {
    color: #7084c7 !important;
    opacity: 1 !important; }

.swiper-pagination-progressbar {
  height: 6px !important;
  background-color: rgba(49, 151, 149, 0.25) !important; }
  .swiper-pagination-progressbar .swiper-pagination-progressbar-fill {
    background-color: #319795 !important; }

.swiper-scrollbar {
  background-color: rgba(255, 255, 255, 0.35);
  -webkit-backdrop-filter: blur(2px);
          backdrop-filter: blur(2px);
  padding: 1.2px;
  height: 6px !important; }
  .swiper-scrollbar .swiper-scrollbar-drag {
    background-color: #fff; }

.swiper-pagination-dark .swiper-pagination-bullet {
  background-color: #7084c7 !important; }

.swiper-pagination-dark .dynamic-pagination .swiper-pagination-bullet {
  background-color: #7084c7 !important; }

.swiper-pagination-dark.pagination-custom .swiper-pagination-bullet {
  color: #fff; }
  .swiper-pagination-dark.pagination-custom .swiper-pagination-bullet.swiper-pagination-bullet-active {
    opacity: 1; }

.swiper-pagination-dark.swiper-scrollbar {
  background-color: rgba(33, 37, 41, 0.35); }

.multi-wrapper {
  border: none;
  position: relative; }
  .multi-wrapper::before {
    content: "\\ea61";
    position: absolute;
    font-family: "remixicon";
    left: 50%;
    transform: translateX(-50%);
    bottom: 86px;
    width: 32px;
    height: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 16px;
    border-radius: 50%;
    color: #878a99;
    background-color: var(--vz-light);
    z-index: 1; }
  .multi-wrapper .non-selected-wrapper {
    border: 1px solid var(--vz-input-border);
    background-color: var(--vz-input-bg);
    border-top-left-radius: 0.25rem;
    border-bottom-left-radius: 0.25rem; }
  .multi-wrapper .selected-wrapper::-webkit-scrollbar, .multi-wrapper .non-selected-wrapper::-webkit-scrollbar {
    -webkit-appearance: none; }
  .multi-wrapper .selected-wrapper::-webkit-scrollbar:vertical, .multi-wrapper .non-selected-wrapper::-webkit-scrollbar:vertical {
    width: 10px; }
  .multi-wrapper .selected-wrapper::-webkit-scrollbar:horizontal, .multi-wrapper .non-selected-wrapper::-webkit-scrollbar:horizontal {
    height: 9px; }
  .multi-wrapper .selected-wrapper::-webkit-scrollbar-thumb, .multi-wrapper .non-selected-wrapper::-webkit-scrollbar-thumb {
    background-color: rgba(var(--vz-dark-rgb), 0.2);
    border-radius: 10px;
    border: 2px solid var(--vz-input-bg); }
  .multi-wrapper .selected-wrapper::-webkit-scrollbar-track, .multi-wrapper .non-selected-wrapper::-webkit-scrollbar-track {
    border-radius: 10px;
    background-color: var(--vz-input-bg); }
  .multi-wrapper .item-group .group-label {
    font-size: 12px; }
  .multi-wrapper .item {
    color: var(--vz-body-color); }
    .multi-wrapper .item:hover {
      background-color: rgba(94, 163, 203, 0.1); }
  .multi-wrapper .selected-wrapper {
    border: 1px solid var(--vz-input-border);
    background: var(--vz-input-bg);
    border-top-right-radius: 0.25rem;
    border-bottom-right-radius: 0.25rem; }
  .multi-wrapper .search-input {
    flex: 0 0 auto;
    padding: 0.5rem 0.9rem;
    font-size: 0.875rem;
    color: var(--vz-body-color);
    background-color: var(--vz-input-bg);
    border: 1px solid var(--vz-input-border);
    border-radius: 0.25rem;
    margin-bottom: 16px; }
    .multi-wrapper .search-input::placeholder {
      color: #878a99; }
  .multi-wrapper .header {
    font-weight: 600;
    color: var(--vz-gray-600); }

.pcr-app {
  background: var(--vz-card-bg);
  box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);
  border-radius: 4px;
  border: 1px solid var(--vz-border-color); }

.pickr .pcr-button {
  border: 4px solid var(--vz-card-bg);
  box-shadow: 0px 0px 0 2px var(--vz-border-color);
  border-radius: 50%;
  box-shadow: none; }
  .pickr .pcr-button::after, .pickr .pcr-button::before {
    border-radius: 50%; }

.pcr-app[data-theme=classic] .pcr-selection .pcr-color-preview {
  margin-right: .75em;
  margin-left: 0; }

.pcr-app[data-theme=classic] .pcr-selection .pcr-color-chooser, .pcr-app[data-theme=classic] .pcr-selection .pcr-color-opacity {
  margin-left: .75em;
  margin-right: 0; }

.pcr-app[data-theme="monolith"] .pcr-result {
  min-width: 100%; }

.pcr-app .pcr-interaction .pcr-type.active {
  background: #5ea3cb; }

.pcr-app .pcr-interaction .pcr-result {
  background-color: var(--vz-input-bg);
  color: var(--vz-body-color);
  border: 1px solid var(--vz-input-border);
  border-radius: 0.25rem; }

.pcr-app .pcr-interaction input {
  border-radius: 0.25rem !important; }
  .pcr-app .pcr-interaction input:focus {
    box-shadow: none;
    background-color: var(--vz-input-bg);
    border-color: var(--vz-input-focus-border); }

.pcr-app .pcr-interaction .pcr-save {
  background: #319795 !important; }

.pcr-app .pcr-interaction .pcr-clear, .pcr-app .pcr-interaction .pcr-cancel {
  background: #E53E3E !important; }

.filepond--root {
  margin-bottom: 0; }
  .filepond--root[data-style-panel-layout~=circle] .filepond--drop-label label {
    font-size: 14px; }

.filepond--panel-root {
  border: 2px dashed var(--vz-border-color);
  background: var(--vz-card-bg); }

.filepond--drop-label {
  color: var(--vz-body-color); }
  .filepond--drop-label label {
    font-weight: 500; }

.filepond--credits {
  display: none; }

.filepond--item-panel {
  background-color: #5ea3cb !important; }

[type="number"]::-webkit-inner-spin-button,
[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  height: auto; }

.input-step {
  border: 1px solid var(--vz-input-border);
  display: inline-flex;
  overflow: visible;
  height: 37.5px;
  border-radius: 0.25rem;
  background: var(--vz-input-bg);
  padding: 4px; }
  .input-step input {
    width: 4em;
    height: 100%;
    text-align: center;
    border: 0;
    background: transparent;
    color: var(--vz-body-color);
    border-radius: 0.25rem; }
    .input-step input:focus-visible {
      outline: 0; }
  .input-step button {
    width: 1.4em;
    font-weight: 300;
    height: 100%;
    line-height: 0.1em;
    font-size: 1.4em;
    padding: 0.2em !important;
    background: var(--vz-light);
    color: var(--vz-body-color);
    border: none;
    border-radius: 0.25rem; }
  .input-step.light {
    background: var(--vz-light); }
    .input-step.light button {
      background-color: var(--vz-input-bg); }
  .input-step.light-input {
    background: var(--vz-light); }
    .input-step.light-input input {
      background-color: var(--vz-input-bg); }
  .input-step.full-width {
    display: flex;
    width: 100%; }
    .input-step.full-width button {
      flex-shrink: 0; }
    .input-step.full-width input {
      flex-grow: 1; }

.input-step.step-primary button {
  background-color: #5ea3cb;
  color: #fff; }

.input-step.step-secondary button {
  background-color: #7084c7;
  color: #fff; }

.input-step.step-success button {
  background-color: #319795;
  color: #fff; }

.input-step.step-info button {
  background-color: #58caea;
  color: #fff; }

.input-step.step-warning button {
  background-color: #f7b84b;
  color: #fff; }

.input-step.step-danger button {
  background-color: #E53E3E;
  color: #fff; }

.input-step.step-light button {
  background-color: #f3f6f9;
  color: #fff; }

.input-step.step-dark button {
  background-color: #212529;
  color: #fff; }

.ck {
  font-family: var(--vz-font-sans-serif) !important; }
  .ck.ck-reset_all, .ck.ck-reset_all * {
    color: var(--vz-body-color) !important; }
  .ck.ck-toolbar {
    background: rgba(var(--vz-light-rgb), 0.75) !important; }
  .ck p {
    margin-bottom: 0; }
  .ck.ck-toolbar {
    border: 1px solid var(--vz-input-border) !important; }
    .ck.ck-toolbar.ck-toolbar_grouping > .ck-toolbar__items {
      flex-wrap: wrap !important; }
    .ck.ck-toolbar .ck.ck-toolbar__separator {
      background: transparent !important; }
  .ck.ck-editor__main > .ck-editor__editable {
    border-top: 0 !important;
    background-color: var(--vz-card-bg) !important;
    border-color: var(--vz-input-border) !important;
    box-shadow: none !important; }
  .ck.ck-dropdown__panel {
    background: var(--vz-dropdown-bg) !important;
    box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);
    animation-name: DropDownSlide;
    animation-duration: .3s;
    animation-fill-mode: both;
    border-radius: 0.3rem; }
  .ck.ck-list {
    background: var(--vz-dropdown-bg) !important; }
  .ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_ne, .ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_se {
    left: 0;
    right: auto !important; }
  .ck.ck-editor__editable_inline[dir=ltr] {
    text-align: left !important; }
  .ck.ck-dropdown__panel {
    box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12) !important;
    border-radius: 0.3rem !important;
    border: 1px solid var(--vz-border-color) !important; }

.ck.ck-button:focus, .ck.ck-button:active,
a.ck.ck-button:focus,
a.ck.ck-button:active {
  box-shadow: none !important;
  border: 1px solid var(--vz-light) !important; }

.ck.ck-button:not(.ck-disabled):hover,
a.ck.ck-button:not(.ck-disabled):hover {
  background: var(--vz-light) !important; }

.ck.ck-button.ck-on,
a.ck.ck-button.ck-on {
  background: var(--vz-light) !important; }

.ck-rounded-corners .ck.ck-editor__top .ck-sticky-panel .ck-toolbar,
.ck.ck-editor__top .ck-sticky-panel .ck-toolbar.ck-rounded-corners {
  border-radius: 0.25rem !important;
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important; }

.ck-rounded-corners .ck.ck-editor__main > .ck-editor__editable,
.ck.ck-editor__main > .ck-editor__editable.ck-rounded-corners {
  border-radius: 0.25rem !important;
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important; }

.ck-editor__editable {
  min-height: 245px !important; }

.ck[class*=ck-heading_heading] {
  font-weight: 500 !important; }

.ck.ck-button.ck-on:not(.ck-disabled):hover, .ck.ck-button.ck-on:not(.ck-disabled):active,
a.ck.ck-button.ck-on:not(.ck-disabled):hover,
a.ck.ck-button.ck-on:not(.ck-disabled):active {
  box-shadow: none !important; }

.ck.ck-tooltip .ck-tooltip__text {
  background: #212529 !important;
  color: #f3f6f9 !important; }

.ck.ck-input-text {
  background: var(--vz-input-bg) !important;
  border: 1px solid var(--vz-input-border) !important; }
  .ck.ck-input-text:focus {
    border: 1px solid var(--vz-input-focus-border) !important;
    box-shadow: none !important; }

.ck.ck-balloon-panel {
  background: var(--vz-dropdown-bg) !important;
  border: 1px solid var(--vz-border-color) !important; }
  .ck.ck-balloon-panel[class*=arrow_n]:after {
    border-bottom-color: var(--vz-dropdown-bg) !important; }
  .ck.ck-balloon-panel[class*=arrow_n]::before {
    border-bottom-color: var(--vz-border-color) !important; }

.ck.ck-labeled-field-view > .ck.ck-labeled-field-view__input-wrapper > .ck.ck-label {
  background: var(--vz-dropdown-bg) !important; }

.ck-editor-reverse .ck-editor {
  display: flex;
  flex-direction: column-reverse; }

.ck-editor-reverse .ck.ck-editor__main > .ck-editor__editable {
  border: 1px solid var(--vz-input-border) !important;
  border-bottom: 0 !important; }

.ck-editor-reverse .ck-rounded-corners .ck.ck-editor__main > .ck-editor__editable,
.ck-editor-reverse .ck.ck-editor__main > .ck-editor__editable.ck-rounded-corners {
  border-radius: 0.25rem !important;
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important; }

.ck-editor-reverse .ck-rounded-corners .ck.ck-editor__top .ck-sticky-panel .ck-toolbar,
.ck-editor-reverse .ck.ck-editor__top .ck-sticky-panel .ck-toolbar.ck-rounded-corners {
  border-radius: 0.25rem !important;
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important; }

[dir="rtl"] .ck.ck-toolbar > .ck-toolbar__items {
  flex-direction: row-reverse; }

.ql-editor {
  text-align: left; }
  .ql-editor ol,
  .ql-editor ul {
    padding-left: 1.5em;
    padding-right: 0; }
  .ql-editor li:not(.ql-direction-rtl)::before {
    margin-left: -1.5em;
    margin-right: 0.3em;
    text-align: right; }

.ql-container {
  font-family: var(--vz-font-sans-serif); }
  .ql-container.ql-snow {
    border-color: var(--vz-input-border);
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px; }

.ql-bubble {
  border: 1px solid var(--vz-input-border);
  border-radius: 0.25rem; }

.ql-toolbar {
  font-family: var(--vz-font-sans-serif) !important; }
  .ql-toolbar span {
    outline: none !important;
    color: var(--vz-dropdown-link-color); }
    .ql-toolbar span:hover {
      color: #5ea3cb !important; }
  .ql-toolbar.ql-snow {
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    border-color: var(--vz-input-border); }
    .ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-label {
      border-color: transparent; }
    .ql-toolbar.ql-snow .ql-picker-options {
      box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);
      border-radius: 0.3rem; }

.ql-snow .ql-stroke,
.ql-snow .ql-script,
.ql-snow .ql-strike svg {
  stroke: var(--vz-dropdown-link-color); }

.ql-snow .ql-fill {
  fill: var(--vz-dropdown-link-color); }

.ql-snow .ql-picker:not(.ql-color-picker):not(.ql-icon-picker) svg {
  right: 0;
  left: auto; }

.ql-snow .ql-picker.ql-expanded .ql-picker-label {
  color: var(--vz-dropdown-link-color); }

.ql-snow .ql-picker-options {
  background-color: var(--vz-dropdown-bg);
  border-color: var(--vz-border-color) !important; }

.gridjs-container {
  color: var(--vz-body-color);
  padding: 0;
  display: block; }

.gridjs-wrapper {
  box-shadow: none;
  border: 1px solid var(--vz-border-color);
  border-radius: 0px; }
  .gridjs-wrapper::-webkit-scrollbar {
    -webkit-appearance: none; }
  .gridjs-wrapper::-webkit-scrollbar:vertical {
    width: 12px; }
  .gridjs-wrapper::-webkit-scrollbar:horizontal {
    height: 12px; }
  .gridjs-wrapper::-webkit-scrollbar-thumb {
    background-color: rgba(var(--vz-dark-rgb), 0.075);
    border-radius: 10px;
    border: 2px solid var(--vz-card-bg); }
  .gridjs-wrapper::-webkit-scrollbar-track {
    border-radius: 10px;
    background-color: var(--vz-card-bg); }

.gridjs-footer {
  border: none !important;
  padding: 12px 0 0; }

.gridjs-table {
  width: 100%; }

.gridjs-tbody, td.gridjs-td {
  background-color: transparent; }

th.gridjs-th,
td.gridjs-td {
  border: 1px solid var(--vz-border-color);
  padding: 0.75rem 0.6rem; }

th.gridjs-th {
  border-top: 0;
  color: var(--vz-body-color);
  background-color: rgba(var(--vz-light-rgb), 0.75); }

th.gridjs-th-sort:focus, th.gridjs-th-sort:hover {
  background-color: rgba(var(--vz-light-rgb), 0.85); }

.gridjs-head {
  padding-top: 0; }

.gridjs-footer {
  box-shadow: none;
  border: 1px solid var(--vz-border-color);
  border-top: 0;
  background-color: transparent; }

.gridjs-summary {
  color: #878a99;
  margin-top: 8px !important; }

.gridjs-pagination .gridjs-pages button {
  margin-left: 0.3rem;
  border-radius: 0.25rem !important;
  border: 1px solid var(--vz-border-color);
  background-color: var(--vz-card-bg);
  color: var(--vz-link-color); }
  .gridjs-pagination .gridjs-pages button:last-child {
    border-right: 1px solid var(--vz-border-color); }
  .gridjs-pagination .gridjs-pages button:disabled, .gridjs-pagination .gridjs-pages button:hover:disabled, .gridjs-pagination .gridjs-pages button[disabled] {
    color: #878a99;
    background-color: var(--vz-card-bg); }
  .gridjs-pagination .gridjs-pages button:hover {
    background-color: var(--vz-pagination-hover-bg);
    color: var(--vz-link-hover-color); }
  .gridjs-pagination .gridjs-pages button:focus {
    box-shadow: none; }
  .gridjs-pagination .gridjs-pages button:last-child:hover, .gridjs-pagination .gridjs-pages button:first-child:hover {
    background-color: transparent; }
  .gridjs-pagination .gridjs-pages button.gridjs-currentPage {
    background-color: #5ea3cb;
    color: #fff;
    border-color: #5ea3cb;
    font-weight: 500; }

.gridjs-search {
  position: relative;
  float: left; }
  .gridjs-search::before {
    content: "\\f0d1";
    font-family: "remixicon";
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 10px;
    font-size: 14px;
    color: #878a99; }

input.gridjs-input {
  border-color: var(--vz-input-border);
  background-color: var(--vz-input-bg);
  color: var(--vz-body-color);
  line-height: 1.5;
  padding: 0.5rem 0.9rem 0.5rem 2.025rem;
  border-radius: 0.25rem;
  font-size: 0.875rem; }
  input.gridjs-input:focus {
    box-shadow: none;
    border-color: var(--vz-input-focus-border);
    background-color: var(--vz-input-bg); }
  input.gridjs-input::placeholder {
    color: #878a99; }

th.gridjs-th .gridjs-th-content {
  float: none;
  display: inline-block;
  vertical-align: middle;
  font-weight: 600; }

button.gridjs-sort {
  float: none;
  display: inline-block;
  vertical-align: middle;
  width: 10px;
  height: 20px; }

th.gridjs-th-sort .gridjs-th-content {
  width: calc(100% - 10px); }

button.gridjs-sort-asc, button.gridjs-sort-desc {
  background-size: 7px; }

.table-card .gridjs-head {
  padding: 16px 16px 5px; }

.table-card .gridjs-wrapper {
  border-top: 0;
  border-radius: 0;
  border-width: 1px 0; }

.table-card .gridjs-footer {
  padding: 8px 16px !important; }

.gridjs-tr-selected td {
  background-color: rgba(var(--vz-light-rgb), 1); }

.gridjs-tr-selected .gridjs-td .gridjs-checkbox[type=checkbox] {
  background-color: #5ea3cb;
  border-color: #5ea3cb;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_35___}); }

.gridjs-td .gridjs-checkbox {
  width: 1.1em;
  height: 1.1em;
  vertical-align: top;
  background-color: var(--vz-input-bg);
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  border: 1px solid var(--vz-input-check-border);
  appearance: none;
  -webkit-print-color-adjust: exact;
          color-adjust: exact; }
  .gridjs-td .gridjs-checkbox[type="checkbox"] {
    border-radius: 0.25em; }

.gridjs-border-none td.gridjs-td, .gridjs-border-none th.gridjs-th {
  border-right-width: 0;
  border-left-width: 0; }

.gridjs-loading-bar {
  background-color: var(--vz-card-bg); }

[data-layout-mode="dark"] button.gridjs-sort-neutral, [data-layout-mode="dark"] button.gridjs-sort-asc, [data-layout-mode="dark"] button.gridjs-sort-desc {
  filter: invert(1) grayscale(100%) brightness(200%); }

.listjs-pagination {
  margin-bottom: 0;
  justify-content: flex-end;
  gap: 8px; }
  .listjs-pagination li .page {
    display: block;
    padding: 0.375rem 0.75rem;
    color: var(--vz-link-color);
    background-color: var(--vz-card-bg);
    border: 1px solid var(--vz-border-color);
    border-radius: 0.25rem; }
  .listjs-pagination li.active .page {
    color: #fff;
    background-color: #5ea3cb;
    border-color: #5ea3cb; }

.pagination-wrap {
  -webkit-user-select: none;
          user-select: none;
  display: flex;
  align-items: center; }
  .pagination-wrap a {
    text-decoration: none;
    display: inline-block; }

.pagination-next,
.pagination-prev {
  color: #5ea3cb;
  font-weight: 500;
  padding: 0.375rem 0.75rem;
  background-color: var(--vz-card-bg);
  border: 1px solid var(--vz-border-color);
  border-radius: 0.25rem; }
  .pagination-next:hover,
  .pagination-prev:hover {
    color: #abcfe4; }
  .pagination-next.disabled,
  .pagination-prev.disabled {
    color: #878a99;
    cursor: default; }
    .pagination-next.disabled:hover,
    .pagination-prev.disabled:hover {
      color: #878a99; }

.apex-charts {
  min-height: 10px !important; }
  .apex-charts text {
    font-family: var(--vz-font-sans-serif) !important; }
  .apex-charts .apexcharts-canvas {
    margin: 0 auto; }

.apexcharts-tooltip-title,
.apexcharts-tooltip-text {
  font-family: var(--vz-font-sans-serif) !important; }

.apexcharts-tooltip {
  border: 1px solid var(--vz-border-color) !important;
  background-color: var(--vz-card-bg) !important;
  box-shadow: 0 1px 2px rgba(56, 65, 74, 0.15) !important; }
  .apexcharts-tooltip * {
    font-family: var(--vz-font-sans-serif) !important;
    color: #878a99 !important; }
  .apexcharts-tooltip .apexcharts-tooltip-title {
    background-color: rgba(var(--vz-light-rgb), 0.75) !important;
    border-bottom: 1px solid var(--vz-border-color) !important; }

.apexcharts-tooltip.apexcharts-theme-dark * {
  color: #fff !important; }

.apexcharts-legend-series {
  font-weight: 500; }

.apexcharts-gridline {
  pointer-events: none;
  stroke: rgba(var(--vz-light-rgb), 0.75); }

.apexcharts-legend-text {
  color: #878a99 !important;
  font-family: var(--vz-font-sans-serif) !important;
  font-size: 13px !important; }

.apexcharts-pie-label {
  fill: #fff !important; }

.apexcharts-title-text, .apexcharts-subtitle-text {
  fill: #adb5bd; }

.apexcharts-yaxis text,
.apexcharts-xaxis text {
  font-family: var(--vz-font-sans-serif) !important;
  fill: #adb5bd; }

.apexcharts-yaxis-title {
  font-weight: 500; }

#dynamicloadedchart-wrap {
  margin: 0px auto;
  max-width: 800px;
  position: relative; }

.chart-box {
  padding-left: 0; }

#chart-year,
#chart-quarter {
  width: 96%;
  max-width: 48%;
  box-shadow: none;
  padding-left: 0;
  padding-top: 20px;
  background: var(--vz-card-bg);
  border: 1px solid var(--vz-border-color); }

#chart-year {
  float: left;
  position: relative;
  transition: 1s ease transform;
  z-index: 3; }
  #chart-year.chart-quarter-activated {
    transform: translateX(0);
    transition: 1s ease transform; }

#chart-quarter {
  float: left;
  position: relative;
  z-index: -2;
  transition: 1s ease transform; }
  #chart-quarter.active {
    transition: 1.1s ease-in-out transform;
    transform: translateX(0);
    z-index: 1; }

@media screen and (min-width: 480px) {
  #chart-year {
    transform: translateX(50%); }
  #chart-quarter {
    transform: translateX(-50%); } }

.apexcharts-radar-series polygon, .apexcharts-radar-series line {
  stroke: var(--vz-border-color); }

.apexcharts-pie circle, .apexcharts-pie line {
  stroke: var(--vz-border-color); }

.apexcharts-pie text {
  fill: var(--vz-body-color); }

.chartjs-chart {
  max-height: 320px; }

.e-charts {
  height: 350px; }

.e-charts-height {
  height: 300px; }

.gmaps, .gmaps-panaroma {
  height: 300px;
  background: #f3f6f9;
  border-radius: 3px; }

.gmaps-overlay {
  display: block;
  text-align: center;
  color: #fff;
  font-size: 16px;
  line-height: 40px;
  background: #5ea3cb;
  border-radius: 4px;
  padding: 10px 20px; }

.gmaps-overlay_arrow {
  left: 50%;
  margin-left: -16px;
  width: 0;
  height: 0;
  position: absolute; }
  .gmaps-overlay_arrow.above {
    bottom: -15px;
    border-left: 16px solid transparent;
    border-right: 16px solid transparent;
    border-top: 16px solid #5ea3cb; }
  .gmaps-overlay_arrow.below {
    top: -15px;
    border-left: 16px solid transparent;
    border-right: 16px solid transparent;
    border-bottom: 16px solid #5ea3cb; }

.autoComplete_wrapper {
  display: block; }
  .autoComplete_wrapper > input {
    display: block;
    width: 100%;
    height: auto;
    padding: 0.5rem 0.9rem;
    font-size: 0.875rem;
    font-weight: 400;
    line-height: 1.5;
    color: var(--vz-body-color);
    background-color: var(--vz-input-bg);
    background-clip: padding-box;
    border: 1px solid var(--vz-input-border);
    border-radius: 0.25rem;
    background-image: none; }
    .autoComplete_wrapper > input::placeholder {
      padding: 0 !important;
      color: #878a99 !important;
      font-size: 0.875rem !important; }
    .autoComplete_wrapper > input:focus {
      border: 1px solid var(--vz-input-focus-border);
      color: var(--vz-body-color); }
    .autoComplete_wrapper > input:hover {
      color: var(--vz-body-color); }
  .autoComplete_wrapper > ul {
    border-radius: 0.25rem;
    border-color: var(--vz-border-color);
    background-color: var(--vz-dropdown-bg);
    box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);
    padding: 0;
    overflow: auto;
    max-height: 160px;
    margin: 0;
    animation-name: DropDownSlide;
    animation-duration: .3s;
    animation-fill-mode: both; }
    .autoComplete_wrapper > ul > li {
      font-size: 0.875rem;
      margin: 0;
      padding: 0.35rem 1.2rem;
      border-radius: 0;
      background-color: var(--vz-dropdown-bg);
      color: var(--vz-body-color); }
      .autoComplete_wrapper > ul > li mark, .autoComplete_wrapper > ul > li .mark {
        color: #E53E3E;
        font-weight: 600;
        padding: 1px; }
      .autoComplete_wrapper > ul > li[aria-selected=true], .autoComplete_wrapper > ul > li:hover {
        color: var(--vz-dropdown-link-hover-color);
        background-color: var(--vz-dropdown-link-hover-bg); }
    .autoComplete_wrapper > ul .no_result {
      padding: 0.7rem 1.2rem;
      font-style: italic;
      font-weight: 500; }

.jvm-tooltip {
  border-radius: 3px;
  background-color: #5ea3cb;
  font-family: var(--vz-font-sans-serif);
  box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);
  padding: 5px 9px; }

.jvm-container text {
  font-family: var(--vz-font-sans-serif);
  font-size: 0.875rem;
  fill: var(--vz-gray-700); }

.jvm-zoom-btn {
  background-color: #5ea3cb; }

.leaflet-map {
  height: 300px; }
  .leaflet-map.leaflet-container {
    z-index: 0;
    font-family: "Poppins", sans-serif; }

.fc td,
.fc th {
  border: 1px solid var(--vz-border-color); }

.fc .fc-toolbar h2, .fc .fc-toolbar .h2 {
  font-size: 16px;
  line-height: 30px;
  text-transform: uppercase; }

@media (max-width: 767.98px) {
  .fc .fc-toolbar .fc-left,
  .fc .fc-toolbar .fc-right,
  .fc .fc-toolbar .fc-center {
    float: none;
    display: block;
    text-align: center;
    clear: both;
    margin: 10px 0; }
  .fc .fc-toolbar > * > * {
    float: none; }
  .fc .fc-toolbar .fc-today-button {
    display: none; } }

.fc .fc-toolbar .btn {
  text-transform: capitalize; }

.fc .fc-col-header-cell {
  background-color: var(--vz-light); }

.fc .fc-col-header-cell-cushion {
  display: block;
  padding: 8px 4px; }

.fc .fc-daygrid-day-number {
  width: 24px;
  height: 24px;
  border-radius: 50%;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 500;
  margin: 2px; }

.fc .fc-daygrid-day.fc-day-today {
  background-color: rgba(94, 163, 203, 0.1); }
  .fc .fc-daygrid-day.fc-day-today .fc-daygrid-day-number {
    background-color: #5ea3cb;
    color: #fff; }

.fc .fc-daygrid-day.fc-day-today {
  background-color: rgba(94, 163, 203, 0.1); }

.fc .fc-timegrid-col.fc-day-today {
  background-color: rgba(94, 163, 203, 0.1); }

.fc .fc-list-event:hover td {
  background: transparent; }

.fc .fc-list-event-title a {
  color: #fff !important; }

.fc .fc-col-header,
.fc .fc-daygrid-body,
.fc .fc-scrollgrid-sync-table {
  width: 100% !important; }

.fc .fc-scrollgrid-section > * {
  border-left: 1px solid var(--vz-border-color);
  border-top: 1px solid var(--vz-border-color); }

.fc .fc-scrollgrid-section-liquid > td {
  border-top: 0; }

.fc-theme-bootstrap a:not([href]) {
  color: var(--vz-body-color); }

.fc-event {
  color: #fff; }

.fc th.fc-widget-header {
  background: #e9ebec;
  line-height: 20px;
  padding: 10px 0;
  text-transform: uppercase;
  font-weight: 700; }

.fc-unthemed .fc-content,
.fc-unthemed .fc-divider,
.fc-unthemed .fc-list-heading td,
.fc-unthemed .fc-list-view,
.fc-unthemed .fc-popover,
.fc-unthemed .fc-row,
.fc-unthemed tbody,
.fc-unthemed td,
.fc-unthemed th,
.fc-unthemed thead {
  border-color: #e9ebec; }

.fc-unthemed td.fc-today {
  background: #f6f8fa; }

.fc-button {
  background: var(--vz-card-bg);
  border-color: var(--vz-border-color);
  color: #495057;
  text-transform: capitalize;
  box-shadow: none;
  padding: 6px 12px !important;
  height: auto !important; }

.fc-state-down,
.fc-state-active,
.fc-state-disabled {
  background-color: #5ea3cb;
  color: #fff;
  text-shadow: none; }

.fc-event {
  border-radius: 2px;
  border: none;
  cursor: move;
  font-size: 0.8125rem;
  margin: 5px 7px;
  padding: 5px 5px;
  text-align: center; }

.fc-event,
.fc-event-dot {
  background-color: #5ea3cb; }

.fc-daygrid-dot-event.fc-event-mirror,
.fc-daygrid-dot-event:hover {
  background-color: #5ea3cb; }

.fc-event-title,
.fc-sticky {
  font-weight: 600 !important;
  text-overflow: ellipsis;
  white-space: nowrap; }

.fc-daygrid-event-dot {
  border-color: #fff !important;
  display: none; }

.fc-event-time {
  display: none; }

.fc-event .fc-content {
  color: #fff; }

#external-events .external-event {
  text-align: left;
  padding: 8px 16px;
  margin: 6px 0; }

.fc-day-grid-event.fc-h-event.fc-event.fc-start.fc-end.bg-dark .fc-content {
  color: #f3f6f9; }

.fc-prev-button,
.fc-next-button {
  position: relative;
  height: 37.5px;
  width: 37.5px; }
  .fc-prev-button::before,
  .fc-next-button::before {
    position: absolute;
    font-family: remixicon !important;
    font-size: 20px;
    top: 0;
    bottom: 0px;
    left: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center; }

.fc-prev-button::before {
  content: "\\ea64"; }

.fc-next-button::before {
  content: "\\ea6e"; }

.fc-toolbar-chunk .btn-group {
  box-shadow: none; }
  .fc-toolbar-chunk .btn-group .btn {
    color: #7084c7;
    background-color: rgba(112, 132, 199, 0.15);
    border: none;
    box-shadow: none; }
    .fc-toolbar-chunk .btn-group .btn:hover, .fc-toolbar-chunk .btn-group .btn.active {
      color: #fff;
      background-color: #7084c7; }

.fc-toolbar-chunk .fc-today-button {
  background-color: #7084c7 !important;
  border: #7084c7; }

@media (max-width: 575.98px) {
  .fc-toolbar {
    flex-direction: column;
    gap: 16px; } }

#upcoming-event-list .card:last-child {
  margin-bottom: 6px !important; }

#event-modal .event-details {
  display: none; }

#event-modal .view-event .event-form {
  display: none; }

#event-modal .view-event #event-category-tag {
  display: none; }

#event-modal .view-event .event-details {
  display: block; }

.fc-daygrid-event-harness .fc-daygrid-event {
  -webkit-backdrop-filter: blur(4px);
          backdrop-filter: blur(4px); }

.fc-timegrid-event-harness .fc-timegrid-event {
  -webkit-backdrop-filter: blur(4px);
          backdrop-filter: blur(4px); }

.fc-timegrid-slots table tr {
  border-color: var(--vz-border-color) !important; }

.fc-list-table {
  border-color: var(--vz-border-color); }

.fc-daygrid-event-harness .fc-daygrid-event.bg-soft-primary .fc-event-title,
.fc-daygrid-event-harness .fc-daygrid-event.bg-soft-primary .fc-event-main {
  color: #5ea3cb !important; }

.fc-timegrid-event-harness .fc-timegrid-event.bg-soft-primary .fc-event-title {
  color: #5ea3cb !important; }

.fc-list-table .fc-list-event.bg-soft-primary {
  color: #5ea3cb !important; }
  .fc-list-table .fc-list-event.bg-soft-primary .fc-list-event-title > a {
    color: #5ea3cb !important; }
  .fc-list-table .fc-list-event.bg-soft-primary .fc-list-event-dot {
    border-color: #5ea3cb; }

.fc-daygrid-event-harness .fc-daygrid-event.bg-soft-secondary .fc-event-title,
.fc-daygrid-event-harness .fc-daygrid-event.bg-soft-secondary .fc-event-main {
  color: #7084c7 !important; }

.fc-timegrid-event-harness .fc-timegrid-event.bg-soft-secondary .fc-event-title {
  color: #7084c7 !important; }

.fc-list-table .fc-list-event.bg-soft-secondary {
  color: #7084c7 !important; }
  .fc-list-table .fc-list-event.bg-soft-secondary .fc-list-event-title > a {
    color: #7084c7 !important; }
  .fc-list-table .fc-list-event.bg-soft-secondary .fc-list-event-dot {
    border-color: #7084c7; }

.fc-daygrid-event-harness .fc-daygrid-event.bg-soft-success .fc-event-title,
.fc-daygrid-event-harness .fc-daygrid-event.bg-soft-success .fc-event-main {
  color: #319795 !important; }

.fc-timegrid-event-harness .fc-timegrid-event.bg-soft-success .fc-event-title {
  color: #319795 !important; }

.fc-list-table .fc-list-event.bg-soft-success {
  color: #319795 !important; }
  .fc-list-table .fc-list-event.bg-soft-success .fc-list-event-title > a {
    color: #319795 !important; }
  .fc-list-table .fc-list-event.bg-soft-success .fc-list-event-dot {
    border-color: #319795; }

.fc-daygrid-event-harness .fc-daygrid-event.bg-soft-info .fc-event-title,
.fc-daygrid-event-harness .fc-daygrid-event.bg-soft-info .fc-event-main {
  color: #58caea !important; }

.fc-timegrid-event-harness .fc-timegrid-event.bg-soft-info .fc-event-title {
  color: #58caea !important; }

.fc-list-table .fc-list-event.bg-soft-info {
  color: #58caea !important; }
  .fc-list-table .fc-list-event.bg-soft-info .fc-list-event-title > a {
    color: #58caea !important; }
  .fc-list-table .fc-list-event.bg-soft-info .fc-list-event-dot {
    border-color: #58caea; }

.fc-daygrid-event-harness .fc-daygrid-event.bg-soft-warning .fc-event-title,
.fc-daygrid-event-harness .fc-daygrid-event.bg-soft-warning .fc-event-main {
  color: #f7b84b !important; }

.fc-timegrid-event-harness .fc-timegrid-event.bg-soft-warning .fc-event-title {
  color: #f7b84b !important; }

.fc-list-table .fc-list-event.bg-soft-warning {
  color: #f7b84b !important; }
  .fc-list-table .fc-list-event.bg-soft-warning .fc-list-event-title > a {
    color: #f7b84b !important; }
  .fc-list-table .fc-list-event.bg-soft-warning .fc-list-event-dot {
    border-color: #f7b84b; }

.fc-daygrid-event-harness .fc-daygrid-event.bg-soft-danger .fc-event-title,
.fc-daygrid-event-harness .fc-daygrid-event.bg-soft-danger .fc-event-main {
  color: #E53E3E !important; }

.fc-timegrid-event-harness .fc-timegrid-event.bg-soft-danger .fc-event-title {
  color: #E53E3E !important; }

.fc-list-table .fc-list-event.bg-soft-danger {
  color: #E53E3E !important; }
  .fc-list-table .fc-list-event.bg-soft-danger .fc-list-event-title > a {
    color: #E53E3E !important; }
  .fc-list-table .fc-list-event.bg-soft-danger .fc-list-event-dot {
    border-color: #E53E3E; }

.fc-daygrid-event-harness .fc-daygrid-event.bg-soft-light .fc-event-title,
.fc-daygrid-event-harness .fc-daygrid-event.bg-soft-light .fc-event-main {
  color: #f3f6f9 !important; }

.fc-timegrid-event-harness .fc-timegrid-event.bg-soft-light .fc-event-title {
  color: #f3f6f9 !important; }

.fc-list-table .fc-list-event.bg-soft-light {
  color: #f3f6f9 !important; }
  .fc-list-table .fc-list-event.bg-soft-light .fc-list-event-title > a {
    color: #f3f6f9 !important; }
  .fc-list-table .fc-list-event.bg-soft-light .fc-list-event-dot {
    border-color: #f3f6f9; }

.fc-daygrid-event-harness .fc-daygrid-event.bg-soft-dark .fc-event-title,
.fc-daygrid-event-harness .fc-daygrid-event.bg-soft-dark .fc-event-main {
  color: #212529 !important; }

.fc-timegrid-event-harness .fc-timegrid-event.bg-soft-dark .fc-event-title {
  color: #212529 !important; }

.fc-list-table .fc-list-event.bg-soft-dark {
  color: #212529 !important; }
  .fc-list-table .fc-list-event.bg-soft-dark .fc-list-event-title > a {
    color: #212529 !important; }
  .fc-list-table .fc-list-event.bg-soft-dark .fc-list-event-dot {
    border-color: #212529; }

.fc-daygrid-event-harness .fc-daygrid-event.bg-soft-dark .fc-event-main, .fc-daygrid-event-harness .fc-daygrid-event.bg-soft-dark .fc-event-title {
  color: var(--vz-dark) !important; }

.fc-direction-ltr {
  direction: ltr; }
  .fc-direction-ltr .fc-toolbar > * > :not(:first-child) {
    margin-left: 0.75em; }

.fg-emoji-picker {
  width: 250px !important;
  box-shadow: 0 1px 2px rgba(56, 65, 74, 0.15) !important;
  top: auto !important;
  bottom: 130px; }
  .fg-emoji-picker * {
    font-family: var(--vz-font-sans-serif) !important;
    color: #212529 !important; }
  @media (max-width: 991.98px) {
    .fg-emoji-picker {
      left: 14px !important;
      top: auto !important;
      bottom: 118px; } }
  .fg-emoji-picker .fg-emoji-picker-container-title {
    color: #212529 !important; }
  .fg-emoji-picker .fg-emoji-picker-search {
    height: 40px !important; }
    .fg-emoji-picker .fg-emoji-picker-search input {
      background-color: var(--vz-input-bg) !important;
      color: var(--vz-body-color) !important;
      padding: 0.5rem 0.9rem !important;
      font-size: 0.875rem !important; }
      .fg-emoji-picker .fg-emoji-picker-search input::placeholder {
        color: #878a99 !important; }
    .fg-emoji-picker .fg-emoji-picker-search svg {
      fill: #212529 !important;
      right: 11px;
      top: 12px; }
  .fg-emoji-picker .fg-emoji-picker-categories {
    background-color: #f3f6f9 !important; }
    .fg-emoji-picker .fg-emoji-picker-categories li.active {
      background-color: rgba(var(--bs-primary-rgb), 0.2); }
    .fg-emoji-picker .fg-emoji-picker-categories a:hover {
      background-color: rgba(var(--bs-primary-rgb), 0.2); }

.fg-emoji-picker-grid > li:hover {
  background-color: rgba(var(--bs-primary-rgb), 0.2) !important; }

a.fg-emoji-picker-close-button {
  background-color: #e5ecf2 !important; }

.toastify {
  padding: 12px 16px;
  color: #fff;
  display: inline-block;
  box-shadow: 0 3px 6px -1px rgba(0, 0, 0, 0.12), 0 10px 36px -4px rgba(77, 96, 232, 0.3);
  background: #319795;
  position: fixed;
  opacity: 0;
  transition: all 0.4s cubic-bezier(0.215, 0.61, 0.355, 1);
  border-radius: 2px;
  cursor: pointer;
  text-decoration: none;
  max-width: calc(50% - 20px);
  z-index: 2147483647; }
  .toastify.on {
    opacity: 1; }

.toast-close {
  opacity: 0.4;
  padding: 0 5px;
  position: relative;
  left: 4px;
  margin-left: 4px; }

.toastify-right {
  right: 15px; }

.toastify-left {
  left: 15px; }
  .toastify-left .toast-close {
    left: -4px;
    margin-left: 0;
    margin-right: 4px; }

.toastify-top {
  top: -150px; }

.toastify-bottom {
  bottom: -150px; }

.toastify-rounded {
  border-radius: 25px; }

.toastify-avatar {
  width: 1.5em;
  height: 1.5em;
  margin: -7px 5px;
  border-radius: 2px; }

.toastify-center {
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  max-width: fit-content;
  max-width: -moz-fit-content; }

@media only screen and (max-width: 360px) {
  .toastify-right, .toastify-left {
    margin-left: auto;
    margin-right: auto;
    left: 0;
    right: 0;
    max-width: -moz-fit-content;
    max-width: fit-content; } }

.choices {
  position: relative;
  margin-bottom: 24px;
  font-size: 16px; }
  .choices:focus {
    outline: none; }
  .choices:last-child {
    margin-bottom: 0; }
  .choices.is-disabled .choices__inner,
  .choices.is-disabled .choices__input {
    background-color: rgba(var(--vz-light-rgb), 0.75);
    cursor: not-allowed;
    -webkit-user-select: none;
            user-select: none; }
  .choices.is-disabled .choices__item {
    cursor: not-allowed; }
  .choices [hidden] {
    display: none !important; }
  .choices[data-type*='select-one'] {
    cursor: pointer; }
    .choices[data-type*='select-one'] .choices__inner {
      padding-bottom: 0.25rem; }
    .choices[data-type*='select-one'] .choices__input {
      display: block;
      width: 100%;
      padding: 0.5rem 0.9rem;
      background-color: var(--vz-input-bg);
      border: 1px solid var(--vz-input-border);
      font-size: 0.875rem;
      border-radius: 0.25rem;
      color: var(--vz-body-color);
      margin-bottom: 10px; }
    .choices[data-type*='select-one'] .choices__button {
      background-image: url(${___CSS_LOADER_URL_REPLACEMENT_64___});
      padding: 0;
      background-size: 8px;
      position: absolute;
      top: 50%;
      right: 0;
      left: auto;
      margin-top: -10px;
      margin-right: 25px;
      margin-left: 0;
      height: 20px;
      width: 20px;
      border-radius: 10em;
      opacity: 0.5; }
      .choices[data-type*='select-one'] .choices__button:hover, .choices[data-type*='select-one'] .choices__button:focus {
        opacity: 1; }
      .choices[data-type*='select-one'] .choices__button:focus {
        box-shadow: 0px 0px 0px 2px #00bcd4; }
    .choices[data-type*='select-one'] .choices__item[data-value=''] .choices__button {
      display: none; }
    .choices[data-type*='select-one']:after {
      content: "\\F0140";
      position: absolute;
      border: 0;
      border-color: #212529 transparent transparent;
      right: 11.5px;
      left: auto;
      font-family: 'Material Design Icons';
      width: auto;
      height: auto;
      margin-top: 0;
      top: 50%;
      transform: translateY(-50%);
      pointer-events: none; }
    .choices[data-type*='select-one'].is-open:after {
      margin-top: 0;
      transform: translateY(-50%) rotate(-180deg); }
  .choices[data-type*='select-multiple'] .choices__inner, .choices[data-type*='text'] .choices__inner {
    cursor: text;
    padding-right: 0.9rem; }
  .choices[data-type*='select-multiple'] .choices__button, .choices[data-type*='text'] .choices__button {
    position: relative;
    display: inline-block;
    margin-top: 0;
    margin-right: -4px;
    margin-bottom: 0;
    margin-left: 8px;
    padding-left: 16px;
    border-left: 1px solid rgba(255, 255, 255, 0.5);
    border-right: 0;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_65___});
    background-size: 8px;
    width: 8px;
    line-height: 1;
    opacity: 0.75;
    border-radius: 0; }
    .choices[data-type*='select-multiple'] .choices__button:hover, .choices[data-type*='select-multiple'] .choices__button:focus, .choices[data-type*='text'] .choices__button:hover, .choices[data-type*='text'] .choices__button:focus {
      opacity: 1; }
  .choices[data-type*='select-multiple'] .choices__list--dropdown, .choices[data-type*='text'] .choices__list--dropdown {
    padding-bottom: 10px; }
    .choices[data-type*='select-multiple'] .choices__list--dropdown .choices__list, .choices[data-type*='text'] .choices__list--dropdown .choices__list {
      margin-bottom: 0; }
  .choices[data-type*=select-multiple] .choices__input {
    padding-top: 3px; }

.input-light .choices__inner {
  background-color: var(--vz-light);
  border: none; }

.choices__inner {
  display: inline-block;
  vertical-align: middle;
  width: 100%;
  background-color: var(--vz-input-bg);
  padding: 0.25rem 3.6rem 0.1rem 0.5rem;
  border: 1px solid var(--vz-input-border);
  border-radius: 0.25rem !important;
  font-size: 0.875rem;
  min-height: 37.5px;
  overflow: hidden; }

.is-focused .choices__inner,
.is-open .choices__inner {
  border-color: var(--vz-input-focus-border); }

.choices__list {
  margin: 0;
  padding-left: 0;
  list-style: none; }

.choices__list--single {
  display: inline-block;
  padding: 4px 16px 4px 4px;
  width: 100%; }
  .choices__list--single .choices__item {
    width: 100%; }

.choices__list--multiple {
  display: inline; }
  .choices__list--multiple .choices__item {
    display: inline-block;
    vertical-align: initial;
    border-radius: 7px;
    padding: 2px 7px;
    font-size: 11px;
    font-weight: 400;
    margin-right: 3.75px;
    margin-bottom: 3.75px;
    margin-top: 2px;
    background-color: #5ea3cb;
    border: 1px solid #5ea3cb;
    word-break: break-all;
    box-sizing: border-box;
    color: #fff;
    box-shadow: none; }
    .choices__list--multiple .choices__item[data-deletable] {
      padding-right: 5px; }
    .choices__list--multiple .choices__item.is-highlighted {
      background-color: #5ea3cb;
      border: 1px solid #5ea3cb; }

.is-disabled .choices__list--multiple .choices__item {
  background-color: #7084c7;
  border: 1px solid #7084c7; }

.choices__list--dropdown {
  visibility: hidden;
  z-index: 1;
  position: absolute;
  width: 100%;
  background-color: var(--vz-dropdown-bg);
  border: 1px solid var(--vz-border-color);
  box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);
  top: 100%;
  margin-top: 0;
  padding: 10px 10px 20px 10px;
  border-bottom-left-radius: 2.5px;
  border-bottom-right-radius: 2.5px;
  overflow: hidden;
  word-break: break-all;
  will-change: visibility;
  animation-duration: .3s;
  animation-fill-mode: both;
  transform: translateY(1px); }
  .choices__list--dropdown.is-active {
    visibility: visible;
    animation-name: DropDownSlide; }
  .choices__list--dropdown .choices__item--selectable.is-highlighted {
    background-color: var(--vz-dropdown-link-hover-bg); }
  .choices__list--dropdown .choices__list {
    margin: 0 -16px -16px; }
  .choices__list--dropdown .has-no-results {
    font-style: italic;
    font-weight: 500; }
  .choices__list--dropdown .choices__item--selectable:after {
    display: none; }

.is-open .choices__list--dropdown {
  border-color: var(--vz-border-color); }

.is-flipped .choices__list--dropdown {
  top: auto;
  bottom: 100%;
  margin-top: 0;
  margin-bottom: -1px;
  border-radius: 0.25rem 0.25rem 0 0; }
  .is-flipped .choices__list--dropdown.is-active {
    animation-name: DropDownSlideDown;
    transform: translateY(-1px); }

.choices__list--dropdown .choices__list {
  position: relative;
  max-height: 300px;
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  will-change: scroll-position; }

.choices__list--dropdown .choices__item {
  position: relative;
  font-size: 0.875rem;
  padding: 0.35rem 1.2rem 0.35rem 16px; }

@media (min-width: 640px) {
  .choices__list--dropdown .choices__item--selectable:after {
    content: attr(data-select-text);
    font-size: 12px;
    opacity: 0;
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%); }
  .choices__list--dropdown .choices__item--selectable.is-highlighted:after {
    opacity: 0.5; } }

.choices__item {
  cursor: default; }

.choices__item--selectable {
  cursor: pointer; }

.choices__item--disabled {
  cursor: not-allowed;
  -webkit-user-select: none;
          user-select: none;
  opacity: 0.5; }

.choices__heading {
  font-weight: 600;
  font-size: 12px;
  padding: 10px 16px;
  border-bottom: 1px solid var(--vz-border-color);
  color: #878a99; }

.choices__button {
  text-indent: -9999px;
  appearance: none;
  border: 0;
  background-color: transparent;
  background-repeat: no-repeat;
  background-position: center;
  cursor: pointer; }
  .choices__button:focus {
    outline: none; }

.choices__input {
  display: inline-block;
  vertical-align: baseline;
  background-color: var(--vz-input-bg);
  color: var(--vz-body-color);
  font-size: 0.875rem;
  margin-bottom: 0;
  border: 0;
  border-radius: 0;
  max-width: 100%;
  padding: 2px 0 2px 2px; }
  .choices__input:focus {
    outline: 0; }
  .choices__input::placeholder {
    color: #878a99; }

.choices__placeholder {
  color: #878a99;
  opacity: 1; }

[data-layout-mode="dark"] .choices[data-type*=select-one] .choices__button {
  filter: invert(1) grayscale(100%) brightness(200%); }

.flatpickr-calendar {
  background: transparent;
  opacity: 0;
  display: none;
  text-align: center;
  visibility: hidden;
  padding: 0;
  animation: none;
  direction: ltr;
  border: 0;
  font-size: 14px;
  line-height: 24px;
  border-radius: 5px;
  position: absolute;
  width: 307.875px;
  box-sizing: border-box;
  touch-action: manipulation;
  background: var(--vz-dropdown-bg);
  box-shadow: 1px 0 0 var(--vz-border-color), -1px 0 0 var(--vz-border-color), 0 1px 0 var(--vz-border-color), 0 -1px 0 var(--vz-border-color), 0 3px 13px rgba(0, 0, 0, 0.08); }
  .flatpickr-calendar.open, .flatpickr-calendar.inline {
    opacity: 1;
    max-height: 640px;
    visibility: visible; }
  .flatpickr-calendar.open {
    display: inline-block;
    z-index: 1; }
  .flatpickr-calendar.animate.open {
    animation: fpFadeInDown 300ms cubic-bezier(0.23, 1, 0.32, 1); }
  .flatpickr-calendar.inline {
    display: block;
    position: relative;
    top: 2px;
    width: 100%;
    box-shadow: none; }
    .flatpickr-calendar.inline .flatpickr-rContainer {
      display: block;
      width: 100%; }
      .flatpickr-calendar.inline .flatpickr-rContainer .flatpickr-days {
        width: 100%;
        border: 1px solid var(--vz-input-border);
        border-top: none;
        border-radius: 0 0 5px 5px; }
        .flatpickr-calendar.inline .flatpickr-rContainer .flatpickr-days .dayContainer {
          width: 100%;
          min-width: 100%;
          max-width: 100%; }
          .flatpickr-calendar.inline .flatpickr-rContainer .flatpickr-days .dayContainer .flatpickr-day {
            max-width: 100%;
            border-radius: 4px; }
    .flatpickr-calendar.inline .flatpickr-time {
      border: 1px solid var(--vz-input-border) !important;
      border-radius: 0.25rem; }
  .flatpickr-calendar.static {
    position: absolute;
    top: calc(100% + 2px); }
    .flatpickr-calendar.static.open {
      z-index: 999;
      display: block; }
  .flatpickr-calendar.multiMonth .flatpickr-days .dayContainer:nth-child(n+1) .flatpickr-day.inRange:nth-child(7n+7) {
    box-shadow: none !important; }
  .flatpickr-calendar.multiMonth .flatpickr-days .dayContainer:nth-child(n+2) .flatpickr-day.inRange:nth-child(7n+1) {
    box-shadow: -2px 0 0 #e6e6e6, 5px 0 0 #e6e6e6; }
  .flatpickr-calendar .hasWeeks .dayContainer,
  .flatpickr-calendar .hasTime .dayContainer {
    border-bottom: 0;
    border-bottom-right-radius: 0;
    border-bottom-left-radius: 0; }
  .flatpickr-calendar .hasWeeks .dayContainer {
    border-left: 0; }
  .flatpickr-calendar.hasTime .flatpickr-time {
    height: 40px;
    border-top: 1px solid var(--vz-border-color); }
  .flatpickr-calendar.noCalendar.hasTime .flatpickr-time {
    height: auto; }
  .flatpickr-calendar::before, .flatpickr-calendar::after {
    position: absolute;
    display: block;
    pointer-events: none;
    border: solid transparent;
    content: '';
    height: 0;
    width: 0;
    left: 22px; }
  .flatpickr-calendar.rightMost::before, .flatpickr-calendar.arrowRight::before, .flatpickr-calendar.rightMost::after, .flatpickr-calendar.arrowRight::after {
    left: auto;
    right: 22px; }
  .flatpickr-calendar.arrowCenter::before, .flatpickr-calendar.arrowCenter::after {
    left: 50%;
    right: 50%; }
  .flatpickr-calendar::before {
    border-width: 5px;
    margin: 0 -5px; }
  .flatpickr-calendar::after {
    border-width: 4px;
    margin: 0 -4px; }
  .flatpickr-calendar.arrowTop::before, .flatpickr-calendar.arrowTop::after {
    bottom: 100%; }
  .flatpickr-calendar.arrowTop::before {
    border-bottom-color: #e6e6e6; }
  .flatpickr-calendar.arrowTop::after {
    border-bottom-color: #fff; }
  .flatpickr-calendar.arrowBottom::before, .flatpickr-calendar.arrowBottom::after {
    top: 100%; }
  .flatpickr-calendar.arrowBottom::before {
    border-top-color: #e6e6e6; }
  .flatpickr-calendar.arrowBottom::after {
    border-top-color: #fff; }
  .flatpickr-calendar:focus {
    outline: 0; }

.flatpickr-wrapper {
  position: relative;
  display: inline-block; }

.flatpickr-months {
  display: flex;
  background-color: #5ea3cb;
  border-radius: 5px 5px 0px 0px; }
  .flatpickr-months .flatpickr-month {
    background: transparent;
    color: rgba(255, 255, 255, 0.9);
    fill: rgba(255, 255, 255, 0.9);
    height: 34px;
    line-height: 1;
    text-align: center;
    position: relative;
    -webkit-user-select: none;
            user-select: none;
    overflow: hidden;
    flex: 1 1; }
  .flatpickr-months .flatpickr-prev-month,
  .flatpickr-months .flatpickr-next-month {
    text-decoration: none;
    cursor: pointer;
    position: absolute;
    top: 0;
    height: 34px;
    padding: 10px;
    z-index: 3;
    color: rgba(255, 255, 255, 0.9);
    fill: rgba(255, 255, 255, 0.9);
    /*
        /*rtl:begin:ignore*/
    /*
        /*rtl:end:ignore*/
    /*
        /*rtl:begin:ignore*/
    /*
        /*rtl:end:ignore*/ }
    .flatpickr-months .flatpickr-prev-month.flatpickr-disabled,
    .flatpickr-months .flatpickr-next-month.flatpickr-disabled {
      display: none; }
    .flatpickr-months .flatpickr-prev-month i,
    .flatpickr-months .flatpickr-next-month i {
      position: relative; }
    .flatpickr-months .flatpickr-prev-month.flatpickr-prev-month,
    .flatpickr-months .flatpickr-next-month.flatpickr-prev-month {
      /*
                  /*rtl:begin:ignore*/
      /*
                  */
      left: 0;
      /*
                  /*rtl:end:ignore*/
      /*
                  */ }
    .flatpickr-months .flatpickr-prev-month.flatpickr-next-month,
    .flatpickr-months .flatpickr-next-month.flatpickr-next-month {
      /*
                  /*rtl:begin:ignore*/
      /*
                  */
      right: 0;
      /*
                  /*rtl:end:ignore*/
      /*
                  */ }
    .flatpickr-months .flatpickr-prev-month:hover,
    .flatpickr-months .flatpickr-next-month:hover {
      color: #959ea9; }
      .flatpickr-months .flatpickr-prev-month:hover svg,
      .flatpickr-months .flatpickr-next-month:hover svg {
        fill: rgba(255, 255, 255, 0.9); }
    .flatpickr-months .flatpickr-prev-month svg,
    .flatpickr-months .flatpickr-next-month svg {
      width: 14px;
      height: 14px; }
      .flatpickr-months .flatpickr-prev-month svg path,
      .flatpickr-months .flatpickr-next-month svg path {
        transition: fill 0.1s;
        fill: inherit; }

.numInputWrapper {
  position: relative;
  height: auto; }
  .numInputWrapper input,
  .numInputWrapper span {
    display: inline-block; }
  .numInputWrapper input {
    width: 100%; }
    .numInputWrapper input::-ms-clear {
      display: none; }
    .numInputWrapper input::-webkit-outer-spin-button, .numInputWrapper input::-webkit-inner-spin-button {
      margin: 0;
      -webkit-appearance: none; }
  .numInputWrapper span {
    position: absolute;
    right: 0;
    width: 14px;
    padding: 0 4px 0 2px;
    height: 50%;
    line-height: 50%;
    opacity: 0;
    cursor: pointer;
    border: 1px solid rgba(var(--vz-dark-rgb), 0.15);
    box-sizing: border-box; }
    .numInputWrapper span:hover {
      background: rgba(0, 0, 0, 0.1); }
    .numInputWrapper span:active {
      background: rgba(0, 0, 0, 0.2); }
    .numInputWrapper span:after {
      display: block;
      content: "";
      position: absolute; }
    .numInputWrapper span.arrowUp {
      top: 0;
      border-bottom: 0; }
      .numInputWrapper span.arrowUp:after {
        border-left: 4px solid transparent;
        border-right: 4px solid transparent;
        border-bottom: 4px solid rgba(57, 57, 57, 0.6);
        top: 26%; }
    .numInputWrapper span.arrowDown {
      top: 50%; }
      .numInputWrapper span.arrowDown:after {
        border-left: 4px solid transparent;
        border-right: 4px solid transparent;
        border-top: 4px solid rgba(57, 57, 57, 0.6);
        top: 40%; }
    .numInputWrapper span svg {
      width: inherit;
      height: auto; }
      .numInputWrapper span svg path {
        fill: rgba(0, 0, 0, 0.5); }
  .numInputWrapper:hover {
    background: rgba(0, 0, 0, 0.05); }
    .numInputWrapper:hover span {
      opacity: 1; }

.flatpickr-current-month {
  font-size: 100%;
  line-height: inherit;
  font-weight: 300;
  color: inherit;
  position: absolute;
  width: 75%;
  left: 12.5%;
  padding: 7.48px 0 0 0;
  line-height: 1;
  height: 34px;
  display: inline-block;
  text-align: center;
  transform: translate3d(0px, 0px, 0px); }
  .flatpickr-current-month span.cur-month {
    font-family: inherit;
    font-weight: 700;
    color: inherit;
    display: inline-block;
    margin-left: 0.5ch;
    padding: 0; }
    .flatpickr-current-month span.cur-month:hover {
      background: rgba(0, 0, 0, 0.05); }
  .flatpickr-current-month .numInputWrapper {
    width: 6ch;
    width: 7ch\\0;
    display: inline-block; }
  .flatpickr-current-month span.arrowUp::after {
    border-bottom-color: rgba(0, 0, 0, 0.9); }
  .flatpickr-current-month span.arrowDown:after {
    border-top-color: rgba(0, 0, 0, 0.9); }
  .flatpickr-current-month input.cur-year {
    background: transparent;
    box-sizing: border-box;
    color: inherit;
    cursor: text;
    padding: 0 0 0 0.5ch;
    margin: 0;
    display: inline-block;
    font-size: inherit;
    font-family: inherit;
    font-weight: 600;
    line-height: inherit;
    height: auto;
    border: 0;
    border-radius: 0;
    vertical-align: initial;
    appearance: textfield; }
    .flatpickr-current-month input.cur-year:focus {
      outline: 0; }
    .flatpickr-current-month input.cur-year[disabled], .flatpickr-current-month input.cur-year[disabled]:hover {
      font-size: 100%;
      color: rgba(255, 255, 255, 0.9);
      background: transparent;
      pointer-events: none; }
  .flatpickr-current-month .flatpickr-monthDropdown-months {
    appearance: menulist;
    background: transparent;
    border: none;
    border-radius: 0;
    box-sizing: border-box;
    color: inherit;
    cursor: pointer;
    font-size: inherit;
    font-family: inherit;
    font-weight: 600;
    height: auto;
    line-height: inherit;
    margin: -1px 0 0 0;
    outline: none;
    padding: 0 0 0 0.5ch;
    position: relative;
    vertical-align: initial;
    width: auto; }
    .flatpickr-current-month .flatpickr-monthDropdown-months:focus, .flatpickr-current-month .flatpickr-monthDropdown-months:active {
      outline: none; }
    .flatpickr-current-month .flatpickr-monthDropdown-months:hover {
      background-color: transparent; }
    .flatpickr-current-month .flatpickr-monthDropdown-months .flatpickr-monthDropdown-month {
      background-color: transparent;
      outline: none;
      padding: 0;
      color: rgba(0, 0, 0, 0.8); }

.flatpickr-weekdays {
  background-color: #5ea3cb;
  text-align: center;
  overflow: hidden;
  width: 100%;
  display: flex;
  align-items: center;
  height: 36px;
  border-bottom: 1px solid var(--vz-border-color); }
  .flatpickr-weekdays .flatpickr-weekdaycontainer {
    display: flex;
    flex: 1 1; }

span.flatpickr-weekday {
  cursor: default;
  font-size: 90%;
  background: transparent;
  color: #fff;
  line-height: 1;
  margin: 0;
  text-align: center;
  display: block;
  flex: 1 1;
  font-weight: 500; }

.dayContainer,
.flatpickr-weeks {
  padding: 1px 0 0 0; }

.flatpickr-days {
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: flex-start;
  width: 307.875px; }
  .flatpickr-days:focus {
    outline: 0; }

.dayContainer {
  padding: 0;
  outline: 0;
  text-align: left;
  width: 307.875px;
  min-width: 307.875px;
  max-width: 307.875px;
  box-sizing: border-box;
  display: inline-block;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-around;
  transform: translate3d(0px, 0px, 0px);
  opacity: 1; }
  .dayContainer + .dayContainer {
    box-shadow: -1px 0 0 #e6e6e6; }

.flatpickr-day {
  background: none;
  border: 1px solid transparent;
  border-radius: 150px;
  box-sizing: border-box;
  color: var(--vz-body-color);
  cursor: pointer;
  font-weight: 400;
  width: 14.2857143%;
  flex-basis: 14.2857143%;
  max-width: 39px;
  height: 39px;
  line-height: 39px;
  margin: 0;
  display: inline-block;
  position: relative;
  justify-content: center;
  text-align: center; }
  .flatpickr-day:hover, .flatpickr-day:focus {
    background-color: rgba(var(--vz-light-rgb), 0.7); }
  .flatpickr-day.inRange, .flatpickr-day.prevMonthDay.inRange, .flatpickr-day.nextMonthDay.inRange, .flatpickr-day.today.inRange, .flatpickr-day.prevMonthDay.today.inRange, .flatpickr-day.nextMonthDay.today.inRange, .flatpickr-day:hover, .flatpickr-day.prevMonthDay:hover, .flatpickr-day.nextMonthDay:hover, .flatpickr-day:focus, .flatpickr-day.prevMonthDay:focus, .flatpickr-day.nextMonthDay:focus {
    cursor: pointer;
    outline: 0;
    background-color: var(--vz-light);
    border-color: var(--vz-light); }
  .flatpickr-day.today {
    border-color: #5ea3cb;
    background-color: rgba(94, 163, 203, 0.1);
    box-shadow: none; }
    .flatpickr-day.today:hover, .flatpickr-day.today:focus {
      border-color: #5ea3cb;
      background-color: rgba(94, 163, 203, 0.15);
      color: var(--vz-dark); }
  .flatpickr-day.selected, .flatpickr-day.startRange, .flatpickr-day.endRange, .flatpickr-day.selected.inRange, .flatpickr-day.startRange.inRange, .flatpickr-day.endRange.inRange, .flatpickr-day.selected:focus, .flatpickr-day.startRange:focus, .flatpickr-day.endRange:focus, .flatpickr-day.selected:hover, .flatpickr-day.startRange:hover, .flatpickr-day.endRange:hover, .flatpickr-day.selected.prevMonthDay, .flatpickr-day.startRange.prevMonthDay, .flatpickr-day.endRange.prevMonthDay, .flatpickr-day.selected.nextMonthDay, .flatpickr-day.startRange.nextMonthDay, .flatpickr-day.endRange.nextMonthDay {
    background: #5ea3cb;
    box-shadow: none;
    color: #fff;
    border-color: #5ea3cb; }
  .flatpickr-day.selected.startRange, .flatpickr-day.startRange.startRange, .flatpickr-day.endRange.startRange {
    border-radius: 50px 0 0 50px; }
    .flatpickr-day.selected.startRange + .endRange:not(:nth-child(7n+1)), .flatpickr-day.startRange.startRange + .endRange:not(:nth-child(7n+1)), .flatpickr-day.endRange.startRange + .endRange:not(:nth-child(7n+1)) {
      box-shadow: -10px 0 0 #5ea3cb; }
    .flatpickr-day.selected.startRange .endRange, .flatpickr-day.startRange.startRange .endRange, .flatpickr-day.endRange.startRange .endRange {
      border-radius: 50px; }
  .flatpickr-day.selected.endRange, .flatpickr-day.startRange.endRange, .flatpickr-day.endRange.endRange {
    border-radius: 0 50px 50px 0; }
  .flatpickr-day.inRange {
    border-radius: 0;
    box-shadow: -5px 0 0 var(--vz-light), 5px 0 0 var(--vz-light); }
  .flatpickr-day.flatpickr-disabled, .flatpickr-day.flatpickr-disabled:hover, .flatpickr-day.prevMonthDay, .flatpickr-day.nextMonthDay, .flatpickr-day.notAllowed, .flatpickr-day.notAllowed.prevMonthDay, .flatpickr-day.notAllowed.nextMonthDay {
    color: rgba(var(--vz-body-color-rgb), 0.3);
    background: transparent;
    border-color: transparent;
    cursor: default; }
  .flatpickr-day.flatpickr-disabled, .flatpickr-day.flatpickr-disabled:hover {
    cursor: not-allowed;
    color: rgba(var(--vz-body-color-rgb), 0.3); }
  .flatpickr-day.week.selected {
    border-radius: 0;
    box-shadow: -5px 0 0 #5ea3cb, 5px 0 0 #5ea3cb; }
  .flatpickr-day.hidden {
    visibility: hidden; }

.rangeMode .flatpickr-day {
  margin-top: 1px; }

.flatpickr-weekwrapper {
  float: left; }
  .flatpickr-weekwrapper .flatpickr-weeks {
    padding: 0 12px;
    box-shadow: 1px 0 0 #e6e6e6; }
  .flatpickr-weekwrapper .flatpickr-weekday {
    float: none;
    width: 100%;
    line-height: 28px; }
  .flatpickr-weekwrapper span.flatpickr-day, .flatpickr-weekwrapper span.flatpickr-day:hover {
    display: block;
    width: 100%;
    max-width: none;
    color: rgba(var(--vz-dark-rgb), 0.3);
    background: transparent;
    cursor: default;
    border: none; }

.flatpickr-innerContainer {
  display: block;
  display: flex;
  box-sizing: border-box;
  overflow: hidden; }

.flatpickr-rContainer {
  display: inline-block;
  padding: 0;
  box-sizing: border-box; }

.flatpickr-time {
  text-align: center;
  outline: 0;
  display: block;
  height: 0;
  line-height: 40px;
  max-height: 40px;
  box-sizing: border-box;
  overflow: hidden;
  display: flex; }
  .flatpickr-time:after {
    content: "";
    display: table;
    clear: both; }
  .flatpickr-time .numInputWrapper {
    flex: 1 1;
    width: 40%;
    height: 40px;
    float: left; }
    .flatpickr-time .numInputWrapper span.arrowUp:after, .flatpickr-time .numInputWrapper span.arrowDown:after {
      border-bottom-color: var(--vz-border-color); }
  .flatpickr-time.hasSeconds .numInputWrapper {
    width: 26%; }
  .flatpickr-time.time24hr .numInputWrapper {
    width: 49%; }
  .flatpickr-time input {
    background: transparent;
    box-shadow: none;
    border: 0;
    border-radius: 0;
    text-align: center;
    margin: 0;
    padding: 0;
    height: inherit;
    line-height: inherit;
    color: var(--vz-body-color);
    font-size: 14px;
    position: relative;
    box-sizing: border-box;
    appearance: textfield; }
    .flatpickr-time input.flatpickr-hour {
      font-weight: bold; }
    .flatpickr-time input.flatpickr-minute, .flatpickr-time input.flatpickr-second {
      font-weight: 400; }
    .flatpickr-time input:focus {
      outline: 0;
      border: 0; }
  .flatpickr-time .flatpickr-time-separator,
  .flatpickr-time .flatpickr-am-pm {
    height: inherit;
    float: left;
    line-height: inherit;
    color: var(--vz-body-color);
    font-weight: bold;
    width: 2%;
    -webkit-user-select: none;
            user-select: none;
    align-self: center; }
  .flatpickr-time .flatpickr-am-pm {
    outline: 0;
    width: 18%;
    cursor: pointer;
    text-align: center;
    font-weight: 400; }
  .flatpickr-time input:hover, .flatpickr-time input:focus, .flatpickr-time .flatpickr-am-pm:hover, .flatpickr-time .flatpickr-am-pm:focus {
    background: rgba(94, 163, 203, 0.04); }

.flatpickr-am-pm:focus, .flatpickr-am-pm:hover,
.numInput:focus,
.numInput:hover,
.numInputWrapper:focus,
.numInputWrapper:hover {
  background-color: transparent; }

.flatpickr-input[readonly] {
  cursor: pointer;
  background-color: var(--vz-input-bg); }

[data-inline-date="true"], [data-time-inline] {
  display: none; }

@keyframes fpFadeInDown {
  from {
    opacity: 0;
    transform: translate3d(0, -20px, 0); }
  to {
    opacity: 1;
    transform: translate3d(0, 0, 0); } }

[datepicker-inline],
[timepicker-inline] {
  display: none; }

.auth-page-wrapper .auth-page-content {
  padding-bottom: 60px;
  position: relative;
  z-index: 2;
  width: 100%; }

.auth-page-wrapper .footer {
  left: 0;
  background-color: transparent;
  color: #212529; }

.auth-one-bg-position {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  width: 100%;
  height: 380px; }
  @media (max-width: 575.98px) {
    .auth-one-bg-position {
      height: 280px; } }

.auth-one-bg {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_66___});
  background-position: center;
  background-size: cover; }
  .auth-one-bg .bg-overlay {
    background: linear-gradient(to right, #4796c4, #5ea3cb);
    opacity: 0.9; }
  .auth-one-bg .shape {
    position: absolute;
    bottom: 0;
    right: 0;
    left: 0;
    z-index: 1;
    pointer-events: none; }
    .auth-one-bg .shape > svg {
      width: 100%;
      height: auto;
      fill: var(--vz-body-bg); }

.auth-pass-inputgroup input[type="text"] + .btn .ri-eye-fill:before {
  content: "\\ecb6"; }

.particles-js-canvas-el {
  position: relative; }

.signin-other-title {
  position: relative; }
  .signin-other-title:after {
    content: "";
    position: absolute;
    width: 100%;
    height: 1px;
    left: 0;
    right: 0;
    border-top: 1px dashed var(--vz-border-color);
    top: 10px; }
  .signin-other-title .title {
    display: inline-block;
    position: relative;
    z-index: 9;
    background-color: var(--vz-card-bg);
    padding: 2px 16px; }

.auth-bg-cover {
  background: linear-gradient(-45deg, #5ea3cb 50%, #319795); }
  .auth-bg-cover > .bg-overlay {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_67___});
    background-position: center;
    background-size: cover;
    opacity: 1;
    background-color: transparent; }
  .auth-bg-cover .footer {
    color: rgba(255, 255, 255, 0.5); }

#password-contain {
  display: none; }
  #password-contain p {
    padding-left: 13px; }
    #password-contain p.valid {
      color: #319795; }
      #password-contain p.valid::before {
        position: relative;
        left: -8px;
        content: "✔"; }
    #password-contain p.invalid {
      color: #E53E3E; }
      #password-contain p.invalid::before {
        position: relative;
        left: -8px;
        content: "✖"; }

.dash-filter-picker {
  min-width: 210px !important; }

.upcoming-scheduled {
  position: relative; }
  .upcoming-scheduled .flatpickr-months {
    position: absolute !important;
    top: -45px !important;
    left: auto !important;
    right: 0px !important;
    width: 200px;
    background-color: transparent; }
    .upcoming-scheduled .flatpickr-months .flatpickr-month {
      color: #878a99 !important;
      fill: #878a99 !important; }
    .upcoming-scheduled .flatpickr-months .flatpickr-prev-month, .upcoming-scheduled .flatpickr-months .flatpickr-next-month {
      display: none; }
  .upcoming-scheduled .flatpickr-calendar {
    box-shadow: none !important; }
    .upcoming-scheduled .flatpickr-calendar .flatpickr-current-month {
      font-size: 13px;
      width: 100%;
      left: 0; }
    .upcoming-scheduled .flatpickr-calendar .flatpickr-monthDropdown-months {
      border: 1px solid var(--vz-border-color);
      border-radius: 4px;
      height: 26px; }
    .upcoming-scheduled .flatpickr-calendar .flatpickr-weekdays {
      background-color: var(--vz-light);
      border: none; }
      .upcoming-scheduled .flatpickr-calendar .flatpickr-weekdays span.flatpickr-weekday {
        color: var(--vz-dark); }
    .upcoming-scheduled .flatpickr-calendar .flatpickr-day.today {
      color: #fff !important;
      background-color: #319795;
      border-color: #319795 !important; }
      .upcoming-scheduled .flatpickr-calendar .flatpickr-day.today:hover {
        color: #319795 !important;
        background-color: rgba(49, 151, 149, 0.2) !important; }
    .upcoming-scheduled .flatpickr-calendar .flatpickr-day.selected {
      background-color: #319795 !important;
      border-color: #319795 !important;
      color: #fff; }
    .upcoming-scheduled .flatpickr-calendar .numInputWrapper {
      width: 7.5ch;
      margin-left: 10px; }
  .upcoming-scheduled .flatpickr-days {
    border: none !important; }

.crm-widget .col {
  border-right: 1px solid var(--vz-border-color); }
  .crm-widget .col:last-child {
    border: 0px; }
  @media (min-width: 768px) and (max-width: 1399.98px) {
    .crm-widget .col:nth-child(3) {
      border-right: 0px; }
    .crm-widget .col:last-child {
      border-right: 1px solid var(--vz-border-color); } }
  @media (max-width: 767.98px) {
    .crm-widget .col {
      border-right: 0px;
      border-bottom: 1px solid var(--vz-border-color); } }

@media (min-width: 1400px) and (max-width: 1599.98px) {
  .project-wrapper > .col-xxl-8, .project-wrapper .col-xxl-4 {
    width: 100%; } }

.crypto-widget {
  max-width: 130px !important; }

.timeline {
  position: relative;
  width: 100%;
  max-width: 1400px;
  margin: 0 auto; }
  .timeline::after {
    content: '';
    position: absolute;
    width: 2px;
    background: var(--vz-card-bg);
    top: 57px;
    bottom: 166px;
    left: 50%;
    margin-left: -1.5px; }

.timeline-item {
  padding: 30px 60px;
  position: relative;
  background: inherit;
  width: 50%; }
  .timeline-item .icon {
    position: absolute;
    display: inline-flex;
    width: 60px;
    height: 60px;
    align-items: center;
    justify-content: center;
    font-size: 25px;
    top: 30px;
    right: -30px;
    padding: 9px 0;
    background: var(--vz-card-bg);
    border: 1px solid var(--vz-border-color);
    border-radius: 50px;
    color: #319795;
    z-index: 1; }
  .timeline-item .date {
    position: absolute;
    display: inline-block;
    width: calc(100% - 48px);
    top: 50px;
    font-size: 14px;
    font-weight: 500;
    font-style: italic; }
  .timeline-item .content {
    padding: 20px;
    background: var(--vz-card-bg);
    position: relative;
    border: 1px solid var(--vz-border-color);
    border-radius: 0.25rem;
    box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075); }
  .timeline-item.left {
    left: 0; }
    .timeline-item.left .date {
      left: calc(100% + 48px);
      text-align: start; }
  .timeline-item.right {
    left: 50%; }
    .timeline-item.right .icon {
      left: -30px; }
    .timeline-item.right .date {
      right: calc(100% + 48px);
      text-align: end; }
    .timeline-item.right::before {
      left: 28px;
      border-color: transparent transparent transparent #fff; }

@media (max-width: 991.98px) {
  .timeline::after {
    left: 112px;
    bottom: 180px; }
  .timeline-item {
    width: 100%;
    padding-left: 165px;
    padding-right: 0px; }
    .timeline-item.right, .timeline-item.left {
      left: 0%; }
      .timeline-item.right .icon, .timeline-item.left .icon {
        width: 45px;
        height: 45px;
        top: 37.5px;
        font-size: 18px;
        left: 90px; }
      .timeline-item.right::before, .timeline-item.left::before {
        left: 110px;
        border-color: transparent transparent transparent var(--vz-border-color); }
      .timeline-item.right .date, .timeline-item.left .date {
        right: auto;
        left: 0px;
        width: 79px; } }

.timeline-2 {
  position: relative; }
  .timeline-2::after {
    position: absolute;
    content: "";
    width: 2px;
    height: 83%;
    top: 50px;
    left: 40px;
    margin-left: -1px;
    background: var(--vz-card-bg); }
  .timeline-2 .timeline-year {
    position: relative;
    width: 100%;
    text-align: left;
    z-index: 1; }
    .timeline-2 .timeline-year p {
      display: inline-flex;
      width: 80px;
      height: 80px;
      margin: 0;
      padding: 23px 10px;
      background: var(--vz-card-bg);
      border-radius: 50px;
      text-transform: uppercase;
      align-items: center;
      justify-content: center;
      text-align: center; }
      .timeline-2 .timeline-year p span {
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis; }
  .timeline-2 .timeline-date {
    font-size: 14px;
    font-weight: 500;
    margin: 24px 0 0 0;
    margin-left: 55px; }
    .timeline-2 .timeline-date::after {
      content: '';
      display: block;
      position: absolute;
      width: 14px;
      height: 14px;
      top: 26px;
      left: 45px;
      align-items: left;
      background: #319795;
      border: 3px solid var(--vz-card-bg);
      border-radius: 50px;
      z-index: 1; }
  .timeline-2 .timeline-box {
    position: relative;
    display: inline-block;
    margin: 23px 62px;
    padding: 20px;
    border: 1px solid var(--vz-border-color);
    border-radius: 6px;
    background: var(--vz-card-bg);
    max-width: 695px; }
    .timeline-2 .timeline-box::after {
      content: '';
      display: block;
      position: absolute;
      width: 0;
      height: 0;
      border-style: solid;
      top: 26px;
      right: 100%;
      border-color: transparent var(--vz-card-bg) transparent transparent;
      border-width: 10px; }
    .timeline-2 .timeline-box::before {
      content: '';
      display: block;
      position: absolute;
      width: 0;
      height: 0;
      border-style: solid;
      right: 100%;
      top: 24px;
      border-color: transparent var(--vz-border-color) transparent transparent;
      border-width: 12px; }
    .timeline-2 .timeline-box .timeline-text {
      position: relative;
      float: left; }
  .timeline-2 .timeline-launch {
    position: relative;
    display: inline-block;
    border: 1px solid var(--vz-border-color);
    border-radius: 6px;
    background: #fff;
    width: 100%;
    margin-top: 15px;
    padding: 0;
    border: none;
    text-align: left;
    background: transparent; }
    .timeline-2 .timeline-launch .timeline-box {
      margin-left: 0; }
      .timeline-2 .timeline-launch .timeline-box::after {
        left: 30px;
        margin-left: 0px;
        top: -20px;
        border-color: transparent transparent var(--vz-border-color) transparent; }
      .timeline-2 .timeline-launch .timeline-box::before {
        left: 30px;
        margin-left: 0px;
        top: -19px;
        border-color: transparent transparent var(--vz-card-bg) transparent;
        border-width: 10px;
        z-index: 1; }

.horizontal-timeline {
  position: relative;
  width: 100%;
  margin: 0 auto; }
  .horizontal-timeline::before {
    content: "";
    position: absolute;
    width: 100%;
    top: 174px;
    left: 0;
    height: 2px;
    background-color: var(--vz-card-bg); }
  .horizontal-timeline .swiper-slide .item-box {
    margin: 227px 0px 0px;
    background-color: transparent;
    box-shadow: none; }
    .horizontal-timeline .swiper-slide .item-box::after {
      content: "";
      position: absolute;
      left: 0px;
      right: 0px;
      margin: 0px auto;
      background: #5ea3cb;
      width: 13px;
      height: 13px;
      top: -59px;
      border-radius: 50px;
      border: 3px solid var(--vz-card-bg); }
  .horizontal-timeline .swiper-slide .timeline-content {
    min-height: 110px;
    display: flex;
    justify-content: center;
    align-items: center;
    position: relative;
    background-color: var(--vz-card-bg); }
    .horizontal-timeline .swiper-slide .timeline-content::before {
      content: '';
      display: block;
      position: absolute;
      width: 0;
      height: 0;
      border-style: solid;
      left: 0px;
      top: -23px;
      border-color: transparent transparent var(--vz-card-bg) transparent;
      border-width: 12px;
      right: 0;
      margin: 0 auto; }
  .horizontal-timeline .swiper-slide .time {
    position: absolute;
    top: -86px;
    right: 0px;
    left: 0px;
    margin: 0px auto; }
  .horizontal-timeline .swiper-slide:nth-child(even) {
    margin-top: 5px;
    transform: rotate(-180deg); }
    .horizontal-timeline .swiper-slide:nth-child(even) .timeline-content {
      transform: rotate(180deg); }
      .horizontal-timeline .swiper-slide:nth-child(even) .timeline-content::before {
        bottom: -23px;
        top: auto;
        border-color: var(--vz-card-bg) transparent transparent transparent; }
    .horizontal-timeline .swiper-slide:nth-child(even) .time {
      transform: rotate(180deg); }
  .horizontal-timeline .swiper-button-next,
  .horizontal-timeline .swiper-button-prev {
    height: 40px;
    width: 40px;
    line-height: 40px;
    border-radius: 50%;
    background-color: #68a9ce; }
    .horizontal-timeline .swiper-button-next::after,
    .horizontal-timeline .swiper-button-prev::after {
      font-size: 24px;
      color: #fff; }
    .horizontal-timeline .swiper-button-next.swiper-button-disabled,
    .horizontal-timeline .swiper-button-prev.swiper-button-disabled {
      background-color: rgba(94, 163, 203, 0.5);
      opacity: 1;
      cursor: auto;
      -webkit-backdrop-filter: blur(25px);
              backdrop-filter: blur(25px);
      pointer-events: none; }
  .horizontal-timeline .swiper-button-next {
    right: 0; }
    .horizontal-timeline .swiper-button-next::after {
      content: "\\EA6E";
      font-family: remixicon; }
  .horizontal-timeline .swiper-button-prev {
    left: 0; }
    .horizontal-timeline .swiper-button-prev::after {
      content: "\\EA64";
      font-family: remixicon; }

.acitivity-timeline {
  position: relative;
  overflow: hidden; }
  .acitivity-timeline .acitivity-item {
    position: relative; }
    .acitivity-timeline .acitivity-item .flex-shrink-0 {
      z-index: 2; }
    .acitivity-timeline .acitivity-item .acitivity-avatar {
      background-color: var(--vz-card-bg);
      border: 3px solid var(--vz-card-bg);
      height: 32px;
      width: 32px; }
    .acitivity-timeline .acitivity-item:before {
      content: "";
      position: absolute;
      border-left: 1px dashed var(--vz-border-color);
      left: 16px;
      height: 100%;
      top: 0px;
      z-index: 0; }
    .acitivity-timeline .acitivity-item:last-child::before {
      border-color: transparent; }

.categories-filter .list-inline-item {
  position: relative;
  margin-right: 0; }
  .categories-filter .list-inline-item a {
    display: block;
    color: var(--vz-body-color);
    font-weight: 600;
    padding: 8px 15px;
    margin: 5px;
    cursor: pointer; }

.gallery-box {
  position: relative;
  overflow: hidden;
  border: 1px solid transparent;
  margin-bottom: 10px;
  box-shadow: none;
  background-color: transparent;
  padding: 8px; }
  .gallery-box::before {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    width: 100%;
    height: 0;
    background-color: var(--vz-card-bg);
    transition: all 0.4s; }
  .gallery-box .gallery-container {
    position: relative;
    overflow: hidden;
    border-radius: 4px; }
    .gallery-box .gallery-container a {
      display: block; }
    .gallery-box .gallery-container .gallery-overlay {
      position: absolute;
      top: 0px;
      left: 0px;
      bottom: 0px;
      right: 0px;
      opacity: 0;
      background: linear-gradient(180deg, rgba(0, 0, 0, 0) 10%, rgba(0, 0, 0, 0) 60%, rgba(0, 0, 0, 0.5) 100%);
      visibility: hidden;
      overflow: hidden;
      transition: all 0.4s ease-in-out 0s;
      display: flex;
      width: 100%;
      align-items: flex-end;
      padding: 16px; }
      .gallery-box .gallery-container .gallery-overlay .overlay-caption {
        color: #fff;
        margin: 0;
        font-size: 16px; }
  .gallery-box .gallery-img {
    transition: all 0.2s ease-in-out; }
  .gallery-box .box-content {
    position: relative; }
    .gallery-box .box-content .title {
      font-size: 14px;
      margin-bottom: 4px;
      display: none; }
    .gallery-box .box-content .post {
      margin: 0;
      transition: all 0.2s;
      color: #878a99; }
  .gallery-box:hover::before {
    height: 100%; }
  .gallery-box:hover .box-content {
    bottom: 0; }
    .gallery-box:hover .box-content .post {
      opacity: 1; }
  .gallery-box:hover .gallery-overlay {
    opacity: 1;
    visibility: visible; }

.gallery-light .gallery-box::before {
  background-color: var(--vz-light); }

.error-basic-img {
  max-width: 450px; }

.error-500 .title {
  font-size: 250px; }

.error-500 .error-500-img {
  position: absolute;
  top: 57px;
  left: 0;
  right: 0;
  margin: 0 auto; }

@media (min-width: 768px) and (max-width: 991.98px) {
  .error-500 .title {
    font-size: 150px; }
  .error-500 .error-500-img {
    width: 20% !important;
    top: 43px; } }

@media (max-width: 767.98px) {
  .error-500 .title {
    font-size: 68px;
    margin-top: 35px; }
  .error-500 .error-500-img {
    position: relative;
    top: 0px; } }

@keyframes errorAnimation {
  0% {
    transform: translateX(0%); }
  15% {
    transform: translateX(-25%) rotate(-5deg); }
  30% {
    transform: translateX(20%) rotate(3deg); }
  45% {
    transform: translateX(-15%) rotate(-3deg); }
  60% {
    transform: translateX(10%) rotate(2deg); }
  75% {
    transform: translateX(-5%) rotate(-1deg); }
  100% {
    transform: translateX(0%); } }

.error-img {
  animation: errorAnimation 20s infinite; }

.error-text {
  text-shadow: 4px 4px rgba(49, 151, 149, 0.4); }
  @media (min-width: 1200px) {
    .error-text {
      font-size: 10rem; } }

.profile-wid-bg {
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  height: 320px; }
  @media (max-width: 575.98px) {
    .profile-wid-bg {
      height: 445px; } }
  .profile-wid-bg::before {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    opacity: 0.9;
    background: #5ea3cb;
    background: linear-gradient(to top, #296080, #5ea3cb); }
  .profile-wid-bg .profile-wid-img {
    width: 100%;
    height: 100%;
    object-fit: cover; }

.profile-nav.nav-pills .nav-link {
  color: rgba(255, 255, 255, 0.8); }
  .profile-nav.nav-pills .nav-link::before {
    background-color: rgba(255, 255, 255, 0.1); }

.profile-project-card {
  border: 1px solid var(--vz-border-color);
  border-left: 3px solid var(--vz-border-color); }

.profile-project-card.profile-project-primary {
  border-left-color: #5ea3cb; }

.profile-project-card.profile-project-secondary {
  border-left-color: #7084c7; }

.profile-project-card.profile-project-success {
  border-left-color: #319795; }

.profile-project-card.profile-project-info {
  border-left-color: #58caea; }

.profile-project-card.profile-project-warning {
  border-left-color: #f7b84b; }

.profile-project-card.profile-project-danger {
  border-left-color: #E53E3E; }

.profile-project-card.profile-project-light {
  border-left-color: #f3f6f9; }

.profile-project-card.profile-project-dark {
  border-left-color: #212529; }

.user-profile-img {
  position: relative; }
  .user-profile-img .profile-img {
    width: 100%;
    height: 250px;
    object-fit: cover; }
    @media (max-width: 991px) {
      .user-profile-img .profile-img {
        height: 160px; } }
  .user-profile-img .profile-foreground-img-file-input {
    display: none; }
  .user-profile-img .profile-photo-edit {
    cursor: pointer; }

.profile-user {
  position: relative;
  display: inline-block; }
  .profile-user .profile-photo-edit {
    position: absolute;
    right: 0;
    left: auto;
    bottom: 0;
    cursor: pointer; }
  .profile-user .user-profile-image {
    object-fit: cover; }
  .profile-user .profile-img-file-input {
    display: none; }

.profile-timeline .accordion-item {
  position: relative; }
  .profile-timeline .accordion-item .accordion-button {
    background-color: transparent; }
    .profile-timeline .accordion-item .accordion-button::after {
      background: none; }
  .profile-timeline .accordion-item::before {
    content: "";
    border-left: 2px dashed var(--vz-border-color);
    position: absolute;
    height: 100%;
    left: 23px; }
  .profile-timeline .accordion-item:first-child::before {
    top: 8px; }
  .profile-timeline .accordion-item:last-child::before {
    height: 20px;
    top: 3px; }

.profile-setting-img {
  position: relative;
  height: 260px; }
  .profile-setting-img .overlay-content {
    content: "";
    position: absolute;
    top: 0;
    right: 0; }
  .profile-setting-img .profile-img {
    width: 100%;
    height: 250px;
    object-fit: cover; }
    @media (max-width: 991.98px) {
      .profile-setting-img .profile-img {
        height: 160px; } }
  .profile-setting-img .profile-foreground-img-file-input {
    display: none; }
  .profile-setting-img .profile-photo-edit {
    cursor: pointer; }

@media (max-width: 575.98px) {
  [data-layout="horizontal"] .profile-foreground {
    margin-top: 0 !important; } }

.sitemap-content {
  width: 100%;
  max-width: 1142px;
  margin: 0 auto;
  padding: 0 20px; }
  .sitemap-content * {
    position: relative; }

.sitemap-horizontal {
  position: relative; }
  .sitemap-horizontal ul {
    padding: 0;
    margin: 0;
    list-style: none; }
    .sitemap-horizontal ul a {
      display: block;
      background: var(--vz-light);
      border: 2px solid var(--vz-card-bg);
      box-shadow: 0 1px 2px rgba(56, 65, 74, 0.15);
      font-size: 0.875rem;
      height: 60px;
      padding: 8px;
      display: flex;
      justify-content: center;
      align-items: center; }
      .sitemap-horizontal ul a span {
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        text-overflow: ellipsis; }

.administration .director > li > a {
  width: 50%;
  margin: 0 auto 0px auto;
  border-radius: 4px; }

.administration .subdirector {
  position: absolute;
  width: 100%; }
  .administration .subdirector::after {
    content: "";
    display: block;
    width: 0;
    height: 130px;
    border-left: 2px dashed var(--vz-border-color);
    left: 45.45%;
    position: relative; }
  .administration .subdirector > li:first-child {
    width: 18.59%;
    height: 64px;
    margin: 0 auto 92px auto;
    padding-top: 25px;
    border-bottom: 2px dashed var(--vz-border-color);
    z-index: 1;
    float: right;
    right: 27.2%;
    border-left: 2px dashed var(--vz-border-color); }
    .administration .subdirector > li:first-child a {
      width: 100%;
      left: 25px; }

@media screen and (max-width: 767px) {
  .administration .subdirector > li:first-child {
    width: 40%;
    right: 10%;
    margin-right: 2px; }
  .administration .subdirector::after {
    left: 49.8%; } }

.departments {
  width: 100%; }
  .departments > li:first-child {
    width: 18.59%;
    height: 64px;
    margin: 0 auto 92px auto;
    padding-top: 25px;
    border-bottom: 2px dashed var(--vz-border-color);
    z-index: 1;
    float: left;
    left: 27%; }
    .departments > li:first-child a {
      width: 100%;
      right: 25px; }
  .departments > li:nth-child(2) {
    margin-left: 0;
    clear: left; }
    .departments > li:nth-child(2).department:before {
      border: none; }
  .departments::after {
    content: "";
    display: block;
    position: absolute;
    width: 81.1%;
    height: 22px;
    border-top: 2px dashed var(--vz-border-color);
    border-right: 2px dashed var(--vz-border-color);
    border-left: 2px dashed var(--vz-border-color);
    margin: 0 auto;
    top: 130px;
    left: 9.1%; }
  @media screen and (max-width: 767px) {
    .departments > li:first-child {
      width: 40%;
      left: 10%;
      margin-left: 2px; }
    .departments::after {
      border-right: none;
      left: 0;
      width: 50%; } }

.department {
  border-left: 2px dashed var(--vz-border-color);
  float: left;
  margin-left: 1.75%;
  margin-bottom: 60px;
  width: 18.25%; }
  .department::before {
    content: "";
    display: block;
    position: absolute;
    width: 0;
    height: 22px;
    border-left: 2px dashed var(--vz-border-color);
    z-index: 1;
    top: -22px;
    left: 50%;
    margin-left: -4px; }
  .department > a {
    margin: 0 0 -26px -4px;
    z-index: 1; }
  .department ul {
    margin-top: 0px;
    margin-bottom: 0px; }
    .department ul li {
      padding-left: 25px;
      border-bottom: 2px dashed var(--vz-border-color);
      height: 80px; }
      .department ul li a {
        background: var(--vz-card-bg);
        margin-top: 48px;
        position: absolute;
        z-index: 1;
        width: 90%;
        height: 60px;
        vertical-align: middle;
        right: -1px;
        text-align: center; }
  .department:first-child {
    margin-left: 0;
    clear: left; }
  @media screen and (min-width: 768px) {
    .department:last-child:before {
      border: none; } }
  @media screen and (max-width: 767px) {
    .department {
      float: none;
      width: 100%;
      margin-left: 0; }
      .department::before {
        content: "";
        display: block;
        position: absolute;
        width: 0;
        height: 60px;
        border-left: 2px dashed #fff;
        z-index: 1;
        top: -60px;
        left: 0%;
        margin-left: -4px; }
      .department:nth-child(2)::before {
        display: none; } }

.hori-sitemap ul {
  padding: 0;
  padding-top: 10px;
  text-align: center; }
  .hori-sitemap ul li {
    position: relative; }
  @media (max-width: 575.98px) {
    .hori-sitemap ul {
      text-align: left; }
      .hori-sitemap ul .parent-title a {
        padding-left: 0; }
        .hori-sitemap ul .parent-title a:after {
          display: none; }
      .hori-sitemap ul .parent-title:before {
        display: none; } }

@media (max-width: 575.98px) {
  .hori-sitemap > ul {
    position: relative; }
    .hori-sitemap > ul:before {
      content: "";
      height: 91%;
      border-right: 2px dashed var(--vz-border-color);
      position: absolute;
      top: 40px;
      left: 0; }
    .hori-sitemap > ul li {
      padding-top: 10px; }
      .hori-sitemap > ul li .second-list,
      .hori-sitemap > ul li .sub-list {
        position: relative; }
        .hori-sitemap > ul li .second-list:before,
        .hori-sitemap > ul li .sub-list:before {
          content: "";
          height: 86%;
          border-right: 2px dashed var(--vz-border-color);
          position: absolute;
          top: 0px;
          left: 0px; }
      .hori-sitemap > ul li .sub-list:before {
        height: 38%; }
      .hori-sitemap > ul li a {
        position: relative;
        padding: 4px 16px 4px 36px; }
        .hori-sitemap > ul li a:after {
          content: "";
          width: 24px;
          border-top: 2px dashed var(--vz-border-color);
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          left: 0; }
      .hori-sitemap > ul li ul {
        margin-left: 36px; } }

@media (min-width: 576px) {
  .hori-sitemap ul {
    padding-top: 20px; }
    .hori-sitemap ul li {
      padding-top: 30px; }
      .hori-sitemap ul li:before {
        content: "";
        height: 24px;
        width: 0;
        border-right: 2px dashed var(--vz-border-color);
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        margin: 0px auto; }
      .hori-sitemap ul li:after {
        content: "";
        width: 100%;
        border-top: 2px dashed var(--vz-border-color);
        position: absolute;
        top: 0;
        left: 50%; }
      .hori-sitemap ul li:last-of-type:after {
        display: none; }
      .hori-sitemap ul li.parent-title::before {
        content: "";
        height: 23px;
        border-right: 2px dashed var(--vz-border-color);
        position: absolute;
        top: 28px;
        left: 0; }
      .hori-sitemap ul li.parent-title::after {
        border: none; }
      .hori-sitemap ul li .sub-title {
        position: relative; }
        .hori-sitemap ul li .sub-title::before {
          content: "";
          height: 21px;
          border-right: 2px dashed var(--vz-border-color);
          position: absolute;
          top: 27px;
          left: 49%;
          margin: 0 auto; } }

.hori-sitemap a {
  color: var(--vz-body-color);
  padding: 4px 0px;
  display: block; }

.verti-sitemap ul {
  padding: 0; }
  .verti-sitemap ul li {
    list-style: none;
    position: relative; }
    .verti-sitemap ul li a {
      color: var(--vz-body-color);
      padding: 4px 0px;
      display: block; }
  .verti-sitemap ul .parent-title a {
    padding-left: 0; }
    .verti-sitemap ul .parent-title a:before {
      display: none; }
  .verti-sitemap ul .parent-title:before {
    display: none; }

.verti-sitemap > ul li {
  padding-top: 10px; }
  .verti-sitemap > ul li ul {
    margin-left: 42px; }
  .verti-sitemap > ul li .second-list {
    position: relative; }
    .verti-sitemap > ul li .second-list:before {
      content: "";
      height: calc(100% - 14px);
      border-left: 2px dashed var(--vz-border-color);
      position: absolute;
      top: 0;
      left: 0;
      margin: 0px auto; }
    .verti-sitemap > ul li .second-list li::before {
      display: none; }
  .verti-sitemap > ul li a {
    position: relative;
    padding: 4px 16px 4px 36px; }
    .verti-sitemap > ul li a::before {
      content: "";
      width: 24px;
      border-top: 2px dashed var(--vz-border-color);
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      left: 0; }
  .verti-sitemap > ul li:before {
    content: "";
    height: 100%;
    border-left: 2px dashed var(--vz-border-color);
    position: absolute;
    top: 0;
    left: 0;
    margin: 0px auto; }
  .verti-sitemap > ul li:last-child::before {
    height: 25px; }

.bookmark-icon svg {
  fill: transparent; }

.bookmark-icon .btn-star {
  cursor: pointer; }

.bookmark-icon .bookmark-input:checked ~ .btn-star svg {
  fill: #f7b84b !important;
  color: #f7b84b !important; }

.bookmark-hide {
  display: none;
  visibility: hidden;
  height: 0; }

.team-box .team-cover, .profile-offcanvas .team-cover {
  display: none;
  position: relative;
  margin-bottom: -140px; }
  .team-box .team-cover img, .profile-offcanvas .team-cover img {
    height: 140px;
    width: 100%;
    object-fit: cover; }
  .team-box .team-cover::before, .profile-offcanvas .team-cover::before {
    content: "";
    position: absolute;
    width: 100%;
    height: 100%;
    background: linear-gradient(to top, #296080, #5ea3cb);
    opacity: 0.6; }

.team-list.grid-view-filter {
  flex-flow: row wrap; }
  .team-list.grid-view-filter .col {
    flex: 0 0 auto;
    width: 25%; }
  .team-list.grid-view-filter .team-box {
    overflow: hidden; }
    .team-list.grid-view-filter .team-box .team-row {
      align-items: start; }
      .team-list.grid-view-filter .team-box .team-row .col {
        width: 100%; }
    .team-list.grid-view-filter .team-box .team-cover {
      display: block; }
    .team-list.grid-view-filter .team-box .team-settings .col {
      width: 50% !important;
      flex: 0 0 auto; }
    .team-list.grid-view-filter .team-box .team-settings .btn-star {
      color: #fff; }
    .team-list.grid-view-filter .team-box .team-settings .dropdown > a {
      color: #fff; }
    .team-list.grid-view-filter .team-box .team-profile-img {
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-bottom: 25px;
      margin-top: 36px; }
      .team-list.grid-view-filter .team-box .team-profile-img .avatar-lg {
        font-size: 22px; }
      .team-list.grid-view-filter .team-box .team-profile-img .team-content {
        margin-left: 0px;
        margin-top: 25px;
        text-align: center; }
    .team-list.grid-view-filter .team-box .view-btn {
      width: 100%;
      margin-top: 25px; }
  @media (min-width: 1200px) and (max-width: 1399.98px) {
    .team-list.grid-view-filter .col {
      flex: 0 0 auto;
      width: 33.33%; } }
  @media (max-width: 1199.98px) {
    .team-list.grid-view-filter .col {
      flex: 0 0 auto;
      width: 50%; } }
  @media (max-width: 767.98px) {
    .team-list.grid-view-filter .col {
      flex: 0 0 auto;
      width: 100%; } }

.team-list.list-view-filter {
  flex-direction: column; }
  .team-list.list-view-filter .team-box {
    margin-bottom: 10px; }
    .team-list.list-view-filter .team-box .team-row {
      align-items: center;
      justify-content: space-between; }
    .team-list.list-view-filter .team-box .team-profile-img {
      display: flex;
      align-items: center; }
      .team-list.list-view-filter .team-box .team-profile-img .avatar-lg {
        height: 4rem;
        width: 4rem;
        font-size: 16px; }
      .team-list.list-view-filter .team-box .team-profile-img .team-content {
        margin-left: 15px; }
    .team-list.list-view-filter .team-box .team-settings {
      width: auto;
      flex: 0 0 auto;
      order: 6; }
    .team-list.list-view-filter .team-box .btn-star {
      color: #5ea3cb; }
  @media (max-width: 767.98px) {
    .team-list.list-view-filter {
      flex-direction: row; }
      .team-list.list-view-filter .col {
        flex: 0 0 auto;
        width: 100%; }
      .team-list.list-view-filter .team-box .team-settings {
        width: 100%;
        flex: 0 0 auto;
        order: -1;
        margin-bottom: 10px; }
        .team-list.list-view-filter .team-box .team-settings .col {
          width: 50%; }
      .team-list.list-view-filter .team-box .team-profile-img {
        margin-bottom: 25px; }
      .team-list.list-view-filter .team-box .view-btn {
        width: 100%;
        margin-top: 25px; } }

.list-grid-nav .nav-link.active {
  background-color: #58caea;
  color: #fff; }

.profile-offcanvas .team-cover {
  margin-bottom: -132px;
  display: block;
  z-index: -1; }

.profile-offcanvas .btn-star {
  color: #fff; }

.profile-offcanvas .dropdown > a {
  color: #fff; }

.countdownlist {
  text-align: center;
  display: flex;
  gap: 24px; }
  .countdownlist .countdownlist-item {
    width: 25%; }
    .countdownlist .countdownlist-item:last-of-type .count-num::after {
      display: none; }
  .countdownlist .count-title {
    font-size: 13px;
    font-weight: 500;
    display: block;
    margin-bottom: 8px;
    color: rgba(var(--vz-dark-rgb), 0.5);
    text-transform: uppercase; }
  .countdownlist .count-num {
    background-color: var(--vz-card-bg);
    padding: 16px 8px;
    position: relative;
    border-radius: 0.25rem;
    box-shadow: 0 1px 2px rgba(56, 65, 74, 0.15);
    font-weight: 600;
    font-size: 32px; }
    @media (max-width: 575.98px) {
      .countdownlist .count-num {
        font-size: 18px; } }
    .countdownlist .count-num::after {
      content: ":";
      font-size: 20px;
      position: absolute;
      right: -16px;
      top: 50%;
      transform: translateY(-50%);
      color: var(--vz-dark); }

.move-animation {
  animation: mover 1s infinite  alternate; }

@keyframes mover {
  0% {
    transform: translateY(0); }
  100% {
    transform: translateY(-16px); } }

.coming-soon-text {
  font-weight: 600;
  text-transform: uppercase;
  color: #fff;
  text-shadow: 3px 4px #319795; }

.countdown-input-group {
  max-width: 400px; }

.search-more-results {
  position: relative;
  overflow: hidden; }
  .search-more-results .nav-icon {
    font-size: 14px;
    color: #fff;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    text-align: center;
    left: 0;
    right: 0; }
    .search-more-results .nav-icon i {
      font-size: 20px; }
    @media (max-width: 767.98px) {
      .search-more-results .nav-icon {
        font-size: 14px; }
        .search-more-results .nav-icon i {
          font-size: 18px; } }

.video-list .list-element {
  display: none; }
  .video-list .list-element:nth-child(1) {
    display: block; }
  .video-list .list-element:nth-child(2) {
    display: block; }
  .video-list .list-element:nth-child(3) {
    display: block; }

.search-voice {
  height: 120px;
  width: 120px;
  line-height: 120px;
  margin: 0px auto;
  text-align: center;
  border-radius: 50%;
  z-index: 1;
  position: relative; }
  .search-voice i {
    line-height: 56px;
    font-size: 30px; }
  .search-voice .voice-wave {
    position: absolute;
    width: 120px;
    height: 120px;
    z-index: -1;
    left: 0px;
    right: 0px;
    margin: 0px auto;
    opacity: 0;
    border-radius: 100px;
    animation: voice-wave 1.8s infinite;
    background-color: var(--vz-light); }
    .search-voice .voice-wave:nth-child(2) {
      animation-delay: 0.3s; }
    .search-voice .voice-wave:nth-child(3) {
      animation-delay: 0.6s; }

@keyframes voice-wave {
  0% {
    opacity: 1;
    transform: scale(0); }
  100% {
    opacity: 0;
    transform: scale(1); } }

.images-menu .swiper-slide {
  width: auto;
  display: inline-block; }

#selection-element {
  display: none; }

.filter-choices-input .choices__inner {
  padding: 0;
  border: none;
  background-color: var(--vz-card-bg); }

.filter-choices-input .choices__input {
  background-color: var(--vz-card-bg); }

@media (min-width: 992px) {
  .sticky-side-div {
    position: sticky;
    top: calc(70px + 1.5rem); } }

.product-img-slider .product-nav-slider .nav-slide-item {
  border: 1px solid var(--vz-border-color);
  border-radius: 0.25rem;
  padding: 0.5rem;
  cursor: pointer; }

.product-img-slider .product-nav-slider .swiper-slide-thumb-active .nav-slide-item {
  background-color: var(--vz-light); }

.filter-list a.active .listname {
  color: #319795; }

.invoice-table tbody:last-child {
  border: none; }

.currency-select .choices__inner {
  padding: 0px;
  padding-right: 15px;
  min-height: 0px; }

.currency-select .choices__list--single {
  padding: 0px 16px 0 4px; }

.currency-select .choices[data-type*=select-one] {
  bottom: 0px; }
  .currency-select .choices[data-type*=select-one] :after {
    top: 4px; }
  .currency-select .choices[data-type*=select-one] .choices__inner {
    padding-bottom: 0px; }

.chat-wrapper {
  position: relative;
  overflow-x: hidden; }

.chat-leftsidebar {
  height: calc(100vh - 137px);
  position: relative;
  background-color: var(--vz-card-bg); }
  @media (min-width: 992px) {
    .chat-leftsidebar {
      min-width: 300px;
      max-width: 300px;
      height: calc(100vh - 70px - 60px - 8px); } }

.chat-list {
  margin: 0; }
  .chat-list > li.active a {
    background-color: rgba(var(--vz-success-rgb), 0.15);
    color: var(--vz-success); }
    .chat-list > li.active a .badge {
      background-color: rgba(var(--vz-success-rgb), 0.15) !important;
      color: #319795 !important; }
  .chat-list > li a {
    display: block;
    padding: 7px 24px;
    color: var(--vz-body-color);
    transition: all 0.4s;
    font-family: "Poppins", sans-serif;
    font-weight: 500;
    font-size: 0.875rem; }
  .chat-list > li .chat-user-message {
    font-size: 14px; }
  .chat-list > li .unread-msg-user {
    font-weight: 600; }
  .chat-list > li .unread-message {
    position: absolute;
    display: inline-block;
    right: 24px;
    left: auto;
    top: 33px; }
    .chat-list > li .unread-message .badge {
      line-height: 16px;
      font-weight: 600;
      font-size: 10px; }

.chat-user-img {
  position: relative; }
  .chat-user-img .user-status {
    width: 10px;
    height: 10px;
    background-color: #adb5bd;
    border-radius: 50%;
    border: 2px solid var(--vz-card-bg);
    position: absolute;
    right: 0;
    left: auto;
    bottom: 0; }
  .chat-user-img.online .user-status {
    background-color: #319795; }
  .chat-user-img.away .user-status {
    background-color: #f7b84b; }

.chat-room-list {
  max-height: calc(100vh - 268px); }
  @media (max-width: 991.98px) {
    .chat-room-list {
      height: calc(100vh - 268px); } }

.user-chat {
  background: url(${___CSS_LOADER_URL_REPLACEMENT_68___});
  transition: all 0.4s;
  position: relative;
  background-color: var(--vz-body-bg); }
  @media (max-width: 991.98px) {
    .user-chat {
      position: absolute;
      left: 0;
      top: 3px;
      width: 100%;
      height: calc(100% - 3px);
      visibility: hidden;
      transform: translateX(100%);
      z-index: 99;
      padding-top: 70px; }
      .user-chat.user-chat-show {
        visibility: visible;
        transform: translateX(0); } }
  .user-chat .chat-content {
    position: relative; }
  .user-chat.user-chat-show .chat-welcome-section {
    display: none; }
  @media (min-width: 992px) {
    .user-chat.user-chat-show .chat-content {
      display: flex !important; } }

.user-chat-topbar {
  border-bottom: 1px solid transparent;
  background-color: var(--vz-card-bg); }
  @media (max-width: 991.98px) {
    .user-chat-topbar {
      position: fixed;
      left: 0;
      right: 0;
      top: 0;
      z-index: 1; } }

.user-chat-nav .nav-btn {
  height: 40px;
  width: 40px;
  line-height: 40px;
  box-shadow: none;
  padding: 0;
  font-size: 20px;
  color: #343a40; }

@media (max-width: 575.98px) {
  .user-chat-nav {
    display: flex;
    justify-content: flex-end; } }

.chat-conversation {
  height: calc(100vh - 299px); }
  @media (max-width: 991.98px) {
    .chat-conversation {
      height: calc(100vh - 275px); } }
  .chat-conversation .simplebar-content-wrapper {
    display: flex;
    flex-direction: column; }
    .chat-conversation .simplebar-content-wrapper .simplebar-content {
      margin-top: auto; }
  .chat-conversation .chat-conversation-list {
    padding-top: 10px;
    margin-bottom: 0; }
    .chat-conversation .chat-conversation-list > li {
      display: flex; }
  .chat-conversation li:last-of-type .conversation-list {
    margin-bottom: 0; }
  .chat-conversation .chat-list.left .check-message-icon {
    display: none; }
  .chat-conversation .chat-list .message-box-drop {
    visibility: hidden; }
  .chat-conversation .chat-list:hover .message-box-drop {
    visibility: visible; }
  .chat-conversation .chat-avatar {
    margin: 0 16px 0 0; }
    .chat-conversation .chat-avatar img {
      width: 28px;
      height: 28px;
      border-radius: 50%; }
  .chat-conversation .chat-day-title {
    position: relative;
    text-align: center;
    margin-bottom: 24px;
    margin-top: 12px;
    width: 100%; }
    .chat-conversation .chat-day-title .title {
      background-color: #fff;
      position: relative;
      font-size: 13px;
      z-index: 1;
      padding: 6px 12px;
      border-radius: 5px; }
    .chat-conversation .chat-day-title:before {
      content: "";
      position: absolute;
      width: 100%;
      height: 1px;
      left: 0;
      right: 0;
      background-color: rgba(94, 163, 203, 0.2);
      top: 10px; }
    .chat-conversation .chat-day-title .badge {
      font-size: 12px; }
  .chat-conversation .conversation-list {
    margin-bottom: 24px;
    display: inline-flex;
    position: relative;
    align-items: flex-end;
    max-width: 80%; }
    @media (max-width: 575.98px) {
      .chat-conversation .conversation-list {
        max-width: 90%; } }
    .chat-conversation .conversation-list .ctext-wrap {
      display: flex;
      margin-bottom: 10px; }
    .chat-conversation .conversation-list .ctext-content {
      word-wrap: break-word;
      word-break: break-word; }
    .chat-conversation .conversation-list .ctext-wrap-content {
      padding: 12px 20px;
      background-color: var(--vz-gray-100);
      position: relative;
      border-radius: 3px;
      box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12); }
      @media (max-width: 575.98px) {
        .chat-conversation .conversation-list .ctext-wrap-content .attached-file .attached-file-avatar {
          display: none; }
        .chat-conversation .conversation-list .ctext-wrap-content .attached-file .dropdown .dropdown-toggle {
          display: block; } }
    .chat-conversation .conversation-list .conversation-name {
      font-weight: 500;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      gap: 8px; }
    .chat-conversation .conversation-list .dropdown .dropdown-toggle {
      font-size: 18px;
      padding: 4px;
      color: #878a99; }
      .chat-conversation .conversation-list .dropdown .dropdown-toggle::after {
        display: none; }
      @media (max-width: 575.98px) {
        .chat-conversation .conversation-list .dropdown .dropdown-toggle {
          display: none; } }
    .chat-conversation .conversation-list .chat-time {
      font-size: 12px;
      margin-top: 4px;
      text-align: right; }
    .chat-conversation .conversation-list .message-img {
      border-radius: .2rem;
      position: relative;
      display: flex;
      flex-wrap: wrap;
      gap: 8px; }
      .chat-conversation .conversation-list .message-img .message-img-list {
        position: relative; }
      .chat-conversation .conversation-list .message-img img {
        max-width: 150px; }
      .chat-conversation .conversation-list .message-img .message-img-link {
        position: absolute;
        right: 10px;
        left: auto;
        bottom: 10px; }
        .chat-conversation .conversation-list .message-img .message-img-link li > a {
          font-size: 18px;
          color: #fff;
          display: inline-block;
          line-height: 20px;
          width: 26px;
          height: 24px;
          border-radius: 3px;
          background-color: rgba(33, 37, 41, 0.7);
          text-align: center; }
  .chat-conversation .right {
    justify-content: flex-end; }
    .chat-conversation .right .chat-avatar {
      order: 3;
      margin-right: 0px;
      margin-left: 16px; }
    .chat-conversation .right .chat-time {
      text-align: left;
      color: #878a99; }
    .chat-conversation .right .conversation-list {
      text-align: right; }
      .chat-conversation .right .conversation-list .ctext-wrap {
        justify-content: flex-end; }
        .chat-conversation .right .conversation-list .ctext-wrap .ctext-wrap-content {
          order: 2;
          background-color: rgba(var(--vz-success-rgb), 0.15);
          color: var(--vz-success);
          text-align: right;
          box-shadow: none; }
          .chat-conversation .right .conversation-list .ctext-wrap .ctext-wrap-content .replymessage-block {
            background-color: rgba(255, 255, 255, 0.5);
            border-color: rgba(var(--vz-success-rgb), 1);
            color: #212529; }
            .chat-conversation .right .conversation-list .ctext-wrap .ctext-wrap-content .replymessage-block .conversation-name {
              color: rgba(var(--vz-success-rgb), 1); }
      .chat-conversation .right .conversation-list .conversation-name {
        justify-content: flex-end; }
        .chat-conversation .right .conversation-list .conversation-name .check-message-icon {
          order: 1; }
        .chat-conversation .right .conversation-list .conversation-name .time {
          order: 2; }
        .chat-conversation .right .conversation-list .conversation-name .name {
          order: 3; }
      .chat-conversation .right .conversation-list .dropdown {
        order: 1; }
    .chat-conversation .right .dot {
      background-color: #212529; }

.chat-input-section {
  border-top: 1px solid transparent;
  background-color: var(--vz-card-bg);
  position: relative;
  z-index: 1; }
  .chat-input-section .chat-input-feedback {
    display: none;
    position: absolute;
    top: -20px;
    left: 4px;
    font-size: 12px;
    color: #E53E3E; }
  .chat-input-section .show {
    display: block; }

.chat-input-links {
  display: flex; }
  .chat-input-links .links-list-item > .btn {
    box-shadow: none;
    padding: 0;
    font-size: 20px;
    width: 37.5px;
    height: 37.5px; }
    .chat-input-links .links-list-item > .btn.btn-link {
      color: #878a99; }

.copyclipboard-alert {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  display: none; }

.replyCard {
  position: absolute;
  left: 0;
  right: 0;
  border-top: 1px solid var(--vz-border-color);
  overflow: hidden;
  opacity: 0;
  bottom: 0;
  border-radius: 0;
  transition: all 0.4s; }
  @media (max-width: 991.98px) {
    .replyCard {
      bottom: -12px; } }
  .replyCard.show {
    transform: translateY(-88px);
    opacity: 1; }
    @media (max-width: 991.98px) {
      .replyCard.show {
        transform: translateY(-83px); } }

.replymessage-block {
  padding: 12px 20px;
  margin-bottom: 8px;
  text-align: left;
  border-radius: 4px;
  background-color: rgba(var(--vz-success-rgb), 0.1);
  border-left: 2px solid rgba(var(--vz-success-rgb), 1); }
  .replymessage-block .conversation-name {
    color: rgba(var(--vz-success-rgb), 1);
    font-size: 14px; }

.chat-sm .ctext-wrap-content {
  box-shadow: none !important; }

.chat-sm .message-img img {
  max-width: 90px !important; }

.chat-sm .message-img-link {
  bottom: 0 !important;
  right: 5px !important; }

@media (min-width: 1025px) {
  [data-layout="horizontal"] .chat-wrapper {
    margin-left: 0 !important;
    margin-right: 0 !important; } }

@media (max-width: 991.98px) {
  [data-layout="horizontal"] .chat-wrapper {
    margin-top: 0 !important; } }

[data-layout="horizontal"] .chat-leftsidebar {
  height: calc(100vh - 70px - 60px - 54px); }
  @media (max-width: 991.98px) {
    [data-layout="horizontal"] .chat-leftsidebar {
      height: calc(100vh - 70px - 60px - 8px); } }

[data-layout="horizontal"] .chat-room-list {
  height: calc(100vh - 316px); }
  @media (max-width: 991.98px) {
    [data-layout="horizontal"] .chat-room-list {
      height: calc(100vh - 265px); } }

[data-layout="horizontal"] .chat-conversation {
  height: calc(100vh - 343px); }
  @media (max-width: 991.98px) {
    [data-layout="horizontal"] .chat-conversation {
      height: calc(100vh - 275px); } }

.email-wrapper {
  position: relative;
  overflow-x: hidden; }

.email-menu-sidebar {
  height: calc(100vh - 137px);
  position: relative;
  background-color: var(--vz-card-bg);
  transition: all 0.2s; }
  @media (min-width: 992px) {
    .email-menu-sidebar {
      min-width: 250px;
      max-width: 250px;
      height: calc(100vh - 70px - 60px - 8px); } }
  @media (max-width: 991.98px) {
    .email-menu-sidebar {
      position: fixed;
      top: 0;
      bottom: 0;
      left: 0;
      width: 200px;
      max-width: 100%;
      z-index: 1003;
      box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);
      transform: translateX(-100%);
      visibility: hidden;
      height: 100vh; }
      .email-menu-sidebar.menubar-show {
        visibility: visible;
        transform: none; } }
  .email-menu-sidebar .email-menu-sidebar-scroll {
    height: calc(100vh - 295px); }
    @media (max-width: 991.98px) {
      .email-menu-sidebar .email-menu-sidebar-scroll {
        height: calc(100vh - 150px); } }

.mail-list a {
  display: flex;
  align-items: center;
  color: #878a99;
  padding: 5px 0;
  font-weight: 500; }
  .mail-list a:hover {
    color: #5ea3cb; }
  .mail-list a i {
    font-size: 14px; }
  .mail-list a.active {
    color: #319795;
    font-weight: 600; }
    .mail-list a.active i {
      color: #319795; }

.email-topbar-link .btn-ghost-secondary {
  color: #878a99; }
  .email-topbar-link .btn-ghost-secondary:hover {
    color: #7084c7; }

.email-content {
  width: 100%;
  background-color: var(--vz-card-bg);
  transition: all 0.2s; }

.unreadConversations-alert {
  position: fixed;
  bottom: 60px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 1; }

.email-detail-content {
  position: absolute;
  top: 4px;
  bottom: 4px;
  left: 68%;
  width: 32%;
  background-color: var(--vz-card-bg);
  transform: translateX(200%);
  transition: all 0.2s;
  visibility: hidden;
  border-left: 2px solid var(--vz-body-bg); }

.email-detail-show .email-detail-content {
  transform: none;
  visibility: visible; }

.email-detail-show .email-content {
  margin-right: 32%; }
  @media (max-width: 1349.98px) {
    .email-detail-show .email-content {
      margin-right: 0; } }

.email-detail-content-scroll {
  height: calc(100vh - 390px); }
  @media (max-width: 1349.98px) {
    .email-detail-content-scroll {
      height: calc(100vh - 252px); } }

.message-list-content {
  height: calc(100vh - 242px); }
  @media (max-width: 575.98px) {
    .message-list-content {
      height: calc(100vh - 230px); } }

.message-list {
  display: block;
  padding-left: 0;
  margin: 0; }
  .message-list li {
    position: relative;
    display: block;
    height: 50px;
    line-height: 50px;
    cursor: default;
    transition-duration: .3s;
    clear: both; }
    .message-list li a {
      color: var(--vz-gray-700); }
    .message-list li:hover {
      background: var(--vz-light);
      transition-duration: .05s; }
    .message-list li .col-mail {
      float: left;
      position: relative; }
    .message-list li .col-mail-1 {
      width: 280px; }
      .message-list li .col-mail-1 .star-toggle,
      .message-list li .col-mail-1 .checkbox-wrapper-mail,
      .message-list li .col-mail-1 .dot {
        display: block;
        float: left; }
      .message-list li .col-mail-1 .dot {
        border: 4px solid transparent;
        border-radius: 100px;
        margin: 22px 26px 0;
        height: 0;
        width: 0;
        line-height: 0;
        font-size: 0; }
      .message-list li .col-mail-1 .checkbox-wrapper-mail {
        margin: 15px 0 0 20px;
        line-height: normal; }
      .message-list li .col-mail-1 .star-toggle {
        margin-top: 18px;
        margin-left: 5px; }
      .message-list li .col-mail-1 .title {
        position: absolute;
        top: 0;
        left: 95px;
        right: 0;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
        margin-bottom: 0; }
        @media (max-width: 575.98px) {
          .message-list li .col-mail-1 .title {
            left: 95px; } }
    .message-list li .col-mail-2 {
      position: absolute;
      top: 0;
      left: 280px;
      right: 0;
      bottom: 0; }
      .message-list li .col-mail-2 .subject,
      .message-list li .col-mail-2 .date {
        position: absolute;
        top: 0; }
      .message-list li .col-mail-2 .subject {
        left: 0;
        right: 110px;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap; }
        .message-list li .col-mail-2 .subject .teaser {
          color: var(--vz-gray-600); }
      .message-list li .col-mail-2 .date {
        right: 0;
        width: 100px;
        padding-left: 20px; }
    .message-list li.active, .message-list li.active:hover {
      box-shadow: inset 3px 0 0 #5ea3cb;
      background-color: var(--vz-light); }
    .message-list li.unread {
      color: var(--vz-gray-800); }
      .message-list li.unread a {
        color: var(--vz-gray-800);
        font-weight: 600; }

#unreadConversations, #email-topbar-actions {
  display: none; }

#mailLoader {
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0; }

.email-compose-input {
  padding-right: 80px; }

@media (max-width: 1349.98px) {
  .email-detail-content {
    position: fixed;
    top: 0;
    bottom: 0;
    left: auto;
    right: 0;
    width: 400px;
    max-width: 100%;
    z-index: 1003;
    box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12);
    transform: translateX(100%); }
  .email-detail-show .email-detail-content {
    transform: none; } }

@media (max-width: 575.98px) {
  .message-list li .col-mail-1 {
    width: 180px; } }

.email-editor .ck-editor__editable_inline {
  min-height: 200px !important; }

.email-chat-detail {
  width: 350px;
  position: fixed;
  max-width: 100%;
  bottom: 60px;
  right: 60px;
  z-index: 9;
  display: none; }
  .email-chat-detail .card {
    box-shadow: 0 5px 10px rgba(30, 32, 37, 0.12); }
  @media (max-width: 515.98px) {
    .email-chat-detail {
      left: 16px;
      right: 16px; } }

@media (min-width: 1025px) {
  [data-layout="horizontal"] .email-wrapper {
    margin-left: 0 !important;
    margin-right: 0 !important; } }

@media (max-width: 991.98px) {
  [data-layout="horizontal"] .email-wrapper {
    margin-top: 0 !important; } }

[data-layout="horizontal"] .email-menu-sidebar {
  height: calc(100vh - 70px - 60px - 54px); }
  @media (max-width: 991.98px) {
    [data-layout="horizontal"] .email-menu-sidebar {
      height: 100vh; } }
  [data-layout="horizontal"] .email-menu-sidebar .email-menu-sidebar-scroll {
    height: calc(100vh - 330px); }
    @media (max-width: 991.98px) {
      [data-layout="horizontal"] .email-menu-sidebar .email-menu-sidebar-scroll {
        height: calc(100vh - 150px); } }

[data-layout="horizontal"] .message-list-content {
  height: calc(100vh - 289px); }

[data-layout="horizontal"] .email-detail-content-scroll {
  height: calc(100vh - 435px); }
  @media (max-width: 1349.98px) {
    [data-layout="horizontal"] .email-detail-content-scroll {
      height: calc(100vh - 252px); } }

.tasks-board {
  display: flex;
  overflow-x: auto;
  align-items: stretch; }
  .tasks-board .tasks-list {
    min-width: 300px;
    margin-right: 24px; }
  .tasks-board::-webkit-scrollbar {
    -webkit-appearance: none; }
  .tasks-board::-webkit-scrollbar:vertical {
    width: 10px; }
  .tasks-board::-webkit-scrollbar:horizontal {
    height: 8px; }
  .tasks-board::-webkit-scrollbar-thumb {
    background-color: rgba(var(--vz-dark-rgb), 0.075);
    border-radius: 8px; }
  .tasks-board::-webkit-scrollbar-track {
    border-radius: 8px; }

.tasks-box .progress {
  border-radius: 0px 0px 0.25rem 0.25rem; }

.tasks-box .tasks-img {
  height: 135px;
  width: 100%;
  object-fit: cover;
  object-position: center;
  margin: 12px 0px; }

.tasks-box:last-child {
  margin-bottom: 0px; }

.tasks-wrapper {
  max-height: calc(100vh - 410px); }

.tasks {
  min-height: 140px;
  position: relative; }
  .tasks::before {
    content: "";
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    height: 180px;
    width: 270px;
    margin: 0 auto;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_69___});
    background-size: cover;
    background-position: center; }

#tasksList tr .tasks-list-menu {
  opacity: 0; }

#tasksList tr:hover .tasks-list-menu {
  opacity: 1; }

.layout-wrapper.landing {
  background-color: var(--vz-card-bg);
  font-size: 15px; }

.section {
  padding: 90px 0;
  position: relative; }
  @media (max-width: 767.98px) {
    .section {
      padding: 50px 0; } }

.icon-effect {
  position: relative; }
  .icon-effect::before {
    content: "";
    position: absolute;
    width: 24px;
    height: 24px;
    background-color: rgba(49, 151, 149, 0.2);
    border-radius: 50%;
    bottom: 0;
    left: 0; }

.navbar-landing {
  padding: 10px 0px; }
  @media (max-width: 991.98px) {
    .navbar-landing {
      background-color: var(--vz-card-bg);
      box-shadow: 0 1px 16px -2px rgba(56, 65, 74, 0.15);
      padding: 10px 8px; } }
  .navbar-landing .navbar-nav .nav-item .nav-link {
    font-size: 16px;
    font-weight: 500;
    transition: all 0.4s;
    font-family: "Poppins", sans-serif;
    color: var(--vz-dark);
    padding: 14px; }
    @media (max-width: 991.98px) {
      .navbar-landing .navbar-nav .nav-item .nav-link {
        padding: 8px 0px; } }
    .navbar-landing .navbar-nav .nav-item .nav-link:hover, .navbar-landing .navbar-nav .nav-item .nav-link.active, .navbar-landing .navbar-nav .nav-item .nav-link:focus {
      color: #319795 !important; }
  .navbar-landing .navbar-nav .nav-item.active .nav-link {
    color: #319795 !important; }
  .navbar-landing .nav-link.active {
    color: #319795 !important; }
  .navbar-landing.is-sticky {
    background-color: var(--vz-card-bg);
    box-shadow: 0 1px 16px -2px rgba(56, 65, 74, 0.15); }

.hero-section {
  background-color: rgba(var(--vz-light-rgb), 0.5); }
  .hero-section .hero-shape-svg svg path {
    fill: var(--vz-card-bg); }

.bg-overlay-pattern {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_70___});
  background-color: transparent;
  background-position: center;
  background-size: cover;
  opacity: 0.2; }

.demo-carousel {
  position: relative;
  z-index: 1; }
  .demo-carousel .carousel-item .demo-item {
    background-color: var(--vz-card-bg);
    padding: 8px;
    border-radius: 7px; }
  .demo-carousel .demo-img-patten-top {
    position: absolute;
    right: -50px;
    top: -16px;
    max-width: 230px; }
  .demo-carousel .demo-img-patten-bottom {
    position: absolute;
    left: -70px;
    bottom: -50px;
    max-width: 230px; }

.client-images img {
  max-height: 45px;
  width: auto;
  margin: 12px auto;
  transition: all 0.4s; }

.plan-box {
  max-width: 356px;
  margin-left: auto;
  margin-right: auto; }

.process-card {
  position: relative; }
  .process-card .process-arrow-img {
    position: absolute;
    left: 75%;
    top: 7%;
    width: 50%;
    opacity: 0.1; }

.custom-footer {
  color: #9ba7b3; }

.footer-list li a {
  color: #9ba7b3;
  padding: 7px 0;
  display: block;
  transition: all 0.3s ease-in-out; }
  .footer-list li a:hover {
    color: rgba(255, 255, 255, 0.9); }

.footer-social-link .avatar-title {
  color: #778089;
  background-color: rgba(255, 255, 255, 0.05);
  transition: all 0.3s ease; }
  .footer-social-link .avatar-title:hover {
    color: #fff;
    background-color: #5ea3cb; }

[data-layout-mode="dark"] .layout-wrapper.landing .demo-img-patten-top,
[data-layout-mode="dark"] .layout-wrapper.landing .demo-img-patten-bottom {
  opacity: 0.2; }

[data-layout-mode="dark"] .layout-wrapper.landing footer.bg-dark {
  background-color: var(--vz-card-bg) !important; }

.section {
  position: relative; }

/*
Template Name: Velzon - Admin & Dashboard Template
Author: Themesbrand
Website: https://themesbrand.com/
Contact: support@themesbrand.com
File: Custom Css File
*/
.css-b62m3t-container .css-1s2u09g-control {
  background-color: var(--vz-card-bg);
  border-color: var(--vz-border-color); }
  .css-b62m3t-container .css-1s2u09g-control:hover {
    border-color: var(--vz-border-color); }

.css-b62m3t-container .css-1pahdxg-control {
  background-color: var(--vz-card-bg);
  border-color: var(--vz-border-color);
  box-shadow: none; }
  .css-b62m3t-container .css-1pahdxg-control:hover {
    border-color: var(--vz-border-color) !important; }

.css-b62m3t-container .css-26l3qy-menu {
  background-color: var(--vz-dropdown-bg); }
  .css-b62m3t-container .css-26l3qy-menu .css-1n7v3ny-option {
    cursor: pointer;
    background-color: var(--vz-dropdown-link-hover-bg); }
    .css-b62m3t-container .css-26l3qy-menu .css-1n7v3ny-option:active {
      background-color: var(--vz-dropdown-link-hover-bg); }

.css-b62m3t-container .css-1rhbuit-multiValue {
  background-color: var(--vz-light); }

.css-b62m3t-container .css-12jo7m5 {
  color: var(--vz-heading-color); }

.css-b62m3t-container .css-6j8wv5-Input, .css-b62m3t-container .css-qc6sy-singleValue {
  color: var(--vz-heading-color); }

iframe {
  display: none; }

.offcanvas-header-dark .btn-close {
  filter: invert(1) grayscale(100%) brightness(200%); }

body * {
  outline: none; }

.noUi-horizontal .noUi-handle {
  height: 16px !important;
  width: 16px !important;
  border-radius: 50% !important;
  right: -10px !important;
  top: -7px !important; }

.noUi-connect,
.noUi-horizontal {
  height: 2px !important; }

.noUi-handle {
  background: #6ada7d !important;
  border: 2px solid var(--vz-card-bg) !important;
  box-shadow: none !important; }

.noUi-target {
  background: #fafafa !important;
  border-radius: 4px !important;
  border: 1px solid #d3d3d3 !important;
  background-color: var(--vz-light) !important;
  border-color: var(--vz-light) !important;
  box-shadow: none !important;
  height: 4px !important; }

.dropzone .dz-message {
  text-align: center; }

.wink {
  animation-name: winker;
  animation-duration: 1s;
  animation-timing-function: linear;
  animation-iteration-count: infinite; }

@keyframes winker {
  0% {
    opacity: 1.0; }
  50% {
    opacity: 0.5; }
  100% {
    opacity: 1.0; } }

.quill-only p {
  margin: 0; }

ol,
ul {
  margin-bottom: 0; }

.ql-indent-1 {
  margin-left: 15px; }

.ql-indent-2 {
  margin-left: 30px; }

.ql-indent-3 {
  margin-left: 45px; }

.ql-indent-4 {
  margin-left: 60px; }

.ql-indent-5 {
  margin-left: 75px; }

.ql-indent-6 {
  margin-left: 90px; }

.ql-indent-7 {
  margin-left: 105px; }

.ql-indent-8 {
  margin-left: 120px; }

.fc-direction-ltr .fc-daygrid-event.fc-event-end,
.fc-direction-rtl .fc-daygrid-event.fc-event-start {
  padding: 5px !important;
  font-size: 12px !important;
  margin-right: 2px; }

.fc-event {
  border: none !important; }

@media (max-width: 575.98px) {
  .fc-toolbar {
    display: block !important;
    text-align: center; }
    .fc-toolbar .fc-left,
    .fc-toolbar .fc-right,
    .fc-toolbar .fc-center {
      float: none;
      display: block;
      clear: both;
      margin: 10px 0; }
  .fc .fc-toolbar > * > * {
    float: none; }
  .fc-today-button {
    display: none; } }

.flatpickr-calendar.open {
  z-index: 1090 !important; }

.upcoming-scheduled .flatpickr-input[readonly] {
  display: none; }

.ql-container.ql-snow {
  height: 250px; }

.rangeslider-horizontal .rangeslider__fill {
  background-color: #5ea3cb !important; }

.Toastify__toast {
  min-height: 43px !important;
  max-height: 43px !important; }

.simplebar-track-primary .simplebar-scrollbar:before {
  background: #5ea3cb !important; }

.simplebar-track-secondary .simplebar-scrollbar:before {
  background: #7084c7 !important; }

.simplebar-track-success .simplebar-scrollbar:before {
  background: #319795 !important; }

.simplebar-track-info .simplebar-scrollbar:before {
  background: #58caea !important; }

.simplebar-track-warning .simplebar-scrollbar:before {
  background: #f7b84b !important; }

.simplebar-track-danger .simplebar-scrollbar:before {
  background: #E53E3E !important; }

.simplebar-track-light .simplebar-scrollbar:before {
  background: #f3f6f9 !important; }

.simplebar-track-dark .simplebar-scrollbar:before {
  background: #212529 !important; }

.chat-conversation .chat-list .message-box-drop .nav-btn {
  font-size: 18px;
  padding: 4px;
  color: #878a99; }

.headerTrial {
  background-color: '#F7FAFC';
  height: 40px;
  text-align: -webkit-center; }
  .headerTrial .a1 {
    display: flex;
    align-items: center;
    gap: 15px;
    position: absolute; }
  .headerTrial .a2 {
    background-color: #e2e8f0;
    padding: 5px 20px;
    border-radius: 8px;
    margin-left: 30px;
    margin: 0px 30px;
    width: max-content; }

#tsparticles canvas {
  position: absolute !important; }

@media screen and (max-width: 850px) {
  .a2 {
    display: none; } }
`, "",{"version":3,"sources":["webpack://./src/assets/scss/themes.scss","webpack://./src/assets/scss/icons.scss","webpack://./src/assets/scss/plugins/icons/_materialdesignicons.scss","webpack://./src/assets/scss/plugins/icons/_boxicons.scss","webpack://./src/assets/scss/plugins/icons/_line-awesome.scss","webpack://./src/assets/scss/plugins/icons/_remixicon.scss","webpack://./src/assets/scss/config/modern/bootstrap.scss","webpack://./node_modules/bootstrap/scss/mixins/_banner.scss","webpack://./node_modules/bootstrap/scss/_root.scss","webpack://./node_modules/bootstrap/scss/vendor/_rfs.scss","webpack://./node_modules/bootstrap/scss/_reboot.scss","webpack://./src/assets/scss/config/modern/_variables.scss","webpack://./node_modules/bootstrap/scss/mixins/_border-radius.scss","webpack://./node_modules/bootstrap/scss/_type.scss","webpack://./node_modules/bootstrap/scss/mixins/_lists.scss","webpack://./node_modules/bootstrap/scss/_images.scss","webpack://./node_modules/bootstrap/scss/mixins/_image.scss","webpack://./node_modules/bootstrap/scss/_containers.scss","webpack://./node_modules/bootstrap/scss/mixins/_container.scss","webpack://./node_modules/bootstrap/scss/mixins/_breakpoints.scss","webpack://./node_modules/bootstrap/scss/_grid.scss","webpack://./node_modules/bootstrap/scss/mixins/_grid.scss","webpack://./node_modules/bootstrap/scss/_tables.scss","webpack://./node_modules/bootstrap/scss/mixins/_table-variants.scss","webpack://./node_modules/bootstrap/scss/forms/_labels.scss","webpack://./node_modules/bootstrap/scss/_functions.scss","webpack://./node_modules/bootstrap/scss/forms/_form-text.scss","webpack://./node_modules/bootstrap/scss/forms/_form-control.scss","webpack://./node_modules/bootstrap/scss/mixins/_transition.scss","webpack://./node_modules/bootstrap/scss/mixins/_gradients.scss","webpack://./node_modules/bootstrap/scss/forms/_form-select.scss","webpack://./node_modules/bootstrap/scss/_variables.scss","webpack://./node_modules/bootstrap/scss/forms/_form-check.scss","webpack://./node_modules/bootstrap/scss/forms/_form-range.scss","webpack://./node_modules/bootstrap/scss/forms/_floating-labels.scss","webpack://./node_modules/bootstrap/scss/forms/_input-group.scss","webpack://./node_modules/bootstrap/scss/mixins/_forms.scss","webpack://./node_modules/bootstrap/scss/_buttons.scss","webpack://./node_modules/bootstrap/scss/mixins/_buttons.scss","webpack://./node_modules/bootstrap/scss/_transitions.scss","webpack://./node_modules/bootstrap/scss/_dropdown.scss","webpack://./node_modules/bootstrap/scss/_button-group.scss","webpack://./node_modules/bootstrap/scss/_nav.scss","webpack://./node_modules/bootstrap/scss/_navbar.scss","webpack://./node_modules/bootstrap/scss/_card.scss","webpack://./node_modules/bootstrap/scss/_accordion.scss","webpack://./node_modules/bootstrap/scss/_breadcrumb.scss","webpack://./node_modules/bootstrap/scss/_pagination.scss","webpack://./node_modules/bootstrap/scss/mixins/_pagination.scss","webpack://./node_modules/bootstrap/scss/_badge.scss","webpack://./node_modules/bootstrap/scss/_alert.scss","webpack://./node_modules/bootstrap/scss/mixins/_alert.scss","webpack://./node_modules/bootstrap/scss/_progress.scss","webpack://./node_modules/bootstrap/scss/_list-group.scss","webpack://./node_modules/bootstrap/scss/mixins/_list-group.scss","webpack://./node_modules/bootstrap/scss/_close.scss","webpack://./node_modules/bootstrap/scss/_toasts.scss","webpack://./node_modules/bootstrap/scss/_modal.scss","webpack://./node_modules/bootstrap/scss/mixins/_backdrop.scss","webpack://./node_modules/bootstrap/scss/_tooltip.scss","webpack://./node_modules/bootstrap/scss/mixins/_reset-text.scss","webpack://./node_modules/bootstrap/scss/_popover.scss","webpack://./node_modules/bootstrap/scss/_carousel.scss","webpack://./node_modules/bootstrap/scss/mixins/_clearfix.scss","webpack://./node_modules/bootstrap/scss/_spinners.scss","webpack://./node_modules/bootstrap/scss/_offcanvas.scss","webpack://./node_modules/bootstrap/scss/_placeholders.scss","webpack://./node_modules/bootstrap/scss/helpers/_color-bg.scss","webpack://./node_modules/bootstrap/scss/helpers/_colored-links.scss","webpack://./node_modules/bootstrap/scss/helpers/_ratio.scss","webpack://./node_modules/bootstrap/scss/helpers/_position.scss","webpack://./node_modules/bootstrap/scss/helpers/_stacks.scss","webpack://./node_modules/bootstrap/scss/helpers/_visually-hidden.scss","webpack://./node_modules/bootstrap/scss/mixins/_visually-hidden.scss","webpack://./node_modules/bootstrap/scss/helpers/_stretched-link.scss","webpack://./node_modules/bootstrap/scss/helpers/_text-truncation.scss","webpack://./node_modules/bootstrap/scss/mixins/_text-truncate.scss","webpack://./node_modules/bootstrap/scss/helpers/_vr.scss","webpack://./node_modules/bootstrap/scss/mixins/_utilities.scss","webpack://./node_modules/bootstrap/scss/utilities/_api.scss","webpack://./src/assets/scss/config/modern/app.scss","webpack://./src/assets/scss/fonts/_fonts.scss","webpack://./src/assets/scss/config/modern/_theme-light.scss","webpack://./src/assets/scss/config/modern/_theme-dark.scss","webpack://./src/assets/scss/structure/_topbar.scss","webpack://./src/assets/scss/structure/_page-head.scss","webpack://./src/assets/scss/structure/_footer.scss","webpack://./src/assets/scss/structure/_vertical.scss","webpack://./src/assets/scss/structure/_horizontal.scss","webpack://./src/assets/scss/structure/_two-column.scss","webpack://./src/assets/scss/structure/_layouts.scss","webpack://./src/assets/scss/components/_waves.scss","webpack://./src/assets/scss/components/_avatar.scss","webpack://./src/assets/scss/components/_accordion.scss","webpack://./src/assets/scss/components/_helper.scss","webpack://./src/assets/scss/components/_preloader.scss","webpack://./src/assets/scss/components/_forms.scss","webpack://./src/assets/scss/components/_widgets.scss","webpack://./src/assets/scss/components/_demos.scss","webpack://./src/assets/scss/components/_print.scss","webpack://./src/assets/scss/components/_ribbons.scss","webpack://./src/assets/scss/components/_toast.scss","webpack://./src/assets/scss/components/_scrollspy.scss","webpack://./src/assets/scss/components/_reboot.scss","webpack://./src/assets/scss/components/_alerts.scss","webpack://./src/assets/scss/components/_backgrounds.scss","webpack://./src/assets/scss/components/_badge.scss","webpack://./src/assets/scss/components/_buttons.scss","webpack://./src/assets/scss/components/_breadcrumb.scss","webpack://./src/assets/scss/components/_card.scss","webpack://./src/assets/scss/components/_dropdown.scss","webpack://./src/assets/scss/components/_nav.scss","webpack://./src/assets/scss/components/_table.scss","webpack://./src/assets/scss/components/_modal.scss","webpack://./src/assets/scss/components/_pagination.scss","webpack://./src/assets/scss/components/_progress.scss","webpack://./src/assets/scss/components/_popover.scss","webpack://./src/assets/scss/components/_type.scss","webpack://./src/assets/scss/components/_form-check.scss","webpack://./src/assets/scss/components/_form-control.scss","webpack://./src/assets/scss/components/_list-group.scss","webpack://./src/assets/scss/plugins/_custom-scrollbar.scss","webpack://./src/assets/scss/plugins/_prismjs.scss","webpack://./src/assets/scss/plugins/_sweetalert2.scss","webpack://./src/assets/scss/plugins/_dropzone.scss","webpack://./src/assets/scss/plugins/_range-slider.scss","webpack://./src/assets/scss/plugins/_sortablejs.scss","webpack://./src/assets/scss/plugins/_tour.scss","webpack://./src/assets/scss/plugins/_swiper.scss","webpack://./src/assets/scss/plugins/_multijs.scss","webpack://./src/assets/scss/plugins/_colorpicker.scss","webpack://./src/assets/scss/plugins/_filepond.scss","webpack://./src/assets/scss/plugins/_form-input-spin.scss","webpack://./src/assets/scss/plugins/_ckeditor.scss","webpack://./src/assets/scss/plugins/_quilljs.scss","webpack://./src/assets/scss/plugins/_gridjs.scss","webpack://./src/assets/scss/plugins/_listjs.scss","webpack://./src/assets/scss/plugins/_apexcharts.scss","webpack://./src/assets/scss/plugins/_chartjs.scss","webpack://./src/assets/scss/plugins/_echarts.scss","webpack://./src/assets/scss/plugins/_google-map.scss","webpack://./src/assets/scss/plugins/_autocomplete.scss","webpack://./src/assets/scss/plugins/_vector-maps.scss","webpack://./src/assets/scss/plugins/_leaflet-maps.scss","webpack://./src/assets/scss/plugins/_fullcalendar.scss","webpack://./src/assets/scss/plugins/_emoji-picker.scss","webpack://./src/assets/scss/plugins/_toastify.scss","webpack://./src/assets/scss/plugins/_choices.scss","webpack://./src/assets/scss/plugins/_flatpicker.scss","webpack://./src/assets/scss/pages/_authentication.scss","webpack://./src/assets/scss/pages/_dashboard.scss","webpack://./src/assets/scss/pages/_timeline.scss","webpack://./src/assets/scss/pages/_gallery.scss","webpack://./src/assets/scss/pages/_errors.scss","webpack://./src/assets/scss/pages/_profile.scss","webpack://./src/assets/scss/pages/_sitemap.scss","webpack://./src/assets/scss/pages/_team.scss","webpack://./src/assets/scss/pages/_coming-soon.scss","webpack://./src/assets/scss/pages/_search-results.scss","webpack://./src/assets/scss/pages/_ecommerce.scss","webpack://./src/assets/scss/pages/_invoice.scss","webpack://./src/assets/scss/pages/_chat.scss","webpack://./src/assets/scss/pages/_email.scss","webpack://./src/assets/scss/pages/_kanban.scss","webpack://./src/assets/scss/pages/_landing.scss","webpack://./src/assets/scss/config/modern/custom.scss"],"names":[],"mappings":"AAAA,gBAAgB;ACAhB;;;;;;;CDQC;AERD,4BAAA;AACA;EACE,oCAAoC;EACpC,4CAAmE;EACnE,qPAA2V;EAC3V,mBAAmB;EACnB,kBAAkB,EAAA;;AAGpB;;EAEE,qBAAqB;EACrB,yDAAyD;EACzD,kBAAkB;EAClB,oBAAoB;EACpB,oBAAoB;EACpB,mCAAmC;EACnC,kCAAkC,EAAA;;AAGpC;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,gBAAgB;EAChB,kBAAkB,EAAA;;AAGpB;EACE,eAAe,EAAA;;AAGjB;EACE,eAAe,EAAA;;AAGjB;EACE,eAAe,EAAA;;AAGjB;EACE,eAAe,EAAA;;AAGjB;EACE,0BAA0B,EAAA;;AAG5B;EACE,0BAA0B,EAAA;;AAG5B;EACE,YAAY,EAAA;;AAGd;EACE,+BAA+B,EAAA;;AAGjC;EACE;;;;;;;;;;;;;;;SFj7MO,EEg8MC;;AAGV;EAGE,wBAAwB,EAAA;;AAG1B;EACE;;;;;;;;;;;;;;;SFn7MO,EEk8MC;;AAGV;EAGE,wBAAwB,EAAA;;AAG1B;EACE;;;;;;;;;;;;;;;SFr7MO,EEo8MC;;AAGV;EAGE,yBAAyB,EAAA;;AAG3B;EACE;;;;;;;;;;;;;;;SFv7MO,EEs8MC;;AAGV;EAGE,yBAAyB,EAAA;;AAG3B;EACE;;;;;;;;;;;;;;;SFz7MO,EEw8MC;;AAGV;EAGE,yBAAyB,EAAA;;AAG3B;EACE;;;;;;;;;;;;;;;SF37MO,EE08MC;;AAGV;EAGE,yBAAyB,EAAA;;AAG3B;EACE;;;;;;;;;;;;;;;SF77MO,EE48MC;;AAGV;EAGE,yBAAyB,EAAA;;AAG3B;EAEE,qBAAqB;EACrB,aAAa;EACb,mBAAmB,EAAA;;AAGrB;EAEE,qBAAqB;EACrB,aAAa;EACb,mBAAmB,EAAA;;AAGrB;EAEE,sCAAsC,EAAA;;AAcxC;EACE;IAEE,uBAAuB,EAAA;EAEzB;IAEE,yBAAyB,EAAA,EAAA;;AAI7B,kDAAA;AC3h0BA;EAEI,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAElB,4CAAuC;EACvC,4SAI0D,EAAA;;AAE9D;EAEI,kCAAkC;EAClC,mBAAmB;EACnB,kBAAkB;EAClB,6BAAoB;EAApB,oBAAoB;EACpB,cAAc;EACd,oBAAoB;EACpB,qBAAqB;EAErB,oBAAoB;EAEpB,WAAW;EACX,mCAAmC;EACnC,kCAAkC,EAAA;;AAEtC;EAEI,gBAAgB;EAChB,eAAe;EAEf,gBAAgB,EAAA;;AAEpB;EAEI,kBAAkB,EAAA;;AAEtB;EAEI,kBAAkB;EAClB,oBAAoB;EAEpB,kBAAkB;EAClB,UAAU;EAEV,UAAU;EAEV,kBAAkB,EAAA;;AAetB;EAEI;IAGY,oBAAoB,EAAA;EAEhC;IAGY,yBAAyB,EAAA,EAAA;;AAoBzC;EAEI;IAGY,mBAAmB;IAE3B,UAAU,EAAA;EAEd;IAGY,qBAAqB;IAE7B,UAAU,EAAA,EAAA;;AAkBlB;EAEI;IAEI,UAAU,EAAA;EAEd;IAEI,UAAU,EAAA;EAEd;IAEI,UAAU,EAAA,EAAA;;AAoBlB;EAEI;IAGY,wBAAwB;IAEhC,UAAU,EAAA;EAEd;IAGY,4BAA4B;IAEpC,UAAU,EAAA,EAAA;;AAoBlB;EAEI;IAGY,wBAAwB;IAEhC,UAAU,EAAA;EAEd;IAGY,2BAA2B;IAEnC,UAAU,EAAA,EAAA;;AAoBlB;EAEI;IAGY,wBAAwB;IAEhC,UAAU,EAAA;EAEd;IAGY,4BAA4B;IAEpC,UAAU,EAAA,EAAA;;AAoBlB;EAEI;IAGY,wBAAwB;IAEhC,UAAU,EAAA;EAEd;IAGY,2BAA2B;IAEnC,UAAU,EAAA,EAAA;;AA0ClB;EAEI;IAGY,2BAA2B,EAAA;EAGvC;;IAIY,8DAA2D,EAAA;EAGvE;;;;IAMY,oDAAoD,EAAA;EAGhE;;;IAKY,oCAAoC,EAAA;EAGhD;IAGY,2BAA2B,EAAA,EAAA;;AAG3C;EAGY,kCAAkC,EAAA;;AAE9C;EAGY,kCAAkC,EAAA;;AAG9C;EAGY,kCAAkC,EAAA;;AAE9C;EAGY,kCAAkC,EAAA;;AAG9C;EAGY,wCAAwC,EAAA;;AAEpD;EAGY,wCAAwC,EAAA;;AAGpD;EAGY,qCAAqC,EAAA;;AAEjD;EAGY,qCAAqC,EAAA;;AAEjD;EAGY,uCAAuC,EAAA;;AAEnD;EAGY,uCAAuC,EAAA;;AAEnD;EAGY,yCAAyC,EAAA;;AAErD;EAGY,yCAAyC,EAAA;;AAErD;EAGY,yCAAyC,EAAA;;AAErD;EAGY,yCAAyC,EAAA;;AAErD;EAGY,0CAA0C,EAAA;;AAEtD;EAGY,0CAA0C,EAAA;;AAEtD;EAEI,0BAAyB,EAAA;;AAE7B;EAEI,6BAA4B,EAAA;;AAEhC;EAEI,6BAA4B,EAAA;;AAEhC;EAEI,0BAA2B,EAAA;;AAE/B;EAEI,yBAAyB;EACzB,iBAAiB;EAEjB,qBAAqB;EACrB,YAAY;EACZ,6BAA2B;EAE3B,sBAAsB,EAAA;;AAE1B;EAEI,WAAW;EAEX,8BAA4B,EAAA;;AAEhC;EAEI,YAAY;EAEZ,6BAA2B,EAAA;;AAE/B;EAEI,wBAAwB;EAExB,sEAAsE,EAAA;;AAE1E;EAEI,yBAAyB;EAEzB,sEAAsE,EAAA;;AAE1E;EAEI,yBAAyB;EAEzB,sEAAsE,EAAA;;AAE1E;EAEI,qBAAqB;EAErB,gFAAgF,EAAA;;AAEpF;EAEI,qBAAqB;EAErB,gFAAgF,EAAA;;AAEpF;EAEI,cAAc;EAEd,uCAAkC;EAClC,oBAAoB,EAAA;;AAExB;EAEI,cAAc;EAEd,uCAAkC;EAClC,kBAAkB,EAAA;;AAIpB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;ACzoKpB;;;;;;EAME,kCAAkC;EAClC,mCAAmC;EACnC,qBAAqB;EACrB,kBAAkB;EAClB,6BAAoB;EAApB,oBAAoB;EACpB,oBAAoB;EACpB,cAAc,EAAA;;AAEhB;EACE,oBAAoB;EACpB,mBAAmB;EACnB,wBAAwB,EAAA;;AAE1B;EACE,gBAAgB,EAAA;;AAElB;EACE,iBAAiB,EAAA;;AAEnB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,cAAc,EAAA;;AAEhB;EACE,eAAe,EAAA;;AAEjB;EACE,kBAAkB;EAClB,aAAa,EAAA;;AAEf;EACE,qBAAqB;EACrB,kBAAkB;EAClB,eAAe,EAAA;;AACf;EACE,kBAAkB,EAAA;;AAEtB;EACE,UAAU;EACV,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,oBAAoB,EAAA;;AAEtB;EACE,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB,EAAA;;AAE3B;EACE,WAAW,EAAA;;AAEb;EACE,YAAY,EAAA;;AAEd;;;;;EAKE,kBAAkB,EAAA;;AAEpB;;;;;EAKE,iBAAiB,EAAA;;AAEnB;EAEU,qCAAqC,EAAA;;AAE/C;EAEU,uCAAuC,EAAA;;AAUjD;EACE;IAEU,uBAAuB,EAAA;EACjC;IAEU,yBAAyB,EAAA,EAAA;;AAErC;EACE,sEAAsE;EAE9D,wBAAwB,EAAA;;AAElC;EACE,sEAAsE;EAE9D,yBAAyB,EAAA;;AAEnC;EACE,sEAAsE;EAE9D,yBAAyB,EAAA;;AAEnC;EACE,gFAAgF;EAExE,uBAAuB,EAAA;;AAEjC;EACE,gFAAgF;EAExE,uBAAuB,EAAA;;AAEjC;EACE,gFAAgF;EAExE,wBAAwB,EAAA;;AAElC;;;;;;EAOU,YAAY,EAAA;;AAEtB;EACE,qBAAqB;EACrB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,YAAY,EAAA;;AAEd;;EAEE,OAAO;EACP,kBAAkB;EAClB,kBAAkB;EAClB,WAAW,EAAA;;AAEb;EACE,oBAAoB,EAAA;;AAEtB;EACE,cAAc,EAAA;;AAEhB;EACE,WAAW,EAAA;;AAEb;gEJuhxBgE;AIrhxBhE;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,SAAS;EACT,sBAAsB;EACtB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,UAAU;EACV,kBAAkB;EAClB,UAAU,EAAA;;AAEZ;EACE,UAAU;EACV,YAAY;EACZ,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,WAAW,EAAA;;AACb;EACE,kCAAkC;EAClC,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;EAClB,6CAA4C;EAC5C,iTAAkU,EAAA;;AAEpU;EACE,kCAAkC,EAAA;;AACpC;EACE,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,6CAA6C;EAC7C,iTAAuU,EAAA;;AAEzU;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAClB;EACE,gCAAgC;EAChC,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,6CAA2C;EAC3C,iTAA6T,EAAA;;AAE/T;;EAEE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,gCAAgC;EAChC,gBAAgB,EAAA;;AAElB;EACE,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;AAElB;EACE,kCAAkC;EAClC,gBAAgB,EAAA;;ACr7MlB;;;;;;;;;CLy99BC;AK/89BD;EACE,wBAAwB;EACxB,6CAAwD;EAAE,OAAA;EAC1D,iTAI2E;EAAE,aAAA;EAC7E,kBAAkB,EAAA;;ALg99BpB;EK589BE,mCAAmC;EACnC,kBAAkB;EAClB,mCAAmC;EACnC,kCAAkC,EAAA;;AAGpC;EAAS,mBAAmB;EAAE,mBAAmB;EAAE,wBAAwB,EAAA;;AAC3E;EAAS,gBAAgB;EAAE,qBAAqB;EAAE,uBAAuB,EAAA;;AACzE;EAAU,eAAe,EAAA;;AACzB;EAAS,gBAAgB,EAAA;;AACzB;EAAS,iBAAkB,EAAA;;AAC3B;EAAS,cAAc,EAAA;;AACvB;EAAS,cAAc,EAAA;;AACvB;EAAS,cAAc,EAAA;;AACvB;EAAS,cAAc,EAAA;;AACvB;EAAS,cAAc,EAAA;;AACvB;EAAS,cAAc,EAAA;;AACvB;EAAS,cAAc,EAAA;;AACvB;EAAS,cAAc,EAAA;;AACvB;EAAS,cAAc,EAAA;;AACvB;EAAU,eAAe,EAAA;;AACzB;EAAS,kBAAkB;EAAE,aAAa,EAAA;;AAE1C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAqB,gBAAgB,EAAA;;AACrC;EAAqB,gBAAgB,EAAA;;AACrC;EAAiB,gBAAgB,EAAA;;AACjC;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAAkC,gBAAgB,EAAA;;AAClD;EAAkC,gBAAgB,EAAA;;AAClD;EAAqC,gBAAgB,EAAA;;AACrD;EAAqC,gBAAgB,EAAA;;AACrD;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAsB,gBAAgB,EAAA;;AACtC;EAAsB,gBAAgB,EAAA;;AACtC;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAwB,gBAAgB,EAAA;;AACxC;EAAyB,gBAAgB,EAAA;;AACzC;EAAuB,gBAAgB,EAAA;;AACvC;EAA8B,gBAAgB,EAAA;;AAC9C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAAmC,gBAAgB,EAAA;;AACnD;EAAmC,gBAAgB,EAAA;;AACnD;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAkC,gBAAgB,EAAA;;AAClD;EAAkC,gBAAgB,EAAA;;AAClD;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAoC,gBAAgB,EAAA;;AACpD;EAAoC,gBAAgB,EAAA;;AACpD;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAAkC,gBAAgB,EAAA;;AAClD;EAAkC,gBAAgB,EAAA;;AAClD;EAAkC,gBAAgB,EAAA;;AAClD;EAAkC,gBAAgB,EAAA;;AAClD;EAAmC,gBAAgB,EAAA;;AACnD;EAAmC,gBAAgB,EAAA;;AACnD;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAmC,gBAAgB,EAAA;;AACnD;EAAmC,gBAAgB,EAAA;;AACnD;EAAoC,gBAAgB,EAAA;;AACpD;EAAoC,gBAAgB,EAAA;;AACpD;EAAkC,gBAAgB,EAAA;;AAClD;EAAkC,gBAAgB,EAAA;;AAClD;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAmC,gBAAgB,EAAA;;AACnD;EAAmC,gBAAgB,EAAA;;AACnD;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAqC,gBAAgB,EAAA;;AACrD;EAAqC,gBAAgB,EAAA;;AACrD;EAAmC,gBAAgB,EAAA;;AACnD;EAAmC,gBAAgB,EAAA;;AACnD;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAAkC,gBAAgB,EAAA;;AAClD;EAAkC,gBAAgB,EAAA;;AAClD;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAAsB,gBAAgB,EAAA;;AACtC;EAAqB,gBAAgB,EAAA;;AACrC;EAAqB,gBAAgB,EAAA;;AACrC;EAA0B,gBAAgB,EAAA;;AAC1C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAA4B,gBAAgB,EAAA;;AAC5C;EAAoC,gBAAgB,EAAA;;AACpD;EAAoC,gBAAgB,EAAA;;AACpD;EAAuC,gBAAgB,EAAA;;AACvD;EAAuC,gBAAgB,EAAA;;AACvD;EAA4B,gBAAgB,EAAA;;AAC5C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAmC,gBAAgB,EAAA;;AACnD;EAAmC,gBAAgB,EAAA;;AACnD;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAoC,gBAAgB,EAAA;;AACpD;EAAoC,gBAAgB,EAAA;;AACpD;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAkB,gBAAgB,EAAA;;AAClC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAsB,gBAAgB,EAAA;;AACtC;EAAsB,gBAAgB,EAAA;;AACtC;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAsB,gBAAgB,EAAA;;AACtC;EAAsB,gBAAgB,EAAA;;AACtC;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAyB,gBAAgB,EAAA;;AACzC;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAyB,gBAAgB,EAAA;;AACzC;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAsB,gBAAgB,EAAA;;AACtC;EAAsB,gBAAgB,EAAA;;AACtC;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAwC,gBAAgB,EAAA;;AACxD;EAAwC,gBAAgB,EAAA;;AACxD;EAAkC,gBAAgB,EAAA;;AAClD;EAAkC,gBAAgB,EAAA;;AAClD;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAwC,gBAAgB,EAAA;;AACxD;EAAwC,gBAAgB,EAAA;;AACxD;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAAkC,gBAAgB,EAAA;;AAClD;EAAkC,gBAAgB,EAAA;;AAClD;EAA2B,gBAAgB,EAAA;;AAC3C;EAAyC,gBAAgB,EAAA;;AACzD;EAAyC,gBAAgB,EAAA;;AACzD;EAA2B,gBAAgB,EAAA;;AAC3C;EAA0C,gBAAgB,EAAA;;AAC1D;EAA0C,gBAAgB,EAAA;;AAC1D;EAAoC,gBAAgB,EAAA;;AACpD;EAAoC,gBAAgB,EAAA;;AACpD;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAoC,gBAAgB,EAAA;;AACpD;EAAoC,gBAAgB,EAAA;;AACpD;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAAuB,gBAAgB,EAAA;;AACvC;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAmC,gBAAgB,EAAA;;AACnD;EAAmC,gBAAgB,EAAA;;AACnD;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAkC,gBAAgB,EAAA;;AAClD;EAAkC,gBAAgB,EAAA;;AAClD;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAuC,gBAAgB,EAAA;;AACvD;EAAuC,gBAAgB,EAAA;;AACvD;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAkC,gBAAgB,EAAA;;AAClD;EAAkC,gBAAgB,EAAA;;AAClD;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAsB,gBAAgB,EAAA;;AACtC;EAAsB,gBAAgB,EAAA;;AACtC;EAAsC,gBAAgB,EAAA;;AACtD;EAAsC,gBAAgB,EAAA;;AACtD;EAAmC,gBAAgB,EAAA;;AACnD;EAAmC,gBAAgB,EAAA;;AACnD;EAAsC,gBAAgB,EAAA;;AACtD;EAAsC,gBAAgB,EAAA;;AACtD;EAAsC,gBAAgB,EAAA;;AACtD;EAAsC,gBAAgB,EAAA;;AACtD;EAAsC,gBAAgB,EAAA;;AACtD;EAAsC,gBAAgB,EAAA;;AACtD;EAAwC,gBAAgB,EAAA;;AACxD;EAAwC,gBAAgB,EAAA;;AACxD;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAAsB,gBAAgB,EAAA;;AACtC;EAAsB,gBAAgB,EAAA;;AACtC;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAqC,gBAAgB,EAAA;;AACrD;EAAqC,gBAAgB,EAAA;;AACrD;EAAmC,gBAAgB,EAAA;;AACnD;EAAmC,gBAAgB,EAAA;;AACnD;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAwB,gBAAgB,EAAA;;AACxC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAmC,gBAAgB,EAAA;;AACnD;EAAmC,gBAAgB,EAAA;;AACnD;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAqB,gBAAgB,EAAA;;AACrC;EAAqB,gBAAgB,EAAA;;AACrC;EAAsB,gBAAgB,EAAA;;AACtC;EAAsB,gBAAgB,EAAA;;AACtC;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAA0B,gBAAgB,EAAA;;AAC1C;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAkC,gBAAgB,EAAA;;AAClD;EAAkC,gBAAgB,EAAA;;AAClD;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAyB,gBAAgB,EAAA;;AACzC;EAAsB,gBAAgB,EAAA;;AACtC;EAA2B,gBAAgB,EAAA;;AAC3C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAAkC,gBAAgB,EAAA;;AAClD;EAAkC,gBAAgB,EAAA;;AAClD;EAA2B,gBAAgB,EAAA;;AAC3C;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAA2B,gBAAgB,EAAA;;AAC3C;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAsB,gBAAgB,EAAA;;AACtC;EAAsB,gBAAgB,EAAA;;AACtC;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAAkC,gBAAgB,EAAA;;AAClD;EAAkC,gBAAgB,EAAA;;AAClD;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAuB,gBAAgB,EAAA;;AACvC;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAuB,gBAAgB,EAAA;;AACvC;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAAkC,gBAAgB,EAAA;;AAClD;EAAkC,gBAAgB,EAAA;;AAClD;EAAyB,gBAAgB,EAAA;;AACzC;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAAyB,gBAAgB,EAAA;;AACzC;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAkC,gBAAgB,EAAA;;AAClD;EAAkC,gBAAgB,EAAA;;AAClD;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAkC,gBAAgB,EAAA;;AAClD;EAAkC,gBAAgB,EAAA;;AAClD;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAkC,gBAAgB,EAAA;;AAClD;EAAkC,gBAAgB,EAAA;;AAClD;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAkC,gBAAgB,EAAA;;AAClD;EAAkC,gBAAgB,EAAA;;AAClD;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAwB,gBAAgB,EAAA;;AACxC;EAAyB,gBAAgB,EAAA;;AACzC;EAAuB,gBAAgB,EAAA;;AACvC;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA0B,gBAAgB,EAAA;;AAC1C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAkC,gBAAgB,EAAA;;AAClD;EAAkC,gBAAgB,EAAA;;AAClD;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAuB,gBAAgB,EAAA;;AACvC;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAmC,gBAAgB,EAAA;;AACnD;EAAmC,gBAAgB,EAAA;;AACnD;EAAyC,gBAAgB,EAAA;;AACzD;EAAyC,gBAAgB,EAAA;;AACzD;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAAyC,gBAAgB,EAAA;;AACzD;EAAyC,gBAAgB,EAAA;;AACzD;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAsB,gBAAgB,EAAA;;AACtC;EAAsB,gBAAgB,EAAA;;AACtC;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAiB,gBAAgB,EAAA;;AACjC;EAAiB,gBAAgB,EAAA;;AACjC;EAAiB,gBAAgB,EAAA;;AACjC;EAAiB,gBAAgB,EAAA;;AACjC;EAAiB,gBAAgB,EAAA;;AACjC;EAAiB,gBAAgB,EAAA;;AACjC;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAqB,gBAAgB,EAAA;;AACrC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAAqB,gBAAgB,EAAA;;AACrC;EAAqB,gBAAgB,EAAA;;AACrC;EAAqB,gBAAgB,EAAA;;AACrC;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAuB,gBAAgB,EAAA;;AACvC;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAuB,gBAAgB,EAAA;;AACvC;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAqB,gBAAgB,EAAA;;AACrC;EAAqB,gBAAgB,EAAA;;AACrC;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAqB,gBAAgB,EAAA;;AACrC;EAAqB,gBAAgB,EAAA;;AACrC;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAkC,gBAAgB,EAAA;;AAClD;EAAkC,gBAAgB,EAAA;;AAClD;EAAoC,gBAAgB,EAAA;;AACpD;EAAoC,gBAAgB,EAAA;;AACpD;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAuC,gBAAgB,EAAA;;AACvD;EAAuC,gBAAgB,EAAA;;AACvD;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAuC,gBAAgB,EAAA;;AACvD;EAAuC,gBAAgB,EAAA;;AACvD;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAAgC,gBAAgB,EAAA;;AAChD;EAAiC,gBAAgB,EAAA;;AACjD;EAA+B,gBAAgB,EAAA;;AAC/C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAoB,gBAAgB,EAAA;;AACpC;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAsB,gBAAgB,EAAA;;AACtC;EAAsB,gBAAgB,EAAA;;AACtC;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAkC,gBAAgB,EAAA;;AAClD;EAAkC,gBAAgB,EAAA;;AAClD;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAyB,gBAAgB,EAAA;;AACzC;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAyB,gBAAgB,EAAA;;AACzC;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAkC,gBAAgB,EAAA;;AAClD;EAAkC,gBAAgB,EAAA;;AAClD;EAA4B,gBAAgB,EAAA;;AAC5C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAuB,gBAAgB,EAAA;;AACvC;EAAyB,gBAAgB,EAAA;;AACzC;EAAuB,gBAAgB,EAAA;;AACvC;EAAoB,gBAAgB,EAAA;;AACpC;EAA2B,gBAAgB,EAAA;;AAC3C;EAAyB,gBAAgB,EAAA;;AACzC;EAAkB,gBAAgB,EAAA;;AAClC;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA0B,gBAAgB,EAAA;;AAC1C;EAAwB,gBAAgB,EAAA;;AACxC;EAA0B,gBAAgB,EAAA;;AAC1C;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAA4B,gBAAgB,EAAA;;AAC5C;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAkC,gBAAgB,EAAA;;AAClD;EAAkC,gBAAgB,EAAA;;AAClD;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAAkC,gBAAgB,EAAA;;AAClD;EAAkC,gBAAgB,EAAA;;AAClD;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAsB,gBAAgB,EAAA;;AACtC;EAAsB,gBAAgB,EAAA;;AACtC;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAuB,gBAAgB,EAAA;;AACvC;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAuB,gBAAgB,EAAA;;AACvC;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAsB,gBAAgB,EAAA;;AACtC;EAAsB,gBAAgB,EAAA;;AACtC;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAkC,gBAAgB,EAAA;;AAClD;EAAkC,gBAAgB,EAAA;;AAClD;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAsB,gBAAgB,EAAA;;AACtC;EAAsB,gBAAgB,EAAA;;AACtC;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAuB,gBAAgB,EAAA;;AACvC;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAuB,gBAAgB,EAAA;;AACvC;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAoC,gBAAgB,EAAA;;AACpD;EAAkC,gBAAgB,EAAA;;AAClD;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAsB,gBAAgB,EAAA;;AACtC;EAAsB,gBAAgB,EAAA;;AACtC;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAsB,gBAAgB,EAAA;;AACtC;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAmC,gBAAgB,EAAA;;AACnD;EAAmC,gBAAgB,EAAA;;AACnD;EAAmC,gBAAgB,EAAA;;AACnD;EAAmC,gBAAgB,EAAA;;AACnD;EAAsC,gBAAgB,EAAA;;AACtD;EAAsC,gBAAgB,EAAA;;AACtD;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAAoC,gBAAgB,EAAA;;AACpD;EAAoC,gBAAgB,EAAA;;AACpD;EAAkC,gBAAgB,EAAA;;AAClD;EAAkC,gBAAgB,EAAA;;AAClD;EAAqC,gBAAgB,EAAA;;AACrD;EAAqC,gBAAgB,EAAA;;AACrD;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAuB,gBAAgB,EAAA;;AACvC;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAuB,gBAAgB,EAAA;;AACvC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAqB,gBAAgB,EAAA;;AACrC;EAAqB,gBAAgB,EAAA;;AACrC;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAsC,gBAAgB,EAAA;;AACtD;EAAsC,gBAAgB,EAAA;;AACtD;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAuB,gBAAgB,EAAA;;AACvC;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAAqC,gBAAgB,EAAA;;AACrD;EAAqC,gBAAgB,EAAA;;AACrD;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAAmC,gBAAgB,EAAA;;AACnD;EAAmC,gBAAgB,EAAA;;AACnD;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAsB,gBAAgB,EAAA;;AACtC;EAAsB,gBAAgB,EAAA;;AACtC;EAAsB,gBAAgB,EAAA;;AACtC;EAAsB,gBAAgB,EAAA;;AACtC;EAAsB,gBAAgB,EAAA;;AACtC;EAAsB,gBAAgB,EAAA;;AACtC;EAAsB,gBAAgB,EAAA;;AACtC;EAAsB,gBAAgB,EAAA;;AACtC;EAAsB,gBAAgB,EAAA;;AACtC;EAAsB,gBAAgB,EAAA;;AACtC;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAsB,gBAAgB,EAAA;;AACtC;EAAsB,gBAAgB,EAAA;;AACtC;EAAmB,gBAAgB,EAAA;;AACnC;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAgC,gBAAgB,EAAA;;AAChD;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA4B,gBAAgB,EAAA;;AAC5C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAuB,gBAAgB,EAAA;;AACvC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAAwB,gBAAgB,EAAA;;AACxC;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAwB,gBAAgB,EAAA;;AACxC;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAuC,gBAAgB,EAAA;;AACvD;EAAuC,gBAAgB,EAAA;;AACvD;EAA0C,gBAAgB,EAAA;;AAC1D;EAA0C,gBAAgB,EAAA;;AAC1D;EAAqC,gBAAgB,EAAA;;AACrD;EAAqC,gBAAgB,EAAA;;AACrD;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAqB,gBAAgB,EAAA;;AACrC;EAAqB,gBAAgB,EAAA;;AACrC;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAkC,gBAAgB,EAAA;;AAClD;EAAkC,gBAAgB,EAAA;;AAClD;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAmC,gBAAgB,EAAA;;AACnD;EAAmC,gBAAgB,EAAA;;AACnD;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAsB,gBAAgB,EAAA;;AACtC;EAAsB,gBAAgB,EAAA;;AACtC;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAsB,gBAAgB,EAAA;;AACtC;EAAsB,gBAAgB,EAAA;;AACtC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAuB,gBAAgB,EAAA;;AACvC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAAwB,gBAAgB,EAAA;;AACxC;EAAkC,gBAAgB,EAAA;;AAClD;EAAkC,gBAAgB,EAAA;;AAClD;EAAoC,gBAAgB,EAAA;;AACpD;EAAoC,gBAAgB,EAAA;;AACpD;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAwB,gBAAgB,EAAA;;AACxC;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAAyB,gBAAgB,EAAA;;AACzC;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAAyB,gBAAgB,EAAA;;AACzC;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAAoC,gBAAgB,EAAA;;AACpD;EAAoC,gBAAgB,EAAA;;AACpD;EAAkC,gBAAgB,EAAA;;AAClD;EAAkC,gBAAgB,EAAA;;AAClD;EAAkC,gBAAgB,EAAA;;AAClD;EAAkC,gBAAgB,EAAA;;AAClD;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAoC,gBAAgB,EAAA;;AACpD;EAAoC,gBAAgB,EAAA;;AACpD;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAkC,gBAAgB,EAAA;;AAClD;EAAkC,gBAAgB,EAAA;;AAClD;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAsB,gBAAgB,EAAA;;AACtC;EAAsB,gBAAgB,EAAA;;AACtC;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAAoC,gBAAgB,EAAA;;AACpD;EAAoC,gBAAgB,EAAA;;AACpD;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAsB,gBAAgB,EAAA;;AACtC;EAAuB,gBAAgB,EAAA;;AACvC;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAmB,gBAAgB,EAAA;;AACnC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAoC,gBAAgB,EAAA;;AACpD;EAAkC,gBAAgB,EAAA;;AAClD;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAsB,gBAAgB,EAAA;;AACtC;EAAsB,gBAAgB,EAAA;;AACtC;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAuB,gBAAgB,EAAA;;AACvC;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAuB,gBAAgB,EAAA;;AACvC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA6B,gBAAgB,EAAA;;AAC7C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAyB,gBAAgB,EAAA;;AACzC;EAAuB,gBAAgB,EAAA;;AACvC;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAsB,gBAAgB,EAAA;;AACtC;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAsB,gBAAgB,EAAA;;AACtC;EAA2B,gBAAgB,EAAA;;AAC3C;EAAyB,gBAAgB,EAAA;;AACzC;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAqB,gBAAgB,EAAA;;AACrC;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAkC,gBAAgB,EAAA;;AAClD;EAAkC,gBAAgB,EAAA;;AAClD;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAuB,gBAAgB,EAAA;;AACvC;EAAkB,gBAAgB,EAAA;;AAClC;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAwB,gBAAgB,EAAA;;AACxC;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAwB,gBAAgB,EAAA;;AACxC;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAyB,gBAAgB,EAAA;;AACzC;EAAuB,gBAAgB,EAAA;;AACvC;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAAqB,gBAAgB,EAAA;;AACrC;EAAqB,gBAAgB,EAAA;;AACrC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAuB,gBAAgB,EAAA;;AACvC;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAsB,gBAAgB,EAAA;;AACtC;EAAsB,gBAAgB,EAAA;;AACtC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAuB,gBAAgB,EAAA;;AACvC;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAuB,gBAAgB,EAAA;;AACvC;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAkC,gBAAgB,EAAA;;AAClD;EAAkC,gBAAgB,EAAA;;AAClD;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAgC,gBAAgB,EAAA;;AAChD;EAAgC,gBAAgB,EAAA;;AAChD;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA+B,gBAAgB,EAAA;;AAC/C;EAA+B,gBAAgB,EAAA;;AAC/C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAsB,gBAAgB,EAAA;;AACtC;EAAsB,gBAAgB,EAAA;;AACtC;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAAoC,gBAAgB,EAAA;;AACpD;EAAoC,gBAAgB,EAAA;;AACpD;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAqC,gBAAgB,EAAA;;AACrD;EAAqC,gBAAgB,EAAA;;AACrD;EAA4B,gBAAgB,EAAA;;AAC5C;EAA4B,gBAAgB,EAAA;;AAC5C;EAAiC,gBAAgB,EAAA;;AACjD;EAAiC,gBAAgB,EAAA;;AACjD;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA8B,gBAAgB,EAAA;;AAC9C;EAA8B,gBAAgB,EAAA;;AAC9C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA6B,gBAAgB,EAAA;;AAC7C;EAA6B,gBAAgB,EAAA;;AAC7C;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAyB,gBAAgB,EAAA;;AACzC;EAAyB,gBAAgB,EAAA;;AACzC;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAoC,gBAAgB,EAAA;;AACpD;EAAoC,gBAAgB,EAAA;;AACpD;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAAuB,gBAAgB,EAAA;;AACvC;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAAwB,gBAAgB,EAAA;;AACxC;EAA0B,gBAAgB,EAAA;;AAC1C;EAA0B,gBAAgB,EAAA;;AAC1C;EAA2B,gBAAgB,EAAA;;AAC3C;EAA2B,gBAAgB,EAAA;;AAC3C;EAAsB,gBAAgB,EAAA;;AACtC;EAAsB,gBAAgB,EAAA;;AC3wEtC;;;;;;;CNisrCC;AOhsrCC;;;;;IPssrCE;AQvsrCJ;EAQI,kBAAwB;EAAxB,oBAAwB;EAAxB,oBAAwB;EAAxB,kBAAwB;EAAxB,iBAAwB;EAAxB,oBAAwB;EAAxB,oBAAwB;EAAxB,mBAAwB;EAAxB,kBAAwB;EAAxB,kBAAwB;EAAxB,gBAAwB;EAAxB,kBAAwB;EAAxB,uBAAwB;EAIxB,sBAAkC;EAAlC,sBAAkC;EAAlC,sBAAkC;EAAlC,sBAAkC;EAAlC,sBAAkC;EAAlC,sBAAkC;EAAlC,sBAAkC;EAAlC,sBAAkC;EAAlC,sBAAkC;EAIlC,qBAAwB;EAAxB,uBAAwB;EAAxB,qBAAwB;EAAxB,kBAAwB;EAAxB,qBAAwB;EAAxB,oBAAwB;EAAxB,mBAAwB;EAAxB,kBAAwB;EAIxB,8BAAgC;EAAhC,iCAAgC;EAAhC,8BAAgC;EAAhC,2BAAgC;EAAhC,8BAAgC;EAAhC,4BAAgC;EAAhC,6BAAgC;EAAhC,yBAAgC;EAGlC,6BAAiC;EACjC,uBAAiC;EACjC,+BAA2C;EAC3C,+BAAqC;EAMrC,2CAA6C;EAC7C,yGAA2C;EAC3C,yFAA+B;EAO/B,gDAA+C;EC4P3C,6BAvE+B;EDnLnC,0BAA+C;EAC/C,0BAA+C;EAC/C,wBAAmC;EAInC,qBAA6B;EAI7B,sBAAuC;EACvC,wBAAuC;EACvC,yCAAuC;EACvC,mDAA+D;EAE/D,2BAAyC;EACzC,6BAA+C;EAC/C,6BAA+C;EAC/C,2BAA+C;EAC/C,4BAAiD;EACjD,8BAAmD;EAGnD,qCAAmC;EACnC,iDAA+C;EAE/C,wBAAmC;EAEnC,0BAAuC,EAAA;;AExDzC;;;EAGE,sBAAsB,EAAA;;AAepB;EFjCJ;IEkCM,uBAAuB,EAAA,EAG5B;;AAWD;EACE,SAAS;EACT,uCAAgE;EDmP5D,mCAvE+B;EC1KnC,uCAAgE;EAChE,uCAAgE;EAChE,2BAA8C;EAC9C,qCAA6D;EAC7D,mCAAmD;EACnD,8BAA8B;EAC9B,6CCiGa,EAAA;;ADxFf;EACE,cAAsB;EACtB,cCotBmC;EDntBnC,SAAS;EACT,qBAAkC;EAClC,aCmtB+B,EAAA;;ADzsBjC;EACE,aAAa;EACb,qBC6pBwC;ED1pBxC,gBC6pB+B;ED5pB/B,gBC6pB+B,EAAA;;ADzpBjC;ED6MQ,qCAf6B,EAAA;EAnJjC;IC3CJ;MDoNQ,oBAlF6B,EAAA,EC/HpC;;AAED;EDwMQ,+BAf6B,EAAA;EAnJjC;ICtCJ;MD+MQ,kBAlF6B,EAAA,EC1HpC;;AAED;EDmMQ,sCAf6B,EAAA;EAnJjC;ICjCJ;MD0MQ,qBAlF6B,EAAA,ECrHpC;;AAED;ED8LQ,qCAf6B,EAAA;EAnJjC;IC5BJ;MDqMQ,oBAlF6B,EAAA,EChHpC;;AAED;EDqLM,qBAvE+B,EAAA;;ACzGrC;EDgLM,mBAvE+B,EAAA;;AC9FrC;EACE,aAAa;EACb,mBC0c8B,EAAA;;ADhchC;EACE,yCAAiC;UAAjC,iCAAiC;EACjC,YAAY;EACZ,8BAA8B,EAAA;;AAMhC;EACE,mBAAmB;EACnB,kBAAkB;EAClB,oBAAoB,EAAA;;AAMtB;;EAEE,kBAAkB,EAAA;;AAGpB;;;EAGE,aAAa;EACb,mBAAmB,EAAA;;AAGrB;;;;EAIE,gBAAgB,EAAA;;AAGlB;EACE,gBCxDwB,EAAA;;AD6D1B;EACE,oBAAoB;EACpB,cAAc,EAAA;;AAMhB;EACE,gBAAgB,EAAA;;AAQlB;;EAEE,mBC2gBkC,EAAA;;ADngBpC;EDmFM,kBAvE+B,EAAA;;ACLrC;EACE,cCukBgC;EDtkBhC,wCAA6D,EAAA;;AAS/D;;EAEE,kBAAkB;ED+Dd,iBAvE+B;ECUnC,cAAc;EACd,wBAAwB,EAAA;;AAG1B;EAAM,cAAc,EAAA;;AACpB;EAAM,UAAU,EAAA;;AAKhB;EACE,2BAA8C;EAC9C,0BC4UiD,EAAA;ED9UnD;IAKI,iCAA0D,EAAA;;AAU9D;EAGI,cAAc;EACd,qBAAqB,EAAA;;AAOzB;;;;EAIE,qCCwboF;EFnahF,cAvE+B,EAAA;;AC0DrC;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,cAAc;EDSV,kBAvE+B,EAAA;EC0DrC;IDaM,kBAvE+B;ICqEjC,cAAc;IACd,kBAAkB,EAAA;;AAItB;EDHM,kBAvE+B;EC4EnC,2BAA8C;EAC9C,qBAAqB,EAAA;EAGrB;IACE,cAAc,EAAA;;AAIlB;EACE,sBCg7CuC;EF/7CnC,kBAvE+B;ECwFnC,WCrKa;EDsKb,yBC7JgB;ECvId,qBDmoB+B,EAAA;EDnWnC;IAQI,UAAU;IDtBR,cAvE+B;IC+FjC,gBCuZ6B,EAAA;;AD9YjC;EACE,gBAAgB,EAAA;;AAMlB;;EAEE,sBAAsB,EAAA;;AAQxB;EACE,oBAAoB;EACpB,yBAAyB,EAAA;;AAG3B;EACE,oBCqdkC;EDpdlC,uBCodkC;EDndlC,cCxMgB;EDyMhB,gBAAgB,EAAA;;AAOlB;EAEE,mBAAmB;EACnB,gCAAgC,EAAA;;AAGlC;;;;;;EAME,qBAAqB;EACrB,mBAAmB;EACnB,eAAe,EAAA;;AAQjB;EACE,qBAAqB,EAAA;;AAMvB;EAEE,gBAAgB,EAAA;;AAQlB;EACE,UAAU,EAAA;;AAKZ;;;;;EAKE,SAAS;EACT,oBAAoB;EDrHhB,kBAvE+B;EC8LnC,oBAAoB,EAAA;;AAItB;;EAEE,oBAAoB,EAAA;;AV6krCtB;EUvkrCE,eAAe,EAAA;;AAGjB;EAGE,iBAAiB,EAAA;EAHnB;IAOI,UAAU,EAAA;;AVqkrCd;EU7jrCE,wBAAwB,EAAA;;AAQ1B;;;;EAIE,0BAA0B,EAAA;EAJ5B;;;;IAQM,eAAe,EAAA;;AAOrB;EACE,UAAU;EACV,kBAAkB,EAAA;;AAKpB;EACE,gBAAgB,EAAA;;AAUlB;EACE,YAAY;EACZ,UAAU;EACV,SAAS;EACT,SAAS,EAAA;;AAQX;EACE,WAAW;EACX,WAAW;EACX,UAAU;EACV,qBC0SiC;EFpf3B,iCAf6B;EC4NnC,oBAAoB,EAAA;ED/WlB;ICwWJ;MD/LQ,iBAlF6B,EAAA,EC6RpC;EAZD;IAUI,WAAW,EAAA;;AAOf;;;;;;;EAOE,UAAU,EAAA;;AAGZ;EACE,YAAY,EAAA;;AVgirCd;EUthrCE,oBAAoB;EACpB,6BAA6B,EAAA;;AAQ/B;;;;;;;CVwhrCC;AU7grCD;EACE,wBAAwB,EAAA;;AAK1B;EACE,UAAU,EAAA;;AAOZ;EACE,aAAa;EACb,0BAA0B,EAAA;;AAK5B;EACE,qBAAqB,EAAA;;AAKvB;EACE,SAAS,EAAA;;AAOX;EACE,kBAAkB;EAClB,eAAe,EAAA;;AAQjB;EACE,wBAAwB,EAAA;;AVu/qC1B;EU9+qCE,wBAAwB,EAAA;;AGpkB1B;EJyQM,qBAvE+B;EIhMnC,gBF2uB+B,EAAA;;AEtuB/B;EJsQM,iCAf6B;EInPjC,gBF4tBqB;EE3tBrB,gBF6sB6B,EAAA;EF9mB7B;IIpGF;MJ6QM,eAlF6B,EAAA,EIrLlC;;AAND;EJsQM,iCAf6B;EInPjC,gBF4tBqB;EE3tBrB,gBF6sB6B,EAAA;EF9mB7B;IIpGF;MJ6QM,iBAlF6B,EAAA,EIrLlC;;AAND;EJsQM,iCAf6B;EInPjC,gBF4tBqB;EE3tBrB,gBF6sB6B,EAAA;EF9mB7B;IIpGF;MJ6QM,eAlF6B,EAAA,EIrLlC;;AAND;EJsQM,iCAf6B;EInPjC,gBF4tBqB;EE3tBrB,gBF6sB6B,EAAA;EF9mB7B;IIpGF;MJ6QM,iBAlF6B,EAAA,EIrLlC;;AAND;EJsQM,iCAf6B;EInPjC,gBF4tBqB;EE3tBrB,gBF6sB6B,EAAA;EF9mB7B;IIpGF;MJ6QM,eAlF6B,EAAA,EIrLlC;;AAND;EJsQM,iCAf6B;EInPjC,gBF4tBqB;EE3tBrB,gBF6sB6B,EAAA;EF9mB7B;IIpGF;MJ6QM,iBAlF6B,EAAA,EIrLlC;;AAkBH;ECvDE,eAAe;EACf,gBAAgB,EAAA;;AD2DlB;EC5DE,eAAe;EACf,gBAAgB,EAAA;;AD8DlB;EACE,qBAAqB,EAAA;EADvB;IAII,oBFguB+B,EAAA;;AEttBnC;EJoNM,kBAvE+B;EI3InC,yBAAyB,EAAA;;AAI3B;EACE,mBFiaW;EFpNP,oBAvE+B,EAAA;EIvIrC;IAKI,gBAAgB,EAAA;;AAIpB;EACE,iBFwZW;EEvZX,mBFuZW;EFpNP,kBAvE+B;EI1HnC,cFmDgB,EAAA;EEvDlB;IAOI,qBAAqB,EAAA;;AEhGzB;ECIE,eAAe;EAGf,YAAY,EAAA;;ADDd;EACE,gBJulDwC;EItlDxC,mCJulD4E;EItlD5E,wCJwlDsF;ECrlDpF,sBDkoBgC;EK1oBlC,eAAe;EAGf,YAAY,EAAA;;ADcd;EAEE,qBAAqB,EAAA;;AAGvB;EACE,qBAA2B;EAC3B,cAAc,EAAA;;AAGhB;EN+PM,kBAvE+B;EMtLnC,cJ+GgB,EAAA;;AMjJhB;;;;;;;ECHA,sBAA+B;EAC/B,gBAA+B;EAC/B,WAAW;EACX,4CAA6D;EAC7D,2CAA4D;EAC5D,kBAAkB;EAClB,iBAAiB,EAAA;;ACsDf;EF5CE;IACE,gBNqlBG,EAAA,EMplBJ;;AE0CH;EF5CE;IACE,gBNslBG,EAAA,EMrlBJ;;AE0CH;EF5CE;IACE,gBNulBG,EAAA,EMtlBJ;;AE0CH;EF5CE;IACE,iBNwlBI,EAAA,EMvlBL;;AE0CH;EF5CE;IACE,iBNylBK,EAAA,EMxlBN;;AGhBL;ECAA,qBAA+B;EAC/B,gBAA+B;EAC/B,aAAa;EACb,eAAe;EAEf,yCAA0D;EAC1D,4CAA6D;EAC7D,2CAA4D,EAAA;EDP5D;ICgBA,cAAc;IACd,WAAW;IACX,eAAe;IACf,4CAA6D;IAC7D,2CAA4D;IAC5D,8BAA+C,EAAA;;AA+C3C;EACE,SAAY,EAAA;;AAGd;EApCJ,cAAc;EACd,WAAW,EAAA;;AAcX;EACE,cAAc;EACd,WZiCqD,EAAA;;AYnCvD;EACE,cAAc;EACd,UZiCqD,EAAA;;AYnCvD;EACE,cAAc;EACd,gBZiCqD,EAAA;;AYnCvD;EACE,cAAc;EACd,UZiCqD,EAAA;;AYnCvD;EACE,cAAc;EACd,UZiCqD,EAAA;;AYnCvD;EACE,cAAc;EACd,gBZiCqD,EAAA;;AYFnD;EAhDJ,cAAc;EACd,WAAW,EAAA;;AAqDH;EAhEN,cAAc;EACd,eAA0C,EAAA;;AA+DpC;EAhEN,cAAc;EACd,gBAA0C,EAAA;;AA+DpC;EAhEN,cAAc;EACd,UAA0C,EAAA;;AA+DpC;EAhEN,cAAc;EACd,gBAA0C,EAAA;;AA+DpC;EAhEN,cAAc;EACd,gBAA0C,EAAA;;AA+DpC;EAhEN,cAAc;EACd,UAA0C,EAAA;;AA+DpC;EAhEN,cAAc;EACd,gBAA0C,EAAA;;AA+DpC;EAhEN,cAAc;EACd,gBAA0C,EAAA;;AA+DpC;EAhEN,cAAc;EACd,UAA0C,EAAA;;AA+DpC;EAhEN,cAAc;EACd,gBAA0C,EAAA;;AA+DpC;EAhEN,cAAc;EACd,gBAA0C,EAAA;;AA+DpC;EAhEN,cAAc;EACd,WAA0C,EAAA;;AAuElC;EAxDV,qBAA8C,EAAA;;AAwDpC;EAxDV,sBAA8C,EAAA;;AAwDpC;EAxDV,gBAA8C,EAAA;;AAwDpC;EAxDV,sBAA8C,EAAA;;AAwDpC;EAxDV,sBAA8C,EAAA;;AAwDpC;EAxDV,gBAA8C,EAAA;;AAwDpC;EAxDV,sBAA8C,EAAA;;AAwDpC;EAxDV,sBAA8C,EAAA;;AAwDpC;EAxDV,gBAA8C,EAAA;;AAwDpC;EAxDV,sBAA8C,EAAA;;AAwDpC;EAxDV,sBAA8C,EAAA;;AAmExC;;EAEE,gBAA+B,EAAA;;AAGjC;;EAEE,gBAA+B,EAAA;;AAPjC;;EAEE,sBAA+B,EAAA;;AAGjC;;EAEE,sBAA+B,EAAA;;AAPjC;;EAEE,qBAA+B,EAAA;;AAGjC;;EAEE,qBAA+B,EAAA;;AAPjC;;EAEE,mBAA+B,EAAA;;AAGjC;;EAEE,mBAA+B,EAAA;;AAPjC;;EAEE,qBAA+B,EAAA;;AAGjC;;EAEE,qBAA+B,EAAA;;AAPjC;;EAEE,mBAA+B,EAAA;;AAGjC;;EAEE,mBAA+B,EAAA;;AF1DrC;EEUE;IACE,SAAY,EAAA;EAGd;IApCJ,cAAc;IACd,WAAW,EAAA;EAcX;IACE,cAAc;IACd,WZiCqD,EAAA;EYnCvD;IACE,cAAc;IACd,UZiCqD,EAAA;EYnCvD;IACE,cAAc;IACd,gBZiCqD,EAAA;EYnCvD;IACE,cAAc;IACd,UZiCqD,EAAA;EYnCvD;IACE,cAAc;IACd,UZiCqD,EAAA;EYnCvD;IACE,cAAc;IACd,gBZiCqD,EAAA;EYFnD;IAhDJ,cAAc;IACd,WAAW,EAAA;EAqDH;IAhEN,cAAc;IACd,eAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,UAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,UAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,UAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,WAA0C,EAAA;EAuElC;IAxDV,cAA4B,EAAA;EAwDlB;IAxDV,qBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,gBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,gBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,gBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAmExC;;IAEE,gBAA+B,EAAA;EAGjC;;IAEE,gBAA+B,EAAA;EAPjC;;IAEE,sBAA+B,EAAA;EAGjC;;IAEE,sBAA+B,EAAA;EAPjC;;IAEE,qBAA+B,EAAA;EAGjC;;IAEE,qBAA+B,EAAA;EAPjC;;IAEE,mBAA+B,EAAA;EAGjC;;IAEE,mBAA+B,EAAA;EAPjC;;IAEE,qBAA+B,EAAA;EAGjC;;IAEE,qBAA+B,EAAA;EAPjC;;IAEE,mBAA+B,EAAA;EAGjC;;IAEE,mBAA+B,EAAA,EAChC;;AF3DL;EEUE;IACE,SAAY,EAAA;EAGd;IApCJ,cAAc;IACd,WAAW,EAAA;EAcX;IACE,cAAc;IACd,WZiCqD,EAAA;EYnCvD;IACE,cAAc;IACd,UZiCqD,EAAA;EYnCvD;IACE,cAAc;IACd,gBZiCqD,EAAA;EYnCvD;IACE,cAAc;IACd,UZiCqD,EAAA;EYnCvD;IACE,cAAc;IACd,UZiCqD,EAAA;EYnCvD;IACE,cAAc;IACd,gBZiCqD,EAAA;EYFnD;IAhDJ,cAAc;IACd,WAAW,EAAA;EAqDH;IAhEN,cAAc;IACd,eAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,UAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,UAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,UAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,WAA0C,EAAA;EAuElC;IAxDV,cAA4B,EAAA;EAwDlB;IAxDV,qBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,gBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,gBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,gBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAmExC;;IAEE,gBAA+B,EAAA;EAGjC;;IAEE,gBAA+B,EAAA;EAPjC;;IAEE,sBAA+B,EAAA;EAGjC;;IAEE,sBAA+B,EAAA;EAPjC;;IAEE,qBAA+B,EAAA;EAGjC;;IAEE,qBAA+B,EAAA;EAPjC;;IAEE,mBAA+B,EAAA;EAGjC;;IAEE,mBAA+B,EAAA;EAPjC;;IAEE,qBAA+B,EAAA;EAGjC;;IAEE,qBAA+B,EAAA;EAPjC;;IAEE,mBAA+B,EAAA;EAGjC;;IAEE,mBAA+B,EAAA,EAChC;;AF3DL;EEUE;IACE,SAAY,EAAA;EAGd;IApCJ,cAAc;IACd,WAAW,EAAA;EAcX;IACE,cAAc;IACd,WZiCqD,EAAA;EYnCvD;IACE,cAAc;IACd,UZiCqD,EAAA;EYnCvD;IACE,cAAc;IACd,gBZiCqD,EAAA;EYnCvD;IACE,cAAc;IACd,UZiCqD,EAAA;EYnCvD;IACE,cAAc;IACd,UZiCqD,EAAA;EYnCvD;IACE,cAAc;IACd,gBZiCqD,EAAA;EYFnD;IAhDJ,cAAc;IACd,WAAW,EAAA;EAqDH;IAhEN,cAAc;IACd,eAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,UAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,UAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,UAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,WAA0C,EAAA;EAuElC;IAxDV,cAA4B,EAAA;EAwDlB;IAxDV,qBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,gBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,gBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,gBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAmExC;;IAEE,gBAA+B,EAAA;EAGjC;;IAEE,gBAA+B,EAAA;EAPjC;;IAEE,sBAA+B,EAAA;EAGjC;;IAEE,sBAA+B,EAAA;EAPjC;;IAEE,qBAA+B,EAAA;EAGjC;;IAEE,qBAA+B,EAAA;EAPjC;;IAEE,mBAA+B,EAAA;EAGjC;;IAEE,mBAA+B,EAAA;EAPjC;;IAEE,qBAA+B,EAAA;EAGjC;;IAEE,qBAA+B,EAAA;EAPjC;;IAEE,mBAA+B,EAAA;EAGjC;;IAEE,mBAA+B,EAAA,EAChC;;AF3DL;EEUE;IACE,SAAY,EAAA;EAGd;IApCJ,cAAc;IACd,WAAW,EAAA;EAcX;IACE,cAAc;IACd,WZiCqD,EAAA;EYnCvD;IACE,cAAc;IACd,UZiCqD,EAAA;EYnCvD;IACE,cAAc;IACd,gBZiCqD,EAAA;EYnCvD;IACE,cAAc;IACd,UZiCqD,EAAA;EYnCvD;IACE,cAAc;IACd,UZiCqD,EAAA;EYnCvD;IACE,cAAc;IACd,gBZiCqD,EAAA;EYFnD;IAhDJ,cAAc;IACd,WAAW,EAAA;EAqDH;IAhEN,cAAc;IACd,eAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,UAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,UAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,UAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,WAA0C,EAAA;EAuElC;IAxDV,cAA4B,EAAA;EAwDlB;IAxDV,qBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,gBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,gBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,gBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAmExC;;IAEE,gBAA+B,EAAA;EAGjC;;IAEE,gBAA+B,EAAA;EAPjC;;IAEE,sBAA+B,EAAA;EAGjC;;IAEE,sBAA+B,EAAA;EAPjC;;IAEE,qBAA+B,EAAA;EAGjC;;IAEE,qBAA+B,EAAA;EAPjC;;IAEE,mBAA+B,EAAA;EAGjC;;IAEE,mBAA+B,EAAA;EAPjC;;IAEE,qBAA+B,EAAA;EAGjC;;IAEE,qBAA+B,EAAA;EAPjC;;IAEE,mBAA+B,EAAA;EAGjC;;IAEE,mBAA+B,EAAA,EAChC;;AF3DL;EEUE;IACE,SAAY,EAAA;EAGd;IApCJ,cAAc;IACd,WAAW,EAAA;EAcX;IACE,cAAc;IACd,WZiCqD,EAAA;EYnCvD;IACE,cAAc;IACd,UZiCqD,EAAA;EYnCvD;IACE,cAAc;IACd,gBZiCqD,EAAA;EYnCvD;IACE,cAAc;IACd,UZiCqD,EAAA;EYnCvD;IACE,cAAc;IACd,UZiCqD,EAAA;EYnCvD;IACE,cAAc;IACd,gBZiCqD,EAAA;EYFnD;IAhDJ,cAAc;IACd,WAAW,EAAA;EAqDH;IAhEN,cAAc;IACd,eAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,UAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,UAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,UAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,gBAA0C,EAAA;EA+DpC;IAhEN,cAAc;IACd,WAA0C,EAAA;EAuElC;IAxDV,cAA4B,EAAA;EAwDlB;IAxDV,qBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,gBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,gBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,gBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAwDpC;IAxDV,sBAA8C,EAAA;EAmExC;;IAEE,gBAA+B,EAAA;EAGjC;;IAEE,gBAA+B,EAAA;EAPjC;;IAEE,sBAA+B,EAAA;EAGjC;;IAEE,sBAA+B,EAAA;EAPjC;;IAEE,qBAA+B,EAAA;EAGjC;;IAEE,qBAA+B,EAAA;EAPjC;;IAEE,mBAA+B,EAAA;EAGjC;;IAEE,mBAA+B,EAAA;EAPjC;;IAEE,qBAA+B,EAAA;EAGjC;;IAEE,qBAA+B,EAAA;EAPjC;;IAEE,mBAA+B,EAAA;EAGjC;;IAEE,mBAA+B,EAAA,EAChC;;ACtHT;EACE,sCAAqC;EACrC,0BAA+B;EAC/B,+CAAmD;EACnD,iCAA6C;EAC7C,8CAAqD;EACrD,qDAA+C;EAC/C,6CAAmD;EACnD,kDAA6C;EAC7C,4CAAiD;EACjD,iDAA2C;EAE3C,WAAW;EACX,mBXweW;EWveX,4BAAgD;EAChD,mBXoyB+B;EWnyB/B,0CAAqE,EAAA;EAhBvE;IAwBI,uBXuxB+B;IWtxB/B,oCAAqD;IACrD,wBX0mB6B;IWzmB7B,wDAAgF,EAAA;EA3BpF;IA+BI,uBAAuB,EAAA;EA/B3B;IAmCI,sBAAsB,EAAA;;AAI1B;EACE,4CXqmBgF,EAAA;;AW9lBlF;EACE,iBAAiB,EAAA;;AAQnB;EAGI,uBXsvBgC,EAAA;;AWxuBpC;EAEI,mBAAmC,EAAA;EAFvC;IAMM,mBXqjB2B,EAAA;;AWhjBjC;EAGI,sBAAsB,EAAA;;AAH1B;EAOI,mBAAmB,EAAA;;AASvB;EAEI,gDAA6C;EAC7C,oCAAgE,EAAA;;AAKpE;EAEI,gDAA6C;EAC7C,oCAAgE,EAAA;;AAQpE;EACE,+CAA6C;EAC7C,mCAA8D,EAAA;;AAOhE;EAEI,8CAA6C;EAC7C,kCAA4D,EAAA;;ACrI9D;EAOE,sBAAqC;EACrC,sBAA+B;EAC/B,gCAAmD;EACnD,8BAA+C;EAC/C,8BAAqD;EACrD,2BAA6C;EAC7C,6BAAmD;EACnD,0BAA2C;EAC3C,4BAAiD;EAEjD,4BAAgD;EAChD,0CAAqE,EAAA;;AAlBvE;EAOE,sBAAqC;EACrC,sBAA+B;EAC/B,gCAAmD;EACnD,8BAA+C;EAC/C,8BAAqD;EACrD,2BAA6C;EAC7C,6BAAmD;EACnD,0BAA2C;EAC3C,4BAAiD;EAEjD,4BAAgD;EAChD,0CAAqE,EAAA;;AAlBvE;EAOE,sBAAqC;EACrC,sBAA+B;EAC/B,gCAAmD;EACnD,8BAA+C;EAC/C,8BAAqD;EACrD,2BAA6C;EAC7C,6BAAmD;EACnD,0BAA2C;EAC3C,4BAAiD;EAEjD,4BAAgD;EAChD,0CAAqE,EAAA;;AAlBvE;EAOE,sBAAqC;EACrC,sBAA+B;EAC/B,gCAAmD;EACnD,8BAA+C;EAC/C,8BAAqD;EACrD,2BAA6C;EAC7C,6BAAmD;EACnD,0BAA2C;EAC3C,4BAAiD;EAEjD,4BAAgD;EAChD,0CAAqE,EAAA;;AAlBvE;EAOE,sBAAqC;EACrC,sBAA+B;EAC/B,gCAAmD;EACnD,8BAA+C;EAC/C,8BAAqD;EACrD,2BAA6C;EAC7C,6BAAmD;EACnD,0BAA2C;EAC3C,4BAAiD;EAEjD,4BAAgD;EAChD,0CAAqE,EAAA;;AAlBvE;EAOE,sBAAqC;EACrC,sBAA+B;EAC/B,gCAAmD;EACnD,8BAA+C;EAC/C,8BAAqD;EACrD,2BAA6C;EAC7C,6BAAmD;EACnD,0BAA2C;EAC3C,4BAAiD;EAEjD,4BAAgD;EAChD,0CAAqE,EAAA;;AAlBvE;EAOE,sBAAqC;EACrC,sBAA+B;EAC/B,gCAAmD;EACnD,8BAA+C;EAC/C,8BAAqD;EACrD,2BAA6C;EAC7C,6BAAmD;EACnD,0BAA2C;EAC3C,4BAAiD;EAEjD,4BAAgD;EAChD,0CAAqE,EAAA;;AAlBvE;EAOE,sBAAqC;EACrC,sBAA+B;EAC/B,gCAAmD;EACnD,8BAA+C;EAC/C,8BAAqD;EACrD,2BAA6C;EAC7C,6BAAmD;EACnD,0BAA2C;EAC3C,4BAAiD;EAEjD,4BAAgD;EAChD,0CAAqE,EAAA;;AD0IrE;EACE,gBAAgB;EAChB,iCAAiC,EAAA;;AHpFnC;EGkFA;IACE,gBAAgB;IAChB,iCAAiC,EAAA,EAClC;;AHrFD;EGkFA;IACE,gBAAgB;IAChB,iCAAiC,EAAA,EAClC;;AHrFD;EGkFA;IACE,gBAAgB;IAChB,iCAAiC,EAAA,EAClC;;AHrFD;EGkFA;IACE,gBAAgB;IAChB,iCAAiC,EAAA,EAClC;;AHrFD;EGkFA;IACE,gBAAgB;IAChB,iCAAiC,EAAA,EAClC;;AE7JL;EACE,qBb47B2C;Eaz7B3C,gBb47ByC,EAAA;;Aat7B3C;EACE,+BC2N8D;ED1N9D,kCC0N8D;EDzN9D,gBAAgB;EfoRZ,kBAvE+B;Ee1MnC,gBbg7ByC;Ea/6BzC,gBbosB+B,EAAA;;AahsBjC;EACE,+BCgN8D;ED/M9D,kCC+M8D;EhB2D1D,qBAvE+B,EAAA;;Ae/LrC;EACE,gCC0M8D;EDzM9D,mCCyM8D;EhB+DxD,qBAf6B,EAAA;EAnJjC;IexGJ;MfiRQ,qBAlF6B,EAAA,Ee3LpC;;AE/BD;EACE,mBfo7B4C;EFppBxC,kBAvE+B;EiBrNnC,cf8IgB,EAAA;;AgBnJlB;EACE,cAAc;EACd,WAAW;EACX,sBhBq2BiC;EFvkB7B,mBAvE+B;EkBpNnC,gBhBysB+B;EgBxsB/B,gBhB8sB+B;EgB7sB/B,2BhBg9BsF;EgB/8BtF,oChB28BkF;EgB18BlF,4BAA4B;EAC5B,wChB88B0F;EgB78B1F,gBAAgB;EfGd,sBDkoBgC;EiBroB9B,wEjBw+B4F,EAAA;EiBp+B5F;IDhBN;MCiBQ,gBAAgB,EAAA,EDwEvB;EAzFD;IAqBI,gBAAgB,EAAA;IArBpB;MAwBM,eAAe,EAAA;EAxBrB;IA8BI,2BhB07BoF;IgBz7BpF,oChBq7BgF;IgBp7BhF,0ChBk8BoG;IgBj8BpG,UAAU;IAKR,4ChBoIc,EAAA;EgB1KpB;IA+CI,aAAmE,EAAA;EA/CvE;IAoDI,chB+Fc;IgB7Fd,UAAU,EAAA;EAtDd;IAgEI,6ChBq5BkG;IgBl5BlG,UAAU,EAAA;EAnEd;IAwEI,sBhBgyB+B;IgB/xB/B,uBhB+xB+B;IgB9xB/B,yBhB8xB+B;IgB7xB/B,2BhB64BoF;IkBx9BtF,gDlBijC0G;IgBp+BxG,oBAAoB;IACpB,qBAAqB;IACrB,mBAAmB;IACnB,eAAe;IACf,4BhBmjB6B;IgBljB7B,gBAAgB;ICtEd,qIjBy5B6I,EAAA;IiBr5B7I;MDhBN;QCiBQ,gBAAgB,EAAA,EDmErB;EApFH;IAuFI,gDhB09BwG,EAAA;;AgBj9B5G;EACE,cAAc;EACd,WAAW;EACX,iBAA2B;EAC3B,gBAAgB;EAChB,gBhBgnB+B;EgB/mB/B,2BhBk4BsF;EgBj4BtF,6BAA6B;EAC7B,yBAAyB;EACzB,mBAAmC,EAAA;EATrC;IAYI,UAAU,EAAA;EAZd;IAiBI,gBAAgB;IAChB,eAAe,EAAA;;AAWnB;EACE,sCFwG8D;EEvG9D,uBhBqvBiC;EF/kB3B,qBAf6B;EGvQjC,qBDmoB+B,EAAA;EF/gB/B;IkBNJ;MlB+KQ,qBAlF6B,EAAA,EkBlFpC;EAXD;IAOI,uBhBgvB+B;IgB/uB/B,wBhB+uB+B;IgB9uB/B,yBhB8uB+B,EAAA;;AgB1uBnC;EACE,sCF2F8D;EE1F9D,sBhB4uBkC;EFvlB9B,qBAvE+B;EG3MjC,qBDooB+B,EAAA;EgBzgBnC;IAOI,sBhBuuBgC;IgBtuBhC,uBhBsuBgC;IgBruBhC,yBhBquBgC,EAAA;;AgB9tBpC;EAEI,oCF0E4D,EAAA;;AE5EhE;EAMI,sCFsE4D,EAAA;;AE5EhE;EAUI,sCFkE4D,EAAA;;AE7DhE;EACE,WhB20B0C;EgB10B1C,gCF2D8D;EE1D9D,ehB2rBiC,EAAA;EgB9rBnC;IAMI,eAAe,EAAA;EANnB;IAUI,oBAAoB;IfpKpB,sBDkoBgC,EAAA;EgBxepC;If1JI,sBDkoBgC,EAAA;EgBxepC;IAkBsB,kCF2C0C,EAAA;EE7DhE;IAmBsB,kCF0C0C,EAAA;;AKrOhE;EACE,cAAc;EACd,WAAW;EACX,oCnBo2BiC;EmBn2BjC,sCLyP8D;EhBmC1D,mBAvE+B;EqBlNnC,gBnBusB+B;EmBtsB/B,gBnB4sB+B;EmB3sB/B,2BnB88BsF;EmB78BtF,oCnBy8BkF;EmBx8BlF,0DLuHgF;EKtHhF,4BAA4B;EAC5B,wCnBojCqE;EmBnjCrE,0BnBojC2C;EmBnjC3C,wCnBy8B0F;EC18BxF,sBDkoBgC;EiBroB9B,wEjBw+B4F;EmBh+BhG,gBAAgB,EAAA;EFJZ;IEfN;MFgBQ,gBAAgB,EAAA,EEiCvB;EAjDD;IAsBI,0CnB28BoG;ImB18BpG,UAAU;IAKR,4CnB6Ic,EAAA;EmBzKpB;IAkCI,qBnBq0B+B;ImBp0B/B,sBAAsB,EAAA;EAnC1B;IAwCI,6CnB46BkG,EAAA;EmBp9BtG;IA8CI,kBAAkB;IAClB,uCnBw6BoF,EAAA;;AmBp6BxF;EACE,oBnB8zBkC;EmB7zBlC,uBnB6zBkC;EmB5zBlC,oBnB6zBiC;EF/kB3B,qBAf6B;EGvQjC,sBmB4dgC,EAAA;EtBxWhC;IqB/EJ;MrBwPQ,qBAlF6B,EAAA,EqBhKpC;;AAED;EACE,mBnB0zBiC;EmBzzBjC,sBnByzBiC;EmBxzBjC,oBnByzBkC;EFvlB9B,qBAvE+B;EG3MjC,qBmB6d+B,EAAA;;AC5enC;EACE,cAAc;EACd,qBrBw/B2E;EqBv/B3E,mBrBw/BsE;EqBv/BtE,uBrBw/B+C,EAAA;EqB5/BjD;IAOI,WAAW;IACX,mBAA2C,EAAA;;AAI/C;EACE,oBrB8+BsE;EqB7+BtE,eAAe;EACf,iBAAiB,EAAA;EAHnB;IAMI,YAAY;IACZ,oBAA4C;IAC5C,cAAc,EAAA;;AAIlB;EACE,YrBg+B6C;EqB/9B7C,arB+9B6C;EqB99B7C,iBAA8D;EAC9D,mBAAmB;EACnB,oCrBu7BkF;EqBt7BlF,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;EACxB,8CrBm+BkH;EqBl+BlH,gBAAgB;EAChB,iCAAyB;UAAzB,yBAAyB,EAAA;EAX3B;IpBTI,qBDs/B2C,EAAA;EqB7+B/C;IAoBI,kBrB09ByC,EAAA;EqB9+B7C;IAwBI,uBrBi9BqD,EAAA;EqBz+BzD;IA4BI,0CrB86BoG;IqB76BpG,UAAU;IACV,4CrBoHgB,EAAA;EqBlJpB;IAkCI,yBrBgHgB;IqB/GhB,qBrB+GgB,EAAA;IqBlJpB;MAyCQ,0DPkE0E,EAAA;IO3GlF;MAiDQ,0DP0D0E,EAAA;EO3GlF;IAuDI,yBrB2FgB;IqB1FhB,qBrB0FgB;IqBrFd,0DP8C4E,EAAA;EO3GlF;IAkEI,oBAAoB;IACpB,YAAY;IACZ,YrBy7ByC,EAAA;EqB7/B7C;IA4EM,eAAe;IACf,YrBg7BuC,EAAA;;AqBl6B7C;EACE,mBrB26ByD,EAAA;EqB56B3D;IAII,UrBu6BiC;IqBt6BjC,mBAA4C;IAC5C,0DPU8E;IOT9E,gCAAgC;IpB3GhC,kBD+gCiC;IiBlhC/B,iDjBshCgE,EAAA;IiBlhChE;MImGN;QJlGQ,gBAAgB,EAAA,EI0HrB;IAxBH;MAYM,0DPI4E,EAAA;IOhBlF;MAgBM,iCrBs6BwC;MqBj6BtC,0DPL0E,EAAA;EOhBlF;IA2BI,oBrBi5BuD;IqBh5BvD,eAAe,EAAA;IA5BnB;MA+BM,oBAA6C;MAC7C,cAAc,EAAA;;AAKpB;EACE,qBAAqB;EACrB,kBrB+3BoC,EAAA;;AqB53BtC;EACE,kBAAkB;EAClB,sBAAsB;EACtB,oBAAoB,EAAA;EAHtB;IAQM,oBAAoB;IACpB,YAAY;IACZ,arBkvB2B,EAAA;;AsBv5BjC;EACE,WAAW;EACX,YR+N2B;EQ9N3B,UAAU;EACV,6BAA6B;EAC7B,gBAAgB,EAAA;EALlB;IAQI,UAAU,EAAA;IARd;MAY8B,+DtB4JV,EAAA;IsBxKpB;MAa8B,+DtB2JV,EAAA;EsBxKpB;IAiBI,SAAS,EAAA;EAjBb;IAqBI,WtBglC2C;IsB/kC3C,YtB+kC2C;IsB9kC3C,oBAAsE;IJzBxE,yBlB0KkB;IsB/IhB,StB+kCwC;IC3lCxC,mBD4lC2C;IiB/lCzC,oHjBqmCkI;IiBrmClI,4GjBqmCkI;IsBllCpI,gBAAgB,EAAA;ILfd;MKdN;QLeQ,wBAAgB;QAAhB,gBAAgB,EAAA,EKmBrB;IAlCH;MJFE,yBJ0MmC,EAAA;EQxMrC;IAqCI,WtByjCkC;IsBxjClC,ctByjCmC;IsBxjCnC,kBAAkB;IAClB,etBwjCqC;IsBvjCrC,oCtBwjC0E;IsBvjC1E,yBAAyB;IrB7BzB,mBDqlCkC,EAAA;EsBlmCtC;IAgDI,WtBqjC2C;IsBpjC3C,YtBojC2C;IkBvmC7C,yBlB0KkB;IsBrHhB,StBqjCwC;IC3lCxC,mBD4lC2C;IiB/lCzC,iHjBqmCkI;IiBrmClI,4GjBqmCkI;IsBxjCpI,gBAAgB,EAAA;ILzCd;MKdN;QLeQ,qBAAgB;QAAhB,gBAAgB,EAAA,EK6CrB;IA5DH;MJFE,yBJ0MmC,EAAA;EQxMrC;IA+DI,WtB+hCkC;IsB9hClC,ctB+hCmC;IsB9hCnC,kBAAkB;IAClB,etB8hCqC;IsB7hCrC,oCtB8hC0E;IsB7hC1E,yBAAyB;IrBvDzB,mBDqlCkC,EAAA;EsBlmCtC;IA0EI,oBAAoB,EAAA;IA1ExB;MA6EM,yBtBmEY,EAAA;IsBhJlB;MAiFM,yBtB+DY,EAAA;;AuBtJlB;EACE,kBAAkB,EAAA;EADpB;;;IAMI,0BToO4D;ISnO5D,iBvBynCkC,EAAA;EuBhoCtC;IAWI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,oBvB41B+B;IuB31B/B,gBAAgB;IAChB,iBAAiB;IACjB,uBAAuB;IACvB,mBAAmB;IACnB,oBAAoB;IACpB,6BAA6C;IAC7C,qBAAqB;INPnB,gEjBunC8E,EAAA;IiBnnC9E;MMpBN;QNqBQ,gBAAgB,EAAA,EMIrB;EAzBH;;IA6BI,oBvB+0B+B,EAAA;IuB52BnC;;MAgCM,kBAAkB,EAAA;IAhCxB;;;MAqCM,qBvB8lCoC;MuB7lCpC,wBvB8lCmC,EAAA;IuBpoCzC;;MA0CM,qBvBylCoC;MuBxlCpC,wBvBylCmC,EAAA;EuBpoCzC;IAgDI,qBvBmlCsC;IuBllCtC,wBvBmlCqC,EAAA;EuBpoCzC;;;;IAyDM,avB4kC+B;IuB3kC/B,8DvB4kC4E,EAAA;EuBtoClF;IAgEM,avBqkC+B;IuBpkC/B,8DvBqkC4E,EAAA;EuBtoClF;IAuEM,mBAAmC,EAAA;;ACnEzC;EACE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,oBAAoB;EACpB,WAAW,EAAA;EALb;;;IAUI,kBAAkB;IAClB,cAAc;IACd,SAAS;IACT,YAAY,EAAA;EAbhB;;;IAoBI,UAAU,EAAA;EApBd;IA2BI,kBAAkB;IAClB,UAAU,EAAA;IA5Bd;MA+BM,UAAU,EAAA;;AAWhB;EACE,aAAa;EACb,mBAAmB;EACnB,sBxB2zBiC;EFvkB7B,mBAvE+B;E0B3KnC,gBxBgqB+B;EwB/pB/B,gBxBqqB+B;EwBpqB/B,2BxBu6BsF;EwBt6BtF,kBAAkB;EAClB,mBAAmB;EACnB,gDxB6/B0G;EwB5/B1G,wCxBo6B0F;EC18BxF,sBDkoBgC,EAAA;;AwBllBpC;;;;EAIE,sBxBqzBkC;EFvlB9B,qBAvE+B;EG3MjC,qBDooB+B,EAAA;;AwB3kBnC;;;;EAIE,uBxBwyBiC;EF/kB3B,qBAf6B;EGvQjC,qBDmoB+B,EAAA;EF/gB/B;I0B3DJ;;;;M1BoOQ,qBAlF6B,EAAA,E0B3IpC;;AAED;;EAEE,qBAAsE,EAAA;;AAWxE;;;;EvB/DI,0BuBqE8B;EvBpE9B,6BuBoE8B,EAAA;;AANlC;;;;EvB/DI,0BuB8E8B;EvB7E9B,6BuB6E8B,EAAA;;AAflC;EAyBI,iBxB6gB6B;ECvlB7B,yBuB2E8B;EvB1E9B,4BuB0E8B,EAAA;;AA1BlC;;EvBjDI,yBuBgF8B;EvB/E9B,4BuB+E8B,EAAA;;AAP4B;EChG1D,aAAa;EACb,WAAW;EACX,mBzB65B0C;EFppBxC,kBAvE+B;E2B/LjC,czBsJgB,EAAA;;AwB3DsB;ECvFtC,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,aAAa;EACb,eAAe;EACf,sBzB+3C4C;EyB93C5C,iBAAiB;E3BgQb,qBAf6B;E2B9OjC,WzBqGW;EyBpGX,yCzBwIgB;EClKhB,qBDmoB+B,EAAA;EF/gB/B;I0BbsC;M1BsLlC,qBAlF6B,EAAA,E2B/KlC;;AAzCC;;;;EA8CE,cAAc,EAAA;;AA9ChB;EAoDE,qBzB2Hc;EyBxHZ,iCX6KwD;EW5KxD,0DXyE0E;EWxE1E,4BAA4B;EAC5B,yDAA6D;EAC7D,4DXyKwD,EAAA;EWpO5D;IA+DI,qBzBgHY;IyB/GZ,4CzB+GY,EAAA;;AyB/KhB;EAyEI,iCX2JwD;EW1JxD,8EX0JwD,EAAA;;AWpO5D;EAiFE,qBzB8Fc,EAAA;EyB/KhB;IAsFM,sBzB++B2F;IyB9+B3F,oGX0CwE;IWzCxE,6DzBg+BoD;IyB/9BpD,uEX2IsD,EAAA;EWpO5D;IA8FI,qBzBiFY;IyBhFZ,4CzBgFY,EAAA;;AyB/KhB;EAuGI,sCX6HwD,EAAA;;AWpO5D;EA8GE,qBzBiEc,EAAA;EyB/KhB;IAiHI,yBzB8DY,EAAA;EyB/KhB;IAqHI,4CzB0DY,EAAA;EyB/KhB;IAyHI,czBsDY,EAAA;;AyBlDlB;EAEI,iBAAiB,EAAA;;AA/HnB;;;;;EAyIM,UAAU,EAAA;;ADrBqF;EChGrG,aAAa;EACb,WAAW;EACX,mBzB65B0C;EFppBxC,kBAvE+B;E2B/LjC,czBmJgB,EAAA;;AwBxD+D;ECvF/E,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,aAAa;EACb,eAAe;EACf,sBzB+3C4C;EyB93C5C,iBAAiB;E3BgQb,qBAf6B;E2B9OjC,WzBqGW;EyBpGX,wCzBqIgB;EC/JhB,qBDmoB+B,EAAA;EF/gB/B;I0Bb+E;M1BsL3E,qBAlF6B,EAAA,E2B/KlC;;AAzCC;;;;EA8CE,cAAc,EAAA;;AA9ChB;EAoDE,qBzBwHc;EyBrHZ,iCX6KwD;EW5KxD,0DXyE0E;EWxE1E,4BAA4B;EAC5B,yDAA6D;EAC7D,4DXyKwD,EAAA;EWpO5D;IA+DI,qBzB6GY;IyB5GZ,2CzB4GY,EAAA;;AyB5KhB;EAyEI,iCX2JwD;EW1JxD,8EX0JwD,EAAA;;AWpO5D;EAiFE,qBzB2Fc,EAAA;EyB5KhB;IAsFM,sBzB++B2F;IyB9+B3F,oGX0CwE;IWzCxE,6DzBg+BoD;IyB/9BpD,uEX2IsD,EAAA;EWpO5D;IA8FI,qBzB8EY;IyB7EZ,2CzB6EY,EAAA;;AyB5KhB;EAuGI,sCX6HwD,EAAA;;AWpO5D;EA8GE,qBzB8Dc,EAAA;EyB5KhB;IAiHI,yBzB2DY,EAAA;EyB5KhB;IAqHI,2CzBuDY,EAAA;EyB5KhB;IAyHI,czBmDY,EAAA;;AyB/ClB;EAEI,iBAAiB,EAAA;;AA/HnB;;;;;EA2IM,UAAU,EAAA;;AC7IpB;EAEE,0BAAyC;EACzC,0BAAyC;EACzC,sBAA6C;E5B6RzC,4BAvE+B;E4BpNnC,yBAA6C;EAC7C,yBAA6C;EAC7C,uBAAiC;EACjC,wBAA2B;EAC3B,0BAA+C;EAC/C,kCAA+C;EAC/C,+BAAiD;EACjD,wCAA2D;EAC3D,4FAA2C;EAC3C,+BAAuD;EACvD,2EAAuD;EAGvD,qBAAqB;EACrB,wDAAoG;EACpG,sCAA8D;E5B4Q1D,kCAvE+B;E4BnMnC,sCAA8D;EAC9D,sCAA8D;EAC9D,0BAA4C;EAC5C,kBAAkB;EAClB,qBAAwD;EAExD,sBAAsB;EACtB,eAA2C;EAC3C,yBAAiB;UAAjB,iBAAiB;EACjB,mEAAqH;EzBjBnH,0CyBkB0E;ERjC5E,kCQkCoD;ETtBhD,qIjBy5B6I,EAAA;EiBr5B7I;IShBN;MTiBQ,gBAAgB,EAAA,ES4FvB;EA7GD;IAuCI,gCAAwD;IAExD,wCAA6D;IAC7D,8CAA6E,EAAA;EAG/E;IAEE,0BAA4C;IAC5C,kCAAiD;IACjD,wCAAiE,EAAA;EAjDrE;IAqDI,gCAAwD;IRrD1D,wCQsDkE;IAChE,8CAA6E;IAC7E,UAAU;IAKR,0CAAuE,EAAA;EAI3E;IACE,8CAA6E;IAC7E,UAAU;IAKR,0CAAuE,EAAA;EAI3E;;IAKE,iCAA0D;IAC1D,yCAA+D;IAG/D,+CAA+E,EAAA;IATjF;;MAiBM,0CAAuE,EAAA;EA7F/E;;IAqGI,mCAA8D;IAC9D,oBAAoB;IACpB,2CAAmE;IAEnE,iDAAmF;IACnF,uCAAoE,EAAA;;AAYtE;ECtGA,oBAAiC;EACjC,oBAA2B;EAC3B,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,wCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,6BAAmD;EACnD,6BAA6C;EAC7C,uCAAiE,EAAA;;ADyFjE;ECtGA,oBAAiC;EACjC,oBAA2B;EAC3B,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,wCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,6BAAmD;EACnD,6BAA6C;EAC7C,uCAAiE,EAAA;;ADyFjE;ECtGA,oBAAiC;EACjC,oBAA2B;EAC3B,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,uCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,6BAAmD;EACnD,6BAA6C;EAC7C,uCAAiE,EAAA;;ADyFjE;ECtGA,oBAAiC;EACjC,oBAA2B;EAC3B,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,wCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,6BAAmD;EACnD,6BAA6C;EAC7C,uCAAiE,EAAA;;ADyFjE;ECtGA,oBAAiC;EACjC,oBAA2B;EAC3B,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,wCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,6BAAmD;EACnD,6BAA6C;EAC7C,uCAAiE,EAAA;;ADyFjE;ECtGA,oBAAiC;EACjC,oBAA2B;EAC3B,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,sCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,6BAAmD;EACnD,6BAA6C;EAC7C,uCAAiE,EAAA;;ADyFjE;ECtGA,oBAAiC;EACjC,oBAA2B;EAC3B,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,wCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,6BAAmD;EACnD,6BAA6C;EAC7C,uCAAiE,EAAA;;ADyFjE;ECtGA,oBAAiC;EACjC,oBAA2B;EAC3B,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,qCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,6BAAmD;EACnD,6BAA6C;EAC7C,uCAAiE,EAAA;;ADmHjE;ECvGA,uBAAiC;EACjC,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,uCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,gCAAmD;EACnD,iCAA6C;EAC7C,uCAAiE;EACjE,mBAA+B,EAAA;;AD0F/B;ECvGA,uBAAiC;EACjC,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,wCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,gCAAmD;EACnD,iCAA6C;EAC7C,uCAAiE;EACjE,mBAA+B,EAAA;;AD0F/B;ECvGA,uBAAiC;EACjC,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,uCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,gCAAmD;EACnD,iCAA6C;EAC7C,uCAAiE;EACjE,mBAA+B,EAAA;;AD0F/B;ECvGA,uBAAiC;EACjC,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,uCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,gCAAmD;EACnD,iCAA6C;EAC7C,uCAAiE;EACjE,mBAA+B,EAAA;;AD0F/B;ECvGA,uBAAiC;EACjC,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,uCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,gCAAmD;EACnD,iCAA6C;EAC7C,uCAAiE;EACjE,mBAA+B,EAAA;;AD0F/B;ECvGA,uBAAiC;EACjC,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,sCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,gCAAmD;EACnD,iCAA6C;EAC7C,uCAAiE;EACjE,mBAA+B,EAAA;;AD0F/B;ECvGA,uBAAiC;EACjC,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,wCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,gCAAmD;EACnD,iCAA6C;EAC7C,uCAAiE;EACjE,mBAA+B,EAAA;;AD0F/B;ECvGA,uBAAiC;EACjC,8BAA+C;EAC/C,0BAA6C;EAC7C,0BAAuC;EACvC,oCAA2D;EAC3D,qCAAuD;EACvD,2BAA+C;EAC/C,2BAAyC;EACzC,qCAA6D;EAC7D,4DAAiD;EACjD,gCAAmD;EACnD,iCAA6C;EAC7C,uCAAiE;EACjE,mBAA+B,EAAA;;ADsGjC;EACE,yBAA6C;EAC7C,oCAAiC;EACjC,wBAA2B;EAC3B,kCAA+C;EAC/C,gDAA6C;EAC7C,wCAA2D;EAC3D,iDAA+C;EAC/C,yCAA6D;EAC7D,gCAAmD;EACnD,2CAAiE;EACjE,yBAA2C;EAC3C,wCAAuD;EAEvD,0B1BkZiD,EAAA;E0BhanD;IAyBI,0BAA4C,EAAA;EAzBhD;IA6BI,gCAAwD,EAAA;;AAW5D;ECxIE,0BAAyC;EACzC,0BAAyC;E7BoOrC,8BAvE+B;E6B3JnC,8BAAiD,EAAA;;ADyInD;EC5IE,2BAAyC;EACzC,0BAAyC;E7BwOnC,8BAf6B;E6BvNnC,8BAAiD,EAAA;E7BoE/C;I4BqEJ;M5BoGQ,8BAlF6B,EAAA,E4BhBpC;;AE9MD;EXgBM,gCjB6pB2C,EAAA;EiBzpB3C;IWpBN;MXqBQ,gBAAgB,EAAA,EWfvB;EAND;IAII,UAAU,EAAA;;AAKd;EAEI,aAAa,EAAA;;AAIjB;EACE,SAAS;EACT,gBAAgB;EXDZ,6BjB+pBwC,EAAA;EiB3pBxC;IWLN;MXMQ,gBAAgB,EAAA,EWIvB;EAVD;IAMI,QAAQ;IACR,YAAY;IXNV,4BjBgqBuC,EAAA;IiB5pBvC;MWLN;QXMQ,gBAAgB,EAAA,EWGrB;;ACvBH;;;;;;EAME,kBAAkB,EAAA;;AL6FG;EKzFrB,mBAAmB,EAAA;;ALyFwB;EKhF3C,0BAA6C;EAC7C,8BAAmD;EACnD,0BAAmD;EACnD,+BAAmD;EACnD,8BAA6C;E/B6QzC,iCAvE+B;E+BpMnC,yCAA2C;EAC3C,uCAAqC;EACrC,kDAAyD;EACzD,mCAA2D;EAC3D,2DAAyD;EACzD,mFAAuE;EACvE,gDAAqD;EACrD,sCAAiE;EACjE,2DAAqD;EACrD,uDAAqD;EACrD,mEAAiE;EACjE,6DAA2D;EAC3D,oEAAmE;EACnE,8DAA6D;EAC7D,0CAAuE;EACvE,oCAA6D;EAC7D,qCAA6D;EAC7D,mCAAyD;EACzD,oCAAiE;EACjE,sCAAiE;EAGjE,kBAAkB;EAClB,kCAA0D;EAC1D,aAAa;EACb,uCAAkE;EAClE,kEAAwH;EACxH,SAAS;E/BgPL,uCAvE+B;E+BvKnC,+BAAsD;EACtD,gBAAgB;EAChB,gBAAgB;EAChB,uCAA2D;EAC3D,4BAA4B;EAC5B,6EAAyI;E5BzCvI,+C4B0CoF,EAAA;EA3CxF;IA+CI,SAAS;IACT,OAAO;IACP,qCAA6D,EAAA;;AAwB7D;EACE,oBAAc,EAAA;EADhB;IAII,WAAW;IACX,OAAO,EAAA;;AAIX;EACE,kBAAc,EAAA;EADhB;IAII,QAAQ;IACR,UAAU,EAAA;;ArB1Cd;EqB4BA;IACE,oBAAc,EAAA;IADhB;MAII,WAAW;MACX,OAAO,EAAA;EAIX;IACE,kBAAc,EAAA;IADhB;MAII,QAAQ;MACR,UAAU,EAAA,EACX;;ArB3CH;EqB4BA;IACE,oBAAc,EAAA;IADhB;MAII,WAAW;MACX,OAAO,EAAA;EAIX;IACE,kBAAc,EAAA;IADhB;MAII,QAAQ;MACR,UAAU,EAAA,EACX;;ArB3CH;EqB4BA;IACE,oBAAc,EAAA;IADhB;MAII,WAAW;MACX,OAAO,EAAA;EAIX;IACE,kBAAc,EAAA;IADhB;MAII,QAAQ;MACR,UAAU,EAAA,EACX;;ArB3CH;EqB4BA;IACE,oBAAc,EAAA;IADhB;MAII,WAAW;MACX,OAAO,EAAA;EAIX;IACE,kBAAc,EAAA;IADhB;MAII,QAAQ;MACR,UAAU,EAAA,EACX;;ArB3CH;EqB4BA;IACE,oBAAc,EAAA;IADhB;MAII,WAAW;MACX,OAAO,EAAA;EAIX;IACE,kBAAc,EAAA;IADhB;MAII,QAAQ;MACR,UAAU,EAAA,EACX;;AAQP;EAEI,SAAS;EACT,YAAY;EACZ,aAAa;EACb,wCAAgE,EAAA;;AAQpE;EAEI,MAAM;EACN,WAAW;EACX,UAAU;EACV,aAAa;EACb,sCAA8D,EAAA;;AANlE;EAYM,iBAAiB,EAAA;;AAKvB;EAEI,MAAM;EACN,WAAW;EACX,UAAU;EACV,aAAa;EACb,uCAA+D,EAAA;;AANnE;EAYM,iBAAiB,EAAA;;AAOvB;EACE,SAAS;EACT,6CAA+E;EAC/E,gBAAgB;EAChB,mDAA+E;EAC/E,UAAU,EAAA;;AAMZ;EACE,cAAc;EACd,WAAW;EACX,4EAA4I;EAC5I,WAAW;EACX,gB7BgiB+B;E6B/hB/B,oCAAgE;EAChE,mBAAmB;EACnB,qBAAwD;EACxD,mBAAmB;EACnB,6BAA6B;EAC7B,SAAS,EAAA;EAXX;IAeI,0CAA4E;IXzL9E,kDW2LsF,EAAA;EAjBxF;IAsBI,2CAA8E;IAC9E,qBAAqB;IXjMvB,mDWkMwF,EAAA;EAxB1F;IA6BI,6CAAkF;IAClF,oBAAoB;IACpB,6BAA6B,EAAA;;AAMjC;EACE,cAAc,EAAA;;AAIhB;EACE,cAAc;EACd,gFAAoJ;EACpJ,gBAAgB;E/B8EV,qBAf6B;E+B7DnC,sCAAoE;EACpE,mBAAmB,EAAA;E/BvFjB;I+BiFJ;M/BwFQ,qBAlF6B,EAAA,E+BCpC;;AAGD;EACE,cAAc;EACd,4EAA4I;EAC5I,oCAAgE,EAAA;;AAIlE;EAEE,4BAA2C;EAC3C,yBAAqC;EACrC,kDAAyD;EACzD,0BAAqD;EACrD,iCAAqD;EACrD,oCAAiE;EACjE,gDAAqD;EACrD,sDAA2D;EAC3D,qCAAmE;EACnE,qCAA6D;EAC7D,0CAAuE;EACvE,mCAAyD,EAAA;;ACrP3D;;EAEE,kBAAkB;EAClB,oBAAoB;EACpB,sBAAsB,EAAA;EAJxB;;IAOI,kBAAkB;IAClB,cAAc,EAAA;EARlB;;;;;;;;;;;;IAmBI,UAAU,EAAA;;AAKd;EACE,aAAa;EACb,eAAe;EACf,2BAA2B,EAAA;EAH7B;IAMI,WAAW,EAAA;;AAIf;E7BhBI,sBDkoBgC,EAAA;E8BlnBpC;;IAMI,iB9B+lB6B,EAAA;E8BrmBjC;;;I7BAI,0B6Ba4B;I7BZ5B,6B6BY4B,EAAA;EAbhC;;;I7BcI,yB6BS8B;I7BR9B,4B6BQ8B,EAAA;;AAgBlC;EACE,uBAAmC;EACnC,sBAAkC,EAAA;EAFpC;;;IAOI,cAAc,EAAA;EAGhB;IACE,eAAe,EAAA;;AAInB;EACE,uBAAsC;EACtC,sBAAqC,EAAA;;AAGvC;EACE,qBAAsC;EACtC,oBAAqC,EAAA;;AAoBvC;EACE,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB,EAAA;EAHzB;;IAOI,WAAW,EAAA;EAPf;;IAYI,gB9BwgB6B,EAAA;E8BphBjC;;I7B1EI,6B6B4F+B;I7B3F/B,4B6B2F+B,EAAA;EAlBnC;;I7BxFI,yB6B+G4B;I7B9G5B,0B6B8G4B,EAAA;;ACtIhC;EAEE,6BAAmD;EACnD,+BAAmD;EAEnD,2BAAuD;EACvD,yCAA2C;EAC3C,qDAAuD;EACvD,qCAA6D;EAG7D,aAAa;EACb,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB,EAAA;;AAGlB;EACE,cAAc;EACd,kEAAwH;EjC4QpH,uCAvE+B;EiCnMnC,2CAAwE;EACxE,+BAAsD;EACtD,qBAAwD;EdbpD,uGjBirCsH,EAAA;EiB7qCtH;IcGN;MdFQ,gBAAgB,EAAA,EcuBvB;EArBD;IAWI,qCAAkE,EAAA;EAXtE;IAiBI,wCAAwE;IACxE,oBAAoB;IACpB,eAAe,EAAA;;AAQnB;EAEE,+BAAyD;EACzD,8CAAyD;EACzD,oCAA2D;EAC3D,+FAA+E;EAC/E,qEAAmE;EACnE,+DAA6D;EAC7D,+GAAiF;EAGjF,oFAAgJ,EAAA;EAXlJ;IAcI,yDAAuF;IACvF,gBAAgB;IAChB,yDAAuF;I9BtCvF,wD8BuC0F;I9BtC1F,yD8BsC0F,EAAA;IAjB9F;MAsBM,kBAAkB;MAClB,wDAAiG,EAAA;IAvBvG;MA4BM,wCAAwE;MACxE,6BAA6B;MAC7B,yBAAyB,EAAA;EA9B/B;;IAoCI,2CAA8E;IAC9E,mDAAmF;IACnF,yDAAmG,EAAA;EAtCvG;IA2CI,sDAAoF;I9BjEpF,yB8BmE4B;I9BlE5B,0B8BkE4B,EAAA;;AAShC;EAEE,qCAA6D;EAC7D,sCAAqE;EACrE,sCAA+D,EAAA;EAJjE;IAQI,gBAAgB;IAChB,SAAS;I9B9FT,gD8B+FwF,EAAA;IAV5F;MAaM,wCAAwE;MACxE,6BAA6B;MAC7B,yBAAyB,EAAA;EAf/B;;IAqBI,4CAAgF;IbzHlF,oDa0H0F,EAAA;;AAS5F;;EAGI,cAAc;EACd,kBAAkB,EAAA;;AAItB;;EAGI,aAAa;EACb,YAAY;EACZ,kBAAkB,EAAA;;AAItB;;EAGI,WAAW,EAAA;;AASf;EAEI,aAAa,EAAA;;AAFjB;EAKI,cAAc,EAAA;;ACpKlB;EAEE,wBAA+C;EAC/C,6BAA+C;EAC/C,sCAAuC;EACvC,2CAAmD;EACnD,8CAAyD;EACzD,4CAAqD;EACrD,uCAA2D;EAC3D,kCAA6D;EAC7D,uCAA2D;EAC3D,2CAAmD;EACnD,iDAA+D;EAC/D,sCAAiE;EACjE,sCAA+D;EAC/D,sCAA+D;EAC/D,yCAA+D;EAC/D,qEAA2D;EAC3D,oDAAqE;EACrE,0CAAuE;EACvE,kCAAmE;EACnE,4DAAiE;EAGjE,kBAAkB;EAClB,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,8BAA8B;EAC9B,8DAAgH,EAAA;EA7BlH;;IAoCI,aAAa;IACb,kBAAkB;IAClB,mBAAmB;IACnB,8BAA8B,EAAA;;AAoBlC;EACE,6CAA4E;EAC5E,gDAA+E;EAC/E,+CAA+E;ElCkO3E,2CAvE+B;EkCzJnC,mCAA8D;EAC9D,qBAAwD;EACxD,mBAAmB,EAAA;EAPrB;IAWI,yCAA0E,EAAA;;AAU9E;EAEE,0BAAmD;EACnD,+BAAmD;EAEnD,2BAAuD;EACvD,2CAA2C;EAC3C,uDAAuD;EACvD,6DAA6D;EAG7D,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,gBAAgB,EAAA;EAflB;;IAmBI,oCAAgE,EAAA;EAnBpE;IAuBI,gBAAgB,EAAA;;AASpB;EACE,mBhCqkCuC;EgCpkCvC,sBhCokCuC;EgCnkCvC,6BAAkD,EAAA;EAHpD;;;IAQI,oCAAgE,EAAA;;AAapE;EACE,gBAAgB;EAChB,YAAY;EAGZ,mBAAmB,EAAA;;AAIrB;EACE,8EAAgJ;ElCiJ5I,6CAvE+B;EkCxEnC,cAAc;EACd,6BAAkD;EAClD,6BAA6B;EAC7B,0EAAmI;E/BtIjI,qD+BuIgG;Ef1I9F,+Ce2IqF,EAAA;EfvIrF;Ie+HN;Mf9HQ,gBAAgB,EAAA,EeiJvB;EAnBD;IAWI,qBAAqB,EAAA;EAXzB;IAeI,qBAAqB;IACrB,UAAU;IACV,sDAAyF,EAAA;;AAM7F;EACE,qBAAqB;EACrB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,kDAAiF;EACjF,4BAA4B;EAC5B,2BAA2B;EAC3B,qBAAqB,EAAA;;AAGvB;EACE,yCAA+D;EAC/D,gBAAgB,EAAA;;AxBxHd;EwBoIA;IAEI,iBAAiB;IACjB,2BAA2B,EAAA;IAH9B;MAMK,mBAAmB,EAAA;MANxB;QASO,kBAAkB,EAAA;MATzB;QAaO,kDAAoF;QACpF,iDAAmF,EAAA;IAd1F;MAmBK,iBAAiB,EAAA;IAnBtB;MAuBK,wBAAwB;MACxB,gBAAgB,EAAA;IAxBrB;MA4BK,aAAa,EAAA;IA5BlB;MAiCK,gBAAgB;MAChB,aAAa;MACb,YAAY;MACZ,sBAAsB;MACtB,uBAAuB;MACvB,8BAA8B;MAC9B,wCAAwC;MACxC,oBAAoB;MACpB,0BAA0B;Mf5N9B,gBe8N4B,EAAA;MA3C7B;QA+CO,aAAa,EAAA;MA/CpB;QAmDO,aAAa;QACb,YAAY;QACZ,UAAU;QACV,mBAAmB,EAAA,EACpB;;AxB3LP;EwBoIA;IAEI,iBAAiB;IACjB,2BAA2B,EAAA;IAH9B;MAMK,mBAAmB,EAAA;MANxB;QASO,kBAAkB,EAAA;MATzB;QAaO,kDAAoF;QACpF,iDAAmF,EAAA;IAd1F;MAmBK,iBAAiB,EAAA;IAnBtB;MAuBK,wBAAwB;MACxB,gBAAgB,EAAA;IAxBrB;MA4BK,aAAa,EAAA;IA5BlB;MAiCK,gBAAgB;MAChB,aAAa;MACb,YAAY;MACZ,sBAAsB;MACtB,uBAAuB;MACvB,8BAA8B;MAC9B,wCAAwC;MACxC,oBAAoB;MACpB,0BAA0B;Mf5N9B,gBe8N4B,EAAA;MA3C7B;QA+CO,aAAa,EAAA;MA/CpB;QAmDO,aAAa;QACb,YAAY;QACZ,UAAU;QACV,mBAAmB,EAAA,EACpB;;AxB3LP;EwBoIA;IAEI,iBAAiB;IACjB,2BAA2B,EAAA;IAH9B;MAMK,mBAAmB,EAAA;MANxB;QASO,kBAAkB,EAAA;MATzB;QAaO,kDAAoF;QACpF,iDAAmF,EAAA;IAd1F;MAmBK,iBAAiB,EAAA;IAnBtB;MAuBK,wBAAwB;MACxB,gBAAgB,EAAA;IAxBrB;MA4BK,aAAa,EAAA;IA5BlB;MAiCK,gBAAgB;MAChB,aAAa;MACb,YAAY;MACZ,sBAAsB;MACtB,uBAAuB;MACvB,8BAA8B;MAC9B,wCAAwC;MACxC,oBAAoB;MACpB,0BAA0B;Mf5N9B,gBe8N4B,EAAA;MA3C7B;QA+CO,aAAa,EAAA;MA/CpB;QAmDO,aAAa;QACb,YAAY;QACZ,UAAU;QACV,mBAAmB,EAAA,EACpB;;AxB3LP;EwBoIA;IAEI,iBAAiB;IACjB,2BAA2B,EAAA;IAH9B;MAMK,mBAAmB,EAAA;MANxB;QASO,kBAAkB,EAAA;MATzB;QAaO,kDAAoF;QACpF,iDAAmF,EAAA;IAd1F;MAmBK,iBAAiB,EAAA;IAnBtB;MAuBK,wBAAwB;MACxB,gBAAgB,EAAA;IAxBrB;MA4BK,aAAa,EAAA;IA5BlB;MAiCK,gBAAgB;MAChB,aAAa;MACb,YAAY;MACZ,sBAAsB;MACtB,uBAAuB;MACvB,8BAA8B;MAC9B,wCAAwC;MACxC,oBAAoB;MACpB,0BAA0B;Mf5N9B,gBe8N4B,EAAA;MA3C7B;QA+CO,aAAa,EAAA;MA/CpB;QAmDO,aAAa;QACb,YAAY;QACZ,UAAU;QACV,mBAAmB,EAAA,EACpB;;AxB3LP;EwBoIA;IAEI,iBAAiB;IACjB,2BAA2B,EAAA;IAH9B;MAMK,mBAAmB,EAAA;MANxB;QASO,kBAAkB,EAAA;MATzB;QAaO,kDAAoF;QACpF,iDAAmF,EAAA;IAd1F;MAmBK,iBAAiB,EAAA;IAnBtB;MAuBK,wBAAwB;MACxB,gBAAgB,EAAA;IAxBrB;MA4BK,aAAa,EAAA;IA5BlB;MAiCK,gBAAgB;MAChB,aAAa;MACb,YAAY;MACZ,sBAAsB;MACtB,uBAAuB;MACvB,8BAA8B;MAC9B,wCAAwC;MACxC,oBAAoB;MACpB,0BAA0B;Mf5N9B,gBe8N4B,EAAA;MA3C7B;QA+CO,aAAa,EAAA;MA/CpB;QAmDO,aAAa;QACb,YAAY;QACZ,UAAU;QACV,mBAAmB,EAAA,EACpB;;AA7DX;EAQQ,iBAAiB;EACjB,2BAA2B,EAAA;EATnC;IAYU,mBAAmB,EAAA;IAZ7B;MAeY,kBAAkB,EAAA;IAf9B;MAmBY,kDAAoF;MACpF,iDAAmF,EAAA;EApB/F;IAyBU,iBAAiB,EAAA;EAzB3B;IA6BU,wBAAwB;IACxB,gBAAgB,EAAA;EA9B1B;IAkCU,aAAa,EAAA;EAlCvB;IAuCU,gBAAgB;IAChB,aAAa;IACb,YAAY;IACZ,sBAAsB;IACtB,uBAAuB;IACvB,8BAA8B;IAC9B,wCAAwC;IACxC,oBAAoB;IACpB,0BAA0B;If5N9B,gBe8N4B,EAAA;IAjDlC;MAqDY,aAAa,EAAA;IArDzB;MAyDY,aAAa;MACb,YAAY;MACZ,UAAU;MACV,mBAAmB,EAAA;;AAiB/B;EAEE,4CAAuC;EACvC,kDAAmD;EACnD,qDAAyD;EACzD,8BAAqD;EACrD,6BAAmD;EACnD,mCAA+D;EAC/D,0DAAqE;EACrE,qEAA2D,EAAA;;AC/Q7D;EAEE,wBAAyC;EACzC,wBAAyC;EACzC,gCAAqD;EACrD,yBAAiD;EACjD,4CAAiD;EACjD,gCAAmD;EACnD,sDAA6C;EAC7C,sCAA+D;EAC/D,6BAAmD;EACnD,6BAAmD;EACnD,uCAAqC;EACrC,qBAA2C;EAC3C,kBAAqC;EACrC,iBAAmC;EACnC,+BAA6B;EAC7B,mCAA+D;EAC/D,+BAAiD;EAGjD,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,6BAAiD;EACjD,qBAAqB;EACrB,mCAAmD;EACnD,2BAA2B;EAC3B,qEAAyH;EhCdvH,2CgCe4E,EAAA;EA9BhF;IAkCI,eAAe;IACf,cAAc,EAAA;EAnClB;IAuCI,mBAAmB;IACnB,sBAAsB,EAAA;IAxC1B;MA2CM,mBAAmB;MhCnBrB,0DgCoBgG;MhCnBhG,2DgCmBgG,EAAA;IA5CpG;MAgDM,sBAAsB;MhCVxB,8DgCWmG;MhCVnG,6DgCUmG,EAAA;EAjDvG;;IAyDI,aAAa,EAAA;;AAIjB;EAGE,cAAc;EACd,wDAAoG;EACpG,2BAA8C,EAAA;;AAGhD;EACE,4CAAwE,EAAA;;AAG1E;EACE,qDAAiF;EACjF,gBAAgB,EAAA;;AAGlB;EACE,gBAAgB,EAAA;;AAGlB;EAMI,oCAA0D,EAAA;;AAQ9D;EACE,kEAAwH;EACxH,gBAAgB;EAChB,+BAAsD;EACtD,uCAA2D;EAC3D,4EAAgI,EAAA;EALlI;IhCjFI,wFgCyFkK,EAAA;;AAItK;EACE,kEAAwH;EACxH,+BAAsD;EACtD,uCAA2D;EAC3D,yEAA6H,EAAA;EAJ/H;IhC7FI,wFgCoGkK,EAAA;;AAStK;EACE,sDAAiF;EACjF,sDAAiF;EACjF,qDAAgF;EAChF,gBAAgB,EAAA;EAJlB;IAOI,mCAAmD;IACnD,sCAAsD,EAAA;;AAI1D;EACE,sDAAiF;EACjF,qDAAgF,EAAA;;AAIlF;EACE,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,2CAA4E;EhCrI1E,iDgCsIwF,EAAA;;AAG5F;;;EAGE,WAAW,EAAA;;AAGb;;EhCtII,0DgCwI4F;EhCvI5F,2DgCuI4F,EAAA;;AAGhG;;EhC7HI,8DgC+H+F;EhC9H/F,6DgC8H+F,EAAA;;AAQnG;EAII,0CAAoE,EAAA;;AzBtHpE;EyBkHJ;IAQI,aAAa;IACb,mBAAmB,EAAA;IATvB;MAcM,SAAY;MACZ,gBAAgB,EAAA;MAftB;QAkBQ,cAAc;QACd,cAAc,EAAA;MAnBtB;QhC9II,0BgCuKkC;QhCtKlC,6BgCsKkC,EAAA;QAzBtC;;UA8BY,0BAA0B,EAAA;QA9BtC;;UAmCY,6BAA6B,EAAA;MAnCzC;QhChII,yBgCwKoC;QhCvKpC,4BgCuKoC,EAAA;QAxCxC;;UA6CY,yBAAyB,EAAA;QA7CrC;;UAkDY,4BAA4B,EAAA,EAC7B;;AChOX;EAEE,0CAA6C;EAC7C,oCAAuC;EACvC,8KAAuD;EACvD,mDAA2D;EAC3D,gCAA2D;EAC3D,qCAA6D;EAC7D,uDAAyE;EACzE,qCAA6D;EAC7D,kCAA6D;EAC7D,8CAAqD;EACrD,wCAA+C;EAC/C,iEAAmD;EACnD,sCAA+D;EAC/D,kDAAuE;EACvE,8DAAyE;EACzE,wEAAiE;EACjE,mEAA+E;EAC/E,0EAA2E;EAC3E,sCAA+D;EAC/D,mCAA+D;EAC/D,oCAA2D;EAC3D,kDAAqD,EAAA;;AAIvD;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,4EAA4I;EpCiQxI,mBAvE+B;EoCxLnC,oCAAgE;EAChE,gBAAgB;EAChB,4CAAqE;EACrE,SAAS;EjCtBP,gBiCuBsB;EACxB,qBAAqB;EjB3BjB,0CiB4B2E,EAAA;EjBxB3E;IiBWN;MjBVQ,gBAAgB,EAAA,EiB2DvB;EAjDD;IAgBI,uCAAsE;IACtE,+CAA2E;IAC3E,kGAAgK,EAAA;IAlBpK;MAqBM,qDAAuF;MACvF,iDAAsF,EAAA;EAtB5F;IA4BI,cAAc;IACd,yCAA0E;IAC1E,0CAA2E;IAC3E,iBAAiB;IACjB,WAAW;IACX,8CAAyE;IACzE,4BAA4B;IAC5B,mDAAoF;IjBlDlF,mDiBmD+F,EAAA;IjB/C/F;MiBWN;QjBVQ,gBAAgB,EAAA,EiB+CrB;EArCH;IAwCI,UAAU,EAAA;EAxCd;IA4CI,UAAU;IACV,wDAAiG;IACjG,UAAU;IACV,oDAA2F,EAAA;;AAI/F;EACE,gBAAgB,EAAA;;AAGlB;EACE,gCAAwD;EACxD,wCAA6D;EAC7D,+EAA6I,EAAA;EAH/I;IjC1DI,yDiCgE4F;IjC/D5F,0DiC+D4F,EAAA;IANhG;MjC1DI,+DiCmE0G;MjClE1G,gEiCkE0G,EAAA;EAT9G;IAcI,aAAa,EAAA;EAdjB;IjC5CI,6DiC+D+F;IjC9D/F,4DiC8D+F,EAAA;IAnBnG;MjC5CI,mEiCmE+G;MjClE/G,kEiCkE+G,EAAA;IAvBnH;MjC5CI,6DiCwEiG;MjCvEjG,4DiCuEiG,EAAA;;AAKrG;EACE,8EAAgJ,EAAA;;AAQlJ;EAEI,eAAe,EAAA;;AAFnB;EAMI,eAAe;EACf,cAAc;EjCpHd,gBiCqHwB,EAAA;EAR5B;IAUoB,aAAa,EAAA;EAVjC;IAWmB,gBAAgB,EAAA;EAXnC;IjC7GI,gBiC6H4B,EAAA;;AChJhC;EAEE,4BAAuD;EACvD,4BAAuD;EACvD,mCAA+D;EAE/D,oBAAyC;EACzC,+BAA+D;EAC/D,sCAA+D;EAC/D,sCAAiE;EACjE,0CAAuE;EAGvE,aAAa;EACb,eAAe;EACf,sEAAgI;EAChI,iDAAkF;ErCqR9E,yCAvE+B;EqC5MnC,gBAAgB;EAChB,yCAA+D;ElCA7D,iDkCCwF,EAAA;;AAG5F;EAGI,iDAAmF,EAAA;EAHvF;IAMM,WAAW;IACX,kDAAoF;IACpF,yCAA0E;IAC1E,yFAAgN,EAAO;;AAT7N;EAcI,6CAAkF,EAAA;;ACrCtF;EAEE,kCAAuD;EACvD,mCAAuD;EtCkSnD,+BAvE+B;EsCzNnC,2CAA+C;EAC/C,qCAAyC;EACzC,iCAA6D;EAC7D,oDAA6D;EAC7D,sCAA+D;EAC/D,uDAA2D;EAC3D,uDAAqD;EACrD,0DAAyE;EACzE,uDAA2D;EAC3D,uDAAqD;EACrD,kEAAqE;EACrE,kCAA6D;EAC7D,kCAAuD;EACvD,4CAA2E;EAC3E,uCAAiE;EACjE,8CAA2D;EAC3D,6DAA+E;EAG/E,aAAa;EjCpBb,eAAe;EACf,gBAAgB,EAAA;;AiCuBlB;EACE,kBAAkB;EAClB,cAAc;EACd,sEAAgI;EtCsQ5H,yCAvE+B;EsC7LnC,iCAA0D;EAC1D,qBAAwD;EACxD,yCAA+D;EAC/D,iFAAiJ;EnBpB7I,qIjBq0CoJ,EAAA;EiBj0CpJ;ImBQN;MnBPQ,gBAAgB,EAAA,EmBiDvB;EA1CD;IAYI,UAAU;IACV,uCAAsE;IAEtE,+CAA2E;IAC3E,qDAA2F,EAAA;EAhB/F;IAoBI,UAAU;IACV,uCAAsE;IACtE,+CAA2E;IAC3E,UpCoxCiC;IoCnxCjC,iDAAqF,EAAA;EAxBzF;;IA6BI,UAAU;IACV,wCAAwE;IlBtD1E,gDkBuDkF;IAChF,sDAA6F,EAAA;EAhCjG;;IAqCI,0CAA4E;IAC5E,oBAAoB;IACpB,kDAAiF;IACjF,wDAAiG,EAAA;;AAIrG;EAEI,iBpC8jB6B,EAAA;;AoChkBjC;EnCvBI,0DmC+BoG;EnC9BpG,6DmC8BoG,EAAA;;AARxG;EnCrCI,2DmCmDkG;EnClDlG,8DmCkDkG,EAAA;;AAgBtG;EClGE,iCAAuD;EACvD,iCAAuD;EvCgSnD,qCAvE+B;EuCvNnC,qCAA+D,EAAA;;ADmGjE;ECtGE,iCAAuD;EACvD,kCAAuD;EvCoSjD,qCAf6B;EuCnRnC,qCAA+D,EAAA;EvCgI7D;IsC7BJ;MtCsMQ,qCAlF6B,EAAA,EsClHpC;;AEvGD;EAEE,4BAA6C;EAC7C,4BAA6C;ExC6RzC,4BAvE+B;EwCpNnC,2BAAiD;EACjD,sBAAqC;EACrC,iCAAqD;EAGrD,qBAAqB;EACrB,4DAA4G;ExCqRxG,oCAvE+B;EwC5MnC,wCAAkE;EAClE,cAAc;EACd,4BAAgD;EAChD,kBAAkB;EAClB,mBAAmB;EACnB,wBAAwB;ErCJtB,4CqCK8E,EAAA;EAnBlF;IAwBI,aAAa,EAAA;;AAKjB;EACE,kBAAkB;EAClB,SAAS,EAAA;;AChCX;EAEE,0BAA+B;EAC/B,0BAA6C;EAC7C,4BAA6C;EAC7C,8BAAqD;EACrD,yBAAqC;EACrC,oCAAmD;EACnD,yDAAuC;EACvC,iCAAqD;EAGrD,kBAAkB;EAClB,4DAA4G;EAC5G,4CAAwE;EACxE,4BAAgD;EAChD,oCAAqD;EACrD,8BAAmD;EtCFjD,4CsCG8E,EAAA;;AAIlF;EAEE,cAAc,EAAA;;AAIhB;EACE,gBvCyFwB,EAAA;;AuCjF1B;EACE,mBvCugDkD,EAAA;EuCxgDpD;IAKI,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,UvCqhBuC;IuCphBvC,kBvCucS,EAAA;;AuCvbX;EChEA,yBAAqC;EACrC,sBAA+B;EAC/B,gCAAmD,EAAA;EAMnD;IACE,c1BwMiC,EAAA;;AyBjJnC;EChEA,yBAAqC;EACrC,sBAA+B;EAC/B,gCAAmD,EAAA;EAMnD;IACE,c1BwMiC,EAAA;;AyBjJnC;EChEA,yBAAqC;EACrC,sBAA+B;EAC/B,gCAAmD,EAAA;EAMnD;IACE,c1BwMiC,EAAA;;AyBjJnC;EChEA,yBAAqC;EACrC,sBAA+B;EAC/B,gCAAmD,EAAA;EAMnD;IACE,c1BwMiC,EAAA;;AyBjJnC;EChEA,yBAAqC;EACrC,sBAA+B;EAC/B,gCAAmD,EAAA;EAMnD;IACE,c1BwMiC,EAAA;;AyBjJnC;EChEA,yBAAqC;EACrC,sBAA+B;EAC/B,gCAAmD,EAAA;EAMnD;IACE,c1BwMiC,EAAA;;AyBjJnC;EChEA,yBAAqC;EACrC,sBAA+B;EAC/B,gCAAmD,EAAA;EAMnD;IACE,c1BwMiC,EAAA;;AyBjJnC;EChEA,yBAAqC;EACrC,sBAA+B;EAC/B,gCAAmD,EAAA;EAMnD;IACE,c1BwMiC,EAAA;;A2B/MnC;EACE;IAAK,+BzCmjDmC,EAAA,EAAA;;AyC9iD5C;EAEE,8BAA6C;E3CyRzC,mCAvE+B;E2ChNnC,uCAAqC;EACrC,oCAA2D;EAC3D,8DAAqD;EACrD,6BAAmD;EACnD,6BAA6C;EAC7C,6CAA6D;EAG7D,aAAa;EACb,iCAAyD;EACzD,gBAAgB;E3C6QZ,uCAvE+B;E2CpMnC,uCAA2D;ExCPzD,+CwCQoF,EAAA;;AAIxF;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;EAChB,mCAA8D;EAC9D,kBAAkB;EAClB,mBAAmB;EACnB,2CAAmE;ExBvB/D,6CwBwBiF,EAAA;ExBpBjF;IwBWN;MxBVQ,gBAAgB,EAAA,EwBoBvB;;AAED;EvBCE,qMAA6I;EuBC7I,oEAAoH,EAAA;;AAIpH;EACE,kDAA8D,EAAA;EAG5D;IAJJ;MAKM,eAAe,EAAA,EAGpB;;ACrDH;EAEE,2CAA+C;EAC/C,qCAAyC;EACzC,oDAA6D;EAC7D,iCAA6D;EAC7D,sCAA+D;EAC/D,oCAAiE;EACjE,sCAAiE;EACjE,kDAA6D;EAC7D,wDAAyE;EACzE,8DAAmE;EACnE,yDAA2E;EAC3E,+DAAqE;EACrE,uCAAiE;EACjE,8CAA2D;EAC3D,kCAA6D;EAC7D,kCAAuD;EACvD,4CAA2E;EAG3E,aAAa;EACb,sBAAsB;EAGtB,eAAe;EACf,gBAAgB;EzCXd,iDyCYwF,EAAA;;AAG5F;EACE,qBAAqB;EACrB,sBAAsB,EAAA;EAFxB;IAMI,oCAAoC;IACpC,0BAA0B,EAAA;;AAS9B;EACE,WAAW;EACX,wCAAwE;EACxE,mBAAmB,EAAA;EAHrB;IAQI,UAAU;IACV,8CAAoF;IACpF,qBAAqB;IACrB,sDAAyF,EAAA;EAX7F;IAeI,+CAAsF;IACtF,uDAA2F,EAAA;;AAQ/F;EACE,kBAAkB;EAClB,cAAc;EACd,gFAAoJ;EACpJ,iCAA0D;EAC1D,qBAAwD;EACxD,yCAA+D;EAC/D,iFAAiJ,EAAA;EAPnJ;IzC9CI,+ByCwDkC;IzCvDlC,gCyCuDkC,EAAA;EAVtC;IzChCI,mCyC8CqC;IzC7CrC,kCyC6CqC,EAAA;EAdzC;IAmBI,0CAA4E;IAC5E,oBAAoB;IACpB,kDAAiF,EAAA;EArBrF;IA0BI,UAAU;IACV,wCAAwE;IACxE,gDAA6E;IAC7E,sDAA6F,EAAA;EA7BjG;IAkCI,mBAAmB,EAAA;IAlCvB;MAqCM,wDAAwF;MACxF,mDAAmF,EAAA;;AAarF;EACE,mBAAmB,EAAA;EADrB;IzCnDA,6DyCwD6G;IzCpE7G,0ByCqEsC,EAAA;EANtC;IzC/DA,2DyCyEwG;IzC7DxG,4ByC8D2C,EAAA;EAX3C;IAeM,aAAa,EAAA;EAfnB;IAmBM,mDAAmF;IACnF,oBAAoB,EAAA;IApB1B;MAuBQ,yDAAyF;MACzF,oDAAoF,EAAA;;AlCtF5F;EkC8DA;IACE,mBAAmB,EAAA;IADrB;MzCnDA,6DyCwD6G;MzCpE7G,0ByCqEsC,EAAA;IANtC;MzC/DA,2DyCyEwG;MzC7DxG,4ByC8D2C,EAAA;IAX3C;MAeM,aAAa,EAAA;IAfnB;MAmBM,mDAAmF;MACnF,oBAAoB,EAAA;MApB1B;QAuBQ,yDAAyF;QACzF,oDAAoF,EAAA,EACrF;;AlCvFP;EkC8DA;IACE,mBAAmB,EAAA;IADrB;MzCnDA,6DyCwD6G;MzCpE7G,0ByCqEsC,EAAA;IANtC;MzC/DA,2DyCyEwG;MzC7DxG,4ByC8D2C,EAAA;IAX3C;MAeM,aAAa,EAAA;IAfnB;MAmBM,mDAAmF;MACnF,oBAAoB,EAAA;MApB1B;QAuBQ,yDAAyF;QACzF,oDAAoF,EAAA,EACrF;;AlCvFP;EkC8DA;IACE,mBAAmB,EAAA;IADrB;MzCnDA,6DyCwD6G;MzCpE7G,0ByCqEsC,EAAA;IANtC;MzC/DA,2DyCyEwG;MzC7DxG,4ByC8D2C,EAAA;IAX3C;MAeM,aAAa,EAAA;IAfnB;MAmBM,mDAAmF;MACnF,oBAAoB,EAAA;MApB1B;QAuBQ,yDAAyF;QACzF,oDAAoF,EAAA,EACrF;;AlCvFP;EkC8DA;IACE,mBAAmB,EAAA;IADrB;MzCnDA,6DyCwD6G;MzCpE7G,0ByCqEsC,EAAA;IANtC;MzC/DA,2DyCyEwG;MzC7DxG,4ByC8D2C,EAAA;IAX3C;MAeM,aAAa,EAAA;IAfnB;MAmBM,mDAAmF;MACnF,oBAAoB,EAAA;MApB1B;QAuBQ,yDAAyF;QACzF,oDAAoF,EAAA,EACrF;;AlCvFP;EkC8DA;IACE,mBAAmB,EAAA;IADrB;MzCnDA,6DyCwD6G;MzCpE7G,0ByCqEsC,EAAA;IANtC;MzC/DA,2DyCyEwG;MzC7DxG,4ByC8D2C,EAAA;IAX3C;MAeM,aAAa,EAAA;IAfnB;MAmBM,mDAAmF;MACnF,oBAAoB,EAAA;MApB1B;QAuBQ,yDAAyF;QACzF,oDAAoF,EAAA,EACrF;;AAaX;EzChJI,gByCiJsB,EAAA;EAD1B;IAII,mDAAmF,EAAA;IAJvF;MAOM,sBAAsB,EAAA;;ACtK1B;EACE,c7B8MiC;E6B7MjC,yB7BwMiC,EAAA;E6B1MnC;IAOM,c7BwM6B;I6BvM7B,yB7BuM6B,EAAA;E6B/MnC;IAYM,W3CiIO;I2ChIP,yB7BkM6B;I6BjM7B,qB7BiM6B,EAAA;;A6B/MnC;EACE,c7B8MiC;E6B7MjC,yB7BwMiC,EAAA;E6B1MnC;IAOM,c7BwM6B;I6BvM7B,yB7BuM6B,EAAA;E6B/MnC;IAYM,W3CiIO;I2ChIP,yB7BkM6B;I6BjM7B,qB7BiM6B,EAAA;;A6B/MnC;EACE,c7B8MiC;E6B7MjC,yB7BwMiC,EAAA;E6B1MnC;IAOM,c7BwM6B;I6BvM7B,yB7BuM6B,EAAA;E6B/MnC;IAYM,W3CiIO;I2ChIP,yB7BkM6B;I6BjM7B,qB7BiM6B,EAAA;;A6B/MnC;EACE,c7B8MiC;E6B7MjC,yB7BwMiC,EAAA;E6B1MnC;IAOM,c7BwM6B;I6BvM7B,yB7BuM6B,EAAA;E6B/MnC;IAYM,W3CiIO;I2ChIP,yB7BkM6B;I6BjM7B,qB7BiM6B,EAAA;;A6B/MnC;EACE,c7B8MiC;E6B7MjC,yB7BwMiC,EAAA;E6B1MnC;IAOM,c7BwM6B;I6BvM7B,yB7BuM6B,EAAA;E6B/MnC;IAYM,W3CiIO;I2ChIP,yB7BkM6B;I6BjM7B,qB7BiM6B,EAAA;;A6B/MnC;EACE,c7B8MiC;E6B7MjC,yB7BwMiC,EAAA;E6B1MnC;IAOM,c7BwM6B;I6BvM7B,yB7BuM6B,EAAA;E6B/MnC;IAYM,W3CiIO;I2ChIP,yB7BkM6B;I6BjM7B,qB7BiM6B,EAAA;;A6B/MnC;EACE,c7B8MiC;E6B7MjC,yB7BwMiC,EAAA;E6B1MnC;IAOM,c7BwM6B;I6BvM7B,yB7BuM6B,EAAA;E6B/MnC;IAYM,W3CiIO;I2ChIP,yB7BkM6B;I6BjM7B,qB7BiM6B,EAAA;;A6B/MnC;EACE,c7B8MiC;E6B7MjC,yB7BwMiC,EAAA;E6B1MnC;IAOM,c7BwM6B;I6BvM7B,yB7BuM6B,EAAA;E6B/MnC;IAYM,W3CiIO;I2ChIP,yB7BkM6B;I6BjM7B,qB7BiM6B,EAAA;;A8B9MrC;EACE,uBAAuB;EACvB,U5CsrD8B;E4CrrD9B,W5CqrD8B;E4CprD9B,sB5CsrDgC;E4CrrDhC,W5CiJa;E4ChJb,0FAA0F;EAC1F,SAAS;E3COP,sBDkoBgC;E4CvoBlC,Y5CsrD6B,EAAA;E4C/rD/B;IAaI,W5CyIW;I4CxIX,qBAAqB;IACrB,a5CirD4B,EAAA;E4ChsDhC;IAmBI,UAAU;IACV,4C5CqJgB;I4CpJhB,U5C4qD0B,EAAA;E4CjsD9B;IA0BI,oBAAoB;IACpB,yBAAiB;YAAjB,iBAAiB;IACjB,a5CsqD4B,EAAA;;A4ClqDhC;EACE,kD5CkqDqE,EAAA;;A6CxsDvE;EAEE,uBAAuC;EACvC,6BAA6C;EAC7C,4BAA6C;EAC7C,2BAAyC;EACzC,2BAA6C;E/C+RzC,8BAvE+B;E+CtNnC,kBAAqC;EACrC,+CAA+B;EAC/B,4BAAmD;EACnD,qDAAmD;EACnD,iCAAqD;EACrD,uDAA+C;EAC/C,gCAAmD;EACnD,sDAA6C;EAC7C,mEAAiE;EAGjE,gCAAwD;EACxD,eAAe;E/CiRX,oCAvE+B;E+CxMnC,4BAAgD;EAChD,oBAAoB;EACpB,oCAAqD;EACrD,4BAA4B;EAC5B,uEAA6H;EAC7H,sCAA+D;E5CR7D,4C4CS8E,EAAA;EA5BlF;IA+BI,UAAU,EAAA;EA/Bd;IAmCI,aAAa,EAAA;;AAIjB;EACE,uBAAuC;EAEvC,kBAAkB;EAClB,+BAAoD;EACpD,kBAAkB;EAClB,eAAe;EACf,oBAAoB,EAAA;EAPtB;IAUI,sCAA4D,EAAA;;AAIhE;EACE,aAAa;EACb,mBAAmB;EACnB,4DAA4G;EAC5G,mCAA8D;EAC9D,2CAAmE;EACnE,4BAA4B;EAC5B,qFAAkJ;E5ChChJ,0F4CiCkJ;E5ChClJ,2F4CgCkJ,EAAA;EARtJ;IAWI,mDAA2E;IAC3E,sCAA8D,EAAA;;AAIlE;EACE,kCAA0D;EAC1D,qBAAqB,EAAA;;AC9DvB;EAEE,uBAAuC;EACvC,uBAAqC;EACrC,2BAAyC;EACzC,yBAAuC;EACvC,kBAAqC;EACrC,iCAA+B;EAC/B,+CAAmD;EACnD,4BAAmD;EACnD,gCAAqD;EACrD,8DAA+C;EAC/C,kDAAiE;EACjE,oCAA2D;EAC3D,oCAA2D;EAC3D,0CAAuD;EACvD,sDAAiE;EACjE,iCAAiE;EACjE,iCAA6D;EAC7D,6BAA+C;EAC/C,sBAA6C;EAC7C,sDAAiE;EACjE,iCAAiE;EAGjE,eAAe;EACf,MAAM;EACN,OAAO;EACP,+BAAoD;EACpD,aAAa;EACb,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAGhB,UAAU,EAAA;;AAOZ;EACE,kBAAkB;EAClB,WAAW;EACX,8BAAmD;EAEnD,oBAAoB,EAAA;EAGpB;I7B5CI,mCjB8gDoD;I8Ch+CtD,8B9C89CmD,EAAA;IiBxgDjD;M6BwCJ;Q7BvCM,gBAAgB,EAAA,E6B0CrB;EACD;IACE,e9C49CoC,EAAA;E8Cx9CtC;IACE,sB9Cy9C2C,EAAA;;A8Cr9C/C;EACE,+CAAoE,EAAA;EADtE;IAII,gBAAgB;IAChB,gBAAgB,EAAA;EALpB;IASI,gBAAgB,EAAA;;AAIpB;EACE,aAAa;EACb,mBAAmB;EACnB,mDAAwE,EAAA;;AAI1E;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,WAAW;EAEX,4BAAgD;EAChD,oBAAoB;EACpB,oCAAqD;EACrD,4BAA4B;EAC5B,uEAA6H;E7CrF3H,4C6CsF8E;EAGhF,UAAU,EAAA;;AAIZ;EAEE,0BAA6C;EAC7C,sBAAqC;EACrC,0BAA+C;EClH/C,eAAe;EACf,MAAM;EACN,OAAO;EACP,kCDkH2E;ECjH3E,YAAY;EACZ,aAAa;EACb,uCD+GsH,EAAA;EC5GtH;IAAS,UAAU,EAAA;EACnB;IAAS,mCD2GkK,EAAA;;AAK7K;EACE,aAAa;EACb,cAAc;EACd,mBAAmB;EACnB,8BAA8B;EAC9B,uCAAoE;EACpE,4FAAgK;E7CtG9J,2D6CuG8F;E7CtG9F,4D6CsG8F,EAAA;EAPlG;IAUI,gGAA8J;IAC9J,mJAAgP,EAAA;;AAKpP;EACE,gBAAgB;EAChB,8CAA8E,EAAA;;AAKhF;EACE,kBAAkB;EAGlB,cAAc;EACd,gCAAsD,EAAA;;AAIxD;EACE,aAAa;EACb,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,yBAAyB;EACzB,wEAAuH;EACvH,2CAAmE;EACnE,yFAA6J;E7C1H3J,+D6C2HiG;E7C1HjG,8D6C0HiG,EAAA;EATrG;IAeI,6CAAsE,EAAA;;AtC5GtE;EsCtDJ;IAyKI,0BAAuC;IACvC,uDAA+C,EAAA;EA/HnD;IAoII,gCAAoD;IACpD,kBAAkB;IAClB,iBAAiB,EAAA;EAGnB;IACE,uBAAqC,EAAA,EACtC;;AtChIC;EsCoIF;;IAEE,uBAAqC,EAAA,EACtC;;AtCvIC;EsC2IF;IACE,wBAAqC,EAAA,EACtC;;AASC;EACE,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,SAAS,EAAA;EAJX;IAOI,YAAY;IACZ,SAAS;I7C1Mb,gB6C2M4B,EAAA;EAT5B;;I7ClMA,gB6CgN4B,EAAA;EAd5B;IAkBI,gBAAgB,EAAA;;AtC3JpB;EsCyIA;IACE,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,SAAS,EAAA;IAJX;MAOI,YAAY;MACZ,SAAS;M7C1Mb,gB6C2M4B,EAAA;IAT5B;;M7ClMA,gB6CgN4B,EAAA;IAd5B;MAkBI,gBAAgB,EAAA,EACjB;;AtC5JH;EsCyIA;IACE,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,SAAS,EAAA;IAJX;MAOI,YAAY;MACZ,SAAS;M7C1Mb,gB6C2M4B,EAAA;IAT5B;;M7ClMA,gB6CgN4B,EAAA;IAd5B;MAkBI,gBAAgB,EAAA,EACjB;;AtC5JH;EsCyIA;IACE,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,SAAS,EAAA;IAJX;MAOI,YAAY;MACZ,SAAS;M7C1Mb,gB6C2M4B,EAAA;IAT5B;;M7ClMA,gB6CgN4B,EAAA;IAd5B;MAkBI,gBAAgB,EAAA,EACjB;;AtC5JH;EsCyIA;IACE,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,SAAS,EAAA;IAJX;MAOI,YAAY;MACZ,SAAS;M7C1Mb,gB6C2M4B,EAAA;IAT5B;;M7ClMA,gB6CgN4B,EAAA;IAd5B;MAkBI,gBAAgB,EAAA,EACjB;;AtC5JH;EsCyIA;IACE,YAAY;IACZ,eAAe;IACf,YAAY;IACZ,SAAS,EAAA;IAJX;MAOI,YAAY;MACZ,SAAS;M7C1Mb,gB6C2M4B,EAAA;IAT5B;;M7ClMA,gB6CgN4B,EAAA;IAd5B;MAkBI,gBAAgB,EAAA,EACjB;;AEvOP;EAEE,yBAA2C;EAC3C,6BAAiD;EACjD,8BAAiD;EACjD,8BAAiD;EACjD,sBAA2C;ElDkSrC,kCAf6B;EkDjRnC,wBAAyC;EACzC,qBAAmC;EACnC,kCAAyD;EACzD,yBAA6C;EAC7C,gCAAqD;EACrD,iCAAuD;EAGvD,iCAAwD;EACxD,cAAc;EACd,uCAAoE;EACpE,gCAAuD;ECnBvD,sCjDssBsF;EiDpsBtF,kBAAkB;EAClB,gBjD+sB+B;EiD9sB/B,gBjDotB+B;EiDntB/B,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EnDsRZ,sCAvE+B;EkDnMnC,qBAAqB;EACrB,UAAU,EAAA;ElD2GR;IkDtIJ;MlD+SQ,kCAlF6B,EAAA,EkDlLpC;EA3CD;IA6BW,kCAA0D,EAAA;EA7BrE;IAgCI,cAAc;IACd,oCAAgE;IAChE,sCAAmE,EAAA;IAlCvE;MAqCM,kBAAkB;MAClB,WAAW;MACX,yBAAyB;MACzB,mBAAmB,EAAA;;AAKzB;EACE,SAAS,EAAA;EADX;IAII,SAAS;IACT,uFAAgJ;IAChJ,sCAAyD,EAAA;;AAI7D,qBAAA;AACA;EACE,OAAO;EACP,qCAAkE;EAClE,qCAAiE,EAAA;EAHnE;IAMI,WAAW;IACX,gIAAqN;IACrN,wCAA2D,EAAA;;AAI/D,mBAAA;AAEA;EACE,MAAM,EAAA;EADR;IAII,YAAY;IACZ,uFAAgJ;IAChJ,yCAA4D,EAAA;;AAIhE,qBAAA;AACA;EACE,QAAQ;EACR,qCAAkE;EAClE,qCAAiE,EAAA;EAHnE;IAMI,UAAU;IACV,gIAAqN;IACrN,uCAA0D,EAAA;;AAI9D,mBAAA;AAkBA;EACE,sCAAgE;EAChE,gEAAoH;EACpH,8BAAoD;EACpD,kBAAkB;EAClB,sCAAyD;E/ClGvD,8C+CmGkF,EAAA;;AEtHtF;EAEE,yBAA2C;EAC3C,6BAAiD;EpDkS7C,gCAvE+B;EoDzNnC,qCAAmC;EACnC,8BAAuD;EACvD,iDAAuD;EACvD,mCAAyD;EACzD,qDAAqE;EACrE,0DAAmD;EACnD,mCAA+D;EAC/D,qCAA+D;EpDyR3D,mCAvE+B;EoDhNnC,2BAAuD;EACvD,4CAAiD;EACjD,iCAA2D;EAC3D,iCAA2D;EAC3D,6CAAmD;EACnD,8BAAqD;EACrD,iCAAuD;EACvD,yDAAuD;EAGvD,iCAAwD;EACxD,cAAc;EACd,sCAAgE;EDzBhE,sCjDssBsF;EiDpsBtF,kBAAkB;EAClB,gBjD+sB+B;EiD9sB/B,gBjDotB+B;EiDntB/B,gBAAgB;EAChB,iBAAiB;EACjB,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;EACpB,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,gBAAgB;EnDsRZ,sCAvE+B;EoD9LnC,qBAAqB;EACrB,sCAAyD;EACzD,4BAA4B;EAC5B,2EAAqI;EjDhBnI,8CiDiBkF,EAAA;EApCtF;IAwCI,cAAc;IACd,oCAAgE;IAChE,sCAAmE,EAAA;IA1CvE;MA8CM,kBAAkB;MAClB,cAAc;MACd,WAAW;MACX,yBAAyB;MACzB,mBAAmB;MACnB,eAAe,EAAA;;AAKrB;EAEI,oFAA8I,EAAA;EAFlJ;IAMM,uFAAgJ,EAAA;EANtJ;IAUM,SAAS;IACT,gDAA6E,EAAA;EAXnF;IAeM,sCAAmE;IACnE,sCAAyD,EAAA;;AAK/D,qBAAA;AACA;EAEI,kFAA4I;EAC5I,qCAAkE;EAClE,qCAAiE,EAAA;EAJrE;IAQM,gIAAqN,EAAA;EAR3N;IAYM,OAAO;IACP,kDAA+E,EAAA;EAbrF;IAiBM,oCAAiE;IACjE,wCAA2D,EAAA;;AAKjE,mBAAA;AAEA;EAEI,iFAA2I,EAAA;EAF/I;IAMM,uFAAgJ,EAAA;EANtJ;IAUM,MAAM;IACN,mDAAgF,EAAA;EAXtF;IAeM,mCAAgE;IAChE,yCAA4D,EAAA;;AAhBlE;EAsBI,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,cAAc;EACd,oCAAgE;EAChE,sDAAkF;EAClF,WAAW;EACX,+EAAsI,EAAA;;AAI1I,qBAAA;AACA;EAEI,mFAA6I;EAC7I,qCAAkE;EAClE,qCAAiE,EAAA;EAJrE;IAQM,gIAAqN,EAAA;EAR3N;IAYM,QAAQ;IACR,iDAA8E,EAAA;EAbpF;IAiBM,qCAAkE;IAClE,uCAA0D,EAAA;;AAKhE,mBAAA;AAkBA;EACE,8EAAgJ;EAChJ,gBAAgB;EpDiHZ,6CAvE+B;EoDxCnC,qCAAkE;EAClE,6CAAuE;EACvE,kFAA4I;EjD5J1I,6DiD6JkG;EjD5JlG,8DiD4JkG,EAAA;EAPtG;IAUI,aAAa,EAAA;;AAIjB;EACE,0EAAwI;EACxI,mCAA8D,EAAA;;ACrLhE;EACE,kBAAkB,EAAA;;AAGpB;EACE,mBAAmB,EAAA;;AAGrB;EACE,kBAAkB;EAClB,WAAW;EACX,gBAAgB,EAAA;ECtBhB;IACE,cAAc;IACd,WAAW;IACX,WAAW,EAAA;;ADuBf;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,WAAW;EACX,mBAAmB;EACnB,2BAA2B;ElClBvB,sCjBmpDkF,EAAA;EiB/oDlF;IkCQN;MlCPQ,gBAAgB,EAAA,EkCevB;;AAED;;;EAGE,cAAc,EAAA;;AAGhB;;EAEE,2BAA2B,EAAA;;AAG7B;;EAEE,4BAA4B,EAAA;;AAQ9B;EAEI,UAAU;EACV,4BAA4B;EAC5B,eAAe,EAAA;;AAJnB;;;EAUI,UAAU;EACV,UAAU,EAAA;;AAXd;;EAgBI,UAAU;EACV,UAAU;ElC5DR,2BjBkpDkC,EAAA;EiB9oDlC;IkCuCN;;MlCtCQ,gBAAgB,EAAA,EkCyDrB;;AAQH;;EAEE,kBAAkB;EAClB,MAAM;EACN,SAAS;EACT,UAAU;EAEV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,UnD0iDsC;EmDziDtC,UAAU;EACV,WnD+Ca;EmD9Cb,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;EACT,YnDqiDqC;EiB3nDjC,8BjB6nDgD,EAAA;EiBznDhD;IkCkEN;;MlCjEQ,gBAAgB,EAAA,EkC4FvB;EA3BD;;;IAsBI,WnDqCW;ImDpCX,qBAAqB;IACrB,UAAU;IACV,YnD6hDmC,EAAA;;AmD1hDvC;EACE,OAAO,EAAA;;AAGT;EACE,QAAQ,EAAA;;AAKV;;EAEE,qBAAqB;EACrB,WnD8hDuC;EmD7hDvC,YnD6hDuC;EmD5hDvC,4BAA4B;EAC5B,wBAAwB;EACxB,0BAA0B,EAAA;;AAG5B;;;;;;;G9Dsv0CG;A8D9u0CH;EACE,0DrCRgF,EAAA;;AqCUlF;EACE,0DrCXgF,EAAA;;AqCmBlF;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,OAAO;EACP,UAAU;EACV,aAAa;EACb,uBAAuB;EACvB,UAAU;EAEV,iBnDs+CsC;EmDr+CtC,mBAAmB;EACnB,gBnDo+CsC;EmDn+CtC,gBAAgB,EAAA;EAblB;IAgBI,uBAAuB;IACvB,cAAc;IACd,WnDm+CqC;ImDl+CrC,WnDm+CoC;ImDl+CpC,UAAU;IACV,iBnDm+CoC;ImDl+CpC,gBnDk+CoC;ImDj+CpC,mBAAmB;IACnB,eAAe;IACf,sBnDlCW;ImDmCX,4BAA4B;IAC5B,SAAS;IAET,kCAAiE;IACjE,qCAAoE;IACpE,YnD09CmC;IiBnoDjC,6BjBsoD+C,EAAA;IiBloD/C;MkCsIN;QlCrIQ,gBAAgB,EAAA,EkCsKrB;EAjCH;IAoCI,UnDu9CkC,EAAA;;AmD98CtC;EACE,kBAAkB;EAClB,UAA4C;EAC5C,enDi9C0C;EmDh9C1C,SAA2C;EAC3C,oBnD88C0C;EmD78C1C,uBnD68C0C;EmD58C1C,WnD7Da;EmD8Db,kBAAkB,EAAA;;AAKpB;;EAGI,gCnDg9CyD,EAAA;;AmDn9C7D;EAOI,sBnDhEW,EAAA;;AmDyDf;EAWI,WnDpEW,EAAA;;AqDvJf;;EAEE,qBAAqB;EACrB,8BAAoD;EACpD,gCAAuD;EACvD,gDAA+E;EAE/E,kBAAkB;EAClB,6FAA4J,EAAA;;AAI9J;EACE;IAAK,0CAA+C,EAAA,EAAA;;AAItD;EAEE,wBAAyC;EACzC,yBAA2C;EAC3C,qCAA2D;EAC3D,iCAAuD;EACvD,mCAA6D;EAC7D,2CAA2D;EAG3D,yDAAsF;EACtF,+BAA+B,EAAA;;AAGjC;EAEE,wBAAyC;EACzC,yBAA2C;EAC3C,gCAAuD,EAAA;;AASzD;EACE;IACE,mBAAmB,EAAA;EAErB;IACE,UAAU;IACV,eAAe,EAAA,EAAA;;AAKnB;EAEE,wBAAyC;EACzC,yBAA2C;EAC3C,qCAA2D;EAC3D,mCAA6D;EAC7D,yCAA2D;EAG3D,8BAA8B;EAC9B,UAAU,EAAA;;AAGZ;EACE,wBAAyC;EACzC,yBAA2C,EAAA;;AAI3C;EACE;;IAEE,kCAA6D,EAAA,EAC9D;;AChFL;EAEE,2BAA+C;EAC/C,2BAA6C;EAC7C,2BAA+C;EAC/C,iCAAqD;EACrD,iCAAqD;EACrD,sBAA6C;EAC7C,qCAAuC;EACvC,gCAA2D;EAC3D,mDAA2D;EAC3D,kEAAuD,EAAA;;A9C+DrD;E8C9CF;IAEI,eAAe;IACf,SAAS;IACT,mCAA4D;IAC5D,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,gCAAwD;IACxD,kBAAkB;IAClB,wCAA6D;IAC7D,4BAA4B;IAC5B,UAAU;IrC1BV,sCqC4BwE,EAAA,EAqE3E;ErC7FG;IqCUJ;MrCTM,gBAAgB,EAAA,EqC4FrB;;A9CrCC;I8C9CF;MAiBM,MAAM;MACN,OAAO;MACP,gCAAwD;MACxD,qFAAmJ;MACnJ,4BAA4B,EAAA;IArBlC;MAyBM,MAAM;MACN,QAAQ;MACR,gCAAwD;MACxD,oFAAkJ;MAClJ,2BAA2B,EAAA;IA7BjC;MAiCM,MAAM;MACN,QAAQ;MACR,OAAO;MACP,kCAA2D;MAC3D,gBAAgB;MAChB,sFAAoJ;MACpJ,4BAA4B,EAAA;IAvClC;MA2CM,QAAQ;MACR,OAAO;MACP,kCAA2D;MAC3D,gBAAgB;MAChB,mFAAiJ;MACjJ,2BAA2B,EAAA;IAhDjC;MAqDM,eAAe,EAAA;IArDrB;MA2DM,mBAAmB,EAAA,EACpB;;A9C3BH;E8CjCF;IAiEM,2BAA+C;IAC/C,8BAA2D;IAC3D,wCAAwC,EAAA;IAnE9C;MAsEQ,aAAa,EAAA;IAtErB;MA0EQ,aAAa;MACb,YAAY;MACZ,UAAU;MACV,mBAAmB;MAEnB,wCAAwC,EAAA,EACzC;;A9ClCL;E8C9CF;IAEI,eAAe;IACf,SAAS;IACT,mCAA4D;IAC5D,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,gCAAwD;IACxD,kBAAkB;IAClB,wCAA6D;IAC7D,4BAA4B;IAC5B,UAAU;IrC1BV,sCqC4BwE,EAAA,EAqE3E;ErC7FG;IqCUJ;MrCTM,gBAAgB,EAAA,EqC4FrB;;A9CrCC;I8C9CF;MAiBM,MAAM;MACN,OAAO;MACP,gCAAwD;MACxD,qFAAmJ;MACnJ,4BAA4B,EAAA;IArBlC;MAyBM,MAAM;MACN,QAAQ;MACR,gCAAwD;MACxD,oFAAkJ;MAClJ,2BAA2B,EAAA;IA7BjC;MAiCM,MAAM;MACN,QAAQ;MACR,OAAO;MACP,kCAA2D;MAC3D,gBAAgB;MAChB,sFAAoJ;MACpJ,4BAA4B,EAAA;IAvClC;MA2CM,QAAQ;MACR,OAAO;MACP,kCAA2D;MAC3D,gBAAgB;MAChB,mFAAiJ;MACjJ,2BAA2B,EAAA;IAhDjC;MAqDM,eAAe,EAAA;IArDrB;MA2DM,mBAAmB,EAAA,EACpB;;A9C3BH;E8CjCF;IAiEM,2BAA+C;IAC/C,8BAA2D;IAC3D,wCAAwC,EAAA;IAnE9C;MAsEQ,aAAa,EAAA;IAtErB;MA0EQ,aAAa;MACb,YAAY;MACZ,UAAU;MACV,mBAAmB;MAEnB,wCAAwC,EAAA,EACzC;;A9ClCL;E8C9CF;IAEI,eAAe;IACf,SAAS;IACT,mCAA4D;IAC5D,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,gCAAwD;IACxD,kBAAkB;IAClB,wCAA6D;IAC7D,4BAA4B;IAC5B,UAAU;IrC1BV,sCqC4BwE,EAAA,EAqE3E;ErC7FG;IqCUJ;MrCTM,gBAAgB,EAAA,EqC4FrB;;A9CrCC;I8C9CF;MAiBM,MAAM;MACN,OAAO;MACP,gCAAwD;MACxD,qFAAmJ;MACnJ,4BAA4B,EAAA;IArBlC;MAyBM,MAAM;MACN,QAAQ;MACR,gCAAwD;MACxD,oFAAkJ;MAClJ,2BAA2B,EAAA;IA7BjC;MAiCM,MAAM;MACN,QAAQ;MACR,OAAO;MACP,kCAA2D;MAC3D,gBAAgB;MAChB,sFAAoJ;MACpJ,4BAA4B,EAAA;IAvClC;MA2CM,QAAQ;MACR,OAAO;MACP,kCAA2D;MAC3D,gBAAgB;MAChB,mFAAiJ;MACjJ,2BAA2B,EAAA;IAhDjC;MAqDM,eAAe,EAAA;IArDrB;MA2DM,mBAAmB,EAAA,EACpB;;A9C3BH;E8CjCF;IAiEM,2BAA+C;IAC/C,8BAA2D;IAC3D,wCAAwC,EAAA;IAnE9C;MAsEQ,aAAa,EAAA;IAtErB;MA0EQ,aAAa;MACb,YAAY;MACZ,UAAU;MACV,mBAAmB;MAEnB,wCAAwC,EAAA,EACzC;;A9ClCL;E8C9CF;IAEI,eAAe;IACf,SAAS;IACT,mCAA4D;IAC5D,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,gCAAwD;IACxD,kBAAkB;IAClB,wCAA6D;IAC7D,4BAA4B;IAC5B,UAAU;IrC1BV,sCqC4BwE,EAAA,EAqE3E;ErC7FG;IqCUJ;MrCTM,gBAAgB,EAAA,EqC4FrB;;A9CrCC;I8C9CF;MAiBM,MAAM;MACN,OAAO;MACP,gCAAwD;MACxD,qFAAmJ;MACnJ,4BAA4B,EAAA;IArBlC;MAyBM,MAAM;MACN,QAAQ;MACR,gCAAwD;MACxD,oFAAkJ;MAClJ,2BAA2B,EAAA;IA7BjC;MAiCM,MAAM;MACN,QAAQ;MACR,OAAO;MACP,kCAA2D;MAC3D,gBAAgB;MAChB,sFAAoJ;MACpJ,4BAA4B,EAAA;IAvClC;MA2CM,QAAQ;MACR,OAAO;MACP,kCAA2D;MAC3D,gBAAgB;MAChB,mFAAiJ;MACjJ,2BAA2B,EAAA;IAhDjC;MAqDM,eAAe,EAAA;IArDrB;MA2DM,mBAAmB,EAAA,EACpB;;A9C3BH;E8CjCF;IAiEM,2BAA+C;IAC/C,8BAA2D;IAC3D,wCAAwC,EAAA;IAnE9C;MAsEQ,aAAa,EAAA;IAtErB;MA0EQ,aAAa;MACb,YAAY;MACZ,UAAU;MACV,mBAAmB;MAEnB,wCAAwC,EAAA,EACzC;;A9ClCL;E8C9CF;IAEI,eAAe;IACf,SAAS;IACT,mCAA4D;IAC5D,aAAa;IACb,sBAAsB;IACtB,eAAe;IACf,gCAAwD;IACxD,kBAAkB;IAClB,wCAA6D;IAC7D,4BAA4B;IAC5B,UAAU;IrC1BV,sCqC4BwE,EAAA,EAqE3E;ErC7FG;IqCUJ;MrCTM,gBAAgB,EAAA,EqC4FrB;;A9CrCC;I8C9CF;MAiBM,MAAM;MACN,OAAO;MACP,gCAAwD;MACxD,qFAAmJ;MACnJ,4BAA4B,EAAA;IArBlC;MAyBM,MAAM;MACN,QAAQ;MACR,gCAAwD;MACxD,oFAAkJ;MAClJ,2BAA2B,EAAA;IA7BjC;MAiCM,MAAM;MACN,QAAQ;MACR,OAAO;MACP,kCAA2D;MAC3D,gBAAgB;MAChB,sFAAoJ;MACpJ,4BAA4B,EAAA;IAvClC;MA2CM,QAAQ;MACR,OAAO;MACP,kCAA2D;MAC3D,gBAAgB;MAChB,mFAAiJ;MACjJ,2BAA2B,EAAA;IAhDjC;MAqDM,eAAe,EAAA;IArDrB;MA2DM,mBAAmB,EAAA,EACpB;;A9C3BH;E8CjCF;IAiEM,2BAA+C;IAC/C,8BAA2D;IAC3D,wCAAwC,EAAA;IAnE9C;MAsEQ,aAAa,EAAA;IAtErB;MA0EQ,aAAa;MACb,YAAY;MACZ,UAAU;MACV,mBAAmB;MAEnB,wCAAwC,EAAA,EACzC;;AAhFP;EAEI,eAAe;EACf,SAAS;EACT,mCAA4D;EAC5D,aAAa;EACb,sBAAsB;EACtB,eAAe;EACf,gCAAwD;EACxD,kBAAkB;EAClB,wCAA6D;EAC7D,4BAA4B;EAC5B,UAAU;ErC1BV,sCqC4BwE,EAAA;ErCxBxE;IqCUJ;MrCTM,gBAAgB,EAAA,EqC4FrB;EAnFD;IAiBM,MAAM;IACN,OAAO;IACP,gCAAwD;IACxD,qFAAmJ;IACnJ,4BAA4B,EAAA;EArBlC;IAyBM,MAAM;IACN,QAAQ;IACR,gCAAwD;IACxD,oFAAkJ;IAClJ,2BAA2B,EAAA;EA7BjC;IAiCM,MAAM;IACN,QAAQ;IACR,OAAO;IACP,kCAA2D;IAC3D,gBAAgB;IAChB,sFAAoJ;IACpJ,4BAA4B,EAAA;EAvClC;IA2CM,QAAQ;IACR,OAAO;IACP,kCAA2D;IAC3D,gBAAgB;IAChB,mFAAiJ;IACjJ,2BAA2B,EAAA;EAhDjC;IAqDM,eAAe,EAAA;EArDrB;IA2DM,mBAAmB,EAAA;;AA2B3B;EPlHE,eAAe;EACf,MAAM;EACN,OAAO;EACP,a/C0qCsC;E+CzqCtC,YAAY;EACZ,aAAa;EACb,sB/CmJa,EAAA;E+ChJb;IAAS,UAAU,EAAA;EACnB;IAAS,Y/CkgD2B,EAAA;;AsDt5CtC;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,oEAA4H,EAAA;EAJ9H;IAOI,0FAAkJ;IAClJ,qDAAiF;IACjF,uDAAmF;IACnF,wDAAoF,EAAA;;AAIxF;EACE,gBAAgB;EAChB,gBtDilB+B,EAAA;;AsD9kBjC;EACE,YAAY;EACZ,oEAA4H;EAC5H,gBAAgB,EAAA;;AC9IlB;EACE,qBAAqB;EACrB,eAAe;EACf,sBAAsB;EACtB,YAAY;EACZ,8BAA8B;EAC9B,YvDy1CoC,EAAA;EuD/1CtC;IASI,qBAAqB;IACrB,WAAW,EAAA;;AAKf;EACE,gBAAgB,EAAA;;AAGlB;EACE,gBAAgB,EAAA;;AAGlB;EACE,iBAAiB,EAAA;;AAInB;EAEI,mDAAmD,EAAA;;AAIvD;EACE;IACE,YvD4zCkC,EAAA,EAAA;;AuDxzCtC;EACE,uFAA8G;UAA9G,+EAA8G;EAC9G,4BAAoB;UAApB,oBAAoB;EACpB,8CAA8C,EAAA;;AAGhD;EACE;IACE,+BAAuB;YAAvB,uBAAuB,EAAA,EAAA;;AH9CzB;EACE,cAAc;EACd,WAAW;EACX,WAAW,EAAA;;AIAb;EACE,sBAAwE;EACxE,wEAAyH,EAAA;;AAF3H;EACE,sBAAwE;EACxE,yEAAyH,EAAA;;AAF3H;EACE,sBAAwE;EACxE,wEAAyH,EAAA;;AAF3H;EACE,sBAAwE;EACxE,wEAAyH,EAAA;;AAF3H;EACE,sBAAwE;EACxE,wEAAyH,EAAA;;AAF3H;EACE,sBAAwE;EACxE,uEAAyH,EAAA;;AAF3H;EACE,sBAAwE;EACxE,yEAAyH,EAAA;;AAF3H;EACE,sBAAwE;EACxE,sEAAyH,EAAA;;ACN3H;EACE,yBAAwB,EAAA;EAD1B;IAMM,yBAA8J,EAAA;;AANpK;EACE,yBAAwB,EAAA;EAD1B;IAMM,yBAA8J,EAAA;;AANpK;EACE,yBAAwB,EAAA;EAD1B;IAMM,yBAA8J,EAAA;;AANpK;EACE,yBAAwB,EAAA;EAD1B;IAMM,yBAA8J,EAAA;;AANpK;EACE,yBAAwB,EAAA;EAD1B;IAMM,yBAA8J,EAAA;;AANpK;EACE,yBAAwB,EAAA;EAD1B;IAMM,yBAA8J,EAAA;;AANpK;EACE,yBAAwB,EAAA;EAD1B;IAMM,yBAA8J,EAAA;;AANpK;EACE,yBAAwB,EAAA;EAD1B;IAMM,yBAA8J,EAAA;;ACLtK;EACE,kBAAkB;EAClB,WAAW,EAAA;EAFb;IAKI,cAAc;IACd,mCAAwD;IACxD,WAAW,EAAA;EAPf;IAWI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY,EAAA;;AAKd;EACE,uBAAuC,EAAA;;AADzC;EACE,qCAAuC,EAAA;;AADzC;EACE,sCAAuC,EAAA;;AADzC;EACE,sCAAuC,EAAA;;ACrB3C;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,OAAO;EACP,a3DuqCsC,EAAA;;A2DpqCxC;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,OAAO;EACP,a3D+pCsC,EAAA;;A2DvpCpC;EACE,gBAAgB;EAChB,MAAM;EACN,a3DmpCkC,EAAA;;A2DhpCpC;EACE,gBAAgB;EAChB,SAAS;EACT,a3D6oCkC,EAAA;;AQ9mCpC;EmDxCA;IACE,gBAAgB;IAChB,MAAM;IACN,a3DmpCkC,EAAA;E2DhpCpC;IACE,gBAAgB;IAChB,SAAS;IACT,a3D6oCkC,EAAA,E2D5oCnC;;AnD8BD;EmDxCA;IACE,gBAAgB;IAChB,MAAM;IACN,a3DmpCkC,EAAA;E2DhpCpC;IACE,gBAAgB;IAChB,SAAS;IACT,a3D6oCkC,EAAA,E2D5oCnC;;AnD8BD;EmDxCA;IACE,gBAAgB;IAChB,MAAM;IACN,a3DmpCkC,EAAA;E2DhpCpC;IACE,gBAAgB;IAChB,SAAS;IACT,a3D6oCkC,EAAA,E2D5oCnC;;AnD8BD;EmDxCA;IACE,gBAAgB;IAChB,MAAM;IACN,a3DmpCkC,EAAA;E2DhpCpC;IACE,gBAAgB;IAChB,SAAS;IACT,a3D6oCkC,EAAA,E2D5oCnC;;AnD8BD;EmDxCA;IACE,gBAAgB;IAChB,MAAM;IACN,a3DmpCkC,EAAA;E2DhpCpC;IACE,gBAAgB;IAChB,SAAS;IACT,a3D6oCkC,EAAA,E2D5oCnC;;AChCL;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB,EAAA;;AAGrB;EACE,aAAa;EACb,cAAc;EACd,sBAAsB;EACtB,mBAAmB,EAAA;;ACRrB;;ECIE,6BAA6B;EAC7B,qBAAqB;EACrB,sBAAsB;EACtB,qBAAqB;EACrB,uBAAuB;EACvB,2BAA2B;EAC3B,iCAAiC;EACjC,8BAA8B;EAC9B,oBAAoB,EAAA;;ACZtB;EAEI,kBAAkB;EAClB,MAAM;EACN,QAAQ;EACR,SAAS;EACT,OAAO;EACP,U/D2jBuC;E+D1jBvC,WAAW,EAAA;;ACRf;ECAE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB,EAAA;;ACNrB;EACE,qBAAqB;EACrB,mBAAmB;EACnB,UAAU;EACV,eAAe;EACf,8BAA8B;EAC9B,alEqxB+B,EAAA;;AmEztBzB;EAOI,mCAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,iCAA+D,EAAA;;AAPnE;EAOI,iCAA+D,EAAA;;AAPnE;EAOI,sCAA+D,EAAA;;AAPnE;EAOI,mCAA+D,EAAA;;AAPnE;EAOI,sBAA+D,EAAA;;AAPnE;EAOI,uBAA+D,EAAA;;AAPnE;EAOI,sBAA+D,EAAA;;AAPnE;EAOI,qBAA+D,EAAA;;AAPnE;EAOI,wBAA+D,EAAA;;AAPnE;EAOI,uBAA+D,EAAA;;AAPnE;EAOI,wBAA+D,EAAA;;AAPnE;EAOI,qBAA+D,EAAA;;AAPnE;EAOI,yBAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,4BAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,0BAA+D,EAAA;;AAPnE;EAOI,gCAA+D,EAAA;;AAPnE;EAOI,yBAA+D,EAAA;;AAPnE;EAOI,wBAA+D,EAAA;;AAPnE;EAOI,yBAA+D,EAAA;;AAPnE;EAOI,6BAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,wBAA+D,EAAA;;AAPnE;EAOI,+BAA+D,EAAA;;AAPnE;EAOI,wBAA+D,EAAA;;AAPnE;EAOI,uDAA+D,EAAA;;AAPnE;EAOI,8DAA+D,EAAA;;AAPnE;EAOI,wDAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,6BAA+D,EAAA;;AAPnE;EAOI,6BAA+D,EAAA;;AAPnE;EAOI,0BAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,iBAA+D,EAAA;;AAPnE;EAOI,mBAA+D,EAAA;;AAPnE;EAOI,oBAA+D,EAAA;;AAPnE;EAOI,oBAA+D,EAAA;;AAPnE;EAOI,sBAA+D,EAAA;;AAPnE;EAOI,uBAA+D,EAAA;;AAPnE;EAOI,kBAA+D,EAAA;;AAPnE;EAOI,oBAA+D,EAAA;;AAPnE;EAOI,qBAA+D,EAAA;;AAPnE;EAOI,mBAA+D,EAAA;;AAPnE;EAOI,qBAA+D,EAAA;;AAPnE;EAOI,sBAA+D,EAAA;;AAPnE;EAOI,2CAA+D,EAAA;;AAPnE;EAOI,sCAA+D,EAAA;;AAPnE;EAOI,sCAA+D,EAAA;;AAPnE;EAOI,uFAA+D,EAAA;;AAPnE;EAOI,oBAA+D,EAAA;;AAPnE;EAOI,2FAA+D,EAAA;;AAPnE;EAOI,wBAA+D,EAAA;;AAPnE;EAOI,6FAA+D,EAAA;;AAPnE;EAOI,0BAA+D,EAAA;;AAPnE;EAOI,8FAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,4FAA+D,EAAA;;AAPnE;EAOI,yBAA+D,EAAA;;AAPnE;EAIQ,sBAA4B;EAGhC,8EAA+D,EAAA;;AAPnE;EAIQ,sBAA4B;EAGhC,gFAA+D,EAAA;;AAPnE;EAIQ,sBAA4B;EAGhC,8EAA+D,EAAA;;AAPnE;EAIQ,sBAA4B;EAGhC,2EAA+D,EAAA;;AAPnE;EAIQ,sBAA4B;EAGhC,8EAA+D,EAAA;;AAPnE;EAIQ,sBAA4B;EAGhC,6EAA+D,EAAA;;AAPnE;EAIQ,sBAA4B;EAGhC,4EAA+D,EAAA;;AAPnE;EAIQ,sBAA4B;EAGhC,2EAA+D,EAAA;;AAPnE;EAIQ,sBAA4B;EAGhC,4EAA+D,EAAA;;AAjBnE;EACE,sBAAoC,EAAA;;AADtC;EACE,sBAAoC,EAAA;;AADtC;EACE,sBAAoC,EAAA;;AADtC;EACE,sBAAoC,EAAA;;AADtC;EACE,sBAAoC,EAAA;;AADtC;EACE,wBAAoC,EAAA;;AADtC;EACE,yBAAoC,EAAA;;AADtC;EACE,wBAAoC,EAAA;;AADtC;EACE,yBAAoC,EAAA;;AADtC;EACE,sBAAoC,EAAA;;AAStC;EAOI,qBAA+D,EAAA;;AAPnE;EAOI,qBAA+D,EAAA;;AAPnE;EAOI,qBAA+D,EAAA;;AAPnE;EAOI,sBAA+D,EAAA;;AAPnE;EAOI,sBAA+D,EAAA;;AAPnE;EAOI,0BAA+D,EAAA;;AAPnE;EAOI,uBAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,sBAA+D,EAAA;;AAPnE;EAOI,sBAA+D,EAAA;;AAPnE;EAOI,sBAA+D,EAAA;;AAPnE;EAOI,uBAA+D,EAAA;;AAPnE;EAOI,uBAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,wBAA+D,EAAA;;AAPnE;EAOI,4BAA+D,EAAA;;AAPnE;EAOI,yBAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,iCAA+D,EAAA;;AAPnE;EAOI,sCAA+D,EAAA;;AAPnE;EAOI,yCAA+D,EAAA;;AAPnE;EAOI,uBAA+D,EAAA;;AAPnE;EAOI,uBAA+D,EAAA;;AAPnE;EAOI,yBAA+D,EAAA;;AAPnE;EAOI,yBAA+D,EAAA;;AAPnE;EAOI,0BAA+D,EAAA;;AAPnE;EAOI,4BAA+D,EAAA;;AAPnE;EAOI,kCAA+D,EAAA;;AAPnE;EAOI,sCAA+D,EAAA;;AAPnE;EAOI,oCAA+D,EAAA;;AAPnE;EAOI,kCAA+D,EAAA;;AAPnE;EAOI,yCAA+D,EAAA;;AAPnE;EAOI,wCAA+D,EAAA;;AAPnE;EAOI,wCAA+D,EAAA;;AAPnE;EAOI,kCAA+D,EAAA;;AAPnE;EAOI,gCAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,gCAA+D,EAAA;;AAPnE;EAOI,+BAA+D,EAAA;;AAPnE;EAOI,oCAA+D,EAAA;;AAPnE;EAOI,kCAA+D,EAAA;;AAPnE;EAOI,gCAA+D,EAAA;;AAPnE;EAOI,uCAA+D,EAAA;;AAPnE;EAOI,sCAA+D,EAAA;;AAPnE;EAOI,iCAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,iCAA+D,EAAA;;AAPnE;EAOI,+BAA+D,EAAA;;AAPnE;EAOI,6BAA+D,EAAA;;AAPnE;EAOI,+BAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,oBAA+D,EAAA;;AAPnE;EAOI,mBAA+D,EAAA;;AAPnE;EAOI,mBAA+D,EAAA;;AAPnE;EAOI,mBAA+D,EAAA;;AAPnE;EAOI,mBAA+D,EAAA;;AAPnE;EAOI,mBAA+D,EAAA;;AAPnE;EAOI,mBAA+D,EAAA;;AAPnE;EAOI,mBAA+D,EAAA;;AAPnE;EAOI,oBAA+D,EAAA;;AAPnE;EAOI,0BAA+D,EAAA;;AAPnE;EAOI,yBAA+D,EAAA;;AAPnE;EAOI,uBAA+D,EAAA;;AAPnE;EAOI,yBAA+D,EAAA;;AAPnE;EAOI,uBAA+D,EAAA;;AAPnE;EAOI,uBAA+D,EAAA;;AAPnE;EAOI,0BAA+D;EAA/D,yBAA+D,EAAA;;AAPnE;EAOI,gCAA+D;EAA/D,+BAA+D,EAAA;;AAPnE;EAOI,+BAA+D;EAA/D,8BAA+D,EAAA;;AAPnE;EAOI,6BAA+D;EAA/D,4BAA+D,EAAA;;AAPnE;EAOI,+BAA+D;EAA/D,8BAA+D,EAAA;;AAPnE;EAOI,6BAA+D;EAA/D,4BAA+D,EAAA;;AAPnE;EAOI,6BAA+D;EAA/D,4BAA+D,EAAA;;AAPnE;EAOI,wBAA+D;EAA/D,2BAA+D,EAAA;;AAPnE;EAOI,8BAA+D;EAA/D,iCAA+D,EAAA;;AAPnE;EAOI,6BAA+D;EAA/D,gCAA+D,EAAA;;AAPnE;EAOI,2BAA+D;EAA/D,8BAA+D,EAAA;;AAPnE;EAOI,6BAA+D;EAA/D,gCAA+D,EAAA;;AAPnE;EAOI,2BAA+D;EAA/D,8BAA+D,EAAA;;AAPnE;EAOI,2BAA+D;EAA/D,8BAA+D,EAAA;;AAPnE;EAOI,wBAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,6BAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,6BAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,0BAA+D,EAAA;;AAPnE;EAOI,gCAA+D,EAAA;;AAPnE;EAOI,+BAA+D,EAAA;;AAPnE;EAOI,6BAA+D,EAAA;;AAPnE;EAOI,+BAA+D,EAAA;;AAPnE;EAOI,6BAA+D,EAAA;;AAPnE;EAOI,6BAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,iCAA+D,EAAA;;AAPnE;EAOI,gCAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,gCAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,yBAA+D,EAAA;;AAPnE;EAOI,+BAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,4BAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,4BAA+D,EAAA;;AAPnE;EAOI,4BAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,0BAA+D,EAAA;;AAPnE;EAOI,wBAA+D,EAAA;;AAPnE;EAOI,0BAA+D,EAAA;;AAPnE;EAOI,wBAA+D,EAAA;;AAPnE;EAOI,iCAA+D;EAA/D,gCAA+D,EAAA;;AAPnE;EAOI,gCAA+D;EAA/D,+BAA+D,EAAA;;AAPnE;EAOI,8BAA+D;EAA/D,6BAA+D,EAAA;;AAPnE;EAOI,gCAA+D;EAA/D,+BAA+D,EAAA;;AAPnE;EAOI,8BAA+D;EAA/D,6BAA+D,EAAA;;AAPnE;EAOI,+BAA+D;EAA/D,kCAA+D,EAAA;;AAPnE;EAOI,8BAA+D;EAA/D,iCAA+D,EAAA;;AAPnE;EAOI,4BAA+D;EAA/D,+BAA+D,EAAA;;AAPnE;EAOI,8BAA+D;EAA/D,iCAA+D,EAAA;;AAPnE;EAOI,4BAA+D;EAA/D,+BAA+D,EAAA;;AAPnE;EAOI,+BAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,4BAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,4BAA+D,EAAA;;AAPnE;EAOI,iCAA+D,EAAA;;AAPnE;EAOI,gCAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,gCAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,kCAA+D,EAAA;;AAPnE;EAOI,iCAA+D,EAAA;;AAPnE;EAOI,+BAA+D,EAAA;;AAPnE;EAOI,iCAA+D,EAAA;;AAPnE;EAOI,+BAA+D,EAAA;;AAPnE;EAOI,gCAA+D,EAAA;;AAPnE;EAOI,+BAA+D,EAAA;;AAPnE;EAOI,6BAA+D,EAAA;;AAPnE;EAOI,+BAA+D,EAAA;;AAPnE;EAOI,6BAA+D,EAAA;;AAPnE;EAOI,qBAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,0BAA+D,EAAA;;AAPnE;EAOI,wBAA+D,EAAA;;AAPnE;EAOI,0BAA+D,EAAA;;AAPnE;EAOI,wBAA+D,EAAA;;AAPnE;EAOI,2BAA+D;EAA/D,0BAA+D,EAAA;;AAPnE;EAOI,iCAA+D;EAA/D,gCAA+D,EAAA;;AAPnE;EAOI,gCAA+D;EAA/D,+BAA+D,EAAA;;AAPnE;EAOI,8BAA+D;EAA/D,6BAA+D,EAAA;;AAPnE;EAOI,gCAA+D;EAA/D,+BAA+D,EAAA;;AAPnE;EAOI,8BAA+D;EAA/D,6BAA+D,EAAA;;AAPnE;EAOI,yBAA+D;EAA/D,4BAA+D,EAAA;;AAPnE;EAOI,+BAA+D;EAA/D,kCAA+D,EAAA;;AAPnE;EAOI,8BAA+D;EAA/D,iCAA+D,EAAA;;AAPnE;EAOI,4BAA+D;EAA/D,+BAA+D,EAAA;;AAPnE;EAOI,8BAA+D;EAA/D,iCAA+D,EAAA;;AAPnE;EAOI,4BAA+D;EAA/D,+BAA+D,EAAA;;AAPnE;EAOI,yBAA+D,EAAA;;AAPnE;EAOI,+BAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,4BAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,4BAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,iCAA+D,EAAA;;AAPnE;EAOI,gCAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,gCAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,4BAA+D,EAAA;;AAPnE;EAOI,kCAA+D,EAAA;;AAPnE;EAOI,iCAA+D,EAAA;;AAPnE;EAOI,+BAA+D,EAAA;;AAPnE;EAOI,iCAA+D,EAAA;;AAPnE;EAOI,+BAA+D,EAAA;;AAPnE;EAOI,0BAA+D,EAAA;;AAPnE;EAOI,gCAA+D,EAAA;;AAPnE;EAOI,+BAA+D,EAAA;;AAPnE;EAOI,6BAA+D,EAAA;;AAPnE;EAOI,+BAA+D,EAAA;;AAPnE;EAOI,6BAA+D,EAAA;;AAPnE;EAOI,iBAA+D,EAAA;;AAPnE;EAOI,uBAA+D,EAAA;;AAPnE;EAOI,sBAA+D,EAAA;;AAPnE;EAOI,oBAA+D,EAAA;;AAPnE;EAOI,sBAA+D,EAAA;;AAPnE;EAOI,oBAA+D,EAAA;;AAPnE;EAOI,gDAA+D,EAAA;;AAPnE;EAOI,gDAA+D,EAAA;;AAPnE;EAOI,0CAA+D,EAAA;;AAPnE;EAOI,iDAA+D,EAAA;;AAPnE;EAOI,gDAA+D,EAAA;;AAPnE;EAOI,gCAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,6BAA+D,EAAA;;AAPnE;EAOI,6BAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,+BAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,yBAA+D,EAAA;;AAPnE;EAOI,4BAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,yBAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,4BAA+D,EAAA;;AAPnE;EAOI,6BAA+D,EAAA;;AAPnE;EAOI,gCAA+D,EAAA;;AAPnE;EAOI,qCAA+D,EAAA;;AAPnE;EAOI,wCAA+D,EAAA;;AAPnE;EAOI,oCAA+D,EAAA;;AAPnE;EAOI,oCAA+D,EAAA;;AAPnE;EAOI,qCAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AArBnE,qBAAA;AAcA;EAOI,gCAA+D;EAA/D,iCAA+D,EAAA;;AAmBnE,mBAAA;AA1BA;EAIQ,oBAA4B;EAGhC,qEAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,uEAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,qEAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,kEAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,qEAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,oEAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,mEAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,kEAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,mEAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,mEAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,wEAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,yBAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,oCAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,0CAA+D,EAAA;;AAPnE;EAIQ,oBAA4B;EAGhC,yBAA+D,EAAA;;AAjBnE;EACE,uBAAoC,EAAA;;AADtC;EACE,sBAAoC,EAAA;;AADtC;EACE,uBAAoC,EAAA;;AADtC;EACE,oBAAoC,EAAA;;AAStC;EAIQ,kBAA4B;EAGhC,8EAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,gFAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,8EAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,2EAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,8EAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,6EAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,4EAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,2EAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,4EAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,4EAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,8EAA+D,EAAA;;AAPnE;EAIQ,kBAA4B;EAGhC,wCAA+D,EAAA;;AAjBnE;EACE,oBAAoC,EAAA;;AADtC;EACE,qBAAoC,EAAA;;AADtC;EACE,oBAAoC,EAAA;;AADtC;EACE,qBAAoC,EAAA;;AADtC;EACE,kBAAoC,EAAA;;AAStC;EAOI,+CAA+D,EAAA;;AAPnE;EAOI,mCAA+D;UAA/D,2BAA+D,EAAA;;AAPnE;EAOI,oCAA+D;UAA/D,4BAA+D,EAAA;;AAPnE;EAOI,oCAA+D;UAA/D,4BAA+D,EAAA;;AAPnE;EAOI,+BAA+D,EAAA;;AAPnE;EAOI,+BAA+D,EAAA;;AAPnE;EAOI,iDAA+D,EAAA;;AAPnE;EAOI,2BAA+D,EAAA;;AAPnE;EAOI,oDAA+D,EAAA;;AAPnE;EAOI,iDAA+D,EAAA;;AAPnE;EAOI,oDAA+D,EAAA;;AAPnE;EAOI,oDAA+D,EAAA;;AAPnE;EAOI,qDAA+D,EAAA;;AAPnE;EAOI,6BAA+D,EAAA;;AAPnE;EAOI,sDAA+D,EAAA;;AAPnE;EAOI,0DAA+D;EAA/D,2DAA+D,EAAA;;AAPnE;EAOI,2DAA+D;EAA/D,8DAA+D,EAAA;;AAPnE;EAOI,8DAA+D;EAA/D,6DAA+D,EAAA;;AAPnE;EAOI,6DAA+D;EAA/D,0DAA+D,EAAA;;AAPnE;EAOI,8BAA+D,EAAA;;AAPnE;EAOI,6BAA+D,EAAA;;A3DVvE;E2DGI;IAOI,sBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,sBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,sCAA+D,EAAA;EAPnE;IAOI,yCAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,sCAA+D,EAAA;EAPnE;IAOI,oCAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,yCAA+D,EAAA;EAPnE;IAOI,wCAA+D,EAAA;EAPnE;IAOI,wCAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,oCAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,uCAA+D,EAAA;EAPnE;IAOI,sCAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,oBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,oBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,0BAA+D;IAA/D,yBAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,+BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,4BAA+D,EAAA;EAPnE;IAOI,+BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,4BAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,4BAA+D,EAAA;EAPnE;IAOI,wBAA+D;IAA/D,2BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,gCAA+D,EAAA;EAPnE;IAOI,2BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,gCAA+D,EAAA;EAPnE;IAOI,2BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,2BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,iCAA+D;IAA/D,gCAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,6BAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D;IAA/D,kCAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,4BAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,4BAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,qBAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,2BAA+D;IAA/D,0BAA+D,EAAA;EAPnE;IAOI,iCAA+D;IAA/D,gCAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,6BAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,6BAA+D,EAAA;EAPnE;IAOI,yBAA+D;IAA/D,4BAA+D,EAAA;EAPnE;IAOI,+BAA+D;IAA/D,kCAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,4BAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,4BAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,iBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,sBAA+D,EAAA;EAPnE;IAOI,oBAA+D,EAAA;EAPnE;IAOI,sBAA+D,EAAA;EAPnE;IAOI,oBAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA,EAElE;;A3DZL;E2DGI;IAOI,sBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,sBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,sCAA+D,EAAA;EAPnE;IAOI,yCAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,sCAA+D,EAAA;EAPnE;IAOI,oCAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,yCAA+D,EAAA;EAPnE;IAOI,wCAA+D,EAAA;EAPnE;IAOI,wCAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,oCAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,uCAA+D,EAAA;EAPnE;IAOI,sCAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,oBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,oBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,0BAA+D;IAA/D,yBAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,+BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,4BAA+D,EAAA;EAPnE;IAOI,+BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,4BAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,4BAA+D,EAAA;EAPnE;IAOI,wBAA+D;IAA/D,2BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,gCAA+D,EAAA;EAPnE;IAOI,2BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,gCAA+D,EAAA;EAPnE;IAOI,2BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,2BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,iCAA+D;IAA/D,gCAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,6BAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D;IAA/D,kCAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,4BAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,4BAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,qBAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,2BAA+D;IAA/D,0BAA+D,EAAA;EAPnE;IAOI,iCAA+D;IAA/D,gCAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,6BAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,6BAA+D,EAAA;EAPnE;IAOI,yBAA+D;IAA/D,4BAA+D,EAAA;EAPnE;IAOI,+BAA+D;IAA/D,kCAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,4BAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,4BAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,iBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,sBAA+D,EAAA;EAPnE;IAOI,oBAA+D,EAAA;EAPnE;IAOI,sBAA+D,EAAA;EAPnE;IAOI,oBAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA,EAElE;;A3DZL;E2DGI;IAOI,sBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,sBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,sCAA+D,EAAA;EAPnE;IAOI,yCAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,sCAA+D,EAAA;EAPnE;IAOI,oCAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,yCAA+D,EAAA;EAPnE;IAOI,wCAA+D,EAAA;EAPnE;IAOI,wCAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,oCAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,uCAA+D,EAAA;EAPnE;IAOI,sCAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,oBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,oBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,0BAA+D;IAA/D,yBAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,+BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,4BAA+D,EAAA;EAPnE;IAOI,+BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,4BAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,4BAA+D,EAAA;EAPnE;IAOI,wBAA+D;IAA/D,2BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,gCAA+D,EAAA;EAPnE;IAOI,2BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,gCAA+D,EAAA;EAPnE;IAOI,2BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,2BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,iCAA+D;IAA/D,gCAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,6BAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D;IAA/D,kCAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,4BAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,4BAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,qBAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,2BAA+D;IAA/D,0BAA+D,EAAA;EAPnE;IAOI,iCAA+D;IAA/D,gCAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,6BAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,6BAA+D,EAAA;EAPnE;IAOI,yBAA+D;IAA/D,4BAA+D,EAAA;EAPnE;IAOI,+BAA+D;IAA/D,kCAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,4BAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,4BAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,iBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,sBAA+D,EAAA;EAPnE;IAOI,oBAA+D,EAAA;EAPnE;IAOI,sBAA+D,EAAA;EAPnE;IAOI,oBAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA,EAElE;;A3DZL;E2DGI;IAOI,sBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,sBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,sCAA+D,EAAA;EAPnE;IAOI,yCAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,sCAA+D,EAAA;EAPnE;IAOI,oCAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,yCAA+D,EAAA;EAPnE;IAOI,wCAA+D,EAAA;EAPnE;IAOI,wCAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,oCAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,uCAA+D,EAAA;EAPnE;IAOI,sCAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,oBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,oBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,0BAA+D;IAA/D,yBAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,+BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,4BAA+D,EAAA;EAPnE;IAOI,+BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,4BAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,4BAA+D,EAAA;EAPnE;IAOI,wBAA+D;IAA/D,2BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,gCAA+D,EAAA;EAPnE;IAOI,2BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,gCAA+D,EAAA;EAPnE;IAOI,2BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,2BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,iCAA+D;IAA/D,gCAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,6BAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D;IAA/D,kCAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,4BAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,4BAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,qBAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,2BAA+D;IAA/D,0BAA+D,EAAA;EAPnE;IAOI,iCAA+D;IAA/D,gCAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,6BAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,6BAA+D,EAAA;EAPnE;IAOI,yBAA+D;IAA/D,4BAA+D,EAAA;EAPnE;IAOI,+BAA+D;IAA/D,kCAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,4BAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,4BAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,iBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,sBAA+D,EAAA;EAPnE;IAOI,oBAA+D,EAAA;EAPnE;IAOI,sBAA+D,EAAA;EAPnE;IAOI,oBAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA,EAElE;;A3DZL;E2DGI;IAOI,sBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,sBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,sCAA+D,EAAA;EAPnE;IAOI,yCAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,sCAA+D,EAAA;EAPnE;IAOI,oCAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,yCAA+D,EAAA;EAPnE;IAOI,wCAA+D,EAAA;EAPnE;IAOI,wCAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,oCAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,uCAA+D,EAAA;EAPnE;IAOI,sCAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,oBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,mBAA+D,EAAA;EAPnE;IAOI,oBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,0BAA+D;IAA/D,yBAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,+BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,4BAA+D,EAAA;EAPnE;IAOI,+BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,4BAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,4BAA+D,EAAA;EAPnE;IAOI,wBAA+D;IAA/D,2BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,gCAA+D,EAAA;EAPnE;IAOI,2BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D;IAA/D,gCAA+D,EAAA;EAPnE;IAOI,2BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,2BAA+D;IAA/D,8BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,iCAA+D;IAA/D,gCAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,6BAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D;IAA/D,kCAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,4BAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,4BAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,qBAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,2BAA+D;IAA/D,0BAA+D,EAAA;EAPnE;IAOI,iCAA+D;IAA/D,gCAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,6BAA+D,EAAA;EAPnE;IAOI,gCAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,6BAA+D,EAAA;EAPnE;IAOI,yBAA+D;IAA/D,4BAA+D,EAAA;EAPnE;IAOI,+BAA+D;IAA/D,kCAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,4BAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D;IAA/D,iCAA+D,EAAA;EAPnE;IAOI,4BAA+D;IAA/D,+BAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,kCAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,iCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,0BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,iBAA+D,EAAA;EAPnE;IAOI,uBAA+D,EAAA;EAPnE;IAOI,sBAA+D,EAAA;EAPnE;IAOI,oBAA+D,EAAA;EAPnE;IAOI,sBAA+D,EAAA;EAPnE;IAOI,oBAA+D,EAAA;EAPnE;IAOI,2BAA+D,EAAA;EAPnE;IAOI,4BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA,EAElE;;ACxDT;ED+CQ;IAOI,+BAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA,EAElE;;ACrCT;ED4BQ;IAOI,0BAA+D,EAAA;EAPnE;IAOI,gCAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,yBAA+D,EAAA;EAPnE;IAOI,6BAA+D,EAAA;EAPnE;IAOI,8BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA;EAPnE;IAOI,+BAA+D,EAAA;EAPnE;IAOI,wBAA+D,EAAA,EAElE;;AE3ET;;;;;;;ChFu38CC;AiF728CD;EACI,wBAAwB;EACxB,6CAA2C;EAC3C,sFAAqF;EACrF,gBAAgB,EAAA;;AAGpB;EACI,wBAAwB;EACxB,6CAA6C;EAC7C,wFAAyF;EACzF,gBAAgB,EAAA;;AAEpB;EACI,wBAAwB;EACxB,6CAA4C;EAC5C,uFAAuF;EACvF,gBAAgB,EAAA;;AAEpB;EACI,wBAAwB;EACxB,6CAA8C;EAC9C,yFAA2F;EAC3F,gBAAgB,EAAA;;AzEjCpB;E0EKE,qBAAuC;EACvC,wBAA4C;EAC5C,+BAAoD;EAGpD,gDAAwD;EACxD,mDAAwE;EACxE,mDAAoF;EACpF,mDAAsF;EACtF,mDAAgF;EAChF,mDAA4F;EAC5F,mDAA8F;EAC9F,mDAA0E;EAG1E,mDAAkE;EAClE,mDAAkF;EAClF,gDAA8F;EAC9F,gDAAgG;EAChG,mDAA0F;EAC1F,kDAAsG;EACtG,mDAAwG;EACxG,oDAAoF;EAGpF,qBAA0C;EAC1C,gCAA0D;EAE1D,6BAAoD;EACpD,qCAAoE;EAGpE,8BAAwD;EAExD,4BAAoD;EACpD,iCAA8D;EAG9D,oBAA0C;EAC1C,0BAAgD;EAGhD,oBAA0C;EAC1C,+BAA0D;EAC1D,sCAAwE;EAGxE,qCAA4E;EAC5E,6BAA0D;EAE1D,qEAAsF;EACtF,qCAAoE;EACpE,4EAAoF;EACpF,iDAAkG;EAClG,mEAA4F;EAG5F,8BAAkD;EAGlD,2BAAkD;EAKlD,mBAAkC;EAClC,6BAA0C;EAC1C,kBAAgC;EAChC,yBAAwC;EAGxC,wBAA4C;EAC5C,8BAAwD;EAGxD,2BAAgD;EAGhD,sBAA8C;EAC9C,iCAA8D;EAC9D,uCAA0E;EAC1E,oCAAoE;EACpE,6BAAkE;EAGlE,kBAAsC;EACtC,sBAA8C;EAC9C,0BAAoD;EACpD,0BAAsD;EAGtD,mBAAwC;EAGxC,wCAA4E;EAC5E,qCAAsE;EAGtE,2CAAkF;EAGlF,yBAA8C;EAG9C,sDAAoE;EACpE,2CAA4D;EAC5D,mDAA0E;EAG1E,iCAA8D;EAG9D,qBAA4C;EAG5C,iCAA8D;EAG9D,mBAAwC;EACxC,0BAAgD;EAChD,gCAA4D;EAC5D,+BAA0D;EAG1D,kCAAgE;EAGhE,+CAA4D,EAAA;;AlFu18C9D;EmF778CM,sBAA2C;EAA3C,sBAA2C;EAA3C,sBAA2C;EAA3C,sBAA2C;EAA3C,sBAA2C;EAA3C,sBAA2C;EAA3C,sBAA2C;EAA3C,sBAA2C;EAA3C,sBAA2C;EAI/C,sBAAuC;EACvC,wBAA4C;EAC5C,kCAAoD;EAIpD,gDAAwD;EACxD,mDAAwE;EACxE,mDAAoF;EACpF,mDAAsF;EACtF,mDAAgF;EAChF,mDAA4F;EAC5F,mDAA8F;EAC9F,mDAA0E;EAG1E,mDAAkE;EAClE,kDAAkF;EAClF,gDAA8F;EAC9F,gDAAgG;EAChG,kDAA0F;EAC1F,kDAAsG;EACtG,mDAAwG;EACxG,oDAAoF;EAGpF,wBAA0C;EAC1C,gCAA0D;EAE1D,8BAAoD;EACpD,qCAAoE;EAGpE,8BAAwD;EAExD,4BAAoD;EACpD,iCAA8D;EAG9D,uBAA0C;EAC1C,0BAAgD;EAGhD,uBAA0C;EAC1C,+BAA0D;EAC1D,mCAAwE;EAGxE,qCAA4E;EAC5E,6BAA0D;EAG1D,qEAAsF;EACtF,qCAAoE;EACpE,4EAAoF;EACpF,iDAAkG;EAClG,mEAA4F;EAG5F,2BAAkD;EAGlD,2BAAkD;EAGlD,mBAAkC;EAClC,0BAA0C;EAC1C,kBAAgC;EAChC,4BAAwC;EAGxC,wBAA4C;EAC5C,8BAAwD;EAGxD,2BAAgD;EAGhD,yBAA8C;EAC9C,iCAA8D;EAC9D,uCAA0E;EAC1E,oCAAoE;EACpE,+BAAkE;EAGlE,qBAAsC;EACtC,yBAA8C;EAC9C,yBAAoD;EACpD,2BAAsD;EAGtD,sBAAwC;EAGxC,wCAA4E;EAC5E,qCAAsE;EAGtE,wCAAkF;EAGlF,yBAA8C;EAG9C,mDAAoE;EACpE,iDAA4D;EAC5D,yDAA0E;EAG1E,iCAA8D;EAG9D,wBAA4C;EAG5C,iCAA8D;EAG9D,sBAAwC;EACxC,0BAAgD;EAChD,gCAA4D;EAC5D,+BAA0D;EAG1D,kCAAgE;EAGhE,iCAA4D,EAAA;;AC7J9D;EACI,eAAe;EACf,MAAM;EACN,QAAQ;EACR,OAAO;EACP,aAAa;EACb,qCzE6E2F;EyE5E3F,6BAA6B,EAAA;EAPjC;IAUM,4CzE8oBqD,EAAA;EyE3oBvD;IAbJ;MAcM,WzEEiD,EAAA,EyEApD;;AAED;EACE,aAAa;EAEb,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;EACd,YzE0DmD;EyEzDnD,oCAA+D,EAAA;EAG/D;IAVF;MAWI,8CAA4E,EAAA,EAsB/E;EAjCD;IAgBM,oBAAoB,EAAA;EAhB1B;IAqBI,YAAY;IACZ,WAAW,EAAA;IAEX;MAxBJ;QAyBM,YAAY;QACZ,WAAW,EAAA,EAEd;EA5BH;IA+BI,yBAAmD,EAAA;;AAIvD,WAAA;AAEA;EACE,yBAA6C,EAAA;EAD/C;IAII,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,4CzE4BwG;IyE3BxG,gBAAgB,EAAA;EATpB;IAaI,kBAAkB;IAClB,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,UAAU;IACV,MAAM;IACN,czEyEY,EAAA;EyE5FhB;IAuBI,UAAU;IACV,qBAAqB,EAAA;EAGvB;IA3BF;MA4BI,8BAA6C,EAAA,EAEhD;;AAID;EAEI,kBAAkB;EAClB,gBAAgB,EAAA;EAHpB;IAMM,2BzEsqC4E,EAAA;;AyEjqClF;EACE;IAEI,aAAa,EAAA;EAFjB;IAMI,qBAAqB,EAAA,EACtB;;AAIL;EACE,YzE/BmD;EyEgCnD,aAAa;EACb,mBAAmB,EAAA;;AAGrB;EACE,YAAY;EACZ,WAAW,EAAA;;AAGb;EACE,QAAQ;EACR,mBAAmB,EAAA;;AAGrB;EACE,WAAW;EACX,mBAAmB,EAAA;;AAInB;EADF;IAEI,0CzEvCmE,EAAA,EyE6CtE;;AARD;EAMI,mBAAmB,EAAA;;AAIvB;EACE,qBAAqB;EACrB,oBAAoB;EACpB,kBAAkB,EAAA;EAHpB;IAMI,kBAAkB;IAClB,UAAU,EAAA;;AAKd;EACE,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;EAC7B,oCzE6mCkG,EAAA;EyEpnCpG;IAUI,YAAY,EAAA;EAVhB;IAcI,cAAc;IACd,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB,EAAA;EAjBvB;IAqBI,kDzEimCsG,EAAA;;AyE5lC1G;EAGM,gBAAgB,EAAA;;ApFk/8CxB;EoF1+8CQ,gBAAgB,EAAA;;ApF6+8CxB;EoFt+8CM,0CzEhHmG;EyEiHnG,sCzEjHmG,EAAA;;AX0l9CzG;EoFp+8CQ,uCzErHiH,EAAA;EX2l9CvH;IoFl+8CQ,2CzEpEK;IyEqEL,WzErEK,EAAA;;AyE2ET;EpFg+8CJ;IoF/98CM,+CzExHgF,EAAA,EyEkInF;;ApFw98CL;EoF998CQ,2CAAoC,EAAA;;ApFi+8C5C;EoF798CQ,kDAAyC,EAAA;;ApFg+8CjD;EoF398CM,aAAa,EAAA;;ApF898CnB;EoF198CM,qBAAqB,EAAA;;ApF698C3B;EoFx98CQ,2CzElGO;EyEmGP,WzEnGO,EAAA;;AX8j9Cf;;EoFt98CQ,+BzExGO,EAAA;;AXkk9Cf;EoFp98CQ,yBzE3GU,EAAA;;AyEgHhB;EACE;IAEI,gBAAgB,EAAA;IAFpB;MAKM,WAAW,EAAA,EACZ;;AAKP;EACE;IACE,oBAAoB,EAAA,EACrB;;AAKC;EpFy88CJ;IoFv88CQ,kBAAkB;IAClB,4CzEiYiD,EAAA;EXwk8CzD;IoFr88CQ,qBAAqB;IACrB,eAAe,EAAA;EpFu88CvB;IoFn88CQ,kBAAkB,EAAA;EpFq88C1B;IoFj88CQ,cAAc;IACd,cAAc,EAAA;EpFm88CtB;IoF778CU,wCAAwC;IACxC,kBAAkB;IAClB,WAAW;IACX,gBAAgB,EAAA;IpF+78CxB;MoF578CU,aAAa,EAAA;IpF878CvB;MoF178CU,cAAc,EAAA,EACf;;ApF478Cb;EoFp78CY,aAAa,EAAA;;ApFu78CzB;EoFp78CY,cAAc,EAAA;;ApFu78C1B;EoF968CM,OAAO;EACP,2CAAqE,EAAA;EAErE;IpF+68CF;MoF768CM,gBAAgB,EAAA,EACjB;;ApF+68CT;EoFt68CM,mEACgD,EAAA;EALhD;IpF668CF;MoF568CI,gBzEpQ+C,EAAA,EyEyQlD;;AAGG;EpFw68CN;IoFv68CQ,+BAA4D,EAAA,EAE/D;;AAQC;EpFi68CN;IoFh68CQ,UzExV4C,EAAA,EyE0V/C;;AAKC;EpF658CN;IoF558CQ,WzEjW6C,EAAA,EyEmWhD;;AAMD;EpFw58CJ;IoFv58CM,wBAAwE,EAAA,EAE3E;;ApFw58CL;EoFr58CM,aAAa,EAAA;;AChYnB;EACI,oB1EonBgC;E0EnnBhC,mC1E82C0E;E0E72C1E,4C1EyF2E;E0ExF3E,6B1EyFkD;E0ExFlD,0B1EwFkD;E0EvFlD,oC1E+mBgC,EAAA;E0ErnBpC;IASQ,6BAA6B;IAC7B,UAAU,EAAA;EAVlB;IAcQ,gBAAgB;IAChB,0BAAyB;IACzB,yBAAyB,EAAA;;ArFux9CjC;EqFjx9CQ,iBAAiB;EACjB,wCAAwC;EACxC,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,SAAS,EAAA;EAET;IrFkx9CJ;MqFjx9CQ,mBAAmB,EAAA,EAE1B;;ArFkx9CL;EqF5w9CY,iBAAiB;EACjB,wCAAwC;EACxC,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,SAAS,EAAA;EAET;IrF6w9CR;MqF5w9CY,mBAAmB,EAAA,EAE1B;;AChDT;EACI,SAAS;EACT,8BAA6C;EAC7C,kBAAkB;EAClB,QAAQ;EACR,6B3EiG+D;E2EhG/D,W3EUmD;E2ETnD,Y3E6FgB;E2E5FhB,qC3E6FsD,EAAA;E2E3FtD;IAVJ;MAWQ,OAAO,EAAA,EAEd;;AtF6z9CD;EsFtz9CY,U3EF0C,EAAA;E2EI1C;ItFuz9CR;MsFtz9CY,OAAO,EAAA,EAEd;;AtFuz9CT;EsFnz9CY,W3EZ2C,EAAA;E2Ec3C;ItFoz9CR;MsFnz9CY,OAAO,EAAA,EAEd;;AtFoz9CT;EsF7y9CQ,kBAAkB,EAAA;;AAMtB;EtF2y9CF;IsFzy9CU,kBAAkB;IAClB,6BAA6B,EAAA,EAChC;;AAMD;EtFsy9CN;IsFry9CU,wBAAwE,EAAA,EAE/E;;AC5DL;EACI,kB5EemD;E4EdnD,gBAAgB,EAAA;EAFpB;IAKM,yBAAyB;IACzB,gB5E4EiD,EAAA;;A4ExErD;EACE,6BAA6B,EAAA;EAE7B;IAHF;MAII,kB5EEiD,EAAA,E4EApD;;AA2ED;EAIE,mBAAmB,EAAA;;AAGrB;EACE,Y5EnFmD;E4EoFnD,a5E5EkD;E4E6ElD,sC5EhF0G;E4EiF1G,4B5EuCW;E4EtCX,SAAS;EACT,aAAa;EACb,eAAe;EACf,MAAM;EACN,4C5ErF2E;E4EsF3E,gCAA6C;EAC7C,6BAA6B,EAAA;EAX/B;IAeM,aAAa;IACb,mBAAmB;IACnB,wB5ErFgD;I4EsFhD,yC5EzFsH;I4E0FtH,oB5E5FmD;I4E6FnD,kC5E3GsD,EAAA;I4EuF5D;MAuBQ,gD5E5FkI,EAAA;I4EqE1I;MA2BQ,+C5EjGgI,EAAA;I4EsExI;MA+BQ,qBAAqB;MACrB,kB5EzF+C;M4E0F/C,eAAe;MACf,oBAAoB,EAAA;IAlC5B;MAsCQ,WAAW;MACX,sBAAsB;MACtB,yC5E/GoH,EAAA;I4EuE5H;MA4CQ,iBAAiB;MACjB,kBAAkB;MAClB,UAAU,EAAA;IA9ClB;MAkDQ,+C5ExHgI,EAAA;M4EsExI;QAoDU,+C5E1H8H;Q4E2H9H,8B5EmBQ,EAAA;I4ExElB;MA2DU,cAAc;MACd,iBAAiB;MACjB,oCAAoC;MACpC,iBAAiB;MACjB,0BAA0B;MAC1B,kBAAkB;MAClB,kBAAkB;MAClB,WAAW;MACX,0C5E7HoH,EAAA;I4E0D9H;MAsEU,gD5E3IgI,EAAA;M4EqE1I;QAyEY,+C5E/I4H;Q4EgJ5H,8B5EFM,EAAA;M4ExElB;QA8EY,wBAAwB;QACxB,gD5EpJ8H,EAAA;M4EqE1I;QAmFY,UAAU;QACV,2D5EzJ8H,EAAA;I4EqE1I;MA2FY,wBAAwB,EAAA;EA3FpC;IAkGM,qB5E3JiD,EAAA;I4EyDvD;MAqGQ,kCAC8C;MAC9C,6C5EvK4H;M4EwK5H,iBAAiB;MACjB,kBAAkB;MAClB,mB5E5KgD;M4E6KhD,kC5EnMoD,EAAA;M4EwF5D;QA8GU,WAAW;QACX,UAAU;QACV,aAAa;QACb,wD5EjL0H;Q4EkL1H,kBAAkB;QAClB,SAAS;QACT,WAAW;QACX,gCAAgC;QAChC,YAAY,EAAA;MAtHtB;QA0HU,mD5EzLsI,EAAA;Q4E+DhJ;UA6HY,yEAAgE;UAChE,UAAU,EAAA;MA9HtB;QAmIU,gD5ExMgI,EAAA;Q4EqE1I;UAqIY,sEAA6D,EAAA;IArIzE;MA2IQ,kBAAkB,EAAA;MA3I1B;QA+IY,WAAW;QACX,UAAU;QACV,SAAS;QACT,kBAAkB;QAClB,6BAA6B;QAC7B,iBAAiB;QACjB,SAAS,EAAA;EArJrB;IA6JI,c5E5GY;I4E6GZ,aAAa,EAAA;;AAIjB;EACE,iBAAiB;EACjB,kBAAkB;EAClB,6BAA6B,EAAA;EAE7B;IALF;MAMI,aAAa,EAAA,EAEhB;;AAED;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,qBAAqB,EAAA;EALvB;IAQI,yB5EnIY;I4EoIZ,kBAAkB;IAClB,kBAAkB;IAClB,iDAAiD;IACjD,WAAW;IACX,WAAW;IACX,cAAc;IACd,SAAS,EAAA;IAfb;MAkBM,MAAM;MACN,UAAU,EAAA;IAnBhB;MAuBM,QAAQ,EAAA;IAvBd;MA2BM,SAAS;MACT,UAAU,EAAA;EAId;IAGM,SAAS,EAAA;EAHf;IAOM,YAAY,EAAA;EAvCpB;IA6CI,yBAAyB,EAAA;IA7C7B;MAiDQ,SAAS;MACT,QAAQ;MACR,WAAW;MACX,wBAAwB;MACxB,uBAAuB,EAAA;IArD/B;MAyDQ,SAAS;MACT,SAAS;MACT,WAAW;MACX,wBAAwB;MACxB,sBAAsB,EAAA;IA7D9B;MAiEQ,SAAS;MACT,SAAS;MACT,WAAW;MACX,yBAAyB;MACzB,uBAAuB,EAAA;;AAM/B;EACE,iB5ExQmD,EAAA;E4EuQrD;IAII,aAAa,EAAA;;AAIjB;EACE,aAAa,EAAA;;AvF0r9CjB;EuFpr9CQ,SAAS,EAAA;EvFsr9Cf;IuFpr9CQ,WAAW;IACX,UAAU,EAAA;;AAId;EvFor9CJ;IuFnr9CM,kBAAkB;IAClB,sBAAsB,EAAA,EAEzB;;AvFor9CL;EuFhr9CQ,UAAU,EAAA;;AAKZ;EvF+q9CJ;IuF9q9CM,aAAa,EAAA,EAEhB;;AvF+q9CL;EuF5q9CM,aAAa,EAAA;;AvF+q9CnB;EuF1q9CQ,iB5ErX8C,EAAA;E4EsX9C;IvF4q9CJ;MuF3q9CM,cAAc,EAAA,EAEjB;;AvF4q9CP;EuFxq9CU,aAAa,EAAA;;AvF2q9CvB;EuFvq9CU,qBAAqB,EAAA;;AvF0q9C/B;EuFrq9CQ,qBAAqB,EAAA;;AAGvB;EvFsq9CJ;IuFpq9CQ,aAAa,EAAA,EACd;;AvFsq9CT;EuFjq9CQ,W5EjZ8C,EAAA;EXoj+CpD;IuFhq9CQ,aAAa,EAAA;IvFkq9CnB;MuF9p9CU,gBAAgB,EAAA;EvFgq9C5B;IuFxp9CU,aAAa,EAAA;EvF0p9CvB;IuFtp9CU,kBAAkB,EAAA;IvFwp9C1B;MuFrp9CU,aAAa,EAAA;IvFup9CvB;MuFnp9CU,cAAc;MACd,iBAAiB;MACjB,eAAe,EAAA;EvFqp9C3B;IuF/o9CY,aAAa,EAAA;EvFip9CzB;IuF7o9CY,eAAe,EAAA;IvF+o9CzB;MuF1o9CY,eAAe,EAAA;EvF4o9C7B;IuFvo9CY,iBAAiB,EAAA;EvFyo9C7B;IuFpo9CY,aAAa,EAAA;EvFso9CzB;IuFjo9CU,aAAa,EAAA;EvFmo9CvB;IuF9n9CQ,uBAAsC,EAAA;IAEtC;MvF+n9CJ;QuF7n9CQ,qBAAqB,EAAA;MvF+n9C7B;QuF3n9CQ,gBAAgB,EAAA,EACjB;IvF4n9CT;MuFvn9CU,cAAc,EAAA;IvFyn9CxB;MuFnn9CU,eAAe,EAAA;MvFqn9CvB;QuFhn9CU,eAAe,EAAA;IvFkn9C3B;MuF7m9CU,sBAAsB,EAAA;IvF+m9ChC;MuFzm9CU,qBAAqB,EAAA;IvF2m9C/B;MuFrm9CU,qBAAqB,EAAA;IvFum9C/B;MuFnm9CU,aAAa,EAAA;IvFqm9CvB;MuFhm9CQ,gBAAgB,EAAA;MvFkm9CtB;QuF/l9CQ,qBAAqB,EAAA;MvFim9C7B;QuF7l9CQ,aAAa,EAAA;;AAUnB;EvFul9CN;IuFtl9CQ,oB5E8E0B,EAAA,E4E5E7B;;AvFul9CP;EuFll9CQ,gBAAgB,EAAA;;AvFql9CxB;EuFjl9CQ,aAAa,EAAA;;AvFol9CrB;EuFhl9CQ,qBAAqB,EAAA;;AAKvB;EvF+k9CJ;IuF9k9CM,kBAAkB,EAAA;IvFgl9CtB;MuF7k9CM,iB5E7iB4C,EAAA,E4E8iB7C;;AAGH;EvF6k9CJ;IuF3k9CQ,cAAc,EAAA,EACf;;AvF6k9CT;EuFzk9CQ,uBAA4C,EAAA;;AvF4k9CpD;EuFxk9CQ,eAAe;EACf,UAAU;EACV,W5E9jB8C;E4E+jB9C,UAAU;EACV,MAAM;EACN,sC5E9jBsG,EAAA;;AXyo+C9G;EuFtk9CU,aAAa,EAAA;;AvFyk9CvB;EuFrk9CU,qBAAqB,EAAA;;AvFwk9C/B;EuFlk9CQ,kBAAkB;EAClB,sBAAyC;EACzC,iB5ElhB+C,EAAA;EXsl+CrD;;IuFhk9CQ,4BAA4B,EAAA;EvFmk9CpC;;IuF9j9CQ,wBAAwB,EAAA;EvFik9ChC;IuF7j9CQ,oBAAoB,EAAA;EvF+j9C5B;IuFzj9CU,wBAAwB,EAAA;EvF2j9ClC;IuFvj9CU,kBAAkB;IAClB,eAAe,EAAA;IvFyj9CvB;MuFtj9CU,aAAa,EAAA;IvFwj9CvB;MuFpj9CU,cAAc;MACd,iBAAiB,EAAA;EvFsj9C7B;IuF/i9CY,aAAa,EAAA;EvFij9CzB;IuF7i9CY,eAAe,EAAA;EvF+i9C3B;IuF5i9CY,iBAAiB,EAAA;EvF8i9C7B;IuFzi9CY,aAAa,EAAA;EvF2i9CzB;IuFti9CU,aAAa;IACb,uBAAuB,EAAA;EvFwi9CjC;IuFpi9CU,kBAAkB,EAAA;IvFsi9C1B;MuFli9CY,kBAAkB;MAClB,yBAA+C;MAC/C,W5E1hBD;M4E2hBC,iD5E5nBsG;M4E6nBtG,gBAAgB,EAAA;MvFoi9C1B;QuFji9CY,oD5E7nBgI;Q4E8nBhI,+B5EhiBH,EAAA;MXmk+CT;QuF/h9CY,qBAAqB;QACrB,kBAAkB,EAAA;MvFii9C9B;QuF7h9CY,cAAc;QACd,wBAAwB;QACxB,W5E3iBH,EAAA;IX0k+CX;MuF1h9CY,cAAc;MACd,U5E5qBsC;M4E6qBtC,kBAAkB;MAClB,YAAY;MACZ,sC5E5qB8F;M4E6qB9F,uBAAuB;MACvB,iBAAiB;MACjB,0BAA0B;MAC1B,4C5E9pB+D,EAAA;EX0r+C7E;IuFth9CU,UAAU,EAAA;IvFwh9ClB;MuFnh9Cc,c5EliBE,EAAA;MXuj+Cd;QuFlh9Cc,cAAc,EAAA;IvFoh9C9B;MuF5g9CY,yBAAyB;MACzB,kCAAkC,EAAA;IvF8g9C9C;MuFzg9CU,qBAAqB;MACrB,MAAM;MACN,6BAA6B,EAAA;;AAQrC;EvFqg9CJ;IuFng9CQ,kB5E5tB6C,EAAA,E4E6tB9C;;AvFqg9CT;EuFjg9CQ,Y5EjuB+C,EAAA;;AXqu+CvD;EuF//8CQ,uBAAyC,EAAA;EvFig9C/C;IuF5/8CU,cAAc;IACd,kBAAkB;IAClB,yBAC0C,EAAA;IvF6/8ClD;MuF1/8CU,cAAc,EAAA;IvF4/8CxB;MuFz/8CU,cAAc;MACd,iBAAiB;MACjB,kBAAkB,EAAA;IvF2/8C5B;MuFv/8CU,wBAAwB,EAAA;IvFy/8ClC;MuFr/8CU,kBAAkB;MAClB,qBAAqB;MACrB,QAAQ;MACR,QAAQ,EAAA;IvFu/8ClB;MuFl/8CY,aAAa,EAAA;EvFo/8C3B;IuF9+8CU,wBAAwB,EAAA;EvFg/8ClC;IuF5+8CU,eAAe,EAAA;EvF8+8CzB;IuFz+8CQ,kBAAkB,EAAA;IvF2+8CxB;MuFx+8CQ,0BAA0B,EAAA;;AvF2+8CtC;EuFn+8CQ,mBAAmB;EACnB,+BAA+B,EAAA;EvFq+8CrC;IuFj+8CU,yD5ExwB0H,EAAA;EX2u+CpI;IuF998CQ,8C5E7wB4H,EAAA;;AX8u+CtI;EuF398CU,c5E3qBQ,EAAA;EXwo+ChB;IuF198CU,qD5EpxBwI,EAAA;EXgv+ClJ;IuFv98CY,cAAc,EAAA;EvFy98C1B;IuFr98CY,qD5E7xBsI,EAAA;IXov+ChJ;MuFr98CY,cAAc,EAAA;IvFu98C1B;MuFn98CY,qD5EnyBoI;M4EoyBpI,8B5EvsBD,EAAA;EX4p+Cb;IuF/88CU,8C5E5yB0H;I4E6yB1H,8B5E9sBG,EAAA;EX+p+Cb;IuF788CU,c5EjrBQ,EAAA;IXgo+ChB;MuF788CU,c5EnrBM;M4EorBN,+B5ErtBC,EAAA;;AXqq+Cf;EuF188CU,iBAAiB,EAAA;EvF488CzB;IuF188CU,c5E5rBQ;I4E6rBR,yBAAyB;IACzB,mBAAmB,EAAA;IvF488C3B;MuF188CU,c5EhsBM;M4EisBN,+B5EluBC,EAAA;;AX+q+Cf;EuFt88CY,c5EhuBM,EAAA;EXwq+ChB;IuFr88CY,wEAA+D,EAAA;EvFu88C3E;IuFn88CY,c5E/sBM,EAAA;IXop+ChB;MuFl88CY,oCAAiC,EAAA;EvFo88C/C;IuF/78CY,c5EvtBM;I4EwtBN,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB,EAAA;;AvFk88ChC;EuF378CgB,wCAAwC,EAAA;;AvF878CxD;EuFz78CkB,0EAAiE,EAAA;;AvF478CnF;EuFv78CgB,c5E3uBI,EAAA;EXoq+ClB;IuFt78CgB,2EAAkE,EAAA;;AvFy78CpF;EuF/68CU,2C5E13B4G,EAAA;;AX4y+CtH;EuFz68CkB,2C5En4BoG,EAAA;;AX+y+CtH;EuFt68Cc,UAAU,EAAA;EvFw68CtB;IuFp68CgB,yBAAyB;IACzB,kCAAkC,EAAA;EvFs68ClD;IuF/58CkB,qD5Ej5BgI,EAAA;IXkz+ChJ;MuF958CkB,cAAc,EAAA;EvFg68ClC;IuFz58Cc,qBAAqB;IACrB,MAAM;IACN,6BAA6B,EAAA;;AvF458C7C;EuFp58CQ,c5E/zBU,EAAA;;AXst+ClB;EuFn58CQ,aAAa,EAAA;;AvFs58CrB;EuFl58CQ,qBAAqB,EAAA;;AvFq58C7B;EuF/48CQ,qBAAqB,EAAA;;AvFk58C7B;EuF948CQ,aAAa,EAAA;;AvFi58CrB;;EuF148CQ,iBAAiB,EAAA;;AAEnB;EvF648CJ;IuF348CQ,kBAAkB,EAAA;EvF648C1B;IuFz48CQ,cAAc;IACd,cAAc;IACd,oB5EnY0B,EAAA;EX8w9ClC;IuFv48CQ,oB5EvY0B,EAAA;EXgx9ClC;IuFr48CQ,wBAAoD;IACpD,c5E5Y0B;I4E6Y1B,UAAU;IACV,wC5E9+BoG;I4E++BpG,kBAAkB;IAClB,eAAe;IACf,UAAU,EAAA;IvFu48ChB;MuFp48CQ,aAAa,EAAA;EvFs48CvB;IuFh48CU,qBAAqB,EAAA;EvFk48C/B;IuF938CU,aAAa,EAAA,EACd;;AvFg48CX;EuF338CQ,6C5E5Y0E,EAAA;;AX0w9ClF;EuFz38CU,gBAAgB,EAAA;;AAKlB;EvFw38CN;;IuFr38CU,kBAAkB,EAAA,EACnB;;AAMT;EACE,sBAAsB;EACtB,eAAe;EACf,eAAe;EACf,yBAAyB;EACzB,0C5E1gC4H;E4E2gC5H,gB5E77BsB,EAAA;E4Eu7BxB;IASI,kBAAkB;IAClB,qBAAqB,EAAA;EAVzB;IAcI,aAAa,EAAA;;AAIjB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,wC5E/6Bc;E4Eg7Bd,aAAa;EACb,aAAa,EAAA;;AAIf;EAEI,cAAc,EAAA;;AAFlB;EAMI,yBAAyB;EACzB,aAAa,EAAA;;AvF228CnB;EuFj28CY,yBAAyB,EAAA;;AvFo28CrC;EuFj28CY,yBAAyB,EAAA;;AvFo28CrC;EwFj8+CI,cAAc,EAAA;;AAGhB;ExFk8+CA;;;;;;;IwF/7+CI,cAAc;IACd,cAAc,EAAA;ExFu8+ClB;IwFn8+CI,kBAAkB,EAAA,EACnB;;AxFq8+CL;EwFj8+CI,8BAA6C,EAAA;EAE7C;IxFk8+CA;MwFj8+CE,oB7EgmB8B,EAAA,E6E9lBjC;;AxFk8+CH;EwF/7+CI,+B7E+EwD;E6E9ExD,2BAA0C;EAC1C,4C7E6B4E;E6E5B5E,gB7EqDmD;E6EpDnD,eAAe;EACf,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,WAAW;EACX,YAAY,EAAA;EAEZ;IxFg8+CA;MwF97+CI,UAAU,EAAA,EACX;ExF+7+CL;IwF37+CI,mBAAmB,EAAA;IxF67+CrB;MwF17+CI,eAAe,EAAA;MxF47+CjB;QwFx7+CM,qBAAqB,EAAA;MxF07+C3B;QwFr7+CM,yC7EmD6F,EAAA;IXo4+CrG;MwFj7+CI,kC7E4C4E;M6E3C5E,uB7EHiD,EAAA;MXs7+CnD;QwFh7+CI,cAAc,EAAA;MxFk7+ClB;QwF96+CI,yC7EqC+F,EAAA;MX24+CnG;QwF56+CI,yC7EiC+F,EAAA;QX64+CjG;UwF36+CI,yC7E8B6F;U6E7B7F,6B7E4FQ,EAAA;QXi1+CZ;UwFz6+CI,yC7EyB6F,EAAA;MXk5+CnG;QwFr6+CM,yC7EmB6F;Q6ElB7F,6B7EiFQ,EAAA;IXs1+ChB;MwFh6+CM,UAAU;MACV,mCAAmC,EAAA;IxFk6+CzC;MwF55+CM,eAAe,EAAA;ExF85+CvB;IwFx5+CI,aAAa,EAAA;;AxF25+CnB;EwFr5+CM,kBAAkB,EAAA;ExFu5+CtB;IwFp5+CM,WAAW;IACX,kCAAkC,EAAA;ExFs5+CxC;IwFj5+CQ,mBAAmB,EAAA;ExFm5+C3B;IwF74+CQ,yC7EvB+F,EAAA;IXs6+CrG;MwF54+CQ,yC7E1B6F;M6E2B7F,6B7EoCQ,EAAA;IX02+ChB;MwF14+CQ,yC7E/B6F,EAAA;E6EmCjG;IxFy4+CJ;MwFv4+CQ,cAAc;MACd,uBAAuB,EAAA,EACxB;;AxFy4+CX;EwFl4+CI,kBAAkB;EAClB,gB7E/FoD;E6EgGpD,iB7EsmCiC;E6ErmCjC,4C7ElG4E;E6EmG5E,6BAA6B;EAC7B,wBAAwB;EACxB,yBAAyB;EACzB,SAAS;EACT,a7EugCoC;E6EtgCpC,uC7EomCkF;E6EnmClF,4BAA4B;EAC5B,oE7EmmCoF;E6ElmCpF,qB7E8e+B;E6E7e/B,aAAa,EAAA;ExFo4+Cf;IwFj4+CI,MAAM;IACN,UAAU,EAAA;;AxFo4+ChB;EwF/3+CI,YAAY,EAAA;;AxFk4+ChB;EwF93+CI,aAAa,EAAA;;AxFi4+CjB;EwF73+CI,sBAAsB;EACtB,WAAW,EAAA;;AAGb;ExF83+CA;IwF53+CI,aAAa,EAAA,EACd;;AAMD;ExFy3+CF;IwFv3+CM,cAAc;IACd,iBAAiB;IACjB,gBAAgB;IAChB,eAAe,EAAA;IxFy3+CnB;MwFt3+CM,sBAAsB,EAAA;MxFw3+C1B;QwFr3+CM,oB7EjL4C,EAAA;MXwi/ClD;QwFn3+CM,qBAAqB,EAAA;ExFq3+C/B;IwF/2+CM,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,OAAO;IACP,eAAe;IACf,cAAc,EAAA;IxFi3+ClB;MwF92+CM,cAAc,EAAA;ExFg3+CtB;IwF32+CM,kBAAkB,EAAA;ExF62+CxB;IwFz2+CM,UAAU,EAAA;ExF22+ChB;IwFv2+CM,WAAW,EAAA,EACZ;;AxFy2+CP;EwF91+CU,aAAa,EAAA;;AxFi2+CvB;EwF71+CU,cAAc,EAAA;;AxFg2+CxB;EwFn1+CU,oCAAoC,EAAA;;AxFs1+C9C;EwF70+CY,qCAAqC,EAAA;;AxFg1+CjD;EyFnm/CQ,iBAAiB;EACjB,Y9EkEgD;E8EjEhD,U9EgE+C,EAAA;EXqi/CrD;IyFlm/CU,qBAAqB;IACrB,eAAe;IACf,eAAe;IACf,yBAAyB;IACzB,qDAA4C;IAC5C,gB9E0Gc,EAAA;IX0/+CtB;MyFjm/CY,wBAAwB,EAAA;IzFmm/CpC;MyF/l/CY,aAAa,EAAA;EzFim/C3B;IyF5l/CU,0BAAuC,EAAA;IACvC;MzF8l/CN;QyF7l/CU,iBAAiB,EAAA,EA0CxB;IzFqj/CL;MyF3l/CY,aAAa,EAAA;IzF6l/CzB;MyFxl/CgB,yBAAyB;MACzB,uBAAuB,EAAA;IzF0l/CvC;MyFpl/CgB,yBAAyB;MACzB,uBAAuB,EAAA;IzFsl/CvC;MyF/k/CoB,SAAS,EAAA;MzFil/C3B;QyF/k/CsB,WAAW;QACX,UAAU,EAAA;IzFil/ClC;MyFzk/CgB,yC9ElC0G,EAAA;MX6m/CxH;QyFxk/CkB,gD9EnCoH,EAAA;EX6m/C1I;IyFnk/CU,UAAU,EAAA;;AzFsk/CtB;EyFjk/CQ,+BAA+E,EAAA;EAC/E;IzFmk/CJ;MyFlk/CQ,iB9EV2C,EAAA,E8EYlD;;AzFmk/CL;EyFhk/CQ,W9Ef+C;E8EgB/C,sD9ElByH;E8EmBzH,YAAY;EACZ,W9ElB+C;E8EmB/C,4C9EjBwE;E8EkBxE,MAAM;EACN,kBAAkB;EAClB,UAAU;EACV,kBAAkB,EAAA;EzFkk/CxB;IyFhk/CU,kBAAkB;IAClB,gBAAgB,EAAA;IzFkk/CxB;MyF/j/CgB,WAAW;MACX,kBAAkB;MAClB,MAAM;MACN,QAAQ;MACR,SAAS;MACT,OAAO,EAAA;EzFik/CzB;IyF3j/CU,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,yC9EpFkH;I8EqFlH,UAAU;IACV,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,aAAa;IACb,oBAAoB;IACpB,uBAAuB;IACvB,mBAAmB,EAAA;IzF6j/C3B;MyF1j/CY,WAAW;MACX,yC9EhG8G,EAAA;IX4p/C1H;MyFxj/CY,0C9E2CI;M8E1CJ,c9E0CI,EAAA;MXgh/Cd;QyFvj/Cc,c9EuCA;Q8EtCA,6B9EsCA,EAAA;;AXoh/CpB;EyFnj/CQ,aAAa,EAAA;;AAGjB;EzFoj/CF;IyFhj/Cc,cAAc,EAAA;EzFkj/C5B;IyF9i/Cc,aAAa,EAAA,EAChB;;AzFgj/Cb;EyFxi/CoB,aAAa,EAAA;;AzF2i/CjC;EyFvi/CoB,cAAc,EAAA;;AzF0i/ClC;EyFli/CY,2D9ElG+H,EAAA;EXso/CzI;IyFli/Cc,+C9EjGyH,EAAA;IXqo/CrI;MyFli/CgB,sD9ElGmI;M8EmGnI,8D9ElG6H,EAAA;;AXuo/CjJ;EyF/h/CY,kD9E5G6G;E8E6G7G,oD9E5G6G,EAAA;EX6o/CvH;IyF9h/CkB,cAAc,EAAA;EzFgi/ChC;IyF5h/CkB,aAAa,EAAA;EzF8h/C/B;IyFvh/CsB,+C9EzHiH,EAAA;;AXmp/CzI;EyF/g/C4B,sD9EnI2H,EAAA;EXop/CrJ;IyF/g/C8B,4EAAmE,EAAA;;AzFkh/CnG;EyF3g/CwB,sD9E5I+H,EAAA;EXyp/CrJ;IyF3g/C0B,iE9E9I2H,EAAA;EX2p/CrJ;IyF1g/C0B,iEAAwD,EAAA;;AzF6g/CpF;EyFng/CY,QAAO,EAAA;EACP;IzFqg/CR;MyFpg/CY,aAAa,EAAA,EAEpB;;AzFqg/CT;EyFng/CY,aAAa,EAAA;;AzFsg/CzB;EyFlg/CY,iB9E9K2C,EAAA;;AXmr/CvD;EyFjg/CY,U9ElL2C,EAAA;;A8EoL/C;EzFmg/CN;IyFjg/Cc,cAAc,EAAA;EzFmg/C5B;IyF//+Cc,OAAO,EAAA,EACV;;AAML;EzF4/+CN;IyF3/+CU,U9ElM2C,EAAA,E8EoMlD;;AACD;EzF4/+CF;IyF1/+CU,cAAc,EAAA;EzF4/+CxB;IyFx/+CU,OAAO,EAAA,EACV;;AzF0/+CT;E0Fxw/CQ,yC/EgHsE,EAAA;;AX2p/C9E;E0Fvw/CQ,iB/E2GsB;E+E1GtB,cAAc;EACd,4C/EgpBmD;E+E/oBnD,mCAA4D,EAAA;;A1F0w/CpE;E0Frw/CY,iBAAiB,EAAA;;A1Fww/C7B;E0Fnw/CQ,iB/E8FsB;E+E7FtB,cAAc;EACd,kBAAkB,EAAA;;AAKd;E1Fkw/CV;I0Fhw/CkB,kBAAkB,EAAA,EACrB;;AAID;E1F+v/Cd;I0F9v/CkB,cAAc,EAAA,EAErB;;A1F+v/Cb;E0F3v/CY,kBAAkB;EAClB,8BAAoE,EAAA;EACpE;I1F6v/CR;M0F5v/CY,qBAAwC,EAAA,EAE/C;;A1F6v/CT;E0Fxv/CY,+BAAiE,EAAA;EAEjE;I1Fyv/CR;M0Fxv/CY,sBAAqC,EAAA,EAE5C;;A1Fyv/CT;E0Fpv/CY,+BAAoE,EAAA;EACpE;I1Fsv/CR;M0Frv/CY,sBAAwC,EAAA,EAE/C;;A1Fsv/CT;E0F/u/CY,mCAA4D,EAAA;;AAGhE;E1Fgv/CN;I0F9u/Cc,iBAAiB;IACjB,gBAAgB,EAAA;E1Fgv/C9B;I0F5u/Cc,iBAAiB,EAAA,EACpB;;A1F8u/Cb;E0Fzu/CgB,eAAe;EACf,kBAAkB,EAAA;;A1F4u/ClC;E0Flu/CQ,eAAe,EAAA;;A1Fqu/CvB;E0Flu/CQ,iB/EYsB,EAAA;;AXyt/C9B;E0Flu/CQ,+BAA8C,EAAA;;A1Fqu/CtD;E0Fhu/CY,kBAAkB,EAAA;;AAQ1B;E1F4t/CF;I0F1t/CU,kBAAkB,EAAA,EACrB;;AAID;E1Fyt/CN;I0Fvt/Cc,kBAAkB,EAAA,EACrB;;AClIb;;;;;;uD3Fi2/CuD;A2F11/CtD;EACG,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,gBAAgB;EAChB,yBAAyB;EAGzB,iBAAiB;EACjB,wCAAwC,EAAA;;AAE1C;EACE,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,8BAA8B;EAI9B,qJAAqJ;EAIrJ,6BAA6B;EAI7B,uCAAuC;EAKvC,mCAAmC;EACnC,oBAAoB,EAAA;;AAEtB;EACE,oCAAoC;EAIpC,6KAA6K,EAAA;;AAE/K;EACE,8BAA8B,EAAA;;AAEhC;EACE,oCAAoC,EAAA;;AAEtC;EAIE,2BAA2B,EAAA;;AAE7B;;EAME,wBAAwB;EACxB,2EAA2E,EAAA;;AAE7E;;;;EAIE,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,YAAY;EACZ,aAAa;EACb,cAAc;EACd,kCAAkC;EAClC,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,UAAU,EAAA;;AAEZ;EACE,qBAAqB;EACrB,oBAAoB,EAAA;;AAEtB;EACE,SAAS;EACT,qBAAqB,EAAA;;AAEvB;EACE,oBAAoB;EACpB,sBAAsB,EAAA;;AAExB;EACE,UAAU,EAAA;;AAEZ;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,UAAU,EAAA;;AAEZ;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,kBAAkB,EAAA;;AAEpB;EACE,wBAAwB;EAExB,iDAAiD;EAIjD,qBAAqB,EAAA;;AAEvB;EAEE,+CAA+C,EAAA;;AAEjD;EACE,cAAc,EAAA;;AAvFhB;EA4FM,0ChFMO,EAAA;;AgFFf;EAEQ,yChF6BY,EAAA;;AgF1BpB;EAEQ,yChF+BY,EAAA;;AgF5BpB;EAEQ,yChF4BY,EAAA;;AgFzBpB;EAEQ,yChFoBY,EAAA;;AgFjBpB;EAEQ,wChFaY,EAAA;;AiF9KpB;EACI,cAAc;EACd,aAAa,EAAA;;AAGjB;EACI,YAAY;EACZ,WAAW,EAAA;;AAGf;EACI,YAAY;EACZ,WAAW,EAAA;;AAGf;EACI,cAAc;EACd,aAAa,EAAA;;AAGjB;EACI,YAAY;EACZ,WAAW,EAAA;;AAGf;EACI,cAAc;EACd,aAAa,EAAA;;AAGjB;EACI,mBAAmB;EACnB,yBjF0IgB;EiFzIhB,WjF4GW;EiF3GX,aAAa;EACb,gBjFkFoB;EiFjFpB,YAAY;EACZ,uBAAuB;EACvB,WAAW,EAAA;;AAIf;EACI,kBAAkB;EAClB,aAAa;EACb,eAAe,EAAA;EAHnB;IAMQ,kBAAkB;IAClB,mCjF+zCsE;IiF9zCtE,kBAAkB;IAClB,oBAAoB,EAAA;IAT5B;MAYY,kBAAkB;MAClB,2BAA2B;MAC3B,UAAU,EAAA;;ACxDtB;EAEQ,gBlFmHgB,EAAA;;AkFrHxB;EAMQ,clF6IU,EAAA;;AkFnJlB;EAYgB,WAAW;EACX,iCAAiC,EAAA;;AAbjD;EAkBoB,WAAW,EAAA;;AAS/B;EAGY,iCAAiC;EACjC,oCAAoC;EACpC,iBAAiB;EACjB,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB,EAAA;;AAR5B;EAagB,iCAAiC;EACjC,iBAAiB;EACjB,kBAAkB,EAAA;;AAQlC;EAGY,iCAAiC;EACjC,oCAAoC;EACpC,iBAAiB;EACjB,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB,EAAA;;AAR5B;EAagB,iCAAiC;EACjC,iBAAiB;EACjB,kBAAkB,EAAA;;AASlC;EAEQ,qBAAqB,EAAA;EAF7B;IAKY,kBAAkB;IAClB,alFyyCqC;IkFxyCrC,SAAS,EAAA;EAPrB;IAYgB,SAAS,EAAA;;AAQzB;EAEQ,4ClF6xCsF;EkF5xCtF,sBlFgjB4B,EAAA;EkFnjBpC;IAMY,eAAe,EAAA;EAN3B;IAUY,sBlFyiBwB,EAAA;IkFnjBpC;MAagB,4BAA4B;MAC5B,6BAA6B,EAAA;;AAM7C;EAEQ,6ClFywCsF,EAAA;;AkFjwC1F;EAEQ,qClF4CQ,EAAA;EkF9ChB;IAKY,gBAAgB,EAAA;IAL5B;MAQgB,clFsCA;MkFrCA,oDAA8C,EAAA;IAT9D;MAagB,clFiCA,EAAA;;AkF3BhB;EAGY,gBAAgB,EAAA;EAH5B;IAMgB,WlFRL;IkFSK,oCAAmC,EAAA;;AA1BnD;EAEQ,sClF8CQ,EAAA;EkFhDhB;IAKY,gBAAgB,EAAA;IAL5B;MAQgB,clFwCA;MkFvCA,qDAA8C,EAAA;IAT9D;MAagB,clFmCA,EAAA;;AkF7BhB;EAGY,gBAAgB,EAAA;EAH5B;IAMgB,WlFRL;IkFSK,oCAAmC,EAAA;;AA1BnD;EAEQ,qClFmDQ,EAAA;EkFrDhB;IAKY,gBAAgB,EAAA;IAL5B;MAQgB,clF6CA;MkF5CA,oDAA8C,EAAA;IAT9D;MAagB,clFwCA,EAAA;;AkFlChB;EAGY,gBAAgB,EAAA;EAH5B;IAMgB,WlFRL;IkFSK,oCAAmC,EAAA;;AA1BnD;EAEQ,qClFqDQ,EAAA;EkFvDhB;IAKY,gBAAgB,EAAA;IAL5B;MAQgB,clF+CA;MkF9CA,oDAA8C,EAAA;IAT9D;MAagB,clF0CA,EAAA;;AkFpChB;EAGY,gBAAgB,EAAA;EAH5B;IAMgB,WlFRL;IkFSK,oCAAmC,EAAA;;AA1BnD;EAEQ,qClFkDQ,EAAA;EkFpDhB;IAKY,gBAAgB,EAAA;IAL5B;MAQgB,clF4CA;MkF3CA,oDAA8C,EAAA;IAT9D;MAagB,clFuCA,EAAA;;AkFjChB;EAGY,gBAAgB,EAAA;EAH5B;IAMgB,WlFRL;IkFSK,oCAAmC,EAAA;;AA1BnD;EAEQ,oClFgDQ,EAAA;EkFlDhB;IAKY,gBAAgB,EAAA;IAL5B;MAQgB,clF0CA;MkFzCA,mDAA8C,EAAA;IAT9D;MAagB,clFqCA,EAAA;;AkF/BhB;EAGY,gBAAgB,EAAA;EAH5B;IAMgB,WlFRL;IkFSK,oCAAmC,EAAA;;AA1BnD;EAEQ,sClFgBM,EAAA;EkFlBd;IAKY,gBAAgB,EAAA;IAL5B;MAQgB,clFUF;MkFTE,qDAA8C,EAAA;IAT9D;MAagB,clFKF,EAAA;;AkFCd;EAGY,gBAAgB,EAAA;EAH5B;IAMgB,WlFRL;IkFSK,oCAAmC,EAAA;;AA1BnD;EAEQ,mClFwBM,EAAA;EkF1Bd;IAKY,gBAAgB,EAAA;IAL5B;MAQgB,clFkBF;MkFjBE,kDAA8C,EAAA;IAT9D;MAagB,clFaF,EAAA;;AkFPd;EAGY,gBAAgB,EAAA;EAH5B;IAMgB,WlFRL;IkFSK,oCAAmC,EAAA;;A7FykgDvD;E6F5jgDY,8CAA6F,EAAA;E7F8jgDvG;I6F5jgDc,0DpElCkE,EAAA;;AzBimgDlF;E6F1jgDY,0DpEvCsE,EAAA;;AzBomgDlF;E6FpjgDY,yBAAyB,EAAA;;AChLnC;EACE,0BAA8C,EAAA;;AADhD;EACE,0BAA8C,EAAA;;AADhD;EACE,0BAA8C,EAAA;;AADhD;EACE,0BAA8C,EAAA;;AADhD;EACE,0BAA8C,EAAA;;AADhD;EACE,0BAA8C,EAAA;;AADhD;EACE,0BAA8C,EAAA;;AADhD;EACE,0BAA8C,EAAA;;AADhD;EACE,0BAA8C,EAAA;;AADhD;EACE,0BAA8C,EAAA;;AADhD;EACE,0BAA8C,EAAA;;AADhD;EACE,0BAA8C,EAAA;;AADhD;EACE,0BAA8C,EAAA;;AADhD;EACE,0BAA8C,EAAA;;AADhD;EACE,0BAA8C,EAAA;;AADhD;EACE,0BAA8C,EAAA;;AADhD;EACE,0BAA8C,EAAA;;AhB0D1C;EgBpDJ,uCAA4D,EAAA;;AhBoDxD;EgBjDJ,wCAA8D,EAAA;;AAM9D;EACI,+BAAgD,EAAA;;AAEpD;EACI,mCAAoD,EAAA;;AAExD;EACI,sCAAuD,EAAA;;AAE3D;EACI,qCAAsD,EAAA;;AAE1D;EACI,oCAAqD,EAAA;;AAIzD;EAEQ,uBAAuB,EAAA;EAF/B;IAIY,+BAAgD,EAAA;;AArB5D;EACI,+BAAgD,EAAA;;AAEpD;EACI,mCAAoD,EAAA;;AAExD;EACI,sCAAuD,EAAA;;AAE3D;EACI,qCAAsD,EAAA;;AAE1D;EACI,oCAAqD,EAAA;;AAIzD;EAEQ,uBAAuB,EAAA;EAF/B;IAIY,+BAAgD,EAAA;;AArB5D;EACI,+BAAgD,EAAA;;AAEpD;EACI,mCAAoD,EAAA;;AAExD;EACI,sCAAuD,EAAA;;AAE3D;EACI,qCAAsD,EAAA;;AAE1D;EACI,oCAAqD,EAAA;;AAIzD;EAEQ,uBAAuB,EAAA;EAF/B;IAIY,+BAAgD,EAAA;;AArB5D;EACI,+BAAgD,EAAA;;AAEpD;EACI,mCAAoD,EAAA;;AAExD;EACI,sCAAuD,EAAA;;AAE3D;EACI,qCAAsD,EAAA;;AAE1D;EACI,oCAAqD,EAAA;;AAIzD;EAEQ,uBAAuB,EAAA;EAF/B;IAIY,+BAAgD,EAAA;;AArB5D;EACI,8BAAgD,EAAA;;AAEpD;EACI,kCAAoD,EAAA;;AAExD;EACI,qCAAuD,EAAA;;AAE3D;EACI,oCAAsD,EAAA;;AAE1D;EACI,mCAAqD,EAAA;;AAIzD;EAEQ,uBAAuB,EAAA;EAF/B;IAIY,8BAAgD,EAAA;;AArB5D;EACI,+BAAgD,EAAA;;AAEpD;EACI,mCAAoD,EAAA;;AAExD;EACI,sCAAuD,EAAA;;AAE3D;EACI,qCAAsD,EAAA;;AAE1D;EACI,oCAAqD,EAAA;;AAIzD;EAEQ,uBAAuB,EAAA;EAF/B;IAIY,+BAAgD,EAAA;;AArB5D;EACI,8BAAgD,EAAA;;AAEpD;EACI,kCAAoD,EAAA;;AAExD;EACI,qCAAuD,EAAA;;AAE3D;EACI,oCAAsD,EAAA;;AAE1D;EACI,mCAAqD,EAAA;;AAIzD;EAEQ,uBAAuB,EAAA;EAF/B;IAIY,8BAAgD,EAAA;;A9Fu4gDhE;E8F93gDQ,qBAA2C,EAAA;E9Fg4gDjD;I8F93gDU,qCAA+D,EAAA;;AAM3E;EACI,eAAe;EACf,aAAa;EACb,WAAW;EACX,yBAAyB;EACzB,aAAa;EACb,aAAa,EAAA;EANjB;IAQQ,uCAAuC,EAAA;;AAO/C;EACI,sCnF0nBoF,EAAA;;AmFvnBxF;EACI,kCnFlE0D,EAAA;;AmFuE9D;EACI,gBnFkCoB,EAAA;;AmEvDhB;EgByBJ,2BAA6C,EAAA;;AAKjD;EACI,SAAO,EAAA;;AAKX;EACI,YAAY;EACZ,WAAW;EACX,6BAA6B;EAC7B,cAAc;EACd,yBnF2Cc;EmF1Cd,kBAAkB;EAClB,cnFyCc;EmFxCd,kBAAkB;EAClB,oBAAoB,EAAA;EATxB;IAYQ,cnFqCU;ImFpCV,yBnFgCU,EAAA;;AmF1BlB;EACI,uEnF24C4E,EAAA;;AmFv4ChF;EACI,eAAe,EAAA;;AAGnB;EACI,eAAe,EAAA;;AAGnB;EACI,gBAAgB,EAAA;;AAGpB;EACI,gBAAgB,EAAA;;AAGpB;EACI,gBAAgB,EAAA;;AAIpB;EACI,YAAY;EACZ,WAAW,EAAA;;AAGf;EACI,YAAY;EACZ,WAAW,EAAA;;AAGf;EACI,YAAY;EACZ,WAAW,EAAA;;AAGf;EACI,YAAY;EACZ,WAAW,EAAA;;AAGf;EACI,YAAY;EACZ,WAAW,EAAA;;AAGf;EACI,YAAY;EACZ,WAAW,EAAA;;AAIf;EACI,cnF7Bc;EmF8Bd,+BnF9Bc,EAAA;;AmFmCd;EACI,cnFZY;EmFaZ,8BnFbY,EAAA;;AmFWhB;EACI,cnFVY;EmFWZ,+BnFXY,EAAA;;AmFShB;EACI,cnFLY;EmFMZ,8BnFNY,EAAA;;AmFIhB;EACI,cnFHY;EmFIZ,8BnFJY,EAAA;;AmFEhB;EACI,cnFNY;EmFOZ,8BnFPY,EAAA;;AmFKhB;EACI,cnFRY;EmFSZ,6BnFTY,EAAA;;AmFOhB;EACI,cnFxCU;EmFyCV,+BnFzCU,EAAA;;AmFuCd;EACI,cnFhCU;EmFiCV,4BnFjCU,EAAA;;AmFsClB;EACI,kBAAkB,EAAA;EADtB;IAGQ,kBAAkB,EAAA;EAH1B;IAMQ,eAAe;IACf,kBAAkB;IAClB,UAAU;IACV,MAAM;IACN,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,cnFtDU,EAAA;;AmF6DlB;EACI,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,QAAQ;EACR,SAAS;EACT,OAAO;EACP,MAAM;EACN,YAAY;EACZ,sBnF5EW,EAAA;;AmFiFf;EACI,eAAe;EACf,YAAY;EACZ,WAAW;EACX,aAAa,EAAA;;ApFkEjB;EoF7DI,wBAAgB;UAAhB,gBAAgB,EAAA;;AAGpB;EACI,YAAY;EACZ,qBAAqC;EACrC,8BAA6C;EAC7C,2BAA0C,EAAA;;AAK1C;EAFJ;IAGQ,aAAa;IACb,0BAA0B;IAC1B,aAAa;IACb,UAAU;IACV,QAAQ;IACR,WAAW;IACX,aAAa,EAAA;IATrB;MAWY,eAAe;MACf,MAAM;MACN,UAAU;MACV,WAAW;MACX,SAAS;MACT,uCnF3GM,EAAA;ImF2FlB;MAoBY,eAAe;MACf,YAAY;MACZ,iBAAiB,EAAA;IAtB7B;MAyBY,gBAAgB;MAChB,+BAA+B,EAAA,EAClC;;AAKL;E9Fy1gDF;I8Fv1gDU,+BAA8C;IAC9C,eAAe;IACf,qCAAoD,EAAA,EACvD;;AAKT;EACI,iBAAiB,EAAA;;AAIrB;EACI,gBAAgB;EAChB,uBAAuB;EACvB,qBAAqB;EACrB,oBAAoB;EACpB,4BAA4B;EAC5B,mBAAmB,EAAA;;AAIvB;EAEQ,cnFzJU,EAAA;;AmFuJlB;EAMY,cnFhIQ,EAAA;EmF0HpB;IASgB,gBAAgB,EAAA;;AAMhC;EACI,kCAAmE,EAAA;;AAGvE;EACI,iCAAiE,EAAA;;A9F00gDrE;E8Fr0gDQ,kDAAkD,EAAA;;AAI1D;EACI,eAAe,EAAA;;ACxUnB;EACI,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,mCpF02C0E;EoFz2C1E,aAAa,EAAA;;AAGjB;EACI,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,uBAAuB,EAAA;;AAG3B;EACI,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kDAAkD,EAAA;;AAGtD;EACI,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,mDAAmD,EAAA;EANvD;IAQQ,WAAW;IACX,cAAc;IACd,UAAU;IACV,WAAW;IACX,yBpFmIY;IoFlIZ,mBAAmB;IACnB,0DAA0D,EAAA;EAdlE;IAkBQ,sBAAsB,EAAA;IAlB9B;MAoBY,sBAAsB,EAAA;EApBlC;IAwBQ,sBAAsB,EAAA;IAxB9B;MA0BY,sBAAsB,EAAA;EA1BlC;IA8BQ,sBAAsB,EAAA;IA9B9B;MAgCY,sBAAsB,EAAA;EAhClC;IAoCQ,sBAAsB,EAAA;IApC9B;MAsCY,sBAAsB,EAAA;EAtClC;IA0CQ,sBAAsB,EAAA;IA1C9B;MA4CY,sBAAsB,EAAA;EA5ClC;IAgDQ,sBAAsB,EAAA;IAhD9B;MAkDY,sBAAsB,EAAA;;AAKlC;EACI;IACI,yBAAyB,EAAA,EAAA;;AAIjC;EACI;IACI,yBAAyB,EAAA,EAAA;;AAIjC;EACI;IACI,qBAAqB,EAAA;EAEzB;IACI,mBAAqB,EAAA,EAAA;;A/FynhD7B;;;;EgGvthDQ,gBAAgB,EAAA;;ACLxB;EAEQ,+CtF2oB0E;EsF1oB1E,iBAAiB,EAAA;EAHzB;IAMY,iBAAiB,EAAA;;AAO7B,aAAA;AAEA;EACI,gBAAgB,EAAA;EADpB;IAIQ,kBAAkB;IAClB,oBAAoB;IACpB,kBAAkB;IAClB,8BtFwHU,EAAA;IsF/HlB;MAUY,WAAW;MACX,cAAc;MACd,kBAAkB;MAClB,QAAQ;MACR,UAAU;MACV,WAAW;MACX,YAAY;MACZ,kBAAkB;MAClB,yBtFyIQ;MsFxIR,mCtF80CkE,EAAA;IsFj2C9E;MAuBY,yBAAyB,EAAA;;AAMrC;EACI,kBAAkB,EAAA;EADtB;IAIQ,gBAAgB;IAChB,kBAAkB,EAAA;IAL1B;MASY,WAAW;MACX,kBAAkB;MAClB,UAAU;MACV,YAAY;MACZ,yCtFwHQ;MsFvHR,SAAS;MACT,wBAAwB;MACxB,SAAS;MACT,oBAAoB,EAAA;IAjBhC;MAqBY,UAAU;MACV,UAAU;MACV,oBAAoB,EAAA;EAvBhC;IA8BgB,UAAU,EAAA;EA9B1B;IAkCgB,UAAU,EAAA;;AC7E1B;EACI,iBAAiB;EACjB,oBAAoB,EAAA;EAFxB;IAKQ,mBAAmB;IACnB,gBAAgB,EAAA;;AAKxB;EACI,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,YAAY;EACZ,UAAU;EACV,UAAU;EACV,cAAc,EAAA;;AlGmxhDlB;EkG9whDQ,4BAA4B,EAAA;;AAKpC;EACI,yBAAmD,EAAA;EADvD;IAIQ,eAAe;IACf,kBAAkB;IAClB,yBAAmD;IACnD,oBAAoB;IACpB,sBAAsB,EAAA;EAR9B;IAYQ,kBAAkB;IAClB,oBAAoB;IACpB,YAAY,EAAA;EAdpB;IAkBQ,gBAAgB,EAAA;IAlBxB;MAsBgB,cvFuHI;MuFtHJ,qBAAqB,EAAA;;AAQrC;EAEQ,yBvFgFU;EuF/EV,gBAAgB;EAChB,gBAAgB;EAChB,gBvFoDgB;EuFnDhB,kBAAkB,EAAA;;AlGgwhD1B;EkGzvhDY,gCAAsD,EAAA;;AlG4vhDlE;EkGzvhDY,2DAAqF,EAAA;;AlG4vhDjG;EkGxvhDY,0DAAiF,EAAA;;AlG2vhD7F;EkGtvhDgB,8CAAoC,EAAA;;ACpFpD;EACI;;;;;;IAME,wBAAwB,EAAA;EAE1B;;;;;IAKE,UAAU;IACV,SAAS,EAAA;EvDhBf;IuDoBM,SAAS,EAAA;EAGX;IAEI,wBAAwB,EAAA;EAG5B;IAEI,yBAAyB;IACzB,qBAAqB;IACrB,0BAA0B,EAAA,EAC3B;;ACjCP;EACI,kBAAkB;EAkMlB,eAAA,EAAgB;EAnMpB;IAIQ,iBAAiB;IACjB,+CzFiJU;IyFhJV,WzFuIO;IyFtIP,mBzFksB8B;IyFjsB9B,gBzF8GkB;IyF7GlB,kBAAkB;IAClB,UAAU;IACV,QAAQ,EAAA;IAXhB;MAcY,4BAA4B,EAAA;IAdxC;MAkBY,qBAAqB,EAAA;MAlBjC;QAqBgB,WAAW;QACX,kBAAkB;QAClB,YAAY;QACZ,MAAM;QACN,8BAA8B,EAAA;MAzB9C;QA6BgB,WAAW;QACX,kBAAkB;QAClB,YAAY;QACZ,SAAS;QACT,8BAA8B,EAAA;EAjC9C;IA0CY,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,SAAS,EAAA;EAlDrB;IAyDQ,gBAAgB,EAAA;IAzDxB;MA4DY,yBAAyB;MACzB,WAAW;MACX,YAAY;MACZ,WAAW;MACX,UAAU;MACV,aAAa;MACb,uBAAuB;MACvB,qBAAqB,EAAA;IAnEjC;MAuEgB,iBAAiB;MACjB,WAAW;MACX,YAAY;MACZ,eAAe;MACf,gBAAgB,EAAA;EA3EhC;IAmFY,kBAAkB;IAClB,UAAU;IACV,QAAQ,EAAA;IArFpB;MAwFgB,4BAA4B,EAAA;IAxF5C;MA4FgB,iBAAiB,EAAA;MA5FjC;QAgGoB,WAAW;QACX,WAAW;QACX,8BAA8B,EAAA;EAlGlD;IAyGgB,UAAU;IACV,WAAW,EAAA;EA1G3B;IA+GY,WAAW;IACX,UAAU,EAAA;EAhHtB;IAqHgB,wBAAwB;IACxB,YAAY;IACZ,UAAU,EAAA;EAvH1B;IA6HgB,UAAU;IACV,WAAW,EAAA;IA9H3B;MAiIoB,UAAU;MACV,YAAY;MACZ,wBAAwB,EAAA;EAnI5C;IA2IQ,WAAW,EAAA;EA3InB;IAiJY,mBzFyBQ,EAAA;IyF1KpB;MAoJgB,6CAA2D,EAAA;IApJ3E;MAyJoB,0BzFiBA;MyFhBA,yBzFgBA,EAAA;IyF1KpB;MA8JoB,0BzFYA;MyFXA,4BzFWA,EAAA;EyF1KpB;IAsKgB,mBzFII,EAAA;IyF1KpB;MA0KwB,2BzFAJ;MyFCI,yBzFDJ,EAAA;IyF1KpB;MA+KwB,2BzFLJ;MyFMI,4BzFNJ,EAAA;EyF1KpB;IAiJY,mBzF2BQ,EAAA;IyF5KpB;MAoJgB,6CAA2D,EAAA;IApJ3E;MAyJoB,0BzFmBA;MyFlBA,yBzFkBA,EAAA;IyF5KpB;MA8JoB,0BzFcA;MyFbA,4BzFaA,EAAA;EyF5KpB;IAsKgB,mBzFMI,EAAA;IyF5KpB;MA0KwB,2BzFEJ;MyFDI,yBzFCJ,EAAA;IyF5KpB;MA+KwB,2BzFHJ;MyFII,4BzFJJ,EAAA;EyF5KpB;IAiJY,mBzFgCQ,EAAA;IyFjLpB;MAoJgB,6CAA2D,EAAA;IApJ3E;MAyJoB,0BzFwBA;MyFvBA,yBzFuBA,EAAA;IyFjLpB;MA8JoB,0BzFmBA;MyFlBA,4BzFkBA,EAAA;EyFjLpB;IAsKgB,mBzFWI,EAAA;IyFjLpB;MA0KwB,2BzFOJ;MyFNI,yBzFMJ,EAAA;IyFjLpB;MA+KwB,2BzFEJ;MyFDI,4BzFCJ,EAAA;EyFjLpB;IAiJY,mBzFkCQ,EAAA;IyFnLpB;MAoJgB,6CAA2D,EAAA;IApJ3E;MAyJoB,0BzF0BA;MyFzBA,yBzFyBA,EAAA;IyFnLpB;MA8JoB,0BzFqBA;MyFpBA,4BzFoBA,EAAA;EyFnLpB;IAsKgB,mBzFaI,EAAA;IyFnLpB;MA0KwB,2BzFSJ;MyFRI,yBzFQJ,EAAA;IyFnLpB;MA+KwB,2BzFIJ;MyFHI,4BzFGJ,EAAA;EyFnLpB;IAiJY,mBzF+BQ,EAAA;IyFhLpB;MAoJgB,6CAA2D,EAAA;IApJ3E;MAyJoB,0BzFuBA;MyFtBA,yBzFsBA,EAAA;IyFhLpB;MA8JoB,0BzFkBA;MyFjBA,4BzFiBA,EAAA;EyFhLpB;IAsKgB,mBzFUI,EAAA;IyFhLpB;MA0KwB,2BzFMJ;MyFLI,yBzFKJ,EAAA;IyFhLpB;MA+KwB,2BzFCJ;MyFAI,4BzFAJ,EAAA;EyFhLpB;IAiJY,mBzF6BQ,EAAA;IyF9KpB;MAoJgB,6CAA2D,EAAA;IApJ3E;MAyJoB,0BzFqBA;MyFpBA,yBzFoBA,EAAA;IyF9KpB;MA8JoB,0BzFgBA;MyFfA,4BzFeA,EAAA;EyF9KpB;IAsKgB,mBzFQI,EAAA;IyF9KpB;MA0KwB,2BzFIJ;MyFHI,yBzFGJ,EAAA;IyF9KpB;MA+KwB,2BzFDJ;MyFEI,4BzFFJ,EAAA;EyF9KpB;IAiJY,mBzFHM,EAAA;IyF9IlB;MAoJgB,6CAA2D,EAAA;IApJ3E;MAyJoB,0BzFXF;MyFYE,yBzFZF,EAAA;IyF9IlB;MA8JoB,0BzFhBF;MyFiBE,4BzFjBF,EAAA;EyF9IlB;IAsKgB,mBzFxBE,EAAA;IyF9IlB;MA0KwB,2BzF5BN;MyF6BM,yBzF7BN,EAAA;IyF9IlB;MA+KwB,2BzFjCN;MyFkCM,4BzFlCN,EAAA;EyF9IlB;IAiJY,mBzFKM,EAAA;IyFtJlB;MAoJgB,6CAA2D,EAAA;IApJ3E;MAyJoB,0BzFHF;MyFIE,yBzFJF,EAAA;IyFtJlB;MA8JoB,0BzFRF;MyFSE,4BzFTF,EAAA;EyFtJlB;IAsKgB,mBzFhBE,EAAA;IyFtJlB;MA0KwB,2BzFpBN;MyFqBM,yBzFrBN,EAAA;IyFtJlB;MA+KwB,2BzFzBN;MyF0BM,4BzF1BN,EAAA;EyFtJlB;IA2LQ,gBAAgB;IAChB,UAAU;IACV,UAAU;IACV,eAAe;IACf,UAAU,EAAA;EA/LlB;IAqMQ,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,iBAAiB,EAAA;IA5MzB;MA+MY,eAAe;MACf,WzFnEG;MyFoEH,kBAAkB;MAClB,iBAAiB;MACjB,yBAAyB;MACzB,YAAY;MACZ,cAAc;MACd,wEAAwE;MACxE,kBAAkB;MAClB,SAAS;MACT,WAAW;MACX,gBzFpGc,EAAA;MyFtH1B;QA6NgB,WAAW;QACX,kBAAkB;QAClB,OAAO;QACP,SAAS;QACT,WAAW;QACX,mCAAmC;QACnC,oCAAoC,EAAA;MAnOpD;QAuOgB,WAAW;QACX,kBAAkB;QAClB,QAAQ;QACR,SAAS;QACT,WAAW;QACX,kCAAkC;QAClC,oCAAoC,EAAA;EA7OpD;IAuPgB,mBzF7EI,EAAA;IyF1KpB;MA0PoB,8BAA4C;MAC5C,6BAA2C,EAAA;IA3P/D;MA+PoB,+BAA6C;MAC7C,6BAA2C,EAAA;EAhQ/D;IAuPgB,mBzF3EI,EAAA;IyF5KpB;MA0PoB,8BAA4C;MAC5C,6BAA2C,EAAA;IA3P/D;MA+PoB,+BAA6C;MAC7C,6BAA2C,EAAA;EAhQ/D;IAuPgB,mBzFtEI,EAAA;IyFjLpB;MA0PoB,8BAA4C;MAC5C,6BAA2C,EAAA;IA3P/D;MA+PoB,+BAA6C;MAC7C,6BAA2C,EAAA;EAhQ/D;IAuPgB,mBzFpEI,EAAA;IyFnLpB;MA0PoB,8BAA4C;MAC5C,6BAA2C,EAAA;IA3P/D;MA+PoB,+BAA6C;MAC7C,6BAA2C,EAAA;EAhQ/D;IAuPgB,mBzFvEI,EAAA;IyFhLpB;MA0PoB,8BAA4C;MAC5C,6BAA2C,EAAA;IA3P/D;MA+PoB,+BAA6C;MAC7C,6BAA2C,EAAA;EAhQ/D;IAuPgB,mBzFzEI,EAAA;IyF9KpB;MA0PoB,8BAA4C;MAC5C,6BAA2C,EAAA;IA3P/D;MA+PoB,+BAA6C;MAC7C,6BAA2C,EAAA;EAhQ/D;IAuPgB,mBzFzGE,EAAA;IyF9IlB;MA0PoB,8BAA4C;MAC5C,6BAA2C,EAAA;IA3P/D;MA+PoB,+BAA6C;MAC7C,6BAA2C,EAAA;EAhQ/D;IAuPgB,mBzFjGE,EAAA;IyFtJlB;MA0PoB,4BAA4C;MAC5C,2BAA2C,EAAA;IA3P/D;MA+PoB,6BAA6C;MAC7C,2BAA2C,EAAA;;AAS/D;EAGY,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,UAAU,EAAA;;AAKtB;EACI,kBAAkB;EAClB,WAAW;EACX,UAAU,EAAA;EAHd;IAMQ,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,WzFhJO;IyFiJP,eAAe;IACf,cAAc;IACd,sBAAsB;IACtB,4BAA4B;IAC5B,WAAW,EAAA;IAdnB;MAkBY,kBAAkB;MAClB,WAAW,EAAA;IAnBvB;MAuBY,WAAW;MACX,UAAU;MACV,UAAU;MACV,MAAM,EAAA;IA1BlB;MA8BY,WAAW;MACX,UAAU;MACV,UAAU;MACV,MAAM;MACN,0BAA0B,EAAA;EAlCtC;IAuCQ,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,SAAS;IACT,mCAAmC;IACnC,oCAAoC;IACpC,sBAAsB,EAAA;;AAM1B;EAGQ,mBzFhKQ,EAAA;EyF6JhB;IAMY,mBzFnKI,EAAA;EyF6JhB;IAUY,mBAA+B,EAAA;;AAV3C;EAeQ,yBzF5KQ,EAAA;;AyF6JhB;EAGQ,mBzF9JQ,EAAA;EyF2JhB;IAMY,mBzFjKI,EAAA;EyF2JhB;IAUY,mBAA+B,EAAA;;AAV3C;EAeQ,yBzF1KQ,EAAA;;AyF2JhB;EAGQ,mBzFzJQ,EAAA;EyFsJhB;IAMY,mBzF5JI,EAAA;EyFsJhB;IAUY,mBAA+B,EAAA;;AAV3C;EAeQ,yBzFrKQ,EAAA;;AyFsJhB;EAGQ,mBzFvJQ,EAAA;EyFoJhB;IAMY,mBzF1JI,EAAA;EyFoJhB;IAUY,mBAA+B,EAAA;;AAV3C;EAeQ,yBzFnKQ,EAAA;;AyFoJhB;EAGQ,mBzF1JQ,EAAA;EyFuJhB;IAMY,mBzF7JI,EAAA;EyFuJhB;IAUY,mBAA+B,EAAA;;AAV3C;EAeQ,yBzFtKQ,EAAA;;AyFuJhB;EAGQ,mBzF5JQ,EAAA;EyFyJhB;IAMY,mBzF/JI,EAAA;EyFyJhB;IAUY,mBAA+B,EAAA;;AAV3C;EAeQ,yBzFxKQ,EAAA;;AyFyJhB;EAGQ,mBzF5LM,EAAA;EyFyLd;IAMY,mBzF/LE,EAAA;EyFyLd;IAUY,mBAA+B,EAAA;;AAV3C;EAeQ,yBzFxMM,EAAA;;AyFyLd;EAGQ,mBzFpLM,EAAA;EyFiLd;IAMY,mBzFvLE,EAAA;EyFiLd;IAUY,mBAA+B,EAAA;;AAV3C;EAeQ,yBzFhMM,EAAA;;AyFsMlB;EAEQ,4BAA4B;EAC5B,yBAAyB,EAAA;EAHjC;IAMY,yBAAyB;IACzB,UAAU,EAAA;;AAPtB;EAaY,wBAAwB,EAAA;EAbpC;IAgBgB,UAAU,EAAA;;AAhB1B;EAsBY,2BAA2B;EAC3B,yBAAyB,EAAA;EAvBrC;IA0BgB,yBAAyB;IACzB,UAAU,EAAA;;AA3B1B;EAiCgB,wBAAwB,EAAA;EAjCxC;IAoCoB,UAAU,EAAA;;AC9X9B;EAEM,sB1Fm9CoC,EAAA;;A0F98CtC;EACI,c1FgKY;E0F/JZ,gC1F+JY,EAAA;;A0FjKhB;EACI,c1FkKY;E0FjKZ,gC1FiKY,EAAA;;A0FnKhB;EACI,c1FuKY;E0FtKZ,gC1FsKY,EAAA;;A0FxKhB;EACI,c1FyKY;E0FxKZ,gC1FwKY,EAAA;;A0F1KhB;EACI,c1FsKY;E0FrKZ,gC1FqKY,EAAA;;A0FvKhB;EACI,c1FoKY;E0FnKZ,gC1FmKY,EAAA;;A0FrKhB;EACI,c1FoIU;E0FnIV,gC1FmIU,EAAA;;A0FrId;EACI,c1F4IU;E0F3IV,gC1F2IU,EAAA;;A2FrJlB;EACE,kBAAkB;EAClB,aAAa;EACb,iBAAiB;EACjB,cAAc,EAAA;;AAGhB;EACE,kBAAkB;EAClB,aAAa;EACb,cAAc,EAAA;;ACXhB;EACI,kBAAkB;EAClB,gBAAgB,EAAA;;AAGpB;;;;;;EAYI,8B5FwGkE;E4FvGlE,kC5FP0D,EAAA;;ADmO9D;E6FxNI,gCAAgC,EAAA;;A7FmWpC;E6F/VI,gB5F2FoB;E4F1FpB,qB5Fk6ByC,EAAA;;ADzvB7C;;E6FrKE,gB5FuFwB,EAAA;;AEnC1B;E0F9CI,kBAAkB;EAClB,8B5F0Gc,EAAA;;A4FvGlB;EACI,cAAc;EACd,+B5FqGc;E4FpGd,iBAAiB,EAAA;;AAWjB;EANJ;;;;;;IAOQ,iBAAiB,EAAA,EAExB;;AnFzDC;EmF6DE,kBAAkB,EAAA;;AC5DtB;EAEQ,W7FyIO,EAAA;;A6FnIf;EACI,mC7Fq2C0E;E6Fp2C1E,iBAAiB,EAAA;;AAKrB;EACI,eAAe,EAAA;;AAKnB;EACI,kBAAkB;EAClB,kBAAkB;EAClB,SAAS,EAAA;EAHb;IAMQ,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,OAAO;IACP,MAAM;IACN,2C7F2GO;I6F1GP,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB,EAAA;EAf/B;IAoBQ,gBAAgB,EAAA;IApBxB;MAuBgB,WAAW;MACX,kBAAkB;MAClB,6BAA6B;MAC7B,0B7FyHI;M6FxHJ,YAAY,EAAA;;AAS5B;EACI,sBAAsB,EAAA;;AAK1B;EACI,mC7F8yC0E;E6F7yC1E,oC7F0kB8E;E6FzkB9E,qBAAqB;EACrB,2BAAuD,EAAA;;AAK3D;EACI,UAAU,EAAA;EADd;IAIQ,oB7FuaK,EAAA;E6F3ab;IAOQ,oB7FoaK;I6FnaL,kC7F+jB4B;I6F9jB5B,mC7F8jB4B;I6F7jB5B,wB7FgjByB,EAAA;;A6F1iBjC;EAEQ,WAAW;EACX,YAAY;EACZ,SAAS;EACT,QAAQ;EACR,2BAA2B;EAC3B,4BAA4B,EAAA;;AAQhC;EAEQ,yB7F+DQ;E6F9DR,qB7F8DQ;E6F7DR,W7FgCG,EAAA;;A6F3BX;EAEQ,c7FsDQ,EAAA;;A6FjDhB;EAEQ,0B7F+CQ,EAAA;;A6F1ChB;EAEQ,yB7FwCQ,EAAA;;A6FjChB;EAGY,yB7F8BI;E6F7BJ,W7FAD,EAAA;;A6FOX;EAGY,W7FVD;E6FWC,yB7FkBI,EAAA;E6FtBhB;IAMgB,qCAAoC,EAAA;;AAMpD;EAGY,c7FOI,EAAA;;A6FAhB;EAGY,yB7FHI;E6FIJ,W7FjCD,EAAA;;A6FpCX;EAEQ,yB7FiEQ;E6FhER,qB7FgEQ;E6F/DR,W7FgCG,EAAA;;A6F3BX;EAEQ,c7FwDQ,EAAA;;A6FnDhB;EAEQ,0B7FiDQ,EAAA;;A6F5ChB;EAEQ,yB7F0CQ,EAAA;;A6FnChB;EAGY,yB7FgCI;E6F/BJ,W7FAD,EAAA;;A6FOX;EAGY,W7FVD;E6FWC,yB7FoBI,EAAA;E6FxBhB;IAMgB,qCAAoC,EAAA;;AAMpD;EAGY,c7FSI,EAAA;;A6FFhB;EAGY,yB7FDI;E6FEJ,W7FjCD,EAAA;;A6FpCX;EAEQ,yB7FsEQ;E6FrER,qB7FqEQ;E6FpER,W7FgCG,EAAA;;A6F3BX;EAEQ,c7F6DQ,EAAA;;A6FxDhB;EAEQ,0B7FsDQ,EAAA;;A6FjDhB;EAEQ,yB7F+CQ,EAAA;;A6FxChB;EAGY,yB7FqCI;E6FpCJ,W7FAD,EAAA;;A6FOX;EAGY,W7FVD;E6FWC,yB7FyBI,EAAA;E6F7BhB;IAMgB,qCAAoC,EAAA;;AAMpD;EAGY,c7FcI,EAAA;;A6FPhB;EAGY,yB7FII;E6FHJ,W7FjCD,EAAA;;A6FpCX;EAEQ,yB7FwEQ;E6FvER,qB7FuEQ;E6FtER,W7FgCG,EAAA;;A6F3BX;EAEQ,c7F+DQ,EAAA;;A6F1DhB;EAEQ,0B7FwDQ,EAAA;;A6FnDhB;EAEQ,yB7FiDQ,EAAA;;A6F1ChB;EAGY,yB7FuCI;E6FtCJ,W7FAD,EAAA;;A6FOX;EAGY,W7FVD;E6FWC,yB7F2BI,EAAA;E6F/BhB;IAMgB,qCAAoC,EAAA;;AAMpD;EAGY,c7FgBI,EAAA;;A6FThB;EAGY,yB7FMI;E6FLJ,W7FjCD,EAAA;;A6FpCX;EAEQ,yB7FqEQ;E6FpER,qB7FoEQ;E6FnER,W7FgCG,EAAA;;A6F3BX;EAEQ,c7F4DQ,EAAA;;A6FvDhB;EAEQ,0B7FqDQ,EAAA;;A6FhDhB;EAEQ,yB7F8CQ,EAAA;;A6FvChB;EAGY,yB7FoCI;E6FnCJ,W7FAD,EAAA;;A6FOX;EAGY,W7FVD;E6FWC,yB7FwBI,EAAA;E6F5BhB;IAMgB,qCAAoC,EAAA;;AAMpD;EAGY,c7FaI,EAAA;;A6FNhB;EAGY,yB7FGI;E6FFJ,W7FjCD,EAAA;;A6FpCX;EAEQ,yB7FmEQ;E6FlER,qB7FkEQ;E6FjER,W7FgCG,EAAA;;A6F3BX;EAEQ,c7F0DQ,EAAA;;A6FrDhB;EAEQ,0B7FmDQ,EAAA;;A6F9ChB;EAEQ,yB7F4CQ,EAAA;;A6FrChB;EAGY,yB7FkCI;E6FjCJ,W7FAD,EAAA;;A6FOX;EAGY,W7FVD;E6FWC,yB7FsBI,EAAA;E6F1BhB;IAMgB,qCAAoC,EAAA;;AAMpD;EAGY,c7FWI,EAAA;;A6FJhB;EAGY,yB7FCI;E6FAJ,W7FjCD,EAAA;;A6FpCX;EAEQ,yB7FmCM;E6FlCN,qB7FkCM;E6FjCN,W7F0CG,EAAA;;A6FrCX;EAEQ,c7F0BM,EAAA;;A6FrBd;EAEQ,0B7FmBM,EAAA;;A6Fdd;EAEQ,yB7FYM,EAAA;;A6FLd;EAGY,yB7FEE;E6FDF,W7FUD,EAAA;;A6FHX;EAGY,W7FAD;E6FCC,yB7FVE,EAAA;E6FMd;IAMgB,qCAAoC,EAAA;;AAMpD;EAGY,c7FrBE,EAAA;;A6F4Bd;EAGY,yB7F/BE;E6FgCF,W7FvBD,EAAA;;A6F9CX;EAEQ,yB7F2CM;E6F1CN,qB7F0CM;E6FzCN,W7FgCG,EAAA;;A6F3BX;EAEQ,c7FkCM,EAAA;;A6F7Bd;EAEQ,0B7F2BM,EAAA;;A6FtBd;EAEQ,yB7FoBM,EAAA;;A6Fbd;EAGY,yB7FUE;E6FTF,W7FAD,EAAA;;A6FOX;EAGY,W7FVD;E6FWC,yB7FFE,EAAA;E6FFd;IAMgB,qCAAoC,EAAA;;AAMpD;EAGY,c7FbE,EAAA;;A6FoBd;EAGY,yB7FvBE;E6FwBF,W7FjCD,EAAA;;AuCxGf;EsDgJQ,kCAAkC,EAAA;EAF1C;IAIY,kCAAkC;IAClC,4BAA4B;IAC5B,eAAe;IACf,iBAAgB;IAChB,+CAA+C,EAAA;;AAzEvD;EA+EA,qBAA2C,EAAA;;AC9L3C;EACI,qDAAiD,EAAA;;AADrD;EACI,sDAAiD,EAAA;;AADrD;EACI,qDAAiD,EAAA;;AADrD;EACI,qDAAiD,EAAA;;AADrD;EACI,qDAAiD,EAAA;;AADrD;EACI,oDAAiD,EAAA;;AADrD;EACI,sDAAiD,EAAA;;AADrD;EACI,mDAAiD,EAAA;;AADrD;EAMA,2DAAkF,EAAA;;AANlF;EAUA,4DAAoF,EAAA;;ACGpF;EAPA,c/FiKgB;E+FhKhB,yB/FgKgB;E+F/JhB,6BAA6B,EAAA;;AAK7B;EAPA,c/FmKgB;E+FlKhB,yB/FkKgB;E+FjKhB,6BAA6B,EAAA;;AAK7B;EAPA,c/FwKgB;E+FvKhB,yB/FuKgB;E+FtKhB,6BAA6B,EAAA;;AAK7B;EAPA,c/F0KgB;E+FzKhB,yB/FyKgB;E+FxKhB,6BAA6B,EAAA;;AAK7B;EAPA,c/FuKgB;E+FtKhB,yB/FsKgB;E+FrKhB,6BAA6B,EAAA;;AAK7B;EAPA,c/FqKgB;E+FpKhB,yB/FoKgB;E+FnKhB,6BAA6B,EAAA;;AAK7B;EAPA,c/FqIc;E+FpId,yB/FoIc;E+FnId,6BAA6B,EAAA;;AAK7B;EAPA,c/F6Ic;E+F5Id,yB/F4Ic;E+F3Id,6BAA6B,EAAA;;AAYjC;EACI,mC/Fw1C0E;E+Fv1C1E,iBAAiB,EAAA;;AAKjB;EA5BA,c/FwKgB;E+FvKhB,yC/FuKgB,EAAA;;A+FxIhB;EAzBA,c/FiKgB;E+FhKhB,yB/FgKgB;E+F/JhB,6BAA6B,EAAA;;AA6B7B;EAGY,2B/F+HI,EAAA;;A+F5IhB;EA5BA,c/F0KgB;E+FzKhB,0C/FyKgB,EAAA;;A+F1IhB;EAzBA,c/FmKgB;E+FlKhB,yB/FkKgB;E+FjKhB,6BAA6B,EAAA;;AA6B7B;EAGY,2B/FiII,EAAA;;A+F9IhB;EA5BA,c/F+KgB;E+F9KhB,yC/F8KgB,EAAA;;A+F/IhB;EAzBA,c/FwKgB;E+FvKhB,yB/FuKgB;E+FtKhB,6BAA6B,EAAA;;AA6B7B;EAGY,2B/FsII,EAAA;;A+FnJhB;EA5BA,c/FiLgB;E+FhLhB,yC/FgLgB,EAAA;;A+FjJhB;EAzBA,c/F0KgB;E+FzKhB,yB/FyKgB;E+FxKhB,6BAA6B,EAAA;;AA6B7B;EAGY,2B/FwII,EAAA;;A+FrJhB;EA5BA,c/F8KgB;E+F7KhB,yC/F6KgB,EAAA;;A+F9IhB;EAzBA,c/FuKgB;E+FtKhB,yB/FsKgB;E+FrKhB,6BAA6B,EAAA;;AA6B7B;EAGY,2B/FqII,EAAA;;A+FlJhB;EA5BA,c/F4KgB;E+F3KhB,wC/F2KgB,EAAA;;A+F5IhB;EAzBA,c/FqKgB;E+FpKhB,yB/FoKgB;E+FnKhB,6BAA6B,EAAA;;AA6B7B;EAGY,2B/FmII,EAAA;;A+FhJhB;EA5BA,c/F4Ic;E+F3Id,0C/F2Ic,EAAA;;A+F5Gd;EAzBA,c/FqIc;E+FpId,yB/FoIc;E+FnId,6BAA6B,EAAA;;AA6B7B;EAGY,2B/FmGE,EAAA;;A+FhHd;EA5BA,c/FoJc;E+FnJd,uC/FmJc,EAAA;;A+FpHd;EAzBA,c/F6Ic;E+F5Id,yB/F4Ic;E+F3Id,6BAA6B,EAAA;;AA6B7B;EAGY,2B/F2GE,EAAA;;A+FnGlB;EACI,sBAAsB,EAAA;;AAK1B;EACI,gBAAgB;EAChB,kBAAkB,EAAA;EAFtB;IAKQ,WAAW;IACX,kBAAkB;IAClB,6BAA6B;IAC7B,2B/FyGY;I+FxGZ,WAAW;IACX,MAAM,EAAA;;A1G61jDd;E0Gt1jDY,4CAAmE,EAAA;;A1Gy1jD/E;E0Gr1jDY,2CAAiE;EACjE,iCAAwD,EAAA;;AAiBhE;EACI,6DAX2E,EAAA;;AAU/E;EACI,6DAV6D,EAAA;;AASjE;EACI,6DAT4D,EAAA;;AAQhE;EACI,6DAR4D,EAAA;;AAOhE;EACI,6DAPyE,EAAA;;AAM7E;EACI,6DANsD,EAAA;;AAK1D;EACI,6DALsD,EAAA;;AC5F9D;;EAEI,wBAAwB;EACxB,kBAAkB,EAAA;;AtEHtB;EsEOI,gBhGqpB8B,EAAA;;AgGjpBlC;EACI,mBAAmB,EAAA;;AAIvB;EACI,oBAAoB;EACpB,uBAAuB;EACvB,mBAAmB;EACnB,gCAAwF;EACxF,+BAAuF;EACvF,UAAU,EAAA;EANd;;;IAWQ,sBAAsB,EAAA;EAX9B;IAeQ,kCAA2F;IAC3F,iCAA0F,EAAA;EAhBlG;IAoBQ,kCAA2F;IAC3F,iCAA0F,EAAA;;AAuB9F;EAdA,chG4HgB;EgG3HhB,yChG2HgB;EgG1HhB,yBAAyB,EAAA;EAEzB;IAGI,WhGwFO;IgGvFP,yBhGoHY,EAAA;;AgG9GhB;EAdA,chG8HgB;EgG7HhB,0ChG6HgB;EgG5HhB,yBAAyB,EAAA;EAEzB;IAGI,WhGwFO;IgGvFP,yBhGsHY,EAAA;;AgGhHhB;EAdA,chGmIgB;EgGlIhB,yChGkIgB;EgGjIhB,yBAAyB,EAAA;EAEzB;IAGI,WhGwFO;IgGvFP,yBhG2HY,EAAA;;AgGrHhB;EAdA,chGqIgB;EgGpIhB,yChGoIgB;EgGnIhB,yBAAyB,EAAA;EAEzB;IAGI,WhGwFO;IgGvFP,yBhG6HY,EAAA;;AgGvHhB;EAdA,chGkIgB;EgGjIhB,yChGiIgB;EgGhIhB,yBAAyB,EAAA;EAEzB;IAGI,WhGwFO;IgGvFP,yBhG0HY,EAAA;;AgGpHhB;EAdA,chGgIgB;EgG/HhB,wChG+HgB;EgG9HhB,yBAAyB,EAAA;EAEzB;IAGI,WhGwFO;IgGvFP,yBhGwHY,EAAA;;AgGlHhB;EAdA,chGgGc;EgG/Fd,0ChG+Fc;EgG9Fd,yBAAyB,EAAA;EAEzB;IAGI,WhGwFO;IgGvFP,yBhGwFU,EAAA;;AgGlFd;EAdA,chGwGc;EgGvGd,uChGuGc;EgGtGd,yBAAyB,EAAA;EAEzB;IAGI,WhGwFO;IgGvFP,yBhGgGU,EAAA;;AgGnEd;EAbA,chGoGgB;EgGnGhB,yBAAyB,EAAA;EAEzB;IAGI,chG8FY;IgG7FZ,yChG6FY,EAAA;;AgGvFhB;EAbA,chGsGgB;EgGrGhB,yBAAyB,EAAA;EAEzB;IAGI,chGgGY;IgG/FZ,0ChG+FY,EAAA;;AgGzFhB;EAbA,chG2GgB;EgG1GhB,yBAAyB,EAAA;EAEzB;IAGI,chGqGY;IgGpGZ,yChGoGY,EAAA;;AgG9FhB;EAbA,chG6GgB;EgG5GhB,yBAAyB,EAAA;EAEzB;IAGI,chGuGY;IgGtGZ,yChGsGY,EAAA;;AgGhGhB;EAbA,chG0GgB;EgGzGhB,yBAAyB,EAAA;EAEzB;IAGI,chGoGY;IgGnGZ,yChGmGY,EAAA;;AgG7FhB;EAbA,chGwGgB;EgGvGhB,yBAAyB,EAAA;EAEzB;IAGI,chGkGY;IgGjGZ,wChGiGY,EAAA;;AgG3FhB;EAbA,chGwEc;EgGvEd,yBAAyB,EAAA;EAEzB;IAGI,chGkEU;IgGjEV,0ChGiEU,EAAA;;AgG3Dd;EAbA,chGgFc;EgG/Ed,yBAAyB,EAAA;EAEzB;IAGI,chG0EU;IgGzEV,uChGyEU,EAAA;;AgGnEd;EAMA,yBAAmD,EAAA;;AAIvD;EACI,kBAAkB;EAClB,kBAAkB,EAAA;EAFtB;IAIQ,kBAAkB;IAClB,aAAa;IACb,UhGiiByB;IgGhiBzB,ShGgiByB;IgG/hBzB,YhG+hByB;IgG9hBzB,0ChGuCO;IgGtCP,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB,EAAA;EAb/B;IAiBY,wChGwCM,EAAA;EgGzDlB;IAqBQ,oBhGsvB2B;IgGrvB3B,mBAAmB,EAAA;IAtB3B;MAwBY,WhG+gBqB;MgG9gBrB,UAAU,EAAA;;AAOtB;EACC,gBAAgB;EAChB,oDAAoD;EACpD,wDAAwD,EAAA;EAHzD;IAKE,wBAAwB;IACxB,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,MAAM;IACN,OAAO;IACP,UAAU;IACV,iCAAiC;IACjC,sBhG8tBiC;IgG7tBjC,wCAAwC;IACxC,wDAAwD,EAAA;EAf1D;IAkBE,cAAc;IACd,wCAAwC;IACxC,wDAAwD,EAAA;EApB1D;IAwBG,UAAU;IACV,+BAA+B,EAAA;EAzBlC;IA4BG,UAAU;IACV,kCAAkC,EAAA;;AAOjC;EACI,yBhGQY;EgGPZ,qBhGOY,EAAA;EgGLZ;IAGI,chGEQ;IgGDR,yChGCQ,EAAA;;AgGThB;EACI,yBhGUY;EgGTZ,qBhGSY,EAAA;EgGPZ;IAGI,chGIQ;IgGHR,0ChGGQ,EAAA;;AgGXhB;EACI,yBhGeY;EgGdZ,qBhGcY,EAAA;EgGZZ;IAGI,chGSQ;IgGRR,yChGQQ,EAAA;;AgGhBhB;EACI,yBhGiBY;EgGhBZ,qBhGgBY,EAAA;EgGdZ;IAGI,chGWQ;IgGVR,yChGUQ,EAAA;;AgGlBhB;EACI,yBhGcY;EgGbZ,qBhGaY,EAAA;EgGXZ;IAGI,chGQQ;IgGPR,yChGOQ,EAAA;;AgGfhB;EACI,yBhGYY;EgGXZ,qBhGWY,EAAA;EgGTZ;IAGI,chGMQ;IgGLR,wChGKQ,EAAA;;AgGbhB;EACI,yBhGpBU;EgGqBV,qBhGrBU,EAAA;EgGuBV;IAGI,chG1BM;IgG2BN,0ChG3BM,EAAA;;AgGmBd;EACI,yBhGZU;EgGaV,qBhGbU,EAAA;EgGeV;IAGI,chGlBM;IgGmBN,uChGnBM,EAAA;;AgGgClB;EAEQ,gBAAgB,EAAA;;AAKxB;EAEQ,YAAY,EAAA;;AAFpB;;;;;EASQ,yChGnBY;EgGoBZ,chGpBY,EAAA;;AXyhkDpB;E2G9/jDQ,qBAA2C;EAC3C,iCAAwD;EACxD,6BAAoD,EAAA;E3GggkD1D;I2G9/jDU,qBAA2C;IAC3C,iDAA4E;IAC5E,6CAAwE,EAAA;;A3GigkDpF;;;;;;E2Gv/jDQ,qBAA2C;EAC3C,iDAA4E;EAC5E,6CAAwE,EAAA;;A3G+/jDhF;;;;;;;;;;;;E2Gh/jDQ,qBAA2C;EAC3C,iDAA4E;EAC5E,6CAAwE,EAAA;;A3G8/jDhF;E2Gx/jDQ,sBAA6C;EAC7C,gCAAsD;EACtD,4BAAkD,EAAA;E3G0/jDxD;I2Gx/jDU,sBAA6C;IAC7C,gDAA0E;IAC1E,4CAAsE,EAAA;;A3G2/jDlF;;;;;;E2Gj/jDQ,sBAA6C;EAC7C,gDAA0E;EAC1E,4CAAsE,EAAA;;A3Gy/jD9E;;;;;;;;;;;;E2G1+jDQ,sBAA6C;EAC7C,gDAA0E;EAC1E,4CAAsE,EAAA;;A3Gw/jD9E;E2Gl/jDQ,qBAA2C;EAC3C,6BAAoD,EAAA;E3Go/jD1D;I2Gl/jDU,qBAA2C;IAC3C,iDAA4E;IAC5E,6CAAwE,EAAA;;A3Gq/jDpF;E2Gh/jDQ,qBAA2C;EAC3C,4BAAkD,EAAA;E3Gk/jDxD;I2Gh/jDU,sBAA6C;IAC7C,gDAA0E;IAC1E,4CAAsE,EAAA;;A3Gm/jDlF;E2G5+jDQ,qBAA2C;EAC3C,gDAA2E,EAAA;E3G8+jDjF;I2G5+jDU,qBAA2C;IAC3C,iCAAwD,EAAA;;A3G++jDpE;E2G1+jDQ,qBAA2C;EAC3C,+CAAyE,EAAA;E3G4+jD/E;I2G1+jDU,sBAA6C;IAC7C,gCAAsD,EAAA;;A3G6+jDlE;E2Gv+jDQ,qBAA2C,EAAA;E3Gy+jDjD;I2Gr+jDU,qBAA2C;IAC3C,gDAA2E,EAAA;;A3Gw+jDvF;E2Gn+jDQ,qBAA2C,EAAA;E3Gq+jDjD;I2Gj+jDU,qBAA2C;IAC3C,+CAAyE,EAAA;;AAQjF;;;EAIQ,gCAA2C,EAAA;;AAJnD;;;EAIQ,gCAA2C,EAAA;;AAJnD;;;EAIQ,gCAA2C,EAAA;;AAJnD;;;EAIQ,gCAA2C,EAAA;;AAJnD;;;EAIQ,gCAA2C,EAAA;;AAJnD;;;EAIQ,gCAA2C,EAAA;;AAJnD;;;EAIQ,gCAA2C,EAAA;;AAJnD;;;EAIQ,gCAA2C,EAAA;;AClWvD;EAEQ,yBAAmD,EAAA;;A9De3D;E8DXY,oCAAoC;EACpC,eAAe;EACf,iBAAiB,EAAA;;AhEV7B;EiECI,qBlGonBgC;EkGnnBhC,4ClGspBuD,EAAA;;AiCxjB3D;EiE1FI,+ClGuoB8E,EAAA;;AkGnoBlF;EAEQ,eAA8B,EAAA;;AjEgGtC;EiE3FI,4ClG4nB8E,EAAA;;AkGznBlF;EACI,clGiIc,EAAA;;AiCjFlB;EiE5CI,eAAe;EACf,iBAAiB,EAAA;;AAGrB;EACI,mBAAmB,EAAA;;AAGvB;EACI,2BAA0C,EAAA;;AAG9C;EACI,oBAAoB,EAAA;EADxB;IAIQ,wCAAuD;IACvD,6ClGgnBuD,EAAA;;AkGlmB3D;EANA,WlG2FW;EkG1FX,yBlGuHgB,EAAA;EkGlHhB;IAIQ,0ClGiFG;IkGhFH,WlGgFG;IkG/EH,yBAAyB,EAAA;EANjC;IAUQ,WlG2EG,EAAA;;AkGrFX;EANA,WlG2FW;EkG1FX,yBlGyHgB,EAAA;EkGpHhB;IAIQ,0ClGiFG;IkGhFH,WlGgFG;IkG/EH,yBAAyB,EAAA;EANjC;IAUQ,WlG2EG,EAAA;;AkGrFX;EANA,WlG2FW;EkG1FX,yBlG8HgB,EAAA;EkGzHhB;IAIQ,0ClGiFG;IkGhFH,WlGgFG;IkG/EH,yBAAyB,EAAA;EANjC;IAUQ,WlG2EG,EAAA;;AkGrFX;EANA,WlG2FW;EkG1FX,yBlGgIgB,EAAA;EkG3HhB;IAIQ,0ClGiFG;IkGhFH,WlGgFG;IkG/EH,yBAAyB,EAAA;EANjC;IAUQ,WlG2EG,EAAA;;AkGrFX;EANA,WlG2FW;EkG1FX,yBlG6HgB,EAAA;EkGxHhB;IAIQ,0ClGiFG;IkGhFH,WlGgFG;IkG/EH,yBAAyB,EAAA;EANjC;IAUQ,WlG2EG,EAAA;;AkGrFX;EANA,WlG2FW;EkG1FX,yBlG2HgB,EAAA;EkGtHhB;IAIQ,0ClGiFG;IkGhFH,WlGgFG;IkG/EH,yBAAyB,EAAA;EANjC;IAUQ,WlG2EG,EAAA;;AkGrFX;EANA,WlG2FW;EkG1FX,yBlG2Fc,EAAA;EkGtFd;IAIQ,0ClGiFG;IkGhFH,WlGgFG;IkG/EH,yBAAyB,EAAA;EANjC;IAUQ,WlG2EG,EAAA;;AkGrFX;EANA,WlG2FW;EkG1FX,yBlGmGc,EAAA;EkG9Fd;IAIQ,0ClGiFG;IkGhFH,WlGgFG;IkG/EH,yBAAyB,EAAA;EANjC;IAUQ,WlG2EG,EAAA;;AkGpEX;EACI,gCAA+B,EAAA;EADnC;IAGQ,qBlG8FQ,EAAA;;AkGjGhB;EACI,gCAA+B,EAAA;EADnC;IAGQ,qBlGgGQ,EAAA;;AkGnGhB;EACI,gCAA+B,EAAA;EADnC;IAGQ,qBlGqGQ,EAAA;;AkGxGhB;EACI,gCAA+B,EAAA;EADnC;IAGQ,qBlGuGQ,EAAA;;AkG1GhB;EACI,gCAA+B,EAAA;EADnC;IAGQ,qBlGoGQ,EAAA;;AkGvGhB;EACI,gCAA+B,EAAA;EADnC;IAGQ,qBlGkGQ,EAAA;;AkGrGhB;EACI,gCAA+B,EAAA;EADnC;IAGQ,qBlGkEM,EAAA;;AkGrEd;EACI,gCAA+B,EAAA;EADnC;IAGQ,qBlG0EM,EAAA;;AkG9Fd;EA2BA,iCAAwD,EAAA;EA3BxD;IA6BI,sCAAkE;IAClE,+CAAyE,EAAA;EAJjF;IAOQ,sCAAkE,EAAA;;AAI1E;EACI,gBAAgB,EAAA;;AAMpB;EACI,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,gDAA2E;EAC3E,aAAa,EAAA;;AAGjB;EACI,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,2CAAyC,EAAA;;AAG7C;EACI,kCAAkC,EAAA;;AAGtC;EACC;IAAK,yBAAyB,EAAA,EAAA;;AAG/B;EACI,kBAAkB;EAClB,gBAAgB,EAAA;EAFpB;IAIQ,WAAW;IACX,yClGsCY;IkGrCZ,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,OAAO;IACP,SAAS,EAAA;EAVjB;IAaQ,kDAA2C,EAAA;;AAInD;EACI,gBAAgB,EAAA;EADpB;IAGQ,eAAe,EAAA;EAHvB;IAOY,aAAa,EAAA;EAPzB;IAUY,cAAc,EAAA;EAV1B;IAcgB,cAAc,EAAA;EAd9B;IAiBgB,aAAa,EAAA;;ACjK7B;EACI,qBAAqB;EACrB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,oCAAoC,EAAA;;A3E0FK;E2EtFzC,6CnGgpB2D;EmG9oB3D,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa,EAAA;EANjB;IASQ,aAAa;IACb,kBAAkB;IAClB,mBAAmB,EAAA;;AA4B3B;EACI;IACI,YAAY,EAAA;EAGhB;IACI,YAAY,EAAA;EAGhB;IACI,YAAY,EAAA,EACf;;ArEWL;EqEPI,iBAAiB,EAAA;EADrB;IAGQ,gBAAgB,EAAA;EAHxB;IAOQ,WAAW;IACX,kBAAkB;IAClB,2CnGsEO;ImGrEP,SnG4jByB;ImG3jBzB,YnG2jByB;ImG1jBzB,WnG0jByB;ImGzjBzB,OAAO;IACP,kCAAwD,EAAA;;AAMhE;EACI,2BAA2B,EAAA;;AAO/B;EACI,YAAY,EAAA;;AAGhB;EACI,YAAY,EAAA;;A9GqhlDhB;E8GhhlDQ,kBAAc,EAAA;;A9GmhlDtB;E8G/glDQ,oBAAc,EAAA;;AAItB;EAEQ,SAAS,EAAA;EAFjB;IAIY,+BnG6BG,EAAA;ImGjCf;MAMgB,uCAAoE,EAAA;IANpF;MASgB,WnGwBD,EAAA;;AmGhBX;EAGM,0CnG0CU;EmGzCV,cnGyCU,EAAA;;AmG7ChB;EAGM,2CnG4CU;EmG3CV,cnG2CU,EAAA;;AmG/ChB;EAGM,0CnGiDU;EmGhDV,cnGgDU,EAAA;;AmGpDhB;EAGM,0CnGmDU;EmGlDV,cnGkDU,EAAA;;AmGtDhB;EAGM,0CnGgDU;EmG/CV,cnG+CU,EAAA;;AmGnDhB;EAGM,yCnG8CU;EmG7CV,cnG6CU,EAAA;;AmGjDhB;EAGM,2CnGcQ;EmGbR,cnGaQ,EAAA;;AmGjBd;EAGM,wCnGsBQ;EmGrBR,cnGqBQ,EAAA;;AoGtJlB;;EAIY,yBAAmD;EACnD,gBpGgHY,EAAA;;AoG3GxB;EAEQ,yBAAmD;EACnD,gBpGwGgB,EAAA;;A+BjBxB;;EqEjFQ,gBpGyoB0B,EAAA;;AoGroBlC;EACI,2CAAqE,EAAA;EADzE;IAIQ,kBAAkB,EAAA;IAJ1B;MAMY,YAAY;MACZ,gBpGuFY,EAAA;MoG9FxB;QASgB,WAAW;QACX,mBpGyII;QoGxIJ,WAAW;QACX,kBAAkB;QAClB,WAAW;QACX,OAAO;QACP,SAAS;QACT,6BAA6B;QAC7B,mBAAmB,EAAA;MAjBnC;QAoBgB,cpG+HI,EAAA;QoGnJpB;UAsBoB,mBAAmB,EAAA;EAtBvC;IA4BQ,iBAAiB,EAAA;IA5BzB;MA8BY,kBpGgcC,EAAA;;AoGzbb;EAGY,kBAAkB;EAClB,kBAAkB;EAClB,kBAAkB,EAAA;EAL9B;IAQgB,eAAe,EAAA;;AAQ/B;EAGY,yBpGiEM;EoGhEN,aAAa,EAAA;;AAOzB;EAGY,kBAAkB;EAClB,kBAAkB,EAAA;EAJ9B;IAOgB,WAAW;IACX,kBAAkB;IAClB,6BAA6B;IAC7B,aAAa;IACb,SAAS;IACT,2BAA2B;InFvFrC,uGjBirCsH,EAAA;IiB7qCtH;MmFuEN;QnFtEQ,gBAAgB,EAAA,EmFoFX;EAdb;IAkBoB,yBpGiEA,EAAA;;AoGzDpB;EAEQ,kBAAkB;EAClB,gBAAgB,EAAA;EAHxB;IAKY,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,kBAAkB,EAAA;IAR9B;MAUgB,eAAe,EAAA;IAV/B;MAagB,eAAe,EAAA;IAb/B;MAiBoB,WpGWL,EAAA;IoG5Bf;MAqBgB,kBAAkB;MAClB,OAAO;MACP,QAAQ;MACR,oBAAoB,EAAA;MAxBpC;QA0BoB,QAAQ;QACR,2BAA2B,EAAA;MA3B/C;QA8BoB,aAAa,EAAA;IA9BjC;MAmCoB,WAAW;MACX,0BAA0B,EAAA;IApC9C;MAuCoB,UAAU,EAAA;;AAU9B;EAEQ,iCAAwD;EACxD,eAAe;EACf,kBAAkB,EAAA;EAElB;IANR;MAQgB,WAAW;MACX,kBAAkB;MAClB,YAAY;MACZ,QAAQ;MACR,2BAA2B;MAC3B,8BAA8B;MAC9B,8BAA8B;MAC9B,sCAAsC,EAAA;IAftD;MAoBoB,0BpGZA,EAAA,EoGaH;;AAOjB;EAEQ,kBAAkB,EAAA;EAF1B;IAKY,2BAAuD;IACvD,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB,oBAAoB;IACpB,UAAU,EAAA;IAVtB;MAagB,kBAAkB,EAAA;IAblC;MAiBgB,WAAW;MACX,kBAAkB;MAClB,MAAM;MACN,QAAQ;MACR,QAAQ;MACR,YAAY;MACZ,6DAA2D;MAC3D,yBpG5CI;MoG6CJ,WAAW,EAAA;IAzB3B;MA8BgB,WpG/ED;MoGgFC,wCAAwC,EAAA;MA/BxD;QAkCoB,WAAW;QACX,OAAO,EAAA;;AAO3B;EAEQ,iCAAiC,EAAA;EAFzC;IAKY,yBpGnEQ,EAAA;;AoG2EhB;EAGY,cpG9EI;EoG+EJ,yBpG/EI,EAAA;;AoG2EhB;EAGY,cpG5EI;EoG6EJ,yBpG7EI,EAAA;;AoGyEhB;EAGY,cpGvEI;EoGwEJ,yBpGxEI,EAAA;;AoGoEhB;EAGY,cpGrEI;EoGsEJ,yBpGtEI,EAAA;;AoGkEhB;EAGY,cpGxEI;EoGyEJ,yBpGzEI,EAAA;;AoGqEhB;EAGY,cpG1EI;EoG2EJ,yBpG3EI,EAAA;;AoGuEhB;EAGY,cpG1GE;EoG2GF,yBpG3GE,EAAA;;AoGuGd;EAGY,cpGlGE;EoGmGF,yBpGnGE,EAAA;;AoGyGlB;EACI,yBpGtFgB;EoGuFhB,sBpGgZgC,EAAA;EoGlZpC;IAMY,gCpGxHG,EAAA;IoGkHf;MASgB,WpG3HD;MoG4HC,0CpG5HD,EAAA;EoGkHf;IAkBgB,qCAA+D,EAAA;IAlB/E;MAqBoB,cpGtIF;MoGuIE,yBpG3GA,EAAA;;AoGoHhB;EACI,yBpGrHY,EAAA;;AoGoHhB;EACI,yBpGnHY,EAAA;;AoGkHhB;EACI,yBpG9GY,EAAA;;AoG6GhB;EACI,yBpG5GY,EAAA;;AoG2GhB;EACI,yBpG/GY,EAAA;;AoG8GhB;EACI,yBpGjHY,EAAA;;AoGgHhB;EACI,yBpGjJU,EAAA;;AoGgJd;EACI,yBpGzIU,EAAA;;AoGwId;EAMA,iCAAwD,EAAA;;AAMxD;EAGY,WpGhKD;EoGiKC,yBpGpII,EAAA;;AoGgIhB;EAWgB,cpG3IA;EoG4IA,mCpG0jC0D,EAAA;;AoGtkC1E;EAoBgB,cpGpJA;EoGqJA,mCpGijC0D,EAAA;EoGtkC1E;IAwBoB,yBpGxJJ,EAAA;;AoGgIhB;EAkCoB,yBpGlKJ,EAAA;;AoGgIhB;EA4CoB,0BpG5KJ,EAAA;;AoGgIhB;EAGY,WpGhKD;EoGiKC,yBpGlII,EAAA;;AoG8HhB;EAWgB,cpGzIA;EoG0IA,mCpG0jC0D,EAAA;;AoGtkC1E;EAoBgB,cpGlJA;EoGmJA,mCpGijC0D,EAAA;EoGtkC1E;IAwBoB,yBpGtJJ,EAAA;;AoG8HhB;EAkCoB,yBpGhKJ,EAAA;;AoG8HhB;EA4CoB,0BpG1KJ,EAAA;;AoG8HhB;EAGY,WpGhKD;EoGiKC,yBpG7HI,EAAA;;AoGyHhB;EAWgB,cpGpIA;EoGqIA,mCpG0jC0D,EAAA;;AoGtkC1E;EAoBgB,cpG7IA;EoG8IA,mCpGijC0D,EAAA;EoGtkC1E;IAwBoB,yBpGjJJ,EAAA;;AoGyHhB;EAkCoB,yBpG3JJ,EAAA;;AoGyHhB;EA4CoB,0BpGrKJ,EAAA;;AoGyHhB;EAGY,WpGhKD;EoGiKC,yBpG3HI,EAAA;;AoGuHhB;EAWgB,cpGlIA;EoGmIA,mCpG0jC0D,EAAA;;AoGtkC1E;EAoBgB,cpG3IA;EoG4IA,mCpGijC0D,EAAA;EoGtkC1E;IAwBoB,yBpG/IJ,EAAA;;AoGuHhB;EAkCoB,yBpGzJJ,EAAA;;AoGuHhB;EA4CoB,0BpGnKJ,EAAA;;AoGuHhB;EAGY,WpGhKD;EoGiKC,yBpG9HI,EAAA;;AoG0HhB;EAWgB,cpGrIA;EoGsIA,mCpG0jC0D,EAAA;;AoGtkC1E;EAoBgB,cpG9IA;EoG+IA,mCpGijC0D,EAAA;EoGtkC1E;IAwBoB,yBpGlJJ,EAAA;;AoG0HhB;EAkCoB,yBpG5JJ,EAAA;;AoG0HhB;EA4CoB,0BpGtKJ,EAAA;;AoG0HhB;EAGY,WpGhKD;EoGiKC,yBpGhII,EAAA;;AoG4HhB;EAWgB,cpGvIA;EoGwIA,mCpG0jC0D,EAAA;;AoGtkC1E;EAoBgB,cpGhJA;EoGiJA,mCpGijC0D,EAAA;EoGtkC1E;IAwBoB,yBpGpJJ,EAAA;;AoG4HhB;EAkCoB,yBpG9JJ,EAAA;;AoG4HhB;EA4CoB,0BpGxKJ,EAAA;;AoG4HhB;EAGY,WpGhKD;EoGiKC,yBpGhKE,EAAA;;AoG4Jd;EAWgB,cpGvKF;EoGwKE,mCpG0jC0D,EAAA;;AoGtkC1E;EAoBgB,cpGhLF;EoGiLE,mCpGijC0D,EAAA;EoGtkC1E;IAwBoB,yBpGpLN,EAAA;;AoG4Jd;EAkCoB,yBpG9LN,EAAA;;AoG4Jd;EA4CoB,0BpGxMN,EAAA;;AoG4Jd;EAGY,WpGhKD;EoGiKC,yBpGxJE,EAAA;;AoGoJd;EAWgB,cpG/JF;EoGgKE,mCpG0jC0D,EAAA;;AoGtkC1E;EAoBgB,cpGxKF;EoGyKE,mCpGijC0D,EAAA;EoGtkC1E;IAwBoB,yBpG5KN,EAAA;;AoGoJd;EAkCoB,yBpGtLN,EAAA;;AoGoJd;EA4CoB,0BpGhMN,EAAA;;AoGyMlB;EACI,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB,EAAA;EAHrB;IAKQ,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,2BAA2B;IAC3B,WAAW,EAAA;EATnB;IAYQ,mBAAmB;IACnB,kBAAkB;IAClB,8BAA8B,EAAA;IAdtC;MAgBY,WAAW;MACX,YAAY;MACZ,iCAAwD;MACxD,UAAU;MACV,qBAA2C;MAC3C,gBpG/PY,EAAA;MoG0OxB;QAuBgB,yBpG5MI;QoG6MJ,WpG1OD,EAAA;;AoGgPf;EAEQ,iCAAwD,EAAA;EAFhE;IAIY,gBAAgB;IAChB,kBAAkB;IAClB,gBpG9QY;IoG+QZ,qBAA2C,EAAA;IAPvD;MASgB,WAAW;MACX,kBAAkB;MAClB,6BAA6B;MAC7B,YAAY;MACZ,QAAQ;MACR,2BAA2B,EAAA;IAd3C;MAiBgB,0CpGpOI;MoGqOJ,cpGrOI,EAAA;MoGmNpB;QAoBoB,8BAA8B,EAAA;IApBlD;MAwBgB,yCpG3OI;MoG4OJ,cpG5OI;MoG6OJ,gBAAgB,EAAA;MA1BhC;QA4BoB,0CpG/OA,EAAA;EoGmNpB;IAoCwB,aAAa,EAAA;;AAQrC;EAEQ,SAAS,EAAA;EAFjB;IAIY,gBAAgB;IAChB,gDAA2E;IAC3E,wCAAsE;IACtE,qBAA2C,EAAA;IAPvD;MASgB,gBpG5TU,EAAA;IoGmT1B;MAYgB,cpGvQI;MoGwQJ,sBAAsB;MACtB,gBpGlUQ;MoGmUR,WAAW,EAAA;IAf3B;MAmBoB,cpG3QA,EAAA;MoGwPpB;QAqBwB,gBAAgB,EAAA;IArBxC;MA0BgB,qBpGzRI,EAAA;IoG+PpB;MA6BgB,qBpGrRI,EAAA;;AoG4RpB;EAGY,6BAA6B;EAC7B,oCAAoC,EAAA;EAJhD;IAOgB,qBpG1SI;IoG2SJ,6BAA6B;IAC7B,cpG5SI,EAAA;;AoGoThB;EAIgB,cpGxTA;EoGyTA,qBpGzTA,EAAA;;AoGoThB;EAIgB,cpGtTA;EoGuTA,qBpGvTA,EAAA;;AoGkThB;EAIgB,cpGjTA;EoGkTA,qBpGlTA,EAAA;;AoG6ShB;EAIgB,cpG/SA;EoGgTA,qBpGhTA,EAAA;;AoG2ShB;EAIgB,cpGlTA;EoGmTA,qBpGnTA,EAAA;;AoG8ShB;EAIgB,cpGpTA;EoGqTA,qBpGrTA,EAAA;;AoGgThB;EAIgB,cpGpVF;EoGqVE,qBpGrVF,EAAA;;AoGgVd;EAIgB,cpG5UF;EoG6UE,qBpG7UF,EAAA;;AoGqVlB;EAEQ,kBAAkB;EAClB,gBAAgB,EAAA;EAHxB;IAMY,kBAAkB;IAClB,cAAc;IACd,YAAY;IACZ,mCAA4D;IAC5D,kBAAkB;IAClB,yBAAyB,EAAA;IAXrC;MAegB,cAAc;MACd,YAAY;MACZ,kBAAkB;MAClB,SAAS;MACT,YAAY;MACZ,WAAW;MACX,mCAA4D;MAC5D,yBAAyB,EAAA;IAtBzC;MA0BgB,wBAAwB;MACxB,YAAY;MACZ,4BAA4B,EAAA;IA5B5C;MAgCgB,wBAAwB;MACxB,WAAW;MACX,6BAA6B,EAAA;IAlC7C;MAwCgB,yBpGzWI;MoG0WJ,WpGvYD,EAAA;IoG8Vf;MA6CgB,UAAU,EAAA;;ACxhB1B;EAEQ,gBrGoHkB,EAAA;;AqGtH1B;EAMQ,crGgJU;EqG/IV,oCrGsoB0E;EqGroB1E,iCAAwD,EAAA;;A1FRhE;E0FYQ,oCrGioB0E,EAAA;;AqG7oBlF;EAgBQ,qBrGonByB,EAAA;;AqG/mBjC;;EAIQ,mBAAmB,EAAA;;AAM3B;EACI,mBrGqdS,EAAA;EqGtdb;;IAOY,kBAAkB,EAAA;EAP9B;;IAWY,mBAAmB,EAAA;EAX/B;IAgBQ,qBrGqlByB,EAAA;;AqG/kB7B;EAGY,gCAA+B,EAAA;;AAK3C;EAGY,uCAAoD,EAAA;;AAXhE;EAGY,gCAA+B,EAAA;;AAK3C;EAGY,uCAAoD,EAAA;;AAXhE;EAGY,gCAA+B,EAAA;;AAK3C;EAGY,uCAAoD,EAAA;;AAXhE;EAGY,gCAA+B,EAAA;;AAK3C;EAGY,uCAAoD,EAAA;;AAXhE;EAGY,gCAA+B,EAAA;;AAK3C;EAGY,uCAAoD,EAAA;;AAXhE;EAGY,gCAA+B,EAAA;;AAK3C;EAGY,uCAAoD,EAAA;;AAXhE;EAGY,gCAA+B,EAAA;;AAK3C;EAGY,qCAAoD,EAAA;;AAXhE;EAGY,gCAA+B,EAAA;;AAK3C;EAGY,uCAAoD,EAAA;;AAMpE;EAEQ,iBAAiB;EACjB,kBAAkB,EAAA;EAH1B;IAMY,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,sBAAsB,EAAA;;AATlC;EAcQ,kBAAkB,EAAA;EAd1B;IAiBY,iBAAiB;IACjB,kBAAkB;IAClB,aAAa;IACb,SAAS;IACT,iBAAiB;IACjB,oCAAoC,EAAA;EAtBhD;IA0BY,kBAAkB;IAClB,aAAa;IACb,iBAAiB;IACjB,oCAAoC;IACpC,iBAAiB;IACjB,SAAS,EAAA;;AhHsrmDrB;EgH/qmDQ,iCAAwD;EACxD,2BAAuD,EAAA;EhHirmD7D;;IgH7qmDU,iCAAwD,EAAA;;AvDuBpE;EwDvII,gBtGqHsB,EAAA;;AsGlH1B;EAEQ,iBAAiB,EAAA;EAFzB;IAKY,4BAAkC,EAAA;;AAL9C;EAUQ,cAAc,EAAA;;AAItB;EAGG,UAAU;EACV,0BAA0B;EAC1B,+BAA+B,EAAA;;AALlC;EAUI,UAAU;EACV,wBAAwB,EAAA;;AAX5B;EAkBG,sCAAsC;EACtC,6BAA6B,EAAA;;AAnBhC;EAwBI,eAAe,EAAA;;AAxBnB;EA+BG,oCAAoC;EACpC,4BAA4B,EAAA;;AAhC/B;EAqCI,eAAe,EAAA;;AArCnB;EA2CE,mBAAmB,EAAA;EA3CrB;IA8CG,UAAU;IACV,0BAA0B;IAC1B,mBAAmB,EAAA;EAhDtB;IAqDI,UAAU;IACV,wBAAwB,EAAA;;AAtD5B;EA6DG,UAAU;EACV,qBAAoB;EACpB,wBAAwB,EAAA;;AA/D3B;EAoEI,UAAU;EACV,mBAAmB,EAAA;;AAOvB;EACC,qBtG65C0C,EAAA;;AsGz5C3C;EACC,aAAa;EACb,qBAAqB;EACrB,gCAAwD,EAAA;EAExD;IALD;MAME,+BAA2D,EAAA,EAE5D;;AAED;EACC,aAAa;EACb,qBAAqB;EACrB,gCAAwD;EACxD,qBtG24C0C,EAAA;EsGz4C1C;IAND;MAOE,+BAA2D,EAAA,EAE5D;;AAED;EACC;IACC,UAAU;IACV,kCAAkC,EAAA;EAGnC;IACC,UAAU;IACV,wBAAwB,EAAA,EAAA;;AAK1B;EACC;IACC,UAAU;IACV,iCAAiC,EAAA;EAGlC;IACC,UAAU;IACV,wBAAwB,EAAA,EAAA;;AAI1B;EACC;IACC,UAAU;IACV,iCAA8B,EAAA;EAG/B;IACC,UACD,EAAA,EAAA;;AAGD;EACC,0DAAg8D;EACh8D,sBAAsB;EACtB,2BAA2B,EAAA;;AC9J5B;EAGY,oBAAoB;EACpB,sBvG4oBwB,EAAA;;AuGtoBpC;EAEQ,8BAA8B;EAC9B,wBAAwB;EACxB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,kBAAkB,EAAA;;AAP1B;EAYY,eAAe;EACf,gBAAgB,EAAA;;AAK5B;EAEQ,gBvG6nB0B,EAAA;;AwG3pBlC;EACI,WAAW,EAAA;;AAIf;EACI,YAAY,EAAA;;AAIhB;EACI,YAAY,EAAA;;AAGhB;EACI,kBAAkB,EAAA;EADtB;IAIQ,kBAAkB;IAClB,UAAU,EAAA;IALlB;MAQY,6BxGy1CkE,EAAA;;AwGl1C9E;EACI,kBAAkB,EAAA;EADtB;IAIQ,kBAAkB;IAClB,kBAAkB;IAClB,8BAA8B,EAAA;;AAItC;EACI;IACI,QAAQ,EAAA,EAAA;;AAMhB;EACI,YAAY;EACZ,YAAY;EACZ,mBAAmB,EAAA;EAHvB;IAMQ,kBAAkB;IAClB,mBAAmB,EAAA;IAP3B;MAUY,WAAW;MACX,kBAAkB;MAClB,UAAU;MACV,WAAW;MACX,sBxG+EG;MwG9EH,kBAAkB;MAClB,UAAU;MACV,QAAQ;MACR,2BAA2B,EAAA;;AAOvC;EACI,iBAAiB,EAAA;EADrB;IAIQ,kBAAkB;IAClB,iBAAiB,EAAA;IALzB;MAQY,kBAAkB;MAClB,UAAU;MACV,WAAW;MACX,yBxGsFQ;MwGrFR,WxGwDG;MwGvDH,qBAAqB;MACrB,iBAAiB;MACjB,cAAc;MACd,kBAAkB,EAAA;MAhB9B;QAmBgB,WAAW;QACX,kBAAkB;QAClB,6BAA6B;QAC7B,yBxG2EI;QwG1EJ,YAAY;QACZ,SAAS;QACT,2BAA2B,EAAA;;AAO3C;EACI,eAAe,EAAA;EADnB;IAIQ,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,WxG6BO,EAAA;IwGpCf;MASY,WAAW;MACX,kBAAkB;MAClB,8BAA8B;MAC9B,YAAY;MACZ,YAAY;MACZ,UAAU,EAAA;;AAOlB;EACI,yBxG2CY,EAAA;EwG1CZ;IACI,0BxGyCQ,EAAA;EwGvCZ;IACI,oDAA2C;IAC3C,yBAAqB,EAAA;IACrB;MACI,0CxGmCI,EAAA;;AwG5ChB;EACI,yBxG6CY,EAAA;EwG5CZ;IACI,0BxG2CQ,EAAA;EwGzCZ;IACI,qDAA2C;IAC3C,yBAAqB,EAAA;IACrB;MACI,2CxGqCI,EAAA;;AwG9ChB;EACI,yBxGkDY,EAAA;EwGjDZ;IACI,0BxGgDQ,EAAA;EwG9CZ;IACI,oDAA2C;IAC3C,yBAAqB,EAAA;IACrB;MACI,0CxG0CI,EAAA;;AwGnDhB;EACI,yBxGoDY,EAAA;EwGnDZ;IACI,0BxGkDQ,EAAA;EwGhDZ;IACI,oDAA2C;IAC3C,yBAAqB,EAAA;IACrB;MACI,0CxG4CI,EAAA;;AwGrDhB;EACI,yBxGiDY,EAAA;EwGhDZ;IACI,0BxG+CQ,EAAA;EwG7CZ;IACI,oDAA2C;IAC3C,yBAAqB,EAAA;IACrB;MACI,0CxGyCI,EAAA;;AwGlDhB;EACI,yBxG+CY,EAAA;EwG9CZ;IACI,0BxG6CQ,EAAA;EwG3CZ;IACI,mDAA2C;IAC3C,yBAAqB,EAAA;IACrB;MACI,yCxGuCI,EAAA;;AwGhDhB;EACI,yBxGeU,EAAA;EwGdV;IACI,0BxGaM,EAAA;EwGXV;IACI,qDAA2C;IAC3C,yBAAqB,EAAA;IACrB;MACI,2CxGOE,EAAA;;AwGhBd;EACI,yBxGuBU,EAAA;EwGtBV;IACI,0BxGqBM,EAAA;EwGnBV;IACI,kDAA2C;IAC3C,yBAAqB,EAAA;IACrB;MACI,wCxGeE,EAAA;;AkD1JlB;EuDKI,6CzGypB2D,EAAA;;A0GzpB/D;EACI,2CAAoC,EAAA;;AAIxC;EAEQ,aAAa;EACb,sBAAsB,EAAA;EAH9B;IAMY,8CAAqC;IACrC,iBAAiB;IACjB,sBAAsB,EAAA;;AAO9B;EAGY,cAAO;EACP,qBAAc;EACd,0C1GgJI,EAAA;E0GrJhB;IAQgB,cAAO,EAAA;;AARvB;EAcgB,qBAAc,EAAA;EAd9B;IAiBoB,cAAO,EAAA;;AAjB3B;EAGY,cAAO;EACP,qBAAc;EACd,2C1GkJI,EAAA;E0GvJhB;IAQgB,cAAO,EAAA;;AARvB;EAcgB,qBAAc,EAAA;EAd9B;IAiBoB,cAAO,EAAA;;AAjB3B;EAGY,cAAO;EACP,qBAAc;EACd,0C1GuJI,EAAA;E0G5JhB;IAQgB,cAAO,EAAA;;AARvB;EAcgB,qBAAc,EAAA;EAd9B;IAiBoB,cAAO,EAAA;;AAjB3B;EAGY,cAAO;EACP,qBAAc;EACd,0C1GyJI,EAAA;E0G9JhB;IAQgB,cAAO,EAAA;;AARvB;EAcgB,qBAAc,EAAA;EAd9B;IAiBoB,cAAO,EAAA;;AAjB3B;EAGY,cAAO;EACP,qBAAc;EACd,0C1GsJI,EAAA;E0G3JhB;IAQgB,cAAO,EAAA;;AARvB;EAcgB,qBAAc,EAAA;EAd9B;IAiBoB,cAAO,EAAA;;AAjB3B;EAGY,cAAO;EACP,qBAAc;EACd,yC1GoJI,EAAA;E0GzJhB;IAQgB,cAAO,EAAA;;AARvB;EAcgB,qBAAc,EAAA;EAd9B;IAiBoB,cAAO,EAAA;;AAjB3B;EAGY,cAAO;EACP,qBAAc;EACd,2C1GoHE,EAAA;E0GzHd;IAQgB,cAAO,EAAA;;AARvB;EAcgB,qBAAc,EAAA;EAd9B;IAiBoB,cAAO,EAAA;;AAjB3B;EAGY,cAAO;EACP,qBAAc;EACd,wC1G4HE,EAAA;E0GjId;IAQgB,cAAO,EAAA;;AARvB;EAcgB,qBAAc,EAAA;EAd9B;IAiBoB,cAAO,EAAA;;AAjB3B;EA4BQ,qBAA2C;EAC3C,4BAAkD;EAClD,gDAA0E,EAAA;EA9BlF;IAgCY,qBAA2C,EAAA;;AAhCvD;EAqCY,4BAAkD,EAAA;EArC9D;IAuCgB,qBAA2C,EAAA;;ArF5D/D;EsFCI,kBAAkB;EAClB,gBAAgB,EAAA;EtFFpB;IsFMQ,eAAe,EAAA;EANvB;IAUQ,eAAe,EAAA;;AASnB;EAGY,yB3GoJI;E2GnJJ,qB3GmJI,EAAA;;A2G9IhB;EAGY,qB3G2II;E2G1IJ,yB3G0II,EAAA;E2G9IhB;IAOgB,yB3GuIA,EAAA;;A2GvJhB;EAGY,yB3GsJI;E2GrJJ,qB3GqJI,EAAA;;A2GhJhB;EAGY,qB3G6II;E2G5IJ,yB3G4II,EAAA;E2GhJhB;IAOgB,yB3GyIA,EAAA;;A2GzJhB;EAGY,yB3G2JI;E2G1JJ,qB3G0JI,EAAA;;A2GrJhB;EAGY,qB3GkJI;E2GjJJ,yB3GiJI,EAAA;E2GrJhB;IAOgB,yB3G8IA,EAAA;;A2G9JhB;EAGY,yB3G6JI;E2G5JJ,qB3G4JI,EAAA;;A2GvJhB;EAGY,qB3GoJI;E2GnJJ,yB3GmJI,EAAA;E2GvJhB;IAOgB,yB3GgJA,EAAA;;A2GhKhB;EAGY,yB3G0JI;E2GzJJ,qB3GyJI,EAAA;;A2GpJhB;EAGY,qB3GiJI;E2GhJJ,yB3GgJI,EAAA;E2GpJhB;IAOgB,yB3G6IA,EAAA;;A2G7JhB;EAGY,yB3GwJI;E2GvJJ,qB3GuJI,EAAA;;A2GlJhB;EAGY,qB3G+II;E2G9IJ,yB3G8II,EAAA;E2GlJhB;IAOgB,yB3G2IA,EAAA;;A2G3JhB;EAGY,yB3GwHE;E2GvHF,qB3GuHE,EAAA;;A2GlHd;EAGY,qB3G+GE;E2G9GF,yB3G8GE,EAAA;E2GlHd;IAOgB,yB3G2GF,EAAA;;A2G3Hd;EAGY,yB3GgIE;E2G/HF,qB3G+HE,EAAA;;A2G1Hd;EAGY,qB3GuHE;E2GtHF,yB3GsHE,EAAA;E2G1Hd;IAOgB,yB3GmHF,EAAA;;A2G5GlB;EACI,eAAe;EACf,gBAAgB,EAAA;;AAIpB;EACI,eAAe;EACf,qBAAqB,EAAA;EAFzB;IAKQ,YAAY;IACZ,cAAc;IACd,oBAA4C,EAAA;EAPpD;IAWQ,cAAc,EAAA;EAXtB;IAgBY,qBAA8C,EAAA;;AAUtD;EAIgB,c3G4FA;E2G3FA,6BAA6B;EAC7B,qB3G0FA,EAAA;;A2GhGhB;EAIgB,c3G8FA;E2G7FA,6BAA6B;EAC7B,qB3G4FA,EAAA;;A2GlGhB;EAIgB,c3GmGA;E2GlGA,6BAA6B;EAC7B,qB3GiGA,EAAA;;A2GvGhB;EAIgB,c3GqGA;E2GpGA,6BAA6B;EAC7B,qB3GmGA,EAAA;;A2GzGhB;EAIgB,c3GkGA;E2GjGA,6BAA6B;EAC7B,qB3GgGA,EAAA;;A2GtGhB;EAIgB,c3GgGA;E2G/FA,6BAA6B;EAC7B,qB3G8FA,EAAA;;A2GpGhB;EAIgB,c3GgEF;E2G/DE,6BAA6B;EAC7B,qB3G8DF,EAAA;;A2GpEd;EAIgB,c3GwEF;E2GvEE,6BAA6B;EAC7B,qB3GsEF,EAAA;;A2G/DlB;EAEQ,kBAAkB,EAAA;EAF1B;IAKY,sBAAsB,EAAA;IALlC;MAQgB,iBAAiB;MACjB,oCAAoC;MACpC,SAAS;MACT,kBAAkB;MAClB,gBAAgB;MAChB,eAAe;MACf,SAAS,EAAA;;AAWrB;EAIgB,c3GsDA;E2GrDA,6BAA6B;EAC7B,qB3GoDA,EAAA;;A2G1DhB;EAIgB,c3GwDA;E2GvDA,6BAA6B;EAC7B,qB3GsDA,EAAA;;A2G5DhB;EAIgB,c3G6DA;E2G5DA,6BAA6B;EAC7B,qB3G2DA,EAAA;;A2GjEhB;EAIgB,c3G+DA;E2G9DA,6BAA6B;EAC7B,qB3G6DA,EAAA;;A2GnEhB;EAIgB,c3G4DA;E2G3DA,6BAA6B;EAC7B,qB3G0DA,EAAA;;A2GhEhB;EAIgB,c3G0DA;E2GzDA,6BAA6B;EAC7B,qB3GwDA,EAAA;;A2G9DhB;EAIgB,c3G0BF;E2GzBE,6BAA6B;EAC7B,qB3GwBF,EAAA;;A2G9Bd;EAIgB,c3GkCF;E2GjCE,6BAA6B;EAC7B,qB3GgCF,EAAA;;A2GzBlB;EAEQ,kBAAkB,EAAA;EAF1B;IAKY,sBAAsB,EAAA;IALlC;MAQgB,iBAAiB;MACjB,oCAAoC;MACpC,QAAQ;MACR,kBAAkB;MAClB,cAAc;MACd,WAAW,EAAA;;AAS3B;EACI,oBAAoB;EACpB,gBAAgB;EAChB,iBAAiB,EAAA;EAHrB;IAMQ,WAAW;IACX,YAAY;IACZ,aAAa;IACb,kBAAkB,EAAA;EAT1B;IAaQ,sBAAsB,EAAA;;AAI9B;EACI,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB,EAAA;EAHrB;IAMQ,WAAW;IACX,YAAY;IACZ,cAAc;IACd,kBAAkB,EAAA;;AnFnI1B;EmFwII,kBAAkB,EAAA;;AAMlB;EAIY,yB3GlBI;E2GmBJ,qB3GnBI,EAAA;;A2GwBhB;EAKoB,c3G7BJ,EAAA;;A2GchB;EAIY,yB3GhBI;E2GiBJ,qB3GjBI,EAAA;;A2GsBhB;EAKoB,c3G3BJ,EAAA;;A2GYhB;EAIY,yB3GXI;E2GYJ,qB3GZI,EAAA;;A2GiBhB;EAKoB,c3GtBJ,EAAA;;A2GOhB;EAIY,yB3GTI;E2GUJ,qB3GVI,EAAA;;A2GehB;EAKoB,c3GpBJ,EAAA;;A2GKhB;EAIY,yB3GZI;E2GaJ,qB3GbI,EAAA;;A2GkBhB;EAKoB,c3GvBJ,EAAA;;A2GQhB;EAIY,yB3GdI;E2GeJ,qB3GfI,EAAA;;A2GoBhB;EAKoB,c3GzBJ,EAAA;;A2GUhB;EAIY,yB3G9CE;E2G+CF,qB3G/CE,EAAA;;A2GoDd;EAKoB,c3GzDN,EAAA;;A2G0Cd;EAIY,yB3GtCE;E2GuCF,qB3GvCE,EAAA;;A2G4Cd;EAKoB,c3GjDN,EAAA;;A2G4DlB;EAEQ,kBAAkB;EAClB,sBAAsB,EAAA;EAH9B;IAMY,iBAAiB;IACjB,oCAAoC;IACpC,SAAS;IACT,kBAAkB;IAClB,eAAe;IACf,UAAU;IACV,c3G3EM;IiBvIZ,iDjBshCgE,EAAA;IiBlhChE;M0FkMN;Q1FjMQ,gBAAgB,EAAA,E0F+Mf;EAdT;IAiBY,sBAAsB;IACtB,oC3GgvBwE;IiBx8B9E,iDjBshCgE,EAAA;IiBlhChE;M0FkMN;Q1FjMQ,gBAAgB,EAAA,E0F0Nf;IAzBT;MAsBgB,WAAW;MACX,UAAU,EAAA;EAvB1B;IA4BY,sBAAsB,EAAA;;AAOlC;EACI,qBAAqB;EACrB,oBAA6C;EAC7C,gBAAgB;EAChB,0BAA0B,EAAA;EAJ9B;IAOQ,YAAY;IACZ,cAAc;IACd,oBAA4C;IAC5C,2BAA2B,EAAA;EAVnC;IAcQ,gBAAgB;IAChB,kBAAkB,EAAA;;AAK1B;EACI,UAAU,EAAA;EADd;IAIQ,mC3GmmCsE;I2GlmCtE,sC3GvHO;I2GwHP,sB3GkY4B;I2GjY5B,aAAa;IACb,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,cAAc;IACd,kBAAkB;IAClB,mBAAmB,EAAA;IAb3B;MAgBY,eAAe,EAAA;EAhB3B;IAqBQ,aAAa,EAAA;IArBrB;MAwBY,gCAAiC,EAAA;MAxB7C;QA2BgB,gBAAgB;QAChB,wBAAwB;QACxB,kBAAkB;QAClB,QAAQ;QACR,UAAU;QACV,eAAe;QACf,c3GhII,EAAA;E2G+FpB;IA0CoB,W3GtKL,EAAA;;AXs5nDf;EsHtunDY,0D7F1LsE,EAAA;;A8FlIlF;EACI,kBAAkB,EAAA;EADtB;IAGQ,oBAAgC;IAChC,kBAAkB,EAAA;EAJ1B;IAOQ,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,UAAU;IACV,aAAa;IACb,mBAAmB,EAAA;EAZ3B;IAgBY,qBAAiC;IACjC,oB5Gs1BuB;I4Gr1BvB,kBAAkB,EAAA;EAlB9B;IAqBY,UAAU;IACV,WAAW,EAAA;;AvHmioDvB;EuH5hoDQ,0D9FqG0E,EAAA;;A+FhI9E;EACI,yB7GsKY;E6GrKZ,qB7GqKY;E6GpKZ,W7GuIO,EAAA;E6G1IX;IAOY,oCAAmC;IACnC,qB7G+JI,EAAA;;A6GvKhB;EACI,yB7GwKY;E6GvKZ,qB7GuKY;E6GtKZ,W7GuIO,EAAA;E6G1IX;IAOY,oCAAmC;IACnC,qB7GiKI,EAAA;;A6GzKhB;EACI,yB7G6KY;E6G5KZ,qB7G4KY;E6G3KZ,W7GuIO,EAAA;E6G1IX;IAOY,oCAAmC;IACnC,qB7GsKI,EAAA;;A6G9KhB;EACI,yB7G+KY;E6G9KZ,qB7G8KY;E6G7KZ,W7GuIO,EAAA;E6G1IX;IAOY,oCAAmC;IACnC,qB7GwKI,EAAA;;A6GhLhB;EACI,yB7G4KY;E6G3KZ,qB7G2KY;E6G1KZ,W7GuIO,EAAA;E6G1IX;IAOY,oCAAmC;IACnC,qB7GqKI,EAAA;;A6G7KhB;EACI,yB7G0KY;E6GzKZ,qB7GyKY;E6GxKZ,W7GuIO,EAAA;E6G1IX;IAOY,oCAAmC;IACnC,qB7GmKI,EAAA;;A6G3KhB;EACI,yB7G0IU;E6GzIV,qB7GyIU;E6GxIV,W7GuIO,EAAA;E6G1IX;IAOY,oCAAmC;IACnC,qB7GmIE,EAAA;;A6G3Id;EACI,yB7GkJU;E6GjJV,qB7GiJU;E6GhJV,W7GuIO,EAAA;E6G1IX;IAOY,oCAAmC;IACnC,qB7G2IE,EAAA;;A6GnJd;EAeA,yBAAuB,EAAA;;AnEoD3B;EmEhDI,kBAAkB,EAAA;EADtB;IAGQ,c7G2HU,EAAA;E0C7ElB;ImE3CQ,gB7GioB0B,EAAA;I6GvoBlC;MAQY,W7GgHG,EAAA;I6GxHf;MAWY,+B7G6GG,EAAA;;AX8/nDf;EyH1ooDE,kBAAkB;EAClB,sBAAsB;EACtB,eAAe;EACf,2BAA2B;EAC3B,yBAAyB;EACzB,uBAAuB,EAAA;;AAGzB;EACE,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,mBAAmB,EAAA;;AAGrB;EACE,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,OAAO;EACP,MAAM;EACN,SAAS;EACT,QAAQ;EACR,sBAAsB;EACtB,uBAAuB;EACvB,UAAU,EAAA;;AAGZ;EACE,6BAA6B;EAC7B,8BAA8B;EAC9B,uBAAuB;EACvB,kBAAkB;EAClB,MAAM;EACN,kBAAkB;EAClB,SAAS;EACT,mBAAmB;EACnB,UAAU;EACV,SAAS;EACT,iCAAiC,EAAA;;AAGnC;EACE,kBAAkB;EAClB,iCAAiC;EACjC,kBAAkB;EAClB,cAAc;EACd,YAAY;EAAE,mGAAA;EACd,WAAW;EACX,mBAAmB;EACnB,cAAc;EAAE,mFAAA;EAChB,eAAe;EAAE,kDAAA;EACjB,gBAAgB;EAAE,0CAAA;EAClB,qBAAqB;EACrB,uBAAuB,EAAA;;AAGzB;;EAEE,aAAa,EAAA;;AAGf;;EAEE,YAAY;EACZ,cAAc,EAAA;;AAGhB;EACE,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,oBAAoB,EAAA;;AAGtB;EACE,8BAA8B;EAC9B,YAAY;EACZ,WAAW;EACX,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,UAAU;EACV,SAAS;EACT,oBAAoB;EACpB,kBAAkB;EAClB,cAAc;EACd,aAAa,EAAA;;AAGf;EACE,mBAAmB;EACnB,cAAc;EACd,UAAU;EACV,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,aAAa;EACb,YAAY;EACZ,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,WAAW,EAAA;;AAGb;EACE,UAAU;EACV,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,oBAAoB;EACpB,gBAAgB,EAAA;;AzHuooDlB;EyHnooDE,oBAAoB;EACpB,iBAAiB;EACjB,yBAAyB,EAAA;;AzHsooD3B;EyHlooDE,mBAAmB,EAAA;;AAGrB;EACE,kBAAkB;EAClB,UAAU;EACV,UAAU;EACV,gBAAgB,EAAA;;AAGlB;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,UAAU;EACV,+BAA+B,EAAA;;AAGjC;EACE,0DAAA;EACA,YAAY;EACZ,6BAA6B,EAAA;;AAG/B;EACE,MAAM;EACN,WAAW,EAAA;;AAGb;EACE,QAAQ;EACR,WAAW,EAAA;;AAGb;EACE,OAAO;EACP,YAAY,EAAA;;AAGd;EACE,YAAY;EACZ,SAAS;EACT,UAAU,EAAA;;AAGZ;EACE,WAAW;EACX,OAAO;EACP,QAAQ;EACR,WAAW;EACX,aAAa;EACb,eAAe;EACf,WAAW,EAAA;;AAGb,gBAAA;AzH2noDA;EyHznoDE,WAAW;EACX,OAAO,EAAA;;AAGT;EACE,cAAc;EACd,eAAe;EACf,UAAU;EACV,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,kBAAkB,EAAA;;AAGpB;EACE,eAAe;EACf,OAAO;EACP,kBAAkB;EAClB,kBAAkB;EAClB,qBAAqB,EAAA;;AAGvB;EACE,YAAY,EAAA;;AzHynoDd;EyHnnoDM,mB9GjDc,EAAA;;AXuqoDpB;EyHtnoDM,mB9G/Cc,EAAA;;AXwqoDpB;EyHznoDM,mB9G1Cc,EAAA;;AXsqoDpB;EyH5noDM,mB9GxCc,EAAA;;AXuqoDpB;EyH/noDM,mB9G3Cc,EAAA;;AX6qoDpB;EyHlooDM,mB9G7Cc,EAAA;;AXkroDpB;EyHrooDM,mB9G7EY,EAAA;;AXqtoDlB;EyHxooDM,mB9GrEY,EAAA;;A+G1JlB;;;;E1H82oDE;A0Hx2oDF;;EAEI,YAAY;EACZ,gBAAgB;EAChB,wBAAwB;EACxB,sEAAsE;EACtE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAIhB,WAAW;EAEX,qBAAqB;EAGrB,aAAa,EAAA;;AAWjB;;;;EAII,iBAAiB;EACjB,mBAAmB,EAAA;;AAGvB;EAxCA;;IA2CQ,iBAAiB,EAAA,EACpB;;AAGL,gBAAA;AACA;EACI,YAAY;EACZ,SAAS;EACT,cAAc,EAAA;;AAGlB;;EAEI,sCAA6D,EAAA;;AAGjE,gBAAA;AACA;EACI,cAAc;EACd,oBAAoB;EACpB,mBAAmB,EAAA;;AAGvB;;;;EAII,gBAAgB,EAAA;;AAGpB;EACI,WAAW,EAAA;;AAGf;EACI,YAAY,EAAA;;AAGhB;;;;;;;EAOI,c/GoFgB,EAAA;;A+GjFpB;;;;;;EAMI,WAAW,EAAA;;AAGf;;;;;EAKI,cAAc;EACd,oEAAA;EACA,oCAAkC,EAAA;;AAGtC;;;EAGI,WAAW,EAAA;;AAGf;;EAEI,cAAc,EAAA;;AAGlB;;;EAGI,WAAW,EAAA;;AAGf;;EAEI,iBAAiB,EAAA;;AAErB;EACI,kBAAkB,EAAA;;AAGtB;EACI,YAAY,EAAA;;AAGhB,iBAAA;AArFA;;EAwFI,mB/GDc,EAAA;;A+G7IlB;;EAmJI,c/GFc;E+GGd,iBAAiB,EAAA;;AAOrB;EAEQ,wBAAwB,EAAA;;AAFhC;EAMQ,WAAW,EAAA;;AANnB;EAUQ,YAAY,EAAA;;AAVpB;EAcQ,+CAAwE;EACxE,mBAAmB;EACnB,iCAAwD,EAAA;;AAhBhE;EAoBQ,mBAAmB;EACnB,iCAAwD,EAAA;;AAOhE;EACI,WAAW;EACX,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,cAAc;EACd,yBAAyB,EAAA;;AAK7B;EACI,6BAA6B;EAC7B,sBAAsB;EACtB,qBAAqB,EAAA;;AAGzB;EACI,qBAAqB,EAAA;EADzB;IAGQ,gCAAgC;IAChC,kCAAkC;IAClC,mCAAmC;IACnC,gJAAsC;IACtC,gCAA2C;IAC3C,qDAA2D;IAC3D,6BAA6B;IAC7B,yBAA0B;IAC1B,2BAA2B,EAAA;IAXnC;MAaY,wBAAwB;MACxB,2BAA2B,EAAA;IAdvC;MAiBY,oCAAqC;MACrC,sBAAwB,EAAA;;AC/NpC;EAEI,oBAAoB;EACpB,eAAe;EACf,gBhHgHoB,EAAA;;AgH5GxB;EACE,oBAAoB;EACpB,qBhHwoBiC;EgHvoBjC,oChHq/C8E;EgHp/C9E,2BAAuD,EAAA;EAJzD;IAOI,8BAA6D,EAAA;EAPjE;IAWI,2BAAuD,EAAA;;AAI3D;EACE,4CAA0E;EAC1E,2BAAuD,EAAA;;AAGzD;EACE,eAAe,EAAA;;AAGjB;EAEI,qBhHgJgB;EgH/IhB,chH+IgB,EAAA;;AgHlJpB;EAOM,yBhHyIc,EAAA;;AgHhJpB;EAWM,qChHqIc,EAAA;;AgHhJpB;EAeI,qBhHgIgB;EgH/HhB,chH+HgB,EAAA;;AgH3HpB;EAEI,gBAAgB,EAAA;;AAIpB;EACE,qDAAuD,EAAA;;AAGzD;EACE,yChHiHkB,EAAA;;AgH9GpB;EAEI,mBhHqGgB,EAAA;EgHvGpB;IAIM,mBhHmGc,EAAA;IgHvGpB;MAMQ,mChHiGY,EAAA;;AgHvGpB;EAWI,mBhH4FgB,EAAA;;AgHxFpB;EAEI,qCAAsC;EACtC,sCAAuC,EAAA;;AAI3C;EACE,wChH+3B0F,EAAA;EgHh4B5F;IAGI,gBAAgB;IAChB,0ChHq4BoG,EAAA;;AgHj4BxG;EACE,YAAY;EACZ,cAAc;EACd,sBhHowBiC;EFvkB7B,mBAvE+B;EkHnHnC,gBhHwmB+B;EgHvmB/B,gBhH6mB+B;EgH5mB/B,2BhH+2BsF;EgH92BtF,oChH02BkF;EgHz2BlF,4BAA4B;EAC5B,wChH62B0F,EAAA;;AgH12B5F;EACE,sChHmlBsF;EgHllBtF,gBhH6lB+B;EgH5lB/B,eAAe,EAAA;EAHjB;IAKI,gBAAgB,EAAA;EALpB;IASI,chHkDgB,EAAA;;AgH9CpB;EACE,6BAA6B,EAAA;;AC5H/B;EACE,iBAAiB;EACjB,yCjH0oBgF;EiHzoBhF,6BjH42C4E;EiH32C5E,kBAAkB,EAAA;EAJpB;IAOI,eAAe;IACf,WAAW;IACX,aAAa,EAAA;;ACTjB;EACE,mBlH+KkB,EAAA;;AkH5KpB;EACE,mBlH2KkB;EkH1KlB,mCAA4D;EAC5D,gBAAgB,EAAA;;AAGlB;EACE,WAAW,EAAA;EADb;IAGI,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,uBAAuB;IACvB,SAAS,EAAA;IAPb;MAUM,aAAa,EAAA;IAVnB;MAaM,UAAU,EAAA;;AAKhB;EACE,YAAY,EAAA;;AAKd;EACE,sBlH+3C8C;EkH93C9C,oClHwmBgF;EkHvmBhF,qBlH4mBiC;EkH3mBjC,mClHy0C4E;EkHx0C5E,clH8GgB,EAAA;;AkHzGlB;EACE,UAAU,EAAA;EADZ;IAGI,YAAY;IACZ,WAAW;IACX,WAAW;IACX,UAAU;IACV,UAAU;IACV,kBAAkB,EAAA;IARtB;MAUM,aAAa,EAAA;IAVnB;MAaM,UAAU,EAAA;EAbhB;IAkBI,MAAM,EAAA;;AAIV;EACE,eAAe,EAAA;;AAGjB;EAEI,YAAY,EAAA;;AAIhB;EACE,gBAAgB,EAAA;;AAGlB;EACE,gBAAgB;EAChB,iCAAwD;EACxD,6BAAoD,EAAA;;AAGtD;EAEI,UAAU,EAAA;;AAMd;EACC,YAAY;EACZ,qBAAqB;EACrB,aAAa,EAAA;;AAGd;EACC,aAAa;EACb,YAAY;EACZ,cAAc;EACd,aAAa;EACb,wClHmiBiF,EAAA;;AkHhiBlF;EACC,iBAAiB;EACjB,aAAa;EACb,YAAY;EACZ,qBAAqB;EACrB,mBAAmB;EACnB,wClH0hBiF;EkHzhB9E,mBAAmB;EACnB,kBAAkB,EAAA;;AAGtB;EAEQ,mBlHoDY,EAAA;;AkHhDpB;EAEQ,mBlHiDY,EAAA;;AkH7CpB;EAEQ,mBlHoCY,EAAA;;AkH9BpB;EAEQ,2BAA2B,EAAA;;AAOnC;EACI,eAAe;EACf,clHJc;EkHKd,cAAc;EACd,cAAc,EAAA;EAJlB;IAMQ,kBAAkB;IAClB,eAAe;IACf,gBAAgB,EAAA;;AA1HxB;EAiII,aAAa,EAAA;;AAEjB;EACI,cAAc,EAAA;;AAKlB;EAAa,mBlHEO,EAAA;;AkHDpB;EAAa,mBlHGO,EAAA;;AkHFpB;EAAa,mBlHGO,EAAA;;AkHFpB;EAAa,mBlHLO,EAAA;;AkHMpB;EAAa,mBlHJO,EAAA;;AkHQpB;EACI,YAAY,EAAA;EADhB;IAIY,qBlHVQ,EAAA;;AX4lpDpB;E6HxkpDM,mBlHxBc,EAAA;;AXmmpDpB;E6HvkpDM,mBlH5Bc,EAAA;;AXsmpDpB;E6HrkpDQ,qBlHjCY,EAAA;;AXympDpB;E6HjlpDM,mBlHtBc,EAAA;;AX0mpDpB;E6HhlpDM,mBlH1Bc,EAAA;;AX6mpDpB;E6H9kpDQ,qBlH/BY,EAAA;;AXgnpDpB;E6H1lpDM,mBlHjBc,EAAA;;AX8mpDpB;E6HzlpDM,mBlHrBc,EAAA;;AXinpDpB;E6HvlpDQ,qBlH1BY,EAAA;;AXonpDpB;E6HnmpDM,mBlHfc,EAAA;;AXqnpDpB;E6HlmpDM,mBlHnBc,EAAA;;AXwnpDpB;E6HhmpDQ,qBlHxBY,EAAA;;AX2npDpB;E6H5mpDM,mBlHlBc,EAAA;;AXiopDpB;E6H3mpDM,mBlHtBc,EAAA;;AXoopDpB;E6HzmpDQ,qBlH3BY,EAAA;;AXuopDpB;E6HrnpDM,mBlHpBc,EAAA;;AX4opDpB;E6HpnpDM,mBlHxBc,EAAA;;AX+opDpB;E6HlnpDQ,qBlH7BY,EAAA;;AXkppDpB;E6H9npDM,mBlHpDY,EAAA;;AXqrpDlB;E6H7npDM,mBlHxDY,EAAA;;AXwrpDlB;E6H3npDQ,qBlH7DU,EAAA;;AX2rpDlB;E6HvopDM,mBlH5CY,EAAA;;AXsrpDlB;E6HtopDM,mBlHhDY,EAAA;;AXyrpDlB;E6HpopDQ,qBlHrDU,EAAA;;AX4rpDlB;E6H7npDI,YAAY,EAAA;E7H+npDd;I6H5npDI,WAAW;IACX,YAAY,EAAA;;A7H+npDlB;E6HxnpDI,WAAW,EAAA;E7H0npDb;I6HvnpDI,WAAW;IACX,YAAY,EAAA;;A7H0npDlB;E6HnnpDI,WAAW,EAAA;E7HqnpDb;I6HlnpDI,WAAW;IACX,YAAY,EAAA;;A7HqnpDlB;E6H5mpDI,UAAU;EACV,kBAAkB;EAClB,WAAW,EAAA;;A7H+mpDf;E6H5mpDI,WAAW;EACX,kBAAkB;EAClB,SAAS,EAAA;;A7H+mpDb;E6HzmpDI,qBlHpFgB;EkHqFhB,mClH0mC0E,EAAA;;AXkgnD9E;E6HtmpDI,kBAAkB;EAClB,wBAAwB;EACxB,YAAY;EACZ,WAAW;EACX,SAAS;EACT,qBlHhGgB;EkHiGhB,mClH8lC0E,EAAA;;AmH/2C9E;EAEQ,0CnHuKY;EmHtKZ,sCnHsKY,EAAA;;AmHlKpB;EACI,eAAe,EAAA;;AAInB;EAEQ,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY,EAAA;;AAVpB;EAaQ,kBAAkB,EAAA;;AC1B1B;EACI,6BpH+2C0E;EoH92C1E,4CpHspBuD,EAAA;;AoHnpB3D;EAGY,iCAAwD;EACxD,uBpH88C8B,EAAA;;AoHl9C1C;EAQY,qCAA8D,EAAA;EAR1E;IAUgB,qCAA8D,EAAA;;AAM9E;EACI,iCAAwD,EAAA;;AAG5D;EACI,eAAe;EACf,gBpH0FoB;EoHzFpB,2BAAuD,EAAA;;AAG3D;EACI,gBpHu7CsC;EoHt7CtC,mBpHwqBkC;EoHvqBlC,2BAAuD,EAAA;;AAG3D;EAEQ,mBAAkC;EAClC,WpHqGO,EAAA;;AoHxGf;EAOQ,2CAAqE;EACrE,qBAA2C,EAAA;;AARnD;EAYQ,mBAAkC;EAClC,WpH2FO,EAAA;;AoHvFf;EACI,0BpHg6CsC,EAAA;;AoH95C1C;;EAEI,gBAAgB;EAChB,wBAAwB;EACxB,eAAe;EACf,UAAU;EACV,wCAAwC;EACxC,uBAAuB;EACvB,cpHyGgB,EAAA;;AoHtGpB;EACI,UAAU,EAAA;;AAGd;EACI,oBAAoB,EAAA;;ACzExB;EACI,uBAAuB;EACvB,sBAAsB;EACtB,yCrHuKgB;EqHtKhB,kCAA0B;UAA1B,0BAA0B;EAC1B,kBAAkB,EAAA;EALtB;IAOQ,iCAAiC;IACjC,0BAA0B;IAC1B,crHiKY;IqHhKZ,yBAAyB,EAAA;;AAIjC;EAEQ,2BAA2B,EAAA;;AAGnC;EAEQ,2BAA2B,EAAA;;AAInC;EACI,sBAAsB;EACtB,sBAAsB;EACtB,iCAAmC;EACnC,8BAA8B;EAC9B,gBrH8nB8B,EAAA;EqHnoBlC;IAOQ,UAAU,EAAA;;AAIlB;EAEQ,UAAU;EACV,WAAW;EACX,sBrHqGO;EqHpGP,YAAY;EACZ,yBAAyB,EAAA;EANjC;IAQY,UAAU;IACV,WAAW,EAAA;;AAKvB;EACI,WrH0FW;EqHzFX,eAAe;EACf,oCrHkGW;EqHjGX,kCAA0B;UAA1B,0BAA0B,EAAA;;AAI9B;EAEQ,uBAAuB;EACvB,sBAAsB;EACtB,4BAA4B;EAC5B,6BAA6B;EAC7B,iCAAmC;EACnC,uBAAuB;EACvB,yBAAyB,EAAA;EARjC;IAUY,yBAA4B;IAC5B,qBACJ,EAAA;;AAIR;EACI,sBAAsB;EACtB,qDAAiD,EAAA;EAFrD;IAIQ,oCAAqC,EAAA;;AAK7C;EACI,2CrHyDW;EqHxDX,kCAA0B;UAA1B,0BAA0B;EAC1B,cAAc;EACd,sBAAsB,EAAA;EAJ1B;IAMQ,sBrHoDO,EAAA;;AqHhDf;EAEQ,oCAAuC,EAAA;;AAF/C;EAMY,oCAAuC,EAAA;;AANnD;EAWY,WrHqCG,EAAA;EqHhDf;IAagB,UAAU,EAAA;;AAb1B;EAkBQ,wCrHuCU,EAAA;;AsHrJlB;EACE,YAAY;EACZ,kBAAkB,EAAA;EAFpB;IAKI,gBAAgB;IAChB,kBAAkB;IAClB,wBAAwB;IACxB,SAAS;IACT,2BAA2B;IAC3B,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,ctHgIc;IsH/Hd,iCAAwD;IACxD,UAAU,EAAA;EApBd;IAwBI,wCtHg8BwF;IsH/7BxF,oCtH07BgF;IsHz7BhF,+BtHsnBgC;IsHrnBhC,kCtHqnBgC,EAAA;EsHhpBpC;IAgCM,wBAAwB,EAAA;EAhC9B;IAoCM,WAAW,EAAA;EApCjB;IAwCM,WAAW,EAAA;EAxCjB;IA4CM,+CAAwE;IACxE,mBAAmB;IACnB,oCtHq6B8E,EAAA;EsHn9BpF;IAkDM,mBAAmB;IACnB,oCtHg6B8E,EAAA;EsHn9BpF;IAwDI,eAAe,EAAA;EAxDnB;IA4DI,2BtH25BoF,EAAA;IsHv9BxF;MA8DM,yCtH2Gc,EAAA;EsHzKpB;IAmEI,wCtHq5BwF;IsHp5BxF,8BtH+4BgF;IsH94BhF,gCtH2kBgC;IsH1kBhC,mCtH0kBgC,EAAA;EsHhpBpC;IA0EI,cAAc;IACd,sBtH4xB+B;IsH1xB/B,mBtH2nBkC;IsH1nBlC,2BtHy4BoF;IsHx4BpF,oCtHo4BgF;IsHn4BhF,wCtHw4BwF;IsHv4BxF,sBtH+jBgC;IsH9jBhC,mBAAmB,EAAA;IAlFvB;MAoFM,ctH8DY,EAAA;EsHlJlB;IAyFI,gBtH4BsB;IsH3BtB,yBAAmD,EAAA;;AC3FvD;EACE,6BvH+2C4E;EuH92C5E,6CvHwpB6D;EuHvpB7D,kBAAkB;EAClB,wCvHyoBgF,EAAA;;AuHtoBlF;EAEI,mCvHu2C0E;EuHt2C1E,gDvHmoB8E;EuHloB9E,kBAAkB;EAClB,gBvHgpB8B,EAAA;EuHrpBlC;IAOM,kBAAkB,EAAA;;AAKxB;EAIQ,mBAAmB;EACnB,cAAc,EAAA;;AALtB;EASQ,kBAAkB;EAClB,eAAe,EAAA;;AAVvB;EAiBM,eAAe,EAAA;;AAjBrB;EAuBM,mBvHgIc,EAAA;;AuHvJpB;EA2BM,oCvHs6B8E;EuHr6B9E,2BvHy6BkF;EuHx6BlF,wCvHy6BsF;EuHx6BtF,sBvHgmB8B,EAAA;;AuH9nBpC;EAkCM,iCAA8C,EAAA;EAlCpD;IAoCQ,gBAAgB;IAChB,oCvH45B4E;IuH35B5E,0CvHy6BgG,EAAA;;AuH/8BxG;EA2CM,8BAA+B,EAAA;;AA3CrC;EA+CM,8BAA8B,EAAA;;AClEpC;EACE,gBAAgB,EAAA;EADlB;IAKM,eAAe,EAAA;;AAKrB;EACE,yCxHkoBgF;EwHjoBhF,6BxHo2C4E,EAAA;;AwHj2C9E;EACE,2BAAuD,EAAA;EADzD;IAGI,gBxHmGoB,EAAA;;AwH/FxB;EACE,aAAa,EAAA;;AAGf;EACE,oCAAqC,EAAA;;AnIooqDvC;;EoI5pqDI,wBAAwB;EACxB,YAAY,EAAA;;AAGhB;EACI,wCzHi9BwF;EyHh9BxF,oBAAoB;EACpB,iBAAiB;EACjB,cAAc;ExHId,sBDkoBgC;EyHpoBhC,8BzHu8BgF;EyHt8BhF,YAAY,EAAA;EAPhB;IAUQ,UAAU;IACV,YAAY;IACZ,kBAAkB;IAClB,SAAS;IACT,uBAAuB;IACvB,2BzHk8BgF;IyHj8BhF,sBzH0nB4B,EAAA;IyH1oBpC;MAmBY,UAAU,EAAA;EAnBtB;IAwBQ,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,kBAAkB;IAClB,gBAAgB;IAChB,yBAAyB;IACzB,2BAAkD;IAClD,2BAAuD;IACvD,YAAY;IACZ,sBzHymB4B,EAAA;EyH1oBpC;IAqCQ,2BAAkD,EAAA;IArC1D;MAwCY,oCzHq6BwE,EAAA;EyH78BpF;IA6CQ,2BAAkD,EAAA;IA7C1D;MAgDY,oCzH65BwE,EAAA;EyH78BpF;IAqDQ,aAAa;IACb,WAAW,EAAA;IAtDnB;MAyDY,cAAc,EAAA;IAzD1B;MA6DY,YAAY,EAAA;;AAOpB;EAGY,yBzH4FI;EyH3FJ,WzH8DD,EAAA;;AyHlEX;EAGY,yBzH8FI;EyH7FJ,WzH8DD,EAAA;;AyHlEX;EAGY,yBzHmGI;EyHlGJ,WzH8DD,EAAA;;AyHlEX;EAGY,yBzHqGI;EyHpGJ,WzH8DD,EAAA;;AyHlEX;EAGY,yBzHkGI;EyHjGJ,WzH8DD,EAAA;;AyHlEX;EAGY,yBzHgGI;EyH/FJ,WzH8DD,EAAA;;AyHlEX;EAGY,yBzHgEE;EyH/DF,WzH8DD,EAAA;;AyHlEX;EAGY,yBzHwEE;EyHvEF,WzH8DD,EAAA;;A0H7If;EACI,iDAAyC,EAAA;EAD7C;IAIQ,sCAAkE,EAAA;EAJ1E;IAOQ,sDAAwE,EAAA;EAPhF;IAWQ,gBAAgB,EAAA;EAXxB;IAeQ,mDAAgD,EAAA;IAfxD;MAkBY,0BAA0B,EAAA;IAlBtC;MAsBY,kCAAkC,EAAA;EAtB9C;IA2BQ,wBAAwB;IACxB,8CAAqC;IACrC,+CAA4C;IAC5C,2BAA2B,EAAA;EA9BnC;IAkCQ,4CAAmC;IACnC,6C1HunBuD;I0HtnBvD,6BAA6B;IAC7B,uBAAuB;IACvB,yBAAyB;IACzB,qB1H4mB2B,EAAA;E0HnpBnC;IA2CQ,4CAAmC,EAAA;EA3C3C;IAkDgB,OAAO;IACP,sBAAsB,EAAA;EAnDtC;IA0DY,2BAA2B,EAAA;EA1DvC;IA+DQ,wDAA2C;IAC3C,gCAAiD;IACjD,mDAAmD,EAAA;;AAI3D;;;EAIQ,2BAA2B;EAC3B,4CAAmE,EAAA;;AAL3E;;EAUY,sCAA6D,EAAA;;AAVzE;;EAeQ,sCAA6D,EAAA;;AAIrE;;EAEI,iCAAwC;EACxC,uCAAuC;EACvC,wCAAwC,EAAA;;AAG5C;;EAEI,iCAAwC;EACxC,oCAAoC;EACpC,qCAAqC,EAAA;;AAGzC;EACI,4BAA4B,EAAA;;AAGhC;EACI,2BAA2C,EAAA;;AAG/C;;;EAMgB,2BAA2B,EAAA;;AAM3C;EAGY,8BAA4B;EAC5B,yBAAwB,EAAA;;AAJpC;EASQ,yCAAgC;EAChC,mDAAgD,EAAA;EAVxD;IAYY,yDAAsD;IACtD,2BAA2B,EAAA;;AAbvC;EAkBQ,4CAAmC;EACnC,mDAAmD,EAAA;EAnB3D;IAuBgB,qDAA4C,EAAA;EAvB5D;IA2BgB,sDAAsD,EAAA;;AAQtE;EACI,4CAAmC,EAAA;;AAKvC;EAEM,aAAa;EACb,8BAA8B,EAAA;;AAHpC;EAQQ,mDAAgD;EAChD,2BAA2B,EAAA;;AATnC;;EAeM,iCAAwC;EACxC,uCAAuC;EACvC,wCAAwC,EAAA;;AAjB9C;;EAsBM,iCAAwC;EACxC,oCAAoC;EACpC,qCAAqC,EAAA;;ArI2qqD3C;EqIrqqDQ,2BAA2B,EAAA;;ACjMnC;EACI,gBAAgB,EAAA;EADpB;;IAKQ,mBAAmB;IACnB,gBAAgB,EAAA;EANxB;IAUQ,mBAAmB;IACnB,mBAAmB;IACnB,iBAAiB,EAAA;;AAIzB;EACI,sC3HkrBoF,EAAA;E2HnrBxF;IAIQ,oC3Hq8BoF;I2Hp8BpF,8BAA8B;IAC9B,+BAA+B,EAAA;;AAIvC;EACI,wC3H87BwF;E2H77BxF,sB3HqnBgC,EAAA;;A2HlnBpC;EACI,iDAAyC,EAAA;EAD7C;IAIQ,wBAAwB;IACxB,oC3H2uC8F,EAAA;I2HhvCtG;MAQY,yBAA0B,EAAA;EARtC;IAaQ,2BAA2B;IAC3B,4BAA4B;IAC5B,oC3H26BoF,EAAA;I2H17B5F;MAmBgB,yBAAyB,EAAA;IAnBzC;MAwBY,6C3HmmBmD;M2HlmBnD,qB3H2lBuB,EAAA;;A2HtlBnC;;;EAKQ,qC3H6sC8F,EAAA;;A2HltCtG;EASQ,mC3HysC8F,EAAA;;A2HltCtG;EAcY,QAAQ;EACR,UAAU,EAAA;;AAftB;EAqBY,oC3H6rC0F,EAAA;;A2HxrCtG;EAEQ,uC3H6qC8E;E2H5qC9E,+CAA+C,EAAA;;AC1FvD;EACI,2B5HozB0E;E4HnzB1E,UAAU;EACV,cAAc,EAAA;;AAGlB;EACI,gBAAgB;EAChB,wC5HqoB8E;E4HpoB9E,kBAAkB,EAAA;EAHtB;IAMQ,wBAAwB,EAAA;EANhC;IAUQ,WAAW,EAAA;EAVnB;IAcQ,YAAY,EAAA;EAdpB;IAkBQ,iDAA0E;IAC1E,mBAAmB;IACnB,mC5Hs1CsE,EAAA;E4H12C9E;IAwBQ,mBAAmB;IACnB,mC5Hi1CsE,EAAA;;A4H70C9E;EACI,uBAAuB;EACvB,iBAAiB,EAAA;;AAGrB;EACI,WAAW,EAAA;;AAGf;EACI,6B5HywBqC,EAAA;;A4HtwBzC;;EAEI,wC5H2lB8E;E4H1lB9E,uB5H4vB+B,EAAA;;A4HzvBnC;EAEQ,aAAa;EACb,2B5H4vBsE;E4H3vBtE,iDAA2E,EAAA;;AAJnF;EAYY,iDAA2E,EAAA;;AAKvF;EACI,cAAc,EAAA;;AArClB;EAyCI,gBAAgB;EAChB,wC5HgkB8E;E4H/jB9E,aAAa;EACb,6B5HuuBqC,EAAA;;A4HpuBzC;EACI,c5HgEc;E4H/Dd,0BAA0B,EAAA;;AAG9B;EAGQ,mBAAmB;EACnB,iCAAwC;EACxC,wC5HkuCgF;E4HjuChF,mC5H6tCsE;E4H5tCtE,2B5H6dkF,EAAA;E4Hpe1F;IAUY,8C5H6tC4E,EAAA;E4HvuCxF;IAgBY,c5H4CM;I4H3CN,mC5HktCkE,EAAA;E4HnuC9E;IAqBY,+C5H0tC0F;I4HztC1F,iC5Hid0F,EAAA;E4HvetG;IA0BY,gBAAgB,EAAA;EA1B5B;IAgCgB,6BAA6B,EAAA;EAhC7C;IAqCY,yB5H8CQ;I4H7CR,W5HgBG;I4HfH,qB5H4CQ;I4H3CR,gB5HVY,EAAA;;A4HexB;EACI,kBAAkB;EAClB,WAAW,EAAA;EAFf;IAKQ,gBAAgB;IAChB,wBAAwB;IACxB,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;IAC3B,UAAU;IACV,eAAe;IACf,c5HGU,EAAA;;A4HClB;EACI,oC5Ho0BwF;E4Hn0BxF,oC5H8zBgF;E4H7zBhF,2B5Hi0BoF;E4Hh0BpF,gB5H6jB6B;E4H5jB7B,sCAAiF;EACjF,sB5HufgC;EFhX9B,mBAvE+B,EAAA;E8HtErC;IAUQ,gBAAgB;IAChB,0C5Hm0BgG;I4Hl0BhG,oC5HozB4E,EAAA;E4Hh0BpF;IAgBQ,c5HjBU,EAAA;;A4HqBlB;EAEQ,WAAW;EACX,qBAAqB;EACrB,sBAAsB;EACtB,gB5HvDkB,EAAA;;A4H2D1B;EACI,WAAW;EACX,qBAAqB;EACrB,sBAAsB;EACtB,WAAW;EACX,YAAY,EAAA;;AAGhB;EACI,wBAAwB,EAAA;;AAG5B;EAEQ,oBAAoB,EAAA;;AAO5B;EAGQ,sBAAsB,EAAA;;AAH9B;EAOQ,aAAa;EACb,gBAAgB;EAChB,mBAAmB,EAAA;;AAT3B;EAaQ,4BAA4B,EAAA;;AAKpC;EAEQ,8C5HumBmG,EAAA;;A4HzmB3G;EAKQ,yB5HnDY;E4HoDZ,qB5HpDY;E4HwDR,0D9G/FsE,EAAA;;A8GmGlF;EAEQ,Y5HixBuC;E4HhxBvC,a5HgxBuC;E4H/wBvC,mBAAmB;EACnB,oC5HyuB4E;E4HxuB5E,4BAA4B;EAC5B,2BAA2B;EAC3B,wBAAwB;EACxB,8C5HqxB4G;E4HpxB5G,gBAAgB;EAChB,iCAAmB;UAAnB,mBAAmB,EAAA;EAX3B;I3HvNI,qBDs/B2C,EAAA;;A4H5wB/C;EAEQ,qBAAqB;EACrB,oBAAoB,EAAA;;AAI5B;EACI,mC5H+mC0E,EAAA;;AX6toD9E;EuIt0qDY,kD5H67C2D,EAAA;;A6HpsDvE;EACI,gBAAgB;EAChB,yBAAyB;EACzB,QAAQ,EAAA;EAHZ;IAMY,cAAc;IACd,yB7H4yC8B;I6H3yC9B,2B7HmjB8E;I6HljB9E,mC7HizCkE;I6HhzClE,wC7HozC4E;I6HnzC5E,sB7HsoBwB,EAAA;E6HjpBpC;IAgBgB,W7H6HD;IkB7Ib,yBlB0KkB;I6HxJJ,qB7HwJI,EAAA;;A6HlJpB;EACI,yBAAiB;UAAjB,iBAAiB;EACjB,aAAa;EACb,mBAAmB,EAAA;EAHvB;IAKQ,qBAAqB;IACrB,qBAAqB,EAAA;;AAI7B;;EAEI,c7HsIgB;E6HrIhB,gB7HgFoB;E6H/EpB,yB7H6wCsC;E6H5wCtC,mC7HmxC0E;E6HlxC1E,wC7HsxCoF;E6HrxCpF,sB7HwmBgC,EAAA;E6H/mBpC;;IASQ,cAA6B,EAAA;EATrC;;IAaQ,c7HoGU;I6HnGV,eAAe,EAAA;IAdvB;;MAiBY,c7HgGM,EAAA;;A8HnJlB;EACI,2BAA2B,EAAA;EAD/B;IAGQ,iDAAyC,EAAA;EAHjD;IAMQ,cAAc,EAAA;;AAItB;;EAEI,iDAAyC,EAAA;;AAG7C;EACI,mDAA0C;EAC1C,8CAAqC;EACrC,uDAAkC,EAAA;EAHtC;IAKQ,iDAAyC;IACzC,yBAA2B,EAAA;EANnC;IAUQ,4DAAsF;IACtF,0DAAiD,EAAA;;AAIzD;EAEQ,sBAAwB,EAAA;;AAIhC;EACI,gB9HgFoB,EAAA;;A8H7ExB;EACI,oBAAoB;EACpB,uCAAiE,EAAA;;AAGrE;EACI,yBAA2B;EAC3B,iDAAyC;EACzC,0BAA0B,EAAA;;AAG9B;EACI,qBAAuB,EAAA;;AAG3B;EACI,a9H0Fc,EAAA;;A8HvFlB;;EAGQ,iDAAyC;EACzC,a9HmFU,EAAA;;A8H/ElB;EACI,gBAAgB,EAAA;;AAKpB;EACI,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB,EAAA;;AAGtB;EACI,eAAe,EAAA;;AAGnB;;EAEI,UAAU;EACV,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,6B9HsxC0E;E8HrxC1E,wC9HkjB8E,EAAA;;A8H/iBlF;EACI,WAAW;EACX,kBAAkB;EAClB,6BAA6B;EAC7B,UAAU,EAAA;EAJd;IAMQ,wBAAwB;IACxB,6BAA6B,EAAA;;AAIrC;EACI,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,6BAA6B,EAAA;EAJjC;IAMQ,sCAAsC;IACtC,wBAAwB;IACxB,UAAU,EAAA;;AAIlB;EAvBA;IAyBQ,0BAA0B,EAAA;EAdlC;IAiBQ,2BAA2B,EAAA,EAC9B;;AAKL;EAEQ,8B9H2gB0E,EAAA;;A8HvgBlF;EAEQ,8B9HqgB0E,EAAA;;A8HvgBlF;EAKQ,0BAAsD,EAAA;;AC1I9D;EACE,iBAAiB,EAAA;;ACFnB;EACI,aAAa,EAAA;;AAGjB;EACI,aAAa,EAAA;;ACJjB;EACE,aAAa;EACb,mBjI2IgB;EiI1IhB,kBAAkB,EAAA;;AAGpB;EACE,cAAc;EACd,kBAAkB;EAClB,WjImIa;EiIlIb,eAAe;EACf,iBAAiB;EACjB,mBjI6JkB;EiI5JlB,kBAAkB;EAClB,kBAAkB,EAAA;;AAGpB;EACE,SAAS;EACT,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,kBAAkB,EAAA;EALpB;IAOI,aAAa;IACb,mCAAmC;IACnC,oCAAoC;IACpC,8BjI8IgB,EAAA;EiIxJpB;IAaI,UAAU;IACV,mCAAmC;IACnC,oCAAoC;IACpC,iCjIwIgB,EAAA;;AkI1KpB;EACI,cAAc,EAAA;EADlB;IAIQ,cAAc;IACd,WAAW;IACX,YAAY;IACZ,sBlIi2B2B;IkI/1B3B,mBlIgsB8B;IkI/rB9B,gBlIqsByB;IkIpsBzB,gBlI0sByB;IkIzsBzB,2BlI48BgF;IkI38BhF,oClIu8B4E;IkIt8B5E,4BAA4B;IAC5B,wClI08BoF;IkIz8BpF,sBlIioB4B;IkIhoB5B,sBAAsB,EAAA;IAjB9B;MAoBY,qBAAqB;MACrB,yBAA0C;MAC1C,8BAAsC,EAAA;IAtBlD;MA0BY,8ClIw8B4F;MkIv8B5F,2BlI67B4E,EAAA;IkIx9BxF;MA+BY,2BlIy7B4E,EAAA;EkIx9BxF;IAoCQ,sBlI6mB4B;IkI5mB5B,oClIkuCgF;IkIjuChF,uClIguC8E;IkI/tC9E,6ClImnBuD;IkIlnBvD,UAAU;IACV,cAAc;IACd,iBAAiB;IACjB,SAAS;IACT,6BAA6B;IAC7B,uBAAuB;IACvB,yBAAyB,EAAA;IA9CjC;MAiDY,mBlIwpB0B;MkIvpB1B,SAAS;MACT,uBlIsuC8B;MkIruC9B,gBAAgB;MAChB,uClIitC0E;MkIhtC1E,2BlI+sCwE,EAAA;MkIrwCpF;QAyDgB,clIqHI;QkIpHJ,gBlI4DU;QkI3DV,YAAY,EAAA;MA3D5B;QAgEgB,0ClIgtCkG;QkBhxChH,kDlBixC0G,EAAA;IkIjxC5G;MAsEY,sBlImtC8B;MkIltC9B,kBAAkB;MAClB,gBlI6CY,EAAA;;AmIrHxB;EACI,kBAAkB;EAClB,yBnIwKgB;EmIvKhB,sCnIgsBoF;EmI/rBpF,6CnIspB2D;EmIrpB3D,gBAAgB,EAAA;;AAGpB;EAEQ,sCnIyrBgF;EmIxrBhF,mBnI8rB8B;EmI7rB9B,wBAAkD,EAAA;;AAI1D;EACI,yBnIyJgB,EAAA;;AoI1KpB;EACI,aAAa,EAAA;EADjB;IAGQ,UAAU;IACV,kCpIMsD,EAAA;;AqIT9D;;EAEI,wCrI0oB8E,EAAA;;AqIvoBlF;EAGY,eAAe;EACf,iBAAiB;EACjB,yBAAyB,EAAA;;AAG7B;EARR;;;IAagB,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,WAAW;IACX,cAAc,EAAA;EAjB9B;IAqBgB,WAAW,EAAA;EArB3B;IAyBgB,aAAa,EAAA,EAChB;;AA1Bb;EA8BY,0BAA0B,EAAA;;AA9BtC;EAmCQ,iCAAwD,EAAA;;AAnChE;EAuCQ,cAAc;EACd,gBAAgB,EAAA;;AAxCxB;EA4CQ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBrI2DgB;EqI1DhB,WAAW,EAAA;;AArDnB;EA0DY,yCrI0GQ,EAAA;EqIpKpB;IA6DgB,yBrIuGI;IqItGJ,WrIyED,EAAA;;AqIvIf;EAqEY,yCrI+FQ,EAAA;;AqIpKpB;EA2EY,yCrIyFQ,EAAA;;AqIpKpB;EAgFQ,uBAAuB,EAAA;;AAhF/B;EAqFY,sBAAwB,EAAA;;AArFpC;;;EA4FQ,sBAAsB,EAAA;;AA5F9B;EAgGQ,6CrIuiB0E;EqItiB1E,4CrIsiB0E,EAAA;;AqIvoBlF;EAqGQ,aAAa,EAAA;;AAIrB;EACI,2BAAuD,EAAA;;AAG3D;EACI,WrIyBW,EAAA;;AqItBf;EAEQ,mBrIuBU;EqItBV,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,gBrImlByB,EAAA;;AqI/kBjC;;;;;;;;;;EAYQ,qBrIGU,EAAA;;AqIflB;EAgBQ,mBAAkC,EAAA;;AAI1C;EACI,6BrI0tC0E;EqIztC1E,oCrIsf8E;EqIrf9E,crIJc;EqIKd,0BAA0B;EAC1B,gBAAgB;EAChB,4BAA4B;EAC5B,uBAAuB,EAAA;;AAG3B;;;EAGI,yBrIQgB;EqIPhB,WrItBW;EqIuBX,iBAAiB,EAAA;;AAjDrB;EAqDI,kBAAkB;EAClB,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,kBAAkB,EAAA;;AAGtB;;EAEI,yBrITgB,EAAA;;AqIYpB;;EAEI,yBrIdgB,EAAA;;AqIqBpB;;EAEI,2BAA6C;EAC7C,uBAAuB;EACvB,mBAAmB,EAAA;;AAGvB;EACI,6BAA+B;EAC/B,aAAa,EAAA;;AAGjB;EACI,aAAa,EAAA;;AAGjB;EACI,WrInEW,EAAA;;AqIsEf;EAEQ,gBAAgB;EAChB,iBAAiB;EACjB,aAAa,EAAA;;AAKrB;EAEQ,crIhFU,EAAA;;AqIoFlB;;EAEI,kBAAkB;EAClB,cAAc;EACd,aAAa,EAAA;EAJjB;;IAOQ,kBAAkB;IAClB,iCAAiC;IACjC,eAAe;IACf,MAAM;IACN,WAAW;IACX,OAAO;IACP,QAAQ;IACR,aAAa;IACb,mBAAmB;IACnB,uBAAuB,EAAA;;AAI/B;EAEQ,gBAAgB,EAAA;;AAIxB;EAEQ,gBAAgB,EAAA;;AAIxB;EAEQ,gBrIwZ0B,EAAA;EqI1ZlC;IAIY,crI1FQ;IqI2FR,2CrI3FQ;IqI4FR,YAAY;IACZ,gBAAgB,EAAA;IAP5B;MAWgB,WrIhID;MqIiIC,yBrIlGI,EAAA;;AqIsFpB;EAkBQ,oCAAuC;EACvC,erIzGY,EAAA;;AqI8GhB;EADJ;IAEQ,sBAAsB;IACtB,SAAS,EAAA,EAEhB;;AAED;EAGY,6BAA6B,EAAA;;AAKzC;EAEQ,aAAa,EAAA;;AAFrB;EAOY,aAAa,EAAA;;AAPzB;EAWY,aAAa,EAAA;;AAXzB;EAeY,cAAc,EAAA;;AAK1B;EAEQ,kCAA0B;UAA1B,0BAA0B,EAAA;;AAIlC;EAEQ,kCAA0B;UAA1B,0BAA0B,EAAA;;AAKlC;EAGY,+CAAsC,EAAA;;AAKlD;EACI,oCrI2T8E,EAAA;;AqItT9E;;EAMgB,yBAAwB,EAAA;;AAMxC;EAIgB,yBAAwB,EAAA;;AAMxC;EAGY,yBAAwB,EAAA;EAHpC;IAOoB,yBAAwB,EAAA;EAP5C;IAYgB,qBrI/MA,EAAA;;AqI6KhB;;EAMgB,yBAAwB,EAAA;;AAMxC;EAIgB,yBAAwB,EAAA;;AAMxC;EAGY,yBAAwB,EAAA;EAHpC;IAOoB,yBAAwB,EAAA;EAP5C;IAYgB,qBrI7MA,EAAA;;AqI2KhB;;EAMgB,yBAAwB,EAAA;;AAMxC;EAIgB,yBAAwB,EAAA;;AAMxC;EAGY,yBAAwB,EAAA;EAHpC;IAOoB,yBAAwB,EAAA;EAP5C;IAYgB,qBrIxMA,EAAA;;AqIsKhB;;EAMgB,yBAAwB,EAAA;;AAMxC;EAIgB,yBAAwB,EAAA;;AAMxC;EAGY,yBAAwB,EAAA;EAHpC;IAOoB,yBAAwB,EAAA;EAP5C;IAYgB,qBrItMA,EAAA;;AqIoKhB;;EAMgB,yBAAwB,EAAA;;AAMxC;EAIgB,yBAAwB,EAAA;;AAMxC;EAGY,yBAAwB,EAAA;EAHpC;IAOoB,yBAAwB,EAAA;EAP5C;IAYgB,qBrIzMA,EAAA;;AqIuKhB;;EAMgB,yBAAwB,EAAA;;AAMxC;EAIgB,yBAAwB,EAAA;;AAMxC;EAGY,yBAAwB,EAAA;EAHpC;IAOoB,yBAAwB,EAAA;EAP5C;IAYgB,qBrI3MA,EAAA;;AqIyKhB;;EAMgB,yBAAwB,EAAA;;AAMxC;EAIgB,yBAAwB,EAAA;;AAMxC;EAGY,yBAAwB,EAAA;EAHpC;IAOoB,yBAAwB,EAAA;EAP5C;IAYgB,qBrI3OF,EAAA;;AqIyMd;;EAMgB,yBAAwB,EAAA;;AAMxC;EAIgB,yBAAwB,EAAA;;AAMxC;EAGY,yBAAwB,EAAA;EAHpC;IAOoB,yBAAwB,EAAA;EAP5C;IAYgB,qBrInOF,EAAA;;AqI0OlB;EAEQ,gCAAuD,EAAA;;AAI/D;EACI,cAAc,EAAA;EADlB;IAGQ,mBAAmB,EAAA;;ACzY3B;EACI,uBAAuB;EACvB,uDAAkC;EAClC,oBAAoB;EACpB,aAAa,EAAA;EAJjB;IAOQ,iDAAyC;IACzC,yBAA6B,EAAA;EAEjC;IAVJ;MAWQ,qBAAqB;MACrB,oBAAoB;MACpB,aAAa,EAAA,EAsCpB;EAnDD;IAiBQ,yBAAuB,EAAA;EAjB/B;IAqBQ,uBAAuB,EAAA;IArB/B;MAuBY,+CAAsC;MACtC,sCAA8B;MAC9B,iCAA6D;MAC7D,8BAAqC,EAAA;MA1BjD;QA4BgB,yBAA0C,EAAA;IA5B1D;MAiCY,wBAA4B;MAC5B,WAAW;MACX,SAAS,EAAA;EAnCrB;IAwCQ,oCAAmC,EAAA;IAxC3C;MA0CY,kDAAkD,EAAA;IA1C9D;MA8CgB,kDAAkD,EAAA;;AAOlE;EACI,6DAA6D,EAAA;;AAGjE;EACI,oCAA+C,EAAA;;ACzDnD;EACI,kBAAkB;EAClB,WvI0IW;EuIzIX,qBAAqB;EACrB,uFAAuF;EACvF,mBvI2KgB;EuI1KhB,eAAe;EACf,UAAU;EACV,wDAAwD;EACxD,kBAAkB;EAClB,eAAe;EACf,qBAAqB;EACrB,2BAA2B;EAC3B,mBAAmB,EAAA;EAbvB;IAeQ,UAAU,EAAA;;AAKlB;EACI,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,SAAS;EACT,gBAAgB,EAAA;;AAGpB;EACI,WAAW,EAAA;;AAGf;EACI,UAAU,EAAA;EADd;IAGQ,UAAU;IACV,cAAc;IACd,iBAAiB,EAAA;;AAIzB;EACI,WAAW,EAAA;;AAGf;EACI,cAAc,EAAA;;AAGlB;EACI,mBAAmB,EAAA;;AAGvB;EACI,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,kBAAkB,EAAA;;AAGtB;EACI,iBAAiB;EACjB,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,sBAAsB;EACtB,2BAA2B,EAAA;;AAG/B;EACI;IACI,iBAAiB;IACjB,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,2BAAsB;IAAtB,sBAAsB,EAAA,EACzB;;AC7EL;EACI,kBAAkB;EAClB,mBAAmB;EACnB,eAAe,EAAA;EAHnB;IAMQ,aAAa,EAAA;EANrB;IAUQ,gBAAgB,EAAA;EAVxB;;IAgBY,iDAA4E;IAC5E,mBAAmB;IACnB,yBAAiB;YAAjB,iBAAiB,EAAA;EAlB7B;IAsBY,mBAAmB,EAAA;EAtB/B;IA2BQ,wBAAwB,EAAA;EA3BhC;IAgCQ,eAAe,EAAA;IAhCvB;MAkCY,uBAAuB,EAAA;IAlCnC;MAsCY,cAAc;MACd,WAAW;MACX,sBxIg0BuB;MwI/zBvB,oCxI26BwE;MwI16BxE,wCxI+6BgF;MwI96BhF,mBxI8pB0B;MwI7pB1B,sBxIqmBwB;MwIpmBxB,2BxI26B4E;MwI16B5E,mBAAmB,EAAA;IA9C/B;MAkDY,0DAAyX;MACzX,UAAU;MACV,oBAAoB;MACpB,kBAAkB;MAClB,QAAQ;MACR,QAAQ;MACR,UAAU;MACV,iBAAiB;MACjB,kBAAkB;MAClB,cAAc;MACd,YAAY;MACZ,WAAW;MACX,mBAAmB;MACnB,YAAY,EAAA;MA/DxB;QAkEgB,UAAU,EAAA;MAlE1B;QAsEgB,mCAAmC,EAAA;IAtEnD;MA2EY,aAAa,EAAA;IA3EzB;MA+EY,iBAAiB;MACjB,kBAAkB;MAClB,SAAS;MACT,6CAA2C;MAC3C,aAAa;MACb,UAAU;MACV,oCAAoC;MACpC,WAAW;MACX,YAAY;MACZ,aAAa;MACb,QAAQ;MACR,2BAA2B;MAC3B,oBAAoB,EAAA;IA3FhC;MA+FY,aAAa;MACb,2CAA2C,EAAA;EAhGvD;IA2GY,YAAY;IACZ,qBxI4vBuB,EAAA;EwIx2BnC;IAgHY,kBAAkB;IAClB,qBAAqB;IACrB,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,+CxIsBG;IwIrBH,eAAe;IACf,0DAAyX;IACzX,oBAAoB;IACpB,UAAU;IACV,cAAc;IACd,aAAa;IACb,gBAAgB,EAAA;IA9H5B;MAgIgB,UAAU,EAAA;EAhI1B;IAoIY,oBAAoB,EAAA;IApIhC;MAsIgB,gBAAgB,EAAA;EAtIhC;IA6IY,gBAAgB,EAAA;;AAM5B;EAEQ,iCAAwD;EACxD,YAAY,EAAA;;AAIpB;EACI,qBAAqB;EACrB,sBAAsB;EACtB,WAAW;EACX,oCxIszBgF;EwIrzBhF,qCAAwF;EACxF,wCxIyzBwF;EwIxzBxF,iCAAoD;EACpD,mBxIuiBkC;EwItiBlC,kBAAkB;EAClB,gBAAgB,EAAA;;AAIpB;;EAGQ,0CxIuzBgG,EAAA;;AwInzBxG;EACI,SAAS;EACT,eAAe;EACf,gBAAgB,EAAA;;AAGpB;EACI,qBAAqB;EACrB,yBAAyB;EACzB,WAAW,EAAA;EAHf;IAMQ,WAAW,EAAA;;AAInB;EACI,eAAe,EAAA;EADnB;IAGQ,qBAAqB;IACrB,uBAAuB;IACvB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,gBxIwgByB;IwIvgBzB,oBAAoB;IACpB,qBAAqB;IACrB,eAAe;IACf,yBxIjCY;IwIkCZ,yBxIlCY;IwImCZ,qBAAqB;IACrB,sBAAsB;IACtB,WxIlEO;IwImEP,gBxI4c0B,EAAA;IwI7dlC;MAmBY,kBAAkB,EAAA;IAnB9B;MAuBY,yBxI5CQ;MwI6CR,yBxI7CQ,EAAA;;AwImDpB;EAGY,yBxIpDQ;EwIqDR,yBxIrDQ,EAAA;;AwI0DpB;EACI,kBAAkB;EAClB,UAAU;EACV,kBAAkB;EAClB,WAAW;EACX,uCxI2hCkF;EwI1hClF,wCxI2hCoF;EwI1hCpF,6CxI6a2D;EwI5a3D,SAAS;EACT,aAAa;EACb,4BAA4B;EAC5B,gCAAgC;EAChC,iCAAiC;EACjC,gBAAgB;EAChB,qBAAqB;EACrB,uBAAuB;EACvB,uBAAuB;EACvB,yBAAyB;EACzB,0BAA0B,EAAA;EAlB9B;IAoBQ,mBAAmB;IACnB,6BAA6B,EAAA;EArBrC;IAyBQ,kDxIkhCoG,EAAA;EwI3iC5G;IA6BQ,qBAAqB,EAAA;EA7B7B;IAiCQ,kBAAkB;IAClB,gBxInJgB,EAAA;EwIiHxB;IAsCQ,aAAa,EAAA;;AAIrB;EAEQ,oCxIq/BgF,EAAA;;AwIj/BxF;EAEQ,SAAS;EACT,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kCAAkC,EAAA;EAN1C;IAQY,iCAAiC;IACjC,2BAA2B,EAAA;;AAzDvC;EAgEQ,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,iCAAiC;EACjC,4BAA4B,EAAA;;AANpC;EAUQ,kBAAkB;EAClB,mBxI0Z8B;EwIzZ9B,oCAAwF,EAAA;;AAMhG;EAhFA;IAqFgB,+BAA+B;IAC/B,eAAe;IACf,UAAU;IACV,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,2BAA2B,EAAA;EAVvC;IAegB,YAAY,EAAA,EACf;;AAQjB;EACI,eAAe,EAAA;;AAGnB;EACI,eAAe,EAAA;;AAGnB;EACI,mBAAmB;EACnB,yBAAiB;UAAjB,iBAAiB;EACjB,YAAY,EAAA;;AAGhB;EACI,gBxIxOsB;EwIyOtB,eAAe;EACf,kBAAkB;EAClB,+CxI4S8E;EwI3S9E,cxI/Mc,EAAA;;AwIkNlB;EACI,oBAAoB;EACpB,gBAAgB;EAChB,SAAS;EACT,6BAA6B;EAC7B,4BAA4B;EAC5B,2BAA2B;EAC3B,eAAe,EAAA;EAPnB;IASQ,aAAa,EAAA;;AAIrB;EACI,qBAAqB;EACrB,wBAAwB;EACxB,oCxI+lBgF;EwI9lBhF,2BxIkmBoF;EwIjmBpF,mBxIkVkC;EwIjVlC,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,sBAAsB,EAAA;EAV1B;IAYQ,UAAU,EAAA;EAZlB;IAeQ,cxI9OU,EAAA;;AwIkPlB;EACI,cxInPc;EwIoPd,UAAU,EAAA;;AnJ6qsDd;EmJtqsDY,kDxIszC2D,EAAA;;AyIpsDvE;EACI,uBAAuB;EACvB,UAAU;EACV,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,eAAe;EACf,cAAc;EACd,SAAS;EACT,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,0BAA0B;EAC1B,iCzIqvCkF;EyIpvClF,4KAAwI,EAAA;EAlB5I;IAsBQ,UAAU;IACV,iBAAiB;IACjB,mBAAmB,EAAA;EAxB3B;IA4BQ,qBAAqB;IACrB,UAAU,EAAA;EA7BlB;IAiCY,4DAA4D,EAAA;EAjCxE;IAqCQ,cAAc;IACd,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,gBAAgB,EAAA;IAzCxB;MA4CY,cAAc;MACd,WAAW,EAAA;MA7CvB;QAgDgB,WAAW;QACX,wCzIw6B4E;QyIv6B5E,gBAAgB;QAChB,0BAA0B,EAAA;QAnD1C;UAuDoB,WAAW;UACX,eAAe;UACf,eAAe,EAAA;UAzDnC;YA4DwB,eAAe;YACf,kBAAkB,EAAA;IA7D1C;MAoEY,mDAAgE;MAChE,sBzI4kBwB,EAAA;EyIjpBpC;IA0EQ,kBAAkB;IAClB,qBAAqB,EAAA;IA3E7B;MA6EY,YAAY;MACZ,cAAc,EAAA;EA9E1B;IAmFQ,2BAA2B,EAAA;EAnFnC;IAuFQ,6CAA6C,EAAA;EAvFrD;;IA4FQ,gBAAgB;IAChB,6BAA6B;IAC7B,4BAA4B,EAAA;EA9FpC;IAkGQ,cAAc,EAAA;EAlGtB;IAsGQ,YAAY;IACZ,4CzIsiB0E,EAAA;EyI7oBlF;IA2GQ,YAAY,EAAA;EA3GpB;IAgHQ,kBAAkB;IAClB,cAAc;IACd,oBAAoB;IACpB,yBAAyB;IACzB,WAAW;IACX,SAAS;IACT,QAAQ;IACR,UAAU,EAAA;EAvHlB;IA8HM,UAAU;IACV,WAAW,EAAA;EA/HjB;IAoIM,SAAS;IACT,UAAU,EAAA;EArIhB;IAyIQ,iBAAiB;IACjB,cAAc,EAAA;EA1ItB;IA6IQ,iBAAiB;IACjB,cAAc,EAAA;EA9ItB;IAmJQ,YAAY,EAAA;EAnJpB;IAsJQ,4BAA4B,EAAA;EAtJpC;IAyJQ,yBzIZO,EAAA;EyI7If;IA8JQ,SAAS,EAAA;EA9JjB;IAiKQ,yBAAyB,EAAA;EAjKjC;IAoKQ,sBzIvBO,EAAA;EyI7If;IAuKQ,UAAU,EAAA;;AAIlB;EACI,kBAAkB;EAClB,qBAAqB,EAAA;;AAGzB;EACI,aAAa;EACb,yBzIRgB;EyIShB,8BAA8B,EAAA;EAHlC;IAMQ,uBAAuB;IACvB,+BzI1CO;IyI2CP,8BzI3CO;IyI4CP,YAAY;IACZ,cAAc;IACd,kBAAkB;IAClB,kBAAkB;IAClB,yBAAiB;YAAjB,iBAAiB;IACjB,gBAAgB;IAChB,SAAO,EAAA;EAff;;IAoBQ,qBAAqB;IACrB,eAAe;IACf,kBAAkB;IAClB,MAAM;IACN,YAAY;IACZ,aAAa;IACb,UAAU;IACV,+BzI9DO;IyI+DP,8BzI/DO;IyIoFL;2BpJm+sDiB;IoJj+sDnB;yBpJm+sDiB;IoJr9sDf;2BpJu9sDiB;IoJr9sDnB;yBpJu9sDiB,EoJt9sDC;IApE1B;;MA+BU,aAAa,EAAA;IA/BvB;;MAmCY,kBAAkB,EAAA;IAnC9B;;MAuCY;qCpJ6/sDyB;MoJ3/sDzB;mBpJ6/sDO;MoJ3/sDL,OAAO;MACT;mCpJ6/sDuB;MoJ3/sDvB;mBpJ6/sDO,EoJ5/sDC;IA/CpB;;MAuDY;qCpJw/sDyB;MoJt/sDzB;mBpJw/sDO;MoJt/sDL,QAAQ;MACV;mCpJw/sDuB;MoJt/sDvB;mBpJw/sDO,EoJv/sDC;IA/DpB;;MAuEY,cAAc,EAAA;MAvE1B;;QA0EgB,8BzI7GD,EAAA;IyImCf;;MA+EY,WAAW;MACX,YAAY,EAAA;MAhFxB;;QAmFgB,qBAAqB;QACrB,aAAa,EAAA;;AAM7B;EACI,kBAAkB;EAClB,YAAY,EAAA;EAFhB;;IAMQ,qBAAqB,EAAA;EAN7B;IAUQ,WAAW,EAAA;IAVnB;MAaY,aAAa,EAAA;IAbzB;MAkBY,SAAS;MACT,wBAAwB,EAAA;EAnBpC;IAwBQ,kBAAkB;IAClB,QAAQ;IACR,WAAW;IACX,oBAAoB;IACpB,WAAW;IACX,gBAAgB;IAChB,UAAU;IACV,eAAe;IACf,gDAAyE;IACzE,sBAAsB,EAAA;IAjC9B;MAoCY,8BAA2B,EAAA;IApCvC;MAwCY,8BAA2B,EAAA;IAxCvC;MA4CY,cAAc;MACd,WAAW;MACX,kBAAkB,EAAA;IA9C9B;MAkDY,MAAM;MACN,gBAAgB,EAAA;MAnD5B;QAsDgB,kCAAkC;QAClC,mCAAmC;QACnC,8CAA2C;QAC3C,QAAQ,EAAA;IAzDxB;MA8DY,QAAQ,EAAA;MA9DpB;QAiEgB,kCAAkC;QAClC,mCAAmC;QACnC,2CAAwC;QACxC,QAAQ,EAAA;IApExB;MAyEY,cAAc;MACd,YAAY,EAAA;MA1ExB;QA6EgB,wBAAqB,EAAA;EA7ErC;IAoFQ,+BAA4B,EAAA;IApFpC;MAsFY,UAAU,EAAA;;AAKtB;EACI,eAAe;EACf,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,qBAAqB;EACrB,cAAc;EACd,YAAY;EACZ,qBAAqB;EACrB,kBAAkB;EAClB,qCAAqC,EAAA;EAbzC;IAgBQ,oBAAoB;IACpB,gBAAgB;IAChB,cAAc;IACd,qBAAqB;IACrB,kBAAkB;IAClB,UAAU,EAAA;IArBlB;MAwBY,+BAA4B,EAAA;EAxBxC;IA6BQ,UAAU;IACV,YAAY;IACZ,qBAAqB,EAAA;EA/B7B;IAoCY,uCAAoC,EAAA;EApChD;IAuCY,oCAAiC,EAAA;EAvC7C;IA4CQ,uBAAuB;IACvB,sBAAsB;IACtB,cAAc;IACd,YAAY;IACZ,oBAAoB;IACpB,SAAS;IACT,qBAAqB;IACrB,kBAAkB;IAClB,oBAAoB;IACpB,gBzIpSkB;IyIqSlB,oBAAoB;IACpB,YAAY;IACZ,SAAS;IACT,gBAAgB;IAChB,uBAAuB;IACvB,qBAAqB,EAAA;IA3D7B;MA8DY,UAAU,EAAA;IA9DtB;MAmEY,eAAe;MACf,+BzI5RG;MyI6RH,uBAAuB;MACvB,oBAAoB,EAAA;EAtEhC;IA2EQ,oBAAoB;IACpB,uBAAuB;IACvB,YAAY;IACZ,gBAAgB;IAChB,sBAAsB;IACtB,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,oBAAoB;IACpB,gBzInUkB;IyIoUlB,YAAY;IACZ,oBAAoB;IACpB,kBAAkB;IAClB,aAAa;IACb,oBAAoB;IACpB,kBAAkB;IAClB,uBAAuB;IACvB,WAAW,EAAA;IA5FnB;MAgGY,aAAa,EAAA;IAhGzB;MAoGY,6BAA6B,EAAA;IApGzC;MAwGY,6BAA6B;MAC7B,aAAa;MACb,UAAU;MACV,yBzIzTG,EAAA;;AyI+Tf;EACI,yBzI7SgB;EyI8ShB,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,+CzI+K8E,EAAA;EyIvLlF;IAUQ,aAAa;IACb,SAAO,EAAA;;AAIf;EACI,eAAe;EACf,cAAc;EACd,uBAAuB;EACvB,WzI5VW;EyI6VX,cAAc;EACd,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,SAAO;EACP,gBzI1XoB,EAAA;;AyI6XxB;;EAEI,kBAAkB,EAAA;;AAEtB;EACI,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,gBAAgB,EAAA;EALpB;IAOQ,UAAU,EAAA;;AAIlB;EACI,UAAU;EACV,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,oBAAoB;EACpB,sBAAsB;EACtB,qBAAqB;EACrB,aAAa;EACb,eAAe;EACf,6BAA6B;EAC7B,qCAAqC;EACrC,UAAU,EAAA;EAbd;IAeQ,4BAA4B,EAAA;;AAIpC;EACI,gBAAgB;EAChB,6BAA6B;EAC7B,oBAAoB;EACpB,sBAAsB;EACtB,2BAAuD;EACvD,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,SAAS;EACT,qBAAqB;EACrB,kBAAkB;EAClB,uBAAuB;EACvB,kBAAkB,EAAA;EAjBtB;IAqBQ,gDAA2E,EAAA;EArBnF;IAoCQ,eAAe;IACf,UAAU;IACV,iCAAwD;IACxD,6BAAoD,EAAA;EAvC5D;IA2CQ,qBzIrZY;IyIsZZ,yCzItZY;IyIuZZ,gBzI2F0B,EAAA;IyIxIlC;MAiDY,qBzI3ZQ;MyI4ZR,0CzI5ZQ;MyI6ZR,qBAA2C,EAAA;EAnDvD;IAyEQ,mBzInbY;IyIobZ,gBzI8D0B;IyI7D1B,WzIldO;IyImdP,qBzItbY,EAAA;EyI0WpB;IAmFY,4BAA4B,EAAA;IAnFxC;MAqFgB,6BzI/bI,EAAA;IyI0WpB;MAyFgB,mBAAmB,EAAA;EAzFnC;IAkGY,4BAA4B,EAAA;EAlGxC;IAuGQ,gBAAgB;IAChB,6DAA2G,EAAA;EAxGnH;IAkHQ,0CAAyE;IACzE,uBAAuB;IACvB,yBAAyB;IACzB,eAAe,EAAA;EArHvB;IA0HQ,mBAAmB;IACnB,0CAAyE,EAAA;EA3HjF;IA+HQ,gBAAgB;IAChB,6CzI1eY,EAAA;EyI0WpB;IAoIQ,kBAAkB,EAAA;;AAI1B;EACI,eAAe,EAAA;;AAGnB;EACI,WAAW,EAAA;EADf;IAGQ,eAAe;IACf,2BAA2B,EAAA;EAJnC;IAQQ,WAAW;IACX,WAAW;IACX,iBAAiB,EAAA;EAVzB;IAgBY,cAAc;IACd,WAAW;IACX,eAAe;IACf,oCAA6D;IAC7D,uBAAuB;IACvB,eAAe;IACf,YAAY,EAAA;;AAMxB;EACI,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,gBAAgB,EAAA;;AAGpB;EACI,qBAAqB;EACrB,UAAU;EACV,sBAAsB,EAAA;;AAG1B;EACI,kBAAkB;EAClB,UAAU;EACV,cAAc;EACd,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,gBAAgB;EAChB,aAAa,EAAA;EATjB;IAYQ,WAAW;IACX,cAAc;IACd,WAAW,EAAA;EAdnB;IAiBQ,SAAO;IACP,UAAU;IACV,YAAY;IACZ,WAAW,EAAA;IApBnB;MAwBoB,2CzIpF8D,EAAA;EyI4DlF;IA+BQ,UAAU,EAAA;EA/BlB;IAmCQ,UAAU,EAAA;EAnClB;IAwCQ,uBAAuB;IACvB,gBAAgB;IAChB,SAAS;IACT,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,eAAe;IACf,oBAAoB;IACpB,2BAAuD;IACvD,eAAe;IACf,kBAAkB;IAClB,sBAAsB;IACtB,qBAAqB,EAAA;IArD7B;MAwDY,iBAAiB,EAAA;IAxD7B;MA6DU,gBAAgB,EAAA;IA7D1B;MAiEY,UAAU;MACV,SAAS,EAAA;EAlErB;;IAyEQ,eAAe;IACf,WAAW;IACX,oBAAoB;IACpB,2BAAuD;IACvD,iBAAiB;IACjB,SAAS;IACT,yBAAiB;YAAjB,iBAAiB;IACjB,kBAAkB,EAAA;EAhF1B;IAoFQ,UAAU;IACV,UAAU;IACV,eAAe;IACf,kBAAkB;IAClB,gBAAgB,EAAA;EAxFxB;IA6FY,oCzI5nBQ,EAAA;;AyIioBpB;;;;;EAKQ,6BAA6B,EAAA;;AAIrC;EACI,eAAe;EACf,oCzI8JgF,EAAA;;AXkpsDpF;EoJ5ysDI,aAAa,EAAA;;AAGjB;EACI;IACI,UAAU;IACV,mCAAmC,EAAA;EAEvC;IACI,UAAU;IACV,+BAA+B,EAAA,EAAA;;ApJ6ysDvC;;EoJvysDI,aAAa,EAAA;;ACz0BjB;EAEQ,oB1IiGY;E0IhGZ,kBAAkB;EAClB,UAAU;EACV,WAAW,EAAA;;AALnB;EAQQ,OAAO;EACP,6BAA6B;EAC7B,c1I2IU,EAAA;;A0IvIlB;EACI,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW;EACX,aAAa,EAAA;EAEb;IARJ;MASQ,aAAa,EAAA,EAEpB;;AAED;EACI,0DAAqD;EACrD,2BAA2B;EAC3B,sBAAsB,EAAA;EAH1B;IAMQ,uDAAqE;IACrE,YAAY,EAAA;EAPpB;IAWQ,kBAAkB;IAClB,SAAS;IACT,QAAQ;IACR,OAAO;IACP,UAAU;IACV,oBAAoB,EAAA;IAhB5B;MAkBY,WAAW;MACX,YAAY;MACZ,uBAAgD,EAAA;;AAO5D;EAGY,gBAAgB,EAAA;;AAK5B;EACI,kBAAkB,EAAA;;AAKtB;EACI,kBAAkB,EAAA;EADtB;IAGQ,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,WAAW;IACX,OAAO;IACP,QAAQ;IACR,6C1I+jB0E;I0I9jB1E,SAAS,EAAA;EAVjB;IAcQ,qBAAqB;IACrB,kBAAkB;IAClB,UAAU;IACV,mC1I0xCsE;I0IzxCtE,iBAAiB,EAAA;;AAMzB;EACI,yDAA2D,EAAA;EAD/D;IAIQ,0DAAuD;IACvD,2BAA2B;IAC3B,sBAAsB;IACtB,UAAU;IACV,6BAA6B,EAAA;EARrC;IAYQ,+B1IoCO,EAAA;;A0I/Bf;EACI,aAAa,EAAA;EADjB;IAIQ,kBAAkB,EAAA;IAJ1B;MAOY,c1I4DQ,EAAA;M0InEpB;QAUgB,kBAAkB;QAClB,UAAU;QACV,YAAS,EAAI;IAZ7B;MAiBY,c1I+CQ,EAAA;M0IhEpB;QAoBgB,kBAAkB;QAClB,UAAU;QACV,YAAS,EAAI;;ACpI7B;EACI,2BAA2B,EAAA;;AAM/B;EACI,kBAAkB,EAAA;EADtB;IAGQ,6BAA6B;IAC7B,qBAAqB;IACrB,qBAAqB;IACrB,qBAAqB;IACrB,YAAY;IACZ,6BAA6B,EAAA;IARrC;MAWY,yBAA2B;MAC3B,wBAA0B,EAAA;IAZtC;MAeY,aAAa,EAAA;EAfzB;IAmBQ,2BAA2B,EAAA;IAnBnC;MAqBY,eAAe;MACf,WAAW;MACX,OAAO,EAAA;IAvBnB;MA0BY,wC3I4mBsE;M2I3mBtE,kBAAkB;MAClB,YAAY,EAAA;IA5BxB;MA+BY,iCAAwD;MACxD,YAAY,EAAA;MAhCxB;QAkCgB,qBAA2C,EAAA;IAlC3D;MAuCgB,sBAAwB;MACxB,yB3IkII;M2IjIJ,gCAAiC,EAAA;MAzCjD;QA2CoB,yBAA0B;QAC1B,oDAAgD,EAAA;IA5CpE;MAgDgB,oCAAqC;MACrC,gCAAiC;MACjC,W3IoFD,EAAA;I2ItIf;MAsDY,YAAY;MACZ,iBAAiB,EAAA;EAvD7B;IA4DQ,uBAAuB,EAAA;;AAI/B;EAEQ,8C3IokB0E,EAAA;E2ItkBlF;IAIY,WAAW,EAAA;EAEf;IANR;MAQgB,iBAAiB,EAAA;IARjC;MAWgB,8C3I2jBkE,EAAA,E2I1jBrE;EAEL;IAdR;MAeY,iBAAiB;MACjB,+C3IsjBsE,EAAA,E2IpjB7E;;AAIL;EACI;IAEQ,WAAW,EAAA,EACd;;AAIT;EACI,2BAA2B,EAAA;;ACtG/B;EACI,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,cAAc,EAAA;EAJlB;IAOQ,WAAW;IACX,kBAAkB;IAClB,UAAU;IACV,6B5IyHqD;I4IxHrD,SAAS;IACT,aAAa;IACb,SAAS;IACT,mBAAmB,EAAA;;AAI3B;EACI,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,UAAU,EAAA;EAJd;IAOQ,kBAAkB;IAClB,oBAAoB;IACpB,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,SAAS;IACT,YAAY;IACZ,cAAc;IACd,6B5I60CsE;I4I50CtE,wC5IymB0E;I4IxmB1E,mBAAmB;IACnB,c5I2IY;I4I1IZ,UAAU,EAAA;EArBlB;IAyBQ,kBAAkB;IAClB,qBAAqB;IACrB,wBAAwB;IACxB,SAAS;IACT,eAAe;IACf,gBAAgB;IAChB,kBAAkB,EAAA;EA/B1B;IAmCQ,aAAa;IACb,6B5I0zCsE;I4IzzCtE,kBAAkB;IAClB,wC5IqlB0E;I4IplB1E,sB5IwlB4B;I4IvlB5B,mD5I6FO,EAAA;E4IrIf;IA4CQ,OAAO,EAAA;IA5Cf;MA+CY,uBAAuB;MACvB,iBAAiB,EAAA;EAhD7B;IAqDQ,SAAS,EAAA;IArDjB;MAwDY,WAAW,EAAA;IAxDvB;MA4DY,wBAAwB;MACxB,eAAe,EAAA;IA7D3B;MAiEY,UAAU;MACV,sD5IyDG,EAAA;;A4IpDf;EAzFA;IA4FY,WAAW;IACX,aAAa,EAAA;EA3EzB;IAgFQ,WAAW;IACX,mBAAmB;IACnB,kBAAkB,EAAA;IAHtB;MAMQ,QAAQ,EAAA;MANhB;QASY,WAAW;QACX,YAAY;QACZ,WAAW;QACX,eAAe;QACf,UAAU,EAAA;MAbtB;QAiBY,WAAW;QACX,wE5I0hBkE,EAAA;M4I5iB9E;QAsBY,WAAW;QACX,SAAS;QACT,WAAW,EAAA,EACd;;AAKb;EACI,kBAAkB,EAAA;EADtB;IAIQ,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,WAAW;IACX,SAAS;IACT,UAAU;IACV,iBAAiB;IACjB,6B5IPqD,EAAA;E4IJ7D;IAeQ,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,UAAU,EAAA;IAlBlB;MAqBY,oBAAoB;MACpB,WAAW;MACX,YAAY;MACZ,SAAS;MACT,kBAAkB;MAClB,6B5ItBiD;M4IuBjD,mBAAmB;MACnB,yBAAyB;MACzB,mBAAmB;MACnB,uBAAuB;MACvB,kBAAkB,EAAA;MA/B9B;QAiCgB,oBAAoB;QACpB,qBAAqB;QACrB,4BAA4B;QAC5B,gBAAgB;QAChB,uBAAuB,EAAA;EArCvC;IA2CQ,eAAe;IACf,gB5ItDgB;I4IuDhB,kBAAkB;IAClB,iBAAiB,EAAA;IA9CzB;MAiDY,WAAW;MACX,cAAc;MACd,kBAAkB;MAClB,WAAW;MACX,YAAY;MACZ,SAAS;MACT,UAAU;MACV,iBAAiB;MACjB,mB5IPQ;M4IQR,mC5ItDiD;M4IuDjD,mBAAmB;MACnB,UAAU,EAAA;EA5DtB;IAiEQ,kBAAkB;IAClB,qBAAqB;IACrB,iBAAiB;IACjB,aAAa;IACb,wC5Iyc0E;I4Ixc1E,kBAAkB;IAClB,6B5I0qCsE;I4IzqCtE,gBAAgB,EAAA;IAxExB;MA2EY,WAAW;MACX,cAAc;MACd,kBAAkB;MAClB,QAAQ;MACR,SAAS;MACT,mBAAmB;MACnB,SAAS;MACT,WAAW;MACX,mEAA0D;MAC1D,kBAAkB,EAAA;IApF9B;MAwFY,WAAW;MACX,cAAc;MACd,kBAAkB;MAClB,QAAQ;MACR,SAAS;MACT,mBAAmB;MACnB,WAAW;MACX,SAAS;MACT,wEAA+D;MAC/D,kBAAkB,EAAA;IAjG9B;MAqGY,kBAAkB;MAClB,WAAW,EAAA;EAtGvB;IA2GQ,kBAAkB;IAClB,qBAAqB;IACrB,wC5Iia0E;I4Iha1E,kBAAkB;IAClB,gB5IjGO;I4IkGP,WAAW;IACX,gBAAgB;IAChB,UAAU;IACV,YAAY;IACZ,gBAAgB;IAChB,uBAAuB,EAAA;IArH/B;MAwHY,cAAc,EAAA;MAxH1B;QA2HgB,UAAU;QACV,gBAAgB;QAChB,UAAU;QACV,wEAA+D,EAAA;MA9H/E;QAkIgB,UAAU;QACV,gBAAgB;QAChB,UAAU;QACV,mEAA0D;QAC1D,kBAAkB;QAClB,UAAU,EAAA;;AAQ1B;EACI,kBAAkB;EAClB,WAAW;EACX,cAAc,EAAA;EAHlB;IAMQ,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,UAAU;IACV,OAAO;IACP,WAAW;IACX,mC5IvJqD,EAAA;E4I2I7D;IAiBY,qBAAqB;IACrB,6BAA6B;IAC7B,gBAAgB,EAAA;IAnB5B;MAsBgB,WAAW;MACX,kBAAkB;MAClB,SAAS;MACT,UAAU;MACV,gBAAgB;MAChB,mB5I/HI;M4IgIJ,WAAW;MACX,YAAY;MACZ,UAAU;MACV,mBAAmB;MACnB,mC5I3K6C,EAAA;E4I2I7D;IAqCY,iBAAiB;IACjB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,kBAAkB;IAClB,mC5IrLiD,EAAA;I4I2I7D;MA6CgB,WAAW;MACX,cAAc;MACd,kBAAkB;MAClB,QAAQ;MACR,SAAS;MACT,mBAAmB;MACnB,SAAS;MACT,UAAU;MACV,mEAAiE;MACjE,kBAAkB;MAClB,QAAQ;MACR,cAAc,EAAA;EAxD9B;IA6DY,kBAAkB;IAClB,UAAU;IACV,UAAU;IACV,SAAS;IACT,gBAAgB,EAAA;EAjE5B;IAqEY,eAAe;IACf,0BAA0B,EAAA;IAtEtC;MAyEgB,yBAAyB,EAAA;MAzEzC;QA4EoB,aAAa;QACb,SAAS;QACT,mEAAiE,EAAA;IA9ErF;MAmFgB,yBAAyB,EAAA;EAnFzC;;IA0FQ,YAAY;IACZ,WAAW;IACX,iBAAiB;IACjB,kBAAkB;IAClB,yBAAyC,EAAA;IA9FjD;;MAiGY,eAAe;MACf,W5InOG,EAAA;I4IiIf;;MAqGY,yC5IzMQ;M4I0MR,UAAU;MACV,YAAY;MACZ,mCAA2B;cAA3B,2BAA2B;MAC3B,oBACJ,EAAA;EA1GR;IA8GQ,QAAQ,EAAA;IA9GhB;MAiHY,gBAAgB;MAChB,sBAAsB,EAAA;EAlHlC;IAuHQ,OAAO,EAAA;IAvHf;MA0HY,gBAAgB;MAChB,sBAAsB,EAAA;;AAOlC;EACI,kBAAkB;EAClB,gBAAgB,EAAA;EAFpB;IAKQ,kBAAkB,EAAA;IAL1B;MAQY,UAAU,EAAA;IARtB;MAYY,mCAA4D;MAC5D,mCAA4D;MAC5D,YAAY;MACZ,WAAW,EAAA;IAfvB;MAmBY,WAAW;MACX,kBAAkB;MAClB,8C5IwOsE;M4IvOtE,UAAU;MACV,YAAY;MACZ,QAAQ;MACR,UAAU,EAAA;IAzBtB;MA6Be,yBAAyB,EAAA;;AC7axC;EAEQ,kBAAkB;EAClB,eAAe,EAAA;EAHvB;IAMY,cAAc;IACd,2BAAuD;IACvD,gB7I8Gc;I6I7Gd,iBAAiB;IACjB,WAAW;IACX,eAAe,EAAA;;AAK3B;EACI,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;EACnB,gBAAgB;EAChB,6BAA6B;EAC7B,YAAY,EAAA;EAPhB;IAUQ,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,MAAM;IACN,WAAW;IACX,SAAS;IACT,mC7I+0CsE;I6I90CtE,oBAAoB,EAAA;EAlB5B;IAsBQ,kBAAkB;IAClB,gBAAgB;IAChB,kBAAkB,EAAA;IAxB1B;MA2BY,cAAc,EAAA;IA3B1B;MA+BY,kBAAkB;MAClB,QAAQ;MACR,SAAS;MACT,WAAW;MACX,UAAU;MACV,UAAU;MACV,wGAAuG;MACvG,kBAAkB;MAClB,gBAAgB;MAChB,mCAAmC;MACnC,aAAa;MACb,WAAW;MACX,qBAAqB;MACrB,aAAa,EAAA;MA5CzB;QA+CgB,W7I8ED;Q6I7EC,SAAS;QACT,eAAe,EAAA;EAjD/B;IAuDQ,gCAAgC,EAAA;EAvDxC;IA2DQ,kBAAkB,EAAA;IA3D1B;MA8DY,eAAe;MACf,kBAAkB;MAClB,aAAa,EAAA;IAhEzB;MAoEY,SAAS;MACT,oBAAoB;MACpB,c7I6DM,EAAA;E6InIlB;IA4EY,YAAY,EAAA;EA5ExB;IAgFY,SAAS,EAAA;IAhFrB;MAmFgB,UAAU,EAAA;EAnF1B;IAwFY,UAAU;IACV,mBAAmB,EAAA;;AAK/B;EAGY,iCAAwD,EAAA;;ACjHpE;EACI,gBAAgB,EAAA;;AAGpB;EAEQ,gBAAgB,EAAA;;AAFxB;EAMQ,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,QAAQ;EACR,cAAc,EAAA;;AAGlB;EAbJ;IAeY,gBAAgB,EAAA;EAf5B;IAmBY,qBAAqB;IACrB,SAAS,EAAA,EACZ;;AAGL;EAxBJ;IA0BY,eAAe;IACf,gBAAgB,EAAA;EA3B5B;IA+BY,kBAAkB;IAClB,QAAQ,EAAA,EACX;;AAKT;EACI;IACI,yBAAyB,EAAA;EAG7B;IACI,yCAAyC,EAAA;EAG7C;IACI,uCAAuC,EAAA;EAG3C;IACI,yCAAyC,EAAA;EAG7C;IACI,uCAAuC,EAAA;EAG3C;IACI,wCAAwC,EAAA;EAG5C;IACI,yBAAyB,EAAA,EAAA;;AAIjC;EACI,sCAAsC,EAAA;;ACzE1C;EACI,4C/IgLgB,EAAA;E+I9KhB;IAHJ;MAIQ,gBAAgB,EAAA,EAEvB;;AAKD;EACI,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,MAAM;EACN,aAAa,EAAA;EACb;IANJ;MAOQ,aAAa,EAAA,EAqBpB;EA5BD;IAWQ,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,MAAM;IACN,SAAS;IACT,YAAY;IACZ,mB/I6IY;I+I5IZ,qDAAoE,EAAA;EAnB5E;IAwBQ,WAAW;IACX,YAAY;IACZ,iBAAiB,EAAA;;AAIzB;EAGY,+B/IiGG,EAAA;E+IpGf;IAMgB,0C/I8FD,EAAA;;A+IxFf;EACI,wC/IulB8E;E+ItlB9E,6C/IslB8E,EAAA;;A+IjlB9E;EAEQ,0B/I4GQ,EAAA;;A+I9GhB;EAEQ,0B/I8GQ,EAAA;;A+IhHhB;EAEQ,0B/ImHQ,EAAA;;A+IrHhB;EAEQ,0B/IqHQ,EAAA;;A+IvHhB;EAEQ,0B/IkHQ,EAAA;;A+IpHhB;EAEQ,0B/IgHQ,EAAA;;A+IlHhB;EAEQ,0B/IgFM,EAAA;;A+IlFd;EAEQ,0B/IwFM,EAAA;;A+InFlB;EACI,kBAAkB,EAAA;EADtB;IAIQ,WAAW;IACX,aAAa;IACb,iBAAiB,EAAA;IAEjB;MARR;QASY,aAAa,EAAA,EAEpB;EAXL;IAcQ,aAAa,EAAA;EAdrB;IAkBQ,eAAe,EAAA;;AAIvB;EACI,kBAAkB;EAClB,qBAAqB,EAAA;EAFzB;IAKQ,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,SAAS;IACT,eAAe,EAAA;EATvB;IAaQ,iBAAiB,EAAA;EAbzB;IAiBQ,aAAa,EAAA;;AAIrB;EAEQ,kBAAkB,EAAA;EAF1B;IAKY,6BAA6B,EAAA;IALzC;MAQgB,gBAAgB,EAAA;EARhC;IAaY,WAAW;IACX,8C/IihBsE;I+IhhBtE,kBAAkB;IAClB,YAAY;IACZ,UAAU,EAAA;EAjBtB;IAsBgB,QAAQ,EAAA;EAtBxB;IA4BgB,YAAY;IACZ,QAAQ,EAAA;;AAMxB;EACI,kBAAkB;EAClB,aAAa,EAAA;EAFjB;IAKQ,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,QAAQ,EAAA;EARhB;IAYQ,WAAW;IACX,aAAa;IACb,iBAAiB,EAAA;IAEjB;MAhBR;QAiBY,aAAa,EAAA,EAEpB;EAnBL;IAsBQ,aAAa,EAAA;EAtBrB;IA0BQ,eAAe,EAAA;;AAIvB;E1J0qvDE;I0JtqvDU,wBAAwB,EAAA,EAC3B;;ACpLT;EACI,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,eAAe,EAAA;EAJnB;IAOQ,kBAAkB,EAAA;;AAI1B;EACI,kBAAkB,EAAA;EADtB;IAIQ,UAAU;IACV,SAAS;IACT,gBAAgB,EAAA;IANxB;MASY,cAAc;MACd,2BAAkD;MAClD,mChJ01CkE;MgJz1ClE,4ChJioB+C;MgJhoB/C,mBhJirB0B;MgJhrB1B,YAAY;MACZ,YAAY;MACZ,aAAa;MACb,uBAAuB;MACvB,mBAAmB,EAAA;MAlB/B;QAqBgB,oBAAoB;QACpB,qBAAqB;QACrB,4BAA4B;QAC5B,gBAAgB;QAChB,uBAAuB,EAAA;;AAMvC;EAIgB,UAAU;EACV,uBAAuB;EACvB,kBAAkB,EAAA;;AANlC;EAYQ,kBAAkB;EAClB,WAAW,EAAA;EAbnB;IAgBY,WAAW;IACX,cAAc;IACd,QAAQ;IACR,aAAa;IACb,8ChJ+kBsE;IgJ9kBtE,YAAY;IACZ,kBAAkB,EAAA;EAtB9B;IA2BgB,aAAa;IACb,YAAY;IACZ,wBAAwB;IACxB,iBAAiB;IACjB,gDhJokBkE;IgJnkBlE,UAAU;IACV,YAAY;IACZ,YAAY;IACZ,8ChJgkBkE,EAAA;IgJnmBlF;MAsCoB,WAAW;MACX,UAAU,EAAA;;AAM1B;EA7CJ;IAiDoB,UAAU;IACV,UAAU;IACV,iBAAiB,EAAA;EAnDrC;IAwDgB,WAAW,EAAA,EACd;;AAKb;EACI,WAAW,EAAA;EADf;IAKY,aAAa;IACb,YAAY;IACZ,wBAAwB;IACxB,iBAAiB;IACjB,gDhJ4hBsE;IgJ3hBtE,UAAU;IACV,WAAW;IACX,SAAS,EAAA;IAZrB;MAegB,WAAW;MACX,WAAW,EAAA;EAhB3B;IAqBY,cAAc;IACd,WAAW,EAAA;IAtBvB;MA0BoB,YAAY,EAAA;EA1BhC;IAiCQ,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,6ChJ+f0E;IgJ9f1E,+ChJ8f0E;IgJ7f1E,8ChJ6f0E;IgJ5f1E,cAAc;IACd,UAAU;IACV,UACJ,EAAA;EAEA;IA9CJ;MAiDgB,UAAU;MACV,SAAS;MACT,gBAAgB,EAAA;IAnDhC;MAwDY,kBAAkB;MAClB,OAAO;MACP,UAAU,EAAA,EACb;;AAIT;EACI,8ChJqe8E;EgJpe9E,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,aAAa,EAAA;EALjB;IAQQ,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,QAAQ;IACR,YAAY;IACZ,8ChJyd0E;IgJxd1E,UAAU;IACV,UAAU;IACV,SAAS;IACT,iBAAiB,EAAA;EAjBzB;IAqBQ,sBAAsB;IACtB,UAAU,EAAA;EAtBlB;IA0BQ,eAAe;IACf,kBAAkB,EAAA;IA3B1B;MA8BY,kBAAkB;MAClB,gDhJucsE;MgJtctE,YAAY,EAAA;MAhCxB;QAmCgB,6BhJsqC8D;QgJrqC9D,gBAAgB;QAChB,kBAAkB;QAClB,UAAU;QACV,UAAU;QACV,YAAY;QACZ,sBAAsB;QACtB,WAAW;QACX,kBAAkB,EAAA;EA3ClC;IAiDQ,cAAc;IACd,WAAW,EAAA;EAGf;IArDJ;MAuDY,YAAY,EAAA,EACf;EAGL;IA3DJ;MA4DQ,WAAW;MACX,WAAW;MACX,cAAc,EAAA;MA9DtB;QAiEY,WAAW;QACX,cAAc;QACd,kBAAkB;QAClB,QAAQ;QACR,YAAY;QACZ,4BhJhGG;QgJiGH,UAAU;QACV,UAAU;QACV,QAAQ;QACR,iBAAiB,EAAA;MA1E7B;QA+EgB,aAAa,EAAA,EAChB;;AASb;EAEQ,UAAU;EACV,iBAAiB;EACjB,kBAAkB,EAAA;EAJ1B;IAMY,kBAAkB,EAAA;EAEtB;IARR;MASY,gBAAgB,EAAA;MAT5B;QAYoB,eAAe,EAAA;QAZnC;UAcwB,aAAa,EAAA;MAdrC;QAmBoB,aAAa,EAAA,EAChB;;AAMb;EA1BJ;IA4BY,kBAAkB,EAAA;IA5B9B;MA8BgB,WAAW;MACX,WAAW;MACX,+ChJ6WkE;MgJ5WlE,kBAAkB;MAClB,SAAS;MACT,OAAO,EAAA;IAnCvB;MAsCgB,iBAAiB,EAAA;MAtCjC;;QAyCoB,kBAAkB,EAAA;QAzCtC;;UA4CwB,WAAW;UACX,WAAW;UACX,+ChJ+V0D;UgJ9V1D,kBAAkB;UAClB,QAAQ;UACR,SAAS,EAAA;MAjDjC;QAsDwB,WAAW,EAAA;MAtDnC;QA0DoB,kBAAkB;QAClB,0BAA0B,EAAA;QA3D9C;UA8DwB,WAAW;UACX,WAAW;UACX,6ChJ6U0D;UgJ5U1D,kBAAkB;UAClB,QAAQ;UACR,2BAA2B;UAC3B,OAAO,EAAA;MApE/B;QAyEoB,iBAAiB,EAAA,EACpB;;AAIb;EA9EJ;IAgFY,iBAAiB,EAAA;IAhF7B;MAkFgB,iBAAiB,EAAA;MAlFjC;QAqFoB,WAAW;QACX,YAAY;QACZ,QAAQ;QACR,+ChJqT8D;QgJpT9D,kBAAkB;QAClB,MAAM;QACN,OAAO;QACP,QAAQ;QACR,gBAAgB,EAAA;MA7FpC;QAiGoB,WAAW;QACX,WAAW;QACX,6ChJ0S8D;QgJzS9D,kBAAkB;QAClB,MAAM;QACN,SAAS,EAAA;MAtG7B;QA2GwB,aAAa,EAAA;MA3GrC;QAiHwB,WAAW;QACX,YAAY;QACZ,+ChJ0R0D;QgJzR1D,kBAAkB;QAClB,SAAS;QACT,OAAO,EAAA;MAtH/B;QAyHwB,YAAY,EAAA;MAzHpC;QA8HoB,kBAAkB,EAAA;QA9HtC;UAiIwB,WAAW;UACX,YAAY;UACZ,+ChJ0Q0D;UgJzQ1D,kBAAkB;UAClB,SAAS;UACT,SAAS;UACT,cAAc,EAAA,EACjB;;AAxIrB;EA+IQ,2BAAuD;EACvD,gBAAgB;EAChB,cAAc,EAAA;;AAOtB;EAEQ,UAAU,EAAA;EAFlB;IAKY,gBAAgB;IAChB,kBAAkB,EAAA;IAN9B;MASgB,2BAAuD;MACvD,gBAAgB;MAChB,cAAc,EAAA;EAX9B;IAiBgB,eAAe,EAAA;IAjB/B;MAoBoB,aAAa,EAAA;EApBjC;IAyBgB,aAAa,EAAA;;AAzB7B;EAgCY,iBAAiB,EAAA;EAhC7B;IAmCgB,iBAAiB,EAAA;EAnCjC;IAuCgB,kBAAkB,EAAA;IAvClC;MA0CoB,WAAW;MACX,yBAAyB;MACzB,8ChJyM8D;MgJxM9D,kBAAkB;MAClB,MAAM;MACN,OAAO;MACP,gBAAgB,EAAA;IAhDpC;MAqDwB,aAAa,EAAA;EArDrC;IA2DgB,kBAAkB;IAClB,0BAA0B,EAAA;IA5D1C;MA+DoB,WAAW;MACX,WAAW;MACX,6ChJoL8D;MgJnL9D,kBAAkB;MAClB,QAAQ;MACR,2BAA2B;MAC3B,OAAO,EAAA;EArE3B;IA0EgB,WAAW;IACX,YAAY;IACZ,8ChJyKkE;IgJxKlE,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,gBAAgB,EAAA;EAhFhC;IAqFoB,YAAY,EAAA;;AC5ehC;EAEQ,iBAAiB,EAAA;;AAFzB;EAMQ,eAAe,EAAA;;AANvB;EAYgB,wBAAyB;EACzB,yBAA0B,EAAA;;AAM1C;EACI,aAAa;EACb,kBAAkB;EAClB,SAAS,EAAA;;AAGb;EAEQ,aAAa;EACb,kBAAkB;EAClB,qBAAqB,EAAA;EAJ7B;IAOY,aAAa;IACb,WAAW;IACX,iBAAiB,EAAA;EAT7B;IAaY,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,qDAAoE;IACpE,YAAY,EAAA;;AAKxB;EAEQ,mBAAmB,EAAA;EAF3B;IAKY,cAAc;IACd,UAAU,EAAA;EANtB;IAUY,gBAAgB,EAAA;IAV5B;MAagB,kBAAkB,EAAA;MAblC;QAgBoB,WAAW,EAAA;IAhB/B;MAqBgB,cAAc,EAAA;IArB9B;MA0BoB,qBAAqB;MACrB,cAAc,EAAA;IA3BlC;MA+BoB,WjJ6DL,EAAA;IiJ5Ff;MAoCwB,WjJwDT,EAAA;IiJ5Ff;MA0CgB,aAAa;MACb,sBAAsB;MACtB,mBAAmB;MACnB,mBAAmB;MACnB,gBAAgB,EAAA;MA9ChC;QAiDoB,eAAe,EAAA;MAjDnC;QAqDoB,gBAAgB;QAChB,gBAAgB;QAChB,kBAAkB,EAAA;IAvDtC;MA4DgB,WAAW;MACX,gBAAgB,EAAA;EAIxB;IAjER;MAmEgB,cAAc;MACd,aAAa,EAAA,EAChB;EAGL;IAxER;MA0EgB,cAAc;MACd,UAAU,EAAA,EACb;EAGL;IA/ER;MAiFgB,cAAc;MACd,WAAW,EAAA,EACd;;AAnFb;EAwFQ,sBAAsB,EAAA;EAxF9B;IA2FY,mBAAmB,EAAA;IA3F/B;MA8FgB,mBAAmB;MACnB,8BAA8B,EAAA;IA/F9C;MAmGgB,aAAa;MACb,mBAAmB,EAAA;MApGnC;QAuGoB,YAAY;QACZ,WAAW;QACX,eAAe,EAAA;MAzGnC;QA6GoB,iBAAiB,EAAA;IA7GrC;MAkHgB,WAAW;MACX,cAAc;MAEd,QAAQ,EAAA;IArHxB;MAyHgB,cjJAI,EAAA;EiJIZ;IA7HR;MA8HY,mBAAmB,EAAA;MA9H/B;QAkIgB,cAAc;QACd,WAAW,EAAA;MAnI3B;QAwIoB,WAAW;QACX,cAAc;QACd,SAAS;QACT,mBAAmB,EAAA;QA3IvC;UA8IwB,UAAU,EAAA;MA9IlC;QAmJoB,mBAAmB,EAAA;MAnJvC;QAuJoB,WAAW;QACX,gBAAgB,EAAA,EACnB;;AAMjB;EAGY,yBjJhCQ;EiJiCR,WjJvEG,EAAA;;AiJ4Ef;EAEQ,qBAAqB;EACrB,cAAc;EACd,WAAW,EAAA;;AAJnB;EAOQ,WjJnFO,EAAA;;AiJ4Ef;EAYY,WjJxFG,EAAA;;AkJ3If;EACI,kBAAkB;EAClB,aAAa;EACb,SAAS,EAAA;EAHb;IAOQ,UAAU,EAAA;IAPlB;MAWoB,aAAa,EAAA;EAXjC;IAiBQ,eAAe;IACf,gBlJiGgB;IkJhGhB,cAAc;IACd,kBAAkB;IAClB,oCAA8D;IAC9D,yBAAyB,EAAA;EAtBjC;IA0BQ,mClJo1CsE;IkJn1CtE,iBAAiB;IACjB,kBAAkB;IAClB,sBlJknB4B;IkJjnB5B,4ClJwnBmD;IkJvnBnD,gBlJqFkB;IkJpFlB,eAAe,EAAA;IACf;MAjCR;QAkCY,eAAe,EAAA,EAYtB;IA9CL;MAsCY,YAAY;MACZ,eAAe;MACf,kBAAkB;MAClB,YAAY;MACZ,QAAQ;MACR,2BAA2B;MAC3B,qBAA2C,EAAA;;AAMvD;EACI,uCAAuC,EAAA;;AAG3C;EACI;IAAK,wBAAwB,EAAA;EAC7B;IAAO,4BAA4B,EAAA,EAAA;;AAGvC;EACI,gBlJwDsB;EkJvDtB,yBAAyB;EACzB,WlJ6EW;EkJ5EX,4BlJgHgB,EAAA;;AkJ7GpB;EACI,gBAAgB,EAAA;;ACrEpB;EACI,kBAAkB;EAClB,gBAAgB,EAAA;EAFpB;IAKQ,eAAe;IACf,WnJuIO;ImJtIP,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;IAC3B,kBAAkB;IAClB,OAAO;IACP,QAAQ,EAAA;IAZhB;MAeY,eAAe,EAAA;IAGnB;MAlBR;QAmBY,eAAe,EAAA;QAnB3B;UAsBgB,eAAe,EAAA,EAClB;;AAKb;EAEQ,aAAa,EAAA;EAFrB;IAIY,cAAc,EAAA;EAJ1B;IAOY,cAAc,EAAA;EAP1B;IAUY,cAAc,EAAA;;AAK1B;EACI,aAAa;EACb,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,UAAU;EACV,kBAAkB,EAAA;EARtB;IAWQ,iBAAiB;IACjB,eAAe,EAAA;EAZvB;IAgBQ,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,WAAW;IACX,SAAS;IACT,UAAU;IACV,gBAAgB;IAChB,UAAU;IACV,oBAAoB;IACpB,mCAAmC;IACnC,iCAAwD,EAAA;IA1BhE;MA6BY,qBAAqB,EAAA;IA7BjC;MAiCY,qBAAqB,EAAA;;AAKjC;EACI;IACI,UAAU;IACV,mBAAmB,EAAA;EAGvB;IACI,UAAU;IACV,mBAAmB,EAAA,EAAA;;AAI3B;EAEQ,WAAW;EACX,qBAAqB,EAAA;;AC9F7B;EACI,aAAa,EAAA;;AAGjB;EAEQ,UAAU;EACV,YAAY;EACZ,mCpJs2CsE,EAAA;;AoJ12C9E;EAQQ,mCpJk2CsE,EAAA;;AoJ31C1E;EADJ;IAEQ,gBAAgB;IAChB,wBAAoD,EAAA,EAE3D;;AAED;EAGY,wCpJ+mBsE;EoJ9mBtE,sBpJknBwB;EoJjnBxB,eAAe;EACf,eAAe,EAAA;;AAN3B;EAWgB,iCAAwD,EAAA;;AAMxE;EAIgB,cpJiII,EAAA;;AqJjLpB;EAGY,YAAY,EAAA;;AAKxB;EAEQ,YAAW;EACX,mBAAmB;EACnB,eAAe,EAAA;;AAJvB;EAOQ,uBAAuB,EAAA;;AAP/B;EAUQ,WAAW,EAAA;EAVnB;IAYY,QAAQ,EAAA;EAZpB;IAeY,mBAAmB,EAAA;;ACvB/B;EACI,kBAAkB;EAClB,kBAAkB,EAAA;;AAKtB;EACI,2BAA2B;EAC3B,kBAAkB;EAClB,mCtJs2C0E,EAAA;EsJp2C1E;IALJ;MAMQ,gBAAgB;MAChB,gBAAgB;MAChB,uCAAiE,EAAA,EAExE;;AAGD;EACI,SAAS,EAAA;EADb;IAMgB,mDtJoGqE;IsJnGrE,wBtJoGkD,EAAA;IsJ3GlE;MAUoB,8DAA2F;MAC3F,yBAA0B,EAAA;EAX9C;IAiBY,cAAc;IACd,iBAAiB;IACjB,2BAAuD;IACvD,oBAAoB;IACpB,kCtJ9BkD;IsJ+BlD,gBtJ2EY;IsJ1EZ,mBtJ8pB0B,EAAA;EsJrrBtC;IA2BY,eAAe,EAAA;EA3B3B;IA+BY,gBtJmEc,EAAA;EsJlG1B;IAmCY,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;IACX,UAAU;IACV,SAAS,EAAA;IAvCrB;MA0CgB,iBAAiB;MACjB,gBtJuDU;MsJtDV,eAAe,EAAA;;AAM/B;EACI,kBAAkB,EAAA;EADtB;IAIQ,WAAW;IACX,YAAY;IACZ,yBtJsEU;IsJrEV,kBAAkB;IAClB,mCtJkyCsE;IsJjyCtE,kBAAkB;IAClB,QAAQ;IACR,UAAU;IACV,SAAS,EAAA;EAZjB;IAiBY,yBtJ0FQ,EAAA;EsJ3GpB;IAuBY,yBtJmFQ,EAAA;;AsJ9EpB;EACI,+BAA+B,EAAA;EAE/B;IAHJ;MAIQ,2BAA2B,EAAA,EAElC;;AAMD;EACI,oDAAmD;EACnD,oBAAoB;EACpB,kBAAkB;EAClB,mCAA4D,EAAA;EAE5D;IANJ;MAOQ,kBAAkB;MAClB,OAAO;MACP,QAAQ;MACR,WAAW;MACX,wBAAwB;MACxB,kBAAkB;MAClB,2BAA2B;MAC3B,WAAW;MACX,iBAAiB,EAAA;MAfzB;QAkBY,mBAAmB;QACnB,wBAAwB,EAAA,EAC3B;EApBT;IAwBQ,kBAAkB,EAAA;EAxB1B;IA6BY,aAAa,EAAA;EAGb;IAhCZ;MAiCgB,wBAAwB,EAAA,EAE/B;;AAIT;EACI,oCAAoC;EACpC,mCtJytC0E,EAAA;EsJxtC1E;IAHJ;MAIQ,eAAe;MACf,OAAO;MACP,QAAQ;MACR,MAAM;MACN,UAAU,EAAA,EAEjB;;AAGD;EAEQ,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,UAAU;EACV,eAAe;EACf,ctJrBU,EAAA;;AsJuBd;EAVJ;IAWQ,aAAa;IACb,yBAAyB,EAAA,EAEhC;;AAGD;EACI,2BAA2B,EAAA;EAC3B;IAFJ;MAGQ,2BAA2B,EAAA,EAqQlC;EAxQD;IAOQ,aAAa;IACb,sBAAsB,EAAA;IAR9B;MAWY,gBAAgB,EAAA;EAX5B;IAgBQ,iBAAiB;IACjB,gBAAgB,EAAA;IAjBxB;MAmBY,aAAa,EAAA;EAnBzB;IA0BgB,gBAAgB,EAAA;EA1BhC;IAmCgB,aAAa,EAAA;EAnC7B;IAuCY,kBAAkB,EAAA;EAvC9B;IA4CgB,mBAAmB,EAAA;EA5CnC;IAkDQ,kBAAkB,EAAA;IAlD1B;MAqDY,WAAW;MACX,YAAY;MACZ,kBAAkB,EAAA;EAvD9B;IA4DQ,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;IAChB,WAAW,EAAA;IAhEnB;MAmEY,sBtJzGG;MsJ0GH,kBAAkB;MAClB,eAAe;MACf,UAAU;MACV,iBAAiB;MACjB,kBAAkB,EAAA;IAxE9B;MA4EY,WAAW;MACX,kBAAkB;MAClB,WAAW;MACX,WAAW;MACX,OAAO;MACP,QAAQ;MACR,yCtJ3FQ;MsJ4FR,SAAS,EAAA;IAnFrB;MAuFY,eAAe,EAAA;EAvF3B;IA4FQ,mBAAmB;IACnB,oBAAoB;IACpB,kBAAkB;IAClB,qBAAqB;IACrB,cAAc,EAAA;IAEd;MAlGR;QAmGY,cAAc,EAAA,EAmGrB;IAtML;MAuGY,aAAa;MACb,mBAAmB,EAAA;IAxG/B;MA4GY,qBAAqB;MACrB,sBAAsB,EAAA;IA7GlC;MAiHY,kBAAkB;MAClB,oCtJxKwD;MsJyKxD,kBAAkB;MAClB,kBAAkB;MAClB,6CtJkXmD,EAAA;MsJ/W/C;QAxHhB;UA0HwB,aAAa,EAAA;QA1HrC;UA8HwB,cAAc,EAAA,EACjB;IA/HrB;MAqIY,gBtJnMY;MsJoMZ,aAAa;MACb,eAAe;MACf,mBAAmB;MACnB,QAAQ,EAAA;IAzIpB;MA8IgB,eAAe;MACf,YAAY;MACZ,ctJhLE,EAAA;MsJgClB;QAkJoB,aAAa,EAAA;MAGjB;QArJhB;UAsJoB,aAAa,EAAA,EAEpB;IAxJb;MA6JY,eAAe;MACf,eAAe;MACf,iBAAiB,EAAA;IA/J7B;MAmKY,oBAAoB;MACpB,kBAAkB;MAClB,aAAa;MACb,eAAe;MACf,QAAQ,EAAA;MAvKpB;QA0KgB,kBAAkB,EAAA;MA1KlC;QA8KgB,gBAAgB,EAAA;MA9KhC;QAkLgB,kBAAkB;QAClB,WAAW;QACX,UAAU;QACV,YAAY,EAAA;QArL5B;UAyLwB,eAAe;UACf,WtJhOT;UsJiOS,qBAAqB;UACrB,iBAAiB;UACjB,WAAW;UACX,YAAY;UACZ,kBAAkB;UAClB,uCtJ7NN;UsJ8NM,kBAAkB,EAAA;EAjM1C;IAyMQ,yBAAyB,EAAA;IAzMjC;MA4MY,QAAQ;MACR,iBAAiB;MACjB,iBAAiB,EAAA;IA9M7B;MAkNY,gBAAgB;MAChB,ctJnPM,EAAA;IsJgClB;MAuNY,iBAAiB,EAAA;MAvN7B;QA0NgB,yBAAyB,EAAA;QA1NzC;UA6NoB,QAAQ;UACR,mDtJnRiE;UsJoRjE,wBtJnR8C;UsJoR9C,iBAAiB;UACjB,gBtJwQc,EAAA;UsJzelC;YAoOwB,0CtJ1QT;YsJ2QS,4CAA4C;YAC5C,ctJnQN,EAAA;YsJ6BlB;cAyO4B,qCAAqC,EAAA;MAzOjE;QAgPgB,yBAAyB,EAAA;QAhPzC;UAmPoB,QAAQ,EAAA;QAnP5B;UAuPoB,QAAQ,EAAA;QAvP5B;UA2PoB,QAAQ,EAAA;MA3P5B;QAgQgB,QAAQ,EAAA;IAhQxB;MAqQY,yBtJlSM,EAAA;;AsJuSlB;EACI,iCAAiC;EACjC,mCtJi7B0E;EsJh7B1E,kBAAkB;EAClB,UAAU,EAAA;EAJd;IAOQ,aAAa;IACb,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,eAAe;IACf,ctJ3RY,EAAA;EsJ+QpB;IAeQ,cAAc,EAAA;;AAItB;EACI,aAAa,EAAA;EADjB;IAIY,gBAAgB;IAChB,UAAU;IACV,eAAe;IACf,aAAa;IACb,cAAc,EAAA;IAR1B;MAUgB,ctJvUE,EAAA;;AsJ+UlB;EACI,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA0B;EAC1B,aAAY,EAAA;;AAGhB;EACI,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,4CtJ+J8E;EsJ9J9E,gBAAgB;EAChB,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,oBAAoB,EAAA;EAEpB;IAXJ;MAYQ,aAAa,EAAA,EAWpB;EAvBD;IAgBQ,4BAA4B;IAC5B,UAAU,EAAA;IAEV;MAnBR;QAoBY,4BAA4B,EAAA,EAEnC;;AAGL;EACI,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,kDAAkD;EAClD,qDAAqD,EAAA;EANzD;IASQ,qCAAqC;IACrC,eAAe,EAAA;;AAMvB;EAEQ,2BAA2B,EAAA;;AAFnC;EAOY,0BAA0B,EAAA;;AAPtC;EAYQ,oBAAoB;EACpB,qBAAqB,EAAA;;AAOrB;EjKuxwDN;IiKtxwDU,yBAAyB;IACzB,0BAA0B,EAAA,EAKjC;;AAHG;EjKwxwDN;IiKvxwDU,wBAAwB,EAAA,EAE/B;;AjKwxwDL;EiKrxwDQ,wCAAkE,EAAA;EAClE;IjKuxwDJ;MiKtxwDQ,uCAAiE,EAAA,EAExE;;AjKuxwDL;EiKpxwDQ,2BAA2B,EAAA;EAC3B;IjKsxwDJ;MiKrxwDQ,2BAA2B,EAAA,EAElC;;AjKsxwDL;EiKnxwDQ,2BAA2B,EAAA;EAC3B;IjKqxwDJ;MiKpxwDQ,2BAA2B,EAAA,EAElC;;ACnkBL;EACE,kBAAkB;EAClB,kBAAkB,EAAA;;AAKpB;EACE,2BAA2B;EAC3B,kBAAkB;EAClB,mCvJs2C4E;EuJr2C5E,oBAAoB,EAAA;EAEpB;IANF;MAOM,gBAAgB;MAChB,gBAAgB;MAChB,uCAAiE,EAAA,EA6BtE;EA1BC;IAZF;MAaM,eAAe;MACf,MAAM;MACN,SAAS;MACT,OAAO;MACP,YAAY;MACZ,eAAe;MACf,aAAa;MACb,6CvJ+nByD;MuJ9nBzD,4BAA4B;MAC5B,kBAAkB;MAClB,aAAa,EAAA;MAvBnB;QA0BU,mBAAmB;QACnB,eAAe,EAAA,EAClB;EA5BP;IAgCM,2BAA2B,EAAA;IAE3B;MAlCN;QAmCU,2BAA2B,EAAA,EAElC;;AAGH;EAEM,aAAa;EACb,mBAAmB;EACnB,cvJgGY;EuJ/FZ,cAAc;EACd,gBvJgEkB,EAAA;EuJtExB;IASU,cvJkHU,EAAA;EuJ3HpB;IAaU,eAAe,EAAA;EAbzB;IAiBU,cvJiHU;IuJhHV,gBvJqDgB,EAAA;IuJvE1B;MAqBc,cvJ6GM,EAAA;;AuJvGpB;EAEM,cvJuEY,EAAA;EuJzElB;IAKU,cvJ6FU,EAAA;;AuJxFpB;EACE,WAAW;EACX,mCvJ0xC4E;EuJzxC5E,oBAAoB,EAAA;;AAGtB;EACE,eAAe;EACf,YvJQkB;EuJPlB,SAAS;EACT,2BAA2B;EAC3B,UAAU,EAAA;;AAGZ;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,SAAS;EACT,UAAU;EACV,mCvJwwC4E;EuJvwC5E,2BAA2B;EAC3B,oBAAoB;EACpB,kBAAkB;EAClB,wCAAiE,EAAA;;AAGnE;EAEM,eAAe;EACf,mBAAmB,EAAA;;AAHzB;EAOM,iBAAiB,EAAA;EAEjB;IATN;MAUU,eAAe,EAAA,EAEtB;;AAGH;EACE,2BAA2B,EAAA;EAE3B;IAHF;MAIM,2BAA2B,EAAA,EAEhC;;AAED;EACE,2BAA2B,EAAA;EAE3B;IAHF;MAIM,2BAA2B,EAAA,EAEhC;;AAED;EACE,cAAc;EACd,eAAe;EACf,SAAS,EAAA;EAHX;IAMM,kBAAkB;IAClB,cAAc;IACd,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,wBAAwB;IACxB,WAAW,EAAA;IAZjB;MAeU,yBAAmD,EAAA;IAf7D;MAmBU,2BAAkD;MAClD,yBAAyB,EAAA;IApBnC;MAwBU,WAAW;MACX,kBAAkB,EAAA;IAzB5B;MA6BU,YAAY,EAAA;MA7BtB;;;QAkCc,cAAc;QACd,WAAW,EAAA;MAnCzB;QAuCc,6BAA6B;QAC7B,oBAAoB;QACpB,mBAAmB;QACnB,SAAS;QACT,QAAQ;QACR,cAAc;QACd,YAAY,EAAA;MA7C1B;QAiDc,qBAAqB;QACrB,mBAAmB,EAAA;MAlDjC;QAsDc,gBAAgB;QAChB,gBAAgB,EAAA;MAvD9B;QA2Dc,kBAAkB;QAClB,MAAM;QACN,UAAU;QACV,QAAQ;QACR,uBAAuB;QACvB,gBAAgB;QAChB,mBAAmB;QACnB,gBAAgB,EAAA;QAEhB;UApEd;YAqEkB,UAAU,EAAA,EAEjB;IAvEX;MA2EU,kBAAkB;MAClB,MAAM;MACN,WAAW;MACX,QAAQ;MACR,SAAS,EAAA;MA/EnB;;QAmFc,kBAAkB;QAClB,MAAM,EAAA;MApFpB;QAwFc,OAAO;QACP,YAAY;QACZ,uBAAuB;QACvB,gBAAgB;QAChB,mBAAmB,EAAA;QA5FjC;UA+FkB,yBAAmD,EAAA;MA/FrE;QAoGc,QAAQ;QACR,YAAY;QACZ,kBAAkB,EAAA;IAtGhC;MA4GU,iCvJhFU;MuJiFV,iCAAwD,EAAA;IA7GlE;MAkHU,yBAAmD,EAAA;MAlH7D;QAqHc,yBAAmD;QACnD,gBvJ9IY,EAAA;;AuJoJ1B;EACE,aAAa,EAAA;;AAGf;EACE,aAAa;EACb,WAAW;EACX,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;EAClB,OAAO;EACP,MAAM;EACN,SAAS,EAAA;;AAGX;EACE,mBAAmB,EAAA;;AAGrB;EA3LA;IA6LM,eAAe;IACf,MAAM;IACN,SAAS;IACT,UAAU;IACV,QAAQ;IACR,YAAY;IACZ,eAAe;IACf,aAAa;IACb,6CvJmXyD;IuJlXzD,2BAA2B,EAAA;EAzLjC;IA8LU,eAAe,EAAA,EAClB;;AAKP;EArKA;IAuKM,YAAY,EAAA,EACf;;AAGH;EAEM,4BAA4B,EAAA;;AAIlC;EACE,YAAY;EACZ,eAAe;EACf,eAAe;EACf,YvJ/NkB;EuJgOlB,WvJhOkB;EuJiOlB,UAAU;EACV,aAAa,EAAA;EAPf;IASM,6CvJkVyD,EAAA;EuJ/U7D;IAZF;MAaM,UAAU;MACV,WAAW,EAAA,EAEhB;;AAKK;ElKqvxDJ;IkKpvxDQ,yBAAyB;IACzB,0BAA0B,EAAA,EAKjC;;AAHG;ElKsvxDJ;IkKrvxDQ,wBAAwB,EAAA,EAE/B;;AlKsvxDH;EkKnvxDM,wCAAkE,EAAA;EAClE;IlKqvxDF;MkKpvxDM,aACJ,EAAA,EAOH;ElK8uxDD;IkKnvxDQ,2BAA2B,EAAA;IAC3B;MlKqvxDJ;QkKpvxDQ,2BAA2B,EAAA,EAElC;;AlKqvxDP;EkKjvxDM,2BAA2B,EAAA;;AlKovxDjC;EkK/uxDM,2BAA2B,EAAA;EAC3B;IlKivxDF;MkKhvxDM,2BAA2B,EAAA,EAElC;;ACpXH;EACI,aAAa;EACb,gBAAgB;EAChB,oBAAoB,EAAA;EAHxB;IAKQ,gBAAgB;IAChB,kBAAkB,EAAA;EAN1B;IASQ,wBAAwB,EAAA;EAThC;IAYQ,WAAW,EAAA;EAZnB;IAeQ,WAAW,EAAA;EAfnB;IAkBQ,iDAA0E;IAC1E,kBAAkB,EAAA;EAnB1B;IAsBQ,kBAAkB,EAAA;;AAI1B;EAEQ,sCxJqnB4B,EAAA;;AwJvnBpC;EAKQ,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,uBAAuB;EACvB,gBAAgB,EAAA;;AATxB;EAYQ,kBAAkB,EAAA;;AAI1B;EACI,+BAA+B,EAAA;;AAInC;EACI,iBAAiB;EACjB,kBAAkB,EAAA;EAFtB;IAIQ,WAAW;IACX,kBAAkB;IAClB,OAAO;IACP,QAAQ;IACR,MAAM;IACN,SAAS;IACT,aAAa;IACb,YAAY;IACZ,cAAc;IACd,0DAA8C;IAC9C,sBAAsB;IACtB,2BAA2B,EAAA;;AAInC;EAGY,UAAU,EAAA;;AAHtB;EAOgB,UAAU,EAAA;;ACzE1B;EAEM,mCzJ82CwE;EyJ72CxE,eAAe,EAAA;;AAMnB;EACE,eAAe;EACf,kBAAkB,EAAA;EAElB;IAJF;MAKI,eAAe,EAAA,EAElB;;AAED;EACE,kBAAkB,EAAA;EADpB;IAII,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,yCzJuJc;IyJtJd,kBAAkB;IAClB,SAAS;IACT,OAAO,EAAA;;AAMX;EACE,iBAAiB,EAAA;EAEjB;IAHF;MAII,mCzJy0CwE;MyJx0CxE,kDAAkD;MAClD,iBAAiB,EAAA,EAyCpB;EA/CD;IAYQ,eAAe;IACf,gBzJqEc;IyJpEd,oBAAoB;IACpB,kCzJvCoD;IyJwCpD,qBAA2C;IAC3C,aAAa,EAAA;IAEb;MAnBR;QAoBU,gBAAgB,EAAA,EAQnB;IA5BP;MA0BU,yBAA0B,EAAA;EA1BpC;IAgCU,yBAA0B,EAAA;EAhCpC;IAwCI,yBAA0B,EAAA;EAxC9B;IA4CI,mCzJiyCwE;IyJhyCxE,kDAAkD,EAAA;;AAMtD;EACE,gDAA2E,EAAA;EAD7E;IAMQ,uBzJoxCoE,EAAA;;AyJ9wC5E;EACE,0DAA4D;EAC5D,6BAA6B;EAC7B,2BAA2B;EAC3B,sBAAsB;EACtB,YAAY,EAAA;;AAGd;EACE,kBAAkB;EAClB,UAAU,EAAA;EAFZ;IAMM,mCzJgwCsE;IyJ/vCtE,YAAY;IACZ,kBAAkB,EAAA;EARxB;IAaI,kBAAkB;IAClB,YAAY;IACZ,UAAU;IACV,gBAAgB,EAAA;EAhBpB;IAoBI,kBAAkB;IAClB,WAAW;IACX,aAAa;IACb,gBAAgB,EAAA;;AAKpB;EACE,gBAAgB;EAChB,WAAW;EACX,iBAAiB;EACjB,oBAAoB,EAAA;;AAKtB;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB,EAAA;;AAIpB;EACE,kBAAkB,EAAA;EADpB;IAII,kBAAkB;IAClB,SAAS;IACT,OAAO;IACP,UAAU;IACV,YAAY,EAAA;;AAIhB;EACE,cAAc,EAAA;;AAGhB;EAGM,cAAc;EACd,cAAc;EACd,cAAc;EACd,gCAAgC,EAAA;EANtC;IASQ,+BzJlCK,EAAA;;AyJwCb;EAEI,cAAc;EACd,2CzJ3CS;EyJ4CT,yBAAyB,EAAA;EAJ7B;IAOM,WzJ/CO;IyJgDP,yBzJnBY,EAAA;;AX4myDpB;;EoK9kyDQ,YAAY,EAAA;;ApKklyDpB;EoK9kyDQ,8CAAqC,EAAA;;AAnM3C;EAyME,kBAAkB,EAAA;;ACtNtB;;;;;;CrK0yyDC;AqKlyyDD;EAEQ,mC1J02CsE;E0Jz2CtE,oC1JsoB0E,EAAA;E0JzoBlF;IAKY,oC1JooBsE,EAAA;;A0JzoBlF;EASQ,mC1Jm2CsE;E0Jl2CtE,oC1J+nB0E;E0J9nB1E,gBAAgB,EAAA;EAXxB;IAaY,+CAAsC,EAAA;;AAblD;EAiBQ,uC1JivC8E,EAAA;E0JlwCtF;IAmBY,eAAe;IACf,kD1JyvCgG,EAAA;I0J7wC5G;MAsBgB,kD1JuvC4F,EAAA;;A0J7wC5G;EA2BQ,iCAAwD,EAAA;;AA3BhE;EA8BQ,8B1JuF8D,EAAA;;A0JrHtE;EAiCQ,8B1JoF8D,EAAA;;ADuctE;EVpjBI,aAAa,EAAA;;AAEjB;EAEI,kDAAkD,EAAA;;AAItD;EAEI,aAAa,EAAA;;A6HXjB;E7HgBE,uBAAuB;EACvB,sBAAsB;EACtB,6BAA6B;EAC7B,uBAAuB;EACvB,oBAAoB,EAAA;;AAGtB;;EAEE,sBAAsB,EAAA;;A6H/BxB;E7HmCE,8BAA8B;EAC9B,8CAA8C;EAE9C,2BAA2B,EAAA;;A6HsC7B;E7HlCE,8BAA8B;EAC9B,6BAA6B;EAC7B,oCAAoC;EACpC,4CAA4C;EAC5C,wCAAwC;EACxC,2BAA2B;EAC3B,sBAAsB,EAAA;;A4HpDxB;E5HwDE,kBAAkB,EAAA;;AAGpB;EACE,sBAAsB;EACtB,sBAAsB;EACtB,iCAAiC;EACjC,mCAAmC,EAAA;;AAGrC;EACE;IACE,YACF,EAAA;EAEA;IACE,YACF,EAAA;EAEA;IACE,YACF,EAAA,EAAA;;AAGF;EACE,SAAS,EAAA;;AUwEX;;EVnEE,gBAAgB,EAAA;;AAGlB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,iBAAiB,EAAA;;AAGnB;EACE,kBAAkB,EAAA;;AAGpB;EACE,kBAAkB,EAAA;;AAqLpB;;EAEE,uBAAuB;EACvB,0BAA0B;EAC1B,iBAAiB,EAAA;;AgJ7LnB;EhJiME,uBAAuB,EAAA;;AmB5OrB;E6HiNJ;IhJgCI,yBAAyB;IACzB,kBAAkB,EAAA;IAFpB;;;MAOI,WAAW;MACX,cAAc;MACd,WAAW;MACX,cAAc,EAAA;EgJ5TpB;IhJoUU,WAAW,EAAA;EAMnB;IACE,aAAa,EAAA,EACd;;AoJlVH;EpJsVE,wBAAwB,EAAA;;AAG1B;EACE,aAAa,EAAA;;AsI1Uf;EtI8UE,aAAa,EAAA;;AAGf;EACE,oCAAoC,EAAA;;AAGtC;EACE,2BAA2B;EAC3B,2BAA2B,EAAA;;AAmI3B;EAEI,8BAA6B,EAAA;;AAFjC;EAEI,8BAA6B,EAAA;;AAFjC;EAEI,8BAA6B,EAAA;;AAFjC;EAEI,8BAA6B,EAAA;;AAFjC;EAEI,8BAA6B,EAAA;;AAFjC;EAEI,8BAA6B,EAAA;;AAFjC;EAEI,8BAA6B,EAAA;;AAFjC;EAEI,8BAA6B,EAAA;;AAMnC;EAEI,eAAe;EACf,YAAY;EACZ,cWnWc,EAAA;;AXuWlB;EACE,2BAA2B;EAC3B,YAAY;EACZ,0BAA0B,EAAA;EAH5B;IAMI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB,EAAA;EATtB;IAaI,yBAAyB;IACzB,iBAAiB;IACjB,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB,EAAA;;AAKtB;EAEI,6BAA6B,EAAA;;AAIjC;EACE;IACE,aAAa,EAAA,EACd","sourcesContent":["@import \"../scss/icons.scss\";\r\n@import \"../scss/config/modern/bootstrap.scss\";\r\n@import \"../scss/config/modern/app.scss\";\r\n@import \"../scss/config/modern/custom.scss\";\r\n@import\"./shepherd.css\";\r\n@import \"./mermaid.min.css\";\r\n\r\n//RTL \r\n// @import \"../scss/rtl/components-rtl\";\r\n// @import \"../scss/rtl/layouts-rtl\";\r\n// @import \"../scss/rtl/plugins-rtl\";\r\n// @import \"../scss/rtl/pages-rtl\";\r\n\r\n//Rigthsidebar offcanvas\r\niframe\r\n{\r\n    display: none;\r\n}\r\n.offcanvas-header-dark {\r\n  .btn-close {\r\n    filter: invert(1) grayscale(100%) brightness(200%);\r\n  }\r\n}\r\n\r\nbody {\r\n  * {\r\n    outline: none;\r\n  }\r\n}\r\n\r\n.noUi-horizontal .noUi-handle {\r\n  height: 16px !important;\r\n  width: 16px !important;\r\n  border-radius: 50% !important;\r\n  right: -10px !important;\r\n  top: -7px !important;\r\n}\r\n\r\n.noUi-connect,\r\n.noUi-horizontal {\r\n  height: 2px !important;\r\n}\r\n\r\n.noUi-handle {\r\n  background: #6ada7d !important;\r\n  border: 2px solid var(--vz-card-bg) !important;\r\n  -webkit-box-shadow: none !important;\r\n  box-shadow: none !important;\r\n}\r\n\r\n.noUi-target {\r\n  background: #fafafa !important;\r\n  border-radius: 4px !important;\r\n  border: 1px solid #d3d3d3 !important;\r\n  background-color: var(--vz-light) !important;\r\n  border-color: var(--vz-light) !important;\r\n  box-shadow: none !important;\r\n  height: 4px !important;\r\n}\r\n\r\n.dropzone .dz-message {\r\n  text-align: center;\r\n}\r\n\r\n.wink {\r\n  animation-name: winker;\r\n  animation-duration: 1s;\r\n  animation-timing-function: linear;\r\n  animation-iteration-count: infinite;\r\n}\r\n\r\n@keyframes winker {\r\n  0% {\r\n    opacity: 1.0\r\n  }\r\n\r\n  50% {\r\n    opacity: 0.5\r\n  }\r\n\r\n  100% {\r\n    opacity: 1.0\r\n  }\r\n}\r\n\r\n.quill-only p {\r\n  margin: 0;\r\n}\r\n\r\nol,\r\nul {\r\n  margin-bottom: 0;\r\n}\r\n\r\n.ql-indent-1 {\r\n  margin-left: 15px;\r\n}\r\n\r\n.ql-indent-2 {\r\n  margin-left: 30px;\r\n}\r\n\r\n.ql-indent-3 {\r\n  margin-left: 45px;\r\n}\r\n\r\n.ql-indent-4 {\r\n  margin-left: 60px;\r\n}\r\n\r\n.ql-indent-5 {\r\n  margin-left: 75px;\r\n}\r\n\r\n.ql-indent-6 {\r\n  margin-left: 90px;\r\n}\r\n\r\n.ql-indent-7 {\r\n  margin-left: 105px;\r\n}\r\n\r\n.ql-indent-8 {\r\n  margin-left: 120px;\r\n}\r\n\r\n// #sidebar-menu {\r\n//   ul {\r\n//     li {\r\n//       a {\r\n//         i {\r\n//           min-width: 2rem;\r\n//         }\r\n//       }\r\n//     }\r\n//   }\r\n// }\r\n\r\n// .leaflet-pane {\r\n//   z-index: 1;\r\n// }\r\n// svg > rect:first-child {\r\n//   fill-opacity: 0 !important;\r\n// }\r\n// .dataTables_filter,\r\n// .dataTables_paginate {\r\n//   float: right;\r\n// }\r\n// .rdw-editor-main {\r\n//   border: 1px solid $gray-300;\r\n//   height: 239px;\r\n//   padding-left: 15px;\r\n// }\r\n// .dz-message {\r\n//   text-align: center;\r\n//   padding: 30px;\r\n// }\r\n// // kanban board\r\n// .react-kanban-column {\r\n//   height: 100%;\r\n//   min-height: 28px;\r\n//   display: inline-block;\r\n//   padding: 15px;\r\n//   border-radius: 2px;\r\n//   background-color: rgb(238, 238, 238);\r\n//   margin: 5px;\r\n//   vertical-align: top;\r\n// }\r\n// .fcYNFc,\r\n// .sc-AxmLO.gmtmqV {\r\n//   background-color: $card-bg !important;\r\n//   margin: 0 20px 0 0 !important;\r\n// }\r\n// .task-box {\r\n//   border: 1px solid $border-color;\r\n// }\r\n// .react-datepicker-wrapper {\r\n//   width: 100% !important;\r\n// }\r\n// .ReactModal__Overlay {\r\n//   z-index: 1001 !important;\r\n// }\r\n// .external-event {\r\n//   &:hover {\r\n//     cursor: pointer;\r\n//   }\r\n// }\r\n// a:hover {\r\n//   cursor: pointer;\r\n// }\r\n// .rating-container {\r\n//   background-color: transparent !important;\r\n// }\r\n// .input-group-append {\r\n//   z-index: 0;\r\n// }\r\n// .input-color {\r\n//   color: $input-color !important;\r\n// }\r\n// .sketch-picker {\r\n//   position: absolute;\r\n//   z-index: 1;\r\n// }\r\n// .rangeslider__fill {\r\n//   background-color: $primary !important;\r\n// }\r\n\r\n// .dropdown-menu-end {\r\n//   left: auto !important;\r\n//   right: 0 !important;\r\n// }\r\n\r\n// .bs-select select {\r\n//   width: auto !important;\r\n// }\r\n\r\n// //File-manager\r\n// .file-manager {\r\n//   .table td {\r\n//     padding: 0.35rem;\r\n//   }\r\n// }\r\n\r\n// //Authenication carousel\r\n// .slider_css {\r\n//   .slide {\r\n//     background: none !important;\r\n//   }\r\n\r\n//   .carousel-status,\r\n//   .control-next,\r\n//   .control-prev {\r\n//     display: none !important;\r\n//   }\r\n// }\r\n// .carousel {\r\n//   .control-dots {\r\n//     margin: -5px 0px;\r\n//   }\r\n//   .dot {\r\n//     background: #556ee6 !important;\r\n//     width: 9px !important;\r\n//     height: 9px !important;\r\n//   }\r\n// }\r\n\r\n// //Two verification Page\r\n// .verification {\r\n//   input {\r\n//     &:focus {\r\n//       border: none;\r\n//       outline: none !important;\r\n//     }\r\n//   }\r\n// }\r\n\r\n// @media (max-width: 768px) {\r\n//   .verification {\r\n//     input {\r\n//       width: 40px !important;\r\n//     }\r\n//   }\r\n// }\r\n\r\n// @media (max-width: 320px) {\r\n//   .verification {\r\n//     input {\r\n//       width: 30px !important;\r\n//       height: 30px !important;\r\n//       font-size: 15px !important;\r\n//     }\r\n//   }\r\n// }\r\n\r\n// //Two verification Page - 2\r\n// .verification-2 {\r\n//   input {\r\n//     &:focus {\r\n//       border: none;\r\n//       outline: none !important;\r\n//     }\r\n//   }\r\n// }\r\n\r\n// @media (max-width: 768px) {\r\n//   .verification-2 {\r\n//     input {\r\n//       width: 40px !important;\r\n//       font-size: 14px;\r\n//     }\r\n//   }\r\n// }\r\n\r\n// @media (max-width: 320px) {\r\n//   .verification-2 {\r\n//     input {\r\n//       width: 30px !important;\r\n//       height: 35px !important;\r\n//       font-size: 15px !important;\r\n//     }\r\n//   }\r\n// }\r\n\r\n// //Calendar\r\n.fc-direction-ltr .fc-daygrid-event.fc-event-end,\r\n.fc-direction-rtl .fc-daygrid-event.fc-event-start {\r\n  padding: 5px !important;\r\n  font-size: 12px !important;\r\n  margin-right: 2px;\r\n}\r\n\r\n.fc-event {\r\n  border: none !important;\r\n}\r\n\r\n@include media-breakpoint-down(sm) {\r\n  .fc-toolbar {\r\n    display: block !important;\r\n    text-align: center;\r\n\r\n    .fc-left,\r\n    .fc-right,\r\n    .fc-center {\r\n      float: none;\r\n      display: block;\r\n      clear: both;\r\n      margin: 10px 0;\r\n    }\r\n  }\r\n\r\n  .fc {\r\n    .fc-toolbar {\r\n      >* {\r\n        >* {\r\n          float: none;\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  .fc-today-button {\r\n    display: none;\r\n  }\r\n}\r\n\r\n.flatpickr-calendar.open {\r\n  z-index: 1090 !important;\r\n}\r\n\r\n.upcoming-scheduled .flatpickr-input[readonly] {\r\n  display: none;\r\n}\r\n\r\n.ql-container.ql-snow {\r\n  height: 250px;\r\n}\r\n\r\n.rangeslider-horizontal .rangeslider__fill {\r\n  background-color: #5ea3cb !important;\r\n}\r\n\r\n.Toastify__toast {\r\n  min-height: 43px !important;\r\n  max-height: 43px !important;\r\n}\r\n\r\n// //Chat Scrollbar\r\n// .ps__rail-y {\r\n//   z-index: 999999 !important;\r\n// }\r\n// .close {\r\n//   background: transparent;\r\n//   border: 0;\r\n//   font-size: 10px;\r\n//   padding: 1.35rem 1.25rem;\r\n//   background: transparent escape-svg($btn-close-bg) center / $btn-close-width\r\n//     auto no-repeat;\r\n//   position: absolute;\r\n//   top: 0;\r\n//   right: 0;\r\n//   opacity: 0.5;\r\n//   width: 1em;\r\n//   height: 1em;\r\n//   z-index: 2;\r\n//   span {\r\n//     display: none;\r\n//   }\r\n// }\r\n\r\n// //\r\n// // Columns\r\n// //\r\n\r\n// .card-columns {\r\n//   .card {\r\n//     margin-bottom: $grid-gutter-width;\r\n//   }\r\n\r\n//   @include media-breakpoint-up(sm) {\r\n//     column-count: 3;\r\n//     column-gap: 1.25rem;\r\n//     orphans: 1;\r\n//     widows: 1;\r\n\r\n//     .card {\r\n//       display: inline-block; // Don't let them vertically span multiple columns\r\n//       width: 100%; // Don't let their width change\r\n//     }\r\n//   }\r\n// }\r\n\r\n// /* drawer */\r\n// .react-drawer-drawer {\r\n//   z-index: 9999;\r\n//   background: #fff;\r\n// }\r\n// .drawer-main-menu {\r\n//   padding-top: 8px;\r\n//   padding-bottom: 8px;\r\n// }\r\n// .drawer-menu a i {\r\n//   min-width: 2rem;\r\n//   display: inline-block;\r\n//   min-width: 1.75rem;\r\n//   padding-bottom: 0.125em;\r\n//   font-size: 1.25rem;\r\n//   line-height: 1.40625rem;\r\n//   vertical-align: middle;\r\n//   color: #7f8387;\r\n//   transition: all 0.4s;\r\n// }\r\n// .drawer-menu a {\r\n//   display: block;\r\n//   padding: 0.625rem 1.5rem;\r\n//   color: #545a6d;\r\n//   position: relative;\r\n//   font-size: 13px;\r\n//   transition: all 0.4s;\r\n// }\r\n// .drawer-close {\r\n//   padding: 0.5rem 0.5rem;\r\n//   margin: -0.5rem -0.5rem -0.5rem auto;\r\n// }\r\n// .ReactModal__Overlay {\r\n//   z-index: 5000 !important;\r\n// }\r\n// .rangeslider__handle:focus {\r\n//   outline: none;\r\n// }\r\n// // React Table next css\r\n// .react-bootstrap-table-page-btns-ul {\r\n//   float: right !important;\r\n// }\r\n// .search-label {\r\n//   float: right;\r\n// }\r\n// .react-drawer-overlay {\r\n//   z-index: 9999;\r\n// }\r\n\r\n// // datatable\r\n\r\n// .react-bs-table-sizePerPage-dropdown {\r\n//   .dropdown-menu {\r\n//     .dropdown-item {\r\n//       a {\r\n//         display: block;\r\n//       }\r\n//     }\r\n//   }\r\n// }\r\n// .rightbar-title .right-bar-toggle {\r\n//   background-color: #444c54 !important;\r\n//   height: 24px !important;\r\n//   width: 24px !important;\r\n//   line-height: 24px !important;\r\n//   display: block !important;\r\n//   color: #eff2f7 !important;\r\n//   text-align: center !important;\r\n//   border-radius: 50% !important;\r\n// }\r\n\r\n// //rightbar drawer\r\n// .css-sourceMap-modules-importLoaders-1-localIdentName-animate__animated___2O131 {\r\n//   animation-duration: 0.6s !important;\r\n// }\r\n// .css-sourceMap-modules-importLoaders-1-localIdentName-ReactDrawer__overlay___2QFmC-sass {\r\n//   background: rgba(0, 0, 0, 0.15) !important;\r\n// }\r\n\r\n\r\n\r\n@each $color,\r\n$value in $theme-colors {\r\n  .simplebar-track-#{$color} {\r\n    .simplebar-scrollbar:before {\r\n      background: $value !important;\r\n    }\r\n  }\r\n}\r\n\r\n// chat\r\n.chat-conversation .chat-list .message-box-drop {\r\n  .nav-btn {\r\n    font-size: 18px;\r\n    padding: 4px;\r\n    color: $gray-600;\r\n  }\r\n}\r\n\r\n.headerTrial{\r\n  background-color: '#F7FAFC';\r\n  height: 40px;\r\n  text-align: -webkit-center;\r\n\r\n  .a1{\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 15px;\r\n    position: absolute;\r\n  }\r\n\r\n  .a2{\r\n    background-color: #e2e8f0;\r\n    padding: 5px 20px;\r\n    border-radius: 8px;\r\n    margin-left: 30px;\r\n    margin: 0px 30px;\r\n    width: max-content;\r\n  }\r\n}\r\n\r\n// Authentication pages \r\n#tsparticles {\r\n  canvas {\r\n    position: absolute !important;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 850px) {\r\n  .a2{\r\n    display: none;\r\n  }\r\n}","/*\r\nTemplate Name: Velzon - Admin & Dashboard Template\r\nAuthor: Themesbrand\r\nVersion: 1.4.0\r\nWebsite: https://Themesbrand.com/\r\nContact: Themesbrand@gmail.com\r\nFile: Icons Css File\r\n*/\r\n\r\n// Icons Scss\r\n@import \"plugins/icons/materialdesignicons\";\r\n@import \"plugins/icons/boxicons\";\r\n@import \"plugins/icons/line-awesome\";\r\n@import \"plugins/icons/remixicon\";","/* MaterialDesignIcons.com */\r\n@font-face {\r\n  font-family: \"Material Design Icons\";\r\n  src: url(\"../../../fonts/materialdesignicons-webfont.eot?v=6.5.95\");\r\n  src: url(\"../../../fonts/materialdesignicons-webfont.eot?#iefix&v=6.5.95\") format(\"embedded-opentype\"), url(\"../../../fonts/materialdesignicons-webfont.woff2?v=6.5.95\") format(\"woff2\"), url(\"../../../fonts/materialdesignicons-webfont.woff?v=6.5.95\") format(\"woff\"), url(\"../../../fonts/materialdesignicons-webfont.ttf?v=6.5.95\") format(\"truetype\");\r\n  font-weight: normal;\r\n  font-style: normal;\r\n}\r\n\r\n.mdi:before,\r\n.mdi-set {\r\n  display: inline-block;\r\n  font: normal normal normal 24px/1 \"Material Design Icons\";\r\n  font-size: inherit;\r\n  text-rendering: auto;\r\n  line-height: inherit;\r\n  -webkit-font-smoothing: antialiased;\r\n  -moz-osx-font-smoothing: grayscale;\r\n}\r\n\r\n.mdi-ab-testing::before {\r\n  content: \"\\F01C9\";\r\n}\r\n\r\n.mdi-abacus::before {\r\n  content: \"\\F16E0\";\r\n}\r\n\r\n.mdi-abjad-arabic::before {\r\n  content: \"\\F1328\";\r\n}\r\n\r\n.mdi-abjad-hebrew::before {\r\n  content: \"\\F1329\";\r\n}\r\n\r\n.mdi-abugida-devanagari::before {\r\n  content: \"\\F132A\";\r\n}\r\n\r\n.mdi-abugida-thai::before {\r\n  content: \"\\F132B\";\r\n}\r\n\r\n.mdi-access-point::before {\r\n  content: \"\\F0003\";\r\n}\r\n\r\n.mdi-access-point-check::before {\r\n  content: \"\\F1538\";\r\n}\r\n\r\n.mdi-access-point-minus::before {\r\n  content: \"\\F1539\";\r\n}\r\n\r\n.mdi-access-point-network::before {\r\n  content: \"\\F0002\";\r\n}\r\n\r\n.mdi-access-point-network-off::before {\r\n  content: \"\\F0BE1\";\r\n}\r\n\r\n.mdi-access-point-off::before {\r\n  content: \"\\F1511\";\r\n}\r\n\r\n.mdi-access-point-plus::before {\r\n  content: \"\\F153A\";\r\n}\r\n\r\n.mdi-access-point-remove::before {\r\n  content: \"\\F153B\";\r\n}\r\n\r\n.mdi-account::before {\r\n  content: \"\\F0004\";\r\n}\r\n\r\n.mdi-account-alert::before {\r\n  content: \"\\F0005\";\r\n}\r\n\r\n.mdi-account-alert-outline::before {\r\n  content: \"\\F0B50\";\r\n}\r\n\r\n.mdi-account-arrow-down::before {\r\n  content: \"\\F1868\";\r\n}\r\n\r\n.mdi-account-arrow-down-outline::before {\r\n  content: \"\\F1869\";\r\n}\r\n\r\n.mdi-account-arrow-left::before {\r\n  content: \"\\F0B51\";\r\n}\r\n\r\n.mdi-account-arrow-left-outline::before {\r\n  content: \"\\F0B52\";\r\n}\r\n\r\n.mdi-account-arrow-right::before {\r\n  content: \"\\F0B53\";\r\n}\r\n\r\n.mdi-account-arrow-right-outline::before {\r\n  content: \"\\F0B54\";\r\n}\r\n\r\n.mdi-account-arrow-up::before {\r\n  content: \"\\F1867\";\r\n}\r\n\r\n.mdi-account-arrow-up-outline::before {\r\n  content: \"\\F186A\";\r\n}\r\n\r\n.mdi-account-box::before {\r\n  content: \"\\F0006\";\r\n}\r\n\r\n.mdi-account-box-multiple::before {\r\n  content: \"\\F0934\";\r\n}\r\n\r\n.mdi-account-box-multiple-outline::before {\r\n  content: \"\\F100A\";\r\n}\r\n\r\n.mdi-account-box-outline::before {\r\n  content: \"\\F0007\";\r\n}\r\n\r\n.mdi-account-cancel::before {\r\n  content: \"\\F12DF\";\r\n}\r\n\r\n.mdi-account-cancel-outline::before {\r\n  content: \"\\F12E0\";\r\n}\r\n\r\n.mdi-account-cash::before {\r\n  content: \"\\F1097\";\r\n}\r\n\r\n.mdi-account-cash-outline::before {\r\n  content: \"\\F1098\";\r\n}\r\n\r\n.mdi-account-check::before {\r\n  content: \"\\F0008\";\r\n}\r\n\r\n.mdi-account-check-outline::before {\r\n  content: \"\\F0BE2\";\r\n}\r\n\r\n.mdi-account-child::before {\r\n  content: \"\\F0A89\";\r\n}\r\n\r\n.mdi-account-child-circle::before {\r\n  content: \"\\F0A8A\";\r\n}\r\n\r\n.mdi-account-child-outline::before {\r\n  content: \"\\F10C8\";\r\n}\r\n\r\n.mdi-account-circle::before {\r\n  content: \"\\F0009\";\r\n}\r\n\r\n.mdi-account-circle-outline::before {\r\n  content: \"\\F0B55\";\r\n}\r\n\r\n.mdi-account-clock::before {\r\n  content: \"\\F0B56\";\r\n}\r\n\r\n.mdi-account-clock-outline::before {\r\n  content: \"\\F0B57\";\r\n}\r\n\r\n.mdi-account-cog::before {\r\n  content: \"\\F1370\";\r\n}\r\n\r\n.mdi-account-cog-outline::before {\r\n  content: \"\\F1371\";\r\n}\r\n\r\n.mdi-account-convert::before {\r\n  content: \"\\F000A\";\r\n}\r\n\r\n.mdi-account-convert-outline::before {\r\n  content: \"\\F1301\";\r\n}\r\n\r\n.mdi-account-cowboy-hat::before {\r\n  content: \"\\F0E9B\";\r\n}\r\n\r\n.mdi-account-cowboy-hat-outline::before {\r\n  content: \"\\F17F3\";\r\n}\r\n\r\n.mdi-account-details::before {\r\n  content: \"\\F0631\";\r\n}\r\n\r\n.mdi-account-details-outline::before {\r\n  content: \"\\F1372\";\r\n}\r\n\r\n.mdi-account-edit::before {\r\n  content: \"\\F06BC\";\r\n}\r\n\r\n.mdi-account-edit-outline::before {\r\n  content: \"\\F0FFB\";\r\n}\r\n\r\n.mdi-account-eye::before {\r\n  content: \"\\F0420\";\r\n}\r\n\r\n.mdi-account-eye-outline::before {\r\n  content: \"\\F127B\";\r\n}\r\n\r\n.mdi-account-filter::before {\r\n  content: \"\\F0936\";\r\n}\r\n\r\n.mdi-account-filter-outline::before {\r\n  content: \"\\F0F9D\";\r\n}\r\n\r\n.mdi-account-group::before {\r\n  content: \"\\F0849\";\r\n}\r\n\r\n.mdi-account-group-outline::before {\r\n  content: \"\\F0B58\";\r\n}\r\n\r\n.mdi-account-hard-hat::before {\r\n  content: \"\\F05B5\";\r\n}\r\n\r\n.mdi-account-heart::before {\r\n  content: \"\\F0899\";\r\n}\r\n\r\n.mdi-account-heart-outline::before {\r\n  content: \"\\F0BE3\";\r\n}\r\n\r\n.mdi-account-injury::before {\r\n  content: \"\\F1815\";\r\n}\r\n\r\n.mdi-account-injury-outline::before {\r\n  content: \"\\F1816\";\r\n}\r\n\r\n.mdi-account-key::before {\r\n  content: \"\\F000B\";\r\n}\r\n\r\n.mdi-account-key-outline::before {\r\n  content: \"\\F0BE4\";\r\n}\r\n\r\n.mdi-account-lock::before {\r\n  content: \"\\F115E\";\r\n}\r\n\r\n.mdi-account-lock-open::before {\r\n  content: \"\\F1960\";\r\n}\r\n\r\n.mdi-account-lock-open-outline::before {\r\n  content: \"\\F1961\";\r\n}\r\n\r\n.mdi-account-lock-outline::before {\r\n  content: \"\\F115F\";\r\n}\r\n\r\n.mdi-account-minus::before {\r\n  content: \"\\F000D\";\r\n}\r\n\r\n.mdi-account-minus-outline::before {\r\n  content: \"\\F0AEC\";\r\n}\r\n\r\n.mdi-account-multiple::before {\r\n  content: \"\\F000E\";\r\n}\r\n\r\n.mdi-account-multiple-check::before {\r\n  content: \"\\F08C5\";\r\n}\r\n\r\n.mdi-account-multiple-check-outline::before {\r\n  content: \"\\F11FE\";\r\n}\r\n\r\n.mdi-account-multiple-minus::before {\r\n  content: \"\\F05D3\";\r\n}\r\n\r\n.mdi-account-multiple-minus-outline::before {\r\n  content: \"\\F0BE5\";\r\n}\r\n\r\n.mdi-account-multiple-outline::before {\r\n  content: \"\\F000F\";\r\n}\r\n\r\n.mdi-account-multiple-plus::before {\r\n  content: \"\\F0010\";\r\n}\r\n\r\n.mdi-account-multiple-plus-outline::before {\r\n  content: \"\\F0800\";\r\n}\r\n\r\n.mdi-account-multiple-remove::before {\r\n  content: \"\\F120A\";\r\n}\r\n\r\n.mdi-account-multiple-remove-outline::before {\r\n  content: \"\\F120B\";\r\n}\r\n\r\n.mdi-account-music::before {\r\n  content: \"\\F0803\";\r\n}\r\n\r\n.mdi-account-music-outline::before {\r\n  content: \"\\F0CE9\";\r\n}\r\n\r\n.mdi-account-network::before {\r\n  content: \"\\F0011\";\r\n}\r\n\r\n.mdi-account-network-outline::before {\r\n  content: \"\\F0BE6\";\r\n}\r\n\r\n.mdi-account-off::before {\r\n  content: \"\\F0012\";\r\n}\r\n\r\n.mdi-account-off-outline::before {\r\n  content: \"\\F0BE7\";\r\n}\r\n\r\n.mdi-account-outline::before {\r\n  content: \"\\F0013\";\r\n}\r\n\r\n.mdi-account-plus::before {\r\n  content: \"\\F0014\";\r\n}\r\n\r\n.mdi-account-plus-outline::before {\r\n  content: \"\\F0801\";\r\n}\r\n\r\n.mdi-account-question::before {\r\n  content: \"\\F0B59\";\r\n}\r\n\r\n.mdi-account-question-outline::before {\r\n  content: \"\\F0B5A\";\r\n}\r\n\r\n.mdi-account-reactivate::before {\r\n  content: \"\\F152B\";\r\n}\r\n\r\n.mdi-account-reactivate-outline::before {\r\n  content: \"\\F152C\";\r\n}\r\n\r\n.mdi-account-remove::before {\r\n  content: \"\\F0015\";\r\n}\r\n\r\n.mdi-account-remove-outline::before {\r\n  content: \"\\F0AED\";\r\n}\r\n\r\n.mdi-account-search::before {\r\n  content: \"\\F0016\";\r\n}\r\n\r\n.mdi-account-search-outline::before {\r\n  content: \"\\F0935\";\r\n}\r\n\r\n.mdi-account-settings::before {\r\n  content: \"\\F0630\";\r\n}\r\n\r\n.mdi-account-settings-outline::before {\r\n  content: \"\\F10C9\";\r\n}\r\n\r\n.mdi-account-star::before {\r\n  content: \"\\F0017\";\r\n}\r\n\r\n.mdi-account-star-outline::before {\r\n  content: \"\\F0BE8\";\r\n}\r\n\r\n.mdi-account-supervisor::before {\r\n  content: \"\\F0A8B\";\r\n}\r\n\r\n.mdi-account-supervisor-circle::before {\r\n  content: \"\\F0A8C\";\r\n}\r\n\r\n.mdi-account-supervisor-circle-outline::before {\r\n  content: \"\\F14EC\";\r\n}\r\n\r\n.mdi-account-supervisor-outline::before {\r\n  content: \"\\F112D\";\r\n}\r\n\r\n.mdi-account-switch::before {\r\n  content: \"\\F0019\";\r\n}\r\n\r\n.mdi-account-switch-outline::before {\r\n  content: \"\\F04CB\";\r\n}\r\n\r\n.mdi-account-sync::before {\r\n  content: \"\\F191B\";\r\n}\r\n\r\n.mdi-account-sync-outline::before {\r\n  content: \"\\F191C\";\r\n}\r\n\r\n.mdi-account-tie::before {\r\n  content: \"\\F0CE3\";\r\n}\r\n\r\n.mdi-account-tie-hat::before {\r\n  content: \"\\F1898\";\r\n}\r\n\r\n.mdi-account-tie-hat-outline::before {\r\n  content: \"\\F1899\";\r\n}\r\n\r\n.mdi-account-tie-outline::before {\r\n  content: \"\\F10CA\";\r\n}\r\n\r\n.mdi-account-tie-voice::before {\r\n  content: \"\\F1308\";\r\n}\r\n\r\n.mdi-account-tie-voice-off::before {\r\n  content: \"\\F130A\";\r\n}\r\n\r\n.mdi-account-tie-voice-off-outline::before {\r\n  content: \"\\F130B\";\r\n}\r\n\r\n.mdi-account-tie-voice-outline::before {\r\n  content: \"\\F1309\";\r\n}\r\n\r\n.mdi-account-voice::before {\r\n  content: \"\\F05CB\";\r\n}\r\n\r\n.mdi-account-voice-off::before {\r\n  content: \"\\F0ED4\";\r\n}\r\n\r\n.mdi-account-wrench::before {\r\n  content: \"\\F189A\";\r\n}\r\n\r\n.mdi-account-wrench-outline::before {\r\n  content: \"\\F189B\";\r\n}\r\n\r\n.mdi-adjust::before {\r\n  content: \"\\F001A\";\r\n}\r\n\r\n.mdi-advertisements::before {\r\n  content: \"\\F192A\";\r\n}\r\n\r\n.mdi-advertisements-off::before {\r\n  content: \"\\F192B\";\r\n}\r\n\r\n.mdi-air-conditioner::before {\r\n  content: \"\\F001B\";\r\n}\r\n\r\n.mdi-air-filter::before {\r\n  content: \"\\F0D43\";\r\n}\r\n\r\n.mdi-air-horn::before {\r\n  content: \"\\F0DAC\";\r\n}\r\n\r\n.mdi-air-humidifier::before {\r\n  content: \"\\F1099\";\r\n}\r\n\r\n.mdi-air-humidifier-off::before {\r\n  content: \"\\F1466\";\r\n}\r\n\r\n.mdi-air-purifier::before {\r\n  content: \"\\F0D44\";\r\n}\r\n\r\n.mdi-airbag::before {\r\n  content: \"\\F0BE9\";\r\n}\r\n\r\n.mdi-airballoon::before {\r\n  content: \"\\F001C\";\r\n}\r\n\r\n.mdi-airballoon-outline::before {\r\n  content: \"\\F100B\";\r\n}\r\n\r\n.mdi-airplane::before {\r\n  content: \"\\F001D\";\r\n}\r\n\r\n.mdi-airplane-alert::before {\r\n  content: \"\\F187A\";\r\n}\r\n\r\n.mdi-airplane-check::before {\r\n  content: \"\\F187B\";\r\n}\r\n\r\n.mdi-airplane-clock::before {\r\n  content: \"\\F187C\";\r\n}\r\n\r\n.mdi-airplane-cog::before {\r\n  content: \"\\F187D\";\r\n}\r\n\r\n.mdi-airplane-edit::before {\r\n  content: \"\\F187E\";\r\n}\r\n\r\n.mdi-airplane-landing::before {\r\n  content: \"\\F05D4\";\r\n}\r\n\r\n.mdi-airplane-marker::before {\r\n  content: \"\\F187F\";\r\n}\r\n\r\n.mdi-airplane-minus::before {\r\n  content: \"\\F1880\";\r\n}\r\n\r\n.mdi-airplane-off::before {\r\n  content: \"\\F001E\";\r\n}\r\n\r\n.mdi-airplane-plus::before {\r\n  content: \"\\F1881\";\r\n}\r\n\r\n.mdi-airplane-remove::before {\r\n  content: \"\\F1882\";\r\n}\r\n\r\n.mdi-airplane-search::before {\r\n  content: \"\\F1883\";\r\n}\r\n\r\n.mdi-airplane-settings::before {\r\n  content: \"\\F1884\";\r\n}\r\n\r\n.mdi-airplane-takeoff::before {\r\n  content: \"\\F05D5\";\r\n}\r\n\r\n.mdi-airport::before {\r\n  content: \"\\F084B\";\r\n}\r\n\r\n.mdi-alarm::before {\r\n  content: \"\\F0020\";\r\n}\r\n\r\n.mdi-alarm-bell::before {\r\n  content: \"\\F078E\";\r\n}\r\n\r\n.mdi-alarm-check::before {\r\n  content: \"\\F0021\";\r\n}\r\n\r\n.mdi-alarm-light::before {\r\n  content: \"\\F078F\";\r\n}\r\n\r\n.mdi-alarm-light-off::before {\r\n  content: \"\\F171E\";\r\n}\r\n\r\n.mdi-alarm-light-off-outline::before {\r\n  content: \"\\F171F\";\r\n}\r\n\r\n.mdi-alarm-light-outline::before {\r\n  content: \"\\F0BEA\";\r\n}\r\n\r\n.mdi-alarm-multiple::before {\r\n  content: \"\\F0022\";\r\n}\r\n\r\n.mdi-alarm-note::before {\r\n  content: \"\\F0E71\";\r\n}\r\n\r\n.mdi-alarm-note-off::before {\r\n  content: \"\\F0E72\";\r\n}\r\n\r\n.mdi-alarm-off::before {\r\n  content: \"\\F0023\";\r\n}\r\n\r\n.mdi-alarm-panel::before {\r\n  content: \"\\F15C4\";\r\n}\r\n\r\n.mdi-alarm-panel-outline::before {\r\n  content: \"\\F15C5\";\r\n}\r\n\r\n.mdi-alarm-plus::before {\r\n  content: \"\\F0024\";\r\n}\r\n\r\n.mdi-alarm-snooze::before {\r\n  content: \"\\F068E\";\r\n}\r\n\r\n.mdi-album::before {\r\n  content: \"\\F0025\";\r\n}\r\n\r\n.mdi-alert::before {\r\n  content: \"\\F0026\";\r\n}\r\n\r\n.mdi-alert-box::before {\r\n  content: \"\\F0027\";\r\n}\r\n\r\n.mdi-alert-box-outline::before {\r\n  content: \"\\F0CE4\";\r\n}\r\n\r\n.mdi-alert-circle::before {\r\n  content: \"\\F0028\";\r\n}\r\n\r\n.mdi-alert-circle-check::before {\r\n  content: \"\\F11ED\";\r\n}\r\n\r\n.mdi-alert-circle-check-outline::before {\r\n  content: \"\\F11EE\";\r\n}\r\n\r\n.mdi-alert-circle-outline::before {\r\n  content: \"\\F05D6\";\r\n}\r\n\r\n.mdi-alert-decagram::before {\r\n  content: \"\\F06BD\";\r\n}\r\n\r\n.mdi-alert-decagram-outline::before {\r\n  content: \"\\F0CE5\";\r\n}\r\n\r\n.mdi-alert-minus::before {\r\n  content: \"\\F14BB\";\r\n}\r\n\r\n.mdi-alert-minus-outline::before {\r\n  content: \"\\F14BE\";\r\n}\r\n\r\n.mdi-alert-octagon::before {\r\n  content: \"\\F0029\";\r\n}\r\n\r\n.mdi-alert-octagon-outline::before {\r\n  content: \"\\F0CE6\";\r\n}\r\n\r\n.mdi-alert-octagram::before {\r\n  content: \"\\F0767\";\r\n}\r\n\r\n.mdi-alert-octagram-outline::before {\r\n  content: \"\\F0CE7\";\r\n}\r\n\r\n.mdi-alert-outline::before {\r\n  content: \"\\F002A\";\r\n}\r\n\r\n.mdi-alert-plus::before {\r\n  content: \"\\F14BA\";\r\n}\r\n\r\n.mdi-alert-plus-outline::before {\r\n  content: \"\\F14BD\";\r\n}\r\n\r\n.mdi-alert-remove::before {\r\n  content: \"\\F14BC\";\r\n}\r\n\r\n.mdi-alert-remove-outline::before {\r\n  content: \"\\F14BF\";\r\n}\r\n\r\n.mdi-alert-rhombus::before {\r\n  content: \"\\F11CE\";\r\n}\r\n\r\n.mdi-alert-rhombus-outline::before {\r\n  content: \"\\F11CF\";\r\n}\r\n\r\n.mdi-alien::before {\r\n  content: \"\\F089A\";\r\n}\r\n\r\n.mdi-alien-outline::before {\r\n  content: \"\\F10CB\";\r\n}\r\n\r\n.mdi-align-horizontal-center::before {\r\n  content: \"\\F11C3\";\r\n}\r\n\r\n.mdi-align-horizontal-distribute::before {\r\n  content: \"\\F1962\";\r\n}\r\n\r\n.mdi-align-horizontal-left::before {\r\n  content: \"\\F11C2\";\r\n}\r\n\r\n.mdi-align-horizontal-right::before {\r\n  content: \"\\F11C4\";\r\n}\r\n\r\n.mdi-align-vertical-bottom::before {\r\n  content: \"\\F11C5\";\r\n}\r\n\r\n.mdi-align-vertical-center::before {\r\n  content: \"\\F11C6\";\r\n}\r\n\r\n.mdi-align-vertical-distribute::before {\r\n  content: \"\\F1963\";\r\n}\r\n\r\n.mdi-align-vertical-top::before {\r\n  content: \"\\F11C7\";\r\n}\r\n\r\n.mdi-all-inclusive::before {\r\n  content: \"\\F06BE\";\r\n}\r\n\r\n.mdi-all-inclusive-box::before {\r\n  content: \"\\F188D\";\r\n}\r\n\r\n.mdi-all-inclusive-box-outline::before {\r\n  content: \"\\F188E\";\r\n}\r\n\r\n.mdi-allergy::before {\r\n  content: \"\\F1258\";\r\n}\r\n\r\n.mdi-alpha::before {\r\n  content: \"\\F002B\";\r\n}\r\n\r\n.mdi-alpha-a::before {\r\n  content: \"\\F0AEE\";\r\n}\r\n\r\n.mdi-alpha-a-box::before {\r\n  content: \"\\F0B08\";\r\n}\r\n\r\n.mdi-alpha-a-box-outline::before {\r\n  content: \"\\F0BEB\";\r\n}\r\n\r\n.mdi-alpha-a-circle::before {\r\n  content: \"\\F0BEC\";\r\n}\r\n\r\n.mdi-alpha-a-circle-outline::before {\r\n  content: \"\\F0BED\";\r\n}\r\n\r\n.mdi-alpha-b::before {\r\n  content: \"\\F0AEF\";\r\n}\r\n\r\n.mdi-alpha-b-box::before {\r\n  content: \"\\F0B09\";\r\n}\r\n\r\n.mdi-alpha-b-box-outline::before {\r\n  content: \"\\F0BEE\";\r\n}\r\n\r\n.mdi-alpha-b-circle::before {\r\n  content: \"\\F0BEF\";\r\n}\r\n\r\n.mdi-alpha-b-circle-outline::before {\r\n  content: \"\\F0BF0\";\r\n}\r\n\r\n.mdi-alpha-c::before {\r\n  content: \"\\F0AF0\";\r\n}\r\n\r\n.mdi-alpha-c-box::before {\r\n  content: \"\\F0B0A\";\r\n}\r\n\r\n.mdi-alpha-c-box-outline::before {\r\n  content: \"\\F0BF1\";\r\n}\r\n\r\n.mdi-alpha-c-circle::before {\r\n  content: \"\\F0BF2\";\r\n}\r\n\r\n.mdi-alpha-c-circle-outline::before {\r\n  content: \"\\F0BF3\";\r\n}\r\n\r\n.mdi-alpha-d::before {\r\n  content: \"\\F0AF1\";\r\n}\r\n\r\n.mdi-alpha-d-box::before {\r\n  content: \"\\F0B0B\";\r\n}\r\n\r\n.mdi-alpha-d-box-outline::before {\r\n  content: \"\\F0BF4\";\r\n}\r\n\r\n.mdi-alpha-d-circle::before {\r\n  content: \"\\F0BF5\";\r\n}\r\n\r\n.mdi-alpha-d-circle-outline::before {\r\n  content: \"\\F0BF6\";\r\n}\r\n\r\n.mdi-alpha-e::before {\r\n  content: \"\\F0AF2\";\r\n}\r\n\r\n.mdi-alpha-e-box::before {\r\n  content: \"\\F0B0C\";\r\n}\r\n\r\n.mdi-alpha-e-box-outline::before {\r\n  content: \"\\F0BF7\";\r\n}\r\n\r\n.mdi-alpha-e-circle::before {\r\n  content: \"\\F0BF8\";\r\n}\r\n\r\n.mdi-alpha-e-circle-outline::before {\r\n  content: \"\\F0BF9\";\r\n}\r\n\r\n.mdi-alpha-f::before {\r\n  content: \"\\F0AF3\";\r\n}\r\n\r\n.mdi-alpha-f-box::before {\r\n  content: \"\\F0B0D\";\r\n}\r\n\r\n.mdi-alpha-f-box-outline::before {\r\n  content: \"\\F0BFA\";\r\n}\r\n\r\n.mdi-alpha-f-circle::before {\r\n  content: \"\\F0BFB\";\r\n}\r\n\r\n.mdi-alpha-f-circle-outline::before {\r\n  content: \"\\F0BFC\";\r\n}\r\n\r\n.mdi-alpha-g::before {\r\n  content: \"\\F0AF4\";\r\n}\r\n\r\n.mdi-alpha-g-box::before {\r\n  content: \"\\F0B0E\";\r\n}\r\n\r\n.mdi-alpha-g-box-outline::before {\r\n  content: \"\\F0BFD\";\r\n}\r\n\r\n.mdi-alpha-g-circle::before {\r\n  content: \"\\F0BFE\";\r\n}\r\n\r\n.mdi-alpha-g-circle-outline::before {\r\n  content: \"\\F0BFF\";\r\n}\r\n\r\n.mdi-alpha-h::before {\r\n  content: \"\\F0AF5\";\r\n}\r\n\r\n.mdi-alpha-h-box::before {\r\n  content: \"\\F0B0F\";\r\n}\r\n\r\n.mdi-alpha-h-box-outline::before {\r\n  content: \"\\F0C00\";\r\n}\r\n\r\n.mdi-alpha-h-circle::before {\r\n  content: \"\\F0C01\";\r\n}\r\n\r\n.mdi-alpha-h-circle-outline::before {\r\n  content: \"\\F0C02\";\r\n}\r\n\r\n.mdi-alpha-i::before {\r\n  content: \"\\F0AF6\";\r\n}\r\n\r\n.mdi-alpha-i-box::before {\r\n  content: \"\\F0B10\";\r\n}\r\n\r\n.mdi-alpha-i-box-outline::before {\r\n  content: \"\\F0C03\";\r\n}\r\n\r\n.mdi-alpha-i-circle::before {\r\n  content: \"\\F0C04\";\r\n}\r\n\r\n.mdi-alpha-i-circle-outline::before {\r\n  content: \"\\F0C05\";\r\n}\r\n\r\n.mdi-alpha-j::before {\r\n  content: \"\\F0AF7\";\r\n}\r\n\r\n.mdi-alpha-j-box::before {\r\n  content: \"\\F0B11\";\r\n}\r\n\r\n.mdi-alpha-j-box-outline::before {\r\n  content: \"\\F0C06\";\r\n}\r\n\r\n.mdi-alpha-j-circle::before {\r\n  content: \"\\F0C07\";\r\n}\r\n\r\n.mdi-alpha-j-circle-outline::before {\r\n  content: \"\\F0C08\";\r\n}\r\n\r\n.mdi-alpha-k::before {\r\n  content: \"\\F0AF8\";\r\n}\r\n\r\n.mdi-alpha-k-box::before {\r\n  content: \"\\F0B12\";\r\n}\r\n\r\n.mdi-alpha-k-box-outline::before {\r\n  content: \"\\F0C09\";\r\n}\r\n\r\n.mdi-alpha-k-circle::before {\r\n  content: \"\\F0C0A\";\r\n}\r\n\r\n.mdi-alpha-k-circle-outline::before {\r\n  content: \"\\F0C0B\";\r\n}\r\n\r\n.mdi-alpha-l::before {\r\n  content: \"\\F0AF9\";\r\n}\r\n\r\n.mdi-alpha-l-box::before {\r\n  content: \"\\F0B13\";\r\n}\r\n\r\n.mdi-alpha-l-box-outline::before {\r\n  content: \"\\F0C0C\";\r\n}\r\n\r\n.mdi-alpha-l-circle::before {\r\n  content: \"\\F0C0D\";\r\n}\r\n\r\n.mdi-alpha-l-circle-outline::before {\r\n  content: \"\\F0C0E\";\r\n}\r\n\r\n.mdi-alpha-m::before {\r\n  content: \"\\F0AFA\";\r\n}\r\n\r\n.mdi-alpha-m-box::before {\r\n  content: \"\\F0B14\";\r\n}\r\n\r\n.mdi-alpha-m-box-outline::before {\r\n  content: \"\\F0C0F\";\r\n}\r\n\r\n.mdi-alpha-m-circle::before {\r\n  content: \"\\F0C10\";\r\n}\r\n\r\n.mdi-alpha-m-circle-outline::before {\r\n  content: \"\\F0C11\";\r\n}\r\n\r\n.mdi-alpha-n::before {\r\n  content: \"\\F0AFB\";\r\n}\r\n\r\n.mdi-alpha-n-box::before {\r\n  content: \"\\F0B15\";\r\n}\r\n\r\n.mdi-alpha-n-box-outline::before {\r\n  content: \"\\F0C12\";\r\n}\r\n\r\n.mdi-alpha-n-circle::before {\r\n  content: \"\\F0C13\";\r\n}\r\n\r\n.mdi-alpha-n-circle-outline::before {\r\n  content: \"\\F0C14\";\r\n}\r\n\r\n.mdi-alpha-o::before {\r\n  content: \"\\F0AFC\";\r\n}\r\n\r\n.mdi-alpha-o-box::before {\r\n  content: \"\\F0B16\";\r\n}\r\n\r\n.mdi-alpha-o-box-outline::before {\r\n  content: \"\\F0C15\";\r\n}\r\n\r\n.mdi-alpha-o-circle::before {\r\n  content: \"\\F0C16\";\r\n}\r\n\r\n.mdi-alpha-o-circle-outline::before {\r\n  content: \"\\F0C17\";\r\n}\r\n\r\n.mdi-alpha-p::before {\r\n  content: \"\\F0AFD\";\r\n}\r\n\r\n.mdi-alpha-p-box::before {\r\n  content: \"\\F0B17\";\r\n}\r\n\r\n.mdi-alpha-p-box-outline::before {\r\n  content: \"\\F0C18\";\r\n}\r\n\r\n.mdi-alpha-p-circle::before {\r\n  content: \"\\F0C19\";\r\n}\r\n\r\n.mdi-alpha-p-circle-outline::before {\r\n  content: \"\\F0C1A\";\r\n}\r\n\r\n.mdi-alpha-q::before {\r\n  content: \"\\F0AFE\";\r\n}\r\n\r\n.mdi-alpha-q-box::before {\r\n  content: \"\\F0B18\";\r\n}\r\n\r\n.mdi-alpha-q-box-outline::before {\r\n  content: \"\\F0C1B\";\r\n}\r\n\r\n.mdi-alpha-q-circle::before {\r\n  content: \"\\F0C1C\";\r\n}\r\n\r\n.mdi-alpha-q-circle-outline::before {\r\n  content: \"\\F0C1D\";\r\n}\r\n\r\n.mdi-alpha-r::before {\r\n  content: \"\\F0AFF\";\r\n}\r\n\r\n.mdi-alpha-r-box::before {\r\n  content: \"\\F0B19\";\r\n}\r\n\r\n.mdi-alpha-r-box-outline::before {\r\n  content: \"\\F0C1E\";\r\n}\r\n\r\n.mdi-alpha-r-circle::before {\r\n  content: \"\\F0C1F\";\r\n}\r\n\r\n.mdi-alpha-r-circle-outline::before {\r\n  content: \"\\F0C20\";\r\n}\r\n\r\n.mdi-alpha-s::before {\r\n  content: \"\\F0B00\";\r\n}\r\n\r\n.mdi-alpha-s-box::before {\r\n  content: \"\\F0B1A\";\r\n}\r\n\r\n.mdi-alpha-s-box-outline::before {\r\n  content: \"\\F0C21\";\r\n}\r\n\r\n.mdi-alpha-s-circle::before {\r\n  content: \"\\F0C22\";\r\n}\r\n\r\n.mdi-alpha-s-circle-outline::before {\r\n  content: \"\\F0C23\";\r\n}\r\n\r\n.mdi-alpha-t::before {\r\n  content: \"\\F0B01\";\r\n}\r\n\r\n.mdi-alpha-t-box::before {\r\n  content: \"\\F0B1B\";\r\n}\r\n\r\n.mdi-alpha-t-box-outline::before {\r\n  content: \"\\F0C24\";\r\n}\r\n\r\n.mdi-alpha-t-circle::before {\r\n  content: \"\\F0C25\";\r\n}\r\n\r\n.mdi-alpha-t-circle-outline::before {\r\n  content: \"\\F0C26\";\r\n}\r\n\r\n.mdi-alpha-u::before {\r\n  content: \"\\F0B02\";\r\n}\r\n\r\n.mdi-alpha-u-box::before {\r\n  content: \"\\F0B1C\";\r\n}\r\n\r\n.mdi-alpha-u-box-outline::before {\r\n  content: \"\\F0C27\";\r\n}\r\n\r\n.mdi-alpha-u-circle::before {\r\n  content: \"\\F0C28\";\r\n}\r\n\r\n.mdi-alpha-u-circle-outline::before {\r\n  content: \"\\F0C29\";\r\n}\r\n\r\n.mdi-alpha-v::before {\r\n  content: \"\\F0B03\";\r\n}\r\n\r\n.mdi-alpha-v-box::before {\r\n  content: \"\\F0B1D\";\r\n}\r\n\r\n.mdi-alpha-v-box-outline::before {\r\n  content: \"\\F0C2A\";\r\n}\r\n\r\n.mdi-alpha-v-circle::before {\r\n  content: \"\\F0C2B\";\r\n}\r\n\r\n.mdi-alpha-v-circle-outline::before {\r\n  content: \"\\F0C2C\";\r\n}\r\n\r\n.mdi-alpha-w::before {\r\n  content: \"\\F0B04\";\r\n}\r\n\r\n.mdi-alpha-w-box::before {\r\n  content: \"\\F0B1E\";\r\n}\r\n\r\n.mdi-alpha-w-box-outline::before {\r\n  content: \"\\F0C2D\";\r\n}\r\n\r\n.mdi-alpha-w-circle::before {\r\n  content: \"\\F0C2E\";\r\n}\r\n\r\n.mdi-alpha-w-circle-outline::before {\r\n  content: \"\\F0C2F\";\r\n}\r\n\r\n.mdi-alpha-x::before {\r\n  content: \"\\F0B05\";\r\n}\r\n\r\n.mdi-alpha-x-box::before {\r\n  content: \"\\F0B1F\";\r\n}\r\n\r\n.mdi-alpha-x-box-outline::before {\r\n  content: \"\\F0C30\";\r\n}\r\n\r\n.mdi-alpha-x-circle::before {\r\n  content: \"\\F0C31\";\r\n}\r\n\r\n.mdi-alpha-x-circle-outline::before {\r\n  content: \"\\F0C32\";\r\n}\r\n\r\n.mdi-alpha-y::before {\r\n  content: \"\\F0B06\";\r\n}\r\n\r\n.mdi-alpha-y-box::before {\r\n  content: \"\\F0B20\";\r\n}\r\n\r\n.mdi-alpha-y-box-outline::before {\r\n  content: \"\\F0C33\";\r\n}\r\n\r\n.mdi-alpha-y-circle::before {\r\n  content: \"\\F0C34\";\r\n}\r\n\r\n.mdi-alpha-y-circle-outline::before {\r\n  content: \"\\F0C35\";\r\n}\r\n\r\n.mdi-alpha-z::before {\r\n  content: \"\\F0B07\";\r\n}\r\n\r\n.mdi-alpha-z-box::before {\r\n  content: \"\\F0B21\";\r\n}\r\n\r\n.mdi-alpha-z-box-outline::before {\r\n  content: \"\\F0C36\";\r\n}\r\n\r\n.mdi-alpha-z-circle::before {\r\n  content: \"\\F0C37\";\r\n}\r\n\r\n.mdi-alpha-z-circle-outline::before {\r\n  content: \"\\F0C38\";\r\n}\r\n\r\n.mdi-alphabet-aurebesh::before {\r\n  content: \"\\F132C\";\r\n}\r\n\r\n.mdi-alphabet-cyrillic::before {\r\n  content: \"\\F132D\";\r\n}\r\n\r\n.mdi-alphabet-greek::before {\r\n  content: \"\\F132E\";\r\n}\r\n\r\n.mdi-alphabet-latin::before {\r\n  content: \"\\F132F\";\r\n}\r\n\r\n.mdi-alphabet-piqad::before {\r\n  content: \"\\F1330\";\r\n}\r\n\r\n.mdi-alphabet-tengwar::before {\r\n  content: \"\\F1337\";\r\n}\r\n\r\n.mdi-alphabetical::before {\r\n  content: \"\\F002C\";\r\n}\r\n\r\n.mdi-alphabetical-off::before {\r\n  content: \"\\F100C\";\r\n}\r\n\r\n.mdi-alphabetical-variant::before {\r\n  content: \"\\F100D\";\r\n}\r\n\r\n.mdi-alphabetical-variant-off::before {\r\n  content: \"\\F100E\";\r\n}\r\n\r\n.mdi-altimeter::before {\r\n  content: \"\\F05D7\";\r\n}\r\n\r\n.mdi-ambulance::before {\r\n  content: \"\\F002F\";\r\n}\r\n\r\n.mdi-ammunition::before {\r\n  content: \"\\F0CE8\";\r\n}\r\n\r\n.mdi-ampersand::before {\r\n  content: \"\\F0A8D\";\r\n}\r\n\r\n.mdi-amplifier::before {\r\n  content: \"\\F0030\";\r\n}\r\n\r\n.mdi-amplifier-off::before {\r\n  content: \"\\F11B5\";\r\n}\r\n\r\n.mdi-anchor::before {\r\n  content: \"\\F0031\";\r\n}\r\n\r\n.mdi-android::before {\r\n  content: \"\\F0032\";\r\n}\r\n\r\n.mdi-android-messages::before {\r\n  content: \"\\F0D45\";\r\n}\r\n\r\n.mdi-android-studio::before {\r\n  content: \"\\F0034\";\r\n}\r\n\r\n.mdi-angle-acute::before {\r\n  content: \"\\F0937\";\r\n}\r\n\r\n.mdi-angle-obtuse::before {\r\n  content: \"\\F0938\";\r\n}\r\n\r\n.mdi-angle-right::before {\r\n  content: \"\\F0939\";\r\n}\r\n\r\n.mdi-angular::before {\r\n  content: \"\\F06B2\";\r\n}\r\n\r\n.mdi-angularjs::before {\r\n  content: \"\\F06BF\";\r\n}\r\n\r\n.mdi-animation::before {\r\n  content: \"\\F05D8\";\r\n}\r\n\r\n.mdi-animation-outline::before {\r\n  content: \"\\F0A8F\";\r\n}\r\n\r\n.mdi-animation-play::before {\r\n  content: \"\\F093A\";\r\n}\r\n\r\n.mdi-animation-play-outline::before {\r\n  content: \"\\F0A90\";\r\n}\r\n\r\n.mdi-ansible::before {\r\n  content: \"\\F109A\";\r\n}\r\n\r\n.mdi-antenna::before {\r\n  content: \"\\F1119\";\r\n}\r\n\r\n.mdi-anvil::before {\r\n  content: \"\\F089B\";\r\n}\r\n\r\n.mdi-apache-kafka::before {\r\n  content: \"\\F100F\";\r\n}\r\n\r\n.mdi-api::before {\r\n  content: \"\\F109B\";\r\n}\r\n\r\n.mdi-api-off::before {\r\n  content: \"\\F1257\";\r\n}\r\n\r\n.mdi-apple::before {\r\n  content: \"\\F0035\";\r\n}\r\n\r\n.mdi-apple-finder::before {\r\n  content: \"\\F0036\";\r\n}\r\n\r\n.mdi-apple-icloud::before {\r\n  content: \"\\F0038\";\r\n}\r\n\r\n.mdi-apple-ios::before {\r\n  content: \"\\F0037\";\r\n}\r\n\r\n.mdi-apple-keyboard-caps::before {\r\n  content: \"\\F0632\";\r\n}\r\n\r\n.mdi-apple-keyboard-command::before {\r\n  content: \"\\F0633\";\r\n}\r\n\r\n.mdi-apple-keyboard-control::before {\r\n  content: \"\\F0634\";\r\n}\r\n\r\n.mdi-apple-keyboard-option::before {\r\n  content: \"\\F0635\";\r\n}\r\n\r\n.mdi-apple-keyboard-shift::before {\r\n  content: \"\\F0636\";\r\n}\r\n\r\n.mdi-apple-safari::before {\r\n  content: \"\\F0039\";\r\n}\r\n\r\n.mdi-application::before {\r\n  content: \"\\F08C6\";\r\n}\r\n\r\n.mdi-application-array::before {\r\n  content: \"\\F10F5\";\r\n}\r\n\r\n.mdi-application-array-outline::before {\r\n  content: \"\\F10F6\";\r\n}\r\n\r\n.mdi-application-braces::before {\r\n  content: \"\\F10F7\";\r\n}\r\n\r\n.mdi-application-braces-outline::before {\r\n  content: \"\\F10F8\";\r\n}\r\n\r\n.mdi-application-brackets::before {\r\n  content: \"\\F0C8B\";\r\n}\r\n\r\n.mdi-application-brackets-outline::before {\r\n  content: \"\\F0C8C\";\r\n}\r\n\r\n.mdi-application-cog::before {\r\n  content: \"\\F0675\";\r\n}\r\n\r\n.mdi-application-cog-outline::before {\r\n  content: \"\\F1577\";\r\n}\r\n\r\n.mdi-application-edit::before {\r\n  content: \"\\F00AE\";\r\n}\r\n\r\n.mdi-application-edit-outline::before {\r\n  content: \"\\F0619\";\r\n}\r\n\r\n.mdi-application-export::before {\r\n  content: \"\\F0DAD\";\r\n}\r\n\r\n.mdi-application-import::before {\r\n  content: \"\\F0DAE\";\r\n}\r\n\r\n.mdi-application-outline::before {\r\n  content: \"\\F0614\";\r\n}\r\n\r\n.mdi-application-parentheses::before {\r\n  content: \"\\F10F9\";\r\n}\r\n\r\n.mdi-application-parentheses-outline::before {\r\n  content: \"\\F10FA\";\r\n}\r\n\r\n.mdi-application-settings::before {\r\n  content: \"\\F0B60\";\r\n}\r\n\r\n.mdi-application-settings-outline::before {\r\n  content: \"\\F1555\";\r\n}\r\n\r\n.mdi-application-variable::before {\r\n  content: \"\\F10FB\";\r\n}\r\n\r\n.mdi-application-variable-outline::before {\r\n  content: \"\\F10FC\";\r\n}\r\n\r\n.mdi-approximately-equal::before {\r\n  content: \"\\F0F9E\";\r\n}\r\n\r\n.mdi-approximately-equal-box::before {\r\n  content: \"\\F0F9F\";\r\n}\r\n\r\n.mdi-apps::before {\r\n  content: \"\\F003B\";\r\n}\r\n\r\n.mdi-apps-box::before {\r\n  content: \"\\F0D46\";\r\n}\r\n\r\n.mdi-arch::before {\r\n  content: \"\\F08C7\";\r\n}\r\n\r\n.mdi-archive::before {\r\n  content: \"\\F003C\";\r\n}\r\n\r\n.mdi-archive-alert::before {\r\n  content: \"\\F14FD\";\r\n}\r\n\r\n.mdi-archive-alert-outline::before {\r\n  content: \"\\F14FE\";\r\n}\r\n\r\n.mdi-archive-arrow-down::before {\r\n  content: \"\\F1259\";\r\n}\r\n\r\n.mdi-archive-arrow-down-outline::before {\r\n  content: \"\\F125A\";\r\n}\r\n\r\n.mdi-archive-arrow-up::before {\r\n  content: \"\\F125B\";\r\n}\r\n\r\n.mdi-archive-arrow-up-outline::before {\r\n  content: \"\\F125C\";\r\n}\r\n\r\n.mdi-archive-cancel::before {\r\n  content: \"\\F174B\";\r\n}\r\n\r\n.mdi-archive-cancel-outline::before {\r\n  content: \"\\F174C\";\r\n}\r\n\r\n.mdi-archive-check::before {\r\n  content: \"\\F174D\";\r\n}\r\n\r\n.mdi-archive-check-outline::before {\r\n  content: \"\\F174E\";\r\n}\r\n\r\n.mdi-archive-clock::before {\r\n  content: \"\\F174F\";\r\n}\r\n\r\n.mdi-archive-clock-outline::before {\r\n  content: \"\\F1750\";\r\n}\r\n\r\n.mdi-archive-cog::before {\r\n  content: \"\\F1751\";\r\n}\r\n\r\n.mdi-archive-cog-outline::before {\r\n  content: \"\\F1752\";\r\n}\r\n\r\n.mdi-archive-edit::before {\r\n  content: \"\\F1753\";\r\n}\r\n\r\n.mdi-archive-edit-outline::before {\r\n  content: \"\\F1754\";\r\n}\r\n\r\n.mdi-archive-eye::before {\r\n  content: \"\\F1755\";\r\n}\r\n\r\n.mdi-archive-eye-outline::before {\r\n  content: \"\\F1756\";\r\n}\r\n\r\n.mdi-archive-lock::before {\r\n  content: \"\\F1757\";\r\n}\r\n\r\n.mdi-archive-lock-open::before {\r\n  content: \"\\F1758\";\r\n}\r\n\r\n.mdi-archive-lock-open-outline::before {\r\n  content: \"\\F1759\";\r\n}\r\n\r\n.mdi-archive-lock-outline::before {\r\n  content: \"\\F175A\";\r\n}\r\n\r\n.mdi-archive-marker::before {\r\n  content: \"\\F175B\";\r\n}\r\n\r\n.mdi-archive-marker-outline::before {\r\n  content: \"\\F175C\";\r\n}\r\n\r\n.mdi-archive-minus::before {\r\n  content: \"\\F175D\";\r\n}\r\n\r\n.mdi-archive-minus-outline::before {\r\n  content: \"\\F175E\";\r\n}\r\n\r\n.mdi-archive-music::before {\r\n  content: \"\\F175F\";\r\n}\r\n\r\n.mdi-archive-music-outline::before {\r\n  content: \"\\F1760\";\r\n}\r\n\r\n.mdi-archive-off::before {\r\n  content: \"\\F1761\";\r\n}\r\n\r\n.mdi-archive-off-outline::before {\r\n  content: \"\\F1762\";\r\n}\r\n\r\n.mdi-archive-outline::before {\r\n  content: \"\\F120E\";\r\n}\r\n\r\n.mdi-archive-plus::before {\r\n  content: \"\\F1763\";\r\n}\r\n\r\n.mdi-archive-plus-outline::before {\r\n  content: \"\\F1764\";\r\n}\r\n\r\n.mdi-archive-refresh::before {\r\n  content: \"\\F1765\";\r\n}\r\n\r\n.mdi-archive-refresh-outline::before {\r\n  content: \"\\F1766\";\r\n}\r\n\r\n.mdi-archive-remove::before {\r\n  content: \"\\F1767\";\r\n}\r\n\r\n.mdi-archive-remove-outline::before {\r\n  content: \"\\F1768\";\r\n}\r\n\r\n.mdi-archive-search::before {\r\n  content: \"\\F1769\";\r\n}\r\n\r\n.mdi-archive-search-outline::before {\r\n  content: \"\\F176A\";\r\n}\r\n\r\n.mdi-archive-settings::before {\r\n  content: \"\\F176B\";\r\n}\r\n\r\n.mdi-archive-settings-outline::before {\r\n  content: \"\\F176C\";\r\n}\r\n\r\n.mdi-archive-star::before {\r\n  content: \"\\F176D\";\r\n}\r\n\r\n.mdi-archive-star-outline::before {\r\n  content: \"\\F176E\";\r\n}\r\n\r\n.mdi-archive-sync::before {\r\n  content: \"\\F176F\";\r\n}\r\n\r\n.mdi-archive-sync-outline::before {\r\n  content: \"\\F1770\";\r\n}\r\n\r\n.mdi-arm-flex::before {\r\n  content: \"\\F0FD7\";\r\n}\r\n\r\n.mdi-arm-flex-outline::before {\r\n  content: \"\\F0FD6\";\r\n}\r\n\r\n.mdi-arrange-bring-forward::before {\r\n  content: \"\\F003D\";\r\n}\r\n\r\n.mdi-arrange-bring-to-front::before {\r\n  content: \"\\F003E\";\r\n}\r\n\r\n.mdi-arrange-send-backward::before {\r\n  content: \"\\F003F\";\r\n}\r\n\r\n.mdi-arrange-send-to-back::before {\r\n  content: \"\\F0040\";\r\n}\r\n\r\n.mdi-arrow-all::before {\r\n  content: \"\\F0041\";\r\n}\r\n\r\n.mdi-arrow-bottom-left::before {\r\n  content: \"\\F0042\";\r\n}\r\n\r\n.mdi-arrow-bottom-left-bold-box::before {\r\n  content: \"\\F1964\";\r\n}\r\n\r\n.mdi-arrow-bottom-left-bold-box-outline::before {\r\n  content: \"\\F1965\";\r\n}\r\n\r\n.mdi-arrow-bottom-left-bold-outline::before {\r\n  content: \"\\F09B7\";\r\n}\r\n\r\n.mdi-arrow-bottom-left-thick::before {\r\n  content: \"\\F09B8\";\r\n}\r\n\r\n.mdi-arrow-bottom-left-thin::before {\r\n  content: \"\\F19B6\";\r\n}\r\n\r\n.mdi-arrow-bottom-left-thin-circle-outline::before {\r\n  content: \"\\F1596\";\r\n}\r\n\r\n.mdi-arrow-bottom-right::before {\r\n  content: \"\\F0043\";\r\n}\r\n\r\n.mdi-arrow-bottom-right-bold-box::before {\r\n  content: \"\\F1966\";\r\n}\r\n\r\n.mdi-arrow-bottom-right-bold-box-outline::before {\r\n  content: \"\\F1967\";\r\n}\r\n\r\n.mdi-arrow-bottom-right-bold-outline::before {\r\n  content: \"\\F09B9\";\r\n}\r\n\r\n.mdi-arrow-bottom-right-thick::before {\r\n  content: \"\\F09BA\";\r\n}\r\n\r\n.mdi-arrow-bottom-right-thin::before {\r\n  content: \"\\F19B7\";\r\n}\r\n\r\n.mdi-arrow-bottom-right-thin-circle-outline::before {\r\n  content: \"\\F1595\";\r\n}\r\n\r\n.mdi-arrow-collapse::before {\r\n  content: \"\\F0615\";\r\n}\r\n\r\n.mdi-arrow-collapse-all::before {\r\n  content: \"\\F0044\";\r\n}\r\n\r\n.mdi-arrow-collapse-down::before {\r\n  content: \"\\F0792\";\r\n}\r\n\r\n.mdi-arrow-collapse-horizontal::before {\r\n  content: \"\\F084C\";\r\n}\r\n\r\n.mdi-arrow-collapse-left::before {\r\n  content: \"\\F0793\";\r\n}\r\n\r\n.mdi-arrow-collapse-right::before {\r\n  content: \"\\F0794\";\r\n}\r\n\r\n.mdi-arrow-collapse-up::before {\r\n  content: \"\\F0795\";\r\n}\r\n\r\n.mdi-arrow-collapse-vertical::before {\r\n  content: \"\\F084D\";\r\n}\r\n\r\n.mdi-arrow-decision::before {\r\n  content: \"\\F09BB\";\r\n}\r\n\r\n.mdi-arrow-decision-auto::before {\r\n  content: \"\\F09BC\";\r\n}\r\n\r\n.mdi-arrow-decision-auto-outline::before {\r\n  content: \"\\F09BD\";\r\n}\r\n\r\n.mdi-arrow-decision-outline::before {\r\n  content: \"\\F09BE\";\r\n}\r\n\r\n.mdi-arrow-down::before {\r\n  content: \"\\F0045\";\r\n}\r\n\r\n.mdi-arrow-down-bold::before {\r\n  content: \"\\F072E\";\r\n}\r\n\r\n.mdi-arrow-down-bold-box::before {\r\n  content: \"\\F072F\";\r\n}\r\n\r\n.mdi-arrow-down-bold-box-outline::before {\r\n  content: \"\\F0730\";\r\n}\r\n\r\n.mdi-arrow-down-bold-circle::before {\r\n  content: \"\\F0047\";\r\n}\r\n\r\n.mdi-arrow-down-bold-circle-outline::before {\r\n  content: \"\\F0048\";\r\n}\r\n\r\n.mdi-arrow-down-bold-hexagon-outline::before {\r\n  content: \"\\F0049\";\r\n}\r\n\r\n.mdi-arrow-down-bold-outline::before {\r\n  content: \"\\F09BF\";\r\n}\r\n\r\n.mdi-arrow-down-box::before {\r\n  content: \"\\F06C0\";\r\n}\r\n\r\n.mdi-arrow-down-circle::before {\r\n  content: \"\\F0CDB\";\r\n}\r\n\r\n.mdi-arrow-down-circle-outline::before {\r\n  content: \"\\F0CDC\";\r\n}\r\n\r\n.mdi-arrow-down-drop-circle::before {\r\n  content: \"\\F004A\";\r\n}\r\n\r\n.mdi-arrow-down-drop-circle-outline::before {\r\n  content: \"\\F004B\";\r\n}\r\n\r\n.mdi-arrow-down-left::before {\r\n  content: \"\\F17A1\";\r\n}\r\n\r\n.mdi-arrow-down-left-bold::before {\r\n  content: \"\\F17A2\";\r\n}\r\n\r\n.mdi-arrow-down-right::before {\r\n  content: \"\\F17A3\";\r\n}\r\n\r\n.mdi-arrow-down-right-bold::before {\r\n  content: \"\\F17A4\";\r\n}\r\n\r\n.mdi-arrow-down-thick::before {\r\n  content: \"\\F0046\";\r\n}\r\n\r\n.mdi-arrow-down-thin::before {\r\n  content: \"\\F19B3\";\r\n}\r\n\r\n.mdi-arrow-down-thin-circle-outline::before {\r\n  content: \"\\F1599\";\r\n}\r\n\r\n.mdi-arrow-expand::before {\r\n  content: \"\\F0616\";\r\n}\r\n\r\n.mdi-arrow-expand-all::before {\r\n  content: \"\\F004C\";\r\n}\r\n\r\n.mdi-arrow-expand-down::before {\r\n  content: \"\\F0796\";\r\n}\r\n\r\n.mdi-arrow-expand-horizontal::before {\r\n  content: \"\\F084E\";\r\n}\r\n\r\n.mdi-arrow-expand-left::before {\r\n  content: \"\\F0797\";\r\n}\r\n\r\n.mdi-arrow-expand-right::before {\r\n  content: \"\\F0798\";\r\n}\r\n\r\n.mdi-arrow-expand-up::before {\r\n  content: \"\\F0799\";\r\n}\r\n\r\n.mdi-arrow-expand-vertical::before {\r\n  content: \"\\F084F\";\r\n}\r\n\r\n.mdi-arrow-horizontal-lock::before {\r\n  content: \"\\F115B\";\r\n}\r\n\r\n.mdi-arrow-left::before {\r\n  content: \"\\F004D\";\r\n}\r\n\r\n.mdi-arrow-left-bold::before {\r\n  content: \"\\F0731\";\r\n}\r\n\r\n.mdi-arrow-left-bold-box::before {\r\n  content: \"\\F0732\";\r\n}\r\n\r\n.mdi-arrow-left-bold-box-outline::before {\r\n  content: \"\\F0733\";\r\n}\r\n\r\n.mdi-arrow-left-bold-circle::before {\r\n  content: \"\\F004F\";\r\n}\r\n\r\n.mdi-arrow-left-bold-circle-outline::before {\r\n  content: \"\\F0050\";\r\n}\r\n\r\n.mdi-arrow-left-bold-hexagon-outline::before {\r\n  content: \"\\F0051\";\r\n}\r\n\r\n.mdi-arrow-left-bold-outline::before {\r\n  content: \"\\F09C0\";\r\n}\r\n\r\n.mdi-arrow-left-bottom::before {\r\n  content: \"\\F17A5\";\r\n}\r\n\r\n.mdi-arrow-left-bottom-bold::before {\r\n  content: \"\\F17A6\";\r\n}\r\n\r\n.mdi-arrow-left-box::before {\r\n  content: \"\\F06C1\";\r\n}\r\n\r\n.mdi-arrow-left-circle::before {\r\n  content: \"\\F0CDD\";\r\n}\r\n\r\n.mdi-arrow-left-circle-outline::before {\r\n  content: \"\\F0CDE\";\r\n}\r\n\r\n.mdi-arrow-left-drop-circle::before {\r\n  content: \"\\F0052\";\r\n}\r\n\r\n.mdi-arrow-left-drop-circle-outline::before {\r\n  content: \"\\F0053\";\r\n}\r\n\r\n.mdi-arrow-left-right::before {\r\n  content: \"\\F0E73\";\r\n}\r\n\r\n.mdi-arrow-left-right-bold::before {\r\n  content: \"\\F0E74\";\r\n}\r\n\r\n.mdi-arrow-left-right-bold-outline::before {\r\n  content: \"\\F09C1\";\r\n}\r\n\r\n.mdi-arrow-left-thick::before {\r\n  content: \"\\F004E\";\r\n}\r\n\r\n.mdi-arrow-left-thin::before {\r\n  content: \"\\F19B1\";\r\n}\r\n\r\n.mdi-arrow-left-thin-circle-outline::before {\r\n  content: \"\\F159A\";\r\n}\r\n\r\n.mdi-arrow-left-top::before {\r\n  content: \"\\F17A7\";\r\n}\r\n\r\n.mdi-arrow-left-top-bold::before {\r\n  content: \"\\F17A8\";\r\n}\r\n\r\n.mdi-arrow-projectile::before {\r\n  content: \"\\F1840\";\r\n}\r\n\r\n.mdi-arrow-projectile-multiple::before {\r\n  content: \"\\F183F\";\r\n}\r\n\r\n.mdi-arrow-right::before {\r\n  content: \"\\F0054\";\r\n}\r\n\r\n.mdi-arrow-right-bold::before {\r\n  content: \"\\F0734\";\r\n}\r\n\r\n.mdi-arrow-right-bold-box::before {\r\n  content: \"\\F0735\";\r\n}\r\n\r\n.mdi-arrow-right-bold-box-outline::before {\r\n  content: \"\\F0736\";\r\n}\r\n\r\n.mdi-arrow-right-bold-circle::before {\r\n  content: \"\\F0056\";\r\n}\r\n\r\n.mdi-arrow-right-bold-circle-outline::before {\r\n  content: \"\\F0057\";\r\n}\r\n\r\n.mdi-arrow-right-bold-hexagon-outline::before {\r\n  content: \"\\F0058\";\r\n}\r\n\r\n.mdi-arrow-right-bold-outline::before {\r\n  content: \"\\F09C2\";\r\n}\r\n\r\n.mdi-arrow-right-bottom::before {\r\n  content: \"\\F17A9\";\r\n}\r\n\r\n.mdi-arrow-right-bottom-bold::before {\r\n  content: \"\\F17AA\";\r\n}\r\n\r\n.mdi-arrow-right-box::before {\r\n  content: \"\\F06C2\";\r\n}\r\n\r\n.mdi-arrow-right-circle::before {\r\n  content: \"\\F0CDF\";\r\n}\r\n\r\n.mdi-arrow-right-circle-outline::before {\r\n  content: \"\\F0CE0\";\r\n}\r\n\r\n.mdi-arrow-right-drop-circle::before {\r\n  content: \"\\F0059\";\r\n}\r\n\r\n.mdi-arrow-right-drop-circle-outline::before {\r\n  content: \"\\F005A\";\r\n}\r\n\r\n.mdi-arrow-right-thick::before {\r\n  content: \"\\F0055\";\r\n}\r\n\r\n.mdi-arrow-right-thin::before {\r\n  content: \"\\F19B0\";\r\n}\r\n\r\n.mdi-arrow-right-thin-circle-outline::before {\r\n  content: \"\\F1598\";\r\n}\r\n\r\n.mdi-arrow-right-top::before {\r\n  content: \"\\F17AB\";\r\n}\r\n\r\n.mdi-arrow-right-top-bold::before {\r\n  content: \"\\F17AC\";\r\n}\r\n\r\n.mdi-arrow-split-horizontal::before {\r\n  content: \"\\F093B\";\r\n}\r\n\r\n.mdi-arrow-split-vertical::before {\r\n  content: \"\\F093C\";\r\n}\r\n\r\n.mdi-arrow-top-left::before {\r\n  content: \"\\F005B\";\r\n}\r\n\r\n.mdi-arrow-top-left-bold-box::before {\r\n  content: \"\\F1968\";\r\n}\r\n\r\n.mdi-arrow-top-left-bold-box-outline::before {\r\n  content: \"\\F1969\";\r\n}\r\n\r\n.mdi-arrow-top-left-bold-outline::before {\r\n  content: \"\\F09C3\";\r\n}\r\n\r\n.mdi-arrow-top-left-bottom-right::before {\r\n  content: \"\\F0E75\";\r\n}\r\n\r\n.mdi-arrow-top-left-bottom-right-bold::before {\r\n  content: \"\\F0E76\";\r\n}\r\n\r\n.mdi-arrow-top-left-thick::before {\r\n  content: \"\\F09C4\";\r\n}\r\n\r\n.mdi-arrow-top-left-thin::before {\r\n  content: \"\\F19B5\";\r\n}\r\n\r\n.mdi-arrow-top-left-thin-circle-outline::before {\r\n  content: \"\\F1593\";\r\n}\r\n\r\n.mdi-arrow-top-right::before {\r\n  content: \"\\F005C\";\r\n}\r\n\r\n.mdi-arrow-top-right-bold-box::before {\r\n  content: \"\\F196A\";\r\n}\r\n\r\n.mdi-arrow-top-right-bold-box-outline::before {\r\n  content: \"\\F196B\";\r\n}\r\n\r\n.mdi-arrow-top-right-bold-outline::before {\r\n  content: \"\\F09C5\";\r\n}\r\n\r\n.mdi-arrow-top-right-bottom-left::before {\r\n  content: \"\\F0E77\";\r\n}\r\n\r\n.mdi-arrow-top-right-bottom-left-bold::before {\r\n  content: \"\\F0E78\";\r\n}\r\n\r\n.mdi-arrow-top-right-thick::before {\r\n  content: \"\\F09C6\";\r\n}\r\n\r\n.mdi-arrow-top-right-thin::before {\r\n  content: \"\\F19B4\";\r\n}\r\n\r\n.mdi-arrow-top-right-thin-circle-outline::before {\r\n  content: \"\\F1594\";\r\n}\r\n\r\n.mdi-arrow-u-down-left::before {\r\n  content: \"\\F17AD\";\r\n}\r\n\r\n.mdi-arrow-u-down-left-bold::before {\r\n  content: \"\\F17AE\";\r\n}\r\n\r\n.mdi-arrow-u-down-right::before {\r\n  content: \"\\F17AF\";\r\n}\r\n\r\n.mdi-arrow-u-down-right-bold::before {\r\n  content: \"\\F17B0\";\r\n}\r\n\r\n.mdi-arrow-u-left-bottom::before {\r\n  content: \"\\F17B1\";\r\n}\r\n\r\n.mdi-arrow-u-left-bottom-bold::before {\r\n  content: \"\\F17B2\";\r\n}\r\n\r\n.mdi-arrow-u-left-top::before {\r\n  content: \"\\F17B3\";\r\n}\r\n\r\n.mdi-arrow-u-left-top-bold::before {\r\n  content: \"\\F17B4\";\r\n}\r\n\r\n.mdi-arrow-u-right-bottom::before {\r\n  content: \"\\F17B5\";\r\n}\r\n\r\n.mdi-arrow-u-right-bottom-bold::before {\r\n  content: \"\\F17B6\";\r\n}\r\n\r\n.mdi-arrow-u-right-top::before {\r\n  content: \"\\F17B7\";\r\n}\r\n\r\n.mdi-arrow-u-right-top-bold::before {\r\n  content: \"\\F17B8\";\r\n}\r\n\r\n.mdi-arrow-u-up-left::before {\r\n  content: \"\\F17B9\";\r\n}\r\n\r\n.mdi-arrow-u-up-left-bold::before {\r\n  content: \"\\F17BA\";\r\n}\r\n\r\n.mdi-arrow-u-up-right::before {\r\n  content: \"\\F17BB\";\r\n}\r\n\r\n.mdi-arrow-u-up-right-bold::before {\r\n  content: \"\\F17BC\";\r\n}\r\n\r\n.mdi-arrow-up::before {\r\n  content: \"\\F005D\";\r\n}\r\n\r\n.mdi-arrow-up-bold::before {\r\n  content: \"\\F0737\";\r\n}\r\n\r\n.mdi-arrow-up-bold-box::before {\r\n  content: \"\\F0738\";\r\n}\r\n\r\n.mdi-arrow-up-bold-box-outline::before {\r\n  content: \"\\F0739\";\r\n}\r\n\r\n.mdi-arrow-up-bold-circle::before {\r\n  content: \"\\F005F\";\r\n}\r\n\r\n.mdi-arrow-up-bold-circle-outline::before {\r\n  content: \"\\F0060\";\r\n}\r\n\r\n.mdi-arrow-up-bold-hexagon-outline::before {\r\n  content: \"\\F0061\";\r\n}\r\n\r\n.mdi-arrow-up-bold-outline::before {\r\n  content: \"\\F09C7\";\r\n}\r\n\r\n.mdi-arrow-up-box::before {\r\n  content: \"\\F06C3\";\r\n}\r\n\r\n.mdi-arrow-up-circle::before {\r\n  content: \"\\F0CE1\";\r\n}\r\n\r\n.mdi-arrow-up-circle-outline::before {\r\n  content: \"\\F0CE2\";\r\n}\r\n\r\n.mdi-arrow-up-down::before {\r\n  content: \"\\F0E79\";\r\n}\r\n\r\n.mdi-arrow-up-down-bold::before {\r\n  content: \"\\F0E7A\";\r\n}\r\n\r\n.mdi-arrow-up-down-bold-outline::before {\r\n  content: \"\\F09C8\";\r\n}\r\n\r\n.mdi-arrow-up-drop-circle::before {\r\n  content: \"\\F0062\";\r\n}\r\n\r\n.mdi-arrow-up-drop-circle-outline::before {\r\n  content: \"\\F0063\";\r\n}\r\n\r\n.mdi-arrow-up-left::before {\r\n  content: \"\\F17BD\";\r\n}\r\n\r\n.mdi-arrow-up-left-bold::before {\r\n  content: \"\\F17BE\";\r\n}\r\n\r\n.mdi-arrow-up-right::before {\r\n  content: \"\\F17BF\";\r\n}\r\n\r\n.mdi-arrow-up-right-bold::before {\r\n  content: \"\\F17C0\";\r\n}\r\n\r\n.mdi-arrow-up-thick::before {\r\n  content: \"\\F005E\";\r\n}\r\n\r\n.mdi-arrow-up-thin::before {\r\n  content: \"\\F19B2\";\r\n}\r\n\r\n.mdi-arrow-up-thin-circle-outline::before {\r\n  content: \"\\F1597\";\r\n}\r\n\r\n.mdi-arrow-vertical-lock::before {\r\n  content: \"\\F115C\";\r\n}\r\n\r\n.mdi-artstation::before {\r\n  content: \"\\F0B5B\";\r\n}\r\n\r\n.mdi-aspect-ratio::before {\r\n  content: \"\\F0A24\";\r\n}\r\n\r\n.mdi-assistant::before {\r\n  content: \"\\F0064\";\r\n}\r\n\r\n.mdi-asterisk::before {\r\n  content: \"\\F06C4\";\r\n}\r\n\r\n.mdi-at::before {\r\n  content: \"\\F0065\";\r\n}\r\n\r\n.mdi-atlassian::before {\r\n  content: \"\\F0804\";\r\n}\r\n\r\n.mdi-atm::before {\r\n  content: \"\\F0D47\";\r\n}\r\n\r\n.mdi-atom::before {\r\n  content: \"\\F0768\";\r\n}\r\n\r\n.mdi-atom-variant::before {\r\n  content: \"\\F0E7B\";\r\n}\r\n\r\n.mdi-attachment::before {\r\n  content: \"\\F0066\";\r\n}\r\n\r\n.mdi-audio-input-rca::before {\r\n  content: \"\\F186B\";\r\n}\r\n\r\n.mdi-audio-input-stereo-minijack::before {\r\n  content: \"\\F186C\";\r\n}\r\n\r\n.mdi-audio-input-xlr::before {\r\n  content: \"\\F186D\";\r\n}\r\n\r\n.mdi-audio-video::before {\r\n  content: \"\\F093D\";\r\n}\r\n\r\n.mdi-audio-video-off::before {\r\n  content: \"\\F11B6\";\r\n}\r\n\r\n.mdi-augmented-reality::before {\r\n  content: \"\\F0850\";\r\n}\r\n\r\n.mdi-auto-download::before {\r\n  content: \"\\F137E\";\r\n}\r\n\r\n.mdi-auto-fix::before {\r\n  content: \"\\F0068\";\r\n}\r\n\r\n.mdi-auto-upload::before {\r\n  content: \"\\F0069\";\r\n}\r\n\r\n.mdi-autorenew::before {\r\n  content: \"\\F006A\";\r\n}\r\n\r\n.mdi-av-timer::before {\r\n  content: \"\\F006B\";\r\n}\r\n\r\n.mdi-aws::before {\r\n  content: \"\\F0E0F\";\r\n}\r\n\r\n.mdi-axe::before {\r\n  content: \"\\F08C8\";\r\n}\r\n\r\n.mdi-axe-battle::before {\r\n  content: \"\\F1842\";\r\n}\r\n\r\n.mdi-axis::before {\r\n  content: \"\\F0D48\";\r\n}\r\n\r\n.mdi-axis-arrow::before {\r\n  content: \"\\F0D49\";\r\n}\r\n\r\n.mdi-axis-arrow-info::before {\r\n  content: \"\\F140E\";\r\n}\r\n\r\n.mdi-axis-arrow-lock::before {\r\n  content: \"\\F0D4A\";\r\n}\r\n\r\n.mdi-axis-lock::before {\r\n  content: \"\\F0D4B\";\r\n}\r\n\r\n.mdi-axis-x-arrow::before {\r\n  content: \"\\F0D4C\";\r\n}\r\n\r\n.mdi-axis-x-arrow-lock::before {\r\n  content: \"\\F0D4D\";\r\n}\r\n\r\n.mdi-axis-x-rotate-clockwise::before {\r\n  content: \"\\F0D4E\";\r\n}\r\n\r\n.mdi-axis-x-rotate-counterclockwise::before {\r\n  content: \"\\F0D4F\";\r\n}\r\n\r\n.mdi-axis-x-y-arrow-lock::before {\r\n  content: \"\\F0D50\";\r\n}\r\n\r\n.mdi-axis-y-arrow::before {\r\n  content: \"\\F0D51\";\r\n}\r\n\r\n.mdi-axis-y-arrow-lock::before {\r\n  content: \"\\F0D52\";\r\n}\r\n\r\n.mdi-axis-y-rotate-clockwise::before {\r\n  content: \"\\F0D53\";\r\n}\r\n\r\n.mdi-axis-y-rotate-counterclockwise::before {\r\n  content: \"\\F0D54\";\r\n}\r\n\r\n.mdi-axis-z-arrow::before {\r\n  content: \"\\F0D55\";\r\n}\r\n\r\n.mdi-axis-z-arrow-lock::before {\r\n  content: \"\\F0D56\";\r\n}\r\n\r\n.mdi-axis-z-rotate-clockwise::before {\r\n  content: \"\\F0D57\";\r\n}\r\n\r\n.mdi-axis-z-rotate-counterclockwise::before {\r\n  content: \"\\F0D58\";\r\n}\r\n\r\n.mdi-babel::before {\r\n  content: \"\\F0A25\";\r\n}\r\n\r\n.mdi-baby::before {\r\n  content: \"\\F006C\";\r\n}\r\n\r\n.mdi-baby-bottle::before {\r\n  content: \"\\F0F39\";\r\n}\r\n\r\n.mdi-baby-bottle-outline::before {\r\n  content: \"\\F0F3A\";\r\n}\r\n\r\n.mdi-baby-buggy::before {\r\n  content: \"\\F13E0\";\r\n}\r\n\r\n.mdi-baby-carriage::before {\r\n  content: \"\\F068F\";\r\n}\r\n\r\n.mdi-baby-carriage-off::before {\r\n  content: \"\\F0FA0\";\r\n}\r\n\r\n.mdi-baby-face::before {\r\n  content: \"\\F0E7C\";\r\n}\r\n\r\n.mdi-baby-face-outline::before {\r\n  content: \"\\F0E7D\";\r\n}\r\n\r\n.mdi-backburger::before {\r\n  content: \"\\F006D\";\r\n}\r\n\r\n.mdi-backspace::before {\r\n  content: \"\\F006E\";\r\n}\r\n\r\n.mdi-backspace-outline::before {\r\n  content: \"\\F0B5C\";\r\n}\r\n\r\n.mdi-backspace-reverse::before {\r\n  content: \"\\F0E7E\";\r\n}\r\n\r\n.mdi-backspace-reverse-outline::before {\r\n  content: \"\\F0E7F\";\r\n}\r\n\r\n.mdi-backup-restore::before {\r\n  content: \"\\F006F\";\r\n}\r\n\r\n.mdi-bacteria::before {\r\n  content: \"\\F0ED5\";\r\n}\r\n\r\n.mdi-bacteria-outline::before {\r\n  content: \"\\F0ED6\";\r\n}\r\n\r\n.mdi-badge-account::before {\r\n  content: \"\\F0DA7\";\r\n}\r\n\r\n.mdi-badge-account-alert::before {\r\n  content: \"\\F0DA8\";\r\n}\r\n\r\n.mdi-badge-account-alert-outline::before {\r\n  content: \"\\F0DA9\";\r\n}\r\n\r\n.mdi-badge-account-horizontal::before {\r\n  content: \"\\F0E0D\";\r\n}\r\n\r\n.mdi-badge-account-horizontal-outline::before {\r\n  content: \"\\F0E0E\";\r\n}\r\n\r\n.mdi-badge-account-outline::before {\r\n  content: \"\\F0DAA\";\r\n}\r\n\r\n.mdi-badminton::before {\r\n  content: \"\\F0851\";\r\n}\r\n\r\n.mdi-bag-carry-on::before {\r\n  content: \"\\F0F3B\";\r\n}\r\n\r\n.mdi-bag-carry-on-check::before {\r\n  content: \"\\F0D65\";\r\n}\r\n\r\n.mdi-bag-carry-on-off::before {\r\n  content: \"\\F0F3C\";\r\n}\r\n\r\n.mdi-bag-checked::before {\r\n  content: \"\\F0F3D\";\r\n}\r\n\r\n.mdi-bag-personal::before {\r\n  content: \"\\F0E10\";\r\n}\r\n\r\n.mdi-bag-personal-off::before {\r\n  content: \"\\F0E11\";\r\n}\r\n\r\n.mdi-bag-personal-off-outline::before {\r\n  content: \"\\F0E12\";\r\n}\r\n\r\n.mdi-bag-personal-outline::before {\r\n  content: \"\\F0E13\";\r\n}\r\n\r\n.mdi-bag-suitcase::before {\r\n  content: \"\\F158B\";\r\n}\r\n\r\n.mdi-bag-suitcase-off::before {\r\n  content: \"\\F158D\";\r\n}\r\n\r\n.mdi-bag-suitcase-off-outline::before {\r\n  content: \"\\F158E\";\r\n}\r\n\r\n.mdi-bag-suitcase-outline::before {\r\n  content: \"\\F158C\";\r\n}\r\n\r\n.mdi-baguette::before {\r\n  content: \"\\F0F3E\";\r\n}\r\n\r\n.mdi-balcony::before {\r\n  content: \"\\F1817\";\r\n}\r\n\r\n.mdi-balloon::before {\r\n  content: \"\\F0A26\";\r\n}\r\n\r\n.mdi-ballot::before {\r\n  content: \"\\F09C9\";\r\n}\r\n\r\n.mdi-ballot-outline::before {\r\n  content: \"\\F09CA\";\r\n}\r\n\r\n.mdi-ballot-recount::before {\r\n  content: \"\\F0C39\";\r\n}\r\n\r\n.mdi-ballot-recount-outline::before {\r\n  content: \"\\F0C3A\";\r\n}\r\n\r\n.mdi-bandage::before {\r\n  content: \"\\F0DAF\";\r\n}\r\n\r\n.mdi-bank::before {\r\n  content: \"\\F0070\";\r\n}\r\n\r\n.mdi-bank-check::before {\r\n  content: \"\\F1655\";\r\n}\r\n\r\n.mdi-bank-minus::before {\r\n  content: \"\\F0DB0\";\r\n}\r\n\r\n.mdi-bank-off::before {\r\n  content: \"\\F1656\";\r\n}\r\n\r\n.mdi-bank-off-outline::before {\r\n  content: \"\\F1657\";\r\n}\r\n\r\n.mdi-bank-outline::before {\r\n  content: \"\\F0E80\";\r\n}\r\n\r\n.mdi-bank-plus::before {\r\n  content: \"\\F0DB1\";\r\n}\r\n\r\n.mdi-bank-remove::before {\r\n  content: \"\\F0DB2\";\r\n}\r\n\r\n.mdi-bank-transfer::before {\r\n  content: \"\\F0A27\";\r\n}\r\n\r\n.mdi-bank-transfer-in::before {\r\n  content: \"\\F0A28\";\r\n}\r\n\r\n.mdi-bank-transfer-out::before {\r\n  content: \"\\F0A29\";\r\n}\r\n\r\n.mdi-barcode::before {\r\n  content: \"\\F0071\";\r\n}\r\n\r\n.mdi-barcode-off::before {\r\n  content: \"\\F1236\";\r\n}\r\n\r\n.mdi-barcode-scan::before {\r\n  content: \"\\F0072\";\r\n}\r\n\r\n.mdi-barley::before {\r\n  content: \"\\F0073\";\r\n}\r\n\r\n.mdi-barley-off::before {\r\n  content: \"\\F0B5D\";\r\n}\r\n\r\n.mdi-barn::before {\r\n  content: \"\\F0B5E\";\r\n}\r\n\r\n.mdi-barrel::before {\r\n  content: \"\\F0074\";\r\n}\r\n\r\n.mdi-baseball::before {\r\n  content: \"\\F0852\";\r\n}\r\n\r\n.mdi-baseball-bat::before {\r\n  content: \"\\F0853\";\r\n}\r\n\r\n.mdi-baseball-diamond::before {\r\n  content: \"\\F15EC\";\r\n}\r\n\r\n.mdi-baseball-diamond-outline::before {\r\n  content: \"\\F15ED\";\r\n}\r\n\r\n.mdi-bash::before {\r\n  content: \"\\F1183\";\r\n}\r\n\r\n.mdi-basket::before {\r\n  content: \"\\F0076\";\r\n}\r\n\r\n.mdi-basket-check::before {\r\n  content: \"\\F18E5\";\r\n}\r\n\r\n.mdi-basket-check-outline::before {\r\n  content: \"\\F18E6\";\r\n}\r\n\r\n.mdi-basket-fill::before {\r\n  content: \"\\F0077\";\r\n}\r\n\r\n.mdi-basket-minus::before {\r\n  content: \"\\F1523\";\r\n}\r\n\r\n.mdi-basket-minus-outline::before {\r\n  content: \"\\F1524\";\r\n}\r\n\r\n.mdi-basket-off::before {\r\n  content: \"\\F1525\";\r\n}\r\n\r\n.mdi-basket-off-outline::before {\r\n  content: \"\\F1526\";\r\n}\r\n\r\n.mdi-basket-outline::before {\r\n  content: \"\\F1181\";\r\n}\r\n\r\n.mdi-basket-plus::before {\r\n  content: \"\\F1527\";\r\n}\r\n\r\n.mdi-basket-plus-outline::before {\r\n  content: \"\\F1528\";\r\n}\r\n\r\n.mdi-basket-remove::before {\r\n  content: \"\\F1529\";\r\n}\r\n\r\n.mdi-basket-remove-outline::before {\r\n  content: \"\\F152A\";\r\n}\r\n\r\n.mdi-basket-unfill::before {\r\n  content: \"\\F0078\";\r\n}\r\n\r\n.mdi-basketball::before {\r\n  content: \"\\F0806\";\r\n}\r\n\r\n.mdi-basketball-hoop::before {\r\n  content: \"\\F0C3B\";\r\n}\r\n\r\n.mdi-basketball-hoop-outline::before {\r\n  content: \"\\F0C3C\";\r\n}\r\n\r\n.mdi-bat::before {\r\n  content: \"\\F0B5F\";\r\n}\r\n\r\n.mdi-bathtub::before {\r\n  content: \"\\F1818\";\r\n}\r\n\r\n.mdi-bathtub-outline::before {\r\n  content: \"\\F1819\";\r\n}\r\n\r\n.mdi-battery::before {\r\n  content: \"\\F0079\";\r\n}\r\n\r\n.mdi-battery-10::before {\r\n  content: \"\\F007A\";\r\n}\r\n\r\n.mdi-battery-10-bluetooth::before {\r\n  content: \"\\F093E\";\r\n}\r\n\r\n.mdi-battery-20::before {\r\n  content: \"\\F007B\";\r\n}\r\n\r\n.mdi-battery-20-bluetooth::before {\r\n  content: \"\\F093F\";\r\n}\r\n\r\n.mdi-battery-30::before {\r\n  content: \"\\F007C\";\r\n}\r\n\r\n.mdi-battery-30-bluetooth::before {\r\n  content: \"\\F0940\";\r\n}\r\n\r\n.mdi-battery-40::before {\r\n  content: \"\\F007D\";\r\n}\r\n\r\n.mdi-battery-40-bluetooth::before {\r\n  content: \"\\F0941\";\r\n}\r\n\r\n.mdi-battery-50::before {\r\n  content: \"\\F007E\";\r\n}\r\n\r\n.mdi-battery-50-bluetooth::before {\r\n  content: \"\\F0942\";\r\n}\r\n\r\n.mdi-battery-60::before {\r\n  content: \"\\F007F\";\r\n}\r\n\r\n.mdi-battery-60-bluetooth::before {\r\n  content: \"\\F0943\";\r\n}\r\n\r\n.mdi-battery-70::before {\r\n  content: \"\\F0080\";\r\n}\r\n\r\n.mdi-battery-70-bluetooth::before {\r\n  content: \"\\F0944\";\r\n}\r\n\r\n.mdi-battery-80::before {\r\n  content: \"\\F0081\";\r\n}\r\n\r\n.mdi-battery-80-bluetooth::before {\r\n  content: \"\\F0945\";\r\n}\r\n\r\n.mdi-battery-90::before {\r\n  content: \"\\F0082\";\r\n}\r\n\r\n.mdi-battery-90-bluetooth::before {\r\n  content: \"\\F0946\";\r\n}\r\n\r\n.mdi-battery-alert::before {\r\n  content: \"\\F0083\";\r\n}\r\n\r\n.mdi-battery-alert-bluetooth::before {\r\n  content: \"\\F0947\";\r\n}\r\n\r\n.mdi-battery-alert-variant::before {\r\n  content: \"\\F10CC\";\r\n}\r\n\r\n.mdi-battery-alert-variant-outline::before {\r\n  content: \"\\F10CD\";\r\n}\r\n\r\n.mdi-battery-arrow-down::before {\r\n  content: \"\\F17DE\";\r\n}\r\n\r\n.mdi-battery-arrow-down-outline::before {\r\n  content: \"\\F17DF\";\r\n}\r\n\r\n.mdi-battery-arrow-up::before {\r\n  content: \"\\F17E0\";\r\n}\r\n\r\n.mdi-battery-arrow-up-outline::before {\r\n  content: \"\\F17E1\";\r\n}\r\n\r\n.mdi-battery-bluetooth::before {\r\n  content: \"\\F0948\";\r\n}\r\n\r\n.mdi-battery-bluetooth-variant::before {\r\n  content: \"\\F0949\";\r\n}\r\n\r\n.mdi-battery-charging::before {\r\n  content: \"\\F0084\";\r\n}\r\n\r\n.mdi-battery-charging-10::before {\r\n  content: \"\\F089C\";\r\n}\r\n\r\n.mdi-battery-charging-100::before {\r\n  content: \"\\F0085\";\r\n}\r\n\r\n.mdi-battery-charging-20::before {\r\n  content: \"\\F0086\";\r\n}\r\n\r\n.mdi-battery-charging-30::before {\r\n  content: \"\\F0087\";\r\n}\r\n\r\n.mdi-battery-charging-40::before {\r\n  content: \"\\F0088\";\r\n}\r\n\r\n.mdi-battery-charging-50::before {\r\n  content: \"\\F089D\";\r\n}\r\n\r\n.mdi-battery-charging-60::before {\r\n  content: \"\\F0089\";\r\n}\r\n\r\n.mdi-battery-charging-70::before {\r\n  content: \"\\F089E\";\r\n}\r\n\r\n.mdi-battery-charging-80::before {\r\n  content: \"\\F008A\";\r\n}\r\n\r\n.mdi-battery-charging-90::before {\r\n  content: \"\\F008B\";\r\n}\r\n\r\n.mdi-battery-charging-high::before {\r\n  content: \"\\F12A6\";\r\n}\r\n\r\n.mdi-battery-charging-low::before {\r\n  content: \"\\F12A4\";\r\n}\r\n\r\n.mdi-battery-charging-medium::before {\r\n  content: \"\\F12A5\";\r\n}\r\n\r\n.mdi-battery-charging-outline::before {\r\n  content: \"\\F089F\";\r\n}\r\n\r\n.mdi-battery-charging-wireless::before {\r\n  content: \"\\F0807\";\r\n}\r\n\r\n.mdi-battery-charging-wireless-10::before {\r\n  content: \"\\F0808\";\r\n}\r\n\r\n.mdi-battery-charging-wireless-20::before {\r\n  content: \"\\F0809\";\r\n}\r\n\r\n.mdi-battery-charging-wireless-30::before {\r\n  content: \"\\F080A\";\r\n}\r\n\r\n.mdi-battery-charging-wireless-40::before {\r\n  content: \"\\F080B\";\r\n}\r\n\r\n.mdi-battery-charging-wireless-50::before {\r\n  content: \"\\F080C\";\r\n}\r\n\r\n.mdi-battery-charging-wireless-60::before {\r\n  content: \"\\F080D\";\r\n}\r\n\r\n.mdi-battery-charging-wireless-70::before {\r\n  content: \"\\F080E\";\r\n}\r\n\r\n.mdi-battery-charging-wireless-80::before {\r\n  content: \"\\F080F\";\r\n}\r\n\r\n.mdi-battery-charging-wireless-90::before {\r\n  content: \"\\F0810\";\r\n}\r\n\r\n.mdi-battery-charging-wireless-alert::before {\r\n  content: \"\\F0811\";\r\n}\r\n\r\n.mdi-battery-charging-wireless-outline::before {\r\n  content: \"\\F0812\";\r\n}\r\n\r\n.mdi-battery-check::before {\r\n  content: \"\\F17E2\";\r\n}\r\n\r\n.mdi-battery-check-outline::before {\r\n  content: \"\\F17E3\";\r\n}\r\n\r\n.mdi-battery-heart::before {\r\n  content: \"\\F120F\";\r\n}\r\n\r\n.mdi-battery-heart-outline::before {\r\n  content: \"\\F1210\";\r\n}\r\n\r\n.mdi-battery-heart-variant::before {\r\n  content: \"\\F1211\";\r\n}\r\n\r\n.mdi-battery-high::before {\r\n  content: \"\\F12A3\";\r\n}\r\n\r\n.mdi-battery-lock::before {\r\n  content: \"\\F179C\";\r\n}\r\n\r\n.mdi-battery-lock-open::before {\r\n  content: \"\\F179D\";\r\n}\r\n\r\n.mdi-battery-low::before {\r\n  content: \"\\F12A1\";\r\n}\r\n\r\n.mdi-battery-medium::before {\r\n  content: \"\\F12A2\";\r\n}\r\n\r\n.mdi-battery-minus::before {\r\n  content: \"\\F17E4\";\r\n}\r\n\r\n.mdi-battery-minus-outline::before {\r\n  content: \"\\F17E5\";\r\n}\r\n\r\n.mdi-battery-minus-variant::before {\r\n  content: \"\\F008C\";\r\n}\r\n\r\n.mdi-battery-negative::before {\r\n  content: \"\\F008D\";\r\n}\r\n\r\n.mdi-battery-off::before {\r\n  content: \"\\F125D\";\r\n}\r\n\r\n.mdi-battery-off-outline::before {\r\n  content: \"\\F125E\";\r\n}\r\n\r\n.mdi-battery-outline::before {\r\n  content: \"\\F008E\";\r\n}\r\n\r\n.mdi-battery-plus::before {\r\n  content: \"\\F17E6\";\r\n}\r\n\r\n.mdi-battery-plus-outline::before {\r\n  content: \"\\F17E7\";\r\n}\r\n\r\n.mdi-battery-plus-variant::before {\r\n  content: \"\\F008F\";\r\n}\r\n\r\n.mdi-battery-positive::before {\r\n  content: \"\\F0090\";\r\n}\r\n\r\n.mdi-battery-remove::before {\r\n  content: \"\\F17E8\";\r\n}\r\n\r\n.mdi-battery-remove-outline::before {\r\n  content: \"\\F17E9\";\r\n}\r\n\r\n.mdi-battery-sync::before {\r\n  content: \"\\F1834\";\r\n}\r\n\r\n.mdi-battery-sync-outline::before {\r\n  content: \"\\F1835\";\r\n}\r\n\r\n.mdi-battery-unknown::before {\r\n  content: \"\\F0091\";\r\n}\r\n\r\n.mdi-battery-unknown-bluetooth::before {\r\n  content: \"\\F094A\";\r\n}\r\n\r\n.mdi-beach::before {\r\n  content: \"\\F0092\";\r\n}\r\n\r\n.mdi-beaker::before {\r\n  content: \"\\F0CEA\";\r\n}\r\n\r\n.mdi-beaker-alert::before {\r\n  content: \"\\F1229\";\r\n}\r\n\r\n.mdi-beaker-alert-outline::before {\r\n  content: \"\\F122A\";\r\n}\r\n\r\n.mdi-beaker-check::before {\r\n  content: \"\\F122B\";\r\n}\r\n\r\n.mdi-beaker-check-outline::before {\r\n  content: \"\\F122C\";\r\n}\r\n\r\n.mdi-beaker-minus::before {\r\n  content: \"\\F122D\";\r\n}\r\n\r\n.mdi-beaker-minus-outline::before {\r\n  content: \"\\F122E\";\r\n}\r\n\r\n.mdi-beaker-outline::before {\r\n  content: \"\\F0690\";\r\n}\r\n\r\n.mdi-beaker-plus::before {\r\n  content: \"\\F122F\";\r\n}\r\n\r\n.mdi-beaker-plus-outline::before {\r\n  content: \"\\F1230\";\r\n}\r\n\r\n.mdi-beaker-question::before {\r\n  content: \"\\F1231\";\r\n}\r\n\r\n.mdi-beaker-question-outline::before {\r\n  content: \"\\F1232\";\r\n}\r\n\r\n.mdi-beaker-remove::before {\r\n  content: \"\\F1233\";\r\n}\r\n\r\n.mdi-beaker-remove-outline::before {\r\n  content: \"\\F1234\";\r\n}\r\n\r\n.mdi-bed::before {\r\n  content: \"\\F02E3\";\r\n}\r\n\r\n.mdi-bed-double::before {\r\n  content: \"\\F0FD4\";\r\n}\r\n\r\n.mdi-bed-double-outline::before {\r\n  content: \"\\F0FD3\";\r\n}\r\n\r\n.mdi-bed-empty::before {\r\n  content: \"\\F08A0\";\r\n}\r\n\r\n.mdi-bed-king::before {\r\n  content: \"\\F0FD2\";\r\n}\r\n\r\n.mdi-bed-king-outline::before {\r\n  content: \"\\F0FD1\";\r\n}\r\n\r\n.mdi-bed-outline::before {\r\n  content: \"\\F0099\";\r\n}\r\n\r\n.mdi-bed-queen::before {\r\n  content: \"\\F0FD0\";\r\n}\r\n\r\n.mdi-bed-queen-outline::before {\r\n  content: \"\\F0FDB\";\r\n}\r\n\r\n.mdi-bed-single::before {\r\n  content: \"\\F106D\";\r\n}\r\n\r\n.mdi-bed-single-outline::before {\r\n  content: \"\\F106E\";\r\n}\r\n\r\n.mdi-bee::before {\r\n  content: \"\\F0FA1\";\r\n}\r\n\r\n.mdi-bee-flower::before {\r\n  content: \"\\F0FA2\";\r\n}\r\n\r\n.mdi-beehive-off-outline::before {\r\n  content: \"\\F13ED\";\r\n}\r\n\r\n.mdi-beehive-outline::before {\r\n  content: \"\\F10CE\";\r\n}\r\n\r\n.mdi-beekeeper::before {\r\n  content: \"\\F14E2\";\r\n}\r\n\r\n.mdi-beer::before {\r\n  content: \"\\F0098\";\r\n}\r\n\r\n.mdi-beer-outline::before {\r\n  content: \"\\F130C\";\r\n}\r\n\r\n.mdi-bell::before {\r\n  content: \"\\F009A\";\r\n}\r\n\r\n.mdi-bell-alert::before {\r\n  content: \"\\F0D59\";\r\n}\r\n\r\n.mdi-bell-alert-outline::before {\r\n  content: \"\\F0E81\";\r\n}\r\n\r\n.mdi-bell-badge::before {\r\n  content: \"\\F116B\";\r\n}\r\n\r\n.mdi-bell-badge-outline::before {\r\n  content: \"\\F0178\";\r\n}\r\n\r\n.mdi-bell-cancel::before {\r\n  content: \"\\F13E7\";\r\n}\r\n\r\n.mdi-bell-cancel-outline::before {\r\n  content: \"\\F13E8\";\r\n}\r\n\r\n.mdi-bell-check::before {\r\n  content: \"\\F11E5\";\r\n}\r\n\r\n.mdi-bell-check-outline::before {\r\n  content: \"\\F11E6\";\r\n}\r\n\r\n.mdi-bell-circle::before {\r\n  content: \"\\F0D5A\";\r\n}\r\n\r\n.mdi-bell-circle-outline::before {\r\n  content: \"\\F0D5B\";\r\n}\r\n\r\n.mdi-bell-minus::before {\r\n  content: \"\\F13E9\";\r\n}\r\n\r\n.mdi-bell-minus-outline::before {\r\n  content: \"\\F13EA\";\r\n}\r\n\r\n.mdi-bell-off::before {\r\n  content: \"\\F009B\";\r\n}\r\n\r\n.mdi-bell-off-outline::before {\r\n  content: \"\\F0A91\";\r\n}\r\n\r\n.mdi-bell-outline::before {\r\n  content: \"\\F009C\";\r\n}\r\n\r\n.mdi-bell-plus::before {\r\n  content: \"\\F009D\";\r\n}\r\n\r\n.mdi-bell-plus-outline::before {\r\n  content: \"\\F0A92\";\r\n}\r\n\r\n.mdi-bell-remove::before {\r\n  content: \"\\F13EB\";\r\n}\r\n\r\n.mdi-bell-remove-outline::before {\r\n  content: \"\\F13EC\";\r\n}\r\n\r\n.mdi-bell-ring::before {\r\n  content: \"\\F009E\";\r\n}\r\n\r\n.mdi-bell-ring-outline::before {\r\n  content: \"\\F009F\";\r\n}\r\n\r\n.mdi-bell-sleep::before {\r\n  content: \"\\F00A0\";\r\n}\r\n\r\n.mdi-bell-sleep-outline::before {\r\n  content: \"\\F0A93\";\r\n}\r\n\r\n.mdi-beta::before {\r\n  content: \"\\F00A1\";\r\n}\r\n\r\n.mdi-betamax::before {\r\n  content: \"\\F09CB\";\r\n}\r\n\r\n.mdi-biathlon::before {\r\n  content: \"\\F0E14\";\r\n}\r\n\r\n.mdi-bicycle::before {\r\n  content: \"\\F109C\";\r\n}\r\n\r\n.mdi-bicycle-basket::before {\r\n  content: \"\\F1235\";\r\n}\r\n\r\n.mdi-bicycle-cargo::before {\r\n  content: \"\\F189C\";\r\n}\r\n\r\n.mdi-bicycle-electric::before {\r\n  content: \"\\F15B4\";\r\n}\r\n\r\n.mdi-bicycle-penny-farthing::before {\r\n  content: \"\\F15E9\";\r\n}\r\n\r\n.mdi-bike::before {\r\n  content: \"\\F00A3\";\r\n}\r\n\r\n.mdi-bike-fast::before {\r\n  content: \"\\F111F\";\r\n}\r\n\r\n.mdi-billboard::before {\r\n  content: \"\\F1010\";\r\n}\r\n\r\n.mdi-billiards::before {\r\n  content: \"\\F0B61\";\r\n}\r\n\r\n.mdi-billiards-rack::before {\r\n  content: \"\\F0B62\";\r\n}\r\n\r\n.mdi-binoculars::before {\r\n  content: \"\\F00A5\";\r\n}\r\n\r\n.mdi-bio::before {\r\n  content: \"\\F00A6\";\r\n}\r\n\r\n.mdi-biohazard::before {\r\n  content: \"\\F00A7\";\r\n}\r\n\r\n.mdi-bird::before {\r\n  content: \"\\F15C6\";\r\n}\r\n\r\n.mdi-bitbucket::before {\r\n  content: \"\\F00A8\";\r\n}\r\n\r\n.mdi-bitcoin::before {\r\n  content: \"\\F0813\";\r\n}\r\n\r\n.mdi-black-mesa::before {\r\n  content: \"\\F00A9\";\r\n}\r\n\r\n.mdi-blender::before {\r\n  content: \"\\F0CEB\";\r\n}\r\n\r\n.mdi-blender-outline::before {\r\n  content: \"\\F181A\";\r\n}\r\n\r\n.mdi-blender-software::before {\r\n  content: \"\\F00AB\";\r\n}\r\n\r\n.mdi-blinds::before {\r\n  content: \"\\F00AC\";\r\n}\r\n\r\n.mdi-blinds-open::before {\r\n  content: \"\\F1011\";\r\n}\r\n\r\n.mdi-block-helper::before {\r\n  content: \"\\F00AD\";\r\n}\r\n\r\n.mdi-blood-bag::before {\r\n  content: \"\\F0CEC\";\r\n}\r\n\r\n.mdi-bluetooth::before {\r\n  content: \"\\F00AF\";\r\n}\r\n\r\n.mdi-bluetooth-audio::before {\r\n  content: \"\\F00B0\";\r\n}\r\n\r\n.mdi-bluetooth-connect::before {\r\n  content: \"\\F00B1\";\r\n}\r\n\r\n.mdi-bluetooth-off::before {\r\n  content: \"\\F00B2\";\r\n}\r\n\r\n.mdi-bluetooth-settings::before {\r\n  content: \"\\F00B3\";\r\n}\r\n\r\n.mdi-bluetooth-transfer::before {\r\n  content: \"\\F00B4\";\r\n}\r\n\r\n.mdi-blur::before {\r\n  content: \"\\F00B5\";\r\n}\r\n\r\n.mdi-blur-linear::before {\r\n  content: \"\\F00B6\";\r\n}\r\n\r\n.mdi-blur-off::before {\r\n  content: \"\\F00B7\";\r\n}\r\n\r\n.mdi-blur-radial::before {\r\n  content: \"\\F00B8\";\r\n}\r\n\r\n.mdi-bolt::before {\r\n  content: \"\\F0DB3\";\r\n}\r\n\r\n.mdi-bomb::before {\r\n  content: \"\\F0691\";\r\n}\r\n\r\n.mdi-bomb-off::before {\r\n  content: \"\\F06C5\";\r\n}\r\n\r\n.mdi-bone::before {\r\n  content: \"\\F00B9\";\r\n}\r\n\r\n.mdi-book::before {\r\n  content: \"\\F00BA\";\r\n}\r\n\r\n.mdi-book-account::before {\r\n  content: \"\\F13AD\";\r\n}\r\n\r\n.mdi-book-account-outline::before {\r\n  content: \"\\F13AE\";\r\n}\r\n\r\n.mdi-book-alert::before {\r\n  content: \"\\F167C\";\r\n}\r\n\r\n.mdi-book-alert-outline::before {\r\n  content: \"\\F167D\";\r\n}\r\n\r\n.mdi-book-alphabet::before {\r\n  content: \"\\F061D\";\r\n}\r\n\r\n.mdi-book-arrow-down::before {\r\n  content: \"\\F167E\";\r\n}\r\n\r\n.mdi-book-arrow-down-outline::before {\r\n  content: \"\\F167F\";\r\n}\r\n\r\n.mdi-book-arrow-left::before {\r\n  content: \"\\F1680\";\r\n}\r\n\r\n.mdi-book-arrow-left-outline::before {\r\n  content: \"\\F1681\";\r\n}\r\n\r\n.mdi-book-arrow-right::before {\r\n  content: \"\\F1682\";\r\n}\r\n\r\n.mdi-book-arrow-right-outline::before {\r\n  content: \"\\F1683\";\r\n}\r\n\r\n.mdi-book-arrow-up::before {\r\n  content: \"\\F1684\";\r\n}\r\n\r\n.mdi-book-arrow-up-outline::before {\r\n  content: \"\\F1685\";\r\n}\r\n\r\n.mdi-book-cancel::before {\r\n  content: \"\\F1686\";\r\n}\r\n\r\n.mdi-book-cancel-outline::before {\r\n  content: \"\\F1687\";\r\n}\r\n\r\n.mdi-book-check::before {\r\n  content: \"\\F14F3\";\r\n}\r\n\r\n.mdi-book-check-outline::before {\r\n  content: \"\\F14F4\";\r\n}\r\n\r\n.mdi-book-clock::before {\r\n  content: \"\\F1688\";\r\n}\r\n\r\n.mdi-book-clock-outline::before {\r\n  content: \"\\F1689\";\r\n}\r\n\r\n.mdi-book-cog::before {\r\n  content: \"\\F168A\";\r\n}\r\n\r\n.mdi-book-cog-outline::before {\r\n  content: \"\\F168B\";\r\n}\r\n\r\n.mdi-book-cross::before {\r\n  content: \"\\F00A2\";\r\n}\r\n\r\n.mdi-book-edit::before {\r\n  content: \"\\F168C\";\r\n}\r\n\r\n.mdi-book-edit-outline::before {\r\n  content: \"\\F168D\";\r\n}\r\n\r\n.mdi-book-education::before {\r\n  content: \"\\F16C9\";\r\n}\r\n\r\n.mdi-book-education-outline::before {\r\n  content: \"\\F16CA\";\r\n}\r\n\r\n.mdi-book-information-variant::before {\r\n  content: \"\\F106F\";\r\n}\r\n\r\n.mdi-book-lock::before {\r\n  content: \"\\F079A\";\r\n}\r\n\r\n.mdi-book-lock-open::before {\r\n  content: \"\\F079B\";\r\n}\r\n\r\n.mdi-book-lock-open-outline::before {\r\n  content: \"\\F168E\";\r\n}\r\n\r\n.mdi-book-lock-outline::before {\r\n  content: \"\\F168F\";\r\n}\r\n\r\n.mdi-book-marker::before {\r\n  content: \"\\F1690\";\r\n}\r\n\r\n.mdi-book-marker-outline::before {\r\n  content: \"\\F1691\";\r\n}\r\n\r\n.mdi-book-minus::before {\r\n  content: \"\\F05D9\";\r\n}\r\n\r\n.mdi-book-minus-multiple::before {\r\n  content: \"\\F0A94\";\r\n}\r\n\r\n.mdi-book-minus-multiple-outline::before {\r\n  content: \"\\F090B\";\r\n}\r\n\r\n.mdi-book-minus-outline::before {\r\n  content: \"\\F1692\";\r\n}\r\n\r\n.mdi-book-multiple::before {\r\n  content: \"\\F00BB\";\r\n}\r\n\r\n.mdi-book-multiple-outline::before {\r\n  content: \"\\F0436\";\r\n}\r\n\r\n.mdi-book-music::before {\r\n  content: \"\\F0067\";\r\n}\r\n\r\n.mdi-book-music-outline::before {\r\n  content: \"\\F1693\";\r\n}\r\n\r\n.mdi-book-off::before {\r\n  content: \"\\F1694\";\r\n}\r\n\r\n.mdi-book-off-outline::before {\r\n  content: \"\\F1695\";\r\n}\r\n\r\n.mdi-book-open::before {\r\n  content: \"\\F00BD\";\r\n}\r\n\r\n.mdi-book-open-blank-variant::before {\r\n  content: \"\\F00BE\";\r\n}\r\n\r\n.mdi-book-open-outline::before {\r\n  content: \"\\F0B63\";\r\n}\r\n\r\n.mdi-book-open-page-variant::before {\r\n  content: \"\\F05DA\";\r\n}\r\n\r\n.mdi-book-open-page-variant-outline::before {\r\n  content: \"\\F15D6\";\r\n}\r\n\r\n.mdi-book-open-variant::before {\r\n  content: \"\\F14F7\";\r\n}\r\n\r\n.mdi-book-outline::before {\r\n  content: \"\\F0B64\";\r\n}\r\n\r\n.mdi-book-play::before {\r\n  content: \"\\F0E82\";\r\n}\r\n\r\n.mdi-book-play-outline::before {\r\n  content: \"\\F0E83\";\r\n}\r\n\r\n.mdi-book-plus::before {\r\n  content: \"\\F05DB\";\r\n}\r\n\r\n.mdi-book-plus-multiple::before {\r\n  content: \"\\F0A95\";\r\n}\r\n\r\n.mdi-book-plus-multiple-outline::before {\r\n  content: \"\\F0ADE\";\r\n}\r\n\r\n.mdi-book-plus-outline::before {\r\n  content: \"\\F1696\";\r\n}\r\n\r\n.mdi-book-refresh::before {\r\n  content: \"\\F1697\";\r\n}\r\n\r\n.mdi-book-refresh-outline::before {\r\n  content: \"\\F1698\";\r\n}\r\n\r\n.mdi-book-remove::before {\r\n  content: \"\\F0A97\";\r\n}\r\n\r\n.mdi-book-remove-multiple::before {\r\n  content: \"\\F0A96\";\r\n}\r\n\r\n.mdi-book-remove-multiple-outline::before {\r\n  content: \"\\F04CA\";\r\n}\r\n\r\n.mdi-book-remove-outline::before {\r\n  content: \"\\F1699\";\r\n}\r\n\r\n.mdi-book-search::before {\r\n  content: \"\\F0E84\";\r\n}\r\n\r\n.mdi-book-search-outline::before {\r\n  content: \"\\F0E85\";\r\n}\r\n\r\n.mdi-book-settings::before {\r\n  content: \"\\F169A\";\r\n}\r\n\r\n.mdi-book-settings-outline::before {\r\n  content: \"\\F169B\";\r\n}\r\n\r\n.mdi-book-sync::before {\r\n  content: \"\\F169C\";\r\n}\r\n\r\n.mdi-book-sync-outline::before {\r\n  content: \"\\F16C8\";\r\n}\r\n\r\n.mdi-book-variant::before {\r\n  content: \"\\F00BF\";\r\n}\r\n\r\n.mdi-book-variant-multiple::before {\r\n  content: \"\\F00BC\";\r\n}\r\n\r\n.mdi-bookmark::before {\r\n  content: \"\\F00C0\";\r\n}\r\n\r\n.mdi-bookmark-box-multiple::before {\r\n  content: \"\\F196C\";\r\n}\r\n\r\n.mdi-bookmark-box-multiple-outline::before {\r\n  content: \"\\F196D\";\r\n}\r\n\r\n.mdi-bookmark-check::before {\r\n  content: \"\\F00C1\";\r\n}\r\n\r\n.mdi-bookmark-check-outline::before {\r\n  content: \"\\F137B\";\r\n}\r\n\r\n.mdi-bookmark-minus::before {\r\n  content: \"\\F09CC\";\r\n}\r\n\r\n.mdi-bookmark-minus-outline::before {\r\n  content: \"\\F09CD\";\r\n}\r\n\r\n.mdi-bookmark-multiple::before {\r\n  content: \"\\F0E15\";\r\n}\r\n\r\n.mdi-bookmark-multiple-outline::before {\r\n  content: \"\\F0E16\";\r\n}\r\n\r\n.mdi-bookmark-music::before {\r\n  content: \"\\F00C2\";\r\n}\r\n\r\n.mdi-bookmark-music-outline::before {\r\n  content: \"\\F1379\";\r\n}\r\n\r\n.mdi-bookmark-off::before {\r\n  content: \"\\F09CE\";\r\n}\r\n\r\n.mdi-bookmark-off-outline::before {\r\n  content: \"\\F09CF\";\r\n}\r\n\r\n.mdi-bookmark-outline::before {\r\n  content: \"\\F00C3\";\r\n}\r\n\r\n.mdi-bookmark-plus::before {\r\n  content: \"\\F00C5\";\r\n}\r\n\r\n.mdi-bookmark-plus-outline::before {\r\n  content: \"\\F00C4\";\r\n}\r\n\r\n.mdi-bookmark-remove::before {\r\n  content: \"\\F00C6\";\r\n}\r\n\r\n.mdi-bookmark-remove-outline::before {\r\n  content: \"\\F137A\";\r\n}\r\n\r\n.mdi-bookshelf::before {\r\n  content: \"\\F125F\";\r\n}\r\n\r\n.mdi-boom-gate::before {\r\n  content: \"\\F0E86\";\r\n}\r\n\r\n.mdi-boom-gate-alert::before {\r\n  content: \"\\F0E87\";\r\n}\r\n\r\n.mdi-boom-gate-alert-outline::before {\r\n  content: \"\\F0E88\";\r\n}\r\n\r\n.mdi-boom-gate-arrow-down::before {\r\n  content: \"\\F0E89\";\r\n}\r\n\r\n.mdi-boom-gate-arrow-down-outline::before {\r\n  content: \"\\F0E8A\";\r\n}\r\n\r\n.mdi-boom-gate-arrow-up::before {\r\n  content: \"\\F0E8C\";\r\n}\r\n\r\n.mdi-boom-gate-arrow-up-outline::before {\r\n  content: \"\\F0E8D\";\r\n}\r\n\r\n.mdi-boom-gate-outline::before {\r\n  content: \"\\F0E8B\";\r\n}\r\n\r\n.mdi-boom-gate-up::before {\r\n  content: \"\\F17F9\";\r\n}\r\n\r\n.mdi-boom-gate-up-outline::before {\r\n  content: \"\\F17FA\";\r\n}\r\n\r\n.mdi-boombox::before {\r\n  content: \"\\F05DC\";\r\n}\r\n\r\n.mdi-boomerang::before {\r\n  content: \"\\F10CF\";\r\n}\r\n\r\n.mdi-bootstrap::before {\r\n  content: \"\\F06C6\";\r\n}\r\n\r\n.mdi-border-all::before {\r\n  content: \"\\F00C7\";\r\n}\r\n\r\n.mdi-border-all-variant::before {\r\n  content: \"\\F08A1\";\r\n}\r\n\r\n.mdi-border-bottom::before {\r\n  content: \"\\F00C8\";\r\n}\r\n\r\n.mdi-border-bottom-variant::before {\r\n  content: \"\\F08A2\";\r\n}\r\n\r\n.mdi-border-color::before {\r\n  content: \"\\F00C9\";\r\n}\r\n\r\n.mdi-border-horizontal::before {\r\n  content: \"\\F00CA\";\r\n}\r\n\r\n.mdi-border-inside::before {\r\n  content: \"\\F00CB\";\r\n}\r\n\r\n.mdi-border-left::before {\r\n  content: \"\\F00CC\";\r\n}\r\n\r\n.mdi-border-left-variant::before {\r\n  content: \"\\F08A3\";\r\n}\r\n\r\n.mdi-border-none::before {\r\n  content: \"\\F00CD\";\r\n}\r\n\r\n.mdi-border-none-variant::before {\r\n  content: \"\\F08A4\";\r\n}\r\n\r\n.mdi-border-outside::before {\r\n  content: \"\\F00CE\";\r\n}\r\n\r\n.mdi-border-right::before {\r\n  content: \"\\F00CF\";\r\n}\r\n\r\n.mdi-border-right-variant::before {\r\n  content: \"\\F08A5\";\r\n}\r\n\r\n.mdi-border-style::before {\r\n  content: \"\\F00D0\";\r\n}\r\n\r\n.mdi-border-top::before {\r\n  content: \"\\F00D1\";\r\n}\r\n\r\n.mdi-border-top-variant::before {\r\n  content: \"\\F08A6\";\r\n}\r\n\r\n.mdi-border-vertical::before {\r\n  content: \"\\F00D2\";\r\n}\r\n\r\n.mdi-bottle-soda::before {\r\n  content: \"\\F1070\";\r\n}\r\n\r\n.mdi-bottle-soda-classic::before {\r\n  content: \"\\F1071\";\r\n}\r\n\r\n.mdi-bottle-soda-classic-outline::before {\r\n  content: \"\\F1363\";\r\n}\r\n\r\n.mdi-bottle-soda-outline::before {\r\n  content: \"\\F1072\";\r\n}\r\n\r\n.mdi-bottle-tonic::before {\r\n  content: \"\\F112E\";\r\n}\r\n\r\n.mdi-bottle-tonic-outline::before {\r\n  content: \"\\F112F\";\r\n}\r\n\r\n.mdi-bottle-tonic-plus::before {\r\n  content: \"\\F1130\";\r\n}\r\n\r\n.mdi-bottle-tonic-plus-outline::before {\r\n  content: \"\\F1131\";\r\n}\r\n\r\n.mdi-bottle-tonic-skull::before {\r\n  content: \"\\F1132\";\r\n}\r\n\r\n.mdi-bottle-tonic-skull-outline::before {\r\n  content: \"\\F1133\";\r\n}\r\n\r\n.mdi-bottle-wine::before {\r\n  content: \"\\F0854\";\r\n}\r\n\r\n.mdi-bottle-wine-outline::before {\r\n  content: \"\\F1310\";\r\n}\r\n\r\n.mdi-bow-arrow::before {\r\n  content: \"\\F1841\";\r\n}\r\n\r\n.mdi-bow-tie::before {\r\n  content: \"\\F0678\";\r\n}\r\n\r\n.mdi-bowl::before {\r\n  content: \"\\F028E\";\r\n}\r\n\r\n.mdi-bowl-mix::before {\r\n  content: \"\\F0617\";\r\n}\r\n\r\n.mdi-bowl-mix-outline::before {\r\n  content: \"\\F02E4\";\r\n}\r\n\r\n.mdi-bowl-outline::before {\r\n  content: \"\\F02A9\";\r\n}\r\n\r\n.mdi-bowling::before {\r\n  content: \"\\F00D3\";\r\n}\r\n\r\n.mdi-box::before {\r\n  content: \"\\F00D4\";\r\n}\r\n\r\n.mdi-box-cutter::before {\r\n  content: \"\\F00D5\";\r\n}\r\n\r\n.mdi-box-cutter-off::before {\r\n  content: \"\\F0B4A\";\r\n}\r\n\r\n.mdi-box-shadow::before {\r\n  content: \"\\F0637\";\r\n}\r\n\r\n.mdi-boxing-glove::before {\r\n  content: \"\\F0B65\";\r\n}\r\n\r\n.mdi-braille::before {\r\n  content: \"\\F09D0\";\r\n}\r\n\r\n.mdi-brain::before {\r\n  content: \"\\F09D1\";\r\n}\r\n\r\n.mdi-bread-slice::before {\r\n  content: \"\\F0CEE\";\r\n}\r\n\r\n.mdi-bread-slice-outline::before {\r\n  content: \"\\F0CEF\";\r\n}\r\n\r\n.mdi-bridge::before {\r\n  content: \"\\F0618\";\r\n}\r\n\r\n.mdi-briefcase::before {\r\n  content: \"\\F00D6\";\r\n}\r\n\r\n.mdi-briefcase-account::before {\r\n  content: \"\\F0CF0\";\r\n}\r\n\r\n.mdi-briefcase-account-outline::before {\r\n  content: \"\\F0CF1\";\r\n}\r\n\r\n.mdi-briefcase-check::before {\r\n  content: \"\\F00D7\";\r\n}\r\n\r\n.mdi-briefcase-check-outline::before {\r\n  content: \"\\F131E\";\r\n}\r\n\r\n.mdi-briefcase-clock::before {\r\n  content: \"\\F10D0\";\r\n}\r\n\r\n.mdi-briefcase-clock-outline::before {\r\n  content: \"\\F10D1\";\r\n}\r\n\r\n.mdi-briefcase-download::before {\r\n  content: \"\\F00D8\";\r\n}\r\n\r\n.mdi-briefcase-download-outline::before {\r\n  content: \"\\F0C3D\";\r\n}\r\n\r\n.mdi-briefcase-edit::before {\r\n  content: \"\\F0A98\";\r\n}\r\n\r\n.mdi-briefcase-edit-outline::before {\r\n  content: \"\\F0C3E\";\r\n}\r\n\r\n.mdi-briefcase-eye::before {\r\n  content: \"\\F17D9\";\r\n}\r\n\r\n.mdi-briefcase-eye-outline::before {\r\n  content: \"\\F17DA\";\r\n}\r\n\r\n.mdi-briefcase-minus::before {\r\n  content: \"\\F0A2A\";\r\n}\r\n\r\n.mdi-briefcase-minus-outline::before {\r\n  content: \"\\F0C3F\";\r\n}\r\n\r\n.mdi-briefcase-off::before {\r\n  content: \"\\F1658\";\r\n}\r\n\r\n.mdi-briefcase-off-outline::before {\r\n  content: \"\\F1659\";\r\n}\r\n\r\n.mdi-briefcase-outline::before {\r\n  content: \"\\F0814\";\r\n}\r\n\r\n.mdi-briefcase-plus::before {\r\n  content: \"\\F0A2B\";\r\n}\r\n\r\n.mdi-briefcase-plus-outline::before {\r\n  content: \"\\F0C40\";\r\n}\r\n\r\n.mdi-briefcase-remove::before {\r\n  content: \"\\F0A2C\";\r\n}\r\n\r\n.mdi-briefcase-remove-outline::before {\r\n  content: \"\\F0C41\";\r\n}\r\n\r\n.mdi-briefcase-search::before {\r\n  content: \"\\F0A2D\";\r\n}\r\n\r\n.mdi-briefcase-search-outline::before {\r\n  content: \"\\F0C42\";\r\n}\r\n\r\n.mdi-briefcase-upload::before {\r\n  content: \"\\F00D9\";\r\n}\r\n\r\n.mdi-briefcase-upload-outline::before {\r\n  content: \"\\F0C43\";\r\n}\r\n\r\n.mdi-briefcase-variant::before {\r\n  content: \"\\F1494\";\r\n}\r\n\r\n.mdi-briefcase-variant-off::before {\r\n  content: \"\\F165A\";\r\n}\r\n\r\n.mdi-briefcase-variant-off-outline::before {\r\n  content: \"\\F165B\";\r\n}\r\n\r\n.mdi-briefcase-variant-outline::before {\r\n  content: \"\\F1495\";\r\n}\r\n\r\n.mdi-brightness-1::before {\r\n  content: \"\\F00DA\";\r\n}\r\n\r\n.mdi-brightness-2::before {\r\n  content: \"\\F00DB\";\r\n}\r\n\r\n.mdi-brightness-3::before {\r\n  content: \"\\F00DC\";\r\n}\r\n\r\n.mdi-brightness-4::before {\r\n  content: \"\\F00DD\";\r\n}\r\n\r\n.mdi-brightness-5::before {\r\n  content: \"\\F00DE\";\r\n}\r\n\r\n.mdi-brightness-6::before {\r\n  content: \"\\F00DF\";\r\n}\r\n\r\n.mdi-brightness-7::before {\r\n  content: \"\\F00E0\";\r\n}\r\n\r\n.mdi-brightness-auto::before {\r\n  content: \"\\F00E1\";\r\n}\r\n\r\n.mdi-brightness-percent::before {\r\n  content: \"\\F0CF2\";\r\n}\r\n\r\n.mdi-broadcast::before {\r\n  content: \"\\F1720\";\r\n}\r\n\r\n.mdi-broadcast-off::before {\r\n  content: \"\\F1721\";\r\n}\r\n\r\n.mdi-broom::before {\r\n  content: \"\\F00E2\";\r\n}\r\n\r\n.mdi-brush::before {\r\n  content: \"\\F00E3\";\r\n}\r\n\r\n.mdi-brush-off::before {\r\n  content: \"\\F1771\";\r\n}\r\n\r\n.mdi-brush-variant::before {\r\n  content: \"\\F1813\";\r\n}\r\n\r\n.mdi-bucket::before {\r\n  content: \"\\F1415\";\r\n}\r\n\r\n.mdi-bucket-outline::before {\r\n  content: \"\\F1416\";\r\n}\r\n\r\n.mdi-buffet::before {\r\n  content: \"\\F0578\";\r\n}\r\n\r\n.mdi-bug::before {\r\n  content: \"\\F00E4\";\r\n}\r\n\r\n.mdi-bug-check::before {\r\n  content: \"\\F0A2E\";\r\n}\r\n\r\n.mdi-bug-check-outline::before {\r\n  content: \"\\F0A2F\";\r\n}\r\n\r\n.mdi-bug-outline::before {\r\n  content: \"\\F0A30\";\r\n}\r\n\r\n.mdi-bugle::before {\r\n  content: \"\\F0DB4\";\r\n}\r\n\r\n.mdi-bulldozer::before {\r\n  content: \"\\F0B22\";\r\n}\r\n\r\n.mdi-bullet::before {\r\n  content: \"\\F0CF3\";\r\n}\r\n\r\n.mdi-bulletin-board::before {\r\n  content: \"\\F00E5\";\r\n}\r\n\r\n.mdi-bullhorn::before {\r\n  content: \"\\F00E6\";\r\n}\r\n\r\n.mdi-bullhorn-outline::before {\r\n  content: \"\\F0B23\";\r\n}\r\n\r\n.mdi-bullhorn-variant::before {\r\n  content: \"\\F196E\";\r\n}\r\n\r\n.mdi-bullhorn-variant-outline::before {\r\n  content: \"\\F196F\";\r\n}\r\n\r\n.mdi-bullseye::before {\r\n  content: \"\\F05DD\";\r\n}\r\n\r\n.mdi-bullseye-arrow::before {\r\n  content: \"\\F08C9\";\r\n}\r\n\r\n.mdi-bulma::before {\r\n  content: \"\\F12E7\";\r\n}\r\n\r\n.mdi-bunk-bed::before {\r\n  content: \"\\F1302\";\r\n}\r\n\r\n.mdi-bunk-bed-outline::before {\r\n  content: \"\\F0097\";\r\n}\r\n\r\n.mdi-bus::before {\r\n  content: \"\\F00E7\";\r\n}\r\n\r\n.mdi-bus-alert::before {\r\n  content: \"\\F0A99\";\r\n}\r\n\r\n.mdi-bus-articulated-end::before {\r\n  content: \"\\F079C\";\r\n}\r\n\r\n.mdi-bus-articulated-front::before {\r\n  content: \"\\F079D\";\r\n}\r\n\r\n.mdi-bus-clock::before {\r\n  content: \"\\F08CA\";\r\n}\r\n\r\n.mdi-bus-double-decker::before {\r\n  content: \"\\F079E\";\r\n}\r\n\r\n.mdi-bus-electric::before {\r\n  content: \"\\F191D\";\r\n}\r\n\r\n.mdi-bus-marker::before {\r\n  content: \"\\F1212\";\r\n}\r\n\r\n.mdi-bus-multiple::before {\r\n  content: \"\\F0F3F\";\r\n}\r\n\r\n.mdi-bus-school::before {\r\n  content: \"\\F079F\";\r\n}\r\n\r\n.mdi-bus-side::before {\r\n  content: \"\\F07A0\";\r\n}\r\n\r\n.mdi-bus-stop::before {\r\n  content: \"\\F1012\";\r\n}\r\n\r\n.mdi-bus-stop-covered::before {\r\n  content: \"\\F1013\";\r\n}\r\n\r\n.mdi-bus-stop-uncovered::before {\r\n  content: \"\\F1014\";\r\n}\r\n\r\n.mdi-butterfly::before {\r\n  content: \"\\F1589\";\r\n}\r\n\r\n.mdi-butterfly-outline::before {\r\n  content: \"\\F158A\";\r\n}\r\n\r\n.mdi-cabin-a-frame::before {\r\n  content: \"\\F188C\";\r\n}\r\n\r\n.mdi-cable-data::before {\r\n  content: \"\\F1394\";\r\n}\r\n\r\n.mdi-cached::before {\r\n  content: \"\\F00E8\";\r\n}\r\n\r\n.mdi-cactus::before {\r\n  content: \"\\F0DB5\";\r\n}\r\n\r\n.mdi-cake::before {\r\n  content: \"\\F00E9\";\r\n}\r\n\r\n.mdi-cake-layered::before {\r\n  content: \"\\F00EA\";\r\n}\r\n\r\n.mdi-cake-variant::before {\r\n  content: \"\\F00EB\";\r\n}\r\n\r\n.mdi-cake-variant-outline::before {\r\n  content: \"\\F17F0\";\r\n}\r\n\r\n.mdi-calculator::before {\r\n  content: \"\\F00EC\";\r\n}\r\n\r\n.mdi-calculator-variant::before {\r\n  content: \"\\F0A9A\";\r\n}\r\n\r\n.mdi-calculator-variant-outline::before {\r\n  content: \"\\F15A6\";\r\n}\r\n\r\n.mdi-calendar::before {\r\n  content: \"\\F00ED\";\r\n}\r\n\r\n.mdi-calendar-account::before {\r\n  content: \"\\F0ED7\";\r\n}\r\n\r\n.mdi-calendar-account-outline::before {\r\n  content: \"\\F0ED8\";\r\n}\r\n\r\n.mdi-calendar-alert::before {\r\n  content: \"\\F0A31\";\r\n}\r\n\r\n.mdi-calendar-arrow-left::before {\r\n  content: \"\\F1134\";\r\n}\r\n\r\n.mdi-calendar-arrow-right::before {\r\n  content: \"\\F1135\";\r\n}\r\n\r\n.mdi-calendar-blank::before {\r\n  content: \"\\F00EE\";\r\n}\r\n\r\n.mdi-calendar-blank-multiple::before {\r\n  content: \"\\F1073\";\r\n}\r\n\r\n.mdi-calendar-blank-outline::before {\r\n  content: \"\\F0B66\";\r\n}\r\n\r\n.mdi-calendar-check::before {\r\n  content: \"\\F00EF\";\r\n}\r\n\r\n.mdi-calendar-check-outline::before {\r\n  content: \"\\F0C44\";\r\n}\r\n\r\n.mdi-calendar-clock::before {\r\n  content: \"\\F00F0\";\r\n}\r\n\r\n.mdi-calendar-clock-outline::before {\r\n  content: \"\\F16E1\";\r\n}\r\n\r\n.mdi-calendar-collapse-horizontal::before {\r\n  content: \"\\F189D\";\r\n}\r\n\r\n.mdi-calendar-cursor::before {\r\n  content: \"\\F157B\";\r\n}\r\n\r\n.mdi-calendar-edit::before {\r\n  content: \"\\F08A7\";\r\n}\r\n\r\n.mdi-calendar-end::before {\r\n  content: \"\\F166C\";\r\n}\r\n\r\n.mdi-calendar-expand-horizontal::before {\r\n  content: \"\\F189E\";\r\n}\r\n\r\n.mdi-calendar-export::before {\r\n  content: \"\\F0B24\";\r\n}\r\n\r\n.mdi-calendar-heart::before {\r\n  content: \"\\F09D2\";\r\n}\r\n\r\n.mdi-calendar-import::before {\r\n  content: \"\\F0B25\";\r\n}\r\n\r\n.mdi-calendar-lock::before {\r\n  content: \"\\F1641\";\r\n}\r\n\r\n.mdi-calendar-lock-outline::before {\r\n  content: \"\\F1642\";\r\n}\r\n\r\n.mdi-calendar-minus::before {\r\n  content: \"\\F0D5C\";\r\n}\r\n\r\n.mdi-calendar-month::before {\r\n  content: \"\\F0E17\";\r\n}\r\n\r\n.mdi-calendar-month-outline::before {\r\n  content: \"\\F0E18\";\r\n}\r\n\r\n.mdi-calendar-multiple::before {\r\n  content: \"\\F00F1\";\r\n}\r\n\r\n.mdi-calendar-multiple-check::before {\r\n  content: \"\\F00F2\";\r\n}\r\n\r\n.mdi-calendar-multiselect::before {\r\n  content: \"\\F0A32\";\r\n}\r\n\r\n.mdi-calendar-outline::before {\r\n  content: \"\\F0B67\";\r\n}\r\n\r\n.mdi-calendar-plus::before {\r\n  content: \"\\F00F3\";\r\n}\r\n\r\n.mdi-calendar-question::before {\r\n  content: \"\\F0692\";\r\n}\r\n\r\n.mdi-calendar-range::before {\r\n  content: \"\\F0679\";\r\n}\r\n\r\n.mdi-calendar-range-outline::before {\r\n  content: \"\\F0B68\";\r\n}\r\n\r\n.mdi-calendar-refresh::before {\r\n  content: \"\\F01E1\";\r\n}\r\n\r\n.mdi-calendar-refresh-outline::before {\r\n  content: \"\\F0203\";\r\n}\r\n\r\n.mdi-calendar-remove::before {\r\n  content: \"\\F00F4\";\r\n}\r\n\r\n.mdi-calendar-remove-outline::before {\r\n  content: \"\\F0C45\";\r\n}\r\n\r\n.mdi-calendar-search::before {\r\n  content: \"\\F094C\";\r\n}\r\n\r\n.mdi-calendar-star::before {\r\n  content: \"\\F09D3\";\r\n}\r\n\r\n.mdi-calendar-start::before {\r\n  content: \"\\F166D\";\r\n}\r\n\r\n.mdi-calendar-sync::before {\r\n  content: \"\\F0E8E\";\r\n}\r\n\r\n.mdi-calendar-sync-outline::before {\r\n  content: \"\\F0E8F\";\r\n}\r\n\r\n.mdi-calendar-text::before {\r\n  content: \"\\F00F5\";\r\n}\r\n\r\n.mdi-calendar-text-outline::before {\r\n  content: \"\\F0C46\";\r\n}\r\n\r\n.mdi-calendar-today::before {\r\n  content: \"\\F00F6\";\r\n}\r\n\r\n.mdi-calendar-week::before {\r\n  content: \"\\F0A33\";\r\n}\r\n\r\n.mdi-calendar-week-begin::before {\r\n  content: \"\\F0A34\";\r\n}\r\n\r\n.mdi-calendar-weekend::before {\r\n  content: \"\\F0ED9\";\r\n}\r\n\r\n.mdi-calendar-weekend-outline::before {\r\n  content: \"\\F0EDA\";\r\n}\r\n\r\n.mdi-call-made::before {\r\n  content: \"\\F00F7\";\r\n}\r\n\r\n.mdi-call-merge::before {\r\n  content: \"\\F00F8\";\r\n}\r\n\r\n.mdi-call-missed::before {\r\n  content: \"\\F00F9\";\r\n}\r\n\r\n.mdi-call-received::before {\r\n  content: \"\\F00FA\";\r\n}\r\n\r\n.mdi-call-split::before {\r\n  content: \"\\F00FB\";\r\n}\r\n\r\n.mdi-camcorder::before {\r\n  content: \"\\F00FC\";\r\n}\r\n\r\n.mdi-camcorder-off::before {\r\n  content: \"\\F00FF\";\r\n}\r\n\r\n.mdi-camera::before {\r\n  content: \"\\F0100\";\r\n}\r\n\r\n.mdi-camera-account::before {\r\n  content: \"\\F08CB\";\r\n}\r\n\r\n.mdi-camera-burst::before {\r\n  content: \"\\F0693\";\r\n}\r\n\r\n.mdi-camera-control::before {\r\n  content: \"\\F0B69\";\r\n}\r\n\r\n.mdi-camera-document::before {\r\n  content: \"\\F1871\";\r\n}\r\n\r\n.mdi-camera-document-off::before {\r\n  content: \"\\F1872\";\r\n}\r\n\r\n.mdi-camera-enhance::before {\r\n  content: \"\\F0101\";\r\n}\r\n\r\n.mdi-camera-enhance-outline::before {\r\n  content: \"\\F0B6A\";\r\n}\r\n\r\n.mdi-camera-flip::before {\r\n  content: \"\\F15D9\";\r\n}\r\n\r\n.mdi-camera-flip-outline::before {\r\n  content: \"\\F15DA\";\r\n}\r\n\r\n.mdi-camera-front::before {\r\n  content: \"\\F0102\";\r\n}\r\n\r\n.mdi-camera-front-variant::before {\r\n  content: \"\\F0103\";\r\n}\r\n\r\n.mdi-camera-gopro::before {\r\n  content: \"\\F07A1\";\r\n}\r\n\r\n.mdi-camera-image::before {\r\n  content: \"\\F08CC\";\r\n}\r\n\r\n.mdi-camera-iris::before {\r\n  content: \"\\F0104\";\r\n}\r\n\r\n.mdi-camera-marker::before {\r\n  content: \"\\F19A7\";\r\n}\r\n\r\n.mdi-camera-marker-outline::before {\r\n  content: \"\\F19A8\";\r\n}\r\n\r\n.mdi-camera-metering-center::before {\r\n  content: \"\\F07A2\";\r\n}\r\n\r\n.mdi-camera-metering-matrix::before {\r\n  content: \"\\F07A3\";\r\n}\r\n\r\n.mdi-camera-metering-partial::before {\r\n  content: \"\\F07A4\";\r\n}\r\n\r\n.mdi-camera-metering-spot::before {\r\n  content: \"\\F07A5\";\r\n}\r\n\r\n.mdi-camera-off::before {\r\n  content: \"\\F05DF\";\r\n}\r\n\r\n.mdi-camera-off-outline::before {\r\n  content: \"\\F19BF\";\r\n}\r\n\r\n.mdi-camera-outline::before {\r\n  content: \"\\F0D5D\";\r\n}\r\n\r\n.mdi-camera-party-mode::before {\r\n  content: \"\\F0105\";\r\n}\r\n\r\n.mdi-camera-plus::before {\r\n  content: \"\\F0EDB\";\r\n}\r\n\r\n.mdi-camera-plus-outline::before {\r\n  content: \"\\F0EDC\";\r\n}\r\n\r\n.mdi-camera-rear::before {\r\n  content: \"\\F0106\";\r\n}\r\n\r\n.mdi-camera-rear-variant::before {\r\n  content: \"\\F0107\";\r\n}\r\n\r\n.mdi-camera-retake::before {\r\n  content: \"\\F0E19\";\r\n}\r\n\r\n.mdi-camera-retake-outline::before {\r\n  content: \"\\F0E1A\";\r\n}\r\n\r\n.mdi-camera-switch::before {\r\n  content: \"\\F0108\";\r\n}\r\n\r\n.mdi-camera-switch-outline::before {\r\n  content: \"\\F084A\";\r\n}\r\n\r\n.mdi-camera-timer::before {\r\n  content: \"\\F0109\";\r\n}\r\n\r\n.mdi-camera-wireless::before {\r\n  content: \"\\F0DB6\";\r\n}\r\n\r\n.mdi-camera-wireless-outline::before {\r\n  content: \"\\F0DB7\";\r\n}\r\n\r\n.mdi-campfire::before {\r\n  content: \"\\F0EDD\";\r\n}\r\n\r\n.mdi-cancel::before {\r\n  content: \"\\F073A\";\r\n}\r\n\r\n.mdi-candelabra::before {\r\n  content: \"\\F17D2\";\r\n}\r\n\r\n.mdi-candelabra-fire::before {\r\n  content: \"\\F17D3\";\r\n}\r\n\r\n.mdi-candle::before {\r\n  content: \"\\F05E2\";\r\n}\r\n\r\n.mdi-candy::before {\r\n  content: \"\\F1970\";\r\n}\r\n\r\n.mdi-candy-off::before {\r\n  content: \"\\F1971\";\r\n}\r\n\r\n.mdi-candy-off-outline::before {\r\n  content: \"\\F1972\";\r\n}\r\n\r\n.mdi-candy-outline::before {\r\n  content: \"\\F1973\";\r\n}\r\n\r\n.mdi-candycane::before {\r\n  content: \"\\F010A\";\r\n}\r\n\r\n.mdi-cannabis::before {\r\n  content: \"\\F07A6\";\r\n}\r\n\r\n.mdi-cannabis-off::before {\r\n  content: \"\\F166E\";\r\n}\r\n\r\n.mdi-caps-lock::before {\r\n  content: \"\\F0A9B\";\r\n}\r\n\r\n.mdi-car::before {\r\n  content: \"\\F010B\";\r\n}\r\n\r\n.mdi-car-2-plus::before {\r\n  content: \"\\F1015\";\r\n}\r\n\r\n.mdi-car-3-plus::before {\r\n  content: \"\\F1016\";\r\n}\r\n\r\n.mdi-car-arrow-left::before {\r\n  content: \"\\F13B2\";\r\n}\r\n\r\n.mdi-car-arrow-right::before {\r\n  content: \"\\F13B3\";\r\n}\r\n\r\n.mdi-car-back::before {\r\n  content: \"\\F0E1B\";\r\n}\r\n\r\n.mdi-car-battery::before {\r\n  content: \"\\F010C\";\r\n}\r\n\r\n.mdi-car-brake-abs::before {\r\n  content: \"\\F0C47\";\r\n}\r\n\r\n.mdi-car-brake-alert::before {\r\n  content: \"\\F0C48\";\r\n}\r\n\r\n.mdi-car-brake-fluid-level::before {\r\n  content: \"\\F1909\";\r\n}\r\n\r\n.mdi-car-brake-hold::before {\r\n  content: \"\\F0D5E\";\r\n}\r\n\r\n.mdi-car-brake-low-pressure::before {\r\n  content: \"\\F190A\";\r\n}\r\n\r\n.mdi-car-brake-parking::before {\r\n  content: \"\\F0D5F\";\r\n}\r\n\r\n.mdi-car-brake-retarder::before {\r\n  content: \"\\F1017\";\r\n}\r\n\r\n.mdi-car-brake-temperature::before {\r\n  content: \"\\F190B\";\r\n}\r\n\r\n.mdi-car-brake-worn-linings::before {\r\n  content: \"\\F190C\";\r\n}\r\n\r\n.mdi-car-child-seat::before {\r\n  content: \"\\F0FA3\";\r\n}\r\n\r\n.mdi-car-clock::before {\r\n  content: \"\\F1974\";\r\n}\r\n\r\n.mdi-car-clutch::before {\r\n  content: \"\\F1018\";\r\n}\r\n\r\n.mdi-car-cog::before {\r\n  content: \"\\F13CC\";\r\n}\r\n\r\n.mdi-car-connected::before {\r\n  content: \"\\F010D\";\r\n}\r\n\r\n.mdi-car-convertible::before {\r\n  content: \"\\F07A7\";\r\n}\r\n\r\n.mdi-car-coolant-level::before {\r\n  content: \"\\F1019\";\r\n}\r\n\r\n.mdi-car-cruise-control::before {\r\n  content: \"\\F0D60\";\r\n}\r\n\r\n.mdi-car-defrost-front::before {\r\n  content: \"\\F0D61\";\r\n}\r\n\r\n.mdi-car-defrost-rear::before {\r\n  content: \"\\F0D62\";\r\n}\r\n\r\n.mdi-car-door::before {\r\n  content: \"\\F0B6B\";\r\n}\r\n\r\n.mdi-car-door-lock::before {\r\n  content: \"\\F109D\";\r\n}\r\n\r\n.mdi-car-electric::before {\r\n  content: \"\\F0B6C\";\r\n}\r\n\r\n.mdi-car-electric-outline::before {\r\n  content: \"\\F15B5\";\r\n}\r\n\r\n.mdi-car-emergency::before {\r\n  content: \"\\F160F\";\r\n}\r\n\r\n.mdi-car-esp::before {\r\n  content: \"\\F0C49\";\r\n}\r\n\r\n.mdi-car-estate::before {\r\n  content: \"\\F07A8\";\r\n}\r\n\r\n.mdi-car-hatchback::before {\r\n  content: \"\\F07A9\";\r\n}\r\n\r\n.mdi-car-info::before {\r\n  content: \"\\F11BE\";\r\n}\r\n\r\n.mdi-car-key::before {\r\n  content: \"\\F0B6D\";\r\n}\r\n\r\n.mdi-car-lifted-pickup::before {\r\n  content: \"\\F152D\";\r\n}\r\n\r\n.mdi-car-light-alert::before {\r\n  content: \"\\F190D\";\r\n}\r\n\r\n.mdi-car-light-dimmed::before {\r\n  content: \"\\F0C4A\";\r\n}\r\n\r\n.mdi-car-light-fog::before {\r\n  content: \"\\F0C4B\";\r\n}\r\n\r\n.mdi-car-light-high::before {\r\n  content: \"\\F0C4C\";\r\n}\r\n\r\n.mdi-car-limousine::before {\r\n  content: \"\\F08CD\";\r\n}\r\n\r\n.mdi-car-multiple::before {\r\n  content: \"\\F0B6E\";\r\n}\r\n\r\n.mdi-car-off::before {\r\n  content: \"\\F0E1C\";\r\n}\r\n\r\n.mdi-car-outline::before {\r\n  content: \"\\F14ED\";\r\n}\r\n\r\n.mdi-car-parking-lights::before {\r\n  content: \"\\F0D63\";\r\n}\r\n\r\n.mdi-car-pickup::before {\r\n  content: \"\\F07AA\";\r\n}\r\n\r\n.mdi-car-seat::before {\r\n  content: \"\\F0FA4\";\r\n}\r\n\r\n.mdi-car-seat-cooler::before {\r\n  content: \"\\F0FA5\";\r\n}\r\n\r\n.mdi-car-seat-heater::before {\r\n  content: \"\\F0FA6\";\r\n}\r\n\r\n.mdi-car-select::before {\r\n  content: \"\\F1879\";\r\n}\r\n\r\n.mdi-car-settings::before {\r\n  content: \"\\F13CD\";\r\n}\r\n\r\n.mdi-car-shift-pattern::before {\r\n  content: \"\\F0F40\";\r\n}\r\n\r\n.mdi-car-side::before {\r\n  content: \"\\F07AB\";\r\n}\r\n\r\n.mdi-car-speed-limiter::before {\r\n  content: \"\\F190E\";\r\n}\r\n\r\n.mdi-car-sports::before {\r\n  content: \"\\F07AC\";\r\n}\r\n\r\n.mdi-car-tire-alert::before {\r\n  content: \"\\F0C4D\";\r\n}\r\n\r\n.mdi-car-traction-control::before {\r\n  content: \"\\F0D64\";\r\n}\r\n\r\n.mdi-car-turbocharger::before {\r\n  content: \"\\F101A\";\r\n}\r\n\r\n.mdi-car-wash::before {\r\n  content: \"\\F010E\";\r\n}\r\n\r\n.mdi-car-windshield::before {\r\n  content: \"\\F101B\";\r\n}\r\n\r\n.mdi-car-windshield-outline::before {\r\n  content: \"\\F101C\";\r\n}\r\n\r\n.mdi-car-wireless::before {\r\n  content: \"\\F1878\";\r\n}\r\n\r\n.mdi-car-wrench::before {\r\n  content: \"\\F1814\";\r\n}\r\n\r\n.mdi-carabiner::before {\r\n  content: \"\\F14C0\";\r\n}\r\n\r\n.mdi-caravan::before {\r\n  content: \"\\F07AD\";\r\n}\r\n\r\n.mdi-card::before {\r\n  content: \"\\F0B6F\";\r\n}\r\n\r\n.mdi-card-account-details::before {\r\n  content: \"\\F05D2\";\r\n}\r\n\r\n.mdi-card-account-details-outline::before {\r\n  content: \"\\F0DAB\";\r\n}\r\n\r\n.mdi-card-account-details-star::before {\r\n  content: \"\\F02A3\";\r\n}\r\n\r\n.mdi-card-account-details-star-outline::before {\r\n  content: \"\\F06DB\";\r\n}\r\n\r\n.mdi-card-account-mail::before {\r\n  content: \"\\F018E\";\r\n}\r\n\r\n.mdi-card-account-mail-outline::before {\r\n  content: \"\\F0E98\";\r\n}\r\n\r\n.mdi-card-account-phone::before {\r\n  content: \"\\F0E99\";\r\n}\r\n\r\n.mdi-card-account-phone-outline::before {\r\n  content: \"\\F0E9A\";\r\n}\r\n\r\n.mdi-card-bulleted::before {\r\n  content: \"\\F0B70\";\r\n}\r\n\r\n.mdi-card-bulleted-off::before {\r\n  content: \"\\F0B71\";\r\n}\r\n\r\n.mdi-card-bulleted-off-outline::before {\r\n  content: \"\\F0B72\";\r\n}\r\n\r\n.mdi-card-bulleted-outline::before {\r\n  content: \"\\F0B73\";\r\n}\r\n\r\n.mdi-card-bulleted-settings::before {\r\n  content: \"\\F0B74\";\r\n}\r\n\r\n.mdi-card-bulleted-settings-outline::before {\r\n  content: \"\\F0B75\";\r\n}\r\n\r\n.mdi-card-minus::before {\r\n  content: \"\\F1600\";\r\n}\r\n\r\n.mdi-card-minus-outline::before {\r\n  content: \"\\F1601\";\r\n}\r\n\r\n.mdi-card-multiple::before {\r\n  content: \"\\F17F1\";\r\n}\r\n\r\n.mdi-card-multiple-outline::before {\r\n  content: \"\\F17F2\";\r\n}\r\n\r\n.mdi-card-off::before {\r\n  content: \"\\F1602\";\r\n}\r\n\r\n.mdi-card-off-outline::before {\r\n  content: \"\\F1603\";\r\n}\r\n\r\n.mdi-card-outline::before {\r\n  content: \"\\F0B76\";\r\n}\r\n\r\n.mdi-card-plus::before {\r\n  content: \"\\F11FF\";\r\n}\r\n\r\n.mdi-card-plus-outline::before {\r\n  content: \"\\F1200\";\r\n}\r\n\r\n.mdi-card-remove::before {\r\n  content: \"\\F1604\";\r\n}\r\n\r\n.mdi-card-remove-outline::before {\r\n  content: \"\\F1605\";\r\n}\r\n\r\n.mdi-card-search::before {\r\n  content: \"\\F1074\";\r\n}\r\n\r\n.mdi-card-search-outline::before {\r\n  content: \"\\F1075\";\r\n}\r\n\r\n.mdi-card-text::before {\r\n  content: \"\\F0B77\";\r\n}\r\n\r\n.mdi-card-text-outline::before {\r\n  content: \"\\F0B78\";\r\n}\r\n\r\n.mdi-cards::before {\r\n  content: \"\\F0638\";\r\n}\r\n\r\n.mdi-cards-club::before {\r\n  content: \"\\F08CE\";\r\n}\r\n\r\n.mdi-cards-club-outline::before {\r\n  content: \"\\F189F\";\r\n}\r\n\r\n.mdi-cards-diamond::before {\r\n  content: \"\\F08CF\";\r\n}\r\n\r\n.mdi-cards-diamond-outline::before {\r\n  content: \"\\F101D\";\r\n}\r\n\r\n.mdi-cards-heart::before {\r\n  content: \"\\F08D0\";\r\n}\r\n\r\n.mdi-cards-heart-outline::before {\r\n  content: \"\\F18A0\";\r\n}\r\n\r\n.mdi-cards-outline::before {\r\n  content: \"\\F0639\";\r\n}\r\n\r\n.mdi-cards-playing::before {\r\n  content: \"\\F18A1\";\r\n}\r\n\r\n.mdi-cards-playing-club::before {\r\n  content: \"\\F18A2\";\r\n}\r\n\r\n.mdi-cards-playing-club-multiple::before {\r\n  content: \"\\F18A3\";\r\n}\r\n\r\n.mdi-cards-playing-club-multiple-outline::before {\r\n  content: \"\\F18A4\";\r\n}\r\n\r\n.mdi-cards-playing-club-outline::before {\r\n  content: \"\\F18A5\";\r\n}\r\n\r\n.mdi-cards-playing-diamond::before {\r\n  content: \"\\F18A6\";\r\n}\r\n\r\n.mdi-cards-playing-diamond-multiple::before {\r\n  content: \"\\F18A7\";\r\n}\r\n\r\n.mdi-cards-playing-diamond-multiple-outline::before {\r\n  content: \"\\F18A8\";\r\n}\r\n\r\n.mdi-cards-playing-diamond-outline::before {\r\n  content: \"\\F18A9\";\r\n}\r\n\r\n.mdi-cards-playing-heart::before {\r\n  content: \"\\F18AA\";\r\n}\r\n\r\n.mdi-cards-playing-heart-multiple::before {\r\n  content: \"\\F18AB\";\r\n}\r\n\r\n.mdi-cards-playing-heart-multiple-outline::before {\r\n  content: \"\\F18AC\";\r\n}\r\n\r\n.mdi-cards-playing-heart-outline::before {\r\n  content: \"\\F18AD\";\r\n}\r\n\r\n.mdi-cards-playing-outline::before {\r\n  content: \"\\F063A\";\r\n}\r\n\r\n.mdi-cards-playing-spade::before {\r\n  content: \"\\F18AE\";\r\n}\r\n\r\n.mdi-cards-playing-spade-multiple::before {\r\n  content: \"\\F18AF\";\r\n}\r\n\r\n.mdi-cards-playing-spade-multiple-outline::before {\r\n  content: \"\\F18B0\";\r\n}\r\n\r\n.mdi-cards-playing-spade-outline::before {\r\n  content: \"\\F18B1\";\r\n}\r\n\r\n.mdi-cards-spade::before {\r\n  content: \"\\F08D1\";\r\n}\r\n\r\n.mdi-cards-spade-outline::before {\r\n  content: \"\\F18B2\";\r\n}\r\n\r\n.mdi-cards-variant::before {\r\n  content: \"\\F06C7\";\r\n}\r\n\r\n.mdi-carrot::before {\r\n  content: \"\\F010F\";\r\n}\r\n\r\n.mdi-cart::before {\r\n  content: \"\\F0110\";\r\n}\r\n\r\n.mdi-cart-arrow-down::before {\r\n  content: \"\\F0D66\";\r\n}\r\n\r\n.mdi-cart-arrow-right::before {\r\n  content: \"\\F0C4E\";\r\n}\r\n\r\n.mdi-cart-arrow-up::before {\r\n  content: \"\\F0D67\";\r\n}\r\n\r\n.mdi-cart-check::before {\r\n  content: \"\\F15EA\";\r\n}\r\n\r\n.mdi-cart-heart::before {\r\n  content: \"\\F18E0\";\r\n}\r\n\r\n.mdi-cart-minus::before {\r\n  content: \"\\F0D68\";\r\n}\r\n\r\n.mdi-cart-off::before {\r\n  content: \"\\F066B\";\r\n}\r\n\r\n.mdi-cart-outline::before {\r\n  content: \"\\F0111\";\r\n}\r\n\r\n.mdi-cart-plus::before {\r\n  content: \"\\F0112\";\r\n}\r\n\r\n.mdi-cart-remove::before {\r\n  content: \"\\F0D69\";\r\n}\r\n\r\n.mdi-cart-variant::before {\r\n  content: \"\\F15EB\";\r\n}\r\n\r\n.mdi-case-sensitive-alt::before {\r\n  content: \"\\F0113\";\r\n}\r\n\r\n.mdi-cash::before {\r\n  content: \"\\F0114\";\r\n}\r\n\r\n.mdi-cash-100::before {\r\n  content: \"\\F0115\";\r\n}\r\n\r\n.mdi-cash-check::before {\r\n  content: \"\\F14EE\";\r\n}\r\n\r\n.mdi-cash-fast::before {\r\n  content: \"\\F185C\";\r\n}\r\n\r\n.mdi-cash-lock::before {\r\n  content: \"\\F14EA\";\r\n}\r\n\r\n.mdi-cash-lock-open::before {\r\n  content: \"\\F14EB\";\r\n}\r\n\r\n.mdi-cash-marker::before {\r\n  content: \"\\F0DB8\";\r\n}\r\n\r\n.mdi-cash-minus::before {\r\n  content: \"\\F1260\";\r\n}\r\n\r\n.mdi-cash-multiple::before {\r\n  content: \"\\F0116\";\r\n}\r\n\r\n.mdi-cash-plus::before {\r\n  content: \"\\F1261\";\r\n}\r\n\r\n.mdi-cash-refund::before {\r\n  content: \"\\F0A9C\";\r\n}\r\n\r\n.mdi-cash-register::before {\r\n  content: \"\\F0CF4\";\r\n}\r\n\r\n.mdi-cash-remove::before {\r\n  content: \"\\F1262\";\r\n}\r\n\r\n.mdi-cassette::before {\r\n  content: \"\\F09D4\";\r\n}\r\n\r\n.mdi-cast::before {\r\n  content: \"\\F0118\";\r\n}\r\n\r\n.mdi-cast-audio::before {\r\n  content: \"\\F101E\";\r\n}\r\n\r\n.mdi-cast-audio-variant::before {\r\n  content: \"\\F1749\";\r\n}\r\n\r\n.mdi-cast-connected::before {\r\n  content: \"\\F0119\";\r\n}\r\n\r\n.mdi-cast-education::before {\r\n  content: \"\\F0E1D\";\r\n}\r\n\r\n.mdi-cast-off::before {\r\n  content: \"\\F078A\";\r\n}\r\n\r\n.mdi-cast-variant::before {\r\n  content: \"\\F001F\";\r\n}\r\n\r\n.mdi-castle::before {\r\n  content: \"\\F011A\";\r\n}\r\n\r\n.mdi-cat::before {\r\n  content: \"\\F011B\";\r\n}\r\n\r\n.mdi-cctv::before {\r\n  content: \"\\F07AE\";\r\n}\r\n\r\n.mdi-cctv-off::before {\r\n  content: \"\\F185F\";\r\n}\r\n\r\n.mdi-ceiling-fan::before {\r\n  content: \"\\F1797\";\r\n}\r\n\r\n.mdi-ceiling-fan-light::before {\r\n  content: \"\\F1798\";\r\n}\r\n\r\n.mdi-ceiling-light::before {\r\n  content: \"\\F0769\";\r\n}\r\n\r\n.mdi-ceiling-light-multiple::before {\r\n  content: \"\\F18DD\";\r\n}\r\n\r\n.mdi-ceiling-light-multiple-outline::before {\r\n  content: \"\\F18DE\";\r\n}\r\n\r\n.mdi-ceiling-light-outline::before {\r\n  content: \"\\F17C7\";\r\n}\r\n\r\n.mdi-cellphone::before {\r\n  content: \"\\F011C\";\r\n}\r\n\r\n.mdi-cellphone-arrow-down::before {\r\n  content: \"\\F09D5\";\r\n}\r\n\r\n.mdi-cellphone-basic::before {\r\n  content: \"\\F011E\";\r\n}\r\n\r\n.mdi-cellphone-charging::before {\r\n  content: \"\\F1397\";\r\n}\r\n\r\n.mdi-cellphone-check::before {\r\n  content: \"\\F17FD\";\r\n}\r\n\r\n.mdi-cellphone-cog::before {\r\n  content: \"\\F0951\";\r\n}\r\n\r\n.mdi-cellphone-dock::before {\r\n  content: \"\\F011F\";\r\n}\r\n\r\n.mdi-cellphone-information::before {\r\n  content: \"\\F0F41\";\r\n}\r\n\r\n.mdi-cellphone-key::before {\r\n  content: \"\\F094E\";\r\n}\r\n\r\n.mdi-cellphone-link::before {\r\n  content: \"\\F0121\";\r\n}\r\n\r\n.mdi-cellphone-link-off::before {\r\n  content: \"\\F0122\";\r\n}\r\n\r\n.mdi-cellphone-lock::before {\r\n  content: \"\\F094F\";\r\n}\r\n\r\n.mdi-cellphone-marker::before {\r\n  content: \"\\F183A\";\r\n}\r\n\r\n.mdi-cellphone-message::before {\r\n  content: \"\\F08D3\";\r\n}\r\n\r\n.mdi-cellphone-message-off::before {\r\n  content: \"\\F10D2\";\r\n}\r\n\r\n.mdi-cellphone-nfc::before {\r\n  content: \"\\F0E90\";\r\n}\r\n\r\n.mdi-cellphone-nfc-off::before {\r\n  content: \"\\F12D8\";\r\n}\r\n\r\n.mdi-cellphone-off::before {\r\n  content: \"\\F0950\";\r\n}\r\n\r\n.mdi-cellphone-play::before {\r\n  content: \"\\F101F\";\r\n}\r\n\r\n.mdi-cellphone-remove::before {\r\n  content: \"\\F094D\";\r\n}\r\n\r\n.mdi-cellphone-screenshot::before {\r\n  content: \"\\F0A35\";\r\n}\r\n\r\n.mdi-cellphone-settings::before {\r\n  content: \"\\F0123\";\r\n}\r\n\r\n.mdi-cellphone-sound::before {\r\n  content: \"\\F0952\";\r\n}\r\n\r\n.mdi-cellphone-text::before {\r\n  content: \"\\F08D2\";\r\n}\r\n\r\n.mdi-cellphone-wireless::before {\r\n  content: \"\\F0815\";\r\n}\r\n\r\n.mdi-centos::before {\r\n  content: \"\\F111A\";\r\n}\r\n\r\n.mdi-certificate::before {\r\n  content: \"\\F0124\";\r\n}\r\n\r\n.mdi-certificate-outline::before {\r\n  content: \"\\F1188\";\r\n}\r\n\r\n.mdi-chair-rolling::before {\r\n  content: \"\\F0F48\";\r\n}\r\n\r\n.mdi-chair-school::before {\r\n  content: \"\\F0125\";\r\n}\r\n\r\n.mdi-chandelier::before {\r\n  content: \"\\F1793\";\r\n}\r\n\r\n.mdi-charity::before {\r\n  content: \"\\F0C4F\";\r\n}\r\n\r\n.mdi-chart-arc::before {\r\n  content: \"\\F0126\";\r\n}\r\n\r\n.mdi-chart-areaspline::before {\r\n  content: \"\\F0127\";\r\n}\r\n\r\n.mdi-chart-areaspline-variant::before {\r\n  content: \"\\F0E91\";\r\n}\r\n\r\n.mdi-chart-bar::before {\r\n  content: \"\\F0128\";\r\n}\r\n\r\n.mdi-chart-bar-stacked::before {\r\n  content: \"\\F076A\";\r\n}\r\n\r\n.mdi-chart-bell-curve::before {\r\n  content: \"\\F0C50\";\r\n}\r\n\r\n.mdi-chart-bell-curve-cumulative::before {\r\n  content: \"\\F0FA7\";\r\n}\r\n\r\n.mdi-chart-box::before {\r\n  content: \"\\F154D\";\r\n}\r\n\r\n.mdi-chart-box-outline::before {\r\n  content: \"\\F154E\";\r\n}\r\n\r\n.mdi-chart-box-plus-outline::before {\r\n  content: \"\\F154F\";\r\n}\r\n\r\n.mdi-chart-bubble::before {\r\n  content: \"\\F05E3\";\r\n}\r\n\r\n.mdi-chart-donut::before {\r\n  content: \"\\F07AF\";\r\n}\r\n\r\n.mdi-chart-donut-variant::before {\r\n  content: \"\\F07B0\";\r\n}\r\n\r\n.mdi-chart-gantt::before {\r\n  content: \"\\F066C\";\r\n}\r\n\r\n.mdi-chart-histogram::before {\r\n  content: \"\\F0129\";\r\n}\r\n\r\n.mdi-chart-line::before {\r\n  content: \"\\F012A\";\r\n}\r\n\r\n.mdi-chart-line-stacked::before {\r\n  content: \"\\F076B\";\r\n}\r\n\r\n.mdi-chart-line-variant::before {\r\n  content: \"\\F07B1\";\r\n}\r\n\r\n.mdi-chart-multiline::before {\r\n  content: \"\\F08D4\";\r\n}\r\n\r\n.mdi-chart-multiple::before {\r\n  content: \"\\F1213\";\r\n}\r\n\r\n.mdi-chart-pie::before {\r\n  content: \"\\F012B\";\r\n}\r\n\r\n.mdi-chart-ppf::before {\r\n  content: \"\\F1380\";\r\n}\r\n\r\n.mdi-chart-sankey::before {\r\n  content: \"\\F11DF\";\r\n}\r\n\r\n.mdi-chart-sankey-variant::before {\r\n  content: \"\\F11E0\";\r\n}\r\n\r\n.mdi-chart-scatter-plot::before {\r\n  content: \"\\F0E92\";\r\n}\r\n\r\n.mdi-chart-scatter-plot-hexbin::before {\r\n  content: \"\\F066D\";\r\n}\r\n\r\n.mdi-chart-timeline::before {\r\n  content: \"\\F066E\";\r\n}\r\n\r\n.mdi-chart-timeline-variant::before {\r\n  content: \"\\F0E93\";\r\n}\r\n\r\n.mdi-chart-timeline-variant-shimmer::before {\r\n  content: \"\\F15B6\";\r\n}\r\n\r\n.mdi-chart-tree::before {\r\n  content: \"\\F0E94\";\r\n}\r\n\r\n.mdi-chart-waterfall::before {\r\n  content: \"\\F1918\";\r\n}\r\n\r\n.mdi-chat::before {\r\n  content: \"\\F0B79\";\r\n}\r\n\r\n.mdi-chat-alert::before {\r\n  content: \"\\F0B7A\";\r\n}\r\n\r\n.mdi-chat-alert-outline::before {\r\n  content: \"\\F12C9\";\r\n}\r\n\r\n.mdi-chat-minus::before {\r\n  content: \"\\F1410\";\r\n}\r\n\r\n.mdi-chat-minus-outline::before {\r\n  content: \"\\F1413\";\r\n}\r\n\r\n.mdi-chat-outline::before {\r\n  content: \"\\F0EDE\";\r\n}\r\n\r\n.mdi-chat-plus::before {\r\n  content: \"\\F140F\";\r\n}\r\n\r\n.mdi-chat-plus-outline::before {\r\n  content: \"\\F1412\";\r\n}\r\n\r\n.mdi-chat-processing::before {\r\n  content: \"\\F0B7B\";\r\n}\r\n\r\n.mdi-chat-processing-outline::before {\r\n  content: \"\\F12CA\";\r\n}\r\n\r\n.mdi-chat-question::before {\r\n  content: \"\\F1738\";\r\n}\r\n\r\n.mdi-chat-question-outline::before {\r\n  content: \"\\F1739\";\r\n}\r\n\r\n.mdi-chat-remove::before {\r\n  content: \"\\F1411\";\r\n}\r\n\r\n.mdi-chat-remove-outline::before {\r\n  content: \"\\F1414\";\r\n}\r\n\r\n.mdi-chat-sleep::before {\r\n  content: \"\\F12D1\";\r\n}\r\n\r\n.mdi-chat-sleep-outline::before {\r\n  content: \"\\F12D2\";\r\n}\r\n\r\n.mdi-check::before {\r\n  content: \"\\F012C\";\r\n}\r\n\r\n.mdi-check-all::before {\r\n  content: \"\\F012D\";\r\n}\r\n\r\n.mdi-check-bold::before {\r\n  content: \"\\F0E1E\";\r\n}\r\n\r\n.mdi-check-circle::before {\r\n  content: \"\\F05E0\";\r\n}\r\n\r\n.mdi-check-circle-outline::before {\r\n  content: \"\\F05E1\";\r\n}\r\n\r\n.mdi-check-decagram::before {\r\n  content: \"\\F0791\";\r\n}\r\n\r\n.mdi-check-decagram-outline::before {\r\n  content: \"\\F1740\";\r\n}\r\n\r\n.mdi-check-network::before {\r\n  content: \"\\F0C53\";\r\n}\r\n\r\n.mdi-check-network-outline::before {\r\n  content: \"\\F0C54\";\r\n}\r\n\r\n.mdi-check-outline::before {\r\n  content: \"\\F0855\";\r\n}\r\n\r\n.mdi-check-underline::before {\r\n  content: \"\\F0E1F\";\r\n}\r\n\r\n.mdi-check-underline-circle::before {\r\n  content: \"\\F0E20\";\r\n}\r\n\r\n.mdi-check-underline-circle-outline::before {\r\n  content: \"\\F0E21\";\r\n}\r\n\r\n.mdi-checkbook::before {\r\n  content: \"\\F0A9D\";\r\n}\r\n\r\n.mdi-checkbox-blank::before {\r\n  content: \"\\F012E\";\r\n}\r\n\r\n.mdi-checkbox-blank-badge::before {\r\n  content: \"\\F1176\";\r\n}\r\n\r\n.mdi-checkbox-blank-badge-outline::before {\r\n  content: \"\\F0117\";\r\n}\r\n\r\n.mdi-checkbox-blank-circle::before {\r\n  content: \"\\F012F\";\r\n}\r\n\r\n.mdi-checkbox-blank-circle-outline::before {\r\n  content: \"\\F0130\";\r\n}\r\n\r\n.mdi-checkbox-blank-off::before {\r\n  content: \"\\F12EC\";\r\n}\r\n\r\n.mdi-checkbox-blank-off-outline::before {\r\n  content: \"\\F12ED\";\r\n}\r\n\r\n.mdi-checkbox-blank-outline::before {\r\n  content: \"\\F0131\";\r\n}\r\n\r\n.mdi-checkbox-intermediate::before {\r\n  content: \"\\F0856\";\r\n}\r\n\r\n.mdi-checkbox-marked::before {\r\n  content: \"\\F0132\";\r\n}\r\n\r\n.mdi-checkbox-marked-circle::before {\r\n  content: \"\\F0133\";\r\n}\r\n\r\n.mdi-checkbox-marked-circle-outline::before {\r\n  content: \"\\F0134\";\r\n}\r\n\r\n.mdi-checkbox-marked-circle-plus-outline::before {\r\n  content: \"\\F1927\";\r\n}\r\n\r\n.mdi-checkbox-marked-outline::before {\r\n  content: \"\\F0135\";\r\n}\r\n\r\n.mdi-checkbox-multiple-blank::before {\r\n  content: \"\\F0136\";\r\n}\r\n\r\n.mdi-checkbox-multiple-blank-circle::before {\r\n  content: \"\\F063B\";\r\n}\r\n\r\n.mdi-checkbox-multiple-blank-circle-outline::before {\r\n  content: \"\\F063C\";\r\n}\r\n\r\n.mdi-checkbox-multiple-blank-outline::before {\r\n  content: \"\\F0137\";\r\n}\r\n\r\n.mdi-checkbox-multiple-marked::before {\r\n  content: \"\\F0138\";\r\n}\r\n\r\n.mdi-checkbox-multiple-marked-circle::before {\r\n  content: \"\\F063D\";\r\n}\r\n\r\n.mdi-checkbox-multiple-marked-circle-outline::before {\r\n  content: \"\\F063E\";\r\n}\r\n\r\n.mdi-checkbox-multiple-marked-outline::before {\r\n  content: \"\\F0139\";\r\n}\r\n\r\n.mdi-checkbox-multiple-outline::before {\r\n  content: \"\\F0C51\";\r\n}\r\n\r\n.mdi-checkbox-outline::before {\r\n  content: \"\\F0C52\";\r\n}\r\n\r\n.mdi-checkerboard::before {\r\n  content: \"\\F013A\";\r\n}\r\n\r\n.mdi-checkerboard-minus::before {\r\n  content: \"\\F1202\";\r\n}\r\n\r\n.mdi-checkerboard-plus::before {\r\n  content: \"\\F1201\";\r\n}\r\n\r\n.mdi-checkerboard-remove::before {\r\n  content: \"\\F1203\";\r\n}\r\n\r\n.mdi-cheese::before {\r\n  content: \"\\F12B9\";\r\n}\r\n\r\n.mdi-cheese-off::before {\r\n  content: \"\\F13EE\";\r\n}\r\n\r\n.mdi-chef-hat::before {\r\n  content: \"\\F0B7C\";\r\n}\r\n\r\n.mdi-chemical-weapon::before {\r\n  content: \"\\F013B\";\r\n}\r\n\r\n.mdi-chess-bishop::before {\r\n  content: \"\\F085C\";\r\n}\r\n\r\n.mdi-chess-king::before {\r\n  content: \"\\F0857\";\r\n}\r\n\r\n.mdi-chess-knight::before {\r\n  content: \"\\F0858\";\r\n}\r\n\r\n.mdi-chess-pawn::before {\r\n  content: \"\\F0859\";\r\n}\r\n\r\n.mdi-chess-queen::before {\r\n  content: \"\\F085A\";\r\n}\r\n\r\n.mdi-chess-rook::before {\r\n  content: \"\\F085B\";\r\n}\r\n\r\n.mdi-chevron-double-down::before {\r\n  content: \"\\F013C\";\r\n}\r\n\r\n.mdi-chevron-double-left::before {\r\n  content: \"\\F013D\";\r\n}\r\n\r\n.mdi-chevron-double-right::before {\r\n  content: \"\\F013E\";\r\n}\r\n\r\n.mdi-chevron-double-up::before {\r\n  content: \"\\F013F\";\r\n}\r\n\r\n.mdi-chevron-down::before {\r\n  content: \"\\F0140\";\r\n}\r\n\r\n.mdi-chevron-down-box::before {\r\n  content: \"\\F09D6\";\r\n}\r\n\r\n.mdi-chevron-down-box-outline::before {\r\n  content: \"\\F09D7\";\r\n}\r\n\r\n.mdi-chevron-down-circle::before {\r\n  content: \"\\F0B26\";\r\n}\r\n\r\n.mdi-chevron-down-circle-outline::before {\r\n  content: \"\\F0B27\";\r\n}\r\n\r\n.mdi-chevron-left::before {\r\n  content: \"\\F0141\";\r\n}\r\n\r\n.mdi-chevron-left-box::before {\r\n  content: \"\\F09D8\";\r\n}\r\n\r\n.mdi-chevron-left-box-outline::before {\r\n  content: \"\\F09D9\";\r\n}\r\n\r\n.mdi-chevron-left-circle::before {\r\n  content: \"\\F0B28\";\r\n}\r\n\r\n.mdi-chevron-left-circle-outline::before {\r\n  content: \"\\F0B29\";\r\n}\r\n\r\n.mdi-chevron-right::before {\r\n  content: \"\\F0142\";\r\n}\r\n\r\n.mdi-chevron-right-box::before {\r\n  content: \"\\F09DA\";\r\n}\r\n\r\n.mdi-chevron-right-box-outline::before {\r\n  content: \"\\F09DB\";\r\n}\r\n\r\n.mdi-chevron-right-circle::before {\r\n  content: \"\\F0B2A\";\r\n}\r\n\r\n.mdi-chevron-right-circle-outline::before {\r\n  content: \"\\F0B2B\";\r\n}\r\n\r\n.mdi-chevron-triple-down::before {\r\n  content: \"\\F0DB9\";\r\n}\r\n\r\n.mdi-chevron-triple-left::before {\r\n  content: \"\\F0DBA\";\r\n}\r\n\r\n.mdi-chevron-triple-right::before {\r\n  content: \"\\F0DBB\";\r\n}\r\n\r\n.mdi-chevron-triple-up::before {\r\n  content: \"\\F0DBC\";\r\n}\r\n\r\n.mdi-chevron-up::before {\r\n  content: \"\\F0143\";\r\n}\r\n\r\n.mdi-chevron-up-box::before {\r\n  content: \"\\F09DC\";\r\n}\r\n\r\n.mdi-chevron-up-box-outline::before {\r\n  content: \"\\F09DD\";\r\n}\r\n\r\n.mdi-chevron-up-circle::before {\r\n  content: \"\\F0B2C\";\r\n}\r\n\r\n.mdi-chevron-up-circle-outline::before {\r\n  content: \"\\F0B2D\";\r\n}\r\n\r\n.mdi-chili-alert::before {\r\n  content: \"\\F17EA\";\r\n}\r\n\r\n.mdi-chili-alert-outline::before {\r\n  content: \"\\F17EB\";\r\n}\r\n\r\n.mdi-chili-hot::before {\r\n  content: \"\\F07B2\";\r\n}\r\n\r\n.mdi-chili-hot-outline::before {\r\n  content: \"\\F17EC\";\r\n}\r\n\r\n.mdi-chili-medium::before {\r\n  content: \"\\F07B3\";\r\n}\r\n\r\n.mdi-chili-medium-outline::before {\r\n  content: \"\\F17ED\";\r\n}\r\n\r\n.mdi-chili-mild::before {\r\n  content: \"\\F07B4\";\r\n}\r\n\r\n.mdi-chili-mild-outline::before {\r\n  content: \"\\F17EE\";\r\n}\r\n\r\n.mdi-chili-off::before {\r\n  content: \"\\F1467\";\r\n}\r\n\r\n.mdi-chili-off-outline::before {\r\n  content: \"\\F17EF\";\r\n}\r\n\r\n.mdi-chip::before {\r\n  content: \"\\F061A\";\r\n}\r\n\r\n.mdi-church::before {\r\n  content: \"\\F0144\";\r\n}\r\n\r\n.mdi-cigar::before {\r\n  content: \"\\F1189\";\r\n}\r\n\r\n.mdi-cigar-off::before {\r\n  content: \"\\F141B\";\r\n}\r\n\r\n.mdi-circle::before {\r\n  content: \"\\F0765\";\r\n}\r\n\r\n.mdi-circle-box::before {\r\n  content: \"\\F15DC\";\r\n}\r\n\r\n.mdi-circle-box-outline::before {\r\n  content: \"\\F15DD\";\r\n}\r\n\r\n.mdi-circle-double::before {\r\n  content: \"\\F0E95\";\r\n}\r\n\r\n.mdi-circle-edit-outline::before {\r\n  content: \"\\F08D5\";\r\n}\r\n\r\n.mdi-circle-expand::before {\r\n  content: \"\\F0E96\";\r\n}\r\n\r\n.mdi-circle-half::before {\r\n  content: \"\\F1395\";\r\n}\r\n\r\n.mdi-circle-half-full::before {\r\n  content: \"\\F1396\";\r\n}\r\n\r\n.mdi-circle-medium::before {\r\n  content: \"\\F09DE\";\r\n}\r\n\r\n.mdi-circle-multiple::before {\r\n  content: \"\\F0B38\";\r\n}\r\n\r\n.mdi-circle-multiple-outline::before {\r\n  content: \"\\F0695\";\r\n}\r\n\r\n.mdi-circle-off-outline::before {\r\n  content: \"\\F10D3\";\r\n}\r\n\r\n.mdi-circle-opacity::before {\r\n  content: \"\\F1853\";\r\n}\r\n\r\n.mdi-circle-outline::before {\r\n  content: \"\\F0766\";\r\n}\r\n\r\n.mdi-circle-slice-1::before {\r\n  content: \"\\F0A9E\";\r\n}\r\n\r\n.mdi-circle-slice-2::before {\r\n  content: \"\\F0A9F\";\r\n}\r\n\r\n.mdi-circle-slice-3::before {\r\n  content: \"\\F0AA0\";\r\n}\r\n\r\n.mdi-circle-slice-4::before {\r\n  content: \"\\F0AA1\";\r\n}\r\n\r\n.mdi-circle-slice-5::before {\r\n  content: \"\\F0AA2\";\r\n}\r\n\r\n.mdi-circle-slice-6::before {\r\n  content: \"\\F0AA3\";\r\n}\r\n\r\n.mdi-circle-slice-7::before {\r\n  content: \"\\F0AA4\";\r\n}\r\n\r\n.mdi-circle-slice-8::before {\r\n  content: \"\\F0AA5\";\r\n}\r\n\r\n.mdi-circle-small::before {\r\n  content: \"\\F09DF\";\r\n}\r\n\r\n.mdi-circular-saw::before {\r\n  content: \"\\F0E22\";\r\n}\r\n\r\n.mdi-city::before {\r\n  content: \"\\F0146\";\r\n}\r\n\r\n.mdi-city-variant::before {\r\n  content: \"\\F0A36\";\r\n}\r\n\r\n.mdi-city-variant-outline::before {\r\n  content: \"\\F0A37\";\r\n}\r\n\r\n.mdi-clipboard::before {\r\n  content: \"\\F0147\";\r\n}\r\n\r\n.mdi-clipboard-account::before {\r\n  content: \"\\F0148\";\r\n}\r\n\r\n.mdi-clipboard-account-outline::before {\r\n  content: \"\\F0C55\";\r\n}\r\n\r\n.mdi-clipboard-alert::before {\r\n  content: \"\\F0149\";\r\n}\r\n\r\n.mdi-clipboard-alert-outline::before {\r\n  content: \"\\F0CF7\";\r\n}\r\n\r\n.mdi-clipboard-arrow-down::before {\r\n  content: \"\\F014A\";\r\n}\r\n\r\n.mdi-clipboard-arrow-down-outline::before {\r\n  content: \"\\F0C56\";\r\n}\r\n\r\n.mdi-clipboard-arrow-left::before {\r\n  content: \"\\F014B\";\r\n}\r\n\r\n.mdi-clipboard-arrow-left-outline::before {\r\n  content: \"\\F0CF8\";\r\n}\r\n\r\n.mdi-clipboard-arrow-right::before {\r\n  content: \"\\F0CF9\";\r\n}\r\n\r\n.mdi-clipboard-arrow-right-outline::before {\r\n  content: \"\\F0CFA\";\r\n}\r\n\r\n.mdi-clipboard-arrow-up::before {\r\n  content: \"\\F0C57\";\r\n}\r\n\r\n.mdi-clipboard-arrow-up-outline::before {\r\n  content: \"\\F0C58\";\r\n}\r\n\r\n.mdi-clipboard-check::before {\r\n  content: \"\\F014E\";\r\n}\r\n\r\n.mdi-clipboard-check-multiple::before {\r\n  content: \"\\F1263\";\r\n}\r\n\r\n.mdi-clipboard-check-multiple-outline::before {\r\n  content: \"\\F1264\";\r\n}\r\n\r\n.mdi-clipboard-check-outline::before {\r\n  content: \"\\F08A8\";\r\n}\r\n\r\n.mdi-clipboard-clock::before {\r\n  content: \"\\F16E2\";\r\n}\r\n\r\n.mdi-clipboard-clock-outline::before {\r\n  content: \"\\F16E3\";\r\n}\r\n\r\n.mdi-clipboard-edit::before {\r\n  content: \"\\F14E5\";\r\n}\r\n\r\n.mdi-clipboard-edit-outline::before {\r\n  content: \"\\F14E6\";\r\n}\r\n\r\n.mdi-clipboard-file::before {\r\n  content: \"\\F1265\";\r\n}\r\n\r\n.mdi-clipboard-file-outline::before {\r\n  content: \"\\F1266\";\r\n}\r\n\r\n.mdi-clipboard-flow::before {\r\n  content: \"\\F06C8\";\r\n}\r\n\r\n.mdi-clipboard-flow-outline::before {\r\n  content: \"\\F1117\";\r\n}\r\n\r\n.mdi-clipboard-list::before {\r\n  content: \"\\F10D4\";\r\n}\r\n\r\n.mdi-clipboard-list-outline::before {\r\n  content: \"\\F10D5\";\r\n}\r\n\r\n.mdi-clipboard-minus::before {\r\n  content: \"\\F1618\";\r\n}\r\n\r\n.mdi-clipboard-minus-outline::before {\r\n  content: \"\\F1619\";\r\n}\r\n\r\n.mdi-clipboard-multiple::before {\r\n  content: \"\\F1267\";\r\n}\r\n\r\n.mdi-clipboard-multiple-outline::before {\r\n  content: \"\\F1268\";\r\n}\r\n\r\n.mdi-clipboard-off::before {\r\n  content: \"\\F161A\";\r\n}\r\n\r\n.mdi-clipboard-off-outline::before {\r\n  content: \"\\F161B\";\r\n}\r\n\r\n.mdi-clipboard-outline::before {\r\n  content: \"\\F014C\";\r\n}\r\n\r\n.mdi-clipboard-play::before {\r\n  content: \"\\F0C59\";\r\n}\r\n\r\n.mdi-clipboard-play-multiple::before {\r\n  content: \"\\F1269\";\r\n}\r\n\r\n.mdi-clipboard-play-multiple-outline::before {\r\n  content: \"\\F126A\";\r\n}\r\n\r\n.mdi-clipboard-play-outline::before {\r\n  content: \"\\F0C5A\";\r\n}\r\n\r\n.mdi-clipboard-plus::before {\r\n  content: \"\\F0751\";\r\n}\r\n\r\n.mdi-clipboard-plus-outline::before {\r\n  content: \"\\F131F\";\r\n}\r\n\r\n.mdi-clipboard-pulse::before {\r\n  content: \"\\F085D\";\r\n}\r\n\r\n.mdi-clipboard-pulse-outline::before {\r\n  content: \"\\F085E\";\r\n}\r\n\r\n.mdi-clipboard-remove::before {\r\n  content: \"\\F161C\";\r\n}\r\n\r\n.mdi-clipboard-remove-outline::before {\r\n  content: \"\\F161D\";\r\n}\r\n\r\n.mdi-clipboard-search::before {\r\n  content: \"\\F161E\";\r\n}\r\n\r\n.mdi-clipboard-search-outline::before {\r\n  content: \"\\F161F\";\r\n}\r\n\r\n.mdi-clipboard-text::before {\r\n  content: \"\\F014D\";\r\n}\r\n\r\n.mdi-clipboard-text-clock::before {\r\n  content: \"\\F18F9\";\r\n}\r\n\r\n.mdi-clipboard-text-clock-outline::before {\r\n  content: \"\\F18FA\";\r\n}\r\n\r\n.mdi-clipboard-text-multiple::before {\r\n  content: \"\\F126B\";\r\n}\r\n\r\n.mdi-clipboard-text-multiple-outline::before {\r\n  content: \"\\F126C\";\r\n}\r\n\r\n.mdi-clipboard-text-off::before {\r\n  content: \"\\F1620\";\r\n}\r\n\r\n.mdi-clipboard-text-off-outline::before {\r\n  content: \"\\F1621\";\r\n}\r\n\r\n.mdi-clipboard-text-outline::before {\r\n  content: \"\\F0A38\";\r\n}\r\n\r\n.mdi-clipboard-text-play::before {\r\n  content: \"\\F0C5B\";\r\n}\r\n\r\n.mdi-clipboard-text-play-outline::before {\r\n  content: \"\\F0C5C\";\r\n}\r\n\r\n.mdi-clipboard-text-search::before {\r\n  content: \"\\F1622\";\r\n}\r\n\r\n.mdi-clipboard-text-search-outline::before {\r\n  content: \"\\F1623\";\r\n}\r\n\r\n.mdi-clippy::before {\r\n  content: \"\\F014F\";\r\n}\r\n\r\n.mdi-clock::before {\r\n  content: \"\\F0954\";\r\n}\r\n\r\n.mdi-clock-alert::before {\r\n  content: \"\\F0955\";\r\n}\r\n\r\n.mdi-clock-alert-outline::before {\r\n  content: \"\\F05CE\";\r\n}\r\n\r\n.mdi-clock-check::before {\r\n  content: \"\\F0FA8\";\r\n}\r\n\r\n.mdi-clock-check-outline::before {\r\n  content: \"\\F0FA9\";\r\n}\r\n\r\n.mdi-clock-digital::before {\r\n  content: \"\\F0E97\";\r\n}\r\n\r\n.mdi-clock-edit::before {\r\n  content: \"\\F19BA\";\r\n}\r\n\r\n.mdi-clock-edit-outline::before {\r\n  content: \"\\F19BB\";\r\n}\r\n\r\n.mdi-clock-end::before {\r\n  content: \"\\F0151\";\r\n}\r\n\r\n.mdi-clock-fast::before {\r\n  content: \"\\F0152\";\r\n}\r\n\r\n.mdi-clock-in::before {\r\n  content: \"\\F0153\";\r\n}\r\n\r\n.mdi-clock-minus::before {\r\n  content: \"\\F1863\";\r\n}\r\n\r\n.mdi-clock-minus-outline::before {\r\n  content: \"\\F1864\";\r\n}\r\n\r\n.mdi-clock-out::before {\r\n  content: \"\\F0154\";\r\n}\r\n\r\n.mdi-clock-outline::before {\r\n  content: \"\\F0150\";\r\n}\r\n\r\n.mdi-clock-plus::before {\r\n  content: \"\\F1861\";\r\n}\r\n\r\n.mdi-clock-plus-outline::before {\r\n  content: \"\\F1862\";\r\n}\r\n\r\n.mdi-clock-remove::before {\r\n  content: \"\\F1865\";\r\n}\r\n\r\n.mdi-clock-remove-outline::before {\r\n  content: \"\\F1866\";\r\n}\r\n\r\n.mdi-clock-start::before {\r\n  content: \"\\F0155\";\r\n}\r\n\r\n.mdi-clock-time-eight::before {\r\n  content: \"\\F1446\";\r\n}\r\n\r\n.mdi-clock-time-eight-outline::before {\r\n  content: \"\\F1452\";\r\n}\r\n\r\n.mdi-clock-time-eleven::before {\r\n  content: \"\\F1449\";\r\n}\r\n\r\n.mdi-clock-time-eleven-outline::before {\r\n  content: \"\\F1455\";\r\n}\r\n\r\n.mdi-clock-time-five::before {\r\n  content: \"\\F1443\";\r\n}\r\n\r\n.mdi-clock-time-five-outline::before {\r\n  content: \"\\F144F\";\r\n}\r\n\r\n.mdi-clock-time-four::before {\r\n  content: \"\\F1442\";\r\n}\r\n\r\n.mdi-clock-time-four-outline::before {\r\n  content: \"\\F144E\";\r\n}\r\n\r\n.mdi-clock-time-nine::before {\r\n  content: \"\\F1447\";\r\n}\r\n\r\n.mdi-clock-time-nine-outline::before {\r\n  content: \"\\F1453\";\r\n}\r\n\r\n.mdi-clock-time-one::before {\r\n  content: \"\\F143F\";\r\n}\r\n\r\n.mdi-clock-time-one-outline::before {\r\n  content: \"\\F144B\";\r\n}\r\n\r\n.mdi-clock-time-seven::before {\r\n  content: \"\\F1445\";\r\n}\r\n\r\n.mdi-clock-time-seven-outline::before {\r\n  content: \"\\F1451\";\r\n}\r\n\r\n.mdi-clock-time-six::before {\r\n  content: \"\\F1444\";\r\n}\r\n\r\n.mdi-clock-time-six-outline::before {\r\n  content: \"\\F1450\";\r\n}\r\n\r\n.mdi-clock-time-ten::before {\r\n  content: \"\\F1448\";\r\n}\r\n\r\n.mdi-clock-time-ten-outline::before {\r\n  content: \"\\F1454\";\r\n}\r\n\r\n.mdi-clock-time-three::before {\r\n  content: \"\\F1441\";\r\n}\r\n\r\n.mdi-clock-time-three-outline::before {\r\n  content: \"\\F144D\";\r\n}\r\n\r\n.mdi-clock-time-twelve::before {\r\n  content: \"\\F144A\";\r\n}\r\n\r\n.mdi-clock-time-twelve-outline::before {\r\n  content: \"\\F1456\";\r\n}\r\n\r\n.mdi-clock-time-two::before {\r\n  content: \"\\F1440\";\r\n}\r\n\r\n.mdi-clock-time-two-outline::before {\r\n  content: \"\\F144C\";\r\n}\r\n\r\n.mdi-close::before {\r\n  content: \"\\F0156\";\r\n}\r\n\r\n.mdi-close-box::before {\r\n  content: \"\\F0157\";\r\n}\r\n\r\n.mdi-close-box-multiple::before {\r\n  content: \"\\F0C5D\";\r\n}\r\n\r\n.mdi-close-box-multiple-outline::before {\r\n  content: \"\\F0C5E\";\r\n}\r\n\r\n.mdi-close-box-outline::before {\r\n  content: \"\\F0158\";\r\n}\r\n\r\n.mdi-close-circle::before {\r\n  content: \"\\F0159\";\r\n}\r\n\r\n.mdi-close-circle-multiple::before {\r\n  content: \"\\F062A\";\r\n}\r\n\r\n.mdi-close-circle-multiple-outline::before {\r\n  content: \"\\F0883\";\r\n}\r\n\r\n.mdi-close-circle-outline::before {\r\n  content: \"\\F015A\";\r\n}\r\n\r\n.mdi-close-network::before {\r\n  content: \"\\F015B\";\r\n}\r\n\r\n.mdi-close-network-outline::before {\r\n  content: \"\\F0C5F\";\r\n}\r\n\r\n.mdi-close-octagon::before {\r\n  content: \"\\F015C\";\r\n}\r\n\r\n.mdi-close-octagon-outline::before {\r\n  content: \"\\F015D\";\r\n}\r\n\r\n.mdi-close-outline::before {\r\n  content: \"\\F06C9\";\r\n}\r\n\r\n.mdi-close-thick::before {\r\n  content: \"\\F1398\";\r\n}\r\n\r\n.mdi-closed-caption::before {\r\n  content: \"\\F015E\";\r\n}\r\n\r\n.mdi-closed-caption-outline::before {\r\n  content: \"\\F0DBD\";\r\n}\r\n\r\n.mdi-cloud::before {\r\n  content: \"\\F015F\";\r\n}\r\n\r\n.mdi-cloud-alert::before {\r\n  content: \"\\F09E0\";\r\n}\r\n\r\n.mdi-cloud-braces::before {\r\n  content: \"\\F07B5\";\r\n}\r\n\r\n.mdi-cloud-check::before {\r\n  content: \"\\F0160\";\r\n}\r\n\r\n.mdi-cloud-check-outline::before {\r\n  content: \"\\F12CC\";\r\n}\r\n\r\n.mdi-cloud-circle::before {\r\n  content: \"\\F0161\";\r\n}\r\n\r\n.mdi-cloud-download::before {\r\n  content: \"\\F0162\";\r\n}\r\n\r\n.mdi-cloud-download-outline::before {\r\n  content: \"\\F0B7D\";\r\n}\r\n\r\n.mdi-cloud-lock::before {\r\n  content: \"\\F11F1\";\r\n}\r\n\r\n.mdi-cloud-lock-outline::before {\r\n  content: \"\\F11F2\";\r\n}\r\n\r\n.mdi-cloud-off-outline::before {\r\n  content: \"\\F0164\";\r\n}\r\n\r\n.mdi-cloud-outline::before {\r\n  content: \"\\F0163\";\r\n}\r\n\r\n.mdi-cloud-print::before {\r\n  content: \"\\F0165\";\r\n}\r\n\r\n.mdi-cloud-print-outline::before {\r\n  content: \"\\F0166\";\r\n}\r\n\r\n.mdi-cloud-question::before {\r\n  content: \"\\F0A39\";\r\n}\r\n\r\n.mdi-cloud-refresh::before {\r\n  content: \"\\F052A\";\r\n}\r\n\r\n.mdi-cloud-search::before {\r\n  content: \"\\F0956\";\r\n}\r\n\r\n.mdi-cloud-search-outline::before {\r\n  content: \"\\F0957\";\r\n}\r\n\r\n.mdi-cloud-sync::before {\r\n  content: \"\\F063F\";\r\n}\r\n\r\n.mdi-cloud-sync-outline::before {\r\n  content: \"\\F12D6\";\r\n}\r\n\r\n.mdi-cloud-tags::before {\r\n  content: \"\\F07B6\";\r\n}\r\n\r\n.mdi-cloud-upload::before {\r\n  content: \"\\F0167\";\r\n}\r\n\r\n.mdi-cloud-upload-outline::before {\r\n  content: \"\\F0B7E\";\r\n}\r\n\r\n.mdi-clover::before {\r\n  content: \"\\F0816\";\r\n}\r\n\r\n.mdi-coach-lamp::before {\r\n  content: \"\\F1020\";\r\n}\r\n\r\n.mdi-coat-rack::before {\r\n  content: \"\\F109E\";\r\n}\r\n\r\n.mdi-code-array::before {\r\n  content: \"\\F0168\";\r\n}\r\n\r\n.mdi-code-braces::before {\r\n  content: \"\\F0169\";\r\n}\r\n\r\n.mdi-code-braces-box::before {\r\n  content: \"\\F10D6\";\r\n}\r\n\r\n.mdi-code-brackets::before {\r\n  content: \"\\F016A\";\r\n}\r\n\r\n.mdi-code-equal::before {\r\n  content: \"\\F016B\";\r\n}\r\n\r\n.mdi-code-greater-than::before {\r\n  content: \"\\F016C\";\r\n}\r\n\r\n.mdi-code-greater-than-or-equal::before {\r\n  content: \"\\F016D\";\r\n}\r\n\r\n.mdi-code-json::before {\r\n  content: \"\\F0626\";\r\n}\r\n\r\n.mdi-code-less-than::before {\r\n  content: \"\\F016E\";\r\n}\r\n\r\n.mdi-code-less-than-or-equal::before {\r\n  content: \"\\F016F\";\r\n}\r\n\r\n.mdi-code-not-equal::before {\r\n  content: \"\\F0170\";\r\n}\r\n\r\n.mdi-code-not-equal-variant::before {\r\n  content: \"\\F0171\";\r\n}\r\n\r\n.mdi-code-parentheses::before {\r\n  content: \"\\F0172\";\r\n}\r\n\r\n.mdi-code-parentheses-box::before {\r\n  content: \"\\F10D7\";\r\n}\r\n\r\n.mdi-code-string::before {\r\n  content: \"\\F0173\";\r\n}\r\n\r\n.mdi-code-tags::before {\r\n  content: \"\\F0174\";\r\n}\r\n\r\n.mdi-code-tags-check::before {\r\n  content: \"\\F0694\";\r\n}\r\n\r\n.mdi-codepen::before {\r\n  content: \"\\F0175\";\r\n}\r\n\r\n.mdi-coffee::before {\r\n  content: \"\\F0176\";\r\n}\r\n\r\n.mdi-coffee-maker::before {\r\n  content: \"\\F109F\";\r\n}\r\n\r\n.mdi-coffee-maker-check::before {\r\n  content: \"\\F1931\";\r\n}\r\n\r\n.mdi-coffee-maker-check-outline::before {\r\n  content: \"\\F1932\";\r\n}\r\n\r\n.mdi-coffee-maker-outline::before {\r\n  content: \"\\F181B\";\r\n}\r\n\r\n.mdi-coffee-off::before {\r\n  content: \"\\F0FAA\";\r\n}\r\n\r\n.mdi-coffee-off-outline::before {\r\n  content: \"\\F0FAB\";\r\n}\r\n\r\n.mdi-coffee-outline::before {\r\n  content: \"\\F06CA\";\r\n}\r\n\r\n.mdi-coffee-to-go::before {\r\n  content: \"\\F0177\";\r\n}\r\n\r\n.mdi-coffee-to-go-outline::before {\r\n  content: \"\\F130E\";\r\n}\r\n\r\n.mdi-coffin::before {\r\n  content: \"\\F0B7F\";\r\n}\r\n\r\n.mdi-cog::before {\r\n  content: \"\\F0493\";\r\n}\r\n\r\n.mdi-cog-box::before {\r\n  content: \"\\F0494\";\r\n}\r\n\r\n.mdi-cog-clockwise::before {\r\n  content: \"\\F11DD\";\r\n}\r\n\r\n.mdi-cog-counterclockwise::before {\r\n  content: \"\\F11DE\";\r\n}\r\n\r\n.mdi-cog-off::before {\r\n  content: \"\\F13CE\";\r\n}\r\n\r\n.mdi-cog-off-outline::before {\r\n  content: \"\\F13CF\";\r\n}\r\n\r\n.mdi-cog-outline::before {\r\n  content: \"\\F08BB\";\r\n}\r\n\r\n.mdi-cog-pause::before {\r\n  content: \"\\F1933\";\r\n}\r\n\r\n.mdi-cog-pause-outline::before {\r\n  content: \"\\F1934\";\r\n}\r\n\r\n.mdi-cog-play::before {\r\n  content: \"\\F1935\";\r\n}\r\n\r\n.mdi-cog-play-outline::before {\r\n  content: \"\\F1936\";\r\n}\r\n\r\n.mdi-cog-refresh::before {\r\n  content: \"\\F145E\";\r\n}\r\n\r\n.mdi-cog-refresh-outline::before {\r\n  content: \"\\F145F\";\r\n}\r\n\r\n.mdi-cog-stop::before {\r\n  content: \"\\F1937\";\r\n}\r\n\r\n.mdi-cog-stop-outline::before {\r\n  content: \"\\F1938\";\r\n}\r\n\r\n.mdi-cog-sync::before {\r\n  content: \"\\F1460\";\r\n}\r\n\r\n.mdi-cog-sync-outline::before {\r\n  content: \"\\F1461\";\r\n}\r\n\r\n.mdi-cog-transfer::before {\r\n  content: \"\\F105B\";\r\n}\r\n\r\n.mdi-cog-transfer-outline::before {\r\n  content: \"\\F105C\";\r\n}\r\n\r\n.mdi-cogs::before {\r\n  content: \"\\F08D6\";\r\n}\r\n\r\n.mdi-collage::before {\r\n  content: \"\\F0640\";\r\n}\r\n\r\n.mdi-collapse-all::before {\r\n  content: \"\\F0AA6\";\r\n}\r\n\r\n.mdi-collapse-all-outline::before {\r\n  content: \"\\F0AA7\";\r\n}\r\n\r\n.mdi-color-helper::before {\r\n  content: \"\\F0179\";\r\n}\r\n\r\n.mdi-comma::before {\r\n  content: \"\\F0E23\";\r\n}\r\n\r\n.mdi-comma-box::before {\r\n  content: \"\\F0E2B\";\r\n}\r\n\r\n.mdi-comma-box-outline::before {\r\n  content: \"\\F0E24\";\r\n}\r\n\r\n.mdi-comma-circle::before {\r\n  content: \"\\F0E25\";\r\n}\r\n\r\n.mdi-comma-circle-outline::before {\r\n  content: \"\\F0E26\";\r\n}\r\n\r\n.mdi-comment::before {\r\n  content: \"\\F017A\";\r\n}\r\n\r\n.mdi-comment-account::before {\r\n  content: \"\\F017B\";\r\n}\r\n\r\n.mdi-comment-account-outline::before {\r\n  content: \"\\F017C\";\r\n}\r\n\r\n.mdi-comment-alert::before {\r\n  content: \"\\F017D\";\r\n}\r\n\r\n.mdi-comment-alert-outline::before {\r\n  content: \"\\F017E\";\r\n}\r\n\r\n.mdi-comment-arrow-left::before {\r\n  content: \"\\F09E1\";\r\n}\r\n\r\n.mdi-comment-arrow-left-outline::before {\r\n  content: \"\\F09E2\";\r\n}\r\n\r\n.mdi-comment-arrow-right::before {\r\n  content: \"\\F09E3\";\r\n}\r\n\r\n.mdi-comment-arrow-right-outline::before {\r\n  content: \"\\F09E4\";\r\n}\r\n\r\n.mdi-comment-bookmark::before {\r\n  content: \"\\F15AE\";\r\n}\r\n\r\n.mdi-comment-bookmark-outline::before {\r\n  content: \"\\F15AF\";\r\n}\r\n\r\n.mdi-comment-check::before {\r\n  content: \"\\F017F\";\r\n}\r\n\r\n.mdi-comment-check-outline::before {\r\n  content: \"\\F0180\";\r\n}\r\n\r\n.mdi-comment-edit::before {\r\n  content: \"\\F11BF\";\r\n}\r\n\r\n.mdi-comment-edit-outline::before {\r\n  content: \"\\F12C4\";\r\n}\r\n\r\n.mdi-comment-eye::before {\r\n  content: \"\\F0A3A\";\r\n}\r\n\r\n.mdi-comment-eye-outline::before {\r\n  content: \"\\F0A3B\";\r\n}\r\n\r\n.mdi-comment-flash::before {\r\n  content: \"\\F15B0\";\r\n}\r\n\r\n.mdi-comment-flash-outline::before {\r\n  content: \"\\F15B1\";\r\n}\r\n\r\n.mdi-comment-minus::before {\r\n  content: \"\\F15DF\";\r\n}\r\n\r\n.mdi-comment-minus-outline::before {\r\n  content: \"\\F15E0\";\r\n}\r\n\r\n.mdi-comment-multiple::before {\r\n  content: \"\\F085F\";\r\n}\r\n\r\n.mdi-comment-multiple-outline::before {\r\n  content: \"\\F0181\";\r\n}\r\n\r\n.mdi-comment-off::before {\r\n  content: \"\\F15E1\";\r\n}\r\n\r\n.mdi-comment-off-outline::before {\r\n  content: \"\\F15E2\";\r\n}\r\n\r\n.mdi-comment-outline::before {\r\n  content: \"\\F0182\";\r\n}\r\n\r\n.mdi-comment-plus::before {\r\n  content: \"\\F09E5\";\r\n}\r\n\r\n.mdi-comment-plus-outline::before {\r\n  content: \"\\F0183\";\r\n}\r\n\r\n.mdi-comment-processing::before {\r\n  content: \"\\F0184\";\r\n}\r\n\r\n.mdi-comment-processing-outline::before {\r\n  content: \"\\F0185\";\r\n}\r\n\r\n.mdi-comment-question::before {\r\n  content: \"\\F0817\";\r\n}\r\n\r\n.mdi-comment-question-outline::before {\r\n  content: \"\\F0186\";\r\n}\r\n\r\n.mdi-comment-quote::before {\r\n  content: \"\\F1021\";\r\n}\r\n\r\n.mdi-comment-quote-outline::before {\r\n  content: \"\\F1022\";\r\n}\r\n\r\n.mdi-comment-remove::before {\r\n  content: \"\\F05DE\";\r\n}\r\n\r\n.mdi-comment-remove-outline::before {\r\n  content: \"\\F0187\";\r\n}\r\n\r\n.mdi-comment-search::before {\r\n  content: \"\\F0A3C\";\r\n}\r\n\r\n.mdi-comment-search-outline::before {\r\n  content: \"\\F0A3D\";\r\n}\r\n\r\n.mdi-comment-text::before {\r\n  content: \"\\F0188\";\r\n}\r\n\r\n.mdi-comment-text-multiple::before {\r\n  content: \"\\F0860\";\r\n}\r\n\r\n.mdi-comment-text-multiple-outline::before {\r\n  content: \"\\F0861\";\r\n}\r\n\r\n.mdi-comment-text-outline::before {\r\n  content: \"\\F0189\";\r\n}\r\n\r\n.mdi-compare::before {\r\n  content: \"\\F018A\";\r\n}\r\n\r\n.mdi-compare-horizontal::before {\r\n  content: \"\\F1492\";\r\n}\r\n\r\n.mdi-compare-remove::before {\r\n  content: \"\\F18B3\";\r\n}\r\n\r\n.mdi-compare-vertical::before {\r\n  content: \"\\F1493\";\r\n}\r\n\r\n.mdi-compass::before {\r\n  content: \"\\F018B\";\r\n}\r\n\r\n.mdi-compass-off::before {\r\n  content: \"\\F0B80\";\r\n}\r\n\r\n.mdi-compass-off-outline::before {\r\n  content: \"\\F0B81\";\r\n}\r\n\r\n.mdi-compass-outline::before {\r\n  content: \"\\F018C\";\r\n}\r\n\r\n.mdi-compass-rose::before {\r\n  content: \"\\F1382\";\r\n}\r\n\r\n.mdi-cone::before {\r\n  content: \"\\F194C\";\r\n}\r\n\r\n.mdi-cone-off::before {\r\n  content: \"\\F194D\";\r\n}\r\n\r\n.mdi-connection::before {\r\n  content: \"\\F1616\";\r\n}\r\n\r\n.mdi-console::before {\r\n  content: \"\\F018D\";\r\n}\r\n\r\n.mdi-console-line::before {\r\n  content: \"\\F07B7\";\r\n}\r\n\r\n.mdi-console-network::before {\r\n  content: \"\\F08A9\";\r\n}\r\n\r\n.mdi-console-network-outline::before {\r\n  content: \"\\F0C60\";\r\n}\r\n\r\n.mdi-consolidate::before {\r\n  content: \"\\F10D8\";\r\n}\r\n\r\n.mdi-contactless-payment::before {\r\n  content: \"\\F0D6A\";\r\n}\r\n\r\n.mdi-contactless-payment-circle::before {\r\n  content: \"\\F0321\";\r\n}\r\n\r\n.mdi-contactless-payment-circle-outline::before {\r\n  content: \"\\F0408\";\r\n}\r\n\r\n.mdi-contacts::before {\r\n  content: \"\\F06CB\";\r\n}\r\n\r\n.mdi-contacts-outline::before {\r\n  content: \"\\F05B8\";\r\n}\r\n\r\n.mdi-contain::before {\r\n  content: \"\\F0A3E\";\r\n}\r\n\r\n.mdi-contain-end::before {\r\n  content: \"\\F0A3F\";\r\n}\r\n\r\n.mdi-contain-start::before {\r\n  content: \"\\F0A40\";\r\n}\r\n\r\n.mdi-content-copy::before {\r\n  content: \"\\F018F\";\r\n}\r\n\r\n.mdi-content-cut::before {\r\n  content: \"\\F0190\";\r\n}\r\n\r\n.mdi-content-duplicate::before {\r\n  content: \"\\F0191\";\r\n}\r\n\r\n.mdi-content-paste::before {\r\n  content: \"\\F0192\";\r\n}\r\n\r\n.mdi-content-save::before {\r\n  content: \"\\F0193\";\r\n}\r\n\r\n.mdi-content-save-alert::before {\r\n  content: \"\\F0F42\";\r\n}\r\n\r\n.mdi-content-save-alert-outline::before {\r\n  content: \"\\F0F43\";\r\n}\r\n\r\n.mdi-content-save-all::before {\r\n  content: \"\\F0194\";\r\n}\r\n\r\n.mdi-content-save-all-outline::before {\r\n  content: \"\\F0F44\";\r\n}\r\n\r\n.mdi-content-save-check::before {\r\n  content: \"\\F18EA\";\r\n}\r\n\r\n.mdi-content-save-check-outline::before {\r\n  content: \"\\F18EB\";\r\n}\r\n\r\n.mdi-content-save-cog::before {\r\n  content: \"\\F145B\";\r\n}\r\n\r\n.mdi-content-save-cog-outline::before {\r\n  content: \"\\F145C\";\r\n}\r\n\r\n.mdi-content-save-edit::before {\r\n  content: \"\\F0CFB\";\r\n}\r\n\r\n.mdi-content-save-edit-outline::before {\r\n  content: \"\\F0CFC\";\r\n}\r\n\r\n.mdi-content-save-move::before {\r\n  content: \"\\F0E27\";\r\n}\r\n\r\n.mdi-content-save-move-outline::before {\r\n  content: \"\\F0E28\";\r\n}\r\n\r\n.mdi-content-save-off::before {\r\n  content: \"\\F1643\";\r\n}\r\n\r\n.mdi-content-save-off-outline::before {\r\n  content: \"\\F1644\";\r\n}\r\n\r\n.mdi-content-save-outline::before {\r\n  content: \"\\F0818\";\r\n}\r\n\r\n.mdi-content-save-settings::before {\r\n  content: \"\\F061B\";\r\n}\r\n\r\n.mdi-content-save-settings-outline::before {\r\n  content: \"\\F0B2E\";\r\n}\r\n\r\n.mdi-contrast::before {\r\n  content: \"\\F0195\";\r\n}\r\n\r\n.mdi-contrast-box::before {\r\n  content: \"\\F0196\";\r\n}\r\n\r\n.mdi-contrast-circle::before {\r\n  content: \"\\F0197\";\r\n}\r\n\r\n.mdi-controller-classic::before {\r\n  content: \"\\F0B82\";\r\n}\r\n\r\n.mdi-controller-classic-outline::before {\r\n  content: \"\\F0B83\";\r\n}\r\n\r\n.mdi-cookie::before {\r\n  content: \"\\F0198\";\r\n}\r\n\r\n.mdi-cookie-alert::before {\r\n  content: \"\\F16D0\";\r\n}\r\n\r\n.mdi-cookie-alert-outline::before {\r\n  content: \"\\F16D1\";\r\n}\r\n\r\n.mdi-cookie-check::before {\r\n  content: \"\\F16D2\";\r\n}\r\n\r\n.mdi-cookie-check-outline::before {\r\n  content: \"\\F16D3\";\r\n}\r\n\r\n.mdi-cookie-clock::before {\r\n  content: \"\\F16E4\";\r\n}\r\n\r\n.mdi-cookie-clock-outline::before {\r\n  content: \"\\F16E5\";\r\n}\r\n\r\n.mdi-cookie-cog::before {\r\n  content: \"\\F16D4\";\r\n}\r\n\r\n.mdi-cookie-cog-outline::before {\r\n  content: \"\\F16D5\";\r\n}\r\n\r\n.mdi-cookie-edit::before {\r\n  content: \"\\F16E6\";\r\n}\r\n\r\n.mdi-cookie-edit-outline::before {\r\n  content: \"\\F16E7\";\r\n}\r\n\r\n.mdi-cookie-lock::before {\r\n  content: \"\\F16E8\";\r\n}\r\n\r\n.mdi-cookie-lock-outline::before {\r\n  content: \"\\F16E9\";\r\n}\r\n\r\n.mdi-cookie-minus::before {\r\n  content: \"\\F16DA\";\r\n}\r\n\r\n.mdi-cookie-minus-outline::before {\r\n  content: \"\\F16DB\";\r\n}\r\n\r\n.mdi-cookie-off::before {\r\n  content: \"\\F16EA\";\r\n}\r\n\r\n.mdi-cookie-off-outline::before {\r\n  content: \"\\F16EB\";\r\n}\r\n\r\n.mdi-cookie-outline::before {\r\n  content: \"\\F16DE\";\r\n}\r\n\r\n.mdi-cookie-plus::before {\r\n  content: \"\\F16D6\";\r\n}\r\n\r\n.mdi-cookie-plus-outline::before {\r\n  content: \"\\F16D7\";\r\n}\r\n\r\n.mdi-cookie-refresh::before {\r\n  content: \"\\F16EC\";\r\n}\r\n\r\n.mdi-cookie-refresh-outline::before {\r\n  content: \"\\F16ED\";\r\n}\r\n\r\n.mdi-cookie-remove::before {\r\n  content: \"\\F16D8\";\r\n}\r\n\r\n.mdi-cookie-remove-outline::before {\r\n  content: \"\\F16D9\";\r\n}\r\n\r\n.mdi-cookie-settings::before {\r\n  content: \"\\F16DC\";\r\n}\r\n\r\n.mdi-cookie-settings-outline::before {\r\n  content: \"\\F16DD\";\r\n}\r\n\r\n.mdi-coolant-temperature::before {\r\n  content: \"\\F03C8\";\r\n}\r\n\r\n.mdi-copyleft::before {\r\n  content: \"\\F1939\";\r\n}\r\n\r\n.mdi-copyright::before {\r\n  content: \"\\F05E6\";\r\n}\r\n\r\n.mdi-cordova::before {\r\n  content: \"\\F0958\";\r\n}\r\n\r\n.mdi-corn::before {\r\n  content: \"\\F07B8\";\r\n}\r\n\r\n.mdi-corn-off::before {\r\n  content: \"\\F13EF\";\r\n}\r\n\r\n.mdi-cosine-wave::before {\r\n  content: \"\\F1479\";\r\n}\r\n\r\n.mdi-counter::before {\r\n  content: \"\\F0199\";\r\n}\r\n\r\n.mdi-countertop::before {\r\n  content: \"\\F181C\";\r\n}\r\n\r\n.mdi-countertop-outline::before {\r\n  content: \"\\F181D\";\r\n}\r\n\r\n.mdi-cow::before {\r\n  content: \"\\F019A\";\r\n}\r\n\r\n.mdi-cow-off::before {\r\n  content: \"\\F18FC\";\r\n}\r\n\r\n.mdi-cpu-32-bit::before {\r\n  content: \"\\F0EDF\";\r\n}\r\n\r\n.mdi-cpu-64-bit::before {\r\n  content: \"\\F0EE0\";\r\n}\r\n\r\n.mdi-cradle::before {\r\n  content: \"\\F198B\";\r\n}\r\n\r\n.mdi-cradle-outline::before {\r\n  content: \"\\F1991\";\r\n}\r\n\r\n.mdi-crane::before {\r\n  content: \"\\F0862\";\r\n}\r\n\r\n.mdi-creation::before {\r\n  content: \"\\F0674\";\r\n}\r\n\r\n.mdi-creative-commons::before {\r\n  content: \"\\F0D6B\";\r\n}\r\n\r\n.mdi-credit-card::before {\r\n  content: \"\\F0FEF\";\r\n}\r\n\r\n.mdi-credit-card-check::before {\r\n  content: \"\\F13D0\";\r\n}\r\n\r\n.mdi-credit-card-check-outline::before {\r\n  content: \"\\F13D1\";\r\n}\r\n\r\n.mdi-credit-card-chip::before {\r\n  content: \"\\F190F\";\r\n}\r\n\r\n.mdi-credit-card-chip-outline::before {\r\n  content: \"\\F1910\";\r\n}\r\n\r\n.mdi-credit-card-clock::before {\r\n  content: \"\\F0EE1\";\r\n}\r\n\r\n.mdi-credit-card-clock-outline::before {\r\n  content: \"\\F0EE2\";\r\n}\r\n\r\n.mdi-credit-card-edit::before {\r\n  content: \"\\F17D7\";\r\n}\r\n\r\n.mdi-credit-card-edit-outline::before {\r\n  content: \"\\F17D8\";\r\n}\r\n\r\n.mdi-credit-card-fast::before {\r\n  content: \"\\F1911\";\r\n}\r\n\r\n.mdi-credit-card-fast-outline::before {\r\n  content: \"\\F1912\";\r\n}\r\n\r\n.mdi-credit-card-lock::before {\r\n  content: \"\\F18E7\";\r\n}\r\n\r\n.mdi-credit-card-lock-outline::before {\r\n  content: \"\\F18E8\";\r\n}\r\n\r\n.mdi-credit-card-marker::before {\r\n  content: \"\\F06A8\";\r\n}\r\n\r\n.mdi-credit-card-marker-outline::before {\r\n  content: \"\\F0DBE\";\r\n}\r\n\r\n.mdi-credit-card-minus::before {\r\n  content: \"\\F0FAC\";\r\n}\r\n\r\n.mdi-credit-card-minus-outline::before {\r\n  content: \"\\F0FAD\";\r\n}\r\n\r\n.mdi-credit-card-multiple::before {\r\n  content: \"\\F0FF0\";\r\n}\r\n\r\n.mdi-credit-card-multiple-outline::before {\r\n  content: \"\\F019C\";\r\n}\r\n\r\n.mdi-credit-card-off::before {\r\n  content: \"\\F0FF1\";\r\n}\r\n\r\n.mdi-credit-card-off-outline::before {\r\n  content: \"\\F05E4\";\r\n}\r\n\r\n.mdi-credit-card-outline::before {\r\n  content: \"\\F019B\";\r\n}\r\n\r\n.mdi-credit-card-plus::before {\r\n  content: \"\\F0FF2\";\r\n}\r\n\r\n.mdi-credit-card-plus-outline::before {\r\n  content: \"\\F0676\";\r\n}\r\n\r\n.mdi-credit-card-refresh::before {\r\n  content: \"\\F1645\";\r\n}\r\n\r\n.mdi-credit-card-refresh-outline::before {\r\n  content: \"\\F1646\";\r\n}\r\n\r\n.mdi-credit-card-refund::before {\r\n  content: \"\\F0FF3\";\r\n}\r\n\r\n.mdi-credit-card-refund-outline::before {\r\n  content: \"\\F0AA8\";\r\n}\r\n\r\n.mdi-credit-card-remove::before {\r\n  content: \"\\F0FAE\";\r\n}\r\n\r\n.mdi-credit-card-remove-outline::before {\r\n  content: \"\\F0FAF\";\r\n}\r\n\r\n.mdi-credit-card-scan::before {\r\n  content: \"\\F0FF4\";\r\n}\r\n\r\n.mdi-credit-card-scan-outline::before {\r\n  content: \"\\F019D\";\r\n}\r\n\r\n.mdi-credit-card-search::before {\r\n  content: \"\\F1647\";\r\n}\r\n\r\n.mdi-credit-card-search-outline::before {\r\n  content: \"\\F1648\";\r\n}\r\n\r\n.mdi-credit-card-settings::before {\r\n  content: \"\\F0FF5\";\r\n}\r\n\r\n.mdi-credit-card-settings-outline::before {\r\n  content: \"\\F08D7\";\r\n}\r\n\r\n.mdi-credit-card-sync::before {\r\n  content: \"\\F1649\";\r\n}\r\n\r\n.mdi-credit-card-sync-outline::before {\r\n  content: \"\\F164A\";\r\n}\r\n\r\n.mdi-credit-card-wireless::before {\r\n  content: \"\\F0802\";\r\n}\r\n\r\n.mdi-credit-card-wireless-off::before {\r\n  content: \"\\F057A\";\r\n}\r\n\r\n.mdi-credit-card-wireless-off-outline::before {\r\n  content: \"\\F057B\";\r\n}\r\n\r\n.mdi-credit-card-wireless-outline::before {\r\n  content: \"\\F0D6C\";\r\n}\r\n\r\n.mdi-cricket::before {\r\n  content: \"\\F0D6D\";\r\n}\r\n\r\n.mdi-crop::before {\r\n  content: \"\\F019E\";\r\n}\r\n\r\n.mdi-crop-free::before {\r\n  content: \"\\F019F\";\r\n}\r\n\r\n.mdi-crop-landscape::before {\r\n  content: \"\\F01A0\";\r\n}\r\n\r\n.mdi-crop-portrait::before {\r\n  content: \"\\F01A1\";\r\n}\r\n\r\n.mdi-crop-rotate::before {\r\n  content: \"\\F0696\";\r\n}\r\n\r\n.mdi-crop-square::before {\r\n  content: \"\\F01A2\";\r\n}\r\n\r\n.mdi-cross::before {\r\n  content: \"\\F0953\";\r\n}\r\n\r\n.mdi-cross-bolnisi::before {\r\n  content: \"\\F0CED\";\r\n}\r\n\r\n.mdi-cross-celtic::before {\r\n  content: \"\\F0CF5\";\r\n}\r\n\r\n.mdi-cross-outline::before {\r\n  content: \"\\F0CF6\";\r\n}\r\n\r\n.mdi-crosshairs::before {\r\n  content: \"\\F01A3\";\r\n}\r\n\r\n.mdi-crosshairs-gps::before {\r\n  content: \"\\F01A4\";\r\n}\r\n\r\n.mdi-crosshairs-off::before {\r\n  content: \"\\F0F45\";\r\n}\r\n\r\n.mdi-crosshairs-question::before {\r\n  content: \"\\F1136\";\r\n}\r\n\r\n.mdi-crowd::before {\r\n  content: \"\\F1975\";\r\n}\r\n\r\n.mdi-crown::before {\r\n  content: \"\\F01A5\";\r\n}\r\n\r\n.mdi-crown-circle::before {\r\n  content: \"\\F17DC\";\r\n}\r\n\r\n.mdi-crown-circle-outline::before {\r\n  content: \"\\F17DD\";\r\n}\r\n\r\n.mdi-crown-outline::before {\r\n  content: \"\\F11D0\";\r\n}\r\n\r\n.mdi-cryengine::before {\r\n  content: \"\\F0959\";\r\n}\r\n\r\n.mdi-crystal-ball::before {\r\n  content: \"\\F0B2F\";\r\n}\r\n\r\n.mdi-cube::before {\r\n  content: \"\\F01A6\";\r\n}\r\n\r\n.mdi-cube-off::before {\r\n  content: \"\\F141C\";\r\n}\r\n\r\n.mdi-cube-off-outline::before {\r\n  content: \"\\F141D\";\r\n}\r\n\r\n.mdi-cube-outline::before {\r\n  content: \"\\F01A7\";\r\n}\r\n\r\n.mdi-cube-scan::before {\r\n  content: \"\\F0B84\";\r\n}\r\n\r\n.mdi-cube-send::before {\r\n  content: \"\\F01A8\";\r\n}\r\n\r\n.mdi-cube-unfolded::before {\r\n  content: \"\\F01A9\";\r\n}\r\n\r\n.mdi-cup::before {\r\n  content: \"\\F01AA\";\r\n}\r\n\r\n.mdi-cup-off::before {\r\n  content: \"\\F05E5\";\r\n}\r\n\r\n.mdi-cup-off-outline::before {\r\n  content: \"\\F137D\";\r\n}\r\n\r\n.mdi-cup-outline::before {\r\n  content: \"\\F130F\";\r\n}\r\n\r\n.mdi-cup-water::before {\r\n  content: \"\\F01AB\";\r\n}\r\n\r\n.mdi-cupboard::before {\r\n  content: \"\\F0F46\";\r\n}\r\n\r\n.mdi-cupboard-outline::before {\r\n  content: \"\\F0F47\";\r\n}\r\n\r\n.mdi-cupcake::before {\r\n  content: \"\\F095A\";\r\n}\r\n\r\n.mdi-curling::before {\r\n  content: \"\\F0863\";\r\n}\r\n\r\n.mdi-currency-bdt::before {\r\n  content: \"\\F0864\";\r\n}\r\n\r\n.mdi-currency-brl::before {\r\n  content: \"\\F0B85\";\r\n}\r\n\r\n.mdi-currency-btc::before {\r\n  content: \"\\F01AC\";\r\n}\r\n\r\n.mdi-currency-cny::before {\r\n  content: \"\\F07BA\";\r\n}\r\n\r\n.mdi-currency-eth::before {\r\n  content: \"\\F07BB\";\r\n}\r\n\r\n.mdi-currency-eur::before {\r\n  content: \"\\F01AD\";\r\n}\r\n\r\n.mdi-currency-eur-off::before {\r\n  content: \"\\F1315\";\r\n}\r\n\r\n.mdi-currency-gbp::before {\r\n  content: \"\\F01AE\";\r\n}\r\n\r\n.mdi-currency-ils::before {\r\n  content: \"\\F0C61\";\r\n}\r\n\r\n.mdi-currency-inr::before {\r\n  content: \"\\F01AF\";\r\n}\r\n\r\n.mdi-currency-jpy::before {\r\n  content: \"\\F07BC\";\r\n}\r\n\r\n.mdi-currency-krw::before {\r\n  content: \"\\F07BD\";\r\n}\r\n\r\n.mdi-currency-kzt::before {\r\n  content: \"\\F0865\";\r\n}\r\n\r\n.mdi-currency-mnt::before {\r\n  content: \"\\F1512\";\r\n}\r\n\r\n.mdi-currency-ngn::before {\r\n  content: \"\\F01B0\";\r\n}\r\n\r\n.mdi-currency-php::before {\r\n  content: \"\\F09E6\";\r\n}\r\n\r\n.mdi-currency-rial::before {\r\n  content: \"\\F0E9C\";\r\n}\r\n\r\n.mdi-currency-rub::before {\r\n  content: \"\\F01B1\";\r\n}\r\n\r\n.mdi-currency-rupee::before {\r\n  content: \"\\F1976\";\r\n}\r\n\r\n.mdi-currency-sign::before {\r\n  content: \"\\F07BE\";\r\n}\r\n\r\n.mdi-currency-try::before {\r\n  content: \"\\F01B2\";\r\n}\r\n\r\n.mdi-currency-twd::before {\r\n  content: \"\\F07BF\";\r\n}\r\n\r\n.mdi-currency-usd::before {\r\n  content: \"\\F01C1\";\r\n}\r\n\r\n.mdi-currency-usd-off::before {\r\n  content: \"\\F067A\";\r\n}\r\n\r\n.mdi-current-ac::before {\r\n  content: \"\\F1480\";\r\n}\r\n\r\n.mdi-current-dc::before {\r\n  content: \"\\F095C\";\r\n}\r\n\r\n.mdi-cursor-default::before {\r\n  content: \"\\F01C0\";\r\n}\r\n\r\n.mdi-cursor-default-click::before {\r\n  content: \"\\F0CFD\";\r\n}\r\n\r\n.mdi-cursor-default-click-outline::before {\r\n  content: \"\\F0CFE\";\r\n}\r\n\r\n.mdi-cursor-default-gesture::before {\r\n  content: \"\\F1127\";\r\n}\r\n\r\n.mdi-cursor-default-gesture-outline::before {\r\n  content: \"\\F1128\";\r\n}\r\n\r\n.mdi-cursor-default-outline::before {\r\n  content: \"\\F01BF\";\r\n}\r\n\r\n.mdi-cursor-move::before {\r\n  content: \"\\F01BE\";\r\n}\r\n\r\n.mdi-cursor-pointer::before {\r\n  content: \"\\F01BD\";\r\n}\r\n\r\n.mdi-cursor-text::before {\r\n  content: \"\\F05E7\";\r\n}\r\n\r\n.mdi-curtains::before {\r\n  content: \"\\F1846\";\r\n}\r\n\r\n.mdi-curtains-closed::before {\r\n  content: \"\\F1847\";\r\n}\r\n\r\n.mdi-cylinder::before {\r\n  content: \"\\F194E\";\r\n}\r\n\r\n.mdi-cylinder-off::before {\r\n  content: \"\\F194F\";\r\n}\r\n\r\n.mdi-dance-ballroom::before {\r\n  content: \"\\F15FB\";\r\n}\r\n\r\n.mdi-dance-pole::before {\r\n  content: \"\\F1578\";\r\n}\r\n\r\n.mdi-data-matrix::before {\r\n  content: \"\\F153C\";\r\n}\r\n\r\n.mdi-data-matrix-edit::before {\r\n  content: \"\\F153D\";\r\n}\r\n\r\n.mdi-data-matrix-minus::before {\r\n  content: \"\\F153E\";\r\n}\r\n\r\n.mdi-data-matrix-plus::before {\r\n  content: \"\\F153F\";\r\n}\r\n\r\n.mdi-data-matrix-remove::before {\r\n  content: \"\\F1540\";\r\n}\r\n\r\n.mdi-data-matrix-scan::before {\r\n  content: \"\\F1541\";\r\n}\r\n\r\n.mdi-database::before {\r\n  content: \"\\F01BC\";\r\n}\r\n\r\n.mdi-database-alert::before {\r\n  content: \"\\F163A\";\r\n}\r\n\r\n.mdi-database-alert-outline::before {\r\n  content: \"\\F1624\";\r\n}\r\n\r\n.mdi-database-arrow-down::before {\r\n  content: \"\\F163B\";\r\n}\r\n\r\n.mdi-database-arrow-down-outline::before {\r\n  content: \"\\F1625\";\r\n}\r\n\r\n.mdi-database-arrow-left::before {\r\n  content: \"\\F163C\";\r\n}\r\n\r\n.mdi-database-arrow-left-outline::before {\r\n  content: \"\\F1626\";\r\n}\r\n\r\n.mdi-database-arrow-right::before {\r\n  content: \"\\F163D\";\r\n}\r\n\r\n.mdi-database-arrow-right-outline::before {\r\n  content: \"\\F1627\";\r\n}\r\n\r\n.mdi-database-arrow-up::before {\r\n  content: \"\\F163E\";\r\n}\r\n\r\n.mdi-database-arrow-up-outline::before {\r\n  content: \"\\F1628\";\r\n}\r\n\r\n.mdi-database-check::before {\r\n  content: \"\\F0AA9\";\r\n}\r\n\r\n.mdi-database-check-outline::before {\r\n  content: \"\\F1629\";\r\n}\r\n\r\n.mdi-database-clock::before {\r\n  content: \"\\F163F\";\r\n}\r\n\r\n.mdi-database-clock-outline::before {\r\n  content: \"\\F162A\";\r\n}\r\n\r\n.mdi-database-cog::before {\r\n  content: \"\\F164B\";\r\n}\r\n\r\n.mdi-database-cog-outline::before {\r\n  content: \"\\F164C\";\r\n}\r\n\r\n.mdi-database-edit::before {\r\n  content: \"\\F0B86\";\r\n}\r\n\r\n.mdi-database-edit-outline::before {\r\n  content: \"\\F162B\";\r\n}\r\n\r\n.mdi-database-export::before {\r\n  content: \"\\F095E\";\r\n}\r\n\r\n.mdi-database-export-outline::before {\r\n  content: \"\\F162C\";\r\n}\r\n\r\n.mdi-database-eye::before {\r\n  content: \"\\F191F\";\r\n}\r\n\r\n.mdi-database-eye-off::before {\r\n  content: \"\\F1920\";\r\n}\r\n\r\n.mdi-database-eye-off-outline::before {\r\n  content: \"\\F1921\";\r\n}\r\n\r\n.mdi-database-eye-outline::before {\r\n  content: \"\\F1922\";\r\n}\r\n\r\n.mdi-database-import::before {\r\n  content: \"\\F095D\";\r\n}\r\n\r\n.mdi-database-import-outline::before {\r\n  content: \"\\F162D\";\r\n}\r\n\r\n.mdi-database-lock::before {\r\n  content: \"\\F0AAA\";\r\n}\r\n\r\n.mdi-database-lock-outline::before {\r\n  content: \"\\F162E\";\r\n}\r\n\r\n.mdi-database-marker::before {\r\n  content: \"\\F12F6\";\r\n}\r\n\r\n.mdi-database-marker-outline::before {\r\n  content: \"\\F162F\";\r\n}\r\n\r\n.mdi-database-minus::before {\r\n  content: \"\\F01BB\";\r\n}\r\n\r\n.mdi-database-minus-outline::before {\r\n  content: \"\\F1630\";\r\n}\r\n\r\n.mdi-database-off::before {\r\n  content: \"\\F1640\";\r\n}\r\n\r\n.mdi-database-off-outline::before {\r\n  content: \"\\F1631\";\r\n}\r\n\r\n.mdi-database-outline::before {\r\n  content: \"\\F1632\";\r\n}\r\n\r\n.mdi-database-plus::before {\r\n  content: \"\\F01BA\";\r\n}\r\n\r\n.mdi-database-plus-outline::before {\r\n  content: \"\\F1633\";\r\n}\r\n\r\n.mdi-database-refresh::before {\r\n  content: \"\\F05C2\";\r\n}\r\n\r\n.mdi-database-refresh-outline::before {\r\n  content: \"\\F1634\";\r\n}\r\n\r\n.mdi-database-remove::before {\r\n  content: \"\\F0D00\";\r\n}\r\n\r\n.mdi-database-remove-outline::before {\r\n  content: \"\\F1635\";\r\n}\r\n\r\n.mdi-database-search::before {\r\n  content: \"\\F0866\";\r\n}\r\n\r\n.mdi-database-search-outline::before {\r\n  content: \"\\F1636\";\r\n}\r\n\r\n.mdi-database-settings::before {\r\n  content: \"\\F0D01\";\r\n}\r\n\r\n.mdi-database-settings-outline::before {\r\n  content: \"\\F1637\";\r\n}\r\n\r\n.mdi-database-sync::before {\r\n  content: \"\\F0CFF\";\r\n}\r\n\r\n.mdi-database-sync-outline::before {\r\n  content: \"\\F1638\";\r\n}\r\n\r\n.mdi-death-star::before {\r\n  content: \"\\F08D8\";\r\n}\r\n\r\n.mdi-death-star-variant::before {\r\n  content: \"\\F08D9\";\r\n}\r\n\r\n.mdi-deathly-hallows::before {\r\n  content: \"\\F0B87\";\r\n}\r\n\r\n.mdi-debian::before {\r\n  content: \"\\F08DA\";\r\n}\r\n\r\n.mdi-debug-step-into::before {\r\n  content: \"\\F01B9\";\r\n}\r\n\r\n.mdi-debug-step-out::before {\r\n  content: \"\\F01B8\";\r\n}\r\n\r\n.mdi-debug-step-over::before {\r\n  content: \"\\F01B7\";\r\n}\r\n\r\n.mdi-decagram::before {\r\n  content: \"\\F076C\";\r\n}\r\n\r\n.mdi-decagram-outline::before {\r\n  content: \"\\F076D\";\r\n}\r\n\r\n.mdi-decimal::before {\r\n  content: \"\\F10A1\";\r\n}\r\n\r\n.mdi-decimal-comma::before {\r\n  content: \"\\F10A2\";\r\n}\r\n\r\n.mdi-decimal-comma-decrease::before {\r\n  content: \"\\F10A3\";\r\n}\r\n\r\n.mdi-decimal-comma-increase::before {\r\n  content: \"\\F10A4\";\r\n}\r\n\r\n.mdi-decimal-decrease::before {\r\n  content: \"\\F01B6\";\r\n}\r\n\r\n.mdi-decimal-increase::before {\r\n  content: \"\\F01B5\";\r\n}\r\n\r\n.mdi-delete::before {\r\n  content: \"\\F01B4\";\r\n}\r\n\r\n.mdi-delete-alert::before {\r\n  content: \"\\F10A5\";\r\n}\r\n\r\n.mdi-delete-alert-outline::before {\r\n  content: \"\\F10A6\";\r\n}\r\n\r\n.mdi-delete-circle::before {\r\n  content: \"\\F0683\";\r\n}\r\n\r\n.mdi-delete-circle-outline::before {\r\n  content: \"\\F0B88\";\r\n}\r\n\r\n.mdi-delete-clock::before {\r\n  content: \"\\F1556\";\r\n}\r\n\r\n.mdi-delete-clock-outline::before {\r\n  content: \"\\F1557\";\r\n}\r\n\r\n.mdi-delete-empty::before {\r\n  content: \"\\F06CC\";\r\n}\r\n\r\n.mdi-delete-empty-outline::before {\r\n  content: \"\\F0E9D\";\r\n}\r\n\r\n.mdi-delete-forever::before {\r\n  content: \"\\F05E8\";\r\n}\r\n\r\n.mdi-delete-forever-outline::before {\r\n  content: \"\\F0B89\";\r\n}\r\n\r\n.mdi-delete-off::before {\r\n  content: \"\\F10A7\";\r\n}\r\n\r\n.mdi-delete-off-outline::before {\r\n  content: \"\\F10A8\";\r\n}\r\n\r\n.mdi-delete-outline::before {\r\n  content: \"\\F09E7\";\r\n}\r\n\r\n.mdi-delete-restore::before {\r\n  content: \"\\F0819\";\r\n}\r\n\r\n.mdi-delete-sweep::before {\r\n  content: \"\\F05E9\";\r\n}\r\n\r\n.mdi-delete-sweep-outline::before {\r\n  content: \"\\F0C62\";\r\n}\r\n\r\n.mdi-delete-variant::before {\r\n  content: \"\\F01B3\";\r\n}\r\n\r\n.mdi-delta::before {\r\n  content: \"\\F01C2\";\r\n}\r\n\r\n.mdi-desk::before {\r\n  content: \"\\F1239\";\r\n}\r\n\r\n.mdi-desk-lamp::before {\r\n  content: \"\\F095F\";\r\n}\r\n\r\n.mdi-deskphone::before {\r\n  content: \"\\F01C3\";\r\n}\r\n\r\n.mdi-desktop-classic::before {\r\n  content: \"\\F07C0\";\r\n}\r\n\r\n.mdi-desktop-mac::before {\r\n  content: \"\\F01C4\";\r\n}\r\n\r\n.mdi-desktop-mac-dashboard::before {\r\n  content: \"\\F09E8\";\r\n}\r\n\r\n.mdi-desktop-tower::before {\r\n  content: \"\\F01C5\";\r\n}\r\n\r\n.mdi-desktop-tower-monitor::before {\r\n  content: \"\\F0AAB\";\r\n}\r\n\r\n.mdi-details::before {\r\n  content: \"\\F01C6\";\r\n}\r\n\r\n.mdi-dev-to::before {\r\n  content: \"\\F0D6E\";\r\n}\r\n\r\n.mdi-developer-board::before {\r\n  content: \"\\F0697\";\r\n}\r\n\r\n.mdi-deviantart::before {\r\n  content: \"\\F01C7\";\r\n}\r\n\r\n.mdi-devices::before {\r\n  content: \"\\F0FB0\";\r\n}\r\n\r\n.mdi-dharmachakra::before {\r\n  content: \"\\F094B\";\r\n}\r\n\r\n.mdi-diabetes::before {\r\n  content: \"\\F1126\";\r\n}\r\n\r\n.mdi-dialpad::before {\r\n  content: \"\\F061C\";\r\n}\r\n\r\n.mdi-diameter::before {\r\n  content: \"\\F0C63\";\r\n}\r\n\r\n.mdi-diameter-outline::before {\r\n  content: \"\\F0C64\";\r\n}\r\n\r\n.mdi-diameter-variant::before {\r\n  content: \"\\F0C65\";\r\n}\r\n\r\n.mdi-diamond::before {\r\n  content: \"\\F0B8A\";\r\n}\r\n\r\n.mdi-diamond-outline::before {\r\n  content: \"\\F0B8B\";\r\n}\r\n\r\n.mdi-diamond-stone::before {\r\n  content: \"\\F01C8\";\r\n}\r\n\r\n.mdi-dice-1::before {\r\n  content: \"\\F01CA\";\r\n}\r\n\r\n.mdi-dice-1-outline::before {\r\n  content: \"\\F114A\";\r\n}\r\n\r\n.mdi-dice-2::before {\r\n  content: \"\\F01CB\";\r\n}\r\n\r\n.mdi-dice-2-outline::before {\r\n  content: \"\\F114B\";\r\n}\r\n\r\n.mdi-dice-3::before {\r\n  content: \"\\F01CC\";\r\n}\r\n\r\n.mdi-dice-3-outline::before {\r\n  content: \"\\F114C\";\r\n}\r\n\r\n.mdi-dice-4::before {\r\n  content: \"\\F01CD\";\r\n}\r\n\r\n.mdi-dice-4-outline::before {\r\n  content: \"\\F114D\";\r\n}\r\n\r\n.mdi-dice-5::before {\r\n  content: \"\\F01CE\";\r\n}\r\n\r\n.mdi-dice-5-outline::before {\r\n  content: \"\\F114E\";\r\n}\r\n\r\n.mdi-dice-6::before {\r\n  content: \"\\F01CF\";\r\n}\r\n\r\n.mdi-dice-6-outline::before {\r\n  content: \"\\F114F\";\r\n}\r\n\r\n.mdi-dice-d10::before {\r\n  content: \"\\F1153\";\r\n}\r\n\r\n.mdi-dice-d10-outline::before {\r\n  content: \"\\F076F\";\r\n}\r\n\r\n.mdi-dice-d12::before {\r\n  content: \"\\F1154\";\r\n}\r\n\r\n.mdi-dice-d12-outline::before {\r\n  content: \"\\F0867\";\r\n}\r\n\r\n.mdi-dice-d20::before {\r\n  content: \"\\F1155\";\r\n}\r\n\r\n.mdi-dice-d20-outline::before {\r\n  content: \"\\F05EA\";\r\n}\r\n\r\n.mdi-dice-d4::before {\r\n  content: \"\\F1150\";\r\n}\r\n\r\n.mdi-dice-d4-outline::before {\r\n  content: \"\\F05EB\";\r\n}\r\n\r\n.mdi-dice-d6::before {\r\n  content: \"\\F1151\";\r\n}\r\n\r\n.mdi-dice-d6-outline::before {\r\n  content: \"\\F05ED\";\r\n}\r\n\r\n.mdi-dice-d8::before {\r\n  content: \"\\F1152\";\r\n}\r\n\r\n.mdi-dice-d8-outline::before {\r\n  content: \"\\F05EC\";\r\n}\r\n\r\n.mdi-dice-multiple::before {\r\n  content: \"\\F076E\";\r\n}\r\n\r\n.mdi-dice-multiple-outline::before {\r\n  content: \"\\F1156\";\r\n}\r\n\r\n.mdi-digital-ocean::before {\r\n  content: \"\\F1237\";\r\n}\r\n\r\n.mdi-dip-switch::before {\r\n  content: \"\\F07C1\";\r\n}\r\n\r\n.mdi-directions::before {\r\n  content: \"\\F01D0\";\r\n}\r\n\r\n.mdi-directions-fork::before {\r\n  content: \"\\F0641\";\r\n}\r\n\r\n.mdi-disc::before {\r\n  content: \"\\F05EE\";\r\n}\r\n\r\n.mdi-disc-alert::before {\r\n  content: \"\\F01D1\";\r\n}\r\n\r\n.mdi-disc-player::before {\r\n  content: \"\\F0960\";\r\n}\r\n\r\n.mdi-discord::before {\r\n  content: \"\\F066F\";\r\n}\r\n\r\n.mdi-dishwasher::before {\r\n  content: \"\\F0AAC\";\r\n}\r\n\r\n.mdi-dishwasher-alert::before {\r\n  content: \"\\F11B8\";\r\n}\r\n\r\n.mdi-dishwasher-off::before {\r\n  content: \"\\F11B9\";\r\n}\r\n\r\n.mdi-disqus::before {\r\n  content: \"\\F01D2\";\r\n}\r\n\r\n.mdi-distribute-horizontal-center::before {\r\n  content: \"\\F11C9\";\r\n}\r\n\r\n.mdi-distribute-horizontal-left::before {\r\n  content: \"\\F11C8\";\r\n}\r\n\r\n.mdi-distribute-horizontal-right::before {\r\n  content: \"\\F11CA\";\r\n}\r\n\r\n.mdi-distribute-vertical-bottom::before {\r\n  content: \"\\F11CB\";\r\n}\r\n\r\n.mdi-distribute-vertical-center::before {\r\n  content: \"\\F11CC\";\r\n}\r\n\r\n.mdi-distribute-vertical-top::before {\r\n  content: \"\\F11CD\";\r\n}\r\n\r\n.mdi-diversify::before {\r\n  content: \"\\F1877\";\r\n}\r\n\r\n.mdi-diving::before {\r\n  content: \"\\F1977\";\r\n}\r\n\r\n.mdi-diving-flippers::before {\r\n  content: \"\\F0DBF\";\r\n}\r\n\r\n.mdi-diving-helmet::before {\r\n  content: \"\\F0DC0\";\r\n}\r\n\r\n.mdi-diving-scuba::before {\r\n  content: \"\\F0DC1\";\r\n}\r\n\r\n.mdi-diving-scuba-flag::before {\r\n  content: \"\\F0DC2\";\r\n}\r\n\r\n.mdi-diving-scuba-tank::before {\r\n  content: \"\\F0DC3\";\r\n}\r\n\r\n.mdi-diving-scuba-tank-multiple::before {\r\n  content: \"\\F0DC4\";\r\n}\r\n\r\n.mdi-diving-snorkel::before {\r\n  content: \"\\F0DC5\";\r\n}\r\n\r\n.mdi-division::before {\r\n  content: \"\\F01D4\";\r\n}\r\n\r\n.mdi-division-box::before {\r\n  content: \"\\F01D5\";\r\n}\r\n\r\n.mdi-dlna::before {\r\n  content: \"\\F0A41\";\r\n}\r\n\r\n.mdi-dna::before {\r\n  content: \"\\F0684\";\r\n}\r\n\r\n.mdi-dns::before {\r\n  content: \"\\F01D6\";\r\n}\r\n\r\n.mdi-dns-outline::before {\r\n  content: \"\\F0B8C\";\r\n}\r\n\r\n.mdi-dock-bottom::before {\r\n  content: \"\\F10A9\";\r\n}\r\n\r\n.mdi-dock-left::before {\r\n  content: \"\\F10AA\";\r\n}\r\n\r\n.mdi-dock-right::before {\r\n  content: \"\\F10AB\";\r\n}\r\n\r\n.mdi-dock-top::before {\r\n  content: \"\\F1513\";\r\n}\r\n\r\n.mdi-dock-window::before {\r\n  content: \"\\F10AC\";\r\n}\r\n\r\n.mdi-docker::before {\r\n  content: \"\\F0868\";\r\n}\r\n\r\n.mdi-doctor::before {\r\n  content: \"\\F0A42\";\r\n}\r\n\r\n.mdi-dog::before {\r\n  content: \"\\F0A43\";\r\n}\r\n\r\n.mdi-dog-service::before {\r\n  content: \"\\F0AAD\";\r\n}\r\n\r\n.mdi-dog-side::before {\r\n  content: \"\\F0A44\";\r\n}\r\n\r\n.mdi-dog-side-off::before {\r\n  content: \"\\F16EE\";\r\n}\r\n\r\n.mdi-dolby::before {\r\n  content: \"\\F06B3\";\r\n}\r\n\r\n.mdi-dolly::before {\r\n  content: \"\\F0E9E\";\r\n}\r\n\r\n.mdi-dolphin::before {\r\n  content: \"\\F18B4\";\r\n}\r\n\r\n.mdi-domain::before {\r\n  content: \"\\F01D7\";\r\n}\r\n\r\n.mdi-domain-off::before {\r\n  content: \"\\F0D6F\";\r\n}\r\n\r\n.mdi-domain-plus::before {\r\n  content: \"\\F10AD\";\r\n}\r\n\r\n.mdi-domain-remove::before {\r\n  content: \"\\F10AE\";\r\n}\r\n\r\n.mdi-dome-light::before {\r\n  content: \"\\F141E\";\r\n}\r\n\r\n.mdi-domino-mask::before {\r\n  content: \"\\F1023\";\r\n}\r\n\r\n.mdi-donkey::before {\r\n  content: \"\\F07C2\";\r\n}\r\n\r\n.mdi-door::before {\r\n  content: \"\\F081A\";\r\n}\r\n\r\n.mdi-door-closed::before {\r\n  content: \"\\F081B\";\r\n}\r\n\r\n.mdi-door-closed-lock::before {\r\n  content: \"\\F10AF\";\r\n}\r\n\r\n.mdi-door-open::before {\r\n  content: \"\\F081C\";\r\n}\r\n\r\n.mdi-door-sliding::before {\r\n  content: \"\\F181E\";\r\n}\r\n\r\n.mdi-door-sliding-lock::before {\r\n  content: \"\\F181F\";\r\n}\r\n\r\n.mdi-door-sliding-open::before {\r\n  content: \"\\F1820\";\r\n}\r\n\r\n.mdi-doorbell::before {\r\n  content: \"\\F12E6\";\r\n}\r\n\r\n.mdi-doorbell-video::before {\r\n  content: \"\\F0869\";\r\n}\r\n\r\n.mdi-dot-net::before {\r\n  content: \"\\F0AAE\";\r\n}\r\n\r\n.mdi-dots-circle::before {\r\n  content: \"\\F1978\";\r\n}\r\n\r\n.mdi-dots-grid::before {\r\n  content: \"\\F15FC\";\r\n}\r\n\r\n.mdi-dots-hexagon::before {\r\n  content: \"\\F15FF\";\r\n}\r\n\r\n.mdi-dots-horizontal::before {\r\n  content: \"\\F01D8\";\r\n}\r\n\r\n.mdi-dots-horizontal-circle::before {\r\n  content: \"\\F07C3\";\r\n}\r\n\r\n.mdi-dots-horizontal-circle-outline::before {\r\n  content: \"\\F0B8D\";\r\n}\r\n\r\n.mdi-dots-square::before {\r\n  content: \"\\F15FD\";\r\n}\r\n\r\n.mdi-dots-triangle::before {\r\n  content: \"\\F15FE\";\r\n}\r\n\r\n.mdi-dots-vertical::before {\r\n  content: \"\\F01D9\";\r\n}\r\n\r\n.mdi-dots-vertical-circle::before {\r\n  content: \"\\F07C4\";\r\n}\r\n\r\n.mdi-dots-vertical-circle-outline::before {\r\n  content: \"\\F0B8E\";\r\n}\r\n\r\n.mdi-download::before {\r\n  content: \"\\F01DA\";\r\n}\r\n\r\n.mdi-download-box::before {\r\n  content: \"\\F1462\";\r\n}\r\n\r\n.mdi-download-box-outline::before {\r\n  content: \"\\F1463\";\r\n}\r\n\r\n.mdi-download-circle::before {\r\n  content: \"\\F1464\";\r\n}\r\n\r\n.mdi-download-circle-outline::before {\r\n  content: \"\\F1465\";\r\n}\r\n\r\n.mdi-download-lock::before {\r\n  content: \"\\F1320\";\r\n}\r\n\r\n.mdi-download-lock-outline::before {\r\n  content: \"\\F1321\";\r\n}\r\n\r\n.mdi-download-multiple::before {\r\n  content: \"\\F09E9\";\r\n}\r\n\r\n.mdi-download-network::before {\r\n  content: \"\\F06F4\";\r\n}\r\n\r\n.mdi-download-network-outline::before {\r\n  content: \"\\F0C66\";\r\n}\r\n\r\n.mdi-download-off::before {\r\n  content: \"\\F10B0\";\r\n}\r\n\r\n.mdi-download-off-outline::before {\r\n  content: \"\\F10B1\";\r\n}\r\n\r\n.mdi-download-outline::before {\r\n  content: \"\\F0B8F\";\r\n}\r\n\r\n.mdi-drag::before {\r\n  content: \"\\F01DB\";\r\n}\r\n\r\n.mdi-drag-horizontal::before {\r\n  content: \"\\F01DC\";\r\n}\r\n\r\n.mdi-drag-horizontal-variant::before {\r\n  content: \"\\F12F0\";\r\n}\r\n\r\n.mdi-drag-variant::before {\r\n  content: \"\\F0B90\";\r\n}\r\n\r\n.mdi-drag-vertical::before {\r\n  content: \"\\F01DD\";\r\n}\r\n\r\n.mdi-drag-vertical-variant::before {\r\n  content: \"\\F12F1\";\r\n}\r\n\r\n.mdi-drama-masks::before {\r\n  content: \"\\F0D02\";\r\n}\r\n\r\n.mdi-draw::before {\r\n  content: \"\\F0F49\";\r\n}\r\n\r\n.mdi-draw-pen::before {\r\n  content: \"\\F19B9\";\r\n}\r\n\r\n.mdi-drawing::before {\r\n  content: \"\\F01DE\";\r\n}\r\n\r\n.mdi-drawing-box::before {\r\n  content: \"\\F01DF\";\r\n}\r\n\r\n.mdi-dresser::before {\r\n  content: \"\\F0F4A\";\r\n}\r\n\r\n.mdi-dresser-outline::before {\r\n  content: \"\\F0F4B\";\r\n}\r\n\r\n.mdi-drone::before {\r\n  content: \"\\F01E2\";\r\n}\r\n\r\n.mdi-dropbox::before {\r\n  content: \"\\F01E3\";\r\n}\r\n\r\n.mdi-drupal::before {\r\n  content: \"\\F01E4\";\r\n}\r\n\r\n.mdi-duck::before {\r\n  content: \"\\F01E5\";\r\n}\r\n\r\n.mdi-dumbbell::before {\r\n  content: \"\\F01E6\";\r\n}\r\n\r\n.mdi-dump-truck::before {\r\n  content: \"\\F0C67\";\r\n}\r\n\r\n.mdi-ear-hearing::before {\r\n  content: \"\\F07C5\";\r\n}\r\n\r\n.mdi-ear-hearing-off::before {\r\n  content: \"\\F0A45\";\r\n}\r\n\r\n.mdi-earbuds::before {\r\n  content: \"\\F184F\";\r\n}\r\n\r\n.mdi-earbuds-off::before {\r\n  content: \"\\F1850\";\r\n}\r\n\r\n.mdi-earbuds-off-outline::before {\r\n  content: \"\\F1851\";\r\n}\r\n\r\n.mdi-earbuds-outline::before {\r\n  content: \"\\F1852\";\r\n}\r\n\r\n.mdi-earth::before {\r\n  content: \"\\F01E7\";\r\n}\r\n\r\n.mdi-earth-arrow-right::before {\r\n  content: \"\\F1311\";\r\n}\r\n\r\n.mdi-earth-box::before {\r\n  content: \"\\F06CD\";\r\n}\r\n\r\n.mdi-earth-box-minus::before {\r\n  content: \"\\F1407\";\r\n}\r\n\r\n.mdi-earth-box-off::before {\r\n  content: \"\\F06CE\";\r\n}\r\n\r\n.mdi-earth-box-plus::before {\r\n  content: \"\\F1406\";\r\n}\r\n\r\n.mdi-earth-box-remove::before {\r\n  content: \"\\F1408\";\r\n}\r\n\r\n.mdi-earth-minus::before {\r\n  content: \"\\F1404\";\r\n}\r\n\r\n.mdi-earth-off::before {\r\n  content: \"\\F01E8\";\r\n}\r\n\r\n.mdi-earth-plus::before {\r\n  content: \"\\F1403\";\r\n}\r\n\r\n.mdi-earth-remove::before {\r\n  content: \"\\F1405\";\r\n}\r\n\r\n.mdi-egg::before {\r\n  content: \"\\F0AAF\";\r\n}\r\n\r\n.mdi-egg-easter::before {\r\n  content: \"\\F0AB0\";\r\n}\r\n\r\n.mdi-egg-fried::before {\r\n  content: \"\\F184A\";\r\n}\r\n\r\n.mdi-egg-off::before {\r\n  content: \"\\F13F0\";\r\n}\r\n\r\n.mdi-egg-off-outline::before {\r\n  content: \"\\F13F1\";\r\n}\r\n\r\n.mdi-egg-outline::before {\r\n  content: \"\\F13F2\";\r\n}\r\n\r\n.mdi-eiffel-tower::before {\r\n  content: \"\\F156B\";\r\n}\r\n\r\n.mdi-eight-track::before {\r\n  content: \"\\F09EA\";\r\n}\r\n\r\n.mdi-eject::before {\r\n  content: \"\\F01EA\";\r\n}\r\n\r\n.mdi-eject-outline::before {\r\n  content: \"\\F0B91\";\r\n}\r\n\r\n.mdi-electric-switch::before {\r\n  content: \"\\F0E9F\";\r\n}\r\n\r\n.mdi-electric-switch-closed::before {\r\n  content: \"\\F10D9\";\r\n}\r\n\r\n.mdi-electron-framework::before {\r\n  content: \"\\F1024\";\r\n}\r\n\r\n.mdi-elephant::before {\r\n  content: \"\\F07C6\";\r\n}\r\n\r\n.mdi-elevation-decline::before {\r\n  content: \"\\F01EB\";\r\n}\r\n\r\n.mdi-elevation-rise::before {\r\n  content: \"\\F01EC\";\r\n}\r\n\r\n.mdi-elevator::before {\r\n  content: \"\\F01ED\";\r\n}\r\n\r\n.mdi-elevator-down::before {\r\n  content: \"\\F12C2\";\r\n}\r\n\r\n.mdi-elevator-passenger::before {\r\n  content: \"\\F1381\";\r\n}\r\n\r\n.mdi-elevator-passenger-off::before {\r\n  content: \"\\F1979\";\r\n}\r\n\r\n.mdi-elevator-passenger-off-outline::before {\r\n  content: \"\\F197A\";\r\n}\r\n\r\n.mdi-elevator-passenger-outline::before {\r\n  content: \"\\F197B\";\r\n}\r\n\r\n.mdi-elevator-up::before {\r\n  content: \"\\F12C1\";\r\n}\r\n\r\n.mdi-ellipse::before {\r\n  content: \"\\F0EA0\";\r\n}\r\n\r\n.mdi-ellipse-outline::before {\r\n  content: \"\\F0EA1\";\r\n}\r\n\r\n.mdi-email::before {\r\n  content: \"\\F01EE\";\r\n}\r\n\r\n.mdi-email-alert::before {\r\n  content: \"\\F06CF\";\r\n}\r\n\r\n.mdi-email-alert-outline::before {\r\n  content: \"\\F0D42\";\r\n}\r\n\r\n.mdi-email-box::before {\r\n  content: \"\\F0D03\";\r\n}\r\n\r\n.mdi-email-check::before {\r\n  content: \"\\F0AB1\";\r\n}\r\n\r\n.mdi-email-check-outline::before {\r\n  content: \"\\F0AB2\";\r\n}\r\n\r\n.mdi-email-edit::before {\r\n  content: \"\\F0EE3\";\r\n}\r\n\r\n.mdi-email-edit-outline::before {\r\n  content: \"\\F0EE4\";\r\n}\r\n\r\n.mdi-email-fast::before {\r\n  content: \"\\F186F\";\r\n}\r\n\r\n.mdi-email-fast-outline::before {\r\n  content: \"\\F1870\";\r\n}\r\n\r\n.mdi-email-lock::before {\r\n  content: \"\\F01F1\";\r\n}\r\n\r\n.mdi-email-mark-as-unread::before {\r\n  content: \"\\F0B92\";\r\n}\r\n\r\n.mdi-email-minus::before {\r\n  content: \"\\F0EE5\";\r\n}\r\n\r\n.mdi-email-minus-outline::before {\r\n  content: \"\\F0EE6\";\r\n}\r\n\r\n.mdi-email-multiple::before {\r\n  content: \"\\F0EE7\";\r\n}\r\n\r\n.mdi-email-multiple-outline::before {\r\n  content: \"\\F0EE8\";\r\n}\r\n\r\n.mdi-email-newsletter::before {\r\n  content: \"\\F0FB1\";\r\n}\r\n\r\n.mdi-email-off::before {\r\n  content: \"\\F13E3\";\r\n}\r\n\r\n.mdi-email-off-outline::before {\r\n  content: \"\\F13E4\";\r\n}\r\n\r\n.mdi-email-open::before {\r\n  content: \"\\F01EF\";\r\n}\r\n\r\n.mdi-email-open-multiple::before {\r\n  content: \"\\F0EE9\";\r\n}\r\n\r\n.mdi-email-open-multiple-outline::before {\r\n  content: \"\\F0EEA\";\r\n}\r\n\r\n.mdi-email-open-outline::before {\r\n  content: \"\\F05EF\";\r\n}\r\n\r\n.mdi-email-outline::before {\r\n  content: \"\\F01F0\";\r\n}\r\n\r\n.mdi-email-plus::before {\r\n  content: \"\\F09EB\";\r\n}\r\n\r\n.mdi-email-plus-outline::before {\r\n  content: \"\\F09EC\";\r\n}\r\n\r\n.mdi-email-receive::before {\r\n  content: \"\\F10DA\";\r\n}\r\n\r\n.mdi-email-receive-outline::before {\r\n  content: \"\\F10DB\";\r\n}\r\n\r\n.mdi-email-remove::before {\r\n  content: \"\\F1661\";\r\n}\r\n\r\n.mdi-email-remove-outline::before {\r\n  content: \"\\F1662\";\r\n}\r\n\r\n.mdi-email-seal::before {\r\n  content: \"\\F195B\";\r\n}\r\n\r\n.mdi-email-seal-outline::before {\r\n  content: \"\\F195C\";\r\n}\r\n\r\n.mdi-email-search::before {\r\n  content: \"\\F0961\";\r\n}\r\n\r\n.mdi-email-search-outline::before {\r\n  content: \"\\F0962\";\r\n}\r\n\r\n.mdi-email-send::before {\r\n  content: \"\\F10DC\";\r\n}\r\n\r\n.mdi-email-send-outline::before {\r\n  content: \"\\F10DD\";\r\n}\r\n\r\n.mdi-email-sync::before {\r\n  content: \"\\F12C7\";\r\n}\r\n\r\n.mdi-email-sync-outline::before {\r\n  content: \"\\F12C8\";\r\n}\r\n\r\n.mdi-email-variant::before {\r\n  content: \"\\F05F0\";\r\n}\r\n\r\n.mdi-ember::before {\r\n  content: \"\\F0B30\";\r\n}\r\n\r\n.mdi-emby::before {\r\n  content: \"\\F06B4\";\r\n}\r\n\r\n.mdi-emoticon::before {\r\n  content: \"\\F0C68\";\r\n}\r\n\r\n.mdi-emoticon-angry::before {\r\n  content: \"\\F0C69\";\r\n}\r\n\r\n.mdi-emoticon-angry-outline::before {\r\n  content: \"\\F0C6A\";\r\n}\r\n\r\n.mdi-emoticon-confused::before {\r\n  content: \"\\F10DE\";\r\n}\r\n\r\n.mdi-emoticon-confused-outline::before {\r\n  content: \"\\F10DF\";\r\n}\r\n\r\n.mdi-emoticon-cool::before {\r\n  content: \"\\F0C6B\";\r\n}\r\n\r\n.mdi-emoticon-cool-outline::before {\r\n  content: \"\\F01F3\";\r\n}\r\n\r\n.mdi-emoticon-cry::before {\r\n  content: \"\\F0C6C\";\r\n}\r\n\r\n.mdi-emoticon-cry-outline::before {\r\n  content: \"\\F0C6D\";\r\n}\r\n\r\n.mdi-emoticon-dead::before {\r\n  content: \"\\F0C6E\";\r\n}\r\n\r\n.mdi-emoticon-dead-outline::before {\r\n  content: \"\\F069B\";\r\n}\r\n\r\n.mdi-emoticon-devil::before {\r\n  content: \"\\F0C6F\";\r\n}\r\n\r\n.mdi-emoticon-devil-outline::before {\r\n  content: \"\\F01F4\";\r\n}\r\n\r\n.mdi-emoticon-excited::before {\r\n  content: \"\\F0C70\";\r\n}\r\n\r\n.mdi-emoticon-excited-outline::before {\r\n  content: \"\\F069C\";\r\n}\r\n\r\n.mdi-emoticon-frown::before {\r\n  content: \"\\F0F4C\";\r\n}\r\n\r\n.mdi-emoticon-frown-outline::before {\r\n  content: \"\\F0F4D\";\r\n}\r\n\r\n.mdi-emoticon-happy::before {\r\n  content: \"\\F0C71\";\r\n}\r\n\r\n.mdi-emoticon-happy-outline::before {\r\n  content: \"\\F01F5\";\r\n}\r\n\r\n.mdi-emoticon-kiss::before {\r\n  content: \"\\F0C72\";\r\n}\r\n\r\n.mdi-emoticon-kiss-outline::before {\r\n  content: \"\\F0C73\";\r\n}\r\n\r\n.mdi-emoticon-lol::before {\r\n  content: \"\\F1214\";\r\n}\r\n\r\n.mdi-emoticon-lol-outline::before {\r\n  content: \"\\F1215\";\r\n}\r\n\r\n.mdi-emoticon-neutral::before {\r\n  content: \"\\F0C74\";\r\n}\r\n\r\n.mdi-emoticon-neutral-outline::before {\r\n  content: \"\\F01F6\";\r\n}\r\n\r\n.mdi-emoticon-outline::before {\r\n  content: \"\\F01F2\";\r\n}\r\n\r\n.mdi-emoticon-poop::before {\r\n  content: \"\\F01F7\";\r\n}\r\n\r\n.mdi-emoticon-poop-outline::before {\r\n  content: \"\\F0C75\";\r\n}\r\n\r\n.mdi-emoticon-sad::before {\r\n  content: \"\\F0C76\";\r\n}\r\n\r\n.mdi-emoticon-sad-outline::before {\r\n  content: \"\\F01F8\";\r\n}\r\n\r\n.mdi-emoticon-sick::before {\r\n  content: \"\\F157C\";\r\n}\r\n\r\n.mdi-emoticon-sick-outline::before {\r\n  content: \"\\F157D\";\r\n}\r\n\r\n.mdi-emoticon-tongue::before {\r\n  content: \"\\F01F9\";\r\n}\r\n\r\n.mdi-emoticon-tongue-outline::before {\r\n  content: \"\\F0C77\";\r\n}\r\n\r\n.mdi-emoticon-wink::before {\r\n  content: \"\\F0C78\";\r\n}\r\n\r\n.mdi-emoticon-wink-outline::before {\r\n  content: \"\\F0C79\";\r\n}\r\n\r\n.mdi-engine::before {\r\n  content: \"\\F01FA\";\r\n}\r\n\r\n.mdi-engine-off::before {\r\n  content: \"\\F0A46\";\r\n}\r\n\r\n.mdi-engine-off-outline::before {\r\n  content: \"\\F0A47\";\r\n}\r\n\r\n.mdi-engine-outline::before {\r\n  content: \"\\F01FB\";\r\n}\r\n\r\n.mdi-epsilon::before {\r\n  content: \"\\F10E0\";\r\n}\r\n\r\n.mdi-equal::before {\r\n  content: \"\\F01FC\";\r\n}\r\n\r\n.mdi-equal-box::before {\r\n  content: \"\\F01FD\";\r\n}\r\n\r\n.mdi-equalizer::before {\r\n  content: \"\\F0EA2\";\r\n}\r\n\r\n.mdi-equalizer-outline::before {\r\n  content: \"\\F0EA3\";\r\n}\r\n\r\n.mdi-eraser::before {\r\n  content: \"\\F01FE\";\r\n}\r\n\r\n.mdi-eraser-variant::before {\r\n  content: \"\\F0642\";\r\n}\r\n\r\n.mdi-escalator::before {\r\n  content: \"\\F01FF\";\r\n}\r\n\r\n.mdi-escalator-box::before {\r\n  content: \"\\F1399\";\r\n}\r\n\r\n.mdi-escalator-down::before {\r\n  content: \"\\F12C0\";\r\n}\r\n\r\n.mdi-escalator-up::before {\r\n  content: \"\\F12BF\";\r\n}\r\n\r\n.mdi-eslint::before {\r\n  content: \"\\F0C7A\";\r\n}\r\n\r\n.mdi-et::before {\r\n  content: \"\\F0AB3\";\r\n}\r\n\r\n.mdi-ethereum::before {\r\n  content: \"\\F086A\";\r\n}\r\n\r\n.mdi-ethernet::before {\r\n  content: \"\\F0200\";\r\n}\r\n\r\n.mdi-ethernet-cable::before {\r\n  content: \"\\F0201\";\r\n}\r\n\r\n.mdi-ethernet-cable-off::before {\r\n  content: \"\\F0202\";\r\n}\r\n\r\n.mdi-ev-plug-ccs1::before {\r\n  content: \"\\F1519\";\r\n}\r\n\r\n.mdi-ev-plug-ccs2::before {\r\n  content: \"\\F151A\";\r\n}\r\n\r\n.mdi-ev-plug-chademo::before {\r\n  content: \"\\F151B\";\r\n}\r\n\r\n.mdi-ev-plug-tesla::before {\r\n  content: \"\\F151C\";\r\n}\r\n\r\n.mdi-ev-plug-type1::before {\r\n  content: \"\\F151D\";\r\n}\r\n\r\n.mdi-ev-plug-type2::before {\r\n  content: \"\\F151E\";\r\n}\r\n\r\n.mdi-ev-station::before {\r\n  content: \"\\F05F1\";\r\n}\r\n\r\n.mdi-evernote::before {\r\n  content: \"\\F0204\";\r\n}\r\n\r\n.mdi-excavator::before {\r\n  content: \"\\F1025\";\r\n}\r\n\r\n.mdi-exclamation::before {\r\n  content: \"\\F0205\";\r\n}\r\n\r\n.mdi-exclamation-thick::before {\r\n  content: \"\\F1238\";\r\n}\r\n\r\n.mdi-exit-run::before {\r\n  content: \"\\F0A48\";\r\n}\r\n\r\n.mdi-exit-to-app::before {\r\n  content: \"\\F0206\";\r\n}\r\n\r\n.mdi-expand-all::before {\r\n  content: \"\\F0AB4\";\r\n}\r\n\r\n.mdi-expand-all-outline::before {\r\n  content: \"\\F0AB5\";\r\n}\r\n\r\n.mdi-expansion-card::before {\r\n  content: \"\\F08AE\";\r\n}\r\n\r\n.mdi-expansion-card-variant::before {\r\n  content: \"\\F0FB2\";\r\n}\r\n\r\n.mdi-exponent::before {\r\n  content: \"\\F0963\";\r\n}\r\n\r\n.mdi-exponent-box::before {\r\n  content: \"\\F0964\";\r\n}\r\n\r\n.mdi-export::before {\r\n  content: \"\\F0207\";\r\n}\r\n\r\n.mdi-export-variant::before {\r\n  content: \"\\F0B93\";\r\n}\r\n\r\n.mdi-eye::before {\r\n  content: \"\\F0208\";\r\n}\r\n\r\n.mdi-eye-arrow-left::before {\r\n  content: \"\\F18FD\";\r\n}\r\n\r\n.mdi-eye-arrow-left-outline::before {\r\n  content: \"\\F18FE\";\r\n}\r\n\r\n.mdi-eye-arrow-right::before {\r\n  content: \"\\F18FF\";\r\n}\r\n\r\n.mdi-eye-arrow-right-outline::before {\r\n  content: \"\\F1900\";\r\n}\r\n\r\n.mdi-eye-check::before {\r\n  content: \"\\F0D04\";\r\n}\r\n\r\n.mdi-eye-check-outline::before {\r\n  content: \"\\F0D05\";\r\n}\r\n\r\n.mdi-eye-circle::before {\r\n  content: \"\\F0B94\";\r\n}\r\n\r\n.mdi-eye-circle-outline::before {\r\n  content: \"\\F0B95\";\r\n}\r\n\r\n.mdi-eye-minus::before {\r\n  content: \"\\F1026\";\r\n}\r\n\r\n.mdi-eye-minus-outline::before {\r\n  content: \"\\F1027\";\r\n}\r\n\r\n.mdi-eye-off::before {\r\n  content: \"\\F0209\";\r\n}\r\n\r\n.mdi-eye-off-outline::before {\r\n  content: \"\\F06D1\";\r\n}\r\n\r\n.mdi-eye-outline::before {\r\n  content: \"\\F06D0\";\r\n}\r\n\r\n.mdi-eye-plus::before {\r\n  content: \"\\F086B\";\r\n}\r\n\r\n.mdi-eye-plus-outline::before {\r\n  content: \"\\F086C\";\r\n}\r\n\r\n.mdi-eye-refresh::before {\r\n  content: \"\\F197C\";\r\n}\r\n\r\n.mdi-eye-refresh-outline::before {\r\n  content: \"\\F197D\";\r\n}\r\n\r\n.mdi-eye-remove::before {\r\n  content: \"\\F15E3\";\r\n}\r\n\r\n.mdi-eye-remove-outline::before {\r\n  content: \"\\F15E4\";\r\n}\r\n\r\n.mdi-eye-settings::before {\r\n  content: \"\\F086D\";\r\n}\r\n\r\n.mdi-eye-settings-outline::before {\r\n  content: \"\\F086E\";\r\n}\r\n\r\n.mdi-eyedropper::before {\r\n  content: \"\\F020A\";\r\n}\r\n\r\n.mdi-eyedropper-minus::before {\r\n  content: \"\\F13DD\";\r\n}\r\n\r\n.mdi-eyedropper-off::before {\r\n  content: \"\\F13DF\";\r\n}\r\n\r\n.mdi-eyedropper-plus::before {\r\n  content: \"\\F13DC\";\r\n}\r\n\r\n.mdi-eyedropper-remove::before {\r\n  content: \"\\F13DE\";\r\n}\r\n\r\n.mdi-eyedropper-variant::before {\r\n  content: \"\\F020B\";\r\n}\r\n\r\n.mdi-face-agent::before {\r\n  content: \"\\F0D70\";\r\n}\r\n\r\n.mdi-face-man::before {\r\n  content: \"\\F0643\";\r\n}\r\n\r\n.mdi-face-man-outline::before {\r\n  content: \"\\F0B96\";\r\n}\r\n\r\n.mdi-face-man-profile::before {\r\n  content: \"\\F0644\";\r\n}\r\n\r\n.mdi-face-man-shimmer::before {\r\n  content: \"\\F15CC\";\r\n}\r\n\r\n.mdi-face-man-shimmer-outline::before {\r\n  content: \"\\F15CD\";\r\n}\r\n\r\n.mdi-face-mask::before {\r\n  content: \"\\F1586\";\r\n}\r\n\r\n.mdi-face-mask-outline::before {\r\n  content: \"\\F1587\";\r\n}\r\n\r\n.mdi-face-recognition::before {\r\n  content: \"\\F0C7B\";\r\n}\r\n\r\n.mdi-face-woman::before {\r\n  content: \"\\F1077\";\r\n}\r\n\r\n.mdi-face-woman-outline::before {\r\n  content: \"\\F1078\";\r\n}\r\n\r\n.mdi-face-woman-profile::before {\r\n  content: \"\\F1076\";\r\n}\r\n\r\n.mdi-face-woman-shimmer::before {\r\n  content: \"\\F15CE\";\r\n}\r\n\r\n.mdi-face-woman-shimmer-outline::before {\r\n  content: \"\\F15CF\";\r\n}\r\n\r\n.mdi-facebook::before {\r\n  content: \"\\F020C\";\r\n}\r\n\r\n.mdi-facebook-gaming::before {\r\n  content: \"\\F07DD\";\r\n}\r\n\r\n.mdi-facebook-messenger::before {\r\n  content: \"\\F020E\";\r\n}\r\n\r\n.mdi-facebook-workplace::before {\r\n  content: \"\\F0B31\";\r\n}\r\n\r\n.mdi-factory::before {\r\n  content: \"\\F020F\";\r\n}\r\n\r\n.mdi-family-tree::before {\r\n  content: \"\\F160E\";\r\n}\r\n\r\n.mdi-fan::before {\r\n  content: \"\\F0210\";\r\n}\r\n\r\n.mdi-fan-alert::before {\r\n  content: \"\\F146C\";\r\n}\r\n\r\n.mdi-fan-auto::before {\r\n  content: \"\\F171D\";\r\n}\r\n\r\n.mdi-fan-chevron-down::before {\r\n  content: \"\\F146D\";\r\n}\r\n\r\n.mdi-fan-chevron-up::before {\r\n  content: \"\\F146E\";\r\n}\r\n\r\n.mdi-fan-minus::before {\r\n  content: \"\\F1470\";\r\n}\r\n\r\n.mdi-fan-off::before {\r\n  content: \"\\F081D\";\r\n}\r\n\r\n.mdi-fan-plus::before {\r\n  content: \"\\F146F\";\r\n}\r\n\r\n.mdi-fan-remove::before {\r\n  content: \"\\F1471\";\r\n}\r\n\r\n.mdi-fan-speed-1::before {\r\n  content: \"\\F1472\";\r\n}\r\n\r\n.mdi-fan-speed-2::before {\r\n  content: \"\\F1473\";\r\n}\r\n\r\n.mdi-fan-speed-3::before {\r\n  content: \"\\F1474\";\r\n}\r\n\r\n.mdi-fast-forward::before {\r\n  content: \"\\F0211\";\r\n}\r\n\r\n.mdi-fast-forward-10::before {\r\n  content: \"\\F0D71\";\r\n}\r\n\r\n.mdi-fast-forward-15::before {\r\n  content: \"\\F193A\";\r\n}\r\n\r\n.mdi-fast-forward-30::before {\r\n  content: \"\\F0D06\";\r\n}\r\n\r\n.mdi-fast-forward-5::before {\r\n  content: \"\\F11F8\";\r\n}\r\n\r\n.mdi-fast-forward-60::before {\r\n  content: \"\\F160B\";\r\n}\r\n\r\n.mdi-fast-forward-outline::before {\r\n  content: \"\\F06D2\";\r\n}\r\n\r\n.mdi-fax::before {\r\n  content: \"\\F0212\";\r\n}\r\n\r\n.mdi-feather::before {\r\n  content: \"\\F06D3\";\r\n}\r\n\r\n.mdi-feature-search::before {\r\n  content: \"\\F0A49\";\r\n}\r\n\r\n.mdi-feature-search-outline::before {\r\n  content: \"\\F0A4A\";\r\n}\r\n\r\n.mdi-fedora::before {\r\n  content: \"\\F08DB\";\r\n}\r\n\r\n.mdi-fence::before {\r\n  content: \"\\F179A\";\r\n}\r\n\r\n.mdi-fence-electric::before {\r\n  content: \"\\F17F6\";\r\n}\r\n\r\n.mdi-fencing::before {\r\n  content: \"\\F14C1\";\r\n}\r\n\r\n.mdi-ferris-wheel::before {\r\n  content: \"\\F0EA4\";\r\n}\r\n\r\n.mdi-ferry::before {\r\n  content: \"\\F0213\";\r\n}\r\n\r\n.mdi-file::before {\r\n  content: \"\\F0214\";\r\n}\r\n\r\n.mdi-file-account::before {\r\n  content: \"\\F073B\";\r\n}\r\n\r\n.mdi-file-account-outline::before {\r\n  content: \"\\F1028\";\r\n}\r\n\r\n.mdi-file-alert::before {\r\n  content: \"\\F0A4B\";\r\n}\r\n\r\n.mdi-file-alert-outline::before {\r\n  content: \"\\F0A4C\";\r\n}\r\n\r\n.mdi-file-cabinet::before {\r\n  content: \"\\F0AB6\";\r\n}\r\n\r\n.mdi-file-cad::before {\r\n  content: \"\\F0EEB\";\r\n}\r\n\r\n.mdi-file-cad-box::before {\r\n  content: \"\\F0EEC\";\r\n}\r\n\r\n.mdi-file-cancel::before {\r\n  content: \"\\F0DC6\";\r\n}\r\n\r\n.mdi-file-cancel-outline::before {\r\n  content: \"\\F0DC7\";\r\n}\r\n\r\n.mdi-file-certificate::before {\r\n  content: \"\\F1186\";\r\n}\r\n\r\n.mdi-file-certificate-outline::before {\r\n  content: \"\\F1187\";\r\n}\r\n\r\n.mdi-file-chart::before {\r\n  content: \"\\F0215\";\r\n}\r\n\r\n.mdi-file-chart-outline::before {\r\n  content: \"\\F1029\";\r\n}\r\n\r\n.mdi-file-check::before {\r\n  content: \"\\F0216\";\r\n}\r\n\r\n.mdi-file-check-outline::before {\r\n  content: \"\\F0E29\";\r\n}\r\n\r\n.mdi-file-clock::before {\r\n  content: \"\\F12E1\";\r\n}\r\n\r\n.mdi-file-clock-outline::before {\r\n  content: \"\\F12E2\";\r\n}\r\n\r\n.mdi-file-cloud::before {\r\n  content: \"\\F0217\";\r\n}\r\n\r\n.mdi-file-cloud-outline::before {\r\n  content: \"\\F102A\";\r\n}\r\n\r\n.mdi-file-code::before {\r\n  content: \"\\F022E\";\r\n}\r\n\r\n.mdi-file-code-outline::before {\r\n  content: \"\\F102B\";\r\n}\r\n\r\n.mdi-file-cog::before {\r\n  content: \"\\F107B\";\r\n}\r\n\r\n.mdi-file-cog-outline::before {\r\n  content: \"\\F107C\";\r\n}\r\n\r\n.mdi-file-compare::before {\r\n  content: \"\\F08AA\";\r\n}\r\n\r\n.mdi-file-delimited::before {\r\n  content: \"\\F0218\";\r\n}\r\n\r\n.mdi-file-delimited-outline::before {\r\n  content: \"\\F0EA5\";\r\n}\r\n\r\n.mdi-file-document::before {\r\n  content: \"\\F0219\";\r\n}\r\n\r\n.mdi-file-document-edit::before {\r\n  content: \"\\F0DC8\";\r\n}\r\n\r\n.mdi-file-document-edit-outline::before {\r\n  content: \"\\F0DC9\";\r\n}\r\n\r\n.mdi-file-document-multiple::before {\r\n  content: \"\\F1517\";\r\n}\r\n\r\n.mdi-file-document-multiple-outline::before {\r\n  content: \"\\F1518\";\r\n}\r\n\r\n.mdi-file-document-outline::before {\r\n  content: \"\\F09EE\";\r\n}\r\n\r\n.mdi-file-download::before {\r\n  content: \"\\F0965\";\r\n}\r\n\r\n.mdi-file-download-outline::before {\r\n  content: \"\\F0966\";\r\n}\r\n\r\n.mdi-file-edit::before {\r\n  content: \"\\F11E7\";\r\n}\r\n\r\n.mdi-file-edit-outline::before {\r\n  content: \"\\F11E8\";\r\n}\r\n\r\n.mdi-file-excel::before {\r\n  content: \"\\F021B\";\r\n}\r\n\r\n.mdi-file-excel-box::before {\r\n  content: \"\\F021C\";\r\n}\r\n\r\n.mdi-file-excel-box-outline::before {\r\n  content: \"\\F102C\";\r\n}\r\n\r\n.mdi-file-excel-outline::before {\r\n  content: \"\\F102D\";\r\n}\r\n\r\n.mdi-file-export::before {\r\n  content: \"\\F021D\";\r\n}\r\n\r\n.mdi-file-export-outline::before {\r\n  content: \"\\F102E\";\r\n}\r\n\r\n.mdi-file-eye::before {\r\n  content: \"\\F0DCA\";\r\n}\r\n\r\n.mdi-file-eye-outline::before {\r\n  content: \"\\F0DCB\";\r\n}\r\n\r\n.mdi-file-find::before {\r\n  content: \"\\F021E\";\r\n}\r\n\r\n.mdi-file-find-outline::before {\r\n  content: \"\\F0B97\";\r\n}\r\n\r\n.mdi-file-gif-box::before {\r\n  content: \"\\F0D78\";\r\n}\r\n\r\n.mdi-file-hidden::before {\r\n  content: \"\\F0613\";\r\n}\r\n\r\n.mdi-file-image::before {\r\n  content: \"\\F021F\";\r\n}\r\n\r\n.mdi-file-image-marker::before {\r\n  content: \"\\F1772\";\r\n}\r\n\r\n.mdi-file-image-marker-outline::before {\r\n  content: \"\\F1773\";\r\n}\r\n\r\n.mdi-file-image-minus::before {\r\n  content: \"\\F193B\";\r\n}\r\n\r\n.mdi-file-image-minus-outline::before {\r\n  content: \"\\F193C\";\r\n}\r\n\r\n.mdi-file-image-outline::before {\r\n  content: \"\\F0EB0\";\r\n}\r\n\r\n.mdi-file-image-plus::before {\r\n  content: \"\\F193D\";\r\n}\r\n\r\n.mdi-file-image-plus-outline::before {\r\n  content: \"\\F193E\";\r\n}\r\n\r\n.mdi-file-image-remove::before {\r\n  content: \"\\F193F\";\r\n}\r\n\r\n.mdi-file-image-remove-outline::before {\r\n  content: \"\\F1940\";\r\n}\r\n\r\n.mdi-file-import::before {\r\n  content: \"\\F0220\";\r\n}\r\n\r\n.mdi-file-import-outline::before {\r\n  content: \"\\F102F\";\r\n}\r\n\r\n.mdi-file-jpg-box::before {\r\n  content: \"\\F0225\";\r\n}\r\n\r\n.mdi-file-key::before {\r\n  content: \"\\F1184\";\r\n}\r\n\r\n.mdi-file-key-outline::before {\r\n  content: \"\\F1185\";\r\n}\r\n\r\n.mdi-file-link::before {\r\n  content: \"\\F1177\";\r\n}\r\n\r\n.mdi-file-link-outline::before {\r\n  content: \"\\F1178\";\r\n}\r\n\r\n.mdi-file-lock::before {\r\n  content: \"\\F0221\";\r\n}\r\n\r\n.mdi-file-lock-outline::before {\r\n  content: \"\\F1030\";\r\n}\r\n\r\n.mdi-file-marker::before {\r\n  content: \"\\F1774\";\r\n}\r\n\r\n.mdi-file-marker-outline::before {\r\n  content: \"\\F1775\";\r\n}\r\n\r\n.mdi-file-move::before {\r\n  content: \"\\F0AB9\";\r\n}\r\n\r\n.mdi-file-move-outline::before {\r\n  content: \"\\F1031\";\r\n}\r\n\r\n.mdi-file-multiple::before {\r\n  content: \"\\F0222\";\r\n}\r\n\r\n.mdi-file-multiple-outline::before {\r\n  content: \"\\F1032\";\r\n}\r\n\r\n.mdi-file-music::before {\r\n  content: \"\\F0223\";\r\n}\r\n\r\n.mdi-file-music-outline::before {\r\n  content: \"\\F0E2A\";\r\n}\r\n\r\n.mdi-file-outline::before {\r\n  content: \"\\F0224\";\r\n}\r\n\r\n.mdi-file-pdf-box::before {\r\n  content: \"\\F0226\";\r\n}\r\n\r\n.mdi-file-percent::before {\r\n  content: \"\\F081E\";\r\n}\r\n\r\n.mdi-file-percent-outline::before {\r\n  content: \"\\F1033\";\r\n}\r\n\r\n.mdi-file-phone::before {\r\n  content: \"\\F1179\";\r\n}\r\n\r\n.mdi-file-phone-outline::before {\r\n  content: \"\\F117A\";\r\n}\r\n\r\n.mdi-file-plus::before {\r\n  content: \"\\F0752\";\r\n}\r\n\r\n.mdi-file-plus-outline::before {\r\n  content: \"\\F0EED\";\r\n}\r\n\r\n.mdi-file-png-box::before {\r\n  content: \"\\F0E2D\";\r\n}\r\n\r\n.mdi-file-powerpoint::before {\r\n  content: \"\\F0227\";\r\n}\r\n\r\n.mdi-file-powerpoint-box::before {\r\n  content: \"\\F0228\";\r\n}\r\n\r\n.mdi-file-powerpoint-box-outline::before {\r\n  content: \"\\F1034\";\r\n}\r\n\r\n.mdi-file-powerpoint-outline::before {\r\n  content: \"\\F1035\";\r\n}\r\n\r\n.mdi-file-presentation-box::before {\r\n  content: \"\\F0229\";\r\n}\r\n\r\n.mdi-file-question::before {\r\n  content: \"\\F086F\";\r\n}\r\n\r\n.mdi-file-question-outline::before {\r\n  content: \"\\F1036\";\r\n}\r\n\r\n.mdi-file-refresh::before {\r\n  content: \"\\F0918\";\r\n}\r\n\r\n.mdi-file-refresh-outline::before {\r\n  content: \"\\F0541\";\r\n}\r\n\r\n.mdi-file-remove::before {\r\n  content: \"\\F0B98\";\r\n}\r\n\r\n.mdi-file-remove-outline::before {\r\n  content: \"\\F1037\";\r\n}\r\n\r\n.mdi-file-replace::before {\r\n  content: \"\\F0B32\";\r\n}\r\n\r\n.mdi-file-replace-outline::before {\r\n  content: \"\\F0B33\";\r\n}\r\n\r\n.mdi-file-restore::before {\r\n  content: \"\\F0670\";\r\n}\r\n\r\n.mdi-file-restore-outline::before {\r\n  content: \"\\F1038\";\r\n}\r\n\r\n.mdi-file-search::before {\r\n  content: \"\\F0C7C\";\r\n}\r\n\r\n.mdi-file-search-outline::before {\r\n  content: \"\\F0C7D\";\r\n}\r\n\r\n.mdi-file-send::before {\r\n  content: \"\\F022A\";\r\n}\r\n\r\n.mdi-file-send-outline::before {\r\n  content: \"\\F1039\";\r\n}\r\n\r\n.mdi-file-settings::before {\r\n  content: \"\\F1079\";\r\n}\r\n\r\n.mdi-file-settings-outline::before {\r\n  content: \"\\F107A\";\r\n}\r\n\r\n.mdi-file-sign::before {\r\n  content: \"\\F19C3\";\r\n}\r\n\r\n.mdi-file-star::before {\r\n  content: \"\\F103A\";\r\n}\r\n\r\n.mdi-file-star-outline::before {\r\n  content: \"\\F103B\";\r\n}\r\n\r\n.mdi-file-swap::before {\r\n  content: \"\\F0FB4\";\r\n}\r\n\r\n.mdi-file-swap-outline::before {\r\n  content: \"\\F0FB5\";\r\n}\r\n\r\n.mdi-file-sync::before {\r\n  content: \"\\F1216\";\r\n}\r\n\r\n.mdi-file-sync-outline::before {\r\n  content: \"\\F1217\";\r\n}\r\n\r\n.mdi-file-table::before {\r\n  content: \"\\F0C7E\";\r\n}\r\n\r\n.mdi-file-table-box::before {\r\n  content: \"\\F10E1\";\r\n}\r\n\r\n.mdi-file-table-box-multiple::before {\r\n  content: \"\\F10E2\";\r\n}\r\n\r\n.mdi-file-table-box-multiple-outline::before {\r\n  content: \"\\F10E3\";\r\n}\r\n\r\n.mdi-file-table-box-outline::before {\r\n  content: \"\\F10E4\";\r\n}\r\n\r\n.mdi-file-table-outline::before {\r\n  content: \"\\F0C7F\";\r\n}\r\n\r\n.mdi-file-tree::before {\r\n  content: \"\\F0645\";\r\n}\r\n\r\n.mdi-file-tree-outline::before {\r\n  content: \"\\F13D2\";\r\n}\r\n\r\n.mdi-file-undo::before {\r\n  content: \"\\F08DC\";\r\n}\r\n\r\n.mdi-file-undo-outline::before {\r\n  content: \"\\F103C\";\r\n}\r\n\r\n.mdi-file-upload::before {\r\n  content: \"\\F0A4D\";\r\n}\r\n\r\n.mdi-file-upload-outline::before {\r\n  content: \"\\F0A4E\";\r\n}\r\n\r\n.mdi-file-video::before {\r\n  content: \"\\F022B\";\r\n}\r\n\r\n.mdi-file-video-outline::before {\r\n  content: \"\\F0E2C\";\r\n}\r\n\r\n.mdi-file-word::before {\r\n  content: \"\\F022C\";\r\n}\r\n\r\n.mdi-file-word-box::before {\r\n  content: \"\\F022D\";\r\n}\r\n\r\n.mdi-file-word-box-outline::before {\r\n  content: \"\\F103D\";\r\n}\r\n\r\n.mdi-file-word-outline::before {\r\n  content: \"\\F103E\";\r\n}\r\n\r\n.mdi-film::before {\r\n  content: \"\\F022F\";\r\n}\r\n\r\n.mdi-filmstrip::before {\r\n  content: \"\\F0230\";\r\n}\r\n\r\n.mdi-filmstrip-box::before {\r\n  content: \"\\F0332\";\r\n}\r\n\r\n.mdi-filmstrip-box-multiple::before {\r\n  content: \"\\F0D18\";\r\n}\r\n\r\n.mdi-filmstrip-off::before {\r\n  content: \"\\F0231\";\r\n}\r\n\r\n.mdi-filter::before {\r\n  content: \"\\F0232\";\r\n}\r\n\r\n.mdi-filter-check::before {\r\n  content: \"\\F18EC\";\r\n}\r\n\r\n.mdi-filter-check-outline::before {\r\n  content: \"\\F18ED\";\r\n}\r\n\r\n.mdi-filter-menu::before {\r\n  content: \"\\F10E5\";\r\n}\r\n\r\n.mdi-filter-menu-outline::before {\r\n  content: \"\\F10E6\";\r\n}\r\n\r\n.mdi-filter-minus::before {\r\n  content: \"\\F0EEE\";\r\n}\r\n\r\n.mdi-filter-minus-outline::before {\r\n  content: \"\\F0EEF\";\r\n}\r\n\r\n.mdi-filter-off::before {\r\n  content: \"\\F14EF\";\r\n}\r\n\r\n.mdi-filter-off-outline::before {\r\n  content: \"\\F14F0\";\r\n}\r\n\r\n.mdi-filter-outline::before {\r\n  content: \"\\F0233\";\r\n}\r\n\r\n.mdi-filter-plus::before {\r\n  content: \"\\F0EF0\";\r\n}\r\n\r\n.mdi-filter-plus-outline::before {\r\n  content: \"\\F0EF1\";\r\n}\r\n\r\n.mdi-filter-remove::before {\r\n  content: \"\\F0234\";\r\n}\r\n\r\n.mdi-filter-remove-outline::before {\r\n  content: \"\\F0235\";\r\n}\r\n\r\n.mdi-filter-variant::before {\r\n  content: \"\\F0236\";\r\n}\r\n\r\n.mdi-filter-variant-minus::before {\r\n  content: \"\\F1112\";\r\n}\r\n\r\n.mdi-filter-variant-plus::before {\r\n  content: \"\\F1113\";\r\n}\r\n\r\n.mdi-filter-variant-remove::before {\r\n  content: \"\\F103F\";\r\n}\r\n\r\n.mdi-finance::before {\r\n  content: \"\\F081F\";\r\n}\r\n\r\n.mdi-find-replace::before {\r\n  content: \"\\F06D4\";\r\n}\r\n\r\n.mdi-fingerprint::before {\r\n  content: \"\\F0237\";\r\n}\r\n\r\n.mdi-fingerprint-off::before {\r\n  content: \"\\F0EB1\";\r\n}\r\n\r\n.mdi-fire::before {\r\n  content: \"\\F0238\";\r\n}\r\n\r\n.mdi-fire-alert::before {\r\n  content: \"\\F15D7\";\r\n}\r\n\r\n.mdi-fire-circle::before {\r\n  content: \"\\F1807\";\r\n}\r\n\r\n.mdi-fire-extinguisher::before {\r\n  content: \"\\F0EF2\";\r\n}\r\n\r\n.mdi-fire-hydrant::before {\r\n  content: \"\\F1137\";\r\n}\r\n\r\n.mdi-fire-hydrant-alert::before {\r\n  content: \"\\F1138\";\r\n}\r\n\r\n.mdi-fire-hydrant-off::before {\r\n  content: \"\\F1139\";\r\n}\r\n\r\n.mdi-fire-off::before {\r\n  content: \"\\F1722\";\r\n}\r\n\r\n.mdi-fire-truck::before {\r\n  content: \"\\F08AB\";\r\n}\r\n\r\n.mdi-firebase::before {\r\n  content: \"\\F0967\";\r\n}\r\n\r\n.mdi-firefox::before {\r\n  content: \"\\F0239\";\r\n}\r\n\r\n.mdi-fireplace::before {\r\n  content: \"\\F0E2E\";\r\n}\r\n\r\n.mdi-fireplace-off::before {\r\n  content: \"\\F0E2F\";\r\n}\r\n\r\n.mdi-firewire::before {\r\n  content: \"\\F05BE\";\r\n}\r\n\r\n.mdi-firework::before {\r\n  content: \"\\F0E30\";\r\n}\r\n\r\n.mdi-firework-off::before {\r\n  content: \"\\F1723\";\r\n}\r\n\r\n.mdi-fish::before {\r\n  content: \"\\F023A\";\r\n}\r\n\r\n.mdi-fish-off::before {\r\n  content: \"\\F13F3\";\r\n}\r\n\r\n.mdi-fishbowl::before {\r\n  content: \"\\F0EF3\";\r\n}\r\n\r\n.mdi-fishbowl-outline::before {\r\n  content: \"\\F0EF4\";\r\n}\r\n\r\n.mdi-fit-to-page::before {\r\n  content: \"\\F0EF5\";\r\n}\r\n\r\n.mdi-fit-to-page-outline::before {\r\n  content: \"\\F0EF6\";\r\n}\r\n\r\n.mdi-fit-to-screen::before {\r\n  content: \"\\F18F4\";\r\n}\r\n\r\n.mdi-fit-to-screen-outline::before {\r\n  content: \"\\F18F5\";\r\n}\r\n\r\n.mdi-flag::before {\r\n  content: \"\\F023B\";\r\n}\r\n\r\n.mdi-flag-checkered::before {\r\n  content: \"\\F023C\";\r\n}\r\n\r\n.mdi-flag-minus::before {\r\n  content: \"\\F0B99\";\r\n}\r\n\r\n.mdi-flag-minus-outline::before {\r\n  content: \"\\F10B2\";\r\n}\r\n\r\n.mdi-flag-off::before {\r\n  content: \"\\F18EE\";\r\n}\r\n\r\n.mdi-flag-off-outline::before {\r\n  content: \"\\F18EF\";\r\n}\r\n\r\n.mdi-flag-outline::before {\r\n  content: \"\\F023D\";\r\n}\r\n\r\n.mdi-flag-plus::before {\r\n  content: \"\\F0B9A\";\r\n}\r\n\r\n.mdi-flag-plus-outline::before {\r\n  content: \"\\F10B3\";\r\n}\r\n\r\n.mdi-flag-remove::before {\r\n  content: \"\\F0B9B\";\r\n}\r\n\r\n.mdi-flag-remove-outline::before {\r\n  content: \"\\F10B4\";\r\n}\r\n\r\n.mdi-flag-triangle::before {\r\n  content: \"\\F023F\";\r\n}\r\n\r\n.mdi-flag-variant::before {\r\n  content: \"\\F0240\";\r\n}\r\n\r\n.mdi-flag-variant-outline::before {\r\n  content: \"\\F023E\";\r\n}\r\n\r\n.mdi-flare::before {\r\n  content: \"\\F0D72\";\r\n}\r\n\r\n.mdi-flash::before {\r\n  content: \"\\F0241\";\r\n}\r\n\r\n.mdi-flash-alert::before {\r\n  content: \"\\F0EF7\";\r\n}\r\n\r\n.mdi-flash-alert-outline::before {\r\n  content: \"\\F0EF8\";\r\n}\r\n\r\n.mdi-flash-auto::before {\r\n  content: \"\\F0242\";\r\n}\r\n\r\n.mdi-flash-off::before {\r\n  content: \"\\F0243\";\r\n}\r\n\r\n.mdi-flash-outline::before {\r\n  content: \"\\F06D5\";\r\n}\r\n\r\n.mdi-flash-red-eye::before {\r\n  content: \"\\F067B\";\r\n}\r\n\r\n.mdi-flashlight::before {\r\n  content: \"\\F0244\";\r\n}\r\n\r\n.mdi-flashlight-off::before {\r\n  content: \"\\F0245\";\r\n}\r\n\r\n.mdi-flask::before {\r\n  content: \"\\F0093\";\r\n}\r\n\r\n.mdi-flask-empty::before {\r\n  content: \"\\F0094\";\r\n}\r\n\r\n.mdi-flask-empty-minus::before {\r\n  content: \"\\F123A\";\r\n}\r\n\r\n.mdi-flask-empty-minus-outline::before {\r\n  content: \"\\F123B\";\r\n}\r\n\r\n.mdi-flask-empty-off::before {\r\n  content: \"\\F13F4\";\r\n}\r\n\r\n.mdi-flask-empty-off-outline::before {\r\n  content: \"\\F13F5\";\r\n}\r\n\r\n.mdi-flask-empty-outline::before {\r\n  content: \"\\F0095\";\r\n}\r\n\r\n.mdi-flask-empty-plus::before {\r\n  content: \"\\F123C\";\r\n}\r\n\r\n.mdi-flask-empty-plus-outline::before {\r\n  content: \"\\F123D\";\r\n}\r\n\r\n.mdi-flask-empty-remove::before {\r\n  content: \"\\F123E\";\r\n}\r\n\r\n.mdi-flask-empty-remove-outline::before {\r\n  content: \"\\F123F\";\r\n}\r\n\r\n.mdi-flask-minus::before {\r\n  content: \"\\F1240\";\r\n}\r\n\r\n.mdi-flask-minus-outline::before {\r\n  content: \"\\F1241\";\r\n}\r\n\r\n.mdi-flask-off::before {\r\n  content: \"\\F13F6\";\r\n}\r\n\r\n.mdi-flask-off-outline::before {\r\n  content: \"\\F13F7\";\r\n}\r\n\r\n.mdi-flask-outline::before {\r\n  content: \"\\F0096\";\r\n}\r\n\r\n.mdi-flask-plus::before {\r\n  content: \"\\F1242\";\r\n}\r\n\r\n.mdi-flask-plus-outline::before {\r\n  content: \"\\F1243\";\r\n}\r\n\r\n.mdi-flask-remove::before {\r\n  content: \"\\F1244\";\r\n}\r\n\r\n.mdi-flask-remove-outline::before {\r\n  content: \"\\F1245\";\r\n}\r\n\r\n.mdi-flask-round-bottom::before {\r\n  content: \"\\F124B\";\r\n}\r\n\r\n.mdi-flask-round-bottom-empty::before {\r\n  content: \"\\F124C\";\r\n}\r\n\r\n.mdi-flask-round-bottom-empty-outline::before {\r\n  content: \"\\F124D\";\r\n}\r\n\r\n.mdi-flask-round-bottom-outline::before {\r\n  content: \"\\F124E\";\r\n}\r\n\r\n.mdi-fleur-de-lis::before {\r\n  content: \"\\F1303\";\r\n}\r\n\r\n.mdi-flip-horizontal::before {\r\n  content: \"\\F10E7\";\r\n}\r\n\r\n.mdi-flip-to-back::before {\r\n  content: \"\\F0247\";\r\n}\r\n\r\n.mdi-flip-to-front::before {\r\n  content: \"\\F0248\";\r\n}\r\n\r\n.mdi-flip-vertical::before {\r\n  content: \"\\F10E8\";\r\n}\r\n\r\n.mdi-floor-lamp::before {\r\n  content: \"\\F08DD\";\r\n}\r\n\r\n.mdi-floor-lamp-dual::before {\r\n  content: \"\\F1040\";\r\n}\r\n\r\n.mdi-floor-lamp-dual-outline::before {\r\n  content: \"\\F17CE\";\r\n}\r\n\r\n.mdi-floor-lamp-outline::before {\r\n  content: \"\\F17C8\";\r\n}\r\n\r\n.mdi-floor-lamp-torchiere::before {\r\n  content: \"\\F1747\";\r\n}\r\n\r\n.mdi-floor-lamp-torchiere-outline::before {\r\n  content: \"\\F17D6\";\r\n}\r\n\r\n.mdi-floor-lamp-torchiere-variant::before {\r\n  content: \"\\F1041\";\r\n}\r\n\r\n.mdi-floor-lamp-torchiere-variant-outline::before {\r\n  content: \"\\F17CF\";\r\n}\r\n\r\n.mdi-floor-plan::before {\r\n  content: \"\\F0821\";\r\n}\r\n\r\n.mdi-floppy::before {\r\n  content: \"\\F0249\";\r\n}\r\n\r\n.mdi-floppy-variant::before {\r\n  content: \"\\F09EF\";\r\n}\r\n\r\n.mdi-flower::before {\r\n  content: \"\\F024A\";\r\n}\r\n\r\n.mdi-flower-outline::before {\r\n  content: \"\\F09F0\";\r\n}\r\n\r\n.mdi-flower-pollen::before {\r\n  content: \"\\F1885\";\r\n}\r\n\r\n.mdi-flower-pollen-outline::before {\r\n  content: \"\\F1886\";\r\n}\r\n\r\n.mdi-flower-poppy::before {\r\n  content: \"\\F0D08\";\r\n}\r\n\r\n.mdi-flower-tulip::before {\r\n  content: \"\\F09F1\";\r\n}\r\n\r\n.mdi-flower-tulip-outline::before {\r\n  content: \"\\F09F2\";\r\n}\r\n\r\n.mdi-focus-auto::before {\r\n  content: \"\\F0F4E\";\r\n}\r\n\r\n.mdi-focus-field::before {\r\n  content: \"\\F0F4F\";\r\n}\r\n\r\n.mdi-focus-field-horizontal::before {\r\n  content: \"\\F0F50\";\r\n}\r\n\r\n.mdi-focus-field-vertical::before {\r\n  content: \"\\F0F51\";\r\n}\r\n\r\n.mdi-folder::before {\r\n  content: \"\\F024B\";\r\n}\r\n\r\n.mdi-folder-account::before {\r\n  content: \"\\F024C\";\r\n}\r\n\r\n.mdi-folder-account-outline::before {\r\n  content: \"\\F0B9C\";\r\n}\r\n\r\n.mdi-folder-alert::before {\r\n  content: \"\\F0DCC\";\r\n}\r\n\r\n.mdi-folder-alert-outline::before {\r\n  content: \"\\F0DCD\";\r\n}\r\n\r\n.mdi-folder-check::before {\r\n  content: \"\\F197E\";\r\n}\r\n\r\n.mdi-folder-check-outline::before {\r\n  content: \"\\F197F\";\r\n}\r\n\r\n.mdi-folder-clock::before {\r\n  content: \"\\F0ABA\";\r\n}\r\n\r\n.mdi-folder-clock-outline::before {\r\n  content: \"\\F0ABB\";\r\n}\r\n\r\n.mdi-folder-cog::before {\r\n  content: \"\\F107F\";\r\n}\r\n\r\n.mdi-folder-cog-outline::before {\r\n  content: \"\\F1080\";\r\n}\r\n\r\n.mdi-folder-download::before {\r\n  content: \"\\F024D\";\r\n}\r\n\r\n.mdi-folder-download-outline::before {\r\n  content: \"\\F10E9\";\r\n}\r\n\r\n.mdi-folder-edit::before {\r\n  content: \"\\F08DE\";\r\n}\r\n\r\n.mdi-folder-edit-outline::before {\r\n  content: \"\\F0DCE\";\r\n}\r\n\r\n.mdi-folder-eye::before {\r\n  content: \"\\F178A\";\r\n}\r\n\r\n.mdi-folder-eye-outline::before {\r\n  content: \"\\F178B\";\r\n}\r\n\r\n.mdi-folder-google-drive::before {\r\n  content: \"\\F024E\";\r\n}\r\n\r\n.mdi-folder-heart::before {\r\n  content: \"\\F10EA\";\r\n}\r\n\r\n.mdi-folder-heart-outline::before {\r\n  content: \"\\F10EB\";\r\n}\r\n\r\n.mdi-folder-hidden::before {\r\n  content: \"\\F179E\";\r\n}\r\n\r\n.mdi-folder-home::before {\r\n  content: \"\\F10B5\";\r\n}\r\n\r\n.mdi-folder-home-outline::before {\r\n  content: \"\\F10B6\";\r\n}\r\n\r\n.mdi-folder-image::before {\r\n  content: \"\\F024F\";\r\n}\r\n\r\n.mdi-folder-information::before {\r\n  content: \"\\F10B7\";\r\n}\r\n\r\n.mdi-folder-information-outline::before {\r\n  content: \"\\F10B8\";\r\n}\r\n\r\n.mdi-folder-key::before {\r\n  content: \"\\F08AC\";\r\n}\r\n\r\n.mdi-folder-key-network::before {\r\n  content: \"\\F08AD\";\r\n}\r\n\r\n.mdi-folder-key-network-outline::before {\r\n  content: \"\\F0C80\";\r\n}\r\n\r\n.mdi-folder-key-outline::before {\r\n  content: \"\\F10EC\";\r\n}\r\n\r\n.mdi-folder-lock::before {\r\n  content: \"\\F0250\";\r\n}\r\n\r\n.mdi-folder-lock-open::before {\r\n  content: \"\\F0251\";\r\n}\r\n\r\n.mdi-folder-marker::before {\r\n  content: \"\\F126D\";\r\n}\r\n\r\n.mdi-folder-marker-outline::before {\r\n  content: \"\\F126E\";\r\n}\r\n\r\n.mdi-folder-move::before {\r\n  content: \"\\F0252\";\r\n}\r\n\r\n.mdi-folder-move-outline::before {\r\n  content: \"\\F1246\";\r\n}\r\n\r\n.mdi-folder-multiple::before {\r\n  content: \"\\F0253\";\r\n}\r\n\r\n.mdi-folder-multiple-image::before {\r\n  content: \"\\F0254\";\r\n}\r\n\r\n.mdi-folder-multiple-outline::before {\r\n  content: \"\\F0255\";\r\n}\r\n\r\n.mdi-folder-multiple-plus::before {\r\n  content: \"\\F147E\";\r\n}\r\n\r\n.mdi-folder-multiple-plus-outline::before {\r\n  content: \"\\F147F\";\r\n}\r\n\r\n.mdi-folder-music::before {\r\n  content: \"\\F1359\";\r\n}\r\n\r\n.mdi-folder-music-outline::before {\r\n  content: \"\\F135A\";\r\n}\r\n\r\n.mdi-folder-network::before {\r\n  content: \"\\F0870\";\r\n}\r\n\r\n.mdi-folder-network-outline::before {\r\n  content: \"\\F0C81\";\r\n}\r\n\r\n.mdi-folder-open::before {\r\n  content: \"\\F0770\";\r\n}\r\n\r\n.mdi-folder-open-outline::before {\r\n  content: \"\\F0DCF\";\r\n}\r\n\r\n.mdi-folder-outline::before {\r\n  content: \"\\F0256\";\r\n}\r\n\r\n.mdi-folder-plus::before {\r\n  content: \"\\F0257\";\r\n}\r\n\r\n.mdi-folder-plus-outline::before {\r\n  content: \"\\F0B9D\";\r\n}\r\n\r\n.mdi-folder-pound::before {\r\n  content: \"\\F0D09\";\r\n}\r\n\r\n.mdi-folder-pound-outline::before {\r\n  content: \"\\F0D0A\";\r\n}\r\n\r\n.mdi-folder-refresh::before {\r\n  content: \"\\F0749\";\r\n}\r\n\r\n.mdi-folder-refresh-outline::before {\r\n  content: \"\\F0542\";\r\n}\r\n\r\n.mdi-folder-remove::before {\r\n  content: \"\\F0258\";\r\n}\r\n\r\n.mdi-folder-remove-outline::before {\r\n  content: \"\\F0B9E\";\r\n}\r\n\r\n.mdi-folder-search::before {\r\n  content: \"\\F0968\";\r\n}\r\n\r\n.mdi-folder-search-outline::before {\r\n  content: \"\\F0969\";\r\n}\r\n\r\n.mdi-folder-settings::before {\r\n  content: \"\\F107D\";\r\n}\r\n\r\n.mdi-folder-settings-outline::before {\r\n  content: \"\\F107E\";\r\n}\r\n\r\n.mdi-folder-star::before {\r\n  content: \"\\F069D\";\r\n}\r\n\r\n.mdi-folder-star-multiple::before {\r\n  content: \"\\F13D3\";\r\n}\r\n\r\n.mdi-folder-star-multiple-outline::before {\r\n  content: \"\\F13D4\";\r\n}\r\n\r\n.mdi-folder-star-outline::before {\r\n  content: \"\\F0B9F\";\r\n}\r\n\r\n.mdi-folder-swap::before {\r\n  content: \"\\F0FB6\";\r\n}\r\n\r\n.mdi-folder-swap-outline::before {\r\n  content: \"\\F0FB7\";\r\n}\r\n\r\n.mdi-folder-sync::before {\r\n  content: \"\\F0D0B\";\r\n}\r\n\r\n.mdi-folder-sync-outline::before {\r\n  content: \"\\F0D0C\";\r\n}\r\n\r\n.mdi-folder-table::before {\r\n  content: \"\\F12E3\";\r\n}\r\n\r\n.mdi-folder-table-outline::before {\r\n  content: \"\\F12E4\";\r\n}\r\n\r\n.mdi-folder-text::before {\r\n  content: \"\\F0C82\";\r\n}\r\n\r\n.mdi-folder-text-outline::before {\r\n  content: \"\\F0C83\";\r\n}\r\n\r\n.mdi-folder-upload::before {\r\n  content: \"\\F0259\";\r\n}\r\n\r\n.mdi-folder-upload-outline::before {\r\n  content: \"\\F10ED\";\r\n}\r\n\r\n.mdi-folder-zip::before {\r\n  content: \"\\F06EB\";\r\n}\r\n\r\n.mdi-folder-zip-outline::before {\r\n  content: \"\\F07B9\";\r\n}\r\n\r\n.mdi-font-awesome::before {\r\n  content: \"\\F003A\";\r\n}\r\n\r\n.mdi-food::before {\r\n  content: \"\\F025A\";\r\n}\r\n\r\n.mdi-food-apple::before {\r\n  content: \"\\F025B\";\r\n}\r\n\r\n.mdi-food-apple-outline::before {\r\n  content: \"\\F0C84\";\r\n}\r\n\r\n.mdi-food-croissant::before {\r\n  content: \"\\F07C8\";\r\n}\r\n\r\n.mdi-food-drumstick::before {\r\n  content: \"\\F141F\";\r\n}\r\n\r\n.mdi-food-drumstick-off::before {\r\n  content: \"\\F1468\";\r\n}\r\n\r\n.mdi-food-drumstick-off-outline::before {\r\n  content: \"\\F1469\";\r\n}\r\n\r\n.mdi-food-drumstick-outline::before {\r\n  content: \"\\F1420\";\r\n}\r\n\r\n.mdi-food-fork-drink::before {\r\n  content: \"\\F05F2\";\r\n}\r\n\r\n.mdi-food-halal::before {\r\n  content: \"\\F1572\";\r\n}\r\n\r\n.mdi-food-hot-dog::before {\r\n  content: \"\\F184B\";\r\n}\r\n\r\n.mdi-food-kosher::before {\r\n  content: \"\\F1573\";\r\n}\r\n\r\n.mdi-food-off::before {\r\n  content: \"\\F05F3\";\r\n}\r\n\r\n.mdi-food-off-outline::before {\r\n  content: \"\\F1915\";\r\n}\r\n\r\n.mdi-food-outline::before {\r\n  content: \"\\F1916\";\r\n}\r\n\r\n.mdi-food-steak::before {\r\n  content: \"\\F146A\";\r\n}\r\n\r\n.mdi-food-steak-off::before {\r\n  content: \"\\F146B\";\r\n}\r\n\r\n.mdi-food-takeout-box::before {\r\n  content: \"\\F1836\";\r\n}\r\n\r\n.mdi-food-takeout-box-outline::before {\r\n  content: \"\\F1837\";\r\n}\r\n\r\n.mdi-food-turkey::before {\r\n  content: \"\\F171C\";\r\n}\r\n\r\n.mdi-food-variant::before {\r\n  content: \"\\F025C\";\r\n}\r\n\r\n.mdi-food-variant-off::before {\r\n  content: \"\\F13E5\";\r\n}\r\n\r\n.mdi-foot-print::before {\r\n  content: \"\\F0F52\";\r\n}\r\n\r\n.mdi-football::before {\r\n  content: \"\\F025D\";\r\n}\r\n\r\n.mdi-football-australian::before {\r\n  content: \"\\F025E\";\r\n}\r\n\r\n.mdi-football-helmet::before {\r\n  content: \"\\F025F\";\r\n}\r\n\r\n.mdi-forest::before {\r\n  content: \"\\F1897\";\r\n}\r\n\r\n.mdi-forklift::before {\r\n  content: \"\\F07C9\";\r\n}\r\n\r\n.mdi-form-dropdown::before {\r\n  content: \"\\F1400\";\r\n}\r\n\r\n.mdi-form-select::before {\r\n  content: \"\\F1401\";\r\n}\r\n\r\n.mdi-form-textarea::before {\r\n  content: \"\\F1095\";\r\n}\r\n\r\n.mdi-form-textbox::before {\r\n  content: \"\\F060E\";\r\n}\r\n\r\n.mdi-form-textbox-lock::before {\r\n  content: \"\\F135D\";\r\n}\r\n\r\n.mdi-form-textbox-password::before {\r\n  content: \"\\F07F5\";\r\n}\r\n\r\n.mdi-format-align-bottom::before {\r\n  content: \"\\F0753\";\r\n}\r\n\r\n.mdi-format-align-center::before {\r\n  content: \"\\F0260\";\r\n}\r\n\r\n.mdi-format-align-justify::before {\r\n  content: \"\\F0261\";\r\n}\r\n\r\n.mdi-format-align-left::before {\r\n  content: \"\\F0262\";\r\n}\r\n\r\n.mdi-format-align-middle::before {\r\n  content: \"\\F0754\";\r\n}\r\n\r\n.mdi-format-align-right::before {\r\n  content: \"\\F0263\";\r\n}\r\n\r\n.mdi-format-align-top::before {\r\n  content: \"\\F0755\";\r\n}\r\n\r\n.mdi-format-annotation-minus::before {\r\n  content: \"\\F0ABC\";\r\n}\r\n\r\n.mdi-format-annotation-plus::before {\r\n  content: \"\\F0646\";\r\n}\r\n\r\n.mdi-format-bold::before {\r\n  content: \"\\F0264\";\r\n}\r\n\r\n.mdi-format-clear::before {\r\n  content: \"\\F0265\";\r\n}\r\n\r\n.mdi-format-color-fill::before {\r\n  content: \"\\F0266\";\r\n}\r\n\r\n.mdi-format-color-highlight::before {\r\n  content: \"\\F0E31\";\r\n}\r\n\r\n.mdi-format-color-marker-cancel::before {\r\n  content: \"\\F1313\";\r\n}\r\n\r\n.mdi-format-color-text::before {\r\n  content: \"\\F069E\";\r\n}\r\n\r\n.mdi-format-columns::before {\r\n  content: \"\\F08DF\";\r\n}\r\n\r\n.mdi-format-float-center::before {\r\n  content: \"\\F0267\";\r\n}\r\n\r\n.mdi-format-float-left::before {\r\n  content: \"\\F0268\";\r\n}\r\n\r\n.mdi-format-float-none::before {\r\n  content: \"\\F0269\";\r\n}\r\n\r\n.mdi-format-float-right::before {\r\n  content: \"\\F026A\";\r\n}\r\n\r\n.mdi-format-font::before {\r\n  content: \"\\F06D6\";\r\n}\r\n\r\n.mdi-format-font-size-decrease::before {\r\n  content: \"\\F09F3\";\r\n}\r\n\r\n.mdi-format-font-size-increase::before {\r\n  content: \"\\F09F4\";\r\n}\r\n\r\n.mdi-format-header-1::before {\r\n  content: \"\\F026B\";\r\n}\r\n\r\n.mdi-format-header-2::before {\r\n  content: \"\\F026C\";\r\n}\r\n\r\n.mdi-format-header-3::before {\r\n  content: \"\\F026D\";\r\n}\r\n\r\n.mdi-format-header-4::before {\r\n  content: \"\\F026E\";\r\n}\r\n\r\n.mdi-format-header-5::before {\r\n  content: \"\\F026F\";\r\n}\r\n\r\n.mdi-format-header-6::before {\r\n  content: \"\\F0270\";\r\n}\r\n\r\n.mdi-format-header-decrease::before {\r\n  content: \"\\F0271\";\r\n}\r\n\r\n.mdi-format-header-equal::before {\r\n  content: \"\\F0272\";\r\n}\r\n\r\n.mdi-format-header-increase::before {\r\n  content: \"\\F0273\";\r\n}\r\n\r\n.mdi-format-header-pound::before {\r\n  content: \"\\F0274\";\r\n}\r\n\r\n.mdi-format-horizontal-align-center::before {\r\n  content: \"\\F061E\";\r\n}\r\n\r\n.mdi-format-horizontal-align-left::before {\r\n  content: \"\\F061F\";\r\n}\r\n\r\n.mdi-format-horizontal-align-right::before {\r\n  content: \"\\F0620\";\r\n}\r\n\r\n.mdi-format-indent-decrease::before {\r\n  content: \"\\F0275\";\r\n}\r\n\r\n.mdi-format-indent-increase::before {\r\n  content: \"\\F0276\";\r\n}\r\n\r\n.mdi-format-italic::before {\r\n  content: \"\\F0277\";\r\n}\r\n\r\n.mdi-format-letter-case::before {\r\n  content: \"\\F0B34\";\r\n}\r\n\r\n.mdi-format-letter-case-lower::before {\r\n  content: \"\\F0B35\";\r\n}\r\n\r\n.mdi-format-letter-case-upper::before {\r\n  content: \"\\F0B36\";\r\n}\r\n\r\n.mdi-format-letter-ends-with::before {\r\n  content: \"\\F0FB8\";\r\n}\r\n\r\n.mdi-format-letter-matches::before {\r\n  content: \"\\F0FB9\";\r\n}\r\n\r\n.mdi-format-letter-spacing::before {\r\n  content: \"\\F1956\";\r\n}\r\n\r\n.mdi-format-letter-starts-with::before {\r\n  content: \"\\F0FBA\";\r\n}\r\n\r\n.mdi-format-line-spacing::before {\r\n  content: \"\\F0278\";\r\n}\r\n\r\n.mdi-format-line-style::before {\r\n  content: \"\\F05C8\";\r\n}\r\n\r\n.mdi-format-line-weight::before {\r\n  content: \"\\F05C9\";\r\n}\r\n\r\n.mdi-format-list-bulleted::before {\r\n  content: \"\\F0279\";\r\n}\r\n\r\n.mdi-format-list-bulleted-square::before {\r\n  content: \"\\F0DD0\";\r\n}\r\n\r\n.mdi-format-list-bulleted-triangle::before {\r\n  content: \"\\F0EB2\";\r\n}\r\n\r\n.mdi-format-list-bulleted-type::before {\r\n  content: \"\\F027A\";\r\n}\r\n\r\n.mdi-format-list-checkbox::before {\r\n  content: \"\\F096A\";\r\n}\r\n\r\n.mdi-format-list-checks::before {\r\n  content: \"\\F0756\";\r\n}\r\n\r\n.mdi-format-list-group::before {\r\n  content: \"\\F1860\";\r\n}\r\n\r\n.mdi-format-list-numbered::before {\r\n  content: \"\\F027B\";\r\n}\r\n\r\n.mdi-format-list-numbered-rtl::before {\r\n  content: \"\\F0D0D\";\r\n}\r\n\r\n.mdi-format-list-text::before {\r\n  content: \"\\F126F\";\r\n}\r\n\r\n.mdi-format-overline::before {\r\n  content: \"\\F0EB3\";\r\n}\r\n\r\n.mdi-format-page-break::before {\r\n  content: \"\\F06D7\";\r\n}\r\n\r\n.mdi-format-page-split::before {\r\n  content: \"\\F1917\";\r\n}\r\n\r\n.mdi-format-paint::before {\r\n  content: \"\\F027C\";\r\n}\r\n\r\n.mdi-format-paragraph::before {\r\n  content: \"\\F027D\";\r\n}\r\n\r\n.mdi-format-pilcrow::before {\r\n  content: \"\\F06D8\";\r\n}\r\n\r\n.mdi-format-quote-close::before {\r\n  content: \"\\F027E\";\r\n}\r\n\r\n.mdi-format-quote-close-outline::before {\r\n  content: \"\\F11A8\";\r\n}\r\n\r\n.mdi-format-quote-open::before {\r\n  content: \"\\F0757\";\r\n}\r\n\r\n.mdi-format-quote-open-outline::before {\r\n  content: \"\\F11A7\";\r\n}\r\n\r\n.mdi-format-rotate-90::before {\r\n  content: \"\\F06AA\";\r\n}\r\n\r\n.mdi-format-section::before {\r\n  content: \"\\F069F\";\r\n}\r\n\r\n.mdi-format-size::before {\r\n  content: \"\\F027F\";\r\n}\r\n\r\n.mdi-format-strikethrough::before {\r\n  content: \"\\F0280\";\r\n}\r\n\r\n.mdi-format-strikethrough-variant::before {\r\n  content: \"\\F0281\";\r\n}\r\n\r\n.mdi-format-subscript::before {\r\n  content: \"\\F0282\";\r\n}\r\n\r\n.mdi-format-superscript::before {\r\n  content: \"\\F0283\";\r\n}\r\n\r\n.mdi-format-text::before {\r\n  content: \"\\F0284\";\r\n}\r\n\r\n.mdi-format-text-rotation-angle-down::before {\r\n  content: \"\\F0FBB\";\r\n}\r\n\r\n.mdi-format-text-rotation-angle-up::before {\r\n  content: \"\\F0FBC\";\r\n}\r\n\r\n.mdi-format-text-rotation-down::before {\r\n  content: \"\\F0D73\";\r\n}\r\n\r\n.mdi-format-text-rotation-down-vertical::before {\r\n  content: \"\\F0FBD\";\r\n}\r\n\r\n.mdi-format-text-rotation-none::before {\r\n  content: \"\\F0D74\";\r\n}\r\n\r\n.mdi-format-text-rotation-up::before {\r\n  content: \"\\F0FBE\";\r\n}\r\n\r\n.mdi-format-text-rotation-vertical::before {\r\n  content: \"\\F0FBF\";\r\n}\r\n\r\n.mdi-format-text-variant::before {\r\n  content: \"\\F0E32\";\r\n}\r\n\r\n.mdi-format-text-variant-outline::before {\r\n  content: \"\\F150F\";\r\n}\r\n\r\n.mdi-format-text-wrapping-clip::before {\r\n  content: \"\\F0D0E\";\r\n}\r\n\r\n.mdi-format-text-wrapping-overflow::before {\r\n  content: \"\\F0D0F\";\r\n}\r\n\r\n.mdi-format-text-wrapping-wrap::before {\r\n  content: \"\\F0D10\";\r\n}\r\n\r\n.mdi-format-textbox::before {\r\n  content: \"\\F0D11\";\r\n}\r\n\r\n.mdi-format-textdirection-l-to-r::before {\r\n  content: \"\\F0285\";\r\n}\r\n\r\n.mdi-format-textdirection-r-to-l::before {\r\n  content: \"\\F0286\";\r\n}\r\n\r\n.mdi-format-title::before {\r\n  content: \"\\F05F4\";\r\n}\r\n\r\n.mdi-format-underline::before {\r\n  content: \"\\F0287\";\r\n}\r\n\r\n.mdi-format-underline-wavy::before {\r\n  content: \"\\F18E9\";\r\n}\r\n\r\n.mdi-format-vertical-align-bottom::before {\r\n  content: \"\\F0621\";\r\n}\r\n\r\n.mdi-format-vertical-align-center::before {\r\n  content: \"\\F0622\";\r\n}\r\n\r\n.mdi-format-vertical-align-top::before {\r\n  content: \"\\F0623\";\r\n}\r\n\r\n.mdi-format-wrap-inline::before {\r\n  content: \"\\F0288\";\r\n}\r\n\r\n.mdi-format-wrap-square::before {\r\n  content: \"\\F0289\";\r\n}\r\n\r\n.mdi-format-wrap-tight::before {\r\n  content: \"\\F028A\";\r\n}\r\n\r\n.mdi-format-wrap-top-bottom::before {\r\n  content: \"\\F028B\";\r\n}\r\n\r\n.mdi-forum::before {\r\n  content: \"\\F028C\";\r\n}\r\n\r\n.mdi-forum-outline::before {\r\n  content: \"\\F0822\";\r\n}\r\n\r\n.mdi-forward::before {\r\n  content: \"\\F028D\";\r\n}\r\n\r\n.mdi-forwardburger::before {\r\n  content: \"\\F0D75\";\r\n}\r\n\r\n.mdi-fountain::before {\r\n  content: \"\\F096B\";\r\n}\r\n\r\n.mdi-fountain-pen::before {\r\n  content: \"\\F0D12\";\r\n}\r\n\r\n.mdi-fountain-pen-tip::before {\r\n  content: \"\\F0D13\";\r\n}\r\n\r\n.mdi-fraction-one-half::before {\r\n  content: \"\\F1992\";\r\n}\r\n\r\n.mdi-freebsd::before {\r\n  content: \"\\F08E0\";\r\n}\r\n\r\n.mdi-french-fries::before {\r\n  content: \"\\F1957\";\r\n}\r\n\r\n.mdi-frequently-asked-questions::before {\r\n  content: \"\\F0EB4\";\r\n}\r\n\r\n.mdi-fridge::before {\r\n  content: \"\\F0290\";\r\n}\r\n\r\n.mdi-fridge-alert::before {\r\n  content: \"\\F11B1\";\r\n}\r\n\r\n.mdi-fridge-alert-outline::before {\r\n  content: \"\\F11B2\";\r\n}\r\n\r\n.mdi-fridge-bottom::before {\r\n  content: \"\\F0292\";\r\n}\r\n\r\n.mdi-fridge-industrial::before {\r\n  content: \"\\F15EE\";\r\n}\r\n\r\n.mdi-fridge-industrial-alert::before {\r\n  content: \"\\F15EF\";\r\n}\r\n\r\n.mdi-fridge-industrial-alert-outline::before {\r\n  content: \"\\F15F0\";\r\n}\r\n\r\n.mdi-fridge-industrial-off::before {\r\n  content: \"\\F15F1\";\r\n}\r\n\r\n.mdi-fridge-industrial-off-outline::before {\r\n  content: \"\\F15F2\";\r\n}\r\n\r\n.mdi-fridge-industrial-outline::before {\r\n  content: \"\\F15F3\";\r\n}\r\n\r\n.mdi-fridge-off::before {\r\n  content: \"\\F11AF\";\r\n}\r\n\r\n.mdi-fridge-off-outline::before {\r\n  content: \"\\F11B0\";\r\n}\r\n\r\n.mdi-fridge-outline::before {\r\n  content: \"\\F028F\";\r\n}\r\n\r\n.mdi-fridge-top::before {\r\n  content: \"\\F0291\";\r\n}\r\n\r\n.mdi-fridge-variant::before {\r\n  content: \"\\F15F4\";\r\n}\r\n\r\n.mdi-fridge-variant-alert::before {\r\n  content: \"\\F15F5\";\r\n}\r\n\r\n.mdi-fridge-variant-alert-outline::before {\r\n  content: \"\\F15F6\";\r\n}\r\n\r\n.mdi-fridge-variant-off::before {\r\n  content: \"\\F15F7\";\r\n}\r\n\r\n.mdi-fridge-variant-off-outline::before {\r\n  content: \"\\F15F8\";\r\n}\r\n\r\n.mdi-fridge-variant-outline::before {\r\n  content: \"\\F15F9\";\r\n}\r\n\r\n.mdi-fruit-cherries::before {\r\n  content: \"\\F1042\";\r\n}\r\n\r\n.mdi-fruit-cherries-off::before {\r\n  content: \"\\F13F8\";\r\n}\r\n\r\n.mdi-fruit-citrus::before {\r\n  content: \"\\F1043\";\r\n}\r\n\r\n.mdi-fruit-citrus-off::before {\r\n  content: \"\\F13F9\";\r\n}\r\n\r\n.mdi-fruit-grapes::before {\r\n  content: \"\\F1044\";\r\n}\r\n\r\n.mdi-fruit-grapes-outline::before {\r\n  content: \"\\F1045\";\r\n}\r\n\r\n.mdi-fruit-pineapple::before {\r\n  content: \"\\F1046\";\r\n}\r\n\r\n.mdi-fruit-watermelon::before {\r\n  content: \"\\F1047\";\r\n}\r\n\r\n.mdi-fuel::before {\r\n  content: \"\\F07CA\";\r\n}\r\n\r\n.mdi-fuel-cell::before {\r\n  content: \"\\F18B5\";\r\n}\r\n\r\n.mdi-fullscreen::before {\r\n  content: \"\\F0293\";\r\n}\r\n\r\n.mdi-fullscreen-exit::before {\r\n  content: \"\\F0294\";\r\n}\r\n\r\n.mdi-function::before {\r\n  content: \"\\F0295\";\r\n}\r\n\r\n.mdi-function-variant::before {\r\n  content: \"\\F0871\";\r\n}\r\n\r\n.mdi-furigana-horizontal::before {\r\n  content: \"\\F1081\";\r\n}\r\n\r\n.mdi-furigana-vertical::before {\r\n  content: \"\\F1082\";\r\n}\r\n\r\n.mdi-fuse::before {\r\n  content: \"\\F0C85\";\r\n}\r\n\r\n.mdi-fuse-alert::before {\r\n  content: \"\\F142D\";\r\n}\r\n\r\n.mdi-fuse-blade::before {\r\n  content: \"\\F0C86\";\r\n}\r\n\r\n.mdi-fuse-off::before {\r\n  content: \"\\F142C\";\r\n}\r\n\r\n.mdi-gamepad::before {\r\n  content: \"\\F0296\";\r\n}\r\n\r\n.mdi-gamepad-circle::before {\r\n  content: \"\\F0E33\";\r\n}\r\n\r\n.mdi-gamepad-circle-down::before {\r\n  content: \"\\F0E34\";\r\n}\r\n\r\n.mdi-gamepad-circle-left::before {\r\n  content: \"\\F0E35\";\r\n}\r\n\r\n.mdi-gamepad-circle-outline::before {\r\n  content: \"\\F0E36\";\r\n}\r\n\r\n.mdi-gamepad-circle-right::before {\r\n  content: \"\\F0E37\";\r\n}\r\n\r\n.mdi-gamepad-circle-up::before {\r\n  content: \"\\F0E38\";\r\n}\r\n\r\n.mdi-gamepad-down::before {\r\n  content: \"\\F0E39\";\r\n}\r\n\r\n.mdi-gamepad-left::before {\r\n  content: \"\\F0E3A\";\r\n}\r\n\r\n.mdi-gamepad-outline::before {\r\n  content: \"\\F1919\";\r\n}\r\n\r\n.mdi-gamepad-right::before {\r\n  content: \"\\F0E3B\";\r\n}\r\n\r\n.mdi-gamepad-round::before {\r\n  content: \"\\F0E3C\";\r\n}\r\n\r\n.mdi-gamepad-round-down::before {\r\n  content: \"\\F0E3D\";\r\n}\r\n\r\n.mdi-gamepad-round-left::before {\r\n  content: \"\\F0E3E\";\r\n}\r\n\r\n.mdi-gamepad-round-outline::before {\r\n  content: \"\\F0E3F\";\r\n}\r\n\r\n.mdi-gamepad-round-right::before {\r\n  content: \"\\F0E40\";\r\n}\r\n\r\n.mdi-gamepad-round-up::before {\r\n  content: \"\\F0E41\";\r\n}\r\n\r\n.mdi-gamepad-square::before {\r\n  content: \"\\F0EB5\";\r\n}\r\n\r\n.mdi-gamepad-square-outline::before {\r\n  content: \"\\F0EB6\";\r\n}\r\n\r\n.mdi-gamepad-up::before {\r\n  content: \"\\F0E42\";\r\n}\r\n\r\n.mdi-gamepad-variant::before {\r\n  content: \"\\F0297\";\r\n}\r\n\r\n.mdi-gamepad-variant-outline::before {\r\n  content: \"\\F0EB7\";\r\n}\r\n\r\n.mdi-gamma::before {\r\n  content: \"\\F10EE\";\r\n}\r\n\r\n.mdi-gantry-crane::before {\r\n  content: \"\\F0DD1\";\r\n}\r\n\r\n.mdi-garage::before {\r\n  content: \"\\F06D9\";\r\n}\r\n\r\n.mdi-garage-alert::before {\r\n  content: \"\\F0872\";\r\n}\r\n\r\n.mdi-garage-alert-variant::before {\r\n  content: \"\\F12D5\";\r\n}\r\n\r\n.mdi-garage-lock::before {\r\n  content: \"\\F17FB\";\r\n}\r\n\r\n.mdi-garage-open::before {\r\n  content: \"\\F06DA\";\r\n}\r\n\r\n.mdi-garage-open-variant::before {\r\n  content: \"\\F12D4\";\r\n}\r\n\r\n.mdi-garage-variant::before {\r\n  content: \"\\F12D3\";\r\n}\r\n\r\n.mdi-garage-variant-lock::before {\r\n  content: \"\\F17FC\";\r\n}\r\n\r\n.mdi-gas-cylinder::before {\r\n  content: \"\\F0647\";\r\n}\r\n\r\n.mdi-gas-station::before {\r\n  content: \"\\F0298\";\r\n}\r\n\r\n.mdi-gas-station-off::before {\r\n  content: \"\\F1409\";\r\n}\r\n\r\n.mdi-gas-station-off-outline::before {\r\n  content: \"\\F140A\";\r\n}\r\n\r\n.mdi-gas-station-outline::before {\r\n  content: \"\\F0EB8\";\r\n}\r\n\r\n.mdi-gate::before {\r\n  content: \"\\F0299\";\r\n}\r\n\r\n.mdi-gate-alert::before {\r\n  content: \"\\F17F8\";\r\n}\r\n\r\n.mdi-gate-and::before {\r\n  content: \"\\F08E1\";\r\n}\r\n\r\n.mdi-gate-arrow-left::before {\r\n  content: \"\\F17F7\";\r\n}\r\n\r\n.mdi-gate-arrow-right::before {\r\n  content: \"\\F1169\";\r\n}\r\n\r\n.mdi-gate-nand::before {\r\n  content: \"\\F08E2\";\r\n}\r\n\r\n.mdi-gate-nor::before {\r\n  content: \"\\F08E3\";\r\n}\r\n\r\n.mdi-gate-not::before {\r\n  content: \"\\F08E4\";\r\n}\r\n\r\n.mdi-gate-open::before {\r\n  content: \"\\F116A\";\r\n}\r\n\r\n.mdi-gate-or::before {\r\n  content: \"\\F08E5\";\r\n}\r\n\r\n.mdi-gate-xnor::before {\r\n  content: \"\\F08E6\";\r\n}\r\n\r\n.mdi-gate-xor::before {\r\n  content: \"\\F08E7\";\r\n}\r\n\r\n.mdi-gatsby::before {\r\n  content: \"\\F0E43\";\r\n}\r\n\r\n.mdi-gauge::before {\r\n  content: \"\\F029A\";\r\n}\r\n\r\n.mdi-gauge-empty::before {\r\n  content: \"\\F0873\";\r\n}\r\n\r\n.mdi-gauge-full::before {\r\n  content: \"\\F0874\";\r\n}\r\n\r\n.mdi-gauge-low::before {\r\n  content: \"\\F0875\";\r\n}\r\n\r\n.mdi-gavel::before {\r\n  content: \"\\F029B\";\r\n}\r\n\r\n.mdi-gender-female::before {\r\n  content: \"\\F029C\";\r\n}\r\n\r\n.mdi-gender-male::before {\r\n  content: \"\\F029D\";\r\n}\r\n\r\n.mdi-gender-male-female::before {\r\n  content: \"\\F029E\";\r\n}\r\n\r\n.mdi-gender-male-female-variant::before {\r\n  content: \"\\F113F\";\r\n}\r\n\r\n.mdi-gender-non-binary::before {\r\n  content: \"\\F1140\";\r\n}\r\n\r\n.mdi-gender-transgender::before {\r\n  content: \"\\F029F\";\r\n}\r\n\r\n.mdi-gentoo::before {\r\n  content: \"\\F08E8\";\r\n}\r\n\r\n.mdi-gesture::before {\r\n  content: \"\\F07CB\";\r\n}\r\n\r\n.mdi-gesture-double-tap::before {\r\n  content: \"\\F073C\";\r\n}\r\n\r\n.mdi-gesture-pinch::before {\r\n  content: \"\\F0ABD\";\r\n}\r\n\r\n.mdi-gesture-spread::before {\r\n  content: \"\\F0ABE\";\r\n}\r\n\r\n.mdi-gesture-swipe::before {\r\n  content: \"\\F0D76\";\r\n}\r\n\r\n.mdi-gesture-swipe-down::before {\r\n  content: \"\\F073D\";\r\n}\r\n\r\n.mdi-gesture-swipe-horizontal::before {\r\n  content: \"\\F0ABF\";\r\n}\r\n\r\n.mdi-gesture-swipe-left::before {\r\n  content: \"\\F073E\";\r\n}\r\n\r\n.mdi-gesture-swipe-right::before {\r\n  content: \"\\F073F\";\r\n}\r\n\r\n.mdi-gesture-swipe-up::before {\r\n  content: \"\\F0740\";\r\n}\r\n\r\n.mdi-gesture-swipe-vertical::before {\r\n  content: \"\\F0AC0\";\r\n}\r\n\r\n.mdi-gesture-tap::before {\r\n  content: \"\\F0741\";\r\n}\r\n\r\n.mdi-gesture-tap-box::before {\r\n  content: \"\\F12A9\";\r\n}\r\n\r\n.mdi-gesture-tap-button::before {\r\n  content: \"\\F12A8\";\r\n}\r\n\r\n.mdi-gesture-tap-hold::before {\r\n  content: \"\\F0D77\";\r\n}\r\n\r\n.mdi-gesture-two-double-tap::before {\r\n  content: \"\\F0742\";\r\n}\r\n\r\n.mdi-gesture-two-tap::before {\r\n  content: \"\\F0743\";\r\n}\r\n\r\n.mdi-ghost::before {\r\n  content: \"\\F02A0\";\r\n}\r\n\r\n.mdi-ghost-off::before {\r\n  content: \"\\F09F5\";\r\n}\r\n\r\n.mdi-ghost-off-outline::before {\r\n  content: \"\\F165C\";\r\n}\r\n\r\n.mdi-ghost-outline::before {\r\n  content: \"\\F165D\";\r\n}\r\n\r\n.mdi-gift::before {\r\n  content: \"\\F0E44\";\r\n}\r\n\r\n.mdi-gift-off::before {\r\n  content: \"\\F16EF\";\r\n}\r\n\r\n.mdi-gift-off-outline::before {\r\n  content: \"\\F16F0\";\r\n}\r\n\r\n.mdi-gift-open::before {\r\n  content: \"\\F16F1\";\r\n}\r\n\r\n.mdi-gift-open-outline::before {\r\n  content: \"\\F16F2\";\r\n}\r\n\r\n.mdi-gift-outline::before {\r\n  content: \"\\F02A1\";\r\n}\r\n\r\n.mdi-git::before {\r\n  content: \"\\F02A2\";\r\n}\r\n\r\n.mdi-github::before {\r\n  content: \"\\F02A4\";\r\n}\r\n\r\n.mdi-gitlab::before {\r\n  content: \"\\F0BA0\";\r\n}\r\n\r\n.mdi-glass-cocktail::before {\r\n  content: \"\\F0356\";\r\n}\r\n\r\n.mdi-glass-cocktail-off::before {\r\n  content: \"\\F15E6\";\r\n}\r\n\r\n.mdi-glass-flute::before {\r\n  content: \"\\F02A5\";\r\n}\r\n\r\n.mdi-glass-fragile::before {\r\n  content: \"\\F1873\";\r\n}\r\n\r\n.mdi-glass-mug::before {\r\n  content: \"\\F02A6\";\r\n}\r\n\r\n.mdi-glass-mug-off::before {\r\n  content: \"\\F15E7\";\r\n}\r\n\r\n.mdi-glass-mug-variant::before {\r\n  content: \"\\F1116\";\r\n}\r\n\r\n.mdi-glass-mug-variant-off::before {\r\n  content: \"\\F15E8\";\r\n}\r\n\r\n.mdi-glass-pint-outline::before {\r\n  content: \"\\F130D\";\r\n}\r\n\r\n.mdi-glass-stange::before {\r\n  content: \"\\F02A7\";\r\n}\r\n\r\n.mdi-glass-tulip::before {\r\n  content: \"\\F02A8\";\r\n}\r\n\r\n.mdi-glass-wine::before {\r\n  content: \"\\F0876\";\r\n}\r\n\r\n.mdi-glasses::before {\r\n  content: \"\\F02AA\";\r\n}\r\n\r\n.mdi-globe-light::before {\r\n  content: \"\\F12D7\";\r\n}\r\n\r\n.mdi-globe-model::before {\r\n  content: \"\\F08E9\";\r\n}\r\n\r\n.mdi-gmail::before {\r\n  content: \"\\F02AB\";\r\n}\r\n\r\n.mdi-gnome::before {\r\n  content: \"\\F02AC\";\r\n}\r\n\r\n.mdi-go-kart::before {\r\n  content: \"\\F0D79\";\r\n}\r\n\r\n.mdi-go-kart-track::before {\r\n  content: \"\\F0D7A\";\r\n}\r\n\r\n.mdi-gog::before {\r\n  content: \"\\F0BA1\";\r\n}\r\n\r\n.mdi-gold::before {\r\n  content: \"\\F124F\";\r\n}\r\n\r\n.mdi-golf::before {\r\n  content: \"\\F0823\";\r\n}\r\n\r\n.mdi-golf-cart::before {\r\n  content: \"\\F11A4\";\r\n}\r\n\r\n.mdi-golf-tee::before {\r\n  content: \"\\F1083\";\r\n}\r\n\r\n.mdi-gondola::before {\r\n  content: \"\\F0686\";\r\n}\r\n\r\n.mdi-goodreads::before {\r\n  content: \"\\F0D7B\";\r\n}\r\n\r\n.mdi-google::before {\r\n  content: \"\\F02AD\";\r\n}\r\n\r\n.mdi-google-ads::before {\r\n  content: \"\\F0C87\";\r\n}\r\n\r\n.mdi-google-analytics::before {\r\n  content: \"\\F07CC\";\r\n}\r\n\r\n.mdi-google-assistant::before {\r\n  content: \"\\F07CD\";\r\n}\r\n\r\n.mdi-google-cardboard::before {\r\n  content: \"\\F02AE\";\r\n}\r\n\r\n.mdi-google-chrome::before {\r\n  content: \"\\F02AF\";\r\n}\r\n\r\n.mdi-google-circles::before {\r\n  content: \"\\F02B0\";\r\n}\r\n\r\n.mdi-google-circles-communities::before {\r\n  content: \"\\F02B1\";\r\n}\r\n\r\n.mdi-google-circles-extended::before {\r\n  content: \"\\F02B2\";\r\n}\r\n\r\n.mdi-google-circles-group::before {\r\n  content: \"\\F02B3\";\r\n}\r\n\r\n.mdi-google-classroom::before {\r\n  content: \"\\F02C0\";\r\n}\r\n\r\n.mdi-google-cloud::before {\r\n  content: \"\\F11F6\";\r\n}\r\n\r\n.mdi-google-controller::before {\r\n  content: \"\\F02B4\";\r\n}\r\n\r\n.mdi-google-controller-off::before {\r\n  content: \"\\F02B5\";\r\n}\r\n\r\n.mdi-google-downasaur::before {\r\n  content: \"\\F1362\";\r\n}\r\n\r\n.mdi-google-drive::before {\r\n  content: \"\\F02B6\";\r\n}\r\n\r\n.mdi-google-earth::before {\r\n  content: \"\\F02B7\";\r\n}\r\n\r\n.mdi-google-fit::before {\r\n  content: \"\\F096C\";\r\n}\r\n\r\n.mdi-google-glass::before {\r\n  content: \"\\F02B8\";\r\n}\r\n\r\n.mdi-google-hangouts::before {\r\n  content: \"\\F02C9\";\r\n}\r\n\r\n.mdi-google-home::before {\r\n  content: \"\\F0824\";\r\n}\r\n\r\n.mdi-google-keep::before {\r\n  content: \"\\F06DC\";\r\n}\r\n\r\n.mdi-google-lens::before {\r\n  content: \"\\F09F6\";\r\n}\r\n\r\n.mdi-google-maps::before {\r\n  content: \"\\F05F5\";\r\n}\r\n\r\n.mdi-google-my-business::before {\r\n  content: \"\\F1048\";\r\n}\r\n\r\n.mdi-google-nearby::before {\r\n  content: \"\\F02B9\";\r\n}\r\n\r\n.mdi-google-play::before {\r\n  content: \"\\F02BC\";\r\n}\r\n\r\n.mdi-google-plus::before {\r\n  content: \"\\F02BD\";\r\n}\r\n\r\n.mdi-google-podcast::before {\r\n  content: \"\\F0EB9\";\r\n}\r\n\r\n.mdi-google-spreadsheet::before {\r\n  content: \"\\F09F7\";\r\n}\r\n\r\n.mdi-google-street-view::before {\r\n  content: \"\\F0C88\";\r\n}\r\n\r\n.mdi-google-translate::before {\r\n  content: \"\\F02BF\";\r\n}\r\n\r\n.mdi-gradient-horizontal::before {\r\n  content: \"\\F174A\";\r\n}\r\n\r\n.mdi-gradient-vertical::before {\r\n  content: \"\\F06A0\";\r\n}\r\n\r\n.mdi-grain::before {\r\n  content: \"\\F0D7C\";\r\n}\r\n\r\n.mdi-graph::before {\r\n  content: \"\\F1049\";\r\n}\r\n\r\n.mdi-graph-outline::before {\r\n  content: \"\\F104A\";\r\n}\r\n\r\n.mdi-graphql::before {\r\n  content: \"\\F0877\";\r\n}\r\n\r\n.mdi-grass::before {\r\n  content: \"\\F1510\";\r\n}\r\n\r\n.mdi-grave-stone::before {\r\n  content: \"\\F0BA2\";\r\n}\r\n\r\n.mdi-grease-pencil::before {\r\n  content: \"\\F0648\";\r\n}\r\n\r\n.mdi-greater-than::before {\r\n  content: \"\\F096D\";\r\n}\r\n\r\n.mdi-greater-than-or-equal::before {\r\n  content: \"\\F096E\";\r\n}\r\n\r\n.mdi-greenhouse::before {\r\n  content: \"\\F002D\";\r\n}\r\n\r\n.mdi-grid::before {\r\n  content: \"\\F02C1\";\r\n}\r\n\r\n.mdi-grid-large::before {\r\n  content: \"\\F0758\";\r\n}\r\n\r\n.mdi-grid-off::before {\r\n  content: \"\\F02C2\";\r\n}\r\n\r\n.mdi-grill::before {\r\n  content: \"\\F0E45\";\r\n}\r\n\r\n.mdi-grill-outline::before {\r\n  content: \"\\F118A\";\r\n}\r\n\r\n.mdi-group::before {\r\n  content: \"\\F02C3\";\r\n}\r\n\r\n.mdi-guitar-acoustic::before {\r\n  content: \"\\F0771\";\r\n}\r\n\r\n.mdi-guitar-electric::before {\r\n  content: \"\\F02C4\";\r\n}\r\n\r\n.mdi-guitar-pick::before {\r\n  content: \"\\F02C5\";\r\n}\r\n\r\n.mdi-guitar-pick-outline::before {\r\n  content: \"\\F02C6\";\r\n}\r\n\r\n.mdi-guy-fawkes-mask::before {\r\n  content: \"\\F0825\";\r\n}\r\n\r\n.mdi-hail::before {\r\n  content: \"\\F0AC1\";\r\n}\r\n\r\n.mdi-hair-dryer::before {\r\n  content: \"\\F10EF\";\r\n}\r\n\r\n.mdi-hair-dryer-outline::before {\r\n  content: \"\\F10F0\";\r\n}\r\n\r\n.mdi-halloween::before {\r\n  content: \"\\F0BA3\";\r\n}\r\n\r\n.mdi-hamburger::before {\r\n  content: \"\\F0685\";\r\n}\r\n\r\n.mdi-hamburger-check::before {\r\n  content: \"\\F1776\";\r\n}\r\n\r\n.mdi-hamburger-minus::before {\r\n  content: \"\\F1777\";\r\n}\r\n\r\n.mdi-hamburger-off::before {\r\n  content: \"\\F1778\";\r\n}\r\n\r\n.mdi-hamburger-plus::before {\r\n  content: \"\\F1779\";\r\n}\r\n\r\n.mdi-hamburger-remove::before {\r\n  content: \"\\F177A\";\r\n}\r\n\r\n.mdi-hammer::before {\r\n  content: \"\\F08EA\";\r\n}\r\n\r\n.mdi-hammer-screwdriver::before {\r\n  content: \"\\F1322\";\r\n}\r\n\r\n.mdi-hammer-sickle::before {\r\n  content: \"\\F1887\";\r\n}\r\n\r\n.mdi-hammer-wrench::before {\r\n  content: \"\\F1323\";\r\n}\r\n\r\n.mdi-hand-back-left::before {\r\n  content: \"\\F0E46\";\r\n}\r\n\r\n.mdi-hand-back-left-off::before {\r\n  content: \"\\F1830\";\r\n}\r\n\r\n.mdi-hand-back-left-off-outline::before {\r\n  content: \"\\F1832\";\r\n}\r\n\r\n.mdi-hand-back-left-outline::before {\r\n  content: \"\\F182C\";\r\n}\r\n\r\n.mdi-hand-back-right::before {\r\n  content: \"\\F0E47\";\r\n}\r\n\r\n.mdi-hand-back-right-off::before {\r\n  content: \"\\F1831\";\r\n}\r\n\r\n.mdi-hand-back-right-off-outline::before {\r\n  content: \"\\F1833\";\r\n}\r\n\r\n.mdi-hand-back-right-outline::before {\r\n  content: \"\\F182D\";\r\n}\r\n\r\n.mdi-hand-clap::before {\r\n  content: \"\\F194B\";\r\n}\r\n\r\n.mdi-hand-coin::before {\r\n  content: \"\\F188F\";\r\n}\r\n\r\n.mdi-hand-coin-outline::before {\r\n  content: \"\\F1890\";\r\n}\r\n\r\n.mdi-hand-extended::before {\r\n  content: \"\\F18B6\";\r\n}\r\n\r\n.mdi-hand-extended-outline::before {\r\n  content: \"\\F18B7\";\r\n}\r\n\r\n.mdi-hand-front-left::before {\r\n  content: \"\\F182B\";\r\n}\r\n\r\n.mdi-hand-front-left-outline::before {\r\n  content: \"\\F182E\";\r\n}\r\n\r\n.mdi-hand-front-right::before {\r\n  content: \"\\F0A4F\";\r\n}\r\n\r\n.mdi-hand-front-right-outline::before {\r\n  content: \"\\F182F\";\r\n}\r\n\r\n.mdi-hand-heart::before {\r\n  content: \"\\F10F1\";\r\n}\r\n\r\n.mdi-hand-heart-outline::before {\r\n  content: \"\\F157E\";\r\n}\r\n\r\n.mdi-hand-okay::before {\r\n  content: \"\\F0A50\";\r\n}\r\n\r\n.mdi-hand-peace::before {\r\n  content: \"\\F0A51\";\r\n}\r\n\r\n.mdi-hand-peace-variant::before {\r\n  content: \"\\F0A52\";\r\n}\r\n\r\n.mdi-hand-pointing-down::before {\r\n  content: \"\\F0A53\";\r\n}\r\n\r\n.mdi-hand-pointing-left::before {\r\n  content: \"\\F0A54\";\r\n}\r\n\r\n.mdi-hand-pointing-right::before {\r\n  content: \"\\F02C7\";\r\n}\r\n\r\n.mdi-hand-pointing-up::before {\r\n  content: \"\\F0A55\";\r\n}\r\n\r\n.mdi-hand-saw::before {\r\n  content: \"\\F0E48\";\r\n}\r\n\r\n.mdi-hand-wash::before {\r\n  content: \"\\F157F\";\r\n}\r\n\r\n.mdi-hand-wash-outline::before {\r\n  content: \"\\F1580\";\r\n}\r\n\r\n.mdi-hand-water::before {\r\n  content: \"\\F139F\";\r\n}\r\n\r\n.mdi-hand-wave::before {\r\n  content: \"\\F1821\";\r\n}\r\n\r\n.mdi-hand-wave-outline::before {\r\n  content: \"\\F1822\";\r\n}\r\n\r\n.mdi-handball::before {\r\n  content: \"\\F0F53\";\r\n}\r\n\r\n.mdi-handcuffs::before {\r\n  content: \"\\F113E\";\r\n}\r\n\r\n.mdi-hands-pray::before {\r\n  content: \"\\F0579\";\r\n}\r\n\r\n.mdi-handshake::before {\r\n  content: \"\\F1218\";\r\n}\r\n\r\n.mdi-handshake-outline::before {\r\n  content: \"\\F15A1\";\r\n}\r\n\r\n.mdi-hanger::before {\r\n  content: \"\\F02C8\";\r\n}\r\n\r\n.mdi-hard-hat::before {\r\n  content: \"\\F096F\";\r\n}\r\n\r\n.mdi-harddisk::before {\r\n  content: \"\\F02CA\";\r\n}\r\n\r\n.mdi-harddisk-plus::before {\r\n  content: \"\\F104B\";\r\n}\r\n\r\n.mdi-harddisk-remove::before {\r\n  content: \"\\F104C\";\r\n}\r\n\r\n.mdi-hat-fedora::before {\r\n  content: \"\\F0BA4\";\r\n}\r\n\r\n.mdi-hazard-lights::before {\r\n  content: \"\\F0C89\";\r\n}\r\n\r\n.mdi-hdr::before {\r\n  content: \"\\F0D7D\";\r\n}\r\n\r\n.mdi-hdr-off::before {\r\n  content: \"\\F0D7E\";\r\n}\r\n\r\n.mdi-head::before {\r\n  content: \"\\F135E\";\r\n}\r\n\r\n.mdi-head-alert::before {\r\n  content: \"\\F1338\";\r\n}\r\n\r\n.mdi-head-alert-outline::before {\r\n  content: \"\\F1339\";\r\n}\r\n\r\n.mdi-head-check::before {\r\n  content: \"\\F133A\";\r\n}\r\n\r\n.mdi-head-check-outline::before {\r\n  content: \"\\F133B\";\r\n}\r\n\r\n.mdi-head-cog::before {\r\n  content: \"\\F133C\";\r\n}\r\n\r\n.mdi-head-cog-outline::before {\r\n  content: \"\\F133D\";\r\n}\r\n\r\n.mdi-head-dots-horizontal::before {\r\n  content: \"\\F133E\";\r\n}\r\n\r\n.mdi-head-dots-horizontal-outline::before {\r\n  content: \"\\F133F\";\r\n}\r\n\r\n.mdi-head-flash::before {\r\n  content: \"\\F1340\";\r\n}\r\n\r\n.mdi-head-flash-outline::before {\r\n  content: \"\\F1341\";\r\n}\r\n\r\n.mdi-head-heart::before {\r\n  content: \"\\F1342\";\r\n}\r\n\r\n.mdi-head-heart-outline::before {\r\n  content: \"\\F1343\";\r\n}\r\n\r\n.mdi-head-lightbulb::before {\r\n  content: \"\\F1344\";\r\n}\r\n\r\n.mdi-head-lightbulb-outline::before {\r\n  content: \"\\F1345\";\r\n}\r\n\r\n.mdi-head-minus::before {\r\n  content: \"\\F1346\";\r\n}\r\n\r\n.mdi-head-minus-outline::before {\r\n  content: \"\\F1347\";\r\n}\r\n\r\n.mdi-head-outline::before {\r\n  content: \"\\F135F\";\r\n}\r\n\r\n.mdi-head-plus::before {\r\n  content: \"\\F1348\";\r\n}\r\n\r\n.mdi-head-plus-outline::before {\r\n  content: \"\\F1349\";\r\n}\r\n\r\n.mdi-head-question::before {\r\n  content: \"\\F134A\";\r\n}\r\n\r\n.mdi-head-question-outline::before {\r\n  content: \"\\F134B\";\r\n}\r\n\r\n.mdi-head-remove::before {\r\n  content: \"\\F134C\";\r\n}\r\n\r\n.mdi-head-remove-outline::before {\r\n  content: \"\\F134D\";\r\n}\r\n\r\n.mdi-head-snowflake::before {\r\n  content: \"\\F134E\";\r\n}\r\n\r\n.mdi-head-snowflake-outline::before {\r\n  content: \"\\F134F\";\r\n}\r\n\r\n.mdi-head-sync::before {\r\n  content: \"\\F1350\";\r\n}\r\n\r\n.mdi-head-sync-outline::before {\r\n  content: \"\\F1351\";\r\n}\r\n\r\n.mdi-headphones::before {\r\n  content: \"\\F02CB\";\r\n}\r\n\r\n.mdi-headphones-bluetooth::before {\r\n  content: \"\\F0970\";\r\n}\r\n\r\n.mdi-headphones-box::before {\r\n  content: \"\\F02CC\";\r\n}\r\n\r\n.mdi-headphones-off::before {\r\n  content: \"\\F07CE\";\r\n}\r\n\r\n.mdi-headphones-settings::before {\r\n  content: \"\\F02CD\";\r\n}\r\n\r\n.mdi-headset::before {\r\n  content: \"\\F02CE\";\r\n}\r\n\r\n.mdi-headset-dock::before {\r\n  content: \"\\F02CF\";\r\n}\r\n\r\n.mdi-headset-off::before {\r\n  content: \"\\F02D0\";\r\n}\r\n\r\n.mdi-heart::before {\r\n  content: \"\\F02D1\";\r\n}\r\n\r\n.mdi-heart-box::before {\r\n  content: \"\\F02D2\";\r\n}\r\n\r\n.mdi-heart-box-outline::before {\r\n  content: \"\\F02D3\";\r\n}\r\n\r\n.mdi-heart-broken::before {\r\n  content: \"\\F02D4\";\r\n}\r\n\r\n.mdi-heart-broken-outline::before {\r\n  content: \"\\F0D14\";\r\n}\r\n\r\n.mdi-heart-circle::before {\r\n  content: \"\\F0971\";\r\n}\r\n\r\n.mdi-heart-circle-outline::before {\r\n  content: \"\\F0972\";\r\n}\r\n\r\n.mdi-heart-cog::before {\r\n  content: \"\\F1663\";\r\n}\r\n\r\n.mdi-heart-cog-outline::before {\r\n  content: \"\\F1664\";\r\n}\r\n\r\n.mdi-heart-flash::before {\r\n  content: \"\\F0EF9\";\r\n}\r\n\r\n.mdi-heart-half::before {\r\n  content: \"\\F06DF\";\r\n}\r\n\r\n.mdi-heart-half-full::before {\r\n  content: \"\\F06DE\";\r\n}\r\n\r\n.mdi-heart-half-outline::before {\r\n  content: \"\\F06E0\";\r\n}\r\n\r\n.mdi-heart-minus::before {\r\n  content: \"\\F142F\";\r\n}\r\n\r\n.mdi-heart-minus-outline::before {\r\n  content: \"\\F1432\";\r\n}\r\n\r\n.mdi-heart-multiple::before {\r\n  content: \"\\F0A56\";\r\n}\r\n\r\n.mdi-heart-multiple-outline::before {\r\n  content: \"\\F0A57\";\r\n}\r\n\r\n.mdi-heart-off::before {\r\n  content: \"\\F0759\";\r\n}\r\n\r\n.mdi-heart-off-outline::before {\r\n  content: \"\\F1434\";\r\n}\r\n\r\n.mdi-heart-outline::before {\r\n  content: \"\\F02D5\";\r\n}\r\n\r\n.mdi-heart-plus::before {\r\n  content: \"\\F142E\";\r\n}\r\n\r\n.mdi-heart-plus-outline::before {\r\n  content: \"\\F1431\";\r\n}\r\n\r\n.mdi-heart-pulse::before {\r\n  content: \"\\F05F6\";\r\n}\r\n\r\n.mdi-heart-remove::before {\r\n  content: \"\\F1430\";\r\n}\r\n\r\n.mdi-heart-remove-outline::before {\r\n  content: \"\\F1433\";\r\n}\r\n\r\n.mdi-heart-settings::before {\r\n  content: \"\\F1665\";\r\n}\r\n\r\n.mdi-heart-settings-outline::before {\r\n  content: \"\\F1666\";\r\n}\r\n\r\n.mdi-helicopter::before {\r\n  content: \"\\F0AC2\";\r\n}\r\n\r\n.mdi-help::before {\r\n  content: \"\\F02D6\";\r\n}\r\n\r\n.mdi-help-box::before {\r\n  content: \"\\F078B\";\r\n}\r\n\r\n.mdi-help-circle::before {\r\n  content: \"\\F02D7\";\r\n}\r\n\r\n.mdi-help-circle-outline::before {\r\n  content: \"\\F0625\";\r\n}\r\n\r\n.mdi-help-network::before {\r\n  content: \"\\F06F5\";\r\n}\r\n\r\n.mdi-help-network-outline::before {\r\n  content: \"\\F0C8A\";\r\n}\r\n\r\n.mdi-help-rhombus::before {\r\n  content: \"\\F0BA5\";\r\n}\r\n\r\n.mdi-help-rhombus-outline::before {\r\n  content: \"\\F0BA6\";\r\n}\r\n\r\n.mdi-hexadecimal::before {\r\n  content: \"\\F12A7\";\r\n}\r\n\r\n.mdi-hexagon::before {\r\n  content: \"\\F02D8\";\r\n}\r\n\r\n.mdi-hexagon-multiple::before {\r\n  content: \"\\F06E1\";\r\n}\r\n\r\n.mdi-hexagon-multiple-outline::before {\r\n  content: \"\\F10F2\";\r\n}\r\n\r\n.mdi-hexagon-outline::before {\r\n  content: \"\\F02D9\";\r\n}\r\n\r\n.mdi-hexagon-slice-1::before {\r\n  content: \"\\F0AC3\";\r\n}\r\n\r\n.mdi-hexagon-slice-2::before {\r\n  content: \"\\F0AC4\";\r\n}\r\n\r\n.mdi-hexagon-slice-3::before {\r\n  content: \"\\F0AC5\";\r\n}\r\n\r\n.mdi-hexagon-slice-4::before {\r\n  content: \"\\F0AC6\";\r\n}\r\n\r\n.mdi-hexagon-slice-5::before {\r\n  content: \"\\F0AC7\";\r\n}\r\n\r\n.mdi-hexagon-slice-6::before {\r\n  content: \"\\F0AC8\";\r\n}\r\n\r\n.mdi-hexagram::before {\r\n  content: \"\\F0AC9\";\r\n}\r\n\r\n.mdi-hexagram-outline::before {\r\n  content: \"\\F0ACA\";\r\n}\r\n\r\n.mdi-high-definition::before {\r\n  content: \"\\F07CF\";\r\n}\r\n\r\n.mdi-high-definition-box::before {\r\n  content: \"\\F0878\";\r\n}\r\n\r\n.mdi-highway::before {\r\n  content: \"\\F05F7\";\r\n}\r\n\r\n.mdi-hiking::before {\r\n  content: \"\\F0D7F\";\r\n}\r\n\r\n.mdi-history::before {\r\n  content: \"\\F02DA\";\r\n}\r\n\r\n.mdi-hockey-puck::before {\r\n  content: \"\\F0879\";\r\n}\r\n\r\n.mdi-hockey-sticks::before {\r\n  content: \"\\F087A\";\r\n}\r\n\r\n.mdi-hololens::before {\r\n  content: \"\\F02DB\";\r\n}\r\n\r\n.mdi-home::before {\r\n  content: \"\\F02DC\";\r\n}\r\n\r\n.mdi-home-account::before {\r\n  content: \"\\F0826\";\r\n}\r\n\r\n.mdi-home-alert::before {\r\n  content: \"\\F087B\";\r\n}\r\n\r\n.mdi-home-alert-outline::before {\r\n  content: \"\\F15D0\";\r\n}\r\n\r\n.mdi-home-analytics::before {\r\n  content: \"\\F0EBA\";\r\n}\r\n\r\n.mdi-home-assistant::before {\r\n  content: \"\\F07D0\";\r\n}\r\n\r\n.mdi-home-automation::before {\r\n  content: \"\\F07D1\";\r\n}\r\n\r\n.mdi-home-battery::before {\r\n  content: \"\\F1901\";\r\n}\r\n\r\n.mdi-home-battery-outline::before {\r\n  content: \"\\F1902\";\r\n}\r\n\r\n.mdi-home-circle::before {\r\n  content: \"\\F07D2\";\r\n}\r\n\r\n.mdi-home-circle-outline::before {\r\n  content: \"\\F104D\";\r\n}\r\n\r\n.mdi-home-city::before {\r\n  content: \"\\F0D15\";\r\n}\r\n\r\n.mdi-home-city-outline::before {\r\n  content: \"\\F0D16\";\r\n}\r\n\r\n.mdi-home-edit::before {\r\n  content: \"\\F1159\";\r\n}\r\n\r\n.mdi-home-edit-outline::before {\r\n  content: \"\\F115A\";\r\n}\r\n\r\n.mdi-home-export-outline::before {\r\n  content: \"\\F0F9B\";\r\n}\r\n\r\n.mdi-home-flood::before {\r\n  content: \"\\F0EFA\";\r\n}\r\n\r\n.mdi-home-floor-0::before {\r\n  content: \"\\F0DD2\";\r\n}\r\n\r\n.mdi-home-floor-1::before {\r\n  content: \"\\F0D80\";\r\n}\r\n\r\n.mdi-home-floor-2::before {\r\n  content: \"\\F0D81\";\r\n}\r\n\r\n.mdi-home-floor-3::before {\r\n  content: \"\\F0D82\";\r\n}\r\n\r\n.mdi-home-floor-a::before {\r\n  content: \"\\F0D83\";\r\n}\r\n\r\n.mdi-home-floor-b::before {\r\n  content: \"\\F0D84\";\r\n}\r\n\r\n.mdi-home-floor-g::before {\r\n  content: \"\\F0D85\";\r\n}\r\n\r\n.mdi-home-floor-l::before {\r\n  content: \"\\F0D86\";\r\n}\r\n\r\n.mdi-home-floor-negative-1::before {\r\n  content: \"\\F0DD3\";\r\n}\r\n\r\n.mdi-home-group::before {\r\n  content: \"\\F0DD4\";\r\n}\r\n\r\n.mdi-home-group-minus::before {\r\n  content: \"\\F19C1\";\r\n}\r\n\r\n.mdi-home-group-plus::before {\r\n  content: \"\\F19C0\";\r\n}\r\n\r\n.mdi-home-group-remove::before {\r\n  content: \"\\F19C2\";\r\n}\r\n\r\n.mdi-home-heart::before {\r\n  content: \"\\F0827\";\r\n}\r\n\r\n.mdi-home-import-outline::before {\r\n  content: \"\\F0F9C\";\r\n}\r\n\r\n.mdi-home-lightbulb::before {\r\n  content: \"\\F1251\";\r\n}\r\n\r\n.mdi-home-lightbulb-outline::before {\r\n  content: \"\\F1252\";\r\n}\r\n\r\n.mdi-home-lightning-bolt::before {\r\n  content: \"\\F1903\";\r\n}\r\n\r\n.mdi-home-lightning-bolt-outline::before {\r\n  content: \"\\F1904\";\r\n}\r\n\r\n.mdi-home-lock::before {\r\n  content: \"\\F08EB\";\r\n}\r\n\r\n.mdi-home-lock-open::before {\r\n  content: \"\\F08EC\";\r\n}\r\n\r\n.mdi-home-map-marker::before {\r\n  content: \"\\F05F8\";\r\n}\r\n\r\n.mdi-home-minus::before {\r\n  content: \"\\F0974\";\r\n}\r\n\r\n.mdi-home-minus-outline::before {\r\n  content: \"\\F13D5\";\r\n}\r\n\r\n.mdi-home-modern::before {\r\n  content: \"\\F02DD\";\r\n}\r\n\r\n.mdi-home-outline::before {\r\n  content: \"\\F06A1\";\r\n}\r\n\r\n.mdi-home-plus::before {\r\n  content: \"\\F0975\";\r\n}\r\n\r\n.mdi-home-plus-outline::before {\r\n  content: \"\\F13D6\";\r\n}\r\n\r\n.mdi-home-remove::before {\r\n  content: \"\\F1247\";\r\n}\r\n\r\n.mdi-home-remove-outline::before {\r\n  content: \"\\F13D7\";\r\n}\r\n\r\n.mdi-home-roof::before {\r\n  content: \"\\F112B\";\r\n}\r\n\r\n.mdi-home-search::before {\r\n  content: \"\\F13B0\";\r\n}\r\n\r\n.mdi-home-search-outline::before {\r\n  content: \"\\F13B1\";\r\n}\r\n\r\n.mdi-home-switch::before {\r\n  content: \"\\F1794\";\r\n}\r\n\r\n.mdi-home-switch-outline::before {\r\n  content: \"\\F1795\";\r\n}\r\n\r\n.mdi-home-thermometer::before {\r\n  content: \"\\F0F54\";\r\n}\r\n\r\n.mdi-home-thermometer-outline::before {\r\n  content: \"\\F0F55\";\r\n}\r\n\r\n.mdi-home-variant::before {\r\n  content: \"\\F02DE\";\r\n}\r\n\r\n.mdi-home-variant-outline::before {\r\n  content: \"\\F0BA7\";\r\n}\r\n\r\n.mdi-hook::before {\r\n  content: \"\\F06E2\";\r\n}\r\n\r\n.mdi-hook-off::before {\r\n  content: \"\\F06E3\";\r\n}\r\n\r\n.mdi-hoop-house::before {\r\n  content: \"\\F0E56\";\r\n}\r\n\r\n.mdi-hops::before {\r\n  content: \"\\F02DF\";\r\n}\r\n\r\n.mdi-horizontal-rotate-clockwise::before {\r\n  content: \"\\F10F3\";\r\n}\r\n\r\n.mdi-horizontal-rotate-counterclockwise::before {\r\n  content: \"\\F10F4\";\r\n}\r\n\r\n.mdi-horse::before {\r\n  content: \"\\F15BF\";\r\n}\r\n\r\n.mdi-horse-human::before {\r\n  content: \"\\F15C0\";\r\n}\r\n\r\n.mdi-horse-variant::before {\r\n  content: \"\\F15C1\";\r\n}\r\n\r\n.mdi-horse-variant-fast::before {\r\n  content: \"\\F186E\";\r\n}\r\n\r\n.mdi-horseshoe::before {\r\n  content: \"\\F0A58\";\r\n}\r\n\r\n.mdi-hospital::before {\r\n  content: \"\\F0FF6\";\r\n}\r\n\r\n.mdi-hospital-box::before {\r\n  content: \"\\F02E0\";\r\n}\r\n\r\n.mdi-hospital-box-outline::before {\r\n  content: \"\\F0FF7\";\r\n}\r\n\r\n.mdi-hospital-building::before {\r\n  content: \"\\F02E1\";\r\n}\r\n\r\n.mdi-hospital-marker::before {\r\n  content: \"\\F02E2\";\r\n}\r\n\r\n.mdi-hot-tub::before {\r\n  content: \"\\F0828\";\r\n}\r\n\r\n.mdi-hours-24::before {\r\n  content: \"\\F1478\";\r\n}\r\n\r\n.mdi-hubspot::before {\r\n  content: \"\\F0D17\";\r\n}\r\n\r\n.mdi-hulu::before {\r\n  content: \"\\F0829\";\r\n}\r\n\r\n.mdi-human::before {\r\n  content: \"\\F02E6\";\r\n}\r\n\r\n.mdi-human-baby-changing-table::before {\r\n  content: \"\\F138B\";\r\n}\r\n\r\n.mdi-human-cane::before {\r\n  content: \"\\F1581\";\r\n}\r\n\r\n.mdi-human-capacity-decrease::before {\r\n  content: \"\\F159B\";\r\n}\r\n\r\n.mdi-human-capacity-increase::before {\r\n  content: \"\\F159C\";\r\n}\r\n\r\n.mdi-human-child::before {\r\n  content: \"\\F02E7\";\r\n}\r\n\r\n.mdi-human-dolly::before {\r\n  content: \"\\F1980\";\r\n}\r\n\r\n.mdi-human-edit::before {\r\n  content: \"\\F14E8\";\r\n}\r\n\r\n.mdi-human-female::before {\r\n  content: \"\\F0649\";\r\n}\r\n\r\n.mdi-human-female-boy::before {\r\n  content: \"\\F0A59\";\r\n}\r\n\r\n.mdi-human-female-dance::before {\r\n  content: \"\\F15C9\";\r\n}\r\n\r\n.mdi-human-female-female::before {\r\n  content: \"\\F0A5A\";\r\n}\r\n\r\n.mdi-human-female-girl::before {\r\n  content: \"\\F0A5B\";\r\n}\r\n\r\n.mdi-human-greeting::before {\r\n  content: \"\\F17C4\";\r\n}\r\n\r\n.mdi-human-greeting-proximity::before {\r\n  content: \"\\F159D\";\r\n}\r\n\r\n.mdi-human-greeting-variant::before {\r\n  content: \"\\F064A\";\r\n}\r\n\r\n.mdi-human-handsdown::before {\r\n  content: \"\\F064B\";\r\n}\r\n\r\n.mdi-human-handsup::before {\r\n  content: \"\\F064C\";\r\n}\r\n\r\n.mdi-human-male::before {\r\n  content: \"\\F064D\";\r\n}\r\n\r\n.mdi-human-male-board::before {\r\n  content: \"\\F0890\";\r\n}\r\n\r\n.mdi-human-male-board-poll::before {\r\n  content: \"\\F0846\";\r\n}\r\n\r\n.mdi-human-male-boy::before {\r\n  content: \"\\F0A5C\";\r\n}\r\n\r\n.mdi-human-male-child::before {\r\n  content: \"\\F138C\";\r\n}\r\n\r\n.mdi-human-male-female::before {\r\n  content: \"\\F02E8\";\r\n}\r\n\r\n.mdi-human-male-female-child::before {\r\n  content: \"\\F1823\";\r\n}\r\n\r\n.mdi-human-male-girl::before {\r\n  content: \"\\F0A5D\";\r\n}\r\n\r\n.mdi-human-male-height::before {\r\n  content: \"\\F0EFB\";\r\n}\r\n\r\n.mdi-human-male-height-variant::before {\r\n  content: \"\\F0EFC\";\r\n}\r\n\r\n.mdi-human-male-male::before {\r\n  content: \"\\F0A5E\";\r\n}\r\n\r\n.mdi-human-non-binary::before {\r\n  content: \"\\F1848\";\r\n}\r\n\r\n.mdi-human-pregnant::before {\r\n  content: \"\\F05CF\";\r\n}\r\n\r\n.mdi-human-queue::before {\r\n  content: \"\\F1571\";\r\n}\r\n\r\n.mdi-human-scooter::before {\r\n  content: \"\\F11E9\";\r\n}\r\n\r\n.mdi-human-wheelchair::before {\r\n  content: \"\\F138D\";\r\n}\r\n\r\n.mdi-human-white-cane::before {\r\n  content: \"\\F1981\";\r\n}\r\n\r\n.mdi-humble-bundle::before {\r\n  content: \"\\F0744\";\r\n}\r\n\r\n.mdi-hvac::before {\r\n  content: \"\\F1352\";\r\n}\r\n\r\n.mdi-hvac-off::before {\r\n  content: \"\\F159E\";\r\n}\r\n\r\n.mdi-hydraulic-oil-level::before {\r\n  content: \"\\F1324\";\r\n}\r\n\r\n.mdi-hydraulic-oil-temperature::before {\r\n  content: \"\\F1325\";\r\n}\r\n\r\n.mdi-hydro-power::before {\r\n  content: \"\\F12E5\";\r\n}\r\n\r\n.mdi-hydrogen-station::before {\r\n  content: \"\\F1894\";\r\n}\r\n\r\n.mdi-ice-cream::before {\r\n  content: \"\\F082A\";\r\n}\r\n\r\n.mdi-ice-cream-off::before {\r\n  content: \"\\F0E52\";\r\n}\r\n\r\n.mdi-ice-pop::before {\r\n  content: \"\\F0EFD\";\r\n}\r\n\r\n.mdi-id-card::before {\r\n  content: \"\\F0FC0\";\r\n}\r\n\r\n.mdi-identifier::before {\r\n  content: \"\\F0EFE\";\r\n}\r\n\r\n.mdi-ideogram-cjk::before {\r\n  content: \"\\F1331\";\r\n}\r\n\r\n.mdi-ideogram-cjk-variant::before {\r\n  content: \"\\F1332\";\r\n}\r\n\r\n.mdi-image::before {\r\n  content: \"\\F02E9\";\r\n}\r\n\r\n.mdi-image-album::before {\r\n  content: \"\\F02EA\";\r\n}\r\n\r\n.mdi-image-area::before {\r\n  content: \"\\F02EB\";\r\n}\r\n\r\n.mdi-image-area-close::before {\r\n  content: \"\\F02EC\";\r\n}\r\n\r\n.mdi-image-auto-adjust::before {\r\n  content: \"\\F0FC1\";\r\n}\r\n\r\n.mdi-image-broken::before {\r\n  content: \"\\F02ED\";\r\n}\r\n\r\n.mdi-image-broken-variant::before {\r\n  content: \"\\F02EE\";\r\n}\r\n\r\n.mdi-image-edit::before {\r\n  content: \"\\F11E3\";\r\n}\r\n\r\n.mdi-image-edit-outline::before {\r\n  content: \"\\F11E4\";\r\n}\r\n\r\n.mdi-image-filter-black-white::before {\r\n  content: \"\\F02F0\";\r\n}\r\n\r\n.mdi-image-filter-center-focus::before {\r\n  content: \"\\F02F1\";\r\n}\r\n\r\n.mdi-image-filter-center-focus-strong::before {\r\n  content: \"\\F0EFF\";\r\n}\r\n\r\n.mdi-image-filter-center-focus-strong-outline::before {\r\n  content: \"\\F0F00\";\r\n}\r\n\r\n.mdi-image-filter-center-focus-weak::before {\r\n  content: \"\\F02F2\";\r\n}\r\n\r\n.mdi-image-filter-drama::before {\r\n  content: \"\\F02F3\";\r\n}\r\n\r\n.mdi-image-filter-frames::before {\r\n  content: \"\\F02F4\";\r\n}\r\n\r\n.mdi-image-filter-hdr::before {\r\n  content: \"\\F02F5\";\r\n}\r\n\r\n.mdi-image-filter-none::before {\r\n  content: \"\\F02F6\";\r\n}\r\n\r\n.mdi-image-filter-tilt-shift::before {\r\n  content: \"\\F02F7\";\r\n}\r\n\r\n.mdi-image-filter-vintage::before {\r\n  content: \"\\F02F8\";\r\n}\r\n\r\n.mdi-image-frame::before {\r\n  content: \"\\F0E49\";\r\n}\r\n\r\n.mdi-image-marker::before {\r\n  content: \"\\F177B\";\r\n}\r\n\r\n.mdi-image-marker-outline::before {\r\n  content: \"\\F177C\";\r\n}\r\n\r\n.mdi-image-minus::before {\r\n  content: \"\\F1419\";\r\n}\r\n\r\n.mdi-image-move::before {\r\n  content: \"\\F09F8\";\r\n}\r\n\r\n.mdi-image-multiple::before {\r\n  content: \"\\F02F9\";\r\n}\r\n\r\n.mdi-image-multiple-outline::before {\r\n  content: \"\\F02EF\";\r\n}\r\n\r\n.mdi-image-off::before {\r\n  content: \"\\F082B\";\r\n}\r\n\r\n.mdi-image-off-outline::before {\r\n  content: \"\\F11D1\";\r\n}\r\n\r\n.mdi-image-outline::before {\r\n  content: \"\\F0976\";\r\n}\r\n\r\n.mdi-image-plus::before {\r\n  content: \"\\F087C\";\r\n}\r\n\r\n.mdi-image-remove::before {\r\n  content: \"\\F1418\";\r\n}\r\n\r\n.mdi-image-search::before {\r\n  content: \"\\F0977\";\r\n}\r\n\r\n.mdi-image-search-outline::before {\r\n  content: \"\\F0978\";\r\n}\r\n\r\n.mdi-image-size-select-actual::before {\r\n  content: \"\\F0C8D\";\r\n}\r\n\r\n.mdi-image-size-select-large::before {\r\n  content: \"\\F0C8E\";\r\n}\r\n\r\n.mdi-image-size-select-small::before {\r\n  content: \"\\F0C8F\";\r\n}\r\n\r\n.mdi-image-text::before {\r\n  content: \"\\F160D\";\r\n}\r\n\r\n.mdi-import::before {\r\n  content: \"\\F02FA\";\r\n}\r\n\r\n.mdi-inbox::before {\r\n  content: \"\\F0687\";\r\n}\r\n\r\n.mdi-inbox-arrow-down::before {\r\n  content: \"\\F02FB\";\r\n}\r\n\r\n.mdi-inbox-arrow-down-outline::before {\r\n  content: \"\\F1270\";\r\n}\r\n\r\n.mdi-inbox-arrow-up::before {\r\n  content: \"\\F03D1\";\r\n}\r\n\r\n.mdi-inbox-arrow-up-outline::before {\r\n  content: \"\\F1271\";\r\n}\r\n\r\n.mdi-inbox-full::before {\r\n  content: \"\\F1272\";\r\n}\r\n\r\n.mdi-inbox-full-outline::before {\r\n  content: \"\\F1273\";\r\n}\r\n\r\n.mdi-inbox-multiple::before {\r\n  content: \"\\F08B0\";\r\n}\r\n\r\n.mdi-inbox-multiple-outline::before {\r\n  content: \"\\F0BA8\";\r\n}\r\n\r\n.mdi-inbox-outline::before {\r\n  content: \"\\F1274\";\r\n}\r\n\r\n.mdi-inbox-remove::before {\r\n  content: \"\\F159F\";\r\n}\r\n\r\n.mdi-inbox-remove-outline::before {\r\n  content: \"\\F15A0\";\r\n}\r\n\r\n.mdi-incognito::before {\r\n  content: \"\\F05F9\";\r\n}\r\n\r\n.mdi-incognito-circle::before {\r\n  content: \"\\F1421\";\r\n}\r\n\r\n.mdi-incognito-circle-off::before {\r\n  content: \"\\F1422\";\r\n}\r\n\r\n.mdi-incognito-off::before {\r\n  content: \"\\F0075\";\r\n}\r\n\r\n.mdi-induction::before {\r\n  content: \"\\F184C\";\r\n}\r\n\r\n.mdi-infinity::before {\r\n  content: \"\\F06E4\";\r\n}\r\n\r\n.mdi-information::before {\r\n  content: \"\\F02FC\";\r\n}\r\n\r\n.mdi-information-off::before {\r\n  content: \"\\F178C\";\r\n}\r\n\r\n.mdi-information-off-outline::before {\r\n  content: \"\\F178D\";\r\n}\r\n\r\n.mdi-information-outline::before {\r\n  content: \"\\F02FD\";\r\n}\r\n\r\n.mdi-information-variant::before {\r\n  content: \"\\F064E\";\r\n}\r\n\r\n.mdi-instagram::before {\r\n  content: \"\\F02FE\";\r\n}\r\n\r\n.mdi-instrument-triangle::before {\r\n  content: \"\\F104E\";\r\n}\r\n\r\n.mdi-integrated-circuit-chip::before {\r\n  content: \"\\F1913\";\r\n}\r\n\r\n.mdi-invert-colors::before {\r\n  content: \"\\F0301\";\r\n}\r\n\r\n.mdi-invert-colors-off::before {\r\n  content: \"\\F0E4A\";\r\n}\r\n\r\n.mdi-iobroker::before {\r\n  content: \"\\F12E8\";\r\n}\r\n\r\n.mdi-ip::before {\r\n  content: \"\\F0A5F\";\r\n}\r\n\r\n.mdi-ip-network::before {\r\n  content: \"\\F0A60\";\r\n}\r\n\r\n.mdi-ip-network-outline::before {\r\n  content: \"\\F0C90\";\r\n}\r\n\r\n.mdi-ip-outline::before {\r\n  content: \"\\F1982\";\r\n}\r\n\r\n.mdi-ipod::before {\r\n  content: \"\\F0C91\";\r\n}\r\n\r\n.mdi-iron::before {\r\n  content: \"\\F1824\";\r\n}\r\n\r\n.mdi-iron-board::before {\r\n  content: \"\\F1838\";\r\n}\r\n\r\n.mdi-iron-outline::before {\r\n  content: \"\\F1825\";\r\n}\r\n\r\n.mdi-island::before {\r\n  content: \"\\F104F\";\r\n}\r\n\r\n.mdi-iv-bag::before {\r\n  content: \"\\F10B9\";\r\n}\r\n\r\n.mdi-jabber::before {\r\n  content: \"\\F0DD5\";\r\n}\r\n\r\n.mdi-jeepney::before {\r\n  content: \"\\F0302\";\r\n}\r\n\r\n.mdi-jellyfish::before {\r\n  content: \"\\F0F01\";\r\n}\r\n\r\n.mdi-jellyfish-outline::before {\r\n  content: \"\\F0F02\";\r\n}\r\n\r\n.mdi-jira::before {\r\n  content: \"\\F0303\";\r\n}\r\n\r\n.mdi-jquery::before {\r\n  content: \"\\F087D\";\r\n}\r\n\r\n.mdi-jsfiddle::before {\r\n  content: \"\\F0304\";\r\n}\r\n\r\n.mdi-jump-rope::before {\r\n  content: \"\\F12FF\";\r\n}\r\n\r\n.mdi-kabaddi::before {\r\n  content: \"\\F0D87\";\r\n}\r\n\r\n.mdi-kangaroo::before {\r\n  content: \"\\F1558\";\r\n}\r\n\r\n.mdi-karate::before {\r\n  content: \"\\F082C\";\r\n}\r\n\r\n.mdi-kayaking::before {\r\n  content: \"\\F08AF\";\r\n}\r\n\r\n.mdi-keg::before {\r\n  content: \"\\F0305\";\r\n}\r\n\r\n.mdi-kettle::before {\r\n  content: \"\\F05FA\";\r\n}\r\n\r\n.mdi-kettle-alert::before {\r\n  content: \"\\F1317\";\r\n}\r\n\r\n.mdi-kettle-alert-outline::before {\r\n  content: \"\\F1318\";\r\n}\r\n\r\n.mdi-kettle-off::before {\r\n  content: \"\\F131B\";\r\n}\r\n\r\n.mdi-kettle-off-outline::before {\r\n  content: \"\\F131C\";\r\n}\r\n\r\n.mdi-kettle-outline::before {\r\n  content: \"\\F0F56\";\r\n}\r\n\r\n.mdi-kettle-pour-over::before {\r\n  content: \"\\F173C\";\r\n}\r\n\r\n.mdi-kettle-steam::before {\r\n  content: \"\\F1319\";\r\n}\r\n\r\n.mdi-kettle-steam-outline::before {\r\n  content: \"\\F131A\";\r\n}\r\n\r\n.mdi-kettlebell::before {\r\n  content: \"\\F1300\";\r\n}\r\n\r\n.mdi-key::before {\r\n  content: \"\\F0306\";\r\n}\r\n\r\n.mdi-key-alert::before {\r\n  content: \"\\F1983\";\r\n}\r\n\r\n.mdi-key-alert-outline::before {\r\n  content: \"\\F1984\";\r\n}\r\n\r\n.mdi-key-arrow-right::before {\r\n  content: \"\\F1312\";\r\n}\r\n\r\n.mdi-key-chain::before {\r\n  content: \"\\F1574\";\r\n}\r\n\r\n.mdi-key-chain-variant::before {\r\n  content: \"\\F1575\";\r\n}\r\n\r\n.mdi-key-change::before {\r\n  content: \"\\F0307\";\r\n}\r\n\r\n.mdi-key-link::before {\r\n  content: \"\\F119F\";\r\n}\r\n\r\n.mdi-key-minus::before {\r\n  content: \"\\F0308\";\r\n}\r\n\r\n.mdi-key-outline::before {\r\n  content: \"\\F0DD6\";\r\n}\r\n\r\n.mdi-key-plus::before {\r\n  content: \"\\F0309\";\r\n}\r\n\r\n.mdi-key-remove::before {\r\n  content: \"\\F030A\";\r\n}\r\n\r\n.mdi-key-star::before {\r\n  content: \"\\F119E\";\r\n}\r\n\r\n.mdi-key-variant::before {\r\n  content: \"\\F030B\";\r\n}\r\n\r\n.mdi-key-wireless::before {\r\n  content: \"\\F0FC2\";\r\n}\r\n\r\n.mdi-keyboard::before {\r\n  content: \"\\F030C\";\r\n}\r\n\r\n.mdi-keyboard-backspace::before {\r\n  content: \"\\F030D\";\r\n}\r\n\r\n.mdi-keyboard-caps::before {\r\n  content: \"\\F030E\";\r\n}\r\n\r\n.mdi-keyboard-close::before {\r\n  content: \"\\F030F\";\r\n}\r\n\r\n.mdi-keyboard-esc::before {\r\n  content: \"\\F12B7\";\r\n}\r\n\r\n.mdi-keyboard-f1::before {\r\n  content: \"\\F12AB\";\r\n}\r\n\r\n.mdi-keyboard-f10::before {\r\n  content: \"\\F12B4\";\r\n}\r\n\r\n.mdi-keyboard-f11::before {\r\n  content: \"\\F12B5\";\r\n}\r\n\r\n.mdi-keyboard-f12::before {\r\n  content: \"\\F12B6\";\r\n}\r\n\r\n.mdi-keyboard-f2::before {\r\n  content: \"\\F12AC\";\r\n}\r\n\r\n.mdi-keyboard-f3::before {\r\n  content: \"\\F12AD\";\r\n}\r\n\r\n.mdi-keyboard-f4::before {\r\n  content: \"\\F12AE\";\r\n}\r\n\r\n.mdi-keyboard-f5::before {\r\n  content: \"\\F12AF\";\r\n}\r\n\r\n.mdi-keyboard-f6::before {\r\n  content: \"\\F12B0\";\r\n}\r\n\r\n.mdi-keyboard-f7::before {\r\n  content: \"\\F12B1\";\r\n}\r\n\r\n.mdi-keyboard-f8::before {\r\n  content: \"\\F12B2\";\r\n}\r\n\r\n.mdi-keyboard-f9::before {\r\n  content: \"\\F12B3\";\r\n}\r\n\r\n.mdi-keyboard-off::before {\r\n  content: \"\\F0310\";\r\n}\r\n\r\n.mdi-keyboard-off-outline::before {\r\n  content: \"\\F0E4B\";\r\n}\r\n\r\n.mdi-keyboard-outline::before {\r\n  content: \"\\F097B\";\r\n}\r\n\r\n.mdi-keyboard-return::before {\r\n  content: \"\\F0311\";\r\n}\r\n\r\n.mdi-keyboard-settings::before {\r\n  content: \"\\F09F9\";\r\n}\r\n\r\n.mdi-keyboard-settings-outline::before {\r\n  content: \"\\F09FA\";\r\n}\r\n\r\n.mdi-keyboard-space::before {\r\n  content: \"\\F1050\";\r\n}\r\n\r\n.mdi-keyboard-tab::before {\r\n  content: \"\\F0312\";\r\n}\r\n\r\n.mdi-keyboard-tab-reverse::before {\r\n  content: \"\\F0325\";\r\n}\r\n\r\n.mdi-keyboard-variant::before {\r\n  content: \"\\F0313\";\r\n}\r\n\r\n.mdi-khanda::before {\r\n  content: \"\\F10FD\";\r\n}\r\n\r\n.mdi-kickstarter::before {\r\n  content: \"\\F0745\";\r\n}\r\n\r\n.mdi-kite::before {\r\n  content: \"\\F1985\";\r\n}\r\n\r\n.mdi-kite-outline::before {\r\n  content: \"\\F1986\";\r\n}\r\n\r\n.mdi-kitesurfing::before {\r\n  content: \"\\F1744\";\r\n}\r\n\r\n.mdi-klingon::before {\r\n  content: \"\\F135B\";\r\n}\r\n\r\n.mdi-knife::before {\r\n  content: \"\\F09FB\";\r\n}\r\n\r\n.mdi-knife-military::before {\r\n  content: \"\\F09FC\";\r\n}\r\n\r\n.mdi-koala::before {\r\n  content: \"\\F173F\";\r\n}\r\n\r\n.mdi-kodi::before {\r\n  content: \"\\F0314\";\r\n}\r\n\r\n.mdi-kubernetes::before {\r\n  content: \"\\F10FE\";\r\n}\r\n\r\n.mdi-label::before {\r\n  content: \"\\F0315\";\r\n}\r\n\r\n.mdi-label-multiple::before {\r\n  content: \"\\F1375\";\r\n}\r\n\r\n.mdi-label-multiple-outline::before {\r\n  content: \"\\F1376\";\r\n}\r\n\r\n.mdi-label-off::before {\r\n  content: \"\\F0ACB\";\r\n}\r\n\r\n.mdi-label-off-outline::before {\r\n  content: \"\\F0ACC\";\r\n}\r\n\r\n.mdi-label-outline::before {\r\n  content: \"\\F0316\";\r\n}\r\n\r\n.mdi-label-percent::before {\r\n  content: \"\\F12EA\";\r\n}\r\n\r\n.mdi-label-percent-outline::before {\r\n  content: \"\\F12EB\";\r\n}\r\n\r\n.mdi-label-variant::before {\r\n  content: \"\\F0ACD\";\r\n}\r\n\r\n.mdi-label-variant-outline::before {\r\n  content: \"\\F0ACE\";\r\n}\r\n\r\n.mdi-ladder::before {\r\n  content: \"\\F15A2\";\r\n}\r\n\r\n.mdi-ladybug::before {\r\n  content: \"\\F082D\";\r\n}\r\n\r\n.mdi-lambda::before {\r\n  content: \"\\F0627\";\r\n}\r\n\r\n.mdi-lamp::before {\r\n  content: \"\\F06B5\";\r\n}\r\n\r\n.mdi-lamp-outline::before {\r\n  content: \"\\F17D0\";\r\n}\r\n\r\n.mdi-lamps::before {\r\n  content: \"\\F1576\";\r\n}\r\n\r\n.mdi-lamps-outline::before {\r\n  content: \"\\F17D1\";\r\n}\r\n\r\n.mdi-lan::before {\r\n  content: \"\\F0317\";\r\n}\r\n\r\n.mdi-lan-check::before {\r\n  content: \"\\F12AA\";\r\n}\r\n\r\n.mdi-lan-connect::before {\r\n  content: \"\\F0318\";\r\n}\r\n\r\n.mdi-lan-disconnect::before {\r\n  content: \"\\F0319\";\r\n}\r\n\r\n.mdi-lan-pending::before {\r\n  content: \"\\F031A\";\r\n}\r\n\r\n.mdi-language-c::before {\r\n  content: \"\\F0671\";\r\n}\r\n\r\n.mdi-language-cpp::before {\r\n  content: \"\\F0672\";\r\n}\r\n\r\n.mdi-language-csharp::before {\r\n  content: \"\\F031B\";\r\n}\r\n\r\n.mdi-language-css3::before {\r\n  content: \"\\F031C\";\r\n}\r\n\r\n.mdi-language-fortran::before {\r\n  content: \"\\F121A\";\r\n}\r\n\r\n.mdi-language-go::before {\r\n  content: \"\\F07D3\";\r\n}\r\n\r\n.mdi-language-haskell::before {\r\n  content: \"\\F0C92\";\r\n}\r\n\r\n.mdi-language-html5::before {\r\n  content: \"\\F031D\";\r\n}\r\n\r\n.mdi-language-java::before {\r\n  content: \"\\F0B37\";\r\n}\r\n\r\n.mdi-language-javascript::before {\r\n  content: \"\\F031E\";\r\n}\r\n\r\n.mdi-language-kotlin::before {\r\n  content: \"\\F1219\";\r\n}\r\n\r\n.mdi-language-lua::before {\r\n  content: \"\\F08B1\";\r\n}\r\n\r\n.mdi-language-markdown::before {\r\n  content: \"\\F0354\";\r\n}\r\n\r\n.mdi-language-markdown-outline::before {\r\n  content: \"\\F0F5B\";\r\n}\r\n\r\n.mdi-language-php::before {\r\n  content: \"\\F031F\";\r\n}\r\n\r\n.mdi-language-python::before {\r\n  content: \"\\F0320\";\r\n}\r\n\r\n.mdi-language-r::before {\r\n  content: \"\\F07D4\";\r\n}\r\n\r\n.mdi-language-ruby::before {\r\n  content: \"\\F0D2D\";\r\n}\r\n\r\n.mdi-language-ruby-on-rails::before {\r\n  content: \"\\F0ACF\";\r\n}\r\n\r\n.mdi-language-rust::before {\r\n  content: \"\\F1617\";\r\n}\r\n\r\n.mdi-language-swift::before {\r\n  content: \"\\F06E5\";\r\n}\r\n\r\n.mdi-language-typescript::before {\r\n  content: \"\\F06E6\";\r\n}\r\n\r\n.mdi-language-xaml::before {\r\n  content: \"\\F0673\";\r\n}\r\n\r\n.mdi-laptop::before {\r\n  content: \"\\F0322\";\r\n}\r\n\r\n.mdi-laptop-off::before {\r\n  content: \"\\F06E7\";\r\n}\r\n\r\n.mdi-laravel::before {\r\n  content: \"\\F0AD0\";\r\n}\r\n\r\n.mdi-laser-pointer::before {\r\n  content: \"\\F1484\";\r\n}\r\n\r\n.mdi-lasso::before {\r\n  content: \"\\F0F03\";\r\n}\r\n\r\n.mdi-lastpass::before {\r\n  content: \"\\F0446\";\r\n}\r\n\r\n.mdi-latitude::before {\r\n  content: \"\\F0F57\";\r\n}\r\n\r\n.mdi-launch::before {\r\n  content: \"\\F0327\";\r\n}\r\n\r\n.mdi-lava-lamp::before {\r\n  content: \"\\F07D5\";\r\n}\r\n\r\n.mdi-layers::before {\r\n  content: \"\\F0328\";\r\n}\r\n\r\n.mdi-layers-edit::before {\r\n  content: \"\\F1892\";\r\n}\r\n\r\n.mdi-layers-minus::before {\r\n  content: \"\\F0E4C\";\r\n}\r\n\r\n.mdi-layers-off::before {\r\n  content: \"\\F0329\";\r\n}\r\n\r\n.mdi-layers-off-outline::before {\r\n  content: \"\\F09FD\";\r\n}\r\n\r\n.mdi-layers-outline::before {\r\n  content: \"\\F09FE\";\r\n}\r\n\r\n.mdi-layers-plus::before {\r\n  content: \"\\F0E4D\";\r\n}\r\n\r\n.mdi-layers-remove::before {\r\n  content: \"\\F0E4E\";\r\n}\r\n\r\n.mdi-layers-search::before {\r\n  content: \"\\F1206\";\r\n}\r\n\r\n.mdi-layers-search-outline::before {\r\n  content: \"\\F1207\";\r\n}\r\n\r\n.mdi-layers-triple::before {\r\n  content: \"\\F0F58\";\r\n}\r\n\r\n.mdi-layers-triple-outline::before {\r\n  content: \"\\F0F59\";\r\n}\r\n\r\n.mdi-lead-pencil::before {\r\n  content: \"\\F064F\";\r\n}\r\n\r\n.mdi-leaf::before {\r\n  content: \"\\F032A\";\r\n}\r\n\r\n.mdi-leaf-circle::before {\r\n  content: \"\\F1905\";\r\n}\r\n\r\n.mdi-leaf-circle-outline::before {\r\n  content: \"\\F1906\";\r\n}\r\n\r\n.mdi-leaf-maple::before {\r\n  content: \"\\F0C93\";\r\n}\r\n\r\n.mdi-leaf-maple-off::before {\r\n  content: \"\\F12DA\";\r\n}\r\n\r\n.mdi-leaf-off::before {\r\n  content: \"\\F12D9\";\r\n}\r\n\r\n.mdi-leak::before {\r\n  content: \"\\F0DD7\";\r\n}\r\n\r\n.mdi-leak-off::before {\r\n  content: \"\\F0DD8\";\r\n}\r\n\r\n.mdi-led-off::before {\r\n  content: \"\\F032B\";\r\n}\r\n\r\n.mdi-led-on::before {\r\n  content: \"\\F032C\";\r\n}\r\n\r\n.mdi-led-outline::before {\r\n  content: \"\\F032D\";\r\n}\r\n\r\n.mdi-led-strip::before {\r\n  content: \"\\F07D6\";\r\n}\r\n\r\n.mdi-led-strip-variant::before {\r\n  content: \"\\F1051\";\r\n}\r\n\r\n.mdi-led-variant-off::before {\r\n  content: \"\\F032E\";\r\n}\r\n\r\n.mdi-led-variant-on::before {\r\n  content: \"\\F032F\";\r\n}\r\n\r\n.mdi-led-variant-outline::before {\r\n  content: \"\\F0330\";\r\n}\r\n\r\n.mdi-leek::before {\r\n  content: \"\\F117D\";\r\n}\r\n\r\n.mdi-less-than::before {\r\n  content: \"\\F097C\";\r\n}\r\n\r\n.mdi-less-than-or-equal::before {\r\n  content: \"\\F097D\";\r\n}\r\n\r\n.mdi-library::before {\r\n  content: \"\\F0331\";\r\n}\r\n\r\n.mdi-library-shelves::before {\r\n  content: \"\\F0BA9\";\r\n}\r\n\r\n.mdi-license::before {\r\n  content: \"\\F0FC3\";\r\n}\r\n\r\n.mdi-lifebuoy::before {\r\n  content: \"\\F087E\";\r\n}\r\n\r\n.mdi-light-flood-down::before {\r\n  content: \"\\F1987\";\r\n}\r\n\r\n.mdi-light-flood-up::before {\r\n  content: \"\\F1988\";\r\n}\r\n\r\n.mdi-light-recessed::before {\r\n  content: \"\\F179B\";\r\n}\r\n\r\n.mdi-light-switch::before {\r\n  content: \"\\F097E\";\r\n}\r\n\r\n.mdi-lightbulb::before {\r\n  content: \"\\F0335\";\r\n}\r\n\r\n.mdi-lightbulb-auto::before {\r\n  content: \"\\F1800\";\r\n}\r\n\r\n.mdi-lightbulb-auto-outline::before {\r\n  content: \"\\F1801\";\r\n}\r\n\r\n.mdi-lightbulb-cfl::before {\r\n  content: \"\\F1208\";\r\n}\r\n\r\n.mdi-lightbulb-cfl-off::before {\r\n  content: \"\\F1209\";\r\n}\r\n\r\n.mdi-lightbulb-cfl-spiral::before {\r\n  content: \"\\F1275\";\r\n}\r\n\r\n.mdi-lightbulb-cfl-spiral-off::before {\r\n  content: \"\\F12C3\";\r\n}\r\n\r\n.mdi-lightbulb-fluorescent-tube::before {\r\n  content: \"\\F1804\";\r\n}\r\n\r\n.mdi-lightbulb-fluorescent-tube-outline::before {\r\n  content: \"\\F1805\";\r\n}\r\n\r\n.mdi-lightbulb-group::before {\r\n  content: \"\\F1253\";\r\n}\r\n\r\n.mdi-lightbulb-group-off::before {\r\n  content: \"\\F12CD\";\r\n}\r\n\r\n.mdi-lightbulb-group-off-outline::before {\r\n  content: \"\\F12CE\";\r\n}\r\n\r\n.mdi-lightbulb-group-outline::before {\r\n  content: \"\\F1254\";\r\n}\r\n\r\n.mdi-lightbulb-multiple::before {\r\n  content: \"\\F1255\";\r\n}\r\n\r\n.mdi-lightbulb-multiple-off::before {\r\n  content: \"\\F12CF\";\r\n}\r\n\r\n.mdi-lightbulb-multiple-off-outline::before {\r\n  content: \"\\F12D0\";\r\n}\r\n\r\n.mdi-lightbulb-multiple-outline::before {\r\n  content: \"\\F1256\";\r\n}\r\n\r\n.mdi-lightbulb-off::before {\r\n  content: \"\\F0E4F\";\r\n}\r\n\r\n.mdi-lightbulb-off-outline::before {\r\n  content: \"\\F0E50\";\r\n}\r\n\r\n.mdi-lightbulb-on::before {\r\n  content: \"\\F06E8\";\r\n}\r\n\r\n.mdi-lightbulb-on-outline::before {\r\n  content: \"\\F06E9\";\r\n}\r\n\r\n.mdi-lightbulb-outline::before {\r\n  content: \"\\F0336\";\r\n}\r\n\r\n.mdi-lightbulb-spot::before {\r\n  content: \"\\F17F4\";\r\n}\r\n\r\n.mdi-lightbulb-spot-off::before {\r\n  content: \"\\F17F5\";\r\n}\r\n\r\n.mdi-lightbulb-variant::before {\r\n  content: \"\\F1802\";\r\n}\r\n\r\n.mdi-lightbulb-variant-outline::before {\r\n  content: \"\\F1803\";\r\n}\r\n\r\n.mdi-lighthouse::before {\r\n  content: \"\\F09FF\";\r\n}\r\n\r\n.mdi-lighthouse-on::before {\r\n  content: \"\\F0A00\";\r\n}\r\n\r\n.mdi-lightning-bolt::before {\r\n  content: \"\\F140B\";\r\n}\r\n\r\n.mdi-lightning-bolt-circle::before {\r\n  content: \"\\F0820\";\r\n}\r\n\r\n.mdi-lightning-bolt-outline::before {\r\n  content: \"\\F140C\";\r\n}\r\n\r\n.mdi-line-scan::before {\r\n  content: \"\\F0624\";\r\n}\r\n\r\n.mdi-lingerie::before {\r\n  content: \"\\F1476\";\r\n}\r\n\r\n.mdi-link::before {\r\n  content: \"\\F0337\";\r\n}\r\n\r\n.mdi-link-box::before {\r\n  content: \"\\F0D1A\";\r\n}\r\n\r\n.mdi-link-box-outline::before {\r\n  content: \"\\F0D1B\";\r\n}\r\n\r\n.mdi-link-box-variant::before {\r\n  content: \"\\F0D1C\";\r\n}\r\n\r\n.mdi-link-box-variant-outline::before {\r\n  content: \"\\F0D1D\";\r\n}\r\n\r\n.mdi-link-lock::before {\r\n  content: \"\\F10BA\";\r\n}\r\n\r\n.mdi-link-off::before {\r\n  content: \"\\F0338\";\r\n}\r\n\r\n.mdi-link-plus::before {\r\n  content: \"\\F0C94\";\r\n}\r\n\r\n.mdi-link-variant::before {\r\n  content: \"\\F0339\";\r\n}\r\n\r\n.mdi-link-variant-minus::before {\r\n  content: \"\\F10FF\";\r\n}\r\n\r\n.mdi-link-variant-off::before {\r\n  content: \"\\F033A\";\r\n}\r\n\r\n.mdi-link-variant-plus::before {\r\n  content: \"\\F1100\";\r\n}\r\n\r\n.mdi-link-variant-remove::before {\r\n  content: \"\\F1101\";\r\n}\r\n\r\n.mdi-linkedin::before {\r\n  content: \"\\F033B\";\r\n}\r\n\r\n.mdi-linux::before {\r\n  content: \"\\F033D\";\r\n}\r\n\r\n.mdi-linux-mint::before {\r\n  content: \"\\F08ED\";\r\n}\r\n\r\n.mdi-lipstick::before {\r\n  content: \"\\F13B5\";\r\n}\r\n\r\n.mdi-liquid-spot::before {\r\n  content: \"\\F1826\";\r\n}\r\n\r\n.mdi-liquor::before {\r\n  content: \"\\F191E\";\r\n}\r\n\r\n.mdi-list-status::before {\r\n  content: \"\\F15AB\";\r\n}\r\n\r\n.mdi-litecoin::before {\r\n  content: \"\\F0A61\";\r\n}\r\n\r\n.mdi-loading::before {\r\n  content: \"\\F0772\";\r\n}\r\n\r\n.mdi-location-enter::before {\r\n  content: \"\\F0FC4\";\r\n}\r\n\r\n.mdi-location-exit::before {\r\n  content: \"\\F0FC5\";\r\n}\r\n\r\n.mdi-lock::before {\r\n  content: \"\\F033E\";\r\n}\r\n\r\n.mdi-lock-alert::before {\r\n  content: \"\\F08EE\";\r\n}\r\n\r\n.mdi-lock-alert-outline::before {\r\n  content: \"\\F15D1\";\r\n}\r\n\r\n.mdi-lock-check::before {\r\n  content: \"\\F139A\";\r\n}\r\n\r\n.mdi-lock-check-outline::before {\r\n  content: \"\\F16A8\";\r\n}\r\n\r\n.mdi-lock-clock::before {\r\n  content: \"\\F097F\";\r\n}\r\n\r\n.mdi-lock-minus::before {\r\n  content: \"\\F16A9\";\r\n}\r\n\r\n.mdi-lock-minus-outline::before {\r\n  content: \"\\F16AA\";\r\n}\r\n\r\n.mdi-lock-off::before {\r\n  content: \"\\F1671\";\r\n}\r\n\r\n.mdi-lock-off-outline::before {\r\n  content: \"\\F1672\";\r\n}\r\n\r\n.mdi-lock-open::before {\r\n  content: \"\\F033F\";\r\n}\r\n\r\n.mdi-lock-open-alert::before {\r\n  content: \"\\F139B\";\r\n}\r\n\r\n.mdi-lock-open-alert-outline::before {\r\n  content: \"\\F15D2\";\r\n}\r\n\r\n.mdi-lock-open-check::before {\r\n  content: \"\\F139C\";\r\n}\r\n\r\n.mdi-lock-open-check-outline::before {\r\n  content: \"\\F16AB\";\r\n}\r\n\r\n.mdi-lock-open-minus::before {\r\n  content: \"\\F16AC\";\r\n}\r\n\r\n.mdi-lock-open-minus-outline::before {\r\n  content: \"\\F16AD\";\r\n}\r\n\r\n.mdi-lock-open-outline::before {\r\n  content: \"\\F0340\";\r\n}\r\n\r\n.mdi-lock-open-plus::before {\r\n  content: \"\\F16AE\";\r\n}\r\n\r\n.mdi-lock-open-plus-outline::before {\r\n  content: \"\\F16AF\";\r\n}\r\n\r\n.mdi-lock-open-remove::before {\r\n  content: \"\\F16B0\";\r\n}\r\n\r\n.mdi-lock-open-remove-outline::before {\r\n  content: \"\\F16B1\";\r\n}\r\n\r\n.mdi-lock-open-variant::before {\r\n  content: \"\\F0FC6\";\r\n}\r\n\r\n.mdi-lock-open-variant-outline::before {\r\n  content: \"\\F0FC7\";\r\n}\r\n\r\n.mdi-lock-outline::before {\r\n  content: \"\\F0341\";\r\n}\r\n\r\n.mdi-lock-pattern::before {\r\n  content: \"\\F06EA\";\r\n}\r\n\r\n.mdi-lock-plus::before {\r\n  content: \"\\F05FB\";\r\n}\r\n\r\n.mdi-lock-plus-outline::before {\r\n  content: \"\\F16B2\";\r\n}\r\n\r\n.mdi-lock-question::before {\r\n  content: \"\\F08EF\";\r\n}\r\n\r\n.mdi-lock-remove::before {\r\n  content: \"\\F16B3\";\r\n}\r\n\r\n.mdi-lock-remove-outline::before {\r\n  content: \"\\F16B4\";\r\n}\r\n\r\n.mdi-lock-reset::before {\r\n  content: \"\\F0773\";\r\n}\r\n\r\n.mdi-lock-smart::before {\r\n  content: \"\\F08B2\";\r\n}\r\n\r\n.mdi-locker::before {\r\n  content: \"\\F07D7\";\r\n}\r\n\r\n.mdi-locker-multiple::before {\r\n  content: \"\\F07D8\";\r\n}\r\n\r\n.mdi-login::before {\r\n  content: \"\\F0342\";\r\n}\r\n\r\n.mdi-login-variant::before {\r\n  content: \"\\F05FC\";\r\n}\r\n\r\n.mdi-logout::before {\r\n  content: \"\\F0343\";\r\n}\r\n\r\n.mdi-logout-variant::before {\r\n  content: \"\\F05FD\";\r\n}\r\n\r\n.mdi-longitude::before {\r\n  content: \"\\F0F5A\";\r\n}\r\n\r\n.mdi-looks::before {\r\n  content: \"\\F0344\";\r\n}\r\n\r\n.mdi-lotion::before {\r\n  content: \"\\F1582\";\r\n}\r\n\r\n.mdi-lotion-outline::before {\r\n  content: \"\\F1583\";\r\n}\r\n\r\n.mdi-lotion-plus::before {\r\n  content: \"\\F1584\";\r\n}\r\n\r\n.mdi-lotion-plus-outline::before {\r\n  content: \"\\F1585\";\r\n}\r\n\r\n.mdi-loupe::before {\r\n  content: \"\\F0345\";\r\n}\r\n\r\n.mdi-lumx::before {\r\n  content: \"\\F0346\";\r\n}\r\n\r\n.mdi-lungs::before {\r\n  content: \"\\F1084\";\r\n}\r\n\r\n.mdi-mace::before {\r\n  content: \"\\F1843\";\r\n}\r\n\r\n.mdi-magazine-pistol::before {\r\n  content: \"\\F0324\";\r\n}\r\n\r\n.mdi-magazine-rifle::before {\r\n  content: \"\\F0323\";\r\n}\r\n\r\n.mdi-magic-staff::before {\r\n  content: \"\\F1844\";\r\n}\r\n\r\n.mdi-magnet::before {\r\n  content: \"\\F0347\";\r\n}\r\n\r\n.mdi-magnet-on::before {\r\n  content: \"\\F0348\";\r\n}\r\n\r\n.mdi-magnify::before {\r\n  content: \"\\F0349\";\r\n}\r\n\r\n.mdi-magnify-close::before {\r\n  content: \"\\F0980\";\r\n}\r\n\r\n.mdi-magnify-expand::before {\r\n  content: \"\\F1874\";\r\n}\r\n\r\n.mdi-magnify-minus::before {\r\n  content: \"\\F034A\";\r\n}\r\n\r\n.mdi-magnify-minus-cursor::before {\r\n  content: \"\\F0A62\";\r\n}\r\n\r\n.mdi-magnify-minus-outline::before {\r\n  content: \"\\F06EC\";\r\n}\r\n\r\n.mdi-magnify-plus::before {\r\n  content: \"\\F034B\";\r\n}\r\n\r\n.mdi-magnify-plus-cursor::before {\r\n  content: \"\\F0A63\";\r\n}\r\n\r\n.mdi-magnify-plus-outline::before {\r\n  content: \"\\F06ED\";\r\n}\r\n\r\n.mdi-magnify-remove-cursor::before {\r\n  content: \"\\F120C\";\r\n}\r\n\r\n.mdi-magnify-remove-outline::before {\r\n  content: \"\\F120D\";\r\n}\r\n\r\n.mdi-magnify-scan::before {\r\n  content: \"\\F1276\";\r\n}\r\n\r\n.mdi-mail::before {\r\n  content: \"\\F0EBB\";\r\n}\r\n\r\n.mdi-mailbox::before {\r\n  content: \"\\F06EE\";\r\n}\r\n\r\n.mdi-mailbox-open::before {\r\n  content: \"\\F0D88\";\r\n}\r\n\r\n.mdi-mailbox-open-outline::before {\r\n  content: \"\\F0D89\";\r\n}\r\n\r\n.mdi-mailbox-open-up::before {\r\n  content: \"\\F0D8A\";\r\n}\r\n\r\n.mdi-mailbox-open-up-outline::before {\r\n  content: \"\\F0D8B\";\r\n}\r\n\r\n.mdi-mailbox-outline::before {\r\n  content: \"\\F0D8C\";\r\n}\r\n\r\n.mdi-mailbox-up::before {\r\n  content: \"\\F0D8D\";\r\n}\r\n\r\n.mdi-mailbox-up-outline::before {\r\n  content: \"\\F0D8E\";\r\n}\r\n\r\n.mdi-manjaro::before {\r\n  content: \"\\F160A\";\r\n}\r\n\r\n.mdi-map::before {\r\n  content: \"\\F034D\";\r\n}\r\n\r\n.mdi-map-check::before {\r\n  content: \"\\F0EBC\";\r\n}\r\n\r\n.mdi-map-check-outline::before {\r\n  content: \"\\F0EBD\";\r\n}\r\n\r\n.mdi-map-clock::before {\r\n  content: \"\\F0D1E\";\r\n}\r\n\r\n.mdi-map-clock-outline::before {\r\n  content: \"\\F0D1F\";\r\n}\r\n\r\n.mdi-map-legend::before {\r\n  content: \"\\F0A01\";\r\n}\r\n\r\n.mdi-map-marker::before {\r\n  content: \"\\F034E\";\r\n}\r\n\r\n.mdi-map-marker-account::before {\r\n  content: \"\\F18E3\";\r\n}\r\n\r\n.mdi-map-marker-account-outline::before {\r\n  content: \"\\F18E4\";\r\n}\r\n\r\n.mdi-map-marker-alert::before {\r\n  content: \"\\F0F05\";\r\n}\r\n\r\n.mdi-map-marker-alert-outline::before {\r\n  content: \"\\F0F06\";\r\n}\r\n\r\n.mdi-map-marker-check::before {\r\n  content: \"\\F0C95\";\r\n}\r\n\r\n.mdi-map-marker-check-outline::before {\r\n  content: \"\\F12FB\";\r\n}\r\n\r\n.mdi-map-marker-circle::before {\r\n  content: \"\\F034F\";\r\n}\r\n\r\n.mdi-map-marker-distance::before {\r\n  content: \"\\F08F0\";\r\n}\r\n\r\n.mdi-map-marker-down::before {\r\n  content: \"\\F1102\";\r\n}\r\n\r\n.mdi-map-marker-left::before {\r\n  content: \"\\F12DB\";\r\n}\r\n\r\n.mdi-map-marker-left-outline::before {\r\n  content: \"\\F12DD\";\r\n}\r\n\r\n.mdi-map-marker-minus::before {\r\n  content: \"\\F0650\";\r\n}\r\n\r\n.mdi-map-marker-minus-outline::before {\r\n  content: \"\\F12F9\";\r\n}\r\n\r\n.mdi-map-marker-multiple::before {\r\n  content: \"\\F0350\";\r\n}\r\n\r\n.mdi-map-marker-multiple-outline::before {\r\n  content: \"\\F1277\";\r\n}\r\n\r\n.mdi-map-marker-off::before {\r\n  content: \"\\F0351\";\r\n}\r\n\r\n.mdi-map-marker-off-outline::before {\r\n  content: \"\\F12FD\";\r\n}\r\n\r\n.mdi-map-marker-outline::before {\r\n  content: \"\\F07D9\";\r\n}\r\n\r\n.mdi-map-marker-path::before {\r\n  content: \"\\F0D20\";\r\n}\r\n\r\n.mdi-map-marker-plus::before {\r\n  content: \"\\F0651\";\r\n}\r\n\r\n.mdi-map-marker-plus-outline::before {\r\n  content: \"\\F12F8\";\r\n}\r\n\r\n.mdi-map-marker-question::before {\r\n  content: \"\\F0F07\";\r\n}\r\n\r\n.mdi-map-marker-question-outline::before {\r\n  content: \"\\F0F08\";\r\n}\r\n\r\n.mdi-map-marker-radius::before {\r\n  content: \"\\F0352\";\r\n}\r\n\r\n.mdi-map-marker-radius-outline::before {\r\n  content: \"\\F12FC\";\r\n}\r\n\r\n.mdi-map-marker-remove::before {\r\n  content: \"\\F0F09\";\r\n}\r\n\r\n.mdi-map-marker-remove-outline::before {\r\n  content: \"\\F12FA\";\r\n}\r\n\r\n.mdi-map-marker-remove-variant::before {\r\n  content: \"\\F0F0A\";\r\n}\r\n\r\n.mdi-map-marker-right::before {\r\n  content: \"\\F12DC\";\r\n}\r\n\r\n.mdi-map-marker-right-outline::before {\r\n  content: \"\\F12DE\";\r\n}\r\n\r\n.mdi-map-marker-star::before {\r\n  content: \"\\F1608\";\r\n}\r\n\r\n.mdi-map-marker-star-outline::before {\r\n  content: \"\\F1609\";\r\n}\r\n\r\n.mdi-map-marker-up::before {\r\n  content: \"\\F1103\";\r\n}\r\n\r\n.mdi-map-minus::before {\r\n  content: \"\\F0981\";\r\n}\r\n\r\n.mdi-map-outline::before {\r\n  content: \"\\F0982\";\r\n}\r\n\r\n.mdi-map-plus::before {\r\n  content: \"\\F0983\";\r\n}\r\n\r\n.mdi-map-search::before {\r\n  content: \"\\F0984\";\r\n}\r\n\r\n.mdi-map-search-outline::before {\r\n  content: \"\\F0985\";\r\n}\r\n\r\n.mdi-mapbox::before {\r\n  content: \"\\F0BAA\";\r\n}\r\n\r\n.mdi-margin::before {\r\n  content: \"\\F0353\";\r\n}\r\n\r\n.mdi-marker::before {\r\n  content: \"\\F0652\";\r\n}\r\n\r\n.mdi-marker-cancel::before {\r\n  content: \"\\F0DD9\";\r\n}\r\n\r\n.mdi-marker-check::before {\r\n  content: \"\\F0355\";\r\n}\r\n\r\n.mdi-mastodon::before {\r\n  content: \"\\F0AD1\";\r\n}\r\n\r\n.mdi-material-design::before {\r\n  content: \"\\F0986\";\r\n}\r\n\r\n.mdi-material-ui::before {\r\n  content: \"\\F0357\";\r\n}\r\n\r\n.mdi-math-compass::before {\r\n  content: \"\\F0358\";\r\n}\r\n\r\n.mdi-math-cos::before {\r\n  content: \"\\F0C96\";\r\n}\r\n\r\n.mdi-math-integral::before {\r\n  content: \"\\F0FC8\";\r\n}\r\n\r\n.mdi-math-integral-box::before {\r\n  content: \"\\F0FC9\";\r\n}\r\n\r\n.mdi-math-log::before {\r\n  content: \"\\F1085\";\r\n}\r\n\r\n.mdi-math-norm::before {\r\n  content: \"\\F0FCA\";\r\n}\r\n\r\n.mdi-math-norm-box::before {\r\n  content: \"\\F0FCB\";\r\n}\r\n\r\n.mdi-math-sin::before {\r\n  content: \"\\F0C97\";\r\n}\r\n\r\n.mdi-math-tan::before {\r\n  content: \"\\F0C98\";\r\n}\r\n\r\n.mdi-matrix::before {\r\n  content: \"\\F0628\";\r\n}\r\n\r\n.mdi-medal::before {\r\n  content: \"\\F0987\";\r\n}\r\n\r\n.mdi-medal-outline::before {\r\n  content: \"\\F1326\";\r\n}\r\n\r\n.mdi-medical-bag::before {\r\n  content: \"\\F06EF\";\r\n}\r\n\r\n.mdi-meditation::before {\r\n  content: \"\\F117B\";\r\n}\r\n\r\n.mdi-memory::before {\r\n  content: \"\\F035B\";\r\n}\r\n\r\n.mdi-menorah::before {\r\n  content: \"\\F17D4\";\r\n}\r\n\r\n.mdi-menorah-fire::before {\r\n  content: \"\\F17D5\";\r\n}\r\n\r\n.mdi-menu::before {\r\n  content: \"\\F035C\";\r\n}\r\n\r\n.mdi-menu-down::before {\r\n  content: \"\\F035D\";\r\n}\r\n\r\n.mdi-menu-down-outline::before {\r\n  content: \"\\F06B6\";\r\n}\r\n\r\n.mdi-menu-left::before {\r\n  content: \"\\F035E\";\r\n}\r\n\r\n.mdi-menu-left-outline::before {\r\n  content: \"\\F0A02\";\r\n}\r\n\r\n.mdi-menu-open::before {\r\n  content: \"\\F0BAB\";\r\n}\r\n\r\n.mdi-menu-right::before {\r\n  content: \"\\F035F\";\r\n}\r\n\r\n.mdi-menu-right-outline::before {\r\n  content: \"\\F0A03\";\r\n}\r\n\r\n.mdi-menu-swap::before {\r\n  content: \"\\F0A64\";\r\n}\r\n\r\n.mdi-menu-swap-outline::before {\r\n  content: \"\\F0A65\";\r\n}\r\n\r\n.mdi-menu-up::before {\r\n  content: \"\\F0360\";\r\n}\r\n\r\n.mdi-menu-up-outline::before {\r\n  content: \"\\F06B7\";\r\n}\r\n\r\n.mdi-merge::before {\r\n  content: \"\\F0F5C\";\r\n}\r\n\r\n.mdi-message::before {\r\n  content: \"\\F0361\";\r\n}\r\n\r\n.mdi-message-alert::before {\r\n  content: \"\\F0362\";\r\n}\r\n\r\n.mdi-message-alert-outline::before {\r\n  content: \"\\F0A04\";\r\n}\r\n\r\n.mdi-message-arrow-left::before {\r\n  content: \"\\F12F2\";\r\n}\r\n\r\n.mdi-message-arrow-left-outline::before {\r\n  content: \"\\F12F3\";\r\n}\r\n\r\n.mdi-message-arrow-right::before {\r\n  content: \"\\F12F4\";\r\n}\r\n\r\n.mdi-message-arrow-right-outline::before {\r\n  content: \"\\F12F5\";\r\n}\r\n\r\n.mdi-message-badge::before {\r\n  content: \"\\F1941\";\r\n}\r\n\r\n.mdi-message-badge-outline::before {\r\n  content: \"\\F1942\";\r\n}\r\n\r\n.mdi-message-bookmark::before {\r\n  content: \"\\F15AC\";\r\n}\r\n\r\n.mdi-message-bookmark-outline::before {\r\n  content: \"\\F15AD\";\r\n}\r\n\r\n.mdi-message-bulleted::before {\r\n  content: \"\\F06A2\";\r\n}\r\n\r\n.mdi-message-bulleted-off::before {\r\n  content: \"\\F06A3\";\r\n}\r\n\r\n.mdi-message-cog::before {\r\n  content: \"\\F06F1\";\r\n}\r\n\r\n.mdi-message-cog-outline::before {\r\n  content: \"\\F1172\";\r\n}\r\n\r\n.mdi-message-draw::before {\r\n  content: \"\\F0363\";\r\n}\r\n\r\n.mdi-message-flash::before {\r\n  content: \"\\F15A9\";\r\n}\r\n\r\n.mdi-message-flash-outline::before {\r\n  content: \"\\F15AA\";\r\n}\r\n\r\n.mdi-message-image::before {\r\n  content: \"\\F0364\";\r\n}\r\n\r\n.mdi-message-image-outline::before {\r\n  content: \"\\F116C\";\r\n}\r\n\r\n.mdi-message-lock::before {\r\n  content: \"\\F0FCC\";\r\n}\r\n\r\n.mdi-message-lock-outline::before {\r\n  content: \"\\F116D\";\r\n}\r\n\r\n.mdi-message-minus::before {\r\n  content: \"\\F116E\";\r\n}\r\n\r\n.mdi-message-minus-outline::before {\r\n  content: \"\\F116F\";\r\n}\r\n\r\n.mdi-message-off::before {\r\n  content: \"\\F164D\";\r\n}\r\n\r\n.mdi-message-off-outline::before {\r\n  content: \"\\F164E\";\r\n}\r\n\r\n.mdi-message-outline::before {\r\n  content: \"\\F0365\";\r\n}\r\n\r\n.mdi-message-plus::before {\r\n  content: \"\\F0653\";\r\n}\r\n\r\n.mdi-message-plus-outline::before {\r\n  content: \"\\F10BB\";\r\n}\r\n\r\n.mdi-message-processing::before {\r\n  content: \"\\F0366\";\r\n}\r\n\r\n.mdi-message-processing-outline::before {\r\n  content: \"\\F1170\";\r\n}\r\n\r\n.mdi-message-question::before {\r\n  content: \"\\F173A\";\r\n}\r\n\r\n.mdi-message-question-outline::before {\r\n  content: \"\\F173B\";\r\n}\r\n\r\n.mdi-message-reply::before {\r\n  content: \"\\F0367\";\r\n}\r\n\r\n.mdi-message-reply-outline::before {\r\n  content: \"\\F173D\";\r\n}\r\n\r\n.mdi-message-reply-text::before {\r\n  content: \"\\F0368\";\r\n}\r\n\r\n.mdi-message-reply-text-outline::before {\r\n  content: \"\\F173E\";\r\n}\r\n\r\n.mdi-message-settings::before {\r\n  content: \"\\F06F0\";\r\n}\r\n\r\n.mdi-message-settings-outline::before {\r\n  content: \"\\F1171\";\r\n}\r\n\r\n.mdi-message-star::before {\r\n  content: \"\\F069A\";\r\n}\r\n\r\n.mdi-message-star-outline::before {\r\n  content: \"\\F1250\";\r\n}\r\n\r\n.mdi-message-text::before {\r\n  content: \"\\F0369\";\r\n}\r\n\r\n.mdi-message-text-clock::before {\r\n  content: \"\\F1173\";\r\n}\r\n\r\n.mdi-message-text-clock-outline::before {\r\n  content: \"\\F1174\";\r\n}\r\n\r\n.mdi-message-text-lock::before {\r\n  content: \"\\F0FCD\";\r\n}\r\n\r\n.mdi-message-text-lock-outline::before {\r\n  content: \"\\F1175\";\r\n}\r\n\r\n.mdi-message-text-outline::before {\r\n  content: \"\\F036A\";\r\n}\r\n\r\n.mdi-message-video::before {\r\n  content: \"\\F036B\";\r\n}\r\n\r\n.mdi-meteor::before {\r\n  content: \"\\F0629\";\r\n}\r\n\r\n.mdi-metronome::before {\r\n  content: \"\\F07DA\";\r\n}\r\n\r\n.mdi-metronome-tick::before {\r\n  content: \"\\F07DB\";\r\n}\r\n\r\n.mdi-micro-sd::before {\r\n  content: \"\\F07DC\";\r\n}\r\n\r\n.mdi-microphone::before {\r\n  content: \"\\F036C\";\r\n}\r\n\r\n.mdi-microphone-minus::before {\r\n  content: \"\\F08B3\";\r\n}\r\n\r\n.mdi-microphone-off::before {\r\n  content: \"\\F036D\";\r\n}\r\n\r\n.mdi-microphone-outline::before {\r\n  content: \"\\F036E\";\r\n}\r\n\r\n.mdi-microphone-plus::before {\r\n  content: \"\\F08B4\";\r\n}\r\n\r\n.mdi-microphone-question::before {\r\n  content: \"\\F1989\";\r\n}\r\n\r\n.mdi-microphone-question-outline::before {\r\n  content: \"\\F198A\";\r\n}\r\n\r\n.mdi-microphone-settings::before {\r\n  content: \"\\F036F\";\r\n}\r\n\r\n.mdi-microphone-variant::before {\r\n  content: \"\\F0370\";\r\n}\r\n\r\n.mdi-microphone-variant-off::before {\r\n  content: \"\\F0371\";\r\n}\r\n\r\n.mdi-microscope::before {\r\n  content: \"\\F0654\";\r\n}\r\n\r\n.mdi-microsoft::before {\r\n  content: \"\\F0372\";\r\n}\r\n\r\n.mdi-microsoft-access::before {\r\n  content: \"\\F138E\";\r\n}\r\n\r\n.mdi-microsoft-azure::before {\r\n  content: \"\\F0805\";\r\n}\r\n\r\n.mdi-microsoft-azure-devops::before {\r\n  content: \"\\F0FD5\";\r\n}\r\n\r\n.mdi-microsoft-bing::before {\r\n  content: \"\\F00A4\";\r\n}\r\n\r\n.mdi-microsoft-dynamics-365::before {\r\n  content: \"\\F0988\";\r\n}\r\n\r\n.mdi-microsoft-edge::before {\r\n  content: \"\\F01E9\";\r\n}\r\n\r\n.mdi-microsoft-excel::before {\r\n  content: \"\\F138F\";\r\n}\r\n\r\n.mdi-microsoft-internet-explorer::before {\r\n  content: \"\\F0300\";\r\n}\r\n\r\n.mdi-microsoft-office::before {\r\n  content: \"\\F03C6\";\r\n}\r\n\r\n.mdi-microsoft-onedrive::before {\r\n  content: \"\\F03CA\";\r\n}\r\n\r\n.mdi-microsoft-onenote::before {\r\n  content: \"\\F0747\";\r\n}\r\n\r\n.mdi-microsoft-outlook::before {\r\n  content: \"\\F0D22\";\r\n}\r\n\r\n.mdi-microsoft-powerpoint::before {\r\n  content: \"\\F1390\";\r\n}\r\n\r\n.mdi-microsoft-sharepoint::before {\r\n  content: \"\\F1391\";\r\n}\r\n\r\n.mdi-microsoft-teams::before {\r\n  content: \"\\F02BB\";\r\n}\r\n\r\n.mdi-microsoft-visual-studio::before {\r\n  content: \"\\F0610\";\r\n}\r\n\r\n.mdi-microsoft-visual-studio-code::before {\r\n  content: \"\\F0A1E\";\r\n}\r\n\r\n.mdi-microsoft-windows::before {\r\n  content: \"\\F05B3\";\r\n}\r\n\r\n.mdi-microsoft-windows-classic::before {\r\n  content: \"\\F0A21\";\r\n}\r\n\r\n.mdi-microsoft-word::before {\r\n  content: \"\\F1392\";\r\n}\r\n\r\n.mdi-microsoft-xbox::before {\r\n  content: \"\\F05B9\";\r\n}\r\n\r\n.mdi-microsoft-xbox-controller::before {\r\n  content: \"\\F05BA\";\r\n}\r\n\r\n.mdi-microsoft-xbox-controller-battery-alert::before {\r\n  content: \"\\F074B\";\r\n}\r\n\r\n.mdi-microsoft-xbox-controller-battery-charging::before {\r\n  content: \"\\F0A22\";\r\n}\r\n\r\n.mdi-microsoft-xbox-controller-battery-empty::before {\r\n  content: \"\\F074C\";\r\n}\r\n\r\n.mdi-microsoft-xbox-controller-battery-full::before {\r\n  content: \"\\F074D\";\r\n}\r\n\r\n.mdi-microsoft-xbox-controller-battery-low::before {\r\n  content: \"\\F074E\";\r\n}\r\n\r\n.mdi-microsoft-xbox-controller-battery-medium::before {\r\n  content: \"\\F074F\";\r\n}\r\n\r\n.mdi-microsoft-xbox-controller-battery-unknown::before {\r\n  content: \"\\F0750\";\r\n}\r\n\r\n.mdi-microsoft-xbox-controller-menu::before {\r\n  content: \"\\F0E6F\";\r\n}\r\n\r\n.mdi-microsoft-xbox-controller-off::before {\r\n  content: \"\\F05BB\";\r\n}\r\n\r\n.mdi-microsoft-xbox-controller-view::before {\r\n  content: \"\\F0E70\";\r\n}\r\n\r\n.mdi-microwave::before {\r\n  content: \"\\F0C99\";\r\n}\r\n\r\n.mdi-microwave-off::before {\r\n  content: \"\\F1423\";\r\n}\r\n\r\n.mdi-middleware::before {\r\n  content: \"\\F0F5D\";\r\n}\r\n\r\n.mdi-middleware-outline::before {\r\n  content: \"\\F0F5E\";\r\n}\r\n\r\n.mdi-midi::before {\r\n  content: \"\\F08F1\";\r\n}\r\n\r\n.mdi-midi-port::before {\r\n  content: \"\\F08F2\";\r\n}\r\n\r\n.mdi-mine::before {\r\n  content: \"\\F0DDA\";\r\n}\r\n\r\n.mdi-minecraft::before {\r\n  content: \"\\F0373\";\r\n}\r\n\r\n.mdi-mini-sd::before {\r\n  content: \"\\F0A05\";\r\n}\r\n\r\n.mdi-minidisc::before {\r\n  content: \"\\F0A06\";\r\n}\r\n\r\n.mdi-minus::before {\r\n  content: \"\\F0374\";\r\n}\r\n\r\n.mdi-minus-box::before {\r\n  content: \"\\F0375\";\r\n}\r\n\r\n.mdi-minus-box-multiple::before {\r\n  content: \"\\F1141\";\r\n}\r\n\r\n.mdi-minus-box-multiple-outline::before {\r\n  content: \"\\F1142\";\r\n}\r\n\r\n.mdi-minus-box-outline::before {\r\n  content: \"\\F06F2\";\r\n}\r\n\r\n.mdi-minus-circle::before {\r\n  content: \"\\F0376\";\r\n}\r\n\r\n.mdi-minus-circle-multiple::before {\r\n  content: \"\\F035A\";\r\n}\r\n\r\n.mdi-minus-circle-multiple-outline::before {\r\n  content: \"\\F0AD3\";\r\n}\r\n\r\n.mdi-minus-circle-off::before {\r\n  content: \"\\F1459\";\r\n}\r\n\r\n.mdi-minus-circle-off-outline::before {\r\n  content: \"\\F145A\";\r\n}\r\n\r\n.mdi-minus-circle-outline::before {\r\n  content: \"\\F0377\";\r\n}\r\n\r\n.mdi-minus-network::before {\r\n  content: \"\\F0378\";\r\n}\r\n\r\n.mdi-minus-network-outline::before {\r\n  content: \"\\F0C9A\";\r\n}\r\n\r\n.mdi-minus-thick::before {\r\n  content: \"\\F1639\";\r\n}\r\n\r\n.mdi-mirror::before {\r\n  content: \"\\F11FD\";\r\n}\r\n\r\n.mdi-mirror-rectangle::before {\r\n  content: \"\\F179F\";\r\n}\r\n\r\n.mdi-mirror-variant::before {\r\n  content: \"\\F17A0\";\r\n}\r\n\r\n.mdi-mixed-martial-arts::before {\r\n  content: \"\\F0D8F\";\r\n}\r\n\r\n.mdi-mixed-reality::before {\r\n  content: \"\\F087F\";\r\n}\r\n\r\n.mdi-molecule::before {\r\n  content: \"\\F0BAC\";\r\n}\r\n\r\n.mdi-molecule-co::before {\r\n  content: \"\\F12FE\";\r\n}\r\n\r\n.mdi-molecule-co2::before {\r\n  content: \"\\F07E4\";\r\n}\r\n\r\n.mdi-monitor::before {\r\n  content: \"\\F0379\";\r\n}\r\n\r\n.mdi-monitor-cellphone::before {\r\n  content: \"\\F0989\";\r\n}\r\n\r\n.mdi-monitor-cellphone-star::before {\r\n  content: \"\\F098A\";\r\n}\r\n\r\n.mdi-monitor-dashboard::before {\r\n  content: \"\\F0A07\";\r\n}\r\n\r\n.mdi-monitor-edit::before {\r\n  content: \"\\F12C6\";\r\n}\r\n\r\n.mdi-monitor-eye::before {\r\n  content: \"\\F13B4\";\r\n}\r\n\r\n.mdi-monitor-lock::before {\r\n  content: \"\\F0DDB\";\r\n}\r\n\r\n.mdi-monitor-multiple::before {\r\n  content: \"\\F037A\";\r\n}\r\n\r\n.mdi-monitor-off::before {\r\n  content: \"\\F0D90\";\r\n}\r\n\r\n.mdi-monitor-screenshot::before {\r\n  content: \"\\F0E51\";\r\n}\r\n\r\n.mdi-monitor-share::before {\r\n  content: \"\\F1483\";\r\n}\r\n\r\n.mdi-monitor-shimmer::before {\r\n  content: \"\\F1104\";\r\n}\r\n\r\n.mdi-monitor-small::before {\r\n  content: \"\\F1876\";\r\n}\r\n\r\n.mdi-monitor-speaker::before {\r\n  content: \"\\F0F5F\";\r\n}\r\n\r\n.mdi-monitor-speaker-off::before {\r\n  content: \"\\F0F60\";\r\n}\r\n\r\n.mdi-monitor-star::before {\r\n  content: \"\\F0DDC\";\r\n}\r\n\r\n.mdi-moon-first-quarter::before {\r\n  content: \"\\F0F61\";\r\n}\r\n\r\n.mdi-moon-full::before {\r\n  content: \"\\F0F62\";\r\n}\r\n\r\n.mdi-moon-last-quarter::before {\r\n  content: \"\\F0F63\";\r\n}\r\n\r\n.mdi-moon-new::before {\r\n  content: \"\\F0F64\";\r\n}\r\n\r\n.mdi-moon-waning-crescent::before {\r\n  content: \"\\F0F65\";\r\n}\r\n\r\n.mdi-moon-waning-gibbous::before {\r\n  content: \"\\F0F66\";\r\n}\r\n\r\n.mdi-moon-waxing-crescent::before {\r\n  content: \"\\F0F67\";\r\n}\r\n\r\n.mdi-moon-waxing-gibbous::before {\r\n  content: \"\\F0F68\";\r\n}\r\n\r\n.mdi-moped::before {\r\n  content: \"\\F1086\";\r\n}\r\n\r\n.mdi-moped-electric::before {\r\n  content: \"\\F15B7\";\r\n}\r\n\r\n.mdi-moped-electric-outline::before {\r\n  content: \"\\F15B8\";\r\n}\r\n\r\n.mdi-moped-outline::before {\r\n  content: \"\\F15B9\";\r\n}\r\n\r\n.mdi-more::before {\r\n  content: \"\\F037B\";\r\n}\r\n\r\n.mdi-mortar-pestle::before {\r\n  content: \"\\F1748\";\r\n}\r\n\r\n.mdi-mortar-pestle-plus::before {\r\n  content: \"\\F03F1\";\r\n}\r\n\r\n.mdi-mosque::before {\r\n  content: \"\\F1827\";\r\n}\r\n\r\n.mdi-mother-heart::before {\r\n  content: \"\\F1314\";\r\n}\r\n\r\n.mdi-mother-nurse::before {\r\n  content: \"\\F0D21\";\r\n}\r\n\r\n.mdi-motion::before {\r\n  content: \"\\F15B2\";\r\n}\r\n\r\n.mdi-motion-outline::before {\r\n  content: \"\\F15B3\";\r\n}\r\n\r\n.mdi-motion-pause::before {\r\n  content: \"\\F1590\";\r\n}\r\n\r\n.mdi-motion-pause-outline::before {\r\n  content: \"\\F1592\";\r\n}\r\n\r\n.mdi-motion-play::before {\r\n  content: \"\\F158F\";\r\n}\r\n\r\n.mdi-motion-play-outline::before {\r\n  content: \"\\F1591\";\r\n}\r\n\r\n.mdi-motion-sensor::before {\r\n  content: \"\\F0D91\";\r\n}\r\n\r\n.mdi-motion-sensor-off::before {\r\n  content: \"\\F1435\";\r\n}\r\n\r\n.mdi-motorbike::before {\r\n  content: \"\\F037C\";\r\n}\r\n\r\n.mdi-motorbike-electric::before {\r\n  content: \"\\F15BA\";\r\n}\r\n\r\n.mdi-mouse::before {\r\n  content: \"\\F037D\";\r\n}\r\n\r\n.mdi-mouse-bluetooth::before {\r\n  content: \"\\F098B\";\r\n}\r\n\r\n.mdi-mouse-move-down::before {\r\n  content: \"\\F1550\";\r\n}\r\n\r\n.mdi-mouse-move-up::before {\r\n  content: \"\\F1551\";\r\n}\r\n\r\n.mdi-mouse-move-vertical::before {\r\n  content: \"\\F1552\";\r\n}\r\n\r\n.mdi-mouse-off::before {\r\n  content: \"\\F037E\";\r\n}\r\n\r\n.mdi-mouse-variant::before {\r\n  content: \"\\F037F\";\r\n}\r\n\r\n.mdi-mouse-variant-off::before {\r\n  content: \"\\F0380\";\r\n}\r\n\r\n.mdi-move-resize::before {\r\n  content: \"\\F0655\";\r\n}\r\n\r\n.mdi-move-resize-variant::before {\r\n  content: \"\\F0656\";\r\n}\r\n\r\n.mdi-movie::before {\r\n  content: \"\\F0381\";\r\n}\r\n\r\n.mdi-movie-check::before {\r\n  content: \"\\F16F3\";\r\n}\r\n\r\n.mdi-movie-check-outline::before {\r\n  content: \"\\F16F4\";\r\n}\r\n\r\n.mdi-movie-cog::before {\r\n  content: \"\\F16F5\";\r\n}\r\n\r\n.mdi-movie-cog-outline::before {\r\n  content: \"\\F16F6\";\r\n}\r\n\r\n.mdi-movie-edit::before {\r\n  content: \"\\F1122\";\r\n}\r\n\r\n.mdi-movie-edit-outline::before {\r\n  content: \"\\F1123\";\r\n}\r\n\r\n.mdi-movie-filter::before {\r\n  content: \"\\F1124\";\r\n}\r\n\r\n.mdi-movie-filter-outline::before {\r\n  content: \"\\F1125\";\r\n}\r\n\r\n.mdi-movie-minus::before {\r\n  content: \"\\F16F7\";\r\n}\r\n\r\n.mdi-movie-minus-outline::before {\r\n  content: \"\\F16F8\";\r\n}\r\n\r\n.mdi-movie-off::before {\r\n  content: \"\\F16F9\";\r\n}\r\n\r\n.mdi-movie-off-outline::before {\r\n  content: \"\\F16FA\";\r\n}\r\n\r\n.mdi-movie-open::before {\r\n  content: \"\\F0FCE\";\r\n}\r\n\r\n.mdi-movie-open-check::before {\r\n  content: \"\\F16FB\";\r\n}\r\n\r\n.mdi-movie-open-check-outline::before {\r\n  content: \"\\F16FC\";\r\n}\r\n\r\n.mdi-movie-open-cog::before {\r\n  content: \"\\F16FD\";\r\n}\r\n\r\n.mdi-movie-open-cog-outline::before {\r\n  content: \"\\F16FE\";\r\n}\r\n\r\n.mdi-movie-open-edit::before {\r\n  content: \"\\F16FF\";\r\n}\r\n\r\n.mdi-movie-open-edit-outline::before {\r\n  content: \"\\F1700\";\r\n}\r\n\r\n.mdi-movie-open-minus::before {\r\n  content: \"\\F1701\";\r\n}\r\n\r\n.mdi-movie-open-minus-outline::before {\r\n  content: \"\\F1702\";\r\n}\r\n\r\n.mdi-movie-open-off::before {\r\n  content: \"\\F1703\";\r\n}\r\n\r\n.mdi-movie-open-off-outline::before {\r\n  content: \"\\F1704\";\r\n}\r\n\r\n.mdi-movie-open-outline::before {\r\n  content: \"\\F0FCF\";\r\n}\r\n\r\n.mdi-movie-open-play::before {\r\n  content: \"\\F1705\";\r\n}\r\n\r\n.mdi-movie-open-play-outline::before {\r\n  content: \"\\F1706\";\r\n}\r\n\r\n.mdi-movie-open-plus::before {\r\n  content: \"\\F1707\";\r\n}\r\n\r\n.mdi-movie-open-plus-outline::before {\r\n  content: \"\\F1708\";\r\n}\r\n\r\n.mdi-movie-open-remove::before {\r\n  content: \"\\F1709\";\r\n}\r\n\r\n.mdi-movie-open-remove-outline::before {\r\n  content: \"\\F170A\";\r\n}\r\n\r\n.mdi-movie-open-settings::before {\r\n  content: \"\\F170B\";\r\n}\r\n\r\n.mdi-movie-open-settings-outline::before {\r\n  content: \"\\F170C\";\r\n}\r\n\r\n.mdi-movie-open-star::before {\r\n  content: \"\\F170D\";\r\n}\r\n\r\n.mdi-movie-open-star-outline::before {\r\n  content: \"\\F170E\";\r\n}\r\n\r\n.mdi-movie-outline::before {\r\n  content: \"\\F0DDD\";\r\n}\r\n\r\n.mdi-movie-play::before {\r\n  content: \"\\F170F\";\r\n}\r\n\r\n.mdi-movie-play-outline::before {\r\n  content: \"\\F1710\";\r\n}\r\n\r\n.mdi-movie-plus::before {\r\n  content: \"\\F1711\";\r\n}\r\n\r\n.mdi-movie-plus-outline::before {\r\n  content: \"\\F1712\";\r\n}\r\n\r\n.mdi-movie-remove::before {\r\n  content: \"\\F1713\";\r\n}\r\n\r\n.mdi-movie-remove-outline::before {\r\n  content: \"\\F1714\";\r\n}\r\n\r\n.mdi-movie-roll::before {\r\n  content: \"\\F07DE\";\r\n}\r\n\r\n.mdi-movie-search::before {\r\n  content: \"\\F11D2\";\r\n}\r\n\r\n.mdi-movie-search-outline::before {\r\n  content: \"\\F11D3\";\r\n}\r\n\r\n.mdi-movie-settings::before {\r\n  content: \"\\F1715\";\r\n}\r\n\r\n.mdi-movie-settings-outline::before {\r\n  content: \"\\F1716\";\r\n}\r\n\r\n.mdi-movie-star::before {\r\n  content: \"\\F1717\";\r\n}\r\n\r\n.mdi-movie-star-outline::before {\r\n  content: \"\\F1718\";\r\n}\r\n\r\n.mdi-mower::before {\r\n  content: \"\\F166F\";\r\n}\r\n\r\n.mdi-mower-bag::before {\r\n  content: \"\\F1670\";\r\n}\r\n\r\n.mdi-muffin::before {\r\n  content: \"\\F098C\";\r\n}\r\n\r\n.mdi-multicast::before {\r\n  content: \"\\F1893\";\r\n}\r\n\r\n.mdi-multiplication::before {\r\n  content: \"\\F0382\";\r\n}\r\n\r\n.mdi-multiplication-box::before {\r\n  content: \"\\F0383\";\r\n}\r\n\r\n.mdi-mushroom::before {\r\n  content: \"\\F07DF\";\r\n}\r\n\r\n.mdi-mushroom-off::before {\r\n  content: \"\\F13FA\";\r\n}\r\n\r\n.mdi-mushroom-off-outline::before {\r\n  content: \"\\F13FB\";\r\n}\r\n\r\n.mdi-mushroom-outline::before {\r\n  content: \"\\F07E0\";\r\n}\r\n\r\n.mdi-music::before {\r\n  content: \"\\F075A\";\r\n}\r\n\r\n.mdi-music-accidental-double-flat::before {\r\n  content: \"\\F0F69\";\r\n}\r\n\r\n.mdi-music-accidental-double-sharp::before {\r\n  content: \"\\F0F6A\";\r\n}\r\n\r\n.mdi-music-accidental-flat::before {\r\n  content: \"\\F0F6B\";\r\n}\r\n\r\n.mdi-music-accidental-natural::before {\r\n  content: \"\\F0F6C\";\r\n}\r\n\r\n.mdi-music-accidental-sharp::before {\r\n  content: \"\\F0F6D\";\r\n}\r\n\r\n.mdi-music-box::before {\r\n  content: \"\\F0384\";\r\n}\r\n\r\n.mdi-music-box-multiple::before {\r\n  content: \"\\F0333\";\r\n}\r\n\r\n.mdi-music-box-multiple-outline::before {\r\n  content: \"\\F0F04\";\r\n}\r\n\r\n.mdi-music-box-outline::before {\r\n  content: \"\\F0385\";\r\n}\r\n\r\n.mdi-music-circle::before {\r\n  content: \"\\F0386\";\r\n}\r\n\r\n.mdi-music-circle-outline::before {\r\n  content: \"\\F0AD4\";\r\n}\r\n\r\n.mdi-music-clef-alto::before {\r\n  content: \"\\F0F6E\";\r\n}\r\n\r\n.mdi-music-clef-bass::before {\r\n  content: \"\\F0F6F\";\r\n}\r\n\r\n.mdi-music-clef-treble::before {\r\n  content: \"\\F0F70\";\r\n}\r\n\r\n.mdi-music-note::before {\r\n  content: \"\\F0387\";\r\n}\r\n\r\n.mdi-music-note-bluetooth::before {\r\n  content: \"\\F05FE\";\r\n}\r\n\r\n.mdi-music-note-bluetooth-off::before {\r\n  content: \"\\F05FF\";\r\n}\r\n\r\n.mdi-music-note-eighth::before {\r\n  content: \"\\F0388\";\r\n}\r\n\r\n.mdi-music-note-eighth-dotted::before {\r\n  content: \"\\F0F71\";\r\n}\r\n\r\n.mdi-music-note-half::before {\r\n  content: \"\\F0389\";\r\n}\r\n\r\n.mdi-music-note-half-dotted::before {\r\n  content: \"\\F0F72\";\r\n}\r\n\r\n.mdi-music-note-off::before {\r\n  content: \"\\F038A\";\r\n}\r\n\r\n.mdi-music-note-off-outline::before {\r\n  content: \"\\F0F73\";\r\n}\r\n\r\n.mdi-music-note-outline::before {\r\n  content: \"\\F0F74\";\r\n}\r\n\r\n.mdi-music-note-plus::before {\r\n  content: \"\\F0DDE\";\r\n}\r\n\r\n.mdi-music-note-quarter::before {\r\n  content: \"\\F038B\";\r\n}\r\n\r\n.mdi-music-note-quarter-dotted::before {\r\n  content: \"\\F0F75\";\r\n}\r\n\r\n.mdi-music-note-sixteenth::before {\r\n  content: \"\\F038C\";\r\n}\r\n\r\n.mdi-music-note-sixteenth-dotted::before {\r\n  content: \"\\F0F76\";\r\n}\r\n\r\n.mdi-music-note-whole::before {\r\n  content: \"\\F038D\";\r\n}\r\n\r\n.mdi-music-note-whole-dotted::before {\r\n  content: \"\\F0F77\";\r\n}\r\n\r\n.mdi-music-off::before {\r\n  content: \"\\F075B\";\r\n}\r\n\r\n.mdi-music-rest-eighth::before {\r\n  content: \"\\F0F78\";\r\n}\r\n\r\n.mdi-music-rest-half::before {\r\n  content: \"\\F0F79\";\r\n}\r\n\r\n.mdi-music-rest-quarter::before {\r\n  content: \"\\F0F7A\";\r\n}\r\n\r\n.mdi-music-rest-sixteenth::before {\r\n  content: \"\\F0F7B\";\r\n}\r\n\r\n.mdi-music-rest-whole::before {\r\n  content: \"\\F0F7C\";\r\n}\r\n\r\n.mdi-mustache::before {\r\n  content: \"\\F15DE\";\r\n}\r\n\r\n.mdi-nail::before {\r\n  content: \"\\F0DDF\";\r\n}\r\n\r\n.mdi-nas::before {\r\n  content: \"\\F08F3\";\r\n}\r\n\r\n.mdi-nativescript::before {\r\n  content: \"\\F0880\";\r\n}\r\n\r\n.mdi-nature::before {\r\n  content: \"\\F038E\";\r\n}\r\n\r\n.mdi-nature-people::before {\r\n  content: \"\\F038F\";\r\n}\r\n\r\n.mdi-navigation::before {\r\n  content: \"\\F0390\";\r\n}\r\n\r\n.mdi-navigation-outline::before {\r\n  content: \"\\F1607\";\r\n}\r\n\r\n.mdi-navigation-variant::before {\r\n  content: \"\\F18F0\";\r\n}\r\n\r\n.mdi-navigation-variant-outline::before {\r\n  content: \"\\F18F1\";\r\n}\r\n\r\n.mdi-near-me::before {\r\n  content: \"\\F05CD\";\r\n}\r\n\r\n.mdi-necklace::before {\r\n  content: \"\\F0F0B\";\r\n}\r\n\r\n.mdi-needle::before {\r\n  content: \"\\F0391\";\r\n}\r\n\r\n.mdi-netflix::before {\r\n  content: \"\\F0746\";\r\n}\r\n\r\n.mdi-network::before {\r\n  content: \"\\F06F3\";\r\n}\r\n\r\n.mdi-network-off::before {\r\n  content: \"\\F0C9B\";\r\n}\r\n\r\n.mdi-network-off-outline::before {\r\n  content: \"\\F0C9C\";\r\n}\r\n\r\n.mdi-network-outline::before {\r\n  content: \"\\F0C9D\";\r\n}\r\n\r\n.mdi-network-strength-1::before {\r\n  content: \"\\F08F4\";\r\n}\r\n\r\n.mdi-network-strength-1-alert::before {\r\n  content: \"\\F08F5\";\r\n}\r\n\r\n.mdi-network-strength-2::before {\r\n  content: \"\\F08F6\";\r\n}\r\n\r\n.mdi-network-strength-2-alert::before {\r\n  content: \"\\F08F7\";\r\n}\r\n\r\n.mdi-network-strength-3::before {\r\n  content: \"\\F08F8\";\r\n}\r\n\r\n.mdi-network-strength-3-alert::before {\r\n  content: \"\\F08F9\";\r\n}\r\n\r\n.mdi-network-strength-4::before {\r\n  content: \"\\F08FA\";\r\n}\r\n\r\n.mdi-network-strength-4-alert::before {\r\n  content: \"\\F08FB\";\r\n}\r\n\r\n.mdi-network-strength-4-cog::before {\r\n  content: \"\\F191A\";\r\n}\r\n\r\n.mdi-network-strength-off::before {\r\n  content: \"\\F08FC\";\r\n}\r\n\r\n.mdi-network-strength-off-outline::before {\r\n  content: \"\\F08FD\";\r\n}\r\n\r\n.mdi-network-strength-outline::before {\r\n  content: \"\\F08FE\";\r\n}\r\n\r\n.mdi-new-box::before {\r\n  content: \"\\F0394\";\r\n}\r\n\r\n.mdi-newspaper::before {\r\n  content: \"\\F0395\";\r\n}\r\n\r\n.mdi-newspaper-check::before {\r\n  content: \"\\F1943\";\r\n}\r\n\r\n.mdi-newspaper-minus::before {\r\n  content: \"\\F0F0C\";\r\n}\r\n\r\n.mdi-newspaper-plus::before {\r\n  content: \"\\F0F0D\";\r\n}\r\n\r\n.mdi-newspaper-remove::before {\r\n  content: \"\\F1944\";\r\n}\r\n\r\n.mdi-newspaper-variant::before {\r\n  content: \"\\F1001\";\r\n}\r\n\r\n.mdi-newspaper-variant-multiple::before {\r\n  content: \"\\F1002\";\r\n}\r\n\r\n.mdi-newspaper-variant-multiple-outline::before {\r\n  content: \"\\F1003\";\r\n}\r\n\r\n.mdi-newspaper-variant-outline::before {\r\n  content: \"\\F1004\";\r\n}\r\n\r\n.mdi-nfc::before {\r\n  content: \"\\F0396\";\r\n}\r\n\r\n.mdi-nfc-search-variant::before {\r\n  content: \"\\F0E53\";\r\n}\r\n\r\n.mdi-nfc-tap::before {\r\n  content: \"\\F0397\";\r\n}\r\n\r\n.mdi-nfc-variant::before {\r\n  content: \"\\F0398\";\r\n}\r\n\r\n.mdi-nfc-variant-off::before {\r\n  content: \"\\F0E54\";\r\n}\r\n\r\n.mdi-ninja::before {\r\n  content: \"\\F0774\";\r\n}\r\n\r\n.mdi-nintendo-game-boy::before {\r\n  content: \"\\F1393\";\r\n}\r\n\r\n.mdi-nintendo-switch::before {\r\n  content: \"\\F07E1\";\r\n}\r\n\r\n.mdi-nintendo-wii::before {\r\n  content: \"\\F05AB\";\r\n}\r\n\r\n.mdi-nintendo-wiiu::before {\r\n  content: \"\\F072D\";\r\n}\r\n\r\n.mdi-nix::before {\r\n  content: \"\\F1105\";\r\n}\r\n\r\n.mdi-nodejs::before {\r\n  content: \"\\F0399\";\r\n}\r\n\r\n.mdi-noodles::before {\r\n  content: \"\\F117E\";\r\n}\r\n\r\n.mdi-not-equal::before {\r\n  content: \"\\F098D\";\r\n}\r\n\r\n.mdi-not-equal-variant::before {\r\n  content: \"\\F098E\";\r\n}\r\n\r\n.mdi-note::before {\r\n  content: \"\\F039A\";\r\n}\r\n\r\n.mdi-note-alert::before {\r\n  content: \"\\F177D\";\r\n}\r\n\r\n.mdi-note-alert-outline::before {\r\n  content: \"\\F177E\";\r\n}\r\n\r\n.mdi-note-check::before {\r\n  content: \"\\F177F\";\r\n}\r\n\r\n.mdi-note-check-outline::before {\r\n  content: \"\\F1780\";\r\n}\r\n\r\n.mdi-note-edit::before {\r\n  content: \"\\F1781\";\r\n}\r\n\r\n.mdi-note-edit-outline::before {\r\n  content: \"\\F1782\";\r\n}\r\n\r\n.mdi-note-minus::before {\r\n  content: \"\\F164F\";\r\n}\r\n\r\n.mdi-note-minus-outline::before {\r\n  content: \"\\F1650\";\r\n}\r\n\r\n.mdi-note-multiple::before {\r\n  content: \"\\F06B8\";\r\n}\r\n\r\n.mdi-note-multiple-outline::before {\r\n  content: \"\\F06B9\";\r\n}\r\n\r\n.mdi-note-off::before {\r\n  content: \"\\F1783\";\r\n}\r\n\r\n.mdi-note-off-outline::before {\r\n  content: \"\\F1784\";\r\n}\r\n\r\n.mdi-note-outline::before {\r\n  content: \"\\F039B\";\r\n}\r\n\r\n.mdi-note-plus::before {\r\n  content: \"\\F039C\";\r\n}\r\n\r\n.mdi-note-plus-outline::before {\r\n  content: \"\\F039D\";\r\n}\r\n\r\n.mdi-note-remove::before {\r\n  content: \"\\F1651\";\r\n}\r\n\r\n.mdi-note-remove-outline::before {\r\n  content: \"\\F1652\";\r\n}\r\n\r\n.mdi-note-search::before {\r\n  content: \"\\F1653\";\r\n}\r\n\r\n.mdi-note-search-outline::before {\r\n  content: \"\\F1654\";\r\n}\r\n\r\n.mdi-note-text::before {\r\n  content: \"\\F039E\";\r\n}\r\n\r\n.mdi-note-text-outline::before {\r\n  content: \"\\F11D7\";\r\n}\r\n\r\n.mdi-notebook::before {\r\n  content: \"\\F082E\";\r\n}\r\n\r\n.mdi-notebook-check::before {\r\n  content: \"\\F14F5\";\r\n}\r\n\r\n.mdi-notebook-check-outline::before {\r\n  content: \"\\F14F6\";\r\n}\r\n\r\n.mdi-notebook-edit::before {\r\n  content: \"\\F14E7\";\r\n}\r\n\r\n.mdi-notebook-edit-outline::before {\r\n  content: \"\\F14E9\";\r\n}\r\n\r\n.mdi-notebook-minus::before {\r\n  content: \"\\F1610\";\r\n}\r\n\r\n.mdi-notebook-minus-outline::before {\r\n  content: \"\\F1611\";\r\n}\r\n\r\n.mdi-notebook-multiple::before {\r\n  content: \"\\F0E55\";\r\n}\r\n\r\n.mdi-notebook-outline::before {\r\n  content: \"\\F0EBF\";\r\n}\r\n\r\n.mdi-notebook-plus::before {\r\n  content: \"\\F1612\";\r\n}\r\n\r\n.mdi-notebook-plus-outline::before {\r\n  content: \"\\F1613\";\r\n}\r\n\r\n.mdi-notebook-remove::before {\r\n  content: \"\\F1614\";\r\n}\r\n\r\n.mdi-notebook-remove-outline::before {\r\n  content: \"\\F1615\";\r\n}\r\n\r\n.mdi-notification-clear-all::before {\r\n  content: \"\\F039F\";\r\n}\r\n\r\n.mdi-npm::before {\r\n  content: \"\\F06F7\";\r\n}\r\n\r\n.mdi-nuke::before {\r\n  content: \"\\F06A4\";\r\n}\r\n\r\n.mdi-null::before {\r\n  content: \"\\F07E2\";\r\n}\r\n\r\n.mdi-numeric::before {\r\n  content: \"\\F03A0\";\r\n}\r\n\r\n.mdi-numeric-0::before {\r\n  content: \"\\F0B39\";\r\n}\r\n\r\n.mdi-numeric-0-box::before {\r\n  content: \"\\F03A1\";\r\n}\r\n\r\n.mdi-numeric-0-box-multiple::before {\r\n  content: \"\\F0F0E\";\r\n}\r\n\r\n.mdi-numeric-0-box-multiple-outline::before {\r\n  content: \"\\F03A2\";\r\n}\r\n\r\n.mdi-numeric-0-box-outline::before {\r\n  content: \"\\F03A3\";\r\n}\r\n\r\n.mdi-numeric-0-circle::before {\r\n  content: \"\\F0C9E\";\r\n}\r\n\r\n.mdi-numeric-0-circle-outline::before {\r\n  content: \"\\F0C9F\";\r\n}\r\n\r\n.mdi-numeric-1::before {\r\n  content: \"\\F0B3A\";\r\n}\r\n\r\n.mdi-numeric-1-box::before {\r\n  content: \"\\F03A4\";\r\n}\r\n\r\n.mdi-numeric-1-box-multiple::before {\r\n  content: \"\\F0F0F\";\r\n}\r\n\r\n.mdi-numeric-1-box-multiple-outline::before {\r\n  content: \"\\F03A5\";\r\n}\r\n\r\n.mdi-numeric-1-box-outline::before {\r\n  content: \"\\F03A6\";\r\n}\r\n\r\n.mdi-numeric-1-circle::before {\r\n  content: \"\\F0CA0\";\r\n}\r\n\r\n.mdi-numeric-1-circle-outline::before {\r\n  content: \"\\F0CA1\";\r\n}\r\n\r\n.mdi-numeric-10::before {\r\n  content: \"\\F0FE9\";\r\n}\r\n\r\n.mdi-numeric-10-box::before {\r\n  content: \"\\F0F7D\";\r\n}\r\n\r\n.mdi-numeric-10-box-multiple::before {\r\n  content: \"\\F0FEA\";\r\n}\r\n\r\n.mdi-numeric-10-box-multiple-outline::before {\r\n  content: \"\\F0FEB\";\r\n}\r\n\r\n.mdi-numeric-10-box-outline::before {\r\n  content: \"\\F0F7E\";\r\n}\r\n\r\n.mdi-numeric-10-circle::before {\r\n  content: \"\\F0FEC\";\r\n}\r\n\r\n.mdi-numeric-10-circle-outline::before {\r\n  content: \"\\F0FED\";\r\n}\r\n\r\n.mdi-numeric-2::before {\r\n  content: \"\\F0B3B\";\r\n}\r\n\r\n.mdi-numeric-2-box::before {\r\n  content: \"\\F03A7\";\r\n}\r\n\r\n.mdi-numeric-2-box-multiple::before {\r\n  content: \"\\F0F10\";\r\n}\r\n\r\n.mdi-numeric-2-box-multiple-outline::before {\r\n  content: \"\\F03A8\";\r\n}\r\n\r\n.mdi-numeric-2-box-outline::before {\r\n  content: \"\\F03A9\";\r\n}\r\n\r\n.mdi-numeric-2-circle::before {\r\n  content: \"\\F0CA2\";\r\n}\r\n\r\n.mdi-numeric-2-circle-outline::before {\r\n  content: \"\\F0CA3\";\r\n}\r\n\r\n.mdi-numeric-3::before {\r\n  content: \"\\F0B3C\";\r\n}\r\n\r\n.mdi-numeric-3-box::before {\r\n  content: \"\\F03AA\";\r\n}\r\n\r\n.mdi-numeric-3-box-multiple::before {\r\n  content: \"\\F0F11\";\r\n}\r\n\r\n.mdi-numeric-3-box-multiple-outline::before {\r\n  content: \"\\F03AB\";\r\n}\r\n\r\n.mdi-numeric-3-box-outline::before {\r\n  content: \"\\F03AC\";\r\n}\r\n\r\n.mdi-numeric-3-circle::before {\r\n  content: \"\\F0CA4\";\r\n}\r\n\r\n.mdi-numeric-3-circle-outline::before {\r\n  content: \"\\F0CA5\";\r\n}\r\n\r\n.mdi-numeric-4::before {\r\n  content: \"\\F0B3D\";\r\n}\r\n\r\n.mdi-numeric-4-box::before {\r\n  content: \"\\F03AD\";\r\n}\r\n\r\n.mdi-numeric-4-box-multiple::before {\r\n  content: \"\\F0F12\";\r\n}\r\n\r\n.mdi-numeric-4-box-multiple-outline::before {\r\n  content: \"\\F03B2\";\r\n}\r\n\r\n.mdi-numeric-4-box-outline::before {\r\n  content: \"\\F03AE\";\r\n}\r\n\r\n.mdi-numeric-4-circle::before {\r\n  content: \"\\F0CA6\";\r\n}\r\n\r\n.mdi-numeric-4-circle-outline::before {\r\n  content: \"\\F0CA7\";\r\n}\r\n\r\n.mdi-numeric-5::before {\r\n  content: \"\\F0B3E\";\r\n}\r\n\r\n.mdi-numeric-5-box::before {\r\n  content: \"\\F03B1\";\r\n}\r\n\r\n.mdi-numeric-5-box-multiple::before {\r\n  content: \"\\F0F13\";\r\n}\r\n\r\n.mdi-numeric-5-box-multiple-outline::before {\r\n  content: \"\\F03AF\";\r\n}\r\n\r\n.mdi-numeric-5-box-outline::before {\r\n  content: \"\\F03B0\";\r\n}\r\n\r\n.mdi-numeric-5-circle::before {\r\n  content: \"\\F0CA8\";\r\n}\r\n\r\n.mdi-numeric-5-circle-outline::before {\r\n  content: \"\\F0CA9\";\r\n}\r\n\r\n.mdi-numeric-6::before {\r\n  content: \"\\F0B3F\";\r\n}\r\n\r\n.mdi-numeric-6-box::before {\r\n  content: \"\\F03B3\";\r\n}\r\n\r\n.mdi-numeric-6-box-multiple::before {\r\n  content: \"\\F0F14\";\r\n}\r\n\r\n.mdi-numeric-6-box-multiple-outline::before {\r\n  content: \"\\F03B4\";\r\n}\r\n\r\n.mdi-numeric-6-box-outline::before {\r\n  content: \"\\F03B5\";\r\n}\r\n\r\n.mdi-numeric-6-circle::before {\r\n  content: \"\\F0CAA\";\r\n}\r\n\r\n.mdi-numeric-6-circle-outline::before {\r\n  content: \"\\F0CAB\";\r\n}\r\n\r\n.mdi-numeric-7::before {\r\n  content: \"\\F0B40\";\r\n}\r\n\r\n.mdi-numeric-7-box::before {\r\n  content: \"\\F03B6\";\r\n}\r\n\r\n.mdi-numeric-7-box-multiple::before {\r\n  content: \"\\F0F15\";\r\n}\r\n\r\n.mdi-numeric-7-box-multiple-outline::before {\r\n  content: \"\\F03B7\";\r\n}\r\n\r\n.mdi-numeric-7-box-outline::before {\r\n  content: \"\\F03B8\";\r\n}\r\n\r\n.mdi-numeric-7-circle::before {\r\n  content: \"\\F0CAC\";\r\n}\r\n\r\n.mdi-numeric-7-circle-outline::before {\r\n  content: \"\\F0CAD\";\r\n}\r\n\r\n.mdi-numeric-8::before {\r\n  content: \"\\F0B41\";\r\n}\r\n\r\n.mdi-numeric-8-box::before {\r\n  content: \"\\F03B9\";\r\n}\r\n\r\n.mdi-numeric-8-box-multiple::before {\r\n  content: \"\\F0F16\";\r\n}\r\n\r\n.mdi-numeric-8-box-multiple-outline::before {\r\n  content: \"\\F03BA\";\r\n}\r\n\r\n.mdi-numeric-8-box-outline::before {\r\n  content: \"\\F03BB\";\r\n}\r\n\r\n.mdi-numeric-8-circle::before {\r\n  content: \"\\F0CAE\";\r\n}\r\n\r\n.mdi-numeric-8-circle-outline::before {\r\n  content: \"\\F0CAF\";\r\n}\r\n\r\n.mdi-numeric-9::before {\r\n  content: \"\\F0B42\";\r\n}\r\n\r\n.mdi-numeric-9-box::before {\r\n  content: \"\\F03BC\";\r\n}\r\n\r\n.mdi-numeric-9-box-multiple::before {\r\n  content: \"\\F0F17\";\r\n}\r\n\r\n.mdi-numeric-9-box-multiple-outline::before {\r\n  content: \"\\F03BD\";\r\n}\r\n\r\n.mdi-numeric-9-box-outline::before {\r\n  content: \"\\F03BE\";\r\n}\r\n\r\n.mdi-numeric-9-circle::before {\r\n  content: \"\\F0CB0\";\r\n}\r\n\r\n.mdi-numeric-9-circle-outline::before {\r\n  content: \"\\F0CB1\";\r\n}\r\n\r\n.mdi-numeric-9-plus::before {\r\n  content: \"\\F0FEE\";\r\n}\r\n\r\n.mdi-numeric-9-plus-box::before {\r\n  content: \"\\F03BF\";\r\n}\r\n\r\n.mdi-numeric-9-plus-box-multiple::before {\r\n  content: \"\\F0F18\";\r\n}\r\n\r\n.mdi-numeric-9-plus-box-multiple-outline::before {\r\n  content: \"\\F03C0\";\r\n}\r\n\r\n.mdi-numeric-9-plus-box-outline::before {\r\n  content: \"\\F03C1\";\r\n}\r\n\r\n.mdi-numeric-9-plus-circle::before {\r\n  content: \"\\F0CB2\";\r\n}\r\n\r\n.mdi-numeric-9-plus-circle-outline::before {\r\n  content: \"\\F0CB3\";\r\n}\r\n\r\n.mdi-numeric-negative-1::before {\r\n  content: \"\\F1052\";\r\n}\r\n\r\n.mdi-numeric-positive-1::before {\r\n  content: \"\\F15CB\";\r\n}\r\n\r\n.mdi-nut::before {\r\n  content: \"\\F06F8\";\r\n}\r\n\r\n.mdi-nutrition::before {\r\n  content: \"\\F03C2\";\r\n}\r\n\r\n.mdi-nuxt::before {\r\n  content: \"\\F1106\";\r\n}\r\n\r\n.mdi-oar::before {\r\n  content: \"\\F067C\";\r\n}\r\n\r\n.mdi-ocarina::before {\r\n  content: \"\\F0DE0\";\r\n}\r\n\r\n.mdi-oci::before {\r\n  content: \"\\F12E9\";\r\n}\r\n\r\n.mdi-ocr::before {\r\n  content: \"\\F113A\";\r\n}\r\n\r\n.mdi-octagon::before {\r\n  content: \"\\F03C3\";\r\n}\r\n\r\n.mdi-octagon-outline::before {\r\n  content: \"\\F03C4\";\r\n}\r\n\r\n.mdi-octagram::before {\r\n  content: \"\\F06F9\";\r\n}\r\n\r\n.mdi-octagram-outline::before {\r\n  content: \"\\F0775\";\r\n}\r\n\r\n.mdi-octahedron::before {\r\n  content: \"\\F1950\";\r\n}\r\n\r\n.mdi-octahedron-off::before {\r\n  content: \"\\F1951\";\r\n}\r\n\r\n.mdi-odnoklassniki::before {\r\n  content: \"\\F03C5\";\r\n}\r\n\r\n.mdi-offer::before {\r\n  content: \"\\F121B\";\r\n}\r\n\r\n.mdi-office-building::before {\r\n  content: \"\\F0991\";\r\n}\r\n\r\n.mdi-office-building-cog::before {\r\n  content: \"\\F1949\";\r\n}\r\n\r\n.mdi-office-building-cog-outline::before {\r\n  content: \"\\F194A\";\r\n}\r\n\r\n.mdi-office-building-marker::before {\r\n  content: \"\\F1520\";\r\n}\r\n\r\n.mdi-office-building-marker-outline::before {\r\n  content: \"\\F1521\";\r\n}\r\n\r\n.mdi-office-building-outline::before {\r\n  content: \"\\F151F\";\r\n}\r\n\r\n.mdi-oil::before {\r\n  content: \"\\F03C7\";\r\n}\r\n\r\n.mdi-oil-lamp::before {\r\n  content: \"\\F0F19\";\r\n}\r\n\r\n.mdi-oil-level::before {\r\n  content: \"\\F1053\";\r\n}\r\n\r\n.mdi-oil-temperature::before {\r\n  content: \"\\F0FF8\";\r\n}\r\n\r\n.mdi-om::before {\r\n  content: \"\\F0973\";\r\n}\r\n\r\n.mdi-omega::before {\r\n  content: \"\\F03C9\";\r\n}\r\n\r\n.mdi-one-up::before {\r\n  content: \"\\F0BAD\";\r\n}\r\n\r\n.mdi-onepassword::before {\r\n  content: \"\\F0881\";\r\n}\r\n\r\n.mdi-opacity::before {\r\n  content: \"\\F05CC\";\r\n}\r\n\r\n.mdi-open-in-app::before {\r\n  content: \"\\F03CB\";\r\n}\r\n\r\n.mdi-open-in-new::before {\r\n  content: \"\\F03CC\";\r\n}\r\n\r\n.mdi-open-source-initiative::before {\r\n  content: \"\\F0BAE\";\r\n}\r\n\r\n.mdi-openid::before {\r\n  content: \"\\F03CD\";\r\n}\r\n\r\n.mdi-opera::before {\r\n  content: \"\\F03CE\";\r\n}\r\n\r\n.mdi-orbit::before {\r\n  content: \"\\F0018\";\r\n}\r\n\r\n.mdi-orbit-variant::before {\r\n  content: \"\\F15DB\";\r\n}\r\n\r\n.mdi-order-alphabetical-ascending::before {\r\n  content: \"\\F020D\";\r\n}\r\n\r\n.mdi-order-alphabetical-descending::before {\r\n  content: \"\\F0D07\";\r\n}\r\n\r\n.mdi-order-bool-ascending::before {\r\n  content: \"\\F02BE\";\r\n}\r\n\r\n.mdi-order-bool-ascending-variant::before {\r\n  content: \"\\F098F\";\r\n}\r\n\r\n.mdi-order-bool-descending::before {\r\n  content: \"\\F1384\";\r\n}\r\n\r\n.mdi-order-bool-descending-variant::before {\r\n  content: \"\\F0990\";\r\n}\r\n\r\n.mdi-order-numeric-ascending::before {\r\n  content: \"\\F0545\";\r\n}\r\n\r\n.mdi-order-numeric-descending::before {\r\n  content: \"\\F0546\";\r\n}\r\n\r\n.mdi-origin::before {\r\n  content: \"\\F0B43\";\r\n}\r\n\r\n.mdi-ornament::before {\r\n  content: \"\\F03CF\";\r\n}\r\n\r\n.mdi-ornament-variant::before {\r\n  content: \"\\F03D0\";\r\n}\r\n\r\n.mdi-outdoor-lamp::before {\r\n  content: \"\\F1054\";\r\n}\r\n\r\n.mdi-overscan::before {\r\n  content: \"\\F1005\";\r\n}\r\n\r\n.mdi-owl::before {\r\n  content: \"\\F03D2\";\r\n}\r\n\r\n.mdi-pac-man::before {\r\n  content: \"\\F0BAF\";\r\n}\r\n\r\n.mdi-package::before {\r\n  content: \"\\F03D3\";\r\n}\r\n\r\n.mdi-package-down::before {\r\n  content: \"\\F03D4\";\r\n}\r\n\r\n.mdi-package-up::before {\r\n  content: \"\\F03D5\";\r\n}\r\n\r\n.mdi-package-variant::before {\r\n  content: \"\\F03D6\";\r\n}\r\n\r\n.mdi-package-variant-closed::before {\r\n  content: \"\\F03D7\";\r\n}\r\n\r\n.mdi-page-first::before {\r\n  content: \"\\F0600\";\r\n}\r\n\r\n.mdi-page-last::before {\r\n  content: \"\\F0601\";\r\n}\r\n\r\n.mdi-page-layout-body::before {\r\n  content: \"\\F06FA\";\r\n}\r\n\r\n.mdi-page-layout-footer::before {\r\n  content: \"\\F06FB\";\r\n}\r\n\r\n.mdi-page-layout-header::before {\r\n  content: \"\\F06FC\";\r\n}\r\n\r\n.mdi-page-layout-header-footer::before {\r\n  content: \"\\F0F7F\";\r\n}\r\n\r\n.mdi-page-layout-sidebar-left::before {\r\n  content: \"\\F06FD\";\r\n}\r\n\r\n.mdi-page-layout-sidebar-right::before {\r\n  content: \"\\F06FE\";\r\n}\r\n\r\n.mdi-page-next::before {\r\n  content: \"\\F0BB0\";\r\n}\r\n\r\n.mdi-page-next-outline::before {\r\n  content: \"\\F0BB1\";\r\n}\r\n\r\n.mdi-page-previous::before {\r\n  content: \"\\F0BB2\";\r\n}\r\n\r\n.mdi-page-previous-outline::before {\r\n  content: \"\\F0BB3\";\r\n}\r\n\r\n.mdi-pail::before {\r\n  content: \"\\F1417\";\r\n}\r\n\r\n.mdi-pail-minus::before {\r\n  content: \"\\F1437\";\r\n}\r\n\r\n.mdi-pail-minus-outline::before {\r\n  content: \"\\F143C\";\r\n}\r\n\r\n.mdi-pail-off::before {\r\n  content: \"\\F1439\";\r\n}\r\n\r\n.mdi-pail-off-outline::before {\r\n  content: \"\\F143E\";\r\n}\r\n\r\n.mdi-pail-outline::before {\r\n  content: \"\\F143A\";\r\n}\r\n\r\n.mdi-pail-plus::before {\r\n  content: \"\\F1436\";\r\n}\r\n\r\n.mdi-pail-plus-outline::before {\r\n  content: \"\\F143B\";\r\n}\r\n\r\n.mdi-pail-remove::before {\r\n  content: \"\\F1438\";\r\n}\r\n\r\n.mdi-pail-remove-outline::before {\r\n  content: \"\\F143D\";\r\n}\r\n\r\n.mdi-palette::before {\r\n  content: \"\\F03D8\";\r\n}\r\n\r\n.mdi-palette-advanced::before {\r\n  content: \"\\F03D9\";\r\n}\r\n\r\n.mdi-palette-outline::before {\r\n  content: \"\\F0E0C\";\r\n}\r\n\r\n.mdi-palette-swatch::before {\r\n  content: \"\\F08B5\";\r\n}\r\n\r\n.mdi-palette-swatch-outline::before {\r\n  content: \"\\F135C\";\r\n}\r\n\r\n.mdi-palette-swatch-variant::before {\r\n  content: \"\\F195A\";\r\n}\r\n\r\n.mdi-palm-tree::before {\r\n  content: \"\\F1055\";\r\n}\r\n\r\n.mdi-pan::before {\r\n  content: \"\\F0BB4\";\r\n}\r\n\r\n.mdi-pan-bottom-left::before {\r\n  content: \"\\F0BB5\";\r\n}\r\n\r\n.mdi-pan-bottom-right::before {\r\n  content: \"\\F0BB6\";\r\n}\r\n\r\n.mdi-pan-down::before {\r\n  content: \"\\F0BB7\";\r\n}\r\n\r\n.mdi-pan-horizontal::before {\r\n  content: \"\\F0BB8\";\r\n}\r\n\r\n.mdi-pan-left::before {\r\n  content: \"\\F0BB9\";\r\n}\r\n\r\n.mdi-pan-right::before {\r\n  content: \"\\F0BBA\";\r\n}\r\n\r\n.mdi-pan-top-left::before {\r\n  content: \"\\F0BBB\";\r\n}\r\n\r\n.mdi-pan-top-right::before {\r\n  content: \"\\F0BBC\";\r\n}\r\n\r\n.mdi-pan-up::before {\r\n  content: \"\\F0BBD\";\r\n}\r\n\r\n.mdi-pan-vertical::before {\r\n  content: \"\\F0BBE\";\r\n}\r\n\r\n.mdi-panda::before {\r\n  content: \"\\F03DA\";\r\n}\r\n\r\n.mdi-pandora::before {\r\n  content: \"\\F03DB\";\r\n}\r\n\r\n.mdi-panorama::before {\r\n  content: \"\\F03DC\";\r\n}\r\n\r\n.mdi-panorama-fisheye::before {\r\n  content: \"\\F03DD\";\r\n}\r\n\r\n.mdi-panorama-horizontal::before {\r\n  content: \"\\F1928\";\r\n}\r\n\r\n.mdi-panorama-horizontal-outline::before {\r\n  content: \"\\F03DE\";\r\n}\r\n\r\n.mdi-panorama-outline::before {\r\n  content: \"\\F198C\";\r\n}\r\n\r\n.mdi-panorama-sphere::before {\r\n  content: \"\\F198D\";\r\n}\r\n\r\n.mdi-panorama-sphere-outline::before {\r\n  content: \"\\F198E\";\r\n}\r\n\r\n.mdi-panorama-variant::before {\r\n  content: \"\\F198F\";\r\n}\r\n\r\n.mdi-panorama-variant-outline::before {\r\n  content: \"\\F1990\";\r\n}\r\n\r\n.mdi-panorama-vertical::before {\r\n  content: \"\\F1929\";\r\n}\r\n\r\n.mdi-panorama-vertical-outline::before {\r\n  content: \"\\F03DF\";\r\n}\r\n\r\n.mdi-panorama-wide-angle::before {\r\n  content: \"\\F195F\";\r\n}\r\n\r\n.mdi-panorama-wide-angle-outline::before {\r\n  content: \"\\F03E0\";\r\n}\r\n\r\n.mdi-paper-cut-vertical::before {\r\n  content: \"\\F03E1\";\r\n}\r\n\r\n.mdi-paper-roll::before {\r\n  content: \"\\F1157\";\r\n}\r\n\r\n.mdi-paper-roll-outline::before {\r\n  content: \"\\F1158\";\r\n}\r\n\r\n.mdi-paperclip::before {\r\n  content: \"\\F03E2\";\r\n}\r\n\r\n.mdi-parachute::before {\r\n  content: \"\\F0CB4\";\r\n}\r\n\r\n.mdi-parachute-outline::before {\r\n  content: \"\\F0CB5\";\r\n}\r\n\r\n.mdi-paragliding::before {\r\n  content: \"\\F1745\";\r\n}\r\n\r\n.mdi-parking::before {\r\n  content: \"\\F03E3\";\r\n}\r\n\r\n.mdi-party-popper::before {\r\n  content: \"\\F1056\";\r\n}\r\n\r\n.mdi-passport::before {\r\n  content: \"\\F07E3\";\r\n}\r\n\r\n.mdi-passport-biometric::before {\r\n  content: \"\\F0DE1\";\r\n}\r\n\r\n.mdi-pasta::before {\r\n  content: \"\\F1160\";\r\n}\r\n\r\n.mdi-patio-heater::before {\r\n  content: \"\\F0F80\";\r\n}\r\n\r\n.mdi-patreon::before {\r\n  content: \"\\F0882\";\r\n}\r\n\r\n.mdi-pause::before {\r\n  content: \"\\F03E4\";\r\n}\r\n\r\n.mdi-pause-circle::before {\r\n  content: \"\\F03E5\";\r\n}\r\n\r\n.mdi-pause-circle-outline::before {\r\n  content: \"\\F03E6\";\r\n}\r\n\r\n.mdi-pause-octagon::before {\r\n  content: \"\\F03E7\";\r\n}\r\n\r\n.mdi-pause-octagon-outline::before {\r\n  content: \"\\F03E8\";\r\n}\r\n\r\n.mdi-paw::before {\r\n  content: \"\\F03E9\";\r\n}\r\n\r\n.mdi-paw-off::before {\r\n  content: \"\\F0657\";\r\n}\r\n\r\n.mdi-paw-off-outline::before {\r\n  content: \"\\F1676\";\r\n}\r\n\r\n.mdi-paw-outline::before {\r\n  content: \"\\F1675\";\r\n}\r\n\r\n.mdi-peace::before {\r\n  content: \"\\F0884\";\r\n}\r\n\r\n.mdi-peanut::before {\r\n  content: \"\\F0FFC\";\r\n}\r\n\r\n.mdi-peanut-off::before {\r\n  content: \"\\F0FFD\";\r\n}\r\n\r\n.mdi-peanut-off-outline::before {\r\n  content: \"\\F0FFF\";\r\n}\r\n\r\n.mdi-peanut-outline::before {\r\n  content: \"\\F0FFE\";\r\n}\r\n\r\n.mdi-pen::before {\r\n  content: \"\\F03EA\";\r\n}\r\n\r\n.mdi-pen-lock::before {\r\n  content: \"\\F0DE2\";\r\n}\r\n\r\n.mdi-pen-minus::before {\r\n  content: \"\\F0DE3\";\r\n}\r\n\r\n.mdi-pen-off::before {\r\n  content: \"\\F0DE4\";\r\n}\r\n\r\n.mdi-pen-plus::before {\r\n  content: \"\\F0DE5\";\r\n}\r\n\r\n.mdi-pen-remove::before {\r\n  content: \"\\F0DE6\";\r\n}\r\n\r\n.mdi-pencil::before {\r\n  content: \"\\F03EB\";\r\n}\r\n\r\n.mdi-pencil-box::before {\r\n  content: \"\\F03EC\";\r\n}\r\n\r\n.mdi-pencil-box-multiple::before {\r\n  content: \"\\F1144\";\r\n}\r\n\r\n.mdi-pencil-box-multiple-outline::before {\r\n  content: \"\\F1145\";\r\n}\r\n\r\n.mdi-pencil-box-outline::before {\r\n  content: \"\\F03ED\";\r\n}\r\n\r\n.mdi-pencil-circle::before {\r\n  content: \"\\F06FF\";\r\n}\r\n\r\n.mdi-pencil-circle-outline::before {\r\n  content: \"\\F0776\";\r\n}\r\n\r\n.mdi-pencil-lock::before {\r\n  content: \"\\F03EE\";\r\n}\r\n\r\n.mdi-pencil-lock-outline::before {\r\n  content: \"\\F0DE7\";\r\n}\r\n\r\n.mdi-pencil-minus::before {\r\n  content: \"\\F0DE8\";\r\n}\r\n\r\n.mdi-pencil-minus-outline::before {\r\n  content: \"\\F0DE9\";\r\n}\r\n\r\n.mdi-pencil-off::before {\r\n  content: \"\\F03EF\";\r\n}\r\n\r\n.mdi-pencil-off-outline::before {\r\n  content: \"\\F0DEA\";\r\n}\r\n\r\n.mdi-pencil-outline::before {\r\n  content: \"\\F0CB6\";\r\n}\r\n\r\n.mdi-pencil-plus::before {\r\n  content: \"\\F0DEB\";\r\n}\r\n\r\n.mdi-pencil-plus-outline::before {\r\n  content: \"\\F0DEC\";\r\n}\r\n\r\n.mdi-pencil-remove::before {\r\n  content: \"\\F0DED\";\r\n}\r\n\r\n.mdi-pencil-remove-outline::before {\r\n  content: \"\\F0DEE\";\r\n}\r\n\r\n.mdi-pencil-ruler::before {\r\n  content: \"\\F1353\";\r\n}\r\n\r\n.mdi-penguin::before {\r\n  content: \"\\F0EC0\";\r\n}\r\n\r\n.mdi-pentagon::before {\r\n  content: \"\\F0701\";\r\n}\r\n\r\n.mdi-pentagon-outline::before {\r\n  content: \"\\F0700\";\r\n}\r\n\r\n.mdi-pentagram::before {\r\n  content: \"\\F1667\";\r\n}\r\n\r\n.mdi-percent::before {\r\n  content: \"\\F03F0\";\r\n}\r\n\r\n.mdi-percent-outline::before {\r\n  content: \"\\F1278\";\r\n}\r\n\r\n.mdi-periodic-table::before {\r\n  content: \"\\F08B6\";\r\n}\r\n\r\n.mdi-perspective-less::before {\r\n  content: \"\\F0D23\";\r\n}\r\n\r\n.mdi-perspective-more::before {\r\n  content: \"\\F0D24\";\r\n}\r\n\r\n.mdi-ph::before {\r\n  content: \"\\F17C5\";\r\n}\r\n\r\n.mdi-phone::before {\r\n  content: \"\\F03F2\";\r\n}\r\n\r\n.mdi-phone-alert::before {\r\n  content: \"\\F0F1A\";\r\n}\r\n\r\n.mdi-phone-alert-outline::before {\r\n  content: \"\\F118E\";\r\n}\r\n\r\n.mdi-phone-bluetooth::before {\r\n  content: \"\\F03F3\";\r\n}\r\n\r\n.mdi-phone-bluetooth-outline::before {\r\n  content: \"\\F118F\";\r\n}\r\n\r\n.mdi-phone-cancel::before {\r\n  content: \"\\F10BC\";\r\n}\r\n\r\n.mdi-phone-cancel-outline::before {\r\n  content: \"\\F1190\";\r\n}\r\n\r\n.mdi-phone-check::before {\r\n  content: \"\\F11A9\";\r\n}\r\n\r\n.mdi-phone-check-outline::before {\r\n  content: \"\\F11AA\";\r\n}\r\n\r\n.mdi-phone-classic::before {\r\n  content: \"\\F0602\";\r\n}\r\n\r\n.mdi-phone-classic-off::before {\r\n  content: \"\\F1279\";\r\n}\r\n\r\n.mdi-phone-dial::before {\r\n  content: \"\\F1559\";\r\n}\r\n\r\n.mdi-phone-dial-outline::before {\r\n  content: \"\\F155A\";\r\n}\r\n\r\n.mdi-phone-forward::before {\r\n  content: \"\\F03F4\";\r\n}\r\n\r\n.mdi-phone-forward-outline::before {\r\n  content: \"\\F1191\";\r\n}\r\n\r\n.mdi-phone-hangup::before {\r\n  content: \"\\F03F5\";\r\n}\r\n\r\n.mdi-phone-hangup-outline::before {\r\n  content: \"\\F1192\";\r\n}\r\n\r\n.mdi-phone-in-talk::before {\r\n  content: \"\\F03F6\";\r\n}\r\n\r\n.mdi-phone-in-talk-outline::before {\r\n  content: \"\\F1182\";\r\n}\r\n\r\n.mdi-phone-incoming::before {\r\n  content: \"\\F03F7\";\r\n}\r\n\r\n.mdi-phone-incoming-outline::before {\r\n  content: \"\\F1193\";\r\n}\r\n\r\n.mdi-phone-lock::before {\r\n  content: \"\\F03F8\";\r\n}\r\n\r\n.mdi-phone-lock-outline::before {\r\n  content: \"\\F1194\";\r\n}\r\n\r\n.mdi-phone-log::before {\r\n  content: \"\\F03F9\";\r\n}\r\n\r\n.mdi-phone-log-outline::before {\r\n  content: \"\\F1195\";\r\n}\r\n\r\n.mdi-phone-message::before {\r\n  content: \"\\F1196\";\r\n}\r\n\r\n.mdi-phone-message-outline::before {\r\n  content: \"\\F1197\";\r\n}\r\n\r\n.mdi-phone-minus::before {\r\n  content: \"\\F0658\";\r\n}\r\n\r\n.mdi-phone-minus-outline::before {\r\n  content: \"\\F1198\";\r\n}\r\n\r\n.mdi-phone-missed::before {\r\n  content: \"\\F03FA\";\r\n}\r\n\r\n.mdi-phone-missed-outline::before {\r\n  content: \"\\F11A5\";\r\n}\r\n\r\n.mdi-phone-off::before {\r\n  content: \"\\F0DEF\";\r\n}\r\n\r\n.mdi-phone-off-outline::before {\r\n  content: \"\\F11A6\";\r\n}\r\n\r\n.mdi-phone-outgoing::before {\r\n  content: \"\\F03FB\";\r\n}\r\n\r\n.mdi-phone-outgoing-outline::before {\r\n  content: \"\\F1199\";\r\n}\r\n\r\n.mdi-phone-outline::before {\r\n  content: \"\\F0DF0\";\r\n}\r\n\r\n.mdi-phone-paused::before {\r\n  content: \"\\F03FC\";\r\n}\r\n\r\n.mdi-phone-paused-outline::before {\r\n  content: \"\\F119A\";\r\n}\r\n\r\n.mdi-phone-plus::before {\r\n  content: \"\\F0659\";\r\n}\r\n\r\n.mdi-phone-plus-outline::before {\r\n  content: \"\\F119B\";\r\n}\r\n\r\n.mdi-phone-refresh::before {\r\n  content: \"\\F1993\";\r\n}\r\n\r\n.mdi-phone-refresh-outline::before {\r\n  content: \"\\F1994\";\r\n}\r\n\r\n.mdi-phone-remove::before {\r\n  content: \"\\F152F\";\r\n}\r\n\r\n.mdi-phone-remove-outline::before {\r\n  content: \"\\F1530\";\r\n}\r\n\r\n.mdi-phone-return::before {\r\n  content: \"\\F082F\";\r\n}\r\n\r\n.mdi-phone-return-outline::before {\r\n  content: \"\\F119C\";\r\n}\r\n\r\n.mdi-phone-ring::before {\r\n  content: \"\\F11AB\";\r\n}\r\n\r\n.mdi-phone-ring-outline::before {\r\n  content: \"\\F11AC\";\r\n}\r\n\r\n.mdi-phone-rotate-landscape::before {\r\n  content: \"\\F0885\";\r\n}\r\n\r\n.mdi-phone-rotate-portrait::before {\r\n  content: \"\\F0886\";\r\n}\r\n\r\n.mdi-phone-settings::before {\r\n  content: \"\\F03FD\";\r\n}\r\n\r\n.mdi-phone-settings-outline::before {\r\n  content: \"\\F119D\";\r\n}\r\n\r\n.mdi-phone-sync::before {\r\n  content: \"\\F1995\";\r\n}\r\n\r\n.mdi-phone-sync-outline::before {\r\n  content: \"\\F1996\";\r\n}\r\n\r\n.mdi-phone-voip::before {\r\n  content: \"\\F03FE\";\r\n}\r\n\r\n.mdi-pi::before {\r\n  content: \"\\F03FF\";\r\n}\r\n\r\n.mdi-pi-box::before {\r\n  content: \"\\F0400\";\r\n}\r\n\r\n.mdi-pi-hole::before {\r\n  content: \"\\F0DF1\";\r\n}\r\n\r\n.mdi-piano::before {\r\n  content: \"\\F067D\";\r\n}\r\n\r\n.mdi-piano-off::before {\r\n  content: \"\\F0698\";\r\n}\r\n\r\n.mdi-pickaxe::before {\r\n  content: \"\\F08B7\";\r\n}\r\n\r\n.mdi-picture-in-picture-bottom-right::before {\r\n  content: \"\\F0E57\";\r\n}\r\n\r\n.mdi-picture-in-picture-bottom-right-outline::before {\r\n  content: \"\\F0E58\";\r\n}\r\n\r\n.mdi-picture-in-picture-top-right::before {\r\n  content: \"\\F0E59\";\r\n}\r\n\r\n.mdi-picture-in-picture-top-right-outline::before {\r\n  content: \"\\F0E5A\";\r\n}\r\n\r\n.mdi-pier::before {\r\n  content: \"\\F0887\";\r\n}\r\n\r\n.mdi-pier-crane::before {\r\n  content: \"\\F0888\";\r\n}\r\n\r\n.mdi-pig::before {\r\n  content: \"\\F0401\";\r\n}\r\n\r\n.mdi-pig-variant::before {\r\n  content: \"\\F1006\";\r\n}\r\n\r\n.mdi-pig-variant-outline::before {\r\n  content: \"\\F1678\";\r\n}\r\n\r\n.mdi-piggy-bank::before {\r\n  content: \"\\F1007\";\r\n}\r\n\r\n.mdi-piggy-bank-outline::before {\r\n  content: \"\\F1679\";\r\n}\r\n\r\n.mdi-pill::before {\r\n  content: \"\\F0402\";\r\n}\r\n\r\n.mdi-pillar::before {\r\n  content: \"\\F0702\";\r\n}\r\n\r\n.mdi-pin::before {\r\n  content: \"\\F0403\";\r\n}\r\n\r\n.mdi-pin-off::before {\r\n  content: \"\\F0404\";\r\n}\r\n\r\n.mdi-pin-off-outline::before {\r\n  content: \"\\F0930\";\r\n}\r\n\r\n.mdi-pin-outline::before {\r\n  content: \"\\F0931\";\r\n}\r\n\r\n.mdi-pine-tree::before {\r\n  content: \"\\F0405\";\r\n}\r\n\r\n.mdi-pine-tree-box::before {\r\n  content: \"\\F0406\";\r\n}\r\n\r\n.mdi-pine-tree-fire::before {\r\n  content: \"\\F141A\";\r\n}\r\n\r\n.mdi-pinterest::before {\r\n  content: \"\\F0407\";\r\n}\r\n\r\n.mdi-pinwheel::before {\r\n  content: \"\\F0AD5\";\r\n}\r\n\r\n.mdi-pinwheel-outline::before {\r\n  content: \"\\F0AD6\";\r\n}\r\n\r\n.mdi-pipe::before {\r\n  content: \"\\F07E5\";\r\n}\r\n\r\n.mdi-pipe-disconnected::before {\r\n  content: \"\\F07E6\";\r\n}\r\n\r\n.mdi-pipe-leak::before {\r\n  content: \"\\F0889\";\r\n}\r\n\r\n.mdi-pipe-valve::before {\r\n  content: \"\\F184D\";\r\n}\r\n\r\n.mdi-pipe-wrench::before {\r\n  content: \"\\F1354\";\r\n}\r\n\r\n.mdi-pirate::before {\r\n  content: \"\\F0A08\";\r\n}\r\n\r\n.mdi-pistol::before {\r\n  content: \"\\F0703\";\r\n}\r\n\r\n.mdi-piston::before {\r\n  content: \"\\F088A\";\r\n}\r\n\r\n.mdi-pitchfork::before {\r\n  content: \"\\F1553\";\r\n}\r\n\r\n.mdi-pizza::before {\r\n  content: \"\\F0409\";\r\n}\r\n\r\n.mdi-play::before {\r\n  content: \"\\F040A\";\r\n}\r\n\r\n.mdi-play-box::before {\r\n  content: \"\\F127A\";\r\n}\r\n\r\n.mdi-play-box-multiple::before {\r\n  content: \"\\F0D19\";\r\n}\r\n\r\n.mdi-play-box-multiple-outline::before {\r\n  content: \"\\F13E6\";\r\n}\r\n\r\n.mdi-play-box-outline::before {\r\n  content: \"\\F040B\";\r\n}\r\n\r\n.mdi-play-circle::before {\r\n  content: \"\\F040C\";\r\n}\r\n\r\n.mdi-play-circle-outline::before {\r\n  content: \"\\F040D\";\r\n}\r\n\r\n.mdi-play-network::before {\r\n  content: \"\\F088B\";\r\n}\r\n\r\n.mdi-play-network-outline::before {\r\n  content: \"\\F0CB7\";\r\n}\r\n\r\n.mdi-play-outline::before {\r\n  content: \"\\F0F1B\";\r\n}\r\n\r\n.mdi-play-pause::before {\r\n  content: \"\\F040E\";\r\n}\r\n\r\n.mdi-play-protected-content::before {\r\n  content: \"\\F040F\";\r\n}\r\n\r\n.mdi-play-speed::before {\r\n  content: \"\\F08FF\";\r\n}\r\n\r\n.mdi-playlist-check::before {\r\n  content: \"\\F05C7\";\r\n}\r\n\r\n.mdi-playlist-edit::before {\r\n  content: \"\\F0900\";\r\n}\r\n\r\n.mdi-playlist-minus::before {\r\n  content: \"\\F0410\";\r\n}\r\n\r\n.mdi-playlist-music::before {\r\n  content: \"\\F0CB8\";\r\n}\r\n\r\n.mdi-playlist-music-outline::before {\r\n  content: \"\\F0CB9\";\r\n}\r\n\r\n.mdi-playlist-play::before {\r\n  content: \"\\F0411\";\r\n}\r\n\r\n.mdi-playlist-plus::before {\r\n  content: \"\\F0412\";\r\n}\r\n\r\n.mdi-playlist-remove::before {\r\n  content: \"\\F0413\";\r\n}\r\n\r\n.mdi-playlist-star::before {\r\n  content: \"\\F0DF2\";\r\n}\r\n\r\n.mdi-plex::before {\r\n  content: \"\\F06BA\";\r\n}\r\n\r\n.mdi-pliers::before {\r\n  content: \"\\F19A4\";\r\n}\r\n\r\n.mdi-plus::before {\r\n  content: \"\\F0415\";\r\n}\r\n\r\n.mdi-plus-box::before {\r\n  content: \"\\F0416\";\r\n}\r\n\r\n.mdi-plus-box-multiple::before {\r\n  content: \"\\F0334\";\r\n}\r\n\r\n.mdi-plus-box-multiple-outline::before {\r\n  content: \"\\F1143\";\r\n}\r\n\r\n.mdi-plus-box-outline::before {\r\n  content: \"\\F0704\";\r\n}\r\n\r\n.mdi-plus-circle::before {\r\n  content: \"\\F0417\";\r\n}\r\n\r\n.mdi-plus-circle-multiple::before {\r\n  content: \"\\F034C\";\r\n}\r\n\r\n.mdi-plus-circle-multiple-outline::before {\r\n  content: \"\\F0418\";\r\n}\r\n\r\n.mdi-plus-circle-outline::before {\r\n  content: \"\\F0419\";\r\n}\r\n\r\n.mdi-plus-minus::before {\r\n  content: \"\\F0992\";\r\n}\r\n\r\n.mdi-plus-minus-box::before {\r\n  content: \"\\F0993\";\r\n}\r\n\r\n.mdi-plus-minus-variant::before {\r\n  content: \"\\F14C9\";\r\n}\r\n\r\n.mdi-plus-network::before {\r\n  content: \"\\F041A\";\r\n}\r\n\r\n.mdi-plus-network-outline::before {\r\n  content: \"\\F0CBA\";\r\n}\r\n\r\n.mdi-plus-outline::before {\r\n  content: \"\\F0705\";\r\n}\r\n\r\n.mdi-plus-thick::before {\r\n  content: \"\\F11EC\";\r\n}\r\n\r\n.mdi-podcast::before {\r\n  content: \"\\F0994\";\r\n}\r\n\r\n.mdi-podium::before {\r\n  content: \"\\F0D25\";\r\n}\r\n\r\n.mdi-podium-bronze::before {\r\n  content: \"\\F0D26\";\r\n}\r\n\r\n.mdi-podium-gold::before {\r\n  content: \"\\F0D27\";\r\n}\r\n\r\n.mdi-podium-silver::before {\r\n  content: \"\\F0D28\";\r\n}\r\n\r\n.mdi-point-of-sale::before {\r\n  content: \"\\F0D92\";\r\n}\r\n\r\n.mdi-pokeball::before {\r\n  content: \"\\F041D\";\r\n}\r\n\r\n.mdi-pokemon-go::before {\r\n  content: \"\\F0A09\";\r\n}\r\n\r\n.mdi-poker-chip::before {\r\n  content: \"\\F0830\";\r\n}\r\n\r\n.mdi-polaroid::before {\r\n  content: \"\\F041E\";\r\n}\r\n\r\n.mdi-police-badge::before {\r\n  content: \"\\F1167\";\r\n}\r\n\r\n.mdi-police-badge-outline::before {\r\n  content: \"\\F1168\";\r\n}\r\n\r\n.mdi-police-station::before {\r\n  content: \"\\F1839\";\r\n}\r\n\r\n.mdi-poll::before {\r\n  content: \"\\F041F\";\r\n}\r\n\r\n.mdi-polo::before {\r\n  content: \"\\F14C3\";\r\n}\r\n\r\n.mdi-polymer::before {\r\n  content: \"\\F0421\";\r\n}\r\n\r\n.mdi-pool::before {\r\n  content: \"\\F0606\";\r\n}\r\n\r\n.mdi-popcorn::before {\r\n  content: \"\\F0422\";\r\n}\r\n\r\n.mdi-post::before {\r\n  content: \"\\F1008\";\r\n}\r\n\r\n.mdi-post-outline::before {\r\n  content: \"\\F1009\";\r\n}\r\n\r\n.mdi-postage-stamp::before {\r\n  content: \"\\F0CBB\";\r\n}\r\n\r\n.mdi-pot::before {\r\n  content: \"\\F02E5\";\r\n}\r\n\r\n.mdi-pot-mix::before {\r\n  content: \"\\F065B\";\r\n}\r\n\r\n.mdi-pot-mix-outline::before {\r\n  content: \"\\F0677\";\r\n}\r\n\r\n.mdi-pot-outline::before {\r\n  content: \"\\F02FF\";\r\n}\r\n\r\n.mdi-pot-steam::before {\r\n  content: \"\\F065A\";\r\n}\r\n\r\n.mdi-pot-steam-outline::before {\r\n  content: \"\\F0326\";\r\n}\r\n\r\n.mdi-pound::before {\r\n  content: \"\\F0423\";\r\n}\r\n\r\n.mdi-pound-box::before {\r\n  content: \"\\F0424\";\r\n}\r\n\r\n.mdi-pound-box-outline::before {\r\n  content: \"\\F117F\";\r\n}\r\n\r\n.mdi-power::before {\r\n  content: \"\\F0425\";\r\n}\r\n\r\n.mdi-power-cycle::before {\r\n  content: \"\\F0901\";\r\n}\r\n\r\n.mdi-power-off::before {\r\n  content: \"\\F0902\";\r\n}\r\n\r\n.mdi-power-on::before {\r\n  content: \"\\F0903\";\r\n}\r\n\r\n.mdi-power-plug::before {\r\n  content: \"\\F06A5\";\r\n}\r\n\r\n.mdi-power-plug-off::before {\r\n  content: \"\\F06A6\";\r\n}\r\n\r\n.mdi-power-plug-off-outline::before {\r\n  content: \"\\F1424\";\r\n}\r\n\r\n.mdi-power-plug-outline::before {\r\n  content: \"\\F1425\";\r\n}\r\n\r\n.mdi-power-settings::before {\r\n  content: \"\\F0426\";\r\n}\r\n\r\n.mdi-power-sleep::before {\r\n  content: \"\\F0904\";\r\n}\r\n\r\n.mdi-power-socket::before {\r\n  content: \"\\F0427\";\r\n}\r\n\r\n.mdi-power-socket-au::before {\r\n  content: \"\\F0905\";\r\n}\r\n\r\n.mdi-power-socket-ch::before {\r\n  content: \"\\F0FB3\";\r\n}\r\n\r\n.mdi-power-socket-de::before {\r\n  content: \"\\F1107\";\r\n}\r\n\r\n.mdi-power-socket-eu::before {\r\n  content: \"\\F07E7\";\r\n}\r\n\r\n.mdi-power-socket-fr::before {\r\n  content: \"\\F1108\";\r\n}\r\n\r\n.mdi-power-socket-it::before {\r\n  content: \"\\F14FF\";\r\n}\r\n\r\n.mdi-power-socket-jp::before {\r\n  content: \"\\F1109\";\r\n}\r\n\r\n.mdi-power-socket-uk::before {\r\n  content: \"\\F07E8\";\r\n}\r\n\r\n.mdi-power-socket-us::before {\r\n  content: \"\\F07E9\";\r\n}\r\n\r\n.mdi-power-standby::before {\r\n  content: \"\\F0906\";\r\n}\r\n\r\n.mdi-powershell::before {\r\n  content: \"\\F0A0A\";\r\n}\r\n\r\n.mdi-prescription::before {\r\n  content: \"\\F0706\";\r\n}\r\n\r\n.mdi-presentation::before {\r\n  content: \"\\F0428\";\r\n}\r\n\r\n.mdi-presentation-play::before {\r\n  content: \"\\F0429\";\r\n}\r\n\r\n.mdi-pretzel::before {\r\n  content: \"\\F1562\";\r\n}\r\n\r\n.mdi-printer::before {\r\n  content: \"\\F042A\";\r\n}\r\n\r\n.mdi-printer-3d::before {\r\n  content: \"\\F042B\";\r\n}\r\n\r\n.mdi-printer-3d-nozzle::before {\r\n  content: \"\\F0E5B\";\r\n}\r\n\r\n.mdi-printer-3d-nozzle-alert::before {\r\n  content: \"\\F11C0\";\r\n}\r\n\r\n.mdi-printer-3d-nozzle-alert-outline::before {\r\n  content: \"\\F11C1\";\r\n}\r\n\r\n.mdi-printer-3d-nozzle-heat::before {\r\n  content: \"\\F18B8\";\r\n}\r\n\r\n.mdi-printer-3d-nozzle-heat-outline::before {\r\n  content: \"\\F18B9\";\r\n}\r\n\r\n.mdi-printer-3d-nozzle-outline::before {\r\n  content: \"\\F0E5C\";\r\n}\r\n\r\n.mdi-printer-alert::before {\r\n  content: \"\\F042C\";\r\n}\r\n\r\n.mdi-printer-check::before {\r\n  content: \"\\F1146\";\r\n}\r\n\r\n.mdi-printer-eye::before {\r\n  content: \"\\F1458\";\r\n}\r\n\r\n.mdi-printer-off::before {\r\n  content: \"\\F0E5D\";\r\n}\r\n\r\n.mdi-printer-off-outline::before {\r\n  content: \"\\F1785\";\r\n}\r\n\r\n.mdi-printer-outline::before {\r\n  content: \"\\F1786\";\r\n}\r\n\r\n.mdi-printer-pos::before {\r\n  content: \"\\F1057\";\r\n}\r\n\r\n.mdi-printer-search::before {\r\n  content: \"\\F1457\";\r\n}\r\n\r\n.mdi-printer-settings::before {\r\n  content: \"\\F0707\";\r\n}\r\n\r\n.mdi-printer-wireless::before {\r\n  content: \"\\F0A0B\";\r\n}\r\n\r\n.mdi-priority-high::before {\r\n  content: \"\\F0603\";\r\n}\r\n\r\n.mdi-priority-low::before {\r\n  content: \"\\F0604\";\r\n}\r\n\r\n.mdi-professional-hexagon::before {\r\n  content: \"\\F042D\";\r\n}\r\n\r\n.mdi-progress-alert::before {\r\n  content: \"\\F0CBC\";\r\n}\r\n\r\n.mdi-progress-check::before {\r\n  content: \"\\F0995\";\r\n}\r\n\r\n.mdi-progress-clock::before {\r\n  content: \"\\F0996\";\r\n}\r\n\r\n.mdi-progress-close::before {\r\n  content: \"\\F110A\";\r\n}\r\n\r\n.mdi-progress-download::before {\r\n  content: \"\\F0997\";\r\n}\r\n\r\n.mdi-progress-pencil::before {\r\n  content: \"\\F1787\";\r\n}\r\n\r\n.mdi-progress-question::before {\r\n  content: \"\\F1522\";\r\n}\r\n\r\n.mdi-progress-star::before {\r\n  content: \"\\F1788\";\r\n}\r\n\r\n.mdi-progress-upload::before {\r\n  content: \"\\F0998\";\r\n}\r\n\r\n.mdi-progress-wrench::before {\r\n  content: \"\\F0CBD\";\r\n}\r\n\r\n.mdi-projector::before {\r\n  content: \"\\F042E\";\r\n}\r\n\r\n.mdi-projector-screen::before {\r\n  content: \"\\F042F\";\r\n}\r\n\r\n.mdi-projector-screen-off::before {\r\n  content: \"\\F180D\";\r\n}\r\n\r\n.mdi-projector-screen-off-outline::before {\r\n  content: \"\\F180E\";\r\n}\r\n\r\n.mdi-projector-screen-outline::before {\r\n  content: \"\\F1724\";\r\n}\r\n\r\n.mdi-projector-screen-variant::before {\r\n  content: \"\\F180F\";\r\n}\r\n\r\n.mdi-projector-screen-variant-off::before {\r\n  content: \"\\F1810\";\r\n}\r\n\r\n.mdi-projector-screen-variant-off-outline::before {\r\n  content: \"\\F1811\";\r\n}\r\n\r\n.mdi-projector-screen-variant-outline::before {\r\n  content: \"\\F1812\";\r\n}\r\n\r\n.mdi-propane-tank::before {\r\n  content: \"\\F1357\";\r\n}\r\n\r\n.mdi-propane-tank-outline::before {\r\n  content: \"\\F1358\";\r\n}\r\n\r\n.mdi-protocol::before {\r\n  content: \"\\F0FD8\";\r\n}\r\n\r\n.mdi-publish::before {\r\n  content: \"\\F06A7\";\r\n}\r\n\r\n.mdi-publish-off::before {\r\n  content: \"\\F1945\";\r\n}\r\n\r\n.mdi-pulse::before {\r\n  content: \"\\F0430\";\r\n}\r\n\r\n.mdi-pump::before {\r\n  content: \"\\F1402\";\r\n}\r\n\r\n.mdi-pumpkin::before {\r\n  content: \"\\F0BBF\";\r\n}\r\n\r\n.mdi-purse::before {\r\n  content: \"\\F0F1C\";\r\n}\r\n\r\n.mdi-purse-outline::before {\r\n  content: \"\\F0F1D\";\r\n}\r\n\r\n.mdi-puzzle::before {\r\n  content: \"\\F0431\";\r\n}\r\n\r\n.mdi-puzzle-check::before {\r\n  content: \"\\F1426\";\r\n}\r\n\r\n.mdi-puzzle-check-outline::before {\r\n  content: \"\\F1427\";\r\n}\r\n\r\n.mdi-puzzle-edit::before {\r\n  content: \"\\F14D3\";\r\n}\r\n\r\n.mdi-puzzle-edit-outline::before {\r\n  content: \"\\F14D9\";\r\n}\r\n\r\n.mdi-puzzle-heart::before {\r\n  content: \"\\F14D4\";\r\n}\r\n\r\n.mdi-puzzle-heart-outline::before {\r\n  content: \"\\F14DA\";\r\n}\r\n\r\n.mdi-puzzle-minus::before {\r\n  content: \"\\F14D1\";\r\n}\r\n\r\n.mdi-puzzle-minus-outline::before {\r\n  content: \"\\F14D7\";\r\n}\r\n\r\n.mdi-puzzle-outline::before {\r\n  content: \"\\F0A66\";\r\n}\r\n\r\n.mdi-puzzle-plus::before {\r\n  content: \"\\F14D0\";\r\n}\r\n\r\n.mdi-puzzle-plus-outline::before {\r\n  content: \"\\F14D6\";\r\n}\r\n\r\n.mdi-puzzle-remove::before {\r\n  content: \"\\F14D2\";\r\n}\r\n\r\n.mdi-puzzle-remove-outline::before {\r\n  content: \"\\F14D8\";\r\n}\r\n\r\n.mdi-puzzle-star::before {\r\n  content: \"\\F14D5\";\r\n}\r\n\r\n.mdi-puzzle-star-outline::before {\r\n  content: \"\\F14DB\";\r\n}\r\n\r\n.mdi-pyramid::before {\r\n  content: \"\\F1952\";\r\n}\r\n\r\n.mdi-pyramid-off::before {\r\n  content: \"\\F1953\";\r\n}\r\n\r\n.mdi-qi::before {\r\n  content: \"\\F0999\";\r\n}\r\n\r\n.mdi-qqchat::before {\r\n  content: \"\\F0605\";\r\n}\r\n\r\n.mdi-qrcode::before {\r\n  content: \"\\F0432\";\r\n}\r\n\r\n.mdi-qrcode-edit::before {\r\n  content: \"\\F08B8\";\r\n}\r\n\r\n.mdi-qrcode-minus::before {\r\n  content: \"\\F118C\";\r\n}\r\n\r\n.mdi-qrcode-plus::before {\r\n  content: \"\\F118B\";\r\n}\r\n\r\n.mdi-qrcode-remove::before {\r\n  content: \"\\F118D\";\r\n}\r\n\r\n.mdi-qrcode-scan::before {\r\n  content: \"\\F0433\";\r\n}\r\n\r\n.mdi-quadcopter::before {\r\n  content: \"\\F0434\";\r\n}\r\n\r\n.mdi-quality-high::before {\r\n  content: \"\\F0435\";\r\n}\r\n\r\n.mdi-quality-low::before {\r\n  content: \"\\F0A0C\";\r\n}\r\n\r\n.mdi-quality-medium::before {\r\n  content: \"\\F0A0D\";\r\n}\r\n\r\n.mdi-quora::before {\r\n  content: \"\\F0D29\";\r\n}\r\n\r\n.mdi-rabbit::before {\r\n  content: \"\\F0907\";\r\n}\r\n\r\n.mdi-racing-helmet::before {\r\n  content: \"\\F0D93\";\r\n}\r\n\r\n.mdi-racquetball::before {\r\n  content: \"\\F0D94\";\r\n}\r\n\r\n.mdi-radar::before {\r\n  content: \"\\F0437\";\r\n}\r\n\r\n.mdi-radiator::before {\r\n  content: \"\\F0438\";\r\n}\r\n\r\n.mdi-radiator-disabled::before {\r\n  content: \"\\F0AD7\";\r\n}\r\n\r\n.mdi-radiator-off::before {\r\n  content: \"\\F0AD8\";\r\n}\r\n\r\n.mdi-radio::before {\r\n  content: \"\\F0439\";\r\n}\r\n\r\n.mdi-radio-am::before {\r\n  content: \"\\F0CBE\";\r\n}\r\n\r\n.mdi-radio-fm::before {\r\n  content: \"\\F0CBF\";\r\n}\r\n\r\n.mdi-radio-handheld::before {\r\n  content: \"\\F043A\";\r\n}\r\n\r\n.mdi-radio-off::before {\r\n  content: \"\\F121C\";\r\n}\r\n\r\n.mdi-radio-tower::before {\r\n  content: \"\\F043B\";\r\n}\r\n\r\n.mdi-radioactive::before {\r\n  content: \"\\F043C\";\r\n}\r\n\r\n.mdi-radioactive-circle::before {\r\n  content: \"\\F185D\";\r\n}\r\n\r\n.mdi-radioactive-circle-outline::before {\r\n  content: \"\\F185E\";\r\n}\r\n\r\n.mdi-radioactive-off::before {\r\n  content: \"\\F0EC1\";\r\n}\r\n\r\n.mdi-radiobox-blank::before {\r\n  content: \"\\F043D\";\r\n}\r\n\r\n.mdi-radiobox-marked::before {\r\n  content: \"\\F043E\";\r\n}\r\n\r\n.mdi-radiology-box::before {\r\n  content: \"\\F14C5\";\r\n}\r\n\r\n.mdi-radiology-box-outline::before {\r\n  content: \"\\F14C6\";\r\n}\r\n\r\n.mdi-radius::before {\r\n  content: \"\\F0CC0\";\r\n}\r\n\r\n.mdi-radius-outline::before {\r\n  content: \"\\F0CC1\";\r\n}\r\n\r\n.mdi-railroad-light::before {\r\n  content: \"\\F0F1E\";\r\n}\r\n\r\n.mdi-rake::before {\r\n  content: \"\\F1544\";\r\n}\r\n\r\n.mdi-raspberry-pi::before {\r\n  content: \"\\F043F\";\r\n}\r\n\r\n.mdi-ray-end::before {\r\n  content: \"\\F0440\";\r\n}\r\n\r\n.mdi-ray-end-arrow::before {\r\n  content: \"\\F0441\";\r\n}\r\n\r\n.mdi-ray-start::before {\r\n  content: \"\\F0442\";\r\n}\r\n\r\n.mdi-ray-start-arrow::before {\r\n  content: \"\\F0443\";\r\n}\r\n\r\n.mdi-ray-start-end::before {\r\n  content: \"\\F0444\";\r\n}\r\n\r\n.mdi-ray-start-vertex-end::before {\r\n  content: \"\\F15D8\";\r\n}\r\n\r\n.mdi-ray-vertex::before {\r\n  content: \"\\F0445\";\r\n}\r\n\r\n.mdi-razor-double-edge::before {\r\n  content: \"\\F1997\";\r\n}\r\n\r\n.mdi-razor-single-edge::before {\r\n  content: \"\\F1998\";\r\n}\r\n\r\n.mdi-react::before {\r\n  content: \"\\F0708\";\r\n}\r\n\r\n.mdi-read::before {\r\n  content: \"\\F0447\";\r\n}\r\n\r\n.mdi-receipt::before {\r\n  content: \"\\F0449\";\r\n}\r\n\r\n.mdi-record::before {\r\n  content: \"\\F044A\";\r\n}\r\n\r\n.mdi-record-circle::before {\r\n  content: \"\\F0EC2\";\r\n}\r\n\r\n.mdi-record-circle-outline::before {\r\n  content: \"\\F0EC3\";\r\n}\r\n\r\n.mdi-record-player::before {\r\n  content: \"\\F099A\";\r\n}\r\n\r\n.mdi-record-rec::before {\r\n  content: \"\\F044B\";\r\n}\r\n\r\n.mdi-rectangle::before {\r\n  content: \"\\F0E5E\";\r\n}\r\n\r\n.mdi-rectangle-outline::before {\r\n  content: \"\\F0E5F\";\r\n}\r\n\r\n.mdi-recycle::before {\r\n  content: \"\\F044C\";\r\n}\r\n\r\n.mdi-recycle-variant::before {\r\n  content: \"\\F139D\";\r\n}\r\n\r\n.mdi-reddit::before {\r\n  content: \"\\F044D\";\r\n}\r\n\r\n.mdi-redhat::before {\r\n  content: \"\\F111B\";\r\n}\r\n\r\n.mdi-redo::before {\r\n  content: \"\\F044E\";\r\n}\r\n\r\n.mdi-redo-variant::before {\r\n  content: \"\\F044F\";\r\n}\r\n\r\n.mdi-reflect-horizontal::before {\r\n  content: \"\\F0A0E\";\r\n}\r\n\r\n.mdi-reflect-vertical::before {\r\n  content: \"\\F0A0F\";\r\n}\r\n\r\n.mdi-refresh::before {\r\n  content: \"\\F0450\";\r\n}\r\n\r\n.mdi-refresh-auto::before {\r\n  content: \"\\F18F2\";\r\n}\r\n\r\n.mdi-refresh-circle::before {\r\n  content: \"\\F1377\";\r\n}\r\n\r\n.mdi-regex::before {\r\n  content: \"\\F0451\";\r\n}\r\n\r\n.mdi-registered-trademark::before {\r\n  content: \"\\F0A67\";\r\n}\r\n\r\n.mdi-reiterate::before {\r\n  content: \"\\F1588\";\r\n}\r\n\r\n.mdi-relation-many-to-many::before {\r\n  content: \"\\F1496\";\r\n}\r\n\r\n.mdi-relation-many-to-one::before {\r\n  content: \"\\F1497\";\r\n}\r\n\r\n.mdi-relation-many-to-one-or-many::before {\r\n  content: \"\\F1498\";\r\n}\r\n\r\n.mdi-relation-many-to-only-one::before {\r\n  content: \"\\F1499\";\r\n}\r\n\r\n.mdi-relation-many-to-zero-or-many::before {\r\n  content: \"\\F149A\";\r\n}\r\n\r\n.mdi-relation-many-to-zero-or-one::before {\r\n  content: \"\\F149B\";\r\n}\r\n\r\n.mdi-relation-one-or-many-to-many::before {\r\n  content: \"\\F149C\";\r\n}\r\n\r\n.mdi-relation-one-or-many-to-one::before {\r\n  content: \"\\F149D\";\r\n}\r\n\r\n.mdi-relation-one-or-many-to-one-or-many::before {\r\n  content: \"\\F149E\";\r\n}\r\n\r\n.mdi-relation-one-or-many-to-only-one::before {\r\n  content: \"\\F149F\";\r\n}\r\n\r\n.mdi-relation-one-or-many-to-zero-or-many::before {\r\n  content: \"\\F14A0\";\r\n}\r\n\r\n.mdi-relation-one-or-many-to-zero-or-one::before {\r\n  content: \"\\F14A1\";\r\n}\r\n\r\n.mdi-relation-one-to-many::before {\r\n  content: \"\\F14A2\";\r\n}\r\n\r\n.mdi-relation-one-to-one::before {\r\n  content: \"\\F14A3\";\r\n}\r\n\r\n.mdi-relation-one-to-one-or-many::before {\r\n  content: \"\\F14A4\";\r\n}\r\n\r\n.mdi-relation-one-to-only-one::before {\r\n  content: \"\\F14A5\";\r\n}\r\n\r\n.mdi-relation-one-to-zero-or-many::before {\r\n  content: \"\\F14A6\";\r\n}\r\n\r\n.mdi-relation-one-to-zero-or-one::before {\r\n  content: \"\\F14A7\";\r\n}\r\n\r\n.mdi-relation-only-one-to-many::before {\r\n  content: \"\\F14A8\";\r\n}\r\n\r\n.mdi-relation-only-one-to-one::before {\r\n  content: \"\\F14A9\";\r\n}\r\n\r\n.mdi-relation-only-one-to-one-or-many::before {\r\n  content: \"\\F14AA\";\r\n}\r\n\r\n.mdi-relation-only-one-to-only-one::before {\r\n  content: \"\\F14AB\";\r\n}\r\n\r\n.mdi-relation-only-one-to-zero-or-many::before {\r\n  content: \"\\F14AC\";\r\n}\r\n\r\n.mdi-relation-only-one-to-zero-or-one::before {\r\n  content: \"\\F14AD\";\r\n}\r\n\r\n.mdi-relation-zero-or-many-to-many::before {\r\n  content: \"\\F14AE\";\r\n}\r\n\r\n.mdi-relation-zero-or-many-to-one::before {\r\n  content: \"\\F14AF\";\r\n}\r\n\r\n.mdi-relation-zero-or-many-to-one-or-many::before {\r\n  content: \"\\F14B0\";\r\n}\r\n\r\n.mdi-relation-zero-or-many-to-only-one::before {\r\n  content: \"\\F14B1\";\r\n}\r\n\r\n.mdi-relation-zero-or-many-to-zero-or-many::before {\r\n  content: \"\\F14B2\";\r\n}\r\n\r\n.mdi-relation-zero-or-many-to-zero-or-one::before {\r\n  content: \"\\F14B3\";\r\n}\r\n\r\n.mdi-relation-zero-or-one-to-many::before {\r\n  content: \"\\F14B4\";\r\n}\r\n\r\n.mdi-relation-zero-or-one-to-one::before {\r\n  content: \"\\F14B5\";\r\n}\r\n\r\n.mdi-relation-zero-or-one-to-one-or-many::before {\r\n  content: \"\\F14B6\";\r\n}\r\n\r\n.mdi-relation-zero-or-one-to-only-one::before {\r\n  content: \"\\F14B7\";\r\n}\r\n\r\n.mdi-relation-zero-or-one-to-zero-or-many::before {\r\n  content: \"\\F14B8\";\r\n}\r\n\r\n.mdi-relation-zero-or-one-to-zero-or-one::before {\r\n  content: \"\\F14B9\";\r\n}\r\n\r\n.mdi-relative-scale::before {\r\n  content: \"\\F0452\";\r\n}\r\n\r\n.mdi-reload::before {\r\n  content: \"\\F0453\";\r\n}\r\n\r\n.mdi-reload-alert::before {\r\n  content: \"\\F110B\";\r\n}\r\n\r\n.mdi-reminder::before {\r\n  content: \"\\F088C\";\r\n}\r\n\r\n.mdi-remote::before {\r\n  content: \"\\F0454\";\r\n}\r\n\r\n.mdi-remote-desktop::before {\r\n  content: \"\\F08B9\";\r\n}\r\n\r\n.mdi-remote-off::before {\r\n  content: \"\\F0EC4\";\r\n}\r\n\r\n.mdi-remote-tv::before {\r\n  content: \"\\F0EC5\";\r\n}\r\n\r\n.mdi-remote-tv-off::before {\r\n  content: \"\\F0EC6\";\r\n}\r\n\r\n.mdi-rename-box::before {\r\n  content: \"\\F0455\";\r\n}\r\n\r\n.mdi-reorder-horizontal::before {\r\n  content: \"\\F0688\";\r\n}\r\n\r\n.mdi-reorder-vertical::before {\r\n  content: \"\\F0689\";\r\n}\r\n\r\n.mdi-repeat::before {\r\n  content: \"\\F0456\";\r\n}\r\n\r\n.mdi-repeat-off::before {\r\n  content: \"\\F0457\";\r\n}\r\n\r\n.mdi-repeat-once::before {\r\n  content: \"\\F0458\";\r\n}\r\n\r\n.mdi-repeat-variant::before {\r\n  content: \"\\F0547\";\r\n}\r\n\r\n.mdi-replay::before {\r\n  content: \"\\F0459\";\r\n}\r\n\r\n.mdi-reply::before {\r\n  content: \"\\F045A\";\r\n}\r\n\r\n.mdi-reply-all::before {\r\n  content: \"\\F045B\";\r\n}\r\n\r\n.mdi-reply-all-outline::before {\r\n  content: \"\\F0F1F\";\r\n}\r\n\r\n.mdi-reply-circle::before {\r\n  content: \"\\F11AE\";\r\n}\r\n\r\n.mdi-reply-outline::before {\r\n  content: \"\\F0F20\";\r\n}\r\n\r\n.mdi-reproduction::before {\r\n  content: \"\\F045C\";\r\n}\r\n\r\n.mdi-resistor::before {\r\n  content: \"\\F0B44\";\r\n}\r\n\r\n.mdi-resistor-nodes::before {\r\n  content: \"\\F0B45\";\r\n}\r\n\r\n.mdi-resize::before {\r\n  content: \"\\F0A68\";\r\n}\r\n\r\n.mdi-resize-bottom-right::before {\r\n  content: \"\\F045D\";\r\n}\r\n\r\n.mdi-responsive::before {\r\n  content: \"\\F045E\";\r\n}\r\n\r\n.mdi-restart::before {\r\n  content: \"\\F0709\";\r\n}\r\n\r\n.mdi-restart-alert::before {\r\n  content: \"\\F110C\";\r\n}\r\n\r\n.mdi-restart-off::before {\r\n  content: \"\\F0D95\";\r\n}\r\n\r\n.mdi-restore::before {\r\n  content: \"\\F099B\";\r\n}\r\n\r\n.mdi-restore-alert::before {\r\n  content: \"\\F110D\";\r\n}\r\n\r\n.mdi-rewind::before {\r\n  content: \"\\F045F\";\r\n}\r\n\r\n.mdi-rewind-10::before {\r\n  content: \"\\F0D2A\";\r\n}\r\n\r\n.mdi-rewind-15::before {\r\n  content: \"\\F1946\";\r\n}\r\n\r\n.mdi-rewind-30::before {\r\n  content: \"\\F0D96\";\r\n}\r\n\r\n.mdi-rewind-5::before {\r\n  content: \"\\F11F9\";\r\n}\r\n\r\n.mdi-rewind-60::before {\r\n  content: \"\\F160C\";\r\n}\r\n\r\n.mdi-rewind-outline::before {\r\n  content: \"\\F070A\";\r\n}\r\n\r\n.mdi-rhombus::before {\r\n  content: \"\\F070B\";\r\n}\r\n\r\n.mdi-rhombus-medium::before {\r\n  content: \"\\F0A10\";\r\n}\r\n\r\n.mdi-rhombus-medium-outline::before {\r\n  content: \"\\F14DC\";\r\n}\r\n\r\n.mdi-rhombus-outline::before {\r\n  content: \"\\F070C\";\r\n}\r\n\r\n.mdi-rhombus-split::before {\r\n  content: \"\\F0A11\";\r\n}\r\n\r\n.mdi-rhombus-split-outline::before {\r\n  content: \"\\F14DD\";\r\n}\r\n\r\n.mdi-ribbon::before {\r\n  content: \"\\F0460\";\r\n}\r\n\r\n.mdi-rice::before {\r\n  content: \"\\F07EA\";\r\n}\r\n\r\n.mdi-rickshaw::before {\r\n  content: \"\\F15BB\";\r\n}\r\n\r\n.mdi-rickshaw-electric::before {\r\n  content: \"\\F15BC\";\r\n}\r\n\r\n.mdi-ring::before {\r\n  content: \"\\F07EB\";\r\n}\r\n\r\n.mdi-rivet::before {\r\n  content: \"\\F0E60\";\r\n}\r\n\r\n.mdi-road::before {\r\n  content: \"\\F0461\";\r\n}\r\n\r\n.mdi-road-variant::before {\r\n  content: \"\\F0462\";\r\n}\r\n\r\n.mdi-robber::before {\r\n  content: \"\\F1058\";\r\n}\r\n\r\n.mdi-robot::before {\r\n  content: \"\\F06A9\";\r\n}\r\n\r\n.mdi-robot-angry::before {\r\n  content: \"\\F169D\";\r\n}\r\n\r\n.mdi-robot-angry-outline::before {\r\n  content: \"\\F169E\";\r\n}\r\n\r\n.mdi-robot-confused::before {\r\n  content: \"\\F169F\";\r\n}\r\n\r\n.mdi-robot-confused-outline::before {\r\n  content: \"\\F16A0\";\r\n}\r\n\r\n.mdi-robot-dead::before {\r\n  content: \"\\F16A1\";\r\n}\r\n\r\n.mdi-robot-dead-outline::before {\r\n  content: \"\\F16A2\";\r\n}\r\n\r\n.mdi-robot-excited::before {\r\n  content: \"\\F16A3\";\r\n}\r\n\r\n.mdi-robot-excited-outline::before {\r\n  content: \"\\F16A4\";\r\n}\r\n\r\n.mdi-robot-happy::before {\r\n  content: \"\\F1719\";\r\n}\r\n\r\n.mdi-robot-happy-outline::before {\r\n  content: \"\\F171A\";\r\n}\r\n\r\n.mdi-robot-industrial::before {\r\n  content: \"\\F0B46\";\r\n}\r\n\r\n.mdi-robot-love::before {\r\n  content: \"\\F16A5\";\r\n}\r\n\r\n.mdi-robot-love-outline::before {\r\n  content: \"\\F16A6\";\r\n}\r\n\r\n.mdi-robot-mower::before {\r\n  content: \"\\F11F7\";\r\n}\r\n\r\n.mdi-robot-mower-outline::before {\r\n  content: \"\\F11F3\";\r\n}\r\n\r\n.mdi-robot-off::before {\r\n  content: \"\\F16A7\";\r\n}\r\n\r\n.mdi-robot-off-outline::before {\r\n  content: \"\\F167B\";\r\n}\r\n\r\n.mdi-robot-outline::before {\r\n  content: \"\\F167A\";\r\n}\r\n\r\n.mdi-robot-vacuum::before {\r\n  content: \"\\F070D\";\r\n}\r\n\r\n.mdi-robot-vacuum-variant::before {\r\n  content: \"\\F0908\";\r\n}\r\n\r\n.mdi-rocket::before {\r\n  content: \"\\F0463\";\r\n}\r\n\r\n.mdi-rocket-launch::before {\r\n  content: \"\\F14DE\";\r\n}\r\n\r\n.mdi-rocket-launch-outline::before {\r\n  content: \"\\F14DF\";\r\n}\r\n\r\n.mdi-rocket-outline::before {\r\n  content: \"\\F13AF\";\r\n}\r\n\r\n.mdi-rodent::before {\r\n  content: \"\\F1327\";\r\n}\r\n\r\n.mdi-roller-skate::before {\r\n  content: \"\\F0D2B\";\r\n}\r\n\r\n.mdi-roller-skate-off::before {\r\n  content: \"\\F0145\";\r\n}\r\n\r\n.mdi-rollerblade::before {\r\n  content: \"\\F0D2C\";\r\n}\r\n\r\n.mdi-rollerblade-off::before {\r\n  content: \"\\F002E\";\r\n}\r\n\r\n.mdi-rollupjs::before {\r\n  content: \"\\F0BC0\";\r\n}\r\n\r\n.mdi-roman-numeral-1::before {\r\n  content: \"\\F1088\";\r\n}\r\n\r\n.mdi-roman-numeral-10::before {\r\n  content: \"\\F1091\";\r\n}\r\n\r\n.mdi-roman-numeral-2::before {\r\n  content: \"\\F1089\";\r\n}\r\n\r\n.mdi-roman-numeral-3::before {\r\n  content: \"\\F108A\";\r\n}\r\n\r\n.mdi-roman-numeral-4::before {\r\n  content: \"\\F108B\";\r\n}\r\n\r\n.mdi-roman-numeral-5::before {\r\n  content: \"\\F108C\";\r\n}\r\n\r\n.mdi-roman-numeral-6::before {\r\n  content: \"\\F108D\";\r\n}\r\n\r\n.mdi-roman-numeral-7::before {\r\n  content: \"\\F108E\";\r\n}\r\n\r\n.mdi-roman-numeral-8::before {\r\n  content: \"\\F108F\";\r\n}\r\n\r\n.mdi-roman-numeral-9::before {\r\n  content: \"\\F1090\";\r\n}\r\n\r\n.mdi-room-service::before {\r\n  content: \"\\F088D\";\r\n}\r\n\r\n.mdi-room-service-outline::before {\r\n  content: \"\\F0D97\";\r\n}\r\n\r\n.mdi-rotate-360::before {\r\n  content: \"\\F1999\";\r\n}\r\n\r\n.mdi-rotate-3d::before {\r\n  content: \"\\F0EC7\";\r\n}\r\n\r\n.mdi-rotate-3d-variant::before {\r\n  content: \"\\F0464\";\r\n}\r\n\r\n.mdi-rotate-left::before {\r\n  content: \"\\F0465\";\r\n}\r\n\r\n.mdi-rotate-left-variant::before {\r\n  content: \"\\F0466\";\r\n}\r\n\r\n.mdi-rotate-orbit::before {\r\n  content: \"\\F0D98\";\r\n}\r\n\r\n.mdi-rotate-right::before {\r\n  content: \"\\F0467\";\r\n}\r\n\r\n.mdi-rotate-right-variant::before {\r\n  content: \"\\F0468\";\r\n}\r\n\r\n.mdi-rounded-corner::before {\r\n  content: \"\\F0607\";\r\n}\r\n\r\n.mdi-router::before {\r\n  content: \"\\F11E2\";\r\n}\r\n\r\n.mdi-router-network::before {\r\n  content: \"\\F1087\";\r\n}\r\n\r\n.mdi-router-wireless::before {\r\n  content: \"\\F0469\";\r\n}\r\n\r\n.mdi-router-wireless-off::before {\r\n  content: \"\\F15A3\";\r\n}\r\n\r\n.mdi-router-wireless-settings::before {\r\n  content: \"\\F0A69\";\r\n}\r\n\r\n.mdi-routes::before {\r\n  content: \"\\F046A\";\r\n}\r\n\r\n.mdi-routes-clock::before {\r\n  content: \"\\F1059\";\r\n}\r\n\r\n.mdi-rowing::before {\r\n  content: \"\\F0608\";\r\n}\r\n\r\n.mdi-rss::before {\r\n  content: \"\\F046B\";\r\n}\r\n\r\n.mdi-rss-box::before {\r\n  content: \"\\F046C\";\r\n}\r\n\r\n.mdi-rss-off::before {\r\n  content: \"\\F0F21\";\r\n}\r\n\r\n.mdi-rug::before {\r\n  content: \"\\F1475\";\r\n}\r\n\r\n.mdi-rugby::before {\r\n  content: \"\\F0D99\";\r\n}\r\n\r\n.mdi-ruler::before {\r\n  content: \"\\F046D\";\r\n}\r\n\r\n.mdi-ruler-square::before {\r\n  content: \"\\F0CC2\";\r\n}\r\n\r\n.mdi-ruler-square-compass::before {\r\n  content: \"\\F0EBE\";\r\n}\r\n\r\n.mdi-run::before {\r\n  content: \"\\F070E\";\r\n}\r\n\r\n.mdi-run-fast::before {\r\n  content: \"\\F046E\";\r\n}\r\n\r\n.mdi-rv-truck::before {\r\n  content: \"\\F11D4\";\r\n}\r\n\r\n.mdi-sack::before {\r\n  content: \"\\F0D2E\";\r\n}\r\n\r\n.mdi-sack-percent::before {\r\n  content: \"\\F0D2F\";\r\n}\r\n\r\n.mdi-safe::before {\r\n  content: \"\\F0A6A\";\r\n}\r\n\r\n.mdi-safe-square::before {\r\n  content: \"\\F127C\";\r\n}\r\n\r\n.mdi-safe-square-outline::before {\r\n  content: \"\\F127D\";\r\n}\r\n\r\n.mdi-safety-goggles::before {\r\n  content: \"\\F0D30\";\r\n}\r\n\r\n.mdi-sail-boat::before {\r\n  content: \"\\F0EC8\";\r\n}\r\n\r\n.mdi-sale::before {\r\n  content: \"\\F046F\";\r\n}\r\n\r\n.mdi-salesforce::before {\r\n  content: \"\\F088E\";\r\n}\r\n\r\n.mdi-sass::before {\r\n  content: \"\\F07EC\";\r\n}\r\n\r\n.mdi-satellite::before {\r\n  content: \"\\F0470\";\r\n}\r\n\r\n.mdi-satellite-uplink::before {\r\n  content: \"\\F0909\";\r\n}\r\n\r\n.mdi-satellite-variant::before {\r\n  content: \"\\F0471\";\r\n}\r\n\r\n.mdi-sausage::before {\r\n  content: \"\\F08BA\";\r\n}\r\n\r\n.mdi-sausage-off::before {\r\n  content: \"\\F1789\";\r\n}\r\n\r\n.mdi-saw-blade::before {\r\n  content: \"\\F0E61\";\r\n}\r\n\r\n.mdi-sawtooth-wave::before {\r\n  content: \"\\F147A\";\r\n}\r\n\r\n.mdi-saxophone::before {\r\n  content: \"\\F0609\";\r\n}\r\n\r\n.mdi-scale::before {\r\n  content: \"\\F0472\";\r\n}\r\n\r\n.mdi-scale-balance::before {\r\n  content: \"\\F05D1\";\r\n}\r\n\r\n.mdi-scale-bathroom::before {\r\n  content: \"\\F0473\";\r\n}\r\n\r\n.mdi-scale-off::before {\r\n  content: \"\\F105A\";\r\n}\r\n\r\n.mdi-scale-unbalanced::before {\r\n  content: \"\\F19B8\";\r\n}\r\n\r\n.mdi-scan-helper::before {\r\n  content: \"\\F13D8\";\r\n}\r\n\r\n.mdi-scanner::before {\r\n  content: \"\\F06AB\";\r\n}\r\n\r\n.mdi-scanner-off::before {\r\n  content: \"\\F090A\";\r\n}\r\n\r\n.mdi-scatter-plot::before {\r\n  content: \"\\F0EC9\";\r\n}\r\n\r\n.mdi-scatter-plot-outline::before {\r\n  content: \"\\F0ECA\";\r\n}\r\n\r\n.mdi-scent::before {\r\n  content: \"\\F1958\";\r\n}\r\n\r\n.mdi-scent-off::before {\r\n  content: \"\\F1959\";\r\n}\r\n\r\n.mdi-school::before {\r\n  content: \"\\F0474\";\r\n}\r\n\r\n.mdi-school-outline::before {\r\n  content: \"\\F1180\";\r\n}\r\n\r\n.mdi-scissors-cutting::before {\r\n  content: \"\\F0A6B\";\r\n}\r\n\r\n.mdi-scooter::before {\r\n  content: \"\\F15BD\";\r\n}\r\n\r\n.mdi-scooter-electric::before {\r\n  content: \"\\F15BE\";\r\n}\r\n\r\n.mdi-scoreboard::before {\r\n  content: \"\\F127E\";\r\n}\r\n\r\n.mdi-scoreboard-outline::before {\r\n  content: \"\\F127F\";\r\n}\r\n\r\n.mdi-screen-rotation::before {\r\n  content: \"\\F0475\";\r\n}\r\n\r\n.mdi-screen-rotation-lock::before {\r\n  content: \"\\F0478\";\r\n}\r\n\r\n.mdi-screw-flat-top::before {\r\n  content: \"\\F0DF3\";\r\n}\r\n\r\n.mdi-screw-lag::before {\r\n  content: \"\\F0DF4\";\r\n}\r\n\r\n.mdi-screw-machine-flat-top::before {\r\n  content: \"\\F0DF5\";\r\n}\r\n\r\n.mdi-screw-machine-round-top::before {\r\n  content: \"\\F0DF6\";\r\n}\r\n\r\n.mdi-screw-round-top::before {\r\n  content: \"\\F0DF7\";\r\n}\r\n\r\n.mdi-screwdriver::before {\r\n  content: \"\\F0476\";\r\n}\r\n\r\n.mdi-script::before {\r\n  content: \"\\F0BC1\";\r\n}\r\n\r\n.mdi-script-outline::before {\r\n  content: \"\\F0477\";\r\n}\r\n\r\n.mdi-script-text::before {\r\n  content: \"\\F0BC2\";\r\n}\r\n\r\n.mdi-script-text-key::before {\r\n  content: \"\\F1725\";\r\n}\r\n\r\n.mdi-script-text-key-outline::before {\r\n  content: \"\\F1726\";\r\n}\r\n\r\n.mdi-script-text-outline::before {\r\n  content: \"\\F0BC3\";\r\n}\r\n\r\n.mdi-script-text-play::before {\r\n  content: \"\\F1727\";\r\n}\r\n\r\n.mdi-script-text-play-outline::before {\r\n  content: \"\\F1728\";\r\n}\r\n\r\n.mdi-sd::before {\r\n  content: \"\\F0479\";\r\n}\r\n\r\n.mdi-seal::before {\r\n  content: \"\\F047A\";\r\n}\r\n\r\n.mdi-seal-variant::before {\r\n  content: \"\\F0FD9\";\r\n}\r\n\r\n.mdi-search-web::before {\r\n  content: \"\\F070F\";\r\n}\r\n\r\n.mdi-seat::before {\r\n  content: \"\\F0CC3\";\r\n}\r\n\r\n.mdi-seat-flat::before {\r\n  content: \"\\F047B\";\r\n}\r\n\r\n.mdi-seat-flat-angled::before {\r\n  content: \"\\F047C\";\r\n}\r\n\r\n.mdi-seat-individual-suite::before {\r\n  content: \"\\F047D\";\r\n}\r\n\r\n.mdi-seat-legroom-extra::before {\r\n  content: \"\\F047E\";\r\n}\r\n\r\n.mdi-seat-legroom-normal::before {\r\n  content: \"\\F047F\";\r\n}\r\n\r\n.mdi-seat-legroom-reduced::before {\r\n  content: \"\\F0480\";\r\n}\r\n\r\n.mdi-seat-outline::before {\r\n  content: \"\\F0CC4\";\r\n}\r\n\r\n.mdi-seat-passenger::before {\r\n  content: \"\\F1249\";\r\n}\r\n\r\n.mdi-seat-recline-extra::before {\r\n  content: \"\\F0481\";\r\n}\r\n\r\n.mdi-seat-recline-normal::before {\r\n  content: \"\\F0482\";\r\n}\r\n\r\n.mdi-seatbelt::before {\r\n  content: \"\\F0CC5\";\r\n}\r\n\r\n.mdi-security::before {\r\n  content: \"\\F0483\";\r\n}\r\n\r\n.mdi-security-network::before {\r\n  content: \"\\F0484\";\r\n}\r\n\r\n.mdi-seed::before {\r\n  content: \"\\F0E62\";\r\n}\r\n\r\n.mdi-seed-off::before {\r\n  content: \"\\F13FD\";\r\n}\r\n\r\n.mdi-seed-off-outline::before {\r\n  content: \"\\F13FE\";\r\n}\r\n\r\n.mdi-seed-outline::before {\r\n  content: \"\\F0E63\";\r\n}\r\n\r\n.mdi-seesaw::before {\r\n  content: \"\\F15A4\";\r\n}\r\n\r\n.mdi-segment::before {\r\n  content: \"\\F0ECB\";\r\n}\r\n\r\n.mdi-select::before {\r\n  content: \"\\F0485\";\r\n}\r\n\r\n.mdi-select-all::before {\r\n  content: \"\\F0486\";\r\n}\r\n\r\n.mdi-select-color::before {\r\n  content: \"\\F0D31\";\r\n}\r\n\r\n.mdi-select-compare::before {\r\n  content: \"\\F0AD9\";\r\n}\r\n\r\n.mdi-select-drag::before {\r\n  content: \"\\F0A6C\";\r\n}\r\n\r\n.mdi-select-group::before {\r\n  content: \"\\F0F82\";\r\n}\r\n\r\n.mdi-select-inverse::before {\r\n  content: \"\\F0487\";\r\n}\r\n\r\n.mdi-select-marker::before {\r\n  content: \"\\F1280\";\r\n}\r\n\r\n.mdi-select-multiple::before {\r\n  content: \"\\F1281\";\r\n}\r\n\r\n.mdi-select-multiple-marker::before {\r\n  content: \"\\F1282\";\r\n}\r\n\r\n.mdi-select-off::before {\r\n  content: \"\\F0488\";\r\n}\r\n\r\n.mdi-select-place::before {\r\n  content: \"\\F0FDA\";\r\n}\r\n\r\n.mdi-select-remove::before {\r\n  content: \"\\F17C1\";\r\n}\r\n\r\n.mdi-select-search::before {\r\n  content: \"\\F1204\";\r\n}\r\n\r\n.mdi-selection::before {\r\n  content: \"\\F0489\";\r\n}\r\n\r\n.mdi-selection-drag::before {\r\n  content: \"\\F0A6D\";\r\n}\r\n\r\n.mdi-selection-ellipse::before {\r\n  content: \"\\F0D32\";\r\n}\r\n\r\n.mdi-selection-ellipse-arrow-inside::before {\r\n  content: \"\\F0F22\";\r\n}\r\n\r\n.mdi-selection-ellipse-remove::before {\r\n  content: \"\\F17C2\";\r\n}\r\n\r\n.mdi-selection-marker::before {\r\n  content: \"\\F1283\";\r\n}\r\n\r\n.mdi-selection-multiple::before {\r\n  content: \"\\F1285\";\r\n}\r\n\r\n.mdi-selection-multiple-marker::before {\r\n  content: \"\\F1284\";\r\n}\r\n\r\n.mdi-selection-off::before {\r\n  content: \"\\F0777\";\r\n}\r\n\r\n.mdi-selection-remove::before {\r\n  content: \"\\F17C3\";\r\n}\r\n\r\n.mdi-selection-search::before {\r\n  content: \"\\F1205\";\r\n}\r\n\r\n.mdi-semantic-web::before {\r\n  content: \"\\F1316\";\r\n}\r\n\r\n.mdi-send::before {\r\n  content: \"\\F048A\";\r\n}\r\n\r\n.mdi-send-check::before {\r\n  content: \"\\F1161\";\r\n}\r\n\r\n.mdi-send-check-outline::before {\r\n  content: \"\\F1162\";\r\n}\r\n\r\n.mdi-send-circle::before {\r\n  content: \"\\F0DF8\";\r\n}\r\n\r\n.mdi-send-circle-outline::before {\r\n  content: \"\\F0DF9\";\r\n}\r\n\r\n.mdi-send-clock::before {\r\n  content: \"\\F1163\";\r\n}\r\n\r\n.mdi-send-clock-outline::before {\r\n  content: \"\\F1164\";\r\n}\r\n\r\n.mdi-send-lock::before {\r\n  content: \"\\F07ED\";\r\n}\r\n\r\n.mdi-send-lock-outline::before {\r\n  content: \"\\F1166\";\r\n}\r\n\r\n.mdi-send-outline::before {\r\n  content: \"\\F1165\";\r\n}\r\n\r\n.mdi-serial-port::before {\r\n  content: \"\\F065C\";\r\n}\r\n\r\n.mdi-server::before {\r\n  content: \"\\F048B\";\r\n}\r\n\r\n.mdi-server-minus::before {\r\n  content: \"\\F048C\";\r\n}\r\n\r\n.mdi-server-network::before {\r\n  content: \"\\F048D\";\r\n}\r\n\r\n.mdi-server-network-off::before {\r\n  content: \"\\F048E\";\r\n}\r\n\r\n.mdi-server-off::before {\r\n  content: \"\\F048F\";\r\n}\r\n\r\n.mdi-server-plus::before {\r\n  content: \"\\F0490\";\r\n}\r\n\r\n.mdi-server-remove::before {\r\n  content: \"\\F0491\";\r\n}\r\n\r\n.mdi-server-security::before {\r\n  content: \"\\F0492\";\r\n}\r\n\r\n.mdi-set-all::before {\r\n  content: \"\\F0778\";\r\n}\r\n\r\n.mdi-set-center::before {\r\n  content: \"\\F0779\";\r\n}\r\n\r\n.mdi-set-center-right::before {\r\n  content: \"\\F077A\";\r\n}\r\n\r\n.mdi-set-left::before {\r\n  content: \"\\F077B\";\r\n}\r\n\r\n.mdi-set-left-center::before {\r\n  content: \"\\F077C\";\r\n}\r\n\r\n.mdi-set-left-right::before {\r\n  content: \"\\F077D\";\r\n}\r\n\r\n.mdi-set-merge::before {\r\n  content: \"\\F14E0\";\r\n}\r\n\r\n.mdi-set-none::before {\r\n  content: \"\\F077E\";\r\n}\r\n\r\n.mdi-set-right::before {\r\n  content: \"\\F077F\";\r\n}\r\n\r\n.mdi-set-split::before {\r\n  content: \"\\F14E1\";\r\n}\r\n\r\n.mdi-set-square::before {\r\n  content: \"\\F145D\";\r\n}\r\n\r\n.mdi-set-top-box::before {\r\n  content: \"\\F099F\";\r\n}\r\n\r\n.mdi-settings-helper::before {\r\n  content: \"\\F0A6E\";\r\n}\r\n\r\n.mdi-shaker::before {\r\n  content: \"\\F110E\";\r\n}\r\n\r\n.mdi-shaker-outline::before {\r\n  content: \"\\F110F\";\r\n}\r\n\r\n.mdi-shape::before {\r\n  content: \"\\F0831\";\r\n}\r\n\r\n.mdi-shape-circle-plus::before {\r\n  content: \"\\F065D\";\r\n}\r\n\r\n.mdi-shape-outline::before {\r\n  content: \"\\F0832\";\r\n}\r\n\r\n.mdi-shape-oval-plus::before {\r\n  content: \"\\F11FA\";\r\n}\r\n\r\n.mdi-shape-plus::before {\r\n  content: \"\\F0495\";\r\n}\r\n\r\n.mdi-shape-polygon-plus::before {\r\n  content: \"\\F065E\";\r\n}\r\n\r\n.mdi-shape-rectangle-plus::before {\r\n  content: \"\\F065F\";\r\n}\r\n\r\n.mdi-shape-square-plus::before {\r\n  content: \"\\F0660\";\r\n}\r\n\r\n.mdi-shape-square-rounded-plus::before {\r\n  content: \"\\F14FA\";\r\n}\r\n\r\n.mdi-share::before {\r\n  content: \"\\F0496\";\r\n}\r\n\r\n.mdi-share-all::before {\r\n  content: \"\\F11F4\";\r\n}\r\n\r\n.mdi-share-all-outline::before {\r\n  content: \"\\F11F5\";\r\n}\r\n\r\n.mdi-share-circle::before {\r\n  content: \"\\F11AD\";\r\n}\r\n\r\n.mdi-share-off::before {\r\n  content: \"\\F0F23\";\r\n}\r\n\r\n.mdi-share-off-outline::before {\r\n  content: \"\\F0F24\";\r\n}\r\n\r\n.mdi-share-outline::before {\r\n  content: \"\\F0932\";\r\n}\r\n\r\n.mdi-share-variant::before {\r\n  content: \"\\F0497\";\r\n}\r\n\r\n.mdi-share-variant-outline::before {\r\n  content: \"\\F1514\";\r\n}\r\n\r\n.mdi-shark::before {\r\n  content: \"\\F18BA\";\r\n}\r\n\r\n.mdi-shark-fin::before {\r\n  content: \"\\F1673\";\r\n}\r\n\r\n.mdi-shark-fin-outline::before {\r\n  content: \"\\F1674\";\r\n}\r\n\r\n.mdi-shark-off::before {\r\n  content: \"\\F18BB\";\r\n}\r\n\r\n.mdi-sheep::before {\r\n  content: \"\\F0CC6\";\r\n}\r\n\r\n.mdi-shield::before {\r\n  content: \"\\F0498\";\r\n}\r\n\r\n.mdi-shield-account::before {\r\n  content: \"\\F088F\";\r\n}\r\n\r\n.mdi-shield-account-outline::before {\r\n  content: \"\\F0A12\";\r\n}\r\n\r\n.mdi-shield-account-variant::before {\r\n  content: \"\\F15A7\";\r\n}\r\n\r\n.mdi-shield-account-variant-outline::before {\r\n  content: \"\\F15A8\";\r\n}\r\n\r\n.mdi-shield-airplane::before {\r\n  content: \"\\F06BB\";\r\n}\r\n\r\n.mdi-shield-airplane-outline::before {\r\n  content: \"\\F0CC7\";\r\n}\r\n\r\n.mdi-shield-alert::before {\r\n  content: \"\\F0ECC\";\r\n}\r\n\r\n.mdi-shield-alert-outline::before {\r\n  content: \"\\F0ECD\";\r\n}\r\n\r\n.mdi-shield-bug::before {\r\n  content: \"\\F13DA\";\r\n}\r\n\r\n.mdi-shield-bug-outline::before {\r\n  content: \"\\F13DB\";\r\n}\r\n\r\n.mdi-shield-car::before {\r\n  content: \"\\F0F83\";\r\n}\r\n\r\n.mdi-shield-check::before {\r\n  content: \"\\F0565\";\r\n}\r\n\r\n.mdi-shield-check-outline::before {\r\n  content: \"\\F0CC8\";\r\n}\r\n\r\n.mdi-shield-cross::before {\r\n  content: \"\\F0CC9\";\r\n}\r\n\r\n.mdi-shield-cross-outline::before {\r\n  content: \"\\F0CCA\";\r\n}\r\n\r\n.mdi-shield-crown::before {\r\n  content: \"\\F18BC\";\r\n}\r\n\r\n.mdi-shield-crown-outline::before {\r\n  content: \"\\F18BD\";\r\n}\r\n\r\n.mdi-shield-edit::before {\r\n  content: \"\\F11A0\";\r\n}\r\n\r\n.mdi-shield-edit-outline::before {\r\n  content: \"\\F11A1\";\r\n}\r\n\r\n.mdi-shield-half::before {\r\n  content: \"\\F1360\";\r\n}\r\n\r\n.mdi-shield-half-full::before {\r\n  content: \"\\F0780\";\r\n}\r\n\r\n.mdi-shield-home::before {\r\n  content: \"\\F068A\";\r\n}\r\n\r\n.mdi-shield-home-outline::before {\r\n  content: \"\\F0CCB\";\r\n}\r\n\r\n.mdi-shield-key::before {\r\n  content: \"\\F0BC4\";\r\n}\r\n\r\n.mdi-shield-key-outline::before {\r\n  content: \"\\F0BC5\";\r\n}\r\n\r\n.mdi-shield-link-variant::before {\r\n  content: \"\\F0D33\";\r\n}\r\n\r\n.mdi-shield-link-variant-outline::before {\r\n  content: \"\\F0D34\";\r\n}\r\n\r\n.mdi-shield-lock::before {\r\n  content: \"\\F099D\";\r\n}\r\n\r\n.mdi-shield-lock-open::before {\r\n  content: \"\\F199A\";\r\n}\r\n\r\n.mdi-shield-lock-open-outline::before {\r\n  content: \"\\F199B\";\r\n}\r\n\r\n.mdi-shield-lock-outline::before {\r\n  content: \"\\F0CCC\";\r\n}\r\n\r\n.mdi-shield-moon::before {\r\n  content: \"\\F1828\";\r\n}\r\n\r\n.mdi-shield-moon-outline::before {\r\n  content: \"\\F1829\";\r\n}\r\n\r\n.mdi-shield-off::before {\r\n  content: \"\\F099E\";\r\n}\r\n\r\n.mdi-shield-off-outline::before {\r\n  content: \"\\F099C\";\r\n}\r\n\r\n.mdi-shield-outline::before {\r\n  content: \"\\F0499\";\r\n}\r\n\r\n.mdi-shield-plus::before {\r\n  content: \"\\F0ADA\";\r\n}\r\n\r\n.mdi-shield-plus-outline::before {\r\n  content: \"\\F0ADB\";\r\n}\r\n\r\n.mdi-shield-refresh::before {\r\n  content: \"\\F00AA\";\r\n}\r\n\r\n.mdi-shield-refresh-outline::before {\r\n  content: \"\\F01E0\";\r\n}\r\n\r\n.mdi-shield-remove::before {\r\n  content: \"\\F0ADC\";\r\n}\r\n\r\n.mdi-shield-remove-outline::before {\r\n  content: \"\\F0ADD\";\r\n}\r\n\r\n.mdi-shield-search::before {\r\n  content: \"\\F0D9A\";\r\n}\r\n\r\n.mdi-shield-star::before {\r\n  content: \"\\F113B\";\r\n}\r\n\r\n.mdi-shield-star-outline::before {\r\n  content: \"\\F113C\";\r\n}\r\n\r\n.mdi-shield-sun::before {\r\n  content: \"\\F105D\";\r\n}\r\n\r\n.mdi-shield-sun-outline::before {\r\n  content: \"\\F105E\";\r\n}\r\n\r\n.mdi-shield-sword::before {\r\n  content: \"\\F18BE\";\r\n}\r\n\r\n.mdi-shield-sword-outline::before {\r\n  content: \"\\F18BF\";\r\n}\r\n\r\n.mdi-shield-sync::before {\r\n  content: \"\\F11A2\";\r\n}\r\n\r\n.mdi-shield-sync-outline::before {\r\n  content: \"\\F11A3\";\r\n}\r\n\r\n.mdi-shimmer::before {\r\n  content: \"\\F1545\";\r\n}\r\n\r\n.mdi-ship-wheel::before {\r\n  content: \"\\F0833\";\r\n}\r\n\r\n.mdi-shipping-pallet::before {\r\n  content: \"\\F184E\";\r\n}\r\n\r\n.mdi-shoe-ballet::before {\r\n  content: \"\\F15CA\";\r\n}\r\n\r\n.mdi-shoe-cleat::before {\r\n  content: \"\\F15C7\";\r\n}\r\n\r\n.mdi-shoe-formal::before {\r\n  content: \"\\F0B47\";\r\n}\r\n\r\n.mdi-shoe-heel::before {\r\n  content: \"\\F0B48\";\r\n}\r\n\r\n.mdi-shoe-print::before {\r\n  content: \"\\F0DFA\";\r\n}\r\n\r\n.mdi-shoe-sneaker::before {\r\n  content: \"\\F15C8\";\r\n}\r\n\r\n.mdi-shopping::before {\r\n  content: \"\\F049A\";\r\n}\r\n\r\n.mdi-shopping-music::before {\r\n  content: \"\\F049B\";\r\n}\r\n\r\n.mdi-shopping-outline::before {\r\n  content: \"\\F11D5\";\r\n}\r\n\r\n.mdi-shopping-search::before {\r\n  content: \"\\F0F84\";\r\n}\r\n\r\n.mdi-shore::before {\r\n  content: \"\\F14F9\";\r\n}\r\n\r\n.mdi-shovel::before {\r\n  content: \"\\F0710\";\r\n}\r\n\r\n.mdi-shovel-off::before {\r\n  content: \"\\F0711\";\r\n}\r\n\r\n.mdi-shower::before {\r\n  content: \"\\F09A0\";\r\n}\r\n\r\n.mdi-shower-head::before {\r\n  content: \"\\F09A1\";\r\n}\r\n\r\n.mdi-shredder::before {\r\n  content: \"\\F049C\";\r\n}\r\n\r\n.mdi-shuffle::before {\r\n  content: \"\\F049D\";\r\n}\r\n\r\n.mdi-shuffle-disabled::before {\r\n  content: \"\\F049E\";\r\n}\r\n\r\n.mdi-shuffle-variant::before {\r\n  content: \"\\F049F\";\r\n}\r\n\r\n.mdi-shuriken::before {\r\n  content: \"\\F137F\";\r\n}\r\n\r\n.mdi-sickle::before {\r\n  content: \"\\F18C0\";\r\n}\r\n\r\n.mdi-sigma::before {\r\n  content: \"\\F04A0\";\r\n}\r\n\r\n.mdi-sigma-lower::before {\r\n  content: \"\\F062B\";\r\n}\r\n\r\n.mdi-sign-caution::before {\r\n  content: \"\\F04A1\";\r\n}\r\n\r\n.mdi-sign-direction::before {\r\n  content: \"\\F0781\";\r\n}\r\n\r\n.mdi-sign-direction-minus::before {\r\n  content: \"\\F1000\";\r\n}\r\n\r\n.mdi-sign-direction-plus::before {\r\n  content: \"\\F0FDC\";\r\n}\r\n\r\n.mdi-sign-direction-remove::before {\r\n  content: \"\\F0FDD\";\r\n}\r\n\r\n.mdi-sign-pole::before {\r\n  content: \"\\F14F8\";\r\n}\r\n\r\n.mdi-sign-real-estate::before {\r\n  content: \"\\F1118\";\r\n}\r\n\r\n.mdi-sign-text::before {\r\n  content: \"\\F0782\";\r\n}\r\n\r\n.mdi-signal::before {\r\n  content: \"\\F04A2\";\r\n}\r\n\r\n.mdi-signal-2g::before {\r\n  content: \"\\F0712\";\r\n}\r\n\r\n.mdi-signal-3g::before {\r\n  content: \"\\F0713\";\r\n}\r\n\r\n.mdi-signal-4g::before {\r\n  content: \"\\F0714\";\r\n}\r\n\r\n.mdi-signal-5g::before {\r\n  content: \"\\F0A6F\";\r\n}\r\n\r\n.mdi-signal-cellular-1::before {\r\n  content: \"\\F08BC\";\r\n}\r\n\r\n.mdi-signal-cellular-2::before {\r\n  content: \"\\F08BD\";\r\n}\r\n\r\n.mdi-signal-cellular-3::before {\r\n  content: \"\\F08BE\";\r\n}\r\n\r\n.mdi-signal-cellular-outline::before {\r\n  content: \"\\F08BF\";\r\n}\r\n\r\n.mdi-signal-distance-variant::before {\r\n  content: \"\\F0E64\";\r\n}\r\n\r\n.mdi-signal-hspa::before {\r\n  content: \"\\F0715\";\r\n}\r\n\r\n.mdi-signal-hspa-plus::before {\r\n  content: \"\\F0716\";\r\n}\r\n\r\n.mdi-signal-off::before {\r\n  content: \"\\F0783\";\r\n}\r\n\r\n.mdi-signal-variant::before {\r\n  content: \"\\F060A\";\r\n}\r\n\r\n.mdi-signature::before {\r\n  content: \"\\F0DFB\";\r\n}\r\n\r\n.mdi-signature-freehand::before {\r\n  content: \"\\F0DFC\";\r\n}\r\n\r\n.mdi-signature-image::before {\r\n  content: \"\\F0DFD\";\r\n}\r\n\r\n.mdi-signature-text::before {\r\n  content: \"\\F0DFE\";\r\n}\r\n\r\n.mdi-silo::before {\r\n  content: \"\\F0B49\";\r\n}\r\n\r\n.mdi-silverware::before {\r\n  content: \"\\F04A3\";\r\n}\r\n\r\n.mdi-silverware-clean::before {\r\n  content: \"\\F0FDE\";\r\n}\r\n\r\n.mdi-silverware-fork::before {\r\n  content: \"\\F04A4\";\r\n}\r\n\r\n.mdi-silverware-fork-knife::before {\r\n  content: \"\\F0A70\";\r\n}\r\n\r\n.mdi-silverware-spoon::before {\r\n  content: \"\\F04A5\";\r\n}\r\n\r\n.mdi-silverware-variant::before {\r\n  content: \"\\F04A6\";\r\n}\r\n\r\n.mdi-sim::before {\r\n  content: \"\\F04A7\";\r\n}\r\n\r\n.mdi-sim-alert::before {\r\n  content: \"\\F04A8\";\r\n}\r\n\r\n.mdi-sim-alert-outline::before {\r\n  content: \"\\F15D3\";\r\n}\r\n\r\n.mdi-sim-off::before {\r\n  content: \"\\F04A9\";\r\n}\r\n\r\n.mdi-sim-off-outline::before {\r\n  content: \"\\F15D4\";\r\n}\r\n\r\n.mdi-sim-outline::before {\r\n  content: \"\\F15D5\";\r\n}\r\n\r\n.mdi-simple-icons::before {\r\n  content: \"\\F131D\";\r\n}\r\n\r\n.mdi-sina-weibo::before {\r\n  content: \"\\F0ADF\";\r\n}\r\n\r\n.mdi-sine-wave::before {\r\n  content: \"\\F095B\";\r\n}\r\n\r\n.mdi-sitemap::before {\r\n  content: \"\\F04AA\";\r\n}\r\n\r\n.mdi-sitemap-outline::before {\r\n  content: \"\\F199C\";\r\n}\r\n\r\n.mdi-size-l::before {\r\n  content: \"\\F13A6\";\r\n}\r\n\r\n.mdi-size-m::before {\r\n  content: \"\\F13A5\";\r\n}\r\n\r\n.mdi-size-s::before {\r\n  content: \"\\F13A4\";\r\n}\r\n\r\n.mdi-size-xl::before {\r\n  content: \"\\F13A7\";\r\n}\r\n\r\n.mdi-size-xs::before {\r\n  content: \"\\F13A3\";\r\n}\r\n\r\n.mdi-size-xxl::before {\r\n  content: \"\\F13A8\";\r\n}\r\n\r\n.mdi-size-xxs::before {\r\n  content: \"\\F13A2\";\r\n}\r\n\r\n.mdi-size-xxxl::before {\r\n  content: \"\\F13A9\";\r\n}\r\n\r\n.mdi-skate::before {\r\n  content: \"\\F0D35\";\r\n}\r\n\r\n.mdi-skate-off::before {\r\n  content: \"\\F0699\";\r\n}\r\n\r\n.mdi-skateboard::before {\r\n  content: \"\\F14C2\";\r\n}\r\n\r\n.mdi-skateboarding::before {\r\n  content: \"\\F0501\";\r\n}\r\n\r\n.mdi-skew-less::before {\r\n  content: \"\\F0D36\";\r\n}\r\n\r\n.mdi-skew-more::before {\r\n  content: \"\\F0D37\";\r\n}\r\n\r\n.mdi-ski::before {\r\n  content: \"\\F1304\";\r\n}\r\n\r\n.mdi-ski-cross-country::before {\r\n  content: \"\\F1305\";\r\n}\r\n\r\n.mdi-ski-water::before {\r\n  content: \"\\F1306\";\r\n}\r\n\r\n.mdi-skip-backward::before {\r\n  content: \"\\F04AB\";\r\n}\r\n\r\n.mdi-skip-backward-outline::before {\r\n  content: \"\\F0F25\";\r\n}\r\n\r\n.mdi-skip-forward::before {\r\n  content: \"\\F04AC\";\r\n}\r\n\r\n.mdi-skip-forward-outline::before {\r\n  content: \"\\F0F26\";\r\n}\r\n\r\n.mdi-skip-next::before {\r\n  content: \"\\F04AD\";\r\n}\r\n\r\n.mdi-skip-next-circle::before {\r\n  content: \"\\F0661\";\r\n}\r\n\r\n.mdi-skip-next-circle-outline::before {\r\n  content: \"\\F0662\";\r\n}\r\n\r\n.mdi-skip-next-outline::before {\r\n  content: \"\\F0F27\";\r\n}\r\n\r\n.mdi-skip-previous::before {\r\n  content: \"\\F04AE\";\r\n}\r\n\r\n.mdi-skip-previous-circle::before {\r\n  content: \"\\F0663\";\r\n}\r\n\r\n.mdi-skip-previous-circle-outline::before {\r\n  content: \"\\F0664\";\r\n}\r\n\r\n.mdi-skip-previous-outline::before {\r\n  content: \"\\F0F28\";\r\n}\r\n\r\n.mdi-skull::before {\r\n  content: \"\\F068C\";\r\n}\r\n\r\n.mdi-skull-crossbones::before {\r\n  content: \"\\F0BC6\";\r\n}\r\n\r\n.mdi-skull-crossbones-outline::before {\r\n  content: \"\\F0BC7\";\r\n}\r\n\r\n.mdi-skull-outline::before {\r\n  content: \"\\F0BC8\";\r\n}\r\n\r\n.mdi-skull-scan::before {\r\n  content: \"\\F14C7\";\r\n}\r\n\r\n.mdi-skull-scan-outline::before {\r\n  content: \"\\F14C8\";\r\n}\r\n\r\n.mdi-skype::before {\r\n  content: \"\\F04AF\";\r\n}\r\n\r\n.mdi-skype-business::before {\r\n  content: \"\\F04B0\";\r\n}\r\n\r\n.mdi-slack::before {\r\n  content: \"\\F04B1\";\r\n}\r\n\r\n.mdi-slash-forward::before {\r\n  content: \"\\F0FDF\";\r\n}\r\n\r\n.mdi-slash-forward-box::before {\r\n  content: \"\\F0FE0\";\r\n}\r\n\r\n.mdi-sledding::before {\r\n  content: \"\\F041B\";\r\n}\r\n\r\n.mdi-sleep::before {\r\n  content: \"\\F04B2\";\r\n}\r\n\r\n.mdi-sleep-off::before {\r\n  content: \"\\F04B3\";\r\n}\r\n\r\n.mdi-slide::before {\r\n  content: \"\\F15A5\";\r\n}\r\n\r\n.mdi-slope-downhill::before {\r\n  content: \"\\F0DFF\";\r\n}\r\n\r\n.mdi-slope-uphill::before {\r\n  content: \"\\F0E00\";\r\n}\r\n\r\n.mdi-slot-machine::before {\r\n  content: \"\\F1114\";\r\n}\r\n\r\n.mdi-slot-machine-outline::before {\r\n  content: \"\\F1115\";\r\n}\r\n\r\n.mdi-smart-card::before {\r\n  content: \"\\F10BD\";\r\n}\r\n\r\n.mdi-smart-card-off::before {\r\n  content: \"\\F18F7\";\r\n}\r\n\r\n.mdi-smart-card-off-outline::before {\r\n  content: \"\\F18F8\";\r\n}\r\n\r\n.mdi-smart-card-outline::before {\r\n  content: \"\\F10BE\";\r\n}\r\n\r\n.mdi-smart-card-reader::before {\r\n  content: \"\\F10BF\";\r\n}\r\n\r\n.mdi-smart-card-reader-outline::before {\r\n  content: \"\\F10C0\";\r\n}\r\n\r\n.mdi-smog::before {\r\n  content: \"\\F0A71\";\r\n}\r\n\r\n.mdi-smoke::before {\r\n  content: \"\\F1799\";\r\n}\r\n\r\n.mdi-smoke-detector::before {\r\n  content: \"\\F0392\";\r\n}\r\n\r\n.mdi-smoke-detector-alert::before {\r\n  content: \"\\F192E\";\r\n}\r\n\r\n.mdi-smoke-detector-alert-outline::before {\r\n  content: \"\\F192F\";\r\n}\r\n\r\n.mdi-smoke-detector-off::before {\r\n  content: \"\\F1809\";\r\n}\r\n\r\n.mdi-smoke-detector-off-outline::before {\r\n  content: \"\\F180A\";\r\n}\r\n\r\n.mdi-smoke-detector-outline::before {\r\n  content: \"\\F1808\";\r\n}\r\n\r\n.mdi-smoke-detector-variant::before {\r\n  content: \"\\F180B\";\r\n}\r\n\r\n.mdi-smoke-detector-variant-alert::before {\r\n  content: \"\\F1930\";\r\n}\r\n\r\n.mdi-smoke-detector-variant-off::before {\r\n  content: \"\\F180C\";\r\n}\r\n\r\n.mdi-smoking::before {\r\n  content: \"\\F04B4\";\r\n}\r\n\r\n.mdi-smoking-off::before {\r\n  content: \"\\F04B5\";\r\n}\r\n\r\n.mdi-smoking-pipe::before {\r\n  content: \"\\F140D\";\r\n}\r\n\r\n.mdi-smoking-pipe-off::before {\r\n  content: \"\\F1428\";\r\n}\r\n\r\n.mdi-snail::before {\r\n  content: \"\\F1677\";\r\n}\r\n\r\n.mdi-snake::before {\r\n  content: \"\\F150E\";\r\n}\r\n\r\n.mdi-snapchat::before {\r\n  content: \"\\F04B6\";\r\n}\r\n\r\n.mdi-snowboard::before {\r\n  content: \"\\F1307\";\r\n}\r\n\r\n.mdi-snowflake::before {\r\n  content: \"\\F0717\";\r\n}\r\n\r\n.mdi-snowflake-alert::before {\r\n  content: \"\\F0F29\";\r\n}\r\n\r\n.mdi-snowflake-melt::before {\r\n  content: \"\\F12CB\";\r\n}\r\n\r\n.mdi-snowflake-off::before {\r\n  content: \"\\F14E3\";\r\n}\r\n\r\n.mdi-snowflake-variant::before {\r\n  content: \"\\F0F2A\";\r\n}\r\n\r\n.mdi-snowman::before {\r\n  content: \"\\F04B7\";\r\n}\r\n\r\n.mdi-snowmobile::before {\r\n  content: \"\\F06DD\";\r\n}\r\n\r\n.mdi-soccer::before {\r\n  content: \"\\F04B8\";\r\n}\r\n\r\n.mdi-soccer-field::before {\r\n  content: \"\\F0834\";\r\n}\r\n\r\n.mdi-social-distance-2-meters::before {\r\n  content: \"\\F1579\";\r\n}\r\n\r\n.mdi-social-distance-6-feet::before {\r\n  content: \"\\F157A\";\r\n}\r\n\r\n.mdi-sofa::before {\r\n  content: \"\\F04B9\";\r\n}\r\n\r\n.mdi-sofa-outline::before {\r\n  content: \"\\F156D\";\r\n}\r\n\r\n.mdi-sofa-single::before {\r\n  content: \"\\F156E\";\r\n}\r\n\r\n.mdi-sofa-single-outline::before {\r\n  content: \"\\F156F\";\r\n}\r\n\r\n.mdi-solar-panel::before {\r\n  content: \"\\F0D9B\";\r\n}\r\n\r\n.mdi-solar-panel-large::before {\r\n  content: \"\\F0D9C\";\r\n}\r\n\r\n.mdi-solar-power::before {\r\n  content: \"\\F0A72\";\r\n}\r\n\r\n.mdi-soldering-iron::before {\r\n  content: \"\\F1092\";\r\n}\r\n\r\n.mdi-solid::before {\r\n  content: \"\\F068D\";\r\n}\r\n\r\n.mdi-sony-playstation::before {\r\n  content: \"\\F0414\";\r\n}\r\n\r\n.mdi-sort::before {\r\n  content: \"\\F04BA\";\r\n}\r\n\r\n.mdi-sort-alphabetical-ascending::before {\r\n  content: \"\\F05BD\";\r\n}\r\n\r\n.mdi-sort-alphabetical-ascending-variant::before {\r\n  content: \"\\F1148\";\r\n}\r\n\r\n.mdi-sort-alphabetical-descending::before {\r\n  content: \"\\F05BF\";\r\n}\r\n\r\n.mdi-sort-alphabetical-descending-variant::before {\r\n  content: \"\\F1149\";\r\n}\r\n\r\n.mdi-sort-alphabetical-variant::before {\r\n  content: \"\\F04BB\";\r\n}\r\n\r\n.mdi-sort-ascending::before {\r\n  content: \"\\F04BC\";\r\n}\r\n\r\n.mdi-sort-bool-ascending::before {\r\n  content: \"\\F1385\";\r\n}\r\n\r\n.mdi-sort-bool-ascending-variant::before {\r\n  content: \"\\F1386\";\r\n}\r\n\r\n.mdi-sort-bool-descending::before {\r\n  content: \"\\F1387\";\r\n}\r\n\r\n.mdi-sort-bool-descending-variant::before {\r\n  content: \"\\F1388\";\r\n}\r\n\r\n.mdi-sort-calendar-ascending::before {\r\n  content: \"\\F1547\";\r\n}\r\n\r\n.mdi-sort-calendar-descending::before {\r\n  content: \"\\F1548\";\r\n}\r\n\r\n.mdi-sort-clock-ascending::before {\r\n  content: \"\\F1549\";\r\n}\r\n\r\n.mdi-sort-clock-ascending-outline::before {\r\n  content: \"\\F154A\";\r\n}\r\n\r\n.mdi-sort-clock-descending::before {\r\n  content: \"\\F154B\";\r\n}\r\n\r\n.mdi-sort-clock-descending-outline::before {\r\n  content: \"\\F154C\";\r\n}\r\n\r\n.mdi-sort-descending::before {\r\n  content: \"\\F04BD\";\r\n}\r\n\r\n.mdi-sort-numeric-ascending::before {\r\n  content: \"\\F1389\";\r\n}\r\n\r\n.mdi-sort-numeric-ascending-variant::before {\r\n  content: \"\\F090D\";\r\n}\r\n\r\n.mdi-sort-numeric-descending::before {\r\n  content: \"\\F138A\";\r\n}\r\n\r\n.mdi-sort-numeric-descending-variant::before {\r\n  content: \"\\F0AD2\";\r\n}\r\n\r\n.mdi-sort-numeric-variant::before {\r\n  content: \"\\F04BE\";\r\n}\r\n\r\n.mdi-sort-reverse-variant::before {\r\n  content: \"\\F033C\";\r\n}\r\n\r\n.mdi-sort-variant::before {\r\n  content: \"\\F04BF\";\r\n}\r\n\r\n.mdi-sort-variant-lock::before {\r\n  content: \"\\F0CCD\";\r\n}\r\n\r\n.mdi-sort-variant-lock-open::before {\r\n  content: \"\\F0CCE\";\r\n}\r\n\r\n.mdi-sort-variant-remove::before {\r\n  content: \"\\F1147\";\r\n}\r\n\r\n.mdi-soundbar::before {\r\n  content: \"\\F17DB\";\r\n}\r\n\r\n.mdi-soundcloud::before {\r\n  content: \"\\F04C0\";\r\n}\r\n\r\n.mdi-source-branch::before {\r\n  content: \"\\F062C\";\r\n}\r\n\r\n.mdi-source-branch-check::before {\r\n  content: \"\\F14CF\";\r\n}\r\n\r\n.mdi-source-branch-minus::before {\r\n  content: \"\\F14CB\";\r\n}\r\n\r\n.mdi-source-branch-plus::before {\r\n  content: \"\\F14CA\";\r\n}\r\n\r\n.mdi-source-branch-refresh::before {\r\n  content: \"\\F14CD\";\r\n}\r\n\r\n.mdi-source-branch-remove::before {\r\n  content: \"\\F14CC\";\r\n}\r\n\r\n.mdi-source-branch-sync::before {\r\n  content: \"\\F14CE\";\r\n}\r\n\r\n.mdi-source-commit::before {\r\n  content: \"\\F0718\";\r\n}\r\n\r\n.mdi-source-commit-end::before {\r\n  content: \"\\F0719\";\r\n}\r\n\r\n.mdi-source-commit-end-local::before {\r\n  content: \"\\F071A\";\r\n}\r\n\r\n.mdi-source-commit-local::before {\r\n  content: \"\\F071B\";\r\n}\r\n\r\n.mdi-source-commit-next-local::before {\r\n  content: \"\\F071C\";\r\n}\r\n\r\n.mdi-source-commit-start::before {\r\n  content: \"\\F071D\";\r\n}\r\n\r\n.mdi-source-commit-start-next-local::before {\r\n  content: \"\\F071E\";\r\n}\r\n\r\n.mdi-source-fork::before {\r\n  content: \"\\F04C1\";\r\n}\r\n\r\n.mdi-source-merge::before {\r\n  content: \"\\F062D\";\r\n}\r\n\r\n.mdi-source-pull::before {\r\n  content: \"\\F04C2\";\r\n}\r\n\r\n.mdi-source-repository::before {\r\n  content: \"\\F0CCF\";\r\n}\r\n\r\n.mdi-source-repository-multiple::before {\r\n  content: \"\\F0CD0\";\r\n}\r\n\r\n.mdi-soy-sauce::before {\r\n  content: \"\\F07EE\";\r\n}\r\n\r\n.mdi-soy-sauce-off::before {\r\n  content: \"\\F13FC\";\r\n}\r\n\r\n.mdi-spa::before {\r\n  content: \"\\F0CD1\";\r\n}\r\n\r\n.mdi-spa-outline::before {\r\n  content: \"\\F0CD2\";\r\n}\r\n\r\n.mdi-space-invaders::before {\r\n  content: \"\\F0BC9\";\r\n}\r\n\r\n.mdi-space-station::before {\r\n  content: \"\\F1383\";\r\n}\r\n\r\n.mdi-spade::before {\r\n  content: \"\\F0E65\";\r\n}\r\n\r\n.mdi-speaker::before {\r\n  content: \"\\F04C3\";\r\n}\r\n\r\n.mdi-speaker-bluetooth::before {\r\n  content: \"\\F09A2\";\r\n}\r\n\r\n.mdi-speaker-multiple::before {\r\n  content: \"\\F0D38\";\r\n}\r\n\r\n.mdi-speaker-off::before {\r\n  content: \"\\F04C4\";\r\n}\r\n\r\n.mdi-speaker-wireless::before {\r\n  content: \"\\F071F\";\r\n}\r\n\r\n.mdi-spear::before {\r\n  content: \"\\F1845\";\r\n}\r\n\r\n.mdi-speedometer::before {\r\n  content: \"\\F04C5\";\r\n}\r\n\r\n.mdi-speedometer-medium::before {\r\n  content: \"\\F0F85\";\r\n}\r\n\r\n.mdi-speedometer-slow::before {\r\n  content: \"\\F0F86\";\r\n}\r\n\r\n.mdi-spellcheck::before {\r\n  content: \"\\F04C6\";\r\n}\r\n\r\n.mdi-sphere::before {\r\n  content: \"\\F1954\";\r\n}\r\n\r\n.mdi-sphere-off::before {\r\n  content: \"\\F1955\";\r\n}\r\n\r\n.mdi-spider::before {\r\n  content: \"\\F11EA\";\r\n}\r\n\r\n.mdi-spider-thread::before {\r\n  content: \"\\F11EB\";\r\n}\r\n\r\n.mdi-spider-web::before {\r\n  content: \"\\F0BCA\";\r\n}\r\n\r\n.mdi-spirit-level::before {\r\n  content: \"\\F14F1\";\r\n}\r\n\r\n.mdi-spoon-sugar::before {\r\n  content: \"\\F1429\";\r\n}\r\n\r\n.mdi-spotify::before {\r\n  content: \"\\F04C7\";\r\n}\r\n\r\n.mdi-spotlight::before {\r\n  content: \"\\F04C8\";\r\n}\r\n\r\n.mdi-spotlight-beam::before {\r\n  content: \"\\F04C9\";\r\n}\r\n\r\n.mdi-spray::before {\r\n  content: \"\\F0665\";\r\n}\r\n\r\n.mdi-spray-bottle::before {\r\n  content: \"\\F0AE0\";\r\n}\r\n\r\n.mdi-sprinkler::before {\r\n  content: \"\\F105F\";\r\n}\r\n\r\n.mdi-sprinkler-fire::before {\r\n  content: \"\\F199D\";\r\n}\r\n\r\n.mdi-sprinkler-variant::before {\r\n  content: \"\\F1060\";\r\n}\r\n\r\n.mdi-sprout::before {\r\n  content: \"\\F0E66\";\r\n}\r\n\r\n.mdi-sprout-outline::before {\r\n  content: \"\\F0E67\";\r\n}\r\n\r\n.mdi-square::before {\r\n  content: \"\\F0764\";\r\n}\r\n\r\n.mdi-square-circle::before {\r\n  content: \"\\F1500\";\r\n}\r\n\r\n.mdi-square-edit-outline::before {\r\n  content: \"\\F090C\";\r\n}\r\n\r\n.mdi-square-medium::before {\r\n  content: \"\\F0A13\";\r\n}\r\n\r\n.mdi-square-medium-outline::before {\r\n  content: \"\\F0A14\";\r\n}\r\n\r\n.mdi-square-off::before {\r\n  content: \"\\F12EE\";\r\n}\r\n\r\n.mdi-square-off-outline::before {\r\n  content: \"\\F12EF\";\r\n}\r\n\r\n.mdi-square-opacity::before {\r\n  content: \"\\F1854\";\r\n}\r\n\r\n.mdi-square-outline::before {\r\n  content: \"\\F0763\";\r\n}\r\n\r\n.mdi-square-root::before {\r\n  content: \"\\F0784\";\r\n}\r\n\r\n.mdi-square-root-box::before {\r\n  content: \"\\F09A3\";\r\n}\r\n\r\n.mdi-square-rounded::before {\r\n  content: \"\\F14FB\";\r\n}\r\n\r\n.mdi-square-rounded-outline::before {\r\n  content: \"\\F14FC\";\r\n}\r\n\r\n.mdi-square-small::before {\r\n  content: \"\\F0A15\";\r\n}\r\n\r\n.mdi-square-wave::before {\r\n  content: \"\\F147B\";\r\n}\r\n\r\n.mdi-squeegee::before {\r\n  content: \"\\F0AE1\";\r\n}\r\n\r\n.mdi-ssh::before {\r\n  content: \"\\F08C0\";\r\n}\r\n\r\n.mdi-stack-exchange::before {\r\n  content: \"\\F060B\";\r\n}\r\n\r\n.mdi-stack-overflow::before {\r\n  content: \"\\F04CC\";\r\n}\r\n\r\n.mdi-stackpath::before {\r\n  content: \"\\F0359\";\r\n}\r\n\r\n.mdi-stadium::before {\r\n  content: \"\\F0FF9\";\r\n}\r\n\r\n.mdi-stadium-variant::before {\r\n  content: \"\\F0720\";\r\n}\r\n\r\n.mdi-stairs::before {\r\n  content: \"\\F04CD\";\r\n}\r\n\r\n.mdi-stairs-box::before {\r\n  content: \"\\F139E\";\r\n}\r\n\r\n.mdi-stairs-down::before {\r\n  content: \"\\F12BE\";\r\n}\r\n\r\n.mdi-stairs-up::before {\r\n  content: \"\\F12BD\";\r\n}\r\n\r\n.mdi-stamper::before {\r\n  content: \"\\F0D39\";\r\n}\r\n\r\n.mdi-standard-definition::before {\r\n  content: \"\\F07EF\";\r\n}\r\n\r\n.mdi-star::before {\r\n  content: \"\\F04CE\";\r\n}\r\n\r\n.mdi-star-box::before {\r\n  content: \"\\F0A73\";\r\n}\r\n\r\n.mdi-star-box-multiple::before {\r\n  content: \"\\F1286\";\r\n}\r\n\r\n.mdi-star-box-multiple-outline::before {\r\n  content: \"\\F1287\";\r\n}\r\n\r\n.mdi-star-box-outline::before {\r\n  content: \"\\F0A74\";\r\n}\r\n\r\n.mdi-star-check::before {\r\n  content: \"\\F1566\";\r\n}\r\n\r\n.mdi-star-check-outline::before {\r\n  content: \"\\F156A\";\r\n}\r\n\r\n.mdi-star-circle::before {\r\n  content: \"\\F04CF\";\r\n}\r\n\r\n.mdi-star-circle-outline::before {\r\n  content: \"\\F09A4\";\r\n}\r\n\r\n.mdi-star-cog::before {\r\n  content: \"\\F1668\";\r\n}\r\n\r\n.mdi-star-cog-outline::before {\r\n  content: \"\\F1669\";\r\n}\r\n\r\n.mdi-star-crescent::before {\r\n  content: \"\\F0979\";\r\n}\r\n\r\n.mdi-star-david::before {\r\n  content: \"\\F097A\";\r\n}\r\n\r\n.mdi-star-face::before {\r\n  content: \"\\F09A5\";\r\n}\r\n\r\n.mdi-star-four-points::before {\r\n  content: \"\\F0AE2\";\r\n}\r\n\r\n.mdi-star-four-points-outline::before {\r\n  content: \"\\F0AE3\";\r\n}\r\n\r\n.mdi-star-half::before {\r\n  content: \"\\F0246\";\r\n}\r\n\r\n.mdi-star-half-full::before {\r\n  content: \"\\F04D0\";\r\n}\r\n\r\n.mdi-star-minus::before {\r\n  content: \"\\F1564\";\r\n}\r\n\r\n.mdi-star-minus-outline::before {\r\n  content: \"\\F1568\";\r\n}\r\n\r\n.mdi-star-off::before {\r\n  content: \"\\F04D1\";\r\n}\r\n\r\n.mdi-star-off-outline::before {\r\n  content: \"\\F155B\";\r\n}\r\n\r\n.mdi-star-outline::before {\r\n  content: \"\\F04D2\";\r\n}\r\n\r\n.mdi-star-plus::before {\r\n  content: \"\\F1563\";\r\n}\r\n\r\n.mdi-star-plus-outline::before {\r\n  content: \"\\F1567\";\r\n}\r\n\r\n.mdi-star-remove::before {\r\n  content: \"\\F1565\";\r\n}\r\n\r\n.mdi-star-remove-outline::before {\r\n  content: \"\\F1569\";\r\n}\r\n\r\n.mdi-star-settings::before {\r\n  content: \"\\F166A\";\r\n}\r\n\r\n.mdi-star-settings-outline::before {\r\n  content: \"\\F166B\";\r\n}\r\n\r\n.mdi-star-shooting::before {\r\n  content: \"\\F1741\";\r\n}\r\n\r\n.mdi-star-shooting-outline::before {\r\n  content: \"\\F1742\";\r\n}\r\n\r\n.mdi-star-three-points::before {\r\n  content: \"\\F0AE4\";\r\n}\r\n\r\n.mdi-star-three-points-outline::before {\r\n  content: \"\\F0AE5\";\r\n}\r\n\r\n.mdi-state-machine::before {\r\n  content: \"\\F11EF\";\r\n}\r\n\r\n.mdi-steam::before {\r\n  content: \"\\F04D3\";\r\n}\r\n\r\n.mdi-steering::before {\r\n  content: \"\\F04D4\";\r\n}\r\n\r\n.mdi-steering-off::before {\r\n  content: \"\\F090E\";\r\n}\r\n\r\n.mdi-step-backward::before {\r\n  content: \"\\F04D5\";\r\n}\r\n\r\n.mdi-step-backward-2::before {\r\n  content: \"\\F04D6\";\r\n}\r\n\r\n.mdi-step-forward::before {\r\n  content: \"\\F04D7\";\r\n}\r\n\r\n.mdi-step-forward-2::before {\r\n  content: \"\\F04D8\";\r\n}\r\n\r\n.mdi-stethoscope::before {\r\n  content: \"\\F04D9\";\r\n}\r\n\r\n.mdi-sticker::before {\r\n  content: \"\\F1364\";\r\n}\r\n\r\n.mdi-sticker-alert::before {\r\n  content: \"\\F1365\";\r\n}\r\n\r\n.mdi-sticker-alert-outline::before {\r\n  content: \"\\F1366\";\r\n}\r\n\r\n.mdi-sticker-check::before {\r\n  content: \"\\F1367\";\r\n}\r\n\r\n.mdi-sticker-check-outline::before {\r\n  content: \"\\F1368\";\r\n}\r\n\r\n.mdi-sticker-circle-outline::before {\r\n  content: \"\\F05D0\";\r\n}\r\n\r\n.mdi-sticker-emoji::before {\r\n  content: \"\\F0785\";\r\n}\r\n\r\n.mdi-sticker-minus::before {\r\n  content: \"\\F1369\";\r\n}\r\n\r\n.mdi-sticker-minus-outline::before {\r\n  content: \"\\F136A\";\r\n}\r\n\r\n.mdi-sticker-outline::before {\r\n  content: \"\\F136B\";\r\n}\r\n\r\n.mdi-sticker-plus::before {\r\n  content: \"\\F136C\";\r\n}\r\n\r\n.mdi-sticker-plus-outline::before {\r\n  content: \"\\F136D\";\r\n}\r\n\r\n.mdi-sticker-remove::before {\r\n  content: \"\\F136E\";\r\n}\r\n\r\n.mdi-sticker-remove-outline::before {\r\n  content: \"\\F136F\";\r\n}\r\n\r\n.mdi-sticker-text::before {\r\n  content: \"\\F178E\";\r\n}\r\n\r\n.mdi-sticker-text-outline::before {\r\n  content: \"\\F178F\";\r\n}\r\n\r\n.mdi-stocking::before {\r\n  content: \"\\F04DA\";\r\n}\r\n\r\n.mdi-stomach::before {\r\n  content: \"\\F1093\";\r\n}\r\n\r\n.mdi-stool::before {\r\n  content: \"\\F195D\";\r\n}\r\n\r\n.mdi-stool-outline::before {\r\n  content: \"\\F195E\";\r\n}\r\n\r\n.mdi-stop::before {\r\n  content: \"\\F04DB\";\r\n}\r\n\r\n.mdi-stop-circle::before {\r\n  content: \"\\F0666\";\r\n}\r\n\r\n.mdi-stop-circle-outline::before {\r\n  content: \"\\F0667\";\r\n}\r\n\r\n.mdi-store::before {\r\n  content: \"\\F04DC\";\r\n}\r\n\r\n.mdi-store-24-hour::before {\r\n  content: \"\\F04DD\";\r\n}\r\n\r\n.mdi-store-alert::before {\r\n  content: \"\\F18C1\";\r\n}\r\n\r\n.mdi-store-alert-outline::before {\r\n  content: \"\\F18C2\";\r\n}\r\n\r\n.mdi-store-check::before {\r\n  content: \"\\F18C3\";\r\n}\r\n\r\n.mdi-store-check-outline::before {\r\n  content: \"\\F18C4\";\r\n}\r\n\r\n.mdi-store-clock::before {\r\n  content: \"\\F18C5\";\r\n}\r\n\r\n.mdi-store-clock-outline::before {\r\n  content: \"\\F18C6\";\r\n}\r\n\r\n.mdi-store-cog::before {\r\n  content: \"\\F18C7\";\r\n}\r\n\r\n.mdi-store-cog-outline::before {\r\n  content: \"\\F18C8\";\r\n}\r\n\r\n.mdi-store-edit::before {\r\n  content: \"\\F18C9\";\r\n}\r\n\r\n.mdi-store-edit-outline::before {\r\n  content: \"\\F18CA\";\r\n}\r\n\r\n.mdi-store-marker::before {\r\n  content: \"\\F18CB\";\r\n}\r\n\r\n.mdi-store-marker-outline::before {\r\n  content: \"\\F18CC\";\r\n}\r\n\r\n.mdi-store-minus::before {\r\n  content: \"\\F165E\";\r\n}\r\n\r\n.mdi-store-minus-outline::before {\r\n  content: \"\\F18CD\";\r\n}\r\n\r\n.mdi-store-off::before {\r\n  content: \"\\F18CE\";\r\n}\r\n\r\n.mdi-store-off-outline::before {\r\n  content: \"\\F18CF\";\r\n}\r\n\r\n.mdi-store-outline::before {\r\n  content: \"\\F1361\";\r\n}\r\n\r\n.mdi-store-plus::before {\r\n  content: \"\\F165F\";\r\n}\r\n\r\n.mdi-store-plus-outline::before {\r\n  content: \"\\F18D0\";\r\n}\r\n\r\n.mdi-store-remove::before {\r\n  content: \"\\F1660\";\r\n}\r\n\r\n.mdi-store-remove-outline::before {\r\n  content: \"\\F18D1\";\r\n}\r\n\r\n.mdi-store-search::before {\r\n  content: \"\\F18D2\";\r\n}\r\n\r\n.mdi-store-search-outline::before {\r\n  content: \"\\F18D3\";\r\n}\r\n\r\n.mdi-store-settings::before {\r\n  content: \"\\F18D4\";\r\n}\r\n\r\n.mdi-store-settings-outline::before {\r\n  content: \"\\F18D5\";\r\n}\r\n\r\n.mdi-storefront::before {\r\n  content: \"\\F07C7\";\r\n}\r\n\r\n.mdi-storefront-outline::before {\r\n  content: \"\\F10C1\";\r\n}\r\n\r\n.mdi-stove::before {\r\n  content: \"\\F04DE\";\r\n}\r\n\r\n.mdi-strategy::before {\r\n  content: \"\\F11D6\";\r\n}\r\n\r\n.mdi-stretch-to-page::before {\r\n  content: \"\\F0F2B\";\r\n}\r\n\r\n.mdi-stretch-to-page-outline::before {\r\n  content: \"\\F0F2C\";\r\n}\r\n\r\n.mdi-string-lights::before {\r\n  content: \"\\F12BA\";\r\n}\r\n\r\n.mdi-string-lights-off::before {\r\n  content: \"\\F12BB\";\r\n}\r\n\r\n.mdi-subdirectory-arrow-left::before {\r\n  content: \"\\F060C\";\r\n}\r\n\r\n.mdi-subdirectory-arrow-right::before {\r\n  content: \"\\F060D\";\r\n}\r\n\r\n.mdi-submarine::before {\r\n  content: \"\\F156C\";\r\n}\r\n\r\n.mdi-subtitles::before {\r\n  content: \"\\F0A16\";\r\n}\r\n\r\n.mdi-subtitles-outline::before {\r\n  content: \"\\F0A17\";\r\n}\r\n\r\n.mdi-subway::before {\r\n  content: \"\\F06AC\";\r\n}\r\n\r\n.mdi-subway-alert-variant::before {\r\n  content: \"\\F0D9D\";\r\n}\r\n\r\n.mdi-subway-variant::before {\r\n  content: \"\\F04DF\";\r\n}\r\n\r\n.mdi-summit::before {\r\n  content: \"\\F0786\";\r\n}\r\n\r\n.mdi-sun-compass::before {\r\n  content: \"\\F19A5\";\r\n}\r\n\r\n.mdi-sun-snowflake::before {\r\n  content: \"\\F1796\";\r\n}\r\n\r\n.mdi-sun-thermometer::before {\r\n  content: \"\\F18D6\";\r\n}\r\n\r\n.mdi-sun-thermometer-outline::before {\r\n  content: \"\\F18D7\";\r\n}\r\n\r\n.mdi-sun-wireless::before {\r\n  content: \"\\F17FE\";\r\n}\r\n\r\n.mdi-sun-wireless-outline::before {\r\n  content: \"\\F17FF\";\r\n}\r\n\r\n.mdi-sunglasses::before {\r\n  content: \"\\F04E0\";\r\n}\r\n\r\n.mdi-surfing::before {\r\n  content: \"\\F1746\";\r\n}\r\n\r\n.mdi-surround-sound::before {\r\n  content: \"\\F05C5\";\r\n}\r\n\r\n.mdi-surround-sound-2-0::before {\r\n  content: \"\\F07F0\";\r\n}\r\n\r\n.mdi-surround-sound-2-1::before {\r\n  content: \"\\F1729\";\r\n}\r\n\r\n.mdi-surround-sound-3-1::before {\r\n  content: \"\\F07F1\";\r\n}\r\n\r\n.mdi-surround-sound-5-1::before {\r\n  content: \"\\F07F2\";\r\n}\r\n\r\n.mdi-surround-sound-5-1-2::before {\r\n  content: \"\\F172A\";\r\n}\r\n\r\n.mdi-surround-sound-7-1::before {\r\n  content: \"\\F07F3\";\r\n}\r\n\r\n.mdi-svg::before {\r\n  content: \"\\F0721\";\r\n}\r\n\r\n.mdi-swap-horizontal::before {\r\n  content: \"\\F04E1\";\r\n}\r\n\r\n.mdi-swap-horizontal-bold::before {\r\n  content: \"\\F0BCD\";\r\n}\r\n\r\n.mdi-swap-horizontal-circle::before {\r\n  content: \"\\F0FE1\";\r\n}\r\n\r\n.mdi-swap-horizontal-circle-outline::before {\r\n  content: \"\\F0FE2\";\r\n}\r\n\r\n.mdi-swap-horizontal-variant::before {\r\n  content: \"\\F08C1\";\r\n}\r\n\r\n.mdi-swap-vertical::before {\r\n  content: \"\\F04E2\";\r\n}\r\n\r\n.mdi-swap-vertical-bold::before {\r\n  content: \"\\F0BCE\";\r\n}\r\n\r\n.mdi-swap-vertical-circle::before {\r\n  content: \"\\F0FE3\";\r\n}\r\n\r\n.mdi-swap-vertical-circle-outline::before {\r\n  content: \"\\F0FE4\";\r\n}\r\n\r\n.mdi-swap-vertical-variant::before {\r\n  content: \"\\F08C2\";\r\n}\r\n\r\n.mdi-swim::before {\r\n  content: \"\\F04E3\";\r\n}\r\n\r\n.mdi-switch::before {\r\n  content: \"\\F04E4\";\r\n}\r\n\r\n.mdi-sword::before {\r\n  content: \"\\F04E5\";\r\n}\r\n\r\n.mdi-sword-cross::before {\r\n  content: \"\\F0787\";\r\n}\r\n\r\n.mdi-syllabary-hangul::before {\r\n  content: \"\\F1333\";\r\n}\r\n\r\n.mdi-syllabary-hiragana::before {\r\n  content: \"\\F1334\";\r\n}\r\n\r\n.mdi-syllabary-katakana::before {\r\n  content: \"\\F1335\";\r\n}\r\n\r\n.mdi-syllabary-katakana-halfwidth::before {\r\n  content: \"\\F1336\";\r\n}\r\n\r\n.mdi-symbol::before {\r\n  content: \"\\F1501\";\r\n}\r\n\r\n.mdi-symfony::before {\r\n  content: \"\\F0AE6\";\r\n}\r\n\r\n.mdi-sync::before {\r\n  content: \"\\F04E6\";\r\n}\r\n\r\n.mdi-sync-alert::before {\r\n  content: \"\\F04E7\";\r\n}\r\n\r\n.mdi-sync-circle::before {\r\n  content: \"\\F1378\";\r\n}\r\n\r\n.mdi-sync-off::before {\r\n  content: \"\\F04E8\";\r\n}\r\n\r\n.mdi-tab::before {\r\n  content: \"\\F04E9\";\r\n}\r\n\r\n.mdi-tab-minus::before {\r\n  content: \"\\F0B4B\";\r\n}\r\n\r\n.mdi-tab-plus::before {\r\n  content: \"\\F075C\";\r\n}\r\n\r\n.mdi-tab-remove::before {\r\n  content: \"\\F0B4C\";\r\n}\r\n\r\n.mdi-tab-search::before {\r\n  content: \"\\F199E\";\r\n}\r\n\r\n.mdi-tab-unselected::before {\r\n  content: \"\\F04EA\";\r\n}\r\n\r\n.mdi-table::before {\r\n  content: \"\\F04EB\";\r\n}\r\n\r\n.mdi-table-account::before {\r\n  content: \"\\F13B9\";\r\n}\r\n\r\n.mdi-table-alert::before {\r\n  content: \"\\F13BA\";\r\n}\r\n\r\n.mdi-table-arrow-down::before {\r\n  content: \"\\F13BB\";\r\n}\r\n\r\n.mdi-table-arrow-left::before {\r\n  content: \"\\F13BC\";\r\n}\r\n\r\n.mdi-table-arrow-right::before {\r\n  content: \"\\F13BD\";\r\n}\r\n\r\n.mdi-table-arrow-up::before {\r\n  content: \"\\F13BE\";\r\n}\r\n\r\n.mdi-table-border::before {\r\n  content: \"\\F0A18\";\r\n}\r\n\r\n.mdi-table-cancel::before {\r\n  content: \"\\F13BF\";\r\n}\r\n\r\n.mdi-table-chair::before {\r\n  content: \"\\F1061\";\r\n}\r\n\r\n.mdi-table-check::before {\r\n  content: \"\\F13C0\";\r\n}\r\n\r\n.mdi-table-clock::before {\r\n  content: \"\\F13C1\";\r\n}\r\n\r\n.mdi-table-cog::before {\r\n  content: \"\\F13C2\";\r\n}\r\n\r\n.mdi-table-column::before {\r\n  content: \"\\F0835\";\r\n}\r\n\r\n.mdi-table-column-plus-after::before {\r\n  content: \"\\F04EC\";\r\n}\r\n\r\n.mdi-table-column-plus-before::before {\r\n  content: \"\\F04ED\";\r\n}\r\n\r\n.mdi-table-column-remove::before {\r\n  content: \"\\F04EE\";\r\n}\r\n\r\n.mdi-table-column-width::before {\r\n  content: \"\\F04EF\";\r\n}\r\n\r\n.mdi-table-edit::before {\r\n  content: \"\\F04F0\";\r\n}\r\n\r\n.mdi-table-eye::before {\r\n  content: \"\\F1094\";\r\n}\r\n\r\n.mdi-table-eye-off::before {\r\n  content: \"\\F13C3\";\r\n}\r\n\r\n.mdi-table-furniture::before {\r\n  content: \"\\F05BC\";\r\n}\r\n\r\n.mdi-table-headers-eye::before {\r\n  content: \"\\F121D\";\r\n}\r\n\r\n.mdi-table-headers-eye-off::before {\r\n  content: \"\\F121E\";\r\n}\r\n\r\n.mdi-table-heart::before {\r\n  content: \"\\F13C4\";\r\n}\r\n\r\n.mdi-table-key::before {\r\n  content: \"\\F13C5\";\r\n}\r\n\r\n.mdi-table-large::before {\r\n  content: \"\\F04F1\";\r\n}\r\n\r\n.mdi-table-large-plus::before {\r\n  content: \"\\F0F87\";\r\n}\r\n\r\n.mdi-table-large-remove::before {\r\n  content: \"\\F0F88\";\r\n}\r\n\r\n.mdi-table-lock::before {\r\n  content: \"\\F13C6\";\r\n}\r\n\r\n.mdi-table-merge-cells::before {\r\n  content: \"\\F09A6\";\r\n}\r\n\r\n.mdi-table-minus::before {\r\n  content: \"\\F13C7\";\r\n}\r\n\r\n.mdi-table-multiple::before {\r\n  content: \"\\F13C8\";\r\n}\r\n\r\n.mdi-table-network::before {\r\n  content: \"\\F13C9\";\r\n}\r\n\r\n.mdi-table-of-contents::before {\r\n  content: \"\\F0836\";\r\n}\r\n\r\n.mdi-table-off::before {\r\n  content: \"\\F13CA\";\r\n}\r\n\r\n.mdi-table-picnic::before {\r\n  content: \"\\F1743\";\r\n}\r\n\r\n.mdi-table-pivot::before {\r\n  content: \"\\F183C\";\r\n}\r\n\r\n.mdi-table-plus::before {\r\n  content: \"\\F0A75\";\r\n}\r\n\r\n.mdi-table-refresh::before {\r\n  content: \"\\F13A0\";\r\n}\r\n\r\n.mdi-table-remove::before {\r\n  content: \"\\F0A76\";\r\n}\r\n\r\n.mdi-table-row::before {\r\n  content: \"\\F0837\";\r\n}\r\n\r\n.mdi-table-row-height::before {\r\n  content: \"\\F04F2\";\r\n}\r\n\r\n.mdi-table-row-plus-after::before {\r\n  content: \"\\F04F3\";\r\n}\r\n\r\n.mdi-table-row-plus-before::before {\r\n  content: \"\\F04F4\";\r\n}\r\n\r\n.mdi-table-row-remove::before {\r\n  content: \"\\F04F5\";\r\n}\r\n\r\n.mdi-table-search::before {\r\n  content: \"\\F090F\";\r\n}\r\n\r\n.mdi-table-settings::before {\r\n  content: \"\\F0838\";\r\n}\r\n\r\n.mdi-table-split-cell::before {\r\n  content: \"\\F142A\";\r\n}\r\n\r\n.mdi-table-star::before {\r\n  content: \"\\F13CB\";\r\n}\r\n\r\n.mdi-table-sync::before {\r\n  content: \"\\F13A1\";\r\n}\r\n\r\n.mdi-table-tennis::before {\r\n  content: \"\\F0E68\";\r\n}\r\n\r\n.mdi-tablet::before {\r\n  content: \"\\F04F6\";\r\n}\r\n\r\n.mdi-tablet-android::before {\r\n  content: \"\\F04F7\";\r\n}\r\n\r\n.mdi-tablet-cellphone::before {\r\n  content: \"\\F09A7\";\r\n}\r\n\r\n.mdi-tablet-dashboard::before {\r\n  content: \"\\F0ECE\";\r\n}\r\n\r\n.mdi-taco::before {\r\n  content: \"\\F0762\";\r\n}\r\n\r\n.mdi-tag::before {\r\n  content: \"\\F04F9\";\r\n}\r\n\r\n.mdi-tag-arrow-down::before {\r\n  content: \"\\F172B\";\r\n}\r\n\r\n.mdi-tag-arrow-down-outline::before {\r\n  content: \"\\F172C\";\r\n}\r\n\r\n.mdi-tag-arrow-left::before {\r\n  content: \"\\F172D\";\r\n}\r\n\r\n.mdi-tag-arrow-left-outline::before {\r\n  content: \"\\F172E\";\r\n}\r\n\r\n.mdi-tag-arrow-right::before {\r\n  content: \"\\F172F\";\r\n}\r\n\r\n.mdi-tag-arrow-right-outline::before {\r\n  content: \"\\F1730\";\r\n}\r\n\r\n.mdi-tag-arrow-up::before {\r\n  content: \"\\F1731\";\r\n}\r\n\r\n.mdi-tag-arrow-up-outline::before {\r\n  content: \"\\F1732\";\r\n}\r\n\r\n.mdi-tag-faces::before {\r\n  content: \"\\F04FA\";\r\n}\r\n\r\n.mdi-tag-heart::before {\r\n  content: \"\\F068B\";\r\n}\r\n\r\n.mdi-tag-heart-outline::before {\r\n  content: \"\\F0BCF\";\r\n}\r\n\r\n.mdi-tag-minus::before {\r\n  content: \"\\F0910\";\r\n}\r\n\r\n.mdi-tag-minus-outline::before {\r\n  content: \"\\F121F\";\r\n}\r\n\r\n.mdi-tag-multiple::before {\r\n  content: \"\\F04FB\";\r\n}\r\n\r\n.mdi-tag-multiple-outline::before {\r\n  content: \"\\F12F7\";\r\n}\r\n\r\n.mdi-tag-off::before {\r\n  content: \"\\F1220\";\r\n}\r\n\r\n.mdi-tag-off-outline::before {\r\n  content: \"\\F1221\";\r\n}\r\n\r\n.mdi-tag-outline::before {\r\n  content: \"\\F04FC\";\r\n}\r\n\r\n.mdi-tag-plus::before {\r\n  content: \"\\F0722\";\r\n}\r\n\r\n.mdi-tag-plus-outline::before {\r\n  content: \"\\F1222\";\r\n}\r\n\r\n.mdi-tag-remove::before {\r\n  content: \"\\F0723\";\r\n}\r\n\r\n.mdi-tag-remove-outline::before {\r\n  content: \"\\F1223\";\r\n}\r\n\r\n.mdi-tag-search::before {\r\n  content: \"\\F1907\";\r\n}\r\n\r\n.mdi-tag-search-outline::before {\r\n  content: \"\\F1908\";\r\n}\r\n\r\n.mdi-tag-text::before {\r\n  content: \"\\F1224\";\r\n}\r\n\r\n.mdi-tag-text-outline::before {\r\n  content: \"\\F04FD\";\r\n}\r\n\r\n.mdi-tailwind::before {\r\n  content: \"\\F13FF\";\r\n}\r\n\r\n.mdi-tangram::before {\r\n  content: \"\\F04F8\";\r\n}\r\n\r\n.mdi-tank::before {\r\n  content: \"\\F0D3A\";\r\n}\r\n\r\n.mdi-tanker-truck::before {\r\n  content: \"\\F0FE5\";\r\n}\r\n\r\n.mdi-tape-drive::before {\r\n  content: \"\\F16DF\";\r\n}\r\n\r\n.mdi-tape-measure::before {\r\n  content: \"\\F0B4D\";\r\n}\r\n\r\n.mdi-target::before {\r\n  content: \"\\F04FE\";\r\n}\r\n\r\n.mdi-target-account::before {\r\n  content: \"\\F0BD0\";\r\n}\r\n\r\n.mdi-target-variant::before {\r\n  content: \"\\F0A77\";\r\n}\r\n\r\n.mdi-taxi::before {\r\n  content: \"\\F04FF\";\r\n}\r\n\r\n.mdi-tea::before {\r\n  content: \"\\F0D9E\";\r\n}\r\n\r\n.mdi-tea-outline::before {\r\n  content: \"\\F0D9F\";\r\n}\r\n\r\n.mdi-teamviewer::before {\r\n  content: \"\\F0500\";\r\n}\r\n\r\n.mdi-teddy-bear::before {\r\n  content: \"\\F18FB\";\r\n}\r\n\r\n.mdi-telescope::before {\r\n  content: \"\\F0B4E\";\r\n}\r\n\r\n.mdi-television::before {\r\n  content: \"\\F0502\";\r\n}\r\n\r\n.mdi-television-ambient-light::before {\r\n  content: \"\\F1356\";\r\n}\r\n\r\n.mdi-television-box::before {\r\n  content: \"\\F0839\";\r\n}\r\n\r\n.mdi-television-classic::before {\r\n  content: \"\\F07F4\";\r\n}\r\n\r\n.mdi-television-classic-off::before {\r\n  content: \"\\F083A\";\r\n}\r\n\r\n.mdi-television-guide::before {\r\n  content: \"\\F0503\";\r\n}\r\n\r\n.mdi-television-off::before {\r\n  content: \"\\F083B\";\r\n}\r\n\r\n.mdi-television-pause::before {\r\n  content: \"\\F0F89\";\r\n}\r\n\r\n.mdi-television-play::before {\r\n  content: \"\\F0ECF\";\r\n}\r\n\r\n.mdi-television-shimmer::before {\r\n  content: \"\\F1110\";\r\n}\r\n\r\n.mdi-television-stop::before {\r\n  content: \"\\F0F8A\";\r\n}\r\n\r\n.mdi-temperature-celsius::before {\r\n  content: \"\\F0504\";\r\n}\r\n\r\n.mdi-temperature-fahrenheit::before {\r\n  content: \"\\F0505\";\r\n}\r\n\r\n.mdi-temperature-kelvin::before {\r\n  content: \"\\F0506\";\r\n}\r\n\r\n.mdi-tennis::before {\r\n  content: \"\\F0DA0\";\r\n}\r\n\r\n.mdi-tennis-ball::before {\r\n  content: \"\\F0507\";\r\n}\r\n\r\n.mdi-tent::before {\r\n  content: \"\\F0508\";\r\n}\r\n\r\n.mdi-terraform::before {\r\n  content: \"\\F1062\";\r\n}\r\n\r\n.mdi-terrain::before {\r\n  content: \"\\F0509\";\r\n}\r\n\r\n.mdi-test-tube::before {\r\n  content: \"\\F0668\";\r\n}\r\n\r\n.mdi-test-tube-empty::before {\r\n  content: \"\\F0911\";\r\n}\r\n\r\n.mdi-test-tube-off::before {\r\n  content: \"\\F0912\";\r\n}\r\n\r\n.mdi-text::before {\r\n  content: \"\\F09A8\";\r\n}\r\n\r\n.mdi-text-account::before {\r\n  content: \"\\F1570\";\r\n}\r\n\r\n.mdi-text-box::before {\r\n  content: \"\\F021A\";\r\n}\r\n\r\n.mdi-text-box-check::before {\r\n  content: \"\\F0EA6\";\r\n}\r\n\r\n.mdi-text-box-check-outline::before {\r\n  content: \"\\F0EA7\";\r\n}\r\n\r\n.mdi-text-box-minus::before {\r\n  content: \"\\F0EA8\";\r\n}\r\n\r\n.mdi-text-box-minus-outline::before {\r\n  content: \"\\F0EA9\";\r\n}\r\n\r\n.mdi-text-box-multiple::before {\r\n  content: \"\\F0AB7\";\r\n}\r\n\r\n.mdi-text-box-multiple-outline::before {\r\n  content: \"\\F0AB8\";\r\n}\r\n\r\n.mdi-text-box-outline::before {\r\n  content: \"\\F09ED\";\r\n}\r\n\r\n.mdi-text-box-plus::before {\r\n  content: \"\\F0EAA\";\r\n}\r\n\r\n.mdi-text-box-plus-outline::before {\r\n  content: \"\\F0EAB\";\r\n}\r\n\r\n.mdi-text-box-remove::before {\r\n  content: \"\\F0EAC\";\r\n}\r\n\r\n.mdi-text-box-remove-outline::before {\r\n  content: \"\\F0EAD\";\r\n}\r\n\r\n.mdi-text-box-search::before {\r\n  content: \"\\F0EAE\";\r\n}\r\n\r\n.mdi-text-box-search-outline::before {\r\n  content: \"\\F0EAF\";\r\n}\r\n\r\n.mdi-text-long::before {\r\n  content: \"\\F09AA\";\r\n}\r\n\r\n.mdi-text-recognition::before {\r\n  content: \"\\F113D\";\r\n}\r\n\r\n.mdi-text-search::before {\r\n  content: \"\\F13B8\";\r\n}\r\n\r\n.mdi-text-shadow::before {\r\n  content: \"\\F0669\";\r\n}\r\n\r\n.mdi-text-short::before {\r\n  content: \"\\F09A9\";\r\n}\r\n\r\n.mdi-text-to-speech::before {\r\n  content: \"\\F050A\";\r\n}\r\n\r\n.mdi-text-to-speech-off::before {\r\n  content: \"\\F050B\";\r\n}\r\n\r\n.mdi-texture::before {\r\n  content: \"\\F050C\";\r\n}\r\n\r\n.mdi-texture-box::before {\r\n  content: \"\\F0FE6\";\r\n}\r\n\r\n.mdi-theater::before {\r\n  content: \"\\F050D\";\r\n}\r\n\r\n.mdi-theme-light-dark::before {\r\n  content: \"\\F050E\";\r\n}\r\n\r\n.mdi-thermometer::before {\r\n  content: \"\\F050F\";\r\n}\r\n\r\n.mdi-thermometer-alert::before {\r\n  content: \"\\F0E01\";\r\n}\r\n\r\n.mdi-thermometer-bluetooth::before {\r\n  content: \"\\F1895\";\r\n}\r\n\r\n.mdi-thermometer-chevron-down::before {\r\n  content: \"\\F0E02\";\r\n}\r\n\r\n.mdi-thermometer-chevron-up::before {\r\n  content: \"\\F0E03\";\r\n}\r\n\r\n.mdi-thermometer-high::before {\r\n  content: \"\\F10C2\";\r\n}\r\n\r\n.mdi-thermometer-lines::before {\r\n  content: \"\\F0510\";\r\n}\r\n\r\n.mdi-thermometer-low::before {\r\n  content: \"\\F10C3\";\r\n}\r\n\r\n.mdi-thermometer-minus::before {\r\n  content: \"\\F0E04\";\r\n}\r\n\r\n.mdi-thermometer-off::before {\r\n  content: \"\\F1531\";\r\n}\r\n\r\n.mdi-thermometer-plus::before {\r\n  content: \"\\F0E05\";\r\n}\r\n\r\n.mdi-thermostat::before {\r\n  content: \"\\F0393\";\r\n}\r\n\r\n.mdi-thermostat-box::before {\r\n  content: \"\\F0891\";\r\n}\r\n\r\n.mdi-thought-bubble::before {\r\n  content: \"\\F07F6\";\r\n}\r\n\r\n.mdi-thought-bubble-outline::before {\r\n  content: \"\\F07F7\";\r\n}\r\n\r\n.mdi-thumb-down::before {\r\n  content: \"\\F0511\";\r\n}\r\n\r\n.mdi-thumb-down-outline::before {\r\n  content: \"\\F0512\";\r\n}\r\n\r\n.mdi-thumb-up::before {\r\n  content: \"\\F0513\";\r\n}\r\n\r\n.mdi-thumb-up-outline::before {\r\n  content: \"\\F0514\";\r\n}\r\n\r\n.mdi-thumbs-up-down::before {\r\n  content: \"\\F0515\";\r\n}\r\n\r\n.mdi-thumbs-up-down-outline::before {\r\n  content: \"\\F1914\";\r\n}\r\n\r\n.mdi-ticket::before {\r\n  content: \"\\F0516\";\r\n}\r\n\r\n.mdi-ticket-account::before {\r\n  content: \"\\F0517\";\r\n}\r\n\r\n.mdi-ticket-confirmation::before {\r\n  content: \"\\F0518\";\r\n}\r\n\r\n.mdi-ticket-confirmation-outline::before {\r\n  content: \"\\F13AA\";\r\n}\r\n\r\n.mdi-ticket-outline::before {\r\n  content: \"\\F0913\";\r\n}\r\n\r\n.mdi-ticket-percent::before {\r\n  content: \"\\F0724\";\r\n}\r\n\r\n.mdi-ticket-percent-outline::before {\r\n  content: \"\\F142B\";\r\n}\r\n\r\n.mdi-tie::before {\r\n  content: \"\\F0519\";\r\n}\r\n\r\n.mdi-tilde::before {\r\n  content: \"\\F0725\";\r\n}\r\n\r\n.mdi-tilde-off::before {\r\n  content: \"\\F18F3\";\r\n}\r\n\r\n.mdi-timelapse::before {\r\n  content: \"\\F051A\";\r\n}\r\n\r\n.mdi-timeline::before {\r\n  content: \"\\F0BD1\";\r\n}\r\n\r\n.mdi-timeline-alert::before {\r\n  content: \"\\F0F95\";\r\n}\r\n\r\n.mdi-timeline-alert-outline::before {\r\n  content: \"\\F0F98\";\r\n}\r\n\r\n.mdi-timeline-check::before {\r\n  content: \"\\F1532\";\r\n}\r\n\r\n.mdi-timeline-check-outline::before {\r\n  content: \"\\F1533\";\r\n}\r\n\r\n.mdi-timeline-clock::before {\r\n  content: \"\\F11FB\";\r\n}\r\n\r\n.mdi-timeline-clock-outline::before {\r\n  content: \"\\F11FC\";\r\n}\r\n\r\n.mdi-timeline-help::before {\r\n  content: \"\\F0F99\";\r\n}\r\n\r\n.mdi-timeline-help-outline::before {\r\n  content: \"\\F0F9A\";\r\n}\r\n\r\n.mdi-timeline-minus::before {\r\n  content: \"\\F1534\";\r\n}\r\n\r\n.mdi-timeline-minus-outline::before {\r\n  content: \"\\F1535\";\r\n}\r\n\r\n.mdi-timeline-outline::before {\r\n  content: \"\\F0BD2\";\r\n}\r\n\r\n.mdi-timeline-plus::before {\r\n  content: \"\\F0F96\";\r\n}\r\n\r\n.mdi-timeline-plus-outline::before {\r\n  content: \"\\F0F97\";\r\n}\r\n\r\n.mdi-timeline-remove::before {\r\n  content: \"\\F1536\";\r\n}\r\n\r\n.mdi-timeline-remove-outline::before {\r\n  content: \"\\F1537\";\r\n}\r\n\r\n.mdi-timeline-text::before {\r\n  content: \"\\F0BD3\";\r\n}\r\n\r\n.mdi-timeline-text-outline::before {\r\n  content: \"\\F0BD4\";\r\n}\r\n\r\n.mdi-timer::before {\r\n  content: \"\\F13AB\";\r\n}\r\n\r\n.mdi-timer-10::before {\r\n  content: \"\\F051C\";\r\n}\r\n\r\n.mdi-timer-3::before {\r\n  content: \"\\F051D\";\r\n}\r\n\r\n.mdi-timer-cog::before {\r\n  content: \"\\F1925\";\r\n}\r\n\r\n.mdi-timer-cog-outline::before {\r\n  content: \"\\F1926\";\r\n}\r\n\r\n.mdi-timer-off::before {\r\n  content: \"\\F13AC\";\r\n}\r\n\r\n.mdi-timer-off-outline::before {\r\n  content: \"\\F051E\";\r\n}\r\n\r\n.mdi-timer-outline::before {\r\n  content: \"\\F051B\";\r\n}\r\n\r\n.mdi-timer-sand::before {\r\n  content: \"\\F051F\";\r\n}\r\n\r\n.mdi-timer-sand-complete::before {\r\n  content: \"\\F199F\";\r\n}\r\n\r\n.mdi-timer-sand-empty::before {\r\n  content: \"\\F06AD\";\r\n}\r\n\r\n.mdi-timer-sand-full::before {\r\n  content: \"\\F078C\";\r\n}\r\n\r\n.mdi-timer-sand-paused::before {\r\n  content: \"\\F19A0\";\r\n}\r\n\r\n.mdi-timer-settings::before {\r\n  content: \"\\F1923\";\r\n}\r\n\r\n.mdi-timer-settings-outline::before {\r\n  content: \"\\F1924\";\r\n}\r\n\r\n.mdi-timetable::before {\r\n  content: \"\\F0520\";\r\n}\r\n\r\n.mdi-tire::before {\r\n  content: \"\\F1896\";\r\n}\r\n\r\n.mdi-toaster::before {\r\n  content: \"\\F1063\";\r\n}\r\n\r\n.mdi-toaster-off::before {\r\n  content: \"\\F11B7\";\r\n}\r\n\r\n.mdi-toaster-oven::before {\r\n  content: \"\\F0CD3\";\r\n}\r\n\r\n.mdi-toggle-switch::before {\r\n  content: \"\\F0521\";\r\n}\r\n\r\n.mdi-toggle-switch-off::before {\r\n  content: \"\\F0522\";\r\n}\r\n\r\n.mdi-toggle-switch-off-outline::before {\r\n  content: \"\\F0A19\";\r\n}\r\n\r\n.mdi-toggle-switch-outline::before {\r\n  content: \"\\F0A1A\";\r\n}\r\n\r\n.mdi-toilet::before {\r\n  content: \"\\F09AB\";\r\n}\r\n\r\n.mdi-toolbox::before {\r\n  content: \"\\F09AC\";\r\n}\r\n\r\n.mdi-toolbox-outline::before {\r\n  content: \"\\F09AD\";\r\n}\r\n\r\n.mdi-tools::before {\r\n  content: \"\\F1064\";\r\n}\r\n\r\n.mdi-tooltip::before {\r\n  content: \"\\F0523\";\r\n}\r\n\r\n.mdi-tooltip-account::before {\r\n  content: \"\\F000C\";\r\n}\r\n\r\n.mdi-tooltip-cellphone::before {\r\n  content: \"\\F183B\";\r\n}\r\n\r\n.mdi-tooltip-check::before {\r\n  content: \"\\F155C\";\r\n}\r\n\r\n.mdi-tooltip-check-outline::before {\r\n  content: \"\\F155D\";\r\n}\r\n\r\n.mdi-tooltip-edit::before {\r\n  content: \"\\F0524\";\r\n}\r\n\r\n.mdi-tooltip-edit-outline::before {\r\n  content: \"\\F12C5\";\r\n}\r\n\r\n.mdi-tooltip-image::before {\r\n  content: \"\\F0525\";\r\n}\r\n\r\n.mdi-tooltip-image-outline::before {\r\n  content: \"\\F0BD5\";\r\n}\r\n\r\n.mdi-tooltip-minus::before {\r\n  content: \"\\F155E\";\r\n}\r\n\r\n.mdi-tooltip-minus-outline::before {\r\n  content: \"\\F155F\";\r\n}\r\n\r\n.mdi-tooltip-outline::before {\r\n  content: \"\\F0526\";\r\n}\r\n\r\n.mdi-tooltip-plus::before {\r\n  content: \"\\F0BD6\";\r\n}\r\n\r\n.mdi-tooltip-plus-outline::before {\r\n  content: \"\\F0527\";\r\n}\r\n\r\n.mdi-tooltip-remove::before {\r\n  content: \"\\F1560\";\r\n}\r\n\r\n.mdi-tooltip-remove-outline::before {\r\n  content: \"\\F1561\";\r\n}\r\n\r\n.mdi-tooltip-text::before {\r\n  content: \"\\F0528\";\r\n}\r\n\r\n.mdi-tooltip-text-outline::before {\r\n  content: \"\\F0BD7\";\r\n}\r\n\r\n.mdi-tooth::before {\r\n  content: \"\\F08C3\";\r\n}\r\n\r\n.mdi-tooth-outline::before {\r\n  content: \"\\F0529\";\r\n}\r\n\r\n.mdi-toothbrush::before {\r\n  content: \"\\F1129\";\r\n}\r\n\r\n.mdi-toothbrush-electric::before {\r\n  content: \"\\F112C\";\r\n}\r\n\r\n.mdi-toothbrush-paste::before {\r\n  content: \"\\F112A\";\r\n}\r\n\r\n.mdi-torch::before {\r\n  content: \"\\F1606\";\r\n}\r\n\r\n.mdi-tortoise::before {\r\n  content: \"\\F0D3B\";\r\n}\r\n\r\n.mdi-toslink::before {\r\n  content: \"\\F12B8\";\r\n}\r\n\r\n.mdi-tournament::before {\r\n  content: \"\\F09AE\";\r\n}\r\n\r\n.mdi-tow-truck::before {\r\n  content: \"\\F083C\";\r\n}\r\n\r\n.mdi-tower-beach::before {\r\n  content: \"\\F0681\";\r\n}\r\n\r\n.mdi-tower-fire::before {\r\n  content: \"\\F0682\";\r\n}\r\n\r\n.mdi-town-hall::before {\r\n  content: \"\\F1875\";\r\n}\r\n\r\n.mdi-toy-brick::before {\r\n  content: \"\\F1288\";\r\n}\r\n\r\n.mdi-toy-brick-marker::before {\r\n  content: \"\\F1289\";\r\n}\r\n\r\n.mdi-toy-brick-marker-outline::before {\r\n  content: \"\\F128A\";\r\n}\r\n\r\n.mdi-toy-brick-minus::before {\r\n  content: \"\\F128B\";\r\n}\r\n\r\n.mdi-toy-brick-minus-outline::before {\r\n  content: \"\\F128C\";\r\n}\r\n\r\n.mdi-toy-brick-outline::before {\r\n  content: \"\\F128D\";\r\n}\r\n\r\n.mdi-toy-brick-plus::before {\r\n  content: \"\\F128E\";\r\n}\r\n\r\n.mdi-toy-brick-plus-outline::before {\r\n  content: \"\\F128F\";\r\n}\r\n\r\n.mdi-toy-brick-remove::before {\r\n  content: \"\\F1290\";\r\n}\r\n\r\n.mdi-toy-brick-remove-outline::before {\r\n  content: \"\\F1291\";\r\n}\r\n\r\n.mdi-toy-brick-search::before {\r\n  content: \"\\F1292\";\r\n}\r\n\r\n.mdi-toy-brick-search-outline::before {\r\n  content: \"\\F1293\";\r\n}\r\n\r\n.mdi-track-light::before {\r\n  content: \"\\F0914\";\r\n}\r\n\r\n.mdi-trackpad::before {\r\n  content: \"\\F07F8\";\r\n}\r\n\r\n.mdi-trackpad-lock::before {\r\n  content: \"\\F0933\";\r\n}\r\n\r\n.mdi-tractor::before {\r\n  content: \"\\F0892\";\r\n}\r\n\r\n.mdi-tractor-variant::before {\r\n  content: \"\\F14C4\";\r\n}\r\n\r\n.mdi-trademark::before {\r\n  content: \"\\F0A78\";\r\n}\r\n\r\n.mdi-traffic-cone::before {\r\n  content: \"\\F137C\";\r\n}\r\n\r\n.mdi-traffic-light::before {\r\n  content: \"\\F052B\";\r\n}\r\n\r\n.mdi-traffic-light-outline::before {\r\n  content: \"\\F182A\";\r\n}\r\n\r\n.mdi-train::before {\r\n  content: \"\\F052C\";\r\n}\r\n\r\n.mdi-train-car::before {\r\n  content: \"\\F0BD8\";\r\n}\r\n\r\n.mdi-train-car-passenger::before {\r\n  content: \"\\F1733\";\r\n}\r\n\r\n.mdi-train-car-passenger-door::before {\r\n  content: \"\\F1734\";\r\n}\r\n\r\n.mdi-train-car-passenger-door-open::before {\r\n  content: \"\\F1735\";\r\n}\r\n\r\n.mdi-train-car-passenger-variant::before {\r\n  content: \"\\F1736\";\r\n}\r\n\r\n.mdi-train-variant::before {\r\n  content: \"\\F08C4\";\r\n}\r\n\r\n.mdi-tram::before {\r\n  content: \"\\F052D\";\r\n}\r\n\r\n.mdi-tram-side::before {\r\n  content: \"\\F0FE7\";\r\n}\r\n\r\n.mdi-transcribe::before {\r\n  content: \"\\F052E\";\r\n}\r\n\r\n.mdi-transcribe-close::before {\r\n  content: \"\\F052F\";\r\n}\r\n\r\n.mdi-transfer::before {\r\n  content: \"\\F1065\";\r\n}\r\n\r\n.mdi-transfer-down::before {\r\n  content: \"\\F0DA1\";\r\n}\r\n\r\n.mdi-transfer-left::before {\r\n  content: \"\\F0DA2\";\r\n}\r\n\r\n.mdi-transfer-right::before {\r\n  content: \"\\F0530\";\r\n}\r\n\r\n.mdi-transfer-up::before {\r\n  content: \"\\F0DA3\";\r\n}\r\n\r\n.mdi-transit-connection::before {\r\n  content: \"\\F0D3C\";\r\n}\r\n\r\n.mdi-transit-connection-horizontal::before {\r\n  content: \"\\F1546\";\r\n}\r\n\r\n.mdi-transit-connection-variant::before {\r\n  content: \"\\F0D3D\";\r\n}\r\n\r\n.mdi-transit-detour::before {\r\n  content: \"\\F0F8B\";\r\n}\r\n\r\n.mdi-transit-skip::before {\r\n  content: \"\\F1515\";\r\n}\r\n\r\n.mdi-transit-transfer::before {\r\n  content: \"\\F06AE\";\r\n}\r\n\r\n.mdi-transition::before {\r\n  content: \"\\F0915\";\r\n}\r\n\r\n.mdi-transition-masked::before {\r\n  content: \"\\F0916\";\r\n}\r\n\r\n.mdi-translate::before {\r\n  content: \"\\F05CA\";\r\n}\r\n\r\n.mdi-translate-off::before {\r\n  content: \"\\F0E06\";\r\n}\r\n\r\n.mdi-transmission-tower::before {\r\n  content: \"\\F0D3E\";\r\n}\r\n\r\n.mdi-transmission-tower-export::before {\r\n  content: \"\\F192C\";\r\n}\r\n\r\n.mdi-transmission-tower-import::before {\r\n  content: \"\\F192D\";\r\n}\r\n\r\n.mdi-trash-can::before {\r\n  content: \"\\F0A79\";\r\n}\r\n\r\n.mdi-trash-can-outline::before {\r\n  content: \"\\F0A7A\";\r\n}\r\n\r\n.mdi-tray::before {\r\n  content: \"\\F1294\";\r\n}\r\n\r\n.mdi-tray-alert::before {\r\n  content: \"\\F1295\";\r\n}\r\n\r\n.mdi-tray-arrow-down::before {\r\n  content: \"\\F0120\";\r\n}\r\n\r\n.mdi-tray-arrow-up::before {\r\n  content: \"\\F011D\";\r\n}\r\n\r\n.mdi-tray-full::before {\r\n  content: \"\\F1296\";\r\n}\r\n\r\n.mdi-tray-minus::before {\r\n  content: \"\\F1297\";\r\n}\r\n\r\n.mdi-tray-plus::before {\r\n  content: \"\\F1298\";\r\n}\r\n\r\n.mdi-tray-remove::before {\r\n  content: \"\\F1299\";\r\n}\r\n\r\n.mdi-treasure-chest::before {\r\n  content: \"\\F0726\";\r\n}\r\n\r\n.mdi-tree::before {\r\n  content: \"\\F0531\";\r\n}\r\n\r\n.mdi-tree-outline::before {\r\n  content: \"\\F0E69\";\r\n}\r\n\r\n.mdi-trello::before {\r\n  content: \"\\F0532\";\r\n}\r\n\r\n.mdi-trending-down::before {\r\n  content: \"\\F0533\";\r\n}\r\n\r\n.mdi-trending-neutral::before {\r\n  content: \"\\F0534\";\r\n}\r\n\r\n.mdi-trending-up::before {\r\n  content: \"\\F0535\";\r\n}\r\n\r\n.mdi-triangle::before {\r\n  content: \"\\F0536\";\r\n}\r\n\r\n.mdi-triangle-outline::before {\r\n  content: \"\\F0537\";\r\n}\r\n\r\n.mdi-triangle-wave::before {\r\n  content: \"\\F147C\";\r\n}\r\n\r\n.mdi-triforce::before {\r\n  content: \"\\F0BD9\";\r\n}\r\n\r\n.mdi-trophy::before {\r\n  content: \"\\F0538\";\r\n}\r\n\r\n.mdi-trophy-award::before {\r\n  content: \"\\F0539\";\r\n}\r\n\r\n.mdi-trophy-broken::before {\r\n  content: \"\\F0DA4\";\r\n}\r\n\r\n.mdi-trophy-outline::before {\r\n  content: \"\\F053A\";\r\n}\r\n\r\n.mdi-trophy-variant::before {\r\n  content: \"\\F053B\";\r\n}\r\n\r\n.mdi-trophy-variant-outline::before {\r\n  content: \"\\F053C\";\r\n}\r\n\r\n.mdi-truck::before {\r\n  content: \"\\F053D\";\r\n}\r\n\r\n.mdi-truck-cargo-container::before {\r\n  content: \"\\F18D8\";\r\n}\r\n\r\n.mdi-truck-check::before {\r\n  content: \"\\F0CD4\";\r\n}\r\n\r\n.mdi-truck-check-outline::before {\r\n  content: \"\\F129A\";\r\n}\r\n\r\n.mdi-truck-delivery::before {\r\n  content: \"\\F053E\";\r\n}\r\n\r\n.mdi-truck-delivery-outline::before {\r\n  content: \"\\F129B\";\r\n}\r\n\r\n.mdi-truck-fast::before {\r\n  content: \"\\F0788\";\r\n}\r\n\r\n.mdi-truck-fast-outline::before {\r\n  content: \"\\F129C\";\r\n}\r\n\r\n.mdi-truck-flatbed::before {\r\n  content: \"\\F1891\";\r\n}\r\n\r\n.mdi-truck-minus::before {\r\n  content: \"\\F19AE\";\r\n}\r\n\r\n.mdi-truck-minus-outline::before {\r\n  content: \"\\F19BD\";\r\n}\r\n\r\n.mdi-truck-outline::before {\r\n  content: \"\\F129D\";\r\n}\r\n\r\n.mdi-truck-plus::before {\r\n  content: \"\\F19AD\";\r\n}\r\n\r\n.mdi-truck-plus-outline::before {\r\n  content: \"\\F19BC\";\r\n}\r\n\r\n.mdi-truck-remove::before {\r\n  content: \"\\F19AF\";\r\n}\r\n\r\n.mdi-truck-remove-outline::before {\r\n  content: \"\\F19BE\";\r\n}\r\n\r\n.mdi-truck-snowflake::before {\r\n  content: \"\\F19A6\";\r\n}\r\n\r\n.mdi-truck-trailer::before {\r\n  content: \"\\F0727\";\r\n}\r\n\r\n.mdi-trumpet::before {\r\n  content: \"\\F1096\";\r\n}\r\n\r\n.mdi-tshirt-crew::before {\r\n  content: \"\\F0A7B\";\r\n}\r\n\r\n.mdi-tshirt-crew-outline::before {\r\n  content: \"\\F053F\";\r\n}\r\n\r\n.mdi-tshirt-v::before {\r\n  content: \"\\F0A7C\";\r\n}\r\n\r\n.mdi-tshirt-v-outline::before {\r\n  content: \"\\F0540\";\r\n}\r\n\r\n.mdi-tumble-dryer::before {\r\n  content: \"\\F0917\";\r\n}\r\n\r\n.mdi-tumble-dryer-alert::before {\r\n  content: \"\\F11BA\";\r\n}\r\n\r\n.mdi-tumble-dryer-off::before {\r\n  content: \"\\F11BB\";\r\n}\r\n\r\n.mdi-tune::before {\r\n  content: \"\\F062E\";\r\n}\r\n\r\n.mdi-tune-variant::before {\r\n  content: \"\\F1542\";\r\n}\r\n\r\n.mdi-tune-vertical::before {\r\n  content: \"\\F066A\";\r\n}\r\n\r\n.mdi-tune-vertical-variant::before {\r\n  content: \"\\F1543\";\r\n}\r\n\r\n.mdi-tunnel::before {\r\n  content: \"\\F183D\";\r\n}\r\n\r\n.mdi-tunnel-outline::before {\r\n  content: \"\\F183E\";\r\n}\r\n\r\n.mdi-turkey::before {\r\n  content: \"\\F171B\";\r\n}\r\n\r\n.mdi-turnstile::before {\r\n  content: \"\\F0CD5\";\r\n}\r\n\r\n.mdi-turnstile-outline::before {\r\n  content: \"\\F0CD6\";\r\n}\r\n\r\n.mdi-turtle::before {\r\n  content: \"\\F0CD7\";\r\n}\r\n\r\n.mdi-twitch::before {\r\n  content: \"\\F0543\";\r\n}\r\n\r\n.mdi-twitter::before {\r\n  content: \"\\F0544\";\r\n}\r\n\r\n.mdi-two-factor-authentication::before {\r\n  content: \"\\F09AF\";\r\n}\r\n\r\n.mdi-typewriter::before {\r\n  content: \"\\F0F2D\";\r\n}\r\n\r\n.mdi-ubisoft::before {\r\n  content: \"\\F0BDA\";\r\n}\r\n\r\n.mdi-ubuntu::before {\r\n  content: \"\\F0548\";\r\n}\r\n\r\n.mdi-ufo::before {\r\n  content: \"\\F10C4\";\r\n}\r\n\r\n.mdi-ufo-outline::before {\r\n  content: \"\\F10C5\";\r\n}\r\n\r\n.mdi-ultra-high-definition::before {\r\n  content: \"\\F07F9\";\r\n}\r\n\r\n.mdi-umbraco::before {\r\n  content: \"\\F0549\";\r\n}\r\n\r\n.mdi-umbrella::before {\r\n  content: \"\\F054A\";\r\n}\r\n\r\n.mdi-umbrella-beach::before {\r\n  content: \"\\F188A\";\r\n}\r\n\r\n.mdi-umbrella-beach-outline::before {\r\n  content: \"\\F188B\";\r\n}\r\n\r\n.mdi-umbrella-closed::before {\r\n  content: \"\\F09B0\";\r\n}\r\n\r\n.mdi-umbrella-closed-outline::before {\r\n  content: \"\\F13E2\";\r\n}\r\n\r\n.mdi-umbrella-closed-variant::before {\r\n  content: \"\\F13E1\";\r\n}\r\n\r\n.mdi-umbrella-outline::before {\r\n  content: \"\\F054B\";\r\n}\r\n\r\n.mdi-undo::before {\r\n  content: \"\\F054C\";\r\n}\r\n\r\n.mdi-undo-variant::before {\r\n  content: \"\\F054D\";\r\n}\r\n\r\n.mdi-unfold-less-horizontal::before {\r\n  content: \"\\F054E\";\r\n}\r\n\r\n.mdi-unfold-less-vertical::before {\r\n  content: \"\\F0760\";\r\n}\r\n\r\n.mdi-unfold-more-horizontal::before {\r\n  content: \"\\F054F\";\r\n}\r\n\r\n.mdi-unfold-more-vertical::before {\r\n  content: \"\\F0761\";\r\n}\r\n\r\n.mdi-ungroup::before {\r\n  content: \"\\F0550\";\r\n}\r\n\r\n.mdi-unicode::before {\r\n  content: \"\\F0ED0\";\r\n}\r\n\r\n.mdi-unicorn::before {\r\n  content: \"\\F15C2\";\r\n}\r\n\r\n.mdi-unicorn-variant::before {\r\n  content: \"\\F15C3\";\r\n}\r\n\r\n.mdi-unicycle::before {\r\n  content: \"\\F15E5\";\r\n}\r\n\r\n.mdi-unity::before {\r\n  content: \"\\F06AF\";\r\n}\r\n\r\n.mdi-unreal::before {\r\n  content: \"\\F09B1\";\r\n}\r\n\r\n.mdi-update::before {\r\n  content: \"\\F06B0\";\r\n}\r\n\r\n.mdi-upload::before {\r\n  content: \"\\F0552\";\r\n}\r\n\r\n.mdi-upload-lock::before {\r\n  content: \"\\F1373\";\r\n}\r\n\r\n.mdi-upload-lock-outline::before {\r\n  content: \"\\F1374\";\r\n}\r\n\r\n.mdi-upload-multiple::before {\r\n  content: \"\\F083D\";\r\n}\r\n\r\n.mdi-upload-network::before {\r\n  content: \"\\F06F6\";\r\n}\r\n\r\n.mdi-upload-network-outline::before {\r\n  content: \"\\F0CD8\";\r\n}\r\n\r\n.mdi-upload-off::before {\r\n  content: \"\\F10C6\";\r\n}\r\n\r\n.mdi-upload-off-outline::before {\r\n  content: \"\\F10C7\";\r\n}\r\n\r\n.mdi-upload-outline::before {\r\n  content: \"\\F0E07\";\r\n}\r\n\r\n.mdi-usb::before {\r\n  content: \"\\F0553\";\r\n}\r\n\r\n.mdi-usb-flash-drive::before {\r\n  content: \"\\F129E\";\r\n}\r\n\r\n.mdi-usb-flash-drive-outline::before {\r\n  content: \"\\F129F\";\r\n}\r\n\r\n.mdi-usb-port::before {\r\n  content: \"\\F11F0\";\r\n}\r\n\r\n.mdi-vacuum::before {\r\n  content: \"\\F19A1\";\r\n}\r\n\r\n.mdi-vacuum-outline::before {\r\n  content: \"\\F19A2\";\r\n}\r\n\r\n.mdi-valve::before {\r\n  content: \"\\F1066\";\r\n}\r\n\r\n.mdi-valve-closed::before {\r\n  content: \"\\F1067\";\r\n}\r\n\r\n.mdi-valve-open::before {\r\n  content: \"\\F1068\";\r\n}\r\n\r\n.mdi-van-passenger::before {\r\n  content: \"\\F07FA\";\r\n}\r\n\r\n.mdi-van-utility::before {\r\n  content: \"\\F07FB\";\r\n}\r\n\r\n.mdi-vanish::before {\r\n  content: \"\\F07FC\";\r\n}\r\n\r\n.mdi-vanish-quarter::before {\r\n  content: \"\\F1554\";\r\n}\r\n\r\n.mdi-vanity-light::before {\r\n  content: \"\\F11E1\";\r\n}\r\n\r\n.mdi-variable::before {\r\n  content: \"\\F0AE7\";\r\n}\r\n\r\n.mdi-variable-box::before {\r\n  content: \"\\F1111\";\r\n}\r\n\r\n.mdi-vector-arrange-above::before {\r\n  content: \"\\F0554\";\r\n}\r\n\r\n.mdi-vector-arrange-below::before {\r\n  content: \"\\F0555\";\r\n}\r\n\r\n.mdi-vector-bezier::before {\r\n  content: \"\\F0AE8\";\r\n}\r\n\r\n.mdi-vector-circle::before {\r\n  content: \"\\F0556\";\r\n}\r\n\r\n.mdi-vector-circle-variant::before {\r\n  content: \"\\F0557\";\r\n}\r\n\r\n.mdi-vector-combine::before {\r\n  content: \"\\F0558\";\r\n}\r\n\r\n.mdi-vector-curve::before {\r\n  content: \"\\F0559\";\r\n}\r\n\r\n.mdi-vector-difference::before {\r\n  content: \"\\F055A\";\r\n}\r\n\r\n.mdi-vector-difference-ab::before {\r\n  content: \"\\F055B\";\r\n}\r\n\r\n.mdi-vector-difference-ba::before {\r\n  content: \"\\F055C\";\r\n}\r\n\r\n.mdi-vector-ellipse::before {\r\n  content: \"\\F0893\";\r\n}\r\n\r\n.mdi-vector-intersection::before {\r\n  content: \"\\F055D\";\r\n}\r\n\r\n.mdi-vector-line::before {\r\n  content: \"\\F055E\";\r\n}\r\n\r\n.mdi-vector-link::before {\r\n  content: \"\\F0FE8\";\r\n}\r\n\r\n.mdi-vector-point::before {\r\n  content: \"\\F055F\";\r\n}\r\n\r\n.mdi-vector-polygon::before {\r\n  content: \"\\F0560\";\r\n}\r\n\r\n.mdi-vector-polygon-variant::before {\r\n  content: \"\\F1856\";\r\n}\r\n\r\n.mdi-vector-polyline::before {\r\n  content: \"\\F0561\";\r\n}\r\n\r\n.mdi-vector-polyline-edit::before {\r\n  content: \"\\F1225\";\r\n}\r\n\r\n.mdi-vector-polyline-minus::before {\r\n  content: \"\\F1226\";\r\n}\r\n\r\n.mdi-vector-polyline-plus::before {\r\n  content: \"\\F1227\";\r\n}\r\n\r\n.mdi-vector-polyline-remove::before {\r\n  content: \"\\F1228\";\r\n}\r\n\r\n.mdi-vector-radius::before {\r\n  content: \"\\F074A\";\r\n}\r\n\r\n.mdi-vector-rectangle::before {\r\n  content: \"\\F05C6\";\r\n}\r\n\r\n.mdi-vector-selection::before {\r\n  content: \"\\F0562\";\r\n}\r\n\r\n.mdi-vector-square::before {\r\n  content: \"\\F0001\";\r\n}\r\n\r\n.mdi-vector-square-close::before {\r\n  content: \"\\F1857\";\r\n}\r\n\r\n.mdi-vector-square-edit::before {\r\n  content: \"\\F18D9\";\r\n}\r\n\r\n.mdi-vector-square-minus::before {\r\n  content: \"\\F18DA\";\r\n}\r\n\r\n.mdi-vector-square-open::before {\r\n  content: \"\\F1858\";\r\n}\r\n\r\n.mdi-vector-square-plus::before {\r\n  content: \"\\F18DB\";\r\n}\r\n\r\n.mdi-vector-square-remove::before {\r\n  content: \"\\F18DC\";\r\n}\r\n\r\n.mdi-vector-triangle::before {\r\n  content: \"\\F0563\";\r\n}\r\n\r\n.mdi-vector-union::before {\r\n  content: \"\\F0564\";\r\n}\r\n\r\n.mdi-vhs::before {\r\n  content: \"\\F0A1B\";\r\n}\r\n\r\n.mdi-vibrate::before {\r\n  content: \"\\F0566\";\r\n}\r\n\r\n.mdi-vibrate-off::before {\r\n  content: \"\\F0CD9\";\r\n}\r\n\r\n.mdi-video::before {\r\n  content: \"\\F0567\";\r\n}\r\n\r\n.mdi-video-3d::before {\r\n  content: \"\\F07FD\";\r\n}\r\n\r\n.mdi-video-3d-off::before {\r\n  content: \"\\F13D9\";\r\n}\r\n\r\n.mdi-video-3d-variant::before {\r\n  content: \"\\F0ED1\";\r\n}\r\n\r\n.mdi-video-4k-box::before {\r\n  content: \"\\F083E\";\r\n}\r\n\r\n.mdi-video-account::before {\r\n  content: \"\\F0919\";\r\n}\r\n\r\n.mdi-video-box::before {\r\n  content: \"\\F00FD\";\r\n}\r\n\r\n.mdi-video-box-off::before {\r\n  content: \"\\F00FE\";\r\n}\r\n\r\n.mdi-video-check::before {\r\n  content: \"\\F1069\";\r\n}\r\n\r\n.mdi-video-check-outline::before {\r\n  content: \"\\F106A\";\r\n}\r\n\r\n.mdi-video-high-definition::before {\r\n  content: \"\\F152E\";\r\n}\r\n\r\n.mdi-video-image::before {\r\n  content: \"\\F091A\";\r\n}\r\n\r\n.mdi-video-input-antenna::before {\r\n  content: \"\\F083F\";\r\n}\r\n\r\n.mdi-video-input-component::before {\r\n  content: \"\\F0840\";\r\n}\r\n\r\n.mdi-video-input-hdmi::before {\r\n  content: \"\\F0841\";\r\n}\r\n\r\n.mdi-video-input-scart::before {\r\n  content: \"\\F0F8C\";\r\n}\r\n\r\n.mdi-video-input-svideo::before {\r\n  content: \"\\F0842\";\r\n}\r\n\r\n.mdi-video-marker::before {\r\n  content: \"\\F19A9\";\r\n}\r\n\r\n.mdi-video-marker-outline::before {\r\n  content: \"\\F19AA\";\r\n}\r\n\r\n.mdi-video-minus::before {\r\n  content: \"\\F09B2\";\r\n}\r\n\r\n.mdi-video-minus-outline::before {\r\n  content: \"\\F02BA\";\r\n}\r\n\r\n.mdi-video-off::before {\r\n  content: \"\\F0568\";\r\n}\r\n\r\n.mdi-video-off-outline::before {\r\n  content: \"\\F0BDB\";\r\n}\r\n\r\n.mdi-video-outline::before {\r\n  content: \"\\F0BDC\";\r\n}\r\n\r\n.mdi-video-plus::before {\r\n  content: \"\\F09B3\";\r\n}\r\n\r\n.mdi-video-plus-outline::before {\r\n  content: \"\\F01D3\";\r\n}\r\n\r\n.mdi-video-stabilization::before {\r\n  content: \"\\F091B\";\r\n}\r\n\r\n.mdi-video-switch::before {\r\n  content: \"\\F0569\";\r\n}\r\n\r\n.mdi-video-switch-outline::before {\r\n  content: \"\\F0790\";\r\n}\r\n\r\n.mdi-video-vintage::before {\r\n  content: \"\\F0A1C\";\r\n}\r\n\r\n.mdi-video-wireless::before {\r\n  content: \"\\F0ED2\";\r\n}\r\n\r\n.mdi-video-wireless-outline::before {\r\n  content: \"\\F0ED3\";\r\n}\r\n\r\n.mdi-view-agenda::before {\r\n  content: \"\\F056A\";\r\n}\r\n\r\n.mdi-view-agenda-outline::before {\r\n  content: \"\\F11D8\";\r\n}\r\n\r\n.mdi-view-array::before {\r\n  content: \"\\F056B\";\r\n}\r\n\r\n.mdi-view-array-outline::before {\r\n  content: \"\\F1485\";\r\n}\r\n\r\n.mdi-view-carousel::before {\r\n  content: \"\\F056C\";\r\n}\r\n\r\n.mdi-view-carousel-outline::before {\r\n  content: \"\\F1486\";\r\n}\r\n\r\n.mdi-view-column::before {\r\n  content: \"\\F056D\";\r\n}\r\n\r\n.mdi-view-column-outline::before {\r\n  content: \"\\F1487\";\r\n}\r\n\r\n.mdi-view-comfy::before {\r\n  content: \"\\F0E6A\";\r\n}\r\n\r\n.mdi-view-comfy-outline::before {\r\n  content: \"\\F1488\";\r\n}\r\n\r\n.mdi-view-compact::before {\r\n  content: \"\\F0E6B\";\r\n}\r\n\r\n.mdi-view-compact-outline::before {\r\n  content: \"\\F0E6C\";\r\n}\r\n\r\n.mdi-view-dashboard::before {\r\n  content: \"\\F056E\";\r\n}\r\n\r\n.mdi-view-dashboard-edit::before {\r\n  content: \"\\F1947\";\r\n}\r\n\r\n.mdi-view-dashboard-edit-outline::before {\r\n  content: \"\\F1948\";\r\n}\r\n\r\n.mdi-view-dashboard-outline::before {\r\n  content: \"\\F0A1D\";\r\n}\r\n\r\n.mdi-view-dashboard-variant::before {\r\n  content: \"\\F0843\";\r\n}\r\n\r\n.mdi-view-dashboard-variant-outline::before {\r\n  content: \"\\F1489\";\r\n}\r\n\r\n.mdi-view-day::before {\r\n  content: \"\\F056F\";\r\n}\r\n\r\n.mdi-view-day-outline::before {\r\n  content: \"\\F148A\";\r\n}\r\n\r\n.mdi-view-gallery::before {\r\n  content: \"\\F1888\";\r\n}\r\n\r\n.mdi-view-gallery-outline::before {\r\n  content: \"\\F1889\";\r\n}\r\n\r\n.mdi-view-grid::before {\r\n  content: \"\\F0570\";\r\n}\r\n\r\n.mdi-view-grid-outline::before {\r\n  content: \"\\F11D9\";\r\n}\r\n\r\n.mdi-view-grid-plus::before {\r\n  content: \"\\F0F8D\";\r\n}\r\n\r\n.mdi-view-grid-plus-outline::before {\r\n  content: \"\\F11DA\";\r\n}\r\n\r\n.mdi-view-headline::before {\r\n  content: \"\\F0571\";\r\n}\r\n\r\n.mdi-view-list::before {\r\n  content: \"\\F0572\";\r\n}\r\n\r\n.mdi-view-list-outline::before {\r\n  content: \"\\F148B\";\r\n}\r\n\r\n.mdi-view-module::before {\r\n  content: \"\\F0573\";\r\n}\r\n\r\n.mdi-view-module-outline::before {\r\n  content: \"\\F148C\";\r\n}\r\n\r\n.mdi-view-parallel::before {\r\n  content: \"\\F0728\";\r\n}\r\n\r\n.mdi-view-parallel-outline::before {\r\n  content: \"\\F148D\";\r\n}\r\n\r\n.mdi-view-quilt::before {\r\n  content: \"\\F0574\";\r\n}\r\n\r\n.mdi-view-quilt-outline::before {\r\n  content: \"\\F148E\";\r\n}\r\n\r\n.mdi-view-sequential::before {\r\n  content: \"\\F0729\";\r\n}\r\n\r\n.mdi-view-sequential-outline::before {\r\n  content: \"\\F148F\";\r\n}\r\n\r\n.mdi-view-split-horizontal::before {\r\n  content: \"\\F0BCB\";\r\n}\r\n\r\n.mdi-view-split-vertical::before {\r\n  content: \"\\F0BCC\";\r\n}\r\n\r\n.mdi-view-stream::before {\r\n  content: \"\\F0575\";\r\n}\r\n\r\n.mdi-view-stream-outline::before {\r\n  content: \"\\F1490\";\r\n}\r\n\r\n.mdi-view-week::before {\r\n  content: \"\\F0576\";\r\n}\r\n\r\n.mdi-view-week-outline::before {\r\n  content: \"\\F1491\";\r\n}\r\n\r\n.mdi-vimeo::before {\r\n  content: \"\\F0577\";\r\n}\r\n\r\n.mdi-violin::before {\r\n  content: \"\\F060F\";\r\n}\r\n\r\n.mdi-virtual-reality::before {\r\n  content: \"\\F0894\";\r\n}\r\n\r\n.mdi-virus::before {\r\n  content: \"\\F13B6\";\r\n}\r\n\r\n.mdi-virus-off::before {\r\n  content: \"\\F18E1\";\r\n}\r\n\r\n.mdi-virus-off-outline::before {\r\n  content: \"\\F18E2\";\r\n}\r\n\r\n.mdi-virus-outline::before {\r\n  content: \"\\F13B7\";\r\n}\r\n\r\n.mdi-vlc::before {\r\n  content: \"\\F057C\";\r\n}\r\n\r\n.mdi-voicemail::before {\r\n  content: \"\\F057D\";\r\n}\r\n\r\n.mdi-volleyball::before {\r\n  content: \"\\F09B4\";\r\n}\r\n\r\n.mdi-volume-high::before {\r\n  content: \"\\F057E\";\r\n}\r\n\r\n.mdi-volume-low::before {\r\n  content: \"\\F057F\";\r\n}\r\n\r\n.mdi-volume-medium::before {\r\n  content: \"\\F0580\";\r\n}\r\n\r\n.mdi-volume-minus::before {\r\n  content: \"\\F075E\";\r\n}\r\n\r\n.mdi-volume-mute::before {\r\n  content: \"\\F075F\";\r\n}\r\n\r\n.mdi-volume-off::before {\r\n  content: \"\\F0581\";\r\n}\r\n\r\n.mdi-volume-plus::before {\r\n  content: \"\\F075D\";\r\n}\r\n\r\n.mdi-volume-source::before {\r\n  content: \"\\F1120\";\r\n}\r\n\r\n.mdi-volume-variant-off::before {\r\n  content: \"\\F0E08\";\r\n}\r\n\r\n.mdi-volume-vibrate::before {\r\n  content: \"\\F1121\";\r\n}\r\n\r\n.mdi-vote::before {\r\n  content: \"\\F0A1F\";\r\n}\r\n\r\n.mdi-vote-outline::before {\r\n  content: \"\\F0A20\";\r\n}\r\n\r\n.mdi-vpn::before {\r\n  content: \"\\F0582\";\r\n}\r\n\r\n.mdi-vuejs::before {\r\n  content: \"\\F0844\";\r\n}\r\n\r\n.mdi-vuetify::before {\r\n  content: \"\\F0E6D\";\r\n}\r\n\r\n.mdi-walk::before {\r\n  content: \"\\F0583\";\r\n}\r\n\r\n.mdi-wall::before {\r\n  content: \"\\F07FE\";\r\n}\r\n\r\n.mdi-wall-sconce::before {\r\n  content: \"\\F091C\";\r\n}\r\n\r\n.mdi-wall-sconce-flat::before {\r\n  content: \"\\F091D\";\r\n}\r\n\r\n.mdi-wall-sconce-flat-outline::before {\r\n  content: \"\\F17C9\";\r\n}\r\n\r\n.mdi-wall-sconce-flat-variant::before {\r\n  content: \"\\F041C\";\r\n}\r\n\r\n.mdi-wall-sconce-flat-variant-outline::before {\r\n  content: \"\\F17CA\";\r\n}\r\n\r\n.mdi-wall-sconce-outline::before {\r\n  content: \"\\F17CB\";\r\n}\r\n\r\n.mdi-wall-sconce-round::before {\r\n  content: \"\\F0748\";\r\n}\r\n\r\n.mdi-wall-sconce-round-outline::before {\r\n  content: \"\\F17CC\";\r\n}\r\n\r\n.mdi-wall-sconce-round-variant::before {\r\n  content: \"\\F091E\";\r\n}\r\n\r\n.mdi-wall-sconce-round-variant-outline::before {\r\n  content: \"\\F17CD\";\r\n}\r\n\r\n.mdi-wallet::before {\r\n  content: \"\\F0584\";\r\n}\r\n\r\n.mdi-wallet-giftcard::before {\r\n  content: \"\\F0585\";\r\n}\r\n\r\n.mdi-wallet-membership::before {\r\n  content: \"\\F0586\";\r\n}\r\n\r\n.mdi-wallet-outline::before {\r\n  content: \"\\F0BDD\";\r\n}\r\n\r\n.mdi-wallet-plus::before {\r\n  content: \"\\F0F8E\";\r\n}\r\n\r\n.mdi-wallet-plus-outline::before {\r\n  content: \"\\F0F8F\";\r\n}\r\n\r\n.mdi-wallet-travel::before {\r\n  content: \"\\F0587\";\r\n}\r\n\r\n.mdi-wallpaper::before {\r\n  content: \"\\F0E09\";\r\n}\r\n\r\n.mdi-wan::before {\r\n  content: \"\\F0588\";\r\n}\r\n\r\n.mdi-wardrobe::before {\r\n  content: \"\\F0F90\";\r\n}\r\n\r\n.mdi-wardrobe-outline::before {\r\n  content: \"\\F0F91\";\r\n}\r\n\r\n.mdi-warehouse::before {\r\n  content: \"\\F0F81\";\r\n}\r\n\r\n.mdi-washing-machine::before {\r\n  content: \"\\F072A\";\r\n}\r\n\r\n.mdi-washing-machine-alert::before {\r\n  content: \"\\F11BC\";\r\n}\r\n\r\n.mdi-washing-machine-off::before {\r\n  content: \"\\F11BD\";\r\n}\r\n\r\n.mdi-watch::before {\r\n  content: \"\\F0589\";\r\n}\r\n\r\n.mdi-watch-export::before {\r\n  content: \"\\F058A\";\r\n}\r\n\r\n.mdi-watch-export-variant::before {\r\n  content: \"\\F0895\";\r\n}\r\n\r\n.mdi-watch-import::before {\r\n  content: \"\\F058B\";\r\n}\r\n\r\n.mdi-watch-import-variant::before {\r\n  content: \"\\F0896\";\r\n}\r\n\r\n.mdi-watch-variant::before {\r\n  content: \"\\F0897\";\r\n}\r\n\r\n.mdi-watch-vibrate::before {\r\n  content: \"\\F06B1\";\r\n}\r\n\r\n.mdi-watch-vibrate-off::before {\r\n  content: \"\\F0CDA\";\r\n}\r\n\r\n.mdi-water::before {\r\n  content: \"\\F058C\";\r\n}\r\n\r\n.mdi-water-alert::before {\r\n  content: \"\\F1502\";\r\n}\r\n\r\n.mdi-water-alert-outline::before {\r\n  content: \"\\F1503\";\r\n}\r\n\r\n.mdi-water-boiler::before {\r\n  content: \"\\F0F92\";\r\n}\r\n\r\n.mdi-water-boiler-alert::before {\r\n  content: \"\\F11B3\";\r\n}\r\n\r\n.mdi-water-boiler-off::before {\r\n  content: \"\\F11B4\";\r\n}\r\n\r\n.mdi-water-check::before {\r\n  content: \"\\F1504\";\r\n}\r\n\r\n.mdi-water-check-outline::before {\r\n  content: \"\\F1505\";\r\n}\r\n\r\n.mdi-water-circle::before {\r\n  content: \"\\F1806\";\r\n}\r\n\r\n.mdi-water-minus::before {\r\n  content: \"\\F1506\";\r\n}\r\n\r\n.mdi-water-minus-outline::before {\r\n  content: \"\\F1507\";\r\n}\r\n\r\n.mdi-water-off::before {\r\n  content: \"\\F058D\";\r\n}\r\n\r\n.mdi-water-off-outline::before {\r\n  content: \"\\F1508\";\r\n}\r\n\r\n.mdi-water-opacity::before {\r\n  content: \"\\F1855\";\r\n}\r\n\r\n.mdi-water-outline::before {\r\n  content: \"\\F0E0A\";\r\n}\r\n\r\n.mdi-water-percent::before {\r\n  content: \"\\F058E\";\r\n}\r\n\r\n.mdi-water-percent-alert::before {\r\n  content: \"\\F1509\";\r\n}\r\n\r\n.mdi-water-plus::before {\r\n  content: \"\\F150A\";\r\n}\r\n\r\n.mdi-water-plus-outline::before {\r\n  content: \"\\F150B\";\r\n}\r\n\r\n.mdi-water-polo::before {\r\n  content: \"\\F12A0\";\r\n}\r\n\r\n.mdi-water-pump::before {\r\n  content: \"\\F058F\";\r\n}\r\n\r\n.mdi-water-pump-off::before {\r\n  content: \"\\F0F93\";\r\n}\r\n\r\n.mdi-water-remove::before {\r\n  content: \"\\F150C\";\r\n}\r\n\r\n.mdi-water-remove-outline::before {\r\n  content: \"\\F150D\";\r\n}\r\n\r\n.mdi-water-sync::before {\r\n  content: \"\\F17C6\";\r\n}\r\n\r\n.mdi-water-well::before {\r\n  content: \"\\F106B\";\r\n}\r\n\r\n.mdi-water-well-outline::before {\r\n  content: \"\\F106C\";\r\n}\r\n\r\n.mdi-waterfall::before {\r\n  content: \"\\F1849\";\r\n}\r\n\r\n.mdi-watering-can::before {\r\n  content: \"\\F1481\";\r\n}\r\n\r\n.mdi-watering-can-outline::before {\r\n  content: \"\\F1482\";\r\n}\r\n\r\n.mdi-watermark::before {\r\n  content: \"\\F0612\";\r\n}\r\n\r\n.mdi-wave::before {\r\n  content: \"\\F0F2E\";\r\n}\r\n\r\n.mdi-waveform::before {\r\n  content: \"\\F147D\";\r\n}\r\n\r\n.mdi-waves::before {\r\n  content: \"\\F078D\";\r\n}\r\n\r\n.mdi-waves-arrow-left::before {\r\n  content: \"\\F1859\";\r\n}\r\n\r\n.mdi-waves-arrow-right::before {\r\n  content: \"\\F185A\";\r\n}\r\n\r\n.mdi-waves-arrow-up::before {\r\n  content: \"\\F185B\";\r\n}\r\n\r\n.mdi-waze::before {\r\n  content: \"\\F0BDE\";\r\n}\r\n\r\n.mdi-weather-cloudy::before {\r\n  content: \"\\F0590\";\r\n}\r\n\r\n.mdi-weather-cloudy-alert::before {\r\n  content: \"\\F0F2F\";\r\n}\r\n\r\n.mdi-weather-cloudy-arrow-right::before {\r\n  content: \"\\F0E6E\";\r\n}\r\n\r\n.mdi-weather-cloudy-clock::before {\r\n  content: \"\\F18F6\";\r\n}\r\n\r\n.mdi-weather-fog::before {\r\n  content: \"\\F0591\";\r\n}\r\n\r\n.mdi-weather-hail::before {\r\n  content: \"\\F0592\";\r\n}\r\n\r\n.mdi-weather-hazy::before {\r\n  content: \"\\F0F30\";\r\n}\r\n\r\n.mdi-weather-hurricane::before {\r\n  content: \"\\F0898\";\r\n}\r\n\r\n.mdi-weather-lightning::before {\r\n  content: \"\\F0593\";\r\n}\r\n\r\n.mdi-weather-lightning-rainy::before {\r\n  content: \"\\F067E\";\r\n}\r\n\r\n.mdi-weather-night::before {\r\n  content: \"\\F0594\";\r\n}\r\n\r\n.mdi-weather-night-partly-cloudy::before {\r\n  content: \"\\F0F31\";\r\n}\r\n\r\n.mdi-weather-partly-cloudy::before {\r\n  content: \"\\F0595\";\r\n}\r\n\r\n.mdi-weather-partly-lightning::before {\r\n  content: \"\\F0F32\";\r\n}\r\n\r\n.mdi-weather-partly-rainy::before {\r\n  content: \"\\F0F33\";\r\n}\r\n\r\n.mdi-weather-partly-snowy::before {\r\n  content: \"\\F0F34\";\r\n}\r\n\r\n.mdi-weather-partly-snowy-rainy::before {\r\n  content: \"\\F0F35\";\r\n}\r\n\r\n.mdi-weather-pouring::before {\r\n  content: \"\\F0596\";\r\n}\r\n\r\n.mdi-weather-rainy::before {\r\n  content: \"\\F0597\";\r\n}\r\n\r\n.mdi-weather-snowy::before {\r\n  content: \"\\F0598\";\r\n}\r\n\r\n.mdi-weather-snowy-heavy::before {\r\n  content: \"\\F0F36\";\r\n}\r\n\r\n.mdi-weather-snowy-rainy::before {\r\n  content: \"\\F067F\";\r\n}\r\n\r\n.mdi-weather-sunny::before {\r\n  content: \"\\F0599\";\r\n}\r\n\r\n.mdi-weather-sunny-alert::before {\r\n  content: \"\\F0F37\";\r\n}\r\n\r\n.mdi-weather-sunny-off::before {\r\n  content: \"\\F14E4\";\r\n}\r\n\r\n.mdi-weather-sunset::before {\r\n  content: \"\\F059A\";\r\n}\r\n\r\n.mdi-weather-sunset-down::before {\r\n  content: \"\\F059B\";\r\n}\r\n\r\n.mdi-weather-sunset-up::before {\r\n  content: \"\\F059C\";\r\n}\r\n\r\n.mdi-weather-tornado::before {\r\n  content: \"\\F0F38\";\r\n}\r\n\r\n.mdi-weather-windy::before {\r\n  content: \"\\F059D\";\r\n}\r\n\r\n.mdi-weather-windy-variant::before {\r\n  content: \"\\F059E\";\r\n}\r\n\r\n.mdi-web::before {\r\n  content: \"\\F059F\";\r\n}\r\n\r\n.mdi-web-box::before {\r\n  content: \"\\F0F94\";\r\n}\r\n\r\n.mdi-web-cancel::before {\r\n  content: \"\\F1790\";\r\n}\r\n\r\n.mdi-web-check::before {\r\n  content: \"\\F0789\";\r\n}\r\n\r\n.mdi-web-clock::before {\r\n  content: \"\\F124A\";\r\n}\r\n\r\n.mdi-web-minus::before {\r\n  content: \"\\F10A0\";\r\n}\r\n\r\n.mdi-web-off::before {\r\n  content: \"\\F0A8E\";\r\n}\r\n\r\n.mdi-web-plus::before {\r\n  content: \"\\F0033\";\r\n}\r\n\r\n.mdi-web-refresh::before {\r\n  content: \"\\F1791\";\r\n}\r\n\r\n.mdi-web-remove::before {\r\n  content: \"\\F0551\";\r\n}\r\n\r\n.mdi-web-sync::before {\r\n  content: \"\\F1792\";\r\n}\r\n\r\n.mdi-webcam::before {\r\n  content: \"\\F05A0\";\r\n}\r\n\r\n.mdi-webcam-off::before {\r\n  content: \"\\F1737\";\r\n}\r\n\r\n.mdi-webhook::before {\r\n  content: \"\\F062F\";\r\n}\r\n\r\n.mdi-webpack::before {\r\n  content: \"\\F072B\";\r\n}\r\n\r\n.mdi-webrtc::before {\r\n  content: \"\\F1248\";\r\n}\r\n\r\n.mdi-wechat::before {\r\n  content: \"\\F0611\";\r\n}\r\n\r\n.mdi-weight::before {\r\n  content: \"\\F05A1\";\r\n}\r\n\r\n.mdi-weight-gram::before {\r\n  content: \"\\F0D3F\";\r\n}\r\n\r\n.mdi-weight-kilogram::before {\r\n  content: \"\\F05A2\";\r\n}\r\n\r\n.mdi-weight-lifter::before {\r\n  content: \"\\F115D\";\r\n}\r\n\r\n.mdi-weight-pound::before {\r\n  content: \"\\F09B5\";\r\n}\r\n\r\n.mdi-whatsapp::before {\r\n  content: \"\\F05A3\";\r\n}\r\n\r\n.mdi-wheel-barrow::before {\r\n  content: \"\\F14F2\";\r\n}\r\n\r\n.mdi-wheelchair-accessibility::before {\r\n  content: \"\\F05A4\";\r\n}\r\n\r\n.mdi-whistle::before {\r\n  content: \"\\F09B6\";\r\n}\r\n\r\n.mdi-whistle-outline::before {\r\n  content: \"\\F12BC\";\r\n}\r\n\r\n.mdi-white-balance-auto::before {\r\n  content: \"\\F05A5\";\r\n}\r\n\r\n.mdi-white-balance-incandescent::before {\r\n  content: \"\\F05A6\";\r\n}\r\n\r\n.mdi-white-balance-iridescent::before {\r\n  content: \"\\F05A7\";\r\n}\r\n\r\n.mdi-white-balance-sunny::before {\r\n  content: \"\\F05A8\";\r\n}\r\n\r\n.mdi-widgets::before {\r\n  content: \"\\F072C\";\r\n}\r\n\r\n.mdi-widgets-outline::before {\r\n  content: \"\\F1355\";\r\n}\r\n\r\n.mdi-wifi::before {\r\n  content: \"\\F05A9\";\r\n}\r\n\r\n.mdi-wifi-alert::before {\r\n  content: \"\\F16B5\";\r\n}\r\n\r\n.mdi-wifi-arrow-down::before {\r\n  content: \"\\F16B6\";\r\n}\r\n\r\n.mdi-wifi-arrow-left::before {\r\n  content: \"\\F16B7\";\r\n}\r\n\r\n.mdi-wifi-arrow-left-right::before {\r\n  content: \"\\F16B8\";\r\n}\r\n\r\n.mdi-wifi-arrow-right::before {\r\n  content: \"\\F16B9\";\r\n}\r\n\r\n.mdi-wifi-arrow-up::before {\r\n  content: \"\\F16BA\";\r\n}\r\n\r\n.mdi-wifi-arrow-up-down::before {\r\n  content: \"\\F16BB\";\r\n}\r\n\r\n.mdi-wifi-cancel::before {\r\n  content: \"\\F16BC\";\r\n}\r\n\r\n.mdi-wifi-check::before {\r\n  content: \"\\F16BD\";\r\n}\r\n\r\n.mdi-wifi-cog::before {\r\n  content: \"\\F16BE\";\r\n}\r\n\r\n.mdi-wifi-lock::before {\r\n  content: \"\\F16BF\";\r\n}\r\n\r\n.mdi-wifi-lock-open::before {\r\n  content: \"\\F16C0\";\r\n}\r\n\r\n.mdi-wifi-marker::before {\r\n  content: \"\\F16C1\";\r\n}\r\n\r\n.mdi-wifi-minus::before {\r\n  content: \"\\F16C2\";\r\n}\r\n\r\n.mdi-wifi-off::before {\r\n  content: \"\\F05AA\";\r\n}\r\n\r\n.mdi-wifi-plus::before {\r\n  content: \"\\F16C3\";\r\n}\r\n\r\n.mdi-wifi-refresh::before {\r\n  content: \"\\F16C4\";\r\n}\r\n\r\n.mdi-wifi-remove::before {\r\n  content: \"\\F16C5\";\r\n}\r\n\r\n.mdi-wifi-settings::before {\r\n  content: \"\\F16C6\";\r\n}\r\n\r\n.mdi-wifi-star::before {\r\n  content: \"\\F0E0B\";\r\n}\r\n\r\n.mdi-wifi-strength-1::before {\r\n  content: \"\\F091F\";\r\n}\r\n\r\n.mdi-wifi-strength-1-alert::before {\r\n  content: \"\\F0920\";\r\n}\r\n\r\n.mdi-wifi-strength-1-lock::before {\r\n  content: \"\\F0921\";\r\n}\r\n\r\n.mdi-wifi-strength-1-lock-open::before {\r\n  content: \"\\F16CB\";\r\n}\r\n\r\n.mdi-wifi-strength-2::before {\r\n  content: \"\\F0922\";\r\n}\r\n\r\n.mdi-wifi-strength-2-alert::before {\r\n  content: \"\\F0923\";\r\n}\r\n\r\n.mdi-wifi-strength-2-lock::before {\r\n  content: \"\\F0924\";\r\n}\r\n\r\n.mdi-wifi-strength-2-lock-open::before {\r\n  content: \"\\F16CC\";\r\n}\r\n\r\n.mdi-wifi-strength-3::before {\r\n  content: \"\\F0925\";\r\n}\r\n\r\n.mdi-wifi-strength-3-alert::before {\r\n  content: \"\\F0926\";\r\n}\r\n\r\n.mdi-wifi-strength-3-lock::before {\r\n  content: \"\\F0927\";\r\n}\r\n\r\n.mdi-wifi-strength-3-lock-open::before {\r\n  content: \"\\F16CD\";\r\n}\r\n\r\n.mdi-wifi-strength-4::before {\r\n  content: \"\\F0928\";\r\n}\r\n\r\n.mdi-wifi-strength-4-alert::before {\r\n  content: \"\\F0929\";\r\n}\r\n\r\n.mdi-wifi-strength-4-lock::before {\r\n  content: \"\\F092A\";\r\n}\r\n\r\n.mdi-wifi-strength-4-lock-open::before {\r\n  content: \"\\F16CE\";\r\n}\r\n\r\n.mdi-wifi-strength-alert-outline::before {\r\n  content: \"\\F092B\";\r\n}\r\n\r\n.mdi-wifi-strength-lock-open-outline::before {\r\n  content: \"\\F16CF\";\r\n}\r\n\r\n.mdi-wifi-strength-lock-outline::before {\r\n  content: \"\\F092C\";\r\n}\r\n\r\n.mdi-wifi-strength-off::before {\r\n  content: \"\\F092D\";\r\n}\r\n\r\n.mdi-wifi-strength-off-outline::before {\r\n  content: \"\\F092E\";\r\n}\r\n\r\n.mdi-wifi-strength-outline::before {\r\n  content: \"\\F092F\";\r\n}\r\n\r\n.mdi-wifi-sync::before {\r\n  content: \"\\F16C7\";\r\n}\r\n\r\n.mdi-wikipedia::before {\r\n  content: \"\\F05AC\";\r\n}\r\n\r\n.mdi-wind-turbine::before {\r\n  content: \"\\F0DA5\";\r\n}\r\n\r\n.mdi-wind-turbine-alert::before {\r\n  content: \"\\F19AB\";\r\n}\r\n\r\n.mdi-wind-turbine-check::before {\r\n  content: \"\\F19AC\";\r\n}\r\n\r\n.mdi-window-close::before {\r\n  content: \"\\F05AD\";\r\n}\r\n\r\n.mdi-window-closed::before {\r\n  content: \"\\F05AE\";\r\n}\r\n\r\n.mdi-window-closed-variant::before {\r\n  content: \"\\F11DB\";\r\n}\r\n\r\n.mdi-window-maximize::before {\r\n  content: \"\\F05AF\";\r\n}\r\n\r\n.mdi-window-minimize::before {\r\n  content: \"\\F05B0\";\r\n}\r\n\r\n.mdi-window-open::before {\r\n  content: \"\\F05B1\";\r\n}\r\n\r\n.mdi-window-open-variant::before {\r\n  content: \"\\F11DC\";\r\n}\r\n\r\n.mdi-window-restore::before {\r\n  content: \"\\F05B2\";\r\n}\r\n\r\n.mdi-window-shutter::before {\r\n  content: \"\\F111C\";\r\n}\r\n\r\n.mdi-window-shutter-alert::before {\r\n  content: \"\\F111D\";\r\n}\r\n\r\n.mdi-window-shutter-open::before {\r\n  content: \"\\F111E\";\r\n}\r\n\r\n.mdi-windsock::before {\r\n  content: \"\\F15FA\";\r\n}\r\n\r\n.mdi-wiper::before {\r\n  content: \"\\F0AE9\";\r\n}\r\n\r\n.mdi-wiper-wash::before {\r\n  content: \"\\F0DA6\";\r\n}\r\n\r\n.mdi-wiper-wash-alert::before {\r\n  content: \"\\F18DF\";\r\n}\r\n\r\n.mdi-wizard-hat::before {\r\n  content: \"\\F1477\";\r\n}\r\n\r\n.mdi-wordpress::before {\r\n  content: \"\\F05B4\";\r\n}\r\n\r\n.mdi-wrap::before {\r\n  content: \"\\F05B6\";\r\n}\r\n\r\n.mdi-wrap-disabled::before {\r\n  content: \"\\F0BDF\";\r\n}\r\n\r\n.mdi-wrench::before {\r\n  content: \"\\F05B7\";\r\n}\r\n\r\n.mdi-wrench-clock::before {\r\n  content: \"\\F19A3\";\r\n}\r\n\r\n.mdi-wrench-outline::before {\r\n  content: \"\\F0BE0\";\r\n}\r\n\r\n.mdi-xamarin::before {\r\n  content: \"\\F0845\";\r\n}\r\n\r\n.mdi-xml::before {\r\n  content: \"\\F05C0\";\r\n}\r\n\r\n.mdi-xmpp::before {\r\n  content: \"\\F07FF\";\r\n}\r\n\r\n.mdi-yahoo::before {\r\n  content: \"\\F0B4F\";\r\n}\r\n\r\n.mdi-yeast::before {\r\n  content: \"\\F05C1\";\r\n}\r\n\r\n.mdi-yin-yang::before {\r\n  content: \"\\F0680\";\r\n}\r\n\r\n.mdi-yoga::before {\r\n  content: \"\\F117C\";\r\n}\r\n\r\n.mdi-youtube::before {\r\n  content: \"\\F05C3\";\r\n}\r\n\r\n.mdi-youtube-gaming::before {\r\n  content: \"\\F0848\";\r\n}\r\n\r\n.mdi-youtube-studio::before {\r\n  content: \"\\F0847\";\r\n}\r\n\r\n.mdi-youtube-subscription::before {\r\n  content: \"\\F0D40\";\r\n}\r\n\r\n.mdi-youtube-tv::before {\r\n  content: \"\\F0448\";\r\n}\r\n\r\n.mdi-yurt::before {\r\n  content: \"\\F1516\";\r\n}\r\n\r\n.mdi-z-wave::before {\r\n  content: \"\\F0AEA\";\r\n}\r\n\r\n.mdi-zend::before {\r\n  content: \"\\F0AEB\";\r\n}\r\n\r\n.mdi-zigbee::before {\r\n  content: \"\\F0D41\";\r\n}\r\n\r\n.mdi-zip-box::before {\r\n  content: \"\\F05C4\";\r\n}\r\n\r\n.mdi-zip-box-outline::before {\r\n  content: \"\\F0FFA\";\r\n}\r\n\r\n.mdi-zip-disk::before {\r\n  content: \"\\F0A23\";\r\n}\r\n\r\n.mdi-zodiac-aquarius::before {\r\n  content: \"\\F0A7D\";\r\n}\r\n\r\n.mdi-zodiac-aries::before {\r\n  content: \"\\F0A7E\";\r\n}\r\n\r\n.mdi-zodiac-cancer::before {\r\n  content: \"\\F0A7F\";\r\n}\r\n\r\n.mdi-zodiac-capricorn::before {\r\n  content: \"\\F0A80\";\r\n}\r\n\r\n.mdi-zodiac-gemini::before {\r\n  content: \"\\F0A81\";\r\n}\r\n\r\n.mdi-zodiac-leo::before {\r\n  content: \"\\F0A82\";\r\n}\r\n\r\n.mdi-zodiac-libra::before {\r\n  content: \"\\F0A83\";\r\n}\r\n\r\n.mdi-zodiac-pisces::before {\r\n  content: \"\\F0A84\";\r\n}\r\n\r\n.mdi-zodiac-sagittarius::before {\r\n  content: \"\\F0A85\";\r\n}\r\n\r\n.mdi-zodiac-scorpio::before {\r\n  content: \"\\F0A86\";\r\n}\r\n\r\n.mdi-zodiac-taurus::before {\r\n  content: \"\\F0A87\";\r\n}\r\n\r\n.mdi-zodiac-virgo::before {\r\n  content: \"\\F0A88\";\r\n}\r\n\r\n.mdi-blank::before {\r\n  content: \"\\F68C\";\r\n  visibility: hidden;\r\n}\r\n\r\n.mdi-18px.mdi-set, .mdi-18px.mdi:before {\r\n  font-size: 18px;\r\n}\r\n\r\n.mdi-24px.mdi-set, .mdi-24px.mdi:before {\r\n  font-size: 24px;\r\n}\r\n\r\n.mdi-36px.mdi-set, .mdi-36px.mdi:before {\r\n  font-size: 36px;\r\n}\r\n\r\n.mdi-48px.mdi-set, .mdi-48px.mdi:before {\r\n  font-size: 48px;\r\n}\r\n\r\n.mdi-dark:before {\r\n  color: rgba(0, 0, 0, 0.54);\r\n}\r\n\r\n.mdi-dark.mdi-inactive:before {\r\n  color: rgba(0, 0, 0, 0.26);\r\n}\r\n\r\n.mdi-light:before {\r\n  color: white;\r\n}\r\n\r\n.mdi-light.mdi-inactive:before {\r\n  color: rgba(255, 255, 255, 0.3);\r\n}\r\n\r\n.mdi-rotate-45 {\r\n  /*\r\n        // Not included in production\r\n        &.mdi-flip-h:before {\r\n            -webkit-transform: scaleX(-1) rotate(45deg);\r\n            transform: scaleX(-1) rotate(45deg);\r\n            filter: FlipH;\r\n            -ms-filter: \"FlipH\";\r\n        }\r\n        &.mdi-flip-v:before {\r\n            -webkit-transform: scaleY(-1) rotate(45deg);\r\n            -ms-transform: rotate(45deg);\r\n            transform: scaleY(-1) rotate(45deg);\r\n            filter: FlipV;\r\n            -ms-filter: \"FlipV\";\r\n        }\r\n        */\r\n}\r\n\r\n.mdi-rotate-45:before {\r\n  -webkit-transform: rotate(45deg);\r\n  -ms-transform: rotate(45deg);\r\n  transform: rotate(45deg);\r\n}\r\n\r\n.mdi-rotate-90 {\r\n  /*\r\n        // Not included in production\r\n        &.mdi-flip-h:before {\r\n            -webkit-transform: scaleX(-1) rotate(90deg);\r\n            transform: scaleX(-1) rotate(90deg);\r\n            filter: FlipH;\r\n            -ms-filter: \"FlipH\";\r\n        }\r\n        &.mdi-flip-v:before {\r\n            -webkit-transform: scaleY(-1) rotate(90deg);\r\n            -ms-transform: rotate(90deg);\r\n            transform: scaleY(-1) rotate(90deg);\r\n            filter: FlipV;\r\n            -ms-filter: \"FlipV\";\r\n        }\r\n        */\r\n}\r\n\r\n.mdi-rotate-90:before {\r\n  -webkit-transform: rotate(90deg);\r\n  -ms-transform: rotate(90deg);\r\n  transform: rotate(90deg);\r\n}\r\n\r\n.mdi-rotate-135 {\r\n  /*\r\n        // Not included in production\r\n        &.mdi-flip-h:before {\r\n            -webkit-transform: scaleX(-1) rotate(135deg);\r\n            transform: scaleX(-1) rotate(135deg);\r\n            filter: FlipH;\r\n            -ms-filter: \"FlipH\";\r\n        }\r\n        &.mdi-flip-v:before {\r\n            -webkit-transform: scaleY(-1) rotate(135deg);\r\n            -ms-transform: rotate(135deg);\r\n            transform: scaleY(-1) rotate(135deg);\r\n            filter: FlipV;\r\n            -ms-filter: \"FlipV\";\r\n        }\r\n        */\r\n}\r\n\r\n.mdi-rotate-135:before {\r\n  -webkit-transform: rotate(135deg);\r\n  -ms-transform: rotate(135deg);\r\n  transform: rotate(135deg);\r\n}\r\n\r\n.mdi-rotate-180 {\r\n  /*\r\n        // Not included in production\r\n        &.mdi-flip-h:before {\r\n            -webkit-transform: scaleX(-1) rotate(180deg);\r\n            transform: scaleX(-1) rotate(180deg);\r\n            filter: FlipH;\r\n            -ms-filter: \"FlipH\";\r\n        }\r\n        &.mdi-flip-v:before {\r\n            -webkit-transform: scaleY(-1) rotate(180deg);\r\n            -ms-transform: rotate(180deg);\r\n            transform: scaleY(-1) rotate(180deg);\r\n            filter: FlipV;\r\n            -ms-filter: \"FlipV\";\r\n        }\r\n        */\r\n}\r\n\r\n.mdi-rotate-180:before {\r\n  -webkit-transform: rotate(180deg);\r\n  -ms-transform: rotate(180deg);\r\n  transform: rotate(180deg);\r\n}\r\n\r\n.mdi-rotate-225 {\r\n  /*\r\n        // Not included in production\r\n        &.mdi-flip-h:before {\r\n            -webkit-transform: scaleX(-1) rotate(225deg);\r\n            transform: scaleX(-1) rotate(225deg);\r\n            filter: FlipH;\r\n            -ms-filter: \"FlipH\";\r\n        }\r\n        &.mdi-flip-v:before {\r\n            -webkit-transform: scaleY(-1) rotate(225deg);\r\n            -ms-transform: rotate(225deg);\r\n            transform: scaleY(-1) rotate(225deg);\r\n            filter: FlipV;\r\n            -ms-filter: \"FlipV\";\r\n        }\r\n        */\r\n}\r\n\r\n.mdi-rotate-225:before {\r\n  -webkit-transform: rotate(225deg);\r\n  -ms-transform: rotate(225deg);\r\n  transform: rotate(225deg);\r\n}\r\n\r\n.mdi-rotate-270 {\r\n  /*\r\n        // Not included in production\r\n        &.mdi-flip-h:before {\r\n            -webkit-transform: scaleX(-1) rotate(270deg);\r\n            transform: scaleX(-1) rotate(270deg);\r\n            filter: FlipH;\r\n            -ms-filter: \"FlipH\";\r\n        }\r\n        &.mdi-flip-v:before {\r\n            -webkit-transform: scaleY(-1) rotate(270deg);\r\n            -ms-transform: rotate(270deg);\r\n            transform: scaleY(-1) rotate(270deg);\r\n            filter: FlipV;\r\n            -ms-filter: \"FlipV\";\r\n        }\r\n        */\r\n}\r\n\r\n.mdi-rotate-270:before {\r\n  -webkit-transform: rotate(270deg);\r\n  -ms-transform: rotate(270deg);\r\n  transform: rotate(270deg);\r\n}\r\n\r\n.mdi-rotate-315 {\r\n  /*\r\n        // Not included in production\r\n        &.mdi-flip-h:before {\r\n            -webkit-transform: scaleX(-1) rotate(315deg);\r\n            transform: scaleX(-1) rotate(315deg);\r\n            filter: FlipH;\r\n            -ms-filter: \"FlipH\";\r\n        }\r\n        &.mdi-flip-v:before {\r\n            -webkit-transform: scaleY(-1) rotate(315deg);\r\n            -ms-transform: rotate(315deg);\r\n            transform: scaleY(-1) rotate(315deg);\r\n            filter: FlipV;\r\n            -ms-filter: \"FlipV\";\r\n        }\r\n        */\r\n}\r\n\r\n.mdi-rotate-315:before {\r\n  -webkit-transform: rotate(315deg);\r\n  -ms-transform: rotate(315deg);\r\n  transform: rotate(315deg);\r\n}\r\n\r\n.mdi-flip-h:before {\r\n  -webkit-transform: scaleX(-1);\r\n  transform: scaleX(-1);\r\n  filter: FlipH;\r\n  -ms-filter: \"FlipH\";\r\n}\r\n\r\n.mdi-flip-v:before {\r\n  -webkit-transform: scaleY(-1);\r\n  transform: scaleY(-1);\r\n  filter: FlipV;\r\n  -ms-filter: \"FlipV\";\r\n}\r\n\r\n.mdi-spin:before {\r\n  -webkit-animation: mdi-spin 2s infinite linear;\r\n  animation: mdi-spin 2s infinite linear;\r\n}\r\n\r\n@-webkit-keyframes mdi-spin {\r\n  0% {\r\n    -webkit-transform: rotate(0deg);\r\n    transform: rotate(0deg);\r\n  }\r\n  100% {\r\n    -webkit-transform: rotate(359deg);\r\n    transform: rotate(359deg);\r\n  }\r\n}\r\n\r\n@keyframes mdi-spin {\r\n  0% {\r\n    -webkit-transform: rotate(0deg);\r\n    transform: rotate(0deg);\r\n  }\r\n  100% {\r\n    -webkit-transform: rotate(359deg);\r\n    transform: rotate(359deg);\r\n  }\r\n}\r\n\r\n/*# sourceMappingURL=materialdesignicons.css.map */","// boxicons 2.1.1\r\n\r\n@font-face\r\n{\r\n    font-family: 'boxicons';\r\n    font-weight: normal;\r\n    font-style: normal;\r\n\r\n    src: url('../../../fonts/boxicons.eot');\r\n    src: url('../../../fonts/boxicons.eot') format('embedded-opentype'),\r\n    url('../../../fonts/boxicons.woff2') format('woff2'),\r\n    url('../../../fonts/boxicons.woff') format('woff'),\r\n    url('../../../fonts/boxicons.ttf') format('truetype'),\r\n    url('../../../fonts/boxicons.svg?#boxicons') format('svg');\r\n}\r\n.bx\r\n{\r\n    font-family: 'boxicons' !important;\r\n    font-weight: normal;\r\n    font-style: normal;\r\n    font-variant: normal;\r\n    line-height: 1;\r\n    text-rendering: auto;\r\n    display: inline-block;\r\n\r\n    text-transform: none;\r\n\r\n    speak: none;\r\n    -webkit-font-smoothing: antialiased;\r\n    -moz-osx-font-smoothing: grayscale;\r\n}\r\n.bx-ul\r\n{\r\n    margin-left: 2em;\r\n    padding-left: 0;\r\n\r\n    list-style: none;\r\n}\r\n.bx-ul > li\r\n{\r\n    position: relative;\r\n}\r\n.bx-ul .bx\r\n{\r\n    font-size: inherit;\r\n    line-height: inherit;\r\n\r\n    position: absolute;\r\n    left: -2em;\r\n\r\n    width: 2em;\r\n\r\n    text-align: center;\r\n}\r\n@-webkit-keyframes spin\r\n{\r\n    0%\r\n    {\r\n        -webkit-transform: rotate(0);\r\n                transform: rotate(0);\r\n    }\r\n    100%\r\n    {\r\n        -webkit-transform: rotate(359deg);\r\n                transform: rotate(359deg);\r\n    }\r\n}\r\n@keyframes spin\r\n{\r\n    0%\r\n    {\r\n        -webkit-transform: rotate(0);\r\n                transform: rotate(0);\r\n    }\r\n    100%\r\n    {\r\n        -webkit-transform: rotate(359deg);\r\n                transform: rotate(359deg);\r\n    }\r\n}\r\n@-webkit-keyframes burst\r\n{\r\n    0%\r\n    {\r\n        -webkit-transform: scale(1);\r\n                transform: scale(1);\r\n\r\n        opacity: 1;\r\n    }\r\n    90%\r\n    {\r\n        -webkit-transform: scale(1.5);\r\n                transform: scale(1.5);\r\n\r\n        opacity: 0;\r\n    }\r\n}\r\n@keyframes burst\r\n{\r\n    0%\r\n    {\r\n        -webkit-transform: scale(1);\r\n                transform: scale(1);\r\n\r\n        opacity: 1;\r\n    }\r\n    90%\r\n    {\r\n        -webkit-transform: scale(1.5);\r\n                transform: scale(1.5);\r\n\r\n        opacity: 0;\r\n    }\r\n}\r\n@-webkit-keyframes flashing\r\n{\r\n    0%\r\n    {\r\n        opacity: 1;\r\n    }\r\n    45%\r\n    {\r\n        opacity: 0;\r\n    }\r\n    90%\r\n    {\r\n        opacity: 1;\r\n    }\r\n}\r\n@keyframes flashing\r\n{\r\n    0%\r\n    {\r\n        opacity: 1;\r\n    }\r\n    45%\r\n    {\r\n        opacity: 0;\r\n    }\r\n    90%\r\n    {\r\n        opacity: 1;\r\n    }\r\n}\r\n@-webkit-keyframes fade-left\r\n{\r\n    0%\r\n    {\r\n        -webkit-transform: translateX(0);\r\n                transform: translateX(0);\r\n\r\n        opacity: 1;\r\n    }\r\n    75%\r\n    {\r\n        -webkit-transform: translateX(-20px);\r\n                transform: translateX(-20px);\r\n\r\n        opacity: 0;\r\n    }\r\n}\r\n@keyframes fade-left\r\n{\r\n    0%\r\n    {\r\n        -webkit-transform: translateX(0);\r\n                transform: translateX(0);\r\n\r\n        opacity: 1;\r\n    }\r\n    75%\r\n    {\r\n        -webkit-transform: translateX(-20px);\r\n                transform: translateX(-20px);\r\n\r\n        opacity: 0;\r\n    }\r\n}\r\n@-webkit-keyframes fade-right\r\n{\r\n    0%\r\n    {\r\n        -webkit-transform: translateX(0);\r\n                transform: translateX(0);\r\n\r\n        opacity: 1;\r\n    }\r\n    75%\r\n    {\r\n        -webkit-transform: translateX(20px);\r\n                transform: translateX(20px);\r\n\r\n        opacity: 0;\r\n    }\r\n}\r\n@keyframes fade-right\r\n{\r\n    0%\r\n    {\r\n        -webkit-transform: translateX(0);\r\n                transform: translateX(0);\r\n\r\n        opacity: 1;\r\n    }\r\n    75%\r\n    {\r\n        -webkit-transform: translateX(20px);\r\n                transform: translateX(20px);\r\n\r\n        opacity: 0;\r\n    }\r\n}\r\n@-webkit-keyframes fade-up\r\n{\r\n    0%\r\n    {\r\n        -webkit-transform: translateY(0);\r\n                transform: translateY(0);\r\n\r\n        opacity: 1;\r\n    }\r\n    75%\r\n    {\r\n        -webkit-transform: translateY(-20px);\r\n                transform: translateY(-20px);\r\n\r\n        opacity: 0;\r\n    }\r\n}\r\n@keyframes fade-up\r\n{\r\n    0%\r\n    {\r\n        -webkit-transform: translateY(0);\r\n                transform: translateY(0);\r\n\r\n        opacity: 1;\r\n    }\r\n    75%\r\n    {\r\n        -webkit-transform: translateY(-20px);\r\n                transform: translateY(-20px);\r\n\r\n        opacity: 0;\r\n    }\r\n}\r\n@-webkit-keyframes fade-down\r\n{\r\n    0%\r\n    {\r\n        -webkit-transform: translateY(0);\r\n                transform: translateY(0);\r\n\r\n        opacity: 1;\r\n    }\r\n    75%\r\n    {\r\n        -webkit-transform: translateY(20px);\r\n                transform: translateY(20px);\r\n\r\n        opacity: 0;\r\n    }\r\n}\r\n@keyframes fade-down\r\n{\r\n    0%\r\n    {\r\n        -webkit-transform: translateY(0);\r\n                transform: translateY(0);\r\n\r\n        opacity: 1;\r\n    }\r\n    75%\r\n    {\r\n        -webkit-transform: translateY(20px);\r\n                transform: translateY(20px);\r\n\r\n        opacity: 0;\r\n    }\r\n}\r\n@-webkit-keyframes tada\r\n{\r\n    from\r\n    {\r\n        -webkit-transform: scale3d(1, 1, 1);\r\n                transform: scale3d(1, 1, 1);\r\n    }\r\n\r\n    10%,\r\n    20%\r\n    {\r\n        -webkit-transform: scale3d(.95, .95, .95) rotate3d(0, 0, 1, -10deg);\r\n                transform: scale3d(.95, .95, .95) rotate3d(0, 0, 1, -10deg);\r\n    }\r\n\r\n    30%,\r\n    50%,\r\n    70%,\r\n    90%\r\n    {\r\n        -webkit-transform: scale3d(1, 1, 1) rotate3d(0, 0, 1, 10deg);\r\n                transform: scale3d(1, 1, 1) rotate3d(0, 0, 1, 10deg);\r\n    }\r\n\r\n    40%,\r\n    60%,\r\n    80%\r\n    {\r\n        -webkit-transform: scale3d(1, 1, 1) rotate3d(0, 0, 1, -10deg);\r\n                transform: scale3d(1, 1, 1) rotate3d(0, 0, 1, -10deg);\r\n    }\r\n\r\n    to\r\n    {\r\n        -webkit-transform: scale3d(1, 1, 1);\r\n                transform: scale3d(1, 1, 1);\r\n    }\r\n}\r\n\r\n@keyframes tada\r\n{\r\n    from\r\n    {\r\n        -webkit-transform: scale3d(1, 1, 1);\r\n                transform: scale3d(1, 1, 1);\r\n    }\r\n\r\n    10%,\r\n    20%\r\n    {\r\n        -webkit-transform: scale3d(.95, .95, .95) rotate3d(0, 0, 1, -10deg);\r\n                transform: scale3d(.95, .95, .95) rotate3d(0, 0, 1, -10deg);\r\n    }\r\n\r\n    30%,\r\n    50%,\r\n    70%,\r\n    90%\r\n    {\r\n        -webkit-transform: scale3d(1, 1, 1) rotate3d(0, 0, 1, 10deg);\r\n                transform: scale3d(1, 1, 1) rotate3d(0, 0, 1, 10deg);\r\n    }\r\n\r\n    40%,\r\n    60%,\r\n    80%\r\n    {\r\n        -webkit-transform: rotate3d(0, 0, 1, -10deg);\r\n                transform: rotate3d(0, 0, 1, -10deg);\r\n    }\r\n\r\n    to\r\n    {\r\n        -webkit-transform: scale3d(1, 1, 1);\r\n                transform: scale3d(1, 1, 1);\r\n    }\r\n}\r\n.bx-spin\r\n{\r\n    -webkit-animation: spin 2s linear infinite;\r\n            animation: spin 2s linear infinite;\r\n}\r\n.bx-spin-hover:hover\r\n{\r\n    -webkit-animation: spin 2s linear infinite;\r\n            animation: spin 2s linear infinite;\r\n}\r\n\r\n.bx-tada\r\n{\r\n    -webkit-animation: tada 1.5s ease infinite;\r\n            animation: tada 1.5s ease infinite;\r\n}\r\n.bx-tada-hover:hover\r\n{\r\n    -webkit-animation: tada 1.5s ease infinite;\r\n            animation: tada 1.5s ease infinite;\r\n}\r\n\r\n.bx-flashing\r\n{\r\n    -webkit-animation: flashing 1.5s infinite linear;\r\n            animation: flashing 1.5s infinite linear;\r\n}\r\n.bx-flashing-hover:hover\r\n{\r\n    -webkit-animation: flashing 1.5s infinite linear;\r\n            animation: flashing 1.5s infinite linear;\r\n}\r\n\r\n.bx-burst\r\n{\r\n    -webkit-animation: burst 1.5s infinite linear;\r\n            animation: burst 1.5s infinite linear;\r\n}\r\n.bx-burst-hover:hover\r\n{\r\n    -webkit-animation: burst 1.5s infinite linear;\r\n            animation: burst 1.5s infinite linear;\r\n}\r\n.bx-fade-up\r\n{\r\n    -webkit-animation: fade-up 1.5s infinite linear;\r\n            animation: fade-up 1.5s infinite linear;\r\n}\r\n.bx-fade-up-hover:hover\r\n{\r\n    -webkit-animation: fade-up 1.5s infinite linear;\r\n            animation: fade-up 1.5s infinite linear;\r\n}\r\n.bx-fade-down\r\n{\r\n    -webkit-animation: fade-down 1.5s infinite linear;\r\n            animation: fade-down 1.5s infinite linear;\r\n}\r\n.bx-fade-down-hover:hover\r\n{\r\n    -webkit-animation: fade-down 1.5s infinite linear;\r\n            animation: fade-down 1.5s infinite linear;\r\n}\r\n.bx-fade-left\r\n{\r\n    -webkit-animation: fade-left 1.5s infinite linear;\r\n            animation: fade-left 1.5s infinite linear;\r\n}\r\n.bx-fade-left-hover:hover\r\n{\r\n    -webkit-animation: fade-left 1.5s infinite linear;\r\n            animation: fade-left 1.5s infinite linear;\r\n}\r\n.bx-fade-right\r\n{\r\n    -webkit-animation: fade-right 1.5s infinite linear;\r\n            animation: fade-right 1.5s infinite linear;\r\n}\r\n.bx-fade-right-hover:hover\r\n{\r\n    -webkit-animation: fade-right 1.5s infinite linear;\r\n            animation: fade-right 1.5s infinite linear;\r\n}\r\n.bx-xs\r\n{\r\n    font-size: 1rem!important;\r\n}\r\n.bx-sm\r\n{\r\n    font-size: 1.55rem!important;\r\n}\r\n.bx-md\r\n{\r\n    font-size: 2.25rem!important;\r\n}\r\n.bx-lg\r\n{\r\n    font-size: 3.0rem!important;\r\n}\r\n.bx-fw\r\n{\r\n    font-size: 1.2857142857em;\r\n    line-height: .8em;\r\n\r\n    width: 1.2857142857em;\r\n    height: .8em;\r\n    margin-top: -.2em!important;\r\n\r\n    vertical-align: middle;\r\n}\r\n.bx-pull-left\r\n{\r\n    float: left;\r\n\r\n    margin-right: .3em!important;\r\n}\r\n.bx-pull-right\r\n{\r\n    float: right;\r\n\r\n    margin-left: .3em!important;\r\n}\r\n.bx-rotate-90\r\n{\r\n    transform: rotate(90deg);\r\n\r\n    -ms-filter: 'progid:DXImageTransform.Microsoft.BasicImage(rotation=1)';\r\n}\r\n.bx-rotate-180\r\n{\r\n    transform: rotate(180deg);\r\n\r\n    -ms-filter: 'progid:DXImageTransform.Microsoft.BasicImage(rotation=2)';\r\n}\r\n.bx-rotate-270\r\n{\r\n    transform: rotate(270deg);\r\n\r\n    -ms-filter: 'progid:DXImageTransform.Microsoft.BasicImage(rotation=3)';\r\n}\r\n.bx-flip-horizontal\r\n{\r\n    transform: scaleX(-1);\r\n\r\n    -ms-filter: 'progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)';\r\n}\r\n.bx-flip-vertical\r\n{\r\n    transform: scaleY(-1);\r\n\r\n    -ms-filter: 'progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)';\r\n}\r\n.bx-border\r\n{\r\n    padding: .25em;\r\n\r\n    border: .07em solid rgba(0,0,0,.1);\r\n    border-radius: .25em;\r\n}\r\n.bx-border-circle\r\n{\r\n    padding: .25em;\r\n\r\n    border: .07em solid rgba(0,0,0,.1);\r\n    border-radius: 50%;\r\n}\r\n\r\n  \r\n  .bxl-meta:before {\r\n    content: \"\\ef27\";\r\n  }\r\n  .bx-lemon:before {\r\n    content: \"\\ef28\";\r\n  }\r\n  .bxs-lemon:before {\r\n    content: \"\\ef29\";\r\n  }\r\n  .bx-cricket-ball:before {\r\n    content: \"\\ef0c\";\r\n  }\r\n  .bx-baguette:before {\r\n    content: \"\\ef0d\";\r\n  }\r\n  .bx-bowl-hot:before {\r\n    content: \"\\ef0e\";\r\n  }\r\n  .bx-bowl-rice:before {\r\n    content: \"\\ef0f\";\r\n  }\r\n  .bx-cable-car:before {\r\n    content: \"\\ef10\";\r\n  }\r\n  .bx-candles:before {\r\n    content: \"\\ef11\";\r\n  }\r\n  .bx-circle-half:before {\r\n    content: \"\\ef12\";\r\n  }\r\n  .bx-circle-quarter:before {\r\n    content: \"\\ef13\";\r\n  }\r\n  .bx-circle-three-quarter:before {\r\n    content: \"\\ef14\";\r\n  }\r\n  .bx-cross:before {\r\n    content: \"\\ef15\";\r\n  }\r\n  .bx-fork:before {\r\n    content: \"\\ef16\";\r\n  }\r\n  .bx-knife:before {\r\n    content: \"\\ef17\";\r\n  }\r\n  .bx-money-withdraw:before {\r\n    content: \"\\ef18\";\r\n  }\r\n  .bx-popsicle:before {\r\n    content: \"\\ef19\";\r\n  }\r\n  .bx-scatter-chart:before {\r\n    content: \"\\ef1a\";\r\n  }\r\n  .bxs-baguette:before {\r\n    content: \"\\ef1b\";\r\n  }\r\n  .bxs-bowl-hot:before {\r\n    content: \"\\ef1c\";\r\n  }\r\n  .bxs-bowl-rice:before {\r\n    content: \"\\ef1d\";\r\n  }\r\n  .bxs-cable-car:before {\r\n    content: \"\\ef1e\";\r\n  }\r\n  .bxs-circle-half:before {\r\n    content: \"\\ef1f\";\r\n  }\r\n  .bxs-circle-quarter:before {\r\n    content: \"\\ef20\";\r\n  }\r\n  .bxs-circle-three-quarter:before {\r\n    content: \"\\ef21\";\r\n  }\r\n  .bxs-cricket-ball:before {\r\n    content: \"\\ef22\";\r\n  }\r\n  .bxs-invader:before {\r\n    content: \"\\ef23\";\r\n  }\r\n  .bx-male-female:before {\r\n    content: \"\\ef24\";\r\n  }\r\n  .bxs-popsicle:before {\r\n    content: \"\\ef25\";\r\n  }\r\n  .bxs-tree-alt:before {\r\n    content: \"\\ef26\";\r\n  }\r\n  .bxl-venmo:before {\r\n    content: \"\\e900\";\r\n  }\r\n  .bxl-upwork:before {\r\n    content: \"\\e901\";\r\n  }\r\n  .bxl-netlify:before {\r\n    content: \"\\e902\";\r\n  }\r\n  .bxl-java:before {\r\n    content: \"\\e903\";\r\n  }\r\n  .bxl-heroku:before {\r\n    content: \"\\e904\";\r\n  }\r\n  .bxl-go-lang:before {\r\n    content: \"\\e905\";\r\n  }\r\n  .bxl-gmail:before {\r\n    content: \"\\e906\";\r\n  }\r\n  .bxl-flask:before {\r\n    content: \"\\e907\";\r\n  }\r\n  .bxl-99designs:before {\r\n    content: \"\\e908\";\r\n  }\r\n  .bxl-500px:before {\r\n    content: \"\\e909\";\r\n  }\r\n  .bxl-adobe:before {\r\n    content: \"\\e90a\";\r\n  }\r\n  .bxl-airbnb:before {\r\n    content: \"\\e90b\";\r\n  }\r\n  .bxl-algolia:before {\r\n    content: \"\\e90c\";\r\n  }\r\n  .bxl-amazon:before {\r\n    content: \"\\e90d\";\r\n  }\r\n  .bxl-android:before {\r\n    content: \"\\e90e\";\r\n  }\r\n  .bxl-angular:before {\r\n    content: \"\\e90f\";\r\n  }\r\n  .bxl-apple:before {\r\n    content: \"\\e910\";\r\n  }\r\n  .bxl-audible:before {\r\n    content: \"\\e911\";\r\n  }\r\n  .bxl-aws:before {\r\n    content: \"\\e912\";\r\n  }\r\n  .bxl-baidu:before {\r\n    content: \"\\e913\";\r\n  }\r\n  .bxl-behance:before {\r\n    content: \"\\e914\";\r\n  }\r\n  .bxl-bing:before {\r\n    content: \"\\e915\";\r\n  }\r\n  .bxl-bitcoin:before {\r\n    content: \"\\e916\";\r\n  }\r\n  .bxl-blender:before {\r\n    content: \"\\e917\";\r\n  }\r\n  .bxl-blogger:before {\r\n    content: \"\\e918\";\r\n  }\r\n  .bxl-bootstrap:before {\r\n    content: \"\\e919\";\r\n  }\r\n  .bxl-chrome:before {\r\n    content: \"\\e91a\";\r\n  }\r\n  .bxl-codepen:before {\r\n    content: \"\\e91b\";\r\n  }\r\n  .bxl-c-plus-plus:before {\r\n    content: \"\\e91c\";\r\n  }\r\n  .bxl-creative-commons:before {\r\n    content: \"\\e91d\";\r\n  }\r\n  .bxl-css3:before {\r\n    content: \"\\e91e\";\r\n  }\r\n  .bxl-dailymotion:before {\r\n    content: \"\\e91f\";\r\n  }\r\n  .bxl-deviantart:before {\r\n    content: \"\\e920\";\r\n  }\r\n  .bxl-dev-to:before {\r\n    content: \"\\e921\";\r\n  }\r\n  .bxl-digg:before {\r\n    content: \"\\e922\";\r\n  }\r\n  .bxl-digitalocean:before {\r\n    content: \"\\e923\";\r\n  }\r\n  .bxl-discord:before {\r\n    content: \"\\e924\";\r\n  }\r\n  .bxl-discord-alt:before {\r\n    content: \"\\e925\";\r\n  }\r\n  .bxl-discourse:before {\r\n    content: \"\\e926\";\r\n  }\r\n  .bxl-django:before {\r\n    content: \"\\e927\";\r\n  }\r\n  .bxl-docker:before {\r\n    content: \"\\e928\";\r\n  }\r\n  .bxl-dribbble:before {\r\n    content: \"\\e929\";\r\n  }\r\n  .bxl-dropbox:before {\r\n    content: \"\\e92a\";\r\n  }\r\n  .bxl-drupal:before {\r\n    content: \"\\e92b\";\r\n  }\r\n  .bxl-ebay:before {\r\n    content: \"\\e92c\";\r\n  }\r\n  .bxl-edge:before {\r\n    content: \"\\e92d\";\r\n  }\r\n  .bxl-etsy:before {\r\n    content: \"\\e92e\";\r\n  }\r\n  .bxl-facebook:before {\r\n    content: \"\\e92f\";\r\n  }\r\n  .bxl-facebook-circle:before {\r\n    content: \"\\e930\";\r\n  }\r\n  .bxl-facebook-square:before {\r\n    content: \"\\e931\";\r\n  }\r\n  .bxl-figma:before {\r\n    content: \"\\e932\";\r\n  }\r\n  .bxl-firebase:before {\r\n    content: \"\\e933\";\r\n  }\r\n  .bxl-firefox:before {\r\n    content: \"\\e934\";\r\n  }\r\n  .bxl-flickr:before {\r\n    content: \"\\e935\";\r\n  }\r\n  .bxl-flickr-square:before {\r\n    content: \"\\e936\";\r\n  }\r\n  .bxl-flutter:before {\r\n    content: \"\\e937\";\r\n  }\r\n  .bxl-foursquare:before {\r\n    content: \"\\e938\";\r\n  }\r\n  .bxl-git:before {\r\n    content: \"\\e939\";\r\n  }\r\n  .bxl-github:before {\r\n    content: \"\\e93a\";\r\n  }\r\n  .bxl-gitlab:before {\r\n    content: \"\\e93b\";\r\n  }\r\n  .bxl-google:before {\r\n    content: \"\\e93c\";\r\n  }\r\n  .bxl-google-cloud:before {\r\n    content: \"\\e93d\";\r\n  }\r\n  .bxl-google-plus:before {\r\n    content: \"\\e93e\";\r\n  }\r\n  .bxl-google-plus-circle:before {\r\n    content: \"\\e93f\";\r\n  }\r\n  .bxl-html5:before {\r\n    content: \"\\e940\";\r\n  }\r\n  .bxl-imdb:before {\r\n    content: \"\\e941\";\r\n  }\r\n  .bxl-instagram:before {\r\n    content: \"\\e942\";\r\n  }\r\n  .bxl-instagram-alt:before {\r\n    content: \"\\e943\";\r\n  }\r\n  .bxl-internet-explorer:before {\r\n    content: \"\\e944\";\r\n  }\r\n  .bxl-invision:before {\r\n    content: \"\\e945\";\r\n  }\r\n  .bxl-javascript:before {\r\n    content: \"\\e946\";\r\n  }\r\n  .bxl-joomla:before {\r\n    content: \"\\e947\";\r\n  }\r\n  .bxl-jquery:before {\r\n    content: \"\\e948\";\r\n  }\r\n  .bxl-jsfiddle:before {\r\n    content: \"\\e949\";\r\n  }\r\n  .bxl-kickstarter:before {\r\n    content: \"\\e94a\";\r\n  }\r\n  .bxl-kubernetes:before {\r\n    content: \"\\e94b\";\r\n  }\r\n  .bxl-less:before {\r\n    content: \"\\e94c\";\r\n  }\r\n  .bxl-linkedin:before {\r\n    content: \"\\e94d\";\r\n  }\r\n  .bxl-linkedin-square:before {\r\n    content: \"\\e94e\";\r\n  }\r\n  .bxl-magento:before {\r\n    content: \"\\e94f\";\r\n  }\r\n  .bxl-mailchimp:before {\r\n    content: \"\\e950\";\r\n  }\r\n  .bxl-markdown:before {\r\n    content: \"\\e951\";\r\n  }\r\n  .bxl-mastercard:before {\r\n    content: \"\\e952\";\r\n  }\r\n  .bxl-mastodon:before {\r\n    content: \"\\e953\";\r\n  }\r\n  .bxl-medium:before {\r\n    content: \"\\e954\";\r\n  }\r\n  .bxl-medium-old:before {\r\n    content: \"\\e955\";\r\n  }\r\n  .bxl-medium-square:before {\r\n    content: \"\\e956\";\r\n  }\r\n  .bxl-messenger:before {\r\n    content: \"\\e957\";\r\n  }\r\n  .bxl-microsoft:before {\r\n    content: \"\\e958\";\r\n  }\r\n  .bxl-microsoft-teams:before {\r\n    content: \"\\e959\";\r\n  }\r\n  .bxl-nodejs:before {\r\n    content: \"\\e95a\";\r\n  }\r\n  .bxl-ok-ru:before {\r\n    content: \"\\e95b\";\r\n  }\r\n  .bxl-opera:before {\r\n    content: \"\\e95c\";\r\n  }\r\n  .bxl-patreon:before {\r\n    content: \"\\e95d\";\r\n  }\r\n  .bxl-paypal:before {\r\n    content: \"\\e95e\";\r\n  }\r\n  .bxl-periscope:before {\r\n    content: \"\\e95f\";\r\n  }\r\n  .bxl-php:before {\r\n    content: \"\\e960\";\r\n  }\r\n  .bxl-pinterest:before {\r\n    content: \"\\e961\";\r\n  }\r\n  .bxl-pinterest-alt:before {\r\n    content: \"\\e962\";\r\n  }\r\n  .bxl-play-store:before {\r\n    content: \"\\e963\";\r\n  }\r\n  .bxl-pocket:before {\r\n    content: \"\\e964\";\r\n  }\r\n  .bxl-product-hunt:before {\r\n    content: \"\\e965\";\r\n  }\r\n  .bxl-python:before {\r\n    content: \"\\e966\";\r\n  }\r\n  .bxl-quora:before {\r\n    content: \"\\e967\";\r\n  }\r\n  .bxl-react:before {\r\n    content: \"\\e968\";\r\n  }\r\n  .bxl-redbubble:before {\r\n    content: \"\\e969\";\r\n  }\r\n  .bxl-reddit:before {\r\n    content: \"\\e96a\";\r\n  }\r\n  .bxl-redux:before {\r\n    content: \"\\e96b\";\r\n  }\r\n  .bxl-sass:before {\r\n    content: \"\\e96c\";\r\n  }\r\n  .bxl-shopify:before {\r\n    content: \"\\e96d\";\r\n  }\r\n  .bxl-sketch:before {\r\n    content: \"\\e96e\";\r\n  }\r\n  .bxl-skype:before {\r\n    content: \"\\e96f\";\r\n  }\r\n  .bxl-slack:before {\r\n    content: \"\\e970\";\r\n  }\r\n  .bxl-slack-old:before {\r\n    content: \"\\e971\";\r\n  }\r\n  .bxl-snapchat:before {\r\n    content: \"\\e972\";\r\n  }\r\n  .bxl-soundcloud:before {\r\n    content: \"\\e973\";\r\n  }\r\n  .bxl-spotify:before {\r\n    content: \"\\e974\";\r\n  }\r\n  .bxl-spring-boot:before {\r\n    content: \"\\e975\";\r\n  }\r\n  .bxl-squarespace:before {\r\n    content: \"\\e976\";\r\n  }\r\n  .bxl-stack-overflow:before {\r\n    content: \"\\e977\";\r\n  }\r\n  .bxl-steam:before {\r\n    content: \"\\e978\";\r\n  }\r\n  .bxl-stripe:before {\r\n    content: \"\\e979\";\r\n  }\r\n  .bxl-tailwind-css:before {\r\n    content: \"\\e97a\";\r\n  }\r\n  .bxl-telegram:before {\r\n    content: \"\\e97b\";\r\n  }\r\n  .bxl-tiktok:before {\r\n    content: \"\\e97c\";\r\n  }\r\n  .bxl-trello:before {\r\n    content: \"\\e97d\";\r\n  }\r\n  .bxl-trip-advisor:before {\r\n    content: \"\\e97e\";\r\n  }\r\n  .bxl-tumblr:before {\r\n    content: \"\\e97f\";\r\n  }\r\n  .bxl-tux:before {\r\n    content: \"\\e980\";\r\n  }\r\n  .bxl-twitch:before {\r\n    content: \"\\e981\";\r\n  }\r\n  .bxl-twitter:before {\r\n    content: \"\\e982\";\r\n  }\r\n  .bxl-unity:before {\r\n    content: \"\\e983\";\r\n  }\r\n  .bxl-unsplash:before {\r\n    content: \"\\e984\";\r\n  }\r\n  .bxl-vimeo:before {\r\n    content: \"\\e985\";\r\n  }\r\n  .bxl-visa:before {\r\n    content: \"\\e986\";\r\n  }\r\n  .bxl-visual-studio:before {\r\n    content: \"\\e987\";\r\n  }\r\n  .bxl-vk:before {\r\n    content: \"\\e988\";\r\n  }\r\n  .bxl-vuejs:before {\r\n    content: \"\\e989\";\r\n  }\r\n  .bxl-whatsapp:before {\r\n    content: \"\\e98a\";\r\n  }\r\n  .bxl-whatsapp-square:before {\r\n    content: \"\\e98b\";\r\n  }\r\n  .bxl-wikipedia:before {\r\n    content: \"\\e98c\";\r\n  }\r\n  .bxl-windows:before {\r\n    content: \"\\e98d\";\r\n  }\r\n  .bxl-wix:before {\r\n    content: \"\\e98e\";\r\n  }\r\n  .bxl-wordpress:before {\r\n    content: \"\\e98f\";\r\n  }\r\n  .bxl-yahoo:before {\r\n    content: \"\\e990\";\r\n  }\r\n  .bxl-yelp:before {\r\n    content: \"\\e991\";\r\n  }\r\n  .bxl-youtube:before {\r\n    content: \"\\e992\";\r\n  }\r\n  .bxl-zoom:before {\r\n    content: \"\\e993\";\r\n  }\r\n  .bx-collapse-alt:before {\r\n    content: \"\\e994\";\r\n  }\r\n  .bx-collapse-horizontal:before {\r\n    content: \"\\e995\";\r\n  }\r\n  .bx-collapse-vertical:before {\r\n    content: \"\\e996\";\r\n  }\r\n  .bx-expand-horizontal:before {\r\n    content: \"\\e997\";\r\n  }\r\n  .bx-expand-vertical:before {\r\n    content: \"\\e998\";\r\n  }\r\n  .bx-injection:before {\r\n    content: \"\\e999\";\r\n  }\r\n  .bx-leaf:before {\r\n    content: \"\\e99a\";\r\n  }\r\n  .bx-math:before {\r\n    content: \"\\e99b\";\r\n  }\r\n  .bx-party:before {\r\n    content: \"\\e99c\";\r\n  }\r\n  .bx-abacus:before {\r\n    content: \"\\e99d\";\r\n  }\r\n  .bx-accessibility:before {\r\n    content: \"\\e99e\";\r\n  }\r\n  .bx-add-to-queue:before {\r\n    content: \"\\e99f\";\r\n  }\r\n  .bx-adjust:before {\r\n    content: \"\\e9a0\";\r\n  }\r\n  .bx-alarm:before {\r\n    content: \"\\e9a1\";\r\n  }\r\n  .bx-alarm-add:before {\r\n    content: \"\\e9a2\";\r\n  }\r\n  .bx-alarm-exclamation:before {\r\n    content: \"\\e9a3\";\r\n  }\r\n  .bx-alarm-off:before {\r\n    content: \"\\e9a4\";\r\n  }\r\n  .bx-alarm-snooze:before {\r\n    content: \"\\e9a5\";\r\n  }\r\n  .bx-album:before {\r\n    content: \"\\e9a6\";\r\n  }\r\n  .bx-align-justify:before {\r\n    content: \"\\e9a7\";\r\n  }\r\n  .bx-align-left:before {\r\n    content: \"\\e9a8\";\r\n  }\r\n  .bx-align-middle:before {\r\n    content: \"\\e9a9\";\r\n  }\r\n  .bx-align-right:before {\r\n    content: \"\\e9aa\";\r\n  }\r\n  .bx-analyse:before {\r\n    content: \"\\e9ab\";\r\n  }\r\n  .bx-anchor:before {\r\n    content: \"\\e9ac\";\r\n  }\r\n  .bx-angry:before {\r\n    content: \"\\e9ad\";\r\n  }\r\n  .bx-aperture:before {\r\n    content: \"\\e9ae\";\r\n  }\r\n  .bx-arch:before {\r\n    content: \"\\e9af\";\r\n  }\r\n  .bx-archive:before {\r\n    content: \"\\e9b0\";\r\n  }\r\n  .bx-archive-in:before {\r\n    content: \"\\e9b1\";\r\n  }\r\n  .bx-archive-out:before {\r\n    content: \"\\e9b2\";\r\n  }\r\n  .bx-area:before {\r\n    content: \"\\e9b3\";\r\n  }\r\n  .bx-arrow-back:before {\r\n    content: \"\\e9b4\";\r\n  }\r\n  .bx-arrow-from-bottom:before {\r\n    content: \"\\e9b5\";\r\n  }\r\n  .bx-arrow-from-left:before {\r\n    content: \"\\e9b6\";\r\n  }\r\n  .bx-arrow-from-right:before {\r\n    content: \"\\e9b7\";\r\n  }\r\n  .bx-arrow-from-top:before {\r\n    content: \"\\e9b8\";\r\n  }\r\n  .bx-arrow-to-bottom:before {\r\n    content: \"\\e9b9\";\r\n  }\r\n  .bx-arrow-to-left:before {\r\n    content: \"\\e9ba\";\r\n  }\r\n  .bx-arrow-to-right:before {\r\n    content: \"\\e9bb\";\r\n  }\r\n  .bx-arrow-to-top:before {\r\n    content: \"\\e9bc\";\r\n  }\r\n  .bx-at:before {\r\n    content: \"\\e9bd\";\r\n  }\r\n  .bx-atom:before {\r\n    content: \"\\e9be\";\r\n  }\r\n  .bx-award:before {\r\n    content: \"\\e9bf\";\r\n  }\r\n  .bx-badge:before {\r\n    content: \"\\e9c0\";\r\n  }\r\n  .bx-badge-check:before {\r\n    content: \"\\e9c1\";\r\n  }\r\n  .bx-ball:before {\r\n    content: \"\\e9c2\";\r\n  }\r\n  .bx-band-aid:before {\r\n    content: \"\\e9c3\";\r\n  }\r\n  .bx-bar-chart:before {\r\n    content: \"\\e9c4\";\r\n  }\r\n  .bx-bar-chart-alt:before {\r\n    content: \"\\e9c5\";\r\n  }\r\n  .bx-bar-chart-alt-2:before {\r\n    content: \"\\e9c6\";\r\n  }\r\n  .bx-bar-chart-square:before {\r\n    content: \"\\e9c7\";\r\n  }\r\n  .bx-barcode:before {\r\n    content: \"\\e9c8\";\r\n  }\r\n  .bx-barcode-reader:before {\r\n    content: \"\\e9c9\";\r\n  }\r\n  .bx-baseball:before {\r\n    content: \"\\e9ca\";\r\n  }\r\n  .bx-basket:before {\r\n    content: \"\\e9cb\";\r\n  }\r\n  .bx-basketball:before {\r\n    content: \"\\e9cc\";\r\n  }\r\n  .bx-bath:before {\r\n    content: \"\\e9cd\";\r\n  }\r\n  .bx-battery:before {\r\n    content: \"\\e9ce\";\r\n  }\r\n  .bx-bed:before {\r\n    content: \"\\e9cf\";\r\n  }\r\n  .bx-been-here:before {\r\n    content: \"\\e9d0\";\r\n  }\r\n  .bx-beer:before {\r\n    content: \"\\e9d1\";\r\n  }\r\n  .bx-bell:before {\r\n    content: \"\\e9d2\";\r\n  }\r\n  .bx-bell-minus:before {\r\n    content: \"\\e9d3\";\r\n  }\r\n  .bx-bell-off:before {\r\n    content: \"\\e9d4\";\r\n  }\r\n  .bx-bell-plus:before {\r\n    content: \"\\e9d5\";\r\n  }\r\n  .bx-bible:before {\r\n    content: \"\\e9d6\";\r\n  }\r\n  .bx-bitcoin:before {\r\n    content: \"\\e9d7\";\r\n  }\r\n  .bx-blanket:before {\r\n    content: \"\\e9d8\";\r\n  }\r\n  .bx-block:before {\r\n    content: \"\\e9d9\";\r\n  }\r\n  .bx-bluetooth:before {\r\n    content: \"\\e9da\";\r\n  }\r\n  .bx-body:before {\r\n    content: \"\\e9db\";\r\n  }\r\n  .bx-bold:before {\r\n    content: \"\\e9dc\";\r\n  }\r\n  .bx-bolt-circle:before {\r\n    content: \"\\e9dd\";\r\n  }\r\n  .bx-bomb:before {\r\n    content: \"\\e9de\";\r\n  }\r\n  .bx-bone:before {\r\n    content: \"\\e9df\";\r\n  }\r\n  .bx-bong:before {\r\n    content: \"\\e9e0\";\r\n  }\r\n  .bx-book:before {\r\n    content: \"\\e9e1\";\r\n  }\r\n  .bx-book-add:before {\r\n    content: \"\\e9e2\";\r\n  }\r\n  .bx-book-alt:before {\r\n    content: \"\\e9e3\";\r\n  }\r\n  .bx-book-bookmark:before {\r\n    content: \"\\e9e4\";\r\n  }\r\n  .bx-book-content:before {\r\n    content: \"\\e9e5\";\r\n  }\r\n  .bx-book-heart:before {\r\n    content: \"\\e9e6\";\r\n  }\r\n  .bx-bookmark:before {\r\n    content: \"\\e9e7\";\r\n  }\r\n  .bx-bookmark-alt:before {\r\n    content: \"\\e9e8\";\r\n  }\r\n  .bx-bookmark-alt-minus:before {\r\n    content: \"\\e9e9\";\r\n  }\r\n  .bx-bookmark-alt-plus:before {\r\n    content: \"\\e9ea\";\r\n  }\r\n  .bx-bookmark-heart:before {\r\n    content: \"\\e9eb\";\r\n  }\r\n  .bx-bookmark-minus:before {\r\n    content: \"\\e9ec\";\r\n  }\r\n  .bx-bookmark-plus:before {\r\n    content: \"\\e9ed\";\r\n  }\r\n  .bx-bookmarks:before {\r\n    content: \"\\e9ee\";\r\n  }\r\n  .bx-book-open:before {\r\n    content: \"\\e9ef\";\r\n  }\r\n  .bx-book-reader:before {\r\n    content: \"\\e9f0\";\r\n  }\r\n  .bx-border-all:before {\r\n    content: \"\\e9f1\";\r\n  }\r\n  .bx-border-bottom:before {\r\n    content: \"\\e9f2\";\r\n  }\r\n  .bx-border-inner:before {\r\n    content: \"\\e9f3\";\r\n  }\r\n  .bx-border-left:before {\r\n    content: \"\\e9f4\";\r\n  }\r\n  .bx-border-none:before {\r\n    content: \"\\e9f5\";\r\n  }\r\n  .bx-border-outer:before {\r\n    content: \"\\e9f6\";\r\n  }\r\n  .bx-border-radius:before {\r\n    content: \"\\e9f7\";\r\n  }\r\n  .bx-border-right:before {\r\n    content: \"\\e9f8\";\r\n  }\r\n  .bx-border-top:before {\r\n    content: \"\\e9f9\";\r\n  }\r\n  .bx-bot:before {\r\n    content: \"\\e9fa\";\r\n  }\r\n  .bx-bowling-ball:before {\r\n    content: \"\\e9fb\";\r\n  }\r\n  .bx-box:before {\r\n    content: \"\\e9fc\";\r\n  }\r\n  .bx-bracket:before {\r\n    content: \"\\e9fd\";\r\n  }\r\n  .bx-braille:before {\r\n    content: \"\\e9fe\";\r\n  }\r\n  .bx-brain:before {\r\n    content: \"\\e9ff\";\r\n  }\r\n  .bx-briefcase:before {\r\n    content: \"\\ea00\";\r\n  }\r\n  .bx-briefcase-alt:before {\r\n    content: \"\\ea01\";\r\n  }\r\n  .bx-briefcase-alt-2:before {\r\n    content: \"\\ea02\";\r\n  }\r\n  .bx-brightness:before {\r\n    content: \"\\ea03\";\r\n  }\r\n  .bx-brightness-half:before {\r\n    content: \"\\ea04\";\r\n  }\r\n  .bx-broadcast:before {\r\n    content: \"\\ea05\";\r\n  }\r\n  .bx-brush:before {\r\n    content: \"\\ea06\";\r\n  }\r\n  .bx-brush-alt:before {\r\n    content: \"\\ea07\";\r\n  }\r\n  .bx-bug:before {\r\n    content: \"\\ea08\";\r\n  }\r\n  .bx-bug-alt:before {\r\n    content: \"\\ea09\";\r\n  }\r\n  .bx-building:before {\r\n    content: \"\\ea0a\";\r\n  }\r\n  .bx-building-house:before {\r\n    content: \"\\ea0b\";\r\n  }\r\n  .bx-buildings:before {\r\n    content: \"\\ea0c\";\r\n  }\r\n  .bx-bulb:before {\r\n    content: \"\\ea0d\";\r\n  }\r\n  .bx-bullseye:before {\r\n    content: \"\\ea0e\";\r\n  }\r\n  .bx-buoy:before {\r\n    content: \"\\ea0f\";\r\n  }\r\n  .bx-bus:before {\r\n    content: \"\\ea10\";\r\n  }\r\n  .bx-bus-school:before {\r\n    content: \"\\ea11\";\r\n  }\r\n  .bx-cabinet:before {\r\n    content: \"\\ea12\";\r\n  }\r\n  .bx-cake:before {\r\n    content: \"\\ea13\";\r\n  }\r\n  .bx-calculator:before {\r\n    content: \"\\ea14\";\r\n  }\r\n  .bx-calendar:before {\r\n    content: \"\\ea15\";\r\n  }\r\n  .bx-calendar-alt:before {\r\n    content: \"\\ea16\";\r\n  }\r\n  .bx-calendar-check:before {\r\n    content: \"\\ea17\";\r\n  }\r\n  .bx-calendar-edit:before {\r\n    content: \"\\ea18\";\r\n  }\r\n  .bx-calendar-event:before {\r\n    content: \"\\ea19\";\r\n  }\r\n  .bx-calendar-exclamation:before {\r\n    content: \"\\ea1a\";\r\n  }\r\n  .bx-calendar-heart:before {\r\n    content: \"\\ea1b\";\r\n  }\r\n  .bx-calendar-minus:before {\r\n    content: \"\\ea1c\";\r\n  }\r\n  .bx-calendar-plus:before {\r\n    content: \"\\ea1d\";\r\n  }\r\n  .bx-calendar-star:before {\r\n    content: \"\\ea1e\";\r\n  }\r\n  .bx-calendar-week:before {\r\n    content: \"\\ea1f\";\r\n  }\r\n  .bx-calendar-x:before {\r\n    content: \"\\ea20\";\r\n  }\r\n  .bx-camera:before {\r\n    content: \"\\ea21\";\r\n  }\r\n  .bx-camera-home:before {\r\n    content: \"\\ea22\";\r\n  }\r\n  .bx-camera-movie:before {\r\n    content: \"\\ea23\";\r\n  }\r\n  .bx-camera-off:before {\r\n    content: \"\\ea24\";\r\n  }\r\n  .bx-capsule:before {\r\n    content: \"\\ea25\";\r\n  }\r\n  .bx-captions:before {\r\n    content: \"\\ea26\";\r\n  }\r\n  .bx-car:before {\r\n    content: \"\\ea27\";\r\n  }\r\n  .bx-card:before {\r\n    content: \"\\ea28\";\r\n  }\r\n  .bx-caret-down:before {\r\n    content: \"\\ea29\";\r\n  }\r\n  .bx-caret-down-circle:before {\r\n    content: \"\\ea2a\";\r\n  }\r\n  .bx-caret-down-square:before {\r\n    content: \"\\ea2b\";\r\n  }\r\n  .bx-caret-left:before {\r\n    content: \"\\ea2c\";\r\n  }\r\n  .bx-caret-left-circle:before {\r\n    content: \"\\ea2d\";\r\n  }\r\n  .bx-caret-left-square:before {\r\n    content: \"\\ea2e\";\r\n  }\r\n  .bx-caret-right:before {\r\n    content: \"\\ea2f\";\r\n  }\r\n  .bx-caret-right-circle:before {\r\n    content: \"\\ea30\";\r\n  }\r\n  .bx-caret-right-square:before {\r\n    content: \"\\ea31\";\r\n  }\r\n  .bx-caret-up:before {\r\n    content: \"\\ea32\";\r\n  }\r\n  .bx-caret-up-circle:before {\r\n    content: \"\\ea33\";\r\n  }\r\n  .bx-caret-up-square:before {\r\n    content: \"\\ea34\";\r\n  }\r\n  .bx-carousel:before {\r\n    content: \"\\ea35\";\r\n  }\r\n  .bx-cart:before {\r\n    content: \"\\ea36\";\r\n  }\r\n  .bx-cart-alt:before {\r\n    content: \"\\ea37\";\r\n  }\r\n  .bx-cast:before {\r\n    content: \"\\ea38\";\r\n  }\r\n  .bx-category:before {\r\n    content: \"\\ea39\";\r\n  }\r\n  .bx-category-alt:before {\r\n    content: \"\\ea3a\";\r\n  }\r\n  .bx-cctv:before {\r\n    content: \"\\ea3b\";\r\n  }\r\n  .bx-certification:before {\r\n    content: \"\\ea3c\";\r\n  }\r\n  .bx-chair:before {\r\n    content: \"\\ea3d\";\r\n  }\r\n  .bx-chalkboard:before {\r\n    content: \"\\ea3e\";\r\n  }\r\n  .bx-chart:before {\r\n    content: \"\\ea3f\";\r\n  }\r\n  .bx-chat:before {\r\n    content: \"\\ea40\";\r\n  }\r\n  .bx-check:before {\r\n    content: \"\\ea41\";\r\n  }\r\n  .bx-checkbox:before {\r\n    content: \"\\ea42\";\r\n  }\r\n  .bx-checkbox-checked:before {\r\n    content: \"\\ea43\";\r\n  }\r\n  .bx-checkbox-minus:before {\r\n    content: \"\\ea44\";\r\n  }\r\n  .bx-checkbox-square:before {\r\n    content: \"\\ea45\";\r\n  }\r\n  .bx-check-circle:before {\r\n    content: \"\\ea46\";\r\n  }\r\n  .bx-check-double:before {\r\n    content: \"\\ea47\";\r\n  }\r\n  .bx-check-shield:before {\r\n    content: \"\\ea48\";\r\n  }\r\n  .bx-check-square:before {\r\n    content: \"\\ea49\";\r\n  }\r\n  .bx-chevron-down:before {\r\n    content: \"\\ea4a\";\r\n  }\r\n  .bx-chevron-down-circle:before {\r\n    content: \"\\ea4b\";\r\n  }\r\n  .bx-chevron-down-square:before {\r\n    content: \"\\ea4c\";\r\n  }\r\n  .bx-chevron-left:before {\r\n    content: \"\\ea4d\";\r\n  }\r\n  .bx-chevron-left-circle:before {\r\n    content: \"\\ea4e\";\r\n  }\r\n  .bx-chevron-left-square:before {\r\n    content: \"\\ea4f\";\r\n  }\r\n  .bx-chevron-right:before {\r\n    content: \"\\ea50\";\r\n  }\r\n  .bx-chevron-right-circle:before {\r\n    content: \"\\ea51\";\r\n  }\r\n  .bx-chevron-right-square:before {\r\n    content: \"\\ea52\";\r\n  }\r\n  .bx-chevrons-down:before {\r\n    content: \"\\ea53\";\r\n  }\r\n  .bx-chevrons-left:before {\r\n    content: \"\\ea54\";\r\n  }\r\n  .bx-chevrons-right:before {\r\n    content: \"\\ea55\";\r\n  }\r\n  .bx-chevrons-up:before {\r\n    content: \"\\ea56\";\r\n  }\r\n  .bx-chevron-up:before {\r\n    content: \"\\ea57\";\r\n  }\r\n  .bx-chevron-up-circle:before {\r\n    content: \"\\ea58\";\r\n  }\r\n  .bx-chevron-up-square:before {\r\n    content: \"\\ea59\";\r\n  }\r\n  .bx-chip:before {\r\n    content: \"\\ea5a\";\r\n  }\r\n  .bx-church:before {\r\n    content: \"\\ea5b\";\r\n  }\r\n  .bx-circle:before {\r\n    content: \"\\ea5c\";\r\n  }\r\n  .bx-clinic:before {\r\n    content: \"\\ea5d\";\r\n  }\r\n  .bx-clipboard:before {\r\n    content: \"\\ea5e\";\r\n  }\r\n  .bx-closet:before {\r\n    content: \"\\ea5f\";\r\n  }\r\n  .bx-cloud:before {\r\n    content: \"\\ea60\";\r\n  }\r\n  .bx-cloud-download:before {\r\n    content: \"\\ea61\";\r\n  }\r\n  .bx-cloud-drizzle:before {\r\n    content: \"\\ea62\";\r\n  }\r\n  .bx-cloud-lightning:before {\r\n    content: \"\\ea63\";\r\n  }\r\n  .bx-cloud-light-rain:before {\r\n    content: \"\\ea64\";\r\n  }\r\n  .bx-cloud-rain:before {\r\n    content: \"\\ea65\";\r\n  }\r\n  .bx-cloud-snow:before {\r\n    content: \"\\ea66\";\r\n  }\r\n  .bx-cloud-upload:before {\r\n    content: \"\\ea67\";\r\n  }\r\n  .bx-code:before {\r\n    content: \"\\ea68\";\r\n  }\r\n  .bx-code-alt:before {\r\n    content: \"\\ea69\";\r\n  }\r\n  .bx-code-block:before {\r\n    content: \"\\ea6a\";\r\n  }\r\n  .bx-code-curly:before {\r\n    content: \"\\ea6b\";\r\n  }\r\n  .bx-coffee:before {\r\n    content: \"\\ea6c\";\r\n  }\r\n  .bx-coffee-togo:before {\r\n    content: \"\\ea6d\";\r\n  }\r\n  .bx-cog:before {\r\n    content: \"\\ea6e\";\r\n  }\r\n  .bx-coin:before {\r\n    content: \"\\ea6f\";\r\n  }\r\n  .bx-coin-stack:before {\r\n    content: \"\\ea70\";\r\n  }\r\n  .bx-collapse:before {\r\n    content: \"\\ea71\";\r\n  }\r\n  .bx-collection:before {\r\n    content: \"\\ea72\";\r\n  }\r\n  .bx-color-fill:before {\r\n    content: \"\\ea73\";\r\n  }\r\n  .bx-columns:before {\r\n    content: \"\\ea74\";\r\n  }\r\n  .bx-command:before {\r\n    content: \"\\ea75\";\r\n  }\r\n  .bx-comment:before {\r\n    content: \"\\ea76\";\r\n  }\r\n  .bx-comment-add:before {\r\n    content: \"\\ea77\";\r\n  }\r\n  .bx-comment-check:before {\r\n    content: \"\\ea78\";\r\n  }\r\n  .bx-comment-detail:before {\r\n    content: \"\\ea79\";\r\n  }\r\n  .bx-comment-dots:before {\r\n    content: \"\\ea7a\";\r\n  }\r\n  .bx-comment-edit:before {\r\n    content: \"\\ea7b\";\r\n  }\r\n  .bx-comment-error:before {\r\n    content: \"\\ea7c\";\r\n  }\r\n  .bx-comment-minus:before {\r\n    content: \"\\ea7d\";\r\n  }\r\n  .bx-comment-x:before {\r\n    content: \"\\ea7e\";\r\n  }\r\n  .bx-compass:before {\r\n    content: \"\\ea7f\";\r\n  }\r\n  .bx-confused:before {\r\n    content: \"\\ea80\";\r\n  }\r\n  .bx-conversation:before {\r\n    content: \"\\ea81\";\r\n  }\r\n  .bx-cookie:before {\r\n    content: \"\\ea82\";\r\n  }\r\n  .bx-cool:before {\r\n    content: \"\\ea83\";\r\n  }\r\n  .bx-copy:before {\r\n    content: \"\\ea84\";\r\n  }\r\n  .bx-copy-alt:before {\r\n    content: \"\\ea85\";\r\n  }\r\n  .bx-copyright:before {\r\n    content: \"\\ea86\";\r\n  }\r\n  .bx-credit-card:before {\r\n    content: \"\\ea87\";\r\n  }\r\n  .bx-credit-card-alt:before {\r\n    content: \"\\ea88\";\r\n  }\r\n  .bx-credit-card-front:before {\r\n    content: \"\\ea89\";\r\n  }\r\n  .bx-crop:before {\r\n    content: \"\\ea8a\";\r\n  }\r\n  .bx-crosshair:before {\r\n    content: \"\\ea8b\";\r\n  }\r\n  .bx-crown:before {\r\n    content: \"\\ea8c\";\r\n  }\r\n  .bx-cube:before {\r\n    content: \"\\ea8d\";\r\n  }\r\n  .bx-cube-alt:before {\r\n    content: \"\\ea8e\";\r\n  }\r\n  .bx-cuboid:before {\r\n    content: \"\\ea8f\";\r\n  }\r\n  .bx-current-location:before {\r\n    content: \"\\ea90\";\r\n  }\r\n  .bx-customize:before {\r\n    content: \"\\ea91\";\r\n  }\r\n  .bx-cut:before {\r\n    content: \"\\ea92\";\r\n  }\r\n  .bx-cycling:before {\r\n    content: \"\\ea93\";\r\n  }\r\n  .bx-cylinder:before {\r\n    content: \"\\ea94\";\r\n  }\r\n  .bx-data:before {\r\n    content: \"\\ea95\";\r\n  }\r\n  .bx-desktop:before {\r\n    content: \"\\ea96\";\r\n  }\r\n  .bx-detail:before {\r\n    content: \"\\ea97\";\r\n  }\r\n  .bx-devices:before {\r\n    content: \"\\ea98\";\r\n  }\r\n  .bx-dialpad:before {\r\n    content: \"\\ea99\";\r\n  }\r\n  .bx-dialpad-alt:before {\r\n    content: \"\\ea9a\";\r\n  }\r\n  .bx-diamond:before {\r\n    content: \"\\ea9b\";\r\n  }\r\n  .bx-dice-1:before {\r\n    content: \"\\ea9c\";\r\n  }\r\n  .bx-dice-2:before {\r\n    content: \"\\ea9d\";\r\n  }\r\n  .bx-dice-3:before {\r\n    content: \"\\ea9e\";\r\n  }\r\n  .bx-dice-4:before {\r\n    content: \"\\ea9f\";\r\n  }\r\n  .bx-dice-5:before {\r\n    content: \"\\eaa0\";\r\n  }\r\n  .bx-dice-6:before {\r\n    content: \"\\eaa1\";\r\n  }\r\n  .bx-directions:before {\r\n    content: \"\\eaa2\";\r\n  }\r\n  .bx-disc:before {\r\n    content: \"\\eaa3\";\r\n  }\r\n  .bx-dish:before {\r\n    content: \"\\eaa4\";\r\n  }\r\n  .bx-dislike:before {\r\n    content: \"\\eaa5\";\r\n  }\r\n  .bx-dizzy:before {\r\n    content: \"\\eaa6\";\r\n  }\r\n  .bx-dna:before {\r\n    content: \"\\eaa7\";\r\n  }\r\n  .bx-dock-bottom:before {\r\n    content: \"\\eaa8\";\r\n  }\r\n  .bx-dock-left:before {\r\n    content: \"\\eaa9\";\r\n  }\r\n  .bx-dock-right:before {\r\n    content: \"\\eaaa\";\r\n  }\r\n  .bx-dock-top:before {\r\n    content: \"\\eaab\";\r\n  }\r\n  .bx-dollar:before {\r\n    content: \"\\eaac\";\r\n  }\r\n  .bx-dollar-circle:before {\r\n    content: \"\\eaad\";\r\n  }\r\n  .bx-donate-blood:before {\r\n    content: \"\\eaae\";\r\n  }\r\n  .bx-donate-heart:before {\r\n    content: \"\\eaaf\";\r\n  }\r\n  .bx-door-open:before {\r\n    content: \"\\eab0\";\r\n  }\r\n  .bx-dots-horizontal:before {\r\n    content: \"\\eab1\";\r\n  }\r\n  .bx-dots-horizontal-rounded:before {\r\n    content: \"\\eab2\";\r\n  }\r\n  .bx-dots-vertical:before {\r\n    content: \"\\eab3\";\r\n  }\r\n  .bx-dots-vertical-rounded:before {\r\n    content: \"\\eab4\";\r\n  }\r\n  .bx-doughnut-chart:before {\r\n    content: \"\\eab5\";\r\n  }\r\n  .bx-down-arrow:before {\r\n    content: \"\\eab6\";\r\n  }\r\n  .bx-down-arrow-alt:before {\r\n    content: \"\\eab7\";\r\n  }\r\n  .bx-down-arrow-circle:before {\r\n    content: \"\\eab8\";\r\n  }\r\n  .bx-download:before {\r\n    content: \"\\eab9\";\r\n  }\r\n  .bx-downvote:before {\r\n    content: \"\\eaba\";\r\n  }\r\n  .bx-drink:before {\r\n    content: \"\\eabb\";\r\n  }\r\n  .bx-droplet:before {\r\n    content: \"\\eabc\";\r\n  }\r\n  .bx-dumbbell:before {\r\n    content: \"\\eabd\";\r\n  }\r\n  .bx-duplicate:before {\r\n    content: \"\\eabe\";\r\n  }\r\n  .bx-edit:before {\r\n    content: \"\\eabf\";\r\n  }\r\n  .bx-edit-alt:before {\r\n    content: \"\\eac0\";\r\n  }\r\n  .bx-envelope:before {\r\n    content: \"\\eac1\";\r\n  }\r\n  .bx-envelope-open:before {\r\n    content: \"\\eac2\";\r\n  }\r\n  .bx-equalizer:before {\r\n    content: \"\\eac3\";\r\n  }\r\n  .bx-eraser:before {\r\n    content: \"\\eac4\";\r\n  }\r\n  .bx-error:before {\r\n    content: \"\\eac5\";\r\n  }\r\n  .bx-error-alt:before {\r\n    content: \"\\eac6\";\r\n  }\r\n  .bx-error-circle:before {\r\n    content: \"\\eac7\";\r\n  }\r\n  .bx-euro:before {\r\n    content: \"\\eac8\";\r\n  }\r\n  .bx-exclude:before {\r\n    content: \"\\eac9\";\r\n  }\r\n  .bx-exit:before {\r\n    content: \"\\eaca\";\r\n  }\r\n  .bx-exit-fullscreen:before {\r\n    content: \"\\eacb\";\r\n  }\r\n  .bx-expand:before {\r\n    content: \"\\eacc\";\r\n  }\r\n  .bx-expand-alt:before {\r\n    content: \"\\eacd\";\r\n  }\r\n  .bx-export:before {\r\n    content: \"\\eace\";\r\n  }\r\n  .bx-extension:before {\r\n    content: \"\\eacf\";\r\n  }\r\n  .bx-face:before {\r\n    content: \"\\ead0\";\r\n  }\r\n  .bx-fast-forward:before {\r\n    content: \"\\ead1\";\r\n  }\r\n  .bx-fast-forward-circle:before {\r\n    content: \"\\ead2\";\r\n  }\r\n  .bx-female:before {\r\n    content: \"\\ead3\";\r\n  }\r\n  .bx-female-sign:before {\r\n    content: \"\\ead4\";\r\n  }\r\n  .bx-file:before {\r\n    content: \"\\ead5\";\r\n  }\r\n  .bx-file-blank:before {\r\n    content: \"\\ead6\";\r\n  }\r\n  .bx-file-find:before {\r\n    content: \"\\ead7\";\r\n  }\r\n  .bx-film:before {\r\n    content: \"\\ead8\";\r\n  }\r\n  .bx-filter:before {\r\n    content: \"\\ead9\";\r\n  }\r\n  .bx-filter-alt:before {\r\n    content: \"\\eada\";\r\n  }\r\n  .bx-fingerprint:before {\r\n    content: \"\\eadb\";\r\n  }\r\n  .bx-first-aid:before {\r\n    content: \"\\eadc\";\r\n  }\r\n  .bx-first-page:before {\r\n    content: \"\\eadd\";\r\n  }\r\n  .bx-flag:before {\r\n    content: \"\\eade\";\r\n  }\r\n  .bx-folder:before {\r\n    content: \"\\eadf\";\r\n  }\r\n  .bx-folder-minus:before {\r\n    content: \"\\eae0\";\r\n  }\r\n  .bx-folder-open:before {\r\n    content: \"\\eae1\";\r\n  }\r\n  .bx-folder-plus:before {\r\n    content: \"\\eae2\";\r\n  }\r\n  .bx-font:before {\r\n    content: \"\\eae3\";\r\n  }\r\n  .bx-font-color:before {\r\n    content: \"\\eae4\";\r\n  }\r\n  .bx-font-family:before {\r\n    content: \"\\eae5\";\r\n  }\r\n  .bx-font-size:before {\r\n    content: \"\\eae6\";\r\n  }\r\n  .bx-food-menu:before {\r\n    content: \"\\eae7\";\r\n  }\r\n  .bx-food-tag:before {\r\n    content: \"\\eae8\";\r\n  }\r\n  .bx-football:before {\r\n    content: \"\\eae9\";\r\n  }\r\n  .bx-fridge:before {\r\n    content: \"\\eaea\";\r\n  }\r\n  .bx-fullscreen:before {\r\n    content: \"\\eaeb\";\r\n  }\r\n  .bx-game:before {\r\n    content: \"\\eaec\";\r\n  }\r\n  .bx-gas-pump:before {\r\n    content: \"\\eaed\";\r\n  }\r\n  .bx-ghost:before {\r\n    content: \"\\eaee\";\r\n  }\r\n  .bx-gift:before {\r\n    content: \"\\eaef\";\r\n  }\r\n  .bx-git-branch:before {\r\n    content: \"\\eaf0\";\r\n  }\r\n  .bx-git-commit:before {\r\n    content: \"\\eaf1\";\r\n  }\r\n  .bx-git-compare:before {\r\n    content: \"\\eaf2\";\r\n  }\r\n  .bx-git-merge:before {\r\n    content: \"\\eaf3\";\r\n  }\r\n  .bx-git-pull-request:before {\r\n    content: \"\\eaf4\";\r\n  }\r\n  .bx-git-repo-forked:before {\r\n    content: \"\\eaf5\";\r\n  }\r\n  .bx-glasses:before {\r\n    content: \"\\eaf6\";\r\n  }\r\n  .bx-glasses-alt:before {\r\n    content: \"\\eaf7\";\r\n  }\r\n  .bx-globe:before {\r\n    content: \"\\eaf8\";\r\n  }\r\n  .bx-globe-alt:before {\r\n    content: \"\\eaf9\";\r\n  }\r\n  .bx-grid:before {\r\n    content: \"\\eafa\";\r\n  }\r\n  .bx-grid-alt:before {\r\n    content: \"\\eafb\";\r\n  }\r\n  .bx-grid-horizontal:before {\r\n    content: \"\\eafc\";\r\n  }\r\n  .bx-grid-small:before {\r\n    content: \"\\eafd\";\r\n  }\r\n  .bx-grid-vertical:before {\r\n    content: \"\\eafe\";\r\n  }\r\n  .bx-group:before {\r\n    content: \"\\eaff\";\r\n  }\r\n  .bx-handicap:before {\r\n    content: \"\\eb00\";\r\n  }\r\n  .bx-happy:before {\r\n    content: \"\\eb01\";\r\n  }\r\n  .bx-happy-alt:before {\r\n    content: \"\\eb02\";\r\n  }\r\n  .bx-happy-beaming:before {\r\n    content: \"\\eb03\";\r\n  }\r\n  .bx-happy-heart-eyes:before {\r\n    content: \"\\eb04\";\r\n  }\r\n  .bx-hash:before {\r\n    content: \"\\eb05\";\r\n  }\r\n  .bx-hdd:before {\r\n    content: \"\\eb06\";\r\n  }\r\n  .bx-heading:before {\r\n    content: \"\\eb07\";\r\n  }\r\n  .bx-headphone:before {\r\n    content: \"\\eb08\";\r\n  }\r\n  .bx-health:before {\r\n    content: \"\\eb09\";\r\n  }\r\n  .bx-heart:before {\r\n    content: \"\\eb0a\";\r\n  }\r\n  .bx-heart-circle:before {\r\n    content: \"\\eb0b\";\r\n  }\r\n  .bx-heart-square:before {\r\n    content: \"\\eb0c\";\r\n  }\r\n  .bx-help-circle:before {\r\n    content: \"\\eb0d\";\r\n  }\r\n  .bx-hide:before {\r\n    content: \"\\eb0e\";\r\n  }\r\n  .bx-highlight:before {\r\n    content: \"\\eb0f\";\r\n  }\r\n  .bx-history:before {\r\n    content: \"\\eb10\";\r\n  }\r\n  .bx-hive:before {\r\n    content: \"\\eb11\";\r\n  }\r\n  .bx-home:before {\r\n    content: \"\\eb12\";\r\n  }\r\n  .bx-home-alt:before {\r\n    content: \"\\eb13\";\r\n  }\r\n  .bx-home-circle:before {\r\n    content: \"\\eb14\";\r\n  }\r\n  .bx-home-heart:before {\r\n    content: \"\\eb15\";\r\n  }\r\n  .bx-home-smile:before {\r\n    content: \"\\eb16\";\r\n  }\r\n  .bx-horizontal-center:before {\r\n    content: \"\\eb17\";\r\n  }\r\n  .bx-hotel:before {\r\n    content: \"\\eb18\";\r\n  }\r\n  .bx-hourglass:before {\r\n    content: \"\\eb19\";\r\n  }\r\n  .bx-id-card:before {\r\n    content: \"\\eb1a\";\r\n  }\r\n  .bx-image:before {\r\n    content: \"\\eb1b\";\r\n  }\r\n  .bx-image-add:before {\r\n    content: \"\\eb1c\";\r\n  }\r\n  .bx-image-alt:before {\r\n    content: \"\\eb1d\";\r\n  }\r\n  .bx-images:before {\r\n    content: \"\\eb1e\";\r\n  }\r\n  .bx-import:before {\r\n    content: \"\\eb1f\";\r\n  }\r\n  .bx-infinite:before {\r\n    content: \"\\eb20\";\r\n  }\r\n  .bx-info-circle:before {\r\n    content: \"\\eb21\";\r\n  }\r\n  .bx-info-square:before {\r\n    content: \"\\eb22\";\r\n  }\r\n  .bx-intersect:before {\r\n    content: \"\\eb23\";\r\n  }\r\n  .bx-italic:before {\r\n    content: \"\\eb24\";\r\n  }\r\n  .bx-joystick:before {\r\n    content: \"\\eb25\";\r\n  }\r\n  .bx-joystick-alt:before {\r\n    content: \"\\eb26\";\r\n  }\r\n  .bx-joystick-button:before {\r\n    content: \"\\eb27\";\r\n  }\r\n  .bx-key:before {\r\n    content: \"\\eb28\";\r\n  }\r\n  .bx-label:before {\r\n    content: \"\\eb29\";\r\n  }\r\n  .bx-landscape:before {\r\n    content: \"\\eb2a\";\r\n  }\r\n  .bx-laptop:before {\r\n    content: \"\\eb2b\";\r\n  }\r\n  .bx-last-page:before {\r\n    content: \"\\eb2c\";\r\n  }\r\n  .bx-laugh:before {\r\n    content: \"\\eb2d\";\r\n  }\r\n  .bx-layer:before {\r\n    content: \"\\eb2e\";\r\n  }\r\n  .bx-layer-minus:before {\r\n    content: \"\\eb2f\";\r\n  }\r\n  .bx-layer-plus:before {\r\n    content: \"\\eb30\";\r\n  }\r\n  .bx-layout:before {\r\n    content: \"\\eb31\";\r\n  }\r\n  .bx-left-arrow:before {\r\n    content: \"\\eb32\";\r\n  }\r\n  .bx-left-arrow-alt:before {\r\n    content: \"\\eb33\";\r\n  }\r\n  .bx-left-arrow-circle:before {\r\n    content: \"\\eb34\";\r\n  }\r\n  .bx-left-down-arrow-circle:before {\r\n    content: \"\\eb35\";\r\n  }\r\n  .bx-left-indent:before {\r\n    content: \"\\eb36\";\r\n  }\r\n  .bx-left-top-arrow-circle:before {\r\n    content: \"\\eb37\";\r\n  }\r\n  .bx-library:before {\r\n    content: \"\\eb38\";\r\n  }\r\n  .bx-like:before {\r\n    content: \"\\eb39\";\r\n  }\r\n  .bx-line-chart:before {\r\n    content: \"\\eb3a\";\r\n  }\r\n  .bx-line-chart-down:before {\r\n    content: \"\\eb3b\";\r\n  }\r\n  .bx-link:before {\r\n    content: \"\\eb3c\";\r\n  }\r\n  .bx-link-alt:before {\r\n    content: \"\\eb3d\";\r\n  }\r\n  .bx-link-external:before {\r\n    content: \"\\eb3e\";\r\n  }\r\n  .bx-lira:before {\r\n    content: \"\\eb3f\";\r\n  }\r\n  .bx-list-check:before {\r\n    content: \"\\eb40\";\r\n  }\r\n  .bx-list-minus:before {\r\n    content: \"\\eb41\";\r\n  }\r\n  .bx-list-ol:before {\r\n    content: \"\\eb42\";\r\n  }\r\n  .bx-list-plus:before {\r\n    content: \"\\eb43\";\r\n  }\r\n  .bx-list-ul:before {\r\n    content: \"\\eb44\";\r\n  }\r\n  .bx-loader:before {\r\n    content: \"\\eb45\";\r\n  }\r\n  .bx-loader-alt:before {\r\n    content: \"\\eb46\";\r\n  }\r\n  .bx-loader-circle:before {\r\n    content: \"\\eb47\";\r\n  }\r\n  .bx-location-plus:before {\r\n    content: \"\\eb48\";\r\n  }\r\n  .bx-lock:before {\r\n    content: \"\\eb49\";\r\n  }\r\n  .bx-lock-alt:before {\r\n    content: \"\\eb4a\";\r\n  }\r\n  .bx-lock-open:before {\r\n    content: \"\\eb4b\";\r\n  }\r\n  .bx-lock-open-alt:before {\r\n    content: \"\\eb4c\";\r\n  }\r\n  .bx-log-in:before {\r\n    content: \"\\eb4d\";\r\n  }\r\n  .bx-log-in-circle:before {\r\n    content: \"\\eb4e\";\r\n  }\r\n  .bx-log-out:before {\r\n    content: \"\\eb4f\";\r\n  }\r\n  .bx-log-out-circle:before {\r\n    content: \"\\eb50\";\r\n  }\r\n  .bx-low-vision:before {\r\n    content: \"\\eb51\";\r\n  }\r\n  .bx-magnet:before {\r\n    content: \"\\eb52\";\r\n  }\r\n  .bx-mail-send:before {\r\n    content: \"\\eb53\";\r\n  }\r\n  .bx-male:before {\r\n    content: \"\\eb54\";\r\n  }\r\n  .bx-male-sign:before {\r\n    content: \"\\eb55\";\r\n  }\r\n  .bx-map:before {\r\n    content: \"\\eb56\";\r\n  }\r\n  .bx-map-alt:before {\r\n    content: \"\\eb57\";\r\n  }\r\n  .bx-map-pin:before {\r\n    content: \"\\eb58\";\r\n  }\r\n  .bx-mask:before {\r\n    content: \"\\eb59\";\r\n  }\r\n  .bx-medal:before {\r\n    content: \"\\eb5a\";\r\n  }\r\n  .bx-meh:before {\r\n    content: \"\\eb5b\";\r\n  }\r\n  .bx-meh-alt:before {\r\n    content: \"\\eb5c\";\r\n  }\r\n  .bx-meh-blank:before {\r\n    content: \"\\eb5d\";\r\n  }\r\n  .bx-memory-card:before {\r\n    content: \"\\eb5e\";\r\n  }\r\n  .bx-menu:before {\r\n    content: \"\\eb5f\";\r\n  }\r\n  .bx-menu-alt-left:before {\r\n    content: \"\\eb60\";\r\n  }\r\n  .bx-menu-alt-right:before {\r\n    content: \"\\eb61\";\r\n  }\r\n  .bx-merge:before {\r\n    content: \"\\eb62\";\r\n  }\r\n  .bx-message:before {\r\n    content: \"\\eb63\";\r\n  }\r\n  .bx-message-add:before {\r\n    content: \"\\eb64\";\r\n  }\r\n  .bx-message-alt:before {\r\n    content: \"\\eb65\";\r\n  }\r\n  .bx-message-alt-add:before {\r\n    content: \"\\eb66\";\r\n  }\r\n  .bx-message-alt-check:before {\r\n    content: \"\\eb67\";\r\n  }\r\n  .bx-message-alt-detail:before {\r\n    content: \"\\eb68\";\r\n  }\r\n  .bx-message-alt-dots:before {\r\n    content: \"\\eb69\";\r\n  }\r\n  .bx-message-alt-edit:before {\r\n    content: \"\\eb6a\";\r\n  }\r\n  .bx-message-alt-error:before {\r\n    content: \"\\eb6b\";\r\n  }\r\n  .bx-message-alt-minus:before {\r\n    content: \"\\eb6c\";\r\n  }\r\n  .bx-message-alt-x:before {\r\n    content: \"\\eb6d\";\r\n  }\r\n  .bx-message-check:before {\r\n    content: \"\\eb6e\";\r\n  }\r\n  .bx-message-detail:before {\r\n    content: \"\\eb6f\";\r\n  }\r\n  .bx-message-dots:before {\r\n    content: \"\\eb70\";\r\n  }\r\n  .bx-message-edit:before {\r\n    content: \"\\eb71\";\r\n  }\r\n  .bx-message-error:before {\r\n    content: \"\\eb72\";\r\n  }\r\n  .bx-message-minus:before {\r\n    content: \"\\eb73\";\r\n  }\r\n  .bx-message-rounded:before {\r\n    content: \"\\eb74\";\r\n  }\r\n  .bx-message-rounded-add:before {\r\n    content: \"\\eb75\";\r\n  }\r\n  .bx-message-rounded-check:before {\r\n    content: \"\\eb76\";\r\n  }\r\n  .bx-message-rounded-detail:before {\r\n    content: \"\\eb77\";\r\n  }\r\n  .bx-message-rounded-dots:before {\r\n    content: \"\\eb78\";\r\n  }\r\n  .bx-message-rounded-edit:before {\r\n    content: \"\\eb79\";\r\n  }\r\n  .bx-message-rounded-error:before {\r\n    content: \"\\eb7a\";\r\n  }\r\n  .bx-message-rounded-minus:before {\r\n    content: \"\\eb7b\";\r\n  }\r\n  .bx-message-rounded-x:before {\r\n    content: \"\\eb7c\";\r\n  }\r\n  .bx-message-square:before {\r\n    content: \"\\eb7d\";\r\n  }\r\n  .bx-message-square-add:before {\r\n    content: \"\\eb7e\";\r\n  }\r\n  .bx-message-square-check:before {\r\n    content: \"\\eb7f\";\r\n  }\r\n  .bx-message-square-detail:before {\r\n    content: \"\\eb80\";\r\n  }\r\n  .bx-message-square-dots:before {\r\n    content: \"\\eb81\";\r\n  }\r\n  .bx-message-square-edit:before {\r\n    content: \"\\eb82\";\r\n  }\r\n  .bx-message-square-error:before {\r\n    content: \"\\eb83\";\r\n  }\r\n  .bx-message-square-minus:before {\r\n    content: \"\\eb84\";\r\n  }\r\n  .bx-message-square-x:before {\r\n    content: \"\\eb85\";\r\n  }\r\n  .bx-message-x:before {\r\n    content: \"\\eb86\";\r\n  }\r\n  .bx-meteor:before {\r\n    content: \"\\eb87\";\r\n  }\r\n  .bx-microchip:before {\r\n    content: \"\\eb88\";\r\n  }\r\n  .bx-microphone:before {\r\n    content: \"\\eb89\";\r\n  }\r\n  .bx-microphone-off:before {\r\n    content: \"\\eb8a\";\r\n  }\r\n  .bx-minus:before {\r\n    content: \"\\eb8b\";\r\n  }\r\n  .bx-minus-back:before {\r\n    content: \"\\eb8c\";\r\n  }\r\n  .bx-minus-circle:before {\r\n    content: \"\\eb8d\";\r\n  }\r\n  .bx-minus-front:before {\r\n    content: \"\\eb8e\";\r\n  }\r\n  .bx-mobile:before {\r\n    content: \"\\eb8f\";\r\n  }\r\n  .bx-mobile-alt:before {\r\n    content: \"\\eb90\";\r\n  }\r\n  .bx-mobile-landscape:before {\r\n    content: \"\\eb91\";\r\n  }\r\n  .bx-mobile-vibration:before {\r\n    content: \"\\eb92\";\r\n  }\r\n  .bx-money:before {\r\n    content: \"\\eb93\";\r\n  }\r\n  .bx-moon:before {\r\n    content: \"\\eb94\";\r\n  }\r\n  .bx-mouse:before {\r\n    content: \"\\eb95\";\r\n  }\r\n  .bx-mouse-alt:before {\r\n    content: \"\\eb96\";\r\n  }\r\n  .bx-move:before {\r\n    content: \"\\eb97\";\r\n  }\r\n  .bx-move-horizontal:before {\r\n    content: \"\\eb98\";\r\n  }\r\n  .bx-move-vertical:before {\r\n    content: \"\\eb99\";\r\n  }\r\n  .bx-movie:before {\r\n    content: \"\\eb9a\";\r\n  }\r\n  .bx-movie-play:before {\r\n    content: \"\\eb9b\";\r\n  }\r\n  .bx-music:before {\r\n    content: \"\\eb9c\";\r\n  }\r\n  .bx-navigation:before {\r\n    content: \"\\eb9d\";\r\n  }\r\n  .bx-network-chart:before {\r\n    content: \"\\eb9e\";\r\n  }\r\n  .bx-news:before {\r\n    content: \"\\eb9f\";\r\n  }\r\n  .bx-no-entry:before {\r\n    content: \"\\eba0\";\r\n  }\r\n  .bx-note:before {\r\n    content: \"\\eba1\";\r\n  }\r\n  .bx-notepad:before {\r\n    content: \"\\eba2\";\r\n  }\r\n  .bx-notification:before {\r\n    content: \"\\eba3\";\r\n  }\r\n  .bx-notification-off:before {\r\n    content: \"\\eba4\";\r\n  }\r\n  .bx-outline:before {\r\n    content: \"\\eba5\";\r\n  }\r\n  .bx-package:before {\r\n    content: \"\\eba6\";\r\n  }\r\n  .bx-paint:before {\r\n    content: \"\\eba7\";\r\n  }\r\n  .bx-paint-roll:before {\r\n    content: \"\\eba8\";\r\n  }\r\n  .bx-palette:before {\r\n    content: \"\\eba9\";\r\n  }\r\n  .bx-paperclip:before {\r\n    content: \"\\ebaa\";\r\n  }\r\n  .bx-paper-plane:before {\r\n    content: \"\\ebab\";\r\n  }\r\n  .bx-paragraph:before {\r\n    content: \"\\ebac\";\r\n  }\r\n  .bx-paste:before {\r\n    content: \"\\ebad\";\r\n  }\r\n  .bx-pause:before {\r\n    content: \"\\ebae\";\r\n  }\r\n  .bx-pause-circle:before {\r\n    content: \"\\ebaf\";\r\n  }\r\n  .bx-pen:before {\r\n    content: \"\\ebb0\";\r\n  }\r\n  .bx-pencil:before {\r\n    content: \"\\ebb1\";\r\n  }\r\n  .bx-phone:before {\r\n    content: \"\\ebb2\";\r\n  }\r\n  .bx-phone-call:before {\r\n    content: \"\\ebb3\";\r\n  }\r\n  .bx-phone-incoming:before {\r\n    content: \"\\ebb4\";\r\n  }\r\n  .bx-phone-off:before {\r\n    content: \"\\ebb5\";\r\n  }\r\n  .bx-phone-outgoing:before {\r\n    content: \"\\ebb6\";\r\n  }\r\n  .bx-photo-album:before {\r\n    content: \"\\ebb7\";\r\n  }\r\n  .bx-pie-chart:before {\r\n    content: \"\\ebb8\";\r\n  }\r\n  .bx-pie-chart-alt:before {\r\n    content: \"\\ebb9\";\r\n  }\r\n  .bx-pie-chart-alt-2:before {\r\n    content: \"\\ebba\";\r\n  }\r\n  .bx-pin:before {\r\n    content: \"\\ebbb\";\r\n  }\r\n  .bx-planet:before {\r\n    content: \"\\ebbc\";\r\n  }\r\n  .bx-play:before {\r\n    content: \"\\ebbd\";\r\n  }\r\n  .bx-play-circle:before {\r\n    content: \"\\ebbe\";\r\n  }\r\n  .bx-plug:before {\r\n    content: \"\\ebbf\";\r\n  }\r\n  .bx-plus:before {\r\n    content: \"\\ebc0\";\r\n  }\r\n  .bx-plus-circle:before {\r\n    content: \"\\ebc1\";\r\n  }\r\n  .bx-plus-medical:before {\r\n    content: \"\\ebc2\";\r\n  }\r\n  .bx-podcast:before {\r\n    content: \"\\ebc3\";\r\n  }\r\n  .bx-pointer:before {\r\n    content: \"\\ebc4\";\r\n  }\r\n  .bx-poll:before {\r\n    content: \"\\ebc5\";\r\n  }\r\n  .bx-polygon:before {\r\n    content: \"\\ebc6\";\r\n  }\r\n  .bx-pound:before {\r\n    content: \"\\ebc7\";\r\n  }\r\n  .bx-power-off:before {\r\n    content: \"\\ebc8\";\r\n  }\r\n  .bx-printer:before {\r\n    content: \"\\ebc9\";\r\n  }\r\n  .bx-pulse:before {\r\n    content: \"\\ebca\";\r\n  }\r\n  .bx-purchase-tag:before {\r\n    content: \"\\ebcb\";\r\n  }\r\n  .bx-purchase-tag-alt:before {\r\n    content: \"\\ebcc\";\r\n  }\r\n  .bx-pyramid:before {\r\n    content: \"\\ebcd\";\r\n  }\r\n  .bx-qr:before {\r\n    content: \"\\ebce\";\r\n  }\r\n  .bx-qr-scan:before {\r\n    content: \"\\ebcf\";\r\n  }\r\n  .bx-question-mark:before {\r\n    content: \"\\ebd0\";\r\n  }\r\n  .bx-radar:before {\r\n    content: \"\\ebd1\";\r\n  }\r\n  .bx-radio:before {\r\n    content: \"\\ebd2\";\r\n  }\r\n  .bx-radio-circle:before {\r\n    content: \"\\ebd3\";\r\n  }\r\n  .bx-radio-circle-marked:before {\r\n    content: \"\\ebd4\";\r\n  }\r\n  .bx-receipt:before {\r\n    content: \"\\ebd5\";\r\n  }\r\n  .bx-rectangle:before {\r\n    content: \"\\ebd6\";\r\n  }\r\n  .bx-recycle:before {\r\n    content: \"\\ebd7\";\r\n  }\r\n  .bx-redo:before {\r\n    content: \"\\ebd8\";\r\n  }\r\n  .bx-refresh:before {\r\n    content: \"\\ebd9\";\r\n  }\r\n  .bx-registered:before {\r\n    content: \"\\ebda\";\r\n  }\r\n  .bx-rename:before {\r\n    content: \"\\ebdb\";\r\n  }\r\n  .bx-repeat:before {\r\n    content: \"\\ebdc\";\r\n  }\r\n  .bx-reply:before {\r\n    content: \"\\ebdd\";\r\n  }\r\n  .bx-reply-all:before {\r\n    content: \"\\ebde\";\r\n  }\r\n  .bx-repost:before {\r\n    content: \"\\ebdf\";\r\n  }\r\n  .bx-reset:before {\r\n    content: \"\\ebe0\";\r\n  }\r\n  .bx-restaurant:before {\r\n    content: \"\\ebe1\";\r\n  }\r\n  .bx-revision:before {\r\n    content: \"\\ebe2\";\r\n  }\r\n  .bx-rewind:before {\r\n    content: \"\\ebe3\";\r\n  }\r\n  .bx-rewind-circle:before {\r\n    content: \"\\ebe4\";\r\n  }\r\n  .bx-right-arrow:before {\r\n    content: \"\\ebe5\";\r\n  }\r\n  .bx-right-arrow-alt:before {\r\n    content: \"\\ebe6\";\r\n  }\r\n  .bx-right-arrow-circle:before {\r\n    content: \"\\ebe7\";\r\n  }\r\n  .bx-right-down-arrow-circle:before {\r\n    content: \"\\ebe8\";\r\n  }\r\n  .bx-right-indent:before {\r\n    content: \"\\ebe9\";\r\n  }\r\n  .bx-right-top-arrow-circle:before {\r\n    content: \"\\ebea\";\r\n  }\r\n  .bx-rocket:before {\r\n    content: \"\\ebeb\";\r\n  }\r\n  .bx-rotate-left:before {\r\n    content: \"\\ebec\";\r\n  }\r\n  .bx-rotate-right:before {\r\n    content: \"\\ebed\";\r\n  }\r\n  .bx-rss:before {\r\n    content: \"\\ebee\";\r\n  }\r\n  .bx-ruble:before {\r\n    content: \"\\ebef\";\r\n  }\r\n  .bx-ruler:before {\r\n    content: \"\\ebf0\";\r\n  }\r\n  .bx-run:before {\r\n    content: \"\\ebf1\";\r\n  }\r\n  .bx-rupee:before {\r\n    content: \"\\ebf2\";\r\n  }\r\n  .bx-sad:before {\r\n    content: \"\\ebf3\";\r\n  }\r\n  .bx-save:before {\r\n    content: \"\\ebf4\";\r\n  }\r\n  .bx-scan:before {\r\n    content: \"\\ebf5\";\r\n  }\r\n  .bx-screenshot:before {\r\n    content: \"\\ebf6\";\r\n  }\r\n  .bx-search:before {\r\n    content: \"\\ebf7\";\r\n  }\r\n  .bx-search-alt:before {\r\n    content: \"\\ebf8\";\r\n  }\r\n  .bx-search-alt-2:before {\r\n    content: \"\\ebf9\";\r\n  }\r\n  .bx-selection:before {\r\n    content: \"\\ebfa\";\r\n  }\r\n  .bx-select-multiple:before {\r\n    content: \"\\ebfb\";\r\n  }\r\n  .bx-send:before {\r\n    content: \"\\ebfc\";\r\n  }\r\n  .bx-server:before {\r\n    content: \"\\ebfd\";\r\n  }\r\n  .bx-shape-circle:before {\r\n    content: \"\\ebfe\";\r\n  }\r\n  .bx-shape-polygon:before {\r\n    content: \"\\ebff\";\r\n  }\r\n  .bx-shape-square:before {\r\n    content: \"\\ec00\";\r\n  }\r\n  .bx-shape-triangle:before {\r\n    content: \"\\ec01\";\r\n  }\r\n  .bx-share:before {\r\n    content: \"\\ec02\";\r\n  }\r\n  .bx-share-alt:before {\r\n    content: \"\\ec03\";\r\n  }\r\n  .bx-shekel:before {\r\n    content: \"\\ec04\";\r\n  }\r\n  .bx-shield:before {\r\n    content: \"\\ec05\";\r\n  }\r\n  .bx-shield-alt:before {\r\n    content: \"\\ec06\";\r\n  }\r\n  .bx-shield-alt-2:before {\r\n    content: \"\\ec07\";\r\n  }\r\n  .bx-shield-quarter:before {\r\n    content: \"\\ec08\";\r\n  }\r\n  .bx-shield-x:before {\r\n    content: \"\\ec09\";\r\n  }\r\n  .bx-shocked:before {\r\n    content: \"\\ec0a\";\r\n  }\r\n  .bx-shopping-bag:before {\r\n    content: \"\\ec0b\";\r\n  }\r\n  .bx-show:before {\r\n    content: \"\\ec0c\";\r\n  }\r\n  .bx-show-alt:before {\r\n    content: \"\\ec0d\";\r\n  }\r\n  .bx-shuffle:before {\r\n    content: \"\\ec0e\";\r\n  }\r\n  .bx-sidebar:before {\r\n    content: \"\\ec0f\";\r\n  }\r\n  .bx-sitemap:before {\r\n    content: \"\\ec10\";\r\n  }\r\n  .bx-skip-next:before {\r\n    content: \"\\ec11\";\r\n  }\r\n  .bx-skip-next-circle:before {\r\n    content: \"\\ec12\";\r\n  }\r\n  .bx-skip-previous:before {\r\n    content: \"\\ec13\";\r\n  }\r\n  .bx-skip-previous-circle:before {\r\n    content: \"\\ec14\";\r\n  }\r\n  .bx-sleepy:before {\r\n    content: \"\\ec15\";\r\n  }\r\n  .bx-slider:before {\r\n    content: \"\\ec16\";\r\n  }\r\n  .bx-slider-alt:before {\r\n    content: \"\\ec17\";\r\n  }\r\n  .bx-slideshow:before {\r\n    content: \"\\ec18\";\r\n  }\r\n  .bx-smile:before {\r\n    content: \"\\ec19\";\r\n  }\r\n  .bx-sort:before {\r\n    content: \"\\ec1a\";\r\n  }\r\n  .bx-sort-alt-2:before {\r\n    content: \"\\ec1b\";\r\n  }\r\n  .bx-sort-a-z:before {\r\n    content: \"\\ec1c\";\r\n  }\r\n  .bx-sort-down:before {\r\n    content: \"\\ec1d\";\r\n  }\r\n  .bx-sort-up:before {\r\n    content: \"\\ec1e\";\r\n  }\r\n  .bx-sort-z-a:before {\r\n    content: \"\\ec1f\";\r\n  }\r\n  .bx-spa:before {\r\n    content: \"\\ec20\";\r\n  }\r\n  .bx-space-bar:before {\r\n    content: \"\\ec21\";\r\n  }\r\n  .bx-speaker:before {\r\n    content: \"\\ec22\";\r\n  }\r\n  .bx-spray-can:before {\r\n    content: \"\\ec23\";\r\n  }\r\n  .bx-spreadsheet:before {\r\n    content: \"\\ec24\";\r\n  }\r\n  .bx-square:before {\r\n    content: \"\\ec25\";\r\n  }\r\n  .bx-square-rounded:before {\r\n    content: \"\\ec26\";\r\n  }\r\n  .bx-star:before {\r\n    content: \"\\ec27\";\r\n  }\r\n  .bx-station:before {\r\n    content: \"\\ec28\";\r\n  }\r\n  .bx-stats:before {\r\n    content: \"\\ec29\";\r\n  }\r\n  .bx-sticker:before {\r\n    content: \"\\ec2a\";\r\n  }\r\n  .bx-stop:before {\r\n    content: \"\\ec2b\";\r\n  }\r\n  .bx-stop-circle:before {\r\n    content: \"\\ec2c\";\r\n  }\r\n  .bx-stopwatch:before {\r\n    content: \"\\ec2d\";\r\n  }\r\n  .bx-store:before {\r\n    content: \"\\ec2e\";\r\n  }\r\n  .bx-store-alt:before {\r\n    content: \"\\ec2f\";\r\n  }\r\n  .bx-street-view:before {\r\n    content: \"\\ec30\";\r\n  }\r\n  .bx-strikethrough:before {\r\n    content: \"\\ec31\";\r\n  }\r\n  .bx-subdirectory-left:before {\r\n    content: \"\\ec32\";\r\n  }\r\n  .bx-subdirectory-right:before {\r\n    content: \"\\ec33\";\r\n  }\r\n  .bx-sun:before {\r\n    content: \"\\ec34\";\r\n  }\r\n  .bx-support:before {\r\n    content: \"\\ec35\";\r\n  }\r\n  .bx-swim:before {\r\n    content: \"\\ec36\";\r\n  }\r\n  .bx-sync:before {\r\n    content: \"\\ec37\";\r\n  }\r\n  .bx-tab:before {\r\n    content: \"\\ec38\";\r\n  }\r\n  .bx-table:before {\r\n    content: \"\\ec39\";\r\n  }\r\n  .bx-tachometer:before {\r\n    content: \"\\ec3a\";\r\n  }\r\n  .bx-tag:before {\r\n    content: \"\\ec3b\";\r\n  }\r\n  .bx-tag-alt:before {\r\n    content: \"\\ec3c\";\r\n  }\r\n  .bx-target-lock:before {\r\n    content: \"\\ec3d\";\r\n  }\r\n  .bx-task:before {\r\n    content: \"\\ec3e\";\r\n  }\r\n  .bx-task-x:before {\r\n    content: \"\\ec3f\";\r\n  }\r\n  .bx-taxi:before {\r\n    content: \"\\ec40\";\r\n  }\r\n  .bx-tennis-ball:before {\r\n    content: \"\\ec41\";\r\n  }\r\n  .bx-terminal:before {\r\n    content: \"\\ec42\";\r\n  }\r\n  .bx-test-tube:before {\r\n    content: \"\\ec43\";\r\n  }\r\n  .bx-text:before {\r\n    content: \"\\ec44\";\r\n  }\r\n  .bx-time:before {\r\n    content: \"\\ec45\";\r\n  }\r\n  .bx-time-five:before {\r\n    content: \"\\ec46\";\r\n  }\r\n  .bx-timer:before {\r\n    content: \"\\ec47\";\r\n  }\r\n  .bx-tired:before {\r\n    content: \"\\ec48\";\r\n  }\r\n  .bx-toggle-left:before {\r\n    content: \"\\ec49\";\r\n  }\r\n  .bx-toggle-right:before {\r\n    content: \"\\ec4a\";\r\n  }\r\n  .bx-tone:before {\r\n    content: \"\\ec4b\";\r\n  }\r\n  .bx-traffic-cone:before {\r\n    content: \"\\ec4c\";\r\n  }\r\n  .bx-train:before {\r\n    content: \"\\ec4d\";\r\n  }\r\n  .bx-transfer:before {\r\n    content: \"\\ec4e\";\r\n  }\r\n  .bx-transfer-alt:before {\r\n    content: \"\\ec4f\";\r\n  }\r\n  .bx-trash:before {\r\n    content: \"\\ec50\";\r\n  }\r\n  .bx-trash-alt:before {\r\n    content: \"\\ec51\";\r\n  }\r\n  .bx-trending-down:before {\r\n    content: \"\\ec52\";\r\n  }\r\n  .bx-trending-up:before {\r\n    content: \"\\ec53\";\r\n  }\r\n  .bx-trim:before {\r\n    content: \"\\ec54\";\r\n  }\r\n  .bx-trip:before {\r\n    content: \"\\ec55\";\r\n  }\r\n  .bx-trophy:before {\r\n    content: \"\\ec56\";\r\n  }\r\n  .bx-tv:before {\r\n    content: \"\\ec57\";\r\n  }\r\n  .bx-underline:before {\r\n    content: \"\\ec58\";\r\n  }\r\n  .bx-undo:before {\r\n    content: \"\\ec59\";\r\n  }\r\n  .bx-unite:before {\r\n    content: \"\\ec5a\";\r\n  }\r\n  .bx-unlink:before {\r\n    content: \"\\ec5b\";\r\n  }\r\n  .bx-up-arrow:before {\r\n    content: \"\\ec5c\";\r\n  }\r\n  .bx-up-arrow-alt:before {\r\n    content: \"\\ec5d\";\r\n  }\r\n  .bx-up-arrow-circle:before {\r\n    content: \"\\ec5e\";\r\n  }\r\n  .bx-upload:before {\r\n    content: \"\\ec5f\";\r\n  }\r\n  .bx-upside-down:before {\r\n    content: \"\\ec60\";\r\n  }\r\n  .bx-upvote:before {\r\n    content: \"\\ec61\";\r\n  }\r\n  .bx-usb:before {\r\n    content: \"\\ec62\";\r\n  }\r\n  .bx-user:before {\r\n    content: \"\\ec63\";\r\n  }\r\n  .bx-user-check:before {\r\n    content: \"\\ec64\";\r\n  }\r\n  .bx-user-circle:before {\r\n    content: \"\\ec65\";\r\n  }\r\n  .bx-user-minus:before {\r\n    content: \"\\ec66\";\r\n  }\r\n  .bx-user-pin:before {\r\n    content: \"\\ec67\";\r\n  }\r\n  .bx-user-plus:before {\r\n    content: \"\\ec68\";\r\n  }\r\n  .bx-user-voice:before {\r\n    content: \"\\ec69\";\r\n  }\r\n  .bx-user-x:before {\r\n    content: \"\\ec6a\";\r\n  }\r\n  .bx-vector:before {\r\n    content: \"\\ec6b\";\r\n  }\r\n  .bx-vertical-center:before {\r\n    content: \"\\ec6c\";\r\n  }\r\n  .bx-vial:before {\r\n    content: \"\\ec6d\";\r\n  }\r\n  .bx-video:before {\r\n    content: \"\\ec6e\";\r\n  }\r\n  .bx-video-off:before {\r\n    content: \"\\ec6f\";\r\n  }\r\n  .bx-video-plus:before {\r\n    content: \"\\ec70\";\r\n  }\r\n  .bx-video-recording:before {\r\n    content: \"\\ec71\";\r\n  }\r\n  .bx-voicemail:before {\r\n    content: \"\\ec72\";\r\n  }\r\n  .bx-volume:before {\r\n    content: \"\\ec73\";\r\n  }\r\n  .bx-volume-full:before {\r\n    content: \"\\ec74\";\r\n  }\r\n  .bx-volume-low:before {\r\n    content: \"\\ec75\";\r\n  }\r\n  .bx-volume-mute:before {\r\n    content: \"\\ec76\";\r\n  }\r\n  .bx-walk:before {\r\n    content: \"\\ec77\";\r\n  }\r\n  .bx-wallet:before {\r\n    content: \"\\ec78\";\r\n  }\r\n  .bx-wallet-alt:before {\r\n    content: \"\\ec79\";\r\n  }\r\n  .bx-water:before {\r\n    content: \"\\ec7a\";\r\n  }\r\n  .bx-webcam:before {\r\n    content: \"\\ec7b\";\r\n  }\r\n  .bx-wifi:before {\r\n    content: \"\\ec7c\";\r\n  }\r\n  .bx-wifi-0:before {\r\n    content: \"\\ec7d\";\r\n  }\r\n  .bx-wifi-1:before {\r\n    content: \"\\ec7e\";\r\n  }\r\n  .bx-wifi-2:before {\r\n    content: \"\\ec7f\";\r\n  }\r\n  .bx-wifi-off:before {\r\n    content: \"\\ec80\";\r\n  }\r\n  .bx-wind:before {\r\n    content: \"\\ec81\";\r\n  }\r\n  .bx-window:before {\r\n    content: \"\\ec82\";\r\n  }\r\n  .bx-window-alt:before {\r\n    content: \"\\ec83\";\r\n  }\r\n  .bx-window-close:before {\r\n    content: \"\\ec84\";\r\n  }\r\n  .bx-window-open:before {\r\n    content: \"\\ec85\";\r\n  }\r\n  .bx-windows:before {\r\n    content: \"\\ec86\";\r\n  }\r\n  .bx-wine:before {\r\n    content: \"\\ec87\";\r\n  }\r\n  .bx-wink-smile:before {\r\n    content: \"\\ec88\";\r\n  }\r\n  .bx-wink-tongue:before {\r\n    content: \"\\ec89\";\r\n  }\r\n  .bx-won:before {\r\n    content: \"\\ec8a\";\r\n  }\r\n  .bx-world:before {\r\n    content: \"\\ec8b\";\r\n  }\r\n  .bx-wrench:before {\r\n    content: \"\\ec8c\";\r\n  }\r\n  .bx-x:before {\r\n    content: \"\\ec8d\";\r\n  }\r\n  .bx-x-circle:before {\r\n    content: \"\\ec8e\";\r\n  }\r\n  .bx-yen:before {\r\n    content: \"\\ec8f\";\r\n  }\r\n  .bx-zoom-in:before {\r\n    content: \"\\ec90\";\r\n  }\r\n  .bx-zoom-out:before {\r\n    content: \"\\ec91\";\r\n  }\r\n  .bxs-party:before {\r\n    content: \"\\ec92\";\r\n  }\r\n  .bxs-hot:before {\r\n    content: \"\\ec93\";\r\n  }\r\n  .bxs-droplet:before {\r\n    content: \"\\ec94\";\r\n  }\r\n  .bxs-cat:before {\r\n    content: \"\\ec95\";\r\n  }\r\n  .bxs-dog:before {\r\n    content: \"\\ec96\";\r\n  }\r\n  .bxs-injection:before {\r\n    content: \"\\ec97\";\r\n  }\r\n  .bxs-leaf:before {\r\n    content: \"\\ec98\";\r\n  }\r\n  .bxs-add-to-queue:before {\r\n    content: \"\\ec99\";\r\n  }\r\n  .bxs-adjust:before {\r\n    content: \"\\ec9a\";\r\n  }\r\n  .bxs-adjust-alt:before {\r\n    content: \"\\ec9b\";\r\n  }\r\n  .bxs-alarm:before {\r\n    content: \"\\ec9c\";\r\n  }\r\n  .bxs-alarm-add:before {\r\n    content: \"\\ec9d\";\r\n  }\r\n  .bxs-alarm-exclamation:before {\r\n    content: \"\\ec9e\";\r\n  }\r\n  .bxs-alarm-off:before {\r\n    content: \"\\ec9f\";\r\n  }\r\n  .bxs-alarm-snooze:before {\r\n    content: \"\\eca0\";\r\n  }\r\n  .bxs-album:before {\r\n    content: \"\\eca1\";\r\n  }\r\n  .bxs-ambulance:before {\r\n    content: \"\\eca2\";\r\n  }\r\n  .bxs-analyse:before {\r\n    content: \"\\eca3\";\r\n  }\r\n  .bxs-angry:before {\r\n    content: \"\\eca4\";\r\n  }\r\n  .bxs-arch:before {\r\n    content: \"\\eca5\";\r\n  }\r\n  .bxs-archive:before {\r\n    content: \"\\eca6\";\r\n  }\r\n  .bxs-archive-in:before {\r\n    content: \"\\eca7\";\r\n  }\r\n  .bxs-archive-out:before {\r\n    content: \"\\eca8\";\r\n  }\r\n  .bxs-area:before {\r\n    content: \"\\eca9\";\r\n  }\r\n  .bxs-arrow-from-bottom:before {\r\n    content: \"\\ecaa\";\r\n  }\r\n  .bxs-arrow-from-left:before {\r\n    content: \"\\ecab\";\r\n  }\r\n  .bxs-arrow-from-right:before {\r\n    content: \"\\ecac\";\r\n  }\r\n  .bxs-arrow-from-top:before {\r\n    content: \"\\ecad\";\r\n  }\r\n  .bxs-arrow-to-bottom:before {\r\n    content: \"\\ecae\";\r\n  }\r\n  .bxs-arrow-to-left:before {\r\n    content: \"\\ecaf\";\r\n  }\r\n  .bxs-arrow-to-right:before {\r\n    content: \"\\ecb0\";\r\n  }\r\n  .bxs-arrow-to-top:before {\r\n    content: \"\\ecb1\";\r\n  }\r\n  .bxs-award:before {\r\n    content: \"\\ecb2\";\r\n  }\r\n  .bxs-baby-carriage:before {\r\n    content: \"\\ecb3\";\r\n  }\r\n  .bxs-backpack:before {\r\n    content: \"\\ecb4\";\r\n  }\r\n  .bxs-badge:before {\r\n    content: \"\\ecb5\";\r\n  }\r\n  .bxs-badge-check:before {\r\n    content: \"\\ecb6\";\r\n  }\r\n  .bxs-badge-dollar:before {\r\n    content: \"\\ecb7\";\r\n  }\r\n  .bxs-ball:before {\r\n    content: \"\\ecb8\";\r\n  }\r\n  .bxs-band-aid:before {\r\n    content: \"\\ecb9\";\r\n  }\r\n  .bxs-bank:before {\r\n    content: \"\\ecba\";\r\n  }\r\n  .bxs-bar-chart-alt-2:before {\r\n    content: \"\\ecbb\";\r\n  }\r\n  .bxs-bar-chart-square:before {\r\n    content: \"\\ecbc\";\r\n  }\r\n  .bxs-barcode:before {\r\n    content: \"\\ecbd\";\r\n  }\r\n  .bxs-baseball:before {\r\n    content: \"\\ecbe\";\r\n  }\r\n  .bxs-basket:before {\r\n    content: \"\\ecbf\";\r\n  }\r\n  .bxs-basketball:before {\r\n    content: \"\\ecc0\";\r\n  }\r\n  .bxs-bath:before {\r\n    content: \"\\ecc1\";\r\n  }\r\n  .bxs-battery:before {\r\n    content: \"\\ecc2\";\r\n  }\r\n  .bxs-battery-charging:before {\r\n    content: \"\\ecc3\";\r\n  }\r\n  .bxs-battery-full:before {\r\n    content: \"\\ecc4\";\r\n  }\r\n  .bxs-battery-low:before {\r\n    content: \"\\ecc5\";\r\n  }\r\n  .bxs-bed:before {\r\n    content: \"\\ecc6\";\r\n  }\r\n  .bxs-been-here:before {\r\n    content: \"\\ecc7\";\r\n  }\r\n  .bxs-beer:before {\r\n    content: \"\\ecc8\";\r\n  }\r\n  .bxs-bell:before {\r\n    content: \"\\ecc9\";\r\n  }\r\n  .bxs-bell-minus:before {\r\n    content: \"\\ecca\";\r\n  }\r\n  .bxs-bell-off:before {\r\n    content: \"\\eccb\";\r\n  }\r\n  .bxs-bell-plus:before {\r\n    content: \"\\eccc\";\r\n  }\r\n  .bxs-bell-ring:before {\r\n    content: \"\\eccd\";\r\n  }\r\n  .bxs-bible:before {\r\n    content: \"\\ecce\";\r\n  }\r\n  .bxs-binoculars:before {\r\n    content: \"\\eccf\";\r\n  }\r\n  .bxs-blanket:before {\r\n    content: \"\\ecd0\";\r\n  }\r\n  .bxs-bolt:before {\r\n    content: \"\\ecd1\";\r\n  }\r\n  .bxs-bolt-circle:before {\r\n    content: \"\\ecd2\";\r\n  }\r\n  .bxs-bomb:before {\r\n    content: \"\\ecd3\";\r\n  }\r\n  .bxs-bone:before {\r\n    content: \"\\ecd4\";\r\n  }\r\n  .bxs-bong:before {\r\n    content: \"\\ecd5\";\r\n  }\r\n  .bxs-book:before {\r\n    content: \"\\ecd6\";\r\n  }\r\n  .bxs-book-add:before {\r\n    content: \"\\ecd7\";\r\n  }\r\n  .bxs-book-alt:before {\r\n    content: \"\\ecd8\";\r\n  }\r\n  .bxs-book-bookmark:before {\r\n    content: \"\\ecd9\";\r\n  }\r\n  .bxs-book-content:before {\r\n    content: \"\\ecda\";\r\n  }\r\n  .bxs-book-heart:before {\r\n    content: \"\\ecdb\";\r\n  }\r\n  .bxs-bookmark:before {\r\n    content: \"\\ecdc\";\r\n  }\r\n  .bxs-bookmark-alt:before {\r\n    content: \"\\ecdd\";\r\n  }\r\n  .bxs-bookmark-alt-minus:before {\r\n    content: \"\\ecde\";\r\n  }\r\n  .bxs-bookmark-alt-plus:before {\r\n    content: \"\\ecdf\";\r\n  }\r\n  .bxs-bookmark-heart:before {\r\n    content: \"\\ece0\";\r\n  }\r\n  .bxs-bookmark-minus:before {\r\n    content: \"\\ece1\";\r\n  }\r\n  .bxs-bookmark-plus:before {\r\n    content: \"\\ece2\";\r\n  }\r\n  .bxs-bookmarks:before {\r\n    content: \"\\ece3\";\r\n  }\r\n  .bxs-bookmark-star:before {\r\n    content: \"\\ece4\";\r\n  }\r\n  .bxs-book-open:before {\r\n    content: \"\\ece5\";\r\n  }\r\n  .bxs-book-reader:before {\r\n    content: \"\\ece6\";\r\n  }\r\n  .bxs-bot:before {\r\n    content: \"\\ece7\";\r\n  }\r\n  .bxs-bowling-ball:before {\r\n    content: \"\\ece8\";\r\n  }\r\n  .bxs-box:before {\r\n    content: \"\\ece9\";\r\n  }\r\n  .bxs-brain:before {\r\n    content: \"\\ecea\";\r\n  }\r\n  .bxs-briefcase:before {\r\n    content: \"\\eceb\";\r\n  }\r\n  .bxs-briefcase-alt:before {\r\n    content: \"\\ecec\";\r\n  }\r\n  .bxs-briefcase-alt-2:before {\r\n    content: \"\\eced\";\r\n  }\r\n  .bxs-brightness:before {\r\n    content: \"\\ecee\";\r\n  }\r\n  .bxs-brightness-half:before {\r\n    content: \"\\ecef\";\r\n  }\r\n  .bxs-brush:before {\r\n    content: \"\\ecf0\";\r\n  }\r\n  .bxs-brush-alt:before {\r\n    content: \"\\ecf1\";\r\n  }\r\n  .bxs-bug:before {\r\n    content: \"\\ecf2\";\r\n  }\r\n  .bxs-bug-alt:before {\r\n    content: \"\\ecf3\";\r\n  }\r\n  .bxs-building:before {\r\n    content: \"\\ecf4\";\r\n  }\r\n  .bxs-building-house:before {\r\n    content: \"\\ecf5\";\r\n  }\r\n  .bxs-buildings:before {\r\n    content: \"\\ecf6\";\r\n  }\r\n  .bxs-bulb:before {\r\n    content: \"\\ecf7\";\r\n  }\r\n  .bxs-bullseye:before {\r\n    content: \"\\ecf8\";\r\n  }\r\n  .bxs-buoy:before {\r\n    content: \"\\ecf9\";\r\n  }\r\n  .bxs-bus:before {\r\n    content: \"\\ecfa\";\r\n  }\r\n  .bxs-business:before {\r\n    content: \"\\ecfb\";\r\n  }\r\n  .bxs-bus-school:before {\r\n    content: \"\\ecfc\";\r\n  }\r\n  .bxs-cabinet:before {\r\n    content: \"\\ecfd\";\r\n  }\r\n  .bxs-cake:before {\r\n    content: \"\\ecfe\";\r\n  }\r\n  .bxs-calculator:before {\r\n    content: \"\\ecff\";\r\n  }\r\n  .bxs-calendar:before {\r\n    content: \"\\ed00\";\r\n  }\r\n  .bxs-calendar-alt:before {\r\n    content: \"\\ed01\";\r\n  }\r\n  .bxs-calendar-check:before {\r\n    content: \"\\ed02\";\r\n  }\r\n  .bxs-calendar-edit:before {\r\n    content: \"\\ed03\";\r\n  }\r\n  .bxs-calendar-event:before {\r\n    content: \"\\ed04\";\r\n  }\r\n  .bxs-calendar-exclamation:before {\r\n    content: \"\\ed05\";\r\n  }\r\n  .bxs-calendar-heart:before {\r\n    content: \"\\ed06\";\r\n  }\r\n  .bxs-calendar-minus:before {\r\n    content: \"\\ed07\";\r\n  }\r\n  .bxs-calendar-plus:before {\r\n    content: \"\\ed08\";\r\n  }\r\n  .bxs-calendar-star:before {\r\n    content: \"\\ed09\";\r\n  }\r\n  .bxs-calendar-week:before {\r\n    content: \"\\ed0a\";\r\n  }\r\n  .bxs-calendar-x:before {\r\n    content: \"\\ed0b\";\r\n  }\r\n  .bxs-camera:before {\r\n    content: \"\\ed0c\";\r\n  }\r\n  .bxs-camera-home:before {\r\n    content: \"\\ed0d\";\r\n  }\r\n  .bxs-camera-movie:before {\r\n    content: \"\\ed0e\";\r\n  }\r\n  .bxs-camera-off:before {\r\n    content: \"\\ed0f\";\r\n  }\r\n  .bxs-camera-plus:before {\r\n    content: \"\\ed10\";\r\n  }\r\n  .bxs-capsule:before {\r\n    content: \"\\ed11\";\r\n  }\r\n  .bxs-captions:before {\r\n    content: \"\\ed12\";\r\n  }\r\n  .bxs-car:before {\r\n    content: \"\\ed13\";\r\n  }\r\n  .bxs-car-battery:before {\r\n    content: \"\\ed14\";\r\n  }\r\n  .bxs-car-crash:before {\r\n    content: \"\\ed15\";\r\n  }\r\n  .bxs-card:before {\r\n    content: \"\\ed16\";\r\n  }\r\n  .bxs-caret-down-circle:before {\r\n    content: \"\\ed17\";\r\n  }\r\n  .bxs-caret-down-square:before {\r\n    content: \"\\ed18\";\r\n  }\r\n  .bxs-caret-left-circle:before {\r\n    content: \"\\ed19\";\r\n  }\r\n  .bxs-caret-left-square:before {\r\n    content: \"\\ed1a\";\r\n  }\r\n  .bxs-caret-right-circle:before {\r\n    content: \"\\ed1b\";\r\n  }\r\n  .bxs-caret-right-square:before {\r\n    content: \"\\ed1c\";\r\n  }\r\n  .bxs-caret-up-circle:before {\r\n    content: \"\\ed1d\";\r\n  }\r\n  .bxs-caret-up-square:before {\r\n    content: \"\\ed1e\";\r\n  }\r\n  .bxs-car-garage:before {\r\n    content: \"\\ed1f\";\r\n  }\r\n  .bxs-car-mechanic:before {\r\n    content: \"\\ed20\";\r\n  }\r\n  .bxs-carousel:before {\r\n    content: \"\\ed21\";\r\n  }\r\n  .bxs-cart:before {\r\n    content: \"\\ed22\";\r\n  }\r\n  .bxs-cart-add:before {\r\n    content: \"\\ed23\";\r\n  }\r\n  .bxs-cart-alt:before {\r\n    content: \"\\ed24\";\r\n  }\r\n  .bxs-cart-download:before {\r\n    content: \"\\ed25\";\r\n  }\r\n  .bxs-car-wash:before {\r\n    content: \"\\ed26\";\r\n  }\r\n  .bxs-category:before {\r\n    content: \"\\ed27\";\r\n  }\r\n  .bxs-category-alt:before {\r\n    content: \"\\ed28\";\r\n  }\r\n  .bxs-cctv:before {\r\n    content: \"\\ed29\";\r\n  }\r\n  .bxs-certification:before {\r\n    content: \"\\ed2a\";\r\n  }\r\n  .bxs-chalkboard:before {\r\n    content: \"\\ed2b\";\r\n  }\r\n  .bxs-chart:before {\r\n    content: \"\\ed2c\";\r\n  }\r\n  .bxs-chat:before {\r\n    content: \"\\ed2d\";\r\n  }\r\n  .bxs-checkbox:before {\r\n    content: \"\\ed2e\";\r\n  }\r\n  .bxs-checkbox-checked:before {\r\n    content: \"\\ed2f\";\r\n  }\r\n  .bxs-checkbox-minus:before {\r\n    content: \"\\ed30\";\r\n  }\r\n  .bxs-check-circle:before {\r\n    content: \"\\ed31\";\r\n  }\r\n  .bxs-check-shield:before {\r\n    content: \"\\ed32\";\r\n  }\r\n  .bxs-check-square:before {\r\n    content: \"\\ed33\";\r\n  }\r\n  .bxs-chess:before {\r\n    content: \"\\ed34\";\r\n  }\r\n  .bxs-chevron-down:before {\r\n    content: \"\\ed35\";\r\n  }\r\n  .bxs-chevron-down-circle:before {\r\n    content: \"\\ed36\";\r\n  }\r\n  .bxs-chevron-down-square:before {\r\n    content: \"\\ed37\";\r\n  }\r\n  .bxs-chevron-left:before {\r\n    content: \"\\ed38\";\r\n  }\r\n  .bxs-chevron-left-circle:before {\r\n    content: \"\\ed39\";\r\n  }\r\n  .bxs-chevron-left-square:before {\r\n    content: \"\\ed3a\";\r\n  }\r\n  .bxs-chevron-right:before {\r\n    content: \"\\ed3b\";\r\n  }\r\n  .bxs-chevron-right-circle:before {\r\n    content: \"\\ed3c\";\r\n  }\r\n  .bxs-chevron-right-square:before {\r\n    content: \"\\ed3d\";\r\n  }\r\n  .bxs-chevrons-down:before {\r\n    content: \"\\ed3e\";\r\n  }\r\n  .bxs-chevrons-left:before {\r\n    content: \"\\ed3f\";\r\n  }\r\n  .bxs-chevrons-right:before {\r\n    content: \"\\ed40\";\r\n  }\r\n  .bxs-chevrons-up:before {\r\n    content: \"\\ed41\";\r\n  }\r\n  .bxs-chevron-up:before {\r\n    content: \"\\ed42\";\r\n  }\r\n  .bxs-chevron-up-circle:before {\r\n    content: \"\\ed43\";\r\n  }\r\n  .bxs-chevron-up-square:before {\r\n    content: \"\\ed44\";\r\n  }\r\n  .bxs-chip:before {\r\n    content: \"\\ed45\";\r\n  }\r\n  .bxs-church:before {\r\n    content: \"\\ed46\";\r\n  }\r\n  .bxs-circle:before {\r\n    content: \"\\ed47\";\r\n  }\r\n  .bxs-city:before {\r\n    content: \"\\ed48\";\r\n  }\r\n  .bxs-clinic:before {\r\n    content: \"\\ed49\";\r\n  }\r\n  .bxs-cloud:before {\r\n    content: \"\\ed4a\";\r\n  }\r\n  .bxs-cloud-download:before {\r\n    content: \"\\ed4b\";\r\n  }\r\n  .bxs-cloud-lightning:before {\r\n    content: \"\\ed4c\";\r\n  }\r\n  .bxs-cloud-rain:before {\r\n    content: \"\\ed4d\";\r\n  }\r\n  .bxs-cloud-upload:before {\r\n    content: \"\\ed4e\";\r\n  }\r\n  .bxs-coffee:before {\r\n    content: \"\\ed4f\";\r\n  }\r\n  .bxs-coffee-alt:before {\r\n    content: \"\\ed50\";\r\n  }\r\n  .bxs-coffee-togo:before {\r\n    content: \"\\ed51\";\r\n  }\r\n  .bxs-cog:before {\r\n    content: \"\\ed52\";\r\n  }\r\n  .bxs-coin:before {\r\n    content: \"\\ed53\";\r\n  }\r\n  .bxs-coin-stack:before {\r\n    content: \"\\ed54\";\r\n  }\r\n  .bxs-collection:before {\r\n    content: \"\\ed55\";\r\n  }\r\n  .bxs-color-fill:before {\r\n    content: \"\\ed56\";\r\n  }\r\n  .bxs-comment:before {\r\n    content: \"\\ed57\";\r\n  }\r\n  .bxs-comment-add:before {\r\n    content: \"\\ed58\";\r\n  }\r\n  .bxs-comment-check:before {\r\n    content: \"\\ed59\";\r\n  }\r\n  .bxs-comment-detail:before {\r\n    content: \"\\ed5a\";\r\n  }\r\n  .bxs-comment-dots:before {\r\n    content: \"\\ed5b\";\r\n  }\r\n  .bxs-comment-edit:before {\r\n    content: \"\\ed5c\";\r\n  }\r\n  .bxs-comment-error:before {\r\n    content: \"\\ed5d\";\r\n  }\r\n  .bxs-comment-minus:before {\r\n    content: \"\\ed5e\";\r\n  }\r\n  .bxs-comment-x:before {\r\n    content: \"\\ed5f\";\r\n  }\r\n  .bxs-compass:before {\r\n    content: \"\\ed60\";\r\n  }\r\n  .bxs-component:before {\r\n    content: \"\\ed61\";\r\n  }\r\n  .bxs-confused:before {\r\n    content: \"\\ed62\";\r\n  }\r\n  .bxs-contact:before {\r\n    content: \"\\ed63\";\r\n  }\r\n  .bxs-conversation:before {\r\n    content: \"\\ed64\";\r\n  }\r\n  .bxs-cookie:before {\r\n    content: \"\\ed65\";\r\n  }\r\n  .bxs-cool:before {\r\n    content: \"\\ed66\";\r\n  }\r\n  .bxs-copy:before {\r\n    content: \"\\ed67\";\r\n  }\r\n  .bxs-copy-alt:before {\r\n    content: \"\\ed68\";\r\n  }\r\n  .bxs-copyright:before {\r\n    content: \"\\ed69\";\r\n  }\r\n  .bxs-coupon:before {\r\n    content: \"\\ed6a\";\r\n  }\r\n  .bxs-credit-card:before {\r\n    content: \"\\ed6b\";\r\n  }\r\n  .bxs-credit-card-alt:before {\r\n    content: \"\\ed6c\";\r\n  }\r\n  .bxs-credit-card-front:before {\r\n    content: \"\\ed6d\";\r\n  }\r\n  .bxs-crop:before {\r\n    content: \"\\ed6e\";\r\n  }\r\n  .bxs-crown:before {\r\n    content: \"\\ed6f\";\r\n  }\r\n  .bxs-cube:before {\r\n    content: \"\\ed70\";\r\n  }\r\n  .bxs-cube-alt:before {\r\n    content: \"\\ed71\";\r\n  }\r\n  .bxs-cuboid:before {\r\n    content: \"\\ed72\";\r\n  }\r\n  .bxs-customize:before {\r\n    content: \"\\ed73\";\r\n  }\r\n  .bxs-cylinder:before {\r\n    content: \"\\ed74\";\r\n  }\r\n  .bxs-dashboard:before {\r\n    content: \"\\ed75\";\r\n  }\r\n  .bxs-data:before {\r\n    content: \"\\ed76\";\r\n  }\r\n  .bxs-detail:before {\r\n    content: \"\\ed77\";\r\n  }\r\n  .bxs-devices:before {\r\n    content: \"\\ed78\";\r\n  }\r\n  .bxs-diamond:before {\r\n    content: \"\\ed79\";\r\n  }\r\n  .bxs-dice-1:before {\r\n    content: \"\\ed7a\";\r\n  }\r\n  .bxs-dice-2:before {\r\n    content: \"\\ed7b\";\r\n  }\r\n  .bxs-dice-3:before {\r\n    content: \"\\ed7c\";\r\n  }\r\n  .bxs-dice-4:before {\r\n    content: \"\\ed7d\";\r\n  }\r\n  .bxs-dice-5:before {\r\n    content: \"\\ed7e\";\r\n  }\r\n  .bxs-dice-6:before {\r\n    content: \"\\ed7f\";\r\n  }\r\n  .bxs-direction-left:before {\r\n    content: \"\\ed80\";\r\n  }\r\n  .bxs-direction-right:before {\r\n    content: \"\\ed81\";\r\n  }\r\n  .bxs-directions:before {\r\n    content: \"\\ed82\";\r\n  }\r\n  .bxs-disc:before {\r\n    content: \"\\ed83\";\r\n  }\r\n  .bxs-discount:before {\r\n    content: \"\\ed84\";\r\n  }\r\n  .bxs-dish:before {\r\n    content: \"\\ed85\";\r\n  }\r\n  .bxs-dislike:before {\r\n    content: \"\\ed86\";\r\n  }\r\n  .bxs-dizzy:before {\r\n    content: \"\\ed87\";\r\n  }\r\n  .bxs-dock-bottom:before {\r\n    content: \"\\ed88\";\r\n  }\r\n  .bxs-dock-left:before {\r\n    content: \"\\ed89\";\r\n  }\r\n  .bxs-dock-right:before {\r\n    content: \"\\ed8a\";\r\n  }\r\n  .bxs-dock-top:before {\r\n    content: \"\\ed8b\";\r\n  }\r\n  .bxs-dollar-circle:before {\r\n    content: \"\\ed8c\";\r\n  }\r\n  .bxs-donate-blood:before {\r\n    content: \"\\ed8d\";\r\n  }\r\n  .bxs-donate-heart:before {\r\n    content: \"\\ed8e\";\r\n  }\r\n  .bxs-door-open:before {\r\n    content: \"\\ed8f\";\r\n  }\r\n  .bxs-doughnut-chart:before {\r\n    content: \"\\ed90\";\r\n  }\r\n  .bxs-down-arrow:before {\r\n    content: \"\\ed91\";\r\n  }\r\n  .bxs-down-arrow-alt:before {\r\n    content: \"\\ed92\";\r\n  }\r\n  .bxs-down-arrow-circle:before {\r\n    content: \"\\ed93\";\r\n  }\r\n  .bxs-down-arrow-square:before {\r\n    content: \"\\ed94\";\r\n  }\r\n  .bxs-download:before {\r\n    content: \"\\ed95\";\r\n  }\r\n  .bxs-downvote:before {\r\n    content: \"\\ed96\";\r\n  }\r\n  .bxs-drink:before {\r\n    content: \"\\ed97\";\r\n  }\r\n  .bxs-droplet-half:before {\r\n    content: \"\\ed98\";\r\n  }\r\n  .bxs-dryer:before {\r\n    content: \"\\ed99\";\r\n  }\r\n  .bxs-duplicate:before {\r\n    content: \"\\ed9a\";\r\n  }\r\n  .bxs-edit:before {\r\n    content: \"\\ed9b\";\r\n  }\r\n  .bxs-edit-alt:before {\r\n    content: \"\\ed9c\";\r\n  }\r\n  .bxs-edit-location:before {\r\n    content: \"\\ed9d\";\r\n  }\r\n  .bxs-eject:before {\r\n    content: \"\\ed9e\";\r\n  }\r\n  .bxs-envelope:before {\r\n    content: \"\\ed9f\";\r\n  }\r\n  .bxs-envelope-open:before {\r\n    content: \"\\eda0\";\r\n  }\r\n  .bxs-eraser:before {\r\n    content: \"\\eda1\";\r\n  }\r\n  .bxs-error:before {\r\n    content: \"\\eda2\";\r\n  }\r\n  .bxs-error-alt:before {\r\n    content: \"\\eda3\";\r\n  }\r\n  .bxs-error-circle:before {\r\n    content: \"\\eda4\";\r\n  }\r\n  .bxs-ev-station:before {\r\n    content: \"\\eda5\";\r\n  }\r\n  .bxs-exit:before {\r\n    content: \"\\eda6\";\r\n  }\r\n  .bxs-extension:before {\r\n    content: \"\\eda7\";\r\n  }\r\n  .bxs-eyedropper:before {\r\n    content: \"\\eda8\";\r\n  }\r\n  .bxs-face:before {\r\n    content: \"\\eda9\";\r\n  }\r\n  .bxs-face-mask:before {\r\n    content: \"\\edaa\";\r\n  }\r\n  .bxs-factory:before {\r\n    content: \"\\edab\";\r\n  }\r\n  .bxs-fast-forward-circle:before {\r\n    content: \"\\edac\";\r\n  }\r\n  .bxs-file:before {\r\n    content: \"\\edad\";\r\n  }\r\n  .bxs-file-archive:before {\r\n    content: \"\\edae\";\r\n  }\r\n  .bxs-file-blank:before {\r\n    content: \"\\edaf\";\r\n  }\r\n  .bxs-file-css:before {\r\n    content: \"\\edb0\";\r\n  }\r\n  .bxs-file-doc:before {\r\n    content: \"\\edb1\";\r\n  }\r\n  .bxs-file-export:before {\r\n    content: \"\\edb2\";\r\n  }\r\n  .bxs-file-find:before {\r\n    content: \"\\edb3\";\r\n  }\r\n  .bxs-file-gif:before {\r\n    content: \"\\edb4\";\r\n  }\r\n  .bxs-file-html:before {\r\n    content: \"\\edb5\";\r\n  }\r\n  .bxs-file-image:before {\r\n    content: \"\\edb6\";\r\n  }\r\n  .bxs-file-import:before {\r\n    content: \"\\edb7\";\r\n  }\r\n  .bxs-file-jpg:before {\r\n    content: \"\\edb8\";\r\n  }\r\n  .bxs-file-js:before {\r\n    content: \"\\edb9\";\r\n  }\r\n  .bxs-file-json:before {\r\n    content: \"\\edba\";\r\n  }\r\n  .bxs-file-md:before {\r\n    content: \"\\edbb\";\r\n  }\r\n  .bxs-file-pdf:before {\r\n    content: \"\\edbc\";\r\n  }\r\n  .bxs-file-plus:before {\r\n    content: \"\\edbd\";\r\n  }\r\n  .bxs-file-png:before {\r\n    content: \"\\edbe\";\r\n  }\r\n  .bxs-file-txt:before {\r\n    content: \"\\edbf\";\r\n  }\r\n  .bxs-film:before {\r\n    content: \"\\edc0\";\r\n  }\r\n  .bxs-filter-alt:before {\r\n    content: \"\\edc1\";\r\n  }\r\n  .bxs-first-aid:before {\r\n    content: \"\\edc2\";\r\n  }\r\n  .bxs-flag:before {\r\n    content: \"\\edc3\";\r\n  }\r\n  .bxs-flag-alt:before {\r\n    content: \"\\edc4\";\r\n  }\r\n  .bxs-flag-checkered:before {\r\n    content: \"\\edc5\";\r\n  }\r\n  .bxs-flame:before {\r\n    content: \"\\edc6\";\r\n  }\r\n  .bxs-flask:before {\r\n    content: \"\\edc7\";\r\n  }\r\n  .bxs-florist:before {\r\n    content: \"\\edc8\";\r\n  }\r\n  .bxs-folder:before {\r\n    content: \"\\edc9\";\r\n  }\r\n  .bxs-folder-minus:before {\r\n    content: \"\\edca\";\r\n  }\r\n  .bxs-folder-open:before {\r\n    content: \"\\edcb\";\r\n  }\r\n  .bxs-folder-plus:before {\r\n    content: \"\\edcc\";\r\n  }\r\n  .bxs-food-menu:before {\r\n    content: \"\\edcd\";\r\n  }\r\n  .bxs-fridge:before {\r\n    content: \"\\edce\";\r\n  }\r\n  .bxs-game:before {\r\n    content: \"\\edcf\";\r\n  }\r\n  .bxs-gas-pump:before {\r\n    content: \"\\edd0\";\r\n  }\r\n  .bxs-ghost:before {\r\n    content: \"\\edd1\";\r\n  }\r\n  .bxs-gift:before {\r\n    content: \"\\edd2\";\r\n  }\r\n  .bxs-graduation:before {\r\n    content: \"\\edd3\";\r\n  }\r\n  .bxs-grid:before {\r\n    content: \"\\edd4\";\r\n  }\r\n  .bxs-grid-alt:before {\r\n    content: \"\\edd5\";\r\n  }\r\n  .bxs-group:before {\r\n    content: \"\\edd6\";\r\n  }\r\n  .bxs-guitar-amp:before {\r\n    content: \"\\edd7\";\r\n  }\r\n  .bxs-hand:before {\r\n    content: \"\\edd8\";\r\n  }\r\n  .bxs-hand-down:before {\r\n    content: \"\\edd9\";\r\n  }\r\n  .bxs-hand-left:before {\r\n    content: \"\\edda\";\r\n  }\r\n  .bxs-hand-right:before {\r\n    content: \"\\eddb\";\r\n  }\r\n  .bxs-hand-up:before {\r\n    content: \"\\eddc\";\r\n  }\r\n  .bxs-happy:before {\r\n    content: \"\\eddd\";\r\n  }\r\n  .bxs-happy-alt:before {\r\n    content: \"\\edde\";\r\n  }\r\n  .bxs-happy-beaming:before {\r\n    content: \"\\eddf\";\r\n  }\r\n  .bxs-happy-heart-eyes:before {\r\n    content: \"\\ede0\";\r\n  }\r\n  .bxs-hdd:before {\r\n    content: \"\\ede1\";\r\n  }\r\n  .bxs-heart:before {\r\n    content: \"\\ede2\";\r\n  }\r\n  .bxs-heart-circle:before {\r\n    content: \"\\ede3\";\r\n  }\r\n  .bxs-heart-square:before {\r\n    content: \"\\ede4\";\r\n  }\r\n  .bxs-help-circle:before {\r\n    content: \"\\ede5\";\r\n  }\r\n  .bxs-hide:before {\r\n    content: \"\\ede6\";\r\n  }\r\n  .bxs-home:before {\r\n    content: \"\\ede7\";\r\n  }\r\n  .bxs-home-circle:before {\r\n    content: \"\\ede8\";\r\n  }\r\n  .bxs-home-heart:before {\r\n    content: \"\\ede9\";\r\n  }\r\n  .bxs-home-smile:before {\r\n    content: \"\\edea\";\r\n  }\r\n  .bxs-hotel:before {\r\n    content: \"\\edeb\";\r\n  }\r\n  .bxs-hourglass:before {\r\n    content: \"\\edec\";\r\n  }\r\n  .bxs-hourglass-bottom:before {\r\n    content: \"\\eded\";\r\n  }\r\n  .bxs-hourglass-top:before {\r\n    content: \"\\edee\";\r\n  }\r\n  .bxs-id-card:before {\r\n    content: \"\\edef\";\r\n  }\r\n  .bxs-image:before {\r\n    content: \"\\edf0\";\r\n  }\r\n  .bxs-image-add:before {\r\n    content: \"\\edf1\";\r\n  }\r\n  .bxs-image-alt:before {\r\n    content: \"\\edf2\";\r\n  }\r\n  .bxs-inbox:before {\r\n    content: \"\\edf3\";\r\n  }\r\n  .bxs-info-circle:before {\r\n    content: \"\\edf4\";\r\n  }\r\n  .bxs-info-square:before {\r\n    content: \"\\edf5\";\r\n  }\r\n  .bxs-institution:before {\r\n    content: \"\\edf6\";\r\n  }\r\n  .bxs-joystick:before {\r\n    content: \"\\edf7\";\r\n  }\r\n  .bxs-joystick-alt:before {\r\n    content: \"\\edf8\";\r\n  }\r\n  .bxs-joystick-button:before {\r\n    content: \"\\edf9\";\r\n  }\r\n  .bxs-key:before {\r\n    content: \"\\edfa\";\r\n  }\r\n  .bxs-keyboard:before {\r\n    content: \"\\edfb\";\r\n  }\r\n  .bxs-label:before {\r\n    content: \"\\edfc\";\r\n  }\r\n  .bxs-landmark:before {\r\n    content: \"\\edfd\";\r\n  }\r\n  .bxs-landscape:before {\r\n    content: \"\\edfe\";\r\n  }\r\n  .bxs-laugh:before {\r\n    content: \"\\edff\";\r\n  }\r\n  .bxs-layer:before {\r\n    content: \"\\ee00\";\r\n  }\r\n  .bxs-layer-minus:before {\r\n    content: \"\\ee01\";\r\n  }\r\n  .bxs-layer-plus:before {\r\n    content: \"\\ee02\";\r\n  }\r\n  .bxs-layout:before {\r\n    content: \"\\ee03\";\r\n  }\r\n  .bxs-left-arrow:before {\r\n    content: \"\\ee04\";\r\n  }\r\n  .bxs-left-arrow-alt:before {\r\n    content: \"\\ee05\";\r\n  }\r\n  .bxs-left-arrow-circle:before {\r\n    content: \"\\ee06\";\r\n  }\r\n  .bxs-left-arrow-square:before {\r\n    content: \"\\ee07\";\r\n  }\r\n  .bxs-left-down-arrow-circle:before {\r\n    content: \"\\ee08\";\r\n  }\r\n  .bxs-left-top-arrow-circle:before {\r\n    content: \"\\ee09\";\r\n  }\r\n  .bxs-like:before {\r\n    content: \"\\ee0a\";\r\n  }\r\n  .bxs-location-plus:before {\r\n    content: \"\\ee0b\";\r\n  }\r\n  .bxs-lock:before {\r\n    content: \"\\ee0c\";\r\n  }\r\n  .bxs-lock-alt:before {\r\n    content: \"\\ee0d\";\r\n  }\r\n  .bxs-lock-open:before {\r\n    content: \"\\ee0e\";\r\n  }\r\n  .bxs-lock-open-alt:before {\r\n    content: \"\\ee0f\";\r\n  }\r\n  .bxs-log-in:before {\r\n    content: \"\\ee10\";\r\n  }\r\n  .bxs-log-in-circle:before {\r\n    content: \"\\ee11\";\r\n  }\r\n  .bxs-log-out:before {\r\n    content: \"\\ee12\";\r\n  }\r\n  .bxs-log-out-circle:before {\r\n    content: \"\\ee13\";\r\n  }\r\n  .bxs-low-vision:before {\r\n    content: \"\\ee14\";\r\n  }\r\n  .bxs-magic-wand:before {\r\n    content: \"\\ee15\";\r\n  }\r\n  .bxs-magnet:before {\r\n    content: \"\\ee16\";\r\n  }\r\n  .bxs-map:before {\r\n    content: \"\\ee17\";\r\n  }\r\n  .bxs-map-alt:before {\r\n    content: \"\\ee18\";\r\n  }\r\n  .bxs-map-pin:before {\r\n    content: \"\\ee19\";\r\n  }\r\n  .bxs-mask:before {\r\n    content: \"\\ee1a\";\r\n  }\r\n  .bxs-medal:before {\r\n    content: \"\\ee1b\";\r\n  }\r\n  .bxs-megaphone:before {\r\n    content: \"\\ee1c\";\r\n  }\r\n  .bxs-meh:before {\r\n    content: \"\\ee1d\";\r\n  }\r\n  .bxs-meh-alt:before {\r\n    content: \"\\ee1e\";\r\n  }\r\n  .bxs-meh-blank:before {\r\n    content: \"\\ee1f\";\r\n  }\r\n  .bxs-memory-card:before {\r\n    content: \"\\ee20\";\r\n  }\r\n  .bxs-message:before {\r\n    content: \"\\ee21\";\r\n  }\r\n  .bxs-message-add:before {\r\n    content: \"\\ee22\";\r\n  }\r\n  .bxs-message-alt:before {\r\n    content: \"\\ee23\";\r\n  }\r\n  .bxs-message-alt-add:before {\r\n    content: \"\\ee24\";\r\n  }\r\n  .bxs-message-alt-check:before {\r\n    content: \"\\ee25\";\r\n  }\r\n  .bxs-message-alt-detail:before {\r\n    content: \"\\ee26\";\r\n  }\r\n  .bxs-message-alt-dots:before {\r\n    content: \"\\ee27\";\r\n  }\r\n  .bxs-message-alt-edit:before {\r\n    content: \"\\ee28\";\r\n  }\r\n  .bxs-message-alt-error:before {\r\n    content: \"\\ee29\";\r\n  }\r\n  .bxs-message-alt-minus:before {\r\n    content: \"\\ee2a\";\r\n  }\r\n  .bxs-message-alt-x:before {\r\n    content: \"\\ee2b\";\r\n  }\r\n  .bxs-message-check:before {\r\n    content: \"\\ee2c\";\r\n  }\r\n  .bxs-message-detail:before {\r\n    content: \"\\ee2d\";\r\n  }\r\n  .bxs-message-dots:before {\r\n    content: \"\\ee2e\";\r\n  }\r\n  .bxs-message-edit:before {\r\n    content: \"\\ee2f\";\r\n  }\r\n  .bxs-message-error:before {\r\n    content: \"\\ee30\";\r\n  }\r\n  .bxs-message-minus:before {\r\n    content: \"\\ee31\";\r\n  }\r\n  .bxs-message-rounded:before {\r\n    content: \"\\ee32\";\r\n  }\r\n  .bxs-message-rounded-add:before {\r\n    content: \"\\ee33\";\r\n  }\r\n  .bxs-message-rounded-check:before {\r\n    content: \"\\ee34\";\r\n  }\r\n  .bxs-message-rounded-detail:before {\r\n    content: \"\\ee35\";\r\n  }\r\n  .bxs-message-rounded-dots:before {\r\n    content: \"\\ee36\";\r\n  }\r\n  .bxs-message-rounded-edit:before {\r\n    content: \"\\ee37\";\r\n  }\r\n  .bxs-message-rounded-error:before {\r\n    content: \"\\ee38\";\r\n  }\r\n  .bxs-message-rounded-minus:before {\r\n    content: \"\\ee39\";\r\n  }\r\n  .bxs-message-rounded-x:before {\r\n    content: \"\\ee3a\";\r\n  }\r\n  .bxs-message-square:before {\r\n    content: \"\\ee3b\";\r\n  }\r\n  .bxs-message-square-add:before {\r\n    content: \"\\ee3c\";\r\n  }\r\n  .bxs-message-square-check:before {\r\n    content: \"\\ee3d\";\r\n  }\r\n  .bxs-message-square-detail:before {\r\n    content: \"\\ee3e\";\r\n  }\r\n  .bxs-message-square-dots:before {\r\n    content: \"\\ee3f\";\r\n  }\r\n  .bxs-message-square-edit:before {\r\n    content: \"\\ee40\";\r\n  }\r\n  .bxs-message-square-error:before {\r\n    content: \"\\ee41\";\r\n  }\r\n  .bxs-message-square-minus:before {\r\n    content: \"\\ee42\";\r\n  }\r\n  .bxs-message-square-x:before {\r\n    content: \"\\ee43\";\r\n  }\r\n  .bxs-message-x:before {\r\n    content: \"\\ee44\";\r\n  }\r\n  .bxs-meteor:before {\r\n    content: \"\\ee45\";\r\n  }\r\n  .bxs-microchip:before {\r\n    content: \"\\ee46\";\r\n  }\r\n  .bxs-microphone:before {\r\n    content: \"\\ee47\";\r\n  }\r\n  .bxs-microphone-alt:before {\r\n    content: \"\\ee48\";\r\n  }\r\n  .bxs-microphone-off:before {\r\n    content: \"\\ee49\";\r\n  }\r\n  .bxs-minus-circle:before {\r\n    content: \"\\ee4a\";\r\n  }\r\n  .bxs-minus-square:before {\r\n    content: \"\\ee4b\";\r\n  }\r\n  .bxs-mobile:before {\r\n    content: \"\\ee4c\";\r\n  }\r\n  .bxs-mobile-vibration:before {\r\n    content: \"\\ee4d\";\r\n  }\r\n  .bxs-moon:before {\r\n    content: \"\\ee4e\";\r\n  }\r\n  .bxs-mouse:before {\r\n    content: \"\\ee4f\";\r\n  }\r\n  .bxs-mouse-alt:before {\r\n    content: \"\\ee50\";\r\n  }\r\n  .bxs-movie:before {\r\n    content: \"\\ee51\";\r\n  }\r\n  .bxs-movie-play:before {\r\n    content: \"\\ee52\";\r\n  }\r\n  .bxs-music:before {\r\n    content: \"\\ee53\";\r\n  }\r\n  .bxs-navigation:before {\r\n    content: \"\\ee54\";\r\n  }\r\n  .bxs-network-chart:before {\r\n    content: \"\\ee55\";\r\n  }\r\n  .bxs-news:before {\r\n    content: \"\\ee56\";\r\n  }\r\n  .bxs-no-entry:before {\r\n    content: \"\\ee57\";\r\n  }\r\n  .bxs-note:before {\r\n    content: \"\\ee58\";\r\n  }\r\n  .bxs-notepad:before {\r\n    content: \"\\ee59\";\r\n  }\r\n  .bxs-notification:before {\r\n    content: \"\\ee5a\";\r\n  }\r\n  .bxs-notification-off:before {\r\n    content: \"\\ee5b\";\r\n  }\r\n  .bxs-offer:before {\r\n    content: \"\\ee5c\";\r\n  }\r\n  .bxs-package:before {\r\n    content: \"\\ee5d\";\r\n  }\r\n  .bxs-paint:before {\r\n    content: \"\\ee5e\";\r\n  }\r\n  .bxs-paint-roll:before {\r\n    content: \"\\ee5f\";\r\n  }\r\n  .bxs-palette:before {\r\n    content: \"\\ee60\";\r\n  }\r\n  .bxs-paper-plane:before {\r\n    content: \"\\ee61\";\r\n  }\r\n  .bxs-parking:before {\r\n    content: \"\\ee62\";\r\n  }\r\n  .bxs-paste:before {\r\n    content: \"\\ee63\";\r\n  }\r\n  .bxs-pen:before {\r\n    content: \"\\ee64\";\r\n  }\r\n  .bxs-pencil:before {\r\n    content: \"\\ee65\";\r\n  }\r\n  .bxs-phone:before {\r\n    content: \"\\ee66\";\r\n  }\r\n  .bxs-phone-call:before {\r\n    content: \"\\ee67\";\r\n  }\r\n  .bxs-phone-incoming:before {\r\n    content: \"\\ee68\";\r\n  }\r\n  .bxs-phone-off:before {\r\n    content: \"\\ee69\";\r\n  }\r\n  .bxs-phone-outgoing:before {\r\n    content: \"\\ee6a\";\r\n  }\r\n  .bxs-photo-album:before {\r\n    content: \"\\ee6b\";\r\n  }\r\n  .bxs-piano:before {\r\n    content: \"\\ee6c\";\r\n  }\r\n  .bxs-pie-chart:before {\r\n    content: \"\\ee6d\";\r\n  }\r\n  .bxs-pie-chart-alt:before {\r\n    content: \"\\ee6e\";\r\n  }\r\n  .bxs-pie-chart-alt-2:before {\r\n    content: \"\\ee6f\";\r\n  }\r\n  .bxs-pin:before {\r\n    content: \"\\ee70\";\r\n  }\r\n  .bxs-pizza:before {\r\n    content: \"\\ee71\";\r\n  }\r\n  .bxs-plane:before {\r\n    content: \"\\ee72\";\r\n  }\r\n  .bxs-plane-alt:before {\r\n    content: \"\\ee73\";\r\n  }\r\n  .bxs-plane-land:before {\r\n    content: \"\\ee74\";\r\n  }\r\n  .bxs-planet:before {\r\n    content: \"\\ee75\";\r\n  }\r\n  .bxs-plane-take-off:before {\r\n    content: \"\\ee76\";\r\n  }\r\n  .bxs-playlist:before {\r\n    content: \"\\ee77\";\r\n  }\r\n  .bxs-plug:before {\r\n    content: \"\\ee78\";\r\n  }\r\n  .bxs-plus-circle:before {\r\n    content: \"\\ee79\";\r\n  }\r\n  .bxs-plus-square:before {\r\n    content: \"\\ee7a\";\r\n  }\r\n  .bxs-pointer:before {\r\n    content: \"\\ee7b\";\r\n  }\r\n  .bxs-polygon:before {\r\n    content: \"\\ee7c\";\r\n  }\r\n  .bxs-printer:before {\r\n    content: \"\\ee7d\";\r\n  }\r\n  .bxs-purchase-tag:before {\r\n    content: \"\\ee7e\";\r\n  }\r\n  .bxs-purchase-tag-alt:before {\r\n    content: \"\\ee7f\";\r\n  }\r\n  .bxs-pyramid:before {\r\n    content: \"\\ee80\";\r\n  }\r\n  .bxs-quote-alt-left:before {\r\n    content: \"\\ee81\";\r\n  }\r\n  .bxs-quote-alt-right:before {\r\n    content: \"\\ee82\";\r\n  }\r\n  .bxs-quote-left:before {\r\n    content: \"\\ee83\";\r\n  }\r\n  .bxs-quote-right:before {\r\n    content: \"\\ee84\";\r\n  }\r\n  .bxs-quote-single-left:before {\r\n    content: \"\\ee85\";\r\n  }\r\n  .bxs-quote-single-right:before {\r\n    content: \"\\ee86\";\r\n  }\r\n  .bxs-radiation:before {\r\n    content: \"\\ee87\";\r\n  }\r\n  .bxs-radio:before {\r\n    content: \"\\ee88\";\r\n  }\r\n  .bxs-receipt:before {\r\n    content: \"\\ee89\";\r\n  }\r\n  .bxs-rectangle:before {\r\n    content: \"\\ee8a\";\r\n  }\r\n  .bxs-registered:before {\r\n    content: \"\\ee8b\";\r\n  }\r\n  .bxs-rename:before {\r\n    content: \"\\ee8c\";\r\n  }\r\n  .bxs-report:before {\r\n    content: \"\\ee8d\";\r\n  }\r\n  .bxs-rewind-circle:before {\r\n    content: \"\\ee8e\";\r\n  }\r\n  .bxs-right-arrow:before {\r\n    content: \"\\ee8f\";\r\n  }\r\n  .bxs-right-arrow-alt:before {\r\n    content: \"\\ee90\";\r\n  }\r\n  .bxs-right-arrow-circle:before {\r\n    content: \"\\ee91\";\r\n  }\r\n  .bxs-right-arrow-square:before {\r\n    content: \"\\ee92\";\r\n  }\r\n  .bxs-right-down-arrow-circle:before {\r\n    content: \"\\ee93\";\r\n  }\r\n  .bxs-right-top-arrow-circle:before {\r\n    content: \"\\ee94\";\r\n  }\r\n  .bxs-rocket:before {\r\n    content: \"\\ee95\";\r\n  }\r\n  .bxs-ruler:before {\r\n    content: \"\\ee96\";\r\n  }\r\n  .bxs-sad:before {\r\n    content: \"\\ee97\";\r\n  }\r\n  .bxs-save:before {\r\n    content: \"\\ee98\";\r\n  }\r\n  .bxs-school:before {\r\n    content: \"\\ee99\";\r\n  }\r\n  .bxs-search:before {\r\n    content: \"\\ee9a\";\r\n  }\r\n  .bxs-search-alt-2:before {\r\n    content: \"\\ee9b\";\r\n  }\r\n  .bxs-select-multiple:before {\r\n    content: \"\\ee9c\";\r\n  }\r\n  .bxs-send:before {\r\n    content: \"\\ee9d\";\r\n  }\r\n  .bxs-server:before {\r\n    content: \"\\ee9e\";\r\n  }\r\n  .bxs-shapes:before {\r\n    content: \"\\ee9f\";\r\n  }\r\n  .bxs-share:before {\r\n    content: \"\\eea0\";\r\n  }\r\n  .bxs-share-alt:before {\r\n    content: \"\\eea1\";\r\n  }\r\n  .bxs-shield:before {\r\n    content: \"\\eea2\";\r\n  }\r\n  .bxs-shield-alt-2:before {\r\n    content: \"\\eea3\";\r\n  }\r\n  .bxs-shield-x:before {\r\n    content: \"\\eea4\";\r\n  }\r\n  .bxs-ship:before {\r\n    content: \"\\eea5\";\r\n  }\r\n  .bxs-shocked:before {\r\n    content: \"\\eea6\";\r\n  }\r\n  .bxs-shopping-bag:before {\r\n    content: \"\\eea7\";\r\n  }\r\n  .bxs-shopping-bag-alt:before {\r\n    content: \"\\eea8\";\r\n  }\r\n  .bxs-shopping-bags:before {\r\n    content: \"\\eea9\";\r\n  }\r\n  .bxs-show:before {\r\n    content: \"\\eeaa\";\r\n  }\r\n  .bxs-skip-next-circle:before {\r\n    content: \"\\eeab\";\r\n  }\r\n  .bxs-skip-previous-circle:before {\r\n    content: \"\\eeac\";\r\n  }\r\n  .bxs-skull:before {\r\n    content: \"\\eead\";\r\n  }\r\n  .bxs-sleepy:before {\r\n    content: \"\\eeae\";\r\n  }\r\n  .bxs-slideshow:before {\r\n    content: \"\\eeaf\";\r\n  }\r\n  .bxs-smile:before {\r\n    content: \"\\eeb0\";\r\n  }\r\n  .bxs-sort-alt:before {\r\n    content: \"\\eeb1\";\r\n  }\r\n  .bxs-spa:before {\r\n    content: \"\\eeb2\";\r\n  }\r\n  .bxs-speaker:before {\r\n    content: \"\\eeb3\";\r\n  }\r\n  .bxs-spray-can:before {\r\n    content: \"\\eeb4\";\r\n  }\r\n  .bxs-spreadsheet:before {\r\n    content: \"\\eeb5\";\r\n  }\r\n  .bxs-square:before {\r\n    content: \"\\eeb6\";\r\n  }\r\n  .bxs-square-rounded:before {\r\n    content: \"\\eeb7\";\r\n  }\r\n  .bxs-star:before {\r\n    content: \"\\eeb8\";\r\n  }\r\n  .bxs-star-half:before {\r\n    content: \"\\eeb9\";\r\n  }\r\n  .bxs-sticker:before {\r\n    content: \"\\eeba\";\r\n  }\r\n  .bxs-stopwatch:before {\r\n    content: \"\\eebb\";\r\n  }\r\n  .bxs-store:before {\r\n    content: \"\\eebc\";\r\n  }\r\n  .bxs-store-alt:before {\r\n    content: \"\\eebd\";\r\n  }\r\n  .bxs-sun:before {\r\n    content: \"\\eebe\";\r\n  }\r\n  .bxs-tachometer:before {\r\n    content: \"\\eebf\";\r\n  }\r\n  .bxs-tag:before {\r\n    content: \"\\eec0\";\r\n  }\r\n  .bxs-tag-alt:before {\r\n    content: \"\\eec1\";\r\n  }\r\n  .bxs-tag-x:before {\r\n    content: \"\\eec2\";\r\n  }\r\n  .bxs-taxi:before {\r\n    content: \"\\eec3\";\r\n  }\r\n  .bxs-tennis-ball:before {\r\n    content: \"\\eec4\";\r\n  }\r\n  .bxs-terminal:before {\r\n    content: \"\\eec5\";\r\n  }\r\n  .bxs-thermometer:before {\r\n    content: \"\\eec6\";\r\n  }\r\n  .bxs-time:before {\r\n    content: \"\\eec7\";\r\n  }\r\n  .bxs-time-five:before {\r\n    content: \"\\eec8\";\r\n  }\r\n  .bxs-timer:before {\r\n    content: \"\\eec9\";\r\n  }\r\n  .bxs-tired:before {\r\n    content: \"\\eeca\";\r\n  }\r\n  .bxs-toggle-left:before {\r\n    content: \"\\eecb\";\r\n  }\r\n  .bxs-toggle-right:before {\r\n    content: \"\\eecc\";\r\n  }\r\n  .bxs-tone:before {\r\n    content: \"\\eecd\";\r\n  }\r\n  .bxs-torch:before {\r\n    content: \"\\eece\";\r\n  }\r\n  .bxs-to-top:before {\r\n    content: \"\\eecf\";\r\n  }\r\n  .bxs-traffic:before {\r\n    content: \"\\eed0\";\r\n  }\r\n  .bxs-traffic-barrier:before {\r\n    content: \"\\eed1\";\r\n  }\r\n  .bxs-traffic-cone:before {\r\n    content: \"\\eed2\";\r\n  }\r\n  .bxs-train:before {\r\n    content: \"\\eed3\";\r\n  }\r\n  .bxs-trash:before {\r\n    content: \"\\eed4\";\r\n  }\r\n  .bxs-trash-alt:before {\r\n    content: \"\\eed5\";\r\n  }\r\n  .bxs-tree:before {\r\n    content: \"\\eed6\";\r\n  }\r\n  .bxs-trophy:before {\r\n    content: \"\\eed7\";\r\n  }\r\n  .bxs-truck:before {\r\n    content: \"\\eed8\";\r\n  }\r\n  .bxs-t-shirt:before {\r\n    content: \"\\eed9\";\r\n  }\r\n  .bxs-tv:before {\r\n    content: \"\\eeda\";\r\n  }\r\n  .bxs-up-arrow:before {\r\n    content: \"\\eedb\";\r\n  }\r\n  .bxs-up-arrow-alt:before {\r\n    content: \"\\eedc\";\r\n  }\r\n  .bxs-up-arrow-circle:before {\r\n    content: \"\\eedd\";\r\n  }\r\n  .bxs-up-arrow-square:before {\r\n    content: \"\\eede\";\r\n  }\r\n  .bxs-upside-down:before {\r\n    content: \"\\eedf\";\r\n  }\r\n  .bxs-upvote:before {\r\n    content: \"\\eee0\";\r\n  }\r\n  .bxs-user:before {\r\n    content: \"\\eee1\";\r\n  }\r\n  .bxs-user-account:before {\r\n    content: \"\\eee2\";\r\n  }\r\n  .bxs-user-badge:before {\r\n    content: \"\\eee3\";\r\n  }\r\n  .bxs-user-check:before {\r\n    content: \"\\eee4\";\r\n  }\r\n  .bxs-user-circle:before {\r\n    content: \"\\eee5\";\r\n  }\r\n  .bxs-user-detail:before {\r\n    content: \"\\eee6\";\r\n  }\r\n  .bxs-user-minus:before {\r\n    content: \"\\eee7\";\r\n  }\r\n  .bxs-user-pin:before {\r\n    content: \"\\eee8\";\r\n  }\r\n  .bxs-user-plus:before {\r\n    content: \"\\eee9\";\r\n  }\r\n  .bxs-user-rectangle:before {\r\n    content: \"\\eeea\";\r\n  }\r\n  .bxs-user-voice:before {\r\n    content: \"\\eeeb\";\r\n  }\r\n  .bxs-user-x:before {\r\n    content: \"\\eeec\";\r\n  }\r\n  .bxs-vector:before {\r\n    content: \"\\eeed\";\r\n  }\r\n  .bxs-vial:before {\r\n    content: \"\\eeee\";\r\n  }\r\n  .bxs-video:before {\r\n    content: \"\\eeef\";\r\n  }\r\n  .bxs-video-off:before {\r\n    content: \"\\eef0\";\r\n  }\r\n  .bxs-video-plus:before {\r\n    content: \"\\eef1\";\r\n  }\r\n  .bxs-video-recording:before {\r\n    content: \"\\eef2\";\r\n  }\r\n  .bxs-videos:before {\r\n    content: \"\\eef3\";\r\n  }\r\n  .bxs-virus:before {\r\n    content: \"\\eef4\";\r\n  }\r\n  .bxs-virus-block:before {\r\n    content: \"\\eef5\";\r\n  }\r\n  .bxs-volume:before {\r\n    content: \"\\eef6\";\r\n  }\r\n  .bxs-volume-full:before {\r\n    content: \"\\eef7\";\r\n  }\r\n  .bxs-volume-low:before {\r\n    content: \"\\eef8\";\r\n  }\r\n  .bxs-volume-mute:before {\r\n    content: \"\\eef9\";\r\n  }\r\n  .bxs-wallet:before {\r\n    content: \"\\eefa\";\r\n  }\r\n  .bxs-wallet-alt:before {\r\n    content: \"\\eefb\";\r\n  }\r\n  .bxs-washer:before {\r\n    content: \"\\eefc\";\r\n  }\r\n  .bxs-watch:before {\r\n    content: \"\\eefd\";\r\n  }\r\n  .bxs-watch-alt:before {\r\n    content: \"\\eefe\";\r\n  }\r\n  .bxs-webcam:before {\r\n    content: \"\\eeff\";\r\n  }\r\n  .bxs-widget:before {\r\n    content: \"\\ef00\";\r\n  }\r\n  .bxs-window-alt:before {\r\n    content: \"\\ef01\";\r\n  }\r\n  .bxs-wine:before {\r\n    content: \"\\ef02\";\r\n  }\r\n  .bxs-wink-smile:before {\r\n    content: \"\\ef03\";\r\n  }\r\n  .bxs-wink-tongue:before {\r\n    content: \"\\ef04\";\r\n  }\r\n  .bxs-wrench:before {\r\n    content: \"\\ef05\";\r\n  }\r\n  .bxs-x-circle:before {\r\n    content: \"\\ef06\";\r\n  }\r\n  .bxs-x-square:before {\r\n    content: \"\\ef07\";\r\n  }\r\n  .bxs-yin-yang:before {\r\n    content: \"\\ef08\";\r\n  }\r\n  .bxs-zap:before {\r\n    content: \"\\ef09\";\r\n  }\r\n  .bxs-zoom-in:before {\r\n    content: \"\\ef0a\";\r\n  }\r\n  .bxs-zoom-out:before {\r\n    content: \"\\ef0b\";\r\n  }\r\n  ",".la,\r\n.las,\r\n.lar,\r\n.lal,\r\n.lad,\r\n.lab {\r\n  -moz-osx-font-smoothing: grayscale;\r\n  -webkit-font-smoothing: antialiased;\r\n  display: inline-block;\r\n  font-style: normal;\r\n  font-variant: normal;\r\n  text-rendering: auto;\r\n  line-height: 1; }\r\n\r\n.la-lg {\r\n  font-size: 1.33333em;\r\n  line-height: 0.75em;\r\n  vertical-align: -.0667em; }\r\n\r\n.la-xs {\r\n  font-size: .75em; }\r\n\r\n.la-sm {\r\n  font-size: .875em; }\r\n\r\n.la-1x {\r\n  font-size: 1em; }\r\n\r\n.la-2x {\r\n  font-size: 2em; }\r\n\r\n.la-3x {\r\n  font-size: 3em; }\r\n\r\n.la-4x {\r\n  font-size: 4em; }\r\n\r\n.la-5x {\r\n  font-size: 5em; }\r\n\r\n.la-6x {\r\n  font-size: 6em; }\r\n\r\n.la-7x {\r\n  font-size: 7em; }\r\n\r\n.la-8x {\r\n  font-size: 8em; }\r\n\r\n.la-9x {\r\n  font-size: 9em; }\r\n\r\n.la-10x {\r\n  font-size: 10em; }\r\n\r\n.la-fw {\r\n  text-align: center;\r\n  width: 1.25em; }\r\n\r\n.la-ul {\r\n  list-style-type: none;\r\n  margin-left: 2.5em;\r\n  padding-left: 0; }\r\n  .la-ul > li {\r\n    position: relative; }\r\n\r\n.la-li {\r\n  left: -2em;\r\n  position: absolute;\r\n  text-align: center;\r\n  width: 2em;\r\n  line-height: inherit; }\r\n\r\n.la-border {\r\n  border: solid 0.08em #eee;\r\n  border-radius: .1em;\r\n  padding: .2em .25em .15em; }\r\n\r\n.la-pull-left {\r\n  float: left; }\r\n\r\n.la-pull-right {\r\n  float: right; }\r\n\r\n.la.la-pull-left,\r\n.las.la-pull-left,\r\n.lar.la-pull-left,\r\n.lal.la-pull-left,\r\n.lab.la-pull-left {\r\n  margin-right: .3em; }\r\n\r\n.la.la-pull-right,\r\n.las.la-pull-right,\r\n.lar.la-pull-right,\r\n.lal.la-pull-right,\r\n.lab.la-pull-right {\r\n  margin-left: .3em; }\r\n\r\n.la-spin {\r\n  -webkit-animation: la-spin 2s infinite linear;\r\n          animation: la-spin 2s infinite linear; }\r\n\r\n.la-pulse {\r\n  -webkit-animation: la-spin 1s infinite steps(8);\r\n          animation: la-spin 1s infinite steps(8); }\r\n\r\n@-webkit-keyframes la-spin {\r\n  0% {\r\n    -webkit-transform: rotate(0deg);\r\n            transform: rotate(0deg); }\r\n  100% {\r\n    -webkit-transform: rotate(360deg);\r\n            transform: rotate(360deg); } }\r\n\r\n@keyframes la-spin {\r\n  0% {\r\n    -webkit-transform: rotate(0deg);\r\n            transform: rotate(0deg); }\r\n  100% {\r\n    -webkit-transform: rotate(360deg);\r\n            transform: rotate(360deg); } }\r\n\r\n.la-rotate-90 {\r\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=1)\";\r\n  -webkit-transform: rotate(90deg);\r\n          transform: rotate(90deg); }\r\n\r\n.la-rotate-180 {\r\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2)\";\r\n  -webkit-transform: rotate(180deg);\r\n          transform: rotate(180deg); }\r\n\r\n.la-rotate-270 {\r\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=3)\";\r\n  -webkit-transform: rotate(270deg);\r\n          transform: rotate(270deg); }\r\n\r\n.la-flip-horizontal {\r\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=0, mirror=1)\";\r\n  -webkit-transform: scale(-1, 1);\r\n          transform: scale(-1, 1); }\r\n\r\n.la-flip-vertical {\r\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)\";\r\n  -webkit-transform: scale(1, -1);\r\n          transform: scale(1, -1); }\r\n\r\n.la-flip-both, .la-flip-horizontal.la-flip-vertical {\r\n  -ms-filter: \"progid:DXImageTransform.Microsoft.BasicImage(rotation=2, mirror=1)\";\r\n  -webkit-transform: scale(-1, -1);\r\n          transform: scale(-1, -1); }\r\n\r\n:root .la-rotate-90,\r\n:root .la-rotate-180,\r\n:root .la-rotate-270,\r\n:root .la-flip-horizontal,\r\n:root .la-flip-vertical,\r\n:root .la-flip-both {\r\n  -webkit-filter: none;\r\n          filter: none; }\r\n\r\n.la-stack {\r\n  display: inline-block;\r\n  height: 2em;\r\n  line-height: 2em;\r\n  position: relative;\r\n  vertical-align: middle;\r\n  width: 2.5em; }\r\n\r\n.la-stack-1x,\r\n.la-stack-2x {\r\n  left: 0;\r\n  position: absolute;\r\n  text-align: center;\r\n  width: 100%; }\r\n\r\n.la-stack-1x {\r\n  line-height: inherit; }\r\n\r\n.la-stack-2x {\r\n  font-size: 2em; }\r\n\r\n.la-inverse {\r\n  color: #fff; }\r\n\r\n/* Font Awesome uses the Unicode Private Use Area (PUA) to ensure screen\r\nreaders do not read off random characters that represent icons */\r\n.la-500px:before {\r\n  content: \"\\f26e\"; }\r\n\r\n.la-accessible-icon:before {\r\n  content: \"\\f368\"; }\r\n\r\n.la-accusoft:before {\r\n  content: \"\\f369\"; }\r\n\r\n.la-acquisitions-incorporated:before {\r\n  content: \"\\f6af\"; }\r\n\r\n.la-ad:before {\r\n  content: \"\\f641\"; }\r\n\r\n.la-address-book:before {\r\n  content: \"\\f2b9\"; }\r\n\r\n.la-address-card:before {\r\n  content: \"\\f2bb\"; }\r\n\r\n.la-adjust:before {\r\n  content: \"\\f042\"; }\r\n\r\n.la-adn:before {\r\n  content: \"\\f170\"; }\r\n\r\n.la-adobe:before {\r\n  content: \"\\f778\"; }\r\n\r\n.la-adversal:before {\r\n  content: \"\\f36a\"; }\r\n\r\n.la-affiliatetheme:before {\r\n  content: \"\\f36b\"; }\r\n\r\n.la-air-freshener:before {\r\n  content: \"\\f5d0\"; }\r\n\r\n.la-airbnb:before {\r\n  content: \"\\f834\"; }\r\n\r\n.la-algolia:before {\r\n  content: \"\\f36c\"; }\r\n\r\n.la-align-center:before {\r\n  content: \"\\f037\"; }\r\n\r\n.la-align-justify:before {\r\n  content: \"\\f039\"; }\r\n\r\n.la-align-left:before {\r\n  content: \"\\f036\"; }\r\n\r\n.la-align-right:before {\r\n  content: \"\\f038\"; }\r\n\r\n.la-alipay:before {\r\n  content: \"\\f642\"; }\r\n\r\n.la-allergies:before {\r\n  content: \"\\f461\"; }\r\n\r\n.la-amazon:before {\r\n  content: \"\\f270\"; }\r\n\r\n.la-amazon-pay:before {\r\n  content: \"\\f42c\"; }\r\n\r\n.la-ambulance:before {\r\n  content: \"\\f0f9\"; }\r\n\r\n.la-american-sign-language-interpreting:before {\r\n  content: \"\\f2a3\"; }\r\n\r\n.la-amilia:before {\r\n  content: \"\\f36d\"; }\r\n\r\n.la-anchor:before {\r\n  content: \"\\f13d\"; }\r\n\r\n.la-android:before {\r\n  content: \"\\f17b\"; }\r\n\r\n.la-angellist:before {\r\n  content: \"\\f209\"; }\r\n\r\n.la-angle-double-down:before {\r\n  content: \"\\f103\"; }\r\n\r\n.la-angle-double-left:before {\r\n  content: \"\\f100\"; }\r\n\r\n.la-angle-double-right:before {\r\n  content: \"\\f101\"; }\r\n\r\n.la-angle-double-up:before {\r\n  content: \"\\f102\"; }\r\n\r\n.la-angle-down:before {\r\n  content: \"\\f107\"; }\r\n\r\n.la-angle-left:before {\r\n  content: \"\\f104\"; }\r\n\r\n.la-angle-right:before {\r\n  content: \"\\f105\"; }\r\n\r\n.la-angle-up:before {\r\n  content: \"\\f106\"; }\r\n\r\n.la-angry:before {\r\n  content: \"\\f556\"; }\r\n\r\n.la-angrycreative:before {\r\n  content: \"\\f36e\"; }\r\n\r\n.la-angular:before {\r\n  content: \"\\f420\"; }\r\n\r\n.la-ankh:before {\r\n  content: \"\\f644\"; }\r\n\r\n.la-app-store:before {\r\n  content: \"\\f36f\"; }\r\n\r\n.la-app-store-ios:before {\r\n  content: \"\\f370\"; }\r\n\r\n.la-apper:before {\r\n  content: \"\\f371\"; }\r\n\r\n.la-apple:before {\r\n  content: \"\\f179\"; }\r\n\r\n.la-apple-alt:before {\r\n  content: \"\\f5d1\"; }\r\n\r\n.la-apple-pay:before {\r\n  content: \"\\f415\"; }\r\n\r\n.la-archive:before {\r\n  content: \"\\f187\"; }\r\n\r\n.la-archway:before {\r\n  content: \"\\f557\"; }\r\n\r\n.la-arrow-alt-circle-down:before {\r\n  content: \"\\f358\"; }\r\n\r\n.la-arrow-alt-circle-left:before {\r\n  content: \"\\f359\"; }\r\n\r\n.la-arrow-alt-circle-right:before {\r\n  content: \"\\f35a\"; }\r\n\r\n.la-arrow-alt-circle-up:before {\r\n  content: \"\\f35b\"; }\r\n\r\n.la-arrow-circle-down:before {\r\n  content: \"\\f0ab\"; }\r\n\r\n.la-arrow-circle-left:before {\r\n  content: \"\\f0a8\"; }\r\n\r\n.la-arrow-circle-right:before {\r\n  content: \"\\f0a9\"; }\r\n\r\n.la-arrow-circle-up:before {\r\n  content: \"\\f0aa\"; }\r\n\r\n.la-arrow-down:before {\r\n  content: \"\\f063\"; }\r\n\r\n.la-arrow-left:before {\r\n  content: \"\\f060\"; }\r\n\r\n.la-arrow-right:before {\r\n  content: \"\\f061\"; }\r\n\r\n.la-arrow-up:before {\r\n  content: \"\\f062\"; }\r\n\r\n.la-arrows-alt:before {\r\n  content: \"\\f0b2\"; }\r\n\r\n.la-arrows-alt-h:before {\r\n  content: \"\\f337\"; }\r\n\r\n.la-arrows-alt-v:before {\r\n  content: \"\\f338\"; }\r\n\r\n.la-artstation:before {\r\n  content: \"\\f77a\"; }\r\n\r\n.la-assistive-listening-systems:before {\r\n  content: \"\\f2a2\"; }\r\n\r\n.la-asterisk:before {\r\n  content: \"\\f069\"; }\r\n\r\n.la-asymmetrik:before {\r\n  content: \"\\f372\"; }\r\n\r\n.la-at:before {\r\n  content: \"\\f1fa\"; }\r\n\r\n.la-atlas:before {\r\n  content: \"\\f558\"; }\r\n\r\n.la-atlassian:before {\r\n  content: \"\\f77b\"; }\r\n\r\n.la-atom:before {\r\n  content: \"\\f5d2\"; }\r\n\r\n.la-audible:before {\r\n  content: \"\\f373\"; }\r\n\r\n.la-audio-description:before {\r\n  content: \"\\f29e\"; }\r\n\r\n.la-autoprefixer:before {\r\n  content: \"\\f41c\"; }\r\n\r\n.la-avianex:before {\r\n  content: \"\\f374\"; }\r\n\r\n.la-aviato:before {\r\n  content: \"\\f421\"; }\r\n\r\n.la-award:before {\r\n  content: \"\\f559\"; }\r\n\r\n.la-aws:before {\r\n  content: \"\\f375\"; }\r\n\r\n.la-baby:before {\r\n  content: \"\\f77c\"; }\r\n\r\n.la-baby-carriage:before {\r\n  content: \"\\f77d\"; }\r\n\r\n.la-backspace:before {\r\n  content: \"\\f55a\"; }\r\n\r\n.la-backward:before {\r\n  content: \"\\f04a\"; }\r\n\r\n.la-bacon:before {\r\n  content: \"\\f7e5\"; }\r\n\r\n.la-balance-scale:before {\r\n  content: \"\\f24e\"; }\r\n\r\n.la-balance-scale-left:before {\r\n  content: \"\\f515\"; }\r\n\r\n.la-balance-scale-right:before {\r\n  content: \"\\f516\"; }\r\n\r\n.la-ban:before {\r\n  content: \"\\f05e\"; }\r\n\r\n.la-band-aid:before {\r\n  content: \"\\f462\"; }\r\n\r\n.la-bandcamp:before {\r\n  content: \"\\f2d5\"; }\r\n\r\n.la-barcode:before {\r\n  content: \"\\f02a\"; }\r\n\r\n.la-bars:before {\r\n  content: \"\\f0c9\"; }\r\n\r\n.la-baseball-ball:before {\r\n  content: \"\\f433\"; }\r\n\r\n.la-basketball-ball:before {\r\n  content: \"\\f434\"; }\r\n\r\n.la-bath:before {\r\n  content: \"\\f2cd\"; }\r\n\r\n.la-battery-empty:before {\r\n  content: \"\\f244\"; }\r\n\r\n.la-battery-full:before {\r\n  content: \"\\f240\"; }\r\n\r\n.la-battery-half:before {\r\n  content: \"\\f242\"; }\r\n\r\n.la-battery-quarter:before {\r\n  content: \"\\f243\"; }\r\n\r\n.la-battery-three-quarters:before {\r\n  content: \"\\f241\"; }\r\n\r\n.la-battle-net:before {\r\n  content: \"\\f835\"; }\r\n\r\n.la-bed:before {\r\n  content: \"\\f236\"; }\r\n\r\n.la-beer:before {\r\n  content: \"\\f0fc\"; }\r\n\r\n.la-behance:before {\r\n  content: \"\\f1b4\"; }\r\n\r\n.la-behance-square:before {\r\n  content: \"\\f1b5\"; }\r\n\r\n.la-bell:before {\r\n  content: \"\\f0f3\"; }\r\n\r\n.la-bell-slash:before {\r\n  content: \"\\f1f6\"; }\r\n\r\n.la-bezier-curve:before {\r\n  content: \"\\f55b\"; }\r\n\r\n.la-bible:before {\r\n  content: \"\\f647\"; }\r\n\r\n.la-bicycle:before {\r\n  content: \"\\f206\"; }\r\n\r\n.la-biking:before {\r\n  content: \"\\f84a\"; }\r\n\r\n.la-bimobject:before {\r\n  content: \"\\f378\"; }\r\n\r\n.la-binoculars:before {\r\n  content: \"\\f1e5\"; }\r\n\r\n.la-biohazard:before {\r\n  content: \"\\f780\"; }\r\n\r\n.la-birthday-cake:before {\r\n  content: \"\\f1fd\"; }\r\n\r\n.la-bitbucket:before {\r\n  content: \"\\f171\"; }\r\n\r\n.la-bitcoin:before {\r\n  content: \"\\f379\"; }\r\n\r\n.la-bity:before {\r\n  content: \"\\f37a\"; }\r\n\r\n.la-black-tie:before {\r\n  content: \"\\f27e\"; }\r\n\r\n.la-blackberry:before {\r\n  content: \"\\f37b\"; }\r\n\r\n.la-blender:before {\r\n  content: \"\\f517\"; }\r\n\r\n.la-blender-phone:before {\r\n  content: \"\\f6b6\"; }\r\n\r\n.la-blind:before {\r\n  content: \"\\f29d\"; }\r\n\r\n.la-blog:before {\r\n  content: \"\\f781\"; }\r\n\r\n.la-blogger:before {\r\n  content: \"\\f37c\"; }\r\n\r\n.la-blogger-b:before {\r\n  content: \"\\f37d\"; }\r\n\r\n.la-bluetooth:before {\r\n  content: \"\\f293\"; }\r\n\r\n.la-bluetooth-b:before {\r\n  content: \"\\f294\"; }\r\n\r\n.la-bold:before {\r\n  content: \"\\f032\"; }\r\n\r\n.la-bolt:before {\r\n  content: \"\\f0e7\"; }\r\n\r\n.la-bomb:before {\r\n  content: \"\\f1e2\"; }\r\n\r\n.la-bone:before {\r\n  content: \"\\f5d7\"; }\r\n\r\n.la-bong:before {\r\n  content: \"\\f55c\"; }\r\n\r\n.la-book:before {\r\n  content: \"\\f02d\"; }\r\n\r\n.la-book-dead:before {\r\n  content: \"\\f6b7\"; }\r\n\r\n.la-book-medical:before {\r\n  content: \"\\f7e6\"; }\r\n\r\n.la-book-open:before {\r\n  content: \"\\f518\"; }\r\n\r\n.la-book-reader:before {\r\n  content: \"\\f5da\"; }\r\n\r\n.la-bookmark:before {\r\n  content: \"\\f02e\"; }\r\n\r\n.la-bootstrap:before {\r\n  content: \"\\f836\"; }\r\n\r\n.la-border-all:before {\r\n  content: \"\\f84c\"; }\r\n\r\n.la-border-none:before {\r\n  content: \"\\f850\"; }\r\n\r\n.la-border-style:before {\r\n  content: \"\\f853\"; }\r\n\r\n.la-bowling-ball:before {\r\n  content: \"\\f436\"; }\r\n\r\n.la-box:before {\r\n  content: \"\\f466\"; }\r\n\r\n.la-box-open:before {\r\n  content: \"\\f49e\"; }\r\n\r\n.la-boxes:before {\r\n  content: \"\\f468\"; }\r\n\r\n.la-braille:before {\r\n  content: \"\\f2a1\"; }\r\n\r\n.la-brain:before {\r\n  content: \"\\f5dc\"; }\r\n\r\n.la-bread-slice:before {\r\n  content: \"\\f7ec\"; }\r\n\r\n.la-briefcase:before {\r\n  content: \"\\f0b1\"; }\r\n\r\n.la-briefcase-medical:before {\r\n  content: \"\\f469\"; }\r\n\r\n.la-broadcast-tower:before {\r\n  content: \"\\f519\"; }\r\n\r\n.la-broom:before {\r\n  content: \"\\f51a\"; }\r\n\r\n.la-brush:before {\r\n  content: \"\\f55d\"; }\r\n\r\n.la-btc:before {\r\n  content: \"\\f15a\"; }\r\n\r\n.la-buffer:before {\r\n  content: \"\\f837\"; }\r\n\r\n.la-bug:before {\r\n  content: \"\\f188\"; }\r\n\r\n.la-building:before {\r\n  content: \"\\f1ad\"; }\r\n\r\n.la-bullhorn:before {\r\n  content: \"\\f0a1\"; }\r\n\r\n.la-bullseye:before {\r\n  content: \"\\f140\"; }\r\n\r\n.la-burn:before {\r\n  content: \"\\f46a\"; }\r\n\r\n.la-buromobelexperte:before {\r\n  content: \"\\f37f\"; }\r\n\r\n.la-bus:before {\r\n  content: \"\\f207\"; }\r\n\r\n.la-bus-alt:before {\r\n  content: \"\\f55e\"; }\r\n\r\n.la-business-time:before {\r\n  content: \"\\f64a\"; }\r\n\r\n.la-buy-n-large:before {\r\n  content: \"\\f8a6\"; }\r\n\r\n.la-buysellads:before {\r\n  content: \"\\f20d\"; }\r\n\r\n.la-calculator:before {\r\n  content: \"\\f1ec\"; }\r\n\r\n.la-calendar:before {\r\n  content: \"\\f133\"; }\r\n\r\n.la-calendar-alt:before {\r\n  content: \"\\f073\"; }\r\n\r\n.la-calendar-check:before {\r\n  content: \"\\f274\"; }\r\n\r\n.la-calendar-day:before {\r\n  content: \"\\f783\"; }\r\n\r\n.la-calendar-minus:before {\r\n  content: \"\\f272\"; }\r\n\r\n.la-calendar-plus:before {\r\n  content: \"\\f271\"; }\r\n\r\n.la-calendar-times:before {\r\n  content: \"\\f273\"; }\r\n\r\n.la-calendar-week:before {\r\n  content: \"\\f784\"; }\r\n\r\n.la-camera:before {\r\n  content: \"\\f030\"; }\r\n\r\n.la-camera-retro:before {\r\n  content: \"\\f083\"; }\r\n\r\n.la-campground:before {\r\n  content: \"\\f6bb\"; }\r\n\r\n.la-canadian-maple-leaf:before {\r\n  content: \"\\f785\"; }\r\n\r\n.la-candy-cane:before {\r\n  content: \"\\f786\"; }\r\n\r\n.la-cannabis:before {\r\n  content: \"\\f55f\"; }\r\n\r\n.la-capsules:before {\r\n  content: \"\\f46b\"; }\r\n\r\n.la-car:before {\r\n  content: \"\\f1b9\"; }\r\n\r\n.la-car-alt:before {\r\n  content: \"\\f5de\"; }\r\n\r\n.la-car-battery:before {\r\n  content: \"\\f5df\"; }\r\n\r\n.la-car-crash:before {\r\n  content: \"\\f5e1\"; }\r\n\r\n.la-car-side:before {\r\n  content: \"\\f5e4\"; }\r\n\r\n.la-caret-down:before {\r\n  content: \"\\f0d7\"; }\r\n\r\n.la-caret-left:before {\r\n  content: \"\\f0d9\"; }\r\n\r\n.la-caret-right:before {\r\n  content: \"\\f0da\"; }\r\n\r\n.la-caret-square-down:before {\r\n  content: \"\\f150\"; }\r\n\r\n.la-caret-square-left:before {\r\n  content: \"\\f191\"; }\r\n\r\n.la-caret-square-right:before {\r\n  content: \"\\f152\"; }\r\n\r\n.la-caret-square-up:before {\r\n  content: \"\\f151\"; }\r\n\r\n.la-caret-up:before {\r\n  content: \"\\f0d8\"; }\r\n\r\n.la-carrot:before {\r\n  content: \"\\f787\"; }\r\n\r\n.la-cart-arrow-down:before {\r\n  content: \"\\f218\"; }\r\n\r\n.la-cart-plus:before {\r\n  content: \"\\f217\"; }\r\n\r\n.la-cash-register:before {\r\n  content: \"\\f788\"; }\r\n\r\n.la-cat:before {\r\n  content: \"\\f6be\"; }\r\n\r\n.la-cc-amazon-pay:before {\r\n  content: \"\\f42d\"; }\r\n\r\n.la-cc-amex:before {\r\n  content: \"\\f1f3\"; }\r\n\r\n.la-cc-apple-pay:before {\r\n  content: \"\\f416\"; }\r\n\r\n.la-cc-diners-club:before {\r\n  content: \"\\f24c\"; }\r\n\r\n.la-cc-discover:before {\r\n  content: \"\\f1f2\"; }\r\n\r\n.la-cc-jcb:before {\r\n  content: \"\\f24b\"; }\r\n\r\n.la-cc-mastercard:before {\r\n  content: \"\\f1f1\"; }\r\n\r\n.la-cc-paypal:before {\r\n  content: \"\\f1f4\"; }\r\n\r\n.la-cc-stripe:before {\r\n  content: \"\\f1f5\"; }\r\n\r\n.la-cc-visa:before {\r\n  content: \"\\f1f0\"; }\r\n\r\n.la-centercode:before {\r\n  content: \"\\f380\"; }\r\n\r\n.la-centos:before {\r\n  content: \"\\f789\"; }\r\n\r\n.la-certificate:before {\r\n  content: \"\\f0a3\"; }\r\n\r\n.la-chair:before {\r\n  content: \"\\f6c0\"; }\r\n\r\n.la-chalkboard:before {\r\n  content: \"\\f51b\"; }\r\n\r\n.la-chalkboard-teacher:before {\r\n  content: \"\\f51c\"; }\r\n\r\n.la-charging-station:before {\r\n  content: \"\\f5e7\"; }\r\n\r\n.la-chart-area:before {\r\n  content: \"\\f1fe\"; }\r\n\r\n.la-chart-bar:before {\r\n  content: \"\\f080\"; }\r\n\r\n.la-chart-line:before {\r\n  content: \"\\f201\"; }\r\n\r\n.la-chart-pie:before {\r\n  content: \"\\f200\"; }\r\n\r\n.la-check:before {\r\n  content: \"\\f00c\"; }\r\n\r\n.la-check-circle:before {\r\n  content: \"\\f058\"; }\r\n\r\n.la-check-double:before {\r\n  content: \"\\f560\"; }\r\n\r\n.la-check-square:before {\r\n  content: \"\\f14a\"; }\r\n\r\n.la-cheese:before {\r\n  content: \"\\f7ef\"; }\r\n\r\n.la-chess:before {\r\n  content: \"\\f439\"; }\r\n\r\n.la-chess-bishop:before {\r\n  content: \"\\f43a\"; }\r\n\r\n.la-chess-board:before {\r\n  content: \"\\f43c\"; }\r\n\r\n.la-chess-king:before {\r\n  content: \"\\f43f\"; }\r\n\r\n.la-chess-knight:before {\r\n  content: \"\\f441\"; }\r\n\r\n.la-chess-pawn:before {\r\n  content: \"\\f443\"; }\r\n\r\n.la-chess-queen:before {\r\n  content: \"\\f445\"; }\r\n\r\n.la-chess-rook:before {\r\n  content: \"\\f447\"; }\r\n\r\n.la-chevron-circle-down:before {\r\n  content: \"\\f13a\"; }\r\n\r\n.la-chevron-circle-left:before {\r\n  content: \"\\f137\"; }\r\n\r\n.la-chevron-circle-right:before {\r\n  content: \"\\f138\"; }\r\n\r\n.la-chevron-circle-up:before {\r\n  content: \"\\f139\"; }\r\n\r\n.la-chevron-down:before {\r\n  content: \"\\f078\"; }\r\n\r\n.la-chevron-left:before {\r\n  content: \"\\f053\"; }\r\n\r\n.la-chevron-right:before {\r\n  content: \"\\f054\"; }\r\n\r\n.la-chevron-up:before {\r\n  content: \"\\f077\"; }\r\n\r\n.la-child:before {\r\n  content: \"\\f1ae\"; }\r\n\r\n.la-chrome:before {\r\n  content: \"\\f268\"; }\r\n\r\n.la-chromecast:before {\r\n  content: \"\\f838\"; }\r\n\r\n.la-church:before {\r\n  content: \"\\f51d\"; }\r\n\r\n.la-circle:before {\r\n  content: \"\\f111\"; }\r\n\r\n.la-circle-notch:before {\r\n  content: \"\\f1ce\"; }\r\n\r\n.la-city:before {\r\n  content: \"\\f64f\"; }\r\n\r\n.la-clinic-medical:before {\r\n  content: \"\\f7f2\"; }\r\n\r\n.la-clipboard:before {\r\n  content: \"\\f328\"; }\r\n\r\n.la-clipboard-check:before {\r\n  content: \"\\f46c\"; }\r\n\r\n.la-clipboard-list:before {\r\n  content: \"\\f46d\"; }\r\n\r\n.la-clock:before {\r\n  content: \"\\f017\"; }\r\n\r\n.la-clone:before {\r\n  content: \"\\f24d\"; }\r\n\r\n.la-closed-captioning:before {\r\n  content: \"\\f20a\"; }\r\n\r\n.la-cloud:before {\r\n  content: \"\\f0c2\"; }\r\n\r\n.la-cloud-download-alt:before {\r\n  content: \"\\f381\"; }\r\n\r\n.la-cloud-meatball:before {\r\n  content: \"\\f73b\"; }\r\n\r\n.la-cloud-moon:before {\r\n  content: \"\\f6c3\"; }\r\n\r\n.la-cloud-moon-rain:before {\r\n  content: \"\\f73c\"; }\r\n\r\n.la-cloud-rain:before {\r\n  content: \"\\f73d\"; }\r\n\r\n.la-cloud-showers-heavy:before {\r\n  content: \"\\f740\"; }\r\n\r\n.la-cloud-sun:before {\r\n  content: \"\\f6c4\"; }\r\n\r\n.la-cloud-sun-rain:before {\r\n  content: \"\\f743\"; }\r\n\r\n.la-cloud-upload-alt:before {\r\n  content: \"\\f382\"; }\r\n\r\n.la-cloudscale:before {\r\n  content: \"\\f383\"; }\r\n\r\n.la-cloudsmith:before {\r\n  content: \"\\f384\"; }\r\n\r\n.la-cloudversify:before {\r\n  content: \"\\f385\"; }\r\n\r\n.la-cocktail:before {\r\n  content: \"\\f561\"; }\r\n\r\n.la-code:before {\r\n  content: \"\\f121\"; }\r\n\r\n.la-code-branch:before {\r\n  content: \"\\f126\"; }\r\n\r\n.la-codepen:before {\r\n  content: \"\\f1cb\"; }\r\n\r\n.la-codiepie:before {\r\n  content: \"\\f284\"; }\r\n\r\n.la-coffee:before {\r\n  content: \"\\f0f4\"; }\r\n\r\n.la-cog:before {\r\n  content: \"\\f013\"; }\r\n\r\n.la-cogs:before {\r\n  content: \"\\f085\"; }\r\n\r\n.la-coins:before {\r\n  content: \"\\f51e\"; }\r\n\r\n.la-columns:before {\r\n  content: \"\\f0db\"; }\r\n\r\n.la-comment:before {\r\n  content: \"\\f075\"; }\r\n\r\n.la-comment-alt:before {\r\n  content: \"\\f27a\"; }\r\n\r\n.la-comment-dollar:before {\r\n  content: \"\\f651\"; }\r\n\r\n.la-comment-dots:before {\r\n  content: \"\\f4ad\"; }\r\n\r\n.la-comment-medical:before {\r\n  content: \"\\f7f5\"; }\r\n\r\n.la-comment-slash:before {\r\n  content: \"\\f4b3\"; }\r\n\r\n.la-comments:before {\r\n  content: \"\\f086\"; }\r\n\r\n.la-comments-dollar:before {\r\n  content: \"\\f653\"; }\r\n\r\n.la-compact-disc:before {\r\n  content: \"\\f51f\"; }\r\n\r\n.la-compass:before {\r\n  content: \"\\f14e\"; }\r\n\r\n.la-compress:before {\r\n  content: \"\\f066\"; }\r\n\r\n.la-compress-arrows-alt:before {\r\n  content: \"\\f78c\"; }\r\n\r\n.la-concierge-bell:before {\r\n  content: \"\\f562\"; }\r\n\r\n.la-confluence:before {\r\n  content: \"\\f78d\"; }\r\n\r\n.la-connectdevelop:before {\r\n  content: \"\\f20e\"; }\r\n\r\n.la-contao:before {\r\n  content: \"\\f26d\"; }\r\n\r\n.la-cookie:before {\r\n  content: \"\\f563\"; }\r\n\r\n.la-cookie-bite:before {\r\n  content: \"\\f564\"; }\r\n\r\n.la-copy:before {\r\n  content: \"\\f0c5\"; }\r\n\r\n.la-copyright:before {\r\n  content: \"\\f1f9\"; }\r\n\r\n.la-cotton-bureau:before {\r\n  content: \"\\f89e\"; }\r\n\r\n.la-couch:before {\r\n  content: \"\\f4b8\"; }\r\n\r\n.la-cpanel:before {\r\n  content: \"\\f388\"; }\r\n\r\n.la-creative-commons:before {\r\n  content: \"\\f25e\"; }\r\n\r\n.la-creative-commons-by:before {\r\n  content: \"\\f4e7\"; }\r\n\r\n.la-creative-commons-nc:before {\r\n  content: \"\\f4e8\"; }\r\n\r\n.la-creative-commons-nc-eu:before {\r\n  content: \"\\f4e9\"; }\r\n\r\n.la-creative-commons-nc-jp:before {\r\n  content: \"\\f4ea\"; }\r\n\r\n.la-creative-commons-nd:before {\r\n  content: \"\\f4eb\"; }\r\n\r\n.la-creative-commons-pd:before {\r\n  content: \"\\f4ec\"; }\r\n\r\n.la-creative-commons-pd-alt:before {\r\n  content: \"\\f4ed\"; }\r\n\r\n.la-creative-commons-remix:before {\r\n  content: \"\\f4ee\"; }\r\n\r\n.la-creative-commons-sa:before {\r\n  content: \"\\f4ef\"; }\r\n\r\n.la-creative-commons-sampling:before {\r\n  content: \"\\f4f0\"; }\r\n\r\n.la-creative-commons-sampling-plus:before {\r\n  content: \"\\f4f1\"; }\r\n\r\n.la-creative-commons-share:before {\r\n  content: \"\\f4f2\"; }\r\n\r\n.la-creative-commons-zero:before {\r\n  content: \"\\f4f3\"; }\r\n\r\n.la-credit-card:before {\r\n  content: \"\\f09d\"; }\r\n\r\n.la-critical-role:before {\r\n  content: \"\\f6c9\"; }\r\n\r\n.la-crop:before {\r\n  content: \"\\f125\"; }\r\n\r\n.la-crop-alt:before {\r\n  content: \"\\f565\"; }\r\n\r\n.la-cross:before {\r\n  content: \"\\f654\"; }\r\n\r\n.la-crosshairs:before {\r\n  content: \"\\f05b\"; }\r\n\r\n.la-crow:before {\r\n  content: \"\\f520\"; }\r\n\r\n.la-crown:before {\r\n  content: \"\\f521\"; }\r\n\r\n.la-crutch:before {\r\n  content: \"\\f7f7\"; }\r\n\r\n.la-css3:before {\r\n  content: \"\\f13c\"; }\r\n\r\n.la-css3-alt:before {\r\n  content: \"\\f38b\"; }\r\n\r\n.la-cube:before {\r\n  content: \"\\f1b2\"; }\r\n\r\n.la-cubes:before {\r\n  content: \"\\f1b3\"; }\r\n\r\n.la-cut:before {\r\n  content: \"\\f0c4\"; }\r\n\r\n.la-cuttlefish:before {\r\n  content: \"\\f38c\"; }\r\n\r\n.la-d-and-d:before {\r\n  content: \"\\f38d\"; }\r\n\r\n.la-d-and-d-beyond:before {\r\n  content: \"\\f6ca\"; }\r\n\r\n.la-dashcube:before {\r\n  content: \"\\f210\"; }\r\n\r\n.la-database:before {\r\n  content: \"\\f1c0\"; }\r\n\r\n.la-deaf:before {\r\n  content: \"\\f2a4\"; }\r\n\r\n.la-delicious:before {\r\n  content: \"\\f1a5\"; }\r\n\r\n.la-democrat:before {\r\n  content: \"\\f747\"; }\r\n\r\n.la-deploydog:before {\r\n  content: \"\\f38e\"; }\r\n\r\n.la-deskpro:before {\r\n  content: \"\\f38f\"; }\r\n\r\n.la-desktop:before {\r\n  content: \"\\f108\"; }\r\n\r\n.la-dev:before {\r\n  content: \"\\f6cc\"; }\r\n\r\n.la-deviantart:before {\r\n  content: \"\\f1bd\"; }\r\n\r\n.la-dharmachakra:before {\r\n  content: \"\\f655\"; }\r\n\r\n.la-dhl:before {\r\n  content: \"\\f790\"; }\r\n\r\n.la-diagnoses:before {\r\n  content: \"\\f470\"; }\r\n\r\n.la-diaspora:before {\r\n  content: \"\\f791\"; }\r\n\r\n.la-dice:before {\r\n  content: \"\\f522\"; }\r\n\r\n.la-dice-d20:before {\r\n  content: \"\\f6cf\"; }\r\n\r\n.la-dice-d6:before {\r\n  content: \"\\f6d1\"; }\r\n\r\n.la-dice-five:before {\r\n  content: \"\\f523\"; }\r\n\r\n.la-dice-four:before {\r\n  content: \"\\f524\"; }\r\n\r\n.la-dice-one:before {\r\n  content: \"\\f525\"; }\r\n\r\n.la-dice-six:before {\r\n  content: \"\\f526\"; }\r\n\r\n.la-dice-three:before {\r\n  content: \"\\f527\"; }\r\n\r\n.la-dice-two:before {\r\n  content: \"\\f528\"; }\r\n\r\n.la-digg:before {\r\n  content: \"\\f1a6\"; }\r\n\r\n.la-digital-ocean:before {\r\n  content: \"\\f391\"; }\r\n\r\n.la-digital-tachograph:before {\r\n  content: \"\\f566\"; }\r\n\r\n.la-directions:before {\r\n  content: \"\\f5eb\"; }\r\n\r\n.la-discord:before {\r\n  content: \"\\f392\"; }\r\n\r\n.la-discourse:before {\r\n  content: \"\\f393\"; }\r\n\r\n.la-divide:before {\r\n  content: \"\\f529\"; }\r\n\r\n.la-dizzy:before {\r\n  content: \"\\f567\"; }\r\n\r\n.la-dna:before {\r\n  content: \"\\f471\"; }\r\n\r\n.la-dochub:before {\r\n  content: \"\\f394\"; }\r\n\r\n.la-docker:before {\r\n  content: \"\\f395\"; }\r\n\r\n.la-dog:before {\r\n  content: \"\\f6d3\"; }\r\n\r\n.la-dollar-sign:before {\r\n  content: \"\\f155\"; }\r\n\r\n.la-dolly:before {\r\n  content: \"\\f472\"; }\r\n\r\n.la-dolly-flatbed:before {\r\n  content: \"\\f474\"; }\r\n\r\n.la-donate:before {\r\n  content: \"\\f4b9\"; }\r\n\r\n.la-door-closed:before {\r\n  content: \"\\f52a\"; }\r\n\r\n.la-door-open:before {\r\n  content: \"\\f52b\"; }\r\n\r\n.la-dot-circle:before {\r\n  content: \"\\f192\"; }\r\n\r\n.la-dove:before {\r\n  content: \"\\f4ba\"; }\r\n\r\n.la-download:before {\r\n  content: \"\\f019\"; }\r\n\r\n.la-draft2digital:before {\r\n  content: \"\\f396\"; }\r\n\r\n.la-drafting-compass:before {\r\n  content: \"\\f568\"; }\r\n\r\n.la-dragon:before {\r\n  content: \"\\f6d5\"; }\r\n\r\n.la-draw-polygon:before {\r\n  content: \"\\f5ee\"; }\r\n\r\n.la-dribbble:before {\r\n  content: \"\\f17d\"; }\r\n\r\n.la-dribbble-square:before {\r\n  content: \"\\f397\"; }\r\n\r\n.la-dropbox:before {\r\n  content: \"\\f16b\"; }\r\n\r\n.la-drum:before {\r\n  content: \"\\f569\"; }\r\n\r\n.la-drum-steelpan:before {\r\n  content: \"\\f56a\"; }\r\n\r\n.la-drumstick-bite:before {\r\n  content: \"\\f6d7\"; }\r\n\r\n.la-drupal:before {\r\n  content: \"\\f1a9\"; }\r\n\r\n.la-dumbbell:before {\r\n  content: \"\\f44b\"; }\r\n\r\n.la-dumpster:before {\r\n  content: \"\\f793\"; }\r\n\r\n.la-dumpster-fire:before {\r\n  content: \"\\f794\"; }\r\n\r\n.la-dungeon:before {\r\n  content: \"\\f6d9\"; }\r\n\r\n.la-dyalog:before {\r\n  content: \"\\f399\"; }\r\n\r\n.la-earlybirds:before {\r\n  content: \"\\f39a\"; }\r\n\r\n.la-ebay:before {\r\n  content: \"\\f4f4\"; }\r\n\r\n.la-edge:before {\r\n  content: \"\\f282\"; }\r\n\r\n.la-edit:before {\r\n  content: \"\\f044\"; }\r\n\r\n.la-egg:before {\r\n  content: \"\\f7fb\"; }\r\n\r\n.la-eject:before {\r\n  content: \"\\f052\"; }\r\n\r\n.la-elementor:before {\r\n  content: \"\\f430\"; }\r\n\r\n.la-ellipsis-h:before {\r\n  content: \"\\f141\"; }\r\n\r\n.la-ellipsis-v:before {\r\n  content: \"\\f142\"; }\r\n\r\n.la-ello:before {\r\n  content: \"\\f5f1\"; }\r\n\r\n.la-ember:before {\r\n  content: \"\\f423\"; }\r\n\r\n.la-empire:before {\r\n  content: \"\\f1d1\"; }\r\n\r\n.la-envelope:before {\r\n  content: \"\\f0e0\"; }\r\n\r\n.la-envelope-open:before {\r\n  content: \"\\f2b6\"; }\r\n\r\n.la-envelope-open-text:before {\r\n  content: \"\\f658\"; }\r\n\r\n.la-envelope-square:before {\r\n  content: \"\\f199\"; }\r\n\r\n.la-envira:before {\r\n  content: \"\\f299\"; }\r\n\r\n.la-equals:before {\r\n  content: \"\\f52c\"; }\r\n\r\n.la-eraser:before {\r\n  content: \"\\f12d\"; }\r\n\r\n.la-erlang:before {\r\n  content: \"\\f39d\"; }\r\n\r\n.la-ethereum:before {\r\n  content: \"\\f42e\"; }\r\n\r\n.la-ethernet:before {\r\n  content: \"\\f796\"; }\r\n\r\n.la-etsy:before {\r\n  content: \"\\f2d7\"; }\r\n\r\n.la-euro-sign:before {\r\n  content: \"\\f153\"; }\r\n\r\n.la-evernote:before {\r\n  content: \"\\f839\"; }\r\n\r\n.la-exchange-alt:before {\r\n  content: \"\\f362\"; }\r\n\r\n.la-exclamation:before {\r\n  content: \"\\f12a\"; }\r\n\r\n.la-exclamation-circle:before {\r\n  content: \"\\f06a\"; }\r\n\r\n.la-exclamation-triangle:before {\r\n  content: \"\\f071\"; }\r\n\r\n.la-expand:before {\r\n  content: \"\\f065\"; }\r\n\r\n.la-expand-arrows-alt:before {\r\n  content: \"\\f31e\"; }\r\n\r\n.la-expeditedssl:before {\r\n  content: \"\\f23e\"; }\r\n\r\n.la-external-link-alt:before {\r\n  content: \"\\f35d\"; }\r\n\r\n.la-external-link-square-alt:before {\r\n  content: \"\\f360\"; }\r\n\r\n.la-eye:before {\r\n  content: \"\\f06e\"; }\r\n\r\n.la-eye-dropper:before {\r\n  content: \"\\f1fb\"; }\r\n\r\n.la-eye-slash:before {\r\n  content: \"\\f070\"; }\r\n\r\n.la-facebook:before {\r\n  content: \"\\f09a\"; }\r\n\r\n.la-facebook-f:before {\r\n  content: \"\\f39e\"; }\r\n\r\n.la-facebook-messenger:before {\r\n  content: \"\\f39f\"; }\r\n\r\n.la-facebook-square:before {\r\n  content: \"\\f082\"; }\r\n\r\n.la-fan:before {\r\n  content: \"\\f863\"; }\r\n\r\n.la-fantasy-flight-games:before {\r\n  content: \"\\f6dc\"; }\r\n\r\n.la-fast-backward:before {\r\n  content: \"\\f049\"; }\r\n\r\n.la-fast-forward:before {\r\n  content: \"\\f050\"; }\r\n\r\n.la-fax:before {\r\n  content: \"\\f1ac\"; }\r\n\r\n.la-feather:before {\r\n  content: \"\\f52d\"; }\r\n\r\n.la-feather-alt:before {\r\n  content: \"\\f56b\"; }\r\n\r\n.la-fedex:before {\r\n  content: \"\\f797\"; }\r\n\r\n.la-fedora:before {\r\n  content: \"\\f798\"; }\r\n\r\n.la-female:before {\r\n  content: \"\\f182\"; }\r\n\r\n.la-fighter-jet:before {\r\n  content: \"\\f0fb\"; }\r\n\r\n.la-figma:before {\r\n  content: \"\\f799\"; }\r\n\r\n.la-file:before {\r\n  content: \"\\f15b\"; }\r\n\r\n.la-file-alt:before {\r\n  content: \"\\f15c\"; }\r\n\r\n.la-file-archive:before {\r\n  content: \"\\f1c6\"; }\r\n\r\n.la-file-audio:before {\r\n  content: \"\\f1c7\"; }\r\n\r\n.la-file-code:before {\r\n  content: \"\\f1c9\"; }\r\n\r\n.la-file-contract:before {\r\n  content: \"\\f56c\"; }\r\n\r\n.la-file-csv:before {\r\n  content: \"\\f6dd\"; }\r\n\r\n.la-file-download:before {\r\n  content: \"\\f56d\"; }\r\n\r\n.la-file-excel:before {\r\n  content: \"\\f1c3\"; }\r\n\r\n.la-file-export:before {\r\n  content: \"\\f56e\"; }\r\n\r\n.la-file-image:before {\r\n  content: \"\\f1c5\"; }\r\n\r\n.la-file-import:before {\r\n  content: \"\\f56f\"; }\r\n\r\n.la-file-invoice:before {\r\n  content: \"\\f570\"; }\r\n\r\n.la-file-invoice-dollar:before {\r\n  content: \"\\f571\"; }\r\n\r\n.la-file-medical:before {\r\n  content: \"\\f477\"; }\r\n\r\n.la-file-medical-alt:before {\r\n  content: \"\\f478\"; }\r\n\r\n.la-file-pdf:before {\r\n  content: \"\\f1c1\"; }\r\n\r\n.la-file-powerpoint:before {\r\n  content: \"\\f1c4\"; }\r\n\r\n.la-file-prescription:before {\r\n  content: \"\\f572\"; }\r\n\r\n.la-file-signature:before {\r\n  content: \"\\f573\"; }\r\n\r\n.la-file-upload:before {\r\n  content: \"\\f574\"; }\r\n\r\n.la-file-video:before {\r\n  content: \"\\f1c8\"; }\r\n\r\n.la-file-word:before {\r\n  content: \"\\f1c2\"; }\r\n\r\n.la-fill:before {\r\n  content: \"\\f575\"; }\r\n\r\n.la-fill-drip:before {\r\n  content: \"\\f576\"; }\r\n\r\n.la-film:before {\r\n  content: \"\\f008\"; }\r\n\r\n.la-filter:before {\r\n  content: \"\\f0b0\"; }\r\n\r\n.la-fingerprint:before {\r\n  content: \"\\f577\"; }\r\n\r\n.la-fire:before {\r\n  content: \"\\f06d\"; }\r\n\r\n.la-fire-alt:before {\r\n  content: \"\\f7e4\"; }\r\n\r\n.la-fire-extinguisher:before {\r\n  content: \"\\f134\"; }\r\n\r\n.la-firefox:before {\r\n  content: \"\\f269\"; }\r\n\r\n.la-first-aid:before {\r\n  content: \"\\f479\"; }\r\n\r\n.la-first-order:before {\r\n  content: \"\\f2b0\"; }\r\n\r\n.la-first-order-alt:before {\r\n  content: \"\\f50a\"; }\r\n\r\n.la-firstdraft:before {\r\n  content: \"\\f3a1\"; }\r\n\r\n.la-fish:before {\r\n  content: \"\\f578\"; }\r\n\r\n.la-fist-raised:before {\r\n  content: \"\\f6de\"; }\r\n\r\n.la-flag:before {\r\n  content: \"\\f024\"; }\r\n\r\n.la-flag-checkered:before {\r\n  content: \"\\f11e\"; }\r\n\r\n.la-flag-usa:before {\r\n  content: \"\\f74d\"; }\r\n\r\n.la-flask:before {\r\n  content: \"\\f0c3\"; }\r\n\r\n.la-flickr:before {\r\n  content: \"\\f16e\"; }\r\n\r\n.la-flipboard:before {\r\n  content: \"\\f44d\"; }\r\n\r\n.la-flushed:before {\r\n  content: \"\\f579\"; }\r\n\r\n.la-fly:before {\r\n  content: \"\\f417\"; }\r\n\r\n.la-folder:before {\r\n  content: \"\\f07b\"; }\r\n\r\n.la-folder-minus:before {\r\n  content: \"\\f65d\"; }\r\n\r\n.la-folder-open:before {\r\n  content: \"\\f07c\"; }\r\n\r\n.la-folder-plus:before {\r\n  content: \"\\f65e\"; }\r\n\r\n.la-font:before {\r\n  content: \"\\f031\"; }\r\n\r\n.la-font-awesome:before {\r\n  content: \"\\f2b4\"; }\r\n\r\n.la-font-awesome-alt:before {\r\n  content: \"\\f35c\"; }\r\n\r\n.la-font-awesome-flag:before {\r\n  content: \"\\f425\"; }\r\n\r\n.la-font-awesome-logo-full:before {\r\n  content: \"\\f4e6\"; }\r\n\r\n.la-fonticons:before {\r\n  content: \"\\f280\"; }\r\n\r\n.la-fonticons-fi:before {\r\n  content: \"\\f3a2\"; }\r\n\r\n.la-football-ball:before {\r\n  content: \"\\f44e\"; }\r\n\r\n.la-fort-awesome:before {\r\n  content: \"\\f286\"; }\r\n\r\n.la-fort-awesome-alt:before {\r\n  content: \"\\f3a3\"; }\r\n\r\n.la-forumbee:before {\r\n  content: \"\\f211\"; }\r\n\r\n.la-forward:before {\r\n  content: \"\\f04e\"; }\r\n\r\n.la-foursquare:before {\r\n  content: \"\\f180\"; }\r\n\r\n.la-free-code-camp:before {\r\n  content: \"\\f2c5\"; }\r\n\r\n.la-freebsd:before {\r\n  content: \"\\f3a4\"; }\r\n\r\n.la-frog:before {\r\n  content: \"\\f52e\"; }\r\n\r\n.la-frown:before {\r\n  content: \"\\f119\"; }\r\n\r\n.la-frown-open:before {\r\n  content: \"\\f57a\"; }\r\n\r\n.la-fulcrum:before {\r\n  content: \"\\f50b\"; }\r\n\r\n.la-funnel-dollar:before {\r\n  content: \"\\f662\"; }\r\n\r\n.la-futbol:before {\r\n  content: \"\\f1e3\"; }\r\n\r\n.la-galactic-republic:before {\r\n  content: \"\\f50c\"; }\r\n\r\n.la-galactic-senate:before {\r\n  content: \"\\f50d\"; }\r\n\r\n.la-gamepad:before {\r\n  content: \"\\f11b\"; }\r\n\r\n.la-gas-pump:before {\r\n  content: \"\\f52f\"; }\r\n\r\n.la-gavel:before {\r\n  content: \"\\f0e3\"; }\r\n\r\n.la-gem:before {\r\n  content: \"\\f3a5\"; }\r\n\r\n.la-genderless:before {\r\n  content: \"\\f22d\"; }\r\n\r\n.la-get-pocket:before {\r\n  content: \"\\f265\"; }\r\n\r\n.la-gg:before {\r\n  content: \"\\f260\"; }\r\n\r\n.la-gg-circle:before {\r\n  content: \"\\f261\"; }\r\n\r\n.la-ghost:before {\r\n  content: \"\\f6e2\"; }\r\n\r\n.la-gift:before {\r\n  content: \"\\f06b\"; }\r\n\r\n.la-gifts:before {\r\n  content: \"\\f79c\"; }\r\n\r\n.la-git:before {\r\n  content: \"\\f1d3\"; }\r\n\r\n.la-git-alt:before {\r\n  content: \"\\f841\"; }\r\n\r\n.la-git-square:before {\r\n  content: \"\\f1d2\"; }\r\n\r\n.la-github:before {\r\n  content: \"\\f09b\"; }\r\n\r\n.la-github-alt:before {\r\n  content: \"\\f113\"; }\r\n\r\n.la-github-square:before {\r\n  content: \"\\f092\"; }\r\n\r\n.la-gitkraken:before {\r\n  content: \"\\f3a6\"; }\r\n\r\n.la-gitlab:before {\r\n  content: \"\\f296\"; }\r\n\r\n.la-gitter:before {\r\n  content: \"\\f426\"; }\r\n\r\n.la-glass-cheers:before {\r\n  content: \"\\f79f\"; }\r\n\r\n.la-glass-martini:before {\r\n  content: \"\\f000\"; }\r\n\r\n.la-glass-martini-alt:before {\r\n  content: \"\\f57b\"; }\r\n\r\n.la-glass-whiskey:before {\r\n  content: \"\\f7a0\"; }\r\n\r\n.la-glasses:before {\r\n  content: \"\\f530\"; }\r\n\r\n.la-glide:before {\r\n  content: \"\\f2a5\"; }\r\n\r\n.la-glide-g:before {\r\n  content: \"\\f2a6\"; }\r\n\r\n.la-globe:before {\r\n  content: \"\\f0ac\"; }\r\n\r\n.la-globe-africa:before {\r\n  content: \"\\f57c\"; }\r\n\r\n.la-globe-americas:before {\r\n  content: \"\\f57d\"; }\r\n\r\n.la-globe-asia:before {\r\n  content: \"\\f57e\"; }\r\n\r\n.la-globe-europe:before {\r\n  content: \"\\f7a2\"; }\r\n\r\n.la-gofore:before {\r\n  content: \"\\f3a7\"; }\r\n\r\n.la-golf-ball:before {\r\n  content: \"\\f450\"; }\r\n\r\n.la-goodreads:before {\r\n  content: \"\\f3a8\"; }\r\n\r\n.la-goodreads-g:before {\r\n  content: \"\\f3a9\"; }\r\n\r\n.la-google:before {\r\n  content: \"\\f1a0\"; }\r\n\r\n.la-google-drive:before {\r\n  content: \"\\f3aa\"; }\r\n\r\n.la-google-play:before {\r\n  content: \"\\f3ab\"; }\r\n\r\n.la-google-plus:before {\r\n  content: \"\\f2b3\"; }\r\n\r\n.la-google-plus-g:before {\r\n  content: \"\\f0d5\"; }\r\n\r\n.la-google-plus-square:before {\r\n  content: \"\\f0d4\"; }\r\n\r\n.la-google-wallet:before {\r\n  content: \"\\f1ee\"; }\r\n\r\n.la-gopuram:before {\r\n  content: \"\\f664\"; }\r\n\r\n.la-graduation-cap:before {\r\n  content: \"\\f19d\"; }\r\n\r\n.la-gratipay:before {\r\n  content: \"\\f184\"; }\r\n\r\n.la-grav:before {\r\n  content: \"\\f2d6\"; }\r\n\r\n.la-greater-than:before {\r\n  content: \"\\f531\"; }\r\n\r\n.la-greater-than-equal:before {\r\n  content: \"\\f532\"; }\r\n\r\n.la-grimace:before {\r\n  content: \"\\f57f\"; }\r\n\r\n.la-grin:before {\r\n  content: \"\\f580\"; }\r\n\r\n.la-grin-alt:before {\r\n  content: \"\\f581\"; }\r\n\r\n.la-grin-beam:before {\r\n  content: \"\\f582\"; }\r\n\r\n.la-grin-beam-sweat:before {\r\n  content: \"\\f583\"; }\r\n\r\n.la-grin-hearts:before {\r\n  content: \"\\f584\"; }\r\n\r\n.la-grin-squint:before {\r\n  content: \"\\f585\"; }\r\n\r\n.la-grin-squint-tears:before {\r\n  content: \"\\f586\"; }\r\n\r\n.la-grin-stars:before {\r\n  content: \"\\f587\"; }\r\n\r\n.la-grin-tears:before {\r\n  content: \"\\f588\"; }\r\n\r\n.la-grin-tongue:before {\r\n  content: \"\\f589\"; }\r\n\r\n.la-grin-tongue-squint:before {\r\n  content: \"\\f58a\"; }\r\n\r\n.la-grin-tongue-wink:before {\r\n  content: \"\\f58b\"; }\r\n\r\n.la-grin-wink:before {\r\n  content: \"\\f58c\"; }\r\n\r\n.la-grip-horizontal:before {\r\n  content: \"\\f58d\"; }\r\n\r\n.la-grip-lines:before {\r\n  content: \"\\f7a4\"; }\r\n\r\n.la-grip-lines-vertical:before {\r\n  content: \"\\f7a5\"; }\r\n\r\n.la-grip-vertical:before {\r\n  content: \"\\f58e\"; }\r\n\r\n.la-gripfire:before {\r\n  content: \"\\f3ac\"; }\r\n\r\n.la-grunt:before {\r\n  content: \"\\f3ad\"; }\r\n\r\n.la-guitar:before {\r\n  content: \"\\f7a6\"; }\r\n\r\n.la-gulp:before {\r\n  content: \"\\f3ae\"; }\r\n\r\n.la-h-square:before {\r\n  content: \"\\f0fd\"; }\r\n\r\n.la-hacker-news:before {\r\n  content: \"\\f1d4\"; }\r\n\r\n.la-hacker-news-square:before {\r\n  content: \"\\f3af\"; }\r\n\r\n.la-hackerrank:before {\r\n  content: \"\\f5f7\"; }\r\n\r\n.la-hamburger:before {\r\n  content: \"\\f805\"; }\r\n\r\n.la-hammer:before {\r\n  content: \"\\f6e3\"; }\r\n\r\n.la-hamsa:before {\r\n  content: \"\\f665\"; }\r\n\r\n.la-hand-holding:before {\r\n  content: \"\\f4bd\"; }\r\n\r\n.la-hand-holding-heart:before {\r\n  content: \"\\f4be\"; }\r\n\r\n.la-hand-holding-usd:before {\r\n  content: \"\\f4c0\"; }\r\n\r\n.la-hand-lizard:before {\r\n  content: \"\\f258\"; }\r\n\r\n.la-hand-middle-finger:before {\r\n  content: \"\\f806\"; }\r\n\r\n.la-hand-paper:before {\r\n  content: \"\\f256\"; }\r\n\r\n.la-hand-peace:before {\r\n  content: \"\\f25b\"; }\r\n\r\n.la-hand-point-down:before {\r\n  content: \"\\f0a7\"; }\r\n\r\n.la-hand-point-left:before {\r\n  content: \"\\f0a5\"; }\r\n\r\n.la-hand-point-right:before {\r\n  content: \"\\f0a4\"; }\r\n\r\n.la-hand-point-up:before {\r\n  content: \"\\f0a6\"; }\r\n\r\n.la-hand-pointer:before {\r\n  content: \"\\f25a\"; }\r\n\r\n.la-hand-rock:before {\r\n  content: \"\\f255\"; }\r\n\r\n.la-hand-scissors:before {\r\n  content: \"\\f257\"; }\r\n\r\n.la-hand-spock:before {\r\n  content: \"\\f259\"; }\r\n\r\n.la-hands:before {\r\n  content: \"\\f4c2\"; }\r\n\r\n.la-hands-helping:before {\r\n  content: \"\\f4c4\"; }\r\n\r\n.la-handshake:before {\r\n  content: \"\\f2b5\"; }\r\n\r\n.la-hanukiah:before {\r\n  content: \"\\f6e6\"; }\r\n\r\n.la-hard-hat:before {\r\n  content: \"\\f807\"; }\r\n\r\n.la-hashtag:before {\r\n  content: \"\\f292\"; }\r\n\r\n.la-hat-cowboy:before {\r\n  content: \"\\f8c0\"; }\r\n\r\n.la-hat-cowboy-side:before {\r\n  content: \"\\f8c1\"; }\r\n\r\n.la-hat-wizard:before {\r\n  content: \"\\f6e8\"; }\r\n\r\n.la-haykal:before {\r\n  content: \"\\f666\"; }\r\n\r\n.la-hdd:before {\r\n  content: \"\\f0a0\"; }\r\n\r\n.la-heading:before {\r\n  content: \"\\f1dc\"; }\r\n\r\n.la-headphones:before {\r\n  content: \"\\f025\"; }\r\n\r\n.la-headphones-alt:before {\r\n  content: \"\\f58f\"; }\r\n\r\n.la-headset:before {\r\n  content: \"\\f590\"; }\r\n\r\n.la-heart:before {\r\n  content: \"\\f004\"; }\r\n\r\n.la-heart-broken:before {\r\n  content: \"\\f7a9\"; }\r\n\r\n.la-heartbeat:before {\r\n  content: \"\\f21e\"; }\r\n\r\n.la-helicopter:before {\r\n  content: \"\\f533\"; }\r\n\r\n.la-highlighter:before {\r\n  content: \"\\f591\"; }\r\n\r\n.la-hiking:before {\r\n  content: \"\\f6ec\"; }\r\n\r\n.la-hippo:before {\r\n  content: \"\\f6ed\"; }\r\n\r\n.la-hips:before {\r\n  content: \"\\f452\"; }\r\n\r\n.la-hire-a-helper:before {\r\n  content: \"\\f3b0\"; }\r\n\r\n.la-history:before {\r\n  content: \"\\f1da\"; }\r\n\r\n.la-hockey-puck:before {\r\n  content: \"\\f453\"; }\r\n\r\n.la-holly-berry:before {\r\n  content: \"\\f7aa\"; }\r\n\r\n.la-home:before {\r\n  content: \"\\f015\"; }\r\n\r\n.la-hooli:before {\r\n  content: \"\\f427\"; }\r\n\r\n.la-hornbill:before {\r\n  content: \"\\f592\"; }\r\n\r\n.la-horse:before {\r\n  content: \"\\f6f0\"; }\r\n\r\n.la-horse-head:before {\r\n  content: \"\\f7ab\"; }\r\n\r\n.la-hospital:before {\r\n  content: \"\\f0f8\"; }\r\n\r\n.la-hospital-alt:before {\r\n  content: \"\\f47d\"; }\r\n\r\n.la-hospital-symbol:before {\r\n  content: \"\\f47e\"; }\r\n\r\n.la-hot-tub:before {\r\n  content: \"\\f593\"; }\r\n\r\n.la-hotdog:before {\r\n  content: \"\\f80f\"; }\r\n\r\n.la-hotel:before {\r\n  content: \"\\f594\"; }\r\n\r\n.la-hotjar:before {\r\n  content: \"\\f3b1\"; }\r\n\r\n.la-hourglass:before {\r\n  content: \"\\f254\"; }\r\n\r\n.la-hourglass-end:before {\r\n  content: \"\\f253\"; }\r\n\r\n.la-hourglass-half:before {\r\n  content: \"\\f252\"; }\r\n\r\n.la-hourglass-start:before {\r\n  content: \"\\f251\"; }\r\n\r\n.la-house-damage:before {\r\n  content: \"\\f6f1\"; }\r\n\r\n.la-houzz:before {\r\n  content: \"\\f27c\"; }\r\n\r\n.la-hryvnia:before {\r\n  content: \"\\f6f2\"; }\r\n\r\n.la-html5:before {\r\n  content: \"\\f13b\"; }\r\n\r\n.la-hubspot:before {\r\n  content: \"\\f3b2\"; }\r\n\r\n.la-i-cursor:before {\r\n  content: \"\\f246\"; }\r\n\r\n.la-ice-cream:before {\r\n  content: \"\\f810\"; }\r\n\r\n.la-icicles:before {\r\n  content: \"\\f7ad\"; }\r\n\r\n.la-icons:before {\r\n  content: \"\\f86d\"; }\r\n\r\n.la-id-badge:before {\r\n  content: \"\\f2c1\"; }\r\n\r\n.la-id-card:before {\r\n  content: \"\\f2c2\"; }\r\n\r\n.la-id-card-alt:before {\r\n  content: \"\\f47f\"; }\r\n\r\n.la-igloo:before {\r\n  content: \"\\f7ae\"; }\r\n\r\n.la-image:before {\r\n  content: \"\\f03e\"; }\r\n\r\n.la-images:before {\r\n  content: \"\\f302\"; }\r\n\r\n.la-imdb:before {\r\n  content: \"\\f2d8\"; }\r\n\r\n.la-inbox:before {\r\n  content: \"\\f01c\"; }\r\n\r\n.la-indent:before {\r\n  content: \"\\f03c\"; }\r\n\r\n.la-industry:before {\r\n  content: \"\\f275\"; }\r\n\r\n.la-infinity:before {\r\n  content: \"\\f534\"; }\r\n\r\n.la-info:before {\r\n  content: \"\\f129\"; }\r\n\r\n.la-info-circle:before {\r\n  content: \"\\f05a\"; }\r\n\r\n.la-instagram:before {\r\n  content: \"\\f16d\"; }\r\n\r\n.la-intercom:before {\r\n  content: \"\\f7af\"; }\r\n\r\n.la-internet-explorer:before {\r\n  content: \"\\f26b\"; }\r\n\r\n.la-invision:before {\r\n  content: \"\\f7b0\"; }\r\n\r\n.la-ioxhost:before {\r\n  content: \"\\f208\"; }\r\n\r\n.la-italic:before {\r\n  content: \"\\f033\"; }\r\n\r\n.la-itch-io:before {\r\n  content: \"\\f83a\"; }\r\n\r\n.la-itunes:before {\r\n  content: \"\\f3b4\"; }\r\n\r\n.la-itunes-note:before {\r\n  content: \"\\f3b5\"; }\r\n\r\n.la-java:before {\r\n  content: \"\\f4e4\"; }\r\n\r\n.la-jedi:before {\r\n  content: \"\\f669\"; }\r\n\r\n.la-jedi-order:before {\r\n  content: \"\\f50e\"; }\r\n\r\n.la-jenkins:before {\r\n  content: \"\\f3b6\"; }\r\n\r\n.la-jira:before {\r\n  content: \"\\f7b1\"; }\r\n\r\n.la-joget:before {\r\n  content: \"\\f3b7\"; }\r\n\r\n.la-joint:before {\r\n  content: \"\\f595\"; }\r\n\r\n.la-joomla:before {\r\n  content: \"\\f1aa\"; }\r\n\r\n.la-journal-whills:before {\r\n  content: \"\\f66a\"; }\r\n\r\n.la-js:before {\r\n  content: \"\\f3b8\"; }\r\n\r\n.la-js-square:before {\r\n  content: \"\\f3b9\"; }\r\n\r\n.la-jsfiddle:before {\r\n  content: \"\\f1cc\"; }\r\n\r\n.la-kaaba:before {\r\n  content: \"\\f66b\"; }\r\n\r\n.la-kaggle:before {\r\n  content: \"\\f5fa\"; }\r\n\r\n.la-key:before {\r\n  content: \"\\f084\"; }\r\n\r\n.la-keybase:before {\r\n  content: \"\\f4f5\"; }\r\n\r\n.la-keyboard:before {\r\n  content: \"\\f11c\"; }\r\n\r\n.la-keycdn:before {\r\n  content: \"\\f3ba\"; }\r\n\r\n.la-khanda:before {\r\n  content: \"\\f66d\"; }\r\n\r\n.la-kickstarter:before {\r\n  content: \"\\f3bb\"; }\r\n\r\n.la-kickstarter-k:before {\r\n  content: \"\\f3bc\"; }\r\n\r\n.la-kiss:before {\r\n  content: \"\\f596\"; }\r\n\r\n.la-kiss-beam:before {\r\n  content: \"\\f597\"; }\r\n\r\n.la-kiss-wink-heart:before {\r\n  content: \"\\f598\"; }\r\n\r\n.la-kiwi-bird:before {\r\n  content: \"\\f535\"; }\r\n\r\n.la-korvue:before {\r\n  content: \"\\f42f\"; }\r\n\r\n.la-landmark:before {\r\n  content: \"\\f66f\"; }\r\n\r\n.la-language:before {\r\n  content: \"\\f1ab\"; }\r\n\r\n.la-laptop:before {\r\n  content: \"\\f109\"; }\r\n\r\n.la-laptop-code:before {\r\n  content: \"\\f5fc\"; }\r\n\r\n.la-laptop-medical:before {\r\n  content: \"\\f812\"; }\r\n\r\n.la-laravel:before {\r\n  content: \"\\f3bd\"; }\r\n\r\n.la-lastfm:before {\r\n  content: \"\\f202\"; }\r\n\r\n.la-lastfm-square:before {\r\n  content: \"\\f203\"; }\r\n\r\n.la-laugh:before {\r\n  content: \"\\f599\"; }\r\n\r\n.la-laugh-beam:before {\r\n  content: \"\\f59a\"; }\r\n\r\n.la-laugh-squint:before {\r\n  content: \"\\f59b\"; }\r\n\r\n.la-laugh-wink:before {\r\n  content: \"\\f59c\"; }\r\n\r\n.la-layer-group:before {\r\n  content: \"\\f5fd\"; }\r\n\r\n.la-leaf:before {\r\n  content: \"\\f06c\"; }\r\n\r\n.la-leanpub:before {\r\n  content: \"\\f212\"; }\r\n\r\n.la-lemon:before {\r\n  content: \"\\f094\"; }\r\n\r\n.la-less:before {\r\n  content: \"\\f41d\"; }\r\n\r\n.la-less-than:before {\r\n  content: \"\\f536\"; }\r\n\r\n.la-less-than-equal:before {\r\n  content: \"\\f537\"; }\r\n\r\n.la-level-down-alt:before {\r\n  content: \"\\f3be\"; }\r\n\r\n.la-level-up-alt:before {\r\n  content: \"\\f3bf\"; }\r\n\r\n.la-life-ring:before {\r\n  content: \"\\f1cd\"; }\r\n\r\n.la-lightbulb:before {\r\n  content: \"\\f0eb\"; }\r\n\r\n.la-line:before {\r\n  content: \"\\f3c0\"; }\r\n\r\n.la-link:before {\r\n  content: \"\\f0c1\"; }\r\n\r\n.la-linkedin:before {\r\n  content: \"\\f08c\"; }\r\n\r\n.la-linkedin-in:before {\r\n  content: \"\\f0e1\"; }\r\n\r\n.la-linode:before {\r\n  content: \"\\f2b8\"; }\r\n\r\n.la-linux:before {\r\n  content: \"\\f17c\"; }\r\n\r\n.la-lira-sign:before {\r\n  content: \"\\f195\"; }\r\n\r\n.la-list:before {\r\n  content: \"\\f03a\"; }\r\n\r\n.la-list-alt:before {\r\n  content: \"\\f022\"; }\r\n\r\n.la-list-ol:before {\r\n  content: \"\\f0cb\"; }\r\n\r\n.la-list-ul:before {\r\n  content: \"\\f0ca\"; }\r\n\r\n.la-location-arrow:before {\r\n  content: \"\\f124\"; }\r\n\r\n.la-lock:before {\r\n  content: \"\\f023\"; }\r\n\r\n.la-lock-open:before {\r\n  content: \"\\f3c1\"; }\r\n\r\n.la-long-arrow-alt-down:before {\r\n  content: \"\\f309\"; }\r\n\r\n.la-long-arrow-alt-left:before {\r\n  content: \"\\f30a\"; }\r\n\r\n.la-long-arrow-alt-right:before {\r\n  content: \"\\f30b\"; }\r\n\r\n.la-long-arrow-alt-up:before {\r\n  content: \"\\f30c\"; }\r\n\r\n.la-low-vision:before {\r\n  content: \"\\f2a8\"; }\r\n\r\n.la-luggage-cart:before {\r\n  content: \"\\f59d\"; }\r\n\r\n.la-lyft:before {\r\n  content: \"\\f3c3\"; }\r\n\r\n.la-magento:before {\r\n  content: \"\\f3c4\"; }\r\n\r\n.la-magic:before {\r\n  content: \"\\f0d0\"; }\r\n\r\n.la-magnet:before {\r\n  content: \"\\f076\"; }\r\n\r\n.la-mail-bulk:before {\r\n  content: \"\\f674\"; }\r\n\r\n.la-mailchimp:before {\r\n  content: \"\\f59e\"; }\r\n\r\n.la-male:before {\r\n  content: \"\\f183\"; }\r\n\r\n.la-mandalorian:before {\r\n  content: \"\\f50f\"; }\r\n\r\n.la-map:before {\r\n  content: \"\\f279\"; }\r\n\r\n.la-map-marked:before {\r\n  content: \"\\f59f\"; }\r\n\r\n.la-map-marked-alt:before {\r\n  content: \"\\f5a0\"; }\r\n\r\n.la-map-marker:before {\r\n  content: \"\\f041\"; }\r\n\r\n.la-map-marker-alt:before {\r\n  content: \"\\f3c5\"; }\r\n\r\n.la-map-pin:before {\r\n  content: \"\\f276\"; }\r\n\r\n.la-map-signs:before {\r\n  content: \"\\f277\"; }\r\n\r\n.la-markdown:before {\r\n  content: \"\\f60f\"; }\r\n\r\n.la-marker:before {\r\n  content: \"\\f5a1\"; }\r\n\r\n.la-mars:before {\r\n  content: \"\\f222\"; }\r\n\r\n.la-mars-double:before {\r\n  content: \"\\f227\"; }\r\n\r\n.la-mars-stroke:before {\r\n  content: \"\\f229\"; }\r\n\r\n.la-mars-stroke-h:before {\r\n  content: \"\\f22b\"; }\r\n\r\n.la-mars-stroke-v:before {\r\n  content: \"\\f22a\"; }\r\n\r\n.la-mask:before {\r\n  content: \"\\f6fa\"; }\r\n\r\n.la-mastodon:before {\r\n  content: \"\\f4f6\"; }\r\n\r\n.la-maxcdn:before {\r\n  content: \"\\f136\"; }\r\n\r\n.la-mdb:before {\r\n  content: \"\\f8ca\"; }\r\n\r\n.la-medal:before {\r\n  content: \"\\f5a2\"; }\r\n\r\n.la-medapps:before {\r\n  content: \"\\f3c6\"; }\r\n\r\n.la-medium:before {\r\n  content: \"\\f23a\"; }\r\n\r\n.la-medium-m:before {\r\n  content: \"\\f3c7\"; }\r\n\r\n.la-medkit:before {\r\n  content: \"\\f0fa\"; }\r\n\r\n.la-medrt:before {\r\n  content: \"\\f3c8\"; }\r\n\r\n.la-meetup:before {\r\n  content: \"\\f2e0\"; }\r\n\r\n.la-megaport:before {\r\n  content: \"\\f5a3\"; }\r\n\r\n.la-meh:before {\r\n  content: \"\\f11a\"; }\r\n\r\n.la-meh-blank:before {\r\n  content: \"\\f5a4\"; }\r\n\r\n.la-meh-rolling-eyes:before {\r\n  content: \"\\f5a5\"; }\r\n\r\n.la-memory:before {\r\n  content: \"\\f538\"; }\r\n\r\n.la-mendeley:before {\r\n  content: \"\\f7b3\"; }\r\n\r\n.la-menorah:before {\r\n  content: \"\\f676\"; }\r\n\r\n.la-mercury:before {\r\n  content: \"\\f223\"; }\r\n\r\n.la-meteor:before {\r\n  content: \"\\f753\"; }\r\n\r\n.la-microchip:before {\r\n  content: \"\\f2db\"; }\r\n\r\n.la-microphone:before {\r\n  content: \"\\f130\"; }\r\n\r\n.la-microphone-alt:before {\r\n  content: \"\\f3c9\"; }\r\n\r\n.la-microphone-alt-slash:before {\r\n  content: \"\\f539\"; }\r\n\r\n.la-microphone-slash:before {\r\n  content: \"\\f131\"; }\r\n\r\n.la-microscope:before {\r\n  content: \"\\f610\"; }\r\n\r\n.la-microsoft:before {\r\n  content: \"\\f3ca\"; }\r\n\r\n.la-minus:before {\r\n  content: \"\\f068\"; }\r\n\r\n.la-minus-circle:before {\r\n  content: \"\\f056\"; }\r\n\r\n.la-minus-square:before {\r\n  content: \"\\f146\"; }\r\n\r\n.la-mitten:before {\r\n  content: \"\\f7b5\"; }\r\n\r\n.la-mix:before {\r\n  content: \"\\f3cb\"; }\r\n\r\n.la-mixcloud:before {\r\n  content: \"\\f289\"; }\r\n\r\n.la-mizuni:before {\r\n  content: \"\\f3cc\"; }\r\n\r\n.la-mobile:before {\r\n  content: \"\\f10b\"; }\r\n\r\n.la-mobile-alt:before {\r\n  content: \"\\f3cd\"; }\r\n\r\n.la-modx:before {\r\n  content: \"\\f285\"; }\r\n\r\n.la-monero:before {\r\n  content: \"\\f3d0\"; }\r\n\r\n.la-money-bill:before {\r\n  content: \"\\f0d6\"; }\r\n\r\n.la-money-bill-alt:before {\r\n  content: \"\\f3d1\"; }\r\n\r\n.la-money-bill-wave:before {\r\n  content: \"\\f53a\"; }\r\n\r\n.la-money-bill-wave-alt:before {\r\n  content: \"\\f53b\"; }\r\n\r\n.la-money-check:before {\r\n  content: \"\\f53c\"; }\r\n\r\n.la-money-check-alt:before {\r\n  content: \"\\f53d\"; }\r\n\r\n.la-monument:before {\r\n  content: \"\\f5a6\"; }\r\n\r\n.la-moon:before {\r\n  content: \"\\f186\"; }\r\n\r\n.la-mortar-pestle:before {\r\n  content: \"\\f5a7\"; }\r\n\r\n.la-mosque:before {\r\n  content: \"\\f678\"; }\r\n\r\n.la-motorcycle:before {\r\n  content: \"\\f21c\"; }\r\n\r\n.la-mountain:before {\r\n  content: \"\\f6fc\"; }\r\n\r\n.la-mouse:before {\r\n  content: \"\\f8cc\"; }\r\n\r\n.la-mouse-pointer:before {\r\n  content: \"\\f245\"; }\r\n\r\n.la-mug-hot:before {\r\n  content: \"\\f7b6\"; }\r\n\r\n.la-music:before {\r\n  content: \"\\f001\"; }\r\n\r\n.la-napster:before {\r\n  content: \"\\f3d2\"; }\r\n\r\n.la-neos:before {\r\n  content: \"\\f612\"; }\r\n\r\n.la-network-wired:before {\r\n  content: \"\\f6ff\"; }\r\n\r\n.la-neuter:before {\r\n  content: \"\\f22c\"; }\r\n\r\n.la-newspaper:before {\r\n  content: \"\\f1ea\"; }\r\n\r\n.la-nimblr:before {\r\n  content: \"\\f5a8\"; }\r\n\r\n.la-node:before {\r\n  content: \"\\f419\"; }\r\n\r\n.la-node-js:before {\r\n  content: \"\\f3d3\"; }\r\n\r\n.la-not-equal:before {\r\n  content: \"\\f53e\"; }\r\n\r\n.la-notes-medical:before {\r\n  content: \"\\f481\"; }\r\n\r\n.la-npm:before {\r\n  content: \"\\f3d4\"; }\r\n\r\n.la-ns8:before {\r\n  content: \"\\f3d5\"; }\r\n\r\n.la-nutritionix:before {\r\n  content: \"\\f3d6\"; }\r\n\r\n.la-object-group:before {\r\n  content: \"\\f247\"; }\r\n\r\n.la-object-ungroup:before {\r\n  content: \"\\f248\"; }\r\n\r\n.la-odnoklassniki:before {\r\n  content: \"\\f263\"; }\r\n\r\n.la-odnoklassniki-square:before {\r\n  content: \"\\f264\"; }\r\n\r\n.la-oil-can:before {\r\n  content: \"\\f613\"; }\r\n\r\n.la-old-republic:before {\r\n  content: \"\\f510\"; }\r\n\r\n.la-om:before {\r\n  content: \"\\f679\"; }\r\n\r\n.la-opencart:before {\r\n  content: \"\\f23d\"; }\r\n\r\n.la-openid:before {\r\n  content: \"\\f19b\"; }\r\n\r\n.la-opera:before {\r\n  content: \"\\f26a\"; }\r\n\r\n.la-optin-monster:before {\r\n  content: \"\\f23c\"; }\r\n\r\n.la-orcid:before {\r\n  content: \"\\f8d2\"; }\r\n\r\n.la-osi:before {\r\n  content: \"\\f41a\"; }\r\n\r\n.la-otter:before {\r\n  content: \"\\f700\"; }\r\n\r\n.la-outdent:before {\r\n  content: \"\\f03b\"; }\r\n\r\n.la-page4:before {\r\n  content: \"\\f3d7\"; }\r\n\r\n.la-pagelines:before {\r\n  content: \"\\f18c\"; }\r\n\r\n.la-pager:before {\r\n  content: \"\\f815\"; }\r\n\r\n.la-paint-brush:before {\r\n  content: \"\\f1fc\"; }\r\n\r\n.la-paint-roller:before {\r\n  content: \"\\f5aa\"; }\r\n\r\n.la-palette:before {\r\n  content: \"\\f53f\"; }\r\n\r\n.la-palfed:before {\r\n  content: \"\\f3d8\"; }\r\n\r\n.la-pallet:before {\r\n  content: \"\\f482\"; }\r\n\r\n.la-paper-plane:before {\r\n  content: \"\\f1d8\"; }\r\n\r\n.la-paperclip:before {\r\n  content: \"\\f0c6\"; }\r\n\r\n.la-parachute-box:before {\r\n  content: \"\\f4cd\"; }\r\n\r\n.la-paragraph:before {\r\n  content: \"\\f1dd\"; }\r\n\r\n.la-parking:before {\r\n  content: \"\\f540\"; }\r\n\r\n.la-passport:before {\r\n  content: \"\\f5ab\"; }\r\n\r\n.la-pastafarianism:before {\r\n  content: \"\\f67b\"; }\r\n\r\n.la-paste:before {\r\n  content: \"\\f0ea\"; }\r\n\r\n.la-patreon:before {\r\n  content: \"\\f3d9\"; }\r\n\r\n.la-pause:before {\r\n  content: \"\\f04c\"; }\r\n\r\n.la-pause-circle:before {\r\n  content: \"\\f28b\"; }\r\n\r\n.la-paw:before {\r\n  content: \"\\f1b0\"; }\r\n\r\n.la-paypal:before {\r\n  content: \"\\f1ed\"; }\r\n\r\n.la-peace:before {\r\n  content: \"\\f67c\"; }\r\n\r\n.la-pen:before {\r\n  content: \"\\f304\"; }\r\n\r\n.la-pen-alt:before {\r\n  content: \"\\f305\"; }\r\n\r\n.la-pen-fancy:before {\r\n  content: \"\\f5ac\"; }\r\n\r\n.la-pen-nib:before {\r\n  content: \"\\f5ad\"; }\r\n\r\n.la-pen-square:before {\r\n  content: \"\\f14b\"; }\r\n\r\n.la-pencil-alt:before {\r\n  content: \"\\f303\"; }\r\n\r\n.la-pencil-ruler:before {\r\n  content: \"\\f5ae\"; }\r\n\r\n.la-penny-arcade:before {\r\n  content: \"\\f704\"; }\r\n\r\n.la-people-carry:before {\r\n  content: \"\\f4ce\"; }\r\n\r\n.la-pepper-hot:before {\r\n  content: \"\\f816\"; }\r\n\r\n.la-percent:before {\r\n  content: \"\\f295\"; }\r\n\r\n.la-percentage:before {\r\n  content: \"\\f541\"; }\r\n\r\n.la-periscope:before {\r\n  content: \"\\f3da\"; }\r\n\r\n.la-person-booth:before {\r\n  content: \"\\f756\"; }\r\n\r\n.la-phabricator:before {\r\n  content: \"\\f3db\"; }\r\n\r\n.la-phoenix-framework:before {\r\n  content: \"\\f3dc\"; }\r\n\r\n.la-phoenix-squadron:before {\r\n  content: \"\\f511\"; }\r\n\r\n.la-phone:before {\r\n  content: \"\\f095\"; }\r\n\r\n.la-phone-alt:before {\r\n  content: \"\\f879\"; }\r\n\r\n.la-phone-slash:before {\r\n  content: \"\\f3dd\"; }\r\n\r\n.la-phone-square:before {\r\n  content: \"\\f098\"; }\r\n\r\n.la-phone-square-alt:before {\r\n  content: \"\\f87b\"; }\r\n\r\n.la-phone-volume:before {\r\n  content: \"\\f2a0\"; }\r\n\r\n.la-photo-video:before {\r\n  content: \"\\f87c\"; }\r\n\r\n.la-php:before {\r\n  content: \"\\f457\"; }\r\n\r\n.la-pied-piper:before {\r\n  content: \"\\f2ae\"; }\r\n\r\n.la-pied-piper-alt:before {\r\n  content: \"\\f1a8\"; }\r\n\r\n.la-pied-piper-hat:before {\r\n  content: \"\\f4e5\"; }\r\n\r\n.la-pied-piper-pp:before {\r\n  content: \"\\f1a7\"; }\r\n\r\n.la-piggy-bank:before {\r\n  content: \"\\f4d3\"; }\r\n\r\n.la-pills:before {\r\n  content: \"\\f484\"; }\r\n\r\n.la-pinterest:before {\r\n  content: \"\\f0d2\"; }\r\n\r\n.la-pinterest-p:before {\r\n  content: \"\\f231\"; }\r\n\r\n.la-pinterest-square:before {\r\n  content: \"\\f0d3\"; }\r\n\r\n.la-pizza-slice:before {\r\n  content: \"\\f818\"; }\r\n\r\n.la-place-of-worship:before {\r\n  content: \"\\f67f\"; }\r\n\r\n.la-plane:before {\r\n  content: \"\\f072\"; }\r\n\r\n.la-plane-arrival:before {\r\n  content: \"\\f5af\"; }\r\n\r\n.la-plane-departure:before {\r\n  content: \"\\f5b0\"; }\r\n\r\n.la-play:before {\r\n  content: \"\\f04b\"; }\r\n\r\n.la-play-circle:before {\r\n  content: \"\\f144\"; }\r\n\r\n.la-playstation:before {\r\n  content: \"\\f3df\"; }\r\n\r\n.la-plug:before {\r\n  content: \"\\f1e6\"; }\r\n\r\n.la-plus:before {\r\n  content: \"\\f067\"; }\r\n\r\n.la-plus-circle:before {\r\n  content: \"\\f055\"; }\r\n\r\n.la-plus-square:before {\r\n  content: \"\\f0fe\"; }\r\n\r\n.la-podcast:before {\r\n  content: \"\\f2ce\"; }\r\n\r\n.la-poll:before {\r\n  content: \"\\f681\"; }\r\n\r\n.la-poll-h:before {\r\n  content: \"\\f682\"; }\r\n\r\n.la-poo:before {\r\n  content: \"\\f2fe\"; }\r\n\r\n.la-poo-storm:before {\r\n  content: \"\\f75a\"; }\r\n\r\n.la-poop:before {\r\n  content: \"\\f619\"; }\r\n\r\n.la-portrait:before {\r\n  content: \"\\f3e0\"; }\r\n\r\n.la-pound-sign:before {\r\n  content: \"\\f154\"; }\r\n\r\n.la-power-off:before {\r\n  content: \"\\f011\"; }\r\n\r\n.la-pray:before {\r\n  content: \"\\f683\"; }\r\n\r\n.la-praying-hands:before {\r\n  content: \"\\f684\"; }\r\n\r\n.la-prescription:before {\r\n  content: \"\\f5b1\"; }\r\n\r\n.la-prescription-bottle:before {\r\n  content: \"\\f485\"; }\r\n\r\n.la-prescription-bottle-alt:before {\r\n  content: \"\\f486\"; }\r\n\r\n.la-print:before {\r\n  content: \"\\f02f\"; }\r\n\r\n.la-procedures:before {\r\n  content: \"\\f487\"; }\r\n\r\n.la-product-hunt:before {\r\n  content: \"\\f288\"; }\r\n\r\n.la-project-diagram:before {\r\n  content: \"\\f542\"; }\r\n\r\n.la-pushed:before {\r\n  content: \"\\f3e1\"; }\r\n\r\n.la-puzzle-piece:before {\r\n  content: \"\\f12e\"; }\r\n\r\n.la-python:before {\r\n  content: \"\\f3e2\"; }\r\n\r\n.la-qq:before {\r\n  content: \"\\f1d6\"; }\r\n\r\n.la-qrcode:before {\r\n  content: \"\\f029\"; }\r\n\r\n.la-question:before {\r\n  content: \"\\f128\"; }\r\n\r\n.la-question-circle:before {\r\n  content: \"\\f059\"; }\r\n\r\n.la-quidditch:before {\r\n  content: \"\\f458\"; }\r\n\r\n.la-quinscape:before {\r\n  content: \"\\f459\"; }\r\n\r\n.la-quora:before {\r\n  content: \"\\f2c4\"; }\r\n\r\n.la-quote-left:before {\r\n  content: \"\\f10d\"; }\r\n\r\n.la-quote-right:before {\r\n  content: \"\\f10e\"; }\r\n\r\n.la-quran:before {\r\n  content: \"\\f687\"; }\r\n\r\n.la-r-project:before {\r\n  content: \"\\f4f7\"; }\r\n\r\n.la-radiation:before {\r\n  content: \"\\f7b9\"; }\r\n\r\n.la-radiation-alt:before {\r\n  content: \"\\f7ba\"; }\r\n\r\n.la-rainbow:before {\r\n  content: \"\\f75b\"; }\r\n\r\n.la-random:before {\r\n  content: \"\\f074\"; }\r\n\r\n.la-raspberry-pi:before {\r\n  content: \"\\f7bb\"; }\r\n\r\n.la-ravelry:before {\r\n  content: \"\\f2d9\"; }\r\n\r\n.la-react:before {\r\n  content: \"\\f41b\"; }\r\n\r\n.la-reacteurope:before {\r\n  content: \"\\f75d\"; }\r\n\r\n.la-readme:before {\r\n  content: \"\\f4d5\"; }\r\n\r\n.la-rebel:before {\r\n  content: \"\\f1d0\"; }\r\n\r\n.la-receipt:before {\r\n  content: \"\\f543\"; }\r\n\r\n.la-record-vinyl:before {\r\n  content: \"\\f8d9\"; }\r\n\r\n.la-recycle:before {\r\n  content: \"\\f1b8\"; }\r\n\r\n.la-red-river:before {\r\n  content: \"\\f3e3\"; }\r\n\r\n.la-reddit:before {\r\n  content: \"\\f1a1\"; }\r\n\r\n.la-reddit-alien:before {\r\n  content: \"\\f281\"; }\r\n\r\n.la-reddit-square:before {\r\n  content: \"\\f1a2\"; }\r\n\r\n.la-redhat:before {\r\n  content: \"\\f7bc\"; }\r\n\r\n.la-redo:before {\r\n  content: \"\\f01e\"; }\r\n\r\n.la-redo-alt:before {\r\n  content: \"\\f2f9\"; }\r\n\r\n.la-registered:before {\r\n  content: \"\\f25d\"; }\r\n\r\n.la-remove-format:before {\r\n  content: \"\\f87d\"; }\r\n\r\n.la-renren:before {\r\n  content: \"\\f18b\"; }\r\n\r\n.la-reply:before {\r\n  content: \"\\f3e5\"; }\r\n\r\n.la-reply-all:before {\r\n  content: \"\\f122\"; }\r\n\r\n.la-replyd:before {\r\n  content: \"\\f3e6\"; }\r\n\r\n.la-republican:before {\r\n  content: \"\\f75e\"; }\r\n\r\n.la-researchgate:before {\r\n  content: \"\\f4f8\"; }\r\n\r\n.la-resolving:before {\r\n  content: \"\\f3e7\"; }\r\n\r\n.la-restroom:before {\r\n  content: \"\\f7bd\"; }\r\n\r\n.la-retweet:before {\r\n  content: \"\\f079\"; }\r\n\r\n.la-rev:before {\r\n  content: \"\\f5b2\"; }\r\n\r\n.la-ribbon:before {\r\n  content: \"\\f4d6\"; }\r\n\r\n.la-ring:before {\r\n  content: \"\\f70b\"; }\r\n\r\n.la-road:before {\r\n  content: \"\\f018\"; }\r\n\r\n.la-robot:before {\r\n  content: \"\\f544\"; }\r\n\r\n.la-rocket:before {\r\n  content: \"\\f135\"; }\r\n\r\n.la-rocketchat:before {\r\n  content: \"\\f3e8\"; }\r\n\r\n.la-rockrms:before {\r\n  content: \"\\f3e9\"; }\r\n\r\n.la-route:before {\r\n  content: \"\\f4d7\"; }\r\n\r\n.la-rss:before {\r\n  content: \"\\f09e\"; }\r\n\r\n.la-rss-square:before {\r\n  content: \"\\f143\"; }\r\n\r\n.la-ruble-sign:before {\r\n  content: \"\\f158\"; }\r\n\r\n.la-ruler:before {\r\n  content: \"\\f545\"; }\r\n\r\n.la-ruler-combined:before {\r\n  content: \"\\f546\"; }\r\n\r\n.la-ruler-horizontal:before {\r\n  content: \"\\f547\"; }\r\n\r\n.la-ruler-vertical:before {\r\n  content: \"\\f548\"; }\r\n\r\n.la-running:before {\r\n  content: \"\\f70c\"; }\r\n\r\n.la-rupee-sign:before {\r\n  content: \"\\f156\"; }\r\n\r\n.la-sad-cry:before {\r\n  content: \"\\f5b3\"; }\r\n\r\n.la-sad-tear:before {\r\n  content: \"\\f5b4\"; }\r\n\r\n.la-safari:before {\r\n  content: \"\\f267\"; }\r\n\r\n.la-salesforce:before {\r\n  content: \"\\f83b\"; }\r\n\r\n.la-sass:before {\r\n  content: \"\\f41e\"; }\r\n\r\n.la-satellite:before {\r\n  content: \"\\f7bf\"; }\r\n\r\n.la-satellite-dish:before {\r\n  content: \"\\f7c0\"; }\r\n\r\n.la-save:before {\r\n  content: \"\\f0c7\"; }\r\n\r\n.la-schlix:before {\r\n  content: \"\\f3ea\"; }\r\n\r\n.la-school:before {\r\n  content: \"\\f549\"; }\r\n\r\n.la-screwdriver:before {\r\n  content: \"\\f54a\"; }\r\n\r\n.la-scribd:before {\r\n  content: \"\\f28a\"; }\r\n\r\n.la-scroll:before {\r\n  content: \"\\f70e\"; }\r\n\r\n.la-sd-card:before {\r\n  content: \"\\f7c2\"; }\r\n\r\n.la-search:before {\r\n  content: \"\\f002\"; }\r\n\r\n.la-search-dollar:before {\r\n  content: \"\\f688\"; }\r\n\r\n.la-search-location:before {\r\n  content: \"\\f689\"; }\r\n\r\n.la-search-minus:before {\r\n  content: \"\\f010\"; }\r\n\r\n.la-search-plus:before {\r\n  content: \"\\f00e\"; }\r\n\r\n.la-searchengin:before {\r\n  content: \"\\f3eb\"; }\r\n\r\n.la-seedling:before {\r\n  content: \"\\f4d8\"; }\r\n\r\n.la-sellcast:before {\r\n  content: \"\\f2da\"; }\r\n\r\n.la-sellsy:before {\r\n  content: \"\\f213\"; }\r\n\r\n.la-server:before {\r\n  content: \"\\f233\"; }\r\n\r\n.la-servicestack:before {\r\n  content: \"\\f3ec\"; }\r\n\r\n.la-shapes:before {\r\n  content: \"\\f61f\"; }\r\n\r\n.la-share:before {\r\n  content: \"\\f064\"; }\r\n\r\n.la-share-alt:before {\r\n  content: \"\\f1e0\"; }\r\n\r\n.la-share-alt-square:before {\r\n  content: \"\\f1e1\"; }\r\n\r\n.la-share-square:before {\r\n  content: \"\\f14d\"; }\r\n\r\n.la-shekel-sign:before {\r\n  content: \"\\f20b\"; }\r\n\r\n.la-shield-alt:before {\r\n  content: \"\\f3ed\"; }\r\n\r\n.la-ship:before {\r\n  content: \"\\f21a\"; }\r\n\r\n.la-shipping-fast:before {\r\n  content: \"\\f48b\"; }\r\n\r\n.la-shirtsinbulk:before {\r\n  content: \"\\f214\"; }\r\n\r\n.la-shoe-prints:before {\r\n  content: \"\\f54b\"; }\r\n\r\n.la-shopping-bag:before {\r\n  content: \"\\f290\"; }\r\n\r\n.la-shopping-basket:before {\r\n  content: \"\\f291\"; }\r\n\r\n.la-shopping-cart:before {\r\n  content: \"\\f07a\"; }\r\n\r\n.la-shopware:before {\r\n  content: \"\\f5b5\"; }\r\n\r\n.la-shower:before {\r\n  content: \"\\f2cc\"; }\r\n\r\n.la-shuttle-van:before {\r\n  content: \"\\f5b6\"; }\r\n\r\n.la-sign:before {\r\n  content: \"\\f4d9\"; }\r\n\r\n.la-sign-in-alt:before {\r\n  content: \"\\f2f6\"; }\r\n\r\n.la-sign-language:before {\r\n  content: \"\\f2a7\"; }\r\n\r\n.la-sign-out-alt:before {\r\n  content: \"\\f2f5\"; }\r\n\r\n.la-signal:before {\r\n  content: \"\\f012\"; }\r\n\r\n.la-signature:before {\r\n  content: \"\\f5b7\"; }\r\n\r\n.la-sim-card:before {\r\n  content: \"\\f7c4\"; }\r\n\r\n.la-simplybuilt:before {\r\n  content: \"\\f215\"; }\r\n\r\n.la-sistrix:before {\r\n  content: \"\\f3ee\"; }\r\n\r\n.la-sitemap:before {\r\n  content: \"\\f0e8\"; }\r\n\r\n.la-sith:before {\r\n  content: \"\\f512\"; }\r\n\r\n.la-skating:before {\r\n  content: \"\\f7c5\"; }\r\n\r\n.la-sketch:before {\r\n  content: \"\\f7c6\"; }\r\n\r\n.la-skiing:before {\r\n  content: \"\\f7c9\"; }\r\n\r\n.la-skiing-nordic:before {\r\n  content: \"\\f7ca\"; }\r\n\r\n.la-skull:before {\r\n  content: \"\\f54c\"; }\r\n\r\n.la-skull-crossbones:before {\r\n  content: \"\\f714\"; }\r\n\r\n.la-skyatlas:before {\r\n  content: \"\\f216\"; }\r\n\r\n.la-skype:before {\r\n  content: \"\\f17e\"; }\r\n\r\n.la-slack:before {\r\n  content: \"\\f198\"; }\r\n\r\n.la-slack-hash:before {\r\n  content: \"\\f3ef\"; }\r\n\r\n.la-slash:before {\r\n  content: \"\\f715\"; }\r\n\r\n.la-sleigh:before {\r\n  content: \"\\f7cc\"; }\r\n\r\n.la-sliders-h:before {\r\n  content: \"\\f1de\"; }\r\n\r\n.la-slideshare:before {\r\n  content: \"\\f1e7\"; }\r\n\r\n.la-smile:before {\r\n  content: \"\\f118\"; }\r\n\r\n.la-smile-beam:before {\r\n  content: \"\\f5b8\"; }\r\n\r\n.la-smile-wink:before {\r\n  content: \"\\f4da\"; }\r\n\r\n.la-smog:before {\r\n  content: \"\\f75f\"; }\r\n\r\n.la-smoking:before {\r\n  content: \"\\f48d\"; }\r\n\r\n.la-smoking-ban:before {\r\n  content: \"\\f54d\"; }\r\n\r\n.la-sms:before {\r\n  content: \"\\f7cd\"; }\r\n\r\n.la-snapchat:before {\r\n  content: \"\\f2ab\"; }\r\n\r\n.la-snapchat-ghost:before {\r\n  content: \"\\f2ac\"; }\r\n\r\n.la-snapchat-square:before {\r\n  content: \"\\f2ad\"; }\r\n\r\n.la-snowboarding:before {\r\n  content: \"\\f7ce\"; }\r\n\r\n.la-snowflake:before {\r\n  content: \"\\f2dc\"; }\r\n\r\n.la-snowman:before {\r\n  content: \"\\f7d0\"; }\r\n\r\n.la-snowplow:before {\r\n  content: \"\\f7d2\"; }\r\n\r\n.la-socks:before {\r\n  content: \"\\f696\"; }\r\n\r\n.la-solar-panel:before {\r\n  content: \"\\f5ba\"; }\r\n\r\n.la-sort:before {\r\n  content: \"\\f0dc\"; }\r\n\r\n.la-sort-alpha-down:before {\r\n  content: \"\\f15d\"; }\r\n\r\n.la-sort-alpha-down-alt:before {\r\n  content: \"\\f881\"; }\r\n\r\n.la-sort-alpha-up:before {\r\n  content: \"\\f15e\"; }\r\n\r\n.la-sort-alpha-up-alt:before {\r\n  content: \"\\f882\"; }\r\n\r\n.la-sort-amount-down:before {\r\n  content: \"\\f160\"; }\r\n\r\n.la-sort-amount-down-alt:before {\r\n  content: \"\\f884\"; }\r\n\r\n.la-sort-amount-up:before {\r\n  content: \"\\f161\"; }\r\n\r\n.la-sort-amount-up-alt:before {\r\n  content: \"\\f885\"; }\r\n\r\n.la-sort-down:before {\r\n  content: \"\\f0dd\"; }\r\n\r\n.la-sort-numeric-down:before {\r\n  content: \"\\f162\"; }\r\n\r\n.la-sort-numeric-down-alt:before {\r\n  content: \"\\f886\"; }\r\n\r\n.la-sort-numeric-up:before {\r\n  content: \"\\f163\"; }\r\n\r\n.la-sort-numeric-up-alt:before {\r\n  content: \"\\f887\"; }\r\n\r\n.la-sort-up:before {\r\n  content: \"\\f0de\"; }\r\n\r\n.la-soundcloud:before {\r\n  content: \"\\f1be\"; }\r\n\r\n.la-sourcetree:before {\r\n  content: \"\\f7d3\"; }\r\n\r\n.la-spa:before {\r\n  content: \"\\f5bb\"; }\r\n\r\n.la-space-shuttle:before {\r\n  content: \"\\f197\"; }\r\n\r\n.la-speakap:before {\r\n  content: \"\\f3f3\"; }\r\n\r\n.la-speaker-deck:before {\r\n  content: \"\\f83c\"; }\r\n\r\n.la-spell-check:before {\r\n  content: \"\\f891\"; }\r\n\r\n.la-spider:before {\r\n  content: \"\\f717\"; }\r\n\r\n.la-spinner:before {\r\n  content: \"\\f110\"; }\r\n\r\n.la-splotch:before {\r\n  content: \"\\f5bc\"; }\r\n\r\n.la-spotify:before {\r\n  content: \"\\f1bc\"; }\r\n\r\n.la-spray-can:before {\r\n  content: \"\\f5bd\"; }\r\n\r\n.la-square:before {\r\n  content: \"\\f0c8\"; }\r\n\r\n.la-square-full:before {\r\n  content: \"\\f45c\"; }\r\n\r\n.la-square-root-alt:before {\r\n  content: \"\\f698\"; }\r\n\r\n.la-squarespace:before {\r\n  content: \"\\f5be\"; }\r\n\r\n.la-stack-exchange:before {\r\n  content: \"\\f18d\"; }\r\n\r\n.la-stack-overflow:before {\r\n  content: \"\\f16c\"; }\r\n\r\n.la-stackpath:before {\r\n  content: \"\\f842\"; }\r\n\r\n.la-stamp:before {\r\n  content: \"\\f5bf\"; }\r\n\r\n.la-star:before {\r\n  content: \"\\f005\"; }\r\n\r\n.la-star-and-crescent:before {\r\n  content: \"\\f699\"; }\r\n\r\n.la-star-half:before {\r\n  content: \"\\f089\"; }\r\n\r\n.la-star-half-alt:before {\r\n  content: \"\\f5c0\"; }\r\n\r\n.la-star-of-david:before {\r\n  content: \"\\f69a\"; }\r\n\r\n.la-star-of-life:before {\r\n  content: \"\\f621\"; }\r\n\r\n.la-staylinked:before {\r\n  content: \"\\f3f5\"; }\r\n\r\n.la-steam:before {\r\n  content: \"\\f1b6\"; }\r\n\r\n.la-steam-square:before {\r\n  content: \"\\f1b7\"; }\r\n\r\n.la-steam-symbol:before {\r\n  content: \"\\f3f6\"; }\r\n\r\n.la-step-backward:before {\r\n  content: \"\\f048\"; }\r\n\r\n.la-step-forward:before {\r\n  content: \"\\f051\"; }\r\n\r\n.la-stethoscope:before {\r\n  content: \"\\f0f1\"; }\r\n\r\n.la-sticker-mule:before {\r\n  content: \"\\f3f7\"; }\r\n\r\n.la-sticky-note:before {\r\n  content: \"\\f249\"; }\r\n\r\n.la-stop:before {\r\n  content: \"\\f04d\"; }\r\n\r\n.la-stop-circle:before {\r\n  content: \"\\f28d\"; }\r\n\r\n.la-stopwatch:before {\r\n  content: \"\\f2f2\"; }\r\n\r\n.la-store:before {\r\n  content: \"\\f54e\"; }\r\n\r\n.la-store-alt:before {\r\n  content: \"\\f54f\"; }\r\n\r\n.la-strava:before {\r\n  content: \"\\f428\"; }\r\n\r\n.la-stream:before {\r\n  content: \"\\f550\"; }\r\n\r\n.la-street-view:before {\r\n  content: \"\\f21d\"; }\r\n\r\n.la-strikethrough:before {\r\n  content: \"\\f0cc\"; }\r\n\r\n.la-stripe:before {\r\n  content: \"\\f429\"; }\r\n\r\n.la-stripe-s:before {\r\n  content: \"\\f42a\"; }\r\n\r\n.la-stroopwafel:before {\r\n  content: \"\\f551\"; }\r\n\r\n.la-studiovinari:before {\r\n  content: \"\\f3f8\"; }\r\n\r\n.la-stumbleupon:before {\r\n  content: \"\\f1a4\"; }\r\n\r\n.la-stumbleupon-circle:before {\r\n  content: \"\\f1a3\"; }\r\n\r\n.la-subscript:before {\r\n  content: \"\\f12c\"; }\r\n\r\n.la-subway:before {\r\n  content: \"\\f239\"; }\r\n\r\n.la-suitcase:before {\r\n  content: \"\\f0f2\"; }\r\n\r\n.la-suitcase-rolling:before {\r\n  content: \"\\f5c1\"; }\r\n\r\n.la-sun:before {\r\n  content: \"\\f185\"; }\r\n\r\n.la-superpowers:before {\r\n  content: \"\\f2dd\"; }\r\n\r\n.la-superscript:before {\r\n  content: \"\\f12b\"; }\r\n\r\n.la-supple:before {\r\n  content: \"\\f3f9\"; }\r\n\r\n.la-surprise:before {\r\n  content: \"\\f5c2\"; }\r\n\r\n.la-suse:before {\r\n  content: \"\\f7d6\"; }\r\n\r\n.la-swatchbook:before {\r\n  content: \"\\f5c3\"; }\r\n\r\n.la-swift:before {\r\n  content: \"\\f8e1\"; }\r\n\r\n.la-swimmer:before {\r\n  content: \"\\f5c4\"; }\r\n\r\n.la-swimming-pool:before {\r\n  content: \"\\f5c5\"; }\r\n\r\n.la-symfony:before {\r\n  content: \"\\f83d\"; }\r\n\r\n.la-synagogue:before {\r\n  content: \"\\f69b\"; }\r\n\r\n.la-sync:before {\r\n  content: \"\\f021\"; }\r\n\r\n.la-sync-alt:before {\r\n  content: \"\\f2f1\"; }\r\n\r\n.la-syringe:before {\r\n  content: \"\\f48e\"; }\r\n\r\n.la-table:before {\r\n  content: \"\\f0ce\"; }\r\n\r\n.la-table-tennis:before {\r\n  content: \"\\f45d\"; }\r\n\r\n.la-tablet:before {\r\n  content: \"\\f10a\"; }\r\n\r\n.la-tablet-alt:before {\r\n  content: \"\\f3fa\"; }\r\n\r\n.la-tablets:before {\r\n  content: \"\\f490\"; }\r\n\r\n.la-tachometer-alt:before {\r\n  content: \"\\f3fd\"; }\r\n\r\n.la-tag:before {\r\n  content: \"\\f02b\"; }\r\n\r\n.la-tags:before {\r\n  content: \"\\f02c\"; }\r\n\r\n.la-tape:before {\r\n  content: \"\\f4db\"; }\r\n\r\n.la-tasks:before {\r\n  content: \"\\f0ae\"; }\r\n\r\n.la-taxi:before {\r\n  content: \"\\f1ba\"; }\r\n\r\n.la-teamspeak:before {\r\n  content: \"\\f4f9\"; }\r\n\r\n.la-teeth:before {\r\n  content: \"\\f62e\"; }\r\n\r\n.la-teeth-open:before {\r\n  content: \"\\f62f\"; }\r\n\r\n.la-telegram:before {\r\n  content: \"\\f2c6\"; }\r\n\r\n.la-telegram-plane:before {\r\n  content: \"\\f3fe\"; }\r\n\r\n.la-temperature-high:before {\r\n  content: \"\\f769\"; }\r\n\r\n.la-temperature-low:before {\r\n  content: \"\\f76b\"; }\r\n\r\n.la-tencent-weibo:before {\r\n  content: \"\\f1d5\"; }\r\n\r\n.la-tenge:before {\r\n  content: \"\\f7d7\"; }\r\n\r\n.la-terminal:before {\r\n  content: \"\\f120\"; }\r\n\r\n.la-text-height:before {\r\n  content: \"\\f034\"; }\r\n\r\n.la-text-width:before {\r\n  content: \"\\f035\"; }\r\n\r\n.la-th:before {\r\n  content: \"\\f00a\"; }\r\n\r\n.la-th-large:before {\r\n  content: \"\\f009\"; }\r\n\r\n.la-th-list:before {\r\n  content: \"\\f00b\"; }\r\n\r\n.la-the-red-yeti:before {\r\n  content: \"\\f69d\"; }\r\n\r\n.la-theater-masks:before {\r\n  content: \"\\f630\"; }\r\n\r\n.la-themeco:before {\r\n  content: \"\\f5c6\"; }\r\n\r\n.la-themeisle:before {\r\n  content: \"\\f2b2\"; }\r\n\r\n.la-thermometer:before {\r\n  content: \"\\f491\"; }\r\n\r\n.la-thermometer-empty:before {\r\n  content: \"\\f2cb\"; }\r\n\r\n.la-thermometer-full:before {\r\n  content: \"\\f2c7\"; }\r\n\r\n.la-thermometer-half:before {\r\n  content: \"\\f2c9\"; }\r\n\r\n.la-thermometer-quarter:before {\r\n  content: \"\\f2ca\"; }\r\n\r\n.la-thermometer-three-quarters:before {\r\n  content: \"\\f2c8\"; }\r\n\r\n.la-think-peaks:before {\r\n  content: \"\\f731\"; }\r\n\r\n.la-thumbs-down:before {\r\n  content: \"\\f165\"; }\r\n\r\n.la-thumbs-up:before {\r\n  content: \"\\f164\"; }\r\n\r\n.la-thumbtack:before {\r\n  content: \"\\f08d\"; }\r\n\r\n.la-ticket-alt:before {\r\n  content: \"\\f3ff\"; }\r\n\r\n.la-times:before {\r\n  content: \"\\f00d\"; }\r\n\r\n.la-times-circle:before {\r\n  content: \"\\f057\"; }\r\n\r\n.la-tint:before {\r\n  content: \"\\f043\"; }\r\n\r\n.la-tint-slash:before {\r\n  content: \"\\f5c7\"; }\r\n\r\n.la-tired:before {\r\n  content: \"\\f5c8\"; }\r\n\r\n.la-toggle-off:before {\r\n  content: \"\\f204\"; }\r\n\r\n.la-toggle-on:before {\r\n  content: \"\\f205\"; }\r\n\r\n.la-toilet:before {\r\n  content: \"\\f7d8\"; }\r\n\r\n.la-toilet-paper:before {\r\n  content: \"\\f71e\"; }\r\n\r\n.la-toolbox:before {\r\n  content: \"\\f552\"; }\r\n\r\n.la-tools:before {\r\n  content: \"\\f7d9\"; }\r\n\r\n.la-tooth:before {\r\n  content: \"\\f5c9\"; }\r\n\r\n.la-torah:before {\r\n  content: \"\\f6a0\"; }\r\n\r\n.la-torii-gate:before {\r\n  content: \"\\f6a1\"; }\r\n\r\n.la-tractor:before {\r\n  content: \"\\f722\"; }\r\n\r\n.la-trade-federation:before {\r\n  content: \"\\f513\"; }\r\n\r\n.la-trademark:before {\r\n  content: \"\\f25c\"; }\r\n\r\n.la-traffic-light:before {\r\n  content: \"\\f637\"; }\r\n\r\n.la-train:before {\r\n  content: \"\\f238\"; }\r\n\r\n.la-tram:before {\r\n  content: \"\\f7da\"; }\r\n\r\n.la-transgender:before {\r\n  content: \"\\f224\"; }\r\n\r\n.la-transgender-alt:before {\r\n  content: \"\\f225\"; }\r\n\r\n.la-trash:before {\r\n  content: \"\\f1f8\"; }\r\n\r\n.la-trash-alt:before {\r\n  content: \"\\f2ed\"; }\r\n\r\n.la-trash-restore:before {\r\n  content: \"\\f829\"; }\r\n\r\n.la-trash-restore-alt:before {\r\n  content: \"\\f82a\"; }\r\n\r\n.la-tree:before {\r\n  content: \"\\f1bb\"; }\r\n\r\n.la-trello:before {\r\n  content: \"\\f181\"; }\r\n\r\n.la-tripadvisor:before {\r\n  content: \"\\f262\"; }\r\n\r\n.la-trophy:before {\r\n  content: \"\\f091\"; }\r\n\r\n.la-truck:before {\r\n  content: \"\\f0d1\"; }\r\n\r\n.la-truck-loading:before {\r\n  content: \"\\f4de\"; }\r\n\r\n.la-truck-monster:before {\r\n  content: \"\\f63b\"; }\r\n\r\n.la-truck-moving:before {\r\n  content: \"\\f4df\"; }\r\n\r\n.la-truck-pickup:before {\r\n  content: \"\\f63c\"; }\r\n\r\n.la-tshirt:before {\r\n  content: \"\\f553\"; }\r\n\r\n.la-tty:before {\r\n  content: \"\\f1e4\"; }\r\n\r\n.la-tumblr:before {\r\n  content: \"\\f173\"; }\r\n\r\n.la-tumblr-square:before {\r\n  content: \"\\f174\"; }\r\n\r\n.la-tv:before {\r\n  content: \"\\f26c\"; }\r\n\r\n.la-twitch:before {\r\n  content: \"\\f1e8\"; }\r\n\r\n.la-twitter:before {\r\n  content: \"\\f099\"; }\r\n\r\n.la-twitter-square:before {\r\n  content: \"\\f081\"; }\r\n\r\n.la-typo3:before {\r\n  content: \"\\f42b\"; }\r\n\r\n.la-uber:before {\r\n  content: \"\\f402\"; }\r\n\r\n.la-ubuntu:before {\r\n  content: \"\\f7df\"; }\r\n\r\n.la-uikit:before {\r\n  content: \"\\f403\"; }\r\n\r\n.la-umbraco:before {\r\n  content: \"\\f8e8\"; }\r\n\r\n.la-umbrella:before {\r\n  content: \"\\f0e9\"; }\r\n\r\n.la-umbrella-beach:before {\r\n  content: \"\\f5ca\"; }\r\n\r\n.la-underline:before {\r\n  content: \"\\f0cd\"; }\r\n\r\n.la-undo:before {\r\n  content: \"\\f0e2\"; }\r\n\r\n.la-undo-alt:before {\r\n  content: \"\\f2ea\"; }\r\n\r\n.la-uniregistry:before {\r\n  content: \"\\f404\"; }\r\n\r\n.la-universal-access:before {\r\n  content: \"\\f29a\"; }\r\n\r\n.la-university:before {\r\n  content: \"\\f19c\"; }\r\n\r\n.la-unlink:before {\r\n  content: \"\\f127\"; }\r\n\r\n.la-unlock:before {\r\n  content: \"\\f09c\"; }\r\n\r\n.la-unlock-alt:before {\r\n  content: \"\\f13e\"; }\r\n\r\n.la-untappd:before {\r\n  content: \"\\f405\"; }\r\n\r\n.la-upload:before {\r\n  content: \"\\f093\"; }\r\n\r\n.la-ups:before {\r\n  content: \"\\f7e0\"; }\r\n\r\n.la-usb:before {\r\n  content: \"\\f287\"; }\r\n\r\n.la-user:before {\r\n  content: \"\\f007\"; }\r\n\r\n.la-user-alt:before {\r\n  content: \"\\f406\"; }\r\n\r\n.la-user-alt-slash:before {\r\n  content: \"\\f4fa\"; }\r\n\r\n.la-user-astronaut:before {\r\n  content: \"\\f4fb\"; }\r\n\r\n.la-user-check:before {\r\n  content: \"\\f4fc\"; }\r\n\r\n.la-user-circle:before {\r\n  content: \"\\f2bd\"; }\r\n\r\n.la-user-clock:before {\r\n  content: \"\\f4fd\"; }\r\n\r\n.la-user-cog:before {\r\n  content: \"\\f4fe\"; }\r\n\r\n.la-user-edit:before {\r\n  content: \"\\f4ff\"; }\r\n\r\n.la-user-friends:before {\r\n  content: \"\\f500\"; }\r\n\r\n.la-user-graduate:before {\r\n  content: \"\\f501\"; }\r\n\r\n.la-user-injured:before {\r\n  content: \"\\f728\"; }\r\n\r\n.la-user-lock:before {\r\n  content: \"\\f502\"; }\r\n\r\n.la-user-md:before {\r\n  content: \"\\f0f0\"; }\r\n\r\n.la-user-minus:before {\r\n  content: \"\\f503\"; }\r\n\r\n.la-user-ninja:before {\r\n  content: \"\\f504\"; }\r\n\r\n.la-user-nurse:before {\r\n  content: \"\\f82f\"; }\r\n\r\n.la-user-plus:before {\r\n  content: \"\\f234\"; }\r\n\r\n.la-user-secret:before {\r\n  content: \"\\f21b\"; }\r\n\r\n.la-user-shield:before {\r\n  content: \"\\f505\"; }\r\n\r\n.la-user-slash:before {\r\n  content: \"\\f506\"; }\r\n\r\n.la-user-tag:before {\r\n  content: \"\\f507\"; }\r\n\r\n.la-user-tie:before {\r\n  content: \"\\f508\"; }\r\n\r\n.la-user-times:before {\r\n  content: \"\\f235\"; }\r\n\r\n.la-users:before {\r\n  content: \"\\f0c0\"; }\r\n\r\n.la-users-cog:before {\r\n  content: \"\\f509\"; }\r\n\r\n.la-usps:before {\r\n  content: \"\\f7e1\"; }\r\n\r\n.la-ussunnah:before {\r\n  content: \"\\f407\"; }\r\n\r\n.la-utensil-spoon:before {\r\n  content: \"\\f2e5\"; }\r\n\r\n.la-utensils:before {\r\n  content: \"\\f2e7\"; }\r\n\r\n.la-vaadin:before {\r\n  content: \"\\f408\"; }\r\n\r\n.la-vector-square:before {\r\n  content: \"\\f5cb\"; }\r\n\r\n.la-venus:before {\r\n  content: \"\\f221\"; }\r\n\r\n.la-venus-double:before {\r\n  content: \"\\f226\"; }\r\n\r\n.la-venus-mars:before {\r\n  content: \"\\f228\"; }\r\n\r\n.la-viacoin:before {\r\n  content: \"\\f237\"; }\r\n\r\n.la-viadeo:before {\r\n  content: \"\\f2a9\"; }\r\n\r\n.la-viadeo-square:before {\r\n  content: \"\\f2aa\"; }\r\n\r\n.la-vial:before {\r\n  content: \"\\f492\"; }\r\n\r\n.la-vials:before {\r\n  content: \"\\f493\"; }\r\n\r\n.la-viber:before {\r\n  content: \"\\f409\"; }\r\n\r\n.la-video:before {\r\n  content: \"\\f03d\"; }\r\n\r\n.la-video-slash:before {\r\n  content: \"\\f4e2\"; }\r\n\r\n.la-vihara:before {\r\n  content: \"\\f6a7\"; }\r\n\r\n.la-vimeo:before {\r\n  content: \"\\f40a\"; }\r\n\r\n.la-vimeo-square:before {\r\n  content: \"\\f194\"; }\r\n\r\n.la-vimeo-v:before {\r\n  content: \"\\f27d\"; }\r\n\r\n.la-vine:before {\r\n  content: \"\\f1ca\"; }\r\n\r\n.la-vk:before {\r\n  content: \"\\f189\"; }\r\n\r\n.la-vnv:before {\r\n  content: \"\\f40b\"; }\r\n\r\n.la-voicemail:before {\r\n  content: \"\\f897\"; }\r\n\r\n.la-volleyball-ball:before {\r\n  content: \"\\f45f\"; }\r\n\r\n.la-volume-down:before {\r\n  content: \"\\f027\"; }\r\n\r\n.la-volume-mute:before {\r\n  content: \"\\f6a9\"; }\r\n\r\n.la-volume-off:before {\r\n  content: \"\\f026\"; }\r\n\r\n.la-volume-up:before {\r\n  content: \"\\f028\"; }\r\n\r\n.la-vote-yea:before {\r\n  content: \"\\f772\"; }\r\n\r\n.la-vr-cardboard:before {\r\n  content: \"\\f729\"; }\r\n\r\n.la-vuejs:before {\r\n  content: \"\\f41f\"; }\r\n\r\n.la-walking:before {\r\n  content: \"\\f554\"; }\r\n\r\n.la-wallet:before {\r\n  content: \"\\f555\"; }\r\n\r\n.la-warehouse:before {\r\n  content: \"\\f494\"; }\r\n\r\n.la-water:before {\r\n  content: \"\\f773\"; }\r\n\r\n.la-wave-square:before {\r\n  content: \"\\f83e\"; }\r\n\r\n.la-waze:before {\r\n  content: \"\\f83f\"; }\r\n\r\n.la-weebly:before {\r\n  content: \"\\f5cc\"; }\r\n\r\n.la-weibo:before {\r\n  content: \"\\f18a\"; }\r\n\r\n.la-weight:before {\r\n  content: \"\\f496\"; }\r\n\r\n.la-weight-hanging:before {\r\n  content: \"\\f5cd\"; }\r\n\r\n.la-weixin:before {\r\n  content: \"\\f1d7\"; }\r\n\r\n.la-whatsapp:before {\r\n  content: \"\\f232\"; }\r\n\r\n.la-whatsapp-square:before {\r\n  content: \"\\f40c\"; }\r\n\r\n.la-wheelchair:before {\r\n  content: \"\\f193\"; }\r\n\r\n.la-whmcs:before {\r\n  content: \"\\f40d\"; }\r\n\r\n.la-wifi:before {\r\n  content: \"\\f1eb\"; }\r\n\r\n.la-wikipedia-w:before {\r\n  content: \"\\f266\"; }\r\n\r\n.la-wind:before {\r\n  content: \"\\f72e\"; }\r\n\r\n.la-window-close:before {\r\n  content: \"\\f410\"; }\r\n\r\n.la-window-maximize:before {\r\n  content: \"\\f2d0\"; }\r\n\r\n.la-window-minimize:before {\r\n  content: \"\\f2d1\"; }\r\n\r\n.la-window-restore:before {\r\n  content: \"\\f2d2\"; }\r\n\r\n.la-windows:before {\r\n  content: \"\\f17a\"; }\r\n\r\n.la-wine-bottle:before {\r\n  content: \"\\f72f\"; }\r\n\r\n.la-wine-glass:before {\r\n  content: \"\\f4e3\"; }\r\n\r\n.la-wine-glass-alt:before {\r\n  content: \"\\f5ce\"; }\r\n\r\n.la-wix:before {\r\n  content: \"\\f5cf\"; }\r\n\r\n.la-wizards-of-the-coast:before {\r\n  content: \"\\f730\"; }\r\n\r\n.la-wolf-pack-battalion:before {\r\n  content: \"\\f514\"; }\r\n\r\n.la-won-sign:before {\r\n  content: \"\\f159\"; }\r\n\r\n.la-wordpress:before {\r\n  content: \"\\f19a\"; }\r\n\r\n.la-wordpress-simple:before {\r\n  content: \"\\f411\"; }\r\n\r\n.la-wpbeginner:before {\r\n  content: \"\\f297\"; }\r\n\r\n.la-wpexplorer:before {\r\n  content: \"\\f2de\"; }\r\n\r\n.la-wpforms:before {\r\n  content: \"\\f298\"; }\r\n\r\n.la-wpressr:before {\r\n  content: \"\\f3e4\"; }\r\n\r\n.la-wrench:before {\r\n  content: \"\\f0ad\"; }\r\n\r\n.la-x-ray:before {\r\n  content: \"\\f497\"; }\r\n\r\n.la-xbox:before {\r\n  content: \"\\f412\"; }\r\n\r\n.la-xing:before {\r\n  content: \"\\f168\"; }\r\n\r\n.la-xing-square:before {\r\n  content: \"\\f169\"; }\r\n\r\n.la-y-combinator:before {\r\n  content: \"\\f23b\"; }\r\n\r\n.la-yahoo:before {\r\n  content: \"\\f19e\"; }\r\n\r\n.la-yammer:before {\r\n  content: \"\\f840\"; }\r\n\r\n.la-yandex:before {\r\n  content: \"\\f413\"; }\r\n\r\n.la-yandex-international:before {\r\n  content: \"\\f414\"; }\r\n\r\n.la-yarn:before {\r\n  content: \"\\f7e3\"; }\r\n\r\n.la-yelp:before {\r\n  content: \"\\f1e9\"; }\r\n\r\n.la-yen-sign:before {\r\n  content: \"\\f157\"; }\r\n\r\n.la-yin-yang:before {\r\n  content: \"\\f6ad\"; }\r\n\r\n.la-yoast:before {\r\n  content: \"\\f2b1\"; }\r\n\r\n.la-youtube:before {\r\n  content: \"\\f167\"; }\r\n\r\n.la-youtube-square:before {\r\n  content: \"\\f431\"; }\r\n\r\n.la-zhihu:before {\r\n  content: \"\\f63f\"; }\r\n\r\n.sr-only {\r\n  border: 0;\r\n  clip: rect(0, 0, 0, 0);\r\n  height: 1px;\r\n  margin: -1px;\r\n  overflow: hidden;\r\n  padding: 0;\r\n  position: absolute;\r\n  width: 1px; }\r\n\r\n.sr-only-focusable:active, .sr-only-focusable:focus {\r\n  clip: auto;\r\n  height: auto;\r\n  margin: 0;\r\n  overflow: visible;\r\n  position: static;\r\n  width: auto; }\r\n@font-face {\r\n  font-family: 'Line Awesome Brands';\r\n  font-style: normal;\r\n  font-weight: normal;\r\n  font-display: auto;\r\n  src: url(\"../../../fonts/la-brands-400.eot\");\r\n  src: url(\"../../../fonts/la-brands-400.eot?#iefix\") format(\"embedded-opentype\"), url(\"../../../fonts/la-brands-400.woff2\") format(\"woff2\"), url(\"../../../fonts/la-brands-400.woff\") format(\"woff\"), url(\"../../../fonts/la-brands-400.ttf\") format(\"truetype\"), url(\"../../../fonts/la-brands-400.svg#lineawesome\") format(\"svg\"); }\r\n\r\n.lab {\r\n  font-family: 'Line Awesome Brands'; }\r\n@font-face {\r\n  font-family: 'Line Awesome Free';\r\n  font-style: normal;\r\n  font-weight: 400;\r\n  font-display: auto;\r\n  src: url(\"../../../fonts/la-regular-400.eot\");\r\n  src: url(\"../../../fonts/la-regular-400.eot?#iefix\") format(\"embedded-opentype\"), url(\"../../../fonts/la-regular-400.woff2\") format(\"woff2\"), url(\"../../../fonts/la-regular-400.woff\") format(\"woff\"), url(\"../../../fonts/la-regular-400.ttf\") format(\"truetype\"), url(\"../../../fonts/la-regular-400.svg#lineawesome\") format(\"svg\"); }\r\n\r\n.lar {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n@font-face {\r\n  font-family: 'Line Awesome Free';\r\n  font-style: normal;\r\n  font-weight: 900;\r\n  font-display: auto;\r\n  src: url(\"../../../fonts/la-solid-900.eot\");\r\n  src: url(\"../../../fonts/la-solid-900.eot?#iefix\") format(\"embedded-opentype\"), url(\"../../../fonts/la-solid-900.woff2\") format(\"woff2\"), url(\"../../../fonts/la-solid-900.woff\") format(\"woff\"), url(\"../../../fonts/la-solid-900.ttf\") format(\"truetype\"), url(\"../../../fonts/la-solid-900.svg#lineawesome\") format(\"svg\"); }\r\n\r\n.la,\r\n.las {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 900; }\r\n\r\n.la.la-glass:before {\r\n  content: \"\\f000\"; }\r\n\r\n.la.la-meetup {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-star-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-star-o:before {\r\n  content: \"\\f005\"; }\r\n\r\n.la.la-remove:before {\r\n  content: \"\\f00d\"; }\r\n\r\n.la.la-close:before {\r\n  content: \"\\f00d\"; }\r\n\r\n.la.la-gear:before {\r\n  content: \"\\f013\"; }\r\n\r\n.la.la-trash-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-trash-o:before {\r\n  content: \"\\f2ed\"; }\r\n\r\n.la.la-file-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-file-o:before {\r\n  content: \"\\f15b\"; }\r\n\r\n.la.la-clock-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-clock-o:before {\r\n  content: \"\\f017\"; }\r\n\r\n.la.la-arrow-circle-o-down {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-arrow-circle-o-down:before {\r\n  content: \"\\f358\"; }\r\n\r\n.la.la-arrow-circle-o-up {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-arrow-circle-o-up:before {\r\n  content: \"\\f35b\"; }\r\n\r\n.la.la-play-circle-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-play-circle-o:before {\r\n  content: \"\\f144\"; }\r\n\r\n.la.la-repeat:before {\r\n  content: \"\\f01e\"; }\r\n\r\n.la.la-rotate-right:before {\r\n  content: \"\\f01e\"; }\r\n\r\n.la.la-refresh:before {\r\n  content: \"\\f021\"; }\r\n\r\n.la.la-list-alt {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-dedent:before {\r\n  content: \"\\f03b\"; }\r\n\r\n.la.la-video-camera:before {\r\n  content: \"\\f03d\"; }\r\n\r\n.la.la-picture-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-picture-o:before {\r\n  content: \"\\f03e\"; }\r\n\r\n.la.la-photo {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-photo:before {\r\n  content: \"\\f03e\"; }\r\n\r\n.la.la-image {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-image:before {\r\n  content: \"\\f03e\"; }\r\n\r\n.la.la-pencil:before {\r\n  content: \"\\f303\"; }\r\n\r\n.la.la-map-marker:before {\r\n  content: \"\\f3c5\"; }\r\n\r\n.la.la-pencil-square-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-pencil-square-o:before {\r\n  content: \"\\f044\"; }\r\n\r\n.la.la-share-square-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-share-square-o:before {\r\n  content: \"\\f14d\"; }\r\n\r\n.la.la-check-square-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-check-square-o:before {\r\n  content: \"\\f14a\"; }\r\n\r\n.la.la-arrows:before {\r\n  content: \"\\f0b2\"; }\r\n\r\n.la.la-times-circle-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-times-circle-o:before {\r\n  content: \"\\f057\"; }\r\n\r\n.la.la-check-circle-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-check-circle-o:before {\r\n  content: \"\\f058\"; }\r\n\r\n.la.la-mail-forward:before {\r\n  content: \"\\f064\"; }\r\n\r\n.la.la-eye {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-eye-slash {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-warning:before {\r\n  content: \"\\f071\"; }\r\n\r\n.la.la-calendar:before {\r\n  content: \"\\f073\"; }\r\n\r\n.la.la-arrows-v:before {\r\n  content: \"\\f338\"; }\r\n\r\n.la.la-arrows-h:before {\r\n  content: \"\\f337\"; }\r\n\r\n.la.la-bar-chart {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-bar-chart:before {\r\n  content: \"\\f080\"; }\r\n\r\n.la.la-bar-chart-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-bar-chart-o:before {\r\n  content: \"\\f080\"; }\r\n\r\n.la.la-twitter-square {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-facebook-square {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-gears:before {\r\n  content: \"\\f085\"; }\r\n\r\n.la.la-thumbs-o-up {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-thumbs-o-up:before {\r\n  content: \"\\f164\"; }\r\n\r\n.la.la-thumbs-o-down {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-thumbs-o-down:before {\r\n  content: \"\\f165\"; }\r\n\r\n.la.la-heart-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-heart-o:before {\r\n  content: \"\\f004\"; }\r\n\r\n.la.la-sign-out:before {\r\n  content: \"\\f2f5\"; }\r\n\r\n.la.la-linkedin-square {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-linkedin-square:before {\r\n  content: \"\\f08c\"; }\r\n\r\n.la.la-thumb-tack:before {\r\n  content: \"\\f08d\"; }\r\n\r\n.la.la-external-link:before {\r\n  content: \"\\f35d\"; }\r\n\r\n.la.la-sign-in:before {\r\n  content: \"\\f2f6\"; }\r\n\r\n.la.la-github-square {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-lemon-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-lemon-o:before {\r\n  content: \"\\f094\"; }\r\n\r\n.la.la-square-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-square-o:before {\r\n  content: \"\\f0c8\"; }\r\n\r\n.la.la-bookmark-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-bookmark-o:before {\r\n  content: \"\\f02e\"; }\r\n\r\n.la.la-twitter {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-facebook {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-facebook:before {\r\n  content: \"\\f39e\"; }\r\n\r\n.la.la-facebook-f {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-facebook-f:before {\r\n  content: \"\\f39e\"; }\r\n\r\n.la.la-github {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-credit-card {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-feed:before {\r\n  content: \"\\f09e\"; }\r\n\r\n.la.la-hdd-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-hdd-o:before {\r\n  content: \"\\f0a0\"; }\r\n\r\n.la.la-hand-o-right {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-hand-o-right:before {\r\n  content: \"\\f0a4\"; }\r\n\r\n.la.la-hand-o-left {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-hand-o-left:before {\r\n  content: \"\\f0a5\"; }\r\n\r\n.la.la-hand-o-up {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-hand-o-up:before {\r\n  content: \"\\f0a6\"; }\r\n\r\n.la.la-hand-o-down {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-hand-o-down:before {\r\n  content: \"\\f0a7\"; }\r\n\r\n.la.la-arrows-alt:before {\r\n  content: \"\\f31e\"; }\r\n\r\n.la.la-group:before {\r\n  content: \"\\f0c0\"; }\r\n\r\n.la.la-chain:before {\r\n  content: \"\\f0c1\"; }\r\n\r\n.la.la-scissors:before {\r\n  content: \"\\f0c4\"; }\r\n\r\n.la.la-files-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-files-o:before {\r\n  content: \"\\f0c5\"; }\r\n\r\n.la.la-floppy-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-floppy-o:before {\r\n  content: \"\\f0c7\"; }\r\n\r\n.la.la-navicon:before {\r\n  content: \"\\f0c9\"; }\r\n\r\n.la.la-reorder:before {\r\n  content: \"\\f0c9\"; }\r\n\r\n.la.la-pinterest {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-pinterest-square {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-google-plus-square {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-google-plus {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-google-plus:before {\r\n  content: \"\\f0d5\"; }\r\n\r\n.la.la-money {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-money:before {\r\n  content: \"\\f3d1\"; }\r\n\r\n.la.la-unsorted:before {\r\n  content: \"\\f0dc\"; }\r\n\r\n.la.la-sort-desc:before {\r\n  content: \"\\f0dd\"; }\r\n\r\n.la.la-sort-asc:before {\r\n  content: \"\\f0de\"; }\r\n\r\n.la.la-linkedin {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-linkedin:before {\r\n  content: \"\\f0e1\"; }\r\n\r\n.la.la-rotate-left:before {\r\n  content: \"\\f0e2\"; }\r\n\r\n.la.la-legal:before {\r\n  content: \"\\f0e3\"; }\r\n\r\n.la.la-tachometer:before {\r\n  content: \"\\f3fd\"; }\r\n\r\n.la.la-dashboard:before {\r\n  content: \"\\f3fd\"; }\r\n\r\n.la.la-comment-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-comment-o:before {\r\n  content: \"\\f075\"; }\r\n\r\n.la.la-comments-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-comments-o:before {\r\n  content: \"\\f086\"; }\r\n\r\n.la.la-flash:before {\r\n  content: \"\\f0e7\"; }\r\n\r\n.la.la-clipboard {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-paste {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-paste:before {\r\n  content: \"\\f328\"; }\r\n\r\n.la.la-lightbulb-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-lightbulb-o:before {\r\n  content: \"\\f0eb\"; }\r\n\r\n.la.la-exchange:before {\r\n  content: \"\\f362\"; }\r\n\r\n.la.la-cloud-download:before {\r\n  content: \"\\f381\"; }\r\n\r\n.la.la-cloud-upload:before {\r\n  content: \"\\f382\"; }\r\n\r\n.la.la-bell-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-bell-o:before {\r\n  content: \"\\f0f3\"; }\r\n\r\n.la.la-cutlery:before {\r\n  content: \"\\f2e7\"; }\r\n\r\n.la.la-file-text-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-file-text-o:before {\r\n  content: \"\\f15c\"; }\r\n\r\n.la.la-building-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-building-o:before {\r\n  content: \"\\f1ad\"; }\r\n\r\n.la.la-hospital-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-hospital-o:before {\r\n  content: \"\\f0f8\"; }\r\n\r\n.la.la-tablet:before {\r\n  content: \"\\f3fa\"; }\r\n\r\n.la.la-mobile:before {\r\n  content: \"\\f3cd\"; }\r\n\r\n.la.la-mobile-phone:before {\r\n  content: \"\\f3cd\"; }\r\n\r\n.la.la-circle-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-circle-o:before {\r\n  content: \"\\f111\"; }\r\n\r\n.la.la-mail-reply:before {\r\n  content: \"\\f3e5\"; }\r\n\r\n.la.la-github-alt {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-folder-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-folder-o:before {\r\n  content: \"\\f07b\"; }\r\n\r\n.la.la-folder-open-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-folder-open-o:before {\r\n  content: \"\\f07c\"; }\r\n\r\n.la.la-smile-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-smile-o:before {\r\n  content: \"\\f118\"; }\r\n\r\n.la.la-frown-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-frown-o:before {\r\n  content: \"\\f119\"; }\r\n\r\n.la.la-meh-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-meh-o:before {\r\n  content: \"\\f11a\"; }\r\n\r\n.la.la-keyboard-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-keyboard-o:before {\r\n  content: \"\\f11c\"; }\r\n\r\n.la.la-flag-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-flag-o:before {\r\n  content: \"\\f024\"; }\r\n\r\n.la.la-mail-reply-all:before {\r\n  content: \"\\f122\"; }\r\n\r\n.la.la-star-half-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-star-half-o:before {\r\n  content: \"\\f089\"; }\r\n\r\n.la.la-star-half-empty {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-star-half-empty:before {\r\n  content: \"\\f089\"; }\r\n\r\n.la.la-star-half-full {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-star-half-full:before {\r\n  content: \"\\f089\"; }\r\n\r\n.la.la-code-fork:before {\r\n  content: \"\\f126\"; }\r\n\r\n.la.la-chain-broken:before {\r\n  content: \"\\f127\"; }\r\n\r\n.la.la-shield:before {\r\n  content: \"\\f3ed\"; }\r\n\r\n.la.la-calendar-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-calendar-o:before {\r\n  content: \"\\f133\"; }\r\n\r\n.la.la-maxcdn {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-html5 {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-css3 {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-ticket:before {\r\n  content: \"\\f3ff\"; }\r\n\r\n.la.la-minus-square-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-minus-square-o:before {\r\n  content: \"\\f146\"; }\r\n\r\n.la.la-level-up:before {\r\n  content: \"\\f3bf\"; }\r\n\r\n.la.la-level-down:before {\r\n  content: \"\\f3be\"; }\r\n\r\n.la.la-pencil-square:before {\r\n  content: \"\\f14b\"; }\r\n\r\n.la.la-external-link-square:before {\r\n  content: \"\\f360\"; }\r\n\r\n.la.la-compass {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-caret-square-o-down {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-caret-square-o-down:before {\r\n  content: \"\\f150\"; }\r\n\r\n.la.la-toggle-down {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-toggle-down:before {\r\n  content: \"\\f150\"; }\r\n\r\n.la.la-caret-square-o-up {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-caret-square-o-up:before {\r\n  content: \"\\f151\"; }\r\n\r\n.la.la-toggle-up {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-toggle-up:before {\r\n  content: \"\\f151\"; }\r\n\r\n.la.la-caret-square-o-right {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-caret-square-o-right:before {\r\n  content: \"\\f152\"; }\r\n\r\n.la.la-toggle-right {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-toggle-right:before {\r\n  content: \"\\f152\"; }\r\n\r\n.la.la-eur:before {\r\n  content: \"\\f153\"; }\r\n\r\n.la.la-euro:before {\r\n  content: \"\\f153\"; }\r\n\r\n.la.la-gbp:before {\r\n  content: \"\\f154\"; }\r\n\r\n.la.la-usd:before {\r\n  content: \"\\f155\"; }\r\n\r\n.la.la-dollar:before {\r\n  content: \"\\f155\"; }\r\n\r\n.la.la-inr:before {\r\n  content: \"\\f156\"; }\r\n\r\n.la.la-rupee:before {\r\n  content: \"\\f156\"; }\r\n\r\n.la.la-jpy:before {\r\n  content: \"\\f157\"; }\r\n\r\n.la.la-cny:before {\r\n  content: \"\\f157\"; }\r\n\r\n.la.la-rmb:before {\r\n  content: \"\\f157\"; }\r\n\r\n.la.la-yen:before {\r\n  content: \"\\f157\"; }\r\n\r\n.la.la-rub:before {\r\n  content: \"\\f158\"; }\r\n\r\n.la.la-ruble:before {\r\n  content: \"\\f158\"; }\r\n\r\n.la.la-rouble:before {\r\n  content: \"\\f158\"; }\r\n\r\n.la.la-krw:before {\r\n  content: \"\\f159\"; }\r\n\r\n.la.la-won:before {\r\n  content: \"\\f159\"; }\r\n\r\n.la.la-btc {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-bitcoin {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-bitcoin:before {\r\n  content: \"\\f15a\"; }\r\n\r\n.la.la-file-text:before {\r\n  content: \"\\f15c\"; }\r\n\r\n.la.la-sort-alpha-asc:before {\r\n  content: \"\\f15d\"; }\r\n\r\n.la.la-sort-alpha-desc:before {\r\n  content: \"\\f881\"; }\r\n\r\n.la.la-sort-amount-asc:before {\r\n  content: \"\\f160\"; }\r\n\r\n.la.la-sort-amount-desc:before {\r\n  content: \"\\f884\"; }\r\n\r\n.la.la-sort-numeric-asc:before {\r\n  content: \"\\f162\"; }\r\n\r\n.la.la-sort-numeric-desc:before {\r\n  content: \"\\f886\"; }\r\n\r\n.la.la-youtube-square {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-youtube {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-xing {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-xing-square {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-youtube-play {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-youtube-play:before {\r\n  content: \"\\f167\"; }\r\n\r\n.la.la-dropbox {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-stack-overflow {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-instagram {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-flickr {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-adn {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-bitbucket {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-bitbucket-square {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-bitbucket-square:before {\r\n  content: \"\\f171\"; }\r\n\r\n.la.la-tumblr {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-tumblr-square {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-long-arrow-down:before {\r\n  content: \"\\f309\"; }\r\n\r\n.la.la-long-arrow-up:before {\r\n  content: \"\\f30c\"; }\r\n\r\n.la.la-long-arrow-left:before {\r\n  content: \"\\f30a\"; }\r\n\r\n.la.la-long-arrow-right:before {\r\n  content: \"\\f30b\"; }\r\n\r\n.la.la-apple {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-windows {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-android {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-linux {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-dribbble {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-skype {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-foursquare {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-trello {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-gratipay {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-gittip {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-gittip:before {\r\n  content: \"\\f184\"; }\r\n\r\n.la.la-sun-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-sun-o:before {\r\n  content: \"\\f185\"; }\r\n\r\n.la.la-moon-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-moon-o:before {\r\n  content: \"\\f186\"; }\r\n\r\n.la.la-vk {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-weibo {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-renren {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-pagelines {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-stack-exchange {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-arrow-circle-o-right {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-arrow-circle-o-right:before {\r\n  content: \"\\f35a\"; }\r\n\r\n.la.la-arrow-circle-o-left {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-arrow-circle-o-left:before {\r\n  content: \"\\f359\"; }\r\n\r\n.la.la-caret-square-o-left {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-caret-square-o-left:before {\r\n  content: \"\\f191\"; }\r\n\r\n.la.la-toggle-left {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-toggle-left:before {\r\n  content: \"\\f191\"; }\r\n\r\n.la.la-dot-circle-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-dot-circle-o:before {\r\n  content: \"\\f192\"; }\r\n\r\n.la.la-vimeo-square {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-try:before {\r\n  content: \"\\f195\"; }\r\n\r\n.la.la-turkish-lira:before {\r\n  content: \"\\f195\"; }\r\n\r\n.la.la-plus-square-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-plus-square-o:before {\r\n  content: \"\\f0fe\"; }\r\n\r\n.la.la-slack {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-wordpress {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-openid {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-institution:before {\r\n  content: \"\\f19c\"; }\r\n\r\n.la.la-bank:before {\r\n  content: \"\\f19c\"; }\r\n\r\n.la.la-mortar-board:before {\r\n  content: \"\\f19d\"; }\r\n\r\n.la.la-yahoo {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-google {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-reddit {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-reddit-square {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-stumbleupon-circle {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-stumbleupon {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-delicious {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-digg {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-pied-piper-pp {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-pied-piper-alt {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-drupal {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-joomla {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-spoon:before {\r\n  content: \"\\f2e5\"; }\r\n\r\n.la.la-behance {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-behance-square {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-steam {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-steam-square {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-automobile:before {\r\n  content: \"\\f1b9\"; }\r\n\r\n.la.la-cab:before {\r\n  content: \"\\f1ba\"; }\r\n\r\n.la.la-envelope-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-envelope-o:before {\r\n  content: \"\\f0e0\"; }\r\n\r\n.la.la-deviantart {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-soundcloud {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-file-pdf-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-file-pdf-o:before {\r\n  content: \"\\f1c1\"; }\r\n\r\n.la.la-file-word-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-file-word-o:before {\r\n  content: \"\\f1c2\"; }\r\n\r\n.la.la-file-excel-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-file-excel-o:before {\r\n  content: \"\\f1c3\"; }\r\n\r\n.la.la-file-powerpoint-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-file-powerpoint-o:before {\r\n  content: \"\\f1c4\"; }\r\n\r\n.la.la-file-image-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-file-image-o:before {\r\n  content: \"\\f1c5\"; }\r\n\r\n.la.la-file-photo-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-file-photo-o:before {\r\n  content: \"\\f1c5\"; }\r\n\r\n.la.la-file-picture-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-file-picture-o:before {\r\n  content: \"\\f1c5\"; }\r\n\r\n.la.la-file-archive-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-file-archive-o:before {\r\n  content: \"\\f1c6\"; }\r\n\r\n.la.la-file-zip-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-file-zip-o:before {\r\n  content: \"\\f1c6\"; }\r\n\r\n.la.la-file-audio-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-file-audio-o:before {\r\n  content: \"\\f1c7\"; }\r\n\r\n.la.la-file-sound-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-file-sound-o:before {\r\n  content: \"\\f1c7\"; }\r\n\r\n.la.la-file-video-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-file-video-o:before {\r\n  content: \"\\f1c8\"; }\r\n\r\n.la.la-file-movie-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-file-movie-o:before {\r\n  content: \"\\f1c8\"; }\r\n\r\n.la.la-file-code-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-file-code-o:before {\r\n  content: \"\\f1c9\"; }\r\n\r\n.la.la-vine {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-codepen {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-jsfiddle {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-life-ring {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-life-bouy {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-life-bouy:before {\r\n  content: \"\\f1cd\"; }\r\n\r\n.la.la-life-buoy {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-life-buoy:before {\r\n  content: \"\\f1cd\"; }\r\n\r\n.la.la-life-saver {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-life-saver:before {\r\n  content: \"\\f1cd\"; }\r\n\r\n.la.la-support {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-support:before {\r\n  content: \"\\f1cd\"; }\r\n\r\n.la.la-circle-o-notch:before {\r\n  content: \"\\f1ce\"; }\r\n\r\n.la.la-rebel {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-ra {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-ra:before {\r\n  content: \"\\f1d0\"; }\r\n\r\n.la.la-resistance {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-resistance:before {\r\n  content: \"\\f1d0\"; }\r\n\r\n.la.la-empire {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-ge {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-ge:before {\r\n  content: \"\\f1d1\"; }\r\n\r\n.la.la-git-square {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-git {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-hacker-news {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-y-combinator-square {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-y-combinator-square:before {\r\n  content: \"\\f1d4\"; }\r\n\r\n.la.la-yc-square {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-yc-square:before {\r\n  content: \"\\f1d4\"; }\r\n\r\n.la.la-tencent-weibo {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-qq {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-weixin {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-wechat {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-wechat:before {\r\n  content: \"\\f1d7\"; }\r\n\r\n.la.la-send:before {\r\n  content: \"\\f1d8\"; }\r\n\r\n.la.la-paper-plane-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-paper-plane-o:before {\r\n  content: \"\\f1d8\"; }\r\n\r\n.la.la-send-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-send-o:before {\r\n  content: \"\\f1d8\"; }\r\n\r\n.la.la-circle-thin {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-circle-thin:before {\r\n  content: \"\\f111\"; }\r\n\r\n.la.la-header:before {\r\n  content: \"\\f1dc\"; }\r\n\r\n.la.la-sliders:before {\r\n  content: \"\\f1de\"; }\r\n\r\n.la.la-futbol-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-futbol-o:before {\r\n  content: \"\\f1e3\"; }\r\n\r\n.la.la-soccer-ball-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-soccer-ball-o:before {\r\n  content: \"\\f1e3\"; }\r\n\r\n.la.la-slideshare {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-twitch {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-yelp {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-newspaper-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-newspaper-o:before {\r\n  content: \"\\f1ea\"; }\r\n\r\n.la.la-paypal {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-google-wallet {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-cc-visa {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-cc-mastercard {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-cc-discover {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-cc-amex {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-cc-paypal {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-cc-stripe {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-bell-slash-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-bell-slash-o:before {\r\n  content: \"\\f1f6\"; }\r\n\r\n.la.la-trash:before {\r\n  content: \"\\f2ed\"; }\r\n\r\n.la.la-copyright {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-eyedropper:before {\r\n  content: \"\\f1fb\"; }\r\n\r\n.la.la-area-chart:before {\r\n  content: \"\\f1fe\"; }\r\n\r\n.la.la-pie-chart:before {\r\n  content: \"\\f200\"; }\r\n\r\n.la.la-line-chart:before {\r\n  content: \"\\f201\"; }\r\n\r\n.la.la-lastfm {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-lastfm-square {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-ioxhost {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-angellist {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-cc {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-cc:before {\r\n  content: \"\\f20a\"; }\r\n\r\n.la.la-ils:before {\r\n  content: \"\\f20b\"; }\r\n\r\n.la.la-shekel:before {\r\n  content: \"\\f20b\"; }\r\n\r\n.la.la-sheqel:before {\r\n  content: \"\\f20b\"; }\r\n\r\n.la.la-meanpath {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-meanpath:before {\r\n  content: \"\\f2b4\"; }\r\n\r\n.la.la-buysellads {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-connectdevelop {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-dashcube {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-forumbee {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-leanpub {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-sellsy {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-shirtsinbulk {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-simplybuilt {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-skyatlas {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-diamond {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-diamond:before {\r\n  content: \"\\f3a5\"; }\r\n\r\n.la.la-intersex:before {\r\n  content: \"\\f224\"; }\r\n\r\n.la.la-facebook-official {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-facebook-official:before {\r\n  content: \"\\f09a\"; }\r\n\r\n.la.la-pinterest-p {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-whatsapp {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-hotel:before {\r\n  content: \"\\f236\"; }\r\n\r\n.la.la-viacoin {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-medium {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-y-combinator {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-yc {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-yc:before {\r\n  content: \"\\f23b\"; }\r\n\r\n.la.la-optin-monster {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-opencart {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-expeditedssl {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-battery-4:before {\r\n  content: \"\\f240\"; }\r\n\r\n.la.la-battery:before {\r\n  content: \"\\f240\"; }\r\n\r\n.la.la-battery-3:before {\r\n  content: \"\\f241\"; }\r\n\r\n.la.la-battery-2:before {\r\n  content: \"\\f242\"; }\r\n\r\n.la.la-battery-1:before {\r\n  content: \"\\f243\"; }\r\n\r\n.la.la-battery-0:before {\r\n  content: \"\\f244\"; }\r\n\r\n.la.la-object-group {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-object-ungroup {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-sticky-note-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-sticky-note-o:before {\r\n  content: \"\\f249\"; }\r\n\r\n.la.la-cc-jcb {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-cc-diners-club {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-clone {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-hourglass-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-hourglass-o:before {\r\n  content: \"\\f254\"; }\r\n\r\n.la.la-hourglass-1:before {\r\n  content: \"\\f251\"; }\r\n\r\n.la.la-hourglass-2:before {\r\n  content: \"\\f252\"; }\r\n\r\n.la.la-hourglass-3:before {\r\n  content: \"\\f253\"; }\r\n\r\n.la.la-hand-rock-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-hand-rock-o:before {\r\n  content: \"\\f255\"; }\r\n\r\n.la.la-hand-grab-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-hand-grab-o:before {\r\n  content: \"\\f255\"; }\r\n\r\n.la.la-hand-paper-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-hand-paper-o:before {\r\n  content: \"\\f256\"; }\r\n\r\n.la.la-hand-stop-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-hand-stop-o:before {\r\n  content: \"\\f256\"; }\r\n\r\n.la.la-hand-scissors-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-hand-scissors-o:before {\r\n  content: \"\\f257\"; }\r\n\r\n.la.la-hand-lizard-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-hand-lizard-o:before {\r\n  content: \"\\f258\"; }\r\n\r\n.la.la-hand-spock-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-hand-spock-o:before {\r\n  content: \"\\f259\"; }\r\n\r\n.la.la-hand-pointer-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-hand-pointer-o:before {\r\n  content: \"\\f25a\"; }\r\n\r\n.la.la-hand-peace-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-hand-peace-o:before {\r\n  content: \"\\f25b\"; }\r\n\r\n.la.la-registered {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-creative-commons {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-gg {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-gg-circle {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-tripadvisor {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-odnoklassniki {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-odnoklassniki-square {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-get-pocket {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-wikipedia-w {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-safari {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-chrome {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-firefox {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-opera {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-internet-explorer {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-television:before {\r\n  content: \"\\f26c\"; }\r\n\r\n.la.la-contao {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-500px {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-amazon {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-calendar-plus-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-calendar-plus-o:before {\r\n  content: \"\\f271\"; }\r\n\r\n.la.la-calendar-minus-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-calendar-minus-o:before {\r\n  content: \"\\f272\"; }\r\n\r\n.la.la-calendar-times-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-calendar-times-o:before {\r\n  content: \"\\f273\"; }\r\n\r\n.la.la-calendar-check-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-calendar-check-o:before {\r\n  content: \"\\f274\"; }\r\n\r\n.la.la-map-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-map-o:before {\r\n  content: \"\\f279\"; }\r\n\r\n.la.la-commenting:before {\r\n  content: \"\\f4ad\"; }\r\n\r\n.la.la-commenting-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-commenting-o:before {\r\n  content: \"\\f4ad\"; }\r\n\r\n.la.la-houzz {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-vimeo {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-vimeo:before {\r\n  content: \"\\f27d\"; }\r\n\r\n.la.la-black-tie {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-fonticons {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-reddit-alien {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-edge {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-credit-card-alt:before {\r\n  content: \"\\f09d\"; }\r\n\r\n.la.la-codiepie {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-modx {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-fort-awesome {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-usb {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-product-hunt {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-mixcloud {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-scribd {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-pause-circle-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-pause-circle-o:before {\r\n  content: \"\\f28b\"; }\r\n\r\n.la.la-stop-circle-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-stop-circle-o:before {\r\n  content: \"\\f28d\"; }\r\n\r\n.la.la-bluetooth {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-bluetooth-b {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-gitlab {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-wpbeginner {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-wpforms {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-envira {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-wheelchair-alt {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-wheelchair-alt:before {\r\n  content: \"\\f368\"; }\r\n\r\n.la.la-question-circle-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-question-circle-o:before {\r\n  content: \"\\f059\"; }\r\n\r\n.la.la-volume-control-phone:before {\r\n  content: \"\\f2a0\"; }\r\n\r\n.la.la-asl-interpreting:before {\r\n  content: \"\\f2a3\"; }\r\n\r\n.la.la-deafness:before {\r\n  content: \"\\f2a4\"; }\r\n\r\n.la.la-hard-of-hearing:before {\r\n  content: \"\\f2a4\"; }\r\n\r\n.la.la-glide {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-glide-g {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-signing:before {\r\n  content: \"\\f2a7\"; }\r\n\r\n.la.la-viadeo {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-viadeo-square {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-snapchat {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-snapchat-ghost {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-snapchat-square {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-pied-piper {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-first-order {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-yoast {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-themeisle {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-google-plus-official {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-google-plus-official:before {\r\n  content: \"\\f2b3\"; }\r\n\r\n.la.la-google-plus-circle {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-google-plus-circle:before {\r\n  content: \"\\f2b3\"; }\r\n\r\n.la.la-font-awesome {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-fa {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-fa:before {\r\n  content: \"\\f2b4\"; }\r\n\r\n.la.la-handshake-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-handshake-o:before {\r\n  content: \"\\f2b5\"; }\r\n\r\n.la.la-envelope-open-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-envelope-open-o:before {\r\n  content: \"\\f2b6\"; }\r\n\r\n.la.la-linode {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-address-book-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-address-book-o:before {\r\n  content: \"\\f2b9\"; }\r\n\r\n.la.la-vcard:before {\r\n  content: \"\\f2bb\"; }\r\n\r\n.la.la-address-card-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-address-card-o:before {\r\n  content: \"\\f2bb\"; }\r\n\r\n.la.la-vcard-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-vcard-o:before {\r\n  content: \"\\f2bb\"; }\r\n\r\n.la.la-user-circle-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-user-circle-o:before {\r\n  content: \"\\f2bd\"; }\r\n\r\n.la.la-user-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-user-o:before {\r\n  content: \"\\f007\"; }\r\n\r\n.la.la-id-badge {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-drivers-license:before {\r\n  content: \"\\f2c2\"; }\r\n\r\n.la.la-id-card-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-id-card-o:before {\r\n  content: \"\\f2c2\"; }\r\n\r\n.la.la-drivers-license-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-drivers-license-o:before {\r\n  content: \"\\f2c2\"; }\r\n\r\n.la.la-quora {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-free-code-camp {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-telegram {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-thermometer-4:before {\r\n  content: \"\\f2c7\"; }\r\n\r\n.la.la-thermometer:before {\r\n  content: \"\\f2c7\"; }\r\n\r\n.la.la-thermometer-3:before {\r\n  content: \"\\f2c8\"; }\r\n\r\n.la.la-thermometer-2:before {\r\n  content: \"\\f2c9\"; }\r\n\r\n.la.la-thermometer-1:before {\r\n  content: \"\\f2ca\"; }\r\n\r\n.la.la-thermometer-0:before {\r\n  content: \"\\f2cb\"; }\r\n\r\n.la.la-bathtub:before {\r\n  content: \"\\f2cd\"; }\r\n\r\n.la.la-s15:before {\r\n  content: \"\\f2cd\"; }\r\n\r\n.la.la-window-maximize {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-window-restore {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-times-rectangle:before {\r\n  content: \"\\f410\"; }\r\n\r\n.la.la-window-close-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-window-close-o:before {\r\n  content: \"\\f410\"; }\r\n\r\n.la.la-times-rectangle-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-times-rectangle-o:before {\r\n  content: \"\\f410\"; }\r\n\r\n.la.la-bandcamp {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-grav {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-etsy {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-imdb {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-ravelry {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-eercast {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-eercast:before {\r\n  content: \"\\f2da\"; }\r\n\r\n.la.la-snowflake-o {\r\n  font-family: 'Line Awesome Free';\r\n  font-weight: 400; }\r\n\r\n.la.la-snowflake-o:before {\r\n  content: \"\\f2dc\"; }\r\n\r\n.la.la-superpowers {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-wpexplorer {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n\r\n.la.la-spotify {\r\n  font-family: 'Line Awesome Brands';\r\n  font-weight: 400; }\r\n","/*\r\n* Remix Icon v2.5.0\r\n* https://remixicon.com\r\n* https://github.com/Remix-Design/RemixIcon\r\n*\r\n* Copyright RemixIcon.com\r\n* Released under the Apache License Version 2.0\r\n*\r\n* Date: 2020-05-23\r\n*/\r\n@font-face {\r\n  font-family: \"remixicon\";\r\n  src: url('../../../fonts/remixicon.eot?t=1590207869815'); /* IE9*/\r\n  src: url('../../../fonts/remixicon.eot?t=1590207869815#iefix') format('embedded-opentype'), /* IE6-IE8 */\r\n  url(\"../../../fonts/remixicon.woff2?t=1590207869815\") format(\"woff2\"),\r\n  url(\"../../../fonts/remixicon.woff?t=1590207869815\") format(\"woff\"),\r\n  url('../../../fonts/remixicon.ttf?t=1590207869815') format('truetype'), /* chrome, firefox, opera, Safari, Android, iOS 4.2+*/\r\n  url('../../../fonts/remixicon.svg?t=1590207869815#remixicon') format('svg'); /* iOS 4.1- */\r\n  font-display: swap;\r\n}\r\n\r\n[class^=\"ri-\"], [class*=\" ri-\"] {\r\n  font-family: 'remixicon' !important;\r\n  font-style: normal;\r\n  -webkit-font-smoothing: antialiased;\r\n  -moz-osx-font-smoothing: grayscale;\r\n}\r\n\r\n.ri-lg { font-size: 1.3333em; line-height: 0.75em; vertical-align: -.0667em; }\r\n.ri-xl { font-size: 1.5em; line-height: 0.6666em; vertical-align: -.075em; }\r\n.ri-xxs { font-size: .5em; }\r\n.ri-xs { font-size: .75em; }\r\n.ri-sm { font-size: .875em }\r\n.ri-1x { font-size: 1em; }\r\n.ri-2x { font-size: 2em; }\r\n.ri-3x { font-size: 3em; }\r\n.ri-4x { font-size: 4em; }\r\n.ri-5x { font-size: 5em; }\r\n.ri-6x { font-size: 6em; }\r\n.ri-7x { font-size: 7em; }\r\n.ri-8x { font-size: 8em; }\r\n.ri-9x { font-size: 9em; }\r\n.ri-10x { font-size: 10em; }\r\n.ri-fw { text-align: center; width: 1.25em; }\r\n\r\n.ri-24-hours-fill:before { content: \"\\ea01\"; }\r\n.ri-24-hours-line:before { content: \"\\ea02\"; }\r\n.ri-4k-fill:before { content: \"\\ea03\"; }\r\n.ri-4k-line:before { content: \"\\ea04\"; }\r\n.ri-a-b:before { content: \"\\ea05\"; }\r\n.ri-account-box-fill:before { content: \"\\ea06\"; }\r\n.ri-account-box-line:before { content: \"\\ea07\"; }\r\n.ri-account-circle-fill:before { content: \"\\ea08\"; }\r\n.ri-account-circle-line:before { content: \"\\ea09\"; }\r\n.ri-account-pin-box-fill:before { content: \"\\ea0a\"; }\r\n.ri-account-pin-box-line:before { content: \"\\ea0b\"; }\r\n.ri-account-pin-circle-fill:before { content: \"\\ea0c\"; }\r\n.ri-account-pin-circle-line:before { content: \"\\ea0d\"; }\r\n.ri-add-box-fill:before { content: \"\\ea0e\"; }\r\n.ri-add-box-line:before { content: \"\\ea0f\"; }\r\n.ri-add-circle-fill:before { content: \"\\ea10\"; }\r\n.ri-add-circle-line:before { content: \"\\ea11\"; }\r\n.ri-add-fill:before { content: \"\\ea12\"; }\r\n.ri-add-line:before { content: \"\\ea13\"; }\r\n.ri-admin-fill:before { content: \"\\ea14\"; }\r\n.ri-admin-line:before { content: \"\\ea15\"; }\r\n.ri-advertisement-fill:before { content: \"\\ea16\"; }\r\n.ri-advertisement-line:before { content: \"\\ea17\"; }\r\n.ri-airplay-fill:before { content: \"\\ea18\"; }\r\n.ri-airplay-line:before { content: \"\\ea19\"; }\r\n.ri-alarm-fill:before { content: \"\\ea1a\"; }\r\n.ri-alarm-line:before { content: \"\\ea1b\"; }\r\n.ri-alarm-warning-fill:before { content: \"\\ea1c\"; }\r\n.ri-alarm-warning-line:before { content: \"\\ea1d\"; }\r\n.ri-album-fill:before { content: \"\\ea1e\"; }\r\n.ri-album-line:before { content: \"\\ea1f\"; }\r\n.ri-alert-fill:before { content: \"\\ea20\"; }\r\n.ri-alert-line:before { content: \"\\ea21\"; }\r\n.ri-aliens-fill:before { content: \"\\ea22\"; }\r\n.ri-aliens-line:before { content: \"\\ea23\"; }\r\n.ri-align-bottom:before { content: \"\\ea24\"; }\r\n.ri-align-center:before { content: \"\\ea25\"; }\r\n.ri-align-justify:before { content: \"\\ea26\"; }\r\n.ri-align-left:before { content: \"\\ea27\"; }\r\n.ri-align-right:before { content: \"\\ea28\"; }\r\n.ri-align-top:before { content: \"\\ea29\"; }\r\n.ri-align-vertically:before { content: \"\\ea2a\"; }\r\n.ri-alipay-fill:before { content: \"\\ea2b\"; }\r\n.ri-alipay-line:before { content: \"\\ea2c\"; }\r\n.ri-amazon-fill:before { content: \"\\ea2d\"; }\r\n.ri-amazon-line:before { content: \"\\ea2e\"; }\r\n.ri-anchor-fill:before { content: \"\\ea2f\"; }\r\n.ri-anchor-line:before { content: \"\\ea30\"; }\r\n.ri-ancient-gate-fill:before { content: \"\\ea31\"; }\r\n.ri-ancient-gate-line:before { content: \"\\ea32\"; }\r\n.ri-ancient-pavilion-fill:before { content: \"\\ea33\"; }\r\n.ri-ancient-pavilion-line:before { content: \"\\ea34\"; }\r\n.ri-android-fill:before { content: \"\\ea35\"; }\r\n.ri-android-line:before { content: \"\\ea36\"; }\r\n.ri-angularjs-fill:before { content: \"\\ea37\"; }\r\n.ri-angularjs-line:before { content: \"\\ea38\"; }\r\n.ri-anticlockwise-2-fill:before { content: \"\\ea39\"; }\r\n.ri-anticlockwise-2-line:before { content: \"\\ea3a\"; }\r\n.ri-anticlockwise-fill:before { content: \"\\ea3b\"; }\r\n.ri-anticlockwise-line:before { content: \"\\ea3c\"; }\r\n.ri-app-store-fill:before { content: \"\\ea3d\"; }\r\n.ri-app-store-line:before { content: \"\\ea3e\"; }\r\n.ri-apple-fill:before { content: \"\\ea3f\"; }\r\n.ri-apple-line:before { content: \"\\ea40\"; }\r\n.ri-apps-2-fill:before { content: \"\\ea41\"; }\r\n.ri-apps-2-line:before { content: \"\\ea42\"; }\r\n.ri-apps-fill:before { content: \"\\ea43\"; }\r\n.ri-apps-line:before { content: \"\\ea44\"; }\r\n.ri-archive-drawer-fill:before { content: \"\\ea45\"; }\r\n.ri-archive-drawer-line:before { content: \"\\ea46\"; }\r\n.ri-archive-fill:before { content: \"\\ea47\"; }\r\n.ri-archive-line:before { content: \"\\ea48\"; }\r\n.ri-arrow-down-circle-fill:before { content: \"\\ea49\"; }\r\n.ri-arrow-down-circle-line:before { content: \"\\ea4a\"; }\r\n.ri-arrow-down-fill:before { content: \"\\ea4b\"; }\r\n.ri-arrow-down-line:before { content: \"\\ea4c\"; }\r\n.ri-arrow-down-s-fill:before { content: \"\\ea4d\"; }\r\n.ri-arrow-down-s-line:before { content: \"\\ea4e\"; }\r\n.ri-arrow-drop-down-fill:before { content: \"\\ea4f\"; }\r\n.ri-arrow-drop-down-line:before { content: \"\\ea50\"; }\r\n.ri-arrow-drop-left-fill:before { content: \"\\ea51\"; }\r\n.ri-arrow-drop-left-line:before { content: \"\\ea52\"; }\r\n.ri-arrow-drop-right-fill:before { content: \"\\ea53\"; }\r\n.ri-arrow-drop-right-line:before { content: \"\\ea54\"; }\r\n.ri-arrow-drop-up-fill:before { content: \"\\ea55\"; }\r\n.ri-arrow-drop-up-line:before { content: \"\\ea56\"; }\r\n.ri-arrow-go-back-fill:before { content: \"\\ea57\"; }\r\n.ri-arrow-go-back-line:before { content: \"\\ea58\"; }\r\n.ri-arrow-go-forward-fill:before { content: \"\\ea59\"; }\r\n.ri-arrow-go-forward-line:before { content: \"\\ea5a\"; }\r\n.ri-arrow-left-circle-fill:before { content: \"\\ea5b\"; }\r\n.ri-arrow-left-circle-line:before { content: \"\\ea5c\"; }\r\n.ri-arrow-left-down-fill:before { content: \"\\ea5d\"; }\r\n.ri-arrow-left-down-line:before { content: \"\\ea5e\"; }\r\n.ri-arrow-left-fill:before { content: \"\\ea5f\"; }\r\n.ri-arrow-left-line:before { content: \"\\ea60\"; }\r\n.ri-arrow-left-right-fill:before { content: \"\\ea61\"; }\r\n.ri-arrow-left-right-line:before { content: \"\\ea62\"; }\r\n.ri-arrow-left-s-fill:before { content: \"\\ea63\"; }\r\n.ri-arrow-left-s-line:before { content: \"\\ea64\"; }\r\n.ri-arrow-left-up-fill:before { content: \"\\ea65\"; }\r\n.ri-arrow-left-up-line:before { content: \"\\ea66\"; }\r\n.ri-arrow-right-circle-fill:before { content: \"\\ea67\"; }\r\n.ri-arrow-right-circle-line:before { content: \"\\ea68\"; }\r\n.ri-arrow-right-down-fill:before { content: \"\\ea69\"; }\r\n.ri-arrow-right-down-line:before { content: \"\\ea6a\"; }\r\n.ri-arrow-right-fill:before { content: \"\\ea6b\"; }\r\n.ri-arrow-right-line:before { content: \"\\ea6c\"; }\r\n.ri-arrow-right-s-fill:before { content: \"\\ea6d\"; }\r\n.ri-arrow-right-s-line:before { content: \"\\ea6e\"; }\r\n.ri-arrow-right-up-fill:before { content: \"\\ea6f\"; }\r\n.ri-arrow-right-up-line:before { content: \"\\ea70\"; }\r\n.ri-arrow-up-circle-fill:before { content: \"\\ea71\"; }\r\n.ri-arrow-up-circle-line:before { content: \"\\ea72\"; }\r\n.ri-arrow-up-down-fill:before { content: \"\\ea73\"; }\r\n.ri-arrow-up-down-line:before { content: \"\\ea74\"; }\r\n.ri-arrow-up-fill:before { content: \"\\ea75\"; }\r\n.ri-arrow-up-line:before { content: \"\\ea76\"; }\r\n.ri-arrow-up-s-fill:before { content: \"\\ea77\"; }\r\n.ri-arrow-up-s-line:before { content: \"\\ea78\"; }\r\n.ri-artboard-2-fill:before { content: \"\\ea79\"; }\r\n.ri-artboard-2-line:before { content: \"\\ea7a\"; }\r\n.ri-artboard-fill:before { content: \"\\ea7b\"; }\r\n.ri-artboard-line:before { content: \"\\ea7c\"; }\r\n.ri-article-fill:before { content: \"\\ea7d\"; }\r\n.ri-article-line:before { content: \"\\ea7e\"; }\r\n.ri-aspect-ratio-fill:before { content: \"\\ea7f\"; }\r\n.ri-aspect-ratio-line:before { content: \"\\ea80\"; }\r\n.ri-asterisk:before { content: \"\\ea81\"; }\r\n.ri-at-fill:before { content: \"\\ea82\"; }\r\n.ri-at-line:before { content: \"\\ea83\"; }\r\n.ri-attachment-2:before { content: \"\\ea84\"; }\r\n.ri-attachment-fill:before { content: \"\\ea85\"; }\r\n.ri-attachment-line:before { content: \"\\ea86\"; }\r\n.ri-auction-fill:before { content: \"\\ea87\"; }\r\n.ri-auction-line:before { content: \"\\ea88\"; }\r\n.ri-award-fill:before { content: \"\\ea89\"; }\r\n.ri-award-line:before { content: \"\\ea8a\"; }\r\n.ri-baidu-fill:before { content: \"\\ea8b\"; }\r\n.ri-baidu-line:before { content: \"\\ea8c\"; }\r\n.ri-ball-pen-fill:before { content: \"\\ea8d\"; }\r\n.ri-ball-pen-line:before { content: \"\\ea8e\"; }\r\n.ri-bank-card-2-fill:before { content: \"\\ea8f\"; }\r\n.ri-bank-card-2-line:before { content: \"\\ea90\"; }\r\n.ri-bank-card-fill:before { content: \"\\ea91\"; }\r\n.ri-bank-card-line:before { content: \"\\ea92\"; }\r\n.ri-bank-fill:before { content: \"\\ea93\"; }\r\n.ri-bank-line:before { content: \"\\ea94\"; }\r\n.ri-bar-chart-2-fill:before { content: \"\\ea95\"; }\r\n.ri-bar-chart-2-line:before { content: \"\\ea96\"; }\r\n.ri-bar-chart-box-fill:before { content: \"\\ea97\"; }\r\n.ri-bar-chart-box-line:before { content: \"\\ea98\"; }\r\n.ri-bar-chart-fill:before { content: \"\\ea99\"; }\r\n.ri-bar-chart-grouped-fill:before { content: \"\\ea9a\"; }\r\n.ri-bar-chart-grouped-line:before { content: \"\\ea9b\"; }\r\n.ri-bar-chart-horizontal-fill:before { content: \"\\ea9c\"; }\r\n.ri-bar-chart-horizontal-line:before { content: \"\\ea9d\"; }\r\n.ri-bar-chart-line:before { content: \"\\ea9e\"; }\r\n.ri-barcode-box-fill:before { content: \"\\ea9f\"; }\r\n.ri-barcode-box-line:before { content: \"\\eaa0\"; }\r\n.ri-barcode-fill:before { content: \"\\eaa1\"; }\r\n.ri-barcode-line:before { content: \"\\eaa2\"; }\r\n.ri-barricade-fill:before { content: \"\\eaa3\"; }\r\n.ri-barricade-line:before { content: \"\\eaa4\"; }\r\n.ri-base-station-fill:before { content: \"\\eaa5\"; }\r\n.ri-base-station-line:before { content: \"\\eaa6\"; }\r\n.ri-basketball-fill:before { content: \"\\eaa7\"; }\r\n.ri-basketball-line:before { content: \"\\eaa8\"; }\r\n.ri-battery-2-charge-fill:before { content: \"\\eaa9\"; }\r\n.ri-battery-2-charge-line:before { content: \"\\eaaa\"; }\r\n.ri-battery-2-fill:before { content: \"\\eaab\"; }\r\n.ri-battery-2-line:before { content: \"\\eaac\"; }\r\n.ri-battery-charge-fill:before { content: \"\\eaad\"; }\r\n.ri-battery-charge-line:before { content: \"\\eaae\"; }\r\n.ri-battery-fill:before { content: \"\\eaaf\"; }\r\n.ri-battery-line:before { content: \"\\eab0\"; }\r\n.ri-battery-low-fill:before { content: \"\\eab1\"; }\r\n.ri-battery-low-line:before { content: \"\\eab2\"; }\r\n.ri-battery-saver-fill:before { content: \"\\eab3\"; }\r\n.ri-battery-saver-line:before { content: \"\\eab4\"; }\r\n.ri-battery-share-fill:before { content: \"\\eab5\"; }\r\n.ri-battery-share-line:before { content: \"\\eab6\"; }\r\n.ri-bear-smile-fill:before { content: \"\\eab7\"; }\r\n.ri-bear-smile-line:before { content: \"\\eab8\"; }\r\n.ri-behance-fill:before { content: \"\\eab9\"; }\r\n.ri-behance-line:before { content: \"\\eaba\"; }\r\n.ri-bell-fill:before { content: \"\\eabb\"; }\r\n.ri-bell-line:before { content: \"\\eabc\"; }\r\n.ri-bike-fill:before { content: \"\\eabd\"; }\r\n.ri-bike-line:before { content: \"\\eabe\"; }\r\n.ri-bilibili-fill:before { content: \"\\eabf\"; }\r\n.ri-bilibili-line:before { content: \"\\eac0\"; }\r\n.ri-bill-fill:before { content: \"\\eac1\"; }\r\n.ri-bill-line:before { content: \"\\eac2\"; }\r\n.ri-billiards-fill:before { content: \"\\eac3\"; }\r\n.ri-billiards-line:before { content: \"\\eac4\"; }\r\n.ri-bit-coin-fill:before { content: \"\\eac5\"; }\r\n.ri-bit-coin-line:before { content: \"\\eac6\"; }\r\n.ri-blaze-fill:before { content: \"\\eac7\"; }\r\n.ri-blaze-line:before { content: \"\\eac8\"; }\r\n.ri-bluetooth-connect-fill:before { content: \"\\eac9\"; }\r\n.ri-bluetooth-connect-line:before { content: \"\\eaca\"; }\r\n.ri-bluetooth-fill:before { content: \"\\eacb\"; }\r\n.ri-bluetooth-line:before { content: \"\\eacc\"; }\r\n.ri-blur-off-fill:before { content: \"\\eacd\"; }\r\n.ri-blur-off-line:before { content: \"\\eace\"; }\r\n.ri-body-scan-fill:before { content: \"\\eacf\"; }\r\n.ri-body-scan-line:before { content: \"\\ead0\"; }\r\n.ri-bold:before { content: \"\\ead1\"; }\r\n.ri-book-2-fill:before { content: \"\\ead2\"; }\r\n.ri-book-2-line:before { content: \"\\ead3\"; }\r\n.ri-book-3-fill:before { content: \"\\ead4\"; }\r\n.ri-book-3-line:before { content: \"\\ead5\"; }\r\n.ri-book-fill:before { content: \"\\ead6\"; }\r\n.ri-book-line:before { content: \"\\ead7\"; }\r\n.ri-book-mark-fill:before { content: \"\\ead8\"; }\r\n.ri-book-mark-line:before { content: \"\\ead9\"; }\r\n.ri-book-open-fill:before { content: \"\\eada\"; }\r\n.ri-book-open-line:before { content: \"\\eadb\"; }\r\n.ri-book-read-fill:before { content: \"\\eadc\"; }\r\n.ri-book-read-line:before { content: \"\\eadd\"; }\r\n.ri-booklet-fill:before { content: \"\\eade\"; }\r\n.ri-booklet-line:before { content: \"\\eadf\"; }\r\n.ri-bookmark-2-fill:before { content: \"\\eae0\"; }\r\n.ri-bookmark-2-line:before { content: \"\\eae1\"; }\r\n.ri-bookmark-3-fill:before { content: \"\\eae2\"; }\r\n.ri-bookmark-3-line:before { content: \"\\eae3\"; }\r\n.ri-bookmark-fill:before { content: \"\\eae4\"; }\r\n.ri-bookmark-line:before { content: \"\\eae5\"; }\r\n.ri-boxing-fill:before { content: \"\\eae6\"; }\r\n.ri-boxing-line:before { content: \"\\eae7\"; }\r\n.ri-braces-fill:before { content: \"\\eae8\"; }\r\n.ri-braces-line:before { content: \"\\eae9\"; }\r\n.ri-brackets-fill:before { content: \"\\eaea\"; }\r\n.ri-brackets-line:before { content: \"\\eaeb\"; }\r\n.ri-briefcase-2-fill:before { content: \"\\eaec\"; }\r\n.ri-briefcase-2-line:before { content: \"\\eaed\"; }\r\n.ri-briefcase-3-fill:before { content: \"\\eaee\"; }\r\n.ri-briefcase-3-line:before { content: \"\\eaef\"; }\r\n.ri-briefcase-4-fill:before { content: \"\\eaf0\"; }\r\n.ri-briefcase-4-line:before { content: \"\\eaf1\"; }\r\n.ri-briefcase-5-fill:before { content: \"\\eaf2\"; }\r\n.ri-briefcase-5-line:before { content: \"\\eaf3\"; }\r\n.ri-briefcase-fill:before { content: \"\\eaf4\"; }\r\n.ri-briefcase-line:before { content: \"\\eaf5\"; }\r\n.ri-bring-forward:before { content: \"\\eaf6\"; }\r\n.ri-bring-to-front:before { content: \"\\eaf7\"; }\r\n.ri-broadcast-fill:before { content: \"\\eaf8\"; }\r\n.ri-broadcast-line:before { content: \"\\eaf9\"; }\r\n.ri-brush-2-fill:before { content: \"\\eafa\"; }\r\n.ri-brush-2-line:before { content: \"\\eafb\"; }\r\n.ri-brush-3-fill:before { content: \"\\eafc\"; }\r\n.ri-brush-3-line:before { content: \"\\eafd\"; }\r\n.ri-brush-4-fill:before { content: \"\\eafe\"; }\r\n.ri-brush-4-line:before { content: \"\\eaff\"; }\r\n.ri-brush-fill:before { content: \"\\eb00\"; }\r\n.ri-brush-line:before { content: \"\\eb01\"; }\r\n.ri-bubble-chart-fill:before { content: \"\\eb02\"; }\r\n.ri-bubble-chart-line:before { content: \"\\eb03\"; }\r\n.ri-bug-2-fill:before { content: \"\\eb04\"; }\r\n.ri-bug-2-line:before { content: \"\\eb05\"; }\r\n.ri-bug-fill:before { content: \"\\eb06\"; }\r\n.ri-bug-line:before { content: \"\\eb07\"; }\r\n.ri-building-2-fill:before { content: \"\\eb08\"; }\r\n.ri-building-2-line:before { content: \"\\eb09\"; }\r\n.ri-building-3-fill:before { content: \"\\eb0a\"; }\r\n.ri-building-3-line:before { content: \"\\eb0b\"; }\r\n.ri-building-4-fill:before { content: \"\\eb0c\"; }\r\n.ri-building-4-line:before { content: \"\\eb0d\"; }\r\n.ri-building-fill:before { content: \"\\eb0e\"; }\r\n.ri-building-line:before { content: \"\\eb0f\"; }\r\n.ri-bus-2-fill:before { content: \"\\eb10\"; }\r\n.ri-bus-2-line:before { content: \"\\eb11\"; }\r\n.ri-bus-fill:before { content: \"\\eb12\"; }\r\n.ri-bus-line:before { content: \"\\eb13\"; }\r\n.ri-bus-wifi-fill:before { content: \"\\eb14\"; }\r\n.ri-bus-wifi-line:before { content: \"\\eb15\"; }\r\n.ri-cactus-fill:before { content: \"\\eb16\"; }\r\n.ri-cactus-line:before { content: \"\\eb17\"; }\r\n.ri-cake-2-fill:before { content: \"\\eb18\"; }\r\n.ri-cake-2-line:before { content: \"\\eb19\"; }\r\n.ri-cake-3-fill:before { content: \"\\eb1a\"; }\r\n.ri-cake-3-line:before { content: \"\\eb1b\"; }\r\n.ri-cake-fill:before { content: \"\\eb1c\"; }\r\n.ri-cake-line:before { content: \"\\eb1d\"; }\r\n.ri-calculator-fill:before { content: \"\\eb1e\"; }\r\n.ri-calculator-line:before { content: \"\\eb1f\"; }\r\n.ri-calendar-2-fill:before { content: \"\\eb20\"; }\r\n.ri-calendar-2-line:before { content: \"\\eb21\"; }\r\n.ri-calendar-check-fill:before { content: \"\\eb22\"; }\r\n.ri-calendar-check-line:before { content: \"\\eb23\"; }\r\n.ri-calendar-event-fill:before { content: \"\\eb24\"; }\r\n.ri-calendar-event-line:before { content: \"\\eb25\"; }\r\n.ri-calendar-fill:before { content: \"\\eb26\"; }\r\n.ri-calendar-line:before { content: \"\\eb27\"; }\r\n.ri-calendar-todo-fill:before { content: \"\\eb28\"; }\r\n.ri-calendar-todo-line:before { content: \"\\eb29\"; }\r\n.ri-camera-2-fill:before { content: \"\\eb2a\"; }\r\n.ri-camera-2-line:before { content: \"\\eb2b\"; }\r\n.ri-camera-3-fill:before { content: \"\\eb2c\"; }\r\n.ri-camera-3-line:before { content: \"\\eb2d\"; }\r\n.ri-camera-fill:before { content: \"\\eb2e\"; }\r\n.ri-camera-lens-fill:before { content: \"\\eb2f\"; }\r\n.ri-camera-lens-line:before { content: \"\\eb30\"; }\r\n.ri-camera-line:before { content: \"\\eb31\"; }\r\n.ri-camera-off-fill:before { content: \"\\eb32\"; }\r\n.ri-camera-off-line:before { content: \"\\eb33\"; }\r\n.ri-camera-switch-fill:before { content: \"\\eb34\"; }\r\n.ri-camera-switch-line:before { content: \"\\eb35\"; }\r\n.ri-capsule-fill:before { content: \"\\eb36\"; }\r\n.ri-capsule-line:before { content: \"\\eb37\"; }\r\n.ri-car-fill:before { content: \"\\eb38\"; }\r\n.ri-car-line:before { content: \"\\eb39\"; }\r\n.ri-car-washing-fill:before { content: \"\\eb3a\"; }\r\n.ri-car-washing-line:before { content: \"\\eb3b\"; }\r\n.ri-caravan-fill:before { content: \"\\eb3c\"; }\r\n.ri-caravan-line:before { content: \"\\eb3d\"; }\r\n.ri-cast-fill:before { content: \"\\eb3e\"; }\r\n.ri-cast-line:before { content: \"\\eb3f\"; }\r\n.ri-cellphone-fill:before { content: \"\\eb40\"; }\r\n.ri-cellphone-line:before { content: \"\\eb41\"; }\r\n.ri-celsius-fill:before { content: \"\\eb42\"; }\r\n.ri-celsius-line:before { content: \"\\eb43\"; }\r\n.ri-centos-fill:before { content: \"\\eb44\"; }\r\n.ri-centos-line:before { content: \"\\eb45\"; }\r\n.ri-character-recognition-fill:before { content: \"\\eb46\"; }\r\n.ri-character-recognition-line:before { content: \"\\eb47\"; }\r\n.ri-charging-pile-2-fill:before { content: \"\\eb48\"; }\r\n.ri-charging-pile-2-line:before { content: \"\\eb49\"; }\r\n.ri-charging-pile-fill:before { content: \"\\eb4a\"; }\r\n.ri-charging-pile-line:before { content: \"\\eb4b\"; }\r\n.ri-chat-1-fill:before { content: \"\\eb4c\"; }\r\n.ri-chat-1-line:before { content: \"\\eb4d\"; }\r\n.ri-chat-2-fill:before { content: \"\\eb4e\"; }\r\n.ri-chat-2-line:before { content: \"\\eb4f\"; }\r\n.ri-chat-3-fill:before { content: \"\\eb50\"; }\r\n.ri-chat-3-line:before { content: \"\\eb51\"; }\r\n.ri-chat-4-fill:before { content: \"\\eb52\"; }\r\n.ri-chat-4-line:before { content: \"\\eb53\"; }\r\n.ri-chat-check-fill:before { content: \"\\eb54\"; }\r\n.ri-chat-check-line:before { content: \"\\eb55\"; }\r\n.ri-chat-delete-fill:before { content: \"\\eb56\"; }\r\n.ri-chat-delete-line:before { content: \"\\eb57\"; }\r\n.ri-chat-download-fill:before { content: \"\\eb58\"; }\r\n.ri-chat-download-line:before { content: \"\\eb59\"; }\r\n.ri-chat-follow-up-fill:before { content: \"\\eb5a\"; }\r\n.ri-chat-follow-up-line:before { content: \"\\eb5b\"; }\r\n.ri-chat-forward-fill:before { content: \"\\eb5c\"; }\r\n.ri-chat-forward-line:before { content: \"\\eb5d\"; }\r\n.ri-chat-heart-fill:before { content: \"\\eb5e\"; }\r\n.ri-chat-heart-line:before { content: \"\\eb5f\"; }\r\n.ri-chat-history-fill:before { content: \"\\eb60\"; }\r\n.ri-chat-history-line:before { content: \"\\eb61\"; }\r\n.ri-chat-new-fill:before { content: \"\\eb62\"; }\r\n.ri-chat-new-line:before { content: \"\\eb63\"; }\r\n.ri-chat-off-fill:before { content: \"\\eb64\"; }\r\n.ri-chat-off-line:before { content: \"\\eb65\"; }\r\n.ri-chat-poll-fill:before { content: \"\\eb66\"; }\r\n.ri-chat-poll-line:before { content: \"\\eb67\"; }\r\n.ri-chat-private-fill:before { content: \"\\eb68\"; }\r\n.ri-chat-private-line:before { content: \"\\eb69\"; }\r\n.ri-chat-quote-fill:before { content: \"\\eb6a\"; }\r\n.ri-chat-quote-line:before { content: \"\\eb6b\"; }\r\n.ri-chat-settings-fill:before { content: \"\\eb6c\"; }\r\n.ri-chat-settings-line:before { content: \"\\eb6d\"; }\r\n.ri-chat-smile-2-fill:before { content: \"\\eb6e\"; }\r\n.ri-chat-smile-2-line:before { content: \"\\eb6f\"; }\r\n.ri-chat-smile-3-fill:before { content: \"\\eb70\"; }\r\n.ri-chat-smile-3-line:before { content: \"\\eb71\"; }\r\n.ri-chat-smile-fill:before { content: \"\\eb72\"; }\r\n.ri-chat-smile-line:before { content: \"\\eb73\"; }\r\n.ri-chat-upload-fill:before { content: \"\\eb74\"; }\r\n.ri-chat-upload-line:before { content: \"\\eb75\"; }\r\n.ri-chat-voice-fill:before { content: \"\\eb76\"; }\r\n.ri-chat-voice-line:before { content: \"\\eb77\"; }\r\n.ri-check-double-fill:before { content: \"\\eb78\"; }\r\n.ri-check-double-line:before { content: \"\\eb79\"; }\r\n.ri-check-fill:before { content: \"\\eb7a\"; }\r\n.ri-check-line:before { content: \"\\eb7b\"; }\r\n.ri-checkbox-blank-circle-fill:before { content: \"\\eb7c\"; }\r\n.ri-checkbox-blank-circle-line:before { content: \"\\eb7d\"; }\r\n.ri-checkbox-blank-fill:before { content: \"\\eb7e\"; }\r\n.ri-checkbox-blank-line:before { content: \"\\eb7f\"; }\r\n.ri-checkbox-circle-fill:before { content: \"\\eb80\"; }\r\n.ri-checkbox-circle-line:before { content: \"\\eb81\"; }\r\n.ri-checkbox-fill:before { content: \"\\eb82\"; }\r\n.ri-checkbox-indeterminate-fill:before { content: \"\\eb83\"; }\r\n.ri-checkbox-indeterminate-line:before { content: \"\\eb84\"; }\r\n.ri-checkbox-line:before { content: \"\\eb85\"; }\r\n.ri-checkbox-multiple-blank-fill:before { content: \"\\eb86\"; }\r\n.ri-checkbox-multiple-blank-line:before { content: \"\\eb87\"; }\r\n.ri-checkbox-multiple-fill:before { content: \"\\eb88\"; }\r\n.ri-checkbox-multiple-line:before { content: \"\\eb89\"; }\r\n.ri-china-railway-fill:before { content: \"\\eb8a\"; }\r\n.ri-china-railway-line:before { content: \"\\eb8b\"; }\r\n.ri-chrome-fill:before { content: \"\\eb8c\"; }\r\n.ri-chrome-line:before { content: \"\\eb8d\"; }\r\n.ri-clapperboard-fill:before { content: \"\\eb8e\"; }\r\n.ri-clapperboard-line:before { content: \"\\eb8f\"; }\r\n.ri-clipboard-fill:before { content: \"\\eb90\"; }\r\n.ri-clipboard-line:before { content: \"\\eb91\"; }\r\n.ri-clockwise-2-fill:before { content: \"\\eb92\"; }\r\n.ri-clockwise-2-line:before { content: \"\\eb93\"; }\r\n.ri-clockwise-fill:before { content: \"\\eb94\"; }\r\n.ri-clockwise-line:before { content: \"\\eb95\"; }\r\n.ri-close-circle-fill:before { content: \"\\eb96\"; }\r\n.ri-close-circle-line:before { content: \"\\eb97\"; }\r\n.ri-close-fill:before { content: \"\\eb98\"; }\r\n.ri-close-line:before { content: \"\\eb99\"; }\r\n.ri-closed-captioning-fill:before { content: \"\\eb9a\"; }\r\n.ri-closed-captioning-line:before { content: \"\\eb9b\"; }\r\n.ri-cloud-fill:before { content: \"\\eb9c\"; }\r\n.ri-cloud-line:before { content: \"\\eb9d\"; }\r\n.ri-cloud-off-fill:before { content: \"\\eb9e\"; }\r\n.ri-cloud-off-line:before { content: \"\\eb9f\"; }\r\n.ri-cloud-windy-fill:before { content: \"\\eba0\"; }\r\n.ri-cloud-windy-line:before { content: \"\\eba1\"; }\r\n.ri-cloudy-2-fill:before { content: \"\\eba2\"; }\r\n.ri-cloudy-2-line:before { content: \"\\eba3\"; }\r\n.ri-cloudy-fill:before { content: \"\\eba4\"; }\r\n.ri-cloudy-line:before { content: \"\\eba5\"; }\r\n.ri-code-box-fill:before { content: \"\\eba6\"; }\r\n.ri-code-box-line:before { content: \"\\eba7\"; }\r\n.ri-code-fill:before { content: \"\\eba8\"; }\r\n.ri-code-line:before { content: \"\\eba9\"; }\r\n.ri-code-s-fill:before { content: \"\\ebaa\"; }\r\n.ri-code-s-line:before { content: \"\\ebab\"; }\r\n.ri-code-s-slash-fill:before { content: \"\\ebac\"; }\r\n.ri-code-s-slash-line:before { content: \"\\ebad\"; }\r\n.ri-code-view:before { content: \"\\ebae\"; }\r\n.ri-codepen-fill:before { content: \"\\ebaf\"; }\r\n.ri-codepen-line:before { content: \"\\ebb0\"; }\r\n.ri-coin-fill:before { content: \"\\ebb1\"; }\r\n.ri-coin-line:before { content: \"\\ebb2\"; }\r\n.ri-coins-fill:before { content: \"\\ebb3\"; }\r\n.ri-coins-line:before { content: \"\\ebb4\"; }\r\n.ri-collage-fill:before { content: \"\\ebb5\"; }\r\n.ri-collage-line:before { content: \"\\ebb6\"; }\r\n.ri-command-fill:before { content: \"\\ebb7\"; }\r\n.ri-command-line:before { content: \"\\ebb8\"; }\r\n.ri-community-fill:before { content: \"\\ebb9\"; }\r\n.ri-community-line:before { content: \"\\ebba\"; }\r\n.ri-compass-2-fill:before { content: \"\\ebbb\"; }\r\n.ri-compass-2-line:before { content: \"\\ebbc\"; }\r\n.ri-compass-3-fill:before { content: \"\\ebbd\"; }\r\n.ri-compass-3-line:before { content: \"\\ebbe\"; }\r\n.ri-compass-4-fill:before { content: \"\\ebbf\"; }\r\n.ri-compass-4-line:before { content: \"\\ebc0\"; }\r\n.ri-compass-discover-fill:before { content: \"\\ebc1\"; }\r\n.ri-compass-discover-line:before { content: \"\\ebc2\"; }\r\n.ri-compass-fill:before { content: \"\\ebc3\"; }\r\n.ri-compass-line:before { content: \"\\ebc4\"; }\r\n.ri-compasses-2-fill:before { content: \"\\ebc5\"; }\r\n.ri-compasses-2-line:before { content: \"\\ebc6\"; }\r\n.ri-compasses-fill:before { content: \"\\ebc7\"; }\r\n.ri-compasses-line:before { content: \"\\ebc8\"; }\r\n.ri-computer-fill:before { content: \"\\ebc9\"; }\r\n.ri-computer-line:before { content: \"\\ebca\"; }\r\n.ri-contacts-book-2-fill:before { content: \"\\ebcb\"; }\r\n.ri-contacts-book-2-line:before { content: \"\\ebcc\"; }\r\n.ri-contacts-book-fill:before { content: \"\\ebcd\"; }\r\n.ri-contacts-book-line:before { content: \"\\ebce\"; }\r\n.ri-contacts-book-upload-fill:before { content: \"\\ebcf\"; }\r\n.ri-contacts-book-upload-line:before { content: \"\\ebd0\"; }\r\n.ri-contacts-fill:before { content: \"\\ebd1\"; }\r\n.ri-contacts-line:before { content: \"\\ebd2\"; }\r\n.ri-contrast-2-fill:before { content: \"\\ebd3\"; }\r\n.ri-contrast-2-line:before { content: \"\\ebd4\"; }\r\n.ri-contrast-drop-2-fill:before { content: \"\\ebd5\"; }\r\n.ri-contrast-drop-2-line:before { content: \"\\ebd6\"; }\r\n.ri-contrast-drop-fill:before { content: \"\\ebd7\"; }\r\n.ri-contrast-drop-line:before { content: \"\\ebd8\"; }\r\n.ri-contrast-fill:before { content: \"\\ebd9\"; }\r\n.ri-contrast-line:before { content: \"\\ebda\"; }\r\n.ri-copper-coin-fill:before { content: \"\\ebdb\"; }\r\n.ri-copper-coin-line:before { content: \"\\ebdc\"; }\r\n.ri-copper-diamond-fill:before { content: \"\\ebdd\"; }\r\n.ri-copper-diamond-line:before { content: \"\\ebde\"; }\r\n.ri-copyleft-fill:before { content: \"\\ebdf\"; }\r\n.ri-copyleft-line:before { content: \"\\ebe0\"; }\r\n.ri-copyright-fill:before { content: \"\\ebe1\"; }\r\n.ri-copyright-line:before { content: \"\\ebe2\"; }\r\n.ri-coreos-fill:before { content: \"\\ebe3\"; }\r\n.ri-coreos-line:before { content: \"\\ebe4\"; }\r\n.ri-coupon-2-fill:before { content: \"\\ebe5\"; }\r\n.ri-coupon-2-line:before { content: \"\\ebe6\"; }\r\n.ri-coupon-3-fill:before { content: \"\\ebe7\"; }\r\n.ri-coupon-3-line:before { content: \"\\ebe8\"; }\r\n.ri-coupon-4-fill:before { content: \"\\ebe9\"; }\r\n.ri-coupon-4-line:before { content: \"\\ebea\"; }\r\n.ri-coupon-5-fill:before { content: \"\\ebeb\"; }\r\n.ri-coupon-5-line:before { content: \"\\ebec\"; }\r\n.ri-coupon-fill:before { content: \"\\ebed\"; }\r\n.ri-coupon-line:before { content: \"\\ebee\"; }\r\n.ri-cpu-fill:before { content: \"\\ebef\"; }\r\n.ri-cpu-line:before { content: \"\\ebf0\"; }\r\n.ri-creative-commons-by-fill:before { content: \"\\ebf1\"; }\r\n.ri-creative-commons-by-line:before { content: \"\\ebf2\"; }\r\n.ri-creative-commons-fill:before { content: \"\\ebf3\"; }\r\n.ri-creative-commons-line:before { content: \"\\ebf4\"; }\r\n.ri-creative-commons-nc-fill:before { content: \"\\ebf5\"; }\r\n.ri-creative-commons-nc-line:before { content: \"\\ebf6\"; }\r\n.ri-creative-commons-nd-fill:before { content: \"\\ebf7\"; }\r\n.ri-creative-commons-nd-line:before { content: \"\\ebf8\"; }\r\n.ri-creative-commons-sa-fill:before { content: \"\\ebf9\"; }\r\n.ri-creative-commons-sa-line:before { content: \"\\ebfa\"; }\r\n.ri-creative-commons-zero-fill:before { content: \"\\ebfb\"; }\r\n.ri-creative-commons-zero-line:before { content: \"\\ebfc\"; }\r\n.ri-criminal-fill:before { content: \"\\ebfd\"; }\r\n.ri-criminal-line:before { content: \"\\ebfe\"; }\r\n.ri-crop-2-fill:before { content: \"\\ebff\"; }\r\n.ri-crop-2-line:before { content: \"\\ec00\"; }\r\n.ri-crop-fill:before { content: \"\\ec01\"; }\r\n.ri-crop-line:before { content: \"\\ec02\"; }\r\n.ri-css3-fill:before { content: \"\\ec03\"; }\r\n.ri-css3-line:before { content: \"\\ec04\"; }\r\n.ri-cup-fill:before { content: \"\\ec05\"; }\r\n.ri-cup-line:before { content: \"\\ec06\"; }\r\n.ri-currency-fill:before { content: \"\\ec07\"; }\r\n.ri-currency-line:before { content: \"\\ec08\"; }\r\n.ri-cursor-fill:before { content: \"\\ec09\"; }\r\n.ri-cursor-line:before { content: \"\\ec0a\"; }\r\n.ri-customer-service-2-fill:before { content: \"\\ec0b\"; }\r\n.ri-customer-service-2-line:before { content: \"\\ec0c\"; }\r\n.ri-customer-service-fill:before { content: \"\\ec0d\"; }\r\n.ri-customer-service-line:before { content: \"\\ec0e\"; }\r\n.ri-dashboard-2-fill:before { content: \"\\ec0f\"; }\r\n.ri-dashboard-2-line:before { content: \"\\ec10\"; }\r\n.ri-dashboard-3-fill:before { content: \"\\ec11\"; }\r\n.ri-dashboard-3-line:before { content: \"\\ec12\"; }\r\n.ri-dashboard-fill:before { content: \"\\ec13\"; }\r\n.ri-dashboard-line:before { content: \"\\ec14\"; }\r\n.ri-database-2-fill:before { content: \"\\ec15\"; }\r\n.ri-database-2-line:before { content: \"\\ec16\"; }\r\n.ri-database-fill:before { content: \"\\ec17\"; }\r\n.ri-database-line:before { content: \"\\ec18\"; }\r\n.ri-delete-back-2-fill:before { content: \"\\ec19\"; }\r\n.ri-delete-back-2-line:before { content: \"\\ec1a\"; }\r\n.ri-delete-back-fill:before { content: \"\\ec1b\"; }\r\n.ri-delete-back-line:before { content: \"\\ec1c\"; }\r\n.ri-delete-bin-2-fill:before { content: \"\\ec1d\"; }\r\n.ri-delete-bin-2-line:before { content: \"\\ec1e\"; }\r\n.ri-delete-bin-3-fill:before { content: \"\\ec1f\"; }\r\n.ri-delete-bin-3-line:before { content: \"\\ec20\"; }\r\n.ri-delete-bin-4-fill:before { content: \"\\ec21\"; }\r\n.ri-delete-bin-4-line:before { content: \"\\ec22\"; }\r\n.ri-delete-bin-5-fill:before { content: \"\\ec23\"; }\r\n.ri-delete-bin-5-line:before { content: \"\\ec24\"; }\r\n.ri-delete-bin-6-fill:before { content: \"\\ec25\"; }\r\n.ri-delete-bin-6-line:before { content: \"\\ec26\"; }\r\n.ri-delete-bin-7-fill:before { content: \"\\ec27\"; }\r\n.ri-delete-bin-7-line:before { content: \"\\ec28\"; }\r\n.ri-delete-bin-fill:before { content: \"\\ec29\"; }\r\n.ri-delete-bin-line:before { content: \"\\ec2a\"; }\r\n.ri-delete-column:before { content: \"\\ec2b\"; }\r\n.ri-delete-row:before { content: \"\\ec2c\"; }\r\n.ri-device-fill:before { content: \"\\ec2d\"; }\r\n.ri-device-line:before { content: \"\\ec2e\"; }\r\n.ri-device-recover-fill:before { content: \"\\ec2f\"; }\r\n.ri-device-recover-line:before { content: \"\\ec30\"; }\r\n.ri-dingding-fill:before { content: \"\\ec31\"; }\r\n.ri-dingding-line:before { content: \"\\ec32\"; }\r\n.ri-direction-fill:before { content: \"\\ec33\"; }\r\n.ri-direction-line:before { content: \"\\ec34\"; }\r\n.ri-disc-fill:before { content: \"\\ec35\"; }\r\n.ri-disc-line:before { content: \"\\ec36\"; }\r\n.ri-discord-fill:before { content: \"\\ec37\"; }\r\n.ri-discord-line:before { content: \"\\ec38\"; }\r\n.ri-discuss-fill:before { content: \"\\ec39\"; }\r\n.ri-discuss-line:before { content: \"\\ec3a\"; }\r\n.ri-dislike-fill:before { content: \"\\ec3b\"; }\r\n.ri-dislike-line:before { content: \"\\ec3c\"; }\r\n.ri-disqus-fill:before { content: \"\\ec3d\"; }\r\n.ri-disqus-line:before { content: \"\\ec3e\"; }\r\n.ri-divide-fill:before { content: \"\\ec3f\"; }\r\n.ri-divide-line:before { content: \"\\ec40\"; }\r\n.ri-donut-chart-fill:before { content: \"\\ec41\"; }\r\n.ri-donut-chart-line:before { content: \"\\ec42\"; }\r\n.ri-door-closed-fill:before { content: \"\\ec43\"; }\r\n.ri-door-closed-line:before { content: \"\\ec44\"; }\r\n.ri-door-fill:before { content: \"\\ec45\"; }\r\n.ri-door-line:before { content: \"\\ec46\"; }\r\n.ri-door-lock-box-fill:before { content: \"\\ec47\"; }\r\n.ri-door-lock-box-line:before { content: \"\\ec48\"; }\r\n.ri-door-lock-fill:before { content: \"\\ec49\"; }\r\n.ri-door-lock-line:before { content: \"\\ec4a\"; }\r\n.ri-door-open-fill:before { content: \"\\ec4b\"; }\r\n.ri-door-open-line:before { content: \"\\ec4c\"; }\r\n.ri-dossier-fill:before { content: \"\\ec4d\"; }\r\n.ri-dossier-line:before { content: \"\\ec4e\"; }\r\n.ri-douban-fill:before { content: \"\\ec4f\"; }\r\n.ri-douban-line:before { content: \"\\ec50\"; }\r\n.ri-double-quotes-l:before { content: \"\\ec51\"; }\r\n.ri-double-quotes-r:before { content: \"\\ec52\"; }\r\n.ri-download-2-fill:before { content: \"\\ec53\"; }\r\n.ri-download-2-line:before { content: \"\\ec54\"; }\r\n.ri-download-cloud-2-fill:before { content: \"\\ec55\"; }\r\n.ri-download-cloud-2-line:before { content: \"\\ec56\"; }\r\n.ri-download-cloud-fill:before { content: \"\\ec57\"; }\r\n.ri-download-cloud-line:before { content: \"\\ec58\"; }\r\n.ri-download-fill:before { content: \"\\ec59\"; }\r\n.ri-download-line:before { content: \"\\ec5a\"; }\r\n.ri-draft-fill:before { content: \"\\ec5b\"; }\r\n.ri-draft-line:before { content: \"\\ec5c\"; }\r\n.ri-drag-drop-fill:before { content: \"\\ec5d\"; }\r\n.ri-drag-drop-line:before { content: \"\\ec5e\"; }\r\n.ri-drag-move-2-fill:before { content: \"\\ec5f\"; }\r\n.ri-drag-move-2-line:before { content: \"\\ec60\"; }\r\n.ri-drag-move-fill:before { content: \"\\ec61\"; }\r\n.ri-drag-move-line:before { content: \"\\ec62\"; }\r\n.ri-dribbble-fill:before { content: \"\\ec63\"; }\r\n.ri-dribbble-line:before { content: \"\\ec64\"; }\r\n.ri-drive-fill:before { content: \"\\ec65\"; }\r\n.ri-drive-line:before { content: \"\\ec66\"; }\r\n.ri-drizzle-fill:before { content: \"\\ec67\"; }\r\n.ri-drizzle-line:before { content: \"\\ec68\"; }\r\n.ri-drop-fill:before { content: \"\\ec69\"; }\r\n.ri-drop-line:before { content: \"\\ec6a\"; }\r\n.ri-dropbox-fill:before { content: \"\\ec6b\"; }\r\n.ri-dropbox-line:before { content: \"\\ec6c\"; }\r\n.ri-dual-sim-1-fill:before { content: \"\\ec6d\"; }\r\n.ri-dual-sim-1-line:before { content: \"\\ec6e\"; }\r\n.ri-dual-sim-2-fill:before { content: \"\\ec6f\"; }\r\n.ri-dual-sim-2-line:before { content: \"\\ec70\"; }\r\n.ri-dv-fill:before { content: \"\\ec71\"; }\r\n.ri-dv-line:before { content: \"\\ec72\"; }\r\n.ri-dvd-fill:before { content: \"\\ec73\"; }\r\n.ri-dvd-line:before { content: \"\\ec74\"; }\r\n.ri-e-bike-2-fill:before { content: \"\\ec75\"; }\r\n.ri-e-bike-2-line:before { content: \"\\ec76\"; }\r\n.ri-e-bike-fill:before { content: \"\\ec77\"; }\r\n.ri-e-bike-line:before { content: \"\\ec78\"; }\r\n.ri-earth-fill:before { content: \"\\ec79\"; }\r\n.ri-earth-line:before { content: \"\\ec7a\"; }\r\n.ri-earthquake-fill:before { content: \"\\ec7b\"; }\r\n.ri-earthquake-line:before { content: \"\\ec7c\"; }\r\n.ri-edge-fill:before { content: \"\\ec7d\"; }\r\n.ri-edge-line:before { content: \"\\ec7e\"; }\r\n.ri-edit-2-fill:before { content: \"\\ec7f\"; }\r\n.ri-edit-2-line:before { content: \"\\ec80\"; }\r\n.ri-edit-box-fill:before { content: \"\\ec81\"; }\r\n.ri-edit-box-line:before { content: \"\\ec82\"; }\r\n.ri-edit-circle-fill:before { content: \"\\ec83\"; }\r\n.ri-edit-circle-line:before { content: \"\\ec84\"; }\r\n.ri-edit-fill:before { content: \"\\ec85\"; }\r\n.ri-edit-line:before { content: \"\\ec86\"; }\r\n.ri-eject-fill:before { content: \"\\ec87\"; }\r\n.ri-eject-line:before { content: \"\\ec88\"; }\r\n.ri-emotion-2-fill:before { content: \"\\ec89\"; }\r\n.ri-emotion-2-line:before { content: \"\\ec8a\"; }\r\n.ri-emotion-fill:before { content: \"\\ec8b\"; }\r\n.ri-emotion-happy-fill:before { content: \"\\ec8c\"; }\r\n.ri-emotion-happy-line:before { content: \"\\ec8d\"; }\r\n.ri-emotion-laugh-fill:before { content: \"\\ec8e\"; }\r\n.ri-emotion-laugh-line:before { content: \"\\ec8f\"; }\r\n.ri-emotion-line:before { content: \"\\ec90\"; }\r\n.ri-emotion-normal-fill:before { content: \"\\ec91\"; }\r\n.ri-emotion-normal-line:before { content: \"\\ec92\"; }\r\n.ri-emotion-sad-fill:before { content: \"\\ec93\"; }\r\n.ri-emotion-sad-line:before { content: \"\\ec94\"; }\r\n.ri-emotion-unhappy-fill:before { content: \"\\ec95\"; }\r\n.ri-emotion-unhappy-line:before { content: \"\\ec96\"; }\r\n.ri-empathize-fill:before { content: \"\\ec97\"; }\r\n.ri-empathize-line:before { content: \"\\ec98\"; }\r\n.ri-emphasis-cn:before { content: \"\\ec99\"; }\r\n.ri-emphasis:before { content: \"\\ec9a\"; }\r\n.ri-english-input:before { content: \"\\ec9b\"; }\r\n.ri-equalizer-fill:before { content: \"\\ec9c\"; }\r\n.ri-equalizer-line:before { content: \"\\ec9d\"; }\r\n.ri-eraser-fill:before { content: \"\\ec9e\"; }\r\n.ri-eraser-line:before { content: \"\\ec9f\"; }\r\n.ri-error-warning-fill:before { content: \"\\eca0\"; }\r\n.ri-error-warning-line:before { content: \"\\eca1\"; }\r\n.ri-evernote-fill:before { content: \"\\eca2\"; }\r\n.ri-evernote-line:before { content: \"\\eca3\"; }\r\n.ri-exchange-box-fill:before { content: \"\\eca4\"; }\r\n.ri-exchange-box-line:before { content: \"\\eca5\"; }\r\n.ri-exchange-cny-fill:before { content: \"\\eca6\"; }\r\n.ri-exchange-cny-line:before { content: \"\\eca7\"; }\r\n.ri-exchange-dollar-fill:before { content: \"\\eca8\"; }\r\n.ri-exchange-dollar-line:before { content: \"\\eca9\"; }\r\n.ri-exchange-fill:before { content: \"\\ecaa\"; }\r\n.ri-exchange-funds-fill:before { content: \"\\ecab\"; }\r\n.ri-exchange-funds-line:before { content: \"\\ecac\"; }\r\n.ri-exchange-line:before { content: \"\\ecad\"; }\r\n.ri-external-link-fill:before { content: \"\\ecae\"; }\r\n.ri-external-link-line:before { content: \"\\ecaf\"; }\r\n.ri-eye-2-fill:before { content: \"\\ecb0\"; }\r\n.ri-eye-2-line:before { content: \"\\ecb1\"; }\r\n.ri-eye-close-fill:before { content: \"\\ecb2\"; }\r\n.ri-eye-close-line:before { content: \"\\ecb3\"; }\r\n.ri-eye-fill:before { content: \"\\ecb4\"; }\r\n.ri-eye-line:before { content: \"\\ecb5\"; }\r\n.ri-eye-off-fill:before { content: \"\\ecb6\"; }\r\n.ri-eye-off-line:before { content: \"\\ecb7\"; }\r\n.ri-facebook-box-fill:before { content: \"\\ecb8\"; }\r\n.ri-facebook-box-line:before { content: \"\\ecb9\"; }\r\n.ri-facebook-circle-fill:before { content: \"\\ecba\"; }\r\n.ri-facebook-circle-line:before { content: \"\\ecbb\"; }\r\n.ri-facebook-fill:before { content: \"\\ecbc\"; }\r\n.ri-facebook-line:before { content: \"\\ecbd\"; }\r\n.ri-fahrenheit-fill:before { content: \"\\ecbe\"; }\r\n.ri-fahrenheit-line:before { content: \"\\ecbf\"; }\r\n.ri-feedback-fill:before { content: \"\\ecc0\"; }\r\n.ri-feedback-line:before { content: \"\\ecc1\"; }\r\n.ri-file-2-fill:before { content: \"\\ecc2\"; }\r\n.ri-file-2-line:before { content: \"\\ecc3\"; }\r\n.ri-file-3-fill:before { content: \"\\ecc4\"; }\r\n.ri-file-3-line:before { content: \"\\ecc5\"; }\r\n.ri-file-4-fill:before { content: \"\\ecc6\"; }\r\n.ri-file-4-line:before { content: \"\\ecc7\"; }\r\n.ri-file-add-fill:before { content: \"\\ecc8\"; }\r\n.ri-file-add-line:before { content: \"\\ecc9\"; }\r\n.ri-file-chart-2-fill:before { content: \"\\ecca\"; }\r\n.ri-file-chart-2-line:before { content: \"\\eccb\"; }\r\n.ri-file-chart-fill:before { content: \"\\eccc\"; }\r\n.ri-file-chart-line:before { content: \"\\eccd\"; }\r\n.ri-file-cloud-fill:before { content: \"\\ecce\"; }\r\n.ri-file-cloud-line:before { content: \"\\eccf\"; }\r\n.ri-file-code-fill:before { content: \"\\ecd0\"; }\r\n.ri-file-code-line:before { content: \"\\ecd1\"; }\r\n.ri-file-copy-2-fill:before { content: \"\\ecd2\"; }\r\n.ri-file-copy-2-line:before { content: \"\\ecd3\"; }\r\n.ri-file-copy-fill:before { content: \"\\ecd4\"; }\r\n.ri-file-copy-line:before { content: \"\\ecd5\"; }\r\n.ri-file-damage-fill:before { content: \"\\ecd6\"; }\r\n.ri-file-damage-line:before { content: \"\\ecd7\"; }\r\n.ri-file-download-fill:before { content: \"\\ecd8\"; }\r\n.ri-file-download-line:before { content: \"\\ecd9\"; }\r\n.ri-file-edit-fill:before { content: \"\\ecda\"; }\r\n.ri-file-edit-line:before { content: \"\\ecdb\"; }\r\n.ri-file-excel-2-fill:before { content: \"\\ecdc\"; }\r\n.ri-file-excel-2-line:before { content: \"\\ecdd\"; }\r\n.ri-file-excel-fill:before { content: \"\\ecde\"; }\r\n.ri-file-excel-line:before { content: \"\\ecdf\"; }\r\n.ri-file-fill:before { content: \"\\ece0\"; }\r\n.ri-file-forbid-fill:before { content: \"\\ece1\"; }\r\n.ri-file-forbid-line:before { content: \"\\ece2\"; }\r\n.ri-file-gif-fill:before { content: \"\\ece3\"; }\r\n.ri-file-gif-line:before { content: \"\\ece4\"; }\r\n.ri-file-history-fill:before { content: \"\\ece5\"; }\r\n.ri-file-history-line:before { content: \"\\ece6\"; }\r\n.ri-file-hwp-fill:before { content: \"\\ece7\"; }\r\n.ri-file-hwp-line:before { content: \"\\ece8\"; }\r\n.ri-file-info-fill:before { content: \"\\ece9\"; }\r\n.ri-file-info-line:before { content: \"\\ecea\"; }\r\n.ri-file-line:before { content: \"\\eceb\"; }\r\n.ri-file-list-2-fill:before { content: \"\\ecec\"; }\r\n.ri-file-list-2-line:before { content: \"\\eced\"; }\r\n.ri-file-list-3-fill:before { content: \"\\ecee\"; }\r\n.ri-file-list-3-line:before { content: \"\\ecef\"; }\r\n.ri-file-list-fill:before { content: \"\\ecf0\"; }\r\n.ri-file-list-line:before { content: \"\\ecf1\"; }\r\n.ri-file-lock-fill:before { content: \"\\ecf2\"; }\r\n.ri-file-lock-line:before { content: \"\\ecf3\"; }\r\n.ri-file-mark-fill:before { content: \"\\ecf4\"; }\r\n.ri-file-mark-line:before { content: \"\\ecf5\"; }\r\n.ri-file-music-fill:before { content: \"\\ecf6\"; }\r\n.ri-file-music-line:before { content: \"\\ecf7\"; }\r\n.ri-file-paper-2-fill:before { content: \"\\ecf8\"; }\r\n.ri-file-paper-2-line:before { content: \"\\ecf9\"; }\r\n.ri-file-paper-fill:before { content: \"\\ecfa\"; }\r\n.ri-file-paper-line:before { content: \"\\ecfb\"; }\r\n.ri-file-pdf-fill:before { content: \"\\ecfc\"; }\r\n.ri-file-pdf-line:before { content: \"\\ecfd\"; }\r\n.ri-file-ppt-2-fill:before { content: \"\\ecfe\"; }\r\n.ri-file-ppt-2-line:before { content: \"\\ecff\"; }\r\n.ri-file-ppt-fill:before { content: \"\\ed00\"; }\r\n.ri-file-ppt-line:before { content: \"\\ed01\"; }\r\n.ri-file-reduce-fill:before { content: \"\\ed02\"; }\r\n.ri-file-reduce-line:before { content: \"\\ed03\"; }\r\n.ri-file-search-fill:before { content: \"\\ed04\"; }\r\n.ri-file-search-line:before { content: \"\\ed05\"; }\r\n.ri-file-settings-fill:before { content: \"\\ed06\"; }\r\n.ri-file-settings-line:before { content: \"\\ed07\"; }\r\n.ri-file-shield-2-fill:before { content: \"\\ed08\"; }\r\n.ri-file-shield-2-line:before { content: \"\\ed09\"; }\r\n.ri-file-shield-fill:before { content: \"\\ed0a\"; }\r\n.ri-file-shield-line:before { content: \"\\ed0b\"; }\r\n.ri-file-shred-fill:before { content: \"\\ed0c\"; }\r\n.ri-file-shred-line:before { content: \"\\ed0d\"; }\r\n.ri-file-text-fill:before { content: \"\\ed0e\"; }\r\n.ri-file-text-line:before { content: \"\\ed0f\"; }\r\n.ri-file-transfer-fill:before { content: \"\\ed10\"; }\r\n.ri-file-transfer-line:before { content: \"\\ed11\"; }\r\n.ri-file-unknow-fill:before { content: \"\\ed12\"; }\r\n.ri-file-unknow-line:before { content: \"\\ed13\"; }\r\n.ri-file-upload-fill:before { content: \"\\ed14\"; }\r\n.ri-file-upload-line:before { content: \"\\ed15\"; }\r\n.ri-file-user-fill:before { content: \"\\ed16\"; }\r\n.ri-file-user-line:before { content: \"\\ed17\"; }\r\n.ri-file-warning-fill:before { content: \"\\ed18\"; }\r\n.ri-file-warning-line:before { content: \"\\ed19\"; }\r\n.ri-file-word-2-fill:before { content: \"\\ed1a\"; }\r\n.ri-file-word-2-line:before { content: \"\\ed1b\"; }\r\n.ri-file-word-fill:before { content: \"\\ed1c\"; }\r\n.ri-file-word-line:before { content: \"\\ed1d\"; }\r\n.ri-file-zip-fill:before { content: \"\\ed1e\"; }\r\n.ri-file-zip-line:before { content: \"\\ed1f\"; }\r\n.ri-film-fill:before { content: \"\\ed20\"; }\r\n.ri-film-line:before { content: \"\\ed21\"; }\r\n.ri-filter-2-fill:before { content: \"\\ed22\"; }\r\n.ri-filter-2-line:before { content: \"\\ed23\"; }\r\n.ri-filter-3-fill:before { content: \"\\ed24\"; }\r\n.ri-filter-3-line:before { content: \"\\ed25\"; }\r\n.ri-filter-fill:before { content: \"\\ed26\"; }\r\n.ri-filter-line:before { content: \"\\ed27\"; }\r\n.ri-filter-off-fill:before { content: \"\\ed28\"; }\r\n.ri-filter-off-line:before { content: \"\\ed29\"; }\r\n.ri-find-replace-fill:before { content: \"\\ed2a\"; }\r\n.ri-find-replace-line:before { content: \"\\ed2b\"; }\r\n.ri-finder-fill:before { content: \"\\ed2c\"; }\r\n.ri-finder-line:before { content: \"\\ed2d\"; }\r\n.ri-fingerprint-2-fill:before { content: \"\\ed2e\"; }\r\n.ri-fingerprint-2-line:before { content: \"\\ed2f\"; }\r\n.ri-fingerprint-fill:before { content: \"\\ed30\"; }\r\n.ri-fingerprint-line:before { content: \"\\ed31\"; }\r\n.ri-fire-fill:before { content: \"\\ed32\"; }\r\n.ri-fire-line:before { content: \"\\ed33\"; }\r\n.ri-firefox-fill:before { content: \"\\ed34\"; }\r\n.ri-firefox-line:before { content: \"\\ed35\"; }\r\n.ri-first-aid-kit-fill:before { content: \"\\ed36\"; }\r\n.ri-first-aid-kit-line:before { content: \"\\ed37\"; }\r\n.ri-flag-2-fill:before { content: \"\\ed38\"; }\r\n.ri-flag-2-line:before { content: \"\\ed39\"; }\r\n.ri-flag-fill:before { content: \"\\ed3a\"; }\r\n.ri-flag-line:before { content: \"\\ed3b\"; }\r\n.ri-flashlight-fill:before { content: \"\\ed3c\"; }\r\n.ri-flashlight-line:before { content: \"\\ed3d\"; }\r\n.ri-flask-fill:before { content: \"\\ed3e\"; }\r\n.ri-flask-line:before { content: \"\\ed3f\"; }\r\n.ri-flight-land-fill:before { content: \"\\ed40\"; }\r\n.ri-flight-land-line:before { content: \"\\ed41\"; }\r\n.ri-flight-takeoff-fill:before { content: \"\\ed42\"; }\r\n.ri-flight-takeoff-line:before { content: \"\\ed43\"; }\r\n.ri-flood-fill:before { content: \"\\ed44\"; }\r\n.ri-flood-line:before { content: \"\\ed45\"; }\r\n.ri-flow-chart:before { content: \"\\ed46\"; }\r\n.ri-flutter-fill:before { content: \"\\ed47\"; }\r\n.ri-flutter-line:before { content: \"\\ed48\"; }\r\n.ri-focus-2-fill:before { content: \"\\ed49\"; }\r\n.ri-focus-2-line:before { content: \"\\ed4a\"; }\r\n.ri-focus-3-fill:before { content: \"\\ed4b\"; }\r\n.ri-focus-3-line:before { content: \"\\ed4c\"; }\r\n.ri-focus-fill:before { content: \"\\ed4d\"; }\r\n.ri-focus-line:before { content: \"\\ed4e\"; }\r\n.ri-foggy-fill:before { content: \"\\ed4f\"; }\r\n.ri-foggy-line:before { content: \"\\ed50\"; }\r\n.ri-folder-2-fill:before { content: \"\\ed51\"; }\r\n.ri-folder-2-line:before { content: \"\\ed52\"; }\r\n.ri-folder-3-fill:before { content: \"\\ed53\"; }\r\n.ri-folder-3-line:before { content: \"\\ed54\"; }\r\n.ri-folder-4-fill:before { content: \"\\ed55\"; }\r\n.ri-folder-4-line:before { content: \"\\ed56\"; }\r\n.ri-folder-5-fill:before { content: \"\\ed57\"; }\r\n.ri-folder-5-line:before { content: \"\\ed58\"; }\r\n.ri-folder-add-fill:before { content: \"\\ed59\"; }\r\n.ri-folder-add-line:before { content: \"\\ed5a\"; }\r\n.ri-folder-chart-2-fill:before { content: \"\\ed5b\"; }\r\n.ri-folder-chart-2-line:before { content: \"\\ed5c\"; }\r\n.ri-folder-chart-fill:before { content: \"\\ed5d\"; }\r\n.ri-folder-chart-line:before { content: \"\\ed5e\"; }\r\n.ri-folder-download-fill:before { content: \"\\ed5f\"; }\r\n.ri-folder-download-line:before { content: \"\\ed60\"; }\r\n.ri-folder-fill:before { content: \"\\ed61\"; }\r\n.ri-folder-forbid-fill:before { content: \"\\ed62\"; }\r\n.ri-folder-forbid-line:before { content: \"\\ed63\"; }\r\n.ri-folder-history-fill:before { content: \"\\ed64\"; }\r\n.ri-folder-history-line:before { content: \"\\ed65\"; }\r\n.ri-folder-info-fill:before { content: \"\\ed66\"; }\r\n.ri-folder-info-line:before { content: \"\\ed67\"; }\r\n.ri-folder-keyhole-fill:before { content: \"\\ed68\"; }\r\n.ri-folder-keyhole-line:before { content: \"\\ed69\"; }\r\n.ri-folder-line:before { content: \"\\ed6a\"; }\r\n.ri-folder-lock-fill:before { content: \"\\ed6b\"; }\r\n.ri-folder-lock-line:before { content: \"\\ed6c\"; }\r\n.ri-folder-music-fill:before { content: \"\\ed6d\"; }\r\n.ri-folder-music-line:before { content: \"\\ed6e\"; }\r\n.ri-folder-open-fill:before { content: \"\\ed6f\"; }\r\n.ri-folder-open-line:before { content: \"\\ed70\"; }\r\n.ri-folder-received-fill:before { content: \"\\ed71\"; }\r\n.ri-folder-received-line:before { content: \"\\ed72\"; }\r\n.ri-folder-reduce-fill:before { content: \"\\ed73\"; }\r\n.ri-folder-reduce-line:before { content: \"\\ed74\"; }\r\n.ri-folder-settings-fill:before { content: \"\\ed75\"; }\r\n.ri-folder-settings-line:before { content: \"\\ed76\"; }\r\n.ri-folder-shared-fill:before { content: \"\\ed77\"; }\r\n.ri-folder-shared-line:before { content: \"\\ed78\"; }\r\n.ri-folder-shield-2-fill:before { content: \"\\ed79\"; }\r\n.ri-folder-shield-2-line:before { content: \"\\ed7a\"; }\r\n.ri-folder-shield-fill:before { content: \"\\ed7b\"; }\r\n.ri-folder-shield-line:before { content: \"\\ed7c\"; }\r\n.ri-folder-transfer-fill:before { content: \"\\ed7d\"; }\r\n.ri-folder-transfer-line:before { content: \"\\ed7e\"; }\r\n.ri-folder-unknow-fill:before { content: \"\\ed7f\"; }\r\n.ri-folder-unknow-line:before { content: \"\\ed80\"; }\r\n.ri-folder-upload-fill:before { content: \"\\ed81\"; }\r\n.ri-folder-upload-line:before { content: \"\\ed82\"; }\r\n.ri-folder-user-fill:before { content: \"\\ed83\"; }\r\n.ri-folder-user-line:before { content: \"\\ed84\"; }\r\n.ri-folder-warning-fill:before { content: \"\\ed85\"; }\r\n.ri-folder-warning-line:before { content: \"\\ed86\"; }\r\n.ri-folder-zip-fill:before { content: \"\\ed87\"; }\r\n.ri-folder-zip-line:before { content: \"\\ed88\"; }\r\n.ri-folders-fill:before { content: \"\\ed89\"; }\r\n.ri-folders-line:before { content: \"\\ed8a\"; }\r\n.ri-font-color:before { content: \"\\ed8b\"; }\r\n.ri-font-size-2:before { content: \"\\ed8c\"; }\r\n.ri-font-size:before { content: \"\\ed8d\"; }\r\n.ri-football-fill:before { content: \"\\ed8e\"; }\r\n.ri-football-line:before { content: \"\\ed8f\"; }\r\n.ri-footprint-fill:before { content: \"\\ed90\"; }\r\n.ri-footprint-line:before { content: \"\\ed91\"; }\r\n.ri-forbid-2-fill:before { content: \"\\ed92\"; }\r\n.ri-forbid-2-line:before { content: \"\\ed93\"; }\r\n.ri-forbid-fill:before { content: \"\\ed94\"; }\r\n.ri-forbid-line:before { content: \"\\ed95\"; }\r\n.ri-format-clear:before { content: \"\\ed96\"; }\r\n.ri-fridge-fill:before { content: \"\\ed97\"; }\r\n.ri-fridge-line:before { content: \"\\ed98\"; }\r\n.ri-fullscreen-exit-fill:before { content: \"\\ed99\"; }\r\n.ri-fullscreen-exit-line:before { content: \"\\ed9a\"; }\r\n.ri-fullscreen-fill:before { content: \"\\ed9b\"; }\r\n.ri-fullscreen-line:before { content: \"\\ed9c\"; }\r\n.ri-function-fill:before { content: \"\\ed9d\"; }\r\n.ri-function-line:before { content: \"\\ed9e\"; }\r\n.ri-functions:before { content: \"\\ed9f\"; }\r\n.ri-funds-box-fill:before { content: \"\\eda0\"; }\r\n.ri-funds-box-line:before { content: \"\\eda1\"; }\r\n.ri-funds-fill:before { content: \"\\eda2\"; }\r\n.ri-funds-line:before { content: \"\\eda3\"; }\r\n.ri-gallery-fill:before { content: \"\\eda4\"; }\r\n.ri-gallery-line:before { content: \"\\eda5\"; }\r\n.ri-gallery-upload-fill:before { content: \"\\eda6\"; }\r\n.ri-gallery-upload-line:before { content: \"\\eda7\"; }\r\n.ri-game-fill:before { content: \"\\eda8\"; }\r\n.ri-game-line:before { content: \"\\eda9\"; }\r\n.ri-gamepad-fill:before { content: \"\\edaa\"; }\r\n.ri-gamepad-line:before { content: \"\\edab\"; }\r\n.ri-gas-station-fill:before { content: \"\\edac\"; }\r\n.ri-gas-station-line:before { content: \"\\edad\"; }\r\n.ri-gatsby-fill:before { content: \"\\edae\"; }\r\n.ri-gatsby-line:before { content: \"\\edaf\"; }\r\n.ri-genderless-fill:before { content: \"\\edb0\"; }\r\n.ri-genderless-line:before { content: \"\\edb1\"; }\r\n.ri-ghost-2-fill:before { content: \"\\edb2\"; }\r\n.ri-ghost-2-line:before { content: \"\\edb3\"; }\r\n.ri-ghost-fill:before { content: \"\\edb4\"; }\r\n.ri-ghost-line:before { content: \"\\edb5\"; }\r\n.ri-ghost-smile-fill:before { content: \"\\edb6\"; }\r\n.ri-ghost-smile-line:before { content: \"\\edb7\"; }\r\n.ri-gift-2-fill:before { content: \"\\edb8\"; }\r\n.ri-gift-2-line:before { content: \"\\edb9\"; }\r\n.ri-gift-fill:before { content: \"\\edba\"; }\r\n.ri-gift-line:before { content: \"\\edbb\"; }\r\n.ri-git-branch-fill:before { content: \"\\edbc\"; }\r\n.ri-git-branch-line:before { content: \"\\edbd\"; }\r\n.ri-git-commit-fill:before { content: \"\\edbe\"; }\r\n.ri-git-commit-line:before { content: \"\\edbf\"; }\r\n.ri-git-merge-fill:before { content: \"\\edc0\"; }\r\n.ri-git-merge-line:before { content: \"\\edc1\"; }\r\n.ri-git-pull-request-fill:before { content: \"\\edc2\"; }\r\n.ri-git-pull-request-line:before { content: \"\\edc3\"; }\r\n.ri-git-repository-commits-fill:before { content: \"\\edc4\"; }\r\n.ri-git-repository-commits-line:before { content: \"\\edc5\"; }\r\n.ri-git-repository-fill:before { content: \"\\edc6\"; }\r\n.ri-git-repository-line:before { content: \"\\edc7\"; }\r\n.ri-git-repository-private-fill:before { content: \"\\edc8\"; }\r\n.ri-git-repository-private-line:before { content: \"\\edc9\"; }\r\n.ri-github-fill:before { content: \"\\edca\"; }\r\n.ri-github-line:before { content: \"\\edcb\"; }\r\n.ri-gitlab-fill:before { content: \"\\edcc\"; }\r\n.ri-gitlab-line:before { content: \"\\edcd\"; }\r\n.ri-global-fill:before { content: \"\\edce\"; }\r\n.ri-global-line:before { content: \"\\edcf\"; }\r\n.ri-globe-fill:before { content: \"\\edd0\"; }\r\n.ri-globe-line:before { content: \"\\edd1\"; }\r\n.ri-goblet-fill:before { content: \"\\edd2\"; }\r\n.ri-goblet-line:before { content: \"\\edd3\"; }\r\n.ri-google-fill:before { content: \"\\edd4\"; }\r\n.ri-google-line:before { content: \"\\edd5\"; }\r\n.ri-google-play-fill:before { content: \"\\edd6\"; }\r\n.ri-google-play-line:before { content: \"\\edd7\"; }\r\n.ri-government-fill:before { content: \"\\edd8\"; }\r\n.ri-government-line:before { content: \"\\edd9\"; }\r\n.ri-gps-fill:before { content: \"\\edda\"; }\r\n.ri-gps-line:before { content: \"\\eddb\"; }\r\n.ri-gradienter-fill:before { content: \"\\eddc\"; }\r\n.ri-gradienter-line:before { content: \"\\eddd\"; }\r\n.ri-grid-fill:before { content: \"\\edde\"; }\r\n.ri-grid-line:before { content: \"\\eddf\"; }\r\n.ri-group-2-fill:before { content: \"\\ede0\"; }\r\n.ri-group-2-line:before { content: \"\\ede1\"; }\r\n.ri-group-fill:before { content: \"\\ede2\"; }\r\n.ri-group-line:before { content: \"\\ede3\"; }\r\n.ri-guide-fill:before { content: \"\\ede4\"; }\r\n.ri-guide-line:before { content: \"\\ede5\"; }\r\n.ri-h-1:before { content: \"\\ede6\"; }\r\n.ri-h-2:before { content: \"\\ede7\"; }\r\n.ri-h-3:before { content: \"\\ede8\"; }\r\n.ri-h-4:before { content: \"\\ede9\"; }\r\n.ri-h-5:before { content: \"\\edea\"; }\r\n.ri-h-6:before { content: \"\\edeb\"; }\r\n.ri-hail-fill:before { content: \"\\edec\"; }\r\n.ri-hail-line:before { content: \"\\eded\"; }\r\n.ri-hammer-fill:before { content: \"\\edee\"; }\r\n.ri-hammer-line:before { content: \"\\edef\"; }\r\n.ri-hand-coin-fill:before { content: \"\\edf0\"; }\r\n.ri-hand-coin-line:before { content: \"\\edf1\"; }\r\n.ri-hand-heart-fill:before { content: \"\\edf2\"; }\r\n.ri-hand-heart-line:before { content: \"\\edf3\"; }\r\n.ri-hand-sanitizer-fill:before { content: \"\\edf4\"; }\r\n.ri-hand-sanitizer-line:before { content: \"\\edf5\"; }\r\n.ri-handbag-fill:before { content: \"\\edf6\"; }\r\n.ri-handbag-line:before { content: \"\\edf7\"; }\r\n.ri-hard-drive-2-fill:before { content: \"\\edf8\"; }\r\n.ri-hard-drive-2-line:before { content: \"\\edf9\"; }\r\n.ri-hard-drive-fill:before { content: \"\\edfa\"; }\r\n.ri-hard-drive-line:before { content: \"\\edfb\"; }\r\n.ri-hashtag:before { content: \"\\edfc\"; }\r\n.ri-haze-2-fill:before { content: \"\\edfd\"; }\r\n.ri-haze-2-line:before { content: \"\\edfe\"; }\r\n.ri-haze-fill:before { content: \"\\edff\"; }\r\n.ri-haze-line:before { content: \"\\ee00\"; }\r\n.ri-hd-fill:before { content: \"\\ee01\"; }\r\n.ri-hd-line:before { content: \"\\ee02\"; }\r\n.ri-heading:before { content: \"\\ee03\"; }\r\n.ri-headphone-fill:before { content: \"\\ee04\"; }\r\n.ri-headphone-line:before { content: \"\\ee05\"; }\r\n.ri-health-book-fill:before { content: \"\\ee06\"; }\r\n.ri-health-book-line:before { content: \"\\ee07\"; }\r\n.ri-heart-2-fill:before { content: \"\\ee08\"; }\r\n.ri-heart-2-line:before { content: \"\\ee09\"; }\r\n.ri-heart-3-fill:before { content: \"\\ee0a\"; }\r\n.ri-heart-3-line:before { content: \"\\ee0b\"; }\r\n.ri-heart-add-fill:before { content: \"\\ee0c\"; }\r\n.ri-heart-add-line:before { content: \"\\ee0d\"; }\r\n.ri-heart-fill:before { content: \"\\ee0e\"; }\r\n.ri-heart-line:before { content: \"\\ee0f\"; }\r\n.ri-heart-pulse-fill:before { content: \"\\ee10\"; }\r\n.ri-heart-pulse-line:before { content: \"\\ee11\"; }\r\n.ri-hearts-fill:before { content: \"\\ee12\"; }\r\n.ri-hearts-line:before { content: \"\\ee13\"; }\r\n.ri-heavy-showers-fill:before { content: \"\\ee14\"; }\r\n.ri-heavy-showers-line:before { content: \"\\ee15\"; }\r\n.ri-history-fill:before { content: \"\\ee16\"; }\r\n.ri-history-line:before { content: \"\\ee17\"; }\r\n.ri-home-2-fill:before { content: \"\\ee18\"; }\r\n.ri-home-2-line:before { content: \"\\ee19\"; }\r\n.ri-home-3-fill:before { content: \"\\ee1a\"; }\r\n.ri-home-3-line:before { content: \"\\ee1b\"; }\r\n.ri-home-4-fill:before { content: \"\\ee1c\"; }\r\n.ri-home-4-line:before { content: \"\\ee1d\"; }\r\n.ri-home-5-fill:before { content: \"\\ee1e\"; }\r\n.ri-home-5-line:before { content: \"\\ee1f\"; }\r\n.ri-home-6-fill:before { content: \"\\ee20\"; }\r\n.ri-home-6-line:before { content: \"\\ee21\"; }\r\n.ri-home-7-fill:before { content: \"\\ee22\"; }\r\n.ri-home-7-line:before { content: \"\\ee23\"; }\r\n.ri-home-8-fill:before { content: \"\\ee24\"; }\r\n.ri-home-8-line:before { content: \"\\ee25\"; }\r\n.ri-home-fill:before { content: \"\\ee26\"; }\r\n.ri-home-gear-fill:before { content: \"\\ee27\"; }\r\n.ri-home-gear-line:before { content: \"\\ee28\"; }\r\n.ri-home-heart-fill:before { content: \"\\ee29\"; }\r\n.ri-home-heart-line:before { content: \"\\ee2a\"; }\r\n.ri-home-line:before { content: \"\\ee2b\"; }\r\n.ri-home-smile-2-fill:before { content: \"\\ee2c\"; }\r\n.ri-home-smile-2-line:before { content: \"\\ee2d\"; }\r\n.ri-home-smile-fill:before { content: \"\\ee2e\"; }\r\n.ri-home-smile-line:before { content: \"\\ee2f\"; }\r\n.ri-home-wifi-fill:before { content: \"\\ee30\"; }\r\n.ri-home-wifi-line:before { content: \"\\ee31\"; }\r\n.ri-honor-of-kings-fill:before { content: \"\\ee32\"; }\r\n.ri-honor-of-kings-line:before { content: \"\\ee33\"; }\r\n.ri-honour-fill:before { content: \"\\ee34\"; }\r\n.ri-honour-line:before { content: \"\\ee35\"; }\r\n.ri-hospital-fill:before { content: \"\\ee36\"; }\r\n.ri-hospital-line:before { content: \"\\ee37\"; }\r\n.ri-hotel-bed-fill:before { content: \"\\ee38\"; }\r\n.ri-hotel-bed-line:before { content: \"\\ee39\"; }\r\n.ri-hotel-fill:before { content: \"\\ee3a\"; }\r\n.ri-hotel-line:before { content: \"\\ee3b\"; }\r\n.ri-hotspot-fill:before { content: \"\\ee3c\"; }\r\n.ri-hotspot-line:before { content: \"\\ee3d\"; }\r\n.ri-hq-fill:before { content: \"\\ee3e\"; }\r\n.ri-hq-line:before { content: \"\\ee3f\"; }\r\n.ri-html5-fill:before { content: \"\\ee40\"; }\r\n.ri-html5-line:before { content: \"\\ee41\"; }\r\n.ri-ie-fill:before { content: \"\\ee42\"; }\r\n.ri-ie-line:before { content: \"\\ee43\"; }\r\n.ri-image-2-fill:before { content: \"\\ee44\"; }\r\n.ri-image-2-line:before { content: \"\\ee45\"; }\r\n.ri-image-add-fill:before { content: \"\\ee46\"; }\r\n.ri-image-add-line:before { content: \"\\ee47\"; }\r\n.ri-image-edit-fill:before { content: \"\\ee48\"; }\r\n.ri-image-edit-line:before { content: \"\\ee49\"; }\r\n.ri-image-fill:before { content: \"\\ee4a\"; }\r\n.ri-image-line:before { content: \"\\ee4b\"; }\r\n.ri-inbox-archive-fill:before { content: \"\\ee4c\"; }\r\n.ri-inbox-archive-line:before { content: \"\\ee4d\"; }\r\n.ri-inbox-fill:before { content: \"\\ee4e\"; }\r\n.ri-inbox-line:before { content: \"\\ee4f\"; }\r\n.ri-inbox-unarchive-fill:before { content: \"\\ee50\"; }\r\n.ri-inbox-unarchive-line:before { content: \"\\ee51\"; }\r\n.ri-increase-decrease-fill:before { content: \"\\ee52\"; }\r\n.ri-increase-decrease-line:before { content: \"\\ee53\"; }\r\n.ri-indent-decrease:before { content: \"\\ee54\"; }\r\n.ri-indent-increase:before { content: \"\\ee55\"; }\r\n.ri-indeterminate-circle-fill:before { content: \"\\ee56\"; }\r\n.ri-indeterminate-circle-line:before { content: \"\\ee57\"; }\r\n.ri-information-fill:before { content: \"\\ee58\"; }\r\n.ri-information-line:before { content: \"\\ee59\"; }\r\n.ri-infrared-thermometer-fill:before { content: \"\\ee5a\"; }\r\n.ri-infrared-thermometer-line:before { content: \"\\ee5b\"; }\r\n.ri-ink-bottle-fill:before { content: \"\\ee5c\"; }\r\n.ri-ink-bottle-line:before { content: \"\\ee5d\"; }\r\n.ri-input-cursor-move:before { content: \"\\ee5e\"; }\r\n.ri-input-method-fill:before { content: \"\\ee5f\"; }\r\n.ri-input-method-line:before { content: \"\\ee60\"; }\r\n.ri-insert-column-left:before { content: \"\\ee61\"; }\r\n.ri-insert-column-right:before { content: \"\\ee62\"; }\r\n.ri-insert-row-bottom:before { content: \"\\ee63\"; }\r\n.ri-insert-row-top:before { content: \"\\ee64\"; }\r\n.ri-instagram-fill:before { content: \"\\ee65\"; }\r\n.ri-instagram-line:before { content: \"\\ee66\"; }\r\n.ri-install-fill:before { content: \"\\ee67\"; }\r\n.ri-install-line:before { content: \"\\ee68\"; }\r\n.ri-invision-fill:before { content: \"\\ee69\"; }\r\n.ri-invision-line:before { content: \"\\ee6a\"; }\r\n.ri-italic:before { content: \"\\ee6b\"; }\r\n.ri-kakao-talk-fill:before { content: \"\\ee6c\"; }\r\n.ri-kakao-talk-line:before { content: \"\\ee6d\"; }\r\n.ri-key-2-fill:before { content: \"\\ee6e\"; }\r\n.ri-key-2-line:before { content: \"\\ee6f\"; }\r\n.ri-key-fill:before { content: \"\\ee70\"; }\r\n.ri-key-line:before { content: \"\\ee71\"; }\r\n.ri-keyboard-box-fill:before { content: \"\\ee72\"; }\r\n.ri-keyboard-box-line:before { content: \"\\ee73\"; }\r\n.ri-keyboard-fill:before { content: \"\\ee74\"; }\r\n.ri-keyboard-line:before { content: \"\\ee75\"; }\r\n.ri-keynote-fill:before { content: \"\\ee76\"; }\r\n.ri-keynote-line:before { content: \"\\ee77\"; }\r\n.ri-knife-blood-fill:before { content: \"\\ee78\"; }\r\n.ri-knife-blood-line:before { content: \"\\ee79\"; }\r\n.ri-knife-fill:before { content: \"\\ee7a\"; }\r\n.ri-knife-line:before { content: \"\\ee7b\"; }\r\n.ri-landscape-fill:before { content: \"\\ee7c\"; }\r\n.ri-landscape-line:before { content: \"\\ee7d\"; }\r\n.ri-layout-2-fill:before { content: \"\\ee7e\"; }\r\n.ri-layout-2-line:before { content: \"\\ee7f\"; }\r\n.ri-layout-3-fill:before { content: \"\\ee80\"; }\r\n.ri-layout-3-line:before { content: \"\\ee81\"; }\r\n.ri-layout-4-fill:before { content: \"\\ee82\"; }\r\n.ri-layout-4-line:before { content: \"\\ee83\"; }\r\n.ri-layout-5-fill:before { content: \"\\ee84\"; }\r\n.ri-layout-5-line:before { content: \"\\ee85\"; }\r\n.ri-layout-6-fill:before { content: \"\\ee86\"; }\r\n.ri-layout-6-line:before { content: \"\\ee87\"; }\r\n.ri-layout-bottom-2-fill:before { content: \"\\ee88\"; }\r\n.ri-layout-bottom-2-line:before { content: \"\\ee89\"; }\r\n.ri-layout-bottom-fill:before { content: \"\\ee8a\"; }\r\n.ri-layout-bottom-line:before { content: \"\\ee8b\"; }\r\n.ri-layout-column-fill:before { content: \"\\ee8c\"; }\r\n.ri-layout-column-line:before { content: \"\\ee8d\"; }\r\n.ri-layout-fill:before { content: \"\\ee8e\"; }\r\n.ri-layout-grid-fill:before { content: \"\\ee8f\"; }\r\n.ri-layout-grid-line:before { content: \"\\ee90\"; }\r\n.ri-layout-left-2-fill:before { content: \"\\ee91\"; }\r\n.ri-layout-left-2-line:before { content: \"\\ee92\"; }\r\n.ri-layout-left-fill:before { content: \"\\ee93\"; }\r\n.ri-layout-left-line:before { content: \"\\ee94\"; }\r\n.ri-layout-line:before { content: \"\\ee95\"; }\r\n.ri-layout-masonry-fill:before { content: \"\\ee96\"; }\r\n.ri-layout-masonry-line:before { content: \"\\ee97\"; }\r\n.ri-layout-right-2-fill:before { content: \"\\ee98\"; }\r\n.ri-layout-right-2-line:before { content: \"\\ee99\"; }\r\n.ri-layout-right-fill:before { content: \"\\ee9a\"; }\r\n.ri-layout-right-line:before { content: \"\\ee9b\"; }\r\n.ri-layout-row-fill:before { content: \"\\ee9c\"; }\r\n.ri-layout-row-line:before { content: \"\\ee9d\"; }\r\n.ri-layout-top-2-fill:before { content: \"\\ee9e\"; }\r\n.ri-layout-top-2-line:before { content: \"\\ee9f\"; }\r\n.ri-layout-top-fill:before { content: \"\\eea0\"; }\r\n.ri-layout-top-line:before { content: \"\\eea1\"; }\r\n.ri-leaf-fill:before { content: \"\\eea2\"; }\r\n.ri-leaf-line:before { content: \"\\eea3\"; }\r\n.ri-lifebuoy-fill:before { content: \"\\eea4\"; }\r\n.ri-lifebuoy-line:before { content: \"\\eea5\"; }\r\n.ri-lightbulb-fill:before { content: \"\\eea6\"; }\r\n.ri-lightbulb-flash-fill:before { content: \"\\eea7\"; }\r\n.ri-lightbulb-flash-line:before { content: \"\\eea8\"; }\r\n.ri-lightbulb-line:before { content: \"\\eea9\"; }\r\n.ri-line-chart-fill:before { content: \"\\eeaa\"; }\r\n.ri-line-chart-line:before { content: \"\\eeab\"; }\r\n.ri-line-fill:before { content: \"\\eeac\"; }\r\n.ri-line-height:before { content: \"\\eead\"; }\r\n.ri-line-line:before { content: \"\\eeae\"; }\r\n.ri-link-m:before { content: \"\\eeaf\"; }\r\n.ri-link-unlink-m:before { content: \"\\eeb0\"; }\r\n.ri-link-unlink:before { content: \"\\eeb1\"; }\r\n.ri-link:before { content: \"\\eeb2\"; }\r\n.ri-linkedin-box-fill:before { content: \"\\eeb3\"; }\r\n.ri-linkedin-box-line:before { content: \"\\eeb4\"; }\r\n.ri-linkedin-fill:before { content: \"\\eeb5\"; }\r\n.ri-linkedin-line:before { content: \"\\eeb6\"; }\r\n.ri-links-fill:before { content: \"\\eeb7\"; }\r\n.ri-links-line:before { content: \"\\eeb8\"; }\r\n.ri-list-check-2:before { content: \"\\eeb9\"; }\r\n.ri-list-check:before { content: \"\\eeba\"; }\r\n.ri-list-ordered:before { content: \"\\eebb\"; }\r\n.ri-list-settings-fill:before { content: \"\\eebc\"; }\r\n.ri-list-settings-line:before { content: \"\\eebd\"; }\r\n.ri-list-unordered:before { content: \"\\eebe\"; }\r\n.ri-live-fill:before { content: \"\\eebf\"; }\r\n.ri-live-line:before { content: \"\\eec0\"; }\r\n.ri-loader-2-fill:before { content: \"\\eec1\"; }\r\n.ri-loader-2-line:before { content: \"\\eec2\"; }\r\n.ri-loader-3-fill:before { content: \"\\eec3\"; }\r\n.ri-loader-3-line:before { content: \"\\eec4\"; }\r\n.ri-loader-4-fill:before { content: \"\\eec5\"; }\r\n.ri-loader-4-line:before { content: \"\\eec6\"; }\r\n.ri-loader-5-fill:before { content: \"\\eec7\"; }\r\n.ri-loader-5-line:before { content: \"\\eec8\"; }\r\n.ri-loader-fill:before { content: \"\\eec9\"; }\r\n.ri-loader-line:before { content: \"\\eeca\"; }\r\n.ri-lock-2-fill:before { content: \"\\eecb\"; }\r\n.ri-lock-2-line:before { content: \"\\eecc\"; }\r\n.ri-lock-fill:before { content: \"\\eecd\"; }\r\n.ri-lock-line:before { content: \"\\eece\"; }\r\n.ri-lock-password-fill:before { content: \"\\eecf\"; }\r\n.ri-lock-password-line:before { content: \"\\eed0\"; }\r\n.ri-lock-unlock-fill:before { content: \"\\eed1\"; }\r\n.ri-lock-unlock-line:before { content: \"\\eed2\"; }\r\n.ri-login-box-fill:before { content: \"\\eed3\"; }\r\n.ri-login-box-line:before { content: \"\\eed4\"; }\r\n.ri-login-circle-fill:before { content: \"\\eed5\"; }\r\n.ri-login-circle-line:before { content: \"\\eed6\"; }\r\n.ri-logout-box-fill:before { content: \"\\eed7\"; }\r\n.ri-logout-box-line:before { content: \"\\eed8\"; }\r\n.ri-logout-box-r-fill:before { content: \"\\eed9\"; }\r\n.ri-logout-box-r-line:before { content: \"\\eeda\"; }\r\n.ri-logout-circle-fill:before { content: \"\\eedb\"; }\r\n.ri-logout-circle-line:before { content: \"\\eedc\"; }\r\n.ri-logout-circle-r-fill:before { content: \"\\eedd\"; }\r\n.ri-logout-circle-r-line:before { content: \"\\eede\"; }\r\n.ri-luggage-cart-fill:before { content: \"\\eedf\"; }\r\n.ri-luggage-cart-line:before { content: \"\\eee0\"; }\r\n.ri-luggage-deposit-fill:before { content: \"\\eee1\"; }\r\n.ri-luggage-deposit-line:before { content: \"\\eee2\"; }\r\n.ri-lungs-fill:before { content: \"\\eee3\"; }\r\n.ri-lungs-line:before { content: \"\\eee4\"; }\r\n.ri-mac-fill:before { content: \"\\eee5\"; }\r\n.ri-mac-line:before { content: \"\\eee6\"; }\r\n.ri-macbook-fill:before { content: \"\\eee7\"; }\r\n.ri-macbook-line:before { content: \"\\eee8\"; }\r\n.ri-magic-fill:before { content: \"\\eee9\"; }\r\n.ri-magic-line:before { content: \"\\eeea\"; }\r\n.ri-mail-add-fill:before { content: \"\\eeeb\"; }\r\n.ri-mail-add-line:before { content: \"\\eeec\"; }\r\n.ri-mail-check-fill:before { content: \"\\eeed\"; }\r\n.ri-mail-check-line:before { content: \"\\eeee\"; }\r\n.ri-mail-close-fill:before { content: \"\\eeef\"; }\r\n.ri-mail-close-line:before { content: \"\\eef0\"; }\r\n.ri-mail-download-fill:before { content: \"\\eef1\"; }\r\n.ri-mail-download-line:before { content: \"\\eef2\"; }\r\n.ri-mail-fill:before { content: \"\\eef3\"; }\r\n.ri-mail-forbid-fill:before { content: \"\\eef4\"; }\r\n.ri-mail-forbid-line:before { content: \"\\eef5\"; }\r\n.ri-mail-line:before { content: \"\\eef6\"; }\r\n.ri-mail-lock-fill:before { content: \"\\eef7\"; }\r\n.ri-mail-lock-line:before { content: \"\\eef8\"; }\r\n.ri-mail-open-fill:before { content: \"\\eef9\"; }\r\n.ri-mail-open-line:before { content: \"\\eefa\"; }\r\n.ri-mail-send-fill:before { content: \"\\eefb\"; }\r\n.ri-mail-send-line:before { content: \"\\eefc\"; }\r\n.ri-mail-settings-fill:before { content: \"\\eefd\"; }\r\n.ri-mail-settings-line:before { content: \"\\eefe\"; }\r\n.ri-mail-star-fill:before { content: \"\\eeff\"; }\r\n.ri-mail-star-line:before { content: \"\\ef00\"; }\r\n.ri-mail-unread-fill:before { content: \"\\ef01\"; }\r\n.ri-mail-unread-line:before { content: \"\\ef02\"; }\r\n.ri-mail-volume-fill:before { content: \"\\ef03\"; }\r\n.ri-mail-volume-line:before { content: \"\\ef04\"; }\r\n.ri-map-2-fill:before { content: \"\\ef05\"; }\r\n.ri-map-2-line:before { content: \"\\ef06\"; }\r\n.ri-map-fill:before { content: \"\\ef07\"; }\r\n.ri-map-line:before { content: \"\\ef08\"; }\r\n.ri-map-pin-2-fill:before { content: \"\\ef09\"; }\r\n.ri-map-pin-2-line:before { content: \"\\ef0a\"; }\r\n.ri-map-pin-3-fill:before { content: \"\\ef0b\"; }\r\n.ri-map-pin-3-line:before { content: \"\\ef0c\"; }\r\n.ri-map-pin-4-fill:before { content: \"\\ef0d\"; }\r\n.ri-map-pin-4-line:before { content: \"\\ef0e\"; }\r\n.ri-map-pin-5-fill:before { content: \"\\ef0f\"; }\r\n.ri-map-pin-5-line:before { content: \"\\ef10\"; }\r\n.ri-map-pin-add-fill:before { content: \"\\ef11\"; }\r\n.ri-map-pin-add-line:before { content: \"\\ef12\"; }\r\n.ri-map-pin-fill:before { content: \"\\ef13\"; }\r\n.ri-map-pin-line:before { content: \"\\ef14\"; }\r\n.ri-map-pin-range-fill:before { content: \"\\ef15\"; }\r\n.ri-map-pin-range-line:before { content: \"\\ef16\"; }\r\n.ri-map-pin-time-fill:before { content: \"\\ef17\"; }\r\n.ri-map-pin-time-line:before { content: \"\\ef18\"; }\r\n.ri-map-pin-user-fill:before { content: \"\\ef19\"; }\r\n.ri-map-pin-user-line:before { content: \"\\ef1a\"; }\r\n.ri-mark-pen-fill:before { content: \"\\ef1b\"; }\r\n.ri-mark-pen-line:before { content: \"\\ef1c\"; }\r\n.ri-markdown-fill:before { content: \"\\ef1d\"; }\r\n.ri-markdown-line:before { content: \"\\ef1e\"; }\r\n.ri-markup-fill:before { content: \"\\ef1f\"; }\r\n.ri-markup-line:before { content: \"\\ef20\"; }\r\n.ri-mastercard-fill:before { content: \"\\ef21\"; }\r\n.ri-mastercard-line:before { content: \"\\ef22\"; }\r\n.ri-mastodon-fill:before { content: \"\\ef23\"; }\r\n.ri-mastodon-line:before { content: \"\\ef24\"; }\r\n.ri-medal-2-fill:before { content: \"\\ef25\"; }\r\n.ri-medal-2-line:before { content: \"\\ef26\"; }\r\n.ri-medal-fill:before { content: \"\\ef27\"; }\r\n.ri-medal-line:before { content: \"\\ef28\"; }\r\n.ri-medicine-bottle-fill:before { content: \"\\ef29\"; }\r\n.ri-medicine-bottle-line:before { content: \"\\ef2a\"; }\r\n.ri-medium-fill:before { content: \"\\ef2b\"; }\r\n.ri-medium-line:before { content: \"\\ef2c\"; }\r\n.ri-men-fill:before { content: \"\\ef2d\"; }\r\n.ri-men-line:before { content: \"\\ef2e\"; }\r\n.ri-mental-health-fill:before { content: \"\\ef2f\"; }\r\n.ri-mental-health-line:before { content: \"\\ef30\"; }\r\n.ri-menu-2-fill:before { content: \"\\ef31\"; }\r\n.ri-menu-2-line:before { content: \"\\ef32\"; }\r\n.ri-menu-3-fill:before { content: \"\\ef33\"; }\r\n.ri-menu-3-line:before { content: \"\\ef34\"; }\r\n.ri-menu-4-fill:before { content: \"\\ef35\"; }\r\n.ri-menu-4-line:before { content: \"\\ef36\"; }\r\n.ri-menu-5-fill:before { content: \"\\ef37\"; }\r\n.ri-menu-5-line:before { content: \"\\ef38\"; }\r\n.ri-menu-add-fill:before { content: \"\\ef39\"; }\r\n.ri-menu-add-line:before { content: \"\\ef3a\"; }\r\n.ri-menu-fill:before { content: \"\\ef3b\"; }\r\n.ri-menu-fold-fill:before { content: \"\\ef3c\"; }\r\n.ri-menu-fold-line:before { content: \"\\ef3d\"; }\r\n.ri-menu-line:before { content: \"\\ef3e\"; }\r\n.ri-menu-unfold-fill:before { content: \"\\ef3f\"; }\r\n.ri-menu-unfold-line:before { content: \"\\ef40\"; }\r\n.ri-merge-cells-horizontal:before { content: \"\\ef41\"; }\r\n.ri-merge-cells-vertical:before { content: \"\\ef42\"; }\r\n.ri-message-2-fill:before { content: \"\\ef43\"; }\r\n.ri-message-2-line:before { content: \"\\ef44\"; }\r\n.ri-message-3-fill:before { content: \"\\ef45\"; }\r\n.ri-message-3-line:before { content: \"\\ef46\"; }\r\n.ri-message-fill:before { content: \"\\ef47\"; }\r\n.ri-message-line:before { content: \"\\ef48\"; }\r\n.ri-messenger-fill:before { content: \"\\ef49\"; }\r\n.ri-messenger-line:before { content: \"\\ef4a\"; }\r\n.ri-meteor-fill:before { content: \"\\ef4b\"; }\r\n.ri-meteor-line:before { content: \"\\ef4c\"; }\r\n.ri-mic-2-fill:before { content: \"\\ef4d\"; }\r\n.ri-mic-2-line:before { content: \"\\ef4e\"; }\r\n.ri-mic-fill:before { content: \"\\ef4f\"; }\r\n.ri-mic-line:before { content: \"\\ef50\"; }\r\n.ri-mic-off-fill:before { content: \"\\ef51\"; }\r\n.ri-mic-off-line:before { content: \"\\ef52\"; }\r\n.ri-mickey-fill:before { content: \"\\ef53\"; }\r\n.ri-mickey-line:before { content: \"\\ef54\"; }\r\n.ri-microscope-fill:before { content: \"\\ef55\"; }\r\n.ri-microscope-line:before { content: \"\\ef56\"; }\r\n.ri-microsoft-fill:before { content: \"\\ef57\"; }\r\n.ri-microsoft-line:before { content: \"\\ef58\"; }\r\n.ri-mind-map:before { content: \"\\ef59\"; }\r\n.ri-mini-program-fill:before { content: \"\\ef5a\"; }\r\n.ri-mini-program-line:before { content: \"\\ef5b\"; }\r\n.ri-mist-fill:before { content: \"\\ef5c\"; }\r\n.ri-mist-line:before { content: \"\\ef5d\"; }\r\n.ri-money-cny-box-fill:before { content: \"\\ef5e\"; }\r\n.ri-money-cny-box-line:before { content: \"\\ef5f\"; }\r\n.ri-money-cny-circle-fill:before { content: \"\\ef60\"; }\r\n.ri-money-cny-circle-line:before { content: \"\\ef61\"; }\r\n.ri-money-dollar-box-fill:before { content: \"\\ef62\"; }\r\n.ri-money-dollar-box-line:before { content: \"\\ef63\"; }\r\n.ri-money-dollar-circle-fill:before { content: \"\\ef64\"; }\r\n.ri-money-dollar-circle-line:before { content: \"\\ef65\"; }\r\n.ri-money-euro-box-fill:before { content: \"\\ef66\"; }\r\n.ri-money-euro-box-line:before { content: \"\\ef67\"; }\r\n.ri-money-euro-circle-fill:before { content: \"\\ef68\"; }\r\n.ri-money-euro-circle-line:before { content: \"\\ef69\"; }\r\n.ri-money-pound-box-fill:before { content: \"\\ef6a\"; }\r\n.ri-money-pound-box-line:before { content: \"\\ef6b\"; }\r\n.ri-money-pound-circle-fill:before { content: \"\\ef6c\"; }\r\n.ri-money-pound-circle-line:before { content: \"\\ef6d\"; }\r\n.ri-moon-clear-fill:before { content: \"\\ef6e\"; }\r\n.ri-moon-clear-line:before { content: \"\\ef6f\"; }\r\n.ri-moon-cloudy-fill:before { content: \"\\ef70\"; }\r\n.ri-moon-cloudy-line:before { content: \"\\ef71\"; }\r\n.ri-moon-fill:before { content: \"\\ef72\"; }\r\n.ri-moon-foggy-fill:before { content: \"\\ef73\"; }\r\n.ri-moon-foggy-line:before { content: \"\\ef74\"; }\r\n.ri-moon-line:before { content: \"\\ef75\"; }\r\n.ri-more-2-fill:before { content: \"\\ef76\"; }\r\n.ri-more-2-line:before { content: \"\\ef77\"; }\r\n.ri-more-fill:before { content: \"\\ef78\"; }\r\n.ri-more-line:before { content: \"\\ef79\"; }\r\n.ri-motorbike-fill:before { content: \"\\ef7a\"; }\r\n.ri-motorbike-line:before { content: \"\\ef7b\"; }\r\n.ri-mouse-fill:before { content: \"\\ef7c\"; }\r\n.ri-mouse-line:before { content: \"\\ef7d\"; }\r\n.ri-movie-2-fill:before { content: \"\\ef7e\"; }\r\n.ri-movie-2-line:before { content: \"\\ef7f\"; }\r\n.ri-movie-fill:before { content: \"\\ef80\"; }\r\n.ri-movie-line:before { content: \"\\ef81\"; }\r\n.ri-music-2-fill:before { content: \"\\ef82\"; }\r\n.ri-music-2-line:before { content: \"\\ef83\"; }\r\n.ri-music-fill:before { content: \"\\ef84\"; }\r\n.ri-music-line:before { content: \"\\ef85\"; }\r\n.ri-mv-fill:before { content: \"\\ef86\"; }\r\n.ri-mv-line:before { content: \"\\ef87\"; }\r\n.ri-navigation-fill:before { content: \"\\ef88\"; }\r\n.ri-navigation-line:before { content: \"\\ef89\"; }\r\n.ri-netease-cloud-music-fill:before { content: \"\\ef8a\"; }\r\n.ri-netease-cloud-music-line:before { content: \"\\ef8b\"; }\r\n.ri-netflix-fill:before { content: \"\\ef8c\"; }\r\n.ri-netflix-line:before { content: \"\\ef8d\"; }\r\n.ri-newspaper-fill:before { content: \"\\ef8e\"; }\r\n.ri-newspaper-line:before { content: \"\\ef8f\"; }\r\n.ri-node-tree:before { content: \"\\ef90\"; }\r\n.ri-notification-2-fill:before { content: \"\\ef91\"; }\r\n.ri-notification-2-line:before { content: \"\\ef92\"; }\r\n.ri-notification-3-fill:before { content: \"\\ef93\"; }\r\n.ri-notification-3-line:before { content: \"\\ef94\"; }\r\n.ri-notification-4-fill:before { content: \"\\ef95\"; }\r\n.ri-notification-4-line:before { content: \"\\ef96\"; }\r\n.ri-notification-badge-fill:before { content: \"\\ef97\"; }\r\n.ri-notification-badge-line:before { content: \"\\ef98\"; }\r\n.ri-notification-fill:before { content: \"\\ef99\"; }\r\n.ri-notification-line:before { content: \"\\ef9a\"; }\r\n.ri-notification-off-fill:before { content: \"\\ef9b\"; }\r\n.ri-notification-off-line:before { content: \"\\ef9c\"; }\r\n.ri-npmjs-fill:before { content: \"\\ef9d\"; }\r\n.ri-npmjs-line:before { content: \"\\ef9e\"; }\r\n.ri-number-0:before { content: \"\\ef9f\"; }\r\n.ri-number-1:before { content: \"\\efa0\"; }\r\n.ri-number-2:before { content: \"\\efa1\"; }\r\n.ri-number-3:before { content: \"\\efa2\"; }\r\n.ri-number-4:before { content: \"\\efa3\"; }\r\n.ri-number-5:before { content: \"\\efa4\"; }\r\n.ri-number-6:before { content: \"\\efa5\"; }\r\n.ri-number-7:before { content: \"\\efa6\"; }\r\n.ri-number-8:before { content: \"\\efa7\"; }\r\n.ri-number-9:before { content: \"\\efa8\"; }\r\n.ri-numbers-fill:before { content: \"\\efa9\"; }\r\n.ri-numbers-line:before { content: \"\\efaa\"; }\r\n.ri-nurse-fill:before { content: \"\\efab\"; }\r\n.ri-nurse-line:before { content: \"\\efac\"; }\r\n.ri-oil-fill:before { content: \"\\efad\"; }\r\n.ri-oil-line:before { content: \"\\efae\"; }\r\n.ri-omega:before { content: \"\\efaf\"; }\r\n.ri-open-arm-fill:before { content: \"\\efb0\"; }\r\n.ri-open-arm-line:before { content: \"\\efb1\"; }\r\n.ri-open-source-fill:before { content: \"\\efb2\"; }\r\n.ri-open-source-line:before { content: \"\\efb3\"; }\r\n.ri-opera-fill:before { content: \"\\efb4\"; }\r\n.ri-opera-line:before { content: \"\\efb5\"; }\r\n.ri-order-play-fill:before { content: \"\\efb6\"; }\r\n.ri-order-play-line:before { content: \"\\efb7\"; }\r\n.ri-organization-chart:before { content: \"\\efb8\"; }\r\n.ri-outlet-2-fill:before { content: \"\\efb9\"; }\r\n.ri-outlet-2-line:before { content: \"\\efba\"; }\r\n.ri-outlet-fill:before { content: \"\\efbb\"; }\r\n.ri-outlet-line:before { content: \"\\efbc\"; }\r\n.ri-page-separator:before { content: \"\\efbd\"; }\r\n.ri-pages-fill:before { content: \"\\efbe\"; }\r\n.ri-pages-line:before { content: \"\\efbf\"; }\r\n.ri-paint-brush-fill:before { content: \"\\efc0\"; }\r\n.ri-paint-brush-line:before { content: \"\\efc1\"; }\r\n.ri-paint-fill:before { content: \"\\efc2\"; }\r\n.ri-paint-line:before { content: \"\\efc3\"; }\r\n.ri-palette-fill:before { content: \"\\efc4\"; }\r\n.ri-palette-line:before { content: \"\\efc5\"; }\r\n.ri-pantone-fill:before { content: \"\\efc6\"; }\r\n.ri-pantone-line:before { content: \"\\efc7\"; }\r\n.ri-paragraph:before { content: \"\\efc8\"; }\r\n.ri-parent-fill:before { content: \"\\efc9\"; }\r\n.ri-parent-line:before { content: \"\\efca\"; }\r\n.ri-parentheses-fill:before { content: \"\\efcb\"; }\r\n.ri-parentheses-line:before { content: \"\\efcc\"; }\r\n.ri-parking-box-fill:before { content: \"\\efcd\"; }\r\n.ri-parking-box-line:before { content: \"\\efce\"; }\r\n.ri-parking-fill:before { content: \"\\efcf\"; }\r\n.ri-parking-line:before { content: \"\\efd0\"; }\r\n.ri-passport-fill:before { content: \"\\efd1\"; }\r\n.ri-passport-line:before { content: \"\\efd2\"; }\r\n.ri-patreon-fill:before { content: \"\\efd3\"; }\r\n.ri-patreon-line:before { content: \"\\efd4\"; }\r\n.ri-pause-circle-fill:before { content: \"\\efd5\"; }\r\n.ri-pause-circle-line:before { content: \"\\efd6\"; }\r\n.ri-pause-fill:before { content: \"\\efd7\"; }\r\n.ri-pause-line:before { content: \"\\efd8\"; }\r\n.ri-pause-mini-fill:before { content: \"\\efd9\"; }\r\n.ri-pause-mini-line:before { content: \"\\efda\"; }\r\n.ri-paypal-fill:before { content: \"\\efdb\"; }\r\n.ri-paypal-line:before { content: \"\\efdc\"; }\r\n.ri-pen-nib-fill:before { content: \"\\efdd\"; }\r\n.ri-pen-nib-line:before { content: \"\\efde\"; }\r\n.ri-pencil-fill:before { content: \"\\efdf\"; }\r\n.ri-pencil-line:before { content: \"\\efe0\"; }\r\n.ri-pencil-ruler-2-fill:before { content: \"\\efe1\"; }\r\n.ri-pencil-ruler-2-line:before { content: \"\\efe2\"; }\r\n.ri-pencil-ruler-fill:before { content: \"\\efe3\"; }\r\n.ri-pencil-ruler-line:before { content: \"\\efe4\"; }\r\n.ri-percent-fill:before { content: \"\\efe5\"; }\r\n.ri-percent-line:before { content: \"\\efe6\"; }\r\n.ri-phone-camera-fill:before { content: \"\\efe7\"; }\r\n.ri-phone-camera-line:before { content: \"\\efe8\"; }\r\n.ri-phone-fill:before { content: \"\\efe9\"; }\r\n.ri-phone-find-fill:before { content: \"\\efea\"; }\r\n.ri-phone-find-line:before { content: \"\\efeb\"; }\r\n.ri-phone-line:before { content: \"\\efec\"; }\r\n.ri-phone-lock-fill:before { content: \"\\efed\"; }\r\n.ri-phone-lock-line:before { content: \"\\efee\"; }\r\n.ri-picture-in-picture-2-fill:before { content: \"\\efef\"; }\r\n.ri-picture-in-picture-2-line:before { content: \"\\eff0\"; }\r\n.ri-picture-in-picture-exit-fill:before { content: \"\\eff1\"; }\r\n.ri-picture-in-picture-exit-line:before { content: \"\\eff2\"; }\r\n.ri-picture-in-picture-fill:before { content: \"\\eff3\"; }\r\n.ri-picture-in-picture-line:before { content: \"\\eff4\"; }\r\n.ri-pie-chart-2-fill:before { content: \"\\eff5\"; }\r\n.ri-pie-chart-2-line:before { content: \"\\eff6\"; }\r\n.ri-pie-chart-box-fill:before { content: \"\\eff7\"; }\r\n.ri-pie-chart-box-line:before { content: \"\\eff8\"; }\r\n.ri-pie-chart-fill:before { content: \"\\eff9\"; }\r\n.ri-pie-chart-line:before { content: \"\\effa\"; }\r\n.ri-pin-distance-fill:before { content: \"\\effb\"; }\r\n.ri-pin-distance-line:before { content: \"\\effc\"; }\r\n.ri-ping-pong-fill:before { content: \"\\effd\"; }\r\n.ri-ping-pong-line:before { content: \"\\effe\"; }\r\n.ri-pinterest-fill:before { content: \"\\efff\"; }\r\n.ri-pinterest-line:before { content: \"\\f000\"; }\r\n.ri-pinyin-input:before { content: \"\\f001\"; }\r\n.ri-pixelfed-fill:before { content: \"\\f002\"; }\r\n.ri-pixelfed-line:before { content: \"\\f003\"; }\r\n.ri-plane-fill:before { content: \"\\f004\"; }\r\n.ri-plane-line:before { content: \"\\f005\"; }\r\n.ri-plant-fill:before { content: \"\\f006\"; }\r\n.ri-plant-line:before { content: \"\\f007\"; }\r\n.ri-play-circle-fill:before { content: \"\\f008\"; }\r\n.ri-play-circle-line:before { content: \"\\f009\"; }\r\n.ri-play-fill:before { content: \"\\f00a\"; }\r\n.ri-play-line:before { content: \"\\f00b\"; }\r\n.ri-play-list-2-fill:before { content: \"\\f00c\"; }\r\n.ri-play-list-2-line:before { content: \"\\f00d\"; }\r\n.ri-play-list-add-fill:before { content: \"\\f00e\"; }\r\n.ri-play-list-add-line:before { content: \"\\f00f\"; }\r\n.ri-play-list-fill:before { content: \"\\f010\"; }\r\n.ri-play-list-line:before { content: \"\\f011\"; }\r\n.ri-play-mini-fill:before { content: \"\\f012\"; }\r\n.ri-play-mini-line:before { content: \"\\f013\"; }\r\n.ri-playstation-fill:before { content: \"\\f014\"; }\r\n.ri-playstation-line:before { content: \"\\f015\"; }\r\n.ri-plug-2-fill:before { content: \"\\f016\"; }\r\n.ri-plug-2-line:before { content: \"\\f017\"; }\r\n.ri-plug-fill:before { content: \"\\f018\"; }\r\n.ri-plug-line:before { content: \"\\f019\"; }\r\n.ri-polaroid-2-fill:before { content: \"\\f01a\"; }\r\n.ri-polaroid-2-line:before { content: \"\\f01b\"; }\r\n.ri-polaroid-fill:before { content: \"\\f01c\"; }\r\n.ri-polaroid-line:before { content: \"\\f01d\"; }\r\n.ri-police-car-fill:before { content: \"\\f01e\"; }\r\n.ri-police-car-line:before { content: \"\\f01f\"; }\r\n.ri-price-tag-2-fill:before { content: \"\\f020\"; }\r\n.ri-price-tag-2-line:before { content: \"\\f021\"; }\r\n.ri-price-tag-3-fill:before { content: \"\\f022\"; }\r\n.ri-price-tag-3-line:before { content: \"\\f023\"; }\r\n.ri-price-tag-fill:before { content: \"\\f024\"; }\r\n.ri-price-tag-line:before { content: \"\\f025\"; }\r\n.ri-printer-cloud-fill:before { content: \"\\f026\"; }\r\n.ri-printer-cloud-line:before { content: \"\\f027\"; }\r\n.ri-printer-fill:before { content: \"\\f028\"; }\r\n.ri-printer-line:before { content: \"\\f029\"; }\r\n.ri-product-hunt-fill:before { content: \"\\f02a\"; }\r\n.ri-product-hunt-line:before { content: \"\\f02b\"; }\r\n.ri-profile-fill:before { content: \"\\f02c\"; }\r\n.ri-profile-line:before { content: \"\\f02d\"; }\r\n.ri-projector-2-fill:before { content: \"\\f02e\"; }\r\n.ri-projector-2-line:before { content: \"\\f02f\"; }\r\n.ri-projector-fill:before { content: \"\\f030\"; }\r\n.ri-projector-line:before { content: \"\\f031\"; }\r\n.ri-psychotherapy-fill:before { content: \"\\f032\"; }\r\n.ri-psychotherapy-line:before { content: \"\\f033\"; }\r\n.ri-pulse-fill:before { content: \"\\f034\"; }\r\n.ri-pulse-line:before { content: \"\\f035\"; }\r\n.ri-pushpin-2-fill:before { content: \"\\f036\"; }\r\n.ri-pushpin-2-line:before { content: \"\\f037\"; }\r\n.ri-pushpin-fill:before { content: \"\\f038\"; }\r\n.ri-pushpin-line:before { content: \"\\f039\"; }\r\n.ri-qq-fill:before { content: \"\\f03a\"; }\r\n.ri-qq-line:before { content: \"\\f03b\"; }\r\n.ri-qr-code-fill:before { content: \"\\f03c\"; }\r\n.ri-qr-code-line:before { content: \"\\f03d\"; }\r\n.ri-qr-scan-2-fill:before { content: \"\\f03e\"; }\r\n.ri-qr-scan-2-line:before { content: \"\\f03f\"; }\r\n.ri-qr-scan-fill:before { content: \"\\f040\"; }\r\n.ri-qr-scan-line:before { content: \"\\f041\"; }\r\n.ri-question-answer-fill:before { content: \"\\f042\"; }\r\n.ri-question-answer-line:before { content: \"\\f043\"; }\r\n.ri-question-fill:before { content: \"\\f044\"; }\r\n.ri-question-line:before { content: \"\\f045\"; }\r\n.ri-question-mark:before { content: \"\\f046\"; }\r\n.ri-questionnaire-fill:before { content: \"\\f047\"; }\r\n.ri-questionnaire-line:before { content: \"\\f048\"; }\r\n.ri-quill-pen-fill:before { content: \"\\f049\"; }\r\n.ri-quill-pen-line:before { content: \"\\f04a\"; }\r\n.ri-radar-fill:before { content: \"\\f04b\"; }\r\n.ri-radar-line:before { content: \"\\f04c\"; }\r\n.ri-radio-2-fill:before { content: \"\\f04d\"; }\r\n.ri-radio-2-line:before { content: \"\\f04e\"; }\r\n.ri-radio-button-fill:before { content: \"\\f04f\"; }\r\n.ri-radio-button-line:before { content: \"\\f050\"; }\r\n.ri-radio-fill:before { content: \"\\f051\"; }\r\n.ri-radio-line:before { content: \"\\f052\"; }\r\n.ri-rainbow-fill:before { content: \"\\f053\"; }\r\n.ri-rainbow-line:before { content: \"\\f054\"; }\r\n.ri-rainy-fill:before { content: \"\\f055\"; }\r\n.ri-rainy-line:before { content: \"\\f056\"; }\r\n.ri-reactjs-fill:before { content: \"\\f057\"; }\r\n.ri-reactjs-line:before { content: \"\\f058\"; }\r\n.ri-record-circle-fill:before { content: \"\\f059\"; }\r\n.ri-record-circle-line:before { content: \"\\f05a\"; }\r\n.ri-record-mail-fill:before { content: \"\\f05b\"; }\r\n.ri-record-mail-line:before { content: \"\\f05c\"; }\r\n.ri-recycle-fill:before { content: \"\\f05d\"; }\r\n.ri-recycle-line:before { content: \"\\f05e\"; }\r\n.ri-red-packet-fill:before { content: \"\\f05f\"; }\r\n.ri-red-packet-line:before { content: \"\\f060\"; }\r\n.ri-reddit-fill:before { content: \"\\f061\"; }\r\n.ri-reddit-line:before { content: \"\\f062\"; }\r\n.ri-refresh-fill:before { content: \"\\f063\"; }\r\n.ri-refresh-line:before { content: \"\\f064\"; }\r\n.ri-refund-2-fill:before { content: \"\\f065\"; }\r\n.ri-refund-2-line:before { content: \"\\f066\"; }\r\n.ri-refund-fill:before { content: \"\\f067\"; }\r\n.ri-refund-line:before { content: \"\\f068\"; }\r\n.ri-registered-fill:before { content: \"\\f069\"; }\r\n.ri-registered-line:before { content: \"\\f06a\"; }\r\n.ri-remixicon-fill:before { content: \"\\f06b\"; }\r\n.ri-remixicon-line:before { content: \"\\f06c\"; }\r\n.ri-remote-control-2-fill:before { content: \"\\f06d\"; }\r\n.ri-remote-control-2-line:before { content: \"\\f06e\"; }\r\n.ri-remote-control-fill:before { content: \"\\f06f\"; }\r\n.ri-remote-control-line:before { content: \"\\f070\"; }\r\n.ri-repeat-2-fill:before { content: \"\\f071\"; }\r\n.ri-repeat-2-line:before { content: \"\\f072\"; }\r\n.ri-repeat-fill:before { content: \"\\f073\"; }\r\n.ri-repeat-line:before { content: \"\\f074\"; }\r\n.ri-repeat-one-fill:before { content: \"\\f075\"; }\r\n.ri-repeat-one-line:before { content: \"\\f076\"; }\r\n.ri-reply-all-fill:before { content: \"\\f077\"; }\r\n.ri-reply-all-line:before { content: \"\\f078\"; }\r\n.ri-reply-fill:before { content: \"\\f079\"; }\r\n.ri-reply-line:before { content: \"\\f07a\"; }\r\n.ri-reserved-fill:before { content: \"\\f07b\"; }\r\n.ri-reserved-line:before { content: \"\\f07c\"; }\r\n.ri-rest-time-fill:before { content: \"\\f07d\"; }\r\n.ri-rest-time-line:before { content: \"\\f07e\"; }\r\n.ri-restart-fill:before { content: \"\\f07f\"; }\r\n.ri-restart-line:before { content: \"\\f080\"; }\r\n.ri-restaurant-2-fill:before { content: \"\\f081\"; }\r\n.ri-restaurant-2-line:before { content: \"\\f082\"; }\r\n.ri-restaurant-fill:before { content: \"\\f083\"; }\r\n.ri-restaurant-line:before { content: \"\\f084\"; }\r\n.ri-rewind-fill:before { content: \"\\f085\"; }\r\n.ri-rewind-line:before { content: \"\\f086\"; }\r\n.ri-rewind-mini-fill:before { content: \"\\f087\"; }\r\n.ri-rewind-mini-line:before { content: \"\\f088\"; }\r\n.ri-rhythm-fill:before { content: \"\\f089\"; }\r\n.ri-rhythm-line:before { content: \"\\f08a\"; }\r\n.ri-riding-fill:before { content: \"\\f08b\"; }\r\n.ri-riding-line:before { content: \"\\f08c\"; }\r\n.ri-road-map-fill:before { content: \"\\f08d\"; }\r\n.ri-road-map-line:before { content: \"\\f08e\"; }\r\n.ri-roadster-fill:before { content: \"\\f08f\"; }\r\n.ri-roadster-line:before { content: \"\\f090\"; }\r\n.ri-robot-fill:before { content: \"\\f091\"; }\r\n.ri-robot-line:before { content: \"\\f092\"; }\r\n.ri-rocket-2-fill:before { content: \"\\f093\"; }\r\n.ri-rocket-2-line:before { content: \"\\f094\"; }\r\n.ri-rocket-fill:before { content: \"\\f095\"; }\r\n.ri-rocket-line:before { content: \"\\f096\"; }\r\n.ri-rotate-lock-fill:before { content: \"\\f097\"; }\r\n.ri-rotate-lock-line:before { content: \"\\f098\"; }\r\n.ri-rounded-corner:before { content: \"\\f099\"; }\r\n.ri-route-fill:before { content: \"\\f09a\"; }\r\n.ri-route-line:before { content: \"\\f09b\"; }\r\n.ri-router-fill:before { content: \"\\f09c\"; }\r\n.ri-router-line:before { content: \"\\f09d\"; }\r\n.ri-rss-fill:before { content: \"\\f09e\"; }\r\n.ri-rss-line:before { content: \"\\f09f\"; }\r\n.ri-ruler-2-fill:before { content: \"\\f0a0\"; }\r\n.ri-ruler-2-line:before { content: \"\\f0a1\"; }\r\n.ri-ruler-fill:before { content: \"\\f0a2\"; }\r\n.ri-ruler-line:before { content: \"\\f0a3\"; }\r\n.ri-run-fill:before { content: \"\\f0a4\"; }\r\n.ri-run-line:before { content: \"\\f0a5\"; }\r\n.ri-safari-fill:before { content: \"\\f0a6\"; }\r\n.ri-safari-line:before { content: \"\\f0a7\"; }\r\n.ri-safe-2-fill:before { content: \"\\f0a8\"; }\r\n.ri-safe-2-line:before { content: \"\\f0a9\"; }\r\n.ri-safe-fill:before { content: \"\\f0aa\"; }\r\n.ri-safe-line:before { content: \"\\f0ab\"; }\r\n.ri-sailboat-fill:before { content: \"\\f0ac\"; }\r\n.ri-sailboat-line:before { content: \"\\f0ad\"; }\r\n.ri-save-2-fill:before { content: \"\\f0ae\"; }\r\n.ri-save-2-line:before { content: \"\\f0af\"; }\r\n.ri-save-3-fill:before { content: \"\\f0b0\"; }\r\n.ri-save-3-line:before { content: \"\\f0b1\"; }\r\n.ri-save-fill:before { content: \"\\f0b2\"; }\r\n.ri-save-line:before { content: \"\\f0b3\"; }\r\n.ri-scales-2-fill:before { content: \"\\f0b4\"; }\r\n.ri-scales-2-line:before { content: \"\\f0b5\"; }\r\n.ri-scales-3-fill:before { content: \"\\f0b6\"; }\r\n.ri-scales-3-line:before { content: \"\\f0b7\"; }\r\n.ri-scales-fill:before { content: \"\\f0b8\"; }\r\n.ri-scales-line:before { content: \"\\f0b9\"; }\r\n.ri-scan-2-fill:before { content: \"\\f0ba\"; }\r\n.ri-scan-2-line:before { content: \"\\f0bb\"; }\r\n.ri-scan-fill:before { content: \"\\f0bc\"; }\r\n.ri-scan-line:before { content: \"\\f0bd\"; }\r\n.ri-scissors-2-fill:before { content: \"\\f0be\"; }\r\n.ri-scissors-2-line:before { content: \"\\f0bf\"; }\r\n.ri-scissors-cut-fill:before { content: \"\\f0c0\"; }\r\n.ri-scissors-cut-line:before { content: \"\\f0c1\"; }\r\n.ri-scissors-fill:before { content: \"\\f0c2\"; }\r\n.ri-scissors-line:before { content: \"\\f0c3\"; }\r\n.ri-screenshot-2-fill:before { content: \"\\f0c4\"; }\r\n.ri-screenshot-2-line:before { content: \"\\f0c5\"; }\r\n.ri-screenshot-fill:before { content: \"\\f0c6\"; }\r\n.ri-screenshot-line:before { content: \"\\f0c7\"; }\r\n.ri-sd-card-fill:before { content: \"\\f0c8\"; }\r\n.ri-sd-card-line:before { content: \"\\f0c9\"; }\r\n.ri-sd-card-mini-fill:before { content: \"\\f0ca\"; }\r\n.ri-sd-card-mini-line:before { content: \"\\f0cb\"; }\r\n.ri-search-2-fill:before { content: \"\\f0cc\"; }\r\n.ri-search-2-line:before { content: \"\\f0cd\"; }\r\n.ri-search-eye-fill:before { content: \"\\f0ce\"; }\r\n.ri-search-eye-line:before { content: \"\\f0cf\"; }\r\n.ri-search-fill:before { content: \"\\f0d0\"; }\r\n.ri-search-line:before { content: \"\\f0d1\"; }\r\n.ri-secure-payment-fill:before { content: \"\\f0d2\"; }\r\n.ri-secure-payment-line:before { content: \"\\f0d3\"; }\r\n.ri-seedling-fill:before { content: \"\\f0d4\"; }\r\n.ri-seedling-line:before { content: \"\\f0d5\"; }\r\n.ri-send-backward:before { content: \"\\f0d6\"; }\r\n.ri-send-plane-2-fill:before { content: \"\\f0d7\"; }\r\n.ri-send-plane-2-line:before { content: \"\\f0d8\"; }\r\n.ri-send-plane-fill:before { content: \"\\f0d9\"; }\r\n.ri-send-plane-line:before { content: \"\\f0da\"; }\r\n.ri-send-to-back:before { content: \"\\f0db\"; }\r\n.ri-sensor-fill:before { content: \"\\f0dc\"; }\r\n.ri-sensor-line:before { content: \"\\f0dd\"; }\r\n.ri-separator:before { content: \"\\f0de\"; }\r\n.ri-server-fill:before { content: \"\\f0df\"; }\r\n.ri-server-line:before { content: \"\\f0e0\"; }\r\n.ri-service-fill:before { content: \"\\f0e1\"; }\r\n.ri-service-line:before { content: \"\\f0e2\"; }\r\n.ri-settings-2-fill:before { content: \"\\f0e3\"; }\r\n.ri-settings-2-line:before { content: \"\\f0e4\"; }\r\n.ri-settings-3-fill:before { content: \"\\f0e5\"; }\r\n.ri-settings-3-line:before { content: \"\\f0e6\"; }\r\n.ri-settings-4-fill:before { content: \"\\f0e7\"; }\r\n.ri-settings-4-line:before { content: \"\\f0e8\"; }\r\n.ri-settings-5-fill:before { content: \"\\f0e9\"; }\r\n.ri-settings-5-line:before { content: \"\\f0ea\"; }\r\n.ri-settings-6-fill:before { content: \"\\f0eb\"; }\r\n.ri-settings-6-line:before { content: \"\\f0ec\"; }\r\n.ri-settings-fill:before { content: \"\\f0ed\"; }\r\n.ri-settings-line:before { content: \"\\f0ee\"; }\r\n.ri-shape-2-fill:before { content: \"\\f0ef\"; }\r\n.ri-shape-2-line:before { content: \"\\f0f0\"; }\r\n.ri-shape-fill:before { content: \"\\f0f1\"; }\r\n.ri-shape-line:before { content: \"\\f0f2\"; }\r\n.ri-share-box-fill:before { content: \"\\f0f3\"; }\r\n.ri-share-box-line:before { content: \"\\f0f4\"; }\r\n.ri-share-circle-fill:before { content: \"\\f0f5\"; }\r\n.ri-share-circle-line:before { content: \"\\f0f6\"; }\r\n.ri-share-fill:before { content: \"\\f0f7\"; }\r\n.ri-share-forward-2-fill:before { content: \"\\f0f8\"; }\r\n.ri-share-forward-2-line:before { content: \"\\f0f9\"; }\r\n.ri-share-forward-box-fill:before { content: \"\\f0fa\"; }\r\n.ri-share-forward-box-line:before { content: \"\\f0fb\"; }\r\n.ri-share-forward-fill:before { content: \"\\f0fc\"; }\r\n.ri-share-forward-line:before { content: \"\\f0fd\"; }\r\n.ri-share-line:before { content: \"\\f0fe\"; }\r\n.ri-shield-check-fill:before { content: \"\\f0ff\"; }\r\n.ri-shield-check-line:before { content: \"\\f100\"; }\r\n.ri-shield-cross-fill:before { content: \"\\f101\"; }\r\n.ri-shield-cross-line:before { content: \"\\f102\"; }\r\n.ri-shield-fill:before { content: \"\\f103\"; }\r\n.ri-shield-flash-fill:before { content: \"\\f104\"; }\r\n.ri-shield-flash-line:before { content: \"\\f105\"; }\r\n.ri-shield-keyhole-fill:before { content: \"\\f106\"; }\r\n.ri-shield-keyhole-line:before { content: \"\\f107\"; }\r\n.ri-shield-line:before { content: \"\\f108\"; }\r\n.ri-shield-star-fill:before { content: \"\\f109\"; }\r\n.ri-shield-star-line:before { content: \"\\f10a\"; }\r\n.ri-shield-user-fill:before { content: \"\\f10b\"; }\r\n.ri-shield-user-line:before { content: \"\\f10c\"; }\r\n.ri-ship-2-fill:before { content: \"\\f10d\"; }\r\n.ri-ship-2-line:before { content: \"\\f10e\"; }\r\n.ri-ship-fill:before { content: \"\\f10f\"; }\r\n.ri-ship-line:before { content: \"\\f110\"; }\r\n.ri-shirt-fill:before { content: \"\\f111\"; }\r\n.ri-shirt-line:before { content: \"\\f112\"; }\r\n.ri-shopping-bag-2-fill:before { content: \"\\f113\"; }\r\n.ri-shopping-bag-2-line:before { content: \"\\f114\"; }\r\n.ri-shopping-bag-3-fill:before { content: \"\\f115\"; }\r\n.ri-shopping-bag-3-line:before { content: \"\\f116\"; }\r\n.ri-shopping-bag-fill:before { content: \"\\f117\"; }\r\n.ri-shopping-bag-line:before { content: \"\\f118\"; }\r\n.ri-shopping-basket-2-fill:before { content: \"\\f119\"; }\r\n.ri-shopping-basket-2-line:before { content: \"\\f11a\"; }\r\n.ri-shopping-basket-fill:before { content: \"\\f11b\"; }\r\n.ri-shopping-basket-line:before { content: \"\\f11c\"; }\r\n.ri-shopping-cart-2-fill:before { content: \"\\f11d\"; }\r\n.ri-shopping-cart-2-line:before { content: \"\\f11e\"; }\r\n.ri-shopping-cart-fill:before { content: \"\\f11f\"; }\r\n.ri-shopping-cart-line:before { content: \"\\f120\"; }\r\n.ri-showers-fill:before { content: \"\\f121\"; }\r\n.ri-showers-line:before { content: \"\\f122\"; }\r\n.ri-shuffle-fill:before { content: \"\\f123\"; }\r\n.ri-shuffle-line:before { content: \"\\f124\"; }\r\n.ri-shut-down-fill:before { content: \"\\f125\"; }\r\n.ri-shut-down-line:before { content: \"\\f126\"; }\r\n.ri-side-bar-fill:before { content: \"\\f127\"; }\r\n.ri-side-bar-line:before { content: \"\\f128\"; }\r\n.ri-signal-tower-fill:before { content: \"\\f129\"; }\r\n.ri-signal-tower-line:before { content: \"\\f12a\"; }\r\n.ri-signal-wifi-1-fill:before { content: \"\\f12b\"; }\r\n.ri-signal-wifi-1-line:before { content: \"\\f12c\"; }\r\n.ri-signal-wifi-2-fill:before { content: \"\\f12d\"; }\r\n.ri-signal-wifi-2-line:before { content: \"\\f12e\"; }\r\n.ri-signal-wifi-3-fill:before { content: \"\\f12f\"; }\r\n.ri-signal-wifi-3-line:before { content: \"\\f130\"; }\r\n.ri-signal-wifi-error-fill:before { content: \"\\f131\"; }\r\n.ri-signal-wifi-error-line:before { content: \"\\f132\"; }\r\n.ri-signal-wifi-fill:before { content: \"\\f133\"; }\r\n.ri-signal-wifi-line:before { content: \"\\f134\"; }\r\n.ri-signal-wifi-off-fill:before { content: \"\\f135\"; }\r\n.ri-signal-wifi-off-line:before { content: \"\\f136\"; }\r\n.ri-sim-card-2-fill:before { content: \"\\f137\"; }\r\n.ri-sim-card-2-line:before { content: \"\\f138\"; }\r\n.ri-sim-card-fill:before { content: \"\\f139\"; }\r\n.ri-sim-card-line:before { content: \"\\f13a\"; }\r\n.ri-single-quotes-l:before { content: \"\\f13b\"; }\r\n.ri-single-quotes-r:before { content: \"\\f13c\"; }\r\n.ri-sip-fill:before { content: \"\\f13d\"; }\r\n.ri-sip-line:before { content: \"\\f13e\"; }\r\n.ri-skip-back-fill:before { content: \"\\f13f\"; }\r\n.ri-skip-back-line:before { content: \"\\f140\"; }\r\n.ri-skip-back-mini-fill:before { content: \"\\f141\"; }\r\n.ri-skip-back-mini-line:before { content: \"\\f142\"; }\r\n.ri-skip-forward-fill:before { content: \"\\f143\"; }\r\n.ri-skip-forward-line:before { content: \"\\f144\"; }\r\n.ri-skip-forward-mini-fill:before { content: \"\\f145\"; }\r\n.ri-skip-forward-mini-line:before { content: \"\\f146\"; }\r\n.ri-skull-2-fill:before { content: \"\\f147\"; }\r\n.ri-skull-2-line:before { content: \"\\f148\"; }\r\n.ri-skull-fill:before { content: \"\\f149\"; }\r\n.ri-skull-line:before { content: \"\\f14a\"; }\r\n.ri-skype-fill:before { content: \"\\f14b\"; }\r\n.ri-skype-line:before { content: \"\\f14c\"; }\r\n.ri-slack-fill:before { content: \"\\f14d\"; }\r\n.ri-slack-line:before { content: \"\\f14e\"; }\r\n.ri-slice-fill:before { content: \"\\f14f\"; }\r\n.ri-slice-line:before { content: \"\\f150\"; }\r\n.ri-slideshow-2-fill:before { content: \"\\f151\"; }\r\n.ri-slideshow-2-line:before { content: \"\\f152\"; }\r\n.ri-slideshow-3-fill:before { content: \"\\f153\"; }\r\n.ri-slideshow-3-line:before { content: \"\\f154\"; }\r\n.ri-slideshow-4-fill:before { content: \"\\f155\"; }\r\n.ri-slideshow-4-line:before { content: \"\\f156\"; }\r\n.ri-slideshow-fill:before { content: \"\\f157\"; }\r\n.ri-slideshow-line:before { content: \"\\f158\"; }\r\n.ri-smartphone-fill:before { content: \"\\f159\"; }\r\n.ri-smartphone-line:before { content: \"\\f15a\"; }\r\n.ri-snapchat-fill:before { content: \"\\f15b\"; }\r\n.ri-snapchat-line:before { content: \"\\f15c\"; }\r\n.ri-snowy-fill:before { content: \"\\f15d\"; }\r\n.ri-snowy-line:before { content: \"\\f15e\"; }\r\n.ri-sort-asc:before { content: \"\\f15f\"; }\r\n.ri-sort-desc:before { content: \"\\f160\"; }\r\n.ri-sound-module-fill:before { content: \"\\f161\"; }\r\n.ri-sound-module-line:before { content: \"\\f162\"; }\r\n.ri-soundcloud-fill:before { content: \"\\f163\"; }\r\n.ri-soundcloud-line:before { content: \"\\f164\"; }\r\n.ri-space-ship-fill:before { content: \"\\f165\"; }\r\n.ri-space-ship-line:before { content: \"\\f166\"; }\r\n.ri-space:before { content: \"\\f167\"; }\r\n.ri-spam-2-fill:before { content: \"\\f168\"; }\r\n.ri-spam-2-line:before { content: \"\\f169\"; }\r\n.ri-spam-3-fill:before { content: \"\\f16a\"; }\r\n.ri-spam-3-line:before { content: \"\\f16b\"; }\r\n.ri-spam-fill:before { content: \"\\f16c\"; }\r\n.ri-spam-line:before { content: \"\\f16d\"; }\r\n.ri-speaker-2-fill:before { content: \"\\f16e\"; }\r\n.ri-speaker-2-line:before { content: \"\\f16f\"; }\r\n.ri-speaker-3-fill:before { content: \"\\f170\"; }\r\n.ri-speaker-3-line:before { content: \"\\f171\"; }\r\n.ri-speaker-fill:before { content: \"\\f172\"; }\r\n.ri-speaker-line:before { content: \"\\f173\"; }\r\n.ri-spectrum-fill:before { content: \"\\f174\"; }\r\n.ri-spectrum-line:before { content: \"\\f175\"; }\r\n.ri-speed-fill:before { content: \"\\f176\"; }\r\n.ri-speed-line:before { content: \"\\f177\"; }\r\n.ri-speed-mini-fill:before { content: \"\\f178\"; }\r\n.ri-speed-mini-line:before { content: \"\\f179\"; }\r\n.ri-split-cells-horizontal:before { content: \"\\f17a\"; }\r\n.ri-split-cells-vertical:before { content: \"\\f17b\"; }\r\n.ri-spotify-fill:before { content: \"\\f17c\"; }\r\n.ri-spotify-line:before { content: \"\\f17d\"; }\r\n.ri-spy-fill:before { content: \"\\f17e\"; }\r\n.ri-spy-line:before { content: \"\\f17f\"; }\r\n.ri-stack-fill:before { content: \"\\f180\"; }\r\n.ri-stack-line:before { content: \"\\f181\"; }\r\n.ri-stack-overflow-fill:before { content: \"\\f182\"; }\r\n.ri-stack-overflow-line:before { content: \"\\f183\"; }\r\n.ri-stackshare-fill:before { content: \"\\f184\"; }\r\n.ri-stackshare-line:before { content: \"\\f185\"; }\r\n.ri-star-fill:before { content: \"\\f186\"; }\r\n.ri-star-half-fill:before { content: \"\\f187\"; }\r\n.ri-star-half-line:before { content: \"\\f188\"; }\r\n.ri-star-half-s-fill:before { content: \"\\f189\"; }\r\n.ri-star-half-s-line:before { content: \"\\f18a\"; }\r\n.ri-star-line:before { content: \"\\f18b\"; }\r\n.ri-star-s-fill:before { content: \"\\f18c\"; }\r\n.ri-star-s-line:before { content: \"\\f18d\"; }\r\n.ri-star-smile-fill:before { content: \"\\f18e\"; }\r\n.ri-star-smile-line:before { content: \"\\f18f\"; }\r\n.ri-steam-fill:before { content: \"\\f190\"; }\r\n.ri-steam-line:before { content: \"\\f191\"; }\r\n.ri-steering-2-fill:before { content: \"\\f192\"; }\r\n.ri-steering-2-line:before { content: \"\\f193\"; }\r\n.ri-steering-fill:before { content: \"\\f194\"; }\r\n.ri-steering-line:before { content: \"\\f195\"; }\r\n.ri-stethoscope-fill:before { content: \"\\f196\"; }\r\n.ri-stethoscope-line:before { content: \"\\f197\"; }\r\n.ri-sticky-note-2-fill:before { content: \"\\f198\"; }\r\n.ri-sticky-note-2-line:before { content: \"\\f199\"; }\r\n.ri-sticky-note-fill:before { content: \"\\f19a\"; }\r\n.ri-sticky-note-line:before { content: \"\\f19b\"; }\r\n.ri-stock-fill:before { content: \"\\f19c\"; }\r\n.ri-stock-line:before { content: \"\\f19d\"; }\r\n.ri-stop-circle-fill:before { content: \"\\f19e\"; }\r\n.ri-stop-circle-line:before { content: \"\\f19f\"; }\r\n.ri-stop-fill:before { content: \"\\f1a0\"; }\r\n.ri-stop-line:before { content: \"\\f1a1\"; }\r\n.ri-stop-mini-fill:before { content: \"\\f1a2\"; }\r\n.ri-stop-mini-line:before { content: \"\\f1a3\"; }\r\n.ri-store-2-fill:before { content: \"\\f1a4\"; }\r\n.ri-store-2-line:before { content: \"\\f1a5\"; }\r\n.ri-store-3-fill:before { content: \"\\f1a6\"; }\r\n.ri-store-3-line:before { content: \"\\f1a7\"; }\r\n.ri-store-fill:before { content: \"\\f1a8\"; }\r\n.ri-store-line:before { content: \"\\f1a9\"; }\r\n.ri-strikethrough-2:before { content: \"\\f1aa\"; }\r\n.ri-strikethrough:before { content: \"\\f1ab\"; }\r\n.ri-subscript-2:before { content: \"\\f1ac\"; }\r\n.ri-subscript:before { content: \"\\f1ad\"; }\r\n.ri-subtract-fill:before { content: \"\\f1ae\"; }\r\n.ri-subtract-line:before { content: \"\\f1af\"; }\r\n.ri-subway-fill:before { content: \"\\f1b0\"; }\r\n.ri-subway-line:before { content: \"\\f1b1\"; }\r\n.ri-subway-wifi-fill:before { content: \"\\f1b2\"; }\r\n.ri-subway-wifi-line:before { content: \"\\f1b3\"; }\r\n.ri-suitcase-2-fill:before { content: \"\\f1b4\"; }\r\n.ri-suitcase-2-line:before { content: \"\\f1b5\"; }\r\n.ri-suitcase-3-fill:before { content: \"\\f1b6\"; }\r\n.ri-suitcase-3-line:before { content: \"\\f1b7\"; }\r\n.ri-suitcase-fill:before { content: \"\\f1b8\"; }\r\n.ri-suitcase-line:before { content: \"\\f1b9\"; }\r\n.ri-sun-cloudy-fill:before { content: \"\\f1ba\"; }\r\n.ri-sun-cloudy-line:before { content: \"\\f1bb\"; }\r\n.ri-sun-fill:before { content: \"\\f1bc\"; }\r\n.ri-sun-foggy-fill:before { content: \"\\f1bd\"; }\r\n.ri-sun-foggy-line:before { content: \"\\f1be\"; }\r\n.ri-sun-line:before { content: \"\\f1bf\"; }\r\n.ri-superscript-2:before { content: \"\\f1c0\"; }\r\n.ri-superscript:before { content: \"\\f1c1\"; }\r\n.ri-surgical-mask-fill:before { content: \"\\f1c2\"; }\r\n.ri-surgical-mask-line:before { content: \"\\f1c3\"; }\r\n.ri-surround-sound-fill:before { content: \"\\f1c4\"; }\r\n.ri-surround-sound-line:before { content: \"\\f1c5\"; }\r\n.ri-survey-fill:before { content: \"\\f1c6\"; }\r\n.ri-survey-line:before { content: \"\\f1c7\"; }\r\n.ri-swap-box-fill:before { content: \"\\f1c8\"; }\r\n.ri-swap-box-line:before { content: \"\\f1c9\"; }\r\n.ri-swap-fill:before { content: \"\\f1ca\"; }\r\n.ri-swap-line:before { content: \"\\f1cb\"; }\r\n.ri-switch-fill:before { content: \"\\f1cc\"; }\r\n.ri-switch-line:before { content: \"\\f1cd\"; }\r\n.ri-sword-fill:before { content: \"\\f1ce\"; }\r\n.ri-sword-line:before { content: \"\\f1cf\"; }\r\n.ri-syringe-fill:before { content: \"\\f1d0\"; }\r\n.ri-syringe-line:before { content: \"\\f1d1\"; }\r\n.ri-t-box-fill:before { content: \"\\f1d2\"; }\r\n.ri-t-box-line:before { content: \"\\f1d3\"; }\r\n.ri-t-shirt-2-fill:before { content: \"\\f1d4\"; }\r\n.ri-t-shirt-2-line:before { content: \"\\f1d5\"; }\r\n.ri-t-shirt-air-fill:before { content: \"\\f1d6\"; }\r\n.ri-t-shirt-air-line:before { content: \"\\f1d7\"; }\r\n.ri-t-shirt-fill:before { content: \"\\f1d8\"; }\r\n.ri-t-shirt-line:before { content: \"\\f1d9\"; }\r\n.ri-table-2:before { content: \"\\f1da\"; }\r\n.ri-table-alt-fill:before { content: \"\\f1db\"; }\r\n.ri-table-alt-line:before { content: \"\\f1dc\"; }\r\n.ri-table-fill:before { content: \"\\f1dd\"; }\r\n.ri-table-line:before { content: \"\\f1de\"; }\r\n.ri-tablet-fill:before { content: \"\\f1df\"; }\r\n.ri-tablet-line:before { content: \"\\f1e0\"; }\r\n.ri-takeaway-fill:before { content: \"\\f1e1\"; }\r\n.ri-takeaway-line:before { content: \"\\f1e2\"; }\r\n.ri-taobao-fill:before { content: \"\\f1e3\"; }\r\n.ri-taobao-line:before { content: \"\\f1e4\"; }\r\n.ri-tape-fill:before { content: \"\\f1e5\"; }\r\n.ri-tape-line:before { content: \"\\f1e6\"; }\r\n.ri-task-fill:before { content: \"\\f1e7\"; }\r\n.ri-task-line:before { content: \"\\f1e8\"; }\r\n.ri-taxi-fill:before { content: \"\\f1e9\"; }\r\n.ri-taxi-line:before { content: \"\\f1ea\"; }\r\n.ri-taxi-wifi-fill:before { content: \"\\f1eb\"; }\r\n.ri-taxi-wifi-line:before { content: \"\\f1ec\"; }\r\n.ri-team-fill:before { content: \"\\f1ed\"; }\r\n.ri-team-line:before { content: \"\\f1ee\"; }\r\n.ri-telegram-fill:before { content: \"\\f1ef\"; }\r\n.ri-telegram-line:before { content: \"\\f1f0\"; }\r\n.ri-temp-cold-fill:before { content: \"\\f1f1\"; }\r\n.ri-temp-cold-line:before { content: \"\\f1f2\"; }\r\n.ri-temp-hot-fill:before { content: \"\\f1f3\"; }\r\n.ri-temp-hot-line:before { content: \"\\f1f4\"; }\r\n.ri-terminal-box-fill:before { content: \"\\f1f5\"; }\r\n.ri-terminal-box-line:before { content: \"\\f1f6\"; }\r\n.ri-terminal-fill:before { content: \"\\f1f7\"; }\r\n.ri-terminal-line:before { content: \"\\f1f8\"; }\r\n.ri-terminal-window-fill:before { content: \"\\f1f9\"; }\r\n.ri-terminal-window-line:before { content: \"\\f1fa\"; }\r\n.ri-test-tube-fill:before { content: \"\\f1fb\"; }\r\n.ri-test-tube-line:before { content: \"\\f1fc\"; }\r\n.ri-text-direction-l:before { content: \"\\f1fd\"; }\r\n.ri-text-direction-r:before { content: \"\\f1fe\"; }\r\n.ri-text-spacing:before { content: \"\\f1ff\"; }\r\n.ri-text-wrap:before { content: \"\\f200\"; }\r\n.ri-text:before { content: \"\\f201\"; }\r\n.ri-thermometer-fill:before { content: \"\\f202\"; }\r\n.ri-thermometer-line:before { content: \"\\f203\"; }\r\n.ri-thumb-down-fill:before { content: \"\\f204\"; }\r\n.ri-thumb-down-line:before { content: \"\\f205\"; }\r\n.ri-thumb-up-fill:before { content: \"\\f206\"; }\r\n.ri-thumb-up-line:before { content: \"\\f207\"; }\r\n.ri-thunderstorms-fill:before { content: \"\\f208\"; }\r\n.ri-thunderstorms-line:before { content: \"\\f209\"; }\r\n.ri-ticket-2-fill:before { content: \"\\f20a\"; }\r\n.ri-ticket-2-line:before { content: \"\\f20b\"; }\r\n.ri-ticket-fill:before { content: \"\\f20c\"; }\r\n.ri-ticket-line:before { content: \"\\f20d\"; }\r\n.ri-time-fill:before { content: \"\\f20e\"; }\r\n.ri-time-line:before { content: \"\\f20f\"; }\r\n.ri-timer-2-fill:before { content: \"\\f210\"; }\r\n.ri-timer-2-line:before { content: \"\\f211\"; }\r\n.ri-timer-fill:before { content: \"\\f212\"; }\r\n.ri-timer-flash-fill:before { content: \"\\f213\"; }\r\n.ri-timer-flash-line:before { content: \"\\f214\"; }\r\n.ri-timer-line:before { content: \"\\f215\"; }\r\n.ri-todo-fill:before { content: \"\\f216\"; }\r\n.ri-todo-line:before { content: \"\\f217\"; }\r\n.ri-toggle-fill:before { content: \"\\f218\"; }\r\n.ri-toggle-line:before { content: \"\\f219\"; }\r\n.ri-tools-fill:before { content: \"\\f21a\"; }\r\n.ri-tools-line:before { content: \"\\f21b\"; }\r\n.ri-tornado-fill:before { content: \"\\f21c\"; }\r\n.ri-tornado-line:before { content: \"\\f21d\"; }\r\n.ri-trademark-fill:before { content: \"\\f21e\"; }\r\n.ri-trademark-line:before { content: \"\\f21f\"; }\r\n.ri-traffic-light-fill:before { content: \"\\f220\"; }\r\n.ri-traffic-light-line:before { content: \"\\f221\"; }\r\n.ri-train-fill:before { content: \"\\f222\"; }\r\n.ri-train-line:before { content: \"\\f223\"; }\r\n.ri-train-wifi-fill:before { content: \"\\f224\"; }\r\n.ri-train-wifi-line:before { content: \"\\f225\"; }\r\n.ri-translate-2:before { content: \"\\f226\"; }\r\n.ri-translate:before { content: \"\\f227\"; }\r\n.ri-travesti-fill:before { content: \"\\f228\"; }\r\n.ri-travesti-line:before { content: \"\\f229\"; }\r\n.ri-treasure-map-fill:before { content: \"\\f22a\"; }\r\n.ri-treasure-map-line:before { content: \"\\f22b\"; }\r\n.ri-trello-fill:before { content: \"\\f22c\"; }\r\n.ri-trello-line:before { content: \"\\f22d\"; }\r\n.ri-trophy-fill:before { content: \"\\f22e\"; }\r\n.ri-trophy-line:before { content: \"\\f22f\"; }\r\n.ri-truck-fill:before { content: \"\\f230\"; }\r\n.ri-truck-line:before { content: \"\\f231\"; }\r\n.ri-tumblr-fill:before { content: \"\\f232\"; }\r\n.ri-tumblr-line:before { content: \"\\f233\"; }\r\n.ri-tv-2-fill:before { content: \"\\f234\"; }\r\n.ri-tv-2-line:before { content: \"\\f235\"; }\r\n.ri-tv-fill:before { content: \"\\f236\"; }\r\n.ri-tv-line:before { content: \"\\f237\"; }\r\n.ri-twitch-fill:before { content: \"\\f238\"; }\r\n.ri-twitch-line:before { content: \"\\f239\"; }\r\n.ri-twitter-fill:before { content: \"\\f23a\"; }\r\n.ri-twitter-line:before { content: \"\\f23b\"; }\r\n.ri-typhoon-fill:before { content: \"\\f23c\"; }\r\n.ri-typhoon-line:before { content: \"\\f23d\"; }\r\n.ri-u-disk-fill:before { content: \"\\f23e\"; }\r\n.ri-u-disk-line:before { content: \"\\f23f\"; }\r\n.ri-ubuntu-fill:before { content: \"\\f240\"; }\r\n.ri-ubuntu-line:before { content: \"\\f241\"; }\r\n.ri-umbrella-fill:before { content: \"\\f242\"; }\r\n.ri-umbrella-line:before { content: \"\\f243\"; }\r\n.ri-underline:before { content: \"\\f244\"; }\r\n.ri-uninstall-fill:before { content: \"\\f245\"; }\r\n.ri-uninstall-line:before { content: \"\\f246\"; }\r\n.ri-unsplash-fill:before { content: \"\\f247\"; }\r\n.ri-unsplash-line:before { content: \"\\f248\"; }\r\n.ri-upload-2-fill:before { content: \"\\f249\"; }\r\n.ri-upload-2-line:before { content: \"\\f24a\"; }\r\n.ri-upload-cloud-2-fill:before { content: \"\\f24b\"; }\r\n.ri-upload-cloud-2-line:before { content: \"\\f24c\"; }\r\n.ri-upload-cloud-fill:before { content: \"\\f24d\"; }\r\n.ri-upload-cloud-line:before { content: \"\\f24e\"; }\r\n.ri-upload-fill:before { content: \"\\f24f\"; }\r\n.ri-upload-line:before { content: \"\\f250\"; }\r\n.ri-usb-fill:before { content: \"\\f251\"; }\r\n.ri-usb-line:before { content: \"\\f252\"; }\r\n.ri-user-2-fill:before { content: \"\\f253\"; }\r\n.ri-user-2-line:before { content: \"\\f254\"; }\r\n.ri-user-3-fill:before { content: \"\\f255\"; }\r\n.ri-user-3-line:before { content: \"\\f256\"; }\r\n.ri-user-4-fill:before { content: \"\\f257\"; }\r\n.ri-user-4-line:before { content: \"\\f258\"; }\r\n.ri-user-5-fill:before { content: \"\\f259\"; }\r\n.ri-user-5-line:before { content: \"\\f25a\"; }\r\n.ri-user-6-fill:before { content: \"\\f25b\"; }\r\n.ri-user-6-line:before { content: \"\\f25c\"; }\r\n.ri-user-add-fill:before { content: \"\\f25d\"; }\r\n.ri-user-add-line:before { content: \"\\f25e\"; }\r\n.ri-user-fill:before { content: \"\\f25f\"; }\r\n.ri-user-follow-fill:before { content: \"\\f260\"; }\r\n.ri-user-follow-line:before { content: \"\\f261\"; }\r\n.ri-user-heart-fill:before { content: \"\\f262\"; }\r\n.ri-user-heart-line:before { content: \"\\f263\"; }\r\n.ri-user-line:before { content: \"\\f264\"; }\r\n.ri-user-location-fill:before { content: \"\\f265\"; }\r\n.ri-user-location-line:before { content: \"\\f266\"; }\r\n.ri-user-received-2-fill:before { content: \"\\f267\"; }\r\n.ri-user-received-2-line:before { content: \"\\f268\"; }\r\n.ri-user-received-fill:before { content: \"\\f269\"; }\r\n.ri-user-received-line:before { content: \"\\f26a\"; }\r\n.ri-user-search-fill:before { content: \"\\f26b\"; }\r\n.ri-user-search-line:before { content: \"\\f26c\"; }\r\n.ri-user-settings-fill:before { content: \"\\f26d\"; }\r\n.ri-user-settings-line:before { content: \"\\f26e\"; }\r\n.ri-user-shared-2-fill:before { content: \"\\f26f\"; }\r\n.ri-user-shared-2-line:before { content: \"\\f270\"; }\r\n.ri-user-shared-fill:before { content: \"\\f271\"; }\r\n.ri-user-shared-line:before { content: \"\\f272\"; }\r\n.ri-user-smile-fill:before { content: \"\\f273\"; }\r\n.ri-user-smile-line:before { content: \"\\f274\"; }\r\n.ri-user-star-fill:before { content: \"\\f275\"; }\r\n.ri-user-star-line:before { content: \"\\f276\"; }\r\n.ri-user-unfollow-fill:before { content: \"\\f277\"; }\r\n.ri-user-unfollow-line:before { content: \"\\f278\"; }\r\n.ri-user-voice-fill:before { content: \"\\f279\"; }\r\n.ri-user-voice-line:before { content: \"\\f27a\"; }\r\n.ri-video-add-fill:before { content: \"\\f27b\"; }\r\n.ri-video-add-line:before { content: \"\\f27c\"; }\r\n.ri-video-chat-fill:before { content: \"\\f27d\"; }\r\n.ri-video-chat-line:before { content: \"\\f27e\"; }\r\n.ri-video-download-fill:before { content: \"\\f27f\"; }\r\n.ri-video-download-line:before { content: \"\\f280\"; }\r\n.ri-video-fill:before { content: \"\\f281\"; }\r\n.ri-video-line:before { content: \"\\f282\"; }\r\n.ri-video-upload-fill:before { content: \"\\f283\"; }\r\n.ri-video-upload-line:before { content: \"\\f284\"; }\r\n.ri-vidicon-2-fill:before { content: \"\\f285\"; }\r\n.ri-vidicon-2-line:before { content: \"\\f286\"; }\r\n.ri-vidicon-fill:before { content: \"\\f287\"; }\r\n.ri-vidicon-line:before { content: \"\\f288\"; }\r\n.ri-vimeo-fill:before { content: \"\\f289\"; }\r\n.ri-vimeo-line:before { content: \"\\f28a\"; }\r\n.ri-vip-crown-2-fill:before { content: \"\\f28b\"; }\r\n.ri-vip-crown-2-line:before { content: \"\\f28c\"; }\r\n.ri-vip-crown-fill:before { content: \"\\f28d\"; }\r\n.ri-vip-crown-line:before { content: \"\\f28e\"; }\r\n.ri-vip-diamond-fill:before { content: \"\\f28f\"; }\r\n.ri-vip-diamond-line:before { content: \"\\f290\"; }\r\n.ri-vip-fill:before { content: \"\\f291\"; }\r\n.ri-vip-line:before { content: \"\\f292\"; }\r\n.ri-virus-fill:before { content: \"\\f293\"; }\r\n.ri-virus-line:before { content: \"\\f294\"; }\r\n.ri-visa-fill:before { content: \"\\f295\"; }\r\n.ri-visa-line:before { content: \"\\f296\"; }\r\n.ri-voice-recognition-fill:before { content: \"\\f297\"; }\r\n.ri-voice-recognition-line:before { content: \"\\f298\"; }\r\n.ri-voiceprint-fill:before { content: \"\\f299\"; }\r\n.ri-voiceprint-line:before { content: \"\\f29a\"; }\r\n.ri-volume-down-fill:before { content: \"\\f29b\"; }\r\n.ri-volume-down-line:before { content: \"\\f29c\"; }\r\n.ri-volume-mute-fill:before { content: \"\\f29d\"; }\r\n.ri-volume-mute-line:before { content: \"\\f29e\"; }\r\n.ri-volume-off-vibrate-fill:before { content: \"\\f29f\"; }\r\n.ri-volume-off-vibrate-line:before { content: \"\\f2a0\"; }\r\n.ri-volume-up-fill:before { content: \"\\f2a1\"; }\r\n.ri-volume-up-line:before { content: \"\\f2a2\"; }\r\n.ri-volume-vibrate-fill:before { content: \"\\f2a3\"; }\r\n.ri-volume-vibrate-line:before { content: \"\\f2a4\"; }\r\n.ri-vuejs-fill:before { content: \"\\f2a5\"; }\r\n.ri-vuejs-line:before { content: \"\\f2a6\"; }\r\n.ri-walk-fill:before { content: \"\\f2a7\"; }\r\n.ri-walk-line:before { content: \"\\f2a8\"; }\r\n.ri-wallet-2-fill:before { content: \"\\f2a9\"; }\r\n.ri-wallet-2-line:before { content: \"\\f2aa\"; }\r\n.ri-wallet-3-fill:before { content: \"\\f2ab\"; }\r\n.ri-wallet-3-line:before { content: \"\\f2ac\"; }\r\n.ri-wallet-fill:before { content: \"\\f2ad\"; }\r\n.ri-wallet-line:before { content: \"\\f2ae\"; }\r\n.ri-water-flash-fill:before { content: \"\\f2af\"; }\r\n.ri-water-flash-line:before { content: \"\\f2b0\"; }\r\n.ri-webcam-fill:before { content: \"\\f2b1\"; }\r\n.ri-webcam-line:before { content: \"\\f2b2\"; }\r\n.ri-wechat-2-fill:before { content: \"\\f2b3\"; }\r\n.ri-wechat-2-line:before { content: \"\\f2b4\"; }\r\n.ri-wechat-fill:before { content: \"\\f2b5\"; }\r\n.ri-wechat-line:before { content: \"\\f2b6\"; }\r\n.ri-wechat-pay-fill:before { content: \"\\f2b7\"; }\r\n.ri-wechat-pay-line:before { content: \"\\f2b8\"; }\r\n.ri-weibo-fill:before { content: \"\\f2b9\"; }\r\n.ri-weibo-line:before { content: \"\\f2ba\"; }\r\n.ri-whatsapp-fill:before { content: \"\\f2bb\"; }\r\n.ri-whatsapp-line:before { content: \"\\f2bc\"; }\r\n.ri-wheelchair-fill:before { content: \"\\f2bd\"; }\r\n.ri-wheelchair-line:before { content: \"\\f2be\"; }\r\n.ri-wifi-fill:before { content: \"\\f2bf\"; }\r\n.ri-wifi-line:before { content: \"\\f2c0\"; }\r\n.ri-wifi-off-fill:before { content: \"\\f2c1\"; }\r\n.ri-wifi-off-line:before { content: \"\\f2c2\"; }\r\n.ri-window-2-fill:before { content: \"\\f2c3\"; }\r\n.ri-window-2-line:before { content: \"\\f2c4\"; }\r\n.ri-window-fill:before { content: \"\\f2c5\"; }\r\n.ri-window-line:before { content: \"\\f2c6\"; }\r\n.ri-windows-fill:before { content: \"\\f2c7\"; }\r\n.ri-windows-line:before { content: \"\\f2c8\"; }\r\n.ri-windy-fill:before { content: \"\\f2c9\"; }\r\n.ri-windy-line:before { content: \"\\f2ca\"; }\r\n.ri-wireless-charging-fill:before { content: \"\\f2cb\"; }\r\n.ri-wireless-charging-line:before { content: \"\\f2cc\"; }\r\n.ri-women-fill:before { content: \"\\f2cd\"; }\r\n.ri-women-line:before { content: \"\\f2ce\"; }\r\n.ri-wubi-input:before { content: \"\\f2cf\"; }\r\n.ri-xbox-fill:before { content: \"\\f2d0\"; }\r\n.ri-xbox-line:before { content: \"\\f2d1\"; }\r\n.ri-xing-fill:before { content: \"\\f2d2\"; }\r\n.ri-xing-line:before { content: \"\\f2d3\"; }\r\n.ri-youtube-fill:before { content: \"\\f2d4\"; }\r\n.ri-youtube-line:before { content: \"\\f2d5\"; }\r\n.ri-zcool-fill:before { content: \"\\f2d6\"; }\r\n.ri-zcool-line:before { content: \"\\f2d7\"; }\r\n.ri-zhihu-fill:before { content: \"\\f2d8\"; }\r\n.ri-zhihu-line:before { content: \"\\f2d9\"; }\r\n.ri-zoom-in-fill:before { content: \"\\f2da\"; }\r\n.ri-zoom-in-line:before { content: \"\\f2db\"; }\r\n.ri-zoom-out-fill:before { content: \"\\f2dc\"; }\r\n.ri-zoom-out-line:before { content: \"\\f2dd\"; }\r\n.ri-zzz-fill:before { content: \"\\f2de\"; }\r\n.ri-zzz-line:before { content: \"\\f2df\"; }\r\n\r\n","/*\r\nTemplate Name: Velzon - Admin & Dashboard Template\r\nAuthor: Themesbrand\r\nVersion: 1.0.0\r\nWebsite: https://Themesbrand.com/\r\nContact: Themesbrand@gmail.com\r\nFile: Custom Bootstrap Css File\r\n*/\r\n\r\n\r\n//Core files\r\n@import \"./node_modules/bootstrap/scss/functions\";\r\n@import \"./node_modules/bootstrap/scss/variables\";\r\n@import \"variables\";\r\n@import \"./node_modules/bootstrap/scss/bootstrap\";\r\n\r\n","@mixin bsBanner($file) {\n  /*!\n   * Bootstrap #{$file} v5.2.3 (https://getbootstrap.com/)\n   * Copyright 2011-2022 The Bootstrap Authors\n   * Copyright 2011-2022 Twitter, Inc.\n   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)\n   */\n}\n\n",":root {\n  // Note: Custom variable values only support SassScript inside `#{}`.\n\n  // Colors\n  //\n  // Generate palettes for full colors, grays, and theme colors.\n\n  @each $color, $value in $colors {\n    --#{$prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $grays {\n    --#{$prefix}gray-#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors {\n    --#{$prefix}#{$color}: #{$value};\n  }\n\n  @each $color, $value in $theme-colors-rgb {\n    --#{$prefix}#{$color}-rgb: #{$value};\n  }\n\n  --#{$prefix}white-rgb: #{to-rgb($white)};\n  --#{$prefix}black-rgb: #{to-rgb($black)};\n  --#{$prefix}body-color-rgb: #{to-rgb($body-color)};\n  --#{$prefix}body-bg-rgb: #{to-rgb($body-bg)};\n\n  // Fonts\n\n  // Note: Use `inspect` for lists so that quoted items keep the quotes.\n  // See https://github.com/sass/sass/issues/2383#issuecomment-336349172\n  --#{$prefix}font-sans-serif: #{inspect($font-family-sans-serif)};\n  --#{$prefix}font-monospace: #{inspect($font-family-monospace)};\n  --#{$prefix}gradient: #{$gradient};\n\n  // Root and body\n  // scss-docs-start root-body-variables\n  @if $font-size-root != null {\n    --#{$prefix}root-font-size: #{$font-size-root};\n  }\n  --#{$prefix}body-font-family: #{$font-family-base};\n  @include rfs($font-size-base, --#{$prefix}body-font-size);\n  --#{$prefix}body-font-weight: #{$font-weight-base};\n  --#{$prefix}body-line-height: #{$line-height-base};\n  --#{$prefix}body-color: #{$body-color};\n  @if $body-text-align != null {\n    --#{$prefix}body-text-align: #{$body-text-align};\n  }\n  --#{$prefix}body-bg: #{$body-bg};\n  // scss-docs-end root-body-variables\n\n  // scss-docs-start root-border-var\n  --#{$prefix}border-width: #{$border-width};\n  --#{$prefix}border-style: #{$border-style};\n  --#{$prefix}border-color: #{$border-color};\n  --#{$prefix}border-color-translucent: #{$border-color-translucent};\n\n  --#{$prefix}border-radius: #{$border-radius};\n  --#{$prefix}border-radius-sm: #{$border-radius-sm};\n  --#{$prefix}border-radius-lg: #{$border-radius-lg};\n  --#{$prefix}border-radius-xl: #{$border-radius-xl};\n  --#{$prefix}border-radius-2xl: #{$border-radius-2xl};\n  --#{$prefix}border-radius-pill: #{$border-radius-pill};\n  // scss-docs-end root-border-var\n\n  --#{$prefix}link-color: #{$link-color};\n  --#{$prefix}link-hover-color: #{$link-hover-color};\n\n  --#{$prefix}code-color: #{$code-color};\n\n  --#{$prefix}highlight-bg: #{$mark-bg};\n}\n","// stylelint-disable property-blacklist, scss/dollar-variable-default\n\n// SCSS RFS mixin\n//\n// Automated responsive values for font sizes, paddings, margins and much more\n//\n// Licensed under MIT (https://github.com/twbs/rfs/blob/main/LICENSE)\n\n// Configuration\n\n// Base value\n$rfs-base-value: 1.25rem !default;\n$rfs-unit: rem !default;\n\n@if $rfs-unit != rem and $rfs-unit != px {\n  @error \"`#{$rfs-unit}` is not a valid unit for $rfs-unit. Use `px` or `rem`.\";\n}\n\n// Breakpoint at where values start decreasing if screen width is smaller\n$rfs-breakpoint: 1200px !default;\n$rfs-breakpoint-unit: px !default;\n\n@if $rfs-breakpoint-unit != px and $rfs-breakpoint-unit != em and $rfs-breakpoint-unit != rem {\n  @error \"`#{$rfs-breakpoint-unit}` is not a valid unit for $rfs-breakpoint-unit. Use `px`, `em` or `rem`.\";\n}\n\n// Resize values based on screen height and width\n$rfs-two-dimensional: false !default;\n\n// Factor of decrease\n$rfs-factor: 10 !default;\n\n@if type-of($rfs-factor) != number or $rfs-factor <= 1 {\n  @error \"`#{$rfs-factor}` is not a valid  $rfs-factor, it must be greater than 1.\";\n}\n\n// Mode. Possibilities: \"min-media-query\", \"max-media-query\"\n$rfs-mode: min-media-query !default;\n\n// Generate enable or disable classes. Possibilities: false, \"enable\" or \"disable\"\n$rfs-class: false !default;\n\n// 1 rem = $rfs-rem-value px\n$rfs-rem-value: 16 !default;\n\n// Safari iframe resize bug: https://github.com/twbs/rfs/issues/14\n$rfs-safari-iframe-resize-bug-fix: false !default;\n\n// Disable RFS by setting $enable-rfs to false\n$enable-rfs: true !default;\n\n// Cache $rfs-base-value unit\n$rfs-base-value-unit: unit($rfs-base-value);\n\n@function divide($dividend, $divisor, $precision: 10) {\n  $sign: if($dividend > 0 and $divisor > 0 or $dividend < 0 and $divisor < 0, 1, -1);\n  $dividend: abs($dividend);\n  $divisor: abs($divisor);\n  @if $dividend == 0 {\n    @return 0;\n  }\n  @if $divisor == 0 {\n    @error \"Cannot divide by 0\";\n  }\n  $remainder: $dividend;\n  $result: 0;\n  $factor: 10;\n  @while ($remainder > 0 and $precision >= 0) {\n    $quotient: 0;\n    @while ($remainder >= $divisor) {\n      $remainder: $remainder - $divisor;\n      $quotient: $quotient + 1;\n    }\n    $result: $result * 10 + $quotient;\n    $factor: $factor * .1;\n    $remainder: $remainder * 10;\n    $precision: $precision - 1;\n    @if ($precision < 0 and $remainder >= $divisor * 5) {\n      $result: $result + 1;\n    }\n  }\n  $result: $result * $factor * $sign;\n  $dividend-unit: unit($dividend);\n  $divisor-unit: unit($divisor);\n  $unit-map: (\n    \"px\": 1px,\n    \"rem\": 1rem,\n    \"em\": 1em,\n    \"%\": 1%\n  );\n  @if ($dividend-unit != $divisor-unit and map-has-key($unit-map, $dividend-unit)) {\n    $result: $result * map-get($unit-map, $dividend-unit);\n  }\n  @return $result;\n}\n\n// Remove px-unit from $rfs-base-value for calculations\n@if $rfs-base-value-unit == px {\n  $rfs-base-value: divide($rfs-base-value, $rfs-base-value * 0 + 1);\n}\n@else if $rfs-base-value-unit == rem {\n  $rfs-base-value: divide($rfs-base-value, divide($rfs-base-value * 0 + 1, $rfs-rem-value));\n}\n\n// Cache $rfs-breakpoint unit to prevent multiple calls\n$rfs-breakpoint-unit-cache: unit($rfs-breakpoint);\n\n// Remove unit from $rfs-breakpoint for calculations\n@if $rfs-breakpoint-unit-cache == px {\n  $rfs-breakpoint: divide($rfs-breakpoint, $rfs-breakpoint * 0 + 1);\n}\n@else if $rfs-breakpoint-unit-cache == rem or $rfs-breakpoint-unit-cache == \"em\" {\n  $rfs-breakpoint: divide($rfs-breakpoint, divide($rfs-breakpoint * 0 + 1, $rfs-rem-value));\n}\n\n// Calculate the media query value\n$rfs-mq-value: if($rfs-breakpoint-unit == px, #{$rfs-breakpoint}px, #{divide($rfs-breakpoint, $rfs-rem-value)}#{$rfs-breakpoint-unit});\n$rfs-mq-property-width: if($rfs-mode == max-media-query, max-width, min-width);\n$rfs-mq-property-height: if($rfs-mode == max-media-query, max-height, min-height);\n\n// Internal mixin used to determine which media query needs to be used\n@mixin _rfs-media-query {\n  @if $rfs-two-dimensional {\n    @if $rfs-mode == max-media-query {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}), (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n    @else {\n      @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) and (#{$rfs-mq-property-height}: #{$rfs-mq-value}) {\n        @content;\n      }\n    }\n  }\n  @else {\n    @media (#{$rfs-mq-property-width}: #{$rfs-mq-value}) {\n      @content;\n    }\n  }\n}\n\n// Internal mixin that adds disable classes to the selector if needed.\n@mixin _rfs-rule {\n  @if $rfs-class == disable and $rfs-mode == max-media-query {\n    // Adding an extra class increases specificity, which prevents the media query to override the property\n    &,\n    .disable-rfs &,\n    &.disable-rfs {\n      @content;\n    }\n  }\n  @else if $rfs-class == enable and $rfs-mode == min-media-query {\n    .enable-rfs &,\n    &.enable-rfs {\n      @content;\n    }\n  }\n  @else {\n    @content;\n  }\n}\n\n// Internal mixin that adds enable classes to the selector if needed.\n@mixin _rfs-media-query-rule {\n\n  @if $rfs-class == enable {\n    @if $rfs-mode == min-media-query {\n      @content;\n    }\n\n    @include _rfs-media-query {\n      .enable-rfs &,\n      &.enable-rfs {\n        @content;\n      }\n    }\n  }\n  @else {\n    @if $rfs-class == disable and $rfs-mode == min-media-query {\n      .disable-rfs &,\n      &.disable-rfs {\n        @content;\n      }\n    }\n    @include _rfs-media-query {\n      @content;\n    }\n  }\n}\n\n// Helper function to get the formatted non-responsive value\n@function rfs-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: '';\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + ' 0';\n    }\n    @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      @if $unit == px {\n        // Convert to rem if needed\n        $val: $val + ' ' + if($rfs-unit == rem, #{divide($value, $value * 0 + $rfs-rem-value)}rem, $value);\n      }\n      @else if $unit == rem {\n        // Convert to px if needed\n        $val: $val + ' ' + if($rfs-unit == px, #{divide($value, $value * 0 + 1) * $rfs-rem-value}px, $value);\n      }\n      @else {\n        // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n        $val: $val + ' ' + $value;\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// Helper function to get the responsive value calculated by RFS\n@function rfs-fluid-value($values) {\n  // Convert to list\n  $values: if(type-of($values) != list, ($values,), $values);\n\n  $val: '';\n\n  // Loop over each value and calculate value\n  @each $value in $values {\n    @if $value == 0 {\n      $val: $val + ' 0';\n    }\n\n    @else {\n      // Cache $value unit\n      $unit: if(type-of($value) == \"number\", unit($value), false);\n\n      // If $value isn't a number (like inherit) or $value has a unit (not px or rem, like 1.5em) or $ is 0, just print the value\n      @if not $unit or $unit != px and $unit != rem {\n        $val: $val + ' ' + $value;\n      }\n\n      @else {\n        // Remove unit from $value for calculations\n        $value: divide($value, $value * 0 + if($unit == px, 1, divide(1, $rfs-rem-value)));\n\n        // Only add the media query if the value is greater than the minimum value\n        @if abs($value) <= $rfs-base-value or not $enable-rfs {\n          $val: $val + ' ' +  if($rfs-unit == rem, #{divide($value, $rfs-rem-value)}rem, #{$value}px);\n        }\n        @else {\n          // Calculate the minimum value\n          $value-min: $rfs-base-value + divide(abs($value) - $rfs-base-value, $rfs-factor);\n\n          // Calculate difference between $value and the minimum value\n          $value-diff: abs($value) - $value-min;\n\n          // Base value formatting\n          $min-width: if($rfs-unit == rem, #{divide($value-min, $rfs-rem-value)}rem, #{$value-min}px);\n\n          // Use negative value if needed\n          $min-width: if($value < 0, -$min-width, $min-width);\n\n          // Use `vmin` if two-dimensional is enabled\n          $variable-unit: if($rfs-two-dimensional, vmin, vw);\n\n          // Calculate the variable width between 0 and $rfs-breakpoint\n          $variable-width: #{divide($value-diff * 100, $rfs-breakpoint)}#{$variable-unit};\n\n          // Return the calculated value\n          $val: $val + ' calc(' + $min-width + if($value < 0, ' - ', ' + ') + $variable-width + ')';\n        }\n      }\n    }\n  }\n\n  // Remove first space\n  @return unquote(str-slice($val, 2));\n}\n\n// RFS mixin\n@mixin rfs($values, $property: font-size) {\n  @if $values != null {\n    $val: rfs-value($values);\n    $fluidVal: rfs-fluid-value($values);\n\n    // Do not print the media query if responsive & non-responsive values are the same\n    @if $val == $fluidVal {\n      #{$property}: $val;\n    }\n    @else {\n      @include _rfs-rule {\n        #{$property}: if($rfs-mode == max-media-query, $val, $fluidVal);\n\n        // Include safari iframe resize fix if needed\n        min-width: if($rfs-safari-iframe-resize-bug-fix, (0 * 1vw), null);\n      }\n\n      @include _rfs-media-query-rule {\n        #{$property}: if($rfs-mode == max-media-query, $fluidVal, $val);\n      }\n    }\n  }\n}\n\n// Shorthand helper mixins\n@mixin font-size($value) {\n  @include rfs($value);\n}\n\n@mixin padding($value) {\n  @include rfs($value, padding);\n}\n\n@mixin padding-top($value) {\n  @include rfs($value, padding-top);\n}\n\n@mixin padding-right($value) {\n  @include rfs($value, padding-right);\n}\n\n@mixin padding-bottom($value) {\n  @include rfs($value, padding-bottom);\n}\n\n@mixin padding-left($value) {\n  @include rfs($value, padding-left);\n}\n\n@mixin margin($value) {\n  @include rfs($value, margin);\n}\n\n@mixin margin-top($value) {\n  @include rfs($value, margin-top);\n}\n\n@mixin margin-right($value) {\n  @include rfs($value, margin-right);\n}\n\n@mixin margin-bottom($value) {\n  @include rfs($value, margin-bottom);\n}\n\n@mixin margin-left($value) {\n  @include rfs($value, margin-left);\n}\n","// stylelint-disable declaration-no-important, selector-no-qualifying-type, property-no-vendor-prefix\n\n\n// Reboot\n//\n// Normalization of HTML elements, manually forked from Normalize.css to remove\n// styles targeting irrelevant browsers while applying new styles.\n//\n// Normalize is licensed MIT. https://github.com/necolas/normalize.css\n\n\n// Document\n//\n// Change from `box-sizing: content-box` so that `width` is not affected by `padding` or `border`.\n\n*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\n\n// Root\n//\n// Ability to the value of the root font sizes, affecting the value of `rem`.\n// null by default, thus nothing is generated.\n\n:root {\n  @if $font-size-root != null {\n    @include font-size(var(--#{$prefix}root-font-size));\n  }\n\n  @if $enable-smooth-scroll {\n    @media (prefers-reduced-motion: no-preference) {\n      scroll-behavior: smooth;\n    }\n  }\n}\n\n\n// Body\n//\n// 1. Remove the margin in all browsers.\n// 2. As a best practice, apply a default `background-color`.\n// 3. Prevent adjustments of font size after orientation changes in iOS.\n// 4. Change the default tap highlight to be completely transparent in iOS.\n\n// scss-docs-start reboot-body-rules\nbody {\n  margin: 0; // 1\n  font-family: var(--#{$prefix}body-font-family);\n  @include font-size(var(--#{$prefix}body-font-size));\n  font-weight: var(--#{$prefix}body-font-weight);\n  line-height: var(--#{$prefix}body-line-height);\n  color: var(--#{$prefix}body-color);\n  text-align: var(--#{$prefix}body-text-align);\n  background-color: var(--#{$prefix}body-bg); // 2\n  -webkit-text-size-adjust: 100%; // 3\n  -webkit-tap-highlight-color: rgba($black, 0); // 4\n}\n// scss-docs-end reboot-body-rules\n\n\n// Content grouping\n//\n// 1. Reset Firefox's gray color\n\nhr {\n  margin: $hr-margin-y 0;\n  color: $hr-color; // 1\n  border: 0;\n  border-top: $hr-border-width solid $hr-border-color;\n  opacity: $hr-opacity;\n}\n\n\n// Typography\n//\n// 1. Remove top margins from headings\n//    By default, `<h1>`-`<h6>` all receive top and bottom margins. We nuke the top\n//    margin for easier control within type scales as it avoids margin collapsing.\n\n%heading {\n  margin-top: 0; // 1\n  margin-bottom: $headings-margin-bottom;\n  font-family: $headings-font-family;\n  font-style: $headings-font-style;\n  font-weight: $headings-font-weight;\n  line-height: $headings-line-height;\n  color: $headings-color;\n}\n\nh1 {\n  @extend %heading;\n  @include font-size($h1-font-size);\n}\n\nh2 {\n  @extend %heading;\n  @include font-size($h2-font-size);\n}\n\nh3 {\n  @extend %heading;\n  @include font-size($h3-font-size);\n}\n\nh4 {\n  @extend %heading;\n  @include font-size($h4-font-size);\n}\n\nh5 {\n  @extend %heading;\n  @include font-size($h5-font-size);\n}\n\nh6 {\n  @extend %heading;\n  @include font-size($h6-font-size);\n}\n\n\n// Reset margins on paragraphs\n//\n// Similarly, the top margin on `<p>`s get reset. However, we also reset the\n// bottom margin to use `rem` units instead of `em`.\n\np {\n  margin-top: 0;\n  margin-bottom: $paragraph-margin-bottom;\n}\n\n\n// Abbreviations\n//\n// 1. Add the correct text decoration in Chrome, Edge, Opera, and Safari.\n// 2. Add explicit cursor to indicate changed behavior.\n// 3. Prevent the text-decoration to be skipped.\n\nabbr[title] {\n  text-decoration: underline dotted; // 1\n  cursor: help; // 2\n  text-decoration-skip-ink: none; // 3\n}\n\n\n// Address\n\naddress {\n  margin-bottom: 1rem;\n  font-style: normal;\n  line-height: inherit;\n}\n\n\n// Lists\n\nol,\nul {\n  padding-left: 2rem;\n}\n\nol,\nul,\ndl {\n  margin-top: 0;\n  margin-bottom: 1rem;\n}\n\nol ol,\nul ul,\nol ul,\nul ol {\n  margin-bottom: 0;\n}\n\ndt {\n  font-weight: $dt-font-weight;\n}\n\n// 1. Undo browser default\n\ndd {\n  margin-bottom: .5rem;\n  margin-left: 0; // 1\n}\n\n\n// Blockquote\n\nblockquote {\n  margin: 0 0 1rem;\n}\n\n\n// Strong\n//\n// Add the correct font weight in Chrome, Edge, and Safari\n\nb,\nstrong {\n  font-weight: $font-weight-bolder;\n}\n\n\n// Small\n//\n// Add the correct font size in all browsers\n\nsmall {\n  @include font-size($small-font-size);\n}\n\n\n// Mark\n\nmark {\n  padding: $mark-padding;\n  background-color: var(--#{$prefix}highlight-bg);\n}\n\n\n// Sub and Sup\n//\n// Prevent `sub` and `sup` elements from affecting the line height in\n// all browsers.\n\nsub,\nsup {\n  position: relative;\n  @include font-size($sub-sup-font-size);\n  line-height: 0;\n  vertical-align: baseline;\n}\n\nsub { bottom: -.25em; }\nsup { top: -.5em; }\n\n\n// Links\n\na {\n  color: var(--#{$prefix}link-color);\n  text-decoration: $link-decoration;\n\n  &:hover {\n    color: var(--#{$prefix}link-hover-color);\n    text-decoration: $link-hover-decoration;\n  }\n}\n\n// And undo these styles for placeholder links/named anchors (without href).\n// It would be more straightforward to just use a[href] in previous block, but that\n// causes specificity issues in many other styles that are too complex to fix.\n// See https://github.com/twbs/bootstrap/issues/19402\n\na:not([href]):not([class]) {\n  &,\n  &:hover {\n    color: inherit;\n    text-decoration: none;\n  }\n}\n\n\n// Code\n\npre,\ncode,\nkbd,\nsamp {\n  font-family: $font-family-code;\n  @include font-size(1em); // Correct the odd `em` font sizing in all browsers.\n}\n\n// 1. Remove browser default top margin\n// 2. Reset browser default of `1em` to use `rem`s\n// 3. Don't allow content to break outside\n\npre {\n  display: block;\n  margin-top: 0; // 1\n  margin-bottom: 1rem; // 2\n  overflow: auto; // 3\n  @include font-size($code-font-size);\n  color: $pre-color;\n\n  // Account for some code outputs that place code tags in pre tags\n  code {\n    @include font-size(inherit);\n    color: inherit;\n    word-break: normal;\n  }\n}\n\ncode {\n  @include font-size($code-font-size);\n  color: var(--#{$prefix}code-color);\n  word-wrap: break-word;\n\n  // Streamline the style when inside anchors to avoid broken underline and more\n  a > & {\n    color: inherit;\n  }\n}\n\nkbd {\n  padding: $kbd-padding-y $kbd-padding-x;\n  @include font-size($kbd-font-size);\n  color: $kbd-color;\n  background-color: $kbd-bg;\n  @include border-radius($border-radius-sm);\n\n  kbd {\n    padding: 0;\n    @include font-size(1em);\n    font-weight: $nested-kbd-font-weight;\n  }\n}\n\n\n// Figures\n//\n// Apply a consistent margin strategy (matches our type styles).\n\nfigure {\n  margin: 0 0 1rem;\n}\n\n\n// Images and content\n\nimg,\nsvg {\n  vertical-align: middle;\n}\n\n\n// Tables\n//\n// Prevent double borders\n\ntable {\n  caption-side: bottom;\n  border-collapse: collapse;\n}\n\ncaption {\n  padding-top: $table-cell-padding-y;\n  padding-bottom: $table-cell-padding-y;\n  color: $table-caption-color;\n  text-align: left;\n}\n\n// 1. Removes font-weight bold by inheriting\n// 2. Matches default `<td>` alignment by inheriting `text-align`.\n// 3. Fix alignment for Safari\n\nth {\n  font-weight: $table-th-font-weight; // 1\n  text-align: inherit; // 2\n  text-align: -webkit-match-parent; // 3\n}\n\nthead,\ntbody,\ntfoot,\ntr,\ntd,\nth {\n  border-color: inherit;\n  border-style: solid;\n  border-width: 0;\n}\n\n\n// Forms\n//\n// 1. Allow labels to use `margin` for spacing.\n\nlabel {\n  display: inline-block; // 1\n}\n\n// Remove the default `border-radius` that macOS Chrome adds.\n// See https://github.com/twbs/bootstrap/issues/24093\n\nbutton {\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 0;\n}\n\n// Explicitly remove focus outline in Chromium when it shouldn't be\n// visible (e.g. as result of mouse click or touch tap). It already\n// should be doing this automatically, but seems to currently be\n// confused and applies its very visible two-tone outline anyway.\n\nbutton:focus:not(:focus-visible) {\n  outline: 0;\n}\n\n// 1. Remove the margin in Firefox and Safari\n\ninput,\nbutton,\nselect,\noptgroup,\ntextarea {\n  margin: 0; // 1\n  font-family: inherit;\n  @include font-size(inherit);\n  line-height: inherit;\n}\n\n// Remove the inheritance of text transform in Firefox\nbutton,\nselect {\n  text-transform: none;\n}\n// Set the cursor for non-`<button>` buttons\n//\n// Details at https://github.com/twbs/bootstrap/pull/30562\n[role=\"button\"] {\n  cursor: pointer;\n}\n\nselect {\n  // Remove the inheritance of word-wrap in Safari.\n  // See https://github.com/twbs/bootstrap/issues/24990\n  word-wrap: normal;\n\n  // Undo the opacity change from Chrome\n  &:disabled {\n    opacity: 1;\n  }\n}\n\n// Remove the dropdown arrow only from text type inputs built with datalists in Chrome.\n// See https://stackoverflow.com/a/54997118\n\n[list]:not([type=\"date\"]):not([type=\"datetime-local\"]):not([type=\"month\"]):not([type=\"week\"]):not([type=\"time\"])::-webkit-calendar-picker-indicator {\n  display: none !important;\n}\n\n// 1. Prevent a WebKit bug where (2) destroys native `audio` and `video`\n//    controls in Android 4.\n// 2. Correct the inability to style clickable types in iOS and Safari.\n// 3. Opinionated: add \"hand\" cursor to non-disabled button elements.\n\nbutton,\n[type=\"button\"], // 1\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button; // 2\n\n  @if $enable-button-pointers {\n    &:not(:disabled) {\n      cursor: pointer; // 3\n    }\n  }\n}\n\n// Remove inner border and padding from Firefox, but don't restore the outline like Normalize.\n\n::-moz-focus-inner {\n  padding: 0;\n  border-style: none;\n}\n\n// 1. Textareas should really only resize vertically so they don't break their (horizontal) containers.\n\ntextarea {\n  resize: vertical; // 1\n}\n\n// 1. Browsers set a default `min-width: min-content;` on fieldsets,\n//    unlike e.g. `<div>`s, which have `min-width: 0;` by default.\n//    So we reset that to ensure fieldsets behave more like a standard block element.\n//    See https://github.com/twbs/bootstrap/issues/12359\n//    and https://html.spec.whatwg.org/multipage/#the-fieldset-and-legend-elements\n// 2. Reset the default outline behavior of fieldsets so they don't affect page layout.\n\nfieldset {\n  min-width: 0; // 1\n  padding: 0; // 2\n  margin: 0; // 2\n  border: 0; // 2\n}\n\n// 1. By using `float: left`, the legend will behave like a block element.\n//    This way the border of a fieldset wraps around the legend if present.\n// 2. Fix wrapping bug.\n//    See https://github.com/twbs/bootstrap/issues/29712\n\nlegend {\n  float: left; // 1\n  width: 100%;\n  padding: 0;\n  margin-bottom: $legend-margin-bottom;\n  @include font-size($legend-font-size);\n  font-weight: $legend-font-weight;\n  line-height: inherit;\n\n  + * {\n    clear: left; // 2\n  }\n}\n\n// Fix height of inputs with a type of datetime-local, date, month, week, or time\n// See https://github.com/twbs/bootstrap/issues/18842\n\n::-webkit-datetime-edit-fields-wrapper,\n::-webkit-datetime-edit-text,\n::-webkit-datetime-edit-minute,\n::-webkit-datetime-edit-hour-field,\n::-webkit-datetime-edit-day-field,\n::-webkit-datetime-edit-month-field,\n::-webkit-datetime-edit-year-field {\n  padding: 0;\n}\n\n::-webkit-inner-spin-button {\n  height: auto;\n}\n\n// 1. Correct the outline style in Safari.\n// 2. This overrides the extra rounded corners on search inputs in iOS so that our\n//    `.form-control` class can properly style them. Note that this cannot simply\n//    be added to `.form-control` as it's not specific enough. For details, see\n//    https://github.com/twbs/bootstrap/issues/11586.\n\n[type=\"search\"] {\n  outline-offset: -2px; // 1\n  -webkit-appearance: textfield; // 2\n}\n\n// 1. A few input types should stay LTR\n// See https://rtlstyling.com/posts/rtl-styling#form-inputs\n// 2. RTL only output\n// See https://rtlcss.com/learn/usage-guide/control-directives/#raw\n\n/* rtl:raw:\n[type=\"tel\"],\n[type=\"url\"],\n[type=\"email\"],\n[type=\"number\"] {\n  direction: ltr;\n}\n*/\n\n// Remove the inner padding in Chrome and Safari on macOS.\n\n::-webkit-search-decoration {\n  -webkit-appearance: none;\n}\n\n// Remove padding around color pickers in webkit browsers\n\n::-webkit-color-swatch-wrapper {\n  padding: 0;\n}\n\n\n// 1. Inherit font family and line height for file input buttons\n// 2. Correct the inability to style clickable types in iOS and Safari.\n\n::file-selector-button {\n  font: inherit; // 1\n  -webkit-appearance: button; // 2\n}\n\n// Correct element displays\n\noutput {\n  display: inline-block;\n}\n\n// Remove border from iframe\n\niframe {\n  border: 0;\n}\n\n// Summary\n//\n// 1. Add the correct display in all browsers\n\nsummary {\n  display: list-item; // 1\n  cursor: pointer;\n}\n\n\n// Progress\n//\n// Add the correct vertical alignment in Chrome, Firefox, and Opera.\n\nprogress {\n  vertical-align: baseline;\n}\n\n\n// Hidden attribute\n//\n// Always hide an element with the `hidden` HTML attribute.\n\n[hidden] {\n  display: none !important;\n}\n","// Variables\r\n\r\n//Google Font\r\n@import url('https://fonts.googleapis.com/css2?family=Nunito:wght@300;400;500;600;700&display=swap');\r\n\r\n//\r\n// custom-variables\r\n//\r\n\r\n// Prefix for :root CSS variables\r\n\r\n$variable-prefix:             vz-;\r\n\r\n// Font Family\r\n$font-family-primary:                    'Poppins', sans-serif ;        //'Nunito', 'Nunito';\r\n$font-family-secondary:                  'Poppins', sans-serif ;       // 'Nunito', 'Nunito';\r\n\r\n//\r\n// Vertical Menu\r\n//\r\n$vertical-menu-width:                             250px;\r\n$vertical-menu-width-md:                          180px;\r\n$vertical-menu-width-sm:                          70px;\r\n\r\n// Light Menu\r\n$vertical-menu-bg:                                var(--#{$variable-prefix}vertical-menu-bg);\r\n$vertical-menu-box-shadow:                        0 2px 4px rgba(15,34,58,0.12);\r\n$vertical-menu-border:                            $white;\r\n$vertical-menu-z-index:                           1002;\r\n$vertical-menu-item-font-size:                    0.9375rem;\r\n$vertical-menu-item-font-family:                  $font-family-secondary;\r\n$vertical-menu-item-color:                        var(--#{$variable-prefix}vertical-menu-item-color);\r\n$vertical-menu-item-hover-color:                  var(--#{$variable-prefix}vertical-menu-item-hover-color);\r\n$vertical-menu-item-active-color:                 var(--#{$variable-prefix}vertical-menu-item-active-color);\r\n$vertical-menu-item-padding-x:                    1.5rem;\r\n$vertical-menu-item-padding-y:                    0.625rem;\r\n$vertical-menu-sub-item-font-size:                0.875rem;\r\n$vertical-menu-sub-item-font-family:              $font-family-primary;\r\n$vertical-menu-sub-item-color:                    var(--#{$variable-prefix}vertical-menu-sub-item-color);\r\n$vertical-menu-sub-item-hover-color:              var(--#{$variable-prefix}vertical-menu-sub-item-hover-color);\r\n$vertical-menu-sub-item-active-color:             var(--#{$variable-prefix}vertical-menu-sub-item-active-color);\r\n$vertical-menu-sub-item-padding-x:                1.5rem;\r\n$vertical-menu-sub-item-padding-y:                0.55rem;\r\n$vertical-menu-dropdown-box-shadow:               0 2px 4px rgba(15,34,58,0.12);\r\n$vertical-menu-title-color:                       var(--#{$variable-prefix}vertical-menu-title-color);\r\n$vertical-menu-item-icon-width:                   1.75rem;\r\n\r\n// Dark Menu\r\n$vertical-menu-bg-dark:                         var(--#{$variable-prefix}vertical-menu-bg-dark);\r\n$vertical-menu-border-dark:                     var(--#{$variable-prefix}vertical-menu-bg-dark);\r\n$vertical-menu-item-color-dark:                 var(--#{$variable-prefix}vertical-menu-item-color-dark);\r\n$vertical-menu-item-hover-color-dark:           var(--#{$variable-prefix}vertical-menu-item-hover-color-dark);\r\n$vertical-menu-item-active-color-dark:          var(--#{$variable-prefix}vertical-menu-item-active-color-dark);\r\n$vertical-menu-sub-item-color-dark:             var(--#{$variable-prefix}vertical-menu-sub-item-color-dark);\r\n$vertical-menu-sub-item-hover-color-dark:       var(--#{$variable-prefix}vertical-menu-sub-item-hover-color-dark);\r\n$vertical-menu-sub-item-active-color-dark:      var(--#{$variable-prefix}vertical-menu-sub-item-active-color-dark);\r\n$vertical-menu-title-color-dark:                var(--#{$variable-prefix}vertical-menu-title-color-dark);\r\n\r\n//\r\n// Horizontal Menu\r\n//\r\n$horizontal-menu-box-shadow:                       0 2px 4px rgba(15,34,58,0.12);\r\n$horizontal-menu-dropdown-box-shadow:              0 0px 5px rgba(15,34,58,0.15);\r\n$horizontal-menu-dropdown-min-width:               12rem; \r\n$horizontal-menu-item-padding-x:                   1.5rem;\r\n$horizontal-menu-item-padding-y:                   0.75rem;\r\n\r\n//\r\n// Two Column Menu\r\n//\r\n$twocolumn-menu-iconview-bg:                     var(--#{$variable-prefix}twocolumn-menu-iconview-bg);\r\n$twocolumn-menu-bg:                              var(--#{$variable-prefix}twocolumn-menu-bg);\r\n$twocolumn-menu-iconview-width:                    70px;\r\n$twocolumn-menu-width:                             220px;\r\n$twocolumn-menu-box-shadow:                        0 2px 4px rgba(15,34,58,0.12);\r\n$twocolumn-menu-z-index:                           1002;\r\n// dark\r\n$twocolumn-menu-iconview-bg-dark:                var(--#{$variable-prefix}twocolumn-menu-iconview-bg-dark);\r\n$twocolumn-menu-bg-dark:                         var(--#{$variable-prefix}twocolumn-menu-bg-dark);\r\n$twocolumn-menu-border-dark:                     var(--#{$variable-prefix}twocolumn-menu-bg-dark);\r\n$twocolumn-menu-item-color-dark:                 var(--#{$variable-prefix}twocolumn-menu-item-color-dark);\r\n$twocolumn-menu-item-active-color-dark:          var(--#{$variable-prefix}twocolumn-menu-item-active-color-dark);\r\n$twocolumn-menu-item-active-bg-dark:             var(--#{$variable-prefix}twocolumn-menu-item-active-bg-dark);\r\n\r\n\r\n// Topbar - (Default Light)\r\n$header-height:                                    70px;\r\n$header-bg:                                      var(--#{$variable-prefix}header-bg);\r\n$header-item-color:                              var(--#{$variable-prefix}header-item-color);\r\n\r\n// Topbar - Dark\r\n$header-bg-dark:                                 var(--#{$variable-prefix}header-bg-dark);\r\n$header-item-color-dark:                         var(--#{$variable-prefix}header-item-color-dark); \r\n\r\n// Topbar Search\r\n$topbar-search-bg:                                var(--#{$variable-prefix}topbar-search-bg);\r\n$page-title-box-shadow:                           0 1px 2px rgba(56,65,74,0.15);\r\n$page-title-border:                               none;\r\n\r\n// Topbar User\r\n$topbar-user-bg: var(--#{$variable-prefix}topbar-user-bg);\r\n$topbar-user-bg-dark: var(--#{$variable-prefix}topbar-user-bg-dark);\r\n\r\n// Footer\r\n$footer-height: 60px;\r\n$footer-bg: var(--#{$variable-prefix}footer-bg);\r\n$footer-color: var(--#{$variable-prefix}footer-color);\r\n\r\n// Horizontal nav\r\n$topnav-bg:   var(--#{$variable-prefix}topnav-bg);\r\n$topnav-item-color:   var(--#{$variable-prefix}topnav-item-color);\r\n$topnav-item-color-active:   var(--#{$variable-prefix}topnav-item-color-active);\r\n\r\n// Brand \r\n$navbar-brand-box-width: 240px;\r\n\r\n// Boxed layout width\r\n$boxed-layout-width:    1300px;\r\n$boxed-body-bg:         var(--#{$variable-prefix}boxed-body-bg);\r\n\r\n// Font Weight\r\n$font-weight-medium: 500;\r\n$font-weight-semibold: 600;\r\n\r\n// heading\r\n$heading-color: var(--#{$variable-prefix}heading-color);\r\n$heading-font-family:         $font-family-secondary;\r\n\r\n// Chat\r\n$chat-primary-bg:       var(--#{$variable-prefix}gray-100);\r\n$chat-secondary-bg:    rgba(var(--#{$variable-prefix}success-rgb), 0.15);\r\n$chat-secondary-color:  var(--#{$variable-prefix}success);\r\n\r\n\r\n// Timeline\r\n$timeline-color:   var(--#{$variable-prefix}card-bg);     \r\n\r\n// Variables\r\n//\r\n// Variables should follow the `$component-state-property-size` formula for\r\n// consistent naming. Ex: $nav-link-disabled-color and $modal-content-box-shadow-xs.\r\n\r\n// Color system\r\n\r\n// scss-docs-start gray-color-variables\r\n$white:    #fff;\r\n$gray-100: #f3f6f9;\r\n$gray-200: #eff2f7;\r\n$gray-300: #e9ebec;\r\n$gray-400: #ced4da;\r\n$gray-500: #adb5bd;\r\n$gray-600: #878a99;\r\n$gray-700: #495057;\r\n$gray-800: #343a40;\r\n$gray-900: #212529;\r\n$black:    #000;\r\n\r\n// fusv-disable\r\n// scss-docs-start gray-colors-map\r\n$grays: (\r\n  \"100\": $gray-100,\r\n  \"200\": $gray-200,\r\n  \"300\": $gray-300,\r\n  \"400\": $gray-400,\r\n  \"500\": $gray-500,\r\n  \"600\": $gray-600,\r\n  \"700\": $gray-700,\r\n  \"800\": $gray-800,\r\n  \"900\": $gray-900\r\n);\r\n// scss-docs-end gray-colors-map\r\n// fusv-enable\r\n\r\n// scss-docs-start color-variables\r\n$blue:       #5ea3cb;\r\n$indigo:     #405189;\r\n$purple:     #7084c7;\r\n$pink:       #f672a7;\r\n$red:        #E53E3E;\r\n$orange:     #f1963b;\r\n$yellow:     #f7b84b;\r\n$green:      #319795;\r\n$teal:       #02a8b5;\r\n$cyan:       #58caea;\r\n// scss-docs-end color-variables\r\n\r\n// scss-docs-start colors-map\r\n$colors: (\r\n  \"blue\":       $blue,\r\n  \"indigo\":     $indigo,\r\n  \"purple\":     $purple,\r\n  \"pink\":       $pink,\r\n  \"red\":        $red,\r\n  \"orange\":     $orange,\r\n  \"yellow\":     $yellow,\r\n  \"green\":      $green,\r\n  \"teal\":       $teal,\r\n  \"cyan\":       $cyan,\r\n  \"white\":      $white,\r\n  \"gray\":       $gray-600,\r\n  \"gray-dark\":  $gray-800\r\n);\r\n// scss-docs-end colors-map\r\n\r\n// scss-docs-start theme-color-variables\r\n$primary:       $blue;\r\n$secondary:     $purple;\r\n$success:       $green;\r\n$info:          $cyan;\r\n$warning:       $yellow;\r\n$danger:        $red;\r\n$light:         $gray-100;\r\n$dark:          $gray-900;\r\n// scss-docs-end theme-color-variables\r\n\r\n// scss-docs-start theme-colors-map\r\n$theme-colors: (\r\n  \"primary\":    $primary,\r\n  \"secondary\":  $secondary,\r\n  \"success\":    $success,\r\n  \"info\":       $info,\r\n  \"warning\":    $warning,\r\n  \"danger\":     $danger,\r\n  \"light\":      $light,\r\n  \"dark\":       $dark\r\n);\r\n// scss-docs-end theme-colors-map\r\n\r\n// scss-docs-start theme-colors-rgb\r\n$theme-colors-rgb: map-loop($theme-colors, to-rgb, \"$value\");\r\n// scss-docs-end theme-colors-rgb\r\n\r\n// The contrast ratio to reach against white, to determine if color changes from \"light\" to \"dark\". Acceptable values for WCAG 2.0 are 3, 4.5 and 7.\r\n// See https://www.w3.org/TR/WCAG20/#visual-audio-contrast-contrast\r\n$min-contrast-ratio:   1.75;\r\n\r\n// Customize the light and dark text colors for use in our color contrast function.\r\n$color-contrast-dark:      $black;\r\n$color-contrast-light:     $white;\r\n\r\n// fusv-disable\r\n$blue-100: tint-color($blue, 80%);\r\n$blue-200: tint-color($blue, 60%);\r\n$blue-300: tint-color($blue, 40%);\r\n$blue-400: tint-color($blue, 20%);\r\n$blue-500: $blue;\r\n$blue-600: shade-color($blue, 20%);\r\n$blue-700: shade-color($blue, 40%);\r\n$blue-800: shade-color($blue, 60%);\r\n$blue-900: shade-color($blue, 80%);\r\n\r\n$indigo-100: tint-color($indigo, 80%);\r\n$indigo-200: tint-color($indigo, 60%);\r\n$indigo-300: tint-color($indigo, 40%);\r\n$indigo-400: tint-color($indigo, 20%);\r\n$indigo-500: $indigo;\r\n$indigo-600: shade-color($indigo, 20%);\r\n$indigo-700: shade-color($indigo, 40%);\r\n$indigo-800: shade-color($indigo, 60%);\r\n$indigo-900: shade-color($indigo, 80%);\r\n\r\n$purple-100: tint-color($purple, 80%);\r\n$purple-200: tint-color($purple, 60%);\r\n$purple-300: tint-color($purple, 40%);\r\n$purple-400: tint-color($purple, 20%);\r\n$purple-500: $purple;\r\n$purple-600: shade-color($purple, 20%);\r\n$purple-700: shade-color($purple, 40%);\r\n$purple-800: shade-color($purple, 60%);\r\n$purple-900: shade-color($purple, 80%);\r\n\r\n$pink-100: tint-color($pink, 80%);\r\n$pink-200: tint-color($pink, 60%);\r\n$pink-300: tint-color($pink, 40%);\r\n$pink-400: tint-color($pink, 20%);\r\n$pink-500: $pink;\r\n$pink-600: shade-color($pink, 20%);\r\n$pink-700: shade-color($pink, 40%);\r\n$pink-800: shade-color($pink, 60%);\r\n$pink-900: shade-color($pink, 80%);\r\n\r\n$red-100: tint-color($red, 80%);\r\n$red-200: tint-color($red, 60%);\r\n$red-300: tint-color($red, 40%);\r\n$red-400: tint-color($red, 20%);\r\n$red-500: $red;\r\n$red-600: shade-color($red, 20%);\r\n$red-700: shade-color($red, 40%);\r\n$red-800: shade-color($red, 60%);\r\n$red-900: shade-color($red, 80%);\r\n\r\n$orange-100: tint-color($orange, 80%);\r\n$orange-200: tint-color($orange, 60%);\r\n$orange-300: tint-color($orange, 40%);\r\n$orange-400: tint-color($orange, 20%);\r\n$orange-500: $orange;\r\n$orange-600: shade-color($orange, 20%);\r\n$orange-700: shade-color($orange, 40%);\r\n$orange-800: shade-color($orange, 60%);\r\n$orange-900: shade-color($orange, 80%);\r\n\r\n$yellow-100: tint-color($yellow, 80%);\r\n$yellow-200: tint-color($yellow, 60%);\r\n$yellow-300: tint-color($yellow, 40%);\r\n$yellow-400: tint-color($yellow, 20%);\r\n$yellow-500: $yellow;\r\n$yellow-600: shade-color($yellow, 20%);\r\n$yellow-700: shade-color($yellow, 40%);\r\n$yellow-800: shade-color($yellow, 60%);\r\n$yellow-900: shade-color($yellow, 80%);\r\n\r\n$green-100: tint-color($green, 80%);\r\n$green-200: tint-color($green, 60%);\r\n$green-300: tint-color($green, 40%);\r\n$green-400: tint-color($green, 20%);\r\n$green-500: $green;\r\n$green-600: shade-color($green, 20%);\r\n$green-700: shade-color($green, 40%);\r\n$green-800: shade-color($green, 60%);\r\n$green-900: shade-color($green, 80%);\r\n\r\n$teal-100: tint-color($teal, 80%);\r\n$teal-200: tint-color($teal, 60%);\r\n$teal-300: tint-color($teal, 40%);\r\n$teal-400: tint-color($teal, 20%);\r\n$teal-500: $teal;\r\n$teal-600: shade-color($teal, 20%);\r\n$teal-700: shade-color($teal, 40%);\r\n$teal-800: shade-color($teal, 60%);\r\n$teal-900: shade-color($teal, 80%);\r\n\r\n$cyan-100: tint-color($cyan, 80%);\r\n$cyan-200: tint-color($cyan, 60%);\r\n$cyan-300: tint-color($cyan, 40%);\r\n$cyan-400: tint-color($cyan, 20%);\r\n$cyan-500: $cyan;\r\n$cyan-600: shade-color($cyan, 20%);\r\n$cyan-700: shade-color($cyan, 40%);\r\n$cyan-800: shade-color($cyan, 60%);\r\n$cyan-900: shade-color($cyan, 80%);\r\n$blues: (\r\n  \"blue-100\": $blue-100,\r\n  \"blue-200\": $blue-200,\r\n  \"blue-300\": $blue-300,\r\n  \"blue-400\": $blue-400,\r\n  \"blue-500\": $blue-500,\r\n  \"blue-600\": $blue-600,\r\n  \"blue-700\": $blue-700,\r\n  \"blue-800\": $blue-800,\r\n  \"blue-900\": $blue-900\r\n);\r\n\r\n$indigos: (\r\n  \"indigo-100\": $indigo-100,\r\n  \"indigo-200\": $indigo-200,\r\n  \"indigo-300\": $indigo-300,\r\n  \"indigo-400\": $indigo-400,\r\n  \"indigo-500\": $indigo-500,\r\n  \"indigo-600\": $indigo-600,\r\n  \"indigo-700\": $indigo-700,\r\n  \"indigo-800\": $indigo-800,\r\n  \"indigo-900\": $indigo-900\r\n);\r\n\r\n$purples: (\r\n  \"purple-100\": $purple-200,\r\n  \"purple-200\": $purple-100,\r\n  \"purple-300\": $purple-300,\r\n  \"purple-400\": $purple-400,\r\n  \"purple-500\": $purple-500,\r\n  \"purple-600\": $purple-600,\r\n  \"purple-700\": $purple-700,\r\n  \"purple-800\": $purple-800,\r\n  \"purple-900\": $purple-900\r\n);\r\n\r\n$pinks: (\r\n  \"pink-100\": $pink-100,\r\n  \"pink-200\": $pink-200,\r\n  \"pink-300\": $pink-300,\r\n  \"pink-400\": $pink-400,\r\n  \"pink-500\": $pink-500,\r\n  \"pink-600\": $pink-600,\r\n  \"pink-700\": $pink-700,\r\n  \"pink-800\": $pink-800,\r\n  \"pink-900\": $pink-900\r\n);\r\n\r\n$reds: (\r\n  \"red-100\": $red-100,\r\n  \"red-200\": $red-200,\r\n  \"red-300\": $red-300,\r\n  \"red-400\": $red-400,\r\n  \"red-500\": $red-500,\r\n  \"red-600\": $red-600,\r\n  \"red-700\": $red-700,\r\n  \"red-800\": $red-800,\r\n  \"red-900\": $red-900\r\n);\r\n\r\n$oranges: (\r\n  \"orange-100\": $orange-100,\r\n  \"orange-200\": $orange-200,\r\n  \"orange-300\": $orange-300,\r\n  \"orange-400\": $orange-400,\r\n  \"orange-500\": $orange-500,\r\n  \"orange-600\": $orange-600,\r\n  \"orange-700\": $orange-700,\r\n  \"orange-800\": $orange-800,\r\n  \"orange-900\": $orange-900\r\n);\r\n\r\n$yellows: (\r\n  \"yellow-100\": $yellow-100,\r\n  \"yellow-200\": $yellow-200,\r\n  \"yellow-300\": $yellow-300,\r\n  \"yellow-400\": $yellow-400,\r\n  \"yellow-500\": $yellow-500,\r\n  \"yellow-600\": $yellow-600,\r\n  \"yellow-700\": $yellow-700,\r\n  \"yellow-800\": $yellow-800,\r\n  \"yellow-900\": $yellow-900\r\n);\r\n\r\n$greens: (\r\n  \"green-100\": $green-100,\r\n  \"green-200\": $green-200,\r\n  \"green-300\": $green-300,\r\n  \"green-400\": $green-400,\r\n  \"green-500\": $green-500,\r\n  \"green-600\": $green-600,\r\n  \"green-700\": $green-700,\r\n  \"green-800\": $green-800,\r\n  \"green-900\": $green-900\r\n);\r\n\r\n$teals: (\r\n  \"teal-100\": $teal-100,\r\n  \"teal-200\": $teal-200,\r\n  \"teal-300\": $teal-300,\r\n  \"teal-400\": $teal-400,\r\n  \"teal-500\": $teal-500,\r\n  \"teal-600\": $teal-600,\r\n  \"teal-700\": $teal-700,\r\n  \"teal-800\": $teal-800,\r\n  \"teal-900\": $teal-900\r\n);\r\n\r\n$cyans: (\r\n  \"cyan-100\": $cyan-100,\r\n  \"cyan-200\": $cyan-200,\r\n  \"cyan-300\": $cyan-300,\r\n  \"cyan-400\": $cyan-400,\r\n  \"cyan-500\": $cyan-500,\r\n  \"cyan-600\": $cyan-600,\r\n  \"cyan-700\": $cyan-700,\r\n  \"cyan-800\": $cyan-800,\r\n  \"cyan-900\": $cyan-900\r\n);\r\n// fusv-enable\r\n\r\n// Characters which are escaped by the escape-svg function\r\n$escaped-characters: (\r\n  (\"<\", \"%3c\"),\r\n  (\">\", \"%3e\"),\r\n  (\"#\", \"%23\"),\r\n  (\"(\", \"%28\"),\r\n  (\")\", \"%29\"),\r\n);\r\n\r\n// Options\r\n//\r\n// Quickly modify global styling by enabling or disabling optional features.\r\n\r\n$enable-caret:                false;\r\n$enable-rounded:              true;\r\n$enable-shadows:              false;\r\n$enable-gradients:            false;\r\n$enable-transitions:          true;\r\n$enable-reduced-motion:       true;\r\n$enable-smooth-scroll:        true;\r\n$enable-grid-classes:         true;\r\n$enable-cssgrid:              false;\r\n$enable-button-pointers:      true;\r\n$enable-rfs:                  true;\r\n$enable-validation-icons:     true;\r\n$enable-negative-margins:     true;\r\n$enable-deprecation-messages: true;\r\n$enable-important-utilities:  true;\r\n\r\n// Gradient\r\n//\r\n// The gradient which is added to components if `$enable-gradients` is `true`\r\n// This gradient is also added to elements with `.bg-gradient`\r\n// scss-docs-start variable-gradient\r\n$gradient: linear-gradient(180deg, rgba($white, .15), rgba($white, 0));\r\n// scss-docs-end variable-gradient\r\n\r\n// Spacing\r\n//\r\n// Control the default styling of most Bootstrap elements by modifying these\r\n// variables. Mostly focused on spacing.\r\n// You can add more entries to the $spacers map, should you need more variation.\r\n\r\n// scss-docs-start spacer-variables-maps\r\n$spacer: 1rem;\r\n$spacers: (\r\n  0: 0,\r\n  1: $spacer * .25,\r\n  2: $spacer * .5,\r\n  3: $spacer,\r\n  4: $spacer * 1.5,\r\n  5: $spacer * 3,\r\n);\r\n\r\n$negative-spacers: if($enable-negative-margins, negativify-map($spacers), null);\r\n// scss-docs-end spacer-variables-maps\r\n\r\n// Position\r\n//\r\n// Define the edge positioning anchors of the position utilities.\r\n\r\n// scss-docs-start position-map\r\n$position-values: (\r\n  0: 0,\r\n  50: 50%,\r\n  100: 100%\r\n);\r\n// scss-docs-end position-map\r\n\r\n// Body\r\n//\r\n// Settings for the `<body>` element.\r\n\r\n$body-bg:                   #ffffff;\r\n$body-color:                $gray-900;\r\n$body-text-align:           null;\r\n\r\n// Utilities maps\r\n//\r\n// Extends the default `$theme-colors` maps to help create our utilities.\r\n\r\n// Come v6, we'll de-dupe these variables. Until then, for backward compatibility, we keep them to reassign.\r\n// scss-docs-start utilities-colors\r\n$utilities-colors: $theme-colors-rgb;\r\n// scss-docs-end utilities-colors\r\n  \r\n// scss-docs-start utilities-text-colors\r\n$utilities-text: map-merge(\r\n  $utilities-colors,\r\n  (\r\n    \"black\": to-rgb($black),\r\n    \"white\": to-rgb($white),\r\n    \"body\": to-rgb($body-color)\r\n  )\r\n);\r\n$utilities-text-colors: map-loop($utilities-text, rgba-css-var, \"$key\", \"text\");\r\n// scss-docs-end utilities-text-colors\r\n\r\n// scss-docs-start utilities-bg-colors\r\n$utilities-bg: map-merge(\r\n  $utilities-colors,\r\n  (\r\n    \"black\": to-rgb($black),\r\n    \"white\": to-rgb($white),\r\n    \"body\": to-rgb($body-bg)\r\n  )\r\n);\r\n$utilities-bg-colors: map-loop($utilities-bg, rgba-css-var, \"$key\", \"bg\");\r\n// scss-docs-end utilities-bg-colors\r\n\r\n// Links\r\n//\r\n// Style anchor elements.\r\n\r\n$link-color:                              var(--#{$variable-prefix}link-color);\r\n$link-decoration:                         underline;\r\n$link-shade-percentage:                   20%;\r\n$link-hover-color:                        var(--#{$variable-prefix}link-hover-color);\r\n$link-hover-decoration:                   null;\r\n\r\n$stretched-link-pseudo-element:           after;\r\n$stretched-link-z-index:                  1;\r\n\r\n// Paragraphs\r\n//\r\n// Style p element.\r\n\r\n$paragraph-margin-bottom:   1rem;\r\n\r\n\r\n// Grid breakpoints\r\n//\r\n// Define the minimum dimensions at which your layout will change,\r\n// adapting to different screen sizes, for use in media queries.\r\n\r\n// scss-docs-start grid-breakpoints\r\n$grid-breakpoints: (\r\n  xs: 0,\r\n  sm: 576px,\r\n  md: 768px,\r\n  lg: 992px,\r\n  xl: 1200px,\r\n  xxl: 1400px\r\n);\r\n// scss-docs-end grid-breakpoints\r\n\r\n@include _assert-ascending($grid-breakpoints, \"$grid-breakpoints\");\r\n@include _assert-starts-at-zero($grid-breakpoints, \"$grid-breakpoints\");\r\n\r\n\r\n// Grid containers\r\n//\r\n// Define the maximum width of `.container` for different screen sizes.\r\n\r\n// scss-docs-start container-max-widths\r\n$container-max-widths: (\r\n  sm: 540px,\r\n  md: 720px,\r\n  lg: 960px,\r\n  xl: 1140px,\r\n  xxl: 1320px\r\n);\r\n// scss-docs-end container-max-widths\r\n\r\n@include _assert-ascending($container-max-widths, \"$container-max-widths\");\r\n\r\n\r\n// Grid columns\r\n//\r\n// Set the number of columns and specify the width of the gutters.\r\n\r\n$grid-columns:                12;\r\n$grid-gutter-width:           1.5rem;\r\n$grid-row-columns:            6;\r\n\r\n$gutters: $spacers;\r\n\r\n// Container padding\r\n\r\n$container-padding-x: $grid-gutter-width * .5;\r\n\r\n\r\n// Components\r\n//\r\n// Define common padding and border radius sizes and more.\r\n\r\n// scss-docs-start border-variables\r\n$border-width:                1px;\r\n$border-widths: (\r\n  1: 1px,\r\n  2: 2px,\r\n  3: 3px,\r\n  4: 4px,\r\n  5: 5px\r\n);\r\n\r\n$border-color:                var(--#{$variable-prefix}border-color);\r\n// scss-docs-end border-variables\r\n\r\n// scss-docs-start border-radius-variables\r\n$border-radius:               .25rem;\r\n$border-radius-sm:            .2rem;\r\n$border-radius-lg:            .3rem;\r\n$border-radius-pill:          50rem;\r\n// scss-docs-end border-radius-variables\r\n\r\n// scss-docs-start box-shadow-variables\r\n$box-shadow:                  0 1px 2px rgba(56,65,74,0.15);\r\n$box-shadow-sm:               0 .125rem .25rem rgba($black, .075);\r\n$box-shadow-lg:               0 5px 10px rgba(30, 32, 37, 0.12);\r\n$box-shadow-inset:            inset 0 1px 2px rgba($black, .075);\r\n$element-shadow:              none;\r\n// scss-docs-end box-shadow-variables\r\n\r\n$component-active-color:      $white;\r\n$component-active-bg:         $primary;\r\n\r\n// scss-docs-start caret-variables\r\n$caret-width:                 .3em;\r\n$caret-vertical-align:        $caret-width * .85;\r\n$caret-spacing:               $caret-width * .85;\r\n// scss-docs-end caret-variables\r\n\r\n$transition-base:             all .2s ease-in-out;\r\n$transition-fade:             opacity .15s linear;\r\n// scss-docs-start collapse-transition\r\n$transition-collapse:         height .35s ease;\r\n$transition-collapse-width:   width .35s ease;\r\n// scss-docs-end collapse-transition\r\n\r\n// stylelint-disable function-disallowed-list\r\n// scss-docs-start aspect-ratios\r\n$aspect-ratios: (\r\n  \"1x1\": 100%,\r\n  \"4x3\": calc(3 / 4 * 100%),\r\n  \"16x9\": calc(9 / 16 * 100%),\r\n  \"21x9\": calc(9 / 21 * 100%)\r\n);\r\n// scss-docs-end aspect-ratios\r\n// stylelint-enable function-disallowed-list\r\n\r\n// Typography\r\n//\r\n// Font, line-height, and color for body text, headings, and more.\r\n\r\n// scss-docs-start font-variables\r\n// stylelint-disable value-keyword-case\r\n$font-family-sans-serif:      $font-family-primary;\r\n$font-family-monospace:       SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\r\n// stylelint-enable value-keyword-case\r\n$font-family-base:            var(--#{$variable-prefix}font-sans-serif);\r\n$font-family-code:            var(--#{$variable-prefix}font-monospace);\r\n\r\n// $font-size-root affects the value of `rem`, which is used for as well font sizes, paddings, and margins\r\n// $font-size-base affects the font size of the body text\r\n$font-size-root:              null;\r\n$font-size-base:              0.875rem; // Assumes the browser default, typically `16px`\r\n$font-size-sm:                $font-size-base * .875;\r\n$font-size-lg:                $font-size-base * 1.25;\r\n\r\n$font-weight-lighter:         lighter;\r\n$font-weight-light:           300;\r\n$font-weight-normal:          400;\r\n$font-weight-bold:            700;\r\n$font-weight-bolder:          bolder;\r\n\r\n$font-weight-base:            $font-weight-normal;\r\n\r\n$line-height-base:            1.5;\r\n$line-height-sm:              1.25;\r\n$line-height-lg:              2;\r\n\r\n$h1-font-size:                $font-size-base * 2.5;\r\n$h2-font-size:                $font-size-base * 2;\r\n$h3-font-size:                $font-size-base * 1.75;\r\n$h4-font-size:                $font-size-base * 1.5;\r\n$h5-font-size:                $font-size-base * 1.25;\r\n$h6-font-size:                $font-size-base;\r\n// scss-docs-end font-variables\r\n\r\n// scss-docs-start font-sizes\r\n$font-sizes: (\r\n  1: $h1-font-size,\r\n  2: $h2-font-size,\r\n  3: $h3-font-size,\r\n  4: $h4-font-size,\r\n  5: $h5-font-size,\r\n  6: $h6-font-size\r\n);\r\n// scss-docs-end font-sizes\r\n\r\n// scss-docs-start headings-variables\r\n$headings-margin-bottom:      $spacer * .5;\r\n$headings-font-family:        null;\r\n$headings-font-style:         null;\r\n$headings-font-weight:        600;\r\n$headings-line-height:        1.2;\r\n$headings-color:              null;\r\n// scss-docs-end headings-variables\r\n\r\n// scss-docs-start display-headings\r\n$display-font-sizes: (\r\n  1: 5rem,\r\n  2: 4.5rem,\r\n  3: 4rem,\r\n  4: 3.5rem,\r\n  5: 3rem,\r\n  6: 2.5rem\r\n);\r\n\r\n$display-font-weight: 300;\r\n$display-line-height: $headings-line-height;\r\n// scss-docs-end display-headings\r\n\r\n// scss-docs-start type-variables\r\n$lead-font-size:              $font-size-base * 1.25;\r\n$lead-font-weight:            300;\r\n\r\n$small-font-size:             .875em;\r\n\r\n$sub-sup-font-size:           .75em;\r\n\r\n$text-muted:                  $gray-600;\r\n\r\n$initialism-font-size:        $small-font-size;\r\n\r\n$blockquote-margin-y:         $spacer;\r\n$blockquote-font-size:        $font-size-base * 1.1;\r\n$blockquote-footer-color:     $gray-600;\r\n$blockquote-footer-font-size: $small-font-size;\r\n\r\n$hr-margin-y:                 $spacer;\r\n$hr-color:                    inherit;\r\n$hr-height:                   $border-width;\r\n$hr-opacity:                  .25;\r\n\r\n$legend-margin-bottom:        .5rem;\r\n$legend-font-size:            1.5rem;\r\n$legend-font-weight:          null;\r\n\r\n$mark-padding:                .2em;\r\n\r\n$dt-font-weight:              $font-weight-semibold;\r\n\r\n$nested-kbd-font-weight:      $font-weight-bold;\r\n\r\n$list-inline-padding:         .5rem;\r\n\r\n$mark-bg:                     #fcf8e3;\r\n// scss-docs-end type-variables\r\n\r\n\r\n// Tables\r\n//\r\n// Customizes the `.table` component with basic values, each used across all table variations.\r\n\r\n// scss-docs-start table-variables\r\n$table-cell-padding-y:        .75rem;\r\n$table-cell-padding-x:        .6rem;\r\n$table-cell-padding-y-sm:     .3rem;\r\n$table-cell-padding-x-sm:     .25rem;\r\n\r\n$table-cell-vertical-align:   top;\r\n\r\n$table-color:                 var(--#{$variable-prefix}body-color);\r\n$table-bg:                    transparent;\r\n$table-accent-bg:             transparent;\r\n\r\n$table-th-font-weight:        null;\r\n\r\n$table-striped-color:         $table-color;\r\n$table-striped-bg-factor:     .02;\r\n$table-striped-bg:            rgba(var(--#{$variable-prefix}dark-rgb), $table-striped-bg-factor);\r\n\r\n$table-active-color:          $table-color;\r\n$table-active-bg-factor:      1;\r\n$table-active-bg:             rgba(var(--#{$variable-prefix}light-rgb), $table-active-bg-factor);\r\n\r\n$table-hover-color:           $table-color;\r\n$table-hover-bg-factor:       1;\r\n$table-hover-bg:              rgba(var(--#{$variable-prefix}light-rgb), $table-hover-bg-factor);\r\n\r\n$table-border-factor:         .1;\r\n$table-border-width:          $border-width;\r\n$table-border-color:          $border-color;\r\n\r\n$table-striped-order:         odd;\r\n\r\n$table-group-separator-color: $border-color;\r\n\r\n$table-caption-color:         $text-muted;\r\n\r\n$table-bg-scale:              -80%;\r\n// scss-docs-end table-variables\r\n\r\n// scss-docs-start table-loop\r\n$table-variants: (\r\n  \"primary\":    shift-color($primary, $table-bg-scale),\r\n  \"secondary\":  shift-color($secondary, $table-bg-scale),\r\n  \"success\":    shift-color($success, $table-bg-scale),\r\n  \"info\":       shift-color($info, $table-bg-scale),\r\n  \"warning\":    shift-color($warning, $table-bg-scale),\r\n  \"danger\":     shift-color($danger, $table-bg-scale),\r\n  \"light\":      $light,\r\n  \"dark\":       $dark,\r\n);\r\n// scss-docs-end table-loop\r\n\r\n\r\n// Buttons + Forms\r\n//\r\n// Shared variables that are reassigned to `$input-` and `$btn-` specific variables.\r\n\r\n// scss-docs-start input-btn-variables\r\n$input-btn-padding-y:         .5rem;\r\n$input-btn-padding-x:         .9rem;\r\n$input-btn-font-family:       null;\r\n$input-btn-font-size:         $font-size-base;\r\n$input-btn-line-height:       $line-height-base;\r\n\r\n$input-btn-focus-width:         0;\r\n$input-btn-focus-color-opacity: .25;\r\n$input-btn-focus-color:         rgba($component-active-bg, $input-btn-focus-color-opacity);\r\n$input-btn-focus-blur:          0;\r\n$input-btn-focus-box-shadow:    0 0 $input-btn-focus-blur $input-btn-focus-width $input-btn-focus-color;\r\n\r\n$input-btn-padding-y-sm:      .25rem;\r\n$input-btn-padding-x-sm:      .5rem;\r\n$input-btn-font-size-sm:      $font-size-sm;\r\n\r\n$input-btn-padding-y-lg:      .7rem;\r\n$input-btn-padding-x-lg:      1.2rem;\r\n$input-btn-font-size-lg:      $font-size-lg;\r\n\r\n$input-btn-border-width:      $border-width;\r\n// scss-docs-end input-btn-variables\r\n\r\n\r\n// Buttons\r\n//\r\n// For each of Bootstrap's buttons, define text, background, and border color.\r\n\r\n// scss-docs-start btn-variables\r\n$btn-padding-y:               $input-btn-padding-y;\r\n$btn-padding-x:               $input-btn-padding-x;\r\n$btn-font-family:             $input-btn-font-family;\r\n$btn-font-size:               $input-btn-font-size;\r\n$btn-line-height:             $input-btn-line-height;\r\n$btn-white-space:             null; // Set to `nowrap` to prevent text wrapping\r\n\r\n$btn-padding-y-sm:            $input-btn-padding-y-sm;\r\n$btn-padding-x-sm:            $input-btn-padding-x-sm;\r\n$btn-font-size-sm:            $input-btn-font-size-sm;\r\n\r\n$btn-padding-y-lg:            $input-btn-padding-y-lg;\r\n$btn-padding-x-lg:            $input-btn-padding-x-lg;\r\n$btn-font-size-lg:            $input-btn-font-size-lg;\r\n\r\n$btn-border-width:            $input-btn-border-width;\r\n\r\n$btn-font-weight:             $font-weight-medium;\r\n$btn-box-shadow:              inset 0 1px 0 rgba($white, .15), 0 1px 1px rgba($black, .075);\r\n$btn-focus-width:             $input-btn-focus-width;\r\n$btn-focus-box-shadow:        $input-btn-focus-box-shadow;\r\n$btn-disabled-opacity:        .65;\r\n$btn-active-box-shadow:       inset 0 3px 5px rgba($black, .125);\r\n\r\n$btn-link-color:              $link-color;\r\n$btn-link-hover-color:        $link-hover-color;\r\n$btn-link-disabled-color:     $gray-600;\r\n\r\n// Allows for customizing button radius independently from global border radius\r\n$btn-border-radius:           $border-radius;\r\n$btn-border-radius-sm:        $border-radius-sm;\r\n$btn-border-radius-lg:        $border-radius-lg;\r\n\r\n$btn-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;\r\n\r\n$btn-hover-bg-shade-amount:       15%;\r\n$btn-hover-bg-tint-amount:        15%;\r\n$btn-hover-border-shade-amount:   20%;\r\n$btn-hover-border-tint-amount:    10%;\r\n$btn-active-bg-shade-amount:      20%;\r\n$btn-active-bg-tint-amount:       20%;\r\n$btn-active-border-shade-amount:  25%;\r\n$btn-active-border-tint-amount:   10%;\r\n// scss-docs-end btn-variables\r\n\r\n\r\n// Forms\r\n\r\n// scss-docs-start form-text-variables\r\n$form-text-margin-top:                  .25rem;\r\n$form-text-font-size:                   $small-font-size;\r\n$form-text-font-style:                  null;\r\n$form-text-font-weight:                 null;\r\n$form-text-color:                       $text-muted;\r\n// scss-docs-end form-text-variables\r\n\r\n// scss-docs-start form-label-variables\r\n$form-label-margin-bottom:              .5rem;\r\n$form-label-font-size:                  null;\r\n$form-label-font-style:                 null;\r\n$form-label-font-weight:                800;\r\n$form-label-color:                      null;\r\n// scss-docs-end form-label-variables\r\n\r\n// scss-docs-start form-input-variables\r\n$input-padding-y:                       $input-btn-padding-y;\r\n$input-padding-x:                       $input-btn-padding-x;\r\n$input-font-family:                     $input-btn-font-family;\r\n$input-font-size:                       $input-btn-font-size;\r\n$input-font-weight:                     $font-weight-base;\r\n$input-line-height:                     $input-btn-line-height;\r\n\r\n$input-padding-y-sm:                    $input-btn-padding-y-sm;\r\n$input-padding-x-sm:                    $input-btn-padding-x-sm;\r\n$input-font-size-sm:                    $input-btn-font-size-sm;\r\n\r\n$input-padding-y-lg:                    $input-btn-padding-y-lg;\r\n$input-padding-x-lg:                    $input-btn-padding-x-lg;\r\n$input-font-size-lg:                    $input-btn-font-size-lg;\r\n\r\n$input-bg:                              var(--#{$variable-prefix}input-bg);\r\n$input-disabled-bg:                     var(--#{$variable-prefix}input-disabled-bg);\r\n$input-disabled-border-color:           null;\r\n\r\n$input-color:                           var(--#{$variable-prefix}body-color);\r\n$input-border-color:                    var(--#{$variable-prefix}input-border);\r\n$input-border-width:                    $input-btn-border-width;\r\n$input-box-shadow:                      $box-shadow-inset;\r\n\r\n$input-border-radius:                   $border-radius;\r\n$input-border-radius-sm:                $border-radius-sm;\r\n$input-border-radius-lg:                $border-radius-lg;\r\n\r\n$input-focus-bg:                        $input-bg;\r\n$input-focus-border-color:              var(--#{$variable-prefix}input-focus-border);\r\n$input-focus-color:                     $input-color;\r\n$input-focus-width:                     $input-btn-focus-width;\r\n$input-focus-box-shadow:                $input-btn-focus-box-shadow;\r\n\r\n$input-placeholder-color:               $gray-600;\r\n$input-plaintext-color:                 var(--#{$variable-prefix}body-color);\r\n\r\n$input-height-border:                   $input-border-width * 2;\r\n\r\n$input-height-inner:                    add($input-line-height * 1em, $input-padding-y * 2);\r\n$input-height-inner-half:               add($input-line-height * .5em, $input-padding-y);\r\n$input-height-inner-quarter:            add($input-line-height * .25em, $input-padding-y * .5);\r\n\r\n$input-height:                          add($input-line-height * 1em, add($input-padding-y * 2, $input-height-border, false));\r\n$input-height-sm:                       add($input-line-height * 1em, add($input-padding-y-sm * 2, $input-height-border, false));\r\n$input-height-lg:                       add($input-line-height * 1em, add($input-padding-y-lg * 2, $input-height-border, false));\r\n\r\n$input-transition:                      border-color .15s ease-in-out, box-shadow .15s ease-in-out;\r\n$form-color-width:                      3rem;\r\n// scss-docs-end form-input-variables\r\n\r\n// scss-docs-start form-check-variables\r\n$form-check-input-width:                  1.1em;\r\n$form-check-min-height:                   $font-size-base * $line-height-base;\r\n$form-check-padding-start:                $form-check-input-width + .5em;\r\n$form-check-margin-bottom:                .125rem;\r\n$form-check-label-color:                  null;\r\n$form-check-label-cursor:                 null;\r\n$form-check-transition:                   null;\r\n\r\n$form-check-input-active-filter:          brightness(90%);\r\n\r\n$form-check-input-bg:                     $input-bg;\r\n$form-check-input-border:                 1px solid var(--#{$variable-prefix}input-check-border);\r\n$form-check-input-border-radius:          .25em;\r\n$form-check-radio-border-radius:          50%;\r\n$form-check-input-focus-border:           $input-focus-border-color;\r\n$form-check-input-focus-box-shadow:       $input-btn-focus-box-shadow;\r\n\r\n$form-check-input-checked-color:          $component-active-color;\r\n$form-check-input-checked-bg-color:       $component-active-bg;\r\n$form-check-input-checked-border-color:   $form-check-input-checked-bg-color;\r\n$form-check-input-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-checked-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10l3 3l6-6'/></svg>\");\r\n$form-check-radio-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='2' fill='#{$form-check-input-checked-color}'/></svg>\");\r\n\r\n$form-check-input-indeterminate-color:          $component-active-color;\r\n$form-check-input-indeterminate-bg-color:       $component-active-bg;\r\n$form-check-input-indeterminate-border-color:   $form-check-input-indeterminate-bg-color;\r\n$form-check-input-indeterminate-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-indeterminate-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/></svg>\");\r\n\r\n$form-check-input-disabled-opacity:        .5;\r\n$form-check-label-disabled-opacity:        $form-check-input-disabled-opacity;\r\n$form-check-btn-check-disabled-opacity:    $btn-disabled-opacity;\r\n\r\n$form-check-inline-margin-end:    1rem;\r\n// scss-docs-end form-check-variables\r\n\r\n// scss-docs-start form-switch-variables\r\n$form-switch-color:               rgba(0, 0, 0, .25);\r\n$form-switch-width:               2em;\r\n$form-switch-padding-start:       $form-switch-width + .5em;\r\n$form-switch-bg-image:            url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-color}'/></svg>\");\r\n$form-switch-border-radius:       $form-switch-width;\r\n$form-switch-transition:          background-position .15s ease-in-out;\r\n\r\n$form-switch-focus-color:         tint-color($component-active-bg, 50%);\r\n$form-switch-focus-bg-image:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-focus-color}'/></svg>\");\r\n\r\n$form-switch-checked-color:       $component-active-color;\r\n$form-switch-checked-bg-image:    url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-checked-color}'/></svg>\");\r\n$form-switch-checked-bg-position: right center;\r\n// scss-docs-end form-switch-variables\r\n\r\n// scss-docs-start input-group-variables\r\n$input-group-addon-padding-y:           $input-padding-y;\r\n$input-group-addon-padding-x:           $input-padding-x;\r\n$input-group-addon-font-weight:         $input-font-weight;\r\n$input-group-addon-color:               $input-color;\r\n$input-group-addon-bg:                  var(--#{$variable-prefix}input-group-addon-bg);\r\n$input-group-addon-border-color:        $input-border-color;\r\n// scss-docs-end input-group-variables\r\n\r\n// scss-docs-start form-select-variables\r\n$form-select-padding-y:             $input-padding-y;\r\n$form-select-padding-x:             $input-padding-x;\r\n$form-select-font-family:           $input-font-family;\r\n$form-select-font-size:             $input-font-size;\r\n$form-select-indicator-padding:     $form-select-padding-x * 3; // Extra padding for background-image\r\n$form-select-font-weight:           $input-font-weight;\r\n$form-select-line-height:           $input-line-height;\r\n$form-select-color:                 $input-color;\r\n$form-select-bg:                    $input-bg;\r\n$form-select-disabled-color:        null;\r\n$form-select-disabled-bg:           $input-disabled-bg;\r\n$form-select-disabled-border-color: $input-disabled-border-color;\r\n$form-select-bg-position:           right $form-select-padding-x center;\r\n$form-select-bg-size:               16px 12px; // In pixels because image dimensions\r\n$form-select-indicator-color:       $gray-800;\r\n$form-select-indicator:             url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path fill='none' stroke='#{$form-select-indicator-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/></svg>\");\r\n\r\n$form-select-feedback-icon-padding-end: $form-select-padding-x * 2.5 + $form-select-indicator-padding;\r\n$form-select-feedback-icon-position:    center right $form-select-indicator-padding;\r\n$form-select-feedback-icon-size:        $input-height-inner-half $input-height-inner-half;\r\n\r\n$form-select-border-width:        $input-border-width;\r\n$form-select-border-color:        $input-border-color;\r\n$form-select-border-radius:       $border-radius;\r\n$form-select-box-shadow:          $box-shadow-inset;\r\n\r\n$form-select-focus-border-color:  $input-focus-border-color;\r\n$form-select-focus-width:         $input-focus-width;\r\n$form-select-focus-box-shadow:    0 0 0 $form-select-focus-width $input-btn-focus-color;\r\n\r\n$form-select-padding-y-sm:        $input-padding-y-sm;\r\n$form-select-padding-x-sm:        $input-padding-x-sm;\r\n$form-select-font-size-sm:        $input-font-size-sm;\r\n\r\n$form-select-padding-y-lg:        $input-padding-y-lg;\r\n$form-select-padding-x-lg:        $input-padding-x-lg;\r\n$form-select-font-size-lg:        $input-font-size-lg;\r\n\r\n$form-select-transition:          $input-transition;\r\n// scss-docs-end form-select-variables\r\n\r\n// scss-docs-start form-range-variables\r\n$form-range-track-width:          100%;\r\n$form-range-track-height:         .5rem;\r\n$form-range-track-cursor:         pointer;\r\n$form-range-track-bg:             var(--#{$variable-prefix}gray-300);\r\n$form-range-track-border-radius:  1rem;\r\n$form-range-track-box-shadow:     $box-shadow-inset;\r\n\r\n$form-range-thumb-width:                   1rem;\r\n$form-range-thumb-height:                  $form-range-thumb-width;\r\n$form-range-thumb-bg:                      $component-active-bg;\r\n$form-range-thumb-border:                  0;\r\n$form-range-thumb-border-radius:           1rem;\r\n$form-range-thumb-box-shadow:              0 .1rem .25rem rgba($black, .1);\r\n$form-range-thumb-focus-box-shadow:        0 0 0 1px $body-bg, $input-focus-box-shadow;\r\n$form-range-thumb-focus-box-shadow-width:  $input-focus-width; // For focus box shadow issue in Edge\r\n$form-range-thumb-active-bg:               tint-color($component-active-bg, 70%);\r\n$form-range-thumb-disabled-bg:             $gray-500;\r\n$form-range-thumb-transition:              background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;\r\n// scss-docs-end form-range-variables\r\n\r\n// scss-docs-start form-file-variables\r\n$form-file-button-color:          $input-color;\r\n$form-file-button-bg:             $input-group-addon-bg;\r\n$form-file-button-hover-bg:       $input-group-addon-bg;\r\n// scss-docs-end form-file-variables\r\n\r\n// scss-docs-start form-floating-variables\r\n$form-floating-height:            add(3.5rem, $input-height-border);\r\n$form-floating-line-height:       1.25;\r\n$form-floating-padding-x:         $input-padding-x;\r\n$form-floating-padding-y:         1rem;\r\n$form-floating-input-padding-t:   1.625rem;\r\n$form-floating-input-padding-b:   .625rem;\r\n$form-floating-label-opacity:     .65;\r\n$form-floating-label-transform:   scale(.85) translateY(-.5rem) translateX(.15rem);\r\n$form-floating-transition:        opacity .1s ease-in-out, transform .1s ease-in-out;\r\n// scss-docs-end form-floating-variables\r\n\r\n// Form validation\r\n\r\n// scss-docs-start form-feedback-variables\r\n$form-feedback-margin-top:          $form-text-margin-top;\r\n$form-feedback-font-size:           $form-text-font-size;\r\n$form-feedback-font-style:          $form-text-font-style;\r\n$form-feedback-valid-color:         $success;\r\n$form-feedback-invalid-color:       $danger;\r\n\r\n$form-feedback-icon-valid-color:    $form-feedback-valid-color;\r\n$form-feedback-icon-valid:          url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'><path fill='#{$form-feedback-icon-valid-color}' d='M2.3 6.73L.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/></svg>\");\r\n$form-feedback-icon-invalid-color:  $form-feedback-invalid-color;\r\n$form-feedback-icon-invalid:        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='#{$form-feedback-icon-invalid-color}'><circle cx='6' cy='6' r='4.5'/><path stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/><circle cx='6' cy='8.2' r='.6' fill='#{$form-feedback-icon-invalid-color}' stroke='none'/></svg>\");\r\n// scss-docs-end form-feedback-variables\r\n\r\n// scss-docs-start form-validation-states\r\n$form-validation-states: (\r\n  \"valid\": (\r\n    \"color\": $form-feedback-valid-color,\r\n    \"icon\": $form-feedback-icon-valid\r\n  ),\r\n  \"invalid\": (\r\n    \"color\": $form-feedback-invalid-color,\r\n    \"icon\": $form-feedback-icon-invalid\r\n  )\r\n);\r\n// scss-docs-end form-validation-states\r\n\r\n// Z-index master list\r\n//\r\n// Warning: Avoid customizing these values. They're used for a bird's eye view\r\n// of components dependent on the z-axis and are designed to all work together.\r\n\r\n// scss-docs-start zindex-stack\r\n$zindex-dropdown:                   1000;\r\n$zindex-sticky:                     1020;\r\n$zindex-fixed:                      1030;\r\n$zindex-offcanvas-backdrop:         1040;\r\n$zindex-offcanvas:                  1045;\r\n$zindex-modal-backdrop:             1050;\r\n$zindex-modal:                      1055;\r\n$zindex-popover:                    1070;\r\n$zindex-tooltip:                    1080;\r\n// scss-docs-end zindex-stack\r\n\r\n\r\n// Navs\r\n\r\n// scss-docs-start nav-variables\r\n$nav-link-padding-y:                .5rem;\r\n$nav-link-padding-x:                1rem;\r\n$nav-link-font-size:                null;\r\n$nav-link-font-weight:              null;\r\n$nav-link-color:                    $link-color;\r\n$nav-link-hover-color:              $link-hover-color;\r\n$nav-link-transition:               color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out;\r\n$nav-link-disabled-color:           $gray-600;\r\n\r\n$nav-tabs-border-color:             var(--#{$variable-prefix}gray-300);\r\n$nav-tabs-border-width:             $border-width;\r\n$nav-tabs-border-radius:            $border-radius;\r\n$nav-tabs-link-hover-border-color:  var(--#{$variable-prefix}gray-300) var(--#{$variable-prefix}gray-300) $nav-tabs-border-color;\r\n$nav-tabs-link-active-color:        var(--#{$variable-prefix}nav-tabs-link-active-color);\r\n$nav-tabs-link-active-bg:           var(--#{$variable-prefix}nav-tabs-link-active-bg);\r\n$nav-tabs-link-active-border-color: var(--#{$variable-prefix}gray-300) var(--#{$variable-prefix}gray-300) $nav-tabs-link-active-bg;\r\n\r\n$nav-pills-border-radius:           $border-radius;\r\n$nav-pills-link-active-color:       $component-active-color;\r\n$nav-pills-link-active-bg:          $component-active-bg;\r\n// scss-docs-end nav-variables\r\n\r\n\r\n// Navbar\r\n\r\n// scss-docs-start navbar-variables\r\n$navbar-padding-y:                  $spacer * .5;\r\n$navbar-padding-x:                  null;\r\n\r\n$navbar-nav-link-padding-x:         .5rem;\r\n\r\n$navbar-brand-font-size:            $font-size-lg;\r\n// Compute the navbar-brand padding-y so the navbar-brand will have the same height as navbar-text and nav-link\r\n$nav-link-height:                   $font-size-base * $line-height-base + $nav-link-padding-y * 2;\r\n$navbar-brand-height:               $navbar-brand-font-size * $line-height-base;\r\n$navbar-brand-padding-y:            ($nav-link-height - $navbar-brand-height) * .5;\r\n$navbar-brand-margin-end:           1rem;\r\n\r\n$navbar-toggler-padding-y:          .25rem;\r\n$navbar-toggler-padding-x:          .75rem;\r\n$navbar-toggler-font-size:          $font-size-lg;\r\n$navbar-toggler-border-radius:      $btn-border-radius;\r\n$navbar-toggler-focus-width:        $btn-focus-width;\r\n$navbar-toggler-transition:         box-shadow .15s ease-in-out;\r\n// scss-docs-end navbar-variables\r\n\r\n// scss-docs-start navbar-theme-variables\r\n$navbar-dark-color:                 rgba($white, .55);\r\n$navbar-dark-hover-color:           rgba($white, .75);\r\n$navbar-dark-active-color:          $white;\r\n$navbar-dark-disabled-color:        rgba($white, .25);\r\n$navbar-dark-toggler-icon-bg:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-dark-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\");\r\n$navbar-dark-toggler-border-color:  rgba($white, .1);\r\n\r\n$navbar-light-color:                rgba($black, .55);\r\n$navbar-light-hover-color:          rgba($black, .7);\r\n$navbar-light-active-color:         rgba($black, .9);\r\n$navbar-light-disabled-color:       rgba($black, .3);\r\n$navbar-light-toggler-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-light-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\");\r\n$navbar-light-toggler-border-color: rgba($black, .1);\r\n\r\n$navbar-light-brand-color:                $navbar-light-active-color;\r\n$navbar-light-brand-hover-color:          $navbar-light-active-color;\r\n$navbar-dark-brand-color:                 $navbar-dark-active-color;\r\n$navbar-dark-brand-hover-color:           $navbar-dark-active-color;\r\n// scss-docs-end navbar-theme-variables\r\n\r\n\r\n// Dropdowns\r\n//\r\n// Dropdown menu container and contents.\r\n\r\n// scss-docs-start dropdown-variables\r\n$dropdown-min-width:                10rem;\r\n$dropdown-padding-x:                0;\r\n$dropdown-padding-y:                .5rem;\r\n$dropdown-spacer:                   .125rem;\r\n$dropdown-font-size:                $font-size-base;\r\n$dropdown-color:                    var(--#{$variable-prefix}body-color);\r\n$dropdown-bg:                       var(--#{$variable-prefix}dropdown-bg);\r\n$dropdown-border-color:             var(--#{$variable-prefix}border-color);\r\n$dropdown-border-radius:            $border-radius-lg;\r\n$dropdown-border-width:             var(--#{$variable-prefix}dropdown-border-width);\r\n$dropdown-inner-border-radius:      subtract($dropdown-border-radius, $dropdown-border-width);\r\n$dropdown-divider-bg:               $dropdown-border-color;\r\n$dropdown-divider-margin-y:         $spacer * .5;\r\n$dropdown-box-shadow:               $box-shadow-lg;\r\n\r\n$dropdown-link-color:               var(--#{$variable-prefix}dropdown-link-color);\r\n$dropdown-link-hover-color:         var(--#{$variable-prefix}dropdown-link-hover-color);\r\n$dropdown-link-hover-bg:            var(--#{$variable-prefix}dropdown-link-hover-bg);\r\n\r\n$dropdown-link-active-color:        var(--#{$variable-prefix}dropdown-link-hover-color);\r\n$dropdown-link-active-bg:           var(--#{$variable-prefix}dropdown-link-hover-bg);\r\n\r\n$dropdown-link-disabled-color:      $gray-500;\r\n\r\n$dropdown-item-padding-y:           0.35rem;\r\n$dropdown-item-padding-x:           1.2rem;\r\n\r\n$dropdown-header-color:             $gray-600;\r\n$dropdown-header-padding:           $dropdown-padding-y $dropdown-item-padding-x;\r\n// scss-docs-end dropdown-variables\r\n\r\n// scss-docs-start dropdown-dark-variables\r\n$dropdown-dark-color:               $gray-300;\r\n$dropdown-dark-bg:                  $gray-800;\r\n$dropdown-dark-border-color:        $dropdown-border-color;\r\n$dropdown-dark-divider-bg:          $dropdown-divider-bg;\r\n$dropdown-dark-box-shadow:          null;\r\n$dropdown-dark-link-color:          $dropdown-dark-color;\r\n$dropdown-dark-link-hover-color:    $white;\r\n$dropdown-dark-link-hover-bg:       rgba($white, .15);\r\n$dropdown-dark-link-active-color:   $white;\r\n$dropdown-dark-link-active-bg:      lighten($dropdown-dark-bg, 5%);\r\n$dropdown-dark-link-disabled-color: $gray-500;\r\n$dropdown-dark-header-color:        $gray-500;\r\n// scss-docs-end dropdown-dark-variables\r\n\r\n\r\n// Pagination\r\n\r\n// scss-docs-start pagination-variables\r\n$pagination-padding-y:              .375rem;\r\n$pagination-padding-x:              .75rem;\r\n$pagination-padding-y-sm:           .25rem;\r\n$pagination-padding-x-sm:           .5rem;\r\n$pagination-padding-y-lg:           .6rem;\r\n$pagination-padding-x-lg:           1.2rem;\r\n\r\n$pagination-color:                  $link-color;\r\n$pagination-bg:                     var(--#{$variable-prefix}card-bg);\r\n$pagination-border-width:           $border-width;\r\n$pagination-border-radius:          $border-radius;\r\n$pagination-margin-start:           -$pagination-border-width;\r\n$pagination-border-color:           var(--#{$variable-prefix}border-color);\r\n\r\n$pagination-focus-color:            $link-hover-color;\r\n$pagination-focus-bg:               var(--#{$variable-prefix}pagination-hover-bg);\r\n$pagination-focus-box-shadow:       $input-btn-focus-box-shadow;\r\n$pagination-focus-outline:          0;\r\n\r\n$pagination-hover-color:            $link-hover-color;\r\n$pagination-hover-bg:               var(--#{$variable-prefix}pagination-hover-bg);\r\n$pagination-hover-border-color:     var(--#{$variable-prefix}border-color);\r\n\r\n$pagination-active-color:           $component-active-color;\r\n$pagination-active-bg:              $component-active-bg;\r\n$pagination-active-border-color:    $pagination-active-bg;\r\n\r\n$pagination-disabled-color:         $gray-600;\r\n$pagination-disabled-bg:            $pagination-bg;\r\n$pagination-disabled-border-color:  $pagination-border-color;\r\n\r\n$pagination-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out;\r\n\r\n$pagination-border-radius-sm:       $border-radius-sm;\r\n$pagination-border-radius-lg:       $border-radius-lg;\r\n// scss-docs-end pagination-variables\r\n\r\n\r\n// Placeholders\r\n\r\n// scss-docs-start placeholders\r\n$placeholder-opacity-max:           .5;\r\n$placeholder-opacity-min:           .2;\r\n// scss-docs-end placeholders\r\n\r\n// Cards\r\n\r\n// scss-docs-start card-variables\r\n$card-spacer-y:                     $spacer;\r\n$card-spacer-x:                     $spacer;\r\n$card-title-spacer-y:               $spacer * .5;\r\n$card-border-width:                 0;\r\n$card-border-color:                 rgba($black, .125);\r\n$card-border-radius:                $border-radius;\r\n$card-box-shadow:                   $box-shadow;\r\n$card-inner-border-radius:          subtract($card-border-radius, $card-border-width);\r\n$card-cap-padding-y:                $card-spacer-y;\r\n$card-cap-padding-x:                $card-spacer-x;\r\n$card-cap-bg:                       var(--#{$variable-prefix}card-cap-bg);\r\n$card-cap-color:                    null;\r\n$card-height:                       null;\r\n$card-color:                        null;\r\n$card-bg:                           var(--#{$variable-prefix}card-bg);\r\n$card-img-overlay-padding:          $spacer;\r\n$card-group-margin:                 $grid-gutter-width * .5;\r\n// scss-docs-end card-variables\r\n\r\n// Accordion\r\n\r\n// scss-docs-start accordion-variables\r\n$accordion-padding-y:                     1rem;\r\n$accordion-padding-x:                     1.25rem;\r\n$accordion-color:                         var(--#{$variable-prefix}body-color);\r\n$accordion-bg:                            var(--#{$variable-prefix}card-bg);\r\n$accordion-border-width:                  $border-width;\r\n$accordion-border-color:                  var(--#{$variable-prefix}border-color);\r\n$accordion-border-radius:                 $border-radius;\r\n$accordion-inner-border-radius:           subtract($accordion-border-radius, $accordion-border-width);\r\n\r\n$accordion-body-padding-y:                $accordion-padding-y;\r\n$accordion-body-padding-x:                $accordion-padding-x;\r\n\r\n$accordion-button-padding-y:              $accordion-padding-y;\r\n$accordion-button-padding-x:              $accordion-padding-x;\r\n$accordion-button-color:                  $accordion-color;\r\n$accordion-button-bg:                     $accordion-bg;\r\n$accordion-transition:                    $btn-transition, border-radius .15s ease;\r\n$accordion-button-active-bg:              rgba($component-active-bg, 0.05);\r\n$accordion-button-active-color:           shade-color($primary, 10%);\r\n\r\n$accordion-button-focus-border-color:     $input-focus-border-color;\r\n$accordion-button-focus-box-shadow:       inset 0 ($accordion-border-width * -1) 0 $accordion-border-color;\r\n\r\n$accordion-icon-width:                    0.75rem;\r\n$accordion-icon-color:                    $accordion-color;\r\n$accordion-icon-active-color:             $accordion-button-active-color;\r\n$accordion-icon-transition:               transform .2s ease-in-out;\r\n$accordion-icon-transform:                rotate(-180deg);\r\n\r\n$accordion-button-icon:         url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$accordion-icon-color}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\");\r\n$accordion-button-active-icon:  url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$accordion-icon-active-color}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\");\r\n// scss-docs-end accordion-variables\r\n\r\n// Tooltips\r\n\r\n// scss-docs-start tooltip-variables\r\n$tooltip-font-size:                 $font-size-sm;\r\n$tooltip-max-width:                 200px;\r\n$tooltip-color:                     $white;\r\n$tooltip-bg:                        $black;\r\n$tooltip-border-radius:             $border-radius-sm;\r\n$tooltip-opacity:                   .9;\r\n$tooltip-padding-y:                 $spacer * .4;\r\n$tooltip-padding-x:                 $spacer * .7;\r\n$tooltip-margin:                    0;\r\n\r\n$tooltip-arrow-width:               .8rem;\r\n$tooltip-arrow-height:              .4rem;\r\n$tooltip-arrow-color:               $tooltip-bg;\r\n// scss-docs-end tooltip-variables\r\n\r\n// Form tooltips must come after regular tooltips\r\n// scss-docs-start tooltip-feedback-variables\r\n$form-feedback-tooltip-padding-y:     $tooltip-padding-y;\r\n$form-feedback-tooltip-padding-x:     $tooltip-padding-x;\r\n$form-feedback-tooltip-font-size:     $tooltip-font-size;\r\n$form-feedback-tooltip-line-height:   null;\r\n$form-feedback-tooltip-opacity:       $tooltip-opacity;\r\n$form-feedback-tooltip-border-radius: $tooltip-border-radius;\r\n// scss-docs-end tooltip-feedback-variables\r\n\r\n\r\n// Popovers\r\n\r\n// scss-docs-start popover-variables\r\n$popover-font-size:                 $font-size-base;\r\n$popover-bg:                        var(--#{$variable-prefix}popover-bg);\r\n$popover-max-width:                 276px;\r\n$popover-border-width:              $border-width;\r\n$popover-border-color:              var(--#{$variable-prefix}border-color);\r\n$popover-border-radius:             $border-radius;\r\n$popover-inner-border-radius:       subtract($popover-border-radius, $popover-border-width);\r\n$popover-box-shadow:                $box-shadow-lg;\r\n\r\n$popover-header-bg:                 $popover-bg;\r\n$popover-header-color:              $headings-color;\r\n$popover-header-padding-y:          .7rem;\r\n$popover-header-padding-x:          $spacer;\r\n\r\n$popover-body-color:                var(--#{$variable-prefix}body-color);\r\n$popover-body-padding-y:            $spacer;\r\n$popover-body-padding-x:            $spacer;\r\n\r\n$popover-arrow-width:               1rem;\r\n$popover-arrow-height:              .5rem;\r\n$popover-arrow-color:               $popover-bg;\r\n\r\n$popover-arrow-outer-color:         var(--#{$variable-prefix}border-color);;\r\n// scss-docs-end popover-variables\r\n\r\n\r\n// Toasts\r\n\r\n// scss-docs-start toast-variables\r\n$toast-max-width:                   350px;\r\n$toast-padding-x:                   .75rem;\r\n$toast-padding-y:                   .5rem;\r\n$toast-font-size:                   .875rem;\r\n$toast-color:                       null;\r\n$toast-background-color:            var(--#{$variable-prefix}toast-background-color);\r\n$toast-border-width:                1px;\r\n$toast-border-color:                var(--#{$variable-prefix}toast-border-color);\r\n$toast-border-radius:               $border-radius;\r\n$toast-box-shadow:                  $box-shadow;\r\n$toast-spacing:                     $container-padding-x;\r\n\r\n$toast-header-color:                $gray-600;\r\n$toast-header-background-color:     var(--#{$variable-prefix}toast-background-color);\r\n$toast-header-border-color:         var(--#{$variable-prefix}toast-header-border-color);\r\n// scss-docs-end toast-variables\r\n\r\n\r\n// Badges\r\n\r\n// scss-docs-start badge-variables\r\n$badge-font-size:                   .75em;\r\n$badge-font-weight:                 $font-weight-semibold;\r\n$badge-color:                       $white;\r\n$badge-padding-y:                   .35em;\r\n$badge-padding-x:                   .65em;\r\n$badge-border-radius:               $border-radius;\r\n// scss-docs-end badge-variables\r\n\r\n\r\n// Modals\r\n\r\n// scss-docs-start modal-variables\r\n$modal-inner-padding:               $spacer * 1.25;\r\n\r\n$modal-footer-margin-between:       .5rem;\r\n\r\n$modal-dialog-margin:               .5rem;\r\n$modal-dialog-margin-y-sm-up:       1.75rem;\r\n\r\n$modal-title-line-height:           $line-height-base;\r\n\r\n$modal-content-color:               null;\r\n$modal-content-bg:                  var(--#{$variable-prefix}modal-bg);\r\n$modal-content-border-color:        $border-color;\r\n$modal-content-border-width:        $border-width;\r\n$modal-content-border-radius:       $border-radius-lg;\r\n$modal-content-inner-border-radius: subtract($modal-content-border-radius, $modal-content-border-width);\r\n$modal-content-box-shadow-xs:       $box-shadow-sm;\r\n$modal-content-box-shadow-sm-up:    $box-shadow;\r\n\r\n$modal-backdrop-bg:                 $black;\r\n$modal-backdrop-opacity:            .5;\r\n$modal-header-border-color:         $border-color;\r\n$modal-footer-border-color:         $modal-header-border-color;\r\n$modal-header-border-width:         0;\r\n$modal-footer-border-width:         $modal-header-border-width;\r\n$modal-header-padding-y:            $modal-inner-padding;\r\n$modal-header-padding-x:            $modal-inner-padding;\r\n$modal-header-padding:              $modal-header-padding-y $modal-header-padding-x; // Keep this for backwards compatibility\r\n\r\n$modal-sm:                          300px;\r\n$modal-md:                          500px;\r\n$modal-lg:                          800px;\r\n$modal-xl:                          1140px;\r\n\r\n$modal-fade-transform:              translate(0, -50px);\r\n$modal-show-transform:              none;\r\n$modal-transition:                  transform .3s ease-out;\r\n$modal-scale-transform:             scale(1.02);\r\n// scss-docs-end modal-variables\r\n\r\n\r\n// Alerts\r\n//\r\n// Define alert colors, border radius, and padding.\r\n\r\n// scss-docs-start alert-variables\r\n$alert-padding-y:               $spacer * 0.8;\r\n$alert-padding-x:               $spacer;\r\n$alert-margin-bottom:           1rem;\r\n$alert-border-radius:           $border-radius;\r\n$alert-link-font-weight:        $font-weight-semibold;\r\n$alert-border-width:            $border-width;\r\n$alert-bg-scale:                -85%;\r\n$alert-border-scale:            -70%;\r\n$alert-color-scale:             25%;\r\n$alert-dismissible-padding-r:   $alert-padding-x * 3; // 3x covers width of x plus default padding on either side\r\n// scss-docs-end alert-variables\r\n\r\n\r\n// Progress bars\r\n\r\n// scss-docs-start progress-variables\r\n$progress-height:                   0.625rem;\r\n$progress-font-size:                $font-size-base * .75;\r\n$progress-bg:                       var(--#{$variable-prefix}progress-bg);;\r\n$progress-border-radius:            $border-radius;\r\n$progress-box-shadow:               $box-shadow-inset;\r\n$progress-bar-color:                $white;\r\n$progress-bar-bg:                   $primary;\r\n$progress-bar-animation-timing:     1s linear infinite;\r\n$progress-bar-transition:           width .6s ease;\r\n// scss-docs-end progress-variables\r\n\r\n\r\n// List group\r\n\r\n// scss-docs-start list-group-variables\r\n$list-group-color:                  var(--#{$variable-prefix}body-color);\r\n$list-group-bg:                     var(--#{$variable-prefix}card-bg);\r\n$list-group-border-color:           var(--#{$variable-prefix}border-color);\r\n$list-group-border-width:           $border-width;\r\n$list-group-border-radius:          $border-radius;\r\n\r\n$list-group-item-padding-y:         $spacer * .7;\r\n$list-group-item-padding-x:         $spacer;\r\n$list-group-item-bg-scale:          -80%;\r\n$list-group-item-color-scale:       40%;\r\n\r\n$list-group-hover-bg:               var(--#{$variable-prefix}list-group-hover-bg);\r\n$list-group-active-color:           $component-active-color;\r\n$list-group-active-bg:              $component-active-bg;\r\n$list-group-active-border-color:    $list-group-active-bg;\r\n\r\n$list-group-disabled-color:         $gray-600;\r\n$list-group-disabled-bg:            $list-group-bg;\r\n\r\n$list-group-action-color:           var(--#{$variable-prefix}body-color);\r\n$list-group-action-hover-color:     $list-group-action-color;\r\n\r\n$list-group-action-active-color:    var(--#{$variable-prefix}body-color);\r\n$list-group-action-active-bg:       var(--#{$variable-prefix}list-group-hover-bg);;\r\n// scss-docs-end list-group-variables\r\n\r\n\r\n// Image thumbnails\r\n\r\n// scss-docs-start thumbnail-variables\r\n$thumbnail-padding:                 .25rem;\r\n$thumbnail-bg:                      var(--#{$variable-prefix}body-bg);\r\n$thumbnail-border-width:            $border-width;\r\n$thumbnail-border-color:            var(--#{$variable-prefix}border-color);\r\n$thumbnail-border-radius:           $border-radius;\r\n$thumbnail-box-shadow:              $box-shadow-sm;\r\n// scss-docs-end thumbnail-variables\r\n\r\n\r\n// Figures\r\n\r\n// scss-docs-start figure-variables\r\n$figure-caption-font-size:          $small-font-size;\r\n$figure-caption-color:              $gray-600;\r\n// scss-docs-end figure-variables\r\n\r\n\r\n// Breadcrumbs\r\n\r\n// scss-docs-start breadcrumb-variables\r\n$breadcrumb-font-size:              null;\r\n$breadcrumb-padding-y:              0;\r\n$breadcrumb-padding-x:              0;\r\n$breadcrumb-item-padding-x:         .5rem;\r\n$breadcrumb-margin-bottom:          1rem;\r\n$breadcrumb-bg:                     null;\r\n$breadcrumb-divider-color:          $gray-600;\r\n$breadcrumb-active-color:           $gray-600;\r\n$breadcrumb-divider:                quote(\"\\F0142\");\r\n$breadcrumb-divider-flipped:        $breadcrumb-divider;\r\n$breadcrumb-border-radius:          null;\r\n// scss-docs-end breadcrumb-variables\r\n\r\n// Carousel\r\n\r\n// scss-docs-start carousel-variables\r\n$carousel-control-color:             $white;\r\n$carousel-control-width:             15%;\r\n$carousel-control-opacity:           .5;\r\n$carousel-control-hover-opacity:     .9;\r\n$carousel-control-transition:        opacity .15s ease;\r\n\r\n$carousel-indicator-width:           30px;\r\n$carousel-indicator-height:          3px;\r\n$carousel-indicator-hit-area-height: 10px;\r\n$carousel-indicator-spacer:          3px;\r\n$carousel-indicator-opacity:         .5;\r\n$carousel-indicator-active-bg:       $white;\r\n$carousel-indicator-active-opacity:  1;\r\n$carousel-indicator-transition:      opacity .6s ease;\r\n\r\n$carousel-caption-width:             70%;\r\n$carousel-caption-color:             $white;\r\n$carousel-caption-padding-y:         1.25rem;\r\n$carousel-caption-spacer:            1.25rem;\r\n\r\n$carousel-control-icon-width:        2rem;\r\n\r\n$carousel-control-prev-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/></svg>\");\r\n$carousel-control-next-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/></svg>\");\r\n\r\n$carousel-transition-duration:       .6s;\r\n$carousel-transition:                transform $carousel-transition-duration ease-in-out; // Define transform transition first if using multiple transitions (e.g., `transform 2s ease, opacity .5s ease-out`)\r\n\r\n$carousel-dark-indicator-active-bg:  $black;\r\n$carousel-dark-caption-color:        $black;\r\n$carousel-dark-control-icon-filter:  invert(1) grayscale(100);\r\n// scss-docs-end carousel-variables\r\n\r\n\r\n// Spinners\r\n\r\n// scss-docs-start spinner-variables\r\n$spinner-width:           2rem;\r\n$spinner-height:          $spinner-width;\r\n$spinner-vertical-align:  -.125em;\r\n$spinner-border-width:    .25em;\r\n$spinner-animation-speed: .75s;\r\n\r\n$spinner-width-sm:        1rem;\r\n$spinner-height-sm:       $spinner-width-sm;\r\n$spinner-border-width-sm: .2em;\r\n// scss-docs-end spinner-variables\r\n\r\n\r\n// Close\r\n\r\n// scss-docs-start close-variables\r\n$btn-close-width:            1em;\r\n$btn-close-height:           $btn-close-width;\r\n$btn-close-padding-x:        .25em;\r\n$btn-close-padding-y:        $btn-close-padding-x;\r\n$btn-close-color:            $black;\r\n$btn-close-bg:               url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$btn-close-color}'><path d='M.293.293a1 1 0 011.414 0L8 6.586 14.293.293a1 1 0 111.414 1.414L9.414 8l6.293 6.293a1 1 0 01-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 01-1.414-1.414L6.586 8 .293 1.707a1 1 0 010-1.414z'/></svg>\");\r\n$btn-close-focus-shadow:     $input-btn-focus-box-shadow;\r\n$btn-close-opacity:          .5;\r\n$btn-close-hover-opacity:    .75;\r\n$btn-close-focus-opacity:    1;\r\n$btn-close-disabled-opacity: .25;\r\n$btn-close-white-filter:     invert(1) grayscale(100%) brightness(200%);\r\n// scss-docs-end close-variables\r\n\r\n\r\n// Offcanvas\r\n\r\n// scss-docs-start offcanvas-variables\r\n$offcanvas-padding-y:               $modal-inner-padding;\r\n$offcanvas-padding-x:               $modal-inner-padding;\r\n$offcanvas-horizontal-width:        400px;\r\n$offcanvas-vertical-height:         30vh;\r\n$offcanvas-transition-duration:     .3s;\r\n$offcanvas-border-color:            $modal-content-border-color;\r\n$offcanvas-border-width:            $modal-content-border-width;\r\n$offcanvas-title-line-height:       $modal-title-line-height;\r\n$offcanvas-bg-color:                $modal-content-bg;\r\n$offcanvas-color:                   $modal-content-color;\r\n$offcanvas-box-shadow:              $modal-content-box-shadow-xs;\r\n$offcanvas-backdrop-bg:             $modal-backdrop-bg;\r\n$offcanvas-backdrop-opacity:        $modal-backdrop-opacity;\r\n// scss-docs-end offcanvas-variables\r\n\r\n// Code\r\n\r\n$code-font-size:                    $small-font-size;\r\n$code-color:                        $pink;\r\n\r\n$kbd-padding-y:                     .2rem;\r\n$kbd-padding-x:                     .4rem;\r\n$kbd-font-size:                     $code-font-size;\r\n$kbd-color:                         $white;\r\n$kbd-bg:                            $gray-900;\r\n\r\n$pre-color:                         null;\r\n","// stylelint-disable property-disallowed-list\n// Single side border-radius\n\n// Helper function to replace negative values with 0\n@function valid-radius($radius) {\n  $return: ();\n  @each $value in $radius {\n    @if type-of($value) == number {\n      $return: append($return, max($value, 0));\n    } @else {\n      $return: append($return, $value);\n    }\n  }\n  @return $return;\n}\n\n// scss-docs-start border-radius-mixins\n@mixin border-radius($radius: $border-radius, $fallback-border-radius: false) {\n  @if $enable-rounded {\n    border-radius: valid-radius($radius);\n  }\n  @else if $fallback-border-radius != false {\n    border-radius: $fallback-border-radius;\n  }\n}\n\n@mixin border-top-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-left-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-top-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-top-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-end-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-right-radius: valid-radius($radius);\n  }\n}\n\n@mixin border-bottom-start-radius($radius: $border-radius) {\n  @if $enable-rounded {\n    border-bottom-left-radius: valid-radius($radius);\n  }\n}\n// scss-docs-end border-radius-mixins\n","//\n// Headings\n//\n.h1 {\n  @extend h1;\n}\n\n.h2 {\n  @extend h2;\n}\n\n.h3 {\n  @extend h3;\n}\n\n.h4 {\n  @extend h4;\n}\n\n.h5 {\n  @extend h5;\n}\n\n.h6 {\n  @extend h6;\n}\n\n\n.lead {\n  @include font-size($lead-font-size);\n  font-weight: $lead-font-weight;\n}\n\n// Type display classes\n@each $display, $font-size in $display-font-sizes {\n  .display-#{$display} {\n    @include font-size($font-size);\n    font-family: $display-font-family;\n    font-style: $display-font-style;\n    font-weight: $display-font-weight;\n    line-height: $display-line-height;\n  }\n}\n\n//\n// Emphasis\n//\n.small {\n  @extend small;\n}\n\n.mark {\n  @extend mark;\n}\n\n//\n// Lists\n//\n\n.list-unstyled {\n  @include list-unstyled();\n}\n\n// Inline turns list items into inline-block\n.list-inline {\n  @include list-unstyled();\n}\n.list-inline-item {\n  display: inline-block;\n\n  &:not(:last-child) {\n    margin-right: $list-inline-padding;\n  }\n}\n\n\n//\n// Misc\n//\n\n// Builds on `abbr`\n.initialism {\n  @include font-size($initialism-font-size);\n  text-transform: uppercase;\n}\n\n// Blockquotes\n.blockquote {\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-font-size);\n\n  > :last-child {\n    margin-bottom: 0;\n  }\n}\n\n.blockquote-footer {\n  margin-top: -$blockquote-margin-y;\n  margin-bottom: $blockquote-margin-y;\n  @include font-size($blockquote-footer-font-size);\n  color: $blockquote-footer-color;\n\n  &::before {\n    content: \"\\2014\\00A0\"; // em dash, nbsp\n  }\n}\n","// Lists\n\n// Unstyled keeps list items block level, just removes default browser padding and list-style\n@mixin list-unstyled {\n  padding-left: 0;\n  list-style: none;\n}\n","// Responsive images (ensure images don't scale beyond their parents)\n//\n// This is purposefully opt-in via an explicit class rather than being the default for all `<img>`s.\n// We previously tried the \"images are responsive by default\" approach in Bootstrap v2,\n// and abandoned it in Bootstrap v3 because it breaks lots of third-party widgets (including Google Maps)\n// which weren't expecting the images within themselves to be involuntarily resized.\n// See also https://github.com/twbs/bootstrap/issues/18178\n.img-fluid {\n  @include img-fluid();\n}\n\n\n// Image thumbnails\n.img-thumbnail {\n  padding: $thumbnail-padding;\n  background-color: $thumbnail-bg;\n  border: $thumbnail-border-width solid $thumbnail-border-color;\n  @include border-radius($thumbnail-border-radius);\n  @include box-shadow($thumbnail-box-shadow);\n\n  // Keep them at most 100% wide\n  @include img-fluid();\n}\n\n//\n// Figures\n//\n\n.figure {\n  // Ensures the caption's text aligns with the image.\n  display: inline-block;\n}\n\n.figure-img {\n  margin-bottom: $spacer * .5;\n  line-height: 1;\n}\n\n.figure-caption {\n  @include font-size($figure-caption-font-size);\n  color: $figure-caption-color;\n}\n","// Image Mixins\n// - Responsive image\n// - Retina image\n\n\n// Responsive image\n//\n// Keep images from scaling beyond the width of their parents.\n\n@mixin img-fluid {\n  // Part 1: Set a maximum relative to the parent\n  max-width: 100%;\n  // Part 2: Override the height to auto, otherwise images will be stretched\n  // when setting a width and height attribute on the img element.\n  height: auto;\n}\n","// Container widths\n//\n// Set the container width, and override it for fixed navbars in media queries.\n\n@if $enable-container-classes {\n  // Single container class with breakpoint max-widths\n  .container,\n  // 100% wide container at all breakpoints\n  .container-fluid {\n    @include make-container();\n  }\n\n  // Responsive containers that are 100% wide until a breakpoint\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    .container-#{$breakpoint} {\n      @extend .container-fluid;\n    }\n\n    @include media-breakpoint-up($breakpoint, $grid-breakpoints) {\n      %responsive-container-#{$breakpoint} {\n        max-width: $container-max-width;\n      }\n\n      // Extend each breakpoint which is smaller or equal to the current breakpoint\n      $extend-breakpoint: true;\n\n      @each $name, $width in $grid-breakpoints {\n        @if ($extend-breakpoint) {\n          .container#{breakpoint-infix($name, $grid-breakpoints)} {\n            @extend %responsive-container-#{$breakpoint};\n          }\n\n          // Once the current breakpoint is reached, stop extending\n          @if ($breakpoint == $name) {\n            $extend-breakpoint: false;\n          }\n        }\n      }\n    }\n  }\n}\n","// Container mixins\n\n@mixin make-container($gutter: $container-padding-x) {\n  --#{$prefix}gutter-x: #{$gutter};\n  --#{$prefix}gutter-y: 0;\n  width: 100%;\n  padding-right: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  padding-left: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  margin-right: auto;\n  margin-left: auto;\n}\n","// Breakpoint viewport sizes and media queries.\n//\n// Breakpoints are defined as a map of (name: minimum width), order from small to large:\n//\n//    (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px)\n//\n// The map defined in the `$grid-breakpoints` global variable is used as the `$breakpoints` argument by default.\n\n// Name of the next breakpoint, or null for the last breakpoint.\n//\n//    >> breakpoint-next(sm)\n//    md\n//    >> breakpoint-next(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    md\n//    >> breakpoint-next(sm, $breakpoint-names: (xs sm md lg xl xxl))\n//    md\n@function breakpoint-next($name, $breakpoints: $grid-breakpoints, $breakpoint-names: map-keys($breakpoints)) {\n  $n: index($breakpoint-names, $name);\n  @if not $n {\n    @error \"breakpoint `#{$name}` not found in `#{$breakpoints}`\";\n  }\n  @return if($n < length($breakpoint-names), nth($breakpoint-names, $n + 1), null);\n}\n\n// Minimum breakpoint width. Null for the smallest (first) breakpoint.\n//\n//    >> breakpoint-min(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    576px\n@function breakpoint-min($name, $breakpoints: $grid-breakpoints) {\n  $min: map-get($breakpoints, $name);\n  @return if($min != 0, $min, null);\n}\n\n// Maximum breakpoint width.\n// The maximum value is reduced by 0.02px to work around the limitations of\n// `min-` and `max-` prefixes and viewports with fractional widths.\n// See https://www.w3.org/TR/mediaqueries-4/#mq-min-max\n// Uses 0.02px rather than 0.01px to work around a current rounding bug in Safari.\n// See https://bugs.webkit.org/show_bug.cgi?id=178261\n//\n//    >> breakpoint-max(md, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    767.98px\n@function breakpoint-max($name, $breakpoints: $grid-breakpoints) {\n  $max: map-get($breakpoints, $name);\n  @return if($max and $max > 0, $max - .02, null);\n}\n\n// Returns a blank string if smallest breakpoint, otherwise returns the name with a dash in front.\n// Useful for making responsive utilities.\n//\n//    >> breakpoint-infix(xs, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"\"  (Returns a blank string)\n//    >> breakpoint-infix(sm, (xs: 0, sm: 576px, md: 768px, lg: 992px, xl: 1200px, xxl: 1400px))\n//    \"-sm\"\n@function breakpoint-infix($name, $breakpoints: $grid-breakpoints) {\n  @return if(breakpoint-min($name, $breakpoints) == null, \"\", \"-#{$name}\");\n}\n\n// Media of at least the minimum breakpoint width. No query for the smallest breakpoint.\n// Makes the @content apply to the given breakpoint and wider.\n@mixin media-breakpoint-up($name, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($name, $breakpoints);\n  @if $min {\n    @media (min-width: $min) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media of at most the maximum breakpoint width. No query for the largest breakpoint.\n// Makes the @content apply to the given breakpoint and narrower.\n@mixin media-breakpoint-down($name, $breakpoints: $grid-breakpoints) {\n  $max: breakpoint-max($name, $breakpoints);\n  @if $max {\n    @media (max-width: $max) {\n      @content;\n    }\n  } @else {\n    @content;\n  }\n}\n\n// Media that spans multiple breakpoint widths.\n// Makes the @content apply between the min and max breakpoints\n@mixin media-breakpoint-between($lower, $upper, $breakpoints: $grid-breakpoints) {\n  $min: breakpoint-min($lower, $breakpoints);\n  $max: breakpoint-max($upper, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($lower, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($upper, $breakpoints) {\n      @content;\n    }\n  }\n}\n\n// Media between the breakpoint's minimum and maximum widths.\n// No minimum for the smallest breakpoint, and no maximum for the largest one.\n// Makes the @content apply only to the given breakpoint, not viewports any wider or narrower.\n@mixin media-breakpoint-only($name, $breakpoints: $grid-breakpoints) {\n  $min:  breakpoint-min($name, $breakpoints);\n  $next: breakpoint-next($name, $breakpoints);\n  $max:  breakpoint-max($next, $breakpoints);\n\n  @if $min != null and $max != null {\n    @media (min-width: $min) and (max-width: $max) {\n      @content;\n    }\n  } @else if $max == null {\n    @include media-breakpoint-up($name, $breakpoints) {\n      @content;\n    }\n  } @else if $min == null {\n    @include media-breakpoint-down($next, $breakpoints) {\n      @content;\n    }\n  }\n}\n","// Row\n//\n// Rows contain your columns.\n\n@if $enable-grid-classes {\n  .row {\n    @include make-row();\n\n    > * {\n      @include make-col-ready();\n    }\n  }\n}\n\n@if $enable-cssgrid {\n  .grid {\n    display: grid;\n    grid-template-rows: repeat(var(--#{$prefix}rows, 1), 1fr);\n    grid-template-columns: repeat(var(--#{$prefix}columns, #{$grid-columns}), 1fr);\n    gap: var(--#{$prefix}gap, #{$grid-gutter-width});\n\n    @include make-cssgrid();\n  }\n}\n\n\n// Columns\n//\n// Common styles for small and large grid columns\n\n@if $enable-grid-classes {\n  @include make-grid-columns();\n}\n","// Grid system\n//\n// Generate semantic grid columns with these mixins.\n\n@mixin make-row($gutter: $grid-gutter-width) {\n  --#{$prefix}gutter-x: #{$gutter};\n  --#{$prefix}gutter-y: 0;\n  display: flex;\n  flex-wrap: wrap;\n  // TODO: Revisit calc order after https://github.com/react-bootstrap/react-bootstrap/issues/6039 is fixed\n  margin-top: calc(-1 * var(--#{$prefix}gutter-y)); // stylelint-disable-line function-disallowed-list\n  margin-right: calc(-.5 * var(--#{$prefix}gutter-x)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}gutter-x)); // stylelint-disable-line function-disallowed-list\n}\n\n@mixin make-col-ready() {\n  // Add box sizing if only the grid is loaded\n  box-sizing: if(variable-exists(include-column-box-sizing) and $include-column-box-sizing, border-box, null);\n  // Prevent columns from becoming too narrow when at smaller grid tiers by\n  // always setting `width: 100%;`. This works because we set the width\n  // later on to override this initial width.\n  flex-shrink: 0;\n  width: 100%;\n  max-width: 100%; // Prevent `.col-auto`, `.col` (& responsive variants) from breaking out the grid\n  padding-right: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  padding-left: calc(var(--#{$prefix}gutter-x) * .5); // stylelint-disable-line function-disallowed-list\n  margin-top: var(--#{$prefix}gutter-y);\n}\n\n@mixin make-col($size: false, $columns: $grid-columns) {\n  @if $size {\n    flex: 0 0 auto;\n    width: percentage(divide($size, $columns));\n\n  } @else {\n    flex: 1 1 0;\n    max-width: 100%;\n  }\n}\n\n@mixin make-col-auto() {\n  flex: 0 0 auto;\n  width: auto;\n}\n\n@mixin make-col-offset($size, $columns: $grid-columns) {\n  $num: divide($size, $columns);\n  margin-left: if($num == 0, 0, percentage($num));\n}\n\n// Row columns\n//\n// Specify on a parent element(e.g., .row) to force immediate children into NN\n// number of columns. Supports wrapping to new lines, but does not do a Masonry\n// style grid.\n@mixin row-cols($count) {\n  > * {\n    flex: 0 0 auto;\n    width: divide(100%, $count);\n  }\n}\n\n// Framework grid generation\n//\n// Used only by Bootstrap to generate the correct number of grid classes given\n// any value of `$grid-columns`.\n\n@mixin make-grid-columns($columns: $grid-columns, $gutter: $grid-gutter-width, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      // Provide basic `.col-{bp}` classes for equal-width flexbox columns\n      .col#{$infix} {\n        flex: 1 0 0%; // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      }\n\n      .row-cols#{$infix}-auto > * {\n        @include make-col-auto();\n      }\n\n      @if $grid-row-columns > 0 {\n        @for $i from 1 through $grid-row-columns {\n          .row-cols#{$infix}-#{$i} {\n            @include row-cols($i);\n          }\n        }\n      }\n\n      .col#{$infix}-auto {\n        @include make-col-auto();\n      }\n\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .col#{$infix}-#{$i} {\n            @include make-col($i, $columns);\n          }\n        }\n\n        // `$columns - 1` because offsetting by the width of an entire row isn't possible\n        @for $i from 0 through ($columns - 1) {\n          @if not ($infix == \"\" and $i == 0) { // Avoid emitting useless .offset-0\n            .offset#{$infix}-#{$i} {\n              @include make-col-offset($i, $columns);\n            }\n          }\n        }\n      }\n\n      // Gutters\n      //\n      // Make use of `.g-*`, `.gx-*` or `.gy-*` utilities to change spacing between the columns.\n      @each $key, $value in $gutters {\n        .g#{$infix}-#{$key},\n        .gx#{$infix}-#{$key} {\n          --#{$prefix}gutter-x: #{$value};\n        }\n\n        .g#{$infix}-#{$key},\n        .gy#{$infix}-#{$key} {\n          --#{$prefix}gutter-y: #{$value};\n        }\n      }\n    }\n  }\n}\n\n@mixin make-cssgrid($columns: $grid-columns, $breakpoints: $grid-breakpoints) {\n  @each $breakpoint in map-keys($breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $breakpoints);\n\n    @include media-breakpoint-up($breakpoint, $breakpoints) {\n      @if $columns > 0 {\n        @for $i from 1 through $columns {\n          .g-col#{$infix}-#{$i} {\n            grid-column: auto / span $i;\n          }\n        }\n\n        // Start with `1` because `0` is and invalid value.\n        // Ends with `$columns - 1` because offsetting by the width of an entire row isn't possible.\n        @for $i from 1 through ($columns - 1) {\n          .g-start#{$infix}-#{$i} {\n            grid-column-start: $i;\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Basic Bootstrap table\n//\n\n.table {\n  --#{$prefix}table-color: #{$table-color};\n  --#{$prefix}table-bg: #{$table-bg};\n  --#{$prefix}table-border-color: #{$table-border-color};\n  --#{$prefix}table-accent-bg: #{$table-accent-bg};\n  --#{$prefix}table-striped-color: #{$table-striped-color};\n  --#{$prefix}table-striped-bg: #{$table-striped-bg};\n  --#{$prefix}table-active-color: #{$table-active-color};\n  --#{$prefix}table-active-bg: #{$table-active-bg};\n  --#{$prefix}table-hover-color: #{$table-hover-color};\n  --#{$prefix}table-hover-bg: #{$table-hover-bg};\n\n  width: 100%;\n  margin-bottom: $spacer;\n  color: var(--#{$prefix}table-color);\n  vertical-align: $table-cell-vertical-align;\n  border-color: var(--#{$prefix}table-border-color);\n\n  // Target th & td\n  // We need the child combinator to prevent styles leaking to nested tables which doesn't have a `.table` class.\n  // We use the universal selectors here to simplify the selector (else we would need 6 different selectors).\n  // Another advantage is that this generates less code and makes the selector less specific making it easier to override.\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y $table-cell-padding-x;\n    background-color: var(--#{$prefix}table-bg);\n    border-bottom-width: $table-border-width;\n    box-shadow: inset 0 0 0 9999px var(--#{$prefix}table-accent-bg);\n  }\n\n  > tbody {\n    vertical-align: inherit;\n  }\n\n  > thead {\n    vertical-align: bottom;\n  }\n}\n\n.table-group-divider {\n  border-top: ($table-border-width * 2) solid $table-group-separator-color;\n}\n\n//\n// Change placement of captions with a class\n//\n\n.caption-top {\n  caption-side: top;\n}\n\n\n//\n// Condensed table w/ half padding\n//\n\n.table-sm {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    padding: $table-cell-padding-y-sm $table-cell-padding-x-sm;\n  }\n}\n\n\n// Border versions\n//\n// Add or remove borders all around the table and between all the columns.\n//\n// When borders are added on all sides of the cells, the corners can render odd when\n// these borders do not have the same color or if they are semi-transparent.\n// Therefor we add top and border bottoms to the `tr`s and left and right borders\n// to the `td`s or `th`s\n\n.table-bordered {\n  > :not(caption) > * {\n    border-width: $table-border-width 0;\n\n    // stylelint-disable-next-line selector-max-universal\n    > * {\n      border-width: 0 $table-border-width;\n    }\n  }\n}\n\n.table-borderless {\n  // stylelint-disable-next-line selector-max-universal\n  > :not(caption) > * > * {\n    border-bottom-width: 0;\n  }\n\n  > :not(:first-child) {\n    border-top-width: 0;\n  }\n}\n\n// Zebra-striping\n//\n// Default zebra-stripe styles (alternating gray and transparent backgrounds)\n\n// For rows\n.table-striped {\n  > tbody > tr:nth-of-type(#{$table-striped-order}) > * {\n    --#{$prefix}table-accent-bg: var(--#{$prefix}table-striped-bg);\n    color: var(--#{$prefix}table-striped-color);\n  }\n}\n\n// For columns\n.table-striped-columns {\n  > :not(caption) > tr > :nth-child(#{$table-striped-columns-order}) {\n    --#{$prefix}table-accent-bg: var(--#{$prefix}table-striped-bg);\n    color: var(--#{$prefix}table-striped-color);\n  }\n}\n\n// Active table\n//\n// The `.table-active` class can be added to highlight rows or cells\n\n.table-active {\n  --#{$prefix}table-accent-bg: var(--#{$prefix}table-active-bg);\n  color: var(--#{$prefix}table-active-color);\n}\n\n// Hover effect\n//\n// Placed here since it has to come after the potential zebra striping\n\n.table-hover {\n  > tbody > tr:hover > * {\n    --#{$prefix}table-accent-bg: var(--#{$prefix}table-hover-bg);\n    color: var(--#{$prefix}table-hover-color);\n  }\n}\n\n\n// Table variants\n//\n// Table variants set the table cell backgrounds, border colors\n// and the colors of the striped, hovered & active tables\n\n@each $color, $value in $table-variants {\n  @include table-variant($color, $value);\n}\n\n// Responsive tables\n//\n// Generate series of `.table-responsive-*` classes for configuring the screen\n// size of where your table will overflow.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n  @include media-breakpoint-down($breakpoint) {\n    .table-responsive#{$infix} {\n      overflow-x: auto;\n      -webkit-overflow-scrolling: touch;\n    }\n  }\n}\n","// scss-docs-start table-variant\n@mixin table-variant($state, $background) {\n  .table-#{$state} {\n    $color: color-contrast(opaque($body-bg, $background));\n    $hover-bg: mix($color, $background, percentage($table-hover-bg-factor));\n    $striped-bg: mix($color, $background, percentage($table-striped-bg-factor));\n    $active-bg: mix($color, $background, percentage($table-active-bg-factor));\n    $table-border-color: mix($color, $background, percentage($table-border-factor));\n\n    --#{$prefix}table-color: #{$color};\n    --#{$prefix}table-bg: #{$background};\n    --#{$prefix}table-border-color: #{$table-border-color};\n    --#{$prefix}table-striped-bg: #{$striped-bg};\n    --#{$prefix}table-striped-color: #{color-contrast($striped-bg)};\n    --#{$prefix}table-active-bg: #{$active-bg};\n    --#{$prefix}table-active-color: #{color-contrast($active-bg)};\n    --#{$prefix}table-hover-bg: #{$hover-bg};\n    --#{$prefix}table-hover-color: #{color-contrast($hover-bg)};\n\n    color: var(--#{$prefix}table-color);\n    border-color: var(--#{$prefix}table-border-color);\n  }\n}\n// scss-docs-end table-variant\n","//\n// Labels\n//\n\n.form-label {\n  margin-bottom: $form-label-margin-bottom;\n  @include font-size($form-label-font-size);\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  color: $form-label-color;\n}\n\n// For use with horizontal and inline forms, when you need the label (or legend)\n// text to align with the form controls.\n.col-form-label {\n  padding-top: add($input-padding-y, $input-border-width);\n  padding-bottom: add($input-padding-y, $input-border-width);\n  margin-bottom: 0; // Override the `<legend>` default\n  @include font-size(inherit); // Override the `<legend>` default\n  font-style: $form-label-font-style;\n  font-weight: $form-label-font-weight;\n  line-height: $input-line-height;\n  color: $form-label-color;\n}\n\n.col-form-label-lg {\n  padding-top: add($input-padding-y-lg, $input-border-width);\n  padding-bottom: add($input-padding-y-lg, $input-border-width);\n  @include font-size($input-font-size-lg);\n}\n\n.col-form-label-sm {\n  padding-top: add($input-padding-y-sm, $input-border-width);\n  padding-bottom: add($input-padding-y-sm, $input-border-width);\n  @include font-size($input-font-size-sm);\n}\n","// Bootstrap functions\n//\n// Utility mixins and functions for evaluating source code across our variables, maps, and mixins.\n\n// Ascending\n// Used to evaluate Sass maps like our grid breakpoints.\n@mixin _assert-ascending($map, $map-name) {\n  $prev-key: null;\n  $prev-num: null;\n  @each $key, $num in $map {\n    @if $prev-num == null or unit($num) == \"%\" or unit($prev-num) == \"%\" {\n      // Do nothing\n    } @else if not comparable($prev-num, $num) {\n      @warn \"Potentially invalid value for #{$map-name}: This map must be in ascending order, but key '#{$key}' has value #{$num} whose unit makes it incomparable to #{$prev-num}, the value of the previous key '#{$prev-key}' !\";\n    } @else if $prev-num >= $num {\n      @warn \"Invalid value for #{$map-name}: This map must be in ascending order, but key '#{$key}' has value #{$num} which isn't greater than #{$prev-num}, the value of the previous key '#{$prev-key}' !\";\n    }\n    $prev-key: $key;\n    $prev-num: $num;\n  }\n}\n\n// Starts at zero\n// Used to ensure the min-width of the lowest breakpoint starts at 0.\n@mixin _assert-starts-at-zero($map, $map-name: \"$grid-breakpoints\") {\n  @if length($map) > 0 {\n    $values: map-values($map);\n    $first-value: nth($values, 1);\n    @if $first-value != 0 {\n      @warn \"First breakpoint in #{$map-name} must start at 0, but starts at #{$first-value}.\";\n    }\n  }\n}\n\n// Colors\n@function to-rgb($value) {\n  @return red($value), green($value), blue($value);\n}\n\n// stylelint-disable scss/dollar-variable-pattern\n@function rgba-css-var($identifier, $target) {\n  @if $identifier == \"body\" and $target == \"bg\" {\n    @return rgba(var(--#{$prefix}#{$identifier}-bg-rgb), var(--#{$prefix}#{$target}-opacity));\n  } @if $identifier == \"body\" and $target == \"text\" {\n    @return rgba(var(--#{$prefix}#{$identifier}-color-rgb), var(--#{$prefix}#{$target}-opacity));\n  } @else {\n    @return rgba(var(--#{$prefix}#{$identifier}-rgb), var(--#{$prefix}#{$target}-opacity));\n  }\n}\n\n@function map-loop($map, $func, $args...) {\n  $_map: ();\n\n  @each $key, $value in $map {\n    // allow to pass the $key and $value of the map as an function argument\n    $_args: ();\n    @each $arg in $args {\n      $_args: append($_args, if($arg == \"$key\", $key, if($arg == \"$value\", $value, $arg)));\n    }\n\n    $_map: map-merge($_map, ($key: call(get-function($func), $_args...)));\n  }\n\n  @return $_map;\n}\n// stylelint-enable scss/dollar-variable-pattern\n\n@function varify($list) {\n  $result: null;\n  @each $entry in $list {\n    $result: append($result, var(--#{$prefix}#{$entry}), space);\n  }\n  @return $result;\n}\n\n// Internal Bootstrap function to turn maps into its negative variant.\n// It prefixes the keys with `n` and makes the value negative.\n@function negativify-map($map) {\n  $result: ();\n  @each $key, $value in $map {\n    @if $key != 0 {\n      $result: map-merge($result, (\"n\" + $key: (-$value)));\n    }\n  }\n  @return $result;\n}\n\n// Get multiple keys from a sass map\n@function map-get-multiple($map, $values) {\n  $result: ();\n  @each $key, $value in $map {\n    @if (index($values, $key) != null) {\n      $result: map-merge($result, ($key: $value));\n    }\n  }\n  @return $result;\n}\n\n// Merge multiple maps\n@function map-merge-multiple($maps...) {\n  $merged-maps: ();\n\n  @each $map in $maps {\n    $merged-maps: map-merge($merged-maps, $map);\n  }\n  @return $merged-maps;\n}\n\n// Replace `$search` with `$replace` in `$string`\n// Used on our SVG icon backgrounds for custom forms.\n//\n// @author Kitty Giraudel\n// @param {String} $string - Initial string\n// @param {String} $search - Substring to replace\n// @param {String} $replace ('') - New value\n// @return {String} - Updated string\n@function str-replace($string, $search, $replace: \"\") {\n  $index: str-index($string, $search);\n\n  @if $index {\n    @return str-slice($string, 1, $index - 1) + $replace + str-replace(str-slice($string, $index + str-length($search)), $search, $replace);\n  }\n\n  @return $string;\n}\n\n// See https://codepen.io/kevinweber/pen/dXWoRw\n//\n// Requires the use of quotes around data URIs.\n\n@function escape-svg($string) {\n  @if str-index($string, \"data:image/svg+xml\") {\n    @each $char, $encoded in $escaped-characters {\n      // Do not escape the url brackets\n      @if str-index($string, \"url(\") == 1 {\n        $string: url(\"#{str-replace(str-slice($string, 6, -3), $char, $encoded)}\");\n      } @else {\n        $string: str-replace($string, $char, $encoded);\n      }\n    }\n  }\n\n  @return $string;\n}\n\n// Color contrast\n// See https://github.com/twbs/bootstrap/pull/30168\n\n// A list of pre-calculated numbers of pow(divide((divide($value, 255) + .055), 1.055), 2.4). (from 0 to 255)\n// stylelint-disable-next-line scss/dollar-variable-default, scss/dollar-variable-pattern\n$_luminance-list: .0008 .001 .0011 .0013 .0015 .0017 .002 .0022 .0025 .0027 .003 .0033 .0037 .004 .0044 .0048 .0052 .0056 .006 .0065 .007 .0075 .008 .0086 .0091 .0097 .0103 .011 .0116 .0123 .013 .0137 .0144 .0152 .016 .0168 .0176 .0185 .0194 .0203 .0212 .0222 .0232 .0242 .0252 .0262 .0273 .0284 .0296 .0307 .0319 .0331 .0343 .0356 .0369 .0382 .0395 .0409 .0423 .0437 .0452 .0467 .0482 .0497 .0513 .0529 .0545 .0561 .0578 .0595 .0612 .063 .0648 .0666 .0685 .0704 .0723 .0742 .0762 .0782 .0802 .0823 .0844 .0865 .0887 .0908 .0931 .0953 .0976 .0999 .1022 .1046 .107 .1095 .1119 .1144 .117 .1195 .1221 .1248 .1274 .1301 .1329 .1356 .1384 .1413 .1441 .147 .15 .1529 .1559 .159 .162 .1651 .1683 .1714 .1746 .1779 .1812 .1845 .1878 .1912 .1946 .1981 .2016 .2051 .2086 .2122 .2159 .2195 .2232 .227 .2307 .2346 .2384 .2423 .2462 .2502 .2542 .2582 .2623 .2664 .2705 .2747 .2789 .2831 .2874 .2918 .2961 .3005 .305 .3095 .314 .3185 .3231 .3278 .3325 .3372 .3419 .3467 .3515 .3564 .3613 .3663 .3712 .3763 .3813 .3864 .3916 .3968 .402 .4072 .4125 .4179 .4233 .4287 .4342 .4397 .4452 .4508 .4564 .4621 .4678 .4735 .4793 .4851 .491 .4969 .5029 .5089 .5149 .521 .5271 .5333 .5395 .5457 .552 .5583 .5647 .5711 .5776 .5841 .5906 .5972 .6038 .6105 .6172 .624 .6308 .6376 .6445 .6514 .6584 .6654 .6724 .6795 .6867 .6939 .7011 .7084 .7157 .7231 .7305 .7379 .7454 .7529 .7605 .7682 .7758 .7835 .7913 .7991 .807 .8148 .8228 .8308 .8388 .8469 .855 .8632 .8714 .8796 .8879 .8963 .9047 .9131 .9216 .9301 .9387 .9473 .956 .9647 .9734 .9823 .9911 1;\n\n@function color-contrast($background, $color-contrast-dark: $color-contrast-dark, $color-contrast-light: $color-contrast-light, $min-contrast-ratio: $min-contrast-ratio) {\n  $foregrounds: $color-contrast-light, $color-contrast-dark, $white, $black;\n  $max-ratio: 0;\n  $max-ratio-color: null;\n\n  @each $color in $foregrounds {\n    $contrast-ratio: contrast-ratio($background, $color);\n    @if $contrast-ratio > $min-contrast-ratio {\n      @return $color;\n    } @else if $contrast-ratio > $max-ratio {\n      $max-ratio: $contrast-ratio;\n      $max-ratio-color: $color;\n    }\n  }\n\n  @warn \"Found no color leading to #{$min-contrast-ratio}:1 contrast ratio against #{$background}...\";\n\n  @return $max-ratio-color;\n}\n\n@function contrast-ratio($background, $foreground: $color-contrast-light) {\n  $l1: luminance($background);\n  $l2: luminance(opaque($background, $foreground));\n\n  @return if($l1 > $l2, divide($l1 + .05, $l2 + .05), divide($l2 + .05, $l1 + .05));\n}\n\n// Return WCAG2.1 relative luminance\n// See https://www.w3.org/TR/WCAG/#dfn-relative-luminance\n// See https://www.w3.org/TR/WCAG/#dfn-contrast-ratio\n@function luminance($color) {\n  $rgb: (\n    \"r\": red($color),\n    \"g\": green($color),\n    \"b\": blue($color)\n  );\n\n  @each $name, $value in $rgb {\n    $value: if(divide($value, 255) < .03928, divide(divide($value, 255), 12.92), nth($_luminance-list, $value + 1));\n    $rgb: map-merge($rgb, ($name: $value));\n  }\n\n  @return (map-get($rgb, \"r\") * .2126) + (map-get($rgb, \"g\") * .7152) + (map-get($rgb, \"b\") * .0722);\n}\n\n// Return opaque color\n// opaque(#fff, rgba(0, 0, 0, .5)) => #808080\n@function opaque($background, $foreground) {\n  @return mix(rgba($foreground, 1), $background, opacity($foreground) * 100%);\n}\n\n// scss-docs-start color-functions\n// Tint a color: mix a color with white\n@function tint-color($color, $weight) {\n  @return mix(white, $color, $weight);\n}\n\n// Shade a color: mix a color with black\n@function shade-color($color, $weight) {\n  @return mix(black, $color, $weight);\n}\n\n// Shade the color if the weight is positive, else tint it\n@function shift-color($color, $weight) {\n  @return if($weight > 0, shade-color($color, $weight), tint-color($color, -$weight));\n}\n// scss-docs-end color-functions\n\n// Return valid calc\n@function add($value1, $value2, $return-calc: true) {\n  @if $value1 == null {\n    @return $value2;\n  }\n\n  @if $value2 == null {\n    @return $value1;\n  }\n\n  @if type-of($value1) == number and type-of($value2) == number and comparable($value1, $value2) {\n    @return $value1 + $value2;\n  }\n\n  @return if($return-calc == true, calc(#{$value1} + #{$value2}), $value1 + unquote(\" + \") + $value2);\n}\n\n@function subtract($value1, $value2, $return-calc: true) {\n  @if $value1 == null and $value2 == null {\n    @return null;\n  }\n\n  @if $value1 == null {\n    @return -$value2;\n  }\n\n  @if $value2 == null {\n    @return $value1;\n  }\n\n  @if type-of($value1) == number and type-of($value2) == number and comparable($value1, $value2) {\n    @return $value1 - $value2;\n  }\n\n  @if type-of($value2) != number {\n    $value2: unquote(\"(\") + $value2 + unquote(\")\");\n  }\n\n  @return if($return-calc == true, calc(#{$value1} - #{$value2}), $value1 + unquote(\" - \") + $value2);\n}\n\n@function divide($dividend, $divisor, $precision: 10) {\n  $sign: if($dividend > 0 and $divisor > 0 or $dividend < 0 and $divisor < 0, 1, -1);\n  $dividend: abs($dividend);\n  $divisor: abs($divisor);\n  @if $dividend == 0 {\n    @return 0;\n  }\n  @if $divisor == 0 {\n    @error \"Cannot divide by 0\";\n  }\n  $remainder: $dividend;\n  $result: 0;\n  $factor: 10;\n  @while ($remainder > 0 and $precision >= 0) {\n    $quotient: 0;\n    @while ($remainder >= $divisor) {\n      $remainder: $remainder - $divisor;\n      $quotient: $quotient + 1;\n    }\n    $result: $result * 10 + $quotient;\n    $factor: $factor * .1;\n    $remainder: $remainder * 10;\n    $precision: $precision - 1;\n    @if ($precision < 0 and $remainder >= $divisor * 5) {\n      $result: $result + 1;\n    }\n  }\n  $result: $result * $factor * $sign;\n  $dividend-unit: unit($dividend);\n  $divisor-unit: unit($divisor);\n  $unit-map: (\n    \"px\": 1px,\n    \"rem\": 1rem,\n    \"em\": 1em,\n    \"%\": 1%\n  );\n  @if ($dividend-unit != $divisor-unit and map-has-key($unit-map, $dividend-unit)) {\n    $result: $result * map-get($unit-map, $dividend-unit);\n  }\n  @return $result;\n}\n","//\n// Form text\n//\n\n.form-text {\n  margin-top: $form-text-margin-top;\n  @include font-size($form-text-font-size);\n  font-style: $form-text-font-style;\n  font-weight: $form-text-font-weight;\n  color: $form-text-color;\n}\n","//\n// General form controls (plus a few specific high-level interventions)\n//\n\n.form-control {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y $input-padding-x;\n  font-family: $input-font-family;\n  @include font-size($input-font-size);\n  font-weight: $input-font-weight;\n  line-height: $input-line-height;\n  color: $input-color;\n  background-color: $input-bg;\n  background-clip: padding-box;\n  border: $input-border-width solid $input-border-color;\n  appearance: none; // Fix appearance for date inputs in Safari\n\n  // Note: This has no effect on <select>s in some browsers, due to the limited stylability of `<select>`s in CSS.\n  @include border-radius($input-border-radius, 0);\n\n  @include box-shadow($input-box-shadow);\n  @include transition($input-transition);\n\n  &[type=\"file\"] {\n    overflow: hidden; // prevent pseudo element button overlap\n\n    &:not(:disabled):not([readonly]) {\n      cursor: pointer;\n    }\n  }\n\n  // Customize the `:focus` state to imitate native WebKit styles.\n  &:focus {\n    color: $input-focus-color;\n    background-color: $input-focus-bg;\n    border-color: $input-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($input-box-shadow, $input-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $input-focus-box-shadow;\n    }\n  }\n\n  // Add some height to date inputs on iOS\n  // https://github.com/twbs/bootstrap/issues/23307\n  // TODO: we can remove this workaround once https://bugs.webkit.org/show_bug.cgi?id=198959 is resolved\n  &::-webkit-date-and-time-value {\n    // Multiply line-height by 1em if it has no unit\n    height: if(unit($input-line-height) == \"\", $input-line-height * 1em, $input-line-height);\n  }\n\n  // Placeholder\n  &::placeholder {\n    color: $input-placeholder-color;\n    // Override Firefox's unusual default opacity; see https://github.com/twbs/bootstrap/pull/11526.\n    opacity: 1;\n  }\n\n  // Disabled inputs\n  //\n  // HTML5 says that controls under a fieldset > legend:first-child won't be\n  // disabled if the fieldset is disabled. Due to implementation difficulty, we\n  // don't honor that edge case; we style them as disabled anyway.\n  &:disabled {\n    color: $input-disabled-color;\n    background-color: $input-disabled-bg;\n    border-color: $input-disabled-border-color;\n    // iOS fix for unreadable disabled content; see https://github.com/twbs/bootstrap/issues/11655.\n    opacity: 1;\n  }\n\n  // File input buttons theming\n  &::file-selector-button {\n    padding: $input-padding-y $input-padding-x;\n    margin: (-$input-padding-y) (-$input-padding-x);\n    margin-inline-end: $input-padding-x;\n    color: $form-file-button-color;\n    @include gradient-bg($form-file-button-bg);\n    pointer-events: none;\n    border-color: inherit;\n    border-style: solid;\n    border-width: 0;\n    border-inline-end-width: $input-border-width;\n    border-radius: 0; // stylelint-disable-line property-disallowed-list\n    @include transition($btn-transition);\n  }\n\n  &:hover:not(:disabled):not([readonly])::file-selector-button {\n    background-color: $form-file-button-hover-bg;\n  }\n}\n\n// Readonly controls as plain text\n//\n// Apply class to a readonly input to make it appear like regular plain\n// text (without any border, background color, focus indicator)\n\n.form-control-plaintext {\n  display: block;\n  width: 100%;\n  padding: $input-padding-y 0;\n  margin-bottom: 0; // match inputs if this class comes on inputs with default margins\n  line-height: $input-line-height;\n  color: $input-plaintext-color;\n  background-color: transparent;\n  border: solid transparent;\n  border-width: $input-border-width 0;\n\n  &:focus {\n    outline: 0;\n  }\n\n  &.form-control-sm,\n  &.form-control-lg {\n    padding-right: 0;\n    padding-left: 0;\n  }\n}\n\n// Form control sizing\n//\n// Build on `.form-control` with modifier classes to decrease or increase the\n// height and font-size of form controls.\n//\n// Repeated in `_input_group.scss` to avoid Sass extend issues.\n\n.form-control-sm {\n  min-height: $input-height-sm;\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n\n  &::file-selector-button {\n    padding: $input-padding-y-sm $input-padding-x-sm;\n    margin: (-$input-padding-y-sm) (-$input-padding-x-sm);\n    margin-inline-end: $input-padding-x-sm;\n  }\n}\n\n.form-control-lg {\n  min-height: $input-height-lg;\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n\n  &::file-selector-button {\n    padding: $input-padding-y-lg $input-padding-x-lg;\n    margin: (-$input-padding-y-lg) (-$input-padding-x-lg);\n    margin-inline-end: $input-padding-x-lg;\n  }\n}\n\n// Make sure textareas don't shrink too much when resized\n// https://github.com/twbs/bootstrap/pull/29124\n// stylelint-disable selector-no-qualifying-type\ntextarea {\n  &.form-control {\n    min-height: $input-height;\n  }\n\n  &.form-control-sm {\n    min-height: $input-height-sm;\n  }\n\n  &.form-control-lg {\n    min-height: $input-height-lg;\n  }\n}\n// stylelint-enable selector-no-qualifying-type\n\n.form-control-color {\n  width: $form-color-width;\n  height: $input-height;\n  padding: $input-padding-y;\n\n  &:not(:disabled):not([readonly]) {\n    cursor: pointer;\n  }\n\n  &::-moz-color-swatch {\n    border: 0 !important; // stylelint-disable-line declaration-no-important\n    @include border-radius($input-border-radius);\n  }\n\n  &::-webkit-color-swatch {\n    @include border-radius($input-border-radius);\n  }\n\n  &.form-control-sm { height: $input-height-sm; }\n  &.form-control-lg { height: $input-height-lg; }\n}\n","// stylelint-disable property-disallowed-list\n@mixin transition($transition...) {\n  @if length($transition) == 0 {\n    $transition: $transition-base;\n  }\n\n  @if length($transition) > 1 {\n    @each $value in $transition {\n      @if $value == null or $value == none {\n        @warn \"The keyword 'none' or 'null' must be used as a single argument.\";\n      }\n    }\n  }\n\n  @if $enable-transitions {\n    @if nth($transition, 1) != null {\n      transition: $transition;\n    }\n\n    @if $enable-reduced-motion and nth($transition, 1) != null and nth($transition, 1) != none {\n      @media (prefers-reduced-motion: reduce) {\n        transition: none;\n      }\n    }\n  }\n}\n","// Gradients\n\n// scss-docs-start gradient-bg-mixin\n@mixin gradient-bg($color: null) {\n  background-color: $color;\n\n  @if $enable-gradients {\n    background-image: var(--#{$prefix}gradient);\n  }\n}\n// scss-docs-end gradient-bg-mixin\n\n// scss-docs-start gradient-mixins\n// Horizontal gradient, from left to right\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-x($start-color: $gray-700, $end-color: $gray-800, $start-percent: 0%, $end-percent: 100%) {\n  background-image: linear-gradient(to right, $start-color $start-percent, $end-color $end-percent);\n}\n\n// Vertical gradient, from top to bottom\n//\n// Creates two color stops, start and end, by specifying a color and position for each color stop.\n@mixin gradient-y($start-color: $gray-700, $end-color: $gray-800, $start-percent: null, $end-percent: null) {\n  background-image: linear-gradient(to bottom, $start-color $start-percent, $end-color $end-percent);\n}\n\n@mixin gradient-directional($start-color: $gray-700, $end-color: $gray-800, $deg: 45deg) {\n  background-image: linear-gradient($deg, $start-color, $end-color);\n}\n\n@mixin gradient-x-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient(to right, $start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-y-three-colors($start-color: $blue, $mid-color: $purple, $color-stop: 50%, $end-color: $red) {\n  background-image: linear-gradient($start-color, $mid-color $color-stop, $end-color);\n}\n\n@mixin gradient-radial($inner-color: $gray-700, $outer-color: $gray-800) {\n  background-image: radial-gradient(circle, $inner-color, $outer-color);\n}\n\n@mixin gradient-striped($color: rgba($white, .15), $angle: 45deg) {\n  background-image: linear-gradient($angle, $color 25%, transparent 25%, transparent 50%, $color 50%, $color 75%, transparent 75%, transparent);\n}\n// scss-docs-end gradient-mixins\n","// Select\n//\n// Replaces the browser default select with a custom one, mostly pulled from\n// https://primer.github.io/.\n\n.form-select {\n  display: block;\n  width: 100%;\n  padding: $form-select-padding-y $form-select-indicator-padding $form-select-padding-y $form-select-padding-x;\n  -moz-padding-start: subtract($form-select-padding-x, 3px); // See https://github.com/twbs/bootstrap/issues/32636\n  font-family: $form-select-font-family;\n  @include font-size($form-select-font-size);\n  font-weight: $form-select-font-weight;\n  line-height: $form-select-line-height;\n  color: $form-select-color;\n  background-color: $form-select-bg;\n  background-image: escape-svg($form-select-indicator);\n  background-repeat: no-repeat;\n  background-position: $form-select-bg-position;\n  background-size: $form-select-bg-size;\n  border: $form-select-border-width solid $form-select-border-color;\n  @include border-radius($form-select-border-radius, 0);\n  @include box-shadow($form-select-box-shadow);\n  @include transition($form-select-transition);\n  appearance: none;\n\n  &:focus {\n    border-color: $form-select-focus-border-color;\n    outline: 0;\n    @if $enable-shadows {\n      @include box-shadow($form-select-box-shadow, $form-select-focus-box-shadow);\n    } @else {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      box-shadow: $form-select-focus-box-shadow;\n    }\n  }\n\n  &[multiple],\n  &[size]:not([size=\"1\"]) {\n    padding-right: $form-select-padding-x;\n    background-image: none;\n  }\n\n  &:disabled {\n    color: $form-select-disabled-color;\n    background-color: $form-select-disabled-bg;\n    border-color: $form-select-disabled-border-color;\n  }\n\n  // Remove outline from select box in FF\n  &:-moz-focusring {\n    color: transparent;\n    text-shadow: 0 0 0 $form-select-color;\n  }\n}\n\n.form-select-sm {\n  padding-top: $form-select-padding-y-sm;\n  padding-bottom: $form-select-padding-y-sm;\n  padding-left: $form-select-padding-x-sm;\n  @include font-size($form-select-font-size-sm);\n  @include border-radius($form-select-border-radius-sm);\n}\n\n.form-select-lg {\n  padding-top: $form-select-padding-y-lg;\n  padding-bottom: $form-select-padding-y-lg;\n  padding-left: $form-select-padding-x-lg;\n  @include font-size($form-select-font-size-lg);\n  @include border-radius($form-select-border-radius-lg);\n}\n","// Variables\n//\n// Variables should follow the `$component-state-property-size` formula for\n// consistent naming. Ex: $nav-link-disabled-color and $modal-content-box-shadow-xs.\n\n// Color system\n\n// scss-docs-start gray-color-variables\n$white:    #fff !default;\n$gray-100: #f8f9fa !default;\n$gray-200: #e9ecef !default;\n$gray-300: #dee2e6 !default;\n$gray-400: #ced4da !default;\n$gray-500: #adb5bd !default;\n$gray-600: #6c757d !default;\n$gray-700: #495057 !default;\n$gray-800: #343a40 !default;\n$gray-900: #212529 !default;\n$black:    #000 !default;\n// scss-docs-end gray-color-variables\n\n// fusv-disable\n// scss-docs-start gray-colors-map\n$grays: (\n  \"100\": $gray-100,\n  \"200\": $gray-200,\n  \"300\": $gray-300,\n  \"400\": $gray-400,\n  \"500\": $gray-500,\n  \"600\": $gray-600,\n  \"700\": $gray-700,\n  \"800\": $gray-800,\n  \"900\": $gray-900\n) !default;\n// scss-docs-end gray-colors-map\n// fusv-enable\n\n// scss-docs-start color-variables\n$blue:    #0d6efd !default;\n$indigo:  #6610f2 !default;\n$purple:  #6f42c1 !default;\n$pink:    #d63384 !default;\n$red:     #dc3545 !default;\n$orange:  #fd7e14 !default;\n$yellow:  #ffc107 !default;\n$green:   #198754 !default;\n$teal:    #20c997 !default;\n$cyan:    #0dcaf0 !default;\n// scss-docs-end color-variables\n\n// scss-docs-start colors-map\n$colors: (\n  \"blue\":       $blue,\n  \"indigo\":     $indigo,\n  \"purple\":     $purple,\n  \"pink\":       $pink,\n  \"red\":        $red,\n  \"orange\":     $orange,\n  \"yellow\":     $yellow,\n  \"green\":      $green,\n  \"teal\":       $teal,\n  \"cyan\":       $cyan,\n  \"black\":      $black,\n  \"white\":      $white,\n  \"gray\":       $gray-600,\n  \"gray-dark\":  $gray-800\n) !default;\n// scss-docs-end colors-map\n\n// The contrast ratio to reach against white, to determine if color changes from \"light\" to \"dark\". Acceptable values for WCAG 2.0 are 3, 4.5 and 7.\n// See https://www.w3.org/TR/WCAG20/#visual-audio-contrast-contrast\n$min-contrast-ratio:   4.5 !default;\n\n// Customize the light and dark text colors for use in our color contrast function.\n$color-contrast-dark:      $black !default;\n$color-contrast-light:     $white !default;\n\n// fusv-disable\n$blue-100: tint-color($blue, 80%) !default;\n$blue-200: tint-color($blue, 60%) !default;\n$blue-300: tint-color($blue, 40%) !default;\n$blue-400: tint-color($blue, 20%) !default;\n$blue-500: $blue !default;\n$blue-600: shade-color($blue, 20%) !default;\n$blue-700: shade-color($blue, 40%) !default;\n$blue-800: shade-color($blue, 60%) !default;\n$blue-900: shade-color($blue, 80%) !default;\n\n$indigo-100: tint-color($indigo, 80%) !default;\n$indigo-200: tint-color($indigo, 60%) !default;\n$indigo-300: tint-color($indigo, 40%) !default;\n$indigo-400: tint-color($indigo, 20%) !default;\n$indigo-500: $indigo !default;\n$indigo-600: shade-color($indigo, 20%) !default;\n$indigo-700: shade-color($indigo, 40%) !default;\n$indigo-800: shade-color($indigo, 60%) !default;\n$indigo-900: shade-color($indigo, 80%) !default;\n\n$purple-100: tint-color($purple, 80%) !default;\n$purple-200: tint-color($purple, 60%) !default;\n$purple-300: tint-color($purple, 40%) !default;\n$purple-400: tint-color($purple, 20%) !default;\n$purple-500: $purple !default;\n$purple-600: shade-color($purple, 20%) !default;\n$purple-700: shade-color($purple, 40%) !default;\n$purple-800: shade-color($purple, 60%) !default;\n$purple-900: shade-color($purple, 80%) !default;\n\n$pink-100: tint-color($pink, 80%) !default;\n$pink-200: tint-color($pink, 60%) !default;\n$pink-300: tint-color($pink, 40%) !default;\n$pink-400: tint-color($pink, 20%) !default;\n$pink-500: $pink !default;\n$pink-600: shade-color($pink, 20%) !default;\n$pink-700: shade-color($pink, 40%) !default;\n$pink-800: shade-color($pink, 60%) !default;\n$pink-900: shade-color($pink, 80%) !default;\n\n$red-100: tint-color($red, 80%) !default;\n$red-200: tint-color($red, 60%) !default;\n$red-300: tint-color($red, 40%) !default;\n$red-400: tint-color($red, 20%) !default;\n$red-500: $red !default;\n$red-600: shade-color($red, 20%) !default;\n$red-700: shade-color($red, 40%) !default;\n$red-800: shade-color($red, 60%) !default;\n$red-900: shade-color($red, 80%) !default;\n\n$orange-100: tint-color($orange, 80%) !default;\n$orange-200: tint-color($orange, 60%) !default;\n$orange-300: tint-color($orange, 40%) !default;\n$orange-400: tint-color($orange, 20%) !default;\n$orange-500: $orange !default;\n$orange-600: shade-color($orange, 20%) !default;\n$orange-700: shade-color($orange, 40%) !default;\n$orange-800: shade-color($orange, 60%) !default;\n$orange-900: shade-color($orange, 80%) !default;\n\n$yellow-100: tint-color($yellow, 80%) !default;\n$yellow-200: tint-color($yellow, 60%) !default;\n$yellow-300: tint-color($yellow, 40%) !default;\n$yellow-400: tint-color($yellow, 20%) !default;\n$yellow-500: $yellow !default;\n$yellow-600: shade-color($yellow, 20%) !default;\n$yellow-700: shade-color($yellow, 40%) !default;\n$yellow-800: shade-color($yellow, 60%) !default;\n$yellow-900: shade-color($yellow, 80%) !default;\n\n$green-100: tint-color($green, 80%) !default;\n$green-200: tint-color($green, 60%) !default;\n$green-300: tint-color($green, 40%) !default;\n$green-400: tint-color($green, 20%) !default;\n$green-500: $green !default;\n$green-600: shade-color($green, 20%) !default;\n$green-700: shade-color($green, 40%) !default;\n$green-800: shade-color($green, 60%) !default;\n$green-900: shade-color($green, 80%) !default;\n\n$teal-100: tint-color($teal, 80%) !default;\n$teal-200: tint-color($teal, 60%) !default;\n$teal-300: tint-color($teal, 40%) !default;\n$teal-400: tint-color($teal, 20%) !default;\n$teal-500: $teal !default;\n$teal-600: shade-color($teal, 20%) !default;\n$teal-700: shade-color($teal, 40%) !default;\n$teal-800: shade-color($teal, 60%) !default;\n$teal-900: shade-color($teal, 80%) !default;\n\n$cyan-100: tint-color($cyan, 80%) !default;\n$cyan-200: tint-color($cyan, 60%) !default;\n$cyan-300: tint-color($cyan, 40%) !default;\n$cyan-400: tint-color($cyan, 20%) !default;\n$cyan-500: $cyan !default;\n$cyan-600: shade-color($cyan, 20%) !default;\n$cyan-700: shade-color($cyan, 40%) !default;\n$cyan-800: shade-color($cyan, 60%) !default;\n$cyan-900: shade-color($cyan, 80%) !default;\n\n$blues: (\n  \"blue-100\": $blue-100,\n  \"blue-200\": $blue-200,\n  \"blue-300\": $blue-300,\n  \"blue-400\": $blue-400,\n  \"blue-500\": $blue-500,\n  \"blue-600\": $blue-600,\n  \"blue-700\": $blue-700,\n  \"blue-800\": $blue-800,\n  \"blue-900\": $blue-900\n) !default;\n\n$indigos: (\n  \"indigo-100\": $indigo-100,\n  \"indigo-200\": $indigo-200,\n  \"indigo-300\": $indigo-300,\n  \"indigo-400\": $indigo-400,\n  \"indigo-500\": $indigo-500,\n  \"indigo-600\": $indigo-600,\n  \"indigo-700\": $indigo-700,\n  \"indigo-800\": $indigo-800,\n  \"indigo-900\": $indigo-900\n) !default;\n\n$purples: (\n  \"purple-100\": $purple-100,\n  \"purple-200\": $purple-200,\n  \"purple-300\": $purple-300,\n  \"purple-400\": $purple-400,\n  \"purple-500\": $purple-500,\n  \"purple-600\": $purple-600,\n  \"purple-700\": $purple-700,\n  \"purple-800\": $purple-800,\n  \"purple-900\": $purple-900\n) !default;\n\n$pinks: (\n  \"pink-100\": $pink-100,\n  \"pink-200\": $pink-200,\n  \"pink-300\": $pink-300,\n  \"pink-400\": $pink-400,\n  \"pink-500\": $pink-500,\n  \"pink-600\": $pink-600,\n  \"pink-700\": $pink-700,\n  \"pink-800\": $pink-800,\n  \"pink-900\": $pink-900\n) !default;\n\n$reds: (\n  \"red-100\": $red-100,\n  \"red-200\": $red-200,\n  \"red-300\": $red-300,\n  \"red-400\": $red-400,\n  \"red-500\": $red-500,\n  \"red-600\": $red-600,\n  \"red-700\": $red-700,\n  \"red-800\": $red-800,\n  \"red-900\": $red-900\n) !default;\n\n$oranges: (\n  \"orange-100\": $orange-100,\n  \"orange-200\": $orange-200,\n  \"orange-300\": $orange-300,\n  \"orange-400\": $orange-400,\n  \"orange-500\": $orange-500,\n  \"orange-600\": $orange-600,\n  \"orange-700\": $orange-700,\n  \"orange-800\": $orange-800,\n  \"orange-900\": $orange-900\n) !default;\n\n$yellows: (\n  \"yellow-100\": $yellow-100,\n  \"yellow-200\": $yellow-200,\n  \"yellow-300\": $yellow-300,\n  \"yellow-400\": $yellow-400,\n  \"yellow-500\": $yellow-500,\n  \"yellow-600\": $yellow-600,\n  \"yellow-700\": $yellow-700,\n  \"yellow-800\": $yellow-800,\n  \"yellow-900\": $yellow-900\n) !default;\n\n$greens: (\n  \"green-100\": $green-100,\n  \"green-200\": $green-200,\n  \"green-300\": $green-300,\n  \"green-400\": $green-400,\n  \"green-500\": $green-500,\n  \"green-600\": $green-600,\n  \"green-700\": $green-700,\n  \"green-800\": $green-800,\n  \"green-900\": $green-900\n) !default;\n\n$teals: (\n  \"teal-100\": $teal-100,\n  \"teal-200\": $teal-200,\n  \"teal-300\": $teal-300,\n  \"teal-400\": $teal-400,\n  \"teal-500\": $teal-500,\n  \"teal-600\": $teal-600,\n  \"teal-700\": $teal-700,\n  \"teal-800\": $teal-800,\n  \"teal-900\": $teal-900\n) !default;\n\n$cyans: (\n  \"cyan-100\": $cyan-100,\n  \"cyan-200\": $cyan-200,\n  \"cyan-300\": $cyan-300,\n  \"cyan-400\": $cyan-400,\n  \"cyan-500\": $cyan-500,\n  \"cyan-600\": $cyan-600,\n  \"cyan-700\": $cyan-700,\n  \"cyan-800\": $cyan-800,\n  \"cyan-900\": $cyan-900\n) !default;\n// fusv-enable\n\n// scss-docs-start theme-color-variables\n$primary:       $blue !default;\n$secondary:     $gray-600 !default;\n$success:       $green !default;\n$info:          $cyan !default;\n$warning:       $yellow !default;\n$danger:        $red !default;\n$light:         $gray-100 !default;\n$dark:          $gray-900 !default;\n// scss-docs-end theme-color-variables\n\n// scss-docs-start theme-colors-map\n$theme-colors: (\n  \"primary\":    $primary,\n  \"secondary\":  $secondary,\n  \"success\":    $success,\n  \"info\":       $info,\n  \"warning\":    $warning,\n  \"danger\":     $danger,\n  \"light\":      $light,\n  \"dark\":       $dark\n) !default;\n// scss-docs-end theme-colors-map\n\n// Characters which are escaped by the escape-svg function\n$escaped-characters: (\n  (\"<\", \"%3c\"),\n  (\">\", \"%3e\"),\n  (\"#\", \"%23\"),\n  (\"(\", \"%28\"),\n  (\")\", \"%29\"),\n) !default;\n\n// Options\n//\n// Quickly modify global styling by enabling or disabling optional features.\n\n$enable-caret:                true !default;\n$enable-rounded:              true !default;\n$enable-shadows:              false !default;\n$enable-gradients:            false !default;\n$enable-transitions:          true !default;\n$enable-reduced-motion:       true !default;\n$enable-smooth-scroll:        true !default;\n$enable-grid-classes:         true !default;\n$enable-container-classes:    true !default;\n$enable-cssgrid:              false !default;\n$enable-button-pointers:      true !default;\n$enable-rfs:                  true !default;\n$enable-validation-icons:     true !default;\n$enable-negative-margins:     false !default;\n$enable-deprecation-messages: true !default;\n$enable-important-utilities:  true !default;\n\n// Prefix for :root CSS variables\n\n$variable-prefix:             bs- !default; // Deprecated in v5.2.0 for the shorter `$prefix`\n$prefix:                      $variable-prefix !default;\n\n// Gradient\n//\n// The gradient which is added to components if `$enable-gradients` is `true`\n// This gradient is also added to elements with `.bg-gradient`\n// scss-docs-start variable-gradient\n$gradient: linear-gradient(180deg, rgba($white, .15), rgba($white, 0)) !default;\n// scss-docs-end variable-gradient\n\n// Spacing\n//\n// Control the default styling of most Bootstrap elements by modifying these\n// variables. Mostly focused on spacing.\n// You can add more entries to the $spacers map, should you need more variation.\n\n// scss-docs-start spacer-variables-maps\n$spacer: 1rem !default;\n$spacers: (\n  0: 0,\n  1: $spacer * .25,\n  2: $spacer * .5,\n  3: $spacer,\n  4: $spacer * 1.5,\n  5: $spacer * 3,\n) !default;\n// scss-docs-end spacer-variables-maps\n\n// Position\n//\n// Define the edge positioning anchors of the position utilities.\n\n// scss-docs-start position-map\n$position-values: (\n  0: 0,\n  50: 50%,\n  100: 100%\n) !default;\n// scss-docs-end position-map\n\n// Body\n//\n// Settings for the `<body>` element.\n\n$body-bg:                   $white !default;\n$body-color:                $gray-900 !default;\n$body-text-align:           null !default;\n\n// Links\n//\n// Style anchor elements.\n\n$link-color:                              $primary !default;\n$link-decoration:                         underline !default;\n$link-shade-percentage:                   20% !default;\n$link-hover-color:                        shift-color($link-color, $link-shade-percentage) !default;\n$link-hover-decoration:                   null !default;\n\n$stretched-link-pseudo-element:           after !default;\n$stretched-link-z-index:                  1 !default;\n\n// Paragraphs\n//\n// Style p element.\n\n$paragraph-margin-bottom:   1rem !default;\n\n\n// Grid breakpoints\n//\n// Define the minimum dimensions at which your layout will change,\n// adapting to different screen sizes, for use in media queries.\n\n// scss-docs-start grid-breakpoints\n$grid-breakpoints: (\n  xs: 0,\n  sm: 576px,\n  md: 768px,\n  lg: 992px,\n  xl: 1200px,\n  xxl: 1400px\n) !default;\n// scss-docs-end grid-breakpoints\n\n@include _assert-ascending($grid-breakpoints, \"$grid-breakpoints\");\n@include _assert-starts-at-zero($grid-breakpoints, \"$grid-breakpoints\");\n\n\n// Grid containers\n//\n// Define the maximum width of `.container` for different screen sizes.\n\n// scss-docs-start container-max-widths\n$container-max-widths: (\n  sm: 540px,\n  md: 720px,\n  lg: 960px,\n  xl: 1140px,\n  xxl: 1320px\n) !default;\n// scss-docs-end container-max-widths\n\n@include _assert-ascending($container-max-widths, \"$container-max-widths\");\n\n\n// Grid columns\n//\n// Set the number of columns and specify the width of the gutters.\n\n$grid-columns:                12 !default;\n$grid-gutter-width:           1.5rem !default;\n$grid-row-columns:            6 !default;\n\n// Container padding\n\n$container-padding-x: $grid-gutter-width !default;\n\n\n// Components\n//\n// Define common padding and border radius sizes and more.\n\n// scss-docs-start border-variables\n$border-width:                1px !default;\n$border-widths: (\n  1: 1px,\n  2: 2px,\n  3: 3px,\n  4: 4px,\n  5: 5px\n) !default;\n\n$border-style:                solid !default;\n$border-color:                $gray-300 !default;\n$border-color-translucent:    rgba($black, .175) !default;\n// scss-docs-end border-variables\n\n// scss-docs-start border-radius-variables\n$border-radius:               .375rem !default;\n$border-radius-sm:            .25rem !default;\n$border-radius-lg:            .5rem !default;\n$border-radius-xl:            1rem !default;\n$border-radius-2xl:           2rem !default;\n$border-radius-pill:          50rem !default;\n// scss-docs-end border-radius-variables\n\n// scss-docs-start box-shadow-variables\n$box-shadow:                  0 .5rem 1rem rgba($black, .15) !default;\n$box-shadow-sm:               0 .125rem .25rem rgba($black, .075) !default;\n$box-shadow-lg:               0 1rem 3rem rgba($black, .175) !default;\n$box-shadow-inset:            inset 0 1px 2px rgba($black, .075) !default;\n// scss-docs-end box-shadow-variables\n\n$component-active-color:      $white !default;\n$component-active-bg:         $primary !default;\n\n// scss-docs-start caret-variables\n$caret-width:                 .3em !default;\n$caret-vertical-align:        $caret-width * .85 !default;\n$caret-spacing:               $caret-width * .85 !default;\n// scss-docs-end caret-variables\n\n$transition-base:             all .2s ease-in-out !default;\n$transition-fade:             opacity .15s linear !default;\n// scss-docs-start collapse-transition\n$transition-collapse:         height .35s ease !default;\n$transition-collapse-width:   width .35s ease !default;\n// scss-docs-end collapse-transition\n\n// stylelint-disable function-disallowed-list\n// scss-docs-start aspect-ratios\n$aspect-ratios: (\n  \"1x1\": 100%,\n  \"4x3\": calc(3 / 4 * 100%),\n  \"16x9\": calc(9 / 16 * 100%),\n  \"21x9\": calc(9 / 21 * 100%)\n) !default;\n// scss-docs-end aspect-ratios\n// stylelint-enable function-disallowed-list\n\n// Typography\n//\n// Font, line-height, and color for body text, headings, and more.\n\n// scss-docs-start font-variables\n// stylelint-disable value-keyword-case\n$font-family-sans-serif:      system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\" !default;\n$font-family-monospace:       SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace !default;\n// stylelint-enable value-keyword-case\n$font-family-base:            var(--#{$prefix}font-sans-serif) !default;\n$font-family-code:            var(--#{$prefix}font-monospace) !default;\n\n// $font-size-root affects the value of `rem`, which is used for as well font sizes, paddings, and margins\n// $font-size-base affects the font size of the body text\n$font-size-root:              null !default;\n$font-size-base:              1rem !default; // Assumes the browser default, typically `16px`\n$font-size-sm:                $font-size-base * .875 !default;\n$font-size-lg:                $font-size-base * 1.25 !default;\n\n$font-weight-lighter:         lighter !default;\n$font-weight-light:           300 !default;\n$font-weight-normal:          400 !default;\n$font-weight-semibold:        600 !default;\n$font-weight-bold:            700 !default;\n$font-weight-bolder:          bolder !default;\n\n$font-weight-base:            $font-weight-normal !default;\n\n$line-height-base:            1.5 !default;\n$line-height-sm:              1.25 !default;\n$line-height-lg:              2 !default;\n\n$h1-font-size:                $font-size-base * 2.5 !default;\n$h2-font-size:                $font-size-base * 2 !default;\n$h3-font-size:                $font-size-base * 1.75 !default;\n$h4-font-size:                $font-size-base * 1.5 !default;\n$h5-font-size:                $font-size-base * 1.25 !default;\n$h6-font-size:                $font-size-base !default;\n// scss-docs-end font-variables\n\n// scss-docs-start font-sizes\n$font-sizes: (\n  1: $h1-font-size,\n  2: $h2-font-size,\n  3: $h3-font-size,\n  4: $h4-font-size,\n  5: $h5-font-size,\n  6: $h6-font-size\n) !default;\n// scss-docs-end font-sizes\n\n// scss-docs-start headings-variables\n$headings-margin-bottom:      $spacer * .5 !default;\n$headings-font-family:        null !default;\n$headings-font-style:         null !default;\n$headings-font-weight:        500 !default;\n$headings-line-height:        1.2 !default;\n$headings-color:              null !default;\n// scss-docs-end headings-variables\n\n// scss-docs-start display-headings\n$display-font-sizes: (\n  1: 5rem,\n  2: 4.5rem,\n  3: 4rem,\n  4: 3.5rem,\n  5: 3rem,\n  6: 2.5rem\n) !default;\n\n$display-font-family: null !default;\n$display-font-style:  null !default;\n$display-font-weight: 300 !default;\n$display-line-height: $headings-line-height !default;\n// scss-docs-end display-headings\n\n// scss-docs-start type-variables\n$lead-font-size:              $font-size-base * 1.25 !default;\n$lead-font-weight:            300 !default;\n\n$small-font-size:             .875em !default;\n\n$sub-sup-font-size:           .75em !default;\n\n$text-muted:                  $gray-600 !default;\n\n$initialism-font-size:        $small-font-size !default;\n\n$blockquote-margin-y:         $spacer !default;\n$blockquote-font-size:        $font-size-base * 1.25 !default;\n$blockquote-footer-color:     $gray-600 !default;\n$blockquote-footer-font-size: $small-font-size !default;\n\n$hr-margin-y:                 $spacer !default;\n$hr-color:                    inherit !default;\n\n// fusv-disable\n$hr-bg-color:                 null !default; // Deprecated in v5.2.0\n$hr-height:                   null !default; // Deprecated in v5.2.0\n// fusv-enable\n\n$hr-border-color:             null !default; // Allows for inherited colors\n$hr-border-width:             $border-width !default;\n$hr-opacity:                  .25 !default;\n\n$legend-margin-bottom:        .5rem !default;\n$legend-font-size:            1.5rem !default;\n$legend-font-weight:          null !default;\n\n$dt-font-weight:              $font-weight-bold !default;\n\n$list-inline-padding:         .5rem !default;\n\n$mark-padding:                .1875em !default;\n$mark-bg:                     $yellow-100 !default;\n// scss-docs-end type-variables\n\n\n// Tables\n//\n// Customizes the `.table` component with basic values, each used across all table variations.\n\n// scss-docs-start table-variables\n$table-cell-padding-y:        .5rem !default;\n$table-cell-padding-x:        .5rem !default;\n$table-cell-padding-y-sm:     .25rem !default;\n$table-cell-padding-x-sm:     .25rem !default;\n\n$table-cell-vertical-align:   top !default;\n\n$table-color:                 var(--#{$prefix}body-color) !default;\n$table-bg:                    transparent !default;\n$table-accent-bg:             transparent !default;\n\n$table-th-font-weight:        null !default;\n\n$table-striped-color:         $table-color !default;\n$table-striped-bg-factor:     .05 !default;\n$table-striped-bg:            rgba($black, $table-striped-bg-factor) !default;\n\n$table-active-color:          $table-color !default;\n$table-active-bg-factor:      .1 !default;\n$table-active-bg:             rgba($black, $table-active-bg-factor) !default;\n\n$table-hover-color:           $table-color !default;\n$table-hover-bg-factor:       .075 !default;\n$table-hover-bg:              rgba($black, $table-hover-bg-factor) !default;\n\n$table-border-factor:         .1 !default;\n$table-border-width:          $border-width !default;\n$table-border-color:          var(--#{$prefix}border-color) !default;\n\n$table-striped-order:         odd !default;\n$table-striped-columns-order: even !default;\n\n$table-group-separator-color: currentcolor !default;\n\n$table-caption-color:         $text-muted !default;\n\n$table-bg-scale:              -80% !default;\n// scss-docs-end table-variables\n\n// scss-docs-start table-loop\n$table-variants: (\n  \"primary\":    shift-color($primary, $table-bg-scale),\n  \"secondary\":  shift-color($secondary, $table-bg-scale),\n  \"success\":    shift-color($success, $table-bg-scale),\n  \"info\":       shift-color($info, $table-bg-scale),\n  \"warning\":    shift-color($warning, $table-bg-scale),\n  \"danger\":     shift-color($danger, $table-bg-scale),\n  \"light\":      $light,\n  \"dark\":       $dark,\n) !default;\n// scss-docs-end table-loop\n\n\n// Buttons + Forms\n//\n// Shared variables that are reassigned to `$input-` and `$btn-` specific variables.\n\n// scss-docs-start input-btn-variables\n$input-btn-padding-y:         .375rem !default;\n$input-btn-padding-x:         .75rem !default;\n$input-btn-font-family:       null !default;\n$input-btn-font-size:         $font-size-base !default;\n$input-btn-line-height:       $line-height-base !default;\n\n$input-btn-focus-width:         .25rem !default;\n$input-btn-focus-color-opacity: .25 !default;\n$input-btn-focus-color:         rgba($component-active-bg, $input-btn-focus-color-opacity) !default;\n$input-btn-focus-blur:          0 !default;\n$input-btn-focus-box-shadow:    0 0 $input-btn-focus-blur $input-btn-focus-width $input-btn-focus-color !default;\n\n$input-btn-padding-y-sm:      .25rem !default;\n$input-btn-padding-x-sm:      .5rem !default;\n$input-btn-font-size-sm:      $font-size-sm !default;\n\n$input-btn-padding-y-lg:      .5rem !default;\n$input-btn-padding-x-lg:      1rem !default;\n$input-btn-font-size-lg:      $font-size-lg !default;\n\n$input-btn-border-width:      $border-width !default;\n// scss-docs-end input-btn-variables\n\n\n// Buttons\n//\n// For each of Bootstrap's buttons, define text, background, and border color.\n\n// scss-docs-start btn-variables\n$btn-padding-y:               $input-btn-padding-y !default;\n$btn-padding-x:               $input-btn-padding-x !default;\n$btn-font-family:             $input-btn-font-family !default;\n$btn-font-size:               $input-btn-font-size !default;\n$btn-line-height:             $input-btn-line-height !default;\n$btn-white-space:             null !default; // Set to `nowrap` to prevent text wrapping\n\n$btn-padding-y-sm:            $input-btn-padding-y-sm !default;\n$btn-padding-x-sm:            $input-btn-padding-x-sm !default;\n$btn-font-size-sm:            $input-btn-font-size-sm !default;\n\n$btn-padding-y-lg:            $input-btn-padding-y-lg !default;\n$btn-padding-x-lg:            $input-btn-padding-x-lg !default;\n$btn-font-size-lg:            $input-btn-font-size-lg !default;\n\n$btn-border-width:            $input-btn-border-width !default;\n\n$btn-font-weight:             $font-weight-normal !default;\n$btn-box-shadow:              inset 0 1px 0 rgba($white, .15), 0 1px 1px rgba($black, .075) !default;\n$btn-focus-width:             $input-btn-focus-width !default;\n$btn-focus-box-shadow:        $input-btn-focus-box-shadow !default;\n$btn-disabled-opacity:        .65 !default;\n$btn-active-box-shadow:       inset 0 3px 5px rgba($black, .125) !default;\n\n$btn-link-color:              var(--#{$prefix}link-color) !default;\n$btn-link-hover-color:        var(--#{$prefix}link-hover-color) !default;\n$btn-link-disabled-color:     $gray-600 !default;\n\n// Allows for customizing button radius independently from global border radius\n$btn-border-radius:           $border-radius !default;\n$btn-border-radius-sm:        $border-radius-sm !default;\n$btn-border-radius-lg:        $border-radius-lg !default;\n\n$btn-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$btn-hover-bg-shade-amount:       15% !default;\n$btn-hover-bg-tint-amount:        15% !default;\n$btn-hover-border-shade-amount:   20% !default;\n$btn-hover-border-tint-amount:    10% !default;\n$btn-active-bg-shade-amount:      20% !default;\n$btn-active-bg-tint-amount:       20% !default;\n$btn-active-border-shade-amount:  25% !default;\n$btn-active-border-tint-amount:   10% !default;\n// scss-docs-end btn-variables\n\n\n// Forms\n\n// scss-docs-start form-text-variables\n$form-text-margin-top:                  .25rem !default;\n$form-text-font-size:                   $small-font-size !default;\n$form-text-font-style:                  null !default;\n$form-text-font-weight:                 null !default;\n$form-text-color:                       $text-muted !default;\n// scss-docs-end form-text-variables\n\n// scss-docs-start form-label-variables\n$form-label-margin-bottom:              .5rem !default;\n$form-label-font-size:                  null !default;\n$form-label-font-style:                 null !default;\n$form-label-font-weight:                null !default;\n$form-label-color:                      null !default;\n// scss-docs-end form-label-variables\n\n// scss-docs-start form-input-variables\n$input-padding-y:                       $input-btn-padding-y !default;\n$input-padding-x:                       $input-btn-padding-x !default;\n$input-font-family:                     $input-btn-font-family !default;\n$input-font-size:                       $input-btn-font-size !default;\n$input-font-weight:                     $font-weight-base !default;\n$input-line-height:                     $input-btn-line-height !default;\n\n$input-padding-y-sm:                    $input-btn-padding-y-sm !default;\n$input-padding-x-sm:                    $input-btn-padding-x-sm !default;\n$input-font-size-sm:                    $input-btn-font-size-sm !default;\n\n$input-padding-y-lg:                    $input-btn-padding-y-lg !default;\n$input-padding-x-lg:                    $input-btn-padding-x-lg !default;\n$input-font-size-lg:                    $input-btn-font-size-lg !default;\n\n$input-bg:                              $body-bg !default;\n$input-disabled-color:                  null !default;\n$input-disabled-bg:                     $gray-200 !default;\n$input-disabled-border-color:           null !default;\n\n$input-color:                           $body-color !default;\n$input-border-color:                    $gray-400 !default;\n$input-border-width:                    $input-btn-border-width !default;\n$input-box-shadow:                      $box-shadow-inset !default;\n\n$input-border-radius:                   $border-radius !default;\n$input-border-radius-sm:                $border-radius-sm !default;\n$input-border-radius-lg:                $border-radius-lg !default;\n\n$input-focus-bg:                        $input-bg !default;\n$input-focus-border-color:              tint-color($component-active-bg, 50%) !default;\n$input-focus-color:                     $input-color !default;\n$input-focus-width:                     $input-btn-focus-width !default;\n$input-focus-box-shadow:                $input-btn-focus-box-shadow !default;\n\n$input-placeholder-color:               $gray-600 !default;\n$input-plaintext-color:                 $body-color !default;\n\n$input-height-border:                   $input-border-width * 2 !default;\n\n$input-height-inner:                    add($input-line-height * 1em, $input-padding-y * 2) !default;\n$input-height-inner-half:               add($input-line-height * .5em, $input-padding-y) !default;\n$input-height-inner-quarter:            add($input-line-height * .25em, $input-padding-y * .5) !default;\n\n$input-height:                          add($input-line-height * 1em, add($input-padding-y * 2, $input-height-border, false)) !default;\n$input-height-sm:                       add($input-line-height * 1em, add($input-padding-y-sm * 2, $input-height-border, false)) !default;\n$input-height-lg:                       add($input-line-height * 1em, add($input-padding-y-lg * 2, $input-height-border, false)) !default;\n\n$input-transition:                      border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$form-color-width:                      3rem !default;\n// scss-docs-end form-input-variables\n\n// scss-docs-start form-check-variables\n$form-check-input-width:                  1em !default;\n$form-check-min-height:                   $font-size-base * $line-height-base !default;\n$form-check-padding-start:                $form-check-input-width + .5em !default;\n$form-check-margin-bottom:                .125rem !default;\n$form-check-label-color:                  null !default;\n$form-check-label-cursor:                 null !default;\n$form-check-transition:                   null !default;\n\n$form-check-input-active-filter:          brightness(90%) !default;\n\n$form-check-input-bg:                     $input-bg !default;\n$form-check-input-border:                 1px solid rgba($black, .25) !default;\n$form-check-input-border-radius:          .25em !default;\n$form-check-radio-border-radius:          50% !default;\n$form-check-input-focus-border:           $input-focus-border-color !default;\n$form-check-input-focus-box-shadow:       $input-btn-focus-box-shadow !default;\n\n$form-check-input-checked-color:          $component-active-color !default;\n$form-check-input-checked-bg-color:       $component-active-bg !default;\n$form-check-input-checked-border-color:   $form-check-input-checked-bg-color !default;\n$form-check-input-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-checked-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='m6 10 3 3 6-6'/></svg>\") !default;\n$form-check-radio-checked-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='2' fill='#{$form-check-input-checked-color}'/></svg>\") !default;\n\n$form-check-input-indeterminate-color:          $component-active-color !default;\n$form-check-input-indeterminate-bg-color:       $component-active-bg !default;\n$form-check-input-indeterminate-border-color:   $form-check-input-indeterminate-bg-color !default;\n$form-check-input-indeterminate-bg-image:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'><path fill='none' stroke='#{$form-check-input-indeterminate-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10h8'/></svg>\") !default;\n\n$form-check-input-disabled-opacity:        .5 !default;\n$form-check-label-disabled-opacity:        $form-check-input-disabled-opacity !default;\n$form-check-btn-check-disabled-opacity:    $btn-disabled-opacity !default;\n\n$form-check-inline-margin-end:    1rem !default;\n// scss-docs-end form-check-variables\n\n// scss-docs-start form-switch-variables\n$form-switch-color:               rgba($black, .25) !default;\n$form-switch-width:               2em !default;\n$form-switch-padding-start:       $form-switch-width + .5em !default;\n$form-switch-bg-image:            url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-color}'/></svg>\") !default;\n$form-switch-border-radius:       $form-switch-width !default;\n$form-switch-transition:          background-position .15s ease-in-out !default;\n\n$form-switch-focus-color:         $input-focus-border-color !default;\n$form-switch-focus-bg-image:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-focus-color}'/></svg>\") !default;\n\n$form-switch-checked-color:       $component-active-color !default;\n$form-switch-checked-bg-image:    url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$form-switch-checked-color}'/></svg>\") !default;\n$form-switch-checked-bg-position: right center !default;\n// scss-docs-end form-switch-variables\n\n// scss-docs-start input-group-variables\n$input-group-addon-padding-y:           $input-padding-y !default;\n$input-group-addon-padding-x:           $input-padding-x !default;\n$input-group-addon-font-weight:         $input-font-weight !default;\n$input-group-addon-color:               $input-color !default;\n$input-group-addon-bg:                  $gray-200 !default;\n$input-group-addon-border-color:        $input-border-color !default;\n// scss-docs-end input-group-variables\n\n// scss-docs-start form-select-variables\n$form-select-padding-y:             $input-padding-y !default;\n$form-select-padding-x:             $input-padding-x !default;\n$form-select-font-family:           $input-font-family !default;\n$form-select-font-size:             $input-font-size !default;\n$form-select-indicator-padding:     $form-select-padding-x * 3 !default; // Extra padding for background-image\n$form-select-font-weight:           $input-font-weight !default;\n$form-select-line-height:           $input-line-height !default;\n$form-select-color:                 $input-color !default;\n$form-select-bg:                    $input-bg !default;\n$form-select-disabled-color:        null !default;\n$form-select-disabled-bg:           $gray-200 !default;\n$form-select-disabled-border-color: $input-disabled-border-color !default;\n$form-select-bg-position:           right $form-select-padding-x center !default;\n$form-select-bg-size:               16px 12px !default; // In pixels because image dimensions\n$form-select-indicator-color:       $gray-800 !default;\n$form-select-indicator:             url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path fill='none' stroke='#{$form-select-indicator-color}' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='m2 5 6 6 6-6'/></svg>\") !default;\n\n$form-select-feedback-icon-padding-end: $form-select-padding-x * 2.5 + $form-select-indicator-padding !default;\n$form-select-feedback-icon-position:    center right $form-select-indicator-padding !default;\n$form-select-feedback-icon-size:        $input-height-inner-half $input-height-inner-half !default;\n\n$form-select-border-width:        $input-border-width !default;\n$form-select-border-color:        $input-border-color !default;\n$form-select-border-radius:       $input-border-radius !default;\n$form-select-box-shadow:          $box-shadow-inset !default;\n\n$form-select-focus-border-color:  $input-focus-border-color !default;\n$form-select-focus-width:         $input-focus-width !default;\n$form-select-focus-box-shadow:    0 0 0 $form-select-focus-width $input-btn-focus-color !default;\n\n$form-select-padding-y-sm:        $input-padding-y-sm !default;\n$form-select-padding-x-sm:        $input-padding-x-sm !default;\n$form-select-font-size-sm:        $input-font-size-sm !default;\n$form-select-border-radius-sm:    $input-border-radius-sm !default;\n\n$form-select-padding-y-lg:        $input-padding-y-lg !default;\n$form-select-padding-x-lg:        $input-padding-x-lg !default;\n$form-select-font-size-lg:        $input-font-size-lg !default;\n$form-select-border-radius-lg:    $input-border-radius-lg !default;\n\n$form-select-transition:          $input-transition !default;\n// scss-docs-end form-select-variables\n\n// scss-docs-start form-range-variables\n$form-range-track-width:          100% !default;\n$form-range-track-height:         .5rem !default;\n$form-range-track-cursor:         pointer !default;\n$form-range-track-bg:             $gray-300 !default;\n$form-range-track-border-radius:  1rem !default;\n$form-range-track-box-shadow:     $box-shadow-inset !default;\n\n$form-range-thumb-width:                   1rem !default;\n$form-range-thumb-height:                  $form-range-thumb-width !default;\n$form-range-thumb-bg:                      $component-active-bg !default;\n$form-range-thumb-border:                  0 !default;\n$form-range-thumb-border-radius:           1rem !default;\n$form-range-thumb-box-shadow:              0 .1rem .25rem rgba($black, .1) !default;\n$form-range-thumb-focus-box-shadow:        0 0 0 1px $body-bg, $input-focus-box-shadow !default;\n$form-range-thumb-focus-box-shadow-width:  $input-focus-width !default; // For focus box shadow issue in Edge\n$form-range-thumb-active-bg:               tint-color($component-active-bg, 70%) !default;\n$form-range-thumb-disabled-bg:             $gray-500 !default;\n$form-range-thumb-transition:              background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n// scss-docs-end form-range-variables\n\n// scss-docs-start form-file-variables\n$form-file-button-color:          $input-color !default;\n$form-file-button-bg:             $input-group-addon-bg !default;\n$form-file-button-hover-bg:       shade-color($form-file-button-bg, 5%) !default;\n// scss-docs-end form-file-variables\n\n// scss-docs-start form-floating-variables\n$form-floating-height:            add(3.5rem, $input-height-border) !default;\n$form-floating-line-height:       1.25 !default;\n$form-floating-padding-x:         $input-padding-x !default;\n$form-floating-padding-y:         1rem !default;\n$form-floating-input-padding-t:   1.625rem !default;\n$form-floating-input-padding-b:   .625rem !default;\n$form-floating-label-opacity:     .65 !default;\n$form-floating-label-transform:   scale(.85) translateY(-.5rem) translateX(.15rem) !default;\n$form-floating-transition:        opacity .1s ease-in-out, transform .1s ease-in-out !default;\n// scss-docs-end form-floating-variables\n\n// Form validation\n\n// scss-docs-start form-feedback-variables\n$form-feedback-margin-top:          $form-text-margin-top !default;\n$form-feedback-font-size:           $form-text-font-size !default;\n$form-feedback-font-style:          $form-text-font-style !default;\n$form-feedback-valid-color:         $success !default;\n$form-feedback-invalid-color:       $danger !default;\n\n$form-feedback-icon-valid-color:    $form-feedback-valid-color !default;\n$form-feedback-icon-valid:          url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 8 8'><path fill='#{$form-feedback-icon-valid-color}' d='M2.3 6.73.6 4.53c-.4-1.04.46-1.4 1.1-.8l1.1 1.4 3.4-3.8c.6-.63 1.6-.27 1.2.7l-4 4.6c-.43.5-.8.4-1.1.1z'/></svg>\") !default;\n$form-feedback-icon-invalid-color:  $form-feedback-invalid-color !default;\n$form-feedback-icon-invalid:        url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 12 12' width='12' height='12' fill='none' stroke='#{$form-feedback-icon-invalid-color}'><circle cx='6' cy='6' r='4.5'/><path stroke-linejoin='round' d='M5.8 3.6h.4L6 6.5z'/><circle cx='6' cy='8.2' r='.6' fill='#{$form-feedback-icon-invalid-color}' stroke='none'/></svg>\") !default;\n// scss-docs-end form-feedback-variables\n\n// scss-docs-start form-validation-states\n$form-validation-states: (\n  \"valid\": (\n    \"color\": $form-feedback-valid-color,\n    \"icon\": $form-feedback-icon-valid\n  ),\n  \"invalid\": (\n    \"color\": $form-feedback-invalid-color,\n    \"icon\": $form-feedback-icon-invalid\n  )\n) !default;\n// scss-docs-end form-validation-states\n\n// Z-index master list\n//\n// Warning: Avoid customizing these values. They're used for a bird's eye view\n// of components dependent on the z-axis and are designed to all work together.\n\n// scss-docs-start zindex-stack\n$zindex-dropdown:                   1000 !default;\n$zindex-sticky:                     1020 !default;\n$zindex-fixed:                      1030 !default;\n$zindex-offcanvas-backdrop:         1040 !default;\n$zindex-offcanvas:                  1045 !default;\n$zindex-modal-backdrop:             1050 !default;\n$zindex-modal:                      1055 !default;\n$zindex-popover:                    1070 !default;\n$zindex-tooltip:                    1080 !default;\n$zindex-toast:                      1090 !default;\n// scss-docs-end zindex-stack\n\n\n// Navs\n\n// scss-docs-start nav-variables\n$nav-link-padding-y:                .5rem !default;\n$nav-link-padding-x:                1rem !default;\n$nav-link-font-size:                null !default;\n$nav-link-font-weight:              null !default;\n$nav-link-color:                    var(--#{$prefix}link-color) !default;\n$nav-link-hover-color:              var(--#{$prefix}link-hover-color) !default;\n$nav-link-transition:               color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out !default;\n$nav-link-disabled-color:           $gray-600 !default;\n\n$nav-tabs-border-color:             $gray-300 !default;\n$nav-tabs-border-width:             $border-width !default;\n$nav-tabs-border-radius:            $border-radius !default;\n$nav-tabs-link-hover-border-color:  $gray-200 $gray-200 $nav-tabs-border-color !default;\n$nav-tabs-link-active-color:        $gray-700 !default;\n$nav-tabs-link-active-bg:           $body-bg !default;\n$nav-tabs-link-active-border-color: $gray-300 $gray-300 $nav-tabs-link-active-bg !default;\n\n$nav-pills-border-radius:           $border-radius !default;\n$nav-pills-link-active-color:       $component-active-color !default;\n$nav-pills-link-active-bg:          $component-active-bg !default;\n// scss-docs-end nav-variables\n\n\n// Navbar\n\n// scss-docs-start navbar-variables\n$navbar-padding-y:                  $spacer * .5 !default;\n$navbar-padding-x:                  null !default;\n\n$navbar-nav-link-padding-x:         .5rem !default;\n\n$navbar-brand-font-size:            $font-size-lg !default;\n// Compute the navbar-brand padding-y so the navbar-brand will have the same height as navbar-text and nav-link\n$nav-link-height:                   $font-size-base * $line-height-base + $nav-link-padding-y * 2 !default;\n$navbar-brand-height:               $navbar-brand-font-size * $line-height-base !default;\n$navbar-brand-padding-y:            ($nav-link-height - $navbar-brand-height) * .5 !default;\n$navbar-brand-margin-end:           1rem !default;\n\n$navbar-toggler-padding-y:          .25rem !default;\n$navbar-toggler-padding-x:          .75rem !default;\n$navbar-toggler-font-size:          $font-size-lg !default;\n$navbar-toggler-border-radius:      $btn-border-radius !default;\n$navbar-toggler-focus-width:        $btn-focus-width !default;\n$navbar-toggler-transition:         box-shadow .15s ease-in-out !default;\n\n$navbar-light-color:                rgba($black, .55) !default;\n$navbar-light-hover-color:          rgba($black, .7) !default;\n$navbar-light-active-color:         rgba($black, .9) !default;\n$navbar-light-disabled-color:       rgba($black, .3) !default;\n$navbar-light-toggler-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-light-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-light-toggler-border-color: rgba($black, .1) !default;\n$navbar-light-brand-color:          $navbar-light-active-color !default;\n$navbar-light-brand-hover-color:    $navbar-light-active-color !default;\n// scss-docs-end navbar-variables\n\n// scss-docs-start navbar-dark-variables\n$navbar-dark-color:                 rgba($white, .55) !default;\n$navbar-dark-hover-color:           rgba($white, .75) !default;\n$navbar-dark-active-color:          $white !default;\n$navbar-dark-disabled-color:        rgba($white, .25) !default;\n$navbar-dark-toggler-icon-bg:       url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'><path stroke='#{$navbar-dark-color}' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/></svg>\") !default;\n$navbar-dark-toggler-border-color:  rgba($white, .1) !default;\n$navbar-dark-brand-color:           $navbar-dark-active-color !default;\n$navbar-dark-brand-hover-color:     $navbar-dark-active-color !default;\n// scss-docs-end navbar-dark-variables\n\n\n// Dropdowns\n//\n// Dropdown menu container and contents.\n\n// scss-docs-start dropdown-variables\n$dropdown-min-width:                10rem !default;\n$dropdown-padding-x:                0 !default;\n$dropdown-padding-y:                .5rem !default;\n$dropdown-spacer:                   .125rem !default;\n$dropdown-font-size:                $font-size-base !default;\n$dropdown-color:                    $body-color !default;\n$dropdown-bg:                       $white !default;\n$dropdown-border-color:             var(--#{$prefix}border-color-translucent) !default;\n$dropdown-border-radius:            $border-radius !default;\n$dropdown-border-width:             $border-width !default;\n$dropdown-inner-border-radius:      subtract($dropdown-border-radius, $dropdown-border-width) !default;\n$dropdown-divider-bg:               $dropdown-border-color !default;\n$dropdown-divider-margin-y:         $spacer * .5 !default;\n$dropdown-box-shadow:               $box-shadow !default;\n\n$dropdown-link-color:               $gray-900 !default;\n$dropdown-link-hover-color:         shade-color($dropdown-link-color, 10%) !default;\n$dropdown-link-hover-bg:            $gray-200 !default;\n\n$dropdown-link-active-color:        $component-active-color !default;\n$dropdown-link-active-bg:           $component-active-bg !default;\n\n$dropdown-link-disabled-color:      $gray-500 !default;\n\n$dropdown-item-padding-y:           $spacer * .25 !default;\n$dropdown-item-padding-x:           $spacer !default;\n\n$dropdown-header-color:             $gray-600 !default;\n$dropdown-header-padding-x:         $dropdown-item-padding-x !default;\n$dropdown-header-padding-y:         $dropdown-padding-y !default;\n// fusv-disable\n$dropdown-header-padding:           $dropdown-header-padding-y $dropdown-header-padding-x !default; // Deprecated in v5.2.0\n// fusv-enable\n// scss-docs-end dropdown-variables\n\n// scss-docs-start dropdown-dark-variables\n$dropdown-dark-color:               $gray-300 !default;\n$dropdown-dark-bg:                  $gray-800 !default;\n$dropdown-dark-border-color:        $dropdown-border-color !default;\n$dropdown-dark-divider-bg:          $dropdown-divider-bg !default;\n$dropdown-dark-box-shadow:          null !default;\n$dropdown-dark-link-color:          $dropdown-dark-color !default;\n$dropdown-dark-link-hover-color:    $white !default;\n$dropdown-dark-link-hover-bg:       rgba($white, .15) !default;\n$dropdown-dark-link-active-color:   $dropdown-link-active-color !default;\n$dropdown-dark-link-active-bg:      $dropdown-link-active-bg !default;\n$dropdown-dark-link-disabled-color: $gray-500 !default;\n$dropdown-dark-header-color:        $gray-500 !default;\n// scss-docs-end dropdown-dark-variables\n\n\n// Pagination\n\n// scss-docs-start pagination-variables\n$pagination-padding-y:              .375rem !default;\n$pagination-padding-x:              .75rem !default;\n$pagination-padding-y-sm:           .25rem !default;\n$pagination-padding-x-sm:           .5rem !default;\n$pagination-padding-y-lg:           .75rem !default;\n$pagination-padding-x-lg:           1.5rem !default;\n\n$pagination-font-size:              $font-size-base !default;\n\n$pagination-color:                  var(--#{$prefix}link-color) !default;\n$pagination-bg:                     $white !default;\n$pagination-border-radius:          $border-radius !default;\n$pagination-border-width:           $border-width !default;\n$pagination-margin-start:           ($pagination-border-width * -1) !default;\n$pagination-border-color:           $gray-300 !default;\n\n$pagination-focus-color:            var(--#{$prefix}link-hover-color) !default;\n$pagination-focus-bg:               $gray-200 !default;\n$pagination-focus-box-shadow:       $input-btn-focus-box-shadow !default;\n$pagination-focus-outline:          0 !default;\n\n$pagination-hover-color:            var(--#{$prefix}link-hover-color) !default;\n$pagination-hover-bg:               $gray-200 !default;\n$pagination-hover-border-color:     $gray-300 !default;\n\n$pagination-active-color:           $component-active-color !default;\n$pagination-active-bg:              $component-active-bg !default;\n$pagination-active-border-color:    $pagination-active-bg !default;\n\n$pagination-disabled-color:         $gray-600 !default;\n$pagination-disabled-bg:            $white !default;\n$pagination-disabled-border-color:  $gray-300 !default;\n\n$pagination-transition:              color .15s ease-in-out, background-color .15s ease-in-out, border-color .15s ease-in-out, box-shadow .15s ease-in-out !default;\n\n$pagination-border-radius-sm:       $border-radius-sm !default;\n$pagination-border-radius-lg:       $border-radius-lg !default;\n// scss-docs-end pagination-variables\n\n\n// Placeholders\n\n// scss-docs-start placeholders\n$placeholder-opacity-max:           .5 !default;\n$placeholder-opacity-min:           .2 !default;\n// scss-docs-end placeholders\n\n// Cards\n\n// scss-docs-start card-variables\n$card-spacer-y:                     $spacer !default;\n$card-spacer-x:                     $spacer !default;\n$card-title-spacer-y:               $spacer * .5 !default;\n$card-border-width:                 $border-width !default;\n$card-border-color:                 var(--#{$prefix}border-color-translucent) !default;\n$card-border-radius:                $border-radius !default;\n$card-box-shadow:                   null !default;\n$card-inner-border-radius:          subtract($card-border-radius, $card-border-width) !default;\n$card-cap-padding-y:                $card-spacer-y * .5 !default;\n$card-cap-padding-x:                $card-spacer-x !default;\n$card-cap-bg:                       rgba($black, .03) !default;\n$card-cap-color:                    null !default;\n$card-height:                       null !default;\n$card-color:                        null !default;\n$card-bg:                           $white !default;\n$card-img-overlay-padding:          $spacer !default;\n$card-group-margin:                 $grid-gutter-width * .5 !default;\n// scss-docs-end card-variables\n\n// Accordion\n\n// scss-docs-start accordion-variables\n$accordion-padding-y:                     1rem !default;\n$accordion-padding-x:                     1.25rem !default;\n$accordion-color:                         $body-color !default; // Sass variable because of $accordion-button-icon\n$accordion-bg:                            $body-bg !default;\n$accordion-border-width:                  $border-width !default;\n$accordion-border-color:                  var(--#{$prefix}border-color) !default;\n$accordion-border-radius:                 $border-radius !default;\n$accordion-inner-border-radius:           subtract($accordion-border-radius, $accordion-border-width) !default;\n\n$accordion-body-padding-y:                $accordion-padding-y !default;\n$accordion-body-padding-x:                $accordion-padding-x !default;\n\n$accordion-button-padding-y:              $accordion-padding-y !default;\n$accordion-button-padding-x:              $accordion-padding-x !default;\n$accordion-button-color:                  $accordion-color !default;\n$accordion-button-bg:                     var(--#{$prefix}accordion-bg) !default;\n$accordion-transition:                    $btn-transition, border-radius .15s ease !default;\n$accordion-button-active-bg:              tint-color($component-active-bg, 90%) !default;\n$accordion-button-active-color:           shade-color($primary, 10%) !default;\n\n$accordion-button-focus-border-color:     $input-focus-border-color !default;\n$accordion-button-focus-box-shadow:       $btn-focus-box-shadow !default;\n\n$accordion-icon-width:                    1.25rem !default;\n$accordion-icon-color:                    $accordion-button-color !default;\n$accordion-icon-active-color:             $accordion-button-active-color !default;\n$accordion-icon-transition:               transform .2s ease-in-out !default;\n$accordion-icon-transform:                rotate(-180deg) !default;\n\n$accordion-button-icon:         url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$accordion-icon-color}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n$accordion-button-active-icon:  url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$accordion-icon-active-color}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n// scss-docs-end accordion-variables\n\n// Tooltips\n\n// scss-docs-start tooltip-variables\n$tooltip-font-size:                 $font-size-sm !default;\n$tooltip-max-width:                 200px !default;\n$tooltip-color:                     $white !default;\n$tooltip-bg:                        $black !default;\n$tooltip-border-radius:             $border-radius !default;\n$tooltip-opacity:                   .9 !default;\n$tooltip-padding-y:                 $spacer * .25 !default;\n$tooltip-padding-x:                 $spacer * .5 !default;\n$tooltip-margin:                    null !default; // TODO: remove this in v6\n\n$tooltip-arrow-width:               .8rem !default;\n$tooltip-arrow-height:              .4rem !default;\n// fusv-disable\n$tooltip-arrow-color:               null !default; // Deprecated in Bootstrap 5.2.0 for CSS variables\n// fusv-enable\n// scss-docs-end tooltip-variables\n\n// Form tooltips must come after regular tooltips\n// scss-docs-start tooltip-feedback-variables\n$form-feedback-tooltip-padding-y:     $tooltip-padding-y !default;\n$form-feedback-tooltip-padding-x:     $tooltip-padding-x !default;\n$form-feedback-tooltip-font-size:     $tooltip-font-size !default;\n$form-feedback-tooltip-line-height:   null !default;\n$form-feedback-tooltip-opacity:       $tooltip-opacity !default;\n$form-feedback-tooltip-border-radius: $tooltip-border-radius !default;\n// scss-docs-end tooltip-feedback-variables\n\n\n// Popovers\n\n// scss-docs-start popover-variables\n$popover-font-size:                 $font-size-sm !default;\n$popover-bg:                        $white !default;\n$popover-max-width:                 276px !default;\n$popover-border-width:              $border-width !default;\n$popover-border-color:              var(--#{$prefix}border-color-translucent) !default;\n$popover-border-radius:             $border-radius-lg !default;\n$popover-inner-border-radius:       subtract($popover-border-radius, $popover-border-width) !default;\n$popover-box-shadow:                $box-shadow !default;\n\n$popover-header-font-size:          $font-size-base !default;\n$popover-header-bg:                 shade-color($popover-bg, 6%) !default;\n$popover-header-color:              $headings-color !default;\n$popover-header-padding-y:          .5rem !default;\n$popover-header-padding-x:          $spacer !default;\n\n$popover-body-color:                $body-color !default;\n$popover-body-padding-y:            $spacer !default;\n$popover-body-padding-x:            $spacer !default;\n\n$popover-arrow-width:               1rem !default;\n$popover-arrow-height:              .5rem !default;\n// scss-docs-end popover-variables\n\n// fusv-disable\n// Deprecated in Bootstrap 5.2.0 for CSS variables\n$popover-arrow-color:               $popover-bg !default;\n$popover-arrow-outer-color:         var(--#{$prefix}border-color-translucent) !default;\n// fusv-enable\n\n\n// Toasts\n\n// scss-docs-start toast-variables\n$toast-max-width:                   350px !default;\n$toast-padding-x:                   .75rem !default;\n$toast-padding-y:                   .5rem !default;\n$toast-font-size:                   .875rem !default;\n$toast-color:                       null !default;\n$toast-background-color:            rgba($white, .85) !default;\n$toast-border-width:                $border-width !default;\n$toast-border-color:                var(--#{$prefix}border-color-translucent) !default;\n$toast-border-radius:               $border-radius !default;\n$toast-box-shadow:                  $box-shadow !default;\n$toast-spacing:                     $container-padding-x !default;\n\n$toast-header-color:                $gray-600 !default;\n$toast-header-background-color:     rgba($white, .85) !default;\n$toast-header-border-color:         rgba($black, .05) !default;\n// scss-docs-end toast-variables\n\n\n// Badges\n\n// scss-docs-start badge-variables\n$badge-font-size:                   .75em !default;\n$badge-font-weight:                 $font-weight-bold !default;\n$badge-color:                       $white !default;\n$badge-padding-y:                   .35em !default;\n$badge-padding-x:                   .65em !default;\n$badge-border-radius:               $border-radius !default;\n// scss-docs-end badge-variables\n\n\n// Modals\n\n// scss-docs-start modal-variables\n$modal-inner-padding:               $spacer !default;\n\n$modal-footer-margin-between:       .5rem !default;\n\n$modal-dialog-margin:               .5rem !default;\n$modal-dialog-margin-y-sm-up:       1.75rem !default;\n\n$modal-title-line-height:           $line-height-base !default;\n\n$modal-content-color:               null !default;\n$modal-content-bg:                  $white !default;\n$modal-content-border-color:        var(--#{$prefix}border-color-translucent) !default;\n$modal-content-border-width:        $border-width !default;\n$modal-content-border-radius:       $border-radius-lg !default;\n$modal-content-inner-border-radius: subtract($modal-content-border-radius, $modal-content-border-width) !default;\n$modal-content-box-shadow-xs:       $box-shadow-sm !default;\n$modal-content-box-shadow-sm-up:    $box-shadow !default;\n\n$modal-backdrop-bg:                 $black !default;\n$modal-backdrop-opacity:            .5 !default;\n\n$modal-header-border-color:         var(--#{$prefix}border-color) !default;\n$modal-header-border-width:         $modal-content-border-width !default;\n$modal-header-padding-y:            $modal-inner-padding !default;\n$modal-header-padding-x:            $modal-inner-padding !default;\n$modal-header-padding:              $modal-header-padding-y $modal-header-padding-x !default; // Keep this for backwards compatibility\n\n$modal-footer-bg:                   null !default;\n$modal-footer-border-color:         $modal-header-border-color !default;\n$modal-footer-border-width:         $modal-header-border-width !default;\n\n$modal-sm:                          300px !default;\n$modal-md:                          500px !default;\n$modal-lg:                          800px !default;\n$modal-xl:                          1140px !default;\n\n$modal-fade-transform:              translate(0, -50px) !default;\n$modal-show-transform:              none !default;\n$modal-transition:                  transform .3s ease-out !default;\n$modal-scale-transform:             scale(1.02) !default;\n// scss-docs-end modal-variables\n\n\n// Alerts\n//\n// Define alert colors, border radius, and padding.\n\n// scss-docs-start alert-variables\n$alert-padding-y:               $spacer !default;\n$alert-padding-x:               $spacer !default;\n$alert-margin-bottom:           1rem !default;\n$alert-border-radius:           $border-radius !default;\n$alert-link-font-weight:        $font-weight-bold !default;\n$alert-border-width:            $border-width !default;\n$alert-bg-scale:                -80% !default;\n$alert-border-scale:            -70% !default;\n$alert-color-scale:             40% !default;\n$alert-dismissible-padding-r:   $alert-padding-x * 3 !default; // 3x covers width of x plus default padding on either side\n// scss-docs-end alert-variables\n\n\n// Progress bars\n\n// scss-docs-start progress-variables\n$progress-height:                   1rem !default;\n$progress-font-size:                $font-size-base * .75 !default;\n$progress-bg:                       $gray-200 !default;\n$progress-border-radius:            $border-radius !default;\n$progress-box-shadow:               $box-shadow-inset !default;\n$progress-bar-color:                $white !default;\n$progress-bar-bg:                   $primary !default;\n$progress-bar-animation-timing:     1s linear infinite !default;\n$progress-bar-transition:           width .6s ease !default;\n// scss-docs-end progress-variables\n\n\n// List group\n\n// scss-docs-start list-group-variables\n$list-group-color:                  $gray-900 !default;\n$list-group-bg:                     $white !default;\n$list-group-border-color:           rgba($black, .125) !default;\n$list-group-border-width:           $border-width !default;\n$list-group-border-radius:          $border-radius !default;\n\n$list-group-item-padding-y:         $spacer * .5 !default;\n$list-group-item-padding-x:         $spacer !default;\n$list-group-item-bg-scale:          -80% !default;\n$list-group-item-color-scale:       40% !default;\n\n$list-group-hover-bg:               $gray-100 !default;\n$list-group-active-color:           $component-active-color !default;\n$list-group-active-bg:              $component-active-bg !default;\n$list-group-active-border-color:    $list-group-active-bg !default;\n\n$list-group-disabled-color:         $gray-600 !default;\n$list-group-disabled-bg:            $list-group-bg !default;\n\n$list-group-action-color:           $gray-700 !default;\n$list-group-action-hover-color:     $list-group-action-color !default;\n\n$list-group-action-active-color:    $body-color !default;\n$list-group-action-active-bg:       $gray-200 !default;\n// scss-docs-end list-group-variables\n\n\n// Image thumbnails\n\n// scss-docs-start thumbnail-variables\n$thumbnail-padding:                 .25rem !default;\n$thumbnail-bg:                      $body-bg !default;\n$thumbnail-border-width:            $border-width !default;\n$thumbnail-border-color:            var(--#{$prefix}border-color) !default;\n$thumbnail-border-radius:           $border-radius !default;\n$thumbnail-box-shadow:              $box-shadow-sm !default;\n// scss-docs-end thumbnail-variables\n\n\n// Figures\n\n// scss-docs-start figure-variables\n$figure-caption-font-size:          $small-font-size !default;\n$figure-caption-color:              $gray-600 !default;\n// scss-docs-end figure-variables\n\n\n// Breadcrumbs\n\n// scss-docs-start breadcrumb-variables\n$breadcrumb-font-size:              null !default;\n$breadcrumb-padding-y:              0 !default;\n$breadcrumb-padding-x:              0 !default;\n$breadcrumb-item-padding-x:         .5rem !default;\n$breadcrumb-margin-bottom:          1rem !default;\n$breadcrumb-bg:                     null !default;\n$breadcrumb-divider-color:          $gray-600 !default;\n$breadcrumb-active-color:           $gray-600 !default;\n$breadcrumb-divider:                quote(\"/\") !default;\n$breadcrumb-divider-flipped:        $breadcrumb-divider !default;\n$breadcrumb-border-radius:          null !default;\n// scss-docs-end breadcrumb-variables\n\n// Carousel\n\n// scss-docs-start carousel-variables\n$carousel-control-color:             $white !default;\n$carousel-control-width:             15% !default;\n$carousel-control-opacity:           .5 !default;\n$carousel-control-hover-opacity:     .9 !default;\n$carousel-control-transition:        opacity .15s ease !default;\n\n$carousel-indicator-width:           30px !default;\n$carousel-indicator-height:          3px !default;\n$carousel-indicator-hit-area-height: 10px !default;\n$carousel-indicator-spacer:          3px !default;\n$carousel-indicator-opacity:         .5 !default;\n$carousel-indicator-active-bg:       $white !default;\n$carousel-indicator-active-opacity:  1 !default;\n$carousel-indicator-transition:      opacity .6s ease !default;\n\n$carousel-caption-width:             70% !default;\n$carousel-caption-color:             $white !default;\n$carousel-caption-padding-y:         1.25rem !default;\n$carousel-caption-spacer:            1.25rem !default;\n\n$carousel-control-icon-width:        2rem !default;\n\n$carousel-control-prev-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z'/></svg>\") !default;\n$carousel-control-next-icon-bg:      url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$carousel-control-color}'><path d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'/></svg>\") !default;\n\n$carousel-transition-duration:       .6s !default;\n$carousel-transition:                transform $carousel-transition-duration ease-in-out !default; // Define transform transition first if using multiple transitions (e.g., `transform 2s ease, opacity .5s ease-out`)\n// scss-docs-end carousel-variables\n\n// scss-docs-start carousel-dark-variables\n$carousel-dark-indicator-active-bg:  $black !default;\n$carousel-dark-caption-color:        $black !default;\n$carousel-dark-control-icon-filter:  invert(1) grayscale(100) !default;\n// scss-docs-end carousel-dark-variables\n\n\n// Spinners\n\n// scss-docs-start spinner-variables\n$spinner-width:           2rem !default;\n$spinner-height:          $spinner-width !default;\n$spinner-vertical-align:  -.125em !default;\n$spinner-border-width:    .25em !default;\n$spinner-animation-speed: .75s !default;\n\n$spinner-width-sm:        1rem !default;\n$spinner-height-sm:       $spinner-width-sm !default;\n$spinner-border-width-sm: .2em !default;\n// scss-docs-end spinner-variables\n\n\n// Close\n\n// scss-docs-start close-variables\n$btn-close-width:            1em !default;\n$btn-close-height:           $btn-close-width !default;\n$btn-close-padding-x:        .25em !default;\n$btn-close-padding-y:        $btn-close-padding-x !default;\n$btn-close-color:            $black !default;\n$btn-close-bg:               url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$btn-close-color}'><path d='M.293.293a1 1 0 0 1 1.414 0L8 6.586 14.293.293a1 1 0 1 1 1.414 1.414L9.414 8l6.293 6.293a1 1 0 0 1-1.414 1.414L8 9.414l-6.293 6.293a1 1 0 0 1-1.414-1.414L6.586 8 .293 1.707a1 1 0 0 1 0-1.414z'/></svg>\") !default;\n$btn-close-focus-shadow:     $input-btn-focus-box-shadow !default;\n$btn-close-opacity:          .5 !default;\n$btn-close-hover-opacity:    .75 !default;\n$btn-close-focus-opacity:    1 !default;\n$btn-close-disabled-opacity: .25 !default;\n$btn-close-white-filter:     invert(1) grayscale(100%) brightness(200%) !default;\n// scss-docs-end close-variables\n\n\n// Offcanvas\n\n// scss-docs-start offcanvas-variables\n$offcanvas-padding-y:               $modal-inner-padding !default;\n$offcanvas-padding-x:               $modal-inner-padding !default;\n$offcanvas-horizontal-width:        400px !default;\n$offcanvas-vertical-height:         30vh !default;\n$offcanvas-transition-duration:     .3s !default;\n$offcanvas-border-color:            $modal-content-border-color !default;\n$offcanvas-border-width:            $modal-content-border-width !default;\n$offcanvas-title-line-height:       $modal-title-line-height !default;\n$offcanvas-bg-color:                $modal-content-bg !default;\n$offcanvas-color:                   $modal-content-color !default;\n$offcanvas-box-shadow:              $modal-content-box-shadow-xs !default;\n$offcanvas-backdrop-bg:             $modal-backdrop-bg !default;\n$offcanvas-backdrop-opacity:        $modal-backdrop-opacity !default;\n// scss-docs-end offcanvas-variables\n\n// Code\n\n$code-font-size:                    $small-font-size !default;\n$code-color:                        $pink !default;\n\n$kbd-padding-y:                     .1875rem !default;\n$kbd-padding-x:                     .375rem !default;\n$kbd-font-size:                     $code-font-size !default;\n$kbd-color:                         var(--#{$prefix}body-bg) !default;\n$kbd-bg:                            var(--#{$prefix}body-color) !default;\n$nested-kbd-font-weight:            null !default; // Deprecated in v5.2.0, removing in v6\n\n$pre-color:                         null !default;\n","//\n// Check/radio\n//\n\n.form-check {\n  display: block;\n  min-height: $form-check-min-height;\n  padding-left: $form-check-padding-start;\n  margin-bottom: $form-check-margin-bottom;\n\n  .form-check-input {\n    float: left;\n    margin-left: $form-check-padding-start * -1;\n  }\n}\n\n.form-check-reverse {\n  padding-right: $form-check-padding-start;\n  padding-left: 0;\n  text-align: right;\n\n  .form-check-input {\n    float: right;\n    margin-right: $form-check-padding-start * -1;\n    margin-left: 0;\n  }\n}\n\n.form-check-input {\n  width: $form-check-input-width;\n  height: $form-check-input-width;\n  margin-top: ($line-height-base - $form-check-input-width) * .5; // line-height minus check height\n  vertical-align: top;\n  background-color: $form-check-input-bg;\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: contain;\n  border: $form-check-input-border;\n  appearance: none;\n  print-color-adjust: exact; // Keep themed appearance for print\n  @include transition($form-check-transition);\n\n  &[type=\"checkbox\"] {\n    @include border-radius($form-check-input-border-radius);\n  }\n\n  &[type=\"radio\"] {\n    // stylelint-disable-next-line property-disallowed-list\n    border-radius: $form-check-radio-border-radius;\n  }\n\n  &:active {\n    filter: $form-check-input-active-filter;\n  }\n\n  &:focus {\n    border-color: $form-check-input-focus-border;\n    outline: 0;\n    box-shadow: $form-check-input-focus-box-shadow;\n  }\n\n  &:checked {\n    background-color: $form-check-input-checked-bg-color;\n    border-color: $form-check-input-checked-border-color;\n\n    &[type=\"checkbox\"] {\n      @if $enable-gradients {\n        background-image: escape-svg($form-check-input-checked-bg-image), var(--#{$prefix}gradient);\n      } @else {\n        background-image: escape-svg($form-check-input-checked-bg-image);\n      }\n    }\n\n    &[type=\"radio\"] {\n      @if $enable-gradients {\n        background-image: escape-svg($form-check-radio-checked-bg-image), var(--#{$prefix}gradient);\n      } @else {\n        background-image: escape-svg($form-check-radio-checked-bg-image);\n      }\n    }\n  }\n\n  &[type=\"checkbox\"]:indeterminate {\n    background-color: $form-check-input-indeterminate-bg-color;\n    border-color: $form-check-input-indeterminate-border-color;\n\n    @if $enable-gradients {\n      background-image: escape-svg($form-check-input-indeterminate-bg-image), var(--#{$prefix}gradient);\n    } @else {\n      background-image: escape-svg($form-check-input-indeterminate-bg-image);\n    }\n  }\n\n  &:disabled {\n    pointer-events: none;\n    filter: none;\n    opacity: $form-check-input-disabled-opacity;\n  }\n\n  // Use disabled attribute in addition of :disabled pseudo-class\n  // See: https://github.com/twbs/bootstrap/issues/28247\n  &[disabled],\n  &:disabled {\n    ~ .form-check-label {\n      cursor: default;\n      opacity: $form-check-label-disabled-opacity;\n    }\n  }\n}\n\n.form-check-label {\n  color: $form-check-label-color;\n  cursor: $form-check-label-cursor;\n}\n\n//\n// Switch\n//\n\n.form-switch {\n  padding-left: $form-switch-padding-start;\n\n  .form-check-input {\n    width: $form-switch-width;\n    margin-left: $form-switch-padding-start * -1;\n    background-image: escape-svg($form-switch-bg-image);\n    background-position: left center;\n    @include border-radius($form-switch-border-radius);\n    @include transition($form-switch-transition);\n\n    &:focus {\n      background-image: escape-svg($form-switch-focus-bg-image);\n    }\n\n    &:checked {\n      background-position: $form-switch-checked-bg-position;\n\n      @if $enable-gradients {\n        background-image: escape-svg($form-switch-checked-bg-image), var(--#{$prefix}gradient);\n      } @else {\n        background-image: escape-svg($form-switch-checked-bg-image);\n      }\n    }\n  }\n\n  &.form-check-reverse {\n    padding-right: $form-switch-padding-start;\n    padding-left: 0;\n\n    .form-check-input {\n      margin-right: $form-switch-padding-start * -1;\n      margin-left: 0;\n    }\n  }\n}\n\n.form-check-inline {\n  display: inline-block;\n  margin-right: $form-check-inline-margin-end;\n}\n\n.btn-check {\n  position: absolute;\n  clip: rect(0, 0, 0, 0);\n  pointer-events: none;\n\n  &[disabled],\n  &:disabled {\n    + .btn {\n      pointer-events: none;\n      filter: none;\n      opacity: $form-check-btn-check-disabled-opacity;\n    }\n  }\n}\n","// Range\n//\n// Style range inputs the same across browsers. Vendor-specific rules for pseudo\n// elements cannot be mixed. As such, there are no shared styles for focus or\n// active states on prefixed selectors.\n\n.form-range {\n  width: 100%;\n  height: add($form-range-thumb-height, $form-range-thumb-focus-box-shadow-width * 2);\n  padding: 0; // Need to reset padding\n  background-color: transparent;\n  appearance: none;\n\n  &:focus {\n    outline: 0;\n\n    // Pseudo-elements must be split across multiple rulesets to have an effect.\n    // No box-shadow() mixin for focus accessibility.\n    &::-webkit-slider-thumb { box-shadow: $form-range-thumb-focus-box-shadow; }\n    &::-moz-range-thumb     { box-shadow: $form-range-thumb-focus-box-shadow; }\n  }\n\n  &::-moz-focus-outer {\n    border: 0;\n  }\n\n  &::-webkit-slider-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    margin-top: ($form-range-track-height - $form-range-thumb-height) * .5; // Webkit specific\n    @include gradient-bg($form-range-thumb-bg);\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n    appearance: none;\n\n    &:active {\n      @include gradient-bg($form-range-thumb-active-bg);\n    }\n  }\n\n  &::-webkit-slider-runnable-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent; // Why?\n    cursor: $form-range-track-cursor;\n    background-color: $form-range-track-bg;\n    border-color: transparent;\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &::-moz-range-thumb {\n    width: $form-range-thumb-width;\n    height: $form-range-thumb-height;\n    @include gradient-bg($form-range-thumb-bg);\n    border: $form-range-thumb-border;\n    @include border-radius($form-range-thumb-border-radius);\n    @include box-shadow($form-range-thumb-box-shadow);\n    @include transition($form-range-thumb-transition);\n    appearance: none;\n\n    &:active {\n      @include gradient-bg($form-range-thumb-active-bg);\n    }\n  }\n\n  &::-moz-range-track {\n    width: $form-range-track-width;\n    height: $form-range-track-height;\n    color: transparent;\n    cursor: $form-range-track-cursor;\n    background-color: $form-range-track-bg;\n    border-color: transparent; // Firefox specific?\n    @include border-radius($form-range-track-border-radius);\n    @include box-shadow($form-range-track-box-shadow);\n  }\n\n  &:disabled {\n    pointer-events: none;\n\n    &::-webkit-slider-thumb {\n      background-color: $form-range-thumb-disabled-bg;\n    }\n\n    &::-moz-range-thumb {\n      background-color: $form-range-thumb-disabled-bg;\n    }\n  }\n}\n",".form-floating {\n  position: relative;\n\n  > .form-control,\n  > .form-control-plaintext,\n  > .form-select {\n    height: $form-floating-height;\n    line-height: $form-floating-line-height;\n  }\n\n  > label {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%; // allow textareas\n    padding: $form-floating-padding-y $form-floating-padding-x;\n    overflow: hidden;\n    text-align: start;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    pointer-events: none;\n    border: $input-border-width solid transparent; // Required for aligning label's text with the input as it affects inner box model\n    transform-origin: 0 0;\n    @include transition($form-floating-transition);\n  }\n\n  > .form-control,\n  > .form-control-plaintext {\n    padding: $form-floating-padding-y $form-floating-padding-x;\n\n    &::placeholder {\n      color: transparent;\n    }\n\n    &:focus,\n    &:not(:placeholder-shown) {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n    // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n    &:-webkit-autofill {\n      padding-top: $form-floating-input-padding-t;\n      padding-bottom: $form-floating-input-padding-b;\n    }\n  }\n\n  > .form-select {\n    padding-top: $form-floating-input-padding-t;\n    padding-bottom: $form-floating-input-padding-b;\n  }\n\n  > .form-control:focus,\n  > .form-control:not(:placeholder-shown),\n  > .form-control-plaintext,\n  > .form-select {\n    ~ label {\n      opacity: $form-floating-label-opacity;\n      transform: $form-floating-label-transform;\n    }\n  }\n  // Duplicated because `:-webkit-autofill` invalidates other selectors when grouped\n  > .form-control:-webkit-autofill {\n    ~ label {\n      opacity: $form-floating-label-opacity;\n      transform: $form-floating-label-transform;\n    }\n  }\n\n  > .form-control-plaintext {\n    ~ label {\n      border-width: $input-border-width 0; // Required to properly position label text - as explained above\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.input-group {\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // For form validation feedback\n  align-items: stretch;\n  width: 100%;\n\n  > .form-control,\n  > .form-select,\n  > .form-floating {\n    position: relative; // For focus state's z-index\n    flex: 1 1 auto;\n    width: 1%;\n    min-width: 0; // https://stackoverflow.com/questions/36247140/why-dont-flex-items-shrink-past-content-size\n  }\n\n  // Bring the \"active\" form control to the top of surrounding elements\n  > .form-control:focus,\n  > .form-select:focus,\n  > .form-floating:focus-within {\n    z-index: 5;\n  }\n\n  // Ensure buttons are always above inputs for more visually pleasing borders.\n  // This isn't needed for `.input-group-text` since it shares the same border-color\n  // as our inputs.\n  .btn {\n    position: relative;\n    z-index: 2;\n\n    &:focus {\n      z-index: 5;\n    }\n  }\n}\n\n\n// Textual addons\n//\n// Serves as a catch-all element for any text or radio/checkbox input you wish\n// to prepend or append to an input.\n\n.input-group-text {\n  display: flex;\n  align-items: center;\n  padding: $input-group-addon-padding-y $input-group-addon-padding-x;\n  @include font-size($input-font-size); // Match inputs\n  font-weight: $input-group-addon-font-weight;\n  line-height: $input-line-height;\n  color: $input-group-addon-color;\n  text-align: center;\n  white-space: nowrap;\n  background-color: $input-group-addon-bg;\n  border: $input-border-width solid $input-group-addon-border-color;\n  @include border-radius($input-border-radius);\n}\n\n\n// Sizing\n//\n// Remix the default form control sizing classes into new ones for easier\n// manipulation.\n\n.input-group-lg > .form-control,\n.input-group-lg > .form-select,\n.input-group-lg > .input-group-text,\n.input-group-lg > .btn {\n  padding: $input-padding-y-lg $input-padding-x-lg;\n  @include font-size($input-font-size-lg);\n  @include border-radius($input-border-radius-lg);\n}\n\n.input-group-sm > .form-control,\n.input-group-sm > .form-select,\n.input-group-sm > .input-group-text,\n.input-group-sm > .btn {\n  padding: $input-padding-y-sm $input-padding-x-sm;\n  @include font-size($input-font-size-sm);\n  @include border-radius($input-border-radius-sm);\n}\n\n.input-group-lg > .form-select,\n.input-group-sm > .form-select {\n  padding-right: $form-select-padding-x + $form-select-indicator-padding;\n}\n\n\n// Rounded corners\n//\n// These rulesets must come after the sizing ones to properly override sm and lg\n// border-radius values when extending. They're more specific than we'd like\n// with the `.input-group >` part, but without it, we cannot override the sizing.\n\n// stylelint-disable-next-line no-duplicate-selectors\n.input-group {\n  &:not(.has-validation) {\n    > :not(:last-child):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n    > .dropdown-toggle:nth-last-child(n + 3),\n    > .form-floating:not(:last-child) > .form-control,\n    > .form-floating:not(:last-child) > .form-select {\n      @include border-end-radius(0);\n    }\n  }\n\n  &.has-validation {\n    > :nth-last-child(n + 3):not(.dropdown-toggle):not(.dropdown-menu):not(.form-floating),\n    > .dropdown-toggle:nth-last-child(n + 4),\n    > .form-floating:nth-last-child(n + 3) > .form-control,\n    > .form-floating:nth-last-child(n + 3) > .form-select {\n      @include border-end-radius(0);\n    }\n  }\n\n  $validation-messages: \"\";\n  @each $state in map-keys($form-validation-states) {\n    $validation-messages: $validation-messages + \":not(.\" + unquote($state) + \"-tooltip)\" + \":not(.\" + unquote($state) + \"-feedback)\";\n  }\n\n  > :not(:first-child):not(.dropdown-menu)#{$validation-messages} {\n    margin-left: -$input-border-width;\n    @include border-start-radius(0);\n  }\n\n  > .form-floating:not(:first-child) > .form-control,\n  > .form-floating:not(:first-child) > .form-select {\n    @include border-start-radius(0);\n  }\n}\n","// This mixin uses an `if()` technique to be compatible with Dart Sass\n// See https://github.com/sass/sass/issues/1873#issuecomment-152293725 for more details\n\n// scss-docs-start form-validation-mixins\n@mixin form-validation-state-selector($state) {\n  @if ($state == \"valid\" or $state == \"invalid\") {\n    .was-validated #{if(&, \"&\", \"\")}:#{$state},\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  } @else {\n    #{if(&, \"&\", \"\")}.is-#{$state} {\n      @content;\n    }\n  }\n}\n\n@mixin form-validation-state(\n  $state,\n  $color,\n  $icon,\n  $tooltip-color: color-contrast($color),\n  $tooltip-bg-color: rgba($color, $form-feedback-tooltip-opacity),\n  $focus-box-shadow: 0 0 $input-btn-focus-blur $input-focus-width rgba($color, $input-btn-focus-color-opacity)\n) {\n  .#{$state}-feedback {\n    display: none;\n    width: 100%;\n    margin-top: $form-feedback-margin-top;\n    @include font-size($form-feedback-font-size);\n    font-style: $form-feedback-font-style;\n    color: $color;\n  }\n\n  .#{$state}-tooltip {\n    position: absolute;\n    top: 100%;\n    z-index: 5;\n    display: none;\n    max-width: 100%; // Contain to parent when possible\n    padding: $form-feedback-tooltip-padding-y $form-feedback-tooltip-padding-x;\n    margin-top: .1rem;\n    @include font-size($form-feedback-tooltip-font-size);\n    line-height: $form-feedback-tooltip-line-height;\n    color: $tooltip-color;\n    background-color: $tooltip-bg-color;\n    @include border-radius($form-feedback-tooltip-border-radius);\n  }\n\n  @include form-validation-state-selector($state) {\n    ~ .#{$state}-feedback,\n    ~ .#{$state}-tooltip {\n      display: block;\n    }\n  }\n\n  .form-control {\n    @include form-validation-state-selector($state) {\n      border-color: $color;\n\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-image: escape-svg($icon);\n        background-repeat: no-repeat;\n        background-position: right $input-height-inner-quarter center;\n        background-size: $input-height-inner-half $input-height-inner-half;\n      }\n\n      &:focus {\n        border-color: $color;\n        box-shadow: $focus-box-shadow;\n      }\n    }\n  }\n\n  // stylelint-disable-next-line selector-no-qualifying-type\n  textarea.form-control {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        padding-right: $input-height-inner;\n        background-position: top $input-height-inner-quarter right $input-height-inner-quarter;\n      }\n    }\n  }\n\n  .form-select {\n    @include form-validation-state-selector($state) {\n      border-color: $color;\n\n      @if $enable-validation-icons {\n        &:not([multiple]):not([size]),\n        &:not([multiple])[size=\"1\"] {\n          padding-right: $form-select-feedback-icon-padding-end;\n          background-image: escape-svg($form-select-indicator), escape-svg($icon);\n          background-position: $form-select-bg-position, $form-select-feedback-icon-position;\n          background-size: $form-select-bg-size, $form-select-feedback-icon-size;\n        }\n      }\n\n      &:focus {\n        border-color: $color;\n        box-shadow: $focus-box-shadow;\n      }\n    }\n  }\n\n  .form-control-color {\n    @include form-validation-state-selector($state) {\n      @if $enable-validation-icons {\n        width: add($form-color-width, $input-height-inner);\n      }\n    }\n  }\n\n  .form-check-input {\n    @include form-validation-state-selector($state) {\n      border-color: $color;\n\n      &:checked {\n        background-color: $color;\n      }\n\n      &:focus {\n        box-shadow: $focus-box-shadow;\n      }\n\n      ~ .form-check-label {\n        color: $color;\n      }\n    }\n  }\n  .form-check-inline .form-check-input {\n    ~ .#{$state}-feedback {\n      margin-left: .5em;\n    }\n  }\n\n  .input-group {\n    > .form-control:not(:focus),\n    > .form-select:not(:focus),\n    > .form-floating:not(:focus-within) {\n      @include form-validation-state-selector($state) {\n        @if $state == \"valid\" {\n          z-index: 3;\n        } @else if $state == \"invalid\" {\n          z-index: 4;\n        }\n      }\n    }\n  }\n}\n// scss-docs-end form-validation-mixins\n","//\n// Base styles\n//\n\n.btn {\n  // scss-docs-start btn-css-vars\n  --#{$prefix}btn-padding-x: #{$btn-padding-x};\n  --#{$prefix}btn-padding-y: #{$btn-padding-y};\n  --#{$prefix}btn-font-family: #{$btn-font-family};\n  @include rfs($btn-font-size, --#{$prefix}btn-font-size);\n  --#{$prefix}btn-font-weight: #{$btn-font-weight};\n  --#{$prefix}btn-line-height: #{$btn-line-height};\n  --#{$prefix}btn-color: #{$body-color};\n  --#{$prefix}btn-bg: transparent;\n  --#{$prefix}btn-border-width: #{$btn-border-width};\n  --#{$prefix}btn-border-color: transparent;\n  --#{$prefix}btn-border-radius: #{$btn-border-radius};\n  --#{$prefix}btn-hover-border-color: transparent;\n  --#{$prefix}btn-box-shadow: #{$btn-box-shadow};\n  --#{$prefix}btn-disabled-opacity: #{$btn-disabled-opacity};\n  --#{$prefix}btn-focus-box-shadow: 0 0 0 #{$btn-focus-width} rgba(var(--#{$prefix}btn-focus-shadow-rgb), .5);\n  // scss-docs-end btn-css-vars\n\n  display: inline-block;\n  padding: var(--#{$prefix}btn-padding-y) var(--#{$prefix}btn-padding-x);\n  font-family: var(--#{$prefix}btn-font-family);\n  @include font-size(var(--#{$prefix}btn-font-size));\n  font-weight: var(--#{$prefix}btn-font-weight);\n  line-height: var(--#{$prefix}btn-line-height);\n  color: var(--#{$prefix}btn-color);\n  text-align: center;\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: $btn-white-space;\n  vertical-align: middle;\n  cursor: if($enable-button-pointers, pointer, null);\n  user-select: none;\n  border: var(--#{$prefix}btn-border-width) solid var(--#{$prefix}btn-border-color);\n  @include border-radius(var(--#{$prefix}btn-border-radius));\n  @include gradient-bg(var(--#{$prefix}btn-bg));\n  @include box-shadow(var(--#{$prefix}btn-box-shadow));\n  @include transition($btn-transition);\n\n  &:hover {\n    color: var(--#{$prefix}btn-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    background-color: var(--#{$prefix}btn-hover-bg);\n    border-color: var(--#{$prefix}btn-hover-border-color);\n  }\n\n  .btn-check + &:hover {\n    // override for the checkbox/radio buttons\n    color: var(--#{$prefix}btn-color);\n    background-color: var(--#{$prefix}btn-bg);\n    border-color: var(--#{$prefix}btn-border-color);\n  }\n\n  &:focus-visible {\n    color: var(--#{$prefix}btn-hover-color);\n    @include gradient-bg(var(--#{$prefix}btn-hover-bg));\n    border-color: var(--#{$prefix}btn-hover-border-color);\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-box-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  .btn-check:focus-visible + & {\n    border-color: var(--#{$prefix}btn-hover-border-color);\n    outline: 0;\n    // Avoid using mixin so we can pass custom focus shadow properly\n    @if $enable-shadows {\n      box-shadow: var(--#{$prefix}btn-box-shadow), var(--#{$prefix}btn-focus-box-shadow);\n    } @else {\n      box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n    }\n  }\n\n  .btn-check:checked + &,\n  :not(.btn-check) + &:active,\n  &:first-child:active,\n  &.active,\n  &.show {\n    color: var(--#{$prefix}btn-active-color);\n    background-color: var(--#{$prefix}btn-active-bg);\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n    border-color: var(--#{$prefix}btn-active-border-color);\n    @include box-shadow(var(--#{$prefix}btn-active-shadow));\n\n    &:focus-visible {\n      // Avoid using mixin so we can pass custom focus shadow properly\n      @if $enable-shadows {\n        box-shadow: var(--#{$prefix}btn-active-shadow), var(--#{$prefix}btn-focus-box-shadow);\n      } @else {\n        box-shadow: var(--#{$prefix}btn-focus-box-shadow);\n      }\n    }\n  }\n\n  &:disabled,\n  &.disabled,\n  fieldset:disabled & {\n    color: var(--#{$prefix}btn-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}btn-disabled-bg);\n    background-image: if($enable-gradients, none, null);\n    border-color: var(--#{$prefix}btn-disabled-border-color);\n    opacity: var(--#{$prefix}btn-disabled-opacity);\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Alternate buttons\n//\n\n// scss-docs-start btn-variant-loops\n@each $color, $value in $theme-colors {\n  .btn-#{$color} {\n    @if $color == \"light\" {\n      @include button-variant(\n        $value,\n        $value,\n        $hover-background: shade-color($value, $btn-hover-bg-shade-amount),\n        $hover-border: shade-color($value, $btn-hover-border-shade-amount),\n        $active-background: shade-color($value, $btn-active-bg-shade-amount),\n        $active-border: shade-color($value, $btn-active-border-shade-amount)\n      );\n    } @else if $color == \"dark\" {\n      @include button-variant(\n        $value,\n        $value,\n        $hover-background: tint-color($value, $btn-hover-bg-tint-amount),\n        $hover-border: tint-color($value, $btn-hover-border-tint-amount),\n        $active-background: tint-color($value, $btn-active-bg-tint-amount),\n        $active-border: tint-color($value, $btn-active-border-tint-amount)\n      );\n    } @else {\n      @include button-variant($value, $value);\n    }\n  }\n}\n\n@each $color, $value in $theme-colors {\n  .btn-outline-#{$color} {\n    @include button-outline-variant($value);\n  }\n}\n// scss-docs-end btn-variant-loops\n\n\n//\n// Link buttons\n//\n\n// Make a button look and behave like a link\n.btn-link {\n  --#{$prefix}btn-font-weight: #{$font-weight-normal};\n  --#{$prefix}btn-color: #{$btn-link-color};\n  --#{$prefix}btn-bg: transparent;\n  --#{$prefix}btn-border-color: transparent;\n  --#{$prefix}btn-hover-color: #{$btn-link-hover-color};\n  --#{$prefix}btn-hover-border-color: transparent;\n  --#{$prefix}btn-active-color: #{$btn-link-hover-color};\n  --#{$prefix}btn-active-border-color: transparent;\n  --#{$prefix}btn-disabled-color: #{$btn-link-disabled-color};\n  --#{$prefix}btn-disabled-border-color: transparent;\n  --#{$prefix}btn-box-shadow: none;\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb(mix(color-contrast($primary), $primary, 15%))};\n\n  text-decoration: $link-decoration;\n  @if $enable-gradients {\n    background-image: none;\n  }\n\n  &:hover,\n  &:focus-visible {\n    text-decoration: $link-hover-decoration;\n  }\n\n  &:focus-visible {\n    color: var(--#{$prefix}btn-color);\n  }\n\n  &:hover {\n    color: var(--#{$prefix}btn-hover-color);\n  }\n\n  // No need for an active state here\n}\n\n\n//\n// Button Sizes\n//\n\n.btn-lg {\n  @include button-size($btn-padding-y-lg, $btn-padding-x-lg, $btn-font-size-lg, $btn-border-radius-lg);\n}\n\n.btn-sm {\n  @include button-size($btn-padding-y-sm, $btn-padding-x-sm, $btn-font-size-sm, $btn-border-radius-sm);\n}\n","// Button variants\n//\n// Easily pump out default styles, as well as :hover, :focus, :active,\n// and disabled options for all buttons\n\n// scss-docs-start btn-variant-mixin\n@mixin button-variant(\n  $background,\n  $border,\n  $color: color-contrast($background),\n  $hover-background: if($color == $color-contrast-light, shade-color($background, $btn-hover-bg-shade-amount), tint-color($background, $btn-hover-bg-tint-amount)),\n  $hover-border: if($color == $color-contrast-light, shade-color($border, $btn-hover-border-shade-amount), tint-color($border, $btn-hover-border-tint-amount)),\n  $hover-color: color-contrast($hover-background),\n  $active-background: if($color == $color-contrast-light, shade-color($background, $btn-active-bg-shade-amount), tint-color($background, $btn-active-bg-tint-amount)),\n  $active-border: if($color == $color-contrast-light, shade-color($border, $btn-active-border-shade-amount), tint-color($border, $btn-active-border-tint-amount)),\n  $active-color: color-contrast($active-background),\n  $disabled-background: $background,\n  $disabled-border: $border,\n  $disabled-color: color-contrast($disabled-background)\n) {\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-bg: #{$background};\n  --#{$prefix}btn-border-color: #{$border};\n  --#{$prefix}btn-hover-color: #{$hover-color};\n  --#{$prefix}btn-hover-bg: #{$hover-background};\n  --#{$prefix}btn-hover-border-color: #{$hover-border};\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb(mix($color, $border, 15%))};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border};\n  --#{$prefix}btn-active-shadow: #{$btn-active-box-shadow};\n  --#{$prefix}btn-disabled-color: #{$disabled-color};\n  --#{$prefix}btn-disabled-bg: #{$disabled-background};\n  --#{$prefix}btn-disabled-border-color: #{$disabled-border};\n}\n// scss-docs-end btn-variant-mixin\n\n// scss-docs-start btn-outline-variant-mixin\n@mixin button-outline-variant(\n  $color,\n  $color-hover: color-contrast($color),\n  $active-background: $color,\n  $active-border: $color,\n  $active-color: color-contrast($active-background)\n) {\n  --#{$prefix}btn-color: #{$color};\n  --#{$prefix}btn-border-color: #{$color};\n  --#{$prefix}btn-hover-color: #{$color-hover};\n  --#{$prefix}btn-hover-bg: #{$active-background};\n  --#{$prefix}btn-hover-border-color: #{$active-border};\n  --#{$prefix}btn-focus-shadow-rgb: #{to-rgb($color)};\n  --#{$prefix}btn-active-color: #{$active-color};\n  --#{$prefix}btn-active-bg: #{$active-background};\n  --#{$prefix}btn-active-border-color: #{$active-border};\n  --#{$prefix}btn-active-shadow: #{$btn-active-box-shadow};\n  --#{$prefix}btn-disabled-color: #{$color};\n  --#{$prefix}btn-disabled-bg: transparent;\n  --#{$prefix}btn-disabled-border-color: #{$color};\n  --#{$prefix}gradient: none;\n}\n// scss-docs-end btn-outline-variant-mixin\n\n// scss-docs-start btn-size-mixin\n@mixin button-size($padding-y, $padding-x, $font-size, $border-radius) {\n  --#{$prefix}btn-padding-y: #{$padding-y};\n  --#{$prefix}btn-padding-x: #{$padding-x};\n  @include rfs($font-size, --#{$prefix}btn-font-size);\n  --#{$prefix}btn-border-radius: #{$border-radius};\n}\n// scss-docs-end btn-size-mixin\n",".fade {\n  @include transition($transition-fade);\n\n  &:not(.show) {\n    opacity: 0;\n  }\n}\n\n// scss-docs-start collapse-classes\n.collapse {\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.collapsing {\n  height: 0;\n  overflow: hidden;\n  @include transition($transition-collapse);\n\n  &.collapse-horizontal {\n    width: 0;\n    height: auto;\n    @include transition($transition-collapse-width);\n  }\n}\n// scss-docs-end collapse-classes\n","// The dropdown wrapper (`<div>`)\n.dropup,\n.dropend,\n.dropdown,\n.dropstart,\n.dropup-center,\n.dropdown-center {\n  position: relative;\n}\n\n.dropdown-toggle {\n  white-space: nowrap;\n\n  // Generate the caret automatically\n  @include caret();\n}\n\n// The dropdown menu\n.dropdown-menu {\n  // scss-docs-start dropdown-css-vars\n  --#{$prefix}dropdown-zindex: #{$zindex-dropdown};\n  --#{$prefix}dropdown-min-width: #{$dropdown-min-width};\n  --#{$prefix}dropdown-padding-x: #{$dropdown-padding-x};\n  --#{$prefix}dropdown-padding-y: #{$dropdown-padding-y};\n  --#{$prefix}dropdown-spacer: #{$dropdown-spacer};\n  @include rfs($dropdown-font-size, --#{$prefix}dropdown-font-size);\n  --#{$prefix}dropdown-color: #{$dropdown-color};\n  --#{$prefix}dropdown-bg: #{$dropdown-bg};\n  --#{$prefix}dropdown-border-color: #{$dropdown-border-color};\n  --#{$prefix}dropdown-border-radius: #{$dropdown-border-radius};\n  --#{$prefix}dropdown-border-width: #{$dropdown-border-width};\n  --#{$prefix}dropdown-inner-border-radius: #{$dropdown-inner-border-radius};\n  --#{$prefix}dropdown-divider-bg: #{$dropdown-divider-bg};\n  --#{$prefix}dropdown-divider-margin-y: #{$dropdown-divider-margin-y};\n  --#{$prefix}dropdown-box-shadow: #{$dropdown-box-shadow};\n  --#{$prefix}dropdown-link-color: #{$dropdown-link-color};\n  --#{$prefix}dropdown-link-hover-color: #{$dropdown-link-hover-color};\n  --#{$prefix}dropdown-link-hover-bg: #{$dropdown-link-hover-bg};\n  --#{$prefix}dropdown-link-active-color: #{$dropdown-link-active-color};\n  --#{$prefix}dropdown-link-active-bg: #{$dropdown-link-active-bg};\n  --#{$prefix}dropdown-link-disabled-color: #{$dropdown-link-disabled-color};\n  --#{$prefix}dropdown-item-padding-x: #{$dropdown-item-padding-x};\n  --#{$prefix}dropdown-item-padding-y: #{$dropdown-item-padding-y};\n  --#{$prefix}dropdown-header-color: #{$dropdown-header-color};\n  --#{$prefix}dropdown-header-padding-x: #{$dropdown-header-padding-x};\n  --#{$prefix}dropdown-header-padding-y: #{$dropdown-header-padding-y};\n  // scss-docs-end dropdown-css-vars\n\n  position: absolute;\n  z-index: var(--#{$prefix}dropdown-zindex);\n  display: none; // none by default, but block on \"open\" of the menu\n  min-width: var(--#{$prefix}dropdown-min-width);\n  padding: var(--#{$prefix}dropdown-padding-y) var(--#{$prefix}dropdown-padding-x);\n  margin: 0; // Override default margin of ul\n  @include font-size(var(--#{$prefix}dropdown-font-size));\n  color: var(--#{$prefix}dropdown-color);\n  text-align: left; // Ensures proper alignment if parent has it changed (e.g., modal footer)\n  list-style: none;\n  background-color: var(--#{$prefix}dropdown-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}dropdown-border-width) solid var(--#{$prefix}dropdown-border-color);\n  @include border-radius(var(--#{$prefix}dropdown-border-radius));\n  @include box-shadow(var(--#{$prefix}dropdown-box-shadow));\n\n  &[data-bs-popper] {\n    top: 100%;\n    left: 0;\n    margin-top: var(--#{$prefix}dropdown-spacer);\n  }\n\n  @if $dropdown-padding-y == 0 {\n    > .dropdown-item:first-child,\n    > li:first-child .dropdown-item {\n      @include border-top-radius(var(--#{$prefix}dropdown-inner-border-radius));\n    }\n    > .dropdown-item:last-child,\n    > li:last-child .dropdown-item {\n      @include border-bottom-radius(var(--#{$prefix}dropdown-inner-border-radius));\n    }\n\n  }\n}\n\n// scss-docs-start responsive-breakpoints\n// We deliberately hardcode the `bs-` prefix because we check\n// this custom property in JS to determine Popper's positioning\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .dropdown-menu#{$infix}-start {\n      --bs-position: start;\n\n      &[data-bs-popper] {\n        right: auto;\n        left: 0;\n      }\n    }\n\n    .dropdown-menu#{$infix}-end {\n      --bs-position: end;\n\n      &[data-bs-popper] {\n        right: 0;\n        left: auto;\n      }\n    }\n  }\n}\n// scss-docs-end responsive-breakpoints\n\n// Allow for dropdowns to go bottom up (aka, dropup-menu)\n// Just add .dropup after the standard .dropdown class and you're set.\n.dropup {\n  .dropdown-menu[data-bs-popper] {\n    top: auto;\n    bottom: 100%;\n    margin-top: 0;\n    margin-bottom: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(up);\n  }\n}\n\n.dropend {\n  .dropdown-menu[data-bs-popper] {\n    top: 0;\n    right: auto;\n    left: 100%;\n    margin-top: 0;\n    margin-left: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(end);\n    &::after {\n      vertical-align: 0;\n    }\n  }\n}\n\n.dropstart {\n  .dropdown-menu[data-bs-popper] {\n    top: 0;\n    right: 100%;\n    left: auto;\n    margin-top: 0;\n    margin-right: var(--#{$prefix}dropdown-spacer);\n  }\n\n  .dropdown-toggle {\n    @include caret(start);\n    &::before {\n      vertical-align: 0;\n    }\n  }\n}\n\n\n// Dividers (basically an `<hr>`) within the dropdown\n.dropdown-divider {\n  height: 0;\n  margin: var(--#{$prefix}dropdown-divider-margin-y) 0;\n  overflow: hidden;\n  border-top: 1px solid var(--#{$prefix}dropdown-divider-bg);\n  opacity: 1; // Revisit in v6 to de-dupe styles that conflict with <hr> element\n}\n\n// Links, buttons, and more within the dropdown menu\n//\n// `<button>`-specific styles are denoted with `// For <button>s`\n.dropdown-item {\n  display: block;\n  width: 100%; // For `<button>`s\n  padding: var(--#{$prefix}dropdown-item-padding-y) var(--#{$prefix}dropdown-item-padding-x);\n  clear: both;\n  font-weight: $font-weight-normal;\n  color: var(--#{$prefix}dropdown-link-color);\n  text-align: inherit; // For `<button>`s\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap; // prevent links from randomly breaking onto new lines\n  background-color: transparent; // For `<button>`s\n  border: 0; // For `<button>`s\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}dropdown-link-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    @include gradient-bg(var(--#{$prefix}dropdown-link-hover-bg));\n  }\n\n  &.active,\n  &:active {\n    color: var(--#{$prefix}dropdown-link-active-color);\n    text-decoration: none;\n    @include gradient-bg(var(--#{$prefix}dropdown-link-active-bg));\n  }\n\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}dropdown-link-disabled-color);\n    pointer-events: none;\n    background-color: transparent;\n    // Remove CSS gradients if they're enabled\n    background-image: if($enable-gradients, none, null);\n  }\n}\n\n.dropdown-menu.show {\n  display: block;\n}\n\n// Dropdown section headers\n.dropdown-header {\n  display: block;\n  padding: var(--#{$prefix}dropdown-header-padding-y) var(--#{$prefix}dropdown-header-padding-x);\n  margin-bottom: 0; // for use with heading elements\n  @include font-size($font-size-sm);\n  color: var(--#{$prefix}dropdown-header-color);\n  white-space: nowrap; // as with > li > a\n}\n\n// Dropdown text\n.dropdown-item-text {\n  display: block;\n  padding: var(--#{$prefix}dropdown-item-padding-y) var(--#{$prefix}dropdown-item-padding-x);\n  color: var(--#{$prefix}dropdown-link-color);\n}\n\n// Dark dropdowns\n.dropdown-menu-dark {\n  // scss-docs-start dropdown-dark-css-vars\n  --#{$prefix}dropdown-color: #{$dropdown-dark-color};\n  --#{$prefix}dropdown-bg: #{$dropdown-dark-bg};\n  --#{$prefix}dropdown-border-color: #{$dropdown-dark-border-color};\n  --#{$prefix}dropdown-box-shadow: #{$dropdown-dark-box-shadow};\n  --#{$prefix}dropdown-link-color: #{$dropdown-dark-link-color};\n  --#{$prefix}dropdown-link-hover-color: #{$dropdown-dark-link-hover-color};\n  --#{$prefix}dropdown-divider-bg: #{$dropdown-dark-divider-bg};\n  --#{$prefix}dropdown-link-hover-bg: #{$dropdown-dark-link-hover-bg};\n  --#{$prefix}dropdown-link-active-color: #{$dropdown-dark-link-active-color};\n  --#{$prefix}dropdown-link-active-bg: #{$dropdown-dark-link-active-bg};\n  --#{$prefix}dropdown-link-disabled-color: #{$dropdown-dark-link-disabled-color};\n  --#{$prefix}dropdown-header-color: #{$dropdown-dark-header-color};\n  // scss-docs-end dropdown-dark-css-vars\n}\n","// Make the div behave like a button\n.btn-group,\n.btn-group-vertical {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle; // match .btn alignment given font-size hack above\n\n  > .btn {\n    position: relative;\n    flex: 1 1 auto;\n  }\n\n  // Bring the hover, focused, and \"active\" buttons to the front to overlay\n  // the borders properly\n  > .btn-check:checked + .btn,\n  > .btn-check:focus + .btn,\n  > .btn:hover,\n  > .btn:focus,\n  > .btn:active,\n  > .btn.active {\n    z-index: 1;\n  }\n}\n\n// Optional: Group multiple button groups together for a toolbar\n.btn-toolbar {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: flex-start;\n\n  .input-group {\n    width: auto;\n  }\n}\n\n.btn-group {\n  @include border-radius($btn-border-radius);\n\n  // Prevent double borders when buttons are next to each other\n  > :not(.btn-check:first-child) + .btn,\n  > .btn-group:not(:first-child) {\n    margin-left: -$btn-border-width;\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn.dropdown-toggle-split:first-child,\n  > .btn-group:not(:last-child) > .btn {\n    @include border-end-radius(0);\n  }\n\n  // The left radius should be 0 if the button is:\n  // - the \"third or more\" child\n  // - the second child and the previous element isn't `.btn-check` (making it the first child visually)\n  // - part of a btn-group which isn't the first child\n  > .btn:nth-child(n + 3),\n  > :not(.btn-check) + .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-start-radius(0);\n  }\n}\n\n// Sizing\n//\n// Remix the default button sizing classes into new ones for easier manipulation.\n\n.btn-group-sm > .btn { @extend .btn-sm; }\n.btn-group-lg > .btn { @extend .btn-lg; }\n\n\n//\n// Split button dropdowns\n//\n\n.dropdown-toggle-split {\n  padding-right: $btn-padding-x * .75;\n  padding-left: $btn-padding-x * .75;\n\n  &::after,\n  .dropup &::after,\n  .dropend &::after {\n    margin-left: 0;\n  }\n\n  .dropstart &::before {\n    margin-right: 0;\n  }\n}\n\n.btn-sm + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-sm * .75;\n  padding-left: $btn-padding-x-sm * .75;\n}\n\n.btn-lg + .dropdown-toggle-split {\n  padding-right: $btn-padding-x-lg * .75;\n  padding-left: $btn-padding-x-lg * .75;\n}\n\n\n// The clickable button for toggling the menu\n// Set the same inset shadow as the :active state\n.btn-group.show .dropdown-toggle {\n  @include box-shadow($btn-active-box-shadow);\n\n  // Show no shadow for `.btn-link` since it has no other button styles.\n  &.btn-link {\n    @include box-shadow(none);\n  }\n}\n\n\n//\n// Vertical button groups\n//\n\n.btn-group-vertical {\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n\n  > .btn,\n  > .btn-group {\n    width: 100%;\n  }\n\n  > .btn:not(:first-child),\n  > .btn-group:not(:first-child) {\n    margin-top: -$btn-border-width;\n  }\n\n  // Reset rounded corners\n  > .btn:not(:last-child):not(.dropdown-toggle),\n  > .btn-group:not(:last-child) > .btn {\n    @include border-bottom-radius(0);\n  }\n\n  > .btn ~ .btn,\n  > .btn-group:not(:first-child) > .btn {\n    @include border-top-radius(0);\n  }\n}\n","// Base class\n//\n// Kickstart any navigation component with a set of style resets. Works with\n// `<nav>`s, `<ul>`s or `<ol>`s.\n\n.nav {\n  // scss-docs-start nav-css-vars\n  --#{$prefix}nav-link-padding-x: #{$nav-link-padding-x};\n  --#{$prefix}nav-link-padding-y: #{$nav-link-padding-y};\n  @include rfs($nav-link-font-size, --#{$prefix}nav-link-font-size);\n  --#{$prefix}nav-link-font-weight: #{$nav-link-font-weight};\n  --#{$prefix}nav-link-color: #{$nav-link-color};\n  --#{$prefix}nav-link-hover-color: #{$nav-link-hover-color};\n  --#{$prefix}nav-link-disabled-color: #{$nav-link-disabled-color};\n  // scss-docs-end nav-css-vars\n\n  display: flex;\n  flex-wrap: wrap;\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n}\n\n.nav-link {\n  display: block;\n  padding: var(--#{$prefix}nav-link-padding-y) var(--#{$prefix}nav-link-padding-x);\n  @include font-size(var(--#{$prefix}nav-link-font-size));\n  font-weight: var(--#{$prefix}nav-link-font-weight);\n  color: var(--#{$prefix}nav-link-color);\n  text-decoration: if($link-decoration == none, null, none);\n  @include transition($nav-link-transition);\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}nav-link-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  // Disabled state lightens text\n  &.disabled {\n    color: var(--#{$prefix}nav-link-disabled-color);\n    pointer-events: none;\n    cursor: default;\n  }\n}\n\n//\n// Tabs\n//\n\n.nav-tabs {\n  // scss-docs-start nav-tabs-css-vars\n  --#{$prefix}nav-tabs-border-width: #{$nav-tabs-border-width};\n  --#{$prefix}nav-tabs-border-color: #{$nav-tabs-border-color};\n  --#{$prefix}nav-tabs-border-radius: #{$nav-tabs-border-radius};\n  --#{$prefix}nav-tabs-link-hover-border-color: #{$nav-tabs-link-hover-border-color};\n  --#{$prefix}nav-tabs-link-active-color: #{$nav-tabs-link-active-color};\n  --#{$prefix}nav-tabs-link-active-bg: #{$nav-tabs-link-active-bg};\n  --#{$prefix}nav-tabs-link-active-border-color: #{$nav-tabs-link-active-border-color};\n  // scss-docs-end nav-tabs-css-vars\n\n  border-bottom: var(--#{$prefix}nav-tabs-border-width) solid var(--#{$prefix}nav-tabs-border-color);\n\n  .nav-link {\n    margin-bottom: calc(-1 * var(--#{$prefix}nav-tabs-border-width)); // stylelint-disable-line function-disallowed-list\n    background: none;\n    border: var(--#{$prefix}nav-tabs-border-width) solid transparent;\n    @include border-top-radius(var(--#{$prefix}nav-tabs-border-radius));\n\n    &:hover,\n    &:focus {\n      // Prevents active .nav-link tab overlapping focus outline of previous/next .nav-link\n      isolation: isolate;\n      border-color: var(--#{$prefix}nav-tabs-link-hover-border-color);\n    }\n\n    &.disabled,\n    &:disabled {\n      color: var(--#{$prefix}nav-link-disabled-color);\n      background-color: transparent;\n      border-color: transparent;\n    }\n  }\n\n  .nav-link.active,\n  .nav-item.show .nav-link {\n    color: var(--#{$prefix}nav-tabs-link-active-color);\n    background-color: var(--#{$prefix}nav-tabs-link-active-bg);\n    border-color: var(--#{$prefix}nav-tabs-link-active-border-color);\n  }\n\n  .dropdown-menu {\n    // Make dropdown border overlap tab border\n    margin-top: calc(-1 * var(--#{$prefix}nav-tabs-border-width)); // stylelint-disable-line function-disallowed-list\n    // Remove the top rounded corners here since there is a hard edge above the menu\n    @include border-top-radius(0);\n  }\n}\n\n\n//\n// Pills\n//\n\n.nav-pills {\n  // scss-docs-start nav-pills-css-vars\n  --#{$prefix}nav-pills-border-radius: #{$nav-pills-border-radius};\n  --#{$prefix}nav-pills-link-active-color: #{$nav-pills-link-active-color};\n  --#{$prefix}nav-pills-link-active-bg: #{$nav-pills-link-active-bg};\n  // scss-docs-end nav-pills-css-vars\n\n  .nav-link {\n    background: none;\n    border: 0;\n    @include border-radius(var(--#{$prefix}nav-pills-border-radius));\n\n    &:disabled {\n      color: var(--#{$prefix}nav-link-disabled-color);\n      background-color: transparent;\n      border-color: transparent;\n    }\n  }\n\n  .nav-link.active,\n  .show > .nav-link {\n    color: var(--#{$prefix}nav-pills-link-active-color);\n    @include gradient-bg(var(--#{$prefix}nav-pills-link-active-bg));\n  }\n}\n\n\n//\n// Justified variants\n//\n\n.nav-fill {\n  > .nav-link,\n  .nav-item {\n    flex: 1 1 auto;\n    text-align: center;\n  }\n}\n\n.nav-justified {\n  > .nav-link,\n  .nav-item {\n    flex-basis: 0;\n    flex-grow: 1;\n    text-align: center;\n  }\n}\n\n.nav-fill,\n.nav-justified {\n  .nav-item .nav-link {\n    width: 100%; // Make sure button will grow\n  }\n}\n\n\n// Tabbable tabs\n//\n// Hide tabbable panes to start, show them when `.active`\n\n.tab-content {\n  > .tab-pane {\n    display: none;\n  }\n  > .active {\n    display: block;\n  }\n}\n","// Navbar\n//\n// Provide a static navbar from which we expand to create full-width, fixed, and\n// other navbar variations.\n\n.navbar {\n  // scss-docs-start navbar-css-vars\n  --#{$prefix}navbar-padding-x: #{if($navbar-padding-x == null, 0, $navbar-padding-x)};\n  --#{$prefix}navbar-padding-y: #{$navbar-padding-y};\n  --#{$prefix}navbar-color: #{$navbar-light-color};\n  --#{$prefix}navbar-hover-color: #{$navbar-light-hover-color};\n  --#{$prefix}navbar-disabled-color: #{$navbar-light-disabled-color};\n  --#{$prefix}navbar-active-color: #{$navbar-light-active-color};\n  --#{$prefix}navbar-brand-padding-y: #{$navbar-brand-padding-y};\n  --#{$prefix}navbar-brand-margin-end: #{$navbar-brand-margin-end};\n  --#{$prefix}navbar-brand-font-size: #{$navbar-brand-font-size};\n  --#{$prefix}navbar-brand-color: #{$navbar-light-brand-color};\n  --#{$prefix}navbar-brand-hover-color: #{$navbar-light-brand-hover-color};\n  --#{$prefix}navbar-nav-link-padding-x: #{$navbar-nav-link-padding-x};\n  --#{$prefix}navbar-toggler-padding-y: #{$navbar-toggler-padding-y};\n  --#{$prefix}navbar-toggler-padding-x: #{$navbar-toggler-padding-x};\n  --#{$prefix}navbar-toggler-font-size: #{$navbar-toggler-font-size};\n  --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-light-toggler-icon-bg)};\n  --#{$prefix}navbar-toggler-border-color: #{$navbar-light-toggler-border-color};\n  --#{$prefix}navbar-toggler-border-radius: #{$navbar-toggler-border-radius};\n  --#{$prefix}navbar-toggler-focus-width: #{$navbar-toggler-focus-width};\n  --#{$prefix}navbar-toggler-transition: #{$navbar-toggler-transition};\n  // scss-docs-end navbar-css-vars\n\n  position: relative;\n  display: flex;\n  flex-wrap: wrap; // allow us to do the line break for collapsing content\n  align-items: center;\n  justify-content: space-between; // space out brand from logo\n  padding: var(--#{$prefix}navbar-padding-y) var(--#{$prefix}navbar-padding-x);\n  @include gradient-bg();\n\n  // Because flex properties aren't inherited, we need to redeclare these first\n  // few properties so that content nested within behave properly.\n  // The `flex-wrap` property is inherited to simplify the expanded navbars\n  %container-flex-properties {\n    display: flex;\n    flex-wrap: inherit;\n    align-items: center;\n    justify-content: space-between;\n  }\n\n  > .container,\n  > .container-fluid {\n    @extend %container-flex-properties;\n  }\n\n  @each $breakpoint, $container-max-width in $container-max-widths {\n    > .container#{breakpoint-infix($breakpoint, $container-max-widths)} {\n      @extend %container-flex-properties;\n    }\n  }\n}\n\n\n// Navbar brand\n//\n// Used for brand, project, or site names.\n\n.navbar-brand {\n  padding-top: var(--#{$prefix}navbar-brand-padding-y);\n  padding-bottom: var(--#{$prefix}navbar-brand-padding-y);\n  margin-right: var(--#{$prefix}navbar-brand-margin-end);\n  @include font-size(var(--#{$prefix}navbar-brand-font-size));\n  color: var(--#{$prefix}navbar-brand-color);\n  text-decoration: if($link-decoration == none, null, none);\n  white-space: nowrap;\n\n  &:hover,\n  &:focus {\n    color: var(--#{$prefix}navbar-brand-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n}\n\n\n// Navbar nav\n//\n// Custom navbar navigation (doesn't require `.nav`, but does make use of `.nav-link`).\n\n.navbar-nav {\n  // scss-docs-start navbar-nav-css-vars\n  --#{$prefix}nav-link-padding-x: 0;\n  --#{$prefix}nav-link-padding-y: #{$nav-link-padding-y};\n  @include rfs($nav-link-font-size, --#{$prefix}nav-link-font-size);\n  --#{$prefix}nav-link-font-weight: #{$nav-link-font-weight};\n  --#{$prefix}nav-link-color: var(--#{$prefix}navbar-color);\n  --#{$prefix}nav-link-hover-color: var(--#{$prefix}navbar-hover-color);\n  --#{$prefix}nav-link-disabled-color: var(--#{$prefix}navbar-disabled-color);\n  // scss-docs-end navbar-nav-css-vars\n\n  display: flex;\n  flex-direction: column; // cannot use `inherit` to get the `.navbar`s value\n  padding-left: 0;\n  margin-bottom: 0;\n  list-style: none;\n\n  .show > .nav-link,\n  .nav-link.active {\n    color: var(--#{$prefix}navbar-active-color);\n  }\n\n  .dropdown-menu {\n    position: static;\n  }\n}\n\n\n// Navbar text\n//\n//\n\n.navbar-text {\n  padding-top: $nav-link-padding-y;\n  padding-bottom: $nav-link-padding-y;\n  color: var(--#{$prefix}navbar-color);\n\n  a,\n  a:hover,\n  a:focus  {\n    color: var(--#{$prefix}navbar-active-color);\n  }\n}\n\n\n// Responsive navbar\n//\n// Custom styles for responsive collapsing and toggling of navbar contents.\n// Powered by the collapse Bootstrap JavaScript plugin.\n\n// When collapsed, prevent the toggleable navbar contents from appearing in\n// the default flexbox row orientation. Requires the use of `flex-wrap: wrap`\n// on the `.navbar` parent.\n.navbar-collapse {\n  flex-basis: 100%;\n  flex-grow: 1;\n  // For always expanded or extra full navbars, ensure content aligns itself\n  // properly vertically. Can be easily overridden with flex utilities.\n  align-items: center;\n}\n\n// Button for toggling the navbar when in its collapsed state\n.navbar-toggler {\n  padding: var(--#{$prefix}navbar-toggler-padding-y) var(--#{$prefix}navbar-toggler-padding-x);\n  @include font-size(var(--#{$prefix}navbar-toggler-font-size));\n  line-height: 1;\n  color: var(--#{$prefix}navbar-color);\n  background-color: transparent; // remove default button style\n  border: var(--#{$prefix}border-width) solid var(--#{$prefix}navbar-toggler-border-color); // remove default button style\n  @include border-radius(var(--#{$prefix}navbar-toggler-border-radius));\n  @include transition(var(--#{$prefix}navbar-toggler-transition));\n\n  &:hover {\n    text-decoration: none;\n  }\n\n  &:focus {\n    text-decoration: none;\n    outline: 0;\n    box-shadow: 0 0 0 var(--#{$prefix}navbar-toggler-focus-width);\n  }\n}\n\n// Keep as a separate element so folks can easily override it with another icon\n// or image file as needed.\n.navbar-toggler-icon {\n  display: inline-block;\n  width: 1.5em;\n  height: 1.5em;\n  vertical-align: middle;\n  background-image: var(--#{$prefix}navbar-toggler-icon-bg);\n  background-repeat: no-repeat;\n  background-position: center;\n  background-size: 100%;\n}\n\n.navbar-nav-scroll {\n  max-height: var(--#{$prefix}scroll-height, 75vh);\n  overflow-y: auto;\n}\n\n// scss-docs-start navbar-expand-loop\n// Generate series of `.navbar-expand-*` responsive classes for configuring\n// where your navbar collapses.\n.navbar-expand {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $next: breakpoint-next($breakpoint, $grid-breakpoints);\n    $infix: breakpoint-infix($next, $grid-breakpoints);\n\n    // stylelint-disable-next-line scss/selector-no-union-class-name\n    &#{$infix} {\n      @include media-breakpoint-up($next) {\n        flex-wrap: nowrap;\n        justify-content: flex-start;\n\n        .navbar-nav {\n          flex-direction: row;\n\n          .dropdown-menu {\n            position: absolute;\n          }\n\n          .nav-link {\n            padding-right: var(--#{$prefix}navbar-nav-link-padding-x);\n            padding-left: var(--#{$prefix}navbar-nav-link-padding-x);\n          }\n        }\n\n        .navbar-nav-scroll {\n          overflow: visible;\n        }\n\n        .navbar-collapse {\n          display: flex !important; // stylelint-disable-line declaration-no-important\n          flex-basis: auto;\n        }\n\n        .navbar-toggler {\n          display: none;\n        }\n\n        .offcanvas {\n          // stylelint-disable declaration-no-important\n          position: static;\n          z-index: auto;\n          flex-grow: 1;\n          width: auto !important;\n          height: auto !important;\n          visibility: visible !important;\n          background-color: transparent !important;\n          border: 0 !important;\n          transform: none !important;\n          @include box-shadow(none);\n          @include transition(none);\n          // stylelint-enable declaration-no-important\n\n          .offcanvas-header {\n            display: none;\n          }\n\n          .offcanvas-body {\n            display: flex;\n            flex-grow: 0;\n            padding: 0;\n            overflow-y: visible;\n          }\n        }\n      }\n    }\n  }\n}\n// scss-docs-end navbar-expand-loop\n\n// Navbar themes\n//\n// Styles for switching between navbars with light or dark background.\n\n.navbar-light {\n  @include deprecate(\"`.navbar-light`\", \"v5.2.0\", \"v6.0.0\", true);\n}\n\n.navbar-dark {\n  // scss-docs-start navbar-dark-css-vars\n  --#{$prefix}navbar-color: #{$navbar-dark-color};\n  --#{$prefix}navbar-hover-color: #{$navbar-dark-hover-color};\n  --#{$prefix}navbar-disabled-color: #{$navbar-dark-disabled-color};\n  --#{$prefix}navbar-active-color: #{$navbar-dark-active-color};\n  --#{$prefix}navbar-brand-color: #{$navbar-dark-brand-color};\n  --#{$prefix}navbar-brand-hover-color: #{$navbar-dark-brand-hover-color};\n  --#{$prefix}navbar-toggler-border-color: #{$navbar-dark-toggler-border-color};\n  --#{$prefix}navbar-toggler-icon-bg: #{escape-svg($navbar-dark-toggler-icon-bg)};\n  // scss-docs-end navbar-dark-css-vars\n}\n","//\n// Base styles\n//\n\n.card {\n  // scss-docs-start card-css-vars\n  --#{$prefix}card-spacer-y: #{$card-spacer-y};\n  --#{$prefix}card-spacer-x: #{$card-spacer-x};\n  --#{$prefix}card-title-spacer-y: #{$card-title-spacer-y};\n  --#{$prefix}card-border-width: #{$card-border-width};\n  --#{$prefix}card-border-color: #{$card-border-color};\n  --#{$prefix}card-border-radius: #{$card-border-radius};\n  --#{$prefix}card-box-shadow: #{$card-box-shadow};\n  --#{$prefix}card-inner-border-radius: #{$card-inner-border-radius};\n  --#{$prefix}card-cap-padding-y: #{$card-cap-padding-y};\n  --#{$prefix}card-cap-padding-x: #{$card-cap-padding-x};\n  --#{$prefix}card-cap-bg: #{$card-cap-bg};\n  --#{$prefix}card-cap-color: #{$card-cap-color};\n  --#{$prefix}card-height: #{$card-height};\n  --#{$prefix}card-color: #{$card-color};\n  --#{$prefix}card-bg: #{$card-bg};\n  --#{$prefix}card-img-overlay-padding: #{$card-img-overlay-padding};\n  --#{$prefix}card-group-margin: #{$card-group-margin};\n  // scss-docs-end card-css-vars\n\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  min-width: 0; // See https://github.com/twbs/bootstrap/pull/22740#issuecomment-305868106\n  height: var(--#{$prefix}card-height);\n  word-wrap: break-word;\n  background-color: var(--#{$prefix}card-bg);\n  background-clip: border-box;\n  border: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n  @include border-radius(var(--#{$prefix}card-border-radius));\n  @include box-shadow(var(--#{$prefix}card-box-shadow));\n\n  > hr {\n    margin-right: 0;\n    margin-left: 0;\n  }\n\n  > .list-group {\n    border-top: inherit;\n    border-bottom: inherit;\n\n    &:first-child {\n      border-top-width: 0;\n      @include border-top-radius(var(--#{$prefix}card-inner-border-radius));\n    }\n\n    &:last-child  {\n      border-bottom-width: 0;\n      @include border-bottom-radius(var(--#{$prefix}card-inner-border-radius));\n    }\n  }\n\n  // Due to specificity of the above selector (`.card > .list-group`), we must\n  // use a child selector here to prevent double borders.\n  > .card-header + .list-group,\n  > .list-group + .card-footer {\n    border-top: 0;\n  }\n}\n\n.card-body {\n  // Enable `flex-grow: 1` for decks and groups so that card blocks take up\n  // as much space as possible, ensuring footers are aligned to the bottom.\n  flex: 1 1 auto;\n  padding: var(--#{$prefix}card-spacer-y) var(--#{$prefix}card-spacer-x);\n  color: var(--#{$prefix}card-color);\n}\n\n.card-title {\n  margin-bottom: var(--#{$prefix}card-title-spacer-y);\n}\n\n.card-subtitle {\n  margin-top: calc(-.5 * var(--#{$prefix}card-title-spacer-y)); // stylelint-disable-line function-disallowed-list\n  margin-bottom: 0;\n}\n\n.card-text:last-child {\n  margin-bottom: 0;\n}\n\n.card-link {\n  &:hover {\n    text-decoration: if($link-hover-decoration == underline, none, null);\n  }\n\n  + .card-link {\n    margin-left: var(--#{$prefix}card-spacer-x);\n  }\n}\n\n//\n// Optional textual caps\n//\n\n.card-header {\n  padding: var(--#{$prefix}card-cap-padding-y) var(--#{$prefix}card-cap-padding-x);\n  margin-bottom: 0; // Removes the default margin-bottom of <hN>\n  color: var(--#{$prefix}card-cap-color);\n  background-color: var(--#{$prefix}card-cap-bg);\n  border-bottom: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n\n  &:first-child {\n    @include border-radius(var(--#{$prefix}card-inner-border-radius) var(--#{$prefix}card-inner-border-radius) 0 0);\n  }\n}\n\n.card-footer {\n  padding: var(--#{$prefix}card-cap-padding-y) var(--#{$prefix}card-cap-padding-x);\n  color: var(--#{$prefix}card-cap-color);\n  background-color: var(--#{$prefix}card-cap-bg);\n  border-top: var(--#{$prefix}card-border-width) solid var(--#{$prefix}card-border-color);\n\n  &:last-child {\n    @include border-radius(0 0 var(--#{$prefix}card-inner-border-radius) var(--#{$prefix}card-inner-border-radius));\n  }\n}\n\n\n//\n// Header navs\n//\n\n.card-header-tabs {\n  margin-right: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  margin-bottom: calc(-1 * var(--#{$prefix}card-cap-padding-y)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  border-bottom: 0;\n\n  .nav-link.active {\n    background-color: var(--#{$prefix}card-bg);\n    border-bottom-color: var(--#{$prefix}card-bg);\n  }\n}\n\n.card-header-pills {\n  margin-right: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n  margin-left: calc(-.5 * var(--#{$prefix}card-cap-padding-x)); // stylelint-disable-line function-disallowed-list\n}\n\n// Card image\n.card-img-overlay {\n  position: absolute;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  padding: var(--#{$prefix}card-img-overlay-padding);\n  @include border-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n.card-img,\n.card-img-top,\n.card-img-bottom {\n  width: 100%; // Required because we use flexbox and this inherently applies align-self: stretch\n}\n\n.card-img,\n.card-img-top {\n  @include border-top-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n.card-img,\n.card-img-bottom {\n  @include border-bottom-radius(var(--#{$prefix}card-inner-border-radius));\n}\n\n\n//\n// Card groups\n//\n\n.card-group {\n  // The child selector allows nested `.card` within `.card-group`\n  // to display properly.\n  > .card {\n    margin-bottom: var(--#{$prefix}card-group-margin);\n  }\n\n  @include media-breakpoint-up(sm) {\n    display: flex;\n    flex-flow: row wrap;\n    // The child selector allows nested `.card` within `.card-group`\n    // to display properly.\n    > .card {\n      // Flexbugs #4: https://github.com/philipwalton/flexbugs#flexbug-4\n      flex: 1 0 0%;\n      margin-bottom: 0;\n\n      + .card {\n        margin-left: 0;\n        border-left: 0;\n      }\n\n      // Handle rounded corners\n      @if $enable-rounded {\n        &:not(:last-child) {\n          @include border-end-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-right-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-right-radius: 0;\n          }\n        }\n\n        &:not(:first-child) {\n          @include border-start-radius(0);\n\n          .card-img-top,\n          .card-header {\n            // stylelint-disable-next-line property-disallowed-list\n            border-top-left-radius: 0;\n          }\n          .card-img-bottom,\n          .card-footer {\n            // stylelint-disable-next-line property-disallowed-list\n            border-bottom-left-radius: 0;\n          }\n        }\n      }\n    }\n  }\n}\n","//\n// Base styles\n//\n\n.accordion {\n  // scss-docs-start accordion-css-vars\n  --#{$prefix}accordion-color: #{$accordion-color};\n  --#{$prefix}accordion-bg: #{$accordion-bg};\n  --#{$prefix}accordion-transition: #{$accordion-transition};\n  --#{$prefix}accordion-border-color: #{$accordion-border-color};\n  --#{$prefix}accordion-border-width: #{$accordion-border-width};\n  --#{$prefix}accordion-border-radius: #{$accordion-border-radius};\n  --#{$prefix}accordion-inner-border-radius: #{$accordion-inner-border-radius};\n  --#{$prefix}accordion-btn-padding-x: #{$accordion-button-padding-x};\n  --#{$prefix}accordion-btn-padding-y: #{$accordion-button-padding-y};\n  --#{$prefix}accordion-btn-color: #{$accordion-button-color};\n  --#{$prefix}accordion-btn-bg: #{$accordion-button-bg};\n  --#{$prefix}accordion-btn-icon: #{escape-svg($accordion-button-icon)};\n  --#{$prefix}accordion-btn-icon-width: #{$accordion-icon-width};\n  --#{$prefix}accordion-btn-icon-transform: #{$accordion-icon-transform};\n  --#{$prefix}accordion-btn-icon-transition: #{$accordion-icon-transition};\n  --#{$prefix}accordion-btn-active-icon: #{escape-svg($accordion-button-active-icon)};\n  --#{$prefix}accordion-btn-focus-border-color: #{$accordion-button-focus-border-color};\n  --#{$prefix}accordion-btn-focus-box-shadow: #{$accordion-button-focus-box-shadow};\n  --#{$prefix}accordion-body-padding-x: #{$accordion-body-padding-x};\n  --#{$prefix}accordion-body-padding-y: #{$accordion-body-padding-y};\n  --#{$prefix}accordion-active-color: #{$accordion-button-active-color};\n  --#{$prefix}accordion-active-bg: #{$accordion-button-active-bg};\n  // scss-docs-end accordion-css-vars\n}\n\n.accordion-button {\n  position: relative;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  padding: var(--#{$prefix}accordion-btn-padding-y) var(--#{$prefix}accordion-btn-padding-x);\n  @include font-size($font-size-base);\n  color: var(--#{$prefix}accordion-btn-color);\n  text-align: left; // Reset button style\n  background-color: var(--#{$prefix}accordion-btn-bg);\n  border: 0;\n  @include border-radius(0);\n  overflow-anchor: none;\n  @include transition(var(--#{$prefix}accordion-transition));\n\n  &:not(.collapsed) {\n    color: var(--#{$prefix}accordion-active-color);\n    background-color: var(--#{$prefix}accordion-active-bg);\n    box-shadow: inset 0 calc(-1 * var(--#{$prefix}accordion-border-width)) 0 var(--#{$prefix}accordion-border-color); // stylelint-disable-line function-disallowed-list\n\n    &::after {\n      background-image: var(--#{$prefix}accordion-btn-active-icon);\n      transform: var(--#{$prefix}accordion-btn-icon-transform);\n    }\n  }\n\n  // Accordion icon\n  &::after {\n    flex-shrink: 0;\n    width: var(--#{$prefix}accordion-btn-icon-width);\n    height: var(--#{$prefix}accordion-btn-icon-width);\n    margin-left: auto;\n    content: \"\";\n    background-image: var(--#{$prefix}accordion-btn-icon);\n    background-repeat: no-repeat;\n    background-size: var(--#{$prefix}accordion-btn-icon-width);\n    @include transition(var(--#{$prefix}accordion-btn-icon-transition));\n  }\n\n  &:hover {\n    z-index: 2;\n  }\n\n  &:focus {\n    z-index: 3;\n    border-color: var(--#{$prefix}accordion-btn-focus-border-color);\n    outline: 0;\n    box-shadow: var(--#{$prefix}accordion-btn-focus-box-shadow);\n  }\n}\n\n.accordion-header {\n  margin-bottom: 0;\n}\n\n.accordion-item {\n  color: var(--#{$prefix}accordion-color);\n  background-color: var(--#{$prefix}accordion-bg);\n  border: var(--#{$prefix}accordion-border-width) solid var(--#{$prefix}accordion-border-color);\n\n  &:first-of-type {\n    @include border-top-radius(var(--#{$prefix}accordion-border-radius));\n\n    .accordion-button {\n      @include border-top-radius(var(--#{$prefix}accordion-inner-border-radius));\n    }\n  }\n\n  &:not(:first-of-type) {\n    border-top: 0;\n  }\n\n  // Only set a border-radius on the last item if the accordion is collapsed\n  &:last-of-type {\n    @include border-bottom-radius(var(--#{$prefix}accordion-border-radius));\n\n    .accordion-button {\n      &.collapsed {\n        @include border-bottom-radius(var(--#{$prefix}accordion-inner-border-radius));\n      }\n    }\n\n    .accordion-collapse {\n      @include border-bottom-radius(var(--#{$prefix}accordion-border-radius));\n    }\n  }\n}\n\n.accordion-body {\n  padding: var(--#{$prefix}accordion-body-padding-y) var(--#{$prefix}accordion-body-padding-x);\n}\n\n\n// Flush accordion items\n//\n// Remove borders and border-radius to keep accordion items edge-to-edge.\n\n.accordion-flush {\n  .accordion-collapse {\n    border-width: 0;\n  }\n\n  .accordion-item {\n    border-right: 0;\n    border-left: 0;\n    @include border-radius(0);\n\n    &:first-child { border-top: 0; }\n    &:last-child { border-bottom: 0; }\n\n    .accordion-button {\n      &,\n      &.collapsed {\n        @include border-radius(0);\n      }\n    }\n  }\n}\n",".breadcrumb {\n  // scss-docs-start breadcrumb-css-vars\n  --#{$prefix}breadcrumb-padding-x: #{$breadcrumb-padding-x};\n  --#{$prefix}breadcrumb-padding-y: #{$breadcrumb-padding-y};\n  --#{$prefix}breadcrumb-margin-bottom: #{$breadcrumb-margin-bottom};\n  @include rfs($breadcrumb-font-size, --#{$prefix}breadcrumb-font-size);\n  --#{$prefix}breadcrumb-bg: #{$breadcrumb-bg};\n  --#{$prefix}breadcrumb-border-radius: #{$breadcrumb-border-radius};\n  --#{$prefix}breadcrumb-divider-color: #{$breadcrumb-divider-color};\n  --#{$prefix}breadcrumb-item-padding-x: #{$breadcrumb-item-padding-x};\n  --#{$prefix}breadcrumb-item-active-color: #{$breadcrumb-active-color};\n  // scss-docs-end breadcrumb-css-vars\n\n  display: flex;\n  flex-wrap: wrap;\n  padding: var(--#{$prefix}breadcrumb-padding-y) var(--#{$prefix}breadcrumb-padding-x);\n  margin-bottom: var(--#{$prefix}breadcrumb-margin-bottom);\n  @include font-size(var(--#{$prefix}breadcrumb-font-size));\n  list-style: none;\n  background-color: var(--#{$prefix}breadcrumb-bg);\n  @include border-radius(var(--#{$prefix}breadcrumb-border-radius));\n}\n\n.breadcrumb-item {\n  // The separator between breadcrumbs (by default, a forward-slash: \"/\")\n  + .breadcrumb-item {\n    padding-left: var(--#{$prefix}breadcrumb-item-padding-x);\n\n    &::before {\n      float: left; // Suppress inline spacings and underlining of the separator\n      padding-right: var(--#{$prefix}breadcrumb-item-padding-x);\n      color: var(--#{$prefix}breadcrumb-divider-color);\n      content: var(--#{$prefix}breadcrumb-divider, escape-svg($breadcrumb-divider)) #{\"/* rtl:\"} var(--#{$prefix}breadcrumb-divider, escape-svg($breadcrumb-divider-flipped)) #{\"*/\"};\n    }\n  }\n\n  &.active {\n    color: var(--#{$prefix}breadcrumb-item-active-color);\n  }\n}\n",".pagination {\n  // scss-docs-start pagination-css-vars\n  --#{$prefix}pagination-padding-x: #{$pagination-padding-x};\n  --#{$prefix}pagination-padding-y: #{$pagination-padding-y};\n  @include rfs($pagination-font-size, --#{$prefix}pagination-font-size);\n  --#{$prefix}pagination-color: #{$pagination-color};\n  --#{$prefix}pagination-bg: #{$pagination-bg};\n  --#{$prefix}pagination-border-width: #{$pagination-border-width};\n  --#{$prefix}pagination-border-color: #{$pagination-border-color};\n  --#{$prefix}pagination-border-radius: #{$pagination-border-radius};\n  --#{$prefix}pagination-hover-color: #{$pagination-hover-color};\n  --#{$prefix}pagination-hover-bg: #{$pagination-hover-bg};\n  --#{$prefix}pagination-hover-border-color: #{$pagination-hover-border-color};\n  --#{$prefix}pagination-focus-color: #{$pagination-focus-color};\n  --#{$prefix}pagination-focus-bg: #{$pagination-focus-bg};\n  --#{$prefix}pagination-focus-box-shadow: #{$pagination-focus-box-shadow};\n  --#{$prefix}pagination-active-color: #{$pagination-active-color};\n  --#{$prefix}pagination-active-bg: #{$pagination-active-bg};\n  --#{$prefix}pagination-active-border-color: #{$pagination-active-border-color};\n  --#{$prefix}pagination-disabled-color: #{$pagination-disabled-color};\n  --#{$prefix}pagination-disabled-bg: #{$pagination-disabled-bg};\n  --#{$prefix}pagination-disabled-border-color: #{$pagination-disabled-border-color};\n  // scss-docs-end pagination-css-vars\n\n  display: flex;\n  @include list-unstyled();\n}\n\n.page-link {\n  position: relative;\n  display: block;\n  padding: var(--#{$prefix}pagination-padding-y) var(--#{$prefix}pagination-padding-x);\n  @include font-size(var(--#{$prefix}pagination-font-size));\n  color: var(--#{$prefix}pagination-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: var(--#{$prefix}pagination-bg);\n  border: var(--#{$prefix}pagination-border-width) solid var(--#{$prefix}pagination-border-color);\n  @include transition($pagination-transition);\n\n  &:hover {\n    z-index: 2;\n    color: var(--#{$prefix}pagination-hover-color);\n    text-decoration: if($link-hover-decoration == underline, none, null);\n    background-color: var(--#{$prefix}pagination-hover-bg);\n    border-color: var(--#{$prefix}pagination-hover-border-color);\n  }\n\n  &:focus {\n    z-index: 3;\n    color: var(--#{$prefix}pagination-focus-color);\n    background-color: var(--#{$prefix}pagination-focus-bg);\n    outline: $pagination-focus-outline;\n    box-shadow: var(--#{$prefix}pagination-focus-box-shadow);\n  }\n\n  &.active,\n  .active > & {\n    z-index: 3;\n    color: var(--#{$prefix}pagination-active-color);\n    @include gradient-bg(var(--#{$prefix}pagination-active-bg));\n    border-color: var(--#{$prefix}pagination-active-border-color);\n  }\n\n  &.disabled,\n  .disabled > & {\n    color: var(--#{$prefix}pagination-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}pagination-disabled-bg);\n    border-color: var(--#{$prefix}pagination-disabled-border-color);\n  }\n}\n\n.page-item {\n  &:not(:first-child) .page-link {\n    margin-left: $pagination-margin-start;\n  }\n\n  @if $pagination-margin-start == ($pagination-border-width * -1) {\n    &:first-child {\n      .page-link {\n        @include border-start-radius(var(--#{$prefix}pagination-border-radius));\n      }\n    }\n\n    &:last-child {\n      .page-link {\n        @include border-end-radius(var(--#{$prefix}pagination-border-radius));\n      }\n    }\n  } @else {\n    // Add border-radius to all pageLinks in case they have left margin\n    .page-link {\n      @include border-radius(var(--#{$prefix}pagination-border-radius));\n    }\n  }\n}\n\n\n//\n// Sizing\n//\n\n.pagination-lg {\n  @include pagination-size($pagination-padding-y-lg, $pagination-padding-x-lg, $font-size-lg, $pagination-border-radius-lg);\n}\n\n.pagination-sm {\n  @include pagination-size($pagination-padding-y-sm, $pagination-padding-x-sm, $font-size-sm, $pagination-border-radius-sm);\n}\n","// Pagination\n\n// scss-docs-start pagination-mixin\n@mixin pagination-size($padding-y, $padding-x, $font-size, $border-radius) {\n  --#{$prefix}pagination-padding-x: #{$padding-x};\n  --#{$prefix}pagination-padding-y: #{$padding-y};\n  @include rfs($font-size, --#{$prefix}pagination-font-size);\n  --#{$prefix}pagination-border-radius: #{$border-radius};\n}\n// scss-docs-end pagination-mixin\n","// Base class\n//\n// Requires one of the contextual, color modifier classes for `color` and\n// `background-color`.\n\n.badge {\n  // scss-docs-start badge-css-vars\n  --#{$prefix}badge-padding-x: #{$badge-padding-x};\n  --#{$prefix}badge-padding-y: #{$badge-padding-y};\n  @include rfs($badge-font-size, --#{$prefix}badge-font-size);\n  --#{$prefix}badge-font-weight: #{$badge-font-weight};\n  --#{$prefix}badge-color: #{$badge-color};\n  --#{$prefix}badge-border-radius: #{$badge-border-radius};\n  // scss-docs-end badge-css-vars\n\n  display: inline-block;\n  padding: var(--#{$prefix}badge-padding-y) var(--#{$prefix}badge-padding-x);\n  @include font-size(var(--#{$prefix}badge-font-size));\n  font-weight: var(--#{$prefix}badge-font-weight);\n  line-height: 1;\n  color: var(--#{$prefix}badge-color);\n  text-align: center;\n  white-space: nowrap;\n  vertical-align: baseline;\n  @include border-radius(var(--#{$prefix}badge-border-radius));\n  @include gradient-bg();\n\n  // Empty badges collapse automatically\n  &:empty {\n    display: none;\n  }\n}\n\n// Quick fix for badges in buttons\n.btn .badge {\n  position: relative;\n  top: -1px;\n}\n","//\n// Base styles\n//\n\n.alert {\n  // scss-docs-start alert-css-vars\n  --#{$prefix}alert-bg: transparent;\n  --#{$prefix}alert-padding-x: #{$alert-padding-x};\n  --#{$prefix}alert-padding-y: #{$alert-padding-y};\n  --#{$prefix}alert-margin-bottom: #{$alert-margin-bottom};\n  --#{$prefix}alert-color: inherit;\n  --#{$prefix}alert-border-color: transparent;\n  --#{$prefix}alert-border: #{$alert-border-width} solid var(--#{$prefix}alert-border-color);\n  --#{$prefix}alert-border-radius: #{$alert-border-radius};\n  // scss-docs-end alert-css-vars\n\n  position: relative;\n  padding: var(--#{$prefix}alert-padding-y) var(--#{$prefix}alert-padding-x);\n  margin-bottom: var(--#{$prefix}alert-margin-bottom);\n  color: var(--#{$prefix}alert-color);\n  background-color: var(--#{$prefix}alert-bg);\n  border: var(--#{$prefix}alert-border);\n  @include border-radius(var(--#{$prefix}alert-border-radius));\n}\n\n// Headings for larger alerts\n.alert-heading {\n  // Specified to prevent conflicts of changing $headings-color\n  color: inherit;\n}\n\n// Provide class for links that match alerts\n.alert-link {\n  font-weight: $alert-link-font-weight;\n}\n\n\n// Dismissible alerts\n//\n// Expand the right padding and account for the close button's positioning.\n\n.alert-dismissible {\n  padding-right: $alert-dismissible-padding-r;\n\n  // Adjust close link position\n  .btn-close {\n    position: absolute;\n    top: 0;\n    right: 0;\n    z-index: $stretched-link-z-index + 1;\n    padding: $alert-padding-y * 1.25 $alert-padding-x;\n  }\n}\n\n\n// scss-docs-start alert-modifiers\n// Generate contextual modifier classes for colorizing the alert.\n\n@each $state, $value in $theme-colors {\n  $alert-background: shift-color($value, $alert-bg-scale);\n  $alert-border: shift-color($value, $alert-border-scale);\n  $alert-color: shift-color($value, $alert-color-scale);\n\n  @if (contrast-ratio($alert-background, $alert-color) < $min-contrast-ratio) {\n    $alert-color: mix($value, color-contrast($alert-background), abs($alert-color-scale));\n  }\n  .alert-#{$state} {\n    @include alert-variant($alert-background, $alert-border, $alert-color);\n  }\n}\n// scss-docs-end alert-modifiers\n","// scss-docs-start alert-variant-mixin\n@mixin alert-variant($background, $border, $color) {\n  --#{$prefix}alert-color: #{$color};\n  --#{$prefix}alert-bg: #{$background};\n  --#{$prefix}alert-border-color: #{$border};\n\n  @if $enable-gradients {\n    background-image: var(--#{$prefix}gradient);\n  }\n\n  .alert-link {\n    color: shade-color($color, 20%);\n  }\n}\n// scss-docs-end alert-variant-mixin\n","// Disable animation if transitions are disabled\n\n// scss-docs-start progress-keyframes\n@if $enable-transitions {\n  @keyframes progress-bar-stripes {\n    0% { background-position-x: $progress-height; }\n  }\n}\n// scss-docs-end progress-keyframes\n\n.progress {\n  // scss-docs-start progress-css-vars\n  --#{$prefix}progress-height: #{$progress-height};\n  @include rfs($progress-font-size, --#{$prefix}progress-font-size);\n  --#{$prefix}progress-bg: #{$progress-bg};\n  --#{$prefix}progress-border-radius: #{$progress-border-radius};\n  --#{$prefix}progress-box-shadow: #{$progress-box-shadow};\n  --#{$prefix}progress-bar-color: #{$progress-bar-color};\n  --#{$prefix}progress-bar-bg: #{$progress-bar-bg};\n  --#{$prefix}progress-bar-transition: #{$progress-bar-transition};\n  // scss-docs-end progress-css-vars\n\n  display: flex;\n  height: var(--#{$prefix}progress-height);\n  overflow: hidden; // force rounded corners by cropping it\n  @include font-size(var(--#{$prefix}progress-font-size));\n  background-color: var(--#{$prefix}progress-bg);\n  @include border-radius(var(--#{$prefix}progress-border-radius));\n  @include box-shadow(var(--#{$prefix}progress-box-shadow));\n}\n\n.progress-bar {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow: hidden;\n  color: var(--#{$prefix}progress-bar-color);\n  text-align: center;\n  white-space: nowrap;\n  background-color: var(--#{$prefix}progress-bar-bg);\n  @include transition(var(--#{$prefix}progress-bar-transition));\n}\n\n.progress-bar-striped {\n  @include gradient-striped();\n  background-size: var(--#{$prefix}progress-height) var(--#{$prefix}progress-height);\n}\n\n@if $enable-transitions {\n  .progress-bar-animated {\n    animation: $progress-bar-animation-timing progress-bar-stripes;\n\n    @if $enable-reduced-motion {\n      @media (prefers-reduced-motion: reduce) {\n        animation: none;\n      }\n    }\n  }\n}\n","// Base class\n//\n// Easily usable on <ul>, <ol>, or <div>.\n\n.list-group {\n  // scss-docs-start list-group-css-vars\n  --#{$prefix}list-group-color: #{$list-group-color};\n  --#{$prefix}list-group-bg: #{$list-group-bg};\n  --#{$prefix}list-group-border-color: #{$list-group-border-color};\n  --#{$prefix}list-group-border-width: #{$list-group-border-width};\n  --#{$prefix}list-group-border-radius: #{$list-group-border-radius};\n  --#{$prefix}list-group-item-padding-x: #{$list-group-item-padding-x};\n  --#{$prefix}list-group-item-padding-y: #{$list-group-item-padding-y};\n  --#{$prefix}list-group-action-color: #{$list-group-action-color};\n  --#{$prefix}list-group-action-hover-color: #{$list-group-action-hover-color};\n  --#{$prefix}list-group-action-hover-bg: #{$list-group-hover-bg};\n  --#{$prefix}list-group-action-active-color: #{$list-group-action-active-color};\n  --#{$prefix}list-group-action-active-bg: #{$list-group-action-active-bg};\n  --#{$prefix}list-group-disabled-color: #{$list-group-disabled-color};\n  --#{$prefix}list-group-disabled-bg: #{$list-group-disabled-bg};\n  --#{$prefix}list-group-active-color: #{$list-group-active-color};\n  --#{$prefix}list-group-active-bg: #{$list-group-active-bg};\n  --#{$prefix}list-group-active-border-color: #{$list-group-active-border-color};\n  // scss-docs-end list-group-css-vars\n\n  display: flex;\n  flex-direction: column;\n\n  // No need to set list-style: none; since .list-group-item is block level\n  padding-left: 0; // reset padding because ul and ol\n  margin-bottom: 0;\n  @include border-radius(var(--#{$prefix}list-group-border-radius));\n}\n\n.list-group-numbered {\n  list-style-type: none;\n  counter-reset: section;\n\n  > .list-group-item::before {\n    // Increments only this instance of the section counter\n    content: counters(section, \".\") \". \";\n    counter-increment: section;\n  }\n}\n\n// Interactive list items\n//\n// Use anchor or button elements instead of `li`s or `div`s to create interactive\n// list items. Includes an extra `.active` modifier class for selected items.\n\n.list-group-item-action {\n  width: 100%; // For `<button>`s (anchors become 100% by default though)\n  color: var(--#{$prefix}list-group-action-color);\n  text-align: inherit; // For `<button>`s (anchors inherit)\n\n  // Hover state\n  &:hover,\n  &:focus {\n    z-index: 1; // Place hover/focus items above their siblings for proper border styling\n    color: var(--#{$prefix}list-group-action-hover-color);\n    text-decoration: none;\n    background-color: var(--#{$prefix}list-group-action-hover-bg);\n  }\n\n  &:active {\n    color: var(--#{$prefix}list-group-action-active-color);\n    background-color: var(--#{$prefix}list-group-action-active-bg);\n  }\n}\n\n// Individual list items\n//\n// Use on `li`s or `div`s within the `.list-group` parent.\n\n.list-group-item {\n  position: relative;\n  display: block;\n  padding: var(--#{$prefix}list-group-item-padding-y) var(--#{$prefix}list-group-item-padding-x);\n  color: var(--#{$prefix}list-group-color);\n  text-decoration: if($link-decoration == none, null, none);\n  background-color: var(--#{$prefix}list-group-bg);\n  border: var(--#{$prefix}list-group-border-width) solid var(--#{$prefix}list-group-border-color);\n\n  &:first-child {\n    @include border-top-radius(inherit);\n  }\n\n  &:last-child {\n    @include border-bottom-radius(inherit);\n  }\n\n  &.disabled,\n  &:disabled {\n    color: var(--#{$prefix}list-group-disabled-color);\n    pointer-events: none;\n    background-color: var(--#{$prefix}list-group-disabled-bg);\n  }\n\n  // Include both here for `<a>`s and `<button>`s\n  &.active {\n    z-index: 2; // Place active items above their siblings for proper border styling\n    color: var(--#{$prefix}list-group-active-color);\n    background-color: var(--#{$prefix}list-group-active-bg);\n    border-color: var(--#{$prefix}list-group-active-border-color);\n  }\n\n  // stylelint-disable-next-line scss/selector-no-redundant-nesting-selector\n  & + .list-group-item {\n    border-top-width: 0;\n\n    &.active {\n      margin-top: calc(-1 * var(--#{$prefix}list-group-border-width)); // stylelint-disable-line function-disallowed-list\n      border-top-width: var(--#{$prefix}list-group-border-width);\n    }\n  }\n}\n\n// Horizontal\n//\n// Change the layout of list group items from vertical (default) to horizontal.\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .list-group-horizontal#{$infix} {\n      flex-direction: row;\n\n      > .list-group-item {\n        &:first-child:not(:last-child) {\n          @include border-bottom-start-radius(var(--#{$prefix}list-group-border-radius));\n          @include border-top-end-radius(0);\n        }\n\n        &:last-child:not(:first-child) {\n          @include border-top-end-radius(var(--#{$prefix}list-group-border-radius));\n          @include border-bottom-start-radius(0);\n        }\n\n        &.active {\n          margin-top: 0;\n        }\n\n        + .list-group-item {\n          border-top-width: var(--#{$prefix}list-group-border-width);\n          border-left-width: 0;\n\n          &.active {\n            margin-left: calc(-1 * var(--#{$prefix}list-group-border-width)); // stylelint-disable-line function-disallowed-list\n            border-left-width: var(--#{$prefix}list-group-border-width);\n          }\n        }\n      }\n    }\n  }\n}\n\n\n// Flush list items\n//\n// Remove borders and border-radius to keep list group items edge-to-edge. Most\n// useful within other components (e.g., cards).\n\n.list-group-flush {\n  @include border-radius(0);\n\n  > .list-group-item {\n    border-width: 0 0 var(--#{$prefix}list-group-border-width);\n\n    &:last-child {\n      border-bottom-width: 0;\n    }\n  }\n}\n\n\n// scss-docs-start list-group-modifiers\n// List group contextual variants\n//\n// Add modifier classes to change text and background color on individual items.\n// Organizationally, this must come after the `:hover` states.\n\n@each $state, $value in $theme-colors {\n  $list-group-variant-bg: shift-color($value, $list-group-item-bg-scale);\n  $list-group-variant-color: shift-color($value, $list-group-item-color-scale);\n  @if (contrast-ratio($list-group-variant-bg, $list-group-variant-color) < $min-contrast-ratio) {\n    $list-group-variant-color: mix($value, color-contrast($list-group-variant-bg), abs($list-group-item-color-scale));\n  }\n\n  @include list-group-item-variant($state, $list-group-variant-bg, $list-group-variant-color);\n}\n// scss-docs-end list-group-modifiers\n","// List Groups\n\n// scss-docs-start list-group-mixin\n@mixin list-group-item-variant($state, $background, $color) {\n  .list-group-item-#{$state} {\n    color: $color;\n    background-color: $background;\n\n    &.list-group-item-action {\n      &:hover,\n      &:focus {\n        color: $color;\n        background-color: shade-color($background, 10%);\n      }\n\n      &.active {\n        color: $white;\n        background-color: $color;\n        border-color: $color;\n      }\n    }\n  }\n}\n// scss-docs-end list-group-mixin\n","// Transparent background and border properties included for button version.\n// iOS requires the button element instead of an anchor tag.\n// If you want the anchor version, it requires `href=\"#\"`.\n// See https://developer.mozilla.org/en-US/docs/Web/Events/click#Safari_Mobile\n\n.btn-close {\n  box-sizing: content-box;\n  width: $btn-close-width;\n  height: $btn-close-height;\n  padding: $btn-close-padding-y $btn-close-padding-x;\n  color: $btn-close-color;\n  background: transparent escape-svg($btn-close-bg) center / $btn-close-width auto no-repeat; // include transparent for button elements\n  border: 0; // for button elements\n  @include border-radius();\n  opacity: $btn-close-opacity;\n\n  // Override <a>'s hover style\n  &:hover {\n    color: $btn-close-color;\n    text-decoration: none;\n    opacity: $btn-close-hover-opacity;\n  }\n\n  &:focus {\n    outline: 0;\n    box-shadow: $btn-close-focus-shadow;\n    opacity: $btn-close-focus-opacity;\n  }\n\n  &:disabled,\n  &.disabled {\n    pointer-events: none;\n    user-select: none;\n    opacity: $btn-close-disabled-opacity;\n  }\n}\n\n.btn-close-white {\n  filter: $btn-close-white-filter;\n}\n",".toast {\n  // scss-docs-start toast-css-vars\n  --#{$prefix}toast-zindex: #{$zindex-toast};\n  --#{$prefix}toast-padding-x: #{$toast-padding-x};\n  --#{$prefix}toast-padding-y: #{$toast-padding-y};\n  --#{$prefix}toast-spacing: #{$toast-spacing};\n  --#{$prefix}toast-max-width: #{$toast-max-width};\n  @include rfs($toast-font-size, --#{$prefix}toast-font-size);\n  --#{$prefix}toast-color: #{$toast-color};\n  --#{$prefix}toast-bg: #{$toast-background-color};\n  --#{$prefix}toast-border-width: #{$toast-border-width};\n  --#{$prefix}toast-border-color: #{$toast-border-color};\n  --#{$prefix}toast-border-radius: #{$toast-border-radius};\n  --#{$prefix}toast-box-shadow: #{$toast-box-shadow};\n  --#{$prefix}toast-header-color: #{$toast-header-color};\n  --#{$prefix}toast-header-bg: #{$toast-header-background-color};\n  --#{$prefix}toast-header-border-color: #{$toast-header-border-color};\n  // scss-docs-end toast-css-vars\n\n  width: var(--#{$prefix}toast-max-width);\n  max-width: 100%;\n  @include font-size(var(--#{$prefix}toast-font-size));\n  color: var(--#{$prefix}toast-color);\n  pointer-events: auto;\n  background-color: var(--#{$prefix}toast-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}toast-border-width) solid var(--#{$prefix}toast-border-color);\n  box-shadow: var(--#{$prefix}toast-box-shadow);\n  @include border-radius(var(--#{$prefix}toast-border-radius));\n\n  &.showing {\n    opacity: 0;\n  }\n\n  &:not(.show) {\n    display: none;\n  }\n}\n\n.toast-container {\n  --#{$prefix}toast-zindex: #{$zindex-toast};\n\n  position: absolute;\n  z-index: var(--#{$prefix}toast-zindex);\n  width: max-content;\n  max-width: 100%;\n  pointer-events: none;\n\n  > :not(:last-child) {\n    margin-bottom: var(--#{$prefix}toast-spacing);\n  }\n}\n\n.toast-header {\n  display: flex;\n  align-items: center;\n  padding: var(--#{$prefix}toast-padding-y) var(--#{$prefix}toast-padding-x);\n  color: var(--#{$prefix}toast-header-color);\n  background-color: var(--#{$prefix}toast-header-bg);\n  background-clip: padding-box;\n  border-bottom: var(--#{$prefix}toast-border-width) solid var(--#{$prefix}toast-header-border-color);\n  @include border-top-radius(calc(var(--#{$prefix}toast-border-radius) - var(--#{$prefix}toast-border-width)));\n\n  .btn-close {\n    margin-right: calc(-.5 * var(--#{$prefix}toast-padding-x)); // stylelint-disable-line function-disallowed-list\n    margin-left: var(--#{$prefix}toast-padding-x);\n  }\n}\n\n.toast-body {\n  padding: var(--#{$prefix}toast-padding-x);\n  word-wrap: break-word;\n}\n","// stylelint-disable function-disallowed-list\n\n// .modal-open      - body class for killing the scroll\n// .modal           - container to scroll within\n// .modal-dialog    - positioning shell for the actual modal\n// .modal-content   - actual modal w/ bg and corners and stuff\n\n\n// Container that the modal scrolls within\n.modal {\n  // scss-docs-start modal-css-vars\n  --#{$prefix}modal-zindex: #{$zindex-modal};\n  --#{$prefix}modal-width: #{$modal-md};\n  --#{$prefix}modal-padding: #{$modal-inner-padding};\n  --#{$prefix}modal-margin: #{$modal-dialog-margin};\n  --#{$prefix}modal-color: #{$modal-content-color};\n  --#{$prefix}modal-bg: #{$modal-content-bg};\n  --#{$prefix}modal-border-color: #{$modal-content-border-color};\n  --#{$prefix}modal-border-width: #{$modal-content-border-width};\n  --#{$prefix}modal-border-radius: #{$modal-content-border-radius};\n  --#{$prefix}modal-box-shadow: #{$modal-content-box-shadow-xs};\n  --#{$prefix}modal-inner-border-radius: #{$modal-content-inner-border-radius};\n  --#{$prefix}modal-header-padding-x: #{$modal-header-padding-x};\n  --#{$prefix}modal-header-padding-y: #{$modal-header-padding-y};\n  --#{$prefix}modal-header-padding: #{$modal-header-padding}; // Todo in v6: Split this padding into x and y\n  --#{$prefix}modal-header-border-color: #{$modal-header-border-color};\n  --#{$prefix}modal-header-border-width: #{$modal-header-border-width};\n  --#{$prefix}modal-title-line-height: #{$modal-title-line-height};\n  --#{$prefix}modal-footer-gap: #{$modal-footer-margin-between};\n  --#{$prefix}modal-footer-bg: #{$modal-footer-bg};\n  --#{$prefix}modal-footer-border-color: #{$modal-footer-border-color};\n  --#{$prefix}modal-footer-border-width: #{$modal-footer-border-width};\n  // scss-docs-end modal-css-vars\n\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: var(--#{$prefix}modal-zindex);\n  display: none;\n  width: 100%;\n  height: 100%;\n  overflow-x: hidden;\n  overflow-y: auto;\n  // Prevent Chrome on Windows from adding a focus outline. For details, see\n  // https://github.com/twbs/bootstrap/pull/10951.\n  outline: 0;\n  // We deliberately don't use `-webkit-overflow-scrolling: touch;` due to a\n  // gnarly iOS Safari bug: https://bugs.webkit.org/show_bug.cgi?id=158342\n  // See also https://github.com/twbs/bootstrap/issues/17695\n}\n\n// Shell div to position the modal with bottom padding\n.modal-dialog {\n  position: relative;\n  width: auto;\n  margin: var(--#{$prefix}modal-margin);\n  // allow clicks to pass through for custom click handling to close modal\n  pointer-events: none;\n\n  // When fading in the modal, animate it to slide down\n  .modal.fade & {\n    @include transition($modal-transition);\n    transform: $modal-fade-transform;\n  }\n  .modal.show & {\n    transform: $modal-show-transform;\n  }\n\n  // When trying to close, animate focus to scale\n  .modal.modal-static & {\n    transform: $modal-scale-transform;\n  }\n}\n\n.modal-dialog-scrollable {\n  height: calc(100% - var(--#{$prefix}modal-margin) * 2);\n\n  .modal-content {\n    max-height: 100%;\n    overflow: hidden;\n  }\n\n  .modal-body {\n    overflow-y: auto;\n  }\n}\n\n.modal-dialog-centered {\n  display: flex;\n  align-items: center;\n  min-height: calc(100% - var(--#{$prefix}modal-margin) * 2);\n}\n\n// Actual modal\n.modal-content {\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  width: 100%; // Ensure `.modal-content` extends the full width of the parent `.modal-dialog`\n  // counteract the pointer-events: none; in the .modal-dialog\n  color: var(--#{$prefix}modal-color);\n  pointer-events: auto;\n  background-color: var(--#{$prefix}modal-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}modal-border-width) solid var(--#{$prefix}modal-border-color);\n  @include border-radius(var(--#{$prefix}modal-border-radius));\n  @include box-shadow(var(--#{$prefix}modal-box-shadow));\n  // Remove focus outline from opened modal\n  outline: 0;\n}\n\n// Modal background\n.modal-backdrop {\n  // scss-docs-start modal-backdrop-css-vars\n  --#{$prefix}backdrop-zindex: #{$zindex-modal-backdrop};\n  --#{$prefix}backdrop-bg: #{$modal-backdrop-bg};\n  --#{$prefix}backdrop-opacity: #{$modal-backdrop-opacity};\n  // scss-docs-end modal-backdrop-css-vars\n\n  @include overlay-backdrop(var(--#{$prefix}backdrop-zindex), var(--#{$prefix}backdrop-bg), var(--#{$prefix}backdrop-opacity));\n}\n\n// Modal header\n// Top section of the modal w/ title and dismiss\n.modal-header {\n  display: flex;\n  flex-shrink: 0;\n  align-items: center;\n  justify-content: space-between; // Put modal header elements (title and dismiss) on opposite ends\n  padding: var(--#{$prefix}modal-header-padding);\n  border-bottom: var(--#{$prefix}modal-header-border-width) solid var(--#{$prefix}modal-header-border-color);\n  @include border-top-radius(var(--#{$prefix}modal-inner-border-radius));\n\n  .btn-close {\n    padding: calc(var(--#{$prefix}modal-header-padding-y) * .5) calc(var(--#{$prefix}modal-header-padding-x) * .5);\n    margin: calc(-.5 * var(--#{$prefix}modal-header-padding-y)) calc(-.5 * var(--#{$prefix}modal-header-padding-x)) calc(-.5 * var(--#{$prefix}modal-header-padding-y)) auto;\n  }\n}\n\n// Title text within header\n.modal-title {\n  margin-bottom: 0;\n  line-height: var(--#{$prefix}modal-title-line-height);\n}\n\n// Modal body\n// Where all modal content resides (sibling of .modal-header and .modal-footer)\n.modal-body {\n  position: relative;\n  // Enable `flex-grow: 1` so that the body take up as much space as possible\n  // when there should be a fixed height on `.modal-dialog`.\n  flex: 1 1 auto;\n  padding: var(--#{$prefix}modal-padding);\n}\n\n// Footer (for actions)\n.modal-footer {\n  display: flex;\n  flex-shrink: 0;\n  flex-wrap: wrap;\n  align-items: center; // vertically center\n  justify-content: flex-end; // Right align buttons with flex property because text-align doesn't work on flex items\n  padding: calc(var(--#{$prefix}modal-padding) - var(--#{$prefix}modal-footer-gap) * .5);\n  background-color: var(--#{$prefix}modal-footer-bg);\n  border-top: var(--#{$prefix}modal-footer-border-width) solid var(--#{$prefix}modal-footer-border-color);\n  @include border-bottom-radius(var(--#{$prefix}modal-inner-border-radius));\n\n  // Place margin between footer elements\n  // This solution is far from ideal because of the universal selector usage,\n  // but is needed to fix https://github.com/twbs/bootstrap/issues/24800\n  > * {\n    margin: calc(var(--#{$prefix}modal-footer-gap) * .5); // Todo in v6: replace with gap on parent class\n  }\n}\n\n// Scale up the modal\n@include media-breakpoint-up(sm) {\n  .modal {\n    --#{$prefix}modal-margin: #{$modal-dialog-margin-y-sm-up};\n    --#{$prefix}modal-box-shadow: #{$modal-content-box-shadow-sm-up};\n  }\n\n  // Automatically set modal's width for larger viewports\n  .modal-dialog {\n    max-width: var(--#{$prefix}modal-width);\n    margin-right: auto;\n    margin-left: auto;\n  }\n\n  .modal-sm {\n    --#{$prefix}modal-width: #{$modal-sm};\n  }\n}\n\n@include media-breakpoint-up(lg) {\n  .modal-lg,\n  .modal-xl {\n    --#{$prefix}modal-width: #{$modal-lg};\n  }\n}\n\n@include media-breakpoint-up(xl) {\n  .modal-xl {\n    --#{$prefix}modal-width: #{$modal-xl};\n  }\n}\n\n// scss-docs-start modal-fullscreen-loop\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n  $postfix: if($infix != \"\", $infix + \"-down\", \"\");\n\n  @include media-breakpoint-down($breakpoint) {\n    .modal-fullscreen#{$postfix} {\n      width: 100vw;\n      max-width: none;\n      height: 100%;\n      margin: 0;\n\n      .modal-content {\n        height: 100%;\n        border: 0;\n        @include border-radius(0);\n      }\n\n      .modal-header,\n      .modal-footer {\n        @include border-radius(0);\n      }\n\n      .modal-body {\n        overflow-y: auto;\n      }\n    }\n  }\n}\n// scss-docs-end modal-fullscreen-loop\n","// Shared between modals and offcanvases\n@mixin overlay-backdrop($zindex, $backdrop-bg, $backdrop-opacity) {\n  position: fixed;\n  top: 0;\n  left: 0;\n  z-index: $zindex;\n  width: 100vw;\n  height: 100vh;\n  background-color: $backdrop-bg;\n\n  // Fade for backdrop\n  &.fade { opacity: 0; }\n  &.show { opacity: $backdrop-opacity; }\n}\n","// Base class\n.tooltip {\n  // scss-docs-start tooltip-css-vars\n  --#{$prefix}tooltip-zindex: #{$zindex-tooltip};\n  --#{$prefix}tooltip-max-width: #{$tooltip-max-width};\n  --#{$prefix}tooltip-padding-x: #{$tooltip-padding-x};\n  --#{$prefix}tooltip-padding-y: #{$tooltip-padding-y};\n  --#{$prefix}tooltip-margin: #{$tooltip-margin};\n  @include rfs($tooltip-font-size, --#{$prefix}tooltip-font-size);\n  --#{$prefix}tooltip-color: #{$tooltip-color};\n  --#{$prefix}tooltip-bg: #{$tooltip-bg};\n  --#{$prefix}tooltip-border-radius: #{$tooltip-border-radius};\n  --#{$prefix}tooltip-opacity: #{$tooltip-opacity};\n  --#{$prefix}tooltip-arrow-width: #{$tooltip-arrow-width};\n  --#{$prefix}tooltip-arrow-height: #{$tooltip-arrow-height};\n  // scss-docs-end tooltip-css-vars\n\n  z-index: var(--#{$prefix}tooltip-zindex);\n  display: block;\n  padding: var(--#{$prefix}tooltip-arrow-height);\n  margin: var(--#{$prefix}tooltip-margin);\n  @include deprecate(\"`$tooltip-margin`\", \"v5\", \"v5.x\", true);\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size(var(--#{$prefix}tooltip-font-size));\n  // Allow breaking very long words so they don't overflow the tooltip's bounds\n  word-wrap: break-word;\n  opacity: 0;\n\n  &.show { opacity: var(--#{$prefix}tooltip-opacity); }\n\n  .tooltip-arrow {\n    display: block;\n    width: var(--#{$prefix}tooltip-arrow-width);\n    height: var(--#{$prefix}tooltip-arrow-height);\n\n    &::before {\n      position: absolute;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n    }\n  }\n}\n\n.bs-tooltip-top .tooltip-arrow {\n  bottom: 0;\n\n  &::before {\n    top: -1px;\n    border-width: var(--#{$prefix}tooltip-arrow-height) calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    border-top-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-end .tooltip-arrow {\n  left: 0;\n  width: var(--#{$prefix}tooltip-arrow-height);\n  height: var(--#{$prefix}tooltip-arrow-width);\n\n  &::before {\n    right: -1px;\n    border-width: calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height) calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    border-right-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-tooltip-bottom .tooltip-arrow {\n  top: 0;\n\n  &::before {\n    bottom: -1px;\n    border-width: 0 calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height); // stylelint-disable-line function-disallowed-list\n    border-bottom-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-tooltip-start .tooltip-arrow {\n  right: 0;\n  width: var(--#{$prefix}tooltip-arrow-height);\n  height: var(--#{$prefix}tooltip-arrow-width);\n\n  &::before {\n    left: -1px;\n    border-width: calc(var(--#{$prefix}tooltip-arrow-width) * .5) 0 calc(var(--#{$prefix}tooltip-arrow-width) * .5) var(--#{$prefix}tooltip-arrow-height); // stylelint-disable-line function-disallowed-list\n    border-left-color: var(--#{$prefix}tooltip-bg);\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-tooltip-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-tooltip-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-tooltip-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-tooltip-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-tooltip-start;\n  }\n}\n\n// Wrapper for the tooltip content\n.tooltip-inner {\n  max-width: var(--#{$prefix}tooltip-max-width);\n  padding: var(--#{$prefix}tooltip-padding-y) var(--#{$prefix}tooltip-padding-x);\n  color: var(--#{$prefix}tooltip-color);\n  text-align: center;\n  background-color: var(--#{$prefix}tooltip-bg);\n  @include border-radius(var(--#{$prefix}tooltip-border-radius));\n}\n","@mixin reset-text {\n  font-family: $font-family-base;\n  // We deliberately do NOT reset font-size or overflow-wrap / word-wrap.\n  font-style: normal;\n  font-weight: $font-weight-normal;\n  line-height: $line-height-base;\n  text-align: left; // Fallback for where `start` is not supported\n  text-align: start;\n  text-decoration: none;\n  text-shadow: none;\n  text-transform: none;\n  letter-spacing: normal;\n  word-break: normal;\n  white-space: normal;\n  word-spacing: normal;\n  line-break: auto;\n}\n",".popover {\n  // scss-docs-start popover-css-vars\n  --#{$prefix}popover-zindex: #{$zindex-popover};\n  --#{$prefix}popover-max-width: #{$popover-max-width};\n  @include rfs($popover-font-size, --#{$prefix}popover-font-size);\n  --#{$prefix}popover-bg: #{$popover-bg};\n  --#{$prefix}popover-border-width: #{$popover-border-width};\n  --#{$prefix}popover-border-color: #{$popover-border-color};\n  --#{$prefix}popover-border-radius: #{$popover-border-radius};\n  --#{$prefix}popover-inner-border-radius: #{$popover-inner-border-radius};\n  --#{$prefix}popover-box-shadow: #{$popover-box-shadow};\n  --#{$prefix}popover-header-padding-x: #{$popover-header-padding-x};\n  --#{$prefix}popover-header-padding-y: #{$popover-header-padding-y};\n  @include rfs($popover-header-font-size, --#{$prefix}popover-header-font-size);\n  --#{$prefix}popover-header-color: #{$popover-header-color};\n  --#{$prefix}popover-header-bg: #{$popover-header-bg};\n  --#{$prefix}popover-body-padding-x: #{$popover-body-padding-x};\n  --#{$prefix}popover-body-padding-y: #{$popover-body-padding-y};\n  --#{$prefix}popover-body-color: #{$popover-body-color};\n  --#{$prefix}popover-arrow-width: #{$popover-arrow-width};\n  --#{$prefix}popover-arrow-height: #{$popover-arrow-height};\n  --#{$prefix}popover-arrow-border: var(--#{$prefix}popover-border-color);\n  // scss-docs-end popover-css-vars\n\n  z-index: var(--#{$prefix}popover-zindex);\n  display: block;\n  max-width: var(--#{$prefix}popover-max-width);\n  // Our parent element can be arbitrary since tooltips are by default inserted as a sibling of their target element.\n  // So reset our font and text properties to avoid inheriting weird values.\n  @include reset-text();\n  @include font-size(var(--#{$prefix}popover-font-size));\n  // Allow breaking very long words so they don't overflow the popover's bounds\n  word-wrap: break-word;\n  background-color: var(--#{$prefix}popover-bg);\n  background-clip: padding-box;\n  border: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-border-color);\n  @include border-radius(var(--#{$prefix}popover-border-radius));\n  @include box-shadow(var(--#{$prefix}popover-box-shadow));\n\n  .popover-arrow {\n    display: block;\n    width: var(--#{$prefix}popover-arrow-width);\n    height: var(--#{$prefix}popover-arrow-height);\n\n    &::before,\n    &::after {\n      position: absolute;\n      display: block;\n      content: \"\";\n      border-color: transparent;\n      border-style: solid;\n      border-width: 0;\n    }\n  }\n}\n\n.bs-popover-top {\n  > .popover-arrow {\n    bottom: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n\n    &::before,\n    &::after {\n      border-width: var(--#{$prefix}popover-arrow-height) calc(var(--#{$prefix}popover-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      bottom: 0;\n      border-top-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      bottom: var(--#{$prefix}popover-border-width);\n      border-top-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-popover-end {\n  > .popover-arrow {\n    left: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n    width: var(--#{$prefix}popover-arrow-height);\n    height: var(--#{$prefix}popover-arrow-width);\n\n    &::before,\n    &::after {\n      border-width: calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height) calc(var(--#{$prefix}popover-arrow-width) * .5) 0; // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      left: 0;\n      border-right-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      left: var(--#{$prefix}popover-border-width);\n      border-right-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-popover-bottom {\n  > .popover-arrow {\n    top: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n\n    &::before,\n    &::after {\n      border-width: 0 calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height); // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      top: 0;\n      border-bottom-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      top: var(--#{$prefix}popover-border-width);\n      border-bottom-color: var(--#{$prefix}popover-bg);\n    }\n  }\n\n  // This will remove the popover-header's border just below the arrow\n  .popover-header::before {\n    position: absolute;\n    top: 0;\n    left: 50%;\n    display: block;\n    width: var(--#{$prefix}popover-arrow-width);\n    margin-left: calc(-.5 * var(--#{$prefix}popover-arrow-width)); // stylelint-disable-line function-disallowed-list\n    content: \"\";\n    border-bottom: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-header-bg);\n  }\n}\n\n/* rtl:begin:ignore */\n.bs-popover-start {\n  > .popover-arrow {\n    right: calc(-1 * (var(--#{$prefix}popover-arrow-height)) - var(--#{$prefix}popover-border-width)); // stylelint-disable-line function-disallowed-list\n    width: var(--#{$prefix}popover-arrow-height);\n    height: var(--#{$prefix}popover-arrow-width);\n\n    &::before,\n    &::after {\n      border-width: calc(var(--#{$prefix}popover-arrow-width) * .5) 0 calc(var(--#{$prefix}popover-arrow-width) * .5) var(--#{$prefix}popover-arrow-height); // stylelint-disable-line function-disallowed-list\n    }\n\n    &::before {\n      right: 0;\n      border-left-color: var(--#{$prefix}popover-arrow-border);\n    }\n\n    &::after {\n      right: var(--#{$prefix}popover-border-width);\n      border-left-color: var(--#{$prefix}popover-bg);\n    }\n  }\n}\n\n/* rtl:end:ignore */\n\n.bs-popover-auto {\n  &[data-popper-placement^=\"top\"] {\n    @extend .bs-popover-top;\n  }\n  &[data-popper-placement^=\"right\"] {\n    @extend .bs-popover-end;\n  }\n  &[data-popper-placement^=\"bottom\"] {\n    @extend .bs-popover-bottom;\n  }\n  &[data-popper-placement^=\"left\"] {\n    @extend .bs-popover-start;\n  }\n}\n\n// Offset the popover to account for the popover arrow\n.popover-header {\n  padding: var(--#{$prefix}popover-header-padding-y) var(--#{$prefix}popover-header-padding-x);\n  margin-bottom: 0; // Reset the default from Reboot\n  @include font-size(var(--#{$prefix}popover-header-font-size));\n  color: var(--#{$prefix}popover-header-color);\n  background-color: var(--#{$prefix}popover-header-bg);\n  border-bottom: var(--#{$prefix}popover-border-width) solid var(--#{$prefix}popover-border-color);\n  @include border-top-radius(var(--#{$prefix}popover-inner-border-radius));\n\n  &:empty {\n    display: none;\n  }\n}\n\n.popover-body {\n  padding: var(--#{$prefix}popover-body-padding-y) var(--#{$prefix}popover-body-padding-x);\n  color: var(--#{$prefix}popover-body-color);\n}\n","// Notes on the classes:\n//\n// 1. .carousel.pointer-event should ideally be pan-y (to allow for users to scroll vertically)\n//    even when their scroll action started on a carousel, but for compatibility (with Firefox)\n//    we're preventing all actions instead\n// 2. The .carousel-item-start and .carousel-item-end is used to indicate where\n//    the active slide is heading.\n// 3. .active.carousel-item is the current slide.\n// 4. .active.carousel-item-start and .active.carousel-item-end is the current\n//    slide in its in-transition state. Only one of these occurs at a time.\n// 5. .carousel-item-next.carousel-item-start and .carousel-item-prev.carousel-item-end\n//    is the upcoming slide in transition.\n\n.carousel {\n  position: relative;\n}\n\n.carousel.pointer-event {\n  touch-action: pan-y;\n}\n\n.carousel-inner {\n  position: relative;\n  width: 100%;\n  overflow: hidden;\n  @include clearfix();\n}\n\n.carousel-item {\n  position: relative;\n  display: none;\n  float: left;\n  width: 100%;\n  margin-right: -100%;\n  backface-visibility: hidden;\n  @include transition($carousel-transition);\n}\n\n.carousel-item.active,\n.carousel-item-next,\n.carousel-item-prev {\n  display: block;\n}\n\n.carousel-item-next:not(.carousel-item-start),\n.active.carousel-item-end {\n  transform: translateX(100%);\n}\n\n.carousel-item-prev:not(.carousel-item-end),\n.active.carousel-item-start {\n  transform: translateX(-100%);\n}\n\n\n//\n// Alternate transitions\n//\n\n.carousel-fade {\n  .carousel-item {\n    opacity: 0;\n    transition-property: opacity;\n    transform: none;\n  }\n\n  .carousel-item.active,\n  .carousel-item-next.carousel-item-start,\n  .carousel-item-prev.carousel-item-end {\n    z-index: 1;\n    opacity: 1;\n  }\n\n  .active.carousel-item-start,\n  .active.carousel-item-end {\n    z-index: 0;\n    opacity: 0;\n    @include transition(opacity 0s $carousel-transition-duration);\n  }\n}\n\n\n//\n// Left/right controls for nav\n//\n\n.carousel-control-prev,\n.carousel-control-next {\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  z-index: 1;\n  // Use flex for alignment (1-3)\n  display: flex; // 1. allow flex styles\n  align-items: center; // 2. vertically center contents\n  justify-content: center; // 3. horizontally center contents\n  width: $carousel-control-width;\n  padding: 0;\n  color: $carousel-control-color;\n  text-align: center;\n  background: none;\n  border: 0;\n  opacity: $carousel-control-opacity;\n  @include transition($carousel-control-transition);\n\n  // Hover/focus state\n  &:hover,\n  &:focus {\n    color: $carousel-control-color;\n    text-decoration: none;\n    outline: 0;\n    opacity: $carousel-control-hover-opacity;\n  }\n}\n.carousel-control-prev {\n  left: 0;\n  background-image: if($enable-gradients, linear-gradient(90deg, rgba($black, .25), rgba($black, .001)), null);\n}\n.carousel-control-next {\n  right: 0;\n  background-image: if($enable-gradients, linear-gradient(270deg, rgba($black, .25), rgba($black, .001)), null);\n}\n\n// Icons for within\n.carousel-control-prev-icon,\n.carousel-control-next-icon {\n  display: inline-block;\n  width: $carousel-control-icon-width;\n  height: $carousel-control-icon-width;\n  background-repeat: no-repeat;\n  background-position: 50%;\n  background-size: 100% 100%;\n}\n\n/* rtl:options: {\n  \"autoRename\": true,\n  \"stringMap\":[ {\n    \"name\"    : \"prev-next\",\n    \"search\"  : \"prev\",\n    \"replace\" : \"next\"\n  } ]\n} */\n.carousel-control-prev-icon {\n  background-image: escape-svg($carousel-control-prev-icon-bg);\n}\n.carousel-control-next-icon {\n  background-image: escape-svg($carousel-control-next-icon-bg);\n}\n\n// Optional indicator pips/controls\n//\n// Add a container (such as a list) with the following class and add an item (ideally a focusable control,\n// like a button) with data-bs-target for each slide your carousel holds.\n\n.carousel-indicators {\n  position: absolute;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 2;\n  display: flex;\n  justify-content: center;\n  padding: 0;\n  // Use the .carousel-control's width as margin so we don't overlay those\n  margin-right: $carousel-control-width;\n  margin-bottom: 1rem;\n  margin-left: $carousel-control-width;\n  list-style: none;\n\n  [data-bs-target] {\n    box-sizing: content-box;\n    flex: 0 1 auto;\n    width: $carousel-indicator-width;\n    height: $carousel-indicator-height;\n    padding: 0;\n    margin-right: $carousel-indicator-spacer;\n    margin-left: $carousel-indicator-spacer;\n    text-indent: -999px;\n    cursor: pointer;\n    background-color: $carousel-indicator-active-bg;\n    background-clip: padding-box;\n    border: 0;\n    // Use transparent borders to increase the hit area by 10px on top and bottom.\n    border-top: $carousel-indicator-hit-area-height solid transparent;\n    border-bottom: $carousel-indicator-hit-area-height solid transparent;\n    opacity: $carousel-indicator-opacity;\n    @include transition($carousel-indicator-transition);\n  }\n\n  .active {\n    opacity: $carousel-indicator-active-opacity;\n  }\n}\n\n\n// Optional captions\n//\n//\n\n.carousel-caption {\n  position: absolute;\n  right: (100% - $carousel-caption-width) * .5;\n  bottom: $carousel-caption-spacer;\n  left: (100% - $carousel-caption-width) * .5;\n  padding-top: $carousel-caption-padding-y;\n  padding-bottom: $carousel-caption-padding-y;\n  color: $carousel-caption-color;\n  text-align: center;\n}\n\n// Dark mode carousel\n\n.carousel-dark {\n  .carousel-control-prev-icon,\n  .carousel-control-next-icon {\n    filter: $carousel-dark-control-icon-filter;\n  }\n\n  .carousel-indicators [data-bs-target] {\n    background-color: $carousel-dark-indicator-active-bg;\n  }\n\n  .carousel-caption {\n    color: $carousel-dark-caption-color;\n  }\n}\n","// scss-docs-start clearfix\n@mixin clearfix() {\n  &::after {\n    display: block;\n    clear: both;\n    content: \"\";\n  }\n}\n// scss-docs-end clearfix\n","//\n// Rotating border\n//\n\n.spinner-grow,\n.spinner-border {\n  display: inline-block;\n  width: var(--#{$prefix}spinner-width);\n  height: var(--#{$prefix}spinner-height);\n  vertical-align: var(--#{$prefix}spinner-vertical-align);\n  // stylelint-disable-next-line property-disallowed-list\n  border-radius: 50%;\n  animation: var(--#{$prefix}spinner-animation-speed) linear infinite var(--#{$prefix}spinner-animation-name);\n}\n\n// scss-docs-start spinner-border-keyframes\n@keyframes spinner-border {\n  to { transform: rotate(360deg) #{\"/* rtl:ignore */\"}; }\n}\n// scss-docs-end spinner-border-keyframes\n\n.spinner-border {\n  // scss-docs-start spinner-border-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width};\n  --#{$prefix}spinner-height: #{$spinner-height};\n  --#{$prefix}spinner-vertical-align: #{$spinner-vertical-align};\n  --#{$prefix}spinner-border-width: #{$spinner-border-width};\n  --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed};\n  --#{$prefix}spinner-animation-name: spinner-border;\n  // scss-docs-end spinner-border-css-vars\n\n  border: var(--#{$prefix}spinner-border-width) solid currentcolor;\n  border-right-color: transparent;\n}\n\n.spinner-border-sm {\n  // scss-docs-start spinner-border-sm-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width-sm};\n  --#{$prefix}spinner-height: #{$spinner-height-sm};\n  --#{$prefix}spinner-border-width: #{$spinner-border-width-sm};\n  // scss-docs-end spinner-border-sm-css-vars\n}\n\n//\n// Growing circle\n//\n\n// scss-docs-start spinner-grow-keyframes\n@keyframes spinner-grow {\n  0% {\n    transform: scale(0);\n  }\n  50% {\n    opacity: 1;\n    transform: none;\n  }\n}\n// scss-docs-end spinner-grow-keyframes\n\n.spinner-grow {\n  // scss-docs-start spinner-grow-css-vars\n  --#{$prefix}spinner-width: #{$spinner-width};\n  --#{$prefix}spinner-height: #{$spinner-height};\n  --#{$prefix}spinner-vertical-align: #{$spinner-vertical-align};\n  --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed};\n  --#{$prefix}spinner-animation-name: spinner-grow;\n  // scss-docs-end spinner-grow-css-vars\n\n  background-color: currentcolor;\n  opacity: 0;\n}\n\n.spinner-grow-sm {\n  --#{$prefix}spinner-width: #{$spinner-width-sm};\n  --#{$prefix}spinner-height: #{$spinner-height-sm};\n}\n\n@if $enable-reduced-motion {\n  @media (prefers-reduced-motion: reduce) {\n    .spinner-border,\n    .spinner-grow {\n      --#{$prefix}spinner-animation-speed: #{$spinner-animation-speed * 2};\n    }\n  }\n}\n","// stylelint-disable function-disallowed-list\n\n%offcanvas-css-vars {\n  // scss-docs-start offcanvas-css-vars\n  --#{$prefix}offcanvas-zindex: #{$zindex-offcanvas};\n  --#{$prefix}offcanvas-width: #{$offcanvas-horizontal-width};\n  --#{$prefix}offcanvas-height: #{$offcanvas-vertical-height};\n  --#{$prefix}offcanvas-padding-x: #{$offcanvas-padding-x};\n  --#{$prefix}offcanvas-padding-y: #{$offcanvas-padding-y};\n  --#{$prefix}offcanvas-color: #{$offcanvas-color};\n  --#{$prefix}offcanvas-bg: #{$offcanvas-bg-color};\n  --#{$prefix}offcanvas-border-width: #{$offcanvas-border-width};\n  --#{$prefix}offcanvas-border-color: #{$offcanvas-border-color};\n  --#{$prefix}offcanvas-box-shadow: #{$offcanvas-box-shadow};\n  // scss-docs-end offcanvas-css-vars\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $next: breakpoint-next($breakpoint, $grid-breakpoints);\n  $infix: breakpoint-infix($next, $grid-breakpoints);\n\n  .offcanvas#{$infix} {\n    @extend %offcanvas-css-vars;\n  }\n}\n\n@each $breakpoint in map-keys($grid-breakpoints) {\n  $next: breakpoint-next($breakpoint, $grid-breakpoints);\n  $infix: breakpoint-infix($next, $grid-breakpoints);\n\n  .offcanvas#{$infix} {\n    @include media-breakpoint-down($next) {\n      position: fixed;\n      bottom: 0;\n      z-index: var(--#{$prefix}offcanvas-zindex);\n      display: flex;\n      flex-direction: column;\n      max-width: 100%;\n      color: var(--#{$prefix}offcanvas-color);\n      visibility: hidden;\n      background-color: var(--#{$prefix}offcanvas-bg);\n      background-clip: padding-box;\n      outline: 0;\n      @include box-shadow(var(--#{$prefix}offcanvas-box-shadow));\n      @include transition(transform $offcanvas-transition-duration ease-in-out);\n\n      &.offcanvas-start {\n        top: 0;\n        left: 0;\n        width: var(--#{$prefix}offcanvas-width);\n        border-right: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateX(-100%);\n      }\n\n      &.offcanvas-end {\n        top: 0;\n        right: 0;\n        width: var(--#{$prefix}offcanvas-width);\n        border-left: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateX(100%);\n      }\n\n      &.offcanvas-top {\n        top: 0;\n        right: 0;\n        left: 0;\n        height: var(--#{$prefix}offcanvas-height);\n        max-height: 100%;\n        border-bottom: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateY(-100%);\n      }\n\n      &.offcanvas-bottom {\n        right: 0;\n        left: 0;\n        height: var(--#{$prefix}offcanvas-height);\n        max-height: 100%;\n        border-top: var(--#{$prefix}offcanvas-border-width) solid var(--#{$prefix}offcanvas-border-color);\n        transform: translateY(100%);\n      }\n\n      &.showing,\n      &.show:not(.hiding) {\n        transform: none;\n      }\n\n      &.showing,\n      &.hiding,\n      &.show {\n        visibility: visible;\n      }\n    }\n\n    @if not ($infix == \"\") {\n      @include media-breakpoint-up($next) {\n        --#{$prefix}offcanvas-height: auto;\n        --#{$prefix}offcanvas-border-width: 0;\n        background-color: transparent !important; // stylelint-disable-line declaration-no-important\n\n        .offcanvas-header {\n          display: none;\n        }\n\n        .offcanvas-body {\n          display: flex;\n          flex-grow: 0;\n          padding: 0;\n          overflow-y: visible;\n          // Reset `background-color` in case `.bg-*` classes are used in offcanvas\n          background-color: transparent !important; // stylelint-disable-line declaration-no-important\n        }\n      }\n    }\n  }\n}\n\n.offcanvas-backdrop {\n  @include overlay-backdrop($zindex-offcanvas-backdrop, $offcanvas-backdrop-bg, $offcanvas-backdrop-opacity);\n}\n\n.offcanvas-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: var(--#{$prefix}offcanvas-padding-y) var(--#{$prefix}offcanvas-padding-x);\n\n  .btn-close {\n    padding: calc(var(--#{$prefix}offcanvas-padding-y) * .5) calc(var(--#{$prefix}offcanvas-padding-x) * .5);\n    margin-top: calc(-.5 * var(--#{$prefix}offcanvas-padding-y));\n    margin-right: calc(-.5 * var(--#{$prefix}offcanvas-padding-x));\n    margin-bottom: calc(-.5 * var(--#{$prefix}offcanvas-padding-y));\n  }\n}\n\n.offcanvas-title {\n  margin-bottom: 0;\n  line-height: $offcanvas-title-line-height;\n}\n\n.offcanvas-body {\n  flex-grow: 1;\n  padding: var(--#{$prefix}offcanvas-padding-y) var(--#{$prefix}offcanvas-padding-x);\n  overflow-y: auto;\n}\n",".placeholder {\n  display: inline-block;\n  min-height: 1em;\n  vertical-align: middle;\n  cursor: wait;\n  background-color: currentcolor;\n  opacity: $placeholder-opacity-max;\n\n  &.btn::before {\n    display: inline-block;\n    content: \"\";\n  }\n}\n\n// Sizing\n.placeholder-xs {\n  min-height: .6em;\n}\n\n.placeholder-sm {\n  min-height: .8em;\n}\n\n.placeholder-lg {\n  min-height: 1.2em;\n}\n\n// Animation\n.placeholder-glow {\n  .placeholder {\n    animation: placeholder-glow 2s ease-in-out infinite;\n  }\n}\n\n@keyframes placeholder-glow {\n  50% {\n    opacity: $placeholder-opacity-min;\n  }\n}\n\n.placeholder-wave {\n  mask-image: linear-gradient(130deg, $black 55%, rgba(0, 0, 0, (1 - $placeholder-opacity-min)) 75%, $black 95%);\n  mask-size: 200% 100%;\n  animation: placeholder-wave 2s linear infinite;\n}\n\n@keyframes placeholder-wave {\n  100% {\n    mask-position: -200% 0%;\n  }\n}\n","// stylelint-disable function-name-case\n\n// All-caps `RGBA()` function used because of this Sass bug: https://github.com/sass/node-sass/issues/2251\n@each $color, $value in $theme-colors {\n  $color-rgb: to-rgb($value);\n  .text-bg-#{$color} {\n    color: color-contrast($value) if($enable-important-utilities, !important, null);\n    background-color: RGBA($color-rgb, var(--#{$prefix}bg-opacity, 1)) if($enable-important-utilities, !important, null);\n  }\n}\n","@each $color, $value in $theme-colors {\n  .link-#{$color} {\n    color: $value !important; // stylelint-disable-line declaration-no-important\n\n    @if $link-shade-percentage != 0 {\n      &:hover,\n      &:focus {\n        color: if(color-contrast($value) == $color-contrast-light, shade-color($value, $link-shade-percentage), tint-color($value, $link-shade-percentage)) !important; // stylelint-disable-line declaration-no-important\n      }\n    }\n  }\n}\n","// Credit: Nicolas Gallagher and SUIT CSS.\n\n.ratio {\n  position: relative;\n  width: 100%;\n\n  &::before {\n    display: block;\n    padding-top: var(--#{$prefix}aspect-ratio);\n    content: \"\";\n  }\n\n  > * {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n  }\n}\n\n@each $key, $ratio in $aspect-ratios {\n  .ratio-#{$key} {\n    --#{$prefix}aspect-ratio: #{$ratio};\n  }\n}\n","// Shorthand\n\n.fixed-top {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n.fixed-bottom {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: $zindex-fixed;\n}\n\n// Responsive sticky top and bottom\n@each $breakpoint in map-keys($grid-breakpoints) {\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    .sticky#{$infix}-top {\n      position: sticky;\n      top: 0;\n      z-index: $zindex-sticky;\n    }\n\n    .sticky#{$infix}-bottom {\n      position: sticky;\n      bottom: 0;\n      z-index: $zindex-sticky;\n    }\n  }\n}\n","// scss-docs-start stacks\n.hstack {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  align-self: stretch;\n}\n\n.vstack {\n  display: flex;\n  flex: 1 1 auto;\n  flex-direction: column;\n  align-self: stretch;\n}\n// scss-docs-end stacks\n","//\n// Visually hidden\n//\n\n.visually-hidden,\n.visually-hidden-focusable:not(:focus):not(:focus-within) {\n  @include visually-hidden();\n}\n","// stylelint-disable declaration-no-important\n\n// Hide content visually while keeping it accessible to assistive technologies\n//\n// See: https://www.a11yproject.com/posts/2013-01-11-how-to-hide-content/\n// See: https://kittygiraudel.com/2016/10/13/css-hide-and-seek/\n\n@mixin visually-hidden() {\n  position: absolute !important;\n  width: 1px !important;\n  height: 1px !important;\n  padding: 0 !important;\n  margin: -1px !important; // Fix for https://github.com/twbs/bootstrap/issues/25686\n  overflow: hidden !important;\n  clip: rect(0, 0, 0, 0) !important;\n  white-space: nowrap !important;\n  border: 0 !important;\n}\n\n// Use to only display content when it's focused, or one of its child elements is focused\n// (i.e. when focus is within the element/container that the class was applied to)\n//\n// Useful for \"Skip to main content\" links; see https://www.w3.org/TR/2013/NOTE-WCAG20-TECHS-20130905/G1\n\n@mixin visually-hidden-focusable() {\n  &:not(:focus):not(:focus-within) {\n    @include visually-hidden();\n  }\n}\n","//\n// Stretched link\n//\n\n.stretched-link {\n  &::#{$stretched-link-pseudo-element} {\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: $stretched-link-z-index;\n    content: \"\";\n  }\n}\n","//\n// Text truncation\n//\n\n.text-truncate {\n  @include text-truncate();\n}\n","// Text truncate\n// Requires inline-block or block for proper styling\n\n@mixin text-truncate() {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n",".vr {\n  display: inline-block;\n  align-self: stretch;\n  width: 1px;\n  min-height: 1em;\n  background-color: currentcolor;\n  opacity: $hr-opacity;\n}\n","// Utility generator\n// Used to generate utilities & print utilities\n@mixin generate-utility($utility, $infix, $is-rfs-media-query: false) {\n  $values: map-get($utility, values);\n\n  // If the values are a list or string, convert it into a map\n  @if type-of($values) == \"string\" or type-of(nth($values, 1)) != \"list\" {\n    $values: zip($values, $values);\n  }\n\n  @each $key, $value in $values {\n    $properties: map-get($utility, property);\n\n    // Multiple properties are possible, for example with vertical or horizontal margins or paddings\n    @if type-of($properties) == \"string\" {\n      $properties: append((), $properties);\n    }\n\n    // Use custom class if present\n    $property-class: if(map-has-key($utility, class), map-get($utility, class), nth($properties, 1));\n    $property-class: if($property-class == null, \"\", $property-class);\n\n    // Use custom CSS variable name if present, otherwise default to `class`\n    $css-variable-name: if(map-has-key($utility, css-variable-name), map-get($utility, css-variable-name), map-get($utility, class));\n\n    // State params to generate pseudo-classes\n    $state: if(map-has-key($utility, state), map-get($utility, state), ());\n\n    $infix: if($property-class == \"\" and str-slice($infix, 1, 1) == \"-\", str-slice($infix, 2), $infix);\n\n    // Don't prefix if value key is null (e.g. with shadow class)\n    $property-class-modifier: if($key, if($property-class == \"\" and $infix == \"\", \"\", \"-\") + $key, \"\");\n\n    @if map-get($utility, rfs) {\n      // Inside the media query\n      @if $is-rfs-media-query {\n        $val: rfs-value($value);\n\n        // Do not render anything if fluid and non fluid values are the same\n        $value: if($val == rfs-fluid-value($value), null, $val);\n      }\n      @else {\n        $value: rfs-fluid-value($value);\n      }\n    }\n\n    $is-css-var: map-get($utility, css-var);\n    $is-local-vars: map-get($utility, local-vars);\n    $is-rtl: map-get($utility, rtl);\n\n    @if $value != null {\n      @if $is-rtl == false {\n        /* rtl:begin:remove */\n      }\n\n      @if $is-css-var {\n        .#{$property-class + $infix + $property-class-modifier} {\n          --#{$prefix}#{$css-variable-name}: #{$value};\n        }\n\n        @each $pseudo in $state {\n          .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n            --#{$prefix}#{$css-variable-name}: #{$value};\n          }\n        }\n      } @else {\n        .#{$property-class + $infix + $property-class-modifier} {\n          @each $property in $properties {\n            @if $is-local-vars {\n              @each $local-var, $variable in $is-local-vars {\n                --#{$prefix}#{$local-var}: #{$variable};\n              }\n            }\n            #{$property}: $value if($enable-important-utilities, !important, null);\n          }\n        }\n\n        @each $pseudo in $state {\n          .#{$property-class + $infix + $property-class-modifier}-#{$pseudo}:#{$pseudo} {\n            @each $property in $properties {\n              @if $is-local-vars {\n                @each $local-var, $variable in $is-local-vars {\n                  --#{$prefix}#{$local-var}: #{$variable};\n                }\n              }\n              #{$property}: $value if($enable-important-utilities, !important, null);\n            }\n          }\n        }\n      }\n\n      @if $is-rtl == false {\n        /* rtl:end:remove */\n      }\n    }\n  }\n}\n","// Loop over each breakpoint\n@each $breakpoint in map-keys($grid-breakpoints) {\n\n  // Generate media query if needed\n  @include media-breakpoint-up($breakpoint) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    // Loop over each utility property\n    @each $key, $utility in $utilities {\n      // The utility can be disabled with `false`, thus check if the utility is a map first\n      // Only proceed if responsive media queries are enabled or if it's the base media query\n      @if type-of($utility) == \"map\" and (map-get($utility, responsive) or $infix == \"\") {\n        @include generate-utility($utility, $infix);\n      }\n    }\n  }\n}\n\n// RFS rescaling\n@media (min-width: $rfs-mq-value) {\n  @each $breakpoint in map-keys($grid-breakpoints) {\n    $infix: breakpoint-infix($breakpoint, $grid-breakpoints);\n\n    @if (map-get($grid-breakpoints, $breakpoint) < $rfs-breakpoint) {\n      // Loop over each utility property\n      @each $key, $utility in $utilities {\n        // The utility can be disabled with `false`, thus check if the utility is a map first\n        // Only proceed if responsive media queries are enabled or if it's the base media query\n        @if type-of($utility) == \"map\" and map-get($utility, rfs) and (map-get($utility, responsive) or $infix == \"\") {\n          @include generate-utility($utility, $infix, true);\n        }\n      }\n    }\n  }\n}\n\n\n// Print utilities\n@media print {\n  @each $key, $utility in $utilities {\n    // The utility can be disabled with `false`, thus check if the utility is a map first\n    // Then check if the utility needs print styles\n    @if type-of($utility) == \"map\" and map-get($utility, print) == true {\n      @include generate-utility($utility, \"-print\");\n    }\n  }\n}\n","/*\r\nTemplate Name: Velzon - Admin & Dashboard Template\r\nAuthor: Themesbrand\r\nVersion: 1.0.0\r\nWebsite: https://themesbrand.com/\r\nContact: support@themesbrand.com\r\nFile: Main Css File\r\n*/\r\n\r\n\r\n//Fonts\r\n@import \"../../fonts/fonts\";\r\n\r\n//Core files\r\n@import \"./node_modules/bootstrap/scss/functions\";\r\n@import \"./node_modules/bootstrap/scss/variables\";\r\n@import \"variables\";\r\n@import \"./node_modules/bootstrap/scss/mixins\";\r\n\r\n@import \"theme-light\";\r\n@import \"theme-dark\";\r\n\r\n// Structure\r\n@import \"../../structure/topbar\";\r\n@import \"../../structure/page-head\";\r\n@import \"../../structure/footer\";\r\n@import \"../../structure/vertical\";\r\n@import \"../../structure/horizontal\";\r\n@import \"../../structure/two-column\";\r\n@import \"../../structure/layouts\";\r\n\r\n// Components\r\n@import \"../../components/waves\";\r\n@import \"../../components/avatar\";\r\n@import \"../../components/accordion\";\r\n@import \"../../components/helper\";\r\n@import \"../../components/preloader\";\r\n@import \"../../components/forms\";\r\n@import \"../../components/widgets\";\r\n@import \"../../components/demos\";\r\n@import \"../../components/print\";\r\n@import \"../../components/ribbons\";\r\n@import \"../../components/toast\";\r\n@import \"../../components/scrollspy\";\r\n\r\n// Bootstrap components\r\n@import \"../../components/reboot\";\r\n@import \"../../components/alerts\";\r\n@import \"../../components/backgrounds\";\r\n@import \"../../components/badge\";\r\n@import \"../../components/buttons\";\r\n@import \"../../components/breadcrumb\";\r\n@import \"../../components/card\";\r\n@import \"../../components/dropdown\";\r\n@import \"../../components/nav\";\r\n@import \"../../components/table\";\r\n@import \"../../components/modal\";\r\n@import \"../../components/pagination\";\r\n@import \"../../components/progress\";\r\n@import \"../../components/popover\";\r\n@import \"../../components/type\";\r\n@import \"../../components/form-check\";\r\n@import \"../../components/form-control\";\r\n@import \"../../components/list-group\";\r\n\r\n// Plugins\r\n@import \"../../plugins/custom-scrollbar\";\r\n@import \"../../plugins/prismjs\";\r\n@import \"../../plugins/sweetalert2\";\r\n@import \"../../plugins/dropzone\";\r\n@import \"../../plugins/range-slider\";\r\n@import \"../../plugins/sortablejs\";\r\n@import \"../../plugins/tour\";\r\n@import \"../../plugins/swiper\";\r\n@import \"../../plugins/multijs\";\r\n@import \"../../plugins/colorpicker\";\r\n@import \"../../plugins/filepond\";\r\n@import \"../../plugins/form-input-spin\";\r\n@import \"../../plugins/ckeditor\";\r\n@import \"../../plugins/quilljs\";\r\n@import \"../../plugins/gridjs\";\r\n@import \"../../plugins/listjs\";\r\n@import \"../../plugins/apexcharts\";\r\n@import \"../../plugins/chartjs\";\r\n@import \"../../plugins/echarts\";\r\n@import \"../../plugins/google-map\";\r\n@import \"../../plugins/autocomplete\";\r\n@import \"../../plugins/vector-maps\";\r\n@import \"../../plugins/leaflet-maps\";\r\n@import \"../../plugins/fullcalendar\";\r\n@import \"../../plugins/emoji-picker\";\r\n\r\n// Plugins\r\n@import \"../../plugins/toastify\";\r\n@import \"../../plugins/choices\";\r\n@import \"../../plugins/flatpicker\";\r\n\r\n// Pages\r\n@import \"../../pages/authentication\";\r\n@import \"../../pages/dashboard\";\r\n@import \"../../pages/timeline\";\r\n@import \"../../pages/gallery\";\r\n@import \"../../pages/errors\";\r\n@import \"../../pages/profile\";\r\n@import \"../../pages/sitemap\";\r\n@import \"../../pages/team\";\r\n@import \"../../pages/coming-soon\";\r\n@import \"../../pages/search-results\";\r\n@import \"../../pages/ecommerce\";\r\n@import \"../../pages/invoice\";\r\n@import \"../../pages/chat\";\r\n@import \"../../pages/email\";\r\n@import \"../../pages/kanban\";\r\n@import \"../../pages/landing\";","//\r\n// Google font - Poppins\r\n//\r\n\r\n@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600;700&display=swap');\r\n\r\n//\r\n// Premium Font : HKGrotesk\r\n//\r\n\r\n@font-face {\r\n    font-family: \"hkgrotesk\";\r\n    src: url(\"../../fonts/hkgrotesk-light.eot\");\r\n    src: local('hkgrotesk light'), url(\"../../fonts/hkgrotesk-light.woff\") format(\"woff\");\r\n    font-weight: 300;\r\n}\r\n\r\n@font-face {\r\n    font-family: \"hkgrotesk\";\r\n    src: url(\"../../fonts/hkgrotesk-regular.eot\");\r\n    src: local('hkgrotesk regular'), url(\"../../fonts/hkgrotesk-regular.woff\") format(\"woff\");\r\n    font-weight: 400;\r\n}\r\n@font-face {\r\n    font-family: \"hkgrotesk\";\r\n    src: url(\"../../fonts/hkgrotesk-medium.eot\");\r\n    src: local('hkgrotesk medium'), url(\"../../fonts/hkgrotesk-medium.woff\") format(\"woff\");\r\n    font-weight: 500;\r\n}\r\n@font-face {\r\n    font-family: \"hkgrotesk\";\r\n    src: url(\"../../fonts/hkgrotesk-semibold.eot\");\r\n    src: local('hkgrotesk semibold'), url(\"../../fonts/hkgrotesk-semibold.woff\") format(\"woff\");\r\n    font-weight: 600;\r\n}\r\n// @font-face {\r\n//     font-family: \"hkgrotesk\";\r\n//     src: url(\"../../fonts/hkgrotesk-bold.eot\");\r\n//     src: local('hkgrotesk bold'), url(\"../../fonts/hkgrotesk-bold.woff\") format(\"woff\");\r\n//     font-weight: 700;\r\n// }","  // :root CSS variables\r\n\r\n:root{\r\n\r\n  // body\r\n  --#{$variable-prefix}body-bg : #{$body-bg};\r\n  --#{$variable-prefix}body-color: #{$body-color};\r\n  --#{$variable-prefix}body-color-rgb: #{to-rgb($body-color)};\r\n\r\n    //vertical light\r\n  --#{$variable-prefix}vertical-menu-bg:                      #{$white};\r\n  --#{$variable-prefix}vertical-menu-item-color:              #{darken($gray-600, 10%)};\r\n  --#{$variable-prefix}vertical-menu-item-hover-color:        #{$primary};\r\n  --#{$variable-prefix}vertical-menu-item-active-color:       #{$primary};\r\n  --#{$variable-prefix}vertical-menu-sub-item-color:          #{darken($gray-600, 4%)};\r\n  --#{$variable-prefix}vertical-menu-sub-item-hover-color:    #{$primary};\r\n  --#{$variable-prefix}vertical-menu-sub-item-active-color:   #{$primary};\r\n  --#{$variable-prefix}vertical-menu-title-color:             #919da9;\r\n  \r\n  //vertical dark\r\n  --#{$variable-prefix}vertical-menu-bg-dark:                 #2e3230;\r\n  --#{$variable-prefix}vertical-menu-item-color-dark:         #a4b0bf;\r\n  --#{$variable-prefix}vertical-menu-item-hover-color-dark:   #{$white};\r\n  --#{$variable-prefix}vertical-menu-item-active-color-dark:  #{$white};\r\n  --#{$variable-prefix}vertical-menu-sub-item-color-dark:     #a4b0bf;\r\n  --#{$variable-prefix}vertical-menu-sub-item-hover-color-dark: #{$white};\r\n  --#{$variable-prefix}vertical-menu-sub-item-active-color-dark: #{$white};\r\n  --#{$variable-prefix}vertical-menu-title-color-dark:         #a4b0bf;\r\n\r\n  // Topbar - (Default Light)\r\n  --#{$variable-prefix}header-bg:  #{$white};\r\n  --#{$variable-prefix}header-item-color:  #e9ecef;\r\n  // Topbar - Dark\r\n  --#{$variable-prefix}header-bg-dark:  #323835;\r\n  --#{$variable-prefix}header-item-color-dark:  #a4b0bf;\r\n\r\n  // Topbar Search\r\n  --#{$variable-prefix}topbar-search-bg: #f3f3f9;\r\n  // Topbar User\r\n  --#{$variable-prefix}topbar-user-bg: #f3f3f9;\r\n  --#{$variable-prefix}topbar-user-bg-dark: #39423e;\r\n\r\n  //footer\r\n  --#{$variable-prefix}footer-bg: #{$white};\r\n  --#{$variable-prefix}footer-color: #98a6ad;\r\n\r\n  // Horizontal nav\r\n  --#{$variable-prefix}topnav-bg: #{$white};\r\n  --#{$variable-prefix}topnav-item-color: #{darken($gray-600, 10%)};\r\n  --#{$variable-prefix}topnav-item-color-active: #{$primary};\r\n\r\n  // twocolumn menu\r\n  --#{$variable-prefix}twocolumn-menu-iconview-bg: #{$white};\r\n  --#{$variable-prefix}twocolumn-menu-bg:  #{$white};\r\n  // two column dark\r\n  --#{$variable-prefix}twocolumn-menu-iconview-bg-dark: var(--#{$variable-prefix}vertical-menu-bg-dark);\r\n  --#{$variable-prefix}twocolumn-menu-bg-dark:  #363a38;\r\n  --#{$variable-prefix}twocolumn-menu-item-color-dark: var(--#{$variable-prefix}vertical-menu-item-color-dark);\r\n  --#{$variable-prefix}twocolumn-menu-item-active-color-dark:  #{$white};\r\n  --#{$variable-prefix}twocolumn-menu-item-active-bg-dark:  #{rgba($white, .15)};\r\n\r\n  // boxed \r\n  --#{$variable-prefix}boxed-body-bg: #{darken($body-bg, 4%)};\r\n\r\n  // heading-color\r\n  --#{$variable-prefix}heading-color: #{$gray-700};\r\n  \r\n  // component variable\r\n\r\n  // theme-color\r\n  --#{$variable-prefix}light: #{$gray-100};\r\n  --#{$variable-prefix}light-rgb: #{to-rgb($gray-100)};\r\n  --#{$variable-prefix}dark: #{$gray-900};\r\n  --#{$variable-prefix}dark-rgb: #{to-rgb($gray-900)};\r\n\r\n  // link\r\n  --#{$variable-prefix}link-color: #{$primary};\r\n  --#{$variable-prefix}link-hover-color: #{$primary};\r\n\r\n  // Border variable\r\n  --#{$variable-prefix}border-color:  #{$gray-300};\r\n\r\n  // dropdown\r\n  --#{$variable-prefix}dropdown-bg: #{$white};\r\n  --#{$variable-prefix}dropdown-link-color: #{$gray-900};\r\n  --#{$variable-prefix}dropdown-link-hover-color: #{shade-color($gray-900, 10%)};\r\n  --#{$variable-prefix}dropdown-link-hover-bg: #{$gray-100};\r\n  --#{$variable-prefix}dropdown-border-width: 0;\r\n\r\n  // card\r\n  --#{$variable-prefix}card-bg: #{$white};\r\n  --#{$variable-prefix}card-cap-bg: #{$white};\r\n  --#{$variable-prefix}card-logo-dark: block;\r\n  --#{$variable-prefix}card-logo-light: none;\r\n\r\n  // modal\r\n  --#{$variable-prefix}modal-bg: #{$white};\r\n\r\n  // nav tabs\r\n  --#{$variable-prefix}nav-tabs-link-active-color: #{$gray-700};\r\n  --#{$variable-prefix}nav-tabs-link-active-bg: #{$body-bg};\r\n\r\n  // accordion\r\n  --#{$variable-prefix}accordion-button-active-color: #{shade-color($primary, 10%)};\r\n\r\n  // progress\r\n  --#{$variable-prefix}progress-bg: #{$gray-200};\r\n\r\n  // toast\r\n  --#{$variable-prefix}toast-background-color: #{rgba($white, .85)};\r\n  --#{$variable-prefix}toast-border-color: #{rgba($black, .1)};\r\n  --#{$variable-prefix}toast-header-border-color: #{rgba($black, .05)};\r\n\r\n  //list\r\n  --#{$variable-prefix}list-group-hover-bg: #{$gray-100};\r\n\r\n  // popover\r\n  --#{$variable-prefix}popover-bg: #{$white};\r\n\r\n  // pagination\r\n  --#{$variable-prefix}pagination-hover-bg: #{$gray-200};\r\n\r\n  // form\r\n  --#{$variable-prefix}input-bg: #{$white};\r\n  --#{$variable-prefix}input-border: #{$gray-400};\r\n  --#{$variable-prefix}input-focus-border: #{tint-color($component-active-bg, 50%)};\r\n  --#{$variable-prefix}input-disabled-bg: #{$gray-200};\r\n\r\n  // input-group-addon\r\n  --#{$variable-prefix}input-group-addon-bg: #{$gray-200};\r\n\r\n  //check\r\n  --#{$variable-prefix}input-check-border: var(--#{$variable-prefix}input-border);\r\n}\r\n","// :root CSS dark variables\r\n\r\n\r\n[data-layout-mode=\"dark\"]{\r\n\r\n  // Color system - Dark Mode only\r\n  $gray-100: #1a1d21;\r\n  $gray-200: #212529;\r\n  $gray-300: #2a2f34;\r\n  $gray-400: #878a99;\r\n  $gray-500: #adb5bd;\r\n  $gray-600: #bfc8e2;\r\n  $gray-700: #ced4da;\r\n  $gray-800: #eff2f7;\r\n  $gray-900: #f3f6f9;\r\n\r\n  $grays: (\r\n      \"100\": $gray-100,\r\n      \"200\": $gray-200,\r\n      \"300\": $gray-300,\r\n      \"400\": $gray-400,\r\n      \"500\": $gray-500,\r\n      \"600\": $gray-600,\r\n      \"700\": $gray-700,\r\n      \"800\": $gray-800,\r\n      \"900\": $gray-900\r\n  );\r\n\r\n  // Prefix for :root CSS variables\r\n  @each $color, $value in $grays {\r\n      --#{$variable-prefix}gray-#{$color}: #{$value};\r\n  }\r\n\r\n  // body\r\n  --#{$variable-prefix}body-bg :  #{$gray-100};\r\n  --#{$variable-prefix}body-color: #{$gray-700};\r\n  --#{$variable-prefix}body-color-rgb: #{to-rgb($gray-700)};\r\n  \r\n\r\n  //vertical light\r\n  --#{$variable-prefix}vertical-menu-bg:                      #{$white};\r\n  --#{$variable-prefix}vertical-menu-item-color:              #{darken($gray-400, 16%)};\r\n  --#{$variable-prefix}vertical-menu-item-hover-color:        #{$primary};\r\n  --#{$variable-prefix}vertical-menu-item-active-color:       #{$primary};\r\n  --#{$variable-prefix}vertical-menu-sub-item-color:          #{darken($gray-400, 12%)};\r\n  --#{$variable-prefix}vertical-menu-sub-item-hover-color:    #{$primary};\r\n  --#{$variable-prefix}vertical-menu-sub-item-active-color:   #{$primary};\r\n  --#{$variable-prefix}vertical-menu-title-color:             #{$gray-400};\r\n\r\n  //vertical dark\r\n  --#{$variable-prefix}vertical-menu-bg-dark:                 #{darken($gray-300, 2.5%)};\r\n  --#{$variable-prefix}vertical-menu-item-color-dark:        #89929b;\r\n  --#{$variable-prefix}vertical-menu-item-hover-color-dark:   #{$white};\r\n  --#{$variable-prefix}vertical-menu-item-active-color-dark:  #{$white};\r\n  --#{$variable-prefix}vertical-menu-sub-item-color-dark:    #89929b;\r\n  --#{$variable-prefix}vertical-menu-sub-item-hover-color-dark: #{$white};\r\n  --#{$variable-prefix}vertical-menu-sub-item-active-color-dark: #{$white};\r\n  --#{$variable-prefix}vertical-menu-title-color-dark:         #89929b;\r\n\r\n  // Topbar - (Default Light)\r\n  --#{$variable-prefix}header-bg:  #292e32;\r\n  --#{$variable-prefix}header-item-color:  #e9ecef;\r\n  // Topbar - Dark\r\n  --#{$variable-prefix}header-bg-dark:   #{darken($gray-300, 4%)};\r\n  --#{$variable-prefix}header-item-color-dark:  #89929b;\r\n\r\n  // Topbar Search\r\n  --#{$variable-prefix}topbar-search-bg: #{darken($gray-200, 3%)};\r\n  // Topbar User\r\n  --#{$variable-prefix}topbar-user-bg: #{lighten($gray-300, 3%)};\r\n  --#{$variable-prefix}topbar-user-bg-dark: #{lighten($gray-300, 2%)};\r\n\r\n  //footer\r\n  --#{$variable-prefix}footer-bg: #{$gray-200};\r\n  --#{$variable-prefix}footer-color: #{$gray-400};\r\n\r\n  // Horizontal nav\r\n  --#{$variable-prefix}topnav-bg: #{lighten($gray-200, 2.5%)};\r\n  --#{$variable-prefix}topnav-item-color: #{$gray-400};\r\n  --#{$variable-prefix}topnav-item-color-active: #{$white};\r\n\r\n  // twocolumn menu\r\n  --#{$variable-prefix}twocolumn-menu-iconview-bg: #{$white};\r\n  --#{$variable-prefix}twocolumn-menu-bg:  #{$white};\r\n    \r\n  // two column dark\r\n  --#{$variable-prefix}twocolumn-menu-iconview-bg-dark: var(--#{$variable-prefix}vertical-menu-bg-dark);\r\n  --#{$variable-prefix}twocolumn-menu-bg-dark:  #{darken($gray-300, 1.5%)};\r\n  --#{$variable-prefix}twocolumn-menu-item-color-dark: var(--#{$variable-prefix}vertical-menu-item-color-dark);\r\n  --#{$variable-prefix}twocolumn-menu-item-active-color-dark:  #{$white};\r\n  --#{$variable-prefix}twocolumn-menu-item-active-bg-dark:  #{rgba($white, .15)};\r\n\r\n  // boxed \r\n  --#{$variable-prefix}boxed-body-bg: #{darken($gray-100, 4%)};\r\n\r\n  // heading-color\r\n  --#{$variable-prefix}heading-color: #{$gray-700};\r\n\r\n  // component variable\r\n  --#{$variable-prefix}light: #{$gray-300};\r\n  --#{$variable-prefix}light-rgb: #{to-rgb($gray-300)};\r\n  --#{$variable-prefix}dark: #{$gray-800};\r\n  --#{$variable-prefix}dark-rgb: #{to-rgb($gray-800)};\r\n\r\n  // link\r\n  --#{$variable-prefix}link-color: #{$gray-700};\r\n  --#{$variable-prefix}link-hover-color: #{$gray-700};\r\n\r\n  // Border variable\r\n  --#{$variable-prefix}border-color:  #{lighten($gray-300, 3.5%)};\r\n  \r\n  // dropdown\r\n  --#{$variable-prefix}dropdown-bg: #{lighten($gray-200, 3.5%)};\r\n  --#{$variable-prefix}dropdown-link-color: #{$gray-500};\r\n  --#{$variable-prefix}dropdown-link-hover-color: #{shade-color($gray-700, 10%)};\r\n  --#{$variable-prefix}dropdown-link-hover-bg: #{lighten($gray-300, 2%)};\r\n  --#{$variable-prefix}dropdown-border-width: 1px;\r\n\r\n  // card\r\n  --#{$variable-prefix}card-bg: #{$gray-200};\r\n  --#{$variable-prefix}card-cap-bg: #{$gray-200};\r\n  --#{$variable-prefix}card-logo-dark: none;\r\n  --#{$variable-prefix}card-logo-light: block;\r\n\r\n  // modal\r\n  --#{$variable-prefix}modal-bg: #{$gray-200};\r\n\r\n  // nav tabs\r\n  --#{$variable-prefix}nav-tabs-link-active-color: #{$gray-900};\r\n  --#{$variable-prefix}nav-tabs-link-active-bg: #{$gray-300};\r\n\r\n    // accordion\r\n  --#{$variable-prefix}accordion-button-active-color: #{$white};\r\n\r\n  // progress\r\n  --#{$variable-prefix}progress-bg: #{$gray-300};\r\n\r\n  // toast\r\n  --#{$variable-prefix}toast-background-color: #{rgba($gray-300, .85)};\r\n  --#{$variable-prefix}toast-border-color: #{rgba($white, .1)};\r\n  --#{$variable-prefix}toast-header-border-color: #{rgba($white, .05)};\r\n\r\n  //list\r\n  --#{$variable-prefix}list-group-hover-bg: #{lighten($gray-200, 2.5%)};\r\n\r\n  // popover\r\n  --#{$variable-prefix}popover-bg: #{lighten($gray-200, 1%)};\r\n\r\n  // pagination\r\n  --#{$variable-prefix}pagination-hover-bg: #{lighten($gray-200, 4%)};\r\n\r\n  //form\r\n  --#{$variable-prefix}input-bg: #{lighten($gray-200, 2%)};\r\n  --#{$variable-prefix}input-border: #{$gray-300};\r\n  --#{$variable-prefix}input-focus-border: #{lighten($gray-300, 4%)};\r\n  --#{$variable-prefix}input-disabled-bg: #{$gray-200};\r\n\r\n  // input-group-addon\r\n  --#{$variable-prefix}input-group-addon-bg: #{$gray-300};\r\n\r\n  //check\r\n  --#{$variable-prefix}input-check-border:  #{lighten($gray-300, 4%)};\r\n}","//\r\n// _topbar.scss\r\n//\r\n\r\n#page-topbar {\r\n    position: fixed;\r\n    top: 0;\r\n    right: 0;\r\n    left: 0;\r\n    z-index: 1002;\r\n    background-color: $header-bg;\r\n    transition: all 0.1s ease-out;\r\n  \r\n    &.topbar-shadow {\r\n      box-shadow: $box-shadow;\r\n    }\r\n  \r\n    @media (min-width: 768px) {\r\n      left: $vertical-menu-width;\r\n    }\r\n  }\r\n  \r\n  .navbar-header {\r\n    display: flex;\r\n    -ms-flex-pack: justify;\r\n    justify-content: space-between;\r\n    align-items: center;\r\n    margin: 0 auto;\r\n    height: $header-height;\r\n    padding: 0 $grid-gutter-width 0 calc(#{$grid-gutter-width} / 2)\r\n      /*rtl: 0 0 0 calc(#{$grid-gutter-width} / 2) */;\r\n  \r\n    @media (max-width: 767.98px) {\r\n      padding: 0 calc(#{$grid-gutter-width} / 2) 0 calc(#{$grid-gutter-width} / 2);\r\n    }\r\n  \r\n    .topbar-head-dropdown {\r\n      .dropdown-menu.show {\r\n        top: 13px !important;\r\n      }\r\n    }\r\n  \r\n    .btn-topbar {\r\n      height: 42px;\r\n      width: 42px;\r\n  \r\n      @media (max-width: 360px) {\r\n        height: 36px;\r\n        width: 36px;\r\n      }\r\n    }\r\n  \r\n    .user-name-text {\r\n      color: var(--#{$variable-prefix}gray-700);\r\n    }\r\n  }\r\n  \r\n  /* Search */\r\n  \r\n  .app-search {\r\n    padding: calc(#{$header-height - 38px} / 2) 0;\r\n  \r\n    .form-control {\r\n      border: none;\r\n      height: 38px;\r\n      padding-left: 40px;\r\n      padding-right: 30px;\r\n      background-color: $topbar-search-bg;\r\n      box-shadow: none;\r\n    }\r\n  \r\n    span.search-widget-icon {\r\n      position: absolute;\r\n      z-index: 10;\r\n      font-size: 18px;\r\n      line-height: 38px;\r\n      left: 13px;\r\n      top: 0;\r\n      color: $gray-600;\r\n    }\r\n  \r\n    .search-widget-icon-close {\r\n      right: 7px;\r\n      left: auto !important;\r\n    }\r\n  \r\n    @media (max-width: 1023.99px) {\r\n      padding-left: calc(#{$grid-gutter-width} / 2);\r\n    }\r\n  }\r\n  \r\n  // Mega menu\r\n  \r\n  .megamenu-list {\r\n    li {\r\n      position: relative;\r\n      padding: 5px 0px;\r\n  \r\n      a {\r\n        color: $dropdown-color;\r\n      }\r\n    }\r\n  }\r\n  \r\n  @media (max-width: 767.98px) {\r\n    .logo {\r\n      span.logo-lg {\r\n        display: none;\r\n      }\r\n  \r\n      span.logo-sm {\r\n        display: inline-block;\r\n      }\r\n    }\r\n  }\r\n  \r\n  .header-item {\r\n    height: $header-height;\r\n    display: flex;\r\n    align-items: center;\r\n  }\r\n  \r\n  .header-profile-user {\r\n    height: 32px;\r\n    width: 32px;\r\n  }\r\n  \r\n  .topbar-badge-sm {\r\n    right: 0;\r\n    top: 7px !important;\r\n  }\r\n  \r\n  .topbar-badge {\r\n    right: -9px;\r\n    top: 4px !important;\r\n  }\r\n  \r\n  .topbar-user {\r\n    @media (min-width: 768px) {\r\n      background-color: $topbar-user-bg;\r\n    }\r\n  \r\n    .dropdown-menu {\r\n      top: 6px !important;\r\n    }\r\n  }\r\n  \r\n  .notification-item {\r\n    padding: 0.75rem 1rem;\r\n    white-space: inherit;\r\n    position: relative;\r\n  \r\n    .form-check-input {\r\n      position: relative;\r\n      z-index: 2;\r\n    }\r\n  }\r\n  \r\n  // Dropdown with Icons\r\n  .dropdown-icon-item {\r\n    display: block;\r\n    border-radius: 3px;\r\n    line-height: 34px;\r\n    text-align: center;\r\n    padding: 15px 0 9px;\r\n    border: 1px solid transparent;\r\n    color: $dropdown-link-color;\r\n  \r\n    img {\r\n      height: 24px;\r\n    }\r\n  \r\n    span {\r\n      display: block;\r\n      overflow: hidden;\r\n      text-overflow: ellipsis;\r\n      white-space: nowrap;\r\n    }\r\n  \r\n    &:hover {\r\n      background-color: $dropdown-link-hover-bg;\r\n    }\r\n  }\r\n  \r\n  // Full Screen\r\n  .fullscreen-enable {\r\n    [data-toggle=\"fullscreen\"] {\r\n      .bx-fullscreen::before {\r\n        content: \"\\eacb\";\r\n      }\r\n    }\r\n  }\r\n  // Dark mode enable\r\n  [data-layout-mode=\"dark\"] {\r\n    .light-dark-mode {\r\n      .bx-moon::before {\r\n        content: \"\\ec34\";\r\n      }\r\n    }\r\n  }\r\n  \r\n  [data-topbar=\"dark\"] {\r\n    #page-topbar {\r\n      background-color: $header-bg-dark;\r\n      border-color: $header-bg-dark;\r\n    }\r\n  \r\n    .navbar-header {\r\n      .btn-topbar {\r\n        color: $header-item-color-dark;\r\n  \r\n        &:hover,\r\n        &:focus {\r\n          background-color: rgba($white, 0.07);\r\n          color: $white;\r\n        }\r\n      }\r\n    }\r\n  \r\n    .topbar-user {\r\n      @media (min-width: 767.99px) {\r\n        background-color: $topbar-user-bg-dark;\r\n      }\r\n  \r\n      .user-name-text {\r\n        color: rgba($white, 0.85) !important;\r\n      }\r\n  \r\n      .user-name-sub-text {\r\n        color: $header-item-color-dark !important;\r\n      }\r\n    }\r\n  \r\n    .logo-dark {\r\n      display: none;\r\n    }\r\n  \r\n    .logo-light {\r\n      display: inline-block;\r\n    }\r\n  \r\n    .app-search {\r\n      .form-control {\r\n        background-color: rgba($white, 0.05);\r\n        color: $white;\r\n      }\r\n  \r\n      span.search-widget-icon,\r\n      input.form-control::-webkit-input-placeholder {\r\n        color: rgba($white, 0.5);\r\n      }\r\n    }\r\n  \r\n    .hamburger-icon {\r\n      span {\r\n        background-color: $gray-300;\r\n      }\r\n    }\r\n  }\r\n  \r\n  @media (max-width: 600px) {\r\n    .navbar-header {\r\n      .dropdown {\r\n        position: static;\r\n  \r\n        .dropdown-menu {\r\n          width: 100%;\r\n        }\r\n      }\r\n    }\r\n  }\r\n  \r\n  @media (max-width: 767.98px) {\r\n    #search-dropdown-reponsive {\r\n      top: 54px !important;\r\n    }\r\n  }\r\n  \r\n  [data-layout=\"vertical\"] {\r\n    &[data-layout-style=\"detached\"] {\r\n      @media (min-width: 1024.1px) {\r\n        #page-topbar {\r\n          left: 0 !important;\r\n          box-shadow: $box-shadow;\r\n        }\r\n  \r\n        .horizontal-logo {\r\n          display: inline-block;\r\n          padding-left: 0;\r\n        }\r\n  \r\n        .topnav-hamburger {\r\n          visibility: hidden;\r\n        }\r\n  \r\n        .layout-width {\r\n          max-width: 95%;\r\n          margin: 0 auto;\r\n        }\r\n  \r\n        &[data-sidebar-size=\"sm\"],\r\n        &[data-sidebar-size=\"sm-hover\"] {\r\n          .navbar-brand-box {\r\n            background-color: transparent !important;\r\n            position: relative;\r\n            width: auto;\r\n            text-align: left;\r\n  \r\n            .logo-sm {\r\n              display: none;\r\n            }\r\n  \r\n            .logo-lg {\r\n              display: block;\r\n            }\r\n          }\r\n        }\r\n      }\r\n  \r\n      &[data-topbar=\"dark\"] {\r\n        .horizontal-logo {\r\n          .logo-dark {\r\n            display: none;\r\n          }\r\n          .logo-light {\r\n            display: block;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n  \r\n  [data-layout=\"horizontal\"] {\r\n    #page-topbar {\r\n      left: 0;\r\n      border-bottom: 1px solid var(--#{$variable-prefix}gray-300);\r\n  \r\n      @media (min-width: 1024.1px) {\r\n        &.topbar-shadow {\r\n          box-shadow: none;\r\n        }\r\n      }\r\n    }\r\n  \r\n    .page-content {\r\n      @media (min-width: 1024.1px) {\r\n        margin-top: $header-height;\r\n      }\r\n  \r\n      padding: calc(45px + #{$grid-gutter-width}) calc(#{$grid-gutter-width} / 2)\r\n        $footer-height calc(#{$grid-gutter-width} / 2);\r\n    }\r\n    &[data-layout-width=\"boxed\"] {\r\n      .page-content {\r\n        @media (min-width: 1024.1px) {\r\n          min-height: calc(100vh - #{$footer-height + $header-height});\r\n        }\r\n      }\r\n    }\r\n  }\r\n  \r\n  [data-layout=\"vertical\"] {\r\n    &[data-sidebar-size=\"sm\"],\r\n    &[data-sidebar-size=\"sm-hover\"] {\r\n      #page-topbar {\r\n        @media (min-width: 768px) {\r\n          left: $vertical-menu-width-sm;\r\n        }\r\n      }\r\n    }\r\n  \r\n    &[data-sidebar-size=\"md\"] {\r\n      #page-topbar {\r\n        @media (min-width: 768px) {\r\n          left: $vertical-menu-width-md;\r\n        }\r\n      }\r\n    }\r\n  }\r\n  \r\n  [data-layout=\"twocolumn\"] {\r\n    #page-topbar {\r\n      @media (min-width: 768px) {\r\n        left: calc(#{$twocolumn-menu-iconview-width} + #{$twocolumn-menu-width});\r\n      }\r\n    }\r\n  \r\n    .horizontal-logo {\r\n      display: none;\r\n    }\r\n  }\r\n  ","// \r\n// _page-head.scss\r\n// \r\n\r\n.page-title-box {\r\n    padding: 10px $grid-gutter-width;\r\n    background-color: $card-bg;\r\n    box-shadow: $page-title-box-shadow;\r\n    border-bottom: 1px solid $page-title-border;\r\n    border-top: 1px solid $page-title-border;\r\n    margin: -23px (-$grid-gutter-width) $grid-gutter-width (-$grid-gutter-width);\r\n\r\n    .breadcrumb {\r\n        background-color: transparent;\r\n        padding: 0;\r\n    }\r\n\r\n    h4 {\r\n        font-weight: 700;\r\n        font-size: 15px!important;\r\n        text-transform: uppercase;\r\n    }\r\n}\r\n\r\n[data-layout=\"horizontal\"] {\r\n    .page-title-box {\r\n        padding: 1.2rem 0;\r\n        background-color: transparent !important;\r\n        border-bottom: none;\r\n        border-top: none;\r\n        box-shadow: none;\r\n        margin: 0;\r\n\r\n        @media (min-width: 1024.1px) {\r\n            margin: -19px 0 0 0;\r\n        }\r\n    }\r\n}\r\n\r\n[data-layout=\"vertical\"] {\r\n    &[data-layout-style=\"detached\"]{\r\n        .page-title-box {\r\n            padding: 1.2rem 0;\r\n            background-color: transparent !important;\r\n            border-bottom: none;\r\n            border-top: none;\r\n            box-shadow: none;\r\n            margin: 0;\r\n    \r\n            @media (min-width: 1024.1px) {\r\n                margin: -19px 0 0 0;\r\n            }\r\n        }\r\n    }\r\n}","// \r\n// _footer.scss\r\n// \r\n\r\n.footer {\r\n    bottom: 0;\r\n    padding: 20px calc(#{$grid-gutter-width} / 2);\r\n    position: absolute;\r\n    right: 0;\r\n    color: $footer-color;\r\n    left: $vertical-menu-width;\r\n    height: $footer-height;\r\n    background-color: $footer-bg;\r\n\r\n    @media (max-width: 991.98px) {\r\n        left: 0;\r\n    }\r\n}\r\n\r\n[data-layout=\"vertical\"] {\r\n\r\n    &[data-sidebar-size=\"sm\"],\r\n    &[data-sidebar-size=\"sm-hover\"] {\r\n        .footer {\r\n            left: $vertical-menu-width-sm;\r\n\r\n            @media (max-width: 767.98px) {\r\n                left: 0;\r\n            }\r\n        }\r\n    }\r\n    &[data-sidebar-size=\"md\"] {\r\n        .footer {\r\n            left: $vertical-menu-width-md;\r\n\r\n            @media (max-width: 991.98px) {\r\n                left: 0;\r\n            }\r\n        }\r\n    }\r\n\r\n}\r\n\r\n[data-layout=\"horizontal\"]{\r\n    .footer {\r\n        left: 0 !important;\r\n    } \r\n}\r\n\r\n[data-layout=\"vertical\"][data-layout-style=\"detached\"] {\r\n\r\n    @media (min-width: 1024.1px) {\r\n        .footer {\r\n            left: 0 !important;\r\n            background-color: transparent;\r\n        } \r\n    }\r\n}\r\n\r\n[data-layout=\"twocolumn\"] { \r\n    .footer {\r\n        @media (min-width: 768.1px) {\r\n            left: calc(#{$twocolumn-menu-iconview-width} + #{$twocolumn-menu-width});\r\n        }\r\n    }\r\n}","//\r\n// _vertical.scss\r\n//\r\n\r\n.app-content {\r\n    margin-left: $vertical-menu-width;\r\n    overflow: hidden;\r\n  \r\n    .content {\r\n      padding: 0 15px 10px 15px;\r\n      margin-top: $header-height;\r\n    }\r\n  }\r\n  \r\n  .main-content {\r\n    transition: all 0.1s ease-out;\r\n  \r\n    @media (min-width: 768px) {\r\n      margin-left: $vertical-menu-width;\r\n    }\r\n  }\r\n\r\n  // .e {\r\n  //   display: inline-block;\r\n  //   position: relative;\r\n    \r\n  //   .eh {\r\n  //     transition:  0.1s linear;\r\n  //     text-decoration: none;\r\n  //     float: left;\r\n  //     font-size: 14px;\r\n  //     color: #FFFFFF;\r\n  //     padding: 4px 0px 4px 8px + (10px * 2);\r\n  //     background: #65bf45;\r\n  //     position: relative;\r\n      \r\n  //     //let remove a little spacing from the first crumb\r\n  //     &:first-child {\r\n  //       padding-left: 10px;\r\n  //     }\r\n      \r\n  //     //the last element will not look like the rest of the crumbs\r\n  //     &:last-child,\r\n  //     &:hover:last-child {\r\n  //       padding-left: 10px + 5px;\r\n  //       background: none;\r\n  //       cursor: text;\r\n  //     }\r\n      \r\n  //     //adding the arrows for the breadcrumbs using rotated pseudo elements\r\n  //     &:after {\r\n  //       transition: 0.1s linear;\r\n  //       content: '';\r\n  //       position: absolute;\r\n  //       top: 3px;\r\n  //       right: 1px - 10px;\r\n  //       padding: 9px;\r\n  //       z-index: 1;\r\n  //       background: #65bf45;\r\n        \r\n  //       //the scaling makes the top/bottom of the arrows flat\r\n  //       transform: scale(.98) rotate(45deg);\r\n        \r\n  //       //stylish arrow design using box shadow\r\n  //       box-shadow:  2px -2px 0 1px #666666;\r\n  //     }\r\n  \r\n  //     //we need to move the last crumb seperator a little more the the left to cover up the background of the crumb itself\r\n  //     &:last-of-type:after {\r\n  //       right: -4px;\r\n  //     }\r\n  \r\n  //     //no seperator for the crumb\r\n  //     &:last-child:after {\r\n  //       content: none;\r\n  //     }\r\n      \r\n  //     //text should be above the seperator\r\n  //     .ehe {\r\n  //       position: relative;\r\n  //       z-index: 2;\r\n  //     }\r\n  //   }\r\n    \r\n  //   a:last-of-type .text {\r\n  //     padding-right: 10px;\r\n  //   }\r\n    \r\n  //   //change background color on hover\r\n  //   a:hover,\r\n  //   a:hover:after {\r\n  //     background: darken(#65bf45, 10);\r\n  //   }\r\n  // }\r\n  \r\n  .page-content {\r\n    // padding: calc(#{$header-height} + #{$grid-gutter-width})\r\n    //   calc(#{$grid-gutter-width} / 2) $footer-height\r\n    //   calc(#{$grid-gutter-width} / 2);\r\n    padding: 100px 60px;\r\n  }\r\n  \r\n  .navbar-menu {\r\n    width: $vertical-menu-width;\r\n    z-index: $vertical-menu-z-index;\r\n    background: $vertical-menu-bg;\r\n    border-right: 1px solid $vertical-menu-border;\r\n    bottom: 0;\r\n    margin-top: 0;\r\n    position: fixed;\r\n    top: 0;\r\n    box-shadow: $vertical-menu-box-shadow;\r\n    padding: 0 0 calc(#{$header-height} + 25px) 0;\r\n    transition: all 0.1s ease-out;\r\n  \r\n    .navbar-nav {\r\n      .nav-link {\r\n        display: flex;\r\n        align-items: center;\r\n        padding: $vertical-menu-item-padding-y $vertical-menu-item-padding-x;\r\n        color: $vertical-menu-item-color;\r\n        font-size: $vertical-menu-item-font-size;\r\n        font-family: $vertical-menu-item-font-family;\r\n  \r\n        &.active {\r\n          color: $vertical-menu-item-active-color;\r\n        }\r\n  \r\n        &:hover {\r\n          color: $vertical-menu-item-hover-color;\r\n        }\r\n  \r\n        i {\r\n          display: inline-block;\r\n          min-width: $vertical-menu-item-icon-width;\r\n          font-size: 18px;\r\n          line-height: inherit;\r\n        }\r\n  \r\n        svg {\r\n          width: 18px;\r\n          margin-right: 0.665rem;\r\n          color: $vertical-menu-item-color;\r\n        }\r\n  \r\n        .badge {\r\n          margin-left: auto;\r\n          margin-right: -2px;\r\n          z-index: 1;\r\n        }\r\n  \r\n        &:hover {\r\n          color: $vertical-menu-item-hover-color;\r\n          .icon-dual {\r\n            color: $vertical-menu-item-hover-color;\r\n            fill: rgba($primary, 0.16);\r\n          }\r\n        }\r\n  \r\n        &[data-bs-toggle=\"collapse\"] {\r\n          &:after {\r\n            display: block;\r\n            content: \"\\F0142\";\r\n            font-family: \"Material Design Icons\";\r\n            margin-left: auto;\r\n            transition: transform 0.2s;\r\n            font-size: 1.05rem;\r\n            position: absolute;\r\n            right: 18px;\r\n            color: $vertical-menu-title-color;\r\n          }\r\n          &[aria-expanded=\"true\"] {\r\n            color: $vertical-menu-item-active-color;\r\n  \r\n            .icon-dual {\r\n              color: $vertical-menu-item-hover-color;\r\n              fill: rgba($primary, 0.16);\r\n            }\r\n  \r\n            &:after {\r\n              transform: rotate(90deg);\r\n              color: $vertical-menu-item-active-color;\r\n            }\r\n  \r\n            &:before {\r\n              opacity: 1;\r\n              background-color: $vertical-menu-item-active-color;\r\n            }\r\n          }\r\n        }\r\n        &.collapsed {\r\n          &.active {\r\n            &::after {\r\n              transform: rotate(90deg);\r\n            }\r\n          }\r\n        }\r\n      }\r\n  \r\n      .nav-sm {\r\n        padding-left: $vertical-menu-item-icon-width;\r\n  \r\n        .nav-link {\r\n          padding: $vertical-menu-sub-item-padding-y\r\n            $vertical-menu-sub-item-padding-x !important;\r\n          color: $vertical-menu-sub-item-color;\r\n          white-space: none;\r\n          position: relative;\r\n          font-size: $vertical-menu-sub-item-font-size;\r\n          font-family: $vertical-menu-sub-item-font-family;\r\n  \r\n          &:before {\r\n            content: \"\";\r\n            width: 6px;\r\n            height: 1.5px;\r\n            background-color: $vertical-menu-sub-item-color;\r\n            position: absolute;\r\n            left: 2px;\r\n            top: 16.5px;\r\n            transition: all 0.4s ease-in-out;\r\n            opacity: 0.5;\r\n          }\r\n  \r\n          &:hover {\r\n            color: $vertical-menu-sub-item-hover-color;\r\n  \r\n            &:before {\r\n              background-color: $vertical-menu-sub-item-hover-color !important;\r\n              opacity: 1;\r\n            }\r\n          }\r\n  \r\n          &.active {\r\n            color: $vertical-menu-item-active-color;\r\n            &:before {\r\n              background-color: $vertical-menu-item-active-color !important;\r\n            }\r\n          }\r\n        }\r\n  \r\n        .nav-sm {\r\n          padding-left: 15px;\r\n  \r\n          .nav-link {\r\n            &:before {\r\n              height: 5px;\r\n              width: 5px;\r\n              left: 5px;\r\n              border-radius: 50%;\r\n              background-color: transparent;\r\n              border: 1px solid;\r\n              top: 16px;\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n  \r\n    .btn-vertical-sm-hover {\r\n      color: $text-muted;\r\n      display: none;\r\n    }\r\n  }\r\n  \r\n  .navbar-brand-box {\r\n    padding: 0 1.3rem;\r\n    text-align: center;\r\n    transition: all 0.1s ease-out;\r\n  \r\n    @media (max-width: 767.98px) {\r\n      display: none;\r\n    }\r\n  }\r\n  \r\n  .hamburger-icon {\r\n    width: 20px;\r\n    height: 14px;\r\n    position: relative;\r\n    cursor: pointer;\r\n    display: inline-block;\r\n  \r\n    span {\r\n      background-color: $text-muted;\r\n      position: absolute;\r\n      border-radius: 2px;\r\n      transition: 0.3s cubic-bezier(0.8, 0.5, 0.2, 1.4);\r\n      width: 100%;\r\n      height: 2px;\r\n      display: block;\r\n      left: 0px;\r\n  \r\n      &:nth-child(1) {\r\n        top: 0;\r\n        width: 80%;\r\n      }\r\n  \r\n      &:nth-child(2) {\r\n        top: 6px;\r\n      }\r\n  \r\n      &:nth-child(3) {\r\n        bottom: 0;\r\n        width: 60%;\r\n      }\r\n    }\r\n  \r\n    .vertical-menu-btn:hover &:not(.open) {\r\n      span {\r\n        &:nth-child(1) {\r\n          top: -1px;\r\n        }\r\n  \r\n        &:nth-child(3) {\r\n          bottom: -1px;\r\n        }\r\n      }\r\n    }\r\n  \r\n    &.open {\r\n      transform: rotate(-90deg);\r\n  \r\n      span {\r\n        &:nth-child(1) {\r\n          left: 1px;\r\n          top: 5px;\r\n          width: 20px;\r\n          transform: rotate(90deg);\r\n          transition-delay: 150ms;\r\n        }\r\n  \r\n        &:nth-child(2) {\r\n          left: 3px;\r\n          top: 13px;\r\n          width: 10px;\r\n          transform: rotate(45deg);\r\n          transition-delay: 50ms;\r\n        }\r\n  \r\n        &:nth-child(3) {\r\n          left: 9px;\r\n          top: 13px;\r\n          width: 10px;\r\n          transform: rotate(-45deg);\r\n          transition-delay: 100ms;\r\n        }\r\n      }\r\n    }\r\n  }\r\n  \r\n  .logo {\r\n    line-height: $header-height;\r\n  \r\n    .logo-sm {\r\n      display: none;\r\n    }\r\n  }\r\n  \r\n  .logo-light {\r\n    display: none;\r\n  }\r\n  \r\n  [data-layout=\"vertical\"] {\r\n    .app-menu {\r\n      .row {\r\n        margin: 0;\r\n        > * {\r\n          width: 100%;\r\n          padding: 0;\r\n        }\r\n      }\r\n  \r\n      @media (max-width: 767.98px) {\r\n        margin-left: -100%;\r\n        padding: 10px 0 20px 0;\r\n      }\r\n    }\r\n  \r\n    .navbar-menu {\r\n      .container-fluid {\r\n        padding: 0;\r\n      }\r\n    }\r\n  \r\n    .navbar-brand-box {\r\n      @media (max-width: 767.98px) {\r\n        display: none;\r\n      }\r\n    }\r\n  \r\n    .horizontal-logo {\r\n      display: none;\r\n    }\r\n  \r\n    &[data-sidebar-size=\"sm-hover\"] {\r\n      .main-content {\r\n        margin-left: $vertical-menu-width-sm;\r\n        @media (max-width: 767.98px) {\r\n          margin-left: 0;\r\n        }\r\n      }\r\n  \r\n      .logo {\r\n        span.logo-lg {\r\n          display: none;\r\n        }\r\n  \r\n        span.logo-sm {\r\n          display: inline-block;\r\n        }\r\n      }\r\n  \r\n      .btn-vertical-sm-hover {\r\n        display: inline-block;\r\n      }\r\n  \r\n      @media (min-width: 768px) {\r\n        .topnav-hamburger {\r\n          display: none;\r\n        }\r\n      }\r\n  \r\n      // Side menu\r\n      .navbar-menu {\r\n        width: $vertical-menu-width-sm;\r\n  \r\n        .btn-vertical-sm-hover {\r\n          display: none;\r\n  \r\n          i {\r\n            &.ri-record-circle-line:before {\r\n              content: \"\\EB7D\";\r\n            }\r\n          }\r\n        }\r\n  \r\n        // Sidebar Menu\r\n        .navbar-nav {\r\n          .badge {\r\n            display: none;\r\n          }\r\n  \r\n          .menu-title {\r\n            text-align: center;\r\n  \r\n            span {\r\n              display: none;\r\n            }\r\n  \r\n            i {\r\n              display: block;\r\n              line-height: 36px;\r\n              font-size: 1rem;\r\n            }\r\n          }\r\n  \r\n          .nav-link {\r\n            span {\r\n              display: none;\r\n            }\r\n  \r\n            i {\r\n              font-size: 22px;\r\n  \r\n              &.las,\r\n              &.lar,\r\n              &.lab {\r\n                font-size: 24px;\r\n              }\r\n            }\r\n  \r\n            svg {\r\n              margin-right: 0px;\r\n            }\r\n  \r\n            &:after,\r\n            &:before {\r\n              display: none;\r\n            }\r\n          }\r\n  \r\n          .menu-dropdown {\r\n            display: none;\r\n          }\r\n        }\r\n  \r\n        &:hover {\r\n          width: $vertical-menu-width !important;\r\n  \r\n          @media (min-width: 1024.99px) {\r\n            .btn-vertical-sm-hover {\r\n              display: inline-block;\r\n            }\r\n  \r\n            .navbar-brand-box {\r\n              text-align: left;\r\n            }\r\n          }\r\n  \r\n          .navbar-nav {\r\n            .menu-dropdown.show {\r\n              display: block;\r\n            }\r\n          }\r\n  \r\n          .nav-link {\r\n            i {\r\n              font-size: 18px;\r\n  \r\n              &.las,\r\n              &.lar,\r\n              &.lab {\r\n                font-size: 20px;\r\n              }\r\n            }\r\n  \r\n            svg {\r\n              margin-right: 0.665rem;\r\n            }\r\n  \r\n            span,\r\n            &:after,\r\n            &:before {\r\n              display: inline-block;\r\n            }\r\n          }\r\n  \r\n          .logo {\r\n            span.logo-lg {\r\n              display: inline-block;\r\n            }\r\n  \r\n            span.logo-sm {\r\n              display: none;\r\n            }\r\n          }\r\n  \r\n          .menu-title {\r\n            text-align: left;\r\n  \r\n            span {\r\n              display: inline-block;\r\n            }\r\n  \r\n            i {\r\n              display: none;\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n  \r\n    &[data-sidebar-size=\"sm-hover\"],\r\n    &[data-sidebar-size=\"sm-hover-active\"] {\r\n      .navbar-header {\r\n        @media (min-width: 1025px) {\r\n          padding-left: $grid-gutter-width;\r\n        }\r\n      }\r\n    }\r\n  \r\n    &[data-sidebar-size=\"sm-hover-active\"] {\r\n      .navbar-brand-box {\r\n        text-align: left;\r\n      }\r\n  \r\n      .topnav-hamburger {\r\n        display: none;\r\n      }\r\n  \r\n      .btn-vertical-sm-hover {\r\n        display: inline-block;\r\n      }\r\n    }\r\n  \r\n    &[data-sidebar-size=\"sm\"] {\r\n      @media (min-width: 768px) {\r\n        min-height: 1400px;\r\n  \r\n        .main-content {\r\n          margin-left: $vertical-menu-width-sm;\r\n        }\r\n      }\r\n  \r\n      @media (max-width: 767.98px) {\r\n        .app-menu {\r\n          margin-left: 0;\r\n        }\r\n      }\r\n  \r\n      #page-topbar {\r\n        z-index: calc(#{$vertical-menu-z-index} + 1);\r\n      }\r\n  \r\n      .navbar-brand-box {\r\n        position: fixed;\r\n        padding: 0;\r\n        width: $vertical-menu-width-sm;\r\n        z-index: 1;\r\n        top: 0;\r\n        background: $vertical-menu-bg;\r\n      }\r\n  \r\n      .logo {\r\n        span.logo-lg {\r\n          display: none;\r\n        }\r\n  \r\n        span.logo-sm {\r\n          display: inline-block;\r\n        }\r\n      }\r\n  \r\n      // Side menu\r\n      .navbar-menu {\r\n        position: absolute;\r\n        width: $vertical-menu-width-sm !important;\r\n        padding-top: $header-height;\r\n  \r\n        .simplebar-mask,\r\n        .simplebar-content-wrapper {\r\n          overflow: visible !important;\r\n        }\r\n  \r\n        .simplebar-scrollbar,\r\n        .vertical-menu-btn {\r\n          display: none !important;\r\n        }\r\n  \r\n        .simplebar-offset {\r\n          bottom: 0 !important;\r\n        }\r\n  \r\n        // Sidebar Menu\r\n        .navbar-nav {\r\n          .badge {\r\n            display: none !important;\r\n          }\r\n  \r\n          .menu-title {\r\n            text-align: center;\r\n            font-size: 1rem;\r\n  \r\n            span {\r\n              display: none;\r\n            }\r\n  \r\n            i {\r\n              display: block;\r\n              line-height: 36px;\r\n            }\r\n          }\r\n  \r\n          .nav-link {\r\n\r\n            span {\r\n              display: none;\r\n            }\r\n  \r\n            i {\r\n              font-size: 22px;\r\n            }\r\n            svg {\r\n              margin-right: 0px;\r\n            }\r\n  \r\n            &:after,\r\n            &:before {\r\n              display: none;\r\n            }\r\n          }\r\n  \r\n          .menu-dropdown {\r\n            display: none;\r\n            height: auto !important;\r\n          }\r\n  \r\n          .nav-item {\r\n            position: relative;\r\n  \r\n            &:hover {\r\n              > a.menu-link {\r\n                position: relative;\r\n                width: calc(200px + #{$vertical-menu-width-sm});\r\n                color: $white;\r\n                background-color: $vertical-menu-bg-dark;\r\n                transition: none;\r\n  \r\n                .icon-dual {\r\n                  color: $vertical-menu-item-hover-color-dark;\r\n                  fill: rgba($white, 0.16);\r\n                }\r\n  \r\n                span {\r\n                  display: inline-block;\r\n                  padding-left: 25px;\r\n                }\r\n  \r\n                &:after {\r\n                  display: block;\r\n                  transform: rotate(90deg);\r\n                  color: $white;\r\n                }\r\n              }\r\n  \r\n              > .menu-dropdown {\r\n                display: block;\r\n                left: $vertical-menu-width-sm;\r\n                position: absolute;\r\n                width: 200px;\r\n                background: $vertical-menu-bg;\r\n                height: auto !important;\r\n                padding: 0.5rem 0;\r\n                border-radius: 0 0 3px 3px;\r\n                box-shadow: $vertical-menu-dropdown-box-shadow;\r\n              }\r\n            }\r\n          }\r\n  \r\n          .nav-sm {\r\n            padding: 0;\r\n  \r\n            .nav-item {\r\n              &:hover {\r\n                > .nav-link {\r\n                  color: $red;\r\n  \r\n                  &:after {\r\n                    color: inherit;\r\n                  }\r\n                }\r\n              }\r\n            }\r\n  \r\n            .nav-link {\r\n              &:after {\r\n                display: block !important;\r\n                transform: rotate(0deg) !important;\r\n              }\r\n            }\r\n  \r\n            .menu-dropdown {\r\n              left: 100% !important;\r\n              top: 0;\r\n              border-radius: 3px !important;\r\n            }\r\n          }\r\n        }\r\n      }\r\n    }\r\n  \r\n    &[data-sidebar-size=\"md\"] {\r\n      @media (min-width: 768px) {\r\n        .main-content {\r\n          margin-left: $vertical-menu-width-md;\r\n        }\r\n      }\r\n  \r\n      .navbar-brand-box {\r\n        width: $vertical-menu-width-md;\r\n      }\r\n  \r\n      // Side menu\r\n      .navbar-menu {\r\n        width: $vertical-menu-width-md !important;\r\n  \r\n        // Sidebar Menu\r\n        .navbar-nav {\r\n          .nav-link {\r\n            display: block;\r\n            text-align: center;\r\n            padding: $vertical-menu-sub-item-padding-y\r\n              $vertical-menu-sub-item-padding-x * 0.35;\r\n  \r\n            i {\r\n              display: block;\r\n            }\r\n            svg {\r\n              display: block;\r\n              margin-left: auto;\r\n              margin-right: auto;\r\n            }\r\n  \r\n            &:before {\r\n              display: none !important;\r\n            }\r\n  \r\n            &[data-bs-toggle=\"collapse\"]:after {\r\n              position: relative;\r\n              display: inline-block;\r\n              right: 0;\r\n              top: 3px;\r\n            }\r\n  \r\n            &.menu-link {\r\n              &[data-bs-toggle=\"collapse\"]:after {\r\n                display: none;\r\n              }\r\n            }\r\n          }\r\n  \r\n          .badge {\r\n            display: none !important;\r\n          }\r\n  \r\n          .nav-sm {\r\n            padding-left: 0;\r\n          }\r\n        }\r\n  \r\n        .menu-title {\r\n          text-align: center;\r\n  \r\n          span {\r\n            text-decoration: underline;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  \r\n    &[data-sidebar=\"dark\"] {\r\n      .navbar-menu {\r\n        background: #F7FAFC;\r\n        border-right: 1px solid #F7FAFC;\r\n  \r\n        .hamburger-icon {\r\n          span {\r\n            background-color: $vertical-menu-item-color-dark;\r\n          }\r\n        }\r\n  \r\n        .btn-vertical-sm-hover {\r\n          color: $vertical-menu-item-color-dark;\r\n        }\r\n      }\r\n  \r\n      .navbar-nav {\r\n        .nav-link {\r\n          color: $dark;\r\n  \r\n          &.active {\r\n            color: $vertical-menu-item-active-color-dark;\r\n          }\r\n  \r\n          &[data-bs-toggle=\"collapse\"] {\r\n            &:after {\r\n              color: inherit;\r\n            }\r\n  \r\n            &[aria-expanded=\"true\"] {\r\n              color: $vertical-menu-item-active-color-dark;\r\n              &:after {\r\n                color: inherit;\r\n              }\r\n  \r\n              .icon-dual {\r\n                color: $vertical-menu-item-active-color-dark;\r\n                fill: rgba($white, 0.1);\r\n              }\r\n            }\r\n          }\r\n  \r\n          svg {\r\n            color: $vertical-menu-item-color-dark;\r\n            fill: rgba($white, 0.1);\r\n          }\r\n  \r\n          &:hover {\r\n            color: $red;\r\n            .icon-dual {\r\n              color: $red;\r\n              fill: rgba($white, 0.16);\r\n            }\r\n          }\r\n        }\r\n  \r\n        > .nav-item {\r\n          margin: 10px 15px;\r\n          .nav-link.active {\r\n            color: $red;\r\n            background-color: #FFE7E7;\r\n            border-radius: 10px;\r\n            .icon-dual {\r\n              color: $red;\r\n              fill: rgba($white, 0.16);\r\n            }\r\n          }\r\n        }\r\n  \r\n        .nav-sm {\r\n          .nav-link {\r\n            color: $dark;\r\n  \r\n            &:before {\r\n              background-color: $vertical-menu-sub-item-color-dark !important;\r\n            }\r\n  \r\n            &:hover {\r\n              color: $red;\r\n  \r\n              &:before {\r\n                background-color: $red !important;\r\n              }\r\n            }\r\n  \r\n            &.active {\r\n              color: $red;\r\n              background-color: #FBE7E6;\r\n              border-radius: 10px;\r\n              margin-right: 20px;\r\n            }\r\n          }\r\n  \r\n          .nav-sm {\r\n            .nav-link {\r\n              &:before {\r\n                background-color: transparent !important;\r\n              }\r\n  \r\n              &:hover {\r\n                &:before {\r\n                  background-color: $vertical-menu-item-hover-color-dark !important;\r\n                }\r\n              }\r\n  \r\n              &.active {\r\n                color: $red;\r\n                // background-color: #FBE7E6;\r\n                &:before {\r\n                  background-color: $vertical-menu-item-active-color-dark !important;\r\n                }\r\n              }\r\n            }\r\n          }\r\n        }\r\n      }\r\n  \r\n      &[data-sidebar-size=\"sm\"] {\r\n        .navbar-brand-box {\r\n          background: $vertical-menu-bg-dark;\r\n        }\r\n  \r\n        // Side menu\r\n        .navbar-menu {\r\n          .navbar-nav {\r\n            .nav-item {\r\n              &:hover {\r\n                > .menu-dropdown {\r\n                  background: $vertical-menu-bg-dark;\r\n                }\r\n              }\r\n            }\r\n  \r\n            .nav-sm {\r\n              padding: 0;\r\n  \r\n              .nav-link {\r\n                &:after {\r\n                  display: block !important;\r\n                  transform: rotate(0deg) !important;\r\n                }\r\n              }\r\n  \r\n              .nav-item {\r\n                &:hover {\r\n                  > .nav-link {\r\n                    color: $vertical-menu-item-active-color-dark;\r\n  \r\n                    &:after {\r\n                      color: inherit;\r\n                    }\r\n                  }\r\n                }\r\n              }\r\n  \r\n              .menu-dropdown {\r\n                left: 100% !important;\r\n                top: 0;\r\n                border-radius: 3px !important;\r\n              }\r\n            }\r\n          }\r\n        }\r\n      }\r\n  \r\n      .menu-title {\r\n        color: $dark;\r\n      }\r\n  \r\n      .logo-dark {\r\n        display: none;\r\n      }\r\n  \r\n      .logo-light {\r\n        display: inline-block;\r\n      }\r\n    }\r\n  \r\n    &[data-sidebar=\"light\"] {\r\n      .logo-dark {\r\n        display: inline-block;\r\n      }\r\n  \r\n      .logo-light {\r\n        display: none;\r\n      }\r\n    }\r\n  \r\n    &[data-layout-style=\"detached\"] {\r\n      #layout-wrapper,\r\n      .main-content {\r\n        min-height: 100vh;\r\n      }\r\n      @media (min-width: 1024.1px) {\r\n        .main-content {\r\n          position: relative;\r\n        }\r\n  \r\n        #layout-wrapper {\r\n          max-width: 95%;\r\n          margin: 0 auto;\r\n          padding-left: $grid-gutter-width;\r\n        }\r\n  \r\n        .navbar-header {\r\n          padding-left: $grid-gutter-width;\r\n        }\r\n  \r\n        .navbar-menu {\r\n          top: calc(#{$header-height} + #{$grid-gutter-width});\r\n          bottom: $grid-gutter-width;\r\n          padding: 0;\r\n          border-right: $vertical-menu-bg;\r\n          border-radius: 5px;\r\n          padding: 10px 0;\r\n          z-index: 1;\r\n  \r\n          .navbar-brand-box {\r\n            display: none;\r\n          }\r\n        }\r\n  \r\n        &[data-sidebar=\"dark\"] {\r\n          .logo-dark {\r\n            display: inline-block;\r\n          }\r\n  \r\n          .logo-light {\r\n            display: none;\r\n          }\r\n        }\r\n      }\r\n  \r\n      .footer {\r\n        border-top: 1px dashed $border-color;\r\n      }\r\n  \r\n      .auth-page-wrapper {\r\n        .footer {\r\n          border-top: none;\r\n        }\r\n      }\r\n  \r\n      &[data-sidebar-size=\"sm\"] {\r\n        @media (min-width: 768px) {\r\n          #layout-wrapper,\r\n          .main-content {\r\n            min-height: 1400px;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n  \r\n  .menu-title {\r\n    letter-spacing: 0.05em;\r\n    cursor: default;\r\n    font-size: 11px;\r\n    text-transform: uppercase;\r\n    color: $vertical-menu-title-color;\r\n    font-weight: $font-weight-semibold;\r\n  \r\n    span {\r\n      padding: 12px 20px;\r\n      display: inline-block;\r\n    }\r\n  \r\n    i {\r\n      display: none;\r\n    }\r\n  }\r\n  \r\n  .vertical-overlay {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    width: 100vw;\r\n    height: 100vh;\r\n    background-color: rgba($dark, 0.35);\r\n    z-index: 1003;\r\n    display: none;\r\n  }\r\n  \r\n  // Mobile Menu\r\n  .vertical-sidebar-enable {\r\n    .vertical-overlay {\r\n      display: block;\r\n    }\r\n  \r\n    .app-menu {\r\n      margin-left: 0 !important;\r\n      z-index: 1004;\r\n    }\r\n  }\r\n  \r\n  // rtl\r\n  [dir=\"rtl\"] {\r\n    .navbar-menu {\r\n      .navbar-nav {\r\n        .nav-link[data-bs-toggle=\"collapse\"] {\r\n          &:after {\r\n            transform: rotate(180deg);\r\n          }\r\n          &[aria-expanded=\"true\"]:after {\r\n            transform: rotate(270deg);\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n  ","//\r\n// _horizontal.scss\r\n//\r\n\r\n[data-layout=\"horizontal\"] {\r\n  .main-content {\r\n    margin-left: 0;\r\n  }\r\n\r\n  @media (min-width: 1024.1px) {\r\n    .layout-width,\r\n    .container-fluid {\r\n      max-width: 90%;\r\n      margin: 0 auto;\r\n    }\r\n\r\n    .topnav-hamburger {\r\n      visibility: hidden;\r\n    }\r\n  }\r\n\r\n  .horizontal-logo {\r\n    padding-left: calc(#{$grid-gutter-width} / 2);\r\n\r\n    @media (max-width: 1024.98px) {\r\n      padding-left: $grid-gutter-width;\r\n    }\r\n  }\r\n\r\n  .navbar-menu {\r\n    background: $topnav-bg;\r\n    padding: 0 calc(#{$grid-gutter-width} / 2);\r\n    box-shadow: $horizontal-menu-box-shadow;\r\n    margin-top: $header-height;\r\n    position: fixed;\r\n    left: 0;\r\n    right: 0;\r\n    z-index: 100;\r\n    width: 100%;\r\n    bottom: auto;\r\n\r\n    @media (max-width: 575.98px) {\r\n      .container-fluid {\r\n        padding: 0;\r\n      }\r\n    }\r\n\r\n    .navbar-nav {\r\n      flex-direction: row;\r\n\r\n      .nav-sm {\r\n        padding-left: 0;\r\n\r\n        .nav-link {\r\n          &:before {\r\n            opacity: 0 !important;\r\n          }\r\n\r\n          &:hover,\r\n          &.active {\r\n            color: $topnav-item-color-active;\r\n          }\r\n        }\r\n      }\r\n\r\n      .nav-link {\r\n        color: $topnav-item-color;\r\n        padding: $horizontal-menu-item-padding-y $horizontal-menu-item-padding-x;\r\n\r\n        i {\r\n          line-height: 1;\r\n        }\r\n\r\n        &.active {\r\n          color: $topnav-item-color-active;\r\n        }\r\n\r\n        &[data-bs-toggle=\"collapse\"][aria-expanded=\"true\"] {\r\n          color: $topnav-item-color-active;\r\n\r\n          .icon-dual {\r\n            color: $topnav-item-color-active;\r\n            fill: rgba($primary, 0.1);\r\n          }\r\n\r\n          &:after {\r\n            color: $topnav-item-color-active;\r\n          }\r\n        }\r\n\r\n        &:hover {\r\n          .icon-dual {\r\n            color: $topnav-item-color-active;\r\n            fill: rgba($primary, 0.1);\r\n          }\r\n        }\r\n      }\r\n\r\n      > .nav-item {\r\n        > .nav-link[data-bs-toggle=\"collapse\"]:after {\r\n          right: 0px;\r\n          transform: rotate(90deg) !important;\r\n        }\r\n      }\r\n\r\n      > li:nth-of-type(2) {\r\n        > .nav-link.menu-link {\r\n          padding-left: 0;\r\n        }\r\n      }\r\n    }\r\n\r\n    .navbar-brand-box {\r\n      display: none;\r\n    }\r\n  }\r\n\r\n  .navbar-nav {\r\n    .nav-item {\r\n      position: relative;\r\n\r\n      .nav-link[data-bs-toggle=\"collapse\"]:after {\r\n        right: 10px;\r\n        transform: rotate(0deg) !important;\r\n      }\r\n\r\n      > .nav-link {\r\n        > .badge {\r\n          margin-right: -10px;\r\n        }\r\n      }\r\n\r\n      &:hover {\r\n        > .nav-link {\r\n          color: $topnav-item-color-active;\r\n\r\n          .icon-dual {\r\n            color: $topnav-item-color-active;\r\n            fill: rgba($primary, 0.1);\r\n          }\r\n\r\n          &:after {\r\n            color: $topnav-item-color-active;\r\n          }\r\n        }\r\n\r\n        @media (min-width: 1024.1px) {\r\n          > .menu-dropdown {\r\n            display: block;\r\n            height: auto !important;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n\r\n  .menu-dropdown {\r\n    position: absolute;\r\n    min-width: $horizontal-menu-dropdown-min-width;\r\n    padding: $dropdown-padding-y $dropdown-padding-x;\r\n    box-shadow: $horizontal-menu-dropdown-box-shadow;\r\n    animation-name: DropDownSlide;\r\n    animation-duration: 0.3s;\r\n    animation-fill-mode: both;\r\n    margin: 0;\r\n    z-index: $zindex-dropdown;\r\n    background-color: $dropdown-bg;\r\n    background-clip: padding-box;\r\n    border: $dropdown-border-width solid $dropdown-border-color;\r\n    border-radius: $dropdown-border-radius;\r\n    display: none;\r\n\r\n    .menu-dropdown {\r\n      top: 0;\r\n      left: 100%;\r\n    }\r\n  }\r\n\r\n  .mega-dropdown-menu {\r\n    width: 40rem;\r\n  }\r\n\r\n  .menu-title {\r\n    display: none;\r\n  }\r\n\r\n  .dropdown-custom-right {\r\n    left: -100% !important;\r\n    right: 100%;\r\n  }\r\n\r\n  @media (max-width: 1024px) {\r\n    .navbar-menu {\r\n      display: none;\r\n    }\r\n  }\r\n}\r\n\r\n[data-layout=\"horizontal\"] {\r\n  .menu {\r\n    @media (max-width: 1024px) {\r\n      .navbar-menu {\r\n        display: block;\r\n        max-height: 360px;\r\n        overflow-y: auto;\r\n        padding-left: 0;\r\n\r\n        .navbar-nav {\r\n          flex-direction: column;\r\n\r\n          > li:nth-of-type(2) > .nav-link.menu-link {\r\n            padding-left: $vertical-menu-item-padding-x;\r\n          }\r\n\r\n          .nav-sm .nav-link:before {\r\n            opacity: 1 !important;\r\n          }\r\n        }\r\n      }\r\n\r\n      .menu-dropdown {\r\n        position: relative;\r\n        min-width: 100%;\r\n        box-shadow: none;\r\n        padding-left: 28px;\r\n        left: 0;\r\n        animation: none;\r\n        padding-top: 0;\r\n\r\n        &.show {\r\n          display: block;\r\n        }\r\n      }\r\n\r\n      .dropdown-custom-right {\r\n        left: 0 !important;\r\n      }\r\n\r\n      .nav-item .nav-link[data-bs-toggle=\"collapse\"]:after {\r\n        right: 0px;\r\n      }\r\n\r\n      .mega-dropdown-menu {\r\n        width: 100%;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n// theme dark\r\n[data-layout-mode=\"dark\"] {\r\n  &[data-topbar=\"light\"] {\r\n    .navbar-header {\r\n      .horizontal-logo {\r\n        .logo-dark {\r\n          display: none;\r\n        }\r\n\r\n        .logo-light {\r\n          display: block;\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n// rtl\r\n[dir=\"rtl\"] {\r\n  &[data-layout=\"horizontal\"] {\r\n    .navbar-menu {\r\n      .navbar-nav > .nav-item > .nav-link[data-bs-toggle=\"collapse\"] {\r\n        &:after {\r\n          transform: rotate(-90deg) !important;\r\n        }\r\n      }\r\n    }\r\n\r\n    .navbar-nav {\r\n      .nav-item {\r\n        .nav-link[data-bs-toggle=\"collapse\"] {\r\n          &:after {\r\n            transform: rotate(-180deg) !important;\r\n          }\r\n        }\r\n      }\r\n    }\r\n  }\r\n}\r\n","//\r\n// _two-column.scss\r\n// \r\n\r\n[data-layout=\"twocolumn\"] {\r\n    .app-menu {\r\n        padding-bottom: 0;\r\n        width: $twocolumn-menu-width;\r\n        left: $twocolumn-menu-iconview-width;\r\n\r\n        .menu-link {\r\n            letter-spacing: .05em;\r\n            cursor: default;\r\n            font-size: 11px;\r\n            text-transform: uppercase;\r\n            color: $vertical-menu-title-color !important;\r\n            font-weight: $font-weight-semibold;\r\n\r\n            &:after {\r\n                display: none !important;\r\n            }\r\n\r\n            i {\r\n                display: none;\r\n            }\r\n        }\r\n\r\n        .navbar-nav {\r\n            height: calc(100vh - #{$header-height});\r\n            @media (max-width: 767.98px) {\r\n                padding-top: 16px;\r\n            }\r\n            \r\n            > li:not(.twocolumn-item-show) {\r\n                display: none;\r\n            }\r\n\r\n            .twocolumn-item-show {\r\n                >div {\r\n                    display: block !important;\r\n                    height: auto !important;\r\n                }\r\n            }\r\n\r\n            > .nav-item {\r\n                > .menu-dropdown {\r\n                    display: block !important;\r\n                    height: auto !important;\r\n                }\r\n            }\r\n\r\n            .nav-item{\r\n                .menu-dropdown{\r\n                    .row{\r\n                        margin: 0;\r\n                        .col-lg-4{\r\n                            width: 100%;\r\n                            padding: 0;\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n\r\n            .nav-sm{\r\n                .nav-link{\r\n                    color: $vertical-menu-item-color;\r\n                    \r\n                    &.active{\r\n                        color: $vertical-menu-item-active-color;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n\r\n        .container-fluid{\r\n            padding: 0;\r\n        }\r\n    }\r\n\r\n    .main-content {\r\n        margin-left: calc(#{$twocolumn-menu-width} + #{$twocolumn-menu-iconview-width});\r\n        @media (max-width:767.98px) {\r\n            margin-left: $twocolumn-menu-iconview-width;\r\n        }\r\n    }\r\n\r\n    .twocolumn-iconview {\r\n        width: $twocolumn-menu-iconview-width;\r\n        background-color: $twocolumn-menu-iconview-bg;\r\n        height: 100%;\r\n        left: -$twocolumn-menu-iconview-width;\r\n        box-shadow: $twocolumn-menu-box-shadow;\r\n        top: 0;\r\n        position: absolute;\r\n        padding: 0;\r\n        text-align: center;\r\n        li{\r\n            position: relative;\r\n            list-style: none;\r\n            .nav-icon{\r\n                &::after{\r\n                    content: \"\";\r\n                    position: absolute;\r\n                    top: 0;\r\n                    right: 0;\r\n                    bottom: 0;\r\n                    left: 0;\r\n                }\r\n            }\r\n        }\r\n\r\n        .nav-icon {\r\n            width: 42px;\r\n            height: 42px;\r\n            line-height: 42px;\r\n            color: $vertical-menu-item-color;\r\n            z-index: 1;\r\n            font-size: 22px;\r\n            text-align: center;\r\n            border-radius: 3px;\r\n            margin: 5px 0;\r\n            display: inline-flex;\r\n            justify-content: center;\r\n            align-items: center;\r\n\r\n            .icon-dual {\r\n                width: 18px;\r\n                color:  $vertical-menu-item-color;\r\n            }\r\n\r\n            &.active {\r\n                background-color: rgba($primary, 0.15);\r\n                color: $primary;\r\n\r\n                .icon-dual {\r\n                    color: $primary;\r\n                    fill: rgba($primary , 0.10);\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    .menu-title {\r\n        display: none;\r\n    }\r\n\r\n    @media (max-width: 991.98px) {\r\n        .logo {\r\n    \r\n            span.logo-lg {\r\n                display: block;\r\n            }\r\n    \r\n            span.logo-sm {\r\n                display: none;\r\n            }\r\n        }\r\n    }\r\n\r\n    &[data-sidebar=\"light\"]{\r\n        .app-menu{\r\n            .navbar-brand-box{\r\n                .logo-light{\r\n                    display: none;\r\n                }\r\n\r\n                .logo-dark{\r\n                    display: block;\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    &[data-sidebar=\"dark\"]{\r\n        .twocolumn-iconview{\r\n            background-color: $twocolumn-menu-iconview-bg-dark;\r\n            .nav-icon{\r\n                color: $twocolumn-menu-item-color-dark;\r\n                &.active{\r\n                    color: $twocolumn-menu-item-active-color-dark;\r\n                    background-color: $twocolumn-menu-item-active-bg-dark;\r\n                }\r\n            }\r\n        }\r\n\r\n        .app-menu{\r\n            background-color: $twocolumn-menu-bg-dark;\r\n            border-right-color: $twocolumn-menu-border-dark;\r\n            .navbar-brand-box{\r\n                .logo-light{\r\n                    display: block;\r\n                }\r\n\r\n                .logo-dark{\r\n                    display: none;\r\n                }\r\n            }\r\n\r\n            .navbar-nav{\r\n                .nav-sm{\r\n                    .nav-link{\r\n                        color: $twocolumn-menu-item-color-dark;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n\r\n        .navbar-menu{\r\n            .navbar-nav{\r\n                .nav-sm{\r\n                    .nav-link{\r\n                        &:hover, &.active{\r\n                            color: $twocolumn-menu-item-active-color-dark;\r\n                            &::before{\r\n                                background-color: $twocolumn-menu-item-active-color-dark !important;\r\n                            }\r\n                        }\r\n                    }\r\n                }\r\n                .nav-link {\r\n                    &[data-bs-toggle=collapse][aria-expanded=true]{\r\n                        color: $twocolumn-menu-item-active-color-dark;\r\n                        &:before{\r\n                            background-color: $twocolumn-menu-item-active-color-dark;\r\n                        }\r\n                        &::after{\r\n                            color: $twocolumn-menu-item-active-color-dark !important;\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    .twocolumn-panel{\r\n        .app-menu {\r\n            width:0;\r\n            @media (max-width: 575.98px) {\r\n                display: none;\r\n            }\r\n        }\r\n        .navbar-brand-box, .navbar-nav {\r\n            display: none;\r\n        }\r\n\r\n        .main-content{\r\n            margin-left: $twocolumn-menu-iconview-width;\r\n        }\r\n\r\n        #page-topbar, .footer{\r\n            left: $twocolumn-menu-iconview-width;\r\n        }\r\n        @media (max-width: 575.98px) {\r\n            .main-content{\r\n                margin-left: 0;\r\n            }\r\n    \r\n            #page-topbar, .footer{\r\n                left: 0;\r\n            }\r\n        }\r\n        \r\n    }\r\n\r\n    #page-topbar, .footer{\r\n        @media (max-width: 767.98px){\r\n            left: $twocolumn-menu-iconview-width;\r\n        }\r\n    }\r\n    @media (max-width: 575.98px) {\r\n        .main-content{\r\n            margin-left: 0;\r\n        }\r\n\r\n        #page-topbar, .footer{\r\n            left: 0;\r\n        }\r\n    }\r\n}\r\n\r\n","// \r\n// _layouts.scss\r\n// \r\n\r\n[data-layout-width=\"boxed\"] {\r\n    body{\r\n        background-color: $boxed-body-bg;\r\n    }\r\n    \r\n    #layout-wrapper {\r\n        max-width: $boxed-layout-width;\r\n        margin: 0 auto;\r\n        box-shadow: $box-shadow;\r\n        background-color: var(--#{$variable-prefix}body-bg);\r\n    }\r\n\r\n    &[data-layout=\"vertical\"]{\r\n        #layout-wrapper {\r\n            min-height: 100vh;\r\n        }\r\n    }\r\n\r\n    #page-topbar, .footer {\r\n        max-width: $boxed-layout-width;\r\n        margin: 0 auto;\r\n        left: 0 !important;\r\n    }\r\n\r\n    &[data-sidebar-size=\"sm-hover\"], &[data-sidebar-size=\"sm\"] {\r\n        &[data-layout=\"vertical\"]{\r\n            @media (min-width: 768px){\r\n                #layout-wrapper {\r\n                    min-height: 1400px;\r\n                }\r\n            }\r\n\r\n            .main-content{\r\n                @media (max-width: 767.98px) {\r\n                    margin-left: 0;\r\n                }\r\n            }\r\n        }\r\n        \r\n        #page-topbar, .footer {\r\n            left: 0 !important;\r\n            max-width: calc(#{$boxed-layout-width} - #{$vertical-menu-width-sm});\r\n            @media (min-width: 768px){\r\n                left: $vertical-menu-width-sm !important;\r\n            }\r\n        }\r\n    }\r\n    &[data-sidebar-size=\"sm-hover-active\"],\r\n    &[data-sidebar-size=\"lg\"] {\r\n        #page-topbar, .footer {\r\n            max-width: calc(#{$boxed-layout-width} - #{$vertical-menu-width});\r\n            \r\n            @media (min-width: 768px){\r\n                left: $vertical-menu-width !important;\r\n            }\r\n        }\r\n    }\r\n\r\n    &[data-sidebar-size=\"md\"] {\r\n        #page-topbar, .footer {\r\n            max-width: calc(#{$boxed-layout-width} - #{$vertical-menu-width-md});\r\n            @media (min-width: 768px){\r\n                left: $vertical-menu-width-md !important;\r\n            }\r\n        }\r\n    }\r\n\r\n    // deteched\r\n    \r\n    &[data-layout=vertical][data-layout-style=detached]{\r\n        body{\r\n            background-color: var(--#{$variable-prefix}body-bg);\r\n        }\r\n        \r\n        @media (min-width: 1024.1px){\r\n            #layout-wrapper{\r\n                max-width: 1300px;\r\n                box-shadow: none;\r\n            }\r\n\r\n            .layout-width{\r\n                max-width: 1300px;\r\n            }\r\n        }\r\n\r\n        &[data-sidebar-size=\"sm-hover\"], &[data-sidebar-size=\"sm\"], &[data-sidebar-size=\"md\"], &[data-sidebar-size=\"lg\"] {\r\n            #page-topbar, .footer {\r\n                max-width: 100%;\r\n                left: 0 !important;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n// Horizontal Boxed Layout\r\n\r\n[data-layout=\"horizontal\"][data-layout-width=\"boxed\"]{\r\n    #page-topbar, #layout-wrapper, .footer {\r\n        max-width: 100%;\r\n    }\r\n    .container-fluid, .navbar-header {\r\n        max-width: $boxed-layout-width;\r\n    }\r\n    .navbar-header {\r\n        padding: 0 calc(#{$grid-gutter-width} / 2) 0 0;\r\n    }\r\n    &[data-sidebar-size=\"sm-hover\"], &[data-sidebar-size=\"sm\"] &[data-sidebar-size=\"sm-hover-active\"],\r\n    &[data-sidebar-size=\"lg\"] {\r\n        #page-topbar, .footer {\r\n            left: 0 !important;\r\n        }\r\n    }\r\n}\r\n\r\n// Scrollable layout\r\n\r\n[data-layout-position=\"scrollable\"] {\r\n    @media (min-width: 992px) {\r\n        #page-topbar, .navbar-menu{\r\n            position: absolute;\r\n        }\r\n    }\r\n\r\n    &[data-layout=\"horizontal\"]{\r\n        @media (min-width: 992px) {\r\n            #page-topbar, .topnav{\r\n                position: absolute;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n","\r\n/*!\r\n * Waves v0.7.6\r\n * http://fian.my.id/Waves \r\n * \r\n * Copyright 2014-2018 Alfiana E. Sibuea and other contributors \r\n * Released under the MIT license \r\n * https://github.com/fians/Waves/blob/master/LICENSE */\r\n .waves-effect {\r\n    position: relative;\r\n    cursor: pointer;\r\n    display: inline-block;\r\n    overflow: hidden;\r\n    -webkit-user-select: none;\r\n    -moz-user-select: none;\r\n    -ms-user-select: none;\r\n    user-select: none;\r\n    -webkit-tap-highlight-color: transparent;\r\n  }\r\n  .waves-effect .waves-ripple {\r\n    position: absolute;\r\n    border-radius: 50%;\r\n    width: 100px;\r\n    height: 100px;\r\n    margin-top: -50px;\r\n    margin-left: -50px;\r\n    opacity: 0;\r\n    background: rgba(0, 0, 0, 0.2);\r\n    background: -webkit-radial-gradient(rgba(0, 0, 0, 0.2) 0, rgba(0, 0, 0, 0.3) 40%, rgba(0, 0, 0, 0.4) 50%, rgba(0, 0, 0, 0.5) 60%, rgba(255, 255, 255, 0) 70%);\r\n    background: -o-radial-gradient(rgba(0, 0, 0, 0.2) 0, rgba(0, 0, 0, 0.3) 40%, rgba(0, 0, 0, 0.4) 50%, rgba(0, 0, 0, 0.5) 60%, rgba(255, 255, 255, 0) 70%);\r\n    background: -moz-radial-gradient(rgba(0, 0, 0, 0.2) 0, rgba(0, 0, 0, 0.3) 40%, rgba(0, 0, 0, 0.4) 50%, rgba(0, 0, 0, 0.5) 60%, rgba(255, 255, 255, 0) 70%);\r\n    background: radial-gradient(rgba(0, 0, 0, 0.2) 0, rgba(0, 0, 0, 0.3) 40%, rgba(0, 0, 0, 0.4) 50%, rgba(0, 0, 0, 0.5) 60%, rgba(255, 255, 255, 0) 70%);\r\n    -webkit-transition: all 0.5s ease-out;\r\n    -moz-transition: all 0.5s ease-out;\r\n    -o-transition: all 0.5s ease-out;\r\n    transition: all 0.5s ease-out;\r\n    -webkit-transition-property: -webkit-transform, opacity;\r\n    -moz-transition-property: -moz-transform, opacity;\r\n    -o-transition-property: -o-transform, opacity;\r\n    transition-property: transform, opacity;\r\n    -webkit-transform: scale(0) translate(0, 0);\r\n    -moz-transform: scale(0) translate(0, 0);\r\n    -ms-transform: scale(0) translate(0, 0);\r\n    -o-transform: scale(0) translate(0, 0);\r\n    transform: scale(0) translate(0, 0);\r\n    pointer-events: none;\r\n  }\r\n  .waves-effect.waves-light .waves-ripple {\r\n    background: rgba(255, 255, 255, 0.4);\r\n    background: -webkit-radial-gradient(rgba(255, 255, 255, 0.2) 0, rgba(255, 255, 255, 0.3) 40%, rgba(255, 255, 255, 0.4) 50%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0) 70%);\r\n    background: -o-radial-gradient(rgba(255, 255, 255, 0.2) 0, rgba(255, 255, 255, 0.3) 40%, rgba(255, 255, 255, 0.4) 50%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0) 70%);\r\n    background: -moz-radial-gradient(rgba(255, 255, 255, 0.2) 0, rgba(255, 255, 255, 0.3) 40%, rgba(255, 255, 255, 0.4) 50%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0) 70%);\r\n    background: radial-gradient(rgba(255, 255, 255, 0.2) 0, rgba(255, 255, 255, 0.3) 40%, rgba(255, 255, 255, 0.4) 50%, rgba(255, 255, 255, 0.5) 60%, rgba(255, 255, 255, 0) 70%);\r\n  }\r\n  .waves-effect.waves-classic .waves-ripple {\r\n    background: rgba(0, 0, 0, 0.2);\r\n  }\r\n  .waves-effect.waves-classic.waves-light .waves-ripple {\r\n    background: rgba(255, 255, 255, 0.4);\r\n  }\r\n  .waves-notransition {\r\n    -webkit-transition: none !important;\r\n    -moz-transition: none !important;\r\n    -o-transition: none !important;\r\n    transition: none !important;\r\n  }\r\n  .waves-button,\r\n  .waves-circle {\r\n    -webkit-transform: translateZ(0);\r\n    -moz-transform: translateZ(0);\r\n    -ms-transform: translateZ(0);\r\n    -o-transform: translateZ(0);\r\n    transform: translateZ(0);\r\n    -webkit-mask-image: -webkit-radial-gradient(circle, white 100%, black 100%);\r\n  }\r\n  .waves-button,\r\n  .waves-button:hover,\r\n  .waves-button:visited,\r\n  .waves-button-input {\r\n    white-space: nowrap;\r\n    vertical-align: middle;\r\n    cursor: pointer;\r\n    border: none;\r\n    outline: none;\r\n    color: inherit;\r\n    background-color: rgba(0, 0, 0, 0);\r\n    font-size: 1em;\r\n    line-height: 1em;\r\n    text-align: center;\r\n    text-decoration: none;\r\n    z-index: 1;\r\n  }\r\n  .waves-button {\r\n    padding: 0.85em 1.1em;\r\n    border-radius: 0.2em;\r\n  }\r\n  .waves-button-input {\r\n    margin: 0;\r\n    padding: 0.85em 1.1em;\r\n  }\r\n  .waves-input-wrapper {\r\n    border-radius: 0.2em;\r\n    vertical-align: bottom;\r\n  }\r\n  .waves-input-wrapper.waves-button {\r\n    padding: 0;\r\n  }\r\n  .waves-input-wrapper .waves-button-input {\r\n    position: relative;\r\n    top: 0;\r\n    left: 0;\r\n    z-index: 1;\r\n  }\r\n  .waves-circle {\r\n    text-align: center;\r\n    width: 2.5em;\r\n    height: 2.5em;\r\n    line-height: 2.5em;\r\n    border-radius: 50%;\r\n  }\r\n  .waves-float {\r\n    -webkit-mask-image: none;\r\n    -webkit-box-shadow: 0px 1px 1.5px 1px rgba(0, 0, 0, 0.12);\r\n    box-shadow: 0px 1px 1.5px 1px rgba(0, 0, 0, 0.12);\r\n    -webkit-transition: all 300ms;\r\n    -moz-transition: all 300ms;\r\n    -o-transition: all 300ms;\r\n    transition: all 300ms;\r\n  }\r\n  .waves-float:active {\r\n    -webkit-box-shadow: 0px 8px 20px 1px rgba(0, 0, 0, 0.3);\r\n    box-shadow: 0px 8px 20px 1px rgba(0, 0, 0, 0.3);\r\n  }\r\n  .waves-block {\r\n    display: block;\r\n  }\r\n\r\n.waves-effect.waves-light {\r\n    .waves-ripple {\r\n        background-color: rgba($white, 0.4);\r\n    }\r\n}\r\n\r\n.waves-effect.waves-primary {\r\n    .waves-ripple {\r\n        background-color: rgba($primary, 0.4);\r\n    }\r\n}\r\n.waves-effect.waves-success {\r\n    .waves-ripple {\r\n        background-color: rgba($success, 0.4);\r\n    }\r\n}\r\n.waves-effect.waves-info {\r\n    .waves-ripple {\r\n        background-color: rgba($info, 0.4);\r\n    }\r\n}\r\n.waves-effect.waves-warning {\r\n    .waves-ripple {\r\n        background-color: rgba($warning, 0.4);\r\n    }\r\n}\r\n.waves-effect.waves-danger {\r\n    .waves-ripple {\r\n        background-color: rgba($danger, 0.4);\r\n    }\r\n}","//\r\n// avatar.scss\r\n//\r\n\r\n.avatar-xxs {\r\n    height: 1.5rem;\r\n    width: 1.5rem;\r\n}\r\n\r\n.avatar-xs {\r\n    height: 2rem;\r\n    width: 2rem;\r\n}\r\n\r\n.avatar-sm {\r\n    height: 3rem;\r\n    width: 3rem;\r\n}\r\n\r\n.avatar-md {\r\n    height: 4.5rem;\r\n    width: 4.5rem;\r\n}\r\n\r\n.avatar-lg {\r\n    height: 6rem;\r\n    width: 6rem;\r\n}\r\n\r\n.avatar-xl {\r\n    height: 7.5rem;\r\n    width: 7.5rem;\r\n}\r\n\r\n.avatar-title {\r\n    align-items: center;\r\n    background-color: $primary;\r\n    color: $white;\r\n    display: flex;\r\n    font-weight: $font-weight-medium;\r\n    height: 100%;\r\n    justify-content: center;\r\n    width: 100%;\r\n}\r\n\r\n// avatar group\r\n.avatar-group {\r\n    padding-left: 12px;\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n\r\n    .avatar-group-item {\r\n        margin-left: -12px;\r\n        border: 2px solid $card-bg;\r\n        border-radius: 50%;\r\n        transition: all 0.2s;\r\n\r\n        &:hover {\r\n            position: relative;\r\n            transform: translateY(-2px);\r\n            z-index: 1;\r\n        }\r\n    }\r\n}","//\r\n// accordion.scss\r\n//\r\n\r\n.accordion {\r\n    .accordion-button {\r\n        font-weight: $font-weight-medium;\r\n    }\r\n\r\n    .accordion-body {\r\n        color: $text-muted;\r\n    }\r\n\r\n    &.accordion-icon-none {\r\n        .accordion-button {\r\n            &::after {\r\n                content: \"\";\r\n                background-image: none !important;\r\n            }\r\n\r\n            &:not(.collapsed) {\r\n                &::after {\r\n                    content: \"\";\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n// Accordion with icon\r\n\r\n.custom-accordionwithicon {\r\n    .accordion-button {\r\n        &::after {\r\n            background-image: none !important;\r\n            font-family: \"Material Design Icons\";\r\n            content: \"\\F0142\";\r\n            font-size: 1.1rem;\r\n            vertical-align: middle;\r\n            line-height: 0.8;\r\n        }\r\n\r\n        &:not(.collapsed) {\r\n            &::after {\r\n                background-image: none !important;\r\n                content: \"\\F0140\";\r\n                margin-right: -3px;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n// Accordion with plus icon\r\n\r\n.custom-accordionwithicon-plus {\r\n    .accordion-button {\r\n        &::after {\r\n            background-image: none !important;\r\n            font-family: \"Material Design Icons\";\r\n            content: \"\\F0415\";\r\n            font-size: 1.1rem;\r\n            vertical-align: middle;\r\n            line-height: 0.8;\r\n        }\r\n\r\n        &:not(.collapsed) {\r\n            &::after {\r\n                background-image: none !important;\r\n                content: \"\\F0374\";\r\n                margin-right: -3px;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n\r\n// left Icon accordion\r\n\r\n.lefticon-accordion {\r\n    .accordion-button {\r\n        padding-left: 2.75rem;\r\n\r\n        &::after {\r\n            position: absolute;\r\n            left: $accordion-button-padding-x;\r\n            top: 14px;\r\n        }\r\n\r\n        &:not(.collapsed) {\r\n            &::after {\r\n                top: 20px;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n// border accordion\r\n\r\n.accordion-border-box {\r\n    .accordion-item {\r\n        border-top: $accordion-border-width solid $accordion-border-color;\r\n        border-radius: $accordion-border-radius;\r\n\r\n        &:not(:first-of-type) {\r\n            margin-top: 8px;\r\n        }\r\n\r\n        .accordion-button {\r\n            border-radius: $accordion-border-radius;\r\n\r\n            &:not(.collapsed) {\r\n                border-bottom-left-radius: 0;\r\n                border-bottom-right-radius: 0;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.custom-accordion-border {\r\n    .accordion-item {\r\n        border-left: 3px solid $accordion-border-color;\r\n    }\r\n}\r\n\r\n//accordion Color \r\n\r\n@each $color,\r\n$value in $theme-colors {\r\n    .accordion-#{$color} {\r\n        .accordion-item {\r\n            border-color: rgba($value, 0.6);\r\n\r\n            .accordion-button {\r\n                box-shadow: none;\r\n\r\n                &:not(.collapsed) {\r\n                    color: $value;\r\n                    background-color: rgba($value, 0.1) !important;\r\n                }\r\n\r\n                &::after {\r\n                    color: $value;\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    .accordion-fill-#{$color} {\r\n        .accordion-item {\r\n            .accordion-button {\r\n                box-shadow: none;\r\n\r\n                &:not(.collapsed) {\r\n                    color: $white;\r\n                    background-color: $value !important;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n\r\n// theme dark\r\n\r\n[data-layout-mode=\"dark\"]{\r\n    .accordion-button {\r\n        &:not(.collapsed) {\r\n            color: var(--#{$variable-prefix}accordion-button-active-color);\r\n            &:after{\r\n                background-image: escape-svg(url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$white}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\"));\r\n            }\r\n        }\r\n\r\n        &:after{\r\n            background-image: escape-svg(url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='#{$gray-500}'><path fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/></svg>\"));\r\n        }\r\n    }\r\n}\r\n\r\n// rtl\r\n[dir=\"rtl\"]{\r\n    .custom-accordionwithicon {\r\n        .accordion-button::after{\r\n            transform: rotate(180deg);\r\n        }\r\n    }\r\n}","//\r\n// _helper.scss\r\n//\r\n\r\n$font-size-mixing: 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 36, 48;\r\n\r\n@each $font-size-mixing in $font-size-mixing {\r\n  .fs-#{$font-size-mixing} {\r\n    font-size: #{$font-size-mixing}px !important;\r\n  }\r\n}\r\n\r\n// border-color\r\n.border-dark {\r\n    border-color: var(--#{$variable-prefix}dark)!important;\r\n}\r\n.border-light {\r\n    border-color: var(--#{$variable-prefix}light)!important;\r\n}\r\n\r\n// Border Style\r\n$border-style-mixing: double, dashed, groove, outset, ridge, dotted, inset;\r\n@each $border-style-mixing in $border-style-mixing {\r\n    .border-#{$border-style-mixing} {\r\n        border-style: #{$border-style-mixing} !important;\r\n    }\r\n    .border-top-#{$border-style-mixing} {\r\n        border-top-style: #{$border-style-mixing} !important;\r\n    }\r\n    .border-bottom-#{$border-style-mixing} {\r\n        border-bottom-style: #{$border-style-mixing} !important;\r\n    }\r\n    .border-end-#{$border-style-mixing} {\r\n        border-right-style: #{$border-style-mixing} !important;\r\n    }\r\n    .border-start-#{$border-style-mixing} {\r\n        border-left-style: #{$border-style-mixing} !important;\r\n    }\r\n    \r\n    // List Group Flush Style\r\n    .list-group-flush {\r\n        &.border-#{$border-style-mixing} { \r\n            border: none !important;\r\n            .list-group-item {\r\n                border-style: #{$border-style-mixing} !important;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n//link\r\n[data-layout-mode=\"dark\"]{\r\n    .link-dark, .link-light{\r\n        color: var(--#{$variable-prefix}dark);\r\n        &:focus, &:hover{\r\n            color: rgba(var(--#{$variable-prefix}dark-rgb), 0.75);\r\n        }\r\n    }\r\n}\r\n\r\n\r\n#back-to-top {\r\n    position: fixed;\r\n    bottom: 100px;\r\n    right: 28px;\r\n    transition: all 0.5s ease;\r\n    display: none;\r\n    z-index: 1000;\r\n    &:hover {\r\n        animation: fade-up 1.5s infinite linear;\r\n    }\r\n}\r\n\r\n\r\n// Font Family\r\n\r\n.ff-base {\r\n    font-family: $font-family-base;\r\n}\r\n\r\n.ff-secondary {\r\n    font-family: $font-family-secondary;\r\n}\r\n\r\n// Font weight help class\r\n\r\n.fw-medium {\r\n    font-weight: $font-weight-medium;\r\n}\r\n\r\n.fw-semibold {\r\n    font-weight: $font-weight-semibold !important;\r\n}\r\n\r\n// Flex\r\n\r\n.flex-1 {\r\n    flex: 1;\r\n}\r\n\r\n// Social\r\n\r\n.social-list-item {\r\n    height: 2rem;\r\n    width: 2rem;\r\n    line-height: calc(2rem - 4px);\r\n    display: block;\r\n    border: 2px solid $gray-500;\r\n    border-radius: 50%;\r\n    color: $gray-500;\r\n    text-align: center;\r\n    transition: all 0.4s;\r\n\r\n    &:hover {\r\n        color: $gray-600;\r\n        background-color: $gray-200;\r\n    }\r\n}\r\n\r\n\r\n// Backgroun pattern\r\n.bg-pattern {\r\n    background: url(\"../../images/modal-bg.png\") $modal-content-bg;\r\n}\r\n\r\n// Fixed minimum width\r\n.w-xs {\r\n    min-width: 80px;\r\n}\r\n\r\n.w-sm {\r\n    min-width: 95px;\r\n}\r\n\r\n.w-md {\r\n    min-width: 110px;\r\n}\r\n\r\n.w-lg {\r\n    min-width: 140px;\r\n}\r\n\r\n.w-xl {\r\n    min-width: 160px;\r\n}\r\n\r\n// Icons Sizes\r\n.icon-xs {\r\n    height: 16px;\r\n    width: 16px;\r\n}\r\n\r\n.icon-sm {\r\n    height: 18px;\r\n    width: 18px;\r\n}\r\n\r\n.icon-md {\r\n    height: 22px;\r\n    width: 22px;\r\n}\r\n\r\n.icon-lg {\r\n    height: 24px;\r\n    width: 24px;\r\n}\r\n\r\n.icon-xl {\r\n    height: 28px;\r\n    width: 28px;\r\n}\r\n\r\n.icon-xxl {\r\n    height: 32px;\r\n    width: 32px;\r\n}\r\n\r\n// Dual Icons\r\n.icon-dual {\r\n    color: $gray-500;\r\n    fill: rgba($gray-500,0.16);\r\n}\r\n\r\n@each $color,\r\n$value in $theme-colors {\r\n    .icon-dual-#{$color} {\r\n        color: $value;\r\n        fill: rgba($value, 0.16);\r\n    }\r\n}\r\n\r\n// Search \r\n.search-box{\r\n    position: relative;\r\n    .form-control{\r\n        padding-left: 40px;\r\n    }\r\n    .search-icon{\r\n        font-size: 14px;\r\n        position: absolute;\r\n        left: 13px;\r\n        top: 0;\r\n        height: 100%;\r\n        display: flex;\r\n        align-items: center;\r\n        color: $text-muted;\r\n    }\r\n}\r\n\r\n\r\n// overlay\r\n\r\n.bg-overlay {\r\n    position: absolute;\r\n    height: 100%;\r\n    width: 100%;\r\n    right: 0;\r\n    bottom: 0;\r\n    left: 0;\r\n    top: 0;\r\n    opacity: 0.7;\r\n    background-color: $white;\r\n}\r\n\r\n// Btn Customizer\r\n\r\n.customizer-setting {\r\n    position: fixed;\r\n    bottom: 40px;\r\n    right: 20px;\r\n    z-index: 1000;\r\n}\r\n\r\n// \r\ncode {\r\n    user-select: all;\r\n}\r\n\r\n.layout-rightside {\r\n    width: 280px;\r\n    margin-right: -#{$grid-gutter-width};\r\n    margin-top: calc(1px - #{$grid-gutter-width});\r\n    height: calc(100% + #{$grid-gutter-width});\r\n}\r\n\r\n.layout-rightside-col {\r\n\r\n    @media (max-width: 1699.98px) { \r\n        display: none;\r\n        position: fixed !important;\r\n        height: 100vh;\r\n        right: 0px;\r\n        top: 0px;\r\n        bottom: 0px;\r\n        z-index: 1004;\r\n        .overlay{\r\n            position: fixed;\r\n            top: 0;\r\n            right: 0px;\r\n            bottom: 0px;\r\n            left: 0px;\r\n            background-color: rgba($dark, 0.2);\r\n           \r\n        }\r\n        .layout-rightside {\r\n            margin-top: 0px;\r\n            height: 100%;\r\n            margin-left: auto;\r\n        }\r\n        .card-body {\r\n            overflow-y: auto;\r\n            padding-bottom: 1rem !important;\r\n        }\r\n    }\r\n}\r\n\r\n[data-layout=\"horizontal\"], [data-layout-style=detached]{\r\n    @media (min-width: 1700px) {\r\n        .layout-rightside{\r\n            margin-top: calc(28px - #{$grid-gutter-width});\r\n            margin-right: 0;\r\n            height: calc(100% - calc(#{$grid-gutter-width} / 5));\r\n        }\r\n    }\r\n}\r\n\r\n// object fit cover\r\n.object-cover{\r\n    object-fit: cover;\r\n}\r\n\r\n// text-truncate-two-lines\r\n.text-truncate-two-lines{\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    -webkit-line-clamp: 2;\r\n    display: -webkit-box;\r\n    -webkit-box-orient: vertical;\r\n    white-space: normal;\r\n}\r\n\r\n// Favourite button \r\n.favourite-btn{\r\n    .ri-star-fill{\r\n        color: $text-muted;\r\n    }\r\n    &.active{\r\n        .ri-star-fill{\r\n            color: $warning;\r\n            \r\n            &:before{\r\n                content: \"\\f186\";\r\n            }\r\n        }\r\n    }\r\n}\r\n// card\r\n.card-logo-light{\r\n    display: var(--#{$variable-prefix}card-logo-light);\r\n}\r\n\r\n.card-logo-dark{\r\n    display: var(--#{$variable-prefix}card-logo-dark);\r\n}\r\n\r\n[data-layout-mode=\"dark\"]{\r\n    .btn-close{\r\n        filter: invert(1) grayscale(100%) brightness(200%);\r\n    }\r\n}\r\n\r\n.cursor-pointer {\r\n    cursor: pointer;\r\n}","// \r\n// preloader.scss\r\n//\r\n\r\n#preloader {\r\n    position: fixed;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    background-color: $card-bg;\r\n    z-index: 9999;\r\n}\r\n\r\n#status {\r\n    width: 40px;\r\n    height: 40px;\r\n    position: absolute;\r\n    left: 50%;\r\n    top: 50%;\r\n    margin: -20px 0 0 -20px;\r\n}\r\n\r\n.spinner-chase {\r\n    margin: 0 auto;\r\n    width: 40px;\r\n    height: 40px;\r\n    position: relative;\r\n    animation: spinner-chase 2.5s infinite linear both;\r\n}\r\n\r\n.chase-dot {\r\n    width: 100%;\r\n    height: 100%;\r\n    position: absolute;\r\n    left: 0;\r\n    top: 0; \r\n    animation: chase-dot 2.0s infinite ease-in-out both; \r\n    &:before {\r\n        content: '';\r\n        display: block;\r\n        width: 25%;\r\n        height: 25%;\r\n        background-color: $primary;\r\n        border-radius: 100%;\r\n        animation: chase-dot-before 2.0s infinite ease-in-out both; \r\n    }\r\n\r\n    &:nth-child(1) { \r\n        animation-delay: -1.1s; \r\n        &:before{\r\n            animation-delay: -1.1s;\r\n        }\r\n    }\r\n    &:nth-child(2) { \r\n        animation-delay: -1.0s;\r\n        &:before{\r\n            animation-delay: -1.0s;\r\n        }\r\n    }\r\n    &:nth-child(3) { \r\n        animation-delay: -0.9s;\r\n        &:before{\r\n            animation-delay: -0.9s;\r\n        } \r\n    }\r\n    &:nth-child(4) { \r\n        animation-delay: -0.8s; \r\n        &:before{\r\n            animation-delay: -0.8s;\r\n        } \r\n    }\r\n    &:nth-child(5) { \r\n        animation-delay: -0.7s; \r\n        &:before{\r\n            animation-delay: -0.7s;\r\n        } \r\n    }\r\n    &:nth-child(6) { \r\n        animation-delay: -0.6s; \r\n        &:before{\r\n            animation-delay: -0.6s;\r\n        }\r\n    }\r\n}\r\n\r\n@keyframes spinner-chase {\r\n    100% { \r\n        transform: rotate(360deg); \r\n    } \r\n}\r\n\r\n@keyframes chase-dot {\r\n    80%, 100% { \r\n        transform: rotate(360deg); \r\n    } \r\n}\r\n\r\n@keyframes chase-dot-before {\r\n    50% {\r\n        transform: scale(0.4); \r\n    } \r\n    100%, 0% {\r\n        transform: scale(1.0); \r\n    } \r\n}","//\r\n// forms.scss\r\n//\r\n\r\n[type=\"tel\"],\r\n[type=\"url\"],\r\n[type=\"email\"],\r\n[type=\"number\"] {\r\n    &::placeholder {\r\n        text-align: left /*rtl: right*/;\r\n    }\r\n}\r\n","// \r\n// Widgets.scss\r\n// \r\n\r\n.main-chart {\r\n    .chart-border-left {\r\n        border-left: 1.4px solid $border-color;\r\n        padding: 2px 20px;\r\n\r\n        &:last-child {\r\n            margin-right: 0px;\r\n        }\r\n    }\r\n}\r\n\r\n\r\n\r\n/* Activity */\r\n\r\n.activity-feed {\r\n    list-style: none;\r\n\r\n    .feed-item {\r\n        position: relative;\r\n        padding-bottom: 27px;\r\n        padding-left: 16px;\r\n        border-left: 2px solid $light;\r\n\r\n        &:after {\r\n            content: \"\";\r\n            display: block;\r\n            position: absolute;\r\n            top: 4px;\r\n            left: -6px;\r\n            width: 10px;\r\n            height: 10px;\r\n            border-radius: 50%;\r\n            border: 2px solid $primary;\r\n            background-color: $card-bg;\r\n        }\r\n\r\n        &:last-child {\r\n            border-color: transparent;\r\n        }\r\n    }\r\n}\r\n\r\n// mini-stats-wid\r\n.mini-stats-wid {\r\n    position: relative;\r\n\r\n    .mini-stat-icon {\r\n        overflow: hidden;\r\n        position: relative;\r\n\r\n        &:before,\r\n        &:after {\r\n            content: \"\";\r\n            position: absolute;\r\n            width: 8px;\r\n            height: 69px;\r\n            background-color: rgba($success, .1);\r\n            left: 3px;\r\n            transform: rotate(32deg);\r\n            top: -8px;\r\n            transition: all 0.4s;\r\n        }\r\n\r\n        &::after {\r\n            left: 27px;\r\n            width: 8px;\r\n            transition: all 0.2s;\r\n        }\r\n    }\r\n\r\n    &:hover {\r\n        .mini-stat-icon {\r\n            &::after {\r\n                left: 60px;\r\n            }\r\n\r\n            &::before {\r\n                left: 50px;\r\n            }\r\n        }\r\n    }\r\n}","// \r\n// _demos.scss\r\n// \r\n\r\n// Buttons demo\r\n.button-items {\r\n    margin-left: -8px;\r\n    margin-bottom: -12px;\r\n\r\n    .btn {\r\n        margin-bottom: 12px;\r\n        margin-left: 8px;\r\n    }\r\n}\r\n\r\n// Modals\r\n.bs-example-modal {\r\n    position: relative;\r\n    top: auto;\r\n    right: auto;\r\n    bottom: auto;\r\n    left: auto;\r\n    z-index: 1;\r\n    display: block;\r\n}\r\n\r\n[dir=\"rtl\"] {\r\n    .modal-open {\r\n        padding-left: 0px !important;\r\n    }\r\n}\r\n\r\n// Icon demo ( Demo only )\r\n.icon-demo-content {\r\n    color: var(--#{$variable-prefix}gray-500);\r\n\r\n    i {\r\n        font-size: 24px;\r\n        margin-right: 10px;\r\n        color: var(--#{$variable-prefix}gray-600);\r\n        transition: all 0.4s;\r\n        vertical-align: middle;\r\n    }\r\n\r\n    svg {\r\n        margin-right: 10px;\r\n        transition: all 0.4s;\r\n        height: 20px;\r\n    }\r\n\r\n    .col-lg-4 {\r\n        margin-top: 24px;\r\n\r\n        &:hover {\r\n            i, svg {\r\n                color: $primary;\r\n                transform: scale(1.5);\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n// Grid\r\n\r\n.grid-structure {\r\n    .grid-container {\r\n        background-color: $gray-100;\r\n        margin-top: 10px;\r\n        font-size: .8rem;\r\n        font-weight: $font-weight-medium;\r\n        padding: 10px 20px;\r\n    }\r\n}\r\n\r\n[data-layout-mode=\"dark\"]{\r\n    .colorscheme-cardradio{\r\n        .form-check-label{\r\n            background-color: var(--#{$variable-prefix}dark);\r\n        }\r\n        .bg-light{\r\n            background-color: rgba(var(--#{$variable-prefix}light-rgb), 0.1)!important;\r\n        }\r\n\r\n        .bg-soft-light {\r\n            background-color: rgba(var(--#{$variable-prefix}dark-rgb),.1)!important;\r\n        }\r\n\r\n        .dark{\r\n            .bg-dark{\r\n                background-color: $card-bg!important;\r\n            }\r\n        }\r\n    }\r\n}","// \r\n// print.scss\r\n//\r\n\r\n// Used invoice page\r\n@media print {\r\n    .vertical-menu,\r\n    .right-bar,\r\n    .page-title-box,\r\n    .navbar-header,\r\n    .footer,\r\n    #back-to-top {\r\n      display: none !important;\r\n    }\r\n    .card-body,\r\n    .main-content,\r\n    .right-bar,\r\n    .page-content,\r\n    body {\r\n      padding: 0;\r\n      margin: 0;\r\n    }\r\n  \r\n    .card {\r\n      border: 0;\r\n    }\r\n  \r\n    .invoice-details {\r\n      .d-sm-flex {\r\n        display: flex !important;\r\n      }\r\n    }\r\n    .address {\r\n      &.col-sm-6 {\r\n        flex: 0 0 auto !important;\r\n        width: 50% !important;\r\n        max-width: 100% !important;\r\n      }\r\n    }\r\n  }","// \r\n// ribbons.scss\r\n//\r\n\r\n.ribbon-box {\r\n    position: relative;\r\n\r\n    .ribbon {\r\n        padding: 5px 12px;\r\n        box-shadow: 2px 5px 10px rgba($dark, 0.15);\r\n        color: $white;\r\n        font-size: $font-size-base;\r\n        font-weight: $font-weight-semibold;\r\n        position: absolute;\r\n        left: -1px;\r\n        top: 5px;\r\n\r\n        &.round-shape {\r\n            border-radius: 0 30px 30px 0;\r\n        }\r\n\r\n        &.ribbon-shape {\r\n            display: inline-block;\r\n\r\n            &::before {\r\n                content: \"\";\r\n                position: absolute;\r\n                right: -17px;\r\n                top: 0;\r\n                border: 14px solid transparent;\r\n            }\r\n\r\n            &::after {\r\n                content: \"\";\r\n                position: absolute;\r\n                right: -17px;\r\n                bottom: 0;\r\n                border: 14px solid transparent;\r\n            }\r\n        }\r\n\r\n    }\r\n\r\n    // ribbon circle\r\n    &.ribbon-circle {\r\n        .ribbon {\r\n            width: 48px;\r\n            height: 48px;\r\n            border-radius: 50%;\r\n            padding: 0;\r\n            display: flex;\r\n            align-items: center;\r\n            justify-content: center;\r\n            left: 20px;\r\n            top: 20px;\r\n        }\r\n    }\r\n\r\n    // ribbon fill\r\n\r\n    &.ribbon-fill {\r\n        overflow: hidden;\r\n            \r\n        .ribbon {\r\n            transform: rotate(-45deg);\r\n            width: 93px;\r\n            height: 52px;\r\n            left: -36px;\r\n            top: -16px;\r\n            display: flex;\r\n            justify-content: center;\r\n            align-items: flex-end;\r\n        }\r\n        &.ribbon-sm {\r\n            .ribbon {\r\n                padding: 2px 12px;\r\n                width: 78px;\r\n                height: 42px;\r\n                font-size: 12px;\r\n                box-shadow: none;\r\n            }\r\n        }\r\n    }\r\n\r\n    // right\r\n    &.right {\r\n        .ribbon {\r\n            position: absolute;\r\n            left: auto;\r\n            right: 0;\r\n\r\n            &.round-shape {\r\n                border-radius: 30px 0 0 30px;\r\n            }\r\n\r\n            &.ribbon-shape {\r\n                text-align: right;\r\n\r\n                &::before,\r\n                &::after {\r\n                    right: auto;\r\n                    left: -17px;\r\n                    border-left-color: transparent;\r\n                }\r\n            }\r\n        }\r\n\r\n        &.ribbon-circle {\r\n            .ribbon {\r\n                left: auto;\r\n                right: 20px;\r\n            }\r\n        }\r\n\r\n        .icon-ribbon {\r\n            right: 24px;\r\n            left: auto;\r\n        }\r\n\r\n        &.ribbon-fill {\r\n            .ribbon {\r\n                transform: rotate(45deg);\r\n                right: -38px;\r\n                left: auto;\r\n            }\r\n        }\r\n\r\n        &.ribbon-box {\r\n            .ribbon-two {\r\n                left: auto;\r\n                right: -5px;\r\n\r\n                span {\r\n                    left: auto;\r\n                    right: -21px;\r\n                    transform: rotate(45deg);\r\n                }\r\n            }\r\n        }\r\n\r\n    }\r\n\r\n    .ribbon-content {\r\n        clear: both;\r\n    }\r\n\r\n    @each $color,\r\n    $value in $theme-colors {\r\n        .ribbon-#{$color} {\r\n            background: ($value);\r\n\r\n            &:before {\r\n                border-color: darken(($value), 10%) transparent transparent;\r\n            }\r\n\r\n            &.ribbon-shape {\r\n                &::before {\r\n                    border-left-color: ($value);\r\n                    border-top-color: ($value);\r\n                }\r\n\r\n                &::after {\r\n                    border-left-color: ($value);\r\n                    border-bottom-color: ($value);\r\n                }\r\n            }\r\n        }\r\n\r\n        &.right {\r\n            .ribbon-#{$color} {\r\n                background: ($value);\r\n\r\n                &.ribbon-shape {\r\n                    &::before {\r\n                        border-right-color: ($value);\r\n                        border-top-color: ($value);\r\n                    }\r\n\r\n                    &::after {\r\n                        border-right-color: ($value);\r\n                        border-bottom-color: ($value);\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n\r\n    // Icon ribbon\r\n\r\n    .icon-ribbon {\r\n        box-shadow: none;\r\n        left: 24px;\r\n        top: -12px;\r\n        font-size: 40px;\r\n        padding: 0;\r\n    }\r\n\r\n\r\n    /* Ribbon two */\r\n    .ribbon-two {\r\n        position: absolute;\r\n        left: -5px;\r\n        top: -5px;\r\n        z-index: 1;\r\n        overflow: hidden;\r\n        width: 75px;\r\n        height: 75px;\r\n        text-align: right;\r\n\r\n        span {\r\n            font-size: 13px;\r\n            color: $white;\r\n            text-align: center;\r\n            line-height: 20px;\r\n            transform: rotate(-45deg);\r\n            width: 100px;\r\n            display: block;\r\n            box-shadow: 0 0 8px 0 rgba(0, 0, 0, 0.06), 0 1px 0 0 rgba(0, 0, 0, 0.02);\r\n            position: absolute;\r\n            top: 19px;\r\n            left: -21px;\r\n            font-weight: $font-weight-semibold;\r\n\r\n            &:before {\r\n                content: \"\";\r\n                position: absolute;\r\n                left: 0;\r\n                top: 100%;\r\n                z-index: -1;\r\n                border-right: 3px solid transparent;\r\n                border-bottom: 3px solid transparent;\r\n            }\r\n\r\n            &:after {\r\n                content: \"\";\r\n                position: absolute;\r\n                right: 0;\r\n                top: 100%;\r\n                z-index: -1;\r\n                border-left: 3px solid transparent;\r\n                border-bottom: 3px solid transparent;\r\n            }\r\n        }\r\n    }\r\n\r\n    @each $color,\r\n    $value in $theme-colors {\r\n        .ribbon-two-#{$color} {\r\n\r\n            span {\r\n                background: ($value);\r\n\r\n                &:before {\r\n                    border-left: 3px solid darken(($value), 15%);\r\n                    border-top: 3px solid darken(($value), 15%);\r\n                }\r\n\r\n                &:after {\r\n                    border-right: 3px solid darken(($value), 15%);\r\n                    border-top: 3px solid darken(($value), 15%);\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n}\r\n\r\n\r\n.ribbon-box {\r\n    &.right {\r\n        .ribbon-three {\r\n            position: absolute;\r\n            top: -6.1px;\r\n            right: 10px;\r\n            left: auto;\r\n        }\r\n    }\r\n}\r\n\r\n.ribbon-three {\r\n    position: absolute;\r\n    top: -6.1px;\r\n    left: 10px;\r\n\r\n    span {\r\n        position: relative;\r\n        display: block;\r\n        text-align: center;\r\n        color: $white;\r\n        font-size: 14px;\r\n        line-height: 1;\r\n        padding: 12px 8px 10px;\r\n        border-top-right-radius: 8px;\r\n        width: 90px;\r\n\r\n        &::after,\r\n        &::before {\r\n            position: absolute;\r\n            content: \"\";\r\n        }\r\n\r\n        &::before {\r\n            height: 6px;\r\n            width: 6px;\r\n            left: -6px;\r\n            top: 0;\r\n        }\r\n\r\n        &::after {\r\n            height: 6px;\r\n            width: 8px;\r\n            left: -8px;\r\n            top: 0;\r\n            border-radius: 8px 8px 0 0;\r\n        }\r\n    }\r\n\r\n    &::after {\r\n        position: absolute;\r\n        content: \"\";\r\n        width: 0;\r\n        height: 0;\r\n        border-left: 44px solid transparent;\r\n        border-right: 44px solid transparent;\r\n        border-top: 10px solid;\r\n    }\r\n}\r\n\r\n@each $color,\r\n$value in $theme-colors {\r\n    .ribbon-three-#{$color} {\r\n\r\n        span {\r\n            background: ($value);\r\n\r\n            &:before {\r\n                background: ($value);\r\n            }\r\n\r\n            &:after {\r\n                background: darken($value, 10%);\r\n            }\r\n        }\r\n\r\n        &::after {\r\n            border-top-color: ($value);\r\n        }\r\n    }\r\n}\r\n\r\n//Ribbon Hover\r\n.ribbon-box {\r\n    .trending-ribbon {\r\n        transform: translateX(-50px);\r\n        transition: all 0.5s ease;\r\n\r\n        .trending-ribbon-text {\r\n            transition: all 0.5s ease;\r\n            opacity: 0;\r\n        }\r\n    }\r\n\r\n    &:hover {\r\n        .trending-ribbon {\r\n            transform: translateX(0);\r\n\r\n            .trending-ribbon-text {\r\n                opacity: 1;\r\n            }\r\n        }\r\n    }\r\n    &.right {\r\n        .trending-ribbon {\r\n            transform: translateX(50px);\r\n            transition: all 0.5s ease;\r\n    \r\n            .trending-ribbon-text {\r\n                transition: all 0.5s ease;\r\n                opacity: 0;\r\n            }\r\n        }\r\n    \r\n        &:hover {\r\n            .trending-ribbon {\r\n                transform: translateX(0);\r\n    \r\n                .trending-ribbon-text {\r\n                    opacity: 1;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}","//\r\n// toast.scss\r\n//\r\n\r\n\r\n// toast\r\n.toast { \r\n    &:not(:last-child) {\r\n      margin-bottom: $toast-padding-x;\r\n    }\r\n}\r\n\r\n@mixin toast-border-variant($bg) {\r\n    .toast-body{\r\n        color: $bg;\r\n        border-bottom: 3px solid $bg;\r\n    }\r\n}\r\n\r\n@each $color, $value in $theme-colors {\r\n    .toast-border-#{$color} {\r\n        @include toast-border-variant($value);\r\n    }\r\n}","//\r\n// scrollspy.scss\r\n//\r\n\r\n// Scrollspy\r\n.scrollspy-example {\r\n  position: relative;\r\n  height: 200px;\r\n  margin-top: .5rem;\r\n  overflow: auto;\r\n}\r\n\r\n.scrollspy-example-2 {\r\n  position: relative;\r\n  height: 370px;\r\n  overflow: auto;\r\n}","// \r\n// reboot.scss\r\n//\r\n\r\nhtml {\r\n    position: relative;\r\n    min-height: 100%;\r\n}\r\n\r\n.h1,\r\n.h2,\r\n.h3,\r\n.h4,\r\n.h5,\r\n.h6,\r\nh1,\r\nh2,\r\nh3,\r\nh4,\r\nh5,\r\nh6 {\r\n    color: $heading-color;\r\n    font-family: $heading-font-family;\r\n}\r\n\r\na {\r\n    text-decoration: none !important;\r\n}\r\n\r\nlabel {\r\n    font-weight: $font-weight-medium;\r\n    margin-bottom: $form-label-margin-bottom;\r\n}\r\nb,\r\nstrong {\r\n  font-weight: $font-weight-semibold;\r\n}\r\n\r\n// blockquote\r\n\r\n.blockquote {\r\n    padding: 10px 20px;\r\n    border-left: 4px solid $gray-300;\r\n}\r\n\r\n.blockquote-reverse {\r\n    border-left: 0;\r\n    border-right: 4px solid $gray-300;\r\n    text-align: right;\r\n}\r\n\r\n// container\r\n\r\n.container,\r\n.container-lg,\r\n.container-md,\r\n.container-sm,\r\n.container-xl,\r\n.container-xxl {\r\n    @media (min-width: 1200px) {\r\n        max-width: 1140px;\r\n    }\r\n}\r\n\r\n// row\r\n.row>*{\r\n    position: relative;\r\n}\r\n\r\n// mixing\r\n\r\n@function set-color-from-background($color) {\r\n    @if (lightness($color) > 70) {\r\n        @return $color-contrast-dark;\r\n    }\r\n    @else {\r\n        @return $color-contrast-light;\r\n    }\r\n}","//\r\n// alerts.scss\r\n//\r\n\r\n// alert solid\r\n\r\n.alert-solid {\r\n    .alert-link {\r\n        color: $white;\r\n    }\r\n}\r\n\r\n// alert outline\r\n\r\n.alert-outline {\r\n    background-color: $card-bg;\r\n    border-width: 2px;\r\n}\r\n\r\n// alert borderless\r\n\r\n.alert-borderless {\r\n    border-width: 0;\r\n}\r\n\r\n// alert-label-icon\r\n\r\n.alert-label-icon {\r\n    position: relative;\r\n    padding-left: 60px;\r\n    border: 0;\r\n\r\n    .label-icon {\r\n        position: absolute;\r\n        width: 45px;\r\n        height: 100%;\r\n        left: 0;\r\n        top: 0;\r\n        background-color: rgba($white, 0.15);\r\n        font-size: 16px;\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n    }\r\n\r\n    // label arrow\r\n    &.label-arrow {\r\n        overflow: hidden;\r\n        .label-icon {\r\n            &:after {\r\n                content: \"\";\r\n                position: absolute;\r\n                border: 6px solid transparent;\r\n                border-left-color: $primary;\r\n                right: -12px;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n\r\n// Alert border left example\r\n\r\n.alert-border-left {\r\n    border-left: 3px solid;\r\n}\r\n\r\n// alert top border example\r\n\r\n.alert-top-border {\r\n    background-color: $card-bg;\r\n    border-color: $border-color;\r\n    border-top: 2px solid;\r\n    color: var(--#{$variable-prefix}body-color);\r\n}\r\n\r\n//alert additional example\r\n\r\n.alert-additional { \r\n    padding: 0;\r\n\r\n    .alert-body{\r\n        padding: $alert-padding-y $alert-padding-x;\r\n    }\r\n    .alert-content {\r\n        padding: $alert-padding-y $alert-padding-x;\r\n        border-bottom-left-radius: $alert-border-radius;\r\n        border-bottom-right-radius: $alert-border-radius;\r\n        margin: 0 (-$alert-border-width) (-$alert-border-width) (-$alert-border-width);\r\n    }\r\n}\r\n\r\n// rounded label example\r\n\r\n.rounded-label {\r\n    .label-icon {\r\n        width: 45px;\r\n        height: 26px;\r\n        left: 0px;\r\n        top: 50%;\r\n        transform: translateY(-50%);\r\n        border-radius: 0 30px 30px 0;\r\n    }\r\n}\r\n\r\n// Alert example loop\r\n\r\n@each $color, $value in $theme-colors {\r\n    // alert solid\r\n    .alert-solid {\r\n        &.alert-#{$color} {\r\n            background-color: $value;\r\n            border-color: $value;\r\n            color: set-color-from-background($value);\r\n        }\r\n    }\r\n\r\n    // alert outline\r\n    .alert-outline {\r\n        &.alert-#{$color} {\r\n            color: $value;\r\n        }\r\n    }\r\n\r\n    // alert border left\r\n    .alert-border-left {\r\n        &.alert-#{$color} {\r\n            border-left-color: $value;\r\n        }\r\n    }\r\n\r\n    // alert top border\r\n    .alert-top-border {\r\n        &.alert-#{$color} {\r\n            border-top-color: $value;\r\n        }\r\n    }\r\n    \r\n\r\n    // rounded label\r\n\r\n    .rounded-label {\r\n        &.alert-#{$color} {\r\n            .label-icon {\r\n                background-color: $value;\r\n                color: set-color-from-background($value);\r\n            }\r\n        }\r\n    }\r\n\r\n    // label arrow\r\n\r\n    .label-arrow {\r\n        &.alert-#{$color} {\r\n            .label-icon {\r\n                color: set-color-from-background($value);\r\n                background-color: $value;\r\n                &:after {\r\n                    border-left-color: $value !important;\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    .alert{\r\n        &.alert-#{$color} {\r\n            .btn-close::after{\r\n                color: $value;\r\n            }\r\n        }\r\n        \r\n    }\r\n\r\n    //alert additional example\r\n    .alert-additional {\r\n        &.alert-#{$color} {\r\n            .alert-content {\r\n                background-color: $value;\r\n                color: set-color-from-background($value);\r\n            }\r\n        }\r\n    }   \r\n}\r\n.alert-dismissible {\r\n    .btn-close {\r\n        background: transparent !important;\r\n        &::after {\r\n            background: transparent !important;\r\n            content: \"\\F0156\" !important;\r\n            font-size: 18px;\r\n            line-height:15px;\r\n            font-family: \"Material Design Icons\" !important;\r\n        }\r\n    }\r\n}\r\n\r\n.alert-outline.alert-dark{\r\n    color: var(--#{$variable-prefix}dark);\r\n}\r\n   ","// \r\n// backgrounds.scss\r\n//\r\n\r\n\r\n@each $color,\r\n$value in $theme-colors {\r\n    .bg-soft-#{$color} {\r\n        background-color: rgba(($value), 0.18) !important;\r\n    }\r\n}\r\n\r\n.bg-soft-dark{\r\n    background-color: rgba(var(--#{$variable-prefix}dark-rgb),.18)!important;\r\n}\r\n\r\n.bg-soft-light{\r\n    background-color: rgba(var(--#{$variable-prefix}light-rgb),.18)!important;\r\n}\r\n\r\n","// \r\n// badge.scss\r\n//\r\n\r\n// Soft badge\r\n@mixin badge-variant-soft($bg) {\r\n    color: $bg;\r\n    background-color: rgba($bg, 0.1);\r\n}\r\n\r\n\r\n// Outline badge\r\n@mixin badge-variant-outline($bg) {\r\n    color: $bg;\r\n    border: 1px solid $bg;\r\n    background-color: transparent;\r\n}\r\n\r\n@each $color,\r\n$value in $theme-colors {\r\n    .badge-outline-#{$color} {\r\n        @include badge-variant-outline($value);\r\n    }\r\n}\r\n\r\n// badge outline\r\n\r\n.badge-outline {\r\n    background-color: $card-bg;\r\n    border: 1px solid;\r\n}\r\n\r\n@each $color,\r\n$value in $theme-colors {\r\n    .badge-soft-#{$color} {\r\n        @include badge-variant-soft($value);\r\n    }\r\n\r\n    .badge-outline {\r\n        &.badge-#{$color} {\r\n            @include badge-variant-outline($value);\r\n        }\r\n    }\r\n\r\n    .badge-label {\r\n        &.bg-#{$color} {\r\n            &:before {\r\n                border-right-color: $value;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n// badge-border\r\n\r\n.badge-border {\r\n    border-left: 2px solid;\r\n}\r\n\r\n// badge-label\r\n\r\n.badge-label {\r\n    margin-left: 8px;\r\n    position: relative;\r\n\r\n    &:before {\r\n        content: \"\";\r\n        position: absolute;\r\n        border: 8px solid transparent;\r\n        border-right-color: $primary;\r\n        left: -14px;\r\n        top: 0;\r\n    }\r\n}\r\n\r\n[data-layout-mode=\"dark\"] {\r\n    .badge {\r\n        &.bg-dark {\r\n            background-color: var(--#{$variable-prefix}light) !important;\r\n        }\r\n\r\n        &.bg-light {\r\n            background-color: var(--#{$variable-prefix}dark) !important;\r\n            color: var(--#{$variable-prefix}light) !important;\r\n        }\r\n    }\r\n}\r\n\r\n//Badge Gradient Style\r\n$gradients: ();\r\n$gradients: map-merge((primary: linear-gradient(135deg, $primary 0%, $success 100%),\r\n        secondary: linear-gradient(135deg, $secondary 0%, $info 100%),\r\n        success: linear-gradient(135deg, $success 0%, $warning 100%),\r\n        danger: linear-gradient(135deg, $danger 0%, $secondary 100%),\r\n        warning: linear-gradient(135deg, $warning 0%, darken($warning, 15%) 100%),\r\n        info: linear-gradient(135deg, $info 0%, $success 100%),\r\n        dark: linear-gradient(135deg, $dark 0%, $primary 100%)),\r\n    $gradients);\r\n\r\n@mixin badge-gradient($parent, $gradient) {\r\n    #{$parent} {\r\n        background: $gradient;\r\n    }\r\n}\r\n\r\n@each $gradient,\r\n$value in $gradients {\r\n    @include badge-gradient(\".badge-gradient-#{$gradient}\", $value);\r\n}","// \r\n// _buttons.scss\r\n// \r\n\r\nbutton,\r\na {\r\n    outline: none !important;\r\n    position: relative;\r\n}\r\n\r\n.btn{\r\n    box-shadow: $element-shadow;\r\n}\r\n\r\n// Rounded Buttons\r\n.btn-rounded {\r\n    border-radius: 30px;\r\n}\r\n\r\n\r\n.btn-icon {\r\n    display: inline-flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    height: calc(#{$btn-padding-y * 2} + #{$btn-line-height}em + #{$btn-border-width * 2});\r\n    width: calc(#{$btn-padding-y * 2} + #{$btn-line-height}em + #{$btn-border-width * 2});\r\n    padding: 0;\r\n\r\n    i,\r\n    svg,\r\n    img {\r\n        vertical-align: middle;\r\n    }\r\n\r\n    &.btn-sm {\r\n        height: calc(#{$btn-padding-y-sm * 2} + #{$btn-line-height}em + #{$btn-border-width * 2});\r\n        width: calc(#{$btn-padding-y-sm * 2} + #{$btn-line-height}em + #{$btn-border-width * 2});\r\n    }\r\n\r\n    &.btn-lg {\r\n        height: calc(#{$btn-padding-y-lg * 2} + #{$btn-line-height}em + #{$btn-border-width * 2});\r\n        width: calc(#{$btn-padding-y-lg * 2} + #{$btn-line-height}em + #{$btn-border-width * 2});\r\n    }\r\n}\r\n\r\n//\r\n// Soft Buttons\r\n// \r\n\r\n@mixin button-variant-soft($bg) {\r\n    color: $bg;\r\n    background-color: rgba($bg, 0.1);\r\n    border-color: transparent;\r\n\r\n    &:hover,\r\n    &:focus,\r\n    &:active {\r\n        color: $white;\r\n        background-color: $bg;\r\n    }\r\n}\r\n\r\n@each $color,\r\n$value in $theme-colors {\r\n    .btn-soft-#{$color} {\r\n        @include button-variant-soft($value);\r\n    }\r\n}\r\n\r\n//\r\n// Ghost Buttons\r\n// \r\n\r\n@mixin button-variant-ghost($bg) {\r\n    color: $bg;\r\n    border-color: transparent;\r\n\r\n    &:hover,\r\n    &:focus,\r\n    &:active {\r\n        color: $bg;\r\n        background-color: rgba($bg, 0.1);\r\n    }\r\n}\r\n\r\n@each $color,\r\n$value in $theme-colors {\r\n    .btn-ghost-#{$color} {\r\n        @include button-variant-ghost($value);\r\n    }\r\n}\r\n\r\n.btn-ghost-secondary {\r\n    color: var(--#{$variable-prefix}gray-700);\r\n}\r\n\r\n//button with icon\r\n.btn-label {\r\n    position: relative;\r\n    padding-left: 44px;\r\n    .label-icon {\r\n        position: absolute;\r\n        width: 35.5px;\r\n        left: -$btn-border-width;\r\n        top: -$btn-border-width;\r\n        bottom: -$btn-border-width;\r\n        background-color: rgba($white, 0.1);\r\n        font-size: 16px;\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n    }\r\n    &.btn-light {\r\n        .label-icon {\r\n            background-color: rgba($dark, 0.05);\r\n        }\r\n    }\r\n    &.right {\r\n        padding-left: $btn-padding-x;\r\n        padding-right: 44px;\r\n        .label-icon {\r\n            right: -$btn-border-width;\r\n            left: auto;\r\n        }\r\n    }\r\n}\r\n\r\n// Animation Button\r\n\r\n.btn-animation {\r\n\toverflow: hidden;\r\n\ttransition: border-color 0.3s, background-color 0.3s;\r\n\ttransition-timing-function: cubic-bezier(0.2, 1, 0.3, 1);\r\n\t&::after {\r\n\t\tcontent: attr(data-text);\r\n\t\tposition: absolute;\r\n\t\twidth: 100%;\r\n\t\theight: 100%;\r\n\t\ttop: 0;\r\n\t\tleft: 0;\r\n\t\topacity: 0;\r\n\t\ttransform: translate3d(0, 25%, 0);\r\n\t\tpadding: $btn-padding-y $btn-padding-x;\r\n\t\ttransition: transform 0.3s, opacity 0.3s;\r\n\t\ttransition-timing-function: cubic-bezier(0.2, 1, 0.3, 1);\r\n\t}\r\n\t>span {\r\n\t\tdisplay: block;\r\n\t\ttransition: transform 0.3s, opacity 0.3s;\r\n\t\ttransition-timing-function: cubic-bezier(0.2, 1, 0.3, 1);\r\n\t}\r\n\t&:hover {\r\n\t\t&::after {\r\n\t\t\topacity: 1;\r\n\t\t\ttransform: translate3d(0, 0, 0);\r\n\t\t}\r\n\t\t>span {\r\n\t\t\topacity: 0;\r\n\t\t\ttransform: translate3d(0, -25%, 0);\r\n\t\t}\r\n\t}\r\n}\r\n\r\n\r\n@mixin button-variant($bg) {\r\n    &.btn-animation {\r\n        background-color: $bg;\r\n        border-color: $bg;\r\n\r\n        &:hover,\r\n        &:focus,\r\n        &:active {\r\n            color: $bg;\r\n            background-color: rgba($bg, 0.1);\r\n        }\r\n    }\r\n}\r\n\r\n@each $color,\r\n$value in $theme-colors {\r\n    .btn-#{$color} {\r\n        @include button-variant($value);\r\n    }\r\n}\r\n\r\n//btn group\r\n.btn-group-vertical {\r\n    label {\r\n        margin-bottom: 0;\r\n    }\r\n}\r\n\r\n// btn group radio\r\n.btn-group.radio{\r\n    .btn{\r\n        border: none;\r\n    }\r\n    .btn-check:active+.btn-light,\r\n    .btn-check:checked+.btn-light,\r\n    .btn-light.active,\r\n    .btn-light.dropdown-toggle.show,\r\n    .btn-light:active{\r\n        background-color: rgba($info, 0.2);\r\n        color: $info;\r\n    }\r\n}\r\n\r\n// theme dark\r\n[data-layout-mode=\"dark\"]{\r\n    .btn-light{\r\n        color: var(--#{$variable-prefix}dark);\r\n        background-color: var(--#{$variable-prefix}light);\r\n        border-color: var(--#{$variable-prefix}light);\r\n        &:hover{\r\n            color: var(--#{$variable-prefix}dark);\r\n            background-color: rgba(var(--#{$variable-prefix}light-rgb), 0.75);\r\n            border-color: rgba(var(--#{$variable-prefix}light-rgb), 0.75);\r\n        }\r\n    }\r\n\r\n    .btn-check:focus+.btn-light,\r\n    .btn-check:focus+.btn-outline-light,\r\n    .btn-check:focus+.btn-soft-light,\r\n    .btn-light:focus,\r\n    .btn-outline-light:focus,\r\n    .btn-soft-light:focus{\r\n        color: var(--#{$variable-prefix}dark);\r\n        background-color: rgba(var(--#{$variable-prefix}light-rgb), 0.75);\r\n        border-color: rgba(var(--#{$variable-prefix}light-rgb), 0.75);\r\n    }\r\n\r\n    .btn-check:active+.btn-light,\r\n    .btn-check:active+.btn-outline-light,\r\n    .btn-check:active+.btn-soft-light,\r\n    .btn-check:checked+.btn-light,\r\n    .btn-check:checked+.btn-outline-light,\r\n    .btn-check:checked+.btn-soft-light,\r\n    .btn-light.active, .btn-light:active,\r\n    .btn-outline-light.active, .btn-outline-light:active,\r\n    .btn-soft-light.active, .btn-soft-light:active,\r\n    .show>.btn-light.dropdown-toggle,\r\n    .show>.btn-outline-light.dropdown-toggle,\r\n    .show>.btn-soft-light.dropdown-toggle{\r\n        color: var(--#{$variable-prefix}dark);\r\n        background-color: rgba(var(--#{$variable-prefix}light-rgb), 0.75);\r\n        border-color: rgba(var(--#{$variable-prefix}light-rgb), 0.75);\r\n    }\r\n\r\n    // dark\r\n\r\n    .btn-dark{\r\n        color: var(--#{$variable-prefix}light);\r\n        background-color: var(--#{$variable-prefix}dark);\r\n        border-color: var(--#{$variable-prefix}dark);\r\n        &:hover{\r\n            color: var(--#{$variable-prefix}light);\r\n            background-color: rgba(var(--#{$variable-prefix}dark-rgb), 0.75);\r\n            border-color: rgba(var(--#{$variable-prefix}dark-rgb), 0.75);\r\n        }\r\n    }\r\n\r\n    .btn-check:focus+.btn-dark, \r\n    .btn-check:focus+.btn-outline-dark,\r\n    .btn-check:focus+.btn-soft-dark,\r\n    .btn-dark:focus,\r\n    .btn-outline-dark:focus,\r\n    .btn-soft-dark:focus{\r\n        color: var(--#{$variable-prefix}light);\r\n        background-color: rgba(var(--#{$variable-prefix}dark-rgb), 0.75);\r\n        border-color: rgba(var(--#{$variable-prefix}dark-rgb), 0.75);\r\n    }\r\n\r\n    .btn-check:active+.btn-dark,\r\n    .btn-check:active+.btn-outline-dark,\r\n    .btn-check:active+.btn-soft-dark,\r\n    .btn-check:checked+.btn-dark,\r\n    .btn-check:checked+.btn-outline-dark,\r\n    .btn-check:checked+.btn-soft-dark,\r\n    .btn-dark.active, .btn-dark:active,\r\n    .btn-outline-dark.active, .btn-outline-dark:active,\r\n    .btn-soft-dark.active, .btn-soft-dark:active,\r\n    .show>.btn-dark.dropdown-toggle,\r\n    .show>.btn-outline-dark.dropdown-toggle,\r\n    .show>.btn-soft-dark.dropdown-toggle{\r\n        color: var(--#{$variable-prefix}light);\r\n        background-color: rgba(var(--#{$variable-prefix}dark-rgb), 0.75);\r\n        border-color: rgba(var(--#{$variable-prefix}dark-rgb), 0.75);\r\n    }\r\n\r\n    // outline\r\n\r\n    .btn-outline-light{\r\n        color: var(--#{$variable-prefix}dark);\r\n        border-color: var(--#{$variable-prefix}light);\r\n        &:hover{\r\n            color: var(--#{$variable-prefix}dark);\r\n            background-color: rgba(var(--#{$variable-prefix}light-rgb), 0.75);\r\n            border-color: rgba(var(--#{$variable-prefix}light-rgb), 0.75);\r\n        }\r\n    }\r\n\r\n    .btn-outline-dark{\r\n        color: var(--#{$variable-prefix}dark);\r\n        border-color: var(--#{$variable-prefix}dark);\r\n        &:hover{\r\n            color: var(--#{$variable-prefix}light);\r\n            background-color: rgba(var(--#{$variable-prefix}dark-rgb), 0.75);\r\n            border-color: rgba(var(--#{$variable-prefix}dark-rgb), 0.75);\r\n        }\r\n    }\r\n\r\n    // soft\r\n\r\n    .btn-soft-light{\r\n        color: var(--#{$variable-prefix}dark);\r\n        background-color: rgba(var(--#{$variable-prefix}light-rgb), 0.1);\r\n        &:hover{\r\n            color: var(--#{$variable-prefix}dark);\r\n            background-color: var(--#{$variable-prefix}light);\r\n        }\r\n    }\r\n\r\n    .btn-soft-dark{\r\n        color: var(--#{$variable-prefix}dark);\r\n        background-color: rgba(var(--#{$variable-prefix}dark-rgb), 0.1);\r\n        &:hover{\r\n            color: var(--#{$variable-prefix}light);\r\n            background-color: var(--#{$variable-prefix}dark);\r\n        }\r\n    }\r\n\r\n    // ghost\r\n    .btn-ghost-light{\r\n        color: var(--#{$variable-prefix}dark);\r\n        &:hover,\r\n        &:focus,\r\n        &:active{\r\n            color: var(--#{$variable-prefix}dark);\r\n            background-color: rgba(var(--#{$variable-prefix}light-rgb), 0.5);\r\n        }\r\n    }\r\n\r\n    .btn-ghost-dark{\r\n        color: var(--#{$variable-prefix}dark);\r\n        &:hover,\r\n        &:focus,\r\n        &:active{\r\n            color: var(--#{$variable-prefix}dark);\r\n            background-color: rgba(var(--#{$variable-prefix}dark-rgb), 0.1);\r\n        }\r\n    }\r\n}\r\n\r\n//Border Bottom Buttons Style\r\n@each $color,\r\n$value in $theme-colors {\r\n    .btn-#{$color},\r\n    .btn-outline-#{$color},\r\n    .btn-soft-#{$color} {\r\n        &.btn-border {\r\n            border-bottom: 2px solid darken($value, 8%);\r\n        }\r\n    }\r\n}","// \r\n// breadcrumb.scss\r\n//\r\n\r\n\r\n// Breadcrumb item arrow\r\n.breadcrumb-item {\r\n    > a {\r\n        color: var(--#{$variable-prefix}gray-700);\r\n    }\r\n    +.breadcrumb-item {\r\n        &::before {\r\n            font-family: \"Material Design Icons\";\r\n            font-size: 15px;\r\n            line-height: 20px;\r\n        }\r\n    }\r\n}\r\n  ","// \r\n// _card.scss\r\n// \r\n\r\n.card {\r\n    margin-bottom: $grid-gutter-width;\r\n    box-shadow: $card-box-shadow;\r\n}\r\n\r\n.card-header {\r\n    border-bottom: 1px solid $border-color;\r\n}\r\n\r\n//Card Header Dropdown\r\n.card-header-dropdown {\r\n    .dropdown-btn {\r\n        padding: $card-cap-padding-y 0;\r\n    }\r\n}\r\n\r\n.card-footer {\r\n    border-top: 1px solid $border-color;\r\n}\r\n\r\n.card-drop {\r\n    color: $body-color;\r\n}\r\n\r\n.card-title {\r\n    font-size: 16px;\r\n    margin: 0 0 7px 0;\r\n}\r\n\r\n.card-title-desc {\r\n    margin-bottom: 24px;\r\n}\r\n\r\n.card-height-100 {\r\n    height: calc(100% - #{$grid-gutter-width});\r\n}\r\n\r\n.card-animate{\r\n    transition: all 0.4s;\r\n\r\n    &:hover{\r\n        transform: translateY(calc(#{-$grid-gutter-width} / 5));\r\n        box-shadow: $box-shadow-lg;\r\n    }\r\n}\r\n\r\n\r\n// card color variant\r\n\r\n@mixin card-variant($bg) {\r\n    color: $white;\r\n    background-color: $bg;\r\n}\r\n\r\n@each $color,\r\n$value in $theme-colors {\r\n    .card-#{$color} {\r\n        @include card-variant($value);\r\n\r\n        .card-header, .card-footer {\r\n            background-color: rgba($white, 0.1);\r\n            color: $white;\r\n            border-color: transparent;\r\n        }\r\n\r\n        .card-title {\r\n            color: $white;\r\n        }\r\n    }\r\n}\r\n\r\n@each $color,\r\n$value in $theme-colors {\r\n    .card-border-#{$color} {\r\n        border-color: $value !important;\r\n        .card-header, .card-footer {\r\n            border-color: $value;\r\n        }\r\n\r\n    }\r\n}\r\n\r\n.card-light{\r\n    background-color: var(--#{$variable-prefix}light);\r\n    .card-header, .card-footer{\r\n        color: var(--#{$variable-prefix}body-color) !important;\r\n        background-color: rgba(var(--#{$variable-prefix}dark-rgb), 0.1);\r\n    }\r\n    .card-title, .card-text { \r\n        color: var(--#{$variable-prefix}body-color) !important;\r\n    }\r\n}\r\n\r\n.stretched-link {\r\n    position: static;\r\n}\r\n\r\n\r\n// Loader\r\n\r\n.card-preloader {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    background-color: rgba(var(--#{$variable-prefix}light-rgb), 0.6);\r\n    z-index: 9999;\r\n}\r\n\r\n.card-status {\r\n    width: 40px;\r\n    height: 40px;\r\n    position: absolute;\r\n    left: 50%;\r\n    top: 50%;\r\n    transform: translate(-50%,-50%)!important;\r\n}\r\n\r\n.custom-loader {\r\n    animation: spin 2s linear infinite;\r\n}\r\n\r\n@keyframes spin {\r\n\tto { transform: rotate(360deg) }\r\n}\r\n\r\n.card-overlay{\r\n    position: relative;\r\n    overflow: hidden;\r\n    &:before {\r\n        content: \"\";\r\n        background-color: rgba($primary, 0.20);\r\n        position: absolute;\r\n        top: 0;\r\n        right: 0;\r\n        left: 0;\r\n        bottom: 0;\r\n    }\r\n    .card-header, .card-footer {\r\n        border-color: rgba($white, 0.15) !important;\r\n    }\r\n}\r\n\r\n.card-toolbar-menu {\r\n    line-height: 0.8;\r\n    a {\r\n        font-size: 17px;\r\n    }\r\n    .minimize-card {\r\n        .plus{\r\n            display: none;\r\n        }  \r\n        .minus {\r\n            display: block;\r\n        }\r\n        &.collapsed{\r\n            .plus{\r\n                display: block;\r\n            }  \r\n            .minus {\r\n                display: none;\r\n            }\r\n        }\r\n    }\r\n}","// \r\n// _dropdown.scss\r\n// \r\n\r\n.dropdown-toggle::after {\r\n    display: inline-block;\r\n    margin-left: .255em;\r\n    font-size: 15px;\r\n    line-height: 15px;\r\n    content: \"\\F0140\";\r\n    font-family: \"Material Design Icons\";\r\n}\r\n\r\n.dropdown-menu {\r\n    box-shadow: $box-shadow-lg;\r\n    // animation-name: DropDownSlide;\r\n    animation-duration: .3s;\r\n    animation-fill-mode: both;\r\n    position: absolute;\r\n    z-index: 1000;\r\n\r\n    &.dropdown-megamenu {\r\n        padding: 20px;\r\n        left: 0 !important;\r\n        right: 0 !important;\r\n    }\r\n\r\n    // &[data-popper-placement=\"top-start\"] {\r\n    //     animation-name: DropDownSlideDown;\r\n    // }\r\n}\r\n\r\n// @keyframes DropDownSlide {\r\n//     100% {\r\n//         margin-top: -1px;\r\n//     }\r\n\r\n//     0% {\r\n//         margin-top: 8px;\r\n//     }\r\n// }\r\n\r\n// @keyframes DropDownSlideDown {\r\n//     100% {\r\n//         margin-bottom: 0;\r\n//     }\r\n\r\n//     0% {\r\n//         margin-bottom: 8px;\r\n//     }\r\n// }\r\n\r\n@media (min-width: 600px) {\r\n    .dropdown-menu-xl {\r\n        width: 420px;\r\n    }\r\n\r\n    .dropdown-menu-lg {\r\n        width: 320px;\r\n    }\r\n\r\n    .dropdown-menu-md {\r\n        width: 240px;\r\n    }\r\n}\r\n\r\n.dropdown-toggle-split {\r\n    border-left: none;\r\n    &::after {\r\n        margin-left: 0px;\r\n    }\r\n\r\n    &:before {\r\n        content: \"\";\r\n        position: absolute;\r\n        background-color: rgba($white,0.12);\r\n        top: -$btn-border-width;\r\n        bottom: -$btn-border-width;\r\n        right: -$btn-border-width;\r\n        left: 0;\r\n        border-radius: 0 $btn-border-radius $btn-border-radius 0;\r\n    }\r\n}\r\n\r\n// Dropdown Mega Menu\r\n\r\n.dropdown-mega {\r\n    position: static !important;\r\n}\r\n\r\n\r\n\r\n// Dropdown size\r\n\r\n.dropdown-mega-menu-xl {\r\n    width: 38rem;\r\n}\r\n\r\n.dropdown-mega-menu-lg {\r\n    width: 26rem;\r\n}\r\n\r\n[dir=\"ltr\"] {\r\n    .dropdown-menu-start {\r\n        --bs-position: end;\r\n    }\r\n\r\n    .dropdown-menu-end {\r\n        --bs-position: start;\r\n    }\r\n}\r\n// Custom Dropdown with Tabs\r\n.dropdown-head{\r\n    .nav-tabs-custom{\r\n        border: 0;\r\n        .nav-link  {\r\n            color: rgba($white, 0.6);\r\n            &.active {\r\n                background-color: var(--#{$variable-prefix}dropdown-bg);\r\n            }\r\n            &:hover {\r\n                color: $white;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n@each $color,\r\n$value in $theme-colors {\r\n    .dropdownmenu-#{$color} {\r\n      .dropdown-item{\r\n        &:focus, &:hover, &.active{\r\n          background-color: rgba(($value), 0.07);\r\n          color: $value;\r\n        }\r\n      }\r\n    }\r\n}","// \r\n// _nav.scss\r\n// \r\n\r\n.nav-tabs,\r\n.nav-pills {\r\n    >li {\r\n        >a {\r\n            color: var(--#{$variable-prefix}gray-700);\r\n            font-weight: $font-weight-medium;\r\n        }\r\n    }\r\n}\r\n\r\n.nav-pills {\r\n    >a {\r\n        color: var(--#{$variable-prefix}gray-700);\r\n        font-weight: $font-weight-medium;\r\n    }\r\n}\r\n\r\n.nav-pills{\r\n    .nav-link.active, .show>.nav-link{\r\n        box-shadow: $element-shadow;\r\n    }\r\n}\r\n\r\n.nav-tabs-custom {\r\n    border-bottom: 1px solid var(--#{$variable-prefix}gray-300);\r\n\r\n    .nav-item {\r\n        position: relative;\r\n        .nav-link {\r\n            border: none;\r\n            font-weight: $font-weight-medium;\r\n            &::after {\r\n                content: \"\";\r\n                background: $primary;\r\n                height: 1px;\r\n                position: absolute;\r\n                width: 100%;\r\n                left: 0;\r\n                bottom: 0;\r\n                transition: all 250ms ease 0s;\r\n                transform: scale(0);\r\n            }\r\n            &.active {\r\n                color: $primary;\r\n                &:after {\r\n                    transform: scale(1);\r\n                }\r\n            }\r\n        }\r\n    }\r\n    &.card-header-tabs {\r\n        margin-top: -1rem;\r\n        .nav-link {\r\n            padding: $card-cap-padding-y $card-cap-padding-x;\r\n        }\r\n    }\r\n}\r\n\r\n// vertical nav\r\n\r\n.vertical-nav {\r\n    .nav {\r\n        .nav-link {\r\n            padding: 24px 16px;\r\n            text-align: center;\r\n            margin-bottom: 8px;\r\n\r\n            .nav-icon {\r\n                font-size: 24px;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n\r\n//Navtab custom\r\n.navtab-bg {\r\n    li {\r\n        >a {\r\n            background-color: $gray-300;\r\n            margin: 0 5px;\r\n        }\r\n    }\r\n}\r\n\r\n// arrow-navtabs\r\n\r\n.arrow-navtabs {\r\n    .nav-item {\r\n        .nav-link {\r\n            position: relative;\r\n            text-align: center;\r\n\r\n            &:before {\r\n                content: \"\";\r\n                position: absolute;\r\n                border: 6px solid transparent;\r\n                bottom: -12px;\r\n                left: 50%;\r\n                transform: translateX(-50%);\r\n                @include transition($nav-link-transition);\r\n            }\r\n\r\n            &.active {\r\n                &:before {\r\n                    border-top-color: $primary;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n// custom hover tab\r\n.custom-hover-nav-tabs {\r\n    .nav-item {\r\n        text-align: center;\r\n        overflow: hidden;\r\n        .nav-link {\r\n            width: 120px;\r\n            height: 45px;\r\n            position: relative;\r\n            border-radius: 0px;\r\n            .nav-icon {\r\n                font-size: 22px;\r\n            }\r\n            .nav-titl {\r\n                font-size: 14px;\r\n            }\r\n            &.active {\r\n                .nav-tab-position {\r\n                    color: $white;\r\n                }\r\n            }\r\n            .nav-tab-position {\r\n                position: absolute;\r\n                left: 0;\r\n                right: 0;\r\n                transition: all 0.4s;\r\n                &.nav-icon {\r\n                    top: 50%;\r\n                    transform: translateY(-50%);\r\n                }\r\n                &.nav-titl {\r\n                    bottom: -20px;\r\n                }\r\n            }\r\n            &:hover {\r\n                .nav-titl {\r\n                    bottom: 50%;\r\n                    transform: translateY(50%);\r\n                }\r\n                .nav-icon {\r\n                    top: -20px;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n\r\n// custom vertical tab\r\n\r\n.custom-verti-nav-pills {\r\n    .nav-link {\r\n        background-color: var(--#{$variable-prefix}light);\r\n        margin-top: 7px;\r\n        position: relative;\r\n\r\n        @media (min-width: 992px) {\r\n            &::before {\r\n                content: \"\";\r\n                position: absolute;\r\n                right: -20px;\r\n                top: 50%;\r\n                transform: translateY(-50%);\r\n                border: 12px solid transparent;\r\n                border-left-color: transparent;\r\n                transition: border-left-color .04 ease;\r\n            }\r\n\r\n            &.active {\r\n                &::before {\r\n                    border-left-color: $primary;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n// animation nav\r\n.animation-nav {\r\n    li {\r\n        position: relative;\r\n\r\n        a {\r\n            color: var(--#{$variable-prefix}body-color);\r\n            border-radius: 4px;\r\n            position: relative;\r\n            overflow: hidden;\r\n            transition: all 0.4s;\r\n            z-index: 1;\r\n\r\n            span {\r\n                position: relative;\r\n            }\r\n\r\n            &::before {\r\n                content: '';\r\n                position: absolute;\r\n                top: 0;\r\n                width: 0;\r\n                right: 0;\r\n                height: 100%;\r\n                transition: width .4s cubic-bezier(0.51, 0.18, 0, 0.88) .1s;\r\n                background-color: $primary;\r\n                z-index: -1;\r\n            }\r\n\r\n            &:hover,\r\n            &.active {\r\n                color: $white;\r\n                background-color: transparent !important;\r\n\r\n                &::before {\r\n                    width: 100%;\r\n                    left: 0;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.nav-border-top {\r\n    .nav-link {\r\n        border-top: 3px solid transparent;\r\n\r\n        &.active {\r\n            border-top-color: $primary;\r\n        }\r\n    }\r\n}\r\n\r\n\r\n@each $color,\r\n$value in $theme-colors {\r\n    .nav-border-top-#{$color} {\r\n        .nav-link {\r\n            &.active {\r\n                color: $value;\r\n                border-top-color: $value;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.nav-custom {\r\n    background-color: $primary;\r\n    border-radius: $card-border-radius;\r\n\r\n    .nav-item {\r\n        .nav-link {\r\n            color: rgba($white, 0.75);\r\n\r\n            &.active {\r\n                color: $white;\r\n                background-color: rgba($white, 0.1);\r\n            }\r\n        }\r\n    }\r\n\r\n    &.nav-custom-light {\r\n        .nav-item {\r\n            .nav-link {\r\n                color: rgba(var(--#{$variable-prefix}dark-rgb), 0.75);\r\n\r\n                &.active {\r\n                    color: $light;\r\n                    background-color: $primary;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n@each $color,\r\n$value in $theme-colors {\r\n    .nav-custom-#{$color} {\r\n        background-color: $value;\r\n    }\r\n}\r\n\r\n.nav-custom-light{\r\n    background-color: var(--#{$variable-prefix}light);\r\n}\r\n\r\n\r\n@each $color,\r\n$value in $theme-colors {\r\n    .nav-#{$color} {\r\n        .nav-link {\r\n            &.active {\r\n                color: $white;\r\n                background-color: $value;\r\n            }\r\n        }\r\n\r\n        &.nav-tabs{\r\n            .nav-link {\r\n                &.active { \r\n                    color: $value;\r\n                    background-color: $card-bg;\r\n                }\r\n            }\r\n        }\r\n\r\n        &.nav-tabs-custom {\r\n            .nav-link {\r\n                &.active {\r\n                    color: $value;\r\n                    background-color: $card-bg;\r\n\r\n                    &::after {\r\n                        background-color: $value;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n\r\n        &.arrow-navtabs {\r\n            .nav-link {\r\n                &.active {\r\n                    &::before {\r\n                        border-top-color: $value;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n\r\n        &.custom-verti-nav-pills {\r\n            .nav-link {\r\n                &.active {\r\n                    &::before {\r\n                        border-left-color: $value;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n// progress nav\r\n.progress-nav{\r\n    position: relative;\r\n    margin-right: 1rem;\r\n    margin-left: 1rem;\r\n    .progress{\r\n        position: absolute;\r\n        left: 0;\r\n        top: 50%;\r\n        transform: translateY(-50%);\r\n        width: 100%;\r\n    }\r\n    .nav{\r\n        margin-right: -1rem;\r\n        margin-left: -1rem;\r\n        justify-content: space-between;\r\n        .nav-link{\r\n            width: 2rem;\r\n            height: 2rem;\r\n            background-color: var(--#{$variable-prefix}light);\r\n            padding: 0;\r\n            color: var(--#{$variable-prefix}dark);\r\n            font-weight: $font-weight-medium;\r\n            &.active, &.done{\r\n                background-color: $primary;\r\n                color: $white;\r\n            }\r\n        }\r\n    }\r\n}\r\n// Step arrow nav\r\n.step-arrow-nav{\r\n    .nav{\r\n        background-color: var(--#{$variable-prefix}light);\r\n        .nav-link{\r\n            border-radius: 0;\r\n            position: relative;\r\n            font-weight: $font-weight-medium;\r\n            color: var(--#{$variable-prefix}dark);\r\n            &::before{\r\n                content: \"\";\r\n                position: absolute;\r\n                border: 7px solid transparent;\r\n                right: -14px;\r\n                top: 50%;\r\n                transform: translateY(-50%);\r\n            }\r\n            &.done{\r\n                background-color: rgba($primary, 0.05);\r\n                color: $primary;\r\n                &::before{\r\n                    border-left-color: transparent;\r\n                }\r\n            }\r\n            &.active{\r\n                background-color: rgba($primary, 0.1);\r\n                color: $primary;\r\n                box-shadow: none;\r\n                &::before{\r\n                    border-left-color: rgba($primary, 0.1);\r\n                }\r\n            }\r\n        }\r\n        .nav-item{\r\n            &:last-child{\r\n                .nav-link{\r\n                    &:before{\r\n                        display: none;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n// vertical nav step\r\n.vertical-navs-step{\r\n    .nav{\r\n        gap: 16px;\r\n        .nav-link{\r\n            text-align: left;\r\n            background-color: rgba(var(--#{$variable-prefix}light-rgb), 0.4);\r\n            border: 1px solid var(--#{$variable-prefix}border-color);\r\n            color: var(--#{$variable-prefix}dark);\r\n            .step-title{\r\n                font-weight: $font-weight-semibold;\r\n            }\r\n            .step-icon{\r\n                color: $danger;\r\n                vertical-align: middle;\r\n                font-weight: $font-weight-medium;\r\n                float: left;\r\n            }\r\n            &.active, &.done{\r\n                .step-icon{\r\n                    color: $success;\r\n                    &:before{\r\n                        content: \"\\eb80\";\r\n                    }\r\n                }\r\n            }\r\n            &.active{\r\n                border-color: $primary;\r\n            }\r\n            &.done{\r\n                border-color: $success;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n//Outline Border Nav\r\n.nav-custom-outline {\r\n    &.nav {\r\n        .nav-link {\r\n            border: 1px solid transparent;\r\n            border-bottom: 2px solid transparent;\r\n\r\n            &.active {\r\n                border-color: $primary;\r\n                background-color: transparent;\r\n                color: $primary;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n@each $color,\r\n$value in $theme-colors {\r\n    .nav-#{$color} {\r\n        &.nav-custom-outline {\r\n            .nav-link {\r\n                &.active {\r\n                    color: $value;\r\n                    border-color: $value;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n//customs nav\r\n.nav-customs {\r\n    &.nav {\r\n        padding-left: 34px;\r\n        overflow: hidden;\r\n\r\n        .nav-link {\r\n            position: relative;\r\n            display: block;\r\n            float: right;\r\n            background-color: var(--#{$variable-prefix}body-bg);\r\n            margin-right: 46px;\r\n            transition: all 0.5s ease;\r\n\r\n            &::before,\r\n            &::after {\r\n                display: block;\r\n                content: \" \";\r\n                position: absolute;\r\n                top: -1px;\r\n                bottom: -1px;\r\n                width: 37px;\r\n                background-color: var(--#{$variable-prefix}body-bg);\r\n                transition: all 0.5s ease;\r\n            }\r\n\r\n            &::before {\r\n                border-radius: 0 8px 0 0;\r\n                right: -24px;\r\n                transform: skew(30deg, 0deg);\r\n            }\r\n\r\n            &::after {\r\n                border-radius: 8px 0 0 0;\r\n                left: -24px;\r\n                transform: skew(-30deg, 0deg);\r\n            }\r\n\r\n            &.active,\r\n            &.active:before,\r\n            &.active:after {\r\n                background-color: $primary;\r\n                color: $white;\r\n            }\r\n\r\n            &.active {\r\n                z-index: 1;\r\n            }\r\n        }\r\n    }\r\n}","// \r\n// _table.scss\r\n// \r\n\r\n.table {\r\n    th {\r\n        font-weight: $font-weight-semibold;\r\n    }\r\n\r\n    .table-light {\r\n        color: $body-color;\r\n        border-color: $table-border-color;\r\n        background-color: var(--#{$variable-prefix}light);\r\n    }\r\n\r\n    >thead {\r\n        border-color: $table-border-color;\r\n    }\r\n\r\n    >:not(:first-child) {\r\n        border-top-width: $table-border-width;\r\n    }\r\n}\r\n\r\n\r\n.table-nowrap {\r\n\r\n    th,\r\n    td {\r\n        white-space: nowrap;\r\n    }\r\n}\r\n\r\n// card table\r\n\r\n.table-card {\r\n    margin: (-$card-spacer-y) (-$card-spacer-x);\r\n\r\n    th,\r\n    td {\r\n\r\n        &:first-child {\r\n            padding-left: 16px;\r\n        }\r\n\r\n        &:last-child {\r\n            padding-right: 16px;\r\n        }\r\n    }\r\n\r\n    .table> :not(:first-child) {\r\n        border-top-width: $table-border-width;\r\n    }\r\n}\r\n\r\n@each $color,\r\n$value in $theme-colors {\r\n    .border-#{$color} {\r\n        &.table {\r\n            >thead {\r\n                border-color: $value !important;\r\n            }\r\n        }\r\n    }\r\n\r\n    .table-#{$color} {\r\n        &.table {\r\n            >thead {\r\n                border-bottom-color: lighten($value, 10%) !important;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.table {\r\n    .form-check {\r\n        padding-left: 0px;\r\n        margin-bottom: 0px;\r\n\r\n        .form-check-input {\r\n            margin-left: 0px;\r\n            margin-top: 0px;\r\n            float: none;\r\n            vertical-align: middle;\r\n        }\r\n    }\r\n\r\n    .sort {\r\n        position: relative;\r\n\r\n        &::before {\r\n            content: \"\\f035d\";\r\n            position: absolute;\r\n            right: 0.5rem;\r\n            top: 18px;\r\n            font-size: 0.8rem;\r\n            font-family: \"Material Design Icons\";\r\n        }\r\n\r\n        &::after {\r\n            position: absolute;\r\n            right: 0.5rem;\r\n            content: \"\\f0360\";\r\n            font-family: \"Material Design Icons\";\r\n            font-size: 0.8rem;\r\n            top: 12px;\r\n        }\r\n    }\r\n}\r\n\r\n[data-layout-mode=\"dark\"] {\r\n    .table-light {\r\n        background-color: var(--#{$variable-prefix}light);\r\n        color: var(--#{$variable-prefix}body-color);\r\n\r\n        th,\r\n        td {\r\n            background-color: var(--#{$variable-prefix}light);\r\n        }\r\n    }\r\n}","//\r\n// _modal.scss\r\n//\r\n\r\n.modal-title {\r\n    font-weight: $font-weight-semibold;\r\n}\r\n\r\n.modal-dialog:not(.modal-dialog-scrollable) {\r\n    .modal-header {\r\n        padding-bottom: 0;\r\n    \r\n        .btn-close {\r\n            margin-top: -$modal-header-padding;\r\n        }\r\n    }\r\n    \r\n    .modal-footer {\r\n        padding-top: 0;\r\n    }\r\n}\r\n\r\n.modal {\r\n\t&.fadeInRight {\r\n\t\t.modal-dialog {\r\n\t\t\topacity: 0;\r\n\t\t\ttransform: translateX(20%);\r\n\t\t\ttransition: all .3s ease-in-out;\r\n\t\t}\r\n\r\n\t\t&.show {\r\n\t\t\t.modal-dialog {\r\n\t\t\t\topacity: 1;\r\n\t\t\t\ttransform: translateX(0);\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\r\n\t&.fadeInLeft {\r\n\t\t.modal-dialog {\r\n\t\t\tanimation: fadeInLeft 0.3s ease-in-out;\r\n\t\t\ttransform: translate(-50%, 0);\r\n\t\t}\r\n\r\n\t\t&.show {\r\n\t\t\t.modal-dialog {\r\n\t\t\t\ttransform: none;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\r\n\t&.fadeInUp {\r\n\t\t.modal-dialog {\r\n\t\t\tanimation: fadeInUp 0.3s ease-in-out;\r\n\t\t\ttransform: translate(0, 30%);\r\n\t\t}\r\n\r\n\t\t&.show {\r\n\t\t\t.modal-dialog {\r\n\t\t\t\ttransform: none;\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\r\n\t&.flip {\r\n\t\tperspective: 1300px;\r\n\r\n\t\t.modal-dialog {\r\n\t\t\topacity: 0;\r\n\t\t\ttransform: rotateY(-70deg);\r\n\t\t\ttransition: all .3s;\r\n\t\t}\r\n\r\n\t\t&.show {\r\n\t\t\t.modal-dialog {\r\n\t\t\t\topacity: 1;\r\n\t\t\t\ttransform: rotateY(0deg);\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n\r\n\t&.zoomIn {\r\n\t\t.modal-dialog {\r\n\t\t\topacity: 0;\r\n\t\t\ttransform: scale(.7);\r\n\t\t\ttransition: all .3s ease;\r\n\t\t}\r\n\r\n\t\t&.show {\r\n\t\t\t.modal-dialog {\r\n\t\t\t\topacity: 1;\r\n\t\t\t\ttransform: scale(1)\r\n\t\t\t}\r\n\t\t}\r\n\t}\r\n}\r\n\r\n\r\n.modal-dialog-right {\r\n\tmargin-right: $modal-dialog-margin-y-sm-up;\r\n}\r\n\r\n// modal-dialog-bottom\r\n.modal-dialog-bottom {\r\n\tdisplay: flex;\r\n\talign-items: flex-end;\r\n\tmin-height: calc(100% - #{$modal-dialog-margin-y-sm-up});\r\n\r\n\t@media (min-width: 576px) {\r\n\t\tmin-height: calc(100% - #{$modal-dialog-margin-y-sm-up*2 });\r\n\t}\r\n}\r\n\r\n.modal-dialog-bottom-right {\r\n\tdisplay: flex;\r\n\talign-items: flex-end;\r\n\tmin-height: calc(100% - #{$modal-dialog-margin-y-sm-up});\r\n\tmargin-right: $modal-dialog-margin-y-sm-up;\r\n\r\n\t@media (min-width: 576px) {\r\n\t\tmin-height: calc(100% - #{$modal-dialog-margin-y-sm-up*2 });\r\n\t}\r\n}\r\n\r\n@keyframes fadeInLeft {\r\n\t0% {\r\n\t\topacity: 0;\r\n\t\ttransform: translate3d(-30%, 0, 0);\r\n\t}\r\n\r\n\tto {\r\n\t\topacity: 1;\r\n\t\ttransform: translateZ(0);\r\n\t}\r\n}\r\n\r\n\r\n@keyframes fadeInUp {\r\n\t0% {\r\n\t\topacity: 0;\r\n\t\ttransform: translate3d(0, 30%, 0);\r\n\t}\r\n\r\n\tto {\r\n\t\topacity: 1;\r\n\t\ttransform: translateZ(0);\r\n\t}\r\n}\r\n\r\n@keyframes zoomIn {\r\n\t0% {\r\n\t\topacity: 0;\r\n\t\ttransform: scale3d(.3, .3, .3);\r\n\t}\r\n\r\n\t50% {\r\n\t\topacity: 1\r\n\t}\r\n}\r\n\r\n.login-modal {\r\n\tbackground-image: url(\"data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' version='1.1' xmlns:xlink='http://www.w3.org/1999/xlink' xmlns:svgjs='http://svgjs.com/svgjs' width='1440' height='560' preserveAspectRatio='none' viewBox='0 0 1440 560'%3e%3cg mask='url(%26quot%3b%23SvgjsMask1016%26quot%3b)' fill='none'%3e%3crect width='1440' height='560' x='0' y='0' fill='rgba(64%2c 81%2c 137%2c 1)'%3e%3c/rect%3e%3cpath d='M0%2c650.704C122.328%2c648.746%2c159.175%2c473.043%2c255.674%2c397.837C339.724%2c332.333%2c461.529%2c324.924%2c526.449%2c240.421C598.428%2c146.73%2c655.546%2c24.847%2c631.015%2c-90.726C606.666%2c-205.444%2c482.926%2c-263.497%2c401.565%2c-347.958C325.215%2c-427.217%2c275.543%2c-549.012%2c167.826%2c-571.563C60.344%2c-594.065%2c-27.703%2c-482.932%2c-135.163%2c-460.325C-256.336%2c-434.833%2c-401.929%2c-509.651%2c-497.972%2c-431.495C-592.807%2c-354.321%2c-579.865%2c-206.886%2c-595.603%2c-85.635C-611.133%2c34.016%2c-656.761%2c169.183%2c-588.884%2c268.934C-520.854%2c368.909%2c-362.458%2c340.324%2c-260.989%2c406.106C-158.875%2c472.306%2c-121.679%2c652.651%2c0%2c650.704' fill='%2333416e'%3e%3c/path%3e%3cpath d='M1440 995.672C1519.728 984.741 1563.12 899.779 1626.466 850.1469999999999 1682.6390000000001 806.135 1756.261 782.602 1791.2939999999999 720.431 1827.571 656.052 1835.537 577.6610000000001 1820.814 505.247 1806.518 434.933 1753.2640000000001 383.16999999999996 1710.941 325.228 1664.475 261.614 1634.992 175.16000000000003 1560.657 149.07999999999998 1485.96 122.87299999999999 1402.146 155.543 1332.03 192.289 1269.541 225.038 1232.754 287.251 1189.969 343.347 1149.925 395.849 1115.781 448.9 1089.96 509.672 1056 589.599 988.9680000000001 671.1659999999999 1015.557 753.837 1041.91 835.774 1142.714 863.61 1217.498 906.22 1288.388 946.611 1359.167 1006.755 1440 995.672' fill='%234d61a4'%3e%3c/path%3e%3c/g%3e%3cdefs%3e%3cmask id='SvgjsMask1016'%3e%3crect width='1440' height='560' fill='white'%3e%3c/rect%3e%3c/mask%3e%3c/defs%3e%3c/svg%3e\");\r\n\tbackground-size: cover;\r\n\tbackground-position: center;\r\n}","// \r\n// _pagination.scss\r\n// \r\n\r\n// Pagination Separated\r\n.pagination-separated {\r\n    .page-item {\r\n        .page-link {\r\n            margin-left: 0.35rem;\r\n            border-radius: $border-radius;\r\n        }\r\n    }\r\n}\r\n\r\n// Pagination rounded (Custom)\r\n.pagination-rounded {\r\n    .page-link {\r\n        border-radius: 30px !important;\r\n        margin: 0 3px !important;\r\n        border: none;\r\n        min-width: 32px;\r\n        min-height: 32px;\r\n        text-align: center;\r\n    }\r\n\r\n    &.pagination-sm {\r\n        .page-link {\r\n            min-width: 25px;\r\n            min-height: 25px;\r\n        }\r\n    }\r\n}\r\n\r\n.page-item.active {\r\n    .page-link{\r\n        box-shadow: $element-shadow;\r\n    }\r\n}","// \r\n// _progress.scss\r\n// \r\n\r\n// Progress height small\r\n.progress-sm {\r\n    height: 5px;\r\n}\r\n\r\n// Progress height large\r\n.progress-lg {\r\n    height: 12px;\r\n}\r\n\r\n// Progress height Extra large\r\n.progress-xl {\r\n    height: 16px;\r\n}\r\n\r\n.custom-progess {\r\n    position: relative;\r\n\r\n    .progress-icon {\r\n        position: absolute;\r\n        top: -12px;\r\n\r\n        .avatar-title {\r\n            background: $card-bg;\r\n        }\r\n    }\r\n}\r\n\r\n// animated-progess\r\n\r\n.animated-progess {\r\n    position: relative;\r\n\r\n    .progress-bar {\r\n        position: relative;\r\n        border-radius: 6px;\r\n        animation: animate-positive 2s;\r\n    }\r\n}\r\n\r\n@keyframes animate-positive {\r\n    0% {\r\n        width: 0;\r\n    }\r\n}\r\n\r\n// custom-progress\r\n\r\n.custom-progress {\r\n    height: 15px;\r\n    padding: 4px;\r\n    border-radius: 30px;\r\n\r\n    .progress-bar {\r\n        position: relative;\r\n        border-radius: 30px;\r\n\r\n        &::before {\r\n            content: \"\";\r\n            position: absolute;\r\n            width: 4px;\r\n            height: 4px;\r\n            background-color: $white;\r\n            border-radius: 7px;\r\n            right: 2px;\r\n            top: 50%;\r\n            transform: translateY(-50%);\r\n\r\n        }\r\n    }\r\n}\r\n\r\n// progress withlabel\r\n.progress-label {\r\n    overflow: visible;\r\n\r\n    .progress-bar {\r\n        position: relative;\r\n        overflow: visible;\r\n\r\n        .label {\r\n            position: absolute;\r\n            top: -25px;\r\n            right: -9px;\r\n            background-color: $primary;\r\n            color: $white;\r\n            display: inline-block;\r\n            line-height: 18px;\r\n            padding: 0 4px;\r\n            border-radius: 4px;\r\n\r\n            &:after {\r\n                content: \"\";\r\n                position: absolute;\r\n                border: 4px solid transparent;\r\n                border-top-color: $primary;\r\n                bottom: -7px;\r\n                left: 50%;\r\n                transform: translateX(-50%);\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n\r\n.progress-step-arrow {\r\n    height: 3.25rem;\r\n\r\n    .progress-bar {\r\n        position: relative;\r\n        overflow: initial;\r\n        font-size: .875rem;\r\n        color: $white;\r\n        &::after {\r\n            content: \"\";\r\n            position: absolute;\r\n            border: 10px solid transparent;\r\n            bottom: 15px;\r\n            right: -20px;\r\n            z-index: 1;\r\n        }\r\n    }\r\n}\r\n\r\n\r\n@mixin progress-variant($bg) {\r\n    .progress-bar {\r\n        background-color: $bg;\r\n        &::after { \r\n            border-left-color: $bg;\r\n        }\r\n        &:nth-child(2) {\r\n            background-color: rgba($bg, 0.1) !important;\r\n            color: $bg !important;\r\n            &::after { \r\n                border-left-color: rgba($bg, 0.1);\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n@each $color, $value in $theme-colors {\r\n    .progress-#{$color} {\r\n        @include progress-variant($value);\r\n    }\r\n}\r\n\r\n","// \r\n// _popover.scss\r\n// \r\n\r\n.popover {\r\n    box-shadow: $popover-box-shadow;\r\n}","// \r\n// type.scss\r\n//\r\n\r\n// Text colors\r\n.text-white-75 {\r\n    color: rgba($white, 0.75) !important;\r\n}\r\n\r\n// Blockquote\r\n.custom-blockquote {\r\n    &.blockquote {\r\n        padding: 16px;\r\n        border-left: 3px solid;\r\n        \r\n        &.blockquote-outline{\r\n            background-color: $card-bg !important;\r\n            border: 1px solid;\r\n            border-left: 3px solid;\r\n        }\r\n    }\r\n}\r\n\r\n@each $color,\r\n$value in $theme-colors {\r\n    .custom-blockquote {\r\n        &.blockquote {\r\n            &.blockquote-#{$color} {\r\n                color: #{$value};\r\n                border-color: #{$value};\r\n                background-color: rgba($value, 0.15);\r\n\r\n                .blockquote-footer {\r\n                    color: #{$value};\r\n                }\r\n            }\r\n\r\n            &.blockquote-outline{\r\n                &.blockquote-#{$color} {\r\n                    border-color: #{$value};\r\n\r\n                    .blockquote-footer {\r\n                        color: #{$value};\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.custom-blockquote{\r\n    &.blockquote{\r\n        &.blockquote-dark{\r\n            color: var(--#{$variable-prefix}dark);\r\n            border-color: var(--#{$variable-prefix}dark);\r\n            background-color: rgba(var(--#{$variable-prefix}dark-rgb), 0.15);\r\n            .blockquote-footer {\r\n                color: var(--#{$variable-prefix}dark);\r\n            }\r\n        }\r\n        &.blockquote-outline{\r\n            &.blockquote-dark{\r\n                border-color: var(--#{$variable-prefix}dark);\r\n                .blockquote-footer {\r\n                    color: var(--#{$variable-prefix}dark);\r\n                }\r\n            }\r\n        }\r\n    }\r\n}","//\r\n// _form-check.scss\r\n//\r\n\r\n.form-check {\r\n    position: relative;\r\n    text-align: left\r\n        /*rtl: right*/;\r\n\r\n    .form-check-input {\r\n        cursor: pointer;\r\n    }\r\n\r\n    label {\r\n        cursor: pointer;\r\n    }\r\n}\r\n\r\n\r\n// checkbox color\r\n\r\n@each $color,\r\n$value in $theme-colors {\r\n    .form-check-#{$color} {\r\n        .form-check-input {\r\n            &:checked {\r\n                background-color: $value;\r\n                border-color: $value;\r\n            }\r\n        }\r\n    }\r\n\r\n    .form-radio-#{$color} {\r\n        .form-check-input {\r\n            &:checked {\r\n                border-color: $value;\r\n                background-color: $value;\r\n\r\n                &:after {\r\n                    background-color: $value;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.form-check-label {\r\n    cursor: pointer;\r\n    margin-bottom: 0;\r\n}\r\n\r\n// checkbox input right\r\n.form-check-right {\r\n    padding-left: 0;\r\n    display: inline-block;\r\n\r\n    .form-check-input {\r\n        float: right;\r\n        margin-left: 0;\r\n        margin-right: $form-check-padding-start * -1;\r\n    }\r\n\r\n    .form-check-label {\r\n        display: block;\r\n    }\r\n\r\n    &.form-switch {\r\n        .form-check-input {\r\n            margin-right: $form-check-padding-start * -1.6;\r\n        }\r\n    }\r\n}\r\n\r\n\r\n// Checkbox outline\r\n\r\n@each $color,\r\n$value in $theme-colors {\r\n    .form-check-outline {\r\n        &.form-check-#{$color} {\r\n            .form-check-input {\r\n                &:checked[type=checkbox] {\r\n                    color: $value;\r\n                    background-color: transparent;\r\n                    border-color: $value;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.form-check-outline {\r\n    .form-check-input {\r\n        position: relative;\r\n\r\n        &:checked[type=checkbox] {\r\n            background-image: none;\r\n\r\n            &::before {\r\n                content: \"\\F012C\";\r\n                font-family: \"Material Design Icons\";\r\n                top: -2px;\r\n                position: absolute;\r\n                font-weight: 700;\r\n                font-size: 11px;\r\n                left: 1px;\r\n            }\r\n        }\r\n\r\n    }\r\n}\r\n\r\n// Radio\r\n\r\n@each $color,\r\n$value in $theme-colors {\r\n    .form-radio-outline {\r\n        &.form-radio-#{$color} {\r\n            .form-check-input {\r\n                &:checked[type=radio] {\r\n                    color: $value;\r\n                    background-color: transparent;\r\n                    border-color: $value;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.form-radio-outline {\r\n    .form-check-input {\r\n        position: relative;\r\n\r\n        &:checked[type=radio] {\r\n            background-image: none;\r\n\r\n            &::before {\r\n                content: \"\\F0765\";\r\n                font-family: \"Material Design Icons\";\r\n                top: 0px;\r\n                position: absolute;\r\n                font-size: 8px;\r\n                left: 2.2px;\r\n            }\r\n        }\r\n\r\n    }\r\n}\r\n\r\n// Switch sizes\r\n\r\n.form-switch-md {\r\n    padding-left: 2.5rem;\r\n    min-height: 22px;\r\n    line-height: 22px;\r\n\r\n    .form-check-input {\r\n        width: 40px;\r\n        height: 20px;\r\n        left: -0.5rem;\r\n        position: relative;\r\n    }\r\n\r\n    .form-check-label {\r\n        vertical-align: middle;\r\n    }\r\n}\r\n\r\n.form-switch-lg {\r\n    padding-left: 2.75rem;\r\n    min-height: 28px;\r\n    line-height: 28px;\r\n\r\n    .form-check-input {\r\n        width: 48px;\r\n        height: 24px;\r\n        left: -0.75rem;\r\n        position: relative;\r\n    }\r\n}\r\n\r\n.input-group-text {\r\n    margin-bottom: 0px;\r\n}\r\n\r\n\r\n@each $color,\r\n$value in $theme-colors {\r\n    .form-switch-#{$color} {\r\n        .form-check-input {\r\n\r\n            &:checked {\r\n                background-color: $value;\r\n                border-color: $value;\r\n            }\r\n        }\r\n    }\r\n\r\n    .form-switch-custom {\r\n        &.form-switch-#{$color} {\r\n            .form-check-input {\r\n                &:checked {\r\n                    &::before {\r\n                        color: $value;\r\n                    }\r\n\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n// Custom Switch style\r\n\r\n.form-switch-custom {\r\n    .form-check-input {\r\n        position: relative;\r\n        background-image: none;\r\n\r\n        &::before {\r\n            content: \"\\F0765\";\r\n            font-family: \"Material Design Icons\";\r\n            top: -9px;\r\n            position: absolute;\r\n            font-size: 20px;\r\n            left: -3px;\r\n            color: $text-muted;\r\n            @include transition($form-switch-transition);\r\n        }\r\n\r\n        &:checked {\r\n            background-image: none;\r\n            background-color: $form-check-input-bg;\r\n            @include transition($form-switch-transition);\r\n\r\n            &::before {\r\n                right: -3px;\r\n                left: auto;\r\n            }\r\n        }\r\n\r\n        &:focus {\r\n            background-image: none;\r\n        }\r\n    }\r\n}\r\n\r\n// Switch - Right\r\n\r\n.form-switch-right {\r\n    display: inline-block;\r\n    padding-right: $form-check-padding-start * .5;\r\n    margin-bottom: 0;\r\n    padding-left: 0 !important;\r\n\r\n    .form-check-input {\r\n        float: right;\r\n        margin-left: 0;\r\n        margin-right: $form-check-padding-start * -1;\r\n        margin-top: .1em !important;\r\n    }\r\n\r\n    label {\r\n        margin-bottom: 0;\r\n        margin-right: 1rem;\r\n    }\r\n}\r\n\r\n// card radio\r\n.card-radio {\r\n    padding: 0;\r\n\r\n    .form-check-label {\r\n        background-color: $card-bg;\r\n        border: 1px solid $card-border-color;\r\n        border-radius: $border-radius;\r\n        padding: 1rem;\r\n        overflow: hidden;\r\n        text-overflow: ellipsis;\r\n        white-space: nowrap;\r\n        display: block;\r\n        position: relative;\r\n        padding-right: 32px;\r\n\r\n        &:hover {\r\n            cursor: pointer;\r\n        }\r\n    }\r\n\r\n    .form-check-input {\r\n        display: none;\r\n\r\n        &:checked+.form-check-label {\r\n            border-color: $primary !important;\r\n\r\n            &:before {\r\n                content: '\\eb80';\r\n                font-family: \"remixicon\";\r\n                position: absolute;\r\n                top: 2px;\r\n                right: 6px;\r\n                font-size: 16px;\r\n                color: $primary;\r\n            }\r\n        }\r\n    }\r\n\r\n    &.dark {\r\n        .form-check-input {\r\n            &:checked+.form-check-label {\r\n                &:before {\r\n                    color: $white;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n[data-layout-mode=\"dark\"]{\r\n    .form-switch{\r\n        .form-check-input, .form-check-input:focus{\r\n            background-image: escape-svg(url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='-4 -4 8 8'><circle r='3' fill='#{$gray-400}'/></svg>\"));\r\n        }\r\n    }\r\n}","//\r\n// _form-control.scss\r\n//\r\n\r\n\r\n.form-icon{\r\n    position: relative;\r\n    .form-control-icon {\r\n        padding-left: $input-padding-x*3;\r\n        position: relative;\r\n    }\r\n    i {\r\n        position: absolute;\r\n        top: 0px;\r\n        bottom: 0px;\r\n        left: 18px;\r\n        display: flex;\r\n        align-items: center;\r\n    }\r\n    &.right{\r\n        .form-control-icon {\r\n            padding-right: $input-padding-x*3;\r\n            padding-left: $input-padding-x;\r\n            position: relative;\r\n        }\r\n        i {\r\n            left: auto;\r\n            right: 18px;\r\n        }\r\n    }\r\n}\r\n\r\n[data-layout-mode=\"dark\"]{\r\n    .form-select {\r\n        background-image: escape-svg(url(\"data:image/svg+xml,<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'><path fill='none' stroke='#{$gray-400}' stroke-linecap='round' stroke-linejoin='round' stroke-width='2' d='M2 5l6 6 6-6'/></svg>\"));\r\n    }\r\n}","//\r\n// _list-group.scss\r\n//\r\n\r\n\r\n@each $color,\r\n$value in $theme-colors {\r\n    .list-group-fill-#{$color} {\r\n        background-color: $value;\r\n        border-color: $value;\r\n        color: $white;\r\n\r\n        .list-group-item {\r\n            &.active {\r\n                background-color: $value !important;\r\n                border-color: $value;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.list-group-fill-light {\r\n    color: $dark !important;\r\n}\r\n\r\n.list-group-item {\r\n    margin-bottom: 0px;\r\n    .list-text {\r\n        color: $text-muted;\r\n    }\r\n    &.active {\r\n        box-shadow: $element-shadow;\r\n        .list-title {\r\n            color: $white;\r\n        }\r\n        .list-text {\r\n            color: rgba($white, 0.50);\r\n        }\r\n    }\r\n}","//\r\n// _custom-scrollbar.scss\r\n//\r\n\r\n[data-simplebar] {\r\n  position: relative;\r\n  flex-direction: column;\r\n  flex-wrap: wrap;\r\n  justify-content: flex-start;\r\n  align-content: flex-start;\r\n  align-items: flex-start;\r\n}\r\n\r\n.simplebar-wrapper {\r\n  overflow: hidden;\r\n  width: inherit;\r\n  height: inherit;\r\n  max-width: inherit;\r\n  max-height: inherit;\r\n}\r\n\r\n.simplebar-mask {\r\n  direction: inherit;\r\n  position: absolute;\r\n  overflow: hidden;\r\n  padding: 0;\r\n  margin: 0;\r\n  left: 0;\r\n  top: 0;\r\n  bottom: 0;\r\n  right: 0;\r\n  width: auto !important;\r\n  height: auto !important;\r\n  z-index: 0;\r\n}\r\n\r\n.simplebar-offset {\r\n  direction: inherit !important;\r\n  box-sizing: inherit !important;\r\n  resize: none !important;\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0 !important;\r\n  bottom: 0;\r\n  right: 0 !important;\r\n  padding: 0;\r\n  margin: 0;\r\n  -webkit-overflow-scrolling: touch;\r\n}\r\n\r\n.simplebar-content-wrapper {\r\n  direction: inherit;\r\n  box-sizing: border-box !important;\r\n  position: relative;\r\n  display: block;\r\n  height: 100%; /* Required for horizontal native scrollbar to not appear if parent is taller than natural height */\r\n  width: auto;\r\n  visibility: visible;\r\n  overflow: auto; /* Scroll on this element otherwise element can't have a padding applied properly */\r\n  max-width: 100%; /* Not required for horizontal scroll to trigger */\r\n  max-height: 100%; /* Needed for vertical scroll to trigger */\r\n  scrollbar-width: none;\r\n  padding: 0px !important;\r\n}\r\n\r\n.simplebar-content-wrapper::-webkit-scrollbar,\r\n.simplebar-hide-scrollbar::-webkit-scrollbar {\r\n  display: none;\r\n}\r\n\r\n.simplebar-content:before,\r\n.simplebar-content:after {\r\n  content: ' ';\r\n  display: table;\r\n}\r\n\r\n.simplebar-placeholder {\r\n  max-height: 100%;\r\n  max-width: 100%;\r\n  width: 100%;\r\n  pointer-events: none;\r\n}\r\n\r\n.simplebar-height-auto-observer-wrapper {\r\n  box-sizing: inherit !important;\r\n  height: 100%;\r\n  width: 100%;\r\n  max-width: 1px;\r\n  position: relative;\r\n  float: left;\r\n  max-height: 1px;\r\n  overflow: hidden;\r\n  z-index: -1;\r\n  padding: 0;\r\n  margin: 0;\r\n  pointer-events: none;\r\n  flex-grow: inherit;\r\n  flex-shrink: 0;\r\n  flex-basis: 0;\r\n}\r\n\r\n.simplebar-height-auto-observer {\r\n  box-sizing: inherit;\r\n  display: block;\r\n  opacity: 0;\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  height: 1000%;\r\n  width: 1000%;\r\n  min-height: 1px;\r\n  min-width: 1px;\r\n  overflow: hidden;\r\n  pointer-events: none;\r\n  z-index: -1;\r\n}\r\n\r\n.simplebar-track {\r\n  z-index: 1;\r\n  position: absolute;\r\n  right: 0;\r\n  bottom: 0;\r\n  pointer-events: none;\r\n  overflow: hidden;\r\n}\r\n\r\n[data-simplebar].simplebar-dragging .simplebar-content {\r\n  pointer-events: none;\r\n  user-select: none;\r\n  -webkit-user-select: none;\r\n}\r\n\r\n[data-simplebar].simplebar-dragging .simplebar-track {\r\n  pointer-events: all;\r\n}\r\n\r\n.simplebar-scrollbar {\r\n  position: absolute;\r\n  right: 2px;\r\n  width: 6px;\r\n  min-height: 10px;\r\n}\r\n\r\n.simplebar-scrollbar:before {\r\n  position: absolute;\r\n  content: '';\r\n  background: #a2adb7;\r\n  border-radius: 7px;\r\n  left: 0;\r\n  right: 0;\r\n  opacity: 0;\r\n  transition: opacity 0.2s linear;\r\n}\r\n\r\n.simplebar-scrollbar.simplebar-visible:before {\r\n  /* When hovered, remove all transitions from drag handle */\r\n  opacity: 0.5;\r\n  transition: opacity 0s linear;\r\n}\r\n\r\n.simplebar-track.simplebar-vertical {\r\n  top: 0;\r\n  width: 11px;\r\n}\r\n\r\n.simplebar-track.simplebar-vertical .simplebar-scrollbar:before {\r\n  top: 2px;\r\n  bottom: 2px;\r\n}\r\n\r\n.simplebar-track.simplebar-horizontal {\r\n  left: 0;\r\n  height: 11px;\r\n}\r\n\r\n.simplebar-track.simplebar-horizontal .simplebar-scrollbar:before {\r\n  height: 100%;\r\n  left: 2px;\r\n  right: 2px;\r\n}\r\n\r\n.simplebar-track.simplebar-horizontal .simplebar-scrollbar {\r\n  right: auto;\r\n  left: 0;\r\n  top: 2px;\r\n  height: 7px;\r\n  min-height: 0;\r\n  min-width: 10px;\r\n  width: auto;\r\n}\r\n\r\n/* Rtl support */\r\n[data-simplebar-direction='rtl'] .simplebar-track.simplebar-vertical {\r\n  right: auto;\r\n  left: 0;\r\n}\r\n\r\n.hs-dummy-scrollbar-size {\r\n  direction: rtl;\r\n  position: fixed;\r\n  opacity: 0;\r\n  visibility: hidden;\r\n  height: 500px;\r\n  width: 500px;\r\n  overflow-y: hidden;\r\n  overflow-x: scroll;\r\n}\r\n\r\n.simplebar-hide-scrollbar {\r\n  position: fixed;\r\n  left: 0;\r\n  visibility: hidden;\r\n  overflow-y: scroll;\r\n  scrollbar-width: none;\r\n}\r\n\r\n.custom-scroll {\r\n  height: 100%;\r\n}\r\n\r\n@each $color, $value in $theme-colors {\r\n  [data-simplebar-track=\"#{$color}\"]{\r\n    .simplebar-scrollbar:before{\r\n      background: $value; \r\n    }\r\n  }\r\n}","/**\r\n * prism.js default theme for JavaScript, CSS and HTML\r\n * Based on dabblet (http://dabblet.com)\r\n * @author Lea Verou\r\n */\r\n\r\ncode[class*=\"language-\"],\r\npre[class*=\"language-\"] {\r\n    color: black;\r\n    background: none;\r\n    text-shadow: 0 1px white;\r\n    font-family: Consolas, Monaco, \"Andale Mono\", \"Ubuntu Mono\", monospace;\r\n    font-size: 1em;\r\n    text-align: left;\r\n    white-space: pre;\r\n    word-spacing: normal;\r\n    word-break: normal;\r\n    word-wrap: normal;\r\n    line-height: 1.5;\r\n\r\n    -moz-tab-size: 4;\r\n    -o-tab-size: 4;\r\n    tab-size: 4;\r\n\r\n    -webkit-hyphens: none;\r\n    -moz-hyphens: none;\r\n    -ms-hyphens: none;\r\n    hyphens: none;\r\n}\r\n\r\npre[class*=\"language-\"]::-moz-selection,\r\npre[class*=\"language-\"] ::-moz-selection,\r\ncode[class*=\"language-\"]::-moz-selection,\r\ncode[class*=\"language-\"] ::-moz-selection {\r\n    text-shadow: none;\r\n    background: #b3d4fc;\r\n}\r\n\r\npre[class*=\"language-\"]::selection,\r\npre[class*=\"language-\"] ::selection,\r\ncode[class*=\"language-\"]::selection,\r\ncode[class*=\"language-\"] ::selection {\r\n    text-shadow: none;\r\n    background: #b3d4fc;\r\n}\r\n\r\n@media print {\r\n    code[class*=\"language-\"],\r\n    pre[class*=\"language-\"] {\r\n        text-shadow: none;\r\n    }\r\n}\r\n\r\n/* Code blocks */\r\npre[class*=\"language-\"] {\r\n    padding: 1em;\r\n    margin: 0;\r\n    overflow: auto;\r\n}\r\n\r\n:not(pre) > code[class*=\"language-\"],\r\npre[class*=\"language-\"] {\r\n    background: var(--#{$variable-prefix}light) !important;\r\n}\r\n\r\n/* Inline code */\r\n:not(pre) > code[class*=\"language-\"] {\r\n    padding: 0.1em;\r\n    border-radius: 0.3em;\r\n    white-space: normal;\r\n}\r\n\r\n.token.comment,\r\n.token.prolog,\r\n.token.doctype,\r\n.token.cdata {\r\n    color: slategray;\r\n}\r\n\r\n.token.punctuation {\r\n    color: #999;\r\n}\r\n\r\n.token.namespace {\r\n    opacity: 0.7;\r\n}\r\n\r\n.token.property,\r\n.token.tag,\r\n.token.boolean,\r\n.token.number,\r\n.token.constant,\r\n.token.symbol,\r\n.token.deleted {\r\n    color: $danger;\r\n}\r\n\r\n.token.selector,\r\n.token.attr-name,\r\n.token.string,\r\n.token.char,\r\n.token.builtin,\r\n.token.inserted {\r\n    color: #690;\r\n}\r\n\r\n.token.operator,\r\n.token.entity,\r\n.token.url,\r\n.language-css .token.string,\r\n.style .token.string {\r\n    color: #9a6e3a;\r\n    /* This background color was intended by the author of this theme. */\r\n    background: hsla(0, 0%, 100%, 0.5);\r\n}\r\n\r\n.token.atrule,\r\n.token.attr-value,\r\n.token.keyword {\r\n    color: #07a;\r\n}\r\n\r\n.token.function,\r\n.token.class-name {\r\n    color: #dd4a68;\r\n}\r\n\r\n.token.regex,\r\n.token.important,\r\n.token.variable {\r\n    color: #e90;\r\n}\r\n\r\n.token.important,\r\n.token.bold {\r\n    font-weight: bold;\r\n}\r\n.token.italic {\r\n    font-style: italic;\r\n}\r\n\r\n.token.entity {\r\n    cursor: help;\r\n}\r\n\r\n/* Prism editor */\r\n:not(pre) > code[class*=\"language-\"],\r\npre[class*=\"language-\"] {\r\n    background: $gray-200;\r\n}\r\n\r\ncode[class*=\"language-\"],\r\npre[class*=\"language-\"] {\r\n    color: $gray-600;\r\n    text-shadow: none;\r\n}\r\n\r\n\r\n\r\n// Scrollbar\r\n\r\n.language-markup {\r\n    &::-webkit-scrollbar {\r\n        -webkit-appearance: none;\r\n    }\r\n\r\n    &::-webkit-scrollbar:vertical {\r\n        width: 10px;\r\n    }\r\n\r\n    &::-webkit-scrollbar:horizontal {\r\n        height: 10px;\r\n    }\r\n\r\n    &::-webkit-scrollbar-thumb {\r\n        background-color: rgba(var(--#{$variable-prefix}dark-rgb), .1);\r\n        border-radius: 10px;\r\n        border: 2px solid var(--#{$variable-prefix}light)\r\n    }\r\n\r\n    &::-webkit-scrollbar-track {\r\n        border-radius: 10px;\r\n        background-color: var(--#{$variable-prefix}light)\r\n    }\r\n}\r\n\r\n\r\n// Scroll-top\r\n\r\n#scroll-top {\r\n    width: 30px;\r\n    height: 30px;\r\n    position: fixed;\r\n    bottom: 65px;\r\n    right: 30px;\r\n    background: #343a40;\r\n    border-color: transparent;\r\n    border-radius: 3px;\r\n    color: #ffffff;\r\n    transition: all 0.5s ease;\r\n}\r\n\r\n// Toolbar (Copy button)\r\n\r\n.btn-clipboard {\r\n    position: absolute !important;\r\n    right: 15px !important;\r\n    z-index: 1 !important;\r\n}\r\n\r\ndiv.code-toolbar > .toolbar {\r\n    opacity: 1 !important;\r\n    button {\r\n        display: inline-block !important;\r\n        margin: 0.375rem 0.5rem !important;\r\n        padding: 0.25rem 0.75rem !important;\r\n        transition: $btn-transition !important;\r\n        border-radius: $border-radius-sm !important;\r\n        border: $border-width solid rgba($primary, 0.35) !important;\r\n        background-color: transparent;\r\n        color: $primary !important;\r\n        box-shadow: none !important;\r\n        &:focus {\r\n            outline: none !important;\r\n            box-shadow: none !important;\r\n        }\r\n        &:hover {\r\n            background-color: $primary !important;\r\n            color: $white !important;\r\n        }\r\n    }\r\n}\r\n","\r\n//\r\n//  _sweetalert2.scss\r\n//\r\n\r\n.swal2-container {\r\n  .swal2-title{\r\n    padding: 24px 24px 0;\r\n    font-size: 20px;\r\n    font-weight: $font-weight-medium;\r\n  }  \r\n}\r\n\r\n.swal2-popup{\r\n  padding-bottom: 24px;\r\n  border-radius: $modal-content-border-radius;\r\n  background-color: $modal-content-bg;\r\n  color: var(--#{$variable-prefix}body-color);\r\n\r\n  .swal2-title{\r\n    color: var(--#{$variable-prefix}heading-color);\r\n  }\r\n\r\n  .swal2-html-container{\r\n    color: var(--#{$variable-prefix}body-color);\r\n  }\r\n}\r\n\r\n.swal2-footer{\r\n  border-top: 1px solid var(--#{$variable-prefix}border-color);\r\n  color: var(--#{$variable-prefix}body-color);\r\n}\r\n\r\n.swal2-html-container{\r\n  font-size: 16px;\r\n}\r\n\r\n.swal2-icon{\r\n  &.swal2-question{\r\n    border-color: $info;\r\n    color: $info;\r\n  }\r\n  &.swal2-success {\r\n    [class^=swal2-success-line]{\r\n      background-color: $success;\r\n    }\r\n\r\n    .swal2-success-ring{\r\n      border-color: rgba($success, 0.3);\r\n    }\r\n  }\r\n  &.swal2-warning{\r\n    border-color: $warning;\r\n    color: $warning;\r\n  }\r\n}\r\n\r\n.swal2-styled{\r\n  &:focus{\r\n    box-shadow: none;\r\n  }\r\n}\r\n\r\n.swal2-loader{\r\n  border-color: $primary transparent $primary transparent;\r\n}\r\n\r\n.swal2-timer-progress-bar{\r\n  background-color: rgba($success, 0.4);\r\n}\r\n\r\n.swal2-progress-steps {\r\n  .swal2-progress-step{\r\n    background: $primary;\r\n    &.swal2-active-progress-step{\r\n      background: $primary;\r\n      &~.swal2-progress-step, &~.swal2-progress-step-line{\r\n        background: rgba($primary, 0.3);\r\n      }\r\n    }\r\n  }\r\n  .swal2-progress-step-line{\r\n    background: $primary;\r\n  }\r\n}\r\n\r\n.swal2-actions.swal2-loading{\r\n  .swal2-styled.swal2-confirm{\r\n    border-left-color: $primary !important;\r\n    border-right-color: $primary !important;\r\n  }\r\n}\r\n\r\n.swal2-file, .swal2-input, .swal2-textarea{\r\n  border: 1px solid $input-border-color;\r\n  &:focus{\r\n    box-shadow: none;\r\n    border-color: $input-focus-border-color;\r\n  }\r\n}\r\n\r\n.swal2-input{\r\n  height: auto;\r\n  display: block;\r\n  padding: $input-padding-y $input-padding-x;\r\n  font-family: $input-font-family;\r\n  @include font-size($input-font-size);\r\n  font-weight: $input-font-weight;\r\n  line-height: $input-line-height;\r\n  color: $input-color;\r\n  background-color: $input-bg;\r\n  background-clip: padding-box;\r\n  border: $input-border-width solid $input-border-color;\r\n}\r\n\r\n.swal2-close{\r\n  font-family: $font-family-base;\r\n  font-weight: $font-weight-light;\r\n  font-size: 28px;\r\n  &:focus{\r\n    box-shadow: none;\r\n  }\r\n\r\n  &:hover{\r\n    color: $primary;\r\n  }\r\n}\r\n\r\n.swal2-validation-message{\r\n  background-color: transparent;\r\n}","//\r\n// Dropzone\r\n//\r\n\r\n\r\n.dropzone {\r\n  min-height: 230px;\r\n  border: 2px dashed $border-color;\r\n  background: $card-bg;\r\n  border-radius: 6px;\r\n\r\n  .dz-message {\r\n    font-size: 24px;\r\n    width: 100%;\r\n    margin: 1em 0;\r\n  }\r\n}\r\n","\r\n//\r\n// _range-slider.scss\r\n//\r\n\r\n.noUi-connect{\r\n  background: $success;\r\n}\r\n\r\n.noUi-handle{\r\n  background: $success;\r\n  border: 2px solid var(--#{$variable-prefix}card-bg);\r\n  box-shadow: none;\r\n}\r\n\r\n.noUi-horizontal{\r\n  height: 4px;\r\n  .noUi-handle{\r\n    height: 16px;\r\n    width: 16px;\r\n    border-radius: 50%;\r\n    right: -10px !important;\r\n    top: -7px;\r\n\r\n    &::before, &::after{\r\n      display: none;\r\n    }\r\n    &:focus{\r\n      outline: 0;\r\n    }\r\n  }\r\n}\r\n\r\n.noUi-pips-horizontal{\r\n  height: 50px;\r\n}\r\n\r\n// tooltip\r\n\r\n.noUi-tooltip{\r\n  padding: $tooltip-padding-y $tooltip-padding-x;\r\n  border-color: $border-color;\r\n  border-radius: $tooltip-border-radius;\r\n  background-color: $card-bg;\r\n  color: $body-color;\r\n}\r\n\r\n// Vertical Slider\r\n\r\n.noUi-vertical{\r\n  width: 4px;\r\n  .noUi-handle{\r\n    height: 16px;\r\n    width: 16px;\r\n    right: -8px;\r\n    top: -12px;\r\n    left: auto;\r\n    border-radius: 50%;\r\n    &::before, &::after{\r\n      display: none;\r\n    }\r\n    &:focus{\r\n      outline: 0;\r\n    }\r\n  }\r\n\r\n  .noUi-origin{\r\n    top: 0;\r\n  }\r\n}\r\n\r\n.noUi-value{\r\n  font-size: 12px;\r\n}\r\n\r\n.noUi-marker-horizontal{\r\n  &.noUi-marker-large{\r\n    height: 12px;\r\n  }\r\n}\r\n\r\n.noUi-value-horizontal{\r\n  padding-top: 4px;\r\n}\r\n\r\n.noUi-target{\r\n  box-shadow: none;\r\n  background-color: var(--#{$variable-prefix}light);\r\n  border-color: var(--#{$variable-prefix}light);\r\n}\r\n\r\n.noUi-touch-area{\r\n  &:focus{\r\n    outline: 0;\r\n  }\r\n}\r\n\r\n// Colorpicker\r\n\r\n#red, #green, #blue {\r\n\tmargin: 10px;\r\n\tdisplay: inline-block;\r\n\theight: 200px;\r\n}\r\n\r\n#colorpicker {\r\n\theight: 240px;\r\n\twidth: 310px;\r\n\tmargin: 0 auto;\r\n\tpadding: 10px;\r\n\tborder: 1px solid $border-color;\r\n}\r\n\r\n#result {\r\n\tmargin: 60px 26px;\r\n\theight: 100px;\r\n\twidth: 100px;\r\n\tdisplay: inline-block;\r\n\tvertical-align: top;\r\n\tborder: 1px solid $border-color;\r\n    box-shadow: 0 0 3px;\r\n    border-radius: 7px;\r\n}\r\n\r\n#red {\r\n    .noUi-connect {\r\n        background: $danger;\r\n    }\r\n}\r\n\r\n#green {\r\n    .noUi-connect {\r\n        background: $success;\r\n    }\r\n}\r\n\r\n#blue {\r\n    .noUi-connect {\r\n        background: $primary;\r\n    }\r\n}\r\n\r\n// Adding keyboard support\r\n\r\n.form-control{\r\n    &.keyboard{\r\n        max-width: 340px !important;\r\n    }\r\n}\r\n\r\n\r\n// Non linear slider\r\n\r\n.example-val{\r\n    font-size: 12px;\r\n    color: $text-muted;\r\n    display: block;\r\n    margin: 15px 0;\r\n    &:before{\r\n        content: \"Value: \";\r\n        font-size: 12px;\r\n        font-weight: 600;\r\n    }\r\n}\r\n\r\n// showing tooltips\r\n\r\n.noUi-tooltip {\r\n    display: none;\r\n}\r\n.noUi-active .noUi-tooltip {\r\n    display: block;\r\n}\r\n\r\n// Colored Connect Elements\r\n\r\n.c-1-color { background: $danger; }\r\n.c-2-color { background: $warning; }\r\n.c-3-color { background: $success; }\r\n.c-4-color { background: $primary; }\r\n.c-5-color { background: $purple; }\r\n\r\n//  slider togle\r\n\r\n#slider-toggle {\r\n    height: 50px;\r\n    &.off{\r\n        .noUi-handle{\r\n            border-color: $danger;\r\n        }\r\n    }\r\n}\r\n\r\n// rangeslider color\r\n\r\n@each $color, $value in $theme-colors {\r\n  [data-slider-color=\"#{$color}\"] {\r\n    .noUi-connect{\r\n      background: $value;\r\n    }\r\n\r\n    .noUi-handle{\r\n      background: $value;\r\n    }\r\n\r\n    &[data-slider-style=\"border\"], &[data-slider-style=\"square\"]{\r\n      .noUi-handle{\r\n        border-color: $value;\r\n      }\r\n    }\r\n  }\r\n}\r\n\r\n// rangeslider sizes\r\n\r\n[data-slider-size=\"lg\"]{\r\n  &.noUi-horizontal{\r\n    height: 12px;\r\n\r\n    .noUi-handle{\r\n      width: 24px;\r\n      height: 24px;\r\n    }\r\n  }\r\n}\r\n\r\n[data-slider-size=\"md\"]{\r\n  &.noUi-horizontal{\r\n    height: 8px;\r\n\r\n    .noUi-handle{\r\n      width: 20px;\r\n      height: 20px;\r\n    }\r\n  }\r\n}\r\n\r\n[data-slider-size=\"sm\"]{\r\n  &.noUi-horizontal{\r\n    height: 4px;\r\n\r\n    .noUi-handle{\r\n      width: 16px;\r\n      height: 16px;\r\n    }\r\n  }\r\n}\r\n\r\n// rangeslider style\r\n\r\n[data-slider-style=\"line\"]{\r\n  &.noUi-horizontal .noUi-handle{\r\n    width: 8px;\r\n    border-radius: 4px;\r\n    right: -8px;\r\n  }\r\n  &.noUi-vertical .noUi-handle{\r\n    height: 8px;\r\n    border-radius: 4px;\r\n    top: -3px;\r\n  }\r\n}\r\n\r\n[data-slider-style=\"border\"]{\r\n  .noUi-handle{\r\n    border-color: $success;\r\n    background-color: $card-bg;\r\n  }\r\n}\r\n\r\n[data-slider-style=\"square\"]{\r\n  .noUi-handle{\r\n    border-radius: 0px;\r\n    transform: rotate(45deg);\r\n    height: 10px;\r\n    width: 10px;\r\n    top: -4px;\r\n    border-color: $success;\r\n    background-color: $card-bg;\r\n  }\r\n}\r\n\r\n","// \r\n// _sortablejs.scss\r\n// \r\n\r\n\r\n.nested-list{\r\n    .list-group-item{\r\n        background-color: rgba($primary, 0.05);\r\n        border-color: rgba($primary, 0.05);\r\n    }\r\n}\r\n\r\n.nested-list, .nested-1, .nested-2, .nested-3{\r\n    margin-top: 5px;\r\n}\r\n\r\n\r\n.nested-sortable-handle{\r\n    .handle{\r\n        position: absolute;\r\n        left: 0;\r\n        top: 0;\r\n        width: 42px;\r\n        height: 42px;\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n        cursor: grab;\r\n    }\r\n    .list-group-item{\r\n        padding-left: 42px;\r\n    }\r\n}","// \r\n// tour.scss\r\n// \r\n\r\n.shepherd-element{\r\n    background: $card-bg;\r\n    box-shadow: $box-shadow;\r\n}\r\n\r\n.shepherd-has-title{\r\n    .shepherd-content{\r\n        .shepherd-header{\r\n            background-color: var(--#{$variable-prefix}light);\r\n            padding: $toast-padding-y $toast-padding-x;\r\n        }\r\n\r\n        .shepherd-cancel-icon{\r\n            color: rgba(var(--#{$variable-prefix}dark-rgb), .75);\r\n            &:hover{\r\n                color: rgba(var(--#{$variable-prefix}dark-rgb), .75);\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.shepherd-element.shepherd-has-title[data-popper-placement^=bottom]>.shepherd-arrow:before{\r\n    background-color: var(--#{$variable-prefix}light);\r\n}\r\n\r\n.shepherd-title{\r\n    font-size: 15px;\r\n    font-weight: $font-weight-medium;\r\n    color: var(--#{$variable-prefix}body-color);\r\n}\r\n\r\n.shepherd-text{\r\n    padding: $toast-padding-x;\r\n    font-size: $font-size-base;\r\n    color: var(--#{$variable-prefix}body-color);\r\n}\r\n\r\n.shepherd-button{\r\n    &.btn-success:not(:disabled):hover{\r\n        background: darken($success, 2.5%);\r\n        color: $white;\r\n    }\r\n\r\n    &.btn-light:not(:disabled):hover{\r\n        background: rgba(var(--#{$variable-prefix}light-rgb), .75);\r\n        color: var(--#{$variable-prefix}dark);\r\n    }\r\n\r\n    &.btn-primary:not(:disabled):hover{\r\n        background: darken($primary, 2.5%);\r\n        color: $white;\r\n    }\r\n}\r\n\r\n.shepherd-footer{\r\n    padding: 0 $toast-padding-x $toast-padding-x;\r\n}\r\n.shepherd-arrow,\r\n.shepherd-arrow:before{\r\n    content: \"\\ea75\";\r\n    font-family: 'remixicon';\r\n    font-size: 24px;\r\n    z-index: 1;\r\n    background-color: transparent !important;\r\n    transform: rotate(0deg);\r\n    color: $primary;\r\n}\r\n\r\n.shepherd-element[data-popper-placement^=bottom]>.shepherd-arrow{\r\n    top: -18px;\r\n}\r\n\r\n.shepherd-button{\r\n    margin-right: 0.5rem;\r\n}","//\r\n// _swiper.scss\r\n//\r\n\r\n.swiper-button-next, .swiper-button-prev {\r\n    height: 32px !important;\r\n    width: 32px !important;\r\n    background-color: rgba($primary, 0.2);\r\n    backdrop-filter: blur(2px);\r\n    border-radius: 8px;\r\n    &::after {\r\n        font-family: remixicon !important;\r\n        font-size: 28px !important;\r\n        color: rgba($primary, 1);\r\n        transition: all 0.3s ease;\r\n    }\r\n}\r\n\r\n.swiper-button-prev {\r\n    &::after {\r\n        content: \"\\ea64\" !important;\r\n    }\r\n}\r\n.swiper-button-next {\r\n    &::after {\r\n        content: \"\\ea6e\" !important;\r\n    }\r\n}\r\n\r\n.swiper-pagination-bullet{\r\n    width: 22px !important;\r\n    height: 5px !important;\r\n    background-color: $white !important;\r\n    border-radius: 50px !important;\r\n    box-shadow: $element-shadow; \r\n    .swiper-pagination-bullet-active{\r\n        opacity: 1; \r\n    }\r\n}\r\n\r\n.dynamic-pagination{\r\n    .swiper-pagination-bullet {\r\n        width: 8px; \r\n        height: 8px; \r\n        background-color: $white; \r\n        opacity: 0.5; \r\n        transition: all 0.5s ease;\r\n        &.swiper-pagination-bullet-active{\r\n            opacity: 1;\r\n            width: 20px;\r\n        }\r\n    }\r\n}\r\n\r\n.swiper-pagination-fraction {\r\n    color: $white; \r\n    font-size: 16px; \r\n    background-color: rgba($black, 0.3); \r\n    backdrop-filter: blur(2px); \r\n}\r\n\r\n\r\n.pagination-custom{\r\n    .swiper-pagination-bullet {\r\n        height: 25px !important;\r\n        width: 25px !important;\r\n        line-height: 25px !important;\r\n        border-radius: 8px !important;\r\n        background-color: $white !important;\r\n        opacity: 0.5 !important;\r\n        transition: all 0.5s ease;\r\n        &.swiper-pagination-bullet-active{\r\n            color: $secondary !important;\r\n            opacity: 1 !important\r\n        }\r\n    }\r\n}\r\n\r\n.swiper-pagination-progressbar{\r\n    height: 6px !important;\r\n    background-color: rgba($success, 0.25) !important;\r\n    .swiper-pagination-progressbar-fill {\r\n        background-color: $success !important;\r\n    }\r\n}\r\n\r\n\r\n.swiper-scrollbar {\r\n    background-color: rgba($white, 0.35); \r\n    backdrop-filter: blur(2px); \r\n    padding: 1.2px; \r\n    height: 6px !important;\r\n    .swiper-scrollbar-drag {\r\n        background-color: $white; \r\n    }\r\n}\r\n\r\n.swiper-pagination-dark {\r\n    .swiper-pagination-bullet {\r\n        background-color: $secondary !important;\r\n    }\r\n    .dynamic-pagination{\r\n        .swiper-pagination-bullet { \r\n            background-color: $secondary !important;\r\n        }\r\n    }\r\n    &.pagination-custom{\r\n        .swiper-pagination-bullet { \r\n            color: $white; \r\n            &.swiper-pagination-bullet-active{\r\n                opacity: 1; \r\n            }\r\n        }\r\n    }\r\n    &.swiper-scrollbar { \r\n        background-color: rgba($dark, 0.35); \r\n    }\r\n}","\r\n//\r\n// _multijs.scss\r\n//\r\n\r\n.multi-wrapper{\r\n  border: none;\r\n  position: relative;\r\n\r\n  &::before{\r\n    content: \"\\ea61\";\r\n    position: absolute;\r\n    font-family: \"remixicon\";\r\n    left: 50%;\r\n    transform: translateX(-50%);\r\n    bottom: 86px;\r\n    width: 32px;\r\n    height: 32px;\r\n    display: flex;\r\n    justify-content: center;\r\n    align-items: center;\r\n    font-size: 16px;\r\n    border-radius: 50%;\r\n    color: $text-muted;\r\n    background-color: var(--#{$variable-prefix}light);\r\n    z-index: 1;\r\n  }\r\n  \r\n  .non-selected-wrapper{\r\n    border: 1px solid $input-border-color;\r\n    background-color: $input-bg;\r\n    border-top-left-radius: $border-radius;\r\n    border-bottom-left-radius: $border-radius;\r\n  }\r\n\r\n  .selected-wrapper, .non-selected-wrapper{\r\n    &::-webkit-scrollbar {\r\n      -webkit-appearance: none;\r\n    }\r\n  \r\n    &::-webkit-scrollbar:vertical {\r\n      width: 10px;\r\n    }\r\n  \r\n    &::-webkit-scrollbar:horizontal {\r\n      height: 9px;\r\n    }\r\n  \r\n    &::-webkit-scrollbar-thumb {\r\n      background-color: rgba(var(--#{$variable-prefix}dark-rgb), .2);\r\n      border-radius: 10px;\r\n      border: 2px solid $input-bg;\r\n    }\r\n  \r\n    &::-webkit-scrollbar-track {\r\n      border-radius: 10px;  \r\n      background-color: $input-bg; \r\n    }\r\n}\r\n\r\n  .item-group .group-label{\r\n    font-size: 12px;\r\n  }\r\n\r\n  .item{\r\n    color: $input-color;\r\n    &:hover{\r\n      background-color: rgba($primary, 0.1);\r\n    }\r\n  }\r\n\r\n  .selected-wrapper{\r\n    border: 1px solid $input-border-color;\r\n    background: $input-bg;\r\n    border-top-right-radius: $border-radius;\r\n    border-bottom-right-radius: $border-radius;\r\n  }\r\n\r\n  .search-input{\r\n    flex: 0 0 auto;\r\n    padding: $input-padding-y $input-padding-x;\r\n    font-family: $input-font-family;\r\n    font-size: $input-font-size;\r\n    color: $input-color;\r\n    background-color: $input-bg;\r\n    border: $input-border-width solid $input-border-color;\r\n    border-radius: $input-border-radius;\r\n    margin-bottom: 16px;\r\n    &::placeholder{\r\n      color: $input-placeholder-color;\r\n    }\r\n  }\r\n\r\n  .header{\r\n    font-weight: $font-weight-semibold;\r\n    color: var(--#{$variable-prefix}gray-600);\r\n  }\r\n}","//\r\n// _colorpicker.scss\r\n//\r\n\r\n.pcr-app{\r\n  background: $card-bg;\r\n  box-shadow: $box-shadow-lg;\r\n  border-radius: 4px;\r\n  border: 1px solid $border-color;\r\n}\r\n\r\n.pickr{\r\n  .pcr-button{\r\n    border: 4px solid $card-bg;\r\n    box-shadow: 0px 0px 0 2px $border-color;\r\n    border-radius: 50%;\r\n    box-shadow: $element-shadow;\r\n    &::after, &::before{\r\n      border-radius: 50%;\r\n    }\r\n  }\r\n}\r\n\r\n.pcr-app{\r\n  &[data-theme=classic]{\r\n    .pcr-selection {\r\n      .pcr-color-preview{\r\n        margin-right: .75em;\r\n        margin-left: 0;\r\n      }\r\n  \r\n      .pcr-color-chooser, .pcr-color-opacity{\r\n        margin-left: .75em;\r\n        margin-right: 0;\r\n      }\r\n    }\r\n  }\r\n\r\n  &[data-theme=\"monolith\"]{\r\n    .pcr-result{\r\n      min-width: 100%;\r\n    }\r\n  }\r\n\r\n  .pcr-interaction{\r\n    .pcr-type.active{\r\n      background: $primary;\r\n    }\r\n\r\n    .pcr-result{\r\n      background-color: $input-bg;\r\n      color: $input-color;\r\n      border: 1px solid $input-border-color;\r\n      border-radius: $input-border-radius;\r\n    }\r\n\r\n    input{\r\n      border-radius: $input-border-radius !important;\r\n      &:focus{\r\n        box-shadow: none;\r\n        background-color: $input-focus-bg;\r\n        border-color: $input-focus-border-color;\r\n      }\r\n    }\r\n\r\n    .pcr-save{\r\n      background: $success !important;\r\n    }\r\n\r\n    .pcr-clear, .pcr-cancel{\r\n      background: $danger !important;\r\n    }\r\n  }\r\n}","//\r\n// filepond\r\n//\r\n\r\n.filepond--root{\r\n  margin-bottom: 0;\r\n\r\n  &[data-style-panel-layout~=circle]{\r\n    .filepond--drop-label label{\r\n      font-size: 14px;\r\n    }\r\n  }\r\n}\r\n\r\n.filepond--panel-root{\r\n  border: 2px dashed $border-color;\r\n  background: $card-bg;\r\n}\r\n\r\n.filepond--drop-label {\r\n  color: var(--#{$variable-prefix}body-color);\r\n  label{\r\n    font-weight: $font-weight-medium;\r\n  }\r\n}\r\n\r\n.filepond--credits {\r\n  display: none;\r\n}\r\n\r\n.filepond--item-panel {\r\n  background-color: $primary !important;\r\n}","//\r\n// _form-input-spin.scss\r\n//\r\n\r\n\r\n[type=\"number\"]::-webkit-inner-spin-button,\r\n[type=\"number\"]::-webkit-outer-spin-button {\r\n    -webkit-appearance: none;\r\n    height: auto;\r\n}\r\n\r\n.input-step {\r\n    border: 1px solid $input-border-color;\r\n    display: inline-flex;\r\n    overflow: visible;\r\n    height: 37.5px;\r\n    @include border-radius($input-border-radius, 0);\r\n    background: $input-bg;\r\n    padding: 4px;\r\n\r\n    input {\r\n        width: 4em;\r\n        height: 100%;\r\n        text-align: center;\r\n        border: 0;\r\n        background: transparent;\r\n        color: $input-color;\r\n        border-radius: $input-border-radius;\r\n\r\n        &:focus-visible {\r\n            outline: 0;\r\n        }\r\n    }\r\n\r\n    button {\r\n        width: 1.4em;\r\n        font-weight: 300;\r\n        height: 100%;\r\n        line-height: 0.1em;\r\n        font-size: 1.4em;\r\n        padding: 0.2em !important;\r\n        background: var(--#{$variable-prefix}light);\r\n        color: var(--#{$variable-prefix}body-color);\r\n        border: none;\r\n        border-radius: $btn-border-radius;\r\n    }\r\n\r\n    &.light {\r\n        background: var(--#{$variable-prefix}light);\r\n\r\n        button {\r\n            background-color: $input-bg;\r\n        }\r\n    }\r\n\r\n    &.light-input {\r\n        background: var(--#{$variable-prefix}light);\r\n\r\n        input {\r\n            background-color: $input-bg;\r\n        }\r\n    }\r\n\r\n    &.full-width {\r\n        display: flex;\r\n        width: 100%;\r\n\r\n        button {\r\n            flex-shrink: 0;\r\n        }\r\n\r\n        input {\r\n            flex-grow: 1;\r\n        }\r\n    }\r\n}\r\n\r\n@each $color,\r\n$value in $theme-colors {\r\n    .input-step {\r\n        &.step-#{$color} {\r\n            button {\r\n                background-color: $value;\r\n                color: $white;\r\n            }\r\n        }\r\n    }\r\n}","//\r\n// _ckeditor.scss\r\n//\r\n\r\n.ck {\r\n    font-family: $font-family-base !important;\r\n\r\n    &.ck-reset_all, &.ck-reset_all *{\r\n        color: var(--#{$variable-prefix}body-color) !important;\r\n    }\r\n    &.ck-toolbar{\r\n        background: #{rgba(var(--#{$variable-prefix}light-rgb), .75)} !important;\r\n    }\r\n\r\n    p {\r\n        margin-bottom: 0;\r\n    }\r\n\r\n    &.ck-toolbar {\r\n        border: 1px solid $input-border-color !important;\r\n\r\n        &.ck-toolbar_grouping>.ck-toolbar__items {\r\n            flex-wrap: wrap !important;\r\n        }\r\n\r\n        .ck.ck-toolbar__separator {\r\n            background: transparent !important;\r\n        }\r\n    }\r\n\r\n    &.ck-editor__main>.ck-editor__editable {\r\n        border-top: 0 !important;\r\n        background-color: $card-bg !important;\r\n        border-color: $input-border-color !important;\r\n        box-shadow: none !important;\r\n    }\r\n\r\n    &.ck-dropdown__panel{\r\n        background: $dropdown-bg !important;\r\n        box-shadow: $box-shadow-lg;\r\n        animation-name: DropDownSlide;\r\n        animation-duration: .3s;\r\n        animation-fill-mode: both;\r\n        border-radius: $dropdown-border-radius;\r\n    }\r\n\r\n    &.ck-list {\r\n        background: $dropdown-bg !important;\r\n    }\r\n\r\n    &.ck-dropdown {\r\n        .ck-dropdown__panel {\r\n            &.ck-dropdown__panel_ne,\r\n            &.ck-dropdown__panel_se {\r\n                left: 0;\r\n                right: auto !important;\r\n            }\r\n        }\r\n    }\r\n\r\n    &.ck-editor__editable_inline {\r\n        &[dir=ltr] {\r\n            text-align: left !important;\r\n        }\r\n    }\r\n\r\n    &.ck-dropdown__panel {\r\n        box-shadow: $dropdown-box-shadow !important;\r\n        border-radius: $dropdown-border-radius !important;\r\n        border: 1px solid $dropdown-border-color !important;\r\n    }\r\n}\r\n\r\n.ck.ck-button, \r\na.ck.ck-button{\r\n\r\n    &:focus, &:active{\r\n        box-shadow: none !important;\r\n        border: 1px solid var(--#{$variable-prefix}light) !important;\r\n    }\r\n\r\n    &:not(.ck-disabled){\r\n        &:hover{\r\n            background: var(--#{$variable-prefix}light) !important;\r\n        }\r\n    }\r\n\r\n    &.ck-on{\r\n        background: var(--#{$variable-prefix}light) !important;\r\n    }\r\n}\r\n\r\n.ck-rounded-corners .ck.ck-editor__top .ck-sticky-panel .ck-toolbar, \r\n.ck.ck-editor__top .ck-sticky-panel .ck-toolbar.ck-rounded-corners{\r\n    border-radius: $border-radius !important;\r\n    border-bottom-left-radius: 0 !important;\r\n    border-bottom-right-radius: 0 !important;\r\n}\r\n\r\n.ck-rounded-corners .ck.ck-editor__main>.ck-editor__editable, \r\n.ck.ck-editor__main>.ck-editor__editable.ck-rounded-corners{\r\n    border-radius: $border-radius !important;\r\n    border-top-left-radius: 0 !important;\r\n    border-top-right-radius: 0 !important;\r\n}\r\n\r\n.ck-editor__editable {\r\n    min-height: 245px !important;\r\n}\r\n\r\n.ck[class*=ck-heading_heading] {\r\n    font-weight: $font-weight-medium !important;\r\n}\r\n\r\n.ck,\r\na.ck {\r\n    &.ck-button {\r\n        &.ck-on:not(.ck-disabled) {\r\n            &:hover,\r\n            &:active {\r\n                box-shadow: none !important;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.ck{\r\n    &.ck-tooltip{\r\n        .ck-tooltip__text {\r\n            background: $dark !important;\r\n            color: $light !important;\r\n        }\r\n    }\r\n\r\n    &.ck-input-text{\r\n        background: $input-bg !important;\r\n        border: 1px solid $input-border-color !important;\r\n        &:focus{\r\n            border: 1px solid $input-focus-border-color !important;\r\n            box-shadow: none !important;\r\n        }\r\n    }\r\n\r\n    &.ck-balloon-panel{\r\n        background: $dropdown-bg !important;\r\n        border: 1px solid $dropdown-border-color !important;\r\n\r\n        &[class*=arrow_n]{\r\n            &:after{\r\n                border-bottom-color: $dropdown-bg !important;\r\n            }\r\n\r\n            &::before{\r\n                border-bottom-color: $dropdown-border-color !important;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n\r\n\r\n.ck.ck-labeled-field-view>.ck.ck-labeled-field-view__input-wrapper>.ck.ck-label{\r\n    background: $dropdown-bg !important;\r\n}\r\n\r\n// ck-editor-reverse\r\n\r\n.ck-editor-reverse{\r\n    .ck-editor{\r\n      display: flex;\r\n      flex-direction: column-reverse;\r\n    }\r\n  \r\n    .ck{\r\n      &.ck-editor__main>.ck-editor__editable{\r\n        border: 1px solid $input-border-color !important;\r\n        border-bottom: 0 !important;\r\n      }\r\n    }\r\n  \r\n    .ck-rounded-corners .ck.ck-editor__main>.ck-editor__editable, \r\n    .ck.ck-editor__main>.ck-editor__editable.ck-rounded-corners{\r\n      border-radius: $border-radius !important;\r\n      border-bottom-left-radius: 0 !important;\r\n      border-bottom-right-radius: 0 !important;\r\n    }\r\n  \r\n    .ck-rounded-corners .ck.ck-editor__top .ck-sticky-panel .ck-toolbar, \r\n    .ck.ck-editor__top .ck-sticky-panel .ck-toolbar.ck-rounded-corners{\r\n      border-radius: $border-radius !important;\r\n      border-top-left-radius: 0 !important;\r\n      border-top-right-radius: 0 !important;\r\n    }\r\n}\r\n\r\n[dir=\"rtl\"] {\r\n    .ck.ck-toolbar>.ck-toolbar__items {\r\n        flex-direction: row-reverse;\r\n    }\r\n}","//\r\n// _quilljs.scss\r\n//\r\n\r\n.ql-editor {\r\n    text-align: left;\r\n\r\n    ol,\r\n    ul {\r\n        padding-left: 1.5em;\r\n        padding-right: 0;\r\n    }\r\n\r\n    li:not(.ql-direction-rtl)::before {\r\n        margin-left: -1.5em;\r\n        margin-right: 0.3em;\r\n        text-align: right;\r\n    }\r\n}\r\n\r\n.ql-container {\r\n    font-family: $font-family-base;\r\n\r\n    &.ql-snow {\r\n        border-color: $input-border-color;\r\n        border-bottom-left-radius: 4px;\r\n        border-bottom-right-radius: 4px;\r\n    }\r\n}\r\n\r\n.ql-bubble {\r\n    border: $input-border-width solid $input-border-color;\r\n    border-radius: $input-border-radius;\r\n}\r\n\r\n.ql-toolbar {\r\n    font-family: $font-family-base !important;\r\n\r\n    span {\r\n        outline: none !important;\r\n        color: $dropdown-link-color;\r\n\r\n        &:hover {\r\n            color: $primary !important;\r\n        }\r\n    }\r\n\r\n    &.ql-snow {\r\n        border-top-left-radius: 4px;\r\n        border-top-right-radius: 4px;\r\n        border-color: $input-border-color;\r\n\r\n        .ql-picker.ql-expanded {\r\n            .ql-picker-label {\r\n                border-color: transparent;\r\n            }\r\n        }\r\n\r\n        .ql-picker-options {\r\n            box-shadow: $dropdown-box-shadow;\r\n            border-radius: $dropdown-border-radius;\r\n        }\r\n    }\r\n}\r\n\r\n.ql-snow {\r\n\r\n    .ql-stroke,\r\n    .ql-script,\r\n    .ql-strike svg {\r\n        stroke: $dropdown-link-color;\r\n    }\r\n\r\n    .ql-fill {\r\n        fill: $dropdown-link-color;\r\n    }\r\n\r\n    .ql-picker:not(.ql-color-picker):not(.ql-icon-picker) {\r\n        svg {\r\n            right: 0;\r\n            left: auto;\r\n        }\r\n    }\r\n\r\n    .ql-picker {\r\n        &.ql-expanded .ql-picker-label {\r\n            color: $dropdown-link-color;\r\n        }\r\n    }\r\n}\r\n\r\n.ql-snow {\r\n    .ql-picker-options {\r\n        background-color: $dropdown-bg;\r\n        border-color: $dropdown-border-color !important;\r\n    }\r\n}","// \r\n// _gridjs.scss\r\n// \r\n\r\n.gridjs-container {\r\n    color: $table-color;\r\n    padding: 0;\r\n    display: block;\r\n}\r\n\r\n.gridjs-wrapper {\r\n    box-shadow: none;\r\n    border: 1px solid $table-border-color;\r\n    border-radius: 0px;\r\n\r\n    &::-webkit-scrollbar {\r\n        -webkit-appearance: none;\r\n    }\r\n\r\n    &::-webkit-scrollbar:vertical {\r\n        width: 12px;\r\n    }\r\n\r\n    &::-webkit-scrollbar:horizontal {\r\n        height: 12px;\r\n    }\r\n\r\n    &::-webkit-scrollbar-thumb {\r\n        background-color: rgba(var(--#{$variable-prefix}dark-rgb), .075);\r\n        border-radius: 10px;\r\n        border: 2px solid $card-bg;\r\n    }\r\n\r\n    &::-webkit-scrollbar-track {\r\n        border-radius: 10px;\r\n        background-color: $card-bg;\r\n    }\r\n}\r\n\r\n.gridjs-footer {\r\n    border: none !important;\r\n    padding: 12px 0 0;\r\n}\r\n\r\n.gridjs-table {\r\n    width: 100%;\r\n}\r\n\r\n.gridjs-tbody, td.gridjs-td{\r\n    background-color: $table-bg;\r\n}\r\n\r\nth.gridjs-th,\r\ntd.gridjs-td {\r\n    border: 1px solid $table-border-color;\r\n    padding: $table-cell-padding-y $table-cell-padding-x;\r\n}\r\n\r\nth {\r\n    &.gridjs-th {\r\n        border-top: 0;\r\n        color: $table-color;\r\n        background-color: rgba(var(--#{$variable-prefix}light-rgb), .75);\r\n\r\n    }\r\n\r\n    &.gridjs-th-sort {\r\n\r\n        &:focus,\r\n        &:hover {\r\n            background-color: rgba(var(--#{$variable-prefix}light-rgb), .85);\r\n        }\r\n    }\r\n}\r\n\r\n.gridjs-head{\r\n    padding-top: 0;\r\n}\r\n\r\n.gridjs-footer {\r\n    box-shadow: none;\r\n    border: 1px solid $table-border-color;\r\n    border-top: 0;\r\n    background-color: $table-bg;\r\n}\r\n\r\n.gridjs-summary {\r\n    color: $text-muted;\r\n    margin-top: 8px !important;\r\n}\r\n\r\n.gridjs-pagination {\r\n\r\n    .gridjs-pages button {\r\n        margin-left: 0.3rem;\r\n        border-radius: $border-radius !important;\r\n        border: 1px solid $pagination-border-color;\r\n        background-color: $pagination-bg;\r\n        color: $pagination-color;\r\n\r\n        &:last-child{\r\n            border-right: 1px solid $pagination-border-color;\r\n        }\r\n\r\n        &:disabled,\r\n        &:hover:disabled,\r\n        &[disabled] {\r\n            color: $pagination-disabled-color;\r\n            background-color: $pagination-bg;\r\n        }\r\n\r\n        &:hover {\r\n            background-color: $pagination-hover-bg;\r\n            color: $pagination-hover-color;\r\n        }\r\n\r\n        &:focus {\r\n            box-shadow: none;\r\n        }\r\n\r\n        &:last-child,\r\n        &:first-child {\r\n            &:hover {\r\n                background-color: transparent;\r\n            }\r\n        }\r\n\r\n        &.gridjs-currentPage {\r\n            background-color: $pagination-active-bg;\r\n            color: $pagination-active-color;\r\n            border-color: $pagination-active-border-color;\r\n            font-weight: $font-weight-medium;\r\n        }\r\n    }\r\n}\r\n\r\n.gridjs-search {\r\n    position: relative;\r\n    float: left;\r\n\r\n    &::before {\r\n        content: \"\\f0d1\";\r\n        font-family: \"remixicon\";\r\n        position: absolute;\r\n        top: 50%;\r\n        transform: translateY(-50%);\r\n        left: 10px;\r\n        font-size: 14px;\r\n        color: $text-muted;\r\n    }\r\n}\r\n\r\ninput.gridjs-input {\r\n    border-color: $input-border-color;\r\n    background-color: $input-bg;\r\n    color: $input-color;\r\n    line-height: $input-line-height;\r\n    padding: $input-padding-y $input-padding-x $input-padding-y $input-padding-x*2.25;\r\n    border-radius: $input-border-radius;\r\n    @include font-size($input-font-size);\r\n\r\n    &:focus {\r\n        box-shadow: none;\r\n        border-color: $input-focus-border-color;\r\n        background-color: $input-focus-bg;\r\n    }\r\n\r\n    &::placeholder{\r\n        color: $input-placeholder-color;\r\n    }\r\n}\r\n\r\nth.gridjs-th {\r\n    .gridjs-th-content {\r\n        float: none;\r\n        display: inline-block;\r\n        vertical-align: middle;\r\n        font-weight: $font-weight-semibold;\r\n    }\r\n}\r\n\r\nbutton.gridjs-sort {\r\n    float: none;\r\n    display: inline-block;\r\n    vertical-align: middle;\r\n    width: 10px;\r\n    height: 20px;\r\n}\r\n\r\nth.gridjs-th-sort .gridjs-th-content {\r\n    width: calc(100% - 10px);\r\n}\r\n\r\nbutton{\r\n    &.gridjs-sort-asc, &.gridjs-sort-desc{\r\n        background-size: 7px;\r\n    }\r\n}\r\n\r\n\r\n// card table\r\n\r\n.table-card{\r\n\r\n    .gridjs-head{\r\n        padding: 16px 16px 5px;\r\n    }\r\n\r\n    .gridjs-wrapper{\r\n        border-top: 0;\r\n        border-radius: 0;\r\n        border-width: 1px 0;\r\n    }\r\n\r\n    .gridjs-footer{\r\n        padding: 8px 16px !important;\r\n    }\r\n}\r\n\r\n// gridjs selection\r\n.gridjs-tr-selected {\r\n    td{\r\n        background-color: $table-active-bg;\r\n    }\r\n    .gridjs-td .gridjs-checkbox[type=checkbox]{\r\n        background-color: $form-check-input-checked-bg-color;\r\n        border-color: $form-check-input-checked-border-color;\r\n        @if $enable-gradients {\r\n            background-image: escape-svg($form-check-input-checked-bg-image), var(--#{$variable-prefix}gradient);\r\n          } @else {\r\n            background-image: escape-svg($form-check-input-checked-bg-image);\r\n          }\r\n    }\r\n}\r\n.gridjs-td{\r\n    .gridjs-checkbox{\r\n        width: $form-check-input-width;\r\n        height: $form-check-input-width;\r\n        vertical-align: top;\r\n        background-color: $form-check-input-bg;\r\n        background-repeat: no-repeat;\r\n        background-position: center;\r\n        background-size: contain;\r\n        border: $form-check-input-border;\r\n        appearance: none;\r\n        color-adjust: exact; // Keep themed appearance for print\r\n        @include transition($form-check-transition);\r\n        &[type=\"checkbox\"] {\r\n          @include border-radius($form-check-input-border-radius);\r\n        }\r\n    }\r\n}\r\n\r\n.gridjs-border-none{\r\n    td.gridjs-td, th.gridjs-th{\r\n        border-right-width: 0;\r\n        border-left-width: 0;\r\n    }\r\n}\r\n\r\n.gridjs-loading-bar {\r\n    background-color: $card-bg;\r\n}\r\n\r\n[data-layout-mode=\"dark\"]{\r\n    button{\r\n        &.gridjs-sort-neutral, &.gridjs-sort-asc, &.gridjs-sort-desc{\r\n            filter: $btn-close-white-filter;\r\n        }\r\n    }\r\n}","// \r\n// _listjs.scss\r\n// \r\n\r\n.listjs-pagination{\r\n    margin-bottom: 0;\r\n    justify-content: flex-end;\r\n    gap: 8px;\r\n    li{\r\n        .page{\r\n            display: block;\r\n            padding: $pagination-padding-y $pagination-padding-x;\r\n            color: $pagination-color;\r\n            background-color: $pagination-bg;\r\n            border: $pagination-border-width solid $pagination-border-color;\r\n            border-radius: $border-radius;\r\n        }\r\n\r\n        &.active{\r\n            .page{\r\n                color: $pagination-active-color;\r\n                @include gradient-bg($pagination-active-bg);\r\n                border-color: $pagination-active-border-color;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.pagination-wrap {\r\n    user-select: none;\r\n    display: flex;\r\n    align-items: center;\r\n    a {\r\n        text-decoration: none;\r\n        display: inline-block;\r\n    }\r\n}\r\n\r\n.pagination-next,\r\n.pagination-prev {\r\n    color: $primary;\r\n    font-weight: $font-weight-medium;\r\n    padding: $pagination-padding-y $pagination-padding-x;\r\n    background-color: $pagination-bg;\r\n    border: $pagination-border-width solid $pagination-border-color;\r\n    border-radius: $border-radius; \r\n    &:hover {\r\n        color: lighten($primary, 20%);\r\n    }\r\n\r\n    &.disabled {\r\n        color: $text-muted;\r\n        cursor: default;\r\n\r\n        &:hover {\r\n            color: $text-muted;\r\n        }\r\n    }\r\n}","//\r\n// apexcharts.scss\r\n//\r\n\r\n.apex-charts {\r\n    min-height: 10px !important;\r\n    text {\r\n        font-family: $font-family-base !important;\r\n    }\r\n    .apexcharts-canvas {\r\n        margin: 0 auto;\r\n    }\r\n}\r\n\r\n.apexcharts-tooltip-title,\r\n.apexcharts-tooltip-text {\r\n    font-family: $font-family-base !important;\r\n}\r\n\r\n.apexcharts-tooltip{\r\n    border: 1px solid $border-color !important;\r\n    background-color: $card-bg !important;\r\n    box-shadow: $box-shadow !important;\r\n    * {\r\n        font-family: $font-family-base !important;\r\n        color: $gray-600 !important;\r\n    }\r\n\r\n    .apexcharts-tooltip-title{\r\n        background-color: rgba(var(--#{$variable-prefix}light-rgb), .75) !important;\r\n        border-bottom: 1px solid $border-color !important;\r\n    }\r\n}\r\n\r\n.apexcharts-tooltip.apexcharts-theme-dark{\r\n    * {\r\n        color: $white !important;\r\n    }\r\n}\r\n\r\n.apexcharts-legend-series {\r\n    font-weight: $font-weight-medium;\r\n}\r\n\r\n.apexcharts-gridline {\r\n    pointer-events: none;\r\n    stroke: rgba(var(--#{$variable-prefix}light-rgb), .75);\r\n}\r\n\r\n.apexcharts-legend-text {\r\n    color: $gray-600 !important;\r\n    font-family: $font-family-base !important;\r\n    font-size: 13px !important;\r\n}\r\n\r\n.apexcharts-pie-label {\r\n    fill: $white !important;\r\n}\r\n\r\n.apexcharts-title-text, .apexcharts-subtitle-text{\r\n    fill: $gray-500;\r\n}\r\n\r\n.apexcharts-yaxis,\r\n.apexcharts-xaxis {\r\n    text {\r\n        font-family: $font-family-base !important;\r\n        fill: $gray-500;\r\n    }\r\n}\r\n\r\n.apexcharts-yaxis-title {\r\n    font-weight: 500;\r\n}\r\n\r\n// column dynamic loaded chart\r\n\r\n#dynamicloadedchart-wrap {\r\n    margin: 0px auto;\r\n    max-width: 800px;\r\n    position: relative;\r\n}\r\n\r\n.chart-box {\r\n    padding-left: 0;\r\n}\r\n\r\n#chart-year,\r\n#chart-quarter {\r\n    width: 96%;\r\n    max-width: 48%;\r\n    box-shadow: none;\r\n    padding-left: 0;\r\n    padding-top: 20px;\r\n    background: $card-bg;\r\n    border: 1px solid $border-color;\r\n}\r\n\r\n#chart-year {\r\n    float: left;\r\n    position: relative;\r\n    transition: 1s ease transform;\r\n    z-index: 3;\r\n    &.chart-quarter-activated {\r\n        transform: translateX(0);\r\n        transition: 1s ease transform;\r\n    }\r\n}\r\n\r\n#chart-quarter {\r\n    float: left;\r\n    position: relative;\r\n    z-index: -2;\r\n    transition: 1s ease transform;\r\n    &.active {\r\n        transition: 1.1s ease-in-out transform;\r\n        transform: translateX(0);\r\n        z-index: 1;\r\n    }\r\n}\r\n\r\n@media screen and (min-width: 480px) {\r\n    #chart-year {\r\n        transform: translateX(50%);\r\n    }\r\n    #chart-quarter {\r\n        transform: translateX(-50%);\r\n    }\r\n}\r\n\r\n// radar chart\r\n\r\n.apexcharts-radar-series{\r\n    polygon, line{\r\n        stroke: $border-color;\r\n    }\r\n}\r\n\r\n.apexcharts-pie{\r\n    circle ,line{\r\n        stroke: $border-color;\r\n    }\r\n    text{\r\n        fill: var(--#{$variable-prefix}body-color);\r\n    }\r\n}","\r\n//\r\n// _chartjs.scss\r\n//\r\n\r\n.chartjs-chart{\r\n  max-height: 320px;\r\n}\r\n  ","//\r\n// echarts.scss\r\n//\r\n\r\n.e-charts{\r\n    height: 350px;\r\n}\r\n\r\n.e-charts-height{\r\n    height: 300px;\r\n}","\r\n//\r\n// _google-map.scss\r\n//\r\n\r\n.gmaps, .gmaps-panaroma {\r\n  height: 300px;\r\n  background: $gray-100;\r\n  border-radius: 3px;\r\n}\r\n\r\n.gmaps-overlay {\r\n  display: block;\r\n  text-align: center;\r\n  color: $white;\r\n  font-size: 16px;\r\n  line-height: 40px;\r\n  background: $primary;\r\n  border-radius: 4px;\r\n  padding: 10px 20px;\r\n}\r\n\r\n.gmaps-overlay_arrow {\r\n  left: 50%;\r\n  margin-left: -16px;\r\n  width: 0;\r\n  height: 0;\r\n  position: absolute;\r\n  &.above {\r\n    bottom: -15px;\r\n    border-left: 16px solid transparent;\r\n    border-right: 16px solid transparent;\r\n    border-top: 16px solid $primary;\r\n  }\r\n  &.below {\r\n    top: -15px;\r\n    border-left: 16px solid transparent;\r\n    border-right: 16px solid transparent;\r\n    border-bottom: 16px solid $primary;\r\n  }\r\n  \r\n}","//\r\n// _autocomplete.scss\r\n//\r\n\r\n.autoComplete_wrapper {\r\n    display: block;\r\n\r\n    >input {\r\n        display: block;\r\n        width: 100%;\r\n        height: auto;\r\n        padding: $input-padding-y $input-padding-x;\r\n        font-family: $input-font-family;\r\n        font-size: $input-font-size;\r\n        font-weight: $input-font-weight;\r\n        line-height: $input-line-height;\r\n        color: $input-color;\r\n        background-color: $input-bg;\r\n        background-clip: padding-box;\r\n        border: $input-border-width solid $input-border-color;\r\n        border-radius: $input-border-radius;\r\n        background-image: none;\r\n\r\n        &::placeholder {\r\n            padding: 0 !important;\r\n            color: $input-placeholder-color !important;\r\n            font-size: $input-font-size !important;\r\n        }\r\n\r\n        &:focus {\r\n            border: $input-border-width solid $input-focus-border-color;\r\n            color: $input-focus-color;\r\n        }\r\n\r\n        &:hover {\r\n            color: $input-color;\r\n        }\r\n    }\r\n\r\n    >ul {\r\n        border-radius: $border-radius;\r\n        border-color: $dropdown-border-color;\r\n        background-color: $dropdown-bg;\r\n        box-shadow: $dropdown-box-shadow;\r\n        padding: 0;\r\n        overflow: auto;\r\n        max-height: 160px;\r\n        margin: 0;\r\n        animation-name: DropDownSlide;\r\n        animation-duration: .3s;\r\n        animation-fill-mode: both;\r\n\r\n        > li {\r\n            font-size: $dropdown-font-size;\r\n            margin: 0;\r\n            padding: $dropdown-item-padding-y $dropdown-item-padding-x;\r\n            border-radius: 0;\r\n            background-color: $dropdown-bg;\r\n            color: $dropdown-color;\r\n\r\n            mark {\r\n                color: $danger;\r\n                font-weight: $font-weight-semibold;\r\n                padding: 1px;\r\n            }\r\n\r\n            &[aria-selected=true],\r\n            &:hover {\r\n                color: $dropdown-link-hover-color;\r\n                @include gradient-bg($dropdown-link-hover-bg);\r\n            }\r\n        }\r\n\r\n        .no_result {\r\n            padding: $dropdown-item-padding-y *2 $dropdown-item-padding-x;\r\n            font-style: italic;\r\n            font-weight: $font-weight-medium;\r\n        }\r\n    }\r\n}","//\r\n// vector-maps.scss\r\n//\r\n\r\n.jvm-tooltip {\r\n    border-radius: 3px;\r\n    background-color: $primary;\r\n    font-family: $font-family-base;\r\n    box-shadow: $box-shadow-lg;\r\n    padding: 5px 9px;\r\n}\r\n\r\n.jvm-container {\r\n    text {\r\n        font-family: $font-family-base;\r\n        font-size: $font-size-base;\r\n        fill: var(--#{$variable-prefix}gray-700);\r\n    }\r\n}\r\n\r\n.jvm-zoom-btn {\r\n    background-color: $primary;\r\n}","//\r\n// _leaflet-maps.scss\r\n//\r\n\r\n.leaflet-map {\r\n    height: 300px;\r\n    &.leaflet-container{\r\n        z-index: 0;\r\n        font-family: $font-family-primary;\r\n    }\r\n}","// \r\n// _fullcalendar.scss\r\n// \r\n\r\n\r\n.fc td,\r\n.fc th {\r\n    border: $table-border-width solid $table-border-color;\r\n}\r\n\r\n.fc {\r\n    .fc-toolbar {\r\n        h2 {\r\n            font-size: 16px;\r\n            line-height: 30px;\r\n            text-transform: uppercase;\r\n        }\r\n\r\n        @media (max-width: 767.98px) {\r\n\r\n            .fc-left,\r\n            .fc-right,\r\n            .fc-center {\r\n                float: none;\r\n                display: block;\r\n                text-align: center;\r\n                clear: both;\r\n                margin: 10px 0;\r\n            }\r\n\r\n            >*>* {\r\n                float: none;\r\n            }\r\n\r\n            .fc-today-button {\r\n                display: none;\r\n            }\r\n        }\r\n\r\n        .btn {\r\n            text-transform: capitalize;\r\n        }\r\n    }\r\n\r\n    .fc-col-header-cell {\r\n        background-color: var(--#{$variable-prefix}light);\r\n    }\r\n\r\n    .fc-col-header-cell-cushion {\r\n        display: block;\r\n        padding: 8px 4px;\r\n    }\r\n\r\n    .fc-daygrid-day-number {\r\n        width: 24px;\r\n        height: 24px;\r\n        border-radius: 50%;\r\n        padding: 0;\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n        font-size: 12px;\r\n        font-weight: $font-weight-medium;\r\n        margin: 2px;\r\n    }\r\n\r\n    .fc-daygrid-day {\r\n        &.fc-day-today {\r\n            background-color: rgba($primary, 0.1);\r\n    \r\n            .fc-daygrid-day-number {\r\n                background-color: $primary;\r\n                color: $white;\r\n            }\r\n        }\r\n    }\r\n\r\n    .fc-daygrid-day {\r\n        &.fc-day-today {\r\n            background-color: rgba($primary, 0.1);\r\n        }\r\n    }\r\n    \r\n    .fc-timegrid-col {\r\n        &.fc-day-today {\r\n            background-color: rgba($primary, 0.1);\r\n        }\r\n    }\r\n\r\n    .fc-list-event:hover td {\r\n        background: transparent;\r\n    }\r\n\r\n    .fc-list-event-title {\r\n        a {\r\n            color: $white !important;\r\n        }\r\n    }\r\n\r\n    .fc-col-header,\r\n    .fc-daygrid-body,\r\n    .fc-scrollgrid-sync-table {\r\n        width: 100% !important;\r\n    }\r\n\r\n    .fc-scrollgrid-section>*{\r\n        border-left: $table-border-width solid $table-border-color;\r\n        border-top: $table-border-width solid $table-border-color;\r\n    }\r\n\r\n    .fc-scrollgrid-section-liquid>td{\r\n        border-top: 0;\r\n    }\r\n}\r\n\r\n.fc-theme-bootstrap a:not([href]) {\r\n    color: var(--#{$variable-prefix}body-color);\r\n}\r\n\r\n.fc-event {\r\n    color: $white;\r\n}\r\n\r\n.fc {\r\n    th.fc-widget-header {\r\n        background: $gray-300;\r\n        line-height: 20px;\r\n        padding: 10px 0;\r\n        text-transform: uppercase;\r\n        font-weight: $font-weight-bold;\r\n    }\r\n}\r\n\r\n.fc-unthemed {\r\n\r\n    .fc-content,\r\n    .fc-divider,\r\n    .fc-list-heading td,\r\n    .fc-list-view,\r\n    .fc-popover,\r\n    .fc-row,\r\n    tbody,\r\n    td,\r\n    th,\r\n    thead {\r\n        border-color: $gray-300;\r\n    }\r\n\r\n    td.fc-today {\r\n        background: lighten($gray-200, 2%);\r\n    }\r\n}\r\n\r\n.fc-button {\r\n    background: $card-bg;\r\n    border-color: $border-color;\r\n    color: $gray-700;\r\n    text-transform: capitalize;\r\n    box-shadow: none;\r\n    padding: 6px 12px !important;\r\n    height: auto !important;\r\n}\r\n\r\n.fc-state-down,\r\n.fc-state-active,\r\n.fc-state-disabled {\r\n    background-color: $primary;\r\n    color: $white;\r\n    text-shadow: none;\r\n}\r\n\r\n.fc-event {\r\n    border-radius: 2px;\r\n    border: none;\r\n    cursor: move;\r\n    font-size: 0.8125rem;\r\n    margin: 5px 7px;\r\n    padding: 5px 5px;\r\n    text-align: center;\r\n}\r\n\r\n.fc-event,\r\n.fc-event-dot {\r\n    background-color: $primary;\r\n}\r\n\r\n.fc-daygrid-dot-event.fc-event-mirror,\r\n.fc-daygrid-dot-event:hover {\r\n    background-color: $primary;\r\n}\r\n\r\n// .fc-daygrid-dot-event {\r\n//     color: $white !important;\r\n// }\r\n\r\n.fc-event-title,\r\n.fc-sticky {\r\n    font-weight: $font-weight-semibold !important;\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n}\r\n\r\n.fc-daygrid-event-dot {\r\n    border-color: $white !important;\r\n    display: none;\r\n}\r\n\r\n.fc-event-time {\r\n    display: none;\r\n}\r\n\r\n.fc-event .fc-content {\r\n    color: $white;\r\n}\r\n\r\n#external-events {\r\n    .external-event {\r\n        text-align: left;\r\n        padding: 8px 16px;\r\n        margin: 6px 0;\r\n    }\r\n}\r\n\r\n\r\n.fc-day-grid-event.fc-h-event.fc-event.fc-start.fc-end.bg-dark {\r\n    .fc-content {\r\n        color: $light;\r\n    }\r\n}\r\n\r\n.fc-prev-button,\r\n.fc-next-button {\r\n    position: relative;\r\n    height: 37.5px;\r\n    width: 37.5px;\r\n\r\n    &::before {\r\n        position: absolute;\r\n        font-family: remixicon !important;\r\n        font-size: 20px;\r\n        top: 0;\r\n        bottom: 0px;\r\n        left: 0;\r\n        right: 0;\r\n        display: flex;\r\n        align-items: center;\r\n        justify-content: center;\r\n    }\r\n}\r\n\r\n.fc-prev-button {\r\n    &::before {\r\n        content: \"\\ea64\";\r\n    }\r\n}\r\n\r\n.fc-next-button {\r\n    &::before {\r\n        content: \"\\ea6e\";\r\n    }\r\n}\r\n\r\n.fc-toolbar-chunk {\r\n    .btn-group {\r\n        box-shadow: $element-shadow;\r\n        .btn {\r\n            color: $secondary;\r\n            background-color: rgba($secondary, 0.15);\r\n            border: none;\r\n            box-shadow: none;\r\n\r\n            &:hover,\r\n            &.active {\r\n                color: $white;\r\n                background-color: $secondary;\r\n            }\r\n        }\r\n    }\r\n\r\n    .fc-today-button {\r\n        background-color: $secondary !important;\r\n        border: $secondary;\r\n    }\r\n}\r\n\r\n.fc-toolbar {\r\n    @media (max-width: 575.98px) {\r\n        flex-direction: column;\r\n        gap: 16px;\r\n    }\r\n}\r\n\r\n#upcoming-event-list {\r\n    .card {\r\n        &:last-child {\r\n            margin-bottom: 6px !important;\r\n        }\r\n    }\r\n}\r\n\r\n#event-modal {\r\n    .event-details {\r\n        display: none;\r\n    }\r\n\r\n    .view-event {\r\n        .event-form {\r\n            display: none;\r\n        }\r\n\r\n        #event-category-tag {\r\n            display: none;\r\n        }\r\n\r\n        .event-details {\r\n            display: block;\r\n        }\r\n    }\r\n}\r\n\r\n.fc-daygrid-event-harness {\r\n    .fc-daygrid-event {\r\n        backdrop-filter: blur(4px);\r\n    }\r\n}\r\n\r\n.fc-timegrid-event-harness {\r\n    .fc-timegrid-event {\r\n        backdrop-filter: blur(4px);\r\n    }\r\n}\r\n\r\n\r\n.fc-timegrid-slots {\r\n    table {\r\n        tr {\r\n            border-color: $border-color !important;\r\n        }\r\n    }\r\n}\r\n\r\n.fc-list-table {\r\n    border-color: $border-color;\r\n}\r\n\r\n@each $color,\r\n$value in $theme-colors {\r\n    .fc-daygrid-event-harness {\r\n        .fc-daygrid-event {\r\n            &.bg-soft-#{$color} {\r\n\r\n                .fc-event-title,\r\n                .fc-event-main {\r\n                    color: $value !important;\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    .fc-timegrid-event-harness {\r\n        .fc-timegrid-event {\r\n            &.bg-soft-#{$color} {\r\n                .fc-event-title {\r\n                    color: $value !important;\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    .fc-list-table {\r\n        .fc-list-event {\r\n            &.bg-soft-#{$color} {\r\n                color: $value !important;\r\n\r\n                .fc-list-event-title {\r\n                    >a {\r\n                        color: $value !important;\r\n                    }\r\n                }\r\n\r\n                .fc-list-event-dot {\r\n                    border-color: $value;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.fc-daygrid-event-harness .fc-daygrid-event.bg-soft-dark{\r\n    .fc-event-main, .fc-event-title {\r\n        color:  var(--#{$variable-prefix}dark) !important;\r\n    }\r\n}\r\n\r\n.fc-direction-ltr{\r\n    direction: ltr;\r\n    .fc-toolbar>*>:not(:first-child){\r\n        margin-left: 0.75em;\r\n    }\r\n}","//\r\n// emoji-picker.scss\r\n//\r\n\r\n.fg-emoji-picker{\r\n    width: 250px !important;\r\n    box-shadow: $box-shadow !important;\r\n    top: auto !important;\r\n    bottom: 130px;\r\n\r\n    *{\r\n        font-family: $font-family-base !important;\r\n        color: $body-color !important;\r\n    }\r\n    @media (max-width:991.98px) {\r\n        left: 14px !important;\r\n        top: auto !important;\r\n        bottom: 118px;\r\n    }\r\n\r\n    .fg-emoji-picker-container-title{\r\n        color: $dark !important;\r\n    }\r\n\r\n    .fg-emoji-picker-search{\r\n        height: 40px !important;\r\n        input{\r\n            background-color: $input-bg !important;\r\n            color: $input-color !important;\r\n            padding: $input-btn-padding-y $input-btn-padding-x !important;\r\n            font-size: $font-size-base !important;\r\n            &::placeholder{\r\n                color: $input-placeholder-color !important;\r\n            }\r\n        }\r\n\r\n        svg{\r\n            fill: $body-color !important;\r\n            right: 11px;\r\n            top: 12px;\r\n        }\r\n    }\r\n\r\n    .fg-emoji-picker-categories{\r\n        background-color: $light !important;\r\n        li.active{\r\n            background-color: rgba(var(--bs-primary-rgb), 0.2);\r\n        }\r\n        a{\r\n            &:hover{\r\n                background-color: rgba(var(--bs-primary-rgb), 0.2);\r\n            }\r\n        }\r\n        \r\n    }\r\n}\r\n\r\n.fg-emoji-picker-grid > li:hover{\r\n    background-color: rgba(var(--bs-primary-rgb), 0.2) !important;\r\n}\r\n\r\na.fg-emoji-picker-close-button{\r\n    background-color: darken($light, 4%) !important;\r\n}","// \r\n// toastify.scss\r\n// \r\n\r\n\r\n.toastify {\r\n    padding: 12px 16px;\r\n    color: $white;\r\n    display: inline-block;\r\n    box-shadow: 0 3px 6px -1px rgba(0, 0, 0, 0.12), 0 10px 36px -4px rgba(77, 96, 232, 0.3);\r\n    background: $success;\r\n    position: fixed;\r\n    opacity: 0;\r\n    transition: all 0.4s cubic-bezier(0.215, 0.61, 0.355, 1);\r\n    border-radius: 2px;\r\n    cursor: pointer;\r\n    text-decoration: none;\r\n    max-width: calc(50% - 20px);\r\n    z-index: 2147483647;\r\n    &.on {\r\n        opacity: 1;\r\n    }\r\n}\r\n\r\n\r\n.toast-close {\r\n    opacity: 0.4;\r\n    padding: 0 5px;\r\n    position: relative;\r\n    left: 4px;\r\n    margin-left: 4px;\r\n}\r\n\r\n.toastify-right {\r\n    right: 15px;\r\n}\r\n\r\n.toastify-left {\r\n    left: 15px;\r\n    .toast-close {\r\n        left: -4px;\r\n        margin-left: 0;\r\n        margin-right: 4px;\r\n    }\r\n}\r\n\r\n.toastify-top {\r\n    top: -150px;\r\n}\r\n\r\n.toastify-bottom {\r\n    bottom: -150px;\r\n}\r\n\r\n.toastify-rounded {\r\n    border-radius: 25px;\r\n}\r\n\r\n.toastify-avatar {\r\n    width: 1.5em;\r\n    height: 1.5em;\r\n    margin: -7px 5px;\r\n    border-radius: 2px;\r\n}\r\n\r\n.toastify-center {\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n    left: 0;\r\n    right: 0;\r\n    max-width: fit-content;\r\n    max-width: -moz-fit-content;\r\n}\r\n\r\n@media only screen and (max-width: 360px) {\r\n    .toastify-right, .toastify-left {\r\n        margin-left: auto;\r\n        margin-right: auto;\r\n        left: 0;\r\n        right: 0;\r\n        max-width: fit-content;\r\n    }\r\n}","//\r\n// _choices.scss\r\n//\r\n\r\n.choices {\r\n    position: relative;\r\n    margin-bottom: 24px;\r\n    font-size: 16px;\r\n\r\n    &:focus {\r\n        outline: none;\r\n    }\r\n\r\n    &:last-child {\r\n        margin-bottom: 0;\r\n    }\r\n\r\n    &.is-disabled{\r\n        .choices__inner,\r\n        .choices__input {\r\n            background-color: rgba(var(--#{$variable-prefix}light-rgb), 0.75);\r\n            cursor: not-allowed;\r\n            user-select: none;\r\n        }\r\n\r\n        .choices__item {\r\n            cursor: not-allowed;\r\n        }\r\n    }\r\n\r\n    [hidden] {\r\n        display: none !important;\r\n    }\r\n    \r\n    // data-type = select-one\r\n    &[data-type*='select-one'] {\r\n        cursor: pointer;\r\n        .choices__inner{\r\n            padding-bottom: 0.25rem;\r\n        }\r\n\r\n        .choices__input{\r\n            display: block;\r\n            width: 100%;\r\n            padding: $input-padding-y $input-padding-x;\r\n            background-color: $input-bg;\r\n            border: 1px solid $input-border-color;\r\n            font-size: $input-font-size;\r\n            border-radius: $input-border-radius;\r\n            color: $input-color;\r\n            margin-bottom: 10px;\r\n        }\r\n\r\n        .choices__button{\r\n            background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyMSAyMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSIjMDAwIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik0yLjU5Mi4wNDRsMTguMzY0IDE4LjM2NC0yLjU0OCAyLjU0OEwuMDQ0IDIuNTkyeiIvPjxwYXRoIGQ9Ik0wIDE4LjM2NEwxOC4zNjQgMGwyLjU0OCAyLjU0OEwyLjU0OCAyMC45MTJ6Ii8+PC9nPjwvc3ZnPg==);\r\n            padding: 0;\r\n            background-size: 8px;\r\n            position: absolute;\r\n            top: 50%;\r\n            right: 0;\r\n            left: auto;\r\n            margin-top: -10px;\r\n            margin-right: 25px;\r\n            margin-left: 0;\r\n            height: 20px;\r\n            width: 20px;\r\n            border-radius: 10em;\r\n            opacity: 0.5;\r\n\r\n            &:hover, &:focus {\r\n                opacity: 1;\r\n            }\r\n\r\n            &:focus {\r\n                box-shadow: 0px 0px 0px 2px #00bcd4;\r\n            }\r\n        }\r\n\r\n        .choices__item[data-value=''] .choices__button {\r\n            display: none;\r\n        }\r\n\r\n        &:after {\r\n            content: \"\\F0140\";\r\n            position: absolute;\r\n            border: 0;\r\n            border-color: $dark transparent transparent;\r\n            right: 11.5px;\r\n            left: auto;\r\n            font-family: 'Material Design Icons';\r\n            width: auto;\r\n            height: auto;\r\n            margin-top: 0;\r\n            top: 50%;\r\n            transform: translateY(-50%);\r\n            pointer-events: none;\r\n        }\r\n\r\n        &.is-open:after {\r\n            margin-top: 0;\r\n            transform: translateY(-50%) rotate(-180deg);\r\n        }\r\n\r\n    }\r\n\r\n\r\n    // data-type = select- multiple & text\r\n\r\n    &[data-type*='select-multiple'],\r\n    &[data-type*='text'] {\r\n        .choices__inner {\r\n            cursor: text;\r\n            padding-right: $form-select-padding-x;\r\n        }\r\n\r\n        .choices__button {\r\n            position: relative;\r\n            display: inline-block;\r\n            margin-top: 0;\r\n            margin-right: -4px;\r\n            margin-bottom: 0;\r\n            margin-left: 8px;\r\n            padding-left: 16px;\r\n            border-left: 1px solid rgba($white, 0.5);\r\n            border-right: 0;\r\n            background-image: url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjEiIGhlaWdodD0iMjEiIHZpZXdCb3g9IjAgMCAyMSAyMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48ZyBmaWxsPSIjRkZGIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiPjxwYXRoIGQ9Ik0yLjU5Mi4wNDRsMTguMzY0IDE4LjM2NC0yLjU0OCAyLjU0OEwuMDQ0IDIuNTkyeiIvPjxwYXRoIGQ9Ik0wIDE4LjM2NEwxOC4zNjQgMGwyLjU0OCAyLjU0OEwyLjU0OCAyMC45MTJ6Ii8+PC9nPjwvc3ZnPg==);\r\n            background-size: 8px;\r\n            width: 8px;\r\n            line-height: 1;\r\n            opacity: 0.75;\r\n            border-radius: 0;\r\n            &:hover, &:focus {\r\n                opacity: 1;\r\n            }\r\n        }\r\n        .choices__list--dropdown{\r\n            padding-bottom: 10px;\r\n            .choices__list{\r\n                margin-bottom: 0;\r\n            }\r\n        }\r\n    }\r\n\r\n    &[data-type*=select-multiple] {\r\n        .choices__input {\r\n            padding-top: 3px;\r\n        }\r\n    }\r\n}\r\n\r\n//Select Light\r\n.input-light {\r\n    .choices__inner { \r\n        background-color: var(--#{$variable-prefix}light);\r\n        border: none;\r\n    }\r\n}\r\n  \r\n.choices__inner {\r\n    display: inline-block;\r\n    vertical-align: middle;\r\n    width: 100%;\r\n    background-color: $form-select-bg;\r\n    padding: 0.25rem ($form-select-padding-x + $form-select-indicator-padding) 0.1rem 0.5rem;\r\n    border: $form-select-border-width solid $form-select-border-color;\r\n    border-radius: $form-select-border-radius !important;\r\n    font-size: $input-font-size;\r\n    min-height: 37.5px;\r\n    overflow: hidden;\r\n}\r\n\r\n  \r\n.is-focused,\r\n.is-open {\r\n    .choices__inner {\r\n        border-color: $input-focus-border-color;\r\n    }\r\n}\r\n  \r\n.choices__list {\r\n    margin: 0;\r\n    padding-left: 0;\r\n    list-style: none;\r\n}\r\n  \r\n.choices__list--single {\r\n    display: inline-block;\r\n    padding: 4px 16px 4px 4px;\r\n    width: 100%;\r\n\r\n    .choices__item {\r\n        width: 100%;\r\n    }\r\n}\r\n\r\n.choices__list--multiple {\r\n    display: inline;\r\n    .choices__item {\r\n        display: inline-block;\r\n        vertical-align: initial;\r\n        border-radius: 7px;\r\n        padding: 2px 7px;\r\n        font-size: 11px;\r\n        font-weight: $font-weight-normal;\r\n        margin-right: 3.75px;\r\n        margin-bottom: 3.75px;\r\n        margin-top: 2px;\r\n        background-color: $primary;\r\n        border: 1px solid $primary;\r\n        word-break: break-all;\r\n        box-sizing: border-box;\r\n        color: $white;\r\n        box-shadow: $element-shadow;\r\n        &[data-deletable] {\r\n            padding-right: 5px;\r\n        }\r\n\r\n        &.is-highlighted {\r\n            background-color: $primary;\r\n            border: 1px solid $primary;\r\n        }\r\n    }\r\n}\r\n\r\n  \r\n.is-disabled {\r\n    .choices__list--multiple {\r\n        .choices__item {\r\n            background-color: $secondary;\r\n            border: 1px solid $secondary\r\n        }\r\n    }\r\n}\r\n  \r\n.choices__list--dropdown {\r\n    visibility: hidden;\r\n    z-index: 1;\r\n    position: absolute;\r\n    width: 100%;\r\n    background-color: $dropdown-bg;\r\n    border: 1px solid $dropdown-border-color;\r\n    box-shadow: $dropdown-box-shadow;\r\n    top: 100%;\r\n    margin-top: 0;\r\n    padding: 10px 10px 20px 10px;\r\n    border-bottom-left-radius: 2.5px;\r\n    border-bottom-right-radius: 2.5px;\r\n    overflow: hidden;\r\n    word-break: break-all;\r\n    will-change: visibility;\r\n    animation-duration: .3s;\r\n    animation-fill-mode: both;\r\n    transform: translateY(1px);\r\n    &.is-active {\r\n        visibility: visible;\r\n        animation-name: DropDownSlide;\r\n    }\r\n\r\n    .choices__item--selectable.is-highlighted {\r\n        background-color: $dropdown-link-hover-bg;\r\n    }\r\n\r\n    .choices__list {\r\n        margin: 0 -16px -16px;\r\n    }\r\n\r\n    .has-no-results {\r\n        font-style: italic;\r\n        font-weight: $font-weight-medium;\r\n    }\r\n\r\n    .choices__item--selectable:after{\r\n        display: none;\r\n    }\r\n}\r\n  \r\n.is-open{\r\n    .choices__list--dropdown {\r\n        border-color: $dropdown-border-color;\r\n    }\r\n}\r\n  \r\n.is-flipped{\r\n    .choices__list--dropdown {\r\n        top: auto;\r\n        bottom: 100%;\r\n        margin-top: 0;\r\n        margin-bottom: -1px;\r\n        border-radius: 0.25rem 0.25rem 0 0;\r\n        &.is-active {\r\n            animation-name: DropDownSlideDown;\r\n            transform: translateY(-1px);\r\n        }\r\n    }\r\n}\r\n  \r\n.choices__list--dropdown{\r\n    .choices__list {\r\n        position: relative;\r\n        max-height: 300px;\r\n        overflow: auto;\r\n        -webkit-overflow-scrolling: touch;\r\n        will-change: scroll-position;\r\n    }\r\n\r\n    .choices__item {\r\n        position: relative;\r\n        font-size: $dropdown-font-size;\r\n        padding: $dropdown-item-padding-y $dropdown-item-padding-x $dropdown-item-padding-y 16px;\r\n    }\r\n}\r\n  \r\n\r\n  \r\n@media (min-width: 640px) {\r\n    .choices__list--dropdown {\r\n        .choices__item--selectable {\r\n\r\n            &:after {\r\n                content: attr(data-select-text);\r\n                font-size: 12px;\r\n                opacity: 0;\r\n                position: absolute;\r\n                right: 10px;\r\n                top: 50%;\r\n                transform: translateY(-50%);\r\n            }\r\n\r\n            &.is-highlighted {\r\n                &:after {\r\n                    opacity: 0.5;\r\n                }\r\n            }\r\n        }\r\n    }\r\n    \r\n\r\n}\r\n  \r\n.choices__item {\r\n    cursor: default;\r\n}\r\n  \r\n.choices__item--selectable {\r\n    cursor: pointer;\r\n}\r\n  \r\n.choices__item--disabled {\r\n    cursor: not-allowed;\r\n    user-select: none;\r\n    opacity: 0.5;\r\n}\r\n  \r\n.choices__heading {\r\n    font-weight: $font-weight-semibold;\r\n    font-size: 12px;\r\n    padding: 10px 16px;\r\n    border-bottom: 1px solid $border-color;\r\n    color: $text-muted;\r\n}\r\n  \r\n.choices__button {\r\n    text-indent: -9999px;\r\n    appearance: none;\r\n    border: 0;\r\n    background-color: transparent;\r\n    background-repeat: no-repeat;\r\n    background-position: center;\r\n    cursor: pointer;\r\n    &:focus {\r\n        outline: none;\r\n    }\r\n}\r\n  \r\n.choices__input {\r\n    display: inline-block;\r\n    vertical-align: baseline;\r\n    background-color: $input-bg;\r\n    color: $input-color;\r\n    font-size: $input-font-size;\r\n    margin-bottom: 0;\r\n    border: 0;\r\n    border-radius: 0;\r\n    max-width: 100%;\r\n    padding: 2px 0 2px 2px;\r\n    &:focus {\r\n        outline: 0;\r\n    }\r\n    &::placeholder {\r\n        color: $input-placeholder-color;\r\n    }\r\n}\r\n  \r\n.choices__placeholder {\r\n    color: $input-placeholder-color;\r\n    opacity: 1;\r\n}\r\n\r\n\r\n[data-layout-mode=\"dark\"]{\r\n    .choices[data-type*=select-one]{\r\n        .choices__button{\r\n            filter: $btn-close-white-filter;\r\n        }\r\n    }\r\n}","//\r\n// _flatpicker.scss\r\n//\r\n\r\n.flatpickr-calendar {\r\n    background: transparent;\r\n    opacity: 0;\r\n    display: none;\r\n    text-align: center;\r\n    visibility: hidden;\r\n    padding: 0;\r\n    animation: none;\r\n    direction: ltr;\r\n    border: 0;\r\n    font-size: 14px;\r\n    line-height: 24px;\r\n    border-radius: 5px;\r\n    position: absolute;\r\n    width: 307.875px;\r\n    box-sizing: border-box;\r\n    touch-action: manipulation;\r\n    background: $dropdown-bg;\r\n    box-shadow: 1px 0 0 $border-color, -1px 0 0 $border-color, 0 1px 0 $border-color, 0 -1px 0 $border-color, 0 3px 13px rgba(0, 0, 0, 0.08);\r\n\r\n    &.open,\r\n    &.inline {\r\n        opacity: 1;\r\n        max-height: 640px;\r\n        visibility: visible;\r\n    }\r\n\r\n    &.open {\r\n        display: inline-block;\r\n        z-index: 1;\r\n    }\r\n\r\n    &.animate.open {\r\n            animation: fpFadeInDown 300ms cubic-bezier(0.23, 1, 0.32, 1);\r\n    }\r\n\r\n    &.inline {\r\n        display: block;\r\n        position: relative;\r\n        top: 2px;\r\n        width: 100%;\r\n        box-shadow: none;\r\n\r\n        .flatpickr-rContainer {\r\n            display: block;\r\n            width: 100%;\r\n\r\n            .flatpickr-days {\r\n                width: 100%;\r\n                border: $input-border-width solid $input-border-color;\r\n                border-top: none;\r\n                border-radius: 0 0 5px 5px;\r\n\r\n\r\n                .dayContainer {\r\n                    width: 100%;\r\n                    min-width: 100%;\r\n                    max-width: 100%;\r\n\r\n                    .flatpickr-day {\r\n                        max-width: 100%;\r\n                        border-radius: 4px;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n\r\n        .flatpickr-time {\r\n            border: $input-border-width solid $input-border-color !important;\r\n            border-radius: $input-border-radius;\r\n        }\r\n    }\r\n\r\n    &.static {\r\n        position: absolute;\r\n        top: calc(100% + 2px);\r\n        &.open {\r\n            z-index: 999;\r\n            display: block;\r\n        }\r\n    }\r\n\r\n    &.multiMonth .flatpickr-days .dayContainer:nth-child(n+1) .flatpickr-day.inRange:nth-child(7n+7) {\r\n        box-shadow: none !important;\r\n    }\r\n\r\n    &.multiMonth .flatpickr-days .dayContainer:nth-child(n+2) .flatpickr-day.inRange:nth-child(7n+1) {\r\n        box-shadow: -2px 0 0 #e6e6e6, 5px 0 0 #e6e6e6;\r\n    }\r\n\r\n    .hasWeeks .dayContainer,\r\n    .hasTime .dayContainer {\r\n        border-bottom: 0;\r\n        border-bottom-right-radius: 0;\r\n        border-bottom-left-radius: 0;\r\n    }\r\n\r\n    .hasWeeks .dayContainer {\r\n        border-left: 0;\r\n    }\r\n\r\n    &.hasTime .flatpickr-time {\r\n        height: 40px;\r\n        border-top: 1px solid $border-color;\r\n    }\r\n\r\n    &.noCalendar.hasTime .flatpickr-time {\r\n        height: auto;\r\n    }\r\n\r\n    &::before,\r\n    &::after {\r\n        position: absolute;\r\n        display: block;\r\n        pointer-events: none;\r\n        border: solid transparent;\r\n        content: '';\r\n        height: 0;\r\n        width: 0;\r\n        left: 22px;\r\n    }\r\n\r\n    &.rightMost::before,\r\n    &.arrowRight::before,\r\n    &.rightMost::after,\r\n    &.arrowRight::after {\r\n      left: auto;\r\n      right: 22px;\r\n    }\r\n\r\n    &.arrowCenter::before,\r\n    &.arrowCenter::after {\r\n      left: 50%;\r\n      right: 50%;\r\n    }\r\n\r\n    &::before {\r\n        border-width: 5px;\r\n        margin: 0 -5px;\r\n    }\r\n    &::after {\r\n        border-width: 4px;\r\n        margin: 0 -4px;\r\n    }\r\n\r\n    &.arrowTop::before,\r\n    &.arrowTop::after {\r\n        bottom: 100%;\r\n    }\r\n    &.arrowTop::before {\r\n        border-bottom-color: #e6e6e6;\r\n    }\r\n    &.arrowTop::after {\r\n        border-bottom-color: $white;\r\n    }\r\n\r\n    &.arrowBottom::before,\r\n    &.arrowBottom::after {\r\n        top: 100%;\r\n    }\r\n    &.arrowBottom::before {\r\n        border-top-color: #e6e6e6;\r\n    }\r\n    &.arrowBottom::after {\r\n        border-top-color: $white;\r\n    }\r\n    &:focus {\r\n        outline: 0;\r\n    }\r\n}\r\n\r\n.flatpickr-wrapper {\r\n    position: relative;\r\n    display: inline-block;\r\n}\r\n\r\n.flatpickr-months {\r\n    display: flex;\r\n    background-color: $primary;\r\n    border-radius: 5px 5px 0px 0px;\r\n\r\n    .flatpickr-month {\r\n        background: transparent;\r\n        color: rgba($white, 0.9);\r\n        fill: rgba($white, 0.9);\r\n        height: 34px;\r\n        line-height: 1;\r\n        text-align: center;\r\n        position: relative;\r\n        user-select: none;\r\n        overflow: hidden;\r\n        flex: 1;\r\n    }\r\n\r\n    .flatpickr-prev-month,\r\n    .flatpickr-next-month {\r\n        text-decoration: none;\r\n        cursor: pointer;\r\n        position: absolute;\r\n        top: 0;\r\n        height: 34px;\r\n        padding: 10px;\r\n        z-index: 3;\r\n        color: rgba($white, 0.9);\r\n        fill: rgba($white, 0.9);\r\n\r\n        &.flatpickr-disabled{\r\n          display: none;\r\n        }\r\n\r\n        i {\r\n            position: relative;\r\n        }\r\n\r\n        &.flatpickr-prev-month {\r\n            /*\r\n                  /*rtl:begin:ignore*/\r\n            /*\r\n                  */\r\n              left: 0;\r\n            /*\r\n                  /*rtl:end:ignore*/\r\n            /*\r\n                  */\r\n        }\r\n          /*\r\n        /*rtl:begin:ignore*/\r\n        /*\r\n        /*rtl:end:ignore*/\r\n\r\n        &.flatpickr-next-month {\r\n            /*\r\n                  /*rtl:begin:ignore*/\r\n            /*\r\n                  */\r\n              right: 0;\r\n            /*\r\n                  /*rtl:end:ignore*/\r\n            /*\r\n                  */\r\n        }\r\n          /*\r\n        /*rtl:begin:ignore*/\r\n        /*\r\n        /*rtl:end:ignore*/\r\n\r\n        &:hover {\r\n            color: #959ea9;\r\n\r\n            svg {\r\n                fill: rgba($white, 0.9);\r\n            }\r\n        }\r\n\r\n        svg {\r\n            width: 14px;\r\n            height: 14px;\r\n\r\n            path {\r\n                transition: fill 0.1s;\r\n                fill: inherit;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.numInputWrapper {\r\n    position: relative;\r\n    height: auto;\r\n\r\n    input,\r\n    span {\r\n        display: inline-block;\r\n    }\r\n\r\n    input {\r\n        width: 100%;\r\n\r\n        &::-ms-clear {\r\n            display: none;\r\n        }\r\n\r\n        &::-webkit-outer-spin-button,\r\n        &::-webkit-inner-spin-button {\r\n            margin: 0;\r\n            -webkit-appearance: none;\r\n        }\r\n    }\r\n\r\n    span {\r\n        position: absolute;\r\n        right: 0;\r\n        width: 14px;\r\n        padding: 0 4px 0 2px;\r\n        height: 50%;\r\n        line-height: 50%;\r\n        opacity: 0;\r\n        cursor: pointer;\r\n        border: 1px solid rgba(var(--#{$variable-prefix}dark-rgb),0.15);\r\n        box-sizing: border-box;\r\n\r\n        &:hover {\r\n            background: rgba(0,0,0,0.1);\r\n        }\r\n\r\n        &:active {\r\n            background: rgba(0,0,0,0.2);\r\n        }\r\n\r\n        &:after {\r\n            display: block;\r\n            content: \"\";\r\n            position: absolute;\r\n        }\r\n\r\n        &.arrowUp {\r\n            top: 0;\r\n            border-bottom: 0;\r\n\r\n            &:after {\r\n                border-left: 4px solid transparent;\r\n                border-right: 4px solid transparent;\r\n                border-bottom: 4px solid rgba(57,57,57,0.6);\r\n                top: 26%;\r\n            }\r\n        }\r\n\r\n        &.arrowDown {\r\n            top: 50%;\r\n\r\n            &:after {\r\n                border-left: 4px solid transparent;\r\n                border-right: 4px solid transparent;\r\n                border-top: 4px solid rgba(57,57,57,0.6);\r\n                top: 40%;\r\n            }\r\n        }\r\n\r\n        svg {\r\n            width: inherit;\r\n            height: auto;\r\n\r\n            path {\r\n                fill: rgba(0,0,0,0.5);\r\n            }\r\n        }\r\n    }\r\n\r\n\r\n    &:hover {\r\n        background: rgba(0,0,0,0.05);\r\n        span {\r\n            opacity: 1;\r\n        }\r\n    }\r\n}\r\n\r\n.flatpickr-current-month {\r\n    font-size: 100%;\r\n    line-height: inherit;\r\n    font-weight: 300;\r\n    color: inherit;\r\n    position: absolute;\r\n    width: 75%;\r\n    left: 12.5%;\r\n    padding: 7.48px 0 0 0;\r\n    line-height: 1;\r\n    height: 34px;\r\n    display: inline-block;\r\n    text-align: center;\r\n    transform: translate3d(0px, 0px, 0px);\r\n\r\n    span.cur-month {\r\n        font-family: inherit;\r\n        font-weight: 700;\r\n        color: inherit;\r\n        display: inline-block;\r\n        margin-left: 0.5ch;\r\n        padding: 0;\r\n\r\n        &:hover {\r\n            background: rgba(0,0,0,0.05);\r\n        }\r\n    }\r\n\r\n    .numInputWrapper {\r\n        width: 6ch;\r\n        width: 7ch\\0;\r\n        display: inline-block;\r\n    }\r\n\r\n    span{\r\n        &.arrowUp::after {\r\n            border-bottom-color: rgba(0,0,0,0.9);\r\n        }\r\n        &.arrowDown:after {\r\n            border-top-color: rgba(0,0,0,0.9);\r\n        }\r\n    }\r\n\r\n    input.cur-year {\r\n        background: transparent;\r\n        box-sizing: border-box;\r\n        color: inherit;\r\n        cursor: text;\r\n        padding: 0 0 0 0.5ch;\r\n        margin: 0;\r\n        display: inline-block;\r\n        font-size: inherit;\r\n        font-family: inherit;\r\n        font-weight: $font-weight-semibold;\r\n        line-height: inherit;\r\n        height: auto;\r\n        border: 0;\r\n        border-radius: 0;\r\n        vertical-align: initial;\r\n        appearance: textfield;\r\n\r\n        &:focus {\r\n            outline: 0;\r\n        }\r\n\r\n        &[disabled],\r\n        &[disabled]:hover {\r\n            font-size: 100%;\r\n            color: rgba($white, 0.9);\r\n            background: transparent;\r\n            pointer-events: none;\r\n        }\r\n    }\r\n\r\n    .flatpickr-monthDropdown-months {\r\n        appearance: menulist;\r\n        background: transparent;\r\n        border: none;\r\n        border-radius: 0;\r\n        box-sizing: border-box;\r\n        color: inherit;\r\n        cursor: pointer;\r\n        font-size: inherit;\r\n        font-family: inherit;\r\n        font-weight: $font-weight-semibold;\r\n        height: auto;\r\n        line-height: inherit;\r\n        margin: -1px 0 0 0;\r\n        outline: none;\r\n        padding: 0 0 0 0.5ch;\r\n        position: relative;\r\n        vertical-align: initial;\r\n        width: auto;\r\n\r\n        &:focus,\r\n        &:active {\r\n            outline: none;\r\n        }\r\n\r\n        &:hover {\r\n            background-color: transparent;\r\n        }\r\n\r\n        .flatpickr-monthDropdown-month {\r\n            background-color: transparent;\r\n            outline: none;\r\n            padding: 0;\r\n            color: rgba($black, 0.8);\r\n        }\r\n    }\r\n}\r\n\r\n\r\n.flatpickr-weekdays {\r\n    background-color: $primary;\r\n    text-align: center;\r\n    overflow: hidden;\r\n    width: 100%;\r\n    display: flex;\r\n    align-items: center;\r\n    height: 36px;\r\n    border-bottom: 1px solid $border-color;\r\n    .flatpickr-weekdaycontainer {\r\n        display: flex;\r\n        flex: 1;\r\n    }\r\n}\r\n\r\nspan.flatpickr-weekday {\r\n    cursor: default;\r\n    font-size: 90%;\r\n    background: transparent;\r\n    color: $white;\r\n    line-height: 1;\r\n    margin: 0;\r\n    text-align: center;\r\n    display: block;\r\n    flex: 1;\r\n    font-weight: $font-weight-medium;\r\n}\r\n\r\n.dayContainer,\r\n.flatpickr-weeks {\r\n    padding: 1px 0 0 0;\r\n}\r\n.flatpickr-days {\r\n    position: relative;\r\n    overflow: hidden;\r\n    display: flex;\r\n    align-items: flex-start;\r\n    width: 307.875px;\r\n    &:focus {\r\n        outline: 0;\r\n    }\r\n}\r\n\r\n.dayContainer {\r\n    padding: 0;\r\n    outline: 0;\r\n    text-align: left;\r\n    width: 307.875px;\r\n    min-width: 307.875px;\r\n    max-width: 307.875px;\r\n    box-sizing: border-box;\r\n    display: inline-block;\r\n    display: flex;\r\n    flex-wrap: wrap;\r\n    justify-content: space-around;\r\n    transform: translate3d(0px, 0px, 0px);\r\n    opacity: 1;\r\n    + .dayContainer {\r\n        box-shadow: -1px 0 0 #e6e6e6;\r\n    }\r\n}\r\n\r\n.flatpickr-day {\r\n    background: none;\r\n    border: 1px solid transparent;\r\n    border-radius: 150px;\r\n    box-sizing: border-box;\r\n    color: var(--#{$variable-prefix}body-color);\r\n    cursor: pointer;\r\n    font-weight: 400;\r\n    width: 14.2857143%;\r\n    flex-basis: 14.2857143%;\r\n    max-width: 39px;\r\n    height: 39px;\r\n    line-height: 39px;\r\n    margin: 0;\r\n    display: inline-block;\r\n    position: relative;\r\n    justify-content: center;\r\n    text-align: center;\r\n\r\n    &:hover,\r\n    &:focus {\r\n        background-color: rgba(var(--#{$variable-prefix}light-rgb), 0.7);\r\n    }\r\n\r\n    &.inRange,\r\n    &.prevMonthDay.inRange,\r\n    &.nextMonthDay.inRange,\r\n    &.today.inRange,\r\n    &.prevMonthDay.today.inRange,\r\n    &.nextMonthDay.today.inRange,\r\n    &:hover,\r\n    &.prevMonthDay:hover,\r\n    &.nextMonthDay:hover,\r\n    &:focus,\r\n    &.prevMonthDay:focus,\r\n    &.nextMonthDay:focus {\r\n        cursor: pointer;\r\n        outline: 0;\r\n        background-color: var(--#{$variable-prefix}light);\r\n        border-color: var(--#{$variable-prefix}light);\r\n    }\r\n\r\n    &.today {\r\n        border-color: $primary;\r\n        background-color: rgba($primary, 0.1);\r\n        box-shadow: $element-shadow;\r\n\r\n        &:hover,\r\n        &:focus {\r\n            border-color: $primary;\r\n            background-color: rgba($primary, 0.15);\r\n            color: var(--#{$variable-prefix}dark);\r\n        }\r\n    }\r\n\r\n    &.selected,\r\n    &.startRange,\r\n    &.endRange,\r\n    &.selected.inRange,\r\n    &.startRange.inRange,\r\n    &.endRange.inRange,\r\n    &.selected:focus,\r\n    &.startRange:focus,\r\n    &.endRange:focus,\r\n    &.selected:hover,\r\n    &.startRange:hover,\r\n    &.endRange:hover,\r\n    &.selected.prevMonthDay,\r\n    &.startRange.prevMonthDay,\r\n    &.endRange.prevMonthDay,\r\n    &.selected.nextMonthDay,\r\n    &.startRange.nextMonthDay,\r\n    &.endRange.nextMonthDay {\r\n        background: $primary;\r\n        box-shadow: $element-shadow;\r\n        color: $white;\r\n        border-color: $primary;\r\n    }\r\n\r\n    &.selected,\r\n    &.startRange,\r\n    &.endRange{\r\n        &.startRange {\r\n            border-radius: 50px 0 0 50px;\r\n            + .endRange:not(:nth-child(7n+1)) {\r\n                box-shadow: -10px 0 0 $primary;\r\n            }\r\n\r\n            .endRange{\r\n                border-radius: 50px;\r\n            }\r\n        }\r\n    }\r\n\r\n    &.selected,\r\n    &.startRange,\r\n    &.endRange{\r\n        &.endRange {\r\n            border-radius: 0 50px 50px 0;\r\n        }\r\n    }\r\n\r\n    &.inRange {\r\n        border-radius: 0;\r\n        box-shadow: -5px 0 0 var(--#{$variable-prefix}light), 5px 0 0 var(--#{$variable-prefix}light);\r\n    }\r\n\r\n    &.flatpickr-disabled,\r\n    &.flatpickr-disabled:hover,\r\n    &.prevMonthDay,\r\n    &.nextMonthDay,\r\n    &.notAllowed,\r\n    &.notAllowed.prevMonthDay,\r\n    &.notAllowed.nextMonthDay {\r\n        color: rgba(var(--#{$variable-prefix}body-color-rgb),0.3);\r\n        background: transparent;\r\n        border-color: transparent;\r\n        cursor: default;\r\n    }\r\n\r\n    &.flatpickr-disabled,\r\n    &.flatpickr-disabled:hover {\r\n        cursor: not-allowed;\r\n        color: rgba(var(--#{$variable-prefix}body-color-rgb),0.3);\r\n    }\r\n\r\n    &.week.selected {\r\n        border-radius: 0;\r\n        box-shadow: -5px 0 0 $primary, 5px 0 0 $primary;\r\n    }\r\n\r\n    &.hidden {\r\n        visibility: hidden;\r\n    }\r\n}\r\n\r\n.rangeMode .flatpickr-day {\r\n    margin-top: 1px;\r\n}\r\n\r\n.flatpickr-weekwrapper {\r\n    float: left;\r\n    .flatpickr-weeks {\r\n        padding: 0 12px;\r\n        box-shadow: 1px 0 0 #e6e6e6;\r\n    }\r\n\r\n    .flatpickr-weekday {\r\n        float: none;\r\n        width: 100%;\r\n        line-height: 28px;\r\n    }\r\n\r\n    span{\r\n        &.flatpickr-day,\r\n        &.flatpickr-day:hover {\r\n            display: block;\r\n            width: 100%;\r\n            max-width: none;\r\n            color: rgba(var(--#{$variable-prefix}dark-rgb),0.3);\r\n            background: transparent;\r\n            cursor: default;\r\n            border: none;\r\n        }\r\n    }\r\n}\r\n\r\n\r\n.flatpickr-innerContainer {\r\n    display: block;\r\n    display: flex;\r\n    box-sizing: border-box;\r\n    overflow: hidden;\r\n}\r\n\r\n.flatpickr-rContainer {\r\n    display: inline-block;\r\n    padding: 0;\r\n    box-sizing: border-box;\r\n}\r\n\r\n.flatpickr-time {\r\n    text-align: center;\r\n    outline: 0;\r\n    display: block;\r\n    height: 0;\r\n    line-height: 40px;\r\n    max-height: 40px;\r\n    box-sizing: border-box;\r\n    overflow: hidden;\r\n    display: flex;\r\n\r\n    &:after {\r\n        content: \"\";\r\n        display: table;\r\n        clear: both;\r\n    }\r\n    .numInputWrapper {\r\n        flex: 1;\r\n        width: 40%;\r\n        height: 40px;\r\n        float: left;\r\n        span{\r\n            &.arrowUp, &.arrowDown{\r\n                &:after {\r\n                    border-bottom-color: $border-color;\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    &.hasSeconds .numInputWrapper {\r\n        width: 26%;\r\n    }\r\n\r\n    &.time24hr .numInputWrapper {\r\n        width: 49%;\r\n    }\r\n\r\n\r\n    input {\r\n        background: transparent;\r\n        box-shadow: none;\r\n        border: 0;\r\n        border-radius: 0;\r\n        text-align: center;\r\n        margin: 0;\r\n        padding: 0;\r\n        height: inherit;\r\n        line-height: inherit;\r\n        color: var(--#{$variable-prefix}body-color);\r\n        font-size: 14px;\r\n        position: relative;\r\n        box-sizing: border-box;\r\n        appearance: textfield;\r\n\r\n        &.flatpickr-hour {\r\n            font-weight: bold;\r\n        }\r\n\r\n        &.flatpickr-minute,\r\n        &.flatpickr-second {\r\n          font-weight: 400;\r\n        }\r\n\r\n        &:focus {\r\n            outline: 0;\r\n            border: 0;\r\n        }\r\n    }\r\n\r\n\r\n    .flatpickr-time-separator,\r\n    .flatpickr-am-pm {\r\n        height: inherit;\r\n        float: left;\r\n        line-height: inherit;\r\n        color: var(--#{$variable-prefix}body-color);\r\n        font-weight: bold;\r\n        width: 2%;\r\n        user-select: none;\r\n        align-self: center;\r\n    }\r\n\r\n    .flatpickr-am-pm {\r\n        outline: 0;\r\n        width: 18%;\r\n        cursor: pointer;\r\n        text-align: center;\r\n        font-weight: 400;\r\n    }\r\n\r\n    input, .flatpickr-am-pm{\r\n        &:hover, &:focus{\r\n            background: rgba($primary, 0.04);\r\n        }\r\n    }\r\n}\r\n\r\n.flatpickr-am-pm,\r\n.numInput,\r\n.numInputWrapper {\r\n    &:focus,\r\n    &:hover {\r\n        background-color: transparent;\r\n    }\r\n}\r\n\r\n.flatpickr-input[readonly] {\r\n    cursor: pointer;\r\n    background-color: $input-bg;\r\n}\r\n\r\n[data-inline-date=\"true\"],[data-time-inline] {\r\n    display: none;\r\n}\r\n\r\n@keyframes fpFadeInDown {\r\n    from {\r\n        opacity: 0;\r\n        transform: translate3d(0, -20px, 0);\r\n    }\r\n    to {\r\n        opacity: 1;\r\n        transform: translate3d(0, 0, 0);\r\n    }\r\n}\r\n  \r\n[datepicker-inline],\r\n[timepicker-inline] {\r\n    display: none;\r\n}","//\r\n// _authentication.scss\r\n//\r\n\r\n\r\n.auth-page-wrapper{\r\n    .auth-page-content{\r\n        padding-bottom: $footer-height;\r\n        position: relative;\r\n        z-index: 2;\r\n        width: 100%;\r\n    }\r\n    .footer{\r\n        left: 0;\r\n        background-color: transparent;\r\n        color: $body-color;\r\n    }\r\n}\r\n\r\n.auth-one-bg-position{\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    width: 100%;\r\n    height: 380px;\r\n    \r\n    @media (max-width: 575.98px) {\r\n        height: 280px;\r\n    }\r\n}\r\n\r\n.auth-one-bg{\r\n    background-image: url(\"../../images/auth-one-bg.jpg\");\r\n    background-position: center;\r\n    background-size: cover;\r\n\r\n    .bg-overlay{\r\n        background: linear-gradient(to right, darken($primary, 6%), $primary);\r\n        opacity: 0.9;\r\n    }\r\n\r\n    .shape{\r\n        position: absolute;\r\n        bottom: 0;\r\n        right: 0;\r\n        left: 0;\r\n        z-index: 1;\r\n        pointer-events: none;\r\n        >svg {\r\n            width: 100%;\r\n            height: auto;\r\n            fill: var(--#{$variable-prefix}body-bg);\r\n        }\r\n    }\r\n}\r\n\r\n// auth-pass-inputgroup\r\n\r\n.auth-pass-inputgroup{\r\n    input[type=\"text\"] + .btn .ri-eye-fill{\r\n        &:before{\r\n            content: \"\\ecb6\";\r\n        }\r\n    }\r\n}\r\n\r\n.particles-js-canvas-el{\r\n    position: relative;\r\n}\r\n\r\n// signin card title\r\n\r\n.signin-other-title{\r\n    position: relative;\r\n    &:after{\r\n        content: \"\";\r\n        position: absolute;\r\n        width: 100%;\r\n        height: 1px;\r\n        left: 0;\r\n        right: 0;\r\n        border-top: 1px dashed $border-color;\r\n        top: 10px;\r\n    }\r\n\r\n    .title{\r\n        display: inline-block;\r\n        position: relative;\r\n        z-index: 9;\r\n        background-color: $card-bg;\r\n        padding: 2px 16px;\r\n    }\r\n}\r\n\r\n// Auth cover\r\n\r\n.auth-bg-cover{\r\n    background: linear-gradient(-45deg, $primary 50%, $success);\r\n\r\n    > .bg-overlay{\r\n        background-image: url(\"../../images/cover-pattern.png\");\r\n        background-position: center;\r\n        background-size: cover;\r\n        opacity: 1;\r\n        background-color: transparent;\r\n    }\r\n\r\n    .footer{\r\n        color: rgba($white, .5);\r\n    }\r\n}\r\n\r\n//passowrd validations \r\n#password-contain {\r\n    display: none;\r\n\r\n    p {\r\n        padding-left: 13px;\r\n\r\n        &.valid {\r\n            color: $success;\r\n\r\n            &::before {\r\n                position: relative;\r\n                left: -8px;\r\n                content: \"✔\";\r\n            }\r\n        }\r\n\r\n        &.invalid {\r\n            color: $danger;\r\n\r\n            &::before {\r\n                position: relative;\r\n                left: -8px;\r\n                content: \"✖\";\r\n            }\r\n        }\r\n    }\r\n}","// \r\n// _dashboard.scss\r\n// \r\n\r\n.dash-filter-picker {\r\n    min-width: 210px !important;\r\n}\r\n\r\n\r\n// Flatpickr Calendar\r\n\r\n.upcoming-scheduled{\r\n    position: relative;\r\n    .flatpickr-months{\r\n        position: absolute !important;\r\n        top: -45px !important;\r\n        left: auto !important;\r\n        right: 0px !important;\r\n        width: 200px;\r\n        background-color: transparent;\r\n        \r\n        .flatpickr-month{\r\n            color: $gray-600 !important;\r\n            fill: $gray-600 !important;\r\n        }\r\n        .flatpickr-prev-month, .flatpickr-next-month{\r\n            display: none;\r\n        }\r\n    }\r\n    .flatpickr-calendar{\r\n        box-shadow: none !important;\r\n        .flatpickr-current-month {\r\n            font-size: 13px;\r\n            width: 100%;\r\n            left: 0;\r\n        }\r\n        .flatpickr-monthDropdown-months {\r\n            border: 1px solid $border-color;\r\n            border-radius: 4px;\r\n            height: 26px;\r\n        }\r\n        .flatpickr-weekdays{\r\n            background-color: var(--#{$variable-prefix}light);\r\n            border: none;\r\n            span.flatpickr-weekday {\r\n                color: var(--#{$variable-prefix}dark);\r\n            }\r\n        }\r\n        .flatpickr-day{\r\n            &.today{\r\n                color: $white !important;\r\n                background-color: $success;\r\n                border-color: $success !important;\r\n                &:hover{\r\n                    color: $success !important;\r\n                    background-color: rgba($success, 0.2) !important;\r\n                }\r\n            }\r\n            &.selected{\r\n                background-color: $success !important;\r\n                border-color: $success !important;\r\n                color: $white;\r\n            }\r\n        }\r\n        .numInputWrapper {\r\n            width: 7.5ch;\r\n            margin-left: 10px;\r\n        }\r\n    }\r\n\r\n    .flatpickr-days {\r\n        border: none !important;\r\n    }\r\n}\r\n\r\n.crm-widget {\r\n    .col {\r\n        border-right: 1px solid $border-color;\r\n        &:last-child {\r\n            border: 0px;\r\n        }\r\n        @media (min-width: 768px) and (max-width: 1399.98px) { \r\n            &:nth-child(3) {\r\n                border-right: 0px;\r\n            }\r\n            &:last-child { \r\n                border-right: 1px solid $border-color;\r\n            }\r\n         }\r\n        @media (max-width: 767.98px) {\r\n            border-right: 0px;\r\n            border-bottom: 1px solid $border-color;\r\n        }\r\n    }\r\n}   \r\n\r\n\r\n@media (min-width: 1400px) and (max-width: 1599.98px) { \r\n    .project-wrapper {\r\n        >.col-xxl-8, .col-xxl-4{\r\n            width: 100%;\r\n        }\r\n    }\r\n}\r\n\r\n.crypto-widget {\r\n    max-width: 130px !important;\r\n}","//\r\n// _timeline.scss\r\n//\r\n\r\n.timeline {\r\n    position: relative;\r\n    width: 100%;\r\n    max-width: 1400px;\r\n    margin: 0 auto;\r\n\r\n    &::after {\r\n        content: '';\r\n        position: absolute;\r\n        width: 2px;\r\n        background: $timeline-color;\r\n        top: 57px;\r\n        bottom: 166px;\r\n        left: 50%;\r\n        margin-left: -1.5px;\r\n    }\r\n}\r\n\r\n.timeline-item {\r\n    padding: 30px 60px;\r\n    position: relative;\r\n    background: inherit;\r\n    width: 50%;\r\n\r\n    .icon {\r\n        position: absolute;\r\n        display: inline-flex;\r\n        width: 60px;\r\n        height: 60px;\r\n        align-items: center;\r\n        justify-content: center;\r\n        font-size: 25px;\r\n        top: 30px;\r\n        right: -30px;\r\n        padding: 9px 0;\r\n        background: $card-bg;\r\n        border: 1px solid $border-color;\r\n        border-radius: 50px;\r\n        color: $success;\r\n        z-index: 1;\r\n    }\r\n\r\n    .date {\r\n        position: absolute;\r\n        display: inline-block;\r\n        width: calc(100% - 48px);\r\n        top: 50px;\r\n        font-size: 14px;\r\n        font-weight: 500;\r\n        font-style: italic;\r\n    }\r\n\r\n    .content {\r\n        padding: 20px;\r\n        background: $card-bg;\r\n        position: relative;\r\n        border: 1px solid $border-color;\r\n        border-radius: $border-radius;\r\n        box-shadow: $box-shadow-sm;\r\n    }\r\n\r\n    &.left {\r\n        left: 0;\r\n\r\n        .date {\r\n            left: calc(100% + 48px);\r\n            text-align: start;\r\n        }\r\n    }\r\n\r\n    &.right {\r\n        left: 50%;\r\n\r\n        .icon {\r\n            left: -30px;\r\n        }\r\n\r\n        .date {\r\n            right: calc(100% + 48px);\r\n            text-align: end;\r\n        }\r\n\r\n        &::before {\r\n            left: 28px;\r\n            border-color: transparent transparent transparent $white;\r\n        }\r\n    }\r\n}\r\n\r\n@media (max-width: 991.98px) {\r\n    .timeline {\r\n        &::after {\r\n            left: 112px;\r\n            bottom: 180px;\r\n        }\r\n    }\r\n\r\n    .timeline-item {\r\n        width: 100%;\r\n        padding-left: 165px;\r\n        padding-right: 0px;\r\n\r\n        &.right,  &.left {\r\n            left: 0%;\r\n\r\n            .icon {\r\n                width: 45px;\r\n                height: 45px;\r\n                top: 37.5px;\r\n                font-size: 18px;\r\n                left: 90px;\r\n            }\r\n\r\n            &::before {\r\n                left: 110px;\r\n                border-color: transparent transparent transparent $border-color;\r\n            }\r\n\r\n            .date {\r\n                right: auto;\r\n                left: 0px;\r\n                width: 79px;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.timeline-2 {\r\n    position: relative;\r\n\r\n    &::after {\r\n        position: absolute;\r\n        content: \"\";\r\n        width: 2px;\r\n        height: 83%;\r\n        top: 50px;\r\n        left: 40px;\r\n        margin-left: -1px;\r\n        background: $timeline-color;\r\n    }\r\n\r\n    .timeline-year {\r\n        position: relative;\r\n        width: 100%;\r\n        text-align: left;\r\n        z-index: 1;\r\n\r\n        p {\r\n            display: inline-flex;\r\n            width: 80px;\r\n            height: 80px;\r\n            margin: 0;\r\n            padding: 23px 10px;\r\n            background: $timeline-color;\r\n            border-radius: 50px;\r\n            text-transform: uppercase;\r\n            align-items: center;\r\n            justify-content: center;\r\n            text-align: center;\r\n            span {\r\n                display: -webkit-box;\r\n                -webkit-line-clamp: 2;\r\n                -webkit-box-orient: vertical;\r\n                overflow: hidden;\r\n                text-overflow: ellipsis;\r\n            }\r\n        }\r\n    }\r\n\r\n    .timeline-date {\r\n        font-size: 14px;\r\n        font-weight: $font-weight-medium;\r\n        margin: 24px 0 0 0;\r\n        margin-left: 55px;\r\n\r\n        &::after {\r\n            content: '';\r\n            display: block;\r\n            position: absolute;\r\n            width: 14px;\r\n            height: 14px;\r\n            top: 26px;\r\n            left: 45px;\r\n            align-items: left;\r\n            background: $success;\r\n            border: 3px solid $timeline-color;\r\n            border-radius: 50px;\r\n            z-index: 1;\r\n        }\r\n    }\r\n\r\n    .timeline-box {\r\n        position: relative;\r\n        display: inline-block;\r\n        margin: 23px 62px;\r\n        padding: 20px;\r\n        border: 1px solid $border-color;\r\n        border-radius: 6px;\r\n        background: $card-bg;\r\n        max-width: 695px;\r\n\r\n        &::after {\r\n            content: '';\r\n            display: block;\r\n            position: absolute;\r\n            width: 0;\r\n            height: 0;\r\n            border-style: solid;\r\n            top: 26px;\r\n            right: 100%;\r\n            border-color: transparent $card-bg transparent transparent;\r\n            border-width: 10px;\r\n        }\r\n\r\n        &::before {\r\n            content: '';\r\n            display: block;\r\n            position: absolute;\r\n            width: 0;\r\n            height: 0;\r\n            border-style: solid;\r\n            right: 100%;\r\n            top: 24px;\r\n            border-color: transparent $border-color transparent transparent;\r\n            border-width: 12px;\r\n        }\r\n\r\n        .timeline-text {\r\n            position: relative;\r\n            float: left;\r\n        }\r\n    }\r\n\r\n    .timeline-launch {\r\n        position: relative;\r\n        display: inline-block;\r\n        border: 1px solid $border-color;\r\n        border-radius: 6px;\r\n        background: $white;\r\n        width: 100%;\r\n        margin-top: 15px;\r\n        padding: 0;\r\n        border: none;\r\n        text-align: left;\r\n        background: transparent;\r\n\r\n        .timeline-box {\r\n            margin-left: 0;\r\n\r\n            &::after {\r\n                left: 30px;\r\n                margin-left: 0px;\r\n                top: -20px;\r\n                border-color: transparent transparent $border-color transparent;\r\n            }\r\n\r\n            &::before {\r\n                left: 30px;\r\n                margin-left: 0px;\r\n                top: -19px;\r\n                border-color: transparent transparent $card-bg transparent;\r\n                border-width: 10px;\r\n                z-index: 1;\r\n            }\r\n        }\r\n\r\n    }\r\n}\r\n\r\n// Horizontal Timeline\r\n.horizontal-timeline {\r\n    position: relative;\r\n    width: 100%;\r\n    margin: 0 auto;\r\n\r\n    &::before {\r\n        content: \"\";\r\n        position: absolute;\r\n        width: 100%;\r\n        top: 174px;\r\n        left: 0;\r\n        height: 2px;\r\n        background-color: $timeline-color;\r\n    }\r\n\r\n    .swiper-slide {\r\n        .item-box {\r\n            margin: 227px 0px 0px;\r\n            background-color: transparent;\r\n            box-shadow: none;\r\n\r\n            &::after {\r\n                content: \"\";\r\n                position: absolute;\r\n                left: 0px;\r\n                right: 0px;\r\n                margin: 0px auto;\r\n                background: $primary;\r\n                width: 13px;\r\n                height: 13px;\r\n                top: -59px;\r\n                border-radius: 50px;\r\n                border: 3px solid $timeline-color;\r\n            }\r\n        }\r\n\r\n        .timeline-content {\r\n            min-height: 110px;\r\n            display: flex;\r\n            justify-content: center;\r\n            align-items: center;\r\n            position: relative;\r\n            background-color: $timeline-color;\r\n\r\n            &::before {\r\n                content: '';\r\n                display: block;\r\n                position: absolute;\r\n                width: 0;\r\n                height: 0;\r\n                border-style: solid;\r\n                left: 0px;\r\n                top: -23px;\r\n                border-color: transparent transparent $timeline-color transparent;\r\n                border-width: 12px;\r\n                right: 0;\r\n                margin: 0 auto;\r\n            }\r\n        }\r\n\r\n        .time {\r\n            position: absolute;\r\n            top: -86px;\r\n            right: 0px;\r\n            left: 0px;\r\n            margin: 0px auto;\r\n        }\r\n\r\n        &:nth-child(even) {\r\n            margin-top: 5px;\r\n            transform: rotate(-180deg);\r\n\r\n            .timeline-content {\r\n                transform: rotate(180deg);\r\n\r\n                &::before {\r\n                    bottom: -23px;\r\n                    top: auto;\r\n                    border-color: $timeline-color transparent transparent transparent;\r\n                }\r\n            }\r\n\r\n            .time {\r\n                transform: rotate(180deg);\r\n            }\r\n        }\r\n    }\r\n\r\n    .swiper-button-next,\r\n    .swiper-button-prev {\r\n        height: 40px;\r\n        width: 40px;\r\n        line-height: 40px;\r\n        border-radius: 50%;\r\n        background-color: lighten($primary, 2.5%);\r\n\r\n        &::after {\r\n            font-size: 24px;\r\n            color: $white;\r\n        }\r\n        &.swiper-button-disabled {\r\n            background-color: rgba($primary, 0.5);\r\n            opacity: 1;\r\n            cursor: auto;\r\n            backdrop-filter: blur(25px);\r\n            pointer-events: none\r\n        }\r\n    }\r\n\r\n    .swiper-button-next {\r\n        right: 0;\r\n\r\n        &::after {\r\n            content: \"\\EA6E\";\r\n            font-family: remixicon;\r\n        }\r\n    }\r\n\r\n    .swiper-button-prev {\r\n        left: 0;\r\n\r\n        &::after {\r\n            content: \"\\EA64\";\r\n            font-family: remixicon;\r\n        }\r\n    }\r\n}\r\n\r\n//activity-timeline\r\n\r\n.acitivity-timeline {\r\n    position: relative;\r\n    overflow: hidden;\r\n\r\n    .acitivity-item {\r\n        position: relative;\r\n\r\n        .flex-shrink-0 {\r\n            z-index: 2;\r\n        }\r\n\r\n        .acitivity-avatar {\r\n            background-color: var(--#{$variable-prefix}card-bg);\r\n            border: 3px solid var(--#{$variable-prefix}card-bg);\r\n            height: 32px;\r\n            width: 32px;\r\n        }\r\n\r\n        &:before {\r\n            content: \"\";\r\n            position: absolute;\r\n            border-left: 1px dashed $border-color;\r\n            left: 16px;\r\n            height: 100%;\r\n            top: 0px;\r\n            z-index: 0;\r\n        }\r\n        &:last-child {\r\n           &::before {\r\n               border-color: transparent;\r\n           }\r\n        }\r\n    }\r\n}","//\r\n// _gallery.scss\r\n//\r\n\r\n.categories-filter {\r\n    .list-inline-item {\r\n        position: relative;\r\n        margin-right: 0;\r\n\r\n        a {\r\n            display: block;\r\n            color: var(--#{$variable-prefix}body-color);\r\n            font-weight: $font-weight-semibold;\r\n            padding: 8px 15px;\r\n            margin: 5px;\r\n            cursor: pointer;\r\n        }\r\n    }\r\n}\r\n\r\n.gallery-box {\r\n    position: relative;\r\n    overflow: hidden;\r\n    border: 1px solid transparent;\r\n    margin-bottom: 10px;\r\n    box-shadow: none;\r\n    background-color: transparent;\r\n    padding: 8px;\r\n\r\n    &::before {\r\n        content: \"\";\r\n        position: absolute;\r\n        left: 0;\r\n        right: 0;\r\n        top: 0;\r\n        width: 100%;\r\n        height: 0;\r\n        background-color: $card-bg;\r\n        transition: all 0.4s;\r\n    }\r\n\r\n    .gallery-container {\r\n        position: relative;\r\n        overflow: hidden;\r\n        border-radius: 4px;\r\n\r\n        a {\r\n            display: block;\r\n        }\r\n\r\n        .gallery-overlay {\r\n            position: absolute;\r\n            top: 0px;\r\n            left: 0px;\r\n            bottom: 0px;\r\n            right: 0px;\r\n            opacity: 0;\r\n            background: linear-gradient(180deg, rgba(0, 0, 0, 0) 10%, rgba(0, 0, 0, 0) 60%, rgba(0, 0, 0, .5) 100%);\r\n            visibility: hidden;\r\n            overflow: hidden;\r\n            transition: all 0.4s ease-in-out 0s;\r\n            display: flex;\r\n            width: 100%;\r\n            align-items: flex-end;\r\n            padding: 16px;\r\n\r\n            .overlay-caption {\r\n                color: $white;\r\n                margin: 0;\r\n                font-size: 16px;\r\n            }\r\n        }\r\n    }\r\n\r\n    .gallery-img {\r\n        transition: all 0.2s ease-in-out;\r\n    }\r\n\r\n    .box-content {\r\n        position: relative;\r\n\r\n        .title {\r\n            font-size: 14px;\r\n            margin-bottom: 4px;\r\n            display: none;\r\n        }\r\n\r\n        .post {\r\n            margin: 0;\r\n            transition: all 0.2s;\r\n            color: $text-muted;\r\n        }\r\n    }\r\n\r\n    &:hover {\r\n        &::before {\r\n            height: 100%;\r\n        }\r\n\r\n        .box-content {\r\n            bottom: 0;\r\n\r\n            .post {\r\n                opacity: 1;\r\n            }\r\n        }\r\n\r\n        .gallery-overlay {\r\n            opacity: 1;\r\n            visibility: visible;\r\n        }\r\n    }\r\n}\r\n\r\n.gallery-light {\r\n    .gallery-box {\r\n        &::before {\r\n            background-color: var(--#{$variable-prefix}light);\r\n        }\r\n    }\r\n}","//\r\n// _errors.scss\r\n//\r\n\r\n.error-basic-img{\r\n    max-width: 450px;\r\n}\r\n\r\n.error-500 {\r\n    .title {\r\n        font-size: 250px;\r\n    }\r\n\r\n    .error-500-img {\r\n        position: absolute;\r\n        top: 57px;\r\n        left: 0;\r\n        right: 0;\r\n        margin: 0 auto;\r\n    }\r\n\r\n    @media (min-width: 768px) and (max-width: 991.98px) {\r\n        .title {\r\n            font-size: 150px;\r\n        }\r\n\r\n        .error-500-img {\r\n            width: 20% !important;\r\n            top: 43px;\r\n        }\r\n    }\r\n\r\n    @media (max-width: 767.98px) {\r\n        .title {\r\n            font-size: 68px;\r\n            margin-top: 35px;\r\n        }\r\n\r\n        .error-500-img {\r\n            position: relative;\r\n            top: 0px;\r\n        }\r\n    }\r\n}\r\n\r\n\r\n@keyframes errorAnimation {\r\n    0% {\r\n        transform: translateX(0%);\r\n    }\r\n\r\n    15% {\r\n        transform: translateX(-25%) rotate(-5deg);\r\n    }\r\n\r\n    30% {\r\n        transform: translateX(20%) rotate(3deg);\r\n    }\r\n\r\n    45% {\r\n        transform: translateX(-15%) rotate(-3deg);\r\n    }\r\n\r\n    60% {\r\n        transform: translateX(10%) rotate(2deg);\r\n    }\r\n\r\n    75% {\r\n        transform: translateX(-5%) rotate(-1deg);\r\n    }\r\n\r\n    100% {\r\n        transform: translateX(0%);\r\n    }\r\n}\r\n\r\n.error-img {\r\n    animation: errorAnimation 20s infinite;\r\n}","//\r\n// _profile.scss\r\n//\r\n\r\n.error-text {\r\n    text-shadow: 4px 4px rgba($success, 0.4);\r\n\r\n    @media (min-width: 1200px) {\r\n        font-size: 10rem;\r\n    }\r\n}\r\n\r\n\r\n// profile\r\n\r\n.profile-wid-bg {\r\n    position: absolute;\r\n    left: 0;\r\n    right: 0;\r\n    top: 0;\r\n    height: 320px;\r\n    @media (max-width: 575.98px) {\r\n        height: 445px;\r\n    }\r\n\r\n    &::before {\r\n        content: \"\";\r\n        position: absolute;\r\n        left: 0;\r\n        right: 0;\r\n        top: 0;\r\n        bottom: 0;\r\n        opacity: 0.9;\r\n        background: $primary;\r\n        background: linear-gradient(to top, darken($primary, 25%), $primary);\r\n\r\n    }\r\n\r\n    .profile-wid-img {\r\n        width: 100%;\r\n        height: 100%;\r\n        object-fit: cover;\r\n    }\r\n}\r\n\r\n.profile-nav {\r\n    &.nav-pills {\r\n        .nav-link {\r\n            color: rgba($white, 0.8);\r\n\r\n            &::before {\r\n                background-color: rgba($white, 0.1);\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.profile-project-card {\r\n    border: 1px solid $border-color;\r\n    border-left: 3px solid $border-color;\r\n}\r\n\r\n@each $color,\r\n$value in $theme-colors {\r\n    .profile-project-card {\r\n        &.profile-project-#{$color} {\r\n            border-left-color: $value;\r\n        }\r\n    }\r\n}\r\n\r\n.user-profile-img {\r\n    position: relative;\r\n\r\n    .profile-img {\r\n        width: 100%;\r\n        height: 250px;\r\n        object-fit: cover;\r\n\r\n        @media (max-width:991px) {\r\n            height: 160px;\r\n        }\r\n    }\r\n\r\n    .profile-foreground-img-file-input {\r\n        display: none;\r\n    }\r\n\r\n    .profile-photo-edit {\r\n        cursor: pointer;\r\n    }\r\n}\r\n\r\n.profile-user {\r\n    position: relative;\r\n    display: inline-block;\r\n\r\n    .profile-photo-edit {\r\n        position: absolute;\r\n        right: 0;\r\n        left: auto;\r\n        bottom: 0;\r\n        cursor: pointer;\r\n    }\r\n\r\n    .user-profile-image {\r\n        object-fit: cover;\r\n    }\r\n\r\n    .profile-img-file-input {\r\n        display: none;\r\n    }\r\n}\r\n\r\n.profile-timeline {\r\n    .accordion-item {\r\n        position: relative;\r\n\r\n        .accordion-button {\r\n            background-color: transparent;\r\n\r\n            &::after {\r\n                background: none;\r\n            }\r\n        }\r\n\r\n        &::before {\r\n            content: \"\";\r\n            border-left: 2px dashed $border-color;\r\n            position: absolute;\r\n            height: 100%;\r\n            left: 23px;\r\n        }\r\n\r\n        &:first-child {\r\n            &::before {\r\n                top: 8px;\r\n            }\r\n        }\r\n\r\n        &:last-child {\r\n            &::before {\r\n                height: 20px;\r\n                top: 3px;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.profile-setting-img {\r\n    position: relative;\r\n    height: 260px;\r\n\r\n    .overlay-content {\r\n        content: \"\";\r\n        position: absolute;\r\n        top: 0;\r\n        right: 0;\r\n    }\r\n\r\n    .profile-img {\r\n        width: 100%;\r\n        height: 250px;\r\n        object-fit: cover;\r\n\r\n        @media (max-width:991.98px) {\r\n            height: 160px;\r\n        }\r\n    }\r\n\r\n    .profile-foreground-img-file-input {\r\n        display: none;\r\n    }\r\n\r\n    .profile-photo-edit {\r\n        cursor: pointer;\r\n    }\r\n}\r\n\r\n@media (max-width:575.98px) {\r\n\r\n    [data-layout=\"horizontal\"]{\r\n        .profile-foreground{\r\n            margin-top: 0 !important;\r\n        }\r\n    }\r\n}","//\r\n// _sitemap.scss\r\n//\r\n\r\n.sitemap-content {\r\n    width: 100%;\r\n    max-width: 1142px;\r\n    margin: 0 auto;\r\n    padding: 0 20px;\r\n\r\n    * {\r\n        position: relative;\r\n    }\r\n}\r\n\r\n.sitemap-horizontal {\r\n    position: relative;\r\n\r\n    ul {\r\n        padding: 0;\r\n        margin: 0;\r\n        list-style: none;\r\n\r\n        a {\r\n            display: block;\r\n            background: var(--#{$variable-prefix}light);\r\n            border: 2px solid $card-bg;\r\n            box-shadow: $box-shadow;\r\n            font-size: $font-size-base;\r\n            height: 60px;\r\n            padding: 8px;\r\n            display: flex;\r\n            justify-content: center;\r\n            align-items: center;\r\n\r\n            span {\r\n                display: -webkit-box;\r\n                -webkit-line-clamp: 2;\r\n                -webkit-box-orient: vertical;\r\n                overflow: hidden;\r\n                text-overflow: ellipsis;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.administration {\r\n    .director {\r\n        >li {\r\n            >a {\r\n                width: 50%;\r\n                margin: 0 auto 0px auto;\r\n                border-radius: 4px;\r\n            }\r\n        }\r\n    }\r\n\r\n    .subdirector {\r\n        position: absolute;\r\n        width: 100%;\r\n\r\n        &::after {\r\n            content: \"\";\r\n            display: block;\r\n            width: 0;\r\n            height: 130px;\r\n            border-left: 2px dashed $border-color;\r\n            left: 45.45%;\r\n            position: relative;\r\n        }\r\n\r\n        >li {\r\n            &:first-child {\r\n                width: 18.59%;\r\n                height: 64px;\r\n                margin: 0 auto 92px auto;\r\n                padding-top: 25px;\r\n                border-bottom: 2px dashed $border-color;\r\n                z-index: 1;\r\n                float: right;\r\n                right: 27.2%;\r\n                border-left: 2px dashed $border-color;\r\n\r\n                a {\r\n                    width: 100%;\r\n                    left: 25px;\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    @media screen and (max-width: 767px) {\r\n        .subdirector {\r\n            >li {\r\n                &:first-child {\r\n                    width: 40%;\r\n                    right: 10%;\r\n                    margin-right: 2px;\r\n                }\r\n            }\r\n\r\n            &::after {\r\n                left: 49.8%;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.departments {\r\n    width: 100%;\r\n\r\n    >li {\r\n        &:first-child {\r\n            width: 18.59%;\r\n            height: 64px;\r\n            margin: 0 auto 92px auto;\r\n            padding-top: 25px;\r\n            border-bottom: 2px dashed $border-color;\r\n            z-index: 1;\r\n            float: left;\r\n            left: 27%;\r\n\r\n            a {\r\n                width: 100%;\r\n                right: 25px;\r\n            }\r\n        }\r\n\r\n        &:nth-child(2) {\r\n            margin-left: 0;\r\n            clear: left;\r\n\r\n            &.department {\r\n                &:before {\r\n                    border: none;\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    &::after {\r\n        content: \"\";\r\n        display: block;\r\n        position: absolute;\r\n        width: 81.1%;\r\n        height: 22px;\r\n        border-top: 2px dashed $border-color;\r\n        border-right: 2px dashed $border-color;\r\n        border-left: 2px dashed $border-color;\r\n        margin: 0 auto;\r\n        top: 130px;\r\n        left: 9.1%\r\n    }\r\n\r\n    @media screen and (max-width: 767px) {\r\n        >li {\r\n            &:first-child {\r\n                width: 40%;\r\n                left: 10%;\r\n                margin-left: 2px;\r\n            }\r\n        }\r\n\r\n        &::after {\r\n            border-right: none;\r\n            left: 0;\r\n            width: 50%;\r\n        }\r\n    }\r\n}\r\n\r\n.department {\r\n    border-left: 2px dashed $border-color;\r\n    float: left;\r\n    margin-left: 1.75%;\r\n    margin-bottom: 60px;\r\n    width: 18.25%;\r\n\r\n    &::before {\r\n        content: \"\";\r\n        display: block;\r\n        position: absolute;\r\n        width: 0;\r\n        height: 22px;\r\n        border-left: 2px dashed $border-color;\r\n        z-index: 1;\r\n        top: -22px;\r\n        left: 50%;\r\n        margin-left: -4px;\r\n    }\r\n\r\n    >a {\r\n        margin: 0 0 -26px -4px;\r\n        z-index: 1;\r\n    }\r\n\r\n    ul {\r\n        margin-top: 0px;\r\n        margin-bottom: 0px;\r\n\r\n        li {\r\n            padding-left: 25px;\r\n            border-bottom: 2px dashed $border-color;\r\n            height: 80px;\r\n\r\n            a {\r\n                background: $card-bg;\r\n                margin-top: 48px;\r\n                position: absolute;\r\n                z-index: 1;\r\n                width: 90%;\r\n                height: 60px;\r\n                vertical-align: middle;\r\n                right: -1px;\r\n                text-align: center;\r\n            }\r\n        }\r\n    }\r\n\r\n    &:first-child {\r\n        margin-left: 0;\r\n        clear: left;\r\n    }\r\n\r\n    @media screen and (min-width: 768px) {\r\n        &:last-child:before {\r\n            border: none;\r\n        }\r\n    }\r\n\r\n    @media screen and (max-width: 767px) {\r\n        float: none;\r\n        width: 100%;\r\n        margin-left: 0;\r\n\r\n        &::before {\r\n            content: \"\";\r\n            display: block;\r\n            position: absolute;\r\n            width: 0;\r\n            height: 60px;\r\n            border-left: 2px dashed $white;\r\n            z-index: 1;\r\n            top: -60px;\r\n            left: 0%;\r\n            margin-left: -4px;\r\n        }\r\n\r\n        &:nth-child(2) {\r\n            &::before {\r\n                display: none;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n\r\n\r\n// sitemap\r\n\r\n.hori-sitemap {\r\n    ul {\r\n        padding: 0;\r\n        padding-top: 10px;\r\n        text-align: center;\r\n        li {\r\n            position: relative;\r\n        }\r\n        @media (max-width: 575.98px) {\r\n            text-align: left;\r\n            .parent-title {\r\n                a {\r\n                    padding-left: 0;\r\n                    &:after {\r\n                        display: none;\r\n                    }\r\n                }\r\n\r\n                &:before {\r\n                    display: none;\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n\r\n    @media (max-width: 575.98px) {\r\n        >ul {\r\n            position: relative;\r\n            &:before {\r\n                content: \"\";\r\n                height: 91%;\r\n                border-right: 2px dashed $border-color;\r\n                position: absolute;\r\n                top: 40px;\r\n                left: 0;\r\n            }\r\n            li {\r\n                padding-top: 10px;\r\n                .second-list,\r\n                .sub-list {\r\n                    position: relative;\r\n\r\n                    &:before {\r\n                        content: \"\";\r\n                        height: 86%;\r\n                        border-right: 2px dashed $border-color;\r\n                        position: absolute;\r\n                        top: 0px;\r\n                        left: 0px;\r\n                    }\r\n                }\r\n                .sub-list {\r\n                    &:before {\r\n                        height: 38%;\r\n                    }\r\n                }\r\n                a {\r\n                    position: relative;\r\n                    padding: 4px 16px 4px 36px;\r\n\r\n                    &:after {\r\n                        content: \"\";\r\n                        width: 24px;\r\n                        border-top: 2px dashed $border-color;\r\n                        position: absolute;\r\n                        top: 50%;\r\n                        transform: translateY(-50%);\r\n                        left: 0;\r\n                    }\r\n                }\r\n\r\n                ul {\r\n                    margin-left: 36px;\r\n                }\r\n            }\r\n        }\r\n    }\r\n    @media (min-width: 576px) {\r\n        ul {\r\n            padding-top: 20px;\r\n            li {\r\n                padding-top: 30px;\r\n\r\n                &:before {\r\n                    content: \"\";\r\n                    height: 24px;\r\n                    width: 0;\r\n                    border-right: 2px dashed $border-color;\r\n                    position: absolute;\r\n                    top: 0;\r\n                    left: 0;\r\n                    right: 0;\r\n                    margin: 0px auto;\r\n                }\r\n\r\n                &:after {\r\n                    content: \"\";\r\n                    width: 100%;\r\n                    border-top: 2px dashed $border-color;\r\n                    position: absolute;\r\n                    top: 0;\r\n                    left: 50%;\r\n                }\r\n\r\n                &:last-of-type {\r\n                    &:after {\r\n                        display: none;\r\n                    }\r\n                }\r\n\r\n                &.parent-title {\r\n                    &::before {\r\n                        content: \"\";\r\n                        height: 23px;\r\n                        border-right: 2px dashed $border-color;\r\n                        position: absolute;\r\n                        top: 28px;\r\n                        left: 0;\r\n                    }\r\n                    &::after {\r\n                        border: none;\r\n                    }\r\n                }\r\n\r\n                .sub-title {\r\n                    position: relative;\r\n\r\n                    &::before {\r\n                        content: \"\";\r\n                        height: 21px;\r\n                        border-right: 2px dashed $border-color;\r\n                        position: absolute;\r\n                        top: 27px;\r\n                        left: 49%;\r\n                        margin: 0 auto;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    a {\r\n        color: var(--#{$variable-prefix}body-color);\r\n        padding: 4px 0px;\r\n        display: block;\r\n\r\n    }\r\n}\r\n\r\n\r\n// vertical sitemap\r\n.verti-sitemap {\r\n    ul {\r\n        padding: 0;\r\n\r\n        li {\r\n            list-style: none;\r\n            position: relative;\r\n\r\n            a {\r\n                color: var(--#{$variable-prefix}body-color);\r\n                padding: 4px 0px;\r\n                display: block;\r\n            }\r\n        }\r\n\r\n        .parent-title {\r\n            a {\r\n                padding-left: 0;\r\n\r\n                &:before {\r\n                    display: none;\r\n                }\r\n            }\r\n\r\n            &:before {\r\n                display: none;\r\n            }\r\n        }\r\n    }\r\n\r\n    >ul {\r\n        li {\r\n            padding-top: 10px;\r\n\r\n            ul {\r\n                margin-left: 42px;\r\n            }\r\n\r\n            .second-list {\r\n                position: relative;\r\n\r\n                &:before {\r\n                    content: \"\";\r\n                    height: calc(100% - 14px);\r\n                    border-left: 2px dashed $border-color;\r\n                    position: absolute;\r\n                    top: 0;\r\n                    left: 0;\r\n                    margin: 0px auto;\r\n                }\r\n\r\n                li {\r\n                    &::before {\r\n                        display: none;\r\n                    }\r\n                }\r\n            }\r\n\r\n            a {\r\n                position: relative;\r\n                padding: 4px 16px 4px 36px;\r\n\r\n                &::before {\r\n                    content: \"\";\r\n                    width: 24px;\r\n                    border-top: 2px dashed $border-color;\r\n                    position: absolute;\r\n                    top: 50%;\r\n                    transform: translateY(-50%);\r\n                    left: 0;\r\n                }\r\n            }\r\n\r\n            &:before {\r\n                content: \"\";\r\n                height: 100%;\r\n                border-left: 2px dashed $border-color;\r\n                position: absolute;\r\n                top: 0;\r\n                left: 0;\r\n                margin: 0px auto;\r\n            }\r\n\r\n            &:last-child {\r\n                &::before {\r\n                    height: 25px;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}","//\r\n// _team.scss\r\n//\r\n\r\n//Bookmark\r\n.bookmark-icon {\r\n    svg {\r\n        fill: transparent;\r\n    }\r\n\r\n    .btn-star {\r\n        cursor: pointer;\r\n    }\r\n\r\n    .bookmark-input {\r\n        &:checked {\r\n            &~.btn-star svg {\r\n                fill: $warning !important;\r\n                color: $warning !important;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.bookmark-hide {\r\n    display: none;\r\n    visibility: hidden;\r\n    height: 0;\r\n}\r\n\r\n.team-box, .profile-offcanvas {\r\n    .team-cover {\r\n        display: none;\r\n        position: relative;\r\n        margin-bottom: -140px;\r\n\r\n        img {\r\n            height: 140px;\r\n            width: 100%;\r\n            object-fit: cover;\r\n        }\r\n\r\n        &::before {\r\n            content: \"\";\r\n            position: absolute;\r\n            width: 100%;\r\n            height: 100%;\r\n            background: linear-gradient(to top, darken($primary, 25%), $primary);\r\n            opacity: 0.6;\r\n        }\r\n    }\r\n}\r\n\r\n.team-list {\r\n    &.grid-view-filter {\r\n        flex-flow: row wrap;\r\n\r\n        .col {\r\n            flex: 0 0 auto;\r\n            width: 25%;\r\n        }\r\n\r\n        .team-box {\r\n            overflow: hidden;\r\n\r\n            .team-row {\r\n                align-items: start;\r\n\r\n                .col {\r\n                    width: 100%;\r\n                }\r\n            }\r\n\r\n            .team-cover {\r\n                display: block;\r\n            }\r\n\r\n            .team-settings {\r\n                .col {\r\n                    width: 50% !important;\r\n                    flex: 0 0 auto;\r\n                }\r\n\r\n                .btn-star {\r\n                    color: $white;\r\n                }\r\n\r\n                .dropdown {\r\n                    >a {\r\n                        color: $white;\r\n                    }\r\n                }\r\n            }\r\n\r\n            .team-profile-img {\r\n                display: flex;\r\n                flex-direction: column;\r\n                align-items: center;\r\n                margin-bottom: 25px;\r\n                margin-top: 36px;\r\n\r\n                .avatar-lg {\r\n                    font-size: 22px;\r\n                }\r\n\r\n                .team-content {\r\n                    margin-left: 0px;\r\n                    margin-top: 25px;\r\n                    text-align: center;\r\n                }\r\n            }\r\n\r\n            .view-btn {\r\n                width: 100%;\r\n                margin-top: 25px;\r\n            }\r\n        }\r\n\r\n        @media (min-width: 1200px) and (max-width: 1399.98px) {\r\n            .col {\r\n                flex: 0 0 auto;\r\n                width: 33.33%;\r\n            }\r\n        }\r\n\r\n        @media (max-width: 1199.98px) {\r\n            .col {\r\n                flex: 0 0 auto;\r\n                width: 50%;\r\n            }\r\n        }\r\n\r\n        @media (max-width: 767.98px) {\r\n            .col {\r\n                flex: 0 0 auto;\r\n                width: 100%;\r\n            }\r\n        }\r\n    }\r\n\r\n    &.list-view-filter {\r\n        flex-direction: column;\r\n\r\n        .team-box {\r\n            margin-bottom: 10px;\r\n\r\n            .team-row {\r\n                align-items: center;\r\n                justify-content: space-between;\r\n            }\r\n\r\n            .team-profile-img {\r\n                display: flex;\r\n                align-items: center;\r\n\r\n                .avatar-lg {\r\n                    height: 4rem;\r\n                    width: 4rem;\r\n                    font-size: 16px;\r\n                }\r\n\r\n                .team-content {\r\n                    margin-left: 15px;\r\n                }\r\n            }\r\n\r\n            .team-settings {\r\n                width: auto;\r\n                flex: 0 0 auto;\r\n                -webkit-box-ordinal-group: 7;\r\n                order: 6;\r\n            }\r\n\r\n            .btn-star {\r\n                color: $primary;\r\n            }\r\n        }\r\n\r\n        @media (max-width: 767.98px) {\r\n            flex-direction: row;\r\n            .col {\r\n                -webkit-box-flex: 0;\r\n                -ms-flex: 0 0 auto;\r\n                flex: 0 0 auto;\r\n                width: 100%;\r\n            }\r\n            .team-box {\r\n\r\n                .team-settings {\r\n                    width: 100%;\r\n                    flex: 0 0 auto;\r\n                    order: -1;\r\n                    margin-bottom: 10px;\r\n\r\n                    .col {\r\n                        width: 50%;\r\n                    }\r\n                }\r\n\r\n                .team-profile-img {\r\n                    margin-bottom: 25px;\r\n                }\r\n\r\n                .view-btn {\r\n                    width: 100%;\r\n                    margin-top: 25px;\r\n                }\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.list-grid-nav {\r\n    .nav-link {\r\n        &.active {\r\n            background-color: $info;\r\n            color: $white;\r\n        }\r\n    }\r\n}\r\n\r\n.profile-offcanvas  {\r\n    .team-cover {\r\n        margin-bottom: -132px;\r\n        display: block;\r\n        z-index: -1;\r\n    }\r\n    .btn-star {\r\n        color: $white;\r\n    }\r\n\r\n    .dropdown {\r\n        >a {\r\n            color: $white;\r\n        }\r\n    }\r\n}","// \r\n// _coming-soon.scss\r\n//\r\n\r\n// countdownlist\r\n\r\n.countdownlist {\r\n    text-align: center;\r\n    display: flex;\r\n    gap: 24px;\r\n\r\n\r\n    .countdownlist-item{\r\n        width: 25%;\r\n        &:last-of-type{\r\n            .count-num{\r\n                &::after{\r\n                    display: none;\r\n                }\r\n            }\r\n        }\r\n    }\r\n    .count-title{\r\n        font-size: 13px;\r\n        font-weight: $font-weight-medium;\r\n        display: block;\r\n        margin-bottom: 8px;\r\n        color: rgba(var(--#{$variable-prefix}dark-rgb), 0.5);\r\n        text-transform: uppercase;\r\n    }\r\n\r\n    .count-num{\r\n        background-color: $card-bg;\r\n        padding: 16px 8px;\r\n        position: relative;\r\n        border-radius: $card-border-radius;\r\n        box-shadow: $box-shadow;\r\n        font-weight: $font-weight-semibold;\r\n        font-size: 32px;\r\n        @media (max-width: 575.98px) {\r\n            font-size: 18px;\r\n        }\r\n    \r\n        &::after{\r\n            content: \":\";\r\n            font-size: 20px;\r\n            position: absolute;\r\n            right: -16px;\r\n            top: 50%;\r\n            transform: translateY(-50%);\r\n            color: var(--#{$variable-prefix}dark);\r\n        }\r\n    }\r\n}\r\n// coming soon \r\n\r\n.move-animation{\r\n    animation: mover 1s infinite  alternate;\r\n}\r\n\r\n@keyframes mover {\r\n    0% { transform: translateY(0); }\r\n    100% { transform: translateY(-16px); }\r\n}\r\n\r\n.coming-soon-text{\r\n    font-weight: $font-weight-semibold;\r\n    text-transform: uppercase;\r\n    color: $white;\r\n    text-shadow: 3px 4px $success;\r\n}\r\n\r\n.countdown-input-group{\r\n    max-width: 400px;\r\n}\r\n","//\r\n// _search-results.scss\r\n//\r\n\r\n.search-more-results {\r\n    position: relative;\r\n    overflow: hidden;\r\n\r\n    .nav-icon {\r\n        font-size: 14px;\r\n        color: $white;\r\n        position: absolute;\r\n        top: 50%;\r\n        transform: translateY(-50%);\r\n        text-align: center;\r\n        left: 0;\r\n        right: 0;\r\n\r\n        i {\r\n            font-size: 20px;\r\n        }\r\n\r\n        @media (max-width: 767.98px) {\r\n            font-size: 14px;\r\n\r\n            i {\r\n                font-size: 18px;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.video-list {\r\n    .list-element {\r\n        display: none;\r\n        &:nth-child(1) {\r\n            display: block;\r\n        }\r\n        &:nth-child(2) {\r\n            display: block;\r\n        }\r\n        &:nth-child(3) {\r\n            display: block;\r\n        }\r\n    }\r\n}\r\n\r\n.search-voice {\r\n    height: 120px;\r\n    width: 120px;\r\n    line-height: 120px;\r\n    margin: 0px auto;\r\n    text-align: center;\r\n    border-radius: 50%;\r\n    z-index: 1;\r\n    position: relative;\r\n\r\n    i {\r\n        line-height: 56px;\r\n        font-size: 30px;\r\n    }\r\n\r\n    .voice-wave {\r\n        position: absolute;\r\n        width: 120px;\r\n        height: 120px;\r\n        z-index: -1;\r\n        left: 0px;\r\n        right: 0px;\r\n        margin: 0px auto;\r\n        opacity: 0;\r\n        border-radius: 100px;\r\n        animation: voice-wave 1.8s infinite;\r\n        background-color: var(--#{$variable-prefix}light);\r\n\r\n        &:nth-child(2) {\r\n            animation-delay: 0.3s;\r\n        }\r\n\r\n        &:nth-child(3) {\r\n            animation-delay: 0.6s;\r\n        }\r\n    }\r\n}\r\n\r\n@keyframes voice-wave {\r\n    0% {\r\n        opacity: 1;\r\n        transform: scale(0);\r\n    }\r\n\r\n    100% {\r\n        opacity: 0;\r\n        transform: scale(1);\r\n    }\r\n}\r\n\r\n.images-menu {\r\n    .swiper-slide {\r\n        width: auto;\r\n        display: inline-block;\r\n    }\r\n}","//\r\n// _ecommerce.scss\r\n//\r\n\r\n// product list\r\n\r\n#selection-element { \r\n    display: none;\r\n}\r\n\r\n.filter-choices-input{\r\n    .choices__inner{\r\n        padding: 0;\r\n        border: none;\r\n        background-color: $card-bg;\r\n    }\r\n\r\n    .choices__input{\r\n        background-color: $card-bg;\r\n    }\r\n}\r\n\r\n//  product detail\r\n\r\n.sticky-side-div{\r\n    @media (min-width: 992px){\r\n        position: sticky;\r\n        top: calc(#{$header-height} + #{$grid-gutter-width});\r\n    }\r\n}\r\n\r\n.product-img-slider{\r\n    .product-nav-slider{\r\n        .nav-slide-item{\r\n            border: 1px solid $border-color;\r\n            border-radius: $border-radius;\r\n            padding: 0.5rem;\r\n            cursor: pointer;\r\n        }\r\n\r\n        .swiper-slide-thumb-active{\r\n            .nav-slide-item{\r\n                background-color: var(--#{$variable-prefix}light);\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.filter-list{\r\n    a {\r\n        &.active {\r\n            .listname {\r\n                color: $success;\r\n            }\r\n        }   \r\n    }\r\n}","//\r\n// _invoice.scss\r\n//\r\n\r\n.invoice-table {\r\n    tbody {\r\n        &:last-child {\r\n            border: none;\r\n        }\r\n    }\r\n}\r\n\r\n.currency-select {\r\n    .choices__inner {\r\n        padding:0px;\r\n        padding-right: 15px;\r\n        min-height: 0px;\r\n    }\r\n    .choices__list--single {\r\n        padding: 0px 16px 0 4px;\r\n    }\r\n    .choices[data-type*=select-one]{\r\n        bottom: 0px;\r\n        :after { \r\n            top: 4px;\r\n        }\r\n        .choices__inner {\r\n            padding-bottom: 0px;\r\n        }\r\n    }\r\n}","//\r\n// _chat.scss\r\n//\r\n\r\n.chat-wrapper{\r\n    position: relative;\r\n    overflow-x: hidden;\r\n}\r\n\r\n// chat left sidebar\r\n\r\n.chat-leftsidebar {\r\n    height: calc(100vh - 137px);\r\n    position: relative;\r\n    background-color: $card-bg;\r\n\r\n    @media (min-width: 992px) {\r\n        min-width: 300px;\r\n        max-width: 300px;\r\n        height: calc(100vh - #{$header-height} - #{$footer-height} - 8px);\r\n    }\r\n}\r\n\r\n\r\n.chat-list {\r\n    margin: 0;\r\n\r\n    > li {\r\n        &.active {\r\n            a {\r\n                background-color: $chat-secondary-bg;\r\n                color: $chat-secondary-color;\r\n\r\n                .badge {\r\n                    background-color: rgba(var(--#{$variable-prefix}success-rgb), 0.15) !important;\r\n                    color: $success !important;\r\n                }\r\n            }\r\n        }\r\n\r\n        a {\r\n            display: block;\r\n            padding: 7px 24px;\r\n            color: var(--#{$variable-prefix}body-color);\r\n            transition: all 0.4s;\r\n            font-family: $font-family-secondary;\r\n            font-weight: $font-weight-medium;\r\n            font-size: $font-size-base;\r\n        }\r\n\r\n        .chat-user-message {\r\n            font-size: 14px;\r\n        }\r\n\r\n        .unread-msg-user {\r\n            font-weight: $font-weight-semibold;\r\n        }\r\n\r\n        .unread-message {\r\n            position: absolute;\r\n            display: inline-block;  \r\n            right: 24px/*rtl:auto*/;\r\n            left: auto/*rtl:0*/;\r\n            top: 33px;\r\n\r\n            .badge {\r\n                line-height: 16px;\r\n                font-weight: $font-weight-semibold;\r\n                font-size: 10px;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.chat-user-img {\r\n    position: relative;\r\n\r\n    .user-status {\r\n        width: 10px;\r\n        height: 10px;\r\n        background-color: $gray-500;\r\n        border-radius: 50%;\r\n        border: 2px solid $card-bg;\r\n        position: absolute;\r\n        right: 0;\r\n        left: auto;\r\n        bottom: 0;\r\n    }\r\n\r\n    &.online {\r\n        .user-status {\r\n            background-color: $success;\r\n        }\r\n    }\r\n\r\n    &.away {\r\n        .user-status {\r\n            background-color: $warning;\r\n        }\r\n    }\r\n}\r\n\r\n.chat-room-list {\r\n    max-height: calc(100vh - 268px);\r\n\r\n    @media (max-width: 991.98px) {\r\n        height: calc(100vh - 268px);\r\n    }\r\n}\r\n\r\n\r\n\r\n// user chat\r\n\r\n.user-chat {\r\n    background: url(\"../../images/chat-bg-pattern.png\");\r\n    transition: all 0.4s;\r\n    position: relative;\r\n    background-color: var(--#{$variable-prefix}body-bg);\r\n\r\n    @media (max-width: 991.98px) {\r\n        position: absolute;\r\n        left: 0;\r\n        top: 3px;\r\n        width: 100%;\r\n        height: calc(100% - 3px);\r\n        visibility: hidden;\r\n        transform: translateX(100%);\r\n        z-index: 99;\r\n        padding-top: 70px;\r\n\r\n        &.user-chat-show{\r\n            visibility: visible;\r\n            transform: translateX(0);\r\n        }\r\n    }\r\n\r\n    .chat-content{\r\n        position: relative;\r\n    }\r\n\r\n    &.user-chat-show{\r\n        .chat-welcome-section{\r\n            display: none;\r\n        }\r\n        .chat-content{\r\n            @media (min-width: 992px) {\r\n                display: flex !important;\r\n            }\r\n        }\r\n    }\r\n}\r\n\r\n.user-chat-topbar{\r\n    border-bottom: 1px solid transparent;\r\n    background-color: $card-bg;\r\n    @media (max-width: 991.98px) {\r\n        position: fixed;\r\n        left: 0;\r\n        right: 0;\r\n        top: 0;\r\n        z-index: 1;\r\n    }\r\n}\r\n\r\n\r\n.user-chat-nav {\r\n    .nav-btn {\r\n        height: 40px;\r\n        width: 40px;\r\n        line-height: 40px;\r\n        box-shadow: none;\r\n        padding: 0;\r\n        font-size: 20px;\r\n        color: $gray-800;\r\n    }\r\n    @media (max-width:575.98px) {\r\n        display: flex;\r\n        justify-content: flex-end;\r\n    }\r\n}\r\n\r\n\r\n.chat-conversation {\r\n    height: calc(100vh - 299px);\r\n    @media (max-width: 991.98px) {\r\n        height: calc(100vh - 275px);\r\n    }\r\n\r\n    .simplebar-content-wrapper{\r\n        display: flex;\r\n        flex-direction: column;\r\n\r\n        .simplebar-content{\r\n            margin-top: auto;\r\n        }\r\n    }\r\n\r\n    .chat-conversation-list{\r\n        padding-top: 10px;\r\n        margin-bottom: 0;\r\n        > li{\r\n            display: flex;\r\n        }\r\n    }\r\n\r\n    li {\r\n        &:last-of-type {\r\n            .conversation-list {\r\n                margin-bottom: 0;\r\n            }\r\n        }\r\n    }\r\n\r\n    .chat-list{\r\n\r\n        &.left{\r\n            .check-message-icon{\r\n                display: none;\r\n            }\r\n        }\r\n        .message-box-drop {\r\n            visibility: hidden;\r\n        }\r\n\r\n        &:hover {\r\n            .message-box-drop {\r\n                visibility: visible;\r\n            }\r\n        }\r\n    }\r\n\r\n    .chat-avatar {\r\n        margin: 0 16px 0 0/*rtl:0 0 0 16px*/;\r\n        \r\n        img {\r\n            width: 28px;\r\n            height: 28px;\r\n            border-radius: 50%;\r\n        }\r\n    }\r\n\r\n    .chat-day-title {\r\n        position: relative;\r\n        text-align: center;\r\n        margin-bottom: 24px;\r\n        margin-top: 12px;\r\n        width: 100%;\r\n\r\n        .title {\r\n            background-color: $white;\r\n            position: relative;\r\n            font-size: 13px;\r\n            z-index: 1;\r\n            padding: 6px 12px;\r\n            border-radius: 5px;\r\n        }\r\n\r\n        &:before {\r\n            content: \"\";\r\n            position: absolute;\r\n            width: 100%;\r\n            height: 1px;\r\n            left: 0;\r\n            right: 0;\r\n            background-color: rgba($primary, 0.2);\r\n            top: 10px;\r\n        }\r\n\r\n        .badge {\r\n            font-size: 12px;\r\n        }\r\n    }\r\n\r\n    .conversation-list {\r\n        margin-bottom: 24px;\r\n        display: inline-flex;\r\n        position: relative;\r\n        align-items: flex-end;\r\n        max-width: 80%;\r\n\r\n        @media (max-width: 575.98px) {\r\n            max-width: 90%;\r\n        }\r\n\r\n        .ctext-wrap {\r\n            display: flex;\r\n            margin-bottom: 10px;\r\n        }\r\n\r\n        .ctext-content{\r\n            word-wrap: break-word;\r\n            word-break: break-word;\r\n        }\r\n\r\n        .ctext-wrap-content {\r\n            padding: 12px 20px;\r\n            background-color: $chat-primary-bg;\r\n            position: relative;\r\n            border-radius: 3px;\r\n            box-shadow: $box-shadow-lg;\r\n\r\n            .attached-file{\r\n                @media (max-width: 575.98px) {\r\n                    .attached-file-avatar{\r\n                        display: none;\r\n                    }\r\n\r\n                    .dropdown .dropdown-toggle{\r\n                        display: block;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n\r\n        .conversation-name {\r\n            font-weight: $font-weight-medium;\r\n            display: flex;\r\n            flex-wrap: wrap;\r\n            align-items: center;\r\n            gap: 8px;\r\n        }\r\n\r\n        .dropdown {\r\n            .dropdown-toggle {\r\n                font-size: 18px;\r\n                padding: 4px;\r\n                color: $gray-600;\r\n                &::after{\r\n                    display: none;\r\n                }\r\n\r\n                @media (max-width: 575.98px) {\r\n                    display: none;\r\n                }\r\n            }\r\n\r\n        }\r\n\r\n        .chat-time {\r\n            font-size: 12px;\r\n            margin-top: 4px;\r\n            text-align: right;\r\n        }\r\n\r\n        .message-img {\r\n            border-radius: .2rem;\r\n            position: relative;\r\n            display: flex;\r\n            flex-wrap: wrap;\r\n            gap: 8px;\r\n\r\n            .message-img-list {\r\n                position: relative;\r\n            }\r\n\r\n            img {\r\n                max-width: 150px;\r\n            }\r\n\r\n            .message-img-link {\r\n                position: absolute;\r\n                right: 10px/*rtl:auto*/;\r\n                left: auto/*rtl:0*/;\r\n                bottom: 10px;\r\n\r\n                li {\r\n                    >a {\r\n                        font-size: 18px;\r\n                        color: $white;\r\n                        display: inline-block;\r\n                        line-height: 20px;\r\n                        width: 26px;\r\n                        height: 24px;\r\n                        border-radius: 3px;\r\n                        background-color: rgba($dark,0.7);\r\n                        text-align: center;\r\n                    }\r\n                }\r\n            }\r\n        }\r\n    }\r\n\r\n    .right {\r\n        justify-content: flex-end;\r\n\r\n        .chat-avatar {\r\n            order: 3;\r\n            margin-right: 0px;\r\n            margin-left: 16px;\r\n        }\r\n\r\n        .chat-time {\r\n            text-align: left;\r\n            color: $gray-600;\r\n        }\r\n\r\n        .conversation-list {\r\n            text-align: right;\r\n\r\n            .ctext-wrap {\r\n                justify-content: flex-end;\r\n\r\n                .ctext-wrap-content {\r\n                    order: 2;\r\n                    background-color: $chat-secondary-bg;\r\n                    color: $chat-secondary-color;\r\n                    text-align: right;\r\n                    box-shadow: $element-shadow;\r\n\r\n                    .replymessage-block{\r\n                        background-color: rgba($white,0.5);\r\n                        border-color: rgba(var(--vz-success-rgb), 1);\r\n                        color: $body-color;\r\n        \r\n                        .conversation-name{\r\n                            color: rgba(var(--vz-success-rgb), 1);\r\n                        }\r\n                    }\r\n                }\r\n            }\r\n\r\n            .conversation-name {\r\n                justify-content: flex-end;\r\n\r\n                .check-message-icon{\r\n                    order: 1;\r\n                }\r\n\r\n                .time{\r\n                    order: 2;\r\n                }\r\n\r\n                .name{\r\n                    order: 3;\r\n                }\r\n            }\r\n\r\n            .dropdown {\r\n                order: 1;\r\n            }\r\n        }\r\n\r\n        .dot {\r\n            background-color: $dark;\r\n        }\r\n    }\r\n}\r\n\r\n.chat-input-section{\r\n    border-top: 1px solid transparent;\r\n    background-color: $card-bg;\r\n    position: relative;\r\n    z-index: 1;\r\n\r\n    .chat-input-feedback {\r\n        display: none;\r\n        position: absolute;\r\n        top: -20px;\r\n        left: 4px;\r\n        font-size: 12px;\r\n        color: $danger;\r\n    }\r\n    .show{\r\n        display: block;\r\n    }\r\n}\r\n\r\n.chat-input-links{\r\n    display: flex;\r\n    .links-list-item{\r\n        > .btn{\r\n            box-shadow: none;\r\n            padding: 0;\r\n            font-size: 20px;\r\n            width: 37.5px;\r\n            height: 37.5px;\r\n            &.btn-link{\r\n                color: $gray-600;\r\n            }\r\n        }\r\n        \r\n    }\r\n}\r\n\r\n//Copy Message Alert\r\n.copyclipboard-alert{\r\n    position: absolute;\r\n    bottom: 0;\r\n    left: 50%;\r\n    transform:translateX(-50%);\r\n    display:none;\r\n}\r\n\r\n.replyCard{\r\n    position: absolute;\r\n    left: 0;\r\n    right: 0;\r\n    border-top: 1px solid $border-color;\r\n    overflow: hidden;\r\n    opacity: 0;\r\n    bottom: 0;\r\n    border-radius: 0;\r\n    transition: all 0.4s;\r\n\r\n    @media (max-width: 991.98px) {\r\n        bottom: -12px;\r\n    }\r\n\r\n    &.show{\r\n        transform: translateY(-88px);\r\n        opacity: 1;\r\n\r\n        @media (max-width: 991.98px) {\r\n            transform: translateY(-83px);\r\n        }\r\n    }\r\n}\r\n\r\n.replymessage-block{\r\n    padding: 12px 20px;\r\n    margin-bottom: 8px;\r\n    text-align: left;\r\n    border-radius: 4px;\r\n    background-color: rgba(var(--vz-success-rgb), 0.1);\r\n    border-left: 2px solid rgba(var(--vz-success-rgb), 1);\r\n\r\n    .conversation-name{\r\n        color: rgba(var(--vz-success-rgb), 1);\r\n        font-size: 14px;\r\n    }\r\n}\r\n\r\n\r\n// Chat Small\r\n.chat-sm {\r\n    .ctext-wrap-content {\r\n        box-shadow: none !important;\r\n    }\r\n\r\n    .message-img {\r\n        img {\r\n            max-width: 90px !important;\r\n        }\r\n    }\r\n\r\n    .message-img-link {\r\n        bottom: 0 !important;\r\n        right: 5px !important;\r\n    }\r\n}\r\n\r\n// for horizontal layout\r\n[data-layout=\"horizontal\"]{\r\n    .chat-wrapper{\r\n        @media (min-width: 1025px) {\r\n            margin-left: 0 !important;\r\n            margin-right: 0 !important;\r\n        }\r\n        @media (max-width: 991.98px) {\r\n            margin-top: 0 !important;\r\n        }\r\n    }\r\n\r\n    .chat-leftsidebar{\r\n        height: calc(100vh - #{$header-height} - #{$footer-height} - 54px);\r\n        @media (max-width: 991.98px) {\r\n            height: calc(100vh - #{$header-height} - #{$footer-height} - 8px);\r\n        }\r\n    }\r\n\r\n    .chat-room-list{\r\n        height: calc(100vh - 316px);\r\n        @media (max-width: 991.98px) {\r\n            height: calc(100vh - 265px);\r\n        }\r\n    }\r\n\r\n    .chat-conversation{\r\n        height: calc(100vh - 343px);\r\n        @media (max-width: 991.98px) {\r\n            height: calc(100vh - 275px);\r\n        }\r\n    }\r\n}","//\r\n// _email.scss\r\n//\r\n\r\n.email-wrapper {\r\n  position: relative;\r\n  overflow-x: hidden;\r\n}\r\n\r\n// chat left sidebar\r\n\r\n.email-menu-sidebar {\r\n  height: calc(100vh - 137px);\r\n  position: relative;\r\n  background-color: $card-bg;\r\n  transition: all 0.2s;\r\n\r\n  @media (min-width: 992px) {\r\n      min-width: 250px;\r\n      max-width: 250px;\r\n      height: calc(100vh - #{$header-height} - #{$footer-height} - 8px);\r\n  }\r\n\r\n  @media (max-width: 991.98px) {\r\n      position: fixed;\r\n      top: 0;\r\n      bottom: 0;\r\n      left: 0;\r\n      width: 200px;\r\n      max-width: 100%;\r\n      z-index: 1003;\r\n      box-shadow: $box-shadow-lg;\r\n      transform: translateX(-100%);\r\n      visibility: hidden;\r\n      height: 100vh;\r\n\r\n      &.menubar-show {\r\n          visibility: visible;\r\n          transform: none;\r\n      }\r\n  }\r\n\r\n  .email-menu-sidebar-scroll {\r\n      height: calc(100vh - 295px);\r\n\r\n      @media (max-width: 991.98px) {\r\n          height: calc(100vh - 150px);\r\n      }\r\n  }\r\n}\r\n\r\n.mail-list {\r\n  a {\r\n      display: flex;\r\n      align-items: center;\r\n      color: $gray-600;\r\n      padding: 5px 0;\r\n      font-weight: $font-weight-medium;\r\n\r\n      &:hover {\r\n          color: $primary;\r\n      }\r\n\r\n      i {\r\n          font-size: 14px;\r\n      }\r\n\r\n      &.active {\r\n          color: $success;\r\n          font-weight: $font-weight-semibold;\r\n\r\n          i {\r\n              color: $success;\r\n          }\r\n      }\r\n  }\r\n}\r\n\r\n.email-topbar-link {\r\n  .btn-ghost-secondary {\r\n      color: $text-muted;\r\n\r\n      &:hover {\r\n          color: $secondary;\r\n      }\r\n  }\r\n}\r\n\r\n.email-content {\r\n  width: 100%;\r\n  background-color: $card-bg;\r\n  transition: all 0.2s;\r\n}\r\n\r\n.unreadConversations-alert{\r\n  position: fixed;\r\n  bottom: $footer-height;\r\n  left: 50%;\r\n  transform: translateX(-50%);\r\n  z-index: 1;\r\n}\r\n\r\n.email-detail-content {\r\n  position: absolute;\r\n  top: 4px;\r\n  bottom: 4px;\r\n  left: 68%;\r\n  width: 32%;\r\n  background-color: $card-bg;\r\n  transform: translateX(200%);\r\n  transition: all 0.2s;\r\n  visibility: hidden;\r\n  border-left: 2px solid var(--#{$variable-prefix}body-bg);\r\n}\r\n\r\n.email-detail-show {\r\n  .email-detail-content {\r\n      transform: none;\r\n      visibility: visible;\r\n  }\r\n\r\n  .email-content {\r\n      margin-right: 32%;\r\n\r\n      @media (max-width: 1349.98px) {\r\n          margin-right: 0;\r\n      }\r\n  }\r\n}\r\n\r\n.email-detail-content-scroll {\r\n  height: calc(100vh - 390px);\r\n\r\n  @media (max-width: 1349.98px) {\r\n      height: calc(100vh - 252px);\r\n  }\r\n}\r\n\r\n.message-list-content {\r\n  height: calc(100vh - 242px);\r\n\r\n  @media (max-width: 575.98px) {\r\n      height: calc(100vh - 230px);\r\n  }\r\n}\r\n\r\n.message-list {\r\n  display: block;\r\n  padding-left: 0;\r\n  margin: 0;\r\n\r\n  li {\r\n      position: relative;\r\n      display: block;\r\n      height: 50px;\r\n      line-height: 50px;\r\n      cursor: default;\r\n      transition-duration: .3s;\r\n      clear: both;\r\n\r\n      a {\r\n          color: var(--#{$variable-prefix}gray-700);\r\n      }\r\n\r\n      &:hover {\r\n          background: var(--#{$variable-prefix}light);\r\n          transition-duration: .05s;\r\n      }\r\n\r\n      .col-mail {\r\n          float: left;\r\n          position: relative;\r\n      }\r\n\r\n      .col-mail-1 {\r\n          width: 280px;\r\n\r\n          .star-toggle,\r\n          .checkbox-wrapper-mail,\r\n          .dot {\r\n              display: block;\r\n              float: left;\r\n          }\r\n\r\n          .dot {\r\n              border: 4px solid transparent;\r\n              border-radius: 100px;\r\n              margin: 22px 26px 0;\r\n              height: 0;\r\n              width: 0;\r\n              line-height: 0;\r\n              font-size: 0;\r\n          }\r\n\r\n          .checkbox-wrapper-mail {\r\n              margin: 15px 0 0 20px;\r\n              line-height: normal;\r\n          }\r\n\r\n          .star-toggle {\r\n              margin-top: 18px;\r\n              margin-left: 5px;\r\n          }\r\n\r\n          .title {\r\n              position: absolute;\r\n              top: 0;\r\n              left: 95px;\r\n              right: 0;\r\n              text-overflow: ellipsis;\r\n              overflow: hidden;\r\n              white-space: nowrap;\r\n              margin-bottom: 0;\r\n\r\n              @media (max-width: 575.98px) {\r\n                  left: 95px;\r\n              }\r\n          }\r\n      }\r\n\r\n      .col-mail-2 {\r\n          position: absolute;\r\n          top: 0;\r\n          left: 280px;\r\n          right: 0;\r\n          bottom: 0;\r\n\r\n          .subject,\r\n          .date {\r\n              position: absolute;\r\n              top: 0;\r\n          }\r\n\r\n          .subject {\r\n              left: 0;\r\n              right: 110px;\r\n              text-overflow: ellipsis;\r\n              overflow: hidden;\r\n              white-space: nowrap;\r\n\r\n              .teaser{\r\n                  color: var(--#{$variable-prefix}gray-600);\r\n              }\r\n          }\r\n\r\n          .date {\r\n              right: 0;\r\n              width: 100px;\r\n              padding-left: 20px;\r\n          }\r\n      }\r\n\r\n      &.active,\r\n      &.active:hover {\r\n          box-shadow: inset 3px 0 0 $primary;\r\n          background-color: var(--#{$variable-prefix}light);\r\n      }\r\n\r\n\r\n      &.unread {\r\n          color: var(--#{$variable-prefix}gray-800);\r\n\r\n          a {\r\n              color: var(--#{$variable-prefix}gray-800);\r\n              font-weight: $font-weight-semibold;\r\n          }\r\n      }\r\n  }\r\n}\r\n\r\n#unreadConversations, #email-topbar-actions{\r\n  display: none;\r\n}\r\n\r\n#mailLoader{\r\n  display: flex;\r\n  width: 100%;\r\n  justify-content: center;\r\n  align-items: center; \r\n  position: absolute; \r\n  left: 0; \r\n  top: 0; \r\n  bottom: 0;\r\n}\r\n\r\n.email-compose-input {\r\n  padding-right: 80px;\r\n}\r\n\r\n@media (max-width: 1349.98px) {\r\n  .email-detail-content {\r\n      position: fixed;\r\n      top: 0;\r\n      bottom: 0;\r\n      left: auto;\r\n      right: 0;\r\n      width: 400px;\r\n      max-width: 100%;\r\n      z-index: 1003;\r\n      box-shadow: $box-shadow-lg;\r\n      transform: translateX(100%);\r\n  }\r\n\r\n  .email-detail-show {\r\n      .email-detail-content {\r\n          transform: none;\r\n      }\r\n  }\r\n}\r\n\r\n\r\n@media (max-width: 575.98px) {\r\n  .message-list li .col-mail-1 {\r\n      width: 180px;\r\n  }\r\n}\r\n\r\n.email-editor {\r\n  .ck-editor__editable_inline {\r\n      min-height: 200px !important;\r\n  }\r\n}\r\n\r\n.email-chat-detail{\r\n  width: 350px;\r\n  position: fixed;\r\n  max-width: 100%;\r\n  bottom: $footer-height;\r\n  right: $footer-height;\r\n  z-index: 9;\r\n  display: none;\r\n  .card{\r\n      box-shadow: $box-shadow-lg;\r\n  }\r\n\r\n  @media (max-width: 515.98px) {\r\n      left: 16px;\r\n      right: 16px;\r\n  }\r\n}\r\n\r\n// for horizontal layout\r\n[data-layout=\"horizontal\"]{\r\n  .email-wrapper{\r\n      @media (min-width: 1025px) {\r\n          margin-left: 0 !important;\r\n          margin-right: 0 !important;\r\n      }\r\n      @media (max-width: 991.98px) {\r\n          margin-top: 0 !important;\r\n      }\r\n  }\r\n\r\n  .email-menu-sidebar{\r\n      height: calc(100vh - #{$header-height} - #{$footer-height} - 54px);\r\n      @media (max-width: 991.98px) {\r\n          height: 100vh\r\n      }\r\n      .email-menu-sidebar-scroll{\r\n          height: calc(100vh - 330px);\r\n          @media (max-width: 991.98px) {\r\n              height: calc(100vh - 150px)\r\n          }\r\n      }\r\n  }\r\n  \r\n  .message-list-content {\r\n      height: calc(100vh - 289px);\r\n      \r\n  }\r\n\r\n  .email-detail-content-scroll{\r\n      height: calc(100vh - 435px);\r\n      @media (max-width: 1349.98px){\r\n          height: calc(100vh - 252px);\r\n      }\r\n  }\r\n}","//\r\n// _kanban.scss\r\n//\r\n\r\n.tasks-board {\r\n    display: flex;\r\n    overflow-x: auto;\r\n    align-items: stretch;\r\n    .tasks-list {\r\n        min-width: 300px;\r\n        margin-right: 24px;\r\n    }\r\n    &::-webkit-scrollbar {\r\n        -webkit-appearance: none;\r\n    }\r\n    &::-webkit-scrollbar:vertical {\r\n        width: 10px;\r\n    }\r\n    &::-webkit-scrollbar:horizontal {\r\n        height: 8px;\r\n    }\r\n    &::-webkit-scrollbar-thumb {\r\n        background-color: rgba(var(--#{$variable-prefix}dark-rgb), .075);\r\n        border-radius: 8px;\r\n    }\r\n    &::-webkit-scrollbar-track {\r\n        border-radius: 8px;  \r\n    }\r\n}\r\n\r\n.tasks-box{\r\n    .progress {\r\n        border-radius: 0px 0px $card-border-radius $card-border-radius;\r\n    }\r\n    .tasks-img{\r\n        height: 135px;\r\n        width: 100%;\r\n        object-fit: cover;\r\n        object-position: center;\r\n        margin: 12px 0px;\r\n    }\r\n    &:last-child {\r\n        margin-bottom: 0px;\r\n    }\r\n}\r\n\r\n.tasks-wrapper {\r\n    max-height: calc(100vh - 410px);\r\n}\r\n\r\n\r\n.tasks {\r\n    min-height: 140px;\r\n    position: relative;\r\n    &::before {\r\n        content: \"\";\r\n        position: absolute;\r\n        left: 0;\r\n        right: 0;\r\n        top: 0;\r\n        bottom: 0;\r\n        height: 180px;\r\n        width: 270px;\r\n        margin: 0 auto;\r\n        background-image: url('../../images/file.png');\r\n        background-size: cover;\r\n        background-position: center;\r\n    }\r\n}\r\n\r\n#tasksList {\r\n    tr {\r\n        .tasks-list-menu {\r\n            opacity: 0;\r\n        }\r\n        &:hover {\r\n            .tasks-list-menu {\r\n                opacity: 1;\r\n            }\r\n        }\r\n    }\r\n}\r\n","//\r\n// _landing.scss\r\n//\r\n\r\n.layout-wrapper {\r\n    &.landing {\r\n      background-color: $card-bg;\r\n      font-size: 15px;\r\n    }\r\n  }\r\n  \r\n  // helper\r\n  \r\n  .section {\r\n    padding: 90px 0;\r\n    position: relative;\r\n  \r\n    @media (max-width: 767.98px) {\r\n      padding: 50px 0;\r\n    }\r\n  }\r\n  \r\n  .icon-effect {\r\n    position: relative;\r\n  \r\n    &::before {\r\n      content: \"\";\r\n      position: absolute;\r\n      width: 24px;\r\n      height: 24px;\r\n      background-color: rgba($success, 0.2);\r\n      border-radius: 50%;\r\n      bottom: 0;\r\n      left: 0;\r\n    }\r\n  }\r\n  \r\n  // navbar\r\n  \r\n  .navbar-landing {\r\n    padding: 10px 0px;\r\n  \r\n    @media (max-width: 991.98px) {\r\n      background-color: $card-bg;\r\n      box-shadow: 0 1px 16px -2px rgba(56, 65, 74, 0.15);\r\n      padding: 10px 8px;\r\n    }\r\n  \r\n    .navbar-nav {\r\n      .nav-item {\r\n        .nav-link {\r\n          font-size: 16px;\r\n          font-weight: $font-weight-medium;\r\n          transition: all 0.4s;\r\n          font-family: $font-family-secondary;\r\n          color: var(--#{$variable-prefix}dark);\r\n          padding: 14px;\r\n  \r\n          @media (max-width: 991.98px) {\r\n            padding: 8px 0px;\r\n          }\r\n  \r\n          &:hover,\r\n          &.active,\r\n          &:focus {\r\n            color: $success !important;\r\n          }\r\n        }\r\n  \r\n        &.active{\r\n          .nav-link{\r\n            color: $success !important;\r\n          }\r\n        }\r\n      }\r\n  \r\n      \r\n    }\r\n    .nav-link.active{\r\n      color: $success !important;\r\n    }\r\n  \r\n    &.is-sticky {\r\n      background-color: $card-bg;\r\n      box-shadow: 0 1px 16px -2px rgba(56, 65, 74, 0.15);\r\n    }\r\n  }\r\n  \r\n  // hero section\r\n  \r\n  .hero-section {\r\n    background-color: rgba(var(--#{$variable-prefix}light-rgb), 0.5);\r\n  \r\n    .hero-shape-svg {\r\n      svg {\r\n        path {\r\n          fill: $card-bg;\r\n        }\r\n      }\r\n    }\r\n  }\r\n  \r\n  .bg-overlay-pattern {\r\n    background-image: url(\"../../images/landing/bg-pattern.png\");\r\n    background-color: transparent;\r\n    background-position: center;\r\n    background-size: cover;\r\n    opacity: 0.2;\r\n  }\r\n  \r\n  .demo-carousel {\r\n    position: relative;\r\n    z-index: 1;\r\n  \r\n    .carousel-item {\r\n      .demo-item {\r\n        background-color: $card-bg;\r\n        padding: 8px;\r\n        border-radius: 7px;\r\n      }\r\n    }\r\n  \r\n    .demo-img-patten-top {\r\n      position: absolute;\r\n      right: -50px;\r\n      top: -16px;\r\n      max-width: 230px;\r\n    }\r\n  \r\n    .demo-img-patten-bottom {\r\n      position: absolute;\r\n      left: -70px;\r\n      bottom: -50px;\r\n      max-width: 230px;\r\n    }\r\n  }\r\n  \r\n  // client images\r\n  .client-images img {\r\n    max-height: 45px;\r\n    width: auto;\r\n    margin: 12px auto;\r\n    transition: all 0.4s;\r\n  }\r\n  \r\n  // plan\r\n  \r\n  .plan-box {\r\n    max-width: 356px;\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n  }\r\n  \r\n  // work process\r\n  .process-card {\r\n    position: relative;\r\n  \r\n    .process-arrow-img {\r\n      position: absolute;\r\n      left: 75%;\r\n      top: 7%;\r\n      width: 50%;\r\n      opacity: 0.1;\r\n    }\r\n  }\r\n  \r\n  .custom-footer {\r\n    color: #9ba7b3;\r\n  }\r\n  \r\n  .footer-list {\r\n    li {\r\n      a {\r\n        color: #9ba7b3;\r\n        padding: 7px 0;\r\n        display: block;\r\n        transition: all 0.3s ease-in-out;\r\n  \r\n        &:hover {\r\n          color: rgba($white, 0.9);\r\n        }\r\n      }\r\n    }\r\n  }\r\n  \r\n  .footer-social-link {\r\n    .avatar-title {\r\n      color: #778089;\r\n      background-color: rgba($white, 0.05);\r\n      transition: all 0.3s ease;\r\n  \r\n      &:hover {\r\n        color: $white;\r\n        background-color: $primary;\r\n      }\r\n    }\r\n  }\r\n  \r\n  // dark\r\n  \r\n  [data-layout-mode=\"dark\"] {\r\n    .layout-wrapper.landing {\r\n      .demo-img-patten-top,\r\n      .demo-img-patten-bottom {\r\n        opacity: 0.2;\r\n      }\r\n  \r\n      footer.bg-dark {\r\n        background-color: $card-bg !important;\r\n      }\r\n    }\r\n  }\r\n  \r\n  .section{\r\n    position: relative;\r\n  }","/*\r\nTemplate Name: Velzon - Admin & Dashboard Template\r\nAuthor: Themesbrand\r\nWebsite: https://themesbrand.com/\r\nContact: support@themesbrand.com\r\nFile: Custom Css File\r\n*/\r\n\r\n.css-b62m3t-container{\r\n    .css-1s2u09g-control{\r\n        background-color: $card-bg;\r\n        border-color: $border-color;\r\n        &:hover {\r\n            border-color: $border-color;\r\n        }\r\n    }\r\n    .css-1pahdxg-control{\r\n        background-color: $card-bg;\r\n        border-color: $border-color;\r\n        box-shadow: none;\r\n        &:hover {\r\n            border-color: $border-color !important;\r\n        }\r\n    }\r\n    .css-26l3qy-menu {\r\n        background-color: $dropdown-bg;\r\n        .css-1n7v3ny-option{\r\n            cursor: pointer;\r\n            background-color: $dropdown-link-hover-bg;\r\n            &:active {\r\n                background-color: $dropdown-link-hover-bg;\r\n            }\r\n        }\r\n    }\r\n    .css-1rhbuit-multiValue{\r\n        background-color: var(--#{$variable-prefix}light);\r\n    }\r\n    .css-12jo7m5{\r\n        color:$heading-color;\r\n    }\r\n    .css-6j8wv5-Input,  .css-qc6sy-singleValue{\r\n        color:$heading-color;\r\n    }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
